webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(370);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _freeze = __webpack_require__(740);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _classCallCheck2 = __webpack_require__(47);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(48);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _WebSocketRails = __webpack_require__(383);
	
	var _WebSocketRails2 = _interopRequireDefault(_WebSocketRails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Docendo = function () {
	  function Docendo() {
	    (0, _classCallCheck3.default)(this, Docendo);
	
	    console.log('open docendo connection');
	    Docendo.self = this;
	  }
	
	  (0, _createClass3.default)(Docendo, [{
	    key: 'open',
	    value: function open() {
	      console.log('open', this);
	      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
	      this.state.websocket =  true ? new _WebSocketRails2.default(window.location.host + '/websocket?tz=' + tz) : new _WebSocketRails2.default('localhost:3000/websocket?tz=' + tz);
	      this.state.websocket.on_open = this.opened;
	      this.state.websocket.bind('connection_closed', this.closed);
	    }
	  }, {
	    key: 'opened',
	    value: function opened() {
	      console.log('opened', this);
	      window.dispatcher = this;
	      Docendo.self.state.retries = 1;
	      Docendo.self.notifyConnected();
	    }
	  }, {
	    key: 'closed',
	    value: function closed() {
	      console.log('closed', this);
	      setTimeout(function () {
	        if (Docendo.self.state.retries < 16) Docendo.self.state.retries *= 2;
	        Docendo.self.open(Docendo.opened, Docendo.closed);
	      }, Docendo.self.state.reconnectTimeout * Docendo.self.state.retries);
	      Docendo.self.notifyDisconnected('closed', Docendo.self);
	    }
	  }, {
	    key: 'subscribeConnected',
	    value: function subscribeConnected(fn) {
	      this.state.observersConnected.push(fn);
	    }
	  }, {
	    key: 'subscribeDisconnected',
	    value: function subscribeDisconnected(fn) {
	      this.state.observersDisconnected.push(fn);
	    }
	  }, {
	    key: 'notifyConnected',
	    value: function notifyConnected() {
	      Docendo.self.state.observersConnected.forEach(function (item) {
	        item.call();
	      });
	    }
	  }, {
	    key: 'notifyDisconnected',
	    value: function notifyDisconnected() {
	      Docendo.self.state.observersDisconnected.forEach(function (item) {
	        item.call();
	      });
	    }
	  }, {
	    key: 'bind',
	    value: function bind(message, func) {
	      this.state.websocket.bind(message, func);
	    }
	  }, {
	    key: 'state',
	    value: function state() {
	      return this.state.websocket.state;
	    }
	  }, {
	    key: 'eventsFromCalendars',
	    value: function eventsFromCalendars(calendarIds, start, end, haveCollision, success, failure) {
	      this.state.websocket.trigger('api.events.list', {
	        calendar_ids: calendarIds,
	        start: start,
	        end: end,
	        have_collision: haveCollision
	      }, success, failure);
	    }
	  }, {
	    key: 'publicEventsFromCalendar',
	    value: function publicEventsFromCalendar(calendarId, start, end, success, failure) {
	      this.state.websocket.trigger('api.events.list_public', {
	        calendar_id: calendarId,
	        start: start,
	        end: end
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarEvents2',
	    value: function calendarEvents2(calendarIds, start, end, eventTypeFilter, success, failure) {
	      this.state.websocket.trigger('api.events.list', {
	        calendar_ids: calendarIds,
	        start: start,
	        end: end,
	        event_type_filter: eventTypeFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarPublicEvents',
	    value: function calendarPublicEvents(calendarId, start, end, notes, eventTypeFilter, noFormat, success, failure) {
	      this.state.websocket.trigger('api.calendars.public_events', {
	        calendar_id: calendarId,
	        start: start,
	        end: end,
	        notes: notes,
	        event_type_filter: eventTypeFilter,
	        no_format: noFormat
	      }, success, failure);
	    }
	  }, {
	    key: 'calendar',
	    value: function calendar(calendarId, success, failure) {
	      this.state.websocket.trigger('api.calendars.get', {
	        calendar_id: calendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarCopyWeeks',
	    value: function calendarCopyWeeks(calendarIds, sourceDate, destinationDates, deleteExisting, onlyEventTypes, exceptEventTypes, success, failure) {
	      this.state.websocket.trigger('api.calendars.copy_weeks', {
	        calendar_ids: calendarIds,
	        source_date: sourceDate,
	        destination_dates: destinationDates,
	        delete_existing: deleteExisting,
	        only_event_types: onlyEventTypes,
	        except_event_types: exceptEventTypes
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectEventsCreate',
	    value: function subjectEventsCreate(schoolId, calendarId, sourceDate, destinationDates, deleteExisting, onlyEventTypes, exceptEventTypes, onlySubjectIds, onlyEventIds, success, failure) {
	      this.state.websocket.trigger('api.calendars.copy', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        source_date: sourceDate,
	        destination_dates: destinationDates,
	        delete_existing: deleteExisting,
	        only_event_types: onlyEventTypes,
	        except_event_types: exceptEventTypes,
	        only_subject_ids: onlySubjectIds,
	        only_event_ids: onlyEventIds
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarCopyDays',
	    value: function calendarCopyDays(schoolId, calendarIds, sourceDates, destinationDates, success, failure) {
	      this.state.websocket.trigger('api.calendars.copy_days', {
	        school_id: schoolId,
	        calendar_ids: calendarIds,
	        source_dates: sourceDates,
	        destination_dates: destinationDates
	      }, success, failure);
	    }
	  }, {
	    key: 'mergeCalendar',
	    value: function mergeCalendar(schoolId, calendarId, mergeCalendarId, success, failure) {
	      this.state.websocket.trigger('api.calendars.merge', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        merge_calendar_id: mergeCalendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'unmergeCalendar',
	    value: function unmergeCalendar(schoolId, calendarId, mergeCalendarId, success, failure) {
	      this.state.websocket.trigger('api.calendars.unmerge', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        merge_calendar_id: mergeCalendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'listCalendarMerges',
	    value: function listCalendarMerges(schoolId, success, failure) {
	      this.state.websocket.trigger('api.calendars.merges', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createEvent',
	    value: function createEvent(schoolId, calendarId, calendarIds, subjectId, start, end, learningGoal, description, notesForStudents, teacherNotes, success, failure) {
	      this.state.websocket.trigger('api.schools.events.create', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        calendar_ids: calendarIds,
	        subject_id: subjectId,
	        start: start,
	        end: end,
	        learning_goal: learningGoal,
	        description: description,
	        notes_for_students: notesForStudents,
	        teacher_notes: teacherNotes
	      }, success, failure);
	    }
	  }, {
	    key: 'updateEvent',
	    value: function updateEvent(schoolId, eventId, eventParams, success, failure) {
	      this.state.websocket.trigger('api.schools.events.update', {
	        school_id: schoolId,
	        event_id: eventId,
	        event: eventParams
	      }, success, failure);
	    }
	  }, {
	    key: 'updateEvents',
	    value: function updateEvents(schoolId, updates, success, failure) {
	      this.state.websocket.trigger('api.events.update', {
	        school_id: schoolId,
	        updates: updates
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteEvent',
	    value: function deleteEvent(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.schools.events.delete', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'listEvents',
	    value: function listEvents(schoolId, date, success, failure) {
	      this.state.websocket.trigger('api.schools.events.list', {
	        school_id: schoolId,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'listEventsForSchools',
	    value: function listEventsForSchools(schoolIds, date, success, failure) {
	      this.state.websocket.trigger('api.schools.events.list', {
	        school_ids: schoolIds,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarCopyCheck',
	    value: function calendarCopyCheck(calendarId, dates, success, failure) {
	      this.state.websocket.trigger('api.events.copy_check_weeks', {
	        calendar_id: calendarId,
	        dates: dates
	      }, success, failure);
	    }
	  }, {
	    key: 'splitEvent',
	    value: function splitEvent(eventId, splitTime, success, failure) {
	      this.state.websocket.trigger('api.events.split', {
	        event_id: eventId,
	        split_time: splitTime
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarOverlaps',
	    value: function calendarOverlaps(eventIds, success, failure) {
	      this.state.websocket.trigger('api.events.calendar_overlaps', {
	        event_ids: eventIds
	      }, success, failure);
	    }
	  }, {
	    key: 'removeSubstitutionOfUser',
	    value: function removeSubstitutionOfUser(schoolId, eventIds, userId, substitutionStatus, success, failure) {
	      this.state.websocket.trigger('api.events.remove_substitution_of_user', {
	        school_id: schoolId,
	        event_ids: eventIds,
	        user_id: userId,
	        substitution_status: substitutionStatus
	      }, success, failure);
	    }
	  }, {
	    key: 'getNotificationsUnreadBeforeId',
	    value: function getNotificationsUnreadBeforeId(count, onlyUnread, beforeId, success, failure) {
	      this.state.websocket.trigger('api.notifications.list', {
	        count: count,
	        only_unread: onlyUnread,
	        before_id: beforeId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateNotification',
	    value: function updateNotification(id, changes, success, failure) {
	      this.state.websocket.trigger('api.notifications.update', { id: id, changes: changes }, success, failure);
	    }
	  }, {
	    key: 'markAllNotificationsAsRead',
	    value: function markAllNotificationsAsRead(success, failure) {
	      this.state.websocket.trigger('api.notifications.mark_all_as_read', {}, success, failure);
	    }
	  }, {
	    key: 'notificationsUnreadCount',
	    value: function notificationsUnreadCount(success, failure) {
	      this.state.websocket.trigger('api.notifications.unread_count', {}, success, failure);
	    }
	  }, {
	    key: 'getNotificationsList',
	    value: function getNotificationsList(count, success, failure) {
	      this.state.websocket.trigger('api.notifications.list', { count: count }, success, failure);
	    }
	  }, {
	    key: 'getNotificationsListUnread',
	    value: function getNotificationsListUnread(count, onlyUnread, success, failure) {
	      this.state.websocket.trigger('api.notifications.list', { count: count, only_unread: onlyUnread }, success, failure);
	    }
	  }, {
	    key: 'getNotificationsBefore',
	    value: function getNotificationsBefore(count, beforeId, success, failure) {
	      this.state.websocket.trigger('api.notifications.list', { count: count, before_id: beforeId }, success, failure);
	    }
	  }, {
	    key: 'calendarsForSchool',
	    value: function calendarsForSchool(id, success, failure) {
	      this.state.websocket.trigger('api.calendars.for_school', { school_id: id }, success);
	    }
	  }, {
	    key: 'deleteEventsRange',
	    value: function deleteEventsRange(calendar, from, to, success, failure) {
	      this.state.websocket.trigger('api.events.delete', { calendar: calendar, from: from, to: to }, success, failure);
	    }
	  }, {
	    key: 'deleteEventCalendar',
	    value: function deleteEventCalendar(id, calendar, success, failure) {
	      this.state.websocket.trigger('api.events.delete_calendar', { id: id, calendar_id: calendar }, success, failure);
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser(success, failure) {
	      this.state.websocket.trigger('api.users.get', {}, success);
	    }
	  }, {
	    key: 'showUser',
	    value: function showUser(userId, success, failure) {
	      this.state.websocket.trigger('api.users.show', { user_id: userId }, success);
	    }
	  }, {
	    key: 'getJwt',
	    value: function getJwt(success, failure) {
	      this.state.websocket.trigger('api.users.jwt', {}, success);
	    }
	  }, {
	    key: 'updateUser',
	    value: function updateUser(changes, success, failure) {
	      this.state.websocket.trigger('api.users.update', changes, success);
	    }
	  }, {
	    key: 'updateUsers',
	    value: function updateUsers(schoolId, userId, changes, success, failure) {
	      this.state.websocket.trigger('api.schools.users.update', {
	        school_id: schoolId,
	        user_id: userId,
	        changes: changes
	      }, success, failure);
	    }
	  }, {
	    key: 'updateUserPhone',
	    value: function updateUserPhone(schoolId, userId, phone, success, failure) {
	      this.state.websocket.trigger('api.schools.user_phone.update', {
	        school_id: schoolId,
	        user_id: userId,
	        user: {
	          unconfirmed_phone: phone
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteUserPhone',
	    value: function deleteUserPhone(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.schools.user_phone.delete', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolVacationDaysCreate',
	    value: function schoolVacationDaysCreate(school, date, success, failure) {
	      this.state.websocket.trigger('api.school_vacation_days.create', { school: school, day: date }, success, failure);
	    }
	  }, {
	    key: 'schoolVacationDaysRead',
	    value: function schoolVacationDaysRead(school, success, failure) {
	      this.state.websocket.trigger('api.school_vacation_days.read', { school: school }, success, failure);
	    }
	  }, {
	    key: 'schoolVacationDaysDelete',
	    value: function schoolVacationDaysDelete(school, id, success, failure) {
	      this.state.websocket.trigger('api.school_vacation_days.delete', { school: school, id: id }, success, failure);
	    }
	  }, {
	    key: 'schoolYearsRead',
	    value: function schoolYearsRead(school, filter, sort, success, failure) {
	      this.state.websocket.trigger('api.school_years.read', {
	        school: school,
	        filter: filter,
	        sort: sort
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolYearsUpdate',
	    value: function schoolYearsUpdate(school, id, changes, success, failure) {
	      this.state.websocket.trigger('api.school_years.update', {
	        school: school,
	        id: id,
	        changes: changes
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolSubscribe',
	    value: function schoolSubscribe(school, subscription, success, failure) {
	      console.log('schoolSubscribe', subscription);
	      this.state.websocket.trigger('api.schools.subscribe', {
	        school_id: school,
	        subscription: subscription
	      }, success, failure);
	    }
	  }, {
	    key: 'weeknote',
	    value: function weeknote(calendarId, week, success, failure) {
	      this.state.websocket.trigger('api.weeknotes.show', { calendar_id: calendarId, week: week }, success, failure);
	    }
	  }, {
	    key: 'weeknoteUpdate',
	    value: function weeknoteUpdate(calendarId, week, note, success, failure) {
	      this.state.websocket.trigger('api.weeknotes.update', {
	        calendar_id: calendarId,
	        week: week,
	        note: note
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkPresenceEvent',
	    value: function bulkPresenceEvent(calendarId, toCreate, toUpdate, toDelete, success, failure) {
	      this.state.websocket.trigger('api.presence.update', { bulk_presence_event: { to_create: toCreate, to_update: toUpdate, to_delete: toDelete } }, success, failure);
	    }
	  }, {
	    key: 'createPresenceForMany',
	    value: function createPresenceForMany(schoolId, calendarIds, weekDates, events, success, failure) {
	      this.state.websocket.trigger('api.presence.create', {
	        school_id: schoolId,
	        calendar_ids: calendarIds,
	        week_dates: weekDates,
	        events: events
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEvents',
	    value: function schoolEvents(schoolId, from, to, userIdsFilter, eventTypeFilter, success, failure) {
	      this.state.websocket.trigger('api.school_user_events.read', {
	        school_id: schoolId,
	        from_datetime: from,
	        to_datetime: to,
	        user_ids_filter: userIdsFilter,
	        event_type_filter: eventTypeFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUsers',
	    value: function schoolUsers(schoolId, userIdsFilter, success, failure) {
	      this.state.websocket.trigger('api.schools.users.read', {
	        school_id: schoolId,
	        user_ids_filter: userIdsFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUsers2',
	    value: function schoolUsers2(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.users.read2', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUsersCreate',
	    value: function schoolUsersCreate(schoolId, users, success, failure) {
	      this.state.websocket.trigger('api.schools.users.create', {
	        school_id: schoolId,
	        users: users
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUsersAssignPermissionSet',
	    value: function schoolUsersAssignPermissionSet(schoolId, userId, permissionSetId, success, failure) {
	      this.state.websocket.trigger('api.schools.users.assign_permission_set', {
	        school_id: schoolId,
	        user_id: userId,
	        permission_set_id: permissionSetId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsList',
	    value: function schoolEventSerialsList(schoolId, date, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.list', {
	        school_id: schoolId,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsCreate',
	    value: function schoolEventSerialsCreate(schoolId, calendarId, subjectId, fromDate, toDate, fromTime, toTime, ongoing, internalNote, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.create', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        subject_id: subjectId,
	        from_date: fromDate,
	        to_date: toDate,
	        from_time: fromTime,
	        to_time: toTime,
	        ongoing: ongoing,
	        internal_note: internalNote
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsRead',
	    value: function schoolEventSerialsRead(schoolId, eventSerialId, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.read', {
	        school_id: schoolId,
	        id: eventSerialId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsUpdate',
	    value: function schoolEventSerialsUpdate(schoolId, eventSerialId, calendarId, subjectId, fromDate, toDate, fromTime, toTime, ongoing, internalNote, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.update', {
	        id: eventSerialId,
	        school_id: schoolId,
	        calendar_id: calendarId,
	        subject_id: subjectId,
	        from_date: fromDate,
	        to_date: toDate,
	        from_time: fromTime,
	        to_time: toTime,
	        ongoing: ongoing,
	        internal_note: internalNote
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolEventSerialsDelete',
	    value: function schoolEventSerialsDelete(schoolId, eventSerialId, success, failure) {
	      this.state.websocket.trigger('api.schools.event_serials.destroy', {
	        school_id: schoolId,
	        id: eventSerialId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsList',
	    value: function schoolAbsenceSubjectsList(schoolId, includeArchived, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.list', {
	        school_id: schoolId,
	        include_archived: includeArchived
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsCreate',
	    value: function schoolAbsenceSubjectsCreate(schoolId, name, color, defaultPrivate, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.create', {
	        school_id: schoolId,
	        name: name,
	        color: color,
	        default_private: defaultPrivate
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsUpdate',
	    value: function schoolAbsenceSubjectsUpdate(id, schoolId, name, color, defaultPrivate, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.update', {
	        id: id,
	        school_id: schoolId,
	        name: name,
	        color: color,
	        default_private: defaultPrivate
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsArchive',
	    value: function schoolAbsenceSubjectsArchive(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.archive', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAbsenceSubjectsUnarchive',
	    value: function schoolAbsenceSubjectsUnarchive(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_subjects.unarchive', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolBulkCreateCalendars',
	    value: function schoolBulkCreateCalendars(schoolId, schoolYearId, calendars, success, failure) {
	      this.state.websocket.trigger('api.calendars.bulk_create', {
	        school_id: schoolId,
	        schoolYearId: schoolYearId,
	        calendars: calendars
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolBulkUpdateCalendars',
	    value: function schoolBulkUpdateCalendars(schoolId, calendars, success, failure) {
	      this.state.websocket.trigger('api.calendars.bulk_update', {
	        school_id: schoolId,
	        calendars: calendars
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolCalendarsUpdate',
	    value: function schoolCalendarsUpdate(schoolId, calendarId, changes, success, failure) {
	      this.state.websocket.trigger('api.calendars.update', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        calendar: changes
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolCalendarsDelete',
	    value: function schoolCalendarsDelete(schoolId, calendarId, success, failure) {
	      this.state.websocket.trigger('api.calendars.delete', {
	        school_id: schoolId,
	        calendar_id: calendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectNormsSchool',
	    value: function subjectNormsSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.subject_norms.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventAddSubstitute',
	    value: function eventAddSubstitute(event, added, subFor, success, failure) {
	      this.state.websocket.trigger('api.events.add_substitute', {
	        event: event,
	        user: added,
	        substitute_for_user: subFor
	      }, success, failure);
	    }
	  }, {
	    key: 'eventRemoveSubstitute',
	    value: function eventRemoveSubstitute(event, user, subFor, success, failure) {
	      this.state.websocket.trigger('api.events.remove_substitute', {
	        event: event,
	        user: user,
	        substitute_for_user: subFor
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolTags',
	    value: function schoolTags(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.tags.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolTagsBulkCreate',
	    value: function schoolTagsBulkCreate(schoolId, tags, userIds, success, failure) {
	      this.state.websocket.trigger('api.schools.tags.bulk_create', {
	        school_id: schoolId,
	        tags: tags,
	        user_ids: userIds
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolTagsBulkDelete',
	    value: function schoolTagsBulkDelete(schoolId, tags, userIds, success, failure) {
	      this.state.websocket.trigger('api.schools.tags.bulk_delete', {
	        school_id: schoolId,
	        tags: tags,
	        user_ids: userIds
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAssignedHours',
	    value: function schoolAssignedHours(schoolId, year, userIdsFilter, success, failure) {
	      this.state.websocket.trigger('api.schools.assigned_hours.read', {
	        school_id: schoolId,
	        year: year,
	        user_ids_filter: userIdsFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolRecalculateAll',
	    value: function schoolRecalculateAll(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.recalculate.recalculate_all', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolActualHours',
	    value: function schoolActualHours(schoolId, fromDateTime, toDateTime, userIdsFilter, success, failure) {
	      this.state.websocket.trigger('api.schools.actual_hours.read', {
	        school_id: schoolId,
	        from_datetime: fromDateTime,
	        to_datetime: toDateTime,
	        user_ids_filter: userIdsFilter
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUserYearRead',
	    value: function schoolUserYearRead(schoolId, userId, year, success, failure) {
	      this.state.websocket.trigger('api.schools.user_years.read', {
	        school_id: schoolId,
	        user_id: userId,
	        year: year
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUserYearsList',
	    value: function schoolUserYearsList(schoolId, schoolYearId, userId, success, failure) {
	      this.state.websocket.trigger('api.schools.user_years.list', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolUserYearUpdate',
	    value: function schoolUserYearUpdate(schoolId, userId, year, data, success, failure) {
	      this.state.websocket.trigger('api.schools.user_years.update', {
	        school_id: schoolId,
	        user_id: userId,
	        year: year,
	        user_data: data
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkSchoolUserYearUpdate',
	    value: function bulkSchoolUserYearUpdate(schoolId, year, data, success, failure) {
	      this.state.websocket.trigger('api.schools.user_years.bulk_update', {
	        school_id: schoolId,
	        user_id: null,
	        year: year,
	        users_data: data
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolAvailabilities',
	    value: function schoolAvailabilities(schoolId, calendarType, startTime, endTime, success, failure) {
	      this.state.websocket.trigger('api.schools.availabilities.list', {
	        school_id: schoolId,
	        calendar_type: calendarType,
	        start_time: startTime,
	        end_time: endTime
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolSubstituteDayNoteRead',
	    value: function schoolSubstituteDayNoteRead(schoolId, day, success, failure) {
	      this.state.websocket.trigger('api.schools.substitute_day_notes.show', {
	        school_id: schoolId,
	        note: {
	          day: day
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolSubstituteDayNoteUpdate',
	    value: function schoolSubstituteDayNoteUpdate(schoolId, day, note, success, failure) {
	      this.state.websocket.trigger('api.schools.substitute_day_notes.update', {
	        school_id: schoolId,
	        note: {
	          day: day,
	          note: note
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'schoolSubstituteHours',
	    value: function schoolSubstituteHours(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.substitute_hours.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'countSms',
	    value: function countSms(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.sms.count', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'sendSmses',
	    value: function sendSmses(schoolId, userIds, message, success, failure) {
	      this.state.websocket.trigger('api.schools.sms.ship', {
	        school_id: schoolId,
	        user_ids: userIds,
	        message: message
	      }, success, failure);
	    }
	  }, {
	    key: 'pastSmses',
	    value: function pastSmses(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.sms.past', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'sendEmails',
	    value: function sendEmails(schoolId, userIds, subject, message, success, failure) {
	      this.state.websocket.trigger('api.schools.email.ship', {
	        school_id: schoolId,
	        user_ids: userIds,
	        subject: subject,
	        message: message
	      }, success, failure);
	    }
	  }, {
	    key: 'readSmsTemplates',
	    value: function readSmsTemplates(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.sms_templates.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createMessageTemplate',
	    value: function createMessageTemplate(schoolId, title, body, messageType, success, failure) {
	      this.state.websocket.trigger('api.schools.message_templates.create', {
	        school_id: schoolId,
	        title: title,
	        body: body,
	        message_type: messageType
	      }, success, failure);
	    }
	  }, {
	    key: 'readMessageTemplates',
	    value: function readMessageTemplates(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.message_templates.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateMessageTemplate',
	    value: function updateMessageTemplate(schoolId, id, title, body, messageType, success, failure) {
	      this.state.websocket.trigger('api.schools.message_templates.update', {
	        school_id: schoolId,
	        id: id,
	        title: title,
	        body: body,
	        message_type: messageType
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteMessageTemplate',
	    value: function deleteMessageTemplate(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.message_templates.delete', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'eventChanges',
	    value: function eventChanges(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.schools.events.changes', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSubject',
	    value: function createSubject(name, color, calendarId, defaultDuration, preparation, hours, subjectType, schoolId, schoolYearId, calendarIds, subjectCode, away, success, failure) {
	      this.state.websocket.trigger('api.subjects.create', {
	        name: name,
	        color: color,
	        calendar_id: calendarId,
	        default_duration: defaultDuration,
	        preparation: preparation,
	        hours: hours,
	        subject_type: subjectType,
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        calendar_ids: calendarIds,
	        subject_code: subjectCode,
	        away: away
	      }, success, failure);
	    }
	  }, {
	    key: 'readSubjects',
	    value: function readSubjects(schoolId, schoolYearId, userId, success, failure) {
	      this.state.websocket.trigger('api.subjects.read', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'showSubject',
	    value: function showSubject(subjectId, success, failure) {
	      this.state.websocket.trigger('api.subjects.show', {
	        id: subjectId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateSubject',
	    value: function updateSubject(id, name, color, calendarId, calendarIds, defaultDuration, preparation, hours, subjectType, schoolId, schoolYearId, subjectCode, away, defaultPrivate, success, failure) {
	      this.state.websocket.trigger('api.subjects.update', {
	        id: id,
	        name: name,
	        color: color,
	        calendar_id: calendarId,
	        default_duration: defaultDuration,
	        hours: hours,
	        subject_type: subjectType,
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        calendar_ids: calendarIds,
	        subject_code: subjectCode,
	        preparation: preparation,
	        away: away,
	        default_private: defaultPrivate
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteSubject',
	    value: function deleteSubject(id, schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subjects.delete', {
	        id: id,
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'setHoursForTeacherOnSubject',
	    value: function setHoursForTeacherOnSubject(id, schoolId, schoolYearId, userId, hours, success, failure) {
	      this.state.websocket.trigger('api.subjects.set_hours', {
	        id: id,
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        hours: hours,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditSubject',
	    value: function auditSubject(schoolId, subjectId, success, failure) {
	      this.state.websocket.trigger('api.audit.subject', {
	        subject_id: subjectId,
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditDeletedEventsBySubject',
	    value: function auditDeletedEventsBySubject(schoolId, subjectId, success, failure) {
	      this.state.websocket.trigger('api.audit.deleted_events_by_subject', {
	        subject_id: subjectId,
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditWeeknote',
	    value: function auditWeeknote(schoolId, weeknoteId, success, failure) {
	      this.state.websocket.trigger('api.audit.weeknote', {
	        school_id: schoolId,
	        weeknote_id: weeknoteId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditUser',
	    value: function auditUser(success, failure) {
	      this.state.websocket.trigger('api.audit.user', {}, success, failure);
	    }
	  }, {
	    key: 'auditLogSchool',
	    value: function auditLogSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.audit_logs.school', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditLogUser',
	    value: function auditLogUser(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.audit_logs.user', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'auditLogCalendar',
	    value: function auditLogCalendar(schoolId, calendarId, success, failure) {
	      this.state.websocket.trigger('api.audit_logs.calendar', {
	        school_id: schoolId,
	        calendar_id: calendarId
	      }, success, failure);
	    }
	  }, {
	    key: 'createTask',
	    value: function createTask(schoolId, schoolYearId, subjectType, hours, name, color, defaultDuration, preparation, belongsToCalendars, userCalendars, canSchedule, inUserCalendar, success, failure) {
	      this.state.websocket.trigger('api.schools.tasks.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        task: {
	          subject_type: subjectType,
	          hours: hours,
	          name: name,
	          color: color,
	          default_duration: defaultDuration,
	          preparation: preparation,
	          belongs_to_calendars: belongsToCalendars,
	          user_calendars: userCalendars,
	          can_schedule: canSchedule,
	          in_user_calendar: inUserCalendar
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'readTasks',
	    value: function readTasks(schoolId, schoolYearId, userId, success, failure) {
	      this.state.websocket.trigger('api.schools.tasks.read', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateTask',
	    value: function updateTask(schoolId, schoolYearId, id, name, color, hours, defaultDuration, preparation, belongsToCalendars, userCalendars, inUserCalendar, success, failure) {
	      this.state.websocket.trigger('api.schools.tasks.update', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id,
	        task: {
	          hours: hours,
	          name: name,
	          color: color,
	          default_duration: defaultDuration,
	          preparation: preparation,
	          belongs_to_calendars: belongsToCalendars,
	          user_calendars: userCalendars,
	          in_user_calendar: inUserCalendar
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteTask',
	    value: function deleteTask(schoolId, schoolYearId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.tasks.delete', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'createExport',
	    value: function createExport(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.exports.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsPermissions',
	    value: function permissionSetsPermissions(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.permissions', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsRead',
	    value: function permissionSetsRead(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsCreate',
	    value: function permissionSetsCreate(schoolId, name, permissions, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.create', {
	        school_id: schoolId,
	        permission_set: {
	          name: name,
	          permissions: permissions
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsUpdate',
	    value: function permissionSetsUpdate(schoolId, id, name, permissions, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.update', {
	        school_id: schoolId,
	        permission_set: {
	          id: id,
	          name: name,
	          permissions: permissions
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'permissionSetsDelete',
	    value: function permissionSetsDelete(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.schools.permission_sets.delete', {
	        school_id: schoolId,
	        permission_set: {
	          id: id
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'employmentsForSchool',
	    value: function employmentsForSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.employments.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'employmentsForSchoolForUser',
	    value: function employmentsForSchoolForUser(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.employments.read', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkCreateEmployment',
	    value: function bulkCreateEmployment(schoolId, userIds, titles, manualSalary, success, failure) {
	      this.state.websocket.trigger('api.employments.bulk_create', {
	        school_id: schoolId,
	        user_ids: userIds,
	        titles: titles,
	        manual_salary: manualSalary
	      }, success, failure);
	    }
	  }, {
	    key: 'createEmployment',
	    value: function createEmployment(schoolId, userId, employmentNumber, employmentTypeId, success, failure) {
	      this.state.websocket.trigger('api.employments.create', {
	        school_id: schoolId,
	        user_id: userId,
	        employment: {
	          employment_number: employmentNumber,
	          employment_type_id: employmentTypeId
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteEmployment',
	    value: function deleteEmployment(schoolId, userId, employmentId, success, failure) {
	      this.state.websocket.trigger('api.employments.delete', {
	        school_id: schoolId,
	        user_id: userId,
	        id: employmentId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateEmployment',
	    value: function updateEmployment(schoolId, userId, employmentId, manualSalary, defaultLoenart, defaultLoebenummer, success, failure) {
	      this.state.websocket.trigger('api.employments.update', {
	        school_id: schoolId,
	        user_id: userId,
	        id: employmentId,
	        manual_salary: manualSalary,
	        default_loenart: defaultLoenart,
	        default_loebenummer: defaultLoebenummer
	      }, success, failure);
	    }
	  }, {
	    key: 'salaryDays',
	    value: function salaryDays(schoolId, schoolIds, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.salaries.read', {
	        school_id: schoolId,
	        school_ids: schoolIds,
	        from_date: fromDate,
	        to_date: toDate
	      }, success, failure);
	    }
	  }, {
	    key: 'salaryDayUpdate',
	    value: function salaryDayUpdate(schoolId, schoolIds, day, success, failure) {
	      this.state.websocket.trigger('api.salaries.update', {
	        school_id: schoolId,
	        school_ids: schoolIds,
	        day: day
	      }, success, failure);
	    }
	  }, {
	    key: 'salaryOpusRead',
	    value: function salaryOpusRead(schoolId, schoolIds, fromDate, toDate, userId, success, failure) {
	      this.state.websocket.trigger('api.salaries.opus_read', {
	        school_id: schoolId,
	        school_ids: schoolIds,
	        from_date: fromDate,
	        to_date: toDate,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'salaryCodes',
	    value: function salaryCodes(schoolId, success, failure) {
	      this.state.websocket.trigger('api.salary_codes.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSalaryCode',
	    value: function createSalaryCode(schoolId, employmentTypeId, code, title, success, failure) {
	      this.state.websocket.trigger('api.salary_codes.create', {
	        school_id: schoolId,
	        employment_type_id: employmentTypeId,
	        code: code,
	        title: title
	      }, success, failure);
	    }
	  }, {
	    key: 'readTaskCategories',
	    value: function readTaskCategories(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.task_categories.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'createTaskCategory',
	    value: function createTaskCategory(schoolId, schoolYearId, name, rank, subjectTypes, success, failure) {
	      this.state.websocket.trigger('api.task_categories.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        name: name,
	        rank: rank,
	        subject_types: subjectTypes
	      }, success, failure);
	    }
	  }, {
	    key: 'updateTaskCategory',
	    value: function updateTaskCategory(schoolId, schoolYearId, id, name, rank, subjectTypes, success, failure) {
	      this.state.websocket.trigger('api.task_categories.update', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id,
	        name: name,
	        rank: rank,
	        subject_types: subjectTypes
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteTaskCategory',
	    value: function deleteTaskCategory(schoolId, schoolYearId, id, success, failure) {
	      this.state.websocket.trigger('api.task_categories.destroy', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'readSubjectCalendars',
	    value: function readSubjectCalendars(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subject_calendars.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkUpdateSubjectCalendars',
	    value: function bulkUpdateSubjectCalendars(schoolId, schoolYearId, updates, success, failure) {
	      this.state.websocket.trigger('api.subject_calendars.bulk_update', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        updates: updates
	      }, success, failure);
	    }
	  }, {
	    key: 'listImports',
	    value: function listImports(schoolId, success, failure) {
	      this.state.websocket.trigger('api.imports.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'enqueueImport',
	    value: function enqueueImport(schoolId, scheduleUuid, date, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.imports.create', {
	        school_id: schoolId,
	        schedule_uuid: scheduleUuid,
	        date: date,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectsForCalendarType',
	    value: function subjectsForCalendarType(calendarType, country, success, failure) {
	      this.state.websocket.trigger('api.subjects.subjects_for_calendar_type', {
	        calendar_type: calendarType,
	        country: country
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectActuals',
	    value: function subjectActuals(schoolId, schoolYearId, userId, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.subject_actuals.read', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId,
	        from_date: fromDate,
	        to_date: toDate
	      }, success, failure);
	    }
	  }, {
	    key: 'userTasks',
	    value: function userTasks(userId, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.users.tasks', {
	        user_id: userId,
	        from_date: fromDate,
	        to_date: toDate
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarActualHoursPerWeek',
	    value: function calendarActualHoursPerWeek(calendarId, fromDate, toDate, success, failure) {
	      this.state.websocket.trigger('api.calendars.actual_hours_per_week_per_master_type', {
	        calendar_id: calendarId,
	        from_date: fromDate,
	        to_date: toDate
	      }, success, failure);
	    }
	  }, {
	    key: 'createCalendarRelation',
	    value: function createCalendarRelation(schoolId, calendarId, otherCalendarId, relation, success, failure) {
	      this.state.websocket.trigger('api.calendar_relations.create', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        other_calendar_id: otherCalendarId,
	        relation: relation
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteCalendarRelation',
	    value: function deleteCalendarRelation(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.calendar_relations.destroy', {
	        school_id: schoolId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'indexCalendarRelations',
	    value: function indexCalendarRelations(schoolId, success, failure) {
	      this.state.websocket.trigger('api.calendar_relations.index', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'employmentTypesForSchool',
	    value: function employmentTypesForSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.employment_types.read', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'createEmploymentType',
	    value: function createEmploymentType(schoolId, title, manualSalary, success, failure) {
	      this.state.websocket.trigger('api.employment_types.create', {
	        school_id: schoolId,
	        employment_type: {
	          title: title,
	          manual_salary: manualSalary
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'updateEmploymentType',
	    value: function updateEmploymentType(schoolId, id, title, manualSalary, success, failure) {
	      this.state.websocket.trigger('api.employment_types.update', {
	        id: id,
	        school_id: schoolId,
	        employment_type: {
	          title: title,
	          manual_salary: manualSalary
	        }
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteEmploymentType',
	    value: function deleteEmploymentType(schoolId, id, success, failure) {
	      this.state.websocket.trigger('api.employment_types.delete', {
	        id: id,
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'sidebar',
	    value: function sidebar(calendarId, date, success, failure) {
	      this.state.websocket.trigger('api.subjects.sidebar', {
	        calendar_id: calendarId,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'listSchools',
	    value: function listSchools(success, failure) {
	      this.state.websocket.trigger('api.schools.index', {}, success, failure);
	    }
	  }, {
	    key: 'showSchool',
	    value: function showSchool(schoolId, success, failure) {
	      this.state.websocket.trigger('api.schools.show', {
	        id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'absenceForDate',
	    value: function absenceForDate(schoolId, date, success, failure) {
	      this.state.websocket.trigger('api.schools.absence_for_date', {
	        id: schoolId,
	        date: date
	      }, success, failure);
	    }
	  }, {
	    key: 'updateSchool',
	    value: function updateSchool(schoolId, updates, success, failure) {
	      this.state.websocket.trigger('api.schools.update', {
	        id: schoolId,
	        school: updates
	      }, success, failure);
	    }
	  }, {
	    key: 'calendarCreateNormSubjects',
	    value: function calendarCreateNormSubjects(schoolId, calendarStepList, success, failure) {
	      this.state.websocket.trigger('api.calendars.create_norm_subjects', {
	        school_id: schoolId,
	        calendar_steps: calendarStepList
	      }, success, failure);
	    }
	  }, {
	    key: 'eventAvailability',
	    value: function eventAvailability(calendarId, eventId, start, end, success, failure) {
	      this.state.websocket.trigger('api.calendars.availability', {
	        calendar_id: calendarId,
	        event_id: eventId,
	        start: start,
	        end: end
	      }, success, failure);
	    }
	  }, {
	    key: 'subjectAvailability',
	    value: function subjectAvailability(calendarId, subjectId, start, end, success, failure) {
	      this.state.websocket.trigger('api.calendars.availability', {
	        calendar_id: calendarId,
	        subject_id: subjectId,
	        start: start,
	        end: end
	      }, success, failure);
	    }
	  }, {
	    key: 'showStilReport',
	    value: function showStilReport(schoolId, success, failure) {
	      this.state.websocket.trigger('api.stil_reports.show', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateStilReport',
	    value: function updateStilReport(schoolId, report, success, failure) {
	      this.state.websocket.trigger('api.stil_reports.update', {
	        school_id: schoolId,
	        report: report
	      }, success, failure);
	    }
	  }, {
	    key: 'submitStilReport',
	    value: function submitStilReport(schoolId, success, failure) {
	      this.state.websocket.trigger('api.stil_reports.submit', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'showStilCompetencyReport',
	    value: function showStilCompetencyReport(schoolId, success, failure) {
	      this.state.websocket.trigger('api.stil_competency.show', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateStilCompetencyReport',
	    value: function updateStilCompetencyReport(schoolId, report, success, failure) {
	      this.state.websocket.trigger('api.stil_competency.update', {
	        school_id: schoolId,
	        report: report
	      }, success, failure);
	    }
	  }, {
	    key: 'submitStilCompetencyReport',
	    value: function submitStilCompetencyReport(schoolId, success, failure) {
	      this.state.websocket.trigger('api.stil_competency.submit', {
	        school_id: schoolId
	      }, success, failure);
	    }
	  }, {
	    key: 'listUserCompetencies',
	    value: function listUserCompetencies(schoolId, userId, success, failure) {
	      this.state.websocket.trigger('api.users.competencies.index', {
	        school_id: schoolId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'updateUserCompetencies',
	    value: function updateUserCompetencies(schoolId, userId, competencies, success, failure) {
	      this.state.websocket.trigger('api.users.competencies.update', {
	        school_id: schoolId,
	        user_id: userId,
	        competencies: competencies
	      }, success, failure);
	    }
	  }, {
	    key: 'eventsDeleteThisAndFollowing',
	    value: function eventsDeleteThisAndFollowing(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.events.delete_this_and_following', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventSwap',
	    value: function eventSwap(schoolId, fromEventId, toEventId, success, failure) {
	      this.state.websocket.trigger('api.events.swap', {
	        school_id: schoolId,
	        from: fromEventId,
	        to: toEventId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventReplace',
	    value: function eventReplace(schoolId, eventId, subjectId, success, failure) {
	      this.state.websocket.trigger('api.events.replace', {
	        school_id: schoolId,
	        event: eventId,
	        subject: subjectId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventReplaceCalendar',
	    value: function eventReplaceCalendar(schoolId, eventId, calendarIdToReplace, calendarIdToReplaceWith, success, failure) {
	      this.state.websocket.trigger('api.events.replace_calendar', {
	        school_id: schoolId,
	        event_id: eventId,
	        calendar_id_to_replace: calendarIdToReplace,
	        calendar_id_to_replace_with: calendarIdToReplaceWith
	      }, success, failure);
	    }
	  }, {
	    key: 'eventAddCalendar',
	    value: function eventAddCalendar(schoolId, eventId, calendarIdToAdd, success, failure) {
	      this.state.websocket.trigger('api.events.add_calendar', {
	        school_id: schoolId,
	        event_id: eventId,
	        calendar_id_to_add: calendarIdToAdd
	      }, success, failure);
	    }
	  }, {
	    key: 'eventRemoveCalendar',
	    value: function eventRemoveCalendar(schoolId, eventId, calendarIdToRemove, success, failure) {
	      this.state.websocket.trigger('api.events.remove_calendar', {
	        school_id: schoolId,
	        event_id: eventId,
	        calendar_id_to_remove: calendarIdToRemove
	      }, success, failure);
	    }
	  }, {
	    key: 'eventListSwapable',
	    value: function eventListSwapable(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.events.list_swapable_events', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'eventListReplaceable',
	    value: function eventListReplaceable(schoolId, eventId, success, failure) {
	      this.state.websocket.trigger('api.events.list_replaceable_events', {
	        school_id: schoolId,
	        event_id: eventId
	      }, success, failure);
	    }
	  }, {
	    key: 'hoursCountForCalendar',
	    value: function hoursCountForCalendar(schoolId, calendarId, start, end, success, failure) {
	      this.state.websocket.trigger('api.calendars.hours_count', {
	        school_id: schoolId,
	        calendar_id: calendarId,
	        start: start,
	        end: end
	      }, success, failure);
	    }
	  }, {
	    key: 'saveTaskOverview',
	    value: function saveTaskOverview(schoolId, schoolYearId, userId, title, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId,
	        title: title
	      }, success, failure);
	    }
	  }, {
	    key: 'bulkCreateTaskOverview',
	    value: function bulkCreateTaskOverview(schoolId, schoolYearId, userIds, title, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.bulk_create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_ids: userIds,
	        title: title
	      }, success, failure);
	    }
	  }, {
	    key: 'readTaskOverviews',
	    value: function readTaskOverviews(schoolId, schoolYearId, userId, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteTaskOverview',
	    value: function deleteTaskOverview(schoolId, schoolYearId, userId, versionId, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.destroy', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        user_id: userId,
	        id: versionId
	      }, success, failure);
	    }
	  }, {
	    key: 'readAllTaskOverview',
	    value: function readAllTaskOverview(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.schools.task_overviews.latest_per_user', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'listSubjectRequests',
	    value: function listSubjectRequests(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subject_requests.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'createSubjectRequest',
	    value: function createSubjectRequest(schoolId, schoolYearId, subjectId, success, failure) {
	      this.state.websocket.trigger('api.subject_requests.create', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        subject_id: subjectId
	      }, success, failure);
	    }
	  }, {
	    key: 'deleteSubjectRequest',
	    value: function deleteSubjectRequest(schoolId, schoolYearId, id, success, failure) {
	      this.state.websocket.trigger('api.subject_requests.destroy', {
	        school_id: schoolId,
	        school_year_id: schoolYearId,
	        id: id
	      }, success, failure);
	    }
	  }, {
	    key: 'listSubjectReductions',
	    value: function listSubjectReductions(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subject_reductions.index', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'refreshSubjectReductions',
	    value: function refreshSubjectReductions(schoolId, schoolYearId, success, failure) {
	      this.state.websocket.trigger('api.subject_reductions.refresh', {
	        school_id: schoolId,
	        school_year_id: schoolYearId
	      }, success, failure);
	    }
	  }, {
	    key: 'getRecentUsers',
	    value: function getRecentUsers(id, limit, success, failure) {
	      this.state.websocket.trigger('api.schools.recent_users', { school: id, limit: limit }, success, failure);
	    }
	  }]);
	  return Docendo;
	}();
	
	var instance = new Docendo();
	instance.state = {};
	instance.state.reconnectTimeout = Math.floor(1000 + Math.random() * 2000);
	instance.state.retries = 1;
	instance.state.observersConnected = [];
	instance.state.observersDisconnected = [];
	instance.open();
	(0, _freeze2.default)(instance);
	exports.default = instance;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new _vue2.default({
	  data: {
	    sideWideAnnouncement: false,
	    now: (0, _moment2.default)().utc(),
	    loadingEvents: false,
	    toast: {},
	    createModalOpen: false,
	    showOnboardingArrow: false,
	    showSetupWidget: false,
	    createUserModal: false,
	    createUserModalROR: false,
	    createKlassModal: false,
	    createRoomModal: false,
	    createMergeModal: false,
	    editCalendarNameModal: false,
	    editCalendarDeleteModal: false,
	    createdId: null,
	    isOpenYouTubePopup: false,
	    youTubeVideoId: '',
	    copyEventEvent: null,
	    isLessonNoteChangedWithoutSaving: false,
	    activeChangeRoleId: null,
	    calendars: [],
	    createCalendarsType: null,
	    isPrintCalendarsModal: false,
	    printCalendarType: null,
	    theKlassesToImportSubjectTo: []
	  }
	});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(878)
	
	/* script */
	__vue_exports__ = __webpack_require__(692)
	
	/* template */
	var __vue_template__ = __webpack_require__(1479)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(945)
	
	/* script */
	__vue_exports__ = __webpack_require__(685)
	
	/* template */
	var __vue_template__ = __webpack_require__(1557)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4549b0c6"
	
	module.exports = __vue_exports__


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(869)
	
	/* script */
	__vue_exports__ = __webpack_require__(683)
	
	/* template */
	var __vue_template__ = __webpack_require__(1470)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1041)
	
	/* script */
	__vue_exports__ = __webpack_require__(682)
	
	/* template */
	var __vue_template__ = __webpack_require__(1661)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7612b8c8"
	
	module.exports = __vue_exports__


/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1133)
	
	/* script */
	__vue_exports__ = __webpack_require__(572)
	
	/* template */
	var __vue_template__ = __webpack_require__(1761)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e014dd16"
	
	module.exports = __vue_exports__


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(890)
	
	/* script */
	__vue_exports__ = __webpack_require__(700)
	
	/* template */
	var __vue_template__ = __webpack_require__(1493)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-26141f76"
	
	module.exports = __vue_exports__


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1065)
	
	/* script */
	__vue_exports__ = __webpack_require__(696)
	
	/* template */
	var __vue_template__ = __webpack_require__(1686)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8029c268"
	
	module.exports = __vue_exports__


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1076)
	
	/* script */
	__vue_exports__ = __webpack_require__(457)
	
	/* template */
	var __vue_template__ = __webpack_require__(1697)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8ad5426c"
	
	module.exports = __vue_exports__


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1078)
	
	/* script */
	__vue_exports__ = __webpack_require__(504)
	
	/* template */
	var __vue_template__ = __webpack_require__(1700)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-90089d60"
	
	module.exports = __vue_exports__


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(992)
	
	/* script */
	__vue_exports__ = __webpack_require__(643)
	
	/* template */
	var __vue_template__ = __webpack_require__(1607)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-609167cc"
	
	module.exports = __vue_exports__


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1124)
	
	/* script */
	__vue_exports__ = __webpack_require__(702)
	
	/* template */
	var __vue_template__ = __webpack_require__(1751)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d433704e"
	
	module.exports = __vue_exports__


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1106)
	
	/* script */
	__vue_exports__ = __webpack_require__(468)
	
	/* template */
	var __vue_template__ = __webpack_require__(1731)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.filter('capitalize', function (string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	});
	
	_vue2.default.filter('L', function (date) {
	  return (0, _moment2.default)(date).format('L');
	});
	
	_vue2.default.filter('LL', function (date) {
	  return (0, _moment2.default)(date).format('LL');
	});
	
	_vue2.default.filter('LT', function (date) {
	  return (0, _moment2.default)(date).format('LT');
	});
	
	_vue2.default.filter('dayAndDate', function (date) {
	  return (0, _moment2.default)(date).format('dddd, LL');
	});
	
	_vue2.default.filter('isMonth', function (date) {
	  return (0, _moment2.default)(date).format('MMMM');
	});
	
	_vue2.default.filter('ddd', function (date) {
	  return (0, _moment2.default)(date).format('ddd');
	});
	
	_vue2.default.filter('timeStamp', function (value) {
	  return (0, _moment2.default)(value).format('LT');
	});
	
	_vue2.default.filter('dddd', function (value) {
	  return (0, _moment2.default)(value).format('dddd');
	});
	
	_vue2.default.filter('D', function (date) {
	  return (0, _moment2.default)(date).format('D');
	});
	
	_vue2.default.filter('dateNoYear', function (date) {
	  return (0, _moment2.default)(date).format('dddd, LL');
	});
	
	_vue2.default.filter('dateOfMonth', function (value) {
	  return (0, _moment2.default)(value).format('dddd D. MMMM - YYYY');
	});
	
	_vue2.default.filter('date', function (date) {
	  return (0, _moment2.default)(date).format('D. MMMM YYYY');
	});
	
	_vue2.default.filter('dayOfWeek', function (date, num) {
	  return (0, _moment2.default)(date).isoWeekday(num);
	});
	
	_vue2.default.filter('month', function (date) {
	  return (0, _moment2.default)(date).format('M');
	});
	
	_vue2.default.filter('isMonthShort', function (date) {
	  return (0, _moment2.default)(date).format('MMM');
	});
	
	_vue2.default.filter('isYear', function (date) {
	  return (0, _moment2.default)(date).format('YYYY');
	});
	
	_vue2.default.filter('timeFromNow', function (m) {
	  if (m !== null) {
	    return 'sidst set ' + (0, _moment2.default)(m).fromNow();
	  } else {
	    return 'aldrig været logget ind';
	  }
	});
	
	_vue2.default.filter('fromNow', function (m) {
	  if (m !== null) {
	    return (0, _moment2.default)(m).fromNow();
	  }
	});
	
	_vue2.default.filter('timeDisplay', {
	  read: function read(val) {
	    return (0, _moment2.default)(val).format('LT');
	  },
	
	  write: function write(val, oldval, eventDate) {
	    var momentObj = (0, _moment2.default)(val, ['h:mm A']);
	    var number = (0, _moment2.default)(val, 'LT');
	    var hours = (0, _moment2.default)(momentObj).format('HH');
	    var minutes = Math.round((0, _moment2.default)(number).format('mm') / 5) * 5;
	
	    var _newDate = (0, _moment2.default)(eventDate).set({ 'hour': hours, 'minute': minutes });
	
	    return isNaN(number) ? eventDate : _newDate;
	  }
	});

/***/ }),
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(925)
	
	/* script */
	__vue_exports__ = __webpack_require__(656)
	
	/* template */
	var __vue_template__ = __webpack_require__(1536)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1099)
	
	/* script */
	__vue_exports__ = __webpack_require__(545)
	
	/* template */
	var __vue_template__ = __webpack_require__(1724)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(940)
	
	/* script */
	__vue_exports__ = __webpack_require__(662)
	
	/* template */
	var __vue_template__ = __webpack_require__(1552)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1154)
	
	/* script */
	__vue_exports__ = __webpack_require__(679)
	
	/* template */
	var __vue_template__ = __webpack_require__(1783)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var now = (0, _moment2.default)().utc();
	
	exports.default = {
	  showWeekends: true,
	  now: now
	};

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1066)
	
	/* script */
	__vue_exports__ = __webpack_require__(459)
	
	/* template */
	var __vue_template__ = __webpack_require__(1687)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8029cc62"
	
	module.exports = __vue_exports__


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1126)
	
	/* script */
	__vue_exports__ = __webpack_require__(442)
	
	/* template */
	var __vue_template__ = __webpack_require__(1753)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d63297e4"
	
	module.exports = __vue_exports__


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(461)
	
	/* template */
	var __vue_template__ = __webpack_require__(1524)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1074)
	
	/* script */
	__vue_exports__ = __webpack_require__(438)
	
	/* template */
	var __vue_template__ = __webpack_require__(1695)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-894064e0"
	
	module.exports = __vue_exports__


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1046)
	
	/* script */
	__vue_exports__ = __webpack_require__(451)
	
	/* template */
	var __vue_template__ = __webpack_require__(1666)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1144)
	
	/* script */
	__vue_exports__ = __webpack_require__(465)
	
	/* template */
	var __vue_template__ = __webpack_require__(1773)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f06f80e4"
	
	module.exports = __vue_exports__


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1096)
	
	/* script */
	__vue_exports__ = __webpack_require__(510)
	
	/* template */
	var __vue_template__ = __webpack_require__(1721)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-aef65da6"
	
	module.exports = __vue_exports__


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(968)
	
	/* script */
	__vue_exports__ = __webpack_require__(596)
	
	/* template */
	var __vue_template__ = __webpack_require__(1581)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-53c96b37"
	
	module.exports = __vue_exports__


/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(979)
	
	/* script */
	__vue_exports__ = __webpack_require__(493)
	
	/* template */
	var __vue_template__ = __webpack_require__(1593)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57d78ff0"
	
	module.exports = __vue_exports__


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(995)
	
	/* script */
	__vue_exports__ = __webpack_require__(581)
	
	/* template */
	var __vue_template__ = __webpack_require__(1610)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(954)
	
	/* script */
	__vue_exports__ = __webpack_require__(590)
	
	/* template */
	var __vue_template__ = __webpack_require__(1567)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4ab73c5c"
	
	module.exports = __vue_exports__


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(964)
	
	/* script */
	__vue_exports__ = __webpack_require__(607)
	
	/* template */
	var __vue_template__ = __webpack_require__(1577)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5166ab48"
	
	module.exports = __vue_exports__


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(923)
	
	/* script */
	__vue_exports__ = __webpack_require__(634)
	
	/* template */
	var __vue_template__ = __webpack_require__(1534)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-38bc317e"
	
	module.exports = __vue_exports__


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(974)
	
	/* script */
	__vue_exports__ = __webpack_require__(701)
	
	/* template */
	var __vue_template__ = __webpack_require__(1588)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(835)
	
	/* script */
	__vue_exports__ = __webpack_require__(706)
	
	/* template */
	var __vue_template__ = __webpack_require__(1436)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-052a48e9"
	
	module.exports = __vue_exports__


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(47);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(48);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Event = function () {
	  function Event(data, success_callback, failure_callback) {
	    (0, _classCallCheck3.default)(this, Event);
	
	    this.success_callback = success_callback;
	    this.failure_callback = failure_callback;
	    this.name = data[0];
	    var attr = data[1];
	
	    if (attr) {
	      this.id = attr.id ? attr.id : (1 + Math.random()) * 0x10000 | 0;
	      this.channel = attr.channel ? attr.channel : undefined;
	      this.data = attr.data ? attr.data : attr;
	      this.token = attr.token ? attr.token : undefined;
	      this.connection_id = data[2];
	      if (attr.success) {
	        this.result = true;
	        this.success = attr.success;
	      } else {
	        this.result = false;
	        this.success = attr.success;
	      }
	    }
	  }
	
	  (0, _createClass3.default)(Event, [{
	    key: 'is_channel',
	    value: function is_channel() {
	      return !!this.channel;
	    }
	  }, {
	    key: 'is_result',
	    value: function is_result() {
	      return this.result;
	    }
	  }, {
	    key: 'is_ping',
	    value: function is_ping() {
	      return this.name === 'websocket_rails.ping';
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize() {
	      return (0, _stringify2.default)([this.name, this.attributes()]);
	    }
	  }, {
	    key: 'attributes',
	    value: function attributes() {
	      return {
	        id: this.id,
	        channel: this.channel,
	        data: this.data,
	        token: this.token
	      };
	    }
	  }, {
	    key: 'run_callbacks',
	    value: function run_callbacks(success, result) {
	      this.success = success;
	      this.result = result;
	      if (this.success) {
	        return typeof this.success_callback === 'function' ? this.success_callback(this.result) : undefined;
	      }
	      return typeof this.failure_callback === 'function' ? this.failure_callback(this.result) : undefined;
	    }
	  }]);
	  return Event;
	}();
	
	exports.default = Event;

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(982)
	
	/* script */
	__vue_exports__ = __webpack_require__(387)
	
	/* template */
	var __vue_template__ = __webpack_require__(1596)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-599cef24"
	
	module.exports = __vue_exports__


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1040)
	
	/* script */
	__vue_exports__ = __webpack_require__(402)
	
	/* template */
	var __vue_template__ = __webpack_require__(1660)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-75af5a47"
	
	module.exports = __vue_exports__


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1137)
	
	/* script */
	__vue_exports__ = __webpack_require__(404)
	
	/* template */
	var __vue_template__ = __webpack_require__(1765)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e2b81218"
	
	module.exports = __vue_exports__


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(872)
	
	/* script */
	__vue_exports__ = __webpack_require__(467)
	
	/* template */
	var __vue_template__ = __webpack_require__(1473)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1120)
	
	/* script */
	__vue_exports__ = __webpack_require__(501)
	
	/* template */
	var __vue_template__ = __webpack_require__(1747)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cd76fcaa"
	
	module.exports = __vue_exports__


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1006)
	
	/* script */
	__vue_exports__ = __webpack_require__(514)
	
	/* template */
	var __vue_template__ = __webpack_require__(1621)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(888)
	
	/* script */
	__vue_exports__ = __webpack_require__(528)
	
	/* template */
	var __vue_template__ = __webpack_require__(1491)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-251e5067"
	
	module.exports = __vue_exports__


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(906)
	
	/* script */
	__vue_exports__ = __webpack_require__(552)
	
	/* template */
	var __vue_template__ = __webpack_require__(1513)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2e471144"
	
	module.exports = __vue_exports__


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(891)
	
	/* script */
	__vue_exports__ = __webpack_require__(566)
	
	/* template */
	var __vue_template__ = __webpack_require__(1494)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2671dc56"
	
	module.exports = __vue_exports__


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1028)
	
	/* script */
	__vue_exports__ = __webpack_require__(575)
	
	/* template */
	var __vue_template__ = __webpack_require__(1648)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1151)
	
	/* script */
	__vue_exports__ = __webpack_require__(586)
	
	/* template */
	var __vue_template__ = __webpack_require__(1780)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f581df80"
	
	module.exports = __vue_exports__


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(828)
	
	/* script */
	__vue_exports__ = __webpack_require__(588)
	
	/* template */
	var __vue_template__ = __webpack_require__(1428)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0083e5ba"
	
	module.exports = __vue_exports__


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(852)
	
	/* script */
	__vue_exports__ = __webpack_require__(591)
	
	/* template */
	var __vue_template__ = __webpack_require__(1453)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0c586aff"
	
	module.exports = __vue_exports__


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1094)
	
	/* script */
	__vue_exports__ = __webpack_require__(604)
	
	/* template */
	var __vue_template__ = __webpack_require__(1719)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a9a6245c"
	
	module.exports = __vue_exports__


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(889)
	
	/* script */
	__vue_exports__ = __webpack_require__(606)
	
	/* template */
	var __vue_template__ = __webpack_require__(1492)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-25fd8e5a"
	
	module.exports = __vue_exports__


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1019)
	
	/* script */
	__vue_exports__ = __webpack_require__(641)
	
	/* template */
	var __vue_template__ = __webpack_require__(1636)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6bfee519"
	
	module.exports = __vue_exports__


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(900)
	
	/* script */
	__vue_exports__ = __webpack_require__(668)
	
	/* template */
	var __vue_template__ = __webpack_require__(1505)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2aec7768"
	
	module.exports = __vue_exports__


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1136)
	
	/* script */
	__vue_exports__ = __webpack_require__(670)
	
	/* template */
	var __vue_template__ = __webpack_require__(1764)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(883)
	
	/* script */
	__vue_exports__ = __webpack_require__(671)
	
	/* template */
	var __vue_template__ = __webpack_require__(1485)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2195af68"
	
	module.exports = __vue_exports__


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(988)
	
	/* script */
	__vue_exports__ = __webpack_require__(681)
	
	/* template */
	var __vue_template__ = __webpack_require__(1603)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5d6c6e69"
	
	module.exports = __vue_exports__


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(838)
	
	/* template */
	var __vue_template__ = __webpack_require__(1439)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-06917bc4"
	
	module.exports = __vue_exports__


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1009)
	
	/* script */
	__vue_exports__ = __webpack_require__(698)
	
	/* template */
	var __vue_template__ = __webpack_require__(1624)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6745c30e"
	
	module.exports = __vue_exports__


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1075)
	
	/* script */
	__vue_exports__ = __webpack_require__(705)
	
	/* template */
	var __vue_template__ = __webpack_require__(1696)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8a18328c"
	
	module.exports = __vue_exports__


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(734)
	
	/* template */
	var __vue_template__ = __webpack_require__(1508)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  if (typeof window.CustomEvent === 'function') return false;
	
	  function CustomEvent(event, params) {
	    params = params || { bubbles: false, cancelable: false, detail: undefined };
	    var evt = document.createEvent('CustomEvent');
	    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	    return evt;
	  }
	
	  CustomEvent.prototype = window.Event.prototype;
	
	  window.CustomEvent = CustomEvent;
	})();

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(47);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(48);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Event = __webpack_require__(90);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AbstractConnection = function () {
	  function AbstractConnection(url, dispatcher) {
	    (0, _classCallCheck3.default)(this, AbstractConnection);
	
	    this.dispatcher = dispatcher;
	    this.message_queue = [];
	  }
	
	  (0, _createClass3.default)(AbstractConnection, [{
	    key: 'close',
	    value: function close() {}
	  }, {
	    key: 'trigger',
	    value: function trigger(event) {
	      if (this.dispatcher.state !== 'connected') {
	        return this.message_queue.push(event);
	      }
	      return this.send_event(event);
	    }
	  }, {
	    key: 'send_event',
	    value: function send_event(event) {
	      if (this.connection_id) {
	        return event.connection_id = this.connection_id;
	      }
	    }
	  }, {
	    key: 'on_close',
	    value: function on_close(event) {
	      if (this.dispatcher && this.dispatcher._conn === this) {
	        var close_event = new _Event2.default(['connection_closed', event]);
	        this.dispatcher.state = 'disconnected';
	        return this.dispatcher.dispatch(close_event);
	      }
	    }
	  }, {
	    key: 'on_error',
	    value: function on_error(event) {
	      if (this.dispatcher && this.dispatcher._conn === this) {
	        var error_event = new _Event2.default(['connection_error', event]);
	        this.dispatcher.state = 'disconnected';
	        return this.dispatcher.dispatch(error_event);
	      }
	    }
	  }, {
	    key: 'on_message',
	    value: function on_message(event_data) {
	      if (this.dispatcher && this.dispatcher._conn === this) {
	        return this.dispatcher.new_message(event_data);
	      }
	    }
	  }, {
	    key: 'setConnectionId',
	    value: function setConnectionId(connection_id) {
	      this.connection_id = connection_id;
	    }
	  }, {
	    key: 'flush_queue',
	    value: function flush_queue() {
	      var _this = this;
	
	      this.message_queue.forEach(function (item) {
	        _this.trigger(item);
	      });
	
	      return this.message_queue = [];
	    }
	  }]);
	  return AbstractConnection;
	}();
	
	exports.default = AbstractConnection;

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(884)
	
	/* script */
	__vue_exports__ = __webpack_require__(392)
	
	/* template */
	var __vue_template__ = __webpack_require__(1486)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-223d07fd"
	
	module.exports = __vue_exports__


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1119)
	
	/* script */
	__vue_exports__ = __webpack_require__(393)
	
	/* template */
	var __vue_template__ = __webpack_require__(1745)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c74ee5a4"
	
	module.exports = __vue_exports__


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1116)
	
	/* script */
	__vue_exports__ = __webpack_require__(405)
	
	/* template */
	var __vue_template__ = __webpack_require__(1741)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1152)
	
	/* script */
	__vue_exports__ = __webpack_require__(412)
	
	/* template */
	var __vue_template__ = __webpack_require__(1781)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f73d31cc"
	
	module.exports = __vue_exports__


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1001)
	
	/* script */
	__vue_exports__ = __webpack_require__(415)
	
	/* template */
	var __vue_template__ = __webpack_require__(1616)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-64af2518"
	
	module.exports = __vue_exports__


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(919)
	
	/* script */
	__vue_exports__ = __webpack_require__(416)
	
	/* template */
	var __vue_template__ = __webpack_require__(1529)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-37033ca5"
	
	module.exports = __vue_exports__


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(863)
	
	/* script */
	__vue_exports__ = __webpack_require__(420)
	
	/* template */
	var __vue_template__ = __webpack_require__(1464)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-13e1ed8c"
	
	module.exports = __vue_exports__


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1121)
	
	/* script */
	__vue_exports__ = __webpack_require__(423)
	
	/* template */
	var __vue_template__ = __webpack_require__(1748)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d00a6530"
	
	module.exports = __vue_exports__


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(998)
	
	/* script */
	__vue_exports__ = __webpack_require__(425)
	
	/* template */
	var __vue_template__ = __webpack_require__(1613)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-63dcf620"
	
	module.exports = __vue_exports__


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(895)
	
	/* script */
	__vue_exports__ = __webpack_require__(427)
	
	/* template */
	var __vue_template__ = __webpack_require__(1499)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-29814708"
	
	module.exports = __vue_exports__


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(887)
	
	/* script */
	__vue_exports__ = __webpack_require__(446)
	
	/* template */
	var __vue_template__ = __webpack_require__(1490)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-246c188a"
	
	module.exports = __vue_exports__


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(458)
	
	/* template */
	var __vue_template__ = __webpack_require__(1517)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(460)
	
	/* template */
	var __vue_template__ = __webpack_require__(1746)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(864)
	
	/* script */
	__vue_exports__ = __webpack_require__(462)
	
	/* template */
	var __vue_template__ = __webpack_require__(1465)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-140f9b06"
	
	module.exports = __vue_exports__


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(961)
	
	/* script */
	__vue_exports__ = __webpack_require__(463)
	
	/* template */
	var __vue_template__ = __webpack_require__(1574)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4eea129d"
	
	module.exports = __vue_exports__


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(466)
	
	/* template */
	var __vue_template__ = __webpack_require__(1639)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1043)
	
	/* script */
	__vue_exports__ = __webpack_require__(471)
	
	/* template */
	var __vue_template__ = __webpack_require__(1663)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-77923726"
	
	module.exports = __vue_exports__


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(848)
	
	/* script */
	__vue_exports__ = __webpack_require__(476)
	
	/* template */
	var __vue_template__ = __webpack_require__(1449)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0a4468b0"
	
	module.exports = __vue_exports__


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(893)
	
	/* script */
	__vue_exports__ = __webpack_require__(480)
	
	/* template */
	var __vue_template__ = __webpack_require__(1496)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-284b8dcf"
	
	module.exports = __vue_exports__


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1030)
	
	/* script */
	__vue_exports__ = __webpack_require__(485)
	
	/* template */
	var __vue_template__ = __webpack_require__(1650)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(488)
	
	/* template */
	var __vue_template__ = __webpack_require__(1718)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(837)
	
	/* script */
	__vue_exports__ = __webpack_require__(490)
	
	/* template */
	var __vue_template__ = __webpack_require__(1438)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0629c0ab"
	
	module.exports = __vue_exports__


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(494)
	
	/* template */
	var __vue_template__ = __webpack_require__(1601)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1097)
	
	/* script */
	__vue_exports__ = __webpack_require__(500)
	
	/* template */
	var __vue_template__ = __webpack_require__(1722)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-af372fc4"
	
	module.exports = __vue_exports__


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(850)
	
	/* script */
	__vue_exports__ = __webpack_require__(503)
	
	/* template */
	var __vue_template__ = __webpack_require__(1451)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0b6a9ee6"
	
	module.exports = __vue_exports__


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(924)
	
	/* script */
	__vue_exports__ = __webpack_require__(508)
	
	/* template */
	var __vue_template__ = __webpack_require__(1535)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-38f50666"
	
	module.exports = __vue_exports__


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1129)
	
	/* script */
	__vue_exports__ = __webpack_require__(526)
	
	/* template */
	var __vue_template__ = __webpack_require__(1756)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-dab03e6e"
	
	module.exports = __vue_exports__


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1143)
	
	/* script */
	__vue_exports__ = __webpack_require__(527)
	
	/* template */
	var __vue_template__ = __webpack_require__(1771)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ec2fc8f0"
	
	module.exports = __vue_exports__


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(534)
	
	/* template */
	var __vue_template__ = __webpack_require__(1625)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1108)
	
	/* script */
	__vue_exports__ = __webpack_require__(548)
	
	/* template */
	var __vue_template__ = __webpack_require__(1733)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1071)
	
	/* script */
	__vue_exports__ = __webpack_require__(549)
	
	/* template */
	var __vue_template__ = __webpack_require__(1692)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(938)
	
	/* script */
	__vue_exports__ = __webpack_require__(551)
	
	/* template */
	var __vue_template__ = __webpack_require__(1550)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-43485a14"
	
	module.exports = __vue_exports__


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1103)
	
	/* script */
	__vue_exports__ = __webpack_require__(555)
	
	/* template */
	var __vue_template__ = __webpack_require__(1728)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b700d4fa"
	
	module.exports = __vue_exports__


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1008)
	
	/* script */
	__vue_exports__ = __webpack_require__(560)
	
	/* template */
	var __vue_template__ = __webpack_require__(1623)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-674316b0"
	
	module.exports = __vue_exports__


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(859)
	
	/* script */
	__vue_exports__ = __webpack_require__(567)
	
	/* template */
	var __vue_template__ = __webpack_require__(1460)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-11b82438"
	
	module.exports = __vue_exports__


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(978)
	
	/* script */
	__vue_exports__ = __webpack_require__(569)
	
	/* template */
	var __vue_template__ = __webpack_require__(1592)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57b76e06"
	
	module.exports = __vue_exports__


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(950)
	
	/* script */
	__vue_exports__ = __webpack_require__(571)
	
	/* template */
	var __vue_template__ = __webpack_require__(1562)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-488a89ef"
	
	module.exports = __vue_exports__


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1063)
	
	/* script */
	__vue_exports__ = __webpack_require__(583)
	
	/* template */
	var __vue_template__ = __webpack_require__(1683)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(996)
	
	/* script */
	__vue_exports__ = __webpack_require__(587)
	
	/* template */
	var __vue_template__ = __webpack_require__(1611)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-62ed89bf"
	
	module.exports = __vue_exports__


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1053)
	
	/* script */
	__vue_exports__ = __webpack_require__(589)
	
	/* template */
	var __vue_template__ = __webpack_require__(1673)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7a1aaf70"
	
	module.exports = __vue_exports__


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1093)
	
	/* script */
	__vue_exports__ = __webpack_require__(592)
	
	/* template */
	var __vue_template__ = __webpack_require__(1717)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a7f3a51e"
	
	module.exports = __vue_exports__


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1011)
	
	/* script */
	__vue_exports__ = __webpack_require__(593)
	
	/* template */
	var __vue_template__ = __webpack_require__(1628)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-69107416"
	
	module.exports = __vue_exports__


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(873)
	
	/* script */
	__vue_exports__ = __webpack_require__(597)
	
	/* template */
	var __vue_template__ = __webpack_require__(1474)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1a690d52"
	
	module.exports = __vue_exports__


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1092)
	
	/* script */
	__vue_exports__ = __webpack_require__(603)
	
	/* template */
	var __vue_template__ = __webpack_require__(1714)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a5458594"
	
	module.exports = __vue_exports__


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1055)
	
	/* script */
	__vue_exports__ = __webpack_require__(608)
	
	/* template */
	var __vue_template__ = __webpack_require__(1675)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(854)
	
	/* script */
	__vue_exports__ = __webpack_require__(614)
	
	/* template */
	var __vue_template__ = __webpack_require__(1455)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0f93c863"
	
	module.exports = __vue_exports__


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(905)
	
	/* script */
	__vue_exports__ = __webpack_require__(618)
	
	/* template */
	var __vue_template__ = __webpack_require__(1511)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2d159440"
	
	module.exports = __vue_exports__


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1039)
	
	/* script */
	__vue_exports__ = __webpack_require__(640)
	
	/* template */
	var __vue_template__ = __webpack_require__(1659)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-75a6b0ef"
	
	module.exports = __vue_exports__


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1142)
	
	/* script */
	__vue_exports__ = __webpack_require__(653)
	
	/* template */
	var __vue_template__ = __webpack_require__(1770)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ebad7330"
	
	module.exports = __vue_exports__


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(939)
	
	/* script */
	__vue_exports__ = __webpack_require__(659)
	
	/* template */
	var __vue_template__ = __webpack_require__(1551)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-438256ad"
	
	module.exports = __vue_exports__


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(829)
	
	/* script */
	__vue_exports__ = __webpack_require__(663)
	
	/* template */
	var __vue_template__ = __webpack_require__(1429)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1010)
	
	/* script */
	__vue_exports__ = __webpack_require__(666)
	
	/* template */
	var __vue_template__ = __webpack_require__(1627)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-68d5e0e0"
	
	module.exports = __vue_exports__


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(969)
	
	/* script */
	__vue_exports__ = __webpack_require__(673)
	
	/* template */
	var __vue_template__ = __webpack_require__(1582)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-540947a6"
	
	module.exports = __vue_exports__


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1149)
	
	/* script */
	__vue_exports__ = __webpack_require__(674)
	
	/* template */
	var __vue_template__ = __webpack_require__(1778)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1135)
	
	/* script */
	__vue_exports__ = __webpack_require__(675)
	
	/* template */
	var __vue_template__ = __webpack_require__(1763)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(909)
	
	/* script */
	__vue_exports__ = __webpack_require__(677)
	
	/* template */
	var __vue_template__ = __webpack_require__(1516)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(956)
	
	/* script */
	__vue_exports__ = __webpack_require__(680)
	
	/* template */
	var __vue_template__ = __webpack_require__(1569)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4b6592c5"
	
	module.exports = __vue_exports__


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1101)
	
	/* script */
	__vue_exports__ = __webpack_require__(684)
	
	/* template */
	var __vue_template__ = __webpack_require__(1726)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b216f258"
	
	module.exports = __vue_exports__


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(931)
	
	/* script */
	__vue_exports__ = __webpack_require__(686)
	
	/* template */
	var __vue_template__ = __webpack_require__(1542)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f1dafca"
	
	module.exports = __vue_exports__


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1061)
	
	/* script */
	__vue_exports__ = __webpack_require__(689)
	
	/* template */
	var __vue_template__ = __webpack_require__(1681)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7e62a5a2"
	
	module.exports = __vue_exports__


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(871)
	
	/* script */
	__vue_exports__ = __webpack_require__(690)
	
	/* template */
	var __vue_template__ = __webpack_require__(1472)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(844)
	
	/* script */
	__vue_exports__ = __webpack_require__(691)
	
	/* template */
	var __vue_template__ = __webpack_require__(1445)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0864a57e"
	
	module.exports = __vue_exports__


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1034)
	
	/* script */
	__vue_exports__ = __webpack_require__(694)
	
	/* template */
	var __vue_template__ = __webpack_require__(1654)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-73c8caf7"
	
	module.exports = __vue_exports__


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(865)
	
	/* script */
	__vue_exports__ = __webpack_require__(708)
	
	/* template */
	var __vue_template__ = __webpack_require__(1466)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-141ad5e2"
	
	module.exports = __vue_exports__


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1049)
	
	/* script */
	__vue_exports__ = __webpack_require__(729)
	
	/* template */
	var __vue_template__ = __webpack_require__(1669)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7906737e"
	
	module.exports = __vue_exports__


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1012)
	
	/* script */
	__vue_exports__ = __webpack_require__(731)
	
	/* template */
	var __vue_template__ = __webpack_require__(1629)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-694147c9"
	
	module.exports = __vue_exports__


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(960)
	
	/* script */
	__vue_exports__ = __webpack_require__(732)
	
	/* template */
	var __vue_template__ = __webpack_require__(1573)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4e8ebce4"
	
	module.exports = __vue_exports__


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(735)
	
	/* template */
	var __vue_template__ = __webpack_require__(1715)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var langs = [{ 'code': 'en', 'name': 'English (American)' }, { 'code': 'ar-dz', 'name': 'Arabic (Algeria)' }, { 'code': 'ar-kw', 'name': 'Arabic (Kuwait)' }, { 'code': 'ar-ly', 'name': 'Arabic (Libya)' }, { 'code': 'ar-ma', 'name': 'Arabic (Morocco)' }, { 'code': 'ar-sa', 'name': 'Arabic (Saudi Arabia)' }, { 'code': 'ar-tn', 'name': 'Arabic (Tunisia)' }, { 'code': 'ar', 'name': 'Arabic', 'nativeName': 'العربية' }, { 'code': 'bg', 'name': 'Bulgarian', 'nativeName': 'български език' }, { 'code': 'ca', 'name': 'Catalan; Valencian', 'nativeName': 'Català' }, { 'code': 'cs', 'name': 'Czech', 'nativeName': 'česky, čeština' }, { 'code': 'da', 'name': 'Danish', 'nativeName': 'dansk' }, { 'code': 'de-at', 'name': 'German (Austria)', 'nativeName': 'Deutsch (Österreich)' }, { 'code': 'de-ch', 'name': 'German (Switzerland)', 'nativeName': 'Deutsch (Schweiz)' }, { 'code': 'de', 'name': 'German', 'nativeName': 'Deutsch' }, { 'code': 'el', 'name': 'Greek, Modern', 'nativeName': 'Ελληνικά' }, { 'code': 'en-au', 'name': 'English (Australia)' }, { 'code': 'en-ca', 'name': 'English (Canada)' }, { 'code': 'en-gb', 'name': 'English (United Kingdom)' }, { 'code': 'en-ie', 'name': 'English (Ireland)' }, { 'code': 'en-nz', 'name': 'English (New Zealand)' }, { 'code': 'es-do', 'name': 'Spanish (Dominican Republic)' }, { 'code': 'es-us', 'name': 'Spanish (American)' }, { 'code': 'es', 'name': 'Spanish; Castilian', 'nativeName': 'español, castellano' }, { 'code': 'et', 'name': 'Estonian', 'nativeName': 'eesti, eesti keel' }, { 'code': 'fa', 'name': 'Persian', 'nativeName': 'فارسی' }, { 'code': 'fi', 'name': 'Finnish', 'nativeName': 'suomi, suomen kieli' }, { 'code': 'fr-ca', 'name': 'French (Canadian)', 'nativeName': 'français (Swiss)' }, { 'code': 'fr-ch', 'name': 'French (Switzerland)', 'nativeName': 'français (Swiss)' }, { 'code': 'fr', 'name': 'French', 'nativeName': 'français, langue française' }, { 'code': 'he', 'name': 'Hebrew (modern)', 'nativeName': 'עברית' }, { 'code': 'hi', 'name': 'Hindi', 'nativeName': 'हिन्दी, हिंदी' }, { 'code': 'hr', 'name': 'Croatian', 'nativeName': 'hrvatski' }, { 'code': 'hu', 'name': 'Hungarian', 'nativeName': 'Magyar' }, { 'code': 'id', 'name': 'Indonesian', 'nativeName': 'Bahasa Indonesia' }, { 'code': 'it', 'name': 'Italian', 'nativeName': 'Italiano' }, { 'code': 'ja', 'name': 'Japanese', 'nativeName': '日本語 (にほんご／にっぽんご)' }, { 'code': 'ko', 'name': 'Korean', 'nativeName': '한국어 (韓國語), 조선말 (朝鮮語)' }, { 'code': 'lt', 'name': 'Lithuanian', 'nativeName': 'lietuvių kalba' }, { 'code': 'lv', 'name': 'Latvian', 'nativeName': 'latviešu valoda' }, { 'code': 'ms-my', 'name': 'Malay (Malaysia)', 'nativeName': 'bahasa Melayu, بهاس ملايو‎' }, { 'code': 'ms', 'name': 'Malay', 'nativeName': 'bahasa Melayu, بهاس ملايو‎' }, { 'code': 'nb', 'name': 'Norwegian Bokmål', 'nativeName': 'Norsk bokmål' }, { 'code': 'nl-be', 'name': 'Belgian Dutch' }, { 'code': 'nl', 'name': 'Dutch', 'nativeName': 'Nederlands, Vlaams' }, { 'code': 'nn', 'name': 'Norwegian Nynorsk', 'nativeName': 'Norsk nynorsk' }, { 'code': 'pl', 'name': 'Polish', 'nativeName': 'polski' }, { 'code': 'pt-br', 'name': 'Brazilian Portuguese' }, { 'code': 'pt', 'name': 'Portuguese', 'nativeName': 'Português' }, { 'code': 'ro', 'name': 'Romanian, Moldavian, Moldovan', 'nativeName': 'română' }, { 'code': 'ru', 'name': 'Russian', 'nativeName': 'русский язык' }, { 'code': 'sk', 'name': 'Slovak', 'nativeName': 'slovenčina' }, { 'code': 'sl', 'name': 'Slovene', 'nativeName': 'slovenščina' }, { 'code': 'sr-cyrl', 'name': 'Serbian Cyrillic' }, { 'code': 'sr', 'name': 'Serbian', 'nativeName': 'српски језик' }, { 'code': 'sv', 'name': 'Swedish', 'nativeName': 'svenska' }, { 'code': 'th', 'name': 'Thai', 'nativeName': 'ไทย' }, { 'code': 'tr', 'name': 'Turkish', 'nativeName': 'Türkçe' }, { 'code': 'uk', 'name': 'Ukrainian', 'nativeName': 'українська' }, { 'code': 'vi', 'name': 'Vietnamese', 'nativeName': 'Tiếng Việt' }, { 'code': 'zh-cn', 'name': 'Mainland China' }, { 'code': 'zh-tw', 'name': 'Taiwan' }];
	exports.default = langs;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueChartjs = __webpack_require__(1190);
	
	var reactiveProp = _vueChartjs.mixins.reactiveProp;
	exports.default = {
	  extends: _vueChartjs.Bar,
	  mixins: [reactiveProp],
	  props: ['options'],
	  mounted: function mounted() {
	    this.renderChart(this.chartData, this.options);
	  }
	};

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  inserted: function inserted(el, bindings, _ref) {
	    var context = _ref.context;
	
	    if (context.appendToBody) {
	      var _context$$refs$toggle = context.$refs.toggle.getBoundingClientRect(),
	          height = _context$$refs$toggle.height,
	          top = _context$$refs$toggle.top,
	          left = _context$$refs$toggle.left;
	
	      context.calculatePosition(el, context, {
	        width: context.$refs.toggle.clientWidth + 2 + 'px',
	        top: window.scrollY + top + height + 'px',
	        left: window.scrollX + left + 'px'
	      });
	      document.body.appendChild(el);
	    }
	  },
	  unbind: function unbind(el, bindings, vnode) {
	    if (vnode.context.appendToBody && el.parentNode) {
	      el.parentNode.removeChild(el);
	    }
	  }
	};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _arrow = __webpack_require__(1406);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _AssignHours = __webpack_require__(1205);
	
	var _AssignHours2 = _interopRequireDefault(_AssignHours);
	
	var _Buy = __webpack_require__(1212);
	
	var _Buy2 = _interopRequireDefault(_Buy);
	
	var _ColorPicker = __webpack_require__(122);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _CopyCalendar = __webpack_require__(298);
	
	var _CopyCalendar2 = _interopRequireDefault(_CopyCalendar);
	
	var _CreateKlasses = __webpack_require__(1225);
	
	var _CreateKlasses2 = _interopRequireDefault(_CreateKlasses);
	
	var _CreateRoomsButton = __webpack_require__(1227);
	
	var _CreateRoomsButton2 = _interopRequireDefault(_CreateRoomsButton);
	
	var _CreateUser = __webpack_require__(1229);
	
	var _CreateUser2 = _interopRequireDefault(_CreateUser);
	
	var _CreateUserButton = __webpack_require__(1230);
	
	var _CreateUserButton2 = _interopRequireDefault(_CreateUserButton);
	
	var _CreateUserButtonROR = __webpack_require__(1231);
	
	var _CreateUserButtonROR2 = _interopRequireDefault(_CreateUserButtonROR);
	
	var _DeleteDayOrWeek = __webpack_require__(306);
	
	var _DeleteDayOrWeek2 = _interopRequireDefault(_DeleteDayOrWeek);
	
	var _DeleteUserSettings = __webpack_require__(1402);
	
	var _DeleteUserSettings2 = _interopRequireDefault(_DeleteUserSettings);
	
	var _DirectDaySelector = __webpack_require__(129);
	
	var _DirectDaySelector2 = _interopRequireDefault(_DirectDaySelector);
	
	var _DropUp = __webpack_require__(351);
	
	var _DropUp2 = _interopRequireDefault(_DropUp);
	
	var _DSelectUsers = __webpack_require__(69);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _Hello = __webpack_require__(313);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _HoursShow = __webpack_require__(1269);
	
	var _HoursShow2 = _interopRequireDefault(_HoursShow);
	
	var _ListWithSearch = __webpack_require__(1272);
	
	var _ListWithSearch2 = _interopRequireDefault(_ListWithSearch);
	
	var _Login = __webpack_require__(1273);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Modal = __webpack_require__(315);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Notifications = __webpack_require__(1274);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _PublicContainer = __webpack_require__(356);
	
	var _PublicContainer2 = _interopRequireDefault(_PublicContainer);
	
	var _RecentUsers = __webpack_require__(1287);
	
	var _RecentUsers2 = _interopRequireDefault(_RecentUsers);
	
	var _Dashboard = __webpack_require__(1323);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _SchoolSideMenu = __webpack_require__(1330);
	
	var _SchoolSideMenu2 = _interopRequireDefault(_SchoolSideMenu);
	
	var _sms = __webpack_require__(1310);
	
	var _sms2 = _interopRequireDefault(_sms);
	
	var _SetupWidget = __webpack_require__(1404);
	
	var _SetupWidget2 = _interopRequireDefault(_SetupWidget);
	
	var _OnboardArrowVacationDaySelector = __webpack_require__(1403);
	
	var _OnboardArrowVacationDaySelector2 = _interopRequireDefault(_OnboardArrowVacationDaySelector);
	
	var _SideNav = __webpack_require__(84);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _Subs = __webpack_require__(1354);
	
	var _Subs2 = _interopRequireDefault(_Subs);
	
	var _Tagging = __webpack_require__(1369);
	
	var _Tagging2 = _interopRequireDefault(_Tagging);
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _TlTest = __webpack_require__(1381);
	
	var _TlTest2 = _interopRequireDefault(_TlTest);
	
	var _Manager = __webpack_require__(358);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _PresenceUser = __webpack_require__(70);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _VacationDaysSelector = __webpack_require__(130);
	
	var _VacationDaysSelector2 = _interopRequireDefault(_VacationDaysSelector);
	
	var _VideoGuides = __webpack_require__(1405);
	
	var _VideoGuides2 = _interopRequireDefault(_VideoGuides);
	
	var _DoYouTube = __webpack_require__(345);
	
	var _DoYouTube2 = _interopRequireDefault(_DoYouTube);
	
	var _EventChanges = __webpack_require__(116);
	
	var _EventChanges2 = _interopRequireDefault(_EventChanges);
	
	var _TeamCalendar = __webpack_require__(339);
	
	var _TeamCalendar2 = _interopRequireDefault(_TeamCalendar);
	
	var _BulkCreateSubjects = __webpack_require__(333);
	
	var _BulkCreateSubjects2 = _interopRequireDefault(_BulkCreateSubjects);
	
	var _SubjectsDistribution = __webpack_require__(1338);
	
	var _SubjectsDistribution2 = _interopRequireDefault(_SubjectsDistribution);
	
	var _QuillOnLesson = __webpack_require__(1286);
	
	var _QuillOnLesson2 = _interopRequireDefault(_QuillOnLesson);
	
	var _DeleteEventOnward = __webpack_require__(312);
	
	var _DeleteEventOnward2 = _interopRequireDefault(_DeleteEventOnward);
	
	var _CopyEvent = __webpack_require__(310);
	
	var _CopyEvent2 = _interopRequireDefault(_CopyEvent);
	
	var _CopyEventButton = __webpack_require__(1263);
	
	var _CopyEventButton2 = _interopRequireDefault(_CopyEventButton);
	
	var _ExportCalendar = __webpack_require__(83);
	
	var _ExportCalendar2 = _interopRequireDefault(_ExportCalendar);
	
	var _Permissions = __webpack_require__(1275);
	
	var _Permissions2 = _interopRequireDefault(_Permissions);
	
	var _CalendarView = __webpack_require__(1215);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _CalendarsBulk = __webpack_require__(1216);
	
	var _CalendarsBulk2 = _interopRequireDefault(_CalendarsBulk);
	
	var _Employment = __webpack_require__(1311);
	
	var _Employment2 = _interopRequireDefault(_Employment);
	
	var _SalarySubsPerf = __webpack_require__(325);
	
	var _SalarySubsPerf2 = _interopRequireDefault(_SalarySubsPerf);
	
	var _ZenImport = __webpack_require__(1390);
	
	var _ZenImport2 = _interopRequireDefault(_ZenImport);
	
	var _CreateCalendars = __webpack_require__(1224);
	
	var _CreateCalendars2 = _interopRequireDefault(_CreateCalendars);
	
	var _CreateSubject = __webpack_require__(329);
	
	var _CreateSubject2 = _interopRequireDefault(_CreateSubject);
	
	var _UserTasks = __webpack_require__(44);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _Print = __webpack_require__(117);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _HelpIcon = __webpack_require__(1268);
	
	var _HelpIcon2 = _interopRequireDefault(_HelpIcon);
	
	var _Students = __webpack_require__(1331);
	
	var _Students2 = _interopRequireDefault(_Students);
	
	var _ExternalCalendars = __webpack_require__(1219);
	
	var _ExternalCalendars2 = _interopRequireDefault(_ExternalCalendars);
	
	var _ImportSubjectsToKlass = __webpack_require__(330);
	
	var _ImportSubjectsToKlass2 = _interopRequireDefault(_ImportSubjectsToKlass);
	
	var _OverviewToday = __webpack_require__(336);
	
	var _OverviewToday2 = _interopRequireDefault(_OverviewToday);
	
	var _SendMessages = __webpack_require__(1309);
	
	var _SendMessages2 = _interopRequireDefault(_SendMessages);
	
	var _AnnualNorm = __webpack_require__(1196);
	
	var _AnnualNorm2 = _interopRequireDefault(_AnnualNorm);
	
	var _Profile = __webpack_require__(1283);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _DShowEventFullCal = __webpack_require__(1265);
	
	var _DShowEventFullCal2 = _interopRequireDefault(_DShowEventFullCal);
	
	var _DCalendarHeader = __webpack_require__(301);
	
	var _DCalendarHeader2 = _interopRequireDefault(_DCalendarHeader);
	
	var _DoCalendar = __webpack_require__(297);
	
	var _DoCalendar2 = _interopRequireDefault(_DoCalendar);
	
	var _Arbeidsplan = __webpack_require__(1200);
	
	var _Arbeidsplan2 = _interopRequireDefault(_Arbeidsplan);
	
	var _BasisOverview = __webpack_require__(1211);
	
	var _BasisOverview2 = _interopRequireDefault(_BasisOverview);
	
	var _DutySchedule = __webpack_require__(308);
	
	var _DutySchedule2 = _interopRequireDefault(_DutySchedule);
	
	var _RequestSubjects = __webpack_require__(1336);
	
	var _RequestSubjects2 = _interopRequireDefault(_RequestSubjects);
	
	var _AbsenceReasons = __webpack_require__(1194);
	
	var _AbsenceReasons2 = _interopRequireDefault(_AbsenceReasons);
	
	var _Reductions = __webpack_require__(1288);
	
	var _Reductions2 = _interopRequireDefault(_Reductions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(826);
	
	_vue2.default.component('assign-users-hours', _AssignHours2.default);
	_vue2.default.component('buy', _Buy2.default);
	_vue2.default.component('color-picker', _ColorPicker2.default);
	_vue2.default.component('copy-calendar', _CopyCalendar2.default);
	_vue2.default.component('copy-calendar', _CopyCalendar2.default);
	_vue2.default.component('create-klasses', _CreateKlasses2.default);
	_vue2.default.component('create-rooms-button', _CreateRoomsButton2.default);
	_vue2.default.component('create-users', _CreateUser2.default);
	_vue2.default.component('create-users-button', _CreateUserButton2.default);
	_vue2.default.component('create-users-button-ror', _CreateUserButtonROR2.default);
	_vue2.default.component('d-select-users', _DSelectUsers2.default);
	_vue2.default.component('delete-day-or-week', _DeleteDayOrWeek2.default);
	_vue2.default.component('delete-user-settings', _DeleteUserSettings2.default);
	_vue2.default.component('direct-day-selector', _DirectDaySelector2.default);
	_vue2.default.component('dropup', _DropUp2.default);
	_vue2.default.component('hello', _Hello2.default);
	_vue2.default.component('hours-show', _HoursShow2.default);
	_vue2.default.component('list-with-search', _ListWithSearch2.default);
	_vue2.default.component('login', _Login2.default);
	_vue2.default.component('modal', _Modal2.default);
	_vue2.default.component('notifications', _Notifications2.default);
	_vue2.default.component('onboarding-arrow', _arrow2.default);
	_vue2.default.component('public-view', _PublicContainer2.default);
	_vue2.default.component('recent-users', _RecentUsers2.default);
	_vue2.default.component('school-dashboard', _Dashboard2.default);
	_vue2.default.component('school-sidebar', _SchoolSideMenu2.default);
	_vue2.default.component('send-sms', _sms2.default);
	_vue2.default.component('setup-widget', _SetupWidget2.default);
	_vue2.default.component('setup-widget-arrow', _OnboardArrowVacationDaySelector2.default);
	_vue2.default.component('side-nav', _SideNav2.default);
	_vue2.default.component('substitution', _Subs2.default);
	_vue2.default.component('tagging', _Tagging2.default);
	_vue2.default.component('time-changer', _TimeChanger2.default);
	_vue2.default.component('tl-test', _TlTest2.default);
	_vue2.default.component('toasts', _Manager2.default);
	_vue2.default.component('toasts', _Manager2.default);
	_vue2.default.component('user-presence', _PresenceUser2.default);
	_vue2.default.component('vacation-days-selector', _VacationDaysSelector2.default);
	_vue2.default.component('video-guides', _VideoGuides2.default);
	_vue2.default.component('do-youtube', _DoYouTube2.default);
	_vue2.default.component('event-changes', _EventChanges2.default);
	_vue2.default.component('team-calendar', _TeamCalendar2.default);
	_vue2.default.component('bulk-create-subjects', _BulkCreateSubjects2.default);
	_vue2.default.component('subjects-distribution', _SubjectsDistribution2.default);
	_vue2.default.component('quill-on-lesson', _QuillOnLesson2.default);
	_vue2.default.component('delete-event-onward', _DeleteEventOnward2.default);
	_vue2.default.component('copy-event', _CopyEvent2.default);
	_vue2.default.component('copy-event-button', _CopyEventButton2.default);
	_vue2.default.component('export-calendar', _ExportCalendar2.default);
	_vue2.default.component('permissions', _Permissions2.default);
	_vue2.default.component('user-calendar', _CalendarView2.default);
	_vue2.default.component('calendars-bulk', _CalendarsBulk2.default);
	_vue2.default.component('employment', _Employment2.default);
	_vue2.default.component('salary', _SalarySubsPerf2.default);
	_vue2.default.component('zen-import', _ZenImport2.default);
	_vue2.default.component('create-calendars', _CreateCalendars2.default);
	_vue2.default.component('create-subject', _CreateSubject2.default);
	_vue2.default.component('user-tasks', _UserTasks2.default);
	_vue2.default.component('print-calendars', _Print2.default);
	_vue2.default.component('help-icon', _HelpIcon2.default);
	_vue2.default.component('students', _Students2.default);
	_vue2.default.component('external-calendars', _ExternalCalendars2.default);
	_vue2.default.component('import-subjects-to-klass', _ImportSubjectsToKlass2.default);
	_vue2.default.component('subs-today', _OverviewToday2.default);
	_vue2.default.component('send-messages', _SendMessages2.default);
	_vue2.default.component('annual-norm', _AnnualNorm2.default);
	_vue2.default.component('d-profile', _Profile2.default);
	_vue2.default.component('d-show-event-full-cal', _DShowEventFullCal2.default);
	_vue2.default.component('d-cal-header', _DCalendarHeader2.default);
	_vue2.default.component('do-calendar', _DoCalendar2.default);
	_vue2.default.component('work-time', _Arbeidsplan2.default);
	_vue2.default.component('basis-overview', _BasisOverview2.default);
	_vue2.default.component('duty-schedule', _DutySchedule2.default);
	_vue2.default.component('request-subjects', _RequestSubjects2.default);
	_vue2.default.component('absences', _AbsenceReasons2.default);
	_vue2.default.component('subject-reductions', _Reductions2.default);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userLocale = window.USER && window.USER.language ? window.USER.language : 'da';
	
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$helpers = {
	      konsol: function konsol(e) {
	        console.log('$helpers', e);
	      },
	      sortArrOnName: function sortArrOnName(arr) {
	        var usersWithoutSpecialCase = arr.filter(function (item) {
	          return item.name && !item.name.startsWith('(');
	        });
	        var usersSorted = usersWithoutSpecialCase.sort(function (a, b) {
	          return a.name.localeCompare(b.name, userLocale, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	        var usersWithSpecialCharacters = arr.filter(function (item) {
	          return item.name && item.name.startsWith('(');
	        });
	        var usersWithSpecialCharactersSorted = usersWithSpecialCharacters.sort(function (a, b) {
	          return a.name.localeCompare(b.name, userLocale, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	        return usersSorted.concat(usersWithSpecialCharactersSorted);
	      },
	      filterEventsOnDate: function filterEventsOnDate(events, date) {
	        return events.filter(function (event) {
	          return (0, _moment2.default)(event.start_time).format('YYYY-MM-DD') === (0, _moment2.default)(date).format('YYYY-MM-DD');
	        });
	      },
	      sortEventsOnDateTime: function sortEventsOnDateTime(events) {
	        var arr = events;
	        return arr.sort(function (a, b) {
	          return (0, _moment2.default)(a.start_time).unix() - (0, _moment2.default)(b.start_time).unix();
	        });
	      },
	      eventsSortedInDaysArray: function eventsSortedInDaysArray(events) {
	        return events.reduce(function (acc, curr, index) {
	          var val = (0, _moment2.default)(curr['start_time']).format('YYYY-MM-DD');
	          acc[val] = acc[val] || [];
	          acc[val].push(curr);
	          return acc;
	        }, {});
	      },
	      eventsPackedInDays: function eventsPackedInDays(events) {
	        return (0, _keys2.default)(events).map(function (e) {
	          return { date: e, events: events[e] };
	        });
	      },
	      checkUserDevice: function checkUserDevice() {
	        var isMobile = /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	        if (isMobile) {
	          return 'Mobile';
	        } else if (/iPad/i.test(navigator.userAgent)) {
	          return 'IPad';
	        } else {
	          return 'Desktop';
	        }
	      },
	      setSessionStorage: function setSessionStorage(name, val) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            window.sessionStorage[name] = val;
	          }
	        } catch (e) {}
	      },
	      getSessionStorage: function getSessionStorage(name) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            if (window.sessionStorage.getItem(name) !== null) {
	              return window.sessionStorage.getItem(name);
	            }
	          }
	        } catch (e) {}
	      },
	      setLocalStorage: function setLocalStorage(name, val) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            window.localStorage.setItem(name, val);
	          }
	        } catch (e) {}
	      },
	      getLocalStorage: function getLocalStorage(name) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            if (window.localStorage.getItem(name) !== null) {
	              return window.localStorage.getItem(name);
	            }
	          }
	        } catch (e) {}
	      },
	      removeLocalStorage: function removeLocalStorage(name) {
	        try {
	          if (typeof Storage !== 'undefined') {
	            if (window.localStorage.getItem(name) !== null) {
	              return window.localStorage.removeItem(name);
	            }
	          }
	        } catch (e) {}
	      },
	      getCookie: function getCookie(cname) {
	        var name = cname + '=';
	        var decodedCookie = decodeURIComponent(document.cookie);
	        var ca = decodedCookie.split(';');
	        for (var i = 0; i < ca.length; i++) {
	          var c = ca[i];
	          while (c.charAt(0) === ' ') {
	            c = c.substring(1);
	          }
	          if (c.indexOf(name) === 0) {
	            return c.substring(name.length, c.length);
	          }
	        }
	        return '';
	      },
	      setCookie: function setCookie(cname, cvalue) {
	        var days = 100;
	        var expires = '';
	        if (days) {
	          var date = new Date();
	          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	          expires = '; expires=' + date.toUTCString();
	        }
	        document.cookie = cname + '=' + (cvalue || '') + expires + '; path=/';
	      },
	      deleteCookie: function deleteCookie(cname) {
	        document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	      },
	      sendCustomEvt: function sendCustomEvt(evtName, val) {
	        var evt = new window.CustomEvent(evtName, { detail: val });
	        window.dispatchEvent(evt);
	      },
	      hashMap: function hashMap(arr, key) {
	        var filteredArr = arr.filter(function (item) {
	          return item[key];
	        });
	        if (!key) {
	          return filteredArr.reduce(function (obj, item) {
	            obj[item.id] = item;
	            return obj;
	          }, {});
	        } else {
	          return filteredArr.reduce(function (obj, item) {
	            obj[item[key]] = item;
	            return obj;
	          }, {});
	        }
	      }
	    };
	  }
	};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var da = __webpack_require__(1160);
	var da2 = __webpack_require__(1161);
	da.da.vue2 = da2;
	
	exports.default = da;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var en = __webpack_require__(1162);
	var en2 = __webpack_require__(1163);
	en.en.vue2 = en2;
	
	exports.default = en;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var no = __webpack_require__(1164);
	
	var no2 = __webpack_require__(1165);
	no.nb.vue2 = no2;
	
	exports.default = no;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(824);
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	__webpack_require__(365);
	
	var _vueRouter = __webpack_require__(1786);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueI18n = __webpack_require__(1191);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _store = __webpack_require__(371);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueTouch = __webpack_require__(1787);
	
	var _vueTouch2 = _interopRequireDefault(_vueTouch);
	
	var _App = __webpack_require__(1192);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1166);
	
	var _generalHelpers = __webpack_require__(366);
	
	var _generalHelpers2 = _interopRequireDefault(_generalHelpers);
	
	var _ComponentViewer = __webpack_require__(1193);
	
	var _ComponentViewer2 = _interopRequireDefault(_ComponentViewer);
	
	var _vueObserveVisibility = __webpack_require__(1785);
	
	var _vueObserveVisibility2 = _interopRequireDefault(_vueObserveVisibility);
	
	var _Show = __webpack_require__(1329);
	
	var _Show2 = _interopRequireDefault(_Show);
	
	var _OverviewTodayAbsentPublic = __webpack_require__(1346);
	
	var _OverviewTodayAbsentPublic2 = _interopRequireDefault(_OverviewTodayAbsentPublic);
	
	var _PublicContainer = __webpack_require__(356);
	
	var _PublicContainer2 = _interopRequireDefault(_PublicContainer);
	
	var _vueYoutube = __webpack_require__(1788);
	
	var _vueYoutube2 = _interopRequireDefault(_vueYoutube);
	
	var _vueTippyMin = __webpack_require__(379);
	
	var _vueTippyMin2 = _interopRequireDefault(_vueTippyMin);
	
	var _GrundskoleIndberetning = __webpack_require__(1289);
	
	var _GrundskoleIndberetning2 = _interopRequireDefault(_GrundskoleIndberetning);
	
	var _Timetalsindberetning = __webpack_require__(1308);
	
	var _Timetalsindberetning2 = _interopRequireDefault(_Timetalsindberetning);
	
	var _SchoolData = __webpack_require__(1325);
	
	var _SchoolData2 = _interopRequireDefault(_SchoolData);
	
	var _ProfileSSN = __webpack_require__(1284);
	
	var _ProfileSSN2 = _interopRequireDefault(_ProfileSSN);
	
	var _KompetenceIndberetning = __webpack_require__(1295);
	
	var _KompetenceIndberetning2 = _interopRequireDefault(_KompetenceIndberetning);
	
	var _SchoolDataAbsence = __webpack_require__(1326);
	
	var _SchoolDataAbsence2 = _interopRequireDefault(_SchoolDataAbsence);
	
	var _DoCalendar = __webpack_require__(297);
	
	var _DoCalendar2 = _interopRequireDefault(_DoCalendar);
	
	var _SchoolDataSubsAbsenceType = __webpack_require__(1328);
	
	var _SchoolDataSubsAbsenceType2 = _interopRequireDefault(_SchoolDataSubsAbsenceType);
	
	var _DutySchedule = __webpack_require__(308);
	
	var _DutySchedule2 = _interopRequireDefault(_DutySchedule);
	
	var _DoHeader = __webpack_require__(1250);
	
	var _DoHeader2 = _interopRequireDefault(_DoHeader);
	
	var _Substitution = __webpack_require__(1368);
	
	var _Substitution2 = _interopRequireDefault(_Substitution);
	
	var _da = __webpack_require__(367);
	
	var _da2 = _interopRequireDefault(_da);
	
	var _nb = __webpack_require__(369);
	
	var _nb2 = _interopRequireDefault(_nb);
	
	var _en = __webpack_require__(368);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _SideNav = __webpack_require__(84);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueTippyMin2.default, {
	  directive: 'tippy',
	  popperOptions: {
	    modifiers: {
	      preventOverflow: {
	        enabled: false
	      }
	    }
	  }
	});
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_generalHelpers2.default);
	_vue2.default.use(_vueYoutube2.default);
	_vue2.default.use(_vueObserveVisibility2.default);
	
	_vue2.default.use(_vueTouch2.default, { name: 'v-touch' });
	
	var router = new _vueRouter2.default({
	  routes: [{
	    path: '/subs/:school_id', components: {
	      default: _Substitution2.default,
	      SideNav: _SideNav2.default,
	      Header: _DoHeader2.default
	    }
	  }, {
	    name: 'Plan',
	    path: '/plan/:school_id', components: {
	      default: _DutySchedule2.default,
	      SideNav: _SideNav2.default,
	      Header: _DoHeader2.default
	    }
	  }, { path: '/', component: _ComponentViewer2.default }, { path: '/public/:calendar_id', component: _PublicContainer2.default }, { path: '/public/substitutes_teachers_show/:school_uuid', component: _OverviewTodayAbsentPublic2.default }, { path: '/show', component: _Show2.default }, {
	    path: '/calendar/:calendar_id',
	    components: {
	      default: _DoCalendar2.default,
	      SideNav: _SideNav2.default,
	      Header: _DoHeader2.default
	    }
	  }, { path: '/dashboard/:school_id', component: _SchoolData2.default }, { path: '/dashboard/absence/:school_id', component: _SchoolDataAbsence2.default }, { path: '/dashboard/absence/subs/:school_id', component: _SchoolDataSubsAbsenceType2.default }, {
	    path: '/grundskoleindberetning/:school_id',
	    components: {
	      default: _GrundskoleIndberetning2.default
	    }
	  }, {
	    path: '/grundskoleindberetning/:school_id',
	    components: {
	      default: _GrundskoleIndberetning2.default
	    }
	  }, { path: '/timetalsindberetning/:school_id', component: _Timetalsindberetning2.default }, {
	    path: '/kompetenceindberetning/:school_id',
	    components: {
	      default: _KompetenceIndberetning2.default
	    }
	  }, {
	    path: '/users/:user_id',
	    components: {
	      default: _ProfileSSN2.default
	    }
	  }]
	});
	
	_vue2.default.use(_vueI18n2.default);
	
	var fallBackTLD = 'en';
	if (window.location.host.indexOf('.dk') > -1) {
	  fallBackTLD = 'da';
	} else if (window.location.host.indexOf('.no') > -1) {
	  fallBackTLD = 'nb';
	}
	
	var i18n = new _vueI18n2.default({
	  locale: window.USER && window.USER.language ? window.USER.language : fallBackTLD,
	  fallbackLocale: fallBackTLD,
	  messages: {
	    da: _da2.default.da,
	    nb: _nb2.default.nb,
	    nn: _nb2.default.nb,
	    en: _en2.default.en
	  }
	});
	var userLocale = window.USER && window.USER.locale ? window.USER.locale : 'en';
	_moment2.default.locale(userLocale);
	
	window.use_i18n = i18n;
	window.use_vuex = _store2.default;
	
	var pageApp = new _vue2.default({
	  i18n: i18n,
	  store: _store2.default,
	  el: '#app',
	  router: router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});
	
	exports.default = { pageApp: pageApp, router: router, i18n: i18n };

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(13);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _subs = __webpack_require__(378);
	
	var _subs2 = _interopRequireDefault(_subs);
	
	var _subjects = __webpack_require__(377);
	
	var _subjects2 = _interopRequireDefault(_subjects);
	
	var _employments = __webpack_require__(375);
	
	var _employments2 = _interopRequireDefault(_employments);
	
	var _flipper = __webpack_require__(376);
	
	var _flipper2 = _interopRequireDefault(_flipper);
	
	var _calendar = __webpack_require__(373);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _analytics = __webpack_require__(372);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _danishHolidays = __webpack_require__(374);
	
	var _danishHolidays2 = _interopRequireDefault(_danishHolidays);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  user: null,
	  isDeviceMobile: false,
	  isUserLoaded: false,
	  userSettings: null,
	  schoolSettings: {},
	  isLoadingSchoolSettings: false,
	  activeSchool: window.SCHOOL ? window.SCHOOL : null,
	  allUsers: [],
	  isLoadingAllUsers: true,
	  calendars: [],
	  isLoadingSchoolCalenders: true,
	  schoolYears: [],
	  activeSchoolYears: [],
	  activatedSchoolYear: '',
	  localActivatedSchoolYear: '',
	  onboardingStep: 0,
	  selectedTags: [],
	  calendarRelations: [],
	  isLoadingCalendarRelations: true,
	  isUpdatingCalendars: false
	};
	
	var getters = {
	  locale: function locale(state) {
	    return state.user && state.user.locale ? state.user.locale : window.USER ? window.USER.language : 'en';
	  },
	  schoolId: function schoolId(state) {
	    return state.activeSchool ? state.activeSchool.id * 1 : window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id * 1 : null;
	  },
	  schoolYearId: function schoolYearId(state) {
	    return state.localActivatedSchoolYear ? state.localActivatedSchoolYear.id : null;
	  },
	  schoolCountry: function schoolCountry(state) {
	    return state.activeSchool && state.activeSchool.country ? state.activeSchool.country : window.SCHOOL && window.SCHOOL.country ? window.SCHOOL.country : 'DK';
	  },
	  isSchoolSystem: function isSchoolSystem(state) {
	    return state.activeSchool && state.activeSchool.state ? state.activeSchool.state === 'system' : window.SCHOOL && window.SCHOOL.state ? window.SCHOOL.state : 'system';
	  },
	  isArbeidstidsplanActivated: function isArbeidstidsplanActivated(state) {
	    var features = state.activeSchool && state.activeSchool.features ? state.activeSchool.features : window.SCHOOL && window.SCHOOL.features ? window.SCHOOL.features : [];
	    return features.indexOf('work_time') > -1;
	  },
	  firstDayOfWeek: function firstDayOfWeek(state) {
	    return state.activeSchool && state.activeSchool.first_day_of_week_num !== undefined ? state.activeSchool.first_day_of_week_num : 1;
	  },
	  userSchools: function userSchools(state, getters, rootState, rootGetters) {
	    var schools = state.user && state.user.memberships ? state.user.memberships : [];
	    return schools.reduce(function (obj, item) {
	      obj[item.school_id] = item;
	      return obj;
	    }, {});
	  },
	  isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool(state) {
	    if (!state.user) {
	      return true;
	    }
	    if (state.user && state.user.admin) {
	      return false;
	    }
	    if (state.user && state.user.memberships) {
	      return state.user.current_school.authorize;
	    }
	  },
	  userPermissions: function userPermissions(state) {
	    if (state.user && state.user.memberships) {
	      var idx = state.user.memberships.findIndex(function (school) {
	        return school.school_id === state.activeSchool.id;
	      });
	      if (idx > -1) {
	        return state.user.memberships[idx].permissions;
	      } else {
	        return [];
	      }
	    } else {
	      return [];
	    }
	  },
	  usersSortedOnName: function usersSortedOnName(state) {
	    var users = state.allUsers.filter(function (user) {
	      return user.name !== null && user.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(users);
	  },
	  usersFilteredWithTags: function usersFilteredWithTags(state, getters) {
	    if (state.selectedTags.length < 1) {
	      return getters.usersSortedOnName;
	    }
	    return getters.usersSortedOnName.filter(function (user) {
	      return user.user_tags.some(function (tag) {
	        return state.selectedTags.indexOf(tag) >= 0;
	      });
	    });
	  },
	  allCalendarsInHash: function allCalendarsInHash(state, getters, rootState, rootGetters) {
	    var cals = state.calendars;
	    return cals.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  klassCalendars: function klassCalendars(state, getters) {
	    var klasses = state.calendars.filter(function (cal) {
	      return cal.type === 'klass' && cal.name !== null && cal.name !== '';
	    });
	    var klassesInActiveYear = klasses.filter(function (cal) {
	      return cal.school_year_id ? cal.school_year_id === state.localActivatedSchoolYear.id : cal.year === state.localActivatedSchoolYear.name;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(klassesInActiveYear);
	  },
	  userCalendars: function userCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'user' && cal.name !== null && cal.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  roomCalendars: function roomCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'room' && !cal.archived_at && cal.name !== null && cal.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  roomCalendarsInclArchived: function roomCalendarsInclArchived(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'room' && cal.name !== null && cal.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  mergeCalendars: function mergeCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'merge' && cal.name !== '' && !cal.archived_at;
	    });
	    var calsInActiveYear = cals.filter(function (cal) {
	      return !cal.school_year_id || cal.school_year_id === state.localActivatedSchoolYear.id;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(calsInActiveYear);
	  },
	  mergeCalendarsInclArchived: function mergeCalendarsInclArchived(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'merge';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  otherCalendars: function otherCalendars(state, getters) {
	    var otherCals = state.calendars.filter(function (cal) {
	      return cal.type === 'other' && cal.name !== '';
	    });
	    var otherCalsInActiveYear = otherCals.filter(function (cal) {
	      return cal.school_year_id ? cal.school_year_id === state.localActivatedSchoolYear.id : cal.year === state.localActivatedSchoolYear.name;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(otherCalsInActiveYear);
	  },
	  clubCalendars: function clubCalendars(state, getters) {
	    var clubCals = state.calendars.filter(function (cal) {
	      return cal.type === 'club' && cal.name !== '';
	    });
	    var clubCalsInActiveYear = clubCals.filter(function (cal) {
	      return cal.school_year_id ? cal.school_year_id === state.localActivatedSchoolYear.id : cal.year === state.localActivatedSchoolYear.name;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(clubCalsInActiveYear);
	  },
	  allStudentCalendars: function allStudentCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'student' && cal.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(cals);
	  },
	  studentCalendars: function studentCalendars(state, getters) {
	    return getters.allStudentCalendars.filter(function (cal) {
	      return !cal.archived_at;
	    });
	  },
	  kindergartenCalendars: function kindergartenCalendars(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'kindergarten' && cal.name !== '';
	    });
	    var calsInActiveYear = cals.filter(function (cal) {
	      return cal.school_year_id ? cal.school_year_id === state.localActivatedSchoolYear.id : cal.year === state.localActivatedSchoolYear.name;
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(calsInActiveYear);
	  },
	  allKlassCalendarsInHash: function allKlassCalendarsInHash(state, getters) {
	    var cals = state.calendars.filter(function (cal) {
	      return cal.type === 'klass';
	    });
	    var newCals = cals.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	    return newCals;
	  },
	  allUsersInCalIdHash: function allUsersInCalIdHash(state, getters) {
	    return state.allUsers.reduce(function (obj, item) {
	      obj[item.user_calendar_id] = item;
	      return obj;
	    }, {});
	  },
	
	  allUsersInHash: function allUsersInHash(state) {
	    return state.allUsers.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  hiddenTaskDistributionCategories: function hiddenTaskDistributionCategories(state) {
	    return state.schoolSettings && state.schoolSettings.hiddenTaskDistributionCategories ? state.schoolSettings.hiddenTaskDistributionCategories : [];
	  },
	  shownOwnPools: function shownOwnPools(state) {
	    return state.schoolSettings && state.schoolSettings.shownOwnPools ? state.schoolSettings.shownOwnPools : [];
	  }
	};
	
	var mutations = {
	  setIsUserLoaded: function setIsUserLoaded(state, boolean) {
	    state.isUserLoaded = boolean;
	  },
	  setSelectedTags: function setSelectedTags(state, tag) {
	    if (state.selectedTags.indexOf(tag) < 0) {
	      state.selectedTags.push(tag);
	    } else {
	      state.selectedTags.splice(state.selectedTags.indexOf(tag), 1);
	    }
	  },
	  setUser: function setUser(state, data) {
	    state.user = data;
	  },
	  updateUserProp: function updateUserProp(state, data) {
	    var prop = data.prop;
	    state.user[prop] = data[prop];
	  },
	  setIsDeviceMobile: function setIsDeviceMobile(state, boolean) {
	    state.isDeviceMobile = boolean;
	  },
	  setUserSettings: function setUserSettings(state, data) {
	    state.userSettings = JSON.parse(data);
	  },
	  setSchoolSettings: function setSchoolSettings(state, data) {
	    var parsedData = void 0;
	    try {
	      parsedData = data && data.settings ? data.settings : data;
	    } catch (err) {
	      parsedData = data;
	      console.error(err.message, err);
	    }
	    state.schoolSettings = parsedData;
	  },
	  updateSchoolUser: function updateSchoolUser(state, data) {
	    var idx = state.allUsers.findIndex(function (user) {
	      return user.id === data.id;
	    });
	    _vue2.default.set(state.allUsers, idx, data);
	  },
	  updatePropOnSchoolUser: function updatePropOnSchoolUser(state, data) {
	    var prop = data.prop;
	    var idx = state.allUsers.findIndex(function (user) {
	      return user.id === data.userId;
	    });
	    state.allUsers[idx][prop] = data[prop];
	  },
	  setActiveSchool: function setActiveSchool(state, data) {
	    state.activeSchool = data;
	  },
	  updateActiveSchoolDuration: function updateActiveSchoolDuration(state, subjectDefaultDuration) {
	    state.activeSchool.subject_default_duration = subjectDefaultDuration;
	  },
	  setCalendars: function setCalendars(state, data) {
	    state.calendars = data;
	  },
	  updateCalendars: function updateCalendars(state, calendars) {
	    calendars.forEach(function (calendar) {
	      var idx = state.calendars.findIndex(function (cal) {
	        return cal.id === calendar.id;
	      });
	      _vue2.default.set(state.calendars, idx, calendar);
	    });
	  },
	  updatePropsOnCalendars: function updatePropsOnCalendars(state, updatedCalendars) {
	    var props = (0, _keys2.default)(updatedCalendars[0]);
	    updatedCalendars.forEach(function (calendar) {
	      var idx = state.calendars.findIndex(function (cal) {
	        return cal.id === calendar.calendar_id;
	      });
	      var updatedCalendar = state.calendars[idx];
	      props.forEach(function (propName) {
	        if (propName !== 'calendar_id') {
	          updatedCalendar[propName] = calendar[propName];
	        }
	      });
	      _vue2.default.set(state.calendars, idx, updatedCalendar);
	    });
	  },
	  setIsLoadingSchoolCalenders: function setIsLoadingSchoolCalenders(state, boolean) {
	    state.isLoadingSchoolCalenders = boolean;
	  },
	  setUsers: function setUsers(state, data) {
	    state.allUsers = data;
	  },
	  setIsLoadingAllUsers: function setIsLoadingAllUsers(state, boolean) {
	    state.isLoadingAllUsers = boolean;
	  },
	  setOnboardingStep: function setOnboardingStep(state, num) {
	    state.onboardingStep = num;
	  },
	  setSchoolYears: function setSchoolYears(state, data) {
	    state.schoolYears = data;
	    state.activeSchoolYears = data.filter(function (year) {
	      return year.active;
	    });
	  },
	  setlocalActivatedSchoolYear: function setlocalActivatedSchoolYear(state, schoolYearId) {
	    var idx = state.activeSchoolYears.map(function (e) {
	      return e.id;
	    }).indexOf(schoolYearId * 1);
	    var activeYearId = '';
	    if (idx > -1) {
	      state.localActivatedSchoolYear = state.activeSchoolYears[idx];
	      activeYearId = schoolYearId;
	    } else {
	      state.localActivatedSchoolYear = state.activeSchoolYears[0];
	      activeYearId = state.activeSchoolYears[0].id;
	    }
	    try {
	      if (typeof Storage !== 'undefined') {
	        window.localStorage.setItem('doActiveSchoolYearId', activeYearId);
	      }
	    } catch (e) {}
	  },
	  updateSchoolCalendar: function updateSchoolCalendar(state, updateObj) {
	    var idx = state.calendars.findIndex(function (calendar) {
	      return calendar.id === updateObj.id;
	    });
	    var updatedCalendar = state.calendars[idx];
	
	    updatedCalendar.name = updateObj.name;
	    updatedCalendar.archived_at = updateObj.archived_at;
	    updatedCalendar.custom_data = updateObj.custom_data;
	    _vue2.default.set(state.calendars, idx, updatedCalendar);
	  },
	  deleteSchoolCalendar: function deleteSchoolCalendar(state, calId) {
	    var idx = state.calendars.findIndex(function (calendar) {
	      return calendar.id === calId;
	    });
	    state.calendars.splice(idx, 1);
	  },
	  setRelations: function setRelations(state, data) {
	    state.calendarRelations = data;
	  },
	  updateRelations: function updateRelations(state, data) {
	    var idx = state.calendarRelations.findIndex(function (relations) {
	      return relations.id === data.id;
	    });
	    _vue2.default.set(state.calendarRelations, idx, data);
	  },
	  addRelation: function addRelation(state, data) {
	    state.calendarRelations.push(data);
	  },
	  deleteRelation: function deleteRelation(state, data) {
	    var idx = state.calendarRelations.findIndex(function (relations) {
	      return relations.id === data.id;
	    });
	    state.calendarRelations.splice(idx, 1);
	  }
	};
	
	var actions = {
	  getUser: function getUser(context) {
	    context.commit('setIsUserLoaded', false);
	    _docendo2.default.getUser(function (data) {
	      if (data.status === 'error') {
	        var pathUrl = window.location.href.replace(window.location.origin, '');
	        window.location.replace(data.redirect_to + '?return_to=' + encodeURIComponent(pathUrl));
	        return;
	      }
	      context.commit('setIsUserLoaded', true);
	      context.commit('setUser', data);
	      context.commit('setUserSettings', data.settings);
	    });
	  },
	  readSchoolSettings: function readSchoolSettings(context) {
	    var schoolId = context.state.activeSchool.id;
	    context.state.isLoadingSchoolSettings = true;
	    _docendo2.default.showSchool(schoolId, function (data) {
	      context.commit('setSchoolSettings', data.custom_data);
	      context.state.isLoadingSchoolSettings = false;
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  readActiveSchool: function readActiveSchool(context, school) {
	    var schoolId = school.id;
	    _docendo2.default.showSchool(schoolId, function (data) {
	      context.commit('setActiveSchool', data);
	      context.commit('setSchoolSettings', data.custom_data);
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  loadActiveSchool: function loadActiveSchool(context, school) {
	    var schoolId = school.id;
	    context.commit('setActiveSchool', school);
	    context.dispatch('getSchoolCalendars', schoolId);
	    context.dispatch('readSchoolYears', schoolId);
	    context.dispatch('getUsersFromSchoolId', schoolId);
	  },
	  updateUserSettings: function updateUserSettings(context, obj) {
	    var str = context.state.userSettings;
	    var prop = (0, _keys2.default)(obj)[0];
	    var val = obj[prop];
	    str[prop] = val;
	    _docendo2.default.updateUser({ settings: (0, _stringify2.default)(str) }, function (success) {
	      return context.commit('setUserSettings', success.settings);
	    });
	  },
	  deleteUserSetting: function deleteUserSetting(context, prop) {
	    var str = context.state.userSettings;
	    delete str[prop];
	    _docendo2.default.updateUser({ settings: (0, _stringify2.default)(str) }, function (success) {
	      return context.commit('setUserSettings', success.settings);
	    });
	  },
	  updateSchoolSettings: function updateSchoolSettings(context, obj) {
	    var schoolId = context.state.activeSchool.id;
	    var settingsObj = context.state.schoolSettings;
	    var prop = (0, _keys2.default)(obj)[0];
	    var val = obj[prop];
	    settingsObj[prop] = val;
	    _docendo2.default.updateSchool(schoolId, { custom_data: { settings: settingsObj } }, function (success) {
	      context.commit('setSchoolSettings', success.custom_data);
	    }, function (failure) {
	      console.log({ failure: failure });
	    });
	  },
	  deleteSchoolSetting: function deleteSchoolSetting(context, prop) {
	    var schoolId = context.state.activeSchool.id;
	    var settingsObj = context.state.schoolSettings;
	    delete settingsObj[prop];
	    _docendo2.default.updateSchool(schoolId, { custom_data: { settings: settingsObj } }, function (success) {
	      return context.commit('setSchoolSettings', success.custom_data);
	    });
	  },
	  updateSchoolSettingsForSchoolYear: function updateSchoolSettingsForSchoolYear(context, saveObj) {
	    var schoolId = context.state.activeSchool.id;
	    var schoolYearId = context.state.localActivatedSchoolYear.id;
	    var settingsObj = context.state.schoolSettings;
	    var prop = (0, _keys2.default)(saveObj)[0];
	    var val = saveObj[prop];
	    var dataProp = 'school_year_' + schoolYearId;
	    if (settingsObj.hasOwnProperty(dataProp)) {
	      settingsObj[dataProp][prop] = val;
	    } else {
	      settingsObj[dataProp] = (0, _defineProperty3.default)({}, prop, val);
	    }
	
	    _docendo2.default.updateSchool(schoolId, { custom_data: { settings: settingsObj } }, function (success) {
	      return context.commit('setSchoolSettings', success.custom_data);
	    });
	  },
	  deleteSchoolSettingForSchoolYear: function deleteSchoolSettingForSchoolYear(context, prop) {
	    var schoolId = context.state.activeSchool.id;
	    var schoolYearId = context.state.localActivatedSchoolYear.id;
	    var settingsObj = context.state.schoolSettings;
	    var dataProp = 'school_year_' + schoolYearId;
	    if (settingsObj[dataProp] && settingsObj[dataProp][prop]) {
	      delete settingsObj[dataProp][prop];
	      if ((0, _keys2.default)(settingsObj[dataProp]).length === 0) {
	        delete settingsObj[dataProp];
	      }
	      _docendo2.default.updateSchool(schoolId, { custom_data: { settings: settingsObj } }, function (success) {
	        return context.commit('setSchoolSettings', success.custom_data);
	      });
	    }
	  },
	
	  getSchoolCalendars: function getSchoolCalendars(context, id) {
	    context.commit('setIsLoadingSchoolCalenders', true);
	    _docendo2.default.calendarsForSchool(id, function (data) {
	      context.commit('setCalendars', data);
	      context.commit('setIsLoadingSchoolCalenders', false);
	      context.dispatch('setCalendarRelations');
	    });
	  },
	  updateSchoolCalendars: function updateSchoolCalendars(context, calendars) {
	    context.state.isUpdatingCalendars = true;
	    _docendo2.default.schoolBulkUpdateCalendars(window.SCHOOL.id, calendars, function (success) {
	      context.commit('updatePropsOnCalendars', calendars);
	      context.state.isUpdatingCalendars = false;
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	
	  getUsers: function getUsers(context, schoolId, userIdsFilter) {
	    context.commit('setIsLoadingAllUsers', true);
	    _docendo2.default.schoolUsers(window.SCHOOL.id, userIdsFilter, function (data) {
	      context.commit('setIsLoadingAllUsers', false);
	      if (data.status) {
	        return;
	      }
	      context.commit('setUsers', data);
	    });
	  },
	  getUsersFromSchoolId: function getUsersFromSchoolId(context, schoolId) {
	    context.commit('setIsLoadingAllUsers', true);
	    _docendo2.default.schoolUsers2(schoolId, function (data) {
	      context.commit('setIsLoadingAllUsers', false);
	      if (data.status) {
	        return;
	      }
	      context.commit('setUsers', data);
	    });
	  },
	  readSchoolYears: function readSchoolYears(context, schoolId) {
	    var activeSchoolId = null;
	    if (schoolId) {
	      activeSchoolId = schoolId;
	    } else {
	      activeSchoolId = window.SCHOOL.id;
	    }
	    _docendo2.default.schoolYearsRead(activeSchoolId, '', 'id', function (data) {
	      context.commit('setSchoolYears', data);
	      try {
	        if (typeof Storage !== 'undefined') {
	          if (window.localStorage.getItem('doActiveSchoolYearId') !== null) {
	            context.commit('setlocalActivatedSchoolYear', window.localStorage.getItem('doActiveSchoolYearId'));
	          } else {
	            var activeYears = context.state.activeSchoolYears;
	            context.commit('setlocalActivatedSchoolYear', activeYears[0].id);
	          }
	        }
	      } catch (e) {}
	    });
	  },
	  updateCalendar: function updateCalendar(context, calObj) {
	    _docendo2.default.schoolCalendarsUpdate(window.SCHOOL.id, calObj.calendarId, calObj.changes, function (success) {
	      var updateObj = {
	        id: success.id,
	        name: success.name,
	        archived_at: success.archived_at,
	        custom_data: {}
	      };
	      if (success.custom_data) {
	        updateObj['custom_data'] = success.custom_data;
	      }
	      context.commit('updateSchoolCalendar', updateObj);
	      _eventbus2.default.toast = { text: 'Calendar updated', 'success': true };
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	  deleteCalendar: function deleteCalendar(context, calId) {
	    _eventbus2.default.toast = { text: 'Deleting calendar', 'success': false };
	    _docendo2.default.schoolCalendarsDelete(window.SCHOOL.id, calId, function (success) {
	      context.commit('deleteSchoolCalendar', calId);
	      _eventbus2.default.toast = { text: 'Calendar deleted', 'success': true };
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	
	  readCalendarRelations: function readCalendarRelations(context) {
	    context.state.isLoadingCalendarRelations = true;
	    _docendo2.default.indexCalendarRelations(window.SCHOOL.id, function (data) {
	      context.commit('setRelations', data);
	      context.state.isLoadingCalendarRelations = false;
	      context.dispatch('setCalendarRelations');
	    }, function (failure) {
	      console.log('failed read relations');
	    });
	  },
	  createRelation: function createRelation(context, obj) {
	    _docendo2.default.createCalendarRelation(window.SCHOOL.id, obj.calendarId, obj.otherCalendarId, obj.relation, function (data) {
	      context.commit('addRelation', data);
	      context.dispatch('setCalendarRelations');
	    }, function (failure) {
	      console.log('failed to set relation');
	    });
	  },
	  deleteRelation: function deleteRelation(context, relationId) {
	    _docendo2.default.deleteCalendarRelation(window.SCHOOL.id, relationId, function (data) {
	      context.commit('deleteRelation', data);
	      context.dispatch('setCalendarRelations');
	    }, function (failure) {
	      console.log('failed to set relation');
	    });
	  },
	  setCalendarRelations: function setCalendarRelations(context) {
	    if (context.state.isLoadingSchoolCalenders || context.state.isLoadingCalendarRelations) {
	      return;
	    }
	    context.state.calendars.forEach(function (calendar) {
	      if (calendar.type === 'klass') {
	        var students = [];
	        context.state.calendarRelations.forEach(function (relation) {
	          if (relation.other_calendar_id === calendar.id) {
	            var idx = students.indexOf(relation.other_calendar_id);
	            if (idx < 0) {
	              students.push(relation.calendar_id);
	            }
	          }
	        });
	        _vue2.default.set(calendar, 'students', students);
	      }
	      if (calendar.type === 'student') {
	        var calRelations = [];
	        var klasses = [];
	        context.state.calendarRelations.forEach(function (relation) {
	          if (relation.calendar_id === calendar.id) {
	            var idx = klasses.indexOf(relation.calendar_id);
	            if (idx < 0) {
	              calRelations.push(relation);
	              klasses.push(relation.other_calendar_id);
	            }
	          }
	        });
	        _vue2.default.set(calendar, 'klasses', klasses);
	        _vue2.default.set(calendar, 'calRelations', calRelations);
	      }
	    });
	  }
	};
	exports.default = new _vuex2.default.Store({
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions,
	  modules: {
	    subs: _subs2.default,
	    subjects: _subjects2.default,
	    employments: _employments2.default,
	    flipper: _flipper2.default,
	    calendar: _calendar2.default,
	    analytics: _analytics2.default,
	    danishHolidays: _danishHolidays2.default
	  }
	});

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actions = {
	  analyticsOnVisitedCalendar: function analyticsOnVisitedCalendar(context) {
	    if (window.$crisp) {
	      window.$crisp.push(['set', 'session:event', [[['do_visited_calendar']]]]);
	    }
	  },
	  analyticsOnVisitedBuy: function analyticsOnVisitedBuy(context) {
	    if (window.$crisp) {
	      window.$crisp.push(['set', 'session:event', [[['do_visited_buy']]]]);
	    }
	  },
	  analyticsOnSubscribe: function analyticsOnSubscribe(context) {
	    if (window.$crisp) {
	      window.$crisp.push(['set', 'session:event', [[['do_subscribed']]]]);
	    }
	    if (window.fbq) {
	      window.fbq('track', 'Subscribe', {});
	    }
	  },
	  analyticsCopyCalender: function analyticsCopyCalender(context) {
	    if (window.$crisp) {
	      window.$crisp.push(['set', 'session:event', [[['do_visited_buy']]]]);
	    }
	  }
	};
	
	exports.default = {
	  actions: actions
	};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  calendarId: null,
	  calendar: null,
	  date: (0, _moment2.default)(),
	  subjects: [],
	  isSubjectsLoading: true,
	  isSubjectsLoadingTimer: null,
	  events: [],
	  isEventsLoading: false,
	  isEventsLoadingTimer: null,
	  activeEventId: null,
	  isDeletingEvent: false,
	  editSubject: null,
	  availabilityEvents: []
	};
	
	var getters = {
	  calendarStartDate: function calendarStartDate(state, getters, rootState, rootGetters) {
	    var firstDay = window.SCHOOL && window.SCHOOL.first_day_of_week_num ? window.SCHOOL.first_day_of_week_num : 1;
	    return (0, _moment2.default)(state.date).isoWeekday(firstDay).format('YYYY-MM-DD 00:00');
	  },
	  calendarEndDate: function calendarEndDate(state) {
	    var firstDay = window.SCHOOL && window.SCHOOL.first_day_of_week_num ? window.SCHOOL.first_day_of_week_num : 1;
	    var lastDay = firstDay + 6;
	    return (0, _moment2.default)(state.date).isoWeekday(lastDay).endOf('day');
	  },
	  activeCalendar: function activeCalendar(state, getters, rootState, rootGetters) {
	    return rootGetters.allCalendarsInHash[state.calendarId] ? rootGetters.allCalendarsInHash[state.calendarId] : state.calendar;
	  },
	  isUserCanEditCalendar: function isUserCanEditCalendar(state, getters, rootState, rootGetters) {
	    if (rootGetters.isPermissionsActivatedForSchool) {
	      return rootGetters.userPermissions.indexOf('can_do_most_stuff') > -1;
	    } else {
	      return true;
	    }
	  },
	
	  activeFullCalendarEvents: function activeFullCalendarEvents(state, getters) {
	    return state.events.map(function (event) {
	      if (event.event_type === 'presence') {
	        _vue2.default.set(event, 'display', 'background');
	        _vue2.default.set(event, 'rendering', 'background');
	        _vue2.default.set(event, 'className', 'fc-bgevent__presence');
	        return event;
	      }
	      var hasNotes = event.description.replace(/<(?:.|\n)*?>/gm, '') || event.notes_for_students.replace(/<(?:.|\n)*?>/gm, '') || event.teacher_notes.replace(/<(?:.|\n)*?>/gm, '') || event.learning_goal.replace(/<(?:.|\n)*?>/gm, '');
	      _vue2.default.set(event, 'has_notes', hasNotes);
	      return event;
	    });
	  },
	  activeFullCalendarEventsInHash: function activeFullCalendarEventsInHash(state, getters) {
	    return getters.activeFullCalendarEvents.reduce(function (obj, item) {
	      obj[item.event_id] = item;
	      return obj;
	    }, {});
	  },
	  activeCalendarEvent: function activeCalendarEvent(state) {
	    var idx = state.activeEventId ? state.events.findIndex(function (event) {
	      return event.event_id === state.activeEventId;
	    }) : -1;
	    return idx > -1 ? state.events[idx] : null;
	  }
	};
	
	var mutations = {
	  setActiveCalendarId: function setActiveCalendarId(state, calendarId) {
	    state.calendarId = calendarId;
	  },
	  setActiveCalendarDate: function setActiveCalendarDate(state, date) {
	    state.date = date;
	  },
	  addCalendarSubject: function addCalendarSubject(state, subject) {
	    state.subjects.push(subject);
	  },
	  setEditSubject: function setEditSubject(state, subject) {
	    state.editSubject = subject;
	  },
	  updateCalendarEvents: function updateCalendarEvents(state, updatedLessons) {
	    updatedLessons.updates.forEach(function (updatedLessonObj) {
	      if (updatedLessonObj.start_time && updatedLessonObj.end_time) {
	        var idx = state.events.findIndex(function (event) {
	          return event.event_id === updatedLessonObj.event_id;
	        });
	        var currentLesson = state.events[idx];
	
	        currentLesson.start = updatedLessonObj.start_time;
	        currentLesson.end = updatedLessonObj.end_time;
	        _vue2.default.set(state.events, idx, currentLesson);
	      }
	    });
	  },
	  updateEventId: function updateEventId(state, lesson) {
	    var idx = state.events.findIndex(function (event) {
	      return event.event_id === lesson.event_id;
	    });
	    if (idx < 0) {
	      var idxEventWithNoId = state.events.findIndex(function (event) {
	        return event.event_id === 'd_temp_id';
	      });
	      state.events[idxEventWithNoId].event_id = lesson.event_id;
	    }
	  },
	  addActiveCalendarEvent: function addActiveCalendarEvent(state, lesson) {
	    state.events.push(lesson);
	  },
	  deleteActiveCalendarEvent: function deleteActiveCalendarEvent(state, lesson) {
	    var idx = state.events.findIndex(function (event) {
	      return event.event_id === lesson.event_id;
	    });
	    if (idx > -1) {
	      state.events.splice(idx, 1);
	    }
	  },
	  updateActiveCalendarEventNote: function updateActiveCalendarEventNote(state, updateObj) {
	    var idx = state.events.findIndex(function (event) {
	      return event.event_id === updateObj.payload.id;
	    });
	    var updatedLesson = state.events[idx];
	
	    updatedLesson[updateObj.noteType] = updateObj.payload[updateObj.noteType];
	    _vue2.default.set(state.events, idx, updatedLesson);
	  },
	  setActiveCalendar: function setActiveCalendar(state, calendar) {
	    state.calendar = calendar;
	    state.calendarId = calendar.id;
	  },
	  setActiveCalendarEventId: function setActiveCalendarEventId(state, eventId) {
	    state.activeEventId = eventId;
	  }
	};
	
	var actions = {
	  readCalendar: function readCalendar(context, calendarId) {
	    _docendo2.default.calendar(calendarId, function (data) {
	      context.commit('setActiveCalendar', data);
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	  readCalendarSubjects: function readCalendarSubjects(context, isNewCalendar) {
	    if (context.state.isSubjectsLoadingTimer) {
	      clearTimeout(context.state.isSubjectsLoadingTimer);
	    }
	    if (!isNewCalendar) {
	      context.state.isSubjectsLoadingTimer = setTimeout(function (_) {
	        context.state.isSubjectsLoading = true;
	      }, 2000);
	    } else {
	      context.state.subjects = [];
	      context.state.isSubjectsLoading = true;
	    }
	    if (!context.state.calendarId) {
	      return;
	    }
	    _docendo2.default.sidebar(context.state.calendarId, context.state.date, function (success) {
	      clearTimeout(context.state.isSubjectsLoadingTimer);
	      context.state.isSubjectsLoading = false;
	      context.state.subjects = success;
	    }, function (failure) {
	      console.log('something went wrong');
	    });
	  },
	
	  createCalendarSubject: function createCalendarSubject(context, subject) {
	    console.log('vuex1::createCalendarSubject', subject);
	
	    function checkIfActiveCalendarDateIsSameOrInBetweenSchoolYear(schoolYearId) {
	      var schoolYear = context.rootState.schoolYears.find(function (schoolYear) {
	        return schoolYear.id === schoolYearId;
	      });
	      var schoolCalendarType = context.rootGetters.allCalendarsInHash[subject.calendarId] ? context.rootGetters.allCalendarsInHash[subject.calendarId]['type'] : null;
	      if (!schoolYear || !schoolCalendarType) {
	        return true;
	      }
	      var startDate = (0, _moment2.default)(schoolYear.employee_time_start);
	      var endDate = (0, _moment2.default)(schoolYear.employee_time_end);
	      if (schoolCalendarType === 'klass') {
	        startDate = (0, _moment2.default)(schoolYear.student_time_start);
	        endDate = (0, _moment2.default)(schoolYear.student_time_end);
	      }
	      var activeDate = context.state.date;
	      var isBetweenOrSame = (0, _moment2.default)(activeDate).isSameOrBefore(endDate) && (0, _moment2.default)(activeDate).isSameOrAfter(startDate);
	      return isBetweenOrSame;
	    }
	
	    var schoolId = context.rootState.activeSchool.id;
	    var preparation = subject.preparation ? subject.preparation : null;
	    var away = subject.away ? subject.away : false;
	    _docendo2.default.createSubject(subject.name, subject.color, subject.calendarId, subject.defaultDuration, preparation, subject.hours, subject.subjectType, schoolId, subject.schoolYearId, subject.calendarIds, subject.subjectCode, away, function (data) {
	      if (checkIfActiveCalendarDateIsSameOrInBetweenSchoolYear(data.school_year_id)) {
	        context.commit('addCalendarSubject', data);
	      } else {
	        var explainerI18n = window.use_i18n.t('vue2.create_subject.subject_is_not_created_in_this_school_year');
	        _eventbus2.default.toast = { text: explainerI18n, success: false };
	      }
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  deleteCalendarSubject: function deleteCalendarSubject(context, subject) {
	    _docendo2.default.deleteSubject(subject.id, subject.school_id, subject.school_year_id, function (data) {
	      context.dispatch('readCalendarSubjects');
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  updateCalendarSubject: function updateCalendarSubject(context, updatedSubject) {
	    console.log('vuex1::updatedSubject', updatedSubject);
	    var preparation = updatedSubject.preparation ? updatedSubject.preparation : null;
	    var away = updatedSubject.away ? updatedSubject.away : true;
	    _docendo2.default.updateSubject(updatedSubject.id, updatedSubject.name, updatedSubject.color, updatedSubject.calendarId, updatedSubject.calendarIds, updatedSubject.defaultDuration, preparation, updatedSubject.hours, updatedSubject.subjectType, updatedSubject.schoolId, updatedSubject.schoolYearId, updatedSubject.subjectCode, away, false, function (data) {
	      context.dispatch('readCalendarSubjects');
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  readCalendarEvents: function readCalendarEvents(context, obj) {
	    context.state.isEventsLoading = true;
	    _docendo2.default.calendarEvents2(obj.calIds, obj.start, obj.end, null, function (data) {
	      context.state.isEventsLoading = false;
	      clearTimeout(context.state.isEventsLoadingTimer);
	      context.state.events = data.length > 0 ? JSON.parse(data) : [];
	      if (obj.andReadSubjects) {
	        context.dispatch('readCalendarSubjects');
	      }
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	  createCalendarEvent: function createCalendarEvent(context, eventObj) {
	    var tempEventId = new Date().getTime();
	    _vue2.default.set(eventObj, 'event_id', tempEventId);
	    var calendarIds = [];
	    eventObj.calendars.forEach(function (calendar) {
	      return calendarIds.push(calendar.id);
	    });
	    if (calendarIds.indexOf(eventObj.calendar_id) < 0) {
	      calendarIds.push(eventObj.calendar_id);
	    }
	    context.commit('addActiveCalendarEvent', eventObj);
	    _docendo2.default.createEvent(eventObj.school_id, eventObj.calendar_id, calendarIds, eventObj.subject_id, eventObj.start, eventObj.end, eventObj.learning_goal, eventObj.description, eventObj.notes_for_students, eventObj.teacher_notes, function (success) {
	      if (success && success.status === 'error') {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      }
	      var calendarInfo = {
	        calIds: [context.state.calendarId],
	        start: context.getters.calendarStartDate,
	        end: context.getters.calendarEndDate
	      };
	      context.dispatch('readCalendarEvents', calendarInfo);
	      context.dispatch('readCalendarSubjects');
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	    console.log('createEVentVuex', eventObj);
	  },
	  createCalendarEvents: function createCalendarEvents(context, eventArr) {
	    eventArr.forEach(function (eventObj, key) {
	      var tempEventId = new Date().getTime() + eventObj.event_id;
	      _vue2.default.set(eventObj, 'event_id', tempEventId);
	      var calendarIds = [];
	      eventObj.calendars.forEach(function (calendar) {
	        return calendarIds.push(calendar.calendar_id);
	      });
	      if (calendarIds.indexOf(eventObj.calendar_id) < 0) {
	        calendarIds.push(eventObj.calendar_id);
	      }
	      context.commit('addActiveCalendarEvent', eventObj);
	      _docendo2.default.createEvent(eventObj.school_id, eventObj.calendar_id, calendarIds, eventObj.subject_id, eventObj.start, eventObj.end, eventObj.learning_goal, eventObj.description, eventObj.notes_for_students, eventObj.teacher_notes, function (success) {
	        if (success && success.status === 'error') {
	          _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	        }
	        var allDone = key + 1 === eventArr.length;
	        if (allDone) {
	          var calendarInfo = {
	            calIds: [context.state.calendarId],
	            start: context.getters.calendarStartDate,
	            end: context.getters.calendarEndDate
	          };
	          context.dispatch('readCalendarEvents', calendarInfo);
	          context.dispatch('readCalendarSubjects');
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    });
	  },
	  updateCalendarEventNotes: function updateCalendarEventNotes(context, updatedLesson) {
	    _docendo2.default.updateEvent(updatedLesson.schoolId, updatedLesson.eventId, updatedLesson.updates, function (success) {
	      if (success && success.status === 'error') {
	        console.log('failure', success);
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      }
	      var calendarInfo = {
	        calIds: [context.state.calendarId],
	        start: context.getters.calendarStartDate,
	        end: context.getters.calendarEndDate
	      };
	      context.dispatch('readCalendarEvents', calendarInfo);
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  updateCalendarEvent: function updateCalendarEvent(context, updatedLesson) {
	    context.commit('updateCalendarEvents', updatedLesson);
	
	    _docendo2.default.updateEvents(updatedLesson.school_id, updatedLesson.updates, function (success) {
	      if (success && success.status === 'error') {
	        console.log('failure', success);
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      }
	      var calendarInfo = {
	        calIds: [context.state.calendarId],
	        start: context.getters.calendarStartDate,
	        end: context.getters.calendarEndDate
	      };
	      context.dispatch('readCalendarEvents', calendarInfo);
	      context.dispatch('readCalendarSubjects');
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  deleteEvent: function deleteEvent(context, lesson) {
	    context.state.isDeletingEvent = true;
	    _docendo2.default.deleteEvent(lesson.school_id, lesson.event_id, function (success) {
	      context.state.isDeletingEvent = false;
	      context.commit('setActiveCalendarEventId', null);
	      context.commit('deleteActiveCalendarEvent', lesson);
	      context.dispatch('readCalendarSubjects');
	      if (_vue2.default.prototype.$helpers.getLocalStorage('do_dont_ask_delete_event')) {
	        var title = lesson.title ? lesson.title : 'The event';
	        var capitalize = function capitalize(s) {
	          return s && s[0].toUpperCase() + s.slice(1) || '';
	        };
	        var lessonTime = lesson.start && lesson.end ? capitalize((0, _moment2.default)(lesson.start).format('dddd LT')) + ' - ' + (0, _moment2.default)(lesson.end).format('LT') : '';
	        var isDeleted = window.use_i18n.t('vue2.common.is_deleted');
	        _eventbus2.default.toast = { text: title + ' ' + isDeleted + ' ' + lessonTime, success: true };
	      }
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  readEventAvailability: function readEventAvailability(context, lesson) {
	    _docendo2.default.eventAvailability(lesson.calendarId, lesson.eventId, context.getters.calendarStartDate, context.getters.calendarEndDate, function (success) {
	      context.state.availabilityEvents = success.length > 0 ? JSON.parse(success) : [];
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  readSubjectAvailability: function readSubjectAvailability(context, subject) {
	    _docendo2.default.subjectAvailability(subject.calendarId, subject.subjectId, context.getters.calendarStartDate, context.getters.calendarEndDate, function (success) {
	      context.state.availabilityEvents = success.length > 0 ? JSON.parse(success) : [];
	    }, function (failure) {
	      _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	    });
	  },
	  clearAvailability: function clearAvailability(context) {
	    context.state.availabilityEvents = [];
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  danishHolidays: ['01-01-2022', '10-04-2022', '14-04-2022', '15-04-2022', '17-04-2022', '18-04-2022', '13-05-2022', '26-05-2022', '05-06-2022', '06-06-2022', '05-06-2022', '24-12-2022', '25-12-2022', '26-12-2022', '31-12-2022', '01-01-2023', '02-04-2023', '06-04-2023', '07-04-2023', '09-04-2023', '10-04-2023', '05-05-2023', '18-05-2023', '28-05-2023', '29-05-2023', '24-12-2023', '25-12-2023', '26-12-2023', '31-12-2023', '01-01-2024', '24-03-2024', '28-03-2024', '29-03-2024', '31-03-2024', '01-04-2024', '09-05-2024', '19-05-2024', '20-05-2024', '25-12-2024', '26-12-2024', '01-01-2025', '17-04-2025', '18-04-2025', '21-04-2025', '29-05-2025', '09-06-2025', '25-12-2025', '26-12-2025', '01-01-2026', '02-04-2026', '03-04-2026', '06-04-2026', '14-05-2026', '25-05-2026', '25-12-2026', '26-12-2026', '01-01-2027', '25-03-2027', '26-03-2027', '29-04-2027', '06-05-2027', '17-05-2027', '25-12-2027', '26-12-2027', '01-01-2028', '13-04-2028', '14-04-2028', '17-04-2028', '25-05-2028', '25-12-2028', '26-12-2028']
	};
	
	var getters = {
	  holidaysWithinActiveSchoolYear: function holidaysWithinActiveSchoolYear(state) {
	    return function (startDate, endDate) {
	      var start = (0, _moment2.default)(startDate, 'YYYY-MM-DD');
	      var end = (0, _moment2.default)(endDate, 'YYYY-MM-DD');
	
	      return state.danishHolidays.filter(function (date) {
	        var mDate = (0, _moment2.default)(date, 'DD-MM-YYYY');
	        var isAfterStart = mDate.isSameOrAfter(start);
	        var isBeforeEnd = mDate.isSameOrBefore(end);
	        var isNotWeekend = mDate.isoWeekday() < 6;
	        return isAfterStart && isBeforeEnd && isNotWeekend;
	      });
	    };
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters
	};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(744);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  isLoadingEmploymentsTypesForSchool: false,
	  employmentsTypes: [],
	  employments: [],
	  isSubmitting: false,
	  isSubmittingUser: false
	};
	
	var getters = {
	  employmentTypesActive: function employmentTypesActive(state) {
	    return [].concat((0, _toConsumableArray3.default)(state.employmentsTypes)).sort(function (a, b) {
	      return a.localeCompare(b);
	    });
	  },
	  employmentToSelectForRules: function employmentToSelectForRules(state) {
	    var addArr = ['*Stillingen fra lektionen før*', '*Stillingen fra lektionen efter*'];
	    var sortedEmployments = state.employmentsTypes.slice().sort(function (a, b) {
	      return a.localeCompare(b);
	    });
	    return [].concat((0, _toConsumableArray3.default)(sortedEmployments), addArr);
	  },
	  employmentTitles: function employmentTitles(state) {
	    var uniqueTitles = [];
	    state.employments.forEach(function (employment) {
	      var idx = uniqueTitles.findIndex(function (uniqueTitle) {
	        return uniqueTitle === employment.title;
	      });
	      if (idx < 0) {
	        uniqueTitles.push(employment.title);
	      }
	    });
	    return uniqueTitles;
	  },
	  allSalaryCodes: function allSalaryCodes(state) {
	    var uniqueSalaryCodes = [];
	    state.employmentsTypes.forEach(function (employmentType) {
	      employmentType.salary_codes.forEach(function (salaryCode) {
	        var idx = uniqueSalaryCodes.findIndex(function (uniqueSalaryCode) {
	          return uniqueSalaryCode.code === salaryCode.code;
	        });
	        if (idx < 0) {
	          uniqueSalaryCodes.push(salaryCode);
	        }
	      });
	    });
	    return uniqueSalaryCodes.sort(function (a, b) {
	      return a.title.localeCompare(b.title);
	    });
	  },
	  employmentsInEmploymentTypeHash: function employmentsInEmploymentTypeHash(state, data) {
	    var hash = {};
	    state.employments.forEach(function (employment) {
	      if (employment.employment_type_id) {
	        if (hash[employment.employment_type_id]) {
	          hash[employment.employment_type_id].push(employment.user_id);
	        } else {
	          hash[employment.employment_type_id] = [employment.user_id];
	        }
	      }
	    });
	    return hash;
	  },
	  employmentsInUserIdHash: function employmentsInUserIdHash(state, getters) {
	    var hash = {};
	    state.employments.forEach(function (employment) {
	      if (hash[employment.user_id]) {
	        hash[employment.user_id].push(employment);
	      } else {
	        hash[employment.user_id] = [employment];
	      }
	    });
	    return hash;
	  }
	};
	
	var mutations = {
	  isLoadingEmploymentsTypesForSchool: function isLoadingEmploymentsTypesForSchool(state, boolean) {
	    state.isLoadingEmploymentsTypesForSchool = boolean;
	  },
	  setEmployments: function setEmployments(state, data) {
	    state.employments = data;
	  },
	  setEmploymentsTypes: function setEmploymentsTypes(state, data) {
	    state.employmentsTypes = data;
	  },
	  updateEmploymentsType: function updateEmploymentsType(state, obj) {
	    var idx = state.employmentsTypes.findIndex(function (type) {
	      return type.id === obj.id;
	    });
	    _vue2.default.set(state.employmentsTypes, idx, obj);
	  },
	  addEmploymentsType: function addEmploymentsType(state, obj) {
	    state.employmentsTypes.push(obj);
	  },
	  deleteEmploymentsType: function deleteEmploymentsType(state, id) {
	    var idx = state.employmentsTypes.findIndex(function (type) {
	      return type.id === id;
	    });
	    state.employmentsTypes.splice(idx, 1);
	  }
	};
	
	var actions = {
	  readEmploymentTypes: function readEmploymentTypes(context) {
	    var schoolId = context.rootGetters.schoolId;
	    context.commit('isLoadingEmploymentsTypesForSchool', true);
	    _docendo2.default.employmentTypesForSchool(schoolId, function (data) {
	      context.commit('setEmploymentsTypes', data);
	      context.commit('isLoadingEmploymentsTypesForSchool', false);
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  createEmploymentType: function createEmploymentType(context, obj) {
	    var schoolId = context.rootGetters.schoolId;
	    _docendo2.default.createEmploymentType(schoolId, obj.title, obj.manualSalary, function (success) {
	      context.commit('addEmploymentsType', success);
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  updateEmploymentsType: function updateEmploymentsType(context, obj) {
	    var schoolId = context.rootGetters.schoolId;
	    _docendo2.default.updateEmploymentType(schoolId, obj.id, obj.title, obj.manualSalary, function (success) {
	      context.commit('updateEmploymentsType', success);
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  readEmployments: function readEmployments(context) {
	    var schoolId = context.rootGetters.schoolId;
	    context.commit('isLoadingEmploymentsTypesForSchool', true);
	    _docendo2.default.employmentsForSchool(schoolId, function (data) {
	      context.commit('setEmployments', data);
	      context.commit('isLoadingEmploymentsTypesForSchool', false);
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  createSalaryCode: function createSalaryCode(context, obj) {
	    context.state.isSubmitting = true;
	    _docendo2.default.createSalaryCode(obj.schoolId, obj.employmentTypeId, obj.code, obj.title, function (data) {
	      console.log('createSalaryCode::oprettet', data);
	      context.state.isSubmitting = false;
	      context.dispatch('readEmploymentTypes');
	      context.dispatch('readEmployments');
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  createEmployments: function createEmployments(context, obj) {
	    context.state.isCreatingUserEmployments = true;
	    console.log('vuex::createEmployments', obj);
	    _docendo2.default.bulkCreateEmployment(obj.schoolId, obj.userIds, obj.employmentTypeIds, obj.isManualSalary, function (data) {
	      context.state.isCreatingUserEmployments = false;
	      context.dispatch('readEmploymentTypes');
	      context.dispatch('readEmployments');
	      _eventbus2.default.toast = { text: 'Oprettet', 'success': true };
	    }, function (failure) {
	      _eventbus2.default.toast = { text: failure.error, 'success': false };
	      console.log('failed read subjects');
	    });
	  },
	  deleteEmployment: function deleteEmployment(context, obj) {
	    _docendo2.default.deleteEmployment(obj.schoolId, obj.userId, obj.employmentId, function (data) {
	      if (data.status === 'error') {
	        _eventbus2.default.toast = { text: data.message, 'success': false };
	      }
	      context.dispatch('readEmployments');
	    }, function (failure) {
	      _eventbus2.default.toast = { text: failure.error, 'success': false };
	      console.log('failed read subjects');
	    });
	  },
	  archiveEmployment: function archiveEmployment(context, obj) {},
	  updateEmployment: function updateEmployment(context, obj) {
	    return new _promise2.default(function (resolve, reject) {
	      _docendo2.default.updateEmployment(obj.schoolId, obj.userId, obj.employmentId, obj.manualSalary, obj.defaultLoenart, obj.defaultLoebenummer, function (data) {
	        context.dispatch('readEmployments').then(function () {
	          resolve();
	        });
	      }, function (failure) {
	        _eventbus2.default.toast = { text: failure.error, success: false };
	        console.log('failed to update employment');
	        reject(failure.error);
	      });
	    });
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var state = {
	  schoolsTestingStudents: [58953, 58706, 56235, 54618, 41576, 50707, 54828, 51581, 51583, 51591, 51599, 51600, 51597, 50402, 51590, 51574, 51588, 51586, 51587, 51589, 51585, 51596, 51576, 51595, 51592, 51594, 51593, 51598, 51577, 51578, 51579, 51601, 51602, 51603, 51580, 8943, 51582, 51584, 51573, 33473, 9111, 37940, 50417, 50803, 51763, 52492, 51408, 50802, 54331, 54479, 54635, 56284, 43915, 55417, 55210, 56149, 54818, 56266, 57418, 57426, 57424, 57426, 57420, 57421, 57422, 57423, 57425, 57427, 57419, 57471]
	};
	
	var getters = {
	  isReductionsActive: function isReductionsActive(state, getters) {
	    return getters.schoolFeatures.indexOf('subject_reductions') > -1;
	  },
	  isKindergarten: function isKindergarten(state, getters, rootState) {
	    return getters.schoolFeatures.indexOf('calendar_kindergarten') > -1;
	  },
	  theSchool: function theSchool(state, getters, rootState) {
	    return rootState.activeSchool ? rootState.activeSchool : window.SCHOOL ? window.SCHOOL : null;
	  },
	  theSchoolCountry: function theSchoolCountry(state, getters, rootState) {
	    return getters.theSchool && getters.theSchool.country ? getters.theSchool.country.toUpperCase() : 'DK';
	  },
	  schoolFeatures: function schoolFeatures(state, getters, rootState) {
	    return getters.theSchool && getters.theSchool.features ? getters.theSchool.features : [];
	  },
	  isSchoolFeatureLocalePool: function isSchoolFeatureLocalePool(state, getters) {
	    return getters.schoolFeatures.indexOf('lokalpulje') > -1;
	  },
	  isSchoolTestingStudents: function isSchoolTestingStudents(state, getters, rootState) {
	    if (window.SCHOOL && window.SCHOOL.features) {
	      return window.SCHOOL.features.includes('calendar_student');
	    }
	
	    var school = rootState && rootState.activeSchool ? rootState.activeSchool : window.SCHOOL;
	    var schoolId = school && school.id ? school.id : '';
	
	    return state.schoolsTestingStudents.includes(schoolId);
	  },
	  isSchoolSFOActive: function isSchoolSFOActive(state, getters, rootState) {
	    var isActivated = getters.schoolFeatures.indexOf('calendar_club') > -1;
	    var schoolId = getters.schoolId;
	    var danishSchoolsWithoutSFO = [57418];
	    if (isActivated) {
	      return true;
	    } else if (getters.theSchoolCountry === 'NO' || getters.theSchoolCountry === 'DK' && danishSchoolsWithoutSFO.indexOf(schoolId) < 0) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  isSubStatusPendingActive: function isSubStatusPendingActive(state, getters, rootState) {
	    var schoolId = getters.schoolId;
	    var schoolIdsTestingSubStatusPending = [51580];
	    return schoolIdsTestingSubStatusPending.includes(schoolId);
	  },
	  isSchoolTestingTaskOverviewDesigner: function isSchoolTestingTaskOverviewDesigner(state, getters) {
	    var schoolId = getters.schoolId;
	    var schoolIdsTestingTaskOverviewDesigner = [62000, 7272, 59488, 59489, 62084];
	    return schoolIdsTestingTaskOverviewDesigner.includes(schoolId);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters
	};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(93);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  isSubmittingTask: false,
	  isLoading: true,
	  isLoadingSubjects: false,
	  isLoadingTasks: false,
	  isConfirmDeletion: false,
	  itemToDelete: null,
	  theDeletedItemId: null,
	  subjects: [],
	  usersAssignedHours: [],
	  tasks: [],
	  subjectTypeFilter: 'klass',
	  selectedSubjectTypeFilters: [],
	  subjectTypes: {
	    da: [{ name: 'Aktiviteter', value: 'activity', desc: 'Tæller UV-tid og reducerer timer på andre fag' }, { name: 'Fag', value: 'subject', desc: 'Tæller timer for klassen. To samtidige brikker tæller halvt.' }, { name: 'UUV', value: 'supplemental', desc: 'Tæller selvstændigt på understøttende undervisning.' }, {
	      name: 'Temavisning (Ramme)',
	      value: 'frame',
	      desc: 'Kan bruges til at markere temaer og anderledes dage i skemaet. Brikken er synlig for elever/forældre, mens fag-brikker, der ligger samtidig med tema-brikken, ikke er synlige. Fagbrikker tæller 100% i tidsrummet, og temabrikken tæller ikke.'
	    }, { name: 'Pause', value: 'break', desc: 'Andre lektioner bør ikke overlappe med en pause.' }, {
	      name: 'Ressource (skjult)',
	      value: 'resource',
	      desc: 'Bruges til at markere ressourcer i skemaet. Tæller ikke fra andre brikker. Vises som standard ikke i elev- og forældreskema.'
	    }, {
	      name: 'Valgfag/Hold',
	      value: 'optional',
	      desc: 'Tæller 100 % og uafhængigt af andre brikker i samme tidsrum.'
	    }, {
	      name: 'Ressource',
	      value: 'person_resource',
	      desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
	    }, { name: 'Anden tid', value: 'other_tasks', desc: 'Ikke undervisning.' }, { name: 'Øvrig tid', value: 'other_stuff', desc: 'Ikke undervisning, ikke elev-relateret.' }, { name: 'SFO', value: 'club', desc: 'Pædagogisk tid' }, { name: 'Øvrige opgaver', value: 'additional_tasks', desc: 'Tæller ikke UV' }],
	    en: [{
	      name: 'Subject',
	      value: 'subject',
	      desc: 'Counting hours for the class. Two simultaneous activities count as halves.'
	    }, {
	      name: 'Theme', value: 'frame',
	      desc: 'Can be used for marking themes and special days in the class schedule. The themed activity is visible for the pupils and parents, while classes that are overlapping the themed activity will not be visible. Classes are fully counting, and the themed activity is not.'
	    }, { name: 'Break', value: 'break', desc: 'Subjects should not overlap with breaks.' }, {
	      name: 'Ressource', value: 'resource',
	      desc: 'Can be used to register ressources. Is not visible to students/parents.'
	    }, {
	      name: 'Optional classes/groups',
	      value: 'optional',
	      desc: 'Fully counting and independent from other activities in the same time period.'
	    }, {
	      name: 'Ressource', value: 'resource',
	      desc: 'Can be used to register ressources. Is not visible to students/parents.'
	    }, { name: 'Other tasks', value: 'other_tasks', desc: 'Not teaching.' }, { name: 'Additional tasks', value: 'other_stuff', desc: 'Not classes and teaching, non-pupil related.' }],
	    nb: [{ name: 'Fag', value: 'subject', desc: 'Teller timer for klassen' }, {
	      name: 'Temavisning (Ramme)',
	      value: 'frame',
	      desc: 'Kan brukes til å markere temaer og spesielle dager/uker i timeplanen. Temavisning er synlig for elever/foreldre, og kan kombineres med fag. Fag teller 100% i perioden, og temaet teller ikke.'
	    }, { name: 'Pause', value: 'break', desc: 'Andre timer bør ikke overlapper med en pause.' }, {
	      name: 'Ressurs',
	      value: 'resource',
	      desc: 'Brukes til å markere ressursene i timeplanen. Teller ikke fra andre fag. Vises som standard ikke i elev- og foreldretimeplan.'
	    }, {
	      name: 'Valgfag/gruppe',
	      value: 'optional',
	      desc: 'Teller 100% og uavhengig av andre aktiviteter i samme tidsrom.'
	    }, {
	      name: 'Ressurs',
	      value: 'resource',
	      desc: 'Brukes til å markere ressursene i timeplanen. Teller ikke fra andre fag. Vises som standard ikke i elev- og foreldretimeplan.'
	    }, { name: 'Annen tid', value: 'other_tasks', desc: 'Ikke undervisning.' }, { name: 'Øvrig tid', value: 'other_stuff', desc: 'Ikke undervisning, ikke elevrelatert.' }]
	  },
	  userTableAcc: {
	    teaching: true
	  },
	  actualSubjectsForUser: [],
	  isLoadingTasksForUser: true,
	  userTasks: [],
	  userActualHours: {},
	  dbSubjectTypes: [{
	    key: 'absence',
	    i18n: {
	      da: 'Fravær',
	      en: 'Absence',
	      nb: 'Fravær'
	    }
	  }, {
	    key: 'additional_tasks',
	    i18n: {
	      da: 'Øvrige opgaver',
	      en: 'Additional tasks',
	      nb: 'Ekstra oppgaver'
	    }
	  }, {
	    key: 'available',
	    i18n: {
	      da: 'Rådighedstime',
	      en: 'Available',
	      nb: 'Tilgjengelig'
	    }
	  }, {
	    key: 'break',
	    i18n: {
	      da: 'Pause',
	      en: 'Break',
	      nb: 'Pause'
	    }
	  }, {
	    key: 'club',
	    i18n: {
	      da: 'SFO',
	      en: 'Club',
	      nb: 'Klubb'
	    }
	  }, {
	    key: 'exercise',
	    i18n: {
	      da: 'Bevægelse',
	      en: 'Exercise',
	      nb: 'Trening'
	    }
	  }, {
	    key: 'flexin',
	    i18n: {
	      da: 'Flex ind',
	      en: 'Flex in',
	      nb: 'Flex inn'
	    }
	  }, {
	    key: 'flexout',
	    i18n: {
	      da: 'Flex ud',
	      en: 'Flex out',
	      nb: 'Flex ut'
	    }
	  }, {
	    key: 'frame',
	    i18n: {
	      da: 'Temavisning/Ramme',
	      en: 'Frame',
	      nb: 'Ramme'
	    }
	  }, {
	    key: 'optional',
	    i18n: {
	      da: 'Valgfag',
	      en: 'Optional',
	      nb: 'Valgfritt'
	    }
	  }, {
	    key: 'other_stuff',
	    i18n: {
	      da: 'Øvrig tid',
	      en: 'Other stuff',
	      nb: 'Andre ting'
	    }
	  }, {
	    key: 'other_tasks',
	    i18n: {
	      da: 'Anden tid',
	      en: 'Other tasks',
	      nb: 'Annen tid'
	    }
	  }, {
	    key: 'resource',
	    i18n: {
	      da: 'Ressource (skjult)',
	      en: 'Resource',
	      nb: 'Ressurs'
	    }
	  }, {
	    key: 'person_resource',
	    i18n: {
	      da: 'Person ressource (skjult)',
	      en: 'Person resource',
	      nb: 'Personressurs'
	    }
	  }, {
	    key: 'person_resource_visible',
	    i18n: {
	      da: 'Ressource (synlig)',
	      en: 'Visible person resource',
	      nb: 'Synlig personressurs'
	    }
	  }, {
	    key: 'pool',
	    i18n: {
	      da: 'Lokalepulje',
	      en: 'Pool',
	      nb: 'Pulje'
	    }
	  }, {
	    key: 'preparation',
	    i18n: {
	      da: 'Forberedelse',
	      en: 'Preparation',
	      nb: 'Forberedelse'
	    }
	  }, {
	    key: 'reservation',
	    i18n: {
	      da: 'Reservation',
	      en: 'Reservation',
	      nb: 'Reservasjon'
	    }
	  }, {
	    key: 'subject',
	    i18n: {
	      da: 'Fag',
	      en: 'Subject',
	      nb: 'Fag'
	    }
	  }, {
	    key: 'supplemental',
	    i18n: {
	      da: 'UUV',
	      en: 'Supplemental',
	      nb: 'Supplerende'
	    }
	  }, {
	    key: 'with_kids',
	    i18n: {
	      da: 'Med børn',
	      en: 'With kids',
	      nb: 'Med barn'
	    }
	  }, {
	    key: 'without_kids',
	    i18n: {
	      da: 'Uden børn',
	      en: 'Without kids',
	      nb: 'Uten barn'
	    }
	  }],
	  subjectsRequests: [],
	  isLoadingSubjectsRequests: false,
	  reductions: [],
	  isLoadingReductions: false
	};
	
	var getters = {
	  reductionsInSubjectIdHash: function reductionsInSubjectIdHash(state, getters) {
	    var obj = {};
	    state.reductions.forEach(function (reduction) {
	      var activity = getters.subjectsInHash[reduction.activity_id] || {};
	      var reductionWithActivity = (0, _extends3.default)({}, reduction, {
	        vActivity: activity,
	        vActivityTitle: activity.name || '',
	        vActivityReductionHours: activity.hours || '?'
	      });
	
	      if (!obj[reduction.subject_id]) {
	        obj[reduction.subject_id] = [reductionWithActivity];
	      } else {
	        obj[reduction.subject_id].push(reductionWithActivity);
	      }
	    });
	    return obj;
	  },
	  activeSubjectTypeFilters: function activeSubjectTypeFilters(state, getters) {
	    var typesI18n = state.subjectTypes[getters.locale];
	    return state.selectedSubjectTypeFilters.filter(function (filter) {
	      return typesI18n.some(function (type) {
	        return type.name === filter;
	      });
	    }).map(function (filter) {
	      return typesI18n.find(function (type) {
	        return type.name === filter;
	      }).value;
	    });
	  },
	  subjectsFilteredOnType: function subjectsFilteredOnType(state, getters) {
	    var activeFilters = getters.activeSubjectTypeFilters;
	
	    if (!activeFilters || activeFilters.length === 0) {
	      return state.subjects;
	    }
	
	    return state.subjects.filter(function (subject) {
	      return activeFilters.includes(subject.subject_type);
	    });
	  },
	  klassCalIdsHashSortedOnName: function klassCalIdsHashSortedOnName(state, getters, rootState, rootGetters) {
	    var klasses = rootGetters.klassCalendars;
	    return klasses.map(function (cal) {
	      return cal.id;
	    });
	  },
	  subjectsInKlassHash: function subjectsInKlassHash(state, getters, rootState, rootGetters) {
	    var klassCalsWithSubjectIds = {};
	    state.subjects.forEach(function (subject) {
	      subject.calendar_ids.forEach(function (calId) {
	        if (rootGetters.allKlassCalendarsInHash[calId]) {
	          if (!klassCalsWithSubjectIds[calId]) {
	            klassCalsWithSubjectIds[calId] = [subject.id];
	          } else {
	            klassCalsWithSubjectIds[calId].push(subject.id);
	          }
	        }
	      });
	    });
	    return klassCalsWithSubjectIds;
	  },
	  subjectsInCalendarHash: function subjectsInCalendarHash(state, getters, rootState, rootGetters) {
	    var calsWithSubjectIds = {};
	    state.subjects.forEach(function (subject) {
	      var calId = subject.calendar_id;
	      if (!calsWithSubjectIds[calId]) {
	        calsWithSubjectIds[calId] = [subject.id];
	      } else {
	        calsWithSubjectIds[calId].push(subject.id);
	      }
	    });
	    return calsWithSubjectIds;
	  },
	  subjectsInUserHash: function subjectsInUserHash(state, getters, rootState, rootGetters) {
	    var calIdsWithSubjectIds = {};
	    state.subjects.forEach(function (subject) {
	      if (subject.master_type === 'teaching') {
	        subject.calendar_ids.forEach(function (calid) {
	          if (calid && rootGetters.allUsersInCalIdHash[calid]) {
	            if (!calIdsWithSubjectIds[calid]) {
	              calIdsWithSubjectIds[calid] = [subject.id];
	            } else if (calIdsWithSubjectIds[calid].indexOf(subject.id) < 0) {
	              calIdsWithSubjectIds[calid].push(subject.id);
	            }
	          }
	        });
	      }
	    });
	    return calIdsWithSubjectIds;
	  },
	  actualSubjectsForUserInHash: function actualSubjectsForUserInHash(state) {
	    var subjects = state.actualSubjectsForUser.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	    return subjects;
	  },
	  subjectsInHash: function subjectsInHash(state, getters) {
	    return state.subjects.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  usersAssignedHoursHash: function usersAssignedHoursHash(state) {
	    if (!state.usersAssignedHours.length || state.usersAssignedHours.length < 1) {
	      return {};
	    }
	    return _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(state.usersAssignedHours.map(function (item) {
	      return (0, _defineProperty3.default)({}, item.user_id, item);
	    }))));
	  },
	  uniqueSubjects: function uniqueSubjects(state, getters, rootState, rootGetters) {
	    if (state.isLoading || rootGetters.klassCalendars.length === 0) {
	      return [];
	    }
	
	    var klassCalendars = rootGetters.klassCalendars;
	    var klassCalendarsInHash = rootGetters.allKlassCalendarsInHash;
	    var allCalendarsInHash = rootGetters.allCalendarsInHash;
	
	    var subjectsMap = {};
	
	    getters.subjectsFilteredOnType.forEach(function (subject) {
	      var calendar = allCalendarsInHash[subject.calendar_id];
	
	      if (!calendar || calendar.type !== state.subjectTypeFilter) return;
	
	      if (!subjectsMap[subject.name]) {
	        subjectsMap[subject.name] = (0, _extends3.default)({}, subject, {
	          klasses: klassCalendars.reduce(function (obj, klass) {
	            obj[klass.id] = { calendar_id: klass.id };
	            return obj;
	          }, {})
	        });
	      }
	
	      subject.calendar_ids.forEach(function (calId) {
	        if (klassCalendarsInHash[calId]) {
	          subjectsMap[subject.name].klasses[calId] = subject;
	        }
	      });
	    });
	
	    return (0, _values2.default)(subjectsMap).sort(function (a, b) {
	      return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
	    });
	  },
	  tasksInUserHash: function tasksInUserHash(state) {
	    var calIdsWithTasksIds = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendar_ids) {
	        task.user_calendar_ids.forEach(function (calid) {
	          if (calid) {
	            if (!calIdsWithTasksIds[calid]) {
	              calIdsWithTasksIds[calid] = [task.id];
	            } else {
	              calIdsWithTasksIds[calid].push(task.id);
	            }
	          }
	        });
	      }
	    });
	    return calIdsWithTasksIds;
	  },
	  tasksInHash: function tasksInHash(state, getters) {
	    state.tasks.forEach(function (task) {
	      var teaching = task.subject_type === 'person_resource' || task.subject_type === 'person_resource_visible' || task.subject_type === 'subject' ? task.hours : null;
	      var tasks = task.subject_type === 'additional_tasks' ? task.hours : null;
	      var prep = task.subject_type === 'preparation' ? task.hours : null;
	      var pool = task.subject_type === 'pool' ? task.hours : null;
	      _vue2.default.set(task, 'timeTeaching', teaching);
	      _vue2.default.set(task, 'timeTasks', tasks);
	      _vue2.default.set(task, 'timePrep', prep);
	      _vue2.default.set(task, 'timePool', pool);
	    });
	    var tasks = state.tasks.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	    return tasks;
	  },
	  userTasksSortedInTypes: function userTasksSortedInTypes() {
	    var selectSorting = {
	      teaching: 1,
	      substitute_hours: 2,
	      club: 3,
	      other: 4,
	      preparation: 5,
	      pool: 6,
	      absence: 10,
	      with_kids: 1,
	      without_kids: 2
	    };
	    var types = [];
	    state.userTasks.forEach(function (task) {
	      if (!task.actual && task.hours * 1 === 0) {
	        var arrOfSubjects = state.userTasks.filter(function (allTask) {
	          return allTask.id === task.id;
	        });
	
	        if (arrOfSubjects.length > 1) {
	          return;
	        }
	      }
	      var activeType = task.task_category_name ? task.task_category_name : task.master_type;
	      if (task.substitute) {
	        activeType = 'substitute_hours';
	      }
	      var idx = types.findIndex(function (type) {
	        return type.title === activeType;
	      });
	      if (idx > -1) {
	        types[idx].tasks.push(task);
	      } else {
	        var order = task.hasOwnProperty('task_category_rank') && task.task_category_rank !== null ? task.task_category_rank : selectSorting[activeType] !== undefined ? selectSorting[activeType] : 100;
	        var obj = {
	          title: activeType,
	          order: order,
	          tasks: [task]
	        };
	        types.push(obj);
	      }
	    });
	    return types.sort(function (a, b) {
	      return a.order - b.order;
	    });
	  },
	  subjectsRequestsInHash: function subjectsRequestsInHash(state, getters) {
	    var obj = {};
	    state.subjectsRequests.forEach(function (req) {
	      if (obj[req.subject_id]) {
	        obj[req.subject_id].push(req.calendar_id);
	      } else {
	        obj[req.subject_id] = [req.calendar_id];
	      }
	    });
	    return obj;
	  },
	  teachingHoursPerUser: function teachingHoursPerUser(state, getters, rootState, rootGetters) {
	    var getSubjectHours = function getSubjectHours(subject, calId) {
	      var userId = rootGetters.allUsersInCalIdHash[calId] ? rootGetters.allUsersInCalIdHash[calId]['id'] : null;
	      if (!userId) {
	        subject.hours * 1;
	      }
	      var idx = subject.teachers[0] ? subject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === userId;
	      }) : -1;
	      if (idx > -1) {
	        return subject.teachers[idx].hours * 1;
	      } else {
	        return subject.hours * 1;
	      }
	    };
	    var userTeachingHours = {};
	    state.subjects.forEach(function (subject) {
	      if (subject.master_type === 'teaching') {
	        subject.cals.forEach(function (calendar) {
	          if (calendar.calendar_type === 'user') {
	            var calId = calendar.id;
	            if (!userTeachingHours[calId]) {
	              userTeachingHours[calId] = 0;
	            }
	            var hours = getSubjectHours(subject, calId);
	            userTeachingHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    return userTeachingHours;
	  },
	  taskHoursPerUser: function taskHoursPerUser(state, getters, rootState, rootGetters) {
	    var getSubjectHours = function getSubjectHours(subject, calId) {
	      var userId = rootGetters.allUsersInCalIdHash[calId] ? rootGetters.allUsersInCalIdHash[calId]['id'] : null;
	      if (!userId) {
	        subject.hours * 1;
	      }
	      var idx = subject.teachers[0] ? subject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === userId;
	      }) : -1;
	      if (idx > -1) {
	        return subject.teachers[idx].hours * 1;
	      } else {
	        return subject.hours * 1;
	      }
	    };
	    var userHours = {};
	    state.tasks.forEach(function (subject) {
	      if (subject.master_type === 'teaching') {
	        subject.cals.forEach(function (calendar) {
	          if (calendar.calendar_type === 'user') {
	            var calId = calendar.id;
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = getSubjectHours(subject, calId);
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    return userHours;
	  },
	  tasksHoursInUserHash: function tasksHoursInUserHash(state) {
	    var subjectType = 'additional_tasks';
	    var userHours = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendar_ids && task.subject_type === subjectType) {
	        task.user_calendar_ids.forEach(function (calId) {
	          if (calId) {
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = task.hours;
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    return userHours;
	  },
	  preparationHoursInUserHash: function preparationHoursInUserHash(state) {
	    var subjectType = 'preparation';
	    var userHours = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendar_ids && task.subject_type === subjectType) {
	        task.user_calendar_ids.forEach(function (calId) {
	          if (calId) {
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = task.hours;
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    return userHours;
	  },
	  localPoolHoursInUserHash: function localPoolHoursInUserHash(state) {
	    var subjectType = 'pool';
	    var userHours = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendar_ids && task.subject_type === subjectType) {
	        task.user_calendar_ids.forEach(function (calId) {
	          if (calId) {
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = task.hours;
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    return userHours;
	  },
	  clubHoursInUserHash: function clubHoursInUserHash(state) {
	    var subjectType = 'club';
	    var userHours = {};
	    state.tasks.forEach(function (task) {
	      if (task.user_calendars && task.subject_type === subjectType) {
	        task.user_calendars.forEach(function (calId) {
	          if (calId) {
	            if (!userHours[calId]) {
	              userHours[calId] = 0;
	            }
	            var hours = task.hours;
	            userHours[calId] += hours || 0;
	          }
	        });
	      }
	    });
	    return userHours;
	  }
	};
	
	var mutations = {
	  SET_SUBJECT_TYPE_FILTER: function SET_SUBJECT_TYPE_FILTER(state, subjectType) {
	    state.selectedSubjectTypeFilters = subjectType;
	  },
	  TOGGLE_SUBJECT_TYPE_FILTER: function TOGGLE_SUBJECT_TYPE_FILTER(state, filter) {
	    var index = state.selectedSubjectTypeFilters.indexOf(filter);
	    if (index === -1) {
	      state.selectedSubjectTypeFilters.push(filter);
	    } else {
	      state.selectedSubjectTypeFilters.splice(index, 1);
	    }
	  },
	  CLEAR_SUBJECT_TYPE_FILTERS: function CLEAR_SUBJECT_TYPE_FILTERS(state) {
	    state.selectedSubjectTypeFilters = [];
	  },
	  addSubjectRequest: function addSubjectRequest(state, payload) {
	    state.subjectsRequests.push(payload);
	  },
	  removeSubjectRequest: function removeSubjectRequest(state, payload) {
	    var idx = state.subjectsRequests.findIndex(function (request) {
	      return request.id === payload.id;
	    });
	    if (idx > -1) {
	      state.subjectsRequests.splice(idx, 1);
	    }
	  },
	  setUserTableAcc: function setUserTableAcc(state, accOpen) {
	    _vue2.default.set(state.userTableAcc, accOpen.title, accOpen.boolean);
	  },
	  setTheDeletedItemId: function setTheDeletedItemId(state, itemId) {
	    state.theDeletedItemId = itemId;
	  },
	  setItemToDelete: function setItemToDelete(state, item) {
	    state.itemToDelete = item;
	  },
	  setSubjects: function setSubjects(state, data) {
	    state.subjects = data;
	  },
	  createSubject: function createSubject(state, newSubject) {
	    _vue2.default.set(state.subjects, state.subjects.length, newSubject);
	  },
	  updateSubject: function updateSubject(state, updatedSubject) {
	    var idx = state.subjects.findIndex(function (subject) {
	      return subject.id === updatedSubject.id;
	    });
	    _vue2.default.set(state.subjects, idx, updatedSubject);
	  },
	  deleteSubject: function deleteSubject(state, deletedSubject) {
	    var idx = state.subjects.findIndex(function (subject) {
	      return subject.id === deletedSubject.id;
	    });
	    state.subjects.splice(idx, 1);
	  },
	  setUsersAssignedHours: function setUsersAssignedHours(state, data) {
	    state.usersAssignedHours = data;
	  },
	  createTask: function createTask(state, newTask) {
	    _vue2.default.set(state.tasks, state.tasks.length, newTask);
	  },
	  setTasks: function setTasks(state, data) {
	    state.tasks = data;
	  },
	  updateTask: function updateTask(state, updatedTask) {
	    var idx = state.tasks.findIndex(function (task) {
	      return task.id === updatedTask.oldId;
	    });
	    _vue2.default.set(state.tasks, idx, updatedTask);
	  },
	  deleteTask: function deleteTask(state, deletedTask) {
	    var idx = state.tasks.findIndex(function (task) {
	      return task.id === deletedTask.id;
	    });
	    state.tasks.splice(idx, 1);
	  },
	  setConfirmDeletion: function setConfirmDeletion(state, boolean) {
	    state.isConfirmDeletion = boolean;
	  },
	  updateTeacherHoursOnSubject: function updateTeacherHoursOnSubject(state, obj) {
	    var subjectIdx = state.subjects.findIndex(function (subject) {
	      return subject.id === obj.subject_id;
	    });
	
	    if (subjectIdx === -1) {
	      return;
	    }
	
	    var subject = state.subjects[subjectIdx];
	
	    if (!subject.teachers) {
	      subject.teachers = [];
	    }
	
	    var teacherIdx = -1;
	    for (var i = 0; i < subject.teachers.length; i++) {
	      if (subject.teachers[i] && subject.teachers[i].user_id === obj.user_id) {
	        teacherIdx = i;
	        break;
	      }
	    }
	
	    if (teacherIdx > -1) {
	      subject.teachers[teacherIdx] = obj;
	    } else {
	      if (subject.teachers.length === 1 && subject.teachers[0] === null) {
	        subject.teachers[0] = obj;
	      } else {
	        subject.teachers.push(obj);
	      }
	    }
	    _vue2.default.set(state.subjects, subjectIdx, subject);
	  },
	  setActualSubjectsForUser: function setActualSubjectsForUser(state, arr) {
	    state.actualSubjectsForUser = arr;
	  },
	  setUserTasks: function setUserTasks(state, arr) {
	    var filterOutReservations = arr.filter(function (item) {
	      return item.subject_type !== 'reservation';
	    });
	    state.userTasks = filterOutReservations;
	  },
	  setUsersActualHours: function setUsersActualHours(state, arr) {
	    state.userActualHours = arr[0];
	  }
	};
	
	var actions = {
	  readReductions: function readReductions(context) {
	    var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    context.state.isLoadingReductions = true;
	    var schoolId = obj.schoolId || context.getters.schoolId;
	    var schoolYearId = obj.schoolYearId || context.getters.schoolYearId;
	    _docendo2.default.listSubjectReductions(schoolId, schoolYearId, function (success) {
	      context.state.reductions = success;
	      context.state.isLoadingReductions = false;
	    }, function (failure) {
	      console.log({ failure: failure });
	    });
	  },
	  readUserTasks: function readUserTasks(context, obj) {
	    context.state.isLoadingTasksForUser = true;
	    _docendo2.default.userTasks(obj.userId, obj.fromDate, obj.toDate, function (data) {
	      if (data && data.status && data.status === 'error') {
	        _eventbus2.default.toast = { text: data.message, 'success': false };
	        return;
	      }
	      context.state.isLoadingTasksForUser = false;
	      context.commit('setUserTasks', data);
	    }, function (failure) {
	      console.log('failure', failure);
	    });
	  },
	
	  readTasksForUser: function readTasksForUser(context, objWithSchoolYearIdAndUserId) {
	    context.state.isLoadingTasksForUser = true;
	    _docendo2.default.readTasks(window.SCHOOL.id, objWithSchoolYearIdAndUserId.activeSchoolYearId, objWithSchoolYearIdAndUserId.userId, function (data) {
	      context.state.isLoadingTasksForUser = false;
	      context.commit('setTasks', data);
	    }, function (failure) {
	      console.log('failed read tasks');
	    });
	  },
	  readSubjectsForUser: function readSubjectsForUser(context, objWithSchoolYearIdAndUserId) {
	    context.state.isLoading = true;
	    _docendo2.default.readSubjects(window.SCHOOL.id, objWithSchoolYearIdAndUserId.activeSchoolYearId, objWithSchoolYearIdAndUserId.userId, function (data) {
	      state.isLoading = false;
	      context.commit('setSubjects', data);
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  readActualSubjectsForUser: function readActualSubjectsForUser(context, objWithSchoolYearIdAndUserId) {
	    context.state.isLoadingActualUserHours = true;
	    _docendo2.default.subjectActuals(window.SCHOOL.id, objWithSchoolYearIdAndUserId.activeSchoolYearId, objWithSchoolYearIdAndUserId.userId, function (data) {
	      context.state.isLoadingActualUserHours = false;
	      context.commit('setActualSubjectsForUser', data);
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  readUsersAssignedHoursForUser: function readUsersAssignedHoursForUser(context, schoolObj) {
	    _docendo2.default.schoolUserYearsList(schoolObj.schoolId, schoolObj.schoolYearId, schoolObj.userId, function (data) {
	      context.commit('setUsersAssignedHours', data);
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  readUsersActualHoursForUser: function readUsersActualHoursForUser(context, schoolObj) {
	    _docendo2.default.schoolActualHours(schoolObj.schoolId, schoolObj.fromDateTime, schoolObj.toDateTime, [schoolObj.userId], function (data) {
	      context.commit('setUsersActualHours', data);
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  readSubjects: function readSubjects(context, activeSchoolYearId) {
	    context.state.isLoading = true;
	    context.state.isLoadingSubjects = true;
	    var schoolId = context.getters.schoolId;
	    _docendo2.default.readSubjects(schoolId, activeSchoolYearId, null, function (data) {
	      context.state.isLoading = false;
	      context.state.isLoadingSubjects = false;
	      context.commit('setSubjects', data);
	    }, function (failure) {
	      console.log('failed read subjects');
	    });
	  },
	  createSubject: function createSubject(context, subject) {
	    var schoolId = subject.schoolId ? subject.schoolId : window.SCHOOL.id;
	    var preparation = subject.preparation ? subject.preparation : null;
	    _docendo2.default.createSubject(subject.name, subject.color, subject.calendarId, subject.defaultDuration, preparation, subject.hours, subject.subjectType, schoolId, subject.schoolYearId, subject.calendarIds, subject.subjectCode, false, function (data) {
	      context.commit('createSubject', data);
	
	      data['calCurrentdate'] = subject.calCurrentdate;
	      window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: data }));
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  updateSubject: function updateSubject(context, updatedSubject) {
	    var away = updatedSubject.away ? updatedSubject.away : false;
	    var preparation = updatedSubject.preparation ? updatedSubject.preparation : null;
	    _docendo2.default.updateSubject(updatedSubject.id, updatedSubject.name, updatedSubject.color, updatedSubject.calendarId, updatedSubject.calendarIds, updatedSubject.defaultDuration, preparation, updatedSubject.hours, updatedSubject.subjectType, updatedSubject.schoolId, updatedSubject.schoolYearId, updatedSubject.subjectCode, away, false, function (data) {
	      context.commit('updateSubject', data);
	      window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: data }));
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  deleteSubject: function deleteSubject(context, _deleteSubject) {
	    _docendo2.default.deleteSubject(_deleteSubject.id, _deleteSubject.school_id, _deleteSubject.school_year_id, function (data) {
	      context.commit('deleteSubject', data);
	      window.dispatchEvent(new window.CustomEvent('vueCRUDSubject', { detail: data }));
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  readUsersAssignedHours: function readUsersAssignedHours(context, schoolObj) {
	    _docendo2.default.schoolUserYearsList(schoolObj.schoolId, schoolObj.schoolYearId, null, function (data) {
	      context.commit('setUsersAssignedHours', data);
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  readTasks: function readTasks(context, activeSchoolYearId) {
	    var schoolId = context.getters.schoolId;
	    context.state.isLoading = true;
	    context.state.isLoadingTasks = true;
	    _docendo2.default.readTasks(schoolId, activeSchoolYearId, null, function (data) {
	      state.isLoading = false;
	      context.commit('setTasks', data);
	      context.state.isLoadingTasks = false;
	      window.dispatchEvent(new window.CustomEvent('vueDoneLoadingTasks', { detail: data }));
	    }, function (failure) {
	      console.log('failed read tasks');
	    });
	  },
	  createTask: function createTask(context, task) {
	    context.state.isSubmittingTask = true;
	    var preparation = task.preparation * 1 ? task.preparation : null;
	    var schoolId = context.getters.schoolId;
	    _docendo2.default.createTask(schoolId, task.schoolYearId, task.subjectType, task.hours, task.name, task.color, task.defaultDuration, preparation, task.belongsToCalendars, task.userCalendars, task.canSchedule, task.inUserCalendar, function (data) {
	      context.commit('createTask', data);
	      context.state.isSubmittingTask = false;
	    }, function (failure) {
	      context.state.isSubmittingTask = false;
	      console.log('failure');
	    });
	  },
	  updateTask: function updateTask(context, task) {
	    context.state.isSubmittingTask = true;
	    var oldTaskId = task.id;
	    var preparation = task.preparation ? task.preparation * 1 : null;
	    _docendo2.default.updateTask(task.schoolId, task.schoolYearId, task.id, task.name, task.color, task.hours, task.defaultDuration, preparation, task.belongsToCalendars, task.userCalendars, task.inUserCalendar, function (data) {
	      var task = data;
	      task['oldId'] = oldTaskId;
	      context.commit('updateTask', task);
	      context.state.isSubmittingTask = false;
	    }, function (failure) {
	      console.log('failure');
	    });
	  },
	  deleteTask: function deleteTask(context, task) {
	    _docendo2.default.deleteTask(task.school_id, task.school_year_id, task.id, function (data) {
	      context.commit('deleteTask', data);
	    }, function (failure) {
	      console.log('failure updated Topics');
	    });
	  },
	  readSubjectRequests: function readSubjectRequests(context, activeSchoolYearId) {
	    var schoolId = context.getters.schoolId;
	    context.state.isLoadingSubjectsRequests = true;
	    _docendo2.default.listSubjectRequests(schoolId, activeSchoolYearId, function (data) {
	      if (data.status !== 'error') {
	        context.state.subjectsRequests = data;
	      }
	      context.state.isLoadingSubjectsRequests = false;
	    }, function (failure) {
	      console.log('failed read tasks');
	    });
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(38);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(37);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _momentRange = __webpack_require__(35);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	
	var state = {
	  allUsers: [],
	  allUsersAndEvents: null,
	  allEvents: [],
	  allEventsInAHash: {},
	  allEventsWithMultipleTeachersOn: {},
	  allCalsWithEventIdsInHash: {},
	  allAbsenceEventInEventSerialIdsHash: {},
	  date: moment().utc(),
	  activeEvent: null,
	  activeUser: null,
	  schedulerActiveEvent: { 'left': 0, 'right': 0, color: '' },
	  absenceReasons: [],
	  longAbsentList: [],
	  isSortSubActive: false,
	  sortSubs: 0,
	  usersAndSubstituteHours: {},
	  dataIsLoading: false,
	  sortingHierarchy: {
	    othersOnLesson: 0,
	    isInSameClassAtTheSameTime: 3,
	    availableHour: 6,
	    presence: 9,
	    multipleLessonsInSameClasses: 12,
	    notOccupiedWithLessonsOnDay: 15,
	    notOccupiedWithoutLessonsOnDay: 18,
	    occupied: 21,
	    absence: 24
	  },
	  activeAbsenceReason: null,
	  isActiveAbsenceReasonIsReadyToDelete: false,
	  activeAbsentUser: null,
	  activeAbsentUserEvents: [],
	  activeAbsentUserOriginalEvents: []
	};
	
	var getters = {
	  allUsersSortedOnName: function allUsersSortedOnName(state) {
	    var removeNullFromUsers = state.allUsers.filter(function (user) {
	      return user.name !== null && user.name !== '';
	    });
	    return _vue2.default.prototype.$helpers.sortArrOnName(removeNullFromUsers);
	  },
	  allUsersSortedIds: function allUsersSortedIds(state, getters) {
	    return getters.allUsersSortedOnName.map(function (user) {
	      return user.user_calendar_id;
	    });
	  },
	  userSet: function userSet(state, getters) {
	    return getters.allUsersSortedIds.map(function (userId) {
	      return state.allUsersAndEvents[userId];
	    });
	  },
	  absentUsersFromUserSet: function absentUsersFromUserSet(state, getters) {
	    return getters.userSet.filter(function (user) {
	      return user.dayAbsence.length > 0;
	    });
	  },
	  substitutesToday: function substitutesToday(state, getters) {
	    return getters.userSet.filter(function (user) {
	      return user.daySubEvents.length > 0;
	    });
	  },
	  absentUsersGetDate: function absentUsersGetDate(state) {
	    return moment(state.date).format('YYYY_MM_DD');
	  },
	  absentUsersHandledHash: function absentUsersHandledHash(state, getters) {
	    var hash = {};
	
	    getters.absentUsersFromUserSet.forEach(function (user) {
	      var userStatus = 1;
	      var isAnyEventsPending = false;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(user.dayAbsence), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var dayAbsence = _step.value;
	
	          var userEvents = user.dayEvents.map(function (dayEventId) {
	            return state.allEventsInAHash[dayEventId];
	          }).filter(function (dayEvent) {
	            return dayEvent && !dayEvent.v_is_event_from_other_school;
	          });
	
	          if (userEvents.length === 0) {
	            var absence = state.allEventsInAHash[dayAbsence] || {};
	            var subStatus = absence.substitution_status ? JSON.parse(absence.substitution_status) : {};
	            var status = subStatus[user.user_calendar_id] && subStatus[user.user_calendar_id].status !== undefined ? subStatus[user.user_calendar_id].status : 1;
	            if (status === 0) {
	              userStatus = 0;
	              break;
	            }
	          }
	
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(userEvents), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var lesson = _step2.value;
	
	              var _absence = state.allEventsInAHash[dayAbsence] || {};
	              var normalizedStart = moment(_absence.start).millisecond(0);
	              var normalizedEnd = moment(_absence.end).millisecond(0);
	              var absenceRange = moment.range(normalizedStart, normalizedEnd);
	              var lessonRange = moment.range(lesson.start, lesson.end);
	
	              if (absenceRange.overlaps(lessonRange)) {
	                var _subStatus = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	                var _status = _subStatus[user.user_calendar_id] && _subStatus[user.user_calendar_id].status !== undefined ? _subStatus[user.user_calendar_id].status : 0;
	                if (_status === 2) {
	                  isAnyEventsPending = true;
	                }
	
	                var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	                  return calEvent.substitute_for_user_id === user.id;
	                });
	
	                if (!isUserSubstituted && _status === 0) {
	                  userStatus = 0;
	                  break;
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      hash[user.id] = userStatus === 1 && isAnyEventsPending ? 2 : userStatus;
	    });
	
	    return hash;
	  },
	  absentUsersUnhandled: function absentUsersUnhandled(state, getters) {
	    return getters.absentUsersFromUserSet.filter(function (user) {
	      return !getters.absentUsersHandledHash[user.id];
	    });
	  },
	  absentUsersHandled: function absentUsersHandled(state, getters) {
	    return getters.absentUsersFromUserSet.filter(function (user) {
	      return getters.absentUsersHandledHash[user.id];
	    });
	  },
	  notAbsentUsersFromUserSet: function notAbsentUsersFromUserSet(state, getters) {
	    return getters.userSet.filter(function (user) {
	      return user.dayAbsence.length < 1;
	    });
	  },
	  subsAbsenceReasonsSorted: function subsAbsenceReasonsSorted(state, getters) {
	    return state.absenceReasons.sort(function (a, b) {
	      var nameA = a.name.toUpperCase().trim();
	      var nameB = b.name.toUpperCase().trim();
	      if (nameA < nameB) return -1;
	      if (nameA > nameB) return 1;
	      return 0;
	    });
	  },
	
	  longAbsentListInHash: function longAbsentListInHash(state, getters) {
	    return state.longAbsentList.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  usersWithOngoingAbsenceInHash: function usersWithOngoingAbsenceInHash(state, getters) {
	    var users = {};
	    state.longAbsentList.filter(function (absence) {
	      return absence.ongoing;
	    }).forEach(function (absence) {
	      if (!users[absence.calendar_id]) {
	        _vue2.default.set(users, absence.calendar_id, { absenceArr: [absence.id] });
	      } else {
	        users[absence.calendar_id].absenceArr.push(absence.id);
	      }
	    });
	    return users;
	  },
	  activeAbsentUserEventsInHash: function activeAbsentUserEventsInHash(state, getters) {
	    return state.activeAbsentUserEvents.reduce(function (obj, item) {
	      obj[item.event_id] = item;
	      return obj;
	    }, {});
	  },
	  activeAbsentUserOriginalEventsInHash: function activeAbsentUserOriginalEventsInHash(state, getters) {
	    return state.activeAbsentUserOriginalEvents.reduce(function (obj, item) {
	      obj[item.event_id] = item;
	      return obj;
	    }, {});
	  }
	};
	
	var mutations = {
	  setSubDate: function setSubDate(state, date) {
	    state.date = moment(date).format('YYYY-MM-DD');
	  },
	
	  setAllUsers: function setAllUsers(state, data) {
	    console.time('create User Arr');
	    state.allUsers = data;
	    var users = state.allUsers;
	    var allUsers = users.reduce(function (obj, item) {
	      var substituteHours = 0;
	      var subPolsDiff = 0;
	      if (item.current_user_year) {
	        if (item.current_user_year.substitute_pool_hours) {
	          subPolsDiff = item.current_user_year.substitute_pool_hours;
	        }
	        if (state.usersAndSubstituteHours[item.id]) {
	          substituteHours = state.usersAndSubstituteHours[item.id].toFixed(1);
	          subPolsDiff = subPolsDiff - state.usersAndSubstituteHours[item.id];
	        }
	      }
	      _vue2.default.set(item, 'dayEvents', []);
	      _vue2.default.set(item, 'daySubEvents', []);
	      _vue2.default.set(item, 'dayAbsence', []);
	      _vue2.default.set(item, 'dayPresence', []);
	      _vue2.default.set(item, 'dayAllEvents', []);
	      _vue2.default.set(item, 'subPoolsDiff', subPolsDiff);
	      _vue2.default.set(item, 'substituteHours', substituteHours);
	      _vue2.default.set(item, 'dayAvailability', []);
	      _vue2.default.set(item, 'v_two_in_class_events', []);
	      _vue2.default.set(item, 'v_two_events_in_class_events', []);
	      obj[item.user_calendar_id] = item;
	      return obj;
	    }, {});
	    state.allUsersAndEvents = allUsers;
	    console.timeEnd('create User Arr');
	  },
	  addEventOnAllUsersWithEvents: function addEventOnAllUsersWithEvents(state, data) {
	    state.allUsersAndEvents[data.cal_id].dayEvents.push(data.event_id);
	  },
	  addANewEvent: function addANewEvent(state, lesson) {
	    state.allEvents.push(lesson);
	    state.allEventsInAHash[lesson.id] = lesson;
	    lesson.calendar_events.forEach(function (user) {
	      if (state.allUsersAndEvents[user.calendar_id]) {
	        state.allUsersAndEvents[user.calendar_id].dayEvents.push(lesson.id);
	      }
	    });
	  },
	  addAbsenceToUserInAllUsersWithEvents: function addAbsenceToUserInAllUsersWithEvents(state, data) {
	    state.allUsersAndEvents[data.cal_id].dayAbsence.push(data.event_id);
	  },
	  removeAbsenceOnAllUsersWithEvents: function removeAbsenceOnAllUsersWithEvents(state, data) {
	    var idx = state.allUsersAndEvents[data.cal_id].dayAbsence.indexOf(data.event_id);
	    state.allUsersAndEvents[data.cal_id].dayAbsence.splice(idx, 1);
	  },
	  removeEventOnAllUsersWithEvents: function removeEventOnAllUsersWithEvents(state, data) {
	    var idx = state.allUsersAndEvents[data.cal_id].dayEvents.indexOf(data.event_id);
	    state.allUsersAndEvents[data.cal_id].dayEvents.splice(idx, 1);
	  },
	  setAllEvents: function setAllEvents(state, data) {
	    state.allEvents = data;
	    var events = state.allEvents;
	    state.allEventsInAHash = events.reduce(function (obj, item) {
	      obj[item.id] = item;
	      return obj;
	    }, {});
	  },
	  updateEventOnAllEventsInAHash: function updateEventOnAllEventsInAHash(state, event) {
	    _vue2.default.set(state.allEventsInAHash, event.id, event);
	  },
	  updateTeacherNoteOnEvent: function updateTeacherNoteOnEvent(state, eventIdAndTeacherNote) {
	    state.allEventsInAHash[eventIdAndTeacherNote.eventId].teacher_notes = eventIdAndTeacherNote.note;
	  },
	  updateAllEventsWithMultipleTeachersOn: function updateAllEventsWithMultipleTeachersOn(state, data) {
	    _vue2.default.set(state.allEventsWithMultipleTeachersOn, data.userAndEventIds, data.userCalIds);
	  },
	  updateSubStatusOnEvent: function updateSubStatusOnEvent(state, eventIdAndsubstitutionStatus) {
	    state.allEventsInAHash[eventIdAndsubstitutionStatus.eventId].substitution_status = eventIdAndsubstitutionStatus.status;
	  },
	  setActiveUser: function setActiveUser(state, data) {
	    state.activeUser = data;
	  },
	  setActiveEvent: function setActiveEvent(state, data) {
	    state.activeEvent = data;
	  },
	  subsSetAbsenceReasons: function subsSetAbsenceReasons(state, data) {
	    state.absenceReasons = data;
	  },
	  subsAddNewAbsenceReason: function subsAddNewAbsenceReason(state, data) {
	    state.absenceReasons.push(data);
	  },
	  subsSetLongAbsentList: function subsSetLongAbsentList(state, data) {
	    state.longAbsentList = data;
	  },
	  setIsSubScoreActive: function setIsSubScoreActive(state, boolean) {
	    state.isSortSubActive = boolean;
	  },
	  setUsersWithSubPools: function setUsersWithSubPools(state, data) {
	    state.usersAndSubstituteHours = data;
	  },
	  setSortSubsAgain: function setSortSubsAgain() {
	    state.sortSubs++;
	  },
	  setCalsInAllCalsAndEvents: function setCalsInAllCalsAndEvents(state, data) {
	    _vue2.default.set(state.allCalsWithEventIdsInHash, data.calid, { lessons: [data.eventid] });
	  },
	  addEventInAllCalsAndEvents: function addEventInAllCalsAndEvents(state, data) {
	    state.allCalsWithEventIdsInHash[data.calid].lessons.push(data.eventid);
	  },
	  setSortingHierarchy: function setSortingHierarchy(state, obj) {
	    (0, _entries2.default)(obj).forEach(function (_ref) {
	      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	          key = _ref2[0],
	          value = _ref2[1];
	
	      state.sortingHierarchy[key] = value;
	    });
	  },
	  setActiveAbsenceReason: function setActiveAbsenceReason(state, obj) {
	    state.activeAbsenceReason = obj;
	  },
	  updateLongListAbsence: function updateLongListAbsence(state, data) {
	    var idx = state.longAbsentList.findIndex(function (absence) {
	      return absence.id === data.id;
	    });
	    _vue2.default.set(state.longAbsentList, idx, data);
	  },
	  deleteLongListAbsenceItem: function deleteLongListAbsenceItem(state, eventSerial) {
	    var idx = state.longAbsentList.findIndex(function (absence) {
	      return absence.id === eventSerial.eventSerialId;
	    });
	    if (idx > -1) {
	      state.longAbsentList.splice(idx, 1);
	    }
	  },
	  setIsActiveAbsenceReasonIsReadyToDelete: function setIsActiveAbsenceReasonIsReadyToDelete(state, boolean) {
	    state.isActiveAbsenceReasonIsReadyToDelete = boolean;
	  },
	  setActiveAbsentUser: function setActiveAbsentUser(state, user) {
	    state.activeAbsentUser = user;
	  },
	  setActiveAbsentUserEvents: function setActiveAbsentUserEvents(state, events) {
	    state.activeAbsentUserEvents = events;
	  },
	  setActiveAbsentUserOriginalEvents: function setActiveAbsentUserOriginalEvents(state, events) {
	    state.activeAbsentUserOriginalEvents = events;
	  },
	  setAllEventsOnUsers: function setAllEventsOnUsers(state, data) {
	    console.time('vuex::setAllEventsOnUsers');
	    var filterReservations = data.filter(function (event) {
	      return event.event_type !== 'reservation';
	    });
	    var allEvents = filterReservations;
	    this.commit('setAllEvents', filterReservations);
	
	    var usersWithEvents = state.allUsersAndEvents;
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = (0, _getIterator3.default)((0, _keys2.default)(usersWithEvents)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var key = _step3.value;
	
	        _vue2.default.set(usersWithEvents[key], 'dayAllEvents', []);
	        _vue2.default.set(usersWithEvents[key], 'dayEvents', []);
	        _vue2.default.set(usersWithEvents[key], 'daySubEvents', []);
	        _vue2.default.set(usersWithEvents[key], 'dayAbsence', []);
	        _vue2.default.set(usersWithEvents[key], 'dayPresence', []);
	        _vue2.default.set(usersWithEvents[key], 'subScore', [0, 0, 0]);
	        _vue2.default.set(usersWithEvents[key], 'dayAvailability', []);
	        _vue2.default.set(usersWithEvents[key], 'v_two_in_class_events', []);
	        _vue2.default.set(usersWithEvents[key], 'v_two_events_in_class_events', []);
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    state.allCalsWithEventIdsInHash = {};
	    state.allAbsenceEventInEventSerialIdsHash = {};
	
	    var klassEventsMap = {};
	
	    var _loop = function _loop(i) {
	      var event = allEvents[i];
	      var klassEvents = event.calendar_events.filter(function (ce) {
	        return ce.calendar_type === 'klass';
	      });
	
	      klassEvents.forEach(function (klassEvent) {
	        var klassId = klassEvent.calendar_id;
	        var start = event.start;
	        var end = event.end;
	
	        if (!klassEventsMap[klassId]) {
	          klassEventsMap[klassId] = [];
	        }
	
	        var overlapping = klassEventsMap[klassId].find(function (existingEvent) {
	          return existingEvent.start === start && existingEvent.end === end;
	        });
	        klassEventsMap[klassId].push({ start: start, end: end, event: event });
	        if (overlapping) {
	          overlapping.event.calendar_events.forEach(function (calEvent) {
	            var userCalId = calEvent.calendar_id;
	            var user = usersWithEvents[userCalId];
	            if (calEvent.calendar_type === 'user' && user) {
	              usersWithEvents[userCalId].v_two_events_in_class_events.push(overlapping.event.id);
	              usersWithEvents[userCalId].v_two_events_in_class_events.push(event.id);
	            }
	          });
	          event.calendar_events.forEach(function (calEvent) {
	            var userCalId = calEvent.calendar_id;
	            var user = usersWithEvents[userCalId];
	            if (calEvent.calendar_type === 'user' && user) {
	              var _userCalId = calEvent.calendar_id;
	              usersWithEvents[_userCalId].v_two_events_in_class_events.push(overlapping.event.id);
	              usersWithEvents[_userCalId].v_two_events_in_class_events.push(event.id);
	            }
	          });
	        }
	      });
	    };
	
	    for (var i = 0; i < allEvents.length; i++) {
	      _loop(i);
	    }
	
	    for (var i = 0; i < allEvents.length; i++) {
	      var _event = allEvents[i];
	      if (_event.calendar_events) {
	        var userCount = _event.calendar_events.filter(function (ce) {
	          return ce.calendar_type === 'user';
	        }).length;
	        var hasKlass = _event.calendar_events.some(function (ce) {
	          return ce.calendar_type === 'klass';
	        });
	        var hasTwoOrMoreTeachersInClass = userCount > 1 && hasKlass;
	
	        for (var j = 0; j < _event.calendar_events.length; j++) {
	          var calendarEvent = _event.calendar_events[j];
	          var calId = calendarEvent.calendar_id;
	
	          if (hasTwoOrMoreTeachersInClass && usersWithEvents[calId]) {
	            usersWithEvents[calId].v_two_in_class_events.push(_event.id);
	          }
	
	          if (state.allCalsWithEventIdsInHash[calId]) {
	            this.commit('addEventInAllCalsAndEvents', {
	              calid: calId,
	              eventid: _event.id
	            });
	          } else {
	            this.commit('setCalsInAllCalsAndEvents', {
	              calid: calId,
	              eventid: _event.id
	            });
	          }
	
	          if (usersWithEvents[calId]) {
	            state.allUsersAndEvents[calId].dayAllEvents.push(_event.id);
	            if (_event.event_type === 'absence' || _event.away) {
	              state.allUsersAndEvents[calId].dayAbsence.push(_event.id);
	              if (_event.event_serial_id) {
	                _vue2.default.set(state.allAbsenceEventInEventSerialIdsHash, _event.event_serial_id, _event);
	              }
	            } else if (_event.event_type === null || _event.event_type === 'presence') {
	              state.allUsersAndEvents[calId].dayPresence.push(_event.id);
	            } else {
	              if (_event.event_type === 'available') {
	                state.allUsersAndEvents[calId].dayAvailability.push(_event.id);
	              }
	              state.allUsersAndEvents[calId].dayEvents.push(_event.id);
	            }
	
	            if (calendarEvent.substitute_for_user_id) {
	              state.allUsersAndEvents[calId].daySubEvents.push(_event.id);
	            }
	          }
	        }
	      }
	    }
	
	    var usersWithEventsInArry = (0, _keys2.default)(usersWithEvents).map(function (key) {
	      return usersWithEvents[key];
	    });
	    state.usersWithEvents = usersWithEventsInArry;
	    state.dataIsLoading = false;
	    console.timeEnd('vuex::setAllEventsOnUsers');
	  }
	};
	
	var actions = {
	  getAllUsers: function getAllUsers(context, schoolId, userIdsFilter) {
	    _docendo2.default.schoolUsers(window.SCHOOL.id, userIdsFilter, function (data) {
	      context.commit('setAllUsers', data);
	    });
	  },
	  readAllEvents: function readAllEvents(context, storeObj) {
	    var activeSchoolId = window.SCHOOL.id * 1;
	    var events = [];
	    context.state.dataIsLoading = true;
	    _docendo2.default.listEventsForSchools(storeObj.schoolIds, moment(context.state.date).format('YYYY-MM-DD'), function (data) {
	      if (data.status === 'error') {
	        context.dispatch('getAllDayEvents');
	      } else {
	        var parsedData = JSON.parse(data);
	        parsedData.forEach(function (event) {
	          var idx = events.findIndex(function (lesson) {
	            return lesson.id === event.id;
	          });
	          if (idx < 0) {
	            if (!storeObj.isShowEventsFromOtherThanActiveSchool && event.school_id * 1 !== activeSchoolId) {
	              _vue2.default.set(event, 'v_is_event_from_other_school', true);
	            }
	            events.push(event);
	          }
	        });
	        context.commit('setAllEventsOnUsers', events);
	      }
	    }, function (failure) {
	      window.alert('Something went wrong');
	      context.state.dataIsLoading = false;
	      context.commit('setAllEventsOnUsers', events);
	    });
	  },
	  getAllDayEvents: function getAllDayEvents(context) {
	    context.state.dataIsLoading = true;
	    _docendo2.default.listEvents(window.SCHOOL.id, moment(context.state.date).format('YYYY-MM-DD'), function (data) {
	      context.commit('setAllEventsOnUsers', JSON.parse(data));
	    });
	  },
	  getUserSubPools: function getUserSubPools(context) {
	    _docendo2.default.schoolSubstituteHours(window.SCHOOL.id, function (data) {
	      context.commit('setUsersWithSubPools', data);
	    });
	  },
	  subsGetAbsenceReasons: function subsGetAbsenceReasons(context) {
	    _docendo2.default.schoolAbsenceSubjectsList(window.SCHOOL.id, false, function (data) {
	      context.commit('subsSetAbsenceReasons', data);
	    });
	  },
	  subsGetLongAbsenceList: function subsGetLongAbsenceList(context) {
	    _docendo2.default.schoolEventSerialsList(window.SCHOOL.id, context.state.date, function (data) {
	      context.commit('subsSetLongAbsentList', data);
	    });
	  },
	  setActiveSchedulerEvent: function setActiveSchedulerEvent(context, data) {
	    context.state.schedulerActiveEvent = data;
	    if (!context.state.isSortSubActive || !data.userIsAbsent || data.obj.event_type === 'absence') {
	      return;
	    }
	    console.time('subScore');
	    var overlappingEvents = {
	      absence: {},
	      available: {},
	      presence: {},
	      severalOnLesson: {},
	      lessonsInSameClass: {},
	      lessons: {},
	      multipleLessonsInSameClasses: {}
	    };
	    var otherOnlessonHash = {};
	    var overlappingLessonsInClassHash = {};
	
	    if (data.othersOnLesson) {
	      otherOnlessonHash = data.othersOnLesson.reduce(function (obj, item) {
	        obj[item.user_calendar_id] = item;
	        return obj;
	      }, {});
	    }
	    if (data.overlappingEvents) {
	      data.overlappingEvents.forEach(function (event) {
	        switch (event.event_type) {
	          case 'absence':
	            event.calendar_events.forEach(function (cal) {
	              overlappingEvents.absence[cal.calendar_id] = cal.calendar_id;
	            });
	            break;
	          case 'available':
	            event.calendar_events.forEach(function (cal) {
	              overlappingEvents.available[cal.calendar_id] = cal.calendar_id;
	            });
	            break;
	          case 'presence':
	            var overlapping = moment(context.state.schedulerActiveEvent.obj.start).isBetween(event.start, event.end, null, '[]') && moment(context.state.schedulerActiveEvent.obj.end).isBetween(event.start, event.end, null, '[]');
	            event.calendar_events.forEach(function (cal) {
	              if (overlapping) {
	                overlappingEvents.presence[cal.calendar_id] = cal.calendar_id;
	              }
	            });
	            break;
	          case null:
	            var overlap = moment(context.state.schedulerActiveEvent.obj.start).isBetween(event.start, event.end, null, '[]') && moment(context.state.schedulerActiveEvent.obj.end).isBetween(event.start, event.end, null, '[]');
	            event.calendar_events.forEach(function (cal) {
	              if (overlap) {
	                overlappingEvents.presence[cal.calendar_id] = cal.calendar_id;
	              }
	            });
	            break;
	          default:
	            event.calendar_events.forEach(function (cal) {
	              var arrOfCalIdsOnActiveEvent = context.state.schedulerActiveEvent.obj.calendar_events.map(function (cal) {
	                return cal.calendar_id;
	              });
	
	              if (event.id !== context.state.schedulerActiveEvent.obj.id && arrOfCalIdsOnActiveEvent.indexOf(cal.calendar_id) > -1) {
	                event.calendar_events.forEach(function (cal) {
	                  overlappingEvents.lessonsInSameClass[cal.calendar_id] = cal.calendar_id;
	                });
	              }
	
	              if (context.rootGetters.allKlassCalendarsInHash[cal.calendar_id]) {
	                if (!overlappingLessonsInClassHash[cal.calendar_id]) {
	                  overlappingLessonsInClassHash[cal.calendar_id] = [event.id];
	                } else {
	                  overlappingLessonsInClassHash[cal.calendar_id].push(event.id);
	                }
	              }
	              if (context.state.allUsersAndEvents[cal.calendar_id]) {
	                if (context.state.allEventsWithMultipleTeachersOn[cal.calendar_id + '_' + event.id]) {
	                  overlappingEvents.severalOnLesson[cal.calendar_id] = cal.calendar_id;
	                } else {
	                  overlappingEvents.lessons[cal.calendar_id] = cal.calendar_id;
	                }
	              }
	            });
	            break;
	        }
	      });
	    }
	
	    (0, _entries2.default)(overlappingLessonsInClassHash).forEach(function (eventIds, key) {
	      if (eventIds[1].length > 1) {
	        eventIds[1].forEach(function (eventId) {
	          context.state.allEventsInAHash[eventId].calendar_events.forEach(function (cal) {
	            if (context.state.allUsersAndEvents[cal.calendar_id]) {
	              overlappingEvents.multipleLessonsInSameClasses[cal.calendar_id] = eventIds[0];
	            }
	          });
	        });
	      }
	    });
	
	    context.state.allUsers.forEach(function (user) {
	      context.state.allUsersAndEvents[user.user_calendar_id].subScore = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	      var subScoreTags = 0;
	      var subScoreSubPools = 0;
	      if (!data.user) {
	        return;
	      }
	
	      data.user.user_tags.forEach(function (userTag) {
	        user.user_tags.forEach(function (subTag) {
	          if (subTag === userTag) {
	            subScoreTags < 10 ? subScoreTags++ : null;
	          }
	        });
	      });
	
	      if (otherOnlessonHash[user.user_calendar_id]) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson + 1] = subScoreTags;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson + 2] = subScoreSubPools;
	      }
	
	      if (overlappingEvents.lessonsInSameClass[user.user_calendar_id]) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime + 1] = subScoreTags;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime + 2] = subScoreSubPools;
	      }
	
	      if (overlappingEvents.multipleLessonsInSameClasses[user.user_calendar_id]) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 1] = overlappingEvents.multipleLessonsInSameClasses[user.user_calendar_id];
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 2] = subScoreSubPools;
	      }
	
	      if (overlappingEvents.lessons[user.user_calendar_id]) {} else if (overlappingEvents.severalOnLesson[user.user_calendar_id]) {
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses] = 1;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 1] = subScoreTags;
	        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 2] = subScoreSubPools;
	      } else {
	        if (overlappingEvents.available[user.user_calendar_id]) {
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour] = 1;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour + 1] = subScoreTags;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour + 2] = subScoreSubPools;
	        }
	
	        if (overlappingEvents.presence[user.user_calendar_id]) {
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence] = 1;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence + 1] = subScoreTags;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence + 2] = subScoreSubPools;
	        }
	
	        if (context.state.allUsersAndEvents[user.user_calendar_id].dayEvents.length > 0) {
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay] = 1;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay + 1] = subScoreTags;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay + 2] = subScoreSubPools;
	        } else {
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay] = 1;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay + 1] = subScoreTags;
	          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay + 2] = subScoreSubPools;
	        }
	      }
	
	      context.state.allUsersAndEvents[user.user_calendar_id].subScore = context.state.allUsersAndEvents[user.user_calendar_id].subScore.join('');
	    });
	    context.state.sortSubs++;
	    console.timeEnd('subScore');
	  },
	  updateIsSubZenActive: function updateIsSubZenActive(context, boolean) {
	    context.commit('setIsSubScoreActive', boolean);
	    context.dispatch('updateUserSettings', { 'isSubZenActive': boolean });
	  },
	  updateSortingHierarchy: function updateSortingHierarchy(context, obj) {
	    var userSettingsObj = { 'subZenOrder': obj };
	    context.dispatch('updateUserSettings', userSettingsObj);
	    context.commit('setSortingHierarchy', obj);
	  },
	  updateEventsSerial: function updateEventsSerial(context, obj) {
	    _docendo2.default.schoolEventSerialsUpdate(window.SCHOOL.id, obj.id, obj.calendar_id, obj.subject_id, obj.from_date, obj.to_date, obj.from_time, obj.to_time, obj.ongoing, obj.internal_note, function (success) {
	      context.commit('updateLongListAbsence', JSON.parse(success));
	      context.dispatch('getAllDayEvents');
	      _eventbus2.default.toast = { text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_updated'), 'success': true };
	    }, function (failure) {
	      console.log('failed', failure);
	    });
	  },
	  removeSubsFromEvents: function removeSubsFromEvents(context, obj) {
	    var statusData = {};
	    statusData[obj.user_calendar_id] = { 'status': 0 };
	    var userId = obj.userId;
	
	    var eventsObj = {};
	    obj.events.forEach(function (event) {
	      if (!eventsObj[event.school_id]) {
	        eventsObj[event.school_id] = [event];
	      } else {
	        eventsObj[event.school_id].push(event);
	      }
	    });
	
	    (0, _keys2.default)(eventsObj).forEach(function (prop) {
	      var schoolId = Number(prop);
	      var eventIds = eventsObj[prop].map(function (event) {
	        return event.event_id;
	      });
	
	      _docendo2.default.removeSubstitutionOfUser(schoolId, eventIds, userId, statusData, function (success) {
	        var data = success.length > 0 ? JSON.parse(success) : [];
	
	        data.forEach(function (event) {
	          if (moment(event.start).format('YYYY_MM_DD') === moment(context.state.date).format('YYYY_MM_DD')) {
	            var eventBeforeUpdate = context.state.allEventsInAHash[event.id];
	            context.commit('updateEventOnAllEventsInAHash', event);
	            var diffCals = eventBeforeUpdate.calendar_events.filter(function (o) {
	              return !event.calendar_events.some(function (i) {
	                return i.id === o.id;
	              });
	            });
	
	            diffCals.forEach(function (cal) {
	              context.commit('removeEventOnAllUsersWithEvents', {
	                cal_id: cal.calendar_id,
	                event_id: event.id
	              });
	            });
	          }
	        });
	        _eventbus2.default.toast = {
	          text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_removed'),
	          success: true
	        };
	      }, function (failure) {
	        console.log('API call failure:', failure);
	
	        _eventbus2.default.toast = {
	          text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_remove_failed'),
	          success: false
	        };
	      });
	    });
	  },
	  deleteAbsence: function deleteAbsence(context, reasonObj) {
	    if (reasonObj.event_serial_id) {
	      _docendo2.default.schoolEventSerialsDelete(window.SCHOOL.id, reasonObj.event_serial_id, function (success) {
	        context.commit('removeAbsenceOnAllUsersWithEvents', {
	          cal_id: reasonObj.user_calendar_id,
	          event_id: reasonObj.id
	        });
	        context.commit('deleteLongListAbsenceItem', {
	          eventSerialId: reasonObj.event_serial_id
	        });
	        _eventbus2.default.toast = { text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_deleted'), 'success': true };
	      });
	    } else {
	      _docendo2.default.deleteEvent(window.SCHOOL.id, reasonObj.id, function (data) {
	        context.commit('removeAbsenceOnAllUsersWithEvents', {
	          cal_id: JSON.parse(data).calendar_id,
	          event_id: JSON.parse(data).id
	        });
	        _eventbus2.default.toast = { text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_deleted'), 'success': true };
	      });
	    }
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  actions: actions,
	  getters: getters
	};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _defineProperties = __webpack_require__(739);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _getOwnPropertyDescriptors = __webpack_require__(741);
	
	var _getOwnPropertyDescriptors2 = _interopRequireDefault(_getOwnPropertyDescriptors);
	
	var _getOwnPropertyDescriptor = __webpack_require__(140);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(742);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _defineProperty = __webpack_require__(91);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VueTippy = function (t) {
	  "use strict";
	  var e = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator,
	      n = function () {
	    for (var t = ["Edge", "Trident", "Firefox"], n = 0; n < t.length; n += 1) {
	      if (e && navigator.userAgent.indexOf(t[n]) >= 0) return 1;
	    }return 0;
	  }();var r = e && window.Promise ? function (t) {
	    var e = !1;return function () {
	      e || (e = !0, window.Promise.resolve().then(function () {
	        e = !1, t();
	      }));
	    };
	  } : function (t) {
	    var e = !1;return function () {
	      e || (e = !0, setTimeout(function () {
	        e = !1, t();
	      }, n));
	    };
	  };function i(t) {
	    return t && "[object Function]" === {}.toString.call(t);
	  }function o(t, e) {
	    if (1 !== t.nodeType) return [];var n = t.ownerDocument.defaultView.getComputedStyle(t, null);return e ? n[e] : n;
	  }function a(t) {
	    return "HTML" === t.nodeName ? t : t.parentNode || t.host;
	  }function p(t) {
	    if (!t) return document.body;switch (t.nodeName) {case "HTML":case "BODY":
	        return t.ownerDocument.body;case "#document":
	        return t.body;}var e = o(t),
	        n = e.overflow,
	        r = e.overflowX,
	        i = e.overflowY;return (/(auto|scroll|overlay)/.test(n + i + r) ? t : p(a(t))
	    );
	  }function s(t) {
	    return t && t.referenceNode ? t.referenceNode : t;
	  }var c = e && !(!window.MSInputMethodContext || !document.documentMode),
	      l = e && /MSIE 10/.test(navigator.userAgent);function f(t) {
	    return 11 === t ? c : 10 === t ? l : c || l;
	  }function d(t) {
	    if (!t) return document.documentElement;for (var e = f(10) ? document.body : null, n = t.offsetParent || null; n === e && t.nextElementSibling;) {
	      n = (t = t.nextElementSibling).offsetParent;
	    }var r = n && n.nodeName;return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === o(n, "position") ? d(n) : n : t ? t.ownerDocument.documentElement : document.documentElement;
	  }function u(t) {
	    return null !== t.parentNode ? u(t.parentNode) : t;
	  }function m(t, e) {
	    if (!(t && t.nodeType && e && e.nodeType)) return document.documentElement;var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
	        r = n ? t : e,
	        i = n ? e : t,
	        o = document.createRange();o.setStart(r, 0), o.setEnd(i, 0);var a,
	        p,
	        s = o.commonAncestorContainer;if (t !== s && e !== s || r.contains(i)) return "BODY" === (p = (a = s).nodeName) || "HTML" !== p && d(a.firstElementChild) !== a ? d(s) : s;var c = u(t);return c.host ? m(c.host, e) : m(t, u(e).host);
	  }function h(t) {
	    var e = "top" === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft",
	        n = t.nodeName;if ("BODY" === n || "HTML" === n) {
	      var r = t.ownerDocument.documentElement;return (t.ownerDocument.scrollingElement || r)[e];
	    }return t[e];
	  }function b(t, e) {
	    var n = "x" === e ? "Left" : "Top",
	        r = "Left" === n ? "Right" : "Bottom";return parseFloat(t["border" + n + "Width"], 10) + parseFloat(t["border" + r + "Width"], 10);
	  }function v(t, e, n, r) {
	    return Math.max(e["offset" + t], e["scroll" + t], n["client" + t], n["offset" + t], n["scroll" + t], f(10) ? parseInt(n["offset" + t]) + parseInt(r["margin" + ("Height" === t ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === t ? "Bottom" : "Right")]) : 0);
	  }function y(t) {
	    var e = t.body,
	        n = t.documentElement,
	        r = f(10) && getComputedStyle(n);return { height: v("Height", e, n, r), width: v("Width", e, n, r) };
	  }var g = function g(t, e) {
	    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
	  },
	      w = function () {
	    function t(t, e) {
	      for (var n = 0; n < e.length; n++) {
	        var r = e[n];r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), (0, _defineProperty2.default)(t, r.key, r);
	      }
	    }return function (e, n, r) {
	      return n && t(e.prototype, n), r && t(e, r), e;
	    };
	  }(),
	      x = function x(t, e, n) {
	    return e in t ? (0, _defineProperty2.default)(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
	  },
	      k = _assign2.default || function (t) {
	    for (var e = 1; e < arguments.length; e++) {
	      var n = arguments[e];for (var r in n) {
	        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
	      }
	    }return t;
	  };function E(t) {
	    return k({}, t, { right: t.left + t.width, bottom: t.top + t.height });
	  }function O(t) {
	    var e = {};try {
	      if (f(10)) {
	        e = t.getBoundingClientRect();var n = h(t, "top"),
	            r = h(t, "left");e.top += n, e.left += r, e.bottom += n, e.right += r;
	      } else e = t.getBoundingClientRect();
	    } catch (t) {}var i = { left: e.left, top: e.top, width: e.right - e.left, height: e.bottom - e.top },
	        a = "HTML" === t.nodeName ? y(t.ownerDocument) : {},
	        p = a.width || t.clientWidth || i.width,
	        s = a.height || t.clientHeight || i.height,
	        c = t.offsetWidth - p,
	        l = t.offsetHeight - s;if (c || l) {
	      var d = o(t);c -= b(d, "x"), l -= b(d, "y"), i.width -= c, i.height -= l;
	    }return E(i);
	  }function A(t, e) {
	    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
	        r = f(10),
	        i = "HTML" === e.nodeName,
	        a = O(t),
	        s = O(e),
	        c = p(t),
	        l = o(e),
	        d = parseFloat(l.borderTopWidth, 10),
	        u = parseFloat(l.borderLeftWidth, 10);n && i && (s.top = Math.max(s.top, 0), s.left = Math.max(s.left, 0));var m = E({ top: a.top - s.top - d, left: a.left - s.left - u, width: a.width, height: a.height });if (m.marginTop = 0, m.marginLeft = 0, !r && i) {
	      var b = parseFloat(l.marginTop, 10),
	          v = parseFloat(l.marginLeft, 10);m.top -= d - b, m.bottom -= d - b, m.left -= u - v, m.right -= u - v, m.marginTop = b, m.marginLeft = v;
	    }return (r && !n ? e.contains(c) : e === c && "BODY" !== c.nodeName) && (m = function (t, e) {
	      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
	          r = h(e, "top"),
	          i = h(e, "left"),
	          o = n ? -1 : 1;return t.top += r * o, t.bottom += r * o, t.left += i * o, t.right += i * o, t;
	    }(m, e)), m;
	  }function C(t) {
	    if (!t || !t.parentElement || f()) return document.documentElement;for (var e = t.parentElement; e && "none" === o(e, "transform");) {
	      e = e.parentElement;
	    }return e || document.documentElement;
	  }function T(t, e, n, r) {
	    var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
	        c = { top: 0, left: 0 },
	        l = i ? C(t) : m(t, s(e));if ("viewport" === r) c = function (t) {
	      var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
	          n = t.ownerDocument.documentElement,
	          r = A(t, n),
	          i = Math.max(n.clientWidth, window.innerWidth || 0),
	          o = Math.max(n.clientHeight, window.innerHeight || 0),
	          a = e ? 0 : h(n),
	          p = e ? 0 : h(n, "left");return E({ top: a - r.top + r.marginTop, left: p - r.left + r.marginLeft, width: i, height: o });
	    }(l, i);else {
	      var f = void 0;"scrollParent" === r ? "BODY" === (f = p(a(e))).nodeName && (f = t.ownerDocument.documentElement) : f = "window" === r ? t.ownerDocument.documentElement : r;var d = A(f, l, i);if ("HTML" !== f.nodeName || function t(e) {
	        var n = e.nodeName;if ("BODY" === n || "HTML" === n) return !1;if ("fixed" === o(e, "position")) return !0;var r = a(e);return !!r && t(r);
	      }(l)) c = d;else {
	        var u = y(t.ownerDocument),
	            b = u.height,
	            v = u.width;c.top += d.top - d.marginTop, c.bottom = b + d.top, c.left += d.left - d.marginLeft, c.right = v + d.left;
	      }
	    }var g = "number" == typeof (n = n || 0);return c.left += g ? n : n.left || 0, c.top += g ? n : n.top || 0, c.right -= g ? n : n.right || 0, c.bottom -= g ? n : n.bottom || 0, c;
	  }function L(t, e, n, r, i) {
	    var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;if (-1 === t.indexOf("auto")) return t;var a = T(n, r, o, i),
	        p = { top: { width: a.width, height: e.top - a.top }, right: { width: a.right - e.right, height: a.height }, bottom: { width: a.width, height: a.bottom - e.bottom }, left: { width: e.left - a.left, height: a.height } },
	        s = (0, _keys2.default)(p).map(function (t) {
	      return k({ key: t }, p[t], { area: (e = p[t], e.width * e.height) });var e;
	    }).sort(function (t, e) {
	      return e.area - t.area;
	    }),
	        c = s.filter(function (t) {
	      var e = t.width,
	          r = t.height;return e >= n.clientWidth && r >= n.clientHeight;
	    }),
	        l = c.length > 0 ? c[0].key : s[0].key,
	        f = t.split("-")[1];return l + (f ? "-" + f : "");
	  }function S(t, e, n) {
	    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;return A(n, r ? C(e) : m(e, s(n)), r);
	  }function M(t) {
	    var e = t.ownerDocument.defaultView.getComputedStyle(t),
	        n = parseFloat(e.marginTop || 0) + parseFloat(e.marginBottom || 0),
	        r = parseFloat(e.marginLeft || 0) + parseFloat(e.marginRight || 0);return { width: t.offsetWidth + r, height: t.offsetHeight + n };
	  }function D(t) {
	    var e = { left: "right", right: "left", bottom: "top", top: "bottom" };return t.replace(/left|right|bottom|top/g, function (t) {
	      return e[t];
	    });
	  }function I(t, e, n) {
	    n = n.split("-")[0];var r = M(t),
	        i = { width: r.width, height: r.height },
	        o = -1 !== ["right", "left"].indexOf(n),
	        a = o ? "top" : "left",
	        p = o ? "left" : "top",
	        s = o ? "height" : "width",
	        c = o ? "width" : "height";return i[a] = e[a] + e[s] / 2 - r[s] / 2, i[p] = n === p ? e[p] - r[c] : e[D(p)], i;
	  }function N(t, e) {
	    return Array.prototype.find ? t.find(e) : t.filter(e)[0];
	  }function H(t, e, n) {
	    return (void 0 === n ? t : t.slice(0, function (t, e, n) {
	      if (Array.prototype.findIndex) return t.findIndex(function (t) {
	        return t[e] === n;
	      });var r = N(t, function (t) {
	        return t[e] === n;
	      });return t.indexOf(r);
	    }(t, "name", n))).forEach(function (t) {
	      t.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var n = t.function || t.fn;t.enabled && i(n) && (e.offsets.popper = E(e.offsets.popper), e.offsets.reference = E(e.offsets.reference), e = n(e, t));
	    }), e;
	  }function P(t, e) {
	    return t.some(function (t) {
	      var n = t.name;return t.enabled && n === e;
	    });
	  }function _(t) {
	    for (var e = [!1, "ms", "Webkit", "Moz", "O"], n = t.charAt(0).toUpperCase() + t.slice(1), r = 0; r < e.length; r++) {
	      var i = e[r],
	          o = i ? "" + i + n : t;if (void 0 !== document.body.style[o]) return o;
	    }return null;
	  }function Y(t) {
	    var e = t.ownerDocument;return e ? e.defaultView : window;
	  }function F(t, e, n, r) {
	    n.updateBound = r, Y(t).addEventListener("resize", n.updateBound, { passive: !0 });var i = p(t);return function t(e, n, r, i) {
	      var o = "BODY" === e.nodeName,
	          a = o ? e.ownerDocument.defaultView : e;a.addEventListener(n, r, { passive: !0 }), o || t(p(a.parentNode), n, r, i), i.push(a);
	    }(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n;
	  }function j() {
	    var t, e;this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (t = this.reference, e = this.state, Y(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function (t) {
	      t.removeEventListener("scroll", e.updateBound);
	    }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e));
	  }function X(t) {
	    return "" !== t && !isNaN(parseFloat(t)) && isFinite(t);
	  }function z(t, e) {
	    (0, _keys2.default)(e).forEach(function (n) {
	      var r = "";-1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && X(e[n]) && (r = "px"), t.style[n] = e[n] + r;
	    });
	  }var B = e && /Firefox/i.test(navigator.userAgent);function W(t, e, n) {
	    var r = N(t, function (t) {
	      return t.name === e;
	    }),
	        i = !!r && t.some(function (t) {
	      return t.name === n && t.enabled && t.order < r.order;
	    });if (!i) {
	      var o = "`" + e + "`",
	          a = "`" + n + "`";console.warn(a + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!");
	    }return i;
	  }var V = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
	      R = V.slice(3);function U(t) {
	    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
	        n = R.indexOf(t),
	        r = R.slice(n + 1).concat(R.slice(0, n));return e ? r.reverse() : r;
	  }var $ = { FLIP: "flip", CLOCKWISE: "clockwise", COUNTERCLOCKWISE: "counterclockwise" };function q(t, e, n, r) {
	    var i = [0, 0],
	        o = -1 !== ["right", "left"].indexOf(r),
	        a = t.split(/(\+|\-)/).map(function (t) {
	      return t.trim();
	    }),
	        p = a.indexOf(N(a, function (t) {
	      return -1 !== t.search(/,|\s/);
	    }));a[p] && -1 === a[p].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var s = /\s*,\s*|\s+/,
	        c = -1 !== p ? [a.slice(0, p).concat([a[p].split(s)[0]]), [a[p].split(s)[1]].concat(a.slice(p + 1))] : [a];return (c = c.map(function (t, r) {
	      var i = (1 === r ? !o : o) ? "height" : "width",
	          a = !1;return t.reduce(function (t, e) {
	        return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e) ? (t[t.length - 1] = e, a = !0, t) : a ? (t[t.length - 1] += e, a = !1, t) : t.concat(e);
	      }, []).map(function (t) {
	        return function (t, e, n, r) {
	          var i = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
	              o = +i[1],
	              a = i[2];if (!o) return t;if (0 === a.indexOf("%")) {
	            var p = void 0;switch (a) {case "%p":
	                p = n;break;case "%":case "%r":default:
	                p = r;}return E(p)[e] / 100 * o;
	          }if ("vh" === a || "vw" === a) return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;return o;
	        }(t, i, e, n);
	      });
	    })).forEach(function (t, e) {
	      t.forEach(function (n, r) {
	        X(n) && (i[e] += n * ("-" === t[r - 1] ? -1 : 1));
	      });
	    }), i;
	  }var K = { placement: "bottom", positionFixed: !1, eventsEnabled: !0, removeOnDestroy: !1, onCreate: function onCreate() {}, onUpdate: function onUpdate() {}, modifiers: { shift: { order: 100, enabled: !0, fn: function fn(t) {
	          var e = t.placement,
	              n = e.split("-")[0],
	              r = e.split("-")[1];if (r) {
	            var i = t.offsets,
	                o = i.reference,
	                a = i.popper,
	                p = -1 !== ["bottom", "top"].indexOf(n),
	                s = p ? "left" : "top",
	                c = p ? "width" : "height",
	                l = { start: x({}, s, o[s]), end: x({}, s, o[s] + o[c] - a[c]) };t.offsets.popper = k({}, a, l[r]);
	          }return t;
	        } }, offset: { order: 200, enabled: !0, fn: function fn(t, e) {
	          var n = e.offset,
	              r = t.placement,
	              i = t.offsets,
	              o = i.popper,
	              a = i.reference,
	              p = r.split("-")[0],
	              s = void 0;return s = X(+n) ? [+n, 0] : q(n, o, a, p), "left" === p ? (o.top += s[0], o.left -= s[1]) : "right" === p ? (o.top += s[0], o.left += s[1]) : "top" === p ? (o.left += s[0], o.top -= s[1]) : "bottom" === p && (o.left += s[0], o.top += s[1]), t.popper = o, t;
	        }, offset: 0 }, preventOverflow: { order: 300, enabled: !0, fn: function fn(t, e) {
	          var n = e.boundariesElement || d(t.instance.popper);t.instance.reference === n && (n = d(n));var r = _("transform"),
	              i = t.instance.popper.style,
	              o = i.top,
	              a = i.left,
	              p = i[r];i.top = "", i.left = "", i[r] = "";var s = T(t.instance.popper, t.instance.reference, e.padding, n, t.positionFixed);i.top = o, i.left = a, i[r] = p, e.boundaries = s;var c = e.priority,
	              l = t.offsets.popper,
	              f = { primary: function primary(t) {
	              var n = l[t];return l[t] < s[t] && !e.escapeWithReference && (n = Math.max(l[t], s[t])), x({}, t, n);
	            }, secondary: function secondary(t) {
	              var n = "right" === t ? "left" : "top",
	                  r = l[n];return l[t] > s[t] && !e.escapeWithReference && (r = Math.min(l[n], s[t] - ("right" === t ? l.width : l.height))), x({}, n, r);
	            } };return c.forEach(function (t) {
	            var e = -1 !== ["left", "top"].indexOf(t) ? "primary" : "secondary";l = k({}, l, f[e](t));
	          }), t.offsets.popper = l, t;
	        }, priority: ["left", "right", "top", "bottom"], padding: 5, boundariesElement: "scrollParent" }, keepTogether: { order: 400, enabled: !0, fn: function fn(t) {
	          var e = t.offsets,
	              n = e.popper,
	              r = e.reference,
	              i = t.placement.split("-")[0],
	              o = Math.floor,
	              a = -1 !== ["top", "bottom"].indexOf(i),
	              p = a ? "right" : "bottom",
	              s = a ? "left" : "top",
	              c = a ? "width" : "height";return n[p] < o(r[s]) && (t.offsets.popper[s] = o(r[s]) - n[c]), n[s] > o(r[p]) && (t.offsets.popper[s] = o(r[p])), t;
	        } }, arrow: { order: 500, enabled: !0, fn: function fn(t, e) {
	          var n;if (!W(t.instance.modifiers, "arrow", "keepTogether")) return t;var r = e.element;if ("string" == typeof r) {
	            if (!(r = t.instance.popper.querySelector(r))) return t;
	          } else if (!t.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;var i = t.placement.split("-")[0],
	              a = t.offsets,
	              p = a.popper,
	              s = a.reference,
	              c = -1 !== ["left", "right"].indexOf(i),
	              l = c ? "height" : "width",
	              f = c ? "Top" : "Left",
	              d = f.toLowerCase(),
	              u = c ? "left" : "top",
	              m = c ? "bottom" : "right",
	              h = M(r)[l];s[m] - h < p[d] && (t.offsets.popper[d] -= p[d] - (s[m] - h)), s[d] + h > p[m] && (t.offsets.popper[d] += s[d] + h - p[m]), t.offsets.popper = E(t.offsets.popper);var b = s[d] + s[l] / 2 - h / 2,
	              v = o(t.instance.popper),
	              y = parseFloat(v["margin" + f], 10),
	              g = parseFloat(v["border" + f + "Width"], 10),
	              w = b - t.offsets.popper[d] - y - g;return w = Math.max(Math.min(p[l] - h, w), 0), t.arrowElement = r, t.offsets.arrow = (x(n = {}, d, Math.round(w)), x(n, u, ""), n), t;
	        }, element: "[x-arrow]" }, flip: { order: 600, enabled: !0, fn: function fn(t, e) {
	          if (P(t.instance.modifiers, "inner")) return t;if (t.flipped && t.placement === t.originalPlacement) return t;var n = T(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed),
	              r = t.placement.split("-")[0],
	              i = D(r),
	              o = t.placement.split("-")[1] || "",
	              a = [];switch (e.behavior) {case $.FLIP:
	              a = [r, i];break;case $.CLOCKWISE:
	              a = U(r);break;case $.COUNTERCLOCKWISE:
	              a = U(r, !0);break;default:
	              a = e.behavior;}return a.forEach(function (p, s) {
	            if (r !== p || a.length === s + 1) return t;r = t.placement.split("-")[0], i = D(r);var c = t.offsets.popper,
	                l = t.offsets.reference,
	                f = Math.floor,
	                d = "left" === r && f(c.right) > f(l.left) || "right" === r && f(c.left) < f(l.right) || "top" === r && f(c.bottom) > f(l.top) || "bottom" === r && f(c.top) < f(l.bottom),
	                u = f(c.left) < f(n.left),
	                m = f(c.right) > f(n.right),
	                h = f(c.top) < f(n.top),
	                b = f(c.bottom) > f(n.bottom),
	                v = "left" === r && u || "right" === r && m || "top" === r && h || "bottom" === r && b,
	                y = -1 !== ["top", "bottom"].indexOf(r),
	                g = !!e.flipVariations && (y && "start" === o && u || y && "end" === o && m || !y && "start" === o && h || !y && "end" === o && b),
	                w = !!e.flipVariationsByContent && (y && "start" === o && m || y && "end" === o && u || !y && "start" === o && b || !y && "end" === o && h),
	                x = g || w;(d || v || x) && (t.flipped = !0, (d || v) && (r = a[s + 1]), x && (o = function (t) {
	              return "end" === t ? "start" : "start" === t ? "end" : t;
	            }(o)), t.placement = r + (o ? "-" + o : ""), t.offsets.popper = k({}, t.offsets.popper, I(t.instance.popper, t.offsets.reference, t.placement)), t = H(t.instance.modifiers, t, "flip"));
	          }), t;
	        }, behavior: "flip", padding: 5, boundariesElement: "viewport", flipVariations: !1, flipVariationsByContent: !1 }, inner: { order: 700, enabled: !1, fn: function fn(t) {
	          var e = t.placement,
	              n = e.split("-")[0],
	              r = t.offsets,
	              i = r.popper,
	              o = r.reference,
	              a = -1 !== ["left", "right"].indexOf(n),
	              p = -1 === ["top", "left"].indexOf(n);return i[a ? "left" : "top"] = o[n] - (p ? i[a ? "width" : "height"] : 0), t.placement = D(e), t.offsets.popper = E(i), t;
	        } }, hide: { order: 800, enabled: !0, fn: function fn(t) {
	          if (!W(t.instance.modifiers, "hide", "preventOverflow")) return t;var e = t.offsets.reference,
	              n = N(t.instance.modifiers, function (t) {
	            return "preventOverflow" === t.name;
	          }).boundaries;if (e.bottom < n.top || e.left > n.right || e.top > n.bottom || e.right < n.left) {
	            if (!0 === t.hide) return t;t.hide = !0, t.attributes["x-out-of-boundaries"] = "";
	          } else {
	            if (!1 === t.hide) return t;t.hide = !1, t.attributes["x-out-of-boundaries"] = !1;
	          }return t;
	        } }, computeStyle: { order: 850, enabled: !0, fn: function fn(t, e) {
	          var n = e.x,
	              r = e.y,
	              i = t.offsets.popper,
	              o = N(t.instance.modifiers, function (t) {
	            return "applyStyle" === t.name;
	          }).gpuAcceleration;void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var a = void 0 !== o ? o : e.gpuAcceleration,
	              p = d(t.instance.popper),
	              s = O(p),
	              c = { position: i.position },
	              l = function (t, e) {
	            var n = t.offsets,
	                r = n.popper,
	                i = n.reference,
	                o = Math.round,
	                a = Math.floor,
	                p = function p(t) {
	              return t;
	            },
	                s = o(i.width),
	                c = o(r.width),
	                l = -1 !== ["left", "right"].indexOf(t.placement),
	                f = -1 !== t.placement.indexOf("-"),
	                d = e ? l || f || s % 2 == c % 2 ? o : a : p,
	                u = e ? o : p;return { left: d(s % 2 == 1 && c % 2 == 1 && !f && e ? r.left - 1 : r.left), top: u(r.top), bottom: u(r.bottom), right: d(r.right) };
	          }(t, window.devicePixelRatio < 2 || !B),
	              f = "bottom" === n ? "top" : "bottom",
	              u = "right" === r ? "left" : "right",
	              m = _("transform"),
	              h = void 0,
	              b = void 0;if (b = "bottom" === f ? "HTML" === p.nodeName ? -p.clientHeight + l.bottom : -s.height + l.bottom : l.top, h = "right" === u ? "HTML" === p.nodeName ? -p.clientWidth + l.right : -s.width + l.right : l.left, a && m) c[m] = "translate3d(" + h + "px, " + b + "px, 0)", c[f] = 0, c[u] = 0, c.willChange = "transform";else {
	            var v = "bottom" === f ? -1 : 1,
	                y = "right" === u ? -1 : 1;c[f] = b * v, c[u] = h * y, c.willChange = f + ", " + u;
	          }var g = { "x-placement": t.placement };return t.attributes = k({}, g, t.attributes), t.styles = k({}, c, t.styles), t.arrowStyles = k({}, t.offsets.arrow, t.arrowStyles), t;
	        }, gpuAcceleration: !0, x: "bottom", y: "right" }, applyStyle: { order: 900, enabled: !0, fn: function fn(t) {
	          var e, n;return z(t.instance.popper, t.styles), e = t.instance.popper, n = t.attributes, (0, _keys2.default)(n).forEach(function (t) {
	            !1 !== n[t] ? e.setAttribute(t, n[t]) : e.removeAttribute(t);
	          }), t.arrowElement && (0, _keys2.default)(t.arrowStyles).length && z(t.arrowElement, t.arrowStyles), t;
	        }, onLoad: function onLoad(t, e, n, r, i) {
	          var o = S(i, e, t, n.positionFixed),
	              a = L(n.placement, o, e, t, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);return e.setAttribute("x-placement", a), z(e, { position: n.positionFixed ? "fixed" : "absolute" }), n;
	        }, gpuAcceleration: void 0 } } },
	      G = function () {
	    function t(e, n) {
	      var o = this,
	          a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};g(this, t), this.scheduleUpdate = function () {
	        return requestAnimationFrame(o.update);
	      }, this.update = r(this.update.bind(this)), this.options = k({}, t.Defaults, a), this.state = { isDestroyed: !1, isCreated: !1, scrollParents: [] }, this.reference = e && e.jquery ? e[0] : e, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, (0, _keys2.default)(k({}, t.Defaults.modifiers, a.modifiers)).forEach(function (e) {
	        o.options.modifiers[e] = k({}, t.Defaults.modifiers[e] || {}, a.modifiers ? a.modifiers[e] : {});
	      }), this.modifiers = (0, _keys2.default)(this.options.modifiers).map(function (t) {
	        return k({ name: t }, o.options.modifiers[t]);
	      }).sort(function (t, e) {
	        return t.order - e.order;
	      }), this.modifiers.forEach(function (t) {
	        t.enabled && i(t.onLoad) && t.onLoad(o.reference, o.popper, o.options, t, o.state);
	      }), this.update();var p = this.options.eventsEnabled;p && this.enableEventListeners(), this.state.eventsEnabled = p;
	    }return w(t, [{ key: "update", value: function value() {
	        return function () {
	          if (!this.state.isDestroyed) {
	            var t = { instance: this, styles: {}, arrowStyles: {}, attributes: {}, flipped: !1, offsets: {} };t.offsets.reference = S(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = L(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = I(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = H(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t));
	          }
	        }.call(this);
	      } }, { key: "destroy", value: function value() {
	        return function () {
	          return this.state.isDestroyed = !0, P(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[_("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
	        }.call(this);
	      } }, { key: "enableEventListeners", value: function value() {
	        return function () {
	          this.state.eventsEnabled || (this.state = F(this.reference, this.options, this.state, this.scheduleUpdate));
	        }.call(this);
	      } }, { key: "disableEventListeners", value: function value() {
	        return j.call(this);
	      } }]), t;
	  }();G.Utils = ("undefined" != typeof window ? window : global).PopperUtils, G.placements = V, G.Defaults = K;function J() {
	    return (J = _assign2.default || function (t) {
	      for (var e = 1; e < arguments.length; e++) {
	        var n = arguments[e];for (var r in n) {
	          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
	        }
	      }return t;
	    }).apply(this, arguments);
	  }var Z = "undefined" != typeof window && "undefined" != typeof document,
	      Q = Z ? navigator.userAgent : "",
	      tt = /MSIE |Trident\//.test(Q),
	      et = /UCBrowser\//.test(Q),
	      nt = Z && /iPhone|iPad|iPod/.test(navigator.platform) && !window.MSStream,
	      rt = { a11y: !0, allowHTML: !0, animateFill: !0, animation: "shift-away", appendTo: function appendTo() {
	      return document.body;
	    }, aria: "describedby", arrow: !1, arrowType: "sharp", boundary: "scrollParent", content: "", delay: 0, distance: 10, duration: [325, 275], flip: !0, flipBehavior: "flip", flipOnUpdate: !1, followCursor: !1, hideOnClick: !0, ignoreAttributes: !1, inertia: !1, interactive: !1, interactiveBorder: 2, interactiveDebounce: 0, lazy: !0, maxWidth: 350, multiple: !1, offset: 0, onHidden: function onHidden() {}, onHide: function onHide() {}, onMount: function onMount() {}, onShow: function onShow() {}, onShown: function onShown() {}, onTrigger: function onTrigger() {}, placement: "top", popperOptions: {}, role: "tooltip", showOnInit: !1, size: "regular", sticky: !1, target: "", theme: "dark", touch: !0, touchHold: !1, trigger: "mouseenter focus", triggerTarget: null, updateDuration: 0, wait: null, zIndex: 9999 },
	      it = ["arrow", "arrowType", "boundary", "distance", "flip", "flipBehavior", "flipOnUpdate", "offset", "placement", "popperOptions"],
	      ot = Z ? Element.prototype : {},
	      at = ot.matches || ot.matchesSelector || ot.webkitMatchesSelector || ot.mozMatchesSelector || ot.msMatchesSelector;function pt(t) {
	    return [].slice.call(t);
	  }function st(t, e) {
	    return ct(t, function (t) {
	      return at.call(t, e);
	    });
	  }function ct(t, e) {
	    for (; t;) {
	      if (e(t)) return t;t = t.parentElement;
	    }return null;
	  }var lt = { passive: !0 },
	      ft = 4,
	      dt = "x-placement",
	      ut = "x-out-of-boundaries",
	      mt = "tippy-iOS",
	      ht = "tippy-active",
	      bt = "tippy-popper",
	      vt = "tippy-tooltip",
	      yt = "tippy-content",
	      gt = "tippy-backdrop",
	      wt = "tippy-arrow",
	      xt = "tippy-roundarrow",
	      kt = ".".concat(bt),
	      Et = ".".concat(vt),
	      Ot = ".".concat(yt),
	      At = ".".concat(gt),
	      Ct = ".".concat(wt),
	      Tt = ".".concat(xt),
	      Lt = !1;function St() {
	    Lt || (Lt = !0, nt && document.body.classList.add(mt), window.performance && document.addEventListener("mousemove", Dt));
	  }var Mt = 0;function Dt() {
	    var t = performance.now();t - Mt < 20 && (Lt = !1, document.removeEventListener("mousemove", Dt), nt || document.body.classList.remove(mt)), Mt = t;
	  }function It() {
	    var t = document.activeElement;t && t.blur && t._tippy && t.blur();
	  }var Nt = (0, _keys2.default)(rt);function Ht(t, e) {
	    return {}.hasOwnProperty.call(t, e);
	  }function Pt(t, e, n) {
	    if (Array.isArray(t)) {
	      var r = t[e];return null == r ? n : r;
	    }return t;
	  }function _t(t, e) {
	    return 0 === e ? t : function (r) {
	      clearTimeout(n), n = setTimeout(function () {
	        t(r);
	      }, e);
	    };var n;
	  }function Yt(t, e) {
	    return t && t.modifiers && t.modifiers[e];
	  }function Ft(t, e) {
	    return t.indexOf(e) > -1;
	  }function jt(t) {
	    return t instanceof Element;
	  }function Xt(t) {
	    return !(!t || !Ht(t, "isVirtual")) || jt(t);
	  }function zt(t, e) {
	    return "function" == typeof t ? t.apply(null, e) : t;
	  }function Bt(t, e) {
	    t.filter(function (t) {
	      return "flip" === t.name;
	    })[0].enabled = e;
	  }function Wt() {
	    return document.createElement("div");
	  }function Vt(t, e) {
	    t.forEach(function (t) {
	      t && (t.style.transitionDuration = "".concat(e, "ms"));
	    });
	  }function Rt(t, e) {
	    t.forEach(function (t) {
	      t && t.setAttribute("data-state", e);
	    });
	  }function Ut(t, e) {
	    var n = J({}, e, { content: zt(e.content, [t]) }, e.ignoreAttributes ? {} : function (t) {
	      return Nt.reduce(function (e, n) {
	        var r = (t.getAttribute("data-tippy-".concat(n)) || "").trim();if (!r) return e;if ("content" === n) e[n] = r;else try {
	          e[n] = JSON.parse(r);
	        } catch (t) {
	          e[n] = r;
	        }return e;
	      }, {});
	    }(t));return (n.arrow || et) && (n.animateFill = !1), n;
	  }function $t(t, e) {
	    (0, _keys2.default)(t).forEach(function (t) {
	      if (!Ht(e, t)) throw new Error("[tippy]: `".concat(t, "` is not a valid option"));
	    });
	  }function qt(t, e) {
	    t.innerHTML = jt(e) ? e.innerHTML : e;
	  }function Kt(t, e) {
	    if (jt(e.content)) qt(t, ""), t.appendChild(e.content);else if ("function" != typeof e.content) {
	      t[e.allowHTML ? "innerHTML" : "textContent"] = e.content;
	    }
	  }function Gt(t) {
	    return { tooltip: t.querySelector(Et), backdrop: t.querySelector(At), content: t.querySelector(Ot), arrow: t.querySelector(Ct) || t.querySelector(Tt) };
	  }function Jt(t) {
	    t.setAttribute("data-inertia", "");
	  }function Zt(t) {
	    var e = Wt();return "round" === t ? (e.className = xt, qt(e, '<svg viewBox="0 0 18 7" xmlns="http://www.w3.org/2000/svg"><path d="M0 7s2.021-.015 5.253-4.218C6.584 1.051 7.797.007 9 0c1.203-.007 2.416 1.035 3.761 2.782C16.012 7.005 18 7 18 7H0z"/></svg>')) : e.className = wt, e;
	  }function Qt() {
	    var t = Wt();return t.className = gt, t.setAttribute("data-state", "hidden"), t;
	  }function te(t, e) {
	    t.setAttribute("tabindex", "-1"), e.setAttribute("data-interactive", "");
	  }function ee(t, e, n) {
	    var r = et && void 0 !== document.body.style.webkitTransition ? "webkitTransitionEnd" : "transitionend";t[e + "EventListener"](r, n);
	  }function ne(t) {
	    var e = t.getAttribute(dt);return e ? e.split("-")[0] : "";
	  }function re(t, e, n) {
	    n.split(" ").forEach(function (n) {
	      t.classList[e](n + "-theme");
	    });
	  }function ie(t, e) {
	    var n = Wt();n.className = bt, n.id = "tippy-".concat(t), n.style.zIndex = "" + e.zIndex, n.style.position = "absolute", n.style.top = "0", n.style.left = "0", e.role && n.setAttribute("role", e.role);var r = Wt();r.className = vt, r.style.maxWidth = e.maxWidth + ("number" == typeof e.maxWidth ? "px" : ""), r.setAttribute("data-size", e.size), r.setAttribute("data-animation", e.animation), r.setAttribute("data-state", "hidden"), re(r, "add", e.theme);var i = Wt();return i.className = yt, i.setAttribute("data-state", "hidden"), e.interactive && te(n, r), e.arrow && r.appendChild(Zt(e.arrowType)), e.animateFill && (r.appendChild(Qt()), r.setAttribute("data-animatefill", "")), e.inertia && Jt(r), Kt(i, e), r.appendChild(i), n.appendChild(r), n;
	  }function oe(t, e, n) {
	    var r = Gt(t),
	        i = r.tooltip,
	        o = r.content,
	        a = r.backdrop,
	        p = r.arrow;t.style.zIndex = "" + n.zIndex, i.setAttribute("data-size", n.size), i.setAttribute("data-animation", n.animation), i.style.maxWidth = n.maxWidth + ("number" == typeof n.maxWidth ? "px" : ""), n.role ? t.setAttribute("role", n.role) : t.removeAttribute("role"), e.content !== n.content && Kt(o, n), !e.animateFill && n.animateFill ? (i.appendChild(Qt()), i.setAttribute("data-animatefill", "")) : e.animateFill && !n.animateFill && (i.removeChild(a), i.removeAttribute("data-animatefill")), !e.arrow && n.arrow ? i.appendChild(Zt(n.arrowType)) : e.arrow && !n.arrow && i.removeChild(p), e.arrow && n.arrow && e.arrowType !== n.arrowType && i.replaceChild(Zt(n.arrowType), p), !e.interactive && n.interactive ? te(t, i) : e.interactive && !n.interactive && function (t, e) {
	      t.removeAttribute("tabindex"), e.removeAttribute("data-interactive");
	    }(t, i), !e.inertia && n.inertia ? Jt(i) : e.inertia && !n.inertia && function (t) {
	      t.removeAttribute("data-inertia");
	    }(i), e.theme !== n.theme && (re(i, "remove", e.theme), re(i, "add", n.theme));
	  }var ae = 1,
	      pe = [];function se(t, e) {
	    var n,
	        r,
	        i,
	        o,
	        a,
	        p = Ut(t, e);if (!p.multiple && t._tippy) return null;var s,
	        c,
	        l,
	        f,
	        d,
	        u = !1,
	        m = !1,
	        h = !1,
	        b = !1,
	        v = [],
	        y = _t(_, p.interactiveDebounce),
	        g = ae++,
	        w = ie(g, p),
	        x = Gt(w),
	        k = { id: g, reference: t, popper: w, popperChildren: x, popperInstance: null, props: p, state: { isEnabled: !0, isVisible: !1, isDestroyed: !1, isMounted: !1, isShown: !1 }, clearDelayTimeouts: $, set: q, setContent: function setContent(t) {
	        q({ content: t });
	      }, show: K, hide: Z, enable: function enable() {
	        k.state.isEnabled = !0;
	      }, disable: function disable() {
	        k.state.isEnabled = !1;
	      }, destroy: function destroy(e) {
	        if (k.state.isDestroyed) return;m = !0, k.state.isMounted && Z(0);N(), delete t._tippy;var n = k.props.target;n && e && jt(t) && pt(t.querySelectorAll(n)).forEach(function (t) {
	          t._tippy && t._tippy.destroy();
	        });k.popperInstance && k.popperInstance.destroy();m = !1, k.state.isDestroyed = !0;
	      } };return t._tippy = k, w._tippy = k, I(), p.lazy || W(), p.showOnInit && V(), !p.a11y || p.target || !jt(d = A()) || at.call(d, "a[href],area[href],button,details,input,textarea,select,iframe,[tabindex]") && !d.hasAttribute("disabled") || A().setAttribute("tabindex", "0"), w.addEventListener("mouseenter", function (t) {
	      k.props.interactive && k.state.isVisible && "mouseenter" === n && V(t, !0);
	    }), w.addEventListener("mouseleave", function () {
	      k.props.interactive && "mouseenter" === n && document.addEventListener("mousemove", y);
	    }), k;function E() {
	      document.removeEventListener("mousemove", H);
	    }function O() {
	      document.body.removeEventListener("mouseleave", R), document.removeEventListener("mousemove", y), pe = pe.filter(function (t) {
	        return t !== y;
	      });
	    }function A() {
	      return k.props.triggerTarget || t;
	    }function C() {
	      document.addEventListener("click", U, !0);
	    }function T() {
	      document.removeEventListener("click", U, !0);
	    }function L() {
	      return [k.popperChildren.tooltip, k.popperChildren.backdrop, k.popperChildren.content];
	    }function S() {
	      var t = k.props.followCursor;return t && "focus" !== n || Lt && "initial" === t;
	    }function M(t, e) {
	      var n = k.popperChildren.tooltip;function r(t) {
	        t.target === n && (ee(n, "remove", r), e());
	      }if (0 === t) return e();ee(n, "remove", l), ee(n, "add", r), l = r;
	    }function D(t, e) {
	      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];A().addEventListener(t, e, n), v.push({ eventType: t, handler: e, options: n });
	    }function I() {
	      k.props.touchHold && !k.props.target && (D("touchstart", P, lt), D("touchend", Y, lt)), k.props.trigger.trim().split(" ").forEach(function (t) {
	        if ("manual" !== t) if (k.props.target) switch (t) {case "mouseenter":
	            D("mouseover", j), D("mouseout", X);break;case "focus":
	            D("focusin", j), D("focusout", X);break;case "click":
	            D(t, j);} else switch (D(t, P), t) {case "mouseenter":
	            D("mouseleave", Y);break;case "focus":
	            D(tt ? "focusout" : "blur", F);}
	      });
	    }function N() {
	      v.forEach(function (t) {
	        var e = t.eventType,
	            n = t.handler,
	            r = t.options;A().removeEventListener(e, n, r);
	      }), v = [];
	    }function H(e) {
	      var n = r = e,
	          i = n.clientX,
	          o = n.clientY;if (f) {
	        var a = ct(e.target, function (e) {
	          return e === t;
	        }),
	            p = t.getBoundingClientRect(),
	            s = k.props.followCursor,
	            c = "horizontal" === s,
	            l = "vertical" === s,
	            d = Ft(["top", "bottom"], ne(w)),
	            u = w.getAttribute(dt),
	            m = !!u && !!u.split("-")[1],
	            h = d ? w.offsetWidth : w.offsetHeight,
	            b = h / 2,
	            v = d ? 0 : m ? h : b,
	            y = d ? m ? h : b : 0;!a && k.props.interactive || (k.popperInstance.reference = J({}, k.popperInstance.reference, { referenceNode: t, clientWidth: 0, clientHeight: 0, getBoundingClientRect: function getBoundingClientRect() {
	            return { width: d ? h : 0, height: d ? 0 : h, top: (c ? p.top : o) - v, bottom: (c ? p.bottom : o) + v, left: (l ? p.left : i) - y, right: (l ? p.right : i) + y };
	          } }), k.popperInstance.update()), "initial" === s && k.state.isVisible && E();
	      }
	    }function P(t) {
	      k.state.isEnabled && !z(t) && (k.state.isVisible || (n = t.type, t instanceof MouseEvent && (r = t, pe.forEach(function (e) {
	        return e(t);
	      }))), "click" === t.type && !1 !== k.props.hideOnClick && k.state.isVisible ? R() : V(t));
	    }function _(e) {
	      var n = st(e.target, kt) === w,
	          r = ct(e.target, function (e) {
	        return e === t;
	      });n || r || function (t, e, n, r) {
	        if (!t) return !0;var i = n.clientX,
	            o = n.clientY,
	            a = r.interactiveBorder,
	            p = r.distance,
	            s = e.top - o > ("top" === t ? a + p : a),
	            c = o - e.bottom > ("bottom" === t ? a + p : a),
	            l = e.left - i > ("left" === t ? a + p : a),
	            f = i - e.right > ("right" === t ? a + p : a);return s || c || l || f;
	      }(ne(w), w.getBoundingClientRect(), e, k.props) && (O(), R());
	    }function Y(t) {
	      if (!z(t)) return k.props.interactive ? (document.body.addEventListener("mouseleave", R), document.addEventListener("mousemove", y), void pe.push(y)) : void R();
	    }function F(t) {
	      t.target === A() && (k.props.interactive && t.relatedTarget && w.contains(t.relatedTarget) || R());
	    }function j(t) {
	      st(t.target, k.props.target) && V(t);
	    }function X(t) {
	      st(t.target, k.props.target) && R();
	    }function z(t) {
	      var e = "ontouchstart" in window,
	          n = Ft(t.type, "touch"),
	          r = k.props.touchHold;return e && Lt && r && !n || Lt && !r && n;
	    }function B() {
	      !b && c && (b = !0, function (t) {
	        t.offsetHeight;
	      }(w), c());
	    }function W() {
	      var e = k.props.popperOptions,
	          n = k.popperChildren,
	          r = n.tooltip,
	          i = n.arrow,
	          o = Yt(e, "preventOverflow");function a(t) {
	        k.props.flip && !k.props.flipOnUpdate && (t.flipped && (k.popperInstance.options.placement = t.placement), Bt(k.popperInstance.modifiers, !1)), r.setAttribute(dt, t.placement), !1 !== t.attributes[ut] ? r.setAttribute(ut, "") : r.removeAttribute(ut), s && s !== t.placement && h && (r.style.transition = "none", requestAnimationFrame(function () {
	          r.style.transition = "";
	        })), s = t.placement, h = k.state.isVisible;var e = ne(w),
	            n = r.style;n.top = n.bottom = n.left = n.right = "", n[e] = -(k.props.distance - 10) + "px";var i = o && void 0 !== o.padding ? o.padding : ft,
	            a = "number" == typeof i,
	            p = J({ top: a ? i : i.top, bottom: a ? i : i.bottom, left: a ? i : i.left, right: a ? i : i.right }, !a && i);p[e] = a ? i + k.props.distance : (i[e] || 0) + k.props.distance, k.popperInstance.modifiers.filter(function (t) {
	          return "preventOverflow" === t.name;
	        })[0].padding = p, f = p;
	      }var p = J({ eventsEnabled: !1, placement: k.props.placement }, e, { modifiers: J({}, e ? e.modifiers : {}, { preventOverflow: J({ boundariesElement: k.props.boundary, padding: ft }, o), arrow: J({ element: i, enabled: !!i }, Yt(e, "arrow")), flip: J({ enabled: k.props.flip, padding: k.props.distance + ft, behavior: k.props.flipBehavior }, Yt(e, "flip")), offset: J({ offset: k.props.offset }, Yt(e, "offset")) }), onCreate: function onCreate(t) {
	          a(t), B(), e && e.onCreate && e.onCreate(t);
	        }, onUpdate: function onUpdate(t) {
	          a(t), B(), e && e.onUpdate && e.onUpdate(t);
	        } });k.popperInstance = new G(t, w, p);
	    }function V(t, n) {
	      if ($(), !k.state.isVisible) {
	        if (k.props.target) return function (t) {
	          if (t) {
	            var n = st(t.target, k.props.target);n && !n._tippy && se(n, J({}, k.props, { content: zt(e.content, [n]), appendTo: e.appendTo, target: "", showOnInit: !0 }));
	          }
	        }(t);if (u = !0, t && !n && k.props.onTrigger(k, t), k.props.wait) return k.props.wait(k, t);S() && !k.state.isMounted && (k.popperInstance || W(), document.addEventListener("mousemove", H)), C();var r = Pt(k.props.delay, 0, rt.delay);r ? i = setTimeout(function () {
	          K();
	        }, r) : K();
	      }
	    }function R() {
	      if ($(), !k.state.isVisible) return E(), void T();u = !1;var t = Pt(k.props.delay, 1, rt.delay);t ? o = setTimeout(function () {
	        k.state.isVisible && Z();
	      }, t) : a = requestAnimationFrame(function () {
	        Z();
	      });
	    }function U(t) {
	      if (!k.props.interactive || !w.contains(t.target)) {
	        if (A().contains(t.target)) {
	          if (Lt) return;if (k.state.isVisible && Ft(k.props.trigger, "click")) return;
	        }!0 === k.props.hideOnClick && ($(), Z());
	      }
	    }function $() {
	      clearTimeout(i), clearTimeout(o), cancelAnimationFrame(a);
	    }function q(e) {
	      $t(e = e || {}, rt), N();var n = k.props,
	          i = Ut(t, J({}, k.props, {}, e, { ignoreAttributes: !0 }));i.ignoreAttributes = Ht(e, "ignoreAttributes") ? e.ignoreAttributes || !1 : n.ignoreAttributes, k.props = i, I(), O(), y = _t(_, i.interactiveDebounce), oe(w, n, i), k.popperChildren = Gt(w), k.popperInstance && (it.some(function (t) {
	        return Ht(e, t) && e[t] !== n[t];
	      }) ? (k.popperInstance.destroy(), W(), k.state.isVisible && k.popperInstance.enableEventListeners(), k.props.followCursor && r && H(r)) : k.popperInstance.update());
	    }function K() {
	      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Pt(k.props.duration, 0, rt.duration[1]);if (!k.state.isDestroyed && k.state.isEnabled && (!Lt || k.props.touch) && !A().hasAttribute("disabled") && !1 !== k.props.onShow(k)) {
	        C(), w.style.visibility = "visible", k.state.isVisible = !0, k.props.interactive && A().classList.add(ht);var n = L();Vt(n.concat(w), 0), c = function c() {
	          if (k.state.isVisible) {
	            var i = S();i && r ? H(r) : i || k.popperInstance.update(), k.popperChildren.backdrop && (k.popperChildren.content.style.transitionDelay = Math.round(e / 12) + "ms"), k.props.sticky && function () {
	              Vt([w], tt ? 0 : k.props.updateDuration);var e = t.getBoundingClientRect();!function n() {
	                var r = t.getBoundingClientRect();e.top === r.top && e.right === r.right && e.bottom === r.bottom && e.left === r.left || k.popperInstance.scheduleUpdate(), e = r, k.state.isMounted && requestAnimationFrame(n);
	              }();
	            }(), Vt([w], k.props.updateDuration), Vt(n, e), Rt(n, "visible"), function (t, e) {
	              M(t, e);
	            }(e, function () {
	              k.props.aria && A().setAttribute("aria-".concat(k.props.aria), w.id), k.props.onShown(k), k.state.isShown = !0;
	            });
	          }
	        }, function () {
	          b = !1;var e = S();k.popperInstance ? (Bt(k.popperInstance.modifiers, k.props.flip), e || (k.popperInstance.reference = t, k.popperInstance.enableEventListeners()), k.popperInstance.scheduleUpdate()) : (W(), e || k.popperInstance.enableEventListeners());var n = k.props.appendTo,
	              r = "parent" === n ? t.parentNode : zt(n, [t]);r.contains(w) || (r.appendChild(w), k.props.onMount(k), k.state.isMounted = !0);
	        }();
	      }
	    }function Z() {
	      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Pt(k.props.duration, 1, rt.duration[1]);if (!k.state.isDestroyed && (k.state.isEnabled || m) && (!1 !== k.props.onHide(k) || m)) {
	        T(), w.style.visibility = "hidden", k.state.isVisible = !1, k.state.isShown = !1, h = !1, k.props.interactive && A().classList.remove(ht);var e = L();Vt(e, t), Rt(e, "hidden"), function (t, e) {
	          M(t, function () {
	            !k.state.isVisible && w.parentNode && w.parentNode.contains(w) && e();
	          });
	        }(t, function () {
	          u || E(), k.props.aria && A().removeAttribute("aria-".concat(k.props.aria)), k.popperInstance.disableEventListeners(), k.popperInstance.options.placement = k.props.placement, w.parentNode.removeChild(w), k.props.onHidden(k), k.state.isMounted = !1;
	        });
	      }
	    }
	  }var ce = !1;function le(t, e) {
	    $t(e || {}, rt), ce || (document.addEventListener("touchstart", St, lt), window.addEventListener("blur", It), ce = !0);var n,
	        r = J({}, rt, {}, e);n = t, "[object Object]" !== {}.toString.call(n) || n.addEventListener || function (t) {
	      var e = { isVirtual: !0, attributes: t.attributes || {}, contains: function contains() {}, setAttribute: function setAttribute(e, n) {
	          t.attributes[e] = n;
	        }, getAttribute: function getAttribute(e) {
	          return t.attributes[e];
	        }, removeAttribute: function removeAttribute(e) {
	          delete t.attributes[e];
	        }, hasAttribute: function hasAttribute(e) {
	          return e in t.attributes;
	        }, addEventListener: function addEventListener() {}, removeEventListener: function removeEventListener() {}, classList: { classNames: {}, add: function add(e) {
	            t.classList.classNames[e] = !0;
	          }, remove: function remove(e) {
	            delete t.classList.classNames[e];
	          }, contains: function contains(e) {
	            return e in t.classList.classNames;
	          } } };for (var n in e) {
	        t[n] = e[n];
	      }
	    }(t);var i = function (t) {
	      if (Xt(t)) return [t];if (t instanceof NodeList) return pt(t);if (Array.isArray(t)) return t;try {
	        return pt(document.querySelectorAll(t));
	      } catch (t) {
	        return [];
	      }
	    }(t).reduce(function (t, e) {
	      var n = e && se(e, r);return n && t.push(n), t;
	    }, []);return Xt(t) ? i[0] : i;
	  }le.version = "4.3.5", le.defaults = rt, le.setDefaults = function (t) {
	    (0, _keys2.default)(t).forEach(function (e) {
	      rt[e] = t[e];
	    });
	  }, le.hideAll = function () {
	    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
	        e = t.exclude,
	        n = t.duration;pt(document.querySelectorAll(kt)).forEach(function (t) {
	      var r,
	          i = t._tippy;if (i) {
	        var o = !1;e && (o = (r = e)._tippy && !at.call(r, kt) ? i.reference === e : t === e.popper), o || i.hide(n);
	      }
	    });
	  }, le.group = function (t) {
	    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
	        n = e.delay,
	        r = void 0 === n ? t[0].props.delay : n,
	        i = e.duration,
	        o = void 0 === i ? 0 : i,
	        a = !1;function p(t) {
	      a = t, f();
	    }function s(e) {
	      e._originalProps.onShow(e), t.forEach(function (t) {
	        t.set({ duration: o }), t.state.isVisible && t.hide();
	      }), p(!0);
	    }function c(t) {
	      t._originalProps.onHide(t), p(!1);
	    }function l(t) {
	      t._originalProps.onShown(t), t.set({ duration: t._originalProps.duration });
	    }function f() {
	      t.forEach(function (t) {
	        t.set({ onShow: s, onShown: l, onHide: c, delay: a ? [0, Array.isArray(r) ? r[1] : r] : r, duration: a ? o : t._originalProps.duration });
	      });
	    }t.forEach(function (t) {
	      t._originalProps ? t.set(t._originalProps) : t._originalProps = J({}, t.props);
	    }), f();
	  }, Z && setTimeout(function () {
	    pt(document.querySelectorAll("[data-tippy]")).forEach(function (t) {
	      var e = t.getAttribute("data-tippy");e && le(t, { content: e });
	    });
	  }), function (t) {
	    if (Z) {
	      var e = document.createElement("style");e.type = "text/css", e.textContent = t, e.setAttribute("data-tippy-stylesheet", "");var n = document.head,
	          r = n.querySelector("style,link");r ? n.insertBefore(e, r) : n.appendChild(e);
	    }
	  }('.tippy-iOS{cursor:pointer!important;-webkit-tap-highlight-color:transparent}.tippy-popper{transition-timing-function:cubic-bezier(.165,.84,.44,1);max-width:calc(100% - 8px);pointer-events:none;outline:0}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-7px;bottom:-6.5px;-webkit-transform-origin:50% 0;transform-origin:50% 0;margin:0 3px}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;bottom:-7px;margin:0 3px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 25%;transform-origin:0 25%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-55%);transform:scale(1) translate(-50%,-55%)}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%,-45%);transform:scale(.2) translate(-50%,-45%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(-10px);transform:perspective(700px) translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateX(60deg);transform:perspective(700px) rotateX(60deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=top] [data-animation=scale]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px) scale(.5);transform:translateY(-10px) scale(.5)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-7px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;margin:0 3px}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;top:-7px;margin:0 3px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -50%;transform-origin:0 -50%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-45%);transform:scale(1) translate(-50%,-45%)}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%);transform:scale(.2) translate(-50%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(10px);transform:perspective(700px) translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateX(-60deg);transform:perspective(700px) rotateX(-60deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=scale]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px) scale(.5);transform:translateY(10px) scale(.5)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-12px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%;margin:3px 0}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-75%,-50%);transform:scale(.2) translate(-75%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(-10px);transform:perspective(700px) translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateY(-60deg);transform:perspective(700px) rotateY(-60deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=left] [data-animation=scale]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px) scale(.5);transform:translateX(-10px) scale(.5)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-12px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%;margin:3px 0}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-50% 0;transform-origin:-50% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-25%,-50%);transform:scale(.2) translate(-25%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(10px);transform:perspective(700px) translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateY(60deg);transform:perspective(700px) rotateY(60deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=right] [data-animation=scale]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px) scale(.5);transform:translateX(10px) scale(.5)}.tippy-tooltip{position:relative;color:#fff;border-radius:.25rem;font-size:.875rem;padding:.3125rem .5625rem;line-height:1.4;text-align:center;background-color:#333}.tippy-tooltip[data-size=small]{padding:.1875rem .375rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.375rem .75rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:initial}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] .tippy-roundarrow path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:18px;height:7px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;background-color:#333;border-radius:50%;width:calc(110% + 2rem);left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:"";float:left;padding-top:100%}.tippy-backdrop+.tippy-content{transition-property:opacity;will-change:opacity}.tippy-backdrop+.tippy-content[data-state=hidden]{opacity:0}');var fe = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};var de,
	      ue = (function (t) {
	    var e, _n, r, i, o, a, p, s, c, l, f, d, u, m, h;e = fe, _n = function n(t, e, r) {
	      if (!s(e) || l(e) || f(e) || d(e) || p(e)) return e;var i,
	          o = 0,
	          a = 0;if (c(e)) for (i = [], a = e.length; o < a; o++) {
	        i.push(_n(t, e[o], r));
	      } else for (var u in i = {}, e) {
	        Object.prototype.hasOwnProperty.call(e, u) && (i[t(u, r)] = _n(t, e[u], r));
	      }return i;
	    }, r = function r(t) {
	      return u(t) ? t : (t = t.replace(/[\-_\s]+(.)?/g, function (t, e) {
	        return e ? e.toUpperCase() : "";
	      })).substr(0, 1).toLowerCase() + t.substr(1);
	    }, i = function i(t) {
	      var e = r(t);return e.substr(0, 1).toUpperCase() + e.substr(1);
	    }, o = function o(t, e) {
	      return function (t, e) {
	        var n = (e = e || {}).separator || "_",
	            r = e.split || /(?=[A-Z])/;return t.split(r).join(n);
	      }(t, e).toLowerCase();
	    }, a = Object.prototype.toString, p = function p(t) {
	      return "function" == typeof t;
	    }, s = function s(t) {
	      return t === Object(t);
	    }, c = function c(t) {
	      return "[object Array]" == a.call(t);
	    }, l = function l(t) {
	      return "[object Date]" == a.call(t);
	    }, f = function f(t) {
	      return "[object RegExp]" == a.call(t);
	    }, d = function d(t) {
	      return "[object Boolean]" == a.call(t);
	    }, u = function u(t) {
	      return (t -= 0) == t;
	    }, m = function m(t, e) {
	      var n = e && "process" in e ? e.process : e;return "function" != typeof n ? t : function (e, r) {
	        return n(e, t, r);
	      };
	    }, h = { camelize: r, decamelize: o, pascalize: i, depascalize: o, camelizeKeys: function camelizeKeys(t, e) {
	        return _n(m(r, e), t);
	      }, decamelizeKeys: function decamelizeKeys(t, e) {
	        return _n(m(o, e), t, e);
	      }, pascalizeKeys: function pascalizeKeys(t, e) {
	        return _n(m(i, e), t);
	      }, depascalizeKeys: function depascalizeKeys() {
	        return this.decamelizeKeys.apply(this, arguments);
	      } }, t.exports ? t.exports = h : e.humps = h;
	  }(de = { exports: {} }, de.exports), de.exports);function me(t, e, n) {
	    return e in t ? (0, _defineProperty2.default)(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
	  }function he(t, e) {
	    var n = (0, _keys2.default)(t);if (_getOwnPropertySymbols2.default) {
	      var r = (0, _getOwnPropertySymbols2.default)(t);e && (r = r.filter(function (e) {
	        return (0, _getOwnPropertyDescriptor2.default)(t, e).enumerable;
	      })), n.push.apply(n, r);
	    }return n;
	  }var be = { a11y: !0, allowHTML: !0, animateFill: !0, arrow: !1, flip: !0, flipOnUpdate: !1, followCursor: !1, hideOnClick: !0, ignoreAttributes: !1, inertia: !1, interactive: !1, lazy: !0, multiple: !1, showOnInit: !1, sticky: !1, touch: !0, touchHold: !1 },
	      ve = function (t) {
	    for (var e = 1; e < arguments.length; e++) {
	      var n = null != arguments[e] ? arguments[e] : {};e % 2 ? he(Object(n), !0).forEach(function (e) {
	        me(t, e, n[e]);
	      }) : _getOwnPropertyDescriptors2.default ? (0, _defineProperties2.default)(t, (0, _getOwnPropertyDescriptors2.default)(n)) : he(Object(n)).forEach(function (e) {
	        (0, _defineProperty2.default)(t, e, (0, _getOwnPropertyDescriptor2.default)(n, e));
	      });
	    }return t;
	  }({ animation: "shift-away", appendTo: function appendTo() {
	      return document.body;
	    }, aria: "describedby", arrowType: "sharp", boundary: "scrollParent", content: "", delay: 0, distance: 10, duration: [325, 275], flipBehavior: "flip", interactiveBorder: 2, interactiveDebounce: 0, maxWidth: 350, offset: 0, onHidden: function onHidden() {}, onHide: function onHide() {}, onMount: function onMount() {}, onShow: function onShow() {}, onShown: function onShown() {}, placement: "top", popperOptions: {}, role: "tooltip", size: "regular", target: "", theme: "dark", trigger: "mouseenter focus", updateDuration: 0, wait: null, zIndex: 9999 }, be),
	      ye = { props: ["to", "toSelector", "toElement", "content", "enabled", "visible", "triggerTarget"], data: function data() {
	      return { tip: null, options: {} };
	    }, mounted: function mounted() {
	      this.init();
	    }, watch: { content: function content() {
	        this.tip && this.tip.set(this.getOptions());
	      }, enabled: function enabled(t) {
	        this.tip && (t ? this.tip.enable() : (this.tip.hide(), this.tip.disable()));
	      }, visible: function visible(t) {
	        this.tip && (t ? this.tip.show() : this.tip.hide());
	      } }, updated: function updated() {
	      this.tip && !this.content && this.tip.set(this.getOptions());
	    }, beforeDestroy: function beforeDestroy() {
	      this.tip && this.tip.destroy();
	    }, computed: { isManualTrigger: function isManualTrigger() {
	        return "manual" === this.options.trigger;
	      } }, methods: { init: function init() {
	        if (this.tip) {
	          try {
	            this.tip.destroy();
	          } catch (t) {}this.tip = null;
	        }var t = this.toElement;if (null == t && (t = this.to ? document.querySelector("[name='".concat(this.to, "']")) : this.toSelector ? document.querySelector(this.toSelector) : this.$refs.trigger && this.$refs.trigger.childElementCount > 0 ? this.$refs.trigger : this.$el.parentElement), t) {
	          var e = le(t, this.getOptions());if (e) {
	            if (Array.isArray(e)) {
	              if (!(e.length > 0)) return;this.tip = e[0];
	            }this.tip = e, this.$emit("onCreate", this.tip), this.$emit("init", this.tip), !1 === this.enabled && this.tip.disable(), this.isManualTrigger && !0 === this.visible && this.tip.show();
	          }
	        }
	      }, tippy: function tippy() {
	        return this.tip;
	      }, filterOptions: function filterOptions() {
	        for (var t = function t(_t2, e) {
	          if (be.hasOwnProperty(_t2)) {
	            if ("" === e) return !0;if ("false" === e) return !1;if ("true" === e) return !0;
	          }return e;
	        }, e = 0, n = (0, _keys2.default)(this.options); e < n.length; e++) {
	          var r = n[e];ve.hasOwnProperty(r) || delete this.options[r], this.options[r] = t(r, this.options[r]);
	        }return this.options;
	      }, getOptions: function getOptions() {
	        var t = this;return (0, _assign2.default)(this.options, ue.camelizeKeys(this.$attrs)), this.filterOptions(), !this.options.onShow && this.$listeners && this.$listeners.show && (this.options.onShow = function () {
	          var e;return (e = t.$listeners.show).fns.apply(e, arguments);
	        }), this.options.onShown || (this.options.onShown = function () {
	          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
	            n[r] = arguments[r];
	          }t.$emit.apply(t, ["shown"].concat(n));
	        }), this.options.onHidden || (this.options.onHidden = function () {
	          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
	            n[r] = arguments[r];
	          }t.$emit.apply(t, ["hidden"].concat(n));
	        }), !this.options.onHide && this.$listeners && this.$listeners.hide && (this.options.onHide = function () {
	          var e;return (e = t.$listeners.hide).fns.apply(e, arguments);
	        }), this.options.onMount || (this.options.onMount = function () {
	          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
	            n[r] = arguments[r];
	          }t.$emit.apply(t, ["mount"].concat(n));
	        }), this.options.hasOwnProperty("content") || (this.options.content = this.content ? this.content : this.$refs.content), this.options.triggerTarget = this.triggerTarget, this.options;
	      } } };"undefined" != typeof navigator && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());var ge = function (t, e, n, r, i, o, a, p, s, c) {
	    "boolean" != typeof a && (s = p, p = a, a = !1);var l = "function" == typeof n ? n.options : n;var f = void 0;if (t && t.render && (l.render = t.render, l.staticRenderFns = t.staticRenderFns, l._compiled = !0, i && (l.functional = !0)), r && (l._scopeId = r), o ? (f = function f(t) {
	      (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), e && e.call(this, s(t)), t && t._registeredComponents && t._registeredComponents.add(o);
	    }, l._ssrRegister = f) : e && (f = a ? function (t) {
	      e.call(this, c(t, this.$root.$options.shadowRoot));
	    } : function (t) {
	      e.call(this, p(t));
	    }), f) if (l.functional) {
	      var _t3 = l.render;l.render = function (e, n) {
	        return f.call(n), _t3(e, n);
	      };
	    } else {
	      var _t4 = l.beforeCreate;l.beforeCreate = _t4 ? [].concat(_t4, f) : [f];
	    }return n;
	  }({ render: function render() {
	      var t = this.$createElement,
	          e = this._self._c || t;return e("div", [e("div", { ref: "trigger" }, [this._t("trigger")], 2), this._v(" "), e("div", { ref: "content" }, [this._t("default")], 2)]);
	    }, staticRenderFns: [] }, void 0, ye, void 0, !1, void 0, !1, void 0, void 0, void 0),
	      we = "tippy",
	      xe = { install: function install(t) {
	      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};we = e.directive || "tippy", le.setDefaults(e || {}), t.directive(we, { inserted: function inserted(n, r, i) {
	          t.nextTick(function () {
	            !function (n, r, i) {
	              var o = i.data && i.data.on || i.componentOptions && i.componentOptions.listeners,
	                  a = r.value || {};a = (0, _assign2.default)({}, e, a), o && o.show && (a.onShow = function () {
	                var t;return (t = o.show).fns.apply(t, arguments);
	              }), o && o.shown && (a.onShown = function () {
	                var t;(t = o.shown).fns.apply(t, arguments);
	              }), o && o.hidden && (a.onHidden = function () {
	                var t;(t = o.hidden).fns.apply(t, arguments);
	              }), o && o.hide && (a.onHide = function () {
	                var t;return (t = o.hide).fns.apply(t, arguments);
	              }), o && o.mount && (a.onMount = function () {
	                var t;(t = o.mount).fns.apply(t, arguments);
	              }), n.getAttribute("title") && !a.content && (a.content = n.getAttribute("title")), n.getAttribute("content") && !a.content && (a.content = n.getAttribute("content")), le(n, a), a.showOnLoad && n._tippy.show(), t.nextTick(function () {
	                o && o.init && o.init.fns(n._tippy, n);
	              });
	            }(n, r, i);
	          });
	        }, unbind: function unbind(t) {
	          t._tippy && t._tippy.destroy();
	        }, componentUpdated: function componentUpdated(t, e, n) {
	          if (t._tippy) {
	            var r = e.value || {};t.getAttribute("title") && !r.content && (r.content = t.getAttribute("title")), t.getAttribute("content") && !r.content && (r.content = t.getAttribute("content")), t._tippy.set(r);
	          }
	        } });
	    } };return "undefined" != typeof window && window.Vue && (window.Vue.use(xe), window.Vue.component("tippy", ge)), t.TippyComponent = ge, t.default = xe, t.tippy = le, t;
	}({});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(47);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(48);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Event = __webpack_require__(90);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Channel = function () {
	  function Channel(name, _dispatcher) {
	    var is_private = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var on_success = arguments[3];
	    var on_failure = arguments[4];
	    (0, _classCallCheck3.default)(this, Channel);
	
	    var event_name = void 0;
	
	    this.name = name;
	    this._dispatcher = _dispatcher;
	    this.is_private = is_private;
	    this.on_success = on_success;
	    this.on_failure = on_failure;
	    this._callbacks = {};
	    this._token = void 0;
	    this._queue = [];
	
	    if (this.is_private) {
	      event_name = 'websocket_rails.subscribe_private';
	    } else {
	      event_name = 'websocket_rails.subscribe';
	    }
	
	    if (this._dispatcher._conn) {
	      this.connection_id = this._dispatcher._conn.connection_id;
	    }
	
	    var event = new _Event2.default([event_name, {
	      data: {
	        channel: this.name
	      }
	    }, this.connection_id], this._success_launcher, this._failure_launcher);
	    this._dispatcher.trigger_event(event);
	  }
	
	  (0, _createClass3.default)(Channel, [{
	    key: 'destroy',
	    value: function destroy() {
	      if (this.connection_id === (this._dispatcher._conn && this._dispatcher._conn.connection_id)) {
	        var event_name = 'websocket_rails.unsubscribe';
	        var event = new _Event2.default([event_name, {
	          data: {
	            channel: this.name
	          }
	        }, this.connection_id]);
	        this._dispatcher.trigger_event(event);
	      }
	
	      return this._callbacks = {};
	    }
	  }, {
	    key: 'bind',
	    value: function bind(eventName, callback) {
	      var _callbacks = this._callbacks;
	
	
	      if (!_callbacks[eventName]) {
	        _callbacks[eventName] = [];
	      }
	
	      return _callbacks[eventName].push(callback);
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind(eventName) {
	      return delete this._callbacks[eventName];
	    }
	  }, {
	    key: 'trigger',
	    value: function trigger(eventName, message) {
	      var name = this.name,
	          _token = this._token,
	          connection_id = this.connection_id,
	          _queue = this._queue,
	          _dispatcher = this._dispatcher;
	
	
	      var event = new _Event2.default([eventName, {
	        channel: name,
	        data: message,
	        token: _token
	      }, connection_id]);
	      if (!_token) {
	        return _queue.push(event);
	      }
	      return _dispatcher.trigger_event(event);
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch(eventName, message) {
	      if (eventName === 'websocket_rails.channel_token') {
	        this.connection_id = this._dispatcher._conn && this._dispatcher._conn.connection_id;
	        this._token = message.token;
	        return this.flush_queue();
	      }
	
	      if (this._callbacks[eventName]) {
	        return this._callbacks[eventName].map(function (item) {
	          return item(message);
	        });
	      }
	    }
	  }, {
	    key: '_success_launcher',
	    value: function _success_launcher(data) {
	      var on_success = this.on_success;
	
	
	      if (on_success) {
	        return on_success(data);
	      }
	    }
	  }, {
	    key: '_failure_launcher',
	    value: function _failure_launcher(data) {
	      var on_failure = this.on_failure;
	
	
	      if (on_failure) {
	        return on_failure(data);
	      }
	    }
	  }, {
	    key: 'flush_queue',
	    value: function flush_queue() {
	      var _this = this;
	
	      this._queue.forEach(function (item) {
	        _this._dispatcher.trigger_event(item);
	      });
	
	      return this._queue = [];
	    }
	  }]);
	  return Channel;
	}();
	
	exports.default = Channel;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(47);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(48);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(143);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(141);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(142);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _AbstractConnection2 = __webpack_require__(139);
	
	var _AbstractConnection3 = _interopRequireDefault(_AbstractConnection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HttpConnection = function (_AbstractConnection) {
	  (0, _inherits3.default)(HttpConnection, _AbstractConnection);
	
	  function HttpConnection(url, dispatcher) {
	    (0, _classCallCheck3.default)(this, HttpConnection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HttpConnection.__proto__ || (0, _getPrototypeOf2.default)(HttpConnection)).call(this, url, dispatcher));
	
	    _this.connection_type = 'http';
	    _this.dispatcher = dispatcher;
	    _this._url = 'http://' + url;
	    _this._conn = _this._createXMLHttpObject();
	    _this.last_pos = 0;
	    try {
	      _this._conn.onreadystatechange = _this._parse_stream();
	      _this._conn.addEventListener('load', _this.on_close, false);
	    } catch (_error) {
	      _this._conn.onprogress = _this._parse_stream();
	      _this._conn.onload = _this.on_close;
	      _this._conn.readyState = 3;
	      console.error(_error);
	    }
	    _this._conn.open('GET', _this._url, true);
	    _this._conn.send();
	    return _this;
	  }
	
	  (0, _createClass3.default)(HttpConnection, [{
	    key: '_httpFactories',
	    value: function _httpFactories() {
	      var _window = window,
	          XDomainRequest = _window.XDomainRequest,
	          XMLHttpRequest = _window.XMLHttpRequest,
	          ActiveXObject = _window.ActiveXObject;
	
	
	      return [function () {
	        return new XDomainRequest();
	      }, function () {
	        return new XMLHttpRequest();
	      }, function () {
	        return new ActiveXObject('Msxml2.XMLHTTP');
	      }, function () {
	        return new ActiveXObject('Msxml3.XMLHTTP');
	      }, function () {
	        return new ActiveXObject('Microsoft.XMLHTTP');
	      }];
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      return this._conn.abort();
	    }
	  }, {
	    key: 'send_event',
	    value: function send_event(event) {
	      (0, _get3.default)(HttpConnection.prototype.__proto__ || (0, _getPrototypeOf2.default)(HttpConnection.prototype), 'send_event', this).call(this, event);
	      return this._post_data(event.serialize());
	    }
	  }, {
	    key: '_post_data',
	    value: function _post_data(payload) {
	      var _window2 = window,
	          jQuery = _window2.jQuery;
	
	      if (jQuery) {
	        return jQuery.ajax(this._url, {
	          type: 'POST',
	          data: {
	            client_id: this.connection_id,
	            data: payload
	          },
	          success: function success() {
	            return false;
	          }
	        });
	      }
	    }
	  }, {
	    key: '_createXMLHttpObject',
	    value: function _createXMLHttpObject() {
	      var factories = void 0;
	      var factory = void 0;
	      var i = void 0;
	      var len = void 0;
	      var xmlhttp = void 0;
	
	      xmlhttp = false;
	      factories = this._httpFactories();
	
	      for (i = 0, len = factories.length; i < len; i++) {
	        factory = factories[i];
	        try {
	          xmlhttp = factory();
	        } catch (_error) {
	          continue;
	        }
	        break;
	      }
	      return xmlhttp;
	    }
	  }, {
	    key: '_parse_stream',
	    value: function _parse_stream() {
	      var data = void 0;
	      var event_data = void 0;
	
	      if (this._conn.readyState === 3) {
	        data = this._conn.responseText.substring(this.last_pos);
	        this.last_pos = this._conn.responseText.length;
	        data = data.replace(/\]\]\[\[/g, "],[");
	
	        try {
	          event_data = JSON.parse(data);
	          return this.on_message(event_data);
	        } catch (_error) {
	          console.error(_error);
	        }
	      }
	    }
	  }]);
	  return HttpConnection;
	}(_AbstractConnection3.default);
	
	exports.default = HttpConnection;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(47);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(48);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(143);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(141);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(142);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _AbstractConnection2 = __webpack_require__(139);
	
	var _AbstractConnection3 = _interopRequireDefault(_AbstractConnection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebSocketConnection = function (_AbstractConnection) {
	  (0, _inherits3.default)(WebSocketConnection, _AbstractConnection);
	
	  function WebSocketConnection(url, dispatcher) {
	    (0, _classCallCheck3.default)(this, WebSocketConnection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WebSocketConnection.__proto__ || (0, _getPrototypeOf2.default)(WebSocketConnection)).call(this, url, dispatcher));
	
	    _this.url = url;
	    _this.connection_type = 'websocket';
	
	    if (_this.url.match(/^wss?:\/\//)) {
	      console.log('WARNING: Using connection urls with protocol specified is depricated');
	    } else if (window.location.protocol === 'https:') {
	      _this.url = 'wss://' + _this.url;
	    } else {
	      _this.url = 'ws://' + _this.url;
	    }
	
	    _this._conn = new WebSocket(_this.url);
	    _this._conn.onmessage = function (event) {
	      return _this.on_message(JSON.parse(event.data));
	    };
	
	    _this._conn.onclose = function (event) {
	      return _this.on_close(event);
	    };
	
	    _this._conn.onerror = function (event) {
	      return _this.on_error(event);
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(WebSocketConnection, [{
	    key: 'close',
	    value: function close() {
	      return this._conn.close();
	    }
	  }, {
	    key: 'send_event',
	    value: function send_event(event) {
	      (0, _get3.default)(WebSocketConnection.prototype.__proto__ || (0, _getPrototypeOf2.default)(WebSocketConnection.prototype), 'send_event', this).call(this, event);
	      return this._conn.send(event.serialize());
	    }
	  }]);
	  return WebSocketConnection;
	}(_AbstractConnection3.default);
	
	exports.default = WebSocketConnection;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(47);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(48);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Channel = __webpack_require__(380);
	
	var _Channel2 = _interopRequireDefault(_Channel);
	
	var _HttpConnection = __webpack_require__(381);
	
	var _HttpConnection2 = _interopRequireDefault(_HttpConnection);
	
	var _WebSocketConnection = __webpack_require__(382);
	
	var _WebSocketConnection2 = _interopRequireDefault(_WebSocketConnection);
	
	var _Event = __webpack_require__(90);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebSocketRails = function () {
	  function WebSocketRails(url) {
	    var use_websockets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    (0, _classCallCheck3.default)(this, WebSocketRails);
	
	    this.url = url;
	    this.use_websockets = use_websockets;
	    this.callbacks = {};
	    this.channels = {};
	    this.queue = {};
	    this.connect();
	  }
	
	  (0, _createClass3.default)(WebSocketRails, [{
	    key: 'connect',
	    value: function connect() {
	      this.state = 'connecting';
	      if (!(this.supports_websockets() && this.use_websockets)) {
	        this._conn = new _HttpConnection2.default(this.url, this);
	      } else {
	        this._conn = new _WebSocketConnection2.default(this.url, this);
	      }
	      return this._conn.new_message = this.new_message;
	    }
	  }, {
	    key: 'disconnect',
	    value: function disconnect() {
	      if (this._conn) {
	        this._conn.close();
	        delete this._conn._conn;
	        delete this._conn;
	      }
	      return this.state = 'disconnected';
	    }
	  }, {
	    key: 'reconnect',
	    value: function reconnect() {
	      var _this = this;
	
	      var old_connection_id = this._conn && this._conn.connection_id;
	
	      this.disconnect();
	      this.connect();
	
	      (0, _keys2.default)(this.queue).forEach(function (key) {
	        var event = _this.queue[key];
	        if (event.connection_id === old_connection_id && !event.is_result()) {
	          _this.trigger_event(event);
	        }
	      });
	
	      return this.reconnect_channels();
	    }
	  }, {
	    key: 'new_message',
	    value: function new_message(data) {
	      var _this2 = this;
	
	      return data.map(function (message) {
	        var event = new _Event2.default(message);
	
	        if (event.is_result()) {
	          if (_this2.queue[event.id]) {
	            _this2.queue[event.id].run_callbacks(event.success, event.data);
	          }
	          delete _this2.queue[event.id];
	        } else if (event.result === false && event.success === false && event.channel === undefined) {
	          if (_this2.queue[event.id]) {
	            _this2.queue[event.id].run_callbacks(event.success, event.data);
	          }
	          delete _this2.queue[event.id];
	        } else if (event.is_channel()) {
	          _this2.dispatch_channel(event);
	        } else if (event.is_ping()) {
	          _this2.pong();
	        } else {
	          _this2.dispatch(event);
	        }
	        if (_this2.state === 'connecting' && event.name === 'client_connected') {
	          return _this2.connection_established(event.data);
	        }
	      });
	    }
	  }, {
	    key: 'connection_established',
	    value: function connection_established(data) {
	      this.state = 'connected';
	      this._conn.setConnectionId(data.connection_id);
	      this._conn.flush_queue();
	      if (this.on_open) {
	        return this.on_open(data);
	      }
	    }
	  }, {
	    key: 'bind',
	    value: function bind(eventName, callback) {
	      if (!this.callbacks[eventName]) {
	        this.callbacks[eventName] = [];
	      }
	      return this.callbacks[eventName].push(callback);
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind(event_name) {
	      return delete this.callbacks[event_name];
	    }
	  }, {
	    key: 'trigger',
	    value: function trigger(eventName, data, success, fail) {
	      var event = new _Event2.default([eventName, data, this._conn && this._conn.connection_id], success, fail);
	      return this.trigger_event(event);
	    }
	  }, {
	    key: 'trigger_event',
	    value: function trigger_event(event) {
	      var id = event.id;
	
	
	      if (!this.queue[id]) {
	        this.queue[id] = event;
	      }
	
	      if (this._conn) {
	        this._conn.trigger(event);
	      }
	      return event;
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch(event) {
	      var name = event.name,
	          data = event.data;
	
	      if (this.callbacks[name]) {
	        return this.callbacks[name].map(function (callback) {
	          return callback(data);
	        });
	      }
	    }
	  }, {
	    key: 'subscribe',
	    value: function subscribe(channelName, success, fail) {
	      if (!this.channels[channelName]) {
	        this.channels[channelName] = new _Channel2.default(channelName, this, false, success, fail);
	      }
	
	      return this.channels[channelName];
	    }
	  }, {
	    key: 'subscribe_private',
	    value: function subscribe_private(channelName, success, fail) {
	      if (!this.channels[channelName]) {
	        this.channels[channelName] = new _Channel2.default(channelName, this, true, success, fail);
	      }
	      return this.channels[channelName];
	    }
	  }, {
	    key: 'unsubscribe',
	    value: function unsubscribe(channelName) {
	      if (this.channels[channelName]) {
	        this.channels[channelName].destroy();
	        return delete this.channels[channelName];
	      }
	    }
	  }, {
	    key: 'dispatch_channel',
	    value: function dispatch_channel(event) {
	      if (this.channels[event.channel]) {
	        return this.channels[event.channel].dispatch(event.name, event.data);
	      }
	    }
	  }, {
	    key: 'supports_websockets',
	    value: function supports_websockets() {
	      var _window = window,
	          WebSocket = _window.WebSocket;
	
	      return typeof WebSocket === 'function' || (typeof WebSocket === 'undefined' ? 'undefined' : (0, _typeof3.default)(WebSocket)) === 'object';
	    }
	  }, {
	    key: 'pong',
	    value: function pong() {
	      var pong = new _Event2.default(['websocket_rails.pong', {}, this._conn && this._conn.connection_id]);
	      return this._conn.trigger(pong);
	    }
	  }, {
	    key: 'connection_stale',
	    value: function connection_stale() {
	      return this.state !== 'connected';
	    }
	  }, {
	    key: 'reconnect_channels',
	    value: function reconnect_channels() {
	      var _this3 = this;
	
	      var channels = this.channels;
	
	
	      return (0, _keys2.default)(channels).map(function (key) {
	        var channel = channels[key];
	        var callbacks = channel._callbacks;
	        channel.destroy();
	        delete _this3.channels[key];
	
	        channel = channel.is_private ? _this3.subscribe_private(key) : _this3.subscribe(key);
	        channel._callbacks = callbacks;
	
	        return channel;
	      });
	    }
	  }]);
	  return WebSocketRails;
	}();
	
	exports.default = WebSocketRails;
	
	
	WebSocketRails.Event = _Event2.default;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SideNav = __webpack_require__(84);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _Manager = __webpack_require__(358);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _DocendoConnectionIndicator = __webpack_require__(1251);
	
	var _DocendoConnectionIndicator2 = _interopRequireDefault(_DocendoConnectionIndicator);
	
	var _appmanifest = __webpack_require__(1791);
	
	var _appmanifest2 = _interopRequireDefault(_appmanifest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DocendoConnnectionIndicator: _DocendoConnectionIndicator2.default, SideNav: _SideNav2.default, Toast: _Manager2.default
	  }
	};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Setup = __webpack_require__(1210);
	
	var _Setup2 = _interopRequireDefault(_Setup);
	
	var _DirectDaySelector = __webpack_require__(129);
	
	var _DirectDaySelector2 = _interopRequireDefault(_DirectDaySelector);
	
	var _Hello = __webpack_require__(313);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _VacationDaysSelector = __webpack_require__(130);
	
	var _VacationDaysSelector2 = _interopRequireDefault(_VacationDaysSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AulaSetup: _Setup2.default, DirectDaySelector: _DirectDaySelector2.default, Hello: _Hello2.default, VacationDaysSelector: _VacationDaysSelector2.default },
	  data: function data() {
	    return {
	      selected: 0,
	      components: [_Setup2.default, _DirectDaySelector2.default, _Hello2.default, _VacationDaysSelector2.default],
	      currentComponent: _Setup2.default
	    };
	  },
	  created: function created() {
	    this.select(this.selected);
	  },
	
	  methods: {
	    select: function select(index) {
	      this.currentComponent = this.components[index];
	    }
	  }
	};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AssignHoursEmploymentEnded = __webpack_require__(114);
	
	var _AssignHoursEmploymentEnded2 = _interopRequireDefault(_AssignHoursEmploymentEnded);
	
	var _AbsenceReasonsTable = __webpack_require__(1195);
	
	var _AbsenceReasonsTable2 = _interopRequireDefault(_AbsenceReasonsTable);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AbsenceReasonsCreate = __webpack_require__(112);
	
	var _AbsenceReasonsCreate2 = _interopRequireDefault(_AbsenceReasonsCreate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absence_reasons: 'Fraværsårsager',
	    create_absence: 'Opret fraværsårsag',
	    title: 'Navn',
	    need_a_title: 'Mangler et navn',
	    no_absence_reasons_created: 'Ingen fraværsårsager oprettet',
	    title_already_exists: 'Navnet findes i forvejen',
	    hide_archived: 'Skjul arkiverede',
	    show_archived: 'Vis arkiverede',
	    hide_title: 'Skjul titel'
	  },
	  nb: {
	    absence_reasons: 'Fraværsårsaker',
	    create_absence: 'Opprett fraværsårsak',
	    title: 'Navn',
	    need_a_title: 'Mangler et navn',
	    no_absence_reasons_created: 'Ingen fraværsårsaker opprettet',
	    title_already_exists: 'Navnet finnes allerede',
	    hide_archived: 'Skjul arkiverte',
	    show_archived: 'Vis arkiverte'
	  },
	  en: {
	    absence_reasons: 'Absence reasons',
	    create_absence: 'Create absence reason',
	    title: 'Name',
	    need_a_title: 'Missing a name',
	    no_absence_reasons_created: 'No absence reasons created',
	    title_already_exists: 'The name already exists',
	    hide_archived: 'Hide archived',
	    show_archived: 'Show archived'
	  }
	};
	exports.default = {
	  components: { AbsenceReasonsTable: _AbsenceReasonsTable2.default, AssignHoursEmploymentEnded: _AssignHoursEmploymentEnded2.default, DModal: _DModal2.default, Loader: _Loader2.default, AppToggle: _AppToggle2.default, AbsenceReasonsCreate: _AbsenceReasonsCreate2.default },
	  data: function data() {
	    return {
	      isLoading: false,
	      absenceReasons: [],
	      newReasonTitle: '',
	      isCreateAbsenceReason: false,
	      errors: {},
	      isCreating: false,
	      theUpdatingReasonId: null,
	      _keyListener: null,
	      isShowArchived: false
	    };
	  },
	
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        setTimeout(function (_) {
	          el.focus();
	        }, 150);
	      }
	    }
	  },
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    absenceReasonsSorted: function absenceReasonsSorted() {
	      return this.absenceReasons.slice().sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    absenceReasonsArchived: function absenceReasonsArchived() {
	      return this.absenceReasonsSorted.filter(function (reason) {
	        return reason.archived;
	      });
	    },
	    absenceReasonsActive: function absenceReasonsActive() {
	      return this.absenceReasonsSorted.filter(function (reason) {
	        return !reason.archived;
	      });
	    }
	  },
	  watch: {
	    schoolId: function schoolId() {
	      this.readAbsenceReasons();
	    }
	  },
	  methods: {
	    handleCreateReason: function handleCreateReason(titleAndDefaultPrivate) {
	      var _this = this;
	
	      var title = titleAndDefaultPrivate.title;
	      var defaultPrivate = titleAndDefaultPrivate.defaultPrivate;
	      this.isCreating = true;
	      _docendo2.default.schoolAbsenceSubjectsCreate(this.schoolId, title, '#564437', defaultPrivate, function (success) {
	        _this.absenceReasons.push(success);
	        _this.setIsCreateAbsenceReason(false);
	      }, function (failure) {
	        console.log('error', failure);
	      });
	    },
	    editAbsencePrivate: function editAbsencePrivate(reason) {
	      var _this2 = this;
	
	      var defaultPrivate = !reason.default_private;
	      this.$nextTick(function (_) {
	        _docendo2.default.schoolAbsenceSubjectsUpdate(reason.id, reason.school_id, reason.name, reason.color, defaultPrivate, function (success) {
	          if (success.status === 'error') {
	            _eventbus2.default.toast = { text: success.message, 'success': false };
	            return;
	          }
	          _this2.updateAbsenceReason(success);
	        }, function (failure) {
	          console.log({ failure: failure });
	        });
	      });
	    },
	    updateAbsenceReason: function updateAbsenceReason(updatedReason) {
	      var idx = this.absenceReasons.findIndex(function (r) {
	        return r.id === updatedReason.id;
	      });
	
	      if (idx !== -1) {
	        this.$set(this.absenceReasons, idx, updatedReason);
	      }
	      this.theUpdatingReasonId = null;
	    },
	    toggleArchived: function toggleArchived(reason) {
	      var _this3 = this;
	
	      var isArchived = reason.archived;
	      this.theUpdatingReasonId = reason.id;
	      if (!isArchived) {
	        _docendo2.default.schoolAbsenceSubjectsArchive(reason.school_id, reason.id, function (success) {
	          if (success.status === 'error') {
	            _eventbus2.default.toast = { text: success.message, 'success': false };
	            return;
	          }
	          _this3.updateAbsenceReason(success);
	        }, function (failure) {
	          console.log('failed!');
	        });
	      } else {
	        _docendo2.default.schoolAbsenceSubjectsUnarchive(reason.school_id, reason.id, function (success) {
	          _this3.updateAbsenceReason(success);
	        }, function (failure) {
	          console.log('failed!');
	        });
	      }
	    },
	    setIsCreateAbsenceReason: function setIsCreateAbsenceReason(bool) {
	      this.isCreateAbsenceReason = bool;
	      if (!bool) {
	        this.newReasonTitle = '';
	        this.errors = {};
	        this.isCreating = false;
	      }
	    },
	    readAbsenceReasons: function readAbsenceReasons() {
	      var _this4 = this;
	
	      if (!this.schoolId) {
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.schoolAbsenceSubjectsList(this.schoolId, true, function (success) {
	        _this4.absenceReasons = success;
	        _this4.isLoading = false;
	      }, function (failure) {
	        _this4.isLoading = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.readAbsenceReasons();
	    this._keyListener = function (e) {
	      if (e.key === 'n' && e.target.tagName.toUpperCase() === 'BODY') {
	        _this5.setIsCreateAbsenceReason(true);
	      }
	    };
	
	    document.addEventListener('keydown', this._keyListener);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absence_reasons: 'Fraværsårsager',
	    create_absence: 'Opret fraværsårsag',
	    need_a_title: 'Mangler et navn',
	    title: 'Titel på fraværsårsag',
	    hide_title: 'Skjul fraværstitel',
	    archive: 'Arkivér',
	    dearchive: 'Genskab',
	    no_absence_reasons_created: 'Ingen fraværsårsager oprettet',
	    tooltip_for_hide_title: 'Når "Skjul titel" er aktiveret, er fraværstitlen kun synlig for administratorer og brugeren med fraværet – for andre vises blot "Fravær". Hvis indstillingen deaktiveres, er titlen synlig for alle, også i Aula.',
	    title_already_exists: 'Navnet findes i forvejen',
	    default_private_explained: 'Hvis "Skjul fraværstitel" er slået til, vil administratorer – samt brugeren med fraværet – se fraværets titel,<br>mens andre brugere blot ser "Fravær" som titel på fraværet.'
	  },
	  nb: {
	    absence_reasons: 'Fraværsårsaker',
	    create_absence: 'Opprett fraværsårsak',
	    hide_title: 'Skjul tittel',
	    archive: 'Arkiver',
	    dearchive: 'Gjenopprett',
	    title: 'Tittel',
	    need_a_title: 'Mangler et navn',
	    no_absence_reasons_created: 'Ingen fraværsårsaker opprettet',
	    tooltip_for_hide_title: 'Når "Skjul tittel" er aktivert, er fraværstittelen kun synlig for administratorer og brukeren fraværet gjelder – for andre vises bare "Fravær". Hvis innstillingen deaktiveres, blir tittelen synlig for alle.',
	    title_already_exists: 'Navnet finnes allerede',
	    default_private_explained: 'Hvis "Skjul fraværstittel" er aktivert, vil administratorer – samt brukeren med fraværet – se fraværets tittel,<br>mens andre brukere kun ser "Fravær" som tittel på fraværet.'
	  },
	  en: {
	    absence_reasons: 'Absence reasons',
	    create_absence: 'Create absence reason',
	    hide_title: 'Hide title',
	    archive: 'Archive',
	    dearchive: 'Restore',
	    title: 'Title',
	    need_a_title: 'Missing a name',
	    no_absence_reasons_created: 'No absence reasons created',
	    tooltip_for_hide_title: 'When "Hide title" is enabled, the absence title is only visible to administrators and the user the absence relates to – others will simply see "Absence". If the setting is disabled, the title becomes visible to everyone.',
	    title_already_exists: 'The name already exists',
	    default_private_explained: 'If "Hide absence title" is enabled, administrators – as well as the user with the absence – will see the absence title,<br>while other users will simply see "Absence" as the title.'
	  }
	};
	exports.default = {
	  components: { DModal: _DModal2.default, AppToggle: _AppToggle2.default },
	  props: {
	    reasons: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    initTitle: {
	      type: String,
	      default: ''
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        setTimeout(function () {
	          el.focus();
	        }, 150);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      newReasonTitle: '',
	      errors: {},
	      isCreating: false,
	      defaultPrivate: true
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    }
	  },
	  methods: {
	    checkIfTitleAlreadyExists: function checkIfTitleAlreadyExists(title) {
	      var _this = this;
	
	      return this.reasons.some(function (reason) {
	        return reason.name.toLowerCase() === _this.newReasonTitle.toLowerCase();
	      });
	    },
	    onCancel: function onCancel() {
	      this.$emit('cancel');
	      this.reset();
	    },
	    onCreate: function onCreate() {
	      if (this.newReasonTitle.length < 1) {
	        this.$set(this.errors, 'newReasonTitle', this.i18n.need_a_title);
	        return;
	      }
	      if (this.checkIfTitleAlreadyExists()) {
	        this.$set(this.errors, 'newReasonTitle', this.i18n.title_already_exists);
	        return;
	      }
	      var titleAndDefaultPrivate = {
	        title: this.newReasonTitle,
	        defaultPrivate: this.defaultPrivate
	      };
	      this.isCreating = true;
	      this.$emit('create', titleAndDefaultPrivate);
	    },
	    clearErrors: function clearErrors() {
	      this.errors = {};
	    },
	    reset: function reset() {
	      this.newReasonTitle = '';
	      this.errors = {};
	      this.isCreating = false;
	    }
	  },
	  mounted: function mounted() {
	    if (this.initTitle) {
	      this.newReasonTitle = this.initTitle;
	    }
	  }
	};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absence_reasons: 'Fraværsårsager',
	    create_absence: 'Opret fraværsårsag',
	    need_a_title: 'Mangler et navn',
	    title: 'Navn',
	    hide_title: 'Skjul titel',
	    archive: 'Arkivér',
	    dearchive: 'Genskab',
	    no_absence_reasons_created: 'Ingen fraværsårsager oprettet',
	    tooltip_for_hide_title: 'Når "Skjul titel" er aktiveret, er fraværstitlen kun synlig for administratorer og brugeren med fraværet – for andre vises blot "Fravær". Hvis indstillingen deaktiveres, er titlen synlig for alle, også i Aula.',
	    title_already_exists: 'Navnet findes i forvejen'
	  },
	  nb: {
	    absence_reasons: 'Fraværsårsaker',
	    create_absence: 'Opprett fraværsårsak',
	    hide_title: 'Skjul tittel',
	    archive: 'Arkiver',
	    dearchive: 'Gjenopprett',
	    title: 'Navn',
	    need_a_title: 'Mangler et navn',
	    no_absence_reasons_created: 'Ingen fraværsårsaker opprettet',
	    tooltip_for_hide_title: 'Når "Skjul tittel" er aktivert, er fraværstittelen kun synlig for administratorer og brukeren fraværet gjelder – for andre vises bare "Fravær". Hvis innstillingen deaktiveres, blir tittelen synlig for alle.',
	    title_already_exists: 'Navnet finnes allerede'
	  },
	  en: {
	    absence_reasons: 'Absence reasons',
	    create_absence: 'Create absence reason',
	    hide_title: 'Hide title',
	    archive: 'Archive',
	    dearchive: 'Restore',
	    title: 'Name',
	    need_a_title: 'Missing a name',
	    no_absence_reasons_created: 'No absence reasons created',
	    tooltip_for_hide_title: 'When "Hide title" is enabled, the absence title is only visible to administrators and the user the absence relates to – others will simply see "Absence". If the setting is disabled, the title becomes visible to everyone.',
	    title_already_exists: 'The name already exists'
	  }
	};
	exports.default = {
	  components: { AppToggle: _AppToggle2.default },
	  props: {
	    items: {
	      default: []
	    },
	    theUpdatingReasonId: {
	      default: null
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    tooltipForHideTitle: function tooltipForHideTitle() {
	      return this.i18n['tooltip_for_hide_title'];
	    }
	  }
	};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AnnualNormWithoutKids = __webpack_require__(291);
	
	var _AnnualNormWithoutKids2 = _interopRequireDefault(_AnnualNormWithoutKids);
	
	var _AnnualNormWithKids = __webpack_require__(1198);
	
	var _AnnualNormWithKids2 = _interopRequireDefault(_AnnualNormWithKids);
	
	var _AssignHoursNorm = __webpack_require__(293);
	
	var _AssignHoursNorm2 = _interopRequireDefault(_AssignHoursNorm);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _AnnualNormResult = __webpack_require__(1197);
	
	var _AnnualNormResult2 = _interopRequireDefault(_AnnualNormResult);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AssignHoursEmploymentEnded = __webpack_require__(114);
	
	var _AssignHoursEmploymentEnded2 = _interopRequireDefault(_AssignHoursEmploymentEnded);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DModal: _DModal2.default, AssignHoursEmploymentEnded: _AssignHoursEmploymentEnded2.default,
	    AnnualNormResult: _AnnualNormResult2.default,
	    ModalConfirmation: _ModalConfirmation2.default, AssignHoursNorm: _AssignHoursNorm2.default, AnnualNormWithKids: _AnnualNormWithKids2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, AnnualNormWithoutKids: _AnnualNormWithoutKids2.default
	  },
	  data: function data() {
	    return {
	      isShowEmploymentEnded: false,
	      viewIsResult: false,
	      isTasksView: true,
	      activeUserId: null,
	      allVacationsDays: [],
	      isUpdatingTasks: false,
	      activeNorm: null
	    };
	  },
	
	  computed: {
	    activeNormFormatted: function activeNormFormatted() {
	      return this.activeNorm.filter(function (item) {
	        return !item.title.startsWith('hidden_');
	      }).map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          value: item.title === 'Periode start' || item.title === 'Periode slut' ? (0, _moment2.default)(item.value).format('ll') : item.value
	        });
	      });
	    },
	    isConfirmDeletion: function isConfirmDeletion() {
	      return this.$store.state.subjects.isConfirmDeletion;
	    },
	    itemToDelete: function itemToDelete() {
	      return this.$store.state.subjects.itemToDelete;
	    },
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.tasks;
	    },
	    filteredTasks: function filteredTasks() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'without_kids';
	      });
	    },
	    tasksWithKids: function tasksWithKids() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'with_kids';
	      });
	    },
	    sortedTasks: function sortedTasks() {
	      return this.filteredTasks.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    sortedTasksWithKids: function sortedTasksWithKids() {
	      return this.tasksWithKids.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    tasksInHash: function tasksInHash() {
	      return this.filteredTasks.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    tasksWithKidsInHash: function tasksWithKidsInHash() {
	      return this.tasksWithKids.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      var calIdsWithTasksIds = {};
	      this.sortedTasks.forEach(function (task) {
	        if (task.user_calendar_ids) {
	          task.user_calendar_ids.forEach(function (calid) {
	            if (calid) {
	              if (!calIdsWithTasksIds[calid]) {
	                calIdsWithTasksIds[calid] = [task.id];
	              } else {
	                calIdsWithTasksIds[calid].push(task.id);
	              }
	            }
	          });
	        }
	      });
	      return calIdsWithTasksIds;
	    },
	    tasksWithKidsInUserHash: function tasksWithKidsInUserHash() {
	      var calIdsWithTasksIds = {};
	      this.sortedTasksWithKids.forEach(function (task) {
	        if (task.user_calendar_ids) {
	          task.user_calendar_ids.forEach(function (calid) {
	            if (calid) {
	              if (!calIdsWithTasksIds[calid]) {
	                calIdsWithTasksIds[calid] = [task.id];
	              } else {
	                calIdsWithTasksIds[calid].push(task.id);
	              }
	            }
	          });
	        }
	      });
	      return calIdsWithTasksIds;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    userWithProps: function userWithProps() {
	      var _this = this;
	
	      return this.users.map(function (user) {
	        var userInHash = _this.usersAssignedHoursHash[user.id];
	        var isActiveUser = user.id === _this.activeUserId;
	        var userTasksWithoutKidsIds = _this.tasksInUserHash[user.user_calendar_id];
	        var userTasksWithKidsIds = _this.tasksWithKidsInUserHash[user.user_calendar_id];
	        var userTotalHoursWithoutKids = 0;
	        var userTasksWithoutKids = [];
	        var userTasksWithKids = [];
	        if (userTasksWithoutKidsIds) {
	          userTasksWithoutKids = userTasksWithoutKidsIds.map(function (id) {
	            return _this.tasksInHash[id];
	          });
	          userTotalHoursWithoutKids = userTasksWithoutKidsIds.map(function (hash) {
	            return _this.tasksInHash[hash].hours;
	          }).reduce(function (acc, n) {
	            return acc + n;
	          });
	        }
	        if (userTasksWithKidsIds) {
	          userTasksWithKids = userTasksWithKidsIds.map(function (id) {
	            return _this.tasksWithKidsInHash[id];
	          });
	        }
	        var assignedTotalHours = 0;
	        if (userInHash) {
	          assignedTotalHours = userInHash.assigned_total_hours;
	        }
	
	        return (0, _extends3.default)({}, user, {
	          v_assigned_total_hours: parseFloat(assignedTotalHours).toFixed(2),
	          v_total_without_kids: parseFloat(userTotalHoursWithoutKids).toFixed(2),
	          v_total_with_kids: parseFloat(assignedTotalHours - userTotalHoursWithoutKids).toFixed(2),
	          v_is_active_user: isActiveUser,
	          v_user_tasks_without_kids: userTasksWithoutKids,
	          v_user_tasks_with_kids: userTasksWithKids
	        });
	      });
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.readAssignedHours();
	      this.readSubjects();
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	    }
	  },
	  methods: {
	    setIsShowEmploymentEnded: function setIsShowEmploymentEnded(bool) {
	      this.isShowEmploymentEnded = bool;
	    },
	    readSubjects: function readSubjects() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    },
	    readTasks: function readTasks() {
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	    },
	    updateTasksFromServer: function updateTasksFromServer() {
	      this.isUpdatingTasks = true;
	      this.readTasks();
	    },
	    readAssignedHours: function readAssignedHours() {
	      var schoolObj = {
	        schoolId: this.schoolId,
	        schoolYearId: this.activeSchoolYear.id
	      };
	      this.$store.dispatch('getUsers', this.schoolId, null);
	      this.$store.dispatch('readUsersAssignedHours', schoolObj);
	      if (this.activeUserId) {
	        this.readUserNorm(this.activeUserId);
	      }
	    },
	    readUserNorm: function readUserNorm(userId) {
	      var _this2 = this;
	
	      this.activeNorm = null;
	      _docendo2.default.schoolUserYearRead(this.schoolId, userId, this.activeSchoolYear.name, function (success) {
	        _this2.activeNorm = success.norm ? success.norm : [];
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    setActiveUserId: function setActiveUserId(userId) {
	      if (this.activeUserId === userId) {
	        this.activeUserId = null;
	      } else {
	        this.readUserNorm(userId);
	        this.activeUserId = userId;
	      }
	    },
	    getSchoolDays: function getSchoolDays() {
	      var _this3 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this3.allVacationsDays = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.itemToDelete && this.itemToDelete.itemType === 'task') {
	        this.$store.dispatch('deleteTask', this.itemToDelete);
	        this.$store.commit('setTheDeletedItemId', this.itemToDelete.id);
	      }
	      this.$store.commit('setConfirmDeletion', false);
	      this.$store.commit('setItemToDelete', null);
	    },
	    setUpdatingFromServer: function setUpdatingFromServer() {
	      this.isUpdatingTasks = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.readAssignedHours();
	    this.getSchoolDays();
	    window.addEventListener('vueCRUDSubject', function () {
	      return _this4.updateTasksFromServer();
	    });
	    window.addEventListener('vueDoneLoadingTasks', function () {
	      return _this4.setUpdatingFromServer();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this5 = this;
	
	    window.removeEventListener('vueDoneLoadingTasks', function () {
	      return _this5.setUpdatingFromServer();
	    });
	    window.removeEventListener('vueCRUDSubject', function () {
	      return _this5.updateTasksFromServer();
	    });
	  }
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AssignHoursAllUsersTheadTh = __webpack_require__(113);
	
	var _AssignHoursAllUsersTheadTh2 = _interopRequireDefault(_AssignHoursAllUsersTheadTh);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserTasks = __webpack_require__(44);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _DatePickerRangeShortcuts = __webpack_require__(88);
	
	var _DatePickerRangeShortcuts2 = _interopRequireDefault(_DatePickerRangeShortcuts);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DDropdown: _DDropdown2.default, DatePickerRangeShortcuts: _DatePickerRangeShortcuts2.default, Loader: _Loader2.default, thUser: _AssignHoursAllUsersTheadTh2.default, DatePickerRange: _DatePickerRange2.default, DModal: _DModal2.default, UserTasks: _UserTasks2.default },
	  props: {
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {
	      type: Number,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1,
	      isLoadingUpdatedNumbers: false,
	      usersWithScheduledHours: {},
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      allVacationsDays: [],
	      theUserToShowTasks: null
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    workDayDates: function workDayDates() {
	      var self = this;
	
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      function isNotVacationDay(m) {
	        var idx = self.allVacationsDays.findIndex(function (date) {
	          return (0, _moment2.default)(date.day).format('YYYY-MM-DD') === m;
	        });
	        return idx < 0;
	      }
	
	      var startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m) && isNotVacationDay(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    workDayDatesInPeriod: function workDayDatesInPeriod() {
	      var _this = this;
	
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        dateArray.push(m);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.filter(function (date) {
	        var m = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var idx = _this.workDayDates.indexOf(m);
	        return idx > -1;
	      });
	    },
	    numberOfWorkDays: function numberOfWorkDays() {
	      return this.workDayDates.length;
	    },
	    numberOfWorkDaysInPeriod: function numberOfWorkDaysInPeriod() {
	      return this.workDayDatesInPeriod.length;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    usersWithProps: function usersWithProps() {
	      var _this2 = this;
	
	      return this.users.map(function (user) {
	        var userHours = _this2.usersWithScheduledHours[user.id] || {};
	        var totalHoursAssignedInPeriod = _this2.getAssignedHoursForPeriod(user.v_assigned_total_hours);
	        var totalHoursActual = userHours.actual_total_hours || 0;
	        var totalHoursDiff = totalHoursAssignedInPeriod - totalHoursActual;
	        var withKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_total_with_kids);
	        var withKidsHoursActual = userHours.actual_with_kids_hours || 0;
	        var withKidsDiff = withKidsAssignedForPeriod - withKidsHoursActual;
	        var withoutKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_total_without_kids);
	        var withoutKidsHoursActual = userHours.actual_without_kids_hours || 0;
	        var withoutKidsDiff = withoutKidsAssignedForPeriod - withoutKidsHoursActual;
	        var withAndWithoutKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_assigned_total_hours);
	        var withAndWithoutKidsHoursActual = withKidsHoursActual + withoutKidsHoursActual;
	        var withAndWithoutKidsDiff = withAndWithoutKidsAssignedForPeriod - withAndWithoutKidsHoursActual;
	
	        return (0, _extends3.default)({}, user, {
	          v_total_hours_assigned_in_period: _this2.numToFixed(totalHoursAssignedInPeriod),
	          v_total_hours_actual: _this2.numToFixed(totalHoursActual),
	          v_total_hours_diff: _this2.numToFixed(totalHoursDiff),
	          v_with_kids_assigned_in_period: _this2.numToFixed(withKidsAssignedForPeriod),
	          v_with_kids_actual: _this2.numToFixed(withKidsHoursActual),
	          v_with_kids_diff: _this2.numToFixed(withKidsDiff),
	          v_without_kids_assigned_in_period: _this2.numToFixed(withoutKidsAssignedForPeriod),
	          v_without_kids_actual: _this2.numToFixed(withoutKidsHoursActual),
	          v_without_kids_diff: _this2.numToFixed(withoutKidsDiff),
	          v_with_and_without_kids_assigned_in_period: _this2.numToFixed(withAndWithoutKidsAssignedForPeriod),
	          v_with_and_without_kids_actual: _this2.numToFixed(withAndWithoutKidsHoursActual),
	          v_with_and_without_kids_diff: _this2.numToFixed(withAndWithoutKidsDiff)
	        });
	      });
	    },
	    sortedUsers: function sortedUsers() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.usersWithProps;
	      if (sortKey === 'name') {
	        return this.$helpers.sortArrOnName(data);
	      }
	      return data.sort(function (a, b) {
	        return order < 0 ? a[sortKey] - b[sortKey] : b[sortKey] - a[sortKey];
	      });
	    }
	  },
	  methods: {
	    setTheUserToShowTasks: function setTheUserToShowTasks(user) {
	      if (this.allUsersInHash[user.id]) {
	        this.theUserToShowTasks = this.allUsersInHash[user.id];
	      }
	    },
	    closeTheUserToShowTasks: function closeTheUserToShowTasks() {
	      this.theUserToShowTasks = null;
	    },
	    numToFixed: function numToFixed(num) {
	      return parseFloat(num).toFixed(2);
	    },
	    createTooltip: function createTooltip(sumForYear) {
	      var hoursInYear = 222;
	      var hoursPerDay = sumForYear / hoursInYear;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.numToFixed(hoursPerDay);
	      var hoursForPeriodFixed = this.numToFixed(hoursForPeriod);
	      return '<p><i>N\xE5r du v\xE6lger et andet datointerval end hele \xE5ret, kan du her se, hvor mange timer, der skal planl\xE6gges for medarbejderen i perioden og i gennemsnit per dag. Udregningen tager h\xF8jde for institutionens ferie- og helligdage.</i></p><br></p><p><b>Beregning</b></p><p>For \xE5ret: ' + sumForYear + ' timer / ' + hoursInYear + ' dage = ' + hoursPerDayFixed + ' timer pr. dag</p><p>For perioden: ' + this.numberOfWorkDaysInPeriod + ' arbejdsdage * ' + hoursPerDayFixed + ' timer pr. dag = ' + hoursForPeriodFixed + ' timer</p>';
	    },
	    getAssignedHoursForPeriod: function getAssignedHoursForPeriod(hours) {
	      if (this.isDatesPristine) {
	        return hours;
	      } else {
	        var hoursPerDay = hours / 222;
	        return hoursPerDay * this.numberOfWorkDaysInPeriod;
	      }
	    },
	    sortBy: function sortBy(key) {
	      this.sortKey = key;
	      this.sortOrder = this.sortOrder * -1;
	    },
	    setTheActiveUserInAssignHours: function setTheActiveUserInAssignHours(user) {
	      this.setTheUserToShowTasks(user);
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { '--bgScaleColor': color };
	    },
	    getUsersActualHours: function getUsersActualHours() {
	      var _this3 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') + ' 00:00';
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') + ' 23:59';
	      _docendo2.default.schoolActualHours(this.schoolId, startDate, endDate, null, function (data) {
	        var newUsers = {};
	        for (var i = 0; i < data.length; i++) {
	          newUsers[data[i].user_id] = data[i];
	        }
	        _this3.usersWithScheduledHours = newUsers;
	        _this3.isLoadingUpdatedNumbers = false;
	      });
	    },
	    updateUserHours: function updateUserHours() {
	      var _this4 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      _docendo2.default.schoolRecalculateAll(this.schoolId, function (data) {
	        _this4.getUsersActualHours();
	      }, function (error) {
	        console.log('error', error);
	        _this4.isLoadingUpdatedNumbers = false;
	      });
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    resetDates: function resetDates() {
	      if (this.activeSchoolYear) {
	        this.setDates(this.activeSchoolYear.employee_time_start, this.activeSchoolYear.employee_time_end);
	      }
	    },
	    setDatesFromRange: function setDatesFromRange(dateRange) {
	      this.setDates(dateRange.start, dateRange.end);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.getUsersActualHours();
	    },
	    readVacationDays: function readVacationDays() {
	      var _this5 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this5.allVacationsDays = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.readVacationDays();
	    this.resetDates();
	  }
	};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CreateSubjectForm = __webpack_require__(123);
	
	var _CreateSubjectForm2 = _interopRequireDefault(_CreateSubjectForm);
	
	var _AnnualNormWithoutKids = __webpack_require__(291);
	
	var _AnnualNormWithoutKids2 = _interopRequireDefault(_AnnualNormWithoutKids);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AnnualNormWithoutKids: _AnnualNormWithoutKids2.default, CreateSubjectForm: _CreateSubjectForm2.default },
	  data: function data() {
	    return {
	      isSubjectModal: false,
	      activeCalendar: null,
	      theEditSubject: null,
	      theEditSubjectId: null
	    };
	  },
	
	  computed: {
	    activeCalendarId: function activeCalendarId() {
	      return this.activeCalendar ? this.activeCalendar.id : null;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.$store.getters.kindergartenCalendars;
	    },
	    kindergartenCalendarsWithProps: function kindergartenCalendarsWithProps() {
	      var _this = this;
	
	      return this.kindergartenCalendars.map(function (calendar) {
	        var arrOfSubjects = _this.tasksInCalendarHash[calendar.id] ? _this.tasksInCalendarHash[calendar.id] : [];
	        var subjects = arrOfSubjects.map(function (id) {
	          return _this.subjectsInHash[id];
	        });
	        return (0, _extends3.default)({}, calendar, {
	          v_tasks_with_kids: subjects
	        });
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.subjects;
	    },
	    filteredTasks: function filteredTasks() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'with_kids';
	      });
	    },
	    sortedTasks: function sortedTasks() {
	      return this.filteredTasks.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    tasksInCalendarHash: function tasksInCalendarHash() {
	      var calsWithSubjectIds = {};
	      this.sortedTasks.forEach(function (subject) {
	        var calId = subject.calendar_id;
	        if (!calsWithSubjectIds[calId]) {
	          calsWithSubjectIds[calId] = [subject.id];
	        } else {
	          calsWithSubjectIds[calId].push(subject.id);
	        }
	      });
	      return calsWithSubjectIds;
	    }
	  },
	  methods: {
	    setIsCreate: function setIsCreate(calendar) {
	      this.activeCalendar = calendar;
	      this.isSubjectModal = true;
	    },
	    closeSubjectModal: function closeSubjectModal() {
	      this.activeCalendar = null;
	      this.isSubjectModal = false;
	      this.theEditSubject = null;
	      this.theEditSubjectId = null;
	    },
	    createNewSubject: function createNewSubject(newSubject) {
	      newSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createSubject', newSubject);
	      this.closeSubjectModal();
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.theEditSubject = (0, _assign2.default)({}, editSubject);
	      this.theEditSubjectId = editSubject.id;
	      this.isSubjectModal = true;
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeSubjectModal();
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      this.$store.dispatch('deleteSubject', editSubject);
	      this.closeSubjectModal();
	    }
	  }
	};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SubjectsDistributionTasksCreate = __webpack_require__(125);
	
	var _SubjectsDistributionTasksCreate2 = _interopRequireDefault(_SubjectsDistributionTasksCreate);
	
	var _DSelectCalsIds = __webpack_require__(59);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _vueClickaway = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DSelectCalendarIds: _DSelectCalsIds2.default, CreateTask: _SubjectsDistributionTasksCreate2.default },
	  props: {
	    isWithKids: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      theEditTask: null,
	      isTaskModal: false,
	      activeDSelectShow: false,
	      activeDSelect: null
	    };
	  },
	
	  computed: {
	    theActiveFilter: function theActiveFilter() {
	      return this.isWithKids ? 'with_kids' : 'without_kids';
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.tasks;
	    },
	    filteredTasks: function filteredTasks() {
	      var _this = this;
	
	      if (!this.isWithKids) {
	        return this.tasks.filter(function (task) {
	          return task.subject_type === 'without_kids';
	        });
	      } else {
	        var isTaskInOtherCalendar = function isTaskInOtherCalendar(task) {
	          if (task.belongs_to_calendars.length !== 1) {
	            return false;
	          }
	          var calendarId = task.belongs_to_calendars[0];
	          var cal = _this.allCalendarsInHash[calendarId];
	          return cal && cal.type === 'other';
	        };
	
	        return this.tasks.filter(function (task) {
	          return task.subject_type === 'with_kids' && (task.in_user_calendar || isTaskInOtherCalendar(task));
	        });
	      }
	    },
	    sortedTasks: function sortedTasks() {
	      return this.filteredTasks.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    sortedTasksWithProps: function sortedTasksWithProps() {
	      var _this2 = this;
	
	      return this.sortedTasks.map(function (task) {
	        var userNames = _this2.getUsers(task.user_calendar_ids);
	        return (0, _extends3.default)({}, task, {
	          v_is_active_d_select: _this2.activeDSelect === task.id,
	          v_staff_names: userNames
	        });
	      });
	    }
	  },
	  methods: {
	    getUsers: function getUsers(userCalIds) {
	      var _this3 = this;
	
	      return userCalIds.filter(function (calId) {
	        return _this3.allCalendarsInHash[calId];
	      }).map(function (calId) {
	        return _this3.allCalendarsInHash[calId].name;
	      });
	    },
	    setCreateNewTask: function setCreateNewTask() {
	      this.theEditTask = null;
	      this.isTaskModal = true;
	    },
	    closeUpdateTask: function closeUpdateTask() {
	      this.isTaskModal = false;
	      this.theEditTask = null;
	    },
	    createTask: function createTask(task) {
	      this.isTaskModal = false;
	      task['schoolId'] = this.schoolId;
	      this.$store.dispatch('createTask', task);
	    },
	    setEditTask: function setEditTask(task) {
	      var _this4 = this;
	
	      this.isTaskModal = false;
	      this.theEditTask = task;
	      setTimeout(function (_) {
	        _this4.isTaskModal = true;
	      }, 0);
	    },
	    setActiveDSelect: function setActiveDSelect(task) {
	      if (task.user_calendar_ids.length < 1) {
	        this.activeDSelectShow = true;
	      } else {
	        this.activeDSelectShow = false;
	      }
	      this.activeDSelect = task.id;
	    },
	    closeDSelect: function closeDSelect() {
	      if (!this.activeDSelect) {
	        return;
	      }
	      this.activeDSelect = null;
	    },
	    usersWithEvents: function usersWithEvents(task) {
	      var usersWithEvents = [];
	      task.subjects.forEach(function (subject) {
	        if (subject.has_events) {
	          if (subject.user_calendars.length > 0) {
	            usersWithEvents = subject.user_calendars;
	          } else {
	            usersWithEvents.push(subject.calendar_id);
	          }
	        }
	      });
	      return usersWithEvents;
	    },
	    getUserNames: function getUserNames(calIds) {
	      var _this5 = this;
	
	      return calIds.map(function (calId) {
	        return _this5.allCalendarsInHash[calId] ? _this5.allCalendarsInHash[calId].name : '';
	      });
	    },
	    setSelectedUsers: function setSelectedUsers(users, task) {
	      if (!task) {
	        this.fastFormUsers = users;
	        return;
	      }
	      var belongsToCalendars = [];
	      var userCalendars = [];
	      var isInOtherCalendar = task.belongs_to_calendars[0] && this.allCalendarsInHash[task.belongs_to_calendars[0]] && this.allCalendarsInHash[task.belongs_to_calendars[0]].type === 'other';
	      if (isInOtherCalendar) {
	        belongsToCalendars = [task.belongs_to_calendars[0]];
	        userCalendars = users.map(function (user) {
	          return user.id;
	        });
	      } else {
	        belongsToCalendars = users.map(function (user) {
	          return user.id;
	        });
	      }
	      var updatedTask = {
	        schoolId: task.school_id,
	        schoolYearId: task.school_year_id,
	        id: task.id,
	        name: task.name,
	        color: task.color,
	        hours: task.hours,
	        defaultDuration: task.default_duration,
	        belongsToCalendars: belongsToCalendars,
	        userCalendars: userCalendars
	      };
	      this.updateTask(updatedTask);
	    },
	    updateTask: function updateTask(updatesForTask) {
	      this.$store.dispatch('updateTask', updatesForTask);
	      this.closeUpdateTask();
	    }
	  }
	};

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    steps: {
	      default: 6
	    },
	    stepNum: {
	      default: 3
	    },
	    animate: {
	      default: false
	    }
	  },
	  computed: {
	    stepClass: function stepClass() {
	      return 'css' + this.stepNum + '-' + this.steps;
	    }
	  }
	};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AssignHoursAllUsersTheadTh = __webpack_require__(113);
	
	var _AssignHoursAllUsersTheadTh2 = _interopRequireDefault(_AssignHoursAllUsersTheadTh);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserTasks = __webpack_require__(44);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _DatePickerRangeShortcuts = __webpack_require__(88);
	
	var _DatePickerRangeShortcuts2 = _interopRequireDefault(_DatePickerRangeShortcuts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DatePickerRangeShortcuts: _DatePickerRangeShortcuts2.default, Loader: _Loader2.default, thUser: _AssignHoursAllUsersTheadTh2.default, DatePickerRange: _DatePickerRange2.default, DModal: _DModal2.default, UserTasks: _UserTasks2.default },
	  props: {
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {
	      type: Number,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1,
	      isLoadingUpdatedNumbers: false,
	      usersWithScheduledHours: {},
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      allVacationsDays: [],
	      theUserToShowTasks: null
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    workDayDates: function workDayDates() {
	      var self = this;
	
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      function isNotVacationDay(m) {
	        var idx = self.allVacationsDays.findIndex(function (date) {
	          return (0, _moment2.default)(date.day).format('YYYY-MM-DD') === m;
	        });
	        return idx < 0;
	      }
	
	      var startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m) && isNotVacationDay(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    workDayDatesInPeriod: function workDayDatesInPeriod() {
	      var _this = this;
	
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        dateArray.push(m);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.filter(function (date) {
	        var m = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var idx = _this.workDayDates.indexOf(m);
	        return idx > -1;
	      });
	    },
	    numberOfWorkDays: function numberOfWorkDays() {
	      return this.workDayDates.length;
	    },
	    numberOfWorkDaysInPeriod: function numberOfWorkDaysInPeriod() {
	      return this.workDayDatesInPeriod.length;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    usersWithProps: function usersWithProps() {
	      var _this2 = this;
	
	      return this.users.map(function (user) {
	        var userHours = _this2.usersWithScheduledHours[user.id] || {};
	        var totalHoursAssignedInPeriod = _this2.getAssignedHoursForPeriod(user.v_assigned_total_hours);
	        var totalHoursActual = userHours.actual_total_hours || 0;
	        var totalHoursDiff = totalHoursAssignedInPeriod - totalHoursActual;
	        var withKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_total_with_kids);
	        var withKidsHoursActual = userHours.actual_with_kids_hours || 0;
	        var withKidsDiff = withKidsAssignedForPeriod - withKidsHoursActual;
	        var withoutKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_total_without_kids);
	        var withoutKidsHoursActual = userHours.actual_without_kids_hours || 0;
	        var withoutKidsDiff = withoutKidsAssignedForPeriod - withoutKidsHoursActual;
	        var withAndWithoutKidsAssignedForPeriod = _this2.getAssignedHoursForPeriod(user.v_assigned_total_hours);
	        var withAndWithoutKidsHoursActual = withKidsHoursActual + withoutKidsHoursActual;
	        var withAndWithoutKidsDiff = withAndWithoutKidsAssignedForPeriod - withAndWithoutKidsHoursActual;
	
	        return (0, _extends3.default)({}, user, {
	          v_total_hours_assigned_in_period: _this2.numToFixed(totalHoursAssignedInPeriod),
	          v_total_hours_actual: _this2.numToFixed(totalHoursActual),
	          v_total_hours_diff: _this2.numToFixed(totalHoursDiff),
	          v_with_kids_assigned_in_period: _this2.numToFixed(withKidsAssignedForPeriod),
	          v_with_kids_actual: _this2.numToFixed(withKidsHoursActual),
	          v_with_kids_diff: _this2.numToFixed(withKidsDiff),
	          v_without_kids_assigned_in_period: _this2.numToFixed(withoutKidsAssignedForPeriod),
	          v_without_kids_actual: _this2.numToFixed(withoutKidsHoursActual),
	          v_without_kids_diff: _this2.numToFixed(withoutKidsDiff),
	          v_with_and_without_kids_assigned_in_period: _this2.numToFixed(withAndWithoutKidsAssignedForPeriod),
	          v_with_and_without_kids_actual: _this2.numToFixed(withAndWithoutKidsHoursActual),
	          v_with_and_without_kids_diff: _this2.numToFixed(withAndWithoutKidsDiff)
	        });
	      });
	    },
	    sortedUsers: function sortedUsers() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.usersWithProps;
	      if (sortKey === 'name') {
	        return this.$helpers.sortArrOnName(data);
	      }
	      return data.sort(function (a, b) {
	        return order < 0 ? a[sortKey] - b[sortKey] : b[sortKey] - a[sortKey];
	      });
	    }
	  },
	  methods: {
	    setTheUserToShowTasks: function setTheUserToShowTasks(user) {
	      if (this.allUsersInHash[user.id]) {
	        this.theUserToShowTasks = this.allUsersInHash[user.id];
	      }
	    },
	    closeTheUserToShowTasks: function closeTheUserToShowTasks() {
	      this.theUserToShowTasks = null;
	    },
	    numToFixed: function numToFixed(num) {
	      return parseFloat(num).toFixed(2);
	    },
	    createTooltip: function createTooltip(sumForYear) {
	      var hoursInYear = 222;
	      var hoursPerDay = sumForYear / hoursInYear;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.numToFixed(hoursPerDay);
	      var hoursForPeriodFixed = this.numToFixed(hoursForPeriod);
	      return '<p><i>N\xE5r du v\xE6lger et andet datointerval end hele \xE5ret, kan du her se, hvor mange timer, der skal planl\xE6gges for medarbejderen i perioden og i gennemsnit per dag. Udregningen tager h\xF8jde for institutionens ferie- og helligdage.</i></p><br></p><p><b>Beregning</b></p><p>For \xE5ret: ' + sumForYear + ' timer / ' + hoursInYear + ' dage = ' + hoursPerDayFixed + ' timer pr. dag</p><p>For perioden: ' + this.numberOfWorkDaysInPeriod + ' arbejdsdage * ' + hoursPerDayFixed + ' timer pr. dag = ' + hoursForPeriodFixed + ' timer</p>';
	    },
	    getAssignedHoursForPeriod: function getAssignedHoursForPeriod(hours) {
	      if (this.isDatesPristine) {
	        return hours;
	      } else {
	        var hoursPerDay = hours / 222;
	        return hoursPerDay * this.numberOfWorkDaysInPeriod;
	      }
	    },
	    sortBy: function sortBy(key) {
	      this.sortKey = key;
	      this.sortOrder = this.sortOrder * -1;
	    },
	    setTheActiveUserInAssignHours: function setTheActiveUserInAssignHours(user) {
	      this.setTheUserToShowTasks(user);
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { '--bgScaleColor': color };
	    },
	    getUsersActualHours: function getUsersActualHours() {
	      var _this3 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') + ' 00:00';
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') + ' 23:59';
	      _docendo2.default.schoolActualHours(this.schoolId, startDate, endDate, null, function (data) {
	        var newUsers = {};
	        for (var i = 0; i < data.length; i++) {
	          newUsers[data[i].user_id] = data[i];
	        }
	        _this3.usersWithScheduledHours = newUsers;
	        _this3.isLoadingUpdatedNumbers = false;
	      });
	    },
	    updateUserHours: function updateUserHours() {
	      var _this4 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      _docendo2.default.schoolRecalculateAll(this.schoolId, function (data) {
	        _this4.getUsersActualHours();
	      }, function (error) {
	        console.log('error', error);
	        _this4.isLoadingUpdatedNumbers = false;
	      });
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    resetDates: function resetDates() {
	      if (this.activeSchoolYear) {
	        this.setDates(this.activeSchoolYear.employee_time_start, this.activeSchoolYear.employee_time_end);
	      }
	    },
	    setDatesFromRange: function setDatesFromRange(dateRange) {
	      this.setDates(dateRange.start, dateRange.end);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.getUsersActualHours();
	    },
	    readVacationDays: function readVacationDays() {
	      var _this5 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this5.allVacationsDays = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.readVacationDays();
	    this.resetDates();
	  }
	};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ArbeidsplanSubjects = __webpack_require__(1203);
	
	var _ArbeidsplanSubjects2 = _interopRequireDefault(_ArbeidsplanSubjects);
	
	var _ArbeidsplanAssignHoursNorm = __webpack_require__(1201);
	
	var _ArbeidsplanAssignHoursNorm2 = _interopRequireDefault(_ArbeidsplanAssignHoursNorm);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _AnnualNormResult = __webpack_require__(1199);
	
	var _AnnualNormResult2 = _interopRequireDefault(_AnnualNormResult);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubjectsDistributionTasks = __webpack_require__(334);
	
	var _SubjectsDistributionTasks2 = _interopRequireDefault(_SubjectsDistributionTasks);
	
	var _SubjectsDistributionUserAgreements = __webpack_require__(86);
	
	var _SubjectsDistributionUserAgreements2 = _interopRequireDefault(_SubjectsDistributionUserAgreements);
	
	var _ArbeidsplanUser = __webpack_require__(1204);
	
	var _ArbeidsplanUser2 = _interopRequireDefault(_ArbeidsplanUser);
	
	var _CreateSubjectForm = __webpack_require__(123);
	
	var _CreateSubjectForm2 = _interopRequireDefault(_CreateSubjectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CreateSubjectForm: _CreateSubjectForm2.default,
	    ArbeidsplanUser: _ArbeidsplanUser2.default,
	    SubjectsDistributionUserAgreements: _SubjectsDistributionUserAgreements2.default,
	    SubjectsDistributionTasks: _SubjectsDistributionTasks2.default,
	    AnnualNormResult: _AnnualNormResult2.default,
	    ModalConfirmation: _ModalConfirmation2.default, ArbeidsplanAssignHoursNorm: _ArbeidsplanAssignHoursNorm2.default, ArbeidsplanSubjects: _ArbeidsplanSubjects2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default
	  },
	  data: function data() {
	    return {
	      theEditSubject: null,
	      theEditSubjectId: null,
	      activeCalendar: null,
	      isSubjectModal: false,
	      viewIsResult: false,
	      isTasksView: false,
	      activeUserId: null,
	      allVacationsDays: [],
	      isUpdatingTasks: false,
	      activeNorm: null,
	      activeUserAgreements: ''
	    };
	  },
	
	  computed: {
	    activeCalendarId: function activeCalendarId() {
	      return this.activeCalendar ? this.activeCalendar.id : null;
	    },
	    activeNormFormatted: function activeNormFormatted() {
	      var norm = this.activeNorm ? this.activeNorm : [];
	      return norm.filter(function (item) {
	        return !item.title.startsWith('hidden_');
	      }).map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          value: item.title === 'Periode start' || item.title === 'Periode slut' ? (0, _moment2.default)(item.value).format('ll') : item.value
	        });
	      });
	    },
	    activeUser: function activeUser() {
	      var _this = this;
	
	      return this.userWithProps.find(function (user) {
	        return user.id === _this.activeUserId;
	      });
	    },
	    calendarsInHash: function calendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    isConfirmDeletion: function isConfirmDeletion() {
	      return this.$store.state.subjects.isConfirmDeletion;
	    },
	    itemToDelete: function itemToDelete() {
	      return this.$store.state.subjects.itemToDelete;
	    },
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    subjects: function subjects() {
	      return this.$store.state.subjects.subjects;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasksInHash: function tasksInHash() {
	      return this.$store.getters.tasksInHash;
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      return this.$store.getters.tasksInUserHash;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    userWithProps: function userWithProps() {
	      var _this2 = this;
	
	      return this.users.map(function (user) {
	        var userInHash = _this2.usersAssignedHoursHash[user.id];
	        var isActiveUser = user.id === _this2.activeUserId;
	
	        var userTasksIds = _this2.tasksInUserHash[user.user_calendar_id] ? _this2.tasksInUserHash[user.user_calendar_id] : [];
	        var userAllTypeTasks = userTasksIds.map(function (id) {
	          return _this2.tasksInHash[id];
	        });
	        var tasks = [];
	        var tasksHours = 0;
	
	        var teachingTasks = [];
	        var teachingTaskHours = 0;
	        userAllTypeTasks.forEach(function (task) {
	          if (task.subject_type === 'additional_tasks') {
	            tasks.push((0, _extends3.default)({}, task, { v_hours_label: (task.hours * 1).toFixed(2) }));
	            tasksHours += task.hours * 1;
	          } else if (task.subject_type === 'person_resource' || task.subject_type === 'person_resource_visible' || task.subject_type === 'subject') {
	            teachingTasks.push(task);
	            teachingTaskHours += task.hours * 1;
	          }
	        });
	        var assignedTotalHours = 0;
	        if (userInHash && userInHash.assigned_total_hours) {
	          assignedTotalHours = userInHash.assigned_total_hours;
	        }
	
	        var userSubjectsWithAarsramme = [];
	        var userSubjectsWithIds = _this2.subjectsInUserHash[user.user_calendar_id];
	        var userSubjects = [];
	        if (userSubjectsWithIds) {
	          userSubjects = userSubjectsWithIds.map(function (id) {
	            return _this2.subjectsInHash[id];
	          });
	        }
	        userSubjects = userSubjects.concat(teachingTasks);
	        var userSubjectHours = 0;
	        var userNorm = userInHash && userInHash['norm'] && userInHash['norm'].length > 0 ? userInHash['norm'] : [];
	        var sumOfTeachingReduction = userNorm.filter(function (item) {
	          return item.value && item.title.startsWith('hidden_reduction_teaching');
	        }).reduce(function (accumulator, item) {
	          return accumulator + item.value;
	        }, 0);
	        var totalTeachingPercentage = sumOfTeachingReduction;
	        userSubjectsWithAarsramme = userSubjects.map(function (subject) {
	          userSubjectHours += subject.hours * 1;
	          var subjectPreptime = subject.preparation ? subject.preparation : 741;
	          var calendarName = subject.calendar_id !== user.user_calendar_id ? _this2.calendarsInHash[subject.calendar_id] ? _this2.calendarsInHash[subject.calendar_id]['name'] : '' : '';
	          var teachingPercentage = subject.hours * 1 / subjectPreptime * 100;
	          totalTeachingPercentage += teachingPercentage;
	          return (0, _extends3.default)({}, subject, {
	            v_calendar: calendarName,
	            v_percentage: teachingPercentage,
	            v_percentage_label: teachingPercentage.toFixed(2) + '%',
	            v_hours_label: (subject.hours * 1).toFixed(2)
	          });
	        });
	
	        return (0, _extends3.default)({}, user, {
	          v_assigned_total_hours: parseFloat(assignedTotalHours).toFixed(2),
	          v_total_teaching_percentage: totalTeachingPercentage,
	          v_total_teaching_percentage_label: totalTeachingPercentage.toFixed(2) + '%',
	          v_is_active_user: isActiveUser,
	          v_user_tasks: tasks,
	          v_user_tasks_hours: tasksHours,
	          v_user_tasks_hours_label: parseFloat(tasksHours).toFixed(2),
	          v_user_subjects: userSubjectsWithAarsramme,
	          v_user_subjects_hours: userSubjectHours,
	          v_user_subjects_hours_label: parseFloat(userSubjectHours).toFixed(2)
	        });
	      });
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.readAssignedHours();
	      this.readSubjects();
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	    }
	  },
	  methods: {
	    setEditSubject: function setEditSubject(editSubject) {
	      this.theEditSubject = (0, _assign2.default)({}, editSubject);
	      this.theEditSubjectId = editSubject.id;
	      this.isSubjectModal = true;
	    },
	    createNewSubject: function createNewSubject(newSubject) {
	      newSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createSubject', newSubject);
	      this.closeSubjectModal();
	    },
	    closeSubjectModal: function closeSubjectModal() {
	      this.activeCalendar = null;
	      this.isSubjectModal = false;
	      this.theEditSubject = null;
	      this.theEditSubjectId = null;
	    },
	    setIsCreateSubject: function setIsCreateSubject(calendar) {
	      this.activeCalendar = calendar;
	      this.isSubjectModal = true;
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeSubjectModal();
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      this.$store.dispatch('deleteSubject', editSubject);
	      this.closeSubjectModal();
	    },
	    readSubjects: function readSubjects() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    },
	    readTasks: function readTasks() {
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	    },
	    updateTasksFromServer: function updateTasksFromServer() {
	      this.isUpdatingTasks = true;
	      this.readTasks();
	    },
	    readAssignedHours: function readAssignedHours() {
	      var schoolObj = {
	        schoolId: this.schoolId,
	        schoolYearId: this.activeSchoolYear.id
	      };
	      this.$store.dispatch('getUsers', this.schoolId, null);
	      this.$store.dispatch('readUsersAssignedHours', schoolObj);
	      if (this.activeUserId) {
	        this.readUserNorm(this.activeUserId);
	      }
	    },
	    readUserNorm: function readUserNorm(userId) {
	      var _this3 = this;
	
	      this.activeNorm = '';
	      this.activeUserAgreements = '';
	      _docendo2.default.schoolUserYearRead(this.schoolId, userId, this.activeSchoolYear.name, function (success) {
	        _this3.activeNorm = success.norm ? success.norm : [];
	        _this3.activeUserAgreements = success.agreements ? success.agreements : '';
	        console.log('readUserNorm', success);
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    setActiveUserId: function setActiveUserId(userId) {
	      if (this.activeUserId === userId) {
	        this.activeUserId = null;
	      } else {
	        this.readUserNorm(userId);
	        this.activeUserId = userId;
	      }
	    },
	    getSchoolDays: function getSchoolDays() {
	      var _this4 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this4.allVacationsDays = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.itemToDelete && this.itemToDelete.itemType === 'task') {
	        this.$store.dispatch('deleteTask', this.itemToDelete);
	        this.$store.commit('setTheDeletedItemId', this.itemToDelete.id);
	      }
	      this.$store.commit('setConfirmDeletion', false);
	      this.$store.commit('setItemToDelete', null);
	    },
	    setUpdatingFromServer: function setUpdatingFromServer() {
	      this.isUpdatingTasks = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.readAssignedHours();
	    this.getSchoolDays();
	    window.addEventListener('vueCRUDSubject', function () {
	      return _this5.updateTasksFromServer();
	    });
	    window.addEventListener('vueDoneLoadingTasks', function () {
	      return _this5.setUpdatingFromServer();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this6 = this;
	
	    window.removeEventListener('vueDoneLoadingTasks', function () {
	      return _this6.setUpdatingFromServer();
	    });
	    window.removeEventListener('vueCRUDSubject', function () {
	      return _this6.updateTasksFromServer();
	    });
	  }
	};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AppEIPWYZIWYG = __webpack_require__(45);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _ArbeidsplanAssignHoursNormList = __webpack_require__(1202);
	
	var _ArbeidsplanAssignHoursNormList2 = _interopRequireDefault(_ArbeidsplanAssignHoursNormList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default, filterTags: _TaggingFilter2.default, AppEIPWYZIWYG: _AppEIPWYZIWYG2.default, ArbeidsplanAssignHoursNormList: _ArbeidsplanAssignHoursNormList2.default },
	  props: {
	    tags: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isLocalPoolActivated: {
	      type: Boolean,
	      default: false
	    },
	    prepFactor: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isWarningActive: false,
	      isActive: false,
	      isSaving: false,
	      selectedUsers: [],
	      appliedFilters: [],
	      nettoItems: [],
	      items: [{ id: 'assigned_teaching_hours', name: 'Undervisning', hours: 800, isChecked: false }, { id: 'assigned_additional_task_hours', name: 'Øvrige oppgaver', hours: 400, isChecked: false }, { id: 'assigned_preparation_hours', name: 'Forberedelse', hours: 400, isChecked: false }, { id: 'assigned_pool_hours', name: 'Lokalpulje', hours: 80, isChecked: false }, { id: 'substitute_pool_hours', name: 'Vikartimer', hours: 0, isChecked: false }, { id: 'assigned_club_hours', name: 'SFO-timer', hours: 0, isChecked: false }],
	      originalItems: [],
	      agreements: '',
	      isShowAgreement: false,
	      activeTab: 1,
	      itemsToSave: [],
	      nettoTime: 1687.5,
	      theEditUserNorm: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName']), {
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    usersSortedOnNameWithTags: function usersSortedOnNameWithTags() {
	      return this.usersSortedOnName.map(function (user) {
	        user.tags = user.user_tags;
	        return user;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this = this;
	
	      var passedUsers = this.usersSortedOnName;
	
	      var _loop = function _loop(i) {
	        passedUsers = passedUsers.filter(function (user) {
	          return user.user_tags && user.user_tags.indexOf(_this.appliedFilters[i]) > -1;
	        });
	      };
	
	      for (var i = 0; i < this.appliedFilters.length; i++) {
	        _loop(i);
	      }
	      return passedUsers;
	    },
	    hoursForTeaching: function hoursForTeaching() {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === 'assigned_teaching_hours';
	      });
	      return this.items[idx].hours;
	    }
	  }),
	  methods: {
	    setIsNormModal: function setIsNormModal() {
	      this.isActive = true;
	      if (this.prepFactor) {
	        var thePrep = this.hoursForTeaching * this.prepFactor;
	        var idx = this.items.findIndex(function (hoursItem) {
	          return hoursItem.id === 'assigned_preparation_hours';
	        });
	        this.items[idx].hours = thePrep;
	      }
	    },
	    onUpdatingHours: function onUpdatingHours(item) {
	      if (!this.prepFactor) {
	        return;
	      }
	      if (item.id === 'assigned_teaching_hours') {
	        var thePrep = item.hours * this.prepFactor;
	        var idx = this.items.findIndex(function (hoursItem) {
	          return hoursItem.id === 'assigned_preparation_hours';
	        });
	        this.items[idx].hours = thePrep;
	      }
	    },
	    toggleItem: function toggleItem(idx) {
	      this.items[idx].isChecked = !this.items[idx].isChecked;
	    },
	    isItemToggled: function isItemToggled(idx) {
	      return this.items[idx].isChecked;
	    },
	    setNettoTime: function setNettoTime(time) {
	      this.nettoTime = time;
	    },
	    setItemsToSave: function setItemsToSave(arr) {
	      console.log('setItemsToSave');
	      this.itemsToSave = arr;
	    },
	    getIsActiveTab: function getIsActiveTab(num) {
	      return this.activeTab === num;
	    },
	    setIsShowAgreement: function setIsShowAgreement() {
	      this.isShowAgreement = !this.isShowAgreement;
	    },
	    toggleAll: function toggleAll() {
	      var _this2 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsers.forEach(function (user) {
	          return _this2.selectedUsers.push(user.id);
	        });
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      return idx > -1;
	    },
	    toggleUser: function toggleUser(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      if (idx > -1) {
	        this.selectedUsers.splice(idx, 1);
	      } else {
	        this.selectedUsers.push(user.id);
	      }
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.push(tag);
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	    },
	    close: function close() {
	      this.isActive = false;
	      this.selectedUsers = [];
	    },
	    save: function save() {
	      var _this3 = this;
	
	      if (this.selectedUsers.length < 1) {
	        return;
	      }
	
	      function validateNumber(item) {
	        var itemsNotToValidate = ['hidden_stillingsprosenten', 'Stillingsprosenten', 'Periode', 'hidden_periode_start', 'hidden_periode_end'];
	        if (item.dontValidate || itemsNotToValidate.indexOf(item.title) > -1 || item.title.startsWith('hidden_reduction_teaching')) {
	          return item.value;
	        } else {
	          var val = item.hours * 1;
	          return val.toFixed(1);
	        }
	      }
	
	      this.isSaving = true;
	      var itemsToSave = this.itemsToSave.map(function (item) {
	        return {
	          title: item.title,
	          value: validateNumber(item)
	        };
	      });
	      var data = {
	        norm: itemsToSave,
	        assigned_total_hours: this.nettoTime
	      };
	      if (this.isShowAgreement) {
	        data['agreements'] = this.agreements;
	      }
	      var activatedItems = this.items.filter(function (item) {
	        return item.isChecked;
	      });
	      activatedItems.forEach(function (item) {
	        data[item.id] = item.hours;
	      });
	
	      var dataToSave = this.selectedUsers.map(function (userId) {
	        return {
	          user_id: userId,
	          data: data
	        };
	      });
	      _docendo2.default.bulkSchoolUserYearUpdate(this.schoolId, this.activeSchoolYear.name, dataToSave, function (success) {
	        _this3.reset();
	        _this3.$emit('updateUsersHours');
	        _this3.close();
	        _eventbus2.default.toast = { text: 'Gemt', 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', 'success': false };
	      });
	    },
	    reset: function reset() {
	      this.isSaving = false;
	      this.selectedUsers = [];
	      this.isShowAgreement = false;
	      this.agreements = '';
	      this.items = JSON.parse((0, _stringify2.default)(this.originalItems));
	      this.isWarningActive = false;
	    },
	    updateAgreements: function updateAgreements(val) {
	      this.agreements = val;
	    },
	    readUserNorm: function readUserNorm(user) {
	      var _this4 = this;
	
	      _docendo2.default.schoolUserYearRead(this.schoolId, user.id, this.activeSchoolYear.name, function (success) {
	        _this4.theEditUserNorm = success.norm ? success.norm : [];
	        _this4.userAgreements = success.agreements ? success.agreements : '';
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    editUserNorm: function editUserNorm(user) {
	      this.readUserNorm(user);
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (!this.isLocalPoolActivated) {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === 'assigned_pool_hours';
	      });
	      this.items.splice(idx, 1);
	    }
	  },
	  mounted: function mounted() {
	    this.originalItems = JSON.parse((0, _stringify2.default)(this.items));
	  }
	};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, DateSelector: _DateSelector2.default },
	  props: {
	    schoolYear: {},
	    theEditUserNorm: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isNetto: {
	      default: false,
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      isEditPeriod: false,
	      initStartDate: null,
	      initEndDate: null,
	      startDate: null,
	      endDate: null,
	      employmentPercentage: {
	        id: 'employment_percentage',
	        title: 'Stillingsprosenten',
	        hours: 100,
	        standardHours: 100,
	        unit: '%',
	        isFixed: false
	      },
	      workingHours: {
	        id: 'working_hours',
	        title: 'Årsverk',
	        hours: 1687.5,
	        standardHours: 1687.5,
	        isFixed: true
	      },
	      planleggingsdager: {
	        id: 'planleggingsdager',
	        title: 'Planleggingsdager',
	        hours: 45,
	        standardHours: 45,
	        isFixed: true
	      },
	      teachingPercentage: {
	        id: 'working_hours',
	        title: 'Undervisningsprosent',
	        hours: 100,
	        standardHours: 100,
	        unit: 'percentage',
	        isFixed: true
	      },
	      standardItems: [{
	        id: 'reduction_employee_percentage',
	        title: 'Stillingsprosenten reduksjon',
	        hours: 0,
	        standardHours: 0,
	        unit: '%',
	        isSelected: false,
	        isHide: true
	      }, {
	        id: 'reduction_newly_educated',
	        title: 'Første yrkesåret etter utdanning',
	        hours: 6,
	        standardHours: 6,
	        unit: '%',
	        isSelected: false
	      }, {
	        id: 'reduction_57_60',
	        title: 'Fra 57 år til og med 59 år',
	        hours: 6,
	        standardHours: 6,
	        unit: '%',
	        isSelected: false
	      }, {
	        id: 'reduction_60',
	        title: '60 år og eldre',
	        hours: 12.5,
	        number: 12.5,
	        year_hours_reduction: 37.5,
	        standardHours: 12.5,
	        unit: '%',
	        isSelected: false
	      }],
	      isEdit: false,
	      isAddNew: false,
	      newItemTitle: '',
	      danishHolidays: ['01-01-2022', '10-04-2022', '14-04-2022', '15-04-2022', '17-04-2022', '18-04-2022', '13-05-2022', '26-05-2022', '05-06-2022', '06-06-2022', '05-06-2022', '24-12-2022', '25-12-2022', '26-12-2022', '31-12-2022', '01-01-2023', '02-04-2023', '06-04-2023', '07-04-2023', '09-04-2023', '10-04-2023', '05-05-2023', '18-05-2023', '28-05-2023', '29-05-2023', '24-12-2023', '25-12-2023', '26-12-2023', '31-12-2023', '01-01-2024', '24-03-2024', '28-03-2024', '29-03-2024', '31-03-2024', '01-04-2024', '09-05-2024', '19-05-2024', '20-05-2024', '25-12-2024', '26-12-2024', '01-01-2025', '13-04-2025', '17-04-2025', '18-04-2025', '20-04-2025', '21-04-2025', '29-05-2025', '08-06-2025', '09-06-2025', '25-12-2025', '26-12-2025', '01-01-2026', '29-03-2026', '02-04-2026', '03-04-2026', '05-04-2026', '06-04-2026', '01-05-2026', '14-05-2026', '24-05-2026', '25-05-2026', '05-06-2026', '24-12-2026', '25-12-2026', '26-12-2026', '31-12-2026']
	    };
	  },
	
	  computed: {
	    workingHoursWithoutPlanleggingsdager: function workingHoursWithoutPlanleggingsdager() {
	      return (this.workingHours.hours - this.planleggingsdager.hours).toFixed(2);
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      return (0, _moment2.default)(this.startDate).format('ll') + ' - ' + (0, _moment2.default)(this.endDate).format('ll');
	    },
	    subtractedItems: function subtractedItems() {
	      return this.standardItems.filter(function (item) {
	        return item.isSelected;
	      });
	    },
	    possibleStandardItems: function possibleStandardItems() {
	      return this.standardItems.filter(function (item) {
	        return !item.isSelected && !item.isHide;
	      });
	    },
	    nettoTime: function nettoTime() {
	      return parseFloat(this.workingHours.hours).toFixed(2);
	    },
	    itemsToSave: function itemsToSave() {
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var periodStart = {
	        id: 'period_start',
	        title: 'hidden_periode_start',
	        isChecked: true,
	        value: startDate,
	        hours: startDate
	      };
	      var periodEnd = { id: 'period_end', title: 'hidden_periode_end', isChecked: true, value: endDate, hours: endDate };
	      var periodDates = { title: 'Periode', value: this.dateRangeFormatted };
	      var arr = [periodStart, periodEnd, periodDates];
	      arr.push({ title: this.employmentPercentage.title, value: this.employmentPercentage.hours + '%' });
	      arr.push({ title: 'hidden_stillingsprosenten', hours: this.employmentPercentage.hours });
	      arr.push(this.workingHours);
	      arr.push({ title: this.planleggingsdager.title, hours: this.planleggingsdager.hours * 1 });
	      arr.push({ title: 'Sum af arbedstid i 38 uker', hours: this.workingHoursWithoutPlanleggingsdager * 1 });
	      this.subtractedItems.forEach(function (item) {
	        var hiddenName = 'hidden_reduction_teaching_' + item.id;
	        var hours = item.hours * 1;
	        var value = item.hours + '%';
	        console.log({ value: value });
	        arr.push({ title: hiddenName, value: hours });
	        arr.push({ title: item.title, value: value, dontValidate: true });
	      });
	      return arr;
	    },
	    numberOfSchoolDays: function numberOfSchoolDays() {
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      var startDate = this.startDate;
	      var endDate = this.endDate;
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.length;
	    },
	    isOnlyPartOfSchoolYear: function isOnlyPartOfSchoolYear() {
	      var initStartDateFormatted = this.initStartDate.format('YYYY-MM-DD');
	      var startDateFormatted = this.startDate.format('YYYY-MM-DD');
	      var initEndDateFormatted = this.initEndDate.format('YYYY-MM-DD');
	      var endDateFormatted = this.endDate.format('YYYY-MM-DD');
	      return initStartDateFormatted !== startDateFormatted || initEndDateFormatted !== endDateFormatted;
	    }
	  },
	  watch: {
	    itemsToSave: function itemsToSave() {
	      this.$emit('updated', this.itemsToSave);
	    },
	    nettoTime: function nettoTime() {
	      this.$emit('changedSum', this.nettoTime);
	    },
	    theEditUserNorm: function theEditUserNorm() {
	      var _this = this;
	
	      this.isEdit = true;
	      this.standardItems.forEach(function (standardItem, idx) {
	        _this.standardItems[idx].isSelected = false;
	      });
	      this.initStartAndEndDate();
	      this.theEditUserNorm.forEach(function (normItem) {
	        var normItemHours = normItem.value * 1;
	        switch (normItem.title) {
	          case 'Periode start':
	          case 'hidden_periode_start':
	            _this.setStartDate(normItem.value);
	            break;
	          case 'Periode slut':
	          case 'hidden_periode_end':
	            _this.setEndDate(normItem.value);
	            break;
	          case 'Årsværk':
	            _this.workingHours.title = normItem.title;
	            _this.$emit('onEditNetto');
	            _this.workingHours.hours = normItemHours;
	            break;
	          case 'hidden_stillingsprosenten':
	            _this.employmentPercentage.hours = normItemHours;
	            break;
	          case 'Periode':
	          case 'Stillingsprosenten':
	          case 'Arbejdstid':
	            break;
	          default:
	            var idx = _this.standardItems.findIndex(function (item) {
	              return item.title === normItem.title;
	            });
	            if (idx > -1) {
	              _this.standardItems[idx].hours = normItemHours;
	              _this.standardItems[idx].isSelected = true;
	            } else {
	              _this.addOwn(normItem);
	            }
	            break;
	        }
	      });
	    },
	    numberOfSchoolDays: function numberOfSchoolDays() {
	      this.initData();
	    },
	    isNetto: function isNetto() {
	      if (!this.isEdit) {
	        this.initStartAndEndDate();
	      }
	      this.initData();
	    }
	  },
	  methods: {
	    initData: function initData() {
	      if (this.isEdit) {
	        return;
	      }
	      var hoursInPeriod = 1687.5;
	      if (this.isOnlyPartOfSchoolYear) {
	        hoursInPeriod = parseFloat(this.numberOfSchoolDays * 7.5).toFixed(2);
	      }
	      this.workingHours.hours = hoursInPeriod;
	      this.workingHours.standardHours = hoursInPeriod;
	    },
	    setStartDate: function setStartDate(date) {
	      var _this2 = this;
	
	      this.startDate = date;
	      setTimeout(function (_) {
	        _this2.isEdit = false;
	      });
	    },
	    setEndDate: function setEndDate(date) {
	      var _this3 = this;
	
	      this.endDate = date;
	      setTimeout(function (_) {
	        _this3.isEdit = false;
	      });
	    },
	    employmentPercentageChanged: function employmentPercentageChanged(val) {
	      var percentage = val / 100;
	      this.hoursPerWeekChanged(percentage, true);
	    },
	    hoursPerWeekChanged: function hoursPerWeekChanged(val, changePercentage) {
	      var employmentRate = val;
	      var percentage = employmentRate * 100;
	      if (changePercentage) {
	        percentage = percentage.toFixed(0);
	        this.employmentPercentage.hours = percentage;
	      }
	      this.workingHours.hours = parseFloat(this.workingHours.standardHours * employmentRate).toFixed(2);
	      this.planleggingsdager.hours = parseFloat(this.planleggingsdager.standardHours * employmentRate).toFixed(2);
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === 'reduction_employee_percentage';
	      });
	      if (percentage < 100) {
	        this.standardItems[idx].hours = 100 - percentage;
	        this.standardItems[idx].isSelected = true;
	      } else {
	        this.standardItems[idx].hours = 0;
	        this.standardItems[idx].isSelected = false;
	      }
	    },
	    onEditWorkingHours: function onEditWorkingHours(value) {
	      this.workingHours.standardHours = value;
	      this.workingHours.isFixed = false;
	    },
	    onEditPlanleggingsdager: function onEditPlanleggingsdager(value) {
	      this.planleggingsdager.standardHours = value;
	      this.planleggingsdager.isFixed = false;
	    },
	    setSubtractedItemValue: function setSubtractedItemValue(item, value) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      if (item.userStandardHours) {
	        this.standardItems[idx].userStandardHours = value * 1;
	      }
	      if (!item.standardHours || item.standardHours * 1 !== value * 1) {
	        this.standardItems[idx].isFixed = false;
	      } else {
	        this.standardItems[idx].isFixed = true;
	      }
	    },
	    setItemValue: function setItemValue(item, idx, value) {
	      if (!this.items[idx].standardHours || this.items[idx].standardHours * 1 !== value * 1) {
	        this.items[idx].isFixed = false;
	      } else {
	        this.items[idx].isFixed = true;
	      }
	    },
	    setIsAddNew: function setIsAddNew(bool) {
	      var _this4 = this;
	
	      if (bool) {
	        this.isAddNew = true;
	        this.$nextTick(function (_) {
	          _this4.$refs.add_new_input.focus();
	        });
	      } else {
	        this.isAddNew = false;
	      }
	    },
	    addFromStandard: function addFromStandard(item) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      this.standardItems[idx].isSelected = true;
	    },
	    addOwn: function addOwn(item) {
	      var newItem = {
	        id: 'reduction_' + new Date().getTime(),
	        title: this.newItemTitle,
	        hours: 0,
	        unit: '%',
	        isFixed: false,
	        isSelected: true,
	        isOwn: true
	      };
	      if (item && item.title) {
	        newItem.id = item.title;
	        newItem.title = item.title;
	        newItem.hours = item.value * 1;
	      }
	      this.standardItems.push(newItem);
	      this.reset();
	    },
	    deleteItem: function deleteItem(item) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      if (item.isOwn) {
	        this.standardItems.splice(idx, 1);
	        return;
	      }
	      this.standardItems[idx].hours = this.standardItems[idx].standardHours;
	      this.standardItems[idx].isFixed = true;
	      this.standardItems[idx].isSelected = false;
	    },
	    reset: function reset() {
	      this.newItemTitle = '';
	      this.isAddNew = false;
	    },
	    initStartAndEndDate: function initStartAndEndDate() {
	      this.startDate = (0, _moment2.default)(this.schoolYear.student_time_start);
	      this.endDate = (0, _moment2.default)(this.schoolYear.student_time_end);
	      this.initStartDate = this.startDate.clone();
	      this.initEndDate = this.endDate.clone();
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.initStartAndEndDate();
	  }
	};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isShowOnlySubjectsWithoutTeacher: true
	    };
	  },
	
	  computed: {
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    calendarsWithProps: function calendarsWithProps() {
	      var _this = this;
	
	      return this.klassCalendars.map(function (calendar) {
	        var arrOfSubjects = _this.tasksInCalendarHash[calendar.id] ? _this.tasksInCalendarHash[calendar.id] : [];
	        var subjects = arrOfSubjects.map(function (id) {
	          return _this.subjectsInHash[id];
	        });
	        var subjectsWithProps = subjects.map(function (subject) {
	          return (0, _extends3.default)({}, subject, {
	            v_has_teacher: _this.subjectHasTeachers(subject),
	            v_has_room: _this.subjectHasRoom(subject),
	            v_teacher_names: _this.getTeacherNames(subject)
	          });
	        });
	        return (0, _extends3.default)({}, calendar, {
	          v_subjects: subjectsWithProps
	        });
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.subjects;
	    },
	    filteredTasks: function filteredTasks() {
	      return this.tasks;
	    },
	    sortedTasks: function sortedTasks() {
	      return this.filteredTasks.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    tasksInCalendarHash: function tasksInCalendarHash() {
	      var calsWithSubjectIds = {};
	      this.sortedTasks.forEach(function (subject) {
	        var calId = subject.calendar_id;
	        if (!calsWithSubjectIds[calId]) {
	          calsWithSubjectIds[calId] = [subject.id];
	        } else {
	          calsWithSubjectIds[calId].push(subject.id);
	        }
	      });
	      return calsWithSubjectIds;
	    }
	  },
	  methods: {
	    subjectHasTeachers: function subjectHasTeachers(subject) {
	      var cals = subject.cals ? subject.cals : [];
	      return cals.some(function (cal) {
	        return cal.calendar_type === 'user';
	      });
	    },
	    subjectHasRoom: function subjectHasRoom(subject) {
	      var cals = subject.cals ? subject.cals : [];
	      return cals.some(function (cal) {
	        return cal.calendar_type === 'room';
	      });
	    },
	    getTeacherNames: function getTeacherNames(subject) {
	      var cals = subject.cals ? subject.cals : [];
	      var teachers = cals.filter(function (cal) {
	        return cal.calendar_type === 'user';
	      });
	      return teachers.map(function (cal) {
	        return cal.name;
	      }).join(', ');
	    },
	    setIsCreate: function setIsCreate(calendar) {
	      this.$emit('setIsCreate', calendar);
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.$emit('setEditSubject', editSubject);
	    }
	  }
	};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SubjectsDistributionUserAgreements = __webpack_require__(86);
	
	var _SubjectsDistributionUserAgreements2 = _interopRequireDefault(_SubjectsDistributionUserAgreements);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    user: {
	      type: Object,
	      default: null
	    },
	    activeNorm: {
	      default: null
	    },
	    activeNormFormatted: {
	      type: Array,
	      default: null
	    }
	  },
	  components: { Loader: _Loader2.default, SubjectsDistributionUserAgreements: _SubjectsDistributionUserAgreements2.default },
	  computed: {
	    planfestet: function planfestet() {
	      var teaching = this.user.v_user_subjects_hours ? this.user.v_user_subjects_hours * 1 : 0;
	      var tasks = this.user.v_user_tasks_hours ? this.user.v_user_tasks_hours * 1 : 0;
	      return (teaching + tasks).toFixed(2);
	    },
	    egenDisponibel: function egenDisponibel() {
	      var teaching = this.user.v_user_subjects_hours ? this.user.v_user_subjects_hours * 1 : 0;
	      var tasks = this.user.v_user_tasks_hours ? this.user.v_user_tasks_hours * 1 : 0;
	      var totalHours = this.user.v_assigned_total_hours ? this.user.v_assigned_total_hours * 1 : 0;
	      return (totalHours - tasks - teaching).toFixed(2);
	    }
	  }
	};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _slicedToArray2 = __webpack_require__(38);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(37);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _Tag = __webpack_require__(127);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _AssignHoursAllUsers = __webpack_require__(1206);
	
	var _AssignHoursAllUsers2 = _interopRequireDefault(_AssignHoursAllUsers);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SpinnerButton = __webpack_require__(132);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _vuex = __webpack_require__(13);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UserEventList = __webpack_require__(1384);
	
	var _UserEventList2 = _interopRequireDefault(_UserEventList);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserTasks = __webpack_require__(44);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _AssignHoursNorm = __webpack_require__(293);
	
	var _AssignHoursNorm2 = _interopRequireDefault(_AssignHoursNorm);
	
	var _DatePickerRangeShortcuts = __webpack_require__(88);
	
	var _DatePickerRangeShortcuts2 = _interopRequireDefault(_DatePickerRangeShortcuts);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _SaveTaskOverview = __webpack_require__(1370);
	
	var _SaveTaskOverview2 = _interopRequireDefault(_SaveTaskOverview);
	
	var _PrintTaskOverviews = __webpack_require__(1280);
	
	var _PrintTaskOverviews2 = _interopRequireDefault(_PrintTaskOverviews);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _AssignHoursEmploymentEnded = __webpack_require__(114);
	
	var _AssignHoursEmploymentEnded2 = _interopRequireDefault(_AssignHoursEmploymentEnded);
	
	var _TaskOverviewSettings = __webpack_require__(1371);
	
	var _TaskOverviewSettings2 = _interopRequireDefault(_TaskOverviewSettings);
	
	var _AssignHoursDeactivatePoolsModal = __webpack_require__(1207);
	
	var _AssignHoursDeactivatePoolsModal2 = _interopRequireDefault(_AssignHoursDeactivatePoolsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	
	var I18N = {
	  da: {
	    name: 'Navn',
	    workTime: 'Arbejdstid',
	    assigned: 'Tildelt',
	    scheduled: 'Skemalagt',
	    difference: 'Forskel',
	    teaching: 'Undervisning',
	    otherTasks: 'Øvrige Opgaver',
	    preparation: 'Forberedelse',
	    absence: 'Fravær',
	    substitute: 'Vikartimer',
	    sfo: 'SFO',
	    download: 'Download',
	    download_to_excel: 'Download til Excel',
	    updating_numbesr_you_will_be_notified: 'Opdaterer alle tal, du får en notifikation, når alle tal er opdateret.',
	    show_assigned_title: 'Vis tildelt og forskel',
	    show_in_minutes_title: 'Vis skemalagt i minutter',
	    change_view: 'Ændre visningen',
	    employee_id: 'Medarbejder-ID'
	  },
	  en: {
	    name: 'Name',
	    workTime: 'Work Time',
	    assigned: 'Assigned',
	    scheduled: 'Scheduled',
	    difference: 'Difference',
	    teaching: 'Teaching',
	    otherTasks: 'Other Tasks',
	    preparation: 'Preparation',
	    absence: 'Absence',
	    substitute: 'Substitute',
	    sfo: 'SFO',
	    download: 'Download',
	    download_to_excel: 'Download to Excel',
	    updating_numbers_you_will_be_notified: 'Updating all numbers, you will be notified when everything is updated.',
	    show_assigned_title: 'Show assigned and difference',
	    show_in_minutes_title: 'Show actual hours in minutes',
	    change_view: 'Change view',
	    employee_id: 'Employee id'
	  },
	  nb: {
	    name: 'Navn',
	    workTime: 'Arbeidstid',
	    assigned: 'Tildelt',
	    scheduled: 'Planlagt',
	    difference: 'Forskjell',
	    teaching: 'Undervisning',
	    otherTasks: 'Andre oppgaver',
	    preparation: 'Forberedelse',
	    absence: 'Fravær',
	    substitute: 'Vikartimer',
	    sfo: 'SFO',
	    download: 'Last ned',
	    download_to_excel: 'Last ned til Excel',
	    updating_numbers_you_will_be_notified: 'Oppdaterer alle tall, du vil få en varsling når alle tall er oppdatert.',
	    show_assigned_title: 'Vis tildelt og forskjell',
	    show_in_minutes_title: 'Vis planlagt i minutter',
	    change_view: 'Endre visningen',
	    employee_id: 'Ansatt ID'
	  }
	};
	
	exports.default = {
	  components: {
	    AssignHoursDeactivatePoolsModal: _AssignHoursDeactivatePoolsModal2.default,
	    TaskOverviewSettings: _TaskOverviewSettings2.default,
	    AssignHoursEmploymentEnded: _AssignHoursEmploymentEnded2.default,
	    DDropdown: _DDropdown2.default,
	    PrintTaskOverviews: _PrintTaskOverviews2.default,
	    SaveTaskOverview: _SaveTaskOverview2.default,
	    DatePickerRangeShortcuts: _DatePickerRangeShortcuts2.default,
	    AssignHoursNorm: _AssignHoursNorm2.default,
	    DatePickerRange: _DatePickerRange2.default,
	    UserTasks: _UserTasks2.default, DModal: _DModal2.default, ShowUserAbsence: _UserEventList2.default, tag: _Tag2.default, Spinner: _Loader2.default, filterTags: _TaggingFilter2.default, AllUsers: _AssignHoursAllUsers2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, SpinnerButton: _SpinnerButton2.default
	  },
	  data: function data() {
	    return {
	      isShowTaskOverviewSettings: false,
	      isDeactivatePoolsModalVisible: false,
	      isShowEmploymentEnded: false,
	      isSavingPrepFactor: false,
	      isThePrepFactorActive: false,
	      thePrepFactor: 0.5,
	      isChangePrepFactorModal: false,
	      selectedUsers: [],
	      tags: [],
	      createTagActive: false,
	      searchText: '',
	      appliedFilters: [],
	      usersWithScheduledHours: [],
	      usersWithAssignedHours: [],
	      isInitalLoad: true,
	      activeUserId: null,
	      activeUserEventFilter: 'absence',
	      theUserToShowTasks: null,
	      startDate: null,
	      endDate: null,
	      isLoadingUpdatedNumbers: false,
	      debounceTimer: null,
	      isDownloading: false,
	      allVacationsDays: [],
	      isUpdateBttnLoading: false,
	      isShowPrintTaskOverviewModal: false,
	      isShowSaveVersionTaskOverviewModal: false,
	      isChangeViewModal: false,
	      viewSettings: {
	        show_assigned: {
	          title: 'Show assigned and difference',
	          active: true
	        },
	        show_in_minutes: {
	          title: 'Show actual hours in minutes',
	          active: false
	        }
	      }
	    };
	  },
	
	  filters: {
	    yearFormat: function yearFormat(date) {
	      return (0, _moment2.default)(date).format('L');
	    }
	  },
	  watch: {
	    schoolId: function schoolId() {
	      this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	      this.getTags();
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      this.setEndDate(this.activeSchoolYear.employee_time_end);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    },
	    userSettings: function userSettings(val) {
	      if (val && val.assign_hours_view_setting) {
	        this.updateViewSettingsFromUserSettings();
	      }
	    },
	    schoolPrepFactor: function schoolPrepFactor() {
	      if (this.isChangePrepFactorModal) {
	        this.setIsChangePrepFactorModal(false);
	        this.isSavingPrepFactor = false;
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName', 'teachingHoursPerUser', 'tasksHoursInUserHash', 'preparationHoursInUserHash', 'localPoolHoursInUserHash', 'clubHoursInUserHash', 'schoolId']), {
	    isLoadingSubjects: function isLoadingSubjects() {
	      return this.$store.state.subjects.isLoadingSubjects;
	    },
	    isLoadingTasks: function isLoadingTasks() {
	      return this.$store.state.subjects.isLoadingTasks;
	    },
	    isLoadingSubjectsOrTasks: function isLoadingSubjectsOrTasks() {
	      return this.isLoadingSubjects || this.isLoadingTasks;
	    },
	    usersWithEmployeeId: function usersWithEmployeeId() {
	      return this.usersSortedOnName.filter(function (user) {
	        return user.employee_id;
	      });
	    },
	    viewSettingsI18N: function viewSettingsI18N() {
	      var _this = this;
	
	      var i18nSettings = {};
	      (0, _keys2.default)(this.viewSettings).forEach(function (key) {
	        var setting = (0, _extends3.default)({}, _this.viewSettings[key]);
	        setting.title = _this.i18n[key + '_title'] || setting.title;
	        i18nSettings[key] = setting;
	      });
	      return i18nSettings;
	    },
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    isLocalPoolActivated: function isLocalPoolActivated() {
	      return this.$store.getters.isSchoolFeatureLocalePool;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool ? this.$store.state.activeSchool : window.SCHOOL ? window.SCHOOL : null;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isSchoolDanish: function isSchoolDanish() {
	      return this.activeSchool.country.toLowerCase() === 'dk';
	    },
	    isSchoolFromCO: function isSchoolFromCO() {
	      return this.locale.toLowerCase() === 'en';
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    theUserCanManageAssignedHours: function theUserCanManageAssignedHours() {
	      return this.userHasPermission('can_manage_school');
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    selectedSchoolYear: function selectedSchoolYear() {
	      return this.activeSchoolYear.name;
	    },
	    userTagsToShowSum: function userTagsToShowSum() {
	      if (this.schoolId !== 61551) {
	        return [];
	      }
	      return ['PÆDAGOGER'];
	    },
	    usersForList: function usersForList() {
	      var _this2 = this;
	
	      var getSafe = function getSafe(obj, key) {
	        return obj && obj[key] ? obj[key] : 0;
	      };
	      var toMinutes = function toMinutes(val) {
	        return _this2.viewSettings.show_in_minutes.active ? val * 60 : val;
	      };
	
	      return this.usersSortedOnName.map(function (obj) {
	        var id = obj.id;
	        var calId = obj.user_calendar_id;
	        var isUserPedagog = _this2.userTagsToShowSum.length === 0 ? false : _this2.userTagsToShowSum.some(function (tag) {
	          return obj.user_tags.includes(tag);
	        });
	
	        var assigned = _this2.usersWithAssignedHours[id] || {};
	        var scheduled = _this2.usersWithScheduledHours[id] || {};
	
	        var assignedTotalHours = getSafe(assigned, 'assigned_total_hours');
	        var substitutePoolHours = getSafe(assigned, 'substitute_pool_hours');
	        var totalHoursAssignedInPeriod = getSafe(assigned, 'assigned_total_hours') ? _this2.getAssignedHoursForPeriod(assigned.assigned_total_hours) : 0;
	
	        var assignedTeachingHours = 0;
	        var assignedAdditionalTaskHours = 0;
	        var assignedPreparationHours = 0;
	        var assignedClubHours = 0;
	        var assignedPoolHours = 0;
	        var sumHours = 0;
	        var restHours = 0;
	
	        if (!_this2.isPoolsDeactivated) {
	          assignedTeachingHours = getSafe(assigned, 'assigned_teaching_hours');
	          assignedAdditionalTaskHours = getSafe(assigned, 'assigned_additional_task_hours');
	          assignedPreparationHours = getSafe(assigned, 'assigned_preparation_hours');
	          assignedClubHours = getSafe(assigned, 'assigned_club_hours');
	          assignedPoolHours = getSafe(assigned, 'assigned_pool_hours');
	        } else {
	          assignedTeachingHours = getSafe(_this2.teachingHoursPerUser, calId);
	          assignedAdditionalTaskHours = getSafe(_this2.tasksHoursInUserHash, calId);
	          assignedPreparationHours = _this2.schoolPrepFactor ? assignedTeachingHours * _this2.schoolPrepFactor : getSafe(_this2.preparationHoursInUserHash, calId);
	          assignedClubHours = getSafe(_this2.clubHoursInUserHash, calId);
	          assignedPoolHours = getSafe(_this2.localPoolHoursInUserHash, calId);
	          sumHours = assignedTeachingHours + assignedAdditionalTaskHours + assignedPreparationHours + assignedClubHours + assignedPoolHours;
	          restHours = assignedTotalHours - sumHours;
	        }
	
	        var actualTeachingHours = getSafe(scheduled, 'actual_teaching_hours');
	        var actualSubstituteHours = getSafe(scheduled, 'actual_substitute_hours');
	        var actualAbsenceHours = getSafe(scheduled, 'actual_absence_hours');
	        var actualAdditionalTaskHours = getSafe(scheduled, 'actual_additional_task_hours');
	        var actualPreparationHours = getSafe(scheduled, 'actual_preparation_hours');
	        var actualClubHours = getSafe(scheduled, 'actual_club_hours');
	        var actualPoolHours = getSafe(scheduled, 'actual_pool_hours');
	
	        var actualTotalHours = isUserPedagog ? actualSubstituteHours + actualTeachingHours + actualAdditionalTaskHours + actualPreparationHours + actualClubHours + actualPoolHours : getSafe(scheduled, 'actual_total_hours');
	
	        actualTeachingHours = toMinutes(actualTeachingHours);
	        actualSubstituteHours = toMinutes(actualSubstituteHours);
	        actualAbsenceHours = toMinutes(actualAbsenceHours);
	        actualAdditionalTaskHours = toMinutes(actualAdditionalTaskHours);
	        actualPreparationHours = toMinutes(actualPreparationHours);
	        actualClubHours = toMinutes(actualClubHours);
	        actualPoolHours = toMinutes(actualPoolHours);
	        actualTotalHours = toMinutes(actualTotalHours);
	
	        var user = {
	          id: id,
	          img: obj.default_thumb_url,
	          name: obj.name,
	          tags: obj.user_tags,
	          v_total_hours_assigned_in_period: _this2.humanizeNumber(totalHoursAssignedInPeriod),
	          assigned_total_hours: _this2.humanizeNumber(assignedTotalHours),
	          actual_total_hours: _this2.humanizeNumber(actualTotalHours),
	          diff_total_hours: _this2.humanizeNumber(totalHoursAssignedInPeriod - actualTotalHours),
	          assigned_teaching_hours: _this2.humanizeNumber(assignedTeachingHours),
	          actual_teaching_hours: _this2.humanizeNumber(actualTeachingHours),
	          diff_teaching_hours: _this2.humanizeNumber(assignedTeachingHours - actualTeachingHours),
	          substitute_pool_hours: _this2.humanizeNumber(substitutePoolHours),
	          actual_substitute_hours: _this2.humanizeNumber(actualSubstituteHours),
	          diff_substitute_hours: _this2.humanizeNumber(substitutePoolHours - actualSubstituteHours),
	          actual_absence_hours: _this2.humanizeNumber(actualAbsenceHours),
	          assigned_additional_task_hours: _this2.humanizeNumber(assignedAdditionalTaskHours),
	          actual_additional_task_hours: _this2.humanizeNumber(actualAdditionalTaskHours),
	          diff_additional_task_hours: _this2.humanizeNumber(assignedAdditionalTaskHours - actualAdditionalTaskHours),
	          assigned_preparation_hours: _this2.humanizeNumber(assignedPreparationHours),
	          actual_preparation_hours: _this2.humanizeNumber(actualPreparationHours),
	          diff_preparation_hours: _this2.humanizeNumber(assignedPreparationHours - actualPreparationHours),
	          assigned_club_hours: _this2.humanizeNumber(assignedClubHours),
	          actual_club_hours: _this2.humanizeNumber(actualClubHours),
	          diff_club_hours: _this2.humanizeNumber(assignedClubHours - actualClubHours),
	          assigned_pool_hours: _this2.humanizeNumber(assignedPoolHours),
	          actual_pool_hours: _this2.humanizeNumber(actualPoolHours),
	          diff_pool_hours: _this2.humanizeNumber(assignedPoolHours - actualPoolHours),
	          rest_hours: _this2.humanizeNumber(restHours),
	          sum_hours: _this2.humanizeNumber(sumHours)
	        };
	
	        if (_this2.usersWithEmployeeId.length > 0) {
	          user.employee_id = obj.employee_id || null;
	        }
	        if (isUserPedagog) {
	          user['vIsPedagogog'] = true;
	        }
	
	        return user;
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this3 = this;
	
	      return this.usersForList.filter(function (user) {
	        return user.name.match(new RegExp(_this3.searchText, 'i'));
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this4 = this;
	
	      var passedUsers = this.searchedUsers;
	
	      var _loop = function _loop(i) {
	        passedUsers = passedUsers.filter(function (user) {
	          return user.tags.indexOf(_this4.appliedFilters[i]) > -1;
	        });
	      };
	
	      for (var i = 0; i < this.appliedFilters.length; i++) {
	        _loop(i);
	      }
	      return this.$helpers.sortArrOnName(passedUsers);
	    },
	    isLoadingUsers: function isLoadingUsers() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    dataToExcel: function dataToExcel() {
	      var _this5 = this;
	
	      var users = this.filteredUsers.map(function (user) {
	        var userObject = {
	          'name': user.name,
	          'assigned_1': parseFloat(_this5.humanizeNumber(user.assigned_total_hours)),
	          'scheduled_1': parseFloat(user.actual_total_hours),
	          'diff_1': parseFloat(user.diff_total_hours),
	          'assigned_2': parseFloat(user.assigned_teaching_hours),
	          'scheduled_2': parseFloat(user.actual_teaching_hours),
	          'diff_2': parseFloat(user.diff_teaching_hours),
	          'assigned_3': parseFloat(user.assigned_additional_task_hours),
	          'scheduled_3': parseFloat(user.actual_additional_task_hours),
	          'diff_3': parseFloat(user.diff_additional_task_hours),
	          'assigned_4': parseFloat(user.assigned_preparation_hours),
	          'scheduled_4': parseFloat(user.actual_preparation_hours),
	          'diff_4': parseFloat(user.diff_preparation_hours),
	          'scheduled_5': parseFloat(user.actual_absence_hours),
	          'assigned_6': parseFloat(user.substitute_pool_hours),
	          'scheduled_6': parseFloat(user.actual_substitute_hours),
	          'diff_6': parseFloat(user.diff_substitute_hours),
	          'assigned_7': parseFloat(user.assigned_club_hours),
	          'scheduled_7': parseFloat(user.actual_club_hours),
	          'diff_7': parseFloat(user.diff_club_hours)
	        };
	
	        if (_this5.usersWithEmployeeId.length > 0) {
	          userObject['employee_id'] = user['employee_id'] ? user['employee_id'] : null;
	        }
	        return userObject;
	      });
	      var baseHeaders = {
	        'name': '',
	        'assigned_1': '',
	        'scheduled_1': '',
	        'diff_1': '',
	        'assigned_2': '',
	        'scheduled_2': '',
	        'diff_2': '',
	        'assigned_3': '',
	        'scheduled_3': '',
	        'diff_3': '',
	        'assigned_4': '',
	        'scheduled_4': '',
	        'diff_4': '',
	        'scheduled_5': '',
	        'assigned_6': '',
	        'scheduled_6': '',
	        'diff_6': '',
	        'assigned_7': '',
	        'scheduled_7': '',
	        'diff_7': ''
	      };
	
	      if (this.usersWithEmployeeId.length > 0) {
	        baseHeaders = (0, _extends3.default)({ 'employee_id': 'Employee ID' }, baseHeaders);
	      }
	
	      var headersRow1 = (0, _keys2.default)(baseHeaders).reduce(function (accumulator, currentKey) {
	        accumulator[currentKey] = '';
	        return accumulator;
	      }, {});
	
	      var headersRow2 = (0, _extends3.default)({}, baseHeaders);
	      users.unshift(headersRow2, headersRow1);
	      return users;
	    },
	    workDayDates: function workDayDates() {
	      var self = this;
	
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      function isNotVacationDay(m) {
	        var idx = self.allVacationsDays.findIndex(function (date) {
	          return (0, _moment2.default)(date.day).format('YYYY-MM-DD') === m;
	        });
	        return idx < 0;
	      }
	
	      var startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m) && isNotVacationDay(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    workDayDatesInPeriod: function workDayDatesInPeriod() {
	      var _this6 = this;
	
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        dateArray.push(m);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.filter(function (date) {
	        var m = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var idx = _this6.workDayDates.indexOf(m);
	        return idx > -1;
	      });
	    },
	    numberOfWorkDays: function numberOfWorkDays() {
	      return this.workDayDates.length;
	    },
	    numberOfWorkDaysInPeriod: function numberOfWorkDaysInPeriod() {
	      return this.workDayDatesInPeriod.length;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    schoolPrepFactor: function schoolPrepFactor() {
	      return this.schoolSettings && this.schoolSettings['prepFactor'] ? this.schoolSettings['prepFactor'] : null;
	    },
	    schoolThresholdToHideTaskHours: function schoolThresholdToHideTaskHours() {
	      return this.schoolSettings && this.schoolSettings['thresholdToHideTaskHours'] ? this.schoolSettings['thresholdToHideTaskHours'] : null;
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return this.schoolSettings && this.schoolSettings['deactivatePools'] ? this.schoolSettings['deactivatePools'] : false;
	    }
	  }),
	  methods: {
	    setIsShowEmploymentEnded: function setIsShowEmploymentEnded(bool) {
	      this.isShowEmploymentEnded = bool;
	    },
	    setIsThePrepFactorActive: function setIsThePrepFactorActive() {
	      var _this7 = this;
	
	      this.isThePrepFactorActive = !this.isThePrepFactorActive;
	      if (this.isThePrepFactorActive) {
	        this.$nextTick(function (_) {
	          _this7.$refs.the_prep_factor_input.focus();
	        });
	      }
	    },
	    savePrepFactor: function savePrepFactor() {
	      this.isSavingPrepFactor = true;
	      if (!this.isThePrepFactorActive) {
	        this.$store.dispatch('deleteSchoolSetting', 'prepFactor');
	      } else {
	        var val = this.thePrepFactor * 1;
	        if (isNaN(Number(val))) {
	          _eventbus2.default.toast = { text: 'Kan ikke gemme. Skal være et tal', 'success': false };
	          this.isSavingPrepFactor = false;
	          return;
	        }
	        this.$store.dispatch('updateSchoolSettings', { 'prepFactor': val });
	      }
	    },
	    setIsChangePrepFactorModal: function setIsChangePrepFactorModal(bool) {
	      this.isChangePrepFactorModal = bool;
	      if (bool && this.schoolPrepFactor) {
	        this.thePrepFactor = this.schoolPrepFactor;
	        this.isThePrepFactorActive = true;
	      }
	    },
	    setIsDeactivatePoolsModalVisible: function setIsDeactivatePoolsModalVisible(bool) {
	      this.isDeactivatePoolsModalVisible = bool;
	    },
	    reReadNumbers: function reReadNumbers() {
	      this.isDeactivatePoolsModalVisible = false;
	      this.getUsersHours();
	      this.readSubjectsAndTasks();
	    },
	    updateViewSettingsFromUserSettings: function updateViewSettingsFromUserSettings() {
	      var _this8 = this;
	
	      var val = this.userSettings;
	      if (val && val.assign_hours_view_setting) {
	        var settingsChanged = (0, _entries2.default)(val.assign_hours_view_setting).some(function (_ref) {
	          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	              key = _ref2[0],
	              setting = _ref2[1];
	
	          if (!_this8.viewSettings[key]) return true;
	          return _this8.viewSettings[key].active !== setting.active || _this8.viewSettings[key].title !== setting.title;
	        }) || (0, _keys2.default)(this.viewSettings).length !== (0, _keys2.default)(val.assign_hours_view_setting).length;
	
	        if (settingsChanged) {
	          this.viewSettings = JSON.parse((0, _stringify2.default)(val.assign_hours_view_setting));
	        }
	      }
	    },
	    setViewSetting: function setViewSetting(key) {
	      if (this.viewSettings[key]) {
	        this.viewSettings[key].active = !this.viewSettings[key].active;
	      }
	
	      this.$store.dispatch('updateUserSettings', { 'assign_hours_view_setting': this.viewSettings });
	    },
	    setIsChangeViewModal: function setIsChangeViewModal() {
	      if (this.isChangeViewModal) {
	        this.isChangeViewModal = false;
	      } else {
	        this.isChangeViewModal = true;
	      }
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this9 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.download();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this9.download();
	          }
	        }, 500);
	      }
	    },
	    download: function download() {
	      var data = XLSX.utils.json_to_sheet(this.dataToExcel, { skipHeader: true });
	      if (this.usersWithEmployeeId.length === 0) {
	        data.A1 = { t: 's', v: this.i18n.name };
	        data.B1 = { t: 's', v: this.i18n.workTime };
	        data.B2 = { t: 's', v: this.i18n.assigned };
	        data.C2 = { t: 's', v: this.i18n.scheduled };
	        data.D2 = { t: 's', v: this.i18n.difference };
	        data.E1 = { t: 's', v: this.i18n.teaching };
	        data.E2 = { t: 's', v: this.i18n.assigned };
	        data.F2 = { t: 's', v: this.i18n.scheduled };
	        data.G2 = { t: 's', v: this.i18n.difference };
	        data.H1 = { t: 's', v: this.i18n.otherTasks };
	        data.H2 = { t: 's', v: this.i18n.assigned };
	        data.I2 = { t: 's', v: this.i18n.scheduled };
	        data.J2 = { t: 's', v: this.i18n.difference };
	        data.K1 = { t: 's', v: this.i18n.preparation };
	        data.K2 = { t: 's', v: this.i18n.assigned };
	        data.L2 = { t: 's', v: this.i18n.scheduled };
	        data.M2 = { t: 's', v: this.i18n.difference };
	        data.N1 = { t: 's', v: this.i18n.absence };
	        data.N2 = { t: 's', v: this.i18n.scheduled };
	        data.O1 = { t: 's', v: this.i18n.substitute };
	        data.O2 = { t: 's', v: this.i18n.assigned };
	        data.P2 = { t: 's', v: this.i18n.scheduled };
	        data.Q2 = { t: 's', v: this.i18n.difference };
	        data.R1 = { t: 's', v: this.i18n.sfo };
	        data.R2 = { t: 's', v: this.i18n.assigned };
	        data.S2 = { t: 's', v: this.i18n.scheduled };
	        data.T2 = { t: 's', v: this.i18n.difference };
	
	        var merge = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } }, { s: { r: 0, c: 4 }, e: { r: 0, c: 6 } }, { s: { r: 0, c: 7 }, e: { r: 0, c: 9 } }, { s: { r: 0, c: 10 }, e: { r: 0, c: 12 } }, { s: { r: 0, c: 14 }, e: { r: 0, c: 16 } }, { s: { r: 0, c: 17 }, e: { r: 0, c: 19 } }];
	        data['!merges'] = merge;
	      } else {
	        data.A1 = { t: 's', v: this.i18n.employee_id };
	        data.B1 = { t: 's', v: this.i18n.name };
	        data.C1 = { t: 's', v: this.i18n.workTime };
	        data.C2 = { t: 's', v: this.i18n.assigned };
	        data.D2 = { t: 's', v: this.i18n.scheduled };
	        data.E2 = { t: 's', v: this.i18n.difference };
	        data.F1 = { t: 's', v: this.i18n.teaching };
	        data.F2 = { t: 's', v: this.i18n.assigned };
	        data.G2 = { t: 's', v: this.i18n.scheduled };
	        data.H2 = { t: 's', v: this.i18n.difference };
	        data.I1 = { t: 's', v: this.i18n.otherTasks };
	        data.I2 = { t: 's', v: this.i18n.assigned };
	        data.J2 = { t: 's', v: this.i18n.scheduled };
	        data.K2 = { t: 's', v: this.i18n.difference };
	        data.L1 = { t: 's', v: this.i18n.preparation };
	        data.L2 = { t: 's', v: this.i18n.assigned };
	        data.M2 = { t: 's', v: this.i18n.scheduled };
	        data.N2 = { t: 's', v: this.i18n.difference };
	        data.O1 = { t: 's', v: this.i18n.absence };
	        data.O2 = { t: 's', v: this.i18n.scheduled };
	        data.P1 = { t: 's', v: this.i18n.substitute };
	        data.P2 = { t: 's', v: this.i18n.assigned };
	        data.Q2 = { t: 's', v: this.i18n.scheduled };
	        data.R2 = { t: 's', v: this.i18n.difference };
	        data.S1 = { t: 's', v: this.i18n.sfo };
	        data.S2 = { t: 's', v: this.i18n.assigned };
	        data.T2 = { t: 's', v: this.i18n.scheduled };
	        data.U2 = { t: 's', v: this.i18n.difference };
	
	        var _merge = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, { s: { r: 0, c: 2 }, e: { r: 0, c: 4 } }, { s: { r: 0, c: 5 }, e: { r: 0, c: 7 } }, { s: { r: 0, c: 8 }, e: { r: 0, c: 10 } }, { s: { r: 0, c: 11 }, e: { r: 0, c: 13 } }, { s: { r: 0, c: 14 }, e: { r: 0, c: 14 } }, { s: { r: 0, c: 15 }, e: { r: 0, c: 17 } }, { s: { r: 0, c: 18 }, e: { r: 0, c: 20 } }];
	        data['!merges'] = _merge;
	      }
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, data, 'data');
	      XLSX.writeFile(wb, 'docendo_tildel_timer.xlsx');
	      this.isDownloading = false;
	    },
	    getAssignedHoursForPeriod: function getAssignedHoursForPeriod(hours) {
	      if (this.isDatesPristine) {
	        return hours;
	      } else {
	        var hoursPerDay = hours / this.numberOfWorkDays;
	        return hoursPerDay * this.numberOfWorkDaysInPeriod;
	      }
	    },
	    humanizeNumber: function humanizeNumber(num) {
	      return parseFloat(num).toFixed(1);
	    },
	    debounceSearch: function debounceSearch(event) {
	      var _this10 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this10.searchText = event.target.value;
	      }, 400);
	    },
	    resetDates: function resetDates() {
	      this.setEndDate(this.activeSchoolYear.employee_time_end, false);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    },
	    setDatesFromRange: function setDatesFromRange(dateRange) {
	      this.setDates(dateRange.start, dateRange.end);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.getUsersActualHours();
	    },
	    setStartDate: function setStartDate(date) {
	      this.startDate = date;
	      if ((0, _moment2.default)(date).isValid()) {
	        this.getUsersHours();
	      }
	    },
	    setEndDate: function setEndDate(date, isCallServer) {
	      this.endDate = date;
	      if (!isCallServer) {
	        return;
	      }
	      if ((0, _moment2.default)(date).isValid()) {
	        this.getUsersHours();
	      }
	    },
	    setTheUserToShowTasks: function setTheUserToShowTasks(user) {
	      if (this.allUsersInHash[user.id]) {
	        this.theUserToShowTasks = this.allUsersInHash[user.id];
	      }
	    },
	    closeTheUserToShowTasks: function closeTheUserToShowTasks() {
	      this.theUserToShowTasks = null;
	    },
	    setActiveUser: function setActiveUser(userAndFilter) {
	      this.activeUserId = userAndFilter.user.id;
	      this.activeUserEventFilter = userAndFilter.filter;
	    },
	    updateUserHours: function updateUserHours() {
	      var _this11 = this;
	
	      _eventbus2.default.toast = { text: this.i18n['updating_numbesr_you_will_be_notified'], 'success': false };
	      if (this.isUpdateBttnLoading) {
	        return;
	      }
	      this.isUpdateBttnLoading = true;
	      _docendo2.default.schoolRecalculateAll(this.schoolId, function (data) {
	        _this11.getUsersHours();
	        _this11.isUpdateBttnLoading();
	      }, function (error) {
	        console.log('error', error);
	      });
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.appliedFilters.push(tag);
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	    },
	    removeAllSelectedUsers: function removeAllSelectedUsers() {
	      this.selectedUsers = [];
	      this.createTagActive = false;
	    },
	    setUser: function setUser(user, idx) {
	      if (this.selectedUsers.indexOf(user.id) > -1) {
	        this.selectedUsers.splice(this.selectedUsers.indexOf(user.id), 1);
	      } else {
	        this.selectedUsers.push(user.id);
	      }
	    },
	    setAllUsersSelected: function setAllUsersSelected() {
	      this.selectedUsers = [];
	      for (var i = 0; i < this.filteredUsers.length; i++) {
	        this.selectedUsers.push(this.filteredUsers[i].id);
	      }
	    },
	    updatedUser: function updatedUser(user) {
	      var id = user.user_id.toString();
	      this.$set(this.usersWithAssignedHours, id, user);
	    },
	    getTags: function getTags() {
	      var _this12 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this12.tags = data;
	      });
	    },
	    getUsersActualHours: function getUsersActualHours() {
	      var _this13 = this;
	
	      this.isLoadingUpdatedNumbers = true;
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') + ' 00:00';
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') + ' 23:59';
	      _docendo2.default.schoolActualHours(this.schoolId, startDate, endDate, null, function (data) {
	        var newUsers = {};
	        for (var i = 0; i < data.length; i++) {
	          newUsers[data[i].user_id] = data[i];
	        }
	        _this13.usersWithScheduledHours = newUsers;
	        _this13.isLoadingUpdatedNumbers = false;
	      });
	    },
	    getUsersHours: function getUsersHours() {
	      var _this14 = this;
	
	      this.getUsersActualHours();
	      _docendo2.default.schoolAssignedHours(this.schoolId, this.selectedSchoolYear, null, function (data) {
	        var newUsers = {};
	        for (var i = 0; i < data.length; i++) {
	          newUsers[data[i].user_id] = data[i];
	        }
	        _this14.usersWithAssignedHours = newUsers;
	        _this14.isInitalLoad = false;
	      });
	      this.readSubjectsAndTasks();
	    },
	    readSubjectsAndTasks: function readSubjectsAndTasks() {
	      if (this.isPoolsDeactivated) {
	        this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	        this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	      }
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    readVacationDays: function readVacationDays() {
	      var _this15 = this;
	
	      _docendo2.default.schoolVacationDaysRead(window.SCHOOL.id, function (success) {
	        if (success.status !== 'error') {
	          _this15.allVacationsDays = success;
	        }
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      } else {
	        return true;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUsersFromSchoolId', this.activeSchool.id);
	    this.readVacationDays();
	    this.getTags();
	  },
	  mounted: function mounted() {
	    if (this.activeSchoolYear) {
	      this.setEndDate(this.activeSchoolYear.employee_time_end, false);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    }
	    this.updateViewSettingsFromUserSettings();
	  }
	};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _AssignHoursAllUsersTheadTh = __webpack_require__(113);
	
	var _AssignHoursAllUsersTheadTh2 = _interopRequireDefault(_AssignHoursAllUsersTheadTh);
	
	var _AssingHoursAllUsersUserPerf = __webpack_require__(1209);
	
	var _AssingHoursAllUsersUserPerf2 = _interopRequireDefault(_AssingHoursAllUsersUserPerf);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _core = __webpack_require__(18);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { Loader: _Loader2.default, thUser: _AssignHoursAllUsersTheadTh2.default, trUser: _AssingHoursAllUsersUserPerf2.default },
	  props: {
	    theUserCanManageAssignedHours: {
	      default: false
	    },
	    schoolid: {},
	    users: {
	      type: Array,
	      default: []
	    },
	    isDatesPristine: {
	      type: Boolean,
	      default: true
	    },
	    isLocalPoolActivated: {
	      type: Boolean,
	      default: false
	    },
	    numberOfWorkDaysInPeriod: {
	      required: true
	    },
	    numberOfWorkDays: {
	      required: true
	    },
	    locale: {
	      default: 'en'
	    },
	    viewSettings: {
	      type: Object
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    },
	    prepFactor: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1,
	      theEditNumberUserId: null,
	      theEditNumberType: '',
	      theEditNumberNumber: 0,
	      isDropdownPopperDone: false,
	      isUpdatingNumber: false
	    };
	  },
	
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	        el.select();
	      }
	    }
	  },
	  computed: {
	    numberOfCols: function numberOfCols() {
	      var isShowAssignedActivated = this.viewSettings['show_assigned']['active'];
	      return isShowAssignedActivated ? 3 : 1;
	    },
	    isSFOActive: function isSFOActive() {
	      return this.$store.getters.isSchoolSFOActive;
	    },
	    filteredData: function filteredData() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.users;
	      if (sortKey && sortKey !== 'name') {
	        data = data.sort(function (a, b) {
	          a = a[sortKey];
	          b = b[sortKey];
	          if (order < 0) {
	            return a - b;
	          } else {
	            return b - a;
	          }
	        });
	      } else {
	        return this.$helpers.sortArrOnName(data);
	      }
	      return data;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isSchoolYearWithNewEmploymentDeal: function isSchoolYearWithNewEmploymentDeal() {
	      return (0, _moment2.default)(this.$store.state.localActivatedSchoolYear.employee_time_start).isAfter('2021-01-01') || (0, _moment2.default)(this.$store.state.localActivatedSchoolYear.student_time_start).isAfter('2021-01-01');
	    }
	  },
	  methods: {
	    createPopper: function createPopper(parentPopper, childPopper) {
	      parentPopper.appendChild(childPopper);
	    },
	    setOpenEdit: function setOpenEdit(obj) {
	      var _this = this;
	
	      this.isDropdownPopperDone = false;
	      this.theEditNumberUserId = obj.userId;
	      this.theEditNumberType = obj.type;
	      this.theEditNumberNumber = obj.number;
	      this.$nextTick(function (_) {
	        _this.createPopper(obj.evt.target, _this.$refs.popper_child);
	        _this.isDropdownPopperDone = true;
	      });
	    },
	    sortBy: function sortBy(key) {
	      this.sortKey = key;
	      this.sortOrder = this.sortOrder * -1;
	    },
	    updatedUser: function updatedUser(user) {
	      this.$emit('updatedUser', user);
	    },
	    setActiveUser: function setActiveUser(userAndFilter) {
	      this.$emit('setActiveUser', userAndFilter);
	    },
	    setTheUserToShowTasks: function setTheUserToShowTasks(user) {
	      this.$emit('setTheUserToShowTasks', user);
	    },
	    closeEditing: function closeEditing() {
	      this.isDropdownPopperDone = false;
	      this.theEditNumberUserId = null;
	      this.theEditNumberType = '';
	      this.theEditNumberNumber = 0;
	    },
	    doneEditing: function doneEditing() {
	      this.docendoEditHours();
	    },
	    docendoEditHours: function docendoEditHours() {
	      var _this2 = this;
	
	      this.isUpdatingNumber = true;
	      var key = this.theEditNumberType;
	      var updateVal = (0, _defineProperty3.default)({}, key, this.theEditNumberNumber);
	      var updatePrepWithPrepFactor = this.prepFactor && this.theEditNumberType === 'assigned_teaching_hours';
	      if (updatePrepWithPrepFactor) {
	        console.log('uv: ', this.theEditNumberNumber + ' = ' + this.theEditNumberNumber * this.prepFactor + ' i forberedelsestid');
	        var thePrep = this.theEditNumberNumber * this.prepFactor;
	        updateVal = {
	          assigned_teaching_hours: this.theEditNumberNumber,
	          assigned_preparation_hours: thePrep
	        };
	      }
	      _docendo2.default.schoolUserYearUpdate(this.schoolid, this.theEditNumberUserId, this.activeSchoolYear.name, updateVal, function (success) {
	        if (updatePrepWithPrepFactor) {
	          var _thePrep = _this2.theEditNumberNumber * _this2.prepFactor;
	          _eventbus2.default.toast = { text: 'Gemt & automatisk opdateret forberedelsestid til ' + _thePrep + ' timer', 'success': true };
	        }
	        _this2.isUpdatingNumber = false;
	        _this2.closeEditing();
	        _this2.$emit('updatedUser', success);
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$refs.popper_child) {
	      this.$refs.popper_child.remove();
	    }
	  }
	};

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    activeSortKey: {
	      type: String
	    },
	    sortProp: {
	      type: String
	    },
	    title: {
	      type: String
	    }
	  },
	  methods: {
	    sortBy: function sortBy() {
	      this.$emit('sortby', this.sortProp);
	    }
	  }
	};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isActive: false,
	      isSaving: false,
	      theSettingProp: 'deactivatePools'
	    };
	  },
	
	  watch: {
	    isPoolsDeactivated: function isPoolsDeactivated(val, oldVal) {
	      this.$emit('reReadNumbers');
	      _eventbus2.default.toast = { text: 'Gemt for skolen', 'success': true };
	    }
	  },
	  methods: {
	    setIsActive: function setIsActive() {
	      var _this = this;
	
	      this.isActive = !this.isActive;
	      setTimeout(function (_) {
	        _this.onSave();
	      }, 250);
	    },
	    onSave: function onSave() {
	      this.isSaving = true;
	      if (!this.isActive) {
	        this.$store.dispatch('deleteSchoolSetting', this.theSettingProp);
	      } else {
	        this.$store.dispatch('updateSchoolSettings', { 'deactivatePools': true });
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.isPoolsDeactivated) {
	      this.isActive = true;
	    }
	  }
	};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(13);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ChangeSchoolYear: _ChangeSchoolYear2.default, DatePickerRange: _DatePickerRange2.default },
	  props: {
	    schoolId: {},
	    users: {
	      type: Array,
	      default: []
	    }
	  },
	  data: function data() {
	    return {
	      hoursPerWeek: 37,
	      userData: null,
	      isLoadingUpdatedNumbers: false,
	      theSelectedUserId: null,
	      numberOfVacationDays: 0,
	      startDate: (0, _moment2.default)().startOf('year').format('YYYY-MM-DD'),
	      endDate: (0, _moment2.default)().endOf('year').format('YYYY-MM-DD') };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    holidaysWithinActiveSchoolYear: 'holidaysWithinActiveSchoolYear'
	  }), {
	    hoursPerDay: function hoursPerDay() {
	      return this.hoursPerWeek / 5;
	    },
	    userActualHours: function userActualHours() {
	      return this.userData && this.userData[0].actual_total_hours ? (this.userData[0].actual_total_hours * 1).toFixed(1) : 0;
	    },
	    userActualHoursDiff: function userActualHoursDiff() {
	      return (this.userActualHours * 1 - this.numberOfWorkDaysPossibleInHours * 1).toFixed(2);
	    },
	    theSelectedUser: function theSelectedUser() {
	      var _this = this;
	
	      return this.theSelectedUserId ? this.users.find(function (user) {
	        return user.id === _this.theSelectedUserId;
	      }) : null;
	    },
	    numberOfWorkDaysPossible: function numberOfWorkDaysPossible() {
	      return this.numberOfDaysWithoutWeekendsAndHolidays - this.numberOfVacationDays;
	    },
	    numberOfWorkDaysPossibleInHours: function numberOfWorkDaysPossibleInHours() {
	      return (this.numberOfWorkDaysPossible * this.hoursPerDay).toFixed(1);
	    },
	    numberOfVacationDaysInHours: function numberOfVacationDaysInHours() {
	      return (this.numberOfVacationDays * this.hoursPerDay).toFixed(1);
	    },
	    filteredHolidays: function filteredHolidays() {
	      return this.holidaysWithinActiveSchoolYear(this.startDate, this.endDate);
	    },
	    hasAnyHolidays: function hasAnyHolidays() {
	      return this.filteredHolidays.length > 0;
	    },
	    holidaysAsLabels: function holidaysAsLabels() {
	      return this.filteredHolidays.join(', ');
	    },
	    filteredHolidaysInHours: function filteredHolidaysInHours() {
	      return (this.filteredHolidays.length * this.hoursPerDay).toFixed(1);
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    numberOfDays: function numberOfDays() {
	      var start = (0, _moment2.default)(this.startDate).startOf('day');
	      var end = (0, _moment2.default)(this.endDate).endOf('day');
	      var diff = end.diff(start, 'day');
	      return diff + 1;
	    },
	    numberOfDaysWithoutWeekendsInHours: function numberOfDaysWithoutWeekendsInHours() {
	      return (this.numberOfDaysWithoutWeekends * this.hoursPerDay).toFixed(1);
	    },
	    numberOfDaysWithoutWeekends: function numberOfDaysWithoutWeekends() {
	      var diff = this.numberOfDays;
	      var newDate = (0, _moment2.default)(this.startDate);
	      var weekdaysCount = 0;
	      for (var i = 0; i < diff; i++) {
	        if (newDate.isoWeekday() !== 6 && newDate.isoWeekday() !== 7) {
	          weekdaysCount++;
	        }
	        newDate = (0, _moment2.default)(newDate).add(1, 'days');
	      }
	      return weekdaysCount;
	    },
	    numberOfDaysWithoutWeekendsAndHolidays: function numberOfDaysWithoutWeekendsAndHolidays() {
	      return this.numberOfDaysWithoutWeekends - this.filteredHolidays.length;
	    },
	    numberOfDaysWithoutWeekendsAndHolidaysInHours: function numberOfDaysWithoutWeekendsAndHolidaysInHours() {
	      return (this.numberOfDaysWithoutWeekendsAndHolidays * this.hoursPerDay).toFixed(1);
	    }
	  }),
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.setEndDate(this.activeSchoolYear.employee_time_end);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    }
	  },
	  methods: {
	    onUserIsSelected: function onUserIsSelected() {
	      this.getUsersHours();
	    },
	    getUsersHours: function getUsersHours() {
	      var _this2 = this;
	
	      if (!this.theSelectedUserId) {
	        return;
	      }
	      this.isLoadingUpdatedNumbers = true;
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') + ' 00:00';
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') + ' 23:59';
	      _docendo2.default.schoolActualHours(this.schoolId, startDate, endDate, [this.theSelectedUserId], function (data) {
	        _this2.userData = data;
	        _this2.isLoadingUpdatedNumbers = false;
	      });
	    },
	    resetDates: function resetDates() {
	      this.setEndDate(this.activeSchoolYear.employee_time_end, false);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    setStartDate: function setStartDate(date) {
	      this.startDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      if ((0, _moment2.default)(date).isValid()) {
	        this.getUsersHours();
	      }
	    },
	    setEndDate: function setEndDate(date, isCallServer) {
	      this.endDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      if (!isCallServer) {
	        return;
	      }
	      if ((0, _moment2.default)(date).isValid()) {
	        this.getUsersHours();
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.activeSchoolYear) {
	      this.setEndDate(this.activeSchoolYear.employee_time_end, false);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    }
	  }
	};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AppEIPWYZIWYG = __webpack_require__(45);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _AssignHoursNormList = __webpack_require__(1208);
	
	var _AssignHoursNormList2 = _interopRequireDefault(_AssignHoursNormList);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DoFiltersFilter: _DoFiltersFilter2.default, ModalConfirmation: _ModalConfirmation2.default, AppToggle: _AppToggle2.default, DModal: _DModal2.default, filterTags: _TaggingFilter2.default, AppEIPWYZIWYG: _AppEIPWYZIWYG2.default, AssignHoursNormList: _AssignHoursNormList2.default },
	  props: {
	    tags: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isKindergarten: {
	      type: Boolean,
	      default: false
	    },
	    isLocalPoolActivated: {
	      type: Boolean,
	      default: false
	    },
	    prepFactor: {
	      default: null
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      theEmploymentRate: 1,
	      theNewNettoValue: null,
	      isWarningActive: false,
	      isActive: false,
	      isSaving: false,
	      selectedUsers: [],
	      appliedFilters: [],
	      nettoItems: [],
	      items: [{ id: 'assigned_teaching_hours', name: 'Undervisning', hours: 800, isChecked: false }, { id: 'assigned_additional_task_hours', name: 'Øvrige opgaver', hours: 400, isChecked: false }, { id: 'assigned_preparation_hours', name: 'Forberedelse', hours: 400, isChecked: false }, { id: 'assigned_pool_hours', name: 'Lokalpulje', hours: 80, isChecked: false }, { id: 'substitute_pool_hours', name: 'Vikartimer', hours: 0, isChecked: false }, { id: 'assigned_club_hours', name: 'SFO-timer', hours: 0, isChecked: false }],
	      originalItems: [],
	      agreements: '',
	      isShowAgreement: false,
	      activeTab: 0,
	      itemsToSave: [],
	      nettoTime: 1686.1,
	      originalNettoTime: 1686.1,
	      theEditUserNorm: null,
	      theNewStandardHoursForPool: null,
	      isAutoCalculateHoursFromEmploymentRate: false,
	      isModalAutoCalculateOpen: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName']), {
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    restCalculation: function restCalculation() {
	      var sum = this.items.filter(function (item) {
	        return item.isChecked;
	      }).reduce(function (sum, item) {
	        return sum + Number(item.hours);
	      }, 0);
	      return (this.nettoTime - sum).toFixed(2);
	    },
	    checkedItemsToUpdate: function checkedItemsToUpdate() {
	      var _this = this;
	
	      return this.items.filter(function (item) {
	        return !_this.prepFactor || item.id !== 'assigned_preparation_hours';
	      }).filter(function (item) {
	        return item.isChecked;
	      });
	    },
	    isEmploymentRateChanged: function isEmploymentRateChanged() {
	      return this.isPoolsDeactivated ? false : Number(this.theEmploymentRate) !== 1;
	    },
	    usersSortedOnNameWithTags: function usersSortedOnNameWithTags() {
	      return this.usersSortedOnName.map(function (user) {
	        user.tags = user.user_tags;
	        return user;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this2 = this;
	
	      if (!this.appliedFilters.length) return this.usersSortedOnName;
	
	      return this.usersSortedOnName.filter(function (user) {
	        return user.user_tags && _this2.appliedFilters.some(function (filter) {
	          return user.user_tags.includes(filter);
	        });
	      });
	    },
	    hoursForTeaching: function hoursForTeaching() {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === 'assigned_teaching_hours';
	      });
	      return this.items[idx].hours;
	    }
	  }),
	  methods: {
	    setHoursFromEmploymentRate: function setHoursFromEmploymentRate(itemToUpdate) {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === itemToUpdate.id;
	      });
	      if (idx === -1) return;
	
	      var item = this.items[idx];
	      var originalItem = this.findOriginalItem(item);
	      var newHours = parseFloat((originalItem.hours * this.theEmploymentRate).toFixed(2));
	
	      this.$set(this.items, idx, (0, _extends3.default)({}, item, { hours: newHours }));
	    },
	    updateActivePoolsFromEmploymentRate: function updateActivePoolsFromEmploymentRate() {
	      var _this3 = this;
	
	      this.checkedItemsToUpdate.forEach(function (checkedItem) {
	        _this3.setHoursFromEmploymentRate(checkedItem);
	      });
	      this.isModalAutoCalculateOpen = false;
	      this.updatePrepHoursFromTeaching();
	    },
	    formatEmploymentRateText: function formatEmploymentRateText(item) {
	      var showResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var originalHours = this.findOriginalItem(item).hours;
	      var employmentRatePercentage = (this.theEmploymentRate * 100).toFixed(0) + '%';
	      var result = (originalHours * this.theEmploymentRate).toFixed(2);
	
	      return showResult ? originalHours + ' timer * ' + employmentRatePercentage + ' = ' + result + ' timer' : originalHours + 't * ' + employmentRatePercentage;
	    },
	    onChangedEmploymentRate: function onChangedEmploymentRate(rate) {
	      if (this.isPoolsDeactivated) {
	        return;
	      }
	      this.theEmploymentRate = rate;
	      this.isModalAutoCalculateOpen = this.items.some(function (item) {
	        return item.isChecked;
	      });
	    },
	    isShowPrepFactorTooltip: function isShowPrepFactorTooltip(item) {
	      return item.id === 'assigned_preparation_hours' && this.prepFactor !== null;
	    },
	    saveNewNettoTime: function saveNewNettoTime() {
	      var _this4 = this;
	
	      var val = this.theNewNettoValue * 1;
	      this.$store.dispatch('updateSchoolSettings', { 'nettoTime': val });
	      this.originalNettoTime = val;
	      setTimeout(function (_) {
	        _this4.setIsShowNewNettoModal(null);
	      }, 0);
	    },
	    setIsShowNewNettoModal: function setIsShowNewNettoModal(val) {
	      this.theNewNettoValue = val;
	    },
	    setTheNewStandardHoursForPool: function setTheNewStandardHoursForPool() {
	      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.theNewStandardHoursForPool = obj;
	    },
	    saveNewStandardHours: function saveNewStandardHours() {
	      var _this5 = this;
	
	      var hours = Number(this.theNewStandardHoursForPool.hours);
	      var key = this.theNewStandardHoursForPool.id;
	
	      this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, key, hours));
	
	      var originalItem = this.originalItems.find(function (item) {
	        return item.id === _this5.theNewStandardHoursForPool.id;
	      });
	      if (originalItem) {
	        originalItem.hours = hours;
	      }
	      setTimeout(function () {
	        _this5.setTheNewStandardHoursForPool(null);
	      }, 0);
	    },
	    setIsNormModal: function setIsNormModal() {
	      this.theEmploymentRate = 1;
	      this.updateItemsWithSchoolSettings();
	      if (this.schoolSettings && (this.schoolSettings['netto_time'] || this.schoolSettings['nettoTime'])) {
	        var nettTime = this.schoolSettings['netto_time'] || this.schoolSettings['nettoTime'];
	        this.nettoTime = nettTime;
	        this.originalNettoTime = nettTime;
	      }
	      this.isActive = true;
	      this.updatePrepHoursFromTeaching();
	    },
	    updatePrepHoursFromTeaching: function updatePrepHoursFromTeaching() {
	      if (!this.prepFactor) {
	        return;
	      }
	      var thePrep = this.hoursForTeaching * this.prepFactor;
	      var roundedPrep = parseFloat(thePrep.toFixed(2));
	      var idx = this.items.findIndex(function (hoursItem) {
	        return hoursItem.id === 'assigned_preparation_hours';
	      });
	      this.items[idx].hours = roundedPrep;
	    },
	    onUpdatingHours: function onUpdatingHours(item, val) {
	      var originalItem = this.originalItems.find(function (item) {
	        return item.id === item.id;
	      });
	      var originalVal = originalItem.hours;
	      var newVal = val * 1;
	      if (!this.isEmploymentRateChanged && originalVal !== newVal) {
	        this.setTheNewStandardHoursForPool(item);
	      }
	      this.updatePrepHoursFromTeaching();
	    },
	    findOriginalItem: function findOriginalItem(item) {
	      return this.originalItems.find(function (originalItem) {
	        return originalItem.id === item.id;
	      });
	    },
	    toggleItem: function toggleItem(idx) {
	      var item = this.items[idx];
	      this.items[idx].isChecked = !this.items[idx].isChecked;
	      if (this.prepFactor && item.id === 'assigned_preparation_hours') {
	        return;
	      }
	      if (this.isEmploymentRateChanged) {
	        this.setHoursFromEmploymentRate(item);
	        this.updatePrepHoursFromTeaching();
	      }
	    },
	    isItemToggled: function isItemToggled(idx) {
	      return this.items[idx].isChecked;
	    },
	    setNettoTime: function setNettoTime(time) {
	      this.nettoTime = time;
	    },
	    setItemsToSave: function setItemsToSave(arr) {
	      this.itemsToSave = arr;
	    },
	    setActiveTab: function setActiveTab(num) {
	      this.activeTab = num;
	      if (num === 1) {
	        this.nettoTime = this.originalNettoTime;
	      }
	    },
	    getIsActiveTab: function getIsActiveTab(num) {
	      return this.activeTab === num;
	    },
	    setIsShowAgreement: function setIsShowAgreement() {
	      this.isShowAgreement = !this.isShowAgreement;
	    },
	    toggleAll: function toggleAll() {
	      var _this6 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsers.forEach(function (user) {
	          return _this6.selectedUsers.push(user.id);
	        });
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      return idx > -1;
	    },
	    toggleUser: function toggleUser(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      if (idx > -1) {
	        this.selectedUsers.splice(idx, 1);
	      } else {
	        this.selectedUsers.push(user.id);
	      }
	    },
	    toggleFilter: function toggleFilter(tag) {
	      this.selectedUsers = [];
	      var idx = this.appliedFilters.findIndex(function (filter) {
	        return filter === tag;
	      });
	
	      if (idx < 0) {
	        this.appliedFilters.push(tag);
	      } else {
	        this.appliedFilters.splice(idx, 1);
	      }
	    },
	    close: function close() {
	      this.isActive = false;
	      this.selectedUsers = [];
	    },
	    save: function save() {
	      var _this7 = this;
	
	      if (this.selectedUsers.length < 1) {
	        return;
	      }
	
	      function validateNumber(item) {
	        var itemsNotToValidate = ['hidden_ansættelsesgrad', 'Periode', 'hidden_periode_start', 'hidden_periode_end', 'Ansættelsesgrad'];
	        if (itemsNotToValidate.indexOf(item.title) > -1) {
	          return item.value;
	        } else {
	          var val = item.hours * 1;
	          return val.toFixed(2);
	        }
	      }
	
	      this.isSaving = true;
	      var itemsToSave = this.itemsToSave.map(function (item) {
	        return {
	          title: item.title,
	          value: validateNumber(item)
	        };
	      });
	      itemsToSave.push({ title: 'Arbejdstid', value: this.nettoTime });
	      var data = {
	        norm: itemsToSave,
	        assigned_total_hours: this.nettoTime
	      };
	      if (this.isShowAgreement) {
	        data['agreements'] = this.agreements;
	      }
	      var activatedItems = this.items.filter(function (item) {
	        return item.isChecked;
	      });
	      activatedItems.forEach(function (item) {
	        data[item.id] = item.hours;
	      });
	
	      var dataToSave = this.selectedUsers.map(function (userId) {
	        return {
	          user_id: userId,
	          data: data
	        };
	      });
	      _docendo2.default.bulkSchoolUserYearUpdate(this.schoolId, this.activeSchoolYear.name, dataToSave, function (success) {
	        _this7.reset();
	        _this7.$emit('updateUsersHours');
	        _this7.close();
	        _eventbus2.default.toast = { text: 'Gemt', 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', 'success': false };
	      });
	    },
	    reset: function reset() {
	      this.isSaving = false;
	      this.selectedUsers = [];
	      this.isShowAgreement = false;
	      this.agreements = '';
	      this.items = JSON.parse((0, _stringify2.default)(this.originalItems));
	      this.isWarningActive = false;
	    },
	    updateAgreements: function updateAgreements(val) {
	      this.agreements = val;
	    },
	    readUserNorm: function readUserNorm(user) {
	      var _this8 = this;
	
	      _docendo2.default.schoolUserYearRead(this.schoolId, user.id, this.activeSchoolYear.name, function (success) {
	        _this8.theEditUserNorm = success.norm ? success.norm : [];
	        _this8.userAgreements = success.agreements ? success.agreements : '';
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    editUserNorm: function editUserNorm(user) {
	      this.readUserNorm(user);
	    },
	    updateItemsWithSchoolSettings: function updateItemsWithSchoolSettings() {
	      var _this9 = this;
	
	      this.items.forEach(function (item) {
	        var setting = _this9.schoolSettings && _this9.schoolSettings[item.id];
	        if (setting) {
	          _this9.$set(item, 'hours', setting);
	        }
	      });
	      this.originalItems.forEach(function (item) {
	        var setting = _this9.schoolSettings && _this9.schoolSettings[item.id];
	        if (setting) {
	          _this9.$set(item, 'hours', setting);
	        }
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (!this.isLocalPoolActivated) {
	      var idx = this.items.findIndex(function (item) {
	        return item.id === 'assigned_pool_hours';
	      });
	      this.items.splice(idx, 1);
	    }
	  },
	  mounted: function mounted() {
	    this.originalItems = JSON.parse((0, _stringify2.default)(this.items));
	  }
	};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, DateSelector: _DateSelector2.default },
	  props: {
	    schoolYear: {},
	    isKindergarten: {
	      type: Boolean,
	      default: false
	    },
	    theEditUserNorm: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isNetto: {
	      default: false,
	      type: Boolean
	    },
	    standardNettoHours: {
	      default: 1686.1
	    }
	  },
	  data: function data() {
	    return {
	      isEditPeriod: false,
	      initStartDate: null,
	      initEndDate: null,
	      startDate: null,
	      endDate: null,
	      isBruttoTid: true,
	      theSelectedWayToCalculate: 'day',
	      waysToCalculate: [{
	        title: '7.4 timer pr. dag: <span>Dvs. 7,4 timer pr. mulig arbejdsdag. Mulige arbejdsdage er dage i delperioden der ikke er weekenddage.</span>',
	        desc: '',
	        value: 'day'
	      }, {
	        title: '160.3 timer pr. måned: <span>Dvs. 1924 timer / 12 måneder. Så hvis man f.eks ansætter en ny pr. 1/9 2023, så er regnestykket: 1924 / 12 * 4 = årsnorm resten af året i de fire måneder.</span>',
	        desc: '',
	        value: 'month'
	      }],
	      hoursPerWeek: {
	        id: 'hours_per_week',
	        title: 'Timeansættelse pr. uge',
	        hours: 37,
	        standardHours: 37,
	        isFixed: false
	      },
	      employmentPercentage: {
	        id: 'employment_percentage',
	        title: 'Ansættelsesgrad',
	        hours: 100,
	        standardHours: 100,
	        unit: 'percentage',
	        isFixed: false
	      },
	      workingHours: {
	        id: 'working_hours',
	        title: 'Arbejdstid i perioden',
	        hours: this.standardNettoHours,
	        standardHours: this.standardNettoHours,
	        isFixed: true
	      },
	      standardItems: [{
	        id: 'holidays',
	        title: 'Søgnehelligdage',
	        hours: 0,
	        standardHours: 0,
	        userStandardHours: 0,
	        desc: 'Søgnehelligdage er helligdage, som ikke falder på en lørdag eller søndag',
	        isFixed: true,
	        isSelected: false
	      }, {
	        id: 'vacation',
	        title: 'Ferie',
	        inputType: 'number',
	        hours: 185.00,
	        standardHours: 185.00,
	        userStandardHours: 185.00,
	        unit: 'timer',
	        isFixed: true,
	        isSelected: false
	      }, {
	        id: 'vacation_6_week',
	        title: '6. Ferieuge',
	        inputType: 'number',
	        hours: 37.00,
	        standardHours: 37.00,
	        userStandardHours: 37.00,
	        unit: 'timer',
	        isFixed: true,
	        isSelected: false
	      }, { id: 'care_days', title: 'Omsorgsdage', hours: 0, standardHours: 0, isFixed: false, isSelected: false }, { id: 'senior_days', title: 'Seniordage', hours: 0, standardHours: 0, isFixed: false, isSelected: false }, {
	        id: 'age_reduction',
	        title: 'Aldersreduktion',
	        hours: 175,
	        standardHours: 175.00,
	        userStandardHours: 175.00,
	        isFixed: true,
	        isSelected: false
	      }],
	      isEdit: false,
	      isAddNew: false,
	      newItemTitle: ''
	    };
	  },
	
	  computed: {
	    danishHolidays: function danishHolidays() {
	      return this.$store.state.danishHolidays.danishHolidays;
	    },
	    isErrorInStartDate: function isErrorInStartDate() {
	      if (this.theSelectedWayToCalculate === 'day') {
	        return false;
	      }
	      var date = (0, _moment2.default)(this.startDate);
	      var isFirstDay = date.date() === 1;
	      var isLastDay = date.clone().add(1, 'days').date() === 1;
	      return !isFirstDay && !isLastDay;
	    },
	    isErrorInEndDate: function isErrorInEndDate() {
	      if (this.theSelectedWayToCalculate === 'day') {
	        return false;
	      }
	      var date = (0, _moment2.default)(this.endDate);
	      var isFirstDay = date.date() === 1;
	      var isLastDay = date.clone().add(1, 'days').date() === 1;
	      return !isFirstDay && !isLastDay;
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      return (0, _moment2.default)(this.startDate).format('ll') + ' - ' + (0, _moment2.default)(this.endDate).format('ll');
	    },
	    subtractedItems: function subtractedItems() {
	      return this.standardItems.filter(function (item) {
	        return item.isSelected;
	      });
	    },
	    possibleStandardItems: function possibleStandardItems() {
	      var _this = this;
	
	      var itemsOnlyForBrutto = ['holidays', 'vacation'];
	      return this.standardItems.filter(function (item) {
	        return _this.isNetto ? !itemsOnlyForBrutto.includes(item.id) && !item.isSelected : !item.isSelected;
	      });
	    },
	    nettoTime: function nettoTime() {
	      var sums = this.subtractedItems.map(function (item) {
	        return item.hours * 1;
	      });
	      var subtract = this.subtractedItems.length < 1 ? 0 : sums.reduce(function (sum, val) {
	        return sum + val;
	      });
	      return parseFloat(this.workingHours.hours - subtract * 1).toFixed(2);
	    },
	    itemsToSave: function itemsToSave() {
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var periodStart = {
	        id: 'period_start',
	        title: 'hidden_periode_start',
	        isChecked: true,
	        value: startDate,
	        hours: startDate
	      };
	      var periodEnd = { id: 'period_end', title: 'hidden_periode_end', isChecked: true, value: endDate, hours: endDate };
	      var periodDates = { title: 'Periode', value: this.dateRangeFormatted };
	      var arr = [periodStart, periodEnd, periodDates];
	      if (this.isBruttoTid) {
	        var workPercentageHidden = { title: 'hidden_ansættelsesgrad', value: this.employmentPercentage.hours };
	        var workPercentage = { title: 'Ansættelsesgrad', value: this.employmentPercentage.hours + '%' };
	        arr.push(workPercentageHidden, workPercentage);
	      }
	      arr.push(this.hoursPerWeek);
	      arr.push(this.workingHours);
	      arr = arr.concat(this.subtractedItems);
	      return arr;
	    },
	    numberOfSchoolDays: function numberOfSchoolDays() {
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      var startDate = this.startDate;
	      var endDate = this.endDate;
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.length;
	    },
	    isOnlyPartOfSchoolYear: function isOnlyPartOfSchoolYear() {
	      var initStartDateFormatted = this.initStartDate.format('YYYY-MM-DD');
	      var startDateFormatted = this.startDate.format('YYYY-MM-DD');
	      var initEndDateFormatted = this.initEndDate.format('YYYY-MM-DD');
	      var endDateFormatted = this.endDate.format('YYYY-MM-DD');
	      return initStartDateFormatted !== startDateFormatted || initEndDateFormatted !== endDateFormatted;
	    }
	  },
	  watch: {
	    itemsToSave: function itemsToSave() {
	      this.$emit('updated', this.itemsToSave);
	    },
	    nettoTime: function nettoTime() {
	      this.$emit('changedSum', this.nettoTime);
	    },
	    theEditUserNorm: function theEditUserNorm() {
	      var _this2 = this;
	
	      this.isEdit = true;
	      this.standardItems.forEach(function (standardItem, idx) {
	        _this2.standardItems[idx].isSelected = false;
	      });
	      this.initStartAndEndDate();
	      this.theEditUserNorm.forEach(function (normItem) {
	        var normItemHours = normItem.value * 1;
	        switch (normItem.title) {
	          case 'Timeansættelse pr. uge':
	            _this2.hoursPerWeek.hours = normItemHours;
	            break;
	          case 'Periode start':
	          case 'hidden_periode_start':
	            _this2.setStartDate(normItem.value);
	            break;
	          case 'Periode slut':
	          case 'hidden_periode_end':
	            _this2.setEndDate(normItem.value);
	            break;
	          case 'Bruttotid':
	          case 'Arbejdstid i perioden':
	            _this2.$emit('onEditBrutto');
	            _this2.workingHours.title = normItem.title;
	            _this2.workingHours.hours = normItemHours;
	            break;
	          case 'Nettotid':
	            _this2.workingHours.title = normItem.title;
	            _this2.$emit('onEditNetto');
	            _this2.workingHours.hours = normItemHours;
	            break;
	          case 'hidden_ansættelsesgrad':
	            _this2.employmentPercentage.hours = normItemHours;
	            break;
	          case 'Periode':
	          case 'Ansættelsesgrad':
	          case 'Arbejdstid':
	            break;
	          default:
	            var idx = _this2.standardItems.findIndex(function (item) {
	              return item.title === normItem.title;
	            });
	            if (idx > -1) {
	              _this2.standardItems[idx].hours = normItemHours;
	              _this2.standardItems[idx].isSelected = true;
	            } else {
	              _this2.addOwn(normItem);
	            }
	            break;
	        }
	      });
	    },
	    numberOfSchoolDays: function numberOfSchoolDays() {
	      this.initData();
	    },
	    isNetto: function isNetto() {
	      if (!this.isEdit) {
	        this.initStartAndEndDate();
	      }
	      this.initData();
	    }
	  },
	  methods: {
	    setTheSelectedWayToCalculate: function setTheSelectedWayToCalculate(wayValue) {
	      this.theSelectedWayToCalculate = wayValue;
	      this.initData();
	    },
	    initData: function initData() {
	      var _this3 = this;
	
	      if (this.isEdit) {
	        return;
	      }
	      this.workingHours.title = this.isNetto ? 'Nettotid' : 'Bruttotid';
	      var hoursInPeriod = this.isNetto ? this.standardNettoHours : 1924;
	      if (this.isOnlyPartOfSchoolYear) {
	        if (this.theSelectedWayToCalculate === 'day') {
	          hoursInPeriod = parseFloat(this.numberOfSchoolDays * 7.4).toFixed(2);
	        } else {
	          var startDate = (0, _moment2.default)(this.startDate);
	          var endDate = (0, _moment2.default)(this.endDate);
	
	          var isLastDayOfMonth = endDate.date() === endDate.clone().endOf('month').date();
	
	          var numberOfMonths = endDate.diff(startDate, 'months') + (isLastDayOfMonth ? 1 : 0);
	          var hoursOfWork = hoursInPeriod / 12 * numberOfMonths;
	          hoursInPeriod = parseFloat(hoursOfWork).toFixed(2);
	        }
	      }
	      this.workingHours.hours = hoursInPeriod;
	      this.workingHours.standardHours = hoursInPeriod;
	      this.standardItems.forEach(function (item, key) {
	        var itemsToAdd = _this3.isNetto ? ['vacation_6_week'] : ['vacation', 'vacation_6_week', 'holidays'];
	        var itemsToHide = _this3.isNetto ? ['vacation', 'holidays'] : [];
	        if (itemsToAdd.indexOf(item.id) > -1) {
	          _this3.standardItems[key].isSelected = true;
	        }
	        if (itemsToHide.indexOf(item.id) > -1) {
	          _this3.standardItems[key].isSelected = false;
	        }
	      });
	      this.getHolidayHours();
	    },
	    setStartDate: function setStartDate(date) {
	      var _this4 = this;
	
	      this.startDate = date;
	      setTimeout(function (_) {
	        _this4.isEdit = false;
	      });
	    },
	    setEndDate: function setEndDate(date) {
	      var _this5 = this;
	
	      this.endDate = date;
	      setTimeout(function (_) {
	        _this5.isEdit = false;
	      });
	    },
	    employmentPercentageChanged: function employmentPercentageChanged(val) {
	      var inHours = val / 100 * 37;
	      this.hoursPerWeek.hours = parseFloat(inHours.toFixed(2));
	      this.hoursPerWeekChanged(inHours, false);
	    },
	    hoursPerWeekChanged: function hoursPerWeekChanged(val, changePercentage) {
	      var employmentRate = val / 37;
	      if (changePercentage) {
	        var percentage = employmentRate * 100;
	        percentage = percentage.toFixed(0);
	        this.employmentPercentage.hours = percentage;
	      }
	      this.$emit('changedEmploymentRate', employmentRate);
	      this.workingHours.hours = parseFloat(this.workingHours.standardHours * employmentRate).toFixed(2);
	      this.standardItems.forEach(function (item) {
	        if (item.userStandardHours) {
	          item.hours = parseFloat(item.userStandardHours * employmentRate).toFixed(2);
	        } else {
	          if (item.standardHours) {
	            item.hours = parseFloat(item.standardHours * employmentRate).toFixed(2);
	          }
	        }
	      });
	    },
	    onEditWorkingHours: function onEditWorkingHours(value) {
	      this.workingHours.standardHours = value;
	      this.workingHours.isFixed = false;
	      if (this.isNetto) {
	        this.$emit('onEditedStandardWorkingHours', value);
	      }
	    },
	    setSubtractedItemValue: function setSubtractedItemValue(item, value) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      if (item.userStandardHours) {
	        this.standardItems[idx].userStandardHours = value * 1;
	      }
	      if (!item.standardHours || item.standardHours * 1 !== value * 1) {
	        this.standardItems[idx].isFixed = false;
	      } else {
	        this.standardItems[idx].isFixed = true;
	      }
	    },
	    setItemValue: function setItemValue(item, idx, value) {
	      if (!this.items[idx].standardHours || this.items[idx].standardHours * 1 !== value * 1) {
	        this.items[idx].isFixed = false;
	      } else {
	        this.items[idx].isFixed = true;
	      }
	    },
	    setIsAddNew: function setIsAddNew(bool) {
	      var _this6 = this;
	
	      if (bool) {
	        this.isAddNew = true;
	        this.$nextTick(function (_) {
	          _this6.$refs.add_new_input.focus();
	        });
	      } else {
	        this.isAddNew = false;
	      }
	    },
	    addFromStandard: function addFromStandard(item) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      this.standardItems[idx].isSelected = true;
	    },
	    addOwn: function addOwn(item) {
	      var newItem = {
	        id: new Date().getTime(),
	        title: this.newItemTitle,
	        hours: 0,
	        isFixed: false,
	        isSelected: true,
	        isOwn: true
	      };
	      if (item && item.title) {
	        newItem.id = item.title;
	        newItem.title = item.title;
	        newItem.hours = item.value * 1;
	      }
	      this.standardItems.push(newItem);
	      this.reset();
	    },
	    deleteItem: function deleteItem(item) {
	      var idx = this.standardItems.findIndex(function (standardItem) {
	        return standardItem.id === item.id;
	      });
	      if (item.isOwn) {
	        this.standardItems.splice(idx, 1);
	        return;
	      }
	      this.standardItems[idx].hours = this.standardItems[idx].standardHours;
	      this.standardItems[idx].isFixed = true;
	      this.standardItems[idx].isSelected = false;
	    },
	    reset: function reset() {
	      this.newItemTitle = '';
	      this.isAddNew = false;
	    },
	    getHolidaysWithinSchoolYearRange: function getHolidaysWithinSchoolYearRange() {
	      var start = this.startDate;
	      var end = this.endDate;
	      return this.danishHolidays.filter(function (date) {
	        var year = date.slice(6, date.length);
	        var month = date.slice(3, 5);
	        var day = date.slice(0, 2);
	        var mDate = (0, _moment2.default)(year + month + day).format('YYYY-MM-DD');
	        var isAfterStart = (0, _moment2.default)(mDate).isSameOrAfter(start);
	        var isBeforeEnd = (0, _moment2.default)(mDate).isSameOrBefore(end);
	        var isNotWeekend = (0, _moment2.default)(mDate).isoWeekday() < 6;
	        return isAfterStart && isBeforeEnd && isNotWeekend;
	      });
	    },
	    getHolidayHours: function getHolidayHours() {
	      var holidays = this.getHolidaysWithinSchoolYearRange();
	      var holidayHours = holidays.length * 7.4;
	      var holidayIdx = this.standardItems.findIndex(function (item) {
	        return item.id === 'holidays';
	      });
	      this.standardItems[holidayIdx].standardHours = holidayHours.toFixed(2);
	      this.standardItems[holidayIdx].hours = holidayHours.toFixed(2);
	      this.standardItems[holidayIdx].userStandardHours = holidayHours.toFixed(2);
	    },
	    initStartAndEndDate: function initStartAndEndDate() {
	      if (this.isKindergarten) {
	        this.startDate = (0, _moment2.default)(this.schoolYear.employee_time_start).set({
	          month: 0,
	          date: 1
	        });
	        this.endDate = (0, _moment2.default)(this.schoolYear.employee_time_end).set({
	          month: 11,
	          date: 31
	        });
	      } else {
	        this.startDate = (0, _moment2.default)(this.schoolYear.employee_time_start).set({
	          month: 7,
	          date: 1
	        });
	        this.endDate = (0, _moment2.default)(this.schoolYear.employee_time_end).set({
	          month: 6,
	          date: 31
	        });
	      }
	      this.initStartDate = this.startDate.clone();
	      this.initEndDate = this.endDate.clone();
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.initStartAndEndDate();
	    if (this.isNetto) {
	      this.workingHours.title = 'Nettotid';
	      return;
	    }
	    if (this.isKindergarten || this.isBruttoTid) {
	      this.getHolidayHours();
	    }
	    if (this.isBruttoTid) {
	      this.workingHours.title = 'Bruttotid';
	    }
	  }
	};

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var I18N = {
	  da: {
	    tooltip: {
	      hours: 'timer',
	      days: 'dage',
	      work_days: 'arbejdsdage',
	      per_day: 'pr. dag',
	      calculation: 'Beregning',
	      forYear: 'For året:',
	      forPeriod: 'For perioden:',
	      explanation: '<p><i>Når du vælger et andet datointerval end hele perioden, kan du her se, hvor mange timer, der i gennemsnit skal planlægges for medarbejderen i perioden og per dag. Udregningen er baseret på antal arbejdsdage angivet for personalet, fratrukket weekender, feriedage og helligdage i \'Feriekalender\'</p>'
	    }
	  },
	  nb: {
	    tooltip: {
	      hours: 'timer',
	      days: 'dager',
	      per_day: 'per dag',
	      work_days: 'arbeidsdager',
	      calculation: 'Beregning',
	      forYear: 'For året:',
	      forPeriod: 'For perioden:',
	      explanation: '<p><i>Når du velger et annet datointerval enn hele året, kan du her se, hvor mange timer som skal planlegges for medarbeideren i perioden og i gjennomsnitt per dag. Beregningen trekker helger og ferie- og helligdager fra.</i></p>'
	    }
	  },
	  en: {
	    tooltip: {
	      hours: 'hours',
	      days: 'days',
	      per_day: 'per day',
	      work_days: 'work days',
	      calculation: 'Calculation',
	      forYear: 'For the year:',
	      forPeriod: 'For the period:',
	      explanation: '<p><i>When you choose a different date range than the whole year, you can see here how many hours need to be planned for the employee in the period and on average per day. The calculation subtracts weekends and holidays.</i></p>'
	    }
	  }
	};
	
	exports.default = {
	  props: {
	    user: {
	      type: Object,
	      default: {}
	    },
	    theUserCanManageAssignedHours: {
	      type: Boolean,
	      default: false
	    },
	    isSFOActive: {
	      type: Boolean,
	      default: false
	    },
	    isSchoolYearWithNewEmploymentDeal: {
	      type: Boolean,
	      default: false
	    },
	    isDatesPristine: {
	      type: Boolean,
	      default: true
	    },
	    numberOfWorkDaysInPeriod: {
	      required: true
	    },
	    numberOfWorkDays: {
	      required: true
	    },
	    locale: {
	      default: 'en'
	    },
	    isLocalPoolActivated: {
	      type: Boolean,
	      default: false
	    },
	    viewSettings: {
	      type: Object
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    },
	    prepFactor: {
	      default: null
	    }
	  },
	  computed: {
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isShowPrepFactorCalculation: function isShowPrepFactorCalculation() {
	      return this.prepFactor !== null && this.isPoolsDeactivated && this.locale === 'da';
	    }
	  },
	  methods: {
	    numToFixed: function numToFixed(num) {
	      return parseFloat(num).toFixed(2);
	    },
	    createTooltip: function createTooltip(sumForYear) {
	      var hoursInYear = this.numberOfWorkDays;
	      var hoursPerDay = sumForYear / hoursInYear;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.numToFixed(hoursPerDay);
	      var hoursForPeriodFixed = this.numToFixed(hoursForPeriod);
	      return this.i18n.tooltip.explanation + '<br></p><p><b>' + this.i18n.tooltip.calculation + '</b></p><p>' + this.i18n.tooltip.forYear + ' ' + sumForYear + ' ' + this.i18n.tooltip.hours + ' / ' + hoursInYear + ' ' + this.i18n.tooltip.days + ' = ' + hoursPerDayFixed + ' ' + this.i18n.tooltip.hours + ' ' + this.i18n.tooltip.per_day + '</p><p>' + this.i18n.tooltip.forPeriod + ' ' + this.numberOfWorkDaysInPeriod + ' ' + this.i18n.tooltip.work_days + ' * ' + hoursPerDayFixed + ' ' + this.i18n.tooltip.hours + ' ' + this.i18n.tooltip.per_day + ' = ' + hoursForPeriodFixed + ' ' + this.i18n.tooltip.hours + '</p>';
	    },
	    setTheActiveUserInAssignHours: function setTheActiveUserInAssignHours() {
	      this.$emit('setTheUserToShowTasks', this.user);
	    },
	    setActiveUser: function setActiveUser(filter) {
	      var userAndFilter = {
	        user: this.user,
	        filter: filter
	      };
	      this.$emit('setActiveUser', userAndFilter);
	    },
	    openEdit: function openEdit(num, type, evt) {
	      if (!this.theUserCanManageAssignedHours || this.isPoolsDeactivated) {
	        return;
	      }
	      var numberInfo = {
	        userId: this.user.id,
	        number: num,
	        type: type,
	        evt: evt
	      };
	      this.$emit('openEdit', numberInfo);
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { '--bgScaleColor': color };
	    }
	  }
	};

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'aula-setup',
	  description: 'Initial setup of Aula for a school.',
	  data: function data() {
	    return {
	      institutionNumberConfirmed: false,
	      dataAgreementConfirmed: false,
	      locationsConfirmed: false,
	      usersImported: false,
	      groupsImported: false
	    };
	  },
	
	  methods: {
	    institutionNumberConfirmedClick: function institutionNumberConfirmedClick() {
	      this.institutionNumberConfirmed = true;
	    },
	    locationsConfirmedClick: function locationsConfirmedClick() {
	      this.locationsConfirmed = true;
	    },
	    usersImportedClick: function usersImportedClick() {
	      this.usersImported = true;
	    },
	    groupsImportedClick: function groupsImportedClick() {
	      this.groupsImported = true;
	    }
	  }
	};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _Tabs = __webpack_require__(1398);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XLSX = null;
	
	exports.default = {
	  components: { Tabs: _Tabs2.default, DatePickerRange: _DatePickerRange2.default },
	  mixins: [_vueClickaway.mixin],
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	        el.select();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      theSelectedTab: 'hours',
	      isDownloading: false,
	      theEditNumberUser: null,
	      theEditNumberType: '',
	      theEditNumberNumber: 0,
	      isDropdownPopperDone: false,
	      isUpdatingNumber: false,
	      startDate: (0, _moment2.default)().startOf('isoWeek'),
	      endDate: (0, _moment2.default)().endOf('isoWeek'),
	      col1: [{ name: 'Employee id', rowspan: 2 }, { name: 'Name', rowspan: 2 }, { name: 'Working hours', color: '#f7f9fe' }, { name: 'Teaching', colspan: 2, color: '#f2f2ff' }, { name: 'Tasks', color: '#fffbf1' }, { name: 'Preparation', color: '#fef7f5' }, { name: 'Substitute', colspan: 2, color: '#f2fafb' }, { name: 'Hours left', color: '#fff' }, { name: 'Absent', color: '#f1f1f1' }],
	      col2: [{ name: 'Working hours', color: '#f7f9fe' }, { name: 'Subject', color: '#f2f2ff' }, { name: 'Breaks', color: '#f2f2ff' }, { name: 'Not teaching', color: '#fffbf1' }, { name: 'Preparation', color: '#fef7f5' }, { name: 'Teaching', color: '#f2fafb' }, { name: 'Breaks/not teaching', color: '#f2fafb' }, { name: 'Hours left', color: '#fff' }, { name: 'Absent', color: '#f1f1f1' }],
	      events: [],
	      isLoading: false,
	      eventsInUserCalendarIdHash: {},
	      debounceTimer: null,
	      clickCount: 0,
	      clickCountTimer: null
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersWithEmployeeId: function usersWithEmployeeId() {
	      return this.users.filter(function (user) {
	        return user.employee_id;
	      });
	    },
	    filteredCalendars: function filteredCalendars() {
	      return this.users && this.users.length > 0 ? this.users.map(function (user) {
	        return user.user_calendar_id;
	      }) : [];
	    },
	    isThisWeek: function isThisWeek() {
	      var start = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') === (0, _moment2.default)().startOf('isoWeek').format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD') === (0, _moment2.default)().endOf('isoWeek').format('YYYY-MM-DD');
	      return start && end;
	    },
	    usersWithVEvents: function usersWithVEvents() {
	      var _this = this;
	
	      var multiple = this.theSelectedTab === 'minutes' ? 1 : 60;
	      var formatTime = function formatTime(num) {
	        return (num / multiple).toFixed(2);
	      };
	
	      var getWeeklyHours = function getWeeklyHours(user) {
	        return user.custom_data && user.custom_data.schools && user.custom_data.schools[_this.schoolId] && user.custom_data.schools[_this.schoolId]['weeklyHours'] || 0;
	      };
	
	      return this.users.map(function (user) {
	        var calUser = _this.eventsInUserCalendarIdHash && _this.eventsInUserCalendarIdHash[user.user_calendar_id];
	        var getCount = function getCount(key) {
	          return calUser && calUser[key] || 0;
	        };
	
	        var vPresence = getWeeklyHours(user);
	        var vSubject = getCount('subject_count');
	        var vBreak = getCount('break_count');
	        var vTasks = getCount('additional_tasks_count');
	        var vPreparation = getCount('preparation_count');
	        var vAbsence = getCount('absence_count');
	        var vSubstituteTeaching = getCount('substitute_teaching_count');
	        var vSubstituteNotTeaching = getCount('substitute_not_teaching_count');
	
	        var usedTime = vSubject + vBreak + vTasks + vPreparation + vSubstituteTeaching + vSubstituteNotTeaching;
	        var vTotal = vPresence - usedTime;
	
	        return (0, _extends3.default)({}, user, {
	          v_presence: formatTime(vPresence),
	          v_subject: formatTime(vSubject),
	          v_break: formatTime(vBreak),
	          v_tasks: formatTime(vTasks),
	          v_preparation: formatTime(vPreparation),
	          v_substitute_teaching: formatTime(vSubstituteTeaching),
	          v_substitute_not_teaching: formatTime(vSubstituteNotTeaching),
	          v_hours_left: formatTime(vTotal),
	          v_absence: formatTime(vAbsence)
	        });
	      });
	    }
	  },
	  watch: {
	    users: function users() {
	      this.readEvents();
	    }
	  },
	  methods: {
	    dataToExcel: function dataToExcel() {
	      var _this2 = this;
	
	      var users = this.usersWithVEvents.map(function (user) {
	        return {
	          'employee_id': user.employee_id || null,
	          'name': user.name,
	          'work_time': parseFloat(_this2.humanizeNumber(user.v_presence)),
	          'subject': parseFloat(user.v_subject),
	          'breaks': parseFloat(user.v_break),
	          'tasks': parseFloat(user.v_tasks),
	          'preparation': parseFloat(user.v_preparation),
	          'substitute_teaching': parseFloat(user.v_substitute_teaching),
	          'substitute_not_teaching': parseFloat(user.v_substitute_not_teaching),
	          'hours_left': parseFloat(user.v_hours_left),
	          'absence': parseFloat(user.v_absence)
	        };
	      });
	
	      var baseHeaders = {
	        'employee_id': 'Employee ID',
	        'name': 'Name',
	        'work_time': 'Work Time',
	        'subject': 'Subject',
	        'breaks': 'Breaks',
	        'tasks': 'Tasks',
	        'preparation': 'Preparation',
	        'substitute_teaching': 'Substitute Teaching',
	        'substitute_not_teaching': 'Substitute Not Teaching',
	        'hours_left': 'Hours Left',
	        'absence': 'Absence'
	      };
	
	      var headersRow1 = (0, _keys2.default)(baseHeaders).reduce(function (accumulator, key) {
	        accumulator[key] = '';
	        return accumulator;
	      }, {});
	
	      var headersRow2 = (0, _extends3.default)({}, baseHeaders);
	
	      users.unshift(headersRow2, headersRow1);
	
	      return users;
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this3 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.download();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this3.download();
	          }
	        }, 500);
	      }
	    },
	    download: function download() {
	      var data = XLSX.utils.json_to_sheet(this.dataToExcel(), { skipHeader: true });
	
	      data.A1 = { t: 's', v: 'Employee id' };
	      data.B1 = { t: 's', v: 'Navn' };
	      data.C1 = { t: 's', v: 'Working hours' };
	
	      data.D1 = { t: 's', v: 'Teaching' };
	      data.D2 = { t: 's', v: 'Subject' };
	      data.E2 = { t: 's', v: 'Breaks' };
	      data.F1 = { t: 's', v: 'Tasks' };
	      data.G1 = { t: 's', v: 'Preparation' };
	
	      data.H1 = { t: 's', v: 'Substitute' };
	      data.H2 = { t: 's', v: 'Teaching' };
	      data.I2 = { t: 's', v: 'Not Teaching' };
	      data.J1 = { t: 's', v: 'Hours Left' };
	      data.K1 = { t: 's', v: 'Absence' };
	
	      var merge = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }, { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } }];
	
	      data['!merges'] = merge;
	
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, data, 'data');
	
	      XLSX.writeFile(wb, 'docendo_tildel_timer.xlsx');
	
	      this.isDownloading = false;
	    },
	    humanizeNumber: function humanizeNumber(num) {
	      return parseFloat(num).toFixed(1);
	    },
	    closeEditing: function closeEditing() {
	      this.isDropdownPopperDone = false;
	      this.theEditNumberUser = null;
	      this.theEditNumberType = '';
	      this.theEditNumberNumber = 0;
	    },
	    doneEditing: function doneEditing() {
	      console.log('doneEditing');
	      this.updateUser(this.theEditNumberUser, this.theEditNumberNumber);
	    },
	    createPopper: function createPopper(parentPopper, childPopper) {
	      parentPopper.appendChild(childPopper);
	    },
	    setOpenEdit: function setOpenEdit(obj) {
	      var _this4 = this;
	
	      this.isDropdownPopperDone = false;
	      this.theEditNumberUser = obj.user;
	      this.theEditNumberType = obj.type;
	      this.theEditNumberNumber = obj.number;
	      this.$nextTick(function (_) {
	        _this4.createPopper(obj.evt.target, _this4.$refs.popper_child);
	        _this4.isDropdownPopperDone = true;
	      });
	    },
	    openEdit: function openEdit(user, num, type, evt) {
	      var numberInfo = {
	        user: user,
	        number: num,
	        type: type,
	        evt: evt
	      };
	      this.setOpenEdit(numberInfo);
	    },
	    updateUser: function updateUser(user, val) {
	      var _this5 = this;
	
	      this.isUpdatingNumber = true;
	      var change = 'weeklyHours';
	      var customData = user.custom_data;
	      var changes = {};
	      if (!customData['schools']) {
	        customData.schools = (0, _defineProperty3.default)({}, this.schoolId, (0, _defineProperty3.default)({}, change, val));
	      }
	      if (customData['schools'] && !customData['schools'][this.schoolId]) {
	        customData['schools'][this.schoolId] = (0, _defineProperty3.default)({}, change, val);
	      }
	      if (customData['schools'] && customData['schools'][this.schoolId]) {
	        if (!val || val.length < 1) {
	          delete customData['schools'][this.schoolId][[change]];
	        } else {
	          customData['schools'][this.schoolId][[change]] = val;
	        }
	      }
	      changes['custom_data'] = customData;
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (data) {
	        _this5.isUpdatingNumber = false;
	        _this5.closeEditing();
	        _this5.$store.commit('updateSchoolUser', data);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    debounce: function debounce(func, delay) {
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(func, delay);
	    },
	    setPrevWeek: function setPrevWeek() {
	      var date = (0, _moment2.default)(this.startDate).subtract(1, 'week');
	      this.startDate = (0, _moment2.default)(date).startOf('isoWeek');
	      this.endDate = (0, _moment2.default)(date).endOf('isoWeek');
	      this.readEvents();
	    },
	    setNextWeek: function setNextWeek() {
	      var date = (0, _moment2.default)(this.startDate).add(1, 'week');
	      this.startDate = (0, _moment2.default)(date).startOf('isoWeek');
	      this.endDate = (0, _moment2.default)(date).endOf('isoWeek');
	      this.readEvents();
	    },
	    setThisWeek: function setThisWeek() {
	      this.startDate = (0, _moment2.default)().startOf('isoWeek');
	      this.endDate = (0, _moment2.default)().endOf('isoWeek');
	      this.readEvents();
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.readEvents();
	    },
	    placeEventsOnUsers: function placeEventsOnUsers() {
	      var _this6 = this;
	
	      this.eventsInUserCalendarIdHash = {};
	      this.events.forEach(function (event) {
	        if (event.event_type === 'presence') {
	          var calcMinutes = (0, _moment2.default)(event.end).diff(event.start, 'minutes');
	          if (!_this6.eventsInUserCalendarIdHash[event.calendar_id]) {
	            _this6.eventsInUserCalendarIdHash[event.calendar_id] = {};
	          }
	          if (_this6.eventsInUserCalendarIdHash[event.calendar_id]['presence']) {
	            _this6.eventsInUserCalendarIdHash[event.calendar_id]['presence'] += calcMinutes;
	          } else {
	            _this6.eventsInUserCalendarIdHash[event.calendar_id]['presence'] = calcMinutes;
	          }
	        } else if (event.school_id === _this6.schoolId) {
	          event.calendars.forEach(function (calendarEvent) {
	            if (calendarEvent.calendar_type === 'user') {
	              var calendarId = calendarEvent.calendar_id;
	              var propName = event.event_type + '_count';
	              if (!_this6.eventsInUserCalendarIdHash[calendarId]) {
	                _this6.eventsInUserCalendarIdHash[calendarId] = {};
	              }
	              if (!calendarEvent.substitute) {
	                if (!_this6.eventsInUserCalendarIdHash[calendarId][event.event_type]) {
	                  _this6.eventsInUserCalendarIdHash[calendarId][event.event_type] = [event];
	                  _this6.eventsInUserCalendarIdHash[calendarId][propName] = calendarEvent.minutes;
	                } else {
	                  var idx = _this6.eventsInUserCalendarIdHash[calendarId][event.event_type].findIndex(function (userEvent) {
	                    return userEvent.event_id === event.event_id;
	                  });
	                  if (idx < 0) {
	                    _this6.eventsInUserCalendarIdHash[calendarId][event.event_type].push(event);
	                    _this6.eventsInUserCalendarIdHash[calendarId][propName] += calendarEvent.minutes;
	                  }
	                }
	              } else if (calendarEvent.substitute) {
	                var teachingTypes = ['subject', 'person_resource', 'person_resource_visible', 'optional'];
	                var isTeaching = teachingTypes.indexOf(event.event_type) > -1;
	                if (isTeaching) {
	                  if (!_this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching']) {
	                    _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching'] = [event];
	                    _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching_count'] = calendarEvent.minutes;
	                  } else {
	                    var _idx = _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching'].findIndex(function (userEvent) {
	                      return userEvent.event_id === event.event_id;
	                    });
	                    if (_idx < 0) {
	                      _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching'].push(event);
	                      _this6.eventsInUserCalendarIdHash[calendarId]['substitute_teaching_count'] += calendarEvent.minutes;
	                    }
	                  }
	                } else if (!isTeaching) {
	                  if (!_this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching']) {
	                    _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching'] = [event];
	                    _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching_count'] = calendarEvent.minutes;
	                  } else {
	                    var _idx2 = _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching'].findIndex(function (userEvent) {
	                      return userEvent.event_id === event.event_id;
	                    });
	                    if (_idx2 < 0) {
	                      _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching'].push(event);
	                      _this6.eventsInUserCalendarIdHash[calendarId]['substitute_not_teaching_count'] += calendarEvent.minutes;
	                    }
	                  }
	                }
	              }
	            }
	          });
	        }
	      });
	    },
	    readEvents: function readEvents() {
	      var _this7 = this;
	
	      if (this.filteredCalendars.length < 1) {
	        return;
	      }
	      this.clickCount++;
	      var start = this.startDate;
	      var end = this.endDate;
	      var calendarIds = this.filteredCalendars;
	      if (this.clickCount === 2) {
	        clearTimeout(this.clickCountTimer);
	      }
	      if (this.clickCount === 1) {
	        this.isLoading = true;
	        _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (success) {
	          _this7.events = success && success.length > 0 ? JSON.parse(success) : [];
	          _this7.placeEventsOnUsers();
	          _this7.isLoading = false;
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	        this.clickCountTimer = setTimeout(function () {
	          _this7.clickCount = 0;
	        }, 300);
	      } else {
	        this.debounce(function () {
	          _this7.isLoading = true;
	          _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (success) {
	            _this7.events = success && success.length > 0 ? JSON.parse(success) : [];
	            _this7.placeEventsOnUsers();
	            _this7.isLoading = false;
	          }, function (failure) {
	            console.log('failure', failure);
	          });
	          _this7.clickCount = 0;
	        }, 300);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$refs.popper_child) {
	      this.$refs.popper_child.remove();
	    }
	  }
	};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Modal = __webpack_require__(315);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Pricing = __webpack_require__(1213);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { modal: _Modal2.default, Pricing: _Pricing2.default },
	  data: function data() {
	    return {
	      interval: 1,
	
	      selectedModel: null,
	      users: '',
	      pupils: '',
	
	      name: '',
	      email: '',
	      phone: '',
	      schoolName: '',
	      schoolEAN: '',
	      showModal: false,
	      modalHeader: '',
	      modalBody: ''
	    };
	  },
	
	  props: ['school'],
	  exampleData: {
	    school: 3
	  },
	  computed: {
	    isChatActive: function isChatActive() {
	      return window.$crisp;
	    },
	    country: function country() {
	      return window.SCHOOL.country.toLowerCase();
	    },
	    isCountryDK: function isCountryDK() {
	      return this.country === 'dk';
	    },
	    countryIsDkOrNo: function countryIsDkOrNo() {
	      return this.country === 'dk' || this.country === 'no';
	    },
	    currency: function currency() {
	      if (this.country === 'dk') {
	        return 'kr';
	      } else if (this.country === 'no') {
	        return 'kr';
	      } else {
	        return '€';
	      }
	    },
	    monthlyInstitutionPrice: function monthlyInstitutionPrice() {
	      if (this.country === 'dk') {
	        return 499;
	      } else if (this.country === 'no') {
	        return 499;
	      } else {
	        return 50;
	      }
	    },
	    userPrice: function userPrice() {
	      if (this.country === 'dk') {
	        return 45;
	      } else if (this.country === 'no') {
	        return 59;
	      } else {
	        return 5;
	      }
	    },
	    pupilsPrice: function pupilsPrice() {
	      return this.country === 'dk' ? 5 : 6.5;
	    },
	    buyButtonEnabled: function buyButtonEnabled() {
	      return this.name.length > 0 && this.email.length > 0 && this.phone.length > 0 && this.schoolName.length > 0;
	    },
	    userAmount: function userAmount() {
	      return this.users < 0 ? 0 : this.users * this.userPrice;
	    },
	    pupilAmount: function pupilAmount() {
	      return this.pupils < 0 ? 0 : this.pupils * this.pupilsPrice;
	    },
	    yearlyPayment: function yearlyPayment() {
	      return this.interval * 1 === 2;
	    },
	    yearlySavings: function yearlySavings() {
	      var total = this.totalAmount * 1.02 * 0.02;
	      return total.toFixed(0);
	    },
	    totalAmount: function totalAmount() {
	      var total = 0;
	
	      if (this.selectedModel === 1) {
	        if (this.yearlyPayment) {
	          total = (this.userAmount + this.monthlyInstitutionPrice) * 0.98 * 12;
	        } else {
	          total = this.userAmount + this.monthlyInstitutionPrice;
	        }
	      } else if (this.selectedModel === 2) {
	        if (this.yearlyPayment) {
	          total = (this.pupilAmount + this.monthlyInstitutionPrice) * 0.98 * 12;
	        } else {
	          total = this.pupilAmount + this.monthlyInstitutionPrice;
	        }
	      } else {
	        total = this.monthlyInstitutionPrice;
	      }
	      return total.toFixed(0);
	    }
	  },
	  methods: {
	    selectModel: function selectModel(num) {
	      this.selectedModel = num;
	    },
	    isSelectedModel: function isSelectedModel(num) {
	      return this.selectedModel === num;
	    },
	    buyClick: function buyClick() {
	      this.showModal = true;
	      this.modalHeader = this.$i18n.t('repitition.processing');
	      this.modalBody = '<h1>' + this.$i18n.t('repitition.one_moment') + '</h1>';
	      _docendo2.default.schoolSubscribe(this.school, {
	        name: this.name,
	        user_count: this.selectedModel === 1 ? parseInt(this.users) : 0,
	        pupil_count: this.selectedModel === 2 ? parseInt(this.pupils) : 0,
	        pay_monthly: this.interval === 1,
	        email: this.email,
	        phone: this.phone,
	        school_name: this.schoolName,
	        ean: this.schoolEAN
	      }, this.buyCallbackSuccess, this.buyCallbackFailure);
	    },
	    buyCallbackSuccess: function buyCallbackSuccess(data) {
	      this.showModal = true;
	      this.modalHeader = this.$i18n.t('vue.buy.thanks_for_buying');
	      this.modalBody = '<a class="font-xlarge" href="/home">' + this.$i18n.t('vue.buy.go_to_home') + '</a>';
	      this.$store.dispatch('analyticsOnSubscribe');
	    },
	    buyCallbackFailure: function buyCallbackFailure(data) {
	      console.log('buyCallbackFailure', data);
	      console.log(data.full_messages);
	      this.modalHeader = this.$i18n.t('vue.buy.error');
	      this.modalBody = this.$i18n.t('vue.buy.missing_inputs');
	      this.showModal = true;
	    },
	    closedModal: function closedModal() {
	      this.showModal = false;
	    },
	    openCrispChat: function openCrispChat() {
	      if (window.$crisp) {
	        window.$crisp.push(['do', 'chat:open']);
	      } else {
	        console.error('Crisp is not loaded on this page.');
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('analyticsOnVisitedBuy');
	  },
	  updated: function updated() {
	    if (!this.countryIsDkOrNo) {
	      this.selectModel(1);
	    }
	  }
	};

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      features: ['Automatisk skemalægning', 'Fleksibel skemalægning', 'Vikardækning', 'Arbejdstidsregistering', 'Årsnorm/Tjenestetid', 'Fagfordeling', 'Opgave- og aktivitetsoversigt', 'Ugeplan', 'Integration med Uni-C (Uni-Login), Aula, Google, Outlook m.m', 'Aula widgets: Dagens Vikarer & Ugeplan', 'Import af fag fra Undervisningsministeriet', 'Grundskole- og kompetenceindberetning', 'Support', 'Evt. Import af jeres nuværende skemaer']
	    };
	  }
	};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoDatePickerRange = __webpack_require__(134);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    flextime: 'Flextid',
	    flexin: 'Flex ind',
	    flexout: 'Flex ud',
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Øvrige Opgaver',
	    available: 'Rådighedstimer',
	    club: 'SFO tid',
	    pool: 'Lokalpulje',
	    absence: 'Fravær',
	    other: 'Opgaver',
	    subject: 'Fag',
	    person_resource: 'Ressource',
	    person_resource_visible: 'Synlig ressource',
	    with_kids: 'Med børn',
	    without_kids: 'Uden børn',
	    unknown: 'Rådighedstime',
	    break: 'Pause',
	    period_hours: 'Timer i perioden',
	    no_schedule: 'Intet skemalagt i perioden',
	    hour: 'time',
	    hours: 'timer',
	    min: 'min',
	    optional: 'Valgfag',
	    resource: 'Ressource'
	  },
	  en: {
	    teaching: 'Teaching',
	    preparation: 'Preparation',
	    additional_tasks: 'Additional Tasks',
	    available: 'Available Hours',
	    club: 'Club Time',
	    pool: 'Local Pool',
	    absence: 'Absence',
	    period_hours: 'Hours in the Period',
	    no_schedule: 'No Schedule in the Period',
	    other: 'Tasks',
	    subject: 'Course',
	    person_resource: 'Resource',
	    person_resource_visible: 'Visible resource',
	    with_kids: 'With children',
	    without_kids: 'Without children',
	    unknown: 'Free period',
	    break: 'Break',
	    hour: 'hour',
	    hours: 'hours',
	    min: 'min',
	    optional: 'Optional',
	    resource: 'Resource'
	  },
	  nb: {
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Ekstra oppgaver',
	    available: 'Tilgjengelige timer',
	    club: 'SFO tid',
	    pool: 'Lokalpulje',
	    absence: 'Fravær',
	    period_hours: 'Timer i perioden',
	    no_schedule: 'Ingen timeplan i perioden',
	    other: 'Oppgaver',
	    subject: 'Fag',
	    person_resource: 'Ressurs',
	    person_resource_visible: 'Synlig ressurs',
	    with_kids: 'Med barn',
	    without_kids: 'Uten barn',
	    unknown: 'Ledig time',
	    break: 'Pause',
	    hour: 'time',
	    hours: 'timer',
	    min: 'min',
	    optional: 'Valgfag',
	    resource: 'Ressurs'
	  }
	};
	
	exports.default = {
	  components: { Loader: _Loader2.default, DoDatePickerRange: _DoDatePickerRange2.default },
	  props: {
	    schoolId: {
	      default: 7272
	    },
	    calendarId: {
	      default: 7
	    },
	    date: {
	      default: (0, _moment2.default)()
	    },
	    isShowOptions: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      startDate: (0, _moment2.default)(this.date).startOf('isoWeek'),
	      endDate: (0, _moment2.default)(this.date).endOf('isoWeek'),
	      hours: [],
	      isLoading: false,
	      maxHeight: '50vh'
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    hoursGrouped: function hoursGrouped() {
	      var _this = this;
	
	      var categories = [];
	      this.hours.forEach(function (subarray) {
	        var masterType = subarray[0] ? subarray[0] : null;
	        var subjectType = subarray[1] ? subarray[1] : null;
	        var subjectTitle = subarray[2] ? subarray[2] : null;
	        var minutes = subarray[3] ? subarray[3] : 0;
	        var vHours = _this.getMinutesToHours(minutes);
	        if (masterType) {
	          var masterTypeIdx = categories.findIndex(function (cat) {
	            return cat.masterType === masterType;
	          });
	          if (masterTypeIdx < 0) {
	            var masterTypeObj = {
	              masterType: masterType,
	              vTitle: _this.getTitle(masterType),
	              vOrder: _this.getOrder(masterType),
	              vHours: vHours,
	              subCategories: []
	            };
	            categories.push(masterTypeObj);
	          } else {
	            if (subjectType && !subjectTitle) {
	              var subjectTypeIdx = categories[masterTypeIdx]['subCategories'].findIndex(function (subCat) {
	                return subCat.subjectType === subjectType;
	              });
	              var subjectTypeObj = {
	                masterType: masterType,
	                subjectType: subjectType,
	                vTitle: _this.getTitle(subjectType),
	                vHours: vHours,
	                vOrder: _this.getOrder(subjectType),
	                subjects: []
	              };
	              if (subjectTypeIdx < 0) {
	                categories[masterTypeIdx]['subCategories'].push(subjectTypeObj);
	              } else {
	                categories[masterTypeIdx]['subCategories'][subjectTypeIdx].push(subjectTypeObj);
	              }
	            }
	            if (subjectType && subjectTitle) {
	              var _subjectTypeIdx = categories[masterTypeIdx]['subCategories'].findIndex(function (subCat) {
	                return subCat.subjectType === subjectType;
	              });
	              var subjectIdx = categories[masterTypeIdx]['subCategories'][_subjectTypeIdx]['subjects'].findIndex(function (subject) {
	                return subject.subjectTitle === subjectTitle;
	              });
	              var subjectObj = {
	                masterType: masterType,
	                subjectType: subjectType,
	                subjectTitle: subjectTitle,
	                vTitle: subjectTitle,
	                vHours: vHours
	              };
	              if (subjectIdx < 0) {
	                categories[masterTypeIdx]['subCategories'][_subjectTypeIdx]['subjects'].push(subjectObj);
	              } else {
	                categories[masterTypeIdx]['subCategories'][_subjectTypeIdx]['subjects'][subjectIdx].push(subjectObj);
	              }
	            }
	          }
	        }
	      });
	      return categories;
	    },
	    hoursGroupedSorted: function hoursGroupedSorted() {
	      var sortedHoursGrouped = [].concat((0, _toConsumableArray3.default)(this.hoursGrouped));
	
	      sortedHoursGrouped.sort(function (a, b) {
	        return a.vOrder - b.vOrder;
	      });
	
	      sortedHoursGrouped.forEach(function (item) {
	        if (item.subCategories) {
	          item.subCategories.sort(function (a, b) {
	            return a.vOrder - b.vOrder;
	          });
	        }
	      });
	      return sortedHoursGrouped;
	    }
	  },
	  methods: {
	    getTitle: function getTitle(label) {
	      if (this.i18n[label]) {
	        return this.i18n[label];
	      } else {
	        return label;
	      }
	    },
	    getOrder: function getOrder(label) {
	      var orders = {
	        flextime: 1,
	        teaching: 1,
	        subject: 1,
	        person_resource: 3,
	        person_resource_visible: 2,
	        with_kids: 1,
	        without_kids: 2,
	        additional_tasks: 2,
	        other: 3,
	        preparation: 4,
	        available: 7,
	        club: 6,
	        pool: 5,
	        unknown: 7,
	        break: 2,
	        absence: 12
	      };
	      return orders[label] ? orders[label] : 20;
	    },
	    setDates: function setDates(startAndEnd) {
	      var start = startAndEnd.start;
	      var end = startAndEnd.end;
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.readHours();
	    },
	    readHours: function readHours() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      this.hours = [];
	      var start = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      _docendo2.default.hoursCountForCalendar(this.schoolId, this.calendarId, start, end, function (success) {
	        _this2.hours = JSON.parse(success);
	        _this2.isLoading = false;
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    getMinutesToHours: function getMinutesToHours(minutes) {
	      var totalMinutes = Math.abs(minutes).toFixed(0);
	      var hours = Math.floor(totalMinutes / 60);
	      var remainingMinutes = totalMinutes % 60;
	      var hoursLabel = hours !== 1 ? this.i18n['hours'] : this.i18n['hour'];
	
	      var sign = minutes < 0 ? '-' : '';
	
	      var hoursAndHoursLabel = hours > 0 ? hours + ' ' + hoursLabel + ' ' : '';
	      return sign + hoursAndHoursLabel + remainingMinutes + ' ' + this.i18n['min'];
	    },
	    calculateMaxHeight: function calculateMaxHeight() {
	      var pxFromTopOfWindow = this.$refs.dropdown.getBoundingClientRect().top;
	      var maxHeight = window.innerHeight - (pxFromTopOfWindow + 30);
	      this.maxHeight = maxHeight + 'px';
	    }
	  },
	  mounted: function mounted() {
	    this.calculateMaxHeight();
	    window.addEventListener('resize', this.calculateMaxHeight);
	    this.readHours();
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.calculateMaxHeight);
	  }
	};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, Loader: _Loader2.default },
	  props: {
	    schoolId: {
	      default: null
	    },
	    calendarId: {
	      default: null
	    },
	    calendarType: {
	      default: null
	    },
	    calendar: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingMerges: false,
	      merges: [],
	      theLoaderId: null
	    };
	  },
	
	  computed: {
	    isMergeCalendar: function isMergeCalendar() {
	      var calType = this.calendar && this.calendar.type ? this.calendar.type : null;
	      return calType === 'merge';
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    mergesFilteredForCalendar: function mergesFilteredForCalendar() {
	      var _this = this;
	
	      return this.merges.filter(function (merge) {
	        return merge.mergee_id === _this.calendarId;
	      });
	    },
	    activeMergeCalendars: function activeMergeCalendars() {
	      return this.$store.getters.mergeCalendars;
	    },
	    mergeCalendarsInclArchived: function mergeCalendarsInclArchived() {
	      return this.$store.getters.mergeCalendarsInclArchived;
	    },
	    mergeCalsMerged: function mergeCalsMerged() {
	      var _this2 = this;
	
	      return this.mergeCalendarsInclArchived.filter(function (mergeCalendar) {
	        return _this2.mergesFilteredForCalendar.findIndex(function (mergesCal) {
	          return mergesCal.merger_id === mergeCalendar.id;
	        }) > -1;
	      });
	    },
	    possibleMergeCals: function possibleMergeCals() {
	      var _this3 = this;
	
	      return this.activeMergeCalendars.filter(function (mergeCalender) {
	        return mergeCalender.school_year_id && mergeCalender.school_year_id === _this3.schoolYear.id && _this3.mergeCalsMerged.findIndex(function (cal) {
	          return cal.id === mergeCalender.id;
	        }) < 0;
	      });
	    },
	    allMergeCalendars: function allMergeCalendars() {
	      var mergedCals = this.mergeCalsMerged.map(function (cal) {
	        return (0, _extends3.default)({}, cal, {
	          vIsMerged: true
	        });
	      });
	      var cals = mergedCals.concat(this.possibleMergeCals);
	      return this.$helpers.sortArrOnName(cals);
	    },
	    allCalendars: function allCalendars() {
	      return this.$store.state.calendars;
	    },
	    mergesFilteredForMergeCalendar: function mergesFilteredForMergeCalendar() {
	      var _this4 = this;
	
	      return this.merges.filter(function (merge) {
	        return merge.merger_id === _this4.calendarId;
	      });
	    },
	    calendarsMerged: function calendarsMerged() {
	      var _this5 = this;
	
	      var cals = this.allCalendars.filter(function (calendar) {
	        return _this5.mergesFilteredForMergeCalendar.findIndex(function (mergesCal) {
	          return mergesCal.mergee_id === calendar.id;
	        }) > -1;
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    possibleToMerge: function possibleToMerge() {
	      var _this6 = this;
	
	      var typesToMerge = ['klass', 'club', 'other'];
	      var isCorrectTypes = this.allCalendars.filter(function (cal) {
	        return typesToMerge.indexOf(cal.type) > -1;
	      });
	      var isCorrectYear = isCorrectTypes.filter(function (cal) {
	        return cal.school_year_id === _this6.schoolYear.id;
	      });
	      var cals = isCorrectYear.filter(function (cal) {
	        return _this6.calendarsMerged.findIndex(function (calMerged) {
	          return calMerged.id === cal.id;
	        }) < 0;
	      });
	      return this.$helpers.sortArrOnName(cals);
	    }
	  },
	  methods: {
	    toggleMergeCalendar: function toggleMergeCalendar(calendar) {
	      this.theLoaderId = calendar.id;
	      if (calendar.vIsMerged) {
	        this.unMergeCalendar(calendar);
	      } else {
	        this.mergeCalendar(calendar);
	      }
	    },
	    mergeCalendar: function mergeCalendar(calendar) {
	      var _this7 = this;
	
	      _docendo2.default.mergeCalendar(this.schoolId, this.calendarId, calendar.id, function (success) {
	        _this7.readCalendarsMerges();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    unMergeCalendar: function unMergeCalendar(calendar) {
	      var _this8 = this;
	
	      _docendo2.default.unmergeCalendar(this.schoolId, this.calendarId, calendar.id, function (success) {
	        _this8.readCalendarsMerges();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    unMergeCalendarFromMergeCalendar: function unMergeCalendarFromMergeCalendar(calendar) {
	      var _this9 = this;
	
	      this.theLoaderId = calendar.id;
	      _docendo2.default.unmergeCalendar(this.schoolId, calendar.id, this.calendarId, function (success) {
	        _this9.readCalendarsMerges();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    mergeCalendarFromMergeCalendar: function mergeCalendarFromMergeCalendar(calendar) {
	      var _this10 = this;
	
	      this.theLoaderId = calendar.id;
	      _docendo2.default.mergeCalendar(this.schoolId, calendar.id, this.calendarId, function (success) {
	        _this10.readCalendarsMerges();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    readCalendarsMerges: function readCalendarsMerges(withSpinner) {
	      var _this11 = this;
	
	      if (withSpinner) {
	        this.isLoadingMerges = true;
	      }
	      _docendo2.default.listCalendarMerges(this.schoolId, function (success) {
	        _this11.isLoadingMerges = false;
	        _this11.theLoaderId = null;
	        _this11.merges = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readCalendarsMerges(true);
	  }
	};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PresenceUser = __webpack_require__(70);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _ExportCalendar = __webpack_require__(83);
	
	var _ExportCalendar2 = _interopRequireDefault(_ExportCalendar);
	
	var _DWeekplan = __webpack_require__(343);
	
	var _DWeekplan2 = _interopRequireDefault(_DWeekplan);
	
	var _WeekSelecter = __webpack_require__(89);
	
	var _WeekSelecter2 = _interopRequireDefault(_WeekSelecter);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DCalendarShowEvent = __webpack_require__(68);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	var _DCalendar = __webpack_require__(58);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _UserTasks = __webpack_require__(44);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _SelectCalendar = __webpack_require__(353);
	
	var _SelectCalendar2 = _interopRequireDefault(_SelectCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DCalendarShowEvent: _DCalendarShowEvent2.default,
	    SelectCalendar: _SelectCalendar2.default,
	    UserTasks: _UserTasks2.default,
	    DWeekplan: _DWeekplan2.default,
	    DCalendar: _DCalendar2.default,
	    Loader: _Loader2.default,
	    Spinner: _Spinner2.default,
	    UserPresence: _PresenceUser2.default,
	    ExportCalendar: _ExportCalendar2.default,
	    weekSelector: _WeekSelecter2.default
	  },
	  data: function data() {
	    return {
	      isShowWeekends: false,
	      startTime: '06:00:00',
	      endTime: '16:00:00',
	      isInPrintMode: false,
	      isCalendarInPrintMode: false,
	      theView: 'calendar'
	    };
	  },
	
	  computed: {
	    isEditable: function isEditable() {
	      return this.$store.getters.isUserCanEditCalendar;
	    },
	    isSubHeader: function isSubHeader() {
	      var isShowSubHeader = false;
	      if (!this.user || !this.calendar) {
	        return isShowSubHeader;
	      }
	      if (this.userHasPermission('can_see_own_task_overview') && this.isUsersCalendar) {
	        isShowSubHeader = true;
	      }
	      if (this.userHasPermission('can_see_others_task_overviews') && this.calendar.type === 'user') {
	        isShowSubHeader = true;
	      }
	      return isShowSubHeader;
	    },
	    theSelectedUser: function theSelectedUser() {
	      if (!this.calendar) {
	        var _userObj = {
	          userId: this.user.id,
	          name: this.user.name,
	          calendarId: this.user.user_calendar_id
	        };
	        return _userObj;
	      }
	      var userObj = {
	        userId: this.allUsersInCalIdHash[this.calendar.id] ? this.allUsersInCalIdHash[this.calendar.id].id : this.user.id,
	        name: this.calendar.name,
	        calendarId: this.calendar.id
	      };
	      return userObj;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    theActiveCalendarId: function theActiveCalendarId() {
	      return this.$store.state.calendar.calendarId;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isUsersCalendar: function isUsersCalendar() {
	      return this.$store.state.calendar.calendarId ? this.theActiveCalendarId === this.user.user_calendar_id : true;
	    },
	    isShowWeekPlan: function isShowWeekPlan() {
	      return this.calendar && this.calendar.type === 'klass' || this.calendar && this.calendar.type === 'user' || this.calendar && this.calendar.type === 'other';
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    calendar: function calendar() {
	      return this.$store.getters.activeCalendar;
	    },
	    events: function events() {
	      return this.$store.state.calendar.events;
	    },
	    availabilityEvents: function availabilityEvents() {
	      return this.$store.state.calendar.availabilityEvents;
	    },
	    dCalendarEvents: function dCalendarEvents() {
	      return this.events.concat(this.availabilityEvents);
	    },
	    isEventsLoading: function isEventsLoading() {
	      return this.$store.state.calendar.isEventsLoading;
	    },
	    activeCalendarDate: function activeCalendarDate() {
	      return (0, _moment2.default)(this.$store.state.calendar.date).format('YYYY-MM-DD');
	    },
	    activeEvent: function activeEvent() {
	      return this.$store.getters.activeCalendarEvent;
	    },
	    iCalUrl: function iCalUrl() {
	      if (this.calendar && this.calendar.ical_url) {
	        return window.location.origin + this.calendar.ical_url;
	      } else if (this.calendar && this.calendar.ical_link) {
	        return window.location.origin + this.calendar.ical_link;
	      } else {
	        return 'loading';
	      }
	    },
	    isNotThisWeek: function isNotThisWeek() {
	      return (0, _moment2.default)(this.$store.state.calendar.date).isoWeek() === (0, _moment2.default)().isoWeek();
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    weekSelectorStartDate: function weekSelectorStartDate() {
	      var startDate = this.calendar && this.calendar.start_date ? this.calendar && this.calendar.start_date : (0, _moment2.default)().startOf('isoweek');
	      var calType = this.calendar ? this.calendar.type : 'klass';
	      if (this.activeSchoolYear) {
	        if (calType === 'klass') {
	          startDate = (0, _moment2.default)(this.activeSchoolYear.student_time_start).startOf('isoweek');
	        } else {
	          startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).startOf('isoweek');
	        }
	      }
	      return startDate;
	    },
	    weekSelectorEndDate: function weekSelectorEndDate() {
	      var endDate = this.calendar && this.calendar.end_date ? this.calendar && this.calendar.end_date : (0, _moment2.default)().startOf('isoweek');
	      var calType = this.calendar ? this.calendar.type : 'klass';
	      if (this.activeSchoolYear) {
	        if (calType === 'klass') {
	          endDate = (0, _moment2.default)(this.activeSchoolYear.student_time_end).startOf('isoweek');
	        } else {
	          endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).startOf('isoweek');
	        }
	      }
	      return endDate;
	    }
	  },
	  watch: {
	    calendar: function calendar() {
	      if (this.calendar && this.calendar.view_state > -1) {
	        var state = this.calendar.view_state * 1;
	        if (state === 0) {
	          this.startTime = '06:00:00';
	          this.endTime = '18:00:00';
	          this.isShowWeekends = false;
	        } else if (state === 1) {
	          this.startTime = '06:00:00';
	          this.endTime = '18:00:00';
	          this.isShowWeekends = true;
	        } else {
	          this.startTime = '00:00:00';
	          this.endTime = '23:00:00';
	          this.isShowWeekends = true;
	        }
	      }
	    },
	    user: function user(val) {
	      if (val) {
	        this.readEvents();
	        this.readCalendar();
	      }
	    },
	    activeCalendarDate: function activeCalendarDate() {
	      this.readEvents();
	    },
	    theActiveCalendarId: function theActiveCalendarId(val) {
	      if (!val) {
	        return;
	      }
	      this.readEvents();
	      this.readCalendar();
	    }
	  },
	  methods: {
	    setTheView: function setTheView(view) {
	      var hasTasksInUrl = window.location.href.indexOf('?tasks') > 0;
	      if (view === 'tasks' && !hasTasksInUrl) {
	        window.location.href = window.location.href + '?tasks';
	      }
	      if (view === 'calendar' && hasTasksInUrl) {
	        window.location.href = window.location.href.substr(0, window.location.href.indexOf('?tasks'));
	      }
	      this.theView = view;
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    readCalendar: function readCalendar() {
	      if (!this.user) {
	        return;
	      }
	      if (!this.theActiveCalendarId) {
	        this.$store.commit('setActiveCalendarId', this.user.user_calendar_id);
	      }
	      this.$store.dispatch('readCalendar', this.theActiveCalendarId);
	    },
	    presenceCall: function presenceCall(arrOfPresenceInWeek) {
	      var _this = this;
	
	      setTimeout(function (_) {
	        _this.readEvents();
	      }, 0);
	    },
	    readEvents: function readEvents() {
	      if (!this.user) {
	        return;
	      }
	      var calendarId = this.theActiveCalendarId ? this.theActiveCalendarId : this.user.user_calendar_id;
	      var obj = {
	        calIds: [calendarId],
	        start: (0, _moment2.default)(this.activeCalendarDate).isoWeekday(1).format('YYYY-MM-DD 00:00'),
	        end: (0, _moment2.default)(this.activeCalendarDate).isoWeekday(7).endOf('day')
	      };
	      this.$store.dispatch('readCalendarEvents', obj);
	    },
	    prevWeek: function prevWeek() {
	      var newDate = (0, _moment2.default)(this.activeCalendarDate).subtract(7, 'days');
	      this.setDate(newDate);
	    },
	    nextWeek: function nextWeek() {
	      var newDate = (0, _moment2.default)(this.activeCalendarDate).add(7, 'days');
	      this.setDate(newDate);
	    },
	    today: function today() {
	      this.setDate((0, _moment2.default)());
	    },
	    setDate: function setDate(date) {
	      this.$store.commit('setActiveCalendarDate', date);
	      this.$helpers.setCookie('calendar_current_date', (0, _moment2.default)(date).format('YYYY-MM-DD'));
	    },
	    print: function print() {
	      var _this2 = this;
	
	      this.isCalendarInPrintMode = true;
	      setTimeout(function (_) {
	        _this2.isInPrintMode = true;
	        _this2.$nextTick(function (_) {
	          var prtHtml = document.getElementById('printCalendar').innerHTML;
	
	          var stylesHtml = '';
	
	          var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	          for (var _i = 0; _i < _arr.length; _i++) {
	            var node = _arr[_i];
	            stylesHtml += node.outerHTML;
	          }
	
	          var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	          WinPrint.document.write('<!DOCTYPE html><html><head>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	          var afterPrint = function afterPrint() {
	            WinPrint.close();
	            _this2.isInPrintMode = false;
	            _this2.isCalendarInPrintMode = false;
	          };
	          WinPrint.onafterprint = afterPrint;
	          setTimeout(function (_) {
	            WinPrint.document.close();
	            WinPrint.focus();
	            WinPrint.print();
	          }, 1000);
	        }, 500);
	      });
	    },
	    setActiveEvent: function setActiveEvent(event) {
	      this.$store.commit('setActiveCalendarEventId', event.obj.event_id);
	    },
	    closeShowEvent: function closeShowEvent() {
	      this.$store.commit('setActiveCalendarEventId', null);
	    },
	    findRoute: function findRoute() {
	      var queryString = window.location.href;
	      var calUrlIndex = window.location.href.indexOf('?cal=');
	      if (calUrlIndex > -1) {
	        var hashEnd = window.location.href.indexOf('#');
	        var calId = queryString.substr(calUrlIndex + 5, hashEnd);
	        this.$store.commit('setActiveCalendarId', calId);
	      }
	    },
	    readUsers: function readUsers() {
	      this.$store.dispatch('getUsers');
	    }
	  },
	  beforeMount: function beforeMount() {
	    var cookieDate = this.$helpers.getCookie('calendar_current_date');
	    if (cookieDate && (0, _moment2.default)(cookieDate).isValid()) {
	      this.$store.commit('setActiveCalendarDate', cookieDate);
	    }
	    var theDevice = this.$helpers.checkUserDevice();
	    if (theDevice === 'Mobile') {
	      this.$store.commit('setIsDeviceMobile', true);
	      document.querySelector('body').classList.add('device--is-mobile');
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	    this.readCalendar();
	    this.findRoute();
	    this.readUsers();
	  }
	};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DCalendar = __webpack_require__(58);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _CalendarViewDayRemoveOrReplace = __webpack_require__(296);
	
	var _CalendarViewDayRemoveOrReplace2 = _interopRequireDefault(_CalendarViewDayRemoveOrReplace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { CalendarViewDayRemoveOrReplace: _CalendarViewDayRemoveOrReplace2.default, DCalendar: _DCalendar2.default, DModal: _DModal2.default },
	  props: {
	    calendar: {
	      default: {
	        id: 7,
	        name: 'Henrik R.'
	      }
	    },
	    date: {
	      default: '2022-02-21'
	    },
	    event: {
	      default: null,
	      type: Object
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      events: [],
	      isEventsLoading: false
	    };
	  },
	
	  computed: {
	    isShowActions: function isShowActions() {
	      var calendarTypes = ['user', 'room', 'klass', 'student'];
	      return this.event && this.calendar && calendarTypes.indexOf(this.calendar.type) > -1;
	    },
	    eventStartFormatted: function eventStartFormatted() {
	      return (0, _moment2.default)(this.event.start).format('LL LT');
	    }
	  },
	  methods: {
	    readEvents: function readEvents() {
	      var _this = this;
	
	      this.isEventsLoading = true;
	      var obj = {
	        calIds: [this.calendar.id],
	        start: (0, _moment2.default)(this.date).startOf('day'),
	        end: (0, _moment2.default)(this.date).endOf('day')
	      };
	      _docendo2.default.calendarEvents2(obj.calIds, obj.start, obj.end, null, function (data) {
	        _this.isEventsLoading = false;
	        _this.events = data.length > 0 ? JSON.parse(data) : [];
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	  }
	};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    event: {
	      default: null
	    },
	    calendar: {
	      default: {
	        id: 7,
	        name: 'Henrik R.'
	      }
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isPossibleToAdd: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      theShowAction: null,
	      theReplaceWithCalendarId: null
	    };
	  },
	
	  computed: {
	    selectableCalendars: function selectableCalendars() {
	      var _this = this;
	
	      return this.calendars.filter(function (cal) {
	        return cal.id !== _this.calendar.id;
	      });
	    }
	  },
	  methods: {
	    start: function start(el) {
	      el.style.height = el.scrollHeight + 'px';
	    },
	    end: function end(el) {
	      el.style.height = '';
	    },
	    setTheShowAction: function setTheShowAction(action) {
	      if (this.theShowAction === action) {
	        this.theShowAction = null;
	      } else {
	        this.theShowAction = action;
	      }
	    },
	    getTheShowAction: function getTheShowAction(action) {
	      return this.theShowAction === action;
	    },
	    removeOnward: function removeOnward() {
	      var _this2 = this;
	
	      _docendo2.default.eventRemoveCalendar(this.event.school_id, this.event.event_id, this.calendar.id, function (success) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.substitution.lessons_updated'), 'success': true };
	        _this2.$emit('updateAndClose');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Sorry, that failed', 'success': false };
	        console.log('failure', failure);
	      });
	    },
	    addOnward: function addOnward() {
	      var _this3 = this;
	
	      _docendo2.default.eventAddCalendar(this.event.school_id, this.event.event_id, this.calendar.id, function (success) {
	        _eventbus2.default.toast = { text: _this3.$t('vue2.substitution.lessons_updated'), 'success': true };
	        _this3.$emit('updateAndClose');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Sorry, that failed', 'success': false };
	        console.log('failure', failure);
	      });
	    },
	    replaceOnward: function replaceOnward() {
	      var _this4 = this;
	
	      _docendo2.default.eventReplaceCalendar(this.event.school_id, this.event.event_id, this.calendar.id, this.theReplaceWithCalendarId, function (success) {
	        _eventbus2.default.toast = { text: _this4.$t('vue2.substitution.lessons_updated'), 'success': true };
	        _this4.$emit('updateAndClose');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Sorry, that failed', 'success': false };
	        console.log('failure', failure);
	      });
	    }
	  }
	};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CopyMultipleCalendars = __webpack_require__(1221);
	
	var _CopyMultipleCalendars2 = _interopRequireDefault(_CopyMultipleCalendars);
	
	var _CalendarsBulkArchiveCalendar = __webpack_require__(1217);
	
	var _CalendarsBulkArchiveCalendar2 = _interopRequireDefault(_CalendarsBulkArchiveCalendar);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Print = __webpack_require__(117);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _PresenceForUsers = __webpack_require__(1277);
	
	var _PresenceForUsers2 = _interopRequireDefault(_PresenceForUsers);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CalendarsDeleteEventsInDays = __webpack_require__(1218);
	
	var _CalendarsDeleteEventsInDays2 = _interopRequireDefault(_CalendarsDeleteEventsInDays);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CalendarsDeleteEventsInDays: _CalendarsDeleteEventsInDays2.default,
	    Datepickerrange: _DatePickerRange2.default,
	    PresenceForUsers: _PresenceForUsers2.default, Print: _Print2.default, CopyMultipleCalendars: _CopyMultipleCalendars2.default, CalendarsBulkArchiveCalendar: _CalendarsBulkArchiveCalendar2.default, ChangeSchoolYear: _ChangeSchoolYear2.default
	  },
	  data: function data() {
	    return {
	      selectedView: 'crudCalendars',
	      fromDate: (0, _moment2.default)(),
	      toDate: (0, _moment2.default)()
	    };
	  },
	
	  computed: {
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.$store.getters.kindergartenCalendars;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    roomCalendarsInclArchived: function roomCalendarsInclArchived() {
	      return this.$store.getters.roomCalendarsInclArchived;
	    },
	    mergeCalendarsInclArchived: function mergeCalendarsInclArchived() {
	      return this.$store.getters.mergeCalendarsInclArchived;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    isSchoolDanish: function isSchoolDanish() {
	      return window.SCHOOL.country.toLowerCase() === 'dk';
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userHasPermissionToEditOthersPresence: function userHasPermissionToEditOthersPresence() {
	      return this.userHasPermission('can_edit_others_presence');
	    }
	  },
	  methods: {
	    setFromDate: function setFromDate(date) {
	      this.setDates(date, null);
	    },
	    setToDate: function setToDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.fromDate = start;
	      }
	      if (end) {
	        this.toDate = end;
	      }
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setSelectedView: function setSelectedView(val) {
	      var _this = this;
	
	      if (val === 'printCalendars') {
	        this.selectedView = 'printCalendars';
	        setTimeout(function (_) {
	          _this.setIsPrintCalendarsModal();
	        }, 0);
	      }
	    },
	    setIsPrintCalendarsModal: function setIsPrintCalendarsModal() {
	      _eventbus2.default.isPrintCalendarsModal = true;
	    }
	  }
	};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    calType: {
	      type: String,
	      default: 'klass'
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isAccOpen: false,
	      isArchivedAccOpen: false,
	      theActiveCalId: null,
	      theUpdateCalName: '',
	      theDeleteCalId: null,
	      theDeleteCalName: ''
	    };
	  },
	
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    calendarsExclArchived: function calendarsExclArchived() {
	      return this.calendars.filter(function (calendar) {
	        return !calendar.archived_at;
	      });
	    },
	    archivedCalendars: function archivedCalendars() {
	      return this.calendars.filter(function (calendar) {
	        return calendar.archived_at;
	      });
	    },
	    deleteCalName: function deleteCalName() {
	      return this.theDeleteCalId ? this.allCalendarsInHash[this.theDeleteCalId].name : '';
	    },
	    isDeleteCalValidated: function isDeleteCalValidated() {
	      return this.theDeleteCalName.length > 0 && this.theDeleteCalName === this.deleteCalName;
	    },
	    title: function title() {
	      switch (this.calType) {
	        case 'klass':
	          return this.$t('vue2.common.classes');
	        case 'user':
	          return this.$t('vue2.common.users');
	        case 'room':
	          return this.$t('vue2.common.rooms');
	        case 'merge':
	          return this.$t('vue2.common.merge_calendars');
	        case 'other':
	          return this.$t('vue2.common.other_calendars');
	      }
	    }
	  },
	  methods: {
	    getIsInselectedCalIds: function getIsInselectedCalIds(calId) {
	      return this.selectedCalIds.indexOf(calId) > -1;
	    },
	    toogleCal: function toogleCal(calId) {
	      var idx = this.selectedCalIds.indexOf(calId);
	      if (idx < 0) {
	        this.selectedCalIds.push(calId);
	      } else {
	        this.selectedCalIds.splice(idx, 1);
	      }
	    },
	    toggleAllKlasses: function toggleAllKlasses() {
	      var _this = this;
	
	      if (this.selectedCalIds.length > 0) {
	        this.selectedCalIds = [];
	      } else {
	        this.selectedCalIds = [];
	        this.calendars.forEach(function (calendar) {
	          return _this.selectedCalIds.push(calendar.id);
	        });
	      }
	    },
	    toggleIsAccOpen: function toggleIsAccOpen() {
	      if (!this.isAccOpen) {
	        this.isAccOpen = true;
	      } else {
	        this.isAccOpen = false;
	        this.selectedCalIds = [];
	      }
	    },
	    archiveCal: function archiveCal(calId) {
	      var calObj = {
	        calendarId: calId,
	        changes: { name: this.allCalendarsInHash[calId].name, archived: true }
	      };
	      this.$store.dispatch('updateCalendar', calObj);
	    },
	    deArchiveCal: function deArchiveCal(calId) {
	      var calObj = {
	        calendarId: calId,
	        changes: { name: this.allCalendarsInHash[calId].name, archived: false }
	      };
	      this.$store.dispatch('updateCalendar', calObj);
	    },
	    setEditCal: function setEditCal(calId) {
	      var _this2 = this;
	
	      this.theUpdateCalName = this.allCalendarsInHash[calId].name;
	      this.theActiveCalId = calId;
	      setTimeout(function (_) {
	        _this2.$refs.edit_name_input.focus();
	      }, 500);
	    },
	    closeUpdateCalName: function closeUpdateCalName() {
	      this.theUpdateCalName = '';
	      this.theActiveCalId = null;
	    },
	    updateCalName: function updateCalName() {
	      var archived = this.allCalendarsInHash[this.theActiveCalId].archived_at;
	      var calObj = {
	        calendarId: this.theActiveCalId,
	        changes: { name: this.theUpdateCalName, archived: archived }
	      };
	      this.$store.dispatch('updateCalendar', calObj);
	      this.closeUpdateCalName();
	    },
	    setDeleteCal: function setDeleteCal(calId) {
	      var _this3 = this;
	
	      this.theDeleteCalId = calId;
	      setTimeout(function (_) {
	        _this3.$refs.delete_name_input.focus();
	      }, 500);
	    },
	    closeDeleteCalModal: function closeDeleteCalModal() {
	      this.theDeleteCalId = null;
	      this.theDeleteCalName = '';
	    },
	    deleteCal: function deleteCal() {
	      this.$store.dispatch('deleteCalendar', this.theDeleteCalId);
	      this.closeDeleteCalModal();
	    }
	  },
	  mounted: function mounted() {
	    if (this.isOpen) {
	      this.isAccOpen = true;
	    }
	  }
	};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, Datepickerrange: _DatePickerRange2.default },
	  props: {
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    calType: {
	      type: String,
	      default: 'klass'
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    toDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    fromDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      copyCalType: null,
	      selectedCalIds: [],
	      isDeleteEvents: true,
	      isAccOpen: false,
	      isArchivedAccOpen: false,
	      isDeleting: false
	    };
	  },
	
	  computed: {
	    fromDateAndToDate: function fromDateAndToDate() {
	      return (0, _moment2.default)(this.fromDate).format('L') + ' to ' + (0, _moment2.default)(this.toDate).format('L');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    calendarsExclArchived: function calendarsExclArchived() {
	      return this.calendars.filter(function (calendar) {
	        return !calendar.archived_at;
	      });
	    },
	    archivedCalendars: function archivedCalendars() {
	      return this.calendars.filter(function (calendar) {
	        return calendar.archived_at;
	      });
	    },
	    title: function title() {
	      switch (this.calType) {
	        case 'klass':
	          return this.$t('vue2.common.classes');
	        case 'user':
	          return this.$t('vue2.common.users');
	        case 'room':
	          return this.$t('vue2.common.rooms');
	        case 'merge':
	          return this.$t('vue2.common.merge_calendars');
	        case 'other':
	          return this.$t('vue2.common.other_calendars');
	        default:
	          return this.calType;
	      }
	    }
	  },
	  methods: {
	    getIsInSelectedCalIds: function getIsInSelectedCalIds(calId) {
	      return this.selectedCalIds.indexOf(calId) > -1;
	    },
	    toogleCal: function toogleCal(calId) {
	      var idx = this.selectedCalIds.indexOf(calId);
	      if (idx < 0) {
	        this.selectedCalIds.push(calId);
	      } else {
	        this.selectedCalIds.splice(idx, 1);
	      }
	    },
	    toggleAllKlasses: function toggleAllKlasses() {
	      var _this = this;
	
	      if (this.selectedCalIds.length > 0) {
	        this.selectedCalIds = [];
	      } else {
	        this.selectedCalIds = [];
	        this.calendars.forEach(function (calendar) {
	          return _this.selectedCalIds.push(calendar.id);
	        });
	      }
	    },
	    deleteDays: function deleteDays() {
	      var _this2 = this;
	
	      this.isDeleting = true;
	      var from = (0, _moment2.default)(this.fromDate).startOf('day');
	      var to = (0, _moment2.default)(this.toDate).endOf('day');
	      var index = 0;
	      var cals = JSON.parse((0, _stringify2.default)(this.selectedCalIds));
	      var dInterval = setInterval(function (_) {
	        var calId = cals[index];
	        if (!calId) {
	          clearInterval(dInterval);
	          _this2.isDeleting = false;
	        }
	        var idx = _this2.selectedCalIds.indexOf(calId);
	        _this2.selectedCalIds.splice(idx, 1);
	        index++;
	        if (calId) {
	          var calName = _this2.allCalendarsInHash[calId] ? _this2.allCalendarsInHash[calId].name : '';
	          _docendo2.default.deleteEventsRange(calId, from, to, function (success) {
	            _eventbus2.default.toast = { text: 'Deleted days in ' + calName, success: true };
	          }, function (failure) {
	            _eventbus2.default.toast = { text: 'Something went wrong!', success: false };
	            console.log('failed', failure);
	          });
	        }
	      }, 1000);
	    },
	    toggleIsAccOpen: function toggleIsAccOpen() {
	      if (!this.isAccOpen) {
	        this.isAccOpen = true;
	      } else {
	        this.isAccOpen = false;
	        this.selectedCalIds = [];
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.isOpen) {
	      this.isAccOpen = true;
	    }
	  }
	};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PresenceUser = __webpack_require__(70);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _ExportCalendar = __webpack_require__(83);
	
	var _ExportCalendar2 = _interopRequireDefault(_ExportCalendar);
	
	var _DWeekplan = __webpack_require__(343);
	
	var _DWeekplan2 = _interopRequireDefault(_DWeekplan);
	
	var _WeekSelecter = __webpack_require__(89);
	
	var _WeekSelecter2 = _interopRequireDefault(_WeekSelecter);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DCalendarShowEvent = __webpack_require__(68);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	var _DCalendar = __webpack_require__(58);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _UserTasks = __webpack_require__(44);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _SelectCalendar = __webpack_require__(353);
	
	var _SelectCalendar2 = _interopRequireDefault(_SelectCalendar);
	
	var _CopyCalendarRotate = __webpack_require__(300);
	
	var _CopyCalendarRotate2 = _interopRequireDefault(_CopyCalendarRotate);
	
	var _DCalendarHeader = __webpack_require__(301);
	
	var _DCalendarHeader2 = _interopRequireDefault(_DCalendarHeader);
	
	var _DeleteDayOrWeek = __webpack_require__(306);
	
	var _DeleteDayOrWeek2 = _interopRequireDefault(_DeleteDayOrWeek);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DeleteDayOrWeek: _DeleteDayOrWeek2.default,
	    DCalendarHeader: _DCalendarHeader2.default,
	    CopyCalendarRotate: _CopyCalendarRotate2.default,
	    DCalendarShowEvent: _DCalendarShowEvent2.default,
	    SelectCalendar: _SelectCalendar2.default,
	    UserTasks: _UserTasks2.default,
	    DWeekplan: _DWeekplan2.default,
	    DCalendar: _DCalendar2.default,
	    Loader: _Loader2.default,
	    Spinner: _Spinner2.default,
	    UserPresence: _PresenceUser2.default,
	    ExportCalendar: _ExportCalendar2.default,
	    weekSelector: _WeekSelecter2.default
	  },
	  props: {
	    calendarId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isShowWeekends: false,
	      startTime: '06:00:00',
	      endTime: '16:00:00',
	      isInPrintMode: false,
	      isCalendarInPrintMode: false,
	      calendarDates: [],
	      isDragging: false,
	      debounceTimer: null,
	      clickCount: 0,
	      clickCountTimer: null,
	      isLockedFromFrontend: false,
	      isCopyCalendarModalOpen: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    isDeviceMobile: function isDeviceMobile() {
	      return this.$store.state.isDeviceMobile;
	    },
	    theActiveCalendarId: function theActiveCalendarId() {
	      return this.calendarId ? this.calendarId : this.$route.params.calendar_id;
	    },
	    isUsersCalendar: function isUsersCalendar() {
	      return this.theActiveCalendarId === this.user.user_calendar_id;
	    },
	    calendar: function calendar() {
	      return this.$store.getters.activeCalendar;
	    },
	    firstDayOfWeek: function firstDayOfWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    },
	    isLocked: function isLocked() {
	      return this.calendar && this.calendar.locked;
	    },
	    calendarName: function calendarName() {
	      return this.calendar ? this.calendar.name : '';
	    },
	    isEditable: function isEditable() {
	      return !this.isLockedFromFrontend;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    isShowWeekPlan: function isShowWeekPlan() {
	      return this.calendar && this.calendar.type === 'klass' || this.calendar && this.calendar.type === 'user' || this.calendar && this.calendar.type === 'other';
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    events: function events() {
	      return this.$store.state.calendar.events;
	    },
	    availabilityEvents: function availabilityEvents() {
	      return this.$store.state.calendar.availabilityEvents;
	    },
	    dCalendarEvents: function dCalendarEvents() {
	      if (this.isDragging) {
	        return this.events.concat(this.availabilityEvents);
	      } else {
	        return this.events;
	      }
	    },
	    isEventsLoading: function isEventsLoading() {
	      return this.$store.state.calendar.isEventsLoading;
	    },
	    activeCalendarDate: function activeCalendarDate() {
	      return (0, _moment2.default)(this.$store.state.calendar.date).format('YYYY-MM-DD');
	    },
	    activeEvent: function activeEvent() {
	      return this.$store.getters.activeCalendarEvent;
	    },
	    iCalUrl: function iCalUrl() {
	      if (this.calendar && this.calendar.ical_url) {
	        return window.location.origin + this.calendar.ical_url;
	      } else if (this.calendar && this.calendar.ical_link) {
	        return window.location.origin + this.calendar.ical_link;
	      } else {
	        return 'loading';
	      }
	    },
	    isNotThisWeek: function isNotThisWeek() {
	      return (0, _moment2.default)(this.$store.state.calendar.date).isoWeek() === (0, _moment2.default)().isoWeek();
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    weekSelectorStartDate: function weekSelectorStartDate() {
	      var calType = this.calendar ? this.calendar.type : 'klass';
	      if (this.activeSchoolYear) {
	        if (calType === 'klass') {
	          return (0, _moment2.default)(this.activeSchoolYear.student_time_start).startOf('isoweek');
	        } else {
	          return (0, _moment2.default)(this.activeSchoolYear.employee_time_start).startOf('isoweek');
	        }
	      }
	    },
	    weekSelectorEndDate: function weekSelectorEndDate() {
	      var endDate = this.calendar && this.calendar.end_date ? this.calendar && this.calendar.end_date : (0, _moment2.default)().startOf('isoweek');
	      var calType = this.calendar ? this.calendar.type : 'klass';
	      if (this.activeSchoolYear) {
	        if (calType === 'klass') {
	          endDate = (0, _moment2.default)(this.activeSchoolYear.student_time_end).startOf('isoweek');
	        } else {
	          endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).startOf('isoweek');
	        }
	      }
	      return endDate;
	    },
	    getIsAbsenceEditable: function getIsAbsenceEditable() {
	      var schoolIdsWithoutDeleteFnc = [29045, 40195];
	      return schoolIdsWithoutDeleteFnc.includes(this.schoolId) ? this.userHasPermission('can_manage_users') : true;
	    }
	  },
	  watch: {
	    calendar: function calendar() {
	      if (this.calendar && this.calendar.view_state > -1) {
	        var state = this.calendar.view_state * 1;
	        if (state === 0) {
	          this.startTime = '06:00:00';
	          this.endTime = '18:00:00';
	          this.isShowWeekends = false;
	        } else if (state === 1) {
	          this.startTime = '06:00:00';
	          this.endTime = '18:00:00';
	          this.isShowWeekends = true;
	        } else {
	          this.startTime = '00:00:00';
	          this.endTime = '23:00:00';
	          this.isShowWeekends = true;
	        }
	      }
	    },
	    activeCalendarDate: function activeCalendarDate(val, oldVal) {
	      this.readEvents(true);
	    }
	  },
	  methods: {
	    setIsCopyCalendarModalOpen: function setIsCopyCalendarModalOpen(bool) {
	      this.isCopyCalendarModalOpen = bool;
	    },
	    setCalendarDates: function setCalendarDates(days) {
	      this.calendarDates = days;
	    },
	    setTheView: function setTheView(view) {
	      var hasTasksInUrl = window.location.href.indexOf('?tasks') > 0;
	      if (view === 'tasks' && !hasTasksInUrl) {
	        window.location.href = window.location.href + '?tasks';
	      }
	      if (view === 'calendar' && hasTasksInUrl) {
	        window.location.href = window.location.href.substr(0, window.location.href.indexOf('?tasks'));
	      }
	      this.theView = view;
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    readCalendar: function readCalendar() {
	      this.$store.dispatch('readCalendar', this.theActiveCalendarId);
	    },
	    presenceCall: function presenceCall(arrOfPresenceInWeek) {
	      var _this = this;
	
	      setTimeout(function (_) {
	        _this.readEvents();
	      }, 0);
	    },
	    debounce: function debounce(func, delay) {
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(func, delay);
	    },
	    readEvents: function readEvents(andReadSubjects) {
	      var _this2 = this;
	
	      var firstDay = this.firstDayOfWeek;
	      var lastDay = this.firstDayOfWeek + 6;
	      this.clickCount++;
	      var obj = {
	        calIds: [this.calendarId],
	        start: (0, _moment2.default)(this.activeCalendarDate).isoWeekday(firstDay).format('YYYY-MM-DD 00:00'),
	        end: (0, _moment2.default)(this.activeCalendarDate).isoWeekday(lastDay).endOf('day')
	      };
	      if (andReadSubjects) {
	        obj['andReadSubjects'] = true;
	      }
	      if (this.clickCount === 2) {
	        clearTimeout(this.clickCountTimer);
	      }
	      if (this.clickCount === 1) {
	        this.$store.dispatch('readCalendarEvents', obj);
	        this.clickCountTimer = setTimeout(function () {
	          _this2.clickCount = 0;
	        }, 300);
	      } else {
	        this.debounce(function () {
	          _this2.$store.dispatch('readCalendarEvents', obj);
	          _this2.clickCount = 0;
	        }, 300);
	      }
	    },
	    prevWeek: function prevWeek() {
	      var newDate = (0, _moment2.default)(this.activeCalendarDate).subtract(7, 'days');
	      this.setDate(newDate);
	    },
	    nextWeek: function nextWeek() {
	      var newDate = (0, _moment2.default)(this.activeCalendarDate).add(7, 'days');
	      this.setDate(newDate);
	    },
	    today: function today() {
	      this.setDate((0, _moment2.default)());
	    },
	    setDate: function setDate(date) {
	      this.$store.commit('setActiveCalendarDate', date);
	      this.$helpers.setCookie('do_calendar_current_date', (0, _moment2.default)(date).format('YYYY-MM-DD'));
	    },
	    print: function print() {
	      var _this3 = this;
	
	      this.isCalendarInPrintMode = true;
	      setTimeout(function (_) {
	        _this3.isInPrintMode = true;
	        _this3.$nextTick(function (_) {
	          var prtHtml = document.getElementById('printCalendar').innerHTML;
	
	          var stylesHtml = '';
	
	          var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	          for (var _i = 0; _i < _arr.length; _i++) {
	            var node = _arr[_i];
	            stylesHtml += node.outerHTML;
	          }
	
	          var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	          WinPrint.document.write('<!DOCTYPE html><html><head>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	          var afterPrint = function afterPrint() {
	            WinPrint.close();
	            _this3.isInPrintMode = false;
	            _this3.isCalendarInPrintMode = false;
	          };
	          WinPrint.onafterprint = afterPrint;
	          setTimeout(function (_) {
	            WinPrint.document.close();
	            WinPrint.focus();
	            WinPrint.print();
	          }, 1000);
	        }, 500);
	      });
	    },
	    setActiveEvent: function setActiveEvent(event) {
	      this.$store.commit('setActiveCalendarEventId', event.obj.event_id);
	    },
	    closeShowEvent: function closeShowEvent() {
	      this.$store.commit('setActiveCalendarEventId', null);
	    },
	    handleKeyDown: function handleKeyDown(evt) {
	      if (evt.key === 'ArrowLeft' && (evt.ctrlKey || evt.metaKey)) {
	        evt.preventDefault();
	        this.prevWeek();
	        return;
	      }
	      if (evt.key === 'ArrowRight' && (evt.ctrlKey || evt.metaKey)) {
	        evt.preventDefault();
	        this.nextWeek();
	        return;
	      }
	    },
	    setIsDragging: function setIsDragging(bool) {
	      this.isDragging = bool;
	    },
	    setIsLockedFromFrontend: function setIsLockedFromFrontend() {
	      this.isLockedFromFrontend = !this.isLockedFromFrontend;
	      this.readEvents();
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.commit('setActiveCalendarId', this.calendarId);
	    this.readCalendar();
	    var cookieDate = this.$helpers.getCookie('do_calendar_current_date');
	    if (cookieDate && (0, _moment2.default)(cookieDate).isValid()) {
	      this.$store.commit('setActiveCalendarDate', cookieDate);
	      if ((0, _moment2.default)(cookieDate).format('YYYY-MM-DD') === (0, _moment2.default)(this.date).format('YYYY-MM-DD')) {
	        this.readEvents();
	      }
	    } else {
	      this.$store.commit('setActiveCalendarDate', (0, _moment2.default)().format('YYYY-MM-DD'));
	      this.readEvents();
	    }
	    var theDevice = this.$helpers.checkUserDevice();
	    if (theDevice === 'Mobile') {
	      this.isLockedFromFrontend = true;
	      this.$store.commit('setIsDeviceMobile', true);
	      document.querySelector('body').classList.add('device--is-mobile');
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('analyticsOnVisitedCalendar');
	  },
	  created: function created() {
	    document.removeEventListener('keydown', this.handleKeyDown);
	    document.addEventListener('keydown', this.handleKeyDown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.handleKeyDown);
	  }
	};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CalendarOnMobileGuides = __webpack_require__(1267);
	
	var _CalendarOnMobileGuides2 = _interopRequireDefault(_CalendarOnMobileGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    external_view: 'Ekstern visning',
	    calendars: 'Kalendere',
	    absent_today: 'Dagens fraværende',
	    show_absent_today: 'Vis dagens fraværende på infoskærm',
	    show_absent_today_desc: 'Ønsker I at vise information om dagens fraværende på infoskærm, kan nedenstående link bruges til opsætningen.',
	    show_selected_schedules: 'Vis udvalgte skemaer',
	    show_selected_schedules_desc: 'For at vise skemaer til elever og forældre kan I linke til skemaerne direkte fra jeres hjemmeside med dette link',
	    show_selected_schedules_desc_with_students: 'For at vise skemaer til klasser, elever og forældre kan du dele nedenstående link på skolens hjemmeside eller lignende. Individuelle elevskemaer vil ikke blive delt via dette fælles link, men kan deles via sit eget unikke link, som kan findes ved at klikke på klassen i listen nedenfor.',
	    selected_the_schedules: 'Vælg hvilke kalendere som skal være synlige på hjemmesiden og via direkte link',
	    selected_the_schedules_with_students: 'Vælg hvilke skemaer for klasser og lokaler, der skal være synlige via linket ovenfor, og hvilke skemaer for elever der kan deles via et unikt direkte link.',
	    visible_via_link: 'Synlig via link',
	    visible_via_link_tooltip: 'Et unikt link til kalenderen, som f.eks. elever og forældre kan tilgå uden at skulle logge ind i Docendo. Klik for at se guide for mobil.',
	    schedules_on_desktop_mobile: 'Skema på desktop, iPad, Mobil',
	    schedules_on_desktop_mobile_tooltip: 'Lektioner i kalenderen vil kun være synlige til og med denne dato. Hvis der ikke er sat en dato, vil alle lektioner blive vist.',
	    show_schedules_until: 'Vis skemaer til og med',
	    integrations_with_google: 'Integration med Apple Calendar, Google mfl. Klik for at se guide',
	    grades: 'Klasser',
	    grade: 'Klasse',
	    unselect: 'Fravælg',
	    select: 'Vælg',
	    all: 'Alle',
	    no_grades_created: 'Der er ikke oprettet nogen klasser',
	    copy_calendar_link: 'Kopier kalenderlink',
	    copied: 'Kopieret',
	    no_end_date: 'Ingen slutdato. Alt vises.',
	    set_a_date: 'Sæt en slutdato',
	    remove_end_date: 'Fjern slutdato',
	    copy_ical_link: 'Kopier iCal-link',
	    room: 'Lokale',
	    rooms: 'Lokaler',
	    no_rooms_created: 'Der er ikke oprettet nogen lokaler',
	    access_schedule_without_login: 'Skal kalenderen kunne tilgås via et unikt link uden login?',
	    student: 'elev',
	    students: 'elever',
	    user: 'bruger',
	    users: 'brugere',
	    no_users_created: 'Der er ikke oprettet nogen brugere',
	    other: 'Andre kalendere',
	    no_other_created: 'Der er ikke oprettet nogen andre kalendere',
	    club: 'SFO',
	    no_club_created: 'Der er ikke oprettet nogen SFO kalendere',
	    merge_calendars: 'Fletteskemaer',
	    merge_calendar: 'Fletteskema',
	    no_merge_created: 'Der er ikke oprettet nogen flettekalendere',
	    use_update_in_url: 'Hvis du ønsker, at de offentlige skemaer automatisk skal hente lektioner hvert 5. minut, skal du tilføje ?update i slutningen af den offentlige URL-adresse.'
	  },
	  en: {
	    external_view: 'External view',
	    calendars: 'Calendars',
	    absent_today: 'Todays absent teachers',
	    show_absent_today: 'Show todays absent teachers',
	    show_absent_today_desc: 'Use link below to display information about absent teachers on info screen.',
	    show_selected_schedules: 'Display selected calendars',
	    show_selected_schedules_desc: 'To show calendars to students and parents, you can link to the calendars directly from your website with this link',
	    show_selected_schedules_desc_with_students: 'To show schedules to students and parents, you can share the link below on the school\'s website or similar. Individual student schedules will not be shared via this common link, but can be shared via their own unique link, which can be found by clicking on the grade/group in the list below.',
	    selected_the_schedules: 'Choose which calendars should be visible on the website and via direct public link',
	    selected_the_schedules_with_students: 'Choose which schedules for grades/groups and rooms are to be visible via the link above, and which student schedules can be shared via a unique direct link.',
	    visible_via_link: 'Visible via link',
	    visible_via_link_tooltip: 'A unique link to the calendar, such as students and parents can access without having to log in to Docendo. Click to view mobile guide.',
	    schedules_on_desktop_mobile: 'Schedules on desktop, iPad, mobile',
	    schedules_on_desktop_mobile_tooltip: 'Lessons in the calendar will only be visible up to and including this date. If no date is set, all lessons will be displayed.',
	    show_schedules_until: 'Show schedules until',
	    integrations_with_google: 'Integration with Apple Calendar, Google, etc. Click to view guide',
	    grades: 'Grades/groups',
	    grade: 'Grade/group',
	    unselect: 'Deselect',
	    select: 'Select',
	    all: 'All',
	    no_grades_created: 'No grades/groups created',
	    copy_calendar_link: 'Copy calendar link',
	    copied: 'Copied',
	    no_end_date: 'No end date. All lesson will be shown.',
	    set_a_date: 'Set an end date',
	    remove_end_date: 'Remove end date',
	    copy_ical_link: 'Copy iCal-link',
	    room: 'Room',
	    rooms: 'Rooms',
	    no_rooms_created: 'No rooms created',
	    access_schedule_without_login: 'Make the calendar accessible via a unique link without login?',
	    student: 'student',
	    students: 'students',
	    user: 'user',
	    users: 'users',
	    no_users_created: 'No users created',
	    other: 'Other calendars',
	    no_other_created: 'No other calendars are created',
	    club: 'Club',
	    no_club_created: 'No club calendars are created',
	    merge_calendars: 'Merge Calendars',
	    merge_calendar: 'Merge Calendar',
	    no_merge_created: 'No merge calendars have been created',
	    use_update_in_url: 'If you want the public schedules to automatically fetch lessons every 5 minutes, you need to add ?update at the end of the public URL address.'
	  },
	  nb: {
	    external_view: 'Ekstern visning',
	    calendars: 'Kalendere',
	    absent_today: 'Dagens fraværende',
	    show_absent_today: 'Vis dagens fraværende',
	    show_absent_today_desc: 'Informasjon om dagens fraværende undervisere kan vises på f.eks infoskjerm. Bruk linken under til oppsetting.',
	    show_selected_schedules: 'Vis valgte timeplaner',
	    show_selected_schedules_desc: 'For å vise timeplaner til klasser, elever og foresatte, kan man dele linken under på skolens hjemmeside eller lignende. Individuelle elevtimeplaner vil ikke deles via denne felles linken, men kan deles via egen unik link, som man finner ved å trykke på klassen i listen under.',
	    show_selected_schedules_desc_with_students: 'For å vise timeplaner til klasser, elever og foresatte, kan man dele linken under på skolens hjemmeside eller lignende. Individuelle elevtimeplaner vil ikke deles via denne felles linken, men kan deles via egen unik link, som man finner ved å trykke på klassen i listen under.',
	    selected_the_schedules: 'Velg hvilke timeplaner for klasser og rom som skal være synlige via linken over, og hvilke timeplaner til elever som kan deles via unik direktelink.',
	    selected_the_schedules_with_students: 'Velg hvilke timeplaner for klasser og rom som skal være synlige via linken over, og hvilke timeplaner til elever som kan deles via unik direktelink.',
	    visible_via_link: 'Synlig via link',
	    visible_via_link_tooltip: 'En unik lenke til kalenderen, som f.eks elever og foreldre kan få tilgang uten å måtte logge på Docendo. Klikk for å se mobilguide.',
	    schedules_on_desktop_mobile: 'Timeplan på desktop, iPad, Mobil',
	    schedules_on_desktop_mobile_tooltip: 'Leksjoner i kalenderen vil kun være synlige til og med denne datoen. Hvis ingen dato er satt, vil alle leksjoner vises.',
	    show_schedules_until: 'Vis timeplaner til og med',
	    integrations_with_google: 'Integrasjon med Apple Calendar, Google, etc. Klikk for å se veiledningen',
	    grades: 'Klasser',
	    grade: 'Klasse',
	    unselect: 'Opphev',
	    select: 'Velg',
	    all: 'alle',
	    no_grades_created: 'Der er ikke opprettet noen klasser',
	    copy_calendar_link: 'Kopier kalenderlenken',
	    copied: 'Kopiert',
	    no_end_date: 'Ingen sluttdato. Alt vises.',
	    set_a_date: 'Angi en sluttdato',
	    remove_end_date: 'Fjern sluttdatoen',
	    copy_ical_link: 'Kopier iCal-lenken',
	    room: 'Rom',
	    rooms: 'Rom',
	    no_rooms_created: 'Der er ikke opprettet noen rom',
	    access_schedule_without_login: 'Kalenderen skal være tilgjengelig via en unik lenke uten pålogging?',
	    student: 'elev',
	    students: 'elever',
	    user: 'bruker',
	    users: 'brukere',
	    no_users_created: 'Der er ikke opprettet noen brukere',
	    other: 'Andre kalendere',
	    no_other_created: 'Der er ikke opprettet noen andre kalendere',
	    club: 'SFO',
	    no_club_created: 'Der er ikke opprettet noen SFO kalendere',
	    merge_calendars: 'Fellestimeplaner',
	    merge_calendar: 'Fellestimeplan',
	    no_merge_created: 'Der er ikke opprettet noen fellestimeplaner',
	    use_update_in_url: 'Hvis du vil at offentlige timeplaner automatisk skal hente leksjoner hvert 5. minutt, må du legge til ?update på slutten av den offentlige URL-adressen.'
	  }
	};
	exports.default = {
	  components: { CalendarOnMobileGuides: _CalendarOnMobileGuides2.default, Loader: _Loader2.default, AppToggle: _AppToggle2.default, DateSelector: _DateSelector2.default },
	  props: {
	    absence: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      theActiveKlassCalendar: null,
	      isShowICalGuide: false,
	      isShowMobileGuide: false,
	      theActiveDatePickerId: null,
	      theActiveDatepickerDate: null,
	      isToggleLoading: '',
	      theActiveTab: 0,
	      isShowKlass: true,
	      isShowRooms: false,
	      isShowUsers: false,
	      isShowOtherCalendars: false,
	      isShowClubCalendars: false,
	      isShowMergeCalendars: false
	    };
	  },
	
	  watch: {
	    isUpdatingCalendars: function isUpdatingCalendars(val) {
	      if (!val) {
	        this.isToggleLoading = '';
	      }
	    }
	  },
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    locale: function locale() {
	      return window.USER.language;
	    },
	    isUpdatingCalendars: function isUpdatingCalendars() {
	      return this.$store.state.isUpdatingCalendars;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoadingCalendars: function isLoadingCalendars() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    roomCalendars: function roomCalendars() {
	      return this.$store.getters.roomCalendars;
	    },
	    roomCalendarsWithProps: function roomCalendarsWithProps() {
	      var _this = this;
	
	      return this.roomCalendars.map(function (calendar) {
	        _this.$set(calendar, 'v_public_link', _this.generatePublicLink(calendar));
	        _this.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    otherCalendarsWithProps: function otherCalendarsWithProps() {
	      var _this2 = this;
	
	      return this.otherCalendars.map(function (calendar) {
	        _this2.$set(calendar, 'v_public_link', _this2.generatePublicLink(calendar));
	        _this2.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this2.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    clubCalendars: function clubCalendars() {
	      return this.$store.getters.clubCalendars;
	    },
	    clubCalendarsWithProps: function clubCalendarsWithProps() {
	      var _this3 = this;
	
	      return this.clubCalendars.map(function (calendar) {
	        _this3.$set(calendar, 'v_public_link', _this3.generatePublicLink(calendar));
	        _this3.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this3.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    mergeCalendars: function mergeCalendars() {
	      return this.$store.getters.mergeCalendars;
	    },
	    mergeCalendarsWithProps: function mergeCalendarsWithProps() {
	      var _this4 = this;
	
	      return this.mergeCalendars.map(function (calendar) {
	        _this4.$set(calendar, 'v_public_link', _this4.generatePublicLink(calendar));
	        _this4.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this4.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    userCalendarsWithProps: function userCalendarsWithProps() {
	      var _this5 = this;
	
	      return this.userCalendars.map(function (calendar) {
	        _this5.$set(calendar, 'v_public_link', _this5.generatePublicLink(calendar));
	        _this5.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this5.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    studentCalendars: function studentCalendars() {
	      return this.$store.getters.studentCalendars;
	    },
	    studentCalendarsWithProps: function studentCalendarsWithProps() {
	      var _this6 = this;
	
	      return this.studentCalendars.map(function (calendar) {
	        _this6.$set(calendar, 'v_public_link', _this6.generatePublicLink(calendar));
	        _this6.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this6.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    activeStudentCalenders: function activeStudentCalenders() {
	      var _this7 = this;
	
	      return this.studentCalendarsWithProps.filter(function (student) {
	        return student.klasses && student.klasses.indexOf(_this7.theActiveKlassCalendar) > -1;
	      });
	    },
	    calendars: function calendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    klassCalendarsWithAnonymousAccess: function klassCalendarsWithAnonymousAccess() {
	      return this.calendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyKlassCalendarsWithAnonymousAccess: function isAnyKlassCalendarsWithAnonymousAccess() {
	      return this.klassCalendarsWithAnonymousAccess.length > 0;
	    },
	    roomCalendarsWithAnonymousAccess: function roomCalendarsWithAnonymousAccess() {
	      return this.roomCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyRoomCalendarsWithAnonymousAccess: function isAnyRoomCalendarsWithAnonymousAccess() {
	      return this.roomCalendarsWithAnonymousAccess.length > 0;
	    },
	    otherCalendarsWithAnonymousAccess: function otherCalendarsWithAnonymousAccess() {
	      return this.otherCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyOtherCalendarsWithAnonymousAccess: function isAnyOtherCalendarsWithAnonymousAccess() {
	      return this.otherCalendarsWithAnonymousAccess.length > 0;
	    },
	    clubCalendarsWithAnonymousAccess: function clubCalendarsWithAnonymousAccess() {
	      return this.clubCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyClubCalendarsWithAnonymousAccess: function isAnyClubCalendarsWithAnonymousAccess() {
	      return this.clubCalendarsWithAnonymousAccess.length > 0;
	    },
	    mergeCalendarsWithAnonymousAccess: function mergeCalendarsWithAnonymousAccess() {
	      return this.mergeCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyMergeCalendarsWithAnonymousAccess: function isAnyMergeCalendarsWithAnonymousAccess() {
	      return this.mergeCalendarsWithAnonymousAccess.length > 0;
	    },
	    userCalendarsWithAnonymousAccess: function userCalendarsWithAnonymousAccess() {
	      return this.userCalendars.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyUserCalendarsWithAnonymousAccess: function isAnyUserCalendarsWithAnonymousAccess() {
	      return this.userCalendarsWithAnonymousAccess.length > 0;
	    },
	    activeStudentCalendersWithAnonymousAccess: function activeStudentCalendersWithAnonymousAccess() {
	      return this.activeStudentCalenders.filter(function (calendar) {
	        return calendar.anonymous_access;
	      });
	    },
	    isAnyActiveStudentCalendersWithAnonymousAccess: function isAnyActiveStudentCalendersWithAnonymousAccess() {
	      return this.activeStudentCalendersWithAnonymousAccess.length > 0;
	    },
	    calendarsWithProps: function calendarsWithProps() {
	      var _this8 = this;
	
	      return this.calendars.map(function (calendar) {
	        _this8.$set(calendar, 'v_is_open', _this8.theActiveKlassCalendar === calendar.id);
	        _this8.$set(calendar, 'v_public_link', _this8.generatePublicLink(calendar));
	        _this8.$set(calendar, 'v_ical_link', window.location.origin + calendar.ical_link);
	        _this8.$set(calendar, 'v_formatted_date', calendar.published_until ? (0, _moment2.default)(calendar.published_until).locale(window.USER.locale).format('DD. MMMM YYYY') : null);
	        return calendar;
	      });
	    },
	    publicLink: function publicLink() {
	      return window.location.origin + '/schools/' + window.SCHOOL.id + '/public_calendars';
	    }
	  },
	  methods: {
	    generatePublicLink: function generatePublicLink(calendar) {
	      return window.location.origin + '/calendar/' + calendar.public_id;
	    },
	    setActiveKlassCalendar: function setActiveKlassCalendar(calendar) {
	      if (calendar.students && calendar.students.length < 1) {
	        return;
	      }
	      if (this.theActiveKlassCalendar === calendar.id) {
	        this.theActiveKlassCalendar = null;
	      } else {
	        this.theActiveKlassCalendar = calendar.id;
	      }
	    },
	    setTheActiveTab: function setTheActiveTab(num) {
	      this.theActiveTab = num;
	    },
	    setActiveDatePicker: function setActiveDatePicker(calendar) {
	      if (calendar.published_until) {
	        this.theActiveDatePickerDate = (0, _moment2.default)(calendar.published_until).format('YYYY-MM-DD');
	      } else {
	        this.theActiveDatePickerDate = (0, _moment2.default)(this.activeSchoolYear.student_time_end).format('YYYY-MM-DD');
	      }
	      this.theActiveDatePickerId = calendar.id;
	    },
	    closeDatepicker: function closeDatepicker(calendar) {
	      this.theActiveDatePickerDate = null;
	      this.theActiveDatePickerId = null;
	    },
	    updatePublishUntilDate: function updatePublishUntilDate(calendar, theDate) {
	      var calendars = [{
	        calendar_id: calendar.id,
	        published_until: theDate,
	        anonymous_access: calendar.anonymous_access
	      }];
	      this.$store.dispatch('updateSchoolCalendars', calendars);
	      this.closeDatepicker();
	    },
	    deleteActiveDatePicker: function deleteActiveDatePicker(calendar) {
	      this.updatePublishUntilDate(calendar, null);
	      this.closeDatepicker();
	    },
	    toggleAllKlassCalendars: function toggleAllKlassCalendars() {
	      var _this9 = this;
	
	      this.isToggleLoading = 'klass';
	      var calendars = this.calendars;
	      if (this.isAnyKlassCalendarsWithAnonymousAccess) {
	        calendars = this.klassCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this9.isAnyKlassCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllUsersCalendars: function toggleAllUsersCalendars() {
	      var _this10 = this;
	
	      this.isToggleLoading = 'users';
	      var calendars = this.userCalendars;
	      if (this.isAnyUserCalendarsWithAnonymousAccess) {
	        calendars = this.userCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this10.isAnyUserCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllRoomCalendars: function toggleAllRoomCalendars() {
	      var _this11 = this;
	
	      this.isToggleLoading = 'rooms';
	      var calendars = this.roomCalendars;
	      if (this.isAnyRoomCalendarsWithAnonymousAccess) {
	        calendars = this.roomCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this11.isAnyRoomCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllOtherCalendars: function toggleAllOtherCalendars() {
	      var _this12 = this;
	
	      this.isToggleLoading = 'other';
	      var calendars = this.otherCalendars;
	      if (this.isAnyOtherCalendarsWithAnonymousAccess) {
	        calendars = this.otherCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this12.isAnyOtherCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllClubCalendars: function toggleAllClubCalendars() {
	      var _this13 = this;
	
	      this.isToggleLoading = 'club';
	      var calendars = this.clubCalendars;
	      if (this.isAnyClubCalendarsWithAnonymousAccess) {
	        calendars = this.clubCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this13.isAnyClubCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllMergeCalendars: function toggleAllMergeCalendars() {
	      var _this14 = this;
	
	      this.isToggleLoading = 'merge';
	      var calendars = this.mergeCalendars;
	      if (this.isAnyMergeCalendarsWithAnonymousAccess) {
	        calendars = this.mergeCalendarsWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this14.isAnyMergeCalendarsWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAllStudentCalendars: function toggleAllStudentCalendars() {
	      var _this15 = this;
	
	      this.isToggleLoading = 'students';
	      var calendars = this.activeStudentCalenders;
	      if (this.isAnyActiveStudentCalendersWithAnonymousAccess) {
	        calendars = this.activeStudentCalendersWithAnonymousAccess;
	      }
	      var cals = calendars.map(function (calendar) {
	        var cal = {
	          calendar_id: calendar.id,
	          published_until: calendar.published_until,
	          anonymous_access: !_this15.isAnyActiveStudentCalendersWithAnonymousAccess
	        };
	        return cal;
	      });
	      this.$store.dispatch('updateSchoolCalendars', cals);
	    },
	    toggleAnonymousAccess: function toggleAnonymousAccess(calendar) {
	      var calendars = [{
	        calendar_id: calendar.id,
	        published_until: calendar.published_until,
	        anonymous_access: !calendar.anonymous_access
	      }];
	      this.$store.dispatch('updateSchoolCalendars', calendars);
	    },
	    setIsShowICalGuide: function setIsShowICalGuide(boolean) {
	      this.isShowICalGuide = boolean;
	    },
	    setIsShowMobileGuide: function setIsShowMobileGuide(boolean) {
	      this.isShowMobileGuide = boolean;
	    },
	    hideTippy: function hideTippy(tippyEl) {
	      setTimeout(function (_) {
	        tippyEl.hide();
	      }, 1000);
	    },
	    copyToClipboard: function copyToClipboard(link, evt) {
	      navigator.clipboard.writeText(link).then(function (_) {
	        evt.target._tippy.show();
	      }, function (_) {
	        console.log('that totally failed');
	      });
	    }
	  }
	};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vuex = __webpack_require__(13);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(35);
	
	var _CalendarViewDay = __webpack_require__(295);
	
	var _CalendarViewDay2 = _interopRequireDefault(_CalendarViewDay);
	
	var _DCalendarShowEvent = __webpack_require__(68);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	var I18N = {
	  da: {
	    double_booking: 'Dobbeltbooking',
	    double_bookings: 'Dobbeltbookinger',
	    no_double_bookings: 'Ingen dobbeltbookinger denne dato',
	    more: 'mere'
	  },
	  en: {
	    double_booking: 'Doublebooking',
	    double_bookings: 'Doublebookings',
	    no_double_bookings: 'There is no double bookings this date',
	    more: 'more'
	  },
	  nb: {
	    double_booking: 'Dobbeltbooking',
	    double_bookings: 'Dobbeltbookinger',
	    no_double_bookings: 'Ingen dobbeltbookinger denne datoen',
	    more: 'til'
	  }
	};
	
	exports.default = {
	  components: { CalendarViewDay: _CalendarViewDay2.default, Loader: _Loader2.default, DCalendarShowEvent: _DCalendarShowEvent2.default },
	  props: {
	    date: {
	      default: function _default() {
	        return moment().startOf('day');
	      }
	    },
	    show: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      activeTab: 'teachers',
	      collisions: [],
	      eventsWithOverlappingEvents: [],
	      startDate: moment().startOf('day'),
	      endDate: moment().endOf('day'),
	      isLoading: true,
	      activeCalendar: null,
	      locale: window.USER.language ? window.USER.language : 'en',
	      activeEvent: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allCalendarsInHash', 'userCalendars', 'roomCalendars']), {
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    allCalendars: function allCalendars() {
	      return this.$store.state.calendars;
	    },
	    calendarIds: function calendarIds() {
	      return this.allCalendars.map(function (calendar) {
	        return calendar.id;
	      });
	    },
	    formattedDate: function formattedDate() {
	      return moment(this.date).format('LL');
	    },
	    i18n: function i18n() {
	      return I18N;
	    }
	  }),
	  watch: {
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders(val) {
	      if (!val) {
	        this.readCollisions();
	      }
	    },
	    date: function date(val) {
	      this.startDate = moment(val).startOf('day');
	      this.endDate = moment(val).endOf('day');
	      this.readCollisions();
	    },
	    show: function show(val) {
	      if (val) {
	        console.log('collisions:update');
	        this.readCollisions();
	      }
	    }
	  },
	  methods: {
	    closeShowEvent: function closeShowEvent() {
	      this.activeEvent = null;
	    },
	    setActiveTab: function setActiveTab(tab) {
	      this.activeTab = tab;
	      this.readCollisions();
	    },
	    readCollisions: function readCollisions() {
	      var _this = this;
	
	      this.isLoading = true;
	      if (this.calendarIds.length < 1) {
	        return;
	      }
	      _docendo2.default.eventsFromCalendars(this.calendarIds, this.startDate, this.endDate, true, function (success) {
	        var data = success && success.length > 0 ? JSON.parse(success) : [];
	        data = data.filter(function (event) {
	          return event.event_type !== 'presence';
	        });
	        _this.collisions = data.sort(function (a, b) {
	          return moment(a.start).unix() - moment(b.start).unix();
	        });
	        _this.isLoading = false;
	        _this.setCollisionsInGroups(_this.collisions);
	      }, function (failure) {
	        console.log('failure', failure);
	        _this.isLoading = false;
	      });
	    },
	    setCollisionsInGroups: function setCollisionsInGroups(eventsArr) {
	      var _this2 = this;
	
	      this.eventsWithOverlappingEvents = [];
	
	      eventsArr.forEach(function (event) {
	        event.v_start = moment(event.start).format('LT');
	        event.v_end = moment(event.end).format('LT');
	        event.v_overlapping_calendars = [];
	        event.v_overlapping_cals_with_events = {};
	        event.v_calendarIds = event.calendars.map(function (cal) {
	          return cal.calendar_id;
	        });
	        event.v_owner_calendar_name = '';
	        event.v_number_of_overlapping_events = 0;
	        if (_this2.allCalendarsInHash[event.calendar_id]) {
	          event.v_owner_calendar_name = _this2.allCalendarsInHash[event.calendar_id].name;
	        }
	        var range1 = moment.range(event.start, event.end);
	        eventsArr.forEach(function (lesson) {
	          if (lesson.event_id !== event.event_id) {
	            var range2 = moment.range(lesson.start, lesson.end);
	
	            if (range1.overlaps(range2)) {
	              var calIds = lesson.calendars.map(function (cal) {
	                return cal.calendar_id;
	              });
	              event.calendars.forEach(function (eventCal) {
	                var overLapCalId = eventCal.calendar_id;
	
	                if (calIds.indexOf(overLapCalId) > -1) {
	                  if (_this2.allCalendarsInHash[overLapCalId]) {
	                    if (!event.v_overlapping_cals_with_events[overLapCalId]) {
	                      event.v_overlapping_cals_with_events[overLapCalId] = {
	                        idx: (0, _keys2.default)(event.v_overlapping_cals_with_events).length,
	                        calendar: _this2.allCalendarsInHash[overLapCalId],
	                        lessons: [{ v_event_id: lesson.event_id, v_event_title: lesson.title }]
	                      };
	                    } else {
	                      event.v_overlapping_cals_with_events[overLapCalId].lessons.push({
	                        v_event_id: lesson.event_id,
	                        v_event_title: lesson.title
	                      });
	                    }
	                  }
	                  event.v_overlapping_calendars.push(eventCal.calendar_id);
	                }
	              });
	            }
	          }
	          event.v_number_of_overlapping_events = (0, _keys2.default)(event.v_overlapping_cals_with_events).length;
	        });
	        _this2.eventsWithOverlappingEvents.push(event);
	      });
	    }
	  },
	  mounted: function mounted() {
	    if (this.isLoadingSchoolCalenders) {
	      return;
	    }
	    this.readCollisions();
	  }
	};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _Feedback = __webpack_require__(1222);
	
	var _Feedback2 = _interopRequireDefault(_Feedback);
	
	var _SpinnerButton = __webpack_require__(132);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	var _CopyCalendarRotate = __webpack_require__(300);
	
	var _CopyCalendarRotate2 = _interopRequireDefault(_CopyCalendarRotate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calid: {
	      default: 71980
	    },
	    initCalendar: {
	      default: null
	    },
	    activeCalendarDate: {
	      default: null
	    }
	  },
	  mixins: [_vueClickaway.mixin],
	  components: { CopyCalendarRotate: _CopyCalendarRotate2.default, leftPanel: _Feedback2.default, spinner: _SpinnerButton2.default },
	  data: function data() {
	    return {
	      cal: null,
	      calType: '',
	      calCurrentDate: (0, _moment2.default)(),
	      modal: false,
	      copyDate: '',
	      isJustCopied: false,
	      selectedWeeks: [],
	      startPasteWeek: _eventbus2.default.now,
	      feedback: false,
	      notSubmit: false,
	      deleteEvents: true,
	      weeks: [],
	      isLoading: false,
	      calStartDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	      calEndDate: (0, _moment2.default)().format('YYYY-MM-DD')
	    };
	  },
	
	  computed: {
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    schoolIsFromDenmark: function schoolIsFromDenmark() {
	      return this.activeSchool && this.activeSchool.country === 'DK';
	    },
	    schoolFeatures: function schoolFeatures() {
	      return this.activeSchool && this.activeSchool.features ? this.activeSchool.features : [];
	    },
	    isShowCopyCalendarRotate: function isShowCopyCalendarRotate() {
	      return this.schoolFeatures.indexOf('rotating_schedules') > -1;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isBetweenActiveSchoolYear: function isBetweenActiveSchoolYear() {
	      var _this = this;
	
	      var calDateIsWithinThisSchoolYear = null;
	      this.activeSchoolYears.forEach(function (year) {
	        var startDate = void 0;
	        var endDate = void 0;
	        if (_this.calType === 'klass') {
	          startDate = (0, _moment2.default)(year.student_time_start).startOf('isoweek');
	          endDate = (0, _moment2.default)(year.student_time_end).endOf('isoweek');
	        } else {
	          startDate = (0, _moment2.default)(year.employee_time_start).startOf('isoweek');
	          endDate = (0, _moment2.default)(year.employee_time_end).endOf('isoweek');
	        }
	        if ((0, _moment2.default)(_this.calCurrentDate).isSame(startDate) || (0, _moment2.default)(_this.calCurrentDate).isBetween(startDate, endDate)) {
	          calDateIsWithinThisSchoolYear = year;
	        }
	      });
	      return calDateIsWithinThisSchoolYear;
	    },
	    currentDateIsNotWithinCalendarRange: function currentDateIsNotWithinCalendarRange() {
	      return !this.isBetweenActiveSchoolYear && this.activeSchoolYears.length > 0;
	    },
	    showStartPasteWeek: function showStartPasteWeek() {
	      return (0, _moment2.default)(this.startPasteWeek).isSame(this.calStartDate);
	    },
	    noneSelected: function noneSelected() {
	      return this.selectedWeeks.length === 0;
	    },
	    tooptipCopyWeek: function tooptipCopyWeek() {
	      return this.$t('vue2.copycalendar.copiedFrom') + ' ' + (0, _moment2.default)(this.copyDate).isoWeek();
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    }
	  },
	  watch: {
	    activeCalendarDate: function activeCalendarDate() {
	      this.calCurrentDate = this.activeCalendarDate;
	    }
	  },
	  filters: {
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date);
	      var start2 = (0, _moment2.default)(date).format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).add(6, 'days');
	      var endFormat = (0, _moment2.default)(date).add(6, 'days').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    week: function week(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  },
	  methods: {
	    getCalType: function getCalType() {
	      var _this2 = this;
	
	      if (this.initCalendar) {
	        this.cal = this.initCalendar;
	        this.calType = this.initCalendar.type;
	      } else {
	        _docendo2.default.calendar(this.calid, function (data) {
	          _this2.cal = data;
	          _this2.calType = data.type;
	        });
	      }
	    },
	    getCopyDate: function getCopyDate() {
	      var _this3 = this;
	
	      var year = this.schoolYear;
	      if (this.isBetweenActiveSchoolYear) {
	        year = this.isBetweenActiveSchoolYear;
	      }
	      if (this.calType === 'klass') {
	        this.calStartDate = year.student_time_start;
	        this.calEndDate = year.student_time_end;
	      } else {
	        this.calStartDate = year.employee_time_start;
	        this.calEndDate = year.employee_time_end;
	      }
	
	      this.removeAllSelectedWeeks();
	      this.cleanCopyDate();
	      if (this.activeCalendarDate) {
	        this.isJustCopied = true;
	        setTimeout(function () {
	          _this3.isJustCopied = false;
	        }, 3500);
	        this.copyDate = (0, _moment2.default)(this.activeCalendarDate).isoWeekday(this.firstDayOfTheWeek);
	      } else {
	        var calendar = document.querySelectorAll('#calendar_' + this.calid);
	        if (calendar.length === 1) {
	          this.isJustCopied = true;
	          setTimeout(function () {
	            _this3.isJustCopied = false;
	          }, 3500);
	          this.copyDate = calendar[0].dataset.current_date;
	        }
	      }
	      this.openModal();
	    },
	    openModal: function openModal() {
	      this.isLoading = true;
	      this.createWeeks();
	      this.getPasteDate();
	      this.modal = true;
	      this.$emit('copyCalendarModalOpen', true);
	    },
	    createWeeks: function createWeeks() {
	      var start = (0, _moment2.default)(this.calStartDate).day(this.firstDayOfTheWeek);
	      var end = (0, _moment2.default)(this.calEndDate).endOf('isoweek');
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i).day(this.firstDayOfTheWeek);
	        weeks.push({
	          date: date,
	          isSelected: false,
	          serverDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          weekNum: date.isoWeek(),
	          isNow: (0, _moment2.default)(date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW'),
	          isCopyWeek: date.isoWeek() === (0, _moment2.default)(this.copyDate).isoWeek()
	        });
	      }
	      this.weeks = weeks;
	      this.isLoading = false;
	    },
	    setSubmit: function setSubmit(val) {
	      this.notSubmit = val;
	    },
	    getPasteDate: function getPasteDate() {
	      if (this.activeCalendarDate) {
	        var week = (0, _moment2.default)(this.activeCalendarDate).isoWeek();
	        this.startPasteWeek = this.activeCalendarDate;
	        this.selectWeek(this.findWeek(week));
	      } else {
	        var calendar = document.querySelectorAll('#calendar_' + this.calid);
	        if (calendar.length === 1 && this.selectedWeeks.length === 0) {
	          var _week = (0, _moment2.default)(calendar[0].dataset.current_date).isoWeek();
	          this.startPasteWeek = calendar[0].dataset.current_date;
	          this.selectWeek(this.findWeek(_week));
	        }
	      }
	    },
	    selectWeek: function selectWeek(i) {
	      if (i > -1) {
	        if (!this.weeks[i].isSelected && !this.weeks[i].isCopyWeek) {
	          this.selectedWeeks.push(this.weeks[i].serverDate);
	          this.weeks[i].isSelected = true;
	        }
	      }
	    },
	    removeWeek: function removeWeek(i) {
	      this.weeks[i].isSelected = false;
	      var selectedIndex = this.selectedWeeks.indexOf(this.weeks[i].serverDate);
	      this.selectedWeeks.splice(selectedIndex, 1);
	    },
	    toggleWeek: function toggleWeek(index) {
	      if (this.selectedWeeks.length < 1 || this.showStartPasteWeek) {
	        this.startPasteWeek = this.weeks[index].date;
	      }
	      if (!this.weeks[index].isSelected) {
	        this.selectWeek(index);
	      } else {
	        this.removeWeek(index);
	      }
	    },
	    findWeek: function findWeek(weekNum) {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if (this.weeks[i].weekNum === weekNum) {
	          return i;
	        }
	      }
	    },
	    selectAll: function selectAll() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          this.selectWeek(i);
	        }
	      }
	    },
	    selectEvenWeeks: function selectEvenWeeks() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          if (this.isEven(this.weeks[i].date.isoWeek())) {
	            this.selectWeek(i);
	          }
	        }
	      }
	    },
	    selectOddWeeks: function selectOddWeeks() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          if (this.isOdd(this.weeks[i].date.isoWeek())) {
	            this.selectWeek(i);
	          }
	        }
	      }
	    },
	    isEven: function isEven(n) {
	      return (/^-?\d*[02468]$/.test(n)
	      );
	    },
	    isOdd: function isOdd(n) {
	      return (/^-?\d*[13579]$/.test(n)
	      );
	    },
	    removeAllSelectedWeeks: function removeAllSelectedWeeks() {
	      this.selectedWeeks = [];
	      for (var i = 0; i < this.weeks.length; i++) {
	        this.weeks[i].isSelected = false;
	      }
	    },
	    submitWeeks: function submitWeeks() {
	      var _this4 = this;
	
	      this.$store.dispatch('analyticsCopyCalender');
	      if (this.selectedWeeks.length > 0 && !this.notSubmit) {
	        this.close();
	        _eventbus2.default.toast = { text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	        _docendo2.default.calendarCopyWeeks(this.calid, this.copyDate, this.selectedWeeks, this.deleteEvents, [], ['absence', 'presence'], function (data) {
	          _this4.removeAllSelectedWeeks();
	        });
	      }
	    },
	    submitThisWeek: function submitThisWeek() {
	      var _this5 = this;
	
	      this.$store.dispatch('analyticsCopyCalender');
	      this.close();
	      _eventbus2.default.toast = { text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	      var serverDate = (0, _moment2.default)(this.calCurrentDate).format('YYYY-WW');
	      this.selectedWeeks.push(serverDate);
	      _docendo2.default.calendarCopyWeeks(this.calid, this.copyDate, this.selectedWeeks, false, [], ['absence', 'presence'], function (data) {
	        _this5.removeAllSelectedWeeks();
	      });
	    },
	    close: function close() {
	      this.modal = false;
	      this.feedback = false;
	      this.$emit('copyCalendarModalOpen', false);
	    },
	    eraseStartDate: function eraseStartDate() {
	      this.startPasteWeek = this.calStartDate;
	    },
	    cleanCopyDate: function cleanCopyDate() {
	      this.copyDate = '';
	      for (var i = 0; i < this.weeks.length; i++) {
	        this.weeks[i].isCopyWeek = false;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.getCalType();
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    if (this.activeCalendarDate) {
	      this.calCurrentDate = this.activeCalendarDate;
	    } else {
	      window.addEventListener('fullcal_view_or_date_changed', function (e) {
	        _this6.calCurrentDate = e.detail;
	      }, false);
	    }
	  }
	};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CopyMultipleCalendarsCopy = __webpack_require__(299);
	
	var _CopyMultipleCalendarsCopy2 = _interopRequireDefault(_CopyMultipleCalendarsCopy);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { TaggingFilter: _TaggingFilter2.default, CopyButton: _CopyMultipleCalendarsCopy2.default },
	  props: {
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    calType: {
	      type: String,
	      default: 'klass'
	    },
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      copyCalType: null,
	      selectedCalIds: [],
	      selectedWeeks: ['2021-26'],
	      copyDate: '2021-02-08',
	      isDeleteEvents: true,
	      isAccOpen: false,
	      isArchivedAccOpen: false,
	      isCopyOpen: false,
	      appliedFilters: [],
	      tags: []
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    filteredCalendars: function filteredCalendars() {
	      var _this = this;
	
	      if (this.appliedFilters.length < 1) {
	        return this.calendars;
	      }
	      return this.calendars.filter(function (calendar) {
	        return calendar.user_tags.some(function (tag) {
	          return _this.appliedFilters.includes(tag);
	        });
	      });
	    },
	    calendarsExclArchived: function calendarsExclArchived() {
	      return this.filteredCalendars.filter(function (calendar) {
	        return !calendar.archived_at;
	      });
	    },
	    calendarsExclArchivedWithoutFilters: function calendarsExclArchivedWithoutFilters() {
	      return this.calendars.filter(function (calendar) {
	        return !calendar.archived_at;
	      });
	    },
	    archivedCalendars: function archivedCalendars() {
	      return this.filteredCalendars.filter(function (calendar) {
	        return calendar.archived_at;
	      });
	    },
	    title: function title() {
	      switch (this.calType) {
	        case 'klass':
	          return this.$t('vue2.common.classes');
	        case 'user':
	          return this.$t('vue2.common.users');
	        case 'room':
	          return this.$t('vue2.common.rooms');
	        case 'merge':
	          return this.$t('vue2.common.merge_calendars');
	        case 'other':
	          return this.$t('vue2.common.other_calendars');
	      }
	    }
	  },
	  methods: {
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.selectedCalIds = [];
	      this.appliedFilters.push(tag);
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	    },
	    getIsInSelectedCalIds: function getIsInSelectedCalIds(calId) {
	      return this.selectedCalIds.indexOf(calId) > -1;
	    },
	    toogleCal: function toogleCal(calId) {
	      var idx = this.selectedCalIds.indexOf(calId);
	      if (idx < 0) {
	        this.selectedCalIds.push(calId);
	      } else {
	        this.selectedCalIds.splice(idx, 1);
	      }
	    },
	    toggleAllKlasses: function toggleAllKlasses() {
	      var _this2 = this;
	
	      if (this.selectedCalIds.length > 0) {
	        this.selectedCalIds = [];
	      } else {
	        this.selectedCalIds = [];
	        this.filteredCalendars.forEach(function (calendar) {
	          return _this2.selectedCalIds.push(calendar.id);
	        });
	      }
	    },
	    copyCals: function copyCals(objWeeks) {
	      this.copyDate = objWeeks.copyDate;
	      this.selectedWeeks = objWeeks.selectedWeeks;
	      this.isDeleteEvents = objWeeks.isDeleteEvents;
	      this.copyWeeks();
	    },
	    copyWeeks: function copyWeeks(calId) {
	      var _this3 = this;
	
	      if (this.selectedCalIds.length < 1) {
	        return;
	      }
	      _docendo2.default.calendarCopyWeeks(this.selectedCalIds, this.copyDate, this.selectedWeeks, this.isDeleteEvents, [], ['absence', 'presence'], function (data) {
	        _eventbus2.default.toast = { text: 'Kopierer kalendere', success: true };
	        _this3.selectedCalIds = [];
	      });
	    },
	    toggleIsAccOpen: function toggleIsAccOpen() {
	      if (this.isCopyOpen) {
	        return;
	      }
	      if (!this.isAccOpen) {
	        this.isAccOpen = true;
	      } else {
	        this.isAccOpen = false;
	        this.selectedCalIds = [];
	      }
	    },
	    getTags: function getTags() {
	      var _this4 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this4.tags = data;
	      });
	    }
	  },
	  mounted: function mounted() {
	    if (this.isOpen) {
	      this.isAccOpen = true;
	    }
	    if (this.calType === 'user') {
	      this.getTags();
	    }
	  }
	};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _core = __webpack_require__(18);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    calType: {
	      type: String,
	      default: 'klass'
	    },
	    initCopyDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      copyDate: null,
	      calStartDate: null,
	      calEndDate: null,
	      selectedWeeks: [],
	      isDropdown: false,
	      isDropdownPopperDone: false,
	      isDeleteEvents: true
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      var start = 1;
	      if ((0, _typeof3.default)(window.SCHOOL) && window.SCHOOL.first_day_of_week_num !== 'undefined') {
	        start = window.SCHOOL.first_day_of_week_num;
	      }
	      return start;
	    },
	    weeks: function weeks() {
	      var activeSchoolYear = this.localActivatedSchoolYear;
	      if (this.calType === 'klass') {
	        this.calStartDate = activeSchoolYear.student_time_start;
	        this.calEndDate = activeSchoolYear.student_time_end;
	      } else {
	        this.calStartDate = activeSchoolYear.employee_time_start;
	        this.calEndDate = activeSchoolYear.employee_time_end;
	      }
	      var start = (0, _moment2.default)(this.calStartDate).day(this.firstDayOfTheWeek);
	      var end = (0, _moment2.default)(this.calEndDate).endOf('isoweek');
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i).day(this.firstDayOfTheWeek);
	        weeks.push({
	          date: date,
	          serverDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          weekNum: date.isoWeek()
	        });
	      }
	      return weeks;
	    }
	  },
	  methods: {
	    createPopper: function createPopper() {
	      var el = this.$refs.copy_calendars_button;
	
	      (0, _core.createPopper)(el, this.$refs.copy_calendars_panel, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: function offset(_ref) {
	              var placement = _ref.placement,
	                  reference = _ref.reference,
	                  popper = _ref.popper;
	
	              return [0, 5];
	            }
	          }
	        }]
	      });
	    },
	    openDropdown: function openDropdown() {
	      var _this = this;
	
	      if (this.initCopyDate) {
	        this.copyDate = this.initCopyDate;
	      }
	      this.isDropdown = true;
	      this.$emit('open');
	      setTimeout(function (_) {
	        _this.createPopper();
	        _this.isDropdownPopperDone = true;
	      }, 0);
	    },
	    closeDropdown: function closeDropdown() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.isDropdown = false;
	      this.$emit('close');
	      this.isDropdownPopperDone = false;
	      this.selectedWeeks = [];
	      this.calStartDate = null;
	      this.copyDate = null;
	    },
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date);
	      var start2 = (0, _moment2.default)(date).format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).add(6, 'days');
	      var endFormat = (0, _moment2.default)(date).add(6, 'days').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    isWeekSelected: function isWeekSelected(week) {
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      return idx > -1;
	    },
	    isCopyWeek: function isCopyWeek(week) {
	      return this.copyDate ? (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)(this.copyDate).format('GGGG-WW') : false;
	    },
	    isNow: function isNow(week) {
	      return (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW');
	    },
	    setSelectedWeek: function setSelectedWeek(week) {
	      if (!this.copyDate) {
	        this.copyDate = week.date;
	        return;
	      }
	      if (this.isCopyWeek(week)) {
	        this.removeSelectedDate();
	        return;
	      }
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      if (idx < 0) {
	        this.selectedWeeks.push(week.serverDate);
	      } else {
	        this.selectedWeeks.splice(idx, 1);
	      }
	    },
	    removeSelectedDate: function removeSelectedDate() {
	      this.copyDate = null;
	      this.selectedWeeks = [];
	    },
	    showWeek: function showWeek(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    },
	    selectWeek: function selectWeek(week) {
	      if (this.isCopyWeek(week)) {
	        return;
	      }
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      if (idx < 0) {
	        this.selectedWeeks.push(week.serverDate);
	      }
	    },
	    addAllWeeksOnward: function addAllWeeksOnward() {
	      var _this2 = this;
	
	      if (!this.copyDate) {
	        return [];
	      }
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this2.copyDate)) {
	          _this2.selectWeek(week);
	        }
	      });
	    },
	    removeAllSelectedWeeks: function removeAllSelectedWeeks() {
	      this.selectedWeeks = [];
	    },
	    selectEvenWeeks: function selectEvenWeeks() {
	      var _this3 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this3.copyDate)) {
	          if (_this3.isEven(week.date.isoWeek())) {
	            _this3.selectWeek(week);
	          }
	        }
	      });
	    },
	    selectOddWeeks: function selectOddWeeks() {
	      var _this4 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this4.copyDate)) {
	          if (_this4.isOdd(week.date.isoWeek())) {
	            _this4.selectWeek(week);
	          }
	        }
	      });
	    },
	    isEven: function isEven(n) {
	      return (/^-?\d*[02468]$/.test(n)
	      );
	    },
	    isOdd: function isOdd(n) {
	      return (/^-?\d*[13579]$/.test(n)
	      );
	    },
	    submit: function submit() {
	      var obj = {
	        copyDate: this.copyDate,
	        selectedWeeks: this.selectedWeeks,
	        isDeleteEvents: this.isDeleteEvents
	      };
	      this.$emit('submit', obj);
	      this.closeDropdown();
	    }
	  }
	};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { spinner: _Spinner2.default },
	  props: ['selectedWeeks', 'calId', 'deleteEvents'],
	  watch: {
	    selectedWeeks: function selectedWeeks(val, oldVal) {
	      this.checkForNotesAndSubstitutes(val);
	    },
	    isLoading: function isLoading(val, oldVal) {
	      this.$emit('load', val);
	    },
	    deleteEvents: function deleteEvents(val, oldVal) {
	      if (val) {
	        this.checkForNotesAndSubstitutes(this.selectedWeeks);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      lessons: []
	    };
	  },
	
	  computed: {
	    sortedLesson: function sortedLesson() {
	      return this.lessons.sort(function compare(a, b) {
	        var dateA = new Date(a.event_time_start);
	        var dateB = new Date(b.event_time_start);
	        return dateA - dateB;
	      });
	    }
	  },
	  filters: {
	    showDateAndTime: function showDateAndTime(val) {
	      return (0, _moment2.default)(val).format('lll');
	    },
	    showWeek: function showWeek(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  },
	  methods: {
	    checkForNotesAndSubstitutes: function checkForNotesAndSubstitutes(weekNums) {
	      var _this = this;
	
	      if (!this.deleteEvents) {
	        return;
	      }
	      var spinnerTimer = setTimeout(function () {
	        _this.isLoading = true;
	      }, 100);
	      this.lesson = [];
	      _docendo2.default.calendarCopyCheck(this.calId, this.selectedWeeks, function (data) {
	        clearTimeout(spinnerTimer);
	        _this.isLoading = false;
	        _this.lessons = data;
	      });
	    },
	    isSameDate: function isSameDate(index) {
	      if (index > 0) {
	        var l1 = this.sortedLesson[index].event_time_start;
	        var l2 = this.sortedLesson[index - 1].event_time_start;
	        return (0, _moment2.default)(l1).isoWeek() === (0, _moment2.default)(l2).isoWeek();
	      } else {
	        return false;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.selectedWeeks.length > 0) {
	      this.checkForNotesAndSubstitutes(this.selectedWeeks);
	    }
	  }
	};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _CopyCalendarRotateDates = __webpack_require__(1223);
	
	var _CopyCalendarRotateDates2 = _interopRequireDefault(_CopyCalendarRotateDates);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DModal: _DModal2.default, DateSelector: _DateSelector2.default, CopyCalendarRotateDates: _CopyCalendarRotateDates2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    calendarId: {
	      type: Number,
	      default: null
	    },
	    activeCalendarDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isDropdown: false,
	      numberOfDays: 5,
	      daysToCopy: [],
	      isSeeDates: false,
	      pasteDates: [],
	      sourceStartDate: (0, _moment2.default)(),
	      isLoading: false
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.localActivatedSchoolYear.id;
	    },
	    schoolId: function schoolId() {
	      return this.$store ? this.$store.getters.schoolId : window.SCHOOL.id;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    isLoadingSchoolSettings: function isLoadingSchoolSettings() {
	      return this.$store.state.isLoadingSchoolSettings;
	    },
	    initStartPasteDate: function initStartPasteDate() {
	      var lastIdx = this.daysToCopy.length - 1;
	      var lastDate = this.daysToCopy[lastIdx]['date'];
	
	      if ((0, _moment2.default)(lastDate).isoWeekday() === 5) {
	        return (0, _moment2.default)(lastDate).add(3, 'days');
	      } else if ((0, _moment2.default)(lastDate).isoWeekday() === 6) {
	        return (0, _moment2.default)(lastDate).add(2, 'days');
	      } else {
	        return (0, _moment2.default)(lastDate).add(1, 'days');
	      }
	    }
	  },
	  watch: {
	    numberOfDays: function numberOfDays(newValue) {
	      var parsedValue = parseInt(newValue, 10);
	      if (isNaN(parsedValue)) {
	        this.numberOfDays = 1;
	      } else if (parsedValue > 12) {
	        this.numberOfDays = 12;
	      } else if (parsedValue < 1) {
	        this.numberOfDays = 1;
	      } else {
	        this.numberOfDays = parsedValue;
	      }
	    },
	    isLoadingSchoolSettings: function isLoadingSchoolSettings() {
	      this.readSavedSourceDates();
	    }
	  },
	  methods: {
	    setPasteDates: function setPasteDates(arr) {
	      this.pasteDates = arr;
	    },
	    addDay: function addDay() {
	      if (this.numberOfDays < 12) {
	        var lastDate = this.daysToCopy[this.daysToCopy.length - 1]['date'];
	        var nextDate = (0, _moment2.default)(lastDate).add(1, 'days').format('YYYY-MM-DD');
	        var day = { label: 'Day ' + (this.daysToCopy.length * 1 + 1), date: nextDate };
	        this.daysToCopy.push(day);
	        this.numberOfDays = this.daysToCopy.length;
	      }
	    },
	    subtractDay: function subtractDay() {
	      if (this.numberOfDays > 1) {
	        this.daysToCopy.pop();
	        this.numberOfDays = this.daysToCopy.length;
	      }
	    },
	    updateDaysToCopy: function updateDaysToCopy() {
	      var currentDate = this.sourceStartDate;
	      var newDaysToCopy = [];
	
	      for (var i = 0; i < this.numberOfDays; i++) {
	        var day = this.daysToCopy[i] || {};
	        var label = 'Day ' + (i + 1);
	        var date = day.date || (0, _moment2.default)(currentDate).add(i, 'days').format('YYYY-MM-DD');
	        newDaysToCopy.push({ label: label, date: date });
	      }
	      this.daysToCopy = newDaysToCopy;
	    },
	    toggleDropdown: function toggleDropdown() {
	      if (!this.isDropdown) {
	        this.openDropdown();
	      } else {
	        this.closeDropdown();
	      }
	    },
	    openDropdown: function openDropdown() {
	      this.$store.dispatch('readSchoolSettings');
	      this.isDropdown = true;
	    },
	    closeDropdown: function closeDropdown() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.isSeeDates = false;
	      this.isDropdown = false;
	    },
	    setDayToCopyDate: function setDayToCopyDate(date, index) {
	      this.daysToCopy[index].date = (0, _moment2.default)(date).format('YYYY-MM-DD');
	    },
	    saveSourceDates: function saveSourceDates() {
	      var sourceDates = this.daysToCopy.map(function (day) {
	        return day.date;
	      });
	      var saveObj = { rotating_schedules_source_dates: (0, _stringify2.default)(sourceDates) };
	      this.saveSchoolYearSetting(saveObj);
	    },
	    saveSchoolYearSetting: function saveSchoolYearSetting(obj) {
	      this.$store.dispatch('updateSchoolSettingsForSchoolYear', obj);
	    },
	    readSavedSourceDates: function readSavedSourceDates() {
	      var _this = this;
	
	      var settings = this.schoolSettings;
	      var schoolYearId = this.schoolYearId;
	      var propSchoolYear = 'school_year_' + schoolYearId;
	      var propName = 'rotating_schedules_source_dates';
	      if (settings && settings[propSchoolYear] && settings[propSchoolYear][propName]) {
	        var dates = JSON.parse(settings[propSchoolYear][propName]);
	        var arr = dates.map(function (date, i) {
	          return { label: 'Day ' + (i + 1), date: date };
	        });
	        this.numberOfDays = dates.length;
	        setTimeout(function (_) {
	          _this.daysToCopy = arr;
	        }, 0);
	      }
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      var sourceDates = this.daysToCopy.map(function (day) {
	        return day.date;
	      });
	      this.saveSourceDates();
	      var destinationDates = this.pasteDates.filter(function (day) {
	        return day.isIncluded;
	      }).map(function (day) {
	        return day.date;
	      });
	      _docendo2.default.calendarCopyDays(this.schoolId, this.calendarId, sourceDates, destinationDates, function (success) {
	        _eventbus2.default.toast = { text: 'Inserting days', 'success': true };
	        _this2.closeDropdown();
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    }
	  },
	  created: function created() {
	    this.updateDaysToCopy();
	  }
	};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, Datepickerrange: _DatePickerRange2.default },
	  props: {
	    daysToCopy: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {},
	    initStartDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)().add(1, 'days'),
	      vacationsDays: [],
	      datesBetween: [],
	      excludedDates: [],
	      isLoading: true
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.activeSchoolYear.id;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    groupedDatesByMonth: function groupedDatesByMonth() {
	      var groupedDates = {};
	
	      this.datesWithMeta.forEach(function (dateObj) {
	        var month = (0, _moment2.default)(dateObj.date).format('MMMM YYYY');
	        if (!groupedDates[month]) {
	          groupedDates[month] = {
	            dates: [],
	            emptyDays: 0
	          };
	          if (groupedDates[month].emptyDays < 0) {
	            groupedDates[month].emptyDays = 6;
	          }
	          var date = (0, _moment2.default)(dateObj.date);
	          var startOfWeek = date.clone().startOf('isoWeek');
	          var days = date.diff(startOfWeek, 'days');
	          groupedDates[month].emptyDays = days;
	        }
	        groupedDates[month].dates.push(dateObj);
	      });
	
	      return groupedDates;
	    },
	    datesWithMeta: function datesWithMeta() {
	      var _this = this;
	
	      var daysToCopyIndex = 0;
	
	      return this.datesBetween.map(function (dateObj) {
	        var dateMoment = (0, _moment2.default)(dateObj.date);
	        var isWeekend = dateMoment.day() === 6 || dateMoment.day() === 0;
	        var isVacationDay = _this.vacationsDays.includes(dateObj.date);
	        var isExcluded = _this.excludedDates.includes(dateObj.date);
	        var isIncluded = !isWeekend && !isVacationDay && !isExcluded;
	
	        var dayToInsert = null;
	        if (isIncluded) {
	          dayToInsert = _this.daysToCopy[daysToCopyIndex];
	          daysToCopyIndex = (daysToCopyIndex + 1) % _this.daysToCopy.length;
	        }
	
	        return (0, _extends3.default)({}, dateObj, {
	          isWeekend: isWeekend,
	          isVacationDay: isVacationDay,
	          isIncluded: isIncluded,
	          dayToInsert: dayToInsert
	        });
	      });
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.onSchoolYearChanged();
	    },
	    datesWithMeta: function datesWithMeta() {
	      this.$emit('pasteDates', this.datesWithMeta);
	    }
	  },
	  methods: {
	    toggleDate: function toggleDate(dateObj) {
	      var idx = this.excludedDates.indexOf(dateObj.date);
	      if (idx < 0) {
	        this.excludedDates.push(dateObj.date);
	      } else {
	        this.excludedDates.splice(idx, 1);
	      }
	      this.saveExcludedDates(this.excludedDates);
	    },
	    saveExcludedDates: function saveExcludedDates(val) {
	      var propName = 'rotating_schedules_excluded_dates';
	      var saveObj = (0, _defineProperty3.default)({}, propName, (0, _stringify2.default)(val));
	      this.$store.dispatch('updateSchoolSettingsForSchoolYear', saveObj);
	    },
	    getExcludedDates: function getExcludedDates() {
	      var settings = this.schoolSettings;
	      var schoolYearId = this.schoolYearId;
	      var propSchoolYear = 'school_year_' + schoolYearId;
	      var propName = 'rotating_schedules_excluded_dates';
	      if (settings && settings[propSchoolYear] && settings[propSchoolYear][propName]) {
	        var arr = JSON.parse(settings[propSchoolYear][propName]);
	        this.excludedDates = arr;
	      }
	    },
	    createDatesBetween: function createDatesBetween() {
	      var start = (0, _moment2.default)(this.startDate);
	      var end = (0, _moment2.default)(this.endDate);
	      var dates = [];
	
	      while (start.isSameOrBefore(end)) {
	        dates.push({
	          date: start.format('YYYY-MM-DD'),
	          formattedDate: start.format('D')
	        });
	        start.add(1, 'days');
	      }
	      this.datesBetween = dates;
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.createDatesBetween();
	    },
	    readVacationDays: function readVacationDays() {
	      var _this2 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        _this2.vacationsDays = success.map(function (day) {
	          return day.day;
	        });
	        _this2.isLoading = false;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    onSchoolYearChanged: function onSchoolYearChanged() {
	      if (this.activeSchoolYear) {
	        this.setDates(this.activeSchoolYear.student_time_start, this.activeSchoolYear.student_time_end);
	      }
	    },
	    initStartAndEndDate: function initStartAndEndDate() {
	      if (this.initStartDate && this.activeSchoolYear) {
	        this.setDates(this.initStartDate, this.activeSchoolYear.student_time_end);
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.initStartAndEndDate();
	  },
	  created: function created() {
	    this.readVacationDays();
	    this.getExcludedDates();
	  }
	};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(67);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ChangeSchoolYear: _ChangeSchoolYear2.default, Modal: _Modal2.default },
	  data: function data() {
	    return {
	      showModal: false,
	      calendars: [],
	      calendarsWithText: [],
	      someWithSameName: false,
	      openedFromRoRSelect2: false
	    };
	  },
	
	  computed: {
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    calendarTypeIsWithSchoolYear: function calendarTypeIsWithSchoolYear() {
	      var typeHasSchoolYear = ['merge', 'other', 'kindergarten', 'club'];
	      return typeHasSchoolYear.indexOf(this.theCreateCalendarsType) > -1;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    placeholderText: function placeholderText() {
	      switch (this.theCreateCalendarsType) {
	        case 'room':
	          return this.$t('vue2.createrooms.placeholder');
	        case 'other':
	          return this.$t('vue2.create_calendars.other_calendar_placeholder');
	        case 'merge':
	          return this.$t('vue2.createmerge.placeholder');
	        case 'club':
	          return 'Eks. SFO Mosehuset';
	      }
	    },
	    showInactiveButton: function showInactiveButton() {
	      if (this.calendarsWithText.length < 1) {
	        return true;
	      }
	    },
	    theCreateCalendarsType: function theCreateCalendarsType() {
	      return _eventbus2.default.createCalendarsType;
	    },
	    buttonText: function buttonText() {
	      if (this.calendarsWithText.length < 1) {
	        return this.$t('vue2.createusers.create');
	      } else {
	        var calendarsPluralized = this.calendarsWithText.length === 1 ? this.$t('vue2.createmerge.calendar') : this.$t('vue2.createmerge.calendars');
	        if (this.theCreateCalendarsType === 'room') {
	          calendarsPluralized = this.calendarsWithText.length === 1 ? this.$t('vue2.createrooms.room') : this.$t('vue2.createrooms.rooms');
	        }
	        return this.$t('vue2.createusers.create') + ' ' + this.calendarsWithText.length + ' ' + calendarsPluralized;
	      }
	    }
	  },
	  watch: {
	    theCreateCalendarsType: function theCreateCalendarsType() {
	      if (this.theCreateCalendarsType) {
	        this.setShowModal();
	      }
	    }
	  },
	  methods: {
	    setShowModal: function setShowModal() {
	      this.showModal = true;
	      this.pushNewCalendar();
	      this.pushNewCalendar();
	      this.pushNewCalendar();
	      setTimeout(function () {
	        document.querySelector('.namefield').focus();
	      }, 100);
	    },
	    setIsSameInputToFalse: function setIsSameInputToFalse() {
	      if (!this.someWithSameName) {
	        return;
	      } else {
	        this.someWithSameName = false;
	        this.calendars.forEach(function (obj) {
	          obj.isSameName = false;
	        });
	      }
	    },
	    setSameInput: function setSameInput(klassName) {
	      for (var i = 0; i < this.calendars.length; i++) {
	        if (this.calendars[i].name !== '') {
	          if (this.calendars[i].name === klassName) {
	            this.calendars[i].isSameName = true;
	          }
	        }
	      }
	    },
	    checkForSameNameInCalendars: function checkForSameNameInCalendars() {
	      var nbr = 0;
	      for (var i = 0; i < this.calendarsWithText.length; i++) {
	        for (var j = 0; j < this.calendarsWithText.length; j++) {
	          if (j !== i) {
	            if (this.calendarsWithText[i].name === this.calendarsWithText[j].name) {
	              this.setSameInput(this.calendarsWithText[i].name);
	              nbr++;
	            }
	          }
	        }
	      }
	      if (nbr > 0) {
	        this.someWithSameName = true;
	      } else {
	        this.someWithSameName = false;
	      }
	    },
	    setCloseModal: function setCloseModal() {
	      this.showModal = false;
	      _eventbus2.default.createCalendarsType = null;
	      this.calendars = [];
	      this.calendarsWithText = [];
	      this.someWithSameName = false;
	      this.openedFromRoRSelect2 = false;
	    },
	    pushNewCalendar: function pushNewCalendar() {
	      var _this = this;
	
	      this.calendars.push({
	        name: '',
	        type: this.theCreateCalendarsType,
	        isSameName: false
	      });
	      if (this.calendars.length > 4) {
	        setTimeout(function () {
	          _this.scrollInDiv();
	        }, 0);
	      }
	    },
	    removeCalendar: function removeCalendar(cal) {
	      this.calendars.splice(this.calendars.indexOf(cal), 1);
	      this.setIsSameInputToFalse();
	      this.checkForSameNameInCalendars();
	      this.checkAllForText();
	    },
	    scrollInDiv: function scrollInDiv() {
	      var objDiv = document.querySelector('.modal-body');
	      objDiv.scrollTop = objDiv.scrollHeight;
	    },
	    checkAllForText: function checkAllForText($event) {
	      if ($event && $event.key === 'Escape') {
	        this.setCloseModal();
	      }
	      this.setIsSameInputToFalse();
	      this.calendarsWithText = [];
	      for (var i = 0; i < this.calendars.length; i++) {
	        if (this.calendars[i].name.length > 0) {
	          this.calendarsWithText.push(this.calendars[i]);
	        }
	      }
	      if (this.calendarsWithText.length === this.calendars.length) {
	        this.pushNewCalendar();
	      }
	      this.checkForSameNameInCalendars();
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      var isOpenedFromRoRSelect2 = false;
	
	      if (this.openedFromRoRSelect2) {
	        isOpenedFromRoRSelect2 = true;
	      }
	      this.checkForSameNameInCalendars();
	      if (!this.someWithSameName) {
	        _eventbus2.default.toast = { text: this.$t('vue2.createrooms.creating'), 'success': false };
	        var calendarType = this.theCreateCalendarsType;
	        _docendo2.default.schoolBulkCreateCalendars(this.activeSchool.id, this.activeSchoolYear.id, this.calendarsWithText, function (success) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.createmerge.succes_text'), 'success': true };
	          _this2.$store.dispatch('getSchoolCalendars', _this2.activeSchool.id);
	
	          if (calendarType === 'merge') {
	            _this2.$store.dispatch('updateUserSettings', { 'setup_widget_progress_merge': true });
	            setTimeout(function () {
	              _this2.$store.commit('setOnboardingStep', 0);
	            }, 2500);
	          }
	
	          if (calendarType === 'room') {
	            _this2.$store.dispatch('updateUserSettings', { 'setup_widget_progress_rooms': true });
	            setTimeout(function () {
	              _this2.$store.commit('setOnboardingStep', 0);
	            }, 2500);
	            if (isOpenedFromRoRSelect2) {
	              _this2.$helpers.sendCustomEvt('vue_created_room', success[0].calendarable_id);
	            }
	          }
	          if (window.Intercom) {
	            window.Intercom('trackEvent', 'Created calendars: ' + _this2.theCreateCalendarsType);
	          }
	        }, function (errors) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.toast.something_went_wrong'), 'success': false };
	        });
	        this.setCloseModal();
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    window.addEventListener('vueCreateRoom', function (e) {
	      _this3.openedFromRoRSelect2 = true;
	      _this3.calendars.push({
	        name: e.detail,
	        type: 'room',
	        isSameName: false
	      });
	      _eventbus2.default.createRoomModal = true;
	      _this3.checkAllForText();
	    }, false);
	  }
	};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(67);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CreateKlassesSubjectList = __webpack_require__(1226);
	
	var _CreateKlassesSubjectList2 = _interopRequireDefault(_CreateKlassesSubjectList);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _StandardDurationSetting = __webpack_require__(121);
	
	var _StandardDurationSetting2 = _interopRequireDefault(_StandardDurationSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { StandardDurationSetting: _StandardDurationSetting2.default, Modal: _Modal2.default, ShowSubjects: _CreateKlassesSubjectList2.default, ChangeSchoolYear: _ChangeSchoolYear2.default },
	  data: function data() {
	    return {
	      showModal: false,
	      klasses: [],
	      showSubjects: false,
	      subjectsArrowPosition: 100,
	      activeKlassStep: 1,
	      klassStepIsSelected: false,
	      someWithSameName: false,
	      schoolCountry: 'dk',
	      isOpenDurationModal: false,
	      isAwaitingServerResponse: false,
	      debounceTimer: null
	    };
	  },
	
	  computed: {
	    showImportSubjects: function showImportSubjects() {
	      return this.schoolCountry === 'dk' || this.schoolCountry === 'no';
	    },
	    showInactiveButton: function showInactiveButton() {
	      if (this.alreadyCreatedKlassesToImportSubjectTo.length < 1) {
	        if (this.klassesToSubmit.length < 1) {
	          return true;
	        }
	      } else {
	        if (this.subjectsToCreateWhenAlreadyCreatedKlasses.length < 1) {
	          return true;
	        }
	      }
	    },
	    openFromOtherComponent: function openFromOtherComponent() {
	      return _eventbus2.default.createKlassModal;
	    },
	    alreadyCreatedKlassesToImportSubjectTo: function alreadyCreatedKlassesToImportSubjectTo() {
	      return _eventbus2.default.theKlassesToImportSubjectTo;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.schoolYears.filter(function (year) {
	        return year.active;
	      });
	    },
	    selectedSchoolYear: function selectedSchoolYear() {
	      return this.activeSchoolYear.name;
	    },
	    country: function country() {
	      return window.SCHOOL.country;
	    },
	    stepNumbers: function stepNumbers() {
	      return this.country === 'NO' ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] : [1, 2, 3, 4, 5, 6, 7, 8, 9];
	    },
	    subjectsToCreateWhenAlreadyCreatedKlasses: function subjectsToCreateWhenAlreadyCreatedKlasses() {
	      return this.klasses.filter(function (klass) {
	        return klass.template;
	      }).map(function (cal) {
	        var klassObj = {
	          calendar_id: cal.calendarId,
	          step: cal.template
	        };
	        return klassObj;
	      });
	    },
	    klassesToSubmit: function klassesToSubmit() {
	      var klassesToSubmit = [];
	      for (var i = 0; i < this.klasses.length; i++) {
	        if (this.klasses[i].name.length > 0) {
	          klassesToSubmit.push({
	            'name': this.klasses[i].name,
	            'type': 'class',
	            'year': this.selectedSchoolYear,
	            'template': this.klasses[i].template.toString()
	          });
	        }
	      }
	      return klassesToSubmit;
	    },
	    buttonText: function buttonText() {
	      if (this.alreadyCreatedKlassesToImportSubjectTo.length < 1) {
	        if (this.klassesToSubmit.length < 1) {
	          return this.$t('vue2.createusers.create');
	        } else {
	          var klassesPluralized = this.klassesToSubmit.length === 1 ? this.$t('vue2.createklass.klass') : this.$t('vue2.createklass.klasses');
	          return this.$t('vue2.createusers.create') + ' ' + this.klassesToSubmit.length + ' ' + klassesPluralized;
	        }
	      } else {
	        return this.subjectsToCreateWhenAlreadyCreatedKlasses.length === 1 ? this.$t('vue2.createusers.create') : this.$t('vue2.createusers.create') + ' ' + this.$t('vue2.common.in') + ' ' + this.subjectsToCreateWhenAlreadyCreatedKlasses.length + ' ' + this.$t('vue2.createklass.klasses');
	      }
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    copySubjectsSchoolYearUrl: function copySubjectsSchoolYearUrl() {
	      if (this.activeSchoolYears.length < 2) {
	        return '#';
	      }
	      var sortedSchoolYears = this.activeSchoolYears.sort(function (a, b) {
	        return new Date(b.student_time_start) - new Date(a.student_time_start);
	      });
	      return '/schools/' + this.activeSchool.id + '/year_transfer/new?from_school_year_id=' + sortedSchoolYears[1].id + '&to_school_year_id=' + sortedSchoolYears[0].id;
	    },
	    isCourseImportSelected: function isCourseImportSelected() {
	      var isSelected = false;
	      this.klasses.forEach(function (klass) {
	        if (klass.template) {
	          isSelected = true;
	        }
	      });
	      return isSelected;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isUserCanEditSchool: function isUserCanEditSchool() {
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf('can_manage_school') > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    }
	  },
	  watch: {
	    openFromOtherComponent: function openFromOtherComponent() {
	      if (this.openFromOtherComponent) {
	        this.setShowModal();
	      }
	    }
	  },
	  methods: {
	    submitOrSetDuration: function submitOrSetDuration() {
	      if (this.isCourseImportSelected && this.isUserCanEditSchool) {
	        this.isOpenDurationModal = true;
	      } else {
	        this.submitKlasses();
	      }
	    },
	    saveDuration: function saveDuration() {
	      this.submitKlasses();
	    },
	    setIsSameInputToFalse: function setIsSameInputToFalse() {
	      if (!this.someWithSameName) {
	        return;
	      } else {
	        this.someWithSameName = false;
	        this.klasses.forEach(function (obj) {
	          obj.isSameName = false;
	        });
	      }
	    },
	    setSameInputOnKlass: function setSameInputOnKlass(klassName) {
	      for (var i = 0; i < this.klasses.length; i++) {
	        if (this.klasses[i].name !== '') {
	          if (this.klasses[i].name === klassName) {
	            this.klasses[i].isSameName = true;
	          }
	        }
	      }
	    },
	    checkForSameNameInKlasses: function checkForSameNameInKlasses() {
	      var nbr = 0;
	      for (var i = 0; i < this.klassesToSubmit.length; i++) {
	        for (var j = 0; j < this.klassesToSubmit.length; j++) {
	          if (j !== i) {
	            if (this.klassesToSubmit[i].name === this.klassesToSubmit[j].name) {
	              this.setSameInputOnKlass(this.klassesToSubmit[i].name);
	              nbr++;
	            }
	          }
	        }
	      }
	      if (nbr > 0) {
	        this.someWithSameName = true;
	      } else {
	        this.someWithSameName = false;
	      }
	    },
	    mouseOverStep: function mouseOverStep(klassStep, event, klass) {
	      if (klass.template !== '') {
	        this.activeKlassStep = klass.template;
	        this.klassStepIsSelected = true;
	      } else {
	        this.activeKlassStep = klassStep;
	        this.klassStepIsSelected = false;
	      }
	      this.showSubjects = true;
	      var modalPxFromTop = document.querySelector('.modal-container').getBoundingClientRect().top;
	      var targetPxFromTop = event.target.getBoundingClientRect().top;
	      this.subjectsArrowPosition = targetPxFromTop - modalPxFromTop;
	    },
	    checkAllForText: function checkAllForText(klass, idx, text) {
	      var _this = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this.klasses[idx]['name'] = text;
	        _this.setIsSameInputToFalse();
	        _this.isTemplateButNotName(klass);
	        var klassesWithName = [];
	        for (var i = 0; i < _this.klasses.length; i++) {
	          if (_this.klasses[i].name.length > 0) {
	            klassesWithName.push(_this.klasses[i]);
	          }
	        }
	        if (klassesWithName.length === _this.klasses.length) {
	          _this.pushNewKlass();
	        }
	        _this.checkForSameNameInKlasses(klass);
	      }, 250);
	    },
	    addDeleteClass: function addDeleteClass(klass) {
	      this.klasses[this.klasses.indexOf(klass)].deleteClass = true;
	    },
	    removeDeleteClass: function removeDeleteClass(klass) {
	      this.klasses[this.klasses.indexOf(klass)].deleteClass = false;
	    },
	    setShowModal: function setShowModal() {
	      var _this2 = this;
	
	      this.klassStepIsSelected = false;
	      if (this.alreadyCreatedKlassesToImportSubjectTo.length < 1) {
	        this.pushNewKlass();
	        this.pushNewKlass();
	        this.pushNewKlass();
	        setTimeout(function () {
	          document.querySelector('.namefield').focus();
	        }, 100);
	      } else {
	        this.alreadyCreatedKlassesToImportSubjectTo.forEach(function (klass) {
	          _this2.pushExistingKlass(klass);
	        });
	      }
	      this.showModal = true;
	      window.setTimeout(function (_) {
	        if (document.querySelector('.import-klass') && document.querySelector('.modal-container')) {
	          var modalPxFromTop = document.querySelector('.modal-container').getBoundingClientRect().top;
	          var targetPxFromTop = document.querySelector('.import-klass').getBoundingClientRect().top;
	          _this2.subjectsArrowPosition = targetPxFromTop - modalPxFromTop;
	        }
	      }, 300);
	    },
	    pushNewKlass: function pushNewKlass() {
	      var _this3 = this;
	
	      this.klasses.push({
	        name: '',
	        schoolYear: '',
	        template: '',
	        deleteClass: false,
	        isValid: true,
	        isSameName: false
	      });
	      if (this.klasses.length > 4) {
	        setTimeout(function () {
	          _this3.scrollInDiv();
	        }, 0);
	      }
	    },
	    pushExistingKlass: function pushExistingKlass(klass) {
	      this.klasses.push({
	        calendarId: klass.id,
	        schoolId: klass.school_id,
	        name: klass.name,
	        template: '',
	        deleteClass: false,
	        isValid: true,
	        isSameName: false
	      });
	    },
	    isTemplateButNotName: function isTemplateButNotName(klass) {
	      var idx = this.klasses.indexOf(klass);
	      if (this.klasses[idx].template.length < 1) {
	        this.klasses[idx].isValid = true;
	      } else {
	        this.klasses[idx].isValid = this.klasses[idx].name.length > 0;
	      }
	    },
	    removeKlass: function removeKlass(klass) {
	      this.klasses.splice(this.klasses.indexOf(klass), 1);
	      this.setIsSameInputToFalse();
	      this.checkForSameNameInKlasses();
	    },
	    setKlassImport: function setKlassImport(klass, value, event) {
	      var idx = this.klasses.indexOf(klass);
	      if (this.klasses[idx].template === value) {
	        this.klasses[idx].template = '';
	        this.klassStepIsSelected = false;
	        this.isTemplateButNotName(klass);
	      } else {
	        this.klasses[idx].template = value;
	        this.klassStepIsSelected = true;
	        this.activeKlassStep = klass.template;
	
	        if (this.klasses[idx].name.length < 1) {
	          document.querySelectorAll('.namefield')[idx].focus();
	        }
	        this.isTemplateButNotName(klass);
	      }
	    },
	    setCloseModal: function setCloseModal() {
	      this.showModal = false;
	      _eventbus2.default.createKlassModal = false;
	      this.klasses = [];
	      _eventbus2.default.theKlassesToImportSubjectTo = [];
	      this.isAwaitingServerResponse = false;
	    },
	    scrollInDiv: function scrollInDiv() {
	      var objDiv = document.querySelector('.modal-body');
	      objDiv.scrollTop = objDiv.scrollHeight;
	    },
	    submitKlasses: function submitKlasses() {
	      var _this4 = this;
	
	      if (this.alreadyCreatedKlassesToImportSubjectTo.length === 0) {
	        this.checkForSameNameInKlasses();
	        if (!this.someWithSameName) {
	          _docendo2.default.schoolBulkCreateCalendars(this.activeSchool.id, this.activeSchoolYear.id, this.klassesToSubmit, function (success) {
	            _eventbus2.default.toast = { text: _this4.$t('vue2.createklass.succes_text'), 'success': true };
	            _this4.$store.dispatch('getSchoolCalendars', _this4.activeSchool.id);
	            _this4.$store.dispatch('updateUserSettings', { 'setup_widget_progress_klass': true });
	            if (window.Intercom) {
	              window.Intercom('trackEvent', 'Created Classes');
	            }
	            var newSubjectsCreated = new window.CustomEvent('new_subjects_created', {
	              bubbles: true,
	              cancelable: true
	            });
	            window.document.dispatchEvent(newSubjectsCreated);
	
	            setTimeout(function () {
	              _this4.$store.commit('setOnboardingStep', 0);
	            }, 2500);
	          }, function (errors) {
	            _eventbus2.default.toast = { text: _this4.$t('vue2.toast.something_went_wrong'), 'success': false };
	          });
	          this.setCloseModal();
	        }
	      } else {
	        this.isAwaitingServerResponse = true;
	        _docendo2.default.calendarCreateNormSubjects(this.klasses[0].schoolId, this.subjectsToCreateWhenAlreadyCreatedKlasses, function (success) {
	          _eventbus2.default.toast = { text: _this4.$t('vue2.createklass.subjects_created_successfully'), 'success': true };
	          _this4.$store.dispatch('readSubjects', _this4.activeSchoolYear.id);
	          _this4.updateSubjectsIfInRORCalendar();
	          _this4.setCloseModal();
	        }, function (failure) {
	          _eventbus2.default.toast = { text: _this4.$t('vue2.toast.something_went_wrong'), 'success': false };
	          _this4.setCloseModal();
	        });
	      }
	    },
	    updateSubjectsIfInRORCalendar: function updateSubjectsIfInRORCalendar() {
	      var updateSidebarInROR = new window.CustomEvent('vueUpdateSidebarSubjects', { bubbles: true, cancelable: true });
	      window.document.dispatchEvent(updateSidebarInROR);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.schoolCountry = window.SCHOOL.country.toLowerCase();
	  }
	};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default },
	  props: {
	    arrowPosition: {},
	    activeKlassStep: {
	      default: 1
	    },
	    klassStepIsSelected: {
	      default: false
	    },
	    country: {
	      default: 'dk'
	    }
	  },
	  filters: {
	    removeDecimal: function removeDecimal(number) {
	      return Math.round(number * 1);
	    }
	  },
	  computed: {
	    activeSubjects: function activeSubjects() {
	      var _this = this;
	
	      return this.subjects.filter(function (obj) {
	        return obj.step === _this.activeKlassStep.toString();
	      });
	    },
	    locale: function locale() {
	      return _moment2.default.locale();
	    },
	    classesNumberized: function classesNumberized() {
	      switch (this.activeKlassStep) {
	        case 1:
	          return 'st';
	        case 2:
	          return 'nd';
	        case 3:
	          return 'rd';
	        default:
	          return 'th';
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: true,
	      subjects: []
	    };
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _docendo2.default.subjectNormsSchool(window.SCHOOL.id, function (data) {
	      _this2.subjects = data;
	      _this2.isLoading = false;
	    });
	  }
	};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    open: function open() {
	      _eventbus2.default.createCalendarsType = 'room';
	    }
	  }
	};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SearchForCalendar = __webpack_require__(328);
	
	var _SearchForCalendar2 = _interopRequireDefault(_SearchForCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Modal: _DModal2.default, SearchForCalendar: _SearchForCalendar2.default },
	  data: function data() {
	    return {
	      students: [],
	      isShowModal: false,
	      theCreateCalendarsType: 'student',
	      debounceTimer: null,
	      isCreateMultipleStudents: false,
	      theBulkStudentsStr: ''
	    };
	  },
	
	  computed: {
	    isShowTextAreaPlaceholder: function isShowTextAreaPlaceholder() {
	      return this.theBulkStudentsStr.length < 1;
	    },
	    theBulkStudentsArr: function theBulkStudentsArr() {
	      var arr = this.theBulkStudentsStr.length > 0 ? this.theBulkStudentsStr.split('\n') : [];
	      return arr.filter(function (studentName) {
	        return studentName.trim().length > 0;
	      });
	    },
	    isFeideActive: function isFeideActive() {
	      return false;
	    },
	    allStudents: function allStudents() {
	      return this.$store.getters.studentCalendars;
	    },
	    allFeideIds: function allFeideIds() {
	      var feideids = [];
	      this.allStudents.forEach(function (student) {
	        var feideId = student.custom_data['feide'];
	        if (feideId) {
	          var idx = feideids.indexOf(feideId);
	          if (idx < 0) {
	            feideids.push(feideId);
	          }
	        }
	      });
	      return feideids;
	    },
	    isFeideAlreadyCreated: function isFeideAlreadyCreated() {
	      var isCreated = false;
	      if (this.students[0] && this.students[0].feide && this.students[0].feide.length > 0) {
	        var idx = this.allFeideIds.indexOf(this.students[0].feide);
	        if (idx > -1) {
	          isCreated = true;
	        }
	      }
	      return isCreated;
	    },
	    studentsWithSameName: function studentsWithSameName() {
	      return this.students[0].name.length > 0;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    showInactiveButton: function showInactiveButton() {
	      if (this.studentsToSubmit.length < 1) {
	        return true;
	      }
	    },
	    studentsToSubmit: function studentsToSubmit() {
	      var studentsToSubmit = [];
	      if (this.isCreateMultipleStudents) {
	        this.theBulkStudentsArr.forEach(function (studentName) {
	          var studentObj = {
	            name: studentName,
	            type: 'student'
	          };
	          studentsToSubmit.push(studentObj);
	        });
	      } else {
	        for (var i = 0; i < this.students.length; i++) {
	          if (this.students[i].name.length > 0) {
	            var userobj = {
	              name: this.students[i].name,
	              type: 'student'
	            };
	            if (this.students[i].unilogin.length > 0) {
	              userobj.unilogin = this.students[i].unilogin;
	            }
	            if (this.students[i].feide.length > 0) {
	              userobj.feide = this.students[i].feide;
	            }
	            if (this.students[i].email.length > 0) {
	              userobj.email = this.students[i].email;
	            }
	            studentsToSubmit.push(userobj);
	          }
	        }
	      }
	      return studentsToSubmit;
	    }
	  },
	  methods: {
	    setIsShowModal: function setIsShowModal() {
	      this.isShowModal = true;
	      this.pushNewStudent();
	      window.setTimeout(function (_) {
	        var el = document.getElementById('studentname_0');
	        if (el) {
	          el.focus();
	        }
	      }, 400);
	    },
	    setCloseModal: function setCloseModal() {
	      this.isShowModal = false;
	      this.cleanForm();
	    },
	    cleanForm: function cleanForm() {
	      this.students = [];
	      this.theBulkStudentsStr = '';
	    },
	    pushNewStudent: function pushNewStudent() {
	      var _this = this;
	
	      this.students.push({
	        name: '',
	        type: this.theCreateCalendarsType,
	        isSameName: false,
	        unilogin: '',
	        feide: '',
	        email: ''
	      });
	      if (this.students.length > 4) {
	        setTimeout(function () {
	          _this.scrollInDiv();
	        }, 0);
	      }
	    },
	    scrollInDiv: function scrollInDiv() {
	      var objDiv = document.querySelector('.modal-body');
	      objDiv.scrollTop = objDiv.scrollHeight;
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      if (this.showInactiveButton) {
	        return;
	      }
	      var successText = this.studentsToSubmit.length > 1 ? this.$t('vue2.students.created_student') : this.$t('vue2.students.created_student');
	      _docendo2.default.schoolBulkCreateCalendars(window.SCHOOL.id, this.activeSchoolYear.id, this.studentsToSubmit, function (success) {
	        _eventbus2.default.toast = { text: successText, 'success': true };
	        _this2.cleanForm();
	        _this2.pushNewStudent();
	        _this2.$store.dispatch('getSchoolCalendars', window.SCHOOL.id);
	      }, function (errors) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    checkAllForText: function checkAllForText() {
	      this.usersWithText = [];
	      for (var i = 0; i < this.users.length; i++) {
	        if (this.users[i].name.length > 0) {
	          this.usersWithText.push(this.users[i]);
	        }
	      }
	      this.$emit('editedUsers', this.usersWithText);
	      if (this.usersWithText.length === this.users.length) {
	        this.pushNewUser();
	      }
	    },
	    validate: function validate(user, key) {
	      if (user.name.length >= 0) {
	        this.students[key].nameIsValid = true;
	      }
	      if (user.feide.length > 0 && user.name.length < 1) {
	        this.students[key].nameIsValid = false;
	      }
	    },
	    unValidate: function unValidate(user, key) {
	      this.users[key].nameIsValid = true;
	    }
	  }
	};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(67);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CreateUsersForm = __webpack_require__(1232);
	
	var _CreateUsersForm2 = _interopRequireDefault(_CreateUsersForm);
	
	var _SearchForCalendar = __webpack_require__(328);
	
	var _SearchForCalendar2 = _interopRequireDefault(_SearchForCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Modal: _Modal2.default, createUserForm: _CreateUsersForm2.default, SearchForCalendar: _SearchForCalendar2.default },
	  computed: {
	    showInactiveButton: function showInactiveButton() {
	      if (this.usersToSubmit.length < 1) {
	        return true;
	      }
	    },
	    openFromOtherComponent: function openFromOtherComponent() {
	      return _eventbus2.default.createUserModal;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    isTestSchool: function isTestSchool() {
	      return window.SCHOOL.id === 7272 || window.SCHOOL.id === 9111 || window.SCHOOL.id === 3;
	    },
	    country: function country() {
	      return this.$store.state.activeSchool.country;
	    },
	    usersToSubmit: function usersToSubmit() {
	      var usersToSubmit = [];
	      for (var i = 0; i < this.users.length; i++) {
	        if (this.users[i].name.length > 0) {
	          var userobj = {
	            name: this.users[i].name
	          };
	          if (this.users[i].unilogin.length > 0) {
	            userobj.unilogin = this.users[i].unilogin;
	          }
	          if (this.users[i].feide.length > 0) {
	            userobj.feide = this.users[i].feide;
	          }
	          if (this.users[i].email.length > 0) {
	            userobj.email = this.users[i].email;
	          }
	          usersToSubmit.push(userobj);
	        }
	      }
	      return usersToSubmit;
	    },
	    buttonText: function buttonText() {
	      if (this.usersToSubmit.length < 1) {
	        return this.$t('vue2.createusers.create');
	      }
	      var users = this.usersToSubmit.length === 1 ? this.$t('vue2.createusers.user') : this.$t('vue2.createusers.users');
	      return this.$t('vue2.createusers.create') + ' ' + this.usersToSubmit.length + ' ' + users;
	    }
	  },
	  data: function data() {
	    return {
	      showModal: false,
	      users: [],
	      pushNameFromSelect2: '',
	      openedFromRoRSelect2: false,
	      activeInputName: ''
	    };
	  },
	
	  watch: {
	    openFromOtherComponent: function openFromOtherComponent() {
	      if (this.openFromOtherComponent) {
	        this.setShowModal();
	      }
	    }
	  },
	  methods: {
	    checkForDoubleNames: function checkForDoubleNames(name) {
	      this.activeInputName = name;
	    },
	    setUsers: function setUsers(users) {
	      this.users = users;
	    },
	    validateEmail: function validateEmail(user, email) {
	      if (email.length < 1) {
	        this.users[this.users.indexOf(user)].validEmail = true;
	      } else {
	        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        this.users[this.users.indexOf(user)].validEmail = re.test(String(email).toLowerCase());
	      }
	    },
	    setShowModal: function setShowModal() {
	      this.showModal = true;
	    },
	    setCloseModal: function setCloseModal() {
	      this.showModal = false;
	      _eventbus2.default.createUserModal = false;
	      this.users = [];
	      this.openedFromRoRSelect2 = false;
	    },
	    submitUsers: function submitUsers() {
	      var _this = this;
	
	      var isOpenedFromRoRSelect2 = false;
	
	      if (this.openedFromRoRSelect2) {
	        isOpenedFromRoRSelect2 = true;
	      }
	      var successText = this.usersToSubmit.length > 1 ? this.$t('vue2.createusers.users_created') : this.$t('vue2.createusers.user_created');
	      _docendo2.default.schoolUsersCreate(this.activeSchool.id, this.usersToSubmit, function (success) {
	        _eventbus2.default.toast = { text: successText, 'success': true };
	        _this.$store.dispatch('getSchoolCalendars', _this.activeSchool.id);
	        _this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_users': true });
	        _this.$store.dispatch('getUsers', _this.activeSchool.id);
	        if (window.Intercom) {
	          window.Intercom('trackEvent', 'Created Users');
	        }
	        _eventbus2.default.createdId = success[0].id;
	        if (isOpenedFromRoRSelect2) {
	          _this.$helpers.sendCustomEvt('vue_created_user', success[0].id);
	        }
	        if (_eventbus2.default.createUserModalROR) {
	          window.location.reload();
	        }
	
	        setTimeout(function () {
	          _this.$store.commit('setOnboardingStep', 0);
	        }, 2500);
	      }, function (errors) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	      this.setCloseModal();
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    window.addEventListener('vueCreateUser', function (e) {
	      _this2.openedFromRoRSelect2 = true;
	      _this2.pushNameFromSelect2 = e.detail === null ? '' : e.detail;
	      _eventbus2.default.createUserModal = true;
	    }, false);
	  }
	};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    open: function open() {
	      _eventbus2.default.createUserModal = true;
	    }
	  }
	};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    open: function open() {
	      _eventbus2.default.createUserModal = true;
	      _eventbus2.default.createUserModalROR = true;
	    }
	  }
	};

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    country: {
	      default: 'dk'
	    },
	    pushname: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      users: [],
	      usersWithText: [],
	      userWithSameFeide: null,
	      debounceTimer: null
	    };
	  },
	
	  computed: {
	    allUsers: function allUsers() {
	      return this.$store.state.allUsers;
	    }
	  },
	  methods: {
	    getIsUserWithSameFeide: function getIsUserWithSameFeide(user) {
	      return this.userWithSameFeide && this.userWithSameFeide.email === user.feide;
	    },
	    pushNewUser: function pushNewUser() {
	      var _this = this;
	
	      this.users.push({
	        name: '',
	        nameIsValid: true,
	        unilogin: '',
	        feide: '',
	        email: '',
	        validEmail: true,
	        userHoverDanger: false
	      });
	      if (this.users.length > 4) {
	        setTimeout(function () {
	          _this.scrollInDiv();
	        }, 0);
	      }
	    },
	    setHoverDanger: function setHoverDanger(idx) {
	      this.users[idx].userHoverDanger = true;
	    },
	    removeHoverDanger: function removeHoverDanger(idx) {
	      this.users[idx].userHoverDanger = false;
	    },
	    removeUser: function removeUser(user) {
	      this.users.splice(this.users.indexOf(user), 1);
	      this.checkAllForText();
	    },
	    scrollInDiv: function scrollInDiv() {
	      var objDiv = document.querySelector('.modal-body');
	      objDiv.scrollTop = objDiv.scrollHeight;
	    },
	    validateEmail: function validateEmail(user, email, key) {
	      if (email.length < 1) {
	        this.users[key].validEmail = true;
	      } else {
	        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        this.users[key].validEmail = re.test(String(email).toLowerCase());
	        if (re.test(String(email).toLowerCase())) {
	          this.validate(user, key);
	        }
	      }
	    },
	    checkEmailAndAllForText: function checkEmailAndAllForText(user, email, userIdx) {
	      var _this2 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this2.users[userIdx].email = email;
	        _this2.checkAllForText();
	        if (email.length < 1) {
	          _this2.users[_this2.users.indexOf(user)].validEmail = true;
	        }
	      }, 250);
	    },
	    checkAllForText: function checkAllForText(text, theType, userIdx) {
	      var _this3 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        if (theType === 'username') {
	          _this3.users[userIdx].name = text;
	          _this3.$emit('onNameInput', text);
	        }
	        if (theType === 'unilogin') {
	          _this3.users[userIdx].unilogin = text;
	        }
	        if (theType === 'feide') {
	          _this3.users[userIdx].feide = text;
	          _this3.checkIfAlreadyUsed(text, 'feide', userIdx);
	        }
	        _this3.usersWithText = [];
	        for (var i = 0; i < _this3.users.length; i++) {
	          if (_this3.users[i].name.length > 0) {
	            _this3.usersWithText.push(_this3.users[i]);
	          }
	        }
	        _this3.$emit('editedUsers', _this3.usersWithText);
	        if (_this3.usersWithText.length === _this3.users.length) {
	          _this3.pushNewUser();
	        }
	      }, 300);
	    },
	    checkIfAlreadyUsed: function checkIfAlreadyUsed(loginId, theType) {
	      if (theType === 'feide') {
	        var user = this.allUsers.filter(function (user) {
	          return user.email === loginId;
	        });
	        if (user.length > 0) {
	          this.userWithSameFeide = user[0];
	        } else {
	          this.userWithSameFeide = null;
	        }
	      }
	    },
	    validate: function validate(user, key) {
	      if (user.name.length >= 0) {
	        this.users[key].nameIsValid = true;
	      }
	      if (user.email.length > 0 && user.name.length < 1) {
	        this.users[key].nameIsValid = false;
	      }
	      if (this.country.toLowerCase() === 'dk') {
	        if (user.unilogin.length > 0 && user.name.length < 1) {
	          this.users[key].nameIsValid = false;
	        }
	      } else if (this.country.toLowerCase() === 'no') {
	        if (user.feide.length > 0 && user.name.length < 1) {
	          this.users[key].nameIsValid = false;
	        }
	      }
	    },
	    unValidate: function unValidate(user, key) {
	      this.users[key].nameIsValid = true;
	    }
	  },
	  mounted: function mounted() {
	    var i = 0;
	    if (this.pushname.length > 1) {
	      this.users.push({
	        name: this.pushname,
	        nameIsValid: true,
	        unilogin: '',
	        feide: '',
	        email: '',
	        validEmail: true,
	        userHoverDanger: false
	      });
	      this.checkAllForText();
	      i = 2;
	    }
	    for (i; i < 3; i++) {
	      this.pushNewUser();
	      this.$emit('editedUsers', this.usersWithText);
	      setTimeout(function () {
	        document.querySelector('.namefield').focus();
	      }, 100);
	    }
	  }
	};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	
	    close_on_click_away: {
	      type: Boolean,
	      default: false
	    },
	    show_modal_mask: {
	      type: Boolean,
	      default: true
	    },
	    show_modal_sidebar: {
	      type: Boolean,
	      default: false
	    }
	  },
	  watch: {
	    show: function show() {
	      var body = document.querySelector('body');
	      if (this.show) {
	        _eventbus2.default.createModalOpen = true;
	        body.classList.add('no-scroll');
	      } else {
	        this.removeModal();
	      }
	    }
	  },
	  methods: {
	    setShowModal: function setShowModal() {
	      this.show = true;
	    },
	    removeModal: function removeModal() {
	      var body = document.querySelector('body');
	      this.$emit('close');
	      body.classList.remove('no-scroll');
	      _eventbus2.default.createModalOpen = false;
	    },
	    clickAway: function clickAway() {
	      this.close_on_click_away ? this.removeModal() : null;
	    }
	  },
	  mounted: function mounted() {
	    this._keyListener = function (e) {
	      if (e.key === 'Escape') {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.removeModal();
	        }
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CreateTaskForm = __webpack_require__(1234);
	
	var _CreateTaskForm2 = _interopRequireDefault(_CreateTaskForm);
	
	var _CreateTaskNewSubject = __webpack_require__(1235);
	
	var _CreateTaskNewSubject2 = _interopRequireDefault(_CreateTaskNewSubject);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { CreateTaskNewSubject: _CreateTaskNewSubject2.default, CreateTaskForm: _CreateTaskForm2.default },
	  props: {
	    user: {
	      type: Object,
	      default: null
	    },
	    initDate: {
	      type: Object,
	      default: (0, _moment2.default)()
	    },
	    emitEvent: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      theCreateNewSubjectName: null,
	      theNewlyCreatedSubject: null
	    };
	  },
	
	  methods: {
	    onCreatedEvent: function onCreatedEvent(lesson) {
	      var initDate = this.initDate;
	
	      var eventStart = lesson.start;
	      var eventEnd = lesson.end;
	
	      var initDateMoment = (0, _moment2.default)(initDate);
	      var eventStartMoment = (0, _moment2.default)(eventStart);
	      var eventEndMoment = (0, _moment2.default)(eventEnd);
	
	      var isStartDateSame = eventStartMoment.isSame(initDateMoment, 'day');
	      var isEndDateSame = eventEndMoment.isSame(initDateMoment, 'day');
	      if (this.emitEvent) {
	        this.$emit('addANewEvent', lesson);
	        return;
	      }
	      if (isStartDateSame && isEndDateSame) {
	        this.$store.commit('addANewEvent', lesson);
	      }
	    },
	    setDate: function setDate(mom) {
	      this.date = mom;
	    },
	    setCreateNewSubject: function setCreateNewSubject(str) {
	      this.theCreateNewSubjectName = str;
	    },
	    onNewSubject: function onNewSubject(subject) {
	      this.theNewlyCreatedSubject = subject;
	      this.setCreateNewSubject(null);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.date = this.initDate;
	  }
	};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { dSelect: _DSelect2.default, DModal: _DModal2.default, TimeChanger: _TimeChanger2.default, DateSelector: _DateSelector2.default },
	  props: {
	    user: {
	      type: Object,
	      default: function _default() {
	        return {
	          name: 'Henrik',
	          user_calendar_id: 7
	        };
	      }
	    },
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    theNewlyCreatedSubject: {
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingSubject: false,
	      subjects: [],
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 45 }),
	      selectedSubject: null,
	      isSubmitting: false,
	      theSearchText: '',
	      theNewSubject: null,
	      isShowCreateSubjectButton: false
	    };
	  },
	
	  computed: {
	    isValidated: function isValidated() {
	      return this.selectedSubject;
	    },
	    filteredSubjects: function filteredSubjects() {
	      return this.subjects.filter(function (subject) {
	        return subject.subject_type !== 'absence';
	      });
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this = this;
	
	      return this.filteredSubjects.map(function (subject) {
	        var translatedSubjectType = _this.$t('vue2.eventTypes.' + subject.subject_type);
	
	        var vSubjectType = translatedSubjectType === 'vue2.eventTypes.' + subject.subject_type ? subject.subject_type : translatedSubjectType;
	
	        return (0, _extends3.default)({}, subject, {
	          vSubjectType: vSubjectType
	        });
	      }).sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  },
	  watch: {
	    theNewlyCreatedSubject: function theNewlyCreatedSubject(val) {
	      this.readSubjects();
	    }
	  },
	  methods: {
	    setDate: function setDate(date) {
	      this.$emit('setDate', date);
	    },
	    onCloseDSelect: function onCloseDSelect() {
	      this.isShowCreateSubjectButton = false;
	    },
	    setIsShowCreateSubjectButton: function setIsShowCreateSubjectButton() {
	      var _this2 = this;
	
	      var idx = this.filteredSubjects.findIndex(function (subject) {
	        return subject.name === _this2.theSearchText;
	      });
	      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateSubjectButton();
	    },
	    onCreateNewSubject: function onCreateNewSubject() {
	      this.$emit('createNewSubject', this.theSearchText);
	      this.theSearchText = '';
	    },
	    setTheSearchText: function setTheSearchText(str) {
	      this.theSearchText = str;
	    },
	    setSubject: function setSubject(arr) {
	      this.selectedSubject = arr[0];
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    readSubjects: function readSubjects() {
	      var _this3 = this;
	
	      this.isLoadingSubject = true;
	      _docendo2.default.sidebar(this.user.user_calendar_id, this.date, function (success) {
	        _this3.isLoadingSubject = false;
	        _this3.subjects = success;
	        _this3.$nextTick(function (_) {
	          if (_this3.theNewlyCreatedSubject) {
	            _this3.theNewSubject = _this3.theNewlyCreatedSubject;
	          }
	        });
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    },
	    submit: function submit() {
	      var _this4 = this;
	
	      var schoolId = this.selectedSubject.school_id;
	      var calendarId = this.selectedSubject.calendar_id;
	      var calendarIds = [calendarId];
	      var subjectId = this.selectedSubject.id;
	      var internalNote = '';
	      this.isSubmitting = true;
	      _docendo2.default.createEvent(schoolId, calendarId, calendarIds, subjectId, this.dbEventStart, this.dbEventEnd, '', '', '', internalNote, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          _this4.$emit('close');
	          return;
	        }
	        var lesson = JSON.parse(data);
	        _this4.$emit('onCreatedEvent', lesson);
	        _this4.$emit('close');
	        _eventbus2.default.toast = { text: _this4.$t('vue2.create_activity.created'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	    setTimeout(function (_) {
	      var el = document.querySelector('#d-create-task-for-user .d-select__input-look > input[type="search"]');
	      if (el) {
	        el.focus();
	      }
	    }, 400);
	  }
	};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubjectFormSubjectType = __webpack_require__(71);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SubjectFormSubjectType: _SubjectFormSubjectType2.default, dSelect: _DSelect2.default, DModal: _DModal2.default },
	  props: {
	    title: {
	      type: String
	    },
	    user: {
	      type: Object,
	      default: function _default() {
	        return {
	          name: 'Henrik',
	          user_calendar_id: 7
	        };
	      }
	    },
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      subjectName: '',
	      subjectType: '',
	      isSubmitting: false,
	      theActiveSchoolId: null,
	      userSchools: [],
	      isLoadingUserSchools: false
	    };
	  },
	
	  computed: {
	    isValidated: function isValidated() {
	      return this.subjectName.length > 0;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    isUserHasMultipleSchools: function isUserHasMultipleSchools() {
	      return (0, _keys2.default)(this.userSchools).length > 1;
	    }
	  },
	  methods: {
	    setSubjectType: function setSubjectType(str) {
	      this.subjectType = str;
	    },
	    findSchoolYearId: function findSchoolYearId() {
	      if (this.activeSchoolYears.length === 1) {
	        return this.activeSchoolYears[0].id;
	      }
	      var givenDate = (0, _moment2.default)(this.date);
	
	      var overlappingSchoolYears = this.activeSchoolYears.filter(function (year) {
	        var start = (0, _moment2.default)(year.employee_time_start);
	        var end = (0, _moment2.default)(year.employee_time_end);
	        return givenDate.isBetween(start, end, undefined, '[]');
	      });
	
	      if (overlappingSchoolYears.length > 0) {
	        var latestSchoolYear = overlappingSchoolYears.reduce(function (latest, current) {
	          var latestEnd = (0, _moment2.default)(latest.employee_time_end);
	          var currentEnd = (0, _moment2.default)(current.employee_time_end);
	          return currentEnd.isAfter(latestEnd) ? current : latest;
	        }, overlappingSchoolYears[0]);
	
	        return latestSchoolYear.id;
	      } else {
	        _eventbus2.default.toast = { text: this.$t('vue2.create_activity.the_selected_date_is_outside_schoolyears'), 'success': false };
	        return null;
	      }
	    },
	    submit: function submit() {
	      var _this = this;
	
	      var calendarId = this.user.user_calendar_id;
	      var schoolYearId = this.findSchoolYearId();
	      if (!schoolYearId) {
	        return;
	      }
	      var schoolId = this.theActiveSchoolId;
	      var color = '#999999';
	      var duration = 45;
	      var preparation = null;
	      var calendarIds = [];
	      var subjectCode = null;
	      this.isSubmitting = true;
	      _docendo2.default.createSubject(this.subjectName, color, calendarId, duration, preparation, 0, this.subjectType, schoolId, schoolYearId, calendarIds, subjectCode, false, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          return;
	        }
	        _this.$emit('newSubject', data);
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readUser: function readUser() {
	      var _this2 = this;
	
	      _docendo2.default.showUser(this.user.id, function (data) {
	        _this2.userSchools = data && data.schools ? data.schools.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }) : [];
	      }, function (failure) {});
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.readUser();
	    this.subjectName = this.title;
	    this.theActiveSchoolId = this.activeSchool.id;
	    this.$nextTick(function (_) {
	      var el = _this3.$refs.d_title_input;
	      if (el) {
	        _this3.$refs.d_title_input.click();
	        _this3.$refs.d_title_input.focus();
	      }
	    });
	  }
	};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DCalendarDay = __webpack_require__(1237);
	
	var _DCalendarDay2 = _interopRequireDefault(_DCalendarDay);
	
	var _DCalendarDayDraggable = __webpack_require__(1238);
	
	var _DCalendarDayDraggable2 = _interopRequireDefault(_DCalendarDayDraggable);
	
	var _DCalendarSubjects = __webpack_require__(1246);
	
	var _DCalendarSubjects2 = _interopRequireDefault(_DCalendarSubjects);
	
	var _DCalendarDraggedSubject = __webpack_require__(1239);
	
	var _DCalendarDraggedSubject2 = _interopRequireDefault(_DCalendarDraggedSubject);
	
	var _DCalendarList = __webpack_require__(1241);
	
	var _DCalendarList2 = _interopRequireDefault(_DCalendarList);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DCalendarList: _DCalendarList2.default,
	    DCalendarDraggedSubject: _DCalendarDraggedSubject2.default,
	    DCalendarSubjects: _DCalendarSubjects2.default,
	    DCalendarDay: _DCalendarDay2.default,
	    Loader: _Loader2.default,
	    DCalendarDayDraggable: _DCalendarDayDraggable2.default,
	    ModalConfirmation: _ModalConfirmation2.default
	  },
	  props: {
	    calendar: {
	      type: Object,
	      default: null
	    },
	    calendarId: {
	      default: 7
	    },
	    calendarName: {
	      default: ''
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    isMultiCalendar: {
	      type: Boolean,
	      default: false
	    },
	    showSidebar: {
	      type: Boolean,
	      default: true
	    },
	    isShowWeek: {
	      type: Boolean,
	      default: true
	    },
	    isShowWeekends: {
	      type: Boolean,
	      default: false
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    },
	    startTime: {
	      default: '06:00:00'
	    },
	    endTime: {
	      default: '16:00:00'
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isLoadingEvents: {
	      type: Boolean,
	      default: false
	    },
	    isEventsClickable: {
	      type: Boolean,
	      default: false
	    },
	    isEditable: {
	      type: Boolean,
	      default: false
	    },
	    isLocked: {
	      type: Boolean,
	      default: false
	    },
	    isCalendarInPrintMode: {
	      type: Boolean,
	      default: false
	    },
	    isShowStudents: {
	      type: Boolean,
	      default: false
	    },
	    isShowAsList: {
	      type: Boolean,
	      default: false
	    },
	    isHideHeader: {
	      type: Boolean,
	      default: false
	    },
	    initNumberOfDays: {
	      default: null
	    },
	    isCalNoBgColors: {
	      type: Boolean,
	      default: false
	    },
	    eventFontSize: {
	      default: 10
	    },
	    isAbsenceEditable: {
	      type: Boolean,
	      default: true
	    },
	    isHideCalendars: {
	      type: Boolean,
	      default: false
	    },
	    isHideDates: {
	      type: Boolean,
	      default: false
	    },
	    isCopyCalendarModalOpen: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      slotHeight: 40,
	      slotWidth: 50,
	      i18n: {
	        da: {
	          week: 'Uge'
	        },
	        nb: {
	          week: 'Uke'
	        },
	        en: {
	          week: 'W '
	        }
	      },
	      activeEvent: null,
	      theDragLesson: null,
	      movedX: 0,
	      movedY: 0,
	      dragEventY: 0,
	      dragEventHeight: 0,
	      dragActiveDate: null,
	      dragActiveDates: [],
	      dragEventStart: (0, _moment2.default)(),
	      dragEventEnd: (0, _moment2.default)(),
	      isResizingEvent: false,
	      isSideResizingEvent: false,
	      isDraggingEvent: false,
	      isDraggingExternalEvent: false,
	      theExternalEvent: null,
	      theExternalEventBCR: null,
	      isWindowResizingTimer: null,
	      deleteSubject: null,
	      theDeleteEvent: null,
	      isDeleteSubjectOverSubjects: false,
	      isConfirmDeleteModal: false,
	      calendarDOMUuid: this.generateUUID()
	    };
	  },
	
	  computed: {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    userSchools: function userSchools() {
	      return this.$store.getters.userSchools;
	    },
	    eventsWithMetaData: function eventsWithMetaData() {
	      var _this = this;
	
	      return this.events.map(function (lesson) {
	        var dLesson = (0, _extends3.default)({}, lesson);
	
	        if (lesson.rendering) {
	          return (0, _extends3.default)({}, lesson, {
	            event_starttime: '',
	            event_endtime: '',
	            event_key: _this.generateUUID(),
	            has_notes: false,
	            has_substitute: false,
	            group: '',
	            teacher: '',
	            v_teachers_arr: [],
	            room: '',
	            substitutes: '',
	            eventDuration: 0,
	            v_other_school: false,
	            v_is_editable: false,
	            v_sort_key: ''
	          });
	        }
	
	        var getHighestMinutesClassName = function getHighestMinutesClassName(calendars) {
	          var highestMinutesCalendar = calendars.reduce(function (highest, calendar) {
	            if (calendar.calendar_type === 'klass' && (!highest || calendar.minutes > highest.minutes)) {
	              return calendar;
	            }
	            return highest;
	          }, null);
	
	          return highestMinutesCalendar ? highestMinutesCalendar.name : '';
	        };
	
	        var cleanText = function cleanText(content) {
	          return content ? content.replace(/<(?:.|\n)*?>/gm, '') : '';
	        };
	
	        var teacherNotes = cleanText(dLesson.teacher_notes);
	        var hasNotes = teacherNotes || cleanText(dLesson.description) || cleanText(dLesson.notes_for_students) || cleanText(dLesson.learning_goal);
	
	        var groups = [];
	        var rooms = [];
	        var teachers = [];
	        var students = [];
	        var substitutes = [];
	        var hasSubstitutes = false;
	        var eventActiveCalendarDuration = 0;
	
	        eventActiveCalendarDuration = 0;
	        dLesson.calendars.forEach(function (calendar) {
	          if (calendar.calendar_id === _this.calendarId) {
	            eventActiveCalendarDuration = calendar.minutes;
	          }
	
	          var name = calendar.name;
	          switch (calendar.calendar_type) {
	            case 'klass':
	              if (calendar.calendar_id !== _this.calendarId) groups.push(name);
	              break;
	            case 'room':
	              if (calendar.calendar_id !== _this.calendarId) rooms.push(name);
	              break;
	            case 'user':
	              if (calendar.substitute) {
	                hasSubstitutes = true;
	                substitutes.push(name);
	              } else if (calendar.calendar_id !== _this.calendarId) {
	                teachers.push(name);
	              }
	              break;
	            case 'student':
	              if (calendar.calendar_id !== _this.calendarId) students.push(name);
	              break;
	          }
	        });
	
	        var className = getHighestMinutesClassName(dLesson.calendars);
	
	        var updatedLesson = (0, _extends3.default)({}, lesson, {
	          event_starttime: (0, _moment2.default)(dLesson.start).locale(_this.locale).format('LT'),
	          event_endtime: (0, _moment2.default)(dLesson.end).locale(_this.locale).format('LT'),
	          event_key: _this.calendarId + '_' + dLesson.event_id,
	          has_notes: !!hasNotes,
	          has_substitute: hasSubstitutes,
	          group: groups.join(', '),
	          teacher: teachers.join(', '),
	          room: rooms.join(', '),
	          substitutes: substitutes.join(', '),
	          eventDuration: eventActiveCalendarDuration,
	          v_other_school: _this.getIsEventOtherSchool(lesson),
	          v_is_editable: _this.getIsEventEditable(lesson),
	          v_sort_key: className,
	          v_other_calendar: _this.calendarId * 1 !== lesson.calendar_id && (_this.allCalendarsInHash[lesson.calendar_id] || true)
	        });
	
	        if (_this.isShowStudents) {
	          updatedLesson.students = students.join(', ');
	        }
	
	        return updatedLesson;
	      });
	    },
	    isLocaleEn: function isLocaleEn() {
	      return this.locale === 'en';
	    },
	    calStartHour: function calStartHour() {
	      return this.startTime.slice(0, 2) !== '00' ? this.startTime.slice(0, 2) : '01';
	    },
	    calEndHour: function calEndHour() {
	      return this.endTime.slice(0, 2);
	    },
	    calStartTime: function calStartTime() {
	      return (0, _moment2.default)().set({ hour: this.calStartHour, minutes: 0, seconds: 0 });
	    },
	    calEndTime: function calEndTime() {
	      return (0, _moment2.default)().set({ hour: this.calEndHour, minutes: 0, seconds: 0 });
	    },
	    theWeekNumber: function theWeekNumber() {
	      return (0, _moment2.default)(this.date).isoWeek();
	    },
	    numberOfDays: function numberOfDays() {
	      if (this.initNumberOfDays) {
	        return this.initNumberOfDays;
	      }
	      if (this.isShowWeek) {
	        if (this.isShowWeekends) {
	          return this.firstDayOfWeek + 6;
	        } else {
	          return this.firstDayOfWeek + 4;
	        }
	      } else {
	        return 1;
	      }
	    },
	    days: function days() {
	      var correctDates = [];
	      var days = [];
	      if (this.isShowWeek) {
	        for (var i = this.firstDayOfWeek; i <= this.numberOfDays; i++) {
	          var date = (0, _moment2.default)(this.date).isoWeekday(i);
	          var dateObj = {
	            day: date,
	            date: this.getShowDate(date),
	            isToday: (0, _moment2.default)().format('YYYY-MM-DD') === (0, _moment2.default)(date).format('YYYY-MM-DD'),
	            dayName: date.format('dddd')
	          };
	          correctDates.push(dateObj);
	          days.push(date);
	        }
	      } else {
	        var _date = (0, _moment2.default)(this.date);
	        var _dateObj = {
	          day: _date,
	          date: this.getShowDate(_date),
	          isToday: (0, _moment2.default)().format('YYYY-MM-DD') === (0, _moment2.default)(_date).format('YYYY-MM-DD')
	        };
	        correctDates.push(_dateObj);
	        days.push(_date);
	      }
	      this.$emit('dates', days);
	      return correctDates;
	    },
	    hours: function hours() {
	      var hours = [];
	      var diffInHours = this.calEndHour * 1 - this.calStartHour * 1;
	      for (var i = 0; i <= diffInHours; i++) {
	        hours.push((0, _moment2.default)(this.calStartTime).add(i, 'hours'));
	      }
	      return hours;
	    },
	    hoursInLocale: function hoursInLocale() {
	      var _this2 = this;
	
	      var localeHours = [];
	      this.hours.forEach(function (h) {
	        localeHours.push((0, _moment2.default)(h).locale(_this2.locale).format('LT'));
	      });
	      return localeHours;
	    },
	    isMobile: function isMobile() {
	      return this.$store.state.isDeviceMobile;
	    }
	  },
	  watch: {
	    isCalendarInPrintMode: function isCalendarInPrintMode() {
	      return this.getSlotHeight();
	    },
	    startTime: function startTime() {
	      this.getSlotHeight();
	    },
	    endTime: function endTime() {
	      this.getSlotHeight();
	    }
	  },
	  methods: {
	    onMouseUpFromDragging: function onMouseUpFromDragging() {
	      var _this3 = this;
	
	      if (this.deleteSubject && this.isDeleteSubjectOverSubjects) {
	        this.theDeleteEvent = this.deleteSubject;
	        var isDontAskDeleteEvent = this.$helpers.getLocalStorage('do_dont_ask_delete_event');
	        if (isDontAskDeleteEvent) {
	          this.deleteEvent();
	        } else {
	          setTimeout(function (_) {
	            _this3.isConfirmDeleteModal = true;
	          }, 0);
	        }
	      }
	    },
	    closeIsConfirmDelete: function closeIsConfirmDelete() {
	      this.isConfirmDeleteModal = false;
	      this.theDeleteEvent = null;
	    },
	    onConfirmDeleteEvent: function onConfirmDeleteEvent(evt) {
	      this.isConfirmDeleteModal = false;
	      if (evt) {
	        this.$helpers.setLocalStorage('do_dont_ask_delete_event', true);
	      }
	      this.deleteEvent();
	    },
	    deleteEvent: function deleteEvent() {
	      this.$store.dispatch('deleteEvent', this.theDeleteEvent);
	      this.theDeleteEvent = null;
	    },
	    onMouseEnterSubjects: function onMouseEnterSubjects() {
	      if (this.deleteSubject) {
	        this.isDeleteSubjectOverSubjects = true;
	      }
	    },
	    onMouseLeaveSubjects: function onMouseLeaveSubjects() {
	      this.isDeleteSubjectOverSubjects = false;
	    },
	    generateUUID: function generateUUID() {
	      var d = new Date().getTime();
	      var d2 = window.performance && window.performance.now && window.performance.now() * 1000 || 0;
	      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16;
	        if (d > 0) {
	          r = (d + r) % 16 | 0;
	          d = Math.floor(d / 16);
	        } else {
	          r = (d2 + r) % 16 | 0;
	          d2 = Math.floor(d2 / 16);
	        }
	        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
	      });
	    },
	    getIsEventEditable: function getIsEventEditable(event) {
	      if (event.event_type === 'absence') {
	        return this.isAbsenceEditable;
	      }
	      return this.calendarId * 1 === event.calendar_id && event.event_type !== 'presence';
	    },
	    getIsEventOtherSchool: function getIsEventOtherSchool(event) {
	      return event.event_type !== 'presence' && !this.userSchools[event.school_id];
	    },
	    setTheExternalEventBCR: function setTheExternalEventBCR(BCR) {
	      this.theExternalEventBCR = BCR;
	    },
	    setMovedXY: function setMovedXY(x, y) {
	      this.movedX = x;
	      this.movedY = y;
	    },
	    subjectsMouseUp: function subjectsMouseUp() {
	      this.theExternalEvent = null;
	    },
	    setIsDraggingExternalEvent: function setIsDraggingExternalEvent(boolean) {
	      this.isDraggingExternalEvent = boolean;
	      this.$emit('onDragging', boolean);
	    },
	    setTheExternalEvent: function setTheExternalEvent(subject) {
	      if (subject) {
	        this.$emit('onDragging', true);
	        this.theExternalEvent = subject;
	        this.isDraggingExternalEvent = true;
	        this.setDragActiveDate(null);
	      } else {
	        this.$emit('onDragging', false);
	        this.theDragLesson = null;
	        this.setIsDraggingEvent(false);
	      }
	    },
	    setIsDraggingEvent: function setIsDraggingEvent(boolean) {
	      this.$emit('onDragging', boolean);
	      this.isDraggingEvent = boolean;
	      if (!boolean) {
	        this.$store.dispatch('clearAvailability');
	        this.deleteSubject = null;
	        this.isDeleteSubjectOverSubjects = false;
	        this.setMovedXY(null, null);
	        return;
	      }
	      if (this.theDragLesson && !this.theExternalEvent) {
	        var lessonObj = {
	          calendarId: this.theDragLesson.obj.calendar_id,
	          eventId: this.theDragLesson.obj.event_id
	        };
	        this.$store.dispatch('readEventAvailability', lessonObj);
	        if (!this.isResizingEvent && !this.isSideResizingEvent) {
	          this.deleteSubject = this.theDragLesson.obj;
	        }
	      }
	    },
	    setTheDeleteSubjectCursorPlacement: function setTheDeleteSubjectCursorPlacement(obj) {
	      if (this.deleteSubject) {
	        this.setMovedXY(obj.x, obj.y);
	      }
	    },
	    setDragEventStart: function setDragEventStart(mom) {
	      this.dragEventStart = mom;
	    },
	    setDragEventEnd: function setDragEventEnd(mom) {
	      this.dragEventEnd = mom;
	    },
	    setDragActiveDate: function setDragActiveDate(mom) {
	      this.dragActiveDate = mom;
	      if (!this.isSideResizingEvent) {
	        return;
	      }
	      if (mom === null) {
	        this.dragActiveDates = [];
	        return;
	      }
	      var theDragLessonStartDate = (0, _moment2.default)(this.theDragLesson.obj.start).format('YYYY-MM-DD');
	      var date = (0, _moment2.default)(mom).format('YYYY-MM-DD');
	      var idx = this.dragActiveDates.indexOf(date);
	      if (theDragLessonStartDate !== date && idx < 0) {
	        this.dragActiveDates.push(date);
	      } else {
	        this.dragActiveDates.splice(idx + 1, this.dragActiveDates.length);
	      }
	    },
	    setDragEventY: function setDragEventY(px) {
	      this.dragEventY = px;
	    },
	    setDragEventHeight: function setDragEventHeight(px) {
	      this.dragEventHeight = px;
	    },
	    setIsResizingEvent: function setIsResizingEvent(boolean) {
	      this.isResizingEvent = boolean;
	    },
	    setIsSideResizingEvent: function setIsSideResizingEvent(boolean) {
	      this.isSideResizingEvent = boolean;
	    },
	    setTheDragLesson: function setTheDragLesson(lesson) {
	      this.theDragLesson = lesson;
	    },
	    onEventClick: function onEventClick(event) {
	      this.$emit('onEventClick', event);
	    },
	    onPresenceClick: function onPresenceClick(event) {
	      this.$emit('onPresenceClick', event);
	    },
	    getShowDate: function getShowDate(date) {
	      return this.locale !== 'en' ? (0, _moment2.default)(date).locale(this.locale).format('ddd[.] DD/MM') : (0, _moment2.default)(date).locale(this.locale).format('ddd MM/DD');
	    },
	    getSlotHeight: function getSlotHeight() {
	      var _this4 = this;
	
	      if (this.isShowAsList) {
	        return;
	      }
	      this.$nextTick(function (_) {
	        _this4.slotHeight = document.querySelector('#calendar_dom_id_' + _this4.calendarDOMUuid + ' .time-slot').getBoundingClientRect().height;
	        _this4.slotWidth = document.querySelector('#calendar_dom_id_' + _this4.calendarDOMUuid + ' .day-cal__event-container').getBoundingClientRect().width;
	      });
	    },
	    handleWindowResize: function handleWindowResize() {
	      var _this5 = this;
	
	      clearTimeout(this.isWindowResizingTimer);
	      this.isWindowResizingTimer = setTimeout(function (_) {
	        _this5.getSlotHeight();
	      }, 0);
	    }
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    this.$nextTick(function (_) {
	      _this6.getSlotHeight();
	      window.addEventListener('resize', _this6.handleWindowResize);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.handleWindowResize);
	  }
	};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    out_of_school: 'Ude af huset',
	    canceled: 'Aflyst'
	  },
	  en: {
	    out_of_school: 'Out of school',
	    canceled: 'Canceled'
	  },
	  nb: {
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst'
	  }
	};
	
	exports.default = {
	  props: {
	    calendarId: {
	      default: 7
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {},
	    slotHeight: {
	      default: 40
	    },
	    calStartTime: {
	      default: '08:00:00'
	    },
	    calEndTime: {
	      default: '17:00:00'
	    },
	    isEventsClickable: {
	      type: Boolean,
	      default: false
	    },
	    isCalendarInPrintMode: {
	      type: Boolean,
	      default: false
	    },
	    isMobile: {
	      type: Boolean,
	      default: false
	    },
	    isCalNoBgColors: {
	      type: Boolean,
	      default: false
	    },
	    eventFontSize: {
	      default: 10
	    },
	    isHideCalendars: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      correctEvents: [],
	      firstEvent: true,
	      isWindowResizing: false
	    };
	  },
	
	  computed: {
	    dayLessons: function dayLessons() {
	      var _this = this;
	
	      return this.events.filter(function (lesson) {
	        return (0, _moment2.default)(lesson.start).format('YYYY-MM-DD') === (0, _moment2.default)(_this.date).format('YYYY-MM-DD');
	      });
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    }
	  },
	  watch: {
	    dayLessons: function dayLessons() {
	      this.updateEventsPositions();
	    },
	    slotHeight: function slotHeight() {
	      this.updateEventsPositions();
	    },
	    calStartTime: function calStartTime() {
	      this.updateEventsPositions();
	    },
	    calEndTime: function calEndTime() {
	      this.updateEventsPositions();
	    }
	  },
	  methods: {
	    getEventWarningLabel: function getEventWarningLabel(eventObj) {
	      if (eventObj.canceled) {
	        return this.i18n.canceled;
	      }
	      if (eventObj.away) {
	        return this.i18n.out_of_school;
	      }
	    },
	    updateEventsPositions: function updateEventsPositions() {
	      var _this2 = this;
	
	      this.$nextTick(function (_) {
	        _this2.correctEvents = [];
	        _this2.formatEvents();
	        _this2.firstEvent = true;
	      });
	    },
	    onEventClick: function onEventClick(event, evt) {
	      if (event.obj.event_type === 'presence') {
	        this.$emit('onPresenceClick', event);
	      } else {
	        evt.stopPropagation();
	        this.$emit('onEventClick', event);
	      }
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hours': (0, _moment2.default)(this.calStartTime).format('HH'),
	        'minutes': (0, _moment2.default)(this.calStartTime).format('mm')
	      });
	      var eventStartTime = (0, _moment2.default)(event.start);
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      var eventTop = this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	      return eventTop;
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = (0, _moment2.default)(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hours': (0, _moment2.default)(this.calStartTime).format('HH'),
	        'minutes': (0, _moment2.default)(this.calStartTime).format('mm')
	      });
	      var eventEndTime = (0, _moment2.default)(event.end);
	      var duration = (0, _moment2.default)(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    formatEvents: function formatEvents() {
	      var dayEventsPresence = this.dayLessons.filter(function (event) {
	        return event.event_type === 'presence';
	      });
	      this.setWidthAndLeft(dayEventsPresence);
	      var dayEvents = this.dayLessons.filter(function (event) {
	        return event.event_type !== 'presence';
	      });
	      this.setWidthAndLeft(dayEvents);
	    },
	    setWidthAndLeft: function setWidthAndLeft(dayLessons) {
	      var _this3 = this;
	
	      var columns = [];
	      var lastEventEnding = null;
	      var events = dayLessons.map(function (elem) {
	        var top = _this3.eventTop(elem);
	        var height = _this3.eventHeight(elem);
	        var bottom = _this3.eventBottom(elem);
	        return {
	          'obj': elem,
	          'top': top,
	          'height': height,
	          'bottom': bottom
	        };
	      });
	      events = events.sort(function (e1, e2) {
	        if (e1.top < e2.top) return -1;
	        if (e1.top > e2.top) return 1;
	        if (e1.bottom < e2.bottom) return 1;
	        if (e1.bottom > e2.bottom) return -1;
	        return e1.obj.v_sort_key.localeCompare(e2.obj.v_sort_key);
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packEvents(columns);
	          columns = [];
	          lastEventEnding = null;
	        }
	        var placed = false;
	        for (var j = 0; j < columns.length; j++) {
	          var col = columns[j];
	          if (!this.collidesWith(col[col.length - 1], e)) {
	            col.push(e);
	            placed = true;
	            break;
	          }
	        }
	        if (!placed) {
	          columns.push([e]);
	        }
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (columns.length > 0) {
	        this.packEvents(columns);
	      }
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].left = i / n * 100;
	          col[j].width = 100 * colSpan / n;
	          col[j].cols = n;
	
	          if (n > 1 && j === 0) {
	            var aTop = col[j].top;
	            var bTop = columns[j + 1][0].top;
	
	            if (bTop - aTop > 20) {
	              col[j].width = 90;
	            }
	          }
	          this.correctEvents.push(col[j]);
	
	          if (this.firstEvent) {
	            this.$emit('lessonsUpdate', this.correctEvents[0]);
	          }
	          this.firstEvent = false;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    }
	  },
	  mounted: function mounted() {
	    this.updateEventsPositions();
	  }
	};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    other_school: 'Anden skole',
	    this_event_can_only_be_edited_in: 'Denne brik kan kun redigeres i',
	    where_it_initially_was_scheduled: 'hvor den er skemalagt',
	    the_calendar: 'den kalender',
	    go_to: 'Gå til',
	    out_of_school: 'Ude af huset',
	    canceled: 'Aflyst'
	  },
	  en: {
	    other_school: 'Other school',
	    this_event_can_only_be_edited_in: 'This event can only be edited in',
	    where_it_initially_was_scheduled: 'where it is scheduled',
	    the_calendar: 'the calendar',
	    go_to: 'Go to',
	    out_of_school: 'Out of school',
	    canceled: 'Canceled'
	  },
	  nb: {
	    other_school: 'Annen skole',
	    this_event_can_only_be_edited_in: 'Denne timen kan kun redigeres i',
	    the_calendar: 'den kalenderen',
	    where_it_initially_was_scheduled: 'hvor den opprinnelig er planlagt',
	    go_to: 'Gå til',
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst'
	  }
	};
	
	exports.default = {
	  props: {
	    calendar: {
	      type: Object,
	      default: null
	    },
	    calendarId: {
	      default: 7
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {},
	    slotHeight: {
	      default: 40
	    },
	    calStartTime: {
	      default: '08:00:00'
	    },
	    calEndTime: {
	      default: '17:00:00'
	    },
	    isEventsClickable: {
	      type: Boolean,
	      default: false
	    },
	    dragLesson: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    dragEventY: {
	      type: Number,
	      default: 0
	    },
	    dragEventHeight: {
	      type: Number,
	      default: 0
	    },
	    dragActiveDate: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    isResizingEvent: {
	      type: Boolean,
	      default: false
	    },
	    isDraggingEvent: {
	      type: Boolean,
	      default: false
	    },
	    isDraggingExternalEvent: {
	      type: Boolean,
	      default: false
	    },
	    theExternalEvent: {
	      type: Object,
	      default: null
	    },
	    dragEventStart: {},
	    dragEventEnd: {},
	    isLocked: {
	      type: Boolean,
	      default: false
	    },
	    dragActiveDates: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isSideResizingEvent: {
	      type: Boolean,
	      default: false
	    },
	    isCopyCalendarModalOpen: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      correctEvents: [],
	      firstEvent: true,
	      isWindowResizing: false,
	      dragLessonId: null,
	      startY: 0,
	      startX: 0,
	      delta: 2,
	      distanceMovedY: null,
	      distanceMovedX: null,
	      raf: null
	    };
	  },
	
	  computed: {
	    isCalendarTypeRoom: function isCalendarTypeRoom() {
	      return this.calendar && this.calendar.type ? this.calendar.type === 'room' : false;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    dragEventStartTime: function dragEventStartTime() {
	      return (0, _moment2.default)(this.dragEventStart).format('LT');
	    },
	    dragEventEndTime: function dragEventEndTime() {
	      return (0, _moment2.default)(this.dragEventEnd).format('LT');
	    },
	    dayLessons: function dayLessons() {
	      var _this = this;
	
	      return this.events.filter(function (lesson) {
	        return (0, _moment2.default)(lesson.start).format('YYYY-MM-DD') === (0, _moment2.default)(_this.date).format('YYYY-MM-DD');
	      });
	    },
	    isActiveDay: function isActiveDay() {
	      if (!this.isSideResizingEvent) {
	        if (!this.dragActiveDate) {
	          return false;
	        }
	        return (0, _moment2.default)(this.date).isSame(this.dragActiveDate);
	      } else {
	        if (this.dragActiveDates.length < 1) {
	          return false;
	        }
	        var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	        return this.dragActiveDates.includes(date);
	      }
	    }
	  },
	  watch: {
	    dayLessons: function dayLessons() {
	      this.updateEventsPositions();
	    },
	    slotHeight: function slotHeight() {
	      this.updateEventsPositions();
	    },
	    calStartTime: function calStartTime() {
	      this.updateEventsPositions();
	    },
	    calEndTime: function calEndTime() {
	      this.updateEventsPositions();
	    }
	  },
	  methods: {
	    getEventWarningLabel: function getEventWarningLabel(eventObj) {
	      if (eventObj.canceled) {
	        return this.i18n.canceled;
	      }
	      if (eventObj.away) {
	        return this.i18n.out_of_school;
	      }
	    },
	    onNativeEventClick: function onNativeEventClick(event, evt) {
	      if (event && event.obj && event.obj.event_type === 'presence') {} else {
	        evt.stopPropagation();
	      }
	    },
	    onMouseEnterDay: function onMouseEnterDay(evt) {
	      var _this2 = this;
	
	      if (!this.dragLesson && !this.theExternalEvent) {
	        return;
	      }
	      if (this.dragLesson || !this.isResizingEvent || this.theExternalEvent) {
	        this.$emit('setDragActiveDate', this.date);
	        if (this.isDraggingExternalEvent) {
	          this.startY = evt.pageY;
	          this.startX = evt.pageX;
	          var elTop = document.querySelector('.day-cal__event-container').getBoundingClientRect().top - 1;
	          var mouseEnterDayPxFromTop = evt.clientY;
	          var PxFromTopOfCal = mouseEnterDayPxFromTop - elTop;
	
	          var fiveMinutesInPx = this.slotHeight / 6;
	          var closestFiveMinutesInPx = Math.floor(PxFromTopOfCal / fiveMinutesInPx) * fiveMinutesInPx;
	
	          var numberOfMinutesToMultiply = Math.floor(PxFromTopOfCal / fiveMinutesInPx);
	          var minutes = 5 * Math.abs(numberOfMinutesToMultiply);
	          var startTime = (0, _moment2.default)(this.calStartTime).add(minutes, 'minutes');
	          var endTime = (0, _moment2.default)(startTime).add(this.theExternalEvent.default_duration, 'minutes');
	
	          var eventCals = this.theExternalEvent.cals;
	          var isNotThisCalendar = this.theExternalEvent.calendar_id !== this.calendarId;
	          var isNotInCalsArrAlready = eventCals.findIndex(function (cal) {
	            return cal.id === _this2.theExternalEvent.calendar_id;
	          }) < 0;
	          if (isNotThisCalendar && isNotInCalsArrAlready) {
	            var otherCal = { id: this.theExternalEvent.calendar_id };
	            eventCals.push(otherCal);
	          }
	          var event = {
	            school_id: this.theExternalEvent.school_id,
	            subject_id: this.theExternalEvent.id,
	            calendarIds: [],
	            title: this.theExternalEvent.title,
	            end: endTime,
	            start: startTime,
	            color: this.theExternalEvent.color,
	            event_id: null,
	            calendars: eventCals,
	            event_type: this.theExternalEvent.subjectType,
	            calendar_id: this.calendarId,
	            description: '',
	            learning_goal: '',
	            teacher_notes: '',
	            notes_for_students: '',
	            has_notes: false,
	            group: '',
	            teacher: '',
	            room: '',
	            substitutes: null,
	            eventDuration: this.theExternalEvent.default_duration,
	            v_other_school: false,
	            v_is_editable: true
	          };
	          var lesson = {
	            top: closestFiveMinutesInPx,
	            height: this.eventHeight(event),
	            bottom: 0,
	            left: 0,
	            width: 100,
	            obj: event
	          };
	          this.onMouseDown(lesson, evt);
	          this.$emit('setIsDraggingExternalEvent', false);
	        }
	      }
	    },
	    onMouseLeaveDay: function onMouseLeaveDay(evt) {
	      if (!this.dragLesson || this.isResizingEvent || this.isSideResizingEvent) {
	        return;
	      }
	      this.$emit('setDragActiveDate', null);
	    },
	    getIsMouseDownAllowed: function getIsMouseDownAllowed(lesson) {
	      return this.isEventsClickable && !lesson.obj.v_other_school && lesson.obj.event_type !== 'presence' && !lesson.obj.v_is_loading;
	    },
	    onMouseDown: function onMouseDown(lesson, evt) {
	      if (!this.getIsMouseDownAllowed(lesson) || evt.button === 2 || evt.button === 1 || evt.target.classList.contains('js-no-click')) {
	        return;
	      }
	      evt.target.releasePointerCapture(evt.pointerId);
	      if (evt.target.classList.contains('d-event__resizer')) {
	        this.$emit('setIsResizingEvent', true);
	      }
	      if (evt.target.classList.contains('d-event__side__resizer')) {
	        this.$emit('setIsSideResizingEvent', true);
	      }
	      this.startY = evt.pageY;
	      this.startX = evt.pageX;
	      this.$emit('setDragEventY', lesson.top);
	      this.$emit('setDragEventHeight', lesson.height);
	      this.$emit('setDragLesson', lesson);
	      this.$emit('setDragEventStart', lesson.obj.start);
	      this.$emit('setDragEventEnd', lesson.obj.end);
	      this.$emit('setDragActiveDate', this.date);
	      if (lesson.obj.v_is_editable && !this.isLocked) {
	        document.addEventListener('pointermove', this.onMouseMove, { passive: true });
	      }
	      document.addEventListener('pointerup', this.onMouseUp, { passive: true });
	      document.addEventListener('pointercancel', this.onMouseUp, { passive: true });
	    },
	    onMouseUp: function onMouseUp(evt) {
	      if (this.dragActiveDate) {
	        this.getIsDragOrClick(evt);
	      }
	      this.$emit('onMouseUp');
	      this.cleanUp();
	      document.removeEventListener('pointermove', this.onMouseMove);
	      document.removeEventListener('pointerup', this.onMouseUp);
	      document.addEventListener('pointercancel', this.onMouseUp);
	      this.distanceMovedY = null;
	      this.distanceMovedX = null;
	      if (this.raf) {
	        window.cancelAnimationFrame(this.raf);
	        this.raf = null;
	      }
	    },
	    getIsDragOrClick: function getIsDragOrClick(evt) {
	      if (!this.dragLesson.obj.v_is_editable && !this.dragLesson.obj.v_other_calendar || this.isLocked && !this.dragLesson.obj.v_other_calendar) {
	        this.onEventClick(evt);
	        return;
	      }
	      if (!this.isDraggingEvent) {
	        this.onEventClick(evt);
	      } else {
	        if (this.dragLesson.obj.v_other_calendar) {
	          var parentCalendarName = this.dragLesson.obj.v_other_calendar && this.dragLesson.obj.v_other_calendar.name ? this.dragLesson.obj.v_other_calendar.name : this.i18n['the_calendar'];
	          var txt = this.i18n['this_event_can_only_be_edited_in'] + ' ' + parentCalendarName + ', ' + this.i18n['where_it_initially_was_scheduled'];
	          _eventbus2.default.toast = { text: txt, 'success': false };
	          return;
	        }
	        this.updateEventTimes();
	      }
	    },
	    updateEventTimes: function updateEventTimes() {
	      var _this3 = this;
	
	      if (this.isSideResizingEvent) {
	        if (this.dragActiveDates.length < 1) {
	          return;
	        }
	        var eventsToCreate = [];
	        this.dragActiveDates.forEach(function (dragDate, key) {
	          var newEvent = (0, _assign2.default)({}, _this3.dragLesson.obj);
	          var year = (0, _moment2.default)(dragDate).year();
	          var month = (0, _moment2.default)(dragDate).month();
	          var day = (0, _moment2.default)(dragDate).date();
	          var newStartTime = (0, _moment2.default)(newEvent.start).set({
	            year: year,
	            month: month,
	            date: day,
	            millisecond: 0
	          });
	          var newEndTime = (0, _moment2.default)(newEvent.end).set({
	            year: year,
	            month: month,
	            date: day,
	            millisecond: 0
	          });
	          newEvent.event_id = 'new_temp_id_' + key;
	          newEvent.start = newStartTime;
	          newEvent.end = newEndTime;
	          newEvent.v_is_loading = true;
	          eventsToCreate.push(newEvent);
	        });
	        this.$store.dispatch('createCalendarEvents', eventsToCreate);
	        return;
	      }
	      var year = (0, _moment2.default)(this.dragActiveDate).year();
	      var month = (0, _moment2.default)(this.dragActiveDate).month();
	      var date = (0, _moment2.default)(this.dragActiveDate).date();
	      var newStartTime = (0, _moment2.default)(this.dragEventStart).set({
	        'year': year,
	        'month': month,
	        'date': date,
	        'millisecond': 0
	      });
	      var newEndTime = (0, _moment2.default)(this.dragEventEnd).set({ 'year': year, 'month': month, 'date': date, 'millisecond': 0 });
	      if (this.dragLesson.obj.event_id) {
	        var updatedArr = {
	          school_id: this.dragLesson.obj.school_id,
	          updates: [{
	            event_id: this.dragLesson.obj.event_id,
	            calendar_id: this.dragLesson.obj.calendar_id,
	            start_time: newStartTime,
	            end_time: newEndTime
	          }]
	        };
	        this.$store.dispatch('updateCalendarEvent', updatedArr);
	      } else {
	        this.dragLesson.obj.event_id = 'new_temp_id';
	        this.dragLesson.obj.start = newStartTime;
	        this.dragLesson.obj.end = newEndTime;
	        this.dragLesson.obj.calendar_id = this.calendarId;
	        this.dragLesson.obj.v_is_loading = true;
	        this.$store.dispatch('createCalendarEvent', this.dragLesson.obj);
	      }
	    },
	    onMouseMove: function onMouseMove(evt) {
	      if (!this.raf) {
	        this.distanceMovedY = evt.pageY - this.startY;
	        this.distanceMovedX = evt.pageX - this.startX;
	        this.raf = window.requestAnimationFrame(this.moveEvent);
	        var cursorPlacement = {
	          x: evt.pageX,
	          y: evt.pageY
	        };
	        this.$emit('setTheDeleteSubjectCursorPlacement', cursorPlacement);
	      }
	    },
	    moveEvent: function moveEvent() {
	      var distanceMovedY = this.distanceMovedY;
	      var distanceMovedX = this.distanceMovedX;
	      if (Math.abs(distanceMovedY) > this.delta || Math.abs(distanceMovedX) > this.delta) {
	        if (!this.isDraggingEvent) {
	          this.$emit('setIsDraggingEvent', true);
	        }
	      }
	      var fiveMinutesInPx = this.slotHeight / 6;
	      var numberOfMinutesToMultiply = Math.floor(distanceMovedY / fiveMinutesInPx);
	      var minutes = 5 * Math.abs(numberOfMinutesToMultiply);
	      var dragEventStart = void 0,
	          dragEventEnd = void 0;
	      if (!this.isResizingEvent && !this.isSideResizingEvent) {
	        if (numberOfMinutesToMultiply > 0) {
	          dragEventStart = (0, _moment2.default)(this.dragLesson.obj.start).add(minutes, 'minutes');
	          dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).add(minutes, 'minutes');
	        } else {
	          dragEventStart = (0, _moment2.default)(this.dragLesson.obj.start).subtract(minutes, 'minutes');
	          dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).subtract(minutes, 'minutes');
	        }
	        this.$emit('setDragEventStart', dragEventStart);
	        this.$emit('setDragEventEnd', dragEventEnd);
	        this.$emit('setDragEventY', this.dragLesson.top + fiveMinutesInPx * numberOfMinutesToMultiply);
	      } else if (this.isResizingEvent) {
	        if (numberOfMinutesToMultiply > 0) {
	          dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).add(minutes, 'minutes');
	        } else {
	          dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.end).subtract(minutes, 'minutes');
	          if ((0, _moment2.default)(dragEventEnd).isSameOrBefore(this.dragLesson.obj.start)) {
	            dragEventEnd = (0, _moment2.default)(this.dragLesson.obj.start).add(5, 'minutes');
	          }
	        }
	        var dragEventHeight = this.dragLesson.height + fiveMinutesInPx * numberOfMinutesToMultiply > 0 ? this.dragLesson.height + fiveMinutesInPx * numberOfMinutesToMultiply : fiveMinutesInPx;
	        this.$emit('setDragEventEnd', dragEventEnd);
	        this.$emit('setDragEventHeight', dragEventHeight);
	      }
	
	      this.raf = null;
	    },
	    cleanUp: function cleanUp() {
	      this.$emit('setDragActiveDate', null);
	      this.$emit('setDragLesson', null);
	      this.$emit('setIsResizingEvent', false);
	      this.$emit('setIsSideResizingEvent', false);
	      this.$emit('setIsDraggingEvent', false);
	    },
	    updateEventsPositions: function updateEventsPositions() {
	      var _this4 = this;
	
	      this.$nextTick(function (_) {
	        _this4.correctEvents = [];
	        _this4.formatEvents();
	        _this4.firstEvent = true;
	      });
	    },
	    onEventClick: function onEventClick(evt) {
	      this.$emit('onEventClick', this.dragLesson);
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hours': (0, _moment2.default)(this.calStartTime).format('HH'),
	        'minutes': (0, _moment2.default)(this.calStartTime).format('mm')
	      });
	      var eventStartTime = (0, _moment2.default)(event.start);
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      var eventTop = this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	      return eventTop;
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = (0, _moment2.default)(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hours': (0, _moment2.default)(this.calStartTime).format('HH'),
	        'minutes': (0, _moment2.default)(this.calStartTime).format('mm')
	      });
	      var eventEndTime = (0, _moment2.default)(event.end);
	      var duration = (0, _moment2.default)(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    formatEvents: function formatEvents() {
	      var dayEventsPresence = this.dayLessons.filter(function (event) {
	        return event.event_type === 'presence';
	      });
	      this.setWidthAndLeft(dayEventsPresence);
	      var backgroundEvent = this.dayLessons.filter(function (event) {
	        return event.rendering && event.event_type !== 'presence';
	      });
	      this.setWidthAndLeft(backgroundEvent);
	      var dayEvents = this.dayLessons.filter(function (event) {
	        return event.event_type !== 'presence' && !event.rendering;
	      });
	      this.setWidthAndLeft(dayEvents);
	    },
	    setWidthAndLeft: function setWidthAndLeft(dayLessons) {
	      var _this5 = this;
	
	      var columns = [];
	      var lastEventEnding = null;
	
	      var events = dayLessons.map(function (elem) {
	        var top = _this5.eventTop(elem);
	        var height = _this5.eventHeight(elem);
	        var bottom = _this5.eventBottom(elem);
	
	        return {
	          'obj': elem,
	          'top': top,
	          'height': height,
	          'bottom': bottom
	        };
	      });
	
	      events = events.sort(function (e1, e2) {
	        if (e1.top < e2.top) return -1;
	        if (e1.top > e2.top) return 1;
	        if (e1.bottom < e2.bottom) return 1;
	        if (e1.bottom > e2.bottom) return -1;
	
	        return e1.obj.v_sort_key.localeCompare(e2.obj.v_sort_key);
	      });
	
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packEvents(columns);
	          columns = [];
	          lastEventEnding = null;
	        }
	        var placed = false;
	        for (var j = 0; j < columns.length; j++) {
	          var col = columns[j];
	          if (!this.collidesWith(col[col.length - 1], e)) {
	            col.push(e);
	            placed = true;
	            break;
	          }
	        }
	        if (!placed) {
	          columns.push([e]);
	        }
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (columns.length > 0) {
	        this.packEvents(columns);
	      }
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].left = i / n * 100;
	          col[j].width = 100 * colSpan / n;
	          col[j].cols = n;
	
	          if (n > 1 && j === 0) {
	            var aTop = col[j].top;
	            var bTop = columns[j + 1][0].top;
	
	            if (bTop - aTop > 20) {
	              col[j].width = 90;
	            }
	          }
	          this.correctEvents.push(col[j]);
	
	          if (this.firstEvent) {
	            this.$emit('lessonsUpdate', this.correctEvents[0]);
	          }
	          this.firstEvent = false;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    goToCalendar: function goToCalendar(calendarId, evt) {
	      window.location.href = '/calendars/' + calendarId;
	    },
	    customTooltip: function customTooltip(obj) {
	      var parentCalendarName = obj.v_other_calendar && obj.v_other_calendar.name ? obj.v_other_calendar.name : this.i18n['the_calendar'];
	      return this.i18n['go_to'] + ' ' + parentCalendarName;
	    }
	  }
	};

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    deleteSubject: {
	      type: Object,
	      default: null
	    },
	    activeSubject: {
	      type: Object,
	      default: null
	    },
	    activeSubjectBCR: {
	      default: null
	    },
	    movedX: {
	      type: Number,
	      default: 0
	    },
	    movedY: {
	      type: Number,
	      default: 0
	    }
	  },
	  computed: {
	    subjectTitle: function subjectTitle() {
	      return this.activeSubject ? this.activeSubject.title : this.deleteSubject ? this.deleteSubject.title : '';
	    },
	    styleObj: function styleObj() {
	      return {
	        'top': this.movedY + 'px',
	        'left': this.movedX + 'px',
	        'background': this.activeSubject ? this.activeSubject.color : this.deleteSubject ? this.deleteSubject.color : 'transparent',
	        'width': this.activeSubjectBCR ? this.activeSubjectBCR.width + 'px' : '165px',
	        'height': this.activeSubjectBCR ? this.activeSubjectBCR.height + 'px' : '40px',
	        'borderColor': this.activeSubject ? this.activeSubject.color : this.deleteSubject ? this.deleteSubject.color : 'transparent'
	      };
	    }
	  },
	  mounted: function mounted() {
	    var el = this.$refs.d_cal_dragged;
	
	    document.getElementById('djs-content-container').appendChild(el);
	  }
	};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DCalendarSelect = __webpack_require__(1243);
	
	var _DCalendarSelect2 = _interopRequireDefault(_DCalendarSelect);
	
	var _CopyCalendar = __webpack_require__(298);
	
	var _CopyCalendar2 = _interopRequireDefault(_CopyCalendar);
	
	var _Print = __webpack_require__(117);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _EditCalendarEditName = __webpack_require__(1262);
	
	var _EditCalendarEditName2 = _interopRequireDefault(_EditCalendarEditName);
	
	var _EditCalendarDelete = __webpack_require__(1261);
	
	var _EditCalendarDelete2 = _interopRequireDefault(_EditCalendarDelete);
	
	var _PresenceUser = __webpack_require__(70);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _ExportCalendar = __webpack_require__(83);
	
	var _ExportCalendar2 = _interopRequireDefault(_ExportCalendar);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CalendarMergeModal = __webpack_require__(1214);
	
	var _CalendarMergeModal2 = _interopRequireDefault(_CalendarMergeModal);
	
	var _CalculateHours = __webpack_require__(294);
	
	var _CalculateHours2 = _interopRequireDefault(_CalculateHours);
	
	var _DCalendarHeaderDelete = __webpack_require__(1240);
	
	var _DCalendarHeaderDelete2 = _interopRequireDefault(_DCalendarHeaderDelete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    calculate_hours: 'Beregn timer'
	  },
	  en: {
	    calculate_hours: 'Calculate Hours'
	  },
	  nb: {
	    calculate_hours: 'Beregn timer'
	  }
	};
	
	exports.default = {
	  components: {
	    DCalendarHeaderDelete: _DCalendarHeaderDelete2.default,
	    CalculateHours: _CalculateHours2.default,
	    CalendarMergeModal: _CalendarMergeModal2.default,
	    EditCalendarDelete: _EditCalendarDelete2.default,
	    ExportCalendar: _ExportCalendar2.default,
	    EditCalendarEditName: _EditCalendarEditName2.default, DDropdown: _DDropdown2.default, Print: _Print2.default, DCalendarSelect: _DCalendarSelect2.default, CopyCalendar: _CopyCalendar2.default, UserPresence: _PresenceUser2.default
	  },
	  props: {
	    calendarId: {
	      required: true
	    },
	    initCalendar: {
	      default: null
	    },
	    activeCalendarDate: {
	      default: null
	    },
	    dates: {
	      default: null
	    },
	    hasHotKeys: {
	      default: false
	    },
	    isLoadingEvents: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      calendar: null,
	      isShowExportCalendarModal: false,
	      isShowMergeCalendars: false,
	      isShowCalculateHours: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    calendarType: function calendarType() {
	      return this.calendar && this.calendar.type ? this.calendar.type : null;
	    },
	    isMergeCalendar: function isMergeCalendar() {
	      return this.calendarType === 'merge';
	    },
	    calendarName: function calendarName() {
	      return this.calendar && this.calendar.name ? this.calendar.name : '';
	    },
	    iCalUrl: function iCalUrl() {
	      return this.calendar && this.calendar.ical_url ? window.location.origin + this.calendar.ical_url : this.calendar && this.calendar.ical_link ? window.location.origin + this.calendar.ical_link : 'loading';
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return this.calendar && this.calendar.school_id ? this.calendar.school_id : this.activeSchool.id;
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      return this.$store.getters.firstDayOfTheWeek;
	    },
	    isLocked: function isLocked() {
	      return this.calendar && this.calendar.locked ? this.calendar.locked : false;
	    },
	    canBeLocked: function canBeLocked() {
	      var typesThatCantBeLocked = ['user', 'room'];
	      return typesThatCantBeLocked.indexOf(this.calendarType) < 0 && this.userHasPermission('can_do_most_stuff');
	    },
	    canToggleViewState: function canToggleViewState() {
	      return this.userHasPermission('can_do_most_stuff');
	    },
	    canBeDeleted: function canBeDeleted() {
	      var typesThatCantBeDeleted = ['merge', 'room', 'user'];
	      return typesThatCantBeDeleted.indexOf(this.calendarType) < 0 && this.userHasPermission('can_manage_calendars');
	    },
	    canEditName: function canEditName() {
	      var typesThatCantEditName = ['user'];
	      return typesThatCantEditName.indexOf(this.calendarType) < 0 && this.userHasPermission('can_manage_calendars');
	    },
	    canBeArchived: function canBeArchived() {
	      var typesThatCantBeDeleted = ['merge', 'room'];
	      return typesThatCantBeDeleted.indexOf(this.calendarType) > -1 && this.userHasPermission('can_manage_calendars');
	    },
	    canEditPresence: function canEditPresence() {
	      var typesThatCanEditPresence = ['user'];
	      return typesThatCanEditPresence.indexOf(this.calendarType) > -1;
	    },
	    canSeeExportCalendar: function canSeeExportCalendar() {
	      var typesThatCanExportCalendar = ['user'];
	      return typesThatCanExportCalendar.indexOf(this.calendarType) > -1;
	    },
	    canSeeMergeWithMergeCalendars: function canSeeMergeWithMergeCalendars() {
	      var typesThatCanExportCalendar = ['klass', 'club'];
	      return typesThatCanExportCalendar.indexOf(this.calendarType) > -1;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    isToday: function isToday() {
	      return this.activeCalendarDate ? (0, _moment2.default)(this.activeCalendarDate).isoWeek() === (0, _moment2.default)().isoWeek() : false;
	    },
	    calendarDateInterval: function calendarDateInterval() {
	      if (this.dates.length === 0) {
	        return '';
	      }
	      var startDate = (0, _moment2.default)(this.dates[0]);
	      var endDate = (0, _moment2.default)(this.dates[this.dates.length - 1]);
	      var startFormat = startDate.format('D.');
	      if (!(0, _moment2.default)(startDate).isSame(endDate, 'month')) {
	        startFormat = startDate.format('D. MMM');
	      }
	      if (!(0, _moment2.default)(startDate).isSame(endDate, 'year')) {
	        startFormat = startDate.format('D. MMM, YYYY');
	      }
	      var endFormat = endDate.format('D. MMM, YYYY');
	      return startFormat + ' - ' + endFormat;
	    },
	    tooltipArrowLeft: function tooltipArrowLeft() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>←</span></p>';
	    },
	    tooltipArrowRight: function tooltipArrowRight() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>→</span></p>';
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    isAnonymousAccessActivated: function isAnonymousAccessActivated() {
	      return this.calendar && this.calendar.anonymous_access;
	    },
	    canSeePublicCalendar: function canSeePublicCalendar() {
	      var typesThatCanExportCalendar = ['klass', 'kindergarten'];
	      return typesThatCanExportCalendar.indexOf(this.calendarType) > -1;
	    }
	  },
	  methods: {
	    setIsShowMergeCalendars: function setIsShowMergeCalendars(bool) {
	      this.isShowMergeCalendars = bool;
	      if (!bool) {
	        if (this.activeCalendarDate) {
	          this.$emit('updateEvents');
	        } else {
	          window.location.reload();
	        }
	      }
	    },
	    setIsShowExportCalendarModal: function setIsShowExportCalendarModal(bool) {
	      this.isShowExportCalendarModal = bool;
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    openEditNameModal: function openEditNameModal() {
	      _eventbus2.default.editCalendarNameModal = true;
	    },
	    openDeleteModal: function openDeleteModal() {
	      _eventbus2.default.editCalendarDeleteModal = true;
	    },
	    toggleCalendarLock: function toggleCalendarLock() {
	      var bool = this.isLocked ? 'false' : 'true';
	      this.updateCalendar({ locked: bool });
	    },
	    toggleCalendarView: function toggleCalendarView(state) {
	      this.updateCalendar({ view_state: state });
	    },
	    updateCalendar: function updateCalendar(changesObj) {
	      _docendo2.default.schoolCalendarsUpdate(this.schoolId, this.calendarId, changesObj, function (success) {
	        _eventbus2.default.toast = { text: 'Calendar updated', 'success': true };
	        window.location.reload();
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    archiveCalendar: function archiveCalendar() {
	      var _this = this;
	
	      _docendo2.default.schoolCalendarsUpdate(this.schoolId, this.calendarId, { archived: true }, function (success) {
	        var updateObj = {
	          id: success.id,
	          name: success.name,
	          archived_at: success.archived_at
	        };
	        _this.$store.commit('updateSchoolCalendar', updateObj);
	        _eventbus2.default.toast = { text: 'Calendar updated', 'success': true };
	        window.location.href = '/calendar';
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    openPublicCalendar: function openPublicCalendar() {
	      if (this.calendar.anonymous_access) {
	        var url = this.generatePublicLink(this.calendar);
	        window.open(url, '_blank').focus();
	      } else {
	        var schoolId = this.calendar.school_id ? this.calendar.school_id : this.schoolId;
	        var _url = window.location.origin + '/schools/' + schoolId + '/calendars_setup#/';
	        window.open(_url, '_blank').focus();
	      }
	    },
	    generatePublicLink: function generatePublicLink(calendar) {
	      return window.location.origin + '/calendar/' + calendar.public_id;
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this2 = this;
	
	    if (this.initCalendar) {
	      this.calendar = this.initCalendar;
	    } else {
	      _docendo2.default.calendar(this.calendarId, function (success) {
	        _this2.calendar = success;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    }
	  }
	};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    calendarId: {
	      default: null
	    },
	    firstDayOfTheWeek: {
	      default: 1
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isConfirmDeletion: false,
	      isDeleteWeek: false,
	      theDeleteDayDate: null,
	      theDeleteText: false,
	      isDeleting: false
	    };
	  },
	
	  computed: {
	    weekDays: function weekDays() {
	      var arr = [];
	      for (var i = this.firstDayOfTheWeek; i < 8; i++) {
	        var weekDayDate = (0, _moment2.default)(this.date).isoWeekday(i);
	        var obj = {
	          date: weekDayDate,
	          name: (0, _moment2.default)(weekDayDate).format('dddd')
	        };
	        arr.push(obj);
	      }
	      return arr;
	    }
	  },
	  methods: {
	    setIsConfirmDeletion: function setIsConfirmDeletion(day) {
	      if (day === 'week') {
	        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + this.$t('vue.deleteday.whole_week');
	        this.isDeleteWeek = true;
	      } else {
	        this.isDeleteWeek = false;
	        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + day.name;
	        this.theDeleteDayDate = day.date;
	      }
	      this.isConfirmDeletion = true;
	    },
	    closeIsConfirmDelete: function closeIsConfirmDelete() {
	      this.isConfirmDeletion = false;
	      this.isDeleteWeek = false;
	      this.theDeleteDayDate = null;
	    },
	    onConfirmDelete: function onConfirmDelete() {
	      if (this.isDeleteWeek) {
	        this.deleteWeek();
	      } else {
	        this.deleteDay();
	      }
	    },
	    deleteDay: function deleteDay() {
	      var _this = this;
	
	      this.isDeleting = true;
	      var from = (0, _moment2.default)(this.theDeleteDayDate).startOf('day').toISOString();
	      var to = (0, _moment2.default)(this.theDeleteDayDate).endOf('day').toISOString();
	      _docendo2.default.deleteEventsRange(this.calendarId, from, to, function (success) {
	        _this.isDeleting = false;
	        _this.closeIsConfirmDelete();
	        _this.$emit('update');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.delete_day_or_week.cant_delete'), success: false };
	      });
	    },
	    deleteWeek: function deleteWeek() {
	      var _this2 = this;
	
	      this.isDeleting = true;
	      var fromDate = this.firstDayOfTheWeek === 1 ? (0, _moment2.default)(this.date).startOf('isoWeek') : (0, _moment2.default)(this.date).startOf('week');
	      var toDate = this.firstDayOfTheWeek === 1 ? (0, _moment2.default)(this.date).endOf('isoWeek') : (0, _moment2.default)(this.date).endOf('week');
	      var from = (0, _moment2.default)(fromDate).toISOString();
	      var to = (0, _moment2.default)(toDate).toISOString();
	      _docendo2.default.deleteEventsRange(this.calendarId, from, to, function (success) {
	        _this2.isDeleting = false;
	        _this2.closeIsConfirmDelete();
	        _this2.$emit('update');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.delete_day_or_week.cant_delete'), success: false };
	      });
	    }
	  }
	};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    no_lessons: 'Der er ingen lektioner i denne uge'
	  },
	  en: {
	    no_lessons: 'No lessons this week'
	  },
	  nb: {
	    no_lessons: 'Ingen leksjoner denne uken'
	  }
	};
	
	exports.default = {
	  props: {
	    calendarName: {
	      default: 'DCalendarList'
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    isShowWeekends: {
	      type: Boolean,
	      default: false
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    },
	    isCalendarInPrintMode: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    startDate: function startDate() {
	      return (0, _moment2.default)(this.date).isoWeekday(this.firstDayOfWeek);
	    },
	    endDate: function endDate() {
	      var endDayNum = this.isShowWeekends ? this.firstDayOfWeek + 6 : this.firstDayOfWeek + 4;
	      return (0, _moment2.default)(this.date).isoWeekday(endDayNum);
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      var isSameYear = (0, _moment2.default)(this.startDate).format('YYYY') === (0, _moment2.default)(this.endDate).format('YYYY');
	      var start = isSameYear ? (0, _moment2.default)(this.startDate).format('DD MMM') : (0, _moment2.default)(this.startDate).format('ll');
	      var end = (0, _moment2.default)(this.endDate).format('ll');
	      return start + ' - ' + end;
	    },
	    filteredEvents: function filteredEvents() {
	      return this.events;
	    },
	    sortedEvents: function sortedEvents() {
	      return this.filteredEvents.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    eventsSortedInDays: function eventsSortedInDays() {
	      var _this = this;
	
	      var eventsAndDays = [];
	      this.sortedEvents.forEach(function (event, idx) {
	        event.v_start = (0, _moment2.default)(event.start).format('LT');
	        event.v_end = (0, _moment2.default)(event.end).format('LT');
	        if (event.event_type === 'presence') {
	          event.title = _this.$t('vue2.task_overview.work_hours');
	          event.color = '#d9e9fb';
	        }
	        var startTime = event.start;
	        var dateObj = {
	          id: startTime,
	          type: 'dayDate',
	          start: (0, _moment2.default)(startTime).format('YYYY-MM-DD'),
	          showDay: (0, _moment2.default)(startTime).format('dddd'),
	          showDate: (0, _moment2.default)(startTime).format('LL')
	        };
	        if (idx === 0) {
	          eventsAndDays.push(dateObj);
	        }
	        if (idx > 0 && (0, _moment2.default)(event.start).format('YYYY-MM-DD') !== (0, _moment2.default)(_this.sortedEvents[idx - 1].start).format('YYYY-MM-DD')) {
	          eventsAndDays.push(dateObj);
	        }
	        eventsAndDays.push(event);
	      });
	      return eventsAndDays;
	    }
	  }
	};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    no_lessons: 'Der er ingen lektioner i denne uge'
	  },
	  en: {
	    no_lessons: 'No lessons this week'
	  },
	  nb: {
	    no_lessons: 'Ingen leksjoner denne uken'
	  }
	};
	
	exports.default = {
	  props: {
	    calendarId: {
	      default: 7
	    },
	    calendarName: {
	      default: 'DCalendarList'
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    isShowWeekends: {
	      type: Boolean,
	      default: false
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    },
	    isCalendarInPrintMode: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    startDate: function startDate() {
	      return (0, _moment2.default)(this.date).isoWeekday(this.firstDayOfWeek);
	    },
	    endDate: function endDate() {
	      var endDayNum = this.isShowWeekends ? this.firstDayOfWeek + 6 : this.firstDayOfWeek + 4;
	      return (0, _moment2.default)(this.date).isoWeekday(endDayNum);
	    },
	    weekDays: function weekDays() {
	      var _this = this;
	
	      var days = [];
	
	      var _loop = function _loop(i) {
	        var day = (0, _moment2.default)(_this.date).isoWeekday(i);
	        var events = _this.eventsWithMetaData.filter(function (event) {
	          return (0, _moment2.default)(event.start).format('YYYY-MM-DD') === day.format('YYYY-MM-DD');
	        });
	        days.push({
	          date: day.format('YYYY-MM-DD'),
	          formatted: _this.getShowDate(day),
	          events: _this.sortEvents(events)
	        });
	      };
	
	      for (var i = this.firstDayOfWeek; i <= this.numberOfDays; i++) {
	        _loop(i);
	      }
	      return days;
	    },
	    numberOfDays: function numberOfDays() {
	      if (this.isShowWeekends) {
	        return this.firstDayOfWeek + 6;
	      } else {
	        return this.firstDayOfWeek + 4;
	      }
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    userSchools: function userSchools() {
	      return this.$store.getters.userSchools;
	    },
	    eventsWithMetaData: function eventsWithMetaData() {
	      var _this2 = this;
	
	      return this.events.map(function (originalLesson) {
	        var lesson = (0, _extends3.default)({}, originalLesson);
	
	        if (lesson.rendering) {
	          (0, _assign2.default)(lesson, {
	            event_starttime: '',
	            event_endtime: '',
	            has_notes: false,
	            has_substitute: false,
	            group: '',
	            teacher: '',
	            v_teachers_arr: [],
	            room: '',
	            substitutes: '',
	            eventDuration: 0,
	            v_other_school: false,
	            v_is_editable: false
	          });
	          return lesson;
	        }
	
	        var stripHtml = function stripHtml(str) {
	          return (str || '').replace(/<(?:.|\n)*?>/gm, '');
	        };
	        var hasNotes = stripHtml(lesson.description) || stripHtml(lesson.notes_for_students) || stripHtml(lesson.teacher_notes) || stripHtml(lesson.learning_goal);
	
	        var groups = [];
	        var allGroups = [];
	        var rooms = [];
	        var allRooms = [];
	        var teachers = [];
	        var allTeachers = [];
	        var students = [];
	        var allStudents = [];
	        var substitutes = [];
	
	        var hasSubstitutes = false;
	        var eventActiveCalendarDuration = 0;
	
	        lesson.calendars.forEach(function (calendar) {
	          var calMeta = _this2.allCalendarsInHash[calendar.calendar_id];
	          if (!calMeta) return;
	
	          var name = calMeta.name;
	          var isCurrent = calendar.calendar_id === _this2.calendarId;
	
	          if (isCurrent) {
	            eventActiveCalendarDuration = calendar.minutes;
	            return;
	          }
	
	          switch (calMeta.type) {
	            case 'klass':
	              allGroups.push(name);
	              if (groups.length < 3) groups.push(name);
	              break;
	            case 'room':
	              allRooms.push(name);
	              if (rooms.length < 3) rooms.push(name);
	              break;
	            case 'user':
	              if (calendar.substitute) {
	                hasSubstitutes = true;
	                substitutes.push(name);
	              } else {
	                allTeachers.push(name);
	                if (teachers.length < 3) teachers.push(name);
	              }
	              break;
	            case 'student':
	              allStudents.push(name);
	              if (students.length < 3) students.push(name);
	              break;
	          }
	        });
	
	        var overflowLabel = function overflowLabel(arr, allArr) {
	          var overflow = allArr.length - 3;
	          if (overflow > 0) arr.push('+' + overflow);
	          return arr.join(', ');
	        };
	
	        (0, _assign2.default)(lesson, {
	          event_starttime: (0, _moment2.default)(lesson.start).locale(_this2.locale).format('LT'),
	          event_endtime: (0, _moment2.default)(lesson.end).locale(_this2.locale).format('LT'),
	          event_key: _this2.calendarId + '_' + lesson.event_id,
	          has_notes: !!hasNotes,
	          has_substitute: hasSubstitutes,
	          group: overflowLabel(groups, allGroups),
	          teacher: overflowLabel(teachers, allTeachers),
	          room: overflowLabel(rooms, allRooms),
	          substitutes: substitutes.join(', '),
	          eventDuration: eventActiveCalendarDuration,
	          v_other_school: _this2.getIsEventOtherSchool(lesson),
	          v_is_editable: _this2.getIsEventEditable(lesson),
	          v_teachers_arr: allTeachers
	        });
	
	        if (_this2.isShowStudents) {
	          lesson.students = overflowLabel(students, allStudents);
	        }
	
	        if (lesson.event_type === 'presence') {
	          lesson.title = _this2.$t('vue2.task_overview.work_hours');
	          lesson.color = '#d9e9fb';
	          lesson.teacher = '';
	        }
	
	        return lesson;
	      });
	    }
	  },
	  methods: {
	    getIsEventEditable: function getIsEventEditable(event) {
	      return this.calendarId * 1 === event.calendar_id && event.event_type !== 'presence';
	    },
	    getIsEventOtherSchool: function getIsEventOtherSchool(event) {
	      return event.event_type !== 'presence' && !this.userSchools[event.school_id];
	    },
	    sortEvents: function sortEvents(events) {
	      return events.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    getShowDate: function getShowDate(date) {
	      return this.locale !== 'en' ? (0, _moment2.default)(date).locale(this.locale).format('ddd[.] DD/MM') : (0, _moment2.default)(date).locale(this.locale).format('ddd MM/DD');
	    }
	  }
	};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _core = __webpack_require__(18);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    calendar: {
	      required: true,
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      selectedCalendarId: null,
	      isDropDown: false,
	      isPopperDone: false,
	      isPopperReady: false,
	      search: '',
	      isKeyboardShortcutsActivated: false,
	      keyboardSelected: null,
	      isMouseMoved: false,
	      isSelectLoading: false
	    };
	  },
	
	  computed: {
	    isSchoolCalendarsLoading: function isSchoolCalendarsLoading() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    calendarName: function calendarName() {
	      return this.calendar ? this.calendar.name : '';
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    roomCalendars: function roomCalendars() {
	      return this.$store.getters.roomCalendars;
	    },
	    mergeCalendars: function mergeCalendars() {
	      return this.$store.getters.mergeCalendars;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    clubCalendars: function clubCalendars() {
	      return this.$store.getters.clubCalendars;
	    },
	    studentCalendars: function studentCalendars() {
	      return this.$store.getters.studentCalendars;
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.$store.getters.kindergartenCalendars;
	    },
	    sortedCalendars: function sortedCalendars() {
	      if (this.calendar) {
	        switch (this.calendar.type) {
	          case 'klass':
	            return this.klassCalendars;
	          case 'user':
	            return this.userCalendars;
	          case 'room':
	            return this.roomCalendars;
	          case 'merge':
	            return this.mergeCalendars;
	          case 'other':
	            return this.otherCalendars;
	          case 'club':
	            return this.clubCalendars;
	          case 'student':
	            return this.studentCalendars;
	          case 'kindergarten':
	            return this.kindergartenCalendars;
	          default:
	            return [];
	        }
	      } else {
	        return [];
	      }
	    },
	    sortedCalendarsWithVProps: function sortedCalendarsWithVProps() {
	      var _this = this;
	
	      return this.sortedCalendars.map(function (calendar) {
	        return (0, _extends3.default)({}, calendar, {
	          v_selected: _this.selectedCalendarId === calendar.id
	        });
	      });
	    },
	    calendarQuery: function calendarQuery() {
	      var _this2 = this;
	
	      return this.sortedCalendarsWithVProps.filter(function (item) {
	        return item.name !== null ? item.name.match(new RegExp(_this2.search, 'i')) : '';
	      });
	    }
	  },
	  watch: {
	    calendarQuery: function calendarQuery() {
	      this.keyboardSelected = this.calendarQuery[0] ? this.calendarQuery[0] : null;
	    }
	  },
	  methods: {
	    onMouseMove: function onMouseMove() {
	      this.isMouseMoved = true;
	    },
	    setTheKeyboardSelected: function setTheKeyboardSelected(calendar) {
	      if (!this.isMouseMoved) {
	        return;
	      }
	      this.keyboardSelected = calendar;
	    },
	    getIsTheKeyboardSelected: function getIsTheKeyboardSelected(calendar) {
	      if (!this.keyboardSelected) {
	        return false;
	      } else {
	        return this.keyboardSelected.id === calendar.id;
	      }
	    },
	    nativeSelect: function nativeSelect() {
	      window.location = '/calendars/' + this.selectedCalendarId;
	    },
	    selectCalendar: function selectCalendar(calendarId) {
	      this.isSelectLoading = true;
	      this.selectedCalendarId = calendarId;
	      window.location = '/calendars/' + calendarId;
	      this.setDropdown();
	    },
	    createPopper: function createPopper() {
	      var _this3 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this3.isPopperReady = true;
	        _this3.isPopperDone = true;
	      }, 0);
	      setTimeout(function (_) {
	        _this3.$refs.inputsearch.focus();
	      }, 200);
	    },
	    setDropdown: function setDropdown() {
	      var _this4 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        setTimeout(function (_) {
	          _this4.createPopper();
	          _this4.addKeyboardEvents();
	          _this4.keyboardSelected = _this4.calendarQuery.length > 0 ? _this4.calendarQuery[0] : null;
	        }, 0);
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	        this.search = '';
	        this.destroyKeyboardEvents();
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    },
	    handleKeyboardNavigation: function handleKeyboardNavigation(event) {
	      var _this5 = this;
	
	      var key = event.key;
	
	      if (this.isDropDown) {
	        if (key === 'Escape') {
	          this.setDropdownFromClick();
	          return;
	        }
	        if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter') {
	          if (this.calendarQuery.length === 0) {
	            return;
	          }
	          var idx = this.keyboardSelected ? this.calendarQuery.findIndex(function (cal) {
	            return cal.id === _this5.keyboardSelected.id;
	          }) : 0;
	          if (key === 'Enter') {
	            if (!this.keyboardSelected) {
	              return;
	            }
	            this.selectCalendar(this.keyboardSelected.id);
	          }
	          if (key === 'ArrowDown') {
	            if (this.calendarQuery.length === idx + 1) {
	              return;
	            }
	            this.keyboardSelected = this.calendarQuery[idx + 1];
	            this.scrollToKeyboardSelected();
	          }
	          if (key === 'ArrowUp') {
	            if (idx === 0) {
	              return;
	            }
	            this.keyboardSelected = this.calendarQuery[idx - 1];
	            this.scrollToKeyboardSelected();
	          }
	        }
	      }
	    },
	    scrollToKeyboardSelected: function scrollToKeyboardSelected() {
	      var _this6 = this;
	
	      setTimeout(function () {
	        var searchFieldHeight = _this6.$refs.ref_d_select_input_container.getBoundingClientRect().height;
	
	        var highlightedCalendar = document.querySelector('.d-list-item.d-list-item--highlighted');
	        var highlightedOffsetTop = highlightedCalendar.offsetTop;
	        var highlightedHeight = highlightedCalendar.getBoundingClientRect().height;
	        var totalHeight = highlightedOffsetTop + highlightedHeight - searchFieldHeight;
	
	        var dropdownScrollTop = _this6.$refs.ref_d_select_calendar_dropdown.scrollTop;
	        var dropdownHeight = _this6.$refs.ref_d_select_calendar_dropdown.getBoundingClientRect().height;
	        var dropdownBottom = dropdownScrollTop + dropdownHeight;
	        if (totalHeight > dropdownBottom) {
	          _this6.isMouseMoved = false;
	          _this6.$refs.ref_d_select_calendar_dropdown.scrollTop = _this6.$refs.ref_d_select_calendar_dropdown.scrollTop + highlightedHeight;
	        }
	
	        if (highlightedOffsetTop - searchFieldHeight < dropdownScrollTop) {
	          _this6.isMouseMoved = false;
	          _this6.$refs.ref_d_select_calendar_dropdown.scrollTop = _this6.$refs.ref_d_select_calendar_dropdown.scrollTop - highlightedHeight;
	        }
	      }, 0);
	    },
	    addKeyboardEvents: function addKeyboardEvents() {
	      if (!this.isKeyboardShortcutsActivated) {
	        window.addEventListener('keydown', this.handleKeyboardNavigation);
	        this.isKeyboardShortcutsActivated = true;
	      }
	    },
	    destroyKeyboardEvents: function destroyKeyboardEvents() {
	      window.addEventListener('keydown', this.handleKeyboardNavigation);
	      this.isKeyboardShortcutsActivated = false;
	    }
	  },
	  mounted: function mounted() {
	    if (this.calendar) {
	      this.selectedCalendarId = this.calendar.id;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var dChild = this.$refs.d_child;
	    if (dChild) {
	      dChild.remove();
	    }
	    this.destroyKeyboardEvents();
	  }
	};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _CopyEvent = __webpack_require__(310);
	
	var _CopyEvent2 = _interopRequireDefault(_CopyEvent);
	
	var _DeleteEventOnward = __webpack_require__(312);
	
	var _DeleteEventOnward2 = _interopRequireDefault(_DeleteEventOnward);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DSelectCalendars = __webpack_require__(302);
	
	var _DSelectCalendars2 = _interopRequireDefault(_DSelectCalendars);
	
	var _AppEIPWYZIWYG = __webpack_require__(45);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _EventChanges = __webpack_require__(116);
	
	var _EventChanges2 = _interopRequireDefault(_EventChanges);
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _DSelectSubs = __webpack_require__(305);
	
	var _DSelectSubs2 = _interopRequireDefault(_DSelectSubs);
	
	var _DCalendarShowEventSubFor = __webpack_require__(1244);
	
	var _DCalendarShowEventSubFor2 = _interopRequireDefault(_DCalendarShowEventSubFor);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _EventSwapOrReplace = __webpack_require__(1266);
	
	var _EventSwapOrReplace2 = _interopRequireDefault(_EventSwapOrReplace);
	
	var _DCalendarShowEventUsersNotOnSchool = __webpack_require__(1245);
	
	var _DCalendarShowEventUsersNotOnSchool2 = _interopRequireDefault(_DCalendarShowEventUsersNotOnSchool);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _DModalCancelLesson = __webpack_require__(1264);
	
	var _DModalCancelLesson2 = _interopRequireDefault(_DModalCancelLesson);
	
	var _DModalOutOfSchoolLesson = __webpack_require__(311);
	
	var _DModalOutOfSchoolLesson2 = _interopRequireDefault(_DModalOutOfSchoolLesson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    out_of_school: 'Ude af huset',
	    hour: 'time',
	    hours: 'timer',
	    minute: 'minut',
	    minutes: 'minutter',
	    delete_events_onward: 'Slet lektionen fremadrettet',
	    only_one_substitute_per_teacher: 'Det kan kun vælges én vikar per fraværende',
	    go_to_calendar: 'Gå til kalender for denne lektion',
	    copy_event_onward: 'Kopier lektionen',
	    delete_event: 'Slet lektion',
	    settings: 'Indstillinger',
	    activity: 'Historik',
	    learning_goal: 'Læringsmål',
	    meeting_purpose: 'Formål med mødet',
	    content: 'Indhold',
	    agenda: 'Agenda',
	    pupil_preparation: 'Elevforberedelse',
	    decisions_and_resume: 'Beslutninger og resumé',
	    teacher_notes: 'Vikarnoter / Interne noter',
	    internal_notes: 'Noter',
	    unsaved_changes_will_be_lost: 'Du har lavet ændringer, der er ikke er gemt. Vil du gemme ændringer før du lukker?',
	    add_grade: 'Tilføj klasse',
	    swap_lesson: 'Byt lektion',
	    replace_lesson: 'Erstat lektion',
	    only_delete_this: 'Slet kun i denne kalender',
	    this_lesson_counts_as: 'Denne lektion tæller som',
	    you_are_about_to_delete_substitutes: 'Du er ved at slette en lektion med vikar på. Vikaren vil få fjernet sin lektion. Er det meningen?',
	    edit_date: 'Rediger dato',
	    cancel_event: 'Aflys timen',
	    uncancel_event: 'Fortryd aflysning',
	    canceled: 'Aflyst'
	  },
	  en: {
	    out_of_school: 'Out of school',
	    canceled: 'Canceled',
	    cancel_event: 'Cancel lesson',
	    uncancel_event: 'Undo cancellation',
	    hour: 'hour',
	    hours: 'hours',
	    minute: 'minute',
	    minutes: 'minutes',
	    delete_events_onward: 'Delete this and on same timeslot forward',
	    only_one_substitute_per_teacher: 'Only one substitute can be chosen per teacher',
	    go_to_calendar: 'Go to calendar for the lesson',
	    copy_event_onward: 'Copy lesson onward',
	    delete_event: 'Delete lesson',
	    settings: 'Settings',
	    activity: 'History',
	    learning_goal: 'Learning goal',
	    meeting_purpose: 'Purpose of the meeting',
	    content: 'Content',
	    agenda: 'Agenda',
	    pupil_preparation: 'Homework',
	    decisions_and_resume: 'Decisions and summary',
	    internal_notes: 'Notes',
	    teacher_notes: 'Teachers notes',
	    unsaved_changes_will_be_lost: 'Your unsaved changes will be lost. Save changes before close?',
	    add_grade: 'Add grade/group',
	    swap_lesson: 'Swap Lesson',
	    replace_lesson: 'Replace Lesson',
	    only_delete_this: 'Only delete in this calendar',
	    this_lesson_counts_as: 'This lesson counts as',
	    you_are_about_to_delete_substitutes: 'Du er i ferd med å slette en leksjon med vikar. Vikaren vil få fjernet leksjonen sin. Er det meningen?',
	    edit_date: 'Edit date'
	  },
	  nb: {
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst',
	    cancel_event: 'Avlys timen',
	    uncancel_event: 'Angre avlysning',
	    hour: 'time',
	    hours: 'timer',
	    minute: 'minutt',
	    minutes: 'minutter',
	    delete_events_onward: 'Slett denne timen fra nå og fremover',
	    only_one_substitute_per_teacher: 'Det kan kun velges én vikar per lærer',
	    go_to_calendar: 'Gå til denne timens kalender',
	    copy_event_onward: 'Kopier faget',
	    delete_event: 'Slett time',
	    settings: 'Innstillinger',
	    activity: 'Logg',
	    learning_goal: 'Læringsmål',
	    meeting_purpose: 'Formål med møtet',
	    content: 'Innhold',
	    agenda: 'Agenda',
	    pupil_preparation: 'Elevforberedelse',
	    decisions_and_resume: 'Beslutninger og sammendrag',
	    teacher_notes: 'Vikarnotater',
	    internal_notes: 'Notater',
	    unsaved_changes_will_be_lost: 'Du har gjort endringer uten å lagre. Vil du lagre før du lukker?',
	    add_grade: 'Legg til klasse',
	    swap_lesson: 'Bytt time',
	    replace_lesson: 'Erstatt time',
	    only_delete_this: 'Slett kun i denne kalender',
	    this_lesson_counts_as: 'Denne leksjonen teller som',
	    you_are_about_to_delete_substitutes: 'You are about to delete a lesson with a substitute. The substitute will have their lesson removed. Is this the intention?',
	    edit_date: 'Rediger dato'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    DModalOutOfSchoolLesson: _DModalOutOfSchoolLesson2.default,
	    DModalCancelLesson: _DModalCancelLesson2.default,
	    DateSelector: _DateSelector2.default,
	    DCalendarShowEventUsersNotOnSchool: _DCalendarShowEventUsersNotOnSchool2.default,
	    DCalendarsShowEventSubFor: _DCalendarShowEventSubFor2.default,
	    DSelectSubs: _DSelectSubs2.default,
	    ModalConfirmation: _ModalConfirmation2.default,
	    DModal: _DModal2.default,
	    DDropdown: _DDropdown2.default,
	    Loader: _Loader2.default,
	    CopyEvent: _CopyEvent2.default,
	    DSelectCalendars: _DSelectCalendars2.default,
	    weip: _AppEIPWYZIWYG2.default,
	    EventChanges: _EventChanges2.default,
	    TimeChanger: _TimeChanger2.default,
	    DeleteEventOnward: _DeleteEventOnward2.default,
	    EventSwapOrReplace: _EventSwapOrReplace2.default
	  },
	  props: {
	    event: {
	      type: Object,
	      default: function _default() {}
	    },
	    initCalendarId: {},
	    calendar: {
	      type: Object,
	      default: null
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    },
	    showSettings: {
	      type: Boolean,
	      default: true
	    },
	    canEditEvent: {
	      type: Boolean,
	      default: true
	    },
	    canEditNotes: {
	      type: Boolean,
	      default: true
	    },
	    isInitEventLoading: {
	      type: Boolean,
	      default: false
	    },
	    isDCalendarInROR: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isEventLoading: false,
	      eventSchoolCalendars: [],
	      isLoadingEventSchoolCalendars: false,
	      eventSchoolUsers: [],
	      isLoadingEventSchoolUsers: false,
	      eventSchoolYears: [],
	      isLoadingEventSchoolYears: false,
	      calendars: [],
	      ownerCalendarId: null,
	      userCalendarIds: [],
	      roomCalendarIds: [],
	      klassCalendarIds: [],
	      studentCalendarIds: [],
	      otherCalendarsIds: [],
	      kindergartenCalendarsIds: [],
	      clubCalendarsIds: [],
	      substituteCalendarIds: [],
	      originalSubstituteCalendarIds: [],
	      substitutionsToSubmit: [],
	      isSubsInputFieldActive: false,
	      theActiveTab: 0,
	      isEditTime: false,
	      isChangesMade: false,
	      updatedStartTime: null,
	      updatedEndTime: null,
	      isConfirmDelete: false,
	      isDeleteOnWard: false,
	      theSubstitutesUserId: null,
	      theSubstituteForUserId: null,
	      noteChanges: {},
	      subToSelectWhoToSubFor: null,
	      isClosingWithoutSaving: false,
	      isUpdating: false,
	      keyboardShortcutAdded: false,
	      isShowKlass: false,
	      isOnlyOwnCalendarTextWarning: false,
	      headerHeight: 192,
	      theRemoveCalendarModal: false,
	      isShowKlassAnimate: false,
	      theChangesMade: {},
	      startDate: (0, _moment2.default)(),
	      isEditDate: false,
	      isCancelLesson: false,
	      isOutOfSchoolLesson: false
	    };
	  },
	
	  computed: {
	    isCanceled: function isCanceled() {
	      return this.event.canceled;
	    },
	    isAway: function isAway() {
	      return this.event.away;
	    },
	    isCanEditEvent: function isCanEditEvent() {
	      var eventTypeIsAbsence = this.event.event_type === 'absence';
	      if (!eventTypeIsAbsence) {
	        return this.canEditEvent;
	      } else {
	        var schoolIdsWithoutDeleteFnc = [29045, 40195];
	        return schoolIdsWithoutDeleteFnc.indexOf(this.schoolId) < 0 ? true : this.userHasPermission('can_manage_users');
	      }
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    activeSchoolName: function activeSchoolName() {
	      return this.activeSchool ? this.activeSchool.name : '';
	    },
	    dShowEventBodyMaxHeight: function dShowEventBodyMaxHeight() {
	      return this.isChangesMade ? this.headerHeight * 1 + 41 : this.headerHeight;
	    },
	    calendarId: function calendarId() {
	      return this.initCalendarId * 1;
	    },
	    isPossibleToDelete: function isPossibleToDelete() {
	      var eventTypeIsAbsence = this.event.event_type === 'absence';
	      var schoolIdsWithoutDeleteFnc = [29045, 40195];
	      var isActivatedForUsers = schoolIdsWithoutDeleteFnc.indexOf(this.schoolId) < 0 ? true : this.userHasPermission('can_manage_users');
	      var isOwnerOtherCalendar = this.ownerCalendarType === 'other' ? this.event.calendar_id === this.calendarId : true;
	
	      return (!eventTypeIsAbsence || eventTypeIsAbsence && isActivatedForUsers) && isOwnerOtherCalendar;
	    },
	    eventTypeTranslated: function eventTypeTranslated() {
	      return this.$t('vue2.eventTypes.' + this.event.event_type);
	    },
	    eventDurationForCalendar: function eventDurationForCalendar() {
	      var _this = this;
	
	      var calendar = this.event.calendars.find(function (cal) {
	        return cal.calendar_id === _this.calendarId;
	      });
	      if (!calendar) {
	        return '';
	      }
	      var minutes = calendar.minutes;
	
	      if (minutes >= 60) {
	        var hours = Math.floor(minutes / 60);
	        var remainingMinutes = minutes % 60;
	        var hourLabel = hours === 1 ? this.i18n[this.locale]['hour'] : this.i18n[this.locale]['hours'];
	        var _minuteLabel = remainingMinutes === 1 ? this.i18n[this.locale]['minute'] : this.i18n[this.locale]['minutes'];
	        return hours + ' ' + hourLabel + ' ' + remainingMinutes + ' ' + _minuteLabel;
	      }
	
	      var minuteLabel = minutes === 1 ? this.i18n[this.locale]['minute'] : this.i18n[this.locale]['minutes'];
	      return minutes + ' ' + minuteLabel;
	    },
	    eventMainCalendarType: function eventMainCalendarType() {
	      var mainCalendar = this.allCalendarsInHash[this.event.calendar_id];
	      if (mainCalendar) {
	        return mainCalendar.type;
	      } else {
	        return null;
	      }
	    },
	    isShowLearningGoal: function isShowLearningGoal() {
	      return !this.isShowOnlyNotes && !this.isKindergarten;
	    },
	    isShowNotesForStudent: function isShowNotesForStudent() {
	      return !this.isShowOnlyNotes && !this.isKindergarten;
	    },
	    isShowTeacherNotes: function isShowTeacherNotes() {
	      return !this.isKindergarten;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    isShowReplaceAndSwap: function isShowReplaceAndSwap() {
	      return this.isCanEditEvent && this.event.event_type !== 'absence' && !this.isKindergarten;
	    },
	    activeEventTypeToSelect: function activeEventTypeToSelect() {
	      var calType = 'klass';
	
	      var eventType = this.event && this.event.event_type ? this.event.event_type : 'v_unknown';
	
	      var schoolIdsWhereAvailableInShowEvent = [60598];
	
	      var calendarType = this.calendar && this.calendar.type ? this.calendar.type : '';
	      if (calendarType === 'klass' && eventType === 'additional_tasks') {
	        return 'klass';
	      }
	      var otherArr = ['other_tasks', 'other_stuff', 'available', 'additional_tasks', 'preparation'];
	      var kindergartenArr = ['with_kids', 'without_kids'];
	
	      if (this.event && this.event.school_id && schoolIdsWhereAvailableInShowEvent.includes(this.event.school_id) && eventType === 'available') {
	        return 'klass';
	      }
	      if (otherArr.includes(eventType)) {
	        return 'other';
	      }
	
	      if (eventType === 'club') {
	        return 'club';
	      }
	
	      if (kindergartenArr.includes(eventType)) {
	        return 'kindergarten';
	      }
	
	      return calType;
	    },
	    isStudentsActivated: function isStudentsActivated() {
	      var schoolFeatures = window.SCHOOL && window.SCHOOL.features ? window.SCHOOL.features : [];
	      return schoolFeatures.indexOf('calendar_student') > -1;
	    },
	    isLoadingEventSchoolCalendarsOrUsers: function isLoadingEventSchoolCalendarsOrUsers() {
	      return this.isLoadingEventSchoolCalendars || this.isLoadingEventSchoolUsers || this.isLoadingEventSchoolYears;
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    },
	    escTooltip: function escTooltip() {
	      return '<p class="tooltip-shortcut">' + this.$t('vue2.common.close') + '<span>Esc</span></p>';
	    },
	    ownerCalendarType: function ownerCalendarType() {
	      if (this.allCalendarsInHash && this.allCalendarsInHash[this.event.calendar_id]) {
	        return this.allCalendarsInHash[this.event.calendar_id].type;
	      }
	
	      return null;
	    },
	    isShowOnlyNotes: function isShowOnlyNotes() {
	      var eventTypes = ['reservation'];
	      return this.event ? eventTypes.indexOf(this.event.event_type) > -1 : false;
	    },
	    isCalendarOfTypeOther: function isCalendarOfTypeOther() {
	      var eventTypes = ['other_tasks', 'reservation', 'available', 'additional_tasks', 'preparation', 'pool'];
	      return this.event ? eventTypes.indexOf(this.event.event_type) > -1 : false;
	    },
	    possibleTeachersToSub: function possibleTeachersToSub() {
	      var _this2 = this;
	
	      var possibleTeachersToSub = [];
	      var teachersWithSub = this.calendars.filter(function (cal) {
	        return cal.substitute;
	      }).map(function (calendar) {
	        return calendar.substitute;
	      });
	      var users = this.userCalendarIds;
	      if (this.ownerCalendarType === 'user' && this.ownerCalendarId) {
	        users.push(this.ownerCalendarId);
	      }
	      users.forEach(function (userCalId) {
	        var user = _this2.allUsersInCalendarHash[userCalId];
	        if (!user) {
	          console.log('teachersWithSub::user_not_found', userCalId, _this2.allUsersInCalendarHash);
	        } else {
	          if (teachersWithSub.indexOf(user.id) < 0) {
	            possibleTeachersToSub.push(user);
	          }
	        }
	      });
	      return possibleTeachersToSub;
	    },
	    i18n: function i18n() {
	      if (this.isKindergarten) {
	        I18N['da']['go_to_calendar'] = 'Gå til kalender for denne aktivitet';
	        I18N['da']['delete_events_onward'] = 'Slet aktiviteten fremadrettet';
	        I18N['da']['copy_event_onward'] = 'Kopier aktiviteten';
	        I18N['da']['delete_event'] = 'Slet aktivitet';
	      }
	      return I18N;
	    },
	    copyEventEvent: function copyEventEvent() {
	      return _eventbus2.default.copyEventEvent;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      var cals = this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.calendars : this.eventSchoolCalendars;
	      return cals.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    allUsersInHash: function allUsersInHash() {
	      var users = this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.allUsers : this.eventSchoolUsers;
	      return users.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    allUsersInCalendarHash: function allUsersInCalendarHash() {
	      var users = this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.allUsers : this.eventSchoolUsers;
	      return users.reduce(function (obj, item) {
	        obj[item.user_calendar_id] = item;
	        return obj;
	      }, {});
	    },
	    isEventSchoolIdTheSameAsActiveSchoolId: function isEventSchoolIdTheSameAsActiveSchoolId() {
	      return this.event && this.event.school_id === this.schoolId;
	    },
	    getCalendarName: function getCalendarName() {
	      return this.allCalendarsInHash[this.event.calendar_id] ? this.allCalendarsInHash[this.event.calendar_id].name : '';
	    },
	    calendarIds: function calendarIds() {
	      return this.klassCalendarIds.concat(this.roomCalendarIds, this.userCalendarIds, this.substituteCalendarIds, this.studentCalendarIds, this.otherCalendarsIds, this.kindergartenCalendarsIds, this.clubCalendarsIds, [this.ownerCalendarId]);
	    },
	    dayAndDate: function dayAndDate() {
	      if (this.locale === 'nn' || this.locale === 'nb') {
	        return (0, _moment2.default)(this.event.start).format('dddd DD. MMMM YYYY');
	      }
	      try {
	        return (0, _moment2.default)(this.event.start)._d.toLocaleDateString(this.locale, {
	          weekday: 'long',
	          month: 'long',
	          day: '2-digit',
	          year: 'numeric'
	        });
	      } catch (e) {
	        return (0, _moment2.default)(this.event.start).format('LL');
	      }
	    },
	    usersWithSubstitute: function usersWithSubstitute() {
	      var _this3 = this;
	
	      var usersWithSub = [];
	      this.calendars.forEach(function (calendar) {
	        var theCalendar = _this3.allCalendarsInHash[calendar.calendar_id];
	        if (calendar.substitute && theCalendar && theCalendar.type === 'user') {
	          var userWithSub = _this3.allUsersInHash[calendar.substitute];
	          if (userWithSub) {
	            usersWithSub.push(userWithSub.user_calendar_id);
	          }
	        }
	      });
	      return usersWithSub;
	    },
	    formattedEventStart: function formattedEventStart() {
	      return (0, _moment2.default)(this.event.start).format('LT');
	    },
	    formattedEventEnd: function formattedEventEnd() {
	      return (0, _moment2.default)(this.event.end).format('LT');
	    },
	    eventDuration: function eventDuration() {
	      var end = this.event.end;
	      var start = this.event.start;
	      return _moment2.default.duration((0, _moment2.default)(end).diff((0, _moment2.default)(start))).asMinutes();
	    },
	    eventMinutes: function eventMinutes() {
	      var hours = Math.floor(this.eventDuration / 60);
	      var minutes = this.eventDuration - hours * 60;
	      return minutes;
	    },
	    eventHours: function eventHours() {
	      return Math.floor(this.eventDuration / 60);
	    },
	    formattedDuration: function formattedDuration() {
	      var hours = this.eventHours < 1 ? '' : this.eventHours + ' ' + (this.eventHours === 1 ? this.i18n[this.locale]['hour'] : this.i18n[this.locale]['hours']);
	      var minutes = this.eventMinutes >= 1 ? this.eventMinutes + ' min' : '';
	      return hours + ' ' + minutes;
	    },
	    eventUsers: function eventUsers() {
	      var _this4 = this;
	
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.calendar_type === 'user' && !calEvent.substitute;
	      }).map(function (user) {
	        return (0, _extends3.default)({}, user, {
	          v_sub: _this4.findSubstitute(user)
	        });
	      });
	    },
	    eventSubstitutes: function eventSubstitutes() {
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.substitute;
	      });
	    },
	    eventRooms: function eventRooms() {
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.calendar_type === 'room';
	      });
	    },
	    eventKlasses: function eventKlasses() {
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.calendar_type === 'klass';
	      });
	    },
	    eventStudents: function eventStudents() {
	      return this.calendars.filter(function (calEvent) {
	        return calEvent.calendar_type === 'student';
	      });
	    },
	    isEveryThingReady: function isEveryThingReady() {
	      return !this.isInitEventLoading && this.locale && !this.isLoadingEventSchoolCalendarsOrUsers;
	    },
	    calsNotOnSchool: function calsNotOnSchool() {
	      var _this5 = this;
	
	      return this.calendars.filter(function (cal) {
	        return !_this5.allCalendarsInHash[cal.calendar_id];
	      });
	    },
	    usersNotOnSchool: function usersNotOnSchool() {
	      return this.calsNotOnSchool.filter(function (cal) {
	        return cal.calendar_type === 'user';
	      });
	    }
	  },
	  watch: {
	    event: function event(val) {
	      this.setTheActiveTab(0);
	      this.checkIfEventSchoolIdIsActiveSchoolId();
	    },
	    isEveryThingReady: function isEveryThingReady(val) {
	      var _this6 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          if (_this6.$refs.d_show_event_header) {
	            _this6.headerHeight = _this6.$refs.d_show_event_header.getBoundingClientRect().height;
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    setIsOutOfSchoolLesson: function setIsOutOfSchoolLesson(bool) {
	      this.isOutOfSchoolLesson = bool;
	    },
	    onEventUpdated: function onEventUpdated() {
	      this.setIsCancelLesson(false);
	      this.setIsOutOfSchoolLesson(false);
	      this.$emit('updated');
	      this.close();
	    },
	    setIsCancelLesson: function setIsCancelLesson(bool) {
	      this.isCancelLesson = bool;
	    },
	    findSubstitute: function findSubstitute(calEvent) {
	      var _this7 = this;
	
	      var user = this.allUsersInCalendarHash[calEvent.calendar_id];
	      if (!user) {
	        return null;
	      }
	      var userId = user.id;
	      var calEventSubsForUser = this.calendars.filter(function (calendar) {
	        return calendar.substitute === userId;
	      });
	      var names = calEventSubsForUser.filter(function (calEvent) {
	        return _this7.allUsersInCalendarHash[calEvent.calendar_id];
	      }).map(function (user) {
	        return user.name;
	      });
	      return names.join(', ');
	    },
	    setStartDate: function setStartDate(date) {
	      this.startDate = date;
	      this.setChangesMade('date');
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setIsShowKlass: function setIsShowKlass(bool) {
	      this.isShowKlassAnimate = true;
	      this.isShowKlass = bool;
	    },
	    onKlassDSelectTransitionDone: function onKlassDSelectTransitionDone() {
	      if (!this.isShowKlassAnimate) {
	        return;
	      }
	      var el = document.querySelector('.input-group__grades .d-select__input-look');
	      el.click();
	    },
	    deleteCalendarFromCalendars: function deleteCalendarFromCalendars(calendar) {
	      var calId = calendar.id;
	      var idx = this.calendars.findIndex(function (cal) {
	        return cal.calendar_id === calId;
	      });
	      this.calendars.splice(idx, 1);
	      var userIdx = this.userCalendarIds.indexOf(calId);
	      if (userIdx > -1) {
	        this.userCalendarIds.splice(userIdx, 1);
	      }
	      var subIdx = this.substituteCalendarIds.indexOf(calId);
	      if (subIdx > -1) {
	        this.substituteCalendarIds.splice(subIdx, 1);
	      }
	      this.setChangesMade('calendars');
	    },
	    setIsConfirmDeleteMerge: function setIsConfirmDeleteMerge() {
	      this.isOnlyOwnCalendarTextWarning = true;
	      this.isConfirmDelete = true;
	    },
	    getCalendarNames: function getCalendarNames(calIds) {
	      var _this8 = this;
	
	      var names = calIds.map(function (calId) {
	        var idx = _this8.calendars.findIndex(function (cal) {
	          return cal.calendar_id === calId;
	        });
	        if (idx > -1) {
	          return _this8.calendars[idx].name;
	        }
	      });
	
	      return names.join(', ').toString();
	    },
	    closeClick: function closeClick(evt) {
	      function isTargetFullCalendarEvent(evt) {
	        var target = evt.target;
	        while (target != null) {
	          if (target.classList.contains('fc-event')) {
	            return true;
	          }
	          if (target.classList.contains('js-no-close')) {
	            return true;
	          }
	          target = target.parentElement;
	        }
	        return false;
	      }
	
	      if (isTargetFullCalendarEvent(evt)) {
	        return;
	      }
	      if (this.copyEventEvent || this.isDeleteOnWard) {
	        return;
	      }
	      if (this.isChangesMade) {
	        this.isClosingWithoutSaving = true;
	        return;
	      }
	      this.close();
	    },
	    setTeacherToSub: function setTeacherToSub(teacher) {
	      var obj = {
	        calendar_id: this.subToSelectWhoToSubFor.calendarId,
	        substitute: teacher.id,
	        substitute_for_cal_id: teacher.user_calendar_id
	      };
	      this.calendars.push(obj);
	      this.substitutionsToSubmit.push(obj);
	      this.subToSelectWhoToSubFor = null;
	    },
	    cancelSubToSelectWhoToSubFor: function cancelSubToSelectWhoToSubFor() {
	      this.subToSelectWhoToSubFor.calendarId;
	      this.subToSelectWhoToSubFor = null;
	    },
	    setNoteChanges: function setNoteChanges(note, noteType) {
	      this.$set(this.noteChanges, noteType, note);
	      this.setChangesMade('notes');
	    },
	    setChangesMade: function setChangesMade(changeType) {
	      this.$set(this.theChangesMade, changeType, true);
	      this.isChangesMade = true;
	    },
	    setIsDeleteOnWard: function setIsDeleteOnWard() {
	      this.$refs.d_show_event.click();
	      this.isDeleteOnWard = true;
	    },
	    openCopyEventDropdown: function openCopyEventDropdown() {
	      _eventbus2.default.copyEventEvent = this.event;
	    },
	    goToCalendarForLesson: function goToCalendarForLesson() {
	      if (this.isInDCalendar && !this.isDCalendarInROR) {
	        this.$store.commit('setActiveCalendarId', this.event.calendar_id);
	        this.close();
	      } else {
	        window.location.href = window.location.href = '/calendars/' + this.event.calendar_id;
	        this.close();
	      }
	    },
	    updateStartTime: function updateStartTime(time) {
	      var newStartTime = (0, _moment2.default)(this.event.start).hours((0, _moment2.default)(time).hours()).minutes((0, _moment2.default)(time).minutes());
	      this.updatedStartTime = newStartTime;
	      this.setChangesMade('time');
	    },
	    updateEndTime: function updateEndTime(time) {
	      var newEndTime = (0, _moment2.default)(this.event.end).hours((0, _moment2.default)(time).hours()).minutes((0, _moment2.default)(time).minutes());
	      this.updatedEndTime = newEndTime;
	      this.setChangesMade('time');
	    },
	    save: function save() {
	      var _this9 = this;
	
	      this.isClosingWithoutSaving = false;
	      var updates = [{
	        event_id: this.event.event_id
	      }];
	      if (this.theChangesMade['calendars']) {
	        var calIds = this.calendarIds.concat(this.calsNotOnSchool.map(function (cal) {
	          return cal.calendar_id;
	        }).filter(function (calendarId) {
	          return !_this9.calendarIds.includes(calendarId);
	        }));
	        updates[0]['calendar_ids'] = calIds;
	      }
	      if (this.theChangesMade['time']) {
	        updates[0]['start_time'] = this.updatedStartTime;
	        updates[0]['end_time'] = this.updatedEndTime;
	      }
	      if (this.theChangesMade['date']) {
	        var newStartDate = (0, _moment2.default)(this.updatedStartTime).year((0, _moment2.default)(this.startDate).year()).month((0, _moment2.default)(this.startDate).month()).date((0, _moment2.default)(this.startDate).date());
	
	        var diffInDays = (0, _moment2.default)(this.updatedEndTime).diff((0, _moment2.default)(this.updatedStartTime), 'days');
	
	        var newEndDate = (0, _moment2.default)(newStartDate).add(diffInDays, 'days');
	
	        newEndDate = newEndDate.hour((0, _moment2.default)(this.updatedEndTime).hour()).minute((0, _moment2.default)(this.updatedEndTime).minute()).second((0, _moment2.default)(this.updatedEndTime).second());
	
	        updates[0]['start_time'] = newStartDate;
	        updates[0]['end_time'] = newEndDate;
	      }
	
	      var noteKeys = (0, _keys2.default)(this.noteChanges);
	      if (noteKeys.length > 0) {
	        var noteChanges = {
	          event_id: this.event.event_id
	        };
	        noteKeys.forEach(function (key) {
	          noteChanges[key] = _this9.noteChanges[key];
	        });
	        updates.push(noteChanges);
	      }
	
	      var subCalIdsToRemove = this.originalSubstituteCalendarIds.filter(function (x) {
	        return !_this9.substituteCalendarIds.includes(x);
	      });
	      if (subCalIdsToRemove.length > 0) {
	        updates['remove_substitute_calendar_id'] = subCalIdsToRemove[0];
	      }
	      subCalIdsToRemove.forEach(function (subCalId) {
	        var removeSub = {
	          event_id: _this9.event.event_id,
	          remove_substitute_calendar_id: subCalId
	        };
	        updates.push(removeSub);
	      });
	      this.substitutionsToSubmit.forEach(function (subObj) {
	        var subUpdate = {
	          event_id: _this9.event.event_id,
	          calendar_id: subObj.substitute_for_cal_id,
	          add_substitute_calendar_id: subObj.calendar_id
	        };
	        updates.push(subUpdate);
	      });
	      var updatedLesson = {
	        school_id: this.event.school_id,
	        updates: updates
	      };
	      if (this.isInDCalendar) {
	        if (this.isCanEditEvent) {
	          this.$store.dispatch('updateCalendarEvent', updatedLesson);
	        } else {
	          var updateEvent = {
	            schoolId: this.event.school_id,
	            eventId: this.event.event_id,
	            updates: this.noteChanges
	          };
	          this.$store.dispatch('updateCalendarEventNotes', updateEvent);
	        }
	        this.close();
	      } else {
	        this.isEventLoading = true;
	        _docendo2.default.updateEvents(updatedLesson.school_id, updatedLesson.updates, function (success) {
	          _this9.$emit('updated');
	          _this9.close();
	        });
	      }
	    },
	    closeIsConfirmDelete: function closeIsConfirmDelete() {
	      this.isOnlyOwnCalendarTextWarning = false;
	      this.isConfirmDelete = false;
	    },
	    deleteEvent: function deleteEvent() {
	      var _this10 = this;
	
	      this.isConfirmDelete = true;
	      if (this.isOnlyOwnCalendarTextWarning) {
	        _docendo2.default.deleteEventCalendar(this.event.event_id, this.calendarId, function (success) {
	          _this10.$emit('updated');
	          _this10.isOnlyOwnCalendarTextWarning = false;
	          _this10.close();
	        });
	      } else {
	        if (this.isInDCalendar) {
	          this.$store.dispatch('deleteEvent', this.event);
	          this.close();
	        } else {
	          this.isEventLoading = true;
	          _docendo2.default.deleteEvent(this.event.school_id, this.event.event_id, function (success) {
	            _this10.$emit('updated');
	            _this10.close();
	          });
	        }
	      }
	    },
	    updateAndClose: function updateAndClose() {
	      this.$emit('updated');
	      this.close();
	    },
	    setIsEditTime: function setIsEditTime() {
	      this.setChangesMade('time');
	    },
	    isTheActiveTab: function isTheActiveTab(tab) {
	      return this.theActiveTab === tab;
	    },
	    setTheActiveTab: function setTheActiveTab(tab) {
	      this.theActiveTab = tab;
	    },
	    submitDeleteEventOnward: function submitDeleteEventOnward() {
	      this.$emit('submitDeleteEventOnward');
	      this.close();
	    },
	    close: function close() {
	      var _this11 = this;
	
	      this.isClosingWithoutSaving = false;
	      this.resetChangesMade();
	      this.$nextTick(function (_) {
	        _this11.$emit('close');
	      });
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.userCalendarIds = users.map(function (user) {
	        return user.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedSubstitutes: function setSelectedSubstitutes(users) {
	      var _this12 = this;
	
	      this.setChangesMade('calendars');
	      var before = this.substituteCalendarIds;
	      var after = users.map(function (user) {
	        return user.id;
	      });
	      var subCalIdsToAdd = after.filter(function (x) {
	        return !before.includes(x);
	      });
	      var subCalIdsToRemove = before.filter(function (x) {
	        return !after.includes(x);
	      });
	      this.substituteCalendarIds = users.map(function (user) {
	        return user.id;
	      });
	      if (subCalIdsToRemove.length > 0) {
	        subCalIdsToRemove.forEach(function (calId) {
	          var idx = _this12.calendars.indexOf(function (cal) {
	            return cal.calendar_id === calId;
	          });
	          _this12.calendars.splice(idx, 1);
	          var idx2 = _this12.substitutionsToSubmit.indexOf(function (cal) {
	            return cal.calendar_id === calId;
	          });
	          _this12.substitutionsToSubmit.splice(idx2, 1);
	        });
	      }
	
	      if (subCalIdsToAdd.length > 0) {
	        if (this.possibleTeachersToSub.length === 1) {
	          subCalIdsToAdd.forEach(function (calId) {
	            var user = _this12.possibleTeachersToSub[0];
	            if (user) {
	              var obj = {
	                calendar_id: calId,
	                substitute: user.id,
	                substitute_for_cal_id: user.user_calendar_id
	              };
	              _this12.calendars.push(obj);
	              _this12.substitutionsToSubmit.push(obj);
	            }
	          });
	        }
	
	        if (this.possibleTeachersToSub.length > 1) {
	          this.subToSelectWhoToSubFor = {
	            calendarId: subCalIdsToAdd[0],
	            name: this.allUsersInCalendarHash[subCalIdsToAdd[0]].name
	          };
	          return;
	        }
	      }
	    },
	    setSelectedRooms: function setSelectedRooms(rooms) {
	      this.roomCalendarIds = rooms.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedKlasses: function setSelectedKlasses(klasses) {
	      this.klassCalendarIds = klasses.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedStudents: function setSelectedStudents(cals) {
	      this.studentCalendarIds = cals.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedOtherCalendar: function setSelectedOtherCalendar(cals) {
	      this.otherCalendarsIds = cals.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedKindergartenCalendar: function setSelectedKindergartenCalendar(cals) {
	      this.kindergartenCalendarsIds = cals.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    setSelectedClubCalendar: function setSelectedClubCalendar(cals) {
	      this.clubCalendarsIds = cals.map(function (cal) {
	        return cal.id;
	      });
	      this.setChangesMade('calendars');
	    },
	    resetChangesMade: function resetChangesMade() {
	      this.theChangesMade = {};
	      this.isChangesMade = false;
	    },
	    reset: function reset() {
	      this.ownerCalendarId = null;
	      this.userCalendarIds = [];
	      this.roomCalendarIds = [];
	      this.klassCalendarIds = [];
	      this.otherCalendarsIds = [];
	      this.kindergartenCalendarsIds = [];
	      this.clubCalendarsIds = [];
	      this.substituteCalendarIds = [];
	      this.originalSubstituteCalendarIds = [];
	      this.studentCalendarIds = [];
	      this.isShowKlass = false;
	      this.isOnlyOwnCalendarTextWarning = false;
	      this.resetChangesMade();
	    },
	    setInitialEventData: function setInitialEventData() {
	      var _this13 = this;
	
	      this.reset();
	      this.updatedStartTime = this.event.start;
	      this.updatedEndTime = this.event.end;
	      this.startDate = this.event.start;
	      this.event.calendars.forEach(function (calendar) {
	        if (calendar.calendar_id === _this13.event.calendar_id) {
	          _this13.ownerCalendarId = calendar.calendar_id;
	        } else {
	          var theCalendar = calendar;
	          if (theCalendar) {
	            switch (theCalendar.calendar_type) {
	              case 'klass':
	                if (_this13.ownerCalendarId !== calendar.calendar_id) {
	                  _this13.isShowKlass = true;
	                }
	                _this13.klassCalendarIds.push(calendar.calendar_id);
	                break;
	              case 'room':
	                _this13.roomCalendarIds.push(calendar.calendar_id);
	                break;
	              case 'other':
	                _this13.otherCalendarsIds.push(calendar.calendar_id);
	                break;
	              case 'club':
	                _this13.clubCalendarsIds.push(calendar.calendar_id);
	                break;
	              case 'kindergarten':
	                _this13.kindergartenCalendarsIds.push(calendar.calendar_id);
	                break;
	              case 'student':
	                _this13.studentCalendarIds.push(calendar.calendar_id);
	                break;
	              case 'user':
	                if (calendar.substitute) {
	                  _this13.substituteCalendarIds.push(calendar.calendar_id);
	                  _this13.originalSubstituteCalendarIds.push(calendar.calendar_id);
	                } else {
	                  _this13.userCalendarIds.push(calendar.calendar_id);
	                }
	                break;
	            }
	          }
	        }
	      });
	
	      this.calendars = JSON.parse((0, _stringify2.default)(this.event.calendars));
	    },
	    setConfirmationMessage: function setConfirmationMessage(e) {
	      var confirmMessage = 'Continue without saving?';
	      if (this.isChangesMade) {
	        (e || window.event).returnValue = confirmMessage;
	        return confirmMessage;
	      }
	    },
	    handleKeyboardShortcut1: function handleKeyboardShortcut1(e) {
	      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
	        e.preventDefault();
	        this.save();
	      }
	    },
	    handleKeyboardShortcut2: function handleKeyboardShortcut2(e) {
	      if (e.key === 'Escape') {
	        e.preventDefault();
	        if (this.isChangesMade) {
	          this.isClosingWithoutSaving = true;
	          return;
	        }
	        this.close();
	      }
	    },
	    checkIfEventSchoolIdIsActiveSchoolId: function checkIfEventSchoolIdIsActiveSchoolId() {
	      var _this14 = this;
	
	      this.eventSchoolCalendars = [];
	      this.eventSchoolUsers = [];
	      var isUsersLoaded = false;
	      var isCalendarsLoaded = false;
	      var isSchoolYearsLoaded = false;
	      if (!this.event) {
	        return;
	      }
	      if (this.event.school_id === this.schoolId) {
	        this.setInitialEventData();
	      } else {
	        this.isLoadingEventSchoolCalendars = true;
	        _docendo2.default.calendarsForSchool(this.event.school_id, function (data) {
	          _this14.eventSchoolCalendars = data;
	          _this14.isLoadingEventSchoolCalendars = false;
	          isCalendarsLoaded = true;
	          if (isUsersLoaded && isSchoolYearsLoaded) {
	            _this14.setInitialEventData();
	          }
	        });
	        this.isLoadingEventSchoolUsers = true;
	        _docendo2.default.schoolUsers2(this.event.school_id, function (data) {
	          _this14.eventSchoolUsers = data;
	          _this14.isLoadingEventSchoolUsers = false;
	          isUsersLoaded = true;
	          if (isCalendarsLoaded && isSchoolYearsLoaded) {
	            _this14.setInitialEventData();
	          }
	        });
	        this.isLoadingEventSchoolYears = true;
	        _docendo2.default.schoolYearsRead(this.event.school_id, '', 'id', function (data) {
	          _this14.eventSchoolYears = data.filter(function (year) {
	            return year.active;
	          });
	          _this14.isLoadingEventSchoolYears = false;
	          isSchoolYearsLoaded = true;
	          if (isCalendarsLoaded && isUsersLoaded) {
	            _this14.setInitialEventData();
	          }
	        });
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.checkIfEventSchoolIdIsActiveSchoolId();
	    window.addEventListener('beforeunload', this.setConfirmationMessage);
	
	    if (!this.keyboardShortcutAdded) {
	      window.addEventListener('keydown', this.handleKeyboardShortcut1);
	      window.addEventListener('keydown', this.handleKeyboardShortcut2);
	      this.keyboardShortcutAdded = true;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('beforeunload', this.setConfirmationMessage);
	
	    window.removeEventListener('keydown', this.handleKeyboardShortcut1);
	    window.removeEventListener('keydown', this.handleKeyboardShortcut2);
	    this.keyboardShortcutAdded = false;
	  }
	};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    which_teacher_will: 'Hvilken person skal',
	    be_substitute_for: 'være vikar for'
	  },
	  en: {
	    which_teacher_will: 'Which teacher will',
	    be_substitute_for: 'be a substitute for'
	  },
	  nb: {
	    which_teacher_will: 'Hvilken lærer bør',
	    be_substitute_for: 'være vikar for'
	  }
	};
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    substitute: {},
	    teachers: {
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N;
	    }
	  }
	};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _CalendarViewDayRemoveOrReplace = __webpack_require__(296);
	
	var _CalendarViewDayRemoveOrReplace2 = _interopRequireDefault(_CalendarViewDayRemoveOrReplace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    following_persons_are_on_the_lesson_but_not_on_school: 'Følgende personer er på lektionen, men er ikke tilknyttet ',
	    sub: 'Vikar',
	    remove: 'Fjern',
	    from_this_lesson: 'fra denne lektion',
	    remove_or_replace: 'Eller vil du gerne fjerne eller erstatte',
	    on: 'på',
	    onwards: 'fremadrettet'
	  },
	  nb: {
	    following_persons_are_on_the_lesson_but_not_on_school: 'Følgende personer er lagt til timen, men er ikke tilknyttet ',
	    sub: 'Vikar',
	    remove: 'Fjern',
	    from_this_lesson: 'fra denne timen',
	    remove_or_replace: 'Eller vil du fjerne eller erstatte',
	    on: 'på',
	    onwards: 'fremover'
	  },
	  en: {
	    following_persons_are_on_the_lesson_but_not_on_school: 'The following staff are in the lesson but are not staff on ',
	    sub: 'Sub',
	    remove: 'Remove',
	    from_this_lesson: 'from this lesson',
	    remove_or_replace: 'Or would you like to remove or replace',
	    on: 'on',
	    onwards: 'onwards'
	  }
	};
	
	exports.default = {
	  components: { DModal: _DModal2.default, CalendarViewDayRemoveOrReplace: _CalendarViewDayRemoveOrReplace2.default },
	  props: {
	    usersNotOnSchool: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    activeSchoolName: {
	      default: ''
	    },
	    event: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      theRemoveCalendar: null
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    userCalendars: function userCalendars() {
	      var _this = this;
	
	      if (this.theRemoveCalendar === null) {
	        return this.$store.getters.userCalendars;
	      } else {
	        return this.$store.getters.userCalendars.filter(function (calendar) {
	          return calendar.id !== _this.theRemoveCalendar.id;
	        });
	      }
	    }
	  },
	  methods: {
	    removeCalendar: function removeCalendar(calendar) {
	      this.$emit('removeCalendar', calendar);
	      this.setTheRemoveCalendar(null);
	    },
	    updateAndClose: function updateAndClose() {
	      this.setTheRemoveCalendar(null);
	      this.$emit('updateAndClose');
	    },
	    setTheRemoveCalendar: function setTheRemoveCalendar(calendar) {
	      if (calendar === null) {
	        this.theRemoveCalendar = null;
	        return;
	      }
	      var calObj = {
	        name: calendar.name,
	        id: calendar.calendar_id
	      };
	      this.theRemoveCalendar = calObj;
	    }
	  }
	};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CreateSubject = __webpack_require__(329);
	
	var _CreateSubject2 = _interopRequireDefault(_CreateSubject);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ImportSubjectsToKlass = __webpack_require__(330);
	
	var _ImportSubjectsToKlass2 = _interopRequireDefault(_ImportSubjectsToKlass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUBJETS_ALL_TYPES = {
	  subject: {
	    da: {
	      name: 'Fag',
	      order: 1
	    },
	    en: {
	      name: 'Subject',
	      order: 1
	    },
	    nb: {
	      name: 'Fag',
	      order: 1
	    }
	  },
	  optional: {
	    da: {
	      name: 'Valgfag/Hold',
	      order: 2
	    },
	    en: {
	      name: 'Optional grades/groups',
	      order: 2
	    },
	    nb: {
	      name: 'Valgfag/gruppe',
	      order: 2
	    }
	  },
	  supplemental: {
	    da: {
	      name: 'UUV',
	      order: 6
	    },
	    en: {
	      name: 'UUV',
	      order: 6
	    },
	    nb: {
	      name: 'UUV',
	      order: 6
	    }
	  },
	  frame: {
	    da: {
	      name: 'Temavisning (Ramme)',
	      order: 3
	    },
	    en: {
	      name: 'Theme',
	      order: 3
	    },
	    nb: {
	      name: 'Temavisning (Ramme)',
	      order: 3
	    }
	  },
	  break: {
	    da: {
	      name: 'Pause',
	      order: 7
	    },
	    en: { name: 'Break', order: 7 },
	    nb: {
	      name: 'Pause',
	      order: 7
	    }
	  },
	  resource: {
	    da: {
	      name: 'Ressource (skjult)',
	      order: 4
	    },
	    en: {
	      name: 'Resource (hidden)',
	      order: 4
	    },
	    nb: {
	      name: 'Ressurs (skjult)',
	      order: 4
	    }
	  },
	  person_resource: {
	    da: {
	      name: 'Ressource (skjult)',
	      order: 4
	    },
	    en: {
	      name: 'Resource (hidden)',
	      order: 4
	    },
	    nb: {
	      name: 'Ressurs (skjult)',
	      order: 4
	    }
	  },
	  other_tasks: {
	    da: {
	      name: 'Anden tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
	      order: 13
	    },
	    en: { name: 'Other tasks', order: 13 },
	    nb: { name: 'Annen tid', order: 13 }
	  },
	  other_stuff: {
	    da: {
	      name: 'Øvrig tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
	      order: 12
	    },
	    en: {
	      name: 'Additional tasks',
	      order: 12
	    },
	    nb: {
	      name: 'Øvrig tid',
	      order: 12
	    }
	  },
	  available: {
	    da: {
	      name: 'Rådighedstime',
	      order: 11
	    },
	    en: {
	      name: 'On-Call',
	      order: 11
	    }
	  },
	  person_resource_visible: {
	    da: {
	      name: 'Ressource (synlig)',
	      order: 5
	    },
	    en: {
	      name: 'Resource (Visible)',
	      order: 5
	    },
	    nb: {
	      name: 'Ressurs (Vises for elever)',
	      order: 5
	    }
	  },
	  club: {
	    da: {
	      name: 'SFO tid',
	      order: 8
	    },
	    en: { name: 'SFO time', order: 8 },
	    nb: { name: 'SFO tid', order: 8 }
	  },
	  additional_tasks: {
	    da: {
	      name: 'Øvrige opgaver',
	      order: 9
	    },
	    en: { name: 'Not teaching', order: 9 },
	    nb: { name: 'Øvrige oppgaver', order: 9 }
	  },
	  pool: {
	    da: {
	      name: 'Lokalpulje',
	      order: 9
	    }
	  },
	  preparation: {
	    da: {
	      name: 'Forberedelse',
	      order: 10
	    },
	    en: {
	      name: 'Preparation',
	      order: 10
	    },
	    nb: {
	      name: 'Forberedelse',
	      order: 10
	    }
	  },
	  reservation: {
	    da: {
	      name: 'Reservation',
	      order: 11
	    },
	    en: {
	      name: 'Reservation',
	      order: 11
	    },
	    nb: {
	      name: 'Reservasjon',
	      order: 11
	    }
	  },
	  activity: {
	    da: {
	      name: 'Aktiviteter',
	      order: 11
	    },
	    en: {
	      name: 'Activities',
	      order: 11
	    },
	    nb: {
	      name: 'Aktiviteter',
	      order: 11
	    }
	  },
	  absence: {
	    da: {
	      name: 'Fravær',
	      order: 12
	    },
	    en: {
	      name: 'Absence',
	      order: 12
	    },
	    nb: {
	      name: 'Fravær',
	      order: 12
	    }
	  },
	  exercise: {
	    da: {
	      name: 'Bevægelse',
	      order: 21
	    }
	  },
	  flextime: {
	    da: {
	      name: 'Flextid',
	      order: 22
	    }
	  },
	  pay_supplement: {
	    da: {
	      name: 'Tillæg',
	      order: 13
	    }
	  },
	  without_kids: {
	    da: {
	      name: 'Uden børn',
	      order: 2
	    }
	  },
	  with_kids: {
	    da: {
	      name: 'Med børn',
	      order: 1
	    }
	  }
	};
	var SUBJECTS_TYPE_WITH_REMEMBER_TEACHER = {
	  subject: true,
	  resource: true,
	  optional: true,
	  exercise: true,
	  club: true,
	  supplemental: true
	};
	var I18N = {
	  da: {
	    cant_edit: 'Kan ikke redigeres fra kalenderen',
	    hours_per_year: 't/år',
	    add: 'Tilføj'
	  },
	  en: {
	    cant_edit: 'Can not edit from the calendar',
	    hours_per_year: 'h/year',
	    add: 'Add'
	  },
	  nb: {
	    cant_edit: 'Kan ikke redigeres fra kalenderen',
	    hours_per_year: 't/år',
	    add: 'Legg til'
	  }
	};
	exports.default = {
	  components: { ImportSubjectsToKlass: _ImportSubjectsToKlass2.default, Loader: _Loader2.default, CreateSubject: _CreateSubject2.default },
	  props: {
	    calendarId: {
	      default: 7
	    },
	    dragActiveDate: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    locale: {
	      default: 'en'
	    },
	    school: {
	      default: null
	    },
	    deleteSubject: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      startX: 0,
	      startY: 0,
	      startClientY: 0,
	      startClientX: 0,
	      delta: 5,
	      activeSubject: null,
	      movedY: 0,
	      movedX: 0,
	      activeSubjectBCR: null,
	      theActiveAcc: null,
	      accTransition: null,
	      isDraggingSubject: false,
	      isDCalATrashcan: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    isShowImportSubjectsOption: function isShowImportSubjectsOption() {
	      var schoolCountry = this.school && this.school.country ? this.school && this.school.country.toLowerCase() : 'da';
	      return this.subjects.length < 1 && this.allKlassCalendarsInAHash[this.calendarId] && (schoolCountry === 'no' || schoolCountry === 'dk');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    calendarType: function calendarType() {
	      return this.allCalendarsInHash[this.calendarId] ? this.allCalendarsInHash[this.calendarId].type : '';
	    },
	    allKlassCalendarsInAHash: function allKlassCalendarsInAHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    subjects: function subjects() {
	      return this.$store.state.calendar.subjects;
	    },
	    isSubjectsLoading: function isSubjectsLoading() {
	      return this.$store.state.calendar.isSubjectsLoading;
	    },
	    theActiveAccSubjects: function theActiveAccSubjects() {
	      var _this = this;
	
	      return this.allSubjects.filter(function (subject) {
	        return subject.subject_type === _this.theActiveAcc;
	      });
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    theUserIsAdmin: function theUserIsAdmin() {
	      return this.userHasPermission('can_manage_school');
	    },
	    isPermissionToSeeAbsence: function isPermissionToSeeAbsence() {
	      if (this.schoolId !== 29045) {
	        return true;
	      } else {
	        return this.theUserIsAdmin;
	      }
	    },
	    filteredSubjects: function filteredSubjects() {
	      var _this2 = this;
	
	      return this.subjects.filter(function (subject) {
	        if (_this2.isPermissionToSeeAbsence) {
	          return subject;
	        } else {
	          return subject.subject_type !== 'absence';
	        }
	      });
	    },
	    allSubjects: function allSubjects() {
	      var _this3 = this;
	
	      var sortedSubjects = this.filteredSubjects.sort(function (a, b) {
	        if (a.name && b.name) {
	          return a.name.localeCompare(b.name, undefined, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        }
	      });
	      return sortedSubjects.map(function (subject) {
	        var title = subject.calendar_id === _this3.calendarId * 1 ? subject.name : subject.name + ', ' + subject.calendar_name;
	        _this3.$set(subject, 'title', title);
	        if (subject.subject_type === 'absence' || subject.subject_type === 'flexin' || subject.subject_type === 'flexout') {
	          _this3.$set(subject, 'v_is_editable', false);
	          _this3.$set(subject, 'v_hours', '');
	          _this3.$set(subject, 'v_other_school', false);
	          _this3.$set(subject, 'v_cal_types', _this3.getCalUsers(subject));
	        } else {
	          var hours = subject.actual_hours ? subject.hours - Math.floor(subject.actual_hours) : subject.hours * 1;
	          _this3.$set(subject, 'v_hours', hours.toFixed(0));
	          _this3.$set(subject, 'v_other_school', false);
	          _this3.$set(subject, 'v_is_editable', true);
	          _this3.$set(subject, 'v_cal_types', _this3.getCalUsers(subject));
	        }
	        if (SUBJECTS_TYPE_WITH_REMEMBER_TEACHER[subject.subject_type] && _this3.calendarType !== 'user') {
	          subject.v_must_have_teacher = true;
	        }
	        return subject;
	      });
	    },
	    subjectsInCategories: function subjectsInCategories() {
	      var subjectsAcc = [];
	      this.allSubjects.forEach(function (subject) {
	        var idx = subjectsAcc.findIndex(function (subjectAcc) {
	          return subjectAcc.type === subject.subject_type;
	        });
	        if (idx < 0) {
	          subjectsAcc.push({ type: subject.subject_type, subjects: [subject] });
	        } else {
	          subjectsAcc[idx].subjects.push(subject);
	        }
	      });
	      return subjectsAcc;
	    },
	    subjectsInCategoriesSorted: function subjectsInCategoriesSorted() {
	      var _this4 = this;
	
	      return this.subjectsInCategories.map(function (subCat) {
	        var name = subCat.type;
	        var order = 100;
	        if (SUBJETS_ALL_TYPES[subCat.type]) {
	          var localized = SUBJETS_ALL_TYPES[subCat.type][_this4.locale] ? SUBJETS_ALL_TYPES[subCat.type][_this4.locale] : SUBJETS_ALL_TYPES[subCat.type]['da'];
	          name = localized.name;
	          order = localized.order;
	        }
	        subCat.v_order = order;
	        subCat.v_title = name;
	        return subCat;
	      }).sort(function (a, b) {
	        return a.v_order > b.v_order ? 1 : -1;
	      });
	    },
	    activeSubjects: function activeSubjects() {
	      var _this5 = this;
	
	      var activeSubjects = this.subjectsInCategoriesSorted.filter(function (subjectsGroup) {
	        return subjectsGroup.type === _this5.theActiveAcc;
	      });
	      return activeSubjects && activeSubjects[0] && activeSubjects[0].subjects ? activeSubjects[0].subjects : [];
	    }
	  },
	  watch: {
	    calendarId: function calendarId(val) {
	      if (val) {
	        var isNewCalendar = true;
	        this.$store.dispatch('readCalendarSubjects', isNewCalendar);
	      }
	    },
	    deleteSubject: function deleteSubject(val) {
	      if (!val) {
	        this.isDCalATrashcan = false;
	      }
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      } else {
	        return true;
	      }
	    },
	    onMouseEnter: function onMouseEnter(evt) {
	      if (!this.deleteSubject) {
	        return;
	      }
	      this.isDCalATrashcan = true;
	      this.$emit('onMouseEnter');
	    },
	    onMouseLeave: function onMouseLeave(evt) {
	      this.isDCalATrashcan = false;
	      if (!this.deleteSubject) {
	        return;
	      }
	      this.$emit('onMouseLeave');
	    },
	    startTrans: function startTrans(el) {
	      el.style.height = el.scrollHeight + 'px';
	    },
	    endTrans: function endTrans(el) {
	      el.style.height = '';
	    },
	    tippyContent: function tippyContent(subject) {
	      if (!subject.v_is_editable) {
	        return this.i18n[this.locale]['cant_edit'];
	      } else {
	        return subject.v_cal_types.toolTipText;
	      }
	    },
	    tippySettings: function tippySettings(subject) {
	      if (!subject.v_is_editable) {
	        return {
	          trigger: 'click',
	          arrow: true,
	          onShow: this.hideTippy,
	          zIndex: '999999992',
	          boundary: 'window'
	        };
	      } else {
	        return {
	          arrow: true,
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function onShow() {
	            return subject.v_cal_types.toolTipText.length > 0;
	          }
	        };
	      }
	    },
	    getCalUsers: function getCalUsers(subject) {
	      var users = [];
	      var rooms = [];
	      if (subject.cals) {
	        subject.cals.forEach(function (cal) {
	          switch (cal.calendar_type) {
	            case 'user':
	              users.push(cal.name);
	              break;
	            case 'room':
	              rooms.push(cal.name);
	              break;
	          }
	        });
	      }
	      return { users: users, rooms: rooms, toolTipText: users.concat(rooms).join(', ') };
	    },
	    setTheActiveAcc: function setTheActiveAcc(subjectType) {
	      var key = 'd_subject_acc_' + this.calendarId;
	      if (this.theActiveAcc === subjectType) {
	        this.theActiveAcc = null;
	        if (this.$helpers.getCookie(key)) {
	          this.$helpers.deleteCookie(key);
	        }
	      } else {
	        this.theActiveAcc = subjectType;
	        if (subjectType !== 'absence') {
	          this.$helpers.setCookie(key, subjectType);
	        }
	      }
	    },
	    onMouseDown: function onMouseDown(subject, evt) {
	      if (evt.button !== 0) {
	        return;
	      }
	      var el = evt.target.closest('li');
	      this.activeSubjectBCR = el.getBoundingClientRect();
	      this.$emit('setDragLesson', subject);
	      this.$emit('setActiveSubjectBCR', el.getBoundingClientRect());
	
	      this.activeSubject = subject;
	      this.startX = evt.pageX;
	      this.startY = evt.pageY;
	      this.startClientY = evt.clientY;
	      this.startClientX = evt.clientX;
	      evt.target.releasePointerCapture(evt.pointerId);
	      document.addEventListener('pointermove', this.onMouseMove);
	      document.addEventListener('pointerup', this.onMouseUp);
	    },
	    onMouseUp: function onMouseUp(evt) {
	      this.getIsDragOrClick(evt);
	      document.removeEventListener('pointermove', this.onMouseMove);
	      document.removeEventListener('pointerup', this.onMouseUp);
	      this.cleanUp();
	      this.$emit('doMouseUp');
	    },
	    getIsDragOrClick: function getIsDragOrClick(event) {
	      if (!this.isDraggingSubject) {
	        if (this.activeSubject.v_is_editable) {
	          this.$store.commit('setEditSubject', this.activeSubject);
	        }
	      }
	    },
	    onMouseMove: function onMouseMove(evt) {
	      this.movedY = evt.pageY - (this.startClientY - this.activeSubjectBCR.top);
	      this.movedX = evt.pageX - (this.startClientX - this.activeSubjectBCR.left);
	      this.$emit('movedXY', this.movedX, this.movedY);
	      if (!this.isDraggingSubject) {
	        this.setIsDraggingSubject(true);
	      }
	      this.$emit('movedXY', this.movedX, this.movedY);
	    },
	    setIsDraggingSubject: function setIsDraggingSubject(boolean) {
	      if (boolean) {
	        this.isDraggingSubject = true;
	        var subjectObj = {
	          calendarId: this.activeSubject.calendar_id,
	          subjectId: this.activeSubject.id
	        };
	        this.$store.dispatch('readSubjectAvailability', subjectObj);
	      } else {
	        this.isDraggingSubject = false;
	      }
	    },
	    cleanUp: function cleanUp() {
	      this.setIsDraggingSubject(false);
	      this.activeSubject = null;
	      this.$emit('movedXY', null, null);
	      this.$emit('setIsDraggingExternalEvent', false);
	      this.$store.dispatch('clearAvailability');
	      var el = this.$refs.d_cal_dragged;
	      if (el) {
	        el.remove();
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    var key = 'd_subject_acc_' + this.calendarId;
	    if (this.$helpers.getCookie(key)) {
	      this.setTheActiveAcc(this.$helpers.getCookie(key));
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readCalendarSubjects');
	  }
	};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DSchedulerItem = __webpack_require__(1248);
	
	var _DSchedulerItem2 = _interopRequireDefault(_DSchedulerItem);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SchedulerItem: _DSchedulerItem2.default,
	    Spinner: _Loader2.default
	  },
	  directives: {
	    scroll: {
	      inserted: function inserted(el, binding) {
	        var f = function f(evt) {
	          if (binding.value(evt, el)) {
	            el.removeEventListener('scroll', f);
	          }
	        };
	        el.addEventListener('scroll', f);
	      }
	    }
	  },
	  props: {
	    calendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    title: {
	      type: String,
	      default: 'Teachers'
	    },
	    isLoading: {
	      type: Boolean,
	      default: false
	    },
	    sortBy: {
	      type: String,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isSyncingLeftScroll: false,
	      isSyncingRightScroll: false,
	      isSyncingTopScroll: false,
	      tags: [],
	      rows: {}
	    };
	  },
	
	  watch: {
	    rows: function rows() {
	      this.$refs.rightDiv.scrollLeft = 480;
	      this.$refs.topDiv.scrollLeft = 480;
	    }
	  },
	  filters: {
	    round: function round(num) {
	      return Math.round(num);
	    }
	  },
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    items: function items() {
	      var _this = this;
	
	      var calendars = JSON.parse((0, _stringify2.default)(this.calendars));
	      var evts = JSON.parse((0, _stringify2.default)(this.events));
	      var cals = calendars.map(function (cal) {
	        var icon = '';
	        switch (cal.type) {
	          case 'user':
	            icon = 'icon-user';
	            break;
	          case 'room':
	            icon = 'icon-location';
	            break;
	          case 'klass':
	            icon = 'icon-calendar4';
	            break;
	          case 'other':
	            icon = 'icon-clipboard2';
	            break;
	          case 'merge':
	            icon = 'icon-calendar-week';
	            break;
	          case 'club':
	            icon = 'icon-users5';
	            break;
	        }
	        _this.$set(cal, 'dCalIcon', icon);
	        _this.$set(cal, 'userLessons', []);
	        _this.$set(cal, 'dayEvents', []);
	        _this.$set(cal, 'dayPresence', []);
	        _this.$set(cal, 'firstEvent', null);
	        _this.$set(cal, 'lastEvent', null);
	        return cal;
	      });
	      evts.forEach(function (event) {
	        _this.$set(event, 'v_calIds', []);
	        _this.$set(event, 'v_groups', []);
	        _this.$set(event, 'v_group_names', '');
	        _this.$set(event, 'v_users', []);
	        _this.$set(event, 'v_subs_for_user_ids', []);
	        _this.$set(event, 'v_room_ids', []);
	        _this.$set(event, 'v_has_teachers', false);
	        _this.$set(event, 'v_user_names_obj', {});
	        _this.$set(event, 'v_user_names', '');
	        if (event.calendars) {
	          event.calendars.forEach(function (calendar) {
	            var cal = _this.allCalendarsInHash[calendar.calendar_id];
	            if (cal) {
	              if (event.v_calIds.indexOf(cal.id) < 0) {
	                event.v_calIds.push(cal.id);
	              }
	              if (cal.type === 'klass') {
	                event.v_groups.push(cal);
	                event.v_group_names += event.v_group_names.length === 0 ? ' ' + cal.name : ', ' + cal.name;
	              }
	              if (cal.type === 'user') {
	                if (calendar.substitute) {
	                  event.v_subs_for_user_ids.push(calendar.substitute);
	                }
	                event.v_has_teachers = true;
	                event.v_users.push(cal);
	                var userId = _this.allUsersInCalIdHash[calendar.calendar_id] ? _this.allUsersInCalIdHash[calendar.calendar_id].id : null;
	                var userObj = {
	                  userId: userId,
	                  name: cal.name ? cal.name : '',
	                  isSubstituted: false
	                };
	                event.v_user_names_obj[userId] = userObj;
	              }
	              if (cal.type === 'room') {
	                event.v_room_ids.push(cal.id);
	              }
	            }
	          });
	        }
	
	        event.v_subs_for_user_ids.forEach(function (userId) {
	          if (event.v_user_names_obj[userId]) {
	            event.v_user_names_obj[userId].isSubstituted = true;
	          }
	        });
	        (0, _keys2.default)(event.v_user_names_obj).forEach(function (key) {
	          var user = event.v_user_names_obj[key];
	          if (user.isSubstituted) {
	            event.v_user_names += '<p class="striketrough">' + user.name + '</p>';
	          } else {
	            event.v_user_names += '<p>' + user.name + '</p>';
	          }
	        });
	        event.v_calIds.forEach(function (calId) {
	          var idx = cals.findIndex(function (cal) {
	            return cal.id === calId;
	          });
	          if (idx > -1) {
	            if (event.event_type === 'presence') {
	              cals[idx].dayPresence.push(event);
	            } else {
	              cals[idx].dayEvents.push(event);
	              if (!cals[idx]['firstEvent'] || (0, _moment2.default)(event.start).isBefore(cals[idx]['firstEvent'])) {
	                cals[idx]['firstEvent'] = new Date(event.start).getTime();
	              }
	              if (!cals[idx]['lastEvent'] || (0, _moment2.default)(event.end).isAfter(cals[idx]['lastEvent'])) {
	                cals[idx]['lastEvent'] = new Date(event.end).getTime();
	              }
	            }
	          }
	        });
	      });
	      return cals;
	    },
	    itemsSorted: function itemsSorted() {
	      if (!this.sortBy) {
	        var userLocale = 'en';
	        return this.items.sort(function (a, b) {
	          return a.name.localeCompare(b.name, userLocale, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	      }
	      if (this.sortBy === 'firstEvent') {
	        return this.items.sort(function (itemA, itemB) {
	          var a = itemA['firstEvent'];
	          var b = itemB['firstEvent'];
	          return (a === null) - (b === null) || +(a > b) || -(a < b);
	        });
	      }
	      if (this.sortBy === 'lastEvent') {
	        return this.items.sort(function (itemA, itemB) {
	          var a = itemA['lastEvent'];
	          var b = itemB['lastEvent'];
	          return (a === null) - (b === null) || -(a > b) || +(a < b);
	        });
	      }
	      return this.items;
	    },
	    hoursInLocale: function hoursInLocale() {
	      var hours = [];
	      for (var i = 0; i < 24; i++) {
	        hours.push((0, _moment2.default)().set({ hour: i, minutes: 0, seconds: 0 }));
	      }
	      return hours;
	    }
	  },
	  methods: {
	    setRows: function setRows(obj, userid) {
	      this.$set(this.rows, userid, obj.rows);
	    },
	    handleScrollRight: function handleScrollRight(evt, el) {
	      if (!this.isSyncingRightScroll) {
	        this.isSyncingLeftScroll = true;
	        this.isSyncingTopScroll = true;
	        this.$refs.leftDiv.scrollTop = el.scrollTop;
	        this.$refs.topDiv.scrollLeft = el.scrollLeft;
	      }
	      this.isSyncingRightScroll = false;
	    },
	    handleScrollLeft: function handleScrollLeft(evt, el) {
	      if (!this.isSyncingLeftScroll) {
	        this.isSyncingRightScroll = true;
	        this.$refs.rightDiv.scrollTop = el.scrollTop;
	      }
	      this.isSyncingLeftScroll = false;
	    },
	    handleScrollTop: function handleScrollTop(evt, el) {
	      if (!this.isSyncingTopScroll) {
	        this.isSyncingRightScroll = true;
	        this.$refs.rightDiv.scrollLeft = el.scrollLeft;
	      }
	      this.isSyncingTopScroll = false;
	    }
	  }
	};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	exports.default = {
	  props: {
	    user: {}
	  },
	  data: function data() {
	    return {
	      slotWidth: 40,
	      slotHeight: 40,
	      rows: 1,
	      firstEvent: true,
	      correctEvents: [],
	      subScoreMeta: [],
	      oldSubScoreMeta: []
	    };
	  },
	
	  computed: {
	    userLessons: function userLessons() {
	      return this.user.dayEvents;
	    },
	    userPresence: function userPresence() {
	      return this.user.dayPresence;
	    },
	    userPresenceForPlacing: function userPresenceForPlacing() {
	      var _this = this;
	
	      return this.userPresence.map(function (event) {
	        return {
	          'left': _this.eventTop(event),
	          'right': _this.eventRight(event),
	          'obj': event
	        };
	      });
	    },
	    sortedEvents: function sortedEvents() {
	      var arr = this.userLessons;
	      return arr.sort(function (a, b) {
	        return moment(a.start).unix() - moment(b.start).unix();
	      });
	    }
	  },
	  watch: {
	    sortedEvents: function sortedEvents() {
	      this.rows = 1;
	      this.$emit('rows', { 'rows': this.rows });
	      this.correctEvents.splice(0, this.correctEvents.length);
	      this.setWidthAndLeft();
	    }
	  },
	  methods: {
	    isActiveEvent: function isActiveEvent(event) {
	      return this.activeEvent && event.obj.id === this.activeEvent.obj.id && this.activeUser && this.user.id === this.activeUser.id;
	    },
	    eventRight: function eventRight(event) {
	      var time = moment.duration({
	        minutes: moment(event.end).format('mm'),
	        hours: moment(event.end).format('HH')
	      }).asMinutes();
	      var endOfDay = moment.duration({
	        hours: 24,
	        minutes: 0
	      }).asMinutes();
	      return this.slotWidth * 2 / 60 * (endOfDay - time);
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = moment(event.start).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventStartTime = moment(event.start);
	      var duration = moment(eventStartTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = moment(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = moment(event.end).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventEndTime = moment(event.end);
	      var duration = moment(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].row = i;
	          if (i + 1 > this.rows) {
	            this.rows = i + 1;
	          }
	          this.$emit('rows', { 'rows': this.rows });
	          col[j].colspan = colSpan / n;
	          this.correctEvents.push(col[j]);
	
	          if (this.firstEvent) {
	            this.$emit('lessonsUpdate', this.correctEvents[0]);
	          }
	          this.firstEvent = false;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    setWidthAndLeft: function setWidthAndLeft() {
	      var _this2 = this;
	
	      var columns = [];
	      var lastEventEnding = null;
	      var events = this.sortedEvents.map(function (elem) {
	        var top = _this2.eventTop(elem);
	        var height = _this2.eventHeight(elem);
	        var bottom = _this2.eventBottom(elem);
	        var right = _this2.eventRight(elem);
	        return {
	          'obj': elem,
	          'top': top,
	          'left': top,
	          'right': right,
	          'height': height,
	          'bottom': bottom,
	          'subs': [],
	          'othersOnLesson': elem.teacher,
	          'klassesOnLesson': elem.group
	        };
	      });
	      events.sort(function (e1, e2) {
	        if (e1.top < e2.top) return -1;
	        if (e1.top > e2.top) return 1;
	        if (e1.bottom < e2.bottom) return -1;
	        if (e1.bottom > e2.bottom) return 1;
	        return 0;
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packEvents(columns);
	          columns = [];
	          lastEventEnding = null;
	        }
	        var placed = false;
	        for (var j = 0; j < columns.length; j++) {
	          var col = columns[j];
	          if (!this.collidesWith(col[col.length - 1], e)) {
	            col.push(e);
	            placed = true;
	            break;
	          }
	        }
	        if (!placed) {
	          columns.push([e]);
	        }
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (columns.length > 0) {
	        this.packEvents(columns);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.rows = 1;
	    this.$emit('rows', { 'rows': this.rows });
	    this.setWidthAndLeft();
	  }
	};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _core = __webpack_require__(18);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    also_assigned: 'Også tilknyttet',
	    working_hours: 'Arbejdstid'
	  },
	  nb: {
	    also_assigned: 'Også tilordnet',
	    working_hours: 'Arbeidstid'
	  },
	  en: {
	    also_assigned: 'Also assigned',
	    working_hours: 'Working Hours'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { Loader: _Loader2.default, spinner: _Spinner2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    isLoading: {
	      default: false,
	      type: Boolean
	    },
	    allDataLoaded: {
	      default: false,
	      type: Boolean
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    multiple: {
	      default: true,
	      type: Boolean
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    },
	    eventId: {
	      type: Number,
	      required: false
	    },
	    receiveData: {},
	    showSelectedUsers: {
	      default: true,
	      type: Boolean
	    },
	    addClass: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemSpaceBetween: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    withoutSelectedItems: function withoutSelectedItems() {
	      var _this = this;
	
	      return this.items.filter(function (el) {
	        return _this.selectedUsers.filter(function (secEl) {
	          return secEl.id === el.id;
	        }).length === 0;
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this2 = this;
	
	      return this.withoutSelectedItems.filter(function (user) {
	        var nameMatch = user.name !== '' ? user.name.match(new RegExp(_this2.searchText, 'i')) : '';
	        var initialsMatch = user.initials && user.initials !== '' ? user.initials.match(new RegExp(_this2.searchText, 'i')) : '';
	        return nameMatch || initialsMatch;
	      });
	    },
	    placeholderText: function placeholderText() {
	      var placeholder = this.placeholder.length > 0 ? this.placeholder : this.$i18n.t('vue2.dselect.placeholder');
	      return this.selectedUsers.length > 0 ? '' : placeholder;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    }
	  },
	  data: function data() {
	    return {
	      showDropdown: false,
	      searchText: '',
	      searchTextDebounced: '',
	      selectedUsers: [],
	      keyboardSelected: null,
	      keyboardSelectedIndex: 0,
	      readyToDelete: null,
	      openFromBottom: false,
	      maxLimit: 400,
	      addLimit: 400,
	      debounceTimer: null
	    };
	  },
	
	  watch: {
	    receiveData: function receiveData() {
	      for (var i = 0; i < this.items.length; i++) {
	        if (this.receiveData.id === this.items[i].id) {
	          this.toggleUser(this.items[i]);
	        }
	      }
	      this.searchText = '';
	    },
	    show: function show() {
	      if (!this.show) {
	        this.close();
	      }
	    },
	    searchedUsers: function searchedUsers() {
	      this.keyboardSelectedIndex = 0;
	      this.keyboardSelected = this.searchedUsers[0];
	    },
	    searchText: function searchText() {
	      this.$emit('searchText', this.searchText);
	    },
	    allDataLoaded: function allDataLoaded() {
	      this.sortSelectedUsers();
	    }
	  },
	  filters: {
	    localeTime: function localeTime(eventTime) {
	      return (0, _moment2.default)(eventTime).format('LT');
	    }
	  },
	  methods: {
	    debounceSearch: function debounceSearch(event) {
	      var _this3 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this3.searchTextDebounced = event.target.value;
	        _this3.$emit('onSearchTextDebounced', _this3.searchTextDebounced);
	      }, 400);
	    },
	    createPopper: function createPopper() {
	      var source = this.$refs.d_select__items;
	      var el = this.$refs.d_select;
	      document.getElementById('djs-content-container').appendChild(source);
	      var elWidth = el.getBoundingClientRect().width;
	      source.style.width = elWidth + 'px';
	      (0, _core.createPopper)(el, source, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }]
	      });
	    },
	    userOccEvents: function userOccEvents(selectedUser) {
	      var _this4 = this;
	
	      if (selectedUser.occupied && selectedUser.occupied.events.length > 0) {
	        var occEventsWithoutPresenceAndCurrentEvent = selectedUser.occupied.events.filter(function (lesson) {
	          return lesson.event_id !== _this4.eventId && lesson.event_type !== 'presence';
	        });
	        return occEventsWithoutPresenceAndCurrentEvent;
	      } else {
	        return false;
	      }
	    },
	    checkHeight: function checkHeight() {
	      var bcr = this.$el.getBoundingClientRect();
	      var pxFromTop = bcr.top;
	      var pxFromBottom = window.innerHeight - (bcr.top + bcr.height);
	      if (pxFromBottom < 330 && pxFromTop > 330) {
	        this.openFromBottom = true;
	      }
	    },
	    isReadyToDelete: function isReadyToDelete(user) {
	      if (!this.readyToDelete) {
	        return;
	      }
	      return this.readyToDelete.id === user.id;
	    },
	    scrollTokeyboardSelected: function scrollTokeyboardSelected() {
	      var _this5 = this;
	
	      setTimeout(function () {
	        var user = document.querySelector('.isReadyForSelection');
	        var selectedOffsetTop = user.offsetTop;
	        var selectedHeight = user.getBoundingClientRect().height;
	        var totalHeight = selectedOffsetTop + selectedHeight;
	
	        var top = _this5.$refs.dropdown.scrollTop;
	        var height = _this5.$refs.dropdown.getBoundingClientRect().height;
	        var bottom = top + height;
	
	        if (totalHeight > bottom) {
	          _this5.$refs.dropdown.scrollTop = _this5.$refs.dropdown.scrollTop + selectedHeight;
	        }
	
	        if (selectedOffsetTop < top) {
	          _this5.$refs.dropdown.scrollTop = _this5.$refs.dropdown.scrollTop - selectedHeight;
	        }
	      }, 0);
	    },
	    setIsReadyForSelection: function setIsReadyForSelection(user, idx) {
	      this.keyboardSelected = null;
	      this.keyboardSelected = user;
	      this.keyboardSelectedIndex = idx;
	    },
	    selectWithKeyboard: function selectWithKeyboard(stroke, e) {
	      if (!this.showDropdown) {
	        this.open();
	      }
	      if (stroke === 'down') {
	        if (this.keyboardSelectedIndex + 1 >= this.searchedUsers.length) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex + 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'up') {
	        if (this.keyboardSelectedIndex - 1 < 0) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex - 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'enter') {
	        if (this.keyboardSelected === null) {
	          return;
	        }
	        if (this.searchedUsers.length < 1) {
	          this.$emit('enter');
	          return;
	        }
	        this.toggleUser(this.keyboardSelected);
	      }
	    },
	    isSelectedWithKeyboard: function isSelectedWithKeyboard(user) {
	      return this.keyboardSelected && this.keyboardSelected.id === user.id;
	    },
	    deleteUserWithKeyboard: function deleteUserWithKeyboard() {
	      if (this.searchText.length > 0 || this.selectedUsers.length < 1) {
	        return;
	      }
	      if (this.readyToDelete === null) {
	        this.readyToDelete = this.selectedUsers[this.selectedUsers.length - 1];
	      } else {
	        this.removeUser(this.selectedUsers[this.selectedUsers.length - 1]);
	        this.readyToDelete = null;
	      }
	    },
	    onClickAway: function onClickAway() {
	      this.close();
	      this.$emit('close');
	    },
	    close: function close() {
	      if (!this.showDropdown) {
	        return;
	      }
	      this.showDropdown = false;
	      this.keyboardSelected = null;
	      this.keyboardSelectedIndex = 0;
	      this.readyToDelete = null;
	      this.searchText = '';
	      this.$emit('show', false);
	      this.$emit('close');
	      this.openFromBottom = false;
	      this.maxLimit = this.addLimit;
	    },
	    open: function open() {
	      var _this6 = this;
	
	      this.checkHeight();
	      this.showDropdown = true;
	      this.$emit('show', true);
	      this.setFocus();
	      this.keyboardSelectedIndex = 0;
	      this.$nextTick(function (_) {
	        _this6.createPopper();
	      });
	    },
	    toggleUser: function toggleUser(item) {
	      if (item.tag) {
	        this.selectAllWithTag(item.name);
	        return;
	      }
	      if (this.isSelected(item)) {
	        this.removeUser(item);
	      } else {
	        if (item.isOnLesson) {
	          this.$emit('addIsOnLesson', item);
	          this.close();
	          return;
	        }
	        if (this.multiple) {
	          this.selectedUsers.push(item);
	          this.$emit('add', item);
	        } else {
	          this.selectedUsers = [];
	          this.selectedUsers.push(item);
	          this.$emit('add', item);
	        }
	        this.$emit('update', this.selectedUsers);
	      }
	      if (!this.showSelectedUsers) {
	        this.selectedUsers = [];
	      }
	      this.close();
	    },
	    selectAllWithTag: function selectAllWithTag(tag) {
	      var _this7 = this;
	
	      var usersWithTag = this.items.filter(function (item) {
	        return item.user_tags && item.user_tags.indexOf(tag) > -1;
	      });
	      usersWithTag.forEach(function (user) {
	        var idx = _this7.items.findIndex(function (x) {
	          return x.id === user.id;
	        });
	        if (!_this7.isSelected(_this7.items[idx])) {
	          _this7.selectedUsers.push(_this7.items[idx]);
	        }
	      });
	      this.close();
	      this.$emit('update', this.selectedUsers);
	    },
	    removeUser: function removeUser(item) {
	      this.selectedUsers.splice(this.selectedUsers.indexOf(item), 1);
	      this.$emit('remove', item);
	      this.$emit('update', this.selectedUsers);
	      this.close();
	    },
	    isSelected: function isSelected(user) {
	      return this.selectedUsers.indexOf(user) > -1;
	    },
	    setFocus: function setFocus() {
	      this.$refs.inputfield.focus();
	    },
	    sortSelectedUsers: function sortSelectedUsers() {
	      this.selectedUsers = this.selectedUsers.sort(function (a, b) {
	        var x = a.name.toLowerCase();
	        var y = b.name.toLowerCase();
	        return x < y ? -1 : x > y ? 1 : 0;
	      });
	    },
	    loadMoreCalendars: function loadMoreCalendars() {
	      if (this.searchedUsers.length > this.maxLimit) {
	        this.maxLimit = this.maxLimit + this.addLimit;
	      }
	    },
	    handleScroll: function handleScroll(evt) {
	      var element = evt.target;
	
	      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
	        this.loadMoreCalendars();
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this8 = this;
	
	    this.$nextTick(function (_) {
	      if (_this8.show) {
	        _this8.open();
	      }
	    });
	    this.selectedUsers = this.itemsSelected;
	  },
	  beforeDestroy: function beforeDestroy() {
	    var source = this.$refs.d_select__items;
	    if (source) {
	      source.remove();
	    }
	  }
	};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CalendarViewDay = __webpack_require__(295);
	
	var _CalendarViewDay2 = _interopRequireDefault(_CalendarViewDay);
	
	var _DSelectCals = __webpack_require__(51);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _core = __webpack_require__(18);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default, CalendarViewDay: _CalendarViewDay2.default },
	  props: {
	    itemType: {
	      default: 'user'
	    },
	    preSelectedItems: {
	      default: function _default() {
	        return [];
	      }
	    },
	    itemsThatCantBeDeleted: {
	      default: function _default() {
	        return [];
	      }
	    },
	    itemsUnselectable: {
	      default: function _default() {
	        return [];
	      }
	    },
	    showTags: {
	      type: Boolean,
	      default: false
	    },
	    isMultiple: {
	      type: Boolean,
	      default: true
	    },
	    showCreateButton: {
	      type: Boolean,
	      default: false
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    eventId: {
	      default: null
	    },
	    event: {
	      default: null
	    },
	    disableAddMore: {
	      type: Boolean,
	      default: false
	    },
	    disableAddMoreMessage: {
	      type: String
	    },
	    isDeleteAllAnOption: {
	      type: Boolean,
	      default: true
	    },
	    isLoadingProp: {
	      type: Boolean,
	      default: false
	    },
	    eventSchoolCalendars: {
	      required: false,
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    eventSchoolUsers: {
	      required: false,
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    eventSchoolYears: {
	      required: false,
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isEventSchoolIdTheSameAsActiveSchoolId: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      activeCalendar: null,
	      isLoaded: false,
	      tags: [],
	      selectedItems: [],
	      occupiedItems: {},
	      presentItems: {},
	      searchText: '',
	      placement: 'bottom',
	      i18n: {
	        da: {
	          search: 'Søg og vælg'
	        },
	        en: {
	          search: 'Search and choose'
	        },
	        nb: {
	          search: 'Søk og velg'
	        }
	      },
	      newUserCalendarId: null,
	      isLoading: false,
	      theShowCalendar: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['locale']), {
	    calendars: function calendars() {
	      return this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.calendars : this.eventSchoolCalendars;
	    },
	    users: function users() {
	      return this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.allUsers : this.eventSchoolUsers;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.activeSchoolYears : this.eventSchoolYears;
	    },
	    schoolId: function schoolId() {
	      return this.event.school_id;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.returnCorrectCalendars('klass');
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.users.reduce(function (obj, item) {
	        obj[item.user_calendar_id] = item;
	        return obj;
	      }, {});
	    },
	    userCalendars: function userCalendars() {
	      var cals = this.calendars.filter(function (cal) {
	        return cal.type === 'user' && cal.name !== null && cal.name !== '';
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    roomCalendars: function roomCalendars() {
	      var cals = this.calendars.filter(function (cal) {
	        return cal.type === 'room' && !cal.archived_at && cal.name !== null && cal.name !== '';
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    otherCalendars: function otherCalendars() {
	      return this.returnCorrectCalendars('other');
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.returnCorrectCalendars('kindergarten');
	    },
	    clubCalendars: function clubCalendars() {
	      return this.returnCorrectCalendars('club');
	    },
	    studentCalendars: function studentCalendars() {
	      var cals = this.calendars.filter(function (cal) {
	        return cal.type === 'student' && !cal.archived_at && cal.name !== null && cal.name !== '';
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    calendarId: function calendarId() {
	      return this.event ? this.event.calendar_id : null;
	    },
	    items: function items() {
	      var _this = this;
	
	      var cals = [];
	      if (this.itemType === 'user') {
	        if (!this.showTags) {
	          cals = this.userCalendars;
	        }
	        var userCalsWithTags = this.userCalendars.map(function (cal) {
	          var tags = _this.allUsersInCalIdHash[cal.id] && _this.allUsersInCalIdHash[cal.id].user_tags ? _this.allUsersInCalIdHash[cal.id].user_tags : [];
	          _this.$set(cal, 'user_tags', tags);
	          return cal;
	        });
	        this.tags.forEach(function (tag) {
	          userCalsWithTags.push(tag);
	        });
	        cals = userCalsWithTags;
	      }
	      if (this.itemType.toLowerCase() === 'room') {
	        cals = this.roomCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'klass') {
	        cals = this.klassCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'student') {
	        cals = this.studentCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'other') {
	        cals = this.otherCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'club') {
	        cals = this.clubCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'kindergarten') {
	        cals = this.kindergartenCalendars;
	      }
	      return this.calendarId ? cals.filter(function (calendar) {
	        return calendar.id !== _this.calendarId;
	      }) : cals;
	    },
	    itemsWithOccupation: function itemsWithOccupation() {
	      var _this2 = this;
	
	      return this.items.map(function (calendar) {
	        _this2.$set(calendar, 'v_occupation', []);
	        _this2.$set(calendar, 'v_presence', []);
	        if (_this2.occupiedItems[calendar.id]) {
	          _this2.$set(calendar, 'v_occupation', _this2.occupiedItems[calendar.id]);
	        }
	        if (_this2.presentItems[calendar.id]) {
	          _this2.$set(calendar, 'v_presence', _this2.presentItems[calendar.id]);
	        }
	        return calendar;
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    date: function date() {
	      return this.event.start;
	    }
	  }),
	  watch: {
	    items: function items(val) {
	      if (val.length > 0) {
	        this.setPreSelectedItems();
	      }
	    },
	    eventId: function eventId(val) {
	      if (this.event) {
	        this.getDoubleBookedCalendars();
	      }
	    },
	    preSelectedItems: function preSelectedItems() {
	      this.setPreSelectedItems();
	    }
	  },
	  methods: {
	    updateAndClose: function updateAndClose() {
	      this.activeCalendar = null;
	      this.$emit('updateAndClose');
	    },
	    returnCorrectCalendars: function returnCorrectCalendars(calType) {
	      var _this3 = this;
	
	      var schoolYearIds = this.activeSchoolYears.map(function (schoolYear) {
	        return schoolYear.id;
	      });
	      var schoolYearYears = this.activeSchoolYears.map(function (schoolYear) {
	        return schoolYear.name;
	      });
	      var calendars = this.calendars.filter(function (cal) {
	        return cal.type === calType && cal.name !== null && cal.name !== '';
	      });
	      var calendarsInActiveYear = calendars.filter(function (cal) {
	        return cal.school_year_id ? schoolYearIds.indexOf(cal.school_year_id) > -1 : schoolYearYears.indexOf(cal.year) > -1;
	      });
	      var calendarInActiveYearMapped = calendarsInActiveYear.map(function (calendar) {
	        return (0, _extends3.default)({}, calendar, {
	          name: schoolYearIds.length < 2 ? calendar.name : _this3.getSchoolYearName(calendar) + ' - ' + calendar.name
	        });
	      });
	      return this.$helpers.sortArrOnName(calendarInActiveYearMapped);
	    },
	    getSchoolYearName: function getSchoolYearName(cal) {
	      var idx = this.activeSchoolYears ? this.activeSchoolYears.findIndex(function (schoolYear) {
	        return schoolYear.id === cal.school_year_id;
	      }) : -1;
	      if (idx > -1) {
	        return this.activeSchoolYears[idx]['name'];
	      }
	      return '';
	    },
	    withPopper: function withPopper(dropdownList, component, _ref) {
	      var width = _ref.width;
	
	      dropdownList.style.width = width;
	      (0, _core.createPopper)(component.$refs.toggle, dropdownList, {
	        placement: this.placement,
	        modifiers: [{
	          name: 'offset', options: {
	            offset: [0, 0]
	          }
	        }, {
	          name: 'toggleClass',
	          enabled: true,
	          phase: 'write',
	          fn: function fn(_ref2) {
	            var state = _ref2.state;
	
	            component.$el.classList.toggle('openFromBottom', state.placement === 'top');
	          }
	        }]
	      });
	    },
	    showCalendar: function showCalendar(calendar) {
	      var el = document.querySelector('.d-show-event');
	      if (el) {
	        el.click();
	      }
	      this.activeCalendar = calendar;
	    },
	    setSelectedItems: function setSelectedItems(val) {
	      this.selectedItems = [];
	      this.selectedItems = val;
	      this.$emit('update', this.selectedItems);
	    },
	    isInSelectedItems: function isInSelectedItems(calid) {
	      return this.selectedItems.findIndex(function (item) {
	        return item.id === calid;
	      }) >= 0;
	    },
	    setPreSelectedItems: function setPreSelectedItems() {
	      var _this4 = this;
	
	      if (this.calendars.length < 1) {
	        return;
	      }
	      this.selectedItems = [];
	      this.preSelectedItems.forEach(function (calendarId) {
	        if (calendarId) {
	          if (!_this4.isInSelectedItems(calendarId)) {
	            var idx = _this4.items.findIndex(function (item) {
	              return item.id === calendarId;
	            });
	            if (idx > -1) {
	              _this4.selectedItems.push(_this4.items[idx]);
	            }
	          }
	        }
	      });
	      if (!this.showTags) {
	        this.isLoaded = true;
	      }
	    },
	    getTags: function getTags() {
	      var _this5 = this;
	
	      _docendo2.default.schoolTags(this.event.school_id, function (data) {
	        var tags = [];
	        var i = 0;
	        data.forEach(function (tag) {
	          i++;
	          var oneTag = {
	            tag: true,
	            id: 999999999999 + i,
	            name: tag,
	            icon: 'icon-price-tag2'
	          };
	          tags.push(oneTag);
	        });
	        _this5.tags = tags;
	      });
	    },
	    createNew: function createNew(evt) {
	      var _this6 = this;
	
	      if (this.itemType === 'room') {
	        var calendars = [{ name: evt, type: this.itemType }];
	        _docendo2.default.schoolBulkCreateCalendars(this.schoolId, this.activeSchoolYear.id, calendars, function (success) {
	          console.log('success', success);
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	        return;
	      }
	      if (this.itemType === 'user') {
	        var users = [{ name: evt }];
	        _docendo2.default.schoolUsersCreate(this.schoolId, users, function (success) {
	          _this6.$store.dispatch('getSchoolCalendars', window.SCHOOL.id);
	          _this6.newUserCalendarId = success[0].user_calendar_id;
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	      }
	    },
	    getDoubleBookedCalendars: function getDoubleBookedCalendars() {
	      var _this7 = this;
	
	      this.isLoading = true;
	      this.occupiedItems = {};
	      this.presentItems = {};
	      _docendo2.default.schoolAvailabilities(this.schoolId, this.itemType, this.event.start, this.event.end, function (data) {
	        _this7.isLoading = false;
	        var dbAnswer = data && data.length > 0 ? JSON.parse(data) : [];
	        dbAnswer.forEach(function (cal) {
	          var occEvents = [];
	          var occPresence = [];
	          cal.events.forEach(function (event) {
	            if (event.event_id !== _this7.eventId) {
	              if (event.event_type === 'presence') {
	                occPresence.push(event);
	              } else {
	                occEvents.push(event);
	              }
	            }
	          });
	          if (occEvents.length > 0) {
	            _this7.$set(_this7.occupiedItems, cal.calendar_id, occEvents);
	          }
	          if (occPresence.length > 0) {
	            _this7.$set(_this7.presentItems, cal.calendar_id, occPresence);
	          }
	        });
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this8 = this;
	
	    this.setPreSelectedItems();
	    if (this.showTags) {
	      this.getTags();
	    }
	    if (this.event) {
	      this.$nextTick(function (_) {
	        _this8.getDoubleBookedCalendars();
	      });
	    }
	  }
	};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _appendToBody = __webpack_require__(364);
	
	var _appendToBody2 = _interopRequireDefault(_appendToBody);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _core = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    delete_all: 'Slet alle valgte',
	    hold_down: 'Hold',
	    to_select_multiple: 'nede for at vælge flere',
	    see_calendar: 'Se kalender'
	  },
	  en: {
	    delete_all: 'Remove all',
	    hold_down: 'Hold down',
	    to_select_multiple: 'to select multiple',
	    see_calendar: 'See calender'
	  },
	  nb: {
	    delete_all: 'Slett alle valgte',
	    hold_down: 'Hold nede',
	    to_select_multiple: 'for å velge flere',
	    see_calendar: 'Se kalender'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  directives: { appendToBody: _appendToBody2.default },
	  components: { Loader: _Loader2.default, spinner: _Spinner2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsUnselectable: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsThatCantBeDeleted: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    isLoading: {
	      default: false,
	      type: Boolean
	    },
	    isLoadingAvailability: {
	      default: false,
	      type: Boolean
	    },
	    allDataLoaded: {
	      default: false,
	      type: Boolean
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    multiple: {
	      default: true,
	      type: Boolean
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    },
	    eventId: {
	      type: Number,
	      required: false
	    },
	    event: {
	      type: Object,
	      default: function _default() {
	        return null;
	      },
	      required: false
	    },
	    appendToBody: {
	      default: false
	    },
	    calculatePosition: {
	      type: Function,
	      default: function _default(dropdownList, component, _ref) {
	        var top = _ref.top,
	            left = _ref.left;
	
	        dropdownList.style.top = top;
	        dropdownList.style.left = left;
	      }
	    },
	    showCreateButton: {
	      default: false,
	      type: Boolean
	    },
	    newUserCalendarId: {
	      default: null
	    },
	    disableAddMore: {
	      type: Boolean,
	      default: false
	    },
	    isDeleteAllAnOption: {
	      type: Boolean,
	      default: true
	    },
	    isShowCollisions: {
	      type: Boolean,
	      default: false
	    },
	    showCalendarYear: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : 'en';
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isInEvent: function isInEvent() {
	      return this.event !== null;
	    },
	    withoutSelectedItems: function withoutSelectedItems() {
	      var _this = this;
	
	      var itemsFiltered = this.items.filter(function (item) {
	        return !_this.itemsUnselectable.includes(item.id);
	      });
	      return itemsFiltered.filter(function (el) {
	        return _this.selectedItems.filter(function (secEl) {
	          return secEl.id === el.id;
	        }).length === 0;
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this2 = this;
	
	      if (this.disableAddMore) {
	        return [];
	      }
	      return this.withoutSelectedItems.filter(function (user) {
	        return user.name !== '' ? user.name.match(new RegExp(_this2.searchText, 'i')) : '';
	      });
	    },
	    placeholderText: function placeholderText() {
	      var placeholder = this.placeholder.length > 0 ? this.placeholder : this.$i18n.t('vue2.dselect.placeholder');
	      return this.selectedItems.length > 0 ? '' : placeholder;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    metaKeyTooltip: function metaKeyTooltip() {
	      return '<p class="tooltip-shortcut">' + this.i18n['hold_down'] + '<span>' + this.metaKey + '</span>' + this.i18n['to_select_multiple'] + '</p>';
	    }
	  },
	  data: function data() {
	    return {
	      showDropdown: false,
	      searchText: '',
	      selectedItems: [],
	      keyboardSelected: null,
	      keyboardSelectedIndex: 0,
	      readyToDelete: null,
	      openFromBottom: false,
	      readyToReceive: false,
	      maxLimit: 400,
	      addLimit: 400,
	      isKeepOpen: false,
	      _keyListenerOne: null,
	      _keyListenerTwo: null,
	      isMouseMoved: false
	    };
	  },
	
	  watch: {
	    show: function show() {
	      if (!this.show) {
	        this.close();
	      }
	    },
	    searchedUsers: function searchedUsers() {
	      this.keyboardSelectedIndex = 0;
	      this.keyboardSelected = this.searchedUsers[0];
	    },
	    searchText: function searchText() {
	      this.$emit('searchText', this.searchText);
	    },
	    allDataLoaded: function allDataLoaded() {
	      this.sortselectedItems();
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders(val) {
	      if (!val && this.newUserCalendarId) {
	        console.log('this.newUserCalendarId', this.newUserCalendarId);
	      }
	    },
	    itemsSelected: function itemsSelected(val) {
	      var preSelectedIds = val.map(function (calendar) {
	        return calendar.id;
	      });
	      var selectedItems = this.selectedItems.map(function (cal) {
	        return cal.id;
	      });
	      if (preSelectedIds.sort().join(',') === selectedItems.sort().join(',')) {} else {
	        this.selectedItems = this.itemsSelected;
	      }
	    }
	  },
	  filters: {
	    localeTime: function localeTime(eventTime) {
	      return (0, _moment2.default)(eventTime).format('LT');
	    }
	  },
	  methods: {
	    onClickAway: function onClickAway() {
	      this.close();
	      this.$emit('close');
	    },
	    isInItemsThatCantBeDeleted: function isInItemsThatCantBeDeleted(selectedItem) {
	      return this.itemsThatCantBeDeleted.indexOf(selectedItem.id) > -1;
	    },
	    isReadyToDelete: function isReadyToDelete(user) {
	      if (!this.readyToDelete) {
	        return;
	      }
	      return this.readyToDelete.id === user.id;
	    },
	    scrollTokeyboardSelected: function scrollTokeyboardSelected() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        var user = document.querySelector('.isReadyForSelection');
	        var selectedOffsetTop = user.offsetTop;
	        var selectedHeight = user.getBoundingClientRect().height;
	        var totalHeight = selectedOffsetTop + selectedHeight;
	
	        var top = _this3.$refs.dropdown.scrollTop;
	        var height = _this3.$refs.dropdown.getBoundingClientRect().height;
	        var bottom = top + height;
	
	        if (totalHeight > bottom) {
	          _this3.isMouseMoved = false;
	          _this3.$refs.dropdown.scrollTop = _this3.$refs.dropdown.scrollTop + selectedHeight;
	        }
	
	        if (selectedOffsetTop < top) {
	          _this3.isMouseMoved = false;
	          _this3.$refs.dropdown.scrollTop = _this3.$refs.dropdown.scrollTop - selectedHeight;
	        }
	      }, 0);
	    },
	    setIsReadyForSelection: function setIsReadyForSelection(user, idx) {
	      if (!this.isMouseMoved) {
	        return;
	      }
	      this.keyboardSelected = null;
	      this.keyboardSelected = user;
	      this.keyboardSelectedIndex = idx;
	    },
	    selectWithKeyboard: function selectWithKeyboard(stroke, e) {
	      if (!this.showDropdown) {
	        this.open();
	      }
	      if (stroke === 'tab') {
	        if (this.searchText.length > 0 && this.searchedUsers.length < 1) {
	          this.createNew();
	          this.close();
	          return;
	        }
	        this.close();
	      }
	      if (stroke === 'down') {
	        if (this.keyboardSelectedIndex + 1 >= this.searchedUsers.length) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex + 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'up') {
	        if (this.keyboardSelectedIndex - 1 < 0) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex - 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'enter') {
	        if (this.keyboardSelected === null) {
	          return;
	        }
	        if (this.searchedUsers.length < 1) {
	          this.$emit('enter');
	          return;
	        }
	        this.toggleUser(this.keyboardSelected);
	      }
	    },
	    isSelectedWithKeyboard: function isSelectedWithKeyboard(user) {
	      return this.keyboardSelected && this.keyboardSelected.id === user.id;
	    },
	    deleteUserWithKeyboard: function deleteUserWithKeyboard() {
	      if (this.searchText.length > 0 || this.selectedItems.length < 1) {
	        return;
	      }
	      if (this.itemsThatCantBeDeleted.length > 0) {
	        return;
	      }
	      if (this.readyToDelete === null) {
	        this.readyToDelete = this.selectedItems[this.selectedItems.length - 1];
	      } else {
	        this.removeUser(this.selectedItems[this.selectedItems.length - 1]);
	        this.readyToDelete = null;
	      }
	    },
	    close: function close() {
	      if (!this.showDropdown) {
	        return;
	      }
	      this.showDropdown = false;
	      this.keyboardSelected = null;
	      this.keyboardSelectedIndex = 0;
	      this.readyToDelete = null;
	      this.searchText = '';
	      this.$emit('show', false);
	      this.openFromBottom = false;
	      this.maxLimit = 400;
	      this.removeKeyboardShortCuts();
	      this.isKeepOpen = false;
	    },
	    open: function open() {
	      var _this4 = this;
	
	      this.showDropdown = true;
	      this.$emit('show', true);
	      this.setFocus();
	      this.keyboardSelectedIndex = 0;
	      this.keyboardShortcut();
	      this.$nextTick(function (_) {
	        _this4.createPopper();
	      });
	    },
	    toggleUser: function toggleUser(item) {
	      if (item.tag) {
	        this.selectAllWithTag(item.name);
	        return;
	      }
	      if (this.isSelected(item)) {
	        this.removeUser(item);
	      } else {
	        if (item.isOnLesson) {
	          this.$emit('addIsOnLesson', item);
	          this.close();
	          return;
	        }
	        if (this.multiple) {
	          this.selectedItems.push(item);
	          this.$emit('add', item);
	          this.readyToDelete = null;
	          this.searchText = '';
	          this.setFocus();
	        } else {
	          this.selectedItems = [];
	          this.selectedItems.push(item);
	          this.$emit('add', item);
	        }
	        this.$emit('update', this.selectedItems);
	      }
	      if (!this.isKeepOpen) {
	        this.close();
	      }
	    },
	    createPopper: function createPopper() {
	      var source = this.$refs.d_select__items;
	      var el = this.$refs.d_select;
	      document.getElementById('djs-content-container').appendChild(source);
	      var elWidth = el.getBoundingClientRect().width;
	      source.style.width = elWidth + 'px';
	      (0, _core.createPopper)(el, source, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }]
	      });
	    },
	    selectAllWithTag: function selectAllWithTag(tag) {
	      var _this5 = this;
	
	      var usersWithTag = this.items.filter(function (item) {
	        return item.user_tags && item.user_tags.indexOf(tag) > -1;
	      });
	      usersWithTag.forEach(function (user) {
	        var idx = _this5.items.findIndex(function (x) {
	          return x.id === user.id;
	        });
	        if (!_this5.isSelected(_this5.items[idx])) {
	          _this5.selectedItems.push(_this5.items[idx]);
	        }
	      });
	      this.close();
	      this.$emit('update', this.selectedItems);
	      this.$emit('add', this.selectedItems);
	    },
	    removeUser: function removeUser(item) {
	      this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
	      this.$emit('remove', item);
	      this.$emit('update', this.selectedItems);
	      this.close();
	    },
	    removeAllUsers: function removeAllUsers() {
	      var _this6 = this;
	
	      this.selectedItems.forEach(function (item) {
	        _this6.$emit('remove', item);
	      });
	      this.selectedItems.splice(0, this.selectedItems.length);
	      this.$emit('update', this.selectedItems);
	      this.close();
	    },
	    isSelected: function isSelected(user) {
	      return this.selectedItems.indexOf(user) > -1;
	    },
	    setFocus: function setFocus() {
	      this.$refs.inputfield.focus();
	    },
	    sortselectedItems: function sortselectedItems() {
	      this.selectedItems = this.selectedItems.sort(function (a, b) {
	        var x = a.name.toLowerCase();
	        var y = b.name.toLowerCase();
	        return x < y ? -1 : x > y ? 1 : 0;
	      });
	    },
	    createNew: function createNew() {
	      this.$emit('createNew', this.searchText);
	      this.readyToReceive = true;
	      this.close();
	    },
	    loadMoreCalendars: function loadMoreCalendars() {
	      if (this.searchedUsers.length < this.maxLimit) {
	        this.maxLimit = this.maxLimit + this.addLimit;
	      }
	    },
	    handleScroll: function handleScroll(evt) {
	      var element = evt.target;
	
	      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
	        this.loadMoreCalendars();
	      }
	    },
	    getCollisionText: function getCollisionText(selectedItem) {
	      return selectedItem.v_occupation.map(function (event) {
	        return event.title;
	      });
	    },
	    showCalendar: function showCalendar(item) {
	      this.$emit('showCalendar', item);
	    },
	    keyboardShortcut: function keyboardShortcut() {
	      if (this._keyListenerOne) {
	        return;
	      }
	      var self = this;
	      this._keyListenerOne = function (e) {
	        if (e.key === 'Meta' || e.key === 'Control') {
	          e.preventDefault();
	          if (!self.isKeepOpen) {
	            self.isKeepOpen = true;
	          }
	        }
	      };
	      this._keyListenerTwo = function (e) {
	        if (e.key === 'Meta' || e.key === 'Control') {
	          e.preventDefault();
	          self.isKeepOpen = false;
	        }
	      };
	      document.addEventListener('keydown', this._keyListenerOne);
	      document.addEventListener('keyup', this._keyListenerTwo);
	    },
	    removeKeyboardShortCuts: function removeKeyboardShortCuts() {
	      document.removeEventListener('keydown', this._keyListenerOne);
	      document.removeEventListener('keyup', this._keyListenerTwo);
	      this._keyListenerOne = null;
	      this._keyListenerTwo = null;
	    }
	  },
	  mounted: function mounted() {
	    if (this.show) {
	      this.open();
	    }
	    this.selectedItems = this.itemsSelected;
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeKeyboardShortCuts();
	
	    var source = this.$refs.d_select__items;
	    if (source) {
	      source.remove();
	    }
	  }
	};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelectCals = __webpack_require__(51);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    itemsSelected: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      allDataLoaded: false,
	      tags: []
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allCalendarsInHash', 'userCalendars', 'klassCalendars', 'allUsersInCalIdHash', 'roomCalendars', 'mergeCalendars', 'otherCalendars', 'studentCalendars', 'kindergartenCalendars', 'clubCalendars']), {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    allCals: function allCals() {
	      return this.usersForSelect.concat(this.kindergartenCalendarsForSelect, this.KlassForSelect, this.roomCalsForDSelect, this.mergeCalendarsForDSelect, this.otherCalendarsForDSelect, this.clubCalendarsForDSelect, this.tagsForSelect, this.studentCalendarsForSelect);
	    },
	    studentCalendarsForSelect: function studentCalendarsForSelect() {
	      return this.studentCalendars.map(function (cal, key) {
	        cal.icon = 'icon-user';
	        return cal;
	      });
	    },
	    kindergartenCalendarsForSelect: function kindergartenCalendarsForSelect() {
	      return this.kindergartenCalendars.map(function (cal, key) {
	        cal.icon = 'icon-users5';
	        return cal;
	      });
	    },
	    usersForSelect: function usersForSelect() {
	      var _this = this;
	
	      var users = this.userCalendars.map(function (cal, key) {
	        if (_this.allUsersInCalIdHash[cal.id]) {
	          _this.$set(cal, 'user_tags', _this.allUsersInCalIdHash[cal.id].user_tags);
	          _this.$set(cal, 'default_thumb_url', _this.allUsersInCalIdHash[cal.id].default_thumb_url);
	        }
	        return cal;
	      });
	      return users;
	    },
	    KlassForSelect: function KlassForSelect() {
	      var klasses = this.klassCalendars.map(function (cal, key) {
	        cal.icon = 'icon-calendar4';
	        return cal;
	      });
	      return klasses;
	    },
	    roomCalsForDSelect: function roomCalsForDSelect() {
	      var rooms = this.roomCalendars.map(function (cal, key) {
	        cal.icon = 'icon-location';
	        return cal;
	      });
	      return rooms;
	    },
	    mergeCalendarsForDSelect: function mergeCalendarsForDSelect() {
	      var mergeCals = this.mergeCalendars.map(function (cal, key) {
	        cal.icon = 'icon-calendar-week';
	        return cal;
	      });
	      return mergeCals;
	    },
	    otherCalendarsForDSelect: function otherCalendarsForDSelect() {
	      var otherCalendars = this.otherCalendars.map(function (cal, key) {
	        cal.icon = 'icon-clipboard2';
	        return cal;
	      });
	      return otherCalendars;
	    },
	    tagsForSelect: function tagsForSelect() {
	      var tags = [];
	      var i = 0;
	      this.tags.forEach(function (tag) {
	        i++;
	        var oneTag = {
	          tag: true,
	          id: 999999999999 + i,
	          name: tag,
	          icon: 'icon-price-tag2'
	        };
	        tags.push(oneTag);
	      });
	      return tags;
	    },
	    clubCalendarsForDSelect: function clubCalendarsForDSelect() {
	      var clubCalendars = this.clubCalendars.map(function (cal, key) {
	        cal.icon = 'icon-users5';
	        return cal;
	      });
	      return clubCalendars;
	    }
	  }),
	  methods: {
	    getTags: function getTags() {
	      var _this2 = this;
	
	      _docendo2.default.schoolTags(this.school.id, function (data) {
	        _this2.tags = data;
	        _this2.allDataLoaded = true;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUsersFromSchoolId', this.school.id);
	    this.getTags();
	  }
	};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelectCals = __webpack_require__(51);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _core = __webpack_require__(18);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    calendarId: {
	      default: null
	    },
	    itemType: {
	      default: 'user'
	    },
	    preSelectedItems: {
	      default: function _default() {
	        return [];
	      }
	    },
	    itemsThatCantBeDeleted: {
	      default: function _default() {
	        return [];
	      }
	    },
	    showTags: {
	      type: Boolean,
	      default: false
	    },
	    isMultiple: {
	      type: Boolean,
	      default: true
	    },
	    showCreateButton: {
	      type: Boolean,
	      default: false
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    calendarIdsToHide: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['klassCalendars', 'userCalendars', 'roomCalendars', 'clubCalendars', 'allUsersInCalIdHash', 'locale']), {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    items: function items() {
	      var _this = this;
	
	      if (this.itemType.toLowerCase() === 'user') {
	        if (!this.showTags) {
	          return this.userCalendars.filter(function (calendar) {
	            if (!_this.calendarIdsToHide || _this.calendarIdsToHide.length === 0) {
	              return true;
	            }
	            return !_this.calendarIdsToHide.some(function (calId) {
	              return calId === calendar.id;
	            });
	          });
	        }
	        var userCalsWithTags = this.userCalendars.map(function (cal) {
	          var tags = _this.allUsersInCalIdHash[cal.id] && _this.allUsersInCalIdHash[cal.id].user_tags ? _this.allUsersInCalIdHash[cal.id].user_tags : [];
	          _this.$set(cal, 'user_tags', tags);
	          return cal;
	        });
	        this.tags.forEach(function (tag) {
	          userCalsWithTags.push(tag);
	        });
	        return userCalsWithTags;
	      }
	      if (this.itemType.toLowerCase() === 'room') {
	        return this.roomCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'club') {
	        return this.calendarId ? this.clubCalendars.filter(function (calendar) {
	          return calendar.id !== _this.calendarId;
	        }) : this.clubCalendars;
	      }
	      if (this.itemType.toLowerCase() === 'klass') {
	        return this.calendarId ? this.klassCalendars.filter(function (calendar) {
	          return calendar.id !== _this.calendarId;
	        }) : this.klassCalendars;
	      }
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    }
	  }),
	  data: function data() {
	    return {
	      isLoaded: false,
	      tags: [],
	      selectedItems: [],
	      searchText: '',
	      placement: 'bottom',
	      i18n: {
	        da: {
	          search: 'Søg og vælg'
	        },
	        en: {
	          search: 'Search and choose'
	        },
	        nb: {
	          search: 'Søk og velg'
	        }
	      },
	      newUserCalendarId: null
	    };
	  },
	
	  watch: {
	    items: function items(val, oldVal) {
	      if (val.length > 0) {
	        this.setPreSelectedItems();
	      }
	    }
	  },
	  methods: {
	    withPopper: function withPopper(dropdownList, component, _ref) {
	      var width = _ref.width;
	
	      dropdownList.style.width = width;
	      (0, _core.createPopper)(component.$refs.toggle, dropdownList, {
	        placement: this.placement,
	        modifiers: [{
	          name: 'offset', options: {
	            offset: [0, 0]
	          }
	        }, {
	          name: 'toggleClass',
	          enabled: true,
	          phase: 'write',
	          fn: function fn(_ref2) {
	            var state = _ref2.state;
	
	            component.$el.classList.toggle('openFromBottom', state.placement === 'top');
	          }
	        }]
	      });
	    },
	    add: function add(item) {},
	    remove: function remove(item) {},
	    setSelectedItems: function setSelectedItems(val) {
	      this.selectedItems = [];
	      this.selectedItems = val;
	      this.$emit('update', this.selectedItems);
	    },
	    isInSelectedItems: function isInSelectedItems(calid) {
	      return this.selectedItems.findIndex(function (item) {
	        return item && item.id === calid;
	      }) >= 0;
	    },
	    setPreSelectedItems: function setPreSelectedItems() {
	      var _this2 = this;
	
	      this.preSelectedItems.forEach(function (userCalendarId) {
	        if (userCalendarId) {
	          if (!_this2.isInSelectedItems(userCalendarId)) {
	            var idx = _this2.items.findIndex(function (item) {
	              return item.id === userCalendarId;
	            });
	            if (idx > -1) {
	              _this2.selectedItems.push(_this2.items[idx]);
	            } else {
	              console.log('cant find', userCalendarId);
	            }
	          }
	        }
	      });
	      if (!this.showTags) {
	        this.isLoaded = true;
	      }
	    },
	    getTags: function getTags() {
	      var _this3 = this;
	
	      _docendo2.default.schoolTags(this.school.id, function (data) {
	        var tags = [];
	        var i = 0;
	        data.forEach(function (tag) {
	          i++;
	          var oneTag = {
	            tag: true,
	            id: 999999999999 + i,
	            name: tag,
	            icon: 'icon-price-tag2'
	          };
	          tags.push(oneTag);
	        });
	        _this3.tags = tags;
	      });
	    },
	    createNew: function createNew(evt) {
	      var _this4 = this;
	
	      if (this.itemType === 'room') {
	        var calendars = [{ name: evt, type: this.itemType }];
	        _docendo2.default.schoolBulkCreateCalendars(window.SCHOOL.id, this.activeSchoolYear.id, calendars, function (success) {
	          console.log('success', success);
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	        return;
	      }
	      if (this.itemType === 'user') {
	        var users = [{ name: evt }];
	        _docendo2.default.schoolUsersCreate(this.school.id, users, function (success) {
	          _this4.$store.dispatch('getSchoolCalendars', _this4.school.id);
	          _this4.newUserCalendarId = success[0].user_calendar_id;
	          console.log('newUserCalendarId', _this4.newUserCalendarId);
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.showTags) {
	      this.getTags();
	    }
	    this.setPreSelectedItems();
	  }
	};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _vuex = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default },
	  props: {
	    showTags: {
	      type: Boolean,
	      default: false
	    },
	    multiple: {
	      type: Boolean,
	      default: true
	    },
	    showCreateButton: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['klassCalendars'])),
	  data: function data() {
	    return {
	      selectedKlasses: [],
	      searchText: '',
	      locale: 'da',
	      i18n: {
	        da: {
	          search: 'Søg og vælg klasse'
	        },
	        en: {
	          search: 'Search and choose class'
	        },
	        nb: {
	          search: 'Søk og velg klasse'
	        }
	      }
	    };
	  },
	
	  watch: {
	    selectedUsers: function selectedUsers() {
	      this.$emit('updated', this.selectedKlasses);
	    }
	  },
	  methods: {
	    add: function add(item) {
	      this.$emit('add', item);
	    },
	    remove: function remove(item) {
	      this.$emit('remove', item);
	    },
	    setSelectedKasses: function setSelectedKasses(val) {
	      this.selectedKlasses = val;
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.USER.language ? window.USER.language : 'da';
	  }
	};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vuex = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    user_not_found: 'Brugeren er fjernet fra skolen',
	    would_you_like_to_set: 'Vil du sætte',
	    as_a_substitute_instead_of_teacher: 'på som vikar i stedet for underviser',
	    yes: 'Ja',
	    no: 'Nej'
	  },
	  nb: {
	    user_not_found: 'Brukeren er fjernet fra skolen',
	    would_you_like_to_set: 'Vil du sette',
	    as_a_substitute_instead_of_teacher: 'som vikar istedenfor lærer',
	    yes: 'Ja',
	    no: 'Nej'
	  },
	  en: {
	    user_not_found: 'User is removed from school',
	    would_you_like_to_set: 'Would you like to set',
	    as_a_substitute_instead_of_teacher: 'as a substitute instead of a teacher',
	    yes: 'Yes',
	    no: 'No'
	  }
	};
	
	exports.default = {
	  components: { dSelect: _DSelect2.default },
	  props: {
	    eventId: {
	      type: Number
	    },
	    startTime: {
	      type: String,
	      default: '2018-06-19 07:00'
	    },
	    endTime: {
	      type: String,
	      default: '2018-06-19 14:00'
	    },
	    subs: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    user: {
	      type: Object,
	      default: function _default() {}
	    },
	    othersOnLesson: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    addClass: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  watch: {
	    eventId: function eventId() {
	      this.selectedForehand = this.subs;
	      this.getUsersSelectedForehand();
	      this.getOccupiedUsers();
	    },
	    user: function user() {
	      this.selectedForehand = this.subs;
	      this.getUsersSelectedForehand();
	      this.getOccupiedUsers();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allUsersSortedOnName', 'locale']), {
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    userNotFoundPlaceholder: function userNotFoundPlaceholder() {
	      return {
	        id: 0,
	        name: this.i18n['user_not_found'],
	        type: 'user',
	        url: '/calendar',
	        calendar_id: 0,
	        dayAbsence: [],
	        dayEvents: [],
	        dayAllEvents: [],
	        default_thumb_url: '',
	        user_tags: [],
	        occupied: false,
	        isOnLesson: false,
	        currentEventId: 0,
	        user_calendar_id: 0,
	        isErrorUser: true
	      };
	    },
	    filterAbsentUser: function filterAbsentUser() {
	      var filterUserIds = [this.user.id];
	      return this.allUsersSortedOnName.filter(function (user) {
	        return filterUserIds.indexOf(user.id) === -1;
	      });
	    },
	    usersForList: function usersForList() {
	      var _this = this;
	
	      var users = this.filterAbsentUser.map(function (obj) {
	        var occ = false;
	        var isOnLesson = false;
	        var isWithAvailability = false;
	        if (_this.occupiedUsers[obj.user_calendar_id]) {
	          occ = _this.occupiedUsers[obj.user_calendar_id];
	          isOnLesson = _this.othersOnLesson.filter(function (user) {
	            return user.user_calendar_id === obj.user_calendar_id;
	          }).length > 0;
	          isWithAvailability = occ.events.filter(function (event) {
	            return event.event_type === 'available';
	          }).length > 0;
	        }
	        var user = {
	          id: obj.id,
	          default_thumb_url: obj.default_thumb_url,
	          name: obj.name,
	          user_tags: obj.user_tags,
	          occupied: occ,
	          currentEventId: _this.eventId,
	          isOnLesson: isOnLesson,
	          isWithAvailability: isWithAvailability,
	          user_calendar_id: obj.user_calendar_id
	        };
	        return user;
	      });
	      users.push(this.userNotFoundPlaceholder);
	      return users;
	    }
	  }),
	  data: function data() {
	    return {
	      selectedUsers: [],
	      occupiedUsers: [],
	      allDataLoaded: false,
	      selfIsLoading: false,
	      subFromIsOnLesson: null
	    };
	  },
	
	  methods: {
	    getUsers: function getUsers(val) {
	      if (val) {
	        this.getOccupiedUsers();
	      }
	    },
	    addUser: function addUser(user) {
	      this.$emit('add', user);
	    },
	    removeUser: function removeUser(user) {
	      this.$emit('remove', user);
	    },
	    setSelectedUsers: function setSelectedUsers(val) {
	      this.selectedUsers = val;
	      this.$emit('updated', this.selectedUsers);
	    },
	    getUsersSelectedForehand: function getUsersSelectedForehand() {
	      var _this2 = this;
	
	      this.selectedUsers.splice(0, this.selectedUsers.length);
	
	      var _loop = function _loop(i) {
	        for (var j = 0; j < _this2.usersForList.length; j++) {
	          if (_this2.usersForList[j].id === _this2.selectedForehand[i].id) {
	            if (_this2.selectedUsers.filter(function (obj) {
	              return obj.id === _this2.selectedForehand[i].id;
	            }).length === 0) {
	              _this2.selectedUsers.push(_this2.usersForList[j]);
	            }
	          }
	        }
	      };
	
	      for (var i = 0; i < this.selectedForehand.length; i++) {
	        _loop(i);
	      }
	    },
	    getOccupiedUsers: function getOccupiedUsers() {
	      var _this3 = this;
	
	      _docendo2.default.schoolAvailabilities(window.SCHOOL.id, 'user', this.startTime, this.endTime, function (data) {
	        var toArr = JSON.parse(data);
	        var newUsers = {};
	        for (var i = 0; i < toArr.length; i++) {
	          newUsers[toArr[i].calendar_id] = toArr[i];
	        }
	        _this3.occupiedUsers = newUsers;
	        if (!_this3.allDataLoaded) {
	          _this3.getUsersSelectedForehand();
	        }
	        _this3.allDataLoaded = true;
	        _this3.selfIsLoading = false;
	      });
	    },
	    addedIsOnLesson: function addedIsOnLesson(sub) {
	      this.subFromIsOnLesson = sub;
	    },
	    setSubFromIsOnLesson: function setSubFromIsOnLesson() {
	      var _this4 = this;
	
	      for (var j = 0; j < this.usersForList.length; j++) {
	        if (this.usersForList[j].id === this.subFromIsOnLesson.id) {
	          this.selectedUsers.push(this.usersForList[j]);
	        }
	      }
	      _docendo2.default.eventAddSubstitute(this.eventId, this.subFromIsOnLesson.id, this.user.id, function (data) {
	        _this4.subFromIsOnLesson = null;
	        _this4.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this4.$emit('addedSubFromTeachers');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.selectedForehand = this.subs;
	    if (this.selectedForehand.length > 0) {
	      this.getOccupiedUsers();
	    }
	  }
	};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    user_not_found: 'Brugeren er fjernet fra skolen',
	    would_you_like_to_set: 'Vil du sætte',
	    as_a_substitute_instead_of_teacher: 'på som vikar i stedet for underviser',
	    yes: 'Ja',
	    no: 'Nej',
	    working_hours: 'Arbejdstid',
	    also_assigned: 'Også tilknyttet'
	  },
	  nb: {
	    user_not_found: 'Brukeren er fjernet fra skolen',
	    would_you_like_to_set: 'Vil du sette',
	    as_a_substitute_instead_of_teacher: 'som vikar istedenfor lærer',
	    yes: 'Ja',
	    no: 'Nej',
	    working_hours: 'Arbeidstid',
	    also_assigned: 'Også tilknyttet'
	  },
	  en: {
	    user_not_found: 'User is removed from school',
	    would_you_like_to_set: 'Would you like to set',
	    as_a_substitute_instead_of_teacher: 'as a substitute instead of a teacher',
	    yes: 'Yes',
	    no: 'No',
	    working_hours: 'Working hours',
	    also_assigned: 'Also assigned'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { spinner: _Spinner2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    isLoading: {
	      default: false,
	      type: Boolean
	    },
	    show: {
	      default: false,
	      type: Boolean
	    },
	    multiple: {
	      default: true,
	      type: Boolean
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    },
	    eventId: {
	      type: Number,
	      required: false
	    },
	    user: {},
	    isUpdatingUsers: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    usersThatAreSelected: function usersThatAreSelected() {
	      var _this = this;
	
	      var subIds = this.selectedUsers.map(function (user) {
	        return user.id;
	      });
	      return subIds.map(function (subID) {
	        return _this.items.find(function (user) {
	          return user.id === subID;
	        });
	      });
	    },
	    withoutSelectedItems: function withoutSelectedItems() {
	      var _this2 = this;
	
	      return this.items.filter(function (el) {
	        return _this2.selectedUsers.filter(function (secEl) {
	          return secEl.id === el.id;
	        }).length === 0;
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this3 = this;
	
	      return this.withoutSelectedItems.filter(function (user) {
	        return user.name !== '' ? user.name.match(new RegExp(_this3.searchText, 'i')) : '';
	      });
	    },
	    placeholderText: function placeholderText() {
	      var placeholder = this.placeholder.length > 0 ? this.placeholder : this.$i18n.t('vue2.dselect.placeholder');
	      return this.selectedUsers.length > 0 ? '' : placeholder;
	    }
	  },
	  data: function data() {
	    return {
	      showDropdown: false,
	      searchText: '',
	      selectedUsers: [],
	      keyboardSelected: null,
	      keyboardSelectedIndex: 0,
	      readyToDelete: null,
	      openFromBottom: false,
	      subFromIsOnLesson: null
	    };
	  },
	
	  watch: {
	    show: function show() {
	      if (!this.show) {
	        this.close();
	      }
	    },
	    searchedUsers: function searchedUsers() {
	      this.keyboardSelectedIndex = 0;
	      this.keyboardSelected = this.searchedUsers[0];
	    },
	    searchText: function searchText() {
	      this.$emit('searchText', this.searchText);
	    }
	  },
	  filters: {
	    localeTime: function localeTime(eventTime) {
	      return (0, _moment2.default)(eventTime).format('LT');
	    }
	  },
	  methods: {
	    addedIsOnLesson: function addedIsOnLesson(sub) {
	      this.subFromIsOnLesson = sub;
	    },
	    setSubFromIsOnLesson: function setSubFromIsOnLesson() {
	      var _this4 = this;
	
	      this.selectedUsers.push(this.items[this.items.indexOf(this.subFromIsOnLesson)]);
	      _docendo2.default.eventAddSubstitute(this.eventId, this.subFromIsOnLesson.id, this.user.id, function (data) {
	        _this4.subFromIsOnLesson = null;
	        _this4.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	      });
	    },
	    userOccEvents: function userOccEvents(selectedUser) {
	      var _this5 = this;
	
	      if (selectedUser.occupied && selectedUser.occupied.events.length > 0) {
	        var occEventsWithoutPresenceAndCurrentEvent = selectedUser.occupied.events.filter(function (lesson) {
	          return lesson.event_id !== _this5.eventId && lesson.event_type !== 'presence';
	        });
	        return occEventsWithoutPresenceAndCurrentEvent;
	      } else {
	        return false;
	      }
	    },
	    checkHeight: function checkHeight() {
	      var bcr = this.$el.getBoundingClientRect();
	      var pxFromTop = bcr.top;
	      var pxFromBottom = window.innerHeight - (bcr.top + bcr.height);
	      if (pxFromBottom < 330 && pxFromTop > 330) {
	        this.openFromBottom = true;
	      }
	    },
	    isReadyToDelete: function isReadyToDelete(user) {
	      if (!this.readyToDelete) {
	        return;
	      }
	      return this.readyToDelete.id === user.id;
	    },
	    scrollTokeyboardSelected: function scrollTokeyboardSelected() {
	      var _this6 = this;
	
	      setTimeout(function () {
	        var user = document.querySelector('.isReadyForSelection');
	        var selectedOffsetTop = user.offsetTop;
	        var selectedHeight = user.getBoundingClientRect().height;
	        var totalHeight = selectedOffsetTop + selectedHeight;
	
	        var top = _this6.$refs.dropdown.scrollTop;
	        var height = _this6.$refs.dropdown.getBoundingClientRect().height;
	        var bottom = top + height;
	
	        if (totalHeight > bottom) {
	          _this6.$refs.dropdown.scrollTop = _this6.$refs.dropdown.scrollTop + selectedHeight;
	        }
	
	        if (selectedOffsetTop < top) {
	          _this6.$refs.dropdown.scrollTop = _this6.$refs.dropdown.scrollTop - selectedHeight;
	        }
	      }, 0);
	    },
	    setIsReadyForSelection: function setIsReadyForSelection(user, idx) {
	      this.keyboardSelected = null;
	      this.keyboardSelected = user;
	      this.keyboardSelectedIndex = idx;
	    },
	    selectWithKeyboard: function selectWithKeyboard(stroke, e) {
	      if (!this.showDropdown) {
	        this.open();
	      }
	      if (stroke === 'down') {
	        if (this.keyboardSelectedIndex + 1 >= this.searchedUsers.length) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex + 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'up') {
	        if (this.keyboardSelectedIndex - 1 < 0) {
	          return;
	        }
	        this.keyboardSelectedIndex = this.keyboardSelectedIndex - 1;
	        this.keyboardSelected = this.searchedUsers[this.keyboardSelectedIndex];
	        this.scrollTokeyboardSelected();
	      }
	      if (stroke === 'enter') {
	        if (this.keyboardSelected === null) {
	          return;
	        }
	        if (this.searchedUsers.length < 1) {
	          this.$emit('enter');
	          return;
	        }
	        this.toggleUser(this.keyboardSelected);
	      }
	    },
	    isSelectedWithKeyboard: function isSelectedWithKeyboard(user) {
	      return this.keyboardSelected && this.keyboardSelected.id === user.id;
	    },
	    deleteUserWithKeyboard: function deleteUserWithKeyboard() {
	      if (this.searchText.length > 0 || this.selectedUsers.length < 1) {
	        return;
	      }
	      if (this.readyToDelete === null) {
	        this.readyToDelete = this.selectedUsers[this.selectedUsers.length - 1];
	      } else {
	        this.removeUser(this.selectedUsers[this.selectedUsers.length - 1]);
	        this.readyToDelete = null;
	      }
	    },
	    close: function close() {
	      this.$emit('close');
	      if (!this.showDropdown) {
	        return;
	      }
	      this.showDropdown = false;
	      this.keyboardSelected = null;
	      this.keyboardSelectedIndex = 0;
	      this.readyToDelete = null;
	      this.searchText = '';
	      this.$emit('show', false);
	      this.openFromBottom = false;
	    },
	    open: function open() {
	      this.checkHeight();
	      this.showDropdown = true;
	      this.$emit('show', true);
	      this.setFocus();
	      this.keyboardSelectedIndex = 0;
	    },
	    toggleUser: function toggleUser(item) {
	      if (item.tag) {
	        this.selectAllWithTag(item.name);
	        return;
	      }
	      if (this.isSelected(item)) {
	        this.removeUser(item);
	      } else {
	        if (item.isOnLesson) {
	          this.addedIsOnLesson(item);
	          this.close();
	          return;
	        }
	        if (this.multiple) {
	          this.selectedUsers.push(item);
	          this.$emit('add', item);
	        } else {
	          this.selectedUsers = [];
	          this.selectedUsers.push(item);
	          this.$emit('add', item);
	        }
	        this.$emit('update', this.selectedUsers);
	      }
	      this.close();
	    },
	    selectAllWithTag: function selectAllWithTag(tag) {
	      var _this7 = this;
	
	      var usersWithTag = this.items.filter(function (item) {
	        return item.user_tags && item.user_tags.indexOf(tag) > -1;
	      });
	      usersWithTag.forEach(function (user) {
	        var idx = _this7.items.findIndex(function (x) {
	          return x.id === user.id;
	        });
	        if (!_this7.isSelected(_this7.items[idx])) {
	          _this7.selectedUsers.push(_this7.items[idx]);
	        }
	      });
	      this.close();
	      this.$emit('update', this.selectedUsers);
	    },
	    removeUser: function removeUser(item) {
	      this.selectedUsers.splice(this.selectedUsers.indexOf(item), 1);
	      this.$emit('remove', item);
	      this.$emit('update', this.selectedUsers);
	      this.close();
	    },
	    isSelected: function isSelected(user) {
	      return this.selectedUsers.indexOf(user) > -1;
	    },
	    setFocus: function setFocus() {
	      this.$refs.inputfield.focus();
	    }
	  },
	  mounted: function mounted() {
	    if (this.show) {
	      this.open();
	    }
	    this.selectedUsers = this.itemsSelected;
	  }
	};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelectCals = __webpack_require__(51);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    showTags: {
	      type: Boolean,
	      default: false
	    },
	    multiple: {
	      type: Boolean,
	      default: true
	    },
	    showCreateButton: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName']), {
	    isLoading: function isLoading() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    schoolId: function schoolId() {
	      return window.SCHOOL.id;
	    },
	    getSelectedUsersIds: function getSelectedUsersIds() {
	      return this.selectedUsers.map(function (user) {
	        return user.id;
	      });
	    },
	    tagsForSelect: function tagsForSelect() {
	      var tags = [];
	      var i = 0;
	      this.tags.forEach(function (tag) {
	        i++;
	        var oneTag = {
	          tag: true,
	          id: 999999999999 + i,
	          name: tag,
	          icon: 'icon-price-tag2'
	        };
	        tags.push(oneTag);
	      });
	      return tags;
	    },
	    usersAndTags: function usersAndTags() {
	      var items = [].concat((0, _toConsumableArray3.default)(this.usersSortedOnName));
	      if (this.showTags) {
	        this.tagsForSelect.forEach(function (obj) {
	          items.push(obj);
	        });
	      }
	      return items;
	    }
	  }),
	  data: function data() {
	    return {
	      selectedUsers: [],
	      searchText: '',
	      tags: [],
	      showDropDown: false,
	      allDataLoaded: false,
	      getOnce: true
	    };
	  },
	
	  watch: {
	    schoolId: function schoolId() {
	      this.$store.dispatch('getUsers', this.schoolId);
	      this.getTags();
	    },
	    isLoading: function isLoading() {
	      if (this.usersSortedOnName.length > 0 && this.getOnce) {
	        this.getUsersFromRORInput();
	      } else {
	        this.setNewlyCreatedUser();
	      }
	    },
	    selectedUsers: function selectedUsers() {
	      this.setUsersOnRORInput();
	      this.$emit('usersUpdated', this.selectedUsers);
	    }
	  },
	  methods: {
	    addUser: function addUser(user) {
	      this.$emit('add', user);
	    },
	    removeUser: function removeUser(user) {
	      this.$emit('remove', user);
	    },
	    setShow: function setShow(val) {
	      this.showDropDown = val;
	    },
	    setSelectedUsers: function setSelectedUsers(val) {
	      this.selectedUsers = val;
	      this.$emit('update', this.selectedUsers);
	    },
	    setCreateUserText: function setCreateUserText(val) {
	      this.searchText = val;
	    },
	    createCalendarOnDSelect: function createCalendarOnDSelect() {
	      this.showDropDown = false;
	
	      window.dispatchEvent(new window.CustomEvent('vueCreateUser', { detail: this.searchText }));
	    },
	    setNewlyCreatedUser: function setNewlyCreatedUser() {
	      for (var j = 0; j < this.usersSortedOnName.length; j++) {
	        if (this.usersSortedOnName[j].id === Number(_eventbus2.default.createdId)) {
	          this.selectedUsers.push(this.usersSortedOnName[j]);
	        }
	      }
	    },
	    getUsersFromRORInput: function getUsersFromRORInput() {
	      if (document.getElementById('subject_stringy_user_ids') === null || document.getElementById('subject_stringy_user_ids').value.length < 1) {
	        return;
	      }
	      var ids = document.getElementById('subject_stringy_user_ids').value;
	      var idsArr = ids.split(',');
	      for (var i = 0; i < idsArr.length; i++) {
	        for (var j = 0; j < this.usersSortedOnName.length; j++) {
	          if (this.usersSortedOnName[j].id === Number(idsArr[i])) {
	            this.selectedUsers.push(this.usersSortedOnName[j]);
	          }
	        }
	      }
	      this.getOnce = false;
	    },
	    setUsersOnRORInput: function setUsersOnRORInput() {
	      if (document.getElementById('subject_stringy_user_ids') === null) {
	        return;
	      }
	      document.getElementById('subject_stringy_user_ids').value = this.getSelectedUsersIds;
	    },
	    getTags: function getTags() {
	      var _this = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this.tags = data;
	        _this.allDataLoaded = true;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUsers', this.schoolId);
	    if (this.showTags) {
	      this.getTags();
	    }
	  }
	};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CustomEvent = __webpack_require__(138);
	
	var _CustomEvent2 = _interopRequireDefault(_CustomEvent);
	
	var _DropUp = __webpack_require__(351);
	
	var _DropUp2 = _interopRequireDefault(_DropUp);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { dropup: _DropUp2.default, ModalConfirmation: _ModalConfirmation2.default },
	  name: 'delete-day-or-week',
	  props: {
	    calendar: {},
	    date: {
	      default: null
	    },
	    internaldate: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    currentdate: {
	      type: String,
	      default: function _default() {
	        return '';
	      }
	    }
	  },
	  computed: {
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    },
	    weekDaysLocale: function weekDaysLocale() {
	      var arr = [];
	
	      var start = this.firstDayOfTheWeek - 1;
	      for (var i = 0; i < 7; i++) {
	        start++;
	        arr.push(start);
	      }
	      return arr.reverse();
	    }
	  },
	  data: function data() {
	    return {
	      showDropUp: false,
	      isConfirmDeletion: false,
	      _currentDate: this.currentdate,
	      _internalDate: this.internaldate,
	      isDeleteWeek: false,
	      theDeleteText: '',
	      theDeleteFromDate: (0, _moment2.default)(),
	      theDeleteToDate: (0, _moment2.default)()
	    };
	  },
	
	  methods: {
	    setIsConfirmDeletion: function setIsConfirmDeletion(day) {
	      if (day === 'week') {
	        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + this.$t('vue.deleteday.whole_week');
	        this.isDeleteWeek = true;
	      } else {
	        this.theDeleteText = this.$t('vue2.common.delete') + ' ' + this.formattedDate(day);
	        this.theDeleteFromDate = (0, _moment2.default)(this._internalDate).clone().day(day).startOf('day');
	        this.theDeleteToDate = (0, _moment2.default)(this._internalDate).clone().day(day).endOf('day');
	      }
	      this.isConfirmDeletion = true;
	      this.showDropUp = false;
	    },
	    closeIsConfirmDelete: function closeIsConfirmDelete() {
	      this.isConfirmDeletion = false;
	      this.isDeleteWeek = false;
	      this.theDeleteFromDate = (0, _moment2.default)(this._internalDate).clone().day(1).startOf('day');
	      this.theDeleteToDate = (0, _moment2.default)(this._internalDate).clone().day(1).endOf('day');
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.isDeleteWeek) {
	        this.deleteWeek();
	      } else {
	        this.deleteDay();
	      }
	      this.closeIsConfirmDelete();
	    },
	    dropUp: function dropUp() {
	      this.showDropUp = true;
	      if (this.date) {
	        this._internalDate = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      } else {
	        this._currentDate = document.querySelector('.calendar').getAttribute('data-current_date');
	        this._internalDate = (0, _moment2.default)(this._currentDate, 'YYYY-MM-DD');
	      }
	    },
	    formattedDate: function formattedDate(day) {
	      return this.internaldate.clone().day(day).format('dddd');
	    },
	    deleteDay: function deleteDay() {
	      var mFrom = (0, _moment2.default)(this.theDeleteFromDate).toDate();
	      var mTo = (0, _moment2.default)(this.theDeleteToDate).toDate();
	      if ((0, _moment2.default)(mFrom).isValid() && (0, _moment2.default)(mTo).isValid()) {
	        _docendo2.default.deleteEventsRange(this.calendar, this.theDeleteFromDate.toISOString(), this.theDeleteToDate.toISOString(), this.deleted);
	      } else {
	        _eventbus2.default.toast = { text: this.$t('vue2.delete_day_or_week.cant_delete'), success: false };
	      }
	      this.showDropUp = false;
	    },
	    deleteWeek: function deleteWeek() {
	      var from = this.theDeleteFromDate = (0, _moment2.default)(this._internalDate).clone().day(this.weekDaysLocale[this.weekDaysLocale.length - 1]);
	      var to = this.theDeleteToDate = (0, _moment2.default)(this._internalDate).clone().day(this.weekDaysLocale[0]).endOf('day');
	      _docendo2.default.deleteEventsRange(this.calendar, from.toISOString(), to.toISOString(), this.deleted);
	      this.showDropUp = false;
	    },
	    deleted: function deleted() {
	      this.$emit('update');
	
	      var event = new window.CustomEvent('UpdateCalendarEvents', { bubbles: true, cancelable: true });
	      window.document.dispatchEvent(event);
	    }
	  }
	};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _vueClickaway = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    substitutes: 'Vikarer',
	    select_filters: 'Vælg filtre',
	    selected: 'valgt',
	    clear_all: 'Ryd alle',
	    filter_by_criteria: 'Vis alle der opfylder ét eller flere af følgende kriterier',
	    filter_by_group: 'Eller er med i en eller flere af disse grupper',
	    groups: 'Grupper',
	    sub_events_available: 'Har rådighedstimer',
	    sub_events_two_in_some_class: 'Er to eller flere samtidig i en klasse'
	  },
	  en: {
	    substitutes: 'Substitutes',
	    select_filters: 'Select filters',
	    selected: 'selected',
	    clear_all: 'Clear all',
	    filter_by_criteria: 'Show all that meet one or more of the following criteria',
	    filter_by_group: 'Or belong to one or more of these groups',
	    groups: 'Groups',
	    sub_events_available: 'Has available hours',
	    sub_events_two_in_some_class: 'Two or more are in a class at the same time'
	  },
	  nb: {
	    substitutes: 'Vikarer',
	    select_filters: 'Velg filtre',
	    selected: 'valgt',
	    clear_all: 'Fjern alle',
	    filter_by_criteria: 'Vis alle som oppfyller ett eller flere av følgende kriterier',
	    filter_by_group: 'Eller er med i en eller flere av disse gruppene',
	    groups: 'Grupper',
	    sub_events_available: 'Har tilgjengelige timer',
	    sub_events_two_in_some_class: 'To eller flere er samtidig i en klasse'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DoFiltersFilter: _DoFiltersFilter2.default, DDropdown: _DDropdown2.default },
	  props: {
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      } },
	    selectedQuickFilters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    theSelectedSorting: {
	      type: String,
	      default: 'name'
	    }
	  },
	  data: function data() {
	    return {
	      isShowDropdown: false,
	      quickFilters: [{ value: 'sub_events_available', titleKey: 'sub_events_available' }, { value: 'sub_events_two_in_some_class', titleKey: 'sub_events_two_in_some_class' }]
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['en'];
	    },
	    allSelectedFiltersLength: function allSelectedFiltersLength() {
	      var quickFilters = (0, _keys2.default)(this.selectedQuickFilters);
	      return quickFilters.length + this.selectedTags.length;
	    }
	  },
	  methods: {
	    getIsQuickFilterSelected: function getIsQuickFilterSelected(quickFilter) {
	      return this.selectedQuickFilters.find(function (selectedQuickFilter) {
	        return selectedQuickFilter === quickFilter.value;
	      });
	    },
	    onClickOutside: function onClickOutside() {
	      this.isShowDropdown = false;
	    }
	  }
	};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    select_filters: 'Vælg filtre',
	    selected: 'valgt',
	    clear_all: 'Ryd alle',
	    search_placeholder: 'Søg',
	    no_results: 'Ingen resultater'
	  },
	  en: {
	    select_filters: 'Select filters',
	    selected: 'selected',
	    clear_all: 'Clear all',
	    search_placeholder: 'Search',
	    no_results: 'No results'
	  },
	  nb: {
	    select_filters: 'Velg filtre',
	    selected: 'valgt',
	    clear_all: 'Fjern alle',
	    search_placeholder: 'Søk',
	    no_results: 'Ingen resultater'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    title: {
	      type: String,
	      default: 'Filtre'
	    },
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      } },
	    numberOfSelectedTagsToShow: {
	      type: Number,
	      default: 3
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        setTimeout(function () {
	          el.focus();
	        }, 0);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      query: ''
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N['en'];
	    },
	    sortedTags: function sortedTags() {
	      var _this = this;
	
	      return this.tags.sort(function (a, b) {
	        return a.localeCompare(b, _this.locale);
	      });
	    },
	    filteredTags: function filteredTags() {
	      var _this2 = this;
	
	      return this.sortedTags.filter(function (tag) {
	        return tag.toLowerCase().includes(_this2.query.toLowerCase());
	      });
	    }
	  },
	  methods: {
	    onCloseDropdown: function onCloseDropdown() {
	      this.query = '';
	    },
	    clearAll: function clearAll() {
	      this.$emit('clear');
	    },
	    select: function select(tag) {
	      this.$emit('select', tag);
	    },
	    getIsItemSelected: function getIsItemSelected(tag) {
	      return this.selectedTags.includes(tag);
	    }
	  }
	};

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    }
	  }
	};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocendoConnnectionIndicator',
	  created: function created() {
	    _docendo2.default.subscribeConnected(this.connected);
	    _docendo2.default.subscribeDisconnected(this.disconnected);
	  },
	  methods: {
	    connected: function connected() {
	      this.is_connected = true;
	    },
	    disconnected: function disconnected() {
	      this.is_connected = false;
	    }
	  },
	  data: function data() {
	    return {
	      is_connected: true
	    };
	  }
	};

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    navigate: function navigate(direction) {
	      if (direction === 'previous') {
	        this.$emit('prev');
	      } else if (direction === 'next') {
	        this.$emit('next');
	      }
	    },
	    goToToday: function goToToday() {
	      this.$emit('today');
	    }
	  }
	};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CreateEventForm = __webpack_require__(1253);
	
	var _CreateEventForm2 = _interopRequireDefault(_CreateEventForm);
	
	var _CreateEventNewSubject = __webpack_require__(1254);
	
	var _CreateEventNewSubject2 = _interopRequireDefault(_CreateEventNewSubject);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default, CreateTaskNewSubject: _CreateEventNewSubject2.default, CreateTaskForm: _CreateEventForm2.default },
	  props: {
	    user: {
	      type: Object,
	      default: null
	    },
	    initDate: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    initSubject: {
	      type: Object,
	      default: null
	    },
	    emitEvent: {
	      type: Boolean,
	      default: false
	    },
	    editEvent: {
	      type: Object,
	      default: null
	    },
	    openingHours: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      theCreateNewSubjectName: null,
	      theNewlyCreatedSubject: null,
	      theDeleteEvent: null,
	      isDeleting: false
	    };
	  },
	
	  methods: {
	    deleteEvent: function deleteEvent() {
	      var _this = this;
	
	      this.isDeleting = true;
	      var schoolId = this.theDeleteEvent.school_id;
	      var eventId = this.theDeleteEvent.event_id;
	      _docendo2.default.deleteEvent(schoolId, eventId, function (success) {
	        _this.onCloseConfirmation();
	        _this.$emit('deletedEvent', success);
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    onCloseConfirmation: function onCloseConfirmation() {
	      this.onDeleteEvent(null);
	    },
	    onDeleteEvent: function onDeleteEvent(lesson) {
	      this.theDeleteEvent = lesson;
	    },
	    onCreatedEvent: function onCreatedEvent(lesson) {
	      var initDate = this.initDate;
	
	      var eventStart = lesson.start;
	      var eventEnd = lesson.end;
	
	      var initDateMoment = (0, _moment2.default)(initDate);
	      var eventStartMoment = (0, _moment2.default)(eventStart);
	      var eventEndMoment = (0, _moment2.default)(eventEnd);
	
	      var isStartDateSame = eventStartMoment.isSame(initDateMoment, 'day');
	      var isEndDateSame = eventEndMoment.isSame(initDateMoment, 'day');
	      if (this.emitEvent) {
	        this.$emit('addANewEvent', lesson);
	        return;
	      }
	      if (isStartDateSame && isEndDateSame) {
	        this.$store.commit('addANewEvent', lesson);
	      }
	    },
	    setDate: function setDate(mom) {
	      this.date = mom;
	    },
	    setCreateNewSubject: function setCreateNewSubject(str) {
	      this.theCreateNewSubjectName = str;
	    },
	    onNewSubject: function onNewSubject(subject) {
	      this.theNewlyCreatedSubject = subject;
	      this.setCreateNewSubject(null);
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.editEvent) {
	      this.date = (0, _moment2.default)(this.editEvent.start);
	      return;
	    }
	    this.date = this.initDate;
	  }
	};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(38);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _Tabslist = __webpack_require__(133);
	
	var _Tabslist2 = _interopRequireDefault(_Tabslist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Tabslist: _Tabslist2.default, dSelect: _DSelect2.default, DModal: _DModal2.default, TimeChanger: _TimeChanger2.default, DateSelector: _DateSelector2.default },
	  props: {
	    user: {
	      type: Object,
	      default: function _default() {
	        return {
	          name: 'Henrik',
	          user_calendar_id: 7
	        };
	      }
	    },
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    initSubject: {
	      type: Object,
	      default: null
	    },
	    theNewlyCreatedSubject: {
	      type: Object,
	      default: null
	    },
	    editEvent: {
	      type: Object,
	      default: null
	    },
	    openingHours: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingSubject: false,
	      subjects: [],
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      selectedSubject: null,
	      isSubmitting: false,
	      theSearchText: '',
	      theNewSubject: null,
	      isShowCreateSubjectButton: false,
	      tabs: ['Med børn', 'Uden Børn', 'Fravær'],
	      activeTab: 'Med børn'
	    };
	  },
	
	  computed: {
	    isWithKids: function isWithKids() {
	      return this.activeTab === 'Med børn';
	    },
	    isValidated: function isValidated() {
	      return this.selectedSubject;
	    },
	    filteredSubjects: function filteredSubjects() {
	      return this.subjects.filter(function (subject) {
	        return subject.subject_type !== 'absence';
	      });
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this = this;
	
	      return this.filteredSubjects.map(function (subject) {
	        var translatedSubjectType = _this.$t('vue2.eventTypes.' + subject.subject_type);
	
	        var vSubjectType = translatedSubjectType === 'vue2.eventTypes.' + subject.subject_type ? subject.subject_type : translatedSubjectType;
	
	        return (0, _extends3.default)({}, subject, {
	          vSubjectType: vSubjectType
	        });
	      }).sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  },
	  watch: {
	    theNewlyCreatedSubject: function theNewlyCreatedSubject(val) {
	      this.readSubjects();
	    }
	  },
	  methods: {
	    selectTab: function selectTab(tab) {
	      this.activeTab = tab;
	    },
	    setDate: function setDate(date) {
	      this.$emit('setDate', date);
	    },
	    onCloseDSelect: function onCloseDSelect() {
	      this.isShowCreateSubjectButton = false;
	    },
	    setIsShowCreateSubjectButton: function setIsShowCreateSubjectButton() {
	      var _this2 = this;
	
	      var idx = this.filteredSubjects.findIndex(function (subject) {
	        return subject.name === _this2.theSearchText;
	      });
	      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateSubjectButton();
	    },
	    onCreateNewSubject: function onCreateNewSubject() {
	      this.$emit('createNewSubject', this.theSearchText);
	      this.theSearchText = '';
	    },
	    setTheSearchText: function setTheSearchText(str) {
	      this.theSearchText = str;
	    },
	    setSubject: function setSubject(arr) {
	      this.selectedSubject = arr[0];
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    readSubjects: function readSubjects() {
	      var _this3 = this;
	
	      this.isLoadingSubject = true;
	      _docendo2.default.sidebar(this.user.user_calendar_id, this.date, function (success) {
	        _this3.isLoadingSubject = false;
	        _this3.subjects = success;
	        _this3.$nextTick(function (_) {
	          if (_this3.theNewlyCreatedSubject) {
	            _this3.theNewSubject = _this3.theNewlyCreatedSubject;
	          }
	        });
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    },
	    onDelete: function onDelete() {
	      this.$emit('deleteEvent', this.editEvent);
	    },
	    onSubmitEditEvent: function onSubmitEditEvent() {
	      var _this4 = this;
	
	      this.isSubmitting = true;
	      var schoolId = this.editEvent.school_id;
	      var updates = [{ event_id: this.editEvent.event_id, start_time: this.dbEventStart, end_time: this.dbEventEnd }];
	      _docendo2.default.updateEvents(schoolId, updates, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          _this4.$emit('close');
	          return;
	        }
	        _this4.isSubmitting = false;
	        var deletedEventId = data.id;
	
	        _this4.$emit('updatedEvent', deletedEventId);
	        _eventbus2.default.toast = { text: _this4.$t('vue2.create_activity.created'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    submit: function submit() {
	      var _this5 = this;
	
	      var schoolId = this.selectedSubject.school_id;
	      var calendarId = this.selectedSubject.calendar_id;
	      var calendarIds = [calendarId].concat((0, _toConsumableArray3.default)(this.selectedSubject.cals.map(function (calendar) {
	        return calendar.id;
	      })));
	      var subjectId = this.selectedSubject.id;
	      var internalNote = '';
	      this.isSubmitting = true;
	      _docendo2.default.createEvent(schoolId, calendarId, calendarIds, subjectId, this.dbEventStart, this.dbEventEnd, '', '', '', internalNote, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          _this5.$emit('close');
	          return;
	        }
	        var lesson = JSON.parse(data);
	        _this5.$emit('onCreatedEvent', lesson);
	        _this5.$emit('close');
	        _eventbus2.default.toast = { text: _this5.$t('vue2.create_activity.created'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    setTimeout(function (_) {
	      var el = document.querySelector('.time-changer__group > .flex.align-center > div:first-child > .d-time-change-input');
	      if (el) {
	        el.select();
	      }
	    }, 0);
	    if (!this.editEvent && this.openingHours) {
	      var openingHoursObj = this.openingHours;
	      var dateDayNum = (0, _moment2.default)(this.date).isoWeekday();
	      var data = openingHoursObj[dateDayNum];
	      if (data) {
	        var openHoursAndMinute = data['open'];
	        var _openHoursAndMinute$s = openHoursAndMinute.split(':'),
	            _openHoursAndMinute$s2 = (0, _slicedToArray3.default)(_openHoursAndMinute$s, 2),
	            hour = _openHoursAndMinute$s2[0],
	            minute = _openHoursAndMinute$s2[1];
	
	        if (openHoursAndMinute) {
	          this.startTime = (0, _moment2.default)().set({ 'hour': hour, 'minutes': minute });
	        }
	        var closeHoursAndMinute = data['close'];
	        var _closeHoursAndMinute$ = closeHoursAndMinute.split(':'),
	            _closeHoursAndMinute$2 = (0, _slicedToArray3.default)(_closeHoursAndMinute$, 2),
	            closeHour = _closeHoursAndMinute$2[0],
	            closeMinute = _closeHoursAndMinute$2[1];
	
	        if (closeHoursAndMinute) {
	          this.endTime = (0, _moment2.default)().set({ 'hour': closeHour, 'minutes': closeMinute });
	        }
	      }
	    }
	    if (this.editEvent) {
	      var startHour = (0, _moment2.default)(this.editEvent.start).format('HH');
	      var startMinute = (0, _moment2.default)(this.editEvent.start).format('mm');
	      this.startTime = (0, _moment2.default)().set({ 'hour': startHour, 'minutes': startMinute });
	      var endHour = (0, _moment2.default)(this.editEvent.end).format('HH');
	      var endMinute = (0, _moment2.default)(this.editEvent.end).format('mm');
	      this.endTime = (0, _moment2.default)().set({ 'hour': endHour, 'minutes': endMinute });
	      return;
	    }
	    if (this.initSubject) {
	      this.selectedSubject = this.initSubject;
	    }
	    this.readSubjects();
	  }
	};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubjectFormSubjectType = __webpack_require__(71);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SubjectFormSubjectType: _SubjectFormSubjectType2.default, dSelect: _DSelect2.default, DModal: _DModal2.default },
	  props: {
	    title: {
	      type: String
	    },
	    user: {
	      type: Object,
	      default: function _default() {
	        return {
	          name: 'Henrik',
	          user_calendar_id: 7
	        };
	      }
	    },
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      subjectName: '',
	      subjectType: '',
	      isSubmitting: false,
	      theActiveSchoolId: null,
	      userSchools: [],
	      isLoadingUserSchools: false
	    };
	  },
	
	  computed: {
	    isValidated: function isValidated() {
	      return this.subjectName.length > 0;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    isUserHasMultipleSchools: function isUserHasMultipleSchools() {
	      return (0, _keys2.default)(this.userSchools).length > 1;
	    }
	  },
	  methods: {
	    setSubjectType: function setSubjectType(str) {
	      this.subjectType = str;
	    },
	    findSchoolYearId: function findSchoolYearId() {
	      if (this.activeSchoolYears.length === 1) {
	        return this.activeSchoolYears[0].id;
	      }
	      var givenDate = (0, _moment2.default)(this.date);
	
	      var overlappingSchoolYears = this.activeSchoolYears.filter(function (year) {
	        var start = (0, _moment2.default)(year.employee_time_start);
	        var end = (0, _moment2.default)(year.employee_time_end);
	        return givenDate.isBetween(start, end, undefined, '[]');
	      });
	
	      if (overlappingSchoolYears.length > 0) {
	        var latestSchoolYear = overlappingSchoolYears.reduce(function (latest, current) {
	          var latestEnd = (0, _moment2.default)(latest.employee_time_end);
	          var currentEnd = (0, _moment2.default)(current.employee_time_end);
	          return currentEnd.isAfter(latestEnd) ? current : latest;
	        }, overlappingSchoolYears[0]);
	
	        return latestSchoolYear.id;
	      } else {
	        _eventbus2.default.toast = { text: this.$t('vue2.create_activity.the_selected_date_is_outside_schoolyears'), 'success': false };
	        return null;
	      }
	    },
	    submit: function submit() {
	      var _this = this;
	
	      var calendarId = this.user.user_calendar_id;
	      var schoolYearId = this.findSchoolYearId();
	      if (!schoolYearId) {
	        return;
	      }
	      var schoolId = this.theActiveSchoolId;
	      var color = '#999999';
	      var duration = 45;
	      var preparation = null;
	      var calendarIds = [];
	      var subjectCode = null;
	      this.isSubmitting = true;
	      _docendo2.default.createSubject(this.subjectName, color, calendarId, duration, preparation, 0, this.subjectType, schoolId, schoolYearId, calendarIds, subjectCode, false, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          return;
	        }
	        _this.$emit('newSubject', data);
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readUser: function readUser() {
	      var _this2 = this;
	
	      _docendo2.default.showUser(this.user.id, function (data) {
	        _this2.userSchools = data && data.schools ? data.schools.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }) : [];
	      }, function (failure) {});
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.readUser();
	    this.subjectName = this.title;
	    this.theActiveSchoolId = this.activeSchool.id;
	    this.$nextTick(function (_) {
	      var el = _this3.$refs.d_title_input;
	      if (el) {
	        _this3.$refs.d_title_input.click();
	        _this3.$refs.d_title_input.focus();
	      }
	    });
	  }
	};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DSelectCalsIds = __webpack_require__(59);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelectCalendarIds: _DSelectCalsIds2.default, dSelect: _DSelect2.default, DModal: _DModal2.default },
	  props: {
	    calendarAndUsers: {
	      type: Object,
	      default: null
	    },
	    schoolId: {
	      default: null
	    },
	    schoolYearId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isSubmitting: false,
	      userCalendarIds: []
	    };
	  },
	
	  computed: {
	    calendar: function calendar() {
	      return this.calendarAndUsers['calendar'];
	    },
	    activeUsers: function activeUsers() {
	      return this.calendarAndUsers['users'];
	    },
	    calendarIdsToHide: function calendarIdsToHide() {
	      return this.activeUsers.map(function (user) {
	        return user.user_calendar_id;
	      });
	    },
	    isValidated: function isValidated() {
	      return this.userCalendarIds.length === 1;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    }
	  },
	  methods: {
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.userCalendarIds = users.map(function (user) {
	        return user.id;
	      });
	    },
	    submit: function submit() {
	      var _this = this;
	
	      this.isSubmitting = true;
	      var calendarId = this.calendar.id;
	      var subjectName = 'Vagt';
	      var color = '#A0A5EF';
	      var defaultDuration = 420;
	      var preparation = 0;
	      var hours = 0;
	      var subjectType = 'with_kids';
	      var subjectCode = null;
	      _docendo2.default.createSubject(subjectName, color, calendarId, defaultDuration, preparation, hours, subjectType, this.schoolId, this.schoolYearId, this.userCalendarIds, subjectCode, false, function (success) {
	        console.log('oprette!', success);
	        _this.$emit('created', success);
	      }, function (failure) {
	        console.log('failure!');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.$nextTick(function (_) {
	      var el = document.querySelector('.d-select__input-look');
	      if (el) {
	        el.click();
	      }
	    });
	  }
	};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _WeekSelecter = __webpack_require__(89);
	
	var _WeekSelecter2 = _interopRequireDefault(_WeekSelecter);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DutySchedulePlan = __webpack_require__(1258);
	
	var _DutySchedulePlan2 = _interopRequireDefault(_DutySchedulePlan);
	
	var _DoSplash = __webpack_require__(350);
	
	var _DoSplash2 = _interopRequireDefault(_DoSplash);
	
	var _DutySchedulePlanCalendar = __webpack_require__(309);
	
	var _DutySchedulePlanCalendar2 = _interopRequireDefault(_DutySchedulePlanCalendar);
	
	var _CreateEvent = __webpack_require__(1252);
	
	var _CreateEvent2 = _interopRequireDefault(_CreateEvent);
	
	var _BottomNav = __webpack_require__(307);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	var _CreateSubject = __webpack_require__(1255);
	
	var _CreateSubject2 = _interopRequireDefault(_CreateSubject);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DutyScheduleOpeningHours = __webpack_require__(1257);
	
	var _DutyScheduleOpeningHours2 = _interopRequireDefault(_DutyScheduleOpeningHours);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DutyScheduleOpeningHours: _DutyScheduleOpeningHours2.default,
	    DModal: _DModal2.default,
	    CreateSubject: _CreateSubject2.default, BottomNav: _BottomNav2.default, CreateEvent: _CreateEvent2.default, DutyScheduleCalendar: _DutySchedulePlanCalendar2.default, DoSplash: _DoSplash2.default, DutySchedulePlan: _DutySchedulePlan2.default, WeekSelecter: _WeekSelecter2.default
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      events: [],
	      isEventsLoading: false,
	      theCreateEventObj: null,
	      theEditEventObj: null,
	      userNorms: null,
	      isLoadingUserNorms: false,
	      theCreateSubjectCalendar: null,
	      theNewlyCreatedSubject: null,
	      isCreateOpeningHours: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    openingHours: function openingHours() {
	      if (!this.schoolSettings || !this.schoolSettings.openingHours) {
	        return null;
	      } else {
	        return this.schoolSettings.openingHours;
	      }
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.schoolYear && this.schoolYear.id ? this.schoolYear.id : null;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    isLoadingAllUsers: function isLoadingAllUsers() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    isInitialLoading: function isInitialLoading() {
	      return this.isLoadingSchoolCalenders || this.isLoadingAllUsers || this.isSubjectsLoading;
	    },
	    kindergartenCalendars: function kindergartenCalendars() {
	      return this.$store.getters.kindergartenCalendars;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    eventsInUserCalendarIdHash: function eventsInUserCalendarIdHash() {
	      return this.events.reduce(function (eventsHash, event) {
	        var eventDate = (0, _moment2.default)(event.start).format('YYYY_MM_DD');
	        var eventTimeFormatted = (0, _moment2.default)(event.start).format('HH:mm') + ' - ' + (0, _moment2.default)(event.end).format('HH:mm');
	        var eventObj = (0, _extends3.default)({}, event, {
	          v_time: eventTimeFormatted
	        });
	        event.calendars.forEach(function (calendar) {
	          var lookUpKey = calendar.calendar_id + '_' + eventDate;
	          if (eventsHash[lookUpKey]) {
	            eventsHash[lookUpKey].push(eventObj);
	          } else {
	            eventsHash[lookUpKey] = [eventObj];
	          }
	        });
	        return eventsHash;
	      }, {});
	    }
	  },
	  watch: {
	    users: function users() {
	      this.readEvents();
	    },
	    schoolYear: function schoolYear() {
	      this.readUserNorm();
	    }
	  },
	  methods: {
	    setIsCreateOpeningHours: function setIsCreateOpeningHours(bool) {
	      this.isCreateOpeningHours = bool;
	    },
	    onNewSubjectCreated: function onNewSubjectCreated($event) {
	      this.onCreateSubject(null);
	      this.theNewlyCreatedSubject = $event;
	    },
	    onCreateSubject: function onCreateSubject(calendarAndUsers) {
	      this.theCreateSubjectCalendar = calendarAndUsers;
	    },
	    onUpdatedEvent: function onUpdatedEvent() {
	      this.onCloseCreateEvent();
	      this.readEvents();
	    },
	    onDeletedEvent: function onDeletedEvent() {
	      this.onCloseCreateEvent();
	      this.readEvents();
	    },
	    onCloseCreateEvent: function onCloseCreateEvent() {
	      this.theCreateEventObj = null;
	      this.theEditEventObj = null;
	    },
	    onAddedEvent: function onAddedEvent(event) {
	      this.theCreateEventObj = null;
	      this.readEvents();
	    },
	    onEditEvent: function onEditEvent(theEditEvent) {
	      this.theEditEventObj = theEditEvent;
	    },
	    onCreateEvent: function onCreateEvent(theEventObject) {
	      this.theCreateEventObj = theEventObject;
	    },
	    setDate: function setDate(date) {
	      this.date = date;
	      this.readEvents();
	    },
	    setToday: function setToday() {
	      this.setDate((0, _moment2.default)());
	    },
	    setPrev: function setPrev() {
	      var date = (0, _moment2.default)(this.date).subtract(1, 'week');
	      this.setDate(date);
	    },
	    setNext: function setNext() {
	      var date = (0, _moment2.default)(this.date).add(1, 'week');
	      this.setDate(date);
	    },
	    readEvents: function readEvents() {
	      var _this = this;
	
	      var calendarIds = this.users.map(function (user) {
	        return user.user_calendar_id;
	      });
	      if (calendarIds.length === 0) {
	        return;
	      }
	
	      var start = (0, _moment2.default)(this.date).isoWeekday(1).format('YYYY-MM-DD 00:00');
	      var end = (0, _moment2.default)(this.date).isoWeekday(5).endOf('day');
	      _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (data) {
	        _this.events = data.length > 0 ? JSON.parse(data) : [];
	        _this.isEventsLoading = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    readUserNorm: function readUserNorm() {
	      var _this2 = this;
	
	      if (!this.schoolYear || !this.schoolId) {
	        return;
	      }
	      this.isLoadingUserNorms = true;
	      this.userNorms = null;
	      _docendo2.default.schoolUserYearsList(this.schoolId, this.schoolYear.id, null, function (success) {
	        _this2.userNorms = success;
	        _this2.isLoadingUserNorms = false;
	      }, function (failure) {
	        console.log('failed!');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	    this.readUserNorm();
	  }
	};

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    isToday: {
	      default: false
	    }
	  },
	  computed: {
	    tooltipArrowLeft: function tooltipArrowLeft() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>←</span></p>';
	    },
	    tooltipArrowRight: function tooltipArrowRight() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>→</span></p>';
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    }
	  }
	};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    propOpeningHours: {
	      default: {
	        1: { open: '08:00', close: '22:00' },
	        2: { open: '08:00', close: '16:00' },
	        3: { open: '08:00', close: '16:00' },
	        4: { open: '08:00', close: '16:00' },
	        5: { open: '08:00', close: '16:00' },
	        6: { open: '', close: '' },
	        7: { open: '', close: '' }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      openingHours: {},
	      isSaving: false
	    };
	  },
	
	  watch: {
	    propOpeningHours: function propOpeningHours(val, oldVal) {
	      this.loadOpeningHours();
	      this.$emit('close');
	    }
	  },
	  methods: {
	    deleteDay: function deleteDay(day) {
	      this.openingHours[day]['open'] = '';
	      this.openingHours[day]['close'] = '';
	    },
	    getDayName: function getDayName(day) {
	      return (0, _moment2.default)().isoWeekday(day * 1).format('dddd');
	    },
	    formatTime: function formatTime(day, type) {
	      var time = this.openingHours[day][type];
	      if (time) {
	        this.openingHours[day][type] = (0, _moment2.default)(time, 'HH:mm').format('HH:mm');
	      }
	    },
	    saveOpeningHours: function saveOpeningHours() {
	      this.isSaving = true;
	      var openingHoursJson = this.openingHours;
	      this.$store.dispatch('updateSchoolSettings', { 'openingHours': openingHoursJson });
	    },
	    loadOpeningHours: function loadOpeningHours() {
	      var storedData = this.propOpeningHours;
	      if (storedData) {
	        this.openingHours = storedData;
	      } else {
	        this.openingHours = {
	          1: { open: '08:00', close: '22:00' },
	          2: { open: '08:00', close: '16:00' },
	          3: { open: '08:00', close: '16:00' },
	          4: { open: '08:00', close: '16:00' },
	          5: { open: '08:00', close: '16:00' },
	          6: { open: '', close: '' },
	          7: { open: '', close: '' }
	        };
	      }
	    }
	  },
	  created: function created() {
	    this.loadOpeningHours();
	  }
	};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DutySchedulePlanCalendar = __webpack_require__(309);
	
	var _DutySchedulePlanCalendar2 = _interopRequireDefault(_DutySchedulePlanCalendar);
	
	var _CopyMultipleCalendarsCopy = __webpack_require__(299);
	
	var _CopyMultipleCalendarsCopy2 = _interopRequireDefault(_CopyMultipleCalendarsCopy);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DutyScheduleNav = __webpack_require__(1256);
	
	var _DutyScheduleNav2 = _interopRequireDefault(_DutyScheduleNav);
	
	var _BottomNav = __webpack_require__(307);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { BottomNav: _BottomNav2.default, DutyScheduleNav: _DutyScheduleNav2.default, DDropdown: _DDropdown2.default, CopyMultipleCalendarsCopy: _CopyMultipleCalendarsCopy2.default, DutyScheduleCalendar: _DutySchedulePlanCalendar2.default },
	  props: {
	    date: {
	      default: new Date()
	    },
	    isEventsLoading: {
	      type: Boolean,
	      default: false
	    },
	    events: {
	      type: Array,
	      default: []
	    },
	    calendars: {
	      type: Array,
	      default: []
	    },
	    usersCalIdsHash: {
	      default: {}
	    },
	    eventsInHash: {
	      default: {}
	    },
	    theCreateEventObj: {
	      type: Object,
	      default: null
	    },
	    userNorms: {
	      type: Array,
	      default: []
	    },
	    theNewlyCreatedSubject: {
	      type: Object,
	      default: null
	    },
	    schoolSettings: {
	      type: Object,
	      default: null
	    },
	    isCreateOpeningHours: {
	      type: Boolean,
	      default: false
	    },
	    openingHours: {
	      default: null
	    }
	  },
	  computed: {
	    currentWeek: function currentWeek() {
	      return (0, _moment2.default)(this.date).isoWeek();
	    },
	    days: function days() {
	      return this.createDates();
	    }
	  },
	  methods: {
	    setIsCreateOpeningHours: function setIsCreateOpeningHours(bool) {
	      this.$emit('setIsCreateOpeningHours', bool);
	    },
	    createCalendars: function createCalendars(calendarType) {
	      _eventbus2.default.createCalendarsType = calendarType;
	    },
	    createDates: function createDates() {
	      _moment2.default.locale('da-DK');
	      var days = [];
	      for (var i = 1; i <= 5; i++) {
	        var date = (0, _moment2.default)(this.date).isoWeekday(i);
	        days.push({
	          dateId: date.format('YYYY-MM-DD'),
	          date: date,
	          dateFormatted: date.format('dddd DD. MMM')
	        });
	      }
	      return days;
	    },
	    copyCals: function copyCals(objWeeks) {
	      var selectedCalIds = this.calendars.map(function (calendar) {
	        return calendar.id;
	      });
	      var copyDate = objWeeks.copyDate;
	      var selectedWeeks = objWeeks.selectedWeeks;
	      var isDeleteEvents = objWeeks.isDeleteEvents;
	      _docendo2.default.calendarCopyWeeks(selectedCalIds, copyDate, selectedWeeks, isDeleteEvents, [], ['absence', 'presence'], function (data) {
	        _eventbus2.default.toast = { text: 'Kopierer kalendere', success: true };
	      });
	    }
	  }
	};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DutySchedulePlanCalendarUserDay = __webpack_require__(1260);
	
	var _DutySchedulePlanCalendarUserDay2 = _interopRequireDefault(_DutySchedulePlanCalendarUserDay);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _DutySchedulePlanCalendarDayStats = __webpack_require__(1259);
	
	var _DutySchedulePlanCalendarDayStats2 = _interopRequireDefault(_DutySchedulePlanCalendarDayStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DutySchedulePlanCalendarDayStats: _DutySchedulePlanCalendarDayStats2.default, ModalConfirmation: _ModalConfirmation2.default, DDropdown: _DDropdown2.default, DutyScheduleCalendarUserDay: _DutySchedulePlanCalendarUserDay2.default },
	  props: {
	    calendar: {
	      type: Object,
	      default: null
	    },
	    date: {
	      default: function _default() {
	        return new Date();
	      }
	    },
	    usersCalIdsHash: {
	      type: Object
	    },
	    days: {
	      type: Array,
	      required: true
	    },
	    colspan: {
	      type: Number,
	      required: false,
	      default: 6 },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    eventsInHash: {
	      default: {}
	    },
	    theCreateEventObj: {
	      type: Object,
	      default: null
	    },
	    userNorms: {
	      type: Array,
	      default: []
	    },
	    theNewlyCreatedSubject: {
	      type: Object,
	      default: null
	    },
	    schoolSettings: {
	      type: Object,
	      default: null
	    },
	    openingHours: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      subjects: [],
	      isLoadingSubjects: false,
	      subjectsInUserCalIdHash: {},
	      users: [],
	      isCreateSubject: false,
	      theDeleteUser: null,
	      isDeletingUserSubject: false,
	      isLoadingTheUserSubject: false,
	      theUserSubject: null
	    };
	  },
	
	  computed: {
	    schoolSettingsColor: function schoolSettingsColor() {
	      return this.schoolSettings && this.schoolSettings;
	    },
	    usersSorted: function usersSorted() {
	      return this.users.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    usersWithCalc: function usersWithCalc() {
	      var _this = this;
	
	      var users = this.usersSorted.map(function (user) {
	        return (0, _extends3.default)({}, user, {
	          v_events: _this.getEventsForCalendarId(user.user_calendar_id),
	          v_employment: _this.getEmployment(user)
	        });
	      });
	
	      return users;
	    },
	    eventsInDays: function eventsInDays() {
	      var _this2 = this;
	
	      var days = this.days.map(function (day) {
	        return (0, _extends3.default)({}, day, {
	          v_minutes: 0
	        });
	      });
	
	      this.events.forEach(function (event) {
	        event.calendars.forEach(function (calEvent) {
	          if (calEvent.calendar_id === _this2.calendar.id) {
	            var eventDate = (0, _moment2.default)(event.start).format('YYYY-MM-DD');
	            var idx = days.findIndex(function (day) {
	              return day.dateId === eventDate;
	            });
	            if (idx >= 0) {
	              days[idx].v_minutes += calEvent.minutes;
	            }
	          }
	        });
	      });
	      return days.map(function (day) {
	        return (0, _extends3.default)({}, day, {
	          v_formattedTime: Math.floor(day.v_minutes / 60) + 't ' + day.v_minutes % 60 + 'm'
	        });
	      });
	    }
	  },
	  watch: {
	    theNewlyCreatedSubject: function theNewlyCreatedSubject(newSubject) {
	      if (newSubject.calendar_id === this.calendar.id) {
	        this.subjects.push(newSubject);
	        this.matchSubjects();
	      }
	    }
	  },
	  methods: {
	    setTheDeleteUser: function setTheDeleteUser(user) {
	      this.theDeleteUser = user;
	    },
	    createSubject: function createSubject() {
	      this.isCreateSubject = true;
	    },
	    getEmployment: function getEmployment(user) {
	      var userNorm = this.userNorms.find(function (userNorm) {
	        return userNorm.user_id === user.id;
	      });
	      var employmentPerWeek = userNorm && userNorm.norm ? userNorm.norm.find(function (normObj) {
	        return normObj.title === 'Timeansættelse pr. uge';
	      }) : null;
	      return employmentPerWeek ? employmentPerWeek.value : null;
	    },
	    getEventsForCalendarId: function getEventsForCalendarId(calendarId) {
	      var obj = {
	        v_events: [],
	        v_minutes: 0,
	        v_minutesFormatted: ''
	      };
	
	      this.events.forEach(function (event) {
	        event.calendars.forEach(function (calEvent) {
	          if (calEvent.calendar_id === calendarId) {
	            obj.v_events.push(event);
	            obj.v_minutes += calEvent.minutes;
	          }
	        });
	      });
	
	      var hours = Math.floor(obj.v_minutes / 60);
	      var minutes = obj.v_minutes % 60;
	      obj.v_minutesFormatted = hours + 't ' + minutes + 'm';
	
	      return obj;
	    },
	    readSubjects: function readSubjects() {
	      var _this3 = this;
	
	      this.isLoadingSubjects = true;
	      _docendo2.default.sidebar(this.calendar.id, this.date, function (success) {
	        _this3.isLoadingSubjects = false;
	        _this3.subjects = success;
	        _this3.matchSubjects();
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    },
	    matchSubjects: function matchSubjects() {
	      var _this4 = this;
	
	      this.users = [];
	      this.subjects.forEach(function (subject) {
	        subject.cals.forEach(function (calEvent) {
	          if (calEvent.calendar_type === 'user') {
	            var userCalendarId = calEvent.id;
	            var user = _this4.usersCalIdsHash[userCalendarId];
	            if (user) {
	              _this4.users.push(user);
	              _this4.$set(_this4.subjectsInUserCalIdHash, userCalendarId, subject);
	            }
	          }
	        });
	      });
	    },
	    resetDeleteUser: function resetDeleteUser() {
	      this.theDeleteUser = null;
	      this.isDeletingUserSubject = false;
	      this.theUserSubject = null;
	      this.isLoadingTheUserSubject = false;
	    },
	    readUserSubject: function readUserSubject(user) {
	      var _this5 = this;
	
	      this.isLoadingTheUserSubject = true;
	      var subject = this.subjectsInUserCalIdHash[user.user_calendar_id];
	      var subjectId = subject.id;
	      _docendo2.default.showSubject(subjectId, function (dbSuccess) {
	        if (dbSuccess.id) {
	          _this5.theUserSubject = dbSuccess;
	        } else {
	          window.alert('Personen kan ikke findes');
	          _this5.resetDeleteUser();
	        }
	        _this5.isLoadingTheUserSubject = false;
	      }, function (failure) {
	        console.error('Error showing subject:', failure);
	      });
	    },
	    deleteUserSubject: function deleteUserSubject() {
	      if (!this.theUserSubject) {
	        console.error('No user selected for deletion');
	        return;
	      }
	      this.isDeletingUserSubject = true;
	      var subject = this.theUserSubject;
	
	      if (!subject) {
	        console.error('Subject not found for user_calendar_id:');
	        this.resetDeleteUser();
	        return;
	      }
	      this.deleteSubject(subject);
	    },
	    deleteSubject: function deleteSubject(_deleteSubject) {
	      var _this6 = this;
	
	      var subjectId = _deleteSubject.id;
	      var schoolId = _deleteSubject.school_id;
	      var schoolYearId = _deleteSubject.school_year_id;
	      if (_deleteSubject.can_delete) {
	        _docendo2.default.deleteSubject(subjectId, schoolId, schoolYearId, function (success) {
	          if (success.id) {
	            var idx = _this6.subjects.findIndex(function (subject) {
	              return subject.id === success.id;
	            });
	            _this6.subjects.splice(idx, idx);
	            _this6.matchSubjects();
	            _this6.resetDeleteUser();
	          }
	        }, function (failure) {
	          console.log('totally failed!');
	        });
	      } else {
	        var userCalendarId = this.theDeleteUser.user_calendar_id;
	        var calendarIds = _deleteSubject.calendar_ids.filter(function (calId) {
	          return calId !== userCalendarId;
	        });
	        _docendo2.default.updateSubject(subjectId, _deleteSubject.name, _deleteSubject.color, _deleteSubject.calendar_id, calendarIds, _deleteSubject.default_duration, _deleteSubject.preparation, _deleteSubject.hours, _deleteSubject.subject_type, _deleteSubject.school_id, schoolYearId, _deleteSubject.subject_code, false, false, function (success) {
	          _this6.readSubjects();
	        }, function (failure) {
	          console.log('FAILED!');
	        });
	        this.resetDeleteUser();
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	  }
	};

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    hours: {
	      default: 0
	    },
	    openingHours: {
	      default: null
	    }
	  }
	};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ButtonSpinner = __webpack_require__(1392);
	
	var _ButtonSpinner2 = _interopRequireDefault(_ButtonSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ButtonSpinner: _ButtonSpinner2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    date: {
	      default: function _default() {
	        return new Date();
	      }
	    },
	    eventsInHash: {
	      default: {}
	    },
	    subjectsInUserCalIdHash: {},
	    theCreateEventObj: {
	      type: Object,
	      default: null
	    }
	  },
	  computed: {
	    filteredEvents: function filteredEvents() {
	      var calendarId = this.user.user_calendar_id;
	      var lookUpKey = calendarId + '_' + (0, _moment2.default)(this.date).format('YYYY_MM_DD');
	      return this.eventsInHash[lookUpKey] ? this.eventsInHash[lookUpKey] : [];
	    },
	    isTheActiveDay: function isTheActiveDay() {
	      if (!this.theCreateEventObj) {
	        return false;
	      }
	      return this.theCreateEventObj.user.id === this.user.id && this.theCreateEventObj.date === this.date;
	    }
	  },
	  methods: {
	    setCreateEventOnUser: function setCreateEventOnUser() {
	      var calendarId = this.user.user_calendar_id;
	      var subject = this.subjectsInUserCalIdHash[calendarId];
	      var newEventObj = {
	        user: this.user,
	        date: this.date,
	        subject: subject
	      };
	      this.$emit('createEvent', newEventObj);
	    },
	    editEvent: function editEvent(event) {
	      var editEventObj = {
	        user: this.user,
	        event: event
	      };
	      this.$emit('editEvent', editEventObj);
	    }
	  }
	};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Modal = __webpack_require__(67);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppModal: _Modal2.default },
	  props: {
	    calendar: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      showModal: false,
	      validatorText: '',
	      validatorTextOriginal: this.$t('vue2.editCalendarDelete.validator_name')
	    };
	  },
	
	  computed: {
	    calName: function calName() {
	      return this.calendar ? this.calendar.name : '';
	    },
	    openFromOtherComponent: function openFromOtherComponent() {
	      return _eventbus2.default.editCalendarDeleteModal;
	    }
	  },
	  methods: {
	    validateInput: function validateInput() {
	      return this.validatorText === this.validatorTextOriginal;
	    },
	    setCloseModal: function setCloseModal() {
	      this.validatorText = '';
	      _eventbus2.default.editCalendarDeleteModal = false;
	    },
	    submitDelete: function submitDelete() {
	      var _this = this;
	
	      _docendo2.default.schoolCalendarsDelete(this.calendar.school_id, this.calendar.id, function (success) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.editCalendarDelete.success_text'), 'success': true };
	      }, function (errors) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	      this.setCloseModal();
	      window.location.href = '/calendar';
	    }
	  }
	};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Modal = __webpack_require__(67);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppModal: _Modal2.default },
	  props: {
	    calendar: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      calName: ''
	    };
	  },
	
	  computed: {
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    openFromOtherComponent: function openFromOtherComponent() {
	      return _eventbus2.default.editCalendarNameModal;
	    }
	  },
	  methods: {
	    validateInput: function validateInput() {
	      return this.calName && this.calName.length > 0;
	    },
	    setCloseModal: function setCloseModal() {
	      _eventbus2.default.editCalendarNameModal = false;
	    },
	    submitNewName: function submitNewName() {
	      var _this = this;
	
	      _docendo2.default.schoolCalendarsUpdate(this.calendar.school_id, this.calendar.id, { name: this.calName }, function (succes) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.editCalendarEditName.success_text'), 'success': true };
	        window.location.reload();
	      }, function (errors) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	      this.setCloseModal();
	    }
	  },
	  mounted: function mounted() {
	    this.calName = this.calendar ? this.calendar.name : '';
	  }
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _core = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default },
	  filters: {
	    showWeek: function showWeek(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  },
	  data: function data() {
	    return {
	      cal: null,
	      calStartDate: null,
	      calEndDate: null,
	      selectedWeeks: [],
	      isDropdown: false,
	      isDropdownPopperDone: false,
	      componentActiveSchoolYearId: null,
	      event: {
	        'id': 24035310,
	        'calendar_id': 133752,
	        'title': 'Billedkunst',
	        'color': '#ff7f50',
	        'event_time_start': '2020-10-20T06:00:00Z',
	        'event_time_end': '2020-10-20T07:00:00Z'
	      }
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    copyEventEvent: function copyEventEvent() {
	      return _eventbus2.default.copyEventEvent;
	    },
	    copyDate: function copyDate() {
	      var startDate = this.event.start ? this.event.start : this.event.event_time_start;
	      return (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	    },
	    sourceWeek: function sourceWeek() {
	      return (0, _moment2.default)(this.copyDate).format('GGGG-WW');
	    },
	    showStartPasteWeek: function showStartPasteWeek() {
	      return (0, _moment2.default)(this.startPasteWeek).isSame(this.calStartDate);
	    },
	    showDateAndTime: function showDateAndTime() {
	      var startDate = this.event.start ? this.event.start : this.event.event_time_start;
	      var endDate = this.event.end ? this.event.end : this.event.event_time_end;
	      return (0, _moment2.default)(startDate).format('dddd, LT') + ' - ' + (0, _moment2.default)(endDate).format('LT');
	    },
	    weeks: function weeks() {
	      var _this = this;
	
	      if (!this.componentActiveSchoolYearId) {
	        return [];
	      }
	      var activeSchoolYear = this.activeSchoolYears[this.activeSchoolYears.findIndex(function (year) {
	        return year.id === _this.componentActiveSchoolYearId;
	      })];
	      if (this.calType === 'klass') {
	        this.calStartDate = activeSchoolYear.student_time_start;
	        this.calEndDate = activeSchoolYear.student_time_end;
	      } else {
	        this.calStartDate = activeSchoolYear.employee_time_start;
	        this.calEndDate = activeSchoolYear.employee_time_end;
	      }
	      var start = (0, _moment2.default)(this.calStartDate).day(this.firstDayOfTheWeek);
	      var end = (0, _moment2.default)(this.calEndDate).endOf('isoweek');
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i).day(this.firstDayOfTheWeek);
	        weeks.push({
	          date: date,
	          serverDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          weekNum: date.isoWeek()
	        });
	      }
	      return weeks;
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    }
	  },
	  watch: {
	    copyEventEvent: function copyEventEvent(val) {
	      if (val) {
	        this.event = val;
	        this.openDropdown();
	      }
	    }
	  },
	  methods: {
	    setInitialActivatedSchoolYear: function setInitialActivatedSchoolYear() {
	      if (this.activeSchoolYear && this.activeSchoolYear.id) {
	        this.componentActiveSchoolYearId = this.activeSchoolYear.id;
	      }
	    },
	    createPopper: function createPopper() {
	      var parentPopper = document.querySelector('#vue-popper__copy_event_button');
	      var childPopper = this.$refs.copy_event_panel;
	      document.getElementById('djs-content-container').appendChild(childPopper);
	      (0, _core.createPopper)(parentPopper, childPopper, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 5]
	          }
	        }]
	      });
	    },
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date);
	      var start2 = (0, _moment2.default)(date).format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).add(6, 'days');
	      var endFormat = (0, _moment2.default)(date).add(6, 'days').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    setSelectedWeek: function setSelectedWeek(week) {
	      if (this.isCopyWeek(week)) {
	        return;
	      }
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      if (idx < 0) {
	        this.selectedWeeks.push(week.serverDate);
	      } else {
	        this.selectedWeeks.splice(idx, 1);
	      }
	    },
	    isWeekSelected: function isWeekSelected(week) {
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      return idx > -1;
	    },
	    isCopyWeek: function isCopyWeek(week) {
	      return (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)(this.copyDate).format('GGGG-WW');
	    },
	    isNow: function isNow(week) {
	      return (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW');
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      var eventId = this.event.event_id ? this.event.event_id : this.event.id;
	      var schoolId = this.event.school_id ? this.event.school_id : window.SCHOOL.id;
	      console.log(this.event, { eventId: eventId, schoolId: schoolId });
	      _docendo2.default.subjectEventsCreate(schoolId, this.event.calendar_id, this.copyDate, this.selectedWeeks, false, null, null, [], [eventId], function (success) {
	        _this2.closeDropdown();
	        setTimeout(function (_) {
	          document.querySelector('.calendar').click();
	        }, 0);
	        _eventbus2.default.toast = { text: _this2.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	      }, function (failure) {
	        _this2.closeDropdown();
	        console.log('failure', failure);
	      });
	    },
	    openDropdown: function openDropdown() {
	      var _this3 = this;
	
	      this.setInitialActivatedSchoolYear();
	      this.isDropdown = true;
	      this.getCalendar();
	      this.$nextTick(function (_) {
	        _this3.createPopper();
	        _this3.isDropdownPopperDone = true;
	        document.getElementById('djs-content-container').appendChild(_this3.$refs.d_copy_event_overlay);
	      });
	    },
	    closeDropdown: function closeDropdown() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.isDropdown = false;
	      this.isDropdownPopperDone = false;
	      _eventbus2.default.copyEventEvent = null;
	      this.removeAllSelectedWeeks();
	      this.calStartDate = null;
	      if (this.$refs.d_copy_event_overlay) {
	        this.$refs.d_copy_event_overlay.remove();
	      }
	    },
	    selectWeek: function selectWeek(week) {
	      if (this.isCopyWeek(week)) {
	        return;
	      }
	      var idx = this.selectedWeeks.indexOf(week.serverDate);
	      if (idx < 0) {
	        this.selectedWeeks.push(week.serverDate);
	      }
	    },
	    selectEvenWeeks: function selectEvenWeeks() {
	      var _this4 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this4.copyDate)) {
	          if (_this4.isEven(week.weekNum)) {
	            _this4.selectWeek(week);
	          }
	        }
	      });
	    },
	    selectOddWeeks: function selectOddWeeks() {
	      var _this5 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this5.copyDate)) {
	          if (_this5.isOdd(week.weekNum)) {
	            _this5.selectWeek(week);
	          }
	        }
	      });
	    },
	    isEven: function isEven(n) {
	      return (/^-?\d*[02468]$/.test(n)
	      );
	    },
	    isOdd: function isOdd(n) {
	      return (/^-?\d*[13579]$/.test(n)
	      );
	    },
	    addAllWeeksOnward: function addAllWeeksOnward() {
	      var _this6 = this;
	
	      this.weeks.forEach(function (week) {
	        if ((0, _moment2.default)(week.date).isSameOrAfter(_this6.copyDate)) {
	          _this6.selectWeek(week);
	        }
	      });
	    },
	    removeAllSelectedWeeks: function removeAllSelectedWeeks() {
	      this.selectedWeeks = [];
	    },
	    getCalendar: function getCalendar() {
	      var _this7 = this;
	
	      _docendo2.default.calendar(this.event.calendar_id, function (data) {
	        _this7.cal = data;
	        _this7.calType = data.type;
	        _this7.setCalStartAndEndDate();
	      }, function (failure) {
	        console.log('failed to get calendar', failure);
	      });
	    },
	    setCalStartAndEndDate: function setCalStartAndEndDate() {
	      var _this8 = this;
	
	      var highestIdx = 0;
	      this.activeSchoolYears.forEach(function (year, idx) {
	        if (idx > highestIdx) {
	          highestIdx = idx;
	        }
	        var startDate = void 0;
	        var endDate = void 0;
	        if (_this8.calType === 'klass') {
	          startDate = (0, _moment2.default)(year.student_time_start).startOf('isoweek');
	          endDate = (0, _moment2.default)(year.student_time_end).endOf('isoweek');
	        } else {
	          startDate = (0, _moment2.default)(year.employee_time_start).startOf('isoweek');
	          endDate = (0, _moment2.default)(year.employee_time_end).endOf('isoweek');
	        }
	        if ((0, _moment2.default)(_this8.copyDate).isSame(startDate) || (0, _moment2.default)(_this8.copyDate).isBetween(startDate, endDate)) {
	          _this8.componentActiveSchoolYearId = _this8.activeSchoolYears[idx].id;
	        }
	      });
	      if (!this.componentActiveSchoolYearId) {
	        this.componentActiveSchoolYearId = this.activeSchoolYears[highestIdx].id;
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.copyEventEvent = null;
	    if (this.$refs.copy_event_panel) {
	      this.$refs.copy_event_panel.remove();
	    }
	    if (this.$refs.d_copy_event_overlay) {
	      this.$refs.d_copy_event_overlay.remove();
	    }
	  }
	};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    event: {
	      type: Object,
	      default: function _default() {
	        return {
	          'id': 24035310,
	          'calendar_id': 133752,
	          'title': 'Billedkunst',
	          'color': '#ff7f50',
	          'event_time_start': '2020-10-20T06:00:00Z',
	          'event_time_end': '2020-10-20T07:00:00Z'
	        };
	      }
	    }
	  },
	  methods: {
	    openCopyEventDropdown: function openCopyEventDropdown() {
	      _eventbus2.default.copyEventEvent = this.event;
	    }
	  }
	};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    cancel_event: 'Aflys timen',
	    uncancel_event: 'Fortryd aflysning',
	    confirm_cancel_title: 'Er du sikker på, at du vil aflyse timen?',
	    confirm_cancel_text: 'Timen bliver ikke slettet, men vil blive markeret som aflyst med overstregede tekster.',
	    confirm_uncancel_title: 'Er du sikker på, at du vil fortryde aflysningen?',
	    confirm_uncancel_text: 'Timen vil blive gendannet, og de overstregede tekster fjernes.'
	  },
	  no: {
	    cancel_event: 'Avlys timen',
	    uncancel_event: 'Angre avlysning',
	    confirm_cancel_title: 'Er du sikker på at du vil avlyse timen?',
	    confirm_cancel_text: 'Timen blir ikke slettet, men vil bli markert som avlyst med gjennomstreket tekst.',
	    confirm_uncancel_title: 'Er du sikker på at du vil angre avlysningen?',
	    confirm_uncancel_text: 'Timen vil bli gjenopprettet, og den gjennomstrekede teksten fjernes.'
	  },
	  en: {
	    cancel_event: 'Cancel lesson',
	    uncancel_event: 'Undo cancellation',
	    confirm_cancel_title: 'Are you sure you want to cancel the lesson?',
	    confirm_cancel_text: 'The lesson will not be deleted but will be marked as canceled with strikethrough text.',
	    confirm_uncancel_title: 'Are you sure you want to undo the cancellation?',
	    confirm_uncancel_text: 'The lesson will be restored, and the strikethrough text will be removed.'
	  }
	};
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    event: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isCancellingLesson: false
	    };
	  },
	
	  computed: {
	    isCanceled: function isCanceled() {
	      return this.event.canceled;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N.en;
	    }
	  },
	  methods: {
	    onConfirmCancelLesson: function onConfirmCancelLesson() {
	      this.handleConfirmCancelLesson();
	    },
	    handleConfirmCancelLesson: function handleConfirmCancelLesson() {
	      var _this = this;
	
	      this.isCancellingLesson = true;
	      var updatedLesson = {
	        school_id: this.event.school_id,
	        updates: [{ event_id: this.event.event_id, canceled: !this.isCanceled }]
	      };
	      _docendo2.default.updateEvents(updatedLesson.school_id, updatedLesson.updates, function (success) {
	        _this.isCancellingLesson = false;
	        _this.$emit('updated');
	      }, function (failure) {
	        console.log('failed');
	      });
	    }
	  }
	};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    mark_as_away: 'Markér som ude af huset',
	    unmark_as_away: 'Fortryd markering som ude af huset',
	    confirm_away_title: 'Er du sikker på, at du vil markere lektionen som ude af huset?',
	    confirm_away_text: 'Lektionen vil blive markeret som værende uden for skolens område. Og personale på lektionen vil fremgå i vikardækningen som fraværende.',
	    confirm_unaway_text: 'Lektionen vil ikke længere fremgå som ude af huset. Og personale vil ikke længere fremgå i vikardækningen som fraværende.',
	    confirm_unaway_title: 'Er du sikker på, at du vil fortryde markeringen som ude af huset?'
	  },
	  no: {
	    mark_as_away: 'Marker som utenfor skolen',
	    unmark_as_away: 'Angre markering som utenfor skolen',
	    confirm_away_title: 'Er du sikker på at du vil markere leksjonen som utenfor skolen?',
	    confirm_away_text: 'Leksjonen vil bli markert som værende utenfor skolens område. Og personalet på leksjonen vil vises i vikaroversikten som fraværende.',
	    confirm_unaway_title: 'Er du sikker på at du vil angre markeringen som utenfor skolen?',
	    confirm_unaway_text: 'Leksjonen vil ikke lenger vises som ute av huset. Og personalet vil ikke lenger vises i vikaroversikten som fraværende.'
	  },
	  en: {
	    mark_as_away: 'Mark as out of school',
	    unmark_as_away: 'Undo out of school marking',
	    confirm_away_title: 'Are you sure you want to mark the event as out of school?',
	    confirm_away_text: 'The event will be marked as taking place outside the school premises. And staff in the event will appear in the substitute management as absent.',
	    confirm_unaway_text: 'The event will no longer be shown as taking place outside the school. And staff will no longer appear in the substitute management as absent.',
	    confirm_unaway_title: 'Are you sure you want to undo the out of school marking?'
	  }
	};
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default },
	  props: {
	    event: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    eventIdProp: {
	      default: 'event_id'
	    }
	  },
	  data: function data() {
	    return {
	      isSubmitting: false
	    };
	  },
	
	  computed: {
	    isAway: function isAway() {
	      return this.event.away;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale] || I18N.en;
	    }
	  },
	  methods: {
	    onConfirmAwayStatus: function onConfirmAwayStatus() {
	      this.handleConfirmAwayStatus();
	    },
	    handleConfirmAwayStatus: function handleConfirmAwayStatus() {
	      var _this = this;
	
	      this.isSubmitting = true;
	      var updatedLesson = {
	        school_id: this.event.school_id,
	        updates: [{ event_id: this.event[this.eventIdProp], away: !this.isAway }]
	      };
	      _docendo2.default.updateEvents(updatedLesson.school_id, updatedLesson.updates, function (success) {
	        _this.isSubmitting = false;
	        _this.$emit('updated');
	      }, function (failure) {
	        console.log('failed');
	      });
	    }
	  }
	};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DCalendarShowEvent = __webpack_require__(68);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DCalendarShowEvent: _DCalendarShowEvent2.default },
	  data: function data() {
	    return {
	      calendarId: null,
	      eventId: null,
	      events: [],
	      isEventsLoading: false
	    };
	  },
	
	  computed: {
	    event: function event() {
	      var _this = this;
	
	      var idx = this.events.findIndex(function (event) {
	        return event.event_id === _this.eventId;
	      });
	      return idx > -1 ? this.events[idx] : null;
	    }
	  },
	  methods: {
	    onEventUpdated: function onEventUpdated() {
	      var customEvent = new window.CustomEvent('UpdateCalendarEvents', { bubbles: true, cancelable: true });
	      window.document.dispatchEvent(customEvent);
	    },
	    onClose: function onClose() {
	      this.eventId = null;
	    },
	    readEvents: function readEvents(event) {
	      var _this2 = this;
	
	      this.calendarId = event.calendar_id;
	      this.eventId = event.event_id;
	      var obj = {
	        calIds: [this.calendarId],
	        start: (0, _moment2.default)(event.start).format('YYYY-MM-DD 00:00'),
	        end: (0, _moment2.default)(event.end).endOf('day')
	      };
	      this.isEventsLoading = true;
	      _docendo2.default.calendarEvents2(obj.calIds, obj.start, obj.end, null, function (data) {
	        console.log({ data: data });
	        _this2.isEventsLoading = false;
	        _this2.events = data.length > 0 ? JSON.parse(data) : [];
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    eventHandler: function eventHandler(e) {
	      var event = e.detail['calEvent'];
	      this.readEvents(event);
	    }
	  },
	  mounted: function mounted() {
	    window.removeEventListener('fullcal_event_click_for_vue', this.eventHandler);
	    window.addEventListener('fullcal_event_click_for_vue', this.eventHandler);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('fullcal_event_click_for_vue', this.eventHandler);
	  }
	};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(85);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _i18n = {
	  da: {
	    delete_events_onward: 'Slet lektionen fremadrettet',
	    are_you_sure: 'Er du sikker?',
	    do_you_want_to_delete_this_and_all_in_same_timeslot: 'Vil du gerne slette denne lektion, og alle der ligger på samme ugedag og i samme tidsrum fremadrettet?',
	    cancel: 'Annuller'
	  },
	  en: {
	    delete_events_onward: 'Delete this and on same timeslot forward',
	    are_you_sure: 'Are you sure?',
	    do_you_want_to_delete_this_and_all_in_same_timeslot: 'Would you like to delete this lesson and all that lie on the same day of the week and in the same time period going forward?',
	    cancel: 'Cancel'
	  },
	  nb: {
	    delete_events_onward: 'Slett denne timen nå og fremover',
	    are_you_sure: 'Er du sikker?',
	    do_you_want_to_delete_this_and_all_in_same_timeslot: 'Vil du slette denne timen og alle tilsvarende planlagte timer i dette faget og tidsrommet fremover i tid?',
	    cancel: 'Avbryt'
	  }
	};
	exports.default = {
	  components: { Modal: _Modal2.default, DDropdown: _DDropdown2.default },
	  props: {
	    subjectId: {
	      default: '262937'
	    },
	    eventId: {
	      default: '24035264'
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    },
	    event: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store ? this.$store.getters.locale : window.USER.language;
	    },
	    schoolId: function schoolId() {
	      return this.$store ? this.$store.getters.schoolId : window.SCHOOL.id;
	    },
	    i18n: function i18n() {
	      return _i18n;
	    },
	    bgColor: function bgColor() {
	      return this.event && this.event.color ? this.event.color : '#989898';
	    }
	  },
	  data: function data() {
	    return {
	      isReadyForModal: false,
	      isModal: false
	    };
	  },
	
	  methods: {
	    closeModal: function closeModal() {
	      this.isReadyForModal = true;
	      this.isModal = false;
	      this.$emit('close');
	    },
	    setDelete: function setDelete() {
	      var _this = this;
	
	      this.isReadyForModal = true;
	      this.$nextTick(function (_) {
	        document.getElementById('djs-content-container').appendChild(_this.$refs.d_modal_delete_event);
	        _this.isModal = true;
	      });
	    },
	    deleteEvents: function deleteEvents() {
	      var _this2 = this;
	
	      var schoolId = this.schoolId;
	      var eventId = this.eventId;
	      if (this.event) {
	        schoolId = this.event.school_id;
	        eventId = this.event.event_id;
	      }
	      _docendo2.default.eventsDeleteThisAndFollowing(schoolId, eventId, function (success) {
	        document.querySelector('body').classList.remove('no-scroll');
	        var elCal = document.querySelector('.calendar');
	        if (elCal) {
	          elCal.click();
	        }
	        _this2.$emit('submit');
	        _this2.closeModal();
	      }, function (failure) {
	        console.log('something went wront');
	      });
	    }
	  },
	  mounted: function mounted() {
	    if (this.isInDCalendar) {
	      this.setDelete();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$refs.d_modal_delete_event) {
	      this.$refs.d_modal_delete_event.remove();
	    }
	  }
	};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    type: {
	      default: 'swap'
	    },
	    propEvent: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isSubmittingSubjectId: null,
	      isSubmittingEventId: null,
	      events: [],
	      subjects: []
	    };
	  },
	
	  computed: {
	    sortedEvents: function sortedEvents() {
	      return this.events.sort(function (a, b) {
	        return (0, _moment2.default)(a.event_time_start).unix() - (0, _moment2.default)(b.event_time_start).unix();
	      });
	    },
	    eventsVProps: function eventsVProps() {
	      var _this = this;
	
	      return this.sortedEvents.map(function (event) {
	        return (0, _extends3.default)({}, event, {
	          vTitle: event.title,
	          vDateAndTime: _this.getDateAndTime(event)
	        });
	      });
	    },
	    subjectsVProps: function subjectsVProps() {
	      return this.subjects.map(function (subject) {
	        return (0, _extends3.default)({}, subject, {
	          vTitle: subject.name
	        });
	      });
	    },
	    schoolId: function schoolId() {
	      return this.propEvent.school_id;
	    },
	    eventId: function eventId() {
	      return this.propEvent.event_id;
	    }
	  },
	  watch: {
	    type: function type() {
	      this.readPossibilities();
	    }
	  },
	  methods: {
	    replaceEvent: function replaceEvent(subject) {
	      var _this2 = this;
	
	      this.isSubmittingSubjectId = subject.id;
	      _docendo2.default.eventReplace(this.schoolId, this.eventId, subject.id, function (success) {
	        if (success.status && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, 'success': false };
	          _this2.isSubmittingSubjectId = null;
	          return;
	        }
	        _eventbus2.default.toast = { text: _this2.$t('vue2.edit_event.lesson_updated'), 'success': true };
	        console.log({ success: success });
	        _this2.isSubmittingSubjectId = null;
	        _this2.$emit('update');
	      }, function (failure) {
	        console.log({ failure: failure });
	        _this2.isSubmittingSubjectId = null;
	      });
	    },
	    eventSwap: function eventSwap(event) {
	      var _this3 = this;
	
	      this.isSubmittingEventId = event.id;
	      _docendo2.default.eventSwap(this.schoolId, this.eventId, event.id, function (success) {
	        if (success.status && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, 'success': false };
	          _this3.isSubmittingEventId = null;
	          return;
	        }
	        _eventbus2.default.toast = { text: _this3.$t('vue2.edit_event.lesson_updated'), 'success': true };
	        console.log({ success: success });
	        _this3.isSubmittingEventId = null;
	        _this3.$emit('update');
	      }, function (failure) {
	        console.log({ failure: failure });
	        _this3.isSubmittingEventId = null;
	      });
	    },
	    getDateAndTime: function getDateAndTime(event) {
	      if (!event.event_time_start) {
	        return '';
	      }
	      return (0, _moment2.default)(event.event_time_start).format('LL LT') + ' - ' + (0, _moment2.default)(event.event_time_end).format('LT');
	    },
	    readReplaceSubjects: function readReplaceSubjects() {
	      var _this4 = this;
	
	      this.isLoading = true;
	      this.subjects = [];
	      _docendo2.default.eventListReplaceable(this.schoolId, this.eventId, function (success) {
	        if (success.status && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, 'success': false };
	          _this4.subjects = [];
	          _this4.isLoading = false;
	          return;
	        }
	        _this4.subjects = success;
	        _this4.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	        console.log('failure', failure);
	        _this4.isLoading = false;
	      });
	    },
	    readSwapEvents: function readSwapEvents() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      this.events = [];
	      _docendo2.default.eventListSwapable(this.schoolId, this.eventId, function (success) {
	        if (success.status && success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, 'success': false };
	          _this5.events = [];
	          _this5.isLoading = false;
	          return;
	        }
	        console.log({ success: success });
	        _this5.events = success;
	        _this5.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	        console.log({ failure: failure });
	        _this5.isLoading = false;
	      });
	    },
	    readPossibilities: function readPossibilities() {
	      if (this.type === 'swap') {
	        this.readSwapEvents();
	      }
	      if (this.type === 'replace') {
	        this.readReplaceSubjects();
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.readPossibilities();
	  }
	};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, Spinner: _Spinner2.default },
	  props: {
	    isShowFromProp: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isModal: false,
	      theActiveIntegration: 0,
	      integrations: [{
	        id: 0,
	        title: 'Apple iPhone',
	        youTubeLink: 'https://www.youtube.com/watch?v=Vkw-bVsvkq4'
	      }, {
	        id: 1,
	        title: 'Android',
	        youTubeLink: 'https://www.youtube.com/watch?v=Idpmc8dcFV0'
	      }]
	    };
	  },
	
	  watch: {
	    isShowFromProp: function isShowFromProp(val) {
	      this.setIsModal(val);
	    }
	  },
	  methods: {
	    setIsModal: function setIsModal(boolean) {
	      this.isModal = boolean;
	      if (!boolean) {
	        this.$emit('close');
	      }
	    }
	  }
	};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _icalIcon = __webpack_require__(1182);
	
	var _icalIcon2 = _interopRequireDefault(_icalIcon);
	
	var _ical_ = __webpack_require__(1183);
	
	var _ical_2 = _interopRequireDefault(_ical_);
	
	var _googleCalendarIcon = __webpack_require__(1178);
	
	var _googleCalendarIcon2 = _interopRequireDefault(_googleCalendarIcon);
	
	var _googlecalendar = __webpack_require__(1179);
	
	var _googlecalendar2 = _interopRequireDefault(_googlecalendar);
	
	var _googlecalendar3 = __webpack_require__(1180);
	
	var _googlecalendar4 = _interopRequireDefault(_googlecalendar3);
	
	var _googlecalendar5 = __webpack_require__(1181);
	
	var _googlecalendar6 = _interopRequireDefault(_googlecalendar5);
	
	var _outlookIcon = __webpack_require__(1184);
	
	var _outlookIcon2 = _interopRequireDefault(_outlookIcon);
	
	var _outlook = __webpack_require__(1185);
	
	var _outlook2 = _interopRequireDefault(_outlook);
	
	var _outlook3 = __webpack_require__(1186);
	
	var _outlook4 = _interopRequireDefault(_outlook3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, Spinner: _Spinner2.default },
	  props: {
	    calLink: {
	      default: ''
	    },
	    isShowButton: {
	      type: Boolean,
	      default: true
	    },
	    isShowFromProp: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isModal: false,
	      theActiveIntegration: 0,
	      integrations: [{
	        id: 0,
	        title: 'Google Calendar',
	        icon: _googleCalendarIcon2.default,
	        imgs: [_googlecalendar2.default, _googlecalendar4.default, _googlecalendar6.default]
	      }, {
	        id: 1,
	        title: 'Apple Calendar',
	        icon: _icalIcon2.default,
	        imgs: [_ical_2.default]
	      }, {
	        id: 2,
	        title: 'Outlook Calendar',
	        icon: _outlookIcon2.default,
	        imgs: [_outlook2.default, _outlook4.default]
	      }]
	    };
	  },
	
	  watch: {
	    isShowFromProp: function isShowFromProp(val) {
	      this.setIsModal(val);
	    }
	  },
	  methods: {
	    setIsModal: function setIsModal(boolean) {
	      this.isModal = boolean;
	      if (!boolean) {
	        this.$emit('close');
	      }
	    }
	  }
	};

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'hello',
	  props: {
	    message: {
	      type: String,
	      default: function _default() {
	        return 'hello';
	      }
	    }
	  },
	  exampleData: {
	    message: 'Example message'
	  },
	  methods: {
	    emitClick: function emitClick() {
	      this.$emit('message', this.message);
	    }
	  }
	};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _anne = __webpack_require__(1187);
	
	var _anne2 = _interopRequireDefault(_anne);
	
	var _henrik = __webpack_require__(1188);
	
	var _henrik2 = _interopRequireDefault(_henrik);
	
	var _jeppe = __webpack_require__(1189);
	
	var _jeppe2 = _interopRequireDefault(_jeppe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isShowChat: false,
	      anne: _anne2.default,
	      henrik: _henrik2.default,
	      jeppe: _jeppe2.default
	    };
	  },
	
	  methods: {
	    setOpenChat: function setOpenChat() {
	      this.isShowChat = !this.isShowChat;
	    }
	  }
	};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(93);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _DSelectUsers = __webpack_require__(69);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _IEAndEdgeWarning = __webpack_require__(352);
	
	var _IEAndEdgeWarning2 = _interopRequireDefault(_IEAndEdgeWarning);
	
	var _HoursShowShortcuts = __webpack_require__(1270);
	
	var _HoursShowShortcuts2 = _interopRequireDefault(_HoursShowShortcuts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'HoursShow',
	  components: { DatePickerRange: _DatePickerRange2.default, dSelectUsers: _DSelectUsers2.default, Spinner: _Spinner2.default, IEwarning: _IEAndEdgeWarning2.default, HoursShowShortcuts: _HoursShowShortcuts2.default },
	  data: function data() {
	    return {
	      startDate: (0, _moment2.default)().isoWeekday(1),
	      endDate: (0, _moment2.default)().isoWeekday(7),
	      selectedUsers: [],
	      usersAndEvents: [],
	      eventsFilter: null,
	      isLoading: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.state.activeSchool.id;
	    },
	    start: function start() {
	      return (0, _moment2.default)(this.startDate).startOf('day');
	    },
	    end: function end() {
	      return (0, _moment2.default)(this.endDate).endOf('day');
	    },
	    selectedUsersIds: function selectedUsersIds() {
	      return this.selectedUsers.map(function (user) {
	        return user.id;
	      });
	    },
	    usersAndEventsSortedOnName: function usersAndEventsSortedOnName() {
	      return this.usersAndEvents.sort(function (a, b) {
	        var x = a.name.toLowerCase();
	        var y = b.name.toLowerCase();
	        if (x < y) {
	          return -1;
	        }
	        if (x > y) {
	          return 1;
	        }
	        return 0;
	      });
	    },
	    usersAndEventsWithProps: function usersAndEventsWithProps() {
	      var _this = this;
	
	      return this.usersAndEventsSortedOnName.map(function (user) {
	        user.v_events_filtered = _this.filteredEvents(user.events);
	        user.v_filter_events = _this.filterEvents(user.events);
	        user.v_day_durations = _this.getUserDayDurations(user.v_events_filtered);
	        user.v_all_days_duration = _this.getAllUserDaysDurations(user.v_day_durations);
	        return user;
	      });
	    }
	  },
	  watch: {
	    selectedUsersIds: function selectedUsersIds() {
	      if (this.selectedUsersIds.length < 1) {
	        this.usersAndEvents = [];
	      }
	      this.getEvents();
	    }
	  },
	  filters: {
	    klassList: function klassList(string) {
	      return string.replace(/{|}/g, '');
	    }
	  },
	  methods: {
	    filterEvents: function filterEvents(events) {
	      var _this2 = this;
	
	      var filteredEvents = events.filter(function (obj) {
	        switch (_this2.eventsFilter) {
	          case null:
	            return obj.event_type !== '';
	          case 'subject':
	            return obj.event_type !== 'absence' && obj.event_type !== 'other_tasks' && obj.event_type !== 'other_stuff' && obj.substitute_for === null;
	          case 'substituteHours':
	            return obj.substitute_for !== null;
	          case 'absence':
	            return obj.event_type === 'absence';
	        }
	      });
	      return filteredEvents;
	    },
	    eventHasAnyKlass: function eventHasAnyKlass(event) {
	      var str = event.replace(/{|}/g, '');
	      return str.length > 0;
	    },
	    eventsToArr: function eventsToArr(events) {
	      events = this.eventsSortedInDays(events);
	      return (0, _keys2.default)(events).map(function (e) {
	        return { date: e, events: events[e] };
	      });
	    },
	    filteredEvents: function filteredEvents(events) {
	      var _this3 = this;
	
	      var filteredEvents = events.filter(function (obj) {
	        switch (_this3.eventsFilter) {
	          case null:
	            return obj.event_type !== '';
	          case 'subject':
	            return obj.event_type !== 'absence' && obj.event_type !== 'other_tasks' && obj.event_type !== 'other_stuff' && obj.substitute_for === null;
	          case 'substituteHours':
	            return obj.substitute_for !== null;
	          case 'absence':
	            return obj.event_type === 'absence';
	        }
	      });
	      return this.sortedEvents(filteredEvents);
	    },
	    sortedEvents: function sortedEvents(events) {
	      var sortedEvent = events.sort(function (a, b) {
	        return (0, _moment2.default)(a.start_time).unix() - (0, _moment2.default)(b.start_time).unix();
	      });
	      return this.eventsSortedInDays(sortedEvent);
	    },
	    eventsSortedInDays: function eventsSortedInDays(events) {
	      return events.reduce(function (acc, curr, index) {
	        var val = (0, _moment2.default)(curr['start_time']).format('YYYY-MM-DD');
	        acc[val] = acc[val] || [];
	        acc[val].push(curr);
	        return acc;
	      }, {});
	    },
	    syncUsers: function syncUsers(data) {
	      this.selectedUsers = data;
	    },
	    startDateChanged: function startDateChanged(date) {
	      this.startDate = date;
	      this.getEvents();
	    },
	    endDateChanged: function endDateChanged(date) {
	      this.endDate = date;
	      this.getEvents();
	    },
	    setEventsFilter: function setEventsFilter(type) {
	      this.eventsFilter = type;
	    },
	    filterIsActive: function filterIsActive(type) {
	      return this.eventsFilter === type;
	    },
	    getEvents: function getEvents() {
	      var _this4 = this;
	
	      if (this.selectedUsersIds.length < 1) {
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.schoolEvents(window.SCHOOL.id, this.start, this.end, this.selectedUsersIds, '', function (data) {
	        _this4.usersAndEvents = data;
	        _this4.isLoading = false;
	      });
	    },
	    print: function print() {
	      window.print();
	    },
	    getSumDuration: function getSumDuration(eventsArr) {
	      var filterAbsence = eventsArr;
	      if (this.eventsFilter !== 'absence') {
	        filterAbsence = eventsArr.filter(function (lesson) {
	          return lesson.event_type !== 'absence';
	        });
	      }
	      var durations = [];
	      filterAbsence.forEach(function (lesson) {
	        durations.push(lesson.user_teaching_mins);
	      });
	      var data = durations.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	      return this.humanizeMinutes(data);
	    },
	    getDayDuration: function getDayDuration(eventsArr) {
	      var start = (0, _moment2.default)(eventsArr[0].start_time);
	      var end = (0, _moment2.default)(eventsArr[eventsArr.length - 1].end_time);
	      var duration = end.diff(start, 'minutes');
	      return this.humanizeMinutes(duration);
	    },
	    getDayDurationInMinutes: function getDayDurationInMinutes(eventsArr) {
	      var start = (0, _moment2.default)(eventsArr[0].start_time);
	      var end = (0, _moment2.default)(eventsArr[eventsArr.length - 1].end_time);
	      return end.diff(start, 'minutes');
	    },
	    humanizeMinutes: function humanizeMinutes(data) {
	      var minutes = data % 60;
	      var hours = (data - minutes) / 60;
	      var multiple = hours === 1 ? this.$i18n.t('vue2.substitute_hours.hour') : this.$i18n.t('vue2.substitute_hours.hours');
	      return hours + ' ' + multiple + ' ' + minutes + ' ' + this.$t('vue2.substitute_hours.min');
	    },
	    getEventDuration: function getEventDuration(event) {
	      if (this.activeFilter !== 'absence' && event.event_type === 'absence') {
	        return '';
	      }
	      return event.user_teaching_mins + ' min.';
	    },
	    getUserDayDurations: function getUserDayDurations(eventsInDays) {
	      var durations = {};
	      for (var key in eventsInDays) {
	        if (!durations[key]) {
	          durations[key] = this.getDayDurationInMinutes(eventsInDays[key]);
	        }
	      }
	      return durations;
	    },
	    getAllUserDaysDurations: function getAllUserDaysDurations(dayDurations) {
	      var durationsArr = (0, _values2.default)(dayDurations);
	      var allDaysDuration = durationsArr && durationsArr.length > 0 ? durationsArr.reduce(function (currentValue, sum) {
	        return currentValue + sum;
	      }) : 0;
	      return this.humanizeMinutes(allDaysDuration);
	    }
	  },
	  mounted: function mounted() {
	    if (window.Intercom) {
	      window.Intercom('trackEvent', 'Visited Get User Events');
	    }
	  }
	};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    filter_reasons: 'Årsager'
	  },
	  en: {
	    filter_reasons: 'Reasons'
	  },
	  nb: {
	    filter_reasons: 'Årsaker'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, DoFiltersFilter: _DoFiltersFilter2.default, Loader: _Loader2.default },
	  props: {
	    start: {
	      type: Object,
	      default: (0, _moment2.default)()
	    },
	    end: {
	      type: Object,
	      default: (0, _moment2.default)()
	    }
	  },
	  data: function data() {
	    return {
	      isShowAbsentUsers: false,
	      absenceEvents: [],
	      isLoading: false,
	      selectedReasonsToFilter: []
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userIsSchoolAdmin: function userIsSchoolAdmin() {
	      return this.userHasPermission('can_manage_school');
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isShowExternalShortCuts: function isShowExternalShortCuts() {
	      return this.schoolCountry.toLowerCase() === 'dk' && this.userIsSchoolAdmin;
	    },
	    schoolLinks: function schoolLinks() {
	      return [{
	        link: window.location.origin + '/app#/dashboard/' + this.schoolId,
	        title: 'Antal vikartimer pr. klasse for skoleåret'
	      }, {
	        link: window.location.origin + '/app#/dashboard/absence/' + this.schoolId,
	        title: 'Personalets fraværstyper fordelt over måneder'
	      }, {
	        link: window.location.origin + '/app#/dashboard/absence/subs/' + this.schoolId,
	        title: 'Vikartimer ift. Fraværstyper'
	      }];
	    },
	    startDateFormatted: function startDateFormatted() {
	      return (0, _moment2.default)(this.start).locale(this.locale).format('DD. MMMM YYYY');
	    },
	    endDateFormatted: function endDateFormatted() {
	      return (0, _moment2.default)(this.end).locale(this.locale).format('DD. MMMM YYYY');
	    },
	    absenceEventsTypes: function absenceEventsTypes() {
	      var types = [];
	      this.absenceEvents.forEach(function (event) {
	        var idx = types.findIndex(function (type) {
	          return type === event.title;
	        });
	        if (idx < 0) {
	          types.push(event.title);
	        }
	      });
	      return types;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    schoolUsers: function schoolUsers() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    schoolUsersIds: function schoolUsersIds() {
	      return this.schoolUsers.map(function (user) {
	        return user.id;
	      });
	    },
	    schoolUserCalIds: function schoolUserCalIds() {
	      return this.schoolUsers.map(function (user) {
	        return user.user_calendar_id;
	      });
	    },
	    absenceEventsFiltered: function absenceEventsFiltered() {
	      var _this = this;
	
	      if (!this.selectedReasonsToFilter.length) {
	        return this.absenceEvents;
	      }
	      return this.absenceEvents.filter(function (event) {
	        return _this.selectedReasonsToFilter.includes(event.title);
	      });
	    },
	    absentUsers: function absentUsers() {
	      var users = [];
	      this.absenceEventsFiltered.forEach(function (event) {
	        var idx = users.findIndex(function (user) {
	          return user.userCalendarId === event.calendar_id;
	        });
	        if (idx < 0) {
	          var user = { userCalendarId: event.calendar_id, events: [event] };
	          users.push(user);
	        } else {
	          users[idx].events.push(event);
	        }
	      });
	      return users;
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    toggleFilter: function toggleFilter(filter) {
	      var idx = this.selectedReasonsToFilter.indexOf(filter);
	      if (idx < 0) {
	        this.selectedReasonsToFilter.push(filter);
	      } else {
	        this.selectedReasonsToFilter.splice(idx, 1);
	      }
	    },
	    print: function print() {
	      var prtHtml = document.getElementById('printList').innerHTML;
	
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	      WinPrint.document.write('<!DOCTYPE html><html><head>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	        WinPrint.close();
	      }, 1000);
	    },
	    hasNoteWithoutHTML: function hasNoteWithoutHTML(myString) {
	      return myString.replace(/<[^>]*>?/gm, '');
	    },
	    open: function open() {
	      var el = document.querySelector('body');
	      if (!el.classList.contains('no-scroll')) {
	        el.classList.add('no-scroll');
	      }
	    },
	    close: function close() {
	      this.isShowAbsentUsers = false;
	      document.querySelector('body').classList.remove('no-scroll');
	    },
	    getAbsentUsers: function getAbsentUsers() {
	      var _this2 = this;
	
	      this.open();
	      this.isShowAbsentUsers = true;
	      this.absenceEvents = [];
	      this.isLoading = true;
	      _docendo2.default.calendarEvents2(this.schoolUserCalIds, this.start, this.end, ['absence'], function (data) {
	        _this2.absenceEvents = data.length > 0 ? JSON.parse(data) : [];
	        _this2.isLoading = false;
	      }, function (failure) {
	        _this2.isLoading = false;
	      });
	    },
	    sortedEvents: function sortedEvents(events) {
	      var sortedEvent = events.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	      return this.eventsSortedInDays(sortedEvent);
	    },
	    eventsSortedInDays: function eventsSortedInDays(events) {
	      return events.reduce(function (acc, curr, index) {
	        var val = (0, _moment2.default)(curr['start']).format('YYYY-MM-DD');
	        acc[val] = acc[val] || [];
	        acc[val].push(curr);
	        return acc;
	      }, {});
	    },
	    getUserNameFromCalId: function getUserNameFromCalId(calId) {
	      return this.allUsersInCalIdHash[calId] && this.allUsersInCalIdHash[calId].name ? this.allUsersInCalIdHash[calId].name : 'User can not be found';
	    },
	    getDuration: function getDuration(event) {
	      return this.humanizeMinutes(event.duration);
	    },
	    humanizeMinutes: function humanizeMinutes(data) {
	      var minutes = data % 60;
	      var hours = (data - minutes) / 60;
	      var multiple = hours === 1 ? this.$i18n.t('vue2.substitute_hours.hour') : this.$i18n.t('vue2.substitute_hours.hours');
	      return hours + ' ' + multiple + ' ' + minutes + ' ' + this.$t('vue2.substitute_hours.min');
	    },
	    getNumberOfDaysAbsent: function getNumberOfDaysAbsent(userEvents) {
	      if (!userEvents) {
	        return 0;
	      }
	      return (0, _keys2.default)(this.sortedEvents(userEvents)).length;
	    }
	  }
	};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    event: {
	      type: Object
	    },
	    activeFilter: {
	      type: String,
	      default: ''
	    }
	  },
	  computed: {
	    eventDuration: function eventDuration() {
	      if (this.activeFilter !== 'absence' && this.event.event_type === 'absence') {
	        return '';
	      }
	      return this.event.user_teaching_mins + ' min.';
	    },
	    showType: function showType() {
	      if (this.event.substitute_for !== null) {
	        return this.$i18n.t('vue2.substitute_hours.substitute_hour');
	      } else if (this.event.event_type === 'absence') {
	        return this.$i18n.t('vue2.substitute_hours.absence');
	      } else if (this.event.event_type === 'other_tasks') {
	        return this.$i18n.t('vue2.substitute_hours.other_tasks');
	      } else if (this.event.event_type === 'other_stuff') {
	        return this.$i18n.t('vue2.substitute_hours.other_stuff');
	      } else {
	        return '';
	      }
	    }
	  },
	  filters: {
	    klassList: function klassList(string) {
	      return string.replace(/{|}/g, '');
	    }
	  },
	  methods: {
	    eventHasAnyKlass: function eventHasAnyKlass(event) {
	      var str = event.replace(/{|}/g, '');
	      return str.length > 0;
	    }
	  }
	};

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'list-with-search',
	  props: {
	    options: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      search: ''
	    };
	  },
	
	  computed: {
	    searchList: function searchList() {
	      var _this = this;
	
	      return this.options.filter(function (obj) {
	        return obj.name !== null ? obj.name.match(new RegExp(_this.search, 'i')) : '';
	      });
	    }
	  },
	  methods: {
	    chooseItem: function chooseItem(obj) {
	      this.$emit('choose', obj);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.$nextTick(function (_) {
	      var searchInput = _this2.$refs.search_input;
	      if (searchInput) {
	        searchInput.focus();
	      }
	    });
	  }
	};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _momentlangs = __webpack_require__(362);
	
	var _momentlangs2 = _interopRequireDefault(_momentlangs);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      locale: window.USER.locale,
	      languages: _momentlangs2.default
	    };
	  },
	
	  computed: {
	    langSorted: function langSorted() {
	      return this.languages.sort(function (a, b) {
	        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
	      });
	    }
	  },
	  methods: {
	    saveInLocalStorage: function saveInLocalStorage() {
	      try {
	        if (typeof Storage !== 'undefined') {
	          window.localStorage.setItem('locale', this.locale);
	        }
	      } catch (e) {}
	    },
	    setLocale: function setLocale(userLocale) {
	      var lowerCaseLocale = userLocale.toLowerCase();
	      var fullCallLongLocales = ['ar-dz', 'ar-kw', 'ar-ly', 'ar-ma', 'ar-sa', 'ar-tn', 'de-at', 'de-ch', 'en-au', 'en-ca', 'en-gb', 'en-ie', 'en-nz', 'es-do', 'es-us', 'fr-ca', 'fr-ch', 'ms-my', 'nl-be', 'pt-br', 'sr-cyrl', 'zh-vn', 'zh-tw'];
	      if (fullCallLongLocales.indexOf(lowerCaseLocale) < 0) {
	        this.locale = lowerCaseLocale.substring(0, 2);
	      } else {
	        this.locale = lowerCaseLocale;
	      }
	      this.$emit('locale', lowerCaseLocale);
	    }
	  },
	  watch: {
	    locale: function locale(val) {
	      this.$emit('locale', val);
	      this.$i18n.locale = val;
	      _moment2.default.locale(val);
	    }
	  },
	  beforeMount: function beforeMount() {
	    try {
	      if (typeof Storage !== 'undefined') {
	        if (window.localStorage.getItem('locale') !== null) {
	          this.setLocale(window.localStorage.getItem('locale'));
	        } else {
	          try {
	            var browserLocale = navigator.language || navigator.userLanguage;
	            this.setLocale(browserLocale);
	          } catch (e) {
	            this.setLocale('en');
	          }
	        }
	      }
	    } catch (e) {
	      this.setLocale('en');
	    }
	  }
	};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'eventChanges',
	  components: { Loader: _Loader2.default },
	  props: {
	    eventId: {
	      type: Number,
	      default: 11794195
	    },
	    event: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          latest_activity: 'Seneste aktivitet',
	          no_changes: 'Ingen ændringer foretaget',
	          created: 'Oprettede',
	          added_room: 'Tilføjede lokale',
	          removed_room: 'Fjernede lokale',
	          added_user: 'Tilføjede person',
	          removed_user: 'Fjernede person',
	          changed_time: 'Ændrede tidspunkt',
	          ago: 'siden',
	          added_grade: 'Tilføjede klasse',
	          removed_grade: 'Fjernede klasse',
	          added_sub: 'Tilføjede vikar',
	          removed_sub: 'Fjernede vikar',
	          learning_goal_changed: 'Læringsmål ændrede',
	          content_changed: 'Indhold ændrede',
	          teacher_notes_changed: 'Vikarnoter ændrede',
	          notes_for_students_changed: 'Noter til elever ændrede'
	        },
	        en: {
	          latest_activity: 'Recent activity',
	          no_changes: 'No changes made',
	          created: 'Created',
	          added_user: 'Added teacher',
	          added_room: 'Added room',
	          removed_user: 'Removed the teacher',
	          changed_time: 'Changed time',
	          ago: 'ago',
	          added_grade: 'Added grade/group',
	          removed_grade: 'Removed grade/group',
	          added_sub: 'Added substitute',
	          removed_sub: 'Removed substitute',
	          learning_goal_changed: 'Learning goal changed',
	          content_changed: 'Content changed',
	          teacher_notes_changed: 'Teacher notes changed',
	          notes_for_students_changed: 'Notes for students changed'
	        },
	        nb: {
	          latest_activity: 'Historikk',
	          no_changes: 'Ingen endringer er blitt gjort',
	          created: 'Opprettet',
	          added_room: 'La til lokalet',
	          removed_room: 'Fjernet lokalet',
	          added_user: 'La til underviser',
	          removed_user: 'Fjernet underviseren',
	          changed_time: 'Endret tiden',
	          ago: 'siden',
	          added_grade: 'La til klasse',
	          removed_grade: 'Fjernet klasse',
	          added_sub: 'La til vikar',
	          removed_sub: 'Fjernet vikar',
	          learning_goal_changed: 'Læringsmål endret',
	          content_changed: 'Innhold endret',
	          teacher_notes_changed: 'Vikarnotater endret',
	          notes_for_students_changed: 'Notater for elever endret'
	        }
	      },
	      isLoading: true,
	      changes: []
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    changesFiltered: function changesFiltered() {
	      return this.changes.filter(function (change) {
	        return change;
	      });
	    },
	    sortedLogs: function sortedLogs() {
	      return this.changesFiltered.sort(function (a, b) {
	        if (b && b.at && a && a.at) {
	          return new Date(b.at) - new Date(a.at);
	        }
	      });
	    },
	    logsFormatted: function logsFormatted() {
	      var _this = this;
	
	      return this.sortedLogs.map(function (activity) {
	        return (0, _extends3.default)({}, activity, {
	          vFormattedDate: _this.formatDate(activity.at),
	          vDuration: _this.getDuration(activity.at),
	          vHumanizedChanges: _this.humanizeChanges(activity.changes)
	        });
	      });
	    }
	  },
	  methods: {
	    formatDate: function formatDate(datetime) {
	      return datetime ? (0, _moment2.default)(datetime).format('LLL') : datetime;
	    },
	    getDuration: function getDuration(datetime) {
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(datetime));
	      return _moment2.default.duration(diff).humanize();
	    },
	    changeCalendars: function changeCalendars(change) {
	      var text = '';
	
	      var addedArr = change.calendars.addded;
	      var removedArr = change.calendars.removed;
	
	      var users = { added: [], removed: [] };
	      var rooms = { added: [], removed: [] };
	      var subs = { added: [], removed: [] };
	      var klasses = { added: [], removed: [] };
	
	      addedArr.forEach(function (obj) {
	        if (obj.type === 'room') {
	          rooms.added.push(obj);
	        }
	        if (obj.type === 'user' && obj.substitute === null) {
	          users.added.push(obj);
	        }
	        if (obj.type === 'user' && obj.substitute !== null) {
	          subs.added.push(obj);
	        }
	        if (obj.type === 'klass') {
	          klasses.added.push(obj);
	        }
	      });
	      removedArr.forEach(function (obj) {
	        if (obj.type === 'room') {
	          rooms.removed.push(obj);
	        }
	        if (obj.type === 'klass') {
	          klasses.removed.push(obj);
	        }
	        if (obj.type === 'user' && obj.substitute === null) {
	          users.removed.push(obj);
	        }
	        if (obj.type === 'user' && obj.substitute !== null) {
	          subs.removed.push(obj);
	        }
	      });
	      if (rooms.added.length > 0) {
	        var i18nRoomChanges = '<b><span class="icon-location"></span> ' + this.i18n[this.locale]['added_room'] + '</b>';
	        var roomNames = rooms.added.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = i18nRoomChanges + ' ' + roomNames + '<br>';
	      }
	      if (rooms.removed.length > 0) {
	        var i18n = '<b><span class="icon-location"></span> ' + this.i18n[this.locale]['removed_room'] + '</b>';
	        var names = rooms.removed.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + i18n + ' ' + names + '<br>';
	      }
	      if (users.added.length > 0) {
	        var _i18n = '<b><span class="icon-user"></span> ' + this.i18n[this.locale]['added_user'] + '</b>';
	        var userNames = users.added.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n + ' ' + userNames + '<br>';
	      }
	      if (users.removed.length > 0) {
	        var _i18n2 = '<b><span class="icon-user"></span> ' + this.i18n[this.locale]['removed_user'] + '</b>';
	        var _userNames = users.removed.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n2 + ' ' + _userNames;
	      }
	      if (klasses.added.length > 0) {
	        var _i18n3 = '<b><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['added_grade'] + '</b>';
	        var _names = klasses.added.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = _i18n3 + ' ' + _names + '<br>';
	      }
	      if (klasses.removed.length > 0) {
	        var _i18n4 = '<b><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['removed_grade'] + '</b>';
	        var _names2 = klasses.removed.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n4 + ' ' + _names2 + '<br>';
	      }
	      if (subs.added.length > 0) {
	        var _i18n5 = '<b><span class="icon-users"></span> ' + this.i18n[this.locale]['added_sub'] + '</b>';
	        var _userNames2 = subs.added.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n5 + ' ' + _userNames2 + '<br>';
	      }
	      if (subs.removed.length > 0) {
	        var _i18n6 = '<b><span class="icon-users"></span> ' + this.i18n[this.locale]['removed_sub'] + '</b>';
	        var _userNames3 = subs.removed.map(function (obj) {
	          return obj.name;
	        }).join(', ');
	        text = text + _i18n6 + ' ' + _userNames3;
	      }
	      return text;
	    },
	    changeLearningGoalNotes: function changeLearningGoalNotes(changes) {
	      var txt = '<b><span class="icon-pencil"></span>' + this.i18n[this.locale]['learning_goal_changed'] + '</b>';
	      var from = changes.learning_goal.from.length < 1 ? '' : changes.learning_goal.from;
	      var to = changes.learning_goal.to;
	      return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>';
	    },
	    changeDescNotes: function changeDescNotes(changes) {
	      var txt = '<b><span class="icon-pencil"></span>' + this.i18n[this.locale]['content_changed'] + '</b>';
	      var from = changes.description.from.length < 1 ? '' : changes.description.from;
	      var to = changes.description.to;
	      return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>';
	    },
	    changeTeacherNotes: function changeTeacherNotes(changes) {
	      var txt = '<b><span class="icon-pencil"></span>' + this.i18n[this.locale]['teacher_notes_changed'] + '</b>';
	      var from = changes.teacher_notes.from.length < 1 ? '' : changes.teacher_notes.from;
	      var to = changes.teacher_notes.to;
	      return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>';
	    },
	    changeNotesForStudents: function changeNotesForStudents(changes) {
	      var txt = '<b><span class="icon-pencil"></span> ' + this.i18n[this.locale]['notes_for_students_changed'] + '</b>';
	      var from = changes.notes_for_students.from.length < 1 ? '' : changes.notes_for_students.from;
	      var to = changes.notes_for_students.to;
	      return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>';
	    },
	    changeTime: function changeTime(changes) {
	      var txt = '<b><span class="icon-clock"></span> ' + this.i18n[this.locale]['changed_time'] + '</b>';
	      var oldStartTime = (0, _moment2.default)(changes.start.start.from).format('dddd LT');
	      var newStartTime = (0, _moment2.default)(changes.start.start.to).format('dddd LT');
	      var oldEndTime = (0, _moment2.default)(changes.end.end.from).format('LT');
	      var newEndTime = (0, _moment2.default)(changes.end.end.to).format('LT');
	      return '<b>' + txt + '</b><br>' + oldStartTime + ' - ' + oldEndTime + ' <span><b>&#8594;</b></span>  ' + newStartTime + ' - ' + newEndTime;
	    },
	    changeStart: function changeStart(changes) {
	      var txt = '<b><span class="icon-clock"></span> Ændrede start</b>';
	      var oldStartTime = (0, _moment2.default)(changes.start.from).format('dddd LT');
	      var newStartTime = (0, _moment2.default)(changes.start.to).format('dddd LT');
	      return '<b>' + txt + '</b> Fra ' + oldStartTime + ' til ' + newStartTime;
	    },
	    changeEnd: function changeEnd(changes) {
	      var txt = '<b><span class="icon-clock"></span> Ændrede slut</b>';
	      var oldEndTime = (0, _moment2.default)(changes.end.from).format('dddd LT');
	      var newEndTime = (0, _moment2.default)(changes.end.to).format('dddd LT');
	      return '<b>' + txt + '</b> Fra ' + oldEndTime + ' til ' + newEndTime;
	    },
	    humanizeChanges: function humanizeChanges(lessonChanges) {
	      var txt = [];
	      if (lessonChanges) {
	        for (var i = 0; i < lessonChanges.length; i++) {
	          switch ((0, _keys2.default)(lessonChanges[i])[0]) {
	            case 'learning_goal':
	              txt.push(this.changeLearningGoalNotes(lessonChanges[i]));
	              break;
	            case 'description':
	              txt.push(this.changeDescNotes(lessonChanges[i]));
	              break;
	            case 'teacher_notes':
	              txt.push(this.changeTeacherNotes(lessonChanges[i]));
	              break;
	            case 'notes_for_students':
	              txt.push(this.changeNotesForStudents(lessonChanges[i]));
	              break;
	            case 'calendars':
	              txt.push(this.changeCalendars(lessonChanges[i]));
	              break;
	            case 'start':
	              if (lessonChanges[i + 1] && lessonChanges[i + 1].end) {
	                txt.push(this.changeTime({ start: lessonChanges[i], end: lessonChanges[i + 1] }));
	              } else {
	                txt.push(this.changeStart(lessonChanges[i]));
	              }
	              break;
	            case 'end':
	              if (lessonChanges[i - 1] && lessonChanges[i - 1].start) {
	                break;
	              } else {
	                txt.push(this.changeEnd(lessonChanges[i]));
	              }
	              break;
	            default:
	              txt.push('Changed something');
	          }
	        }
	      }
	      return txt;
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    var schoolId = window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.event.school_id;
	    _docendo2.default.eventChanges(schoolId, this.eventId, function (data) {
	      _this2.isLoading = false;
	      _this2.changes = data && data.length > 0 ? JSON.parse(data) : [];
	    });
	  }
	};

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'login',
	  created: function created() {
	    this.$on('docendo_state', function (data) {
	      if (data === 'connected') {
	        this.connected();
	      } else if (data === 'disconnected') {
	        this.disconnected();
	      }
	    });
	  },
	  methods: {
	    connected: function connected() {},
	    disconnected: function disconnected() {},
	    login: function login() {
	      var location = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	      console.log(location);
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	
	    close_on_click_away: {
	      type: Boolean,
	      default: false
	    },
	    modal_from_bottom: {
	      type: Boolean,
	      default: false
	    },
	    show_modal_mask: {
	      type: Boolean,
	      default: true
	    }
	  },
	  watch: {
	    show: function show() {
	      var body = document.querySelector('body');
	      this.show === true ? body.classList.add('no-scroll') : this.removeModal();
	    }
	  },
	  methods: {
	    setShowModal: function setShowModal() {
	      this.show = true;
	    },
	    removeModal: function removeModal() {
	      var body = document.querySelector('body');
	      this.show = false;
	      this.$emit('close');
	      body.classList.remove('no-scroll');
	    },
	    clickAway: function clickAway() {
	      this.close_on_click_away ? this.removeModal() : null;
	    }
	  }
	};

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var I18N = {
	  da: {
	    are_you_sure: 'Er du sikker på, at du vil slette denne?',
	    are_you_sure_own_calendar: 'Er du sikker på, at du vil slette denne brik? Det vil kun gælde for denne kalender og kan ikke fortrydes. Venligst bekræft, hvis du ønsker at fortsætte.',
	    delete: 'Slet',
	    cancel: 'Annuller',
	    dont_ask_me_again: 'Spørg mig ikke igen'
	  },
	  nb: {
	    are_you_sure: 'Er du sikker på at du vil slette dette?',
	    are_you_sure_own_calendar: 'Er du sikker på at du vil slette dette? Dette vil kun gjelde for denne kalenderen og kan ikke reverseres. Vennligst bekreft at du ønsker å fortsette.',
	    delete: 'Slett',
	    cancel: 'Annuller',
	    dont_ask_me_again: 'Ikke spør meg igjen'
	  },
	  en: {
	    are_you_sure: 'Are you sure that you want to delete this?',
	    are_you_sure_own_calendar: 'Are you sure you want to delete this? This will only apply to this calendar and cannot be undone. Please confirm if you wish to proceed.',
	    delete: 'Delete',
	    cancel: 'Cancel',
	    dont_ask_me_again: 'Don\'t ask me again'
	  }
	};
	
	exports.default = {
	  props: {
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    isOnlyOwnCalendarText: {
	      type: Boolean,
	      default: false
	    },
	    isSubmitButtonLoading: {
	      type: Boolean,
	      default: false
	    },
	    isShowDontAskAgain: {
	      type: Boolean,
	      default: false
	    },
	    propLocale: {
	      default: null
	    },
	    isShowConfirmDeleteMessage: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      isDontAskAgain: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return !this.propLocale ? I18N[this.locale] : I18N[this.propLocale];
	    }
	  },
	  methods: {
	    onConfirm: function onConfirm() {
	      this.$emit('confirm', this.isDontAskAgain);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      var el = _this.$refs.submit_bttn;
	      if (el) {
	        _this.$refs.submit_bttn.focus();
	      }
	    });
	    if (this.appendToBody) {
	      var el = this.$refs.d_modal;
	      var bod = document.getElementById('djs-content-container');
	      if (bod) {
	        bod.appendChild(el);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var el = this.$refs.d_modal;
	    if (el) {
	      el.remove();
	    }
	  }
	};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      onlyUnreadMessagesActive: false,
	      show: false,
	      messages: [],
	      unReadCounter: '',
	      lastId: '',
	      isAllLoaded: false,
	      isInitialLoad: true
	    };
	  },
	
	  methods: {
	    handleScrolledToBottom: function handleScrolledToBottom(isVisible) {
	      if (!isVisible) {
	        return;
	      }
	      this.getMessagesBefore(this.lastId);
	    },
	    close: function close() {
	      this.show = false;
	      this.messages = [];
	    },
	    open: function open() {
	      this.show = true;
	      this.getMessages();
	    },
	    toggle: function toggle(e) {
	      if (e.target.classList.contains('js-toggle-notifications')) {
	        if (!this.show) {
	          this.open();
	        } else {
	          this.close();
	        }
	      }
	    },
	    getMessages: function getMessages() {
	      this.isInitialLoad = true;
	      this.onlyUnreadMessagesActive = false;
	      _docendo2.default.getNotificationsList(5, this.receiveMessages);
	    },
	    getMessagesUnread: function getMessagesUnread() {
	      this.onlyUnreadMessagesActive = true;
	      _docendo2.default.getNotificationsListUnread(5, true, this.receiveMessages);
	    },
	    getMessagesBefore: function getMessagesBefore(id) {
	      if (!this.onlyUnreadMessagesActive) {
	        _docendo2.default.getNotificationsBefore(5, id, this.pushMessages);
	      } else {
	        _docendo2.default.getNotificationsUnreadBeforeId(5, true, id, this.pushMessages);
	      }
	    },
	    receiveMessages: function receiveMessages(messages) {
	      this.messages = messages;
	      this.isAllLoaded = false;
	      this.isInitialLoad = false;
	
	      if (messages < 1) {
	        this.isAllLoaded = true;
	        return;
	      }
	      this.lastId = messages[messages.length - 1].id;
	    },
	    pushMessages: function pushMessages(messages) {
	      if (messages < 1) {
	        this.isAllLoaded = true;
	        return;
	      }
	      this.lastId = messages[messages.length - 1].id;
	      this.messages = this.messages.concat(messages);
	    },
	    readStatusRead: function readStatusRead(e, index, id, read) {
	      if (this.messages[index].read === false) {
	        this.unReadCounter === 0 ? this.unReadCounter = '' : this.unReadCounter = this.unReadCounter - 1;
	      }
	      this.messages[index].read = true;
	      _docendo2.default.updateNotification(id, { read: read }, this.updateMessage);
	    },
	    changeReadStatus: function changeReadStatus(e, index, id, read) {
	      var _this = this;
	
	      e.preventDefault();
	      read === true ? this.unReadCounter = this.unReadCounter - 1 : this.unReadCounter++;
	
	      this.messages[index].read = !this.messages[index].read;
	      _docendo2.default.updateNotification(id, { read: read }, function (data) {
	        _this.updateMessage(data);
	      });
	    },
	    updateMessage: function updateMessage(data) {
	      console.log('updateMessage', data);
	    },
	    markAllAsRead: function markAllAsRead() {
	      for (var i = 0; i < this.messages.length; i++) {
	        this.messages[i].read = true;
	      }
	      this.unReadCounter = 0;
	      _docendo2.default.markAllNotificationsAsRead();
	    },
	    unreadCount: function unreadCount() {
	      _docendo2.default.notificationsUnreadCount(this.updateUnreadCount);
	    },
	    updateUnreadCount: function updateUnreadCount(count) {
	      count >= 1 ? this.unReadCounter = count : this.unReadCounter = '';
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.unreadCount();
	    _docendo2.default.bind('new_notification', function (data) {
	      _this2.unreadCount();
	    });
	  }
	};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _PermissionsUserChange = __webpack_require__(316);
	
	var _PermissionsUserChange2 = _interopRequireDefault(_PermissionsUserChange);
	
	var _PermissionsUser = __webpack_require__(1276);
	
	var _PermissionsUser2 = _interopRequireDefault(_PermissionsUser);
	
	var _vueVirtualScrollList = __webpack_require__(360);
	
	var _vueVirtualScrollList2 = _interopRequireDefault(_vueVirtualScrollList);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  en: {
	    administrator: 'Administrator',
	    read_only_user: 'Read only user',
	    regular_user: 'Regular user'
	  },
	  da: {
	    administrator: 'Administrator',
	    read_only_user: 'Skrivebeskyttet bruger',
	    regular_user: 'Normal bruger'
	  },
	  nb: {
	    administrator: 'Administrator',
	    read_only_user: 'Lesetilgang',
	    regular_user: 'Vanlig bruker'
	  }
	};
	exports.default = {
	  components: {
	    Loader: _Loader2.default,
	    DModal: _DModal2.default, DDropdown: _DDropdown2.default, AppToggle: _AppToggle2.default, DSelect: _DSelect2.default, PermissionsUserChange: _PermissionsUserChange2.default, PermissionsUser: _PermissionsUser2.default, virtualList: _vueVirtualScrollList2.default
	  },
	  data: function data() {
	    return {
	      itemComponent: _PermissionsUser2.default,
	      permissions: [],
	      roles: [],
	      isLoadingRoles: true,
	      users: [],
	      activeRoleId: null,
	      isRoleModal: false,
	      createNewRoleName: '',
	      theEditRole: null,
	      theDeleteRole: null,
	      existingRoleToCopyId: null,
	      isSavingWithoutInput: false,
	      debounceTimer: null
	    };
	  },
	
	  computed: {
	    isInputFieldLength: function isInputFieldLength() {
	      return this.createNewRoleName.length > 0;
	    },
	    schoolId: function schoolId() {
	      if (this.$route && this.$route.params && this.$route.params.school_id) {
	        return this.$route.params.school_id;
	      }
	      return this.$store.getters.schoolId;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    rolesWithMeta: function rolesWithMeta() {
	      var rolesMap = {
	        'Read only user': { v_title: I18N[this.locale].read_only_user, v_sort: 3 },
	        'Regular user': { v_title: I18N[this.locale].regular_user, v_sort: 2 },
	        'Administrator': { v_title: I18N[this.locale].administrator, v_sort: 1 }
	      };
	
	      var roles = this.roles.map(function (role) {
	        var vRoleType = role.permissions.includes('can_manage_users') ? 'admin' : role.permissions.includes('can_do_most_stuff') ? 'normalUser' : 'readOnly';
	
	        return (0, _extends3.default)({}, role, rolesMap[role.name] || { v_title: role.name }, {
	          vRoleType: vRoleType
	        });
	      });
	
	      var sortedRoles = roles.sort(function (a, b) {
	        if (a.v_sort && b.v_sort) {
	          return a.v_sort - b.v_sort;
	        } else if (a.v_sort) {
	          return -1;
	        } else if (b.v_sort) {
	          return 1;
	        } else {
	          return a.v_title.localeCompare(b.v_title);
	        }
	      });
	
	      return sortedRoles;
	    },
	    rolesToCopy: function rolesToCopy() {
	      return this.rolesWithMeta.filter(function (role) {
	        return role.vRoleType !== 'admin';
	      });
	    },
	    activeRole: function activeRole() {
	      var _this = this;
	
	      var idx = this.roles.findIndex(function (role) {
	        return role.id === _this.activeRoleId;
	      });
	      return this.roles[idx];
	    },
	    usersWithActiveRole: function usersWithActiveRole() {
	      var _this2 = this;
	
	      if (!this.activeRole) {
	        return [];
	      }
	      var users = this.activeRole.user_ids.map(function (userId) {
	        return _this2.allUsersInHash[userId];
	      });
	      users = users.filter(function (user) {
	        return user.name;
	      });
	      return this.$helpers.sortArrOnName(users);
	    },
	    allUsersSortedByName: function allUsersSortedByName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    usersForDSelect: function usersForDSelect() {
	      var _this3 = this;
	
	      return this.activeRole ? this.allUsersSortedByName.filter(function (user) {
	        return _this3.activeRole.user_ids.indexOf(user.id) < 0;
	      }) : this.allUsersSortedByName;
	    },
	    selectableRoles: function selectableRoles() {
	      var _this4 = this;
	
	      return this.rolesWithMeta.filter(function (role) {
	        return role.id !== _this4.activeRole.id;
	      });
	    },
	    activeChangeRoleUserId: function activeChangeRoleUserId() {
	      return _eventbus2.default.activeChangeRoleId;
	    },
	    activePermissions: function activePermissions() {
	      var _this5 = this;
	
	      var normalUserPermissions = ['can_see_other_subject_requests', 'can_edit_subject_requests', 'can_edit_user_year_notes', 'can_change_substitution', 'can_edit_own_presence', 'can_edit_others_presence', 'can_see_subjects_distribution_page', 'can_manage_assigned_hours', 'can_see_assigned_hours', 'can_manage_calendars', 'can_manage_absence_reasons', 'can_see_own_task_overview', 'can_see_others_task_overviews', 'can_manage_tasks'].filter(function (permission) {
	        return !(_this5.isKindergarten && permission === 'can_see_subjects_distribution_page');
	      });
	
	      if (!this.activeRole) {
	        return [];
	      }
	
	      var filteredPermissions = [];
	      var isNormalUser = this.activeRole.permissions.includes('can_do_most_stuff');
	
	      switch (this.activeRole.name) {
	        case 'Read only user':
	          filteredPermissions = this.permissions.filter(function (permission) {
	            return ['can_edit_subject_requests', 'can_edit_own_notes', 'can_see_other_calendars', 'can_see_own_task_overview', 'can_see_others_task_overviews', 'can_edit_own_presence'].includes(permission);
	          });
	          break;
	        case 'Regular user':
	          filteredPermissions = this.permissions.filter(function (permission) {
	            return normalUserPermissions.includes(permission);
	          });
	          break;
	        case 'Administrator':
	          filteredPermissions = [];
	          break;
	        default:
	          if (isNormalUser) {
	            filteredPermissions = this.permissions.filter(function (permission) {
	              return normalUserPermissions.includes(permission);
	            });
	          } else {
	            filteredPermissions = this.permissions.filter(function (permission) {
	              return ['can_edit_own_notes', 'can_see_other_calendars', 'can_see_own_task_overview', 'can_see_others_task_overviews', 'can_edit_own_presence'].includes(permission);
	            });
	          }
	      }
	
	      return filteredPermissions.map(function (permission) {
	        return {
	          permission: permission,
	          vTitle: _this5.$t('vue2.permissions.' + permission) || permission
	        };
	      }).sort(function (a, b) {
	        return a.vTitle.localeCompare(b.vTitle);
	      });
	    },
	    getRoleDesc: function getRoleDesc() {
	      if (!this.activeRole) {
	        return '';
	      }
	      switch (this.activeRole.name) {
	        case 'Administrator':
	          return this.$t('vue2.permissions.role_desc_administrator');
	        case 'Read only user':
	          return this.$t('vue2.permissions.role_desc_read_only_user');
	        case 'Regular user':
	          return this.$t('vue2.permissions.role_desc_regular_user');
	        default:
	          return '';
	      }
	    }
	  },
	  methods: {
	    onInput: function onInput(evt) {
	      var _this6 = this;
	
	      var val = evt.target.value;
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this6.createNewRoleName = val;
	      }, 0);
	    },
	    getIsPermissioni18n: function getIsPermissioni18n(permission) {
	      if (!this.isKindergarten) {
	        return false;
	      }
	      var kindergartenI18N = {
	        can_see_others_task_overviews: 'Kan se andres årsnormsoversigt',
	        can_see_own_task_overview: 'Kan se egen årsnormsoversigt'
	      };
	      return kindergartenI18N[permission];
	    },
	    readPermissions: function readPermissions() {
	      var _this7 = this;
	
	      _docendo2.default.permissionSetsPermissions(this.schoolId, function (data) {
	        _this7.permissions = data;
	      }, function (failure) {
	        console.log('something went wrong', failure);
	      });
	    },
	    readPermissionSets: function readPermissionSets() {
	      var _this8 = this;
	
	      this.isLoadingRoles = true;
	      _docendo2.default.permissionSetsRead(this.schoolId, function (data) {
	        _this8.roles = data.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        });
	        _this8.isLoadingRoles = false;
	        if (_this8.roles[0]) {
	          _this8.setActiveRole(_this8.roles[0]);
	        }
	      }, function (failure) {
	        console.log('something went wrong', failure);
	        _this8.isLoadingRoles = false;
	      });
	    },
	    createNewRole: function createNewRole() {
	      var _this9 = this;
	
	      var existingRole = this.rolesToCopy.find(function (role) {
	        return Number(role.id) === Number(_this9.existingRoleToCopyId);
	      });
	      var permissions = [];
	      if (existingRole) {
	        console.log('existingRole', existingRole);
	        permissions = existingRole.permissions;
	      }
	      this.isLoadingRoles = true;
	      _docendo2.default.permissionSetsCreate(this.schoolId, this.createNewRoleName, permissions, function (data) {
	        _eventbus2.default.toast = { text: _this9.$t('vue2.permissions.role_created'), 'success': true };
	        _this9.roles.push(data);
	        _this9.isLoadingRoles = false;
	        _this9.setActiveRole(data);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this9.$t('vue2.toast.something_went_wrong'), 'success': false };
	        _this9.isLoadingRoles = false;
	      });
	      this.isRoleModal = false;
	      this.resetCreateRoleForm();
	    },
	    updateRoleName: function updateRoleName() {
	      var _this10 = this;
	
	      var idx = this.roles.findIndex(function (role) {
	        return role.id === _this10.theEditRole.id;
	      });
	      _docendo2.default.permissionSetsUpdate(this.schoolId, this.theEditRole.id, this.createNewRoleName, this.theEditRole.permissions, function (data) {
	        _eventbus2.default.toast = { text: _this10.$t('vue2.permissions.role_updated'), 'success': true };
	        _this10.$set(_this10.roles, idx, data);
	        _this10.setActiveRole(data);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this10.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	      this.resetCreateRoleForm();
	      this.isRoleModal = false;
	    },
	    resetCreateRoleForm: function resetCreateRoleForm() {
	      this.isSavingWithoutInput = false;
	      this.theEditRole = null;
	      this.createNewRoleName = '';
	      var defaultRole = this.rolesToCopy.find(function (role) {
	        return role.name === 'Read only user';
	      });
	      this.existingRoleToCopyId = defaultRole ? defaultRole.id : null;
	    },
	    setTheDeleteRole: function setTheDeleteRole(role) {
	      this.theDeleteRole = role;
	      this.setIsRoleModal(true);
	    },
	    deleteRole: function deleteRole() {
	      var _this11 = this;
	
	      _docendo2.default.permissionSetsDelete(this.schoolId, this.theDeleteRole.id, function (success) {
	        _eventbus2.default.toast = { text: _this11.$t('vue2.permissions.role_deleted'), 'success': true };
	        var idx = _this11.roles.findIndex(function (role) {
	          return role.id === _this11.theDeleteRole.id;
	        });
	        _this11.roles.splice(idx, 1);
	        _this11.theDeleteRole = null;
	        _this11.setIsRoleModal(false);
	        _this11.setActiveRole(_this11.roles[0]);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this11.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    togglePermissionToRole: function togglePermissionToRole(permission) {
	      var _this12 = this;
	
	      var rolePermissions = this.activeRole.permissions;
	      var rolePermissionIdx = rolePermissions.indexOf(permission);
	      if (rolePermissionIdx < 0) {
	        rolePermissions.push(permission);
	      } else {
	        rolePermissions.splice(rolePermissionIdx, 1);
	      }
	      _docendo2.default.permissionSetsUpdate(this.schoolId, this.activeRole.id, this.activeRole.name, rolePermissions, function (data) {
	        _eventbus2.default.toast = { text: _this12.$t('vue2.permissions.role_updated'), 'success': true };
	        var roleIdx = _this12.roles.findIndex(function (role) {
	          return role.id === data.id;
	        });
	        _this12.$set(_this12.roles, roleIdx, data);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this12.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    isPermissionInActiveRole: function isPermissionInActiveRole(permission) {
	      return this.activeRole ? this.activeRole.permissions.indexOf(permission) > -1 : false;
	    },
	    setActiveRole: function setActiveRole(role) {
	      this.activeRoleId = role.id;
	    },
	    isActiveRole: function isActiveRole(role) {
	      if (!this.activeRole) {
	        return false;
	      }
	      return this.activeRole && this.activeRole.name === role.name;
	    },
	    onNoInput: function onNoInput() {
	      var _this13 = this;
	
	      this.isSavingWithoutInput = true;
	      setTimeout(function (_) {
	        _this13.isSavingWithoutInput = false;
	      }, 1500);
	      this.$refs.roleCreateInputField.focus();
	    },
	    setIsRoleModal: function setIsRoleModal(boolean) {
	      var _this14 = this;
	
	      if (boolean) {
	        this.isRoleModal = true;
	        setTimeout(function (_) {
	          if (_this14.$refs.roleCreateInputField) {
	            _this14.$refs.roleCreateInputField.focus();
	          }
	        }, 500);
	        var defaultRole = this.rolesToCopy.find(function (role) {
	          return role.name === 'Read only user';
	        });
	        this.existingRoleToCopyId = defaultRole ? defaultRole.id : null;
	      } else {
	        this.isRoleModal = false;
	        this.createNewRoleName = '';
	        this.theEditRole = null;
	        this.theDeleteRole = null;
	      }
	    },
	    setTheEditRole: function setTheEditRole(role) {
	      this.theEditRole = role;
	      this.createNewRoleName = role.name;
	      this.setIsRoleModal(true);
	    },
	    addUserToRole: function addUserToRole(user) {
	      var _this15 = this;
	
	      var roleIdx = this.roles.findIndex(function (role) {
	        return role.id === _this15.activeRole.id;
	      });
	      _docendo2.default.schoolUsersAssignPermissionSet(window.SCHOOL.id, user.id, this.activeRole.id, function (success) {
	        _this15.removeFromAllRoles(user);
	        _this15.roles[roleIdx].user_ids.push(user.id);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this15.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    setRole: function setRole(roleFromDropdown) {
	      var _this16 = this;
	
	      var user = {
	        name: '',
	        id: this.activeChangeRoleUserId
	      };
	      var roleIdx = this.roles.findIndex(function (role) {
	        return role.id === roleFromDropdown.id;
	      });
	      _docendo2.default.schoolUsersAssignPermissionSet(window.SCHOOL.id, this.activeChangeRoleUserId, roleFromDropdown.id, function (success) {
	        _this16.roles[roleIdx].user_ids.push(_this16.activeChangeRoleUserId);
	        _this16.removeFromActiveRole(user);
	        _eventbus2.default.activeChangeRoleId = null;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this16.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    removeFromAllRoles: function removeFromAllRoles(user) {
	      var _this17 = this;
	
	      this.roles.forEach(function (role, idx) {
	        var userIdx = role.user_ids.indexOf(user.id);
	        if (userIdx > -1) {
	          _this17.roles[idx].user_ids.splice(userIdx, 1);
	        }
	      });
	    },
	    removeFromActiveRole: function removeFromActiveRole(user) {
	      var _this18 = this;
	
	      var roleIdx = this.roles.findIndex(function (role) {
	        return role.id === _this18.activeRoleId;
	      });
	      var userIdx = this.roles[roleIdx].user_ids.indexOf(user.id);
	      if (userIdx > -1) {
	        this.roles[roleIdx].user_ids.splice(userIdx, 1);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsers');
	    this.readPermissions();
	    this.readPermissionSets();
	  }
	};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _PermissionsUserChange = __webpack_require__(316);
	
	var _PermissionsUserChange2 = _interopRequireDefault(_PermissionsUserChange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'item-component',
	  components: { PermissionsUserChange: _PermissionsUserChange2.default },
	  props: {
	    selectableRoles: {},
	    index: {
	      type: Number
	    },
	    source: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  computed: {
	    activeChangeId: function activeChangeId() {
	      return _eventbus2.default.activeChangeRoleId;
	    }
	  },
	  methods: {
	    setChangeRole: function setChangeRole() {
	      if (_eventbus2.default.activeChangeRoleId === this.source.id) {
	        _eventbus2.default.activeChangeRoleId = null;
	      } else {
	        _eventbus2.default.activeChangeRoleId = this.source.id;
	      }
	    }
	  }
	};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(18);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    roles: {
	      type: Array
	    }
	  },
	  data: function data() {
	    return {
	      isDropDown: false,
	      isDropdownPopperDone: false,
	      activeDiv: null
	    };
	  },
	
	  computed: {
	    activeChangeRoleId: function activeChangeRoleId() {
	      return _eventbus2.default.activeChangeRoleId;
	    }
	  },
	  watch: {
	    activeChangeRoleId: function activeChangeRoleId(val) {
	      var _this = this;
	
	      if (val) {
	        this.isDropdownPopperDone = false;
	        this.activeDiv = document.querySelector('.role-change__selector__placeholder[data-user-id="' + val + '"]');
	        this.isDropDown = true;
	        setTimeout(function (_) {
	          _this.createPopper();
	          _this.isDropdownPopperDone = true;
	        }, 0);
	      } else {
	        _eventbus2.default.activeChangeRoleId = null;
	        this.isDropDown = false;
	        this.isDropdownPopperDone = false;
	      }
	    }
	  },
	  methods: {
	    createPopper: function createPopper() {
	      (0, _core.createPopper)(this.activeDiv, this.$refs.role_child, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 5]
	          }
	        }]
	      });
	    },
	    setRole: function setRole(role) {
	      this.$emit('set', role);
	      this.isDropDown = false;
	    },
	    setDropdown: function setDropdown() {
	      var _this2 = this;
	
	      if (this.isDropDown) {
	        _eventbus2.default.activeChangeRoleId = null;
	        this.isDropDown = false;
	        this.isDropdownPopperDone = false;
	      } else {
	        this.isDropDown = true;
	        setTimeout(function (_) {
	          _this2.createPopper();
	          _this2.isDropdownPopperDone = true;
	        }, 0);
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick(el) {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    }
	  }
	};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _PresenceUser = __webpack_require__(70);
	
	var _PresenceUser2 = _interopRequireDefault(_PresenceUser);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DModal: _DModal2.default,
	    Loader: _Loader2.default,
	    TaggingFilter: _TaggingFilter2.default,
	    PresenceUser: _PresenceUser2.default
	  },
	  data: function data() {
	    return {
	      selectedIds: {},
	      selectedTags: [],
	      tags: [],
	      i18n: {
	        da: {
	          add_presence_to_many_user: 'Tildel arbejdstider til flere brugere',
	          of: 'af',
	          no_users_created: 'Ingen brugere oprettet'
	        },
	        en: {
	          add_presence_to_many_user: 'Add working hours to multiple users',
	          of: 'of',
	          no_users_created: 'No users created'
	        },
	        nb: {
	          add_presence_to_many_user: 'Legg inn arbeidstider for flere brukere',
	          of: 'av',
	          no_users_created: 'Ingen brukere opprettet'
	        }
	      }
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    firstDayOfWeek: function firstDayOfWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    },
	    selectedIdsLength: function selectedIdsLength() {
	      return (0, _keys2.default)(this.selectedIds).length;
	    },
	    users: function users() {
	      return this.$store.getters.userCalendars;
	    },
	    usersFiltered: function usersFiltered() {
	      var _this = this;
	
	      if (this.selectedTags.length === 0) {
	        return this.users;
	      }
	      return this.users.filter(function (user) {
	        return _this.selectedTags.some(function (tag) {
	          return user.user_tags.includes(tag);
	        });
	      });
	    },
	    usersWithProps: function usersWithProps() {
	      var _this2 = this;
	
	      return this.usersFiltered.map(function (user) {
	        _this2.$set(user, 'v_isSelected', _this2.isUserSelected(user.id));
	        return user;
	      });
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    }
	  },
	  methods: {
	    isUserSelected: function isUserSelected(userId) {
	      return this.selectedIds[userId];
	    },
	    toggleUser: function toggleUser(userId) {
	      if (this.isUserSelected(userId)) {
	        this.$delete(this.selectedIds, userId);
	      } else {
	        this.$set(this.selectedIds, userId, true);
	      }
	    },
	    selectAll: function selectAll() {
	      var _this3 = this;
	
	      this.usersWithProps.forEach(function (user) {
	        _this3.$set(_this3.selectedIds, user.id, true);
	      });
	    },
	    unSelectAll: function unSelectAll() {
	      var _this4 = this;
	
	      this.usersWithProps.forEach(function (user) {
	        _this4.$delete(_this4.selectedIds, user.id);
	      });
	    },
	    getTags: function getTags() {
	      var _this5 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this5.tags = data;
	      });
	    },
	    setTag: function setTag(tag) {
	      this.unSelectAll();
	      this.selectedTags.push(tag);
	    },
	    removeTag: function removeTag(tag) {
	      this.unSelectAll();
	      this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
	    },
	    savePresence: function savePresence(emitData) {
	      _eventbus2.default.toast = { text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	      emitData.calendarIds = (0, _keys2.default)(this.selectedIds);
	      console.log('emitData.eventsToCreate', emitData.eventsToCreate);
	      _docendo2.default.createPresenceForMany(this.schoolId, emitData.calendarIds, emitData.pasteInWeeks, emitData.eventsToCreate, function (success) {
	        console.log('success', success);
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	      this.unSelectAll();
	    },
	    close: function close() {
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    this.getTags();
	  }
	};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _PresenceUserEditEvent = __webpack_require__(1278);
	
	var _PresenceUserEditEvent2 = _interopRequireDefault(_PresenceUserEditEvent);
	
	var _WeekPicker = __webpack_require__(1279);
	
	var _WeekPicker2 = _interopRequireDefault(_WeekPicker);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CustomEvent = __webpack_require__(138);
	
	var _CustomEvent2 = _interopRequireDefault(_CustomEvent);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	exports.default = {
	  components: { EditEvent: _PresenceUserEditEvent2.default, WeekPicker: _WeekPicker2.default, Spinner: _Spinner2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    calid: {
	      type: Number
	    },
	    firstDayOfWeek: {
	      default: 1
	    },
	    activeCalendarDate: {
	      default: function _default() {
	        return moment().format('YYYY-MM-DD');
	      }
	    },
	    isModalLeft: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: true,
	      modal: false,
	      durations: [],
	      intersections: [],
	      events: [],
	      deletedEventIds: [],
	      pasteInWeeks: [],
	      showWeekSelector: false,
	      currentDateIsNotWithinCalendarRange: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isOwnCalendar: function isOwnCalendar() {
	      return this.user && this.user.user_calendar_id === this.calid;
	    },
	    userHasPermissionToEdit: function userHasPermissionToEdit() {
	      if (this.isOwnCalendar) {
	        return this.userHasPermission('can_edit_own_presence');
	      } else {
	        return this.userHasPermission('can_edit_others_presence');
	      }
	    },
	    weekDays: function weekDays() {
	      var days = [];
	
	      var start = this.firstDayOfWeek;
	      for (var i = 0; i < 7; i++) {
	        days.push(moment(this.activeCalendarDate).day(start));
	        start++;
	      }
	      return days;
	    },
	    totalDurationWeek: function totalDurationWeek() {
	      var arr = [];
	      this.events.forEach(function (event) {
	        arr.push(event.tempDuration);
	      });
	      return arr.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	    },
	    eventsToCreate: function eventsToCreate() {
	      var arr = this.events.filter(function (event) {
	        return event.tempNew === true;
	      });
	      var newArr = [];
	      arr.forEach(function (obj) {
	        newArr.push({
	          calendar_id: obj.calendar_id,
	          start: obj.start,
	          end: obj.end
	        });
	      });
	      return newArr;
	    },
	    eventsToUpdate: function eventsToUpdate() {
	      var arr = this.events.filter(function (event) {
	        return event.toUpdate === true;
	      });
	      var newArr = [];
	      arr.forEach(function (obj) {
	        newArr.push({
	          id: obj.event_id,
	          calendar_id: obj.calendar_id,
	          start: obj.start,
	          end: obj.end
	        });
	      });
	      return newArr;
	    },
	    hasWeekendEvents: function hasWeekendEvents() {
	      return this.events.some(function (event) {
	        var startDate = moment(event.start);
	        var dayOfWeek = startDate.day();
	        return dayOfWeek === 0 || dayOfWeek === 6;
	      });
	    }
	  },
	  watch: {
	    events: function events() {
	      this.$emit('events', this.events);
	    }
	  },
	  filters: {
	    dayOfWeek: function dayOfWeek(date) {
	      return moment(date).format('dddd');
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setCurrentDateIsNotWithinCalendarRange: function setCurrentDateIsNotWithinCalendarRange(val) {
	      this.currentDateIsNotWithinCalendarRange = val;
	    },
	    durationAsHoursAndMin: function durationAsHoursAndMin(inMinutes) {
	      var hours = Math.floor(inMinutes / 60);
	      var minutes = inMinutes - hours * 60;
	      return hours + ' ' + this.$t('vue2.presence.hours') + ' ' + minutes + ' ' + this.$t('vue2.presence.minutes');
	    },
	    readCurrentEvents: function readCurrentEvents() {
	      this.getAllEvents();
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    open: function open() {
	      if (this.calid) {
	        this.readCurrentEvents();
	      } else {
	        this.isLoading = false;
	        this.events = [];
	      }
	      this.modal = true;
	      this.pasteInWeeks = [];
	    },
	    close: function close() {
	      if (!this.modal) {
	        return;
	      }
	      this.$emit('close');
	      this.deletedEventIds = [];
	      this.modal = false;
	      this.showWeekSelector = false;
	      this.cleanAllIntersections();
	      if (this.calid) {
	        this.getAllEvents();
	      }
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return moment(firstDate).format('YYYY-MM-DD') === moment(secondDate).format('YYYY-MM-DD');
	    },
	    lastEventOfDayIsCloseToMidnight: function lastEventOfDayIsCloseToMidnight(weekDay) {
	      var _this = this;
	
	      var dayEvents = this.events.filter(function (event) {
	        return _this.compareDates(event.start, weekDay);
	      });
	      if (dayEvents.length > 1) {
	        var lastEventEnd = moment(dayEvents[dayEvents.length - 1].end).utc();
	        if (moment(lastEventEnd).local().format('HH') * 1 === 23 && moment(lastEventEnd).local().format('mm') * 1 > 49) {
	          return true;
	        }
	      }
	      return false;
	    },
	    addEvent: function addEvent(weekDay) {
	      var _this2 = this;
	
	      var start = void 0;
	      var end = void 0;
	      var dayEvents = this.events.filter(function (event) {
	        return _this2.compareDates(event.start, weekDay);
	      });
	      if (dayEvents.length < 1) {
	        start = moment(weekDay).set({ 'hour': 8, 'minutes': 0, 'seconds': 0, 'milliseconds': 0 });
	        end = moment(weekDay).set({ 'hour': 16, 'minutes': 0, 'seconds': 0, 'milliseconds': 0 });
	      } else {
	        if (this.lastEventOfDayIsCloseToMidnight(weekDay)) {
	          return;
	        }
	        var lastEventEnd = moment(dayEvents[dayEvents.length - 1].end);
	        var add5Min = lastEventEnd.add(5, 'minutes');
	        start = moment(weekDay).set({
	          'hour': add5Min.format('HH'),
	          'minutes': add5Min.format('mm'),
	          'seconds': 0,
	          'milliseconds': 0
	        });
	        var add10Min = lastEventEnd.add(10, 'minutes');
	        end = moment(weekDay).set({
	          'hour': add10Min.format('HH'),
	          'minutes': add10Min.format('mm'),
	          'seconds': 0,
	          'milliseconds': 0
	        });
	      }
	      var event = {
	        calendar_id: this.calid,
	        start_time: start.utc().toISOString(),
	        end_time: end.utc().toISOString(),
	        start: start.utc().toISOString(),
	        end: end.utc().toISOString(),
	        rendering: 'background',
	        className: 'fc-bgevent__presence',
	        deleted: false,
	        tempId: Date.now(),
	        tempDuration: 0,
	        tempIntersect: false,
	        tempNew: true
	      };
	      this.events.push(event);
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    deleteEvent: function deleteEvent(presenceEvent) {
	      if (presenceEvent.event_id) {
	        this.deletedEventIds.push(presenceEvent.event_id);
	      }
	      var idx = this.events.findIndex(function (event) {
	        return event.tempId === presenceEvent.tempId;
	      });
	      this.events.splice(idx, 1);
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    updateStart: function updateStart(tempIdAndStarTime) {
	      var idx = this.events.findIndex(function (event) {
	        return event.tempId === tempIdAndStarTime.tempId;
	      });
	      this.events[idx].start = tempIdAndStarTime.startTime;
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    updateEnd: function updateEnd(tempIdAndEndTime) {
	      var idx = this.events.findIndex(function (event) {
	        return event.tempId === tempIdAndEndTime.tempId;
	      });
	      this.events[idx].end = tempIdAndEndTime.endTime;
	      this.cleanAllIntersections();
	      this.checkAllWithAllForIntersection();
	    },
	    setEventDurations: function setEventDurations(idAndDurationInMinutes) {
	      var idx = this.events.findIndex(function (event) {
	        return event.tempId === idAndDurationInMinutes.tempId;
	      });
	      this.events[idx].tempDuration = idAndDurationInMinutes.asMinutes;
	    },
	    cleanAllIntersections: function cleanAllIntersections() {
	      this.intersections = [];
	      for (var i = 0; i < this.events.length; i++) {
	        this.events[i].tempIntersect = false;
	      }
	    },
	    checkTwoDatesForIntersection: function checkTwoDatesForIntersection(idx1, idx2) {
	      var range1 = moment.range(this.events[idx1].start, this.events[idx1].end);
	      var range2 = moment.range(this.events[idx2].start, this.events[idx2].end);
	      if (range1.intersect(range2)) {
	        return true;
	      }
	    },
	    checkAllWithAllForIntersection: function checkAllWithAllForIntersection() {
	      for (var i = 0; i < this.events.length; i++) {
	        for (var j = 0; j < this.events.length; j++) {
	          if (i !== j) {
	            if (this.checkTwoDatesForIntersection(i, j)) {
	              this.events[i].tempIntersect = true;
	              this.intersections.push(this.events[j]);
	            }
	          }
	        }
	      }
	    },
	    setPastedWeeks: function setPastedWeeks(weekArray) {
	      this.pasteInWeeks = weekArray;
	    },
	    getAllEvents: function getAllEvents() {
	      var _this3 = this;
	
	      var start = moment(this.activeCalendarDate).day(this.firstDayOfWeek).startOf('day');
	
	      var end = moment(this.activeCalendarDate).day(this.firstDayOfWeek + 6).endOf('day');
	
	      this.isLoading = true;
	
	      _docendo2.default.calendarEvents2([this.calid], start, end, ['presence'], function (data) {
	        _this3.isLoading = false;
	        var events = data.length > 0 ? JSON.parse(data) : [];
	
	        var sortedEvents = events.filter(function (event) {
	          return event.event_type === 'presence';
	        }).sort(function (a, b) {
	          return new Date(a.start) - new Date(b.start);
	        });
	
	        var tempIdCounter = 0;
	
	        _this3.events = sortedEvents.map(function (event) {
	          return (0, _extends3.default)({}, event, {
	            rendering: 'background',
	            className: 'fc-bgevent__presence',
	            tempDuration: 0,
	            tempId: tempIdCounter++,
	            tempIntersect: false,
	            toUpdate: true
	          });
	        });
	      }, function (error) {
	        console.log(error);
	      });
	    },
	    savePresence: function savePresence() {
	      var _this4 = this;
	
	      if (this.calid) {
	        console.log('this.activeCalendarDate', this.activeCalendarDate);
	
	        var dbDate = moment(this.activeCalendarDate).day(this.firstDayOfWeek).format('YYYY-MM-DD');
	        console.log({ dbDate: dbDate });
	        _docendo2.default.bulkPresenceEvent(this.calid, this.eventsToCreate, this.eventsToUpdate, this.deletedEventIds, function (data) {
	          _this4.$emit('saved', data);
	
	          if (_this4.pasteInWeeks.length > 0) {
	            _eventbus2.default.toast = { text: _this4.$i18n.t('vue2.copycalendar.noticationMessage'), success: false };
	            _docendo2.default.calendarCopyWeeks(_this4.calid, dbDate, _this4.pasteInWeeks, true, 'presence', function (success) {});
	          }
	        });
	      } else {
	        var emitObj = {
	          eventsToCreate: this.eventsToCreate,
	          pasteInWeeks: this.pasteInWeeks
	        };
	        this.$emit('save', emitObj);
	      }
	      this.close(this.eventsToCreate);
	    }
	  }
	};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { timechanger: _TimeChanger2.default },
	  props: {
	    event: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      isOn: true
	    };
	  },
	
	  computed: {
	    durationAsMinutes: function durationAsMinutes() {
	      var diff = (0, _moment2.default)(this.event.end).diff(this.event.start);
	      var asMinutes = _moment2.default.duration(diff).asMinutes();
	      this.$emit('duration', { tempId: this.event.tempId, asMinutes: asMinutes });
	      return asMinutes;
	    },
	    duration: function duration() {
	      var hours = Math.floor(this.durationAsMinutes / 60);
	      var minutes = this.durationAsMinutes - hours * 60;
	      return hours + this.$t('vue2.presence.h') + ' ' + minutes + this.$t('vue2.presence.m');
	    }
	  },
	  methods: {
	    updateStart: function updateStart(startTime) {
	      this.$emit('updateStart', { tempId: this.event.tempId, startTime: startTime });
	    },
	    updateEnd: function updateEnd(endTime) {
	      this.$emit('updateEnd', { tempId: this.event.tempId, endTime: endTime });
	    },
	    deleteEvent: function deleteEvent() {
	      this.$emit('delete', this.event);
	    },
	    setEventPresence: function setEventPresence(val) {
	      this.isOn = val;
	    }
	  }
	};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SpinnerButton = __webpack_require__(132);
	
	var _SpinnerButton2 = _interopRequireDefault(_SpinnerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calid: {
	      type: Number
	    },
	    date: {}
	  },
	  components: { spinner: _SpinnerButton2.default },
	  directives: {
	    tooltip: {
	      inserted: function inserted(el) {
	        var headerBottom = document.querySelector('.up-modal__header').getBoundingClientRect().bottom;
	        var elBottom = el.getBoundingClientRect().bottom;
	        var calc = elBottom - headerBottom;
	        if (calc < 100) {
	          el.classList.remove('hint--top');
	          el.classList.add('hint--bottom');
	        }
	      },
	      update: function update(el) {
	        var headerBottom = document.querySelector('.up-modal__header').getBoundingClientRect().bottom;
	        var elBottom = el.getBoundingClientRect().bottom;
	        var calc = elBottom - headerBottom;
	        if (calc < 100) {
	          el.classList.remove('hint--top');
	          el.classList.add('hint--bottom');
	        }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      modal: false,
	      today: _eventbus2.default.now,
	      copyDate: _eventbus2.default.now,
	      selectedWeeks: [],
	      calStartDate: _eventbus2.default.now,
	      calEndDate: _eventbus2.default.now,
	      calCurrentDate: _eventbus2.default.now,
	      calType: '',
	      startPasteWeek: _eventbus2.default.now,
	      weeks: [],
	      deleteEvents: true
	    };
	  },
	
	  watch: {
	    selectedWeeks: function selectedWeeks() {
	      this.$emit('weeks', this.selectedWeeks);
	    }
	  },
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    showStartPasteWeek: function showStartPasteWeek() {
	      return (0, _moment2.default)(this.startPasteWeek).isSame(this.calStartDate);
	    },
	    noneSelected: function noneSelected() {
	      return this.selectedWeeks.length === 0;
	    },
	    firstDayOfTheWeek: function firstDayOfTheWeek() {
	      var start = 1;
	      if (typeof window.SCHOOL.first_day_of_week_num !== 'undefined') {
	        start = window.SCHOOL.first_day_of_week_num;
	      }
	      return start;
	    }
	  },
	  filters: {
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date);
	      var start2 = (0, _moment2.default)(date).format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).add(6, 'days');
	      var endFormat = (0, _moment2.default)(date).add(6, 'days').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    week: function week(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  },
	  methods: {
	    setActiveSchoolYear: function setActiveSchoolYear(evt) {
	      this.$store.commit('setlocalActivatedSchoolYear', evt.target.value);
	      this.setStartAndEndDateBasedOnSchoolYear();
	    },
	    setStartAndEndDate: function setStartAndEndDate() {
	      var _this = this;
	
	      var isCalDateNotWithinASchoolYear = true;
	      var startDate = void 0;
	      var endDate = void 0;
	      this.activeSchoolYears.forEach(function (year) {
	        startDate = (0, _moment2.default)(year.employee_time_start).startOf('isoweek');
	        endDate = (0, _moment2.default)(year.employee_time_end).endOf('isoweek');
	        if (_this.isCalDateWithinRange(startDate, endDate)) {
	          _this.calStartDate = startDate;
	          _this.calEndDate = endDate;
	          isCalDateNotWithinASchoolYear = false;
	        }
	      });
	      this.createWeeks();
	      this.$emit('isWithinCalRange', isCalDateNotWithinASchoolYear);
	    },
	    setStartAndEndDateBasedOnSchoolYear: function setStartAndEndDateBasedOnSchoolYear() {
	      this.calStartDate = this.activeSchoolYear.employee_time_start;
	      this.calEndDate = this.activeSchoolYear.employee_time_end;
	      this.createWeeks();
	    },
	    isCalDateWithinRange: function isCalDateWithinRange(start, end) {
	      var lockupdate = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      return (0, _moment2.default)(lockupdate).isBetween(start, end) || (0, _moment2.default)(lockupdate).isSame(start) || (0, _moment2.default)(lockupdate).isSame(end);
	    },
	    createWeeks: function createWeeks() {
	      var start = (0, _moment2.default)(this.calStartDate).day(this.firstDayOfTheWeek);
	      var end = this.calEndDate;
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i).day(this.firstDayOfTheWeek);
	        weeks.push({
	          date: date,
	          isSelected: false,
	          serverDate: (0, _moment2.default)(date).format('YYYY-MM-DD'),
	          weekNum: date.isoWeek(),
	          isNow: (0, _moment2.default)(date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW'),
	          isCopyWeek: false
	        });
	      }
	      this.weeks = weeks;
	    },
	    getCalDatesAndCreateWeeks: function getCalDatesAndCreateWeeks() {
	      var _this2 = this;
	
	      _docendo2.default.calendar(this.calid, function (data) {
	        _this2.calType = data.type;
	        _this2.calStartDate = data.start_date;
	        _this2.calEndDate = data.end_date;
	        _this2.setStartAndEndDate();
	        _this2.setStartWeek();
	      });
	    },
	    setStartWeek: function setStartWeek() {
	      var weekNum = (0, _moment2.default)(this.date).isoWeek();
	      var index = this.findWeek(weekNum);
	      if (this.weeks[index] !== undefined) {
	        this.weeks[index].isCopyWeek = true;
	        this.startPasteWeek = this.date;
	      }
	    },
	    selectWeek: function selectWeek(i) {
	      if (!this.weeks[i].isSelected && !this.weeks[i].isCopyWeek) {
	        this.selectedWeeks.push(this.weeks[i].serverDate);
	        this.weeks[i].isSelected = true;
	      }
	    },
	    removeWeek: function removeWeek(i) {
	      this.weeks[i].isSelected = false;
	      var selectedIndex = this.selectedWeeks.indexOf(this.weeks[i].serverDate);
	      this.selectedWeeks.splice(selectedIndex, 1);
	    },
	    toggleWeek: function toggleWeek(index) {
	      if (this.selectedWeeks.length < 1 || this.showStartPasteWeek) {
	        this.startPasteWeek = this.weeks[index].date;
	      }
	      if (this.weeks[index].isCopyWeek) {
	        return;
	      }
	      if (!this.weeks[index].isSelected) {
	        this.selectWeek(index);
	      } else {
	        this.removeWeek(index);
	      }
	    },
	    findWeek: function findWeek(weekNum) {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if (this.weeks[i].weekNum === weekNum) {
	          return i;
	        }
	      }
	    },
	    selectAll: function selectAll() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          this.selectWeek(i);
	        }
	      }
	    },
	    selectEvenWeeks: function selectEvenWeeks() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          if (this.isEven(this.weeks[i].date.isoWeek())) {
	            this.selectWeek(i);
	          }
	        }
	      }
	    },
	    selectOddWeeks: function selectOddWeeks() {
	      for (var i = 0; i < this.weeks.length; i++) {
	        if ((0, _moment2.default)(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
	          if (this.isOdd(this.weeks[i].date.isoWeek())) {
	            this.selectWeek(i);
	          }
	        }
	      }
	    },
	    isEven: function isEven(n) {
	      return (/^-?\d*[02468]$/.test(n)
	      );
	    },
	    isOdd: function isOdd(n) {
	      return (/^-?\d*[13579]$/.test(n)
	      );
	    },
	    removeAllSelectedWeeks: function removeAllSelectedWeeks() {
	      this.selectedWeeks = [];
	      for (var i = 0; i < this.weeks.length; i++) {
	        this.weeks[i].isSelected = false;
	      }
	    },
	    close: function close() {
	      this.modal = false;
	      this.feedback = false;
	    },
	    eraseStartDate: function eraseStartDate() {
	      this.startPasteWeek = this.calStartDate;
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.calid) {
	      this.getCalDatesAndCreateWeeks();
	    } else {
	      this.setStartAndEndDateBasedOnSchoolYear();
	    }
	  }
	};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _TaskOverviewUser = __webpack_require__(340);
	
	var _TaskOverviewUser2 = _interopRequireDefault(_TaskOverviewUser);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, Loader: _Loader2.default, DModal: _DModal2.default, TaskOverviewUser: _TaskOverviewUser2.default, filterTags: _TaggingFilter2.default },
	  props: {
	    schoolThresholdToHideTaskHours: {
	      default: null
	    },
	    theUserCanManageAssignedHours: {
	      default: false
	    },
	    tags: {
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      versions: [],
	      isLoading: false,
	      isHideTaskHoursUnderThreshold: true,
	      isShowUserSelectModal: true,
	      selectedUserIds: [],
	      isLoadingPrint: false,
	      appliedFilters: [] };
	  },
	
	  computed: {
	    usersSortedOnName: function usersSortedOnName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    usersSortedOnNameWithTags: function usersSortedOnNameWithTags() {
	      return this.usersSortedOnName.map(function (user) {
	        user.tags = user.user_tags;
	        return user;
	      });
	    },
	    filteredUsersOnTags: function filteredUsersOnTags() {
	      var _this = this;
	
	      if (this.appliedFilters.length < 1) {
	        return this.usersSortedOnNameWithTags;
	      }
	      return this.usersSortedOnNameWithTags.filter(function (user) {
	        if (!user.tags) return false;
	        return user.tags.some(function (tag) {
	          return _this.appliedFilters.includes(tag);
	        });
	      });
	    },
	    sortedUsers: function sortedUsers() {
	      var _this2 = this;
	
	      var versions = this.versions.filter(function (version) {
	        return _this2.allUsersInHash[version.user_id];
	      }).map(function (version) {
	        return {
	          name: _this2.allUsersInHash[version.user_id]['name'],
	          user: _this2.allUsersInHash[version.user_id],
	          version: version
	        };
	      });
	      return this.$helpers.sortArrOnName(versions);
	    },
	    filteredUsers: function filteredUsers() {
	      var _this3 = this;
	
	      if (this.selectedUserIds.length < 1) {
	        return this.sortedUsers;
	      }
	      return this.sortedUsers.filter(function (user) {
	        return _this3.selectedUserIds.includes(user.user.id);
	      });
	    }
	  },
	  methods: {
	    toggleUser: function toggleUser(user) {
	      var userId = user.id;
	      var index = this.selectedUserIds.indexOf(userId);
	      if (index === -1) {
	        this.selectedUserIds.push(userId);
	      } else {
	        this.selectedUserIds.splice(index, 1);
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(user) {
	      return this.selectedUserIds.includes(user.id);
	    },
	    toggleAll: function toggleAll() {
	      if (this.selectedUserIds.length < 1) {
	        this.selectedUserIds = this.filteredUsersOnTags.map(function (user) {
	          return user.id;
	        });
	      } else {
	        this.selectedUserIds = [];
	      }
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      if (!this.appliedFilters.includes(tag)) {
	        this.appliedFilters.push(tag);
	      }
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      var index = this.appliedFilters.indexOf(tag);
	      if (index !== -1) {
	        this.appliedFilters.splice(index, 1);
	      }
	    },
	    startPrint: function startPrint() {
	      var _this4 = this;
	
	      this.isLoadingPrint = true;
	      this.$nextTick(function (_) {
	        _this4.isShowUserSelectModal = false;
	        _this4.$nextTick(function (_) {
	          _this4.isLoadingPrint = false;
	          _this4.print();
	        });
	      });
	    },
	    setIsHideTaskHoursUnderThreshold: function setIsHideTaskHoursUnderThreshold() {
	      this.isHideTaskHoursUnderThreshold = !this.isHideTaskHoursUnderThreshold;
	    },
	    closeModal: function closeModal() {
	      this.$emit('close');
	    },
	    readAllOverviews: function readAllOverviews() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      _docendo2.default.readAllTaskOverview(this.schoolId, this.schoolYearId, function (success) {
	        _this5.versions = success;
	        _this5.isLoading = false;
	        _this5.$nextTick(function (_) {
	          _this5.isShowUserSelectModal = true;
	        });
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    print: function print() {
	      var _this6 = this;
	
	      var i18nTaskOverview = this.$t('vue2.task_versions.task_overview');
	
	      var prtHtml = document.getElementById('printTaskOverviews').innerHTML;
	
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + i18nTaskOverview + '</title>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	      var afterPrint = function afterPrint() {
	        WinPrint.close();
	        _this6.closeModal();
	      };
	      WinPrint.onafterprint = afterPrint;
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	      }, 1000);
	    }
	  },
	  mounted: function mounted() {
	    this.readAllOverviews();
	  }
	};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _PrintCalendarsWeekSelector = __webpack_require__(1282);
	
	var _PrintCalendarsWeekSelector2 = _interopRequireDefault(_PrintCalendarsWeekSelector);
	
	var _PrintCalendars = __webpack_require__(1281);
	
	var _PrintCalendars2 = _interopRequireDefault(_PrintCalendars);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _vueClickaway = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DDropdown: _DDropdown2.default, PrintCalendars: _PrintCalendars2.default, PrintCalendarsWeekSelector: _PrintCalendarsWeekSelector2.default, DModal: _DModal2.default },
	  props: {
	    calendarId: {
	      default: 7
	    },
	    activeCalendarDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      theStep: 1,
	      calendarTypes: [{ title: this.$t('vue2.print_all_calendars.all_classes'), type: 'klass' }, { title: this.$t('vue2.print_all_calendars.all_teachers'), type: 'user' }, { title: this.$t('vue2.print_all_calendars.all_rooms'), type: 'room' }],
	      date: (0, _moment2.default)().format('YYYY-MM-DD 00:00'),
	      startDate: (0, _moment2.default)().isoWeek(1).startOf('day'),
	      endDate: (0, _moment2.default)().isoWeek(7).endOf('day'),
	      isDropdown: false,
	      selectedCalendars: []
	    };
	  },
	
	  computed: {
	    firstDayOfWeek: function firstDayOfWeek() {
	      return this.$store.getters.firstDayOfWeek;
	    },
	    allSchoolCalendars: function allSchoolCalendars() {
	      return this.$store.state.calendars;
	    },
	    isShowModal: function isShowModal() {
	      return _eventbus2.default.isPrintCalendarsModal;
	    },
	    printCalendarType: function printCalendarType() {
	      return _eventbus2.default.printCalendarType;
	    },
	    calendarIds: function calendarIds() {
	      var _this = this;
	
	      var filteredCals = [];
	      if (this.printCalendarType === 'single_calendar') {
	        filteredCals = this.allSchoolCalendars.filter(function (calendar) {
	          return calendar.id === _this.calendarId;
	        });
	      } else if (this.printCalendarType === 'multiple_calendars') {
	        filteredCals = this.selectedCalendars;
	      } else {
	        filteredCals = this.allSchoolCalendars.filter(function (calendar) {
	          return calendar.type === _this.printCalendarType;
	        });
	      }
	      var sortedFilteredCals = filteredCals.sort(function (a, b) {
	        if (a.name && b.name) {
	          return a.name.localeCompare(b.name, undefined, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        }
	      });
	      return this.printCalendarType ? sortedFilteredCals.filter(function (cal) {
	        return cal.id;
	      }).map(function (cal) {
	        return cal.id;
	      }) : [];
	    }
	  },
	  watch: {
	    isShowModal: function isShowModal(val) {
	      if (!val) {
	        this.resetForm();
	      }
	    }
	  },
	  methods: {
	    clearSelectedCalendars: function clearSelectedCalendars() {
	      this.selectedCalendars = [];
	    },
	    updateSelectedCalendar: function updateSelectedCalendar(cals) {
	      this.selectedCalendars = cals;
	    },
	    getPrintingDate: function getPrintingDate() {
	      if (this.activeCalendarDate) {
	        this.setDate(this.activeCalendarDate);
	      } else {
	        var calendar = document.querySelectorAll('#calendar_' + this.calendarId);
	        if (calendar.length > 0) {
	          this.setDate(calendar[0].dataset.current_date);
	        }
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.isDropdown = false;
	    },
	    setIsDropdown: function setIsDropdown() {
	      if (!this.isDropdown) {
	        this.getPrintingDate();
	      }
	      this.isDropdown = !this.isDropdown;
	    },
	    setDate: function setDate(date) {
	      var selectedDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      if (this.firstDayOfWeek === 0) {
	        selectedDate = (0, _moment2.default)(selectedDate).add(1, 'days');
	      }
	      this.date = selectedDate;
	      var endDayOfWeek = this.firstDayOfWeek + 6;
	      this.startDate = (0, _moment2.default)(selectedDate).isoWeekday(this.firstDayOfWeek).startOf('day');
	      this.endDate = (0, _moment2.default)(selectedDate).isoWeekday(endDayOfWeek).endOf('day');
	      this.theStep = 2;
	    },
	    setIsShowModalFalse: function setIsShowModalFalse() {
	      _eventbus2.default.isPrintCalendarsModal = false;
	      this.resetForm();
	    },
	    resetForm: function resetForm() {
	      _eventbus2.default.printCalendarType = null;
	      this.theStep = 1;
	    },
	    selectType: function selectType(type) {
	      this.isDropdown = false;
	      _eventbus2.default.printCalendarType = type.type;
	      this.theStep = 1;
	      _eventbus2.default.isPrintCalendarsModal = true;
	    },
	    printThis: function printThis() {
	      this.isDropdown = false;
	      _eventbus2.default.printCalendarType = 'single_calendar';
	      this.theStep = 1;
	      _eventbus2.default.isPrintCalendarsModal = true;
	    },
	    printOld: function printOld() {
	      window.noTextNoPrint();
	      window.printCalendar(this.calendarId);
	    }
	  }
	};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DSelectCalsAll = __webpack_require__(303);
	
	var _DSelectCalsAll2 = _interopRequireDefault(_DSelectCalsAll);
	
	var _DCalendar = __webpack_require__(58);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _DCalendarPrint = __webpack_require__(1242);
	
	var _DCalendarPrint2 = _interopRequireDefault(_DCalendarPrint);
	
	var _CalculateHours = __webpack_require__(294);
	
	var _CalculateHours2 = _interopRequireDefault(_CalculateHours);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelectCals: _DSelectCalsAll2.default, CalculateHours: _CalculateHours2.default, DCalendarPrint: _DCalendarPrint2.default, AppToggle: _AppToggle2.default, DModal: _DModal2.default, Loader: _Loader2.default, DCalendar: _DCalendar2.default, TimeChanger: _TimeChanger2.default },
	  props: {
	    calendarIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)().format('YYYY-MM-DD');
	      }
	    },
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)().isoWeekday(1).format('YYYY-MM-DD 00:00');
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().isoWeekday(7).format('YYYY-MM-DD 00:00');
	      }
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    },
	    showDSelect: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      events: [],
	      isLoading: true,
	      theViewSetting: 'calendar',
	      isShowPrintButton: false,
	      isShowWeekends: false,
	      isPrintHours: false,
	      startTimeDate: (0, _moment2.default)().set({ 'hour': 6, 'minutes': 0, 'second': 0, 'millisecond': 0 }),
	      endTimeDate: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0, 'second': 0, 'millisecond': 0 }),
	      isCalNoBgColors: false,
	      eventFontSize: 10,
	      isCalendarsSelected: false,
	      isHideCalendars: false,
	      isHideDates: false
	    };
	  },
	
	  watch: {
	    isLoading: function isLoading(val) {
	      var _this = this;
	
	      if (!this.isLoading) {
	        setTimeout(function (_) {
	          _this.isShowPrintButton = true;
	        }, 500);
	      }
	    },
	    calendarIds: function calendarIds(val) {
	      if (this.isCalendarsSelected) {
	        this.getEvents();
	      }
	    }
	  },
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    startTime: function startTime() {
	      return (0, _moment2.default)(this.startTimeDate).format('HH:mm:ss');
	    },
	    endTime: function endTime() {
	      return (0, _moment2.default)(this.endTimeDate).format('HH:mm:ss');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    eventsInHash: function eventsInHash() {
	      var _this2 = this;
	
	      var objOfEvents = {};
	      if (this.events.length < 1) {
	        objOfEvents = {};
	      } else {
	        this.events.forEach(function (event) {
	          event.calendars.forEach(function (calendar) {
	            var calendarId = calendar.calendar_id;
	            if (!objOfEvents[calendarId]) {
	              _this2.$set(objOfEvents, calendarId, [event]);
	            } else {
	              objOfEvents[calendarId].push(event);
	            }
	          });
	        });
	      }
	      return objOfEvents;
	    },
	    calendars: function calendars() {
	      var _this3 = this;
	
	      var cals = [];
	      cals = this.calendarIds.map(function (calId) {
	        return {
	          id: calId,
	          name: _this3.allCalendarsInHash[calId] ? _this3.allCalendarsInHash[calId].name : 'No title',
	          view_state: 0,
	          events: _this3.eventsInHash[calId] ? _this3.eventsInHash[calId] : [],
	          isHasEvents: _this3.eventsInHash[calId]
	        };
	      });
	      return cals.filter(function (cal) {
	        return cal.isHasEvents;
	      });
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    userPrintSettings: function userPrintSettings() {
	      return this.userSettings['print_settings_calendar'] ? this.userSettings['print_settings_calendar'] : {};
	    },
	    hasUserPrintSettings: function hasUserPrintSettings() {
	      return (0, _keys2.default)(this.userPrintSettings).length > 0;
	    }
	  },
	  methods: {
	    setIsCalendarsSelected: function setIsCalendarsSelected() {
	      var _this4 = this;
	
	      this.isCalendarsSelected = true;
	      this.$nextTick(function (_) {
	        _this4.getEvents();
	      });
	    },
	    dSelectCalsUpdated: function dSelectCalsUpdated(type, cals) {
	      this.$emit('updateCalendars', cals);
	    },
	    updatePrintSettingsFromComputed: function updatePrintSettingsFromComputed() {
	      var _this5 = this;
	
	      (0, _keys2.default)(this.userPrintSettings).forEach(function (setting) {
	        var val = _this5.userPrintSettings[setting];
	        if (_this5.hasOwnProperty(setting)) {
	          _this5[setting] = val;
	        }
	      });
	    },
	    changeSetting: function changeSetting(setting, val) {
	      if (this.hasOwnProperty(setting)) {
	        this[setting] = val;
	        this.savePrintSettings(setting, val);
	      }
	    },
	    savePrintSettings: function savePrintSettings(setting, val) {
	      var initPrintSettings = {
	        theViewSetting: 'calendar',
	        isShowWeekends: false,
	        isPrintHours: false,
	        startTimeDate: (0, _moment2.default)().set({ 'hour': 6, 'minutes': 0, 'second': 0, 'millisecond': 0 }),
	        endTimeDate: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0, 'second': 0, 'millisecond': 0 }),
	        isCalNoBgColors: false,
	        eventFontSize: 10
	      };
	      var newPrintSettings = JSON.parse((0, _stringify2.default)(this.userPrintSettings));
	      if (initPrintSettings[setting] === val && this.userPrintSettings[setting]) {
	        delete newPrintSettings[setting];
	        if ((0, _keys2.default)(newPrintSettings).length === 0) {
	          this.$store.dispatch('deleteUserSetting', 'print_settings_calendar');
	        } else {
	          this.$store.dispatch('updateUserSettings', { 'print_settings_calendar': newPrintSettings });
	        }
	        return;
	      }
	      if (initPrintSettings[setting] !== val) {
	        newPrintSettings[setting] = val;
	        this.$store.dispatch('updateUserSettings', { 'print_settings_calendar': newPrintSettings });
	      }
	    },
	    resetPrintSettings: function resetPrintSettings() {
	      this.theViewSetting = 'calendar';
	      this.isShowWeekends = false;
	      this.isPrintHours = false;
	      this.startTimeDate = (0, _moment2.default)().set({ 'hour': 6, 'minutes': 0, 'second': 0, 'millisecond': 0 }).format();
	      this.endTimeDate = (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0, 'second': 0, 'millisecond': 0 }).format();
	      this.isCalNoBgColors = false;
	      this.eventFontSize = 10;
	      this.$store.dispatch('deleteUserSetting', 'print_settings_calendar');
	    },
	    setViewSetting: function setViewSetting(type) {
	      if (this.theViewSetting === type) {
	        this.theViewSetting = 'calendar';
	        this.changeSetting('theViewSetting', 'calendar');
	      } else {
	        this.theViewSetting = type;
	        this.changeSetting('theViewSetting', type);
	      }
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTimeDate = payload;
	      this.changeSetting('startTimeDate', payload);
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTimeDate = payload;
	      this.changeSetting('endTimeDate', payload);
	    },
	    getEvents: function getEvents() {
	      var _this6 = this;
	
	      this.isLoading = true;
	      _docendo2.default.eventsFromCalendars(this.calendarIds, this.startDate, this.endDate, null, function (data) {
	        _this6.events = data.length > 0 ? JSON.parse(data) : [];
	        _this6.isLoading = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    print: function print() {
	      var _this7 = this;
	
	      this.isShowPrintButton = false;
	      this.$nextTick(function (_) {
	        var prtHtml = document.getElementById('printCalendars').innerHTML;
	
	        var stylesHtml = '';
	
	        var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	        for (var _i = 0; _i < _arr.length; _i++) {
	          var node = _arr[_i];
	          stylesHtml += node.outerHTML;
	        }
	
	        var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	        WinPrint.document.write('<!DOCTYPE html><html><head>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	        var afterPrint = function afterPrint() {
	          WinPrint.close();
	          _this7.close();
	        };
	        WinPrint.onafterprint = afterPrint;
	        setTimeout(function (_) {
	          WinPrint.document.close();
	          WinPrint.focus();
	          WinPrint.print();
	        }, 1000);
	      });
	    },
	    close: function close() {
	      this.isShowPrintButton = false;
	      _eventbus2.default.isPrintCalendarsModal = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this8 = this;
	
	    this.updatePrintSettingsFromComputed();
	    setTimeout(function (_) {
	      _this8.getEvents();
	    }, 500);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$emit('clear');
	  }
	};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ChangeSchoolYear: _ChangeSchoolYear2.default },
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    weeks: function weeks() {
	      var activeSchoolYear = this.localActivatedSchoolYear;
	      if (this.calType === 'klass') {
	        this.calStartDate = activeSchoolYear.student_time_start;
	        this.calEndDate = activeSchoolYear.student_time_end;
	      } else {
	        this.calStartDate = activeSchoolYear.employee_time_start;
	        this.calEndDate = activeSchoolYear.employee_time_end;
	      }
	      var start = (0, _moment2.default)(this.calStartDate).startOf('isoweek');
	      var end = (0, _moment2.default)(this.calEndDate).endOf('isoweek');
	      var startWeek = (0, _moment2.default)(start).isoWeek();
	      var diff = (0, _moment2.default)(end).diff(start, 'week');
	      var max = startWeek + diff;
	      var weeks = [];
	      for (var i = startWeek; i <= max; i++) {
	        var date = (0, _moment2.default)(start).isoWeek(i);
	        weeks.push({
	          date: date,
	          serverDate: (0, _moment2.default)(date).format('GGGG-WW'),
	          weekNum: date.isoWeek()
	        });
	      }
	      return weeks;
	    }
	  },
	  methods: {
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date).startOf('isoweek');
	      var start2 = (0, _moment2.default)(date).startOf('isoweek').format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).endOf('isoweek');
	      var endFormat = (0, _moment2.default)(date).endOf('isoweek').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    isNow: function isNow(week) {
	      return (0, _moment2.default)(week.date).format('GGGG-WW') === (0, _moment2.default)().format('GGGG-WW');
	    },
	    setSelectedWeek: function setSelectedWeek(week) {
	      this.$emit('setWeek', week);
	    },
	    showWeek: function showWeek(date) {
	      return (0, _moment2.default)(date).isoWeek();
	    }
	  }
	};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ProfileSubjects = __webpack_require__(1285);
	
	var _ProfileSubjects2 = _interopRequireDefault(_ProfileSubjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ProfileSubjects: _ProfileSubjects2.default, Loader: _Loader2.default },
	  props: {
	    userId: {
	      default: null
	    }
	  },
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolIsFromDenmark: function schoolIsFromDenmark() {
	      var school = this.$store.state.activeSchool;
	      return school && school.country === 'DK';
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    theUser: function theUser() {
	      if (!this.user) {
	        return null;
	      }
	      if (this.userId * 1 === this.user.id * 1) {
	        return this.user;
	      }
	      return this.allUsersInHash && this.allUsersInHash[this.userId] ? this.allUsersInHash[this.userId] : null;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isUserCanEdit: function isUserCanEdit() {
	      if (this.userId * 1 === this.user.id * 1) {
	        return true;
	      }
	      return this.userHasPermission('can_manage_users');
	    },
	    users: function users() {
	      return this.$store.state.allUsers;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    }
	  }
	};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    user: {
	      default: null
	    },
	    users: {
	      default: function _default() {
	        return [];
	      }
	    },
	    canEdit: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isEditable: false,
	      formErrors: {},
	      ssn: '',
	      isSaving: false
	    };
	  },
	
	  computed: {
	    ssnTrimmed: function ssnTrimmed() {
	      var cpr = this.ssn.replace(/[^0-9]/ig, '');
	      return cpr.toString();
	    },
	    isSaveButtonDisabled: function isSaveButtonDisabled() {
	      return this.ssn.replace(/[^0-9]/ig, '').length !== 10;
	    },
	    ssnHidden: function ssnHidden() {
	      var ssnText = 'Ikke udfyldt';
	      if (this.ssn.length > 0) {
	        ssnText = this.ssn;
	        if (this.ssn.length > 5) {
	          var replacement = 'xxxx';
	          ssnText = ssnText.slice(0, -4) + replacement;
	        }
	      }
	      return ssnText;
	    }
	  },
	  methods: {
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    formValidation: function formValidation() {
	      this.formErrors = {};
	      if (!this.validateCPR()) {
	        this.$set(this.formErrors, 'ssn', 'Er ikke et gyldigt CPR nummer');
	      }
	    },
	    validateCPR: function validateCPR() {
	      var ssn = this.ssn.replace(/[^0-9]/ig, '');
	      return ssn.length === 10;
	    },
	    resetForm: function resetForm() {
	      this.ssn = this.user.ssn;
	      this.formErrors = {};
	    },
	    cancel: function cancel() {
	      this.resetForm();
	      this.isEditable = false;
	    },
	    submit: function submit() {
	      var _this = this;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      this.isSaving = true;
	      var changes = { ssn: this.ssnTrimmed };
	      _docendo2.default.updateUser(changes, function (success) {
	        _eventbus2.default.toast = { text: 'Gemt', 'success': true };
	        var obj = {
	          prop: 'ssn',
	          ssn: success.ssn
	        };
	        _this.$store.commit('updateUserProp', obj);
	        _this.isSaving = false;
	        _this.cancel();
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'CPR nummer er allerede brugt', 'success': false };
	        _this.isSaving = false;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.ssn = this.user.ssn;
	  }
	};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _KompetenceIndberetningDSelect = __webpack_require__(319);
	
	var _KompetenceIndberetningDSelect2 = _interopRequireDefault(_KompetenceIndberetningDSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DSelect: _KompetenceIndberetningDSelect2.default },
	  props: {
	    user: {
	      default: null
	    },
	    schoolId: {
	      default: null
	    },
	    canEdit: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isEditable: false,
	      formErrors: {},
	      isSaving: false,
	      competencies: [],
	      theNewSubject: null,
	      theNewSubjectLevel: 'L',
	      standardSubjects: [{ subject_code: 110, name: 'Dansk' }, { subject_code: 120, name: 'Engelsk' }, { subject_code: 130, name: 'Tysk (tilbudsfag)' }, { subject_code: 134, name: 'Tysk (valgfag)' }, { subject_code: 140, name: 'Fransk (tilbudsfag)' }, { subject_code: 144, name: 'Fransk (valgfag)' }, { subject_code: 170, name: 'Kristendomskundskab' }, { subject_code: 171, name: 'Kristendomskundskab/religion' }, { subject_code: 181, name: 'Historie' }, { subject_code: 182, name: 'Samfundsfag' }, { subject_code: 210, name: 'Idræt' }, { subject_code: 220, name: 'Musik' }, { subject_code: 230, name: 'Billedkunst' }, { subject_code: 240, name: 'Håndarbejde' }, { subject_code: 245, name: 'Håndværk og design' }, { subject_code: 250, name: 'Sløjd' }, { subject_code: 260, name: 'Madkundskab' }, { subject_code: 310, name: 'Matematik' }, { subject_code: 320, name: 'Fysik/kemi' }, { subject_code: 330, name: 'Geografi' }, { subject_code: 340, name: 'Biologi' }, { subject_code: 350, name: 'Natur/teknik' }, { subject_code: 511, name: 'Praktisk/Musisk valgfag: Håndværk/design' }, { subject_code: 520, name: 'Praktisk/Musisk valgfag: Musik' }, { subject_code: 531, name: 'Praktisk/Musisk valgfag: Billedkunst' }, { subject_code: 540, name: 'Praktisk/Musisk valgfag: Madkundskab' }, { subject_code: 600, name: 'Børnehaveklasse' }],
	      levelMap: {
	        L: 'Linjefag',
	        K: 'Tilsvarende kompetencer'
	      }
	    };
	  },
	
	  computed: {
	    isSaveButtonDisabled: function isSaveButtonDisabled() {
	      return false;
	    },
	    standardSubjectsWithVProps: function standardSubjectsWithVProps() {
	      var _this = this;
	
	      var subjects = [];
	      var sortedSubjects = this.standardSubjects.sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	      sortedSubjects.forEach(function (subject) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(_this.levelMap)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var key = _step.value;
	
	            var obj = {};
	            obj.level = key;
	            obj.name = subject.name + ' (' + key + ')';
	            obj.id = subject.subject_code + '_' + key;
	            obj.user_id = subject.subject_code + '_' + key;
	            obj.subject_code = subject.subject_code;
	            subjects.push(obj);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      });
	      return subjects;
	    },
	    userCompetencies: function userCompetencies() {
	      var _this2 = this;
	
	      var competencies = [];
	      this.competencies.forEach(function (subject) {
	        var id = subject.subject_code + '_' + subject.level;
	        var idx = _this2.standardSubjectsWithVProps.findIndex(function (subjectWithVProps) {
	          return subjectWithVProps.id === id;
	        });
	        var obj = {
	          id: subject.subject_code + '_' + subject.level,
	          subject_code: subject.subject_code,
	          level: subject.level,
	          name: idx > -1 ? _this2.standardSubjectsWithVProps[idx].name : ''
	        };
	        competencies.push(obj);
	      });
	      return competencies;
	    }
	  },
	  methods: {
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    cancel: function cancel() {
	      this.resetForm();
	      this.isEditable = false;
	    },
	    updateSubjectOnUser: function updateSubjectOnUser(subjects) {
	      var _this3 = this;
	
	      var user = this.user;
	      var subjectForServer = [];
	      subjects.forEach(function (subject) {
	        var obj = {
	          subject_code: subject.subject_code,
	          level: subject.level
	        };
	        subjectForServer.push(obj);
	      });
	      _docendo2.default.updateUserCompetencies(this.schoolId, user.id, subjectForServer, function (success) {
	        var userCompetencies = success.filter(function (subject) {
	          return subject.user_id === _this3.user.id;
	        });
	        _this3.competencies = userCompetencies;
	        _eventbus2.default.toast = { text: 'Linjefag er opdateret', success: true };
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readCompetencies: function readCompetencies() {
	      var _this4 = this;
	
	      this.isLoading = true;
	      _docendo2.default.listUserCompetencies(this.schoolId, this.user.id, function (success) {
	        var userCompetencies = success.filter(function (subject) {
	          return subject.user_id === _this4.user.id;
	        });
	        _this4.competencies = userCompetencies;
	        _this4.isLoading = false;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readCompetencies();
	  }
	};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppEIPWYZIWYG = __webpack_require__(45);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    text: {
	      type: String
	    },
	    noteType: {
	      type: String,
	      default: ''
	    }
	  },
	  components: {
	    weip: _AppEIPWYZIWYG2.default
	  },
	  data: function data() {
	    return {
	      serverText: ''
	    };
	  },
	
	  methods: {
	    changed: function changed(text) {
	      this.serverText = text;
	      var el = this.$refs.quillelement.closest('.djs-slidein-form');
	      if (el) {
	        el.setAttribute('data-form-changes', 'true');
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.serverText = this.text;
	  }
	};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'recent-users',
	  data: function data() {
	    return {
	      users: []
	    };
	  },
	  props: ['school'],
	  methods: {
	    tooltiptitle: function tooltiptitle(user) {
	      return user.name + ' ' + this.timeFromNow(user.last_seen);
	    },
	    timeFromNow: function timeFromNow(m) {
	      if (m !== null) {
	        return this.$i18n.t('vue.recent_users.last_seen') + ' ' + (0, _moment2.default)(m).fromNow();
	      } else {
	        return this.$i18n.t('vue.recent_users.never_logged_in');
	      }
	    },
	    update: function update() {
	      _docendo2.default.getRecentUsers(this.school, 25, this.updated);
	    },
	    updated: function updated(data) {
	      this.users = data;
	    },
	    startRefreshing: function startRefreshing() {
	      this.timer = setInterval(this.update, 60000);
	    },
	    stopRefreshing: function stopRefreshing() {
	      clearInterval(this.timer);
	    }
	  },
	  mounted: function mounted() {
	    this.update();
	    this.startRefreshing();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.stopRefreshing();
	  },
	  created: function created() {
	    this.$on('docendo_state', function (data) {
	      if (data === 'connected') {
	        this.startRefreshing();
	      } else if (data === 'disconnected') {
	        this.stopRefreshing();
	      }
	    });
	  }
	};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _set = __webpack_require__(52);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _Tabslist = __webpack_require__(133);
	
	var _Tabslist2 = _interopRequireDefault(_Tabslist);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _BulkCreateSubjects = __webpack_require__(333);
	
	var _BulkCreateSubjects2 = _interopRequireDefault(_BulkCreateSubjects);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _SubjectForm = __webpack_require__(124);
	
	var _SubjectForm2 = _interopRequireDefault(_SubjectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SubjectForm: _SubjectForm2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, BulkCreateSubjects: _BulkCreateSubjects2.default, DModal: _DModal2.default, Tabslist: _Tabslist2.default, DoFiltersFilter: _DoFiltersFilter2.default, Loader: _Loader2.default },
	  data: function data() {
	    return {
	      selectedTab: 'Aktiviteter',
	      selectedKlassFilters: [],
	      statusFilters: [],
	      selectedStatusFilters: [],
	      loadingSubjects: {},
	      subjectSearchQuery: '',
	      debounceTimer: null,
	      isCreateActivityModal: false,
	      editSubject: null,
	      isRefreshing: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userCalendarId: function userCalendarId() {
	      return this.user && this.user.user_calendar_id ? this.user.user_calendar_id : null;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    isLoadingSubjects: function isLoadingSubjects() {
	      return this.$store.state.subjects.isLoadingSubjects;
	    },
	    isRefreshingOrLoadingSubjects: function isRefreshingOrLoadingSubjects() {
	      return this.isRefreshing || this.isLoadingSubjects;
	    },
	    subjects: function subjects() {
	      return this.$store.state.subjects.subjects;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    klassCalendars: function klassCalendars() {
	      var cals = [];
	      var seenIds = new _set2.default();
	      this.subjects.forEach(function (subject) {
	        subject.cals.forEach(function (cal) {
	          if (cal.calendar_type === 'klass' && !seenIds.has(cal.id)) {
	            seenIds.add(cal.id);
	            cals.push(cal);
	          }
	        });
	      });
	      return cals.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    klassTags: function klassTags() {
	      return this.klassCalendars.map(function (klassCalendar) {
	        return klassCalendar.name;
	      });
	    },
	    calsWithProps: function calsWithProps() {
	      var _this = this;
	
	      var klasses = this.klassCalendars;
	
	      return klasses.map(function (klass) {
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: (_this.subjectsInKlassHash[klass.id] || []).map(function (subjectId) {
	            var subject = _this.subjectsInHash[subjectId] || {};
	
	            return (0, _extends3.default)({}, subject);
	          })
	        });
	      });
	    },
	    filteredKlassCals: function filteredKlassCals() {
	      var _this2 = this;
	
	      var klasses = this.calsWithProps;
	
	      if (this.selectedKlassFilters.length > 0) {
	        klasses = klasses.filter(function (klass) {
	          return _this2.selectedKlassFilters.includes(klass.name);
	        });
	      }
	
	      return klasses.map(function (klass) {
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: klass.vSubjects.filter(function (subject) {
	            var matchesStatusFilter = _this2.selectedTab === 'Fag' ? subject.subject_type === 'subject' : subject.subject_type === 'frame';
	
	            var matchesSearch = !_this2.subjectSearchQuery || subject.name.toLowerCase().includes(_this2.subjectSearchQuery.toLowerCase());
	
	            return matchesStatusFilter && matchesSearch;
	          })
	        });
	      });
	    }
	  },
	  methods: {
	    updateSubject: function updateSubject(updatedSubject) {
	      updatedSubject['schoolId'] = this.schoolId;
	      updatedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeEditSubjectModal();
	    },
	    closeEditSubjectModal: function closeEditSubjectModal() {
	      this.editSubject = null;
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.editSubject = (0, _assign2.default)({}, editSubject);
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      var deletedSubject = {
	        id: editSubject.id,
	        school_id: editSubject.school_id,
	        school_year_id: this.activeSchoolYear.id
	      };
	      deletedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('deleteSubject', deletedSubject);
	      this.closeEditSubjectModal();
	    },
	    refreshReductions: function refreshReductions() {
	      var _this3 = this;
	
	      this.isRefreshing = true;
	      _docendo2.default.refreshSubjectReductions(this.schoolId, this.schoolYearId, function (success) {
	        _this3.isRefreshing = false;
	        _this3.$store.dispatch('readSubjects', _this3.schoolYearId);
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    setIsCreateActivityModal: function setIsCreateActivityModal(bool) {
	      this.isCreateActivityModal = bool;
	    },
	    onSelectTab: function onSelectTab(tab) {
	      this.selectedTab = tab;
	      this.subjectSearchQuery = '';
	      if (tab === 'Fag') {
	        this.refreshReductions();
	      }
	    },
	    debounceSearch: function debounceSearch(event) {
	      var _this4 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this4.subjectSearchQuery = event.target.value;
	      }, 400);
	    },
	    toggleSelectedStatusFilters: function toggleSelectedStatusFilters(filter) {
	      var idx = this.selectedStatusFilters.indexOf(filter);
	      if (idx < 0) {
	        this.selectedStatusFilters.push(filter);
	      } else {
	        this.selectedStatusFilters.splice(idx, 1);
	      }
	    },
	    toggleKlassTag: function toggleKlassTag(filter) {
	      var idx = this.selectedKlassFilters.indexOf(filter);
	      if (idx < 0) {
	        this.selectedKlassFilters.push(filter);
	      } else {
	        this.selectedKlassFilters.splice(idx, 1);
	      }
	    },
	    getUserNames: function getUserNames(subjectId) {
	      var _this5 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      if (!calIds || calIds.length < 1 || !calIds[0]) {
	        return '';
	      }
	      return calIds.filter(function (calId) {
	        return _this5.allCalendarsInHash[calId] && _this5.allCalendarsInHash[calId].type === 'user';
	      }).map(function (userCalId) {
	        return _this5.allCalendarsInHash[userCalId].name ? _this5.allCalendarsInHash[userCalId].name : '';
	      });
	    },
	    subjectHasTeachers: function subjectHasTeachers(subjectId) {
	      var _this6 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      var hasTeachers = false;
	      calIds.forEach(function (calId) {
	        if (_this6.allCalendarsInHash[calId] && _this6.allCalendarsInHash[calId].type === 'user') {
	          hasTeachers = true;
	        }
	      });
	      return hasTeachers;
	    },
	    readSubjects: function readSubjects() {
	      if (this.schoolYearId) {
	        this.$store.dispatch('readSubjects', this.schoolYearId);
	        this.$store.dispatch('readReductions');
	      }
	    }
	  },
	  watch: {
	    schoolYearId: function schoolYearId(val) {
	      this.readSubjects();
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	    var filters = ['Aktiviteter'];
	    this.$store.commit('SET_SUBJECT_TYPE_FILTER', filters);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.debounceTimer) {
	      clearTimeout(this.debounceTimer);
	    }
	  }
	};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _GrundskoleIndberetningUsers = __webpack_require__(1294);
	
	var _GrundskoleIndberetningUsers2 = _interopRequireDefault(_GrundskoleIndberetningUsers);
	
	var _GrundskoleIndberetningTimetal = __webpack_require__(118);
	
	var _GrundskoleIndberetningTimetal2 = _interopRequireDefault(_GrundskoleIndberetningTimetal);
	
	var _GrundskoleIndberetningRessource = __webpack_require__(1290);
	
	var _GrundskoleIndberetningRessource2 = _interopRequireDefault(_GrundskoleIndberetningRessource);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _GrundskoleIndberetningResume = __webpack_require__(318);
	
	var _GrundskoleIndberetningResume2 = _interopRequireDefault(_GrundskoleIndberetningResume);
	
	var _StilGuides = __webpack_require__(41);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    StilGuides: _StilGuides2.default,
	    GrundskoleIndberetningResume: _GrundskoleIndberetningResume2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    Loader: _Loader2.default, GrundskoleIndberetningUsers: _GrundskoleIndberetningUsers2.default, GrundskoleIndberetningTimetal: _GrundskoleIndberetningTimetal2.default, GrundskoleIndberetningRessource: _GrundskoleIndberetningRessource2.default
	  },
	  data: function data() {
	    return {
	      theActiveTab: 0,
	      stilData: [],
	      isLoadingStilData: false,
	      userEmailInput: '',
	      userEmailFormErrors: {},
	      isSavingUserEmail: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    userHasNoEmail: function userHasNoEmail() {
	      return this.user && this.user.email === null;
	    },
	    isSaveButtonForUserEmailDisabled: function isSaveButtonForUserEmailDisabled() {
	      return this.userEmailInput.length < 3;
	    }
	  },
	  watch: {
	    user: function user() {
	      var _this = this;
	
	      if (this.userHasNoEmail) {
	        setTimeout(function () {
	          var el = _this.$refs.user_email_input;
	          if (el) {
	            _this.$refs.user_email_input.focus();
	          }
	        }, 0);
	        return;
	      }
	      this.isLoadingStilData = true;
	      _docendo2.default.showStilReport(this.schoolId, function (success) {
	        _this.isLoadingStilData = false;
	        _this.stilData = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  methods: {
	    updateRessource: function updateRessource(ressourceSkema) {
	      var _this2 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      stilData['ressourceskema'] = ressourceSkema;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this2.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    setTolaerer: function setTolaerer(obj) {
	      var _this3 = this;
	
	      var setting = obj.godkendelseskode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin;
	      });
	      stilData['undervisningskema'][idx]['godkendelseskode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this3.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    setForanstaltning: function setForanstaltning(obj) {
	      var _this4 = this;
	
	      var setting = obj.godkendelseskode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin;
	      });
	      stilData['undervisningskema'][idx]['godkendelseskode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this4.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updatePraktik: function updatePraktik(obj) {
	      var _this5 = this;
	
	      var setting = obj.praktikkode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.v_fag._type;
	      });
	      stilData['undervisningskema'][idx]['praktikkode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this5.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateKonfirmation: function updateKonfirmation(obj) {
	      var _this6 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.v_fag._type;
	      });
	
	      stilData['undervisningskema'][idx]['klassetrin'] = obj.value;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this6.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateSubject: function updateSubject(obj) {
	      var _this7 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.originalObject._type && stilTing.klassetype === obj.originalObject.klassetype && stilTing.fagkode === obj.originalObject.fagkode && stilTing.klassetrin === obj.originalObject.klassetrin;
	      });
	      stilData['undervisningskema'][idx][obj.toUpdate] = obj.value * 1;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this7.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    nulstilKlasse: function nulstilKlasse(grade) {
	      var _this8 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var subjects = stilData['undervisningskema'].filter(function (subject) {
	        return subject._type === 'undervisningstid' && subject.klassetrin === grade.value * 1;
	      });
	      subjects.forEach(function (subject) {
	        var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	          return stilTing._type === subject._type && stilTing.klassetype === subject.klassetype && stilTing.fagkode === subject.fagkode && stilTing.klassetrin === subject.klassetrin;
	        });
	        stilData['undervisningskema'][idx]['klokketimer'] = 0;
	        _docendo2.default.updateStilReport(_this8.schoolId, stilData, function (success) {
	          _this8.stilData = success;
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	      });
	    },
	    update: function update(obj) {
	      var _this9 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData[obj.type].findIndex(function (elevtal) {
	        return elevtal._type === obj.cell._type && elevtal.elevtaltype === obj.cell.elevtaltype && elevtal.klassetrin === obj.cell.klassetrin;
	      });
	      stilData[obj.type][idx]['antal'] = obj.num * 1;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this9.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    submitUserEmail: function submitUserEmail() {
	      var _this10 = this;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.userEmailFormErrors).length > 0) {
	        return;
	      }
	      this.isSavingUserEmail = true;
	      var changes = { email: this.userEmailInput };
	      _docendo2.default.updateUser(changes, function (success) {
	        _eventbus2.default.toast = { text: 'Emailen er gemt', 'success': true };
	        var obj = {
	          prop: 'email',
	          email: success.email
	        };
	        _this10.$store.commit('updateUserProp', obj);
	        _this10.isSavingUserEmail = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Email er allerede brugt', 'success': false };
	        _this10.isSavingUserEmail = false;
	      });
	    },
	    formValidation: function formValidation() {
	      this.userEmailFormErrors = {};
	      if (!this.validateEmail(this.userEmailInput)) {
	        this.$set(this.userEmailFormErrors, 'email', 'Er ikke en gyldig email');
	      }
	    },
	    validateEmail: function validateEmail(email) {
	      var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
	      return email.trim() !== '' && emailRegex.test(email);
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.userEmailFormErrors, title);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('readSchoolYears', this.schoolId);
	  }
	};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _GrundskoleIndberetningRessourceInsertModal = __webpack_require__(1291);
	
	var _GrundskoleIndberetningRessourceInsertModal2 = _interopRequireDefault(_GrundskoleIndberetningRessourceInsertModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _GrundskoleIndberetningRessourceOverview = __webpack_require__(317);
	
	var _GrundskoleIndberetningRessourceOverview2 = _interopRequireDefault(_GrundskoleIndberetningRessourceOverview);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserTasks = __webpack_require__(44);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	var _StilRessourceTasks = __webpack_require__(1307);
	
	var _StilRessourceTasks2 = _interopRequireDefault(_StilRessourceTasks);
	
	var _StilGuides = __webpack_require__(41);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var klasseType = {
	  stil_hours_40_B: {
	    klassetype: '40',
	    tidstype: 'B'
	  },
	  stil_hours_50_B: {
	    klassetype: '50',
	    tidstype: 'B'
	  },
	  stil_hours_40_A1: {
	    klassetype: '40',
	    tidstype: 'A1'
	  },
	  stil_hours_50_A1: {
	    klassetype: '50',
	    tidstype: 'A1'
	  },
	  stil_hours_40_A22: {
	    klassetype: '40',
	    tidstype: 'A22'
	  },
	  stil_hours_50_A22: {
	    klassetype: '50',
	    tidstype: 'A22'
	  },
	  stil_hours_40_A33: {
	    klassetype: '40',
	    tidstype: 'A33'
	  },
	  stil_hours_50_A33: {
	    klassetype: '50',
	    tidstype: 'A33'
	  }
	};
	
	exports.default = {
	  components: {
	    StilGuides: _StilGuides2.default,
	    StilRessourceTasks: _StilRessourceTasks2.default,
	    DModal: _DModal2.default, UserTasks: _UserTasks2.default, GrundskoleIndberetningRessourceOverview: _GrundskoleIndberetningRessourceOverview2.default, GrundskoleIndberetningRessourceInsertModal: _GrundskoleIndberetningRessourceInsertModal2.default
	  },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      activeUserFilter: '',
	      isInsertOnMore: false,
	      theActiveUserId: null,
	      selectedUsers: []
	    };
	  },
	
	  computed: {
	    selectedUserObjects: function selectedUserObjects() {
	      var _this = this;
	
	      return this.selectedUsers.map(function (userId) {
	        var idx = _this.usersWithVProps.findIndex(function (user) {
	          return user.id === userId;
	        });
	        return _this.usersWithVProps[idx];
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    stilStillinger: function stilStillinger() {
	      return [{ value: '', title: 'Alle' }, { value: 'LA', title: 'Lærer' }, { value: 'BH', title: 'Børnehaveklasseleder' }, { value: 'PA', title: 'Pædagog' }, { value: 'LE', title: 'Leder' }, { value: 'AN', title: 'Andre med undervisningsopgaver', shortTitle: 'Andre med UV' }, { value: 'undtaget', title: 'Ingen undervisningsopgaver', shortTitle: 'Ingen UV' }];
	    },
	    stilStillingerWithCount: function stilStillingerWithCount() {
	      var _this2 = this;
	
	      return this.stilStillinger.map(function (stilling) {
	        if (!stilling.value) {
	          _this2.$set(stilling, 'count', _this2.usersWithVProps.length);
	        } else {
	          _this2.$set(stilling, 'count', _this2.usersWithVProps.filter(function (user) {
	            return user.v_stil_stilling && user.v_stil_stilling === stilling.value;
	          }).length);
	        }
	        return stilling;
	      });
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersWithVProps: function usersWithVProps() {
	      var _this3 = this;
	
	      return this.users.map(function (user) {
	        var birthday = null;
	        if (user.dob && user.dob.length > 6) {
	          birthday = user.dob;
	        }
	        _this3.$set(user, 'v_birthday', birthday);
	        var stilStilling = null;
	        if (user.custom_data && user.custom_data['schools'] && user.custom_data['schools'][_this3.schoolId] && user.custom_data['schools'][_this3.schoolId]['stilling']) {
	          stilStilling = user.custom_data['schools'][_this3.schoolId]['stilling'];
	        }
	        _this3.$set(user, 'v_stil_stilling', stilStilling);
	        _this3.$set(user, 'v_stil_stilling_title', _this3.getStilStillingTitle(stilStilling));
	        _this3.$set(user, 'v_stil_hours_total_normal', _this3.getUserSetting(user, 'stil_hours_40_B'));
	        _this3.$set(user, 'v_stil_hours_total_special', _this3.getUserSetting(user, 'stil_hours_50_B'));
	        _this3.$set(user, 'v_stil_hours_fag_normal', _this3.getUserSetting(user, 'stil_hours_40_A1'));
	        _this3.$set(user, 'v_stil_hours_fag_special', _this3.getUserSetting(user, 'stil_hours_50_A1'));
	        _this3.$set(user, 'v_stil_hours_uuv_normal', _this3.getUserSetting(user, 'stil_hours_40_A22'));
	        _this3.$set(user, 'v_stil_hours_uuv_special', _this3.getUserSetting(user, 'stil_hours_50_A22'));
	        _this3.$set(user, 'v_stil_hours_other_normal', _this3.getUserSetting(user, 'stil_hours_40_A33'));
	        _this3.$set(user, 'v_stil_hours_other_special', _this3.getUserSetting(user, 'stil_hours_50_A33'));
	        return user;
	      });
	    },
	    unfilledUsers: function unfilledUsers() {
	      return this.usersWithVProps.filter(function (user) {
	        return !user.gender || !user.v_birthday || !user.v_stil_stilling;
	      });
	    },
	    filteredUsersWithVProps: function filteredUsersWithVProps() {
	      var _this4 = this;
	
	      if (!this.activeUserFilter || this.activeUserFilter.length < 1) {
	        return this.usersWithVProps;
	      }
	      return this.usersWithVProps.filter(function (user) {
	        return user.v_stil_stilling && user.v_stil_stilling === _this4.activeUserFilter;
	      });
	    }
	  },
	  methods: {
	    updateRessourceFromModal: function updateRessourceFromModal(obj) {
	      var _this5 = this;
	
	      var changes = obj.change;
	      var user = obj.user;
	      var skemaer = this.stilData['ressourceskema'];
	
	      var _loop = function _loop(updateProp) {
	        user['v_' + updateProp] = changes[updateProp];
	        var idx = skemaer.findIndex(function (skema) {
	          return skema._type === 'ressource' && skema.tidstype === klasseType[updateProp]['tidstype'] && skema.personaletype === user.v_stil_stilling && skema.klassetype === klasseType[updateProp]['klassetype'];
	        });
	        skemaer[idx]['timer'] = _this5.getHoursPerPerson(user, user.v_stil_stilling, updateProp);
	      };
	
	      for (var updateProp in changes) {
	        _loop(updateProp);
	      }
	      this.$emit('updateStil', skemaer);
	    },
	    updateRessource: function updateRessource(user, updateProp) {
	      var skemaer = this.stilData['ressourceskema'];
	      var idx = skemaer.findIndex(function (skema) {
	        return skema._type === 'ressource' && skema.tidstype === klasseType[updateProp]['tidstype'] && skema.personaletype === user.v_stil_stilling && skema.klassetype === klasseType[updateProp]['klassetype'];
	      });
	      skemaer[idx]['timer'] = this.getHoursPerPerson(user, user.v_stil_stilling, updateProp);
	      this.$emit('updateStil', skemaer);
	    },
	    getHoursPerPerson: function getHoursPerPerson(user, stilStilling, roleType) {
	      var userSetting = 'v_' + roleType;
	      var users = this.users.filter(function (uUser) {
	        return uUser.v_stil_stilling === stilStilling && uUser.id !== user.id;
	      });
	      users.push(user);
	      var arrOfAmounts = users.map(function (user) {
	        return user[userSetting];
	      }).filter(function (val) {
	        return val && val * 1 > 0;
	      });
	      return arrOfAmounts.length > 0 ? arrOfAmounts.reduce(function (num, sum) {
	        return sum * 1 + num * 1;
	      }) : 0;
	    },
	    closeInsertOnMore: function closeInsertOnMore() {
	      this.selectedUsers = [];
	      this.isInsertOnMore = false;
	    },
	    toggleAll: function toggleAll() {
	      var _this6 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsersWithVProps.forEach(function (user) {
	          return _this6.selectedUsers.push(user.id);
	        });
	      }
	    },
	    selectUser: function selectUser(userId) {
	      var idx = this.selectedUsers.indexOf(userId);
	      if (idx < 0) {
	        this.selectedUsers.push(userId);
	      } else {
	        this.selectedUsers.splice(idx, 1);
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(userId) {
	      return this.selectedUsers.indexOf(userId) > -1;
	    },
	    setTheActiveUserId: function setTheActiveUserId(userId) {
	      if (this.theActiveUserId === userId) {
	        this.theActiveUserId = null;
	      } else {
	        this.theActiveUserId = userId;
	      }
	    },
	    getStilStillingTitle: function getStilStillingTitle(val) {
	      var title = '';
	      if (!val || val.length === 0) {
	        return title;
	      }
	      var idx = this.stilStillinger.findIndex(function (stilling) {
	        return stilling.value === val;
	      });
	      if (idx > -1) {
	        return this.stilStillinger[idx].shortTitle ? this.stilStillinger[idx].shortTitle : this.stilStillinger[idx].title;
	      } else {
	        return title;
	      }
	    },
	    getUserSetting: function getUserSetting(user, setting) {
	      var customData = user.custom_data;
	      if (customData['schools'] && customData['schools'][this.schoolId] && customData['schools'][this.schoolId][[setting]]) {
	        return customData['schools'][this.schoolId][[setting]];
	      } else {
	        return '';
	      }
	    },
	    updateUser: function updateUser(user, change, val) {
	      var _this7 = this;
	
	      var text = val.replace(',', '.');
	      var numberInput = text * 1;
	      if (isNaN(numberInput)) {
	        _eventbus2.default.toast = { text: 'Skal være et tal', success: false };
	        return;
	      }
	      var customData = user.custom_data;
	      var changes = {};
	      if (!customData['schools']) {
	        customData.schools = (0, _defineProperty3.default)({}, this.schoolId, (0, _defineProperty3.default)({}, change, numberInput));
	      }
	      if (customData['schools'] && !customData['schools'][this.schoolId]) {
	        customData['schools'][this.schoolId] = (0, _defineProperty3.default)({}, change, numberInput);
	      }
	      if (customData['schools'] && customData['schools'][this.schoolId]) {
	        if (val.length < 1) {
	          delete customData['schools'][this.schoolId][[change]];
	        } else {
	          customData['schools'][this.schoolId][[change]] = numberInput;
	        }
	      }
	      changes['custom_data'] = customData;
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (data) {
	        _this7.$store.commit('updateSchoolUser', data);
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  }
	};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    selectedUsers: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      numberOfUsersSaved: 0,
	      items: [{ id: 'B', title: 'Antal arbejdstimer i alt', nHours: 1924, sHours: null }, { id: 'A1', title: 'Fagopdelt undervisning', nHours: null, sHours: null }, { id: 'A22', title: 'Understøttende undervisning', nHours: null, sHours: null }, { id: 'A33', title: 'Øvrig tid med eleverne', nHours: null, sHours: null }]
	    };
	  },
	
	  computed: {
	    itemsToSave: function itemsToSave() {
	      var changes = {};
	      this.items.forEach(function (item) {
	        if (item.id === 'B') {
	          changes['stil_hours_40_B'] = item.nHours;
	          changes['stil_hours_50_B'] = item.sHours;
	        }
	        if (item.id === 'A1') {
	          changes['stil_hours_40_A1'] = item.nHours;
	          changes['stil_hours_50_A1'] = item.sHours;
	        }
	        if (item.id === 'A22') {
	          changes['stil_hours_40_A22'] = item.nHours;
	          changes['stil_hours_50_A22'] = item.sHours;
	        }
	        if (item.id === 'A33') {
	          changes['stil_hours_40_A33'] = item.nHours;
	          changes['stil_hours_50_A33'] = item.sHours;
	        }
	      });
	      return changes;
	    }
	  },
	  methods: {
	    close: function close() {
	      this.$emit('close');
	    },
	    save: function save() {
	      this.updateUsers();
	      this.$emit('save', this.items);
	    },
	    updateUsers: function updateUsers() {
	      var _this = this;
	
	      this.isSaving = true;
	      this.selectedUsers.forEach(function (user) {
	        _this.updateUser(user);
	      });
	    },
	    updateUser: function updateUser(user) {
	      var _this2 = this;
	
	      var customData = user.custom_data;
	      var changes = {};
	      for (var change in this.itemsToSave) {
	        var val = this.itemsToSave[change];
	        if (!customData['schools']) {
	          customData.schools = (0, _defineProperty3.default)({}, this.schoolId, (0, _defineProperty3.default)({}, change, val));
	        }
	        if (customData['schools'] && !customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId] = (0, _defineProperty3.default)({}, change, val);
	        }
	        if (customData['schools'] && customData['schools'][this.schoolId]) {
	          if (!val || val.length < 1) {
	            delete customData['schools'][this.schoolId][[change]];
	          } else {
	            customData['schools'][this.schoolId][[change]] = val;
	          }
	        }
	      }
	      changes['custom_data'] = customData;
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (data) {
	        _this2.$store.commit('updateSchoolUser', data);
	        _this2.numberOfUsersSaved++;
	        if (_this2.numberOfUsersSaved === _this2.selectedUsers.length) {
	          _this2.close();
	        }
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  }
	};

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    stilDataRessourceSkema: function stilDataRessourceSkema() {
	      return this.stilData && this.stilData.ressourceskema ? this.stilData.ressourceskema : [];
	    },
	    userTypes: function userTypes() {
	      return [{ id: 'LE', title: 'Ledere' }, { id: 'LA', title: 'Lærere' }, { id: 'BH', title: 'BH klasseledere' }, { id: 'PA', title: 'Pædagoger' }, { id: 'AN', title: 'Andre med undervisningsopgaver' }];
	    },
	    stilDataRess: function stilDataRess() {
	      var _this = this;
	
	      return this.userTypes.map(function (userType) {
	        var userTypeObj = {
	          id: userType.id,
	          title: userType.title,
	          number_of_usertype: _this.getNumberOfUsertype(userType.id),
	          years_of_work: _this.getYearsOfWork(userType.id),
	          stil_hours_40_B: _this.getHoursPerUserType(userType.id, '40', 'B'),
	          stil_hours_50_B: _this.getHoursPerUserType(userType.id, '50', 'B'),
	          stil_hours_40_A1: _this.getHoursPerUserType(userType.id, '40', 'A1'),
	          stil_hours_50_A1: _this.getHoursPerUserType(userType.id, '50', 'A1'),
	          stil_hours_40_A22: _this.getHoursPerUserType(userType.id, '40', 'A22'),
	          stil_hours_50_A22: _this.getHoursPerUserType(userType.id, '50', 'A22'),
	          stil_hours_40_A33: _this.getHoursPerUserType(userType.id, '40', 'A33'),
	          stil_hours_50_A33: _this.getHoursPerUserType(userType.id, '50', 'A33')
	        };
	        return userTypeObj;
	      });
	    }
	  },
	  methods: {
	    getNumberOfUsertype: function getNumberOfUsertype(personaletype) {
	      return this.users.filter(function (user) {
	        return user.v_stil_stilling === personaletype;
	      }).length;
	    },
	    getHoursPerUserType: function getHoursPerUserType(personaletype, klassetype, tidstype) {
	      var idx = this.stilDataRessourceSkema.findIndex(function (skema) {
	        return skema.personaletype === personaletype && skema.klassetype === klassetype && personaletype && skema.tidstype === tidstype;
	      });
	      return idx > -1 ? this.stilDataRessourceSkema[idx]['timer'] : 0;
	    },
	    getYearsOfWork: function getYearsOfWork(personaletype) {
	      var normalKlasse = this.getHoursPerUserType(personaletype, '40', 'B') * 1;
	      var specialKlasse = this.getHoursPerUserType(personaletype, '50', 'B') * 1;
	      var sum = normalKlasse + specialKlasse;
	      return (sum / 1924).toFixed(2);
	    }
	  }
	};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ResumePersonaleSkema = __webpack_require__(1306);
	
	var _ResumePersonaleSkema2 = _interopRequireDefault(_ResumePersonaleSkema);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _GrundskoleIndberetningTimetal = __webpack_require__(118);
	
	var _GrundskoleIndberetningTimetal2 = _interopRequireDefault(_GrundskoleIndberetningTimetal);
	
	var _GrundskoleIndberetningRessourceOverview = __webpack_require__(317);
	
	var _GrundskoleIndberetningRessourceOverview2 = _interopRequireDefault(_GrundskoleIndberetningRessourceOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { GrundskoleIndberetningRessourceOverview: _GrundskoleIndberetningRessourceOverview2.default, GrundskoleIndberetningTimetal: _GrundskoleIndberetningTimetal2.default, ResumePersonaleSkema: _ResumePersonaleSkema2.default, Loader: _Loader2.default },
	  data: function data() {
	    return {
	      isSendingToStil: false,
	      stilData: {},
	      isLoadingStilData: true
	    };
	  },
	
	  computed: {
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    ressourceskema: function ressourceskema() {
	      return this.stilData['ressourceskema'] ? this.stilData['ressourceskema'] : [];
	    },
	    undervisningskema: function undervisningskema() {
	      return this.stilData['undervisningskema'] ? this.stilData['undervisningskema'] : [];
	    }
	  },
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.isSendingToStil = true;
	      _docendo2.default.submitStilReport(this.schoolId, function (success) {
	        _this.isSendingToStil = false;
	        _eventbus2.default.toast = { text: 'Grundskoleindberetning er sendt til STIL', 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.isLoadingStilData = true;
	    _docendo2.default.showStilReport(this.schoolId, function (success) {
	      _this2.isLoadingStilData = false;
	      _this2.stilData = success;
	      console.log('success', success);
	    }, function (failure) {
	      console.log('failure');
	    });
	  }
	};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GrundskoleIndberetningTimetalFag = __webpack_require__(1292);
	
	var _GrundskoleIndberetningTimetalFag2 = _interopRequireDefault(_GrundskoleIndberetningTimetalFag);
	
	var _GrundskoleIndberetningTimetalFagSpecial = __webpack_require__(1293);
	
	var _GrundskoleIndberetningTimetalFagSpecial2 = _interopRequireDefault(_GrundskoleIndberetningTimetalFagSpecial);
	
	var _StilGuides = __webpack_require__(41);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { StilGuides: _StilGuides2.default, GrundskoleIndberetningTimetalFagSpecial: _GrundskoleIndberetningTimetalFagSpecial2.default, GrundskoleIndberetningTimetalFag: _GrundskoleIndberetningTimetalFag2.default },
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    isReadOnly: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      klasstype: {
	        40: 'Normalklasse',
	        50: 'Specialklasse'
	      },
	      grades: [{ value: 1, title: '1.' }, { value: 2, title: '2.' }, { value: 3, title: '3.' }, { value: 4, title: '4.' }, { value: 5, title: '5.' }, { value: 6, title: '6.' }, { value: 7, title: '7.' }, { value: 8, title: '8.' }, { value: 9, title: '9.' }],
	      fag: {
	        110: 'Dansk',
	        120: 'Engelsk',
	        130: 'Tysk',
	        140: 'Fransk',
	        170: 'Kristendomskundskab',
	        171: 'Kristendomskundskab/religion (10. klasse)',
	        181: 'Historie',
	        182: 'Samfundsfag',
	        210: 'Idræt',
	        220: 'Musik',
	        230: 'Billedkunst',
	        902: 'Håndværk og design samt madkundskab',
	        310: 'Matematik',
	        320: 'Fysik/Kemi',
	        330: 'Geografi',
	        340: 'Biologi',
	        350: 'Natur/teknologi',
	        511: 'Praktisk/Musisk valgfag: Håndværk/design',
	        520: 'Praktisk/Musisk valgfag: Musik',
	        531: 'Praktisk/Musisk valgfag: Billedkunst',
	        540: 'Praktisk/Musisk valgfag: Madkundskab',
	        589: 'Andre tilbudsfag / valgfag',
	        600: 'Børnehaveklasse',
	        799: 'Øvrige fag',
	        800: 'Understøttende undervisning'
	      }
	    };
	  },
	
	  computed: {
	    undervisningskema: function undervisningskema() {
	      return this.stilData && this.stilData['undervisningskema'] ? this.stilData['undervisningskema'] : [];
	    },
	    fagFraStil: function fagFraStil() {
	      var filteredKlassetrin = [0, '0', 10, '10'];
	      return this.stilData.undervisningskema.filter(function (type) {
	        return type._type === 'undervisningstid' && type.klassetype === '40' && !filteredKlassetrin.includes(type.klassetrin);
	      });
	    }
	  },
	  methods: {
	    updateCell: function updateCell(type, cell, num) {
	      var obj = { type: type, cell: cell, num: num };
	      this.$emit('update', obj);
	    },
	    updateSubject: function updateSubject(obj) {
	      this.$emit('updateSubject', obj);
	    },
	    updateKonfirmation: function updateKonfirmation(obj) {
	      this.$emit('updateKonfirmation', obj);
	    },
	    updatePraktik: function updatePraktik(fag) {
	      this.$emit('updatePraktik', fag);
	    },
	    setTolaerer: function setTolaerer(fag) {
	      this.$emit('setTolaerer', fag);
	    },
	    setForanstaltning: function setForanstaltning(foranstaltning) {
	      this.$emit('setForanstaltning', foranstaltning);
	    },
	    nulstilKlasse: function nulstilKlasse(grade) {
	      this.$emit('nulstilKlasse', grade);
	    }
	  }
	};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(38);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(37);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    fagFraStil: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    undervisningskema: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isReadOnly: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      fag: [{
	        _type: 'undervisningstid', fagkode: '600', title: 'Børnehaveklasse', klasser: [],
	        obligatorisk: { 0: true }
	      }, {
	        _type: 'undervisningstid',
	        fagkode: '110',
	        title: 'Dansk',
	        klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '120', title: 'Engelsk', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '130', title: 'Tysk', klasser: [],
	        obligatorisk: { 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '140', title: 'Fransk', klasser: [],
	        obligatorisk: { 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '181', title: 'Historie', klasser: [],
	        obligatorisk: { 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '170', title: 'Kristendomskundskab', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, { _type: 'konfirmation', title: 'Hvor finder konfirmationsforberedelsen sted?', klassetrin: 7, klasser: [] }, {
	        _type: 'undervisningstid',
	        fagkode: '182',
	        title: 'Samfundsfag',
	        klasser: [],
	        obligatorisk: { 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '310', title: 'Matematik', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '350', title: 'Natur/teknologi', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '330', title: 'Geografi', klasser: [],
	        obligatorisk: { 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '340', title: 'Biologi', klasser: [],
	        obligatorisk: { 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '320', title: 'Fysik/Kemi', klasser: [],
	        obligatorisk: { 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '210', title: 'Idræt', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '220', title: 'Musik', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '230', title: 'Billedkunst', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '902', title: 'Håndværk og design samt madkundskab', klasser: [],
	        obligatorisk: { 3: true, 4: true, 5: true, 6: true, 7: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '589', title: 'Valgfag', klasser: [],
	        obligatorisk: { 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '511', title: 'Praktisk/Musisk valgfag: Håndværk/ design', klasser: [],
	        obligatorisk: { 7: true, 8: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '520', title: 'Praktisk/Musisk valgfag: Musik', klasser: [],
	        obligatorisk: { 7: true, 8: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '531', title: 'Praktisk/Musisk valgfag: Billedkunst', klasser: [],
	        obligatorisk: { 7: true, 8: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '540', title: 'Praktisk/Musisk valgfag: Madkundskab', klasser: [],
	        obligatorisk: { 7: true, 8: true }
	      }],
	      klasstype: {
	        40: 'Normalklasse',
	        50: 'Specialklasse'
	      },
	      grades: [{ value: '1', title: '1.' }, { value: '2', title: '2.' }, { value: '3', title: '3.' }, { value: '4', title: '4.' }, { value: '5', title: '5.' }, { value: '6', title: '6.' }, { value: '7', title: '7.' }, { value: '8', title: '8.' }, { value: '9', title: '9.' }],
	      minimumFagopdelt: {
	        1: 750,
	        2: 780,
	        3: 810,
	        4: 870,
	        5: 930,
	        6: 930,
	        7: 960,
	        8: 990,
	        9: 990
	      },
	      totalMinimum: {
	        1: 1110,
	        2: 1110,
	        3: 1110,
	        4: 1320,
	        5: 1320,
	        6: 1320,
	        7: 1400,
	        8: 1400,
	        9: 1400
	      },
	      understottende: [{
	        _type: 'undervisningstid',
	        fagkode: '800',
	        title: 'Understøttende undervisning i alt inkl. alle pauser',
	        klasser: []
	      }],
	      tolaererOrdning: [{
	        _type: 'tolaerer',
	        godkendelsestype: 'b',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i normalklasser jf. §16b?',
	        klasser: []
	      }, {
	        _type: 'tolaerer',
	        godkendelsestype: 'd',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i normalklasser jf. §16d?',
	        klasser: []
	      }],
	      foranstaltninger: [{
	        _type: 'foranstaltninger',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i normalklasser jf. §16e?',
	        klasser: []
	      }],
	      valgfagsFagKoder: [511, 520, 531, 540],
	      tyskOgFranskKoder: [130, 140]
	    };
	  },
	
	  computed: {
	    foranstaltningerFraStil: function foranstaltningerFraStil() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'foranstaltninger' && skema.klassetype === '40';
	      });
	    },
	    foranstaltningerMedProps: function foranstaltningerMedProps() {
	      var _this = this;
	
	      return this.foranstaltninger.map(function (foranstaltning) {
	        foranstaltning.klasser = [];
	        _this.grades.forEach(function (grade) {
	          var idx = _this.foranstaltningerFraStil.findIndex(function (faget) {
	            return faget.klassetrin * 1 === grade.value * 1;
	          });
	          foranstaltning.klasser.push(_this.foranstaltningerFraStil[idx]);
	        });
	        return foranstaltning;
	      });
	    },
	    tolaerer: function tolaerer() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'tolaerer' && skema.klassetype === '40';
	      });
	    },
	    tolaererArr: function tolaererArr() {
	      var _this2 = this;
	
	      return this.tolaererOrdning.map(function (toLaerer) {
	        var arr = _this2.tolaerer.filter(function (obj) {
	          return obj.godkendelsestype === toLaerer.godkendelsestype;
	        });
	        toLaerer.klasser = [];
	        _this2.grades.forEach(function (grade) {
	          var idx = arr.findIndex(function (faget) {
	            return faget.klassetrin * 1 === grade.value * 1;
	          });
	          toLaerer.klasser.push(arr[idx]);
	        });
	        return toLaerer;
	      });
	    },
	    hojesteValgfag: function hojesteValgfag() {
	      var _this3 = this;
	
	      var valgfagene = this.fagMedVProps.filter(function (fag) {
	        var fagKode = fag.fagkode * 1;
	        return fag._type === 'undervisningstid' && _this3.valgfagsFagKoder.includes(fagKode);
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      valgfagene.forEach(function (valgfag) {
	        valgfag.klasser.forEach(function (klasse) {
	          if (klasse && klasse.num) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            var hoursInKlasse = parseFloat(klasse.num);
	
	            if (klassetrin in hoursInGrades && hoursInKlasse > hoursInGrades[klassetrin]) {
	              hoursInGrades[klassetrin] = hoursInKlasse;
	            }
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    highestTyskFransk: function highestTyskFransk() {
	      var subjectCodesForGermanAndFrenchToCheckForHighestNumber = this.tyskOgFranskKoder;
	      var tyskFranskFag = this.fagMedVProps.filter(function (fag) {
	        var fagKode = parseInt(fag.fagkode, 10);
	        return fag._type === 'undervisningstid' && subjectCodesForGermanAndFrenchToCheckForHighestNumber.includes(fagKode);
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	
	      tyskFranskFag.forEach(function (fag) {
	        fag.klasser.forEach(function (klasse) {
	          if (klasse && klasse.num && klasse.v_originalObject && klasse.v_originalObject.klassetrin) {
	            var klassetrin = parseInt(klasse.v_originalObject.klassetrin, 10);
	            var hoursInKlasse = parseFloat(klasse.num);
	            if (klassetrin in hoursInGrades && hoursInKlasse > hoursInGrades[klassetrin]) {
	              hoursInGrades[klassetrin] = hoursInKlasse;
	            }
	          }
	        });
	      });
	
	      return Object.fromEntries((0, _entries2.default)(hoursInGrades).filter(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            klassetrin = _ref2[0],
	            hours = _ref2[1];
	
	        return hours > 0;
	      }));
	    },
	    obligatoriskFagopdelt: function obligatoriskFagopdelt() {
	      var _this4 = this;
	
	      var fagUdenValgfag = this.fagMedVProps.filter(function (fag) {
	        var fagKode = fag.fagkode * 1;
	        return fag._type === 'undervisningstid' && !_this4.valgfagsFagKoder.includes(fagKode) && !_this4.tyskOgFranskKoder.includes(fagKode);
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fagUdenValgfag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num && (klasse.v_obligatorisk || key === 10)) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += klasse.num;
	          }
	        });
	      });
	
	      var highestTyskFransk = this.highestTyskFransk;
	      (0, _keys2.default)(hoursInGrades).forEach(function (klassetrin) {
	        if (highestTyskFransk[klassetrin]) {
	          hoursInGrades[klassetrin] += highestTyskFransk[klassetrin];
	        }
	      });
	
	      var highestValgfag = this.hojesteValgfag;
	      (0, _keys2.default)(hoursInGrades).forEach(function (klassetrin) {
	        if (highestValgfag[klassetrin]) {
	          hoursInGrades[klassetrin] += highestValgfag[klassetrin];
	        }
	      });
	      return hoursInGrades;
	    },
	    sammentaelling: function sammentaelling() {
	      var _this5 = this;
	
	      var fagUdenValgfag = this.fagMedVProps.filter(function (fag) {
	        var fagKode = fag.fagkode * 1;
	        return fag._type === 'undervisningstid' && !_this5.valgfagsFagKoder.includes(fagKode) && !_this5.tyskOgFranskKoder.includes(fagKode);
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fagUdenValgfag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse) {
	          if (klasse && klasse.num) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += parseFloat(klasse.num);
	          }
	        });
	      });
	
	      this.uuv.forEach(function (uuv) {
	        uuv.klasser.forEach(function (uuvKlasse, key) {
	          if (uuvKlasse && uuvKlasse.num) {
	            var prop = uuvKlasse.v_originalObject.klassetrin;
	            hoursInGrades[prop] += uuvKlasse.num;
	          }
	        });
	      });
	
	      var highestTyskFransk = this.highestTyskFransk;
	      (0, _keys2.default)(hoursInGrades).forEach(function (klassetrin) {
	        if (highestTyskFransk[klassetrin]) {
	          hoursInGrades[klassetrin] += highestTyskFransk[klassetrin];
	        }
	      });
	
	      var highestValgfag = this.hojesteValgfag;
	      (0, _keys2.default)(hoursInGrades).forEach(function (klassetrin) {
	        if (highestValgfag[klassetrin]) {
	          hoursInGrades[klassetrin] += highestValgfag[klassetrin];
	        }
	      });
	      return hoursInGrades;
	    },
	    uuv: function uuv() {
	      var _this6 = this;
	
	      return this.understottende.map(function (fag) {
	        fag.v_originalObject = _this6.fagFraStil[_this6.fagFraStil.findIndex(function (faget) {
	          return faget.fagkode === fag.fagkode;
	        })];
	        fag.klasser = [];
	        _this6.grades.forEach(function (grade) {
	          fag.klasser.push(_this6.findGradeAndHours(fag, grade.value, '40'));
	        });
	        return fag;
	      });
	    },
	    ovrigFagopdelt: function ovrigFagopdelt() {
	      var fag = this.fagMedVProps.filter(function (fag) {
	        return fag._type === 'undervisningstid';
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num && !klasse.v_obligatorisk && key !== 10) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += klasse.num;
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    kristendom: function kristendom() {
	      return this.undervisningskema[this.undervisningskema.findIndex(function (skema) {
	        return skema._type === 'konfirmation';
	      })];
	    },
	    fagMedVProps: function fagMedVProps() {
	      var _this7 = this;
	
	      return this.fag.map(function (fag) {
	        if (fag._type === 'undervisningstid') {
	          fag.v_fag = _this7.fagFraStil[_this7.fagFraStil.findIndex(function (faget) {
	            return faget.fagkode === fag.fagkode;
	          })];
	          fag.klasser = [];
	          _this7.grades.forEach(function (grade) {
	            fag.klasser.push(_this7.findGradeAndHours(fag, grade.value, '40'));
	          });
	        }
	        if (fag._type === 'konfirmation') {
	          fag.klasser = [];
	          fag.v_fag = _this7.undervisningskema[_this7.undervisningskema.findIndex(function (skema) {
	            return skema._type === 'konfirmation';
	          })];
	          _this7.grades.forEach(function (grade) {
	            if (grade.value === '7' || grade.value === '8') {
	              fag.klasser.push({ checkbox: true, value: grade.value });
	            } else {
	              fag.klasser.push(false);
	            }
	          });
	        }
	        if (fag._type === 'praktik') {
	          fag.v_fag = _this7.undervisningskema[_this7.undervisningskema.findIndex(function (skema) {
	            return skema._type === 'praktik';
	          })];
	          fag.klasser = [];
	          fag.praktikkode = fag.v_fag.praktikkode;
	          _this7.grades.forEach(function (grade) {
	            if (grade.value === '10') {
	              fag.klasser.push({ checkbox: true, value: fag.v_fag.praktikkode });
	            } else {
	              fag.klasser.push(false);
	            }
	          });
	        }
	        return fag;
	      });
	    }
	  },
	  methods: {
	    setForanstaltning: function setForanstaltning(foranstaltning) {
	      this.$emit('setForanstaltning', foranstaltning);
	    },
	    findToLaererAndHours: function findToLaererAndHours(arr, klassetrin) {
	      var idx = arr.findIndex(function (faget) {
	        return faget.klassetrin * 1 === klassetrin * 1;
	      });
	      if (idx > -1) {
	        return { num: arr[idx]['godkendelseskode'], v_originalObject: arr[idx] };
	      } else {
	        return false;
	      }
	    },
	    setPraktik: function setPraktik(fag) {
	      this.$emit('updatePraktik', fag);
	    },
	    setTolaerer: function setTolaerer(fag) {
	      this.$emit('setTolaerer', fag);
	    },
	    updateCell: function updateCell(originalObject, value) {
	      var obj = { originalObject: originalObject, value: value, toUpdate: 'klokketimer' };
	      this.$emit('update', obj);
	    },
	    setKonfirmation: function setKonfirmation(fag, klasse) {
	      var obj = { v_fag: fag, value: klasse };
	      this.$emit('updateKonfirmation', obj);
	    },
	    findGradeAndHours: function findGradeAndHours(fag, klassetrin, klassetype) {
	      var idx = this.fagFraStil.findIndex(function (faget) {
	        return faget.klassetype === klassetype && faget.fagkode === fag.fagkode && faget.klassetrin * 1 === klassetrin * 1;
	      });
	      var self = this;
	
	      function getIsObligatorisk() {
	        if (fag.fagkode === '170') {
	          return fag.obligatorisk && fag.obligatorisk[klassetrin] && self.kristendom && self.kristendom['klassetrin'] * 1 !== klassetrin * 1;
	        }
	        return fag.obligatorisk && fag.obligatorisk[klassetrin];
	      }
	
	      if (idx > -1) {
	        return {
	          num: this.fagFraStil[idx]['klokketimer'],
	          v_originalObject: this.fagFraStil[idx],
	          v_obligatorisk: getIsObligatorisk()
	        };
	      } else {
	        return false;
	      }
	    },
	    nulstilKlasse: function nulstilKlasse(grade) {
	      this.$emit('nulstilKlasse', grade);
	    }
	  }
	};

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    undervisningskema: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isReadOnly: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      fag: [{
	        _type: 'undervisningstid', fagkode: '600', title: 'Børnehaveklasse', klasser: [],
	        obligatorisk: { 0: true }
	      }, {
	        _type: 'undervisningstid',
	        fagkode: '110',
	        title: 'Dansk',
	        klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '181', title: 'Historie', klasser: [],
	        obligatorisk: { 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '310', title: 'Matematik', klasser: [],
	        obligatorisk: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true }
	      }, {
	        _type: 'undervisningstid', fagkode: '799', title: 'Øvrige fag', klasser: [],
	        obligatorisk: {}
	      }],
	      klasstype: {
	        40: 'Normalklasse',
	        50: 'Specialklasse'
	      },
	      grades: [{ value: '1', title: '1.' }, { value: '2', title: '2.' }, { value: '3', title: '3.' }, { value: '4', title: '4.' }, { value: '5', title: '5.' }, { value: '6', title: '6.' }, { value: '7', title: '7.' }, { value: '8', title: '8.' }, { value: '9', title: '9.' }],
	      minimumFagopdelt: {
	        1: 750,
	        2: 780,
	        3: 810,
	        4: 870,
	        5: 930,
	        6: 930,
	        7: 960,
	        8: 990,
	        9: 990
	      },
	      totalMinimum: {
	        1: 1110,
	        2: 1110,
	        3: 1110,
	        4: 1320,
	        5: 1320,
	        6: 1320,
	        7: 1400,
	        8: 1400,
	        9: 1400
	      },
	      understottende: [{
	        _type: 'undervisningstid',
	        fagkode: '800',
	        title: 'Understøttende undervisning i alt inkl. alle pauser',
	        klasser: []
	      }],
	      tolaererOrdning: [{
	        _type: 'tolaerer',
	        godkendelsestype: 'b',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i specialklasser jf. §16b?',
	        klasser: []
	      }, {
	        _type: 'tolaerer',
	        godkendelsestype: 'd',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i specialklasser jf. §16d?',
	        klasser: []
	      }],
	      foranstaltninger: [{
	        _type: 'foranstaltninger',
	        title: 'Har kommunalbestyrelsen godkendt, at en del af den understøttende undervisning konverteres til ekstra personale i specialklasser jf. §16e?',
	        klasser: []
	      }]
	    };
	  },
	
	  computed: {
	    fagFraStil: function fagFraStil() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'undervisningstid' && skema.klassetype === '50';
	      });
	    },
	    foranstaltningerFraStil: function foranstaltningerFraStil() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'foranstaltninger' && skema.klassetype === '50';
	      });
	    },
	    foranstaltningerMedProps: function foranstaltningerMedProps() {
	      var _this = this;
	
	      return this.foranstaltninger.map(function (foranstaltning) {
	        foranstaltning.klasser = [];
	        _this.grades.forEach(function (grade) {
	          var idx = _this.foranstaltningerFraStil.findIndex(function (faget) {
	            return faget.klassetrin * 1 === grade.value * 1;
	          });
	          foranstaltning.klasser.push(_this.foranstaltningerFraStil[idx]);
	        });
	        return foranstaltning;
	      });
	    },
	    tolaerer: function tolaerer() {
	      return this.undervisningskema.filter(function (skema) {
	        return skema._type === 'tolaerer' && skema.klassetype === '50';
	      });
	    },
	    tolaererArr: function tolaererArr() {
	      var _this2 = this;
	
	      return this.tolaererOrdning.map(function (toLaerer) {
	        var arr = _this2.tolaerer.filter(function (obj) {
	          return obj.godkendelsestype === toLaerer.godkendelsestype;
	        });
	        toLaerer.klasser = [];
	        _this2.grades.forEach(function (grade) {
	          var idx = arr.findIndex(function (faget) {
	            return faget.klassetrin * 1 === grade.value * 1;
	          });
	          toLaerer.klasser.push(arr[idx]);
	        });
	        return toLaerer;
	      });
	    },
	    sammentaelling: function sammentaelling() {
	      var fag = this.fagMedVProps.filter(function (fag) {
	        return fag._type === 'undervisningstid';
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num) {
	            var prop = klasse.v_originalObject.klassetrin;
	            hoursInGrades[prop] += klasse.num;
	          }
	        });
	      });
	      this.uuv.forEach(function (uuv) {
	        uuv.klasser.forEach(function (uuvKlasse, key) {
	          if (uuvKlasse && uuvKlasse.num) {
	            var prop = uuvKlasse.v_originalObject.klassetrin;
	            hoursInGrades[prop] += uuvKlasse.num;
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    uuv: function uuv() {
	      var _this3 = this;
	
	      return this.understottende.map(function (fag) {
	        fag.v_originalObject = _this3.fagFraStil[_this3.fagFraStil.findIndex(function (faget) {
	          return faget.fagkode === fag.fagkode;
	        })];
	        fag.klasser = [];
	        _this3.grades.forEach(function (grade) {
	          fag.klasser.push(_this3.findGradeAndHours(fag, grade.value, '50'));
	        });
	        return fag;
	      });
	    },
	    obligatoriskFagopdelt: function obligatoriskFagopdelt() {
	      var fag = this.fagMedVProps.filter(function (fag) {
	        return fag._type === 'undervisningstid';
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num && (klasse.v_obligatorisk || key === 10)) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += klasse.num;
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    ovrigFagopdelt: function ovrigFagopdelt() {
	      var fag = this.fagMedVProps.filter(function (fag) {
	        return fag._type === 'undervisningstid';
	      });
	      var hoursInGrades = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0,
	        5: 0,
	        6: 0,
	        7: 0,
	        8: 0,
	        9: 0
	      };
	      fag.forEach(function (hvertFag) {
	        hvertFag.klasser.forEach(function (klasse, key) {
	          if (klasse && klasse.num && !klasse.v_obligatorisk && key !== 10) {
	            var klassetrin = klasse.v_originalObject.klassetrin;
	            hoursInGrades[klassetrin] += klasse.num;
	          }
	        });
	      });
	      return hoursInGrades;
	    },
	    kristendom: function kristendom() {
	      return this.undervisningskema[this.undervisningskema.findIndex(function (skema) {
	        return skema._type === 'konfirmation';
	      })];
	    },
	    fagMedVProps: function fagMedVProps() {
	      var _this4 = this;
	
	      return this.fag.map(function (fag) {
	        if (fag._type === 'undervisningstid') {
	          fag.v_fag = _this4.fagFraStil[_this4.fagFraStil.findIndex(function (faget) {
	            return faget.fagkode === fag.fagkode;
	          })];
	          fag.klasser = [];
	          _this4.grades.forEach(function (grade) {
	            fag.klasser.push(_this4.findGradeAndHours(fag, grade.value, '50'));
	          });
	        }
	        if (fag._type === 'konfirmation') {
	          fag.klasser = [];
	          fag.v_fag = _this4.undervisningskema[_this4.undervisningskema.findIndex(function (skema) {
	            return skema._type === 'konfirmation';
	          })];
	          _this4.grades.forEach(function (grade) {
	            if (grade.value === '7' || grade.value === '8') {
	              fag.klasser.push({ checkbox: true, value: grade.value });
	            } else {
	              fag.klasser.push(false);
	            }
	          });
	        }
	        if (fag._type === 'praktik') {
	          fag.v_fag = _this4.undervisningskema[_this4.undervisningskema.findIndex(function (skema) {
	            return skema._type === 'praktik';
	          })];
	          fag.klasser = [];
	          fag.praktikkode = fag.v_fag.praktikkode;
	          _this4.grades.forEach(function (grade) {
	            if (grade.value === '10') {
	              fag.klasser.push({ checkbox: true, value: fag.v_fag.praktikkode });
	            } else {
	              fag.klasser.push(false);
	            }
	          });
	        }
	        return fag;
	      });
	    }
	  },
	  methods: {
	    findToLaererAndHours: function findToLaererAndHours(arr, klassetrin) {
	      var idx = arr.findIndex(function (faget) {
	        return faget.klassetrin * 1 === klassetrin * 1;
	      });
	      if (idx > -1) {
	        return { num: arr[idx]['godkendelseskode'], v_originalObject: arr[idx] };
	      } else {
	        return false;
	      }
	    },
	    setPraktik: function setPraktik(fag) {
	      this.$emit('updatePraktik', fag);
	    },
	    setTolaerer: function setTolaerer(fag) {
	      this.$emit('setTolaerer', fag);
	    },
	    setForanstaltning: function setForanstaltning(foranstaltning) {
	      this.$emit('setForanstaltning', foranstaltning);
	    },
	    updateCell: function updateCell(originalObject, value) {
	      var obj = { originalObject: originalObject, value: value, toUpdate: 'klokketimer' };
	      this.$emit('update', obj);
	    },
	    setKonfirmation: function setKonfirmation(fag, klasse) {
	      var obj = { v_fag: fag, value: klasse };
	      this.$emit('updateKonfirmation', obj);
	    },
	    findGradeAndHours: function findGradeAndHours(fag, klassetrin, klassetype) {
	      var idx = this.fagFraStil.findIndex(function (faget) {
	        return faget.klassetype === klassetype && faget.fagkode === fag.fagkode && faget.klassetrin * 1 === klassetrin * 1;
	      });
	      var self = this;
	
	      function getIsObligatorisk() {
	        if (fag.fagkode === '170') {
	          return fag.obligatorisk && fag.obligatorisk[klassetrin] && self.kristendom && self.kristendom['klassetrin'] * 1 !== klassetrin * 1;
	        }
	        return fag.obligatorisk && fag.obligatorisk[klassetrin];
	      }
	
	      if (idx > -1) {
	        return {
	          num: this.fagFraStil[idx]['klokketimer'],
	          v_originalObject: this.fagFraStil[idx],
	          v_obligatorisk: getIsObligatorisk()
	        };
	      } else {
	        return false;
	      }
	    }
	  }
	};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _StilGuides = __webpack_require__(41);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { StilGuides: _StilGuides2.default },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      theSelectMonth: null,
	      activeFilter: 0
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersWithVProps: function usersWithVProps() {
	      var _this = this;
	
	      return this.users.map(function (user) {
	        var birthday = null;
	        if (user.dob && user.dob.length > 6) {
	          birthday = user.dob;
	        }
	        _this.$set(user, 'v_birthday', birthday);
	        var stilStilling = null;
	        if (user.custom_data && user.custom_data['schools'] && user.custom_data['schools'][_this.schoolId] && user.custom_data['schools'][_this.schoolId]['stilling']) {
	          stilStilling = user.custom_data['schools'][_this.schoolId]['stilling'];
	        }
	        _this.$set(user, 'v_stil_stilling', stilStilling);
	        return user;
	      });
	    },
	    unfilledUsers: function unfilledUsers() {
	      return this.usersWithVProps.filter(function (user) {
	        return !user.gender || !user.v_birthday || !user.v_stil_stilling;
	      });
	    },
	    filteredUsersWithVProps: function filteredUsersWithVProps() {
	      if (this.activeFilter === 0) {
	        return this.usersWithVProps;
	      } else {
	        return this.unfilledUsers;
	      }
	    }
	  },
	  methods: {
	    updateUser: function updateUser(user, change, val) {
	      var _this2 = this;
	
	      var customData = user.custom_data;
	      var errors = false;
	      var changes = {};
	      changes[change] = val;
	      if (change === 'stil_stilling') {
	        if (!customData['schools']) {
	          customData.schools = (0, _defineProperty3.default)({}, this.schoolId, { 'stilling': val });
	        }
	        if (customData['schools'] && !customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId] = { 'stilling': val };
	        }
	        if (customData['schools'] && customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId]['stilling'] = val;
	        }
	        changes['custom_data'] = customData;
	      }
	      if (change === 'dob') {
	        if (!(0, _moment2.default)(val).isValid() || (0, _moment2.default)(val).isAfter((0, _moment2.default)())) {
	          _eventbus2.default.toast = { text: 'Ugyldig fødselsdato', success: false };
	          errors = true;
	          var originalDob = JSON.parse((0, _stringify2.default)(user.dob));
	          user.dob = null;
	          user.dob = originalDob;
	        }
	        changes[change] = val;
	      }
	      if (errors) {
	        return;
	      }
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (success) {
	        _this2.$store.commit('updateSchoolUser', success);
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	      });
	    }
	  }
	};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _StilGuides = __webpack_require__(41);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _KompetenceIndberetningLinjeFag = __webpack_require__(1303);
	
	var _KompetenceIndberetningLinjeFag2 = _interopRequireDefault(_KompetenceIndberetningLinjeFag);
	
	var _KompetenceIndberetningKlasser = __webpack_require__(1300);
	
	var _KompetenceIndberetningKlasser2 = _interopRequireDefault(_KompetenceIndberetningKlasser);
	
	var _KompetenceIndberetningDaekning = __webpack_require__(1297);
	
	var _KompetenceIndberetningDaekning2 = _interopRequireDefault(_KompetenceIndberetningDaekning);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _KompetenceIndberetningIndberet = __webpack_require__(1299);
	
	var _KompetenceIndberetningIndberet2 = _interopRequireDefault(_KompetenceIndberetningIndberet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    KompetenceIndberetningIndberet: _KompetenceIndberetningIndberet2.default,
	    StilGuides: _StilGuides2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    Loader: _Loader2.default,
	    KompetenceIndberetningLinjeFag: _KompetenceIndberetningLinjeFag2.default,
	    KompetenceIndberetningKlasser: _KompetenceIndberetningKlasser2.default,
	    KompetenceIndberetningDaekning: _KompetenceIndberetningDaekning2.default
	  },
	  data: function data() {
	    return {
	      dbStilData: null,
	      stilData: null,
	      isLoadingStilData: false,
	      theActiveTab: 1,
	      theTabs: {
	        1: {
	          title: 'Undervisningskompetencer',
	          component: _KompetenceIndberetningLinjeFag2.default
	        },
	        2: {
	          title: 'Klasser',
	          component: _KompetenceIndberetningKlasser2.default
	        },
	        3: {
	          title: 'Fag',
	          component: _KompetenceIndberetningKlasser2.default,
	          isShowSubjects: true
	        },
	        4: {
	          title: 'Kompetencedækning',
	          component: _KompetenceIndberetningDaekning2.default
	        },
	        5: {
	          title: 'Resumé og indberet',
	          component: _KompetenceIndberetningIndberet2.default
	        }
	      },
	      theActiveComponent: _KompetenceIndberetningLinjeFag2.default,
	      standardSubjects: [{ subject_code: 110, fagkode: '110', name: 'Dansk' }, { subject_code: 120, fagkode: '120', name: 'Engelsk' }, { subject_code: 130, fagkode: '130', name: 'Tysk (tilbudsfag)' }, { subject_code: 134, fagkode: '134', name: 'Tysk (valgfag)' }, { subject_code: 140, fagkode: '140', name: 'Fransk (tilbudsfag)' }, { subject_code: 144, fagkode: '144', name: 'Fransk (valgfag)' }, { subject_code: 170, fagkode: '170', name: 'Kristendomskundskab' }, { subject_code: 171, fagkode: '171', name: 'Kristendomskundskab/religion' }, { subject_code: 181, fagkode: '181', name: 'Historie' }, { subject_code: 182, fagkode: '182', name: 'Samfundsfag' }, { subject_code: 210, fagkode: '210', name: 'Idræt' }, { subject_code: 220, fagkode: '220', name: 'Musik' }, { subject_code: 230, fagkode: '230', name: 'Billedkunst' }, { subject_code: 240, fagkode: '240', name: 'Håndarbejde' }, { subject_code: 245, fagkode: '245', name: 'Håndværk og design' }, { subject_code: 250, fagkode: '250', name: 'Sløjd' }, { subject_code: 260, fagkode: '260', name: 'Madkundskab' }, { subject_code: 310, fagkode: '310', name: 'Matematik' }, { subject_code: 320, fagkode: '320', name: 'Fysik/kemi' }, { subject_code: 330, fagkode: '330', name: 'Geografi' }, { subject_code: 340, fagkode: '340', name: 'Biologi' }, { subject_code: 350, fagkode: '350', name: 'Natur/teknik' }, { subject_code: 511, fagkode: '511', name: 'Praktisk/Musisk valgfag: Håndværk/design' }, { subject_code: 520, fagkode: '520', name: 'Praktisk/Musisk valgfag: Musik' }, { subject_code: 531, fagkode: '531', name: 'Praktisk/Musisk valgfag: Billedkunst' }, { subject_code: 540, fagkode: '540', name: 'Praktisk/Musisk valgfag: Madkundskab' }, { subject_code: 600, fagkode: '600', name: 'Børnehaveklasse' }],
	      isShowSubjects: false,
	      klokketimetyper: {
	        1: 'Almindelig undervisning',
	        10: 'Tolærerordning',
	        20: 'Undervisningsassistenter og pædagoger',
	        30: 'Supplerende undervisning af enkelte elever',
	        91: 'Andet',
	        92: 'Ej specificeret på nuværende tidspunkt'
	      }
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersSSNHash: function usersSSNHash() {
	      var _this = this;
	
	      var users = this.users.filter(function (user) {
	        return _this.getUserStilling(user);
	      });
	      return this.$helpers.hashMap(users, 'ssn');
	    },
	    userIdsKlasseFagMap: function userIdsKlasseFagMap() {
	      var fagOnUserMap = {};
	      this.stilData.klasser.forEach(function (klasse) {
	        klasse.fag.forEach(function (fag) {
	          fag.laerere.forEach(function (learer) {
	            var vUid = klasse.klasse_id + '_' + fag.fag_id;
	            var vFag = {
	              vUid: vUid,
	              user_id: learer.user_id,
	              cpr: learer.cpr,
	              klassebetegnelse: klasse.klassebetegnelse,
	              klasse_id: klasse.klasse_id,
	              klasse_type: klasse.klasse_type,
	              klasse_klokketimer: fag.klokketimer,
	              fag_id: fag.fag_id,
	              fag_navn: fag.fag_navn,
	              fagkode: fag.fagkode,
	              learer_klokketimer: learer.klokketimer,
	              klokketimer_type: learer.klokketimer_type
	            };
	            if (learer.user_id) {
	              if (!fagOnUserMap[learer.user_id]) {
	                fagOnUserMap[learer.user_id] = [vFag];
	              } else {
	                fagOnUserMap[learer.user_id].push(vFag);
	              }
	            }
	          });
	        });
	      });
	      return fagOnUserMap;
	    }
	  },
	  methods: {
	    getUserStilling: function getUserStilling(user) {
	      return user.custom_data && user.custom_data.schools && user.custom_data.schools[this.schoolId] && user.custom_data.schools[this.schoolId]['stilling'] && user.custom_data.schools[this.schoolId]['stilling'] !== 'undtaget';
	    },
	    getIsTheActiveTab: function getIsTheActiveTab(prop) {
	      return this.theActiveTab * 1 === prop * 1;
	    },
	    setTheActiveTab: function setTheActiveTab(tab, prop) {
	      this.theActiveComponent = tab.component;
	      this.theActiveTab = prop;
	      this.isShowSubjects = tab['isShowSubjects'];
	      if (prop === '5') {
	        this.removeTeachersWithoutStilling();
	      } else {
	        this.readStilCompetencyReport();
	      }
	    },
	    readStilCompetencyReport: function readStilCompetencyReport() {
	      var _this2 = this;
	
	      this.isLoadingStilData = true;
	      _docendo2.default.showStilCompetencyReport(this.schoolId, function (success) {
	        _this2.isLoadingStilData = false;
	        _this2.stilData = success;
	        _this2.dbStilData = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    updateStil: function updateStil(report) {
	      var _this3 = this;
	
	      _docendo2.default.updateStilCompetencyReport(this.schoolId, report, function (success) {
	        _eventbus2.default.toast = { text: 'Opdateret', success: true };
	        _this3.stilData = success;
	        _this3.dbStilData = success;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	      });
	    },
	    removeTeachersWithoutStilling: function removeTeachersWithoutStilling() {
	      var _this4 = this;
	
	      this.isLoadingStilData = true;
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      report['laerere'] = this.stilData['laerere'].filter(function (laerer) {
	        return laerer.stilling !== 'undtaget';
	      });
	
	      _docendo2.default.updateStilCompetencyReport(this.schoolId, report, function (success) {
	        _this4.readStilCompetencyReport();
	      });
	    },
	    updateStilReportUser: function updateStilReportUser(user) {
	      var userId = user.id;
	      var SSN = user.ssn;
	      var userSubjects = this.userIdsKlasseFagMap[userId] || [];
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	
	      userSubjects.forEach(function (itemFag) {
	        var klasse = report.klasser.find(function (klasse) {
	          return klasse.klasse_id === itemFag.klasse_id;
	        });
	        if (!klasse) return;
	
	        var fag = klasse.fag.find(function (fag) {
	          return fag.fag_id === itemFag.fag_id;
	        });
	        if (!fag) return;
	
	        var teacher = fag.laerere.find(function (teacher) {
	          return teacher.user_id === userId;
	        });
	        if (teacher) {
	          teacher.cpr = SSN;
	        }
	      });
	
	      this.updateStil(report);
	    }
	  },
	  mounted: function mounted() {
	    this.readStilCompetencyReport();
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('readSchoolYears', this.schoolId);
	  }
	};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      klassebetegnelse: ''
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    isFormValid: function isFormValid() {
	      return this.klassebetegnelse.length > 0;
	    }
	  },
	  methods: {
	    close: function close() {
	      this.$emit('close');
	    },
	    submit: function submit() {
	      if (!this.isFormValid) {
	        return;
	      }
	      var uniqueId = 'id_' + new Date().getTime() + '_' + Math.random().toString(36).substr(2, 9);
	      var klasse = {
	        klassebetegnelse: this.klassebetegnelse,
	        fag: [],
	        hold: '',
	        klasse_id: uniqueId,
	        klasse_type: '',
	        klassetrin: '',
	        spor: ''
	
	      };
	      this.$emit('save', klasse);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      _this.$refs.inputTitle.focus();
	    });
	  }
	};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DSelectCals = __webpack_require__(51);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    placeholder: {
	      type: String,
	      default: 'Søg og vælg kompetence'
	    },
	    show: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    itemsFiltered: function itemsFiltered() {
	      var _this = this;
	
	      if (this.itemsSelected.length > 5) {
	        return [];
	      }
	      return this.items.filter(function (item) {
	        return _this.itemsSelected.findIndex(function (itemSelected) {
	          return itemSelected.subject_code === item.subject_code;
	        }) < 0;
	      });
	    }
	  },
	  methods: {
	    update: function update(val) {
	      this.$emit('update', val);
	    }
	  }
	};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _KompetenceIndberetningDaekningUser = __webpack_require__(1298);
	
	var _KompetenceIndberetningDaekningUser2 = _interopRequireDefault(_KompetenceIndberetningDaekningUser);
	
	var _StilGuides = __webpack_require__(41);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { KompetenceIndberetningDaekningUser: _KompetenceIndberetningDaekningUser2.default, StilGuides: _StilGuides2.default },
	  props: {
	    standardSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    dbStilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    isShowSubjects: {
	      type: Boolean,
	      default: false
	    },
	    usersSSNHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    klokketimetyper: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  computed: {
	    users: function users() {
	      var _this = this;
	
	      return this.stilData.laerere.filter(function (user) {
	        return _this.usersSSNHash[user.cpr];
	      }).map(function (user) {
	        var vName = _this.usersSSNHash[user.cpr].name;
	        var vFag = _this.usersWithSubjectIdsMap[user.cpr] ? _this.usersWithSubjectIdsMap[user.cpr] : [];
	        vFag = vFag.sort(function (a, b) {
	          return a.fag_navn.localeCompare(b.fag_navn, 'da', {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	        return (0, _extends3.default)({}, user, { vName: vName, vFag: vFag });
	      });
	    },
	    usersSorted: function usersSorted() {
	      return this.users.sort(function (a, b) {
	        return a.vName.localeCompare(b.vName, 'da', {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    usersWithSubjectIdsMap: function usersWithSubjectIdsMap() {
	      var fagOnUserMap = {};
	      this.stilData.klasser.forEach(function (klasse) {
	        klasse.fag.forEach(function (fag) {
	          fag.laerere.forEach(function (learer) {
	            var vUid = klasse.klasse_id + '_' + fag.fag_id;
	            var vFag = {
	              vUid: vUid,
	              cpr: learer.cpr,
	              klassebetegnelse: klasse.klassebetegnelse,
	              klasse_id: klasse.klasse_id,
	              klasse_type: klasse.klasse_type,
	              klasse_klokketimer: fag.klokketimer,
	              fag_id: fag.fag_id,
	              fag_navn: fag.fag_navn,
	              fagkode: fag.fagkode,
	              learer_klokketimer: learer.klokketimer,
	              klokketimer_type: learer.klokketimer_type
	            };
	            if (learer.cpr) {
	              if (!fagOnUserMap[learer.cpr]) {
	                fagOnUserMap[learer.cpr] = [vFag];
	              } else {
	                fagOnUserMap[learer.cpr].push(vFag);
	              }
	            }
	          });
	        });
	      });
	      return fagOnUserMap;
	    }
	  },
	  methods: {
	    isValidNumber: function isValidNumber(input) {
	      if (isNaN(input)) {
	        return false;
	      }
	      if (input < 0) {
	        return false;
	      }
	      return true;
	    },
	    updateStilKlasseFagLaerer: function updateStilKlasseFagLaerer(user, itemFag, prop, val, target) {
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === itemFag.klasse_id;
	      });
	      var fagIdx = report.klasser[klasseIdx].fag.findIndex(function (fag) {
	        return fag.fag_id === itemFag.fag_id;
	      });
	      var teacherIdx = report.klasser[klasseIdx].fag[fagIdx]['laerere'].findIndex(function (teacher) {
	        return teacher.cpr === itemFag.cpr;
	      });
	      var oldValue = report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop];
	      if (oldValue === val) {
	        return;
	      }
	      report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop] = val;
	      if (prop === 'klokketimer' && !this.isValidNumber(val)) {
	        _eventbus2.default.toast = { text: 'Skal være et tal, 0 eller højere', success: false };
	        target.value = oldValue;
	        return;
	      }
	      this.$emit('updateStil', report);
	    }
	  }
	};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _isInteger = __webpack_require__(73);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    user: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    dbStilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    klokketimetyper: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  methods: {
	    isValidNumber: function isValidNumber(input) {
	      if (isNaN(input)) {
	        return false;
	      }
	      if (input < 0) {
	        return false;
	      }
	      return true;
	    },
	    updateStilKlasseFagLaerer: function updateStilKlasseFagLaerer(user, itemFag, prop, val, target) {
	      if (prop === 'klokketimer') {
	        if (target) {
	          target.classList.remove('d-input__small--warning');
	        }
	        if (!(0, _isInteger2.default)(Number(val))) {
	          window.alert('Klokketimer skal være et helt tal');
	          target.classList.add('d-input__small--warning');
	          return;
	        }
	      }
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === itemFag.klasse_id;
	      });
	      var fagIdx = report.klasser[klasseIdx].fag.findIndex(function (fag) {
	        return fag.fag_id === itemFag.fag_id;
	      });
	      var teacherIdx = report.klasser[klasseIdx].fag[fagIdx]['laerere'].findIndex(function (teacher) {
	        return teacher.cpr === itemFag.cpr;
	      });
	      var oldValue = report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop];
	      if (oldValue === val) {
	        return;
	      }
	      report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop] = val;
	      if (prop === 'klokketimer' && !this.isValidNumber(val)) {
	        _eventbus2.default.toast = { text: 'Skal være et tal, 0 eller højere', success: false };
	        target.value = oldValue;
	        return;
	      }
	      this.$emit('updateStil', report);
	    }
	  }
	};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _IndberetPersonale = __webpack_require__(1305);
	
	var _IndberetPersonale2 = _interopRequireDefault(_IndberetPersonale);
	
	var _IndberetFag = __webpack_require__(1304);
	
	var _IndberetFag2 = _interopRequireDefault(_IndberetFag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { IndberetFag: _IndberetFag2.default, IndberetetPersonale: _IndberetPersonale2.default, DModal: _DModal2.default },
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      isSendingToStil: false,
	      messageFromStil: ''
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    error: function error() {
	      return this.stilData['error'] ? this.stilData['error'] : false;
	    },
	    klasser: function klasser() {
	      return this.stilData['klasser'] ? this.stilData['klasser'] : [];
	    },
	    klasserUdenFag: function klasserUdenFag() {
	      return this.klasser.filter(function (klasse) {
	        return klasse.fag.length === 0;
	      });
	    }
	  },
	  methods: {
	    confirmDeleteGrade: function confirmDeleteGrade(grade) {
	      var klasseId = grade.klasse_id;
	      var report = JSON.parse((0, _stringify2.default)(this.stilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === klasseId;
	      });
	      if (klasseIdx < 0) {
	        return;
	      }
	      report.klasser.splice(klasseIdx, 1);
	      this.$emit('updateStil', report);
	    },
	    submit: function submit() {
	      var _this = this;
	
	      this.isSendingToStil = true;
	      this.messageFromStil = '';
	      _docendo2.default.submitStilCompetencyReport(this.schoolId, function (success) {
	        _this.messageFromStil = success;
	        _this.isSendingToStil = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	        _this.isSendingToStil = false;
	      });
	    }
	  }
	};

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(73);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _KompetenceIndberetningKlasserDSelect = __webpack_require__(1301);
	
	var _KompetenceIndberetningKlasserDSelect2 = _interopRequireDefault(_KompetenceIndberetningKlasserDSelect);
	
	var _KompetenceIndberetningKlasserFagForm = __webpack_require__(1302);
	
	var _KompetenceIndberetningKlasserFagForm2 = _interopRequireDefault(_KompetenceIndberetningKlasserFagForm);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _StilGuides = __webpack_require__(41);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _KompetenceIndberetningCreateKlasseModal = __webpack_require__(1296);
	
	var _KompetenceIndberetningCreateKlasseModal2 = _interopRequireDefault(_KompetenceIndberetningCreateKlasseModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    KompetenceIndberetningCreateKlasseModal: _KompetenceIndberetningCreateKlasseModal2.default,
	    ModalConfirmation: _ModalConfirmation2.default, KompetenceIndberetningKlasserFagForm: _KompetenceIndberetningKlasserFagForm2.default, DSelect: _KompetenceIndberetningKlasserDSelect2.default, DModal: _DModal2.default, StilGuides: _StilGuides2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    standardSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    dbStilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    },
	    isShowSubjects: {
	      type: Boolean,
	      default: false
	    },
	    usersSSNHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      isModalCreateGrade: false,
	      theEditTeacher: null,
	      klassetrin: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
	      theCreateSubject: null,
	      theDeleteSubject: null,
	      klasseTyper: {
	        40: 'Normalklasser - fuldt årgangsdelte',
	        41: 'Normalklasser - Ikke fuldt årgangsdelte',
	        45: 'EUD10',
	        46: '20/20',
	        50: 'Specialklasser',
	        55: 'Klasser for ældre tosprogede elever'
	      },
	      formErrors: {},
	      theDeleteGrade: null
	    };
	  },
	
	  computed: {
	    videoGuideId: function videoGuideId() {
	      return !this.isShowSubjects ? '5Id4TeuHMvI?start=122' : '5Id4TeuHMvI?start=139';
	    },
	    videoGuideText: function videoGuideText() {
	      return !this.isShowSubjects ? 'Guide: Se videoguide til udfyldning af klasser' : 'Guide: Se videoguide til udfyldning af fag';
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    klasser: function klasser() {
	      if (!this.stilData['klasser']) {
	        return [];
	      }
	      return this.stilData['klasser'];
	    },
	    klasserMedProps: function klasserMedProps() {
	      var _this = this;
	
	      var klasser = this.klasser.map(function (klasse) {
	        klasse.fag.forEach(function (fag) {
	          _this.$set(fag, 'v_klasse_name', klasse.klassebetegnelse);
	          var isTheEditTeacher = _this.theEditTeacher === fag.fag_id;
	          _this.$set(fag, 'v_is_the_edit_teacher', isTheEditTeacher);
	          fag.laerere.forEach(function (laerer) {
	            var teacherName = laerer.user_name + ' (Mangler CPR)';
	            var user = _this.usersSSNHash[laerer.cpr];
	            if (user) {
	              teacherName = _this.usersSSNHash[laerer.cpr].name;
	              _this.$delete(laerer, 'v_no_cpr');
	            } else {
	              _this.$set(laerer, 'v_no_cpr', true);
	            }
	            _this.$set(laerer, 'v_name', teacherName);
	          });
	        });
	        klasse.fag = klasse.fag.sort(function (a, b) {
	          return a.fag_navn.localeCompare(b.fag_navn, 'da', {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        });
	        return klasse;
	      });
	      return klasser.sort(function (a, b) {
	        return a.klassebetegnelse.localeCompare(b.klassebetegnelse, 'da', {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    standardSubjectsHash: function standardSubjectsHash() {
	      return this.$helpers.hashMap(this.standardSubjects, 'fagkode');
	    }
	  },
	  methods: {
	    saveNewGrade: function saveNewGrade(newKlasse) {
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      report.klasser.push(newKlasse);
	      this.$emit('updateStil', report);
	      this.setIsModalCreateGrade(false);
	    },
	    setIsModalCreateGrade: function setIsModalCreateGrade(bool) {
	      if (bool) {
	        this.isModalCreateGrade = bool;
	        return;
	      }
	      if (this.isModalCreateGrade) {
	        this.isModalCreateGrade = false;
	      } else {
	        this.isModalCreateGrade = true;
	      }
	    },
	    closeModalConfirm: function closeModalConfirm() {
	      this.theDeleteSubject = null;
	      this.theDeleteGrade = null;
	    },
	    setTheDeleteGrade: function setTheDeleteGrade(klasse) {
	      this.theDeleteGrade = klasse;
	    },
	    setTheDeleteSubject: function setTheDeleteSubject(klasse, fag) {
	      this.theDeleteSubject = { klasse: klasse, fag: fag };
	    },
	    confirmDeleteGrade: function confirmDeleteGrade() {
	      var klasseId = this.theDeleteGrade.klasse_id;
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === klasseId;
	      });
	      if (klasseIdx < 0) {
	        return;
	      }
	      report.klasser.splice(klasseIdx, 1);
	      this.$emit('updateStil', report);
	      this.theDeleteGrade = null;
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.theDeleteGrade) {
	        this.confirmDeleteGrade();
	        return;
	      }
	      var klasseId = this.theDeleteSubject.klasse.klasse_id;
	      var fagId = this.theDeleteSubject.fag.fag_id;
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === klasseId;
	      });
	      var fagIdx = report.klasser[klasseIdx].fag.findIndex(function (fag) {
	        return fag.fag_id === fagId;
	      });
	      if (klasseIdx < 0 || fagIdx < 0) {
	        return;
	      }
	      report.klasser[klasseIdx].fag.splice(fagIdx, 1);
	      this.$emit('updateStil', report);
	      this.theDeleteSubject = null;
	    },
	    updateStilKlasse: function updateStilKlasse(itemKlasse, prop, val) {
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var idx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === itemKlasse.klasse_id;
	      });
	      if (idx > -1) {
	        if (report.klasser[idx][prop] === val) {
	          return;
	        }
	        report.klasser[idx][prop] = val;
	      }
	      this.$emit('updateStil', report);
	    },
	    isValidNumber: function isValidNumber(input) {
	      if (isNaN(input)) {
	        return false;
	      }
	      if (input < 0) {
	        return false;
	      }
	      return true;
	    },
	    updateStilKlasseFag: function updateStilKlasseFag(itemKlasse, itemFag, prop, val, target) {
	      if (prop === 'klokketimer') {
	        if (target) {
	          target.classList.remove('d-input__small--warning');
	        }
	        if (!(0, _isInteger2.default)(Number(val))) {
	          window.alert('Klassetimer skal være et helt tal');
	          target.classList.add('d-input__small--warning');
	          return;
	        }
	      }
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === itemKlasse.klasse_id;
	      });
	      var fagIdx = report.klasser[klasseIdx].fag.findIndex(function (fag) {
	        return fag.fag_id === itemFag.fag_id;
	      });
	
	      if (prop === 'laerere') {
	        var currentUsers = report.klasser[klasseIdx]['fag'][fagIdx][prop];
	        var hours = report.klasser[klasseIdx]['fag'][fagIdx]['klokketimer'];
	        val = val.map(function (user) {
	          var userIdx = currentUsers.findIndex(function (currentUser) {
	            return currentUser.cpr === user.ssn;
	          });
	          if (userIdx > -1 && currentUsers[userIdx]['klokketimer']) {
	            hours = currentUsers[userIdx]['klokketimer'];
	          }
	          return {
	            cpr: user.ssn,
	            klokketimer: hours,
	            klokketimer_type: '1',
	            user_id: user.id,
	            user_name: user.name
	          };
	        });
	      }
	
	      if (prop === 'klokketimer' && !this.isValidNumber(val)) {
	        target.value = report.klasser[klasseIdx]['fag'][fagIdx][prop];
	        _eventbus2.default.toast = { text: 'Skal være 0 eller større', success: false };
	        return;
	      }
	      if (fagIdx > -1 || klasseIdx > -1) {
	        if (report.klasser[klasseIdx]['fag'][fagIdx][prop] === val) {
	          return;
	        }
	        report.klasser[klasseIdx]['fag'][fagIdx][prop] = val;
	      }
	      this.$emit('updateStil', report);
	    },
	    saveNewSubject: function saveNewSubject(newSubject) {
	      var report = JSON.parse((0, _stringify2.default)(this.dbStilData));
	      var klasseIdx = report.klasser.findIndex(function (klasse) {
	        return klasse.klasse_id === newSubject.klasse_id;
	      });
	      report.klasser[klasseIdx].fag.push(newSubject);
	      this.$emit('updateStil', report);
	    },
	    setTheEditSubject: function setTheEditSubject(subject) {
	      this.theEditSubject = subject;
	    },
	    close: function close() {
	      this.theEditSubject = null;
	    }
	  }
	};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DSelectCals = __webpack_require__(51);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelectCals2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    usersSSNHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  computed: {
	    itemsFiltered: function itemsFiltered() {
	      var _this = this;
	
	      return this.items.filter(function (user) {
	        return _this.usersSSNHash[user.ssn];
	      });
	    },
	    itemsSelectedFormatted: function itemsSelectedFormatted() {
	      var _this2 = this;
	
	      var usersNotOnSchool = this.itemsSelected.filter(function (user) {
	        return !_this2.usersSSNHash[user.cpr];
	      }).map(function (user) {
	        return {
	          id: user.user_id,
	          name: user.user_name
	        };
	      });
	      var users = this.itemsSelected.filter(function (user) {
	        return _this2.usersSSNHash[user.cpr];
	      }).map(function (user) {
	        return _this2.usersSSNHash[user.cpr];
	      });
	      return usersNotOnSchool.concat(users);
	    }
	  },
	  methods: {
	    update: function update(val) {
	      this.$emit('update', val);
	    }
	  }
	};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default, DModal: _DModal2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    standardSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    theCreateSubject: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      title: '',
	      fagkode: 110,
	      klokketimer: 220
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    isFormValid: function isFormValid() {
	      return this.title.length > 0 && this.isValidNumber(this.klokketimer);
	    }
	  },
	  methods: {
	    isValidNumber: function isValidNumber(input) {
	      if (input.length < 1) {
	        return false;
	      }
	      if (isNaN(input)) {
	        return false;
	      }
	      if (input < 0) {
	        return false;
	      }
	      return true;
	    },
	    close: function close() {
	      this.$emit('close');
	    },
	    submit: function submit() {
	      var fag = {
	        klasse_id: this.theCreateSubject.klasse_id,
	        fag_id: new Date().valueOf(),
	        fag_navn: this.title,
	        fagkode: this.fagkode,
	        klokketimer: this.klokketimer,
	        laerere: []
	      };
	      this.$emit('save', fag);
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      _this.$refs.inputTitle.focus();
	    });
	  }
	};

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _StilGuides = __webpack_require__(41);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _KompetenceIndberetningDSelect = __webpack_require__(319);
	
	var _KompetenceIndberetningDSelect2 = _interopRequireDefault(_KompetenceIndberetningDSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _KompetenceIndberetningDSelect2.default, StilGuides: _StilGuides2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    standardSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      theSelectMonth: null,
	      activeUserFilter: 0,
	      standardSubjectsWithVProps: [],
	      levelMap: {
	        L: 'Linjefag',
	        K: 'Tilsvarende kompetencer'
	      },
	      theEditUserId: null,
	      sortProperty: 'name',
	      sortOrder: 'asc' };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersWithVProps: function usersWithVProps() {
	      var _this = this;
	
	      return this.users.map(function (user) {
	        var competencies = [];
	        if (!user.competencies) {
	          console.log('user', user, user.competencies);
	        }
	        user.competencies.forEach(function (subject) {
	          var id = subject.subject_code + '_' + subject.level;
	          var idx = _this.standardSubjectsWithVProps.findIndex(function (subjectWithVProps) {
	            return subjectWithVProps.id === id;
	          });
	          var obj = {
	            id: subject.subject_code + '_' + subject.level,
	            subject_code: subject.subject_code,
	            level: subject.level,
	            name: _this.standardSubjectsWithVProps[idx].name
	          };
	          competencies.push(obj);
	        });
	        var vSsn = user.ssn && user.ssn.length > 6 ? user.ssn : '';
	        var isTheEditUser = _this.theEditUserId === user.id;
	        var stilStilling = null;
	        if (user.custom_data && user.custom_data['schools'] && user.custom_data['schools'][_this.schoolId] && user.custom_data['schools'][_this.schoolId]['stilling']) {
	          stilStilling = user.custom_data['schools'][_this.schoolId]['stilling'];
	        }
	        _this.$set(user, 'v_stil_stilling', stilStilling);
	        _this.$set(user, 'v_ssn', vSsn);
	        _this.$set(user, 'v_competencies', competencies);
	        _this.$set(user, 'v_isTheEditUser', isTheEditUser);
	        return user;
	      });
	    },
	    unfilledUsers: function unfilledUsers() {
	      return this.usersWithVProps.filter(function (user) {
	        return user.v_stil_stilling === 'undtaget';
	      });
	    },
	    filledUsers: function filledUsers() {
	      return this.usersWithVProps.filter(function (user) {
	        return user.v_stil_stilling !== 'undtaget';
	      });
	    },
	    filteredUsersWithVProps: function filteredUsersWithVProps() {
	      if (this.activeUserFilter === 0) {
	        return this.filledUsers;
	      } else {
	        return this.unfilledUsers;
	      }
	    },
	    sortedUsers: function sortedUsers() {
	      var _this2 = this;
	
	      var arrCopy = [].concat((0, _toConsumableArray3.default)(this.filteredUsersWithVProps));
	      var sortOrder = this.sortOrder === 'asc' ? 1 : -1;
	      return arrCopy.sort(function (a, b) {
	        var propA = a[_this2.sortProperty];
	        var propB = b[_this2.sortProperty];
	        if (propA === null || propA === undefined) {
	          return 1 * sortOrder;
	        }
	        if (propB === null || propB === undefined) {
	          return -1 * sortOrder;
	        }
	        var propAUppercase = propA.toUpperCase();
	        var propBUppercase = propB.toUpperCase();
	        if (propAUppercase < propBUppercase) {
	          return -1 * sortOrder;
	        }
	        if (propAUppercase > propBUppercase) {
	          return 1 * sortOrder;
	        }
	        return 0;
	      }).concat(arrCopy.filter(function (item) {
	        return item[_this2.sortProperty] === null || item[_this2.sortProperty] === undefined;
	      }));
	    }
	  },
	  methods: {
	    setSortProperty: function setSortProperty(property) {
	      if (this.sortProperty === property) {
	        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortOrder = 'asc';
	      }
	      this.sortProperty = property;
	    },
	    validateCPR: function validateCPR(vSsn) {
	      var ssn = vSsn.replace(/[^0-9]/ig, '');
	      return ssn.length === 10;
	    },
	    updateSubjectOnUser: function updateSubjectOnUser(subjects, user) {
	      var _this3 = this;
	
	      var subjectForServer = [];
	      subjects.forEach(function (subject) {
	        var obj = {
	          subject_code: subject.subject_code,
	          level: subject.level
	        };
	        subjectForServer.push(obj);
	      });
	      _docendo2.default.updateUserCompetencies(this.schoolId, user.id, subjectForServer, function (success) {
	        var userCompetencies = success.filter(function (subject) {
	          return subject.user_id === user.id;
	        });
	        var data = {
	          prop: 'competencies',
	          userId: user.id,
	          competencies: userCompetencies
	        };
	        _eventbus2.default.toast = { text: 'Linjefag er opdateret', success: true };
	        _this3.$store.commit('updatePropOnSchoolUser', data);
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    updateUser: function updateUser(user, change, val, forceUpdate) {
	      var _this4 = this;
	
	      var customData = user.custom_data;
	      var errors = false;
	      var changes = {};
	      changes[change] = val;
	      if (change === 'stil_stilling') {
	        if (!customData['schools']) {
	          customData.schools = (0, _defineProperty3.default)({}, this.schoolId, { 'stilling': val });
	        }
	        if (customData['schools'] && !customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId] = { 'stilling': val };
	        }
	        if (customData['schools'] && customData['schools'][this.schoolId]) {
	          customData['schools'][this.schoolId]['stilling'] = val;
	        }
	        changes['custom_data'] = customData;
	      }
	      if (change === 'ssn') {
	        val = val.replace(/[^0-9]/ig, '');
	        if (!forceUpdate && (val === user.ssn || val.length === 0)) {
	          var originalSSN = JSON.parse((0, _stringify2.default)(user.ssn));
	          user.ssn = null;
	          user.ssn = originalSSN;
	          return;
	        }
	        if (!this.validateCPR(val)) {
	          _eventbus2.default.toast = { text: 'Ugyldigt cpr nummer', success: false };
	          errors = true;
	          var _originalSSN = JSON.parse((0, _stringify2.default)(user.ssn));
	          user.ssn = null;
	          user.ssn = _originalSSN;
	        }
	        changes[change] = val;
	      }
	      if (errors) {
	        return;
	      }
	      _docendo2.default.updateUsers(this.schoolId, user.id, changes, function (success) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(changes)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var key = _step.value;
	
	            var data = (0, _defineProperty3.default)({
	              prop: key,
	              userId: user.id
	            }, key, success[key]);
	            _this4.$store.commit('updatePropOnSchoolUser', data);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (change === 'ssn') {
	          _this4.updateStilReportUser(user);
	        } else {
	          _eventbus2.default.toast = { text: 'Opdateret', success: true };
	        }
	      }, function (failure) {
	        if (change === 'ssn') {
	          var _originalSSN2 = JSON.parse((0, _stringify2.default)(user.ssn));
	          user.ssn = null;
	          user.ssn = _originalSSN2;
	          _eventbus2.default.toast = { text: 'CPR er allerede brugt', success: false };
	        }
	      });
	    },
	    updateStilReportUser: function updateStilReportUser(user) {
	      this.$emit('updateStilReportUser', user);
	    },
	    createStandardSubjectsWithVProps: function createStandardSubjectsWithVProps() {
	      var _this5 = this;
	
	      var sortedSubjects = this.standardSubjects.sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	      sortedSubjects.forEach(function (subject) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(_this5.levelMap)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var key = _step2.value;
	
	            var obj = {};
	            obj.level = key;
	            obj.name = subject.name + ' (' + key + ')';
	            obj.id = subject.subject_code + '_' + key;
	            obj.user_id = subject.subject_code + '_' + key;
	            obj.subject_code = subject.subject_code;
	            _this5.standardSubjectsWithVProps.push(obj);
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.createStandardSubjectsWithVProps();
	  }
	};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(73);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      stillinger: {
	        LA: 'Lærere',
	        BH: 'Børnehaveklasseledere',
	        PA: 'Pædagoger',
	        LE: 'Ledere',
	        AN: 'Andre med undervisningsopgaver',
	        KO: 'Konsulenter'
	      }
	    };
	  },
	
	  computed: {
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    klasser: function klasser() {
	      var klasser = this.stilData['klasser'] ? this.stilData['klasser'] : [];
	      return klasser.sort(function (a, b) {
	        return a.klassebetegnelse.localeCompare(b.klassebetegnelse, 'da', {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    fag: function fag() {
	      var fagArr = [];
	      this.klasser.forEach(function (klasse) {
	        klasse.fag.forEach(function (fag) {
	          var obj = (0, _extends3.default)({
	            klasse: klasse.klassebetegnelse,
	            klassetrin: klasse.klassetrin
	          }, fag);
	          fagArr.push(obj);
	        });
	      });
	      return fagArr;
	    },
	    fagUdenKorrekteOplysninger: function fagUdenKorrekteOplysninger() {
	      var fagMedManglendeOplysninger = [];
	
	      this.fag.forEach(function (fag) {
	        var klassename = fag.klasse ? fag.klasse : 'Klassen';
	        var errors = [];
	
	        if (!fag.klasse) {
	          errors.push(klassename + ' mangler klassebetegnelse');
	        }
	        if (!fag.klassetrin) {
	          errors.push(klassename + ' mangler klassetrin');
	        }
	        if (!fag.fagkode || String(fag.fagkode).trim() === '') {
	          errors.push('Fag mangler fagkode');
	        }
	        if (!fag.klokketimer) {
	          errors.push('Fag mangler klokketimer');
	        } else {
	          var klokketimerNum = Number(fag.klokketimer);
	          if (isNaN(klokketimerNum)) {
	            errors.push('Klokketimer skal være et tal');
	          } else if (!(0, _isInteger2.default)(klokketimerNum)) {
	            errors.push('Klokketimer skal være et helt tal');
	          }
	        }
	
	        if (!Array.isArray(fag.laerere) || fag.laerere.length === 0) {
	          errors.push('Fag mangler lærer');
	        } else {
	          fag.laerere.forEach(function (laerer) {
	            var username = laerer.user_name ? laerer.user_name : 'En lærer';
	
	            if (!laerer.cpr) {
	              errors.push(username + ' mangler cpr');
	            }
	
	            if (!laerer.klokketimer) {
	              errors.push(username + ' mangler klokketimer');
	            } else {
	              var laererKlokketimerNum = Number(laerer.klokketimer);
	              if (isNaN(laererKlokketimerNum)) {
	                errors.push(username + 's klokketimer skal være et tal');
	              } else if (!(0, _isInteger2.default)(laererKlokketimerNum)) {
	                errors.push(username + 's klokketimer skal være et helt tal');
	              }
	            }
	          });
	        }
	
	        if (errors.length > 0) {
	          var newFag = (0, _extends3.default)({}, fag, {
	            errors: errors
	          });
	          fagMedManglendeOplysninger.push(newFag);
	        }
	      });
	
	      return fagMedManglendeOplysninger;
	    },
	    laerere: function laerere() {
	      return this.stilData['laerere'] ? this.stilData['laerere'] : [];
	    },
	    personaleUdenKorrekteOplysninger: function personaleUdenKorrekteOplysninger() {
	      var _this = this;
	
	      var users = this.laerere.filter(function (laerer) {
	        return laerer.stilling !== 'undtaget' && (!laerer.cpr || !laerer.stilling);
	      });
	      var usersWithProps = users.map(function (user) {
	        var name = _this.allUsersInHash[user.user_id] ? _this.allUsersInHash[user.user_id].name : user.user_id;
	        return (0, _extends3.default)({}, user, {
	          name: name
	        });
	      });
	      return this.$helpers.sortArrOnName(usersWithProps);
	    }
	  }
	};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    stilData: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      stillinger: {
	        LA: 'Lærere',
	        BH: 'Børnehaveklasseledere',
	        PA: 'Pædagoger',
	        LE: 'Ledere',
	        AN: 'Andre med undervisningsopgaver',
	        KO: 'Konsulenter'
	      }
	    };
	  },
	
	  computed: {
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    laerere: function laerere() {
	      return this.stilData['laerere'] ? this.stilData['laerere'] : [];
	    },
	    personaleUdenKorrekteOplysninger: function personaleUdenKorrekteOplysninger() {
	      var _this = this;
	
	      var users = this.laerere.filter(function (laerer) {
	        return laerer.stilling !== 'undtaget' && (!laerer.cpr || !laerer.stilling);
	      });
	      var usersWithProps = users.map(function (user) {
	        var name = _this.allUsersInHash[user.user_id] ? _this.allUsersInHash[user.user_id].name : user.user_id;
	        return (0, _extends3.default)({}, user, {
	          name: name
	        });
	      });
	      return this.$helpers.sortArrOnName(usersWithProps);
	    },
	    groupedLaerere: function groupedLaerere() {
	      var _this2 = this;
	
	      var result = {};
	
	      var _loop = function _loop(stilling) {
	        var jobTitle = _this2.stillinger[stilling];
	        var learereWithJobTitle = _this2.laerere.filter(function (lærer) {
	          return lærer.stilling === stilling;
	        });
	        result[jobTitle] = learereWithJobTitle;
	      };
	
	      for (var stilling in this.stillinger) {
	        _loop(stilling);
	      }
	      return result;
	    },
	    groupedLaerereProps: function groupedLaerereProps() {
	      var result = {};
	      for (var jobTitle in this.groupedLaerere) {
	        var laerere = this.groupedLaerere[jobTitle];
	        var laerereWithFag = laerere.filter(function (laerer) {
	          return laerer.fag.length > 0;
	        });
	        var laerereWithoutFag = laerere.filter(function (laerer) {
	          return laerer.fag.length === 0;
	        });
	        result[jobTitle] = [laerereWithFag, laerereWithoutFag];
	      }
	      return result;
	    }
	  }
	};

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    personaleskema: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      userTypesInHash: {
	        'LA': 'Lærere',
	        'BH': 'Børnehaveklasseledere',
	        'PA': 'Pædagoger',
	        'LE': 'Ledere',
	        'AN': 'Andre med undervisningsopgaver'
	      },
	      userTypes: [{ value: 'LA', title: 'Lærere' }, { value: 'BH', title: 'Børnehaveklasseledere' }, { value: 'PA', title: 'Pædagoger' }, { value: 'LE', title: 'Ledere' }, { value: 'AN', title: 'Andre med undervisningsopgaver' }]
	    };
	  },
	
	  computed: {
	    personale: function personale() {
	      var _this = this;
	
	      return this.userTypes.map(function (usertype) {
	        var obj = {
	          title: usertype.title,
	          male: _this.getMalesFromTitle(usertype.title)
	        };
	        return obj;
	      });
	    }
	  },
	  methods: {
	    getMalesFromTitle: function getMalesFromTitle(title) {
	      this.userTypes;
	    }
	  }
	};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    textForLink: {
	      default: 'Guide: Se videoguide Her'
	    },
	    videoId: {
	      default: 'etaeiteazYM'
	    },
	    isButton: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isShowGuide: false,
	      playerVars: {
	        autoplay: 1,
	        resize: true,
	        fitParent: true
	      }
	    };
	  },
	
	  computed: {
	    videoLink: function videoLink() {
	      return 'https://www.youtube.com/embed/' + this.videoId;
	    }
	  },
	  methods: {
	    playing: function playing() {
	      console.log('playing');
	    }
	  }
	};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    userId: {
	      default: null
	    },
	    schoolYear: {},
	    startDate: {},
	    endDate: {}
	  },
	  data: function data() {
	    return {
	      tasks: [],
	      isLoading: true,
	      tildeltArbejdstid: 0,
	      tildeltUndervisning: 0
	    };
	  },
	
	  computed: {
	    tildeltUndervisningUdenUUV: function tildeltUndervisningUdenUUV() {
	      return (this.tildeltUndervisning * 1 - this.tasksInTypes[1].sum * 1).toFixed(1);
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    tasksInTypes: function tasksInTypes() {
	      var tasks = [{ id: 'teaching', title: 'Fag', events: [], sum: 0 }, { id: 'supplemental', title: 'UUV', events: [], sum: 0 }];
	      this.tasks.forEach(function (task) {
	        if (task.master_type === 'teaching' && task.subject_type !== 'supplemental') {
	          tasks[0].events.push(task);
	          tasks[0].sum += task.hours * 1;
	        }
	        if (task.subject_type === 'supplemental') {
	          tasks[1].events.push(task);
	          tasks[1].sum += task.hours * 1;
	        }
	      });
	      tasks[0].sum = tasks[0].sum.toFixed(1);
	      tasks[1].sum = tasks[1].sum.toFixed(1);
	      return tasks;
	    }
	  },
	  methods: {
	    readUserTasks: function readUserTasks() {
	      var _this = this;
	
	      this.isLoading = true;
	      _docendo2.default.userTasks(this.userId, this.startDate, this.endDate, function (success) {
	        _this.isLoading = false;
	        _this.tasks = success;
	      }, function (failure) {
	        console.log(failure);
	      });
	      _docendo2.default.schoolAssignedHours(this.schoolId, this.schoolYear.name, [this.userId], function (data) {
	        if (data && data.length === 1 && data[0]['assigned_total_hours']) {
	          _this.tildeltArbejdstid = data[0]['assigned_total_hours'];
	          _this.tildeltUndervisning = data[0]['assigned_teaching_hours'] ? data[0]['assigned_teaching_hours'] : 0;
	        }
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readUserTasks();
	  }
	};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _GrundskoleIndberetningTimetal = __webpack_require__(118);
	
	var _GrundskoleIndberetningTimetal2 = _interopRequireDefault(_GrundskoleIndberetningTimetal);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _StilGuides = __webpack_require__(41);
	
	var _StilGuides2 = _interopRequireDefault(_StilGuides);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _GrundskoleIndberetningResume = __webpack_require__(318);
	
	var _GrundskoleIndberetningResume2 = _interopRequireDefault(_GrundskoleIndberetningResume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    GrundskoleIndberetningResume: _GrundskoleIndberetningResume2.default,
	    StilGuides: _StilGuides2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    Loader: _Loader2.default,
	    GrundskoleIndberetningTimetal: _GrundskoleIndberetningTimetal2.default
	  },
	  data: function data() {
	    return {
	      isSendingToStil: false,
	      stilData: [],
	      isLoadingStilData: false,
	      userEmailInput: '',
	      userEmailFormErrors: {},
	      isSavingUserEmail: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    userHasNoEmail: function userHasNoEmail() {
	      return this.user && this.user.email === null;
	    },
	    isSaveButtonForUserEmailDisabled: function isSaveButtonForUserEmailDisabled() {
	      return this.userEmailInput.length < 3;
	    }
	  },
	  watch: {
	    user: function user() {
	      var _this = this;
	
	      if (this.userHasNoEmail) {
	        setTimeout(function () {
	          var el = _this.$refs.user_email_input;
	          if (el) {
	            _this.$refs.user_email_input.focus();
	          }
	        }, 0);
	        return;
	      }
	      this.isLoadingStilData = true;
	      _docendo2.default.showStilReport(this.schoolId, function (success) {
	        _this.isLoadingStilData = false;
	        _this.stilData = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  methods: {
	    submit: function submit() {
	      var _this2 = this;
	
	      this.isSendingToStil = true;
	      _docendo2.default.submitStilReport(this.schoolId, function (success) {
	        _this2.isSendingToStil = false;
	        _eventbus2.default.toast = { text: 'Grundskoleindberetning er sendt til STIL', 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', 'success': false };
	      });
	    },
	    setTolaerer: function setTolaerer(obj) {
	      var _this3 = this;
	
	      var setting = obj.godkendelseskode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin;
	      });
	      stilData['undervisningskema'][idx]['godkendelseskode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this3.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    setForanstaltning: function setForanstaltning(obj) {
	      var _this4 = this;
	
	      var setting = obj.godkendelseskode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin;
	      });
	      stilData['undervisningskema'][idx]['godkendelseskode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this4.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updatePraktik: function updatePraktik(obj) {
	      var _this5 = this;
	
	      var setting = obj.praktikkode === 'J' ? 'N' : 'J';
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.v_fag._type;
	      });
	      stilData['undervisningskema'][idx]['praktikkode'] = setting;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this5.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateKonfirmation: function updateKonfirmation(obj) {
	      var _this6 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.v_fag._type;
	      });
	      if (stilData['undervisningskema'][idx]['klassetrin'] === obj.value) {
	        stilData['undervisningskema'][idx]['klassetrin'] = null;
	      } else {
	        stilData['undervisningskema'][idx]['klassetrin'] = obj.value;
	      }
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this6.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateSubject: function updateSubject(obj) {
	      var _this7 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	        return stilTing._type === obj.originalObject._type && stilTing.klassetype === obj.originalObject.klassetype && stilTing.fagkode === obj.originalObject.fagkode && stilTing.klassetrin === obj.originalObject.klassetrin;
	      });
	      stilData['undervisningskema'][idx][obj.toUpdate] = obj.value * 1;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this7.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    nulstilKlasse: function nulstilKlasse(grade) {
	      var _this8 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var subjects = stilData['undervisningskema'].filter(function (subject) {
	        return subject._type === 'undervisningstid' && subject.klassetrin === grade.value * 1;
	      });
	      subjects.forEach(function (subject) {
	        var idx = stilData['undervisningskema'].findIndex(function (stilTing) {
	          return stilTing._type === subject._type && stilTing.klassetype === subject.klassetype && stilTing.fagkode === subject.fagkode && stilTing.klassetrin === subject.klassetrin;
	        });
	        stilData['undervisningskema'][idx]['klokketimer'] = 0;
	        _docendo2.default.updateStilReport(_this8.schoolId, stilData, function (success) {
	          _this8.stilData = success;
	        }, function (failure) {
	          console.log('failure', failure);
	        });
	      });
	    },
	    update: function update(obj) {
	      var _this9 = this;
	
	      var stilData = JSON.parse((0, _stringify2.default)(this.stilData));
	      var idx = stilData[obj.type].findIndex(function (elevtal) {
	        return elevtal._type === obj.cell._type && elevtal.elevtaltype === obj.cell.elevtaltype && elevtal.klassetrin === obj.cell.klassetrin;
	      });
	      stilData[obj.type][idx]['antal'] = obj.num * 1;
	      _docendo2.default.updateStilReport(this.schoolId, stilData, function (success) {
	        _this9.stilData = success;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    submitUserEmail: function submitUserEmail() {
	      var _this10 = this;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.userEmailFormErrors).length > 0) {
	        return;
	      }
	      this.isSavingUserEmail = true;
	      var changes = { email: this.userEmailInput };
	      _docendo2.default.updateUser(changes, function (success) {
	        _eventbus2.default.toast = { text: 'Emailen er gemt', 'success': true };
	        var obj = {
	          prop: 'email',
	          email: success.email
	        };
	        _this10.$store.commit('updateUserProp', obj);
	        _this10.isSavingUserEmail = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Email er allerede brugt', 'success': false };
	        _this10.isSavingUserEmail = false;
	      });
	    },
	    formValidation: function formValidation() {
	      this.userEmailFormErrors = {};
	      if (!this.validateEmail(this.userEmailInput)) {
	        this.$set(this.userEmailFormErrors, 'email', 'Er ikke en gyldig email');
	      }
	    },
	    validateEmail: function validateEmail(email) {
	      var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
	      return email.trim() !== '' && emailRegex.test(email);
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.userEmailFormErrors, title);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('readSchoolYears', this.schoolId);
	  }
	};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    editsms: {
	      type: Object
	    },
	    messageType: {
	      default: 'sms'
	    }
	  },
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      _docendo2.default.deleteMessageTemplate(window.SCHOOL.id, this.editsms.id, function (success) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.sms.template_sms_deleted'), success: true };
	        _this.$emit('updated');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.sms.an_error_occured'), success: false };
	        _this.$emit('close');
	      });
	    }
	  }
	};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _autosize = __webpack_require__(361);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    editsms: {
	      type: Object
	    },
	    messageType: {
	      default: 'sms'
	    }
	  },
	  data: function data() {
	    return {
	      title: '',
	      body: '',
	      errors: {}
	    };
	  },
	
	  computed: {
	    today: function today() {
	      _moment2.default.locale(window.USER.language);
	      return (0, _moment2.default)().format('dddd');
	    }
	  },
	  methods: {
	    insertToday: function insertToday() {
	      this.body = this.body + '[today]';
	      this.$refs.smsbodyinput.focus();
	    },
	    validation: function validation() {
	      if (this.title.length < 1) {
	        this.$set(this.errors, 'title', this.$t('vue2.common.must_be_filled'));
	      }
	      if (this.body.length < 1) {
	        this.$set(this.errors, 'body', this.$t('vue2.common.must_be_filled'));
	      }
	    },
	    resetValidation: function resetValidation(type) {
	      this.$delete(this.errors, type);
	    },
	    updateTemplate: function updateTemplate() {
	      var _this = this;
	
	      this.validation();
	      if (this.errors.length > 0) {
	        return;
	      }
	      _docendo2.default.updateMessageTemplate(window.SCHOOL.id, this.editsms.id, this.title, this.body, this.editsms.message_type, function (success) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.sms.updated_sms_template'), success: true };
	        _this.$emit('updated');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.sms.an_error_occured'), success: false };
	      });
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      this.validation();
	      if (this.errors.length > 0) {
	        return;
	      }
	      var messageType = this.messageType === 'sms' ? 'sms' : 'email';
	      _docendo2.default.createMessageTemplate(window.SCHOOL.id, this.title, this.body, messageType, function (success) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.sms.created_sms_template'), success: true };
	        _this2.$emit('updated');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.editsms) {
	      this.title = this.editsms.title;
	      this.body = this.editsms.body;
	    }
	  },
	  mounted: function mounted() {
	    (0, _autosize2.default)(document.querySelectorAll('textarea'));
	    this.$refs.titleInput.focus();
	  }
	};

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _SmsAddNumber = __webpack_require__(119);
	
	var _SmsAddNumber2 = _interopRequireDefault(_SmsAddNumber);
	
	var _MessageTemplate = __webpack_require__(321);
	
	var _MessageTemplate2 = _interopRequireDefault(_MessageTemplate);
	
	var _MedssageTemplateDelete = __webpack_require__(320);
	
	var _MedssageTemplateDelete2 = _interopRequireDefault(_MedssageTemplateDelete);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SendMessagesUserSetting = __webpack_require__(322);
	
	var _SendMessagesUserSetting2 = _interopRequireDefault(_SendMessagesUserSetting);
	
	var _Loader3 = __webpack_require__(4);
	
	var _Loader4 = _interopRequireDefault(_Loader3);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DoFilters = __webpack_require__(115);
	
	var _DoFilters2 = _interopRequireDefault(_DoFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    send_message: 'Send besked',
	    recipient: 'Modtager',
	    a_recipient: 'Vælg en modtager',
	    subject: 'Emnefelt',
	    message: 'Besked',
	    message_must_be_filled: 'Besked skal udfyldes',
	    sending_message: 'Sender besked',
	    message_sent: 'Besked sendt',
	    no_users_matches: 'Ingen brugere matcher din søgning',
	    todays_substitutes: 'Vælg dagens vikarer',
	    send_message_to: 'Send besked til',
	    select_a_standard_template: 'Vælg en besked',
	    create_a_standard_template: 'Opret ny standard besked',
	    recipients: 'Modtagere',
	    select_recipients: 'Vælg modtagere fra listen til venstre',
	    deactivate_sms: 'Slå SMS fra',
	    activate_sms: 'Slå SMS til',
	    deactivate_email: 'Slå email fra',
	    activate_email: 'Slå email til',
	    add_number: 'Tilføj nummer',
	    add_email: 'Tilføj email',
	    awaiting_approval: 'Afventer bekræftelse',
	    sms: 'SMS',
	    email: 'email',
	    settings: 'Indstillinger',
	    email_sent: 'Emails afsendt',
	    sms_sent: 'SMSer afsendt',
	    welcome_to_sms: 'Velkommen til SMS',
	    add_your_number_to_send_sms: 'Indtast dit mobilnummer for at begynde at sende smser til skolens personale. Modtagere kan besvare til dette nummer.',
	    add_your_number: 'Tilføj dit mobilnummer'
	  },
	  nb: {
	    send_message: 'Send melding',
	    recipient: 'Velg mottaker',
	    a_recipient: 'Velg en mottaker',
	    subject: 'Emnefelt',
	    message: 'Melding',
	    message_must_be_filled: 'Meldingsfelt må utfylles',
	    sending_message: 'Sender melding',
	    message_sent: 'Melding sendt',
	    no_users_matches: 'Ingen brukere passer til søket',
	    todays_substitutes: 'Dagens vikarer',
	    send_message_to: 'Send melding til',
	    select_a_standard_template: 'Velg en melding',
	    create_a_standard_sms: 'Opprett ny standardmelding',
	    recipients: 'Mottakere',
	    select_recipients: 'Velg mottakere fra listen til venstre',
	    deactivate_sms: 'Deaktivere SMS',
	    activate_sms: 'Aktivere SMS',
	    deactivate_email: 'Deaktivere e-post',
	    activate_email: 'Aktivere e-post',
	    add_number: 'Legg til nummer',
	    add_email: 'Legg til e-post',
	    awaiting_approval: 'Venter på bekreftelse',
	    sms: 'SMS',
	    email: 'e-post',
	    settings: 'Innstillinger',
	    email_sent: 'E-poster sendt',
	    sms_sent: 'SMS sendt'
	  },
	  en: {
	    send_message: 'Send message',
	    recipient: 'Recipient',
	    a_recipient: 'Choose a recipient',
	    subject: 'Subject',
	    message: 'Message',
	    message_must_be_filled: 'Message can not be empty',
	    sending_message: 'Sending message',
	    message_sent: 'Message sent',
	    no_users_matches: 'No matching users',
	    todays_substitutes: 'Substitutes today',
	    send_message_to: 'Send message to',
	    select_a_standard_template: 'Choose a template',
	    create_a_standard_template: 'Create new template',
	    recipients: 'Recipients',
	    select_recipients: 'Choose users to receive the message',
	    deactivate_sms: 'Deactivate SMS',
	    activate_sms: 'Activate SMS',
	    deactivate_email: 'Deactivate email',
	    activate_email: 'Activate email',
	    add_number: 'Add number',
	    add_email: 'Add email',
	    awaiting_approval: 'Awaiting approval',
	    sms: 'SMS',
	    email: 'email',
	    settings: 'Settings',
	    email_sent: 'Emails sent',
	    sms_sent: 'SMS sent'
	  }
	};
	
	exports.default = {
	  components: {
	    DoFilters: _DoFilters2.default,
	    TaggingFilter: _TaggingFilter2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default,
	    Loader: _Loader4.default, SendMessagesUserSetting: _SendMessagesUserSetting2.default, DDropdown: _DDropdown2.default, SmsAddNumber: _SmsAddNumber2.default, TemplateModal: _MessageTemplate2.default, TemplateDelete: _MedssageTemplateDelete2.default, Spinner: _Loader2.default
	  },
	  data: function data() {
	    return {
	      isEmailActive: true,
	      isSMSActive: false,
	      isOpen: false,
	      selectedWithoutContactForm: [],
	      selectedUser: '',
	      messageSubject: '',
	      messageBody: '',
	      giveFeedback: false,
	      selectedUsers: [],
	      searchText: '',
	      appliedFilters: [],
	      tags: [],
	      isCreateTemplate: false,
	      theEditTemplate: null,
	      theDeleteTemplate: null,
	      isLoadingTemplates: true,
	      templates: [],
	      theActiveEditUser: null,
	      isEmailSent: true,
	      isSMSSent: true,
	      isLoading: true,
	      isInitialLoad: true
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    noNumberForUser: function noNumberForUser() {
	      return this.user && !this.user.phone;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    usersToReceiveEmail: function usersToReceiveEmail() {
	      var users = this.userSetSelected.filter(function (user) {
	        return user.v_email_setting === 'active';
	      });
	      return users.map(function (user) {
	        return user.id;
	      });
	    },
	    usersToReceiveSMS: function usersToReceiveSMS() {
	      var users = this.userSetSelected.filter(function (user) {
	        return user.v_phone_setting === 'active';
	      });
	      return users.map(function (user) {
	        return user.id;
	      });
	    },
	    userSetSelected: function userSetSelected() {
	      var usersMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.id] = user;
	        return acc;
	      }, {});
	
	      return this.selectedUsers.filter(function (id) {
	        return usersMap[id];
	      }).map(function (id) {
	        return usersMap[id];
	      });
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    usersSortedOnName: function usersSortedOnName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    noText: function noText() {
	      return this.messageBody.length < 1 || this.messageSubject.length < 1;
	    },
	    noReceiver: function noReceiver() {
	      return this.selectedUsers.length < 1;
	    },
	    usersUrl: function usersUrl() {
	      return '/schools/' + window.SCHOOL.id + '/users';
	    },
	    usersWithCustomProps: function usersWithCustomProps() {
	      var _this = this;
	
	      return this.usersSortedOnName.map(function (user) {
	        var vPhoneSetting = _this.getContactOption(user, 'phone');
	        var vEmailSetting = _this.getContactOption(user, 'email');
	
	        return (0, _extends3.default)({}, user, {
	          v_phone_setting: vPhoneSetting,
	          v_phone_tooltip: _this.getTooltipText('sms', vPhoneSetting),
	          v_email_setting: vEmailSetting,
	          v_email_tooltip: _this.getTooltipText('email', vEmailSetting)
	        });
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this2 = this;
	
	      return this.usersWithCustomProps.filter(function (user) {
	        return user.name !== '' ? user.name.match(new RegExp(_this2.searchText, 'i')) : '';
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this3 = this;
	
	      var passedUsers = this.searchedUsers;
	      if (this.appliedFilters.length === 0) {
	        return passedUsers;
	      }
	      return passedUsers.filter(function (user) {
	        return user.user_tags.some(function (tag) {
	          return _this3.appliedFilters.includes(tag);
	        });
	      });
	    },
	    absentUsersFromUserSet: function absentUsersFromUserSet() {
	      return this.$store.getters.absentUsersFromUserSet;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    }
	  },
	  methods: {
	    toggleTag: function toggleTag(tag) {
	      var idx = this.appliedFilters.indexOf(tag);
	      if (idx > -1) {
	        this.appliedFilters.splice(idx, 1);
	      } else {
	        this.appliedFilters.push(tag);
	      }
	    },
	    clearAllTags: function clearAllTags() {
	      this.appliedFilters = [];
	      this.removeAllSelectedUsers();
	    },
	    setOpen: function setOpen(bool) {
	      if (bool) {
	        this.isLoading = true;
	        this.isOpen = true;
	        if (this.isInitialLoad) {
	          this.readTags();
	          this.$store.dispatch('getUsers');
	          this.readMessageTemplates();
	        }
	        this.isInitialLoad = false;
	      } else {
	        this.isOpen = false;
	      }
	    },
	    onEnterComplete: function onEnterComplete() {
	      this.isLoading = false;
	    },
	    getTooltipText: function getTooltipText(contactType, setting) {
	      var tooltips = {
	        active: this.i18n[this.locale]['deactivate_' + contactType],
	        no_number: this.i18n[this.locale]['add_number'],
	        no_email: this.i18n[this.locale]['add_email'],
	        awaiting_approval: this.i18n[this.locale]['awaiting_approval'],
	        deactivated: this.i18n[this.locale]['activate_' + contactType]
	      };
	      return tooltips[setting];
	    },
	    setOption: function setOption(user, contactType) {
	      var currentSetting = this.getContactOption(user, contactType);
	      var needsEdit = contactType === 'phone' && currentSetting === 'no_number' || contactType === 'email' && currentSetting === 'no_email' || currentSetting === 'awaiting_approval';
	
	      if (needsEdit) {
	        this.theActiveEditUser = user;
	        return;
	      }
	
	      if (['active', 'deactivated'].includes(currentSetting)) {
	        this.updateUserSettings(user, contactType);
	      }
	    },
	    getContactOption: function getContactOption(user, contactType) {
	      if (contactType === 'phone' && !this.isSMSActive) return 'no_number';
	      if (contactType === 'email' && !this.isEmailActive) return 'no_email';
	
	      var hasContact = user[contactType];
	      if (!hasContact) return contactType === 'phone' ? 'no_number' : 'no_email';
	
	      if (contactType === 'phone' && user.unconfirmed_phone) return 'awaiting_approval';
	
	      var userSettings = JSON.parse(user.settings);
	      if (userSettings['dont_receive_' + contactType]) return 'deactivated';
	
	      return 'active';
	    },
	    closeUserSetting: function closeUserSetting() {
	      var user = this.allUsersInHash[this.theActiveEditUser.id];
	      var emailSetting = this.getContactOption(user, 'email');
	      var phoneSetting = this.getContactOption(user, 'phone');
	      if (emailSetting === 'active' || phoneSetting === 'active') {
	        var idx2 = this.selectedWithoutContactForm.indexOf(user.id);
	        if (idx2 > -1) {
	          this.selectedWithoutContactForm.splice(idx2, 1);
	        }
	      } else {
	        var idx = this.selectedUsers.indexOf(user.id);
	        if (idx > -1) {
	          this.selectedUsers.splice(idx, 1);
	        }
	      }
	      this.theActiveEditUser = null;
	    },
	    updateUserSettings: function updateUserSettings(user, contactType) {
	      var _this4 = this;
	
	      var idx = this.selectedWithoutContactForm.indexOf(user.id);
	      if (idx > -1) {
	        this.selectedWithoutContactForm.splice(idx, 1);
	      }
	      var idx2 = this.selectedUsers.indexOf(user.id);
	      if (idx2 > -1) {
	        this.selectedUsers.splice(idx2, 1);
	      }
	      var userSettings = JSON.parse(user.settings);
	      var varOption = 'dont_receive_' + contactType;
	      var settingsObj = {};
	      settingsObj[varOption] = true;
	      var prop = (0, _keys2.default)(settingsObj)[0];
	      if (this.getContactOption(user, contactType) === 'deactivated') {
	        delete userSettings[prop];
	      } else {
	        var val = settingsObj[prop];
	        userSettings[prop] = val;
	      }
	      var changes = { settings: (0, _stringify2.default)(userSettings) };
	      _docendo2.default.updateUsers(window.SCHOOL.id, user.id, changes, function (data) {
	        _this4.$store.commit('updateSchoolUser', data);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    setTheEditTemplate: function setTheEditTemplate(template) {
	      this.theEditTemplate = template;
	      this.isCreateTemplate = true;
	    },
	    createNewTemplate: function createNewTemplate() {
	      this.isCreateTemplate = true;
	    },
	    closeTemplate: function closeTemplate() {
	      this.theEditTemplate = null;
	      this.theDeleteTemplate = null;
	      this.isCreateTemplate = false;
	    },
	    selectTemplate: function selectTemplate(template) {
	      var today = (0, _moment2.default)().format('dddd');
	      this.messageSubject = template.title.replace('[today]', today);
	      this.messageBody = template.body.replace('[today]', today);
	    },
	    getSubsOfTheDay: function getSubsOfTheDay() {
	      var _this5 = this;
	
	      this.absentUsersFromUserSet.forEach(function (user) {
	        _this5.getUserLessons(user);
	      });
	    },
	    getUserLessons: function getUserLessons(user) {
	      var _this6 = this;
	
	      var lessons = user.dayEvents.map(function (eventId) {
	        return _this6.allEventsInAHash[eventId];
	      });
	      lessons.filter(function (lesson) {
	        return !lesson.v_is_event_from_other_school;
	      }).forEach(function (lesson) {
	        _this6.getSubsFromLessons(lesson);
	      });
	    },
	    getSubsFromLessons: function getSubsFromLessons(lesson) {
	      var _this7 = this;
	
	      var subEvents = lesson.calendar_events.filter(function (event) {
	        return event.substitute;
	      });
	
	      var userMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.user_calendar_id] = user;
	        return acc;
	      }, {});
	
	      subEvents.forEach(function (subEvent) {
	        var sub = userMap[subEvent.calendar_id];
	        if (sub) {
	          _this7.setSub(sub);
	        }
	      });
	    },
	    setSub: function setSub(user, $event) {
	      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	        if (this.selectedUsers.indexOf(user.id) < 0) {
	          this.selectedUsers.push(user.id);
	        }
	      } else {
	        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
	          this.selectedWithoutContactForm.push(user.id);
	        }
	      }
	    },
	    checkIfInListWithoutContactForm: function checkIfInListWithoutContactForm(userid) {
	      return this.selectedWithoutContactForm.indexOf(userid) > -1;
	    },
	    resetData: function resetData() {
	      this.selectedUsers = [];
	      this.selectedUser = '';
	      this.messageSubject = '';
	      this.messageBody = '';
	    },
	    sendMessage: function sendMessage() {
	      var usersToReceiveEmail = this.usersToReceiveEmail;
	      var usersToReceiveSMS = this.usersToReceiveSMS;
	      if (usersToReceiveEmail.length > 0) {
	        this.isEmailSent = false;
	      }
	      if (usersToReceiveSMS.length > 0) {
	        this.isSMSSent = false;
	      }
	      if (usersToReceiveEmail.length > 0) {
	        this.sendEmails(usersToReceiveEmail);
	      }
	      if (usersToReceiveSMS.length > 0) {
	        this.sendSMS(usersToReceiveSMS);
	      }
	    },
	    sendEmails: function sendEmails(userIds) {
	      var _this8 = this;
	
	      _eventbus2.default.toast = { text: this.i18n[this.locale]['sending_message'], 'success': false };
	      this.isOpen = false;
	      _docendo2.default.sendEmails(window.SCHOOL.id, userIds, this.messageSubject, this.messageBody, function (success) {
	        _this8.isEmailSent = true;
	        _eventbus2.default.toast = { text: _this8.i18n[_this8.locale]['email_sent'], 'success': true };
	        if (_this8.isSMSSent) {
	          _this8.resetData();
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    sendSMS: function sendSMS(userIds) {
	      var _this9 = this;
	
	      _docendo2.default.sendSmses(window.SCHOOL.id, userIds, this.messageBody, function (data) {
	        _this9.isSMSSent = true;
	        _eventbus2.default.toast = { text: _this9.i18n[_this9.locale]['sms_sent'], 'success': true };
	        if (_this9.isEmailSent) {
	          _this9.resetData();
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    removeAllSelectedUsers: function removeAllSelectedUsers() {
	      this.selectedUsers = [];
	      this.selectedWithoutContactForm = [];
	    },
	    setUser: function setUser(user, idx, $event) {
	      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	        if (this.selectedUsers.indexOf(user.id) > -1) {
	          this.selectedUsers.splice(this.selectedUsers.indexOf(user.id), 1);
	        } else {
	          this.selectedUsers.push(user.id);
	        }
	      } else {
	        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
	          this.selectedWithoutContactForm.push(user.id);
	        }
	      }
	    },
	    setAllUsersSelected: function setAllUsersSelected() {
	      this.selectedUsers = [];
	      this.selectedWithoutContactForm = [];
	      for (var i = 0; i < this.filteredUsers.length; i++) {
	        var user = this.filteredUsers[i];
	        if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	          this.selectedUsers.push(user.id);
	        }
	      }
	    },
	    checkIfInList: function checkIfInList(userid) {
	      return this.selectedUsers.indexOf(userid) > -1;
	    },
	    readMessageTemplates: function readMessageTemplates() {
	      var _this10 = this;
	
	      this.closeTemplate();
	      this.isLoadingTemplates = true;
	      this.templates = [];
	      _docendo2.default.readMessageTemplates(window.SCHOOL.id, function (messages) {
	        _this10.templates = messages.filter(function (message) {
	          return message.message_type === 'email';
	        });
	        _this10.isLoadingTemplates = false;
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readTags: function readTags() {
	      var _this11 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this11.tags = data;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    var schoolsWithEmailNotSMS = [41576];
	    if (window.SCHOOL.country) {
	      if (window.SCHOOL.country.toLowerCase() === 'dk' || window.SCHOOL.country.toLowerCase() === 'no') {
	        if (window.SCHOOL.id && schoolsWithEmailNotSMS.indexOf(window.SCHOOL.id) < 0) {
	          this.isSMSActive = true;
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _isInteger = __webpack_require__(73);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _SmsAddNumber = __webpack_require__(119);
	
	var _SmsAddNumber2 = _interopRequireDefault(_SmsAddNumber);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    awaiting_approval: 'Afventer bekræftelse',
	    user_settings: 'Brugerindstillinger',
	    mobile_number: 'Mobilnummer',
	    number_must_be_8_digits: 'Telefonummer skal være 8 cifre',
	    receive_sms: 'Modtag SMS',
	    email: 'Email',
	    use_a_valid_email: 'Skriv en gyldig email',
	    receive_email: 'Modtag email',
	    user_updated: 'Opdateret'
	  },
	  nb: {
	    awaiting_approval: 'Venter på bekreftelse',
	    user_settings: 'brukerinstillinger',
	    mobile_number: 'Telefonnummer',
	    number_must_be_8_digits: 'Telefonnummer må være 8 sifre',
	    receive_sms: 'Motta SMS',
	    email: 'E-post',
	    use_a_valid_email: 'Bruk en gyldig e-post',
	    receive_email: 'Motta epost',
	    user_updated: 'Oppdatert'
	  },
	  en: {
	    awaiting_approval: 'Awaiting approval',
	    user_settings: 'User settings',
	    mobile_number: 'Mobile number',
	    number_must_be_8_digits: 'Mobile number must be 8 digits',
	    receive_sms: 'Receive sms',
	    email: 'Email',
	    use_a_valid_email: 'Use a valid email',
	    receive_email: 'Receive email',
	    user_updated: 'User updated'
	  }
	};
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default, DDropdown: _DDropdown2.default, SmsAddNumber: _SmsAddNumber2.default },
	  props: {
	    user: {},
	    isEmailActive: {
	      type: Boolean,
	      default: true
	    },
	    isSMSActive: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      phone: '',
	      initialPhone: '',
	      isPhoneValid: true,
	      isAnimatePhoneUnconfirmed: false,
	      isAnimatePhone: false,
	      email: '',
	      initialEmail: '',
	      initialReceiveSMS: true,
	      receiveSMS: true,
	      hideSMSToggle: false,
	      receiveEmails: true,
	      initialReceiveEmails: true,
	      isEmailValid: true,
	      hideEmailToggle: false,
	      activeCountry: null,
	      countries: [{ name: 'Danmark', countryCode: '45', code: 'dk', flag: 'https://zen.docendo.co/flags/dk.svg' }, { name: 'Norge', countryCode: '47', code: 'no', flag: 'https://zen.docendo.co/flags/no.svg' }, { name: 'United States', countryCode: '1', code: 'us', flag: 'https://zen.docendo.co/flags/us.svg' }],
	      isSubmitting: false,
	      initialUserSettings: null,
	      userSettings: null,
	      errors: {}
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    locale: function locale() {
	      return window.USER.language ? window.USER.language : 'en';
	    },
	    isUSA: function isUSA() {
	      return this.activeCountry.code === 'us';
	    },
	    isNumberBeingDeleted: function isNumberBeingDeleted() {
	      return this.phone.length === 0 && this.phone !== this.initialPhone;
	    }
	  },
	  methods: {
	    toggleSetting: function toggleSetting(contactType) {
	      var _this = this;
	
	      if (contactType === 'phone') {
	        if (this.user.v_phone_setting === 'no_number' || this.phone.length < 1) {
	          this.isPhoneValid = false;
	          this.isAnimatePhone = true;
	          clearTimeout(dTimer);
	          this.$refs.input_phone.focus();
	          var dTimer = setTimeout(function (_) {
	            _this.isAnimatePhone = false;
	          }, 1000);
	          return;
	        }
	        if (this.user.v_phone_setting === 'awaiting_approval') {
	          var _dTimer = null;
	          clearTimeout(_dTimer);
	          this.isAnimatePhoneUnconfirmed = true;
	          _dTimer = setTimeout(function (_) {
	            _this.isAnimatePhoneUnconfirmed = false;
	          }, 1000);
	          return;
	        }
	        this.receiveSMS = !this.receiveSMS;
	      }
	    },
	    validateEmail: function validateEmail(email) {
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      this.isEmailValid = email.length < 1 ? true : re.test(String(email).toLowerCase());
	    },
	    setActiveCountry: function setActiveCountry(country) {
	      this.activeCountry = country;
	    },
	    onPhoneKeyup: function onPhoneKeyup(number) {
	      if (number.length === 0 || number.length > 8) {
	        this.hideSMSToggle = true;
	      }
	      if (number.length === 8) {
	        this.hideSMSToggle = false;
	      }
	      this.isPhoneValid = true;
	    },
	    isValidNumber: function isValidNumber(number) {
	      if (this.isUSA) {
	        return true;
	      }
	      var num = number * 1;
	      this.isPhoneValid = number.length < 1 ? true : (0, _isInteger2.default)(num) && number.length === 8;
	    },
	    setNumber: function setNumber() {
	      var num = '';
	
	      if (this.user.phone) {
	        num = !this.isUSA && this.user.phone.substr(0, 2) === this.activeCountry.countryCode ? this.user.phone.replace(this.activeCountry.countryCode, '') : this.user.phone;
	      }
	      this.initialPhone = num;
	      this.phone = num;
	    },
	    updateUserSettings: function updateUserSettings(contactType) {
	      var userSettings = JSON.parse(this.userSettings);
	      var varOption = 'dont_receive_' + contactType;
	      var settingsObj = {};
	      settingsObj[varOption] = true;
	      var prop = (0, _keys2.default)(settingsObj)[0];
	      if (this.getContactOption(this.user, contactType) === 'deactivated') {
	        delete userSettings[prop];
	      } else {
	        var val = settingsObj[prop];
	        userSettings[prop] = val;
	      }
	      this.userSettings = (0, _stringify2.default)(userSettings);
	    },
	    getContactOption: function getContactOption(user, contactType) {
	      var userSettings = JSON.parse(user.settings);
	      var varOption = 'dont_receive_' + contactType;
	      if (userSettings[varOption]) {
	        return 'deactivated';
	      }
	      if (contactType === 'phone' && !user.phone) {
	        return 'no_number';
	      }
	      if (contactType === 'phone' && user.phone && user.unconfirmed_phone) {
	        return 'awaiting_approval';
	      }
	      if (contactType === 'phone' && user.phone) {
	        return 'active';
	      }
	      if (contactType === 'email' && !user.email) {
	        return 'no_email';
	      }
	      if (contactType === 'email' && user.email) {
	        return 'active';
	      }
	    },
	    onEmailKeyup: function onEmailKeyup(val) {
	      if (val.length === 0) {
	        this.hideEmailToggle = true;
	      } else {
	        this.hideEmailToggle = false;
	      }
	      this.isEmailValid = true;
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      var changes = {};
	      if (this.isSMSActive) {
	        this.isValidNumber(this.phone);
	      }
	      if (this.isEmailActive) {
	        this.validateEmail(this.email);
	      }
	      if (!this.isEmailValid || !this.isPhoneValid) {
	        return;
	      }
	      if (this.isEmailActive && this.email !== this.initialEmail) {
	        changes['email'] = this.email;
	      }
	      if (this.isSMSActive && this.phone !== this.initialPhone) {
	        if (this.phone.length > 0) {
	          changes['phone'] = this.activeCountry.countryCode + this.phone;
	        } else {
	          changes['phone'] = this.phone;
	        }
	      }
	      if (this.initialReceiveSMS !== this.receiveSMS) {
	        this.updateUserSettings('phone');
	        changes['settings'] = this.userSettings;
	      }
	      if (this.initialReceiveEmails !== this.receiveEmails) {
	        this.updateUserSettings('email');
	        changes['settings'] = this.userSettings;
	      }
	      _docendo2.default.updateUsers(window.SCHOOL.id, this.user.id, changes, function (success) {
	        _this2.$store.commit('updateSchoolUser', success);
	        _eventbus2.default.toast = { text: _this2.i18n[_this2.locale]['user_updated'], success: true };
	        _this2.$emit('close');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (window.SCHOOL.country) {
	      var idxOfCountry = this.countries.findIndex(function (country) {
	        return country.code === window.SCHOOL.country.toLowerCase();
	      });
	      this.activeCountry = idxOfCountry > -1 ? this.countries[idxOfCountry] : this.countries[0];
	    }
	    this.userSettings = this.user.settings;
	    this.initialUserSettings = this.user.settings;
	    if (this.isSMSActive) {
	      this.setNumber();
	      var phoneSetting = this.getContactOption(this.user, 'phone');
	      if (phoneSetting === 'no_number') {
	        this.initialReceiveSMS = false;
	        this.receiveSMS = false;
	      } else {
	        if (phoneSetting === 'deactivated' || phoneSetting === 'awaiting_approval') {
	          this.initialReceiveSMS = false;
	          this.receiveSMS = false;
	        }
	      }
	    }
	    if (this.isEmailActive) {
	      this.email = this.user.email ? this.user.email : '';
	      this.initialEmail = this.user.email ? this.user.email : '';
	      if (!this.user.email) {
	        this.receiveEmails = false;
	        this.initialReceiveEmails = false;
	      } else {
	        if (this.getContactOption(this.user, 'email') === 'deactivated') {
	          this.receiveEmails = false;
	          this.initialReceiveEmails = false;
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SmsAddNumber',
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    userid: {
	      type: Number,
	      required: true
	    },
	    hint: {
	      type: String,
	      default: 'hint--top'
	    },
	    isEditFromStart: {
	      type: Boolean,
	      default: false
	    },
	    updateThisUser: {
	      type: Boolean,
	      default: false
	    }
	  },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      originalNumber: null,
	      number: null,
	      isEdit: false,
	      showWarning: false,
	      timeout: null,
	      user: null,
	      activeCountry: null,
	      countries: [{ name: 'Danmark', countryCode: '45', code: 'dk', flag: 'https://zen.docendo.co/flags/dk.svg' }, { name: 'Norge', countryCode: '47', code: 'no', flag: 'https://zen.docendo.co/flags/no.svg' }, { name: 'United States', countryCode: '1', code: 'us', flag: 'https://zen.docendo.co/flags/us.svg' }]
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    loggedInUser: function loggedInUser() {
	      return this.$store.state.user;
	    },
	    isLoggedInUser: function isLoggedInUser() {
	      return this.loggedInUser.id === this.user.id;
	    },
	    hintClass: function hintClass() {
	      return this.showWarning ? this.hint + ' hint--always' : '';
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    isValidNumber: function isValidNumber() {
	      if (this.isUSA) {
	        return true;
	      }
	      if (this.number && this.number.length === 8) {
	        this.showWarning = false;
	      }
	      return this.number.length === 8 || this.isNumberBeingDeleted && this.number.length === 0;
	    },
	    isNumberChanged: function isNumberChanged() {
	      return this.number !== this.originalNumber;
	    },
	    isNumberBeingDeleted: function isNumberBeingDeleted() {
	      return this.number.length === 0 && this.number !== this.originalNumber;
	    },
	    isPendingConfirmation: function isPendingConfirmation() {
	      return this.allUsersInHash[this.userid].unconfirmed_phone;
	    },
	    isUSA: function isUSA() {
	      return this.activeCountry.code === 'us';
	    }
	  },
	  methods: {
	    setActiveCountry: function setActiveCountry(country) {
	      this.activeCountry = country;
	    },
	    onMouseOver: function onMouseOver() {
	      if (!this.isValidNumber) {
	        this.showWarning = true;
	      }
	    },
	    onMouseLeave: function onMouseLeave() {
	      this.showWarning = false;
	    },
	    keyPressEnter: function keyPressEnter() {
	      this.submitNumber();
	    },
	    setEdit: function setEdit() {
	      var _this = this;
	
	      this.isEdit = true;
	      setTimeout(function (_) {
	        if (_this.$refs.inputfield) {
	          _this.$refs.inputfield.focus();
	        }
	      }, 400);
	    },
	    closeEdit: function closeEdit() {
	      this.isEdit = false;
	    },
	    inputKeypress: function inputKeypress(evt) {
	      this.isNumber(evt);
	    },
	    isNumber: function isNumber(evt) {
	      var charCode = evt.which ? evt.which : evt.keyCode;
	      if (charCode === 13) {
	        this.keyPressEnter();
	      }
	      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 9 || !this.isUSA && this.number.length === 8) {
	        evt.preventDefault();
	      } else {
	        return true;
	      }
	    },
	    setNumber: function setNumber() {
	      this.user = this.allUsersInHash[this.userid];
	      var num = '';
	
	      if (this.user.phone) {
	        num = !this.isUSA && this.user.phone.substr(0, 2) === this.activeCountry.countryCode ? this.user.phone.replace(this.activeCountry.countryCode, '') : this.user.phone;
	      }
	      this.originalNumber = num;
	      this.number = this.originalNumber;
	    },
	    inputKeyup: function inputKeyup() {
	      this.showWarning = false;
	    },
	    closeWithoutSubmit: function closeWithoutSubmit(val) {
	      if (this.isEditFromStart) {
	        if (val === 'button') {
	          this.$emit('close');
	        }
	        return;
	      }
	      this.number = this.originalNumber;
	      this.closeEdit();
	    },
	    submitNumber: function submitNumber() {
	      var _this2 = this;
	
	      if (!this.isValidNumber) {
	        setTimeout(function (_) {
	          _this2.showWarning = true;
	        }, 300);
	        return;
	      }
	      if (this.isNumberBeingDeleted) {
	        this.closeEdit();
	        _docendo2.default.deleteUserPhone(window.SCHOOL.id, this.userid, function (payload) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.sms.number_deleted'), success: true };
	          _this2.$store.commit('updateSchoolUser', payload);
	          _this2.setNumber();
	          _this2.$emit('close');
	        }, function (failure) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	        });
	        return;
	      }
	      if (this.isValidNumber && !this.isNumberBeingDeleted) {
	        var num = this.activeCountry.countryCode + this.number;
	        var changes = {};
	        changes['phone'] = num;
	        _docendo2.default.updateUsers(this.schoolId, this.userid, changes, function (success) {
	          _this2.$store.commit('updateSchoolUser', success);
	          if (_this2.updateThisUser) {
	            var updateObj = {
	              prop: 'phone',
	              phone: success.phone
	            };
	            _this2.$store.commit('updateUserProp', updateObj);
	          }
	          _eventbus2.default.toast = { text: 'Updated', success: true };
	          _this2.$emit('close');
	        }, function (failure) {
	          _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	        });
	        if (this.isEditFromStart) {
	          this.$emit('added');
	        }
	        this.closeEdit();
	        this.$emit('close');
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (window.SCHOOL.country) {
	      var idxOfCountry = this.countries.findIndex(function (country) {
	        return country.code === window.SCHOOL.country.toLowerCase();
	      });
	      this.activeCountry = idxOfCountry > -1 ? this.countries[idxOfCountry] : this.countries[0];
	    }
	    this.setNumber();
	  },
	  mounted: function mounted() {
	    if (this.isEditFromStart) {
	      this.setEdit();
	    }
	  }
	};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _SmsAddNumber = __webpack_require__(119);
	
	var _SmsAddNumber2 = _interopRequireDefault(_SmsAddNumber);
	
	var _MessageTemplate = __webpack_require__(321);
	
	var _MessageTemplate2 = _interopRequireDefault(_MessageTemplate);
	
	var _MedssageTemplateDelete = __webpack_require__(320);
	
	var _MedssageTemplateDelete2 = _interopRequireDefault(_MedssageTemplateDelete);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SendMessagesUserSetting = __webpack_require__(322);
	
	var _SendMessagesUserSetting2 = _interopRequireDefault(_SendMessagesUserSetting);
	
	var _Loader3 = __webpack_require__(4);
	
	var _Loader4 = _interopRequireDefault(_Loader3);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DoFilters = __webpack_require__(115);
	
	var _DoFilters2 = _interopRequireDefault(_DoFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    send_message: 'Send besked',
	    recipient: 'Modtager',
	    a_recipient: 'Vælg en modtager',
	    subject: 'Emnefelt',
	    message: 'Besked',
	    message_must_be_filled: 'Besked skal udfyldes',
	    sending_message: 'Sender besked',
	    message_sent: 'Besked sendt',
	    no_users_matches: 'Ingen brugere matcher din søgning',
	    todays_substitutes: 'Vælg dagens vikarer',
	    send_message_to: 'Send besked til',
	    select_a_standard_template: 'Vælg en besked',
	    create_a_standard_template: 'Opret ny standard besked',
	    recipients: 'Modtagere',
	    select_recipients: 'Vælg modtagere fra listen til venstre',
	    deactivate_sms: 'Slå SMS fra',
	    activate_sms: 'Slå SMS til',
	    deactivate_email: 'Slå email fra',
	    activate_email: 'Slå email til',
	    add_number: 'Tilføj nummer',
	    add_email: 'Tilføj email',
	    awaiting_approval: 'Afventer bekræftelse',
	    sms: 'SMS',
	    email: 'email',
	    settings: 'Indstillinger',
	    email_sent: 'Emails afsendt',
	    sms_sent: 'SMSer afsendt',
	    welcome_to_sms: 'Velkommen til SMS',
	    add_your_number_to_send_sms: 'Indtast dit mobilnummer for at begynde at sende smser til skolens personale. Modtagere kan besvare til dette nummer.',
	    add_your_number: 'Tilføj dit mobilnummer'
	  },
	  nb: {
	    send_message: 'Send melding',
	    recipient: 'Velg mottaker',
	    a_recipient: 'Velg en mottaker',
	    subject: 'Emnefelt',
	    message: 'Melding',
	    message_must_be_filled: 'Meldingsfelt må utfylles',
	    sending_message: 'Sender melding',
	    message_sent: 'Melding sendt',
	    no_users_matches: 'Ingen brukere passer til søket',
	    todays_substitutes: 'Dagens vikarer',
	    send_message_to: 'Send melding til',
	    select_a_standard_template: 'Velg en melding',
	    create_a_standard_sms: 'Opprett ny standardmelding',
	    recipients: 'Mottakere',
	    select_recipients: 'Velg mottakere fra listen til venstre',
	    deactivate_sms: 'Deaktivere SMS',
	    activate_sms: 'Aktivere SMS',
	    deactivate_email: 'Deaktivere e-post',
	    activate_email: 'Aktivere e-post',
	    add_number: 'Legg til nummer',
	    add_email: 'Legg til e-post',
	    awaiting_approval: 'Venter på bekreftelse',
	    sms: 'SMS',
	    email: 'e-post',
	    settings: 'Innstillinger',
	    email_sent: 'E-poster sendt',
	    sms_sent: 'SMS sendt'
	  },
	  en: {
	    send_message: 'Send message',
	    recipient: 'Recipient',
	    a_recipient: 'Choose a recipient',
	    subject: 'Subject',
	    message: 'Message',
	    message_must_be_filled: 'Message can not be empty',
	    sending_message: 'Sending message',
	    message_sent: 'Message sent',
	    no_users_matches: 'No matching users',
	    todays_substitutes: 'Substitutes today',
	    send_message_to: 'Send message to',
	    select_a_standard_template: 'Choose a template',
	    create_a_standard_template: 'Create new template',
	    recipients: 'Recipients',
	    select_recipients: 'Choose users to receive the message',
	    deactivate_sms: 'Deactivate SMS',
	    activate_sms: 'Activate SMS',
	    deactivate_email: 'Deactivate email',
	    activate_email: 'Activate email',
	    add_number: 'Add number',
	    add_email: 'Add email',
	    awaiting_approval: 'Awaiting approval',
	    sms: 'SMS',
	    email: 'email',
	    settings: 'Settings',
	    email_sent: 'Emails sent',
	    sms_sent: 'SMS sent'
	  }
	};
	
	exports.default = {
	  components: {
	    DoFilters: _DoFilters2.default,
	    TaggingFilter: _TaggingFilter2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default,
	    Loader: _Loader4.default, SendMessagesUserSetting: _SendMessagesUserSetting2.default, DDropdown: _DDropdown2.default, SmsAddNumber: _SmsAddNumber2.default, TemplateModal: _MessageTemplate2.default, TemplateDelete: _MedssageTemplateDelete2.default, Spinner: _Loader2.default
	  },
	  data: function data() {
	    return {
	      isEmailActive: true,
	      isSMSActive: false,
	      isOpen: false,
	      selectedWithoutContactForm: [],
	      selectedUser: '',
	      messageSubject: '',
	      messageBody: '',
	      giveFeedback: false,
	      selectedUsers: [],
	      searchText: '',
	      appliedFilters: [],
	      tags: [],
	      isCreateTemplate: false,
	      theEditTemplate: null,
	      theDeleteTemplate: null,
	      isLoadingTemplates: true,
	      templates: [],
	      theActiveEditUser: null,
	      isEmailSent: true,
	      isSMSSent: true,
	      isLoading: true,
	      isInitialLoad: true
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    noNumberForUser: function noNumberForUser() {
	      return this.user && !this.user.phone;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    usersToReceiveEmail: function usersToReceiveEmail() {
	      var users = this.userSetSelected.filter(function (user) {
	        return user.v_email_setting === 'active';
	      });
	      return users.map(function (user) {
	        return user.id;
	      });
	    },
	    usersToReceiveSMS: function usersToReceiveSMS() {
	      var users = this.userSetSelected.filter(function (user) {
	        return user.v_phone_setting === 'active';
	      });
	      return users.map(function (user) {
	        return user.id;
	      });
	    },
	    userSetSelected: function userSetSelected() {
	      var usersMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.id] = user;
	        return acc;
	      }, {});
	
	      return this.selectedUsers.filter(function (id) {
	        return usersMap[id];
	      }).map(function (id) {
	        return usersMap[id];
	      });
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    usersSortedOnName: function usersSortedOnName() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    noText: function noText() {
	      return this.messageBody.length < 1 || this.messageSubject.length < 1;
	    },
	    noReceiver: function noReceiver() {
	      return this.selectedUsers.length < 1;
	    },
	    usersUrl: function usersUrl() {
	      return '/schools/' + window.SCHOOL.id + '/users';
	    },
	    usersWithCustomProps: function usersWithCustomProps() {
	      var _this = this;
	
	      return this.usersSortedOnName.map(function (user) {
	        var vPhoneSetting = _this.getContactOption(user, 'phone');
	        var vEmailSetting = _this.getContactOption(user, 'email');
	
	        return (0, _extends3.default)({}, user, {
	          v_phone_setting: vPhoneSetting,
	          v_phone_tooltip: _this.getTooltipText('sms', vPhoneSetting),
	          v_email_setting: vEmailSetting,
	          v_email_tooltip: _this.getTooltipText('email', vEmailSetting)
	        });
	      });
	    },
	    searchedUsers: function searchedUsers() {
	      var _this2 = this;
	
	      return this.usersWithCustomProps.filter(function (user) {
	        return user.name !== '' ? user.name.match(new RegExp(_this2.searchText, 'i')) : '';
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this3 = this;
	
	      var passedUsers = this.searchedUsers;
	      if (this.appliedFilters.length === 0) {
	        return passedUsers;
	      }
	      return passedUsers.filter(function (user) {
	        return user.user_tags.some(function (tag) {
	          return _this3.appliedFilters.includes(tag);
	        });
	      });
	    },
	    absentUsersFromUserSet: function absentUsersFromUserSet() {
	      return this.$store.getters.absentUsersFromUserSet;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    }
	  },
	  methods: {
	    toggleTag: function toggleTag(tag) {
	      var idx = this.appliedFilters.indexOf(tag);
	      if (idx > -1) {
	        this.appliedFilters.splice(idx, 1);
	      } else {
	        this.appliedFilters.push(tag);
	      }
	    },
	    clearAllTags: function clearAllTags() {
	      this.appliedFilters = [];
	      this.removeAllSelectedUsers();
	    },
	    setOpen: function setOpen(bool) {
	      if (bool) {
	        this.isLoading = true;
	        this.isOpen = true;
	        if (this.isInitialLoad) {
	          this.readTags();
	          this.$store.dispatch('getUsers');
	          this.readMessageTemplates();
	        }
	        this.isInitialLoad = false;
	      } else {
	        this.isOpen = false;
	      }
	    },
	    onEnterComplete: function onEnterComplete() {
	      this.isLoading = false;
	    },
	    getTooltipText: function getTooltipText(contactType, setting) {
	      var tooltips = {
	        active: this.i18n[this.locale]['deactivate_' + contactType],
	        no_number: this.i18n[this.locale]['add_number'],
	        no_email: this.i18n[this.locale]['add_email'],
	        awaiting_approval: this.i18n[this.locale]['awaiting_approval'],
	        deactivated: this.i18n[this.locale]['activate_' + contactType]
	      };
	      return tooltips[setting];
	    },
	    setOption: function setOption(user, contactType) {
	      var currentSetting = this.getContactOption(user, contactType);
	      var needsEdit = contactType === 'phone' && currentSetting === 'no_number' || contactType === 'email' && currentSetting === 'no_email' || currentSetting === 'awaiting_approval';
	
	      if (needsEdit) {
	        this.theActiveEditUser = user;
	        return;
	      }
	
	      if (['active', 'deactivated'].includes(currentSetting)) {
	        this.updateUserSettings(user, contactType);
	      }
	    },
	    getContactOption: function getContactOption(user, contactType) {
	      if (contactType === 'phone' && !this.isSMSActive) return 'no_number';
	      if (contactType === 'email' && !this.isEmailActive) return 'no_email';
	
	      var hasContact = user[contactType];
	      if (!hasContact) return contactType === 'phone' ? 'no_number' : 'no_email';
	
	      if (contactType === 'phone' && user.unconfirmed_phone) return 'awaiting_approval';
	
	      var userSettings = JSON.parse(user.settings);
	      if (userSettings['dont_receive_' + contactType]) return 'deactivated';
	
	      return 'active';
	    },
	    closeUserSetting: function closeUserSetting() {
	      var user = this.allUsersInHash[this.theActiveEditUser.id];
	      var emailSetting = this.getContactOption(user, 'email');
	      var phoneSetting = this.getContactOption(user, 'phone');
	      if (emailSetting === 'active' || phoneSetting === 'active') {
	        var idx2 = this.selectedWithoutContactForm.indexOf(user.id);
	        if (idx2 > -1) {
	          this.selectedWithoutContactForm.splice(idx2, 1);
	        }
	      } else {
	        var idx = this.selectedUsers.indexOf(user.id);
	        if (idx > -1) {
	          this.selectedUsers.splice(idx, 1);
	        }
	      }
	      this.theActiveEditUser = null;
	    },
	    updateUserSettings: function updateUserSettings(user, contactType) {
	      var _this4 = this;
	
	      var idx = this.selectedWithoutContactForm.indexOf(user.id);
	      if (idx > -1) {
	        this.selectedWithoutContactForm.splice(idx, 1);
	      }
	      var idx2 = this.selectedUsers.indexOf(user.id);
	      if (idx2 > -1) {
	        this.selectedUsers.splice(idx2, 1);
	      }
	      var userSettings = JSON.parse(user.settings);
	      var varOption = 'dont_receive_' + contactType;
	      var settingsObj = {};
	      settingsObj[varOption] = true;
	      var prop = (0, _keys2.default)(settingsObj)[0];
	      if (this.getContactOption(user, contactType) === 'deactivated') {
	        delete userSettings[prop];
	      } else {
	        var val = settingsObj[prop];
	        userSettings[prop] = val;
	      }
	      var changes = { settings: (0, _stringify2.default)(userSettings) };
	      _docendo2.default.updateUsers(window.SCHOOL.id, user.id, changes, function (data) {
	        _this4.$store.commit('updateSchoolUser', data);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    setTheEditTemplate: function setTheEditTemplate(template) {
	      this.theEditTemplate = template;
	      this.isCreateTemplate = true;
	    },
	    createNewTemplate: function createNewTemplate() {
	      this.isCreateTemplate = true;
	    },
	    closeTemplate: function closeTemplate() {
	      this.theEditTemplate = null;
	      this.theDeleteTemplate = null;
	      this.isCreateTemplate = false;
	    },
	    selectTemplate: function selectTemplate(template) {
	      var today = (0, _moment2.default)().format('dddd');
	      this.messageSubject = template.title.replace('[today]', today);
	      this.messageBody = template.body.replace('[today]', today);
	    },
	    getSubsOfTheDay: function getSubsOfTheDay() {
	      var _this5 = this;
	
	      this.absentUsersFromUserSet.forEach(function (user) {
	        _this5.getUserLessons(user);
	      });
	    },
	    getUserLessons: function getUserLessons(user) {
	      var _this6 = this;
	
	      var lessons = user.dayEvents.map(function (eventId) {
	        return _this6.allEventsInAHash[eventId];
	      });
	      lessons.filter(function (lesson) {
	        return !lesson.v_is_event_from_other_school;
	      }).forEach(function (lesson) {
	        _this6.getSubsFromLessons(lesson);
	      });
	    },
	    getSubsFromLessons: function getSubsFromLessons(lesson) {
	      var _this7 = this;
	
	      var subEvents = lesson.calendar_events.filter(function (event) {
	        return event.substitute;
	      });
	
	      var userMap = this.usersWithCustomProps.reduce(function (acc, user) {
	        acc[user.user_calendar_id] = user;
	        return acc;
	      }, {});
	
	      subEvents.forEach(function (subEvent) {
	        var sub = userMap[subEvent.calendar_id];
	        if (sub) {
	          _this7.setSub(sub);
	        }
	      });
	    },
	    setSub: function setSub(user, $event) {
	      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	        if (this.selectedUsers.indexOf(user.id) < 0) {
	          this.selectedUsers.push(user.id);
	        }
	      } else {
	        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
	          this.selectedWithoutContactForm.push(user.id);
	        }
	      }
	    },
	    checkIfInListWithoutContactForm: function checkIfInListWithoutContactForm(userid) {
	      return this.selectedWithoutContactForm.indexOf(userid) > -1;
	    },
	    resetData: function resetData() {
	      this.selectedUsers = [];
	      this.selectedUser = '';
	      this.messageSubject = '';
	      this.messageBody = '';
	    },
	    sendMessage: function sendMessage() {
	      var usersToReceiveEmail = this.usersToReceiveEmail;
	      var usersToReceiveSMS = this.usersToReceiveSMS;
	      if (usersToReceiveEmail.length > 0) {
	        this.isEmailSent = false;
	      }
	      if (usersToReceiveSMS.length > 0) {
	        this.isSMSSent = false;
	      }
	      if (usersToReceiveEmail.length > 0) {
	        this.sendEmails(usersToReceiveEmail);
	      }
	      if (usersToReceiveSMS.length > 0) {
	        this.sendSMS(usersToReceiveSMS);
	      }
	    },
	    sendEmails: function sendEmails(userIds) {
	      var _this8 = this;
	
	      _eventbus2.default.toast = { text: this.i18n[this.locale]['sending_message'], 'success': false };
	      this.isOpen = false;
	      _docendo2.default.sendEmails(window.SCHOOL.id, userIds, this.messageSubject, this.messageBody, function (success) {
	        _this8.isEmailSent = true;
	        _eventbus2.default.toast = { text: _this8.i18n[_this8.locale]['email_sent'], 'success': true };
	        if (_this8.isSMSSent) {
	          _this8.resetData();
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    sendSMS: function sendSMS(userIds) {
	      var _this9 = this;
	
	      _docendo2.default.sendSmses(window.SCHOOL.id, userIds, this.messageBody, function (data) {
	        _this9.isSMSSent = true;
	        _eventbus2.default.toast = { text: _this9.i18n[_this9.locale]['sms_sent'], 'success': true };
	        if (_this9.isEmailSent) {
	          _this9.resetData();
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', 'success': false };
	      });
	    },
	    removeAllSelectedUsers: function removeAllSelectedUsers() {
	      this.selectedUsers = [];
	      this.selectedWithoutContactForm = [];
	    },
	    setUser: function setUser(user, idx, $event) {
	      if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	        if (this.selectedUsers.indexOf(user.id) > -1) {
	          this.selectedUsers.splice(this.selectedUsers.indexOf(user.id), 1);
	        } else {
	          this.selectedUsers.push(user.id);
	        }
	      } else {
	        if (this.selectedWithoutContactForm.indexOf(user.id) < 0) {
	          this.selectedWithoutContactForm.push(user.id);
	        }
	      }
	    },
	    setAllUsersSelected: function setAllUsersSelected() {
	      this.selectedUsers = [];
	      this.selectedWithoutContactForm = [];
	      for (var i = 0; i < this.filteredUsers.length; i++) {
	        var user = this.filteredUsers[i];
	        if (user.v_phone_setting === 'active' || user.v_email_setting === 'active') {
	          this.selectedUsers.push(user.id);
	        }
	      }
	    },
	    checkIfInList: function checkIfInList(userid) {
	      return this.selectedUsers.indexOf(userid) > -1;
	    },
	    readMessageTemplates: function readMessageTemplates() {
	      var _this10 = this;
	
	      this.closeTemplate();
	      this.isLoadingTemplates = true;
	      this.templates = [];
	      _docendo2.default.readMessageTemplates(window.SCHOOL.id, function (messages) {
	        _this10.templates = messages.filter(function (message) {
	          return message.message_type === 'email';
	        });
	        _this10.isLoadingTemplates = false;
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    readTags: function readTags() {
	      var _this11 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this11.tags = data;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    var schoolsWithEmailNotSMS = [41576];
	    if (window.SCHOOL.country) {
	      if (window.SCHOOL.country.toLowerCase() === 'dk' || window.SCHOOL.country.toLowerCase() === 'no') {
	        if (window.SCHOOL.id && schoolsWithEmailNotSMS.indexOf(window.SCHOOL.id) < 0) {
	          this.isSMSActive = true;
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DModal: _DModal2.default },
	  props: {
	    userId: {
	      default: 13
	    },
	    userName: {
	      default: 'Henrik'
	    }
	  },
	  data: function data() {
	    return {
	      isModal: false,
	      isLoading: true,
	      isCreateForm: false,
	      createFormCPR: '',
	      createFormExtraCiffer: '',
	      createFormEmploymentTypeId: null,
	      employments: [],
	      schoolEmployments: [],
	      theDeleteEmployment: null,
	      formErrors: {},
	      isShowArchived: false
	    };
	  },
	
	  computed: {
	    createFormEmploymentNumber: function createFormEmploymentNumber() {
	      var cpr = this.createFormCPR.replace(/[^0-9]/ig, '');
	      return cpr.toString() + this.createFormExtraCiffer.toString();
	    },
	    isEmploymentTypesLoading: function isEmploymentTypesLoading() {
	      return this.$store.getters.isLoadingEmploymentsTypesForSchool;
	    },
	    isAllDoneLoading: function isAllDoneLoading() {
	      return !this.isLoading && !this.isEmploymentTypesLoading;
	    },
	    employmentTypes: function employmentTypes() {
	      return this.$store.state.employments.employmentsTypes;
	    },
	    employmentTypesActive: function employmentTypesActive() {
	      return this.employmentTypes.filter(function (type) {
	        return !type.deleted;
	      });
	    },
	    userEmployments: function userEmployments() {
	      return this.employments.filter(function (employment) {
	        return !employment.deleted;
	      });
	    },
	    userDeletedEmployments: function userDeletedEmployments() {
	      return this.employments.filter(function (employment) {
	        return employment.deleted;
	      });
	    },
	    userEmploymentsWithTitle: function userEmploymentsWithTitle() {
	      var _this = this;
	
	      var arr = [];
	      this.userEmployments.forEach(function (employment) {
	        var title = _this.getEmploymentTypeTitle(employment.employment_type_id);
	        _this.$set(employment, 'title', title);
	        arr.push(employment);
	      });
	      return arr;
	    },
	    deletedUserEmploymentsWithTitle: function deletedUserEmploymentsWithTitle() {
	      var _this2 = this;
	
	      var arr = [];
	      this.userDeletedEmployments.forEach(function (employment) {
	        var title = _this2.getEmploymentTypeTitle(employment.employment_type_id);
	        _this2.$set(employment, 'title', title);
	        arr.push(employment);
	      });
	      return arr;
	    }
	  },
	  methods: {
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    formValidation: function formValidation() {
	      this.formErrors = {};
	      if (!this.createFormEmploymentTypeId) {
	        this.$set(this.formErrors, 'type', 'Vælg en type');
	      }
	      if (!this.validateCPR()) {
	        this.$set(this.formErrors, 'cpr', 'Er ikke et gyldigt CPR nummer');
	      }
	      if (this.createFormExtraCiffer.length < 1) {
	        this.$set(this.formErrors, 'ciffer', 'Skal sættes');
	      }
	      if (this.validateCPRAndCifferIsAlreadyUsed()) {
	        this.$set(this.formErrors, 'cpr', 'CPR nummer + ekstra ciffer er allerede brugt');
	        this.$set(this.formErrors, 'ciffer', ' ');
	      }
	    },
	    validateCPRAndCifferIsAlreadyUsed: function validateCPRAndCifferIsAlreadyUsed() {
	      var _this3 = this;
	
	      var idx = this.userEmployments.findIndex(function (employment) {
	        return employment.employment_number.toString() === _this3.createFormEmploymentNumber.toString();
	      });
	      return idx > -1;
	    },
	    validateCPR: function validateCPR() {
	      var cpr = this.createFormCPR;
	      var res = cpr.replace(/[^0-9]/ig, '');
	      if (res.length !== 10) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    closeIsModal: function closeIsModal() {
	      this.closeIsCreateForm();
	      this.isModal = false;
	    },
	    setIsCreateForm: function setIsCreateForm(boolean) {
	      if (boolean) {
	        this.isCreateForm = true;
	      }
	    },
	    resetForm: function resetForm() {
	      this.createFormCPR = '';
	      this.createFormExtraCiffer = '';
	      this.createFormEmploymentTypeId = null;
	      this.formErrors = {};
	    },
	    closeIsCreateForm: function closeIsCreateForm() {
	      this.resetForm();
	      if (this.userEmployments.length < 1) {
	        this.isModal = false;
	      }
	      this.isCreateForm = false;
	    },
	    openIsModal: function openIsModal() {
	      this.getUserEmployments();
	      this.isModal = true;
	    },
	    createEmployment: function createEmployment() {
	      var _this4 = this;
	
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      _docendo2.default.createEmployment(window.SCHOOL.id, this.userId, this.createFormEmploymentNumber, this.createFormEmploymentTypeId, function (success) {
	        _this4.employments.push(success);
	        _this4.closeIsCreateForm();
	        _eventbus2.default.toast = { text: 'Ansættelsen er oprettet', success: true };
	        _this4.$store.dispatch('readEmployments');
	      }, function (failure) {
	        console.log('FAILED', failure);
	        _this4.$store.dispatch('readEmployments');
	      });
	    },
	    getUserEmployments: function getUserEmployments() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      _docendo2.default.employmentsForSchoolForUser(window.SCHOOL.id, this.userId, function (success) {
	        _this5.employments = success;
	        _this5.isLoading = false;
	        if (_this5.employments.length < 1) {
	          _this5.isCreateForm = true;
	        }
	      }, function (failure) {
	        console.log('failed', failure);
	      });
	    },
	    setDeleteEmployment: function setDeleteEmployment(employment) {
	      this.theDeleteEmployment = employment;
	    },
	    deleteEmployment: function deleteEmployment() {
	      var _this6 = this;
	
	      _docendo2.default.deleteEmployment(window.SCHOOL.id, this.userId, this.theDeleteEmployment.id, function (success) {
	        _eventbus2.default.toast = { text: 'Ansættelsen er slettet', success: true };
	        _this6.getUserEmployments();
	        _this6.theDeleteEmployment = null;
	        _this6.$store.dispatch('readEmployments');
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', success: false };
	        _this6.getUserEmployments();
	        _this6.theDeleteEmployment = null;
	        _this6.$store.dispatch('readEmployments');
	      });
	    },
	    getAllEmployments: function getAllEmployments() {
	      var _this7 = this;
	
	      _docendo2.default.employmentsForSchool(window.SCHOOL.id, function (success) {
	        _this7.schoolEmployments = success;
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    getEmploymentTypeTitle: function getEmploymentTypeTitle(employmentTypeId) {
	      var employmentIdStr = employmentTypeId * 1;
	      var idx = this.employmentTypes.findIndex(function (employment) {
	        return employment.id === employmentIdStr;
	      });
	      return idx > -1 ? this.employmentTypes[idx].title : '?';
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readEmploymentTypes');
	    this.$store.dispatch('readEmployments');
	  }
	};

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    activeFilter: {
	      default: 'draft'
	    },
	    userDaysSorted: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    userDaysDrafts: function userDaysDrafts() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'draft';
	      });
	    },
	    userDaysApproved: function userDaysApproved() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'approved';
	      });
	    },
	    userDaysSent: function userDaysSent() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'sent';
	      });
	    }
	  },
	  methods: {
	    setFilter: function setFilter(filter) {
	      this.$emit('change', filter);
	    }
	  }
	};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SalarySettingsUsers = __webpack_require__(1314);
	
	var _SalarySettingsUsers2 = _interopRequireDefault(_SalarySettingsUsers);
	
	var _SalaryRule = __webpack_require__(1317);
	
	var _SalaryRule2 = _interopRequireDefault(_SalaryRule);
	
	var _SalaryRule3 = __webpack_require__(1318);
	
	var _SalaryRule4 = _interopRequireDefault(_SalaryRule3);
	
	var _SalaryRule5 = __webpack_require__(1319);
	
	var _SalaryRule6 = _interopRequireDefault(_SalaryRule5);
	
	var _SalaryRule7 = __webpack_require__(1320);
	
	var _SalaryRule8 = _interopRequireDefault(_SalaryRule7);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, SalaryRule1: _SalaryRule2.default, SalaryRule2: _SalaryRule4.default, SalaryRule3: _SalaryRule6.default, SalaryRule4: _SalaryRule8.default, SalarySettingsUsers: _SalarySettingsUsers2.default, DModal: _DModal2.default },
	  props: {
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isSubmitting: false,
	      isValidated: false,
	      tabs: [{ id: 1, title: '1. Opret ansættelser' }, { id: 2, title: '2. Hvornår skal hvilken ansættelse bruges' }, { id: 5, title: '3. Skal der gives tid før første lektion' }, { id: 3, title: '4. Hvordan tæller mellemtimer' }, { id: 4, title: '5. Er der et minimum antal timer' }],
	      theActiveTab: 1,
	      isChangesMade: true,
	      theEditUser: null,
	      isInitLoading: true
	    };
	  },
	
	  computed: {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolSubstituteRules: function schoolSubstituteRules() {
	      if (this.school && this.school.substitute_rules) {
	        return this.school.substitute_rules;
	      }
	    },
	    rules: function rules() {
	      return this.schoolSubstituteRules && this.schoolSubstituteRules.rules ? this.schoolSubstituteRules.rules : [];
	    },
	    config: function config() {
	      return this.schoolSubstituteRules && this.schoolSubstituteRules.configuration ? this.schoolSubstituteRules.configuration : {};
	    }
	  },
	  methods: {
	    setEditUser: function setEditUser(user) {
	      this.theEditUser = user;
	    },
	    onClose: function onClose() {
	      if (this.isChangesMade) {
	        this.$emit('update');
	      }
	      this.$emit('close');
	      this.isChangesMade = false;
	    },
	    setTheActiveTab: function setTheActiveTab(tabId) {
	      this.theActiveTab = tabId;
	    },
	    updateSchoolConfiguration: function updateSchoolConfiguration(dbConfig, employmentRules) {
	      var _this = this;
	
	      var dbRules = JSON.parse((0, _stringify2.default)(this.schoolSubstituteRules));
	      if (!dbConfig || (0, _keys2.default)(dbConfig).length === 0) {
	        delete dbRules.configuration;
	      } else {
	        dbRules['configuration'] = dbConfig;
	      }
	      if (employmentRules && employmentRules.length === 0) {
	        delete dbRules.rules;
	      }
	      if (employmentRules) {
	        dbRules['rules'] = employmentRules;
	      }
	      this.isSaving = true;
	      this.isChangesMade = true;
	      _docendo2.default.updateSchool(this.schoolId, { substitute_rules: dbRules }, function (success) {
	        _eventbus2.default.toast = { text: 'Gemt', 'success': true };
	        _this.isSaving = false;
	        _this.$store.commit('setActiveSchool', success);
	        _this.$store.commit('setSchoolSettings', success.custom_data);
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.isInitLoading = true;
	    setTimeout(function (_) {
	      _this2.isInitLoading = false;
	    }, 500);
	  }
	};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ModalConfirmation: _ModalConfirmation2.default, AppToggle: _AppToggle2.default, DModal: _DModal2.default },
	  props: {
	    isCreateNewEmploymentTitle: {
	      type: Boolean,
	      default: false
	    },
	    isManualSalary: {
	      type: Boolean,
	      default: false
	    },
	    selectedUsers: {
	      type: Array,
	      default: []
	    }
	  },
	  data: function data() {
	    return {
	      title: '',
	      isDeleteConfirm: false,
	      isDeleting: false
	    };
	  },
	
	  computed: {
	    isValid: function isValid() {
	      return this.isCreateNewEmploymentTitle ? this.title.length > 0 : true;
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      if (this.isCreateNewEmploymentTitle) {
	        this.$emit('save', this.title);
	      } else {
	        this.$emit('save');
	      }
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    if (this.isCreateNewEmploymentTitle) {
	      this.$refs.title_input.focus();
	    }
	  }
	};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _SalarySettingsUsersUser = __webpack_require__(1316);
	
	var _SalarySettingsUsersUser2 = _interopRequireDefault(_SalarySettingsUsersUser);
	
	var _SalarySettingsCreateEmploymentType = __webpack_require__(1313);
	
	var _SalarySettingsCreateEmploymentType2 = _interopRequireDefault(_SalarySettingsCreateEmploymentType);
	
	var _SalarySettingsUsersOpus = __webpack_require__(1315);
	
	var _SalarySettingsUsersOpus2 = _interopRequireDefault(_SalarySettingsUsersOpus);
	
	var _SalarySettingsUsersOpusTable = __webpack_require__(324);
	
	var _SalarySettingsUsersOpusTable2 = _interopRequireDefault(_SalarySettingsUsersOpusTable);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    AppToggle: _AppToggle2.default,
	    SalarySettingsUsersTable: _SalarySettingsUsersOpusTable2.default,
	    SalarySettingsUsersOpus: _SalarySettingsUsersOpus2.default,
	    SalarySettingsCreateEmploymentType: _SalarySettingsCreateEmploymentType2.default,
	    TaggingFilter: _TaggingFilter2.default,
	    SalarySettingsUsersUser: _SalarySettingsUsersUser2.default
	  },
	  props: {
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      tags: [],
	      appliedFilters: [],
	      selectedUsers: [],
	      selectedEmployments: [],
	      isDropdown: false,
	      theEditUser: null,
	      theEditUserEmployment: null,
	      isAddEmploymentModal: false,
	      isCreateNewEmploymentTitle: false,
	      isManualSalary: false,
	      selectedOrganisations: []
	    };
	  },
	
	  computed: {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    isSubmittingUsers: function isSubmittingUsers() {
	      return this.$store.state.employments.isSubmittingUser;
	    },
	    employments: function employments() {
	      return this.$store.state.employments.employments;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    employmentsTypes: function employmentsTypes() {
	      return this.$store.state.employments.employmentsTypes;
	    },
	    employmentTypesSorted: function employmentTypesSorted() {
	      return this.$store.getters.employmentTypesActive;
	    },
	    employmentsTypesForDropdown: function employmentsTypesForDropdown() {
	      var _this = this;
	
	      return this.employmentTypesSorted.map(function (employmentType) {
	        return {
	          v_title: employmentType,
	          v_isSelected: _this.selectedEmployments.findIndex(function (selectedEmployment) {
	            return selectedEmployment === employmentType;
	          }) > -1
	        };
	      });
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    usersWithEmployments: function usersWithEmployments() {
	      var _this2 = this;
	
	      return this.users.map(function (user) {
	        var employments = _this2.employmentsInUserIdHash[user.id] ? _this2.employmentsInUserIdHash[user.id] : [];
	        var employmentsSorted = employments.sort(function (a, b) {
	          return a.title.localeCompare(b.title);
	        });
	        return (0, _extends3.default)({}, user, {
	          v_employments: employmentsSorted.filter(function (employment) {
	            return !employment.deleted;
	          }),
	          v_oldEmployments: employmentsSorted.filter(function (employment) {
	            return employment.deleted;
	          })
	        });
	      });
	    },
	    usersWithSelection: function usersWithSelection() {
	      var _this3 = this;
	
	      return this.usersWithEmployments.map(function (user) {
	        return (0, _extends3.default)({}, user, {
	          v_isSelected: _this3.selectedUsers.findIndex(function (selectedUser) {
	            return selectedUser.id === user.id;
	          }) > -1
	        });
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this4 = this;
	
	      if (this.appliedFilters.length < 1) {
	        return this.usersWithSelection;
	      }
	      return this.usersWithSelection.filter(function (user) {
	        return user.user_tags.some(function (tag) {
	          return _this4.appliedFilters.includes(tag);
	        });
	      });
	    }
	  },
	  methods: {
	    setIsManualSalary: function setIsManualSalary(bool) {
	      this.isManualSalary = bool;
	    },
	    setIsCreateNewEmploymentTitle: function setIsCreateNewEmploymentTitle(bool) {
	      this.isCreateNewEmploymentTitle = bool;
	      if (bool) {
	        this.setIsAddExistingEmploymentsToUsers(true);
	      }
	    },
	    setIsAddExistingEmploymentsToUsers: function setIsAddExistingEmploymentsToUsers(bool) {
	      this.isAddEmploymentModal = bool;
	      if (this.isCreateNewEmploymentTitle) {
	        this.selectedEmployments = [];
	      }
	      if (!bool) {
	        this.isManualSalary = false;
	        this.setIsCreateNewEmploymentTitle(false);
	      }
	    },
	    updateEmployment: function updateEmployment(employment) {
	      var _this5 = this;
	
	      var dbObj = {
	        schoolId: employment.school_id,
	        userId: employment.user_id,
	        employmentId: employment.id,
	        manualSalary: !employment.manual_salary,
	        defaultLoenart: employment.default_loenart ? employment.default_loenart * 1 : null,
	        defaultLoebenummer: employment.default_loebenummer ? employment.default_loebenummer * 1 : null
	      };
	      _docendo2.default.updateEmployment(dbObj.schoolId, dbObj.userId, dbObj.employmentId, dbObj.manualSalary, dbObj.defaultLoenart, dbObj.defaultLoebenummer, function (success) {
	        _this5.$store.dispatch('readEmployments');
	      }, function (failure) {
	        console.log('failure!');
	      });
	    },
	    setTheEditUserEmployment: function setTheEditUserEmployment(userAndEmployment) {
	      if (userAndEmployment.context === 'manual_salary') {
	        this.updateEmployment(userAndEmployment.employment);
	        return;
	      }
	      this.theEditUserEmployment = userAndEmployment.employment;
	      this.theEditUser = userAndEmployment.user;
	    },
	    setTheEditUser: function setTheEditUser(user) {
	      if (!user) {
	        this.theEditUserEmployment = null;
	      }
	      this.theEditUser = user;
	      this.$emit('setEditUser', user);
	    },
	    setIsDropdown: function setIsDropdown() {
	      if (!this.isDropdown) {
	        this.selectedEmployments = [];
	      }
	      this.isDropdown = !this.isDropdown;
	    },
	    saveForUsers: function saveForUsers(newEmploymentTitle) {
	      var _this6 = this;
	
	      if (this.selectedUsers.length < 1) {
	        return;
	      }
	      if (newEmploymentTitle) {
	        this.selectedEmployments.push(newEmploymentTitle);
	      }
	      if (this.selectedEmployments.length < 1) {
	        return;
	      }
	
	      var dbObj = {
	        schoolId: this.schoolId,
	        userIds: [],
	        employmentTypeIds: [],
	        isManualSalary: this.isManualSalary
	      };
	
	      var selectedEmploymentTypeIds = this.selectedEmployments.map(function (employment) {
	        return employment;
	      });
	      var usersWithEmployments = {};
	
	      this.selectedUsers.forEach(function (user) {
	        var userEmployments = user.v_employments.map(function (employment) {
	          return employment.title;
	        });
	
	        selectedEmploymentTypeIds.forEach(function (employmentTypeId) {
	          if (userEmployments.includes(employmentTypeId)) {
	            if (usersWithEmployments[employmentTypeId]) {
	              usersWithEmployments[employmentTypeId].push(user.id);
	            } else {
	              usersWithEmployments[employmentTypeId] = [user.id];
	            }
	          }
	        });
	      });
	
	      if ((0, _keys2.default)(usersWithEmployments).length === 0) {
	        dbObj.userIds = this.selectedUsers.map(function (user) {
	          return user.id;
	        });
	        dbObj.employmentTypeIds = selectedEmploymentTypeIds;
	        this.$emit('changedMade');
	        this.$store.dispatch('createEmployments', dbObj);
	        this.reset();
	      } else {
	        var numberOfUpdatesToCompleted = this.selectedEmployments.length;
	        var numberOfUpdates = 0;
	        this.selectedEmployments.forEach(function (selectedEmployment, key) {
	          var userIdsArr = usersWithEmployments[selectedEmployment] ? usersWithEmployments[selectedEmployment] : [];
	          var newUserIds = _this6.selectedUsers.filter(function (user) {
	            return !userIdsArr.includes(user.id);
	          }).map(function (user) {
	            return user.id;
	          });
	          if (newUserIds.length > 0) {
	            var newObj = {
	              schoolId: _this6.schoolId,
	              userIds: newUserIds,
	              employmentTypeIds: [selectedEmployment],
	              isManualSalary: _this6.isManualSalary
	            };
	            _this6.$emit('changedMade');
	            _this6.$store.dispatch('createEmployments', newObj);
	            numberOfUpdates++;
	            if (numberOfUpdates === numberOfUpdatesToCompleted) {
	              _this6.reset();
	            }
	          }
	        });
	      }
	    },
	    reset: function reset() {
	      this.selectedUsers = [];
	      this.selectedEmployments = [];
	      this.isDropdown = false;
	    },
	    selectedEmploymentsType: function selectedEmploymentsType(employmentsType) {
	      var idx = this.selectedEmployments.findIndex(function (selectedEmployment) {
	        return selectedEmployment === employmentsType;
	      });
	      if (idx < 0) {
	        this.selectedEmployments.push(employmentsType);
	      } else {
	        this.selectedEmployments.splice(idx, 1);
	      }
	    },
	    onClickAway: function onClickAway() {
	      if (!this.isDropdown) {
	        return;
	      }
	      this.selectedEmployments = [];
	      this.isDropdown = false;
	    },
	    toggleUser: function toggleUser(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser.id === user.id;
	      });
	      if (idx < 0) {
	        this.selectedUsers.push(user);
	      } else {
	        this.selectedUsers.splice(idx, 1);
	      }
	    },
	    toggleAll: function toggleAll() {
	      var _this7 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsers.forEach(function (user) {
	          return _this7.selectedUsers.push(user);
	        });
	      }
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.push(tag);
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	    },
	    readAllEmployments: function readAllEmployments() {
	      this.$store.dispatch('readEmploymentTypes');
	      this.$store.dispatch('readEmployments');
	    },
	    readTags: function readTags() {
	      var _this8 = this;
	
	      this.isLoadingTags = true;
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this8.tags = data;
	        _this8.isLoadingTags = false;
	      });
	    },
	    setTbodyMaxHeight: function setTbodyMaxHeight() {
	      var tbody = this.$refs['d-b'];
	      if (!tbody) {
	        return;
	      }
	      var tbodyTop = tbody.getBoundingClientRect().top;
	      var windowHeight = window.innerHeight;
	      var maxHeight = windowHeight - tbodyTop - 20;
	
	      tbody.style.maxHeight = maxHeight + 'px';
	    }
	  },
	  mounted: function mounted() {
	    this.readTags();
	    this.readAllEmployments();
	    this.setTbodyMaxHeight();
	    window.addEventListener('resize', this.setTbodyMaxHeight);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.setTbodyMaxHeight);
	  }
	};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _from = __webpack_require__(72);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _set = __webpack_require__(52);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SalarySettingsUsersOpusTable = __webpack_require__(324);
	
	var _SalarySettingsUsersOpusTable2 = _interopRequireDefault(_SalarySettingsUsersOpusTable);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { TaggingFilter: _TaggingFilter2.default, DoFiltersFilter: _DoFiltersFilter2.default, SalarySettingsUsersTable: _SalarySettingsUsersOpusTable2.default, Loader: _Loader2.default, DModal: _DModal2.default },
	  props: {
	    users: {
	      default: function _default() {
	        return [];
	      }
	    },
	    employments: {
	      default: function _default() {
	        return [];
	      }
	    },
	    tags: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      selectedOrganisations: [],
	      selectedTags: [],
	      selectedEmployments: []
	    };
	  },
	
	  computed: {
	    organisations: function organisations() {
	      var organisations = new _set2.default();
	      this.employments.forEach(function (employment) {
	        if (employment.organisation) {
	          organisations.add(employment.organisation);
	        }
	      });
	      return (0, _from2.default)(organisations).sort(function (a, b) {
	        return a.localeCompare(b, 'da-DK');
	      });
	    },
	    filteredEmployments: function filteredEmployments() {
	      var _this = this;
	
	      return this.employments.filter(function (employment) {
	        return _this.selectedOrganisations.length > 0 ? _this.selectedOrganisations.indexOf(employment.organisation) > -1 : true;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this2 = this;
	
	      var getEmploymentsForUser = function getEmploymentsForUser(userId) {
	        return _this2.filteredEmployments.filter(function (employment) {
	          return employment.user_id === userId;
	        });
	      };
	      return this.users.filter(function (user) {
	        if (_this2.selectedTags.length > 0) {
	          return user.user_tags.some(function (tag) {
	            return _this2.selectedTags.includes(tag);
	          });
	        } else {
	          return true;
	        }
	      }).map(function (user) {
	        return (0, _extends3.default)({}, user, {
	          v_employments: getEmploymentsForUser(user.id).sort(function (a, b) {
	            return a.title.localeCompare(b.title, 'da-DK');
	          })
	        });
	      });
	    }
	  },
	  methods: {
	    toggleTag: function toggleTag(tag) {
	      var idx = this.selectedTags.indexOf(tag);
	      if (idx > -1) {
	        this.selectedTags.splice(idx, 1);
	      } else {
	        this.selectedTags.push(tag);
	      }
	    },
	    selectedOrganisation: function selectedOrganisation(organisation) {
	      var idx = this.selectedOrganisations.indexOf(organisation);
	      if (idx > -1) {
	        this.selectedOrganisations.splice(idx, 1);
	      } else {
	        this.selectedOrganisations.push(organisation);
	      }
	    },
	    onClose: function onClose() {
	      this.$emit('close');
	    }
	  }
	};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default },
	  props: {
	    filteredUsers: {
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedUsers: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isShowNoEmploymentsText: {
	      type: Boolean,
	      default: false
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    setTheEditUser: function setTheEditUser(user) {
	      this.$emit('setTheEditUser', user);
	    },
	    toggleAll: function toggleAll() {
	      this.$emit('toggleAll');
	    },
	    toggleUser: function toggleUser(user) {
	      this.$emit('toggleUser', user);
	    },
	    setTbodyMaxHeight: function setTbodyMaxHeight() {
	      var tbody = this.$refs['d-b'];
	      var tbodyTop = tbody.getBoundingClientRect().top;
	      var windowHeight = window.innerHeight;
	      var maxHeight = windowHeight - tbodyTop - 20;
	
	      tbody.style.maxHeight = maxHeight + 'px';
	    }
	  },
	  mounted: function mounted() {
	    this.setTbodyMaxHeight();
	    window.addEventListener('resize', this.setTbodyMaxHeight);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.setTbodyMaxHeight);
	  }
	};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    theEditEmployment: {
	      type: Object,
	      default: null
	    },
	    school: {
	      type: Object,
	      default: null
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      theDeleteEmployment: null,
	      isShowOldEmployment: false,
	      theUpdatingEmployment: null,
	      employments: [],
	      isSaving: false
	    };
	  },
	
	  computed: {
	    filteredEmployment: function filteredEmployment() {
	      var _this = this;
	
	      return this.theEditEmployment ? this.employments.filter(function (employment) {
	        return employment.id === _this.theEditEmployment.id;
	      }) : this.employments;
	    }
	  },
	  methods: {
	    onChanged: function onChanged(employment) {
	      var idx = this.employments.findIndex(function (emp) {
	        return emp.id === employment.id;
	      });
	      if (idx > -1 && this.employments[idx].hasOwnProperty('v_has_error')) {
	        this.$delete(this.employments[idx], 'v_has_error');
	      }
	    },
	    setIsManualSalary: function setIsManualSalary(employment, bool) {
	      var idx = this.employments.findIndex(function (emp) {
	        return emp.id === employment.id;
	      });
	      if (idx > -1) {
	        this.employments[idx]['manual_salary'] = bool;
	        this.onChanged(this.employments[idx]);
	      }
	    },
	    setIsShowOldEmployment: function setIsShowOldEmployment() {
	      this.isShowOldEmployment = !this.isShowOldEmployment;
	    },
	    setDeleteEmployment: function setDeleteEmployment(employment) {
	      this.theDeleteEmployment = employment;
	    },
	    deleteEmployment: function deleteEmployment(employment) {
	      var dbObj = {
	        schoolId: employment.school_id,
	        userId: employment.user_id,
	        employmentId: employment.id
	      };
	      this.$store.dispatch('deleteEmployment', dbObj);
	      this.$emit('close');
	    },
	    archiveEmployment: function archiveEmployment(employment) {
	      var dbObj = {
	        schoolId: employment.school_id,
	        userId: employment.user_id,
	        employmentId: employment.id
	      };
	      this.$store.dispatch('deleteEmployment', dbObj);
	      this.$emit('close');
	    },
	    validate: function validate() {
	      var _this2 = this;
	
	      var isValidated = true;
	      var errors = [];
	
	      if (this.isSalaryIntegrationActive) {
	        this.employments.forEach(function (employment) {
	          if (employment.manual_salary) {
	            var missingFields = [];
	
	            if (employment.default_loenart === null || employment.default_loenart === '' || employment.default_loenart === undefined) {
	              missingFields.push('Lønart');
	            }
	
	            if (employment.default_loebenummer === null || employment.default_loebenummer === '' || employment.default_loebenummer === undefined) {
	              missingFields.push('Løbenummer');
	            } else {
	              var loebenummerValue = Number(employment.default_loebenummer);
	              if (loebenummerValue < 1 || loebenummerValue > 9 || isNaN(loebenummerValue)) {
	                errors.push('Ugyldigt l\xF8benummer for ' + (employment.name || 'ansat') + ' \u2013 skal v\xE6re mellem 1 og 9 eller tomt');
	                isValidated = false;
	                _this2.$set(employment, 'v_has_error', true);
	              }
	            }
	
	            if (missingFields.length > 0) {
	              errors.push('Manglende ' + missingFields.join(' og ') + ' for ' + (employment.name || 'ansat'));
	              isValidated = false;
	              _this2.$set(employment, 'v_has_error', true);
	            }
	          }
	        });
	      }
	
	      if (!isValidated) {
	        _eventbus2.default.toast = {
	          text: errors.length > 1 ? 'Flere fejl:\n' + errors.join('\n') : errors[0],
	          success: false
	        };
	      }
	
	      return isValidated;
	    },
	    saveChanges: function saveChanges() {
	      var _this3 = this;
	
	      if (!this.validate()) {
	        return;
	      }
	      this.isSaving = true;
	      var numberOfSaves = this.employments.length;
	      var saves = 0;
	      this.employments.forEach(function (employment, key) {
	        var dbObj = {
	          schoolId: employment.school_id,
	          userId: employment.user_id,
	          employmentId: employment.id,
	          manualSalary: employment.manual_salary,
	          defaultLoenart: employment.default_loenart ? employment.default_loenart * 1 : null,
	          defaultLoebenummer: employment.default_loebenummer ? employment.default_loebenummer * 1 : null
	        };
	        _docendo2.default.updateEmployment(dbObj.schoolId, dbObj.userId, dbObj.employmentId, dbObj.manualSalary, dbObj.defaultLoenart, dbObj.defaultLoebenummer, function (success) {
	          saves++;
	          if (numberOfSaves === saves) {
	            _this3.$store.dispatch('readEmployments');
	            _this3.$emit('close');
	          }
	        }, function (failure) {
	          console.log('failure!');
	        });
	      });
	    }
	  },
	  mounted: function mounted() {
	    var employments = JSON.parse((0, _stringify2.default)(this.user.v_employments));
	    this.employments = employments.sort(function (a, b) {
	      return a.title.localeCompare(b.title);
	    });
	  }
	};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vuedraggable = __webpack_require__(137);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUBJECTTYPES = ['subject', 'supplemental', 'additional_tasks', 'optional', 'frame', 'break', 'resource', 'person_resource', 'preparation', 'club'];
	
	exports.default = {
	  name: 'SalaryRules',
	  components: { draggable: _vuedraggable2.default },
	  props: {
	    propRules: {
	      type: Array,
	      default: null
	    },
	    schoolSubstituteRules: {
	      type: Object,
	      default: null
	    },
	    schoolIds: {
	      type: Array,
	      default: []
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      isConfirmDeletion: false,
	      isChangeHasBeenMade: false,
	      rules: [],
	      ruleTypes: [{
	        id: 1,
	        value: 'employment_type',
	        title: 'man er vikar for',
	        prop: 'substituted_employment_title'
	      }, {
	        id: 2,
	        value: 'subject_type',
	        title: 'briktypen er',
	        prop: 'subject_type'
	      }, {
	        id: 3,
	        value: 'subject_title',
	        title: 'brikken hedder',
	        prop: 'subject_title'
	      }, {
	        id: 4,
	        value: 'calendar_id',
	        title: 'kalenderen er',
	        prop: 'calendar_id'
	      }]
	    };
	  },
	
	  computed: {
	    calendars: function calendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    employmentTypesActive: function employmentTypesActive() {
	      return this.$store.getters.employmentTypesActive;
	    },
	    employmentToSelectForRules: function employmentToSelectForRules() {
	      return this.$store.getters.employmentToSelectForRules;
	    },
	    employmentsTypesForFullTime: function employmentsTypesForFullTime() {
	      return this.employmentTypesActive.filter(function (employmentType) {
	        return employmentType;
	      });
	    },
	    subjectTypes: function subjectTypes() {
	      var _this = this;
	
	      return SUBJECTTYPES.map(function (subjectType) {
	        return {
	          value: subjectType,
	          name: _this.$t('vue2.eventTypes.' + subjectType) !== 'vue2.eventTypes.' + subjectType ? _this.$t('vue2.eventTypes.' + subjectType) : subjectType
	        };
	      });
	    }
	  },
	  methods: {
	    onChange: function onChange() {
	      this.isChangeHasBeenMade = true;
	    },
	    validateArray: function validateArray(arr) {
	      if (!Array.isArray(arr)) {
	        return false;
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var obj = _step.value;
	
	          if (obj && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && !Array.isArray(obj)) {
	            for (var key in obj) {
	              if (obj[key] === null || obj[key] === '') {
	                return false;
	              }
	            }
	          } else {
	              return false;
	            }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return true;
	    },
	    onChangeRuleType: function onChangeRuleType(rule, val) {
	      var _this2 = this;
	
	      var ruleTypeProp = this.ruleTypes.find(function (ruleType) {
	        return ruleType.value === val;
	      })['prop'];
	      var idxOfRule = this.rules.findIndex(function (rulesRule) {
	        return rulesRule.id === rule.id;
	      });
	      delete this.rules[idxOfRule]['subject_type'];
	      delete this.rules[idxOfRule]['substituted_employment_title'];
	      delete this.rules[idxOfRule]['calendar_id'];
	      delete this.rules[idxOfRule]['subject_title'];
	      this.rules[idxOfRule][ruleTypeProp] = null;
	      this.onChange();
	
	      this.$nextTick(function () {
	        if (val === 'subject_title') {
	          var inputRef = _this2.$refs['subjectTitleInput' + rule.id];
	          if (inputRef) {
	            inputRef[0].focus();
	          }
	        }
	      });
	    },
	    setRoleToDelete: function setRoleToDelete(rule) {
	      var idx = this.rules.findIndex(function (item) {
	        return item.id === rule.id;
	      });
	      if (idx > -1) {
	        this.rules.splice(idx, 1);
	      }
	      this.onChange();
	    },
	    onChangeOrder: function onChangeOrder() {
	      this.onChange();
	    },
	    addNewRule: function addNewRule() {
	      var newRuleObj = {
	        id: this.generateUUID(),
	        type: 'employment_type',
	        substituted_employment_title: null,
	        selected_employment_title: null
	      };
	      this.rules.push(newRuleObj);
	      this.onChange();
	    },
	    submit: function submit() {
	      var _this3 = this;
	
	      if (!this.validateArray(this.rules)) {
	        _eventbus2.default.toast = { text: 'En regel må ikke indeholde tomme værdier', success: false };
	        return;
	      }
	
	      this.isSaving = true;
	
	      var dbRules = JSON.parse((0, _stringify2.default)(this.schoolSubstituteRules));
	
	      var extraTimeRules = this.propRules ? this.propRules.filter(function (item) {
	        return item.id.startsWith('_extra_time');
	      }) : [];
	
	      var combinedRules = [].concat((0, _toConsumableArray3.default)(extraTimeRules), (0, _toConsumableArray3.default)(this.rules));
	
	      if (!combinedRules || combinedRules.length === 0) {
	        delete dbRules.rules;
	      } else {
	        dbRules['rules'] = combinedRules;
	      }
	
	      this.$emit('changedMade');
	      _docendo2.default.updateSchool(this.schoolId, { substitute_rules: dbRules }, function (success) {
	        _eventbus2.default.toast = { text: 'Gemt', success: true };
	        _this3.isSaving = false;
	        _this3.isChangeHasBeenMade = false;
	        _this3.$store.commit('setActiveSchool', success);
	        _this3.$store.commit('setSchoolSettings', success.custom_data);
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    cancel: function cancel() {
	      this.$emit('close');
	    },
	    generateUUID: function generateUUID() {
	      var d = new Date().getTime();
	      var d2 = window.performance && window.performance.now && window.performance.now() * 1000 || 0;
	      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16;
	        if (d > 0) {
	          r = (d + r) % 16 | 0;
	          d = Math.floor(d / 16);
	        } else {
	          r = (d2 + r) % 16 | 0;
	          d2 = Math.floor(d2 / 16);
	        }
	        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
	      });
	    }
	  },
	  mounted: function mounted() {
	    if (this.propRules) {
	      this.rules = this.propRules.filter(function (item) {
	        return !item.id.startsWith('_extra_time');
	      });
	    }
	  }
	};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _SalaryRulesRule = __webpack_require__(120);
	
	var _SalaryRulesRule2 = _interopRequireDefault(_SalaryRulesRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SalaryRulesRule: _SalaryRulesRule2.default, AppToggle: _AppToggle2.default },
	  props: {
	    config: {
	      type: Object,
	      default: null
	    },
	    propRules: {
	      type: Array,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isOn: false,
	      minutes: 45,
	      subjectType: '_extra_time_between_events_',
	      selectedEmploymentTypeId: ''
	    };
	  },
	
	  computed: {
	    initMinutes: function initMinutes() {
	      return this.config && this.config.between_events && this.config.between_events.minutes;
	    },
	    initSelectedEmploymentTypeId: function initSelectedEmploymentTypeId() {
	      var _this = this;
	
	      if (!this.propRules) {
	        return '';
	      }
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this.subjectType;
	      });
	      if (idx < 0) {
	        return '';
	      }
	      return this.propRules[idx]['selected_employment_title'];
	    },
	    isChangesMade: function isChangesMade() {
	      if (this.isOn) {
	        return this.initMinutes !== this.minutes * 1 || this.initSelectedEmploymentTypeId !== this.selectedEmploymentTypeId;
	      } else {
	        return this.config && this.config.between_events;
	      }
	    }
	  },
	  methods: {
	    setRuleEmployment: function setRuleEmployment(selectedEmploymentTypeId) {
	      this.selectedEmploymentTypeId = selectedEmploymentTypeId;
	    },
	    newRulesArr: function newRulesArr() {
	      var _this2 = this;
	
	      if (!this.isOn || this.selectedEmploymentTypeId === '') {
	        return this.propRules.filter(function (item) {
	          return item.id !== _this2.subjectType;
	        });
	      }
	      var dbRules = JSON.parse((0, _stringify2.default)(this.propRules));
	      var idx = dbRules.findIndex(function (item) {
	        return item.id === _this2.subjectType;
	      });
	      if (idx < 0) {
	        var newRuleObj = {
	          id: this.subjectType,
	          type: 'subject_type',
	          subject_type: this.subjectType,
	          selected_employment_title: this.selectedEmploymentTypeId
	        };
	        dbRules.unshift(newRuleObj);
	      } else {
	        dbRules[idx].selected_employment_title = this.selectedEmploymentTypeId;
	      }
	      return dbRules;
	    },
	    setIsOn: function setIsOn() {
	      var _this3 = this;
	
	      this.isOn = !this.isOn;
	      if (this.isOn) {
	        this.$nextTick(function (_) {
	          _this3.$refs.input_number.focus();
	        });
	      }
	    },
	    onSubmit: function onSubmit() {
	      var dbConfig = JSON.parse((0, _stringify2.default)(this.config));
	      if (!this.isOn) {
	        delete dbConfig.between_events;
	      } else {
	        dbConfig.between_events = { minutes: this.minutes * 1 };
	      }
	      this.$emit('onSubmit', dbConfig, this.newRulesArr());
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    if (this.propRules) {
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this4.subjectType;
	      });
	      if (idx > -1) {
	        var employmentId = JSON.parse((0, _stringify2.default)(this.propRules[idx]['selected_employment_title']));
	        this.selectedEmploymentTypeId = employmentId;
	      }
	    }
	    if (this.config && this.config.between_events && this.config.between_events.minutes) {
	      var minutes = JSON.parse((0, _stringify2.default)(this.config.between_events.minutes * 1));
	      this.isOn = true;
	      this.minutes = minutes;
	    }
	  }
	};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _TimeInput = __webpack_require__(135);
	
	var _TimeInput2 = _interopRequireDefault(_TimeInput);
	
	var _SalaryRulesRule = __webpack_require__(120);
	
	var _SalaryRulesRule2 = _interopRequireDefault(_SalaryRulesRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SalaryRulesRule: _SalaryRulesRule2.default, TimeInput: _TimeInput2.default, AppToggle: _AppToggle2.default },
	  props: {
	    config: {
	      type: Object,
	      default: null
	    },
	    propRules: {
	      type: Array,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isOn: false,
	      minutes: 120,
	      subjectType: '_extra_time_if_shorter_than_',
	      selectedEmploymentTypeId: ''
	    };
	  },
	
	  computed: {
	    initMinutes: function initMinutes() {
	      return this.config && this.config.if_shorter_than && this.config.if_shorter_than.minutes;
	    },
	    initSelectedEmploymentTypeId: function initSelectedEmploymentTypeId() {
	      var _this = this;
	
	      if (!this.propRules) {
	        return '';
	      }
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this.subjectType;
	      });
	      if (idx < 0) {
	        return '';
	      }
	      return this.propRules[idx]['selected_employment_title'];
	    },
	    isChangesMade: function isChangesMade() {
	      if (this.isOn) {
	        return this.initMinutes !== this.minutes * 1 || this.initSelectedEmploymentTypeId !== this.selectedEmploymentTypeId;
	      } else {
	        return this.config && this.config.if_shorter_than;
	      }
	    }
	  },
	  methods: {
	    setRuleEmployment: function setRuleEmployment(selectedEmploymentTypeId) {
	      this.selectedEmploymentTypeId = selectedEmploymentTypeId;
	    },
	    newRulesArr: function newRulesArr() {
	      var _this2 = this;
	
	      if (!this.isOn || this.selectedEmploymentTypeId === '') {
	        return this.propRules.filter(function (item) {
	          return item.id !== _this2.subjectType;
	        });
	      }
	      var dbRules = JSON.parse((0, _stringify2.default)(this.propRules));
	      var idx = dbRules.findIndex(function (item) {
	        return item.id === _this2.subjectType;
	      });
	      if (idx < 0) {
	        var newRuleObj = {
	          id: this.subjectType,
	          type: 'subject_type',
	          subject_type: this.subjectType,
	          selected_employment_title: this.selectedEmploymentTypeId
	        };
	        dbRules.unshift(newRuleObj);
	      } else {
	        dbRules[idx].selected_employment_title = this.selectedEmploymentTypeId;
	      }
	      return dbRules;
	    },
	    setIsOn: function setIsOn() {
	      var _this3 = this;
	
	      this.isOn = !this.isOn;
	      if (this.isOn) {
	        this.$nextTick(function (_) {
	          _this3.$refs.input_number.focus();
	        });
	      }
	    },
	    onSubmit: function onSubmit() {
	      var dbConfig = JSON.parse((0, _stringify2.default)(this.config));
	      if (!this.isOn) {
	        delete dbConfig.if_shorter_than;
	      } else {
	        dbConfig.if_shorter_than = { minutes: this.minutes * 1 };
	      }
	      this.$emit('onSubmit', dbConfig, this.newRulesArr());
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    if (this.propRules) {
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this4.subjectType;
	      });
	      if (idx > -1) {
	        var employmentId = JSON.parse((0, _stringify2.default)(this.propRules[idx]['selected_employment_title']));
	        this.selectedEmploymentTypeId = employmentId;
	      }
	    }
	    if (this.config && this.config.if_shorter_than && this.config.if_shorter_than.minutes) {
	      this.isOn = true;
	      this.minutes = JSON.parse((0, _stringify2.default)(this.config.if_shorter_than.minutes * 1));
	    }
	  }
	};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _SalaryRulesRule = __webpack_require__(120);
	
	var _SalaryRulesRule2 = _interopRequireDefault(_SalaryRulesRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SalaryRulesRule: _SalaryRulesRule2.default, AppToggle: _AppToggle2.default },
	  props: {
	    config: {
	      type: Object,
	      default: null
	    },
	    propRules: {
	      type: Array,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isOn: false,
	      atStartOfDay: [],
	      subjectType: '_extra_time_at_start_of_day_',
	      selectedEmploymentTitle: '',
	      isChangesMade: false
	    };
	  },
	
	  methods: {
	    updateTime: function updateTime(event, index) {
	      this.atStartOfDay[index].time = event.target.value;
	      this.isChangesMade = true;
	    },
	    updateMinutes: function updateMinutes(event, index) {
	      this.atStartOfDay[index].minutes = parseInt(event.target.value, 10) || 0;
	      this.isChangesMade = true;
	    },
	    setRuleEmployment: function setRuleEmployment(selectedEmploymentTitle) {
	      this.selectedEmploymentTitle = selectedEmploymentTitle;
	      this.isChangesMade = true;
	    },
	    newRulesArr: function newRulesArr() {
	      var _this = this;
	
	      if (!this.isOn || this.selectedEmploymentTitle === '') {
	        return this.propRules.filter(function (item) {
	          return item.id !== _this.subjectType;
	        });
	      }
	      var dbRules = JSON.parse((0, _stringify2.default)(this.propRules));
	      var idx = dbRules.findIndex(function (item) {
	        return item.id === _this.subjectType;
	      });
	      if (idx < 0) {
	        var newRuleObj = {
	          id: this.subjectType,
	          type: 'subject_type',
	          subject_type: this.subjectType,
	          selected_employment_title: this.selectedEmploymentTitle
	        };
	        dbRules.unshift(newRuleObj);
	      } else {
	        dbRules[idx].selected_employment_title = this.selectedEmploymentTitle;
	      }
	      return dbRules;
	    },
	    setIsOn: function setIsOn() {
	      this.isOn = !this.isOn;
	      this.isChangesMade = true;
	      if (this.atStartOfDay.length === 0) {
	        this.atStartOfDay.push({ time: '08:00', minutes: 10 });
	      }
	    },
	    addTime: function addTime() {
	      this.atStartOfDay.push({ time: '08:00', minutes: 10 });
	      this.isChangesMade = true;
	    },
	    deleteItem: function deleteItem(idx) {
	      this.atStartOfDay.splice(idx, 1);
	      this.isChangesMade = true;
	      if (this.atStartOfDay.length === 0) {
	        this.isOn = false;
	      }
	    },
	    onSubmit: function onSubmit() {
	      var dbConfig = JSON.parse((0, _stringify2.default)(this.config));
	
	      if (!this.isOn) {
	        delete dbConfig.at_start_of_day;
	      } else {
	        dbConfig.at_start_of_day = this.atStartOfDay;
	      }
	      this.$emit('onSubmit', dbConfig, this.newRulesArr());
	      this.isChangesMade = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (this.propRules) {
	      var idx = this.propRules.findIndex(function (item) {
	        return item.id === _this2.subjectType;
	      });
	      if (idx > -1) {
	        this.selectedEmploymentTitle = JSON.parse((0, _stringify2.default)(this.propRules[idx]['selected_employment_title']));
	      }
	    }
	    if (this.config && this.config.at_start_of_day) {
	      this.isOn = true;
	      this.atStartOfDay = JSON.parse((0, _stringify2.default)(Array.isArray(this.config.at_start_of_day) ? this.config.at_start_of_day : [this.config.at_start_of_day]));
	    } else {
	      this.atStartOfDay = [{ time: '08:00', minutes: 10 }];
	    }
	  }
	};

/***/ }),
/* 566 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    subjectType: {
	      default: '_extra_time_if_shorter_than_'
	    },
	    propSelectedEmploymentTypeId: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      selectedEmploymentTitle: this.propSelectedEmploymentTypeId
	    };
	  },
	
	  computed: {
	    employmentToSelectForRules: function employmentToSelectForRules() {
	      if (this.subjectType === '_extra_time_at_start_of_day_') {
	        return this.$store.getters.employmentToSelectForRules.filter(function (title) {
	          return title !== '*Stillingen fra lektionen før*';
	        });
	      }
	      if (this.subjectType === '_extra_time_if_shorter_than_') {
	        return this.$store.getters.employmentToSelectForRules.filter(function (title) {
	          return title !== '*Stillingen fra lektionen efter*';
	        });
	      }
	      return this.$store.getters.employmentToSelectForRules;
	    }
	  },
	  watch: {
	    propSelectedEmploymentTypeId: function propSelectedEmploymentTypeId(newVal) {
	      this.selectedEmploymentTitle = newVal;
	    }
	  },
	  methods: {
	    onChange: function onChange(val) {
	      this.selectedEmploymentTitle = val;
	      this.$emit('change', val);
	    }
	  },
	  mounted: function mounted() {
	    this.selectedEmploymentTitle = this.propSelectedEmploymentTypeId;
	  }
	};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(38);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(37);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _SalarySettings = __webpack_require__(1312);
	
	var _SalarySettings2 = _interopRequireDefault(_SalarySettings);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DoDatePickerRange = __webpack_require__(134);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	var _SalarySubsPerfUserDay = __webpack_require__(326);
	
	var _SalarySubsPerfUserDay2 = _interopRequireDefault(_SalarySubsPerfUserDay);
	
	var _SchoolsSelector = __webpack_require__(1396);
	
	var _SchoolsSelector2 = _interopRequireDefault(_SchoolsSelector);
	
	var _SalarySubsPerfUser = __webpack_require__(1321);
	
	var _SalarySubsPerfUser2 = _interopRequireDefault(_SalarySubsPerfUser);
	
	var _SalaryFilters = __webpack_require__(323);
	
	var _SalaryFilters2 = _interopRequireDefault(_SalaryFilters);
	
	var _SalarySubsPerfUserTable = __webpack_require__(327);
	
	var _SalarySubsPerfUserTable2 = _interopRequireDefault(_SalarySubsPerfUserTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SalarySubsPerfUserTable: _SalarySubsPerfUserTable2.default,
	    SalaryFilters: _SalaryFilters2.default,
	    SalarySubsPerfUser: _SalarySubsPerfUser2.default,
	    SchoolsSelector: _SchoolsSelector2.default,
	    SalarySubsPerfUserDay: _SalarySubsPerfUserDay2.default, DoDatePickerRange: _DoDatePickerRange2.default, Loader: _Loader2.default, SalarySettings: _SalarySettings2.default, Datepickerrange: _DatePickerRange2.default
	  },
	  data: function data() {
	    return {
	      permission: 'can_manage_salary',
	      startDate: (0, _moment2.default)(this.date).startOf('month').startOf('day'),
	      endDate: (0, _moment2.default)(this.date).endOf('month').endOf('day'),
	      isLoading: false,
	      usersAndEvents: [],
	      isShowSalarySettings: false,
	      activeFilter: 'draft',
	      theActiveUserDay: null,
	      isInitialLoad: true,
	      theUserDaySubmitting: null,
	      schoolIdsWithSchoolSelector: [7272, 60494],
	      selectedSchoolIds: [],
	      isSchoolSelectorOn: false,
	      activeUserId: null,
	      salaryCodes: [{ title: 'Timelønnet pædagogmedhjælper', code: 2322 }, { title: 'Vikar, ikke uddannet', code: 1212 }],
	      loebenummer: [0, 1, 2, 3, 4, 5]
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    isSalaryIntegrationActive: function isSalaryIntegrationActive() {
	      return this.school && this.school.features && this.school.features.includes('kmd_opus_integration');
	    },
	    costCenters: function costCenters() {
	      var centers = this.schoolSettings && this.schoolSettings.kmd_opus_cost_centers;
	      if (!centers) return [];
	
	      return (0, _entries2.default)(centers).map(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            title = _ref2[0],
	            code = _ref2[1];
	
	        return {
	          title: title,
	          code: code };
	      });
	    },
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSchools: function userSchools() {
	      return this.user && this.user.schools ? this.user.schools : [];
	    },
	    userMemberships: function userMemberships() {
	      return this.$store.getters.userSchools;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    dateShortCuts: function dateShortCuts() {
	      var custom = [{
	        title: 'Denne måned',
	        startDate: (0, _moment2.default)(this.date).startOf('month'),
	        endDate: (0, _moment2.default)(this.date).endOf('month')
	      }, {
	        title: 'Sidste måned',
	        startDate: (0, _moment2.default)(this.date).subtract(1, 'month').startOf('month'),
	        endDate: (0, _moment2.default)(this.date).subtract(1, 'month').endOf('month')
	      }];
	      return custom;
	    },
	    dbStartDate: function dbStartDate() {
	      return (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	    },
	    dbEndDate: function dbEndDate() {
	      return (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	    },
	    usersAndEventsWithOnlyNewestEvent: function usersAndEventsWithOnlyNewestEvent() {
	      var filteredDays = [];
	      this.usersAndEvents.forEach(function (userDay) {
	        var idx = filteredDays.findIndex(function (day) {
	          return day.user_id === userDay.user_id && day.day === userDay.day;
	        });
	        if (idx < 0) {
	          filteredDays.push(userDay);
	        } else {
	          if (filteredDays[idx].id < userDay.id) {
	            filteredDays.splice(idx, 1);
	            filteredDays.push(userDay);
	          }
	        }
	      });
	      return filteredDays;
	    },
	    userDaysSorted: function userDaysSorted() {
	      return this.usersAndEventsWithOnlyNewestEvent.sort(function (a, b) {
	        return (0, _moment2.default)(a.day).unix() - (0, _moment2.default)(b.day).unix();
	      });
	    },
	    userDaysDrafts: function userDaysDrafts() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'draft';
	      });
	    },
	    userDaysApproved: function userDaysApproved() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'approved';
	      });
	    },
	    userDaysSent: function userDaysSent() {
	      return this.userDaysSorted.filter(function (userDay) {
	        return userDay.state === 'sent';
	      });
	    },
	    usersAndEventsFiltered: function usersAndEventsFiltered() {
	      if (this.activeFilter === 'draft') {
	        return this.userDaysDrafts;
	      } else if (this.activeFilter === 'approved') {
	        return this.userDaysApproved;
	      } else if (this.activeFilter === 'sent') {
	        return this.userDaysSent;
	      }
	    },
	    usersPackedInDays: function usersPackedInDays() {
	      var _this = this;
	
	      var subs = [];
	
	      this.usersAndEventsFiltered.forEach(function (userAndDay) {
	        var userEmployments = _this.getUserEmployments(userAndDay.user_id);
	
	        var startEvent = userAndDay.events[0];
	        var endEvent = userAndDay.events[userAndDay.events.length - 1];
	        var userDayDateFormatted = (0, _moment2.default)(startEvent.start).format('ddd') + ', ' + (0, _moment2.default)(startEvent.start).format('LL') + ', kl. ' + (0, _moment2.default)(startEvent.start).format('LT') + ' - ' + (0, _moment2.default)(endEvent.end).format('LT');
	        userAndDay.v_date_formatted = userDayDateFormatted;
	        userAndDay.v_unfilled = (0, _keys2.default)(userAndDay.sums).some(function (key) {
	          return key === '';
	        });
	
	        var sums = userAndDay.sums;
	
	        if (sums && (typeof sums === 'undefined' ? 'undefined' : (0, _typeof3.default)(sums)) === 'object' && (0, _keys2.default)(sums).length > 0) {
	          userAndDay.v_sums = (0, _keys2.default)(sums).map(function (key) {
	            var employment = userEmployments.find(function (employment) {
	              return employment.id === key * 1;
	            });
	            return {
	              employment_not_set: !employment,
	              employment_id: key,
	              employment_title: employment && employment.title ? employment.title : 'Ikke sat',
	              minutes: sums[key],
	              minutes_humanized: _this.getHumanizeMinutes(sums[key]),
	              minutes_to_copy: _this.getSumTopCopy(sums[key])
	            };
	          });
	        } else {
	          userAndDay.v_sums = [];
	        }
	
	        var updateUserSums = function updateUserSums(currentSumArr, newSumArr) {
	          var arr = currentSumArr;
	          newSumArr.forEach(function (item) {
	            var idx = arr.findIndex(function (currentItem) {
	              return currentItem.employment_id === item.employment_id;
	            });
	            if (idx < 0) {
	              arr.push((0, _extends3.default)({}, item));
	            } else {
	              arr[idx]['minutes'] += item.minutes * 1;
	              arr[idx]['minutes_humanized'] = _this.getHumanizeMinutes(arr[idx]['minutes']);
	              arr[idx]['minutes_to_copy'] = _this.getSumTopCopy(arr[idx]['minutes']);
	            }
	          });
	          return arr;
	        };
	
	        var idx = subs.findIndex(function (sub) {
	          return sub.user_id === userAndDay.user_id;
	        });
	        if (idx < 0) {
	          subs.push({
	            user_id: userAndDay.user_id,
	            days: [userAndDay],
	            v_user_name: userAndDay.name,
	            v_user_employments: userEmployments,
	            v_user_active_employments: userEmployments.filter(function (employment) {
	              return !employment.deleted && employment.manual_salary;
	            }),
	            v_user_sums: JSON.parse((0, _stringify2.default)(userAndDay.v_sums))
	          });
	        } else {
	          subs[idx].days.push(userAndDay);
	          subs[idx].v_user_sums = updateUserSums(subs[idx].v_user_sums, userAndDay.v_sums);
	        }
	      });
	
	      return subs;
	    },
	    usersPackedInDaysWithProps: function usersPackedInDaysWithProps() {
	      var _this2 = this;
	
	      return this.usersPackedInDays.map(function (user) {
	        return (0, _extends3.default)({}, user, {
	          days: user.days.map(function (userAndDay) {
	            return (0, _extends3.default)({}, userAndDay, {
	              v_is_open: _this2.getIsTheActiveUserDay(userAndDay)
	            });
	          })
	        });
	      }).sort(function (a, b) {
	        return a.v_user_name.localeCompare(b.v_user_name);
	      });
	    },
	    localStorageKey: function localStorageKey() {
	      return 'do_salary_subs_schools_' + this.schoolId;
	    }
	  },
	  watch: {
	    user: function user(newVal, oldVal) {
	      if (newVal !== oldVal) {
	        this.getSavedSchoolIdsAndCheckForPermission();
	      }
	    }
	  },
	  methods: {
	    parseUserErrors: function parseUserErrors(errors) {
	      if (!errors || (typeof errors === 'undefined' ? 'undefined' : (0, _typeof3.default)(errors)) !== 'object') return [];
	
	      var errorMessages = [];
	
	      (0, _keys2.default)(errors).forEach(function (key) {
	        var errorList = errors[key];
	        if (Array.isArray(errorList)) {
	          errorList.forEach(function (error) {
	            var message = key + ': "' + error.Tekst + '" (Kode: ' + error.Kode + ', Type: ' + error.Type + ')';
	            errorMessages.push(message);
	          });
	        }
	      });
	
	      return errorMessages;
	    },
	    hideTippy: function hideTippy(tippyEl) {
	      setTimeout(function (_) {
	        tippyEl.hide();
	      }, 1000);
	    },
	    copyToClipboard: function copyToClipboard(val, evt) {
	      navigator.clipboard.writeText(val.toString()).then(function (_) {
	        evt.target._tippy.show();
	      }, function (_) {
	        console.log('that totally failed');
	      });
	    },
	    setActiveUserId: function setActiveUserId(userId) {
	      this.activeUserId = userId;
	      var body = document.querySelector('body');
	      if (userId) {
	        body.classList.add('no-scroll');
	      } else {
	        body.classList.remove('no-scroll');
	      }
	    },
	    getHasPermission: function getHasPermission(schoolId) {
	      var schoolMember = this.userMemberships[schoolId];
	      if (!schoolMember) {
	        return false;
	      }
	      return schoolMember['permissions'].indexOf(this.permission) > -1;
	    },
	    toggleSchool: function toggleSchool(school) {
	      var _this3 = this;
	
	      this.usersAndEvents = [];
	      var idx = this.selectedSchoolIds.indexOf(school.id);
	      if (idx < 0) {
	        this.selectedSchoolIds.push(school.id);
	      } else {
	        this.selectedSchoolIds.splice(idx, 1);
	      }
	      var selectedSchoolIdsWithoutActiveSchoolId = this.selectedSchoolIds.filter(function (schoolId) {
	        return schoolId !== _this3.schoolId;
	      });
	      if (selectedSchoolIdsWithoutActiveSchoolId.length > 0) {
	        this.$helpers.setLocalStorage(this.localStorageKey, (0, _stringify2.default)(this.selectedSchoolIds));
	      } else {
	        this.$helpers.removeLocalStorage(this.localStorageKey);
	      }
	      if (this.selectedSchoolIds.length > 0) {
	        this.readSalary();
	      }
	    },
	    setIsSubmitting: function setIsSubmitting(userDay) {
	      if (!userDay) {
	        this.theUserDaySubmitting = null;
	      } else {
	        this.theUserDaySubmitting = userDay.day_id;
	      }
	    },
	    getIsSubmitting: function getIsSubmitting(userDay) {
	      return this.theUserDaySubmitting === userDay.day_id;
	    },
	    updatePropOnLesson: function updatePropOnLesson(obj) {
	      var idx = this.usersAndEvents.findIndex(function (userDay) {
	        return userDay.day_id === obj.userDay.day_id;
	      });
	
	      if (idx < 0) {
	        return;
	      }
	      var eventIdx = this.usersAndEvents[idx]['events'].findIndex(function (event) {
	        return event.event_id === obj.event.event_id;
	      });
	
	      if (eventIdx < 0) {
	        return;
	      }
	      this.usersAndEvents[idx]['events'][eventIdx][obj.propToUpdate] = obj.val * 1;
	      if (this.isSalaryIntegrationActive && obj.propToUpdate === 'employment_id') {
	        var userEmployment = obj.user.v_user_employments.find(function (employment) {
	          return employment.id === Number(obj.val);
	        });
	        if (userEmployment) {
	          if (userEmployment.default_loebenummer) {
	            this.usersAndEvents[idx].events[eventIdx].loebenummer = Number(userEmployment.default_loebenummer);
	          }
	          if (userEmployment.default_loenart) {
	            this.usersAndEvents[idx].events[eventIdx].loenart = Number(userEmployment.default_loenart);
	          }
	        }
	      }
	      this.saveDay(this.usersAndEvents[idx]);
	    },
	    saveDay: function saveDay(userDay) {
	      var _this4 = this;
	
	      _docendo2.default.salaryDayUpdate(this.schoolId, this.selectedSchoolIds, userDay, function (success) {
	        _this4.setIsSubmitting(null);
	        var days = success && success.days ? success.days : [];
	        days.forEach(function (userDaySuccess) {
	          var idx = _this4.usersAndEvents.findIndex(function (userDay) {
	            return userDay.day_id === userDaySuccess.day_id;
	          });
	          if (idx > -1) {
	            _this4.$set(_this4.usersAndEvents, idx, userDaySuccess);
	          }
	        });
	      });
	    },
	    changeStateIsSent: function changeStateIsSent(userDay) {
	      this.setIsSubmitting(userDay);
	      var updatedUserDay = JSON.parse((0, _stringify2.default)(userDay));
	      updatedUserDay['state'] = 'sent';
	      this.saveDay(updatedUserDay);
	    },
	    unApproveDay: function unApproveDay(userDay) {
	      this.setIsSubmitting(userDay);
	      var updatedUserDay = JSON.parse((0, _stringify2.default)(userDay));
	      updatedUserDay['state'] = 'draft';
	      this.saveDay(updatedUserDay);
	    },
	    approveDay: function approveDay(userDay) {
	      this.setIsSubmitting(userDay);
	      var updatedUserDay = JSON.parse((0, _stringify2.default)(userDay));
	      updatedUserDay['state'] = 'approved';
	      this.saveDay(updatedUserDay);
	    },
	    getHumanizeMinutes: function getHumanizeMinutes(data) {
	      var totalMinutes = data;
	      var hours = Math.floor(totalMinutes / 60);
	      var minutes = totalMinutes % 60;
	      var hoursTitle = hours === 1 ? 'time' : 'timer';
	      return '(' + hours + ' ' + hoursTitle + ' ' + minutes + ' ' + 'min)' + ' - ' + (totalMinutes / 60).toFixed(2) + ' timer';
	    },
	    getSumTopCopy: function getSumTopCopy(totalMinutes) {
	      return (totalMinutes / 60).toFixed(2);
	    },
	    getIsDayValidated: function getIsDayValidated(userAndDay) {
	      return !userAndDay.events.every(function (event) {
	        return event.employment_id;
	      });
	    },
	    getUserEmployments: function getUserEmployments(userId) {
	      return this.employmentsInUserIdHash[userId] ? this.employmentsInUserIdHash[userId] : [];
	    },
	    getIsTheActiveUserDay: function getIsTheActiveUserDay(userDay) {
	      return this.theActiveUserDay === userDay.day_id;
	    },
	    setTheActiveUserDay: function setTheActiveUserDay(userDay) {
	      this.theActiveUserDay = this.theActiveUserDay === userDay.day_id ? null : userDay.day_id;
	    },
	    setFilter: function setFilter(filter) {
	      this.activeFilter = filter;
	    },
	    setIsShowSalarySettings: function setIsShowSalarySettings(bool) {
	      this.isShowSalarySettings = bool;
	    },
	    startDateChanged: function startDateChanged(date) {
	      this.startDate = date;
	      if (!this.isInitialLoad) {
	        this.readSalary();
	      }
	    },
	    endDateChanged: function endDateChanged(date) {
	      this.endDate = date;
	      if (!this.isInitialLoad) {
	        this.readSalary();
	      }
	    },
	    onUpdate: function onUpdate() {
	      this.readSalary();
	    },
	    readSalary: function readSalary() {
	      var _this5 = this;
	
	      if (this.selectedSchoolIds.length < 1) {
	        this.usersAndEvents = [];
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.salaryDays(this.schoolId, this.selectedSchoolIds, this.dbStartDate, this.dbEndDate, function (success) {
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          _this5.isLoading = false;
	          return;
	        }
	        _this5.usersAndEvents = success.days;
	        _this5.isLoading = false;
	        if (_this5.isInitialLoad) {
	          _this5.isInitialLoad = false;
	        }
	      }, function (failure) {
	        _eventbus2.default.toast = { text: failure, success: false };
	        _this5.isLoading = false;
	      });
	    },
	    getSavedSchoolIdsAndCheckForPermission: function getSavedSchoolIdsAndCheckForPermission() {
	      var _this6 = this;
	
	      if (!this.isUserLoaded) {
	        return;
	      }
	
	      var localStorageSelectedSchoolIds = this.$helpers.getLocalStorage(this.localStorageKey);
	      var selectedSchoolIds = [];
	      if (localStorageSelectedSchoolIds) {
	        try {
	          var parsedSchoolIds = JSON.parse(localStorageSelectedSchoolIds);
	          parsedSchoolIds.forEach(function (schoolId) {
	            if (_this6.getHasPermission(schoolId) && !selectedSchoolIds.includes(schoolId)) {
	              selectedSchoolIds.push(schoolId);
	            }
	          });
	          var selectedSchoolIdsWithoutActiveSchoolId = selectedSchoolIds.filter(function (schoolId) {
	            return schoolId !== _this6.schoolId;
	          });
	
	          if (selectedSchoolIdsWithoutActiveSchoolId.length > 0) {
	            this.$helpers.setLocalStorage(this.localStorageKey, (0, _stringify2.default)(selectedSchoolIds));
	          } else {
	            this.$helpers.removeLocalStorage(this.localStorageKey);
	          }
	
	          if (selectedSchoolIdsWithoutActiveSchoolId.length === 0) {
	            this.selectedSchoolIds = [this.schoolId];
	          } else {
	            this.selectedSchoolIds = selectedSchoolIds;
	          }
	
	          this.readSalary();
	        } catch (e) {
	          console.error('Error parsing localStorage data', e);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readEmployments');
	    if (this.schoolIdsWithSchoolSelector.includes(this.schoolId)) {
	      this.isSchoolSelectorOn = true;
	    } else {
	      this.$helpers.removeLocalStorage(this.localStorageKey);
	    }
	
	    var localStorageSelectedSchoolIds = this.$helpers.getLocalStorage(this.localStorageKey);
	
	    if (!localStorageSelectedSchoolIds) {
	      this.selectedSchoolIds = [this.schoolId];
	      this.readSalary();
	    } else {
	      this.getSavedSchoolIdsAndCheckForPermission();
	    }
	  }
	};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SalarySubsPerfUserDay = __webpack_require__(326);
	
	var _SalarySubsPerfUserDay2 = _interopRequireDefault(_SalarySubsPerfUserDay);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SalaryFilters = __webpack_require__(323);
	
	var _SalaryFilters2 = _interopRequireDefault(_SalaryFilters);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SalarySubsPerfUserTable = __webpack_require__(327);
	
	var _SalarySubsPerfUserTable2 = _interopRequireDefault(_SalarySubsPerfUserTable);
	
	var _SalarySubsPerfUserOpusModal = __webpack_require__(1322);
	
	var _SalarySubsPerfUserOpusModal2 = _interopRequireDefault(_SalarySubsPerfUserOpusModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SalarySubsPerfUserOpusModal: _SalarySubsPerfUserOpusModal2.default,
	    SalarySubsPerfUserTable: _SalarySubsPerfUserTable2.default, Loader: _Loader2.default, SalaryFilters: _SalaryFilters2.default, SalarySubsPerfUserDay: _SalarySubsPerfUserDay2.default, DModal: _DModal2.default
	  },
	  props: {
	    usersPackedInDaysWithProps: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    activeUserId: {
	      default: null
	    },
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)().startOf('month');
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().endOf('month');
	      }
	    },
	    schoolId: {
	      default: null
	    },
	    activeFilter: {
	      default: 'draft'
	    },
	    theUserDaySubmitting: {},
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    salaryCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    loebenummer: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    costCenters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isShowUserTable: false,
	      activeOpusUser: null
	    };
	  },
	
	  computed: {
	    user: function user() {
	      var _this = this;
	
	      return this.usersPackedInDaysWithProps.find(function (user) {
	        return user.user_id === _this.activeUserId;
	      }) ? this.usersPackedInDaysWithProps.find(function (user) {
	        return user.user_id === _this.activeUserId;
	      }) : null;
	    },
	    userName: function userName() {
	      return this.user && this.user.v_user_name ? this.user.v_user_name : '';
	    },
	    titleOfPeriod: function titleOfPeriod() {
	      return (0, _moment2.default)(this.startDate).format('LL') + ' - ' + (0, _moment2.default)(this.endDate).format('LL');
	    },
	    title: function title() {
	      switch (this.activeFilter) {
	        case 'draft':
	          return 'Efterbehandling';
	        case 'approved':
	          return 'Godkendt';
	        case 'sent':
	          return this.isSalaryIntegrationActive ? 'Sendt til lønsystem' : 'Er indberettet';
	      }
	    }
	  },
	  methods: {
	    setActiveOpusUser: function setActiveOpusUser(user) {
	      this.activeOpusUser = user;
	    },
	    getIsSubmitting: function getIsSubmitting(userDay) {
	      return this.theUserDaySubmitting === userDay.day_id;
	    },
	    getIsDayValidated: function getIsDayValidated(userAndDay) {
	      return !userAndDay.events.every(function (event) {
	        return event.employment_id;
	      });
	    },
	    print: function print() {
	      var fileTitle = 'Vikarløn Efterbehandling ' + this.userName + ' - ' + (0, _moment2.default)(this.startDate).format('DD-MM-YYYY') + '_' + (0, _moment2.default)(this.endDate).format('DD-MM-YYYY') + ' • docendo.dk';
	
	      var prtHtml = document.getElementById('printUserSalary').innerHTML;
	
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + fileTitle + '</title>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	      var afterPrint = function afterPrint() {
	        WinPrint.close();
	      };
	      WinPrint.onafterprint = afterPrint;
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	      }, 1000);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.isLoading = true;
	    setTimeout(function (_) {
	      _this2.isLoading = false;
	    }, 500);
	  }
	};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    user: {
	      type: Object
	    },
	    userDay: {
	      type: Object
	    },
	    isSalaryIntegrationActive: {
	      type: Boolean,
	      default: false
	    },
	    salaryCodes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    loebenummer: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    costCenters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    events: function events() {
	      var _this = this;
	
	      return this.userDay.events.map(function (event) {
	        var userEmployments = _this.user.v_user_employments;
	        return (0, _extends3.default)({}, event, {
	          v_is_special: event.event_type.startsWith('_extra_time_'),
	          v_start_and_endtime: (0, _moment2.default)(event.start).format('LT') + ' - ' + (0, _moment2.default)(event.end).format('LT'),
	          v_calendar_name: event.calendars ? _this.getCalendarName(event) : '',
	          v_substitute_for_employments: event.substitute_for_user_id ? _this.getSubstituteForEmployments(event.substitute_for_user_id) : [],
	          v_substitute_for_name: event.substitute_for_user_id && _this.allUsersInHash[event.substitute_for_user_id] ? _this.allUsersInHash[event.substitute_for_user_id]['name'] : '',
	          v_event_type_name: _this.getExtraEventTitle(event.event_type) || (_this.$t('vue2.eventTypes.' + event.event_type) !== 'vue2.eventTypes.' + event.event_type ? _this.$t('vue2.eventTypes.' + event.event_type) : event.event_type),
	          v_employment_id_title: event.employment_id ? userEmployments.find(function (userEmployment) {
	            return userEmployment.id === event.employment_id;
	          }) ? userEmployments.find(function (userEmployment) {
	            return userEmployment.id === event.employment_id;
	          })['title'] : event.employment_id : 'Ingen valgt'
	        });
	      });
	    },
	    employmentsInUserIdHash: function employmentsInUserIdHash() {
	      return this.$store.getters.employmentsInUserIdHash;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    }
	  },
	  methods: {
	    validateLoebenummer: function validateLoebenummer(user, userDay, event, value) {
	      if (value === '' || value === null) {
	        event.loebenummer = null;
	      } else {
	        var newValue = Number(value);
	
	        if (newValue < 1) newValue = 1;
	        if (newValue > 9) newValue = 9;
	
	        event.loebenummer = newValue;
	      }
	      this.updatePropOnLesson('loebenummer', user, userDay, event, event.loebenummer);
	    },
	    updatePropOnLesson: function updatePropOnLesson(propToUpdate, user, userDay, event, val) {
	      var obj = { propToUpdate: propToUpdate, user: user, userDay: userDay, event: event, val: val };
	      this.$emit('updatePropOnLesson', obj);
	    },
	    getCalendarName: function getCalendarName(event) {
	      var calendar = event.calendars ? event.calendars.find(function (calEvent) {
	        return calEvent.calendar_id === event.calendar_id;
	      }) : null;
	      return calendar ? calendar.name : '';
	    },
	    getSubstituteForEmployments: function getSubstituteForEmployments(substituteForUserId) {
	      return this.getUserEmployments(substituteForUserId).map(function (employment) {
	        return employment.title;
	      });
	    },
	    getUserEmployments: function getUserEmployments(userId) {
	      return this.employmentsInUserIdHash[userId] ? this.employmentsInUserIdHash[userId] : [];
	    },
	    getExtraEventTitle: function getExtraEventTitle(eventTitle) {
	      var obj = {
	        _extra_time_at_start_of_day_: 'Ekstra tid',
	        _extra_time_if_shorter_than_: 'Ekstra tid',
	        _extra_time_between_events_: 'Ekstra tid'
	      };
	      return obj[eventTitle];
	    }
	  }
	};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, DModal: _DModal2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)().startOf('month');
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().endOf('month');
	      }
	    },
	    schoolId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      fromDate: (0, _moment2.default)().format('YYYY-MM-DD'),
	      toDate: (0, _moment2.default)().add(1, 'days').format('YYYY-MM-DD'),
	      opusData: [],
	      isLoading: false
	    };
	  },
	
	  computed: {
	    titleOfPeriod: function titleOfPeriod() {
	      if (!this.startDate || !this.endDate) return 'Ingen periode valgt';
	      return (0, _moment2.default)(this.startDate).format('LL') + ' - ' + (0, _moment2.default)(this.endDate).format('LL');
	    },
	    oneTimePayments: function oneTimePayments() {
	      if (!this.opusData || !this.opusData.one_time_payments) {
	        return [];
	      } else {
	        return this.opusData.one_time_payments.sort(function (a, b) {
	          return new Date(a.startdato) - new Date(b.startdato);
	        });
	      }
	    }
	  },
	  methods: {
	    readOpus: function readOpus() {
	      var _this = this;
	
	      this.isLoading = true;
	      var schoolIds = [this.schoolId];
	      _docendo2.default.salaryOpusRead(this.schoolId, schoolIds, this.fromDate, this.toDate, this.user.user_id, function (success) {
	        _this.opusData = success;
	        _this.isLoading = false;
	        console.log('opus', success);
	      }, function (failure) {
	        console.log(failure);
	        _eventbus2.default.toast = { text: failure.error, success: false };
	        _this.isLoading = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.fromDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	    this.toDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	    this.readOpus();
	  }
	};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().add(3, 'days');
	      }
	    },
	    user: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      tables: []
	    };
	  },
	
	  computed: {
	    userName: function userName() {
	      return this.user && this.user.v_user_name ? this.user.v_user_name : '';
	    }
	  },
	  methods: {
	    createTables: function createTables() {
	      var _this = this;
	
	      this.user.v_user_sums.forEach(function (sumType) {
	        var obj = {
	          employmentId: sumType.employment_id,
	          title: sumType.employment_title,
	          minutes: sumType.minutes_to_copy,
	          dates: _this.datesForTable(sumType.employment_id)
	        };
	        _this.tables.push(obj);
	      });
	    },
	    datesForTable: function datesForTable(employmentId) {
	      var _this2 = this;
	
	      function switchDotsAndCommas(s) {
	        return s.replaceAll(/\.|,/g, function (match) {
	          return match === ',' ? '.' : ',';
	        });
	      }
	
	      var dates = [];
	      var startDate = (0, _moment2.default)(this.startDate).startOf('day');
	      var endDate = (0, _moment2.default)(this.endDate).endOf('day');
	      var daysDiff = endDate.diff(startDate, 'days');
	      var _loop = function _loop(i) {
	        var currentDate = startDate.clone().add(i, 'days');
	        var formattedDate = currentDate.format('DD-MM-YYYY');
	        var rawDate = currentDate.format('YYYY-MM-DD');
	
	        var subDay = _this2.user.days.find(function (day) {
	          return day.day === rawDate;
	        });
	        var dayCount = null;
	
	        if (subDay) {
	          var theEmployment = subDay.v_sums.find(function (vSum) {
	            return vSum.employment_id === employmentId;
	          });
	          if (theEmployment) {
	            dayCount = switchDotsAndCommas(JSON.parse((0, _stringify2.default)(theEmployment.minutes_to_copy)));
	          }
	        }
	
	        dates.push({ date: formattedDate, dayCount: dayCount });
	      };
	
	      for (var i = 0; i <= daysDiff; i++) {
	        _loop(i);
	      }
	
	      return dates;
	    },
	    copyTableDayCounts: function copyTableDayCounts(table, evt) {
	      var dayCounts = table.dates.map(function (date) {
	        return date.dayCount !== null && date.dayCount !== undefined ? date.dayCount : '';
	      }).join('\n');
	      navigator.clipboard.writeText(dayCounts).then(function () {
	        evt.target._tippy.show();
	      }).catch(function (err) {
	        console.error('Failed to copy day counts for ' + table.title + ': ', err);
	      });
	    },
	    hideTippy: function hideTippy(tippyEl) {
	      setTimeout(function (_) {
	        tippyEl.hide();
	      }, 1000);
	    },
	    print: function print() {
	      var fileTitle = 'Vikarløn tabel ' + this.userName + ' - ' + (0, _moment2.default)(this.startDate).format('DD-MM-YYYY') + '_' + (0, _moment2.default)(this.endDate).format('DD-MM-YYYY') + ' • docendo.dk';
	
	      var prtHtml = document.getElementById('printUserSalaryTable').innerHTML;
	
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + fileTitle + '</title>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	      var afterPrint = function afterPrint() {
	        WinPrint.close();
	      };
	      WinPrint.onafterprint = afterPrint;
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	      }, 1000);
	    }
	  },
	  mounted: function mounted() {
	    this.createTables();
	  }
	};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    whiteTheme: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      showDropdown: false
	    };
	  },
	
	  computed: {
	    schoolYears: function schoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear(val) {
	      this.$emit('yearChange', val);
	    }
	  },
	  methods: {
	    setActiveSchoolYear: function setActiveSchoolYear(schoolYearId) {
	      this.showDropdown = false;
	      this.$store.commit('setlocalActivatedSchoolYear', schoolYearId);
	    },
	    clickaway: function clickaway() {
	      if (!this.showDropdown) {
	        return;
	      }
	      this.showDropdown = false;
	    }
	  }
	};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _StepDoughnut = __webpack_require__(292);
	
	var _StepDoughnut2 = _interopRequireDefault(_StepDoughnut);
	
	var _DashboardBox = __webpack_require__(1324);
	
	var _DashboardBox2 = _interopRequireDefault(_DashboardBox);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _VacationDaysSelector = __webpack_require__(130);
	
	var _VacationDaysSelector2 = _interopRequireDefault(_VacationDaysSelector);
	
	var _IEAndEdgeWarning = __webpack_require__(352);
	
	var _IEAndEdgeWarning2 = _interopRequireDefault(_IEAndEdgeWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { doughnut: _StepDoughnut2.default, dashboardBox: _DashboardBox2.default, vacationDaySelector: _VacationDaysSelector2.default, isIEOrEdge: _IEAndEdgeWarning2.default },
	  computed: {
	    showSetupWidget: function showSetupWidget() {
	      return _eventbus2.default.showSetupWidget;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.selectedSchoolYear;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    klassCals: function klassCals() {
	      return this.$store.getters.klassCalendars;
	    },
	    userCals: function userCals() {
	      return this.$store.getters.userCalendars;
	    },
	    roomCals: function roomCals() {
	      return this.$store.getters.roomCalendars;
	    },
	    mergeCals: function mergeCals() {
	      return this.$store.getters.mergeCalendars;
	    },
	    steps: function steps() {
	      if (this.country === 'dk') {
	        return this.stepsDK;
	      } else if (this.country === 'no') {
	        return this.stepsNO;
	      } else {
	        return this.stepsEN;
	      }
	    },
	    howManyDone: function howManyDone() {
	      var doneSteps = this.steps.filter(function (obj) {
	        return obj.done === true;
	      });
	      return doneSteps.length;
	    }
	  },
	  watch: {
	    userSettings: function userSettings() {
	      var obj = this.userSettings;
	      this.progressed = (0, _keys2.default)(obj).filter(function (key) {
	        return key.startsWith('setup_widget_progress');
	      });
	      this.checkProgress();
	    },
	    klassCals: function klassCals(val) {
	      this.setNumberOfCals('setup_widget_progress_klass', val.length);
	    },
	    userCals: function userCals(val) {
	      this.setNumberOfCals('setup_widget_progress_users', val.length);
	    },
	    roomCals: function roomCals(val) {
	      this.setNumberOfCals('setup_widget_progress_rooms', val.length);
	    },
	    mergeCals: function mergeCals(val) {
	      this.setNumberOfCals('setup_widget_progress_merge', val.length);
	    }
	  },
	  data: function data() {
	    var _this = this;
	
	    return {
	      schoolId: 0,
	      userName: '',
	      schoolName: '',
	      isOnboarding: false,
	      progressed: [],
	      showSlideUp: false,
	      country: 'EN',
	      showTutorial: false,
	      videoId: '5gjODdkqRDI',
	      videoVars: {
	        autoplay: 0,
	        modestbranding: 1,
	        rel: 0 },
	      stepsDK: [{
	        title: 'Klasser',
	        icon: 'icon-calendar4',
	        buttonText: '+ Opret klasser',
	        guide: 'https://www.youtube.com/watch?v=5gjODdkqRDI&feature=youtu.be',
	        videoid: '5gjODdkqRDI',
	        guideDuration: '1:01',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createKlassModal = true;
	        }
	      }, {
	        title: 'Undervisere',
	        icon: 'icon-users',
	        buttonText: '+ Opret undervisere',
	        guide: 'https://www.youtube.com/watch?v=YtujiFzH50A&feature=youtu.be',
	        videoid: 'YtujiFzH50A',
	        guideDuration: '0:41',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createUserModal = true;
	        }
	      }, {
	        title: 'Lokaler',
	        icon: 'icon-location',
	        buttonText: '+ Opret lokaler',
	        guide: 'https://www.youtube.com/watch?v=2XQjHWLvyrM&feature=youtu.be',
	        videoid: '2XQjHWLvyrM',
	        guideDuration: '0:39',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Skoledage',
	        icon: 'icon-calendar2',
	        guide: 'https://www.youtube.com/watch?v=0XB5A0xr-N0&feature=youtu.be',
	        videoid: '0XB5A0xr-N0',
	        guideDuration: '0:39',
	        buttonText: 'Vælg feriedage',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 4,
	        number: 0,
	        action: function action() {
	          _this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_vacation': true });
	          if (window.Intercom) {
	            window.Intercom('trackEvent', 'Visited Holiday Calendar');
	          }
	          _this.setShowSlideUp('true');
	        }
	      }, {
	        title: 'Fletteskemaer',
	        icon: '',
	        guide: 'https://www.youtube.com/watch?time_continue=2&v=VNt1m80YEsI',
	        videoid: 'VNt1m80YEsI',
	        guideDuration: '0:39',
	        buttonText: '+ Opret fletteskemaer',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 5,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Skemalægning i klasser',
	        icon: '',
	        guide: 'https://www.youtube.com/watch?v=7NR8_EygcoM&feature=youtu.be',
	        videoid: '7NR8_EygcoM',
	        guideDuration: '2:25',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 6,
	        desc: 'Når du har oprettet klasser, undervisere og fag, så er du klar til at lægge skemaer for klasserne.',
	        uniClass: 'text-left'
	      }],
	      stepsNO: [{
	        title: 'Klasser',
	        icon: 'icon-calendar4',
	        buttonText: '+ Opprett klasser',
	        guide: 'https://www.youtube.com/watch?v=P9lc_0-64kc&feature=youtu.be',
	        videoid: 'P9lc_0-64kc',
	        guideDuration: '0:36',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createKlassModal = true;
	        }
	      }, {
	        title: 'Lærere',
	        icon: 'icon-users',
	        buttonText: '+ Opprett lærere',
	        guide: 'https://www.youtube.com/watch?v=X-w0i3MFeL4&feature=youtu.be',
	        videoid: 'X-w0i3MFeL4',
	        guideDuration: '0:44',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createUserModal = true;
	        }
	      }, {
	        title: 'Lokaler',
	        icon: 'icon-location',
	        buttonText: '+ Opprett lokaler',
	        guide: 'https://www.youtube.com/watch?v=8FoyUOiwdPk&feature=youtu.be',
	        videoid: '8FoyUOiwdPk',
	        guideDuration: '0:37',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Skoledager',
	        icon: 'icon-calendar2',
	        guide: 'https://www.youtube.com/watch?v=KmLDUVlzhXA&feature=youtu.be',
	        videoid: 'KmLDUVlzhXA',
	        guideDuration: '0:39',
	        buttonText: 'Legg inn fridager',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 4,
	        number: 0,
	        action: function action() {
	          _this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_vacation': true });
	          _this.setShowSlideUp('true');
	        }
	      }, {
	        title: 'Fellestimeplaner',
	        icon: '',
	        guide: 'https://www.youtube.com/watch?v=39daX1u0238&feature=youtu.be',
	        videoid: '39daX1u0238',
	        guideDuration: '2:09',
	        buttonText: '+ Opprett fellestimeplaner',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 5,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Timeplanlegging i klasser',
	        icon: '',
	        guide: 'https://www.youtube.com/watch?v=s6b7b07ZHl0&feature=youtu.be',
	        videoid: 's6b7b07ZHl0',
	        guideDuration: '2:25',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 6,
	        desc: 'Du må opprette klasser, lærere og fag før du kan lage timeplaner.',
	        uniClass: 'text-left'
	      }],
	      stepsEN: [{
	        title: 'Classes',
	        icon: 'icon-calendar4',
	        buttonText: '+ Create Classes',
	        guide: 'https://youtu.be/WdXydJxGFpI',
	        videoid: 'WdXydJxGFpI',
	        guideDuration: '0:52',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createKlassModal = true;
	        }
	      }, {
	        title: 'Teachers',
	        icon: 'icon-users',
	        buttonText: '+ Create teachers',
	        guide: 'https://youtu.be/D83kXuPIZzE',
	        videoid: 'D83kXuPIZzE',
	        guideDuration: '0:43',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createUserModal = true;
	        }
	      }, {
	        title: 'Classrooms',
	        icon: 'icon-location',
	        buttonText: '+ Create classrooms',
	        guide: 'https://youtu.be/UBI-WnWOtdQ',
	        videoid: 'UBI-WnWOtdQ',
	        guideDuration: '1:01',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'School days',
	        icon: 'icon-calendar2',
	        guide: 'https://youtu.be/CkUvNQQgMoQ',
	        videoid: 'CkUvNQQgMoQ',
	        guideDuration: '0:36',
	        buttonText: 'Choose holidays',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 4,
	        number: 0,
	        action: function action() {
	          _this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_vacation': true });
	          if (window.Intercom) {
	            window.Intercom('trackEvent', 'Visited Holiday Calendar');
	          }
	          _this.setShowSlideUp('true');
	        }
	      }, {
	        title: 'Shared calendar',
	        icon: '',
	        guide: 'https://youtu.be/aIvpXbHwYeA',
	        videoid: 'aIvpXbHwYeA',
	        guideDuration: '2:56',
	        buttonText: '+ Create breaks',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 5,
	        number: 0,
	        action: function action() {
	          _eventbus2.default.createCalendarsType = 'merge';
	        }
	      }, {
	        title: 'Subjects',
	        icon: '',
	        guide: 'https://youtu.be/EpEfabVl7yw',
	        videoid: 'EpEfabVl7yw',
	        guideDuration: '2:31',
	        buttonText: '',
	        dbName: 'setup_widget_progress_subjects',
	        done: false,
	        desc: 'Go to classes to create subjects for that specific class',
	        stepNum: 6,
	        uniClass: 'text-left'
	      }, {
	        title: 'Start scheduling',
	        icon: '',
	        guide: 'https://youtu.be/UXZpf-wAh-U',
	        videoid: 'UXZpf-wAh-U',
	        guideDuration: '3:31',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 7,
	        desc: 'You have to create classes, teachers and subjects before you can schedule a class',
	        uniClass: 'text-left'
	      }]
	    };
	  },
	
	  methods: {
	    openSetupWidget: function openSetupWidget() {
	      _eventbus2.default.showSetupWidget = true;
	    },
	    checkProgress: function checkProgress() {
	      for (var i = 0; i < this.progressed.length; i++) {
	        for (var j = 0; j < this.steps.length; j++) {
	          if (this.steps[j].dbName === this.progressed[i]) {
	            this.steps[j].done = true;
	          }
	        }
	      }
	    },
	    findStepIndex: function findStepIndex(dbName) {
	      return this.steps.map(function (step) {
	        return step.dbName;
	      }).indexOf(dbName);
	    },
	    setNumberOfCals: function setNumberOfCals(dbName, number) {
	      this.steps[this.findStepIndex(dbName)].number = number;
	    },
	    setSchoolDays: function setSchoolDays(days) {
	      this.setNumberOfCals('setup_widget_progress_vacation', days);
	    },
	    setShowSlideUp: function setShowSlideUp(boolean) {
	      if (boolean) {
	        this.showSlideUp = true;
	      } else {
	        this.showSlideUp = false;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.userName = window.USER.name;
	    this.schoolName = window.SCHOOL.name;
	    this.schoolId = window.SCHOOL.id;
	    this.country = window.SCHOOL.country.toLowerCase();
	    if (window.SCHOOL.state && window.SCHOOL.state === 'demo') {
	      this.isOnboarding = true;
	    }
	  }
	};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { spinner: _Spinner2.default },
	  props: {
	    isOnboarding: {
	      type: Boolean,
	      default: false
	    },
	    step: {
	      default: {
	        title: 'Classes',
	        icon: 'icon-calendar4',
	        buttonText: '+ Create Classes',
	        guide: 'https://youtu.be/WdXydJxGFpI',
	        videoid: 'UXZpf-wAh-U',
	        guideDuration: '0:52',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1
	      }
	    }
	  },
	  computed: {
	    isSchoolFromNorway: function isSchoolFromNorway() {
	      return window.SCHOOL.country.toLowerCase() === 'no';
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    }
	  },
	  methods: {
	    seeTutorial: function seeTutorial(step) {
	      _eventbus2.default.youTubeVideoId = step.videoid;
	      _eventbus2.default.isOpenYouTubePopup = true;
	      this.$emit('tutorial', step);
	      if (window.Intercom) {
	        window.Intercom('trackEvent', 'Watched tutorial Video planning: ' + step.title);
	      }
	    }
	  }
	};

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    isOpenModal: {
	      type: Boolean,
	      default: false
	    },
	    isForImportInZEN: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      inputDuration: 0,
	      isButtonLoading: false
	    };
	  },
	
	  computed: {
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    originalDuration: function originalDuration() {
	      if (this.activeSchool && this.activeSchool.subject_default_duration) {
	        return this.activeSchool.subject_default_duration;
	      }
	    },
	    isAValidDuration: function isAValidDuration() {
	      return (/^-?[\d.]+(?:e-?\d+)?$/.test(this.inputDuration) && this.inputDuration > 0 && this.inputDuration < 1440 && this.inputDuration % 5 === 0
	      );
	    }
	  },
	  watch: {
	    isOpenModal: function isOpenModal(val) {
	      if (val) {
	        this.openModal();
	      } else {
	        this.closeModal();
	      }
	    }
	  },
	  methods: {
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    openModal: function openModal() {
	      var _this = this;
	
	      this.inputDuration = this.originalDuration;
	      this.$nextTick(function (_) {
	        _this.$refs.duration_input.focus();
	      });
	    },
	    closeModal: function closeModal() {
	      this.$emit('close');
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      this.isButtonLoading = true;
	      var updates = { subject_default_duration: this.inputDuration };
	      _docendo2.default.updateSchool(window.SCHOOL.id, updates, function (success) {
	        _this2.$store.commit('updateActiveSchoolDuration', success.subject_default_duration);
	        _this2.$emit('close');
	        _this2.$emit('submit');
	        _this2.isButtonLoading = false;
	      }, function (failure) {
	        console.log('failed');
	      });
	    }
	  }
	};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _SchoolDataGrade = __webpack_require__(1327);
	
	var _SchoolDataGrade2 = _interopRequireDefault(_SchoolDataGrade);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, SchoolDataGrade: _SchoolDataGrade2.default },
	  data: function data() {
	    return {
	      events: [],
	      isLoading: false,
	      startDate: null,
	      endDate: null
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id * 1;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    filteredCalendars: function filteredCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    schoolYearStartDate: function schoolYearStartDate() {
	      return this.schoolYear ? this.schoolYear.student_time_start : null;
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      return this.schoolYear ? this.schoolYear.student_time_end : null;
	    },
	    eventsInHash: function eventsInHash() {
	      var eventsInHash = {};
	      this.filteredEvents.forEach(function (event, idx) {
	        event.calendars.forEach(function (calendarEvent) {
	          var calId = calendarEvent.calendar_id;
	          var durationInMinutes = (0, _moment2.default)(event.end).diff((0, _moment2.default)(event.start), 'minutes');
	          event.v_duration = durationInMinutes;
	          if (calendarEvent.substitute) {
	            event.v_has_substitute = true;
	          }
	          if (!eventsInHash[calId]) {
	            eventsInHash[calId] = [event];
	          } else {
	            eventsInHash[calId].push(event);
	          }
	        });
	      });
	      return eventsInHash;
	    },
	    filteredEvents: function filteredEvents() {
	      var _this = this;
	
	      return this.events.filter(function (event) {
	        var start = (0, _moment2.default)(event.start);
	        var startDate = (0, _moment2.default)(_this.startDate).startOf('day');
	        var endDate = (0, _moment2.default)(_this.endDate).endOf('day');
	        return start.isSameOrAfter(startDate) && start.isSameOrBefore(endDate);
	      });
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.schoolYearStartDate, this.startDate) && this.compareDates(this.schoolYearEndDate, this.endDate);
	    }
	  },
	  watch: {
	    user: function user() {
	      this.$store.dispatch('readSchoolYears', this.schoolId);
	      this.$store.dispatch('getSchoolCalendars', this.schoolId);
	    },
	    filteredCalendars: function filteredCalendars() {
	      this.readEvents();
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	    }
	  },
	  methods: {
	    resetDates: function resetDates() {
	      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	    },
	    readEvents: function readEvents() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      var start = this.schoolYearStartDate;
	      var end = this.schoolYearEndDate;
	      var calendarIds = this.filteredCalendars.map(function (calendar) {
	        return calendar.id;
	      });
	      _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (success) {
	        _this2.events = JSON.parse(success).filter(function (event) {
	          return event.school_id === _this2.schoolId;
	        });
	        _this2.isLoading = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  mounted: function mounted() {
	    this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	  }
	};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default },
	  data: function data() {
	    return {
	      events: [],
	      isLoading: false,
	      startDate: null,
	      endDate: null,
	      absenceEvents: [],
	      showHidden: false,
	      hiddenAbsence: []
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id * 1;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    filteredCalendars: function filteredCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    schoolYearStartDate: function schoolYearStartDate() {
	      return this.schoolYear ? this.schoolYear.student_time_start : null;
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      return this.schoolYear ? this.schoolYear.student_time_end : null;
	    },
	    eventsInHash: function eventsInHash() {
	      var eventsInHash = {};
	      this.filteredEvents.forEach(function (event, idx) {
	        event.calendars.forEach(function (calendarEvent) {
	          var calId = calendarEvent.calendar_id;
	          var durationInMinutes = (0, _moment2.default)(event.end).diff((0, _moment2.default)(event.start), 'minutes');
	          event.v_duration = durationInMinutes;
	          if (calendarEvent.substitute) {
	            event.v_has_substitute = true;
	          }
	          if (!eventsInHash[calId]) {
	            eventsInHash[calId] = [event];
	          } else {
	            eventsInHash[calId].push(event);
	          }
	        });
	      });
	      return eventsInHash;
	    },
	    filteredEvents: function filteredEvents() {
	      var _this = this;
	
	      return this.events.filter(function (event) {
	        var start = (0, _moment2.default)(event.start);
	        var startDate = (0, _moment2.default)(_this.startDate).startOf('day');
	        var endDate = (0, _moment2.default)(_this.endDate).endOf('day');
	        return start.isSameOrAfter(startDate) && start.isSameOrBefore(endDate);
	      });
	    },
	    isDatesPristine: function isDatesPristine() {
	      return this.compareDates(this.schoolYearStartDate, this.startDate) && this.compareDates(this.schoolYearEndDate, this.endDate);
	    },
	    absenceTypes: function absenceTypes() {
	      var obj = this.restructuredAbsenceData.length > 0 ? this.restructuredAbsenceData[0] : {};
	      var arr = (0, _keys2.default)(obj).filter(function (key) {
	        return key !== 'month';
	      }).sort(function (a, b) {
	        return a.localeCompare(b);
	      });
	      return arr;
	    },
	    visibleAbsenceTypes: function visibleAbsenceTypes() {
	      var _this2 = this;
	
	      return this.absenceTypes.filter(function (type) {
	        return _this2.hiddenAbsence.indexOf(type) < 0;
	      });
	    },
	    hiddenAbsenceTypes: function hiddenAbsenceTypes() {
	      var _this3 = this;
	
	      return this.absenceTypes.filter(function (type) {
	        return _this3.hiddenAbsence.indexOf(type) > -1;
	      });
	    },
	    restructuredAbsenceData: function restructuredAbsenceData() {
	      var start = (0, _moment2.default)(this.startDate);
	      var end = (0, _moment2.default)(this.endDate);
	
	      var restructuredData = [];
	
	      var absenceTypes = {};
	
	      while (start.isSameOrBefore(end)) {
	        restructuredData.push({
	          month: start.format('MMM YYYY')
	        });
	        start.add(1, 'month');
	      }
	
	      this.absenceEvents.forEach(function (event) {
	        var eventDate = (0, _moment2.default)(event.start);
	        var monthIndex = restructuredData.findIndex(function (data) {
	          return data.month === eventDate.format('MMM YYYY');
	        });
	
	        if (monthIndex !== -1) {
	          var absenceType = event.title;
	
	          if (!absenceTypes[absenceType]) {
	            absenceTypes[absenceType] = true;
	            restructuredData.forEach(function (data) {
	              data[absenceType] = 0;
	            });
	          }
	
	          restructuredData[monthIndex][absenceType]++;
	        }
	      });
	
	      return restructuredData;
	    }
	  },
	  watch: {
	    user: function user() {
	      this.$store.dispatch('readSchoolYears', this.schoolId);
	      this.$store.dispatch('getSchoolCalendars', this.schoolId);
	    },
	    filteredCalendars: function filteredCalendars() {
	      this.readEvents();
	    },
	    schoolYearEndDate: function schoolYearEndDate() {
	      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	    }
	  },
	  methods: {
	    toggleHiddenAbsence: function toggleHiddenAbsence(type) {
	      var idx = this.hiddenAbsence.indexOf(type);
	      if (idx < 0) {
	        this.hiddenAbsence.push(type);
	      } else {
	        this.hiddenAbsence.splice(idx, 1);
	      }
	      this.$helpers.setLocalStorage('d_hidden_absence', (0, _stringify2.default)(this.hiddenAbsence));
	    },
	    resetDates: function resetDates() {
	      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	    },
	    readEvents: function readEvents() {
	      var _this4 = this;
	
	      this.isLoading = true;
	      var start = this.schoolYearStartDate;
	      var end = this.schoolYearEndDate;
	      var calendarIds = this.filteredCalendars.map(function (calendar) {
	        return calendar.id;
	      });
	      _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (success) {
	        _this4.events = JSON.parse(success).filter(function (event) {
	          return event.school_id === _this4.schoolId;
	        });
	        _this4.absenceEvents = _this4.events.filter(function (event) {
	          return event.event_type === 'absence' && event.school_id === _this4.schoolId;
	        });
	        _this4.isLoading = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  mounted: function mounted() {
	    var localVal = this.$helpers.getLocalStorage('d_hidden_absence');
	    if (localVal) {
	      this.hiddenAbsence = JSON.parse(localVal);
	    }
	    this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	  }
	};

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    calendar: {
	      type: Object,
	      default: null
	    },
	    eventsInHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      isShowMore: false
	    };
	  },
	
	  computed: {
	    events: function events() {
	      return this.eventsInHash[this.calendar.id] ? this.eventsInHash[this.calendar.id] : [];
	    },
	    calendarName: function calendarName() {
	      return this.calendar ? this.calendar.name : '';
	    },
	    eventsInPools: function eventsInPools() {
	      var events = {};
	      this.events.forEach(function (event) {
	        if (!events[event.title]) {
	          events[event.title] = {
	            events: 0,
	            eventsWithSubs: 0,
	            durations: [0],
	            durationsWithSubs: [0]
	          };
	        }
	        events[event.title]['events'] += 1;
	        events[event.title]['durations'].push(event.v_duration);
	        if (event.v_has_substitute) {
	          events[event.title]['eventsWithSubs'] += 1;
	          events[event.title]['durationsWithSubs'].push(event.v_duration);
	        }
	      });
	      for (var key in events) {
	        var sumInHours = events[key]['durations'].reduce(function (a, b) {
	          return a + b;
	        }) / 60;
	        events[key]['durationInHours'] = parseFloat(sumInHours).toFixed(2);
	        var sumOfDurationsWithSubs = events[key]['durationsWithSubs'].reduce(function (a, b) {
	          return a + b;
	        }) / 60;
	        events[key]['durationWithSubsInHours'] = parseFloat(sumOfDurationsWithSubs).toFixed(2);
	      }
	      return events;
	    },
	    eventsInHours: function eventsInHours() {
	      return this.getEventsInHours(this.events);
	    },
	    eventsWithSubInHours: function eventsWithSubInHours() {
	      return this.getEventsInHours(this.eventsWithSub);
	    },
	    eventsWithSub: function eventsWithSub() {
	      return this.events.filter(function (event) {
	        var hasSub = false;
	        event.calendars.forEach(function (calendar) {
	          if (calendar.substitute) {
	            hasSub = true;
	          }
	        });
	        return hasSub;
	      });
	    }
	  },
	  methods: {
	    getEventsInHours: function getEventsInHours(events) {
	      var eventsDurations = [0];
	      events.forEach(function (event) {
	        eventsDurations.push(event.v_duration);
	      });
	      var sum = eventsDurations.reduce(function (a, b) {
	        return a + b;
	      });
	      var inHours = sum / 60;
	      return parseFloat(inHours).toFixed(2);
	    }
	  }
	};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default },
	  data: function data() {
	    return {
	      events: [],
	      subEventsWithAbsenceType: [],
	      absenceTypesWithLessons: {},
	      absenceEventsInHash: {},
	      sortedAbsenceTypesWithLessons: {},
	      isLoading: false,
	      startDate: moment(),
	      endDate: moment().add(7, 'days'),
	      absenceEvents: [],
	      theActiveAcc: '',
	      isReadEventsClick: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    schoolId: function schoolId() {
	      return this.$route.params.school_id * 1;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    filteredCalendars: function filteredCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    }
	  },
	  watch: {
	    user: function user() {
	      this.$store.dispatch('getSchoolCalendars', this.schoolId);
	    }
	  },
	  methods: {
	    setAbsenceEventsInHash: function setAbsenceEventsInHash() {
	      var _this = this;
	
	      this.absenceEventsInHash = {};
	      this.absenceEvents.forEach(function (event, idx) {
	        var calId = _this.allUsersInCalIdHash[event.calendar_id] ? _this.allUsersInCalIdHash[event.calendar_id].id : event.calendar_id;
	        if (!_this.absenceEventsInHash[calId]) {
	          _this.absenceEventsInHash[calId] = [event];
	        } else {
	          _this.absenceEventsInHash[calId].push(event);
	        }
	      });
	    },
	    setSubEventsWithAbsenceType: function setSubEventsWithAbsenceType() {
	      var _this2 = this;
	
	      this.subEventsWithAbsenceType = [];
	      moment.locale(this.locale);
	      this.events.forEach(function (lesson) {
	        lesson.calendars.forEach(function (cal) {
	          if (cal.substitute) {
	            var subLesson = {
	              id: lesson.event_id + '_' + cal.calendar_id,
	              title: lesson.title,
	              start: lesson.start,
	              vTimestamp: moment(lesson.start).format('lll') + ' - ' + moment(lesson.end).format('LT'),
	              vKlasses: lesson.calendars.filter(function (cal) {
	                return cal.calendar_type === 'klass';
	              }).map(function (cal) {
	                return cal.name;
	              }).join(' ,'),
	              end: lesson.end,
	              substitute: _this2.allUsersInCalIdHash[cal.calendar_id] ? _this2.allUsersInCalIdHash[cal.calendar_id].name : cal.calendar_id,
	              substituteCalId: cal.calendar_id,
	              minutes: cal.minutes,
	              substituteFor: _this2.allUsersInHash[cal.substitute] ? _this2.allUsersInHash[cal.substitute].name : cal.substitute,
	              absenceOverlapping: [],
	              absenceTitle: 'Ukendt fraværsårsag'
	            };
	            if (_this2.absenceEventsInHash[cal.substitute]) {
	              subLesson.absenceOverlapping = _this2.getEventsWithinDateTimes(_this2.absenceEventsInHash[cal.substitute], lesson.start, lesson.end);
	            }
	            if (subLesson.absenceOverlapping.length === 1) {
	              subLesson.absenceTitle = subLesson.absenceOverlapping[0].title;
	            }
	            if (subLesson.absenceOverlapping.length > 1) {
	              subLesson.absenceTitle = 'Multiple';
	            }
	            _this2.subEventsWithAbsenceType.push(subLesson);
	          }
	        });
	      });
	      this.setAbsenceTypesWithLessons();
	    },
	    setAbsenceTypesWithLessons: function setAbsenceTypesWithLessons() {
	      var _this3 = this;
	
	      this.absenceTypesWithLessons = {};
	      this.subEventsWithAbsenceType.forEach(function (lesson) {
	        if (_this3.absenceTypesWithLessons[lesson.absenceTitle]) {
	          _this3.absenceTypesWithLessons[lesson.absenceTitle]['minutes'] = _this3.absenceTypesWithLessons[lesson.absenceTitle]['minutes'] + lesson.minutes * 1;
	          _this3.absenceTypesWithLessons[lesson.absenceTitle]['lessons'].push(lesson);
	        } else {
	          _this3.absenceTypesWithLessons[lesson.absenceTitle] = { minutes: lesson.minutes * 1, lessons: [lesson], type: lesson.absenceTitle, isOpen: false };
	        }
	      });
	      this.setSortedAbsenceTypesWithLessons();
	    },
	    setSortedAbsenceTypesWithLessons: function setSortedAbsenceTypesWithLessons() {
	      var _this4 = this;
	
	      this.sortedAbsenceTypesWithLessons = {};
	
	      var sortedKeys = (0, _keys2.default)(this.absenceTypesWithLessons).sort(function (a, b) {
	        var minutesA = _this4.absenceTypesWithLessons[a].minutes;
	        var minutesB = _this4.absenceTypesWithLessons[b].minutes;
	        return minutesB - minutesA;
	      });
	
	      sortedKeys.forEach(function (key) {
	        _this4.sortedAbsenceTypesWithLessons[key] = (0, _extends3.default)({}, _this4.absenceTypesWithLessons[key], {
	          formattedDuration: _this4.formatDuration(_this4.absenceTypesWithLessons[key].minutes)
	        });
	      });
	    },
	    formatDuration: function formatDuration(minutes) {
	      var hours = Math.floor(minutes / 60);
	      var remainingMinutes = (minutes % 60).toFixed(0);
	      return hours + ' timer ' + remainingMinutes + ' min';
	    },
	    setActiveAcc: function setActiveAcc(prop) {
	      if (this.theActiveAcc === prop) {
	        this.theActiveAcc = '';
	      } else {
	        this.theActiveAcc = prop;
	      }
	    },
	    getEventsWithinDateTimes: function getEventsWithinDateTimes(events, start, end) {
	      return events.filter(function (event) {
	        var eventStart = moment(start).startOf('day');
	        var eventEnd = moment(end).endOf('day');
	        var absenceStart = moment(event.start);
	        var absenceEnd = moment(event.end);
	
	        var range1 = moment.range(eventStart, eventEnd);
	        var range2 = moment.range(absenceStart, absenceEnd);
	        return range1.intersect(range2);
	      });
	    },
	    resetDates: function resetDates() {
	      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate);
	    },
	    setStartDate: function setStartDate(date) {
	      this.setDates(date, null);
	    },
	    setEndDate: function setEndDate(date) {
	      this.setDates(null, date);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	    },
	    readEvents: function readEvents() {
	      var _this5 = this;
	
	      this.theActiveAcc = '';
	      this.isReadEventsClick = true;
	      this.isLoading = true;
	      var start = moment(this.startDate).format('YYYY-MM-DD');
	      var end = moment(this.endDate).endOf('day');
	      var calendarIds = this.filteredCalendars.map(function (calendar) {
	        return calendar.id;
	      });
	      _docendo2.default.calendarEvents2(calendarIds, start, end, null, function (success) {
	        _this5.events = JSON.parse(success).filter(function (event) {
	          return event.school_id === _this5.schoolId;
	        });
	        _this5.absenceEvents = _this5.events.filter(function (event) {
	          return event.event_type === 'absence' && event.school_id === _this5.schoolId;
	        });
	        _this5.isLoading = false;
	        _this5.setAbsenceEventsInHash();
	        _this5.setSubEventsWithAbsenceType();
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return moment(firstDate).format('YYYY-MM-DD') === moment(secondDate).format('YYYY-MM-DD');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUsersFromSchoolId', this.schoolId);
	    this.$store.dispatch('getUser');
	  }
	};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SideNav = __webpack_require__(84);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _SalarySubsPerf = __webpack_require__(325);
	
	var _SalarySubsPerf2 = _interopRequireDefault(_SalarySubsPerf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SideNav: _SideNav2.default,
	    SalarySubsPerf: _SalarySubsPerf2.default
	  }
	};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ToggleYear = __webpack_require__(1399);
	
	var _ToggleYear2 = _interopRequireDefault(_ToggleYear);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _OnboardArrow = __webpack_require__(354);
	
	var _OnboardArrow2 = _interopRequireDefault(_OnboardArrow);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _TeamCalendar = __webpack_require__(339);
	
	var _TeamCalendar2 = _interopRequireDefault(_TeamCalendar);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, yearToggle: _ToggleYear2.default, onboardArrow: _OnboardArrow2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, TeamCalendar: _TeamCalendar2.default },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      open: false,
	      search: '',
	      type: '',
	      active: '',
	      changeSchoolDropdown: false,
	      searchName: '',
	      hover: false,
	      theStudentsActiveForCal: null
	    };
	  },
	
	  watch: {
	    schoolId: function schoolId(val, oldVal) {
	      this.getSchoolCalendars();
	    },
	    user: function user() {
	      this.setActiveSchool();
	      this.$i18n.locale = this.locale;
	      _moment2.default.locale(this.locale);
	      this.getSchoolCalendars();
	    },
	    activeOnboardingStep: function activeOnboardingStep() {
	      if (this.activeOnboardingStep > 0 && this.activeOnboardingStep < 5) {
	        this.openSideNav();
	        this.chooseCals(this.activeOnboardingStep);
	      } else if (this.activeOnboardingStep === 6) {
	        this.openSideNav();
	        this.chooseCals(1);
	      }
	    }
	  },
	  computed: {
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    schoolId: function schoolId() {
	      if (this.$route && this.$route.params && this.$route.params.school_id) {
	        return this.$route.params.school_id;
	      }
	      if (this.activeSchool && this.activeSchool.id) {
	        return this.activeSchool.id;
	      }
	      if (window.SCHOOL && window.SCHOOL.id) {
	        return window.SCHOOL.id;
	      }
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    isSchoolTestingStudents: function isSchoolTestingStudents() {
	      return this.$store.getters.isSchoolTestingStudents;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userHasMultipleSchools: function userHasMultipleSchools() {
	      return this.user && this.user.schools ? this.user.schools.length > 1 : false;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    year: function year() {
	      return this.activeSchoolYear.name;
	    },
	    schoolYearStartDate: function schoolYearStartDate() {
	      return this.activeSchoolYear ? this.activeSchoolYear.student_time_start : null;
	    },
	    notCreatedAnyTextString: function notCreatedAnyTextString() {
	      switch (this.activeType.type) {
	        case 'klass':
	          return this.$t('vue2.sidenav.not_created_klass');
	        case 'user':
	          return this.$t('vue2.sidenav.not_created_users');
	        case 'room':
	          return this.$t('vue2.sidenav.not_created_rooms');
	        case 'merge':
	          return this.$t('vue2.sidenav.not_created_merge');
	        case 'other':
	          return this.$t('vue2.sidenav.not_created_other');
	        case 'club':
	          return this.$t('vue2.club.not_created_club');
	        case 'kindergarten':
	          return 'stue';
	      }
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    cals: function cals() {
	      return this.$store.state.calendars;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    activeOnboardingStep: function activeOnboardingStep() {
	      return this.$store.state.onboardingStep;
	    },
	    showOnboardingArrow: function showOnboardingArrow() {
	      return _eventbus2.default.showOnboardingArrow;
	    },
	    calendarData: function calendarData() {
	      return {
	        1: {
	          type: 'klass',
	          title: this.$i18n.t('vue2.common.class'),
	          searchName: this.$i18n.t('vue2.common.classes'),
	          icon: 'icon-calendar4',
	          hasSchoolYear: true
	        },
	        2: {
	          type: 'user',
	          title: this.$i18n.t('vue2.common.user'),
	          searchName: this.$i18n.t('vue2.common.users'),
	          icon: 'icon-users',
	          hasSchoolYear: false
	        },
	        3: {
	          type: 'room',
	          title: this.$i18n.t('vue2.common.room'),
	          searchName: this.$i18n.t('vue2.common.rooms'),
	          icon: 'icon-location',
	          hasSchoolYear: false
	        },
	        4: {
	          type: 'merge',
	          title: this.$i18n.t('vue2.common.merge_calendar'),
	          searchName: this.$i18n.t('vue2.common.merge_calendars'),
	          icon: 'icon-calendar-week',
	          hasSchoolYear: true
	        },
	        5: {
	          type: 'other',
	          title: this.$i18n.t('vue2.common.other_calendar'),
	          searchName: this.$i18n.t('vue2.common.other_calendars'),
	          icon: 'icon-clipboard2',
	          hasSchoolYear: true
	        },
	        6: {
	          type: 'club',
	          title: this.$i18n.t('vue2.club.club_calendar'),
	          searchName: this.$i18n.t('vue2.club.club'),
	          icon: 'icon-users5',
	          hasSchoolYear: true
	        },
	        7: {
	          type: 'kindergarten',
	          title: 'Stue',
	          searchName: 'Stue',
	          icon: 'icon-users5',
	          hasSchoolYear: true
	        }
	      };
	    },
	    activeType: function activeType() {
	      if (this.active !== '') {
	        return this.calendarData[this.active];
	      } else {
	        return '';
	      }
	    },
	    allSchools: function allSchools() {
	      return this.user.schools;
	    },
	    activeCals: function activeCals() {
	      var _this = this;
	
	      return this.cals.filter(function (cal) {
	        return cal.type === _this.type && !cal.archived_at;
	      });
	    },
	    yearCals: function yearCals() {
	      var _this2 = this;
	
	      var cals = this.activeCals.filter(function (cal) {
	        return cal.school_year_id ? cal.school_year_id === _this2.activeSchoolYear.id : cal.year === '' || cal.year.match(_this2.year);
	      });
	      return this.$helpers.sortArrOnName(cals);
	    },
	    searchCals: function searchCals() {
	      var _this3 = this;
	
	      return this.yearCals.filter(function (cal) {
	        return cal.name !== null ? cal.name.match(new RegExp(_this3.search, 'i')) : '';
	      });
	    },
	    isSchoolSFOActive: function isSchoolSFOActive() {
	      return this.$store.getters.isSchoolSFOActive;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    }
	  },
	  methods: {
	    goToDutySchedule: function goToDutySchedule() {
	      window.location.href = '/schools/' + this.schoolId + '/duty_schedule';
	    },
	    getSchoolCalendars: function getSchoolCalendars() {
	      if (!this.schoolId) {
	        return;
	      }
	      if (this.isSchoolTestingStudents) {
	        this.$store.dispatch('readCalendarRelations');
	      }
	      this.$store.dispatch('getSchoolCalendars', this.schoolId);
	      this.$store.dispatch('readSchoolYears', this.schoolId);
	    },
	    getCalStudents: function getCalStudents(calStudents) {
	      var _this4 = this;
	
	      var students = calStudents.filter(function (studentId) {
	        return _this4.allCalendarsInHash[studentId] && !_this4.allCalendarsInHash[studentId].archived_at;
	      }).map(function (studentId) {
	        return _this4.allCalendarsInHash[studentId];
	      });
	      return this.$helpers.sortArrOnName(students);
	    },
	    setActiveCalendarId: function setActiveCalendarId(calId) {
	      if (window.location.href.indexOf('calendar') < 0 || window.location.href.indexOf('?tasks') > 0) {
	        window.location.href = '/calendar/?cal=' + calId;
	      }
	      this.$store.commit('setActiveCalendarId', calId);
	      this.closeSideNav();
	    },
	    setTheStudentsActiveForCal: function setTheStudentsActiveForCal(calId) {
	      if (this.isStudentsActiveForCal(calId)) {
	        this.theStudentsActiveForCal = null;
	      } else {
	        this.theStudentsActiveForCal = calId;
	      }
	    },
	    isStudentsActiveForCal: function isStudentsActiveForCal(calId) {
	      return this.theStudentsActiveForCal === calId;
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    createKlasses: function createKlasses() {
	      _eventbus2.default.createKlassModal = true;
	      _eventbus2.default.showOnboardingArrow = false;
	    },
	    createUsers: function createUsers() {
	      _eventbus2.default.createUserModal = true;
	      _eventbus2.default.showOnboardingArrow = false;
	    },
	    createCalendars: function createCalendars(calendarType) {
	      _eventbus2.default.createCalendarsType = calendarType;
	      _eventbus2.default.showOnboardingArrow = false;
	    },
	    toggleChangeSchoolDropdown: function toggleChangeSchoolDropdown() {
	      this.changeSchoolDropdown = !this.changeSchoolDropdown;
	    },
	    openSideNav: function openSideNav(cals) {
	      var _this5 = this;
	
	      if (this.open) {
	        return;
	      }
	      this.open = true;
	      var pagewidth = document.getElementById('djs-content-container');
	      if (!pagewidth.classList.contains('djs_menu_out')) {
	        pagewidth.className += ' djs_menu_out';
	      }
	      if (cals === 0) {
	        this.isKindergarten ? this.chooseCals(7) : this.chooseCals(1);
	      }
	      setTimeout(function (_) {
	        _this5.$refs.searchfield.focus();
	      }, 200);
	    },
	    clickaway: function clickaway(e) {
	      if (e !== undefined) {
	        if (e.target.classList.toString().startsWith('lity') || e.target.classList.contains('js-setupWidgetEvent') || e.target.classList.contains('js-modalCloseEvent') || e.target.classList.contains('js-dontCloseSidenav')) {
	          return;
	        }
	      }
	      if (_eventbus2.default.createModalOpen) {
	        return;
	      }
	      this.closeSideNav();
	      if (this.activeOnboardingStep > 0 && this.activeOnboardingStep < 5) {
	        this.$store.commit('setOnboardingStep', 0);
	      }
	      if (this.activeOnboardingStep === 6) {
	        this.$store.commit('setOnboardingStep', 0);
	      }
	    },
	    closeSideNav: function closeSideNav() {
	      this.open = false;
	      var pagewidth = document.getElementById('djs-content-container');
	      if (this.hasClass(pagewidth, 'djs_menu_out')) {
	        pagewidth.className = 'content_container';
	        this.active = '';
	      }
	    },
	    clearSearch: function clearSearch() {
	      this.search = '';
	    },
	    chooseCals: function chooseCals(num) {
	      var searchfield = document.getElementById('searchfield');
	      if (searchfield !== null) {
	        searchfield.focus();
	      }
	      var calendar = this.calendarData[num];
	      this.type = calendar.type;
	      this.active = num;
	      this.searchName = calendar.searchName.toLowerCase();
	    },
	    isActive: function isActive(num) {
	      return this.active === num;
	    },
	    hasClass: function hasClass(elem, cls) {
	      return (' ' + elem.className + ' ').indexOf(' ' + cls + ' ') > -1;
	    },
	    setActiveSchool: function setActiveSchool() {
	      var activeSchool = '';
	
	      if (this.user.current_school) {
	        activeSchool = this.user.current_school;
	      } else if (this.user.primary_school) {
	        activeSchool = this.user.primary_school;
	      } else {
	        activeSchool = this.user.schools[0];
	      }
	
	      this.$store.dispatch('readActiveSchool', activeSchool);
	    },
	    manipulateSchoolStuffForKindergarten: function manipulateSchoolStuffForKindergarten() {
	      var elSupportLink = document.querySelector('.js-intro-support__nav > a');
	      if (elSupportLink) {
	        elSupportLink.setAttribute('href', 'https://app.docendo.dk/features/daycare/');
	      }
	      this.changeLinksTextString('Opgaveoversigt', 'Årsnormsoversigt');
	      this.changeLinksTextString('Feriekalender', 'Lukkedage');
	      this.changeLinksTextString('Skoleår', 'Perioder');
	      this.changeDivTextString('Undervisere', 'Personale');
	      this.changePlanningLink();
	    },
	    changePlanningLink: function changePlanningLink() {
	      var planningLink = document.querySelector('.js-onboarding-arrow-planning > a');
	      var subPlanningLink = document.querySelector('.js-onboarding-arrow-planning > .header-nav__item__dropdown > a:first-child');
	      if (!planningLink || !subPlanningLink) {
	        return;
	      }
	      planningLink.setAttribute('href', '/schools/' + this.schoolId + '/annual_norm');
	      planningLink.innerHTML = '<span class="icon-calendar2"></span> Årsnorm';
	      subPlanningLink.remove();
	    },
	    changeDivTextString: function changeDivTextString(initialText, newText) {
	      var aElements = document.querySelectorAll('div');
	      for (var i = 0; i < aElements.length; i++) {
	        var a = aElements[i];
	        if (a.textContent.indexOf(initialText) !== -1) {
	          a.innerText = newText;
	        }
	      }
	    },
	    changeLinksTextString: function changeLinksTextString(initialText, newText) {
	      var aElements = document.querySelectorAll('a');
	      for (var i = 0; i < aElements.length; i++) {
	        var a = aElements[i];
	        if (a.textContent.indexOf(initialText) !== -1) {
	          a.innerText = newText;
	        }
	      }
	    },
	    manipulateFullCalendarForRotatingSchedules: function manipulateFullCalendarForRotatingSchedules(numberOfDays) {
	      var _this6 = this;
	
	      window.addEventListener('fullcal_view_or_date_changed', function (e) {
	        if ($) {
	          var el = $('.calendar');
	          var currentDate = el.fullCalendar('getDate');
	
	          var startDate = _this6.schoolYearStartDate;
	          var dataSpan = document.querySelector('#js-data-cal-date');
	          if (!dataSpan && !startDate) {
	            return;
	          }
	          if (dataSpan) {
	            startDate = dataSpan.getAttribute('data-cal_start_date');
	          }
	          var currentWeek = (0, _moment2.default)(currentDate).isoWeek();
	          var startWeek = (0, _moment2.default)(startDate).isoWeek();
	          if (currentWeek === startWeek - 1) {
	            if (!el.data('is_master_schedule')) {
	              el.data('is_master_schedule', true);
	              if (numberOfDays === 6) {
	                var options = { view_state: 'weekends', hiddenDays: [0] };
	                calItFormROR(el, (0, _moment2.default)(currentDate).add(1, 'days'), options);
	              }
	              changeFullCalendarDayCellNames();
	            }
	          } else {
	            if (el.data('is_master_schedule')) {
	              el.data('is_master_schedule', false);
	              if (numberOfDays === 6) {
	                var _options = { view_state: 'weekends', hiddenDays: [] };
	                calItFormROR(el, currentDate, _options);
	              }
	            }
	          }
	        }
	      });
	
	      function calItFormROR(el, date, options) {
	        el.fullCalendar('destroy');
	        cal_it(el, date, options);
	      }
	
	      function changeFullCalendarDayCellNames() {
	        var cells = document.querySelectorAll('th[data-date]');
	        cells.forEach(function (cell) {
	          var date = cell.getAttribute('data-date');
	          var isoWeekday = (0, _moment2.default)(date, 'YYYY-MM-DD').isoWeekday();
	          cell.textContent = 'Day ' + isoWeekday;
	        });
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUser');
	  },
	  mounted: function mounted() {
	    if (this.isKindergarten) {
	      this.manipulateSchoolStuffForKindergarten();
	    }
	
	    if (!this.schoolId) {
	      return;
	    }
	    var schoolId = this.schoolId * 1;
	    if (schoolId === 56541) {
	      this.manipulateFullCalendarForRotatingSchedules(6);
	    }
	    if (schoolId === 3 || schoolId === 51097) {
	      this.manipulateFullCalendarForRotatingSchedules(5);
	    }
	  }
	};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['school'],
	  data: function data() {
	    return {
	      html: ''
	    };
	  },
	
	  methods: {
	    getAllData: function getAllData() {
	      _docendo2.default.getSchoolLeftSideMenu(this.school, this.sidebarUpdated);
	    },
	    sidebarUpdated: function sidebarUpdated(data) {
	      this.html = data.data;
	    }
	  },
	  mounted: function mounted() {
	    this.getAllData();
	  }
	};

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    query: {
	      type: String,
	      default: ''
	    },
	    calendarType: {
	      type: String,
	      default: 'students'
	    }
	  },
	  data: function data() {
	    return {
	      searchQuery: '',
	      search_timeout: null
	    };
	  },
	
	  computed: {
	    searchedCalendars: function searchedCalendars() {
	      var _this = this;
	
	      return this.searchQuery.length > 0 ? this.activeCalendars.filter(function (cal) {
	        return cal.name !== null ? cal.name.match(new RegExp(_this.searchQuery, 'i')) : '';
	      }) : [];
	    },
	    activeCalendars: function activeCalendars() {
	      return this.calendarType === 'students' ? this.students : this.users;
	    },
	    calendars: function calendars() {
	      return this.$store.state.calendars;
	    },
	    students: function students() {
	      return this.$store.getters.allStudentCalendars;
	    },
	    users: function users() {
	      return this.$store.getters.userCalendars;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    }
	  },
	  watch: {
	    query: function query(val, oldVal) {
	      this.debounceSearch(val);
	    }
	  },
	  methods: {
	    debounceSearch: function debounceSearch(val) {
	      var _this2 = this;
	
	      if (this.search_timeout) {
	        clearTimeout(this.search_timeout);
	      }
	      this.search_timeout = setTimeout(function (_) {
	        _this2.searchQuery = val;
	      }, 400);
	    },
	    getStudentKlasses: function getStudentKlasses(student) {
	      var _this3 = this;
	
	      if (student.klasses) {
	        return student.klasses.map(function (calId) {
	          if (_this3.allCalendarsInHash[calId]) {
	            return _this3.allCalendarsInHash[calId];
	          }
	        });
	      } else {
	        return [];
	      }
	    }
	  }
	};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _feide = __webpack_require__(1177);
	
	var _feide2 = _interopRequireDefault(_feide);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CreateStudents = __webpack_require__(1228);
	
	var _CreateStudents2 = _interopRequireDefault(_CreateStudents);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ChangeSchoolYear: _ChangeSchoolYear2.default, Spinner: _Spinner2.default, ModalConfirmation: _ModalConfirmation2.default, Loader: _Loader2.default, DModal: _DModal2.default, CreateStudents: _CreateStudents2.default },
	  data: function data() {
	    return {
	      theActiveFilter: 'filter__activatedStudents',
	      feideLogo: _feide2.default,
	      dragStudents: [],
	      dragEvt: null,
	      theActiveStudent: null,
	      isHoverOnKlass: false,
	      editName: '',
	      editFeide: '',
	      isEditStudentChanges: false,
	      isEditStudentConfirmation: false,
	      theLatestFeideImport: null,
	      isImporting: false,
	      offsetTop: 0
	    };
	  },
	
	  computed: {
	    bodyStyleObj: function bodyStyleObj() {
	      var offsetHeight = this.offsetTop + 20;
	      return {
	        overflow: 'auto',
	        maxHeight: 'calc(100vh - ' + offsetHeight + 'px)'
	      };
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isFeideActive: function isFeideActive() {
	      return false;
	    },
	    isFeideImportActive: function isFeideImportActive() {
	      return false;
	    },
	    lastUpdateFromFeide: function lastUpdateFromFeide() {
	      var ddate = (0, _moment2.default)().subtract(2, 'hour');
	      return this.theLatestFeideImport ? (0, _moment2.default)(this.theLatestFeideImport).format('LLL') : (0, _moment2.default)(ddate).format('LLL');
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    isLoadingCalendarRelations: function isLoadingCalendarRelations() {
	      return this.$store.state.isLoadingCalendarRelations;
	    },
	    isLoading: function isLoading() {
	      return this.isLoadingSchoolCalenders || this.isLoadingCalendarRelations;
	    },
	    students: function students() {
	      return this.$store.getters.allStudentCalendars;
	    },
	    studentsWithoutKlasses: function studentsWithoutKlasses() {
	      return this.students.filter(function (student) {
	        return student.klasses.length === 0;
	      });
	    },
	    studentsActivated: function studentsActivated() {
	      return this.students.filter(function (student) {
	        return !student.archived_at;
	      });
	    },
	    filteredStudents: function filteredStudents() {
	      var _this = this;
	
	      var students = [];
	      if (this.theActiveFilter === '') {
	        students = this.students;
	      } else if (this.theActiveFilter === 'filter__students_without_groups') {
	        students = this.studentsWithoutKlasses;
	      } else if (this.theActiveFilter === 'filter__activatedStudents') {
	        students = this.studentsActivated;
	      } else {
	        students = this.students.filter(function (student) {
	          var idx = student.klasses.indexOf(_this.theActiveFilter);
	          if (idx > -1) {
	            return student;
	          }
	        });
	      }
	      return students.map(function (stud) {
	        var iSSelectedForDrag = _this.dragStudents.findIndex(function (dragStudent) {
	          return dragStudent.id === stud.id;
	        }) > -1;
	        _this.$set(stud, 'v_klasses', _this.getStudentKlasses(stud));
	        _this.$set(stud, 'v_isSelectedForDrag', iSSelectedForDrag);
	        return stud;
	      });
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    relations: function relations() {
	      return this.$store.state.calendarRelations;
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    schoolYearsInHash: function schoolYearsInHash() {
	      return this.schoolYears.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    }
	  },
	  methods: {
	    updateOffsetTop: function updateOffsetTop() {
	      if (this.$refs.students_col1_body) {
	        this.offsetTop = this.$refs.students_col1_body.getBoundingClientRect().top;
	      }
	    },
	    setStudentsSelectedForDrag: function setStudentsSelectedForDrag(student) {
	      var idx = this.dragStudents.findIndex(function (dragStudent) {
	        return dragStudent.id === student.id;
	      });
	      if (idx < 0) {
	        this.dragStudents.push(student);
	      } else {
	        this.dragStudents.splice(idx, 1);
	      }
	    },
	    getSchoolYearName: function getSchoolYearName(klass) {
	      var schoolYearId = this.allCalendarsInHash[klass.id] && this.allCalendarsInHash[klass.id].school_year_id ? this.allCalendarsInHash[klass.id].school_year_id : null;
	      return this.schoolYearsInHash[schoolYearId] ? '(' + this.schoolYearsInHash[schoolYearId].name + ')' : '';
	    },
	    getLatestFeideUpdate: function getLatestFeideUpdate() {
	      var latestDate = this.$helpers.getLocalStorage('feideUpdate');
	      if (latestDate) {
	        this.theLatestFeideImport = latestDate;
	      }
	    },
	    updateFromFeide: function updateFromFeide() {
	      var _this2 = this;
	
	      this.isImporting = true;
	      this.$helpers.setLocalStorage('feideUpdate', (0, _moment2.default)().format('YYYY-MM-DD HH:mm'));
	      setTimeout(function (_) {
	        _this2.getLatestFeideUpdate();
	        _this2.isImporting = false;
	      }, 2500);
	    },
	    setTheActiveStudent: function setTheActiveStudent(student) {
	      this.theActiveStudent = student;
	      this.editName = student.name;
	      this.editFeide = student.custom_data['feide'] ? student.custom_data['feide'] : '';
	    },
	    closeModal: function closeModal() {
	      this.theActiveStudent = null;
	      this.isEditStudentChanges = false;
	      this.isEditStudentConfirmation = false;
	    },
	    getStudentKlasses: function getStudentKlasses(student) {
	      var _this3 = this;
	
	      if (student.klasses) {
	        return student.klasses.filter(function (klassCalId) {
	          return _this3.allCalendarsInHash[klassCalId] && _this3.allCalendarsInHash[klassCalId].school_year_id && _this3.allCalendarsInHash[klassCalId].school_year_id === _this3.localActivatedSchoolYear.id;
	        }).map(function (calId) {
	          return _this3.allCalendarsInHash[calId];
	        });
	      } else {
	        return [];
	      }
	    },
	    getStudentRelations: function getStudentRelations(student) {
	      var _this4 = this;
	
	      if (student.calRelations) {
	        return student.calRelations.filter(function (calRel) {
	          return _this4.allCalendarsInHash[calRel.other_calendar_id];
	        }).map(function (relation) {
	          if (_this4.allCalendarsInHash[relation.other_calendar_id].name) {
	            var objRelation = {
	              id: relation.id,
	              name: _this4.allCalendarsInHash[relation.other_calendar_id].name
	            };
	            return objRelation;
	          }
	        });
	      } else {
	        return [];
	      }
	    },
	    setTheActiveFilter: function setTheActiveFilter(filter) {
	      this.theActiveFilter = filter;
	    },
	    isTheActiveFilter: function isTheActiveFilter(filter) {
	      return this.theActiveFilter === filter;
	    },
	    toggleAll: function toggleAll() {
	      var _this5 = this;
	
	      if (this.dragStudents.length > 0) {
	        this.dragStudents = [];
	      } else {
	        this.dragStudents = [];
	        this.filteredStudents.forEach(function (student) {
	          _this5.dragStudents.push(student);
	        });
	      }
	    },
	    dragStart: function dragStart(student, evt) {
	      var idx = this.dragStudents.findIndex(function (dragStudent) {
	        return dragStudent.id === student.id;
	      });
	      if (idx < 0) {
	        this.dragStudents.push(student);
	      }
	      this.dragEvt = evt;
	      this.dragEvt.target.classList.add('isDragging');
	      var el = this.$refs.customdrag;
	      el.style.display = 'flex';
	      evt.dataTransfer.setDragImage(el, 0, 0);
	    },
	    dragEnd: function dragEnd() {
	      if (this.dragStudents.length === 0) {
	        return;
	      }
	      this.dragEvt.target.classList.remove('isDragging');
	      this.dragEvt.target.style.display = '';
	      this.dragStudents = [];
	      this.dragEvt = null;
	      this.$refs.customdrag.style.display = 'none';
	    },
	    dragEnter: function dragEnter(klass, evt) {
	      if (this.dragStudents.length === 0) {
	        return;
	      }
	      evt.target.classList.add('isDragEnter');
	    },
	    dragLeave: function dragLeave(evt) {
	      if (this.dragStudents.length === 0) {
	        return;
	      }
	      evt.target.classList.remove('isDragEnter');
	    },
	    drop: function drop(klass) {
	      if (this.dragStudents.length === 0) {
	        return;
	      }
	      this.addStudentsToKlass(this.dragStudents, klass);
	      this.dragEnd();
	      var elements = this.$refs.droppable_elements;
	      for (var i = 0; i < elements.length; i++) {
	        elements[i].classList.remove('isDragEnter');
	      }
	    },
	    addStudentsToKlass: function addStudentsToKlass(students, klass) {
	      var _this6 = this;
	
	      students.forEach(function (student) {
	        var idx = student.calRelations.findIndex(function (relation) {
	          return relation.other_calendar_id === klass.id;
	        });
	        if (idx > -1) {
	          _eventbus2.default.toast = { text: _this6.$t('vue2.students.is_already_in_the_klass'), success: false };
	        } else {
	          var obj = {
	            calendarId: student.id,
	            otherCalendarId: klass.id,
	            relation: 'student_of'
	          };
	          _this6.$store.dispatch('createRelation', obj);
	        }
	      });
	    },
	    removeFromKlass: function removeFromKlass(relation) {
	      this.$store.dispatch('deleteRelation', relation.id);
	    },
	    deleteStudent: function deleteStudent() {
	      this.$store.dispatch('deleteCalendar', this.theActiveStudent.id);
	      this.closeModal();
	    },
	    submitModal: function submitModal() {
	      var calObj = {
	        calendarId: this.theActiveStudent.id,
	        changes: {
	          name: this.editName,
	          feide: this.editFeide
	        }
	      };
	      this.$store.dispatch('updateCalendar', calObj);
	      this.closeModal();
	    },
	    toggleStudentArchived: function toggleStudentArchived(student) {
	      var _this7 = this;
	
	      var calId = student.id;
	      var archive = false;
	      if (!student.archived_at) {
	        archive = true;
	      }
	      var calObj = {
	        calendarId: calId,
	        changes: { archived: archive }
	      };
	      _docendo2.default.schoolCalendarsUpdate(student.school_id, calObj.calendarId, calObj.changes, function (success) {
	        var updateObj = {
	          id: success.id,
	          name: success.name,
	          archived_at: success.archived_at
	        };
	        _this7.$store.commit('updateSchoolCalendar', updateObj);
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.getLatestFeideUpdate();
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('readCalendarRelations');
	    this.updateOffsetTop();
	    window.addEventListener('resize', this.updateOffsetTop);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.updateOffsetTop);
	  }
	};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default, DModal: _DModal2.default },
	  props: {
	    calendarId: {
	      default: '141457'
	    },
	    studentCalendarIds: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isNotEditSubject: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isShowModal: false,
	      studentsForSubject: [],
	      studentsSelected: [],
	      isAddStudentFromAnotherGroup: false
	    };
	  },
	
	  computed: {
	    studentsInArr: function studentsInArr() {
	      var _this = this;
	
	      return this.studentsForSubject.filter(function (id) {
	        return _this.allCalendarsInHash[id];
	      }).map(function (id) {
	        return _this.allCalendarsInHash[id];
	      });
	    },
	    studentsSorted: function studentsSorted() {
	      return this.studentsInArr.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    studentsFromOtherGroups: function studentsFromOtherGroups() {
	      var _this2 = this;
	
	      return this.students.filter(function (student) {
	        var idx = student.klasses.indexOf(_this2.calendarId);
	
	        return idx < 0 && _this2.studentsForSubject.indexOf(student.id) < 0;
	      });
	    },
	    students: function students() {
	      return this.$store.getters.studentCalendars;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassStudents: function klassStudents() {
	      var _this3 = this;
	
	      var students = this.allCalendarsInHash[this.calendarId] && this.allCalendarsInHash[this.calendarId].students ? this.allCalendarsInHash[this.calendarId].students : [];
	      return students.filter(function (studentId) {
	        return _this3.allCalendarsInHash[studentId] && !_this3.allCalendarsInHash[studentId].archived_at;
	      });
	    },
	    getCalendarName: function getCalendarName() {
	      return this.allCalendarsInHash[this.calendarId] ? this.allCalendarsInHash[this.calendarId].name : this.$t('vue2.students.the_group');
	    }
	  },
	  methods: {
	    getStudentKlasses: function getStudentKlasses(student) {
	      var _this4 = this;
	
	      return student.klasses.filter(function (klassCalId) {
	        return _this4.allCalendarsInHash[klassCalId];
	      }).map(function (klassCalId) {
	        return _this4.allCalendarsInHash[klassCalId];
	      });
	    },
	    setStudentsForSubject: function setStudentsForSubject() {
	      var _this5 = this;
	
	      this.klassStudents.forEach(function (studentId) {
	        _this5.studentsForSubject.push(studentId);
	        if (_this5.isNotEditSubject) {
	          _this5.studentsSelected.push(studentId);
	        }
	      });
	      if (this.isNotEditSubject) {
	        this.$emit('changed', this.studentsSelected);
	      }
	    },
	    selectAll: function selectAll() {
	      var _this6 = this;
	
	      if (this.studentsSelected.length === this.studentsSorted.length) {
	        this.studentsSelected = [];
	      } else {
	        this.studentsSorted.forEach(function (student) {
	          var idx = _this6.studentsSelected.indexOf(student.id);
	          if (idx < 0) {
	            _this6.studentsSelected.push(student.id);
	          }
	        });
	      }
	    },
	    addStudentToSubject: function addStudentToSubject(item) {
	      this.studentsForSubject.push(item.id);
	      this.studentsSelected.push(item.id);
	    },
	    isInStudentsSelected: function isInStudentsSelected(itemId) {
	      return this.studentsSelected.indexOf(itemId) > -1;
	    },
	    toggleInStudentsSelected: function toggleInStudentsSelected(itemId) {
	      var idx = this.studentsSelected.indexOf(itemId);
	      if (idx < 0) {
	        this.studentsSelected.push(itemId);
	      } else {
	        this.studentsSelected.splice(idx, 1);
	      }
	    },
	    closeStudentModal: function closeStudentModal() {
	      this.isAddStudentFromAnotherGroup = false;
	      this.isShowModal = false;
	    },
	    submit: function submit() {
	      this.$emit('changed', this.studentsSelected);
	      this.closeStudentModal();
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this7 = this;
	
	    this.setStudentsForSubject();
	
	    this.studentCalendarIds.forEach(function (studentCalId) {
	      if (_this7.klassStudents.indexOf(studentCalId) < 0) {
	        _this7.studentsForSubject.push(studentCalId);
	        _this7.studentsSelected.push(studentCalId);
	      } else {
	        _this7.studentsSelected.push(studentCalId);
	      }
	    });
	  }
	};

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    initialColor: {
	      type: String,
	      default: '#e74c3c'
	    }
	  },
	  watch: {
	    initialColor: function initialColor(val) {
	      var idxOfColor = this.colors.map(function (obj) {
	        return obj.value;
	      }).indexOf(this.initialColor);
	      this.setColor(idxOfColor);
	    },
	    selectedColor: function selectedColor(val) {
	      this.$emit('changedColor', val);
	    }
	  },
	  data: function data() {
	    return {
	      selectedColor: '',
	      colors: [{
	        value: '#e74c3c',
	        title: this.$t('vue2.subject.red'),
	        active: false
	      }, {
	        value: '#cd8c95',
	        title: this.$t('vue2.subject.lightred'),
	        active: false
	      }, {
	        value: '#f08080',
	        title: this.$t('vue2.subject.red2'),
	        active: false
	      }, {
	        value: '#A0A5EF',
	        title: this.$t('vue2.subject.lightpurple'),
	        active: false
	      }, {
	        value: '#6e84c4',
	        title: this.$t('vue2.subject.lightblue'),
	        active: false
	      }, {
	        value: '#9B63E0',
	        title: this.$t('vue2.subject.purple'),
	        active: false
	      }, {
	        value: '#9b59b6',
	        title: this.$t('vue2.subject.darkpurple'),
	        active: false
	      }, {
	        value: '#34495e',
	        title: this.$t('vue2.subject.darkblue'),
	        active: false
	      }, {
	        value: '#0066cc',
	        title: this.$t('vue2.subject.blue'),
	        active: false
	      }, {
	        value: '#578ACC',
	        title: this.$t('vue2.subject.azure'),
	        active: false
	      }, {
	        value: '#87B0BE',
	        title: this.$t('vue2.subject.lightblue2'),
	        active: false
	      }, {
	        value: '#85DD74',
	        title: this.$t('vue2.subject.lightgreen'),
	        active: false
	      }, {
	        value: '#20b2aa',
	        title: this.$t('vue2.subject.marinoblue'),
	        active: false
	      }, {
	        value: '#1abc9c',
	        title: this.$t('vue2.subject.turkis'),
	        active: false
	      }, {
	        value: '#2baf63',
	        title: this.$t('vue2.subject.green'),
	        active: false
	      }, {
	        value: '#93A36C',
	        title: this.$t('vue2.subject.darkgreen'),
	        active: false
	      }, {
	        value: '#cdbe70',
	        title: this.$t('vue2.subject.lightyellow'),
	        active: false
	      }, {
	        value: '#f1c40f',
	        title: this.$t('vue2.subject.darkyellow'),
	        active: false
	      }, {
	        value: '#fcbb2f',
	        title: this.$t('vue2.subject.lightyellow2'),
	        active: false
	      }, {
	        value: '#ff6600',
	        title: this.$t('vue2.subject.orange'),
	        active: false
	      }, {
	        value: '#ff7f50',
	        title: this.$t('vue2.subject.coral'),
	        active: false
	      }, {
	        value: '#EF8430',
	        title: this.$t('vue2.subject.darkorange'),
	        active: false
	      }, {
	        value: '#cd661d',
	        title: this.$t('vue2.subject.darkorange2'),
	        active: false
	      }, {
	        value: '#E1A370',
	        title: this.$t('vue2.subject.bronze'),
	        active: false
	      }, {
	        value: '#97957F',
	        title: this.$t('vue2.subject.lightbrown'),
	        active: false
	      }, {
	        value: '#999999',
	        title: this.$t('vue2.subject.grey'),
	        active: false
	      }, {
	        value: '#564437',
	        title: this.$t('vue2.subject.brown'),
	        active: false
	      }]
	    };
	  },
	
	  methods: {
	    setColor: function setColor(idx) {
	      this.selectedColor = this.colors[idx].value;
	      if (this.$refs.inputradio[idx]) {
	        this.$refs.inputradio[idx].focus();
	      }
	      var el = document.querySelector('#subject_color');
	      if (el) {
	        el.value = this.colors[idx].value;
	      }
	    },
	    isSelectedColor: function isSelectedColor(val) {
	      return this.selectedColor === val;
	    }
	  },
	  mounted: function mounted() {
	    var el = document.querySelector('#subject_color');
	    if (el) {
	      this.initialColor = el.value;
	    }
	    var idxOfColor = this.colors.map(function (obj) {
	      return obj.value;
	    }).indexOf(this.initialColor);
	    this.setColor(idxOfColor);
	  }
	};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _CreateSubjectForm = __webpack_require__(123);
	
	var _CreateSubjectForm2 = _interopRequireDefault(_CreateSubjectForm);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { CreateSubjectForm: _CreateSubjectForm2.default },
	  props: {
	    calendarId: {
	      default: null
	    },
	    isHideCreateButton: {
	      type: Boolean,
	      default: false
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isSubjectModal: false,
	      editSubject: null,
	      editSubjectId: null,
	      calCurrentDate: (0, _moment2.default)()
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    activeCalendar: function activeCalendar() {
	      return this.allCalendarsInHash[this.calendarId];
	    },
	    schoolYearIdToCreateSubject: function schoolYearIdToCreateSubject() {
	      return this.activeCalendar && this.activeCalendar.school_year_id ? this.activeCalendar.school_year_id : this.activeSchoolYear.id;
	    },
	    theEditSubject: function theEditSubject() {
	      return this.$store.state.calendar.editSubject;
	    }
	  },
	  watch: {
	    theEditSubject: function theEditSubject() {
	      if (this.theEditSubject) {
	        this.setEditSubject(this.theEditSubject);
	      }
	    }
	  },
	  methods: {
	    createNewSubject: function createNewSubject(newSubject) {
	      newSubject['schoolYearId'] = this.schoolYearIdToCreateSubject;
	      newSubject['calCurrentdate'] = this.calCurrentDate;
	      if (this.isInDCalendar) {
	        this.$store.dispatch('createCalendarSubject', newSubject);
	      } else {
	        this.$store.dispatch('createSubject', newSubject);
	      }
	      this.closeModal();
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.editSubject = (0, _assign2.default)({}, editSubject);
	      if (this.isInDCalendar && this.editSubject.cals) {
	        this.editSubject.calendar_ids = this.editSubject.cals.map(function (cal) {
	          return cal.id;
	        });
	      }
	      this.isSubjectModal = true;
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      if (this.isInDCalendar) {
	        this.$store.dispatch('updateCalendarSubject', updatedSubject);
	      } else {
	        this.$store.dispatch('updateSubject', updatedSubject);
	      }
	      this.closeModal();
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      if (this.isInDCalendar) {
	        this.$store.dispatch('deleteCalendarSubject', editSubject);
	      } else {
	        var deletedSubject = {
	          id: editSubject.id,
	          school_id: editSubject.school_id,
	          school_year_id: this.activeSchoolYear.id
	        };
	        deletedSubject['schoolYearId'] = this.activeSchoolYear.id;
	        this.$store.dispatch('deleteSubject', deletedSubject);
	      }
	      this.closeModal();
	    },
	    closeModal: function closeModal() {
	      this.editSubject = null;
	      this.editSubjectId = null;
	      this.$store.commit('setEditSubject', null);
	      this.isSubjectModal = false;
	    },
	    setTheEditSubject: function setTheEditSubject(theEditSubject) {
	      this.editSubject = theEditSubject;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('fullcal_view_or_date_changed', function (e) {
	      _this.calCurrentDate = e.detail;
	    }, false);
	
	    window.addEventListener('vue::editSubject', function (e) {
	      _this.editSubjectId = e.detail;
	      _this.isSubjectModal = true;
	    }, false);
	  }
	};

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Modal = __webpack_require__(85);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _DSelectUsers = __webpack_require__(69);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _DSelectKlass = __webpack_require__(304);
	
	var _DSelectKlass2 = _interopRequireDefault(_DSelectKlass);
	
	var _ColorPicker = __webpack_require__(122);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _SubjectFormSubjectType = __webpack_require__(71);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _DSelectCalsIds = __webpack_require__(59);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _SubjectFormLog = __webpack_require__(332);
	
	var _SubjectFormLog2 = _interopRequireDefault(_SubjectFormLog);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _StudentsOnSubject = __webpack_require__(1332);
	
	var _StudentsOnSubject2 = _interopRequireDefault(_StudentsOnSubject);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _SubjectFormDeleteSubjects = __webpack_require__(331);
	
	var _SubjectFormDeleteSubjects2 = _interopRequireDefault(_SubjectFormDeleteSubjects);
	
	var _SubjectFormLogDeletedEvents = __webpack_require__(1333);
	
	var _SubjectFormLogDeletedEvents2 = _interopRequireDefault(_SubjectFormLogDeletedEvents);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    create_subject: 'Opret brik',
	    hours_in_school_year: 'Klokketimer i skoleåret',
	    add_teacher: 'Tilføj underviser',
	    add_room: 'Tilføj lokale',
	    add_klass: 'Tilføj klasse',
	    add_club: 'Tilføj SFO',
	    more_settings: 'Yderligere indstillinger',
	    subject_title: 'Brikkens navn',
	    standard_duration: 'Normal varighed (i minutter)',
	    choose_class: 'Vælg klasse',
	    choose_color: 'Vælg farve',
	    choose_subject_type: 'Vælg briktype',
	    ex_subject: 'Eks. Dansk',
	    cancel: 'Annullér',
	    update_subject: 'Opdatér brik',
	    delete_subject: 'Slet brikken',
	    edit_subject: 'Redigér brik',
	    activity: 'Historik for brik',
	    latest_activity: 'Seneste aktivitet',
	    cannot_delete: 'Ikke muligt at slette, da brikken er skemalagt',
	    choose_school_year: 'Vælg skoleår',
	    can_not_find_subject: 'Kan desværre ikke vise brikken',
	    deleted_lessons: 'Slettede lektioner',
	    out_of_school_desc: 'Personalet vil fremgå som fraværende i vikardækningen, når denne er aktiveret.',
	    out_of_school: 'Ude af huset'
	  },
	  en: {
	    create_subject: 'Create course',
	    hours_in_school_year: 'Hours in school year',
	    add_teacher: 'Add teacher',
	    add_room: 'Add room',
	    add_klass: 'Add grade/group',
	    add_club: 'Add club',
	    more_settings: 'Advanced settings',
	    subject_title: 'Subject title',
	    standard_duration: 'Standard duration (in minutes)',
	    choose_class: 'Choose grade/group',
	    choose_color: 'Choose color',
	    choose_subject_type: 'Choose course category',
	    ex_subject: 'E.g. Math',
	    cancel: 'Cancel',
	    update_subject: 'Update course',
	    delete_subject: 'Delete course',
	    edit_subject: 'Edit course',
	    activity: 'History',
	    latest_activity: 'Activity',
	    cannot_delete: 'Not possible to delete because the subject has lessons in a calendar',
	    choose_school_year: 'Choose school year',
	    can_not_find_subject: 'Unfortunately can not show the subject',
	    deleted_lessons: 'Deleted lessons',
	    out_of_school_desc: 'The staff will appear as absent in the substitute coverage when this is activated.',
	    out_of_school: 'Out of school'
	  },
	  nb: {
	    create_subject: 'Opprett fag',
	    hours_in_school_year: 'Årstimetall',
	    add_teacher: 'Legg til lærer',
	    add_room: 'Legg til lokale',
	    add_klass: 'Legg til klasse',
	    add_club: 'Legg til SFO',
	    more_settings: 'Flere innstillinger',
	    subject_title: 'Navn på fag',
	    standard_duration: 'Normal varighet (i minutter)',
	    choose_class: 'Velg klasse',
	    choose_color: 'Velg farge',
	    choose_subject_type: 'Velg type',
	    ex_subject: 'F.eks. Norsk',
	    cancel: 'Angre',
	    update_subject: 'Oppdater fag',
	    delete_subject: 'Slett fag',
	    edit_subject: 'Rediger fag',
	    activity: 'Historikk',
	    latest_activity: 'Aktivitet',
	    cannot_delete: 'Ikke mulig å slette fordi faget har leksjoner i en kalender',
	    choose_school_year: 'Velg skoleår',
	    can_not_find_subject: 'Kan dessverre ikke vise faget',
	    deleted_lessons: 'Slettede leksjoner',
	    out_of_school_desc: 'Personalet vil vises som fraværende i vikaroversikten når denne er aktivert.',
	    out_of_school: 'Utenfor skolen'
	  }
	};
	
	exports.default = {
	  components: {
	    AppToggle: _AppToggle2.default,
	    StudentsOnSubject: _StudentsOnSubject2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    Loader: _Loader2.default,
	    modal: _Modal2.default,
	    ColorPicker: _ColorPicker2.default,
	    DSelectCalendarIds: _DSelectCalsIds2.default,
	    DSelectUser: _DSelectUsers2.default,
	    DSelectKlass: _DSelectKlass2.default,
	    SubjectTypePicker: _SubjectFormSubjectType2.default,
	    SubjectFormLog: _SubjectFormLog2.default,
	    SubjectFormDeleteSubjects: _SubjectFormDeleteSubjects2.default,
	    SubjectFormLogDeletedEvents: _SubjectFormLogDeletedEvents2.default
	  },
	  props: {
	    initCalendarId: {
	      default: null
	    },
	    showModal: {
	      default: false
	    },
	    editSubject: {
	      default: null
	    },
	    editSubjectId: {
	      default: null
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      preparationOptionsForNorway: [741, 711, 664, 635, 606],
	      preparation: null,
	      theActiveTab: 0,
	      calendarId: null,
	      name: '',
	      color: '#A0A5EF',
	      defaultDuration: 45,
	      hours: 0,
	      subjectType: null,
	      klassCalendarIds: [],
	      userCalendarIds: [],
	      roomCalendarIds: [],
	      studentCalendarIds: [],
	      clubCalendarIds: [],
	      formErrors: [],
	      isLoadingTheEditSubject: false,
	      showDbErrorText: false,
	      subjectCode: '',
	      isPossibleToAddKlasses: false,
	      subjectsWithSameName: [],
	      updatedSubject: null,
	      newSubject: null,
	      isPossibleToAddClub: false,
	      isAway: false
	    };
	  },
	
	  computed: {
	    isArbeidstidsplanActivated: function isArbeidstidsplanActivated() {
	      return this.$store.getters.isArbeidstidsplanActivated;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isSchoolFromNorway: function isSchoolFromNorway() {
	      return this.schoolCountry.toLowerCase() === 'no';
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      var I18N_2 = I18N;
	      if (this.isKindergarten) {
	        I18N_2['da']['add_teacher'] = 'Tilføj pædagog';
	        I18N_2['da']['ex_subject'] = 'Eks. Carina';
	        I18N_2['da']['hours_in_school_year'] = 'Timer i perioden';
	        I18N_2['da']['choose_school_year'] = 'Vælg periode';
	        I18N_2['da']['add_klass'] = 'Tilføj stue';
	      }
	      return I18N_2;
	    },
	    schoolId: function schoolId() {
	      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_id ? this.$route.params.school_id : null;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    isAllowedToAddKlasses: function isAllowedToAddKlasses() {
	      return this.calendarType === 'klass' || this.calendarType === 'user' && this.subjectType !== 'club';
	    },
	    isAllowedToAddClub: function isAllowedToAddClub() {
	      return this.calendarType === 'club' || this.calendarType === 'user' && this.subjectType === 'club';
	    },
	    editSubjectCanBeDeleted: function editSubjectCanBeDeleted() {
	      return this.editSubject && this.editSubject.can_delete || this.editSubject && this.editSubject.actual_hours === null;
	    },
	    isEditSubject: function isEditSubject() {
	      return !this.editSubject;
	    },
	    klassStudents: function klassStudents() {
	      var _this = this;
	
	      var students = this.allCalendarsInHash[this.calendarId] && this.allCalendarsInHash[this.calendarId].students ? this.allCalendarsInHash[this.calendarId].students : [];
	      return students.filter(function (studentId) {
	        return _this.allCalendarsInHash[studentId] && !_this.allCalendarsInHash[studentId].archived_at;
	      });
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    theSchoolForTheSubject: function theSchoolForTheSubject() {
	      var _this2 = this;
	
	      var school = null;
	      if (this.editSubject && this.editSubject.school_id) {
	        var schoolIdx = this.user.schools.findIndex(function (school) {
	          return school.id === _this2.editSubject.school_id;
	        });
	        if (schoolIdx > -1) {
	          school = this.user.schools[schoolIdx];
	        }
	      }
	      return school;
	    },
	    theActiveSchoolYearForTheSubject: function theActiveSchoolYearForTheSubject() {
	      var _this3 = this;
	
	      var schoolYear = null;
	      if (this.editSubject && this.editSubject.school_year_id) {
	        var schoolYearIdx = this.schoolYears.findIndex(function (schoolYear) {
	          return schoolYear.id === _this3.editSubject.school_year_id;
	        });
	        if (schoolYearIdx > -1) {
	          schoolYear = this.schoolYears[schoolYearIdx];
	        }
	      }
	      return schoolYear;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    localActivatedSchoolYear: function localActivatedSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    calendarType: function calendarType() {
	      var calType = this.allCalendarsInHash[this.calendarId] ? this.allCalendarsInHash[this.calendarId].type : 'user';
	      return this.calendarId ? calType : 'klass';
	    },
	    isShowSchool: function isShowSchool() {
	      var userHasMultipleSchools = this.user.schools.length > 1;
	      return this.calendarType === 'user' && userHasMultipleSchools;
	    },
	    isShowSchoolYearSelector: function isShowSchoolYearSelector() {
	      var hasMultipleActiveSchoolYears = this.activeSchoolYears.length > 1;
	      return !this.theActiveSchoolYearForTheSubject && hasMultipleActiveSchoolYears && this.calendarType === 'user';
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassCalendarInHash: function klassCalendarInHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    showMasterCalendarName: function showMasterCalendarName() {
	      return this.editSubject && this.allCalendarsInHash[this.editSubject.calendar_id] && this.allCalendarsInHash[this.editSubject.calendar_id].name ? this.allCalendarsInHash[this.editSubject.calendar_id].name : '';
	    },
	    activeSchoolYearId: function activeSchoolYearId() {
	      return this.editSubject && this.editSubject.school_year_id ? this.editSubject.school_year_id : this.localActivatedSchoolYear.id;
	    },
	    arrOfAllSubjectCalendars: function arrOfAllSubjectCalendars() {
	      var calIds = [];
	      this.userCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.roomCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.klassCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.studentCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.clubCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      return calIds;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    }
	  },
	  watch: {
	    defaultDuration: function defaultDuration(val) {
	      this.removeErrors('defaultDuration');
	    }
	  },
	  methods: {
	    setIsPossibleToAddKlasses: function setIsPossibleToAddKlasses() {
	      this.isPossibleToAddKlasses = true;
	      this.$store.dispatch('readSubjects', this.activeSchoolYearId);
	    },
	    setIsPossibleToAddClub: function setIsPossibleToAddClub() {
	      this.isPossibleToAddClub = true;
	      this.$store.dispatch('readSubjects', this.activeSchoolYearId);
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.userCalendarIds = users.map(function (user) {
	        return user.id;
	      });
	    },
	    setSelectedRooms: function setSelectedRooms(rooms) {
	      this.roomCalendarIds = rooms.map(function (room) {
	        return room.id;
	      });
	    },
	    setSelectedKlass: function setSelectedKlass(klasses) {
	      this.klassCalendarIds = klasses.map(function (klass) {
	        return klass.id;
	      });
	    },
	    setSelectedClub: function setSelectedClub(clubs) {
	      this.clubCalendarIds = clubs.map(function (cal) {
	        return cal.id;
	      });
	    },
	    addKlass: function addKlass(klass) {
	      this.calendarId = klass.id;
	      this.removeErrors('calendarId');
	    },
	    removeKlass: function removeKlass() {
	      this.calendarId = null;
	    },
	    setSubjectColor: function setSubjectColor(val) {
	      this.color = val;
	    },
	    formValidation: function formValidation() {
	      if (this.name.length < 1) {
	        this.$set(this.formErrors, 'name', {
	          da: 'Fag skal have et navn',
	          en: 'Subjects must have a name',
	          nb: 'Fag må ha et navn'
	        });
	      }
	      if (this.hours < 0) {
	        this.$set(this.formErrors, 'hours', {
	          da: 'Skal være 0 eller højere',
	          en: 'Must be zero or greater',
	          nb: 'Må være 0 eller høyere'
	        });
	      }
	      if (!this.isAValidDuration(this.defaultDuration)) {
	        this.$set(this.formErrors, 'defaultDuration', {
	          da: 'Skal være mellem 5 og 1440 minutter',
	          en: 'Must be between 5 to 1440 minutes',
	          nb: 'Må være mellom 5 og 1440 minutter'
	        });
	      }
	      if (!this.calendarId) {
	        this.$set(this.formErrors, 'calendarId', {
	          da: 'Skal vælges. Du kan bagefter kopiere til andre',
	          en: 'Must choose a class. It can later be copied',
	          nb: 'Må velges. Du kan deretter kopiere til andres'
	        });
	      }
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    createSubject: function createSubject() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      this.newSubject = {
	        name: this.name,
	        color: this.color,
	        calendarId: this.calendarId,
	        defaultDuration: this.defaultDuration,
	        preparation: this.preparation,
	        hours: this.hours,
	        subjectType: this.subjectType,
	        calendarIds: this.arrOfAllSubjectCalendars,
	        subjectCode: this.subjectCode,
	        away: this.isAway
	      };
	      if (this.klassCalendarIds.length === 0) {
	        this.$emit('createSubject', this.newSubject);
	      } else {
	        this.checkIfAddedKlassAlreadyHasSubjectWithSameName();
	      }
	    },
	    updateSubject: function updateSubject() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      this.updatedSubject = {
	        id: this.editSubject.id,
	        name: this.name,
	        color: this.color,
	        calendarId: this.calendarId,
	        defaultDuration: this.defaultDuration,
	        preparation: this.preparation,
	        hours: this.hours,
	        subjectType: this.subjectType,
	        calendarIds: this.arrOfAllSubjectCalendars,
	        schoolId: this.theSchoolForTheSubject ? this.theSchoolForTheSubject.id : window.SCHOOL.id,
	        schoolYearId: this.editSubject && this.editSubject.school_year_id ? this.editSubject.school_year_id : this.activeSchoolYear.id,
	        subjectCode: this.subjectCode,
	        away: this.isAway
	      };
	      if (this.klassCalendarIds.length === 0) {
	        this.$emit('updateSubject', this.updatedSubject);
	      } else {
	        this.checkIfAddedKlassAlreadyHasSubjectWithSameName();
	      }
	    },
	    deleteExistingSubjects: function deleteExistingSubjects() {
	      var _this4 = this;
	
	      this.subjectsWithSameName.forEach(function (subject) {
	        _this4.$emit('deleteSubject', subject);
	      });
	      this.createOrUpdate();
	    },
	    keepExistingSubjects: function keepExistingSubjects() {
	      this.subjectsWithSameName = [];
	      this.createOrUpdate();
	    },
	    createOrUpdate: function createOrUpdate() {
	      if (this.editSubject) {
	        this.$emit('updateSubject', this.updatedSubject);
	      } else {
	        this.$emit('createSubject', this.newSubject);
	      }
	    },
	    closeModalSubjectsWithSameName: function closeModalSubjectsWithSameName() {
	      this.subjectsWithSameName = [];
	    },
	    checkIfAddedKlassAlreadyHasSubjectWithSameName: function checkIfAddedKlassAlreadyHasSubjectWithSameName() {
	      var _this5 = this;
	
	      var newKlassesAddedOnSubject = [];
	      this.klassCalendarIds.forEach(function (calId) {
	        if (_this5.editSubject) {
	          if (_this5.editSubject.calendar_ids.indexOf(calId) < 0) {
	            newKlassesAddedOnSubject.push(calId);
	          }
	        } else {
	          newKlassesAddedOnSubject.push(calId);
	        }
	      });
	      if (newKlassesAddedOnSubject.length > 0) {
	        newKlassesAddedOnSubject.forEach(function (calId) {
	          var subjectIdsForKlass = _this5.subjectsInKlassHash[calId] ? _this5.subjectsInKlassHash[calId] : [];
	          var klassSubjects = subjectIdsForKlass.map(function (subjectId) {
	            if (_this5.subjectsInHash[subjectId]) {
	              return _this5.subjectsInHash[subjectId];
	            }
	          });
	          klassSubjects.forEach(function (subject) {
	            if (subject.name === _this5.name) {
	              _this5.subjectsWithSameName.push(subject);
	            }
	          });
	        });
	        if (this.subjectsWithSameName.length === 0) {
	          this.createOrUpdate();
	        }
	      } else {
	        this.createOrUpdate();
	      }
	    },
	    deleteEditSubject: function deleteEditSubject() {
	      this.$emit('deleteSubject', this.editSubject);
	    },
	    clearForm: function clearForm() {
	      this.theActiveTab = 0;
	      this.formErrors = [];
	      this.name = '';
	      this.calendarIds = [];
	      this.hours = 0;
	      this.color = '#A0A5EF';
	      this.setDefaultDuration();
	      this.isLoadingTheEditSubject = false;
	      this.subjectCode = '';
	      this.subjectsWithSameName = [];
	      this.updatedSubject = null;
	      this.newSubject = null;
	      this.preparation = '';
	    },
	    isAValidDuration: function isAValidDuration(duration) {
	      return (/^-?[\d.]+(?:e-?\d+)?$/.test(duration) && duration > 4 && duration < 1441
	      );
	    },
	    close: function close() {
	      this.clearForm();
	      this.$emit('close');
	    },
	    selectSubjectType: function selectSubjectType(subjectType) {
	      this.subjectType = subjectType;
	
	      if (this.subjectType === 'other_tasks' || this.subjectType === 'other_stuff' || this.subjectType === 'club') {
	        this.klassCalendarIds = [];
	        this.isPossibleToAddKlasses = false;
	      }
	      if (this.subjectType !== 'club') {
	        this.clubCalendarIds = [];
	        this.isPossibleToAddClub = false;
	      }
	    },
	    readTheEditSubject: function readTheEditSubject(editSubjectId) {
	      var _this6 = this;
	
	      _docendo2.default.showSubject(editSubjectId, function (success) {
	        _this6.$emit('setTheEditSubject', success);
	        if (success.status === 'error') {
	          _this6.setErrorMessage();
	          return;
	        }
	        setTimeout(function (_) {
	          _this6.setTheEditSubject();
	        }, 0);
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    setErrorMessage: function setErrorMessage() {
	      this.showDbErrorText = true;
	      this.isLoadingTheEditSubject = false;
	    },
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    setTheEditSubject: function setTheEditSubject() {
	      var _this7 = this;
	
	      console.log('this.editSubject.away', this.editSubject);
	      this.name = this.editSubject.name;
	      this.color = this.editSubject.color;
	      this.hours = this.editSubject.hours;
	      this.defaultDuration = this.editSubject.default_duration;
	      this.subjectType = this.editSubject.subject_type;
	      this.calendarId = this.editSubject.calendar_id;
	      this.subjectCode = this.editSubject.subject_code;
	      if (typeof this.editSubject.away !== 'undefined') {
	        this.isAway = this.editSubject.away;
	      }
	      if (this.editSubject.preparation) {
	        this.preparation = this.editSubject.preparation * 1;
	      }
	      if (this.editSubject.calendar_ids) {
	        var klassCounter = 0;
	        this.editSubject.calendar_ids.forEach(function (calid) {
	          if (_this7.allCalendarsInHash[calid] && _this7.allCalendarsInHash[calid].type === 'user') {
	            _this7.userCalendarIds.push(calid);
	          }
	          if (_this7.allCalendarsInHash[calid] && _this7.allCalendarsInHash[calid].type === 'room') {
	            _this7.roomCalendarIds.push(calid);
	          }
	          if (_this7.allCalendarsInHash[calid] && _this7.allCalendarsInHash[calid].type === 'club' && calid !== _this7.calendarId) {
	            _this7.isPossibleToAddClub = true;
	            _this7.clubCalendarIds.push(calid);
	          }
	          if (_this7.allCalendarsInHash[calid] && _this7.allCalendarsInHash[calid].type === 'klass' && calid !== _this7.calendarId) {
	            if (klassCounter === 0) {
	              _this7.setIsPossibleToAddKlasses();
	            }
	            _this7.klassCalendarIds.push(calid);
	            klassCounter++;
	          }
	          if (_this7.allCalendarsInHash[calid] && _this7.allCalendarsInHash[calid].type === 'student') {
	            _this7.studentCalendarIds.push(calid);
	          }
	        });
	      }
	      this.isLoadingTheEditSubject = false;
	    },
	    setStudentCalendarIds: function setStudentCalendarIds(arr) {
	      this.studentCalendarIds = arr;
	    },
	    setDefaultDuration: function setDefaultDuration() {
	      if (this.activeSchool && this.activeSchool.subject_default_duration) {
	        this.defaultDuration = this.activeSchool.subject_default_duration;
	      } else {
	        this.defaultDuration = 45;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.initCalendarId) {
	      this.calendarId = this.initCalendarId;
	    }
	    if (this.editSubjectId) {
	      this.isLoadingTheEditSubject = true;
	      this.readTheEditSubject(this.editSubjectId);
	    }
	    if (this.editSubject) {
	      this.setTheEditSubject();
	    }
	    if (!this.editSubject && !this.editSubjectId) {
	      this.setDefaultDuration();
	    }
	  },
	  mounted: function mounted() {
	    var _this8 = this;
	
	    if (!this.isInDCalendar && this.editSubject) {
	      if (this.theActiveTab === 0) {
	        setTimeout(function (_) {
	          _this8.$refs.inputLessonCount.focus();
	        }, 500);
	      }
	      return;
	    }
	    this.$nextTick(function (_) {
	      _this8.$refs.name.focus();
	    });
	  }
	};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calendarId: {},
	    noSubjects: {
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      klassHasNoSubjects: false,
	      i18n: {
	        da: {
	          no_subjects_created: 'Ingen fag er oprettet. Du kan enten',
	          import_subjects: 'importere standardfag',
	          or_click_on_create_subject: 'eller klikke på "Opret brik"'
	        },
	        nb: {
	          no_subjects_created: 'Det er ikke opprettet fag. Du kan enten',
	          import_subjects: 'importere standardfag',
	          or_click_on_create_subject: 'eller trykke på "Opprett fag"'
	        }
	      },
	      en: {
	        no_subjects_created: 'No courses have been created. You can choose to either',
	        import_subjects: 'import courses',
	        or_click_on_create_subject: 'or create them yourself by clicking on "Create course”'
	      }
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    allKlassCalendarsInHash: function allKlassCalendarsInHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    theCalendar: function theCalendar() {
	      return this.allKlassCalendarsInHash[this.calendarId] ? this.allKlassCalendarsInHash[this.calendarId] : null;
	    }
	  },
	  methods: {
	    setImportSubjects: function setImportSubjects() {
	      _eventbus2.default.theKlassesToImportSubjectTo = [this.theCalendar];
	      _eventbus2.default.createKlassModal = true;
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.klassHasNoSubjects = this.noSubjects;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('vueUpdateSidebarSubjects', function (evt) {
	      _this.klassHasNoSubjects = false;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this2 = this;
	
	    window.removeEventListener('vueUpdateSidebarSubjects', function (evt) {
	      _this2.klassHasNoSubjects = false;
	    });
	  }
	};

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    closeCrossColor: {
	      default: '#ffffff'
	    },
	    isCloseOnEsc: {
	      type: Boolean,
	      default: true
	    }
	  },
	  methods: {
	    handleKeydown: function handleKeydown(event) {
	      if (event.key === 'Escape' && this.isCloseOnEsc) {
	        this.$emit('close');
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (!document.querySelector('body').classList.contains('no-scroll')) {
	      document.querySelector('body').classList.add('no-scroll');
	    }
	  },
	  mounted: function mounted() {
	    window.addEventListener('keydown', this.handleKeydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.querySelector('body').classList.remove('no-scroll');
	    window.removeEventListener('keydown', this.handleKeydown);
	  }
	};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Modal = __webpack_require__(85);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _DSelectUsers = __webpack_require__(69);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _DSelectKlass = __webpack_require__(304);
	
	var _DSelectKlass2 = _interopRequireDefault(_DSelectKlass);
	
	var _ColorPicker = __webpack_require__(122);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _SubjectFormSubjectType = __webpack_require__(71);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _DSelectCalsIds = __webpack_require__(59);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _SubjectFormLog = __webpack_require__(332);
	
	var _SubjectFormLog2 = _interopRequireDefault(_SubjectFormLog);
	
	var _StandardDurationSetting = __webpack_require__(121);
	
	var _StandardDurationSetting2 = _interopRequireDefault(_StandardDurationSetting);
	
	var _SubjectFormDeleteSubjects = __webpack_require__(331);
	
	var _SubjectFormDeleteSubjects2 = _interopRequireDefault(_SubjectFormDeleteSubjects);
	
	var _SubjectFormReductions = __webpack_require__(1334);
	
	var _SubjectFormReductions2 = _interopRequireDefault(_SubjectFormReductions);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    create_subject: 'Opret fag',
	    hours_in_school_year: 'Klokketimer i skoleåret',
	    add_teacher: 'Tilføj underviser',
	    add_room: 'Tilføj lokale',
	    add_klass: 'Tilføj klasse',
	    more_settings: 'Yderligere indstillinger',
	    subject_title: 'Fagets navn',
	    standard_duration: 'Normal varighed (i minutter)',
	    choose_class: 'Vælg klasse',
	    choose_color: 'Vælg farve',
	    choose_subject_type: 'Vælg briktype',
	    ex_subject: 'Eks. Dansk',
	    cancel: 'Annullér',
	    update_subject: 'Opdatér',
	    delete_subject: 'Slet faget i klassen',
	    edit_subject: 'Redigér',
	    activity: 'Historik',
	    latest_activity: 'Seneste aktivitet',
	    cannot_delete: 'Ikke muligt at slette, da brikken er skemalagt',
	    requested_by: 'Ønsket af'
	  },
	  en: {
	    create_subject: 'Create subject',
	    hours_in_school_year: 'Hours in school year',
	    add_teacher: 'Add teacher',
	    add_klass: 'Add grade/group',
	    add_room: 'Add room',
	    more_settings: 'Advanced settings',
	    subject_title: 'Subject title',
	    standard_duration: 'Standard duration (in minutes)',
	    choose_class: 'Choose class',
	    choose_color: 'Choose color',
	    choose_subject_type: 'Choose subject category',
	    ex_subject: 'E.g. Math',
	    cancel: 'Cancel',
	    update_subject: 'Update subject',
	    delete_subject: 'Delete subject in class',
	    edit_subject: 'Edit subject',
	    activity: 'History',
	    latest_activity: 'Activity',
	    cannot_delete: 'Not possible to delete because the subject has lessons in a calendar',
	    requested_by: 'Requested by'
	  },
	  nb: {
	    create_subject: 'Opprett fag',
	    hours_in_school_year: 'Årstimetall',
	    add_teacher: 'Legg til lærer',
	    add_room: 'Legg til lokale',
	    add_klass: 'Legg til klasse',
	    more_settings: 'Flere innstillinger',
	    subject_title: 'Navn på fag',
	    standard_duration: 'Normal varighet (i minutter)',
	    choose_class: 'Velg klasse',
	    choose_color: 'Velg farge',
	    choose_subject_type: 'Velg type',
	    ex_subject: 'F.eks. Norsk',
	    cancel: 'Angre',
	    update_subject: 'Oppdater fag',
	    delete_subject: 'Slett fag',
	    edit_subject: 'Rediger fag',
	    activity: 'Historikk',
	    latest_activity: 'Aktivitet',
	    cannot_delete: 'Ikke mulig å slette fordi faget har leksjoner i en kalender',
	    requested_by: 'Ønsket av'
	  }
	};
	
	exports.default = {
	  components: {
	    Loader: _Loader2.default,
	    SubjectFormReductions: _SubjectFormReductions2.default,
	    StandardDurationSetting: _StandardDurationSetting2.default,
	    modal: _Modal2.default,
	    ColorPicker: _ColorPicker2.default,
	    DSelectCalendarIds: _DSelectCalsIds2.default,
	    DSelectUser: _DSelectUsers2.default,
	    DSelectKlass: _DSelectKlass2.default,
	    SubjectTypePicker: _SubjectFormSubjectType2.default,
	    SubjectFormLog: _SubjectFormLog2.default,
	    SubjectFormDeleteSubjects: _SubjectFormDeleteSubjects2.default
	  },
	  props: {
	    showModal: {
	      default: false
	    },
	    editSubject: {
	      default: null
	    },
	    isShowSubjectsRequest: {
	      type: Boolean,
	      default: false
	    },
	    subjectsRequestsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    isActivities: {
	      type: Boolean,
	      default: false
	    },
	    propCalendarId: {
	      default: null
	    },
	    propTab: {
	      default: null
	    },
	    isShowReductions: {
	      default: false
	    },
	    propIsLoading: {
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      preparationOptionsForNorway: [741, 711, 664, 635, 606],
	      preparation: null,
	      name: '',
	      color: '#A0A5EF',
	      calendarId: null,
	      defaultDuration: 45,
	      hours: 0,
	      subjectType: null,
	      klassCalendarIds: [],
	      userCalendarIds: [],
	      roomCalendarIds: [],
	      formErrors: [],
	      isEditSubjectAdvanced: false,
	      activeTab: 'edit',
	      subjectCode: '',
	      isOpenDurationModal: false,
	      isPossibleToAddKlasses: false,
	      subjectsWithSameName: [],
	      updatedSubject: null
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    subjectRequestedBy: function subjectRequestedBy() {
	      var _this = this;
	
	      if (!this.isShowSubjectsRequest || !this.editSubject) {
	        return [];
	      }
	      var calendarIds = this.subjectsRequestsInHash[this.editSubject.id] || [];
	      return calendarIds.filter(function (calId) {
	        return _this.allCalendarsInHash[calId];
	      }).map(function (calId) {
	        return _this.allCalendarsInHash[calId]['name'];
	      }).join(' ,');
	    },
	    isArbeidstidsplanActivated: function isArbeidstidsplanActivated() {
	      return this.$store.getters.isArbeidstidsplanActivated;
	    },
	    isReductionsActive: function isReductionsActive() {
	      return this.$store.getters.isReductionsActive;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    isAllowedToAddKlasses: function isAllowedToAddKlasses() {
	      return this.calendarType === 'klass' || this.calendarType === 'user';
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userCanManageSchool: function userCanManageSchool() {
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf('can_manage_school') > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    editSubjectCanBeDeleted: function editSubjectCanBeDeleted() {
	      return this.editSubject && this.editSubject.can_delete;
	    },
	    isSubjectCodeActive: function isSubjectCodeActive() {
	      var schoolIsFromNorway = window.SCHOOL && window.SCHOOL.country && window.SCHOOL.country.toLowerCase() === 'no';
	      var userIsJeppe = this.user && this.user.id * 1 === 15;
	      return schoolIsFromNorway || userIsJeppe;
	    },
	    calendarType: function calendarType() {
	      return this.calendarId ? this.allCalendarsInHash[this.calendarId].type : 'klass';
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    klassCalendarInHash: function klassCalendarInHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    showMasterCalendarName: function showMasterCalendarName() {
	      return this.editSubject && this.allCalendarsInHash[this.editSubject.calendar_id] && this.allCalendarsInHash[this.editSubject.calendar_id].name ? this.allCalendarsInHash[this.editSubject.calendar_id].name : '';
	    }
	  },
	  watch: {
	    defaultDuration: function defaultDuration(val) {
	      this.removeErrors('defaultDuration');
	    },
	
	    editSubject: {
	      handler: function handler() {
	        this.handleEditSubject();
	      },
	
	      immediate: true
	    }
	  },
	  methods: {
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.userCalendarIds = users.map(function (user) {
	        return user.id;
	      });
	    },
	    setSelectedRooms: function setSelectedRooms(rooms) {
	      this.roomCalendarIds = rooms.map(function (room) {
	        return room.id;
	      });
	    },
	    setSelectedKlass: function setSelectedKlass(klasses) {
	      this.klassCalendarIds = klasses.map(function (klass) {
	        return klass.id;
	      });
	    },
	    addKlass: function addKlass(klass) {
	      this.calendarId = klass.id;
	      this.removeErrors('calendarId');
	    },
	    removeKlass: function removeKlass() {
	      this.calendarId = null;
	    },
	    setSubjectColor: function setSubjectColor(val) {
	      this.color = val;
	    },
	    formValidation: function formValidation() {
	      if (this.name.length < 1) {
	        this.$set(this.formErrors, 'name', {
	          da: 'Fag skal have et navn',
	          en: 'Subjects must have a name',
	          nb: 'Fag må ha et navn'
	        });
	      }
	      if (this.hours < 0) {
	        this.$set(this.formErrors, 'hours', {
	          da: 'Skal være 0 eller højere',
	          en: 'Must be zero or greater',
	          nb: 'Må være 0 eller høyere'
	        });
	      }
	      if (!this.isAValidDuration(this.defaultDuration)) {
	        this.$set(this.formErrors, 'defaultDuration', {
	          da: 'Må ikke være højere end 1440 minutter',
	          en: 'Can not be greater than 1440 minutes',
	          nb: 'Kan ikke være lengre enn 1440 minutter'
	        });
	      }
	      if (!this.calendarId) {
	        this.$set(this.formErrors, 'calendarId', {
	          da: 'Skal vælges. Du kan bagefter kopiere til andre',
	          en: 'Must choose a class. It can later be copied',
	          nb: 'Må velges. Du kan deretter kopiere til andres'
	        });
	      }
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    createSubject: function createSubject() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var newSubject = {
	        name: this.name,
	        color: this.color,
	        calendarId: this.calendarId,
	        defaultDuration: this.defaultDuration,
	        hours: this.hours,
	        subjectType: this.subjectType,
	        calendarIds: [],
	        subjectCode: this.subjectCode,
	        preparation: this.preparation
	      };
	      this.$emit('createSubject', newSubject);
	    },
	    updateSubject: function updateSubject() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var calIds = [];
	      this.userCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.roomCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.klassCalendarIds.forEach(function (calId) {
	        calIds.push(calId);
	      });
	      this.updatedSubject = {
	        id: this.editSubject.id,
	        name: this.name,
	        color: this.color,
	        calendarId: this.calendarId,
	        defaultDuration: this.defaultDuration,
	        preparation: this.preparation,
	        hours: this.hours,
	        subjectType: this.subjectType,
	        calendarIds: calIds,
	        subjectCode: this.subjectCode
	      };
	      if (this.klassCalendarIds.length === 0) {
	        this.$emit('updateSubject', this.updatedSubject);
	      } else {
	        this.checkIfAddedKlassAlreadyHasSubjectWithSameName();
	      }
	    },
	    checkIfAddedKlassAlreadyHasSubjectWithSameName: function checkIfAddedKlassAlreadyHasSubjectWithSameName() {
	      var _this2 = this;
	
	      var newKlassesAddedOnSubject = [];
	      this.klassCalendarIds.forEach(function (calId) {
	        if (_this2.editSubject.calendar_ids.indexOf(calId) < 0) {
	          newKlassesAddedOnSubject.push(calId);
	        }
	      });
	      if (newKlassesAddedOnSubject.length > 0) {
	        newKlassesAddedOnSubject.forEach(function (calId) {
	          var subjectIdsForKlass = _this2.subjectsInKlassHash[calId];
	          var klassSubjects = subjectIdsForKlass.map(function (subjectId) {
	            if (_this2.subjectsInHash[subjectId]) {
	              return _this2.subjectsInHash[subjectId];
	            }
	          });
	          klassSubjects.forEach(function (subject) {
	            if (subject.name === _this2.name) {
	              _this2.subjectsWithSameName.push(subject);
	            }
	          });
	        });
	        if (this.subjectsWithSameName.length === 0) {
	          this.$emit('updateSubject', this.updatedSubject);
	        }
	      } else {
	        this.$emit('updateSubject', this.updatedSubject);
	      }
	    },
	    deleteExistingSubjects: function deleteExistingSubjects() {
	      var _this3 = this;
	
	      this.subjectsWithSameName.forEach(function (subject) {
	        _this3.$emit('deleteSubject', subject);
	      });
	      this.$emit('updateSubject', this.updatedSubject);
	    },
	    keepExistingSubjects: function keepExistingSubjects() {
	      this.subjectsWithSameName = [];
	      this.$emit('updateSubject', this.updatedSubject);
	    },
	    closeModalSubjectsWithSameName: function closeModalSubjectsWithSameName() {
	      this.subjectsWithSameName = [];
	    },
	    deleteEditSubject: function deleteEditSubject() {
	      this.$emit('deleteSubject', this.editSubject);
	    },
	    clearForm: function clearForm() {
	      this.formErrors = [];
	      this.name = '';
	      this.calendarIds = [];
	      this.hours = 0;
	      this.color = '#A0A5EF';
	      this.setDefaultDuration();
	      this.subjectCode = '';
	      this.subjectsWithSameName = [];
	      this.updatedSubject = null;
	      this.preparation = '';
	    },
	    close: function close() {
	      this.clearForm();
	      this.$emit('close');
	    },
	    selectSubjectType: function selectSubjectType(subjectType) {
	      this.subjectType = subjectType;
	    },
	    saveUpdatedDuration: function saveUpdatedDuration() {
	      this.setDefaultDuration();
	      this.$refs.input_default_duration.focus();
	      this.$refs.input_default_duration.select();
	    },
	    setDefaultDuration: function setDefaultDuration() {
	      if (this.activeSchool && this.activeSchool.subject_default_duration) {
	        this.defaultDuration = this.activeSchool.subject_default_duration;
	      } else {
	        this.defaultDuration = 45;
	      }
	    },
	    isAValidDuration: function isAValidDuration(duration) {
	      return (/^-?[\d.]+(?:e-?\d+)?$/.test(duration) && duration > 0 && duration < 1440
	      );
	    },
	    handleEditSubject: function handleEditSubject() {
	      var _this4 = this;
	
	      if (this.editSubject) {
	        this.name = this.editSubject.name;
	        this.color = this.editSubject.color;
	        this.hours = this.editSubject.hours;
	        this.defaultDuration = this.editSubject.default_duration;
	        this.subjectType = this.editSubject.subject_type;
	        this.calendarId = this.editSubject.calendar_id;
	        this.subjectCode = this.editSubject.subject_code;
	
	        if (this.editSubject.preparation) {
	          this.preparation = this.editSubject.preparation;
	        }
	
	        var cals = this.editSubject.calendar_ids ? this.editSubject.calendar_ids : this.editSubject.cals;
	        if (cals) {
	          cals.forEach(function (calid) {
	            if (_this4.allCalendarsInHash[calid] && _this4.allCalendarsInHash[calid].type === 'user') {
	              _this4.userCalendarIds.push(calid);
	            }
	            if (_this4.allCalendarsInHash[calid] && _this4.allCalendarsInHash[calid].type === 'room') {
	              _this4.roomCalendarIds.push(calid);
	            }
	            if (_this4.allCalendarsInHash[calid] && _this4.allCalendarsInHash[calid].type === 'klass' && calid !== _this4.calendarId) {
	              _this4.isPossibleToAddKlasses = true;
	              _this4.klassCalendarIds.push(calid);
	            }
	          });
	        }
	      } else {
	        this.setDefaultDuration();
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.propTab) {
	      this.activeTab = this.propTab;
	    }
	    if (this.isActivities) {
	      this.subjectType = 'activity';
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    if (this.propCalendarId) {
	      this.calendarId = this.propCalendarId;
	    }
	    if (this.editSubject) {
	      if (this.activeTab === 'edit') {
	        setTimeout(function (_) {
	          _this5.$refs.inputLessonCount.focus();
	        }, 500);
	      }
	      return;
	    }
	    setTimeout(function (_) {
	      _this5.$refs.name.focus();
	    }, 150);
	  }
	};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    subjectsWithSameName: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      locale: 'da',
	      i18n: {
	        da: {
	          exists: 'findes allerede',
	          the_subject: 'Faget',
	          already_exists: 'findes allerede i klassen/klasserne, du er ved at tilføje på faget.',
	          do_you_want_to_delete: 'Vil du slette eksisterende fag',
	          create_new_anyway: 'Behold eksisterende',
	          delete: 'Slet eksisterende fag',
	          subject_cannot_be_deleted: 'Disse fag kan ikke slettes, da de er skemalagt'
	        },
	        en: {
	          exists: 'already exists',
	          delete_existing_subjects: 'Delete already existing course',
	          the_subject: 'The course',
	          already_exists: 'already exists in the grades/groups.',
	          do_you_want_to_delete: 'Would you like to delete the already existing course?',
	          create_new_anyway: 'Keep existing',
	          delete: 'Delete already existing course',
	          subject_cannot_be_deleted: 'These courses cannot be deleted, as they contain scheduled activities.'
	        },
	        nb: {
	          exists: 'er allerede opprettet',
	          delete_existing_subjects: 'Slett eksisterende fag',
	          the_subject: 'Faget',
	          already_exists: 'finnes allerede i klassen/klassene du ønsker å legge til.',
	          do_you_want_to_delete: 'Vil du slette allerede eksisterende fag',
	          create_new_anyway: 'Legg til fag til i klassen allikevel',
	          delete: 'Slett eksisterende fag',
	          subject_cannot_be_deleted: 'Disse fagene kan ikke slettes, ettersom de inngår i planlagte timer i timeplanene.'
	        }
	      }
	    };
	  },
	
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsCanBeDeleted: function subjectsCanBeDeleted() {
	      return this.subjectsWithSameName.filter(function (subject) {
	        return subject.can_delete;
	      });
	    },
	    subjectsCanBeDeletedWithVProps: function subjectsCanBeDeletedWithVProps() {
	      var _this = this;
	
	      return this.subjectsCanBeDeleted.map(function (subject) {
	        subject.v_calendar_name = _this.allCalendarsInHash[subject.calendar_id] ? _this.allCalendarsInHash[subject.calendar_id].name : subject.calendar_id;
	        return subject;
	      });
	    },
	    subjectsCannotDelete: function subjectsCannotDelete() {
	      return this.subjectsWithSameName.filter(function (subject) {
	        return !subject.can_delete;
	      });
	    },
	    subjectsCannotDeleteWithVProps: function subjectsCannotDeleteWithVProps() {
	      var _this2 = this;
	
	      return this.subjectsCannotDelete.map(function (subject) {
	        subject.v_calendar_name = _this2.allCalendarsInHash[subject.calendar_id] ? _this2.allCalendarsInHash[subject.calendar_id].name : subject.calendar_id;
	        return subject;
	      });
	    },
	    firstInSubjectsWithSameName: function firstInSubjectsWithSameName() {
	      return this.subjectsWithSameName[0] ? this.subjectsWithSameName[0] : { name: '', color: '' };
	    }
	  },
	  methods: {
	    close: function close() {
	      this.$emit('close');
	    },
	    keepExistingSubjects: function keepExistingSubjects() {
	      this.$emit('keep');
	    },
	    deleteExistingSubjects: function deleteExistingSubjects() {
	      this.$emit('delete');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.language ? window.language : 'da';
	  }
	};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default },
	  props: {
	    subject: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          there_is_no_logged_activity: 'Der er ingen historik',
	          no_changes: 'Ingen ændringer foretaget',
	          created_subject: 'Oprettede faget',
	          from: 'fra',
	          to: 'til',
	          added: 'Tilføjede',
	          added_user: 'Tilføjede underviser',
	          added_room: 'Tilføjede lokalet',
	          removed: 'Fjernede',
	          removed_room: 'Fjernede lokalet',
	          removed_user: 'Fjernede underviseren',
	          changed: 'Ændrede',
	          changed_hours_in_school_year_from: 'Ændrede timer i skoleåret fra',
	          changed_subject_name_from: 'Ændrede fagets navn fra',
	          changed_subject_default_duration_from: 'Ændrede fagets normale varighed fra',
	          changed_subject_color: 'Ændrede fagets farve',
	          changed_subject_type_from: 'Ændrede fagets type fra',
	          subject: 'Fag',
	          supplemental: 'UUV',
	          frame: 'Temavisning (Ramme)',
	          break: 'break',
	          resource: 'Ressource',
	          optional: 'Valgfag/Hold',
	          ago: 'siden'
	        },
	        en: {
	          there_is_no_logged_activity: 'No history',
	          no_changes: 'No changes made',
	          created_subject: 'created the subject',
	          from: 'from',
	          to: 'to',
	          added: 'Added',
	          added_user: 'Added teacher',
	          added_room: 'Added room',
	          removed: 'Removed',
	          removed_room: 'Removed room',
	          removed_user: 'Removed the teacher',
	          changed: 'Changed',
	          changed_hours_in_school_year_from: 'Changed annual isntruction time from',
	          changed_subject_name_from: 'Changed the subject title from',
	          changed_subject_default_duration_from: 'Changed the subject standard duration from',
	          changed_subject_color: 'Changed the subject color',
	          changed_subject_type_from: 'Changed the subject category from',
	          subject: 'subject',
	          supplemental: 'UUV',
	          frame: 'Theme/focus',
	          break: 'break',
	          resource: 'Resource',
	          optional: 'Elective',
	          ago: 'ago'
	        },
	        nb: {
	          there_is_no_logged_activity: 'Ingen historikk',
	          no_changes: 'Ingen endringer er blitt gjort',
	          created_subject: 'Opprettet faget',
	          from: 'fra',
	          to: 'til',
	          added: 'La til',
	          added_user: 'La til underviser',
	          added_room: 'La til lokalet',
	          removed: 'Fjernet',
	          removed_room: 'Fjernet lokalet',
	          removed_user: 'Fjernet underviseren',
	          changed: 'Endret',
	          changed_hours_in_school_year_from: 'Endret timer i skoleåret fra',
	          changed_subject_name_from: 'Endret fagets navn fra',
	          changed_subject_default_duration_from: 'Endret fagets normale varighet fra',
	          changed_subject_color: 'Endret fagets farge',
	          changed_subject_type_from: 'Endret fagets type fra',
	          subject: 'Fag',
	          supplemental: 'UUV',
	          frame: 'Temavisning (Ramme)',
	          break: 'Pause',
	          resource: 'Ressurs',
	          optional: 'Valgfag',
	          ago: 'siden'
	        }
	      },
	      isLoading: true,
	      activities: null
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    usersHash: function usersHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    sortedActivities: function sortedActivities() {
	      var withoutNull = this.activities.filter(function (activity) {
	        return activity;
	      });
	      return withoutNull.sort(function (a, b) {
	        return new Date(b.at) - new Date(a.at);
	      });
	    },
	    packedActivities: function packedActivities() {
	      var sortedOnTimestamp = [];
	      for (var i = 0; i < this.sortedActivities.length; i++) {
	        var lastSortedTimestamp = sortedOnTimestamp[sortedOnTimestamp.length - 1];
	
	        var isWithinFiveMinutes = lastSortedTimestamp && (0, _moment2.default)(lastSortedTimestamp.at).format('YYYYMMDDh:mm') === (0, _moment2.default)(this.sortedActivities[i].at).format('YYYYMMDDh:mm');
	        if (isWithinFiveMinutes && lastSortedTimestamp.by && lastSortedTimestamp.by.id === this.sortedActivities[i].by.id) {
	          sortedOnTimestamp[sortedOnTimestamp.length - 1].changes.push(this.sortedActivities[i]);
	        } else {
	          this.$set(this.sortedActivities[i], 'changes', [this.sortedActivities[i]]);
	          sortedOnTimestamp.push(this.sortedActivities[i]);
	        }
	      }
	      return sortedOnTimestamp;
	    }
	  },
	  methods: {
	    humanizeChange: function humanizeChange(change) {
	      var text = '';
	      if (change.ta === 'subject_calendars') {
	        if (change.ac === 'I') {
	          text += '<p><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['added'] + ' ' + change.refs.calendar.name + '</p>';
	        }
	        if (change.ac === 'D') {
	          text += '<p><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['removed'] + ' ' + change.refs.calendar.name + '</p>';
	        }
	      } else if (change.ta === 'subjects' && !change.new) {
	        text += '<p>' + this.i18n[this.locale]['created_subject'] + '</p>';
	      } else if (change.ta === 'subjects' && change.new) {
	        for (var prop in change.new) {
	          if (prop === 'hours') {
	            text += '<p>' + this.i18n[this.locale].changed_hours_in_school_year_from + ' ' + change.old.hours + ' ' + this.i18n[this.locale].to + '  ' + change.new.hours + '</p>';
	          }
	          if (prop === 'default_duration') {
	            text += '<p>' + this.i18n[this.locale].changed_subject_default_duration_from + ' ' + change.old.default_duration + ' ' + this.i18n[this.locale].to + '  ' + change.new.default_duration + '</p>';
	          }
	          if (prop === 'name') {
	            text += '<p>' + this.i18n[this.locale].changed_subject_name_from + ' ' + change.old.name + ' ' + this.i18n[this.locale].to + '  ' + change.new.name + '</p>';
	          }
	          if (prop === 'color') {
	            text += '<p>' + this.i18n[this.locale].changed_subject_color + '</p>';
	          }
	          if (prop === 'subject_type') {
	            text += '<p>' + this.i18n[this.locale].changed_subject_type_from + ' ' + this.i18n[this.locale][change.old.subject_type] + ' ' + this.i18n[this.locale].to + ' ' + this.i18n[this.locale][change.new.subject_type] + '</p>';
	          }
	        }
	      }
	      return text;
	    },
	    formatDate: function formatDate(datetime) {
	      _moment2.default.locale(this.locale);
	      return (0, _moment2.default)(datetime).format('LLL');
	    },
	    getDuration: function getDuration(datetime) {
	      _moment2.default.locale(this.locale);
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(datetime));
	      return _moment2.default.duration(diff).humanize();
	    },
	    getSubjectLog: function getSubjectLog() {
	      var _this = this;
	
	      var schoolId = this.subject.school_id;
	      _docendo2.default.auditSubject(schoolId, this.subject.id, function (data) {
	        _this.activities = data.hasOwnProperty('data') ? [] : JSON.parse(data);
	        _this.isLoading = false;
	      }, function (failure) {
	        console.log('failed', failure);
	      });
	    },
	    getUserImg: function getUserImg(activity) {
	      var userId = activity.by.id;
	      return this.usersHash[userId].default_thumb_url;
	    },
	    getUserName: function getUserName(activity) {
	      return activity.by ? activity.by.name : '';
	    }
	  },
	  mounted: function mounted() {
	    this.getSubjectLog();
	  }
	};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    subject: {
	      required: true,
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      log: [],
	      isLoading: false
	    };
	  },
	
	  computed: {
	    sortedLog: function sortedLog() {
	      var _this = this;
	
	      return this.log.slice().sort(function (a, b) {
	        return (0, _moment2.default)(b.ts).valueOf() - (0, _moment2.default)(a.ts).valueOf();
	      }).map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          v_formattedDate: _this.formatDate(item.ts),
	          v_humanizedDate: _this.getDuration(item.ts),
	          v_eventDate: _this.getEventDate(item)
	        });
	      });
	    }
	  },
	  methods: {
	    getEventDate: function getEventDate(item) {
	      var start = item.start_time ? (0, _moment2.default)(item.start_time).format('llll') : '';
	      var end = item.end_time ? (0, _moment2.default)(item.end_time).format('LT') : '';
	      return start + ' - ' + end;
	    },
	    formatDate: function formatDate(datetime) {
	      return datetime ? (0, _moment2.default)(datetime).format('LLL') : datetime;
	    },
	    getDuration: function getDuration(datetime) {
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(datetime));
	      return _moment2.default.duration(diff).humanize();
	    },
	    readDeletedEventsLog: function readDeletedEventsLog() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      var schoolId = this.subject.school_id;
	      var subjectId = this.subject.id;
	      _docendo2.default.auditDeletedEventsBySubject(schoolId, subjectId, function (success) {
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          _this2.isLoading = false;
	          return;
	        }
	        _this2.log = success;
	        _this2.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.sms.an_error_occured'), success: false };
	        _this2.isLoading = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readDeletedEventsLog();
	    if (window.Intercom) {
	      window.Intercom('trackEvent', 'Docendo Feature: Log Of Deleted Events');
	    }
	  }
	};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default },
	  props: {
	    subject: {
	      type: Object
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isLoadingReductions: function isLoadingReductions() {
	      return this.$store.state.subjects.isLoadingReductions;
	    },
	    reductionsInSubjectIdHash: function reductionsInSubjectIdHash() {
	      return this.$store.getters.reductionsInSubjectIdHash;
	    },
	    subjectReductions: function subjectReductions() {
	      return (this.reductionsInSubjectIdHash[this.subject.id] || []).map(function (reduction) {
	        return (0, _extends3.default)({}, reduction, {
	          vFormattedHours: Number(reduction.hours).toFixed(2)
	        });
	      });
	    },
	    subjectReductionsSorted: function subjectReductionsSorted() {
	      var _this = this;
	
	      return this.subjectReductions.sort(function (a, b) {
	        return a.vActivityTitle.localeCompare(b.vActivityTitle, _this.locale);
	      });
	    },
	    totalReductionHours: function totalReductionHours() {
	      var total = this.subjectReductions.reduce(function (sum, reduction) {
	        return sum + Number(reduction.hours);
	      }, 0);
	
	      return total.toFixed(2);
	    }
	  },
	  mounted: function mounted() {
	    var schoolId = this.subject.school_id;
	    var schoolYearId = this.subject.school_year_id;
	    this.$store.dispatch('readReductions', { schoolId: schoolId, schoolYearId: schoolYearId });
	  }
	};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _core = __webpack_require__(18);
	
	var _subject = __webpack_require__(1176);
	
	var _subject2 = _interopRequireDefault(_subject);
	
	var _optional = __webpack_require__(1175);
	
	var _optional2 = _interopRequireDefault(_optional);
	
	var _frame = __webpack_require__(1174);
	
	var _frame2 = _interopRequireDefault(_frame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calendarType: {
	      default: 'klass'
	    },
	    subjectType: {
	      default: ''
	    },
	    isInTasks: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      calSubjectTypes: [],
	      allTypes: {
	        'subject': [{
	          lang: 'da',
	          name: 'Fag <span class="do-bagde-break">UV-tid</span>',
	          value: 'subject',
	          order: 1,
	          desc: 'Tæller UV-tid. To samtidige brikker tæller halvt.'
	        }, {
	          lang: 'en',
	          name: 'Subject',
	          value: 'subject',
	          order: 1,
	          desc: 'Counting hours for the class. Two simultaneous activities count as halves.'
	        }, {
	          lang: 'nb',
	          name: 'Fag',
	          value: 'subject',
	          order: 1,
	          desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Fag: Standard for undervisningstimer. Legges to eller flere fag i samme tidsrom fordeles tiden likt mellom fagene.</p><img style="width: 80%;" src="' + _subject2.default + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: to 60 minutters undervisningstimer i Norsk og Matematikk i samme tidsrom i en klasse telles som 30 minutter norsk og 30 min matematikk.</p></div>'
	        }],
	        'optional': [{
	          lang: 'da',
	          name: 'Valgfag/Hold <span class="do-bagde-break">UV-tid</span>',
	          value: 'optional',
	          order: 2,
	          desc: 'Tæller UV-tid. Tæller 100%, uafhængigt af andre brikker i samme tidsrum i klassen.'
	        }, {
	          lang: 'en',
	          name: 'Optional grades/groups',
	          value: 'optional',
	          order: 2,
	          desc: 'Fully counting and independent from other activities in the same time period.'
	        }, {
	          lang: 'nb',
	          name: 'Valgfag/gruppe',
	          value: 'optional',
	          order: 2,
	          desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Valgfag/gruppe: Undervisningstimer som ikke teller fra andre fag. Er særlig nyttig for valgfag og tilvalgsfag. </p><img style="width: 80%;" src="' + _optional2.default + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: to 60 minutters undervisningstimer i Spansk og Fransk i samme tidsrom telles som 60 min Spansk og 60 min Fransk.</p></div>'
	        }],
	        'supplemental': [{
	          lang: 'da',
	          name: 'UUV <span class="do-bagde-break">UV-tid</span>',
	          value: 'supplemental',
	          desc: 'Tæller UV-tid. Og selvstændigt på understøttende undervisning.',
	          order: 6
	        }, {
	          lang: 'en',
	          name: 'UUV',
	          value: 'supplemental',
	          desc: 'Tæller selvstændigt på understøttende undervisning.',
	          order: 6
	        }, {
	          lang: 'nb',
	          name: 'UUV',
	          value: 'supplemental',
	          desc: 'Tæller selvstændigt på understøttende undervisning.',
	          order: 6
	        }],
	        'frame': [{
	          lang: 'da',
	          name: 'Temavisning',
	          value: 'frame',
	          order: 3,
	          desc: 'Tæller ikke noget selv, men fagbrikker i samme tidsrum tæller 100%. Temavisning kan bruges til at markere temaer og anderledes dage i skemaet. Brikken er synlig, mens fag-brikker, der ligger samtidig med tema-brikken skjules for elever/forældre. '
	        }, {
	          lang: 'en',
	          name: 'Theme',
	          value: 'frame',
	          order: 3,
	          desc: 'Can be used for marking themes and special days in the class schedule. The themed activity is visible for the pupils and parents, while classes that are overlapping the themed activity will not be visible. Classes are fully counting, and the themed activity is not.'
	        }, {
	          lang: 'nb',
	          name: 'Temavisning (Ramme)',
	          value: 'frame',
	          order: 3,
	          desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Temavisning (ramme): Brukes til å markere temaer eller spesielle dager/fag i timeplanen. Timer lagt inn med denne fagtype er synlig for elever/foresatte, og kan med fordel legges i samme tidsrom som andre fag, og vil da skjule disse for elever/foresatte. Temavisning telles ikke som undervisningstimer, det gjør derimot fagene som er lagt i samme tidsrom.</p><img style="width: 80%;" src="' + _frame2.default + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: \'Idrettsdag’\' opprettes som Temavisning, og legges over fagene som normalt ligger i timeplanen. Lærere ser alle timene, mens elever/foresatte ser ‘Idrettsdag’ i timeplanen. Kan også brukes på samme måte for å markere tilvalgsfag eller valgfag for elever. Legger man en temavisning over for eksempel fire tilvalgsfag, vil dette gi en forenklet visning til elevene.</p></div>'
	        }],
	        'break': [{
	          lang: 'da',
	          name: 'Pause <span class="do-bagde-break">UV-tid</span>',
	          value: 'break',
	          desc: 'Tæller UV-tid. Andre lektioner bør ikke overlappe med en pause.',
	          order: 7
	        }, { lang: 'en', name: 'Break', value: 'break', desc: 'Subjects should not overlap with breaks.', order: 7 }, { lang: 'nb', name: 'Pause', value: 'break', desc: 'Andre timer bør ikke overlapper med en pause.', order: 7 }],
	        'resource': [{
	          lang: 'da',
	          name: 'Ressource (skjult) <span class="do-bagde-break">UV-tid</span>',
	          value: 'resource',
	          order: 4,
	          desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
	        }, {
	          lang: 'en',
	          name: 'Resource (hidden)',
	          value: 'resource',
	          order: 4,
	          desc: 'Can be used to register teaching resources. Is not visible to students/parents.'
	        }, {
	          lang: 'nb',
	          name: 'Ressurs (skjult)',
	          value: 'resource',
	          order: 4,
	          desc: '<p style="width: 300px">Ressurs: Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er særlig nyttig til å legge inn at det er en ekstra assistent (ressurs) til stede i klassen, f.eks.i form av SNO eller Barneveileder. Undervisningsfaget i samme tidsrom telles 100%, samme med ressursen. Faget er ikke synlig for elever/foresatte.</p>'
	        }],
	        'person_resource': [{
	          lang: 'da',
	          name: 'Ressource (skjult) <span class="do-bagde-break">UV-tid</span>',
	          value: 'person_resource',
	          order: 4,
	          desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
	        }, {
	          lang: 'en',
	          name: 'Resource (hidden)',
	          value: 'person_resource',
	          order: 4,
	          desc: 'Can be used to register teaching resources. Is not visible to students/parents.'
	        }, {
	          lang: 'nb',
	          name: 'Ressurs (skjult)',
	          value: 'person_resource',
	          order: 4,
	          desc: '<p style="width: 300px">Ressurs: Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er særlig nyttig til å legge inn at det er en ekstra assistent (ressurs) til stede i klassen, f.eks.i form av SNO eller Barneveileder. Undervisningsfaget i samme tidsrom telles 100%, samme med ressursen. Faget er ikke synlig for elever/foresatte.</p>'
	        }],
	        'other_tasks': [{
	          lang: 'da',
	          name: 'Anden tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
	          value: 'other_tasks',
	          desc: 'Ikke undervisning',
	          order: 13
	        }, { lang: 'en', name: 'Other tasks', value: 'other_tasks', desc: 'Not teaching', order: 13 }, { lang: 'nb', name: 'Annen tid', value: 'other_tasks', desc: 'Ikke undervisning', order: 13 }],
	        'other_stuff': [{
	          lang: 'da',
	          name: 'Øvrig tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
	          value: 'other_stuff',
	          desc: 'Ikke undervisning, ikke elev-relateret.',
	          order: 12
	        }, {
	          lang: 'en',
	          name: 'Additional tasks',
	          value: 'other_stuff',
	          desc: 'Not classes and teaching, non-pupil related.',
	          order: 12
	        }, {
	          lang: 'nb',
	          name: 'Øvrig tid',
	          value: 'other_stuff',
	          desc: 'Ikke undervisning, ikke elevrelatert.',
	          order: 12
	        }],
	        'available': [{
	          lang: 'da',
	          name: 'Rådighedstime',
	          value: 'available',
	          desc: 'Brug til at vise, hvornår en underviser kan tage en vikartime',
	          order: 11
	        }, {
	          lang: 'nb',
	          name: 'Rådighetstime',
	          value: 'available',
	          desc: ' Brukes til å vise når en underviser kan ta en vikartime',
	          order: 11
	        }, {
	          lang: 'en',
	          name: 'On-Call',
	          value: 'available',
	          desc: 'The \'On-Call\' event indicates a timeslot when a teacher is available and ready to take over a course as a substitute. These events can be prioritized within the Substitute Management module, ensuring that available teachers can be quickly identified and assigned to cover classes as needed.',
	          order: 11
	        }],
	        'person_resource_visible': [{
	          lang: 'da',
	          name: 'Ressource (synlig) <span class="do-bagde-break">UV-tid</span>',
	          value: 'person_resource_visible',
	          order: 5,
	          desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises i elev- og forældre visning.'
	        }, {
	          lang: 'en',
	          name: 'Resource (Visible)',
	          value: 'person_resource_visible',
	          order: 5,
	          desc: 'Can be used to register teaching resources. Visible to students/parents.'
	        }, {
	          lang: 'nb',
	          name: 'Ressurs (Vises for elever)',
	          value: 'person_resource_visible',
	          order: 5,
	          desc: '<p style="width: 400px">Ressurs (vises for elever): Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er synlig for elever/foresatte. Som fagtypen Ressurs, er denne også nyttig til å vise at det er ekstra personale til stede, f.eks en Miljøveileder, som også skal være synlig for elever/foresatte i timeplanen.</p>'
	        }],
	        'club': [{ lang: 'da', name: 'SFO tid', value: 'club', desc: 'Pædagogisk tid i SFO, FFO, DUS eller lignende', order: 8 }, { lang: 'en', name: 'SFO time', value: 'club', desc: 'Pedagogical time', order: 8 }, { lang: 'nb', name: 'SFO tid', value: 'club', desc: 'Pedagogisk tid', order: 8 }],
	        'additional_tasks': [{
	          lang: 'da',
	          name: 'Øvrige opgaver',
	          value: 'additional_tasks',
	          desc: 'Tæller som Øvrige Opgaver. Ikke undervisning',
	          order: 9
	        }, { lang: 'en', name: 'Not teaching', value: 'additional_tasks', desc: 'Not teaching', order: 9 }, { lang: 'nb', name: 'Øvrige oppgaver', value: 'additional_tasks', desc: 'Tæller som øvrige opgaver.', order: 9 }],
	        'preparation': [{
	          lang: 'da',
	          name: 'Forberedelse',
	          value: 'preparation',
	          desc: 'Kan bruges til individuel eller fælles forberedelse (f.eks. teammøder m.m)',
	          order: 10
	        }, {
	          lang: 'en',
	          name: 'Preparation',
	          value: 'preparation',
	          desc: 'Can be used for individual or joint preparation',
	          order: 10
	        }, {
	          lang: 'nb',
	          name: 'Forberedelse',
	          value: 'preparation',
	          desc: 'Kan brukes til individuell eller felles forberedelse',
	          order: 10
	        }],
	        'pool': [{
	          lang: 'da',
	          name: 'Lokalpulje',
	          value: 'pool',
	          desc: 'Kan bruges til f.eks. udvikling, forberedelse, overlevering, opgaver i tilknytning til afslutning',
	          order: 11
	        }, {
	          lang: 'nb',
	          name: 'Planleggingsdager',
	          value: 'pool',
	          desc: '',
	          order: 11
	        }],
	        'activity': [{
	          lang: 'da',
	          name: 'Aktivitet <span style="text-transform: initial">(m. reduktion)</span> <span class="do-bagde-break">UV-tid</span>',
	          value: 'activity',
	          desc: 'Bruges til at oprette aktiviteter i klasser, der skal reducere timepuljer fra andre fag.',
	          order: 11
	        }],
	        'reservation': [{
	          lang: 'da',
	          name: 'Reservation',
	          value: 'reservation',
	          desc: 'Bruges til f.eks. lokalebooking. Tæller intet - men blokerer blot et tidsrum i en kalender',
	          order: 11
	        }, {
	          lang: 'nb',
	          name: 'Reservasjon',
	          value: 'reservation',
	          desc: 'Brukes til f.eks. rombestilling. Teller ingenting - men blokkerer bare et tidsrom i en kalender',
	          order: 11
	        }, {
	          lang: 'en',
	          name: 'Reservation',
	          value: 'reservation',
	          desc: 'Used for e.g. room booking. Counts for nothing - but simply blocks a time slot in a calendar',
	          order: 11
	        }]
	      },
	      kindergartenTypes: {
	        'with_kids': [{ lang: 'da', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11 }, { lang: 'en', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11 }, { lang: 'nb', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11 }],
	        'without_kids': [{ lang: 'da', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12 }, { lang: 'en', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12 }, { lang: 'nb', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12 }]
	      },
	      selectedtype: null,
	      isTooltip: false,
	      isTooltipPopperDone: false,
	      activeSubjectTypeDesc: ''
	    };
	  },
	
	  computed: {
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_id ? this.$route.params.school_id : this.school.id;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    isReductionsActive: function isReductionsActive() {
	      return this.$store.getters.isReductionsActive;
	    },
	    activeSubjectTypes: function activeSubjectTypes() {
	      var _this = this;
	
	      var arr = [];
	      var dbSubjectTypes = !this.isInTasks ? this.calSubjectTypes : this.calSubjectTypes.filter(function (type) {
	        return !(type === 'other_stuff' || type === 'other_tasks');
	      });
	      var allTypes = this.isKindergarten ? this.kindergartenTypes : this.allTypes;
	      dbSubjectTypes.forEach(function (activeType) {
	        if (allTypes[activeType] && allTypes[activeType].filter(function (subjectType) {
	          return subjectType.lang === _this.locale;
	        })[0]) {
	          arr.push(allTypes[activeType].filter(function (subjectType) {
	            return subjectType.lang === _this.locale;
	          })[0]);
	        }
	      });
	      if (!this.isSchoolFeatureLocalePool) {
	        arr = arr.filter(function (subjectType) {
	          return subjectType.value !== 'pool';
	        });
	      }
	      if (this.calendarType === 'room') {
	        arr = arr.filter(function (subjectType) {
	          return subjectType.value !== 'subject';
	        });
	      }
	      if (this.calendarType === 'klass') {
	        var idx = arr.findIndex(function (subjectType) {
	          return subjectType.value === 'additional_tasks' && subjectType.lang === 'da';
	        });
	        if (idx > -1) {
	          arr[idx]['name'] = 'Tilsyn / Øvrige opgaver';
	        }
	      }
	      return arr.filter(function (item) {
	        return !_this.isReductionsActive ? item.value !== 'activity' : true;
	      }).sort(function (a, b) {
	        return a.order > b.order ? 1 : -1;
	      });
	    },
	    isSchoolFeatureLocalePool: function isSchoolFeatureLocalePool() {
	      return this.$store.getters.isSchoolFeatureLocalePool;
	    }
	  },
	  watch: {
	    calendarType: function calendarType() {
	      this.readSubjectTypes(this.calendarType);
	    },
	    selectedtype: function selectedtype(val) {
	      this.$emit('change', val);
	    },
	    activeSubjectTypes: function activeSubjectTypes() {
	      var _this2 = this;
	
	      var idx = this.activeSubjectTypes.findIndex(function (subjectType) {
	        return subjectType.value === _this2.subjectType;
	      });
	      if (idx > 0 && this.subjectType) {
	        this.selectedtype = this.subjectType;
	      } else {
	        this.selectedtype = this.activeSubjectTypes[0].value;
	      }
	    }
	  },
	  methods: {
	    createPopper: function createPopper(evt) {
	      var childPopper = this.$refs.child_popper;
	      document.getElementById('djs-content-container').appendChild(childPopper);
	      (0, _core.createPopper)(evt.target, childPopper, {
	        placement: 'right',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: function offset(_ref) {
	              var placement = _ref.placement,
	                  reference = _ref.reference,
	                  popper = _ref.popper;
	
	              return [0, 5];
	            }
	          }
	        }]
	      });
	    },
	    showTooltip: function showTooltip(desc, evt) {
	      var _this3 = this;
	
	      this.activeSubjectTypeDesc = desc;
	      this.isTooltip = true;
	      this.$nextTick(function (_) {
	        _this3.createPopper(evt);
	        _this3.isTooltipPopperDone = true;
	      });
	    },
	    hideTooltip: function hideTooltip() {
	      this.activeSubjectTypeDesc = '';
	      this.isTooltip = false;
	      this.isTooltipPopperDone = false;
	    },
	    readSubjectTypes: function readSubjectTypes(calType) {
	      var _this4 = this;
	
	      var schoolCountry = this.school.country;
	      _docendo2.default.subjectsForCalendarType(calType, schoolCountry, function (success) {
	        _this4.calSubjectTypes = success;
	      }, function (failure) {
	        console.log('failed');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.activeSubjectTypes && this.activeSubjectTypes[0]) {
	      this.subjectType ? this.selectedtype = this.subjectType : this.selectedtype = this.activeSubjectTypes[0].value;
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjectTypes(this.calendarType);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var childPopper = this.$refs.child_popper;
	    if (childPopper) {
	      childPopper.remove();
	    }
	  }
	};

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _values = __webpack_require__(93);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _SubjectForm = __webpack_require__(124);
	
	var _SubjectForm2 = _interopRequireDefault(_SubjectForm);
	
	var _BulkCreateSubjectsSubject = __webpack_require__(1335);
	
	var _BulkCreateSubjectsSubject2 = _interopRequireDefault(_BulkCreateSubjectsSubject);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    headline: 'Fagoprettelse',
	    create_subject: 'Opret fag',
	    create_classes_first: 'Opret klasser i sidemenuen først',
	    import_subjects: 'Importer fag',
	    subjects: 'Fag',
	    no_subjects: 'Ingen fag',
	    create: 'Opret',
	    in: 'i'
	  },
	  en: {
	    headline: 'Create course',
	    create_subject: 'Create course',
	    create_classes_first: 'Start by creating grades/groups',
	    import_subjects: 'Import courses',
	    subjects: 'Courses',
	    no_subjects: 'No courses',
	    create: 'Create',
	    in: 'in'
	  },
	  nb: {
	    headline: 'Fag- og timefordeling',
	    create_subject: 'Opprett fag',
	    create_classes_first: 'Opprett klasser i sidemenyen',
	    import_subjects: 'Importer fag',
	    no_subjects: 'Ingen fag',
	    create: 'Opprett',
	    in: 'i'
	  }
	};
	
	exports.default = {
	  components: { DoFiltersFilter: _DoFiltersFilter2.default, Loader: _Loader2.default, AddSubject: _BulkCreateSubjectsSubject2.default, SubjectForm: _SubjectForm2.default, ChangeSchoolYear: _ChangeSchoolYear2.default },
	  props: {
	    isActivities: {
	      default: false
	    },
	    propIsSubjectModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      tableWidth: '100%',
	      editSubject: null,
	      isSubjectModal: false,
	      isTheCreateCalenderSubjectActive: null,
	      isSubjectImportModal: false,
	      createInCalendarId: null
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    subjectTypes: function subjectTypes() {
	      return this.$store.state.subjects.subjectTypes[this.locale];
	    },
	    subjectTypeFilters: function subjectTypeFilters() {
	      var excluded = ['other_tasks', 'other_stuff', 'club'];
	
	      return this.subjectTypes.filter(function (type) {
	        return !excluded.includes(type.value);
	      }).map(function (type) {
	        return type.name;
	      });
	    },
	    subjectsInKlasses: function subjectsInKlasses() {
	      return this.$store.getters.uniqueSubjects ? this.$store.getters.uniqueSubjects : [];
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    klassesWithoutSubjects: function klassesWithoutSubjects() {
	      var _this = this;
	
	      return this.klassCalendarsSorted.filter(function (klass) {
	        return !_this.subjectsInKlassHash[klass.id];
	      });
	    },
	    subjectsInKlassesWithProps: function subjectsInKlassesWithProps() {
	      var _this2 = this;
	
	      return this.subjectsInKlasses.map(function (subject) {
	        (0, _values2.default)(subject.klasses).forEach(function (cal) {
	          var calId = cal.calendar_id;
	          if (subject.klasses[calId].calendar_ids) {
	            _this2.$set(subject['klasses'][calId], 'v_subjectHasTeachers', _this2.subjectHasTeachers(subject.klasses[calId].calendar_ids));
	            _this2.$set(subject['klasses'][calId], 'v_subjectHasRooms', _this2.subjectHasRooms(subject.klasses[calId].calendar_ids));
	            _this2.$set(subject['klasses'][calId], 'v_subjectOtherKlasses', _this2.subjectOtherKlasses(subject.klasses[calId], subject.klasses[calId].calendar_ids));
	            _this2.$set(subject['klasses'][calId], 'v_userNames', _this2.getUserNames(subject.klasses[calId].calendar_ids));
	          }
	        });
	        return subject;
	      });
	    },
	    klassCalendarsSorted: function klassCalendarsSorted() {
	      return this.$store.getters.klassCalendars;
	    },
	    klassCalIdsHashSortedOnName: function klassCalIdsHashSortedOnName() {
	      return this.$store.getters.klassCalIdsHashSortedOnName;
	    },
	    klassCalendarInHash: function klassCalendarInHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    selectedSubjectTypeFilters: function selectedSubjectTypeFilters() {
	      return this.$store.state.subjects.selectedSubjectTypeFilters;
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    },
	    propIsSubjectModal: function propIsSubjectModal(bool) {
	      this.isSubjectModal = bool;
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  },
	  methods: {
	    createTooltip: function createTooltip(subject, calId) {
	      var locale = this.locale || 'en';
	      var translations = this.i18n && this.i18n[locale] ? this.i18n[locale] : {};
	
	      var subjectName = subject && subject.name ? subject.name : '';
	      var calendarName = typeof this.getCalendarName === 'function' ? this.getCalendarName(calId) : '';
	
	      var createText = translations['create'] || 'Create';
	      var inText = translations['in'] || 'in';
	      return createText + ' ' + subjectName + ' ' + inText + ' ' + calendarName;
	    },
	    setCreateInCalendarId: function setCreateInCalendarId(calId) {
	      this.createInCalendarId = calId;
	      if (calId) {
	        this.isSubjectModal = true;
	      } else {
	        this.isSubjectModal = false;
	      }
	    },
	    toggleSelectedSubjectTypeFilters: function toggleSelectedSubjectTypeFilters(filter) {
	      this.$store.commit('TOGGLE_SUBJECT_TYPE_FILTER', filter);
	    },
	    clearSelectedSubjectTypeFilters: function clearSelectedSubjectTypeFilters() {
	      this.$store.commit('CLEAR_SUBJECT_TYPE_FILTERS');
	    },
	    setImportSubjects: function setImportSubjects() {
	      _eventbus2.default.theKlassesToImportSubjectTo = [].concat((0, _toConsumableArray3.default)(this.klassesWithoutSubjects));
	      _eventbus2.default.createKlassModal = true;
	    },
	    subjectHasTeachers: function subjectHasTeachers(calIds) {
	      var _this3 = this;
	
	      var hasTeachers = false;
	      calIds.forEach(function (calId) {
	        if (_this3.allCalendarsInHash[calId] && _this3.allCalendarsInHash[calId].type === 'user') {
	          hasTeachers = true;
	        }
	      });
	      return hasTeachers;
	    },
	    subjectHasRooms: function subjectHasRooms(calIds) {
	      var _this4 = this;
	
	      var hasRooms = false;
	      calIds.forEach(function (calId) {
	        if (_this4.allCalendarsInHash[calId] && _this4.allCalendarsInHash[calId].type === 'room') {
	          hasRooms = true;
	        }
	      });
	      return hasRooms;
	    },
	    subjectOtherKlasses: function subjectOtherKlasses(subject, calIds) {
	      var _this5 = this;
	
	      if (!calIds || calIds.length < 1 || !calIds[0]) {
	        return '';
	      }
	      return calIds.filter(function (calId) {
	        return calId !== subject.calendar_id && _this5.allCalendarsInHash[calId] && _this5.allCalendarsInHash[calId].type === 'klass';
	      }).map(function (userCalId) {
	        return _this5.allCalendarsInHash[userCalId].name ? _this5.allCalendarsInHash[userCalId].name : '';
	      });
	    },
	    getUserNames: function getUserNames(calIds) {
	      var _this6 = this;
	
	      if (!calIds || calIds.length < 1 || !calIds[0]) {
	        return '';
	      }
	      return calIds.filter(function (calId) {
	        return _this6.allCalendarsInHash[calId] && _this6.allCalendarsInHash[calId].type === 'user';
	      }).map(function (userCalId) {
	        return _this6.allCalendarsInHash[userCalId].name ? _this6.allCalendarsInHash[userCalId].name : '';
	      });
	    },
	    getCalendarName: function getCalendarName(calId) {
	      return this.klassCalendarInHash[calId] ? this.klassCalendarInHash[calId].name : 'id: ' + calId;
	    },
	    setIsCreateSubject: function setIsCreateSubject(subject, calendarSubject) {
	      var _this7 = this;
	
	      setTimeout(function (_) {
	        _this7.isTheCreateCalenderSubjectActive = subject.id + '_' + calendarSubject.calendar_id;
	      }, 0);
	    },
	    isCreateSubject: function isCreateSubject(subject, calendarSubject) {
	      return this.isTheCreateCalenderSubjectActive === subject.id + '_' + calendarSubject.calendar_id;
	    },
	    closeIsCreateSubject: function closeIsCreateSubject() {
	      this.isTheCreateCalenderSubjectActive = null;
	    },
	    closeModal: function closeModal() {
	      this.editSubject = null;
	      this.isSubjectModal = false;
	      this.createInCalendarId = null;
	      this.$emit('closeSubjectModal');
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      var _this8 = this;
	
	      this.editSubject = (0, _assign2.default)({}, editSubject);
	      this.isSubjectModal = true;
	      setTimeout(function (_) {
	        _this8.isTheCreateCalenderSubjectActive = null;
	      }, 1);
	    },
	    createNewSubject: function createNewSubject(newSubject) {
	      newSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createSubject', newSubject);
	      this.closeModal();
	    },
	    createExistingSubjectInCal: function createExistingSubjectInCal(brik) {
	      var newSubject = {
	        calendarId: brik.calendar.calendar_id,
	        name: brik.subject.name,
	        color: brik.subject.color,
	        defaultDuration: brik.subject.default_duration,
	        preparation: brik.subject.preparation ? brik.subject.preparation : null,
	        hours: brik.hours,
	        subjectType: brik.subject.subject_type,
	        calendarIds: [],
	        subjectCode: brik.subject.subject_code
	      };
	      newSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createSubject', newSubject);
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      updatedSubject['schoolId'] = updatedSubject.schoolId ? updatedSubject.schoolId : window.SCHOOL.id;
	      updatedSubject['schoolYearId'] = updatedSubject.schoolYearId ? updatedSubject.schoolYearId : this.activeSchoolYear.id;
	
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeModal();
	    },
	    findOtherKlassesOnSubject: function findOtherKlassesOnSubject(subject) {
	      var _this9 = this;
	
	      var calIds = subject.calendarIds;
	      var idx = this.subjectsInKlasses.findIndex(function (subjectWithKlasses) {
	        return subjectWithKlasses.name === subject.name;
	      });
	      if (!calIds || calIds.length < 1 || !calIds[0]) {
	        return '';
	      }
	      return calIds.filter(function (calId) {
	        return calId !== subject.calendar_id && _this9.allCalendarsInHash[calId] && _this9.allCalendarsInHash[calId].type === 'klass' && _this9.subjectsInKlasses[idx].klasses[calId] && _this9.subjectsInKlasses[idx].klasses[calId].hours;
	      });
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      var deletedSubject = {
	        id: editSubject.id,
	        school_id: editSubject.school_id,
	        school_year_id: this.activeSchoolYear.id
	      };
	      deletedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('deleteSubject', deletedSubject);
	      this.closeModal();
	    },
	    setTableWidth: function setTableWidth() {
	      var el = this.$refs.tableHead;
	      if (!el) {
	        return;
	      }
	      var tableBCR = el.getBoundingClientRect();
	      this.tableWidth = tableBCR.width + 15 + 'px';
	    },
	    readSubject: function readSubject() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    }
	  },
	  mounted: function mounted() {
	    var _this10 = this;
	
	    window.addEventListener('new_subjects_created', function () {
	      return _this10.readSubject();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this11 = this;
	
	    window.removeEventListener('new_subjects_created', function () {
	      return _this11.readSubject();
	    });
	  },
	  updated: function updated() {
	    this.setTableWidth();
	  }
	};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    subject: {
	      default: null
	    },
	    calendar: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      hours: 0
	    };
	  },
	
	  methods: {
	    close: function close() {
	      this.$emit('close');
	      this.hours = 0;
	    },
	    selectAll: function selectAll(event) {
	      setTimeout(function () {
	        event.target.select();
	      }, 0);
	    },
	    addSubject: function addSubject() {
	      if (this.hours < 0 || isNaN(this.hours)) {
	        this.isCreateSubject = false;
	        this.hours = 0;
	        return;
	      }
	      var newSubject = {
	        subject: this.subject,
	        calendar: this.calendar,
	        hours: this.hours
	      };
	      this.$emit('createSubject', newSubject);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    setTimeout(function (_) {
	      _this.$refs.count.focus();
	    }, 0);
	  }
	};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _set = __webpack_require__(52);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _RequestSubjectsUser = __webpack_require__(1337);
	
	var _RequestSubjectsUser2 = _interopRequireDefault(_RequestSubjectsUser);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Tabslist = __webpack_require__(133);
	
	var _Tabslist2 = _interopRequireDefault(_Tabslist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Tabslist: _Tabslist2.default, RequestSubjectsUser: _RequestSubjectsUser2.default, DoFiltersFilter: _DoFiltersFilter2.default, Loader: _Loader2.default },
	  data: function data() {
	    return {
	      selectedTab: 'Fag',
	      selectedKlassFilters: [],
	      statusFilters: ['Fag uden tildelt underviser', 'Fag med tildelt underviser', 'Fag jeg har ønsket'],
	      selectedStatusFilters: ['Fag uden tildelt underviser'],
	      loadingSubjects: {},
	      subjectSearchQuery: '',
	      debounceTimer: null,
	      schoolYearId: null
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userCalendarId: function userCalendarId() {
	      return this.user && this.user.user_calendar_id ? this.user.user_calendar_id : null;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    subjects: function subjects() {
	      return this.$store.state.subjects.subjects;
	    },
	    requestedSubjects: function requestedSubjects() {
	      return this.$store.getters.subjectsRequestsInHash;
	    },
	    isShowSubjectsWithoutTeachers: function isShowSubjectsWithoutTeachers() {
	      return this.selectedStatusFilters.includes('Fag uden tildelt underviser');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    klassCalendars: function klassCalendars() {
	      var cals = [];
	      var seenIds = new _set2.default();
	      this.subjects.forEach(function (subject) {
	        subject.cals.forEach(function (cal) {
	          if (cal.calendar_type === 'klass' && !seenIds.has(cal.id)) {
	            seenIds.add(cal.id);
	            cals.push(cal);
	          }
	        });
	      });
	      return cals.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    klassTags: function klassTags() {
	      return this.klassCalendars.map(function (klassCalendar) {
	        return klassCalendar.name;
	      });
	    },
	    calsWithProps: function calsWithProps() {
	      var _this = this;
	
	      var klasses = this.klassCalendars;
	
	      return klasses.map(function (klass) {
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: (_this.subjectsInKlassHash[klass.id] || []).map(function (subjectId) {
	            var subject = _this.subjectsInHash[subjectId] || {};
	
	            return (0, _extends3.default)({}, subject, {
	              vRequestedBy: _this.getSubjectedRequestedBy(subjectId),
	              vHasTeachers: _this.subjectHasTeachers(subjectId),
	              vUserNames: _this.getUserNames(subjectId),
	              vIsRequestedByUser: _this.getIsSubjectRequestedByUser(subjectId),
	              vIsLoading: _this.getIsSubjectLoading(subjectId) });
	          })
	        });
	      });
	    },
	    filteredKlassCals: function filteredKlassCals() {
	      var _this2 = this;
	
	      var klasses = this.calsWithProps;
	
	      if (this.selectedKlassFilters.length > 0) {
	        klasses = klasses.filter(function (klass) {
	          return _this2.selectedKlassFilters.includes(klass.name);
	        });
	      }
	
	      var hasStatusFilters = this.selectedStatusFilters.length > 0;
	
	      return klasses.map(function (klass) {
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: klass.vSubjects.filter(function (subject) {
	            var matchesStatusFilter = !hasStatusFilters || _this2.selectedStatusFilters.includes('Fag uden tildelt underviser') && !subject.vHasTeachers || _this2.selectedStatusFilters.includes('Fag med tildelt underviser') && subject.vHasTeachers || _this2.selectedStatusFilters.includes('Fag jeg har ønsket') && subject.vIsRequestedByUser;
	
	            var matchesSearch = !_this2.subjectSearchQuery || subject.name.toLowerCase().includes(_this2.subjectSearchQuery.toLowerCase());
	
	            return matchesStatusFilter && matchesSearch;
	          })
	        });
	      });
	    },
	    subjectsRequests: function subjectsRequests() {
	      return this.$store.state.subjects.subjectsRequests;
	    },
	    isLoadingSubjectsRequests: function isLoadingSubjectsRequests() {
	      return this.$store.state.subjects.isLoadingSubjectsRequests;
	    },
	    userRequestedSubjects: function userRequestedSubjects() {
	      var _this3 = this;
	
	      if (!this.user) {
	        return [];
	      }
	      return this.subjects.filter(function (subject) {
	        return _this3.getIsSubjectRequestedByUser(subject.id);
	      });
	    },
	    userRequestedSubjectsWithProps: function userRequestedSubjectsWithProps() {
	      var _this4 = this;
	
	      return this.userRequestedSubjects.map(function (subject) {
	        return (0, _extends3.default)({}, subject, {
	          vKlass: _this4.getKlassesOnSubjects(subject),
	          vRequestedBy: _this4.getSubjectedRequestedBy(subject.id)
	        });
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.tasks;
	    }
	  },
	  methods: {
	    getKlassesOnSubjects: function getKlassesOnSubjects(subject) {
	      var cal = this.allCalendarsInHash[subject.calendar_id];
	      return cal ? cal.name : '';
	    },
	    onSelectTab: function onSelectTab(tab) {
	      this.selectedTab = tab;
	    },
	    debounceSearch: function debounceSearch(event) {
	      var _this5 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this5.subjectSearchQuery = event.target.value;
	      }, 400);
	    },
	    getSubjectedRequestedBy: function getSubjectedRequestedBy(subjectId) {
	      var _this6 = this;
	
	      var currentCalendarIds = this.requestedSubjects[subjectId] || [];
	      return currentCalendarIds.filter(function (calId) {
	        return calId !== _this6.userCalendarId && _this6.allCalendarsInHash[calId];
	      }).map(function (calId) {
	        return _this6.allCalendarsInHash[calId] ? _this6.allCalendarsInHash[calId]['name'] : [];
	      });
	    },
	    getIsSubjectRequestedByUser: function getIsSubjectRequestedByUser(subjectId) {
	      var userCalendarId = this.userCalendarId;
	      var currentUserIds = this.requestedSubjects[subjectId];
	      return currentUserIds && currentUserIds.includes(userCalendarId);
	    },
	    onSetSubjectRequest: function onSetSubjectRequest(subjectId) {
	      var _this7 = this;
	
	      this.$set(this.loadingSubjects, subjectId, true);
	
	      if (this.getIsSubjectRequestedByUser(subjectId)) {
	        var idx = this.subjectsRequests.findIndex(function (subjectsReq) {
	          return subjectsReq.subject_id === subjectId && subjectsReq.calendar_id === _this7.userCalendarId;
	        });
	        if (idx > -1) {
	          var reqId = this.subjectsRequests[idx]['id'];
	
	          _docendo2.default.deleteSubjectRequest(this.schoolId, this.schoolYearId, reqId, function (success) {
	            _this7.$store.commit('removeSubjectRequest', success);
	            _this7.$delete(_this7.loadingSubjects, subjectId);
	          }, function (failure) {
	            _this7.$delete(_this7.loadingSubjects, subjectId);
	          });
	        }
	      } else {
	        _docendo2.default.createSubjectRequest(this.schoolId, this.schoolYearId, subjectId, function (success) {
	          _this7.$store.commit('addSubjectRequest', success);
	          _this7.$delete(_this7.loadingSubjects, subjectId);
	        }, function (failure) {
	          _this7.$delete(_this7.loadingSubjects, subjectId);
	        });
	      }
	    },
	    getIsSubjectLoading: function getIsSubjectLoading(subjectId) {
	      return this.loadingSubjects[subjectId];
	    },
	    toggleSelectedStatusFilters: function toggleSelectedStatusFilters(filter) {
	      var idx = this.selectedStatusFilters.indexOf(filter);
	      if (idx < 0) {
	        this.selectedStatusFilters.push(filter);
	      } else {
	        this.selectedStatusFilters.splice(idx, 1);
	      }
	    },
	    toggleKlassTag: function toggleKlassTag(filter) {
	      var idx = this.selectedKlassFilters.indexOf(filter);
	      if (idx < 0) {
	        this.selectedKlassFilters.push(filter);
	      } else {
	        this.selectedKlassFilters.splice(idx, 1);
	      }
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      console.log('setEditSubject', editSubject);
	    },
	    getUserNames: function getUserNames(subjectId) {
	      var _this8 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      if (!calIds || calIds.length < 1 || !calIds[0]) {
	        return '';
	      }
	      return calIds.filter(function (calId) {
	        return _this8.allCalendarsInHash[calId] && _this8.allCalendarsInHash[calId].type === 'user';
	      }).map(function (userCalId) {
	        return _this8.allCalendarsInHash[userCalId].name ? _this8.allCalendarsInHash[userCalId].name : '';
	      });
	    },
	    isShowWithoutTeacher: function isShowWithoutTeacher(subjectid) {
	      if (!this.isShowSubjectsWithoutTeachers) {
	        return true;
	      } else {
	        return !this.subjectHasTeachers(subjectid);
	      }
	    },
	    subjectHasTeachers: function subjectHasTeachers(subjectId) {
	      var _this9 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      var hasTeachers = false;
	      calIds.forEach(function (calId) {
	        if (_this9.allCalendarsInHash[calId] && _this9.allCalendarsInHash[calId].type === 'user') {
	          hasTeachers = true;
	        }
	      });
	      return hasTeachers;
	    },
	    readSubjectRequests: function readSubjectRequests() {
	      if (this.schoolYearId) {
	        this.$store.dispatch('readSubjects', this.schoolYearId);
	
	        this.$store.dispatch('readSubjectRequests', this.schoolYearId);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var urlParams = new window.URLSearchParams(window.location.search);
	    this.schoolYearId = urlParams.get('school_year_id');
	    if (!this.schoolYearId) {
	      window.alert('Der mangler et skoleårs ID i URL’en');
	    }
	    this.readSubjectRequests();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.debounceTimer) {
	      clearTimeout(this.debounceTimer);
	    }
	  }
	};

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    user: {
	      type: Object,
	      default: {
	        name: ''
	      }
	    },
	    userSubjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    loadingSubjects: {
	      default: {}
	    }
	  },
	  computed: {
	    sumOfHours: function sumOfHours() {
	      return this.userSubjects.reduce(function (sum, subject) {
	        return sum + parseFloat(subject.hours);
	      }, 0).toFixed(1);
	    }
	  }
	};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(38);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(37);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _SubjectForm = __webpack_require__(124);
	
	var _SubjectForm2 = _interopRequireDefault(_SubjectForm);
	
	var _FilterUsers = __webpack_require__(338);
	
	var _FilterUsers2 = _interopRequireDefault(_FilterUsers);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _SubjectsDistributionTasks = __webpack_require__(334);
	
	var _SubjectsDistributionTasks2 = _interopRequireDefault(_SubjectsDistributionTasks);
	
	var _AppFlipperButtons = __webpack_require__(347);
	
	var _AppFlipperButtons2 = _interopRequireDefault(_AppFlipperButtons);
	
	var _SubjectsDistributionUser = __webpack_require__(126);
	
	var _SubjectsDistributionUser2 = _interopRequireDefault(_SubjectsDistributionUser);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _SubjectsDistributionPrint = __webpack_require__(1339);
	
	var _SubjectsDistributionPrint2 = _interopRequireDefault(_SubjectsDistributionPrint);
	
	var _SubjectsDistributionTasksCreate = __webpack_require__(125);
	
	var _SubjectsDistributionTasksCreate2 = _interopRequireDefault(_SubjectsDistributionTasksCreate);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _StandardDurationSetting = __webpack_require__(121);
	
	var _StandardDurationSetting2 = _interopRequireDefault(_StandardDurationSetting);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoButtonAndDate = __webpack_require__(1393);
	
	var _DoButtonAndDate2 = _interopRequireDefault(_DoButtonAndDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    name: 'Navn',
	    subjects_for_teachers: 'Fagfordeling',
	    filter_users: ' Vælg teams',
	    teaching_hours_from_subjects: 'UV-TID FRA FAG',
	    created_subject: 'Oprettede faget',
	    klass: 'Klasse',
	    subjects: 'Fag',
	    teaching_hours: 'UV tid',
	    no_subjects_assigned: 'Ingen fag tildelt',
	    assigned: 'Tildelt',
	    from_subjects: 'Fra fag',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Vis fag uden underviser',
	    only_subjects_with_teachers: 'Vis fag med underviser',
	    hours_in_school_year: 'Timer i skoleåret',
	    export_to_zen: 'Overfør til automatisk skemalægning',
	    go_to_zen: 'Gå til automatisk skemalægning',
	    exported_to_zen: 'Data overført til Docendo ZEN',
	    something_went_wrong: 'Noget gik galt',
	    choose_grades: 'Vælg klasser',
	    grades: 'Klasser',
	    only_show_users_with_uv_time: 'Vis kun brugere med tildelt UV tid',
	    tasks: 'Opgaver',
	    no_users_matches: 'Ingen brugere matcher dine filtre',
	    print: 'Print opgaveoversigter',
	    only_subjects_with_requests: 'Vis kun fag med ønsker',
	    subjects_status: 'Status'
	  },
	  en: {
	    subjects_status: 'Status',
	    name: 'name',
	    subjects_for_teachers: 'Teacher-subject allocation',
	    filter_users: ' Filter users by groups',
	    teaching_hours_from_subjects: 'Annual instruction time from subjects',
	    created_subject: 'Created subject',
	    klass: 'Class',
	    subjects: 'Subjects',
	    teaching_hours: 'Instruction time',
	    no_subjects_assigned: 'No subjects allocated',
	    assigned: 'Allocated',
	    from_subjects: 'From subjects',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Show only subjects without teachers',
	    only_subjects_with_teachers: 'Show subjects without teachers',
	    hours_in_school_year: 'Annual Instruction Time',
	    export_to_zen: 'Export to automatic scheduling',
	    go_to_zen: 'Go to automatic scheduling',
	    exported_to_zen: 'Data is ready in Docendo ZEN',
	    something_went_wrong: 'Something went wrong',
	    choose_grades: 'Choose grades/groups',
	    grades: 'Grades/groups',
	    only_show_users_with_uv_time: 'Only show user with assigned teaching hours',
	    tasks: 'Tasks',
	    no_users_matches: 'No users matches',
	    print: 'Print',
	    only_subjects_with_requests: 'Show only subjects with requests'
	  },
	  nb: {
	    subjects_status: 'Status',
	    name: 'Navn',
	    subjects_for_teachers: 'Fag- og lærerfordeling',
	    filter_users: ' Filtrer etter gruppe',
	    teaching_hours_from_subjects: 'Årstimetall',
	    created_subject: 'Opprettet faget',
	    klass: 'Klasse',
	    subjects: 'Fag',
	    teaching_hours: 'Timetall',
	    no_subjects_assigned: 'Ingen fag tildelt',
	    assigned: 'Tildelt',
	    from_subjects: 'Fra fag',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Vis kun fag uten underviser',
	    only_subjects_with_teachers: 'Vis fag uten underviser',
	    hours_in_school_year: 'Timer i skoleåret',
	    export_to_zen: 'Overfør for automatisk timeplanlegging',
	    go_to_zen: 'Gå til automatisk timeplanlegging',
	    exported_to_zen: 'Data is ready in Docendo ZEN',
	    something_went_wrong: 'Something went wrong',
	    choose_grades: 'Velg klasser',
	    grades: 'Klasser',
	    only_show_users_with_uv_time: 'Vis kun brukere med tildelt undervisning',
	    tasks: 'Oppgaver',
	    no_users_matches: 'Ingen brukere passer til søket',
	    print: 'Skriv ut',
	    only_subjects_with_requests: 'Vis kun fag med ønsker'
	  }
	};
	
	exports.default = {
	  components: {
	    DoButtonAndDate: _DoButtonAndDate2.default,
	    DateSelector: _DateSelector2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default,
	    Loader: _Loader2.default,
	    AppToggle: _AppToggle2.default,
	    ModalConfirmation: _ModalConfirmation2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    SubjectForm: _SubjectForm2.default,
	    FilterUsers: _FilterUsers2.default,
	    TaggingFilter: _TaggingFilter2.default,
	    Spinner: _Spinner2.default,
	    SubjectsDistributionTasks: _SubjectsDistributionTasks2.default,
	    AppFlipperButton: _AppFlipperButtons2.default,
	    SubjectsDistributionUser: _SubjectsDistributionUser2.default,
	    SubjectDistributionPrint: _SubjectsDistributionPrint2.default,
	    SubjectsDistributionTasksCreate: _SubjectsDistributionTasksCreate2.default,
	    DModal: _DModal2.default,
	    StandardDurationSetting: _StandardDurationSetting2.default
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear(val) {
	      this.readAssignedHours();
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	      this.setSubjectsRequestEndDate(this.activeSchoolYear);
	      this.readSubjectRequests();
	    },
	    onlyShowSubjectsWithoutTeacherI18n: function onlyShowSubjectsWithoutTeacherI18n() {
	      if (!this.isShowSubjectsWithoutTeachers) {
	        this.selectedSubjectStatusFilters.push(this.onlyShowSubjectsWithoutTeacherI18n);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      subjectSearchQuery: '',
	      selectedSubjectStatusFilters: [],
	      sortBy: 'name',
	      sortOrder: -1,
	      isShowOnlyTeacherWithTeachingTime: false,
	      isPrintUsers: false,
	      editSubject: null,
	      theEditTask: null,
	      isSubjectModal: false,
	      activeUserId: null,
	      selectedKlassFilters: [],
	      isTasksView: false,
	      theZENToken: '',
	      isOpenDurationModal: false,
	      isModalKlassTotalHours: false,
	      subjectsRequestEndDate: null,
	      isUpdatingSchoolYear: false,
	      isSubjectLoading: false,
	      selectedSubjectFilters: []
	    };
	  },
	
	  computed: {
	    subjectStatusFilters: function subjectStatusFilters() {
	      return [this.onlyShowSubjectsWithoutTeacherI18n, this.onlyShowSubjectsWithRequestsI18n, this.onlyShowSubjectsWithTeacherI18n];
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    school: function school() {
	      return this.$store.state.activeSchool;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.school && this.school.country ? this.school.country : 'NO';
	    },
	    isSchoolDanish: function isSchoolDanish() {
	      return this.schoolCountry.toUpperCase() === 'DK';
	    },
	    isShowSubjectsRequest: function isShowSubjectsRequest() {
	      return this.isSchoolDanish && this.userHasPermission('can_see_other_subject_requests');
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    userCanManageSchool: function userCanManageSchool() {
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions && this.userPermissions.indexOf('can_manage_school') > -1 || this.user && this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    zenUrl: function zenUrl() {
	      var startURL = 'https://zen.docendo.co/login/?jwt=';
	      if (this.locale === 'da') {
	        startURL = 'https://zen.docendo.co/da/login/?jwt=';
	      }
	      if (this.locale === 'nb') {
	        startURL = 'https://zen.docendo.co/nb/login/?jwt=';
	      }
	
	      var schoolUuid = this.school && this.school.uuid ? this.school.uuid : null;
	      var url = startURL + this.theZENToken;
	      url += '&domain=' + encodeURIComponent(window.location.hostname);
	      if (schoolUuid) {
	        url += '&school_uuid=' + schoolUuid;
	      }
	
	      return url;
	    },
	    isConfirmDeletion: function isConfirmDeletion() {
	      return this.$store.state.subjects.isConfirmDeletion;
	    },
	    itemToDelete: function itemToDelete() {
	      return this.$store.state.subjects.itemToDelete;
	    },
	    klassTags: function klassTags() {
	      return this.klassCalendars.map(function (calendar) {
	        return calendar.name;
	      });
	    },
	    uniqueSubjects: function uniqueSubjects() {
	      var names = [];
	      this.calsWithProps.forEach(function (klass) {
	        klass.vSubjects.forEach(function (subject) {
	          if (subject.name && !names.includes(subject.name)) {
	            names.push(subject.name);
	          }
	        });
	      });
	      return names;
	    },
	    klassSubjects: function klassSubjects() {
	      var _this = this;
	
	      var map = {};
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(this.subjectsInKlassHash)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	              klassId = _step$value[0],
	              subjectIds = _step$value[1];
	
	          map[klassId] = subjectIds.map(function (subjectId) {
	            var subject = _this.subjectsInHash[subjectId] || {};
	
	            return (0, _extends3.default)({}, subject, {
	              vRequestedBy: _this.getSubjectedRequestedBy(subjectId),
	              vHasTeachers: _this.subjectHasTeachers(subjectId),
	              vHasRooms: _this.subjectHasRooms(subjectId),
	              vUserNames: _this.getUserNames(subjectId)
	            });
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return map;
	    },
	    calsWithProps: function calsWithProps() {
	      var _this2 = this;
	
	      return this.klassCalendars.map(function (klass) {
	        return (0, _extends3.default)({}, klass, {
	          vTotalHours: _this2.totalHoursCount(klass.id),
	          vSubjects: _this2.klassSubjects[klass.id] || []
	        });
	      });
	    },
	    filteredKlassCals: function filteredKlassCals() {
	      var _this3 = this;
	
	      var klasses = this.calsWithProps;
	
	      if (this.selectedKlassFilters.length > 0) {
	        klasses = klasses.filter(function (klass) {
	          return _this3.selectedKlassFilters.includes(klass.name);
	        });
	      }
	
	      var hasStatusFilters = this.selectedSubjectStatusFilters.length > 0;
	      var hasSubjectFilters = this.selectedSubjectFilters.length > 0;
	
	      return klasses.map(function (klass) {
	        return (0, _extends3.default)({}, klass, {
	          vSubjects: klass.vSubjects.filter(function (subject) {
	            var hasFilterWithoutTeacher = _this3.selectedSubjectStatusFilters.includes(_this3.onlyShowSubjectsWithoutTeacherI18n);
	            var hasFilterWithTeacher = _this3.selectedSubjectStatusFilters.includes(_this3.onlyShowSubjectsWithTeacherI18n);
	            var hasFilterWithRequests = _this3.selectedSubjectStatusFilters.includes(_this3.onlyShowSubjectsWithRequestsI18n);
	
	            var matchesStatusFilter = !hasStatusFilters || hasFilterWithoutTeacher && !subject.vHasTeachers || hasFilterWithTeacher && subject.vHasTeachers || hasFilterWithRequests && subject.vRequestedBy.length > 0;
	
	            var subjectName = subject.name ? subject.name.toLowerCase() : '';
	            var matchesSearch = !_this3.subjectSearchQuery || subjectName.includes(_this3.subjectSearchQuery.toLowerCase());
	
	            var matchesSubjectFilter = !hasSubjectFilters || _this3.selectedSubjectFilters.includes(subject.name);
	
	            return matchesStatusFilter && matchesSearch && matchesSubjectFilter;
	          })
	        });
	      });
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isLoading: function isLoading() {
	      return this.$store.state.subjects.isLoading;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    allUsersInCalendarHash: function allUsersInCalendarHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    subjectsInKlassHash: function subjectsInKlassHash() {
	      return this.$store.getters.subjectsInKlassHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      return this.$store.getters.tasksInUserHash;
	    },
	    tasksInHash: function tasksInHash() {
	      return this.$store.getters.tasksInHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    usersFilteredWithTags: function usersFilteredWithTags() {
	      var _this4 = this;
	
	      var users = this.$store.getters.usersFilteredWithTags;
	      if (!this.isPoolsDeactivated && this.isShowOnlyTeacherWithTeachingTime) {
	        return users.filter(function (user) {
	          var userHours = _this4.usersAssignedHoursHash[user.id];
	          return userHours && userHours.assigned_teaching_hours;
	        });
	      }
	      return users;
	    },
	    sortedUsersFilteredWithTags: function sortedUsersFilteredWithTags() {
	      var _this5 = this;
	
	      if (this.sortBy === 'name') {
	        return this.$helpers.sortArrOnName(this.usersFilteredWithTags);
	      }
	      return this.usersFilteredWithTags.sort(function (a, b) {
	        return _this5.sortOrder < 0 ? _this5.getUserTeachingHoursDiff(a.id) - _this5.getUserTeachingHoursDiff(b.id) : _this5.getUserTeachingHoursDiff(b.id) - _this5.getUserTeachingHoursDiff(a.id);
	      });
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return this.schoolSettings && this.schoolSettings['deactivatePools'] ? this.schoolSettings['deactivatePools'] : false;
	    },
	    doesRessCountInKlassTotalHours: function doesRessCountInKlassTotalHours() {
	      return !this.schoolSettings.hasOwnProperty('hide_ressource_hours_count_in_total_hours_for_klasse');
	    },
	    subjectsRequestsInHash: function subjectsRequestsInHash() {
	      return this.$store.getters.subjectsRequestsInHash;
	    },
	    isShowSubjectsWithoutTeachers: function isShowSubjectsWithoutTeachers() {
	      return this.selectedSubjectStatusFilters.indexOf(this.onlyShowSubjectsWithoutTeacherI18n) > -1;
	    },
	    isShowSubjectsWithTeachers: function isShowSubjectsWithTeachers() {
	      return this.selectedSubjectStatusFilters.indexOf(this.onlyShowSubjectsWithTeacherI18n) > -1;
	    },
	    onlyShowSubjectsWithoutTeacherI18n: function onlyShowSubjectsWithoutTeacherI18n() {
	      return this.i18n[this.locale].only_subjects_without_teachers;
	    },
	    onlyShowSubjectsWithRequestsI18n: function onlyShowSubjectsWithRequestsI18n() {
	      return this.i18n[this.locale].only_subjects_with_requests;
	    },
	    onlyShowSubjectsWithTeacherI18n: function onlyShowSubjectsWithTeacherI18n() {
	      return this.i18n[this.locale].only_subjects_with_teachers;
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions && this.userPermissions.indexOf(permission) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    getSubjectedRequestedBy: function getSubjectedRequestedBy(subjectId) {
	      var _this6 = this;
	
	      var currentCalendarIds = this.subjectsRequestsInHash[subjectId] || [];
	      return currentCalendarIds.filter(function (calId) {
	        return calId !== _this6.userCalendarId && _this6.allCalendarsInHash[calId];
	      }).map(function (calId) {
	        return _this6.allCalendarsInHash[calId] ? _this6.allCalendarsInHash[calId]['name'] : [];
	      });
	    },
	    setSubjectsRequestEndDate: function setSubjectsRequestEndDate(schoolYear) {
	      if (schoolYear && Object.prototype.hasOwnProperty.call(schoolYear, 'subject_request_end')) {
	        this.subjectsRequestEndDate = schoolYear.subject_request_end;
	      }
	    },
	    onSetSubjectsRequestEndDate: function onSetSubjectsRequestEndDate(date) {
	      var _this7 = this;
	
	      this.isUpdatingSchoolYear = true;
	      var dbDate = null;
	      if (date) {
	        dbDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      }
	      _docendo2.default.schoolYearsUpdate(this.schoolId, this.activeSchoolYear.id, { subject_request_end: dbDate }, function (success) {
	        _this7.isUpdatingSchoolYear = false;
	        _this7.setSubjectsRequestEndDate(success);
	        _this7.updateRORDOMAnnouncementBadge(dbDate);
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    updateRORDOMAnnouncementBadge: function updateRORDOMAnnouncementBadge(dbDate) {
	      var announcementEl = document.querySelector('.do-top-menu-announcement');
	      var navStart = document.querySelector('#nav-start');
	      var navEnd = document.querySelector('#nav-end');
	
	      if (!navStart || !navEnd) {
	        console.warn('Kunne ikke finde navigationselementerne i headeren.');
	        return;
	      }
	
	      if (dbDate && (0, _moment2.default)(dbDate).isBefore((0, _moment2.default)(), 'day')) {
	        if (announcementEl) {
	          announcementEl.remove();
	        }
	        return;
	      }
	
	      if (!dbDate) {
	        if (announcementEl) {
	          announcementEl.remove();
	        }
	        return;
	      }
	
	      if (!announcementEl) {
	        var newEl = document.createElement('div');
	        newEl.classList.add('do-top-menu-announcement');
	
	        var anchor = document.createElement('a');
	        anchor.href = '/schools/' + this.schoolId + '/subject_requests?school_year_id=' + this.activeSchoolYear.id;
	        anchor.innerHTML = 'Fag\xF8nsker er \xE5ben indtil <span data-date="' + dbDate + '">' + (0, _moment2.default)(dbDate).format('D. MMMM YYYY') + '</span>';
	
	        newEl.appendChild(anchor);
	
	        navStart.parentNode.insertBefore(newEl, navEnd);
	      } else {
	        var spanEl = announcementEl.querySelector('span[data-date]');
	        if (spanEl) {
	          spanEl.setAttribute('data-date', dbDate);
	          spanEl.textContent = (0, _moment2.default)(dbDate).format('D. MMMM YYYY');
	        }
	      }
	    },
	    readSubjectRequests: function readSubjectRequests() {
	      if (this.isShowSubjectsRequest && this.activeSchoolYear && this.activeSchoolYear.id) {
	        this.$store.dispatch('readSubjectRequests', this.activeSchoolYear.id);
	      }
	    },
	    toggleDoesRessCount: function toggleDoesRessCount() {
	      if (!this.doesRessCountInKlassTotalHours) {
	        this.$store.dispatch('deleteSchoolSetting', 'hide_ressource_hours_count_in_total_hours_for_klasse');
	      } else {
	        this.$store.dispatch('updateSchoolSettings', { 'hide_ressource_hours_count_in_total_hours_for_klasse': true });
	      }
	    },
	    saveUpdatedDuration: function saveUpdatedDuration() {
	      this.exportToZen();
	    },
	    closeIsPrintUsers: function closeIsPrintUsers() {
	      this.isPrintUsers = false;
	      window.scrollTo(0, 0);
	    },
	    deleteSubject: function deleteSubject(editSubject) {
	      var deletedSubject = {
	        id: editSubject.id,
	        school_id: editSubject.school_id,
	        school_year_id: this.activeSchoolYear.id
	      };
	      deletedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('deleteSubject', deletedSubject);
	      this.closeModal();
	    },
	    exportToZen: function exportToZen() {
	      var _this8 = this;
	
	      _docendo2.default.createExport(this.schoolId, this.activeSchoolYear.id, function (success) {
	        _eventbus2.default.toast = { text: _this8.i18n[_this8.locale].exported_to_zen, 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this8.i18n[_this8.locale].something_went_wrong, 'success': false };
	      });
	    },
	    userHasAgreements: function userHasAgreements(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].agreements;
	    },
	    setSortBy: function setSortBy(key) {
	      this.sortBy = key;
	      this.sortOrder = this.sortOrder * -1;
	    },
	    confirmDelete: function confirmDelete() {
	      if (this.itemToDelete && this.itemToDelete.itemType === 'task') {
	        this.$store.dispatch('deleteTask', this.itemToDelete);
	        this.$store.commit('setTheDeletedItemId', this.itemToDelete.id);
	      }
	      this.$store.commit('setConfirmDeletion', false);
	      this.$store.commit('setItemToDelete', null);
	    },
	    subjectHasTeachers: function subjectHasTeachers(subjectId) {
	      var _this9 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      var hasTeachers = false;
	      calIds.forEach(function (calId) {
	        if (_this9.allCalendarsInHash[calId] && _this9.allCalendarsInHash[calId].type === 'user') {
	          hasTeachers = true;
	        }
	      });
	      return hasTeachers;
	    },
	    subjectHasRooms: function subjectHasRooms(subjectId) {
	      var _this10 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      var hasRooms = false;
	      calIds.forEach(function (calId) {
	        if (_this10.allCalendarsInHash[calId] && _this10.allCalendarsInHash[calId].type === 'room') {
	          hasRooms = true;
	        }
	      });
	      return hasRooms;
	    },
	    getUserNames: function getUserNames(subjectId) {
	      var _this11 = this;
	
	      var calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : [];
	      if (!calIds || calIds.length < 1 || !calIds[0]) {
	        return '';
	      }
	      return calIds.filter(function (calId) {
	        return _this11.allCalendarsInHash[calId] && _this11.allCalendarsInHash[calId].type === 'user';
	      }).map(function (userCalId) {
	        return _this11.allCalendarsInHash[userCalId].name ? _this11.allCalendarsInHash[userCalId].name : '';
	      });
	    },
	    subjectHasRoom: function subjectHasRoom(subjectId) {
	      var subject = this.subjectsInHash[subjectId];
	      return subject.rooms_calendar_ids && subject.rooms_calendar_ids.length > 0 && subject.rooms_calendar_ids[0];
	    },
	    updateLocalStorage: function updateLocalStorage(key, filters) {
	      var val = (0, _stringify2.default)(filters);
	      this.$helpers.setLocalStorage(key, val);
	    },
	    toggleFilter: function toggleFilter(filter, filterArray) {
	      var storageKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      if (filterArray.includes(filter)) {
	        filterArray.splice(filterArray.indexOf(filter), 1);
	      } else {
	        filterArray.push(filter);
	      }
	
	      if (storageKey) {
	        this.updateLocalStorage(storageKey, filterArray);
	      }
	    },
	    toggleKlassTag: function toggleKlassTag(tag) {
	      this.toggleFilter(tag, this.selectedKlassFilters, 'doSubjectsDistributionSubjectKlassFilters');
	    },
	    clearSelectedKlassFilters: function clearSelectedKlassFilters() {
	      this.selectedKlassFilters = [];
	      var storageKey = 'doSubjectsDistributionSubjectKlassFilters';
	      this.updateLocalStorage(storageKey, []);
	    },
	    toggleSelectedSubjectStatusFilters: function toggleSelectedSubjectStatusFilters(filter) {
	      this.toggleFilter(filter, this.selectedSubjectStatusFilters, 'doSubjectsDistributionSubjectStatusFilters');
	    },
	    toggleSelectedSubjectFilters: function toggleSelectedSubjectFilters(filter) {
	      this.toggleFilter(filter, this.selectedSubjectFilters, 'doSubjectsDistributionSubjectFilters');
	    },
	    clearSelectedSubjectFilters: function clearSelectedSubjectFilters() {
	      this.selectedSubjectFilters = [];
	      var storageKey = 'doSubjectsDistributionSubjectFilters';
	      this.updateLocalStorage(storageKey, []);
	    },
	    clearSelectedSubjectStatusFilters: function clearSelectedSubjectStatusFilters() {
	      this.selectedSubjectStatusFilters = [];
	      var storageKey = 'doSubjectsDistributionSubjectStatusFilters';
	      this.updateLocalStorage(storageKey, []);
	    },
	    getUserAssignedTeachingHours: function getUserAssignedTeachingHours(userId) {
	      return this.usersAssignedHoursHash[userId] ? this.usersAssignedHoursHash[userId].assigned_teaching_hours : 0;
	    },
	    getSubjectHours: function getSubjectHours(subjectId, userCalId) {
	      var userId = this.allUsersInCalendarHash[userCalId].id;
	      var theSubject = this.subjectsInHash[subjectId];
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === userId;
	      }) : -1;
	      if (idx > -1) {
	        return theSubject.teachers[idx].hours;
	      } else {
	        return theSubject.hours;
	      }
	    },
	    getTotalSubjectTeachingHours: function getTotalSubjectTeachingHours(userCalId) {
	      var _this12 = this;
	
	      var subjectsHours = [0];
	      var subjects = this.subjectsInUserHash[userCalId] ? this.subjectsInUserHash[userCalId].map(function (subjectId) {
	        return _this12.subjectsInHash[subjectId];
	      }) : [];
	      subjects = subjects.filter(function (subject) {
	        var calendarType = _this12.allCalendarsInHash[subject.calendar_id] ? _this12.allCalendarsInHash[subject.calendar_id].type : 'null';
	        return calendarType === 'klass' || calendarType === 'merge';
	      });
	      subjectsHours = subjects && subjects.length > 0 ? subjects.map(function (subject) {
	        return _this12.getSubjectHours(subject.id, userCalId) * 1;
	      }) : [0];
	      var total = subjectsHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return total;
	    },
	    getTotalUserTasksTeachingHours: function getTotalUserTasksTeachingHours(userCalId) {
	      var _this13 = this;
	
	      var tasks = this.tasksInUserHash[userCalId] ? this.tasksInUserHash[userCalId].filter(function (taskId) {
	        return _this13.tasksInHash[taskId].subject_type === 'person_resource' || _this13.tasksInHash[taskId].subject_type === 'person_resource_visible' || _this13.tasksInHash[taskId].subject_type === 'subject';
	      }) : null;
	      var tasksHours = tasks && tasks.length > 0 ? tasks.map(function (taskId) {
	        return _this13.tasksInHash[taskId].hours * 1;
	      }) : [0];
	      return tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	    },
	    getTotalUserHoursTeachingCount: function getTotalUserHoursTeachingCount(userCalId) {
	      return this.getTotalSubjectTeachingHours(userCalId) + this.getTotalUserTasksTeachingHours(userCalId);
	    },
	    getUserTeachingHoursDiff: function getUserTeachingHoursDiff(userId) {
	      var diff = !this.isPoolsDeactivated ? this.getUserAssignedTeachingHours(userId) - this.getTotalUserHoursTeachingCount(this.allUsersInHash[userId].user_calendar_id) : this.getTotalUserHoursTeachingCount(this.allUsersInHash[userId].user_calendar_id);
	      return diff.toFixed(1);
	    },
	    setActiveUserId: function setActiveUserId(userId) {
	      if (this.activeUserId === userId) {
	        return;
	      }
	      this.activeUserId = userId;
	    },
	    resetActiveUserId: function resetActiveUserId() {
	      var _this14 = this;
	
	      setTimeout(function (_) {
	        _this14.activeUserId = null;
	      }, 0);
	    },
	    getAllUserSubjects: function getAllUserSubjects(calid) {
	      return this.subjectsInUserHash[calid];
	    },
	    readAssignedHours: function readAssignedHours() {
	      var schoolObj = {
	        schoolId: this.schoolId,
	        schoolYearId: this.activeSchoolYear.id
	      };
	      this.$store.dispatch('getUsers', this.schoolId, null);
	      this.$store.dispatch('readUsersAssignedHours', schoolObj);
	    },
	    totalHoursCount: function totalHoursCount(klassCalId) {
	      var _this15 = this;
	
	      var subjectsHours = [0];
	      var subjectsTypesThatDoesntCount = this.doesRessCountInKlassTotalHours ? [] : ['resource', 'person_resource_visible'];
	      if (this.subjectsInKlassHash[klassCalId]) {
	        var subjects = this.subjectsInKlassHash[klassCalId].map(function (subjectId) {
	          return _this15.subjectsInHash[subjectId];
	        }).filter(function (subject) {
	          return subjectsTypesThatDoesntCount.indexOf(subject.subject_type) < 0;
	        });
	        subjectsHours = subjects.map(function (subject) {
	          return subject.hours * 1;
	        });
	      }
	      var sum = subjectsHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return sum.toFixed(2);
	    },
	    isShowWithoutTeacher: function isShowWithoutTeacher(subjectid) {
	      if (!this.isShowSubjectsWithoutTeachers) {
	        return true;
	      } else {
	        return !this.subjectHasTeachers(subjectid);
	      }
	    },
	    closeModal: function closeModal() {
	      this.editSubject = null;
	      this.isSubjectModal = false;
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      var _this16 = this;
	
	      this.isSubjectLoading = true;
	      this.isSubjectModal = true;
	      _docendo2.default.showSubject(editSubject.id, function (success) {
	        _this16.editSubject = (0, _assign2.default)({}, success);
	        _this16.isSubjectLoading = false;
	        setTimeout(function (_) {
	          _this16.$store.commit('updateSubject', success);
	        }, 1500);
	        setTimeout(function (_) {
	          _this16.isTheCreateCalenderSubjectActive = null;
	        }, 1);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    setEditTask: function setEditTask(editTask) {
	      this.theEditTask = this.tasksInHash[editTask.id];
	    },
	    updateSubject: function updateSubject(updatedSubject) {
	      if (!updatedSubject['schoolId']) {
	        updatedSubject['schoolId'] = this.schoolId;
	      }
	      if (!updatedSubject['schoolYearId']) {
	        updatedSubject['schoolYearId'] = this.activeSchoolYear.id;
	      }
	      this.$store.dispatch('updateSubject', updatedSubject);
	      this.closeModal();
	    },
	    setPrint: function setPrint() {
	      this.isPrintUsers = true;
	    },
	    getZENJWT: function getZENJWT() {
	      var _this17 = this;
	
	      _docendo2.default.getJwt(function (data) {
	        _this17.theZENToken = data && data.token ? data.token : '';
	      });
	    },
	    readSubject: function readSubject() {
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	    },
	    loadFiltersFromLocalStorage: function loadFiltersFromLocalStorage(key, filterArray) {
	      var deprecatedFilters = ['Vis kun fag uden underviser'];
	      var storedFilters = this.$helpers.getLocalStorage(key);
	
	      if (storedFilters) {
	        var parsedFilters = JSON.parse(storedFilters);
	
	        parsedFilters = parsedFilters.filter(function (filter) {
	          return !deprecatedFilters.includes(filter);
	        });
	
	        this[filterArray] = parsedFilters;
	
	        if (parsedFilters.length !== JSON.parse(storedFilters).length) {
	          this.$helpers.setLocalStorage(key, (0, _stringify2.default)(parsedFilters));
	        }
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (!this.isShowSubjectsWithoutTeachers) {
	      this.selectedSubjectStatusFilters.push(this.onlyShowSubjectsWithoutTeacherI18n);
	    }
	
	    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectStatusFilters', 'selectedSubjectStatusFilters');
	    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectKlassFilters', 'selectedKlassFilters');
	    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectFilters', 'selectedSubjectFilters');
	  },
	  mounted: function mounted() {
	    var _this18 = this;
	
	    this.readAssignedHours();
	    this.getZENJWT();
	    this.readSubjectRequests();
	    window.addEventListener('new_subjects_created', function () {
	      return _this18.readSubject();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _this19 = this;
	
	    window.removeEventListener('new_subjects_created', function () {
	      return _this19.readSubject();
	    });
	  }
	};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SubjectsDistributionUser = __webpack_require__(126);
	
	var _SubjectsDistributionUser2 = _interopRequireDefault(_SubjectsDistributionUser);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { SubjectsDistributionUser: _SubjectsDistributionUser2.default, DModal: _DModal2.default },
	  data: function data() {
	    return {
	      isPrintSettingsModal: false,
	      filteredUsers: []
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    usersFilteredWithTags: function usersFilteredWithTags() {
	      return this.$store.getters.usersFilteredWithTags;
	    },
	    usersFilteredWithTagsFiltered: function usersFilteredWithTagsFiltered() {
	      return this.usersFilteredWithTags.filter(function (user) {
	        return user;
	      });
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.readAssignedHours();
	      this.$store.dispatch('readSubjects', this.activeSchoolYear.id);
	      this.$store.dispatch('readTasks', this.activeSchoolYear.id);
	    }
	  },
	  methods: {
	    isUserFiltered: function isUserFiltered(user) {
	      return this.filteredUsers.indexOf(user.id) > -1;
	    },
	    toggleFilteredUser: function toggleFilteredUser(user) {
	      var idx = this.filteredUsers.indexOf(user.id);
	      if (idx < 0) {
	        this.filteredUsers.push(user.id);
	      } else {
	        this.filteredUsers.splice(idx, 1);
	      }
	    },
	    readAssignedHours: function readAssignedHours() {
	      var schoolObj = {
	        schoolId: window.SCHOOL.id,
	        schoolYearId: this.activeSchoolYear.id
	      };
	      this.$store.dispatch('getUsers', window.SCHOOL.id, null);
	      this.$store.dispatch('readUsersAssignedHours', schoolObj);
	    },
	    print: function print() {
	      setTimeout(function (_) {
	        try {
	          document.execCommand('print', false, null);
	        } catch (err) {
	          window.print();
	        }
	        setTimeout(function (_) {
	          window.close();
	        }, 1000);
	      }, 0);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.readAssignedHours();
	    setTimeout(function (_) {
	      _this.isPrintSettingsModal = true;
	    }, 500);
	  }
	};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(52);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(72);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DSelectCalsIds = __webpack_require__(59);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _SubjectsDistributionTasksCreate = __webpack_require__(125);
	
	var _SubjectsDistributionTasksCreate2 = _interopRequireDefault(_SubjectsDistributionTasksCreate);
	
	var _DFilters = __webpack_require__(348);
	
	var _DFilters2 = _interopRequireDefault(_DFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    create_tasks: 'Opret opgaver',
	    search_task: 'Søg på opgave',
	    teaching_short: 'UV',
	    other_short: 'Øvrig',
	    prep: 'Forb.',
	    teacher: 'Underviser',
	    sum: 'Total',
	    task_name: 'Opgavens navn...',
	    create: 'Opret',
	    search_and_select: 'Søg og vælg',
	    has_scheduled_and_cant_be_deleted: 'har skemalagte brikker, og kan ikke fjernes',
	    no_tasks_created: 'Der er ikke oprettet nogen opgaver',
	    no_tasks_matching: 'Ingen opgaver matcher søgningen',
	    all: 'Alle',
	    teaching: 'Undervisning',
	    additional_tasks: 'Øvrige opgaver',
	    preparation: 'Forberedelse',
	    pool: 'Lokalpulje'
	  },
	  nb: {
	    create_tasks: 'Opprett oppgaver',
	    search_task: 'Søk etter oppgave',
	    teaching_short: 'undervisning',
	    other_short: 'Oppgave',
	    prep: 'Forberedelse',
	    teacher: 'Underviser',
	    sum: 'Totalt',
	    task_name: 'Oppgavens navn...',
	    create: 'Opprett',
	    search_and_select: 'Søk og velg',
	    has_scheduled_and_cant_be_deleted: 'er planlagt i timeplanen, og kan derfor ikke slettes.',
	    no_tasks_created: 'Der er ikke opprettet noen oppgaver.',
	    no_tasks_matching: 'Ingen treff',
	    all: 'Alle',
	    teaching: 'Undervisning',
	    additional_tasks: 'Øvrige oppgaver',
	    preparation: 'Forberedelse',
	    pool: 'Planleggingsdager'
	  },
	  en: {
	    create_tasks: 'Create tasks',
	    search_task: 'Search for task',
	    teaching_short: 'teaching',
	    other_short: 'Additional',
	    prep: 'Preparation',
	    teacher: 'Teacher',
	    sum: 'Total',
	    task_name: 'Name of task...',
	    create: 'Create',
	    search_and_select: 'Search and choose',
	    has_scheduled_and_cant_be_deleted: 'has been schedules, and cannot be deleted',
	    no_tasks_created: 'No tasks created',
	    no_tasks_matching: 'No match',
	    all: 'All',
	    teaching: 'Teaching',
	    additional_tasks: 'Additional tasks',
	    preparation: 'Preparation',
	    pool: 'Custom pool'
	  }
	};
	
	exports.default = {
	  components: { DFilters: _DFilters2.default, DSelectCalendarIds: _DSelectCalsIds2.default, CreateTask: _SubjectsDistributionTasksCreate2.default },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      isTaskModal: false,
	      editTask: null,
	      isSearchHidden: true,
	      isSearchHiddenFadeIn: false,
	      query: '',
	      activeDSelect: null,
	      activeDSelectShow: false,
	      theFilter: '',
	      isShowCreateFast: false,
	      fastFormName: '',
	      fastFormHoursTeaching: '',
	      fastFormHoursTask: '',
	      fastFormHoursPrep: '',
	      fastFormUsers: [],
	      formErrors: {}
	    };
	  },
	
	  computed: {
	    isSubmittingTask: function isSubmittingTask() {
	      return this.$store.state.subjects.isSubmittingTask;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isSchoolFeatureLocalePool: function isSchoolFeatureLocalePool() {
	      return this.$store.getters.isSchoolFeatureLocalePool;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    tasks: function tasks() {
	      return this.$store.state.subjects.tasks;
	    },
	    tasksTeaching: function tasksTeaching() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'person_resource_visible' || task.subject_type === 'person_resource' || task.subject_type === 'subject';
	      });
	    },
	    tasksTasks: function tasksTasks() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'additional_tasks';
	      });
	    },
	    tasksPrep: function tasksPrep() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'preparation';
	      });
	    },
	    tasksPool: function tasksPool() {
	      return this.tasks.filter(function (task) {
	        return task.subject_type === 'pool';
	      });
	    },
	    filters: function filters() {
	      var filters = [{ label: this.i18n[this.locale]['all'], value: '', length: this.tasks.length }, { label: this.i18n[this.locale]['teaching'], value: 'person_resource', length: this.tasksTeaching.length }, { label: this.i18n[this.locale]['additional_tasks'], value: 'additional_tasks', length: this.tasksTasks.length }, { label: this.i18n[this.locale]['preparation'], value: 'preparation', length: this.tasksPrep.length }, { label: this.i18n[this.locale]['pool'], value: 'pool', length: this.tasksPool.length }];
	      return this.isSchoolFeatureLocalePool ? filters : filters.filter(function (filter) {
	        return filter.value !== 'pool';
	      });
	    },
	    filteredTasks: function filteredTasks() {
	      switch (this.theFilter) {
	        case 'person_resource':
	          return this.tasksTeaching;
	        case 'additional_tasks':
	          return this.tasksTasks;
	        case 'preparation':
	          return this.tasksPrep;
	        case 'pool':
	          return this.tasksPool;
	        default:
	          return this.tasks;
	      }
	    },
	    sortedTasks: function sortedTasks() {
	      return this.filteredTasks.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    searchedTasks: function searchedTasks() {
	      var _this = this;
	
	      return this.sortedTasks.filter(function (task) {
	        task.user_calendar_ids = task.user_calendar_ids.filter(function (calId) {
	          return _this.allCalendarsInHash[calId];
	        });
	        return task.name !== null ? task.name.match(new RegExp(_this.query, 'i')) : '';
	      });
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    usersHash: function usersHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    calcAllHours: function calcAllHours() {
	      var count = 0;
	      this.filteredTasks.forEach(function (task) {
	        count += task.user_calendar_ids ? task.hours * task.user_calendar_ids.length : 0;
	      });
	      return count;
	    },
	    keyboardShortcut: function keyboardShortcut() {
	      return this.isShowCreateFast ? 'esc' : 'N';
	    },
	    hasValidNumber: function hasValidNumber() {
	      var hasNumber = -1;
	      if (this.fastFormHoursTeaching !== '') {
	        hasNumber = this.fastFormHoursTeaching * 1;
	      } else if (this.fastFormHoursTask !== '') {
	        hasNumber = this.fastFormHoursTask * 1;
	      } else if (this.fastFormHoursPrep !== '') {
	        hasNumber = this.fastFormHoursPrep * 1;
	      }
	      return hasNumber > -1;
	    },
	    isFastFormValid: function isFastFormValid() {
	      return this.fastFormName.length > 0 && this.hasValidNumber;
	    },
	    theDeletedItemId: function theDeletedItemId() {
	      return this.$store.state.subjects.theDeletedItemId;
	    }
	  },
	  watch: {
	    theDeletedItemId: function theDeletedItemId() {
	      this.closeUpdateTask();
	    }
	  },
	  methods: {
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    setFilter: function setFilter(val) {
	      this.theFilter = val;
	      this.fastFormHoursTeaching = '';
	      this.fastFormHoursTask = '';
	      this.fastFormHoursPrep = '';
	    },
	    closeDSelect: function closeDSelect() {
	      if (!this.activeDSelect) {
	        return;
	      }
	      this.activeDSelect = null;
	    },
	    isActiveDSelect: function isActiveDSelect(taskId) {
	      return this.activeDSelect === taskId;
	    },
	    setActiveDSelect: function setActiveDSelect(task) {
	      if (task.user_calendar_ids.length < 1) {
	        this.activeDSelectShow = true;
	      } else {
	        this.activeDSelectShow = false;
	      }
	      this.activeDSelect = task.id;
	    },
	    getUsers: function getUsers(userCalIds) {
	      var _this2 = this;
	
	      return userCalIds.map(function (calId) {
	        return _this2.allCalendarsInHash[calId] ? _this2.allCalendarsInHash[calId].name : '';
	      });
	    },
	    closeSearchGroup: function closeSearchGroup() {
	      if (this.isSearchHidden) {
	        return;
	      }
	      this.isSearchHidden = true;
	      this.isSearchHiddenFadeIn = false;
	      this.query = '';
	    },
	    setIsSearchHidden: function setIsSearchHidden(boolean) {
	      var _this3 = this;
	
	      if (!boolean) {
	        this.isSearchHidden = false;
	        setTimeout(function (_) {
	          _this3.$refs.query_input.focus();
	          _this3.isSearchHiddenFadeIn = true;
	        }, 0);
	      }
	    },
	    setCreateNewTask: function setCreateNewTask() {
	      this.editTask = null;
	      this.isTaskModal = true;
	    },
	    submitFastForm: function submitFastForm() {
	      var _this4 = this;
	
	      this.fastFormValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var subjectType = 'additional_tasks';
	      var hours = 0;
	      if (this.fastFormHoursTeaching) {
	        subjectType = 'person_resource';
	        hours = this.fastFormHoursTeaching;
	      } else if (this.fastFormHoursTask) {
	        subjectType = 'additional_tasks';
	        hours = this.fastFormHoursTask;
	      } else if (this.fastFormHoursPrep) {
	        subjectType = 'preparation';
	        hours = this.fastFormHoursPrep;
	      }
	      var newTask = {
	        schoolYearId: this.activeSchoolYear.id,
	        subjectType: subjectType,
	        hours: hours,
	        name: this.fastFormName,
	        color: '#999999',
	        defaultDuration: 45,
	        preparation: null,
	        belongsToCalendars: this.fastFormUsers.map(function (user) {
	          return user.id;
	        }),
	        userCalendars: null,
	        canSchedule: false,
	        inUserCalendar: true
	      };
	      this.$store.dispatch('createTask', newTask);
	      this.resetFastForm();
	      this.isShowCreateFast = false;
	      setTimeout(function (_) {
	        _this4.isShowCreateFast = true;
	      }, 200);
	      setTimeout(function (_) {
	        _this4.$refs.shortcutInput.focus();
	      }, 500);
	    },
	    resetFastForm: function resetFastForm() {
	      this.fastFormName = '';
	      this.fastFormHoursTeaching = '';
	      this.fastFormHoursTask = '';
	      this.fastFormHoursPrep = '';
	      this.fastFormUsers = [];
	    },
	    createTask: function createTask(task) {
	      var _this5 = this;
	
	      task['schoolYearId'] = this.activeSchoolYear.id;
	      this.$store.dispatch('createTask', task);
	      this.isTaskModal = false;
	      setTimeout(function (_) {
	        _this5.isTaskModal = true;
	      }, 0);
	    },
	    setEditTask: function setEditTask(task) {
	      var _this6 = this;
	
	      this.isTaskModal = false;
	      this.editTask = task;
	      setTimeout(function (_) {
	        _this6.isTaskModal = true;
	      }, 0);
	    },
	    closeUpdateTask: function closeUpdateTask() {
	      this.isTaskModal = false;
	      this.editTask = null;
	    },
	    updateTask: function updateTask(updatesForTask) {
	      this.$store.dispatch('updateTask', updatesForTask);
	      this.closeUpdateTask();
	    },
	    getCalcTotal: function getCalcTotal(task) {
	      return task.hours * task.user_calendar_ids.length;
	    },
	    setSelectedUsers: function setSelectedUsers(users, task) {
	      if (!task) {
	        this.fastFormUsers = users;
	        return;
	      }
	      var userCalIdsCannotDelete = this.usersWithEvents(task) || [];
	      var userCalendars = (0, _from2.default)(new _set2.default(users.map(function (user) {
	        return user.id;
	      }).concat(userCalIdsCannotDelete)));
	      var belongsToCalendars = [];
	      if (!task.in_user_calendar) {
	        belongsToCalendars = task.belongs_to_calendars[0];
	      } else {
	        belongsToCalendars = userCalendars;
	      }
	
	      var updatedTask = {
	        schoolId: task.school_id,
	        schoolYearId: task.school_year_id,
	        id: task.id,
	        name: task.name,
	        color: task.color,
	        hours: task.hours,
	        defaultDuration: task.default_duration,
	        preparation: Number(task.preparation) || 0,
	        belongsToCalendars: belongsToCalendars,
	        userCalendars: userCalendars,
	        inUserCalendar: task.in_user_calendar
	      };
	      this.updateTask(updatedTask);
	    },
	    setIsShowCreateFast: function setIsShowCreateFast() {
	      if (!this.isShowCreateFast) {
	        this.openIsShowCreateFast();
	      } else {
	        this.closeIsShowCreateFast();
	      }
	    },
	    openIsShowCreateFast: function openIsShowCreateFast() {
	      var _this7 = this;
	
	      this.isShowCreateFast = true;
	      setTimeout(function (_) {
	        _this7.$refs.shortcutInput.focus();
	      }, 500);
	    },
	    closeIsShowCreateFast: function closeIsShowCreateFast() {
	      this.isShowCreateFast = false;
	      this.resetFastForm();
	    },
	    fastFormValidation: function fastFormValidation() {
	      if (this.fastFormName.length < 1) {
	        this.$set(this.formErrors, 'fastFormName', {
	          da: 'Opgaven skal have et navn',
	          en: 'Task must have a name',
	          nb: 'Opgave må ha et navn'
	        });
	      }
	      if (!this.hasValidNumber) {
	        this.$set(this.formErrors, 'fastFormHours', {
	          da: 'Opgaven skal tildeles en pulje',
	          en: 'The task must be assigned a number of hours',
	          nb: 'Oppgaven skal tildeles et antall timer'
	        });
	      }
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    usersWithEvents: function usersWithEvents(task) {
	      var usersWithEvents = [];
	      task.subjects.forEach(function (subject) {
	        if (subject.has_events) {
	          if (subject.user_calendars.length > 0) {
	            usersWithEvents = subject.user_calendars;
	          } else {
	            usersWithEvents.push(subject.calendar_id);
	          }
	        }
	      });
	      return usersWithEvents;
	    },
	    getUserNames: function getUserNames(calIds) {
	      var _this8 = this;
	
	      return calIds.map(function (calId) {
	        return _this8.allCalendarsInHash[calId] ? _this8.allCalendarsInHash[calId].name : '';
	      });
	    }
	  },
	  mounted: function mounted() {
	    this._keyListener = function (e) {
	      if (e.key === 'n') {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.setIsShowCreateFast();
	        }
	      }
	      if (e.key === 'Escape') {
	        this.closeIsShowCreateFast();
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(52);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(72);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DSelectCalsIds = __webpack_require__(59);
	
	var _DSelectCalsIds2 = _interopRequireDefault(_DSelectCalsIds);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _SubjectFormSubjectType = __webpack_require__(71);
	
	var _SubjectFormSubjectType2 = _interopRequireDefault(_SubjectFormSubjectType);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _SubjectsDistributionTasksCreateDropdown = __webpack_require__(1340);
	
	var _SubjectsDistributionTasksCreateDropdown2 = _interopRequireDefault(_SubjectsDistributionTasksCreateDropdown);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    create_task: 'Opret opgave',
	    update_task: 'Opdatér',
	    task_title: 'Opgavens titel',
	    ex_task: 'Eks. Tilsyn',
	    choose_type: 'Vælg type',
	    hours_as: 'Timer som',
	    add_user: 'Tilføj personale',
	    hours_in_school_year_per_person: 'Øvrig tid',
	    teaching_hours: 'UV tid',
	    cancel: 'Annullér',
	    cannot_be_deleted: 'Kan ikke slettes, da der er skemalagte brikker',
	    can_be_scheduled: 'Kan skemalægges',
	    duration: 'NORMAL VARIGHED (I MINUTTER)',
	    create_in_calendar: 'Opret i kalender',
	    created_in_calendar: 'Oprettet i kalenderen',
	    choose_color: 'Vælg farve',
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Øvrige Opgaver',
	    available: 'Rådighedstimer',
	    club: 'SFO tid',
	    locale_pool: 'Lokalpulje'
	  },
	  nb: {
	    create_task: 'Opprett oppgave',
	    update_task: 'Oppdater',
	    task_title: 'Navn på oppgave',
	    ex_task: 'F.eks. Tilsyn',
	    choose_type: 'Velg type',
	    hours_as: 'Timer som',
	    add_user: 'Legg til underviser(e)',
	    hours_in_school_year_per_person: 'Øvrig tid',
	    teaching_hours: 'Undervisningstid',
	    cancel: 'Annuller',
	    cannot_be_deleted: 'Kan ikke slettes, ettersom faget er timeplanlagt.',
	    can_be_scheduled: 'Kan timeplanlegges',
	    duration: 'STANDARDLENGDE (I MINUTTER)',
	    create_in_calendar: 'Opprett i kalender',
	    created_in_calendar: 'Opprettet i kalenderen',
	    choose_color: 'Velg farge',
	    teaching: 'Undervisning',
	    preparation: 'Forberedelse',
	    additional_tasks: 'Øvrige oppgaver',
	    available: 'Rådighetstimer',
	    club: 'SFO tid',
	    locale_pool: 'Planleggingsdager'
	  },
	  en: {
	    create_task: 'Add task',
	    update_task: 'Update',
	    task_title: 'Title',
	    ex_task: 'eg. non teaching task',
	    choose_type: 'Choose type',
	    hours_as: 'Hours as',
	    add_user: 'Add teacher(s)',
	    hours_in_school_year_per_person: 'Additional time',
	    teaching_hours: 'Teaching hours',
	    cancel: 'Cancel',
	    cannot_be_deleted: 'Cannot be deleted due to scheduled tasks.',
	    can_be_scheduled: 'Can be scheduled',
	    duration: 'STANDARD DURATION (IN MINUTES)',
	    create_in_calendar: 'Create in calendar',
	    created_in_calendar: 'Created in calendar',
	    choose_color: 'Choose color',
	    teaching: 'Teaching',
	    preparation: 'Preparation',
	    additional_tasks: 'Additional tasks',
	    available: 'Available hours',
	    club: 'Club hours',
	    locale_pool: 'Custom pool'
	  }
	};
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default, DSelectCalendarIds: _DSelectCalsIds2.default, SubjectFormSubjectType: _SubjectFormSubjectType2.default, SelectOtherCal: _SubjectsDistributionTasksCreateDropdown2.default, DSelect: _DSelect2.default },
	  props: {
	    editTask: {
	      default: null
	    },
	    activeFilter: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      name: '',
	      hours: 0,
	      calendars: [],
	      subjectType: 'additional_tasks',
	      canSchedule: true,
	      duration: 60,
	      color: '#999999',
	      selectedOtherCalendarId: null,
	      formErrors: [],
	      preparation: null
	    };
	  },
	
	  computed: {
	    isArbeidstidsplanActivated: function isArbeidstidsplanActivated() {
	      return this.$store.getters.isArbeidstidsplanActivated;
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isSchoolFromNorway: function isSchoolFromNorway() {
	      return this.schoolCountry.toLowerCase() === 'no';
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    hoursType: function hoursType() {
	      switch (this.subjectType) {
	        case 'person_resource_visible':
	        case 'person_resource':
	        case 'subject':
	          return this.i18n[this.locale]['teaching'];
	        case 'preparation':
	          return this.i18n[this.locale]['preparation'];
	        case 'additional_tasks':
	          return this.i18n[this.locale]['additional_tasks'];
	        case 'available':
	          return this.i18n[this.locale]['available'];
	        case 'club':
	          return this.i18n[this.locale]['club'];
	        case 'pool':
	          return this.i18n[this.locale]['locale_pool'];
	        case 'with_kids':
	          return 'Med børn';
	        case 'without_kids':
	          return 'Uden børn';
	        default:
	          return this.subjectType;
	      }
	    },
	    isCreateInOtherCalendarAnOption: function isCreateInOtherCalendarAnOption() {
	      return this.subjectType === 'without_kids' || this.subjectType === 'preparation' || this.subjectType === 'additional_tasks';
	    },
	    usersWithEvents: function usersWithEvents() {
	      if (!this.editTask) {
	        return [];
	      }
	      var usersWithEvents = [];
	      this.editTask.subjects.forEach(function (subject) {
	        if (subject.has_events) {
	          if (subject.user_calendars.length > 0) {
	            usersWithEvents = subject.user_calendars;
	          } else {
	            usersWithEvents.push(subject.calendar_id);
	          }
	        }
	      });
	      return usersWithEvents;
	    },
	    theDeletedItemId: function theDeletedItemId() {
	      return this.$store.state.subjects.theDeletedItemId;
	    },
	    isSubmittingTask: function isSubmittingTask() {
	      return this.$store.state.subjects.isSubmittingTask;
	    }
	  },
	  watch: {
	    editTask: function editTask() {
	      var _this = this;
	
	      if (this.editTask) {
	        this.name = this.editTask.name;
	        this.hours = this.editTask.hours_total;
	        this.calendars = [];
	        if (this.editTask.calendar_ids) {
	          this.editTask.calendar_ids.forEach(function (calid) {
	            _this.calendars.push(calid);
	          });
	        }
	        this.$refs.name.focus();
	      }
	    },
	    defaultDuration: function defaultDuration(val) {
	      this.removeErrors('defaultDuration');
	    },
	    theDeletedItemId: function theDeletedItemId() {
	      if (this.theDeletedItemId === this.editTask.id) {
	        this.close();
	      }
	    }
	  },
	  methods: {
	    selectAllOnFocus: function selectAllOnFocus(evt) {
	      setTimeout(function (_) {
	        evt.target.select();
	      }, 0);
	    },
	    getOtherCalendarName: function getOtherCalendarName(calId) {
	      return this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'other' ? this.allCalendarsInHash[calId].name : '';
	    },
	    setSelectedOtherCalendarId: function setSelectedOtherCalendarId(calendarId) {
	      this.selectedOtherCalendarId = calendarId;
	    },
	    setSubjectType: function setSubjectType(type) {
	      this.subjectType = type;
	    },
	    setColor: function setColor(color) {
	      this.color = color;
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.calendars = users.map(function (user) {
	        return user.id;
	      });
	    },
	    setIsCreateAsSubject: function setIsCreateAsSubject(boolean) {
	      var _this2 = this;
	
	      this.canSchedule = boolean;
	      if (!boolean) {
	        this.setColor('#999999');
	      } else {
	        this.$nextTick(function (_) {
	          if (_this2.$refs.inputLessonCount) {
	            _this2.$refs.inputLessonCount.focus();
	          }
	        });
	      }
	    },
	    formValidation: function formValidation() {
	      if (this.name.length < 1) {
	        this.$set(this.formErrors, 'name', {
	          da: 'Opgaven skal have et navn',
	          en: 'Task must have a name',
	          nb: 'Opgave må ha et navn'
	        });
	      }
	      if (this.duration < 0) {
	        this.$set(this.formErrors, 'duration', {
	          da: 'Skal være 0 eller højere',
	          en: 'Must be zero or greater',
	          nb: 'Må være 0 eller høyere'
	        });
	      }
	    },
	    removeErrors: function removeErrors(title) {
	      this.$delete(this.formErrors, title);
	    },
	    createTask: function createTask() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var belongsToCalendars = [];
	      var userCalendars = [];
	      var inUserCalendar = true;
	      if (this.selectedOtherCalendarId) {
	        inUserCalendar = false;
	        belongsToCalendars = [this.selectedOtherCalendarId];
	        userCalendars = this.calendars;
	      } else {
	        belongsToCalendars = this.calendars;
	      }
	      var newTask = {
	        schoolYearId: this.activeSchoolYear.id,
	        subjectType: this.subjectType,
	        hours: this.hours,
	        name: this.name,
	        color: this.color,
	        defaultDuration: this.duration,
	        preparation: this.preparation,
	        belongsToCalendars: belongsToCalendars,
	        userCalendars: userCalendars,
	        canSchedule: this.canSchedule,
	        inUserCalendar: inUserCalendar
	      };
	      this.$emit('create', newTask);
	      this.clearForm();
	      this.$refs.name.focus();
	    },
	    updateTask: function updateTask() {
	      this.formValidation();
	      if ((0, _keys2.default)(this.formErrors).length > 0) {
	        return;
	      }
	      var task = this.editTask;
	      var userCalIdsCannotDelete = this.usersWithEvents || [];
	      var userCalendars = (0, _from2.default)(new _set2.default(this.calendars.concat(userCalIdsCannotDelete)));
	      var belongsToCalendars = [];
	      if (!task.in_user_calendar) {
	        belongsToCalendars = task.belongs_to_calendars[0];
	      } else {
	        belongsToCalendars = userCalendars;
	      }
	      var updatedTask = {
	        schoolId: this.editTask['school_id'],
	        schoolYearId: this.editTask['school_year_id'],
	        id: this.editTask['id'],
	        name: this.name,
	        color: this.color,
	        hours: this.hours,
	        defaultDuration: this.duration,
	        preparation: this.preparation,
	        belongsToCalendars: belongsToCalendars,
	        userCalendars: userCalendars,
	        inUserCalendar: this.editTask['in_user_calendar']
	      };
	      this.$store.dispatch('updateTask', updatedTask);
	      this.$emit('close', updatedTask);
	    },
	    clearForm: function clearForm() {
	      this.formErrors = [];
	      this.name = '';
	      this.hours = 0;
	      this.duration = 45;
	      this.preparation = null;
	      this.color = '#999999';
	      this.calendars = [];
	      this.selectedOtherCalendarId = null;
	    },
	    close: function close() {
	      this.clearForm();
	      this.canSchedule = true;
	      this.$emit('close');
	    },
	    deleteTask: function deleteTask() {
	      this.editTask['itemType'] = 'task';
	      this.$store.commit('setItemToDelete', this.editTask);
	      this.$store.commit('setConfirmDeletion', true);
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this3 = this;
	
	    this.locale = window.USER.language ? window.USER.language : 'da';
	    if (this.activeFilter) {
	      this.subjectType = this.activeFilter;
	    }
	    if (this.editTask) {
	      this.name = this.editTask.name;
	      this.hours = this.editTask.hours;
	      this.subjectType = this.editTask.subject_type;
	      this.color = this.editTask.color;
	      this.canSchedule = this.editTask.can_schedule;
	      this.duration = this.editTask.default_duration;
	      this.preparation = this.editTask.preparation * 1;
	      this.editTask.user_calendar_ids.forEach(function (calid) {
	        _this3.calendars.push(calid);
	      });
	      if (!this.editTask.in_user_calendar) {
	        this.selectedOtherCalendarId = this.editTask.belongs_to_calendars[0];
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    setTimeout(function (_) {
	      _this4.$refs.name.focus();
	    }, 500);
	  }
	};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _core = __webpack_require__(18);
	
	var _vueClickaway = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    own_calendars: 'I hver persons kalender'
	  },
	  nb: {
	    own_calendars: 'I hver lærers kalender'
	  },
	  en: {
	    own_calendars: 'Each teachers calendar'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    selectedCalendarId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isDropDown: false,
	      isPopperReady: false,
	      isPopperDone: false,
	      locale: window.USER.language ? window.USER.language : 'da'
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    selectedCalendar: function selectedCalendar() {
	      var _this = this;
	
	      if (!this.selectedCalendarId) {
	        return this.i18n[this.locale]['own_calendars'];
	      }
	      return this.otherCalendars.filter(function (cal) {
	        return cal.id === _this.selectedCalendarId;
	      })[0].name;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    }
	  },
	  methods: {
	    selectCalendar: function selectCalendar(calendar) {
	      this.$emit('changed', calendar);
	    },
	    createPopper: function createPopper() {
	      var _this2 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, -1]
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this2.isPopperReady = true;
	        _this2.isPopperDone = true;
	      }, 0);
	    },
	    setDropdown: function setDropdown() {
	      var _this3 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        setTimeout(function (_) {
	          _this3.createPopper();
	        }, 0);
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    }
	  }
	};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SubjectsDistributionUserAgreements = __webpack_require__(86);
	
	var _SubjectsDistributionUserAgreements2 = _interopRequireDefault(_SubjectsDistributionUserAgreements);
	
	var _SubjectsDistributionUserEditHours = __webpack_require__(335);
	
	var _SubjectsDistributionUserEditHours2 = _interopRequireDefault(_SubjectsDistributionUserEditHours);
	
	var _SubjectsDistributionUserTable = __webpack_require__(1341);
	
	var _SubjectsDistributionUserTable2 = _interopRequireDefault(_SubjectsDistributionUserTable);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    subjects_for_teachers: 'Fagfordeling',
	    filter_users: ' Filtrer på teams',
	    teaching_hours_from_subjects: 'UV-TID FRA FAG',
	    created_subject: 'Oprettede faget',
	    klass: 'Tilhører',
	    subjects: 'Undervisning',
	    teaching_hours: 'UV tid',
	    no_subjects_assigned: 'Ingen fag tildelt',
	    assigned: 'Tildelt',
	    from_subjects: 'Fra fag',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Vis kun fag uden underviser',
	    hours_in_school_year: 'Timer i skoleåret',
	    time: 'Timer',
	    additional_tasks: 'Øvrige opgaver',
	    preparation: 'Forberedelse',
	    club: 'SFO'
	  },
	  en: {
	    subjects_for_teachers: 'Teacher-subject allocation',
	    filter_users: ' Filter users by groups',
	    teaching_hours_from_subjects: 'Annual instruction time from subjects',
	    created_subject: 'Created subject',
	    klass: 'Class',
	    subjects: 'Subjects',
	    teaching_hours: 'Instruction time',
	    no_subjects_assigned: 'No subjects allocated',
	    assigned: 'Allocated',
	    from_subjects: 'From subjects',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Show only subjects without teachers',
	    hours_in_school_year: 'Annual Instruction Time',
	    time: 'Hours',
	    additional_tasks: 'Not teaching',
	    preparation: 'Preparation',
	    club: 'club'
	  },
	  nb: {
	    subjects_for_teachers: 'Fag- og lærerfordeling',
	    filter_users: ' Filtrer etter gruppe',
	    teaching_hours_from_subjects: 'Årstimetall',
	    created_subject: 'Opprettet faget',
	    klass: 'Klasse',
	    subjects: 'Fag',
	    teaching_hours: 'Timetall',
	    no_subjects_assigned: 'Ingen fag tildelt',
	    assigned: 'Tildelt',
	    from_subjects: 'Fra fag',
	    difference: 'Diff',
	    only_subjects_without_teachers: 'Vis kun fag uten underviser',
	    hours_in_school_year: 'Timer i skoleåret',
	    time: 'Timer',
	    additional_tasks: 'Øvrige oppgaver',
	    preparation: 'Forberedelse',
	    club: 'SFO'
	  }
	};
	
	exports.default = {
	  components: { SubjectsDistributionUserAgreements: _SubjectsDistributionUserAgreements2.default, DDropdown: _DDropdown2.default, DModal: _DModal2.default, SubjectsDistributionUserEditHours: _SubjectsDistributionUserEditHours2.default, TasksTable: _SubjectsDistributionUserTable2.default },
	  props: {
	    activeUserId: {
	      default: null
	    },
	    showCloseCross: {
	      default: true
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      locale: 'da',
	      isPrint: false,
	      theActiveSubject: null,
	      userTasksTasks: []
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    getTheActiveSubject: function getTheActiveSubject() {
	      return this.theActiveSubject ? this.subjectsInHash[this.theActiveSubject] : null;
	    },
	    getTheActiveUser: function getTheActiveUser() {
	      return this.activeUserId ? this.allUsersInHash[this.activeUserId] : null;
	    },
	    isTestSchool: function isTestSchool() {
	      return window.SCHOOL.country === 'DK';
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      return this.$store.getters.tasksInUserHash;
	    },
	    tasksInHash: function tasksInHash() {
	      return this.$store.getters.tasksInHash;
	    },
	    userCalId: function userCalId() {
	      return this.allUsersInHash[this.activeUserId].user_calendar_id;
	    },
	    allUserTasks: function allUserTasks() {
	      var _this = this;
	
	      return this.tasksInUserHash[this.userCalId] ? this.tasksInUserHash[this.userCalId].map(function (taskId) {
	        return _this.tasksInHash[taskId];
	      }) : [];
	    },
	    getAllUserTasksTask: function getAllUserTasksTask() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'additional_tasks';
	      });
	    },
	    getAllUserTasksPrep: function getAllUserTasksPrep() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'preparation';
	      });
	    },
	    getAllUserTasksClub: function getAllUserTasksClub() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'club';
	      });
	    },
	    getAllUserTasksTeaching: function getAllUserTasksTeaching() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'person_resource' || task.subject_type === 'person_resource_visible' || task.subject_type === 'subject';
	      });
	    },
	    getAllUserSubjectsAndTeachingTasks: function getAllUserSubjectsAndTeachingTasks() {
	      var _this2 = this;
	
	      var calId = this.userCalId;
	      var subjects = this.subjectsInUserHash[calId] ? this.subjectsInUserHash[calId].map(function (subjectId) {
	        return _this2.subjectsInHash[subjectId];
	      }) : [];
	      subjects = subjects.filter(function (subject) {
	        if (_this2.allCalendarsInHash[subject.calendar_id]) {
	          var calendarType = _this2.allCalendarsInHash[subject.calendar_id].type;
	          return calendarType === 'klass' || calendarType === 'merge';
	        } else {
	          console.log('error::calendar not found', subject.calendar_id);
	        }
	      });
	      return subjects.concat(this.getAllUserTasksTeaching);
	    }
	  },
	  methods: {
	    getUserAssignedTotalHours: function getUserAssignedTotalHours(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_total_hours ? this.usersAssignedHoursHash[userId].assigned_total_hours : 0;
	    },
	    getPercentageOfTeaching: function getPercentageOfTeaching(userId) {
	      var total = this.getUserAssignedTotalHours(userId);
	      var teaching = this.getUserAssignedTeachingHours(userId);
	      var percentage = teaching / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getUserAssignedTaskHours: function getUserAssignedTaskHours(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_additional_task_hours ? this.usersAssignedHoursHash[userId].assigned_additional_task_hours : 0;
	    },
	    getPercentageOfTasks: function getPercentageOfTasks(userId) {
	      var total = this.getUserAssignedTotalHours(userId);
	      var tasks = this.getUserAssignedTaskHours(userId);
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getUserAssignedPreparationHours: function getUserAssignedPreparationHours(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_preparation_hours ? this.usersAssignedHoursHash[userId].assigned_preparation_hours : 0;
	    },
	    getUserAssignedClubHours: function getUserAssignedClubHours(userId) {
	      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_club_hours ? this.usersAssignedHoursHash[userId].assigned_club_hours : 0;
	    },
	    getPercentageOfPrep: function getPercentageOfPrep(userId) {
	      var total = this.getUserAssignedTotalHours(userId);
	      var tasks = this.getUserAssignedPreparationHours(userId);
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getAllUserSubjects: function getAllUserSubjects(calid) {
	      var _this3 = this;
	
	      var subjects = this.subjectsInUserHash[calid] ? this.subjectsInUserHash[calid] : [];
	      return subjects.sort(function (subjectA, subjectB) {
	        var subjectFromSubjectA = _this3.allCalendarsInHash[_this3.subjectsInHash[subjectB].calendar_id];
	        var subjectFromSubjectB = _this3.allCalendarsInHash[_this3.subjectsInHash[subjectA].calendar_id];
	        if (subjectFromSubjectA && subjectFromSubjectA.name && subjectFromSubjectB && subjectFromSubjectB.name) {
	          return subjectFromSubjectA.name.localeCompare(subjectFromSubjectB.name, undefined, {
	            numeric: true,
	            sensitivity: 'base'
	          });
	        }
	      });
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.$emit('editSubject', editSubject);
	    },
	    setEditTask: function setEditTask(editTask) {
	      if (editTask.hasOwnProperty('can_schedule')) {
	        this.$emit('editTask', editTask);
	      } else {
	        this.$emit('editSubject', editTask);
	      }
	    },
	    setDeleteTask: function setDeleteTask(taskId) {
	      var task = this.tasksInHash[taskId];
	      task['itemType'] = 'task';
	      this.$store.commit('setItemToDelete', task);
	      this.$store.commit('setConfirmDeletion', true);
	    },
	    getUserAssignedTeachingHours: function getUserAssignedTeachingHours(userId) {
	      return this.usersAssignedHoursHash[userId] ? this.usersAssignedHoursHash[userId].assigned_teaching_hours : 0;
	    },
	    getTotalSubjectTeachingHours: function getTotalSubjectTeachingHours(userCalId) {
	      var _this4 = this;
	
	      var subjectsHours = this.subjectsInUserHash[userCalId] ? this.subjectsInUserHash[userCalId].map(function (subjectId) {
	        return _this4.getSubjectHours(subjectId) * 1;
	      }) : [0];
	      var sum = subjectsHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return sum.toFixed(2);
	    },
	    getTotalUserTasksTeachingHours: function getTotalUserTasksTeachingHours(userCalId) {
	      var _this5 = this;
	
	      var tasksHours = this.tasksInUserHash[userCalId] ? this.tasksInUserHash[userCalId].map(function (taskId) {
	        return _this5.tasksInHash[taskId].timeTeaching * 1;
	      }) : [0];
	      return tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      }).toFixed(2);
	    },
	    getTotalUserHoursTeachingCount: function getTotalUserHoursTeachingCount(userCalId) {
	      var sum = this.getTotalSubjectTeachingHours(userCalId) * 1 + this.getTotalUserTasksTeachingHours(userCalId) * 1;
	      return sum.toFixed(2);
	    },
	    getUserTeachingHoursDiff: function getUserTeachingHoursDiff(userId) {
	      var diff = this.getUserAssignedTeachingHours(userId) - this.getTotalUserHoursTeachingCount(this.allUsersInHash[userId].user_calendar_id);
	      return diff.toFixed(1);
	    },
	    getTotalUserTasksHours: function getTotalUserTasksHours(userCalId) {
	      var _this6 = this;
	
	      var tasksHours = this.tasksInUserHash[userCalId] ? this.tasksInUserHash[userCalId].map(function (taskId) {
	        return _this6.tasksInHash[taskId].hours * 1;
	      }) : [0];
	      var sum = tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return sum.toFixed(1);
	    },
	    setActiveSubject: function setActiveSubject(subject) {
	      this.theActiveSubject = subject;
	    },
	    getSubjectHours: function getSubjectHours(subjectId) {
	      var _this7 = this;
	
	      var theSubject = this.subjectsInHash[subjectId];
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this7.activeUserId;
	      }) : -1;
	      if (idx > -1) {
	        return theSubject.teachers[idx].hours;
	      } else {
	        return theSubject.hours;
	      }
	    },
	    getIsHoursModified: function getIsHoursModified(subjectId) {
	      var _this8 = this;
	
	      var theSubject = this.subjectsInHash[subjectId];
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this8.activeUserId;
	      }) : -1;
	      return idx > -1;
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.USER.language;
	  }
	};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppEIPWYZIWYG = __webpack_require__(45);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppEIPWYZIWYG: _AppEIPWYZIWYG2.default },
	  props: {
	    userId: {
	      type: Number,
	      required: true
	    },
	    userAgreements: {
	      default: '',
	      required: false
	    },
	    isReadAgreements: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      agreements: '',
	      locale: 'da',
	      i18n: {
	        da: {
	          notes_for: 'Noter til'
	        },
	        nb: {
	          notes_for: 'Noter til'
	        },
	        en: {
	          notes_for: 'Notes for'
	        }
	      }
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    userCanEditAgreementNote: function userCanEditAgreementNote() {
	      return this.userHasPermission('can_edit_user_year_notes');
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      this.readAgreements();
	    },
	    userAgreements: function userAgreements(val) {
	      this.agreements = val;
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    readAgreements: function readAgreements() {
	      var _this = this;
	
	      if (!this.isReadAgreements) {
	        return;
	      }
	      _docendo2.default.schoolUserYearRead(window.SCHOOL.id, this.userId, this.activeSchoolYear.name, function (success) {
	        _this.agreements = success.agreements;
	      }, function (failure) {
	        console.log('failed!');
	      });
	    },
	    updateAgreements: function updateAgreements(updatedText) {
	      var _this2 = this;
	
	      _docendo2.default.schoolUserYearUpdate(window.SCHOOL.id, this.userId, this.activeSchoolYear.name, { 'agreements': updatedText.text }, function (success) {
	        _this2.agreements = success.agreements;
	      }, function (failure) {
	        console.log('failed!');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.USER.language;
	  },
	  mounted: function mounted() {
	    this.agreements = this.userAgreements;
	    this.readAgreements();
	  }
	};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    subject: {},
	    teacher: {}
	  },
	  data: function data() {
	    return {
	      hours: 0,
	      i18n: {
	        da: {
	          add_new_hours_for: 'Indtast nyt timetal for',
	          has: 'har',
	          hours_in_school_year: 'Klokketimer i skoleåret',
	          cancel: 'Annullér',
	          update: 'Opdatér'
	        },
	        en: {
	          add_new_hours_for: 'Enter new number of hours for',
	          has: 'has',
	          hours_in_school_year: 'hours in schoolyear',
	          cancel: 'Cancel',
	          update: 'Update'
	        },
	        nb: {
	          add_new_hours_for: 'Angi nytt antall timer for',
	          has: 'har',
	          hours_in_school_year: 'timer i skoleåret',
	          cancel: 'Avbryt',
	          update: 'Oppdater'
	        }
	      },
	      locale: 'da'
	    };
	  },
	
	  computed: {
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    getAllKlasses: function getAllKlasses() {
	      return this.allCalendarsInHash[this.subject.calendar_id].name;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    }
	  },
	  methods: {
	    selectAll: function selectAll(event) {
	      setTimeout(function () {
	        event.target.select();
	      }, 0);
	    },
	    submit: function submit() {
	      var _this = this;
	
	      _docendo2.default.setHoursForTeacherOnSubject(this.subject.id, this.subject.school_id, this.subject.school_year_id, this.teacher.id, this.hours, function (success) {
	        var succesObj = success;
	        succesObj['user_id'] = _this.teacher.id;
	        _this.$store.commit('updateTeacherHoursOnSubject', success);
	      }, function (failure) {
	        console.log('Something went wrong');
	      });
	      this.$emit('close');
	    },
	    getSubjectHours: function getSubjectHours() {
	      var _this2 = this;
	
	      var idx = this.subject.teachers[0] ? this.subject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this2.teacher.id;
	      }) : -1;
	      if (idx > -1) {
	        this.hours = this.subject.teachers[idx].hours;
	      } else {
	        this.hours = this.subject.hours;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.locale = window.USER.language;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.getSubjectHours();
	    setTimeout(function (_) {
	      _this3.$refs.input_hours.focus();
	    }, 500);
	  }
	};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    id: {
	      type: String,
	      default: 'teaching'
	    },
	    user: {
	      type: Object
	    },
	    userCalendarId: {
	      default: 13
	    },
	    title: {
	      type: String,
	      default: 'Øvrige opgaver'
	    },
	    hoursTitle: {
	      type: String,
	      default: 'Timer'
	    },
	    tasks: {
	      default: function _default() {
	        return [];
	      }
	    },
	    assignedHours: {
	      default: '0.0'
	    },
	    isTeaching: {
	      type: Boolean,
	      default: false
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          no_subjects_assigned: 'Ingen opgaver tildelt',
	          assigned: 'Tildelt',
	          difference: 'Diff',
	          time: 'Timer'
	        },
	        en: {
	          no_subjects_assigned: 'No subjects allocated',
	          assigned: 'Allocated',
	          from_subjects: 'From subjects',
	          difference: 'Diff',
	          time: 'Hours'
	        },
	        nb: {
	          no_subjects_assigned: 'Ingen fag tildelt',
	          assigned: 'Tildelt',
	          from_subjects: 'Fra fag',
	          difference: 'Diff',
	          time: 'Timer'
	        }
	      }
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    sortedTasks: function sortedTasks() {
	      return this.tasks.sort(function (subjectA, subjectB) {
	        return subjectA.name.localeCompare(subjectB.name, undefined, {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    sumOfHours: function sumOfHours() {
	      var _this = this;
	
	      var tasksHours = [0];
	      if (this.tasks.length > 0) {
	        tasksHours = this.tasks.map(function (task) {
	          if (_this.subjectsInHash[task.id]) {
	            return _this.getSubjectHours(task.id) * 1;
	          } else {
	            return task.hours * 1;
	          }
	        });
	      }
	      return tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      }).toFixed(1);
	    },
	    sumOfHoursWithSubject: function sumOfHoursWithSubject() {
	      var _this2 = this;
	
	      var tasksHours = [0];
	      if (this.tasks.length > 0) {
	        tasksHours = this.tasks.map(function (task) {
	          if (_this2.subjectsInHash[task.id]) {
	            return _this2.getSubjectHours(task.id) * 1;
	          } else {
	            if (task.can_schedule) {
	              return task.hours * 1;
	            } else {
	              return 0;
	            }
	          }
	        });
	      }
	      return tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      }).toFixed(1);
	    },
	    sumOfHoursWithoutSubject: function sumOfHoursWithoutSubject() {
	      var _this3 = this;
	
	      var tasksHours = [0];
	      if (this.tasks.length > 0) {
	        tasksHours = this.tasks.map(function (task) {
	          if (_this3.subjectsInHash[task.id]) {
	            return 0;
	          } else {
	            if (!task.can_schedule) {
	              return task.hours * 1;
	            } else {
	              return 0;
	            }
	          }
	        });
	      }
	      return tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      }).toFixed(1);
	    },
	    getDiff: function getDiff() {
	      return (this.assignedHours - this.sumOfHours).toFixed(1);
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    tasksWithoutSubject: function tasksWithoutSubject() {
	      return this.tasks.filter(function (task) {
	        return task.hasOwnProperty('can_schedule') && !task.can_schedule;
	      });
	    },
	    userTableAcc: function userTableAcc() {
	      return this.$store.state.subjects.userTableAcc;
	    },
	    isOpen: function isOpen() {
	      return this.userTableAcc[this.id];
	    }
	  },
	  methods: {
	    setIsOpen: function setIsOpen() {
	      var current = this.userTableAcc[this.id];
	      var obj = {
	        title: this.id,
	        boolean: current ? !current : true
	      };
	      return this.$store.commit('setUserTableAcc', obj);
	    },
	    setEditTask: function setEditTask(task) {
	      this.$emit('edit', task);
	    },
	    setDeleteTask: function setDeleteTask(task) {
	      this.$emit('delete', task);
	    },
	    calsToString: function calsToString(cals) {
	      if (!cals || !cals.length) return '';
	      var names = cals.slice(0, 2).map(function (cal) {
	        return cal.name;
	      });
	      return cals.length > 2 ? names.join(', ') + ' ...' : names.join(', ');
	    },
	    getShowCalendarIfNotOwn: function getShowCalendarIfNotOwn(task) {
	      var _this4 = this;
	
	      var isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId;
	      if (isInOwnCalendar) {
	        return null;
	      }
	      if (task.cals) {
	        var klasses = task.cals.filter(function (cal) {
	          return cal.calendar_type === 'klass';
	        });
	        if (klasses && klasses.length > 0) {
	          return this.calsToString(klasses);
	        }
	      }
	      if (task.belongs_to_calendars) {
	        return task.belongs_to_calendars.filter(function (calId) {
	          return _this4.allCalendarsInHash[calId];
	        }).map(function (calId) {
	          return _this4.allCalendarsInHash[calId]['name'];
	        }).join(',');
	      }
	      return this.allCalendarsInHash[task.calendar_id] ? this.allCalendarsInHash[task.calendar_id]['name'] : [];
	    },
	    getSubjectHours: function getSubjectHours(subjectId) {
	      var _this5 = this;
	
	      var theSubject = this.subjectsInHash[subjectId];
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this5.user.id;
	      }) : -1;
	      if (idx > -1) {
	        return theSubject.teachers[idx].hours;
	      } else {
	        return theSubject.hours;
	      }
	    },
	    setActiveSubject: function setActiveSubject(subjectId) {
	      this.$emit('setActiveSubject', subjectId);
	    }
	  }
	};

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	exports.default = {
	  props: {
	    lesson: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      numberOfTeachersToShow: 3,
	      isShowAllTeachers: false
	    };
	  },
	
	  computed: {
	    numberOfTeachersHidden: function numberOfTeachersHidden() {
	      return this.teachersInKlassSameTime.length - this.numberOfTeachersToShow;
	    },
	    calsAndEventIds: function calsAndEventIds() {
	      return this.$store.state.subs.allCalsWithEventIdsInHash;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    allUsersAndEvents: function allUsersAndEvents() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    lessonThatOverLap: function lessonThatOverLap() {
	      return this.otherLessonsInKlassThatOverlap(this.lesson);
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    lessons: function lessons() {
	      return this.lessonThatOverLap.map(function (lesson) {
	        return (0, _extends3.default)({}, lesson, {
	          v_title: lesson.title + ', ' + moment(lesson.start).format('LT') + '-' + moment(lesson.end).format('LT')
	        });
	      });
	    },
	    teachersInKlassSameTime: function teachersInKlassSameTime() {
	      var _this = this;
	
	      var users = [];
	      this.lessons.forEach(function (lesson) {
	        var usersOnLesson = lesson.calendar_events.filter(function (cal) {
	          return cal.calendar_type === 'user';
	        });
	        usersOnLesson.forEach(function (userCalEvent) {
	          var user = _this.allUsersAndEvents[userCalEvent.calendar_id];
	          user['v_overlapping_absence'] = user.dayAbsence.length > 0 ? _this.absenceOverlapLesson(lesson.id, user.dayAbsence) : [];
	          user['v_is_substitute'] = userCalEvent['substitute'];
	          var obj = {
	            lesson: lesson,
	            user: user
	          };
	          users.push(obj);
	        });
	      });
	      return users;
	    }
	  },
	  methods: {
	    otherLessonsInKlassThatOverlap: function otherLessonsInKlassThatOverlap(lesson) {
	      var _this2 = this;
	
	      var klassCals = lesson.calendar_events.filter(function (cal) {
	        return cal.calendar_type === 'klass';
	      });
	
	      var klassCalEventsIDs = klassCals.map(function (cal) {
	        return _this2.calsAndEventIds[cal.calendar_id];
	      });
	      var allEventsInKlass = klassCalEventsIDs.map(function (obj) {
	        return obj.lessons;
	      });
	      var lessonsInKlass = allEventsInKlass[0] ? allEventsInKlass[0].map(function (id) {
	        return _this2.allEventsInAHash[id];
	      }) : [];
	
	      var overlappingEvents = [];
	      lessonsInKlass.forEach(function (event) {
	        var range1 = moment.range(lesson.start, lesson.end);
	        var range2 = moment.range(event.start, event.end);
	
	        if (event.id !== lesson.id && range1.overlaps(range2)) {
	          overlappingEvents.push(event);
	        }
	      });
	      return overlappingEvents;
	    },
	    absenceOverlapLesson: function absenceOverlapLesson(lessonId, absenceIds) {
	      var _this3 = this;
	
	      var absenceOverlapping = [];
	      var absenceEvents = absenceIds.map(function (eventId) {
	        return _this3.allEventsInAHash[eventId];
	      });
	      var lessonEvent = this.allEventsInAHash[lessonId];
	      absenceEvents.forEach(function (absenceEvent) {
	        var range1 = moment.range(absenceEvent.start, absenceEvent.end);
	        var range2 = moment.range(lessonEvent.start, lessonEvent.end);
	        if (range1.intersect(range2)) {
	          var absentLessonReadable = absenceEvent.title + ' ' + moment(absenceEvent.start).format('LT') + '-' + moment(absenceEvent.end).format('LT');
	          absenceOverlapping.push(absentLessonReadable);
	        }
	      });
	      return absenceOverlapping;
	    }
	  }
	};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DSelectCals = __webpack_require__(51);
	
	var _DSelectCals2 = _interopRequireDefault(_DSelectCals);
	
	var _vuex = __webpack_require__(13);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _OutOfSchoolSubject = __webpack_require__(1345);
	
	var _OutOfSchoolSubject2 = _interopRequireDefault(_OutOfSchoolSubject);
	
	var _OutOfSchoolAbsence = __webpack_require__(1344);
	
	var _OutOfSchoolAbsence2 = _interopRequireDefault(_OutOfSchoolAbsence);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { OutOfSchoolAbsence: _OutOfSchoolAbsence2.default, OutOfSchoolSubject: _OutOfSchoolSubject2.default, DatepickerRange: _DatePickerRange2.default, TimeChanger: _TimeChanger2.default, DSelectCals: _DSelectCals2.default, DModal: _DModal2.default },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      selectedKlasses: [],
	      selectedSubject: null,
	      selectedUsers: [],
	      selectedAbsence: null,
	      events: [],
	      isSubmitting: false,
	      isKlassEventCreated: false,
	      isUserAbsenceCreated: false,
	      isAllUserEventsCreated: false,
	      activeSchoolId: null,
	      isMultipleSchoolsActive: false,
	      isLoadingSchoolCalendars: false,
	      schoolCalendars: [],
	      schoolYears: [],
	      isLoadingSchoolYears: false,
	      availableCalendarId: null,
	      availableSubjectId: null,
	      isAllEventsUpdated: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userCalendars', 'schoolId']), {
	    activeSchoolYear: function activeSchoolYear() {
	      var _this = this;
	
	      return this.schoolYears.find(function (year) {
	        return (0, _moment2.default)(_this.startDate).isBetween(year.student_time_start, year.student_time_end, null, '[]');
	      });
	    },
	    klassCalendars: function klassCalendars() {
	      var activeSchoolYearId = this.activeSchoolYear ? this.activeSchoolYear.id : null;
	      return this.schoolCalendars.filter(function (calendar) {
	        return calendar.type === 'klass' && calendar.school_year_id === activeSchoolYearId;
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSchools: function userSchools() {
	      return this.user && this.user.schools ? this.user.schools : [];
	    },
	    userSchoolsSorted: function userSchoolsSorted() {
	      return this.userSchools.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    isValidated: function isValidated() {
	      return this.selectedKlasses.length > 0 && this.selectedSubject && (this.selectedUsers.length === 0 || this.selectedAbsence);
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  }),
	  methods: {
	    onChangeActiveSchoolId: function onChangeActiveSchoolId() {
	      this.readSchoolCalendars();
	      this.readSchoolYears();
	      this.$nextTick(function (_) {
	        console.log(document.getElementById('app'));
	      });
	    },
	    readSchoolCalendars: function readSchoolCalendars() {
	      var _this2 = this;
	
	      this.isLoadingSchoolCalendars = true;
	      _docendo2.default.calendarsForSchool(this.activeSchoolId, function (data) {
	        _this2.schoolCalendars = data;
	        _this2.isLoadingSchoolCalendars = false;
	      });
	    },
	    readSchoolYears: function readSchoolYears() {
	      var _this3 = this;
	
	      this.isLoadingSchoolYears = true;
	      _docendo2.default.schoolYearsRead(this.activeSchoolId, {}, 'name', function (data) {
	        _this3.schoolYears = data;
	        _this3.isLoadingSchoolYears = false;
	      });
	    },
	    setSelectedSubject: function setSelectedSubject(subject) {
	      this.selectedSubject = subject;
	    },
	    setStartDate: function setStartDate(payload) {
	      this.startDate = payload;
	    },
	    setEndDate: function setEndDate(payload) {
	      this.endDate = payload;
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    setSelectedKlasses: function setSelectedKlasses(val) {
	      this.selectedKlasses = val;
	      this.setSelectedSubject(null);
	    },
	    setSelectedUsers: function setSelectedUsers(val) {
	      this.selectedUsers = val;
	    },
	    setSelectedAbsence: function setSelectedAbsence(absence) {
	      this.selectedAbsence = absence;
	    },
	    submit: function submit() {
	      var _this4 = this;
	
	      this.isSubmitting = true;
	
	      this.isKlassEventCreated = false;
	      this.isUserAbsenceCreated = false;
	      this.isAllUserEventsCreated = false;
	      this.isAllEventsUpdated = false;
	
	      this.readKlassEvents(function () {
	        if (_this4.isKlassEventCreated) {
	          _this4.createAbsence(function () {
	            if (_this4.isUserAbsenceCreated) {
	              _this4.createMainEvent(function () {
	                if (_this4.isAllUserEventsCreated) {
	                  _this4.updateEvents(function () {
	                    if (_this4.isAllEventsUpdated) {
	                      _this4.isSubmitting = false;
	                      _this4.showToast(_this4.$t('vue2.create_activity.created'), true);
	                      _this4.$emit('onCreatedEvents');
	                      _this4.$emit('close');
	                    }
	                  });
	                }
	              });
	            }
	          });
	        }
	      });
	    },
	    readKlassEvents: function readKlassEvents(callback) {
	      var _this5 = this;
	
	      var calendarIds = this.selectedKlasses.map(function (calendar) {
	        return calendar.id;
	      });
	      _docendo2.default.calendarEvents2(calendarIds, this.dbEventStart, this.dbEventEnd, null, function (success) {
	        _this5.events = success && success.length > 0 ? JSON.parse(success) : [];
	        _this5.isKlassEventCreated = true;
	        _this5.findEventsWithUsersNotParticipating();
	
	        callback();
	      }, function (failure) {
	        _this5.showToast('Error fetching class events', false);
	        _this5.isSubmitting = false;
	      });
	    },
	    createAbsence: function createAbsence(callback) {
	      var _this6 = this;
	
	      var schoolId = this.selectedSubject.school_id;
	      var absenceStart = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var absenceEnd = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	
	      var completedCount = 0;
	      var totalUsers = this.selectedUsers.length;
	      if (totalUsers === 0) {
	        this.isUserAbsenceCreated = true;
	        callback();
	        return;
	      }
	      this.selectedUsers.forEach(function (userCalendar) {
	        var userCalendarId = userCalendar.id;
	        _docendo2.default.schoolEventSerialsCreate(schoolId, userCalendarId, _this6.selectedAbsence.id, absenceStart, absenceEnd, _this6.startTime.toISOString(), _this6.endTime.toISOString(), false, '', function (data) {
	          completedCount++;
	          if (completedCount === totalUsers) {
	            _this6.isUserAbsenceCreated = true;
	            callback();
	          }
	        }, function (failure) {
	          _this6.showToast('Error creating absence', false);
	          _this6.isSubmitting = false;
	        });
	      });
	    },
	    createMainEvent: function createMainEvent(callback) {
	      var _this7 = this;
	
	      var schoolId = this.selectedSubject.school_id;
	      var calendarId = this.selectedSubject.calendar_id;
	      var calendarIds = [this.selectedSubject.calendar_id].concat((0, _toConsumableArray3.default)(this.selectedUsers.map(function (calendar) {
	        return calendar.id;
	      })));
	      var subjectId = this.selectedSubject.id;
	      var internalNote = '';
	
	      _docendo2.default.createEvent(schoolId, calendarId, calendarIds, subjectId, this.dbEventStart, this.dbEventEnd, '', '', '', internalNote, function (data) {
	        if (data && data.status === 'error') {
	          _this7.showToast(data.message, false);
	          _this7.$emit('close');
	          return;
	        }
	        _this7.isAllUserEventsCreated = true;
	        callback();
	      }, function (failure) {
	        _this7.showToast('Something went wrong', false);
	      });
	    },
	    findEventsWithUsersNotParticipating: function findEventsWithUsersNotParticipating() {
	      var participatingCalendarIds = this.selectedUsers.map(function (calendar) {
	        return calendar.id;
	      });
	
	      var eventsWithUsersNotParticipating = this.events.filter(function (event) {
	        return event.calendars.some(function (calendarEvent) {
	          return calendarEvent.calendar_type === 'user' && !participatingCalendarIds.includes(calendarEvent.calendar_id);
	        });
	      });
	      this.createAvailableEventsOnEachUserNotParticipating(eventsWithUsersNotParticipating);
	    },
	    createAvailableEventsOnEachUserNotParticipating: function createAvailableEventsOnEachUserNotParticipating(events) {
	      var _this8 = this;
	
	      var participatingCalendarIds = this.selectedUsers.map(function (calendar) {
	        return calendar.id;
	      });
	
	      events.forEach(function (event) {
	        event.calendars.forEach(function (calendarEvent) {
	          if (calendarEvent.calendar_type === 'user' && !participatingCalendarIds.includes(calendarEvent.calendar_id)) {
	            var schoolId = _this8.schoolId;
	            var calendarId = _this8.availableCalendarId;
	            var subjectId = _this8.availableSubjectId;
	            var calendarIds = [_this8.availableCalendarId, calendarEvent.calendar_id];
	            var eventStart = event.start;
	            var eventEnd = event.end;
	            _this8.createEvent(schoolId, calendarId, calendarIds, subjectId, eventStart, eventEnd);
	          }
	        });
	      });
	    },
	    createEvent: function createEvent(schoolId, calendarId, calendarIds, subjectId, eventStart, eventEnd, callback) {
	      var _this9 = this;
	
	      _docendo2.default.createEvent(schoolId, calendarId, calendarIds, subjectId, eventStart, eventEnd, '', '', '', '', function (data) {
	        if (data && data.status === 'error') {
	          _this9.showToast(data.message, false);
	          return;
	        }
	        callback && callback();
	      }, function (failure) {
	        _this9.showToast('Something went wrong', false);
	      });
	    },
	    updateEvents: function updateEvents(callback) {
	      var _this10 = this;
	
	      var eventsToUpdate = this.events.map(function (lesson) {
	        var userCalendarIds = lesson.calendars.filter(function (calEvent) {
	          return calEvent.calendar_type === 'user';
	        }).map(function (calEvent) {
	          return calEvent.calendar_id;
	        });
	
	        var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	
	        userCalendarIds.forEach(function (calId) {
	          statusData[calId] = { status: 1 };
	        });
	
	        return {
	          school_id: lesson.school_id,
	          event_id: lesson.event_id,
	          substitution_status: (0, _stringify2.default)(statusData)
	        };
	      });
	
	      var groupedEvents = eventsToUpdate.reduce(function (groups, event) {
	        if (!groups[event.school_id]) {
	          groups[event.school_id] = [];
	        }
	        groups[event.school_id].push(event);
	        return groups;
	      }, {});
	
	      var schoolIds = (0, _keys2.default)(groupedEvents);
	      var completedUpdates = 0;
	
	      schoolIds.forEach(function (schoolId) {
	        _docendo2.default.updateEvents(schoolId, groupedEvents[schoolId], function () {
	          completedUpdates++;
	          if (completedUpdates === schoolIds.length) {
	            _this10.isAllEventsUpdated = true;
	            callback && callback();
	          }
	        });
	      });
	    },
	    showToast: function showToast(message, success) {
	      _eventbus2.default.toast = { text: message, success: success };
	    }
	  },
	  beforeMount: function beforeMount() {
	    var schoolConfig = {
	      7272: {
	        activeSchoolId: 7272,
	        availableCalendarId: 394554,
	        availableSubjectId: 1009095,
	        isMultipleSchoolsActive: true,
	        callOnChange: true
	      },
	      60494: {
	        isMultipleSchoolsActive: true,
	        availableCalendarId: 394635,
	        availableSubjectId: 1009370,
	        callOnChange: false
	      },
	      60598: {
	        activeSchoolId: 60598,
	        availableCalendarId: 394721,
	        availableSubjectId: 1009904,
	        isMultipleSchoolsActive: false,
	        callOnChange: true
	      },
	      60032: {
	        activeSchoolId: 60032,
	        availableCalendarId: 401122,
	        availableSubjectId: 1032466,
	        isMultipleSchoolsActive: false,
	        callOnChange: true
	      },
	      36305: {
	        activeSchoolId: 36305,
	        availableCalendarId: 401122,
	        availableSubjectId: 1056241,
	        isMultipleSchoolsActive: false,
	        callOnChange: true
	      },
	      36203: {
	        activeSchoolId: 36203,
	        availableCalendarId: 409125,
	        availableSubjectId: 1056243,
	        isMultipleSchoolsActive: false,
	        callOnChange: true
	      },
	      61476: {
	        activeSchoolId: 61476,
	        availableCalendarId: 412237,
	        availableSubjectId: 1069030,
	        isMultipleSchoolsActive: false,
	        callOnChange: true
	      },
	      62676: {
	        activeSchoolId: 62676,
	        availableCalendarId: 432097,
	        availableSubjectId: 1161807,
	        isMultipleSchoolsActive: false,
	        callOnChange: true
	      }
	    };
	
	    var config = schoolConfig[this.schoolId];
	    if (config) {
	      if (config.activeSchoolId) {
	        this.activeSchoolId = config.activeSchoolId;
	      }
	
	      this.availableCalendarId = config.availableCalendarId;
	      this.availableSubjectId = config.availableSubjectId;
	      this.isMultipleSchoolsActive = config.isMultipleSchoolsActive || false;
	
	      if (config.callOnChange) {
	        this.onChangeActiveSchoolId();
	      }
	    }
	  }
	};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _AbsenceReasonsCreate = __webpack_require__(112);
	
	var _AbsenceReasonsCreate2 = _interopRequireDefault(_AbsenceReasonsCreate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AbsenceReasonsCreate: _AbsenceReasonsCreate2.default, dSelect: _DSelect2.default },
	  props: {
	    calendarId: {
	      default: function _default() {
	        return 309496;
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    selectedSubject: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingSubjects: false,
	      subjects: [],
	      isSubmitting: false,
	      theSearchText: '',
	      theNewSubject: null,
	      isShowCreateSubjectButton: false,
	      theNewlyCreatedSubject: null,
	      isCreateAbsenceReason: false
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    filteredSubjects: function filteredSubjects() {
	      return this.subjects;
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this = this;
	
	      return this.filteredSubjects.map(function (subject) {
	        var translatedSubjectType = _this.$t('vue2.eventTypes.' + subject.subject_type);
	
	        var vSubjectType = translatedSubjectType === 'vue2.eventTypes.' + subject.subject_type ? subject.subject_type : translatedSubjectType;
	
	        return (0, _extends3.default)({}, subject, {
	          vSubjectType: vSubjectType
	        });
	      }).sort(function (a, b) {
	        if (a.name < b.name) return -1;
	        if (a.name > b.name) return 1;
	        return 0;
	      });
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    }
	  },
	  watch: {
	    calendarId: function calendarId(val) {
	      this.readSubjects();
	    },
	    theNewlyCreatedSubject: function theNewlyCreatedSubject(val) {
	      this.readSubjects();
	    }
	  },
	  methods: {
	    setDate: function setDate(date) {
	      this.$emit('setDate', date);
	    },
	    onCloseDSelect: function onCloseDSelect() {
	      this.isShowCreateSubjectButton = false;
	    },
	    setIsShowCreateSubjectButton: function setIsShowCreateSubjectButton() {
	      var _this2 = this;
	
	      var idx = this.filteredSubjects.findIndex(function (subject) {
	        return subject.name === _this2.theSearchText;
	      });
	      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateSubjectButton();
	    },
	    createAbsenceReason: function createAbsenceReason(titleAndDefaultPrivate) {
	      var _this3 = this;
	
	      var title = titleAndDefaultPrivate.title;
	      var defaultPrivate = titleAndDefaultPrivate.defaultPrivate;
	      _docendo2.default.schoolAbsenceSubjectsCreate(this.schoolId, title, '#564437', defaultPrivate, function (data) {
	        _this3.$store.commit('subsAddNewAbsenceReason', data);
	        _this3.isCreatingNewSubject = false;
	        _this3.theNewlyCreatedSubject = data;
	        _this3.theSearchText = '';
	        _this3.readSubjects();
	        _this3.isCreateAbsenceReason = false;
	      }, function (failure) {
	        console.log('Failed', failure);
	      });
	      this.$emit('createNewSubject', this.theSearchText);
	      this.theSearchText = '';
	    },
	    setTheSearchText: function setTheSearchText(str) {
	      this.theSearchText = str;
	    },
	    setSubject: function setSubject(arr) {
	      this.$emit('setSubject', arr[0]);
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    readSubjects: function readSubjects() {
	      var _this4 = this;
	
	      this.isLoadingSubjects = true;
	      _docendo2.default.schoolAbsenceSubjectsList(this.schoolId, false, function (success) {
	        _this4.isLoadingSubjects = false;
	        _this4.subjects = success;
	        _this4.$nextTick(function (_) {
	          if (_this4.theNewlyCreatedSubject) {
	            _this4.theNewSubject = _this4.theNewlyCreatedSubject;
	          }
	        });
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	    setTimeout(function (_) {
	      var el = document.querySelector('#d-create-task-for-user .d-select__input-look > input[type="search"]');
	      if (el) {
	        el.focus();
	      }
	    }, 400);
	  }
	};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { dSelect: _DSelect2.default },
	  props: {
	    calendarId: {
	      default: function _default() {
	        return 309496;
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    selectedSubject: {
	      default: null
	    },
	    schoolId: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingSubjects: false,
	      subjects: [],
	      isSubmitting: false,
	      theSearchText: '',
	      theNewSubject: null,
	      isShowCreateSubjectButton: false,
	      isCreatingNewSubject: false,
	      subjectType: 'frame',
	      theNewlyCreatedSubject: null
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.activeSchoolYears;
	    },
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    filteredSubjects: function filteredSubjects() {
	      var _this = this;
	
	      return this.subjects.filter(function (subject) {
	        return subject.subject_type === _this.subjectType;
	      });
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this2 = this;
	
	      return this.filteredSubjects.map(function (subject) {
	        var translatedSubjectType = _this2.$t('vue2.eventTypes.' + subject.subject_type);
	
	        var vSubjectType = translatedSubjectType === 'vue2.eventTypes.' + subject.subject_type ? subject.subject_type : translatedSubjectType;
	
	        return (0, _extends3.default)({}, subject, {
	          vSubjectType: vSubjectType
	        });
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    }
	  },
	  watch: {
	    calendarId: function calendarId(val) {
	      this.readSubjects();
	    }
	  },
	  methods: {
	    onCloseDSelect: function onCloseDSelect() {
	      this.isShowCreateSubjectButton = false;
	    },
	    setIsShowCreateSubjectButton: function setIsShowCreateSubjectButton() {
	      var _this3 = this;
	
	      var idx = this.filteredSubjects.findIndex(function (subject) {
	        return subject.name === _this3.theSearchText;
	      });
	      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateSubjectButton();
	    },
	    findSchoolYearId: function findSchoolYearId() {
	      if (this.activeSchoolYears.length === 1) {
	        return this.activeSchoolYears[0].id;
	      }
	      var givenDate = (0, _moment2.default)(this.date);
	
	      var overlappingSchoolYears = this.activeSchoolYears.filter(function (year) {
	        var start = (0, _moment2.default)(year.employee_time_start);
	        var end = (0, _moment2.default)(year.employee_time_end);
	        return givenDate.isBetween(start, end, undefined, '[]');
	      });
	
	      if (overlappingSchoolYears.length > 0) {
	        var latestSchoolYear = overlappingSchoolYears.reduce(function (latest, current) {
	          var latestEnd = (0, _moment2.default)(latest.employee_time_end);
	          var currentEnd = (0, _moment2.default)(current.employee_time_end);
	          return currentEnd.isAfter(latestEnd) ? current : latest;
	        }, overlappingSchoolYears[0]);
	
	        return latestSchoolYear.id;
	      } else {
	        _eventbus2.default.toast = {
	          text: this.$t('vue2.create_activity.the_selected_date_is_outside_schoolyears'),
	          'success': false
	        };
	        return null;
	      }
	    },
	    onCreateNewSubject: function onCreateNewSubject() {
	      var _this4 = this;
	
	      var calendarId = this.calendarId;
	      var schoolYearId = this.findSchoolYearId();
	      if (!schoolYearId) {
	        return;
	      }
	      var schoolId = this.schoolId;
	      var color = '#999999';
	      var duration = 300;
	      var preparation = null;
	      var calendarIds = [];
	      var subjectCode = null;
	      this.isCreatingNewSubject = true;
	      _docendo2.default.createSubject(this.theSearchText, color, calendarId, duration, preparation, 0, this.subjectType, schoolId, schoolYearId, calendarIds, subjectCode, false, function (data) {
	        if (data && data.status === 'error') {
	          _eventbus2.default.toast = { text: data.message, 'success': false };
	          return;
	        }
	        _this4.isCreatingNewSubject = false;
	        _this4.theNewlyCreatedSubject = data;
	        _this4.theSearchText = '';
	        _this4.readSubjects();
	      }, function (failure) {
	        console.log('failed');
	      });
	    },
	    setTheSearchText: function setTheSearchText(str) {
	      this.theSearchText = str;
	    },
	    setSubject: function setSubject(arr) {
	      this.$emit('setSubject', arr[0]);
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    readSubjects: function readSubjects() {
	      var _this5 = this;
	
	      this.isLoadingSubjects = true;
	      _docendo2.default.sidebar(this.calendarId, this.date, function (success) {
	        _this5.isLoadingSubjects = false;
	        _this5.subjects = success;
	        _this5.$nextTick(function (_) {
	          if (_this5.theNewlyCreatedSubject) {
	            _this5.theNewSubject = _this5.theNewlyCreatedSubject;
	          }
	        });
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readSubjects();
	    setTimeout(function (_) {
	      var el = document.querySelector('#d-create-task-for-user .d-select__input-look > input[type="search"]');
	      if (el) {
	        el.focus();
	      }
	    }, 400);
	  }
	};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(35);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	var XLSX = null;
	
	var I18N = {
	  en: {
	    subs_today: 'Substitutes today',
	    today: 'Today',
	    download: 'Download to Excel',
	    no_subs_today: 'No substitutes today',
	    course: 'COURSE',
	    grade: 'GROUP',
	    room: 'ROOM',
	    sub_for: 'SUBSTITUTE FOR',
	    not_on_school: 'Not on school',
	    subs: 'substitutes',
	    sub: 'substitute',
	    absent: 'absent',
	    no_one_absent_today: 'No one absent',
	    no_lessons_effected: 'No lessons are affected by the absence',
	    absence: 'Absence'
	  },
	  da: {
	    subs_today: 'Dagens vikarer',
	    today: 'I dag',
	    no_subs_today: 'Ingen vikarer denne dag',
	    download: 'Download til Excel',
	    course: 'FAG',
	    grade: 'KLASSE',
	    room: 'LOKALE',
	    sub_for: 'VIKAR FOR',
	    not_on_school: 'Ikke på skolen',
	    subs: 'vikarer',
	    sub: 'vikar',
	    absent: 'fraværende',
	    no_one_absent_today: 'Ingen fraværende',
	    no_lessons_effected: 'Ingen lektioner påvirkes af fravær',
	    absence: 'Fravær'
	  },
	  nb: {
	    subs_today: 'Dagens vikarer',
	    today: 'I dag',
	    no_subs_today: 'Ingen vikarer i dag',
	    download: 'Last ned som Excel-fil',
	    course: 'FAG',
	    grade: 'KLASSE',
	    room: 'ROM',
	    sub_for: 'VIKAR FOR',
	    not_on_school: 'Ikke på skolen',
	    subs: 'vikarer',
	    sub: 'vikar',
	    absent: 'fraværende',
	    no_one_absent_today: 'Ingen fraværende',
	    no_lessons_effected: 'Ingen leksjoner påvirkes av fraværet',
	    absence: 'Fravær'
	  }
	};
	exports.default = {
	  components: { Loader: _Loader2.default, DatePicker: _DateSelector2.default },
	  props: {
	    isSubsToday: {
	      type: Boolean,
	      default: true
	    },
	    isPublic: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isDownloading: false,
	      absentToday: [],
	      isLoadingAbsence: false,
	      isSlider: false,
	      theSliderIndex: 0,
	      theSliderInterval: null,
	      theAnimateProgress: 0,
	      theAnimateProgressInterval: null
	    };
	  },
	
	  computed: {
	    schoolUuid: function schoolUuid() {
	      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_uuid;
	    },
	    urlLocale: function urlLocale() {
	      var url = window.location.host;
	      var locale = 'en';
	      if (url.indexOf('.dk') > -1) {
	        locale = 'da';
	      }
	      if (url.indexOf('.no') > -1) {
	        locale = 'nb';
	      }
	      return locale;
	    },
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : this.urlLocale;
	    },
	    isShowRooms: function isShowRooms() {
	      return this.locale === 'en';
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    isLoadingSubs: function isLoadingSubs() {
	      return this.$store.state.subs.dataIsLoading;
	    },
	    isLoading: function isLoading() {
	      return this.isLoadingSubs || this.isLoadingAbsence;
	    },
	    getIsToday: function getIsToday() {
	      moment.locale(this.locale);
	      return moment(this.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');
	    },
	    date: function date() {
	      return moment(this.$store.state.subs.date).format('YYYY-MM-DD');
	    },
	    formattedDayDate: function formattedDayDate() {
	      moment.locale(this.locale);
	      return moment(this.date).format('dddd') + ' ' + moment(this.date).format('LL');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    allKlassCalendarsInAHash: function allKlassCalendarsInAHash() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    allEventsInHash: function allEventsInHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    allUsersAndEvents: function allUsersAndEvents() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    substitutesToday: function substitutesToday() {
	      return this.$store.getters.substitutesToday;
	    },
	    absentFormatted: function absentFormatted() {
	      return this.absentToday.map(function (user) {
	        var userObj = {
	          id: user.user_id,
	          user_calendar_id: user.calendar_id,
	          name: user.name,
	          dayEvents: [],
	          dayAbsence: []
	        };
	        user.events.forEach(function (event) {
	          if (event.event_type === 'absence') {
	            userObj.dayAbsence.push(event);
	          }
	          if (event.event_type !== 'absence' && event.event_type !== 'presence') {
	            userObj.dayEvents.push(event);
	          }
	        });
	        return userObj;
	      });
	    },
	    usersFormatted: function usersFormatted() {
	      var _this = this;
	
	      var usersSelected = this.isSubsToday ? this.substitutesToday : this.absentFormatted;
	      var users = usersSelected.map(function (user) {
	        var eventsArr = _this.isSubsToday ? user.dayEvents.filter(function (event) {
	          return _this.allEventsInHash[event];
	        }).map(function (eventId) {
	          return _this.allEventsInHash[eventId];
	        }) : user.dayEvents;
	        var events = _this.isSubsToday ? eventsArr.filter(function (event) {
	          return _this.isEventAsASubstitute(event, user);
	        }) : eventsArr.filter(function (event) {
	          return _this.doesEventOverLapAbsence(event, user);
	        });
	        var absence = _this.isSubsToday ? user.dayAbsence.filter(function (event) {
	          return _this.allEventsInHash[event];
	        }).map(function (eventId) {
	          return _this.allEventsInHash[eventId];
	        }) : user.dayAbsence;
	        var absenceFormatted = absence.map(function (event) {
	          var eventStart = moment(event.start).format('LT');
	          var eventEnd = moment(event.end).format('LT');
	          var eventFormat = {
	            title: _this.isPublic ? _this.i18n[_this.locale]['absence'] : event.title,
	            startTime: event.start,
	            start: eventStart,
	            end: eventEnd,
	            timeFormatted: eventStart + '-' + eventEnd
	          };
	          return eventFormat;
	        });
	        var eventsFormatted = events.map(function (event) {
	          var eventStart = moment(event.start).format('LT');
	          var eventEnd = moment(event.end).format('LT');
	          var eventFormat = {
	            title: event.title,
	            startTime: event.start,
	            start: eventStart,
	            end: eventEnd,
	            timeFormatted: eventStart + '-' + eventEnd,
	            grades: [],
	            substitute_for: [],
	            substitute: [],
	            rooms: []
	          };
	          event.calendar_events.forEach(function (calEvent) {
	            if (calEvent.calendar_type === 'klass' && calEvent.name) {
	              eventFormat.grades.push(calEvent.name);
	            }
	
	            if (calEvent.calendar_id === user.user_calendar_id && calEvent.substitute_for_user_id) {
	              var subForUserName = _this.allUsersInHash[calEvent.substitute_for_user_id] ? _this.allUsersInHash[calEvent.substitute_for_user_id].name : _this.i18n[_this.locale]['not_on_school'];
	              eventFormat.substitute_for.push(subForUserName);
	            }
	
	            if (calEvent.substitute_for_user_id === user.id) {
	              eventFormat.substitute.push(calEvent.name);
	            }
	
	            if (calEvent.calendar_type === 'room' && calEvent.name) {
	              eventFormat.rooms.push(calEvent.name);
	            }
	          });
	          eventFormat.grades = eventFormat.grades.sort(function (a, b) {
	            if (a && b) {
	              return a.localeCompare(b, undefined, {
	                numeric: true,
	                sensitivity: 'base'
	              });
	            }
	          });
	          if (eventFormat.grades.length < 3) {
	            eventFormat.grades = eventFormat.grades.join(', ');
	          } else {
	            var gradesAsString = eventFormat.grades.filter(function (grade, idx) {
	              return idx < 3;
	            }).join(', ');
	            eventFormat.grades = gradesAsString + '...';
	          }
	          eventFormat.substitute_for = eventFormat.substitute_for.sort(function (a, b) {
	            if (a && b) {
	              return a.localeCompare(b, undefined, {
	                numeric: true,
	                sensitivity: 'base'
	              });
	            }
	          }).join(', ');
	          eventFormat.substitute = eventFormat.substitute.sort(function (a, b) {
	            if (a && b) {
	              return a.localeCompare(b, undefined, {
	                numeric: true,
	                sensitivity: 'base'
	              });
	            }
	          }).join(', ');
	          eventFormat.rooms = eventFormat.rooms.sort(function (a, b) {
	            if (a && b) {
	              return a.localeCompare(b, undefined, {
	                numeric: true,
	                sensitivity: 'base'
	              });
	            }
	          }).join(', ');
	          return eventFormat;
	        });
	        var userObj = {
	          name: user.name ? user.name : _this.allUsersInCalIdHash[user.user_calendar_id] ? _this.allUsersInCalIdHash[user.user_calendar_id].name : '(' + _this.i18n[_this.locale]['not_on_school'] + ')',
	          events: eventsFormatted.sort(function (a, b) {
	            return moment(a.startTime).unix() - moment(b.startTime).unix();
	          }),
	          absence: absenceFormatted.sort(function (a, b) {
	            return moment(a.startTime).unix() - moment(b.startTime).unix();
	          })
	        };
	        return userObj;
	      });
	      return this.$helpers.sortArrOnName(users);
	    },
	    userInRows: function userInRows() {
	      var newArr = [];
	      var arr = JSON.parse((0, _stringify2.default)(this.usersFormatted));
	      while (arr.length) {
	        newArr.push(arr.splice(0, 8));
	      }return newArr;
	    },
	    usersInArraysSlider: function usersInArraysSlider() {
	      return this.userInRows;
	    },
	    dataToExcel: function dataToExcel() {
	      var _this2 = this;
	
	      var dataArr = [{ name: this.i18n[this.locale]['subs_today'] + ', ' + this.formattedDayDate }, { name: '' }];
	      this.usersFormatted.forEach(function (user) {
	        dataArr.push({ name: user.name });
	        dataArr.push({
	          name: _this2.i18n[_this2.locale]['course'],
	          class: _this2.i18n[_this2.locale]['grade'],
	          sub_for: _this2.i18n[_this2.locale]['sub_for'],
	          room: _this2.i18n[_this2.locale]['room']
	        });
	        user.events.forEach(function (event) {
	          dataArr.push({
	            name: event.title + ', ' + event.timeFormatted,
	            class: event.grades,
	            sub_for: event.substitute_for,
	            room: event.rooms
	          });
	        });
	        dataArr.push({ name: '' });
	      });
	      return dataArr;
	    },
	    animatePercentage: function animatePercentage() {
	      return this.theAnimateProgress / 700 * 100 + '%';
	    }
	  },
	  methods: {
	    animateProgress: function animateProgress() {
	      var _this3 = this;
	
	      this.theAnimateProgressInterval = window.setInterval(function (_) {
	        _this3.theAnimateProgress += 1;
	      }, 10);
	    },
	    startSlider: function startSlider() {
	      var _this4 = this;
	
	      this.isSlider = !this.isSlider;
	      clearInterval(this.theSliderInterval);
	      clearInterval(this.theAnimateProgressInterval);
	      if (this.isSlider) {
	        this.animateProgress();
	        this.theSliderInterval = window.setInterval(function (_) {
	          if (_this4.theSliderIndex < _this4.userInRows.length - 1) {
	            _this4.theSliderIndex++;
	          } else {
	            _this4.theSliderIndex = 0;
	          }
	          _this4.theAnimateProgress = 0;
	        }, 7000);
	      } else {
	        this.theSliderIndex = 0;
	      }
	    },
	    isEventAsASubstitute: function isEventAsASubstitute(event, user) {
	      var isSub = false;
	      event.calendar_events.forEach(function (calEvent) {
	        if (calEvent.calendar_id === user.user_calendar_id && calEvent.substitute) {
	          isSub = true;
	        }
	      });
	      return isSub;
	    },
	    doesEventOverLapAbsence: function doesEventOverLapAbsence(event, user) {
	      var overlaps = false;
	      for (var i = 0; i < user.dayAbsence.length; i++) {
	        var absence = user.dayAbsence[i];
	        var range1 = moment.range(absence.start, absence.end);
	        var range2 = moment.range(event.start, event.end);
	        if (range1.overlaps(range2)) {
	          overlaps = true;
	        }
	      }
	      return overlaps;
	    },
	    asyncLoadXLSXAndDownload: function asyncLoadXLSXAndDownload() {
	      var _this5 = this;
	
	      this.isDownloading = true;
	      if (window.XLSX && XLSX) {
	        this.download();
	      } else {
	        var cdnXLSX = document.createElement('script');
	        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js');
	        document.head.appendChild(cdnXLSX);
	        var intervalTimer = setInterval(function (_) {
	          if (window.XLSX) {
	            clearInterval(intervalTimer);
	            XLSX = window.XLSX;
	            _this5.download();
	          }
	        }, 500);
	      }
	    },
	    download: function download() {
	      var data = XLSX.utils.json_to_sheet(this.dataToExcel, { skipHeader: true });
	      var wb = XLSX.utils.book_new();
	      XLSX.utils.book_append_sheet(wb, data, 'data');
	      XLSX.writeFile(wb, 'docendo_subs_today.xlsx');
	      this.isDownloading = false;
	    },
	    setDate: function setDate(date) {
	      this.$store.commit('setSubDate', date);
	      this.getData(date);
	    },
	    prevDay: function prevDay() {
	      var date = moment(this.date).subtract(1, 'days').format('YYYY-MM-DD');
	      this.setDate(date);
	    },
	    nextDay: function nextDay() {
	      var date = moment(this.date).add(1, 'days').format('YYYY-MM-DD');
	      this.setDate(date);
	    },
	    setToday: function setToday() {
	      var date = moment().format('YYYY-MM-DD');
	      this.setDate(date);
	    },
	    print: function print() {
	      window.print();
	    },
	    getData: function getData(date) {
	      if (this.isSubsToday) {
	        this.$store.dispatch('getAllDayEvents');
	      } else {
	        this.getAbsence(date);
	      }
	    },
	    getAbsence: function getAbsence(date) {
	      var _this6 = this;
	
	      this.isLoadingAbsence = true;
	      _docendo2.default.absenceForDate(this.schoolUuid, date, function (success) {
	        _this6.isLoadingAbsence = false;
	        _this6.absentToday = success && success.length > 1 ? JSON.parse(success) : [];
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (window.location.href.indexOf('?kiosk') > -1) {
	      this.startSlider();
	    }
	  },
	  mounted: function mounted() {
	    if (this.isSubsToday) {
	      this.$store.dispatch('getAllUsers');
	      this.$store.dispatch('getAllDayEvents');
	    } else {
	      this.getAbsence(moment());
	    }
	  }
	};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OverviewToday = __webpack_require__(336);
	
	var _OverviewToday2 = _interopRequireDefault(_OverviewToday);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AbsentToday: _OverviewToday2.default },
	  computed: {
	    schoolUuid: function schoolUuid() {
	      return this.$route.params.school_uuid;
	    }
	  },
	  mounted: function mounted() {
	    console.log('this.$route', this.$route);
	  }
	};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(38);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(37);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _SchedulerItem = __webpack_require__(1348);
	
	var _SchedulerItem2 = _interopRequireDefault(_SchedulerItem);
	
	var _SchedulerRulers = __webpack_require__(1351);
	
	var _SchedulerRulers2 = _interopRequireDefault(_SchedulerRulers);
	
	var _SchedulerSubSubstituteHours = __webpack_require__(1353);
	
	var _SchedulerSubSubstituteHours2 = _interopRequireDefault(_SchedulerSubSubstituteHours);
	
	var _SchedulerItemPopover = __webpack_require__(337);
	
	var _SchedulerItemPopover2 = _interopRequireDefault(_SchedulerItemPopover);
	
	var _core = __webpack_require__(18);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    go_to_calendar: 'Se kalender',
	    add_sub_to_multiple_lessons: 'Vikardæk flere lektioner',
	    auto_created: 'Oprettet automatisk',
	    should: 'Skal',
	    be_appointed: 'sætttes på som vikar eller lærer',
	    as_a_substitute: 'Som en vikar',
	    as_a_teacher: 'Som en lærer',
	    create_activity: 'Opret aktivitet'
	  },
	  nb: {
	    go_to_calendar: 'Se kalender',
	    add_sub_to_multiple_lessons: 'Legg til vikar for flere leksjoner',
	    auto_created: 'Løpende lengre fravær',
	    should: 'Bør',
	    be_appointed: 'settes inn som lærer eller vikar',
	    as_a_substitute: 'Som en vikar',
	    as_a_teacher: 'Som en lærer',
	    create_activity: 'Opprett aktivitet'
	  },
	  en: {
	    go_to_calendar: 'Go to calendar',
	    add_sub_to_multiple_lessons: 'Add substitute to multiple lessons',
	    auto_created: 'Autogenerated',
	    should: 'Should',
	    be_appointed: 'be appointed as a substitute teacher or teacher',
	    as_a_substitute: 'As a subtitute teacher',
	    as_a_teacher: 'As a teacher',
	    create_activity: 'Create event'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    ModalConfirmation: _ModalConfirmation2.default,
	    DModal: _DModal2.default,
	    DDropdown: _DDropdown2.default,
	    SchedulerItem: _SchedulerItem2.default,
	    SchedulerRulers: _SchedulerRulers2.default,
	    SchedulerSubsSubstituteHours: _SchedulerSubSubstituteHours2.default,
	    SchedulerPopover: _SchedulerItemPopover2.default,
	    Loader: _Loader2.default
	  },
	  directives: {
	    scroll: {
	      inserted: function inserted(el, binding) {
	        var f = function f(evt) {
	          if (binding.value(evt, el)) {
	            el.removeEventListener('scroll', f);
	          }
	        };
	        el.addEventListener('scroll', f);
	      }
	    }
	  },
	  props: {
	    date: {
	      required: false
	    },
	    items: {},
	    title: {
	      type: String,
	      default: 'Teachers'
	    },
	    subsTitle: {
	      type: String,
	      default: 'Potential Substitutes'
	    },
	    isSortOnName: {
	      type: Boolean,
	      default: true
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    longAbsentListInHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      isLoadingEvent: false,
	      theTeacherOrSubObj: null,
	      isSyncingLeftScroll: false,
	      isSyncingRightScroll: false,
	      isSyncingTopScroll: false,
	      tags: [],
	      rows: {},
	      activeUser: null,
	      activeUserBCR: null,
	      subStatusDropdown: null,
	      theAbsentUserHandledDropdown: null,
	      theUserHandlerLoading: null,
	      theDeleteEvent: null,
	      schedulerMaxHeight: '100vh',
	      isVerticalScrollbar: false
	    };
	  },
	
	  watch: {
	    rows: function rows() {
	      this.$refs.rightDiv.scrollLeft = 480;
	      this.$refs.topDiv.scrollLeft = 480;
	    },
	    date: function date() {
	      this.closePopover();
	    }
	  },
	  filters: {
	    round: function round(num) {
	      return Math.round(num);
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    theSubName: function theSubName() {
	      return this.theTeacherOrSubObj && this.theTeacherOrSubObj.userAsSub && this.theTeacherOrSubObj.userAsSub.name ? this.theTeacherOrSubObj.userAsSub.name : 'the teacher';
	    },
	    dataIsLoading: function dataIsLoading() {
	      return this.$store.state.subs.dataIsLoading;
	    },
	    hoursInLocale: function hoursInLocale() {
	      var hours = [];
	      for (var i = 0; i < 24; i++) {
	        hours.push((0, _moment2.default)().set({ hour: i, minutes: 0, seconds: 0 }));
	      }
	      return hours;
	    },
	    isSubScoreActive: function isSubScoreActive() {
	      return this.$store.state.subs.isSortSubActive;
	    },
	    activeEvent: function activeEvent() {
	      return this.$store.state.subs.schedulerActiveEvent;
	    },
	    schedulerUser: function schedulerUser() {
	      return this.$store.state.subs.activeUser;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    getDate: function getDate() {
	      return this.$store.getters.absentUsersGetDate;
	    },
	    absentUsersHandledHash: function absentUsersHandledHash() {
	      return this.$store.getters.absentUsersHandledHash;
	    },
	    allEvents: function allEvents() {
	      return this.$store.state.subs.allEvents;
	    }
	  },
	  methods: {
	    calculateMaxHeight: function calculateMaxHeight() {
	      if (this.$refs.rightDiv) {
	        var topOffset = this.$refs.rightDiv.getBoundingClientRect().top;
	        this.schedulerMaxHeight = window.innerHeight - topOffset;
	      }
	    },
	    getIsUsersAbsentHandled: function getIsUsersAbsentHandled(user) {
	      return this.absentUsersHandledHash[user.id] ? this.absentUsersHandledHash[user.id] : false;
	    },
	    schedulerUserHandledCls: function schedulerUserHandledCls(item) {
	      if (!this.isSubStatusPendingActive) {
	        return this.getIsUsersAbsentHandled(item) ? 'scheduler__users__user__handled__handler--handled' : null;
	      } else {
	        if (!this.getIsUsersAbsentHandled(item)) {
	          return null;
	        }
	        return this.getIsUsersAbsentHandled(item) && this.getIsUsersAbsentHandled(item) === 2 ? 'scheduler__users__user__handled__handler--pending' : 'scheduler__users__user__handled__handler--handled';
	      }
	    },
	    setDeleteEvent: function setDeleteEvent(lesson) {
	      this.theDeleteEvent = lesson;
	    },
	    deleteTheDeleteEvent: function deleteTheDeleteEvent() {
	      var _this = this;
	
	      _docendo2.default.deleteEvent(this.theDeleteEvent.school_id, this.theDeleteEvent.id, function (success) {
	        var event = JSON.parse(success);
	        event.calendar_events.forEach(function (calEvent) {
	          if (calEvent.calendar_type === 'user') {
	            if (event.away) {
	              _this.$store.commit('removeAbsenceOnAllUsersWithEvents', {
	                cal_id: calEvent.calendar_id,
	                event_id: event.id
	              });
	            } else {
	              _this.$store.commit('removeEventOnAllUsersWithEvents', {
	                cal_id: calEvent.calendar_id,
	                event_id: event.id
	              });
	            }
	          }
	        });
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	      document.querySelector('body').click();
	      this.theDeleteEvent = null;
	    },
	    setSubStatus: function setSubStatus(lesson, num, teacherToSub) {
	      var _this2 = this;
	
	      var statusData = this.getSubstitutionStatus(lesson);
	      statusData[teacherToSub.user_calendar_id] = { 'status': num };
	      _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this2.$store.commit('updateSubStatusOnEvent', {
	          'eventId': lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	      });
	    },
	    getSubstitutionStatus: function getSubstitutionStatus(lesson) {
	      return lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	    },
	    setAsSub: function setAsSub() {
	      var _this3 = this;
	
	      this.isLoadingEvent = true;
	      var activeEvent = this.theTeacherOrSubObj.eventToSub;
	      var teacherToAdd = this.theTeacherOrSubObj.userAsSub;
	      var teacherToSub = this.theTeacherOrSubObj.userToSub;
	      if (this.isSubStatusPendingActive) {
	        this.setSubStatus(activeEvent, 2, teacherToSub);
	      }
	      var userEventObj = { cal_id: teacherToAdd.user_calendar_id, event_id: activeEvent.id };
	      _docendo2.default.eventAddSubstitute(activeEvent.id, teacherToAdd.id, teacherToSub.id, function (data) {
	        _this3.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this3.$store.commit('addEventOnAllUsersWithEvents', userEventObj);
	        _this3.isLoadingEvent = false;
	        _this3.theTeacherOrSubObj = null;
	      });
	    },
	    setAsTeacher: function setAsTeacher() {
	      var _this4 = this;
	
	      this.isLoadingEvent = true;
	      var activeEvent = this.theTeacherOrSubObj.eventToSub;
	      var teacherToAdd = this.theTeacherOrSubObj.userAsSub;
	      var teacherToSub = this.theTeacherOrSubObj.userToSub;
	      this.setSubStatus(activeEvent, 1, teacherToSub);
	      var userCalIds = activeEvent.calendar_events.map(function (cal) {
	        return cal.calendar_id;
	      });
	      var allCals = userCalIds.concat([teacherToAdd.user_calendar_id]);
	      var updates = [{ event_id: activeEvent.id, calendar_ids: allCals }];
	      _docendo2.default.updateEvents(activeEvent.school_id, updates, function (success) {
	        _this4.isLoadingEvent = false;
	        _this4.$store.dispatch('getAllDayEvents');
	        _this4.theTeacherOrSubObj = null;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    onChooseSubType: function onChooseSubType(obj) {
	      this.theTeacherOrSubObj = obj;
	      this.setIsModal(true);
	    },
	    setIsModal: function setIsModal(bool) {
	      if (!bool) {
	        this.theTeacherOrSubObj = null;
	      }
	    },
	    showLog: function showLog(event) {
	      this.$emit('showLog', event);
	    },
	    removeSubs: function removeSubs(data) {
	      this.$emit('removeSubs', data);
	    },
	    setActiveUser: function setActiveUser(item, e) {
	      this.activeUser = item;
	      this.activeUserBCR = e.target.getBoundingClientRect();
	    },
	    setRows: function setRows(obj, userid) {
	      this.$set(this.rows, userid, obj.rows);
	    },
	    handleScrollRight: function handleScrollRight(evt, el) {
	      if (!this.isSyncingRightScroll) {
	        this.isSyncingLeftScroll = true;
	        this.isSyncingTopScroll = true;
	        this.$refs.leftDiv.scrollTop = el.scrollTop;
	        this.$refs.topDiv.scrollLeft = el.scrollLeft;
	      }
	      this.isSyncingRightScroll = false;
	    },
	    handleScrollLeft: function handleScrollLeft(evt, el) {
	      if (!this.isSyncingLeftScroll) {
	        this.isSyncingRightScroll = true;
	        this.$refs.rightDiv.scrollTop = el.scrollTop;
	      }
	      this.isSyncingLeftScroll = false;
	    },
	    handleScrollTop: function handleScrollTop(evt, el) {
	      if (!this.isSyncingTopScroll) {
	        this.isSyncingRightScroll = true;
	        this.$refs.rightDiv.scrollLeft = el.scrollLeft;
	      }
	      this.isSyncingTopScroll = false;
	    },
	    closePopover: function closePopover(e) {
	      if (!this.setActiveUser) {
	        return;
	      }
	      this.$store.commit('setActiveUser', null);
	      this.$store.commit('setActiveEvent', null);
	      this.$store.dispatch('setActiveSchedulerEvent', {
	        'left': -10,
	        'right': -10,
	        'color': '',
	        'oldSubScoreMeta': this.subScoreMeta,
	        'obj': null
	      });
	    },
	    createPopperForAbsentStatusDropdown: function createPopperForAbsentStatusDropdown(itemId) {
	      (0, _core.createPopper)(this.$refs['absence_status_dropdown__parent___' + itemId][0], this.$refs['absence_status_dropdown'], {
	        placement: 'right-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, -10]
	          }
	        }]
	      });
	    },
	    setIsUserHandlerLoading: function setIsUserHandlerLoading(itemId) {
	      this.theUserHandlerLoading = itemId;
	    },
	    getIsUserHandlerLoading: function getIsUserHandlerLoading(itemId) {
	      return this.theUserHandlerLoading === itemId;
	    },
	    setTheAbsentUserHandledDropdown: function setTheAbsentUserHandledDropdown(user) {
	      var _this5 = this;
	
	      this.theAbsentUserHandledDropdown = user;
	      if (!user) {
	        return;
	      }
	      setTimeout(function (_) {
	        _this5.createPopperForAbsentStatusDropdown(user.id);
	      }, 0);
	    },
	    getIsUserSubstituted: function getIsUserSubstituted(user, lesson) {
	      var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	        return calEvent.substitute_for_user_id === user.id;
	      });
	      if (isUserSubstituted) {
	        return true;
	      }
	    },
	    setAbsenceStatus: function setAbsenceStatus(user, num) {
	      var _this6 = this;
	
	      var groupBySchoolId = function groupBySchoolId(lessons) {
	        return lessons.reduce(function (groups, lesson) {
	          var schoolId = lesson.school_id;
	          if (!groups[schoolId]) {
	            groups[schoolId] = [];
	          }
	          groups[schoolId].push(lesson);
	          return groups;
	        }, {});
	      };
	
	      if (user.dayEvents.length < 1) {
	        user.dayAbsence.forEach(function (lessonId) {
	          var lesson = _this6.allEventsInAHash[lessonId];
	          var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	          statusData[user.user_calendar_id] = { status: num };
	
	          _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	            _this6.$store.commit('updateSubStatusOnEvent', {
	              eventId: lesson.id,
	              status: (0, _stringify2.default)(statusData)
	            });
	          });
	        });
	      }
	
	      var lessonsToUpdate = user.dayEvents.filter(function (lessonId) {
	        var lesson = _this6.allEventsInAHash[lessonId];
	        return !_this6.isSubStatusPendingActive ? !_this6.getIsUserSubstituted(user, lesson) : true;
	      }).map(function (lessonId) {
	        var lesson = _this6.allEventsInAHash[lessonId];
	        var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	        statusData[user.user_calendar_id] = { status: num };
	
	        return (0, _extends3.default)({}, lesson, {
	          substitution_status: (0, _stringify2.default)(statusData)
	        });
	      });
	
	      var groupedLessons = groupBySchoolId(lessonsToUpdate);
	
	      this.setIsUserHandlerLoading(user.id);
	
	      (0, _entries2.default)(groupedLessons).forEach(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            schoolId = _ref2[0],
	            lessons = _ref2[1];
	
	        var eventsToUpdate = lessons.map(function (lesson) {
	          return {
	            event_id: lesson.id,
	            substitution_status: lesson.substitution_status
	          };
	        });
	
	        _docendo2.default.updateEvents(schoolId, eventsToUpdate, function (success) {
	          if (success) {
	            eventsToUpdate.forEach(function (event) {
	              _this6.$store.commit('updateSubStatusOnEvent', {
	                eventId: event.event_id,
	                status: event.substitution_status
	              });
	            });
	          } else {
	            console.error('Failed to update events for school_id: ' + schoolId);
	          }
	
	          _this6.setIsUserHandlerLoading(null);
	        });
	      });
	
	      setTimeout(function () {
	        _this6.setTheAbsentUserHandledDropdown(null);
	      }, 0);
	    },
	    getAbsenceTitle: function getAbsenceTitle(absenceId) {
	      return this.allEventsInAHash[absenceId] && this.allEventsInAHash[absenceId].title ? this.allEventsInAHash[absenceId].title : 'No title';
	    },
	    closeSubStatusDropdown: function closeSubStatusDropdown(evt) {
	      var theClassList = evt.target.classList;
	      if (theClassList.contains('scheduler__users__user__handled__handler') || theClassList.contains('scheduler__users__user__handled')) {
	        return;
	      }
	      this.setTheAbsentUserHandledDropdown(null);
	    },
	    isAbsenceAutoGenerated: function isAbsenceAutoGenerated(item) {
	      var _this7 = this;
	
	      if (item.dayAbsence.length < 1) {
	        return false;
	      }
	      var autoGeneratedToday = false;
	      item.dayAbsence.forEach(function (absenceId) {
	        var absence = _this7.allEventsInAHash[absenceId] && _this7.allEventsInAHash[absenceId] ? _this7.allEventsInAHash[absenceId] : {};
	        var statusObj = absence.substitution_status ? JSON.parse(absence.substitution_status) : {};
	        var todayDate = (0, _moment2.default)(_this7.date).format('YYYY-MM-DD');
	        if (statusObj['extended_at'] && (0, _moment2.default)(statusObj['extended_at']).isSame(todayDate)) {
	          autoGeneratedToday = true;
	        }
	      });
	      return autoGeneratedToday;
	    },
	    setActiveAbsentUser: function setActiveAbsentUser(item) {
	      this.$store.commit('setActiveAbsentUser', item);
	    },
	    setCreateEventOnUser: function setCreateEventOnUser(item) {
	      var user = item;
	      var date = (0, _moment2.default)(this.date);
	      this.$emit('setCreateEventOnUser', { user: user, date: date });
	    },
	    setCreateEventOnUserOnNotAbsentUser: function setCreateEventOnUserOnNotAbsentUser(item) {
	      if (item.dayAbsence.length > 0) {
	        return;
	      }
	      this.setCreateEventOnUser(item);
	    },
	    hasVerticalScrollbar: function hasVerticalScrollbar(el) {
	      return el.offsetWidth > el.clientWidth;
	    }
	  },
	  mounted: function mounted() {
	    this.calculateMaxHeight();
	    window.addEventListener('resize', this.calculateMaxHeight);
	    var rightDiv = this.$refs.rightDiv;
	    this.isVerticalScrollbar = this.hasVerticalScrollbar(rightDiv);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.calculateMaxHeight);
	  }
	};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SchedulerItemPopover = __webpack_require__(337);
	
	var _SchedulerItemPopover2 = _interopRequireDefault(_SchedulerItemPopover);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(35);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	
	var I18N = {
	  da: {
	    multiple_days: 'Flere dage',
	    ongoing: 'Løbende fravær',
	    auto_created: 'Oprettet automatisk',
	    from_another_school: 'Fra anden skole'
	  },
	  nb: {
	    multiple_days: 'Flere dager',
	    ongoing: 'Automatisk',
	    auto_created: 'Løpende lengre fravær',
	    from_another_school: 'Fra annen skole'
	  },
	  en: {
	    multiple_days: 'Multiple days',
	    ongoing: 'Automatic',
	    auto_created: 'Autogenerated',
	    from_another_school: 'From another school'
	  }
	};
	
	exports.default = {
	  components: { doPopover: _SchedulerItemPopover2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    locale: {
	      default: 'da'
	    },
	    allEvents: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    longAbsentListInHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      isShowSelectButton: false,
	      selectButtonStyleObjForLoader: { color: '' },
	      selectButtonLoading: false,
	      slotWidth: 40,
	      slotHeight: 40,
	      rows: 1,
	      firstEvent: true,
	      correctEvents: [],
	      subScoreMeta: [],
	      oldSubScoreMeta: [],
	      isEventsHasSortedOnce: false
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isOnActiveEvent: function isOnActiveEvent() {
	      var arr = this.allEventsInAHash[this.activeEvent.obj.id].calendar_events ? this.allEventsInAHash[this.activeEvent.obj.id].calendar_events.map(function (cal) {
	        return cal.calendar_id;
	      }) : [];
	
	      return arr.indexOf(this.user.user_calendar_id) > -1;
	    },
	    isShowSetAsSubButton: function isShowSetAsSubButton() {
	      return this.selectButtonLoading || this.isShowSelectButton && this.styleObj.color !== '' && this.user.dayAbsence.length < 1 && !this.user.headline && this.activeEvent && this.activeEvent.obj.event_type !== 'absence' && !this.isOnActiveEvent;
	    },
	    schedulerActiveEvent: function schedulerActiveEvent() {
	      return this.$store.state.subs.schedulerActiveEvent;
	    },
	    styleObj: function styleObj() {
	      return this.schedulerActiveEvent.obj ? this.schedulerActiveEvent : this.selectButtonStyleObjForLoader;
	    },
	    activeEvent: function activeEvent() {
	      return this.$store.state.subs.activeEvent;
	    },
	    activeUser: function activeUser() {
	      return this.$store.state.subs.activeUser;
	    },
	    isSortSubActive: function isSortSubActive() {
	      return this.$store.state.subs.isSortSubActive;
	    },
	    users: function users() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    userLessons: function userLessons() {
	      var _this = this;
	
	      return this.user.dayEvents.map(function (eventId) {
	        return _this.allEventsInAHash[eventId];
	      });
	    },
	    userPresence: function userPresence() {
	      var _this2 = this;
	
	      return this.user.dayPresence.map(function (eventId) {
	        return _this2.allEventsInAHash[eventId];
	      });
	    },
	    userAbsence: function userAbsence() {
	      var _this3 = this;
	
	      return this.user.dayAbsence.map(function (eventId) {
	        return _this3.allEventsInAHash[eventId];
	      });
	    },
	    hasAbsence: function hasAbsence() {
	      return this.userAbsence.length > 0 ? 12 : 0;
	    },
	    userAbsenceForPlacing: function userAbsenceForPlacing() {
	      var _this4 = this;
	
	      return this.userAbsence.map(function (event) {
	        return {
	          'left': _this4.eventTop(event),
	          'right': _this4.eventRight(event),
	          'row': 0,
	          'bottom': _this4.eventBottom(event),
	          'obj': event
	        };
	      });
	    },
	    userPresenceForPlacing: function userPresenceForPlacing() {
	      var _this5 = this;
	
	      return this.userPresence.map(function (event) {
	        return {
	          'left': _this5.eventTop(event),
	          'right': _this5.eventRight(event),
	          'obj': event
	        };
	      });
	    },
	    sortedEvents: function sortedEvents() {
	      var _this6 = this;
	
	      var arr = this.userLessons.map(function (lesson) {
	        return (0, _extends3.default)({}, lesson, {
	          v_status: _this6.getSubstitutionStatusForUserCalId(lesson)
	        });
	      });
	      return arr.sort(function (a, b) {
	        return moment(a.start).unix() - moment(b.start).unix();
	      });
	    },
	    activeDate: function activeDate() {
	      return this.$store.state.subs.date;
	    },
	    isSchoolCalendarsLoading: function isSchoolCalendarsLoading() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    }
	  },
	  watch: {
	    sortedEvents: function sortedEvents() {
	      this.rows = 1;
	      this.$emit('rows', { 'rows': this.rows });
	      this.correctEvents.splice(0, this.correctEvents.length);
	      this.setWidthAndLeft();
	    },
	    isSchoolCalendarsLoading: function isSchoolCalendarsLoading() {
	      this.setWidthAndLeft();
	    }
	  },
	  methods: {
	    getSerialListItem: function getSerialListItem(reason) {
	      return this.longAbsentListInHash[reason.event_serial_id] || false;
	    },
	    getIsAbsenceOngoing: function getIsAbsenceOngoing(reason) {
	      return this.getSerialListItem(reason) && this.getSerialListItem(reason).ongoing;
	    },
	    getIsAbsenceAutoGenerated: function getIsAbsenceAutoGenerated(reason) {
	      var statusObj = reason.substitution_status ? JSON.parse(reason.substitution_status) : {};
	      return statusObj['extended_at'] && moment(statusObj['extended_at']).isSame(moment(this.activeDate).format('YYYY-MM-DD'));
	    },
	    getIsAbsenceMultipleDays: function getIsAbsenceMultipleDays(reason) {
	      var serialItem = this.getSerialListItem(reason);
	      return serialItem && moment(serialItem.from_date).format('YYYY-MM-DD') !== moment(serialItem.to_date).format('YYYY-MM-DD');
	    },
	    getAbsenceTitle: function getAbsenceTitle(reason) {
	      var str = this.getIsAbsenceOngoing(reason) ? '(' + this.i18n['ongoing'] + ')' : '(' + this.i18n['multiple_days'] + ')';
	      if (this.getIsAbsenceAutoGenerated(reason)) {
	        str = '(' + this.i18n['ongoing'] + ')' + '<span class="marg-5-left badge badge--small badge--orange-warning">' + this.i18n['auto_created'] + '</span>';
	      }
	      return this.getIsAbsenceOngoing(reason) || this.getIsAbsenceMultipleDays(reason) ? reason.title + ' - ' + str : reason.title;
	    },
	    allOnLessonHumanized: function allOnLessonHumanized(lesson) {
	      if (!lesson) return [];
	
	      if (lesson.subs && lesson.subs.length > 0) {
	        return lesson.subs.map(function (obj) {
	          return obj && obj.name ? obj.name : '';
	        });
	      } else if (lesson.othersOnLesson) {
	        return lesson.othersOnLesson.map(function (obj, idx) {
	          return obj && obj.name && idx < 3 ? obj.name : '';
	        });
	      }
	
	      return [];
	    },
	    getSubstitutionStatusForUserCalId: function getSubstitutionStatusForUserCalId(lesson) {
	      var _this7 = this;
	
	      var statusObj = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	      var userStatus = statusObj[this.user.user_calendar_id] ? statusObj[this.user.user_calendar_id].status : 0;
	      if (this.isSubStatusPendingActive) {
	        return userStatus;
	      } else {
	        var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	          return calEvent.substitute_for_user_id === _this7.user.id;
	        });
	        if (isUserSubstituted || userStatus === 1) {
	          return 1;
	        } else {
	          return 0;
	        }
	      }
	    },
	    setPopover: function setPopover(lesson) {
	      var _this8 = this;
	
	      if (lesson.obj.v_is_event_from_other_school) {
	        return;
	      }
	      setTimeout(function () {
	        var overlappingEvents = [];
	        if (_this8.isSortSubActive && _this8.user.dayAbsence.length > 0 && lesson.obj.event_type !== 'absence') {
	          _this8.oldSubScoreMeta = _this8.subScoreMeta;
	          _this8.subScoreMeta = lesson.othersOnLesson;
	          _this8.allEvents.forEach(function (event) {
	            var range1 = moment.range(lesson.obj.start, lesson.obj.end);
	            var range2 = moment.range(event.start, event.end);
	            if (range1.overlaps(range2)) {
	              overlappingEvents.push(event);
	            }
	          });
	        }
	        _this8.$store.commit('setActiveUser', _this8.user);
	        _this8.$store.commit('setActiveEvent', lesson);
	        _this8.$store.dispatch('setActiveSchedulerEvent', {
	          'obj': lesson.obj,
	          'left': lesson.left,
	          'right': lesson.right,
	          'color': lesson.obj.color,
	          'user': _this8.user,
	          'userIsAbsent': _this8.user.dayAbsence.length > 0,
	          'oldSubScoreMeta': _this8.oldSubScoreMeta,
	          'othersOnLesson': lesson.othersOnLesson,
	          'overlappingEvents': overlappingEvents
	        });
	      }, 100);
	    },
	    eventOverLapsAbsence: function eventOverLapsAbsence(event) {
	      var overlaps = false;
	      for (var i = 0; i < this.user.dayAbsence.length; i++) {
	        var lesson = this.allEventsInAHash[this.user.dayAbsence[i]];
	        var range1 = moment.range(lesson.start, lesson.end);
	        var range2 = moment.range(event.start, event.end);
	        if (range1.overlaps(range2)) {
	          overlaps = true;
	        }
	      }
	      return overlaps;
	    },
	    eventRight: function eventRight(event) {
	      var time = moment.duration({
	        minutes: moment(event.end).format('mm'),
	        hours: moment(event.end).format('HH')
	      }).asMinutes();
	      var endOfDay = moment.duration({
	        hours: 24,
	        minutes: 0
	      }).asMinutes();
	      return this.slotWidth * 2 / 60 * (endOfDay - time);
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = moment(event.start).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventStartTime = moment(event.start);
	      var duration = moment(eventStartTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = moment(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = moment(event.end).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventEndTime = moment(event.end);
	      var duration = moment(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * moment.duration(duration).asMinutes();
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    packEvents: function packEvents(columns) {
	      var _this9 = this;
	
	      var n = columns.length;
	
	      var _loop = function _loop(i) {
	        var col = columns[i];
	
	        var _loop2 = function _loop2(j) {
	          var ev = col[j];
	          var colSpan = _this9.expandEvent(ev, i, columns);
	          col[j].row = i;
	          if (i + 1 > _this9.rows) {
	            _this9.rows = i + 1;
	          }
	          _this9.$emit('rows', { 'rows': _this9.rows });
	          col[j].colspan = colSpan / n;
	          var idx = _this9.correctEvents.findIndex(function (lesson) {
	            return lesson.obj.id === col[j].obj.id;
	          });
	          if (idx < 0) {
	            _this9.correctEvents.push(col[j]);
	          } else {
	            _this9.$set(_this9.correctEvents, idx, col[j]);
	          }
	
	          if (_this9.firstEvent) {
	            _this9.$emit('lessonsUpdate', _this9.correctEvents[0]);
	          }
	          _this9.firstEvent = false;
	        };
	
	        for (var j = 0; j < col.length; j++) {
	          _loop2(j);
	        }
	      };
	
	      for (var i = 0; i < n; i++) {
	        _loop(i);
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var _col = columns[i];
	        for (var j = 0; j < _col.length; j++) {
	          var ev1 = _col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    setWidthAndLeft: function setWidthAndLeft() {
	      var _this10 = this;
	
	      this.isEventsHasSortedOnce = true;
	      var columns = [];
	      var lastEventEnding = null;
	      var events = this.sortedEvents.map(function (elem) {
	        var subs = [];
	        var othersOnLesson = [];
	        var klassesOnLesson = [];
	
	        elem.calendar_events.forEach(function (calEvent) {
	          if (calEvent.calendar_id !== _this10.user.user_calendar_id && calEvent.substitute && calEvent.substitute_for_user_id === _this10.user.id) {
	            subs.push(_this10.users[calEvent.calendar_id]);
	          } else if (calEvent.calendar_type === 'user' && !calEvent.substitute && calEvent.calendar_id !== _this10.user.user_calendar_id) {
	            othersOnLesson.push(_this10.users[calEvent.calendar_id]);
	          } else if (calEvent.calendar_type === 'klass' || calEvent.calendar_type === 'club') {
	            klassesOnLesson.push(calEvent);
	          }
	        });
	        var top = _this10.eventTop(elem);
	        var height = _this10.eventHeight(elem);
	        var bottom = _this10.eventBottom(elem);
	        var right = _this10.eventRight(elem);
	        var overlapsAbsent = _this10.eventOverLapsAbsence(elem);
	        return {
	          'obj': elem,
	          'top': top,
	          'left': top,
	          'right': right,
	          'height': height,
	          'bottom': bottom,
	          'overlapsAbsent': overlapsAbsent,
	          'subs': subs,
	          'othersOnLesson': othersOnLesson,
	          'klassesOnLesson': klassesOnLesson,
	          'klassesAsString': klassesOnLesson.filter(function (klass) {
	            return klass && klass.name;
	          }).map(function (klass) {
	            return klass.name;
	          }).join(', ')
	        };
	      });
	      events.sort(function (e1, e2) {
	        if (e1.top < e2.top) return -1;
	        if (e1.top > e2.top) return 1;
	        if (e1.bottom < e2.bottom) return -1;
	        if (e1.bottom > e2.bottom) return 1;
	        return 0;
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packEvents(columns);
	          columns = [];
	          lastEventEnding = null;
	        }
	        var placed = false;
	        for (var j = 0; j < columns.length; j++) {
	          var _col2 = columns[j];
	          if (!this.collidesWith(_col2[_col2.length - 1], e)) {
	            _col2.push(e);
	            placed = true;
	            break;
	          }
	        }
	        if (!placed) {
	          columns.push([e]);
	        }
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (columns.length > 0) {
	        this.packEvents(columns);
	      }
	    },
	    setAddSubstitute: function setAddSubstitute() {
	      var _this11 = this;
	
	      if (this.selectButtonLoading) {
	        return;
	      }
	
	      if (this.checkIfAvailableEventOverlaps(this.activeEvent, this.sortedEvents)) {
	        var _userEventObj = { userAsSub: this.user, eventToSub: this.activeEvent.obj, userToSub: this.activeUser };
	        this.$emit('onChooseSubType', _userEventObj);
	        return;
	      }
	      this.selectButtonStyleObjForLoader = this.schedulerActiveEvent;
	      this.selectButtonLoading = true;
	      if (this.isSubStatusPendingActive) {
	        this.setSubStatus(this.activeEvent.obj, 2);
	      }
	      var userEventObj = { cal_id: this.user.user_calendar_id, event_id: this.activeEvent.obj.id };
	      _docendo2.default.eventAddSubstitute(this.activeEvent.obj.id, this.user.id, this.activeUser.id, function (data) {
	        _this11.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this11.$store.commit('addEventOnAllUsersWithEvents', userEventObj);
	        _this11.selectButtonLoading = false;
	        _this11.selectButtonStyleObjForLoader = { color: '' };
	      });
	    },
	    checkIfAvailableEventOverlaps: function checkIfAvailableEventOverlaps(eventToSubstitute, userEvents) {
	      var startTime = moment(eventToSubstitute.obj.start);
	      var endTime = moment(eventToSubstitute.obj.end);
	
	      var overlappingAvailableEvents = userEvents.filter(function (event) {
	        var eventStart = moment(event.start);
	        var eventEnd = moment(event.end);
	        return eventStart.isBefore(endTime) && eventEnd.isAfter(startTime) && event.event_type === 'available';
	      });
	
	      return overlappingAvailableEvents.length > 0;
	    },
	    setSubStatus: function setSubStatus(lesson, num) {
	      var _this12 = this;
	
	      var statusData = this.getSubstitutionStatus(lesson);
	      statusData[this.activeUser.user_calendar_id] = { 'status': num };
	      _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this12.$store.commit('updateSubStatusOnEvent', {
	          'eventId': lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	      });
	    },
	    getSubstitutionStatus: function getSubstitutionStatus(lesson) {
	      return lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	    }
	  },
	  mounted: function mounted() {
	    this.rows = 1;
	    this.$emit('rows', { 'rows': this.rows });
	    this.setWidthAndLeft();
	  }
	};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DSelectSubs = __webpack_require__(305);
	
	var _DSelectSubs2 = _interopRequireDefault(_DSelectSubs);
	
	var _SchedulerItemPopoverStatus = __webpack_require__(1349);
	
	var _SchedulerItemPopoverStatus2 = _interopRequireDefault(_SchedulerItemPopoverStatus);
	
	var _SubsUserAbsenceReason = __webpack_require__(87);
	
	var _SubsUserAbsenceReason2 = _interopRequireDefault(_SubsUserAbsenceReason);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _AppEIPWYZIWYG = __webpack_require__(45);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DSelectCalendars = __webpack_require__(302);
	
	var _DSelectCalendars2 = _interopRequireDefault(_DSelectCalendars);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _LessonOverlapInKlass = __webpack_require__(1342);
	
	var _LessonOverlapInKlass2 = _interopRequireDefault(_LessonOverlapInKlass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    absent: 'Fraværende',
	    user_not_found: 'Brugeren er fjernet fra skolen',
	    edit_teachers: 'Redigér underviser(e)',
	    delete_lesson: 'Slet lektion',
	    split_lesson: 'Opdel lektion',
	    out_of_school: 'Ude af huset',
	    cancel_event: 'Aflys timen',
	    uncancel_event: 'Fortryd aflysning',
	    canceled: 'Aflyst'
	  },
	  nb: {
	    absent: 'Fraværende',
	    user_not_found: 'Brukeren er fjernet fra skolen',
	    edit_teachers: 'Rediger lærer(e)',
	    delete_lesson: 'Slett time',
	    split_lesson: 'Del opp timen',
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst',
	    cancel_event: 'Avlys timen',
	    uncancel_event: 'Angre avlysning'
	  },
	  en: {
	    absent: 'Absent',
	    user_not_found: 'User is removed from school',
	    edit_teachers: 'Edit teacher(s)',
	    delete_lesson: 'Delete lesson',
	    split_lesson: 'Split lesson in two',
	    out_of_school: 'Out of school',
	    canceled: 'Canceled',
	    cancel_event: 'Cancel lesson',
	    uncancel_event: 'Undo cancellation'
	  }
	};
	
	exports.default = {
	  components: {
	    LessonOverlapInKlass: _LessonOverlapInKlass2.default,
	    DDropdown: _DDropdown2.default, Loader: _Loader2.default, DSelectCalendars: _DSelectCalendars2.default, dSelectSub: _DSelectSubs2.default, lessonsSubstitutionStatus: _SchedulerItemPopoverStatus2.default, AbsenceReason: _SubsUserAbsenceReason2.default, weip: _AppEIPWYZIWYG2.default
	  },
	  props: {
	    activeEventId: {
	      type: Object
	    },
	    user: {
	      type: Object,
	      default: function _default() {}
	    },
	    locale: {
	      default: 'da'
	    }
	  },
	  mixins: [_vueClickaway.mixin],
	  data: function data() {
	    return {
	      isUpdatingSubstitutes: false,
	      isEditTeacher: false,
	      isUpdatingTeachers: false,
	      showAllOnLesson: 3,
	      propStatus: 3,
	      isActiveEIP: false,
	      hasSubstituteNoteChanged: false,
	      propToCloseDropdown: 0
	    };
	  },
	
	  filters: {
	    time: function time(date) {
	      return (0, _moment2.default)(date).format('LT');
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allCalendarsInHash', 'userSet', 'allUsersInHash', 'isSubStatusPendingActive']), {
	    i18n: function i18n() {
	      return I18N;
	    },
	    lesson: function lesson() {
	      return this.allEventsInAHash[this.activeEventId.obj.id];
	    },
	    isCanceled: function isCanceled() {
	      return this.lesson.canceled;
	    },
	    isAway: function isAway() {
	      return this.lesson.away;
	    },
	    allUsersAndEvents: function allUsersAndEvents() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    calsOnLesson: function calsOnLesson() {
	      var _this = this;
	
	      return this.lesson.calendar_events.map(function (event) {
	        return _this.allCalendarsInHash[event.calendar_id];
	      });
	    },
	    klassesOnLesson: function klassesOnLesson() {
	      return this.calsOnLesson.filter(function (cal) {
	        return cal && cal.type === 'klass' || cal && cal.type === 'other';
	      });
	    },
	    usersOnLesson: function usersOnLesson() {
	      var _this2 = this;
	
	      var userIds = [];
	      this.lesson.calendar_events.forEach(function (cal) {
	        if (cal.calendar_type === 'user' && !cal.substitute && cal.calendar_type === 'user' && cal.calendar_id !== _this2.lesson.calendar_id) {
	          userIds.push(cal.calendar_id);
	        }
	      });
	      return userIds;
	    },
	    userCalIdsSubstituted: function userCalIdsSubstituted() {
	      var _this3 = this;
	
	      var userIdsSubstituted = this.lesson.calendar_events.map(function (cal) {
	        return cal.substitute_for_user_id;
	      });
	      return userIdsSubstituted.filter(function (userId) {
	        return _this3.allUsersInHash[userId];
	      }).map(function (userId) {
	        return _this3.allUsersInHash[userId].user_calendar_id;
	      });
	    },
	    othersOnLesson: function othersOnLesson() {
	      var users = [];
	      for (var i = 0; i < this.lesson.calendar_events.length; i++) {
	        if (this.allUsersAndEvents[this.lesson.calendar_events[i].calendar_id] && !this.lesson.calendar_events[i].substitute && this.lesson.calendar_events[i].calendar_id !== this.user.user_calendar_id) {
	          var user = this.allUsersAndEvents[this.lesson.calendar_events[i].calendar_id];
	          user['v_isUserAbsentFromLesson'] = this.absenceOverlapLesson(this.lesson.id, user.dayAbsence);
	          users.push(user);
	        }
	      }
	      return users;
	    },
	    userNotFoundPlaceholder: function userNotFoundPlaceholder() {
	      return {
	        id: 0,
	        name: this.i18n[this.locale]['user_not_found'],
	        type: 'user',
	        url: '/calendar',
	        calendar_id: 0,
	        dayAbsence: [],
	        dayEvents: [],
	        dayAllEvents: [],
	        default_thumb_url: '',
	        user_tags: [],
	        occupied: false,
	        isOnLesson: false,
	        currentEventId: 0,
	        user_calendar_id: 0,
	        isErrorUser: true
	      };
	    },
	    substitutesOnLesson: function substitutesOnLesson() {
	      var _this4 = this;
	
	      var subs = [];
	      this.lesson.calendar_events.map(function (event) {
	        if (event.substitute && event.substitute_for_user_id === _this4.user.id) {
	          var sub = _this4.allUsersAndEvents[event.calendar_id] ? _this4.allUsersAndEvents[event.calendar_id] : _this4.userNotFoundPlaceholder;
	          subs.push(sub);
	        }
	      });
	      return subs;
	    }
	  }),
	  methods: {
	    setActiveSplitLesson: function setActiveSplitLesson(lesson) {
	      this.propToCloseDropdown++;
	      this.$emit('splitLesson', lesson);
	    },
	    onDeletedLesson: function onDeletedLesson(lesson) {
	      this.propToCloseDropdown++;
	      this.$emit('deleteEvent', lesson);
	    },
	    setUsers: function setUsers(userCals) {
	      var _this5 = this;
	
	      this.isUpdatingTeachers = true;
	      var userCalIds = userCals.map(function (cal) {
	        return cal.id;
	      });
	      var calIdsNotInUserCalIds = this.lesson.calendar_events.filter(function (cal) {
	        return !(cal.calendar_type === 'user' && cal.substitute === false && cal.calendar_id !== _this5.lesson.calendar_id);
	      }).map(function (cal) {
	        return cal.calendar_id;
	      });
	      var allCals = calIdsNotInUserCalIds.concat(userCalIds);
	      var updates = [{ event_id: this.lesson.id, calendar_ids: allCals }];
	      _docendo2.default.updateEvents(this.lesson.school_id, updates, function (success) {
	        _this5.$store.dispatch('getAllDayEvents');
	        _this5.isUpdatingTeachers = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    showLog: function showLog(event) {
	      this.$emit('showLog', event);
	    },
	    absenceOverlapLesson: function absenceOverlapLesson(lessonId, absenceIds) {
	      var _this6 = this;
	
	      var absenceOverlapping = [];
	      var absenceEvents = absenceIds.map(function (eventId) {
	        return _this6.allEventsInAHash[eventId];
	      });
	      var lessonEvent = this.allEventsInAHash[lessonId];
	      absenceEvents.forEach(function (absenceEvent) {
	        var range1 = _moment2.default.range(absenceEvent.start, absenceEvent.end);
	        var range2 = _moment2.default.range(lessonEvent.start, lessonEvent.end);
	        if (range1.intersect(range2)) {
	          var absentLessonReadable = absenceEvent.title + ' ' + (0, _moment2.default)(absenceEvent.start).format('LT') + '-' + (0, _moment2.default)(absenceEvent.end).format('LT');
	          absenceOverlapping.push(absentLessonReadable);
	        }
	      });
	      return absenceOverlapping;
	    },
	    getUser: function getUser(calId) {
	      return this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].name ? this.allCalendarsInHash[calId].name : 'Not found';
	    },
	    updateTeacherNote: function updateTeacherNote(obj) {
	      var _this7 = this;
	
	      if (this.lesson.teacher_notes === obj.text || !obj) {
	        return;
	      }
	      var eventIdAndTeacherNote = {
	        eventId: this.lesson.id,
	        note: obj.text
	      };
	      _docendo2.default.updateEvent(window.SCHOOL.id, obj.lesson.id, (0, _defineProperty3.default)({}, obj.noteType, obj.text), function (success) {
	        _this7.$store.commit('updateTeacherNoteOnEvent', eventIdAndTeacherNote);
	      });
	    },
	    addSubstitute: function addSubstitute(userObj) {
	      var _this8 = this;
	
	      if (userObj.isWithAvailability) {
	        var updateObj = {
	          eventToSub: this.lesson,
	          userAsSub: userObj,
	          userToSub: this.user
	        };
	        this.$emit('chooseSubType', updateObj);
	        this.emitClose();
	        return;
	      }
	      this.isUpdatingSubstitutes = true;
	      if (this.isSubStatusPendingActive) {
	        this.propStatus = 2;
	      }
	
	      var userEventObj = { cal_id: userObj.user_calendar_id, event_id: this.lesson.id };
	      _docendo2.default.eventAddSubstitute(this.lesson.id, userObj.id, this.user.id, function (data) {
	        _this8.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this8.$store.commit('addEventOnAllUsersWithEvents', userEventObj);
	        _this8.isUpdatingSubstitutes = false;
	      });
	    },
	    removeSubstitute: function removeSubstitute(userObj) {
	      var _this9 = this;
	
	      this.isUpdatingSubstitutes = true;
	
	      var subsForTheSub = [];
	      this.lesson.calendar_events.forEach(function (calEvent) {
	        if (calEvent.substitute && calEvent.substitute_for_user_id === userObj.id) {
	          subsForTheSub.indexOf(calEvent.calendar_id) < 0 ? subsForTheSub.push(calEvent.calendar_id) : null;
	        }
	      });
	      var userAndSubsForUser = {
	        user: this.user,
	        lesson: this.lesson,
	        subToBeRemoved: userObj,
	        subsForTheSubToBeRemoved: subsForTheSub
	      };
	      if (subsForTheSub.length > 0) {
	        this.$emit('removeSubs', userAndSubsForUser);
	        return;
	      }
	
	      this.propStatus = 0;
	      _docendo2.default.eventRemoveSubstitute(this.lesson.id, userObj.id, this.user.id, function (data) {
	        _this9.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this9.$store.commit('removeEventOnAllUsersWithEvents', {
	          cal_id: userObj.user_calendar_id,
	          event_id: _this9.lesson.id
	        });
	        _this9.isUpdatingSubstitutes = false;
	      });
	    },
	    emitClose: function emitClose(e) {
	      this.$emit('close');
	    },
	    emitClickAway: function emitClickAway(evt) {
	      var targ = evt.target.closest('ul');
	
	      if (targ && targ.classList.contains('d-select__items__container') || _eventbus2.default.isLessonNoteChangedWithoutSaving) {
	        return;
	      }
	      this.$emit('clickaway');
	    }
	  }
	};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    user: {
	      type: Object,
	      default: null
	    },
	
	    userCalendarId: {
	      type: Number
	    },
	    lesson: {
	      type: Object,
	      default: function _default() {}
	    },
	    statusProp: {
	      type: Number,
	      default: 0
	    },
	    dropdownPlacement: {
	      type: String,
	      default: 'bottom-end'
	    },
	    othersOnLesson: {
	      type: Array,
	      default: []
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    statusDotClass: function statusDotClass() {
	      if (this.status === 2) {
	        return 'dot-yellow';
	      }
	      if (!this.status || this.status === 0) {
	        return 'dot-white';
	      }
	    },
	    substitution_status: function substitution_status() {
	      return this.lesson.substitution_status ? JSON.parse(this.lesson.substitution_status) : {};
	    },
	    status: function status() {
	      return this.substitution_status[this.userCalendarId] ? this.substitution_status[this.userCalendarId].status : null;
	    },
	    othersOnLessonAbsence: function othersOnLessonAbsence() {
	      return this.othersOnLesson.filter(function (user) {
	        return user.v_isUserAbsentFromLesson && user.v_isUserAbsentFromLesson.length > 0;
	      }).map(function (user) {
	        return user.user_calendar_id;
	      });
	    },
	    getIsUserSubstituted: function getIsUserSubstituted() {
	      var _this = this;
	
	      var isUserSubstituted = this.lesson.calendar_events.some(function (calEvent) {
	        return calEvent.substitute_for_user_id === _this.user.id;
	      });
	      return isUserSubstituted;
	    }
	  },
	  data: function data() {
	    return {
	      showDropdown: false,
	      isSubmitting: false
	    };
	  },
	
	  watch: {
	    statusProp: function statusProp(val, oldVal) {
	      this.setStatus(this.statusProp);
	    }
	  },
	  methods: {
	    setStatusForAll: function setStatusForAll() {
	      var _this2 = this;
	
	      this.isSubmitting = true;
	      var calendarIds = [this.userCalendarId];
	      var otherAbsentUsers = JSON.parse((0, _stringify2.default)(this.othersOnLessonAbsence));
	      var allCalendarIds = calendarIds.concat(otherAbsentUsers);
	      var statusData = (0, _extends3.default)({}, this.substitution_status);
	      allCalendarIds.forEach(function (id) {
	        statusData[id] = { 'status': 1 };
	      });
	      _docendo2.default.updateEvent(this.lesson.school_id, this.lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this2.$store.commit('updateSubStatusOnEvent', {
	          'eventId': _this2.lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	        _this2.isSubmitting = false;
	        _this2.closeDropDown();
	      });
	    },
	    setStatus: function setStatus(num) {
	      var _this3 = this;
	
	      this.isSubmitting = true;
	      var statusData = (0, _extends3.default)({}, this.substitution_status);
	
	      if (num === 0) {
	        if (!statusData[this.userCalendarId]) {
	          this.isSubmitting = false;
	          this.closeDropDown();
	          return;
	        }
	        delete statusData[this.userCalendarId];
	      } else {
	        statusData[this.userCalendarId] = { status: num };
	      }
	      var payload = {
	        substitution_status: (0, _stringify2.default)(statusData)
	      };
	      _docendo2.default.updateEvent(this.lesson.school_id, this.lesson.id, payload, function (success) {
	        if (success) {
	          _this3.$store.commit('updateSubStatusOnEvent', {
	            eventId: _this3.lesson.id,
	            status: payload.substitution_status
	          });
	        } else {
	          console.error('Failed to update substitution status');
	        }
	
	        _this3.isSubmitting = false;
	        _this3.closeDropDown();
	      });
	    },
	    closeDropDown: function closeDropDown() {
	      if (!this.showDropdown) {
	        return;
	      }
	      this.showDropdown = false;
	    }
	  }
	};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _entries = __webpack_require__(37);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _vuedraggable = __webpack_require__(137);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    draggable: _vuedraggable2.default
	  },
	  props: {
	    propsIsPrioritizerActive: {
	      default: false
	    }
	  },
	  watch: {
	    propsIsPrioritizerActive: function propsIsPrioritizerActive(val) {
	      this.setIsPrioritizerActive(val);
	    }
	  },
	  data: function data() {
	    return {
	      isPrioritizerActive: false,
	      isEditable: true,
	      isChangeHasBeenMade: false,
	      list: [],
	      translations: {
	        othersOnLesson: this.$t('vue2.sub_scheduler.already_on_lesson'),
	        isInSameClassAtTheSameTime: this.$t('vue2.sub_scheduler.is_in_same_class_at_the_same_time'),
	        multipleLessonsInSameClasses: this.$t('vue2.sub_scheduler.multiple_lessons_in_same_classes'),
	        availableHour: this.$t('vue2.sub_scheduler.not_occupied_with_available_lesson'),
	        presence: this.$t('vue2.sub_scheduler.not_occupied_with_work_hours'),
	        notOccupiedWithLessonsOnDay: this.$t('vue2.sub_scheduler.not_occupied_without_work_hours'),
	        severalOnALesson: this.$t('vue2.sub_scheduler.multiple_on_a_lesson'),
	        notOccupiedWithoutLessonsOnDay: this.$t('vue2.sub_scheduler.not_occupied_without_lessons_on_the_day'),
	        occupied: this.$t('vue2.sub_scheduler.occupied'),
	        absence: this.$t('vue2.sub_scheduler.absent_people')
	      }
	    };
	  },
	
	  computed: {
	    dragOptions: function dragOptions() {
	      return {
	        animation: 0,
	        group: 'description',
	        disabled: false,
	        ghostClass: 'ghost'
	      };
	    },
	    storeSorting: function storeSorting() {
	      return this.$store.state.subs.sortingHierarchy;
	    },
	    sortingHierarchy: function sortingHierarchy() {
	      return (0, _entries2.default)(this.storeSorting).sort(function (a, b) {
	        return a[1] - b[1];
	      });
	    },
	    updatedList: function updatedList() {
	      return this.list.map(function (item, idx) {
	        return {
	          name: item[0], value: idx * 3
	        };
	      });
	    },
	    unAvailableItems: function unAvailableItems() {
	      return [['notOccupiedWithoutLessonsOnDay', 18], ['occupied', 21]];
	    }
	  },
	  methods: {
	    setIsPrioritizerActive: function setIsPrioritizerActive(boolean) {
	      if (boolean) {
	        this.list = this.sortingHierarchy.filter(function (item) {
	          return item[0] !== 'absence' && item[0] !== 'occupied' && item[0] !== 'notOccupiedWithoutLessonsOnDay';
	        });
	        this.isPrioritizerActive = true;
	        this.isChangeHasBeenMade = false;
	      } else {
	        this.isPrioritizerActive = false;
	      }
	      this.$emit('setIsPrioritizerActive', this.isPrioritizerActive);
	    },
	    getItemTitle: function getItemTitle(item) {
	      return this.translations[item] ? this.translations[item] : 'No title';
	    },
	    removeActiveEvent: function removeActiveEvent() {
	      this.$store.commit('setActiveUser', null);
	      this.$store.commit('setActiveEvent', null);
	      this.$store.dispatch('setActiveSchedulerEvent', {
	        'left': -10,
	        'right': -10,
	        'color': '',
	        'oldSubScoreMeta': [],
	        'obj': null
	      });
	    },
	    onChange: function onChange() {
	      this.isChangeHasBeenMade = true;
	    },
	    onSave: function onSave() {
	      if (!this.isChangeHasBeenMade) {
	        return;
	      }
	      var updatedObj = this.updatedList.reduce(function (obj, item) {
	        return (0, _assign2.default)(obj, (0, _defineProperty3.default)({}, item.name, item.value));
	      }, {});
	      this.$store.dispatch('updateSortingHierarchy', updatedObj);
	      this.removeActiveEvent();
	      this.setIsPrioritizerActive(false);
	    }
	  }
	};

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    styleObj: function styleObj() {
	      return this.$store.state.subs.schedulerActiveEvent;
	    }
	  }
	};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    name: 'Navn',
	    pools: 'Vikarpulje (høj til lav)',
	    poolsAsc: 'Vikarpulje (lav til høj)',
	    workHours: 'Arbejdstid',
	    proposals: 'Forslag',
	    sort_by: 'Sortering af vikarer'
	  },
	  nb: {
	    name: 'Navn',
	    pools: 'Vikarpulje (høy til lav)',
	    poolsAsc: 'Vikarpulje (lav til høy)',
	    workHours: 'Arbeidstid',
	    proposals: 'Suggestions',
	    sort_by: 'Sorter vikarer'
	  },
	  en: {
	    name: 'Name',
	    pools: 'Substitute pool (high to low)',
	    poolsAsc: 'Substitute pool (low to high)',
	    workHours: 'Work hours',
	    proposals: 'Forslag',
	    sort_by: 'Sort substitutes by'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    selected: {
	      default: 'name'
	    },
	    locale: {
	      default: 'da'
	    }
	  },
	  computed: {
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    selectedI18n: function selectedI18n() {
	      var _this = this;
	
	      var selectedOptions = this.options.find(function (option) {
	        return option.value === _this.selected;
	      });
	      return selectedOptions.name || '';
	    },
	    options: function options() {
	      return [{ value: 'subzen', name: this.i18n['proposals'], selected: this.selected === 'subzen' }, { value: 'name', name: this.i18n['name'], selected: this.selected === 'name' }, { value: 'pools', name: this.i18n['pools'], selected: this.selected === 'pools' }, { value: 'poolsAsc', name: this.i18n['poolsAsc'], selected: this.selected === 'poolsAsc' }, { value: 'workHours', name: this.i18n['workHours'], selected: this.selected === 'workHours' }];
	    }
	  },
	  methods: {
	    select: function select(selected) {
	      this.$emit('onSortBy', selected);
	    }
	  }
	};

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    item: {},
	    itemBCR: {}
	  },
	  computed: {
	    posTop: function posTop() {
	      return this.itemBCR.top - 15;
	    },
	    itemSubPool: function itemSubPool() {
	      return this.item.current_user_year && this.item.current_user_year.substitute_pool_hours || 0;
	    },
	    itemSubPoolDiff: function itemSubPoolDiff() {
	      return (this.itemSubPool - this.item.substituteHours).toFixed(1);
	    }
	  }
	};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _SubsCreate = __webpack_require__(1356);
	
	var _SubsCreate2 = _interopRequireDefault(_SubsCreate);
	
	var _SubsUser = __webpack_require__(1363);
	
	var _SubsUser2 = _interopRequireDefault(_SubsUser);
	
	var _AppFlipperButtons = __webpack_require__(347);
	
	var _AppFlipperButtons2 = _interopRequireDefault(_AppFlipperButtons);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DoFilters = __webpack_require__(115);
	
	var _DoFilters2 = _interopRequireDefault(_DoFilters);
	
	var _Scheduler = __webpack_require__(1347);
	
	var _Scheduler2 = _interopRequireDefault(_Scheduler);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SubsEventSplit = __webpack_require__(1361);
	
	var _SubsEventSplit2 = _interopRequireDefault(_SubsEventSplit);
	
	var _SubsNote = __webpack_require__(1362);
	
	var _SubsNote2 = _interopRequireDefault(_SubsNote);
	
	var _EventChanges = __webpack_require__(116);
	
	var _EventChanges2 = _interopRequireDefault(_EventChanges);
	
	var _AppModal = __webpack_require__(131);
	
	var _AppModal2 = _interopRequireDefault(_AppModal);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SchedulerPrioritizer = __webpack_require__(1350);
	
	var _SchedulerPrioritizer2 = _interopRequireDefault(_SchedulerPrioritizer);
	
	var _SubsAbsentWithoutEnd = __webpack_require__(1355);
	
	var _SubsAbsentWithoutEnd2 = _interopRequireDefault(_SubsAbsentWithoutEnd);
	
	var _SubsEditAbsence = __webpack_require__(1360);
	
	var _SubsEditAbsence2 = _interopRequireDefault(_SubsEditAbsence);
	
	var _SubsUserPanel = __webpack_require__(1364);
	
	var _SubsUserPanel2 = _interopRequireDefault(_SubsUserPanel);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _CreateTask = __webpack_require__(1233);
	
	var _CreateTask2 = _interopRequireDefault(_CreateTask);
	
	var _OutOfSchool = __webpack_require__(1343);
	
	var _OutOfSchool2 = _interopRequireDefault(_OutOfSchool);
	
	var _DFilters = __webpack_require__(348);
	
	var _DFilters2 = _interopRequireDefault(_DFilters);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _DModalOutOfSchoolLesson = __webpack_require__(311);
	
	var _DModalOutOfSchoolLesson2 = _interopRequireDefault(_DModalOutOfSchoolLesson);
	
	var _SchedulerSort = __webpack_require__(1352);
	
	var _SchedulerSort2 = _interopRequireDefault(_SchedulerSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SchedulerSort: _SchedulerSort2.default,
	    DModalOutOfSchoolLesson: _DModalOutOfSchoolLesson2.default,
	    DoFiltersFilter: _DoFiltersFilter2.default,
	    DFilters: _DFilters2.default,
	    OutOfSchool: _OutOfSchool2.default,
	    CreateTask: _CreateTask2.default,
	    SubsUserPanel: _SubsUserPanel2.default,
	    SchedulerPrioritizer: _SchedulerPrioritizer2.default,
	    scheduler: _Scheduler2.default,
	    SubsUser: _SubsUser2.default,
	    filterTags: _TaggingFilter2.default,
	    DatePicker: _DateSelector2.default,
	    SubstitutionCreate: _SubsCreate2.default,
	    appFlipperButton: _AppFlipperButtons2.default,
	    appToggleButton: _AppToggle2.default,
	    spinner: _Loader2.default,
	    splitLesson: _SubsEventSplit2.default,
	    AppModal: _AppModal2.default,
	    SubsNote: _SubsNote2.default,
	    EventChanges: _EventChanges2.default,
	    SubsAbsentWithoutEnd: _SubsAbsentWithoutEnd2.default,
	    SubsEditAbsence: _SubsEditAbsence2.default,
	    DoFilters: _DoFilters2.default
	  },
	  data: function data() {
	    return {
	      selectedSort: 'name',
	      localSchedulerView: true,
	      selectedQuickFilters: [],
	      appliedFilters: [],
	      appliedFiltersAbsentUsers: [],
	      selectedUser: null,
	      sortOnName: true,
	      isSortOnSubPools: false,
	      sortOnSubPoolsAsc: true,
	      sortOnDayPresence: false,
	      activeSplitLesson: null,
	      activeDSelect: null,
	      isModal: false,
	      userAndLessonAndSubsToBeDeleted: {
	        user: {},
	        lesson: {},
	        subToBeRemoved: {},
	        subsForTheSubToBeRemoved: []
	      },
	      eventChangesEvent: null,
	      isFilterAbsentUsersWithHandledLessons: false,
	      absentFilter: '',
	      createEventOnUser: null,
	      isModalOutOfSchool: false,
	      theOutOfSchoolLesson: null,
	      isPrioritizerActive: false
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isTestingCreateAKU: function isTestingCreateAKU() {
	      var schoolIds = [7272, 60494, 60598, 60032, 61476, 62676];
	      return schoolIds.indexOf(this.schoolId) !== -1;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    allEvents: function allEvents() {
	      return this.$store.state.subs.allEvents;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    allUsersAndEvents: function allUsersAndEvents() {
	      return this.$store.state.subs.allUsersAndEvents;
	    },
	    allCalendarsInAHash: function allCalendarsInAHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    longAbsentListInHash: function longAbsentListInHash() {
	      return this.$store.getters.longAbsentListInHash;
	    },
	    calsAndEventIds: function calsAndEventIds() {
	      return this.$store.state.subs.allCalsWithEventIdsInHash;
	    },
	    absentUsersHandledHash: function absentUsersHandledHash() {
	      return this.$store.getters.absentUsersHandledHash;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    }
	  }, (0, _vuex.mapGetters)(['allUsersSortedOnName', 'userSet', 'absentUsersFromUserSet', 'notAbsentUsersFromUserSet', 'allUsersInCalIdHash', 'absentUsersUnhandled', 'absentUsersHandled', 'isSubStatusPendingActive', 'usersWithOngoingAbsenceInHash']), {
	    i18n: function i18n() {
	      return {
	        da: {
	          filters_saved_locally: 'Filtre gemt lokalt på din enhed',
	          remove_subs: 'Fjern følgende vikarer',
	          substitutes_for: 'Fjern følgende vikarer for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' på ' + this.userAndLessonAndSubsToBeDeleted.lesson.title,
	          has_to_remove_subs: 'Du er ved at fjerne en vikar, som har fået vikardækket lektionen af en anden vikar. Før du kan fortsætte, skal vikarer for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' fjernes.',
	          click_on_remove_all: 'Klik \'fjern alle\' for at gøre dette.',
	          button_text: 'Fjern alle',
	          absent_today: 'Fraværende i dag',
	          absent_handled: 'Håndterede',
	          absent_unhandled: 'Ikke-håndterede',
	          absent: 'Fraværende'
	        },
	        en: {
	          filters_saved_locally: 'Filters saved locally on your device',
	          remove_subs: 'Remove substitute teachers',
	          substitutes_for: 'Remove substitutes for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' in ' + this.userAndLessonAndSubsToBeDeleted.lesson.title,
	          has_to_remove_subs: 'You are about to delete a substitute teacher that has been substituted by another substitute teacher. To continue, the substitute teacher for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' has to be removed',
	          click_on_remove_all: 'Press \'remove all\' to continue.',
	          button_text: 'Remove all',
	          absent_today: 'Absent today',
	          absent_handled: 'Handled',
	          absent_unhandled: 'Unhandled',
	          absent: 'Absent'
	        },
	        nb: {
	          filters_saved_locally: 'Filtre lagret lokalt på enheten din',
	          remove_subs: 'Fjern vikar',
	          substitutes_for: 'Fjern vikarer for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' i ' + this.userAndLessonAndSubsToBeDeleted.lesson.title,
	          has_to_remove_subs: 'Du kommer nå til å fjerne en vikar som har blitt erstattet av en annen vikar. For å fortsette skal vikarer for  ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' fjernes',
	          click_on_remove_all: 'Klikk på \'fjern alle\' for å gjennomføre dette.',
	          button_text: 'Fjern alle',
	          absent_today: 'Fraværende i dag',
	          absent_handled: 'Håndtert',
	          absent_unhandled: 'Ikke håndtert',
	          absent: 'Fraværende'
	        }
	      };
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    userCanSeeInternalNote: function userCanSeeInternalNote() {
	      var lang = this.locale;
	      if (!lang || lang.toLowerCase() === 'en') {
	        return false;
	      }
	      return this.userHasPermission('can_manage_school');
	    },
	    dataIsLoading: function dataIsLoading() {
	      return this.$store.state.subs.dataIsLoading;
	    },
	    sortSubs: function sortSubs() {
	      return this.$store.state.subs.sortSubs;
	    },
	    activeTab: function activeTab() {
	      return this.localSchedulerView ? 1 : 0;
	    },
	    allUsers: function allUsers() {
	      return this.$store.state.subs.allUsers;
	    },
	    getDate: function getDate() {
	      return this.$store.state.subs.date;
	    },
	    isSubScoreActive: function isSubScoreActive() {
	      return this.$store.state.subs.isSortSubActive;
	    },
	    text: function text() {
	      return this.$t('vue2.sub_scheduler.absent_people') + ': ' + this.filteredAbsentUsers.length + ' ' + this.$t('vue2.sub_scheduler.out_of') + ' ' + this.absentUsersFromUserSet.length;
	    },
	    subsHeadline: function subsHeadline() {
	      return this.$t('vue2.sub_scheduler.potential_substitutes') + ': ' + this.filteredNotAbsentUsers.filter(function (user) {
	        return !user.headline;
	      }).length;
	    },
	    isToday: function isToday() {
	      return _moment2.default.utc().format('YYYY-MM-DD') === (0, _moment2.default)(this.getDate).format('YYYY-MM-DD');
	    },
	    absentUsers: function absentUsers() {
	      if (this.absentFilter === 'unhandled') {
	        return this.absentUsersUnhandled;
	      } else if (this.absentFilter === 'handled') {
	        return this.absentUsersHandled;
	      } else {
	        return this.absentUsersFromUserSet;
	      }
	    },
	    filteredAbsentUsers: function filteredAbsentUsers() {
	      var _this = this;
	
	      var passedUsers = this.absentUsers;
	      if (this.appliedFiltersAbsentUsers.length > 0) {
	        passedUsers = passedUsers.filter(function (user) {
	          return user.headline || user.user_tags.some(function (tag) {
	            return _this.appliedFiltersAbsentUsers.includes(tag);
	          });
	        });
	      }
	      return passedUsers;
	    },
	    filteredNotAbsentUsers: function filteredNotAbsentUsers() {
	      var _this2 = this;
	
	      var passedUsers = this.notAbsentUsersFromUserSet;
	      if (this.appliedFilters.length === 0 && this.selectedQuickFilters.length === 0) {
	        return passedUsers;
	      }
	
	      var isAvailableActive = this.selectedQuickFilters.includes('sub_events_available');
	      var isTwoInClassActive = this.selectedQuickFilters.includes('sub_events_two_in_some_class');
	
	      return passedUsers.filter(function (user) {
	        if (isAvailableActive && user.dayAvailability && user.dayAvailability.length > 0) {
	          return true;
	        }
	        if (isTwoInClassActive && (user.v_two_in_class_events && user.v_two_in_class_events.length > 0 || user.v_two_events_in_class_events && user.v_two_events_in_class_events.length > 0)) {
	          return true;
	        }
	        if (user.headline) {
	          return true;
	        }
	        var tagMatches = user.user_tags && user.user_tags.some(function (tag) {
	          return _this2.appliedFilters.includes(tag);
	        });
	        if (tagMatches) {
	          return true;
	        }
	      });
	    },
	    absentAndSubs: function absentAndSubs() {
	      var _this3 = this;
	
	      if (!this.localSchedulerView) return [];
	
	      var headline = {
	        name: this.$t('vue2.sub_scheduler.potential_subs'),
	        id: 12312312312312313123123123,
	        dayAbsence: [],
	        dayPresence: [],
	        dayEvents: [],
	        headline: true
	      };
	
	      var subs = [].concat((0, _toConsumableArray3.default)(this.filteredNotAbsentUsers));
	
	      var sortFunctions = {
	        subScore: function subScore(a, b) {
	          return b.subScore - a.subScore;
	        },
	        subPools: function subPools(a, b) {
	          return _this3.sortOnSubPoolsAsc ? a.subPoolsDiff - b.subPoolsDiff : b.subPoolsDiff - a.subPoolsDiff;
	        },
	        dayPresence: function dayPresence(a, b) {
	          return b.dayPresence.length - a.dayPresence.length;
	        },
	        name: function name() {
	          return _this3.$helpers.sortArrOnName(subs);
	        }
	      };
	
	      var shouldSort = this.isSubScoreActive && this.sortSubs !== 0 || !this.isSubScoreActive && this.isSortOnSubPools && this.sortSubs !== 0 || this.sortOnDayPresence || this.sortOnName;
	
	      if (shouldSort) {
	        subs = subs.filter(function (user) {
	          return !user.headline;
	        });
	
	        if (this.isSubScoreActive && this.sortSubs !== 0) {
	          subs.sort(sortFunctions.subScore);
	        } else if (this.isSortOnSubPools && this.sortSubs !== 0) {
	          subs.sort(sortFunctions.subPools);
	        } else if (this.sortOnDayPresence) {
	          subs.sort(sortFunctions.dayPresence);
	        } else if (this.sortOnName) {
	          sortFunctions.name();
	        }
	
	        subs.unshift(headline);
	      } else if (subs.length === 0 || !subs[0].headline) {
	        subs.unshift(headline);
	      }
	
	      return [].concat((0, _toConsumableArray3.default)(this.filteredAbsentUsers), (0, _toConsumableArray3.default)(subs));
	    },
	    activeAbsenceReason: function activeAbsenceReason() {
	      return this.$store.state.subs.activeAbsenceReason;
	    },
	    activeAbsentUser: function activeAbsentUser() {
	      return this.$store.state.subs.activeAbsentUser;
	    }
	  }),
	  watch: {
	    userSettings: function userSettings(val) {
	      this.applyUserSettings(val);
	    },
	    isSubScoreActive: function isSubScoreActive(val) {
	      this.sortOnName = !val;
	    }
	  },
	  methods: {
	    setTheOutOfSchoolLesson: function setTheOutOfSchoolLesson() {
	      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.theOutOfSchoolLesson = obj;
	    },
	    onOutOfSchoolLessonUpdated: function onOutOfSchoolLessonUpdated() {
	      this.setTheOutOfSchoolLesson(null);
	      this.readEvents();
	      this.$nextTick(function (_) {
	        var el = document.getElementById('djs-body-click');
	        if (el) {
	          el.click();
	        }
	      });
	    },
	    setIsModalOutOfSchool: function setIsModalOutOfSchool(bool) {
	      this.isModalOutOfSchool = bool;
	    },
	    setCreateEventOnUser: function setCreateEventOnUser(userAndDateObj) {
	      this.createEventOnUser = userAndDateObj;
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setActiveAbsentUser: function setActiveAbsentUser(user) {
	      this.$store.commit('setActiveAbsentUser', user);
	    },
	    setAbsentFilter: function setAbsentFilter(filter) {
	      this.absentFilter = filter;
	    },
	    isAbsentUserFilter: function isAbsentUserFilter(filter) {
	      return this.absentFilter === filter;
	    },
	    showEventLog: function showEventLog(event) {
	      this.eventChangesEvent = event;
	    },
	    setActiveDSelect: function setActiveDSelect(userAndLessonId) {
	      this.activeDSelect = userAndLessonId;
	    },
	    setRemoveSubsFromEvent: function setRemoveSubsFromEvent(userAndLessonAndSubsForUser) {
	      this.userAndLessonAndSubsToBeDeleted = userAndLessonAndSubsForUser;
	      this.isModal = true;
	    },
	    removeSubs: function removeSubs() {
	      var _this4 = this;
	
	      var lesson = this.userAndLessonAndSubsToBeDeleted.lesson;
	      this.userAndLessonAndSubsToBeDeleted.subsForTheSubToBeRemoved.forEach(function (sub) {
	        _this4.removeSub(_this4.allUsersInCalIdHash[sub], _this4.userAndLessonAndSubsToBeDeleted.subToBeRemoved, lesson);
	      });
	
	      this.removeSub(this.userAndLessonAndSubsToBeDeleted.subToBeRemoved, this.userAndLessonAndSubsToBeDeleted.user, lesson);
	      this.setSubStatusOnLesson(this.userAndLessonAndSubsToBeDeleted.user, this.userAndLessonAndSubsToBeDeleted.subToBeRemoved, lesson);
	      this.isModal = false;
	    },
	    removeSub: function removeSub(sub, subFor, lesson) {
	      var _this5 = this;
	
	      _docendo2.default.eventRemoveSubstitute(lesson.id, sub.id, subFor.id, function (data) {
	        _this5.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this5.$store.commit('removeEventOnAllUsersWithEvents', {
	          cal_id: sub.user_calendar_id,
	          event_id: lesson.id
	        });
	      });
	    },
	    setSubStatusOnLesson: function setSubStatusOnLesson(user, sub, lesson) {
	      var _this6 = this;
	
	      var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	      statusData[user.user_calendar_id] = { 'status': 0 };
	      statusData[sub.user_calendar_id] = { 'status': 0 };
	      _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this6.$store.commit('updateSubStatusOnEvent', {
	          'eventId': lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	      });
	    },
	    onSortBy: function onSortBy(selected) {
	      var saveInLocalStorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      this.resetSort();
	      this.selectedSort = selected;
	      if (selected === 'subzen') {
	        this.$store.commit('setIsSubScoreActive', true);
	      }
	      if (selected === 'pools') {
	        this.isSortOnSubPools = true;
	      }
	      if (selected === 'poolsAsc') {
	        this.isSortOnSubPools = true;
	        this.sortOnSubPoolsAsc = true;
	      }
	      if (selected === 'name') {
	        this.sortOnName = true;
	      }
	      if (selected === 'workHours') {
	        this.sortOnDayPresence = true;
	      }
	      this.$store.commit('setSortSubsAgain');
	      var saveSortSetting = { 'selectedSubSchedulerSorting': selected };
	      if (saveInLocalStorage) {
	        this.$store.dispatch('updateUserSettings', saveSortSetting);
	      }
	    },
	    resetSort: function resetSort() {
	      this.sortOnName = false;
	      this.isSortOnSubPools = false;
	      this.sortOnSubPoolsAsc = false;
	      this.sortOnDayPresence = false;
	      this.$store.commit('setIsSubScoreActive', false);
	    },
	    setIsSubScoreActive: function setIsSubScoreActive(boolean) {
	      this.$store.dispatch('updateIsSubZenActive', boolean);
	    },
	    setSchedulerView: function setSchedulerView(num) {
	      if (num === 1) {
	        this.localSchedulerView = true;
	        this.$helpers.removeLocalStorage('subListView');
	      } else {
	        this.localSchedulerView = false;
	        this.$helpers.setLocalStorage('subListView', true);
	      }
	      this.setActiveDSelect(null);
	    },
	    prevDay: function prevDay() {
	      this.$store.commit('setSubDate', (0, _moment2.default)(this.getDate).subtract(1, 'days'));
	      this.readEvents();
	      this.$store.dispatch('subsGetLongAbsenceList');
	      this.setActiveDSelect(null);
	    },
	    nextDay: function nextDay() {
	      this.$store.commit('setSubDate', (0, _moment2.default)(this.getDate).add(1, 'days'));
	      this.readEvents();
	      this.$store.dispatch('subsGetLongAbsenceList');
	      this.setActiveDSelect(null);
	    },
	    setToday: function setToday() {
	      this.$store.commit('setSubDate', _moment2.default.utc().format('YYYY-MM-DD'));
	      this.readEvents();
	      this.$store.dispatch('subsGetLongAbsenceList');
	      this.setActiveDSelect(null);
	    },
	    setDate: function setDate(date) {
	      this.$store.commit('setSubDate', date);
	      this.readEvents();
	      this.$store.dispatch('subsGetLongAbsenceList');
	      this.setActiveDSelect(null);
	    },
	    print: function print() {
	      window.print();
	    },
	    updateLocalStorage: function updateLocalStorage(keyStr, items) {
	      var key = keyStr + '_' + this.schoolId;
	      if (items.length > 0) {
	        this.$helpers.setLocalStorage(key, (0, _stringify2.default)(items));
	      } else {
	        this.$helpers.removeLocalStorage(key);
	      }
	    },
	    toggleQuickFilter: function toggleQuickFilter(quickFilter) {
	      var val = quickFilter.value;
	      var idx = this.selectedQuickFilters.indexOf(val);
	      if (idx > -1) {
	        this.selectedQuickFilters.splice(idx, 1);
	      } else {
	        this.selectedQuickFilters.push(val);
	      }
	      this.updateLocalStorage('d_applied_event_filters_subs', this.selectedQuickFilters);
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.appliedFilters.push(tag);
	      this.updateLocalStorage('d_applied_filters_subs', this.appliedFilters);
	      _eventbus2.default.toast = { text: this.i18n[this.locale]['filters_saved_locally'], 'success': true, position: 'bottomLeft' };
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	      this.updateLocalStorage('d_applied_filters_subs', this.appliedFilters);
	    },
	    toggleTag: function toggleTag(tag) {
	      var idx = this.appliedFilters.indexOf(tag);
	      if (idx > -1) {
	        this.removeTagFromFilter(tag);
	      } else {
	        this.setTagFromFilter(tag);
	      }
	    },
	    clearAllTags: function clearAllTags() {
	      this.appliedFilters = [];
	      this.updateLocalStorage('d_applied_filters_subs', this.appliedFilters);
	      this.selectedQuickFilters = [];
	      this.updateLocalStorage('d_applied_event_filters_subs', this.selectedQuickFilters);
	    },
	    clearAllFiltersForSubs: function clearAllFiltersForSubs() {
	      this.clearAllTags();
	    },
	    setTagFromFilterOnAbsentUsers: function setTagFromFilterOnAbsentUsers(tag) {
	      this.appliedFiltersAbsentUsers.push(tag);
	      this.updateLocalStorage('d_applied_filters_absent', this.appliedFiltersAbsentUsers);
	      _eventbus2.default.toast = { text: this.i18n[this.locale]['filters_saved_locally'], 'success': true, position: 'bottomLeft' };
	    },
	    removeTagFromFilterOnAbsentUsers: function removeTagFromFilterOnAbsentUsers(tag) {
	      this.appliedFiltersAbsentUsers.splice(this.appliedFiltersAbsentUsers.indexOf(tag), 1);
	      this.updateLocalStorage('d_applied_filters_absent', this.appliedFiltersAbsentUsers);
	    },
	    toggleAbsentFilter: function toggleAbsentFilter(tag) {
	      var idx = this.appliedFiltersAbsentUsers.indexOf(tag);
	      if (idx > -1) {
	        this.removeTagFromFilterOnAbsentUsers(tag);
	      } else {
	        this.setTagFromFilterOnAbsentUsers(tag);
	      }
	    },
	    clearAllAbsentFilters: function clearAllAbsentFilters() {
	      this.appliedFiltersAbsentUsers = [];
	      this.updateLocalStorage('d_applied_filters_absent', this.appliedFiltersAbsentUsers);
	    },
	    getTags: function getTags() {
	      var _this7 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this7.tags = data;
	      });
	    },
	    setSplitLesson: function setSplitLesson(lesson) {
	      this.activeSplitLesson = lesson;
	    },
	    closeSplitLesson: function closeSplitLesson() {
	      this.activeSplitLesson = null;
	    },
	    onSubmittedSplitEvent: function onSubmittedSplitEvent() {
	      this.activeSplitLesson = null;
	      this.closeSchedulerPopover();
	    },
	    closeSchedulerPopover: function closeSchedulerPopover() {
	      this.$store.commit('setActiveUser', null);
	      this.$store.commit('setActiveEvent', null);
	      this.$store.dispatch('setActiveSchedulerEvent', {
	        'left': -10,
	        'right': -10,
	        'color': '',
	        'oldSubScoreMeta': this.subScoreMeta,
	        'obj': null
	      });
	    },
	    readEvents: function readEvents() {
	      var _this8 = this;
	
	      var checkIfUserIsMemberOfAllSchools = function checkIfUserIsMemberOfAllSchools(schoolIdsToCall) {
	        var userSchools = _this8.user && _this8.user.schools ? _this8.user.schools : null;
	        if (!userSchools) {
	          return true;
	        }
	        var userSchoolIds = userSchools.map(function (school) {
	          return school.id;
	        });
	
	        return schoolIdsToCall.every(function (id) {
	          return userSchoolIds.includes(id);
	        });
	      };
	      var activeSchoolId = this.schoolId * 1;
	
	      var isSchoolSorenKanneFaelles = activeSchoolId === 60494;
	      if (isSchoolSorenKanneFaelles) {
	        var schoolIdsFromSorenKanne = [60489, 60490, 60491, 60492, 60494];
	        var storeObj = {
	          schoolIds: schoolIdsFromSorenKanne,
	          isShowEventsFromOtherThanActiveSchool: true
	        };
	        this.$store.dispatch('readAllEvents', storeObj);
	        return;
	      }
	      var schoolIdsFromLillevang = [59488, 59489];
	      var schoolIdsFromHerlevBySkole = [57481, 17269];
	      var schoolIdsFromKildegaard = [23481, 57727];
	      var schoolsIdsFromBorneby = [60458, 60459, 60460, 60495];
	      var schoolIdsFromSolsort = [7272, 62084];
	      var isIdxInHerlevArr = schoolIdsFromHerlevBySkole.indexOf(activeSchoolId);
	      var isIdxInKildeArr = schoolIdsFromKildegaard.indexOf(activeSchoolId);
	      var isIdxInLillevangArr = schoolIdsFromLillevang.indexOf(activeSchoolId);
	      var isIdxInBornebyArr = schoolsIdsFromBorneby.indexOf(activeSchoolId);
	      var isIdsInSolsort = schoolIdsFromSolsort.indexOf(activeSchoolId);
	      if (isIdxInBornebyArr > -1) {
	        var _storeObj = {
	          schoolIds: schoolsIdsFromBorneby,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        this.$store.dispatch('readAllEvents', _storeObj);
	        return;
	      }
	      if (isIdsInSolsort > -1) {
	        var _storeObj2 = {
	          schoolIds: schoolIdsFromSolsort,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        this.$store.dispatch('readAllEvents', _storeObj2);
	        return;
	      }
	      if (isIdxInLillevangArr > -1) {
	        var _storeObj3 = {
	          schoolIds: schoolIdsFromLillevang,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        if (checkIfUserIsMemberOfAllSchools(schoolIdsFromLillevang)) {
	          this.$store.dispatch('readAllEvents', _storeObj3);
	        } else {
	          this.$store.dispatch('getAllDayEvents');
	        }
	        return;
	      }
	      if (isIdxInHerlevArr > -1) {
	        var _storeObj4 = {
	          schoolIds: schoolIdsFromHerlevBySkole,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        this.$store.dispatch('readAllEvents', _storeObj4);
	        return;
	      }
	      if (isIdxInKildeArr > -1) {
	        var _storeObj5 = {
	          schoolIds: schoolIdsFromKildegaard,
	          isShowEventsFromOtherThanActiveSchool: false
	        };
	        this.$store.dispatch('readAllEvents', _storeObj5);
	        return;
	      }
	      this.$store.dispatch('getAllDayEvents');
	    },
	    applyUserSettings: function applyUserSettings(val) {
	      if (!val) return;
	
	      var selectedSubSchedulerSorting = val.selectedSubSchedulerSorting,
	          isSubZenActive = val.isSubZenActive,
	          subZenOrder = val.subZenOrder;
	
	
	      if (selectedSubSchedulerSorting) {
	        this.onSortBy(selectedSubSchedulerSorting, false);
	      } else if (isSubZenActive) {
	        this.onSortBy('subzen', true);
	      }
	
	      if (subZenOrder) {
	        this.$store.commit('setSortingHierarchy', subZenOrder);
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.$store.dispatch('getUserSubPools');
	    this.$store.dispatch('subsGetLongAbsenceList');
	    var localStorageAppliedFiltersForSubs = this.$helpers.getLocalStorage('d_applied_filters_subs_' + this.schoolId);
	    var localStorageAppliedFiltersForAbsent = this.$helpers.getLocalStorage('d_applied_filters_absent_' + this.schoolId);
	    this.appliedFilters = localStorageAppliedFiltersForSubs ? JSON.parse(localStorageAppliedFiltersForSubs) : [];
	    this.appliedFiltersAbsentUsers = localStorageAppliedFiltersForAbsent ? JSON.parse(localStorageAppliedFiltersForAbsent) : [];
	    var localStorageAppliedEventFiltersForSubs = this.$helpers.getLocalStorage('d_applied_event_filters_subs_' + this.schoolId);
	    this.selectedQuickFilters = localStorageAppliedEventFiltersForSubs ? JSON.parse(localStorageAppliedEventFiltersForSubs) : [];
	    if (this.$helpers.getLocalStorage('subListView')) {
	      this.localSchedulerView = false;
	    }
	    this.applyUserSettings(this.userSettings);
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('getAllUsers');
	    this.$store.dispatch('getUsers');
	    this.readEvents();
	    this.getTags();
	  }
	};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(13);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  data: function data() {
	    return {
	      isOpen: false
	    };
	  },
	
	  filters: {
	    showDate: function showDate(date) {
	      return (0, _moment2.default)(date).format('dddd, D. MMM');
	    },
	    showTime: function showTime(date) {
	      return (0, _moment2.default)(date).format('LT');
	    },
	    date: function date(_date) {
	      return (0, _moment2.default)(_date).format('ll');
	    },
	    absenceDate: function absenceDate(date) {
	      return (0, _moment2.default)(date).format('DD. MMM, [kl]. LT');
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['longAbsentListInHash', 'usersWithOngoingAbsenceInHash', 'allUsersInCalIdHash']), {
	    absentUsers: function absentUsers() {
	      var _this = this;
	
	      if ((0, _keys2.default)(this.allUsersInCalIdHash).length < 1) {
	        return [];
	      }
	      var userArr = (0, _keys2.default)(this.usersWithOngoingAbsenceInHash);
	      var filteredNotExisting = userArr.filter(function (userCalId) {
	        return !_this.allUsersInCalIdHash[userCalId];
	      });
	      if (filteredNotExisting.length > 0) {
	        console.log('filteredNotExisting', filteredNotExisting);
	      }
	      var filteredUser = userArr.filter(function (userCalId) {
	        return _this.allUsersInCalIdHash[userCalId];
	      });
	      return filteredUser.map(function (userCalId) {
	        var user = {
	          name: _this.allUsersInCalIdHash[userCalId].name,
	          default_thumb_url: _this.allUsersInCalIdHash[userCalId].default_thumb_url,
	          reasons: _this.usersWithOngoingAbsenceInHash[userCalId].absenceArr.map(function (absenceId) {
	            return _this.longAbsentListInHash[absenceId];
	          })
	        };
	        return user;
	      });
	    },
	    absentUsersSorted: function absentUsersSorted() {
	      var _this2 = this;
	
	      return this.absentUsers.sort(function (a, b) {
	        return new Date(_this2.getAbsenceIsRunningOut(a)) - new Date(_this2.getAbsenceIsRunningOut(b));
	      });
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    absenceReasons: function absenceReasons() {
	      return this.$store.state.subs.absenceReasons;
	    },
	    absenceAutogeneratedToday: function absenceAutogeneratedToday() {
	      var _this3 = this;
	
	      var num = 0;
	      this.absentUsers.forEach(function (user) {
	        if (_this3.getIsUserAbsenceAutogeneratedToday(user)) {
	          num++;
	        }
	      });
	      return num;
	    },
	    textAbsenceCreatedAuto: function textAbsenceCreatedAuto() {
	      return this.$t('vue2.subs_ongoing_absence.auto_created');
	    },
	    allAbsenceEventInEventSerialIdsHash: function allAbsenceEventInEventSerialIdsHash() {
	      return this.$store.state.subs.allAbsenceEventInEventSerialIdsHash;
	    },
	    activeDate: function activeDate() {
	      return this.$store.state.subs.date;
	    }
	  }),
	  methods: {
	    getIsUserAbsenceAutogeneratedToday: function getIsUserAbsenceAutogeneratedToday(user) {
	      var _this4 = this;
	
	      var autoGeneratedToday = false;
	      user.reasons.forEach(function (reason) {
	        var absence = _this4.allAbsenceEventInEventSerialIdsHash[reason.event_serial_id];
	        if (!absence) {
	          return autoGeneratedToday;
	        }
	        var statusObj = absence.substitution_status ? JSON.parse(absence.substitution_status) : {};
	        var todayDate = (0, _moment2.default)(_this4.activeDate).format('YYYY-MM-DD');
	        var extendedDate = (0, _moment2.default)(statusObj['extended_at']).format('YYYY-MM-DD');
	        if (statusObj['extended_at'] && (0, _moment2.default)(extendedDate).isSame(todayDate)) {
	          autoGeneratedToday = true;
	        }
	      });
	      return autoGeneratedToday;
	    },
	    getReasonTitle: function getReasonTitle(reason) {
	      var idx = this.absenceReasons.findIndex(function (absenceSubject) {
	        return absenceSubject.id === reason.subject_id;
	      });
	      return idx > -1 ? this.absenceReasons[idx].name : '';
	    },
	    getSerialListItem: function getSerialListItem(reason) {
	      return this.longAbsentListInHash[reason.event_serial_id] || false;
	    },
	    getAbsenceIsRunningOut: function getAbsenceIsRunningOut(user) {
	      var end = null;
	      user.reasons.forEach(function (reason) {
	        if (!end || (0, _moment2.default)(reason.to_date).isBefore(end)) {
	          end = reason.to_date;
	        }
	      });
	      return end;
	    },
	    setTheEditAbsenceReason: function setTheEditAbsenceReason(reason) {
	      this.$store.commit('setActiveAbsenceReason', reason);
	    },
	    humanizeEndDate: function humanizeEndDate(user) {
	      _moment2.default.locale(window.USER.language);
	      var endDate = this.getAbsenceIsRunningOut(user);
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(endDate).endOf('day'));
	      return _moment2.default.duration(diff).humanize();
	    }
	  }
	};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AppModal = __webpack_require__(131);
	
	var _AppModal2 = _interopRequireDefault(_AppModal);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _SubsCreateDayPicker = __webpack_require__(1358);
	
	var _SubsCreateDayPicker2 = _interopRequireDefault(_SubsCreateDayPicker);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vuex = __webpack_require__(13);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DQuestionMark = __webpack_require__(349);
	
	var _DQuestionMark2 = _interopRequireDefault(_DQuestionMark);
	
	var _SubsCreateDSelect = __webpack_require__(1357);
	
	var _SubsCreateDSelect2 = _interopRequireDefault(_SubsCreateDSelect);
	
	var _AbsenceReasonsCreate = __webpack_require__(112);
	
	var _AbsenceReasonsCreate2 = _interopRequireDefault(_AbsenceReasonsCreate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    AbsenceReasonsCreate: _AbsenceReasonsCreate2.default,
	    SubsCreateDSelect: _SubsCreateDSelect2.default,
	    AppToggle: _AppToggle2.default, AppModal: _AppModal2.default, DModal: _DModal2.default, dSelect: _DSelect2.default, DatepickerRange: _DatePickerRange2.default, TimeChanger: _TimeChanger2.default, DaySelector: _SubsCreateDayPicker2.default, DQuestionMark: _DQuestionMark2.default
	  },
	  props: {
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    usersWithOngoingAbsenceInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    allUsersInCalIdHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    schoolId: {
	      default: null
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['subsAbsenceReasonsSorted', 'locale']), {
	    absentUsersWithOngoingAbsenceAlready: function absentUsersWithOngoingAbsenceAlready() {
	      var _this = this;
	
	      if (!this.isAbsenceOngoing) {
	        return [];
	      }
	
	      return this.usersAbsent.filter(function (absentUserCalId) {
	        return _this.usersWithOngoingAbsenceInHash[absentUserCalId];
	      }).map(function (absentUserCalId) {
	        var user = _this.allUsersInCalIdHash[absentUserCalId];
	        return user ? user.name : absentUserCalId;
	      });
	    },
	    text: function text() {
	      return '';
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    isUserLoaded: function isUserLoaded() {
	      return this.$store.state.isUserLoaded;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    dbEventStart: function dbEventStart() {
	      var date = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var time = this.startTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    dbEventEnd: function dbEventEnd() {
	      var date = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var time = this.endTime.locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    isStartDateSameDayAsEndDate: function isStartDateSameDayAsEndDate() {
	      return (0, _moment2.default)(this.startDate).format('YYYY-MM-DD') === (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	    },
	    isUserSelected: function isUserSelected() {
	      return this.usersAbsent.length > 0;
	    },
	    isReasonSelected: function isReasonSelected() {
	      return this.reason !== '';
	    },
	    getDate: function getDate() {
	      return this.$store.state.subs.date;
	    },
	    isOngoingAbsenceAllowed: function isOngoingAbsenceAllowed() {
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      return (0, _moment2.default)(endDate).isSameOrAfter(now);
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    },
	    saveKeyTooltip: function saveKeyTooltip() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>';
	    }
	  }),
	  data: function data() {
	    return {
	      isCreateAbsenceReason: false,
	      i18n: {
	        da: {
	          note_to_absence: 'Eventuel note til fraværet',
	          set_default_start_and_endtime: 'Sæt standard start- og sluttid',
	          standard_setting: 'Standard indstilling',
	          as_a_new_reason: 'som ny årsag',
	          already_has_ongoing_absence: 'har allerede løbende fravær'
	        },
	        en: {
	          note_to_absence: 'Note to absence',
	          set_default_start_and_endtime: 'Set default start and end time',
	          standard_setting: 'Standard setting',
	          as_a_new_reason: 'as a new absence',
	          already_has_ongoing_absence: 'already has ongoing absence'
	        },
	        nb: {
	          note_to_absence: 'Merknad til fravær',
	          set_default_start_and_endtime: 'Angi standard start- og sluttid',
	          standard_setting: 'Standardinnstilling',
	          as_a_new_reason: 'som en ny årsak',
	          already_has_ongoing_absence: 'har allerede pågående fravær'
	        }
	      },
	      noteForAbsentReason: '',
	      showModal: false,
	      showErrorMessages: false,
	      usersAbsent: [],
	      startDate: (0, _moment2.default)(),
	      endDate: (0, _moment2.default)(),
	      reason: '',
	      reasonCreated: '',
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      standardStartTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      standardEndTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      isAbsenceOngoing: false,
	      isShowSettings: false,
	      reasonSearchText: '',
	      isShowCreateAbsenceReasonButton: false,
	      isEventListenerForSubmitAdded: false
	    };
	  },
	
	  methods: {
	    onCloseDSelectAbsenceReasons: function onCloseDSelectAbsenceReasons() {
	      this.isShowCreateAbsenceReasonButton = false;
	    },
	    setIsShowCreateAbsenceReasonButton: function setIsShowCreateAbsenceReasonButton() {
	      var _this2 = this;
	
	      var idx = this.subsAbsenceReasonsSorted.findIndex(function (absenceReason) {
	        return absenceReason.name === _this2.reasonSearchText;
	      });
	      this.isShowCreateAbsenceReasonButton = this.reasonSearchText.length > 0 && idx < 0;
	    },
	    onSearchTextDebounced: function onSearchTextDebounced() {
	      this.setIsShowCreateAbsenceReasonButton();
	    },
	    setIsAbsenceRunning: function setIsAbsenceRunning(val) {
	      if (this.isAbsenceOngoing !== val) {
	        this.isAbsenceOngoing = !this.isAbsenceOngoing;
	      }
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setShowModal: function setShowModal() {
	      this.showModal = true;
	      this.addEventListenerSubmit();
	      if (this.userSettings) {
	        if (this.userSettings.subSettingsCreateTime) {
	          var start = (0, _moment2.default)(this.userSettings.subSettingsCreateTime.start);
	          var end = (0, _moment2.default)(this.userSettings.subSettingsCreateTime.end);
	          this.startTime = (0, _moment2.default)().set({ 'hour': (0, _moment2.default)(start).hour(), 'minutes': (0, _moment2.default)(start).minute() });
	          this.endTime = (0, _moment2.default)().set({ 'hour': (0, _moment2.default)(end).hour(), 'minutes': (0, _moment2.default)(end).minute() });
	          this.standardStartTime = this.startTime;
	          this.standardEndTime = this.endTime;
	        }
	      }
	      setTimeout(function (_) {
	        document.querySelector('#create_absence_user .d-select__input-look > input[type="search"]').focus();
	      }, 500);
	    },
	    addEventListenerSubmit: function addEventListenerSubmit() {
	      if (!this.isEventListenerForSubmitAdded) {
	        window.addEventListener('keydown', this.onHandleKeyboardShortcutSubmit);
	        window.addEventListener('keydown', this.onHandleKeyboardShortcutEsc);
	        this.isEventListenerForSubmitAdded = true;
	      }
	    },
	    removeEventListenerForSubmit: function removeEventListenerForSubmit() {
	      window.removeEventListener('keydown', this.onHandleKeyboardShortcutSubmit);
	      window.removeEventListener('keydown', this.onHandleKeyboardShortcutEsc);
	      this.isEventListenerForSubmitAdded = false;
	    },
	    closeModal: function closeModal() {
	      this.showModal = false;
	      this.showErrorMessages = false;
	      this.isAbsenceOngoing = false;
	      this.reasonSearchText = '';
	      this.isShowCreateAbsenceReasonButton = false;
	      this.removeEventListenerForSubmit();
	    },
	    createAbsenceReason: function createAbsenceReason(titleAndDefaultPrivate) {
	      var _this3 = this;
	
	      var title = titleAndDefaultPrivate.title;
	      var defaultPrivate = titleAndDefaultPrivate.defaultPrivate;
	      _docendo2.default.schoolAbsenceSubjectsCreate(this.schoolId, title, '#564437', defaultPrivate, function (data) {
	        _this3.$store.commit('subsAddNewAbsenceReason', data);
	        _this3.reasonCreated = data;
	        _this3.isCreateAbsenceReason = false;
	      }, function (failure) {
	        console.log('Failed', failure);
	      });
	    },
	    setReasonSearchText: function setReasonSearchText(text) {
	      this.reasonSearchText = text;
	    },
	    setUsers: function setUsers(users) {
	      this.usersAbsent = users.map(function (user) {
	        return user.user_calendar_id;
	      });
	    },
	    setReason: function setReason(reason) {
	      this.reason = reason[0];
	
	      var schoolIdsWithAutoOngoingAbsenceOnSick = [54378, 7272, 60032, 60494, 61476];
	      var isActivated = schoolIdsWithAutoOngoingAbsenceOnSick.indexOf(this.schoolId) > -1;
	      var reasonName = reason[0] && reason[0].name ? reason[0].name.toLowerCase() : '';
	      if (isActivated && reason[0] && (reasonName === 'syg' || reasonName === 'sygdom (sy)' || reasonName === 'fravær')) {
	        this.isAbsenceOngoing = true;
	      }
	    },
	    setStartDate: function setStartDate(payload) {
	      this.startDate = payload;
	    },
	    setEndDate: function setEndDate(payload) {
	      this.endDate = payload;
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    setStandardStartTime: function setStandardStartTime(payload) {
	      this.standardStartTime = payload;
	    },
	    setStandardEndTime: function setStandardEndTime(payload) {
	      this.standardEndTime = payload;
	    },
	    submitUser: function submitUser() {
	      var _this4 = this;
	
	      if (!this.isUserSelected || !this.isReasonSelected) {
	        this.showErrorMessages = true;
	        return;
	      }
	      if (!this.isOngoingAbsenceAllowed) {
	        this.isAbsenceOngoing = false;
	      }
	      var currDate = (0, _moment2.default)(this.getDate).format('YYYY-MM-DD');
	      var absenceStart = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var absenceEnd = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var absenceOverlapsCurrentDate = (0, _moment2.default)(currDate).isBetween(absenceStart, absenceEnd, null, []);
	      var startTime = this.startTime.second(0).millisecond(0).toISOString();
	      var endTime = this.endTime.second(0).millisecond(0).toISOString();
	      this.usersAbsent.forEach(function (userCalendarId) {
	        _docendo2.default.schoolEventSerialsCreate(window.SCHOOL.id, userCalendarId, _this4.reason.id, absenceStart, absenceEnd, startTime, endTime, _this4.isAbsenceOngoing, _this4.noteForAbsentReason, function (data) {
	          var parsedEvent = JSON.parse(data);
	
	          if (absenceOverlapsCurrentDate) {
	            _this4.$store.commit('updateEventOnAllEventsInAHash', parsedEvent.events[0]);
	            _this4.$store.commit('addAbsenceToUserInAllUsersWithEvents', {
	              cal_id: parsedEvent.calendar_id,
	              event_id: parsedEvent.events[0].id
	            });
	          }
	          _this4.$store.dispatch('subsGetLongAbsenceList');
	        });
	      });
	      this.showModal = false;
	      this.showErrorMessages = false;
	      this.clearForm();
	      this.$emit('created');
	    },
	    clearForm: function clearForm() {
	      this.startDate = (0, _moment2.default)();
	      this.endDate = (0, _moment2.default)();
	      this.startTime = (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 });
	      this.endTime = (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 });
	      this.reason = '';
	      this.noteForAbsentReason = '';
	      this.showErrorMessages = false;
	      this.isAbsenceOngoing = false;
	    },
	    submitStandardSettings: function submitStandardSettings() {
	      var standardSubsCreateTime = { 'subSettingsCreateTime': { start: this.standardStartTime, end: this.standardEndTime } };
	      this.$store.dispatch('updateUserSettings', standardSubsCreateTime);
	      var start = this.standardStartTime;
	      var end = this.standardEndTime;
	      this.startTime = (0, _moment2.default)().set({ 'hour': (0, _moment2.default)(start).hour(), 'minutes': (0, _moment2.default)(start).minute() });
	      this.endTime = (0, _moment2.default)().set({ 'hour': (0, _moment2.default)(end).hour(), 'minutes': (0, _moment2.default)(end).minute() });
	      this.isShowSettings = false;
	    },
	    onHandleKeyboardShortcutSubmit: function onHandleKeyboardShortcutSubmit(e) {
	      if (this.showModal && (e.ctrlKey || e.metaKey) && e.key === 'Enter') {
	        e.preventDefault();
	        this.submitUser();
	      }
	    },
	    onHandleKeyboardShortcutEsc: function onHandleKeyboardShortcutEsc(e) {
	      if (e.key === 'Escape') {
	        e.preventDefault();
	        this.closeModal();
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('subsGetAbsenceReasons');
	    this._keyListener = function (e) {
	      if (e.key === 'n') {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.setShowModal();
	        }
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeEventListenerForSubmit();
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DSelect: _DSelect2.default },
	  props: {
	    items: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    },
	    itemsSelected: {
	      default: function _default() {
	        return [];
	      },
	      type: Array
	    }
	  },
	  data: function data() {
	    return {
	      tags: []
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return window.SCHOOL && window.SCHOOL.id;
	    },
	    dSelectItems: function dSelectItems() {
	      return this.items.concat(this.tagsForSelect);
	    },
	    tagsForSelect: function tagsForSelect() {
	      var tags = [];
	      var i = 0;
	      this.tags.forEach(function (tag) {
	        i++;
	        var oneTag = {
	          tag: true,
	          id: 999999999999 + i,
	          name: tag,
	          icon: 'icon-price-tag2'
	        };
	        tags.push(oneTag);
	      });
	      return tags;
	    }
	  },
	  methods: {
	    sendUpdate: function sendUpdate($event) {
	      this.$emit('update', $event);
	    },
	    getTags: function getTags() {
	      var _this = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this.tags = data;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.getTags();
	  }
	};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { appToogler: _AppToggle2.default },
	  data: function data() {
	    return {
	      isSelectorActive: false,
	      selectedDays: []
	    };
	  },
	
	  computed: {
	    weekDays: function weekDays() {
	      var weekDaysNumbers = [1, 2, 3, 4, 5, 6, 7];
	      var weekDays = weekDaysNumbers.map(function (num) {
	        return (0, _moment2.default)().isoWeekday(num);
	      });
	      var days = weekDays.map(function (mom) {
	        return {
	          date: mom,
	          isoWeekDay: (0, _moment2.default)(mom).isoWeekday()
	        };
	      });
	      return days;
	    }
	  },
	  filters: {
	    ddd: function ddd(date) {
	      return (0, _moment2.default)(date).format('dddd');
	    }
	  },
	  methods: {
	    setSelectorActive: function setSelectorActive(Boolean) {
	      this.isSelectorActive = Boolean;
	      console.log('true', Boolean);
	    },
	    isInList: function isInList(day) {
	      return this.selectedDays.indexOf(day.isoWeekDay) > -1;
	    },
	    toggleDay: function toggleDay(day, idx) {
	      if (this.selectedDays.indexOf(day.isoWeekDay) < 0) {
	        this.selectedDays.push(day.isoWeekDay);
	      } else {
	        this.selectedDays.splice(this.selectedDays.indexOf(day.isoWeekDay), 1);
	      }
	    }
	  }
	};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Lesson = __webpack_require__(1271);
	
	var _Lesson2 = _interopRequireDefault(_Lesson);
	
	var _vuex = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, Lesson: _Lesson2.default },
	  props: {
	    calendarId: {},
	    firstRange: {},
	    lastRange: {},
	    dates: {
	      default: function _default() {
	        return [];
	      }
	    },
	    startTime: {},
	    endTime: {}
	  },
	  data: function data() {
	    return {
	      events: [],
	      eventsWithSubstitutes: [],
	      eventsToRemovedSubs: [],
	      isLoading: true
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allUsersInHash', 'allUsersInCalIdHash', 'allKlassCalendarsInHash', 'allCalendarsInHash']), {
	    sortedEvents: function sortedEvents() {
	      var arr = this.eventsWithSubstitutes;
	      return arr.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    eventsSortedInDays: function eventsSortedInDays() {
	      var sortedEventsInDays = this.sortedEvents.reduce(function (acc, curr, index) {
	        var val = (0, _moment2.default)(curr['start']).format('YYYY-MM-DD');
	        acc[val] = acc[val] || [];
	        acc[val].push(curr);
	        return acc;
	      }, {});
	      return this.eventsToArr(sortedEventsInDays);
	    }
	  }),
	  watch: {
	    dates: function dates() {
	      this.getAllEventsInPeriod();
	    },
	    eventsWithSubstitutes: function eventsWithSubstitutes(val) {
	      this.$emit('lessonsWithSubs', val);
	    }
	  },
	  methods: {
	    setDbDateTime: function setDbDateTime(inputDate, dayTime) {
	      var date = (0, _moment2.default)(inputDate).format('YYYY-MM-DD');
	      var time = (0, _moment2.default)(dayTime).locale('LT');
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    readEvents: function readEvents(start, end) {
	      var _this = this;
	
	      var dbStart = this.setDbDateTime(start, (0, _moment2.default)().startOf('day'));
	      var dbEnd = this.setDbDateTime(end, (0, _moment2.default)().endOf('day'));
	      _docendo2.default.eventsFromCalendars([this.calendarId], dbStart, dbEnd, null, function (success) {
	        _this.isLoading = false;
	        var data = success && success.length > 0 ? JSON.parse(success) : [];
	        data.forEach(function (lesson) {
	          _this.events.push(lesson);
	          lesson.calendars.forEach(function (calendar) {
	            if (calendar.substitute && calendar.substitute === _this.allUsersInCalIdHash[_this.calendarId].id) {
	              _this.eventsWithSubstitutes.push(lesson);
	              _this.toggleEvent(lesson);
	            }
	          });
	        });
	        _this.$emit('gotLessons', true);
	      }, function (failure) {
	        console.log('failed', failure);
	      });
	    },
	    eventsToArr: function eventsToArr(events) {
	      return (0, _keys2.default)(events).map(function (e) {
	        return { date: e, events: events[e] };
	      });
	    },
	    getSubstitute: function getSubstitute(event) {
	      var _this2 = this;
	
	      var subs = event.calendars.filter(function (calendar) {
	        return calendar.substitute === _this2.allUsersInCalIdHash[_this2.calendarId].id;
	      });
	      return subs.map(function (calendar) {
	        return _this2.allUsersInCalIdHash[calendar.calendar_id];
	      });
	    },
	    getClasses: function getClasses(event) {
	      var _this3 = this;
	
	      return event.calendars.filter(function (calendar) {
	        return _this3.allKlassCalendarsInHash[calendar.calendar_id];
	      }).map(function (calendar) {
	        return _this3.allKlassCalendarsInHash[calendar.calendar_id];
	      });
	    },
	    isInEventsToRemovedSubs: function isInEventsToRemovedSubs(lesson) {
	      var idx = this.eventsToRemovedSubs.findIndex(function (currentEvent) {
	        return currentEvent.event_id === lesson.event_id;
	      });
	      return idx > -1;
	    },
	    toggleEvent: function toggleEvent(lesson) {
	      var idx = this.eventsToRemovedSubs.findIndex(function (currentEvent) {
	        return currentEvent.event_id === lesson.event_id;
	      });
	      if (idx < 0) {
	        this.eventsToRemovedSubs.push(lesson);
	      } else {
	        this.eventsToRemovedSubs.splice(idx, 1);
	      }
	      this.$emit('changed', this.eventsToRemovedSubs);
	    },
	    toggleAll: function toggleAll() {
	      var _this4 = this;
	
	      if (this.eventsToRemovedSubs.length > 0) {
	        this.eventsToRemovedSubs = [];
	      } else {
	        this.eventsWithSubstitutes.forEach(function (event) {
	          return _this4.eventsToRemovedSubs.push(event);
	        });
	      }
	      this.$emit('changed', this.eventsToRemovedSubs);
	    },
	    getAllEventsInPeriod: function getAllEventsInPeriod() {
	      this.events = [];
	      if (this.firstRange.length > 0) {
	        this.readEvents(this.firstRange[0], this.firstRange[1]);
	      }
	      if (this.lastRange.length > 0) {
	        this.readEvents(this.lastRange[0], this.lastRange[1]);
	      }
	      if (!this.firstRange && !this.lastRange && this.dates) {
	        var moments = this.dates.map(function (d) {
	          return (0, _moment2.default)(d);
	        });
	        var startDate = _moment2.default.min(moments);
	        var endDate = _moment2.default.max(moments);
	        if (this.dates.length === 1) {
	          this.readEvents((0, _moment2.default)(this.dates[0]).startOf('day'), (0, _moment2.default)(this.dates[0]).endOf('day'));
	        } else {
	          this.readEvents((0, _moment2.default)(startDate).startOf('day'), (0, _moment2.default)(endDate).endOf('day'));
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.getAllEventsInPeriod();
	  }
	};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _vue2Datepicker = __webpack_require__(136);
	
	var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);
	
	__webpack_require__(1156);
	
	__webpack_require__(1790);
	
	var _vuex = __webpack_require__(13);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubsDeleteAbsenceSubs = __webpack_require__(1359);
	
	var _SubsDeleteAbsenceSubs2 = _interopRequireDefault(_SubsDeleteAbsenceSubs);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _SubsUserAbsenceReason = __webpack_require__(87);
	
	var _SubsUserAbsenceReason2 = _interopRequireDefault(_SubsUserAbsenceReason);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DQuestionMark = __webpack_require__(349);
	
	var _DQuestionMark2 = _interopRequireDefault(_DQuestionMark);
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DModal: _DModal2.default,
	    DatePicker: _vue2Datepicker2.default,
	    SubsDeleteAbsence: _SubsDeleteAbsenceSubs2.default,
	    DatepickerRange: _DatePickerRange2.default,
	    SubsUserAbsenceReason: _SubsUserAbsenceReason2.default,
	    AppToggle: _AppToggle2.default,
	    DQuestionMark: _DQuestionMark2.default,
	    TimeChanger: _TimeChanger2.default,
	    DSelect: _DSelect2.default
	  },
	  data: function data() {
	    return {
	      originalStartAndEnd: [],
	      eventsToRemovedSubs: [],
	      isLessonsLoaded: false,
	      datePickerStart: null,
	      datePickerEnd: null,
	      startAndEnd: [],
	      isAbsenceOngoing: false,
	      lessonsWithSubs: [],
	      startTime: (0, _moment2.default)().set({ 'hour': 8, 'minutes': 0 }),
	      endTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      reason: [],
	      showErrors: false
	    };
	  },
	
	  filters: {
	    showDate: function showDate(date) {
	      return (0, _moment2.default)(date).format('DD. MMM, LT');
	    },
	    showTime: function showTime(date) {
	      return (0, _moment2.default)(date).format('LT');
	    },
	    date: function date(_date) {
	      return (0, _moment2.default)(_date).format('ll');
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allUsersInCalIdHash', 'longAbsentListInHash', 'subsAbsenceReasonsSorted']), {
	    activeAbsenceReason: function activeAbsenceReason() {
	      return this.$store.state.subs.activeAbsenceReason;
	    },
	    isActiveAbsenceReasonIsReadyToDelete: function isActiveAbsenceReasonIsReadyToDelete() {
	      return this.$store.state.subs.isActiveAbsenceReasonIsReadyToDelete;
	    },
	    showUser: function showUser() {
	      return this.allUsersInCalIdHash[this.activeAbsenceReason.calendar_id];
	    },
	    absenceReasons: function absenceReasons() {
	      return this.$store.state.subs.absenceReasons;
	    },
	    originalStart: function originalStart() {
	      return (0, _moment2.default)(this.originalStartAndEnd[0]).format('YYYY-MM-DD');
	    },
	    originalEnd: function originalEnd() {
	      return (0, _moment2.default)(this.originalStartAndEnd[1]).format('YYYY-MM-DD');
	    },
	    originalDatesArr: function originalDatesArr() {
	      return this.enumerateDaysBetweenDates(this.originalStart, this.originalEnd);
	    },
	    datePickerDatesArr: function datePickerDatesArr() {
	      var start = (0, _moment2.default)(this.datePickerStart).format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(this.datePickerEnd).format('YYYY-MM-DD');
	      return this.enumerateDaysBetweenDates(start, end);
	    },
	    originalDatesNotInNewRange: function originalDatesNotInNewRange() {
	      var _this = this;
	
	      return this.originalDatesArr.filter(function (e) {
	        return _this.datePickerDatesArr.indexOf(e) === -1;
	      });
	    },
	    originalDatesNotInNewRangeMinimum: function originalDatesNotInNewRangeMinimum() {
	      var moments = this.originalDatesNotInNewRange.map(function (d) {
	        return (0, _moment2.default)(d);
	      });
	      var date = _moment2.default.min(moments);
	      var datepickerStart = (0, _moment2.default)(this.datePickerStart).format('YYYY-MM-DD');
	      if (this.datePickerStart) {
	        return (0, _moment2.default)(date).isBefore(this.datePickerStart) ? [date, (0, _moment2.default)(datepickerStart).subtract(1, 'day')] : false;
	      } else {
	        return false;
	      }
	    },
	    originalDatesNotInNewRangeMaximum: function originalDatesNotInNewRangeMaximum() {
	      var moments = this.originalDatesNotInNewRange.map(function (d) {
	        return (0, _moment2.default)(d);
	      });
	      var date = _moment2.default.max(moments);
	      var datepickerEnd = (0, _moment2.default)(this.datePickerEnd).format('YYYY-MM-DD');
	      return (0, _moment2.default)(date).isAfter(this.datePickerEnd) ? [(0, _moment2.default)(datepickerEnd).add(1, 'day'), date] : false;
	    },
	    deleteAbsenceFollowingDates: function deleteAbsenceFollowingDates() {
	      return this.originalDatesNotInNewRange;
	    },
	    getSerialListItem: function getSerialListItem() {
	      return this.activeAbsenceReason.event_serial_id ? this.longAbsentListInHash[this.activeAbsenceReason.event_serial_id] : false;
	    },
	    isOngoing: function isOngoing() {
	      return this.getSerialListItem && this.getSerialListItem.ongoing;
	    },
	    isOngoingAbsenceAllowed: function isOngoingAbsenceAllowed() {
	      var endDate = (0, _moment2.default)(this.startAndEnd[1]).format('YYYY-MM-DD');
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      return (0, _moment2.default)(endDate).isSameOrAfter(now);
	    }
	  }),
	  watch: {
	    isActiveAbsenceReasonIsReadyToDelete: function isActiveAbsenceReasonIsReadyToDelete() {
	      if (this.isActiveAbsenceReasonIsReadyToDelete) {
	        this.datePickerStart = null;
	        this.datePickerEnd = null;
	      }
	    }
	  },
	  methods: {
	    getIsAbsenceMultipleDays: function getIsAbsenceMultipleDays() {
	      var serialItem = this.getSerialListItem;
	      return serialItem && (0, _moment2.default)(serialItem.from_date).format('YYYY-MM-DD') !== (0, _moment2.default)(serialItem.to_date).format('YYYY-MM-DD');
	    },
	    setDeleteSubs: function setDeleteSubs(val) {
	      this.eventsToRemovedSubs = val;
	    },
	    enumerateDaysBetweenDates: function enumerateDaysBetweenDates(startDate, endDate) {
	      var date = [];
	      while ((0, _moment2.default)(startDate) <= (0, _moment2.default)(endDate)) {
	        date.push(startDate);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days').format('YYYY-MM-DD');
	      }
	      return date;
	    },
	    getReasonTitle: function getReasonTitle(reason) {
	      var idx = this.absenceReasons.findIndex(function (absenceSubject) {
	        return absenceSubject.id === reason.subject_id;
	      });
	      return idx > -1 ? this.absenceReasons[idx].name : '';
	    },
	    removeSubsAndUpdateAbsence: function removeSubsAndUpdateAbsence() {
	      var vuexObj = {
	        events: this.eventsToRemovedSubs,
	        userId: this.showUser.id,
	        user_calendar_id: this.activeAbsenceReason.calendar_id
	      };
	      this.$store.dispatch('removeSubsFromEvents', vuexObj);
	      this.updateDates();
	    },
	    updateDates: function updateDates() {
	      if (!this.reason[0]) {
	        this.showErrors = true;
	        return;
	      }
	      var obj = JSON.parse((0, _stringify2.default)(this.activeAbsenceReason));
	      obj['from_date'] = this.datePickerStart;
	      obj['to_date'] = this.datePickerEnd;
	      obj['ongoing'] = this.isAbsenceOngoing;
	      obj['to_time'] = this.endTime;
	      obj['from_time'] = this.startTime;
	      obj['subject_id'] = this.reason[0].id;
	      this.$store.dispatch('updateEventsSerial', obj);
	      this.close();
	    },
	    close: function close() {
	      this.$store.commit('setActiveAbsenceReason', null);
	      this.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', false);
	    },
	    removeSubsAndDeleteAbsence: function removeSubsAndDeleteAbsence() {
	      var obj = {
	        events: this.eventsToRemovedSubs,
	        userId: this.showUser.id,
	        user_calendar_id: this.activeAbsenceReason.calendar_id
	      };
	      this.$store.dispatch('removeSubsFromEvents', obj);
	      var reasonObj = {
	        event_serial_id: this.activeAbsenceReason.event_serial_id,
	        user_calendar_id: this.activeAbsenceReason.calendar_id,
	        id: this.activeAbsenceReason.id
	      };
	      this.$store.dispatch('deleteAbsence', reasonObj);
	      this.closeSchedulerPopover();
	      this.close();
	    },
	    setStartDate: function setStartDate(payload) {
	      this.datePickerStart = (0, _moment2.default)(payload).format('YYYY-MM-DD');
	      this.setStartAndEnd();
	    },
	    setEndDate: function setEndDate(payload) {
	      this.datePickerEnd = (0, _moment2.default)(payload).format('YYYY-MM-DD');
	      this.setStartAndEnd();
	
	      var endDate = (0, _moment2.default)(payload).format('YYYY-MM-DD');
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      if (!(0, _moment2.default)(endDate).isSameOrAfter(now)) {
	        this.isAbsenceOngoing = false;
	      }
	    },
	    setStartTime: function setStartTime(payload) {
	      this.startTime = payload;
	    },
	    setEndTime: function setEndTime(payload) {
	      this.endTime = payload;
	    },
	    setStartAndEnd: function setStartAndEnd() {
	      this.startAndEnd = [(0, _moment2.default)(this.datePickerStart).format('YYYY-MM-DD'), (0, _moment2.default)(this.datePickerEnd).format('YYYY-MM-DD')];
	    },
	    setLessonsWithSubs: function setLessonsWithSubs(arr) {
	      this.lessonsWithSubs = arr;
	    },
	    setReason: function setReason(reason) {
	      this.reason = reason;
	      this.showErrors = false;
	    },
	    closeSchedulerPopover: function closeSchedulerPopover() {
	      this.$store.commit('setActiveUser', null);
	      this.$store.commit('setActiveEvent', null);
	      this.$store.dispatch('setActiveSchedulerEvent', {
	        'left': -10,
	        'right': -10,
	        'color': '',
	        'oldSubScoreMeta': [],
	        'obj': null
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this2 = this;
	
	    var startTime = this.getSerialListItem ? this.getSerialListItem.from_time : this.activeAbsenceReason.start;
	    this.startTime = (0, _moment2.default)(startTime).locale('LT');
	    var endTime = this.getSerialListItem ? this.getSerialListItem.to_time : this.activeAbsenceReason.end;
	    this.endTime = (0, _moment2.default)(endTime).locale('LT');
	    var idx = this.absenceReasons.findIndex(function (absenceSubject) {
	      return absenceSubject.id === _this2.activeAbsenceReason.subject_id;
	    });
	    this.reason = [this.absenceReasons[idx]];
	    if (this.activeAbsenceReason.event_serial_id) {
	      var reason = this.longAbsentListInHash[this.activeAbsenceReason.event_serial_id];
	      this.originalStartAndEnd = [reason.from_date, reason.to_date];
	      this.isAbsenceOngoing = reason.ongoing;
	      return;
	    }
	    if (this.activeAbsenceReason.from_date) {
	      this.originalStartAndEnd = [new Date(this.activeAbsenceReason.from_date), new Date(this.activeAbsenceReason.to_date)];
	    } else {
	      this.originalStartAndEnd = [this.activeAbsenceReason.start, this.activeAbsenceReason.end];
	    }
	  }
	};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TimeInput = __webpack_require__(135);
	
	var _TimeInput2 = _interopRequireDefault(_TimeInput);
	
	var _AppModal = __webpack_require__(131);
	
	var _AppModal2 = _interopRequireDefault(_AppModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	
	exports.default = {
	  components: { AppModal: _AppModal2.default, timeInput: _TimeInput2.default },
	  props: {
	    user: {
	      type: Object
	    },
	    lesson: {
	      type: Object
	    }
	  },
	  filters: {
	    LT: function LT(dateTime) {
	      return moment(dateTime).format('LT');
	    },
	    showDate: function showDate(dateTime) {
	      return moment(dateTime).format('dddd, D. MMM');
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    newCurrentLessonEnd: function newCurrentLessonEnd() {
	      return moment(this.newLessonStart);
	    },
	    oldDuration: function oldDuration() {
	      var duration = moment.duration(moment(this.lesson.end).diff(this.lesson.start));
	      return duration.asMinutes();
	    },
	    newLessonDuration: function newLessonDuration() {
	      var duration = moment.duration(moment(this.lesson.end).diff(this.newLessonStart));
	      return duration.asMinutes();
	    },
	    lessonDuration: function lessonDuration() {
	      var duration = moment.duration(this.newCurrentLessonEnd.diff(this.lesson.start));
	      return duration.asMinutes();
	    }
	  },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          split: 'Opdel',
	          original_lesson: 'Nuværende lektion',
	          duration: 'Varighed',
	          minutes: 'minutter',
	          when_is_the_split: 'På hvilket tidspunkt vil du dele lektion i to?',
	          everything_will_be_cloned: 'Alt ved den oprindelige brik bliver kopieret dvs. undervisere, vikarer, noter osv.',
	          split_lessons: 'Lektionen vil så blive delt til flg. lektioner: ',
	          btn: 'Opdel lektion'
	        },
	        nb: {
	          split: 'Del opp',
	          original_lesson: 'Nåværende time',
	          duration: 'Lengde',
	          minutes: 'minutter',
	          when_is_the_split: 'På hvilket tidspunkt skal timen deles i to?',
	          everything_will_be_cloned: 'Alt i den opprinnelige timen blir kopiert dvs. undervisere, vikarer, notater osv.',
	          split_lessons: 'Timen vil så bli delt opp til følgende timer: ',
	          btn: 'Del opp timen'
	        },
	        en: {
	          split: 'Split',
	          original_lesson: 'Original lesson',
	          duration: 'Duration',
	          minutes: 'minutes',
	          when_is_the_split: 'At what time should the lesson be split in two?',
	          everything_will_be_cloned: 'All information from the original lesson will be copied i.e. teachers, substitutes, notes etc.',
	          split_lessons: 'The lesson will be divided into the following lessons:',
	          btn: 'Split lesson'
	        }
	      },
	      showModal: true,
	      newLessonStart: 8,
	      newLessonEnd: this.lesson.end,
	      isSubmitting: false
	    };
	  },
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.isSubmitting = true;
	      _docendo2.default.splitEvent(this.lesson.id, moment(this.newLessonStart).toISOString(), function (data) {
	        JSON.parse(data).forEach(function (lesson) {
	          _this.allEventsInAHash[lesson.id] ? _this.$store.commit('updateEventOnAllEventsInAHash', lesson) : _this.$store.commit('addANewEvent', lesson);
	        });
	        _this.isSubmitting = false;
	        _this.$emit('submitted');
	        _this.showModal = false;
	      }, function (failure) {
	        console.log('failure', failure);
	      });
	    },
	    closeModal: function closeModal() {
	      this.$emit('closeSplitEvent');
	      this.showModal = false;
	    },
	    setStartTime: function setStartTime(val) {
	      var number = moment(val, 'LT');
	      if (isNaN(number)) {
	        this.newLessonStart = this.newLessonStart;
	        return;
	      } else {
	        var hours = moment(number).format('HH');
	        var minutes = Math.round(moment(number).format('mm') / 5) * 5;
	        var _newDate = moment(this.newLessonStart).set({ 'hour': hours, 'minute': minutes });
	        if (hours * 1 === 23 && minutes * 1 === 55) {
	          _newDate = moment(this.newLessonStart).set({ 'hour': hours, 'minute': 50 });
	        }
	
	        if (moment(_newDate).isSameOrBefore(this.lesson.start)) {
	          this.newLessonStart = this.newLessonStart;
	          return;
	        }
	        if (moment(_newDate).isSameOrAfter(this.lesson.end)) {
	          this.newLessonStart = this.newLessonStart;
	          return;
	        }
	        this.newLessonStart = _newDate;
	      }
	    },
	    createInitialSplit: function createInitialSplit() {
	      var start = this.lesson.start;
	      var end = this.lesson.end;
	      var diffInMinutes = moment(end).diff(moment(start), 'minutes');
	
	      var minutes = Math.round(diffInMinutes / 2 / 5) * 5;
	      this.newLessonStart = moment(this.lesson.end).subtract(minutes, 'minutes');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.createInitialSplit();
	  },
	  created: function created() {
	    this.$nextTick(function () {
	      document.getElementById('focus').focus();
	    });
	  }
	};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppEIPWYZIWYG = __webpack_require__(45);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppEIPWYZIWYG: _AppEIPWYZIWYG2.default },
	  props: {
	    date: {}
	  },
	  data: function data() {
	    return {
	      isOpen: false,
	      noteText: ''
	    };
	  },
	
	  watch: {
	    date: function date(val) {
	      this.readNoteText();
	    }
	  },
	  computed: {
	    showDate: function showDate() {
	      return (0, _moment2.default)(this.date).locale(window.USER.locale).format('dddd DD. MMMM YYYY');
	    },
	    serverDate: function serverDate() {
	      return (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	    }
	  },
	  methods: {
	    readNoteText: function readNoteText() {
	      var _this = this;
	
	      _docendo2.default.schoolSubstituteDayNoteRead(window.SCHOOL.id, this.serverDate, function (data) {
	        _this.noteText = data.note ? data.note : '';
	      });
	    },
	    updateNoteText: function updateNoteText(updatedText) {
	      var _this2 = this;
	
	      _docendo2.default.schoolSubstituteDayNoteUpdate(window.SCHOOL.id, this.serverDate, updatedText.text, function (success) {
	        _this2.noteText = success.note;
	      }, function (failure) {
	        console.log('failed!');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readNoteText();
	  }
	};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(38);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(37);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SubsUserAbsenceReason = __webpack_require__(87);
	
	var _SubsUserAbsenceReason2 = _interopRequireDefault(_SubsUserAbsenceReason);
	
	var _DSelectSubsSub = __webpack_require__(1249);
	
	var _DSelectSubsSub2 = _interopRequireDefault(_DSelectSubsSub);
	
	var _AppEIPWYZIWYG = __webpack_require__(45);
	
	var _AppEIPWYZIWYG2 = _interopRequireDefault(_AppEIPWYZIWYG);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(35);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = (0, _momentRange.extendMoment)(_moment2.default);
	var I18N = {
	  da: {
	    subject: 'Fag',
	    class: 'Klasse',
	    other_users: 'I samme tidsrum',
	    substitute: 'Vikar',
	    substitute_notes: 'Vikarnoter',
	    todays_lessons: 'Dagens lektioner',
	    see_all: 'Se alle',
	    see_less: 'Se færre',
	    search: 'Søg på person',
	    multiple_days: 'Flere dage',
	    lessons_on_day: 'Lektioner på dagen',
	    lessons_affected_by_absence: 'Lektioner påvirket af fravær',
	    absent: 'Fraværende',
	    reason: 'Årsag',
	    absent_period: 'Fraværsperiode',
	    note: 'Note',
	    split_lesson: 'Opdel lektion',
	    same_time: 'I samme tidsrum',
	    on_the_lesson: 'Underviser',
	    same_time_in_class: 'Samtidig i klassen',
	    view_all: 'Se alle',
	    view_less: 'Se færre',
	    view_all_lessons: 'Se alle lektioner',
	    view_less_lessons: 'Se færre lektioner',
	    log: 'Historik',
	    user_not_found: 'Brugeren er fjernet fra skolen',
	    absent_handled: 'Håndteret',
	    ongoing_absence: 'Løbende fravær',
	    auto_created: 'Oprettet Automatisk',
	    see_calendar: 'Se kalender',
	    add_sub_to_multiple_lessons: 'Vikardæk flere lektioner'
	  },
	  en: {
	    subject: 'Subject',
	    class: 'Class',
	    other_users: 'Other users',
	    substitute: 'Substitute',
	    substitute_notes: 'Substitute notes',
	    todays_lessons: 'Todays lessons',
	    see_all: 'View all',
	    see_less: 'View less',
	    search: 'Search',
	    multiple_days: 'Multiple days',
	    lessons_on_day: 'Lessons this day',
	    lessons_affected_by_absence: 'Lessons affected by absence',
	    absent: 'Absent',
	    reason: 'Reason',
	    absent_period: 'Period of absence',
	    note: 'Note',
	    note_for_absent: 'Note for absent',
	    split_lesson: 'Split lesson in two',
	    same_time: 'At the same time',
	    on_the_lesson: 'Teachers',
	    same_time_in_class: 'In the same class',
	    view_all: 'View all',
	    view_less: 'View less',
	    view_all_lessons: 'View all lessons',
	    view_less_lessons: 'View fewer lessons',
	    log: 'Activity log',
	    user_not_found: 'User is removed from school',
	    absent_handled: 'Covered',
	    ongoing_absence: 'Ongoing absence',
	    auto_created: 'Autogenerated',
	    see_calendar: 'See calendar',
	    add_sub_to_multiple_lessons: 'Add substitute to multiple lessons'
	  },
	  nb: {
	    subject: 'Fag',
	    class: 'Klasse',
	    other_users: 'Også tilknyttet',
	    substitute: 'Vikar',
	    substitute_notes: 'Vikarnotater',
	    todays_lessons: 'Dagens timer',
	    see_all: 'Se alle',
	    see_less: 'Se mindre',
	    search: 'Søk etter person',
	    multiple_days: 'Flere dager',
	    lessons_on_day: 'Undervisningstimer denne dag',
	    lessons_affected_by_absence: 'Timer påvirket av fravær',
	    absent: 'Fraværende',
	    reason: 'Årsak',
	    absent_period: 'Fraværsperiode',
	    note: 'Notat',
	    note_for_absent: 'Eventuell notat til fraværet',
	    split_lesson: 'Del opp timen',
	    same_time: 'I samme tidsrom',
	    on_the_lesson: 'Undervisere',
	    same_time_in_class: 'Samtidig i klassen',
	    view_all: 'Se alle',
	    view_less: 'Se færre',
	    view_all_lessons: 'Se alle timer',
	    view_less_lessons: 'Se færre timer',
	    log: 'Historikk',
	    user_not_found: 'Brukeren er fjernet fra skolen',
	    absent_handled: 'Håndtert',
	    ongoing_absence: 'Løpende lengre fravær',
	    auto_created: 'Opprettet automatisk',
	    see_calendar: 'Se kalender',
	    add_sub_to_multiple_lessons: 'Legg til vikar for flere leksjoner'
	  }
	};
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { DDropdown: _DDropdown2.default, DSelectSub: _DSelectSubsSub2.default, weip: _AppEIPWYZIWYG2.default, AbsenceReason: _SubsUserAbsenceReason2.default },
	  props: {
	    user: {},
	    activeDSelect: {
	      type: String,
	      default: null
	    },
	    allEvents: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    allEventsInAHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    allUsersAndEvents: {
	      type: Object,
	      default: function _default() {}
	    },
	    allCalendarsInAHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    allUsersSortedOnName: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    longAbsentListInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    date: {
	      type: [Object, String],
	      default: function _default() {
	        return moment();
	      }
	    },
	    calsAndEventIds: {
	      type: Object,
	      default: function _default() {}
	    },
	    absentUsersHandledHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isSubmittingAbsenceStatus: false,
	      activeEIP: [],
	      showOtherOnLesson: -1,
	      showDSub: -1,
	      searchText: '',
	      occupiedUsers: [],
	      usersForDSelect: [],
	      subStatusDropdown: null,
	      isUpdatingPotentialSubs: false,
	      overlappingArr: [],
	      theActiveShowAllOtherOnLessonId: null,
	      theActiveShowOtherLessonsInKlassThatOverlap: null,
	      theActiveOtherLessonShowAllUsers: null,
	      theLoadingLessons: []
	    };
	  },
	
	  filters: {
	    showDate: function showDate(date) {
	      return moment(date).format('dddd, D. MMM');
	    },
	    showTime: function showTime(date) {
	      return moment(date).format('LT');
	    },
	    date: function date(_date) {
	      return moment(_date).format('ll');
	    },
	    absenceDate: function absenceDate(date) {
	      return moment(date).format('DD. MMM, [kl]. LT');
	    }
	  },
	  watch: {
	    date: function date() {
	      this.resetAllFormData();
	    }
	  },
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    userLessons: function userLessons() {
	      var _this = this;
	
	      return this.user.dayEvents.map(function (eventId) {
	        return _this.allEventsInAHash[eventId];
	      });
	    },
	    countryIsDK: function countryIsDK() {
	      return window.SCHOOL.country === 'DK';
	    },
	    filterAbsentUser: function filterAbsentUser() {
	      var _this2 = this;
	
	      return this.allUsersSortedOnName.filter(function (user) {
	        return user.id !== _this2.user.id;
	      });
	    },
	    sortedEvents: function sortedEvents() {
	      var _this3 = this;
	
	      return this.userLessons.map(function (lesson) {
	        return (0, _extends3.default)({}, lesson, {
	          v_substituted: _this3.getIsUserSubstituted(lesson),
	          v_status: _this3.getSubstitutionStatusForUserCalId(lesson),
	          v_isLoading: _this3.getIsLessonLoading(lesson),
	          showAllOtherOnLesson: _this3.getIsShowAllOthersOnLesson(lesson),
	          klassesAndOther: lesson.calendar_events.filter(function (cal) {
	            return cal && (cal.calendar_type === 'klass' || cal.calendar_type === 'other');
	          }).map(function (calEvent) {
	            return (0, _extends3.default)({}, calEvent, {
	              url: window.location.origin + '/calendars/' + calEvent.calendar_id
	            });
	          }),
	          otherLessonsInKlassThatOverlap: _this3.otherLessonsInKlassThatOverlap(lesson),
	          showOtherLessonsInKlassThatOverlap: lesson.id === _this3.theActiveShowOtherLessonsInKlassThatOverlap
	        });
	      }).sort(function (a, b) {
	        return moment(a.start).unix() - moment(b.start).unix();
	      });
	    },
	    absenceReasons: function absenceReasons() {
	      var _this4 = this;
	
	      return this.user.dayAbsence.map(function (eventId) {
	        return _this4.allEventsInAHash[eventId];
	      });
	    },
	    userNotFoundPlaceholder: function userNotFoundPlaceholder() {
	      return {
	        id: 0,
	        name: this.i18n[this.locale]['user_not_found'],
	        type: 'user',
	        url: '/calendar',
	        calendar_id: 0,
	        dayAbsence: [],
	        dayEvents: [],
	        dayAllEvents: [],
	        isErrorUser: true,
	        default_thumb_url: '',
	        user_tags: [],
	        occupied: false,
	        isOnLesson: false,
	        currentEventId: 0,
	        user_calendar_id: 0
	      };
	    }
	  },
	  methods: {
	    schedulerUserHandledCls: function schedulerUserHandledCls(item) {
	      var userStatus = this.getIsUserAbsentHandled(item);
	      if (userStatus === 0) {
	        return 'dot-white';
	      }
	      if (userStatus === 2) {
	        return 'dot-yellow';
	      }
	    },
	    statusDotClass: function statusDotClass(lesson) {
	      if (lesson.v_status === 2) {
	        return 'dot-yellow';
	      }
	      if (lesson.v_status === 0) {
	        return 'dot-white';
	      }
	    },
	    getIsLessonLoading: function getIsLessonLoading(lesson) {
	      return this.theLoadingLessons.indexOf(lesson.id) > -1;
	    },
	    setOtherLessonShowAllUsers: function setOtherLessonShowAllUsers(lessonId) {
	      this.theActiveOtherLessonShowAllUsers = lessonId;
	    },
	    setShowOtherLessonsInKlassThatOverlap: function setShowOtherLessonsInKlassThatOverlap(lessonId) {
	      this.theActiveShowOtherLessonsInKlassThatOverlap = lessonId;
	    },
	    getIsAbsenceMultipleDays: function getIsAbsenceMultipleDays(reason) {
	      var serialItem = this.getSerialListItem(reason);
	      return serialItem && moment(serialItem.from_date).format('YYYY-MM-DD') !== moment(serialItem.to_date).format('YYYY-MM-DD');
	    },
	    getIsAbsenceAutoGenerated: function getIsAbsenceAutoGenerated(reason) {
	      var statusObj = reason.substitution_status ? JSON.parse(reason.substitution_status) : {};
	      return statusObj['extended_at'] && moment(statusObj['extended_at']).isSame(moment(this.date).format('YYYY-MM-DD'));
	    },
	    setActiveAbsentUser: function setActiveAbsentUser() {
	      this.$store.commit('setActiveAbsentUser', this.user);
	    },
	    setReadyToDelete: function setReadyToDelete(reason) {
	      this.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true);
	      this.$store.commit('setActiveAbsenceReason', reason);
	    },
	    showLog: function showLog(event) {
	      this.$emit('showLog', event);
	    },
	    getSubs: function getSubs(lesson) {
	      var _this5 = this;
	
	      var subCalIds = lesson.calendar_events.filter(function (event) {
	        return event.substitute && event.substitute_for_user_id === _this5.user.id;
	      });
	      return subCalIds.map(function (sub) {
	        return _this5.allUsersAndEvents[sub.calendar_id] ? _this5.allUsersAndEvents[sub.calendar_id] : _this5.userNotFoundPlaceholder;
	      });
	    },
	    isLessonOverlappingWithAbsence: function isLessonOverlappingWithAbsence(lesson) {
	      var _this6 = this;
	
	      this.absenceReasons.forEach(function (absence) {
	        var range1 = moment.range(lesson.start, lesson.end);
	        var range2 = moment.range(absence.start, absence.end);
	        if (range1.intersect(range2)) {
	          _this6.overlappingArr.indexOf(lesson.id) < 0 ? _this6.overlappingArr.push(lesson.id) : [];
	        }
	      });
	      return this.overlappingArr.indexOf(lesson.id) > -1;
	    },
	    setSubStatusDropdown: function setSubStatusDropdown(lessonId) {
	      this.subStatusDropdown = lessonId;
	    },
	    isSubStatusDropdown: function isSubStatusDropdown(lessonId) {
	      return this.subStatusDropdown === lessonId;
	    },
	    getIsUserSubstituted: function getIsUserSubstituted(lesson) {
	      var _this7 = this;
	
	      var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	        return calEvent.substitute_for_user_id === _this7.user.id;
	      });
	      if (isUserSubstituted) {
	        return true;
	      }
	    },
	    getSubstitutionStatusForUserCalId: function getSubstitutionStatusForUserCalId(lesson) {
	      var _this8 = this;
	
	      var statusObj = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	      var userStatus = statusObj[this.user.user_calendar_id] ? statusObj[this.user.user_calendar_id].status : 0;
	      if (this.isSubStatusPendingActive) {
	        return userStatus;
	      } else {
	        var isUserSubstituted = lesson.calendar_events.some(function (calEvent) {
	          return calEvent.substitute_for_user_id === _this8.user.id;
	        });
	        if (isUserSubstituted || userStatus === 1) {
	          return 1;
	        } else {
	          return 0;
	        }
	      }
	    },
	    setSubStatus: function setSubStatus(lesson, num) {
	      var _this9 = this;
	
	      this.pushLoadingLesson(lesson.id);
	      var statusData = (0, _extends3.default)({}, this.substitution_status);
	      if (num === 0) {
	        delete statusData[this.user.user_calendar_id];
	      } else {
	        statusData[this.user.user_calendar_id] = { status: num };
	      }
	      _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	        _this9.$store.commit('updateSubStatusOnEvent', {
	          'eventId': lesson.id,
	          'status': (0, _stringify2.default)(statusData)
	        });
	        _this9.spliceLoadingLesson(lesson.id);
	      });
	      this.closeSubStatusDropdown();
	    },
	    getIsUserAbsentHandled: function getIsUserAbsentHandled() {
	      return this.absentUsersHandledHash[this.user.id] ? this.absentUsersHandledHash[this.user.id] : 0;
	    },
	    setAbsenceStatus: function setAbsenceStatus(num) {
	      var _this10 = this;
	
	      this.isSubmittingAbsenceStatus = true;
	      if (this.user.dayEvents.length < 1) {
	        this.user.dayAbsence.forEach(function (lessonId) {
	          var lesson = _this10.allEventsInAHash[lessonId];
	          var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	          statusData[_this10.user.user_calendar_id] = { 'status': num };
	          _docendo2.default.updateEvent(lesson.school_id, lesson.id, { substitution_status: (0, _stringify2.default)(statusData) }, function (success) {
	            _this10.$store.commit('updateSubStatusOnEvent', {
	              'eventId': lesson.id,
	              'status': (0, _stringify2.default)(statusData)
	            });
	          });
	        });
	      } else {
	        var groupBySchoolId = function groupBySchoolId(lessons) {
	          return lessons.reduce(function (groups, lesson) {
	            var schoolId = lesson.school_id;
	            if (!groups[schoolId]) {
	              groups[schoolId] = [];
	            }
	            groups[schoolId].push(lesson);
	            return groups;
	          }, {});
	        };
	
	        var lessonsToUpdate = this.user.dayEvents.filter(function (lessonId) {
	          var lesson = _this10.allEventsInAHash[lessonId];
	          return !_this10.isSubStatusPendingActive ? !_this10.getIsUserSubstituted(lesson) : true;
	        }).map(function (lessonId) {
	          var lesson = _this10.allEventsInAHash[lessonId];
	          var statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {};
	          statusData[_this10.user.user_calendar_id] = { status: num };
	
	          return (0, _extends3.default)({}, lesson, {
	            substitution_status: (0, _stringify2.default)(statusData)
	          });
	        });
	
	        var groupedLessons = groupBySchoolId(lessonsToUpdate);
	
	        (0, _entries2.default)(groupedLessons).forEach(function (_ref) {
	          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	              schoolId = _ref2[0],
	              lessons = _ref2[1];
	
	          var eventsToUpdate = lessons.map(function (lesson) {
	            return {
	              event_id: lesson.id,
	              substitution_status: lesson.substitution_status
	            };
	          });
	
	          _docendo2.default.updateEvents(schoolId, eventsToUpdate, function (success) {
	            if (success) {
	              eventsToUpdate.forEach(function (event) {
	                _this10.$store.commit('updateSubStatusOnEvent', {
	                  eventId: event.event_id,
	                  status: event.substitution_status
	                });
	              });
	            } else {
	              console.error('Failed to update events for school_id: ' + schoolId);
	            }
	            setTimeout(function (_) {
	              _this10.isSubmittingAbsenceStatus = false;
	              _this10.closeSubStatusDropdown();
	            }, 0);
	          });
	        });
	      }
	    },
	    closeSubStatusDropdown: function closeSubStatusDropdown() {
	      this.subStatusDropdown = null;
	    },
	    isActiveEIP: function isActiveEIP(idx) {
	      return this.activeEIP.indexOf(idx) > -1;
	    },
	    setActiveEIP: function setActiveEIP(idx) {
	      if (this.activeEIP.indexOf(idx) < 0) {
	        this.activeEIP.push(idx);
	      }
	    },
	    isShowOtherOnLesson: function isShowOtherOnLesson(idx) {
	      return this.showOtherOnLesson === idx;
	    },
	    setShowOtherOnLesson: function setShowOtherOnLesson(lessonId) {
	      this.theActiveShowAllOtherOnLessonId = lessonId;
	    },
	    getIsShowAllOthersOnLesson: function getIsShowAllOthersOnLesson(lesson) {
	      return lesson.id === this.theActiveShowAllOtherOnLessonId;
	    },
	    subLessonsThatOverlap: function subLessonsThatOverlap(lesson, lessonsArr) {
	      var _this11 = this;
	
	      var filterCurrLesson = lessonsArr.filter(function (eventid) {
	        return eventid !== lesson.id;
	      });
	      var arr = filterCurrLesson.map(function (eventId) {
	        return _this11.allEventsInAHash[eventId];
	      });
	      var arrWithOutPresence = arr.filter(function (event) {
	        return event.event_type !== null;
	      });
	      return arrWithOutPresence.filter(function (dayLesson) {
	        var range1 = moment.range(dayLesson.start, dayLesson.end);
	        var range2 = moment.range(lesson.start, lesson.end);
	        return range1.intersect(range2);
	      });
	    },
	    textFromSubLessonsThatOverlap: function textFromSubLessonsThatOverlap(lesson, lessonsArr) {
	      var _this12 = this;
	
	      var filterCurrLesson = lessonsArr.filter(function (eventid) {
	        return eventid !== lesson.id;
	      });
	      var arr = filterCurrLesson.map(function (eventId) {
	        return _this12.allEventsInAHash[eventId];
	      });
	      var arrWithOutPResence = arr.filter(function (event) {
	        return event.event_type !== null;
	      });
	      var lessonsArrToTitles = arrWithOutPResence.filter(function (dayLesson) {
	        var range1 = moment.range(dayLesson.start, dayLesson.end);
	        var range2 = moment.range(lesson.start, lesson.end);
	        return range1.intersect(range2);
	      });
	      return lessonsArrToTitles.map(function (lesson) {
	        return lesson.title;
	      });
	    },
	    otherLessonsInKlassThatOverlap: function otherLessonsInKlassThatOverlap(lesson) {
	      var _this13 = this;
	
	      var cals = this.calsOnLesson(lesson);
	      var klassCals = cals.filter(function (cal) {
	        return cal && cal.type === 'klass';
	      });
	      var klassCalEventsIDs = klassCals.map(function (cal) {
	        return _this13.calsAndEventIds[cal.id];
	      });
	      var allEventsInKlass = klassCalEventsIDs.map(function (obj) {
	        return obj.lessons;
	      });
	      var lessonsInKlass = allEventsInKlass[0] ? allEventsInKlass[0].map(function (id) {
	        return _this13.allEventsInAHash[id];
	      }) : [];
	
	      return lessonsInKlass.filter(function (event) {
	        var range1 = moment.range(lesson.start, lesson.end);
	        var range2 = moment.range(event.start, event.end);
	        return event.id !== lesson.id && range1.overlaps(range2);
	      }).map(function (event) {
	        var usersOnEvent = event.calendar_events.flatMap(function (cal) {
	          return _this13.allUsersAndEvents[cal.calendar_id] || [];
	        });
	
	        return (0, _extends3.default)({}, event, {
	          showAllUsers: event.id === _this13.theActiveOtherLessonShowAllUsers,
	          users: usersOnEvent
	        });
	      });
	    },
	    setUsersForDSelect: function setUsersForDSelect() {
	      var _this14 = this;
	
	      this.filterAbsentUser.map(function (obj) {
	        var occ = false;
	        var isOnLesson = true;
	        var user = {
	          id: obj.id,
	          default_thumb_url: obj.default_thumb_url,
	          name: obj.name,
	          user_tags: obj.user_tags,
	          occupied: occ,
	          isOnLesson: isOnLesson,
	          currentEventId: 1,
	          user_calendar_id: obj.user_calendar_id
	        };
	        _this14.usersForDSelect.push(user);
	      });
	      this.usersForDSelect.push(this.userNotFoundPlaceholder);
	    },
	    updateUsersForList: function updateUsersForList(lesson) {
	      var _this15 = this;
	
	      this.usersForDSelect.forEach(function (obj, idx) {
	        _this15.usersForDSelect[idx].currentEventId = lesson.id;
	        _this15.usersForDSelect[idx].isOnLesson = _this15.othersOnLesson(lesson).filter(function (user) {
	          return user.id === obj.id;
	        }).length > 0;
	        if (_this15.occupiedUsers[obj.user_calendar_id]) {
	          _this15.usersForDSelect[idx].occupied = _this15.occupiedUsers[obj.user_calendar_id];
	        } else {
	          _this15.usersForDSelect[idx].occupied = false;
	        }
	        _this15.isUpdatingPotentialSubs = false;
	      });
	    },
	    getOccupiedUsers: function getOccupiedUsers(lesson) {
	      var _this16 = this;
	
	      this.isUpdatingPotentialSubs = true;
	      _docendo2.default.schoolAvailabilities(lesson.school_id, 'user', lesson.start, lesson.end, function (data) {
	        var toArr = JSON.parse(data);
	        var newUsers = {};
	        for (var i = 0; i < toArr.length; i++) {
	          newUsers[toArr[i].calendar_id] = toArr[i];
	        }
	        _this16.occupiedUsers = newUsers;
	        _this16.updateUsersForList(lesson);
	      });
	    },
	    setDSelect: function setDSelect(lesson) {
	      this.$emit('setActiveDSelect', this.user.id + '_' + lesson.id);
	      this.getOccupiedUsers(lesson);
	    },
	    openDSelect: function openDSelect(lesson) {
	      return this.activeDSelect === this.user.id + '_' + lesson.id;
	    },
	    calIdsOnLesson: function calIdsOnLesson(lesson) {
	      var _this17 = this;
	
	      var calIds = lesson.calendar_events.map(function (cal) {
	        return cal.calendar_id;
	      });
	      return calIds.filter(function (calIds) {
	        return calIds !== _this17.user.user_calendar_id;
	      });
	    },
	    calsOnLesson: function calsOnLesson(lesson) {
	      var _this18 = this;
	
	      return this.calIdsOnLesson(lesson).filter(function (calId) {
	        return _this18.allCalendarsInAHash[calId];
	      }).map(function (calId) {
	        return _this18.allCalendarsInAHash[calId];
	      });
	    },
	    othersOnLesson: function othersOnLesson(lesson) {
	      var users = [];
	      for (var i = 0; i < lesson.calendar_events.length; i++) {
	        if (this.allUsersAndEvents[lesson.calendar_events[i].calendar_id] && !lesson.calendar_events[i].substitute && lesson.calendar_events[i].calendar_id !== this.user.user_calendar_id) {
	          var user = this.allUsersAndEvents[lesson.calendar_events[i].calendar_id];
	          user['v_isUserAbsentFromLesson'] = this.doesAbsenceOverlapLesson(lesson.id, user.dayAbsence);
	          users.push(user);
	        }
	      }
	      return users;
	    },
	    doesAbsenceOverlapLesson: function doesAbsenceOverlapLesson(lessonId, absenceIds) {
	      var _this19 = this;
	
	      var absenceOverlapping = [];
	      var absenceEvents = absenceIds.map(function (eventId) {
	        return _this19.allEventsInAHash[eventId];
	      });
	      var lessonEvent = this.allEventsInAHash[lessonId];
	      absenceEvents.forEach(function (absenceEvent) {
	        var range1 = moment.range(absenceEvent.start, absenceEvent.end);
	        var range2 = moment.range(lessonEvent.start, lessonEvent.end);
	        if (range1.intersect(range2)) {
	          var absentLessonReadable = absenceEvent.title + ' ' + moment(absenceEvent.start).format('LT') + '-' + moment(absenceEvent.end).format('LT');
	          absenceOverlapping.push(absentLessonReadable);
	        }
	      });
	      return absenceOverlapping;
	    },
	    pushLoadingLesson: function pushLoadingLesson(lessonId) {
	      var idx = this.theLoadingLessons.indexOf(lessonId);
	      if (idx < 0) {
	        this.theLoadingLessons.push(lessonId);
	      }
	    },
	    spliceLoadingLesson: function spliceLoadingLesson(lessonId) {
	      var idx = this.theLoadingLessons.indexOf(lessonId);
	      if (idx > -1) {
	        this.theLoadingLessons.splice(idx, 1);
	      }
	    },
	    addSubstitute: function addSubstitute(userObj, lesson) {
	      var _this20 = this;
	
	      this.pushLoadingLesson(lesson.id);
	      if (this.isSubStatusPendingActive) {
	        this.setSubStatus(lesson, 2);
	      }
	      _docendo2.default.eventAddSubstitute(lesson.id, userObj.id, this.user.id, function (data) {
	        _this20.spliceLoadingLesson(lesson.id);
	        _this20.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this20.$store.commit('addEventOnAllUsersWithEvents', { cal_id: userObj.user_calendar_id, event_id: lesson.id });
	      });
	    },
	    removeSubstitute: function removeSubstitute(userObj, lesson) {
	      var _this21 = this;
	
	      this.pushLoadingLesson(lesson.id);
	
	      var subsForTheSub = [];
	      lesson.calendar_events.forEach(function (calEvent) {
	        if (calEvent.substitute && calEvent.substitute_for_user_id === userObj.id) {
	          subsForTheSub.indexOf(calEvent.calendar_id) < 0 ? subsForTheSub.push(calEvent.calendar_id) : null;
	        }
	      });
	      var userAndSubsForUser = {
	        user: this.user,
	        lesson: lesson,
	        subToBeRemoved: userObj,
	        subsForTheSubToBeRemoved: subsForTheSub
	      };
	      if (subsForTheSub.length > 0) {
	        this.$emit('removeSubs', userAndSubsForUser);
	        this.resetAllFormData();
	        this.spliceLoadingLesson(lesson.id);
	        return;
	      }
	      this.setSubStatus(lesson, 0);
	      _docendo2.default.eventRemoveSubstitute(lesson.id, userObj.id, this.user.id, function (data) {
	        _this21.spliceLoadingLesson(lesson.id);
	        _this21.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data));
	        _this21.$store.commit('removeEventOnAllUsersWithEvents', {
	          cal_id: userObj.user_calendar_id,
	          event_id: lesson.id
	        });
	      });
	    },
	    resetAllFormData: function resetAllFormData() {
	      this.$emit('setActiveDSelect', null);
	      this.activeEIP = [];
	      this.showOtherOnLesson = -1;
	      this.showDSub = -1;
	    },
	    getSerialListItem: function getSerialListItem(reason) {
	      return this.longAbsentListInHash[reason.event_serial_id] || false;
	    },
	    getIsAbsenceOngoing: function getIsAbsenceOngoing(reason) {
	      return this.getSerialListItem(reason) && this.getSerialListItem(reason).ongoing;
	    },
	    selectedUser: function selectedUser() {
	      this.$emit('selectedUser');
	    },
	    setActiveSplitLesson: function setActiveSplitLesson(lesson) {
	      this.$emit('splitLesson', lesson);
	    },
	    updateTeacherNote: function updateTeacherNote(obj) {
	      _docendo2.default.updateEvent(obj.lesson.school_id, obj.lesson.id, (0, _defineProperty3.default)({}, obj.noteType, obj.text), function (success) {
	        console.log('opdateret');
	      });
	    },
	    setTheEditAbsenceReason: function setTheEditAbsenceReason(reason) {
	      var absence = this.getSerialListItem(reason) ? this.getSerialListItem(reason) : reason;
	      this.$store.commit('setActiveAbsenceReason', absence);
	    }
	  },
	  mounted: function mounted() {
	    this.setUsersForDSelect();
	  }
	};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    user_calendar_id: {},
	    reason: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      start: this.reason.start,
	      end: this.reason.end
	    };
	  },
	
	  computed: {
	    longAbsentList: function longAbsentList() {
	      return this.$store.state.subs.longAbsentList;
	    },
	    longAbsentListInHash: function longAbsentListInHash() {
	      return this.$store.getters.longAbsentListInHash;
	    },
	    getSerialListItem: function getSerialListItem() {
	      return this.reason && this.reason.event_serial_id ? this.longAbsentListInHash[this.reason.event_serial_id] : false;
	    },
	    isOngoing: function isOngoing() {
	      return this.getSerialListItem ? this.getSerialListItem.ongoing : false;
	    },
	    getIsAbsenceMultipleDays: function getIsAbsenceMultipleDays() {
	      var serialItem = this.getSerialListItem;
	      return serialItem && (0, _moment2.default)(serialItem.from_date).format('YYYY-MM-DD') !== (0, _moment2.default)(serialItem.to_date).format('YYYY-MM-DD');
	    }
	  },
	  filters: {
	    showDate: function showDate(date) {
	      return (0, _moment2.default)(date).format('DD. MMM, LT');
	    },
	    showTime: function showTime(date) {
	      return (0, _moment2.default)(date).format('LT');
	    },
	    date: function date(_date) {
	      return (0, _moment2.default)(_date).format('ll');
	    }
	  },
	  methods: {
	    showLog: function showLog(event) {
	      this.$emit('showLog', event);
	    },
	    setReadyToDelete: function setReadyToDelete() {
	      this.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true);
	      this.$store.commit('setActiveAbsenceReason', this.reason);
	    },
	    isEndDateSameDayAsStart: function isEndDateSameDayAsStart(startDate, endDate) {
	      var start = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(endDate).format('YYYY-MM-DD');
	      return (0, _moment2.default)(start).isSame(end);
	    },
	    setTheEditAbsenceReason: function setTheEditAbsenceReason() {
	      var absence = this.getSerialListItem ? this.getSerialListItem : this.reason;
	      this.$store.commit('setActiveAbsenceReason', absence);
	    },
	    getIsAbsenceOngoing: function getIsAbsenceOngoing(reason) {
	      return this.getSerialListItem && this.getSerialListItem.ongoing;
	    }
	  },
	  mounted: function mounted() {
	    this.$emit('start', this.start);
	    this.$emit('end', this.end);
	    this.$store.dispatch('subsGetLongAbsenceList');
	  }
	};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SubsUserAbsenceReason = __webpack_require__(87);
	
	var _SubsUserAbsenceReason2 = _interopRequireDefault(_SubsUserAbsenceReason);
	
	var _vuex = __webpack_require__(13);
	
	var _SubsUserPanelLessons = __webpack_require__(1365);
	
	var _SubsUserPanelLessons2 = _interopRequireDefault(_SubsUserPanelLessons);
	
	var _SubsUserPanelSubs = __webpack_require__(1366);
	
	var _SubsUserPanelSubs2 = _interopRequireDefault(_SubsUserPanelSubs);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoDatePickerRange = __webpack_require__(134);
	
	var _DoDatePickerRange2 = _interopRequireDefault(_DoDatePickerRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DoDatePickerRange: _DoDatePickerRange2.default, AbsenceReason: _SubsUserAbsenceReason2.default, SubsUserPanelLessons: _SubsUserPanelLessons2.default, SubsUserPanelSubs: _SubsUserPanelSubs2.default, DModal: _DModal2.default },
	  props: {
	    activeDate: {
	      default: (0, _moment2.default)()
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      dateShortCuts: [{
	        sortKey: 1,
	        title: this.$t('vue2.substitution.selected_date'),
	        startDate: (0, _moment2.default)(this.activeDate).startOf('day'),
	        endDate: (0, _moment2.default)(this.activeDate).endOf('day')
	      }],
	      startDate: (0, _moment2.default)(this.activeDate).startOf('day'),
	      endDate: (0, _moment2.default)(this.activeDate).endOf('day'),
	      absentDates: [[(0, _moment2.default)(this.activeDate).startOf('day'), (0, _moment2.default)(this.activeDate).endOf('day')]],
	      isClosingWithoutSaving: false,
	      animate: null,
	      selectedEventIds: [],
	      subToAdd: null,
	      dbEventsWithSubs: [] };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allCalendarsInHash', 'allKlassCalendarsInHash', 'longAbsentListInHash', 'activeAbsentUserEventsInHash']), {
	    selectedEvents: function selectedEvents() {
	      var _this = this;
	
	      return this.selectedEventIds.map(function (eventId) {
	        return _this.activeAbsentUserEventsInHash[eventId];
	      });
	    },
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    user: function user() {
	      return this.$store.state.subs.activeAbsentUser;
	    },
	    absenceReasons: function absenceReasons() {
	      var _this2 = this;
	
	      return this.user.dayAbsence.map(function (eventId) {
	        return _this2.allEventsInAHash[eventId];
	      });
	    },
	    dateShortCutsSorted: function dateShortCutsSorted() {
	      return this.dateShortCuts.slice().sort(function (a, b) {
	        if (a.sortKey !== b.sortKey) {
	          return a.sortKey - b.sortKey;
	        }
	
	        return a.title.localeCompare(b.title);
	      });
	    }
	  }),
	  methods: {
	    setDates: function setDates(startAndEnd) {
	      this.startDate = startAndEnd.start;
	      this.endDate = startAndEnd.end;
	      this.absentDates = [[this.startDate, this.endDate]];
	    },
	    setAbsentDates: function setAbsentDates() {
	      var _this3 = this;
	
	      var isFromTodayAndOnwardsPushed = false;
	      if (!this.absenceReasons) {
	        return;
	      }
	
	      var globalStartDate = (0, _moment2.default)(this.activeDate);
	      var globalEndDate = (0, _moment2.default)(this.activeDate);
	
	      this.absenceReasons.forEach(function (absence) {
	        var start = void 0,
	            end = void 0;
	
	        if (absence.event_serial_id) {
	          var reason = _this3.longAbsentListInHash[absence.event_serial_id];
	          start = (0, _moment2.default)(reason.from_date);
	          end = (0, _moment2.default)(reason.to_date);
	        } else {
	          start = (0, _moment2.default)(absence.start);
	          end = (0, _moment2.default)(absence.end);
	        }
	
	        _this3.dateShortCuts.push({
	          sortKey: 3,
	          title: absence.title || '',
	          startDate: start.startOf('day'),
	          endDate: end.startOf('day')
	        });
	
	        if (start.isBefore(globalStartDate)) {
	          globalStartDate = start;
	        }
	        if (end.isAfter(globalEndDate)) {
	          globalEndDate = end;
	        }
	      });
	
	      if (this.absenceReasons.length > 1) {
	        this.dateShortCuts.push({
	          sortKey: 4,
	          title: this.$t('vue2.substitution.entire_period'),
	          startDate: globalStartDate.startOf('day'),
	          endDate: globalEndDate.endOf('day')
	        });
	      }
	
	      if ((0, _moment2.default)(this.activeDate).format('YYYY-MM-DD') !== (0, _moment2.default)(globalStartDate).format('YYYY-MM-DD') && !isFromTodayAndOnwardsPushed) {
	        this.dateShortCuts.push({
	          sortKey: 2,
	          title: this.$t('vue2.substitution.from_selected_date_onwards'),
	          startDate: (0, _moment2.default)(this.activeDate).startOf('day'),
	          endDate: globalEndDate.endOf('day')
	        });
	        isFromTodayAndOnwardsPushed = true;
	      }
	    },
	    close: function close() {
	      var _this4 = this;
	
	      if (this.dbEventsWithSubs.length > 0) {
	        this.isClosingWithoutSaving = true;
	        return;
	      }
	      this.animate = false;
	      setTimeout(function (_) {
	        _this4.$store.commit('setActiveAbsentUser', null);
	      }, 250);
	    },
	    updateSelectedEventIds: function updateSelectedEventIds(arr) {
	      this.selectedEventIds = arr;
	    },
	    addSubToEvents: function addSubToEvents(user) {
	      this.subToAdd = user;
	    },
	    updateDbEventsWithSubs: function updateDbEventsWithSubs(arr) {
	      this.dbEventsWithSubs = arr;
	      this.subToAdd = null;
	    },
	    cancel: function cancel() {
	      this.isClosingWithoutSaving = false;
	      this.dbEventsWithSubs = [];
	      this.close();
	    },
	    submit: function submit() {
	      var _this5 = this;
	
	      var updates = {};
	      this.dbEventsWithSubs.forEach(function (eventMap) {
	        var eventId = eventMap.event_id;
	        var event = _this5.activeAbsentUserEventsInHash[eventId];
	        var schoolId = event && event.school_id ? event.school_id : null;
	        if (!updates[schoolId]) {
	          updates[schoolId] = [eventMap];
	        } else {
	          updates[schoolId].push(eventMap);
	        }
	      });
	      var successTxt = this.$t('vue2.substitution.lessons_updated');
	      var errorTxt = this.$t('vue2.common.something_went_wrong');
	      (0, _keys2.default)(updates).forEach(function (schoolId) {
	        _docendo2.default.updateEvents(schoolId, updates[schoolId], function (success) {
	          _eventbus2.default.toast = { text: successTxt, success: true };
	        }, function (failure) {
	          _eventbus2.default.toast = { text: errorTxt, success: false };
	        });
	      });
	      this.$emit('readEvents');
	      this.dbEventsWithSubs = [];
	      this.close();
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.setAbsentDates();
	  },
	  mounted: function mounted() {
	    this.animate = true;
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.animate = false;
	  }
	};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, Loader: _Loader2.default },
	  props: {
	    calendarId: {},
	    dates: {
	      default: function _default() {
	        return [];
	      }
	    },
	    subToAdd: {
	      type: Object,
	      default: null
	    },
	    isSubStatusPendingActive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      events: [],
	      selectedEvents: [],
	      eventIdsToAddSub: [],
	      activeFilter: 'lessonsWithoutSub',
	      dbEventsWithSubs: [],
	      isAskRemoveAll: false,
	      activeLesson: null,
	      activeSub: null
	    };
	  },
	
	  watch: {
	    subToAdd: function subToAdd(val, oldVal) {
	      if (val) {
	        this.addSubstitute(this.subToAdd);
	      }
	    },
	    eventIdsToAddSub: function eventIdsToAddSub() {
	      this.$emit('changed', this.eventIdsToAddSub);
	    },
	    dates: function dates() {
	      this.getAllEventsInRanges();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['allCalendarsInHash', 'allUsersInCalIdHash', 'allKlassCalendarsInHash', 'longAbsentListInHash', 'activeAbsentUserOriginalEventsInHash']), {
	    allEventsInAHash: function allEventsInAHash() {
	      return this.$store.state.subs.allEventsInAHash;
	    },
	    filteredEvents: function filteredEvents() {
	      var _this = this;
	
	      if (this.activeFilter === 'lessonsWithoutSub') {
	        return this.events.filter(function (event) {
	          return !_this.getEventHasSub(event);
	        });
	      } else if (this.activeFilter === 'lessonsWithSub') {
	        return this.events.filter(function (event) {
	          return _this.getEventHasSub(event);
	        });
	      } else {
	        return this.events;
	      }
	    },
	    sortedEvents: function sortedEvents() {
	      var arr = this.filteredEvents;
	      if (arr.length < 1) {
	        return [];
	      }
	      return arr.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    eventsSortedInDays: function eventsSortedInDays() {
	      if (this.sortedEvents.length < 1) {
	        return [];
	      }
	      var sortedEventsInDays = this.sortedEvents.reduce(function (acc, curr, index) {
	        var val = (0, _moment2.default)(curr['start']).format('YYYY-MM-DD');
	        acc[val] = acc[val] || [];
	        acc[val].push(curr);
	        return acc;
	      }, {});
	      return this.eventsToArr(sortedEventsInDays);
	    },
	    eventsWithoutSubstitute: function eventsWithoutSubstitute() {
	      var _this2 = this;
	
	      var events = this.events.filter(function (lesson) {
	        return !_this2.getEventHasSub(lesson);
	      });
	      return events.map(function (event) {
	        return event.event_id;
	      });
	    },
	    eventsWithSubstitute: function eventsWithSubstitute() {
	      var _this3 = this;
	
	      var events = this.events.filter(function (lesson) {
	        return _this3.getEventHasSub(lesson);
	      });
	      return events.map(function (event) {
	        return event.event_id;
	      });
	    }
	  }),
	  methods: {
	    getEventHasSub: function getEventHasSub(event) {
	      var _this4 = this;
	
	      var hasSub = false;
	      event.calendars.forEach(function (calendar) {
	        if (calendar.substitute && calendar.substitute === _this4.allUsersInCalIdHash[_this4.calendarId].id) {
	          hasSub = true;
	        }
	      });
	      return hasSub;
	    },
	    setFilter: function setFilter(filter) {
	      this.eventIdsToAddSub = [];
	      this.activeFilter = filter;
	    },
	    setDbDateTime: function setDbDateTime(inputDate, dayTime) {
	      var date = (0, _moment2.default)(inputDate).format('YYYY-MM-DD');
	      var time = (0, _moment2.default)(dayTime);
	      return (0, _moment2.default)(date).set({
	        hour: time.get('hour'),
	        minutes: time.get('minutes')
	      });
	    },
	    readEvents: function readEvents(start, end) {
	      var _this5 = this;
	
	      this.eventIdsToAddSub = [];
	      this.isLoading = true;
	      var dbStart = this.setDbDateTime(start, (0, _moment2.default)().startOf('day'));
	      var dbEnd = this.setDbDateTime(end, (0, _moment2.default)().endOf('day'));
	
	      _docendo2.default.eventsFromCalendars([this.calendarId], dbStart, dbEnd, null, function (success) {
	        var data = success && success.length > 0 ? JSON.parse(success) : [];
	        data.forEach(function (lesson) {
	          var idx = _this5.events.findIndex(function (event) {
	            return event.event_id === lesson.event_id;
	          });
	          if (idx < 0 && lesson.event_type !== 'absence' && lesson.event_type !== 'presence') {
	            _this5.events.push(lesson);
	          }
	          console.log('this.eventIdsToAddSub', _this5.eventIdsToAddSub.length);
	        });
	
	        _this5.events.forEach(function (lesson) {
	          if (!_this5.getEventHasSub(lesson)) {
	            if (_this5.eventIdsToAddSub.indexOf(lesson.event_id) < 0) {
	              _this5.eventIdsToAddSub.push(lesson.event_id);
	            }
	          }
	        });
	        _this5.$emit('gotLessons', true);
	        _this5.$store.commit('setActiveAbsentUserEvents', _this5.events);
	
	        _this5.$store.commit('setActiveAbsentUserOriginalEvents', JSON.parse((0, _stringify2.default)(_this5.events)));
	        setTimeout(function (_) {
	          _this5.isLoading = false;
	        }, 500);
	      }, function (failure) {
	        console.log('failed', failure);
	      });
	    },
	    eventsToArr: function eventsToArr(events) {
	      return (0, _keys2.default)(events).map(function (e) {
	        return { date: e, events: events[e] };
	      });
	    },
	    getSubstitute: function getSubstitute(event) {
	      var _this6 = this;
	
	      var subs = event.calendars.filter(function (calendar) {
	        return calendar.substitute === _this6.allUsersInCalIdHash[_this6.calendarId].id;
	      });
	      return subs.map(function (calendar) {
	        return _this6.allUsersInCalIdHash[calendar.calendar_id];
	      });
	    },
	    getClasses: function getClasses(event) {
	      return event.calendars.filter(function (cal) {
	        return cal.calendar_type === 'klass';
	      });
	    },
	    isInEventIdsToAddSub: function isInEventIdsToAddSub(eventId) {
	      var idx = this.eventIdsToAddSub.indexOf(eventId);
	      return idx > -1;
	    },
	    toggleEvent: function toggleEvent(eventId) {
	      var idx = this.eventIdsToAddSub.indexOf(eventId);
	      if (idx < 0) {
	        this.eventIdsToAddSub.push(eventId);
	      } else {
	        this.eventIdsToAddSub.splice(idx, 1);
	      }
	    },
	    toggleAll: function toggleAll() {
	      var _this7 = this;
	
	      if (this.eventIdsToAddSub.length > 0) {
	        this.eventIdsToAddSub = [];
	        this.selectedEvents = [];
	      } else {
	        this.events.forEach(function (event) {
	          _this7.eventIdsToAddSub.push(event.event_id);
	          _this7.selectedEvents.push(event);
	        });
	      }
	    },
	    getAllEventsInRanges: function getAllEventsInRanges() {
	      var _this8 = this;
	
	      this.events = [];
	      this.$store.commit('setActiveAbsentUserEvents', []);
	      this.dates.forEach(function (range) {
	        var moments = range.map(function (d) {
	          return (0, _moment2.default)(d);
	        });
	        var startDate = _moment2.default.min(moments);
	        var endDate = _moment2.default.max(moments);
	        _this8.readEvents((0, _moment2.default)(startDate).startOf('day'), (0, _moment2.default)(endDate).endOf('day'));
	      });
	    },
	    addSubstitute: function addSubstitute(user) {
	      var _this9 = this;
	
	      this.eventIdsToAddSub.forEach(function (eventId) {
	        var idx = _this9.events.findIndex(function (event) {
	          return event.event_id === eventId;
	        });
	        var calendar = {
	          calendar_id: user.user_calendar_id,
	          substitute: _this9.allUsersInCalIdHash[_this9.calendarId].id,
	
	          minutes: 60
	        };
	        var calIdx = _this9.events[idx].calendars.findIndex(function (calendar) {
	          return calendar.calendar_id === user.user_calendar_id;
	        });
	
	        if (calIdx < 0) {
	          _this9.events[idx].calendars.push(calendar);
	
	          var dbArrIdx = _this9.dbEventsWithSubs.findIndex(function (obj) {
	            return obj.event_id === eventId && obj.calendar === _this9.calendarId && obj.remove_substitute_calendar_id === user.user_calendar_id;
	          });
	          if (dbArrIdx < 0) {
	            var updateObj = {
	              event_id: eventId,
	              calendar_id: _this9.calendarId,
	              add_substitute_calendar_id: user.user_calendar_id
	            };
	            if (_this9.isSubStatusPendingActive) {
	              var statusData = {};
	              statusData[_this9.calendarId] = { 'status': 2 };
	              updateObj['substitution_status'] = (0, _stringify2.default)(statusData);
	            }
	            _this9.dbEventsWithSubs.push(updateObj);
	          } else {
	            _this9.dbEventsWithSubs.splice(dbArrIdx, 1);
	          }
	        }
	      });
	      this.$emit('updatedArr', this.dbEventsWithSubs);
	      this.eventIdsToAddSub = [];
	    },
	    setIsAskRemoveAll: function setIsAskRemoveAll(boolean, lesson, sub) {
	      this.isAskRemoveAll = boolean;
	      this.activeLesson = lesson;
	      this.activeSub = sub;
	    },
	    removeSubFromAllLessons: function removeSubFromAllLessons() {
	      var _this10 = this;
	
	      var sub = this.activeSub;
	      this.events.forEach(function (event) {
	        var calIdx = event.calendars.findIndex(function (calendar) {
	          return calendar.calendar_id === sub.user_calendar_id && calendar.substitute === _this10.allUsersInCalIdHash[_this10.calendarId].id;
	        });
	        if (calIdx > -1) {
	          _this10.removeSub(event, sub);
	        }
	      });
	      this.isAskRemoveAll = false;
	      this.activeLesson = null;
	      this.activeSub = null;
	    },
	    removeSubFromActiveLesson: function removeSubFromActiveLesson() {
	      this.removeSub(this.activeLesson, this.activeSub);
	      this.isAskRemoveAll = false;
	      this.activeLesson = null;
	      this.activeSub = null;
	    },
	    removeSub: function removeSub(lesson, sub) {
	      var _this11 = this;
	
	      var eventIdx = this.events.findIndex(function (event) {
	        return event.event_id === lesson.event_id;
	      });
	      var calIdx = this.events[eventIdx].calendars.findIndex(function (calendar) {
	        return calendar.calendar_id === sub.user_calendar_id && calendar.substitute === _this11.allUsersInCalIdHash[_this11.calendarId].id;
	      });
	      this.events[eventIdx].calendars.splice(calIdx, 1);
	
	      var statusData = {};
	      statusData[this.calendarId] = { 'status': 0 };
	      var origCalIdx = this.activeAbsentUserOriginalEventsInHash[lesson.event_id].calendars.findIndex(function (calendar) {
	        return calendar.calendar_id === sub.user_calendar_id && calendar.substitute === _this11.allUsersInCalIdHash[_this11.calendarId].id;
	      });
	      if (origCalIdx > -1) {
	        this.dbEventsWithSubs.push({
	          event_id: lesson.event_id,
	          calendar_id: this.calendarId,
	          remove_substitute_calendar_id: sub.user_calendar_id,
	          substitution_status: (0, _stringify2.default)(statusData)
	        });
	      } else {
	        var dbEventsIdx = this.dbEventsWithSubs.findIndex(function (event) {
	          return event.event_id === lesson.event_id && event.add_substitute_calendar_id === sub.user_calendar_id;
	        });
	        this.dbEventsWithSubs.splice(dbEventsIdx, 1);
	      }
	      this.$emit('updatedArr', this.dbEventsWithSubs);
	    }
	  },
	  mounted: function mounted() {
	    this.getAllEventsInRanges();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.events = [];
	    this.$store.commit('setActiveAbsentUserEvents', []);
	  }
	};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(13);
	
	var _FilterUsers = __webpack_require__(338);
	
	var _FilterUsers2 = _interopRequireDefault(_FilterUsers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { FilterUsers: _FilterUsers2.default },
	  props: {
	    selectedEvents: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      users: [],
	      isLoading: true,
	      searchQuery: '',
	      debounceTimer: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersFilteredWithTags', 'allUsersInCalIdHash']), {
	    activeAbsentUser: function activeAbsentUser() {
	      return this.$store.state.subs.activeAbsentUser;
	    },
	    activeUserEvents: function activeUserEvents() {
	      return this.$store.state.subs.activeAbsentUserEvents;
	    },
	    filteredUsers: function filteredUsers() {
	      var _this = this;
	
	      return this.usersFilteredWithTags.filter(function (user) {
	        return user.user_calendar_id !== _this.activeAbsentUser.user_calendar_id;
	      });
	    },
	    usersSorted: function usersSorted() {
	      if (!this.searchQuery) {
	        return this.filteredUsers;
	      }
	      var lowercasedQuery = this.searchQuery.toLowerCase();
	
	      return this.filteredUsers.filter(function (user) {
	        return user.name.toLowerCase().includes(lowercasedQuery) || user.initials && user.initials.toLowerCase().includes(lowercasedQuery);
	      });
	    }
	  }),
	  methods: {
	    addSub: function addSub(user) {
	      if (this.selectedEvents.length < 1) {
	        window.alert(this.$t('vue2.substitution.select_lessons_to_substitute'));
	        return;
	      }
	      this.$emit('addSub', user);
	    },
	    debounceSearch: function debounceSearch(event) {
	      var _this2 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function () {
	        _this2.searchQuery = event.target.value;
	      }, 400);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.debounceTimer) {
	      clearTimeout(this.debounceTimer);
	    }
	  }
	};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    klassCalendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    userCalendars: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      calendarType: 'user',
	      slotHeight: 35,
	      slotWidth: 50,
	      eventHeightInPx: 28,
	      rows: 1,
	      schedulerMaxHeight: '100vh'
	    };
	  },
	
	  computed: {
	    hoursInLocale: function hoursInLocale() {
	      var hours = [];
	      for (var i = 0; i < 24; i++) {
	        var hour = (0, _moment2.default)().set({ hour: i, minutes: 0, seconds: 0 }).format('LT');
	        hours.push(hour);
	      }
	      return hours;
	    },
	    presenceAndAbsenceEvents: function presenceAndAbsenceEvents() {
	      return this.events.filter(function (event) {
	        return event.event_type === 'presence' || event.event_type === 'absence';
	      });
	    },
	    filteredEvents: function filteredEvents() {
	      return this.events.filter(function (event) {
	        return event.event_type !== 'presence' && event.event_type !== 'absence';
	      });
	    },
	    calendarsWithPresence: function calendarsWithPresence() {
	      var _this = this;
	
	      return this.userCalendars.map(function (calendar) {
	        var presenceAbsenceEvents = _this.presenceAndAbsenceEvents.filter(function (event) {
	          return event.calendar_events.some(function (calEvent) {
	            return calEvent.calendar_id === calendar.id;
	          });
	        });
	
	        var formattedEvents = presenceAbsenceEvents.map(function (event) {
	          var top = _this.eventTop(event);
	          var right = _this.eventRight(event);
	          var left = top;
	          var height = _this.eventHeightInPx;
	          var bottom = _this.eventBottom(event);
	
	          return (0, _extends3.default)({}, event, {
	            top: top,
	            bottom: bottom,
	            left: left,
	            right: right,
	            height: height,
	            vStyle: {
	              backgroundColor: event.color,
	              top: top + 'px',
	              bottom: bottom + 'px',
	              left: left + 'px',
	              right: right + 'px',
	              height: height + 'px'
	            }
	          });
	        });
	
	        return (0, _extends3.default)({}, calendar, {
	          vPresence: formattedEvents.filter(function (event) {
	            return event.event_type === 'presence';
	          }),
	          vAbsence: formattedEvents.filter(function (event) {
	            return event.event_type === 'absence';
	          })
	        });
	      });
	    },
	    calendarsWithEventsHash: function calendarsWithEventsHash() {
	      var _this2 = this;
	
	      var calendarMap = {};
	
	      this.filteredEvents.forEach(function (event) {
	        event.calendar_events.forEach(function (calEvent) {
	          if (!calendarMap[calEvent.calendar_id]) {
	            calendarMap[calEvent.calendar_id] = [];
	          }
	
	          var top = _this2.eventTop(event);
	          var height = _this2.eventHeightInPx;
	          var bottom = _this2.eventBottom(event);
	          var right = _this2.eventRight(event);
	
	          var eventData = (0, _extends3.default)({}, event, {
	            vColumns: 1,
	            top: top,
	            bottom: bottom,
	            left: top,
	            height: height,
	            right: right,
	            vStyle: {
	              backgroundColor: event.color,
	              top: 0,
	              bottom: '5px',
	              left: top + 'px',
	              height: height + 'px',
	              right: right + 'px'
	            }
	          });
	          calendarMap[calEvent.calendar_id].push(eventData);
	        });
	      });
	
	      (0, _keys2.default)(calendarMap).forEach(function (calendarId) {
	        var events = calendarMap[calendarId];
	        events.sort(function (e1, e2) {
	          return e1.top - e2.top || e1.bottom - e2.bottom;
	        });
	
	        var columns = [];
	
	        events.forEach(function (event) {
	          var placed = false;
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(columns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var column = _step.value;
	
	              if (!column.some(function (e) {
	                return _this2.collidesWith(e, event);
	              })) {
	                column.push(event);
	                placed = true;
	                break;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          if (!placed) {
	            columns.push([event]);
	          }
	        });
	
	        columns.forEach(function (column, colIndex) {
	          var colWidth = _this2.eventHeightInPx * colIndex + 1;
	          if (colIndex > 0) {
	            colWidth = colWidth + 2;
	          }
	          column.forEach(function (event) {
	            event.vStyle.top = colWidth + 'px';
	            event.vColumns = columns.length;
	          });
	        });
	      });
	
	      return calendarMap;
	    },
	    calendarsWithEvents: function calendarsWithEvents() {
	      var _this3 = this;
	
	      return this.userCalendars.map(function (calendar) {
	        var events = _this3.calendarsWithEventsHash[calendar.id] || [];
	        var presenceAbsence = _this3.calendarsWithPresence.find(function (pCal) {
	          return pCal.id === calendar.id;
	        }) || {};
	
	        return (0, _extends3.default)({}, calendar, {
	          vEvents: events.sort(function (a, b) {
	            return (0, _moment2.default)(a.start).valueOf() - (0, _moment2.default)(b.start).valueOf();
	          }),
	          vPresence: presenceAbsence.vPresence || [],
	          vAbsence: presenceAbsence.vAbsence || [],
	          vColumns: _this3.findLargestColumn(events)
	        });
	      });
	    }
	  },
	  methods: {
	    calculateMaxHeight: function calculateMaxHeight() {
	      if (this.$refs.doScheduler) {
	        var topOffset = this.$refs.doScheduler.getBoundingClientRect().top;
	        this.schedulerMaxHeight = window.innerHeight - topOffset - 16;
	      }
	    },
	    getEventStyle: function getEventStyle(event) {
	      return (0, _assign2.default)({}, event.vStyle, { '--event-color': event.color });
	    },
	    findLargestColumn: function findLargestColumn(events) {
	      return events.reduce(function (max, event) {
	        return event.vColumns > max ? event.vColumns : max;
	      }, 1);
	    },
	    eventRight: function eventRight(event) {
	      var time = _moment2.default.duration({
	        minutes: (0, _moment2.default)(event.end).format('mm'),
	        hours: (0, _moment2.default)(event.end).format('HH')
	      }).asMinutes();
	      var endOfDay = _moment2.default.duration({
	        hours: 24,
	        minutes: 0
	      }).asMinutes();
	      return this.slotWidth * 2 / 60 * (endOfDay - time);
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = (0, _moment2.default)(event.start).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventStartTime = (0, _moment2.default)(event.start);
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      return this.slotWidth * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = (0, _moment2.default)(event.end).set({
	        'hour': 0,
	        'minutes': 0
	      });
	      var eventEndTime = (0, _moment2.default)(event.end);
	      var duration = (0, _moment2.default)(eventEndTime).diff(calStartTime);
	      return this.slotWidth * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].row = i;
	          if (i + 1 > this.rows) {
	            this.rows = i + 1;
	          }
	          col[j].colspan = colSpan / n;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    setWidthAndLeft: function setWidthAndLeft() {
	      var _this4 = this;
	
	      this.isEventsHasSortedOnce = true;
	      var columns = [];
	      var lastEventEnding = null;
	      var events = this.sortedEvents.map(function (elem) {
	        var top = _this4.eventTop(elem);
	        var height = _this4.eventHeight(elem);
	        var bottom = _this4.eventBottom(elem);
	        var right = _this4.eventRight(elem);
	        return {
	          'obj': elem,
	          'top': top,
	          'left': top,
	          'right': right,
	          'height': height,
	          'bottom': bottom
	        };
	      });
	      events.sort(function (e1, e2) {
	        if (e1.top < e2.top) return -1;
	        if (e1.top > e2.top) return 1;
	        if (e1.bottom < e2.bottom) return -1;
	        if (e1.bottom > e2.bottom) return 1;
	        return 0;
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packEvents(columns);
	          columns = [];
	          lastEventEnding = null;
	        }
	        var placed = false;
	        for (var j = 0; j < columns.length; j++) {
	          var col = columns[j];
	          if (!this.collidesWith(col[col.length - 1], e)) {
	            col.push(e);
	            placed = true;
	            break;
	          }
	        }
	        if (!placed) {
	          columns.push([e]);
	        }
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (columns.length > 0) {
	        this.packEvents(columns);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.calculateMaxHeight();
	    window.addEventListener('resize', this.calculateMaxHeight);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.calculateMaxHeight);
	  }
	};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DoChangeDayNav = __webpack_require__(1394);
	
	var _DoChangeDayNav2 = _interopRequireDefault(_DoChangeDayNav);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DoSplash = __webpack_require__(350);
	
	var _DoSplash2 = _interopRequireDefault(_DoSplash);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Scheduler = __webpack_require__(1367);
	
	var _Scheduler2 = _interopRequireDefault(_Scheduler);
	
	var _vuex = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Scheduler: _Scheduler2.default, DoSplash: _DoSplash2.default, DoChangeDayNav: _DoChangeDayNav2.default, Loader: _Loader2.default },
	  data: function data() {
	    return {
	      isLoadingEvents: false,
	      events: [],
	      date: (0, _moment2.default)(),
	      activeUserIds: [],
	      isInitialLoad: true
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['klassCalendars', 'userCalendars', 'allCalendarsInHash']), {
	    schoolId: function schoolId() {
	      return this.$route.params.school_id ? this.$route.params.school_id : this.$store.getters.schoolId;
	    },
	    dateFormatted: function dateFormatted() {
	      return (0, _moment2.default)(this.date).format('DD-MM-YYYY');
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    isLoadingSchoolCalenders: function isLoadingSchoolCalenders() {
	      return this.$store.state.isLoadingSchoolCalenders;
	    },
	    isLoadingAllUsers: function isLoadingAllUsers() {
	      return this.$store.state.isLoadingAllUsers;
	    },
	    isInitialLoading: function isInitialLoading() {
	      return this.isLoadingSchoolCalenders || this.isLoadingAllUsers;
	    },
	    eventsInHash: function eventsInHash() {
	      var events = this.events;
	      return events.reduce(function (obj, item) {
	        obj[item.id] = item;
	        return obj;
	      }, {});
	    },
	    eventsInCalIdsHash: function eventsInCalIdsHash() {
	      var calIds = {};
	      this.events.forEach(function (event) {
	        event.calendar_events.forEach(function (calEvent) {
	          var cal = calIds[calEvent.calendar_id];
	          if (!cal) {
	            calIds[calEvent.calendar_id] = [event];
	          } else {
	            calIds[calEvent.calendar_id].push(event);
	          }
	        });
	      });
	      return calIds;
	    },
	    usersWithEvents: function usersWithEvents() {
	      if (this.isInitialLoading) {
	        return [];
	      }
	    },
	    absentUsers: function absentUsers() {
	      if (this.isInitialLoading) {
	        return [];
	      }
	      return [];
	    }
	  }),
	  methods: {
	    getIsUserSubstituted: function getIsUserSubstituted(event, user) {
	      return event.calendar_events.some(function (calEvent) {
	        return calEvent.substitute_for_user_id === user.id;
	      });
	    },
	    getStatus: function getStatus(event, user) {
	      var isSubstituted = this.getIsUserSubstituted(event, user);
	      if (isSubstituted) {
	        return 1;
	      }
	      var status = event.substitution_status ? JSON.parse(event.substitution_status) : {};
	      var userStatus = status[user.user_calendar_id] ? status[user.user_calendar_id]['status'] : 0;
	      return userStatus;
	    },
	    setActiveUser: function setActiveUser(user) {
	      this.activeUserIds = [user.id];
	    },
	    onChangeSubstitute: function onChangeSubstitute(updateObj) {
	      this.submit([updateObj]);
	    },
	    onChangeStatus: function onChangeStatus(updateObj) {
	      var _this = this;
	
	      var event = updateObj.event;
	      var user = updateObj.user;
	      var val = updateObj.val * 1;
	      var status = event.substitution_status ? JSON.parse(event.substitution_status) : {};
	      var statusData = (0, _extends3.default)({}, status);
	      if (val === 0) {
	        delete statusData[user.user_calendar_id];
	      } else {
	        statusData[user.user_calendar_id] = { status: val };
	      }
	      _docendo2.default.updateEvent(event.school_id, event.id, { substitution_status: statusData }, function (success) {
	        _this.readEvents();
	      });
	    },
	    submit: function submit(dbEventsWithSubs) {
	      var _this2 = this;
	
	      var updates = {};
	      dbEventsWithSubs.forEach(function (eventMap) {
	        var eventId = eventMap.event_id;
	        var event = _this2.eventsInHash[eventId];
	        var schoolId = event && event.school_id ? event.school_id : null;
	        if (!updates[schoolId]) {
	          updates[schoolId] = [eventMap];
	        } else {
	          updates[schoolId].push(eventMap);
	        }
	      });
	      var successTxt = this.$t('vue2.substitution.lessons_updated');
	      var errorTxt = this.$t('vue2.common.something_went_wrong');
	      (0, _keys2.default)(updates).forEach(function (schoolId) {
	        _docendo2.default.updateEvents(schoolId, updates[schoolId], function (success) {
	          _eventbus2.default.toast = { text: successTxt, success: true };
	          _this2.readEvents();
	        }, function (failure) {
	          _eventbus2.default.toast = { text: errorTxt, success: false };
	        });
	      });
	    },
	    setDate: function setDate(inputDate) {
	      var _this3 = this;
	
	      var date = inputDate;
	      if (date === 'today') {
	        date = (0, _moment2.default)();
	      }
	      if (date === 'prev') {
	        date = (0, _moment2.default)(this.date).subtract(1, 'days');
	      }
	      if (date === 'next') {
	        date = (0, _moment2.default)(this.date).add(1, 'days');
	      }
	      this.date = date;
	      setTimeout(function (_) {
	        _this3.readEvents();
	      }, 100);
	    },
	    readEvents: function readEvents() {
	      var _this4 = this;
	
	      this.isInitialLoad = true;
	      this.events = [];
	      this.isLoadingEvents = true;
	      var schoolIds = [this.schoolId];
	      _docendo2.default.listEventsForSchools(schoolIds, this.date, function (success) {
	        var events = success && success.length > 0 ? JSON.parse(success) : [];
	        _this4.setEventsWithMetaData(events);
	        _this4.isLoadingEvents = false;
	      }, function (failure) {
	        console.log('something went wrong');
	      });
	    },
	    setEventsWithMetaData: function setEventsWithMetaData(events) {
	      this.events = events.map(function (event) {
	        return (0, _extends3.default)({}, event, {
	          vTime: (0, _moment2.default)(event.start).format('LT') + ' - ' + (0, _moment2.default)(event.end).format('LT'),
	          vKlasses: event.calendar_events.filter(function (cal) {
	            return cal && cal.calendar_type === 'klass';
	          }).map(function (cal) {
	            return cal.name;
	          }).join(', '),
	          vSubstitutes: [] });
	      }).sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readEvents();
	  }
	};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tag = __webpack_require__(127);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { tag: _Tag2.default },
	  props: {
	    searchText: {
	      default: ''
	    },
	    columns: {
	      type: Boolean,
	      default: false
	    },
	    showHowMany: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      tags: [],
	      active: false,
	      showDropdown: false,
	      showInput: false,
	      tagText: ''
	    };
	  },
	
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  },
	  watch: {
	    active: function active() {
	      var _this = this;
	
	      if (this.active) {
	        setTimeout(function () {
	          _this.showDropdown = true;
	        }, 0);
	      } else {
	        this.showDropdown = false;
	      }
	    }
	  },
	  computed: {
	    selectedTags: function selectedTags() {
	      return this.$store.state.selectedTags;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    sortedTags: function sortedTags() {
	      return this.tags.sort(function (a, b) {
	        return a.localeCompare(b);
	      });
	    },
	    filteredTags: function filteredTags() {
	      var _this2 = this;
	
	      return this.sortedTags.filter(function (tag) {
	        return tag !== '' ? tag.match(new RegExp(_this2.tagText, 'i')) : '';
	      });
	    },
	    personsWithTags: function personsWithTags() {
	      if (!this.showHowMany) {
	        return 0;
	      }
	      return this.users.filter(function (user) {
	        return user.user_tags.length > 0;
	      });
	    },
	    notSelectedTags: function notSelectedTags() {
	      var _this3 = this;
	
	      return this.filteredTags.filter(function (tag) {
	        return _this3.selectedTags.indexOf(tag) < 0;
	      });
	    },
	    schoolid: function schoolid() {
	      return window.SCHOOL.id;
	    }
	  },
	  methods: {
	    hideActive: function hideActive() {
	      this.tagText = '';
	      this.active = false;
	    },
	    setTag: function setTag(tag) {
	      this.$store.commit('setSelectedTags', tag);
	      this.hideActive();
	    },
	    howManyWithTag: function howManyWithTag(tag) {
	      var arr = this.personsWithTags.filter(function (user) {
	        return user.user_tags.indexOf(tag) > -1;
	      });
	      return arr.length;
	    },
	    removeTag: function removeTag(tag) {
	      this.$store.commit('setSelectedTags', tag);
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this4 = this;
	
	    _docendo2.default.schoolTags(window.SCHOOL.id, function (data) {
	      _this4.tags = data;
	    });
	  }
	};

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    tag: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    remove: function remove() {
	      this.$emit('remove', this.tag);
	    }
	  }
	};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(13);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DSelect = __webpack_require__(21);
	
	var _DSelect2 = _interopRequireDefault(_DSelect);
	
	var _DSelectUsers = __webpack_require__(69);
	
	var _DSelectUsers2 = _interopRequireDefault(_DSelectUsers);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userLocale = window.USER && window.USER.language ? window.USER.language : 'da';
	
	var I18N = {
	  da: {
	    groups: 'Grupper',
	    create_a_new_group: 'Opret ny gruppe',
	    all: 'Alle',
	    in_the_group: 'i gruppen',
	    create_group: 'Opret gruppe',
	    edit_group: 'Redigér gruppe',
	    delete_group: 'Slet gruppe',
	    name_for_group: 'Navn på gruppen',
	    select_a_user: 'Vælg mindst én bruger (tilføj flere senere)',
	    created: 'Oprettet',
	    updated: 'Opdateret',
	    deleted: 'Slettet',
	    add: 'Tilføj',
	    drag_and_drop_explained: 'Drag and drop bruger til gruppe'
	  },
	  nb: {
	    groups: 'Grupper',
	    create_a_new_group: 'Opprett ny gruppe',
	    all: 'Alle',
	    in_the_group: 'i gruppen',
	    create_group: 'Opprett gruppe',
	    edit_group: 'Rediger gruppe',
	    delete_group: 'Slett gruppe',
	    name_for_group: 'Navn på gruppe',
	    select_a_user: 'Velg minst en bruker',
	    created: 'Opprettet',
	    updated: 'Oppdatert',
	    deleted: 'Slettet',
	    add: 'Legg til',
	    drag_and_drop_explained: 'Dra og slipp bruker til gruppe'
	  },
	  en: {
	    groups: 'Groups',
	    create_a_new_group: 'Create new group',
	    all: 'All',
	    in_the_group: 'in the group',
	    create_group: 'Create group',
	    edit_group: 'Edit group',
	    delete_group: 'Delete group',
	    name_for_group: 'Name for group',
	    select_a_user: 'Select minimum one user',
	    created: 'Created',
	    updated: 'Updated',
	    deleted: 'Deleted',
	    add: 'Add',
	    drag_and_drop_explained: 'Drag and drop user to group'
	  }
	};
	
	exports.default = {
	  components: { Loader: _Loader2.default, DSelectUsers: _DSelectUsers2.default, DModal: _DModal2.default, DDropdown: _DDropdown2.default, DSelect: _DSelect2.default },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      tags: [],
	      activeTag: null,
	      isModal: false,
	      theEditTag: null,
	      theDeleteTag: null,
	      tagTitle: '',
	      selectedUserIds: [],
	      isButtonLoading: false,
	      dragItem: null,
	      dragEvt: null,
	      usersSelectedForDrag: [],
	      isShowDragExplainer: false,
	      isLoading: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName', 'allUsersInHash']), {
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id;
	    },
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : 'en';
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    sortedTags: function sortedTags() {
	      return this.tags.sort(function (a, b) {
	        return a.localeCompare(b, userLocale, {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    tagsWithProps: function tagsWithProps() {
	      var _this = this;
	
	      return this.sortedTags.map(function (tag) {
	        var tagObj = {
	          v_name: tag,
	          v_number_of_persons: _this.getUsersWithTag(tag).length
	        };
	        return tagObj;
	      });
	    },
	    usersWithProps: function usersWithProps() {
	      var _this2 = this;
	
	      return this.usersSortedOnName.map(function (user) {
	        var iSSelectedForDrag = _this2.usersSelectedForDrag.indexOf(user.id) > -1;
	        _this2.$set(user, 'v_isSelectedForDrag', iSSelectedForDrag);
	        return user;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      return this.getUsersWithTag(this.activeTag);
	    },
	    filteredUserIds: function filteredUserIds() {
	      return this.filteredUsers.map(function (user) {
	        return user.id;
	      });
	    },
	    usersForDSelect: function usersForDSelect() {
	      var _this3 = this;
	
	      return this.usersSortedOnName.filter(function (user) {
	        return _this3.filteredUserIds.indexOf(user.id) < 0;
	      });
	    }
	  }),
	  methods: {
	    setActiveTag: function setActiveTag(tag) {
	      this.activeTag = tag;
	      this.usersSelectedForDrag = [];
	    },
	    setUsersSelectedForDrag: function setUsersSelectedForDrag(user) {
	      var idx = this.usersSelectedForDrag.indexOf(user.id);
	      if (idx < 0) {
	        this.usersSelectedForDrag.push(user.id);
	      } else {
	        this.usersSelectedForDrag.splice(idx, 1);
	      }
	    },
	    setSelectedUsers: function setSelectedUsers(users) {
	      this.selectedUserIds = users.map(function (user) {
	        return user.id;
	      });
	    },
	    setIsModal: function setIsModal(boolean) {
	      this.isModal = boolean;
	      if (!boolean) {
	        this.theDeleteTag = null;
	        this.theEditTag = null;
	        this.tagTitle = '';
	        this.selectedUserIds = [];
	      }
	    },
	    isSubmitted: function isSubmitted(tagTitle) {
	      this.isButtonLoading = false;
	      this.getTags();
	      this.reset();
	      this.setIsModal(false);
	      this.$store.dispatch('getUsers');
	      if (tagTitle) {
	        this.activeTag = tagTitle;
	      }
	    },
	    reset: function reset() {
	      this.activeTag = null;
	      this.theDeleteTag = null;
	      this.theEditTag = null;
	      this.tagTitle = '';
	    },
	    setTheDeleteTag: function setTheDeleteTag(tag) {
	      this.theDeleteTag = tag;
	      this.setIsModal(true);
	    },
	    setTheEditTag: function setTheEditTag(tag) {
	      this.theEditTag = tag;
	      this.tagTitle = tag.v_name;
	      this.setIsModal(true);
	    },
	    getTags: function getTags() {
	      var _this4 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this4.tags = data;
	      });
	    },
	    getUsersWithTag: function getUsersWithTag(tag) {
	      if (!tag) {
	        return this.usersSortedOnName;
	      }
	      return this.usersWithProps.filter(function (user) {
	        return user.user_tags.indexOf(tag) > -1;
	      });
	    },
	    toggleAll: function toggleAll() {
	      var _this5 = this;
	
	      if (this.usersSelectedForDrag.length > 0) {
	        this.usersSelectedForDrag = [];
	      } else {
	        this.usersSelectedForDrag = [];
	        this.filteredUserIds.forEach(function (userId) {
	          _this5.usersSelectedForDrag.push(userId);
	        });
	      }
	    },
	    createTag: function createTag() {
	      var _this6 = this;
	
	      var successText = this.i18n['created'];
	      if (this.tagTitle.length < 1 || this.selectedUserIds.length === 0) {
	        return;
	      }
	      this.isButtonLoading = true;
	      _docendo2.default.schoolTagsBulkCreate(this.schoolId, [this.tagTitle], this.selectedUserIds, function (success) {
	        _this6.isSubmitted();
	        _eventbus2.default.toast = { text: successText, 'success': true };
	      }, function (failure) {
	        _this6.isButtonLoading = false;
	        _eventbus2.default.toast = { text: _this6.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    deleteTag: function deleteTag() {
	      var _this7 = this;
	
	      var successText = this.i18n['deleted'];
	      this.isButtonLoading = true;
	      _docendo2.default.schoolTagsBulkDelete(this.schoolId, [this.theDeleteTag.v_name], this.filteredUserIds, function (success) {
	        _this7.isSubmitted();
	        _eventbus2.default.toast = { text: successText, 'success': true };
	      }, function (failure) {
	        _this7.isSubmitted();
	        _eventbus2.default.toast = { text: _this7.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    editTag: function editTag() {
	      var _this8 = this;
	
	      if (this.tagTitle.length < 1) {
	        return;
	      }
	      var successText = this.i18n['updated'];
	      this.isButtonLoading = true;
	      _docendo2.default.schoolTagsBulkDelete(this.schoolId, [this.theEditTag.v_name], this.filteredUserIds, function (success) {
	        _docendo2.default.schoolTagsBulkCreate(_this8.schoolId, [_this8.tagTitle], _this8.filteredUserIds, function (success) {
	          _this8.isSubmitted(_this8.tagTitle);
	          _eventbus2.default.toast = { text: successText, 'success': true };
	        }, function (failure) {
	          _this8.isButtonLoading = false;
	          _eventbus2.default.toast = { text: _this8.$t('vue2.toast.something_went_wrong'), 'success': false };
	        });
	      }, function (failure) {
	        _this8.isSubmitted();
	        _eventbus2.default.toast = { text: _this8.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    dragStart: function dragStart(item, evt) {
	      this.isShowDragExplainer = false;
	      this.dragItem = item;
	      var idx = this.usersSelectedForDrag.indexOf(item.id);
	      if (idx < 0) {
	        this.usersSelectedForDrag.push(item.id);
	      }
	      this.dragEvt = evt;
	      this.dragEvt.target.classList.add('isDragging');
	      var el = this.$refs.customdrag;
	      el.style.display = 'flex';
	      evt.dataTransfer.setDragImage(el, 0, 0);
	    },
	    dragEnd: function dragEnd() {
	      if (!this.dragItem) {
	        return;
	      }
	      this.$refs.customdrag.style.display = 'none';
	      this.dragEvt.target.classList.remove('isDragging');
	      this.dragEvt.target.style.display = '';
	      this.usersSelectedForDrag = [];
	      this.dragItem = null;
	      this.dragEvt = null;
	    },
	    dragEnter: function dragEnter(tag, evt) {
	      if (!this.dragItem) {
	        return;
	      }
	      evt.target.classList.add('isDragEnter');
	    },
	    dragLeave: function dragLeave(evt) {
	      if (!this.dragItem) {
	        return;
	      }
	      evt.target.classList.remove('isDragEnter');
	    },
	    drop: function drop(tag) {
	      if (!this.dragItem) {
	        return;
	      }
	      this.addTagToItems(tag);
	      this.dragEnd();
	      var elements = this.$refs.droppable_elements;
	      for (var i = 0; i < elements.length; i++) {
	        elements[i].classList.remove('isDragEnter');
	      }
	    },
	    addTagToItems: function addTagToItems(tag) {
	      var _this9 = this;
	
	      this.isLoading = true;
	      var successText = this.i18n['updated'];
	
	      var users = this.usersSelectedForDrag.map(function (userId) {
	        return _this9.allUsersInHash[userId];
	      });
	      var userIdsToAdd = users.filter(function (user) {
	        return user.user_tags.indexOf(tag.v_name) < 0;
	      }).map(function (user) {
	        return user.id;
	      });
	      _docendo2.default.schoolTagsBulkCreate(this.schoolId, [tag.v_name], userIdsToAdd, function (success) {
	        _eventbus2.default.toast = { text: successText, 'success': true };
	        _this9.isSubmitted(_this9.activeTag);
	        _this9.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this9.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    deleteTagFromUser: function deleteTagFromUser(user, tag) {
	      var _this10 = this;
	
	      this.isLoading = true;
	      _docendo2.default.schoolTagsBulkDelete(this.schoolId, [tag], [user.id], function (success) {
	        _this10.isSubmitted(_this10.activeTag);
	        _this10.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this10.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    addUserToTag: function addUserToTag(user) {
	      var _this11 = this;
	
	      var tags = [this.activeTag];
	      var userIds = [user.id];
	      this.isLoading = true;
	      _docendo2.default.schoolTagsBulkCreate(this.schoolId, tags, userIds, function (success) {
	        console.log('success', success);
	        _this11.isSubmitted(_this11.activeTag);
	        _this11.isLoading = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this11.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.getTags();
	  }
	};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tag = __webpack_require__(127);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _vueClickaway = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userLocale = window.USER && window.USER.language ? window.USER.language : 'da';
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: { tag: _Tag2.default },
	  props: {
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    searchText: {
	      default: ''
	    },
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedTags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    columns: {
	      type: Boolean,
	      default: false
	    },
	    showHowMany: {
	      type: Boolean,
	      default: true
	    },
	    isShowNoTagsText: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      active: false,
	      showDropdown: false,
	      showInput: false,
	      tagText: ''
	    };
	  },
	
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  },
	  watch: {
	    active: function active() {
	      var _this = this;
	
	      if (this.active) {
	        setTimeout(function () {
	          _this.showDropdown = true;
	        }, 0);
	      } else {
	        this.showDropdown = false;
	      }
	    }
	  },
	  computed: {
	    sortedTags: function sortedTags() {
	      return this.tags.sort(function (a, b) {
	        return a.localeCompare(b, userLocale, {
	          numeric: true,
	          sensitivity: 'base'
	        });
	      });
	    },
	    filteredTags: function filteredTags() {
	      var _this2 = this;
	
	      return this.sortedTags.filter(function (tag) {
	        return tag !== '' ? tag.match(new RegExp(_this2.tagText, 'i')) : '';
	      });
	    },
	    personsWithTags: function personsWithTags() {
	      if (!this.showHowMany) {
	        return 0;
	      }
	      return this.users.filter(function (user) {
	        return user.tags && user.tags.length > 0;
	      });
	    },
	    notSelectedTags: function notSelectedTags() {
	      var _this3 = this;
	
	      return this.filteredTags.filter(function (tag) {
	        return _this3.selectedTags.indexOf(tag) < 0;
	      });
	    },
	    schoolid: function schoolid() {
	      return window.SCHOOL.id;
	    }
	  },
	  methods: {
	    hideActive: function hideActive() {
	      this.tagText = '';
	      this.active = false;
	    },
	    setTag: function setTag(tag) {
	      this.$emit('set', tag);
	      this.hideActive();
	    },
	    howManyWithTag: function howManyWithTag(tag) {
	      var arr = this.personsWithTags.filter(function (user) {
	        return user.tags.indexOf(tag) > -1;
	      });
	      return arr.length;
	    },
	    removeTag: function removeTag(tag) {
	      this.$emit('remove', tag);
	    }
	  }
	};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _TaggingFilter = __webpack_require__(26);
	
	var _TaggingFilter2 = _interopRequireDefault(_TaggingFilter);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _vuex = __webpack_require__(13);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default, DModal: _DModal2.default, filterTags: _TaggingFilter2.default },
	  data: function data() {
	    return {
	      isSaving: false,
	      selectedUsers: [],
	      appliedFilters: [],
	      tags: [],
	      isLoadingTags: false,
	      newVersionTitle: '',
	      theTab: 1,
	      theFAQAcc: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['usersSortedOnName']), {
	    schoolId: function schoolId() {
	      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : this.$store.getters.schoolId ? this.$store.getters.schoolId : window.SCHOOL.id;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    usersSortedOnNameWithTags: function usersSortedOnNameWithTags() {
	      return this.usersSortedOnName.map(function (user) {
	        user.tags = user.user_tags;
	        return user;
	      });
	    },
	    filteredUsers: function filteredUsers() {
	      var _this = this;
	
	      var passedUsers = this.usersSortedOnName;
	
	      var _loop = function _loop(i) {
	        passedUsers = passedUsers.filter(function (user) {
	          return user.user_tags && user.user_tags.indexOf(_this.appliedFilters[i]) > -1;
	        });
	      };
	
	      for (var i = 0; i < this.appliedFilters.length; i++) {
	        _loop(i);
	      }
	      return passedUsers;
	    }
	  }),
	  methods: {
	    start: function start(el) {
	      el.style.height = el.scrollHeight + 'px';
	    },
	    end: function end(el) {
	      el.style.height = '';
	    },
	    setTheFAQAcc: function setTheFAQAcc(num) {
	      if (this.theFAQAcc === num) {
	        this.theFAQAcc = null;
	      } else {
	        this.theFAQAcc = num;
	      }
	    },
	    getTheFAQAcc: function getTheFAQAcc(num) {
	      return this.theFAQAcc === num;
	    },
	    toggleAll: function toggleAll() {
	      var _this2 = this;
	
	      if (this.selectedUsers.length > 0) {
	        this.selectedUsers = [];
	      } else {
	        this.selectedUsers = [];
	        this.filteredUsers.forEach(function (user) {
	          return _this2.selectedUsers.push(user.id);
	        });
	      }
	    },
	    getIsUserSelected: function getIsUserSelected(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      return idx > -1;
	    },
	    toggleUser: function toggleUser(user) {
	      var idx = this.selectedUsers.findIndex(function (selectedUser) {
	        return selectedUser === user.id;
	      });
	      if (idx > -1) {
	        this.selectedUsers.splice(idx, 1);
	      } else {
	        this.selectedUsers.push(user.id);
	      }
	    },
	    setTagFromFilter: function setTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.push(tag);
	    },
	    removeTagFromFilter: function removeTagFromFilter(tag) {
	      this.selectedUsers = [];
	      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1);
	    },
	    readTags: function readTags() {
	      var _this3 = this;
	
	      this.isLoadingTags = true;
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this3.tags = data;
	        _this3.isLoadingTags = false;
	      });
	    },
	    close: function close() {
	      this.reset();
	      this.$emit('close');
	    },
	    save: function save() {
	      var _this4 = this;
	
	      if (this.selectedUsers.length < 1) {
	        return;
	      }
	      this.isSaving = true;
	      _docendo2.default.bulkCreateTaskOverview(this.schoolId, this.activeSchoolYear.id, this.selectedUsers, this.newVersionTitle, function (success) {
	        _this4.isSaving = false;
	        _eventbus2.default.toast = { text: 'Gemt', 'success': true };
	        _this4.close();
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Noget gik galt', 'success': false };
	      });
	    },
	    reset: function reset() {
	      this.isSaving = false;
	      this.selectedUsers = [];
	      this.newVersionTitle = '';
	      this.theTab = 1;
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.readTags();
	    this.$nextTick(function (_) {
	      _this5.$refs.version_name_input.focus();
	    });
	  }
	};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TaskOverviewSettingsCategoriesTasks = __webpack_require__(1374);
	
	var _TaskOverviewSettingsCategoriesTasks2 = _interopRequireDefault(_TaskOverviewSettingsCategoriesTasks);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _TaskOverviewSettingsCategories = __webpack_require__(1372);
	
	var _TaskOverviewSettingsCategories2 = _interopRequireDefault(_TaskOverviewSettingsCategories);
	
	var _TaskOverviewSettingsCategoriesCreate = __webpack_require__(1373);
	
	var _TaskOverviewSettingsCategoriesCreate2 = _interopRequireDefault(_TaskOverviewSettingsCategoriesCreate);
	
	var _TaskOverviewSettingsUserTasks = __webpack_require__(1378);
	
	var _TaskOverviewSettingsUserTasks2 = _interopRequireDefault(_TaskOverviewSettingsUserTasks);
	
	var _TaskOverviewSettingsGuide = __webpack_require__(1376);
	
	var _TaskOverviewSettingsGuide2 = _interopRequireDefault(_TaskOverviewSettingsGuide);
	
	var _TaskOverviewSettingsSettings = __webpack_require__(1377);
	
	var _TaskOverviewSettingsSettings2 = _interopRequireDefault(_TaskOverviewSettingsSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TaskOverviewSettingsGuide: _TaskOverviewSettingsGuide2.default,
	    TaskOverviewSettingsUserTasks: _TaskOverviewSettingsUserTasks2.default,
	    TaskOverviewSettingsCategories: _TaskOverviewSettingsCategories2.default,
	    TaskOverviewSettingsCategoryCreate: _TaskOverviewSettingsCategoriesCreate2.default,
	    TaskOverviewSettingsSettings: _TaskOverviewSettingsSettings2.default,
	    Loader: _Loader2.default,
	    DModal: _DModal2.default,
	    TaskOverviewSettingsCategoriesTasks: _TaskOverviewSettingsCategoriesTasks2.default
	  },
	  data: function data() {
	    return {
	      isWatchGuide: false,
	      tabs: [{ id: 1, title: '1. Opret og organiser kategorier' }, { id: 2, title: '2. Tilpas kategorier til brikker' }, { id: 3, title: '3. Lav yderligere indstillinger' }, { id: 4, title: '4. Se opgaveoversigter' }],
	      theActiveTab: 1,
	      isLoadingSubjects: true,
	      subjects: [],
	      taskCategories: [],
	      isLoadingTaskCategories: true,
	      isCreateCategory: false,
	      theEditTask: null,
	      theActiveUserIdForExample: null,
	      tags: []
	    };
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    users: function users() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    dbSubjectTypes: function dbSubjectTypes() {
	      return this.$store.state.subjects.dbSubjectTypes;
	    },
	    isInitLoading: function isInitLoading() {
	      return this.isLoadingSubjects || this.isLoadingTaskCategories;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    taskCategoriesSorted: function taskCategoriesSorted() {
	      return this.taskCategories.sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	    }
	  },
	  watch: {
	    schoolYearId: function schoolYearId(val) {
	      this.readSubjects();
	      this.readTaskCategories();
	    }
	  },
	  methods: {
	    setTheActiveUserIdForExample: function setTheActiveUserIdForExample(val) {
	      this.theActiveUserIdForExample = val;
	    },
	    onSetEditTask: function onSetEditTask(evt) {
	      this.theEditTask = evt;
	    },
	    updateSubjects: function updateSubjects(updates) {
	      var _this = this;
	
	      updates.forEach(function (subjectUpdate) {
	        var idx = _this.subjects.findIndex(function (subject) {
	          return subject.id === subjectUpdate.id;
	        });
	        if (idx !== -1) {
	          _this.$set(_this.subjects, idx, (0, _extends3.default)({}, _this.subjects[idx], {
	            selected_task_category_id: subjectUpdate.selected_task_category_id
	          }));
	        }
	      });
	    },
	    onNewCategory: function onNewCategory(theNewCategory) {
	      this.taskCategories.push(theNewCategory);
	      this.isCreateCategory = false;
	    },
	    onDeleteTaskCategory: function onDeleteTaskCategory(theDeletedCategoryId) {
	      var idx = this.taskCategories.findIndex(function (cat) {
	        return cat.id === theDeletedCategoryId;
	      });
	      this.taskCategories.splice(idx, 1);
	    },
	    onUpdateCategory: function onUpdateCategory(theUpdatedCategory) {
	      var idx = this.taskCategories.findIndex(function (cat) {
	        return cat.id === theUpdatedCategory.id;
	      });
	      this.$set(this.taskCategories, idx, theUpdatedCategory);
	    },
	    setCreateCategory: function setCreateCategory(bool) {
	      this.isCreateCategory = bool;
	    },
	    onClose: function onClose() {
	      this.$emit('close');
	    },
	    setTheActiveTab: function setTheActiveTab(tabId) {
	      this.theActiveTab = tabId;
	    },
	    readSubjects: function readSubjects() {
	      var _this2 = this;
	
	      this.isLoadingSubjects = true;
	      _docendo2.default.readSubjectCalendars(this.schoolId, this.schoolYearId, function (data) {
	        _this2.isLoadingSubjects = false;
	        _this2.subjects = data;
	      }, function (failure) {
	        console.log('failed read subjects');
	      });
	    },
	    readTaskCategories: function readTaskCategories() {
	      var _this3 = this;
	
	      this.isLoadingTaskCategories = true;
	      _docendo2.default.readTaskCategories(this.schoolId, this.schoolYearId, function (data) {
	        _this3.isLoadingTaskCategories = false;
	        _this3.taskCategories = data && data.length > 0 ? data : [];
	      });
	    },
	    readTags: function readTags() {
	      var _this4 = this;
	
	      _docendo2.default.schoolTags(this.schoolId, function (data) {
	        _this4.tags = data;
	      });
	    }
	  },
	  mounted: function mounted() {
	    if (this.schoolYearId && this.schoolId) {
	      this.readSubjects();
	      this.readTaskCategories();
	      this.readTags();
	    }
	  }
	};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _vuedraggable = __webpack_require__(137);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default, draggable: _vuedraggable2.default },
	  props: {
	    schoolId: {},
	    schoolYearId: {},
	    schoolYear: {
	      name: ''
	    },
	    taskCategories: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    dbSubjectTypes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    locale: {
	      default: 'da'
	    },
	    subjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  directives: {
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      taskCategoriesOrder: [],
	      theEditTask: null,
	      theUpdatingTaskId: null,
	      selectedItem: null,
	      theDeleteTaskCategoryId: null,
	      theDeletedCategoryId: null,
	      dragEvt: null,
	      draggedSubjectType: null,
	      draggedFromCategoryId: null,
	      oldCategoryName: ''
	    };
	  },
	
	  computed: {
	    theDeleteTaskCategory: function theDeleteTaskCategory() {
	      var _this = this;
	
	      return this.theDeleteTaskCategoryId !== null ? this.taskCategoriesOrder.find(function (taskCat) {
	        return taskCat.id === _this.theDeleteTaskCategoryId * 1;
	      }) || null : null;
	    },
	    dbSubjectTypesTranslated: function dbSubjectTypesTranslated() {
	      var _this2 = this;
	
	      return this.dbSubjectTypes.map(function (subjectType) {
	        return {
	          key: subjectType.key,
	          v_title: _this2.getTranslatedSubjectType(subjectType) };
	      }).sort(function (a, b) {
	        return a.v_title.localeCompare(b.v_title);
	      });
	    },
	    getTaskCategoriesOrder: function getTaskCategoriesOrder() {
	      var _this3 = this;
	
	      return this.taskCategoriesOrder.filter(function (taskCat) {
	        return taskCat.id !== _this3.theDeleteTaskCategoryId;
	      });
	    },
	    schoolSettingShownOwnPools: function schoolSettingShownOwnPools() {
	      return this.$store.getters.shownOwnPools;
	    }
	  },
	  watch: {
	    taskCategories: function taskCategories(val) {
	      this.setAllCategories();
	    }
	  },
	  methods: {
	    getIsUsedOnSubjects: function getIsUsedOnSubjects(taskCategory) {
	      return this.subjects.filter(function (subject) {
	        return subject.selected_task_category_id === taskCategory.id;
	      });
	    },
	    resetDrag: function resetDrag() {
	      this.dragEvt.target.classList.remove('isDragging');
	      this.dragEvt.target.style.display = '';
	      this.dragEvt = null;
	      this.draggedSubjectType = null;
	      this.draggedFromCategoryId = null;
	    },
	    dragStart: function dragStart(subjectType, draggedFromCategoryId, evt) {
	      this.draggedSubjectType = subjectType;
	      this.draggedFromCategoryId = draggedFromCategoryId;
	      this.dragEvt = evt;
	      this.dragEvt.target.classList.add('isDragging');
	    },
	    dragEnd: function dragEnd() {
	      if (!this.dragEvt) {
	        return;
	      }
	      this.resetDrag();
	    },
	    dragEnter: function dragEnter(taskCategory, evt) {
	      if (!this.dragEvt) {
	        return;
	      }
	      evt.target.classList.add('isDragEnter');
	    },
	    dragLeave: function dragLeave(evt) {
	      if (!this.dragEvt) {
	        return;
	      }
	      evt.target.classList.remove('isDragEnter');
	    },
	    drop: function drop(taskCategory, evt) {
	      if (!this.dragEvt) {
	        return;
	      }
	      if (this.draggedFromCategoryId !== taskCategory.id) {
	        this.onAddSubjectType(taskCategory, this.draggedSubjectType.key);
	      }
	      this.dragEnd();
	      var elements = this.$refs.droppable_elements;
	      for (var i = 0; i < elements.length; i++) {
	        elements[i].classList.remove('isDragEnter');
	      }
	    },
	    setTheDeleteTaskCategory: function setTheDeleteTaskCategory(taskCategory) {
	      if (!taskCategory) {
	        this.setEditTask(null);
	        this.theDeleteTaskCategoryId = null;
	      }
	      this.theDeleteTaskCategoryId = taskCategory.id;
	    },
	    getFilteredDbSubjectTypes: function getFilteredDbSubjectTypes(taskCategory) {
	      var excludedTypes = ['absence', 'flexin', 'flexout', 'with_kids', 'without_kids', 'exercise', 'reservation', 'frame'];
	      var allExcludedTypes = excludedTypes.concat(taskCategory.subject_types);
	      return this.dbSubjectTypesTranslated.filter(function (subjectType) {
	        return !allExcludedTypes.includes(subjectType.key);
	      });
	    },
	    onChangeCategoryForSubjectType: function onChangeCategoryForSubjectType(taskCategoryId, subjectType) {
	      var newTaskCategory = this.taskCategories.find(function (category) {
	        return category.id === taskCategoryId * 1;
	      });
	      this.onAddSubjectType(newTaskCategory, subjectType);
	    },
	    onAddSubjectType: function onAddSubjectType(taskCategory, val) {
	      var currentTaskCategory = this.taskCategories.find(function (category) {
	        return category.subject_types.includes(val);
	      });
	
	      if (currentTaskCategory) {
	        var currentTaskCategoryTypes = currentTaskCategory.subject_types.filter(function (subjectType) {
	          return subjectType !== val;
	        });
	        this.updateSubjectTypesOnCategory(currentTaskCategory, currentTaskCategoryTypes);
	      }
	
	      if (!taskCategory.subject_types.includes(val)) {
	        var updatedSubjectTypes = [].concat((0, _toConsumableArray3.default)(taskCategory.subject_types), [val]);
	        this.updateSubjectTypesOnCategory(taskCategory, updatedSubjectTypes);
	      }
	    },
	    updateSchoolSettings: function updateSchoolSettings(setting) {
	      var isDelete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!isDelete && this.oldCategoryName === setting) {
	        return;
	      }
	      var saveKey = 'shownOwnPools';
	      var oldSettingName = !isDelete ? this.oldCategoryName : setting;
	      var arr = [].concat((0, _toConsumableArray3.default)(this.schoolSettingShownOwnPools));
	      var index = arr.indexOf(oldSettingName);
	
	      if (index !== -1) {
	        arr.splice(index, 1);
	        if (!isDelete) {
	          arr.push(setting);
	        }
	      }
	      if (arr.length > 0) {
	        this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, saveKey, arr));
	      } else {
	        if (this.schoolSettings[saveKey]) {
	          this.$store.dispatch('deleteSchoolSetting', saveKey);
	        }
	      }
	    },
	    updateSubjectTypesOnCategory: function updateSubjectTypesOnCategory(taskCategory, subjectTypes) {
	      var _this4 = this;
	
	      _docendo2.default.updateTaskCategory(this.schoolId, this.schoolYearId, taskCategory.id, taskCategory.name, taskCategory.rank, subjectTypes, function (success) {
	        _this4.$emit('updateCategory', success);
	        _this4.setEditTask(null);
	        _this4.theUpdatingTaskId = null;
	        _this4.selectedItem = null;
	      }, function (failure) {
	        console.log('Failed to update category');
	        _this4.setEditTask(null);
	        _this4.theUpdatingTaskId = null;
	      });
	    },
	    saveEditTask: function saveEditTask() {
	      var _this5 = this;
	
	      if (this.theEditTask.name.length === 0) {
	        window.alert('må ikke være tom');
	        return;
	      }
	      this.theUpdatingTaskId = this.theEditTask.id;
	      _docendo2.default.updateTaskCategory(this.schoolId, this.schoolYearId, this.theEditTask.id, this.theEditTask.name, this.theEditTask.rank, this.theEditTask.subject_types, function (success) {
	        _this5.updateSchoolSettings(success.name, false);
	        _this5.$emit('updateCategory', success);
	        _this5.setEditTask(null);
	        _this5.theUpdatingTaskId = null;
	      }, function (failure) {
	        console.log('Failed to update category');
	        _this5.setEditTask(null);
	        _this5.theUpdatingTaskId = null;
	      });
	    },
	    getIsTheEditTask: function getIsTheEditTask(taskCategory) {
	      return this.theEditTask && this.theEditTask.id === taskCategory.id;
	    },
	    setEditTask: function setEditTask(taskCategory) {
	      if (taskCategory) {
	        this.oldCategoryName = taskCategory.name;
	      } else {
	        this.oldCategoryName = '';
	      }
	      this.theEditTask = JSON.parse((0, _stringify2.default)(taskCategory));
	      this.$emit('onSetEditTask', taskCategory);
	    },
	    deleteTaskCategory: function deleteTaskCategory(taskCategory) {
	      var _this6 = this;
	
	      this.theDeletedCategoryId = taskCategory.id;
	      _docendo2.default.deleteTaskCategory(this.schoolId, this.schoolYearId, this.theDeletedCategoryId, function (success) {
	        _this6.updateSchoolSettings(taskCategory.name, true);
	        _this6.$emit('onDeleteTaskCategory', _this6.theDeletedCategoryId);
	        _this6.theDeletedCategoryId = null;
	        _this6.setTheDeleteTaskCategory(null);
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    onChangeOrder: function onChangeOrder(evt) {
	      var _this7 = this;
	
	      var movedCategory = evt.moved.element;
	
	      var newIndex = evt.moved.newIndex;
	
	      var prevCategory = this.taskCategoriesOrder[newIndex - 1];
	      var nextCategory = this.taskCategoriesOrder[newIndex + 1];
	
	      var newRank = void 0;
	      if (prevCategory && nextCategory) {
	        newRank = (prevCategory.rank + nextCategory.rank) / 2;
	      } else if (prevCategory) {
	        newRank = prevCategory.rank + 1;
	      } else if (nextCategory) {
	        newRank = nextCategory.rank - 1;
	      } else {
	        newRank = movedCategory.rank;
	      }
	
	      movedCategory.rank = newRank;
	
	      _docendo2.default.updateTaskCategory(this.schoolId, this.schoolYearId, movedCategory.id, movedCategory.name, movedCategory.rank, movedCategory.subject_types, function (success) {
	        _this7.$emit('updateCategory', success);
	      }, function (failure) {
	        console.log('Failed to update category ' + movedCategory.id);
	      });
	    },
	    getTranslatedSubjectType: function getTranslatedSubjectType(subjectType) {
	      return subjectType && subjectType.i18n && subjectType.i18n[this.locale] || subjectType.key;
	    },
	    setAllCategories: function setAllCategories() {
	      var _this8 = this;
	
	      this.taskCategoriesOrder = this.taskCategories.map(function (taskCategory) {
	        return (0, _extends3.default)({}, taskCategory, {
	          v_is_used_on_subjects: _this8.getIsUsedOnSubjects(taskCategory),
	          v_subject_types: taskCategory.subject_types.map(function (subjectType) {
	            var dbSubjectType = _this8.dbSubjectTypes.find(function (dbSubjectType) {
	              return dbSubjectType.key === subjectType;
	            });
	            return {
	              key: subjectType,
	              v_name: _this8.getTranslatedSubjectType(dbSubjectType)
	            };
	          })
	        });
	      }).sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.setAllCategories();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.setEditTask(null);
	  }
	};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    taskCategories: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    theEditCategory: {},
	    schoolId: {},
	    schoolYearId: {}
	  },
	  data: function data() {
	    return {
	      title: '',
	      isSubmitting: false,
	      isTitleAlreadyCreated: false
	    };
	  },
	
	  methods: {
	    onClose: function onClose() {
	      this.$emit('close');
	    },
	    createCategory: function createCategory() {
	      var _this = this;
	
	      if (this.title.length < 1) {
	        return;
	      }
	      this.isTitleAlreadyCreated = this.taskCategories.filter(function (cat) {
	        return cat.name === _this.title;
	      }).length > 0;
	      if (this.isTitleAlreadyCreated) {
	        return;
	      }
	      this.isSubmitting = true;
	
	      var highestRank = Math.max.apply(null, this.taskCategories.map(function (item) {
	        return item.rank;
	      }));
	
	      if (highestRank === -Infinity) {
	        highestRank = 0;
	      }
	
	      var nextRank = Math.ceil(highestRank + 1);
	      var subjectTypes = [];
	
	      _docendo2.default.createTaskCategory(this.schoolId, this.schoolYearId, this.title, nextRank, subjectTypes, function (success) {
	        _this.$emit('onNewCategory', success);
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.$nextTick(function (_) {
	      var el = _this2.$refs.title_input;
	      if (el) {
	        el.focus();
	      }
	    });
	  }
	};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _set = __webpack_require__(52);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _DoFiltersFilter = __webpack_require__(29);
	
	var _DoFiltersFilter2 = _interopRequireDefault(_DoFiltersFilter);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _vueVirtualScrollList = __webpack_require__(360);
	
	var _vueVirtualScrollList2 = _interopRequireDefault(_vueVirtualScrollList);
	
	var _TaskOverviewSettingsCategoriesTasksTask = __webpack_require__(1375);
	
	var _TaskOverviewSettingsCategoriesTasksTask2 = _interopRequireDefault(_TaskOverviewSettingsCategoriesTasksTask);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  subject: 'Fag',
	  optional: 'Valgfag/Hold',
	  supplemental: 'UUV',
	  frame: 'Temavisning (Ramme)',
	  break: 'Pause',
	  resource: 'Ressource (synlig)',
	  person_resource: 'Ressource (skjult)',
	  other_tasks: 'Anden tid',
	  other_stuff: 'Øvrig tid',
	  available: 'Rådighedstime',
	  person_resource_visible: 'Ressource (synlig)',
	  club: 'SFO tid',
	  additional_tasks: 'Øvrige opgaver',
	  preparation: 'Forberedelse',
	  with_kids: 'Tid med børn',
	  without_kids: 'Tid uden børn',
	  pool: 'Lokalpulje',
	  absence: 'Fravær',
	  _extra_time_at_start_of_day_: 'Ekstra tid for start på dag',
	  reservation: 'Reservation'
	};
	
	exports.default = {
	  components: { Loader: _Loader2.default, DoFiltersFilter: _DoFiltersFilter2.default, virtualList: _vueVirtualScrollList2.default, TaskOverviewSettingsCategoriesTasksTask: _TaskOverviewSettingsCategoriesTasksTask2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    schoolId: {},
	    schoolYearId: {},
	    subjects: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    taskCategories: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    allCalendarsInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    allUsersInHash: {
	      type: Object,
	      default: function _default() {}
	    },
	    tags: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isInitLoad: true,
	      itemComponent: _TaskOverviewSettingsCategoriesTasksTask2.default,
	      selectedSubjects: [],
	      isDropdown: false,
	      isUpdating: false,
	      selectedTags: [],
	      selectedPersons: [],
	      selectedSubjectsNames: [],
	      selectedTypes: [],
	      sortKey: '',
	      sortDirection: 'asc' };
	  },
	
	  computed: {
	    selectedSubjectIds: function selectedSubjectIds() {
	      return new _set2.default(this.selectedSubjects.map(function (s) {
	        return s.id;
	      }));
	    },
	    sortIcon: function sortIcon() {
	      return this.sortDirection === 'asc' ? '▲' : '▼';
	    },
	    sortedSubjects: function sortedSubjects() {
	      var _this = this;
	
	      return [].concat((0, _toConsumableArray3.default)(this.filteredSubjects)).sort(function (a, b) {
	        if (!_this.sortKey) return 0;
	
	        var valueA = _this.getNestedValue(a, _this.sortKey);
	        var valueB = _this.getNestedValue(b, _this.sortKey);
	
	        if (typeof valueA === 'string' && typeof valueB === 'string') {
	          return _this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
	        }
	
	        return _this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
	      });
	    },
	    persons: function persons() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.subjects.map(function (subject) {
	        return subject.calendar.name;
	      }))));
	    },
	    subjectNames: function subjectNames() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.subjects.map(function (subject) {
	        return subject.subject.name;
	      }))));
	    },
	    subjectTypes: function subjectTypes() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.subjects.map(function (subject) {
	        var i18n = I18N[subject.subject.subject_type];
	        return i18n || subject.subject.subject_type;
	      }))));
	    },
	    subjectsWithType: function subjectsWithType() {
	      var _this2 = this;
	
	      return this.subjects.map(function (subject) {
	        var i18n = I18N[subject.subject.subject_type];
	        return (0, _extends3.default)({}, subject, {
	          v_type: i18n || subject.subject.subject_type,
	          v_DefaultCategory: _this2.getDefaultTaskCategory(subject),
	          v_tags: _this2.getTags(subject)
	        });
	      });
	    },
	    filteredSubjects: function filteredSubjects() {
	      var _this3 = this;
	
	      return this.subjectsWithType.filter(function (subject) {
	        var matchesPerson = _this3.selectedPersons.length === 0 || _this3.selectedPersons.includes(subject.calendar.name);
	        var matchesSubjectName = _this3.selectedSubjectsNames.length === 0 || _this3.selectedSubjectsNames.includes(subject.subject.name);
	        var matchesType = _this3.selectedTypes.length === 0 || _this3.selectedTypes.includes(subject.v_type);
	        var matchesTags = _this3.selectedTags.length === 0 || subject.v_tags.some(function (tag) {
	          return _this3.selectedTags.includes(tag);
	        });
	
	        return matchesPerson && matchesSubjectName && matchesType && matchesTags;
	      });
	    }
	  },
	  methods: {
	    getTags: function getTags(subject) {
	      if (!subject.calendar || !subject.calendar.user_id) {
	        return [];
	      }
	      var user = this.allUsersInHash[subject.calendar.user_id];
	      return user && user.user_tags ? user.user_tags : [];
	    },
	    getDefaultTaskCategory: function getDefaultTaskCategory(subject) {
	      return this.taskCategories.find(function (taskCat) {
	        return taskCat.id === subject.default_task_category_id;
	      });
	    },
	    sortBy: function sortBy(column) {
	      if (this.sortKey === column) {
	        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
	      } else {
	        this.sortKey = column;
	        this.sortDirection = 'asc';
	      }
	    },
	    getNestedValue: function getNestedValue(obj, path) {
	      return path.split('.').reduce(function (acc, part) {
	        return acc && acc[part];
	      }, obj) || '';
	    },
	    onSelectPerson: function onSelectPerson(person) {
	      this.toggleSelection(this.selectedPersons, person);
	    },
	    onSelectTags: function onSelectTags(tag) {
	      this.toggleSelection(this.selectedTags, tag);
	    },
	    onSelectSubject: function onSelectSubject(subjectName) {
	      this.toggleSelection(this.selectedSubjectsNames, subjectName);
	    },
	    onSelectType: function onSelectType(type) {
	      this.toggleSelection(this.selectedTypes, type);
	    },
	    toggleSelection: function toggleSelection(array, value) {
	      var idx = array.indexOf(value);
	      if (idx < 0) {
	        array.push(value);
	      } else {
	        array.splice(idx, 1);
	      }
	    },
	    updateSubjectTaskCategory: function updateSubjectTaskCategory(subject, value) {
	      var _this4 = this;
	
	      this.isUpdating = true;
	      var updates = [{ id: subject.id, selected_task_category_id: value }];
	      _docendo2.default.bulkUpdateSubjectCalendars(this.schoolId, this.schoolYearId, updates, function (success) {
	        _this4.$emit('updateSubjects', updates);
	        _this4.isUpdating = false;
	        _this4.closeDropdown(false);
	      }, function (failure) {
	        console.log('failure');
	        _this4.isUpdating = false;
	        _this4.closeDropdown(false);
	      });
	    },
	    setTasksCategory: function setTasksCategory(taskCategory) {
	      var _this5 = this;
	
	      this.isUpdating = true;
	      var updates = this.selectedSubjects.map(function (selectedSubject) {
	        return {
	          id: selectedSubject.id,
	          selected_task_category_id: taskCategory.id
	        };
	      });
	      _docendo2.default.bulkUpdateSubjectCalendars(this.schoolId, this.schoolYearId, updates, function (success) {
	        _this5.$emit('updateSubjects', updates);
	        _this5.isUpdating = false;
	        _this5.closeDropdown(false);
	      }, function (failure) {
	        console.log('failure');
	        _this5.isUpdating = false;
	        _this5.closeDropdown(false);
	      });
	    },
	    onClickAway: function onClickAway() {
	      if (!this.isDropdown) return;
	      this.selectedSubjects = [];
	      this.isDropdown = false;
	    },
	    closeDropdown: function closeDropdown() {
	      this.isDropdown = false;
	      this.selectedSubjects = [];
	    },
	    setIsDropdown: function setIsDropdown() {
	      this.isDropdown = !this.isDropdown;
	    },
	    toggleAll: function toggleAll() {
	      if (this.selectedSubjects.length > 0) {
	        this.selectedSubjects = [];
	      } else {
	        this.selectedSubjects = [].concat((0, _toConsumableArray3.default)(this.filteredSubjects));
	      }
	    },
	    toggleSubject: function toggleSubject(subject) {
	      var idx = this.selectedSubjects.findIndex(function (selectedSubjects) {
	        return selectedSubjects.id === subject.id;
	      });
	      if (idx < 0) {
	        this.selectedSubjects.push(subject);
	      } else {
	        this.selectedSubjects.splice(idx, 1);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    setTimeout(function (_) {
	      _this6.isInitLoad = false;
	    }, 100);
	  }
	};

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    source: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    toggleSubject: {
	      type: Function
	    },
	    updateSubjectTaskCategory: {
	      type: Function
	    },
	    selectedSubjects: {
	      default: function _default() {
	        return function () {
	          return [];
	        };
	      }
	    },
	    taskCategories: {
	      default: function _default() {
	        return function () {
	          return [];
	        };
	      }
	    },
	    selectedSubjectIds: {
	      default: function _default() {
	        return function () {};
	      }
	    },
	    index: {
	      type: Number
	    }
	  },
	  computed: {
	    subject: function subject() {
	      return this.source;
	    },
	    isSelected: function isSelected() {
	      return this.selectedSubjectIds.has(this.subject.id);
	    }
	  }
	};

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    videoId: {
	      type: String,
	      required: true,
	      default: 1056171188
	    }
	  },
	  computed: {
	    videoSrc: function videoSrc() {
	      return "https://player.vimeo.com/video/" + this.videoId + "?badge=0&autopause=0&player_id=0&app_id=58479";
	    }
	  }
	};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { AppToggle: _AppToggle2.default },
	  props: {
	    taskCategories: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isOn: true,
	      schoolSettingsKey: 'hiddenTaskDistributionCategories',
	      schoolSettingsKey2: 'shownOwnPools',
	      isActive: false,
	      thresholdToHideTaskHours: 0
	    };
	  },
	
	  computed: {
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    hiddenTaskDistributionCategories: function hiddenTaskDistributionCategories() {
	      return this.$store.getters.hiddenTaskDistributionCategories;
	    },
	    schoolThresholdToHideTaskHours: function schoolThresholdToHideTaskHours() {
	      return this.schoolSettings && this.schoolSettings['thresholdToHideTaskHours'] ? this.schoolSettings['thresholdToHideTaskHours'] : null;
	    },
	    schoolSettingShownOwnPools: function schoolSettingShownOwnPools() {
	      return this.$store.getters.shownOwnPools;
	    }
	  },
	  methods: {
	    setIsActive: function setIsActive() {
	      var _this = this;
	
	      this.isActive = !this.isActive;
	      if (!this.isActive) {
	        this.thresholdToHideTaskHours = 0;
	        this.onSave();
	      } else {
	        this.$nextTick(function (_) {
	          _this.$refs.the_input_field.focus();
	        });
	      }
	    },
	    onSave: function onSave() {
	      var key = 'thresholdToHideTaskHours';
	      if (!this.isActive) {
	        this.$store.dispatch('deleteSchoolSetting', key);
	      } else {
	        var val = this.thresholdToHideTaskHours * 1;
	        if (isNaN(Number(val))) {
	          _eventbus2.default.toast = { text: 'Kan ikke gemme. Skal være et tal', 'success': false };
	          return;
	        }
	        this.$store.dispatch('updateSchoolSettings', { 'thresholdToHideTaskHours': val });
	      }
	    },
	    getIsOn: function getIsOn(setting) {
	      return !this.hiddenTaskDistributionCategories.includes(setting);
	    },
	    getIsOwnPoolOn: function getIsOwnPoolOn(settingId) {
	      return this.schoolSettingShownOwnPools.includes(settingId);
	    },
	    setIsOn: function setIsOn() {
	      this.isOn = !this.isOn;
	    },
	    toggleSettings: function toggleSettings(setting) {
	      var arr = [].concat((0, _toConsumableArray3.default)(this.hiddenTaskDistributionCategories));
	      var index = arr.indexOf(setting);
	
	      if (index !== -1) {
	        arr.splice(index, 1);
	      } else {
	        arr.push(setting);
	      }
	
	      if (arr.length > 0) {
	        this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, this.schoolSettingsKey, arr));
	      } else {
	        if (this.schoolSettings[this.schoolSettingsKey]) {
	          this.$store.dispatch('deleteSchoolSetting', this.schoolSettingsKey);
	        }
	      }
	    },
	    toggleOwnPool: function toggleOwnPool(setting) {
	      var arr = [].concat((0, _toConsumableArray3.default)(this.schoolSettingShownOwnPools));
	      var index = arr.indexOf(setting);
	
	      if (index !== -1) {
	        arr.splice(index, 1);
	      } else {
	        arr.push(setting);
	      }
	
	      if (arr.length > 0) {
	        this.$store.dispatch('updateSchoolSettings', (0, _defineProperty3.default)({}, this.schoolSettingsKey2, arr));
	      } else {
	        if (this.schoolSettings[this.schoolSettingsKey2]) {
	          this.$store.dispatch('deleteSchoolSetting', this.schoolSettingsKey2);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.schoolThresholdToHideTaskHours) {
	      this.isActive = true;
	      this.thresholdToHideTaskHours = this.schoolThresholdToHideTaskHours;
	    }
	  }
	};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserTasks = __webpack_require__(44);
	
	var _UserTasks2 = _interopRequireDefault(_UserTasks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { UserTasks: _UserTasks2.default },
	  props: {
	    theActiveUserId: {
	      default: null
	    },
	    users: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    schoolYear: {
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  computed: {
	    theActiveUser: function theActiveUser() {
	      var _this = this;
	
	      if (!this.theActiveUserId) {
	        if (this.users.length > 0) {
	          return this.users[0];
	        }
	        return null;
	      }
	      return this.users.find(function (user) {
	        return user.id === _this.theActiveUserId * 1;
	      });
	    }
	  }
	};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TeamCalendarHeader = __webpack_require__(1379);
	
	var _TeamCalendarHeader2 = _interopRequireDefault(_TeamCalendarHeader);
	
	var _DScheduler = __webpack_require__(1247);
	
	var _DScheduler2 = _interopRequireDefault(_DScheduler);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DCalendar = __webpack_require__(58);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Collisions = __webpack_require__(1220);
	
	var _Collisions2 = _interopRequireDefault(_Collisions);
	
	var _DCalendarShowEvent = __webpack_require__(68);
	
	var _DCalendarShowEvent2 = _interopRequireDefault(_DCalendarShowEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DCalendarShowEvent: _DCalendarShowEvent2.default, Collisions: _Collisions2.default, DCalendar: _DCalendar2.default, calHeader: _TeamCalendarHeader2.default, dScheduler: _DScheduler2.default, spinner: _Loader2.default },
	  data: function data() {
	    return {
	      i18n: {
	        da: {
	          button_text: 'Skema-<br>overblik',
	          team_calendar: 'Skemaoverblik',
	          loading_events: 'Henter lektioner..'
	        },
	        en: {
	          button_text: 'Schedule<br>overview',
	          team_calendar: 'Schedule overview',
	          loading_events: 'Loading events..'
	        },
	        nb: {
	          button_text: 'Timeplan-<br>overblikk',
	          team_calendar: 'Timeplanoverblikk',
	          loading_events: 'Loading events..'
	        }
	      },
	      showTeamCalendar: false,
	      calView: 'resourceTimeGridFiveDay',
	      date: (0, _moment2.default)().format('YYYY-MM-DD 00:00'),
	      maxRessLength: 4,
	      selectedRess: [],
	      events: [],
	      prevCounter: 0,
	      nextCounter: 0,
	      todayCounter: 0,
	      theSchedulerCalendars: [],
	      theSchedulerEvents: [],
	      rooms: [],
	      isLoading: false,
	      isLoadingEvents: false,
	      timeout: null,
	      _keyListener: null,
	      theSortOptionForAllSchedules: null,
	      activeEvent: null,
	      activeCalendar: null,
	      activeEventCalendarId: null,
	      selectedScrollOption: ''
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    schoolId: function schoolId() {
	      return this.$store ? this.$store.getters.schoolId : window.SCHOOL.id;
	    },
	    locale: function locale() {
	      return this.user && this.user.locale ? this.user.locale : 'en';
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    allCalendars: function allCalendars() {
	      return this.$store.state.calendars;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    isListView: function isListView() {
	      return this.calView === 'listView';
	    },
	    isSchedulerView: function isSchedulerView() {
	      return this.calView === 'schedulerView';
	    },
	    isShowSchedulerShortcut: function isShowSchedulerShortcut() {
	      return this.calView === 'scheduler' || this.calView === 'scheduler__all_cals' || this.calView === 'scheduler__all_users';
	    },
	    isCalendarView: function isCalendarView() {
	      return this.calView === 'resourceTimeGridFiveDay' || this.calView === 'resourceTimeGridDay' || this.calView === 'listView';
	    },
	    isShowWeek: function isShowWeek() {
	      return this.calView !== 'resourceTimeGridDay';
	    },
	    startDate: function startDate() {
	      var startDate = (0, _moment2.default)(this.date).format('YYYY-MM-DD 00:00');
	      if (this.calView === 'resourceTimeGridFiveDay' || this.calView === 'listView') {
	        startDate = (0, _moment2.default)(this.date).isoWeekday(1).format('YYYY-MM-DD 00:00');
	      }
	      return startDate;
	    },
	    endDate: function endDate() {
	      var endDate = (0, _moment2.default)(this.date).format('YYYY-MM-DD 23:59');
	      if (this.calView === 'resourceTimeGridFiveDay' || this.calView === 'listView') {
	        if (this.isShowWeekends) {
	          endDate = (0, _moment2.default)(this.date).isoWeekday(7).format('YYYY-MM-DD 23:59');
	        } else {
	          endDate = (0, _moment2.default)(this.date).isoWeekday(5).format('YYYY-MM-DD 23:59');
	        }
	        if (this.userCustomNumberOfDays) {
	          endDate = (0, _moment2.default)(this.date).isoWeekday(this.userCustomNumberOfDays).format('YYYY-MM-DD 23:59');
	        }
	      }
	      return endDate;
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      var isInSameMonth = (0, _moment2.default)(this.startDate).format('MM') === (0, _moment2.default)(this.endDate).format('MM');
	      var start = isInSameMonth ? (0, _moment2.default)(this.startDate).format('DD[.]') : (0, _moment2.default)(this.startDate).format('DD[.] MMM');
	      if (this.locale !== 'en') {
	        if (this.calView !== 'resourceTimeGridDay') {
	          return start + ' - ' + (0, _moment2.default)(this.endDate).format('DD[.] MMM[,] YYYY');
	        } else {
	          return (0, _moment2.default)(this.endDate).format('DD[.] MMM[,] YYYY');
	        }
	      } else {
	        start = (0, _moment2.default)(this.startDate).format('MMM DD');
	        var end = isInSameMonth ? (0, _moment2.default)(this.endDate).format('DD[,] YYYY') : (0, _moment2.default)(this.endDate).format('MMM DD[,] YYYY');
	        if (this.calView !== 'resourceTimeGridDay') {
	          return start + ' - ' + end;
	        } else {
	          return (0, _moment2.default)(this.endDate).format('MMM DD[,] YYYY');
	        }
	      }
	    },
	    startTime: function startTime() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
	        var end = (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.end);
	        var start = (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.start);
	        if ((0, _moment2.default)(start).isBefore(end)) {
	          return (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.start).format('HH:mm:00');
	        } else {
	          this.$store.dispatch('deleteUserSetting', 'teamCalendarSettingTimes');
	        }
	      } else {
	        return '07:00:00';
	      }
	    },
	    endTime: function endTime() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
	        return (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.end).format('HH:mm:00');
	      } else {
	        return '16:00:00';
	      }
	    },
	    isShowWeekends: function isShowWeekends() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.isShowWeekends) {
	        return this.userSettings.teamCalendarSettingTimes.isShowWeekends;
	      } else {
	        return false;
	      }
	    },
	    userCustomNumberOfDays: function userCustomNumberOfDays() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.numberOfDays) {
	        return this.userSettings.teamCalendarSettingTimes.numberOfDays;
	      } else {
	        return null;
	      }
	    },
	    schedulerDate: function schedulerDate() {
	      return (0, _moment2.default)(this.date).format('dddd') + ', ' + (0, _moment2.default)(this.date).format('ll');
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    allUsersInCalIdHash: function allUsersInCalIdHash() {
	      return this.$store.getters.allUsersInCalIdHash;
	    },
	    roomsGetter: function roomsGetter() {
	      return this.$store.getters.roomCalendars;
	    },
	    eventsInHash: function eventsInHash() {
	      var eventsHash = {};
	      this.events.forEach(function (event) {
	        if (event.event_type === 'presence') {
	          var calId = event.calendar_id;
	          if (!eventsHash[calId]) {
	            eventsHash[calId] = [event];
	          } else {
	            eventsHash[calId].push(event);
	          }
	        } else {
	          event.calendars.forEach(function (calendar) {
	            var calId = calendar.calendar_id;
	            if (!eventsHash[calId]) {
	              eventsHash[calId] = [event];
	            } else {
	              eventsHash[calId].push(event);
	            }
	          });
	        }
	      });
	      return eventsHash;
	    },
	    isUserCanEditCalendar: function isUserCanEditCalendar() {
	      return this.$store.getters.isUserCanEditCalendar;
	    }
	  },
	  methods: {
	    readInitialScrollOption: function readInitialScrollOption() {
	      var key = 'd_team_calendar_scroll_option';
	      var val = this.$helpers.getLocalStorage(key);
	      if (val) {
	        this.selectedScrollOption = val;
	      }
	    },
	    setSelectedScrollOption: function setSelectedScrollOption(val) {
	      this.selectedScrollOption = val;
	      var key = 'd_team_calendar_scroll_option';
	      if (val === '') {
	        this.$helpers.removeLocalStorage(key);
	      } else {
	        this.$helpers.setLocalStorage(key, val);
	      }
	    },
	    setSortOption: function setSortOption(sortBy) {
	      this.theSortOptionForAllSchedules = sortBy;
	    },
	    getCalendarEvents: function getCalendarEvents(calendarId) {
	      return this.eventsInHash[calendarId] ? this.eventsInHash[calendarId] : [];
	    },
	    setNextDay: function setNextDay() {
	      var newDate = (0, _moment2.default)(this.date).add(1, 'days');
	      this.setDate(newDate);
	    },
	    setPrevDay: function setPrevDay() {
	      var newDate = (0, _moment2.default)(this.date).subtract(1, 'days');
	      this.setDate(newDate);
	    },
	    setDate: function setDate(mom) {
	      var _this = this;
	
	      this.date = mom;
	      if (this.calView === 'doubleBookings') {
	        return;
	      }
	      setTimeout(function (_) {
	        _this.getEvents();
	      }, 0);
	    },
	    setCalView: function setCalView(val) {
	      if (this.calView === val) {
	        return;
	      }
	      if (val === 'scheduler') {
	        this.theSchedulerCalendars = this.roomsGetter;
	      }
	      if (val === 'scheduler__all_cals') {
	        this.theSchedulerCalendars = this.$helpers.sortArrOnName(this.allCalendars);
	      }
	      if (val === 'scheduler__all_users') {
	        this.theSchedulerCalendars = this.userCalendars;
	      }
	      this.calView = val;
	      this.getEvents();
	    },
	    setCalDate: function setCalDate(calDate) {
	      if ((0, _moment2.default)(this.date).format('YYYY-MM-DD') !== (0, _moment2.default)(calDate).format('YYYY-MM-DD')) {
	        this.date = calDate;
	      }
	    },
	    setToday: function setToday() {
	      this.todayCounter++;
	      this.date = (0, _moment2.default)();
	    },
	    setSelectedRess: function setSelectedRess(calendars) {
	      var _this2 = this;
	
	      this.selectedRess = [];
	      calendars.forEach(function (calendar) {
	        _this2.selectedRess.push(calendar);
	      });
	    },
	    updateEvents: function updateEvents($event) {
	      var _this3 = this;
	
	      setTimeout(function (_) {
	        _this3.getEvents();
	      }, 0);
	    },
	    setView: function setView() {
	      this.getEvents();
	    },
	    getEvents: function getEvents() {
	      var _this4 = this;
	
	      if (this.calView === 'doubleBookings') {
	        return;
	      }
	      if (this.isShowSchedulerShortcut) {
	        var _calendarIds = this.theSchedulerCalendars.map(function (cal) {
	          return cal.id;
	        });
	        this.isLoadingEvents = true;
	        this.theSchedulerEvents = [];
	        _docendo2.default.eventsFromCalendars(_calendarIds, this.startDate, this.endDate, null, function (data) {
	          var events = data.length > 0 ? JSON.parse(data) : [];
	          _this4.theSchedulerEvents = events;
	          _this4.isLoadingEvents = false;
	        });
	        return;
	      }
	      if (this.selectedRess.length === 0) {
	        return;
	      }
	      var calendarIds = this.selectedRess.map(function (user) {
	        return user.id;
	      });
	      this.isLoadingEvents = true;
	      this.events = [];
	      _docendo2.default.eventsFromCalendars(calendarIds, this.startDate, this.endDate, null, function (data) {
	        var events = data.length > 0 ? JSON.parse(data) : [];
	        _this4.events = events;
	        _this4.isLoadingEvents = false;
	      });
	    },
	    setShowTeamCalendar: function setShowTeamCalendar() {
	      var _this5 = this;
	
	      this.showTeamCalendar = true;
	      if (this.selectedRess.length > 0) {
	        this.getEvents();
	      }
	      var body = document.querySelector('body');
	      if (!body.classList.contains('no-scroll')) {
	        body.classList.add('no-scroll');
	      }
	      var onEscape = function onEscape(e) {
	        if (_this5.showTeamCalendar && e.keyCode === 27) {
	          _this5.closeTeamCalendar();
	        }
	      };
	      document.addEventListener('keydown', onEscape);
	      this.$once('hook:destroyed', function () {
	        document.removeEventListener('keydown', onEscape);
	      });
	    },
	    closeTeamCalendar: function closeTeamCalendar() {
	      this.showTeamCalendar = false;
	      var body = document.querySelector('body');
	      body.classList.remove('no-scroll');
	    },
	    toggleShowTeamCalendar: function toggleShowTeamCalendar() {
	      if (this.showTeamCalendar) {
	        this.closeTeamCalendar();
	      } else {
	        this.setShowTeamCalendar();
	      }
	    },
	    setActiveEvent: function setActiveEvent(event, calendar) {
	      if (!this.isUserCanEditCalendar) {
	        return;
	      }
	      if (!event) {
	        this.activeEvent = null;
	        this.activeCalendar = null;
	        this.activeEventCalendarId = null;
	      } else {
	        this.activeEvent = event.obj;
	        this.activeCalendar = calendar;
	        this.activeEventCalendarId = calendar.id;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this6 = this;
	
	    window.addEventListener('vue_open_teamcalendar', function (e) {
	      _this6.setShowTeamCalendar();
	    });
	    this.readInitialScrollOption();
	    this.calView = this.userSettings['teamcalendar_view__tab_1'];
	    this.theSortOptionForAllSchedules = this.userSettings['teamcalendar_view__sort_option'];
	  },
	  mounted: function mounted() {
	    this._keyListener = function (e) {
	      if (e.key === 's') {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.toggleShowTeamCalendar();
	        }
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(15);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _TimeChanger = __webpack_require__(36);
	
	var _TimeChanger2 = _interopRequireDefault(_TimeChanger);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _DSelectCalsAll = __webpack_require__(303);
	
	var _DSelectCalsAll2 = _interopRequireDefault(_DSelectCalsAll);
	
	var _TeamCalendarHeaderSaveView = __webpack_require__(1380);
	
	var _TeamCalendarHeaderSaveView2 = _interopRequireDefault(_TeamCalendarHeaderSaveView);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    views: 'Visning',
	    shortcuts: 'Genveje',
	    room_overview: 'Alle lokaler',
	    close_room_overview: 'Luk lokaleoverblik',
	    show_day: 'Vis en dag',
	    show_week: 'Vis en uge',
	    show_double_bookings: 'Vis dobbeltbookinger',
	    close_double_bookings: 'Luk dobbeltbookinger',
	    show_list: 'Vis som liste',
	    show_scheduler: 'Vis som overblik',
	    custom: 'Tilpasset',
	    all_calendars: 'Alle kalendere',
	    sort_by: 'Sorter efter',
	    name: 'Navn',
	    first_lesson: 'Første lektion',
	    last_lesson: 'Sidste lektion',
	    all_users: 'Alle brugere',
	    scroll_up_and_down: 'Scroll op/ned',
	    scroll_sideways: 'Scroll til siden'
	  },
	  en: {
	    views: 'View',
	    shortcuts: 'Shortcuts',
	    room_overview: 'All rooms',
	    close_room_overview: 'Close rooms overview',
	    show_day: 'Show day',
	    show_week: 'Show week',
	    show_double_bookings: 'Show double bookings',
	    close_double_bookings: 'Close double bookings',
	    show_list: 'Show as list',
	    show_scheduler: 'Show scheduler',
	    custom: 'Custom',
	    all_calendars: 'All calendars',
	    sort_by: 'Sort by',
	    name: 'Name',
	    first_lesson: 'First lesson',
	    last_lesson: 'Last lesson',
	    all_users: 'All users',
	    scroll_up_and_down: 'Scroll up/down',
	    scroll_sideways: 'Scroll sideways'
	  },
	  nb: {
	    views: 'Visning',
	    shortcuts: 'Snarveier',
	    room_overview: 'Alle rom',
	    close_room_overview: 'Lukk dagens romoverblikk',
	    show_day: 'Vis dag',
	    show_week: 'Vis uke',
	    show_double_bookings: 'Vis dobbeltbookinger',
	    close_double_bookings: 'Lukk dobbeltbookinger',
	    show_list: 'Vis som liste',
	    show_scheduler: 'Vis skemaoverblikk',
	    custom: 'Tilpasset',
	    all_calendars: 'Alle kalendere',
	    sort_by: 'Sorter etter',
	    name: 'Navn',
	    first_lesson: 'Første leksjon',
	    last_lesson: 'Siste leksjon',
	    all_users: 'Alle brukere',
	    scroll_up_and_down: 'Scroll opp/ned',
	    scroll_sideways: 'Scroll til siden'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, dSelectAll: _DSelectCalsAll2.default, AppToggle: _AppToggle2.default, DatePicker: _DateSelector2.default, DModal: _DModal2.default, TimeChanger: _TimeChanger2.default, TeamCalendarHeaderSaveView: _TeamCalendarHeaderSaveView2.default },
	  props: {
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    calview: {
	      type: String,
	      default: 'resourceTimeGridFiveDay'
	    },
	    isNotThisWeek: {
	      type: Boolean,
	      default: true
	    },
	    itemsSelected: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedScrollOption: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      theTab: 1,
	      isShowSettings: false,
	      isShowWeekends: false,
	      showViewOptions: true,
	      standardStartTime: (0, _moment2.default)().set({ 'hour': 7, 'minutes': 0 }),
	      standardEndTime: (0, _moment2.default)().set({ 'hour': 16, 'minutes': 0 }),
	      theSortOptionForAllSchedules: null,
	      isSetCustomNumberOfDays: false,
	      numberOfDays: 5
	    };
	  },
	
	  computed: {
	    scrollOptions: function scrollOptions() {
	      return [{ value: '', title: this.i18n[this.locale]['scroll_up_and_down'] }, { value: 'horizontal', title: this.i18n[this.locale]['scroll_sideways'] }];
	    },
	    theSelectedScrollOption: function theSelectedScrollOption() {
	      var _this = this;
	
	      return this.scrollOptions.find(function (scrollOption) {
	        return scrollOption.value === _this.selectedScrollOption;
	      })['title'];
	    },
	    sortOptionsForAllSchedules: function sortOptionsForAllSchedules() {
	      return [{ value: null, title: this.i18n[this.locale]['name'] }, { value: 'firstEvent', title: this.i18n[this.locale]['first_lesson'] }, { value: 'lastEvent', title: this.i18n[this.locale]['last_lesson'] }];
	    },
	    i18n: function i18n() {
	      return I18N;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    locale: function locale() {
	      return this.user && this.user.locale ? this.user.locale : 'en';
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isToday: function isToday() {
	      return (0, _moment2.default)(this.date).format('YYYY-MM-DD') === (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    isSchedulerView: function isSchedulerView() {
	      return this.calview === 'scheduler';
	    },
	    startTime: function startTime() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
	        return (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.start);
	      } else {
	        return null;
	      }
	    },
	    endTime: function endTime() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
	        return (0, _moment2.default)(this.userSettings.teamCalendarSettingTimes.end);
	      } else {
	        return null;
	      }
	    },
	    calendarsInHash: function calendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    }
	  },
	  methods: {
	    dSelectUsersUpdated: function dSelectUsersUpdated(type, cals) {
	      if (cals) {
	        this.$emit('usersUpdated', cals);
	      }
	      this.$emit('updateEvents');
	    },
	    setChangedSortOption: function setChangedSortOption(val) {
	      this.$emit('changedSortOption', val);
	      var settingsName = 'teamcalendar_view__sort_option';
	      if (!val) {
	        this.$store.dispatch('deleteUserSetting', settingsName);
	      } else {
	        this.$store.dispatch('updateUserSettings', (0, _defineProperty3.default)({}, settingsName, val));
	      }
	    },
	    setTab: function setTab(num) {
	      this.theTab = num;
	      if (num === 1) {
	        var selectedView = this.userSettings['teamcalendar_view__tab_1'];
	        if (selectedView) {
	          this.setView(selectedView);
	        } else {
	          this.setView('resourceTimeGridFiveDay');
	        }
	      } else {
	        var _selectedView = this.userSettings['teamcalendar_view__tab_2'];
	        if (_selectedView) {
	          this.setView(_selectedView);
	        } else {
	          this.setView('scheduler');
	        }
	      }
	    },
	    userHasPermission: function userHasPermission(val) {
	      if (!this.user) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(val) > -1 || this.user.admin;
	      } else {
	        return true;
	      }
	    },
	    setInitialShowWeekend: function setInitialShowWeekend() {
	      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.isShowWeekends) {
	        this.isShowWeekends = this.userSettings.teamCalendarSettingTimes.isShowWeekends;
	      }
	    },
	    setIsShowWeekends: function setIsShowWeekends(boolean) {
	      this.isShowWeekends = boolean;
	    },
	    setCustomNumberOfDays: function setCustomNumberOfDays(bool) {
	      var _this2 = this;
	
	      this.isSetCustomNumberOfDays = bool;
	      if (bool) {
	        this.$nextTick(function (_) {
	          _this2.$refs.input_custom_number_of_days.focus();
	        });
	      }
	    },
	    setStandardStartTime: function setStandardStartTime(payload) {
	      this.standardStartTime = payload;
	    },
	    setStandardEndTime: function setStandardEndTime(payload) {
	      this.standardEndTime = payload;
	    },
	    submitStandardSettings: function submitStandardSettings() {
	      var teamCalendarSettingTimes = {
	        'teamCalendarSettingTimes': {
	          start: this.standardStartTime,
	          end: this.standardEndTime
	        }
	      };
	      if (this.isSetCustomNumberOfDays) {
	        if (this.numberOfDays * 1 > 0 && this.numberOfDays * 1 < 8) {
	          teamCalendarSettingTimes['teamCalendarSettingTimes']['numberOfDays'] = this.numberOfDays;
	        } else {
	          window.alert('Not a valid number');
	          return;
	        }
	      } else {
	        teamCalendarSettingTimes['teamCalendarSettingTimes']['isShowWeekends'] = this.isShowWeekends;
	      }
	      this.$store.dispatch('updateUserSettings', teamCalendarSettingTimes);
	      this.isShowSettings = false;
	      this.$emit('updateEvents');
	    },
	    print: function print() {
	      var prtHtml = document.getElementById('printTeamCalendar').innerHTML;
	
	      var stylesHtml = '';
	
	      var _arr = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var node = _arr[_i];
	        stylesHtml += node.outerHTML;
	      }
	
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	
	      WinPrint.document.write('<!DOCTYPE html><html><head>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>');
	      setTimeout(function (_) {
	        WinPrint.document.close();
	        WinPrint.focus();
	        WinPrint.print();
	        WinPrint.close();
	      }, 1000);
	    },
	    today: function today() {
	      if (this.isToday) {
	        return;
	      }
	      this.$emit('dateChange', (0, _moment2.default)());
	    },
	    setDate: function setDate(date) {
	      this.$emit('dateChange', date);
	    },
	    next: function next() {
	      switch (this.calview) {
	        case 'resourceTimeGridFiveDay':
	          this.$emit('dateChange', (0, _moment2.default)(this.date).add(1, 'weeks'));
	          break;
	        case 'listView':
	          this.$emit('dateChange', (0, _moment2.default)(this.date).add(1, 'weeks'));
	          break;
	        default:
	          this.$emit('dateChange', (0, _moment2.default)(this.date).add(1, 'days'));
	      }
	    },
	    prev: function prev() {
	      switch (this.calview) {
	        case 'resourceTimeGridFiveDay':
	          this.$emit('dateChange', (0, _moment2.default)(this.date).subtract(1, 'weeks'));
	          break;
	        case 'listView':
	          this.$emit('dateChange', (0, _moment2.default)(this.date).subtract(1, 'weeks'));
	          break;
	        default:
	          this.$emit('dateChange', (0, _moment2.default)(this.date).subtract(1, 'days'));
	      }
	    },
	    setView: function setView(doView) {
	      this.$emit('setView', doView);
	      var name = 'teamcalendar_view__tab_' + this.theTab;
	      var val = doView;
	      this.$store.dispatch('updateUserSettings', (0, _defineProperty3.default)({}, name, val));
	    },
	    getIsView: function getIsView(calView) {
	      return this.calview === calView;
	    },
	    setIsShowSettings: function setIsShowSettings() {
	      this.isShowSettings = true;
	      if (this.startTime) {
	        this.standardStartTime = this.startTime;
	      }
	      if (this.endTime) {
	        this.standardEndTime = this.endTime;
	      }
	    },
	    setSelectedScrollOption: function setSelectedScrollOption(view) {
	      this.$emit('setSelectedScrollOption', view.value);
	    },
	    setSavedView: function setSavedView(calenderIds) {
	      var _this3 = this;
	
	      var selectedCalIds = this.itemsSelected.map(function (cal) {
	        return cal.id;
	      }).sort();
	      var calIdsFiltered = calenderIds.filter(function (calId) {
	        return _this3.calendarsInHash[calId];
	      }).sort();
	      var cals = calIdsFiltered.map(function (calId) {
	        return _this3.calendarsInHash[calId];
	      });
	      if ((0, _stringify2.default)(selectedCalIds) !== (0, _stringify2.default)(calIdsFiltered)) {
	        this.$emit('usersUpdated', cals);
	      }
	      this.$emit('updateEvents');
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.theSortOptionForAllSchedules = this.userSettings['teamcalendar_view__sort_option'];
	  },
	  mounted: function mounted() {
	    this.setInitialShowWeekend();
	  }
	};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(9);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _ModalConfirmation = __webpack_require__(22);
	
	var _ModalConfirmation2 = _interopRequireDefault(_ModalConfirmation);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    save_view: 'Gem visning',
	    saved_views: 'Mine visninger',
	    create_new_view: 'Opret ny visning',
	    give_the_view_a_title: 'Giv visningen en titel',
	    ex_title: 'Eks. vikarer',
	    or_overwrite_existing: 'Eller overskriv eksisterende',
	    choose_existing: 'Vælg eksisterende..'
	  },
	  nb: {
	    save_view: 'Lagre visning',
	    saved_views: 'Lagrede visninger',
	    create_new_view: 'Opprett ny visning',
	    give_the_view_a_title: 'Gi visning en tittel',
	    ex_title: 'Eks. vikarer',
	    or_overwrite_existing: 'Eller overskriv eksisterende',
	    choose_existing: 'Velg eksisterende..'
	  },
	  en: {
	    save_view: 'Save view',
	    saved_views: 'Saved views',
	    create_new_view: 'Create new view',
	    give_the_view_a_title: 'Give the view a title',
	    ex_title: 'Ex. substitutes',
	    or_overwrite_existing: 'Or overwrite existing',
	    choose_existing: 'Choose existing..'
	  }
	};
	
	exports.default = {
	  components: { DModal: _DModal2.default, ModalConfirmation: _ModalConfirmation2.default, DDropdown: _DDropdown2.default },
	  props: {
	    itemsSelected: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      title: '',
	      isConfirmModal: false,
	      theDeleteItem: '',
	      isSaveModal: false,
	      isInputTitleDisabled: false
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return this.$store.state.user;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    activeSchoolId: function activeSchoolId() {
	      return this.$store.state.activeSchool ? this.$store.state.activeSchool.id : null;
	    },
	    storageName: function storageName() {
	      return 'school_' + this.activeSchoolId + '__team_calendar_views';
	    },
	    savedViews: function savedViews() {
	      if (!this.userSettings || !this.userSettings[this.storageName]) {
	        return {};
	      }
	      return JSON.parse(this.userSettings[this.storageName]);
	    }
	  },
	  methods: {
	    setReplaceExisting: function setReplaceExisting(prop) {
	      if (prop.length > 1) {
	        this.title = prop;
	        this.isInputTitleDisabled = true;
	      } else {
	        this.title = '';
	        this.isInputTitleDisabled = false;
	      }
	    },
	    saveView: function saveView() {
	      if (!this.activeSchoolId || this.itemsSelected.length === 0 || this.title.length < 1) {
	        return;
	      }
	      var saveObj = JSON.parse((0, _stringify2.default)(this.savedViews));
	      if (Array.isArray(this.savedViews)) {
	        saveObj = {};
	      }
	      saveObj[this.title] = this.itemsSelected.map(function (cal) {
	        return cal.id;
	      });
	      this.$store.dispatch('updateUserSettings', (0, _defineProperty3.default)({}, this.storageName, (0, _stringify2.default)(saveObj)));
	      this.closeIsSaveModal();
	    },
	    setDeleteItemConfirm: function setDeleteItemConfirm(prop) {
	      this.theDeleteItem = prop;
	      this.isConfirmModal = true;
	    },
	    deleteItem: function deleteItem() {
	      var saveObj = JSON.parse((0, _stringify2.default)(this.savedViews));
	      delete saveObj[this.theDeleteItem];
	      this.$store.dispatch('updateUserSettings', (0, _defineProperty3.default)({}, this.storageName, (0, _stringify2.default)(saveObj)));
	      this.closeIsSaveModal();
	    },
	    selectView: function selectView(view, prop) {
	      this.$emit('setSavedView', view);
	    },
	    reset: function reset() {
	      this.theDeleteItem = '';
	      this.isConfirmModal = false;
	      this.isInputTitleDisabled = false;
	      this.title = '';
	    },
	    closeIsSaveModal: function closeIsSaveModal() {
	      this.theDeleteItem = '';
	      this.isConfirmModal = false;
	      this.isInputTitleDisabled = false;
	      this.title = '';
	      this.isSaveModal = false;
	    },
	    setIsSaveModal: function setIsSaveModal() {
	      var _this = this;
	
	      this.isSaveModal = true;
	      this.$nextTick(function (_) {
	        _this.$refs.is_save_modal_input.focus();
	      });
	    }
	  }
	};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeInput = __webpack_require__(135);
	
	var _TimeInput2 = _interopRequireDefault(_TimeInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { timeInput: _TimeInput2.default },
	  props: {
	    start: {},
	    end: {},
	    lang: {},
	    addClass: {
	      type: String,
	      default: ''
	    },
	    showIcon: {
	      type: Boolean,
	      default: false
	    },
	    isFiveMinutesInterval: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      diff: 60,
	      startTime: (0, _moment2.default)(this.start),
	      endTime: (0, _moment2.default)(this.end)
	    };
	  },
	
	  watch: {
	    start: function start() {
	      this.startTime = (0, _moment2.default)(this.start);
	    },
	    end: function end() {
	      this.endTime = (0, _moment2.default)(this.end);
	    }
	  },
	  computed: {
	    utcStart: function utcStart() {
	      return _moment2.default.utc(this.startTime).toISOString();
	    },
	    utcEnd: function utcEnd() {
	      return _moment2.default.utc(this.endTime).toISOString();
	    }
	  },
	  methods: {
	    calcDiff: function calcDiff() {
	      var _diff = (0, _moment2.default)(this.endTime).diff(this.startTime);
	      this.diff = _moment2.default.duration(_diff).asMinutes();
	    },
	    setStartTime: function setStartTime(val) {
	      var number = (0, _moment2.default)(val, 'LT');
	      if (isNaN(number)) {
	        this.startTime = this.startTime;
	        return;
	      } else {
	        var hours = (0, _moment2.default)(number).format('HH');
	        var minutes = this.isFiveMinutesInterval ? Math.round((0, _moment2.default)(number).format('mm') / 5) * 5 : (0, _moment2.default)(number).format('mm');
	        var _newDate = (0, _moment2.default)(this.startTime).set({ 'hour': hours, 'minute': minutes });
	        if (hours * 1 === 23 && minutes * 1 === 55) {
	          _newDate = (0, _moment2.default)(this.startTime).set({ 'hour': hours, 'minute': 50 });
	        }
	        this.startTime = _newDate;
	        if ((0, _moment2.default)(this.endTime).isBefore(_newDate) || (0, _moment2.default)(this.endTime).isSame(_newDate)) {
	          var newEndDate = (0, _moment2.default)(this.startTime).add(this.diff, 'minutes');
	          if ((0, _moment2.default)(this.startTime).isSame(newEndDate, 'day')) {
	            this.endTime = newEndDate;
	          } else {
	            this.endTime = (0, _moment2.default)(this.startTime).set({ 'hour': 23, 'minutes': 55 });
	          }
	          this.$emit('updateEnd', this.endTime);
	        }
	        this.$emit('updateStart', this.startTime);
	      }
	    },
	    setEndTime: function setEndTime(val) {
	      var number = (0, _moment2.default)(val, 'LT');
	      if (isNaN(number)) {
	        this.endTime = this.endTime;
	        return;
	      } else {
	        var hours = (0, _moment2.default)(number).format('HH');
	        var minutes = this.isFiveMinutesInterval ? Math.round((0, _moment2.default)(number).format('mm') / 5) * 5 : (0, _moment2.default)(number).format('mm');
	        var _newDate = (0, _moment2.default)(this.endTime).set({ 'hour': hours, 'minute': minutes });
	        if ((0, _moment2.default)(_newDate).isBefore(this.startTime) || (0, _moment2.default)(this.startTime).isSame(_newDate)) {
	          this.endTime = this.endTime;
	        } else {
	          this.endTime = _newDate;
	          this.$emit('updateEnd', this.endTime);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.calcDiff();
	  }
	};

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      count: 0
	    };
	  },
	  mounted: function mounted() {
	    console.log('Vue tl-test, ready');
	    this.start_update();
	  },
	  beforeDestroy: function beforeDestroy() {
	    console.log('Vue tl-test, beforeDestroy');
	    this.stop_update();
	  },
	
	  methods: {
	    start_update: function start_update() {
	      this.timer = setInterval(this.update, 5000);
	    },
	    stop_update: function stop_update() {
	      clearInterval(this.timer);
	    },
	    update: function update() {
	      this.count++;
	      console.log('still counting');
	    }
	  }
	};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TaskOverviewUser = __webpack_require__(340);
	
	var _TaskOverviewUser2 = _interopRequireDefault(_TaskOverviewUser);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default, DModal: _DModal2.default, Loader: _Loader2.default, TaskOverviewUser: _TaskOverviewUser2.default },
	  props: {
	    user: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      isSaving: false,
	      isLoading: false,
	      versions: [],
	      activeVersion: null,
	      activeVersionId: null,
	      isDeleteWarningActive: false,
	      isDeleting: false,
	      newVersionTitle: ''
	    };
	  },
	
	  computed: {
	    userId: function userId() {
	      return this.user ? this.user.id : null;
	    },
	    schoolId: function schoolId() {
	      return this.$store.getters.schoolId;
	    },
	    schoolYearId: function schoolYearId() {
	      return this.$store.getters.schoolYearId;
	    },
	    versionDateFormatted: function versionDateFormatted() {
	      var date = this.activeVersion ? this.activeVersion.created_at : (0, _moment2.default)();
	      return (0, _moment2.default)(date).format('LLL');
	    },
	    sortedVersions: function sortedVersions() {
	      return this.versions.sort(function (a, b) {
	        return new Date(b.created_at) - new Date(a.created_at);
	      }).filter(function (version) {
	        return version.id;
	      }).map(function (version) {
	        return (0, _extends3.default)({}, version, {
	          vTitle: version.title ? version.title : (0, _moment2.default)(version.created_at).format('LLL')
	        });
	      });
	    },
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    isUserSchoolAdmin: function isUserSchoolAdmin() {
	      return this.userHasPermission('can_manage_school');
	    }
	  },
	  watch: {
	    schoolId: function schoolId() {
	      this.readVersions();
	    },
	    schoolYearId: function schoolYearId() {
	      this.readVersions();
	    },
	    user: function user() {
	      this.readVersions();
	    }
	  },
	  methods: {
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      } else {
	        return true;
	      }
	    },
	    readVersions: function readVersions() {
	      var _this = this;
	
	      if (!this.schoolYearId || !this.schoolId || !this.userId) {
	        return;
	      }
	      this.isLoading = true;
	      _docendo2.default.readTaskOverviews(this.schoolId, this.schoolYearId, this.userId, function (success) {
	        _this.isLoading = false;
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          return;
	        }
	        _this.versions = success;
	      }, function (failure) {
	        _this.isLoading = false;
	        _eventbus2.default.toast = { text: 'Something went wrong', success: false };
	      });
	    },
	    selectVersion: function selectVersion(version) {
	      this.activeVersion = version;
	      if (version) {
	        this.activeVersionId = version.id;
	      } else {
	        this.activeVersionId = null;
	      }
	    },
	    selectVersionFromId: function selectVersionFromId(id) {
	      var idx = this.sortedVersions.findIndex(function (version) {
	        return version.id === id;
	      });
	      this.selectVersion(this.sortedVersions[idx]);
	    },
	    setWarningToDelete: function setWarningToDelete() {
	      this.isDeleteWarningActive = true;
	    },
	    deleteVersion: function deleteVersion() {
	      var _this2 = this;
	
	      this.isDeleting = true;
	      _docendo2.default.deleteTaskOverview(this.schoolId, this.schoolYearId, this.userId, this.activeVersion.id, function (success) {
	        _this2.isDeleteWarningActive = false;
	        _this2.isDeleting = false;
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          return;
	        }
	        _eventbus2.default.toast = { text: 'Deleted', success: true };
	        var idx = _this2.versions.findIndex(function (version) {
	          return version.id === success.id;
	        });
	        _this2.versions.splice(idx, 1);
	        _this2.activeVersion = null;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', success: false };
	      });
	    },
	    saveVersion: function saveVersion() {
	      var _this3 = this;
	
	      this.isSaving = true;
	      _docendo2.default.saveTaskOverview(this.schoolId, this.schoolYearId, this.userId, this.newVersionTitle, function (success) {
	        _this3.isSaving = false;
	        _this3.newVersionTitle = '';
	        if (success.status === 'error') {
	          _eventbus2.default.toast = { text: success.message, success: false };
	          return;
	        }
	        _eventbus2.default.toast = { text: 'Saved', success: true };
	        _this3.versions.push(success);
	        _this3.activeVersion = success;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: 'Something went wrong', success: false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.readVersions();
	  }
	};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(38);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(37);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _UserTasksOverviewOwnPools = __webpack_require__(342);
	
	var _UserTasksOverviewOwnPools2 = _interopRequireDefault(_UserTasksOverviewOwnPools);
	
	var _TaskOverviewUserTasks = __webpack_require__(1383);
	
	var _TaskOverviewUserTasks2 = _interopRequireDefault(_TaskOverviewUserTasks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    assigned_total_hours: 'Arbejdstid',
	    assigned_teaching_hours: 'Undervisning',
	    assigned_preparation_hours: 'Forberedelse',
	    assigned_additional_task_hours: 'Øvrige opgaver',
	    assigned_pool_hours: 'Lokalpulje',
	    assigned_club_hours: 'SFO timer',
	    substitute_pool_hours: 'Vikartimer',
	    notes: 'Noter/særlige aftaler',
	    pools: 'Fordeling'
	  },
	  nb: {
	    assigned_total_hours: 'Arbeidstid',
	    assigned_teaching_hours: 'Undervisning',
	    assigned_preparation_hours: 'Forberedelse',
	    assigned_additional_task_hours: 'Oppgaver',
	    substitute_pool_hours: 'Vikartimer',
	    assigned_pool_hours: 'Planegginsdager',
	    assigned_club_hours: 'SFO timer',
	    notes: 'Noter/særlige aftaler',
	    pools: 'Puljer'
	  },
	  en: {
	    assigned_club_hours: 'Club Hours',
	    assigned_pool_hours: 'Local pool',
	    assigned_total_hours: 'Work time',
	    substitute_pool_hours: 'Substitute hours',
	    assigned_teaching_hours: 'Teaching',
	    assigned_preparation_hours: 'Preparation',
	    assigned_additional_task_hours: 'Additional tasks',
	    notes: 'Notes',
	    pools: 'Pools'
	  }
	};
	exports.default = {
	  components: { UserTasksOverviewOwnPools: _UserTasksOverviewOwnPools2.default, TaskOverviewUserTasks: _TaskOverviewUserTasks2.default },
	  props: {
	    user: {},
	    version: {
	      default: function _default() {
	        return null;
	      }
	    },
	    isHideTaskHoursUnderThreshold: {
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      isShowScheduled: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    schoolCustomData: function schoolCustomData() {
	      return this.version && this.version.overview && this.version.overview.school_custom_data;
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return this.schoolCustomData ? this.schoolCustomData.deactivatePools : false;
	    },
	    schoolThresholdToHideTaskHours: function schoolThresholdToHideTaskHours() {
	      return this.schoolCustomData ? this.schoolCustomData.thresholdToHideTaskHours : null;
	    },
	    schoolSettingShownOwnPools: function schoolSettingShownOwnPools() {
	      return this.schoolCustomData ? this.schoolCustomData.shownOwnPools : [];
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    schoolSettingPrepFactor: function schoolSettingPrepFactor() {
	      return this.schoolSettings && this.schoolSettings['prepFactor'] ? this.schoolSettings['prepFactor'] : null;
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    schoolYear: function schoolYear() {
	      var _this = this;
	
	      if (!this.version || !this.version.school_year_id) {
	        return '';
	      }
	      var idx = this.schoolYears.findIndex(function (schoolYear) {
	        return schoolYear.id === _this.version.school_year_id;
	      });
	      return idx > -1 ? this.schoolYears[idx]['name'] : '';
	    },
	    userAgreements: function userAgreements() {
	      return this.version.overview && this.version.overview.agreements ? this.version.overview.agreements : '';
	    },
	    userNorm: function userNorm() {
	      return this.version.overview.norm;
	    },
	    userNormFormatted: function userNormFormatted() {
	      if ((0, _keys2.default)(this.userNorm).length < 1) {
	        return [];
	      }
	      var normsFiltered = this.userNorm.filter(function (item) {
	        return item.title.indexOf('hidden_') < 0;
	      });
	      return normsFiltered.map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          value: item.value
	        });
	      });
	    },
	    userPools: function userPools() {
	      return this.version.overview.pools;
	    },
	    taskPools: function taskPools() {
	      var _this2 = this;
	
	      var result = {};
	
	      var formatHours = function formatHours(value) {
	        return value || value === 0 ? value.toFixed(2) : '0.00';
	      };
	
	      var totalWorkHours = this.userPools['assigned_total_hours'];
	      var translatedKey = this.i18n['assigned_total_hours'] || 'assigned_total_hours';
	      var translatedPrep = this.i18n['assigned_preparation_hours'];
	      result[translatedKey] = formatHours(totalWorkHours);
	
	      var taskTypes = this.schoolSettingPrepFactor ? this.tasksByOriginalType.filter(function (taskType) {
	        return taskType.originalType !== 'preparation';
	      }) : this.tasksByOriginalType;
	      taskTypes.forEach(function (taskType) {
	        if (_this2.schoolSettingPrepFactor && taskType.originalType === 'teaching') {
	          result[translatedPrep] = formatHours(taskType.totalHours * _this2.schoolSettingPrepFactor);
	        }
	        result[taskType.title] = formatHours(taskType.totalHours);
	      });
	      return result;
	    },
	    userPoolsFormatted: function userPoolsFormatted() {
	      var _this3 = this;
	
	      if (this.isPoolsDeactivated) {
	        return this.taskPools;
	      }
	      var result = {};
	
	      var translatedKeys = [];
	      for (var key in this.userPools) {
	        if (this.userPools[key] !== null && this.userPools[key] !== 0) {
	          var translatedKey = this.i18n[key] || key;
	          translatedKeys.push({ key: translatedKey, originalKey: key });
	        }
	      }
	
	      translatedKeys.sort(function (a, b) {
	        return (0, _keys2.default)(_this3.i18n).indexOf(a.originalKey) - (0, _keys2.default)(_this3.i18n).indexOf(b.originalKey);
	      });
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(translatedKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var item = _step.value;
	
	          result[item.key] = this.userPools[item.originalKey].toFixed(2);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return result;
	    },
	    totalUserPools: function totalUserPools() {
	      var poolsObj = this.isPoolsDeactivated ? this.taskPools : this.userPools;
	      var sum = 0;
	      for (var key in poolsObj) {
	        if (key !== 'assigned_total_hours' && key !== this.i18n['assigned_total_hours']) {
	          var value = poolsObj[key];
	          var num = Number(value);
	          if (!isNaN(num)) {
	            sum += num;
	          }
	        }
	      }
	      return sum;
	    },
	    rest: function rest() {
	      if (this.userPools.assigned_total_hours && this.userPools.assigned_total_hours > 0) {
	        var remainingHours = this.userPools.assigned_total_hours - this.totalUserPools;
	        return remainingHours.toFixed(2);
	      }
	    },
	    tasks: function tasks() {
	      return this.version.overview.tasks;
	    },
	    tasksFiltered: function tasksFiltered() {
	      return this.tasks.filter(function (item) {
	        return item.master_type !== 'unknown';
	      });
	    },
	    tasksByMasterType: function tasksByMasterType() {
	      var _this4 = this;
	
	      var pools = {};
	
	      this.tasksFiltered.forEach(function (task) {
	        if (!task.actual && task.hours * 1 === 0) {
	          var sameIdTasks = _this4.tasksFiltered.filter(function (t) {
	            return t.id === task.id;
	          });
	          if (sameIdTasks.length > 1) {
	            return;
	          }
	        }
	
	        var activeType = task.task_category_name ? task.task_category_name : task.master_type;
	
	        if (task.substitute) {
	          activeType = 'substitute_hours';
	        }
	
	        var title = _this4.getMasterTypeTitle(activeType);
	
	        if (!pools[title]) {
	          pools[title] = {
	            originalType: activeType,
	            tasks: [],
	            totalHours: 0.0
	          };
	        }
	
	        pools[title].tasks.push(task);
	        pools[title].totalHours += parseFloat(task.hours);
	      });
	
	      for (var pool in pools) {
	        pools[pool].tasks.sort(function (a, b) {
	          if (a.name < b.name) return -1;
	          if (a.name > b.name) return 1;
	          return 0;
	        });
	      }
	
	      var poolsArray = (0, _entries2.default)(pools).map(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            title = _ref2[0],
	            _ref2$ = _ref2[1],
	            originalType = _ref2$.originalType,
	            tasks = _ref2$.tasks,
	            totalHours = _ref2$.totalHours;
	
	        return {
	          title: title === 'substitute_hours' ? _this4.getMasterTypeTitle('substitute_hours') : title,
	          originalType: originalType,
	          tasks: tasks,
	          totalHours: totalHours
	        };
	      });
	
	      poolsArray.sort(function (a, b) {
	        var aOrder = _this4.sortOrder[a.originalType] !== undefined ? _this4.sortOrder[a.originalType] : 999;
	        var bOrder = _this4.sortOrder[b.originalType] !== undefined ? _this4.sortOrder[b.originalType] : 999;
	        return aOrder - bOrder;
	      });
	
	      return poolsArray.filter(function (pool) {
	        return pool.originalType !== 'absence';
	      });
	    },
	    tasksByOriginalType: function tasksByOriginalType() {
	      var _this5 = this;
	
	      var pools = {};
	
	      this.tasksFiltered.forEach(function (task) {
	        var masterTypeTitle = _this5.getMasterTypeTitle(task.master_type);
	
	        if (!pools[masterTypeTitle]) {
	          pools[masterTypeTitle] = {
	            originalType: task.master_type,
	            tasks: [],
	            totalHours: 0.0
	          };
	        }
	
	        pools[masterTypeTitle].totalHours += parseFloat(task.hours);
	
	        if (task.substitute && !pools['substitute_hours']) {
	          pools['substitute_hours'] = {
	            originalType: 'substitute_hours',
	            tasks: [task],
	            totalHours: parseFloat(task.hours)
	          };
	        } else if (task.substitute) {
	          pools['substitute_hours'].tasks.push(task);
	          pools['substitute_hours'].totalHours += parseFloat(task.hours);
	        } else {
	          pools[masterTypeTitle].tasks.push(task);
	        }
	      });
	
	      for (var pool in pools) {
	        pools[pool].tasks.sort(function (a, b) {
	          if (a.name < b.name) return -1;
	          if (a.name > b.name) return 1;
	          return 0;
	        });
	      }
	
	      var poolsArray = (0, _entries2.default)(pools);
	
	      poolsArray = poolsArray.map(function (_ref3) {
	        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	            title = _ref4[0],
	            _ref4$ = _ref4[1],
	            originalType = _ref4$.originalType,
	            tasks = _ref4$.tasks,
	            totalHours = _ref4$.totalHours;
	
	        return {
	          title: title === 'substitute_hours' ? _this5.getMasterTypeTitle('substitute_hours') : title,
	          originalType: originalType,
	          tasks: tasks,
	          totalHours: totalHours
	        };
	      });
	
	      poolsArray.sort(function (a, b) {
	        var aOrder = _this5.sortOrder[a.originalType] !== undefined ? _this5.sortOrder[a.originalType] : 999;
	        var bOrder = _this5.sortOrder[b.originalType] !== undefined ? _this5.sortOrder[b.originalType] : 999;
	
	        return aOrder - bOrder;
	      });
	
	      return poolsArray.filter(function (pool) {
	        return pool.originalType !== 'absence';
	      });
	    },
	    sortOrder: function sortOrder() {
	      return {
	        teaching: 0,
	        substitute_hours: 1,
	        other: 2,
	        preparation: 3,
	        club: 4,
	        absence: 8,
	        unknown: 8,
	        with_kids: 0,
	        without_kids: 2
	      };
	    }
	  },
	  methods: {
	    getMasterTypeTitle: function getMasterTypeTitle(title) {
	      switch (title) {
	        case 'teaching':
	          return this.$t('vue2.task_overview.teaching');
	        case 'other':
	          return this.$t('vue2.task_overview.tasks');
	        case 'preparation':
	          return this.$t('vue2.task_overview.preparation');
	        case 'absence':
	          return this.$t('vue2.task_overview.absence');
	        case 'club':
	          return this.$t('vue2.task_overview.club');
	        case 'substitute_hours':
	          return this.$t('vue2.task_overview.substitute_hours');
	        case 'pool':
	          return this.$t('vue2.task_overview.pool');
	        case 'with_kids':
	          return 'Tid med børn';
	        case 'without_kids':
	          return 'Tid uden børn';
	        default:
	          return title;
	      }
	    }
	  }
	};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserTasksTable = __webpack_require__(128);
	
	var _UserTasksTable2 = _interopRequireDefault(_UserTasksTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { UserTasksTable: _UserTasksTable2.default },
	  props: {
	    user: {
	      type: Object,
	      required: true
	    },
	    tasks: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isHideTaskHoursUnderThreshold: {
	      default: false
	    },
	    schoolThresholdToHideTaskHours: {
	      default: null
	    },
	    sortOrder: {
	      default: null
	    },
	    tasksByMasterType: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  methods: {
	    getIsHideHours: function getIsHideHours(task) {
	      return task.hours * 1 === 0 || this.isHideTaskHoursUnderThreshold && task.subject_type === 'additional_tasks' && task.hours * 1 < this.schoolThresholdToHideTaskHours;
	    },
	    getIsHideTotalHours: function getIsHideTotalHours(tasksType) {
	      return tasksType.totalHours < 1 || this.isHideTaskHoursUnderThreshold && this.schoolThresholdToHideTaskHours && tasksType.originalType === 'other';
	    }
	  }
	};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(85);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Loader: _Loader2.default, Modal: _Modal2.default },
	  props: {
	    userId: {
	      type: Number
	    },
	    eventsFilter: {
	      type: String,
	      default: 'absence'
	    }
	  },
	  data: function data() {
	    return {
	      showModal: false,
	      events: [],
	      isLoading: false
	    };
	  },
	
	  computed: {
	    activeSchoolYears: function activeSchoolYears() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    start: function start() {
	      return (0, _moment2.default)(this.activeSchoolYears.employee_time_start).startOf('day');
	    },
	    end: function end() {
	      return (0, _moment2.default)(this.activeSchoolYears.employee_time_end).startOf('day');
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    selectedUsersIds: function selectedUsersIds() {
	      return [this.userId];
	    },
	    userName: function userName() {
	      return this.allUsersInHash[this.userId] ? this.allUsersInHash[this.userId].name : '';
	    },
	    filteredEvents: function filteredEvents() {
	      var _this = this;
	
	      return this.events.filter(function (obj) {
	        switch (_this.eventsFilter) {
	          case null:
	            return obj.event_type !== '';
	          case 'subject':
	            return obj.event_type !== 'absence' && obj.event_type !== 'other_tasks' && obj.event_type !== 'other_stuff' && obj.substitute_for === null;
	          case 'substituteHours':
	            return obj.substitute_for !== null;
	          case 'absence':
	            return obj.event_type === 'absence';
	        }
	      });
	    },
	    sortedEvents: function sortedEvents() {
	      var arr = this.filteredEvents;
	      return arr.sort(function (a, b) {
	        return (0, _moment2.default)(a.start_time).unix() - (0, _moment2.default)(b.start_time).unix();
	      });
	    },
	    totalDuration: function totalDuration() {
	      var durations = [];
	      this.sortedEvents.forEach(function (event) {
	        durations.push(event.user_teaching_mins);
	      });
	      var data = durations.reduce(function (a, b) {
	        return a + b;
	      }, 0);
	      return this.humanizeMinutes(data);
	    }
	  },
	  watch: {
	    userId: function userId() {
	      this.getAllEvents();
	    }
	  },
	  methods: {
	    getAllEvents: function getAllEvents() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      _docendo2.default.schoolEvents(window.SCHOOL.id, this.start, this.end, this.selectedUsersIds, 'absence', function (data) {
	        _this2.events = data[0].events;
	        _this2.isLoading = false;
	      });
	    },
	    getDuration: function getDuration(event) {
	      return this.humanizeMinutes(event.user_teaching_mins);
	    },
	    humanizeMinutes: function humanizeMinutes(data) {
	      var minutes = data % 60;
	      var hours = (data - minutes) / 60;
	      var multiple = hours === 1 ? this.$i18n.t('vue2.substitute_hours.hour') : this.$i18n.t('vue2.substitute_hours.hours');
	      return hours + ' ' + multiple + ' ' + minutes + ' ' + this.$t('vue2.substitute_hours.min');
	    },
	    close: function close() {
	      this.$emit('close');
	      this.events = [];
	    }
	  },
	  mounted: function mounted() {
	    this.getAllEvents();
	  }
	};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _SubjectsDistributionUser = __webpack_require__(126);
	
	var _SubjectsDistributionUser2 = _interopRequireDefault(_SubjectsDistributionUser);
	
	var _UserTasksChart = __webpack_require__(341);
	
	var _UserTasksChart2 = _interopRequireDefault(_UserTasksChart);
	
	var _UserTasksOverview = __webpack_require__(1385);
	
	var _UserTasksOverview2 = _interopRequireDefault(_UserTasksOverview);
	
	var _UserTasksTable = __webpack_require__(128);
	
	var _UserTasksTable2 = _interopRequireDefault(_UserTasksTable);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SelectUser = __webpack_require__(1397);
	
	var _SelectUser2 = _interopRequireDefault(_SelectUser);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerRangeShortcuts = __webpack_require__(88);
	
	var _DatePickerRangeShortcuts2 = _interopRequireDefault(_DatePickerRangeShortcuts);
	
	var _TaskOverview = __webpack_require__(1382);
	
	var _TaskOverview2 = _interopRequireDefault(_TaskOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TaskOverviewVersions: _TaskOverview2.default,
	    DatePickerRangeShortcuts: _DatePickerRangeShortcuts2.default,
	    Loader: _Loader2.default,
	    ChangeSchoolYear: _ChangeSchoolYear2.default,
	    UserTasksOverview: _UserTasksOverview2.default,
	    SubjectsDistributionUser: _SubjectsDistributionUser2.default,
	    DatePickerRange: _DatePickerRange2.default,
	    UserTasksChart: _UserTasksChart2.default,
	    UserTasksTable: _UserTasksTable2.default,
	    SelectUser: _SelectUser2.default
	  },
	  props: {
	    user_id: {
	      default: 13
	    },
	    user_calendar_id: {
	      default: 7
	    },
	    user_name: {
	      default: ''
	    },
	    isShowHeader: {
	      type: Boolean,
	      default: true
	    },
	    isShowPrintButton: {
	      type: Boolean,
	      default: true
	    },
	    isCanSeeOtherUsers: {
	      type: Boolean,
	      default: true
	    },
	    initialStartDate: {
	      default: null
	    },
	    initialEndDate: {
	      default: null
	    },
	    initialIsShowScheduled: {
	      default: null
	    },
	    isReactive: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      startDate: null,
	      endDate: null,
	      initialLoad: false,
	      debounceTimer: null,
	      isShowScheduled: true,
	      _keyListener: null
	    };
	  },
	
	  computed: {
	    theUser: function theUser() {
	      return this.$store.state.user;
	    },
	    canUserSeeVersions: function canUserSeeVersions() {
	      if (!this.theUser || !this.user) {
	        return false;
	      } else if (this.theUserCanManageAssignedHours) {
	        return true;
	      }
	      return this.theUser.id * 1 === this.user.id * 1 && this.userHasPermission('can_see_own_task_overview');
	    },
	    schoolId: function schoolId() {
	      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_id ? this.$route.params.school_id : null;
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    user: function user() {
	      return {
	        name: this.user_name,
	        id: this.user_id,
	        user_calendar_id: this.user_calendar_id
	      };
	    },
	    isLoadingTasksForUser: function isLoadingTasksForUser() {
	      return this.$store.state.subjects.isLoadingTasksForUser;
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    isStartOrEndDateChanged: function isStartOrEndDateChanged() {
	      return this.compareDates(this.activeSchoolYear.employee_time_start, this.startDate) && this.compareDates(this.activeSchoolYear.employee_time_end, this.endDate);
	    },
	    dates: function dates() {
	      return this.startDate ? (0, _moment2.default)(this.startDate).format('LL') + ' - ' + (0, _moment2.default)(this.endDate).format('LL') : '';
	    },
	    usersSorted: function usersSorted() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    isPermissionsActivatedForSchool: function isPermissionsActivatedForSchool() {
	      return this.$store.getters.isPermissionsActivatedForSchool;
	    },
	    userPermissions: function userPermissions() {
	      return this.$store.getters.userPermissions;
	    },
	    theUserCanManageAssignedHours: function theUserCanManageAssignedHours() {
	      return this.userHasPermission('can_manage_school');
	    },
	    schoolSettings: function schoolSettings() {
	      return this.$store.state.schoolSettings;
	    },
	    isPoolsDeactivated: function isPoolsDeactivated() {
	      return this.schoolSettings && this.schoolSettings['deactivatePools'] ? this.schoolSettings['deactivatePools'] : false;
	    },
	    schoolPrepFactor: function schoolPrepFactor() {
	      return this.schoolSettings && this.schoolSettings['prepFactor'] ? this.schoolSettings['prepFactor'] : null;
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear() {
	      if (!this.initialStartDate) {
	        this.setEndDate(this.activeSchoolYear.employee_time_end);
	        this.setStartDate(this.activeSchoolYear.employee_time_start);
	      }
	    },
	    user_id: function user_id(val) {
	      if (this.isReactive) {
	        this.readAllSubjects();
	      }
	    }
	  },
	  methods: {
	    selectNextUser: function selectNextUser() {
	      var _this = this;
	
	      var idx = this.usersSorted.findIndex(function (user) {
	        return user.id * 1 === _this.user_id * 1;
	      });
	      var nextIdx = idx + 1;
	      var nextUserId = this.usersSorted[nextIdx] && this.usersSorted[nextIdx].id ? this.usersSorted[nextIdx].id : null;
	      if (nextUserId) {
	        this.selectUser(nextUserId);
	      }
	    },
	    selectPrevUser: function selectPrevUser() {
	      var _this2 = this;
	
	      var idx = this.usersSorted.findIndex(function (user) {
	        return user.id * 1 === _this2.user_id * 1;
	      });
	      var nextIdx = idx - 1;
	      var prevUserId = this.usersSorted[nextIdx] && this.usersSorted[nextIdx].id ? this.usersSorted[nextIdx].id : null;
	      if (prevUserId) {
	        this.selectUser(prevUserId);
	      }
	    },
	    selectUser: function selectUser(id) {
	      window.location = '/users/' + id + '/tasks#';
	    },
	    setIsShowScheduled: function setIsShowScheduled(boolean) {
	      this.isShowScheduled = boolean;
	    },
	    compareDates: function compareDates(firstDate, secondDate) {
	      return (0, _moment2.default)(firstDate).format('YYYY-MM-DD') === (0, _moment2.default)(secondDate).format('YYYY-MM-DD');
	    },
	    resetDates: function resetDates() {
	      this.setDates(this.activeSchoolYear.employee_time_start, this.activeSchoolYear.employee_time_end);
	    },
	    setDatesFromRange: function setDatesFromRange(dateRange) {
	      this.setDates(dateRange.start, dateRange.end);
	    },
	    setDates: function setDates(start, end) {
	      if (start) {
	        this.startDate = start;
	      }
	      if (end) {
	        this.endDate = end;
	      }
	      this.readAllSubjects();
	    },
	    setStartDate: function setStartDate(date) {
	      this.startDate = date;
	      if ((0, _moment2.default)(date).isValid()) {
	        this.readAllSubjects();
	      }
	    },
	    setEndDate: function setEndDate(date) {
	      this.endDate = date;
	      if ((0, _moment2.default)(date).isValid()) {
	        this.readAllSubjects();
	      }
	    },
	    readUserTasks: function readUserTasks() {
	      var _this3 = this;
	
	      if (!this.endDate) {
	        return;
	      }
	      var endDate = (0, _moment2.default)(this.endDate).add(1, 'days');
	
	      setTimeout(function (_) {
	        var readObj = {
	          userId: _this3.user_id,
	          fromDate: _this3.startDate,
	          toDate: endDate
	        };
	        _this3.$store.dispatch('readUserTasks', readObj);
	      }, 0);
	    },
	    readAllSubjects: function readAllSubjects() {
	      var _this4 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function (_) {
	        _this4.readAssignedHours();
	        _this4.readUserTasks();
	      }, 250);
	    },
	    readAssignedHours: function readAssignedHours() {
	      var _this5 = this;
	
	      setTimeout(function (_) {
	        var schoolObj = {
	          schoolId: window.SCHOOL.id,
	          schoolYearId: _this5.activeSchoolYear.id,
	          userId: _this5.user.id,
	          fromDateTime: (0, _moment2.default)(_this5.startDate).format('YYYY-MM-DD') + ' 00:00',
	          toDateTime: (0, _moment2.default)(_this5.endDate).format('YYYY-MM-DD') + ' 23:59'
	        };
	        _this5.$store.dispatch('readUsersAssignedHoursForUser', schoolObj);
	        _this5.$store.dispatch('readUsersActualHoursForUser', schoolObj);
	      }, 0);
	    },
	    print: function print() {
	      window.print();
	    },
	    userHasPermission: function userHasPermission(permission) {
	      if (!this.theUser) {
	        return false;
	      }
	      if (this.isPermissionsActivatedForSchool) {
	        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin;
	      } else {
	        return true;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.initialIsShowScheduled) {
	      this.isShowScheduled = this.initialIsShowScheduled;
	    }
	  },
	  mounted: function mounted() {
	    if (this.initialStartDate) {
	      this.setEndDate(this.initialEndDate);
	      this.setStartDate(this.initialStartDate);
	      return;
	    }
	    if (this.activeSchoolYear) {
	      this.setEndDate(this.activeSchoolYear.employee_time_end);
	      this.setStartDate(this.activeSchoolYear.employee_time_start);
	    }
	    if (document.title) {
	      if (this.user_name) {
	        document.title = this.user_name + ' - ' + this.$t('vue2.task_overview.task_overview');
	      }
	    }
	    this._keyListener = function (e) {
	      var key = e.which || e.keyCode;
	      var metaKey = e.metaKey || e.ctrlKey;
	      if (metaKey && key === 39) {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.selectNextUser();
	        }
	      }
	      if (metaKey && e.shiftKey && key === 37) {
	        if (e.target.tagName.toUpperCase() === 'BODY') {
	          this.selectPrevUser();
	        }
	      }
	    };
	    document.addEventListener('keydown', this._keyListener.bind(this));
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this._keyListener);
	  }
	};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _BarChart = __webpack_require__(363);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LineChart: _BarChart2.default,
	    Loader: _Loader2.default
	  },
	  props: {
	    calendarId: {
	      default: 7
	    },
	    startDate: {
	      default: null
	    },
	    endDate: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: true,
	      debounceTimer: null,
	      options: {
	        indexAxis: 'x',
	        responsive: true,
	        maintainAspectRatio: false,
	        scales: {
	          xAxes: [{
	            gridLines: {
	              color: 'rgba(0, 0, 0, 0)'
	            },
	            stacked: true,
	            ticks: {
	              beginAtZero: true
	            }
	          }, {
	            id: 'x2',
	            display: false,
	            stacked: false,
	            offset: true,
	            padding: 2,
	            ticks: {
	              beginAtZero: true
	            },
	            gridLines: {
	              drawOnChartArea: false }
	          }],
	          yAxes: [{
	            ticks: {
	              suggestedMax: 40,
	              beginAtZero: true
	            }
	          }]
	        }
	      },
	      dbHours: [],
	      datacollection: null,
	      dataPresence: [],
	      dataTeaching: [],
	      dataTasks: [],
	      dataPreparation: [],
	      dataAbsence: [],
	      dataClub: [],
	      dataWithKids: [],
	      dataWithoutKids: [],
	      dataPool: [],
	      weeks: [],
	      weekNumbersLabels: []
	    };
	  },
	
	  computed: {
	    masterTypes: function masterTypes() {
	      var types = [];
	      this.dbHours.forEach(function (hours) {
	        var idx = types.indexOf(hours.master_type);
	        if (idx < 0) {
	          types.push(hours.master_type);
	        }
	      });
	      return types;
	    }
	  },
	  watch: {
	    startDate: function startDate(val) {
	      if ((0, _moment2.default)(val).isValid()) {
	        this.callAPI();
	      }
	    },
	    endDate: function endDate(val) {
	      if ((0, _moment2.default)(val).isValid()) {
	        this.callAPI();
	      }
	    }
	  },
	  methods: {
	    createWeeks: function createWeeks() {
	      var _this = this;
	
	      this.dataPreparation = [];
	      this.dataTeaching = [];
	      this.dataTasks = [];
	      this.dataPresence = [];
	      this.dataAbsence = [];
	      this.weeks = [];
	      this.weekNumbersLabels = [];
	      this.dataClub = [];
	      this.dataWithKids = [];
	      this.dataWithoutKids = [];
	      this.dataPool = [];
	      this.dbHours.forEach(function (hours) {
	        var idx = _this.weeks.indexOf(hours.week);
	        if (idx < 0) {
	          _this.weeks.push(hours.week);
	          var mom = (0, _moment2.default)(hours.week * 1);
	          var weekNumber = mom.isoWeek();
	          _this.weekNumbersLabels.push(weekNumber);
	        }
	      });
	
	      function twoDigits(val) {
	        return parseFloat(Number(val)).toFixed(2);
	      }
	
	      this.dbHours.forEach(function (hours) {
	        var idxForWeek = _this.weeks.indexOf(hours.week);
	        switch (hours.master_type) {
	          case 'preparation':
	            _this.dataPreparation[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'teaching':
	            _this.dataTeaching[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'other':
	            _this.dataTasks[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'presence':
	            _this.dataPresence[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'absence':
	            _this.dataAbsence[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'club':
	            _this.dataClub[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'with_kids':
	            _this.dataWithKids[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'without_kids':
	            _this.dataWithoutKids[idxForWeek] = twoDigits(hours.coalesce);
	            break;
	          case 'pool':
	            _this.dataPool[idxForWeek] = twoDigits(hours.coalesce);
	        }
	      });
	      this.fillData();
	    },
	    callAPI: function callAPI() {
	      var _this2 = this;
	
	      clearTimeout(this.debounceTimer);
	      this.debounceTimer = setTimeout(function (_) {
	        _this2.getData();
	      }, 250);
	    },
	    fillData: function fillData() {
	      var dataset = [];
	      var arrOfTypes = [{ arr: this.dataPresence, value: 'presence' }, { arr: this.dataTeaching, value: 'teaching' }, { arr: this.dataTasks, value: 'tasks' }, { arr: this.dataPreparation, value: 'preparation' }, { arr: this.dataClub, value: 'club' }, { arr: this.dataWithKids, value: 'with_kids' }, { arr: this.dataWithoutKids, value: 'without_kids' }, { arr: this.dataPool, value: 'pool' }];
	      var datasetLabels = [{
	        data: this.dataPresence,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.work_hours'),
	        backgroundColor: 'rgba(153, 197, 244, 0.4)',
	        barPercentage: 1,
	        order: 5,
	        xAxisID: 'x2',
	        v_valueType: 'presence'
	      }, {
	        data: this.dataTeaching,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.teaching'),
	        backgroundColor: 'rgba(122, 115, 255, .4)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 1,
	        v_valueType: 'teaching'
	      }, {
	        data: this.dataTasks,
	        label: this.$t('vue2.task_overview.tasks'),
	        type: 'bar',
	        backgroundColor: 'rgba(255, 217, 106, 1)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 2,
	        v_valueType: 'tasks'
	      }, {
	        data: this.dataPreparation,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.preparation'),
	        backgroundColor: '#eee',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 3,
	        v_valueType: 'preparation'
	      }, {
	        data: this.dataClub,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.club'),
	        backgroundColor: '#f3b09b',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'club'
	      }, {
	        data: this.dataWithKids,
	        type: 'bar',
	        label: 'Med børn',
	        backgroundColor: 'rgba(252, 127, 92,.6)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'with_kids'
	      }, {
	        data: this.dataWithoutKids,
	        type: 'bar',
	        label: 'Uden børn',
	        backgroundColor: 'rgba(128, 128, 128,.6)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'without_kids'
	      }, {
	        data: this.dataPool,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.pool'),
	        backgroundColor: 'rgba(238, 174, 101,.6)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'pool'
	      }, {
	        data: this.dataAbsence,
	        type: 'bar',
	        label: this.$t('vue2.task_overview.absence'),
	        backgroundColor: 'rgba(86,68,55,.6)',
	        barPercentage: 0.5,
	        stack: '1',
	        order: 4,
	        v_valueType: 'absence'
	      }];
	      arrOfTypes.forEach(function (type) {
	        if (type.arr.length > 0) {
	          var idx = datasetLabels.findIndex(function (label) {
	            return label.v_valueType === type.value;
	          });
	          if (idx > -1) {
	            dataset.push(datasetLabels[idx]);
	          }
	        }
	      });
	      this.datacollection = {
	        labels: this.weekNumbersLabels,
	        datasets: dataset
	      };
	      this.isLoading = false;
	    },
	    getData: function getData() {
	      var _this3 = this;
	
	      this.isLoading = true;
	      if (!this.startDate && !this.endDate || !(0, _moment2.default)(this.startDate).isValid() || !(0, _moment2.default)(this.endDate).isValid()) {
	        return;
	      }
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).add(1, 'days').format('YYYY-MM-DD');
	      _docendo2.default.calendarActualHoursPerWeek(this.calendarId, startDate, endDate, function (success) {
	        _this3.dbHours = success;
	        _this3.createWeeks();
	      }, function (failure) {
	        console.log('failure');
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.callAPI();
	  }
	};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SubjectsDistributionUserAgreements = __webpack_require__(86);
	
	var _SubjectsDistributionUserAgreements2 = _interopRequireDefault(_SubjectsDistributionUserAgreements);
	
	var _SubjectsDistributionUserEditHours = __webpack_require__(335);
	
	var _SubjectsDistributionUserEditHours2 = _interopRequireDefault(_SubjectsDistributionUserEditHours);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _UserTasksTable = __webpack_require__(128);
	
	var _UserTasksTable2 = _interopRequireDefault(_UserTasksTable);
	
	var _AppToggle = __webpack_require__(12);
	
	var _AppToggle2 = _interopRequireDefault(_AppToggle);
	
	var _UserTasksChart = __webpack_require__(341);
	
	var _UserTasksChart2 = _interopRequireDefault(_UserTasksChart);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UserTasksOverviewKindergarten = __webpack_require__(1386);
	
	var _UserTasksOverviewKindergarten2 = _interopRequireDefault(_UserTasksOverviewKindergarten);
	
	var _UserTasksTableSubstituteHours = __webpack_require__(1388);
	
	var _UserTasksTableSubstituteHours2 = _interopRequireDefault(_UserTasksTableSubstituteHours);
	
	var _UserTasksOverviewOwnPools = __webpack_require__(342);
	
	var _UserTasksOverviewOwnPools2 = _interopRequireDefault(_UserTasksOverviewOwnPools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    work_days: 'arbejdsdage',
	    tooltip: {
	      hours: 'timer',
	      days: 'dage',
	      work_days: 'arbejdsdage',
	      per_day: 'pr. dag',
	      calculation: 'Beregning',
	      forYear: 'For året:',
	      forPeriod: 'For perioden:',
	      explanation: '<p><i>Når du vælger et andet datointerval end hele perioden, kan du her se, hvor mange timer, der i gennemsnit skal planlægges i perioden og per dag. Udregningen er baseret på antal arbejdsdage angivet for personalet, fratrukket weekender, feriedage og helligdage i \'Feriekalender\'</p>'
	    }
	  },
	  nb: {
	    work_days: 'arbeidsdager',
	    tooltip: {
	      hours: 'timer',
	      days: 'dager',
	      per_day: 'per dag',
	      work_days: 'arbeidsdager',
	      calculation: 'Beregning',
	      forYear: 'For året:',
	      forPeriod: 'For perioden:',
	      explanation: '<p><i>Når du velger et annet datointerval enn hele året, kan du her se, hvor mange timer som skal planlegges i perioden og i gjennomsnitt per dag. Beregningen trekker helger og ferie- og helligdager fra.</i></p>'
	    }
	  },
	  en: {
	    work_days: 'work days',
	    tooltip: {
	      hours: 'hours',
	      days: 'days',
	      per_day: 'per day',
	      work_days: 'work days',
	      calculation: 'Calculation',
	      forYear: 'For the year:',
	      forPeriod: 'For the period:',
	      explanation: '<p><i>When you choose a different date range than the whole year, you can see here how many hours need to be planned in the period and on average per day. The calculation subtracts weekends and holidays.</i></p>'
	    }
	  }
	};
	
	exports.default = {
	  components: {
	    UserTasksOverviewOwnPools: _UserTasksOverviewOwnPools2.default,
	    UserTasksTableSubstituteHours: _UserTasksTableSubstituteHours2.default,
	    UserTasksOverviewKindergarten: _UserTasksOverviewKindergarten2.default,
	    AppToggle: _AppToggle2.default,
	    SubjectsDistributionUserAgreements: _SubjectsDistributionUserAgreements2.default,
	    DDropdown: _DDropdown2.default,
	    DModal: _DModal2.default,
	    SubjectsDistributionUserEditHours: _SubjectsDistributionUserEditHours2.default,
	    UserTasksTable: _UserTasksTable2.default,
	    UserTasksChart: _UserTasksChart2.default
	  },
	  props: {
	    user: {
	      default: function _default() {
	        return {
	          name: 'Henrik Rasch',
	          id: 13,
	          user_calendar_id: 7
	        };
	      }
	    },
	    isKindergarten: {
	      type: Boolean,
	      default: false
	    },
	    activeUserId: {
	      default: null
	    },
	    showCloseCross: {
	      default: true
	    },
	    isInUserCalendar: {
	      default: false
	    },
	    dates: {},
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    isShowHeader: {
	      type: Boolean,
	      default: true
	    },
	    isPoolsDeactivated: {
	      type: Boolean,
	      default: false
	    },
	    schoolPrepFactor: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isPrint: false,
	      theActiveSubject: null,
	      isShowScheduled: true,
	      userNorm: [],
	      userAgreements: '',
	      allVacationsDays: [],
	      userIdsWithoutCalc: [171563]
	    };
	  },
	
	  computed: {
	    hiddenTaskDistributionCategories: function hiddenTaskDistributionCategories() {
	      return this.$store.getters.hiddenTaskDistributionCategories;
	    },
	    schoolSettingShownOwnPools: function schoolSettingShownOwnPools() {
	      return this.$store.getters.shownOwnPools;
	    },
	    titleForTeachingAndSubstituteHoursTotal: function titleForTeachingAndSubstituteHoursTotal() {
	      var idx = this.userTasksFiltered.findIndex(function (userTasks) {
	        return userTasks.title === 'substitute_hours';
	      });
	      if (idx < 0) {
	        return 'Undervisning + Vikartimer (UV-timer)';
	      }
	      var hasClubTasks = this.userTasksSortedInTypes[idx]['tasks'].some(function (task) {
	        return task.master_type === 'club';
	      });
	      if (hasClubTasks) {
	        return 'Undervisning + Vikartimer (UV-timer & SFO)';
	      } else {
	        return 'Undervisning + Vikartimer (UV-timer)';
	      }
	    },
	    userNormFormatted: function userNormFormatted() {
	      var normsFiltered = this.userNorm.filter(function (item) {
	        return item.title.indexOf('hidden_') < 0;
	      });
	      return normsFiltered.map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          value: item.value
	        });
	      });
	    },
	    tooltipContent: function tooltipContent() {
	      return '<p><i>N\xE5r du v\xE6lger et andet datointerval end hele \xE5ret, kan du her se, hvor mange timer, der skal planl\xE6gges for medarbejderen i perioden og i gennemsnit per dag. Udregningen tager h\xF8jde for institutionens ferie- og helligdage.</i></p><br></p><p><b>Beregning</b></p><p>For \xE5ret: ' + this.getUserHoursOverview.assigned_total_hours + ' timer / ' + this.workDayDates.length + ' dage = ' + this.averageWorkingHoursPerDay + ' timer pr. dag</p><p>For perioden: ' + this.numberOfWorkDaysInPeriod + ' arbejdsdage * ' + this.averageWorkingHoursPerDay + ' timer pr. dag = ' + this.assignedTotalHoursForPeriod + ' timer</p>';
	    },
	    schoolTooltipContent: function schoolTooltipContent() {
	      var sumForYear = this.getUserHoursOverview.assigned_total_hours;
	      var hoursInYear = this.numberOfWorkDays;
	      var hoursPerDay = sumForYear / hoursInYear;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.toFixedIfNecessary(hoursPerDay);
	      var hoursForPeriodFixed = this.toFixedIfNecessary(hoursForPeriod);
	      return this.i18n.tooltip.explanation + '<br></p><p><b>' + this.i18n.tooltip.calculation + '</b></p><p>' + this.i18n.tooltip.forYear + ' ' + sumForYear + ' ' + this.i18n.tooltip.hours + ' / ' + hoursInYear + ' ' + this.i18n.tooltip.days + ' = ' + hoursPerDayFixed + ' ' + this.i18n.tooltip.hours + ' ' + this.i18n.tooltip.per_day + '</p><p>' + this.i18n.tooltip.forPeriod + ' ' + this.numberOfWorkDaysInPeriod + ' ' + this.i18n.tooltip.work_days + ' * ' + hoursPerDayFixed + ' ' + this.i18n.tooltip.hours + ' ' + this.i18n.tooltip.per_day + ' = ' + hoursForPeriodFixed + ' ' + this.i18n.tooltip.hours + '</p>';
	    },
	    urlLocale: function urlLocale() {
	      var url = window.location.host;
	      var locale = 'en';
	      if (url.indexOf('.dk') > -1) {
	        locale = 'da';
	      }
	      if (url.indexOf('.no') > -1) {
	        locale = 'nb';
	      }
	      return locale;
	    },
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : this.urlLocale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    isDateIntervalChanged: function isDateIntervalChanged() {
	      var userId = this.user.id * 1;
	      if (this.userIdsWithoutCalc.indexOf(userId) > -1) {
	        return false;
	      }
	      var originalStart = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var originalEnd = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      return startDate !== originalStart || endDate !== originalEnd;
	    },
	    schoolId: function schoolId() {
	      if (window.SCHOOL && window.SCHOOL.id) {
	        return window.SCHOOL.id;
	      }
	      if (this.$route && this.$route.params && this.$route.params.school_id) {
	        return this.$route.params.school_id;
	      }
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    workDayDates: function workDayDates() {
	      var self = this;
	
	      function isNotWeekend(m) {
	        return (0, _moment2.default)(m).isoWeekday() !== 6 && (0, _moment2.default)(m).isoWeekday() !== 7;
	      }
	
	      function isNotVacationDay(m) {
	        var idx = self.allVacationsDays.findIndex(function (date) {
	          return (0, _moment2.default)(date.day).format('YYYY-MM-DD') === m;
	        });
	        return idx < 0;
	      }
	
	      var startDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_start).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.activeSchoolYear.employee_time_end).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        if (isNotWeekend(m) && isNotVacationDay(m)) {
	          dateArray.push(m);
	        }
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    workDayDatesInPeriod: function workDayDatesInPeriod() {
	      var _this = this;
	
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.endDate).format('YYYY-MM-DD');
	      var dateArray = [];
	      while ((0, _moment2.default)(startDate).isSameOrBefore(endDate)) {
	        var m = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	        dateArray.push(m);
	        startDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	      return dateArray.filter(function (date) {
	        var m = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var idx = _this.workDayDates.indexOf(m);
	        return idx > -1;
	      });
	    },
	    numberOfWorkDays: function numberOfWorkDays() {
	      return this.workDayDates.length;
	    },
	    numberOfWorkDaysInPeriod: function numberOfWorkDaysInPeriod() {
	      return this.workDayDatesInPeriod.length;
	    },
	    averageWorkingHoursPerDay: function averageWorkingHoursPerDay() {
	      var hoursPerDay = this.getUserHoursOverview.assigned_total_hours / this.numberOfWorkDays * 1;
	      return this.toFixedIfNecessary(hoursPerDay);
	    },
	    assignedTotalHoursForPeriod: function assignedTotalHoursForPeriod() {
	      var userId = this.user.id * 1;
	      if (this.userIdsWithoutCalc.includes(userId)) {
	        return this.getUserHoursOverview.assigned_total_hours;
	      }
	      var hoursPerDay = this.getUserHoursOverview.assigned_total_hours / this.numberOfWorkDays * 1;
	      var hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      return this.toFixedIfNecessary(hoursInThePeriod);
	    },
	    diffTotalHoursForPeriod: function diffTotalHoursForPeriod() {
	      var diff = this.assignedTotalHoursForPeriod - this.getUserHoursOverview.actual_total_hours;
	      return this.toFixedIfNecessary(diff);
	    },
	    schoolCountry: function schoolCountry() {
	      return this.$store.getters.schoolCountry;
	    },
	    isShowSubsAndTeachingActive: function isShowSubsAndTeachingActive() {
	      var schoolIds = [7272, 1256, 2987, 2991, 2986, 2989, 2990, 2985, 2992, 4910, 4911, 4912, 1976, 6527, 61476, 60668, 1795, 60800];
	      return schoolIds.indexOf(this.schoolId) > -1;
	    },
	    isSchoolGlHjortespring: function isSchoolGlHjortespring() {
	      return this.schoolId === 25609;
	    },
	    isSchoolWantSum: function isSchoolWantSum() {
	      var schoolIds = [40195];
	      return schoolIds.indexOf(this.schoolId) > -1;
	    },
	    userTasksSortedInTypes: function userTasksSortedInTypes() {
	      return this.$store.getters.userTasksSortedInTypes;
	    },
	    userTasksFiltered: function userTasksFiltered() {
	      if (this.isShowScheduled) {
	        return this.userTasksSortedInTypes;
	      } else {
	        return this.userTasksSortedInTypes.filter(function (type) {
	          return type.title !== 'absence' && type.title !== 'substitute_hours';
	        });
	      }
	    },
	    getTheActiveSubject: function getTheActiveSubject() {
	      return this.theActiveSubject ? this.subjectsInHash[this.theActiveSubject] : null;
	    },
	    getTheActiveUser: function getTheActiveUser() {
	      return this.activeUserId ? this.allUsersInHash[this.activeUserId] : null;
	    },
	    allUsersInHash: function allUsersInHash() {
	      return this.$store.getters.allUsersInHash;
	    },
	    subjectsInUserHash: function subjectsInUserHash() {
	      return this.$store.getters.subjectsInUserHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    },
	    usersAssignedHoursHash: function usersAssignedHoursHash() {
	      return this.$store.getters.usersAssignedHoursHash;
	    },
	    preparationHoursInUserHash: function preparationHoursInUserHash() {
	      return this.$store.getters.preparationHoursInUserHash;
	    },
	    localPoolHoursInUserHash: function localPoolHoursInUserHash() {
	      return this.$store.getters.localPoolHoursInUserHash;
	    },
	    clubHoursInUserHash: function clubHoursInUserHash() {
	      return this.$store.getters.clubHoursInUserHash;
	    },
	    theUserAssignedHours: function theUserAssignedHours() {
	      var obj = this.usersAssignedHoursHash[this.user.id] ? (0, _extends3.default)({}, this.usersAssignedHoursHash[this.user.id]) : {};
	      if (this.isPoolsDeactivated) {
	        var calId = this.user.user_calendar_id;
	        var assignedTeachingHours = this.getSumOfHoursForMasterType('teaching', calId);
	        obj.assigned_teaching_hours = assignedTeachingHours || 0;
	        obj.assigned_additional_task_hours = this.getSumOfHoursForMasterType('additional_tasks');
	        obj.assigned_preparation_hours = this.schoolPrepFactor !== null ? assignedTeachingHours * this.schoolPrepFactor : this.getSumOfHoursForMasterType('preparation') || 0;
	        obj.assigned_pool_hours = this.getSumOfHoursForMasterType('pool') || 0;
	        obj.assigned_club_hours = this.getSumOfHoursForMasterType('club') || 0;
	      }
	      return obj;
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    tasksInUserHash: function tasksInUserHash() {
	      return this.$store.getters.tasksInUserHash;
	    },
	    tasksInHash: function tasksInHash() {
	      return this.$store.getters.tasksInHash;
	    },
	    allUserTasks: function allUserTasks() {
	      var _this2 = this;
	
	      return this.tasksInUserHash[this.user.user_calendar_id] ? this.tasksInUserHash[this.user.user_calendar_id].map(function (taskId) {
	        return _this2.tasksInHash[taskId];
	      }) : [];
	    },
	    getAllUserTasksTask: function getAllUserTasksTask() {
	      return this.allUserTasks.filter(function (task) {
	        return task.subject_type === 'additional_tasks';
	      });
	    },
	    userActualHours: function userActualHours() {
	      return this.$store.state.subjects.userActualHours;
	    },
	    getUserHoursOverview: function getUserHoursOverview() {
	      var obj = this.user;
	      var usersWithAssignedHours = this.theUserAssignedHours;
	      var usersWithScheduledHours = this.userActualHours;
	      var user = {
	        id: obj.id,
	        name: obj.name,
	        assigned_total_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_total_hours) || 0,
	        actual_total_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_total_hours) || 0,
	        diff_total_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_total_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_total_hours || 0)),
	        assigned_teaching_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_teaching_hours) || 0,
	        actual_teaching_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_teaching_hours) || 0,
	        diff_teaching_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_teaching_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_teaching_hours || 0)),
	        substitute_pool_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.substitute_pool_hours) || 0,
	        actual_substitute_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_substitute_hours) || 0,
	        diff_substitute_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.substitute_pool_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_substitute_hours || 0)),
	        actual_absence_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_absence_hours) || 0,
	        assigned_additional_task_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_additional_task_hours) || 0,
	        actual_additional_task_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_additional_task_hours) || 0,
	        diff_additional_task_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_additional_task_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_additional_task_hours || 0)),
	        assigned_preparation_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_preparation_hours) || 0,
	        actual_preparation_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_preparation_hours) || 0,
	        diff_preparation_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_preparation_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_preparation_hours || 0)),
	        assigned_pool_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_pool_hours) || 0,
	        actual_pool_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_pool_hours) || 0,
	        diff_pool_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_pool_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_pool_hours || 0)),
	        assigned_club_hours: usersWithAssignedHours && this.toFixedIfNecessary(usersWithAssignedHours.assigned_club_hours) || 0,
	        actual_club_hours: usersWithScheduledHours && this.toFixedIfNecessary(usersWithScheduledHours.actual_club_hours) || 0,
	        diff_club_hours: this.toFixedIfNecessary(parseFloat(usersWithAssignedHours && usersWithAssignedHours.assigned_club_hours || 0) - parseFloat(usersWithScheduledHours && usersWithScheduledHours.actual_club_hours || 0))
	      };
	      return user;
	    },
	    getUserAssignedTotalHours: function getUserAssignedTotalHours() {
	      return this.theUserAssignedHours.assigned_total_hours || 0;
	    },
	    getUserAssignedTeachingHours: function getUserAssignedTeachingHours() {
	      return this.theUserAssignedHours.assigned_teaching_hours || 0;
	    },
	    getPercentageOfTeaching: function getPercentageOfTeaching() {
	      var total = this.getUserAssignedTotalHours;
	      var teaching = this.getUserAssignedTeachingHours;
	      var percentage = teaching / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getUserAssignedTaskHours: function getUserAssignedTaskHours() {
	      return this.theUserAssignedHours.assigned_additional_task_hours || 0;
	    },
	    getPercentageOfTasks: function getPercentageOfTasks() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserAssignedTaskHours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getUserAssignedPreparationHours: function getUserAssignedPreparationHours() {
	      return this.theUserAssignedHours.assigned_preparation_hours || 0;
	    },
	    getUserAssignedClubHours: function getUserAssignedClubHours() {
	      return this.theUserAssignedHours.assigned_club_hours || 0;
	    },
	    getPercentageOfPrep: function getPercentageOfPrep() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserAssignedPreparationHours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getUserAssignedPoolHours: function getUserAssignedPoolHours() {
	      return this.theUserAssignedHours.assigned_pool_hours || 0;
	    },
	    getPercentageOfPool: function getPercentageOfPool() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserAssignedPoolHours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getPercentageOfClub: function getPercentageOfClub() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserAssignedClubHours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getPercentageOfSubPool: function getPercentageOfSubPool() {
	      var total = this.getUserAssignedTotalHours;
	      var tasks = this.getUserHoursOverview.substitute_pool_hours;
	      var percentage = tasks / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    getSum: function getSum() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      var sumOfAllAssigned = this.getUserHoursOverview.actual_teaching_hours + this.getUserHoursOverview.actual_club_hours + this.getUserHoursOverview.assigned_additional_task_hours + this.getUserHoursOverview.assigned_preparation_hours + this.getUserHoursOverview.substitute_pool_hours + this.getUserHoursOverview.assigned_pool_hours;
	      return sumOfAllAssigned - total;
	    },
	    getTotalAssigned: function getTotalAssigned() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      var sumOfAllAssigned = this.getUserHoursOverview.assigned_teaching_hours + this.getUserHoursOverview.assigned_additional_task_hours + this.getUserHoursOverview.assigned_preparation_hours + this.getUserHoursOverview.substitute_pool_hours + this.getUserHoursOverview.assigned_club_hours + this.getUserHoursOverview.assigned_pool_hours;
	      return total - sumOfAllAssigned;
	    },
	    getPercentageOfRest: function getPercentageOfRest() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      var percentage = this.getTotalAssigned / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    getTotalTooMany: function getTotalTooMany() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      var sumOfAllAssigned = this.getUserHoursOverview.assigned_teaching_hours + this.getUserHoursOverview.assigned_additional_task_hours + this.getUserHoursOverview.assigned_preparation_hours + this.getUserHoursOverview.substitute_pool_hours + this.getUserHoursOverview.assigned_club_hours + this.getUserHoursOverview.assigned_pool_hours;
	      return sumOfAllAssigned - total;
	    },
	    getPercentageOfTooMany: function getPercentageOfTooMany() {
	      var total = this.getUserHoursOverview.assigned_total_hours;
	      var percentage = this.getTotalTooMany / total * 100;
	      return percentage.toFixed(0) + '%';
	    },
	    tasksHoursInUserHash: function tasksHoursInUserHash() {
	      return this.$store.getters.tasksHoursInUserHash;
	    },
	    userTasks: function userTasks() {
	      return this.$store.state.subjects.userTasks;
	    }
	  },
	  watch: {
	    userSettings: function userSettings() {
	      if (!this.isShowHeader) {
	        return;
	      }
	      if (this.userSettings && this.userSettings.hasOwnProperty('userTasksIsShowScheduled')) {
	        this.isShowScheduled = this.userSettings.userTasksIsShowScheduled;
	      }
	    },
	    activeSchoolYear: function activeSchoolYear() {
	      this.readUserAgreements();
	    }
	  },
	  methods: {
	    getSumOfHoursForMasterType: function getSumOfHoursForMasterType(subjectType) {
	      var isTeaching = subjectType === 'teaching';
	      var tasksFiltered = this.userTasks.filter(function (task) {
	        return isTeaching ? task.master_type === 'teaching' : task.subject_type === subjectType;
	      });
	      var tasksHours = tasksFiltered.map(function (task) {
	        return task.hours ? parseFloat(task.hours) : 0;
	      });
	      var sum = tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      }, 0);
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    getIsCategoryVisible: function getIsCategoryVisible(category) {
	      return this.hiddenTaskDistributionCategories && this.hiddenTaskDistributionCategories.indexOf(category) < 0;
	    },
	    getSchoolDays: function getSchoolDays() {
	      var _this3 = this;
	
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, function (success) {
	        if (success.status !== 'error') {
	          _this3.allVacationsDays = success;
	        }
	      }, function (failure) {
	        console.log('failure');
	      });
	    },
	    toFixedIfNecessary: function toFixedIfNecessary(value) {
	      return +parseFloat(value).toFixed(2);
	    },
	    setIsShowScheduled: function setIsShowScheduled(boolean) {
	      this.isShowScheduled = boolean;
	      this.$emit('changedIsShowScheduled', boolean);
	      var obj = {
	        userTasksIsShowScheduled: boolean
	      };
	      this.$store.dispatch('updateUserSettings', obj);
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { 'backgroundColor': color };
	    },
	    getAllUserTasks: function getAllUserTasks(calid) {
	      return this.tasksInUserHash[calid];
	    },
	    setEditSubject: function setEditSubject(editSubject) {
	      this.$emit('editSubject', editSubject);
	    },
	    setDeleteTask: function setDeleteTask(taskId) {
	      var task = this.tasksInHash[taskId];
	      task['itemType'] = 'task';
	      this.$store.commit('setItemToDelete', task);
	      this.$store.commit('setConfirmDeletion', true);
	    },
	    getTotalSubjectTeachingHours: function getTotalSubjectTeachingHours(userCalId) {
	      var _this4 = this;
	
	      var subjectsHours = this.subjectsInUserHash[userCalId] ? this.subjectsInUserHash[userCalId].map(function (subjectId) {
	        return _this4.getSubjectHours(subjectId) * 1;
	      }) : [0];
	      var sum = subjectsHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return sum.toFixed(2);
	    },
	    getTotalUserTasksTeachingHours: function getTotalUserTasksTeachingHours(userCalId) {
	      var _this5 = this;
	
	      var tasksHours = this.tasksInUserHash[userCalId] ? this.tasksInUserHash[userCalId].map(function (taskId) {
	        return _this5.tasksInHash[taskId].hours_teaching * 1;
	      }) : [0];
	      return tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      }).toFixed(2);
	    },
	    setActiveSubject: function setActiveSubject(subject) {
	      this.theActiveSubject = subject;
	    },
	    getSubjectHours: function getSubjectHours(subjectId) {
	      var _this6 = this;
	
	      var theSubject = this.subjectsInHash[subjectId];
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this6.activeUserId;
	      }) : -1;
	      if (idx > -1) {
	        return theSubject.teachers[idx].hours;
	      } else {
	        return theSubject.hours;
	      }
	    },
	    getIsHoursModified: function getIsHoursModified(subjectId) {
	      var _this7 = this;
	
	      var theSubject = this.subjectsInHash[subjectId];
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this7.activeUserId;
	      }) : -1;
	      return idx > -1;
	    },
	    readUserAgreements: function readUserAgreements() {
	      var _this8 = this;
	
	      _docendo2.default.schoolUserYearRead(this.schoolId, this.user.id, this.activeSchoolYear.name, function (success) {
	        _this8.userNorm = success.norm ? success.norm : [];
	        _this8.userAgreements = success.agreements ? success.agreements : '';
	      }, function (failure) {
	        console.log('failed!');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (!this.isShowHeader) {
	      this.isShowScheduled = false;
	    }
	  },
	  mounted: function mounted() {
	    this.getSchoolDays();
	    this.readUserAgreements();
	    if (!this.isShowHeader) {
	      return;
	    }
	    if (this.userSettings && this.userSettings.hasOwnProperty('userTasksIsShowScheduled')) {
	      this.isShowScheduled = this.userSettings.userTasksIsShowScheduled;
	      this.$emit('changedIsShowScheduled', this.isShowScheduled);
	    }
	  }
	};

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    isShowScheduled: {
	      type: Boolean,
	      default: true
	    },
	    isDateIntervalChanged: {
	      type: Boolean,
	      default: false
	    },
	    workDayDates: {},
	    assignedTotalHoursForYear: {
	      type: Number,
	      default: 0
	    },
	    assignedTotalHoursForPeriod: {
	      type: Number,
	      default: 0
	    },
	    diffTotalHoursForPeriod: {
	      type: Number,
	      default: 0
	    },
	    userActualHours: {
	      type: Object,
	      default: function _default() {}
	    },
	    getUserHoursOverview: {
	      type: Object,
	      default: function _default() {}
	    },
	    tooltipContent: {
	      type: String,
	      default: ''
	    },
	    numberOfWorkDays: {
	      type: Number,
	      default: 0
	    },
	    numberOfWorkDaysInPeriod: {
	      type: Number,
	      default: 0
	    }
	  },
	  computed: {
	    userActualWithKids: function userActualWithKids() {
	      var usersWithScheduledHours = this.userActualHours;
	      if (usersWithScheduledHours && usersWithScheduledHours.actual_with_kids_hours) {
	        return this.toFixedIfNecessary(usersWithScheduledHours.actual_with_kids_hours);
	      } else {
	        return 0;
	      }
	    },
	    userActualWithoutKids: function userActualWithoutKids() {
	      var usersWithScheduledHours = this.userActualHours;
	      if (usersWithScheduledHours && usersWithScheduledHours.actual_without_kids_hours) {
	        return this.toFixedIfNecessary(usersWithScheduledHours.actual_without_kids_hours);
	      } else {
	        return 0;
	      }
	    },
	    userWithKidsAndWithout: function userWithKidsAndWithout() {
	      var sum = this.userActualWithKids * 1 + this.userActualWithoutKids * 1;
	      return this.toFixedIfNecessary(sum);
	    },
	    userDiffWithKidsAndWithout: function userDiffWithKidsAndWithout() {
	      var sum = this.userActualWithKids * 1 + this.userActualWithoutKids * 1;
	      var diff = this.assignedTotalHoursForPeriod - sum;
	      return this.toFixedIfNecessary(diff);
	    },
	    userTasks: function userTasks() {
	      return this.$store.state.subjects.userTasks;
	    },
	    assignedHoursWithoutKids: function assignedHoursWithoutKids() {
	      var tasks = this.userTasks.filter(function (task) {
	        return task.master_type === 'without_kids';
	      });
	      var hours = [0];
	      tasks.forEach(function (task) {
	        hours.push(task.hours * 1);
	      });
	      return hours.reduce(function (acc, n) {
	        return acc + n;
	      });
	    },
	    assignedHoursWithoutKidsInPeriod: function assignedHoursWithoutKidsInPeriod() {
	      return this.assignedHoursForPeriod(this.assignedHoursWithoutKids);
	    },
	    diffHoursWithoutKidsForPeriod: function diffHoursWithoutKidsForPeriod() {
	      var hoursPerDay = this.assignedHoursWithoutKids / this.numberOfWorkDays * 1;
	      var hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var diff = hoursInThePeriod - this.userActualWithoutKids;
	      return this.toFixedIfNecessary(diff);
	    },
	    assignedHoursWithKids: function assignedHoursWithKids() {
	      return this.assignedTotalHoursForYear - this.assignedHoursWithoutKids;
	    },
	    assignedHoursWithKidsInPeriod: function assignedHoursWithKidsInPeriod() {
	      var hoursPerDay = this.assignedHoursWithoutKids / this.numberOfWorkDays * 1;
	      var assignedHoursWithoutKidsInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var result = this.assignedTotalHoursForPeriod - assignedHoursWithoutKidsInThePeriod;
	      return this.toFixedIfNecessary(result);
	    },
	    diffHoursWithKidsForPeriod: function diffHoursWithKidsForPeriod() {
	      var hoursPerDay = this.assignedHoursWithKids / this.numberOfWorkDays * 1;
	      var hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var diff = hoursInThePeriod - this.userActualWithKids;
	      return this.toFixedIfNecessary(diff);
	    }
	  },
	  methods: {
	    createTooltip: function createTooltip(sumForYear) {
	      var hoursPerDay = sumForYear / this.numberOfWorkDays;
	      var hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      var hoursPerDayFixed = this.toFixedIfNecessary(hoursPerDay);
	      var hoursForPeriodFixed = this.toFixedIfNecessary(hoursForPeriod);
	      return '<p><i>N\xE5r du v\xE6lger et andet datointerval end hele \xE5ret, kan du her se, hvor mange timer, der skal planl\xE6gges for medarbejderen i perioden og i gennemsnit per dag. Udregningen tager h\xF8jde for institutionens ferie- og helligdage.</i></p><br></p><p><b>Beregning</b></p><p>For \xE5ret: ' + sumForYear + ' timer / ' + this.numberOfWorkDays + ' dage = ' + hoursPerDayFixed + ' timer pr. dag</p><p>For perioden: ' + this.numberOfWorkDaysInPeriod + ' arbejdsdage * ' + hoursPerDayFixed + ' timer pr. dag = ' + hoursForPeriodFixed + ' timer</p>';
	    },
	    assignedHoursForPeriod: function assignedHoursForPeriod(hours) {
	      var hoursPerDay = hours / this.numberOfWorkDays * 1;
	      var hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod;
	      return this.toFixedIfNecessary(hoursInThePeriod);
	    },
	    toFixedIfNecessary: function toFixedIfNecessary(value) {
	      var num = value * 1;
	      return parseFloat(num).toFixed(2);
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { 'backgroundColor': color };
	    }
	  }
	};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserTasksOverviewOwnPoolsPool = __webpack_require__(1387);
	
	var _UserTasksOverviewOwnPoolsPool2 = _interopRequireDefault(_UserTasksOverviewOwnPoolsPool);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { UserTasksOverviewOwnPoolsPool: _UserTasksOverviewOwnPoolsPool2.default },
	  props: {
	    isShowScheduled: {
	      default: false
	    },
	    isDateIntervalChanged: {
	      default: false
	    },
	    schoolSettingShownOwnPools: {
	      default: function _default() {
	        return [];
	      }
	    },
	    userTasks: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    visibleCategories: function visibleCategories() {
	      var _this = this;
	
	      return this.userTasks.filter(function (tasks) {
	        return _this.schoolSettingShownOwnPools.includes(tasks.title);
	      });
	    }
	  }
	};

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    taskCategory: {
	      default: function _default() {
	        return [];
	      }
	    },
	    isDateIntervalChanged: {
	      default: false
	    },
	    isShowScheduled: {
	      default: true
	    }
	  },
	  computed: {
	    tasks: function tasks() {
	      return this.taskCategory.tasks;
	    },
	    sumOfHours: function sumOfHours() {
	      var tasksHours = [0];
	      if (this.tasks.length > 0) {
	        tasksHours = this.tasks.map(function (task) {
	          return task.hours ? parseFloat(task.hours) : 0;
	        });
	      }
	      var sum = tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfActual: function sumOfActual() {
	      var tasksActual = [0];
	      if (this.tasks.length > 0) {
	        tasksActual = this.tasks.map(function (task) {
	          var actual = task.actual ? task.actual : 0;
	          return parseFloat(actual);
	        });
	      }
	      var sum = tasksActual.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfDiff: function sumOfDiff() {
	      var tasksNumbers = [0];
	      if (this.tasks.length > 0) {
	        tasksNumbers = this.tasks.map(function (task) {
	          return task.diff ? parseFloat(task.diff) : 0;
	        });
	      }
	      var sum = tasksNumbers.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    }
	  },
	  methods: {
	    toFixedIfNecessary: function toFixedIfNecessary(value, dp) {
	      return +parseFloat(value).toFixed(dp);
	    }
	  }
	};

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    userCalendarId: {
	      default: 13
	    },
	    userId: {
	      default: 7
	    },
	    title: {
	      type: String,
	      default: 'Øvrige opgaver'
	    },
	    tasks: {
	      default: function _default() {
	        return [];
	      }
	    },
	    assignedHours: {
	      default: '0.0'
	    },
	    isShowScheduled: {
	      default: false,
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1
	    };
	  },
	
	  computed: {
	    isOnlyShowScheduled: function isOnlyShowScheduled() {
	      return this.title === 'absence' || this.title === 'substitute_hours';
	    },
	    sortedTasks: function sortedTasks() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.tasks;
	      if (sortKey) {
	        data = data.sort(function (a, b) {
	          a = a[sortKey];
	          b = b[sortKey];
	          if (sortKey !== 'name' && sortKey !== 'calendar') {
	            if (order < 0) {
	              return a - b;
	            } else {
	              return b - a;
	            }
	          } else {
	            a = a.toLowerCase();
	            b = b.toLowerCase();
	            return (a === b ? 0 : a > b ? 1 : -1) * order;
	          }
	        });
	      }
	      return data;
	    },
	    sumOfHours: function sumOfHours() {
	      var tasksHours = [0];
	      if (this.tasks.length > 0) {
	        tasksHours = this.tasks.map(function (task) {
	          return task.hours ? parseFloat(task.hours) : 0;
	        });
	      }
	      var sum = tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfActual: function sumOfActual() {
	      var tasksActual = [0];
	      if (this.tasks.length > 0) {
	        tasksActual = this.tasks.map(function (task) {
	          var actual = task.actual ? task.actual : 0;
	          return parseFloat(actual);
	        });
	      }
	      var sum = tasksActual.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfDiff: function sumOfDiff() {
	      var tasksNumbers = [0];
	      if (this.tasks.length > 0) {
	        tasksNumbers = this.tasks.map(function (task) {
	          return task.diff ? parseFloat(task.diff) : 0;
	        });
	      }
	      var sum = tasksNumbers.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    }
	  },
	  methods: {
	    getI18n: function getI18n(title) {
	      switch (title) {
	        case 'teaching':
	          return this.$t('vue2.task_overview.teaching');
	        case 'other':
	          return this.$t('vue2.task_overview.tasks');
	        case 'preparation':
	          return this.$t('vue2.task_overview.preparation');
	        case 'absence':
	          return this.$t('vue2.task_overview.absence');
	        case 'club':
	          return this.$t('vue2.task_overview.club');
	        case 'substitute_hours':
	          return this.$t('vue2.task_overview.substitute_hours');
	        case 'pool':
	          return this.$t('vue2.task_overview.pool');
	        case 'unknown':
	          return this.$t('vue2.task_overview.unknown');
	        case 'with_kids':
	          return 'Tid med børn';
	        case 'without_kids':
	          return 'Tid uden børn';
	        default:
	          return title;
	      }
	    },
	    setSortKey: function setSortKey(prop) {
	      this.sortKey = prop;
	      this.sortOrder === 1 ? this.sortOrder = -1 : this.sortOrder = 1;
	    },
	    toFixedIfNecessary: function toFixedIfNecessary(value, dp) {
	      return +parseFloat(value).toFixed(dp);
	    },
	    getTaskActual: function getTaskActual(task) {
	      var actual = task.actual ? task.actual * 1 : 0;
	      return this.toFixedIfNecessary(actual, 2);
	    },
	    getTasksHours: function getTasksHours(task) {
	      return task.hours ? this.toFixedIfNecessary(task.hours, 2) : '';
	    },
	    calcDifference: function calcDifference(task) {
	      var actual = task.actual ? task.actual * 1 : 0;
	      var hours = task.hours ? parseFloat(task.hours) : null;
	      return task.hours ? this.toFixedIfNecessary(hours - actual, 2) : '';
	    },
	    getSubjectHours: function getSubjectHours(task) {
	      var _this = this;
	
	      var theSubject = task;
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this.userId;
	      }) : -1;
	      var num = 0;
	      if (idx > -1) {
	        num = theSubject.teachers[idx].hours;
	      } else {
	        num = theSubject.hours;
	      }
	      return parseFloat(num).toFixed(1);
	    },
	    setEditTask: function setEditTask(task) {
	      this.$emit('edit', task);
	    },
	    setDeleteTask: function setDeleteTask(task) {
	      this.$emit('delete', task);
	    },
	    getShowCalendarIfNotOwn: function getShowCalendarIfNotOwn(task) {
	      var _this2 = this;
	
	      var isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId;
	      if (isInOwnCalendar) {
	        return [];
	      } else {
	        return task.belongs_to_calendars ? task.belongs_to_calendars.map(function (calId) {
	          return _this2.allCalendarsInHash[calId];
	        }) : [this.allCalendarsInHash[task.calendar_id]];
	      }
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { 'backgroundColor': color };
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this3 = this;
	
	    this.tasks.forEach(function (task, i) {
	      return _this3.$set(_this3.tasks[i], 'diff', _this3.calcDifference(task));
	    });
	  }
	};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    userCalendarId: {
	      default: 13
	    },
	    userId: {
	      default: 7
	    },
	    title: {
	      type: String,
	      default: 'Øvrige opgaver'
	    },
	    tasks: {
	      default: function _default() {
	        return [];
	      }
	    },
	    assignedHours: {
	      default: '0.0'
	    },
	    isShowScheduled: {
	      default: false,
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      sortKey: 'name',
	      sortOrder: 1
	    };
	  },
	
	  computed: {
	    isOnlyShowScheduled: function isOnlyShowScheduled() {
	      return this.title === 'absence' || this.title === 'substitute_hours';
	    },
	    sortedTasks: function sortedTasks() {
	      var sortKey = this.sortKey;
	      var order = this.sortOrder;
	      var data = this.tasks;
	      if (sortKey) {
	        data = data.sort(function (a, b) {
	          a = a[sortKey];
	          b = b[sortKey];
	          if (sortKey !== 'name' && sortKey !== 'calendar') {
	            if (order < 0) {
	              return a - b;
	            } else {
	              return b - a;
	            }
	          } else {
	            a = a.toLowerCase();
	            b = b.toLowerCase();
	            return (a === b ? 0 : a > b ? 1 : -1) * order;
	          }
	        });
	      }
	      return data;
	    },
	    tasksGrouped: function tasksGrouped() {
	      var types = [];
	      this.sortedTasks.forEach(function (event) {
	        var idx = types.findIndex(function (masterType) {
	          return masterType.masterType === event.master_type;
	        });
	        if (idx < 0) {
	          var obj = { masterType: event.master_type, events: [event], sum: event.actual };
	          types.push(obj);
	        } else {
	          types[idx]['events'].push(event);
	          types[idx]['sum'] += event.actual;
	        }
	      });
	      var masterTypeOrder = ['teaching', 'club', 'other', 'preparation', 'pool', 'unknown'];
	      types.sort(function (a, b) {
	        var aIndex = masterTypeOrder.indexOf(a.masterType);
	        var bIndex = masterTypeOrder.indexOf(b.masterType);
	
	        var aFinalIndex = aIndex === -1 ? 9999 : aIndex;
	        var bFinalIndex = bIndex === -1 ? 9999 : bIndex;
	
	        return aFinalIndex - bFinalIndex;
	      });
	
	      return types;
	    },
	    sumOfHours: function sumOfHours() {
	      var tasksHours = [0];
	      if (this.tasks.length > 0) {
	        tasksHours = this.tasks.map(function (task) {
	          return parseFloat(task.hours);
	        });
	      }
	      var sum = tasksHours.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfActual: function sumOfActual() {
	      var tasksActual = [0];
	      if (this.tasks.length > 0) {
	        tasksActual = this.tasks.map(function (task) {
	          var actual = task.actual ? task.actual : 0;
	          return parseFloat(actual);
	        });
	      }
	      var sum = tasksActual.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    sumOfDiff: function sumOfDiff() {
	      var tasksNumbers = [0];
	      if (this.tasks.length > 0) {
	        tasksNumbers = this.tasks.map(function (task) {
	          return parseFloat(task.diff);
	        });
	      }
	      var sum = tasksNumbers.reduce(function (acc, item) {
	        return acc + item;
	      });
	      return this.toFixedIfNecessary(sum, 2);
	    },
	    allCalendarsInHash: function allCalendarsInHash() {
	      return this.$store.getters.allCalendarsInHash;
	    },
	    subjectsInHash: function subjectsInHash() {
	      return this.$store.getters.subjectsInHash;
	    }
	  },
	  methods: {
	    getI18n: function getI18n(title) {
	      switch (title) {
	        case 'teaching':
	          return this.$t('vue2.task_overview.teaching');
	        case 'other':
	          return this.$t('vue2.task_overview.tasks');
	        case 'preparation':
	          return this.$t('vue2.task_overview.preparation');
	        case 'absence':
	          return this.$t('vue2.task_overview.absence');
	        case 'club':
	          return this.$t('vue2.task_overview.club');
	        case 'substitute_hours':
	          return this.$t('vue2.task_overview.substitute_hours');
	        case 'pool':
	          return this.$t('vue2.task_overview.pool');
	        case 'unknown':
	          return this.$t('vue2.task_overview.unknown');
	        case 'with_kids':
	          return 'Tid med børn';
	        case 'without_kids':
	          return 'Tid uden børn';
	        default:
	          return title;
	      }
	    },
	    setSortKey: function setSortKey(prop) {
	      this.sortKey = prop;
	      this.sortOrder === 1 ? this.sortOrder = -1 : this.sortOrder = 1;
	    },
	    toFixedIfNecessary: function toFixedIfNecessary(value, dp) {
	      return +parseFloat(value).toFixed(dp);
	    },
	    getTaskActual: function getTaskActual(task) {
	      var actual = task.actual ? task.actual * 1 : 0;
	      return this.toFixedIfNecessary(actual, 2);
	    },
	    getTasksHours: function getTasksHours(task) {
	      return this.toFixedIfNecessary(task.hours, 2);
	    },
	    calcDifference: function calcDifference(task) {
	      var actual = task.actual ? task.actual * 1 : 0;
	      var hours = parseFloat(task.hours);
	      return this.toFixedIfNecessary(hours - actual, 2);
	    },
	    getSubjectHours: function getSubjectHours(task) {
	      var _this = this;
	
	      var theSubject = task;
	      var idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(function (teacher) {
	        return teacher.user_id === _this.userId;
	      }) : -1;
	      var num = 0;
	      if (idx > -1) {
	        num = theSubject.teachers[idx].hours;
	      } else {
	        num = theSubject.hours;
	      }
	      return parseFloat(num).toFixed(1);
	    },
	    setEditTask: function setEditTask(task) {
	      this.$emit('edit', task);
	    },
	    setDeleteTask: function setDeleteTask(task) {
	      this.$emit('delete', task);
	    },
	    getShowCalendarIfNotOwn: function getShowCalendarIfNotOwn(task) {
	      var _this2 = this;
	
	      var isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId;
	      if (isInOwnCalendar) {
	        return [];
	      } else {
	        return task.belongs_to_calendars ? task.belongs_to_calendars.map(function (calId) {
	          return _this2.allCalendarsInHash[calId];
	        }) : [this.allCalendarsInHash[task.calendar_id]];
	      }
	    },
	    scaleIndicator: function scaleIndicator(diff) {
	      var color = 'rgba(62, 207, 142, 0.4)';
	      var newDiff = parseFloat(diff);
	      var indicatorPercentage = parseFloat(newDiff.toFixed(0));
	      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
	        indicatorPercentage = '0' + indicatorPercentage;
	      }
	      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
	        indicatorPercentage = '0' + indicatorPercentage * -1;
	      }
	      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
	        indicatorPercentage = indicatorPercentage * -1;
	      }
	      if (newDiff === 0) {
	        color = 'transparent';
	      }
	      if (newDiff < 0) {
	        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff < -99) {
	        color = 'rgba(250, 86, 90, 1)';
	      }
	      if (newDiff > 0) {
	        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')';
	      }
	      if (newDiff > 99) {
	        color = 'rgba(62, 207, 142, 1)';
	      }
	      return { 'backgroundColor': color };
	    }
	  },
	  beforeMount: function beforeMount() {
	    var _this3 = this;
	
	    this.tasks.forEach(function (task, i) {
	      return _this3.$set(_this3.tasks[i], 'diff', _this3.calcDifference(task));
	    });
	  }
	};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'direct-day-selector',
	  description: 'Can list individual days of a date range in month rows.\n' + 'Each day can be selected, this emits two events:\n' + ' "toggled" : has the date and whether it is selected\n' + ' "updated" : has counts and a list of selected dates\n',
	  props: {
	    fromDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      },
	
	      validator: function validator(value) {
	        return (0, _moment2.default)(value).isValid();
	      }
	    },
	    toDate: {
	      default: function _default() {
	        return (0, _moment2.default)().add(1, 'month');
	      },
	
	      validator: function validator(value) {
	        return (0, _moment2.default)(value).isValid();
	      }
	    },
	    selectedDays: {
	      default: function _default() {
	        return [];
	      },
	
	      type: Array
	    },
	    includeWeekends: {
	      default: function _default() {
	        return false;
	      },
	
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      dates: [],
	      datesInMonths: [],
	      checked: false
	    };
	  },
	
	  watch: {
	    fromDate: function fromDate(newVal, oldVal) {
	      this.updateDates();
	    },
	    toDate: function toDate(newVal, oldVal) {
	      this.updateDates();
	    },
	    includeWeekends: function includeWeekends(newVal, oldVal) {
	      this.updateDates();
	    },
	    selectedDays: function selectedDays(newVal, oldVal) {
	      this.updateDates();
	    }
	  },
	  computed: {
	    totalDaysCount: function totalDaysCount() {
	      return this.dates.length;
	    },
	    selectableDaysCount: function selectableDaysCount() {
	      return this.dates.filter(function (date) {
	        return date.isSelectable;
	      }).length;
	    },
	    selectedDaysCount: function selectedDaysCount() {
	      var self = this;
	      return this.selectedDays.filter(function (date) {
	        return self.fromDate <= (0, _moment2.default)(date) && (0, _moment2.default)(date) <= self.toDate;
	      }).length;
	    }
	  },
	  methods: {
	    updateDates: function updateDates() {
	      var _this = this;
	
	      this.datesInMonths = [];
	      this.dates = [];
	      if (this.fromDate < this.toDate) {
	        var theDate = this.fromDate.clone().startOf('month');
	
	        var _loop = function _loop() {
	          var thisDate = theDate.clone().endOf('day');
	          if (theDate.format('D') === '1') {
	            var monthObj = { month: (0, _moment2.default)(theDate.format('YYYY-MM')), dates: [] };
	            _this.datesInMonths.push(monthObj);
	          }
	          thisDate.simpleDate = thisDate.format('YYYY-MM-DD');
	          thisDate.isWeekend = _this.isWeekend(thisDate);
	          thisDate.isInRange = _this.isInRange(thisDate);
	          thisDate.isSelectable = _this.includeWeekends ? thisDate.isInRange : !thisDate.isWeekend && thisDate.isInRange;
	
	          thisDate.isSelected = thisDate.isSelectable && _this.selectedDays.indexOf(thisDate.simpleDate) > -1;
	          var idx = _this.datesInMonths.findIndex(function (month) {
	            return (0, _moment2.default)(month.month).format('YYYY-MM') === thisDate.format('YYYY-MM');
	          });
	          _this.datesInMonths[idx].dates.push(thisDate);
	          theDate.add(1, 'days');
	        };
	
	        while (theDate.clone().endOf('day') <= this.toDate.clone().endOf('month')) {
	          _loop();
	        }
	      }
	      this.sendUpdate();
	    },
	    isInRange: function isInRange(date) {
	      return date.isBetween(this.fromDate.clone().startOf('day'), this.toDate.clone().endOf('day'), null, '[]');
	    },
	    isWeekend: function isWeekend(date) {
	      return date.isoWeekday() === 6 || date.isoWeekday() === 7;
	    },
	    isSelected: function isSelected(date) {
	      return date.isSelected;
	    },
	    toggle: function toggle(date) {
	      if (date.isSelectable) {
	        date.isSelected = !date.isSelected;
	        if (!this.isDateSelected(date)) {
	          this.selectedDays.push(date.simpleDate);
	        } else {
	          var index = this.selectedDays.indexOf(date.simpleDate);
	          this.selectedDays.splice(index, 1);
	        }
	        this.sendToggle(date, date.isSelected);
	      }
	    },
	    sendToggle: function sendToggle(date, isSelected) {
	      this.$emit('toggled', date.simpleDate, isSelected);
	    },
	    sendUpdate: function sendUpdate() {
	      this.$emit('updated', {
	        selectedDays: this.selectedDays,
	        totalDaysCount: this.totalDaysCount,
	        selectableDaysCount: this.selectableDaysCount,
	        selectedDaysCount: this.selectedDaysCount
	      });
	    },
	    isDateSelected: function isDateSelected(date) {
	      return this.selectedDays.indexOf((0, _moment2.default)(date).format('YYYY-MM-DD')) > -1;
	    }
	  },
	  mounted: function mounted() {
	    this.updateDates();
	  }
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DirectDaySelector = __webpack_require__(129);
	
	var _DirectDaySelector2 = _interopRequireDefault(_DirectDaySelector);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'vacation-day-selector',
	  components: {
	    DirectDaySelector: _DirectDaySelector2.default, DatePickerRange: _DatePickerRange2.default
	  },
	  props: {
	    initialYear: {
	      type: String,
	      default: '2018-2019'
	    },
	    schoolId: {
	      type: Number,
	      default: 3
	    },
	    emitEventOnLoad: {
	      type: Boolean,
	      default: true
	    },
	    fromDate: {
	      default: function _default() {
	        return (0, _moment2.default)('2016-08-08T12:00');
	      },
	      validator: function validator(value) {
	        return (0, _moment2.default)(value).isValid();
	      }
	    },
	    toDate: {
	      default: function _default() {
	        return (0, _moment2.default)('2017-06-23T12:00');
	      },
	      validator: function validator(value) {
	        return (0, _moment2.default)(value).isValid();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      initialSelectedDates: [],
	      vacationDays: {},
	      schoolYears: [],
	      activeSchoolYears: [],
	      selectedSchoolYearIndex: 0,
	      currFromDate: this.fromDate,
	      currToDate: this.toDate,
	      includeWeekends: false
	    };
	  },
	
	  watch: {
	    schoolDaysCount: function schoolDaysCount(val) {
	      this.$emit('schoolDays', val);
	    }
	  },
	  mounted: function mounted() {
	    _docendo2.default.schoolYearsRead(this.schoolId, {}, 'name', this.schoolYearsCallback);
	    _docendo2.default.schoolVacationDaysRead(this.schoolId, this.initialDaysCallback);
	  },
	
	  computed: {
	    schoolId: function schoolId() {
	      if (window.SCHOOL && window.SCHOOL.id) {
	        return window.SCHOOL.id;
	      }
	      if (this.$route && this.$route.params && this.$route.params.school_id) {
	        return this.$route.params.school_id;
	      }
	    },
	    isKindergarten: function isKindergarten() {
	      return this.$store.getters.isKindergarten;
	    },
	    vacationDaysBetweenStartAndEnd: function vacationDaysBetweenStartAndEnd() {
	      var _this = this;
	
	      return this.initialSelectedDates.filter(function (date) {
	        return (0, _moment2.default)(date).isSameOrBefore(_this.currToDate) && (0, _moment2.default)(date).isSameOrAfter(_this.currFromDate);
	      });
	    },
	    vacationDaysWithoutWeekends: function vacationDaysWithoutWeekends() {
	      return this.vacationDaysBetweenStartAndEnd.filter(function (date) {
	        if ((0, _moment2.default)(date).isoWeekday() !== 6 && (0, _moment2.default)(date).isoWeekday() !== 7) {
	          return date;
	        }
	      });
	    },
	    allDates: function allDates() {
	      var startDate = this.currFromDate;
	      var dateArray = [];
	      var currentDate = (0, _moment2.default)(startDate);
	      var stopDate = (0, _moment2.default)(this.currToDate);
	      while (currentDate <= stopDate) {
	        dateArray.push((0, _moment2.default)(currentDate).format('YYYY-MM-DD'));
	        currentDate = (0, _moment2.default)(currentDate).add(1, 'days');
	      }
	      return dateArray;
	    },
	    weekends: function weekends() {
	      return this.allDates.filter(function (date) {
	        if ((0, _moment2.default)(date).isoWeekday() === 6 || (0, _moment2.default)(date).isoWeekday() === 7) {
	          return date;
	        }
	      });
	    },
	    newCount: function newCount() {
	      return this.currToDate.diff(this.currFromDate, 'days') + 1;
	    },
	    schoolDaysCount: function schoolDaysCount() {
	      if (this.includeWeekends) {
	        return this.newCount - this.vacationDaysBetweenStartAndEnd.length;
	      } else {
	        return this.newCount - this.weekends.length - this.vacationDaysWithoutWeekends.length;
	      }
	    },
	    selectedSchoolYear: function selectedSchoolYear() {
	      return this.activeSchoolYears[this.selectedSchoolYearIndex];
	    }
	  },
	  methods: {
	    updateToFromDates: function updateToFromDates() {
	      this.currFromDate = (0, _moment2.default)(this.selectedSchoolYear.student_time_start);
	      this.currToDate = (0, _moment2.default)(this.selectedSchoolYear.student_time_end);
	    },
	    dayToggled: function dayToggled(date, isSelected) {
	      if (isSelected) {
	        _docendo2.default.schoolVacationDaysCreate(this.schoolId, date, this.saved, this.failed);
	      } else {
	        var id = this.vacationDays[date];
	        _docendo2.default.schoolVacationDaysDelete(this.schoolId, id, this.saved, this.failed);
	      }
	    },
	    saved: function saved(vacationDay) {
	      this.vacationDays[vacationDay.day] = vacationDay.id;
	    },
	    failed: function failed(error) {
	      console.log('failed', error);
	    },
	    schoolYearsCallback: function schoolYearsCallback(data) {
	      var _this2 = this;
	
	      this.schoolYears = data;
	      this.activeSchoolYears = this.schoolYears.filter(function (schoolYear) {
	        return schoolYear.active;
	      });
	      this.selectedSchoolYearIndex = this.initialYear ? this.activeSchoolYears.findIndex(function (x) {
	        return x.name === _this2.initialYear;
	      }) : 0;
	      if (this.selectedSchoolYearIndex < 0) {
	        this.selectedSchoolYearIndex = 0;
	      }
	      this.updateToFromDates();
	    },
	    initialDaysCallback: function initialDaysCallback(data) {
	      var _this3 = this;
	
	      this.initialSelectedDates = [];
	      data.forEach(function (vacationDay) {
	        this.vacationDays[vacationDay.day] = vacationDay.id;
	        this.initialSelectedDates.push(vacationDay.day);
	      }, this);
	      if (this.emitEventOnLoad) {
	        this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_vacation': true });
	
	        setTimeout(function () {
	          _this3.$store.commit('setOnboardingStep', 0);
	        }, 2500);
	      }
	    },
	    onSchoolYearChanged: function onSchoolYearChanged() {
	      this.updateToFromDates();
	      _docendo2.default.schoolVacationDaysRead(this.schoolId, this.initialDaysCallback);
	    },
	    onStartDateChanged: function onStartDateChanged(date) {
	      var self = this;
	      if (this.selectedSchoolYear === undefined) {
	        return;
	      }
	      if (date !== this.selectedSchoolYear.student_time_start) {
	        _docendo2.default.schoolYearsUpdate(this.schoolId, this.selectedSchoolYear.id, { student_time_start: date }, function (data) {
	          self.currFromDate = (0, _moment2.default)(date);
	          self.schoolYears[self.selectedSchoolYearIndex].student_time_start = data.student_time_start;
	        });
	      }
	    },
	    onEndDateChanged: function onEndDateChanged(date) {
	      var self = this;
	      if (this.selectedSchoolYear === undefined) {
	        return;
	      }
	      if (date !== this.selectedSchoolYear.student_time_end) {
	        _docendo2.default.schoolYearsUpdate(this.schoolId, this.selectedSchoolYear.id, { student_time_end: date }, function (data) {
	          self.currToDate = (0, _moment2.default)(date);
	          self.schoolYears[self.selectedSchoolYearIndex].student_time_end = data.student_time_end;
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	__webpack_require__(165);
	
	__webpack_require__(166);
	
	__webpack_require__(164);
	
	var _vueQuillEditor = __webpack_require__(359);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DoWeekPlanLog = __webpack_require__(344);
	
	var _DoWeekPlanLog2 = _interopRequireDefault(_DoWeekPlanLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    quillEditor: _vueQuillEditor.quillEditor,
	    DModal: _DModal2.default,
	    DoWeekPlanLog: _DoWeekPlanLog2.default
	  },
	  props: {
	    isUploadFile: {
	      type: Boolean,
	      default: false
	    },
	    isUploadImage: {
	      type: Boolean,
	      default: false
	    },
	    textInput: {
	      type: String,
	      default: null
	    },
	    lesson: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    noteType: {
	      type: String,
	      default: ''
	    },
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    isInTestOfSaveButton: {
	      type: Boolean,
	      default: true
	    },
	    isClosingWithoutSaving: {
	      type: Boolean,
	      default: false
	    },
	
	    activeEIP: {},
	    isSaving: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      initialHTML: '',
	      isChanged: false,
	      editor: null,
	      edit: false,
	      text: '',
	      linkText: '',
	      link: '',
	      isMouseDown: false,
	      isLinkModal: false,
	      preserveWhitespace: true,
	      editorOption: {
	        modules: {
	          toolbar: {
	            container: '#toolbar'
	          }
	        },
	        clipboard: {
	          matchVisual: false
	        }
	      },
	      placeholder: '',
	      isShowModalTeleport: false,
	      isShowModalTeleportClosingWithoutSaving: false
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    linkWithHttp: function linkWithHttp() {
	      var withHttp = function withHttp(url) {
	        return !/^https?:\/\//i.test(url) ? 'http://' + url : url;
	      };
	      return withHttp(this.link);
	    },
	    isValidURL: function isValidURL() {
	      return this.checkValidURL(this.linkWithHttp);
	    },
	    isValidated: function isValidated() {
	      return this.isValidURL && this.linkText.length > 0;
	    },
	    textWithoutHTML: function textWithoutHTML() {
	      return this.text ? this.text.replace(/<\/?p[^>]*>/g, '') : '';
	    },
	    i18n: function i18n() {
	      return {
	        da: {
	          bold: 'Fed',
	          italic: 'Kursiv',
	          underline: 'Understreget',
	          list_ordered: 'Liste nummereret',
	          list_bullets: 'Liste i punktform',
	          insert_link: 'Indsæt link',
	          link_text_label: 'Tekst der skal vises',
	          link_text_placeholder: 'eks. Docendo',
	          link_link_label: 'Webadressen',
	          link_link_placeholder: 'eks. www.docendo.dk',
	          cancel: 'Annuller'
	        },
	        en: {
	          bold: 'Bold',
	          italic: 'Italic',
	          underline: 'Underline',
	          list_ordered: 'List Ordered',
	          list_bullets: 'List i punktform',
	          insert_link: 'Insert link',
	          link_text_label: 'Text to be shown',
	          link_text_placeholder: 'e.g. Docendo',
	          link_link_label: 'Web address',
	          link_link_placeholder: 'e.g. www.docendo.co',
	          cancel: 'Cancel'
	        },
	        nb: {
	          bold: 'Fet',
	          italic: 'Kursiv',
	          underline: 'Understreket',
	          list_ordered: 'Punktliste',
	          list_bullets: 'Nummerert liste',
	          insert_link: 'Sett inn link',
	          link_text_label: 'Tekst som skal vises',
	          link_text_placeholder: 'eks. Docendo',
	          link_link_label: 'Nettadressen',
	          link_link_placeholder: 'eks. www.docendo.no',
	          cancel: 'Annuller'
	        }
	      };
	    }
	  },
	  watch: {
	    activeEIP: function activeEIP(val, oldVal) {
	      if (val) {
	        this.reboot();
	      }
	    },
	    textInput: function textInput(val) {
	      if (!this.lesson) {
	        this.text = val;
	      }
	    },
	    isClosingWithoutSaving: function isClosingWithoutSaving(val) {
	      var _this = this;
	
	      if (val) {
	        this.isShowModalTeleportClosingWithoutSaving = true;
	        this.$nextTick(function (_) {
	          var el = _this.$refs.d_modal_teleport_alert;
	          document.getElementById('djs-content-container').appendChild(el);
	        });
	      }
	    }
	  },
	  methods: {
	    reboot: function reboot() {
	      this.text = this.lesson[this.noteType];
	      this.initialHTML = this.text;
	      this.editor.focus();
	    },
	    checkValidURL: function checkValidURL(str) {
	      return true;
	    },
	    setIsLinkModal: function setIsLinkModal(boolean) {
	      var _this2 = this;
	
	      if (boolean) {
	        this.isShowModalTeleport = true;
	        this.isLinkModal = true;
	        this.$nextTick(function (_) {
	          var el = _this2.$refs.d_modal_teleport;
	          document.getElementById('djs-content-container').appendChild(el);
	          _this2.$refs.linkTextInput.focus();
	        });
	      } else {
	        this.$refs.d_modal_teleport.remove();
	        this.linkText = '';
	        this.link = '';
	        this.isLinkModal = false;
	      }
	    },
	    insertLink: function insertLink() {
	      this.editor.focus();
	      var index = (this.editor.getSelection() || {}).index || this.editor.getLength() - 1;
	      this.editor.insertText(index, this.linkText, 'link', this.linkWithHttp);
	      this.setIsLinkModal(false);
	    },
	    onEditorReady: function onEditorReady(quill) {
	      this.editor = quill;
	      quill.focus();
	    },
	    onUploadFile: function onUploadFile(e) {
	      console.log('show some file uploading');
	    },
	    cancelModal: function cancelModal() {
	      this.$refs.d_modal_teleport_alert.remove();
	      this.isShowModalTeleportClosingWithoutSaving = false;
	      this.cancel();
	    },
	    saveModal: function saveModal() {
	      this.$refs.d_modal_teleport_alert.remove();
	      this.isShowModalTeleportClosingWithoutSaving = false;
	      this.save();
	    },
	    cancel: function cancel() {
	      this.edit = false;
	      if (this.lesson) {
	        this.text = this.lesson[this.noteType];
	      } else {
	        this.text = this.textInput;
	      }
	      this.setIsEditorTextChanged(false);
	      this.$emit('close', false);
	    },
	    save: function save() {
	      this.edit = false;
	      if (this.lesson) {
	        this.$emit('close', { lesson: this.lesson, noteType: this.noteType, text: this.text });
	      } else {
	        this.$emit('close', { text: this.text });
	      }
	      this.setIsEditorTextChanged(false);
	    },
	    onEditorChange: function onEditorChange(_ref) {
	      var quill = _ref.quill,
	          html = _ref.html,
	          text = _ref.text;
	
	      var oldVal = this.lesson[this.noteType];
	      var newVal = html;
	      var isDiff = oldVal.trim() !== newVal.trim();
	      this.text = html;
	
	      if (this.textInput && this.textInput === html || this.initialHTML === html) {
	        return;
	      }
	      if (isDiff) {
	        this.setIsEditorTextChanged(true);
	      }
	    },
	    setIsEditorTextChanged: function setIsEditorTextChanged(bool) {
	      this.isChanged = bool;
	      this.$emit('changed', bool);
	      if (this.isInTestOfSaveButton) {
	        _eventbus2.default.isLessonNoteChangedWithoutSaving = bool;
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.textInput) {
	      this.text = this.textInput;
	      this.initialHTML = this.text;
	      return;
	    }
	    if (this.lesson && this.noteType) {
	      this.text = this.lesson[this.noteType];
	      this.initialHTML = this.text;
	    }
	    window.addEventListener('beforeunload', function (e) {
	      var confirmMessage = 'Continue without saving?';
	      if (_eventbus2.default.isLessonNoteChangedWithoutSaving) {
	        (e || window.event).returnValue = confirmMessage;
	        return confirmMessage;
	      }
	    });
	  }
	};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DEIP = __webpack_require__(1389);
	
	var _DEIP2 = _interopRequireDefault(_DEIP);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    weekplan: 'Ugeplan',
	    no_events_this_week: 'Ingen lektioner eller noter i ugen',
	    learning_goal: 'Læringsmål',
	    meeting_purpose: 'Formål med mødet',
	    content: 'Indhold',
	    agenda: 'Agenda',
	    pupil_preparation: 'Elevforberedelse',
	    decisions_and_resume: 'Beslutninger og resumé',
	    teacher_notes: 'Vikarnoter / Interne noter',
	    internal_notes: 'Noter'
	  },
	  en: {
	    weekplan: 'Weekplan',
	    no_events_this_week: 'No lessons or notes this week',
	    learning_goal: 'Learning goal',
	    meeting_purpose: 'Purpose of the meeting',
	    content: 'Content',
	    agenda: 'Agenda',
	    pupil_preparation: 'Homework',
	    decisions_and_resume: 'Decisions and summary',
	    internal_notes: 'Notes',
	    teacher_notes: 'Teachers notes'
	  },
	  nb: {
	    weekplan: 'Ukeplan',
	    no_events_this_week: 'Ingen leksjoner eller notater denne uken',
	    learning_goal: 'Læringsmål',
	    meeting_purpose: 'Formål med møtet',
	    content: 'Innhold',
	    agenda: 'Agenda',
	    pupil_preparation: 'Elevforberedelse',
	    decisions_and_resume: 'Beslutninger og resymé',
	    teacher_notes: 'Vikarnotater',
	    internal_notes: 'Notater'
	  }
	};
	
	exports.default = {
	  props: {
	    isReadOnly: {
	      type: Boolean,
	      default: false
	    },
	    isI18N: {
	      type: Boolean,
	      default: false
	    },
	    isInPrintMode: {
	      type: Boolean,
	      default: false
	    }
	  },
	  components: { Loader: _Loader2.default, EIP: _DEIP2.default },
	  data: function data() {
	    return {
	      isInViewport: false,
	      isWeekplanHasLesson: false,
	      activeEIP: null,
	      activeEvent: null,
	      activeNoteType: '',
	      activeText: '',
	      isEditorChangedWithoutSave: false,
	      isClosingWithoutSaving: false,
	      weekNote: '',
	      weeknoteId: null,
	      weekNoteState: '',
	      isSavingEIP: false
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      return I18N;
	    },
	    placeholderHeight: function placeholderHeight() {
	      var boxHeight = 27 + 12;
	      var dayHeight = 24 + 12 + 22 + 34;
	      var eventHeight = 68 + 12;
	      var days = 0;
	      var events = 0;
	      this.eventsWithinDays.forEach(function (day) {
	        if (day.lessons.length > 0) {
	          days++;
	          events += day.lessons.length;
	        }
	      });
	      if (days < 1) {
	        return 'height: 61px';
	      }
	      var height = boxHeight + days * dayHeight + events * eventHeight;
	      return 'height:' + height + 'px';
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    isEventsLoading: function isEventsLoading() {
	      return this.$store.state.calendar.isEventsLoading;
	    },
	    calendar: function calendar() {
	      return this.$store.state.calendar.calendar;
	    },
	    date: function date() {
	      return this.$store.state.calendar.date;
	    },
	    events: function events() {
	      return this.$store.getters.activeFullCalendarEvents;
	    },
	    eventsFiltered: function eventsFiltered() {
	      return this.isInPrintMode || this.isReadOnly ? this.events.filter(function (event) {
	        return event.has_notes;
	      }) : this.events;
	    },
	    eventsInHash: function eventsInHash() {
	      return this.$store.getters.activeFullCalendarEventsInHash;
	    },
	    eventsWithinDays: function eventsWithinDays() {
	      this.isWeekplanHasLesson = false;
	      var allDates = [];
	      for (var i = 1; i < 8; i++) {
	        var date = (0, _moment2.default)(this.date).isoWeekday(i).format('YYYY-MM-DD');
	        var arr = this.filterLesson(i).concat();
	        arr.sort(function compare(a, b) {
	          var dateA = new Date(a.start);
	          var dateB = new Date(b.start);
	          return dateA - dateB;
	        });
	        if (arr.length > 0) {
	          this.isWeekplanHasLesson = true;
	        }
	        allDates.push({ date: date, lessons: arr });
	      }
	      return allDates;
	    },
	    activeEventId: function activeEventId() {
	      return !this.activeEvent ? '' : this.activeEvent.event_id + '_' + this.activeNoteType;
	    }
	  },
	  watch: {
	    date: function date() {
	      this.cleanUp();
	
	      this.isInViewport = false;
	      this.getWeekNote();
	    },
	    isInPrintMode: function isInPrintMode(val) {
	      if (val) {
	        this.isInViewport = true;
	      }
	    },
	    calendar: function calendar() {
	      this.getWeekNote();
	    }
	  },
	  methods: {
	    createPopper: function createPopper(divId) {
	      var el = document.getElementById(divId);
	      var source = this.$refs.d_eip;
	      el.appendChild(source);
	    },
	    closeEip: function closeEip(obj) {
	      var _this = this;
	
	      if (!obj) {
	        this.activeEvent = null;
	        return;
	      }
	      if (obj.noteType === 'weeknote') {
	        this.updateWeekNote(obj.text);
	        return;
	      }
	      this.isSavingEIP = true;
	      _docendo2.default.updateEvent(obj.lesson.school_id, obj.lesson.event_id, (0, _defineProperty3.default)({}, obj.noteType, obj.text), function (payload) {
	        var updateObj = {
	          noteType: obj.noteType,
	          payload: payload
	        };
	        _this.$store.commit('updateActiveCalendarEventNote', updateObj);
	        _this.activeEvent = null;
	        _this.isSavingEIP = false;
	        _eventbus2.default.toast = { text: _this.$t('vue2.common.saved'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    },
	    setActiveEip: function setActiveEip(event, noteType, divId, evt) {
	      var _this2 = this;
	
	      if (this.isReadOnly) {
	        return;
	      }
	      if (this.activeEvent && divId === this.activeEvent.event_id + '_' + this.activeNoteType) {
	        return;
	      }
	      if (evt.target.tagName.toLowerCase() === 'a' && evt.target.href.length > 0) {
	        evt.stopPropagation();
	        window.open(evt.target.href, '_blank', 'noopener,noreferrer');
	        return;
	      }
	      if (this.isEditorChangedWithoutSave) {
	        this.isClosingWithoutSaving = true;
	        return;
	      }
	      this.isClosingWithoutSaving = false;
	      this.createPopper(divId);
	      this.$nextTick(function (_) {
	        if (noteType === 'weeknote') {
	          var activeEvent = {
	            weeknote: _this2.weekNote,
	            event_id: _this2.calendar.id
	          };
	          _this2.activeEvent = activeEvent;
	          _this2.activeNoteType = noteType;
	          _this2.activeText = _this2.weekNote;
	          _this2.activeEIP = _this2.calendar.id + '_' + 'weeknote';
	        } else {
	          _this2.activeEvent = event;
	          _this2.activeNoteType = noteType;
	          _this2.activeText = _this2.activeEvent[_this2.activeNoteType];
	          _this2.activeEIP = event.event_id + '_' + noteType;
	        }
	      });
	    },
	    setIsEditorChangedWithoutSave: function setIsEditorChangedWithoutSave(boolean) {
	      this.isEditorChangedWithoutSave = boolean;
	    },
	    filterLocaleDate: function filterLocaleDate(mom) {
	      if (this.locale === 'nn') {
	        return (0, _moment2.default)(mom).format('dddd DD. MMMM');
	      }
	      try {
	        return (0, _moment2.default)(mom)._d.toLocaleDateString(this.locale, { weekday: 'long', month: 'long', day: '2-digit' });
	      } catch (e) {
	        return (0, _moment2.default)(mom).format('LL');
	      }
	    },
	    getEvent: function getEvent(eventId) {
	      return this.eventsInHash[eventId];
	    },
	    filterLesson: function filterLesson(dayNum) {
	      var _this3 = this;
	
	      var allowedEventTypes = ['subject', 'supplemental', 'exercise', 'resource', 'frame', 'optional', 'person_resource', 'person_resource_visible', 'other_tasks', 'other_stuff'];
	      return this.eventsFiltered.filter(function (lesson) {
	        if (allowedEventTypes.indexOf(lesson.event_type) > -1) {
	          var lessonDate = (0, _moment2.default)(lesson.start).format('YYYY-MM-DD');
	          var day = (0, _moment2.default)(_this3.date).isoWeekday(dayNum).format('YYYY-MM-DD');
	          return (0, _moment2.default)(lessonDate).isSame(day);
	        }
	      });
	    },
	    cleanUp: function cleanUp() {
	      this.activeEvent = null;
	      this.activeNoteType = '';
	      this.activeText = '';
	      this.activeEIP = null;
	    },
	    toogleWeekplan: function toogleWeekplan(evt) {
	      if (this.activeEIP) {
	        return;
	      }
	      this.isInViewport = evt[0].isIntersecting;
	      if (!this.isInViewport) {
	        this.cleanUp();
	      }
	    },
	    scrollTrigger: function scrollTrigger() {
	      var observer = new window.IntersectionObserver(this.toogleWeekplan);
	      if (!this.isInPrintMode) {
	        observer.observe(this.$refs.d_weekplan);
	      }
	    },
	    getWeekNote: function getWeekNote() {
	      var _this4 = this;
	
	      if (!this.calendar || this.calendar && this.calendar.type !== 'klass') {
	        return;
	      }
	      var isoWeek = (0, _moment2.default)(this.date).isoWeek().toString().length < 2 ? '0' + (0, _moment2.default)(this.date).isoWeek() : (0, _moment2.default)(this.date).isoWeek();
	      var week = (0, _moment2.default)(this.date).format('YYYY') + 'W' + isoWeek;
	      _docendo2.default.weeknote(this.calendar.id, week, function (data) {
	        _this4.weekNote = data.note ? data.note : '';
	
	        _this4.weeknoteId = data.note ? data.id : null;
	      });
	    },
	    updateWeekNote: function updateWeekNote(note) {
	      var _this5 = this;
	
	      this.isSavingEIP = true;
	      var isoWeek = (0, _moment2.default)(this.date).isoWeek().toString().length < 2 ? '0' + (0, _moment2.default)(this.date).isoWeek() : (0, _moment2.default)(this.date).isoWeek();
	      var week = (0, _moment2.default)(this.date).format('YYYY') + 'W' + isoWeek;
	      this.weekNoteState = 'saving';
	      _docendo2.default.weeknoteUpdate(this.calendar.id, week, note, function (success) {
	        _this5.weekNoteState = 'saved';
	        if (success.hasOwnProperty('note')) {
	          _this5.weekNote = success.note;
	          _this5.weeknoteId = success.id;
	        }
	        _this5.activeEvent = null;
	        _this5.isSavingEIP = false;
	        _eventbus2.default.toast = { text: _this5.$t('vue2.common.saved'), 'success': true };
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this5.$t('vue2.toast.something_went_wrong'), 'success': false };
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.scrollTrigger();
	    this.getWeekNote();
	  }
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DModal: _DModal2.default },
	  props: {
	    weeknoteId: {}
	  },
	  data: function data() {
	    return {
	      activeIdxs: [0, 1],
	      log: [],
	      isShowHistory: false
	    };
	  },
	
	  computed: {
	    latestActivity: function latestActivity() {
	      var _this = this;
	
	      return this.log ? this.log.filter(function (log, idx) {
	        return _this.isInActiveIdx(idx);
	      }) : [];
	    },
	    logSorted: function logSorted() {
	      return this.log ? this.log.sort(function (a, b) {
	        return new Date(b.at) - new Date(a.at);
	      }) : [];
	    }
	  },
	  methods: {
	    showHumanizedTime: function showHumanizedTime(dateTime) {
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(dateTime));
	      return _moment2.default.duration(diff).humanize();
	    },
	    isInActiveIdx: function isInActiveIdx(key) {
	      return this.activeIdxs.indexOf(key) > -1;
	    },
	    setShowHistory: function setShowHistory() {
	      this.isShowHistory = true;
	      this.getWeeknoteLog();
	    },
	    close: function close() {
	      this.isShowHistory = false;
	    },
	    getWeeknoteLog: function getWeeknoteLog() {
	      var _this2 = this;
	
	      if (!this.weeknoteId) {
	        this.log = [];
	      }
	      _docendo2.default.auditWeeknote(window.SCHOOL.id, this.weeknoteId, function (data) {
	        _this2.log = data && data.length > 0 ? JSON.parse(data) : [];
	      }, function (failure) {
	        console.log('something went wrong', failure);
	      });
	    },
	    showDate: function showDate(date) {
	      return (0, _moment2.default)(date).format('L LT');
	    },
	    showUser: function showUser(user) {
	      return user.name;
	    },
	    revertedKey: function revertedKey(version) {
	      var idx = this.logSorted.findIndex(function (log) {
	        return log.at === version.at;
	      });
	      return this.logSorted.length - idx;
	    },
	    setVersion: function setVersion(version) {
	      var idx = this.logSorted.findIndex(function (log) {
	        return log.at === version.at;
	      });
	      this.activeIdxs = [];
	      this.activeIdxs.push(idx, idx + 1);
	    },
	    isNewestVersion: function isNewestVersion(version) {
	      var idx = this.logSorted.findIndex(function (log) {
	        return log.at === version.at;
	      });
	      return idx === 0;
	    }
	  }
	};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'do-youtube',
	  description: 'Popup that plays youtube-videoes. Tags: Popup, YouTube-API, responsive',
	  computed: {
	    player: function player() {
	      return this.$refs.youtube.player;
	    },
	    showTutorial: function showTutorial() {
	      return _eventbus2.default.isOpenYouTubePopup;
	    },
	    videoId: function videoId() {
	      return _eventbus2.default.youTubeVideoId;
	    }
	  },
	  watch: {
	    showTutorial: function showTutorial(val) {
	      var _this = this;
	
	      if (val) {
	        setTimeout(function () {
	          _this.classListTimeout = true;
	        }, 0);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      videoVars: {
	        autoplay: 1,
	        modestbranding: 1,
	        rel: 0 },
	      classListTimeout: false
	    };
	  },
	
	  methods: {
	    playVideo: function playVideo(youTubeUrl) {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.player.playVideo();
	      });
	    },
	    getVideoId: function getVideoId(youTubeUrl) {
	      this.videoId = this.$youtube.getIdFromUrl(youTubeUrl);
	    },
	    closeYouTubePopup: function closeYouTubePopup() {
	      _eventbus2.default.isOpenYouTubePopup = false;
	      this.player.stopVideo();
	      this.classListTimeout = false;
	    },
	    videoPlaying: function videoPlaying() {
	      console.log('video started');
	    },
	    videoEnded: function videoEnded() {
	      this.closeYouTubePopup();
	      console.log('video ended');
	    },
	    videoReady: function videoReady() {
	      console.log('video ready');
	    },
	    videoCued: function videoCued() {
	      console.log('video cued');
	    }
	  }
	};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ChangeSchoolYear = __webpack_require__(14);
	
	var _ChangeSchoolYear2 = _interopRequireDefault(_ChangeSchoolYear);
	
	var _Loader = __webpack_require__(4);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _Spinner = __webpack_require__(20);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _vue2Datepicker = __webpack_require__(136);
	
	var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Spinner: _Spinner2.default, Loader: _Loader2.default, ChangeSchoolYear: _ChangeSchoolYear2.default, DatePicker: _vue2Datepicker2.default },
	  data: function data() {
	    return {
	      isLoading: false,
	      isSendingData: false,
	      schedules: [],
	      theSelected: null,
	      theDate: (0, _moment2.default)().format('YYYY-MM-DD')
	    };
	  },
	
	  computed: {
	    activeSchoolYear: function activeSchoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    datepickerType: function datepickerType() {
	      return window.SCHOOL.id === 40235 ? 'date' : 'week';
	    },
	    datepickerLang: function datepickerLang() {
	      return {
	        formatLocale: {
	          firstDayOfWeek: window.SCHOOL.id === 40235 ? 0 : 1
	        }
	      };
	    },
	    datepickerFormat: function datepickerFormat() {
	      return window.SCHOOL.id === 40235 ? 'YYYY-MM-DD' : this.$t('vue2.zen_import.week') + ' w, YYYY';
	    }
	  },
	  watch: {
	    activeSchoolYear: function activeSchoolYear(val) {
	      this.theDate = this.activeSchoolYear.student_time_start;
	    }
	  },
	  methods: {
	    isSelected: function isSelected(id) {
	      return this.theSelected === id;
	    },
	    setActiveSchedule: function setActiveSchedule(id) {
	      this.theSelected = id;
	    },
	    setDate: function setDate(date) {
	      this.theDate = date;
	    },
	    readVersions: function readVersions() {
	      var _this = this;
	
	      this.isLoading = true;
	      _docendo2.default.listImports(window.SCHOOL.id, function (versions) {
	        if (versions.length < 1) {
	          _this.schedules = [];
	        } else {
	          var sortedVersions = versions.sort(function (a, b) {
	            var aModified = a.modifiedAt ? a.modifiedAt : (0, _moment2.default)();
	            var bModified = b.modifiedAt ? b.modifiedAt : (0, _moment2.default)();
	            return new Date(bModified) - new Date(aModified);
	          });
	          _this.schedules = sortedVersions;
	          _this.theSelected = sortedVersions[0].scheduleUuid;
	        }
	        _this.isLoading = false;
	      }, function (failure) {
	        console.log('failure', failure);
	        _this.isLoading = false;
	      });
	    },
	    submitSchudules: function submitSchudules() {
	      var _this2 = this;
	
	      this.isSendingData = true;
	      var serverDate = (0, _moment2.default)(this.theDate).isoWeekday(1).format('YYYY-MM-DD');
	      if (window.SCHOOL.id === 40235) {
	        serverDate = (0, _moment2.default)(this.theDate).format('YYYY-MM-DD');
	      }
	      _docendo2.default.enqueueImport(window.SCHOOL.id, this.theSelected, serverDate, this.activeSchoolYear.id, function (success) {
	        _eventbus2.default.toast = {
	          text: _this2.$t('vue2.zen_import.schedules_are_being_inserted') + ' ' + (0, _moment2.default)(_this2.theDate).isoWeek(),
	          success: true
	        };
	        _this2.isSendingData = false;
	      }, function (failure) {
	        _eventbus2.default.toast = { text: _this2.$t('vue2.common.something_went_wrong'), success: false };
	        _this2.isSendingData = false;
	      });
	    },
	    showHumanizeDate: function showHumanizeDate(date) {
	      _moment2.default.locale(window.USER.language);
	      var diff = (0, _moment2.default)().diff((0, _moment2.default)(date));
	      return _moment2.default.duration(diff).humanize() + ' ' + this.$t('vue2.common.ago');
	    },
	    showDate: function showDate(modifiedAt) {
	      _moment2.default.locale(window.USER.language);
	      return (0, _moment2.default)(modifiedAt).format('LLLL');
	    }
	  },
	  mounted: function mounted() {
	    this.readVersions();
	  }
	};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(167);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _fullcalendar = __webpack_require__(1157);
	
	var _fullcalendar2 = _interopRequireDefault(_fullcalendar);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(46);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calendarId: {
	      default: null
	    },
	    caldate: {
	      default: function _default() {
	        return _config2.default.now;
	      }
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    viewState: {
	      type: Number,
	      default: 0
	    },
	    locale: {
	      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    },
	    i18n: {}
	  },
	  computed: {
	    calendarDate: function calendarDate() {
	      return this.caldate;
	    },
	    calendarViewState: function calendarViewState() {
	      var state = this.viewState * 1;
	      if (window.SCHOOL && window.SCHOOL.id === 56058) {
	        return {
	          minTime: '08:00:00',
	          maxTime: '20:00:00',
	          showWeekends: true
	        };
	      }
	      if (state === 0) {
	        return {
	          minTime: '06:00:00',
	          maxTime: '18:00:00',
	          showWeekends: false
	        };
	      } else if (state === 1) {
	        return {
	          minTime: '06:00:00',
	          maxTime: '18:00:00',
	          showWeekends: true
	        };
	      } else {
	        return {
	          minTime: '00:00:00',
	          maxTime: '24:00:00',
	          showWeekends: true
	        };
	      }
	    }
	  },
	  data: function data() {
	    return {
	      load: true,
	      isDayView: false
	    };
	  },
	
	  watch: {
	    events: function events(value) {
	      this.load = false;
	      this.updateEvents();
	    },
	    caldate: function caldate() {
	      this.goToDate();
	    },
	    calendarViewState: function calendarViewState() {
	      this.cal.fullCalendar('destroy');
	      this.fullCalendar();
	    },
	    locale: function locale(val) {
	      this.updatelocale(val);
	    }
	  },
	  methods: {
	    updatelocale: function updatelocale(val) {
	      var timeFormat = 'LT';
	      this.cal.fullCalendar('option', {
	        'locale': val,
	        'slotLabelFormat': timeFormat,
	        columnHeaderText: function columnHeaderText(mom) {
	          if (val === 'nn' || val === 'nb') {
	            return (0, _moment2.default)(mom).format('dddd DD/MM');
	          }
	          try {
	            return (0, _moment2.default)(mom).local().toDate().toLocaleDateString(val, {
	              weekday: 'long',
	              month: '2-digit',
	              day: '2-digit'
	            });
	          } catch (e) {
	            return (0, _moment2.default)(mom).format('LL');
	          }
	        }
	      });
	      this.updateEvents();
	    },
	    goToDate: function goToDate() {
	      this.cal.fullCalendar('gotoDate', (0, _moment2.default)(this.caldate));
	    },
	    updateEvents: function updateEvents() {
	      this.cal.fullCalendar('removeEvents');
	      this.cal.fullCalendar('addEventSource', this.events);
	    },
	    fullCalendar: function fullCalendar() {
	      var _this = this;
	
	      var calIdsWithSundayFirst = [268587, 268583, 268581, 268588, 268575, 268585, 268577, 268579];
	      var firstDay = this.calendarId && calIdsWithSundayFirst.indexOf(this.calendarId) > -1 ? 0 : 1;
	      var self = this;
	      self.cal = (0, _jquery2.default)(self.$el);
	      self.cal.fullCalendar({
	        schedulerLicenseKey: '0561574571-fcs-1494418560',
	        locale: window.use_i18n.locale,
	        minTime: this.calendarViewState.minTime,
	        maxTime: this.calendarViewState.maxTime,
	        allDaySlot: false,
	        height: 'auto',
	        weekends: this.calendarViewState.showWeekends,
	        editable: false,
	        droppable: false,
	        firstDay: firstDay,
	        timezone: 'local',
	        events: this.allEvents,
	        defaultView: 'agendaWeek',
	        timeFormat: 'LT',
	        slotLabelFormat: 'LT',
	        header: {
	          left: '',
	          right: ''
	        },
	        columnHeaderText: function columnHeaderText(mom) {
	          try {
	            return (0, _moment2.default)(mom).local().toDate().toLocaleDateString(self.locale, {
	              weekday: 'long',
	              month: '2-digit',
	              day: 'numeric'
	            });
	          } catch (e) {
	            return (0, _moment2.default)(mom).format('LL');
	          }
	        },
	        eventClick: function eventClick(event, view) {
	          self.$emit('eventclick', event);
	        },
	        eventRender: function eventRender(event, element) {
	          var teachersString = event.duration > 20 ? '<p class="title__meta"><span class="icon-user"> </span>' + event.teacher + '</p>' : ', <span class="marg-5-left"> </span> <span class="icon-user"></span> ' + event.teacher + '</span>';
	
	          if (event.group) {
	            element.find('.fc-title').append('<p class="title__meta"><span class="icon-users"> </span>' + event.group + '</p>');
	          }
	
	          if (event.teacher) {
	            element.find('.fc-title').append(teachersString);
	          }
	
	          if (event.room) {
	            element.find('.fc-title').append('<p class="title__meta"><span class="icon-location"> </span>' + event.room + '</p>');
	          }
	
	          if (event.has_notes) {
	            element.find('div.fc-time').prepend('<span class="right icon-file-text2"></span>');
	          }
	
	          if (event.away) {
	            element.addClass('d-event-outside-school');
	          }
	
	          if (event.canceled) {
	            var str = self.i18n && self.i18n.canceled ? self.i18n.canceled : 'Canceled';
	            element.addClass('d-event--canceled');
	            element.attr('data-label', str);
	          }
	        }
	      });
	      self.$nextTick(function () {
	        _this.goToDate();
	        _this.$emit('view', _this.cal.fullCalendar('getView'));
	        if (window.location.href && window.location.href.indexOf('?day') > -1) {
	          _this.cal.fullCalendar('changeView', 'agendaDay', (0, _moment2.default)());
	          _this.cal.fullCalendar('option', 'minTime', '07:45:00');
	          _this.cal.fullCalendar('option', 'maxTime', '14:30:00');
	        }
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (window.location.href && window.location.href.indexOf('?day') > -1) {
	      this.isDayView = true;
	    }
	  },
	  mounted: function mounted() {
	    this.fullCalendar();
	  }
	};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    calview: {},
	    locale: {
	      default: 'en'
	    },
	    isNotThisWeek: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    showDate: function showDate() {
	      var self = this;
	      try {
	        if (self.locale === 'nn' || self.locale === 'nb') {
	          return (0, _moment2.default)(this.date).locale(self.locale).format('MMMM YYYY');
	        }
	        return (0, _moment2.default)(this.date)._d.toLocaleDateString(self.locale, { month: 'long', year: 'numeric' });
	      } catch (e) {
	        return (0, _moment2.default)(this.date).format('LL');
	      }
	    }
	  }
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	__webpack_require__(165);
	
	__webpack_require__(166);
	
	__webpack_require__(164);
	
	var _vueQuillEditor = __webpack_require__(359);
	
	var _DModal = __webpack_require__(6);
	
	var _DModal2 = _interopRequireDefault(_DModal);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DoWeekPlanLog = __webpack_require__(344);
	
	var _DoWeekPlanLog2 = _interopRequireDefault(_DoWeekPlanLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  components: {
	    quillEditor: _vueQuillEditor.quillEditor,
	    DModal: _DModal2.default,
	    DoWeekPlanLog: _DoWeekPlanLog2.default
	  },
	  props: {
	    isUploadFile: {
	      type: Boolean,
	      default: false
	    },
	    isUploadImage: {
	      type: Boolean,
	      default: false
	    },
	    textInput: {
	      type: String,
	      default: ''
	    },
	    lesson: {
	      type: Object,
	      default: function _default() {
	        return null;
	      }
	    },
	    noteType: {
	      type: String,
	      default: ''
	    },
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    isInTestOfSaveButton: {
	      type: Boolean,
	      default: true
	    },
	    isInDCalendar: {
	      type: Boolean,
	      default: false
	    },
	    isKeepOpen: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      editor: null,
	      uniqueNum: 1,
	      isChanged: false,
	      edit: false,
	      text: '',
	      linkText: '',
	      link: '',
	      isMouseDown: false,
	      isLinkModal: false,
	      editorOption: {},
	      placeholder: '',
	      isClosingWithoutSaving: false
	    };
	  },
	
	  computed: {
	    linkWithHttp: function linkWithHttp() {
	      var withHttp = function withHttp(url) {
	        return !/^https?:\/\//i.test(url) ? 'http://' + url : url;
	      };
	      return withHttp(this.link);
	    },
	    isValidURL: function isValidURL() {
	      return this.checkValidURL(this.linkWithHttp);
	    },
	    isValidated: function isValidated() {
	      return this.isValidURL && this.linkText.length > 0;
	    },
	    textWithoutHTML: function textWithoutHTML() {
	      return this.text ? this.text.replace(/<\/?p[^>]*>/g, '') : '';
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return {
	        da: {
	          bold: 'Fed',
	          italic: 'Kursiv',
	          underline: 'Understreget',
	          list_ordered: 'Liste nummereret',
	          list_bullets: 'Liste i punktform',
	          insert_link: 'Indsæt link',
	          link_text_label: 'Tekst der skal vises',
	          link_text_placeholder: 'eks. Docendo',
	          link_link_label: 'Webadressen',
	          link_link_placeholder: 'eks. www.docendo.dk',
	          cancel: 'Annuller'
	        },
	        en: {
	          bold: 'Bold',
	          italic: 'Italic',
	          underline: 'Underline',
	          list_ordered: 'List Ordered',
	          list_bullets: 'List i punktform',
	          insert_link: 'Insert link',
	          link_text_label: 'Text to be shown',
	          link_text_placeholder: 'e.g. Docendo',
	          link_link_label: 'Web address',
	          link_link_placeholder: 'e.g. www.docendo.co',
	          cancel: 'Cancel'
	        },
	        nb: {
	          bold: 'Fet',
	          italic: 'Kursiv',
	          underline: 'Understreket',
	          list_ordered: 'Punktliste',
	          list_bullets: 'Nummerert liste',
	          insert_link: 'Sett inn link',
	          link_text_label: 'Tekst som skal vises',
	          link_text_placeholder: 'eks. Docendo',
	          link_link_label: 'Nettadressen',
	          link_link_placeholder: 'eks. www.docendo.no',
	          cancel: 'Annuller'
	        }
	      };
	    }
	  },
	  watch: {
	    lesson: {
	      handler: function handler(newValue, oldVal) {
	        this.text = this.lesson[this.noteType];
	      },
	
	      deep: true
	    },
	    textInput: function textInput(val) {
	      if (!this.lesson) {
	        this.text = val;
	      }
	    }
	  },
	  methods: {
	    checkValidURL: function checkValidURL(str) {
	      return true;
	    },
	    setIsLinkModal: function setIsLinkModal(boolean) {
	      var _this = this;
	
	      if (!boolean) {
	        this.linkText = '';
	        this.link = '';
	      } else {
	        setTimeout(function (_) {
	          _this.$refs.linkTextInput.focus();
	        }, 500);
	      }
	      this.isLinkModal = boolean;
	    },
	    insertLink: function insertLink() {
	      this.editor.focus();
	      var index = (this.editor.getSelection() || {}).index || this.editor.getLength() - 1;
	      this.editor.insertText(index, this.linkText, 'link', this.linkWithHttp);
	      this.setIsLinkModal(false);
	    },
	    onEditorReady: function onEditorReady(quill) {
	      this.editor = quill;
	      quill.focus();
	    },
	    onUploadFile: function onUploadFile(e) {
	      console.log('show some file uploading');
	    },
	    setEdit: function setEdit() {
	      var _this2 = this;
	
	      if (_eventbus2.default.isLessonNoteChangedWithoutSaving && !this.isInDCalendar) {
	        return;
	      }
	
	      document.querySelectorAll('.d-quill__toolbar').forEach(function (el) {
	        if (el.dataset.num >= _this2.uniqueNum) {
	          _this2.uniqueNum = el.dataset.num * 1 + 1;
	        }
	      });
	      this.editorOption = {
	        modules: {
	          toolbar: {
	            container: '#toolbar_' + this.uniqueNum
	          }
	        },
	        clipboard: {
	          matchVisual: false
	        }
	      };
	      this.$emit('open');
	      this.edit = true;
	    },
	    closeEdit: function closeEdit(event) {
	      if (this.isKeepOpen) {
	        return;
	      }
	      if (this.isInDCalendar) {
	        this.edit = false;
	        return;
	      }
	      if (this.isChanged && this.isInTestOfSaveButton) {
	        this.isClosingWithoutSaving = true;
	        return;
	      }
	      if (!this.isChanged && this.isInTestOfSaveButton) {
	        this.edit = false;
	        return;
	      }
	      if (event.target.classList.contains('ap')) {
	        return;
	      }
	      if (this.isMouseDown) {
	        this.isMouseDown = false;
	        return;
	      }
	      if (!this.edit) {
	        return;
	      }
	      if (this.lesson) {
	        this.$emit('close', { lesson: this.lesson, noteType: this.noteType, text: this.text });
	      } else {
	        this.$emit('close', { text: this.text });
	      }
	      this.edit = false;
	    },
	    cancel: function cancel() {
	      this.edit = false;
	      if (this.lesson) {
	        this.text = this.lesson[this.noteType];
	      } else {
	        this.text = this.textInput;
	      }
	      this.isClosingWithoutSaving = false;
	      this.isChanged = false;
	      this.$emit('close', false);
	      _eventbus2.default.isLessonNoteChangedWithoutSaving = false;
	    },
	    save: function save() {
	      this.edit = false;
	      if (this.lesson) {
	        this.$emit('close', { lesson: this.lesson, noteType: this.noteType, text: this.text });
	      } else {
	        this.$emit('close', { text: this.text });
	      }
	      this.isClosingWithoutSaving = false;
	      this.isChanged = false;
	      _eventbus2.default.isLessonNoteChangedWithoutSaving = false;
	    },
	    onEditorChange: function onEditorChange(_ref) {
	      var quill = _ref.quill,
	          html = _ref.html,
	          text = _ref.text;
	
	      this.text = html;
	
	      if (this.textInput && this.textInput === html) {
	        return;
	      }
	      this.isChanged = true;
	      this.$emit('changed', this.text);
	      if (this.isInTestOfSaveButton) {
	        _eventbus2.default.isLessonNoteChangedWithoutSaving = true;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (this.isOpen) {
	      this.setEdit();
	    }
	  },
	  mounted: function mounted() {
	    if (this.textInput) {
	      this.text = this.textInput;
	      return;
	    }
	    if (this.lesson && this.noteType) {
	      this.text = this.lesson[this.noteType];
	    }
	    window.addEventListener('beforeunload', function (e) {
	      var confirmMessage = 'Continue without saving?';
	      if (_eventbus2.default.isLessonNoteChangedWithoutSaving) {
	        (e || window.event).returnValue = confirmMessage;
	        return confirmMessage;
	      }
	    });
	  }
	};

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    preselectedTab: {
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      activeTab: this.preselectedTab
	    };
	  },
	
	  methods: {
	    setTab: function setTab(num) {
	      this.activeTab = num;
	      this.$emit('update', num);
	    },
	    isActiveTab: function isActiveTab(num) {
	      return num === this.activeTab;
	    }
	  }
	};

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    submitTxt: {
	      type: String,
	      default: 'OK'
	    },
	    isShowFooter: {
	      default: true,
	      type: Boolean
	    }
	  }
	};

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    propOn: {
	      default: true
	    },
	    allowChanges: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      isOn: this.propOn
	    };
	  },
	
	  watch: {
	    propOn: function propOn(val, oldVal) {
	      if (this.propOn !== this.isOn) {
	        this.isOn = this.propOn;
	      }
	    },
	    isOn: function isOn() {
	      this.$emit('changed', this.isOn);
	    }
	  },
	  methods: {
	    toggleIsOn: function toggleIsOn() {
	      if (!this.allowChanges) {
	        return;
	      }
	      this.isOn = !this.isOn;
	    }
	  }
	};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	var _core = __webpack_require__(18);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    isShowDots: {
	      type: Boolean,
	      default: true
	    },
	    isBottomStart: {
	      type: Boolean,
	      default: true
	    },
	    propOffset: {
	      type: Array,
	      default: function _default() {
	        return null;
	      }
	    },
	    isCloseOnDropdownClick: {
	      type: Boolean,
	      default: true
	    },
	    closeFromProp: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      isDropDown: false,
	      isPopperDone: false,
	      isPopperReady: false
	    };
	  },
	
	  watch: {
	    closeFromProp: function closeFromProp(val, oldVal) {
	      this.setDropdown();
	    }
	  },
	  methods: {
	    createPopper: function createPopper() {
	      var _this = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      var dOffset = this.isShowDots ? [5, 5] : [0, -20];
	      if (this.propOffset) {
	        dOffset = this.propOffset;
	      }
	      var dPlacement = this.isBottomStart ? 'bottom-start' : 'bottom-end';
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: dPlacement,
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: dOffset
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this.isPopperReady = true;
	        _this.isPopperDone = true;
	      }, 0);
	    },
	    setDropdown: function setDropdown() {
	      var _this2 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        this.$emit('open');
	        this.$nextTick(function (_) {
	          _this2.createPopper();
	        });
	      } else {
	        this.$emit('onClose');
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown || !this.isCloseOnDropdownClick) {
	        return;
	      }
	      this.setDropdown();
	    },
	    onClickOutside: function onClickOutside() {
	      if (this.isCloseOnDropdownClick) {
	        return;
	      }
	      if (this.isDropDown) {
	        this.setDropdown();
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var dChild = this.$refs.d_child;
	    if (dChild) {
	      dChild.remove();
	    }
	  }
	};

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DFilters',
	  props: {
	    initialFilter: {
	      default: ''
	    },
	    filters: {
	      type: Array,
	      default: function _default() {
	        return [{ label: 'Alle', value: '', length: 20 }, { label: 'Undervisning', value: 'person_resource', length: 10 }, { label: 'Øvrige opgaver', value: 'additional_tasks', length: 8 }, { label: 'Forberedelse', value: 'preparation', length: 2 }];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      left: 0,
	      width: 0
	    };
	  },
	
	  watch: {
	    initialFilter: function initialFilter() {
	      this.selectorSliderLeft();
	    }
	  },
	  methods: {
	    setFilter: function setFilter(filter) {
	      this.$emit('set', filter.value);
	    },
	    isFilter: function isFilter(filterValue) {
	      return this.initialFilter === filterValue;
	    },
	    selectorSliderLeft: function selectorSliderLeft() {
	      var el = document.querySelector('#filter_' + this.initialFilter);
	      if (!el) {
	        return;
	      }
	      var parentBCR = this.$refs.dfilters.getBoundingClientRect();
	      var BCR = el.getBoundingClientRect();
	      this.width = BCR.width + 'px';
	      this.left = BCR.left * 1 - parentBCR.left * 1 + 'px';
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    setTimeout(function (_) {
	      _this.selectorSliderLeft();
	    }, 500);
	  }
	};

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    isBgOverlay: {
	      type: Boolean,
	      default: false
	    },
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    placeInTop: {
	      type: Boolean,
	      default: false
	    },
	    pxFromTop: {
	      type: Number,
	      default: 2
	    },
	    isCloseOnEsc: {
	      type: Boolean,
	      default: true
	    }
	  },
	  methods: {
	    handleKeydown: function handleKeydown(event) {
	      if (event.key === 'Escape' && this.isCloseOnEsc) {
	        this.$emit('close');
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.appendToBody) {
	      var el = this.$refs.d_modal;
	      var container = document.getElementById('djs-content-container');
	
	      if (el && container) {
	        container.appendChild(el);
	      }
	    }
	    window.addEventListener('keydown', this.handleKeydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var el = this.$refs.d_modal;
	    if (el && el.parentNode) {
	      el.parentNode.removeChild(el);
	    }
	    window.removeEventListener('keydown', this.handleKeydown);
	  }
	};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(18);
	
	exports.default = {
	  data: function data() {
	    return {
	      isHovered: false
	    };
	  },
	
	  methods: {
	    createPopper: function createPopper() {
	      var el = this.$refs.d_question;
	      var source = this.$refs.d_popover;
	      document.getElementById('djs-content-container').appendChild(source);
	      (0, _core.createPopper)(el, source, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [5, 5]
	          }
	        }]
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.createPopper();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var source = this.$refs.d_popover;
	    if (source) {
	      source.remove();
	    }
	  }
	};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DateSelector: _DateSelector2.default },
	  props: {
	    selectedDate: {
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      isDatepickerOpen: false
	    };
	  },
	
	  computed: {
	    selectedDateFormatted: function selectedDateFormatted() {
	      return (0, _moment2.default)(this.selectedDate).format('DD/MM-YY');
	    }
	  },
	  methods: {
	    setDate: function setDate(date) {
	      this.$emit('dateChanged', date);
	    }
	  }
	};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: (0, _moment2.default)()
	    }
	  },
	  computed: {
	    isToday: function isToday() {
	      return (0, _moment2.default)(this.date).format('YYYY-MM-DD') === (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    tooltipArrowLeft: function tooltipArrowLeft() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>←</span></p>';
	    },
	    tooltipArrowRight: function tooltipArrowRight() {
	      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>→</span></p>';
	    },
	    metaKey: function metaKey() {
	      var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
	      return isMac ? '⌘' : 'CTRL';
	    }
	  }
	};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DoLogo = __webpack_require__(1395);
	
	var _DoLogo2 = _interopRequireDefault(_DoLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DoLogo: _DoLogo2.default }
	};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	    buttonText: {
	      type: String,
	      default: 'Drop Up!'
	    }
	  },
	  exampleData: {
	    buttonText: 'Click me!'
	  },
	  methods: {
	    open: function open() {
	      this.$emit('open');
	    },
	    close: function close() {
	      this.$emit('close');
	    }
	  }
	};

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    isIEorEdge: function isIEorEdge() {
	      var isIE = false || !!document.documentMode;
	
	      var isEdge = !isIE && !!window.StyleMedia;
	
	      return isIE || isEdge;
	    }
	  }
	};

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    bgColor: {
	      default: '#edf0f5'
	    },
	    isSmall: {
	      type: Boolean,
	      default: false
	    },
	    isExtraSmall: {
	      type: Boolean,
	      default: false
	    },
	    isLoaderModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    styleObj: function styleObj() {
	      return {
	        '--bgColor': this.bgColor
	      };
	    }
	  }
	};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    schools: {
	      type: Array,
	      default: []
	    },
	    selectedSchoolIds: {
	      type: Array,
	      default: []
	    },
	    permission: {
	      default: 'can_manage_salary'
	    }
	  },
	  computed: {
	    activeSchool: function activeSchool() {
	      return this.$store.state.activeSchool;
	    },
	    selectedTitle: function selectedTitle() {
	      if (this.selectedSchoolIds.length === 0) {
	        return 'Vælg skole';
	      }
	      if (this.selectedSchoolIds.length === 1) {
	        var id = this.selectedSchoolIds[0];
	        var school = this.schools.find(function (school) {
	          return school.id === id;
	        });
	        return school ? school['name'] : 'Unavngiven skole';
	      }
	      if (this.selectedSchoolIds.length > 1) {
	        return this.selectedSchoolIds.length + ' skoler valgt';
	      }
	    },
	    userSchoolsSorted: function userSchoolsSorted() {
	      var _this = this;
	
	      console.log('this.schools', this.schools);
	      return this.schools.filter(function (school) {
	        return _this.getHasPermission(school);
	      }).map(function (school) {
	        return (0, _extends3.default)({}, school, {
	          v_is_selected: _this.getIsSelected(school)
	        });
	      }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    },
	    userMemberships: function userMemberships() {
	      return this.$store.getters.userSchools;
	    }
	  },
	  methods: {
	    toggleSchool: function toggleSchool(school) {
	      this.$emit('toggleSchool', school);
	    },
	    getIsSelected: function getIsSelected(school) {
	      return this.selectedSchoolIds.includes(school.id);
	    },
	    getHasPermission: function getHasPermission(school) {
	      var schoolMember = this.userMemberships[school.id];
	      if (!schoolMember) {
	        return false;
	      }
	      return schoolMember['permissions'].indexOf(this.permission) > -1;
	    },
	    onSelectionChange: function onSelectionChange() {
	      this.$emit('schools-changed', this.selectedSchoolIds);
	    }
	  }
	};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	var _core = __webpack_require__(18);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    isMultiple: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      isDropDown: false,
	      isPopperDone: false,
	      isPopperReady: false,
	      search: ''
	    };
	  },
	
	  computed: {
	    activeCalendar: function activeCalendar() {
	      return this.$store.state.calendar.calendar;
	    },
	    klassCalendars: function klassCalendars() {
	      return this.$store.getters.klassCalendars;
	    },
	    userCalendars: function userCalendars() {
	      return this.$store.getters.userCalendars;
	    },
	    roomCalendars: function roomCalendars() {
	      return this.$store.getters.roomCalendars;
	    },
	    mergeCalendars: function mergeCalendars() {
	      return this.$store.getters.mergeCalendars;
	    },
	    otherCalendars: function otherCalendars() {
	      return this.$store.getters.otherCalendars;
	    },
	    activeCalendarName: function activeCalendarName() {
	      return this.activeCalendar ? this.activeCalendar.name : '';
	    },
	    sortedCalendars: function sortedCalendars() {
	      if (this.activeCalendar) {
	        switch (this.activeCalendar.type) {
	          case 'klass':
	            return this.klassCalendars;
	          case 'user':
	            return this.userCalendars;
	          case 'room':
	            return this.roomCalendars;
	          case 'merge':
	            return this.mergeCalendars;
	          case 'other':
	            return this.otherCalendars;
	          default:
	            return [];
	        }
	      } else {
	        return [];
	      }
	    },
	    calendarQuery: function calendarQuery() {
	      var _this = this;
	
	      return this.sortedCalendars.filter(function (item) {
	        return item.name !== null && item.id !== _this.activeCalendar.id ? item.name.match(new RegExp(_this.search, 'i')) : '';
	      });
	    }
	  },
	  methods: {
	    selectCalendar: function selectCalendar(calendarId) {
	      this.$store.commit('setActiveCalendarId', calendarId);
	      this.setDropdown();
	    },
	    createPopper: function createPopper() {
	      var _this2 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }]
	      });
	      this.$nextTick(function (_) {
	        _this2.isPopperReady = true;
	        _this2.isPopperDone = true;
	        setTimeout(function (_) {
	          _this2.$refs.inputsearch.focus();
	        }, 200);
	      });
	    },
	    setDropdown: function setDropdown() {
	      var _this3 = this;
	
	      if (!this.isMultiple || this.sortedCalendars.length < 2) {
	        return;
	      }
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        this.$nextTick(function (_) {
	          _this3.createPopper();
	        });
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	        this.search = '';
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var dChild = this.$refs.d_child;
	    if (dChild) {
	      dChild.remove();
	    }
	  }
	};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueClickaway = __webpack_require__(8);
	
	var _core = __webpack_require__(18);
	
	exports.default = {
	  mixins: [_vueClickaway.mixin],
	  props: {
	    preSelectedUserId: {
	      default: 13
	    },
	    userName: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      selectedUserId: null,
	      isDropDown: false,
	      isPopperDone: false,
	      isPopperReady: false,
	      search: ''
	    };
	  },
	
	  computed: {
	    selectedUser: function selectedUser() {
	      var _this = this;
	
	      var idx = this.users.findIndex(function (user) {
	        return user.id === _this.selectedUserId * 1;
	      });
	      return this.users[idx];
	    },
	    users: function users() {
	      return this.$store.state.allUsers;
	    },
	    usersSorted: function usersSorted() {
	      return this.$store.getters.usersSortedOnName;
	    },
	    usersQuery: function usersQuery() {
	      var _this2 = this;
	
	      return this.usersSorted.filter(function (item) {
	        return item.name !== null ? item.name.match(new RegExp(_this2.search, 'i')) : '';
	      });
	    }
	  },
	  methods: {
	    selectUser: function selectUser(id) {
	      this.selectedUserId = id;
	      window.location = '/users/' + id + '/tasks#';
	    },
	    createPopper: function createPopper() {
	      var _this3 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.d_child;
	      var dParent = this.$refs.d_parent;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, 0]
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this3.isPopperReady = true;
	        _this3.isPopperDone = true;
	      }, 0);
	      setTimeout(function (_) {
	        _this3.$refs.inputsearch.focus();
	      }, 200);
	    },
	    setDropdown: function setDropdown() {
	      var _this4 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        setTimeout(function (_) {
	          _this4.createPopper();
	        }, 0);
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	        this.search = '';
	      }
	    },
	    setDropdownFromClick: function setDropdownFromClick() {
	      if (!this.isDropDown) {
	        return;
	      }
	      this.setDropdown();
	    }
	  },
	  mounted: function mounted() {
	    if (this.preSelectedUserId) {
	      this.selectedUserId = this.preSelectedUserId;
	    }
	    this.$store.dispatch('getUsers');
	  },
	  beforeDestroy: function beforeDestroy() {
	    var dChild = this.$refs.d_child;
	    if (dChild) {
	      dChild.remove();
	    }
	  }
	};

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'spinner',
	  props: {
	    color: {
	      type: String,
	      default: 'white'
	    },
	    size: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    tabs: {
	      type: Array,
	      default: function _default() {
	        return [{ id: 'minutes', title: 'Show as minutes' }, { id: 'hours', title: 'Show as hours' }];
	      },
	      validator: function validator(tabs) {
	        return Array.isArray(tabs) && tabs.every(function (t) {
	          return t.id && t.title;
	        });
	      }
	    },
	    selected: {
	      type: String,
	      default: 'minutes'
	    },
	    isLarge: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    onSelect: function onSelect(tabId) {
	      this.$emit('select', tabId);
	    }
	  }
	};

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    tabs: {
	      type: Array,
	      default: function _default() {
	        return ['Byt', 'Erstat', 'Ledigt personale'];
	      }
	    },
	    selected: {
	      type: String,
	      default: 'Byt'
	    },
	    isLarge: {
	      default: false,
	      type: Boolean
	    }
	  },
	  methods: {
	    onSelect: function onSelect(tab) {
	      this.$emit('select', tab);
	    }
	  }
	};

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    val1: {
	      type: String,
	      default: '17/18'
	    },
	    val2: {
	      type: String,
	      default: '18/19'
	    },
	    value: {
	      default: 1
	    }
	  },
	  methods: {
	    setValue: function setValue(val) {
	      this.currValue = val;
	      this.$emit('changed', val);
	    },
	    checkValue: function checkValue(val) {
	      return this.value * 1 === val;
	    }
	  }
	};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DateSelector = __webpack_require__(27);
	
	var _DateSelector2 = _interopRequireDefault(_DateSelector);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'datepickerrange',
	  components: { dateselector: _DateSelector2.default },
	  props: {
	    allowSameDate: {
	      type: Boolean,
	      default: false
	    },
	    startdate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    enddate: {
	      default: function _default() {
	        return this.allowSameDate ? (0, _moment2.default)() : (0, _moment2.default)().add(1, 'days');
	      }
	    },
	    maximumDateRange: {
	      type: Number,
	      default: null }
	  },
	  data: function data() {
	    return {
	      start: this.startdate,
	      end: this.enddate
	    };
	  },
	
	  watch: {
	    enddate: function enddate() {
	      this.end = this.enddate;
	    },
	    startdate: function startdate() {
	      this.start = this.startdate;
	    }
	  },
	  methods: {
	    checkIfDatesAreMoreThanMaxRange: function checkIfDatesAreMoreThanMaxRange(startDate, endDate) {
	      if (!this.maximumDateRange || this.maximumDateRange <= 0) {
	        return false;
	      }
	
	      var start = (0, _moment2.default)(startDate);
	      var end = (0, _moment2.default)(endDate);
	      var dateDifference = end.diff(start, 'days');
	
	      return dateDifference > this.maximumDateRange;
	    },
	    setStartDate: function setStartDate(date) {
	      var _this = this;
	
	      if (this.startIsAfterEnd(date, this.end)) {
	        this.setEndDate(this.addDaysToEnd(date));
	      }
	      if (this.checkIfDatesAreMoreThanMaxRange(date, this.end)) {
	        var txt = this.$t('vue2.datepicker.max_date_range_start') + ' ' + this.maximumDateRange + ' ' + this.$t('vue2.datepicker.max_date_range_end');
	        _eventbus2.default.toast = { text: txt, 'success': false };
	        var newEndDate = (0, _moment2.default)(date).add(this.maximumDateRange, 'days');
	        this.setEndDate(newEndDate);
	      }
	      this.start = date;
	      setTimeout(function (_) {
	        _this.$emit('startchanged', _this.start);
	      }, 0);
	    },
	    setEndDate: function setEndDate(date) {
	      var _this2 = this;
	
	      if (this.startIsAfterEnd(this.start, date)) {
	        this.setStartDate(this.substractDaysToStart(date));
	      }
	      if (this.checkIfDatesAreMoreThanMaxRange(this.start, date)) {
	        var txt = this.$t('vue2.datepicker.max_date_range_start') + ' ' + this.maximumDateRange + ' ' + this.$t('vue2.datepicker.max_date_range_end');
	        _eventbus2.default.toast = { text: txt, 'success': false };
	        var newStartDate = (0, _moment2.default)(date).subtract(this.maximumDateRange, 'days');
	        this.setStartDate(newStartDate);
	      }
	      this.end = date;
	      setTimeout(function (_) {
	        _this2.$emit('endchanged', _this2.end);
	      });
	    },
	    startIsAfterEnd: function startIsAfterEnd(startDate, endDate) {
	      var start = (0, _moment2.default)(startDate).format('YYYY-MM-DD');
	      var end = (0, _moment2.default)(endDate).format('YYYY-MM-DD');
	      if (this.allowSameDate) {
	        return (0, _moment2.default)(start).isAfter(end);
	      } else {
	        return (0, _moment2.default)(start).isSameOrAfter(end);
	      }
	    },
	    addDaysToEnd: function addDaysToEnd(date) {
	      if (this.allowSameDate) {
	        return (0, _moment2.default)(date);
	      } else {
	        return (0, _moment2.default)(date).add(1, 'days');
	      }
	    },
	    substractDaysToStart: function substractDaysToStart(date) {
	      if (this.allowSameDate) {
	        return (0, _moment2.default)(date);
	      } else {
	        return (0, _moment2.default)(date).subtract(1, 'days');
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.setEndDate((0, _moment2.default)(this.enddate));
	    this.setStartDate((0, _moment2.default)(this.startdate));
	  }
	};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    choose_period: 'Vælg periode'
	  },
	  nb: {
	    choose_period: 'Velg periode'
	  },
	  en: {
	    choose_period: 'Choose period'
	  }
	};
	
	exports.default = {
	  components: { DDropdown: _DDropdown2.default },
	  props: {
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().add(1, 'days');
	      }
	    },
	    selectedStartDate: {
	      default: function _default() {
	        return null;
	      }
	    },
	    selectedEndDate: {
	      default: function _default() {
	        return null;
	      }
	    }
	  },
	  computed: {
	    locale: function locale() {
	      return window.USER && window.USER.language ? window.USER.language : 'en';
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    title: function title() {
	      if (!this.selectedStartDate || !this.selectedEndDate) {
	        return this.i18n['choose_period'];
	      }
	      var dateRangeId = (0, _moment2.default)(this.selectedStartDate).format('YYYY-MM-DD') + '_' + (0, _moment2.default)(this.selectedEndDate).format('YYYY-MM-DD');
	      var idx = this.shortcuts.findIndex(function (shortcut) {
	        return shortcut.id === dateRangeId;
	      });
	      if (idx < 0) {
	        return this.i18n['choose_period'];
	      } else {
	        return this.shortcuts[idx].title;
	      }
	    },
	    quartersInRange: function quartersInRange() {
	      var startDate = this.startDate;
	      var dateRanges = [];
	      var currentDate = (0, _moment2.default)(startDate);
	      var stopDate = (0, _moment2.default)(this.endDate);
	      while (currentDate <= stopDate) {
	        var intervalStart = (0, _moment2.default)(currentDate).format('YYYY-MM-DD');
	        var intervalEnd = (0, _moment2.default)(currentDate).add(3, 'months').subtract(1, 'days').format('YYYY-MM-DD');
	        dateRanges.push({ start: intervalStart, end: intervalEnd });
	        currentDate = (0, _moment2.default)(currentDate).add(3, 'months');
	      }
	      return dateRanges;
	    },
	    getFirstWeekShortcut: function getFirstWeekShortcut() {
	      var startDate = (0, _moment2.default)(this.startDate).format('YYYY-MM-DD');
	      var endDate = (0, _moment2.default)(this.startDate).add(6, 'days').format('YYYY-MM-DD');
	      var startTitle = (0, _moment2.default)(startDate).format('ll');
	      var endTitle = (0, _moment2.default)(endDate).format('ll');
	      return {
	        id: startDate + '_' + endDate,
	        title: startTitle + ' - ' + endTitle,
	        dateRange: {
	          start: startDate,
	          end: endDate
	        }
	      };
	    },
	    shortcuts: function shortcuts() {
	      var shortcuts = [this.getFirstWeekShortcut];
	      this.quartersInRange.forEach(function (range) {
	        var startTitle = (0, _moment2.default)(range.start).format('ll');
	        var endTitle = (0, _moment2.default)(range.end).format('ll');
	        var obj = {
	          id: range.start + '_' + range.end,
	          title: startTitle + ' - ' + endTitle,
	          dateRange: {
	            start: range.start,
	            end: range.end
	          }
	        };
	        shortcuts.push(obj);
	      });
	      return shortcuts;
	    }
	  }
	};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _config = __webpack_require__(46);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _core = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DateSelector',
	  mixins: [_vueClickaway.mixin],
	  props: {
	    popperPlacement: {
	      default: 'bottom-start'
	    },
	
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)().utc();
	      }
	    },
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    isOnlyShowFirstAndLastDateEachMonth: {
	      type: Boolean,
	      default: false
	    },
	    isShowInput: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      active: false,
	      isDropdownPopperDone: false,
	      chosenDate: this.date,
	      datepickerDate: (0, _moment2.default)(this.date),
	      weekends: _config2.default.showWeekends
	    };
	  },
	
	  watch: {
	    date: function date() {
	      this.chosenDate = this.date;
	      this.datepickerDate = (0, _moment2.default)(this.date);
	    }
	  },
	  filters: {
	    threeLetters: function threeLetters(string) {
	      return string.substring(0, 3);
	    }
	  },
	  computed: {
	    datePickerDateFormatted: function datePickerDateFormatted() {
	      return (0, _moment2.default)(this.datepickerDate).locale(this.locale).format('MMMM YYYY');
	    },
	    urlLocale: function urlLocale() {
	      var url = window.location.host;
	      var locale = 'en';
	      if (url.indexOf('.dk') > -1) {
	        locale = 'da';
	      }
	      if (url.indexOf('.no') > -1) {
	        locale = 'nb';
	      }
	      return locale;
	    },
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    formatDate: function formatDate() {
	      return (0, _moment2.default)(this.chosenDate).locale(this.locale).format('dddd DD. MMMM YYYY');
	    },
	    today: function today() {
	      return _config2.default.now.format('YYYY-MM-DD');
	    },
	    weekDays: function weekDays() {
	      var ary = _moment2.default.weekdays();
	
	      var last = ary.shift();
	      ary.push(last);
	      return ary;
	    },
	    dates: function dates() {
	      var self = this;
	      var months = [];
	      var date = (0, _moment2.default)(this.datepickerDate).utc('MM-DD-YYYY');
	      var dates = [];
	
	      var startOfWeek = date.date(1).isoWeekday();
	
	      if (!this.weekends && startOfWeek > 5) {} else {
	        for (var i = 1; i < startOfWeek; i++) {
	          dates.push({
	            show: false,
	            showDate: '&nbsp;',
	            dayClass: 'hide'
	          });
	        }
	      }
	
	      function isFirstOrLastDayInMonth(date) {
	        var momentDate = (0, _moment2.default)(date);
	
	        var isFirstDay = momentDate.date() === 1;
	
	        var nextDay = momentDate.clone().add(1, 'day');
	
	        var isLastDay = nextDay.date() === 1;
	        return isFirstDay || isLastDay;
	      }
	
	      for (var _i = 1; _i <= date.daysInMonth(); _i++) {
	        var thisDate = (0, _moment2.default)(date).date(_i).utc('MM-DD-YYYY');
	        dates.push({
	          show: true,
	          date: thisDate,
	          showDate: thisDate.format('D'),
	          dayOfWeek: thisDate.isoWeekday(),
	          week: thisDate.isoWeek(),
	          isToday: self.isTodayDate(thisDate),
	          isSelected: self.isCurrentDate(thisDate),
	          id: thisDate.format('D'),
	          dayClass: 'd_' + thisDate.isoWeekday(),
	          isDisabled: !this.isOnlyShowFirstAndLastDateEachMonth ? false : !isFirstOrLastDayInMonth(thisDate)
	        });
	      }
	      months.push({
	        date: dates
	      });
	      return months;
	    },
	    weekNumbers: function weekNumbers() {
	      var weeks = [];
	      this.dates[0].date.forEach(function (date) {
	        var idx = weeks.indexOf(date.week);
	        if (idx < 0 && date.week) {
	          weeks.push(date.week);
	        }
	      });
	      return weeks;
	    }
	  },
	  methods: {
	    createPopper: function createPopper() {
	      var parentPopper = this.$refs.date_input_field;
	      var childPopper = this.$refs.child_popper;
	      document.getElementById('djs-content-container').appendChild(childPopper);
	      (0, _core.createPopper)(parentPopper, childPopper, {
	        placement: this.popperPlacement,
	        modifiers: [{
	          name: 'flip',
	          options: {
	            fallbackPlacements: ['top', 'right', 'left']
	          }
	        }, {
	          name: 'offset',
	          options: {
	            offset: [0, 5]
	          }
	        }]
	      });
	    },
	    openDatePicker: function openDatePicker(e) {
	      var _this = this;
	
	      this.active = true;
	      this.$nextTick(function (_) {
	        _this.createPopper();
	        _this.isDropdownPopperDone = true;
	      });
	    },
	    closeDatePicker: function closeDatePicker() {
	      var self = this;
	      this.isDropdownPopperDone = false;
	      this.active = false;
	      this.$emit('close');
	
	      setTimeout(function () {
	        self.datepickerDate = (0, _moment2.default)(self.chosenDate);
	      }, 100);
	    },
	    isCurrentDate: function isCurrentDate(date) {
	      var chosen = (0, _moment2.default)(this.chosenDate).format('YYYY-MM-DD');
	      var datePickerDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      return chosen === datePickerDate;
	    },
	    isTodayDate: function isTodayDate(date) {
	      return (0, _moment2.default)(date).format('Y-MM-DD') === this.today;
	    },
	    setDate: function setDate(date) {
	      if (date.isDisabled) {
	        return;
	      }
	      this.chosenDate = date.date;
	      this.$emit('changed', date.date);
	      this.closeDatePicker();
	    },
	    prevMonth: function prevMonth() {
	      this.datepickerDate = (0, _moment2.default)(this.datepickerDate).subtract(1, 'month').date(2);
	    },
	    nextMonth: function nextMonth() {
	      this.datepickerDate = (0, _moment2.default)(this.datepickerDate).add(1, 'month').date(2);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (this.isOpen) {
	      this.$nextTick(function (_) {
	        _this2.openDatePicker();
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$refs.child_popper) {
	      this.$refs.child_popper.remove();
	    }
	  }
	};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueClickaway = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DateSelector',
	  mixins: [_vueClickaway.mixin],
	  props: {
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    theCalendarDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    active: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    today: function today() {
	      return (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    weekdays: function weekdays() {
	      var days = [];
	      for (var i = 1; i <= 7; i++) {
	        days.push((0, _moment2.default)().isoWeekday(i).format('ddd'));
	      }
	      return days;
	    },
	    weeks: function weeks() {
	      var week = [];
	      var date = (0, _moment2.default)(this.date).utc().date(1);
	      var daysInMonth = (0, _moment2.default)(this.date).daysInMonth();
	      week.push((0, _moment2.default)(date).isoWeek());
	      for (var i = 1; i <= daysInMonth; i++) {
	        var thisDate = (0, _moment2.default)(date).date(i);
	        var weekNum = thisDate.isoWeek();
	        if (week[week.length - 1] !== weekNum) {
	          week.push(weekNum);
	        }
	      }
	      return week;
	    },
	    datesInWeeks: function datesInWeeks() {
	      var weeks = [];
	      var date = (0, _moment2.default)(this.date).utc();
	      var startOfMonth = (0, _moment2.default)(date.startOf('month'));
	      var weeksInMonth = this.weeks.length;
	      var startWeek = (0, _moment2.default)(startOfMonth).isoWeek();
	      var thisMonth = (0, _moment2.default)(date).month();
	      for (var i = 0; i < weeksInMonth; i++) {
	        var weekNum = startWeek + i;
	        var dates = [];
	        for (var j = 1; j <= 7; j++) {
	          var thisDate = (0, _moment2.default)(date).isoWeek(weekNum).isoWeekday(j);
	          if (thisMonth !== (0, _moment2.default)(date).isoWeek(weekNum).isoWeekday(j).month()) {
	            dates.push({
	              show: false,
	              showDate: '&nbsp;',
	              dayClass: 'hide'
	            });
	          } else {
	            dates.push({
	              show: true,
	              date: thisDate.format('YYYY-MM-DD'),
	              showDate: thisDate.format('D'),
	              dayOfWeek: thisDate.isoWeekday(),
	              week: thisDate.isoWeek(),
	              isToday: this.isTodayDate(thisDate),
	              isSelected: this.isCurrentDate(thisDate),
	              id: thisDate.format('D'),
	              dayClass: 'd_' + thisDate.isoWeekday()
	            });
	          }
	        }
	        weeks.push({
	          'week': weekNum,
	          'dates': dates
	        });
	      }
	      return weeks;
	    }
	  },
	  methods: {
	    closeDatePicker: function closeDatePicker() {
	      this.active = false;
	    },
	    isCurrentDate: function isCurrentDate(date) {
	      var datePickerDate = (0, _moment2.default)(this.theCalendarDate).format('YYYY-MM-DD');
	      var theDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      return theDate === datePickerDate;
	    },
	    isTodayDate: function isTodayDate(date) {
	      return (0, _moment2.default)(date).format('Y-MM-DD') === (0, _moment2.default)().format('YYYY-MM-DD');
	    },
	    setDate: function setDate(date) {
	      this.$emit('changed', (0, _moment2.default)(date.date).format('YYYY-MM-DD'));
	    }
	  }
	};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(46);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: function _default() {
	        return _config2.default.now;
	      }
	    },
	    weekends: {
	      default: true
	    },
	    locale: {
	      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    }
	  },
	  computed: {
	    isMon: function isMon() {
	      return this.isDay(1);
	    },
	    isTue: function isTue() {
	      return this.isDay(2);
	    },
	    isWed: function isWed() {
	      return this.isDay(3);
	    },
	    isTur: function isTur() {
	      return this.isDay(4);
	    },
	    isFri: function isFri() {
	      return this.isDay(5);
	    },
	    isSat: function isSat() {
	      return this.isDay(6);
	    },
	    isSun: function isSun() {
	      return this.isDay(7);
	    }
	  },
	  methods: {
	    isToday: function isToday(date) {
	      return (0, _moment2.default)(date).format('DD-MM-YYYY') === _config2.default.now.format('DD-MM-YYYY');
	    },
	    setDay: function setDay(dayNum) {
	      var newDate = (0, _moment2.default)(this.date).isoWeekday(dayNum);
	      this.$emit('changed', newDate);
	    },
	    isDay: function isDay(dayNum) {
	      return (0, _moment2.default)(this.date).format('') === (0, _moment2.default)(this.date).isoWeekday(dayNum).format('');
	    },
	    day: function day(weekday) {
	      return (0, _moment2.default)(this.date).locale(this.locale).isoWeekday(weekday).format('ddd');
	    }
	  }
	};

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DDropdown = __webpack_require__(10);
	
	var _DDropdown2 = _interopRequireDefault(_DDropdown);
	
	var _DatePickerRange = __webpack_require__(17);
	
	var _DatePickerRange2 = _interopRequireDefault(_DatePickerRange);
	
	var _vueClickaway = __webpack_require__(8);
	
	var _core = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    select_dates: 'Vælg datoer',
	    submit: 'Indlæs',
	    this_week: 'Denne uge',
	    this_month: 'Denne måned',
	    school_year: 'Skoleåret',
	    custom: 'Tilpasset'
	  },
	  en: {
	    select_dates: 'Select Dates',
	    submit: 'Submit',
	    this_week: 'This week',
	    this_month: 'This month',
	    school_year: 'School year',
	    custom: 'Custom'
	  },
	  nb: {
	    select_dates: 'Velg datoer',
	    submit: 'Submit',
	    this_week: 'Denne uke',
	    this_month: 'Denne måned',
	    school_year: 'Skoleåret',
	    custom: 'Tilpasset'
	  }
	};
	
	exports.default = {
	  components: { Datepickerrange: _DatePickerRange2.default, DDropdown: _DDropdown2.default },
	  mixins: [_vueClickaway.mixin],
	  props: {
	    maximumDateRange: {
	      type: Number,
	      default: null },
	    allowSameDate: {
	      type: Boolean,
	      default: false
	    },
	    startDate: {
	      default: function _default() {
	        return (0, _moment2.default)().startOf('isoWeek');
	      }
	    },
	    endDate: {
	      default: function _default() {
	        return (0, _moment2.default)().endOf('isoWeek');
	      }
	    },
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    dateShortCutsProps: {
	      type: Array,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      isDateDropdown: false,
	      isPopperReady: false,
	      isPopperDone: false,
	      initialStartDate: (0, _moment2.default)(),
	      initialEndDate: (0, _moment2.default)()
	    };
	  },
	
	  computed: {
	    locale: function locale() {
	      return this.$store.getters.locale;
	    },
	    i18n: function i18n() {
	      return I18N[this.locale];
	    },
	    quartersInRange: function quartersInRange() {
	      var startDate = this.startDate;
	      var dateRanges = [];
	      var currentDate = (0, _moment2.default)(startDate);
	      var stopDate = (0, _moment2.default)(this.endDate);
	      while (currentDate <= stopDate) {
	        var intervalStart = (0, _moment2.default)(currentDate).format('YYYY-MM-DD');
	        var intervalEnd = (0, _moment2.default)(currentDate).add(3, 'months').subtract(1, 'days').format('YYYY-MM-DD');
	        dateRanges.push({ start: intervalStart, end: intervalEnd });
	        currentDate = (0, _moment2.default)(currentDate).add(3, 'months');
	      }
	      return dateRanges;
	    },
	    schoolYears: function schoolYears() {
	      return this.$store.state.schoolYears;
	    },
	    activeSchoolYears: function activeSchoolYears() {
	      return this.schoolYears.filter(function (schoolYear) {
	        return schoolYear.active;
	      });
	    },
	    schoolYear: function schoolYear() {
	      return this.$store.state.localActivatedSchoolYear;
	    },
	    dateShortCuts: function dateShortCuts() {
	      var _this = this;
	
	      if (this.dateShortCutsProps) {
	        return this.dateShortCutsProps;
	      }
	      var custom = [{ title: this.i18n['this_week'], startDate: (0, _moment2.default)(this.date).startOf('isoWeek'), endDate: (0, _moment2.default)(this.date).endOf('isoWeek') }, { title: this.i18n['this_month'], startDate: (0, _moment2.default)(this.date).startOf('month'), endDate: (0, _moment2.default)(this.date).endOf('month') }];
	      var schoolYears = this.activeSchoolYears.map(function (schoolYear) {
	        return {
	          title: _this.i18n['school_year'] + ' ' + schoolYear.name,
	          startDate: (0, _moment2.default)(schoolYear.employee_time_start).startOf('day'),
	          endDate: (0, _moment2.default)(schoolYear.employee_time_end).endOf('day')
	        };
	      });
	      return custom.concat(schoolYears);
	    },
	    activeShortCutTitle: function activeShortCutTitle() {
	      var _this2 = this;
	
	      var idx = this.dateShortCuts.findIndex(function (shortCut) {
	        return (0, _moment2.default)(shortCut.startDate).isSame(_this2.startDate, 'day') && (0, _moment2.default)(shortCut.endDate).isSame(_this2.endDate, 'day');
	      });
	      return idx < 0 ? this.i18n['custom'] : this.dateShortCuts[idx].title;
	    },
	    dateRangeFormatted: function dateRangeFormatted() {
	      var startFormat = this.startDate.format('D.');
	      if (!(0, _moment2.default)(this.startDate).isSame(this.endDate, 'month')) {
	        startFormat = this.startDate.format('D. MMM');
	      }
	      if (!(0, _moment2.default)(this.startDate).isSame(this.endDate, 'year')) {
	        startFormat = this.startDate.format('D. MMM, YYYY');
	      }
	      var endFormat = this.endDate.format('D. MMM, YYYY');
	      return startFormat + ' - ' + endFormat;
	    }
	  },
	  methods: {
	    setDropdown: function setDropdown() {
	      var _this3 = this;
	
	      this.isDropDown = !this.isDropDown;
	      if (this.isDropDown) {
	        setTimeout(function (_) {
	          _this3.createPopper();
	        }, 0);
	      } else {
	        this.isPopperReady = false;
	        this.isPopperDone = false;
	      }
	    },
	    openIsDateDropdown: function openIsDateDropdown() {
	      var _this4 = this;
	
	      this.isDateDropdown = true;
	      this.$nextTick(function (_) {
	        _this4.createPopper();
	      });
	    },
	    closeIsDateDropdown: function closeIsDateDropdown() {
	      this.isDropdownPopperDone = false;
	      this.isDateDropdown = false;
	    },
	    createPopper: function createPopper() {
	      var _this5 = this;
	
	      this.isPopperReady = false;
	      this.isPopperDone = false;
	      var dChild = this.$refs.child_popper;
	      var dParent = this.$refs.date_input_button;
	      if (this.appendToBody) {
	        document.getElementById('djs-body-click').appendChild(dChild);
	      }
	      (0, _core.createPopper)(dParent, dChild, {
	        placement: 'bottom-start',
	        modifiers: [{
	          name: 'offset',
	          options: {
	            offset: [0, -1]
	          }
	        }]
	      });
	      setTimeout(function (_) {
	        _this5.isPopperReady = true;
	        _this5.isPopperDone = true;
	      }, 0);
	    },
	    setDateFromShortCut: function setDateFromShortCut(dateShortCut) {
	      var start = dateShortCut.startDate;
	      var end = dateShortCut.endDate;
	      this.$emit('startChanged', start);
	      this.$emit('endChanged', end);
	      this.$emit('datesChanged', { start: start, end: end });
	    },
	    setStartDate: function setStartDate(date) {
	      this.initialStartDate = date;
	    },
	    setEndDate: function setEndDate(date) {
	      this.initialEndDate = date;
	    },
	    submitDateRange: function submitDateRange() {
	      this.$emit('startChanged', this.initialStartDate);
	      this.$emit('endChanged', this.initialEndDate);
	      var start = this.initialStartDate;
	      var end = this.initialEndDate;
	      this.$emit('datesChanged', { start: start, end: end });
	      this.isDateDropdown = false;
	    },
	    closeDoDatepickerDropdown: function closeDoDatepickerDropdown() {
	      this.isDateDropdown = false;
	    }
	  }
	};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: (0, _moment2.default)()
	    },
	    startDate: {
	      default: null
	    },
	    endDate: {
	      default: null
	    }
	  },
	  computed: {
	    weekDate: function weekDate() {
	      return (0, _moment2.default)(this.date);
	    },
	    weeksInYear: function weeksInYear() {
	      var startDate = (0, _moment2.default)(this.startDate).startOf('isoweek');
	      var endDate = (0, _moment2.default)(this.endDate).endOf('isoweek');
	      var weeksBetweenStartAndFinish = (0, _moment2.default)(endDate).diff(startDate, 'week');
	      var self = this;
	      var startWeek = (0, _moment2.default)(this.startDate).isoWeek();
	      var weeks = [];
	      for (var i = startWeek; i <= startWeek + weeksBetweenStartAndFinish; i++) {
	        var date = (0, _moment2.default)(self.startDate).isoWeek(i);
	        weeks.push({
	          date: date,
	          weekNum: date.isoWeek(),
	          isChosenWeek: self.isChosenWeek(date),
	          isThisWeek: self.isThisWeek(date),
	          tooltipDate: self.tooltipDate(date)
	        });
	      }
	      return weeks;
	    },
	    startDateInYear: function startDateInYear() {
	      return (0, _moment2.default)(this.startDate).format('YYYY');
	    },
	    endDateInYear: function endDateInYear() {
	      return (0, _moment2.default)(this.endDate).format('YYYY');
	    }
	  },
	  methods: {
	    tooltipDate: function tooltipDate(date) {
	      var start = (0, _moment2.default)(date).startOf('isoweek');
	      var start2 = (0, _moment2.default)(date).startOf('isoweek').format('DD. MMM');
	      var startFormat = start.format('DD');
	      var end = (0, _moment2.default)(date).endOf('isoweek');
	      var endFormat = (0, _moment2.default)(date).endOf('isoweek').format('DD. MMM YYYY');
	
	      if ((0, _moment2.default)(start).format('MM') === (0, _moment2.default)(end).format('MM')) {
	        return startFormat + ' - ' + endFormat;
	      } else {
	        return start2 + ' - ' + endFormat;
	      }
	    },
	    setDate: function setDate(date) {
	      this.$emit('changed', date);
	    },
	    isChosenWeek: function isChosenWeek(date) {
	      return this.weekDate.isoWeek() === (0, _moment2.default)(date).isoWeek() && this.weekDate.format('YYYY') === (0, _moment2.default)(date).format('YYYY');
	    },
	    isThisWeek: function isThisWeek(date) {
	      return (0, _moment2.default)(date).isoWeek() === (0, _moment2.default)().isoWeek() && (0, _moment2.default)(date).format('YYYY') === (0, _moment2.default)().format('YYYY');
	    }
	  }
	};

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    deleteSetupWidgetOpen: function deleteSetupWidgetOpen() {
	      this.$store.dispatch('deleteUserSetting', 'setupWidgetOpen');
	    },
	    deleteKlass: function deleteKlass() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_klass');
	    },
	    deleteUser: function deleteUser() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_users');
	    },
	    deleteRoom: function deleteRoom() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_rooms');
	    },
	    deleteMerge: function deleteMerge() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_merge');
	    },
	    deleteScheduling: function deleteScheduling() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_scheduling');
	    },
	    deleteVacation: function deleteVacation() {
	      this.$store.dispatch('deleteUserSetting', 'setup_widget_progress_vacation');
	    }
	  }
	};

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    setupWidget: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    bottom: {
	      default: -4
	    },
	    right: {
	      default: 0
	    }
	  },
	  computed: {
	    activeOnboardingStep: function activeOnboardingStep() {
	      return this.$store.state.onboardingStep;
	    },
	    show: function show() {
	      return this.activeOnboardingStep * 1 === 5;
	    }
	  }
	};

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _StepDoughnut = __webpack_require__(292);
	
	var _StepDoughnut2 = _interopRequireDefault(_StepDoughnut);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _OnboardArrow = __webpack_require__(354);
	
	var _OnboardArrow2 = _interopRequireDefault(_OnboardArrow);
	
	var _DoYouTube = __webpack_require__(345);
	
	var _DoYouTube2 = _interopRequireDefault(_DoYouTube);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { doughnut: _StepDoughnut2.default, arrow: _OnboardArrow2.default, doYouTube: _DoYouTube2.default },
	  computed: {
	    showModal: function showModal() {
	      return _eventbus2.default.showSetupWidget;
	    },
	    user: function user() {
	      return this.$store.state.user;
	    },
	    userSettings: function userSettings() {
	      return this.$store.state.userSettings;
	    },
	    activeOnboardingStep: function activeOnboardingStep() {
	      return this.$store.state.onboardingStep;
	    },
	    showOnboardingArrow: function showOnboardingArrow() {
	      return _eventbus2.default.showOnboardingArrow;
	    },
	    klassCals: function klassCals() {
	      return this.$store.getters.allKlassCalendarsInHash;
	    },
	    stepNumbers: function stepNumbers() {
	      if (this.country === 'dk') {
	        return this.stepsDK;
	      } else if (this.country === 'no') {
	        return this.stepsNO;
	      } else {
	        return this.stepsEN;
	      }
	    },
	    stepsLength: function stepsLength() {
	      return this.stepNumbers.length;
	    },
	    howManyDone: function howManyDone() {
	      var doneSteps = this.stepNumbers.filter(function (obj) {
	        return obj.done === true;
	      });
	      return doneSteps.length;
	    }
	  },
	  watch: {
	    userSettings: function userSettings(val, oldVal) {
	      var obj = this.userSettings;
	      this.progressed = (0, _keys2.default)(obj).filter(function (key) {
	        return key.startsWith('setup_widget_progress');
	      });
	      this.checkProgress();
	    },
	    showModal: function showModal(val, oldVal) {
	      console.log('showModal', val);
	    }
	  },
	  data: function data() {
	    return {
	      animateSlide: false,
	      onboardArrowTopPx: 0,
	      showLocalOnboardingArrow: false,
	      progressed: [],
	      country: window.SCHOOL.country.toLowerCase(),
	      stepsNO: [{
	        title: 'Opprett klasser - (0:36)',
	        videoid: 'P9lc_0-64kc',
	        guide: 'https://www.youtube.com/watch?v=P9lc_0-64kc&feature=youtu.be',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1
	      }, {
	        title: 'Opprett lærere/brukere - (0:44)',
	        videoid: 'X-w0i3MFeL4',
	        guide: 'https://www.youtube.com/watch?v=X-w0i3MFeL4&feature=youtu.be',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2
	      }, {
	        title: 'Opprett lokaler - (0:37)',
	        videoid: '8FoyUOiwdPk',
	        guide: 'https://www.youtube.com/watch?v=8FoyUOiwdPk&feature=youtu.be',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3
	      }, {
	        title: 'Opprett fellestimeplaner - (2:09)',
	        videoid: '39daX1u0238',
	        guide: 'https://www.youtube.com/watch?v=DI4d0auYfg4&feature=youtu.be',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 4
	      }, {
	        title: 'Legg inn ferier og helligdager - (0:39)',
	        videoid: 'KmLDUVlzhXA',
	        guide: 'https://www.youtube.com/watch?v=KmLDUVlzhXA&feature=youtu.be',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 5
	      }, {
	        title: 'Timeplanlegging i klasser - (2:55)',
	        videoid: 's6b7b07ZHl0',
	        guide: 'https://www.youtube.com/watch?v=s6b7b07ZHl0&feature=youtu.be',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 6
	      }],
	      stepsDK: [{
	        title: 'Opret klasser - (1:01)',
	        videoid: '5gjODdkqRDI',
	        guide: 'https://www.youtube.com/watch?v=5gjODdkqRDI&feature=youtu.be',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1
	      }, {
	        title: 'Opret lærere/brugere - (0:41)',
	        videoid: 'YtujiFzH50A',
	        guide: 'https://www.youtube.com/watch?v=YtujiFzH50A&feature=youtu.be',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2
	      }, {
	        title: 'Opret lokaler - (0:39)',
	        videoid: '2XQjHWLvyrM',
	        guide: 'https://www.youtube.com/watch?v=2XQjHWLvyrM&feature=youtu.be',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3
	      }, {
	        title: 'Opret fletteskemaer - (02:41)',
	        videoid: 'VNt1m80YEsI',
	        guide: 'https://www.youtube.com/watch?v=VNt1m80YEsI&feature=youtu.be',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 4
	      }, {
	        title: 'Indtast feriedage - (0:39)',
	        videoid: '0XB5A0xr-N0',
	        guide: 'https://www.youtube.com/watch?v=0XB5A0xr-N0&feature=youtu.be',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 5
	      }, {
	        title: 'Skemalægning i klasser - (2:25)',
	        videoid: '7NR8_EygcoM',
	        guide: 'https://www.youtube.com/watch?v=7NR8_EygcoM&feature=youtu.be',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 6
	      }],
	      stepsEN: [{
	        title: 'Create grades/groups - (0:52)',
	        videoid: 'WdXydJxGFpI',
	        guide: 'https://youtu.be/WdXydJxGFpI',
	        dbName: 'setup_widget_progress_klass',
	        done: false,
	        stepNum: 1
	      }, {
	        title: 'Create teachers - (0:43)',
	        videoid: 'D83kXuPIZzE',
	        guide: 'https://youtu.be/D83kXuPIZzE',
	        dbName: 'setup_widget_progress_users',
	        done: false,
	        stepNum: 2
	      }, {
	        title: 'Create classrooms / locations - (1:01)',
	        videoid: 'UBI-WnWOtdQ',
	        guide: 'https://youtu.be/UBI-WnWOtdQ',
	        dbName: 'setup_widget_progress_rooms',
	        done: false,
	        stepNum: 3
	      }, {
	        title: 'Choose school holidays - (0:36)',
	        videoid: 'CkUvNQQgMoQ',
	        guide: 'https://youtu.be/CkUvNQQgMoQ',
	        dbName: 'setup_widget_progress_vacation',
	        done: false,
	        stepNum: 5
	      }, {
	        title: 'Create shared calendar - (2:56)',
	        videoid: 'aIvpXbHwYeA',
	        guide: 'https://youtu.be/aIvpXbHwYeA',
	        dbName: 'setup_widget_progress_merge',
	        done: false,
	        stepNum: 4
	      }, {
	        title: 'Create subjects - (2:31)',
	        videoid: 'EpEfabVl7yw',
	        guide: 'https://youtu.be/EpEfabVl7yw',
	        dbName: 'setup_widget_progress_subjects',
	        done: false,
	        stepNum: 6
	      }, {
	        title: 'Schedule classes  - (3:31)',
	        videoid: 'UXZpf-wAh-U',
	        guide: 'https://youtu.be/UXZpf-wAh-U',
	        dbName: 'setup_widget_progress_scheduling',
	        done: false,
	        stepNum: 7
	      }]
	    };
	  },
	
	  methods: {
	    fireWhenDataIsReady: function fireWhenDataIsReady() {
	      this.findNextStep();
	      if (this.userSettings.setupWidgetOpen !== false) {
	        _eventbus2.default.showSetupWidget = true;
	      }
	    },
	    findNextStep: function findNextStep() {
	      this.showLocalOnboardingArrow = false;
	      for (var i = 0; i < this.stepNumbers.length; i++) {
	        if (!this.stepNumbers[i].done) {
	          this.calcOnboardArrowTop(i);
	          return;
	        }
	      }
	    },
	    calcOnboardArrowTop: function calcOnboardArrowTop(nextStepIdx) {
	      if (document.querySelectorAll('.js-onboard-item-click')[nextStepIdx]) {
	        var nextStepBCRTop = document.querySelectorAll('.js-onboard-item-click')[nextStepIdx].getBoundingClientRect().top;
	        this.onboardArrowTopPx = nextStepBCRTop - 8;
	        this.showLocalOnboardingArrow = true;
	      }
	    },
	    openYouTube: function openYouTube(videoid) {
	      _eventbus2.default.youTubeVideoId = videoid;
	      _eventbus2.default.isOpenYouTubePopup = true;
	    },
	    checkProgress: function checkProgress() {
	      for (var i = 0; i < this.progressed.length; i++) {
	        for (var j = 0; j < this.stepNumbers.length; j++) {
	          if (this.stepNumbers[j].dbName === this.progressed[i]) {
	            this.stepNumbers[j].done = true;
	          }
	        }
	      }
	      this.fireWhenDataIsReady();
	    },
	    setShowModal: function setShowModal(panel) {
	      if (this.showModal) {
	        this.animateSlide = true;
	        this.closeModal(panel);
	      } else {
	        this.animateSlide = true;
	        this.openModal(panel);
	      }
	    },
	    openModal: function openModal() {
	      _eventbus2.default.showSetupWidget = true;
	      this.$store.dispatch('updateUserSettings', { 'setupWidgetOpen': true });
	      var wrapper = document.querySelector('#djs-content-container');
	      if (!wrapper.classList.contains('djs_setup_widget_open')) {
	        wrapper.classList.add('djs_setup_widget_open');
	      }
	    },
	    closeModal: function closeModal() {
	      _eventbus2.default.showSetupWidget = false;
	      this.$store.dispatch('updateUserSettings', { 'setupWidgetOpen': false });
	      document.querySelector('#djs-content-container').classList.remove('djs_setup_widget_open');
	    },
	    showIntercom: function showIntercom() {
	      window.Intercom('show');
	    },
	    stepFnc: function stepFnc(stepNum, title) {
	      _eventbus2.default.showOnboardingArrow = true;
	      this.$store.commit('setOnboardingStep', stepNum);
	      window.Intercom('trackEvent', 'Watched Onboarding Video: ' + title);
	      if (stepNum === 5) {
	        setTimeout(function () {
	          var el = document.querySelector('.js-onboarding-arrow-planning .djs-header-dropdown-click');
	          el.click();
	        }, 500);
	      }
	    },
	    isCalIdAKlass: function isCalIdAKlass(calId) {
	      if (this.klassCals[calId]) {
	        return true;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    var settings = JSON.parse(window.USER.settings.replace(/&quot;/g, '"'));
	    if (settings.setupWidgetOpen !== false) {
	      _eventbus2.default.showSetupWidget = true;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (!this.$helpers.getSessionStorage('doSession')) {
	      window.Intercom('trackEvent', 'Session Device ' + this.$helpers.checkUserDevice());
	    }
	
	    this.$helpers.setSessionStorage('doSession', true);
	
	    window.addEventListener('vue_dropped_subject', function (e) {
	      if (window.SCHOOL.state === 'demo' && _this.isCalIdAKlass(e.detail.cal_id)) {
	        window.Intercom('trackEvent', 'Dropped Event In Class');
	        _this.$store.dispatch('updateUserSettings', { 'setup_widget_progress_scheduling': true });
	      }
	    }, false);
	
	    window.addEventListener('vue_dropped_subject_no_teacher', function (e) {
	      if (window.SCHOOL.state === 'demo' && _this.isCalIdAKlass(e.detail.cal_id)) {
	        window.Intercom('trackEvent', 'Fail No Teacher On Subject In Class');
	      }
	    }, false);
	  }
	};

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  mounted: function mounted() {
	    if (window.location.href.indexOf('intro=true') > -1) {
	      var el = document.querySelector('.js-onboarding-arrow-planning').getBoundingClientRect();
	      this.$el.style.top = el.bottom + 0 + 'px';
	      this.$el.style.left = el.left + (el.width / 2 - 20) + 'px';
	      this.$el.style.display = 'block';
	    }
	  }
	};

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(1409);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _FullCal = __webpack_require__(346);
	
	var _FullCal2 = _interopRequireDefault(_FullCal);
	
	var _FullCalHeader = __webpack_require__(1391);
	
	var _FullCalHeader2 = _interopRequireDefault(_FullCalHeader);
	
	var _WeekSelecter = __webpack_require__(89);
	
	var _WeekSelecter2 = _interopRequireDefault(_WeekSelecter);
	
	var _WeekPlan = __webpack_require__(1411);
	
	var _WeekPlan2 = _interopRequireDefault(_WeekPlan);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _config = __webpack_require__(46);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    desktopHeader: _Header2.default,
	    weekSelector: _WeekSelecter2.default,
	    fullCalendar: _FullCal2.default,
	    fullCalendarHeader: _FullCalHeader2.default,
	    weekplan: _WeekPlan2.default
	  },
	  props: {
	    calId: {},
	    schoolName: {},
	    i18n: {}
	  },
	  data: function data() {
	    return {
	      allEvents: [],
	      date: _config2.default.now,
	      today: _config2.default.now,
	      locale: window.USER.locale,
	      calInfo: '',
	      calView: '',
	      intervalId: null
	    };
	  },
	
	  computed: {
	    weekStartDate: function weekStartDate() {
	      return (0, _moment2.default)(this.date).isoWeekday(1).format('YYYY-MM-DD');
	    },
	    weekEndDate: function weekEndDate() {
	      return (0, _moment2.default)(this.date).isoWeekday(7).format('YYYY-MM-DD');
	    },
	    isNotToday: function isNotToday() {
	      return (0, _moment2.default)(this.date).format('YYYY-MM-DD') !== (0, _moment2.default)(this.today).format('YYYY-MM-DD');
	    },
	    isNotThisWeek: function isNotThisWeek() {
	      return (0, _moment2.default)(this.date).isoWeek() !== (0, _moment2.default)(this.today).isoWeek();
	    }
	  },
	  methods: {
	    getSchoolInfo: function getSchoolInfo() {
	      var _this = this;
	
	      _docendo2.default.calendar(this.calId, function (data) {
	        _this.calInfo = data;
	      });
	    },
	    getLessons: function getLessons() {
	      var _this2 = this;
	
	      var start = this.weekStartDate;
	      var end = this.weekEndDate;
	      _docendo2.default.calendarPublicEvents(this.calId, start, end, true, null, true, function (data) {
	        _this2.allEvents = data;
	      });
	    },
	    setDate: function setDate(date) {
	      this.date = date;
	      this.getLessons();
	    },
	    nextWeek: function nextWeek() {
	      var date = (0, _moment2.default)(this.date).add(7, 'days');
	      this.setDate(date);
	    },
	    prevWeek: function prevWeek() {
	      var date = (0, _moment2.default)(this.date).subtract(7, 'days');
	      this.setDate(date);
	    },
	    setToday: function setToday() {
	      this.setDate(this.today);
	    },
	    setView: function setView(view) {
	      this.calView = view;
	    },
	    showEvent: function showEvent(event) {
	      this.$emit('eventClick', event);
	    },
	    setLocale: function setLocale(val) {
	      this.locale = val;
	      this.$emit('setLocale', val);
	    }
	  },
	  beforeMount: function beforeMount() {
	    if (window.location.href && window.location.href.indexOf('?update') > -1) {
	      this.intervalId = setInterval(this.getLessons, 300000);
	    }
	  },
	  mounted: function mounted() {
	    this.getSchoolInfo();
	    this.getLessons();
	
	    if (this.$helpers.getCookie('calendar_current_date_public') && this.$helpers.getCookie('calendar_current_date')) {
	      this.setDate(this.$helpers.getCookie('calendar_current_date'));
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.intervalId) {
	      clearInterval(this.intervalId);
	    }
	  }
	};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DCalendar = __webpack_require__(58);
	
	var _DCalendar2 = _interopRequireDefault(_DCalendar);
	
	var _SmartScreen = __webpack_require__(1410);
	
	var _SmartScreen2 = _interopRequireDefault(_SmartScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { DCalendar: _DCalendar2.default, SmartScreen: _SmartScreen2.default },
	  props: {
	    calendarId: {},
	    calendar: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      startDate: (0, _moment2.default)().startOf('isoWeek'),
	      endDate: (0, _moment2.default)().endOf('isoWeek'),
	      events: [],
	      isLoadingEvents: false
	    };
	  },
	
	  computed: {
	    calendarName: function calendarName() {
	      return this.calendar ? this.calendar.name : '';
	    }
	  },
	  methods: {
	    getCalendarEvents: function getCalendarEvents() {
	      var _this = this;
	
	      this.isLoadingEvents = true;
	      _docendo2.default.publicEventsFromCalendar(this.calendarId, this.startDate, this.endDate, function (success) {
	        _this.events = success && success.length > 0 ? JSON.parse(success) : [];
	        _this.isLoadingEvents = false;
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.getCalendarEvents();
	  }
	};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SetLocale = __webpack_require__(314);
	
	var _SetLocale2 = _interopRequireDefault(_SetLocale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { setLocale: _SetLocale2.default },
	  props: ['calname', 'schoolname'],
	  data: function data() {
	    return {
	      locale: 'en'
	    };
	  },
	
	  methods: {
	    emitLocale: function emitLocale(val) {
	      this.locale = val;
	      this.$emit('locale', val);
	    },
	    print: function print() {
	      if (window.Intercom) {
	        window.Intercom('trackEvent', 'Print calendar');
	      }
	      if (document.querySelector('.day_change_header') === null && document.querySelector('.week_note') === null) {
	        document.querySelector('.weekplan').classList.add('hide');
	        window.print();
	        document.querySelector('.weekplan').classList.remove('hide');
	      } else {
	        window.print();
	      }
	    },
	    printWithoutColors: function printWithoutColors() {
	      if (window.Intercom) {
	        window.Intercom('trackEvent', 'Print calendar');
	      }
	      if (document.querySelector('.day_change_header') === null && document.querySelector('.week_note') === null) {
	        document.querySelector('.public-app').classList.add('black-and-white');
	        document.querySelector('.weekplan').classList.add('hide');
	        window.print();
	        document.querySelector('.weekplan').classList.remove('hide');
	        document.querySelector('.public-app').classList.remove('black-and-white');
	      } else {
	        document.querySelector('.public-app').classList.add('black-and-white');
	        window.print();
	        document.querySelector('.public-app').classList.remove('black-and-white');
	      }
	    }
	  },
	  updated: function updated() {
	    document.title = this.calname;
	  }
	};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    calendarId: {
	      default: 285799
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(),
	      events: [],
	      isLoadingEvents: false,
	      refreshTimeout: null,
	      fontSize: '16px',
	      scrollInterval: null
	    };
	  },
	
	  computed: {
	    computedStyle: function computedStyle() {
	      return {
	        fontSize: this.fontSize
	      };
	    },
	    dateFormatted: function dateFormatted() {
	      return (0, _moment2.default)(this.date).format('dddd LL');
	    },
	    latestUpdate: function latestUpdate() {
	      return (0, _moment2.default)(this.date).format('LL LTS');
	    },
	    eventsFiltered: function eventsFiltered() {
	      var _this = this;
	
	      return this.events.filter(function (event) {
	        return (0, _moment2.default)(event.start).format('YYYY-MM-DD') === (0, _moment2.default)(_this.date).format('YYYY-MM-DD');
	      });
	    },
	    eventsSorted: function eventsSorted() {
	      return this.eventsFiltered.sort(function (a, b) {
	        return (0, _moment2.default)(a.start).unix() - (0, _moment2.default)(b.start).unix();
	      });
	    },
	    eventsWithProps: function eventsWithProps() {
	      return this.eventsSorted.map(function (event) {
	        return (0, _extends3.default)({}, event, {
	          vEventTime: (0, _moment2.default)(event.start).format('LT') + ' - ' + (0, _moment2.default)(event.end).format('LT'),
	          vRooms: event.calendars.filter(function (cal) {
	            return cal.calendar_type === 'room';
	          }).map(function (cal) {
	            return cal.name;
	          }).join(', '),
	          vTeachers: event.calendars.filter(function (cal) {
	            return cal.calendar_type === 'user';
	          }).map(function (cal) {
	            return cal.name;
	          }).join(', '),
	          vStudents: event.calendars.filter(function (cal) {
	            return cal.calendar_type === 'student';
	          }).map(function (cal) {
	            return cal.name;
	          }).join(', ')
	        });
	      });
	    }
	  },
	  watch: {
	    events: function events(val) {
	      var _this2 = this;
	
	      this.$nextTick(function (_) {
	        _this2.checkForUrlParamScroll();
	      });
	    }
	  },
	  methods: {
	    checkScrollable: function checkScrollable() {
	      var publicAppElement = document.querySelector('.public-app');
	      var viewportHeight = window.innerHeight;
	
	      if (publicAppElement.offsetHeight > viewportHeight) {
	        console.log('The .public-app element is taller than the viewport and can be scrolled.');
	
	        this.startAutoScroll();
	      } else {
	        console.log('The .public-app element is not taller than the viewport and cannot be scrolled.');
	      }
	    },
	    startAutoScroll: function startAutoScroll() {
	      var scrollDirection = 1;
	      var scrollSpeed = 1;
	
	      var autoScrollPage = function autoScrollPage() {
	        window.scrollBy(0, scrollSpeed * scrollDirection);
	
	        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
	          scrollDirection = -1;
	        } else if (window.scrollY <= 0) {
	          scrollDirection = 1;
	        }
	      };
	      clearInterval(this.scrollInterval);
	      this.scrollInterval = setInterval(autoScrollPage, 30);
	    },
	    setupRefresh: function setupRefresh() {
	      var _this3 = this;
	
	      this.getCalendarEvents();
	
	      this.refreshTimeout = setInterval(function () {
	        _this3.date = (0, _moment2.default)();
	        _this3.getCalendarEvents();
	      }, 600000);
	    },
	    getCalendarEvents: function getCalendarEvents() {
	      var _this4 = this;
	
	      this.isLoadingEvents = true;
	      var startDate = (0, _moment2.default)(this.date);
	      var endDate = (0, _moment2.default)(this.date).add(1, 'days');
	      _docendo2.default.publicEventsFromCalendar(this.calendarId, startDate, endDate, function (success) {
	        _this4.events = success && success.length > 0 ? JSON.parse(success) : [];
	        _this4.isLoadingEvents = false;
	        _this4.$nextTick(function (_) {});
	      }, function (failure) {
	        console.log({ failure: failure });
	      });
	    },
	    updateFontSizeFromUrl: function updateFontSizeFromUrl() {
	      var hash = window.location.hash;
	
	      if (hash.includes('?')) {
	        var queryString = hash.split('?')[1];
	        var urlParams = new window.URLSearchParams(queryString);
	        var fontsize = urlParams.get('fontsize');
	
	        if (fontsize) {
	          this.fontSize = fontsize + 'px';
	        }
	      }
	    },
	    checkForUrlParamScroll: function checkForUrlParamScroll() {
	      var hash = window.location.hash;
	
	      if (hash.includes('?')) {
	        var queryString = hash.split('?')[1];
	        var urlParams = new window.URLSearchParams(queryString);
	        var autoscroll = urlParams.get('autoscroll');
	
	        if (autoscroll && autoscroll === 'true') {
	          console.log('Autoscroll is enabled');
	
	          this.checkScrollable();
	        } else {
	          console.log('Autoscroll is disabled');
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.setupRefresh();
	    this.updateFontSizeFromUrl();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.refreshTimeout);
	  }
	};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WeekPlanLesson = __webpack_require__(1412);
	
	var _WeekPlanLesson2 = _interopRequireDefault(_WeekPlanLesson);
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    events: {},
	    calId: {},
	    date: {
	      default: (0, _moment2.default)().utc()
	    },
	    calview: {},
	    locale: {}
	  },
	  data: function data() {
	    return {
	      weekNote: ''
	    };
	  },
	
	  watch: {
	    date: function date() {
	      this.getWeekNote();
	      this.createLocaleDate(this.date);
	    }
	  },
	  components: {
	    dWeekPlanLesson: _WeekPlanLesson2.default
	  },
	  computed: {
	    weekNoteWithLineBreaks: function weekNoteWithLineBreaks() {
	      return this.weekNote.replace(/(?:\r\n|\r|\n)/g, '<br/>');
	    },
	    eventsWithNotes: function eventsWithNotes() {
	      var allDates = [];
	      for (var i = 1; i < 8; i++) {
	        var date = (0, _moment2.default)(this.date).isoWeekday(i).format('YYYY-MM-DD');
	        var arr = this.filterLesson(i).concat();
	        arr.sort(function compare(a, b) {
	          var dateA = new Date(a.start);
	          var dateB = new Date(b.start);
	          return dateA - dateB;
	        });
	        allDates.push({ date: date, lessons: arr });
	      }
	      return allDates;
	    }
	  },
	  methods: {
	    createLocaleDate: function createLocaleDate(mom) {
	      if (this.locale === 'nn') {
	        return (0, _moment2.default)(mom).format('dddd DD. MMMM');
	      }
	      try {
	        return (0, _moment2.default)(mom)._d.toLocaleDateString(this.locale, { weekday: 'long', month: 'long', day: '2-digit' });
	      } catch (e) {
	        return (0, _moment2.default)(mom).format('LL');
	      }
	    },
	    getWeekNote: function getWeekNote() {
	      var _this = this;
	
	      var isoWeek = (0, _moment2.default)(this.date).isoWeek().toString().length < 2 ? '0' + (0, _moment2.default)(this.date).isoWeek() : (0, _moment2.default)(this.date).isoWeek();
	      var week = (0, _moment2.default)(this.date).endOf('week').format('YYYY') + 'W' + isoWeek;
	      _docendo2.default.weeknote(this.calId, week, function (data) {
	        _this.weekNote = data.note;
	      });
	    },
	    filterLesson: function filterLesson(dayNum) {
	      var _this2 = this;
	
	      return this.events.filter(function (lesson) {
	        var lessonDate = (0, _moment2.default)(lesson.start).format('YYYY-MM-DD');
	        var day = (0, _moment2.default)(_this2.date).isoWeekday(dayNum).format('YYYY-MM-DD');
	        return (0, _moment2.default)(lessonDate).isSame(day) && lesson.has_notes;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.getWeekNote();
	  }
	};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['event', 'date'],
	  computed: {
	    learningGoal: function learningGoal() {
	      return this.event.learning_goal;
	    },
	    description: function description() {
	      return this.event.description;
	    },
	    notes_for_students: function notes_for_students() {
	      return this.event.notes_for_students;
	    }
	  }
	};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatepickerMobile = __webpack_require__(1400);
	
	var _DatepickerMobile2 = _interopRequireDefault(_DatepickerMobile);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    theCalendarDate: {
	      default: function _default() {
	        return (0, _moment2.default)();
	      }
	    },
	    active: {
	      type: Boolean,
	      default: false
	    },
	    dateChange: {}
	  },
	  components: { mobileDatepicker: _DatepickerMobile2.default },
	  data: function data() {
	    return {
	      calendars: [],
	      translateX: 0,
	      panStart: 0,
	      panCurrent: 0,
	      isScrolling: false,
	      isActive: false
	    };
	  },
	
	  watch: {
	    active: function active(val) {
	      var _this = this;
	
	      if (val) {
	        setTimeout(function (_) {
	          _this.isActive = true;
	        });
	      } else {
	        this.isActive = false;
	      }
	    }
	  },
	  methods: {
	    addThreeCalendars: function addThreeCalendars() {
	      this.addCal(this.date);
	      var prev = (0, _moment2.default)(this.date).subtract(1, 'months');
	      var next = (0, _moment2.default)(this.date).add(1, 'months');
	      this.addCal(prev);
	      this.addCal(next);
	    },
	    addCal: function addCal(date) {
	      var calDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      var calDateStartOfMonth = (0, _moment2.default)(calDate).startOf('month');
	      var dateStartOfMonth = (0, _moment2.default)(this.date).startOf('month');
	      var diff = (0, _moment2.default)(calDateStartOfMonth).diff(dateStartOfMonth, 'months', false);
	      var disX = 100 * diff;
	      this.calendars.push({ date: calDate, style: disX });
	    },
	    updateCal: function updateCal(date) {
	      var calDate = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      for (var i = 0; i < 3; i++) {
	        var calDateStartOfMonth = (0, _moment2.default)(calDate).startOf('month');
	        var dateStartOfMonth = (0, _moment2.default)(this.calendars[i].date).startOf('month');
	        var dateDiff = (0, _moment2.default)(calDateStartOfMonth).diff(dateStartOfMonth, 'months');
	        if (dateDiff === -2) {
	          var prevDate = (0, _moment2.default)(date).subtract(1, 'months').format('YYYY-MM-DD');
	          var x = this.translateX + 100;
	          this.calendars[i].date = prevDate;
	          this.calendars[i].style = -x;
	        }
	        if (dateDiff === 2) {
	          var nextDate = (0, _moment2.default)(date).add(1, 'months').format('YYYY-MM-DD');
	          var _x = this.translateX - 100;
	          this.calendars[i].date = nextDate;
	          this.calendars[i].style = -_x;
	        }
	      }
	    },
	    setPanStart: function setPanStart(e) {
	      this.panStart = e.srcEvent.pageX || e.pointers[0].pageX;
	    },
	    onPan: function onPan(e) {
	      e.preventDefault();
	      this.panCurrent = e.srcEvent.pageX || e.pointers[0].pageX;
	      var element = document.querySelector('.days-container');
	      var distanceX = this.panCurrent - this.panStart;
	      var percentage = distanceX / element.getBoundingClientRect().width * 100;
	      var range = this.translateX + percentage;
	      element.style.transitionDuration = '0ms';
	      element.style.webkitTransform = 'translate3d(' + range + '%, 0,0)';
	    },
	    onPanEnd: function onPanEnd(e) {
	      var _this2 = this;
	
	      var element = document.querySelector('.days-container');
	      element.style.transitionDuration = '0ms';
	      element.style.webkitTransform = 'translate3d(' + 0 + '%, 0,0)';
	      var distanceX = this.panCurrent - this.panStart;
	      if (Math.abs(distanceX) < 55) {
	        this.scrollToDate(this.translateX, 5);
	      } else {
	        if (distanceX > 55) {
	          this.translateX = this.translateX + 100;
	          this.scrollToDate(this.translateX, 35);
	          var date = (0, _moment2.default)(this.date).subtract(1, 'months').format('YYYY-MM-DD');
	          this.$emit('changed', date);
	          setTimeout(function () {
	            _this2.updateCal(_this2.date);
	          }, 200);
	        } else {
	          this.translateX = this.translateX - 100;
	          this.scrollToDate(this.translateX, 35);
	          var _date = (0, _moment2.default)(this.date).add(1, 'months').format('YYYY-MM-DD');
	          this.$emit('changed', _date);
	          setTimeout(function () {
	            _this2.updateCal(_this2.date);
	          }, 200);
	        }
	      }
	      this.panStart = null;
	    },
	    scrollToDate: function scrollToDate(scroolX, speed) {
	      var element = document.querySelector('.days-container');
	      element.style.webkitTransform = 'translate3d(' + scroolX + '%, 0,0)';
	      element.style.transition = '0.' + speed + 's';
	    },
	    setCalDate: function setCalDate(date) {
	      this.translateX = 0;
	      this.scrollToDate(0, 0);
	      this.$emit('setDate', date);
	    }
	  },
	  mounted: function mounted() {
	    this.addThreeCalendars();
	  }
	};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DayCal = __webpack_require__(1415);
	
	var _DayCal2 = _interopRequireDefault(_DayCal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['date', 'dateChange', 'viewState', 'locale', 'lessons', 'i18n'],
	  components: { dayCal: _DayCal2.default },
	  data: function data() {
	    return {
	      height: 300
	    };
	  },
	
	  methods: {
	    onTap: function onTap(lesson) {
	      this.$emit('eventClicked', lesson);
	    },
	    calculateHeightForCalendar: function calculateHeightForCalendar() {
	      var bottom = document.querySelector('.day-select__container').getBoundingClientRect().bottom;
	      var windowHeight = window.innerHeight;
	      this.height = windowHeight - bottom - 55;
	    },
	    setScrollTop: function setScrollTop(val) {
	      this.$el.scrollTop = val.top - 20;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.calculateHeightForCalendar();
	    window.addEventListener('resize', function () {
	      _this.calculateHeightForCalendar();
	    });
	  }
	};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DayCalEvent = __webpack_require__(1416);
	
	var _DayCalEvent2 = _interopRequireDefault(_DayCalEvent);
	
	var _NowIndicator = __webpack_require__(1417);
	
	var _NowIndicator2 = _interopRequireDefault(_NowIndicator);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(46);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: function _default() {
	        return _config2.default.now;
	      }
	    },
	    events: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    viewState: {
	      type: Number,
	      default: 0
	    },
	    locale: {
	      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    },
	    i18n: {}
	  },
	  components: { calEvent: _DayCalEvent2.default, nowIndicator: _NowIndicator2.default },
	  data: function data() {
	    return {
	      slotHeight: 40,
	      correctEvents: [],
	      firstEvent: true
	    };
	  },
	
	  computed: {
	    start: function start() {
	      if (this.viewState !== 2) {
	        return 6;
	      } else {
	        return 0;
	      }
	    },
	    end: function end() {
	      if (this.viewState !== 2) {
	        return 18;
	      } else {
	        return 24;
	      }
	    },
	    isToday: function isToday() {
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      var today = (0, _moment2.default)().format('YYYY-MM-DD');
	      return (0, _moment2.default)(date).isSame(today);
	    },
	    dayLessons: function dayLessons() {
	      var _this = this;
	
	      return this.events.filter(function (lesson) {
	        var lessonDate = (0, _moment2.default)(lesson.start).format('YYYY-MM-DD');
	        var day = (0, _moment2.default)(_this.date).format('YYYY-MM-DD');
	        return (0, _moment2.default)(lessonDate).isSame(day);
	      });
	    },
	    hours: function hours() {
	      var hours = [];
	      for (var i = this.start; i <= this.end; i++) {
	        hours.push(i);
	      }
	      return hours;
	    },
	    hoursInLocale: function hoursInLocale() {
	      var _this2 = this;
	
	      var localeHours = [];
	      this.hours.forEach(function (h) {
	        var mom = (0, _moment2.default)().set({ hour: h, minutes: 0, seconds: 0 });
	        localeHours.push((0, _moment2.default)(mom).locale(_this2.locale).format('LT'));
	      });
	      return localeHours;
	    }
	  },
	  watch: {
	    dayLessons: function dayLessons() {
	      this.correctEvents = [];
	      this.setWidthAndLeft();
	      this.firstEvent = true;
	    }
	  },
	  methods: {
	    onTap: function onTap(lesson) {
	      this.$emit('eventClicked', lesson);
	    },
	    getHeightOfTimeSlots: function getHeightOfTimeSlots() {
	      var height = document.getElementsByClassName('time-slot')[1].getBoundingClientRect().height;
	      this.slotHeight = height;
	    },
	    eventTop: function eventTop(event) {
	      var calStartTime = (0, _moment2.default)(event.start).hour(this.start).minutes('0');
	      var eventStartTime = (0, _moment2.default)(event.start);
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventHeight: function eventHeight(event) {
	      var duration = (0, _moment2.default)(event.end).diff(event.start);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    eventBottom: function eventBottom(event) {
	      var calStartTime = (0, _moment2.default)(event.end).hour(this.start).minutes('0');
	      var eventEndTime = (0, _moment2.default)(event.end);
	      var duration = (0, _moment2.default)(eventEndTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    },
	    collidesWith: function collidesWith(a, b) {
	      return a.bottom > b.top && a.top < b.bottom;
	    },
	    packEvents: function packEvents(columns) {
	      var n = columns.length;
	      for (var i = 0; i < n; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev = col[j];
	          var colSpan = this.expandEvent(ev, i, columns);
	          col[j].left = i / n * 100;
	          col[j].width = 100 * colSpan / n;
	          this.correctEvents.push(col[j]);
	
	          if (this.firstEvent) {
	            this.$emit('lessonsUpdate', this.correctEvents[0]);
	          }
	          this.firstEvent = false;
	        }
	      }
	    },
	    expandEvent: function expandEvent(ev, iColumn, columns) {
	      var colSpan = 1;
	      for (var i = iColumn + 1; i < columns.length; i++) {
	        var col = columns[i];
	        for (var j = 0; j < col.length; j++) {
	          var ev1 = col[j];
	          if (this.collidesWith(ev, ev1)) {
	            return colSpan;
	          }
	        }
	        colSpan++;
	      }
	      return colSpan;
	    },
	    setWidthAndLeft: function setWidthAndLeft() {
	      var _this3 = this;
	
	      var columns = [];
	      var lastEventEnding = null;
	      var events = this.dayLessons.map(function (elem) {
	        var top = _this3.eventTop(elem);
	        var height = _this3.eventHeight(elem);
	        var bottom = _this3.eventBottom(elem);
	        return {
	          'obj': elem,
	          'top': top,
	          'height': height,
	          'bottom': bottom
	        };
	      });
	      events = events.sort(function (e1, e2) {
	        if (e1.top < e2.top) return -1;
	        if (e1.top > e2.top) return 1;
	        if (e1.bottom < e2.bottom) return -1;
	        if (e1.bottom > e2.bottom) return 1;
	        return 0;
	      });
	      for (var i = 0; i < events.length; i++) {
	        var e = events[i];
	        if (lastEventEnding !== null && e.top >= lastEventEnding) {
	          this.packEvents(columns);
	          columns = [];
	          lastEventEnding = null;
	        }
	        var placed = false;
	        for (var j = 0; j < columns.length; j++) {
	          var col = columns[j];
	          if (!this.collidesWith(col[col.length - 1], e)) {
	            col.push(e);
	            placed = true;
	            break;
	          }
	        }
	        if (!placed) {
	          columns.push([e]);
	        }
	        if (lastEventEnding === null || e.bottom > lastEventEnding) {
	          lastEventEnding = e.bottom;
	        }
	      }
	      if (columns.length > 0) {
	        this.packEvents(columns);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.getHeightOfTimeSlots();
	  }
	};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['event', 'start', 'i18n'],
	  data: function data() {
	    return {
	      slotHeight: 40
	    };
	  },
	
	  computed: {
	    styleObject: function styleObject() {
	      var styleObject = {
	        borderColor: this.event.obj.color,
	        height: this.event.height + 'px',
	        top: this.event.top - 1 + 'px',
	        left: this.event.left + '%',
	        width: this.event.width + '%'
	      };
	      return styleObject;
	    }
	  },
	  methods: {
	    getEventWarningLabel: function getEventWarningLabel(eventObj) {
	      if (eventObj.canceled) {
	        return this.i18n.canceled;
	      }
	      if (eventObj.away) {
	        return this.i18n.out_of_school;
	      }
	    }
	  }
	};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    start: {
	      default: 6
	    },
	    slotHeight: {
	      default: 40
	    }
	  },
	  computed: {
	    top: function top() {
	      return this.eventTop();
	    }
	  },
	  methods: {
	    eventTop: function eventTop() {
	      var calStartTime = (0, _moment2.default)().hour(this.start).minutes('0');
	      var eventStartTime = (0, _moment2.default)();
	      var duration = (0, _moment2.default)(eventStartTime).diff(calStartTime);
	      return this.slotHeight * 2 / 60 * _moment2.default.duration(duration).asMinutes();
	    }
	  }
	};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    isNotToday: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    className: function className() {
	      return _eventbus2.default.sideWideAnnouncement ? 'true' : '';
	    }
	  },
	  methods: {
	    prev: function prev(e) {
	      e.preventDefault();
	      this.$emit('prev');
	    },
	    next: function next(e) {
	      e.preventDefault();
	      this.$emit('next');
	    },
	    preventZoom: function preventZoom(e) {
	      e.preventDefault();
	    }
	  }
	};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      default: (0, _moment2.default)().format('YYYY-MM-DD')
	    },
	    showdatepicker: {},
	    calname: {},
	    schoolname: {},
	    anyWeekNotes: {
	      type: Boolean,
	      default: false
	    },
	    locale: {
	      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    }
	  },
	  computed: {
	    weekNum: function weekNum() {
	      return (0, _moment2.default)(this.date).isoWeek();
	    },
	    isMonth: function isMonth() {
	      return (0, _moment2.default)(this.date).locale(this.locale).format('MMMM, YYYY');
	    }
	  },
	  methods: {
	    sendClick: function sendClick() {
	      this.$emit('monthClick');
	    }
	  }
	};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(1419);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _DaySelect = __webpack_require__(1401);
	
	var _DaySelect2 = _interopRequireDefault(_DaySelect);
	
	var _PanContainer = __webpack_require__(1413);
	
	var _PanContainer2 = _interopRequireDefault(_PanContainer);
	
	var _CalContainer = __webpack_require__(1414);
	
	var _CalContainer2 = _interopRequireDefault(_CalContainer);
	
	var _FooterNav = __webpack_require__(1418);
	
	var _FooterNav2 = _interopRequireDefault(_FooterNav);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _config = __webpack_require__(46);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ShowEvent = __webpack_require__(357);
	
	var _ShowEvent2 = _interopRequireDefault(_ShowEvent);
	
	var _Container = __webpack_require__(1423);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SideNav = __webpack_require__(1421);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _CalContainer3 = __webpack_require__(1422);
	
	var _CalContainer4 = _interopRequireDefault(_CalContainer3);
	
	var _SiteWideAnnouncement = __webpack_require__(1425);
	
	var _SiteWideAnnouncement2 = _interopRequireDefault(_SiteWideAnnouncement);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _DAppCalendarNav = __webpack_require__(1236);
	
	var _DAppCalendarNav2 = _interopRequireDefault(_DAppCalendarNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DAppCalendarNav: _DAppCalendarNav2.default,
	    publicHeader: _Header2.default,
	    daySelector: _DaySelect2.default,
	    calContainer: _CalContainer2.default,
	    showEvent: _ShowEvent2.default,
	    panContainer: _PanContainer2.default,
	    footerNav: _FooterNav2.default,
	    weekplan: _Container2.default,
	    sidenav: _SideNav2.default,
	    weekCalendar: _CalContainer4.default,
	    announcement: _SiteWideAnnouncement2.default
	  },
	  props: ['calId', 'viewState', 'weekplan', 'schoolName', 'calName', 'i18n'],
	  data: function data() {
	    return {
	      chosenView: 1,
	      oldChosenView: 1,
	      allEvents: [],
	      date: _config2.default.now,
	      today: _config2.default.now,
	      dateChange: false,
	      locale: _moment2.default.locale(),
	      datePickerDate: _config2.default.now,
	      showdatepicker: false,
	      isDatePickerReady: false,
	      weeknote: '',
	      menu: false,
	      start: _config2.default.now,
	      end: _config2.default.now,
	      load: true
	    };
	  },
	
	  watch: {
	    showdatepicker: function showdatepicker() {
	      this.showdatepicker === false ? this.datePickerDate = this.date : null;
	    },
	    date: function date(val, oldVal) {
	      if ((0, _moment2.default)(val).isoWeek() !== (0, _moment2.default)(oldVal).isoWeek()) {
	        this.getWeekNote();
	      }
	    },
	    chosenView: function chosenView(val, oldval) {
	      this.oldChosenView = oldval;
	      try {
	        if (typeof Storage !== 'undefined') {
	          window.localStorage.setItem('chosenView', this.chosenView);
	        }
	      } catch (e) {}
	      this.getLessons();
	    }
	  },
	  computed: {
	    isNotToday: function isNotToday() {
	      return (0, _moment2.default)(this.date).format('YYYY-MM-DD') !== (0, _moment2.default)(this.today).format('YYYY-MM-DD');
	    }
	  },
	  methods: {
	    getView: function getView(val) {
	      this.chosenView = val;
	    },
	    setDate: function setDate(date) {
	      this.date = date;
	      this.datePickerDate = date;
	      this.dateChange = !this.dateChange;
	      this.getLessons();
	      this.closeDatepicker();
	    },
	    closeDatepicker: function closeDatepicker() {
	      this.showdatepicker = false;
	      this.isDatePickerReady = false;
	    },
	    setDatePickerDate: function setDatePickerDate(date) {
	      this.datePickerDate = date;
	    },
	    getLessons: function getLessons() {
	      var _this = this;
	
	      var timer;
	
	      _eventbus2.default.loadingEvents = true;
	      timer = setTimeout(function () {
	        _this.load = true;
	      }, 300);
	      var date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	      if (this.chosenView !== 1) {
	        this.start = (0, _moment2.default)(date).startOf('isoWeek').utc();
	        this.end = (0, _moment2.default)(date).endOf('isoWeek').utc();
	        _docendo2.default.calendarPublicEvents(this.calId, this.start, this.end, true, null, true, function (data) {
	          clearTimeout(timer);
	          _this.load = false;
	          _eventbus2.default.loadingEvents = false;
	          _this.allEvents = data;
	        });
	      } else {
	        this.start = (0, _moment2.default)(date).startOf('day').utc();
	        this.end = (0, _moment2.default)(date).endOf('day').utc();
	        _docendo2.default.calendarPublicEvents(this.calId, this.start, this.end, true, null, true, function (data) {
	          clearTimeout(timer);
	          _this.load = false;
	          _eventbus2.default.loadingEvents = false;
	          _this.allEvents = data;
	        });
	      }
	    },
	    getWeekNote: function getWeekNote() {
	      var _this2 = this;
	
	      var isoWeek = (0, _moment2.default)(this.date).isoWeek().toString().length < 2 ? '0' + (0, _moment2.default)(this.date).isoWeek() : (0, _moment2.default)(this.date).isoWeek();
	      var week = (0, _moment2.default)(this.date).endOf('week').format('YYYY') + 'W' + isoWeek;
	      _docendo2.default.weeknote(this.calId, week, function (data) {
	        if (data.note === undefined) {
	          _this2.weeknote = '';
	        } else {
	          _this2.weeknote = data.note;
	        }
	      });
	    },
	    prev: function prev() {
	      var prevDate = void 0;
	      if (this.chosenView !== 1) {
	        prevDate = (0, _moment2.default)(this.date).subtract(7, 'days').isoWeekday(1);
	      } else {
	        prevDate = (0, _moment2.default)(this.date).subtract(1, 'days');
	      }
	      this.setDate(prevDate);
	    },
	    next: function next() {
	      var nextDate = void 0;
	      if (this.chosenView !== 1) {
	        nextDate = (0, _moment2.default)(this.date).add(7, 'days').isoWeekday(1);
	      } else {
	        nextDate = (0, _moment2.default)(this.date).add(1, 'days');
	      }
	      this.setDate(nextDate);
	    },
	    showEvent: function showEvent(event) {
	      this.$emit('eventClick', event);
	    },
	    setLocale: function setLocale(val) {
	      this.locale = val;
	      this.$emit('setLocale', val);
	    },
	    closeWeekPlan: function closeWeekPlan() {
	      this.chosenView = this.oldChosenView;
	    },
	    setMenu: function setMenu() {
	      this.closeDatepicker();
	      this.menu = true;
	    },
	    toggleDatePicker: function toggleDatePicker() {
	      var _this3 = this;
	
	      if (!this.showdatepicker) {
	        this.showdatepicker = true;
	        setTimeout(function (_) {
	          _this3.isDatePickerReady = true;
	        }, 0);
	      } else {
	        this.closeDatepicker();
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    try {
	      if (typeof Storage !== 'undefined') {
	        if (window.localStorage.getItem('chosenView') !== null) {
	          this.chosenView = window.localStorage.getItem('chosenView') * 1;
	        }
	      }
	    } catch (e) {}
	  },
	  mounted: function mounted() {
	    this.getLessons();
	    this.getWeekNote();
	  },
	  updated: function updated() {
	    document.title = this.calName;
	  }
	};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SetLocale = __webpack_require__(314);
	
	var _SetLocale2 = _interopRequireDefault(_SetLocale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { setLocale: _SetLocale2.default },
	  props: {
	    menu: {
	      default: false
	    },
	    schoolName: {},
	    calName: {},
	    chosenView: {
	      default: 1
	    }
	  },
	  data: function data() {
	    return {
	      view: this.chosenView,
	      startX: 0,
	      currentX: 0,
	      translate: 0,
	      translateX: -105 + '%',
	      touchingSideNav: false
	    };
	  },
	
	  watch: {
	    chosenView: function chosenView() {
	      this.view = this.chosenView;
	    },
	    menu: function menu(val) {
	      if (val) {
	        this.translateX = 0 + '%';
	      } else {
	        this.translateX = -105 + '%';
	      }
	    }
	  },
	  methods: {
	    onPanStart: function onPanStart(e) {
	      this.touchingSideNav = true;
	      this.startX = e.srcEvent.pageX;
	      window.requestAnimationFrame(this.update);
	    },
	    onPanEnd: function onPanEnd(e) {
	      this.touchingSideNav = false;
	      if (this.translate < 0) {
	        this.$emit('close');
	      }
	    },
	    moveMenu: function moveMenu(e) {
	      if (!this.touchingSideNav) {
	        return;
	      }
	      this.currentX = e.srcEvent.pageX;
	      this.translate = Math.min(0, this.currentX - this.startX);
	    },
	    update: function update() {
	      if (!this.touchingSideNav) {
	        return;
	      }
	      window.requestAnimationFrame(this.update);
	      this.translateX = Math.min(0, this.currentX - this.startX) + 'px';
	    },
	    setView: function setView(num) {
	      this.$emit('close');
	      this.view = num;
	    },
	    sendView: function sendView() {
	      this.$emit('afterLeave', this.view);
	    },
	    emitLocale: function emitLocale(val) {
	      this.$emit('locale', val);
	    }
	  }
	};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FullCal = __webpack_require__(346);
	
	var _FullCal2 = _interopRequireDefault(_FullCal);
	
	var _WeekPlan = __webpack_require__(355);
	
	var _WeekPlan2 = _interopRequireDefault(_WeekPlan);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['lessons', 'date', 'dateChange', 'viewState', 'calId', 'weeknote', 'locale', 'i18n'],
	  components: { fullCalendar: _FullCal2.default, weekplan: _WeekPlan2.default },
	  computed: {
	    calRangeView: function calRangeView() {
	      var s = (0, _moment2.default)(this.date).isoWeekday(1);
	      var e = (0, _moment2.default)(this.date).isoWeekday(7);
	      var start = s.format('DD.');
	      var start2 = s.format('DD. MMM');
	      var end = e.format('DD. MMM YYYY');
	
	      if (s.format('MM') === e.format('MM')) {
	        return start + ' - ' + end;
	      } else {
	        return start2 + ' - ' + end;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      height: 300
	    };
	  },
	
	  methods: {
	    onTap: function onTap(lesson) {
	      this.$emit('eventClicked', lesson);
	    },
	    calculateHeightForCalendar: function calculateHeightForCalendar() {
	      var windowHeight = window.innerHeight;
	      this.height = windowHeight - 55 - 55;
	    },
	    setScrollTop: function setScrollTop(val) {
	      this.$el.scrollTop = val.top - 20;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('resize', function () {
	      _this.calculateHeightForCalendar();
	    });
	    this.calculateHeightForCalendar();
	  }
	};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _WeekPlan = __webpack_require__(355);
	
	var _WeekPlan2 = _interopRequireDefault(_WeekPlan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { weekplan: _WeekPlan2.default },
	  props: ['calId', 'events', 'date', 'weeknote', 'locale'],
	  data: function data() {
	    return {
	      height: 300
	    };
	  },
	
	  computed: {
	    calRangeView: function calRangeView() {
	      var s = (0, _moment2.default)(this.date).isoWeekday(1);
	      var e = (0, _moment2.default)(this.date).isoWeekday(7);
	      var start = s.locale(this.locale).format('ll');
	      var end = e.locale(this.locale).format('ll');
	      return start + ' - ' + end;
	    }
	  },
	  methods: {
	    onTap: function onTap(lesson) {
	      this.$emit('eventClicked', lesson);
	    },
	    calculateHeightForCalendar: function calculateHeightForCalendar() {
	      var windowHeight = window.innerHeight;
	      this.height = windowHeight - 80 - 55;
	    },
	    close: function close() {
	      this.$emit('close');
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('resize', function () {
	      _this.calculateHeightForCalendar();
	    });
	    this.calculateHeightForCalendar();
	  }
	};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WeekPlanLesson = __webpack_require__(1424);
	
	var _WeekPlanLesson2 = _interopRequireDefault(_WeekPlanLesson);
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    dWeekPlanLesson: _WeekPlanLesson2.default
	  },
	  props: {
	    events: {},
	    calId: {},
	    date: {
	      default: (0, _moment2.default)().utc()
	    },
	    weeknote: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      weekNote: ''
	    };
	  },
	
	  computed: {
	    weekNoteWithLineBreaks: function weekNoteWithLineBreaks() {
	      return this.weeknote.replace(/(?:\r\n|\r|\n)/g, '<br/>');
	    },
	    isLoading: function isLoading() {
	      return _eventbus2.default.loadingEvents;
	    },
	    eventsWithNotes: function eventsWithNotes() {
	      var allDates = [];
	      for (var i = 1; i < 8; i++) {
	        var date = (0, _moment2.default)(this.date).isoWeekday(i).format('YYYY-MM-DD');
	        var arr = this.filterLesson(i).concat();
	        allDates.push({ date: date, lessons: arr });
	      }
	      return allDates;
	    },
	    anyNotes: function anyNotes() {
	      return this.events.find(function (event) {
	        if (event.has_notes) {
	          return event.has_notes;
	        }
	      });
	    }
	  },
	  methods: {
	    filterLesson: function filterLesson(dayNum) {
	      var _this = this;
	
	      return this.events.filter(function (lesson) {
	        var lessonDate = (0, _moment2.default)(lesson.start).format('YYYY-MM-DD');
	        var day = (0, _moment2.default)(_this.date).isoWeekday(dayNum).format('YYYY-MM-DD');
	        return (0, _moment2.default)(lessonDate).isSame(day) && lesson.has_notes;
	      });
	    }
	  }
	};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filters = __webpack_require__(34);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['event', 'date'],
	  methods: {
	    checkLengthWithoutHTML: function checkLengthWithoutHTML(text) {
	      return text.replace(/<(?:.|\n)*?>/gm, '');
	    }
	  }
	};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShowEvent = __webpack_require__(357);
	
	var _ShowEvent2 = _interopRequireDefault(_ShowEvent);
	
	var _DesktopView = __webpack_require__(1407);
	
	var _DesktopView2 = _interopRequireDefault(_DesktopView);
	
	var _DesktopVue = __webpack_require__(1408);
	
	var _DesktopVue2 = _interopRequireDefault(_DesktopVue);
	
	var _MobileView = __webpack_require__(1420);
	
	var _MobileView2 = _interopRequireDefault(_MobileView);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18N = {
	  da: {
	    out_of_school: 'Ude af huset',
	    canceled: 'Aflyst'
	  },
	  en: {
	    out_of_school: 'Out of school',
	    canceled: 'Canceled'
	  },
	  nb: {
	    out_of_school: 'Utenfor skolen',
	    canceled: 'Avlyst'
	  }
	};
	
	exports.default = {
	  components: {
	    DesktopVue: _DesktopVue2.default,
	    showEvent: _ShowEvent2.default,
	    desktop: _DesktopView2.default,
	    app: _MobileView2.default
	  },
	  props: {
	    calId: {
	      type: Number,
	      default: 405264
	    }
	  },
	  data: function data() {
	    return {
	      calendar: null,
	      view: 'desktop',
	      isMobile: false,
	      activeEvent: null,
	      viewState: 0,
	      calName: '',
	      schoolName: '',
	      locale: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    };
	  },
	
	  computed: {
	    i18n: function i18n() {
	      var loc = this.locale || 'en';
	      return I18N[loc] || I18N['en'];
	    }
	  },
	  methods: {
	    setLocale: function setLocale(val) {
	      this.locale = val;
	    },
	    setActiveEvent: function setActiveEvent(event) {
	      this.activeEvent = event;
	    },
	    getSchoolInfo: function getSchoolInfo() {
	      var _this = this;
	
	      _docendo2.default.calendar(this.calId, function (data) {
	        _this.calendar = data;
	        _this.calName = data.name;
	        _this.viewState = data.view_state;
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.isMobile = /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	    this.getSchoolInfo();
	    if (window.location.href && window.location.href.indexOf('smartscreen') > -1) {
	      this.view = 'smartscreen';
	    }
	  }
	};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    event: {
	      type: Object
	    },
	    locale: {
	      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
	    },
	    i18n: {}
	  },
	  computed: {
	    eventMinutes: function eventMinutes() {
	      var hours = Math.floor(this.event.duration / 60);
	      var minutes = this.event.duration - hours * 60;
	      return minutes;
	    },
	    eventHours: function eventHours() {
	      return Math.floor(this.event.duration / 60);
	    },
	    dayAndDate: function dayAndDate() {
	      if (this.locale === 'nn' || this.locale === 'nb') {
	        return (0, _moment2.default)(this.event.start).format('dddd DD. MMMM YYYY');
	      }
	      try {
	        return (0, _moment2.default)(this.event.start)._d.toLocaleDateString(this.locale, {
	          weekday: 'long',
	          month: 'long',
	          day: '2-digit',
	          year: 'numeric'
	        });
	      } catch (e) {
	        return (0, _moment2.default)(this.event.start).format('LL');
	      }
	    }
	  },
	  methods: {
	    checkLengthWithoutHTML: function checkLengthWithoutHTML(text) {
	      return text.replace(/<(?:.|\n)*?>/gm, '');
	    },
	    close: function close() {
	      this.$emit('close');
	    }
	  }
	};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      videoid: 'GUsvPp2uuGk',
	      seen: false,
	      isActive: false,
	      isDone: false,
	      w: 320,
	      h: 200
	    };
	  },
	
	  methods: {
	    setSeen: function setSeen() {
	      var _this = this;
	
	      this.isActive = false;
	      this.isDone = true;
	      setTimeout(function () {
	        _this.seen = true;
	      }, 300);
	
	      _eventbus2.default.sideWideAnnouncement = false;
	      try {
	        if (typeof Storage !== 'undefined') {
	          window.localStorage.setItem('publicNewsSeen', true);
	        }
	      } catch (e) {}
	    },
	    getMobileOperatingSystem: function getMobileOperatingSystem() {
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	
	      if (/windows phone/i.test(userAgent)) {
	        this.videoid = 'GUsvPp2uuGk';
	      }
	      if (/android/i.test(userAgent)) {
	        this.videoid = 'Idpmc8dcFV0';
	      }
	
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        this.videoid = 'Vkw-bVsvkq4';
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    try {
	      if (typeof Storage !== 'undefined') {
	        if (window.localStorage.getItem('publicNewsSeen') !== null) {
	          this.seen = window.localStorage.getItem('publicNewsSeen');
	        } else {
	          this.w = window.innerWidth;
	          _eventbus2.default.sideWideAnnouncement = true;
	        }
	      }
	    } catch (e) {}
	    this.getMobileOperatingSystem();
	  }
	};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(46);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    date: {
	      type: Object,
	      default: function _default() {
	        return (0, _moment2.default)(_config2.default.now).set({ 'hour': 8, 'minutes': 0 });
	      }
	    },
	    customClass: {
	      default: 'd-time-change-input'
	    }
	  },
	  watch: {
	    date: function date() {
	      if (this.active === false) {
	        this.$refs.input.value = (0, _moment2.default)(this.date).format('LT');
	      }
	    }
	  },
	  data: function data() {
	    return {
	      active: false
	    };
	  },
	
	  methods: {
	    updateValue: function updateValue(val) {
	      this.$emit('changed', val);
	    },
	    formatValue: function formatValue() {
	      this.$emit('blur');
	      this.$refs.input.value = (0, _moment2.default)(this.date).format('LT');
	      this.active = false;
	    },
	
	    selectAll: function selectAll(event) {
	      setTimeout(function () {
	        event.target.select();
	      }, 0);
	      this.active = true;
	    }
	  },
	  mounted: function mounted() {
	    this.$refs.input.value = (0, _moment2.default)(this.date).format('LT');
	  }
	};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(3);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _docendo = __webpack_require__(2);
	
	var _docendo2 = _interopRequireDefault(_docendo);
	
	var _Toast = __webpack_require__(1426);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { toast: _Toast2.default },
	  data: function data() {
	    return {
	      toasts: []
	    };
	  },
	
	  computed: {
	    messageFromOtherComponent: function messageFromOtherComponent() {
	      return _eventbus2.default.toast;
	    }
	  },
	  watch: {
	    messageFromOtherComponent: function messageFromOtherComponent() {
	      var text = this.messageFromOtherComponent.text;
	      var status = this.messageFromOtherComponent.success;
	      var position = this.messageFromOtherComponent.position ? this.messageFromOtherComponent.position : null;
	      this.pushToast(text, status, position);
	    }
	  },
	  methods: {
	    pushToast: function pushToast(text, success, position) {
	      this.toasts.push({
	        id: Date.now(),
	        text: text,
	        success: success,
	        position: position
	      });
	    },
	    removeNow: function removeNow(id) {
	      for (var i = 0; i < this.toasts.length; i++) {
	        if (this.toasts[i].id === id) {
	          this.toasts.splice(i, 1);
	        }
	      }
	    },
	    remove: function remove(id) {
	      var _this = this;
	
	      setTimeout(function () {
	        for (var i = 0; i < _this.toasts.length; i++) {
	          if (_this.toasts[i].id === id) {
	            _this.toasts.splice(i, 1);
	          }
	        }
	      }, 6500);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _docendo2.default.bind('new_notification', function (data) {
	      _this2.pushToast(data.message, true);
	    });
	  }
	};

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['index', 'toast', 'arrayLength'],
	  computed: {
	    styleObj: function styleObj() {
	      return { top: 60 * -this.index + this.arrayLength * 60 + 'px' };
	    },
	    leftBottom: function leftBottom() {
	      return this.toast.position && this.toast.position === 'bottomLeft';
	    }
	  },
	  methods: {
	    remove: function remove() {
	      this.$emit('remove', this.toast.id);
	    }
	  },
	  mounted: function mounted() {
	    this.remove();
	  }
	};

/***/ }),
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 911 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 960 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */
/***/ (function(module, exports) {

	module.exports = {"da":{"activerecord":{"attributes":{"calendar":{"name":"Navn"},"group":{"country":"Land","demo_expiry":"Demoperiode udløb","description":"Beskrivelse","institution_number":"Institutionsnummer","name":"Navn","open":"Åben?","si_name":"Navn i SkoleIntra","visible":"Synlig?"},"institution":{"number":"Institutionsnummer"},"lesson":{"count_hours":"Tæl timer"},"material":{"class":"Klassetrin","description":"Beskrivelse","documenttypes":"Dokumenttype","klassetrin":"Klassetrin","status":"Status","subjects":"Fag","tag_list":"Tag list","thefile":"Materiale","title":"Titel"},"notification":{"body":"Brødtekst","header":"Overskrift","sitewide":"Site wide","url":"URL"},"post":{"body":"Indhold","published":"Publiceret?","titel":"Titel"},"room":{"name":"Navn","navn":"Navn","si_name":"Navn i SkoleIntra"},"signup":{"already_in_use":"er allerede brugt","country":"Land","email":"Email","password":"Kodeord","password_can_not_be_email":"kan ikke være din email","password_can_not_be_school_name":"kan ikke være skolens navn","password_can_not_be_user_name":"kan ikke være dit navn","password_confirmation":"Bekræft kodeord","school_name":"Skolenavn","terms_of_service":"Betingelser","user_name":"Dit navn"},"subject":{"calendar":"Kalender","color":"Farve","default_duration":"Normal varighed","hours":"Timer","name":"Navn","si_name":"Navn i SkoleIntra","subject_type":"Briktype"},"subject_period":{"hours_per_week":"Timer per uge","total_hours":"Timer i alt"},"user":{"Email":"Email","Fag":"Fag","Initialer":"Initialer","Klassetrin":"Klassetrin","Navn":"Navn","Sprog":"Sprog","assigned_preparation_hours":"Forberedelse","assigned_teaching_hours":"Undervisningstid","assigned_total_hours":"Timer i år","description":"Beskrivelse","email":"Email","groups":"Groups","name":"Navn","organisation":"Skole","password":"Kodeord","password_confirmation":"Bekræftelse af kodeord","primary_school":"Primær skole","remember_me":"Remember me"}},"errors":{"models":{"group":{"attributes":{"institution_number":{"taken":"er allerede oprettet"}}}}},"models":{"calendar":"skema","group":"gruppe","institution":"institution","lesson":"modul","material":"materiale","post":"indlæg","room":"lokale","signup":"Signup","subject":"brik","subject_period":"fagperiode","user":"bruger","user/calendar_transfer":"Calendar transfer"}},"calendars":{"administration":{"archive_merge_table":"Arkivering af et fletteskema gør det usynligt på forsiden","archive_room":"Arkivering af et lokale gør det usynligt på forsiden"},"calendar_hours_count":{"andet_halvår":"2. halvår","første_halvår":"1. halvår","indeværende_uge":"Indeværende uge","skoleår_til_dato":"Skoleår til dato"},"calendar_sidebar":{"skema":" Skema"},"copy_paste":{"indsæt":"Indsæt","indsæt_resten_af_året":"Indsæt + resten af året","kopiér":"Kopiér"},"delete_merge_calendar_button":{"delete_merge_calendar":"Slet fletteskema","dette_kan_ikke_fortrydes":"Dette kan ikke fortrydes.","ja_slet_dette_fletteskema":"Ja","nej":"Nej","slet_dette_fletteskema":"Slet dette fletteskema?"},"delete_week_button":{"der_vil_kun_blive_slettet_de_lektioner_som_er_lagt_ind_i_denne_kalender":"Der vil kun blive slettet de lektioner, som er lagt ind i denne kalender.","dette_kan_ikke_fortrydes":"Dette kan ikke fortrydes","ja_slet_ugens_lektioner":"Ja, slet ugens lektioner.","lektioner":"Slet ugens lektioner...","nej":"Nej","vil_du_slette_alle_ugens_lektioner":"Vil du slette alle ugens lektioner?"},"events_with_notes_or_substitutes":{"hvis_du_kopierer_et_skema_frem_bliver_vikardækninger_fravær_i_personlige_kalendre_og_noter_på_lektionerne_ikke_gemt":"Hvis du kopierer et skema frem bliver vikardækninger i personlige kalendre og noter på lektionerne ikke gemt.","ja_jeg_vil_overskrive_disse":"Ja, jeg vil overskrive disse","lektioner_med_noter_vikardækning_eller_fravær":"Lektioner med noter"},"expand":{"skift_visning_mellem_arbejdsuge_weekender_og_fuld_uge":"Skift visning mellem skoleuge"},"explain_copy_in_background":{"der_kan_gå_5-10_minutter":"Der kan gå 5-10 minutter.","du_får_en_notifikation_på":"Du får en notifikation på","du_kan_fortsætte_med_at_arbejde_i_andre_kalendre":"Du kan fortsætte med at arbejde i andre kalendre.","forsiden":"forsiden","kopierer_kalenderen_frem":"Kopierer kalenderen frem i tid","når_kopieringen_er_afsluttet":"når kopieringen er afsluttet.","ok":"Ok"},"group":{"flet_med_fletteskemaer":"Flet med fletteskemaer...","flet_med_skema":"Flet med fletteskema","se_elevskema":"Se elevskema","vælg_skema":"Vælg skema:"},"group_hours":{"total":"Total","type":"Type"},"merge":{"dette_skema_er_flettet_ind_i":"Dette skema er flettet ind i:","hvis_du_vil_slette_dette_fletteskema_skal_du_først":"Hvis du vil slette dette fletteskema skal du først fjerne indfletningen i ovenstående skemaer.","vælg_kalender":"Vælg kalender:"},"merge_with_selector":{"flet":"Flet ind"},"new":{"nyt_fletteskema":"Nyt fletteskema","opret_fletteskema":"Opret fletteskema"},"public":{"mobile_guide":"Guide til at vise skema på mobil og tablets.","print_in_black_white":"Print uden farve","printing_guide":"Guide til print","se_skemaet_på":"Se skemaet på"},"room":{"vælg_skema":"Vælg skema: "},"subject_hours":{"anden_tid_i_perioden":"Anden tid i perioden","er_du_tilknyttet":"Er du tilknyttet flere brikker i samme tidsrum? Din optælling fordeles ligeligt på de viste brikker.","flextid_for_året":"Flextid for året","fravær_i_perioden":"Fravær i perioden","til":"til","timer":"timer","undervisning_i_perioden":"Undervisning i perioden"},"user":{"apple_kalender":"Apple Kalender","google_kalender":"Google Kalender","google_opdaterer_kalenderen_ca_tre_gange_i_døgnet":"Google opdaterer kalenderen ca. tre gange i døgnet.","ical":"iCal","kopiér_webaddresen_herunder_og_kopier_den_ind_i_den_eksterne_kalender_hvor_du_gerne_vil_have_den":"Kopiér webaddresen herunder og kopier den ind i den eksterne kalender, hvor du gerne vil have den vist.","outlook":"Outlook","se_evt_guides_nedenfor_i_forhold_til_hvordan_du_skal_gøre":"Se evt. guides nedenfor i forhold til hvordan du skal gøre.","siden":"siden.","sidst_hentet":"Sidst hentet","tilføj_dit_skema_til_ekstern_kalender":"Tilføj dit skema til ekstern kalender","vælg_kalender":"Vælg kalender: "},"user_hours":{"undervisningstid":"Undervisningstid"},"week_note":{"week_notes":"Ugenotater"},"week_plan":{"content":"Indhold","internal_notes":"Vikarnoter","learning_goal":"Læringsmål","pupil_preparation":"Elevforberedelse","subject":"Fag"},"week_plan_and_note":{"week":"Uge","week_plan":"Ugeplan"}},"controllers":{"ws":{"events":{"you_are_no_longer_substitute":"%{creator} fjernede dig som vikar i %{subject} i %{klass}, %{time}","you_are_substitute":"%{creator} gjorde dig til vikar i %{subject} i %{klass}, %{time}"}}},"da_only":{"add_user_with_uni":"Tilføj bruger(e) med UNI-Login","click_to_login_with_unilogin":"Klik her for at logge på med Uni-login","fictive_user_text":"Brugeren har en kalender og det vil være muligt at tilføje brugeren som underviser i skolens skemaer. Dette kan bruges til lærere som ikke er ansat endnu eller vikarer uden unilogin. Brugeren kan ikke logge på docendo.","guide_link_parentintra":"Guide til link i klassens forældreIntra","lærere_på_skoleintra":"Lærere på SkoleIntra","opdatér_profil_fra_uni-c":"Opdatér profil fra UNI-C","parent_portal":"ForældreIntra","show_tables_parentintra":"Vis skemaer i ForældreIntra","skriv_brikken_skoleintra":"Skriv hvad brikken hedder i SkoleIntra","uni_login":"UNI-Login","vis_skema_i_skoleintra":"Vis skema i SkoleIntra","website_portal":"Hjemmeside / Skoleporten"},"date":{"formats":{"iso":"%Y-%m-%d"}},"demo":{"firstlogin":{"kom_igang":"Kom igang med Docendo","velkommen":"Velkommen til docendo. Se introvideoen og klik kom igang, når du er klar."}},"devise":{"confirmations":{"new":{"resend_confirmation_instructions":"Send bekræftelsesinstruktioner"}},"failure":{"invited":"Du har en afventende invitation, accepter den for at få adgang."},"invitations":{"edit":{"header":"Vælg dit kodeord","password":"Kodeord","password_confirmation":"Bekræft kodeord","submit_button":"Sæt mit kodeord"},"invitation_removed":"Din invitation er blevet slettet.","invitation_token_invalid":"Invitationsnøglen er ikke gyldig.","new":{"header":"Send en invitation","submit_button":"Send invitation"},"no_invitations_remaining":"Ingen invitationer tilbage","send_instructions":"En invitation er blevet sendt til %{email}.","updated":"Dit kodeord er gemt. Du er nu logget ind.","updated_not_active":"Dit kodeord er gemt."},"mailer":{"confirmation_instructions":{"confirm_my_account":"Bekræft min konto","you_can_confirm_your_account_email_through_the_link_below":"Du kan bekræfte din konto-mail via linket nedenfor:"},"invitation_instructions":{"accept":"Acceptér invitation","accept_until":"Invitationen udløber %{due_date}.","contact_us":"Hvis du har spørgsmål, er du velkommen til at kontakte os på kontakt@docendo.dk","from_school":"Du er netop blevet inviteret til Docendo – Fleksibel Skemalægning på %{school_name}.","hello":"Hej %{email}","regards_html":"<p>Med venlig hilsen,<br/>\nDit Docendo Team<br/>\nhttps://docendo.dk</p>","someone_invited_you":"For at acceptere invitationen skal du klikke på dette link:","subject":"Instruktioner til invitation"},"reset_password_instructions":{"change_my_password":"Ændr mit password","change_password_link_requested":"Du kan ændre dit kodeord via linket herunder.","greeting":"Hej","wont_change":"Hvis du ikke gør noget vil dit kodeord ikke blive ændret."},"unlock_instructions":{"click_the_link_below_to_unlock_your_account":"Klik på linket nedenfor for at låse din konto op.","unlock_my_account":"Lås min konto op","your_account_has_been_locked_due_to_an_excessive_number_of_unsuccessful_sign_in_attempts":"Din konto er blevet låst grundet et stort antal forsøg på login."}},"passwords":{"edit":{"change_my_password":"Skift mit kodeord","change_your_password":"Skift dit kodeord","confirm_new_password":"Bekræft nyt kodeord","new_password":"Nyt kodeord"},"new":{"forgot_your_password":"Glemt dit kodeord?","send_me_reset_password_instructions":"Send mig instruktioner om nulstillelse af kodeord"}},"registrations":{"edit":{"are_you_sure":"Er du sikker?","cancel_my_account":"Afmeld min konto","current_password":"Nuværende kodeord","password":"kodeord","password_confirmation":"gentag kodeord","update":"Update"}},"sessions":{"new":{"brugernavn":"Brugernavn","create_a_free_trial":"Opret en gratis prøveperiode","kodeord":"Kodeord","log_ind":"Log ind","log_ind_med":"Log ind med Uni-login","log_ind_med_mail_og_kodeord":"Log ind med mail og kodeord","log_ind_på_docendo":"Log ind på docendo","no_account":"Har du ikke en konto?"}},"shared":{"links":{"didn":"Modtog ikke bekræftelses-instruktioner?","didn_2":"Modtog ikke unlock-instruktioner?","forgot_your_password":"Glemt dit kodeord?","sign_in":"Log ind","sign_up":"Sign up"}},"unlocks":{"new":{"resend_unlock_instructions":"Send unlock-instruktioner igen"}}},"events":{"event_debug":{"brugere":"Brugere: ","ejerkalender":"Ejerkalender: ","grupper":"Grupper: ","kalendre":"Kalendre: ","lokaler":"Lokaler: "},"replace_room":{"erstat_fremadrettet_på_dette_fag":"Erstat fremadrettet på dette fag","og_resten_af_året":" og resten af året?","på":" på"},"replace_user":{"erstat_fremadrettet_på_dette_fag":"Erstat fremadrettet på dette fag","klik_her_for_at_gå_til_kalenderen_for":"Klik her for at gå til kalenderen for","med":"Med:","og_resten_af_året":" og resten af året?","på":" på"},"show":{"agenda":"Agenda","agenda_placeholder":"F.eks: 1. Opfølgning fra sidst, 2. Oplæg fra...","content":"Indhold","decisions_and_resume":"Beslutninger og resumé","decisions_and_resume_placeholder":"F.eks.: Ulla undersøger med udskolingen om vi kan...","denne_lektion_tæller_som":"Denne lektion tæller som:","er_du_sikker":"Er du sikker?","external_links":"Mine læringsmål og forløb","find_vikar":"Find vikar","gå_til_kalender_for_denne_lektion":"Gå til kalender for denne lektion","internal_notes":"Vikarnoter","jump_to_calendar_for_event":"Hop til kalender for denne brik","learning_goal":"Læringsmål","location":"Lokale","meeting_purpose":"Formål med mødet","meeting_purpose_placeholder":"F.eks.: Vi skal være dygtige til...","only_visible_internally":"kun synligt for undervisere","pupil_preparation":"Elevforberedelse","slet_brik":"Slet brik","slet_fra_denne_kalender":"Slet kun i denne kalender","substitutes":"Vikarer","swappable_lessons":"Følgende lektioner kan byttes med den valgte lektion","søg_og_vælg":"Søg og vælg","søg_og_vælg_vikar":"Søg og vælg vikar","teachers":"Undervisere","undervisere_lokaler_noter":"Undervisere","vacant":"Underviser og lokale er ledige for nedenstående fag","vælg_klasser":"Vælg klasser","vælg_lokation":"Vælg lokale"},"show_public":{"agenda":"Agenda","content":"Indhold","decisions_and_resume":"Beslutninger og resumé","external_links":"Mine læringsmål og kurser","jump_to_calendar_for_event":"Hop til kalender for denne brik","learning_goal":"Hvad skal vi lære?","location":"Lokale","meeting_purpose":"Formål med mødet","pupil_preparation":"Elevforberedelse","substitutes":"Vikarer","teachers":"Undervisere"}},"groups":{"about":{"om":"Om"},"admin":{"assign_hours_employees":"Tildel timer til ansatte","classes_and_subjects":"på klasser og fag","more_tables":"se flere skemaer sammen","show_to_parents":"Vis for forældre","status":"tildeling og status","substitutes":"Vikarpulje","supplement":"Tillæg","year":"2016-2017"},"calendars_setup":{"copy_link":"Kopier link","copy_link_table_insert":"Kopier linket til det klasseskema, du gerne vil abonnere på - og indsæt det","docendo_extern_calendar":"Docendo-skemaer kan vises I eksterne kalendre. Kopier linket ud for skemaet nedenfor og indsæt det i den eksterne kalender. Følg slides til højre for hjælp til opsætningen.","find_in_google_cal":"Guide til integration i egen kalender","google_calendar":"Google Kalender","guide_integration_own_cal":"Guide til integration i egen kalender","guide_setup_schoolport":"Guide til opsætning på skoleporten","guide_setup_table_elevintra":"Guide til opsætning af skema i klassens ElevIntra","guide_step_copy":"Klik på ’kopiér link’ ud for skemaet, du vil sætte op - og følg guiden til højre.","ical_google_outlook":"iCal","integrate_tables":"Integrer skemaer i iCal, Google eller Outlook","links_for_each_class":"Ønsker I at vise skemaer for hver enkelt klasse på klassens ElevIntra, kan I benytte jer af linkene for hver klasse nedenfor.","outlook":"Outlook","parentintra_seperate_class":"Ønsker I at vise skemaer for hver enkelt klasse på klassens ForældreIntra, kan I benytte jer af linkene for hver klasse nedenfor.","show_table_selected":"Vis udvalgte skemaer på Skoleporten","show_tables_elevintra":"Vis skemaer på ElevIntra","substitutes_teachers_show_public":"Dagens fraværende","substitutes_teachers_show_public_explain":"Ønsker I at vise information om dagens fraværende på infoskærm, kan nedenstående link bruges til opsætningen.","text_set_x":"Kryds af nedenfor, hvilke skemaer I vil have vist via linket. Til højre finder I en guide til opsætning af skemaer på SkolePorten.","text_show_tables":"For at vise skemaer til elever og forældre kan I linke til skemaerne direkte fra jeres hjemmeside/Skoleporten med dette link:","vaelg_alle":"Vælg alle"},"create_klass":{"evt_vaelg":"Evt. vælg import af fag og timer svarende til klassetrinnet","import_af_fag":"Import af fag?","import_norm":"Ønsker du at importere og oprette fag med norm-timer fra UVM? Så vælg det klassetrin der passer til klassen her:","klassens_navn":"Klassens navn","opret_en_ny_klasse_for":"Opret en ny klasse","skriv_klassens_navn":"Skriv klassens navn"},"delete_popup":{"brikker_som_slettes_kun_fra_denne_kalender":"Brikker som slettes kun fra denne kalender","den_har":"Den har:","denne_handling_kan_ikke_fortrydes":"Denne handling kan ikke fortrydes!","indlæg_som_slettes":"indlæg som slettes","kalendere_som_slettes":"Kalendere som slettes","lektioner_i_kalenderen":"lektioner i kalenderen","medlemmer_som_ikke_længere_vil_kunne_bruge_gruppen":"medlemmer som ikke længere vil kunne bruge gruppen","skriv_slet_gruppen_herunder":"Skriv \"Slet gruppen\" herunder:","slet_gruppen":"Slet gruppen","uploadet":"uploadet"},"edit":{"redigér_gruppe":"Redigér gruppe"},"flextime":{"flextime":"Flextid","flextime_teacher_appear":"Kun lærere som har brugt flextid optræder i listen."},"flextime_activator":{"aktivering_af_flextid":"Aktivering af flextid","aktiveringen_giver_alle_ansatte_brikker_til_flextid_i_deres_egen_kalender":"Aktiveringen giver alle ansatte brikker til flextid i deres egen kalender.","aktivér_flextid":"Aktivér flextid"},"form":{"fejl_forhindrede_denne_gruppe_i_at_blive_gemt":" fejl forhindrede denne gruppe i at blive gemt:","skriv_hvad_gruppen_hedder":"Skriv hvad gruppen hedder","skriv_om_gruppen":"Skriv om gruppen"},"hours":{"press_empty_bricks":"Tryk i tomme felter for at oprette brikken i klassen."},"merge_calendars":{"merge_tables":"Fletteskemaer","new_merge_table":"Nyt fletteskema"},"mine":{"ikke_medlem_af_nogen_grupper_endnu":"Ikke medlem af nogen grupper endnu."},"multical":{"help_for_table":"Hjælp til skemaoverblik","today":"I dag","vaelg_klasse":"Vælg klasse","vaelg_lokale":"Vælg lokale","vaelg_person":"Vælg person"},"newother":{"fejl_forhindrede_denne_kalender_i_at_blive_gemt":" fejl forhindrede denne kalender i at blive gemt:","opret_anden_kalender":"Opret anden kalender","opret_kalender":"Opret kalender","skriv_evt_kalen":"Skriv evt. noget om kalenderen","skriv_hvad_kalen":"Skriv hvad kalenderen skal hedde..."},"pay_supplement":{"get":"Hent","minutes":"Minutter","show_supplement":"Vis tillæg","supplement_type":"Tillægstype"},"school":{"video":"Video"},"schools":{"vælg_skole":"Vælg skole"},"show":{"bliv_medlem":"Bliv medlem","class_year":"klasse/årgang","filer":"Filer:","forlad_gruppen":"Forlad gruppen","gruppen":"gruppen...","indlæg":"Indlæg:","opret_team":"Opret team"},"substitute_pool":{"details":"Detaljer","hours":"timer","mistakes_look":"fejl, se nedenfor","notice":"Bemærk","notice_list_item_1":"Vikartimer tælles med i det samlede antal undervisningstimer for underviseren","notice_list_item_2":"Vikartimer vil i underviserens egen kalender være angivet som det fag, der vikaries i - f.eks. \"Dansk\"","pool":"Pulje","rest":"Rest","substitute_hours_per_month":"Vikartimer brugt pr. måned","substitute_overview":"Vikaroverblik","there_was":"Der var","total_substitute_pool":"Total vikarpulje:","total_used_substitute_hours":"Total brugte vikartimer:","total_used_substitute_hours ":"Total brugte vikartimer:","used":"Brugt","vis_timer":"Vis timer"},"users":{"ical":"ical:","initials":"Initialer","users":"Brugere"}},"import":{"csv_overview":{"i_fil":"I fil:","ikke-fundne_klasser_oprettes_i_skoleåret_hvor_der_importeres_til":"Ikke-fundne klasser oprettes i skoleåret hvor der importeres til","ikke-fundne_lokaler_oprettes":"Ikke-fundne lokaler oprettes","ikke-fundne_lærere_oprettes_med_initialer":"Ikke-fundne lærere oprettes med initialer","ikke_fundet":"Ikke fundet","import":"Import","kontrollér_at_disse_er_rigtige":"Kontrollér at disse er rigtige","lagt_sammen":"Lagt sammen: ","lokaler":"Lokaler","lærerer":"Lærere","ringetider":"Ringetider","til_uge":"Til uge: "},"result":{"der_var_nogle_fejl":"Der var nogle fejl","import_afsluttet":"Import afsluttet","ingen_fejl_i_import":"Ingen fejl i import"}},"jobs":{"copy_events_year_job":{"calendar_is_copied":"Kalenderen %{calendar_name} er kopieret"}},"js":{"all_day":"Hele dagen","calculating_and_controlling":"Indsætter, beregner og kontrollerer for kollisioner...","changes_may_not_be_saved":"Ændringer, du har foretaget, gemmes muligvis ikke","click_keyboard_shortcuts_to_copy":"Klik ⌘ + C for at kopiere","close_without_saving":"Vil du lukke uden at gemme?","copied":"Kopieret","error_occured":"Der er opstået en fejl."},"layouts":{"application":{"dage":"dage","der_er_ikke":"Der er ikke forbindelse til docendo. Dette kan skyldes at du ikke har forbindelse til internettet.","din_profil":"Din profil","hjem":"Hjem","kurser":"Kurser","køb_nu":"Køb nu","log_ud":"Log ud","profil":"Profil","prøveperiode_slutter_om":"Prøveperiode slutter om","skal_slettes_for_sig_selv":"skal slettes for sig selv.","skift_kodeord":"Skift kodeord","slet_indlæg":"Slet indlæg","soeg":"Søg","vil_du_deaktivere":"Vil du deaktivere skolen?","Ønsker_du_at_slette_dit_indlæg":"Ønsker du at slette dit indlæg?"},"blank":{"der_er_ikke":"Der er ikke"},"devise":{"book_en_gratis_demo":"Book en gratis demo","docendodk":"docendo.dk","kontakt":"kontakt","log_ind_med":"Log ind med","log_ind_med_email":"Log ind med email","login":"Login","med_en_fuldt_integreret":"Med en fuldt integreret","om_docendo":"Om Docendo","om_os":"om os","tlf_70_40_02_10":"Tlf. 70 40 02 10","udviklet_i_samarbejde_med_ledere_lærere_og_pædagoger":"Udviklet i samarbejde med ledere","uni":"UNI"},"public":{"skal_slettes_for_sig_selv":"skal slettes for sig selv.","slet_indlæg":"Slet indlæg","Ønsker_du_at_slette_dit_indlæg":"Ønsker du at slette dit indlæg?"},"schools":{"users":{"create_user_by_alias":"Opret fiktiv bruger","create_user_by_email":"Opret bruger med email","create_user_by_unilogin":"Opret bruger med unilogin","merge_users":"Læg brugerprofiler sammen","transfer_calendar":"Overtag skema i periode"}}},"materials":{"details":{"antal_downloads":"Antal downloads:","beskrivelse":"Beskrivelse:","detaljer_om_filen":"Detaljer om filen","dialog_om_filen":"Dialog om filen","dokumenttype":"Dokumenttype:","klassetrin":"Klassetrin:","status":"Status:","uploadet_af":"Uploadet af: "},"edit":{"redigér_fil":"Redigér fil","vis":"Vis"},"form":{"dit_materiale_er_gemt":"Dit materiale er gemt","fejl_forhindrede_dette_materiale_i_at_blive_gemt":" fejl forhindrede dette materiale i at blive gemt:","filnavn":"Filnavn: ","gem_materiale":"Gem materiale","skriv_noget_relevant":"Skriv noget relevant","titel_på_fil":"Titel på fil","venligst_udfyld_nogle_informationer_om_materialet":"Venligst udfyld nogle informationer om materialet","vælg_dine_fag":"Vælg dine fag","vælg_dokumenttype":"Vælg dokumenttype(r)...","vælg_dokumenttyper":"Vælg dokumenttyper","vælg_klassetrin":"Vælg klassetrin","vælg_status":"Vælg status"},"index":{"antal_hentede":"Antal hentede","klassetrin":"Klassetrin"},"material":{"fra":"fra","mere_info":"Mere info","uploadet_af":"uploadet af"},"new":{"gem_materiale":"Gem materiale"},"new1":{"attach_files":"Vedhæft materiale"},"popedit":{"dit_materiale_er_gemt":"Dit materiale er gemt","erstat_materiale":"Erstat materiale:","fejl_forhindrede_dette_materiale_i_at_blive_gemt":"fejl forhindrede dette materiale i at blive gemt:","gem_materiale":"Gem materiale","giv_nogle_informationer_om_materialet":"Giv nogle informationer om materialet","vælg_dine_fag":"Vælg dine fag","vælg_dokument":"Vælg dokumenttyper","vælg_klassetrin":"Vælg klasse","vælg_status":"Vælg status"},"show":{"beskrivelse":"Beskrivelse:","group":"Gruppe:","post":"Post:","tags":"Tags: ","user":"Bruger:"},"sidebar":{"nyeste":"Nyeste","populære":"Populære","se_alle":"Se alle"},"upload":{"del_et_materiale":"Del et materiale","upload":"upload.","vælg_et_dokument":"Vælg et dokument"}},"models":{"calendar":{"beregn_timer":"Beregn timer","flex_ind":"Flex ind","flex_ud":"Flex ud"},"group":{"alle":"Alle","already_created":"er allerede oprettet","share_with":"Del med","skolen":"Skolen","team":"Team","ukendt":"ukendt"},"group_school":{"importerede":"Importerede","med":"med","oprettede_klasse":"Oprettede klasse","oprettede_lærer":"Oprettede lærer","uden_lærer_i":"uden lærer i"},"import_lesson":{"invalid":"Ugyldig"},"material":{"skal_vælges":"skal vælges"},"pay_supplement_rule_school_camp":{"lejrskole":"Lejrskole"},"pay_supplement_rule_substitute":{"ekstern_vikar":"Ekstern vikar"},"post":{"synes_godt_om":"Synes godt om"},"subject_period":{"timer_uge":"Timer/uge"},"user":{"ukendt":"ukendt"}},"notifications":{"form":{"indhold":"Indhold:","link_https__skal_tilføjes_hvis_linket_er_eksternt":"Link: ('https://' skal tilføjes, hvis linket er eksternt)","notifikationer":"Notifikationer","overskrift":"Overskrift:"},"index":{"notifikationer":"Notifikationer","opret_ny":"Opret ny","siden":"siden"},"notification":{"siden":"siden"},"show":{"brugere":"brugere","link":"Link: ","læst_af":"Læst af","notifikationer":"Notifikationer","sendt_til":"Synlig for","sidst_opdateret":"Sidst opdateret: ","skrevet_af":"Skrevet af"}},"posts":{"edit":{"redigér_indlæg":"Redigér indlæg","vis":"Vis"},"form":{"del_noget":"Del noget...","fejl_forhindrede":"fejl forhindrede dette indlæg i at blive gemt","tilføj_kommentar":"Tilføj kommentar..."},"new":{"nyt_indlæg":"Nyt indlæg"},"post":{"antal_downloads":"Antal downloads","comments":"Kommentarer","from":"fra","show":"Vis","since_in_group":"siden i gruppen","slet_indlæg":"Slet indlæg"},"show":{"bruger":"Bruger:","indhold":"Indhold:"}},"rack_dev_mark":{"development":"development"},"repitition":{"add":"Tilføj","administration":"Administration","aktivitet":"Aktivitet","all_calendars":"alle kalendere","annuller":"Annuller","archive":"Arkivér","brikker":"Brikker","brugeradministration":"Brugeradministration","calendaradministration":"Kalenderadministration","choose":"Vælg","chooselanguage":"Vælg sprog","create":"Opret","dagens_fraværende":"Dagens fraværende","dagens_vikarer":"Dagens vikarer","dearchive":"Dearkivér","delete":"Slet","deleting":"Sletter","din_kalender":"Din kalender","docendo":"Docendo - fleksibel skemalægning","email":"Email","enddate":"Slut dato","endtime":"Sluttidspunkt","errors":"fejl","fag":"Fag","feriekalender":"Feriekalender","fjern":"Fjern","fjern_brugere":"Fjern brugere","flextidsoversigt":"Flextidsoversigt","fra_og_med":"fra og med","from":"fra","gem":"Gem","hour":"time","kalender":"Kalender","klass":"klasse","klasser":"Klasser","klasser_lille":"klasser","kr":"kr","langfravær":"Længerevarende fravær","lesson":"lektionen","luk":"Luk","materialer":"Materialer","medlem":"medlem","medlemmer":"medlemmer","merge_calendar":"fletteskema","merge_calendars":"fletteskemaer","målstyring":"Målstyring","navn":"Navn","none":"Ingen","opgaveoversigt":"Opgaveoversigt","opret":"Opret","opret_brik":"Opret brik","opret_fraværsgrund":" Opret fravær","opret_tilføj_bruger":"Opret/tilføj bruger","oprettet":"Oprettet:","other_calendar":"anden kalender","other_calendars":"andre kalendere","planlægning":"Planlægning","processing":"Behandler","rediger":"Redigér","replace":"Erstat","replace_lesson":"Erstat lektion","room":"lokale","rooms":"lokaler","se_kalender":"Se kalender","search":"søg","search_for":"søg på","select_user":"Vælg bruger","send":"Send","show":"Vis","skema":"Skema","skemaoverblik":"Skemaoverblik","skole":"Skole","skoler":"Skoler","skoleår":"Skoleår","skriv":"Skriv...","startdate":"Start dato","starttime":"Starttidspunkt","substitute":"Vikardækning","superadmin":"Superadmin","support":"Support","swap":"byt","swap_lesson":"Byt lektion","tilbage":"Tilbage","tildel_timer":"Tildel timer","timefordeling":"Timefordeling","timer":"Timer","timeudtraek":"Timeudtræk","titel":"Titel","today":"I dag","unauthorized_access":{"help":"Din bruger er ikke tilknyttet en aktiv skole på Docendo. Mener du, dette er en fejl, bedes du kontakte din skoles administration for at blive tilknyttet skolen.","no_access":"Du har ingen adgang."},"until":"til","user":"bruger","users":"brugere","vikardækning":"Vikardækning","vikarpuljer":"Vikarpuljer","vis_skemaer_til_elever":"Ekstern visning","with":"med","yearplan":"Årsplanlægning","Årsoverblik":"Årsoverblik","år":"År","årsplanlægning":"Årsplanlægning"},"rooms":{"create_room":"Opret lokale","edit":{"er_du_sikker":"Er du sikker?","redigér_lokale":"Redigér lokale","slet_lokale":"Slet lokale"},"form":{"fejl_forhindrede_dette_lokale_i_at_blive_gemt":"fejl forhindrede dette lokale i at blive gemt:"},"new":{"nyt_lokale":"Nyt lokale"},"room_is_not_created":"Lokalet findes ikke","rooms":{"new_room":"Nyt lokale","rooms":"Lokaler"}},"schools":{"calendar_transfers":{"new":{"activity_count":"Aktiviteter","from_date":"Fra dato","have_calendar":"Har skema","including_both":"begge inklusive","period":"Periode","receive_calendar":"Skal overtage skema","replacee_in_period":"Fraværende i perioden","replacement_in_period":"Overtager i perioden","title":"Lad en bruger overtage en anden brugers skema i en periode, f.eks. ved barsel eller længerevarende fravær.","to_date":"Til dato","transfer":"Overfør","transfer_calendar_for_a_period":"Overtag skema i periode","warning":"Overtagelse af skema kan ikke fortrydes."}},"onboarding":{"administration_and_counting":"Administration og tælling","assign_user_hours":"Tildel timer til undervisere","create_calendars":"Opret kalendere","create_classes":"Opret klasser","create_fixed_hours":"Opret faste bånd","create_merge_calendars":"Opret fletteskemaer","create_other_calendars":"Opret andre kalendere","create_rooms":"Opret lokaler","create_school_year":"Opret skoleår","create_teachers":"Opret undervisere","create_your_school":"Opsætning af din skole i Docendo","follow_the_steps":"Følg trinene herunder for at komme godt i gang med jeres skemalægning","import_of_schedules":"Import af skemaer?","import_of_schedules_content":"Hvis I ønsker det, kan vi også importere jeres nuværende skemaer fra SkoleIntra eller Tabulex. Send en email til vores kundesupport, hvor I skriver jeres ringetider og vedhæfter jeres skemafiler.","make_room_bindings":"Evt. lav lokalebindinger","scheduling_classes_calendars":"Skemalægning i elevskemaer","select_vacationdays":"Indtast feriedage","show_calendars_to_students":"Vis skemaer til elever og forældre","student_scheduling":"Læg klassernes skemaer","user_tasks":"Opgaveoversigt til undervisere"},"user_merges":{"new":{"merge_on_this_user":"Sammenlæg på denne bruger","title":"Læg to brugere sammen – f.eks. i tilfælde af to ens brugere, eller hvis en bruger uden login skal erstattes med en bruger med login. Alle skemaaktiviteter samles på én bruger.","warning":"Sammenlægningen kan ikke fortrydes."}},"users":{"index":{"actions":"Handlinger","help":"Tryk på billedet for at indsætte et nyt. Initialer kan redigeres.","photo":"Foto"},"user":{"invite":"Invitér","remove":"Fjern"}}},"search":{"post":{"siden_i_gruppen":"siden i gruppen"},"search_content_type_filter":{"alle":"Alle","grupper":"Grupper","opdateringer":"Opdateringer","profiler":"Profiler","vis_resultater_for":"Vis resultater for"},"search_filter":{"filtre":"Filtre","type_af_materiale":"Type af materiale","vælg_dine_fag":"Vælg dine fag","vælg_dokumenttyper":"Vælg dokumenttyper","vælg_fag":"Vælg fag","vælg_klassetrin":"Vælg klassetrin","vælg_status":"Vælg status"},"search_results":{"antal_hentede":"Antal hentede","grupper":"Grupper","klassetrin":"Klassetrin","none":"Desværre - vi kunne ikke finde noget","opdateringer":"Opdateringer","profiler":"Profiler","viser_Res_for":"Viser resultater for"}},"sidebars":{"get_started_new_year":{"assign_hours_employees":"Tildel timer til ansatte","follow_steps":"Følg trinene herunder","get_started":"Kom i gang","other_calendars":"andre kalendere","time_distribution":"Timefordeling på klasser"},"school":{"other_calendars":"Andre kalendere (fx. teamkalender)"},"substitution_links":{"assign_substitutes":"tildel dagens vikarer","substitute_cover":"Vikardæk"}},"signups":{"by_existing_users":{"new":{"already_user":"Bruger din skole allerede Docendo, men du kan ikke få adgang? Kontakt din skoles kontor for at få adgang.","try_free":"Prøv Docendo - gratis i 14 dage"}},"new":{"create_signup":"Opret","i_accept":"Jeg accepterer","password_rule":"(mindst 8 tegn)","signup":"Opret 14 dages prøveperiode","terms_of_service":"betingelserne"}},"subject_periods":{"edit":{"antal_uger":"Antal uger","fordel_timer_i_perioden":"Fordel timer i perioden","opdatér":"Opdatér","skoledage_i_perioden":"Skoledage i perioden","slet":"Slet","timer_i_perioden":"Timer i perioden"}},"subjects":{"edit":{"arkiver":"Arkivér","arkiver_denne_brik_den_vil_ikke_længere_være_synlig":"Arkivér denne brik? Den vil ikke længere være synlig.","arkiverer":"Arkiverer...","er_du_sikker":"Er du sikker?","redigér_brik":"Redigér brik","slet_brik":"Slet brik","vil_du_arkivere_denne_brik":"Vil du arkivere denne brik? Den vil ikke længere være synlig.  Brikker der er lagt i skemaer forbliver."},"inner_edit":{"absence":"Fravær","absence_description":"sygdom, ferie etc.","anden_tid":"Anden tid","anden_tid_description":"ikke undervisning.","antal_minutter_modul":"Skriv hvor mange minutter et modul normalt varer","antal_timer_på_år":"Skriv hvor mange timer, der skal bruges i løbet af i år...","bevægelse":"Bevægelse","bevægelse_description":"tæller 100 % og uafhængigt af andre brikker i samme tidsrum.","fag":"Fag","fag_description":"tæller timer for klassen. To samtidige brikker tæller halvt.","fejl_forhindrede_denne_brik_i_at_blive_gemt":"fejl forhindrede denne brik i at blive gemt","frame":"Temavisning (Ramme)","frame_description":"kan bruges til at markere temaer og anderledes dage i skemaet. Brikken er synlig for elever/forældre, mens fag-brikker, der ligger samtidig med tema-brikken, ikke er synlige. Fagbrikker tæller 100% i tidsrummet, og temabrikken tæller ikke.","klasser_andre_kalendre":"Klasser/Andre kalendre","lokation":"Lokation","normal_varighed_i_minutter":"Normal varighed (i minutter)","oovrig_tid":"Øvrig tid","oovrig_tid_description":"ikke undervisning, ikke elev-relateret.","optional":"Valgfag/hold","optional_description":"tæller 100 % og uafhængigt af andre brikker i samme tidsrum.","pause":"Pause","pause_description":"andre lektioner bør ikke overlappe med en pause.","ressource":"Ressource","ressource_description":"bruges til at markere ressourcer i skemaet. Tæller ikke fra andre brikker. Vises som standard ikke i elev- og forældreskema.","skriv_et_bogstav_for_at_søge":"Skriv et bogstav for at søge...","skriv_hvad_brikken_hedder":"Skriv hvad brikken hedder...","sygdom_ferie_etc":"sygdom, ferie etc.","timer_på_årsbasis":"Timer (i skoleåret)","underviser":"Underviser","uuv":"UUV","uuv_description":" tæller selvstændigt på understøttende undervisning.","vælg_briktype":"Vælg briktype","vælg_farve":"Vælg farve","vælg_klasser":"Søg og vælg klasser"},"new":{"ny_brik":"Ny brik"},"subject_accordion_menu":{"absence":"Fravær","break":"Pause","exercise":"Bevægelse","flextime":"Flextid","frame":"Temavisning (Ramme)","optional":"Valgfag/hold","other_stuff":"Øvrig tid","other_tasks":"Andre opgaver","pay_supplement":"Tillæg","person_resource":"Undervisningsressourcer","resource":"Ressource","subject":"Fag","supplemental":"Understøttende undervisning"},"subject_draggable":{"hours_per_year":"t/år","per_week":"/uge"},"ws_edit":{"er_du_sikker":"Er du sikker?","opdater_brik":"Opdater brik","redigér_brik":"Redigér brik","slet_brik":"Slet brik"}},"substitutes":{"edit":{"i_dag":"i dag","ingen_lektioner_for":"Ingen lektioner for ","klasse":"Klasse","også_tilknyttet":"Også tilknyttet","se_alle":"Se alle","se_mindre":"Se mindre","søg_og_vælg":"Søg og vælg","vikar":"Vikar","vikar_for":"Vikar for","vikarnoter":"Vikarnoter"},"known_absence":{"byt":"Byt","feriedage":"Feriedage","fraværende_med_lektioner":"Fraværende med lektioner","kalenderen_for_7b":"Kalenderen for 7.b","kursus":"Kursus","lektioner":"lektioner","lektioner_der_kan_byttes_med":"Lektioner der kan byttes med:","lektioner_der_skal_håndteres":"Lektioner der skal håndteres:","opret_fravær":"Opret fravær","opret_planlagt_fravær":"Opret planlagt fravær","syg":"Syg"},"substitute_day":{"klasse":"Klasse"},"substitutes_edit":{"fraværsårsager_og_skemaoverblik":"Fraværsårsager og skemaoverblik","tilføj_kalendre":"Tilføj kalendre","vælg_klasse":"Vælg klasse","vælg_lokale":"Vælg lokale","vælg_person":"Vælg person","vælg_person_vikardækning":"Vælg person(er)"},"substitutes_show":{"ingen_vikarer_i_dag":"Ingen vikarer i dag"},"substitutes_show_teachers":{"ingen_fraværende_i_dag":"Ingen fraværende i dag"}},"time":{"formats":{"day_only":"%A","devise":{"mailer":{"invitation_instructions":{"accept_until_format":"d. %B %d, %Y %I:%M"}}},"time_only":"%H:%M"}},"unilogin":{"welcome":{"create_a_trial":"Vil du oprette en prøveperiode?","eller":"eller","enten_giver_din_stilling_dig_ikke_mulighed_for_at_kigge_med_eller_også_er_din_skole_er_ikke_på_docendo_endnu":"Enten giver din stilling dig ikke mulighed for at kigge med eller også er din skole er ikke på docendo endnu.","hvis_du_vil_have_din_skole_på_docendo_så":"Hvis du vil have din skole på Docendo så","kontakt_os":"kontakt os","prøv_en_demoperiode":"opret en gratis prøveperiode","student_or_parent":"Er du elev eller forælder?","student_or_parent_info":"Leder du efter dit eller dit barns klasseskema, skal dette typisk findes på skolens Elev-/ForældreIntra eller på skolens hjemmeside. Vi anbefaler, at du kontakter skolens administration, hvis du ikke har adgang til skemaerne.","velkommen":"Velkommen"}},"users":{"assign_user_hours":{"anden_tid":"Anden tid","der_var":"Der var","fejl_se_nedenfor":"fejl. Se nedenfor","lommeregner":"Lommeregner","skemalagt":"Skemalagt","tildeling_af_timer":"Tildeling af timer","tildelt":"Tildelt","total_på_år":"Total på år","undervisning":"Undervisning","Øvrig_tid":"Øvrig tid"},"create":{"add_user":"Opret/tilføj bruger","add_user_with_uni":"Tilføj bruger(e) med UNI-Login","create_teacher":"Opret underviser","fictive_user":"Fiktiv bruger","fictive_user_text":"Brugeren har en kalender og det vil være muligt at tilføje brugeren som underviser i skolens skemaer. Dette kan bruges til lærere som ikke er ansat endnu eller vikarer uden unilogin. Brugeren kan ikke logge på docendo.","notify_user_more_users":"Du skal selv give brugerne besked om tilføjelsen. Du kan skrive flere brugernavne i feltet herunder, adskil med mellemrum.","user_does_not_exist":"Underviseren eksisterer ikke","user_with_email":"Bruger med email","user_with_email_text":"Bruges til at oprette brugere med email. Brugeren kan logge ind med mail og kodeord. Der bliver sendt en mail til brugeren med instruktioner."},"edit":{"annullér":"Annullér","redigér_bruger":"Redigér bruger"},"files_for_download":{"files_to_download":"Filer til download"},"form":{"andre_undervisere_vide":"Hvad kan andre undervisere have brug for at vide om dig?","beskrivelse":"Beskrivelse","du_kan_skrive_om_dine_interesser_fag_klassetrin_færdigheder_etc":"Du kan skrive om dine interesser","email":"E-mail","fejl_forhindrede_denne_bruger_i_at_blive_gemt":"fejl forhindrede denne bruger i at blive gemt:","fjern_profilbillede":"Fjern profilbillede","hvilke_fag":"Hvilke fag","hvilke_klassetrin_underviser":"(Hvilke klassetrin underviser du?)","initialer":"Initialer","initialer_på_skolen":"Initialer på skolen","klassetrin":"Klassetrin","opdatér_profil_fra_uni-c":"Opdatér profil fra UNI-C","profilbillede":"Profilbillede","skriv_dit_navn":"Skriv dit navn","upload_nyt_profilbillede":"Upload nyt profilbillede?","vælg_dine_fag":"Vælg dine fag","vælg_dine_klassetrin":"Vælg dine klassetrin"},"hours":{"skoleåret":"Skoleåret"},"hours_list":{"_vikartimer":"vikartimer","min":"min","vikartimer":"Vikartimer"},"hours_status":{"anden_tid":"Anden tid","ingen_data":"Ingen data","tildelt":"Tildelt","undervisning":"Undervisning","øvrig_tid":"Øvrig tid"},"list_all":{"alle":"Alle"},"members":{"personale":"Personale","se_alle":"Se alle"},"net_promoter_scores":{"new":{"nps_question":"Hvor sandsynligt er det, at du vil anbefale docendo til en ven eller kollega?","question_one":"Hvad er den vigtigste årsag til den karakter, du gav?","reason":"Vi bygger et skemalægningsprogram til mennesker. Og det er svært at gøre godt - medmindre at dig der bruger det, fortæller os, hvordan du synes, at vi skal gøre det. Vi håber derfor, at du vil hjælpe os ved at besvare de følgende to spørgsmål.","very_likely":"Meget sandsynligt","very_unlikely":"Ikke sandsynligt"}},"password":{"bekræft_nyt_kodeord":"Bekræft nyt kodeord","fejl":" fejl:","nyt_kodeord":"Nyt kodeord","skift_kodeord":"Skift kodeord"},"profile":{"klassetrin":"Klassetrin","om_mig":"Om mig","underviser_i":"Underviser i"},"remove_users_list":{"delete_user":"Fjern bruger","press_remove_to_remove":"Klik 'fjern' for at fjerne en bruger fra skolen.","remove_list_item_1":"Når en bruger bliver fjernet har vedkommende ikke længere adgang til skolens grupper eller kalendere. ","remove_list_item_2":"Brugeren bliver ikke fjernet fra lektionerne på skolen.","remove_list_item_3":"Brugeren bliver ikke slettet fra docendo men har blot ikke adgang til skolen længere."},"show":{"aktivitet":"Aktivitet","filer":"Filer:","grupper":"Grupper","indlæg":"Indlæg:","medlem_i":"Medlem i:"},"si_teachers_list":{"træk_læreren_fra_venstre_til_højre_for_at_tildele_initialer":"Træk læreren fra venstre til højre for at tildele initialer"},"substitute":{"følgene_lærere_er_ledige_i_tidsrummet":"Følgende lærere er ledige i tidsrummet","ingen_lærere_er_ledige_i_tidsrummet":"Ingen lærere er ledige i tidsrummet","kl":"kl.","vælg_vikar":"Vælg vikar"},"tasks_status":{"fag_opgave":"Fag/opgave","lagt_i_skema":"Lagt i skema","tildelt":"Tildelt","tilhører":"Tilhører","total":"Total"},"user_item_abandoned_user":{"grupper":"Grupper: ","indlæg":"Indlæg: ","kalenderaftaler":"Kalenderaftaler: ","material_count":"Material count: "},"user_item_profile_calendar_lastseen":{"se_profil":"Se profil","se_tildeling":"Se tildeling"},"user_item_remove_user":{"delete_user":"Slet bruger"},"user_item_select_substitute":{"vælg_som_vikar":"Vælg som vikar"},"user_merge_details":{"aftaler":"Skemalagte aktiviteter","groups":"Skoler"}},"views":{"pagination":{"first":"Første","last":"Sidste","next":"Næste","previous":"Tidligere","truncate":"..."}},"vue":{"buy":{"a_user_is":"En bruger er en medarbejder som har en kalender og/eller et login, dvs. en underviser, en pædagog, en vikar o.lign.","billed_monthly_or_yearly":"Vil du faktureres månedligt eller årligt?","buy":"Køb","buy_access_for_school_users":"Køb adgang til skolens brugere","call_us_at":"Ring til","choose_the_right_price":"Vælg den rette pris for jer","discount":"Rabat","error":"Fejl","go_to_home":"Klik her for at gå til forsiden","institution":"institution","missing_inputs":"Du mangler at udfylde nogle felter","month":"måned","only_pay_per":"Betal kun for de brugere, der skal kunne skemalægges og/eller have et login","pay_for_unlimited_users_and_get":"Betal for skolens samlede elevtal - og få et ubegrænset antal brugere på","payment_info":"Betalingsinfo","per_month":"Pr. måned","per_student":"pr. elev","per_user":"pr. bruger","per_year":"Pr. år","popular":"populær","price":"pris","questions":"Spørgsmål","save_2":"Spar 2%","school_name":"Skolens navn","subscription_info":"Abonnementsinfo","thanks_for_buying":"Tak for dit køb.","total":"Total","total_student_number":"Skolens samlede elevtal","unlimited":"Ubegrænset","write_number_of_students":"Skriv skolens samlede elevtal - og få ubegrænset antal brugere på *","write_number_of_users":"Skriv det antal brugere, som skal kunne skemalægges og/eller have et login *","your_email":"Din email","your_invoice":"Din faktura","your_name":"Dit navn","your_phonenumber":"Dit telefonnummer"},"deleteday":{"delete_day_or_week":"Slet dag/ugen","whole_week":"Hele ugen"},"intro_home":{"step1_title":"Velkommen til Docendo","step3_title":"Navigation til alle funktioner","step4_content":"Her kan du finde navigationen til alle skemaer, lokaler og personalekalendere i Docendo","step4_title":"Navigation til alle skemaer og kalendere","step5_content":"Vi har på forhånd udfyldt et klasseskema (4A - DEMO), som du kan redigere i, så du hurtigt kan få en fornemmelse af mulighederne i Docendo. Slå dig løs!","step5_title":"Se et demo-klasseskema"},"public":{"app":{"sidenav":{"changeview":"Skift visning","showday":"Vis dag","showweek":"Vis uge","showweekplan":"Vis ugeplan"}},"no_notes":"Ingen noter til ugen"},"recent_users":{"last_seen":"sidst set","never_logged_in":"aldrig været logget ind"},"sidenav":{"merge_calendar_special":"flette-skemaer"},"vacations_days_selector":{"choose_period":"Vælg periode","school_days":"skoledage","school_year":"Skoleår","vacation_for_pupils":"Feriekalender for elever"},"year_planning":{"distribute_hours_over_year":"Fordel timer i perioden","hours_during_period":"Timer i perioden","norm":"Norm","number_of_weeks":"Antal uger","planned":"Planlagt","school_days_during_period":"Skoledage i perioden"}}}}

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

	module.exports = {"copycalendar":{"copy":"Kopier","paste":"Indsæt","pasteThisWeek":"Indsæt i denne uge","weekSelected":"uge valgt","weeksSelected":"uger valgt","markWeeksFrom":"Markér uger fra","allWeeks":"Alle uger","oddWeeks":"Ulige uger","evenWeeks":"Lige uger","unselectAll":"Fravælg alle","deleteLessonsInSelectedWeeks":"Slet og erstat lektioner i de valgte uger","absenceWillNotBeDeleted":"fravær slettes ikke","noticationMessage":"Kopieringen er i gang. Det kan tage nogle minutter. Du kan i mellemtiden arbejde i andre skemaer.","copiedFrom":"Kopieret fra","noSubstitutesOrNotes":"Der er ingen lektioner med vikarer eller noter i de valgte uger","youAreAboutToDelete":"Du er ved at slette,","lesson":"lektion","lessons":"lektioner","withSubstitutesOrNotes":"med vikarer eller noter","week":"Uge"},"homevideoes":{"video":"Video","video_guide":"Videoguides","introduction":"Introduktion til Docendo","watch_intro":"Se introduktion til docendo","klass_schedule":"Klasseskema","klass_schedule_overview":"Overblik over klasseskemaet","teacher_calendar":"Underviserkalender","teacher_calendar_overview":"Rundtur i underviserens kalender","notes_weekplan":"Noter & ugeplan","notes_weekplan_overview":"Udnyt noter & ugeplaner","learn_to_substitute":"Lær at vikardække med Docendo"},"vSelect":{"choose_persons":"Vælg person(er)"},"substitute_hours":{"title":"Timeudtræk for undervisere og vikarer","choose_period":"Vælg periode","all":"Alle","teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","choose_persons":"Vælg person(er)","work_days":"arbejdsdage","calendar_event":"kalenderaktivitet","calendar_events":"kalenderaktiviteter","substitute_for":"Vikar for","substitute_hour":"Vikartime","other_tasks":"Andre opgaver","other_stuff":"Øvrig tid","total":"Total","hours":"timer","hour":"time","min":"min","shortcuts":"Genveje","show_all_absent":"Vis alle fraværende i perioden","getting_all":"Henter alle","absent_in_the_period":"fraværende i perioden","there_is_no_one_absent":"Der er ingen fraværende i perioden","days_with_absence":"Dage med fravær"},"notifications":{"notifications":"notifikationer","all":"Alle","unread":"Ulæste","mark_all_as_read":"Markér alle som læste","sent_from":"Sendt fra","mark_as":"Marker som","read":"Læst","not_read":"Ulæst","no_new_notifications":"Ingen nye notifikationer"},"presence":{"work_hours":"Arbejdstider","set_work_hours":"Indtast arbejdstider","choose_weeks_for_work_hours":"Vælg uger for arbejdstiden","work_hours_in_the_week":"Timer i ugen","cancel":"Annullér","copy_to_multiple_weeks":"Indsæt i flere uger","back":"Tilbage","save":"Gem","times_may_not_overlap":"Tider må ikke overlappe hinanden","hours":"timer","minutes":"min","h":"t","m":"m","present":"Til stede","not_present":"Ikke til stede","total_working_hours":"Skemalagt arbejdetid for året"},"createusers":{"create_users":"Opret bruger(e)","login_options":"Login mulighed(er)","can_be_added_later":"kan evt. tilføjes senere","must_be_added":"Skal udfyldes","name":"Navn","mail":"email","placeholder_name":"Navn Efternavn","placeholder_email":"navn@skolemail.dk","email_error_text":"Det ligner ikke en rigtig email!","add_more":"Tilføj flere","create":"Opret","user":"bruger","users":"brugere","user_created":"Bruger oprettet!","users_created":"Brugere oprettet!","feide_is_already_used_for":"Feide er allerede tilføjet"},"createuser_button":{"create_user":"Opret bruger"},"toast":{"something_went_wrong":"Noget gik galt"},"subject":{"azure":"Azurblå","blue":"Blå","bronze":"Bronze","brown":"Brun","coral":"Koral","grey":"Grå","green":"Grøn","purple":"Lilla","lightblue":"Lyseblå","lightblue2":"Lyseblå2","lightbrown":"Lysebrun","lightgreen":"Lysegrøn","lightyellow":"Lysegul","lightyellow2":"Lysegul2","lightpurple":"Lyselilla","lightred":"Lyserød","marinoblue":"Marineblå","darkblue":"Mørkeblå","darkgreen":"Mørkegrøn","darkyellow":"Mørkegul","darkpurple":"Mørkelilla","darkorange":"Mørkeorange","darkorange2":"Mørkeorange2","orange":"Orange","red":"Rød","red2":"Rød2","skal_vaelges":"skal vælges","turkis":"Turkis"},"createklass":{"create_klasses":"Opret klasse(r)","schoolyear":"Skoleår","klass_name":"Klassens navn","klass_step":"Klassetrin til import af fag (valgfrit)","import_subjects_question":"Ønsker du at importére basisfagene for klassen?","import_subjects_done":"Disse fag vil blive oprettet i klassen","subjects_for":"Fag for","klass":"klasse","klasses":"klasser","hoursPrYear":"t/år","grade":"klasse","warning_text":"Klasser kan ikke have samme navn","succes_text":"Klasse(r) blev oprettet!","creating":"Opretter,","import_subject_to_the_klass":"Importer fag til klasser","subjects_created_successfully":"Fagene er oprettet"},"createrooms":{"create_rooms":"Opret lokale(r)","room_name":"Lokalets navn","placeholder":"Idtrætshallen","room":"lokale","rooms":"lokaler","warning_text":"Lokaler kan ikke have samme navn","succes_text":"Lokale(r) blev oprettet!","creating":"Opretter"},"createroom_button":{"create_room":"Opret lokale"},"editCalendarEditName":{"edit_name":"Redigér navnet","calendar_name":"Kalenderens navn","warning_text":"Navnet må ikke være tomt","update_name":"Opdatér navnet","success_text":"Navnet er opdateret!"},"editCalendarMenu":{"edit_name":"Rediger navn","delete_calendar":"Slet kalender","remove_calendar":"Fjern kalender","view":"Visning","5_days":"5 dage","7_days":"7 dage","7_days_and_24_hours":"7 dage, 24 timer","lock":"Lås kalenderen","unlock":"Lås op","calendar_is_locked":"Kalenderen er låst","merge_with_merge_calendars":"Flet med fletteskemaer","merge_with_calendar":"Flet ind i kalender","is_merged":"Er flettet ind i","can_be_merged_into":"Kan flettes ind i","see_public_view":"Se elevvisning","active_public_view":"Aktiver elevvisning"},"editCalendarDelete":{"delete_calendar":"Slet kalender","deleting_this_calendar":"Du er ved at slette kalenderen","all_data_will_be_deleted":"Alle kalenderaktiviteter vil blive slettet PERMANENT, og data kan IKKE GENSKABES.","validator_name":"slet kalenderen","write":"Skriv","if_you_want_to_delete":"hvis du vil slette denne kalender","you_have_to_write":"Du skal skrive","success_text":"Kalenderen er slettet"},"setupWidget":{"do_steps_for_scheduling":"6 trin for at komme i gang med skemalægningen","get_going_easy":"Kom i gang","follow_these_steps":"Følg vejledninger i videoerne","write_us":"Chat med os","support_forum":"Supportforum"},"createmerge":{"create_merge":"Opret fletteskema(er)","name":"Navn","placeholder":"Pauser","calendar":"kalender","calendars":"kalendere","warning_text":"Kalendere kan ikke have samme navn","succes_text":"Kalender(e) blev oprettet!"},"sidenav":{"not_created_klass":"Du har ikke oprettet nogen klasser","not_created_users":"Du har ikke oprettet nogen brugere","not_created_rooms":"Du har ikke oprettet nogen lokaler","not_created_merge":"Du har ikke oprettet nogen fletteskemaer","not_created_other":"Andre Kalendere bruges til teammøder og lignende. <a href=\"https://help.docendo.dk/da/knowledgebase/13-andre-kalendere/docs/19-andre-kalendere-til-moder-og-andre-opgaver-der-ikke-er-undervisning\" target=\"_blank\">Læs mere om Andre Kalendere</a>"},"year_transfer":{"copy_klasses_from":"Kopier kalendere fra skoleåret","to":"til","copy_nothing":"Kopier intet","klass_name":"Kalendar navn","klass_name_desc":"Kopierer en kalender med samme navn til det nye skoleår - uden brikker.","klass_name_and_subjects":"Kalenderens navn og brikker inkl. årsnorm","klass_name_and_subjects_desc":"Kopierer en kalendar med samme navn og alle oprettede brikker inkl. årsnorm til det nye skoleår.","klass_name_and_subjects_with_teachers":"Kalenderens navn og brikker inkl. årsnorm og tilknyttede undervisere og lokaler","klass_name_and_subjects_with_teachers_desc":"Kopierer en kalender med samme navn i det nye skoleår - og alle oprettede brikker inkl. årsnorm og tilknyttede undervisere og lokaler.","choose_all":"Vælg alle","img_src_one":"http://support.docendo.dk/img/transferyear/1DK.png","img_src_two":"http://support.docendo.dk/img/transferyear/2DK.png","img_src_three":"http://support.docendo.dk/img/transferyear/3DK.png","year_transfer_link":"Vil du oprette klasser med navne og brikker fra sidste skoleår? Klik her","from_week_33_in":"fra uge 33 i","to_week_33_in":"til uge 33 i","klass_name_and_subjects_with_teachers_and_schedules":"Klassens navn og brikker inkl. årsnorm og tilknyttede undervisere, lokaler og skemaer","calendar_already_exist":"kalenderen eksisterer allerede","everything_is_copied_except":"Alt kopieres undtagen evt. tilknyttede klasser","everything_is_copied_except_tooltip":"Hvis der er mere end en klasse tilknyttet brikkerne, bliver disse ikke kopieret, da de tilknyttede klasser tilhører det forrige skoleår","and_schedules":"og skema","from_week":"Fra uge","to_week":"Til uge"},"assign_users_hours":{"assign_hours":"Årsnorm","search_a_name":"Søg på navn","work_hours":"Arbejdstid","teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","name":"Navn","assigned":"Tildelt","scheduled":"Skemalagt","diff":"Forskel","update":"Opdatér tal","applies_to_the_period":"Gælder for perioden","tasks":"Øvrige opgaver","preparation":"Forberedelse"},"tagging":{"tagging_users":"Gruppering af brugere","users_selected_from":"brugere valgt af","add_tag_to":"Tilføj tag til","select_persons_first":"Vælg personer først","select_all":"Vælg alle","unselect_all":"Fravælg alle","already_created":"Allerede oprettede","example_tags":"Eks. Lærer, Vikar, Team","create_tag":"Opret tag","search_tag":"Søg tag","create_tags":"Opret tags","with":"med","you_have_created_zero_tags":"Du har oprettet 0 tags"},"dselect":{"no_matching_results":"Ingen matchende resultater","placeholder":"Søg på person","create_user":"Opret bruger,","in_same_klass":"I samme klasse","placeholder_calendars":"Søg og vælg"},"substitution":{"substitution":"Vikardækning","none_absent":"Ingen fraværende","number_absent_today":"Antal fraværende i dag","today":"I dag","create_absence":"Opret fraværende","who":"Hvem","person_must_be_filled":"Person skal udfyldes","reason":"Årsag","choose_absence_reason":"Vælg fraværsårsag","create":"Opret","reason_must_be_filled":"Årsag skal udfyldes","date":"Dato","time":"Tid","absent_period":"Fraværsperiode","do_you_want_to_delete_the_absent_reason":"Vil du slette fraværsårsagen","yes":"Ja","cancel":"Annullér","substitutes_will_not_be_removed":"Vikarer på lektioner vil IKKE blive fjernet. Så fjern evt. disse inden.","subject":"Fag","class":"Klasse","other_users":"Også tilknyttet","substitute":"Vikar","substitute_notes":"Vikarnoter","todays_lessons":"Dagens lektioner","see_all":"Se alle","see_less":"Se færre","absence_is_created_in_a_calendar":"Fraværet er oprettet i en kalendar, og skal derfor slettes i denne.","go_to_calendar":"Gå til kalender","deleting_absence_from":"Sletter fraværet fra","to":"til","choose_absence_user":"Vælg en eller flere undervisere","absence_notes":"Evt. note til fraværet","add_sub_to_several_lesson":"Sæt en vikar på flere lektioner","find_sub_for":"Find vikar til","lessons":"lektioner","finding_available_subs":"Finder ledige vikarer","select_lessons_to_substitute":"Vælg lektioner der skal vikardækkes","overlap":"overlap","available":"Ledig","do_you_want_to_save":"Vil du gerne gemme dine ændringer","no_close_without_saving":"Luk uden at gemme","yes_save_my_changes":"Ja, gem mine ændringer","lessons_updated":"Lektioner opdateret","lessons_without_sub":"Lektioner uden vikar","lessons_with_sub":"Lektioner med vikar","all_lessons":"Alle lektioner","no_lessons_without_subs":"Ingen lektioner uden vikar","no_lessons_with_sub":"Ingen lektioner med vikar","no_lessons":"Ingen lektioner","remove_sub_from_all_lessons":"Fjern som vikar på alle lektioner","do_you_want_to_remove":"Vil du fjerne","as_sub_on":"som vikar på","or_on_all_lessons":"eller på alle lektioner","remove_from_all_lessons":"Fjern fra alle lektioner","just_this_lessons":"Kun på denne lektion","choose_period_lessons":"Vælg en periode for at se lektioner","from_selected_date_onwards":"Fra valgt dato og frem","entire_period":"Hele perioden","selected_date":"Valgt dato","lessons_that_overlap_in_class":"Samtidig i klassen","delete_lesson":"Slet lektion"},"substitution_user":{"multiple_days":"Flere dage","lessons_on_day":"Lektioner på dagen","lessons_affected_by_absence":"Lektioner påvirket af fravær","absent":"Fraværende"},"substitution_show":{"show_all_lessons":"Vis alle lektioner","show_the_absent":"Vis fraværende","lessons":"Lektioner","choosen_lessons":"Valgte lektioner"},"sub_scheduler":{"filter_substitutes":"Filtrér i vikarer","sub_pools":"Vikarpuljer","todays_absent":"Dagens fraværende","potential_subs":"Potentielle vikarer","choose_sub":"Vælg vikar","status":"Status","sort_after":"Sortér efter forslag","set_priorities":"Vælg prioriteringer","sorting_will_be_based_on":"Sortering sker ud fra","already_on_lesson":"Også tilknyttet på lektionen","is_in_same_class_at_the_same_time":"Er i klassen samtidig","multiple_lessons_in_same_classes":"+2 undervisere samtidig i en anden klasse","not_occupied_with_available_lesson":"Ledig med Rådighedstime","not_occupied_with_work_hours":"Ledig med arbejdstid","not_occupied_without_work_hours":"Ledig uden arbejdstid - men med fag på dagen","multiple_on_a_lesson":"+2 samtidig i en anden klasse","not_occupied_without_lessons_on_the_day":"Ingen lektioner på dagen","occupied":"Optaget","it_will_also_be_sorted_based_on_tags_in_common":"Ovenstående sorteres også ud fra antal tags til fælles med den fraværende","absent_people":"Fraværende","substitutes":"Vikarer","out_of":"ud af","potential_substitutes":"Potentielle vikarer","pool":"Pulje","choose_filters":"Vælg filtre","list":"Liste","schedules_overview":"Skemaoverblik","is_substituted":"Er vikardækket"},"sub_scheduler_item":{"prolonged_absence":"Længerevarende","also_on_lesson":"Også tilknyttet"},"sub_scheduler_popover":{"substitute_for":"Vikardæk for","handled":"Håndteret","not_handled":"Ikke håndteret","handled_for_absence":"Håndteret for alle fraværende","pending":"Afventer"},"sub_scheduler_sub_pools":{"substitute_hours":"Vikartimer","difference":"Forskel","assigned":"Tildelt","scheduled":"Skemalagt"},"IEWarning":{"you_are_using_a_IE_or_Edge_to_get":"OBS! Du bruger Internet Explorer / Edge. For at få","a_faster_and_better_experience":"en hurtigere og bedre oplevelse","we_recommend_that_you_switch_to_these_browsers":"anbefaler vi, at du skifter til en af disse gratis browsere","or":"eller"},"dashboard":{"welcome":"Velkommen","start_by_setting_up":"Start med opsætning af","steps_completed":"Trin fuldført","step":"Trin","tutorial":"Videoguide","follow_the_steps":"Følg Setup Guiden"},"delete_day_or_week":{"cant_delete":"Kunne ikke slettes. Prøv igen."},"user_event_list":{"absence":"Fravær","teaching":"Undervisning","substitute_hours":"Vikartimer","from":"fra","to":"til","no_matching_events":"Listen er tom","total":"Sum","close":"Luk"},"weekplan_2":{"no_events_this_week":"Ingen lektioner i ugen"},"event_form":{"delete_events_onward":"Slet lektioner fremadrettet","are_you_sure":"Er du sikker?","do_you_want_to_delete_this_and_all_in_same_timeslot":"Vil du gerne slette denne lektion, og alle der ligger på samme ugedag og i samme tidsrum fremadrettet?","cancel":"Annuller"},"calendar_export":{"export_calendar":"Eksporter kalender","export_calendar_to":"Eksporter kalender til ...","copy_the_url_and_insert":"Kopier følgende URL og indsæt den i den eksterne kalender","guide_to":"Guide til","guide_to_export_calendar":"Guide til at eksportere til Outlook, Google eller iCalendar,","create_a_link_on_mobile":"Opsætning af klasseskemaer på mobilen"},"common":{"search":"Søg","show_print_hours":"Vis Beregn timer","show_as_blocks":"Vis som blokke","show_as_table":"Vis som tabel","show_as_list":"Vis som liste","add":"Tilføj","submit":"Gem","create":"Opret","edit":"Redigér","save":"Gem","saved":"Gemt","dont_save":"Gem ikke","select":"Vælg","cancel":"Annuller","update":"Opdater","yes":"Ja","no":"Nej","save_changes":"Vil du gemme dine ændringer?","are_you_sure_you_want_to_delete":"Er du sikker på, at du gerne vil slette","ago":"siden","min":"min","class":"Klasse","classes":"Klasser","classes_sidenav":"Klasser","teacher":"Underviser","room":"Lokale","substitute":"Vikar","rename":"Omdøb","delete":"Slet","add_user":"Tilføj bruger","press":"Tryk","user":"Bruger","users":"Brugere","rooms":"Lokaler","merge_calendar":"Fletteskema","merge_calendars":"Fletteskemaer","merge_calendars_sidenav":"Flette-skemaer","other_calendar":"Anden kalender","other_calendars":"Andre kalendere","close":"Luk","must_be_filled":"Skal udfyldes","something_went_wrong":"Noget gik galt","show_weekends":"Vis weekender","calendar":"Kalender","in":"i","search_for":"søg på","remove":"Fjern","none_created":"Ingen oprettet","log":"Historik","no_calendars_found":"Ingen kalendere fundet..","done":"Færdig","is_deleted":"er slettet,","choose_school":"Vælg skole","show_more":"Vis flere","show_less":"Skjul flere","search_name_or_initials":"Søg på navn eller initialer","hide_calendars":"Skjul kalendere på fag","hide_dates":"Skjul datoer"},"weeknote_log":{"saved_versions":"Gemte versioner af ugenoten","activity":"Historik","no_saved_versions":"Ingen gemte versioner","choose_versions_to_compare":"Vælg versioner til sammenligning","current_version":"Aktuel version"},"show_event":{"this_lesson_counts_as":"Denne lektion tæller som"},"permissions":{"roles":"Roller","create_new_role":"Opret ny rolle","users":"Brugere som er","users_assigned_role":"brugere tildelt rollen","add_user_to":"Tilføj bruger til","role":"rolle","permissions":"Tilladelser som","change_permissions_for_role":"Ændre tilladelser for rollen","rename_role":"Omdøb rollen","delete_role":"Slet rollen","give_role_a_title":"Giv rollen et navn","choose_new_name":"Vælg nyt navn","you_cant_delete_a_role_that_has_users":"Du kan ikke slette en rolle, der har brugere tilknyttet","give_the_following_user_a_new_role":"Giv følgende brugere en ny rolle","can_change_substitution":"Vikardækning - Kan tilgå og ændre Vikardækning","can_manage_absence_reasons":"Vikardækning - Kan oprette og ændre Fraværsårsager","can_do_most_stuff":"Kan gøre det meste","can_edit_own_notes":"Skema - Kan redigere noter","can_export":"Kan eksportere til Docendo ZEN","can_manage_assigned_hours":"Årsnorm - Kan tilgå og ændre Årsnorm","can_see_assigned_hours":"Årsnorm - Kan tilgå Årsnorm","can_manage_school_years":"Kan ændre i skoleår","can_manage_sms":"Kan anvende SMS","can_manage_substitute_hours":"Kan ændre i vikarpuljer","can_manage_tasks":"Fagfordelingen - Kan ændre i fag og opgaver","can_manage_users":"Kan håndtere brugere","can_see_other_calendars":"Skema - Kan se alle kalendere","can_manage_calendars":"Kalendere - Kan oprette, slette og redigere kalendere","can_setup_aula":"Kan ændre opsætning til Aula","change_role":"Ændre rolle","role_desc_administrator":"En administrator har adgang til alle funktioner i Docendo, og kan håndtere rettigheder for alle roller.","role_desc_read_only_user":"En skrivebeskyttet bruger har som udgangspunkt kun adgang til egen kalender, og brugeren kan ikke se eller ændre i andre kalendere eller tilgå vikardækning og andre administrative funktioner. Denne rolle kan dog tildeles adgang til udvalgte funktioner.","role_desc_regular_user":"En Normal bruger har adgang til alle skemaer/kalendere og alle funktioner, men kan ikke tilføje, ændre eller slette brugere og årsnormsperioder/skoleår eller ændre Aula-opsætning.","role_updated":"Rollen er opdateret","role_deleted":"Rollen er slettet","role_created":"Rollen er oprettet","can_see_other_subject_requests":"Fagønsker - Kan se andres ønsker","can_edit_subject_requests":"Fagønsker - Kan ønske fag (når der er åben for Fagønsker)","can_see_subjects_distribution_page":"Fagfordelingen - Kan tilgå fagfordelingen","can_see_others_task_overviews":"Opgaveoversigt - Kan se andres opgaveoversigt","can_see_own_task_overview":"Opgaveoversigt - Kan se sin egen opgaveoversigt","can_edit_own_presence":"Arbejdstid - Kan redigere sin egen arbejdstid","can_edit_others_presence":"Arbejdstid - Kan redigere andres arbejdstid,","can_edit_user_year_notes":"Opgaveoversigt - Kan skrive og redigere noter hos andre","can_send_substitute_email":"Vikardækning - Kan sende emails","can_send_substitute_sms":"Vikardækning - Kan sende SMS'er","select_role_to_base_new_on":"Vælg en rolle, den nye skal baseres på"},"calendars":{"calendars":"Kalendere","edit_calendars":"Slet / omdøb kalendere","copy_calendars":"Kopier kalendere","archive":"Arkivér","show":"Se","hide":"Skjul","archived":"arkiverede","unarchive":"Gendan","write_name":"Skriv navn","selected_of":"valgt af","select_calendars_to_copy":"Vælg kalendere der skal kopieres","copy":"Kopier","select_week_to_copy_from":"Vælg uge der skal kopieres fra","select_weeks_that_week":"Vælg uger som uge","must_be_copied_to":"skal kopieres til","do_you_want_to_delete":"Vil du slette","print_calendars":"Print kalendere","add_presence":"Tilføj arbejdstider","delete_events_in_date_range":"Slet alt skemalagt i et datointerval","delete":"Slet"},"sms":{"sms":"SMS","do_you_want_to_delete_the_template":"Vil du slette standard besked","template_sms_deleted":"Standard besked slettet","an_error_occured":"Der opstod en fejl","add_number":"Tilføj mobilnummer","number_must_be_8_digits":"Telefonummer skal være 8 cifre","number_deleted":"Telefonnummer slettet","number_added_awaiting":"Nummeret tilføjet. Afventer bekræftelse","edit":"Redigér","new":"Ny","standard_sms":"standard besked","title":"Titel","to_show_in_list":"til visning i listen","ex_you_are_sub":"Eks. Du er blevet vikar","insert_today_to":"Indsæt [today] for få dagen eks.","updated_sms_template":"Opdaterede besked","created_sms_template":"Oprettede besked","message":"Besked","subject":"Emnefelt"},"subs_ongoing_absence":{"delete_absence":"Slet fravær","change_start_and_end_date":"Ændre start- og slutdato","ongoing_absence":"Løbende fravær","ongoing_absence_explained":"Løbende fravær forlænges automatisk, når den oprindelige slutdato er nået. Slutdatoen er den forventede sidste dato for fraværet. Fraværet forlænges med én dag ad gangen, indtil du afslutter fraværet.","date_label":"Dato (inkl. begge dage)","absence_will_be_deleted":"Fravær slettes","remove_subs_and_delete_absence":"Fjern vikarer og slet fravær","keep_subs_and_delete_absence":"Behold vikarer og slet fravær","remove_subs_and_update":"Fjern vikarer og opdater","keep_subs_and_update":"Behold vikarer og opdater","remove_subs_and_stop_ongoing_absence":"Fjern vikarer og stop løbende fravær","keep_subs_and_stop_ongoing_absence":"Behold vikarer og stop løbende fravær","confirm_date_and_stop_ongoing_absence":"Bekræft datoer og stop løbende fravær","update_dates":"Opdater datoer","checking_for_substitutes":"Tjekker for vikarer","lessons_with_substitutes":"Lektioner med vikar","no_subs_on_lessons":"Ingen vikarer på lektioner i de dage fraværet slettes","of":"af","lessons_that_will_have_subs_removed":"lektioner får slettet vikarer","select_all":"Vælg alle","unselect_all":"Fravælg alle","remove_sub":"Fjern vikar","teachers_with_ongoing_absence":"Undervisere med løbende fravær","no_teachers_with_ongoing_absence":"Ingen undervisere med løbende fravær","absence_will_be_prolonged_in":"Forlænges om","edit_stop":"Redigér / stop","subs_removed":"Vikarer fjernet","absence_deleted":"Fravær slettet","auto_created_today":"Oprettet automatisk i dag","absence_updated":"Fravær opdateret","stop_ongoing_absence":"Stop løbende fravær","cant_be_ongoing_absence":"Løbende fravær kan ikke oprettes med slutdato tidligere end dags dato","auto_created":"Oprettet automatisk"},"zen_import":{"import_from_zen":"Importer skemasæt fra ZEN til Docendo","choose_version":"Vælg skemasæt","you_have_no_created_any_versions":"Du har ikke oprettet nogen skemasæt i ZEN","last_updated":"Seneste ændring","choose_schoolyear":"Vælg skoleår","insert_in_week":"Indsæt i uge","insert_schedules":"Indsæt skemaer","week":"Uge","schedules_are_being_inserted":"Skemaer indsættes i uge"},"create_calendars":{"other_calendar":"Opret andre kalendere","other_calendar_placeholder":"Eks. Team kalender"},"create_subject":{"create_subject":"Opret brik","subject_is_not_created_in_this_school_year":"Brikken er oprettet. Vær dog opmærksom på, at den er tilknyttet et skoleår, som ikke matcher den aktuelle dato."},"task_overview":{"task_overview":"Opgaveoversigt","no_tasks_assigned":"Ingen opgaver tildelt","distribution":"Fordeling","work_hours":"Arbejdstid","teaching":"Undervisning","tasks":"Øvrige Opgaver","preparation":"Forberedelse","show_scheduled_hours":"Vis skemalagte timer","coming_soon":"Kommer snart","belongs_to":"Tilhører","absence":"Fravær","reset":"Nulstil dato","club":"SFO","substitute_hours":"Vikartimer","showing_scheduled_hours_from":"Viser skemalagte timer fra","rest":"Rest","pool":"Lokalpulje","unknown":"Rådighedstimer","diff_from_total_workhours":"Difference ift. tildelt arbejdstid"},"standard_settings":{"standard_setting":"Standard indstilling","set_default_start_and_endtime":"Sæt standard start- og sluttid"},"print_all_calendars":{"loading":"Henter lektioner for alle kalendere. Det kan tage noget tid..","no_calendars":"Det er 0 kalendere med lektioner","are_you_ready_to_print":"Er du klar til at printe?","print":"Print","this_calendar":"Denne kalender","this_calendar_with_weekplan":"Kalender m. ugeplan","all_classes":"Alle klasser","all_teachers":"Alle undervisere","all_rooms":"Alle lokaler","only_printing_calendars_with_lessons":"Printer kun kalendere med lektioner","show_print_without_bg_colors":"print uden baggrundsfarver","event_font_size":"Skriftstørrelse","custom":"Vælg kalendere"},"edit_event":{"teachers":"Personale","substitutes":"Vikar","rooms":"Lokale","klass":"Klasse","swap_headline":"Følgende lektioner kan bytte plads med den valgte lektion","swap_desc":"Byt-funktionen bruges til at bytte en eksisterende lektion med en anden lektion, der allerede er planlagt til et andet tidspunkt i samme kalender. Det betyder, at man kan flytte en planlagt lektion til et andet tidspunkt og erstatte den med en anden lektion fra samme kalender. Følgende lektioner kan byttes med den valgte lektion uden at skabe dobbeltbookinger, da undervisere og lokaler er ledige i de nye tidsrum.","swap_no_lessons":"Desværre ingen lektioner at bytte med...","select":"Vælg","replace_headline":"Erstat lektionen med en ny","replace_desc":"Erstat-funktionen bruges til at erstatte en eksisterende lektion med en ny (ikke-skemalagt) lektion fra et udvalgt fag. Der er muligt at erstatte lektionen med en ny fra nedenstående fag, da både underviser og lokale er ledige.","replace_no_lessons":"Desværre ingen lektioner at erstatte med...","lesson_updated":"Lektionen er opdateret"},"students":{"all":"Alle","activated_schedules":"Aktiverede elevskemaer","student":"elev","students":"elever","created_student":"Elev oprettet","delete_student":"Slet elev?","add_student":"Tilføj fra anden klasse","create_student":"Opret elev","students_with_same_name":"Følgene elever har et lignende navn","users_with_same_name":"Følgene brugere har et lignende navn","latest_updated":"Senest opdateret","is_already_in_the_klass":"Er allerede i klassen","without_a_group":"uden klasse","has_no_groups":"Ingen klasser tilknyttet","name":"navn","feide":"feide","feide_is_already_used":"Dette Feide er allerde brugt","import_students":"Importer elever","groups":"grupper","without_group":"Uden klasse","calendar":"kalender","remove":"Fjern","of":"af","students_in":"elever i","the_group":"klassen","select_all":"Vælg alle","unselect_all":"Fravælg alle","insert_multiple_students":"Indsæt liste med elevnavne. Skift linje efter hver elev.","create_multiple_students":"Opret flere elever på en gang","to_be_scheduled":"Skemalægges"},"set_standard_duration":{"lessons_duration":"Lektionslængde","minutes":"minutter","set_standard_duration_for_the_school":"Sæt standard lektionslængde for skolen","standard_duration_for_the_school":"Standard lektionslængde for skolen","the_number_must_be_divisible_by_five":"Minuttallet skal gå op i 5","this_setting_will_be_selected_if_nothing_else_is":"Denne indstilling bruges, hvis ikke andet er valgt","standard_duration_can_be_selected_for_each_course":"Standardvarigheden for et fag kan altid ændres for hvert enkelt fag","already_created_courses_want_be_updated":"Allerede oprettede fag vil ikke blive opdateret","set_standard_length_for_zen":"Standard lektionslængden bruges til at udregne antal lektioner for et ugeskema i Docendo ZEN."},"club":{"club":"SFO","club_calendar":"SFO kalender","create_club_calendar":"Opret SFO kalender","not_created_club":"Med et SFO-skema kan du oprette SFO-tid for pædagoger adskilt fra skole-tid"},"calendar_view_day":{"remove":"Fjern","add":"Tilføj","replace":"Erstat","actions_for":"Handlinger for","onwards":"fremadrettet","remove_onwards":"Fjern fremadrettet","do_you_want_to_remove":"Vil du fjerne","on_all_lessons_from":"på alle lektioner fra og med","and_onwards":"og på alle lektioner fremover","add_onwards":"Tilføj fremadrettet","do_you_want_to_add":"Vil du tilføje","on_all":"på alle","lessons":"lektioner","onwards_which_include":"fremadrettet? Dette inkluderer lektioner fra og med","and_all_onwards":"og på alle fremtidige lektioner","with_on_all":"med på alle","select_the_person_to_replace":"Vælg den kalender du gerne vil erstatte","select_person":"Vælg kalender","replace_onwards":"Erstat fremadrettet"},"eventTypes":{"subject":"Fag","optional":"Valgfag/Hold","supplemental":"UUV","frame":"Temavisning (Ramme)","break":"Pause","resource":"Ressource (synlig)","person_resource":"Ressource (skjult)","other_tasks":"Anden tid","other_stuff":"Øvrig tid","available":"Rådighedstime","person_resource_visible":"Ressource (synlig)","club":"SFO tid","additional_tasks":"Øvrige opgaver","preparation":"Forberedelse","with_kids":"Tid med børn","without_kids":"Tid uden børn","pool":"Lokalpulje","absence":"Fravær","_extra_time_at_start_of_day_":"Ekstra tid for start på dag","reservation":"Reservation"},"task_versions":{"task_overview":"Opgaveoversigt","versions":"Versioner","save_print_task_overviews":"Gem/print opgaveoversigter","save_new_version_task_overviews":"Gem en ny version opgaveoversigter","print_latest_version_task_overviews":"Print nyeste version af opgaveoversigter","saved_message":"Gemt","delete_message":"Slet","confirm_delete_message":"Vil du slette","delete_warning_message":"Versioner der slettes kan ikke genskabes","annual_norm":"Årsnorm","save_task_overview_version":"Gem version af opgaveoversigt","version_title":"Titel for versionen af opgaveoversigten","auto_name_description":"Navngives automatisk med dags dato, hvis du ikke skriver en titel","what_is_version":"Hvad er en version?","saved_task_overview_description":"En gemt opgaveoversigt viser et øjebliksbillede af medarbejderens opgaveoversigt, som den så ud på det tidspunkt, hvor versionen af opgaveoversigten blev gemt. Det svarer til at lave en udskrift eller PDF med detaljer om, hvordan opgaveoversigten så ud på det givne tidspunkt.","find_saved_versions":"Hvor kan jeg finde gemte versioner?","find_saved_versions_description":"Du kan finde gemte versioner ved at navigere til \"Opgaveoversigt\" for de enkelte personer. Her vil der være en dropdown-menu, hvor de alle gemte versioner i skoleåret er tilgængelige for gennemsyn.","select_personnel":"Vælg personale","go_back":"Tilbage","select_min_user":"Der skal vælges minimum en bruger","save_for_selected_users":"Gem for","save_for_selected_users_of":"af","print_latest_version":"Print alles nyeste version af opgaveoversigten","no_saved_versions":"Ingen versioner er gemt"},"deleted_subjects_log":{"deleted_log":"Log over slettede","no_lessons_deleted":"Der er ikke slettet nogle lektioner fra denne brik","lesson":"Lektionen","deleted":"Slettet"},"create_activity":{"create_activity":"Opret aktivitet","create_activity_for":"Opret aktivitet for","title":"titel","search_or_create":"Søg eller opret","created":"Oprettet","create_new_subject_for":"Opret ny brik for","choose_subject_type":"Vælg briktype","the_selected_date_is_outside_schoolyears":"Den valgte dato er uden for alle aktive skoleår"},"datepicker":{"max_date_range_start":"Der kan max hentes","max_date_range_end":"dages interval"}}

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	module.exports = {"en":{"activerecord":{"attributes":{"calendar":{"name":"Name"},"group":{"country":"Country","demo_expiry":"Demo expired","description":"Description:","institution_number":null,"name":"Name","open":"Open?","si_name":null,"visible":"Visible?"},"institution":{"number":"Institution number"},"lesson":{"count_hours":"Count hours"},"material":{"class":"Grade/group","description":"Description:","documenttypes":"Type of document","klassetrin":"Grade/group","status":"Status","subjects":"Subject","tag_list":"Tag list","thefile":"File","title":"Title"},"notification":{"body":"Body text","header":"Title","sitewide":null,"url":"URL"},"post":{"body":"Content","published":"Published?","titel":"Title"},"room":{"name":"Name","navn":"Name","si_name":null},"signup":{"already_in_use":"already in use","country":"Country","email":"E-mail","password":"Password","password_can_not_be_email":"cannot be your e-mail","password_can_not_be_school_name":"cannot be the name of your school","password_can_not_be_user_name":"cannot be your name","password_confirmation":"Confirm password","school_name":"School name","terms_of_service":"Terms of service","user_name":"Your name"},"subject":{"calendar":"Calendar","color":"Color","default_duration":"Standard duration (minutes)","hours":"Hours","name":"Subject title","si_name":null,"subject_type":"Type"},"subject_period":{"hours_per_week":"Hours per week","total_hours":"Total hours"},"user":{"Email":"E-mail","Fag":"Subject","Initialer":"Initials","Klassetrin":"Grade","Navn":"Name","Sprog":"Language","assigned_preparation_hours":"Preparation","assigned_teaching_hours":"Assigned teaching hours","assigned_total_hours":"Teaching hours (year)","description":"Description: ","email":"E-mail","groups":"Groups","name":"Name","organisation":"School","password":"Password","password_confirmation":"Confirm password","primary_school":"Your main school","remember_me":"Remember me"}},"errors":{"models":{"group":{"attributes":{"institution_number":{"taken":null}}}}},"models":{"calendar":"schedule","group":"group","institution":"school","lesson":"lesson","material":"material","post":"post","room":"location / classroom","signup":"Signup","subject":"subject","subject_period":"Subject period","user":"user","user/calendar_transfer":"Calendar transfer"}},"calendars":{"administration":{"archive_merge_table":"Archiving a shared calendar will make it invisible on the home page","archive_room":"Archiving a location will make it invisible on the homepage"},"calendar_hours_count":{"andet_halvår":"2nd half of year","første_halvår":"1st half of year","indeværende_uge":"Current week","skoleår_til_dato":"School year to date"},"calendar_sidebar":{"skema":"Schedule"},"copy_paste":{"indsæt":"Paste","indsæt_resten_af_året":"Paste + rest of school year","kopiér":"Copy week"},"delete_merge_calendar_button":{"delete_merge_calendar":"Delete shared calendar","dette_kan_ikke_fortrydes":"This action can't be undone","ja_slet_dette_fletteskema":"Yes","nej":"No","slet_dette_fletteskema":"Delete this shared calendar?"},"delete_week_button":{"der_vil_kun_blive_slettet_de_lektioner_som_er_lagt_ind_i_denne_kalender":"Only events originally placed in this calendar will be deleted.","dette_kan_ikke_fortrydes":"This action can't be undone","ja_slet_ugens_lektioner":"Yes, delete everything this week.","lektioner":"Delete lessons this week...","nej":"No","vil_du_slette_alle_ugens_lektioner":"Do you want to delete all lessons this week?"},"events_with_notes_or_substitutes":{"hvis_du_kopierer_et_skema_frem_bliver_vikardækninger_fravær_i_personlige_kalendre_og_noter_på_lektionerne_ikke_gemt":"By copying and pasting this week all substitute settings and notes will be overwritten.","ja_jeg_vil_overskrive_disse":"Yes, I want to overwrite ","lektioner_med_noter_vikardækning_eller_fravær":"Lessons with notes"},"expand":{"skift_visning_mellem_arbejdsuge_weekender_og_fuld_uge":"Change view (full week/24hours)"},"explain_copy_in_background":{"der_kan_gå_5-10_minutter":"Estimated time: 2-5 minutes","du_får_en_notifikation_på":"You will receive a notification","du_kan_fortsætte_med_at_arbejde_i_andre_kalendre":"You will receive a notification when complete. You can close this window and continue. ","forsiden":"the front page","kopierer_kalenderen_frem":"Copying","når_kopieringen_er_afsluttet":"when the action is complete.","ok":"OK"},"group":{"flet_med_fletteskemaer":"Merge with shared calendars...","flet_med_skema":"Merge with shared calendar","se_elevskema":"View student schedule","vælg_skema":"Choose schedule"},"group_hours":{"total":"Total","type":"Type"},"merge":{"dette_skema_er_flettet_ind_i":"This schedule has been merged with:","hvis_du_vil_slette_dette_fletteskema_skal_du_først":"In order to delete this shared calendar you have to merge out of the above schedules.","vælg_kalender":"Choose schedule:"},"merge_with_selector":{"flet":"Merge"},"new":{"nyt_fletteskema":"New shared calendar","opret_fletteskema":"Create shared calendar"},"public":{"mobile_guide":"Guide: schedule on mobile and tablets.","print_in_black_white":"Print w/o color","printing_guide":"Print guide","se_skemaet_på":"See this schedule on"},"room":{"vælg_skema":"Choose schedule:"},"subject_hours":{"anden_tid_i_perioden":"Non-student related activities","er_du_tilknyttet":"In case you have more than one subject in the same period, time will be equally distributed. ","flextid_for_året":"Flexible hours by year","fravær_i_perioden":"Absence in this period of time","til":"to","timer":"hours","undervisning_i_perioden":"Teaching"},"user":{"apple_kalender":"Apple Calendar","google_kalender":"Google Calendar","google_opdaterer_kalenderen_ca_tre_gange_i_døgnet":"Google fetches information around 3 times a day","ical":"iCal","kopiér_webaddresen_herunder_og_kopier_den_ind_i_den_eksterne_kalender_hvor_du_gerne_vil_have_den":"Copy the URL and insert in the external calendar.","outlook":"Outlook","se_evt_guides_nedenfor_i_forhold_til_hvordan_du_skal_gøre":null,"siden":"ago.","sidst_hentet":"Last fetched","tilføj_dit_skema_til_ekstern_kalender":"External calendar: add your schedule","vælg_kalender":"Choose schedule"},"user_hours":{"undervisningstid":"Teaching"},"week_note":{"week_notes":"Week notes - general"},"week_plan":{"content":"Content","internal_notes":"Teachers notes","learning_goal":"Learning goal","pupil_preparation":"Homework","subject":"Subject"},"week_plan_and_note":{"week":"Week","week_plan":"Notes"}},"controllers":{"ws":{"events":{"you_are_no_longer_substitute":"%{creator} removed you as substitute teacher in %{subject} in %{klass}, %{time}","you_are_substitute":"%{creator} added you as substitute teacher in%{subject} in %{klass}, %{time}"}}},"da_only":{"add_user_with_uni":null,"click_to_login_with_unilogin":null,"fictive_user_text":"A calendar will be created for the fictive user, but the user will not be able to log in.","guide_link_parentintra":null,"lærere_på_skoleintra":null,"opdatér_profil_fra_uni-c":null,"parent_portal":null,"show_tables_parentintra":null,"skriv_brikken_skoleintra":null,"uni_login":null,"vis_skema_i_skoleintra":"Set up for external view","website_portal":"Website"},"date":{"formats":{"iso":"%Y-%m-%d"}},"demo":{"firstlogin":{"kom_igang":"Get started with Docendo","velkommen":"Welcome to Docenday! Watch intro video and click 'Get started' when you're ready."}},"devise":{"confirmations":{"new":{"resend_confirmation_instructions":"Send confirmation instructions"}},"failure":{"invited":"You have a pending invitation, accept it to finish creating your account."},"invitations":{"edit":{"header":"Set your password","password":"Password","password_confirmation":"Confirm password","submit_button":"Set my password"},"invitation_removed":"Your invitation was removed.","invitation_token_invalid":"The invitation token provided is not valid!","new":{"header":"Send invitation","submit_button":"Send an invitation"},"no_invitations_remaining":"No invitations remaining","send_instructions":"An invitation email has been sent to %{email}.","updated":"Your password was set successfully. You are now signed in.","updated_not_active":"Your password was set successfully."},"mailer":{"confirmation_instructions":{"confirm_my_account":"Confirm my account","you_can_confirm_your_account_email_through_the_link_below":"Use link below to confirm your account mail:"},"invitation_instructions":{"accept":"Accept invitation","accept_until":"This invitation will be due in %{due_date}.","contact_us":"If you have any questions you are welcome to contact us at kontakt@docendo.dk","from_school":"You have been invited to Docendo at %{school_name}.","hello":"Hello %{email}","regards_html":"<p>Regards,<br/>\nThe Docendo Team<br/>\nhttps://docendo.co</p>","someone_invited_you":"To accept the invitation click the link below","subject":"Invitation instructions"},"reset_password_instructions":{"change_my_password":"Change password","change_password_link_requested":"You can change your password through the link below. ","greeting":"Hello","wont_change":"Without any action, your password will not be changed. "},"unlock_instructions":{"click_the_link_below_to_unlock_your_account":"Click link below to unlock your account.","unlock_my_account":"Unlock my account.","your_account_has_been_locked_due_to_an_excessive_number_of_unsuccessful_sign_in_attempts":"Your account has been locked due to an excessive number of unsuccessful sign in attempts"}},"passwords":{"edit":{"change_my_password":"Change my password","change_your_password":"Change your password","confirm_new_password":"Confirm new password","new_password":"New password"},"new":{"forgot_your_password":"Forgot your password?","send_me_reset_password_instructions":"I want to receive instructions how to reset my password."}},"registrations":{"edit":{"are_you_sure":"Are you sure?","cancel_my_account":"Cancel my account","current_password":"Current password","password":"password","password_confirmation":"confirm password","update":"Update"}},"sessions":{"new":{"brugernavn":"User name","create_a_free_trial":"Create free trial","kodeord":"Password","log_ind":"Log in","log_ind_med":null,"log_ind_med_mail_og_kodeord":"Log in with e-mail and password","log_ind_på_docendo":"Log in","no_account":"Don't have an account?"}},"shared":{"links":{"didn":"Didn't receive instructions?","didn_2":"Didn't receive unlock instructions?","forgot_your_password":"Forgotten your password?","sign_in":"Log in","sign_up":"Sign up"}},"unlocks":{"new":{"resend_unlock_instructions":"Send unlock instructions again"}}},"events":{"event_debug":{"brugere":"Users:","ejerkalender":"Original calendar:","grupper":"Groups:","kalendre":"Schedules:","lokaler":"Locations:"},"replace_room":{"erstat_fremadrettet_på_dette_fag":"Replace from date onwards","og_resten_af_året":"and the rest of the year?","på":"on"},"replace_user":{"erstat_fremadrettet_på_dette_fag":"Replace from date onwards on this subject","klik_her_for_at_gå_til_kalenderen_for":"Click here to go to the schedule for","med":"With:","og_resten_af_året":"and the rest of the year?","på":"on"},"show":{"agenda":"Agenda","agenda_placeholder":"Example: 1. Follow-up on last meeting, 2. Mike will make a presentation of...","content":"Content","decisions_and_resume":"Decisions and summary","decisions_and_resume_placeholder":"Example: John will ask the teachers from...","denne_lektion_tæller_som":"This lesson counts as:","er_du_sikker":"Are you sure?","external_links":"My learning goals and courses","find_vikar":"Find substitute","gå_til_kalender_for_denne_lektion":"Go to schedule for this lesson","internal_notes":"Teachers/substitute notes","jump_to_calendar_for_event":"Go to calendar for this item","learning_goal":"Learning goal","location":"Location","meeting_purpose":"Purpose of the meeting","meeting_purpose_placeholder":"Example: Finalize content for...","only_visible_internally":"Visible only for teachers/staff","pupil_preparation":"Student preparation","slet_brik":"Delete item","slet_fra_denne_kalender":"Delete from this calendar only","substitutes":"Substitute","swappable_lessons":"The following lessons kan be switched around with the chosen lesson","søg_og_vælg":"Choose teacher","søg_og_vælg_vikar":"Search and choose substitute","teachers":"Teachers","undervisere_lokaler_noter":"Teachers","vacant":"Teacher and location vacant for the following subjects","vælg_klasser":"Choose grades/groups","vælg_lokation":"Choose location"},"show_public":{"agenda":"Agenda","content":"Content","decisions_and_resume":"Decisions and summary","external_links":"Learning goals","jump_to_calendar_for_event":"Go to calendar of this event","learning_goal":"What are our learning goals?","location":"Location","meeting_purpose":"Purpose of the meeting","pupil_preparation":"Student preparation","substitutes":"Substitutes","teachers":"Teachers"}},"groups":{"about":{"om":"About"},"admin":{"assign_hours_employees":"Assign hours","classes_and_subjects":"on grades/groups and subjects","more_tables":"See multiple schedules at the same time","show_to_parents":"Show to parents/students","status":"status","substitutes":"Substitutes ","supplement":"Supplement","year":"2016-2017"},"calendars_setup":{"copy_link":"Copy link","copy_link_table_insert":"Copy schedule link","docendo_extern_calendar":"Copy link and use in external calendar (iCal, Google Calendar, Outlook).","find_in_google_cal":"Guide: Docendo integration in external calendar","google_calendar":"Google Calendar","guide_integration_own_cal":"Guide: Docendo integration in external calendar","guide_setup_schoolport":"Setup guide","guide_setup_table_elevintra":null,"guide_step_copy":"Click on 'copy link' on the schedule you want to set up, and follow the instructions to the right.","ical_google_outlook":"iCal","integrate_tables":"Integrate schedules in iCal, Google or Outlook","links_for_each_class":"Distribute links to schedules individually by using the links below.","outlook":"Outlook","parentintra_seperate_class":null,"show_table_selected":"Show selected schedules","show_tables_elevintra":null,"substitutes_teachers_show_public":"Todays absent teachers","substitutes_teachers_show_public_explain":"Use link below to display information about absent teachers on info screen.","text_set_x":"Tick off the schedules you want shown through the link.","text_show_tables":"By pasting this URL on your website, students and parents will be able to view the schedules.","vaelg_alle":"Choose all"},"create_klass":{"evt_vaelg":"Do you want to import subjects and total amount of hours? Choose grade below:","import_af_fag":"Import subjects?","import_norm":"Do you want to import and set up subjects with corresponding assigned hours? Choose the grade corresponing to your grades/groups here:","klassens_navn":"Grade/group name","opret_en_ny_klasse_for":"Create new grade/group","skriv_klassens_navn":"Enter grade/group name"},"delete_popup":{"brikker_som_slettes_kun_fra_denne_kalender":"Items that will be deleted from this schedule","den_har":"It has:","denne_handling_kan_ikke_fortrydes":"This can not be undone.","indlæg_som_slettes":"posts that will be deleted","kalendere_som_slettes":"Schedules that will be deleted","lektioner_i_kalenderen":"lessons in the schedule","medlemmer_som_ikke_længere_vil_kunne_bruge_gruppen":"members that will no longer be able to use the group","skriv_slet_gruppen_herunder":"Write \"Delete group\" below:","slet_gruppen":"Delete group","uploadet":"uploaded"},"edit":{"redigér_gruppe":"Edit group"},"flextime":{"flextime":"Flexible hours","flextime_teacher_appear":"Only teachers using flexible hours will appear on the list."},"flextime_activator":{"aktivering_af_flextid":"Activation of flexible hours","aktiveringen_giver_alle_ansatte_brikker_til_flextid_i_deres_egen_kalender":"The activation give every employee the possibility of flexible hours in their calendars. ","aktivér_flextid":"Activate flexible hours"},"form":{"fejl_forhindrede_denne_gruppe_i_at_blive_gemt":"error prevented this group from being saved:","skriv_hvad_gruppen_hedder":"Enter the name of the group","skriv_om_gruppen":"Enter information about the group"},"hours":{"press_empty_bricks":"Click empty fields to create subject or adjust amount of subject hours."},"merge_calendars":{"merge_tables":"Shared calendars","new_merge_table":"Shared calendars"},"mine":{"ikke_medlem_af_nogen_grupper_endnu":"Not member of any groups yet."},"multical":{"help_for_table":null,"today":"Today","vaelg_klasse":"Choose grade/group","vaelg_lokale":"Choose location","vaelg_person":"Choose person"},"newother":{"fejl_forhindrede_denne_kalender_i_at_blive_gemt":"errors prevented this calendar from being saved:","opret_anden_kalender":"Create other calendar","opret_kalender":"Create calendar","skriv_evt_kalen":"Add something about the calendar","skriv_hvad_kalen":"Enter the name of the schedule..."},"pay_supplement":{"get":"Get","minutes":"Minutes","show_supplement":"Show supplement","supplement_type":"Type of supplement"},"school":{"video":"Video"},"schools":{"vælg_skole":"Choose school"},"show":{"bliv_medlem":"Become member","class_year":"grade/group/year","filer":"Files:","forlad_gruppen":"Leave group","gruppen":"group...","indlæg":"Posts:","opret_team":"Create team"},"substitute_pool":{"details":"Details","hours":"hours","mistakes_look":"errors, details below","notice":"Notice","notice_list_item_1":"Substitute hours are calculated as part of the total amount of teaching hours for the teacher.","notice_list_item_2":"Substitute lessons are displayed in the substitute's calendar as the name of the original lesson, eg. 'Math', 'Science'.","pool":"Pool","rest":"Remaining","substitute_hours_per_month":"Substitute hours used per month","substitute_overview":"Substitute overview","there_was":"There was","total_substitute_pool":"Total substitute pool:","total_used_substitute_hours":"Used substitute hours in total:","total_used_substitute_hours ":"Total used substitute hours:","used":"Used","vis_timer":"Show "},"users":{"ical":"iCal:","initials":"Initials","users":"Staff"}},"import":{"csv_overview":{"i_fil":"In file:","ikke-fundne_klasser_oprettes_i_skoleåret_hvor_der_importeres_til":"Grades/groupses not found will be imported to the school year which is currently being imported to. ","ikke-fundne_lokaler_oprettes":"Locations not found are being created","ikke-fundne_lærere_oprettes_med_initialer":"Teachers not found will be created by initials. ","ikke_fundet":"Not found","import":"Import","kontrollér_at_disse_er_rigtige":"Please check information for errors.","lagt_sammen":"Added together: ","lokaler":"Locations","lærerer":"Teachers","ringetider":"Phone hours","til_uge":"Until week: "},"result":{"der_var_nogle_fejl":"Error(s) occured","import_afsluttet":"Import finished","ingen_fejl_i_import":"No errors in import"}},"jobs":{"copy_events_year_job":{"calendar_is_copied":"The calendar %{calendar_name} has been copied"}},"js":{"all_day":"All day","calculating_and_controlling":"Copying and calculating...","changes_may_not_be_saved":"Changes you have made will not be saved","click_keyboard_shortcuts_to_copy":"To copy: ⌘ + C or ctrl + C","close_without_saving":"Close without saving?","copied":"Copied!","error_occured":"An error has occured."},"layouts":{"application":{"dage":"days","der_er_ikke":"Connection lost! Check your internet connection.","din_profil":"Your profile","hjem":"Home","kurser":"Courses","køb_nu":"Buy now","log_ud":"Log out","profil":"Profile","prøveperiode_slutter_om":"Trial ends in","skal_slettes_for_sig_selv":"must be deleted on its own. ","skift_kodeord":"Change password","slet_indlæg":"Delete post","soeg":"Search","vil_du_deaktivere":"Do you want to deactivate the school?","Ønsker_du_at_slette_dit_indlæg":"Do you want to delete your post?"},"blank":{"der_er_ikke":"There's not"},"devise":{"book_en_gratis_demo":"Book a free demo","docendodk":null,"kontakt":"Contact","log_ind_med":"Log in with","log_ind_med_email":"Log in (E-mail)","login":"Login","med_en_fuldt_integreret":null,"om_docendo":"About Docendo","om_os":"About us","tlf_70_40_02_10":"Phone: (+45) 70 40 02 10","udviklet_i_samarbejde_med_ledere_lærere_og_pædagoger":null,"uni":null},"public":{"skal_slettes_for_sig_selv":null,"slet_indlæg":"Delete post","Ønsker_du_at_slette_dit_indlæg":"Do you want to delete your post?"},"schools":{"users":{"create_user_by_alias":"Create fictional staff member","create_user_by_email":"Create user with e-mail","create_user_by_unilogin":null,"merge_users":"Merge users","transfer_calendar":"Transfer calendar (periodic)"}}},"materials":{"details":{"antal_downloads":"Amount of downloads:","beskrivelse":"Description:","detaljer_om_filen":"About the file","dialog_om_filen":"Dialogue about the file","dokumenttype":"Type of document","klassetrin":"Grades:","status":"Status:","uploadet_af":"Uploaded by:"},"edit":{"redigér_fil":"Edit file","vis":"Show"},"form":{"dit_materiale_er_gemt":"Your material has been saved","fejl_forhindrede_dette_materiale_i_at_blive_gemt":"error(s) prevented this materiale from being saved:","filnavn":"File name:","gem_materiale":"Save material","skriv_noget_relevant":"Write something relevant","titel_på_fil":"Title","venligst_udfyld_nogle_informationer_om_materialet":"Please enter information about the item","vælg_dine_fag":"Choose your subjects","vælg_dokumenttype":null,"vælg_dokumenttyper":"Choose document types","vælg_klassetrin":"Choose grade","vælg_status":"Choose status"},"index":{"antal_hentede":"Downloaded number of times","klassetrin":"Grade"},"material":{"fra":"from","mere_info":"More info","uploadet_af":"uploaded by"},"new":{"gem_materiale":"Save"},"new1":{"attach_files":"Attach files"},"popedit":{"dit_materiale_er_gemt":null,"erstat_materiale":null,"fejl_forhindrede_dette_materiale_i_at_blive_gemt":null,"gem_materiale":null,"giv_nogle_informationer_om_materialet":"Enter information about the material","vælg_dine_fag":"Choose your subjects","vælg_dokument":"Choose document types","vælg_klassetrin":"Choose grade","vælg_status":"Choose status"},"show":{"beskrivelse":"Description:","group":"Group:","post":"Post:","tags":"Tags:","user":"User:"},"sidebar":{"nyeste":"Newest","populære":"Popular","se_alle":"Show all"},"upload":{"del_et_materiale":null,"upload":"upload.","vælg_et_dokument":"Choose a document"}},"models":{"calendar":{"beregn_timer":"Calculate time","flex_ind":"Flex in","flex_ud":"Flex out"},"group":{"alle":"All","already_created":"has already been created","share_with":"Share with","skolen":"The school","team":"Team","ukendt":"unknown"},"group_school":{"importerede":"Imported","med":"with","oprettede_klasse":"Created grade/group","oprettede_lærer":"Created teacher","uden_lærer_i":"without teacher in"},"import_lesson":{"invalid":"Invalid"},"material":{"skal_vælges":"Must be chosen"},"pay_supplement_rule_school_camp":{"lejrskole":null},"pay_supplement_rule_substitute":{"ekstern_vikar":"External substitute"},"post":{"synes_godt_om":"Like"},"subject_period":{"timer_uge":"Hours/week"},"user":{"ukendt":"unknown"}},"notifications":{"form":{"indhold":"Contents:","link_https__skal_tilføjes_hvis_linket_er_eksternt":null,"notifikationer":"Notifications","overskrift":"Title:"},"index":{"notifikationer":"Notifications","opret_ny":"Create new","siden":"ago"},"notification":{"siden":"ago"},"show":{"brugere":"users","link":"Link:","læst_af":"Read by","notifikationer":"Notifications","sendt_til":"Visible to","sidst_opdateret":"Last updated:","skrevet_af":"Posted by"}},"posts":{"edit":{"redigér_indlæg":"Edit post","vis":"Show"},"form":{"del_noget":"Write something...","fejl_forhindrede":"errors prevented this post from being saved","tilføj_kommentar":"Add comment..."},"new":{"nyt_indlæg":"New post"},"post":{"antal_downloads":"Number of downloads","comments":"Comments","from":"from","show":"Show","since_in_group":"ago in group","slet_indlæg":"Delete post"},"show":{"bruger":"User:","indhold":"Contents:"}},"rack_dev_mark":{"development":"development"},"repitition":{"add":"Add","administration":"Administration","aktivitet":"Activity","all_calendars":"All calendars","annuller":"Cancel","archive":"Archive","brikker":"Activities","brugeradministration":"User management","calendaradministration":"Calendar administration","choose":"Choose","chooselanguage":"Choose language","create":"Create","dagens_fraværende":"Absent today","dagens_vikarer":"Substitutes today","dearchive":"Unarchive","delete":"Delete","deleting":"Deleting","din_kalender":"Your schedule","docendo":"Docendo - flexible scheduling","email":"E-mail","enddate":"End date","endtime":"End time","errors":"errors","fag":"Subjects","feriekalender":"Holiday calendar","fjern":"Remove","fjern_brugere":"Remove users","flextidsoversigt":"Overview of flexible hours","fra_og_med":"from","from":"from","gem":"Save","hour":"hour","kalender":"Schedule","klass":"grade/group","klasser":"Grades/ groups","klasser_lille":"grades/groups","kr":null,"langfravær":"Prolonged absence","lesson":"the lesson","luk":"Close","materialer":"Materials","medlem":"member","medlemmer":"members","merge_calendar":"shared calendar","merge_calendars":"shared calendars","målstyring":null,"navn":"name","none":"None","opgaveoversigt":"Task overview","opret":"Create","opret_brik":"Create subject","opret_fraværsgrund":"Create absence reason","opret_tilføj_bruger":"Add user","oprettet":"Created:","other_calendar":"other calendar","other_calendars":"other calendars","planlægning":"Planning","processing":"Processing","rediger":"Edit","replace":"Replace","replace_lesson":"Replace lesson","room":"location","rooms":"locations","se_kalender":"See schedule","search":"search","search_for":"search for","select_user":"Select user","send":"Send","show":"Show","skema":"Schedule","skemaoverblik":"Schedule overview","skole":"School","skoler":"Schools","skoleår":"School year","skriv":"...","startdate":"Start date","starttime":"Start time","substitute":"Teacher substitutes","superadmin":"Superadmin","support":"Support","swap":"swap","swap_lesson":"Swap lesson","tilbage":"Back","tildel_timer":"Assign hours","timefordeling":"Subject hours","timer":"Hours","timeudtraek":"Activity overview","titel":"Title","today":"Today","unauthorized_access":{"help":"Your user is not associated with a school on Docendo. Please contact your school administration.","no_access":"You don't have access."},"until":"until","user":"user","users":"users","vikardækning":"Substitutes","vikarpuljer":"Substitute pools","vis_skemaer_til_elever":"External view","with":"with","yearplan":"Year planning","Årsoverblik":"Year overview","år":"Year","årsplanlægning":"Year planning"},"rooms":{"create_room":"Create room","edit":{"er_du_sikker":"Are you sure?","redigér_lokale":"Edit location","slet_lokale":"Delete location"},"form":{"fejl_forhindrede_dette_lokale_i_at_blive_gemt":"error(s) prevented this location from being saved:"},"new":{"nyt_lokale":"New location"},"room_is_not_created":"Room does not exist","rooms":{"new_room":"New location","rooms":"Locations"}},"schools":{"calendar_transfers":{"new":{"activity_count":"Activities","from_date":"From","have_calendar":"Has a calendar ","including_both":"start & end dates included","period":"Period","receive_calendar":"Will receive calendar ","replacee_in_period":"Takes over the schedule","replacement_in_period":"Temporary replacement","title":"Let a user take over another user's calendar activities - eg. in case of maternity leave etc.","to_date":"Until","transfer":"Transfer","transfer_calendar_for_a_period":"Transfer calendar","warning":"Can not be undone."}},"onboarding":{"administration_and_counting":"Administration and counting ","assign_user_hours":"Assign hours to teachers","create_calendars":"Create schedules","create_classes":"Create grades/groups","create_fixed_hours":"Create shared calendars","create_merge_calendars":"Create shared calendars","create_other_calendars":"Create other calendars","create_rooms":"Create locations","create_school_year":"Create school year","create_teachers":"Create teachers","create_your_school":"Setup of your school","follow_the_steps":"Follow these steps to get started","import_of_schedules":"Import of existing schedules?","import_of_schedules_content":"If wanted, we'll import your existing schedules from a CSV-file. Send us a mail, and you'll receive instructions.","make_room_bindings":"If wanted, add location","scheduling_classes_calendars":"Scheduling grades/groups","select_vacationdays":"Enter vacation days","show_calendars_to_students":"Make schedules available to students/parents.","student_scheduling":"Create grade/group schedules","user_tasks":"Task overview for teachers"},"user_merges":{"new":{"merge_on_this_user":"Merge on this user","title":"Merge users in case of two similar users etc. All scheduled activities will be merged on one user.","warning":"Merge can't be undone."}},"users":{"index":{"actions":"Actions","help":"Click on picture to insert new picture. Initials are editable. ","photo":"Photo"},"user":{"invite":"Invite","remove":"Remove"}}},"search":{"post":{"siden_i_gruppen":"ago in the group"},"search_content_type_filter":{"alle":"All","grupper":"Groups","opdateringer":"Updates","profiler":"Profiles","vis_resultater_for":"Show results for"},"search_filter":{"filtre":"Filters","type_af_materiale":"Type of material","vælg_dine_fag":"Choose your subjects","vælg_dokumenttyper":"Choose document types","vælg_fag":"Choose subject","vælg_klassetrin":"Choose grade","vælg_status":"Choose status"},"search_results":{"antal_hentede":"Number of downloads","grupper":"Groups","klassetrin":"Grades","none":"We're sorry - no matches!","opdateringer":"Updates","profiler":"Profiles","viser_Res_for":"Show results for"}},"sidebars":{"get_started_new_year":{"assign_hours_employees":"Assign hours to employees","follow_steps":"Follow the steps below","get_started":"Get started","other_calendars":"other calendars","time_distribution":"Distribution of subjects and hours in grades/groups"},"school":{"other_calendars":"Other calendars (eg. team calendars)"},"substitution_links":{"assign_substitutes":"Assign substitutes","substitute_cover":"Substitutes"}},"signups":{"by_existing_users":{"new":{"already_user":"Can't log in? Contact your school administration to get access. ","try_free":"Try Docendo for free for 14 days"}},"new":{"create_signup":"Sign up","i_accept":"I accept","password_rule":"(at least 8 characters)","signup":"Create demo","terms_of_service":"Terms of service"}},"subject_periods":{"edit":{"antal_uger":"Weeks","fordel_timer_i_perioden":"Distribute lessons in the chosen period","opdatér":"Update","skoledage_i_perioden":"School days in this period","slet":"Delete","timer_i_perioden":"Hours in this period"}},"subjects":{"edit":{"arkiver":"Archive","arkiver_denne_brik_den_vil_ikke_længere_være_synlig":"Archive this item? It will no longer be visible.","arkiverer":"Archiving ","er_du_sikker":"Are you sure?","redigér_brik":"Edit","slet_brik":"Delete","vil_du_arkivere_denne_brik":"Do you want to archive this? It will no longer be visible."},"inner_edit":{"absence":"Absence","absence_description":"Reason of absence","anden_tid":"Other tasks","anden_tid_description":"not teaching.","antal_minutter_modul":"Enter the standard length (minutes) of subjects","antal_timer_på_år":"Enter amount of hours per year","bevægelse":"Exercise","bevægelse_description":"fully counting and independent from other activtites in the same period of time. ","fag":"Subject","fag_description":"counting hours for the grade/group. Two simultaneous activities counts as halves. ","fejl_forhindrede_denne_brik_i_at_blive_gemt":"errors occured","frame":"Theme","frame_description":"can be used for marking themes and special days in the grade/group schedule. The themed activity is visible for the pupils and parents, while grades/groups that are overlapping the themed activity will not be visible. Lessons are fully counting, and the themed activity is not.","klasser_andre_kalendre":"Classes/Other calendars","lokation":"Location","normal_varighed_i_minutter":"Standard duration (minutes)","oovrig_tid":"Additional tasks","oovrig_tid_description":"not grades/groups and teaching, non-pupil related.","optional":"Optional grades/groups","optional_description":"Fully counting and independent from other activities in the same time period.","pause":"Break","pause_description":"Subjects should not overlap with breaks.","ressource":"Ressource","ressource_description":"can be used to register ressources. Is not visible to students/parents.","skriv_et_bogstav_for_at_søge":"Search...","skriv_hvad_brikken_hedder":"Enter the name of the subject/event","sygdom_ferie_etc":"Sick leave, holidays etc.","timer_på_årsbasis":"Total hours (in school year)","underviser":"Teacher","uuv":null,"uuv_description":null,"vælg_briktype":"Choose subject type","vælg_farve":"Choose color","vælg_klasser":"Search and choose grades"},"new":{"ny_brik":"New subject"},"subject_accordion_menu":{"absence":"Absence","break":"Break","exercise":"Exercise","flextime":"Flexible hours","frame":"Theme","optional":"Electives","other_stuff":"Additional tasks","other_tasks":"Other tasks","pay_supplement":"Supplement","person_resource":"Ressource","resource":"Ressource","subject":"Subject","supplemental":"Supplement grades/groups"},"subject_draggable":{"hours_per_year":"h/year","per_week":"/week"},"ws_edit":{"er_du_sikker":"Are you sure?","opdater_brik":"Update subject","redigér_brik":"Edit subject","slet_brik":"Delete subject"}},"substitutes":{"edit":{"i_dag":"Today","ingen_lektioner_for":"No lessons for","klasse":"Grade/group","også_tilknyttet":"Also on this lesson","se_alle":"See all","se_mindre":"View less","søg_og_vælg":"Search and choose","vikar":"Substitute","vikar_for":"Substitute for","vikarnoter":"Substitute notes"},"known_absence":{"byt":"Swap","feriedage":"Holidays","fraværende_med_lektioner":"Absent teachers with lessons","kalenderen_for_7b":null,"kursus":"Course","lektioner":"lessons","lektioner_der_kan_byttes_med":"Lessons that can be swapped:","lektioner_der_skal_håndteres":"Lessons to be administered:","opret_fravær":"Add absence","opret_planlagt_fravær":"Enter absence","syg":null},"substitute_day":{"klasse":"Grade/group"},"substitutes_edit":{"fraværsårsager_og_skemaoverblik":"Absence reasons & schedule overview","tilføj_kalendre":"Add schedules","vælg_klasse":"Choose grade/group","vælg_lokale":"Choose location","vælg_person":"Choose person","vælg_person_vikardækning":"Choose person(s)"},"substitutes_show":{"ingen_vikarer_i_dag":"No substitutes today"},"substitutes_show_teachers":{"ingen_fraværende_i_dag":"There's nobody absent today"}},"time":{"formats":{"day_only":null,"devise":{"mailer":{"invitation_instructions":{"accept_until_format":"%B %d, %Y %I:%M %p"}}},"time_only":"%H:%M"}},"unilogin":{"welcome":{"create_a_trial":"Create a free trial?","eller":"or","enten_giver_din_stilling_dig_ikke_mulighed_for_at_kigge_med_eller_også_er_din_skole_er_ikke_på_docendo_endnu":"You do not have access to Docendo.","hvis_du_vil_have_din_skole_på_docendo_så":"If your school would like to use Docendo, then","kontakt_os":"contact us","prøv_en_demoperiode":"start a free trial","student_or_parent":"Are you a student or parent?","student_or_parent_info":"If you are looking for your own or your childs schedule, this should typically be found on the schools website. We recommend that you contact the school administration if you can't find the schedule.","velkommen":"Welcome"}},"users":{"assign_user_hours":{"anden_tid":"Other tasks","der_var":"There was","fejl_se_nedenfor":"errors. See details below.","lommeregner":"Calculator","skemalagt":"Scheduled","tildeling_af_timer":"Assign hours","tildelt":"Assigned","total_på_år":"Year total","undervisning":"Teaching","Øvrig_tid":"Additional tasks"},"create":{"add_user":"Add user","add_user_with_uni":null,"create_teacher":"Create teacher","fictive_user":"User without login","fictive_user_text":"The user can be used in scheduling but does not have a login. ","notify_user_more_users":"You must provide users with a message about the addition. You can enter multiple usernames in the field below, separated by spaces.","user_does_not_exist":"Teacher does not exist","user_with_email":"User with e-mail","user_with_email_text":"Add user with e-mail. The user can log in with e-mail and password. The user will receive instructions."},"edit":{"annullér":"Cancel","redigér_bruger":"Edit user"},"files_for_download":{"files_to_download":"Files to download"},"form":{"andre_undervisere_vide":"What would other teachers want to know about you?","beskrivelse":"Description","du_kan_skrive_om_dine_interesser_fag_klassetrin_færdigheder_etc":"you can write about your interests","email":"E-mail","fejl_forhindrede_denne_bruger_i_at_blive_gemt":"error(s) kept this user from being saved. ","fjern_profilbillede":"Remove profile picture","hvilke_fag":"Which subjects","hvilke_klassetrin_underviser":"(What grades do you teach?)","initialer":"Initials","initialer_på_skolen":"Initials","klassetrin":"Grades","opdatér_profil_fra_uni-c":null,"profilbillede":"Profile picture","skriv_dit_navn":"Enter your name","upload_nyt_profilbillede":"Upload new profile picture?","vælg_dine_fag":"Choose your subjects","vælg_dine_klassetrin":"Choose your grades"},"hours":{"skoleåret":"School year"},"hours_list":{"_vikartimer":"Substitute hours","min":"min","vikartimer":"Substitute hours"},"hours_status":{"anden_tid":"Other tasks","ingen_data":"No data","tildelt":"Assigned","undervisning":"Teaching","øvrig_tid":"Additional tasks"},"list_all":{"alle":"All"},"members":{"personale":"Staff","se_alle":"See all"},"net_promoter_scores":{"new":{"nps_question":"How likely is it that you would recommend docendo to a friend or colleague?","question_one":"What is the most important reason for your score?","reason":"We are making a scheduling tool for people. This is hard to do without the people using it giving us feedback on how to make it better. We hope you'll help us by answering the two following questions. ","very_likely":"Very likely","very_unlikely":"Not likely"}},"password":{"bekræft_nyt_kodeord":"Confirm new password","fejl":"error:","nyt_kodeord":"New password","skift_kodeord":"Change password"},"profile":{"klassetrin":"Grade","om_mig":"About me","underviser_i":"Teach in"},"remove_users_list":{"delete_user":"Delete user","press_remove_to_remove":"Click 'remove' to remove user from Docendo.","remove_list_item_1":"When a user is removed, he or she no longer has access to the school's calendars.","remove_list_item_2":"The user will NOT be removed from lessons.","remove_list_item_3":"The user will be deleted from the school."},"show":{"aktivitet":"Activity","filer":"Files:","grupper":"Groups","indlæg":"Posts:","medlem_i":"Has been a member for:"},"si_teachers_list":{"træk_læreren_fra_venstre_til_højre_for_at_tildele_initialer":"Drag the teacher from left to right to assign initials"},"substitute":{"følgene_lærere_er_ledige_i_tidsrummet":"The following teachers are available in this time.","ingen_lærere_er_ledige_i_tidsrummet":"No teachers are available in this time.","kl":null,"vælg_vikar":"Choose substitute"},"tasks_status":{"fag_opgave":"Subject/task","lagt_i_skema":"Scheduled","tildelt":"Assigned","tilhører":"Belongs to","total":"Total"},"user_item_abandoned_user":{"grupper":"Groups:","indlæg":"Posts:","kalenderaftaler":"Items in calendar:","material_count":null},"user_item_profile_calendar_lastseen":{"se_profil":"View profile","se_tildeling":null},"user_item_remove_user":{"delete_user":"Delete user"},"user_item_select_substitute":{"vælg_som_vikar":"Choose as substitute"},"user_merge_details":{"aftaler":"Scheduled items","groups":"Schools"}},"views":{"pagination":{"first":"First","last":"Last","next":"Next","previous":"Earlier","truncate":"..."}},"vue":{"buy":{"a_user_is":"A user is an employee who has a calendar and/or a login.","billed_monthly_or_yearly":"Monthly of yearly billing?","buy":"Buy","buy_access_for_school_users":"Buy acess for school staff","call_us_at":"Call us at","choose_the_right_price":"Choose the right price for your school","discount":"Discount","error":"Error","go_to_home":"Click here for 'Home'","institution":"institution","missing_inputs":"You need to fill in all of the fields.","month":"month","only_pay_per":"Only pay for the users able to make schedules and/or have a login.","pay_for_unlimited_users_and_get":"Pay for the schools total number of students, and get an unlimited number of users on","payment_info":"Payment info","per_month":"Per month","per_student":"per student","per_user":"per user","per_year":"Per year","popular":"popular","price":"price","questions":"Questions","save_2":"Save 2%","school_name":"School name","subscription_info":"Subscription info","thanks_for_buying":"Thanks for your purchase.","total":"Total","total_student_number":"Total number of students","unlimited":"Unlimited","write_number_of_students":"Enter the total number of students - gain access for unlimited amount of users.","write_number_of_users":"Enter the total amount of users that will be used in scheduling or will have access to Docendo *","your_email":"Your e-mail","your_invoice":"Your invoice","your_name":"Your name","your_phonenumber":"Your phone number"},"deleteday":{"delete_day_or_week":"Delete day/week","whole_week":"Whole week"},"intro_home":{"step1_title":"Welcome to Docendo","step3_title":null,"step4_content":null,"step4_title":null,"step5_content":null,"step5_title":null},"public":{"app":{"sidenav":{"changeview":"Change view","showday":"Show day","showweek":"Show week","showweekplan":"Show weekplan"}},"no_notes":"No notes for the week"},"recent_users":{"last_seen":"last seen","never_logged_in":"never logged in"},"sidenav":{"merge_calendar_special":"shared calendars"},"vacations_days_selector":{"choose_period":"Choose period","school_days":"school days","school_year":"school year","vacation_for_pupils":"School year and holidays"},"year_planning":{"distribute_hours_over_year":"Distribute hours","hours_during_period":"Hours","norm":"Assigned","number_of_weeks":"Amount of weeks","planned":"Planned","school_days_during_period":"School days during period"}}}}

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	module.exports = {"copycalendar":{"copy":"Copy","paste":"Paste","pasteThisWeek":"Paste in this week","weekSelected":"week selected","weeksSelected":"weeks selected","markWeeksFrom":"Select weeks from","allWeeks":"All weeks","oddWeeks":"Odd weeks","evenWeeks":"Even weeks","unselectAll":"Unselect all","deleteLessonsInSelectedWeeks":"Delete and replace lessons in selected weeks","absenceWillNotBeDeleted":"absence will not be deleted","noticationMessage":"Inserting...","copiedFrom":"Copied from","noSubstitutesOrNotes":"There are no lessons with substitutes or notes in the selected weeks","youAreAboutToDelete":"You are about to delete","lesson":"lesson","lessons":"lessons","withSubstitutesOrNotes":"with substitutes or notes","week":"week"},"homevideoes":{"video":"Video","video_guide":"Video guides","introduction":"Introduction to Docendo","watch_intro":"See intro to Docendo","klass_schedule":"Grade/group timetable","klass_schedule_overview":"Overblik over klasseskemaet","teacher_calendar":"Teacher's schedule","teacher_calendar_overview":"About the teacher schedule","notes_weekplan":"Notes & week plan","notes_weekplan_overview":"Use notes & week plans","learn_to_substitute":"Learn how to manage substitute teachers"},"vSelect":{"choose_persons":"Select user(s)"},"substitute_hours":{"title":"Show events for teachers","choose_period":"Choose period","all":"All","teaching":"Teaching","substitute_hours":"Substitute hours","absence":"Absence","work_days":"day(s)","lessons":"lesson(s)","calendar_event":"calendar event","calendar_events":"calendar events","substitute_for":"Substitute for","substitute_hour":"Substitute hour","other_tasks":"Other tasks","other_stuff":"Other stuff","total":"Total","hours":"hours","hour":"hour","min":"min","shortcuts":"Shortcuts","show_all_absent":"Show all absent during the period","getting_all":"Getting all","absent_in_the_period":"absent during the period","there_is_no_one_absent":"There are no absences during the period","days_with_absence":"Days with absence"},"notifications":{"notifications":"notifications","all":"All","unread":"Unread","mark_all_as_read":"Mark all as read","sent_from":"Sent from","mark_as":"Mark as","read":"Read","not_read":"Unread","no_new_notifications":"No new notifications"},"presence":{"work_hours":"Working hours","set_work_hours":"Enter your working hours","choose_weeks_for_work_hours":"Choose weeks","work_hours_in_the_week":"Total hours in week","cancel":"Cancel","copy_to_multiple_weeks":"Copy to multiple weeks","back":"Back","save":"Save","times_may_not_overlap":"Times may not overlap","hours":"hours","minutes":"min","h":"h","m":"m","present":"Present","not_present":"Not present","total_working_hours":"Working hours for the year"},"createusers":{"create_users":"Create staff member(s)","login_options":"Login option(s)","can_be_added_later":"can be added later","must_be_added":"Is required","name":"Name","mail":"email","placeholder_name":"Name Lastname","placeholder_email":"name@schoolmail.com","email_error_text":"It doesn't look like an email address","add_more":"Add more","create":"Create","user":"staff member","users":"staff members","user_created":"Staff member created!","users_created":"Staff created!","feide_is_already_used_for":"Feide is already used for"},"createuser_button":{"create_user":"Create staff member"},"toast":{"something_went_wrong":"Something went wrong"},"subject":{"azure":"Azure","blue":"Blue","bronze":"Bronze","brown":"Brown","coral":"Coral","grey":"Grey","green":"Green","purple":"Purple","lightblue":"Light blue","lightblue2":"Lighter blue","lightbrown":"Light brown","lightgreen":"Light green","lightyellow":"Light yellow","lightyellow2":"Lighter yellow","lightpurple":"Light purple","lightred":"Light red","marinoblue":"Navy","darkblue":"Dark blue","darkgreen":"Dark green","darkyellow":"Dark yellow","darkpurple":"Dark purple","darkorange":"Dark orange","darkorange2":"Darker orange","orange":"Orange","red":"Red","red2":"Dark red","turkis":"Turquoise"},"createklass":{"create_klasses":"Create grade(s)/group(s)","schoolyear":"School year","klass_name":"Grade/group name","klass_step":"Grade/group step for import of courses (optional)","import_subjects_question":"Do you want to import subjects for this grade/group?","import_subjects_done":"These subjects will be created in the grade/group","subjects_for":"Courses for","klass":"grade/group","klasses":"grades/groups","hoursPrYear":"h/year","grade":"grade","warning_text":"Grades/groups can't have the same name","succes_text":"(s) created!","creating":"Creating","import_subject_to_the_klass":"Import courses into grades/groups","subjects_created_successfully":"Courses are created"},"createrooms":{"create_rooms":"Create location(s)","room_name":"Location name","placeholder":"Science classroom","room":"location","rooms":"locations","warning_text":"Locations can't have the same name","succes_text":"Location(s) created!","creating":"Creating"},"createroom_button":{"create_room":"Create location"},"editCalendarEditName":{"edit_name":"Edit name","calendar_name":"Calendar name","warning_text":"Name can not be empty","update_name":"Update name","success_text":"Name is updated!"},"editCalendarMenu":{"edit_name":"Edit name","delete_calendar":"Delete calendar","remove_calendar":"Remove calendar","view":"View","5_days":"5 days","7_days":"7 days","7_days_and_24_hours":"7 days, 24 hours","lock":"Lock calendar","unlock":"Unlock","calendar_is_locked":"Calendar is locked","merge_with_merge_calendars":"Merge with shared calendars","merge_with_calendar":"Merge into calendar","is_merged":"Is merged into","can_be_merged_into":"Can be merged into","see_public_view":"View student display","active_public_view":"Activate student display"},"editCalendarDelete":{"delete_calendar":"Delete calendar","deleting_this_calendar":"You are about to delete this calendar","all_data_will_be_deleted":"All calendar activities will be deleted PERMANENT, and data can not be restored.","validator_name":"delete calendar","write":"write","if_you_want_to_delete":"if you want to delete this calendar","you_have_to_write":"You have to write","success_text":"Calendar deleted"},"setupWidget":{"do_steps_for_scheduling":"Follow these 4 steps to get started","get_going_easy":"Quick Guide","follow_these_steps":"Follow the tutorials in the videos","write_us":"Chat with us","support_forum":"Support forum"},"createmerge":{"create_merge":"Create shared calendar(s)","name":"Name","placeholder":"Breaks","calendar":"calendar","calendars":"calendars","warning_text":"Calendars can not have the same name","succes_text":"Calendar(s) created!"},"sidenav":{"not_created_klass":"You have not created any grades/groups","not_created_users":"You have not created any staff members","not_created_rooms":"You have not created any classrooms/locations","not_created_merge":"You have not created any merge calendars","not_created_other":"You have not created any other calendars"},"year_transfer":{"copy_klasses_from":"Copy calendars from the school year","to":"to","copy_nothing":"Do not copy","klass_name":"Calendar name","klass_name_desc":"Copy a calendar with the same name to the new school year, without courses.","klass_name_and_subjects":"Calendar name and courses, incl. requiered hours of instruction.","klass_name_and_subjects_desc":"Copy a calendar with the same name and courses to the new school year, incl. requiered hours of instruction.","klass_name_and_subjects_with_teachers":"Calendar name and courses, incl. requiered hours of instruction, aswell as teachers and classrooms.","klass_name_and_subjects_with_teachers_desc":"Copy a calendar with the same name and courses, incl. required hours of instruction. Teachers and classrooms attached to the courses will also be copied.","choose_all":"Choose all","img_src_one":"http://support.docendo.dk/img/transferyear/1EN.png","img_src_two":"http://support.docendo.dk/img/transferyear/2NO.png","img_src_three":"http://support.docendo.dk/img/transferyear/3EN.png","year_transfer_link":"Do you want to create grades/groups with names and subjects from last school year? click here","from_week_33_in":"from week 33 in","to_week_33_in":"to week 33 in","klass_name_and_subjects_with_teachers_and_schedules":"Grades/groups and courses incl. requiered hours of instruction and associated teachers, classrooms and schedules","calendar_already_exist":"the calendar already exists","everything_is_copied_except":"Everything is copied except associated grades","everything_is_copied_except_tooltip":"If there are more than one class associated with the pieces, these will not be copied as the associated classes belong to the previous school year","and_schedules":"and schedules","from_week":"From week","to_week":"To week"},"assign_users_hours":{"assign_hours":"Assign hours","search_a_name":"Search by name","work_hours":"Working hours","teaching":"Teaching","substitute_hours":"Substitute hours","absence":"Absence","name":"Name","assigned":"Assigned","scheduled":"Scheduled","diff":"Difference","update":"Update numbers","applies_to_the_period":"Applies to the period","tasks":"Tasks","preparation":"Preparation"},"tagging":{"tagging_users":"Grouping of staff members","users_selected_from":"Staff selected from","add_tag_to":"Add tag to","select_persons_first":"Select staff members first","select_all":"Select all","unselect_all":"Unselect all","already_created":"Already created","example_tags":"Eg. Teachers, Teams, Substitutes","create_tag":"Create tag","search_tag":"Search tag","create_tags":"Create tags","with":"with","you_have_created_zero_tags":"You have created 0 tags"},"dselect":{"no_matching_results":"No matching results","placeholder":"Search for a staff member","create_user":"Create staff member,","in_same_klass":"In same grade/group","placeholder_calendars":"Search and select"},"substitution":{"substitution":"Substitutes","none_absent":"No absence","number_absent_today":"Number of teachers absent","today":"Today","create_absence":"Add absence","who":"Who","person_must_be_filled":"Name must be filled in","reason":"Reason for absence","choose_absence_reason":"Choose reason for absense","create":"Add","reason_must_be_filled":"Reason must be filled in","date":"Date","time":"Time","absent_period":"Period of absence","do_you_want_to_delete_the_absent_reason":"Do you want do delete reason of absence","yes":"Yes","cancel":"Cancel","substitutes_will_not_be_removed":"Substitutes on lessons will not be deleted. These can be deleted beforehand.","subject":"Subject","class":"Grade/group","other_users":"Other staff members","substitute":"Substitutes","substitute_notes":"Substitute notes","todays_lessons":"Todays lessons","see_all":"View all","see_less":"View less","absence_is_created_in_a_calendar":"Ansence is added in a calendar, and has to be deleted from this calendar.","go_to_calendar":"Go to calendar","deleting_absence_from":"Delete absence from","to":"to","choose_absence_user":"Choose absent teacher","absence_notes":"Note for absence","add_sub_to_several_lesson":"Add substitute to several lessons","find_sub_for":"Find substitute for","lessons":"lessons","finding_available_subs":"Searching for available substitutes","select_lessons_to_substitute":"Select lessons to substitute","overlap":"overlap","available":"Available","do_you_want_to_save":"Do you want to save","no_close_without_saving":"No, close without saving","yes_save_my_changes":"Yes, save my changes","lessons_updated":"Lessons updated","lessons_without_sub":"Lessons without substitute","lessons_with_sub":"Lessons with substitute","all_lessons":"All lessons","no_lessons_without_subs":"No lessons without substitute","no_lessons_with_sub":"No lessons with substitute","no_lessons":"No lessons","remove_sub_from_all_lessons":"Remove as a substitute for all lessons","do_you_want_to_remove":"Do you want to remove","as_sub_on":"as a substitute on","or_on_all_lessons":"or on all lessons","remove_from_all_lessons":"Remove from all lessons","just_this_lessons":"Only this lesson","choose_period_lessons":"Select a period to view lessons","from_selected_date_onwards":"From the selected date onwards","entire_period":"The entire period","selected_date":"Selected date","lessons_that_overlap_in_class":"Also in grade/group","delete_lesson":"Delete lesson"},"substitution_user":{"multiple_days":"Multiple days","lessons_on_day":"Lessons this day","lessons_affected_by_absence":"Lessons affected by absence","absent":"Absent"},"substitution_show":{"show_all_lessons":"View all lessons","show_the_absent":"View absence","lessons":"Lessons","choosen_lessons":"Selected lessons"},"sub_scheduler":{"filter_substitutes":"Filtrate substitutes","sub_pools":"Substitute pools","todays_absent":"Todays absence","potential_subs":"Potential substitute","choose_sub":"Select substitute","status":"Status","sort_after":"Sort after suggestions","set_priorities":"Set priorities","sorting_will_be_based_on":"Sorting based on","already_on_lesson":"Additional teachers on same lesson","is_in_same_class_at_the_same_time":"Is in the same grade/group at the same time","multiple_lessons_in_same_classes":"+2 teachers simultaneously in another grade/group","not_occupied_with_available_lesson":"Available with 'On-Call'-event","not_occupied_with_work_hours":"Available within working hours","not_occupied_without_work_hours":"Available outside working hours","not_occupied_without_lessons_on_the_day":"Available w/o any lessons","occupied":"Occupied","it_will_also_be_sorted_based_on_tags_in_common":"The sorting also takes into account the number of tags in common with the absent teacher.","absent_people":"Absent","substitutes":"Substitutes","out_of":"out of","potential_substitutes":"Potential substitutes","pool":"Pool","choose_filters":"Select filters","list":"List","schedules_overview":"Schedules","is_substituted":"Is substituted"},"sub_scheduler_item":{"prolonged_absence":"Prolonged absence","also_on_lesson":"Also in lesson"},"sub_scheduler_popover":{"substitute_for":"Find substitute for","handled":"Covered","not_handled":"Not handled","handled_for_absence":"Handled for all absentees","pending":"Pending"},"sub_scheduler_sub_pools":{"substitute_hours":"Substitute hours","difference":"Difference","assigned":"Assigned","scheduled":"Scheduled"},"IEWarning":{"you_are_using_a_IE_or_Edge_to_get":"NB! You are using Internet Explorer/Edge. To get","a_faster_and_better_experience":"a faster and better experience","we_recommend_that_you_switch_to_these_browsers":"we recommend switching to","or":"or"},"dashboard":{"welcome":"Welcome","start_by_setting_up":"Start by setting up","steps_completed":"Steps completed","step":"Step","tutorial":"Tutorial","follow_the_steps":"Follow the quick guide"},"delete_day_or_week":{"cant_delete":"Couldn't delete. Try again."},"user_event_list":{"absence":"Absence","teaching":"Teaching","substitute_hours":"Substitute hours","from":"from","to":"to","no_matching_events":"List is empty","total":"Total","close":"Close"},"weekplan_2":{"no_events_this_week":"No lessons this week"},"event_form":{"delete_events_onward":"Delete this and on same timeslot forward","are_you_sure":"Are you sure?","do_you_want_to_delete_this_and_all_in_same_timeslot":"Would you like to delete this lesson and all that lie on the same day of the week and in the same time period going forward?","cancel":"Cancel"},"calendar_export":{"export_calendar":"Export calendar","export_calendar_to":"Export calendar to ...","copy_the_url_and_insert":"Copy this URL and paste it into the external calendar","guide_to":"Guide to","guide_to_export_calendar":"Guide on how to export to Outlook, Google or iCalendar,","create_a_link_on_mobile":"Setting up class schedules on mobile"},"common":{"search":"Search","show_print_hours":"Show calculated hours","show_as_blocks":"Show as blocks","show_as_table":"Show as table","show_as_list":"Show as list","add":"Add","save":"Save","saved":"Saved","dont_save":"Don't save","create":"Create","cancel":"Cancel","update":"Update","delete":"Delete","select":"Select","edit":"Edit","yes":"Yes","no":"No","save_changes":"Do you wish to save your changes?","ago":"ago","min":"min","class":"Grade/group","classes":"Grades/groups","classes_sidenav":"Grades/ groups","teacher":"Teacher","room":"Room","substitute":"Substitute","rename":"Rename","add_user":"Add staff member","press":"Press","user":"Staff member","users":"Staff","rooms":"Locations","shared_calendars":"Shared calendars","merge_calendar":"Shared calendar","merge_calendars":"Shared calendars","merge_calendars_sidenav":"Shared calendars","other_calendar":"Other calendar","other_calendars":"Other calendars","close":"Close","must_be_filled":"Required","something_went_wrong":"Something went wrong","show_weekends":"Show weekends","calendar":"Calendar","in":"in","search_for":"search for","remove":"Remove","none_created":"Ingen opprettet","log":"Activity log","no_calendars_found":"No calendars found..","done":"Done","is_deleted":"is deleted","choose_school":"Choose school","show_more":"Show more","show_less":"Show less","search_name_or_initials":"Search name or initials","hide_calendars":"Hide calendars","hide_dates":"Hide dates"},"weeknote_log":{"saved_versions":"Saved versions of the weeknote Gemte versioner af ugenoten","activity":"Activity log","no_saved_versions":"No saved versions","choose_versions_to_compare":"Choose versions to compare","current_version":"Current version"},"show_event":{"this_lesson_counts_as":"This lesson counts as"},"permissions":{"can_edit_subject_requests":"Can request subjects (when Subject Requests are open)","roles":"Roles","create_new_role":"Create new role","users":"Staff that are","users_assigned_role":"staff assigned role","add_user_to":"Add staff to","role":"role","permissions":"Permissions as","change_permissions_for_role":"Change permissions for role","rename_role":"Rename role","delete_role":"Delete role","give_role_a_title":"Give role a new name","choose_new_name":"Choose a new name","you_cant_delete_a_role_that_has_users":"You can't delete a role that has staff assigned","give_the_following_user_a_new_role":"Give the following staff a new role","can_change_substitution":"Can access Substitution Management","can_do_most_stuff":"Can do must stuff","can_edit_own_notes":"Can edit notes","can_export":"Can export data to Docendo ZEN","can_manage_absence_reasons":"Can manage absence reasons","can_manage_assigned_hours":"Can change Assigned Hours","can_see_assigned_hours":"Can see Assigned Hours","can_manage_school_years":"Can create and edit school years","can_manage_sms":"Can send SMS","can_manage_substitute_hours":"Can create, delete and edit substitute hours","can_manage_tasks":"Can manage tasks","can_manage_users":"Can create, edit and delete staff","can_see_other_calendars":"Can see schools calendars","can_manage_calendars":"Can create, edit and delete calenders","can_setup_aula":"Can change export to Aula","change_role":"Change role","role_desc_administrator":"An administrator can access all features and edit permissions for all roles.","role_desc_read_only_user":"A read only user can only access the user's own schedule, and the user can't edit anything or see other schedules. This role can be given the permission to edit notes from the user's own schedule.","role_desc_regular_user":"A regular user can access all schedules and most features, but the user can't add, edit or delete staff members and school years.","role_updated":"Role is updated","role_deleted":"Role is deleted","role_created":"Role is created","can_see_subjects_distribution_page":"Can access subjects distribution page","can_see_others_task_overviews":"Can see others task overview","can_see_own_task_overview":"Can see own task overview","can_edit_own_presence":"Can edit own working hours","can_edit_others_presence":"Can edit other working hours","can_edit_user_year_notes":"Can write and edit notes in others' task overview","can_send_substitute_email":"Can send emails","can_send_substitute_sms":"Can send SMS","select_role_to_base_new_on":"Select a role to base the new one on","done":"Done"},"calendars":{"calendars":"Calendars","edit_calendars":"Delete / rename calendars","copy_calendars":"Copy calendars","archive":"Remove","show":"Show","hide":"Hide","archived":"removed","unarchive":"Restore","write_name":"Write name","selected_of":"selected by","select_calendars_to_copy":"Select calendars to copy","copy":"Copy","select_week_to_copy_from":"Select week to copy from","select_weeks_that_week":"Select weeks as week","must_be_copied_to":"must be copied to","print_calendars":"Print calendars","add_presence":"Add working hours","delete_events_in_date_range":"Delete events in date range","delete":"Delete"},"sms":{"sms":"SMS","do_you_want_to_delete_the_template":"Do you want to delete this template","template_sms_deleted":"Template deleted","an_error_occured":"There was an error","add_number":"Add mobile number","number_must_be_8_digits":"Mobile number must be 8 digits","number_deleted":"Mobile number deleted","number_added_awaiting":"Mobile number added. Awaiting approval","edit":"Edit","new":"New","standard_sms":"Template","title":"Title","to_show_in_list":"to show on the list","ex_you_are_sub":"Eg. \"You have new assignments as a substitute teacher...\"","insert_today_to":"Insert [today] in template for the name of today, eg.","updated_sms_template":"Updated template","created_sms_template":"Created template,","message":"Message","subject":"Subject"},"subs_ongoing_absence":{"delete_absence":"Delete absence","change_start_and_end_date":"Edit start/end date","ongoing_absence":"Ongoing absence","ongoing_absence_explained":"Continuous absence is automatically extended when the original end date is reached. The end date is the expected last date of absence. The absence is extended by one day at a time until you end the absence.","date_label":"Date (first/last date included)","absence_will_be_deleted":"Absence will be deleted","remove_subs_and_delete_absence":"Remove subs and delete absence","keep_subs_and_delete_absence":"Keep subs and delete absence","remove_subs_and_update":"Remove subs and update","keep_subs_and_update":"Keep subs and update","remove_subs_and_stop_ongoing_absence":"Remove subs and stop continuous absence","keep_subs_and_stop_ongoing_absence":"Keep subs and stop continuous absence","confirm_date_and_stop_ongoing_absence":"Confirm date and stop continuous absence","update_dates":"Update dates","checking_for_substitutes":"Checking for substitutes","lessons_with_substitutes":"Classes with substitute","no_subs_on_lessons":"No substitutes on the dates chosen for deletion of absence","of":"of","lessons_that_will_have_subs_removed":"classes where subs will be removed","select_all":"Select all","unselect_all":"Clear","remove_sub":"Remove substitute","teachers_with_ongoing_absence":"Continuous absent teachers","no_teachers_with_ongoing_absence":"No continuously absent teachers","absence_will_be_prolonged_in":"Will be extended in","edit_stop":"Edit / stop","subs_removed":"Substitutes removed","absence_deleted":"Absence deleted","auto_created_today":"Autogenerated today","absence_updated":"Absence updated","stop_ongoing_absence":"Stop continuous absence","cant_be_ongoing_absence":"Continuous absence cannot be created with an end date earlier than today's date","auto_created":"Autogenerated"},"zen_import":{"import_from_zen":"Import schedules from ZEN to Docendo","choose_version":"Choose version","you_have_no_created_any_versions":"You haven't created any schedules in Docendo ZEN","last_updated":"Last updated","choose_schoolyear":"Choose schoolyear","insert_in_week":"Insert in week","insert_schedules":"Insert schedules","week":"Week","schedules_are_being_inserted":"Schedules will be inserted into week"},"create_calendars":{"other_calendar":"Create other calendar","other_calendar_placeholder":"E.g. Meeting calendar"},"create_subject":{"create_subject":"Create course","subject_is_not_created_in_this_school_year":"The course has been created. However, please be aware that it is associated with a school year that does not match the current date."},"task_overview":{"task_overview":"Task overview","no_tasks_assigned":"No tasks assigned","distribution":"Distribution","work_hours":"Work hours","teaching":"Teaching","tasks":"Tasks","preparation":"Preparation","show_scheduled_hours":"Show scheduled hours","coming_soon":"Coming soon","belongs_to":"Calendar","absence":"Absence","reset":"Reset dates","club":"Club","substitute_hours":"Substitute hours","showing_scheduled_hours_from":"Showing scheduled hours from","rest":"Remainder","pool":"Custom pool","unknown":"On-call","diff_from_total_workhours":"Difference in relation to total work hours"},"standard_settings":{"standard_setting":"Standard setting","set_default_start_and_endtime":"Set default start and end time"},"print_all_calendars":{"loading":"Getting events for all calendars. It may take some time..","no_calendars":"There is 0 calendars with lessons","are_you_ready_to_print":"Are you ready to print?","print":"Print","this_calendar_with_weekplan":"Calendar w. weekplan","this_calendar":"This calendar","all_classes":"All grades/groups","all_teachers":"All teachers","all_rooms":"All rooms","only_printing_calendars_with_lessons":"Only printing calendars with lessons","show_print_without_bg_colors":"Print without background colors","event_font_size":"Font size","custom":"Choose Calendars"},"edit_event":{"teachers":"Staff","substitutes":"Substitutes","rooms":"Rooms","klass":"Grades / groups","swap_headline":"The following lessons can swap times with the selected lesson","swap_desc":"The 'Swap' function is used to swap an existing lesson with another scheduled lesson from a different time in the same calendar. This means that one can move a scheduled lesson to a different time and replace it with another lesson from the same calendar. The following lessons are possible to swap with the selected lesson, as both the teacher and classroom will be available during the new time slots.","swap_no_lessons":"Unfortunately, there are no lessons to swap with...","select":"Select","replace_headline":"Replace the lesson with a new","replace_desc":"The 'Replace' function is used to replace an existing lesson with a new (non-scheduled) lesson from a selected course. It is possible to replace the lesson with a new one from the following courses, since both the teacher and the classroom are available.","replace_no_lessons":"Unfortunately, there are no lessons to replace with...","lesson_updated":"The lesson has been updated"},"students":{"all":"All","activated_schedules":"Activated student schedules","student":"student","students":"students","created_student":"Created student","delete_student":"Delete student?","add_student":"Add from another group","create_student":"Create student","students_with_same_name":"Following students has a similar name","users_with_same_name":"Following users has a similar name","latest_updated":"Last updated","is_already_in_the_klass":"Is already in the group","without_a_group":"without a group","has_no_groups":"Has no groups","name":"name","feide":"feide","feide_is_already_used":"Feide is already used","import_students":"Import students","groups":"groups","without_group":"without a group","calendar":"calendar","remove":"Remove","of":"of","students_in":"students in","the_group":"the group","select_all":"Select all","unselect_all":"Unselect all","insert_multiple_students":"Insert list of student names. Change line after each student.","create_multiple_students":"Create multiple students at once","to_be_scheduled":"To be scheduled"},"set_standard_duration":{"lessons_duration":"Lessons length","minutes":"minutes","set_standard_duration_for_the_school":"Standard lesson length","standard_duration_for_the_school":"Set standard lessons length for all lessons","the_number_must_be_divisible_by_five":"Number of minutes must be divisible by five","this_setting_will_be_selected_if_nothing_else_is":"This setting will be selected, if nothing else is done","standard_duration_can_be_selected_for_each_course":"Standard lessons length can be changed for each course","already_created_courses_want_be_updated":"Courses already created will not be affected by this change","set_standard_length_for_zen":"The default lesson length is used to calculate the number of lessons for a weekly schedule in Docendo ZEN."},"club":{"club":"Club","club_calendar":"Club calendar","create_club_calendar":"Create club calender","not_created_club":"With a club calendar, you can create club time for educators separate from school time"},"calendar_view_day":{"remove":"Remove","add":"Add","replace":"Replace","actions_for":"Actions for","onwards":"onwards","remove_onwards":"Remove onwards","do_you_want_to_remove":"Do you want to remove","on_all_lessons_from":"on all lessons from and including","and_onwards":"and all future lessons","add_onwards":"Add onwards","do_you_want_to_add":"Do you want to add","on_all":"on all","lessons":"lessons","onwards_which_include":"onwards? This includes lessons from and including","and_all_onwards":"and all future lessons","with_on_all":"with on all","select_the_person_to_replace":"Select the calendar to replace","select_person":"Select calendar","replace_onwards":"Replace onwards"},"eventTypes":{"subject":"Subject","optional":"Optional grades/groups","supplemental":"UUV","frame":"Theme","break":"Break","resource":"Resource","person_resource":"Resource (hidden)","other_tasks":"Other tasks","other_stuff":"Additional tasks","available":"On-call","person_resource_visible":"Resource (Visible)","club":"SFO time","additional_tasks":"Not teaching","preparation":"Preparation","with_kids":"Tid med børn","without_kids":"Tid uden børn","pool":"Custom pool","absence":"Absence"},"task_versions":{"task_overview":"Task Overview","versions":"Versions","save_print_task_overviews":"Save/Print task overviews","save_new_version_task_overviews":"Save a new version of task overviews","print_latest_version_task_overviews":"Print latest version of task overviews","saved_message":"Saved","delete_message":"Delete","confirm_delete_message":"Do you want to delete","delete_warning_message":"Deleted versions cannot be recovered","annual_norm":"Annual Norm","save_task_overview_version":"Save task overview version","version_title":"Title for task overview version","auto_name_description":"Automatically named with today's date if you don't provide a title","what_is_version":"What is a version?","saved_task_overview_description":"A saved task overview shows a snapshot of the employee's task overview as it appeared at the time when the task overview version was saved. It is equivalent to making a printout or PDF with details of how the task overview looked at that particular moment.","find_saved_versions":"Where can I find saved versions?","find_saved_versions_description":"You can find saved versions by navigating to the \"Task Overview\" for each individual. There will be a dropdown menu where all the saved versions within the school year are available for review.","select_personnel":"Select personnel","go_back":"Back","select_min_user":"At least one user must be selected","save_for_selected_users":"Save for","save_for_selected_users_of":"out of","print_latest_version":"Print latest version of task overview for all","no_saved_versions":"No versions are saved"},"deleted_subjects_log":{"deleted_log":"Deleted Log","no_lessons_deleted":"No events have been deleted from this subjects","lesson":"Lesson","deleted":"Deleted"},"create_activity":{"create_activity":"Create event","create_activity_for":"Create event for","title":"title","search_or_create":"Search or create","created":"Created","create_new_subject_for":"Create new course for","choose_subject_type":"Choose course category","the_selected_date_is_outside_schoolyears":"The selected date is outside all active school years"},"datepicker":{"max_date_range_start":"You can fetch a maximum of","max_date_range_end":"days interval"}}

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

	module.exports = {"nb":{"activerecord":{"attributes":{"calendar":{"name":"Navn"},"group":{"country":"Land","demo_expiry":"Demoperiode utløp","description":"Beskrivelse","institution_number":"Institusjonsnummer","name":"Navn","open":"Åpen?","si_name":"-","visible":"Synlig?"},"institution":{"number":"Institusjonsnummer"},"lesson":{"count_hours":"Tell timer"},"material":{"class":"Klassetrinn","description":"Beskrivelse","documenttypes":"Dokumenttype","klassetrin":"Klassetrinn","status":"Status","subjects":"Fag","tag_list":null,"thefile":"Materiale","title":"Tittel"},"notification":{"body":"Brødtekst","header":"Overskrift","sitewide":null,"url":"URL"},"post":{"body":"Innhold","published":"Publisert?","titel":"Tittel"},"room":{"name":"Navn","navn":"Navn","si_name":"Navn i SkoleIntra"},"signup":{"already_in_use":"er allerede i brug","country":"Land","email":"E-post","password":"Passord","password_can_not_be_email":"kan ikke være din email","password_can_not_be_school_name":"kan ikke være skolens navn","password_can_not_be_user_name":"kan ikke være ditt navn","password_confirmation":"Bekreft passord","school_name":"Skolens navn","terms_of_service":"Betingelser","user_name":"Ditt navn"},"subject":{"calendar":"Kalender","color":"Farge","default_duration":"Normal varighet","hours":"Timer","name":"Navn","si_name":"Navn i SkoleIntra","subject_type":"Type"},"subject_period":{"hours_per_week":"Timer per uke","total_hours":"Timer i alt"},"user":{"Email":"E-mail","Fag":"Fag","Initialer":"Initialer ","Klassetrin":"Klassetrinn","Navn":"Navn","Sprog":"Språk","assigned_preparation_hours":"Forberedelse","assigned_teaching_hours":"Undervisningstid","assigned_total_hours":"Timer i år","description":"Beskrivelse","email":"E-post","groups":"Grupper","name":"Navn","organisation":"Skole","password":"Passord","password_confirmation":"Bekreftelse av passord","primary_school":"Primærskole","remember_me":"Husk meg"}},"errors":{"models":{"group":{"attributes":{"institution_number":{"taken":"er allerede opprettet "}}}}},"models":{"calendar":"timeplan","group":"gruppe","institution":"institusjon","lesson":"modul","material":"materiale","post":"innlegg","room":"lokale","signup":null,"subject":"fag","subject_period":"fagperiode","user":"bruker","user/calendar_transfer":"Overføring av kalender"}},"calendars":{"administration":{"archive_merge_table":"Hvis du arkiverer en fellestimeplan, blir den usynlig på forsiden.","archive_room":"Hvis du arkiverer et lokale, blir det usynligt på forsiden."},"calendar_hours_count":{"andet_halvår":"2. halvår","første_halvår":"1. halvår","indeværende_uge":"Denne uken","skoleår_til_dato":"Skoleår til dato"},"calendar_sidebar":{"skema":"timeplan"},"copy_paste":{"indsæt":"Sett inn","indsæt_resten_af_året":"Sett inn + resten av året","kopiér":"Kopier"},"delete_merge_calendar_button":{"delete_merge_calendar":"Slett fellestimeplan","dette_kan_ikke_fortrydes":"Dette kan ikke angres.","ja_slet_dette_fletteskema":"Ja, slett denne fellestimeplanen.","nej":"Nei","slet_dette_fletteskema":"Slett denne fellestimeplanen?"},"delete_week_button":{"der_vil_kun_blive_slettet_de_lektioner_som_er_lagt_ind_i_denne_kalender":"Det er kun timene som er lagt inn i denne kalenderen som blir slettet. ","dette_kan_ikke_fortrydes":"Dette kan ikke angres","ja_slet_ugens_lektioner":"Ja, slett ukens timer. ","lektioner":"Slett ukens timer...","nej":"Nei","vil_du_slette_alle_ugens_lektioner":"Vil du slette alle ukens timer?"},"events_with_notes_or_substitutes":{"hvis_du_kopierer_et_skema_frem_bliver_vikardækninger_fravær_i_personlige_kalendre_og_noter_på_lektionerne_ikke_gemt":"Hvis du kopierer timeplanen fremover for året vil ikke vikarer, fravær i personlige kalendere og notater til timene bli lagret.","ja_jeg_vil_overskrive_disse":"Ja, jeg vil overskrive disse.","lektioner_med_noter_vikardækning_eller_fravær":"Timer med notater"},"expand":{"skift_visning_mellem_arbejdsuge_weekender_og_fuld_uge":"Bytt visning mellom skoleuke, full uke og 24 timer"},"explain_copy_in_background":{"der_kan_gå_5-10_minutter":"Det kan ta 5-10 minutter.","du_får_en_notifikation_på":"Du får et varsel","du_kan_fortsætte_med_at_arbejde_i_andre_kalendre":"Du kan fortsette med å arbeide i andre kalendere.","forsiden":"forsiden","kopierer_kalenderen_frem":"Kopierer kalenderen frem i tid.","når_kopieringen_er_afsluttet":"når kopieringen er avsluttet. ","ok":"Ok"},"group":{"flet_med_fletteskemaer":"Flett med fellestimeplan...","flet_med_skema":"Flett med timeplan","se_elevskema":"Se elevtimeplan","vælg_skema":"Velg timeplan"},"group_hours":{"total":"Totalt","type":"Type"},"merge":{"dette_skema_er_flettet_ind_i":"Denne timeplan er flettet inn i:","hvis_du_vil_slette_dette_fletteskema_skal_du_først":"Hvis du vil slette denne fellestimeplanem, må du først fjerne flettingen i timeplanene ovenfor.","vælg_kalender":"Velg kalender:"},"merge_with_selector":{"flet":"Flett inn"},"new":{"nyt_fletteskema":"Ny fellestimeplan","opret_fletteskema":"Opprett fellestimeplan"},"public":{"mobile_guide":"Veiledning for mobil og nettbrett","print_in_black_white":"Skriv ut uten farge","printing_guide":"Veiledning for utskrift","se_skemaet_på":"Se timeplan på"},"room":{"vælg_skema":"Velg timeplan:"},"subject_hours":{"anden_tid_i_perioden":"Annen tid i perioden","er_du_tilknyttet":"er du tilknyttet","flextid_for_året":"Fleksitid for året","fravær_i_perioden":"Fravær i perioden","til":"til","timer":"timer","undervisning_i_perioden":"Undervisning i perioden"},"user":{"apple_kalender":"Apple Kalender","google_kalender":"Google Kalender","google_opdaterer_kalenderen_ca_tre_gange_i_døgnet":"Google oppdaterer kalenderen ca. tre ganger i døgnet.","ical":"iCal","kopiér_webaddresen_herunder_og_kopier_den_ind_i_den_eksterne_kalender_hvor_du_gerne_vil_have_den":"Kopier nettadressen under og legg inn i den eksterne kalenderen. ","outlook":"Outlook","se_evt_guides_nedenfor_i_forhold_til_hvordan_du_skal_gøre":"Se evt. veiledning nedenfor som viser hva du skal gjøre.","siden":"siden.","sidst_hentet":"Det ble sist lastet ned","tilføj_dit_skema_til_ekstern_kalender":"Legg timeplanen inn i en ekstern kalender","vælg_kalender":"Velg kalender:"},"user_hours":{"undervisningstid":"Undervisningstid"},"week_note":{"week_notes":"Ukenotater"},"week_plan":{"content":"Innhold","internal_notes":"Vikarnotater","learning_goal":"Læringsmål","pupil_preparation":"Elevforberedelse","subject":"Fag"},"week_plan_and_note":{"week":"Uke","week_plan":"Ukeplan"}},"controllers":{"ws":{"events":{"you_are_no_longer_substitute":"%{creator} fjernet deg som vikar i %{subject} i %{klass}, %{time}","you_are_substitute":"%{creator} gjorde deg til vikar i %{subject} i %{klass}, %{time}"}}},"da_only":{"add_user_with_uni":"Tilføy bruker(e) med Feide","click_to_login_with_unilogin":"Klik her for at logge på med Uni-login","fictive_user_text":"Brukeren har en kalender, og det vil være mulig å legge til brukeren som lærer i timeplaner. Brukeren kan ikke logge på Docendo.","guide_link_parentintra":"Guide til link i klassens forældreIntra","lærere_på_skoleintra":"Lærere på SkoleIntra","opdatér_profil_fra_uni-c":"Opdatér profil fra UNI-C","parent_portal":"ForældreIntra","show_tables_parentintra":"Vis skemaer i ForældreIntra","skriv_brikken_skoleintra":"Skriv hvad brikken hedder i SkoleIntra","uni_login":"-","vis_skema_i_skoleintra":"Vis timeplan for elever/foreldre","website_portal":"Skolens hjemmeside"},"date":{"formats":{"iso":"%Y-%m-%d"}},"demo":{"firstlogin":{"kom_igang":"Kom i gang","velkommen":"Velkommen"}},"devise":{"confirmations":{"new":{"resend_confirmation_instructions":"Send bekreftelsesinstruksjoner"}},"failure":{"invited":"Du har en invitasjon på vent, aksepter denne for å få adgang. "},"invitations":{"edit":{"header":"Velg passord. ","password":"Passord","password_confirmation":"Bekreft passord","submit_button":"Lagre passord"},"invitation_removed":"Invitasjonen din er blitt slettet. ","invitation_token_invalid":"Invitasjonen er ikke gyldig. ","new":{"header":"Send invitasjon","submit_button":"Send invitasjon"},"no_invitations_remaining":"Ingen flere invitasjoner. ","send_instructions":"En invitasjonsmail har blitt sendt til %{email}.","updated":"Passordet er blitt lagret. Du er nå logget inn. ","updated_not_active":"Passordet er lagret. "},"mailer":{"confirmation_instructions":{"confirm_my_account":"Bekreft kontoen min","you_can_confirm_your_account_email_through_the_link_below":"Du kan bekrefte din mail via linken under:"},"invitation_instructions":{"accept":"Aksepter invitasjon","accept_until":"Invitasjonen utløper %{due_date}.","contact_us":"Hvis du har spørsmål, kontakt oss gjerne på kontakt@docendo.no","from_school":"Du er akkurat blitt invitert til Docendo – Fleksibel Timeplanlegging på %{school_name}.","hello":"Hei %{email}","regards_html":"<p>Med venlig hilsen,<br/>\nDit Docendo Team<br/>\nhttps://docendo.no</p>","someone_invited_you":"For å akseptere invitasjonen, trykk på denne linken ","subject":"Instruksjoner til invitasjonen"},"reset_password_instructions":{"change_my_password":"Endre mitt passord","change_password_link_requested":"Du kan endre passordet via linken under. ","greeting":"Hei","wont_change":"Hvis du ikke gjør noe vil passordet ikke endres. "},"unlock_instructions":{"click_the_link_below_to_unlock_your_account":"Klikk på linken nedenfor for å låse opp kontoen din.","unlock_my_account":"Lås opp kontoen min.","your_account_has_been_locked_due_to_an_excessive_number_of_unsuccessful_sign_in_attempts":"Kontoen din har blitt låst på grunn av et stort antall påloggingsforsøk."}},"passwords":{"edit":{"change_my_password":"Bytt mitt passord","change_your_password":"Bytt passord","confirm_new_password":"Bekreft nytt passord","new_password":"Nytt passord"},"new":{"forgot_your_password":"Glemt ditt passord?","send_me_reset_password_instructions":"Send meg instruksjoner om nullstillingav passord"}},"registrations":{"edit":{"are_you_sure":"Er du sikker?","cancel_my_account":"Slett min konto","current_password":"Nåværende passord","password":"passord","password_confirmation":"Gjenta passord","update":"Oppdater"}},"sessions":{"new":{"brugernavn":"Brukernavn","create_a_free_trial":"Opprett en gratis prøveversjon","kodeord":"Passord","log_ind":"Logg på","log_ind_med":"Logg inn med Feide","log_ind_med_mail_og_kodeord":"Logg på med e-post og passord","log_ind_på_docendo":"Logg på docendo","no_account":"Ingen konto?"}},"shared":{"links":{"didn":"Fikk du ikke bekreftelsesinstruksjoner?","didn_2":"Fikk du ikke unlock-instruksjoner?","forgot_your_password":"Glemt ditt passord?","sign_in":"Logg på","sign_up":"Meld deg på"}},"unlocks":{"new":{"resend_unlock_instructions":"Send unlock-instruksjoner igjen"}}},"events":{"event_debug":{"brugere":"Brukere:","ejerkalender":"Eierkalender:","grupper":"Grupper: ","kalendre":"Kalendere:","lokaler":"Lokaler: "},"replace_room":{"erstat_fremadrettet_på_dette_fag":"Erstatt fremover på dette faget","og_resten_af_året":"og resten av året?","på":"på"},"replace_user":{"erstat_fremadrettet_på_dette_fag":"Erstatt fremover på dette faget","klik_her_for_at_gå_til_kalenderen_for":"Klikk her for å gå til kalenderen for","med":"Med:","og_resten_af_året":"og resten av året?","på":"på"},"show":{"agenda":"Agenda","agenda_placeholder":"F.eks: 1. Oppfølging fra sist, 2. Opplegg fra...","content":"Innhold","decisions_and_resume":"Beslutninger og oppsummering","decisions_and_resume_placeholder":"F.eks.: Henriette undersøker med ungdomstrinnet om vi kan...","denne_lektion_tæller_som":"Denne timen teller som:","er_du_sikker":"Er du sikker?","external_links":"Mine læringsmål og forløp","find_vikar":"Finn vikar","gå_til_kalender_for_denne_lektion":"Gå til kalenderen for denne timen","internal_notes":"Vikarnotater","jump_to_calendar_for_event":"Hopp til kalender for dette faget","learning_goal":"Hva skal vi lære?","location":"Lokale","meeting_purpose":"Formål med møtet","meeting_purpose_placeholder":"F.eks.: Vi skal være flinke på å...","only_visible_internally":"Bare synlig for undervisere","pupil_preparation":"Elevforberedelse","slet_brik":"Slett fag","slet_fra_denne_kalender":"Slett kun i denne kalenderen","substitutes":"Vikarer","swappable_lessons":"Følgende timer og tidspunkt kan byttes med valgt time","søg_og_vælg":"Søk og velg","søg_og_vælg_vikar":"Søk og velg vikar","teachers":"Undervisere","undervisere_lokaler_noter":"Undervisere","vacant":"Underviser og lokale er ledige for fagene/timene under","vælg_klasser":"Velg klasser","vælg_lokation":"Velg lokale"},"show_public":{"agenda":"Agenda","content":"Innhold","decisions_and_resume":"Beslutninger og resymé","external_links":"Mine læringsmål og kurs","jump_to_calendar_for_event":"Hopp til kalenderen for dette faget","learning_goal":"Hva skal vi lære?","location":"Lokale","meeting_purpose":"Formål med møtet","pupil_preparation":"Elevforberedelse","substitutes":"Vikarer","teachers":"Undervisere"}},"groups":{"about":{"om":"Om"},"admin":{"assign_hours_employees":"Tildel timer til ansatte","classes_and_subjects":"på klasser og fag","more_tables":"se flere timeplaner sammen","show_to_parents":"Vis for foreldre","status":"tildeling og status","substitutes":"Vikarpulje","supplement":"Tillegg","year":"2016-2017"},"calendars_setup":{"copy_link":"Kopier link","copy_link_table_insert":"Kopier linken til den klassens timeplan du gjerne vil abonnere på - og sett inn","docendo_extern_calendar":"Docendo-timeplaner kan vises i eksterne kalendere. Kopier linken ved siden av timeplanen nedenfor og sett inn i ekstern kalender. Følg slides til høyre for hjelp til oppsett.","find_in_google_cal":"Veiledning for integrasjon i egen kalender","google_calendar":"Google Kalender","guide_integration_own_cal":"Veiledning for integrasjon i egen kalender","guide_setup_schoolport":"Veiledning for oppsett på Fronter/ItsLearning","guide_setup_table_elevintra":"Veiledning for oppsett av timeplan i klassens ElevIntra","guide_step_copy":"Klikk på ’Kopier link’ ved siden av timeplanen du vil sette opp - og følg veiledningen til høyre.","ical_google_outlook":"iCal","integrate_tables":"Integrer timeplaner i iCal, Google eller Outlook","links_for_each_class":"Ønsker dere å vise timeplaner for hver enkelt klasse, kan dere benytte linkene for hver klasse nedenfor.","outlook":"Outlook","parentintra_seperate_class":"Ønsker dere å vise timeplaner for hver enkelt klasse på klassens ForeldreIntra, kan dere benytte linkene for hver klasse nedenfor.","show_table_selected":"Vis utvalgte timeplaner på hjemmeside","show_tables_elevintra":"Vis timeplaner på ElevIntra","substitutes_teachers_show_public":"Dagens fraværende","substitutes_teachers_show_public_explain":"Informasjon om dagens fraværende undervisere kan vises på f.eks infoskjerm. Bruk linken under til oppsetting. ","text_set_x":"Kryss av nedenfor hvilke timeplaner som ønskes vist via linken.","text_show_tables":"For å gjøre timeplanene tilgjengelige for elever og foreldre kan denne nettadressen legges ut på f.eks. skolens hjemmeside eller It's Learning:","vaelg_alle":"Velg alle"},"create_klass":{"evt_vaelg":"Evt. velg import av fag og timer som svarer til klassetrinnet","import_af_fag":"Import av fag?","import_norm":"Ønsker du å importere og opprette fag med fastsatt timetall? Velg i så fall det klassetrinnet som klassen tilhører her: ","klassens_navn":"Klassens navn","opret_en_ny_klasse_for":"Opprett en ny klasse","skriv_klassens_navn":"Skriv klassens navn"},"delete_popup":{"brikker_som_slettes_kun_fra_denne_kalender":"Fag som slettes bare fra denne kalenderen","den_har":"Den har:","denne_handling_kan_ikke_fortrydes":"Denne handlingen kan ikke angres!","indlæg_som_slettes":"innlegg som slettes.","kalendere_som_slettes":"Kalendere som slettes.","lektioner_i_kalenderen":"timer i kalenderen.","medlemmer_som_ikke_længere_vil_kunne_bruge_gruppen":"medlemmer som ikke lenger vil kunne bruke gruppen.","skriv_slet_gruppen_herunder":"Skriv 'Slett gruppen' nedenfor:","slet_gruppen":"Slett gruppen","uploadet":"Lastet opp"},"edit":{"redigér_gruppe":"Rediger gruppe"},"flextime":{"flextime":"Fleksitid","flextime_teacher_appear":"Bare lærere som har brukt fleksitid vises i listen."},"flextime_activator":{"aktivering_af_flextid":"Aktivering av fleksitid","aktiveringen_giver_alle_ansatte_brikker_til_flextid_i_deres_egen_kalender":"Aktiveringen gir alle ansatte brikker for fleksitid i egen kalender.","aktivér_flextid":"Aktiver fleksitid"},"form":{"fejl_forhindrede_denne_gruppe_i_at_blive_gemt":"feil forhindret at denne gruppen ble lagret:","skriv_hvad_gruppen_hedder":"Skriv hva gruppen heter","skriv_om_gruppen":"Skriv om gruppen"},"hours":{"press_empty_bricks":"Trykk i tomme felt for å opprette fag/legge inn timer i klassen."},"merge_calendars":{"merge_tables":"Fellestimeplan","new_merge_table":"Ny fellestimeplan"},"mine":{"ikke_medlem_af_nogen_grupper_endnu":"Ikke medlem av noen grupper ennå."},"multical":{"help_for_table":"Hjelp til timeplanoversikt","today":"I dag","vaelg_klasse":"Velg klasse","vaelg_lokale":"Velg lokale","vaelg_person":"Velg person"},"newother":{"fejl_forhindrede_denne_kalender_i_at_blive_gemt":"feil forhindret at denne kalenderen ble lagret:","opret_anden_kalender":"Opprett en annen kalender","opret_kalender":"Opprett kalender","skriv_evt_kalen":"Skriv evt. noe om kalenderen","skriv_hvad_kalen":"Skriv hva kalenderen vil bli navngitt..."},"pay_supplement":{"get":"Hent","minutes":"Minutter","show_supplement":"Vis tillegg","supplement_type":"Tilleggstype"},"school":{"video":"Video"},"schools":{"vælg_skole":"Velg skole"},"show":{"bliv_medlem":"Bli medlem","class_year":"klasse/årgang","filer":"Filer:","forlad_gruppen":"Forlat gruppen","gruppen":"gruppen...","indlæg":"Innlegg:","opret_team":"Opprett gruppe"},"substitute_pool":{"details":"Detaljer","hours":"timer","mistakes_look":"feil","notice":"Merk","notice_list_item_1":"Vikartimer telles med i samlet antall undervisningstimer for underviseren","notice_list_item_2":"Vikartimer er i underviserens egen kalender angitt som det faget det vikaries i - f.eks. 'Norsk'","pool":"Pulje","rest":"Rest","substitute_hours_per_month":"Vikartimer brukt pr. måned","substitute_overview":"Vikaroversikt","there_was":"Det var","total_substitute_pool":"Total vikarpulje:","total_used_substitute_hours":"Totalt brukte vikartimer:","total_used_substitute_hours ":"Totalt brukte vikartimer:","used":"Brukt","vis_timer":"Se timer"},"users":{"ical":"ical:","initials":"Initialer","users":"Brukere"}},"import":{"csv_overview":{"i_fil":"I fil:","ikke-fundne_klasser_oprettes_i_skoleåret_hvor_der_importeres_til":"Klasser som ikke er funnet, opprettes i skoleåret som det importeres til","ikke-fundne_lokaler_oprettes":"Lokaler som ikke er funnet, opprettes","ikke-fundne_lærere_oprettes_med_initialer":"Lærere som ikke er funnet, opprettes med initialer","ikke_fundet":"Ikke funnet","import":"Import","kontrollér_at_disse_er_rigtige":"Kontroller at disse er riktige","lagt_sammen":"Lagt sammen: ","lokaler":"Lokaler","lærerer":"Lærere","ringetider":"Ringetider","til_uge":"Til uke:"},"result":{"der_var_nogle_fejl":"Det var noen feil","import_afsluttet":"Import fullført","ingen_fejl_i_import":"Ingen feil i import."}},"jobs":{"copy_events_year_job":{"calendar_is_copied":"Kalenderen %{calendar_name} er kopiert"}},"js":{"all_day":"Hele dagen","calculating_and_controlling":"Setter inn og beregner tid...","changes_may_not_be_saved":"Endringer du har gjort lagres ikke","click_keyboard_shortcuts_to_copy":"Klikk på ⌘ + C  eller ctrl + C for å kopiere","close_without_saving":"Ønsker du å lukke uten å lagre?","copied":"Kopiert","error_occured":"En feil har oppstått."},"layouts":{"application":{"dage":"dager","der_er_ikke":"Det er ikke forbindelse til Docendo. Dette kan skyldes at du ikke har forbindelse til internett.","din_profil":"Din profil","hjem":"Hjem","kurser":"Kurs","køb_nu":"Kjøp nå","log_ud":"Logg ut","profil":"Profil","prøveperiode_slutter_om":"Prøveperioden avsluttes om","skal_slettes_for_sig_selv":"skal slettes for seg selv.","skift_kodeord":"Bytt passord","slet_indlæg":"Slett innlegg","soeg":"Søk","vil_du_deaktivere":"Vil du deaktivere skolen?","Ønsker_du_at_slette_dit_indlæg":"Ønsker du å slette ditt innlegg?"},"blank":{"der_er_ikke":"Det er ikke"},"devise":{"book_en_gratis_demo":"Book en gratis demo","docendodk":"docendo.no","kontakt":"kontakt","log_ind_med":"Logg inn med","log_ind_med_email":"Logg på med e-post","login":"Logg inn ","med_en_fuldt_integreret":"Med en fullt integrert","om_docendo":"Om docendo","om_os":"om oss","tlf_70_40_02_10":"Telefonnummer: +45 70 40 02 10","udviklet_i_samarbejde_med_ledere_lærere_og_pædagoger":"Utviklet i samarbeid med ledere, lærere og pedagoger","uni":null},"public":{"skal_slettes_for_sig_selv":"skal slettes for seg selv.","slet_indlæg":"Slett innlegg","Ønsker_du_at_slette_dit_indlæg":"Ønsker du å slette innlegget ditt?"},"schools":{"users":{"create_user_by_alias":"Oprett bruker uten innlogging","create_user_by_email":"Opprett bruker med e-mail","create_user_by_unilogin":"Opprett bruker med Feide","merge_users":"Slå sammen brukere","transfer_calendar":"Ta over timeplan"}}},"materials":{"details":{"antal_downloads":"Antall nedlastinger:","beskrivelse":"Beskrivelse:","detaljer_om_filen":"Detaljer om filen","dialog_om_filen":"Dialog om filen","dokumenttype":"Dokumenttype:","klassetrin":"Klassetrinn:","status":"Status:","uploadet_af":"Lastet opp av:"},"edit":{"redigér_fil":"Rediger fil","vis":"Vis"},"form":{"dit_materiale_er_gemt":"Materialet ditt er lagret","fejl_forhindrede_dette_materiale_i_at_blive_gemt":"feil forhindret at dette materialet ble lagret:","filnavn":"Filnavn: ","gem_materiale":"Lagre materiale","skriv_noget_relevant":"Skriv noe relevant","titel_på_fil":"Tittel på fil","venligst_udfyld_nogle_informationer_om_materialet":"Vennligst fyll ut informasjon om materialet","vælg_dine_fag":"Velg dine fag","vælg_dokumenttype":"Velg dokumenttype(r)","vælg_dokumenttyper":"Velg dokumenttyper","vælg_klassetrin":"Velg klassetrinn","vælg_status":"Velg status"},"index":{"antal_hentede":"Antall hentede","klassetrin":"Klassetrinn"},"material":{"fra":"fra","mere_info":"Mer info","uploadet_af":"lastet opp av"},"new":{"gem_materiale":"Lagre materiale"},"new1":{"attach_files":"Legg ved materiale"},"popedit":{"dit_materiale_er_gemt":"Materialet ditt er lagret","erstat_materiale":"Erstatt materiale:","fejl_forhindrede_dette_materiale_i_at_blive_gemt":"feil forhindret at dette materialet ble lagret:","gem_materiale":"Lagre materiale","giv_nogle_informationer_om_materialet":"Gi informasjon om materialet","vælg_dine_fag":"Velg dine fag","vælg_dokument":"Velg dokumenttyper","vælg_klassetrin":"Velg klasse","vælg_status":"Velg status"},"show":{"beskrivelse":"Beskrivelse:","group":"Gruppe:","post":"Innlegg:","tags":"Koder:","user":"Bruker:"},"sidebar":{"nyeste":"Nyeste","populære":"Populære","se_alle":"Se alle"},"upload":{"del_et_materiale":"Del materiale","upload":"Last opp.","vælg_et_dokument":"Velg et dokument"}},"models":{"calendar":{"beregn_timer":"Beregn timer","flex_ind":"Fleks inn","flex_ud":"Fleks ut"},"group":{"alle":"Alle","already_created":"er allerede opprettet","share_with":"Del med","skolen":"Skolen","team":"Gruppe","ukendt":"ukjent"},"group_school":{"importerede":"Importerte","med":"med","oprettede_klasse":"Opprettet klasse","oprettede_lærer":"Opprettet lærer","uden_lærer_i":"uten lærer i"},"import_lesson":{"invalid":"Ugyldig"},"material":{"skal_vælges":"Må velges"},"pay_supplement_rule_school_camp":{"lejrskole":"Leirskole"},"pay_supplement_rule_substitute":{"ekstern_vikar":"Ekstern vikar"},"post":{"synes_godt_om":"Liker"},"subject_period":{"timer_uge":"Timer/uke"},"user":{"ukendt":"ukjent"}},"notifications":{"form":{"indhold":"Innhold:","link_https__skal_tilføjes_hvis_linket_er_eksternt":"Link: ('https://' må legges til hvis linken er ekstern)","notifikationer":"Meldinger","overskrift":"Overskrift:"},"index":{"notifikationer":"Meldinger","opret_ny":"Opprett ny","siden":"siden"},"notification":{"siden":"siden"},"show":{"brugere":"brukere","link":"Link: ","læst_af":"Lest av","notifikationer":"Meldinger","sendt_til":"Synlig for","sidst_opdateret":"Sist oppdatert:","skrevet_af":"Skrevet av"}},"posts":{"edit":{"redigér_indlæg":"Rediger innlegg","vis":"Vis"},"form":{"del_noget":"Del noe...","fejl_forhindrede":"feil forhindret at dette innlegget ble lagret","tilføj_kommentar":"Tilføy kommentar..."},"new":{"nyt_indlæg":"Nytt innlegg"},"post":{"antal_downloads":"Antall nedlastinger","comments":"Kommentarer","from":"fra","show":"Vis","since_in_group":"siden i gruppen","slet_indlæg":"Slett innlegg"},"show":{"bruger":"Bruker:","indhold":"Innhold:"}},"rack_dev_mark":{"development":"Utvikling"},"repitition":{"add":"Legg til","administration":"Administrasjon","aktivitet":"Aktivitet","all_calendars":"alle kalendere","annuller":"Avbryt","archive":"Arkiver","brikker":"Fag","brugeradministration":"Brukeradministrasjon","calendaradministration":"Kalenderadministrasjon","choose":"Velg","chooselanguage":"Velg språk","create":"Opprett","dagens_fraværende":"Dagens fraværende","dagens_vikarer":"Dagens vikarer","dearchive":"Dearkiver","delete":"Slett","deleting":"Sletter","din_kalender":"Din kalender","docendo":"Docendo - Fleksibel timeplanlegging","email":"E-post","enddate":"Sluttdato","endtime":"Sluttid","errors":"feil","fag":"Fag","feriekalender":"Feriekalender","fjern":"Fjern","fjern_brugere":"Fjern brukere","flextidsoversigt":"Fleksitidsoversikt","fra_og_med":"fra","from":"fra","gem":"Lagre","hour":"time","kalender":"Kalender","klass":"klasse","klasser":"Klasser","klasser_lille":"klasser","kr":"kr","langfravær":"Langtidsfravær","lesson":"timen","luk":"Lukk","materialer":"Materialer","medlem":"medlem","medlemmer":"medlemmer","merge_calendar":"fellestimeplan","merge_calendars":"fellestimeplaner","målstyring":"Målstyring","navn":"Navn","none":"Ingen","opgaveoversigt":"Oppgaveoversikt","opret":"Opprett","opret_brik":"Opprett fag","opret_fraværsgrund":"Opprett fraværsårsak","opret_tilføj_bruger":"Opprett/tilføy bruker","oprettet":"Opprettet:","other_calendar":"annen kalender","other_calendars":"andre kalendere","planlægning":"Planlegging","processing":"Behandler","rediger":"Redigér","replace":"Erstatt","replace_lesson":"Erstatt time","room":"lokale","rooms":"lokaler","se_kalender":"Se kalender","search":"søk","search_for":"søk etter","select_user":"Velg bruker","send":"Send","show":"Vis","skema":"Timeplan","skemaoverblik":"Timeplanoversikt","skole":"Skole","skoler":"Skoler","skoleår":"Skoleår","skriv":"Skriv...","startdate":"Startdato","starttime":"Starttid","substitute":" Vikardekning","superadmin":"Superadmin","support":"Support","swap":"bytt","swap_lesson":"Bytt time","tilbage":"Tilbake","tildel_timer":"Tildele timer","timefordeling":"Timefordeling","timer":"Timer","timeudtraek":"Timeuttrekk","titel":"Tittel","today":"I dag","unauthorized_access":{"help":"Brukeren din er ikke knyttet til en aktiv skole på Docendo. Mener du at dette er feil, kontakt skoleadministrasjonen for å bli knyttet til skolen. ","no_access":"Du har ikke adgang. "},"until":"til","user":"bruker","users":"brukere","vikardækning":"Vikardekning","vikarpuljer":"Vikarpuljer","vis_skemaer_til_elever":"Ekstern visning av timeplaner","with":"med","yearplan":"Årsplanlegging","Årsoverblik":"Årsoversikt","år":"År","årsplanlægning":"Årsplanlegging"},"rooms":{"create_room":"Opprett lokale","edit":{"er_du_sikker":"Er du sikker?","redigér_lokale":"Rediger lokale","slet_lokale":"Slett lokale"},"form":{"fejl_forhindrede_dette_lokale_i_at_blive_gemt":"feil forhindret at dette lokalet ble lagret:"},"new":{"nyt_lokale":"Nytt lokale"},"room_is_not_created":"Lokalet eksisterer ikke","rooms":{"new_room":"Nytt lokale","rooms":"Lokaler"}},"schools":{"calendar_transfers":{"new":{"activity_count":"Aktiviteter","from_date":"Fra dato","have_calendar":"Har timeplan som skal overdras","including_both":"begge datoer inkludert","period":"Periode","receive_calendar":"Skal overta timeplan","replacee_in_period":"Overdrar timeplan","replacement_in_period":"Overtar i perioden ","title":"La en bruker overta en annen brukers timeplan for en periode, for eksempel ved fødselspermisjon eller langvarig fravær.","to_date":"Til dato","transfer":"Overfør","transfer_calendar_for_a_period":"Ta over timeplan","warning":"Kan ikke angres."}},"onboarding":{"administration_and_counting":"Administrasjon og telling","assign_user_hours":"Tildel timer til lærere","create_calendars":"Opprett timeplaner","create_classes":"Opprett klasser","create_fixed_hours":"Opprett felles pauser","create_merge_calendars":"Opprett fellestimeplaner","create_other_calendars":"Opprett andre kalendere","create_rooms":"Opprett lokaler","create_school_year":"Opprett skoleår","create_teachers":"Opprett lærere/brukere","create_your_school":"Opprett skolen i Docendo","follow_the_steps":"Følg trinnene nedenfor for å komme i gang med planleggingen","import_of_schedules":"Importere timeplaner?","import_of_schedules_content":"Hvis du ønsker, kan vi også importere dine eksisterende timeplaner fra CSV-fil. Send en mail til oss, og du vil motta instruksjoner.","make_room_bindings":"Binding av lokaler","scheduling_classes_calendars":"Timeplanlegging i klasser","select_vacationdays":"Legg inn ferier og helligdager","show_calendars_to_students":"Vis timeplaner for elever og foreldre","student_scheduling":"Timeplanlegging for klassene","user_tasks":"Oppgaveoversikt til lærere"},"user_merges":{"new":{"merge_on_this_user":"Slå sammen på denne brukeren","title":"Slå sammen brukere. For eksempel i tilfelle av to identiske brukere eller hvis en bruker uten innlogging må byttes ut med en bruker med innlogging. Alle aktiviteter samles inn på en bruker. ","warning":"Du kan ikke angre handlingen."}},"users":{"index":{"actions":"Handlinger","help":"Trykk på bildet for å sette inn et nytt. Initialer kan redigeres.","photo":"Foto"},"user":{"invite":"Inviter","remove":"Fjern"}}},"search":{"post":{"siden_i_gruppen":"siden i gruppen"},"search_content_type_filter":{"alle":"Alle","grupper":"Grupper","opdateringer":"Oppdateringer","profiler":"Profiler","vis_resultater_for":"Vis resultater for"},"search_filter":{"filtre":"Filtre","type_af_materiale":"Type av materiale","vælg_dine_fag":"Velg dine fag","vælg_dokumenttyper":"Velg dokumenttyper","vælg_fag":"Velg fag","vælg_klassetrin":"Velg klassetrinn","vælg_status":"Velg status"},"search_results":{"antal_hentede":"Antall hentet","grupper":"Grupper","klassetrin":"Klassetrinn","none":"Dessverre - vi kunne ikke finne noe","opdateringer":"Oppdateringer","profiler":"Profiler","viser_Res_for":"Viser resultater for"}},"sidebars":{"get_started_new_year":{"assign_hours_employees":"Tildel timer til ansatte","follow_steps":"Følg trinnene nedenfor","get_started":"Kom i gang","other_calendars":"andre kalendere","time_distribution":"Timefordeling på klasser"},"school":{"other_calendars":"Andre kalendere (f.eks. team-kalender)"},"substitution_links":{"assign_substitutes":"Legg til dagens vikarer","substitute_cover":"Vikardekk"}},"signups":{"by_existing_users":{"new":{"already_user":"Bruker allerede skolen din Docendo, men du har ikke adgang? Kontakt skoleadministrasjonen for å få adgang. ","try_free":"Prøv Docendo gratis i 14 dager"}},"new":{"create_signup":"Opprett","i_accept":"Jeg aksepterer","password_rule":"(minst 8 tegn)","signup":"Opprett demo","terms_of_service":"betingelserne"}},"subject_periods":{"edit":{"antal_uger":"Antall uker","fordel_timer_i_perioden":"Fordel timer i perioden","opdatér":"Oppdater","skoledage_i_perioden":"Skoledager i perioden","slet":"Slett","timer_i_perioden":"Timer i perioden"}},"subjects":{"edit":{"arkiver":"Arkiver","arkiver_denne_brik_den_vil_ikke_længere_være_synlig":"Arkiver dette faget? Det vil ikke lenger være synlig","arkiverer":"Lagre","er_du_sikker":"Er du sikker?","redigér_brik":"Rediger fag","slet_brik":"Slett fag","vil_du_arkivere_denne_brik":"Ønsker du å arkivere dette faget? Det vil da ikke lengre være synlig, men timer som er lagt inn i timeplanen forblir."},"inner_edit":{"absence":"Fravær","absence_description":"sykdom, ferier osv.","anden_tid":"Annen tid","anden_tid_description":"ikke undervisning. ","antal_minutter_modul":"Skriv hvor mange minutter en modul normalt varer","antal_timer_på_år":"Angi det totale antall timer for året","bevægelse":"Bevegelse","bevægelse_description":"teller 100% og uavhengig av andre aktiviteter i samme tidsrom. ","fag":"Fag","fag_description":"teller timer for klassen.","fejl_forhindrede_denne_brik_i_at_blive_gemt":"feil forhindret at dette fag ble lagret","frame":"Temavisning (Ramme)","frame_description":"kan brukes til å markere temaer og spesielle dager/uker i timeplanen. Temavisning er synlig for elever/foreldre, og kan kombineres med fag. Fag teller 100% i perioden, og temaet teller ikke.","klasser_andre_kalendre":"Klasser/Andre kalendere","lokation":"Lokale","normal_varighed_i_minutter":"Normal varighet (i minutter)","oovrig_tid":"Øvrig tid","oovrig_tid_description":"ikke undervisning, ikke elevrelatert. ","optional":"Valgfag/gruppe","optional_description":"teller 100% og uavhengig av andre aktiviteter i samme tidsrom. ","pause":"Pause","pause_description":"andre timer bør ikke overlapper med en pause.","ressource":"Ressurs","ressource_description":"brukes til å markere ressursene i timeplanen. Teller ikke fra andre fag. Vises som standard ikke i elev- og foreldretimeplan.","skriv_et_bogstav_for_at_søge":"Skriv en bokstav for å søke...","skriv_hvad_brikken_hedder":"Skriv hva faget heter...","sygdom_ferie_etc":"sykdom, ferier osv. ","timer_på_årsbasis":"Timer(i skoleåret)","underviser":"Underviser","uuv":"UUV","uuv_description":null,"vælg_briktype":"Velg type","vælg_farve":"Velg farge","vælg_klasser":"Søk og velg klasser"},"new":{"ny_brik":"Nytt fag"},"subject_accordion_menu":{"absence":"Fravær","break":"Pause","exercise":"Bevegelse","flextime":"Fleksitid","frame":"Temavisning (Ramme)","optional":"Valgfag/gruppe","other_stuff":"Annet","other_tasks":"Andre oppgaver","pay_supplement":"Tillegg","person_resource":"Undervisningsressurser","resource":"Ressurs","subject":"Fag","supplemental":"Støtteundervisning"},"subject_draggable":{"hours_per_year":"t/år","per_week":"/uke"},"ws_edit":{"er_du_sikker":"Er du sikker?","opdater_brik":"Oppdater fag","redigér_brik":"Rediger fag","slet_brik":"Slett fag"}},"substitutes":{"edit":{"i_dag":"i dag","ingen_lektioner_for":"Ingen timer for","klasse":"Klasse","også_tilknyttet":"Også tilknyttet","se_alle":"Se alle","se_mindre":"Se mindre","søg_og_vælg":"Søk og velg","vikar":"Vikar","vikar_for":"Vikar for","vikarnoter":"Vikarnotater"},"known_absence":{"byt":"Bytt","feriedage":"Feriedager","fraværende_med_lektioner":"Fraværende med timer","kalenderen_for_7b":"Kalenderen til 7b","kursus":"Kurs","lektioner":"timer","lektioner_der_kan_byttes_med":"Timer som kan byttes: ","lektioner_der_skal_håndteres":"Timer som skal håndteres: ","opret_fravær":"Opprett fravær","opret_planlagt_fravær":"Opprett planlagt fravær","syg":"Syk"},"substitute_day":{"klasse":"Klasse"},"substitutes_edit":{"fraværsårsager_og_skemaoverblik":"Fraværsårsaker og timeplanoversikt","tilføj_kalendre":"Tilføy kalendere","vælg_klasse":"Velg klasse","vælg_lokale":"Velg lokale","vælg_person":"Velg person","vælg_person_vikardækning":"Velg person(er)"},"substitutes_show":{"ingen_vikarer_i_dag":"Ingen vikarer i dag"},"substitutes_show_teachers":{"ingen_fraværende_i_dag":"Ingen fraværende i dag"}},"time":{"formats":{"day_only":"%A","devise":{"mailer":{"invitation_instructions":{"accept_until_format":"d. %B %d, %Y %I:%M"}}},"time_only":"%H:%M"}},"unilogin":{"welcome":{"create_a_trial":"Start en gratis prøveperiode!","eller":"eller","enten_giver_din_stilling_dig_ikke_mulighed_for_at_kigge_med_eller_også_er_din_skole_er_ikke_på_docendo_endnu":"Du har ikke tilgang til denne siden, eller så er skolen din enda ikke på Docendo.","hvis_du_vil_have_din_skole_på_docendo_så":"Hvis du ønsker skolen din på Docendo så","kontakt_os":"kontakt oss","prøv_en_demoperiode":"Start en gratis prøveperiode","student_or_parent":"Er du elev eller foresatt?","student_or_parent_info":"Hvis du ser etter din eller ditt barns timeplan, bør denne vanligvis finnes på skolens nettside. Vi anbefaler at du kontakter skolens administrasjon hvis du ikke har tilgang til timeplanen.","velkommen":"Velkommen"}},"users":{"assign_user_hours":{"anden_tid":"Annen tid","der_var":"Det var","fejl_se_nedenfor":"feil. Se nedenfor","lommeregner":"Kalkulator","skemalagt":"Timeplanlagt","tildeling_af_timer":"Tildeling av timer","tildelt":"Tildelt","total_på_år":"Totalt i året","undervisning":"Undervisning","Øvrig_tid":"Øvrig tid"},"create":{"add_user":"Opprett bruker","add_user_with_uni":"- ","create_teacher":"Opprett underviser","fictive_user":"Bruker uten innlogging","fictive_user_text":"Brukeren har en kalender og det er mulig å legge til brukeren som underviser i skolens timeplaner. Dette kan brukes for lærere som ennå ikke er ansatt, eller vikarer uten unilogin. Brukeren kan ikke logge på Docendo.","notify_user_more_users":"Du må selv gi brukerne en melding om tilføyelsen. Du kan skrive flere brukernavn i feltet nedenfor, adskilt med mellomrom.","user_does_not_exist":"Underviseren eksisterer ikke","user_with_email":"Bruker med e-post","user_with_email_text":"Brukes til å opprette brukere med e-post. Brukeren kan logge på med e-post og passord. Det blir sendt en e-post til brukeren med instruksjoner."},"edit":{"annullér":"Annuller","redigér_bruger":"Rediger bruker"},"files_for_download":{"files_to_download":"Filer til nedlasting"},"form":{"andre_undervisere_vide":"Hva kan andre undervisere trenge å vite om deg?","beskrivelse":"Beskrivelse","du_kan_skrive_om_dine_interesser_fag_klassetrin_færdigheder_etc":"Du kan skrive om dine interesser","email":"E-mail","fejl_forhindrede_denne_bruger_i_at_blive_gemt":"feil forhindret at denne brukeren ble lagret:","fjern_profilbillede":"Fjern profilbilde","hvilke_fag":"Hvilke fag","hvilke_klassetrin_underviser":"(Hvilke klassetrinn underviser du?)","initialer":"Initialer","initialer_på_skolen":"Initialer på skolen","klassetrin":"Klassetrinn","opdatér_profil_fra_uni-c":"Oppdater profil fra UNI-C","profilbillede":"Profilbilde","skriv_dit_navn":"Skriv ditt navn","upload_nyt_profilbillede":"Last opp nytt profilbilde?","vælg_dine_fag":"Velg dine fag","vælg_dine_klassetrin":"Velg dine klassetrinn"},"hours":{"skoleåret":"Skoleåret"},"hours_list":{"_vikartimer":"vikartimer","min":"min.","vikartimer":"Vikartimer"},"hours_status":{"anden_tid":"Annen tid","ingen_data":"Ingen data","tildelt":"Tildelt","undervisning":"Undervisning","øvrig_tid":"Øvrig tid"},"list_all":{"alle":"Alle"},"members":{"personale":"Personale","se_alle":"Se alle"},"net_promoter_scores":{"new":{"nps_question":"Hvor sannsynlig er det at du vil anbefale Docendo til en venn eller kollega?","question_one":"Hva er den viktigste årsaken til karakteren du gav? ","reason":"Vi lager et timeplanleggingsprogram til mennesker, og dette er vanskelig å gjøre med mindre vi får tilbakemeldinger fra de som bruker programmet. Vi håper derfor at du vil hjelpe oss med å besvare de to følgende spørsmål. ","very_likely":"Svært sannsynlig","very_unlikely":"Lite sannsynlig"}},"password":{"bekræft_nyt_kodeord":"Bekreft nytt passord","fejl":"feil:","nyt_kodeord":"Nytt passord","skift_kodeord":"Bytt passord"},"profile":{"klassetrin":"Klassetrinn","om_mig":"Om meg","underviser_i":"Underviser i"},"remove_users_list":{"delete_user":"Fjern bruker","press_remove_to_remove":"Klikk på ''Fjern'' for å fjerne en bruker fra skolen.","remove_list_item_1":"Når en bruker blir fjernet, har vedkommende ikke lenger tilgang til skolens grupper eller kalendere.","remove_list_item_2":"Brukeren blir ikke fjernet fra timene på skolen.","remove_list_item_3":"Brukeren blir ikke slettet fra Docendo, men har ikke tilgang til skolen lenger."},"show":{"aktivitet":"Aktivitet","filer":"Filer:","grupper":"Grupper","indlæg":"Innlegg:","medlem_i":"Medlem i:"},"si_teachers_list":{"træk_læreren_fra_venstre_til_højre_for_at_tildele_initialer":"Dra læreren fra venstre mot høyre for å tildele initialer"},"substitute":{"følgene_lærere_er_ledige_i_tidsrummet":"Følgende lærere er ledige i tidsrommet","ingen_lærere_er_ledige_i_tidsrummet":"Ingen lærere er ledige i tidsrommet","kl":"kl.","vælg_vikar":"Velg vikar"},"tasks_status":{"fag_opgave":"Fag/oppgave","lagt_i_skema":"Lagt i timeplan","tildelt":"Tildelt","tilhører":"Timeplan","total":"Totalt"},"user_item_abandoned_user":{"grupper":"Grupper: ","indlæg":"Innlegg:","kalenderaftaler":"Kalenderavtaler:","material_count":"Material count: "},"user_item_profile_calendar_lastseen":{"se_profil":"Se profil","se_tildeling":"Se tildeling"},"user_item_remove_user":{"delete_user":"Fjern bruker"},"user_item_select_substitute":{"vælg_som_vikar":"Velg som vikar"},"user_merge_details":{"aftaler":"Planlagte aktiviteter","groups":"Skoler"}},"views":{"pagination":{"first":"Første","last":"Siste","next":"Neste","previous":"Tidligere","truncate":"..."}},"vue":{"buy":{"a_user_is":"En bruker er en ansatt som har en kalender og / eller innlogging, dvs. en lærer, en pedagog, en vikar etc.","billed_monthly_or_yearly":"Betal månedlig eller årlig","buy":"Kjøp","buy_access_for_school_users":"Kjøp tilgang til skolens brukere","call_us_at":"Ring oss på","choose_the_right_price":"Velg riktig pris for jer","discount":"Rabatt","error":"Feil","go_to_home":"Klikk her for å gå til forsiden","institution":"institusjon","missing_inputs":"Du mangler å fylle ut noen felter","month":"måned","only_pay_per":"Betal kun for de brukere som skal kunne planlegges for, og/eller ha en innlogging","pay_for_unlimited_users_and_get":"Betal for skolens totale elevtall - og få et ubegrenset antall brukere","payment_info":"Betalingsinformasjon","per_month":"Pr. måned","per_student":"pr. elev","per_user":"pr. bruker","per_year":"Pr. år","popular":"populær","price":"pris","questions":"Spørsmål","save_2":"Spar 2%","school_name":"Skolens navn","subscription_info":"Abonnementsinformasjon","thanks_for_buying":"Takk for ditt kjøp.","total":"Total","total_student_number":"Skolens totale antall elever","unlimited":"Ubegrenset","write_number_of_students":"Skriv skolens totale elevtall - og få ubegrenset antall brukere *","write_number_of_users":"Skriv inn antall brukere som vil være i stand til å logge inn / bli planlagt for","your_email":"E-posten din","your_invoice":"Din faktura","your_name":"ditt navn","your_phonenumber":"Telefonnummeret ditt"},"deleteday":{"delete_day_or_week":"Slett dag/uke","whole_week":"Hele uken"},"intro_home":{"step1_title":"Velkommen til Docendo","step3_title":"Navigasjon til alle funksjoner","step4_content":"Her finner du navigasjon til alle timeplaner i Docendo.","step4_title":"Navigasjon til alle timeplaner og kalendere.","step5_content":"Vi har oprettet en demo-timeplan for 4A (4A - DEMO) som du kan redigere, slik at du raskt kan få en følelse av mulighetene i Docendo.","step5_title":"Se demo-timeplan"},"public":{"app":{"sidenav":{"changeview":"Endre visning","showday":"Vis dag","showweek":"Vis uke","showweekplan":"Vis ukeplan"}},"no_notes":"Ingen notater for uken"},"recent_users":{"last_seen":"sist sett","never_logged_in":"aldri logget inn"},"sidenav":{"merge_calendar_special":"felles-timeplaner"},"vacations_days_selector":{"choose_period":"Velg periode","school_days":"skoledager","school_year":"Skoleår","vacation_for_pupils":"Ferier og helligdager"},"year_planning":{"distribute_hours_over_year":"Fordel timer i perioden","hours_during_period":"Timer i perioden","norm":"Fastsatt timetall","number_of_weeks":"Antall uker","planned":"Planlagt","school_days_during_period":"Skoledager i perioden"}}}}

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

	module.exports = {"copycalendar":{"copy":"Kopier","paste":"Sett inn","pasteThisWeek":"Sett inn i denne uken","weekSelected":"uke valgt","weeksSelected":"uker valgt","markWeeksFrom":"Velg uker fra","allWeeks":"Alle uker","oddWeeks":"Oddetallsuker","evenWeeks":"Partallsuker","unselectAll":"Fjern valgte uker","deleteLessonsInSelectedWeeks":"Slett nåværende innhold i de valgte ukene","absenceWillNotBeDeleted":"fraværet vil ikke bli slettet","noticationMessage":"Kopierer","copiedFrom":"Kopieret fra","noSubstitutesOrNotes":"Ingen leksjoner med vikarer eller notater i de valgte ukene.","youAreAboutToDelete":"Du er i ferd med å slette,","lesson":"time","lessons":"timer","withSubstitutesOrNotes":"med vikarer eller notater","week":"Uke"},"homevideoes":{"video":"Video","video_guide":"Videoguides","introduction":"Introduksjon","watch_intro":"Se introduksjon til Docendo","klass_schedule":"Klassetimeplan","klass_schedule_overview":"Oversikt over klassens timeplan","teacher_calendar":"Undervisers kalender","teacher_calendar_overview":"Rundtur i underviserens kalender","notes_weekplan":"Notater & ukeplan","notes_weekplan_overview":"Bruk notater & ukeplaner","learn_to_substitute":"Lær å vikardekke med Docendo"},"vSelect":{"choose_persons":"Velg person(er)"},"substitute_hours":{"title":"Trekk ut timer for undervisere","choose_period":"Velg periode","all":"Alle","teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","choose_persons":"Velg person(er)","work_days":"dager","lessons":"undervisningstimer","calendar_event":"kalenderaktivitet","calendar_events":"kalenderaktiviteter","substitute_for":"Vikar for","substitute_hour":"Vikartime","other_tasks":"Andre oppgaver","other_stuff":"Øvrig tid","total":"Total","hours":"timer","hour":"time","min":"min","shortcuts":"Snarveier","show_all_absent":"Vis alle fraværende i perioden","getting_all":"Henter alle","absent_in_the_period":"fraværende i perioden","there_is_no_one_absent":"Det er ingen fravær i perioden","days_with_absence":"Dager med fravær"},"notifications":{"notifications":"Varsler","all":"Alle","unread":"Uleste","mark_all_as_read":"Merk alle som lest","sent_from":"Sendt fra","mark_as":"Merk som","read":"Lest","not_read":"Ulest","no_new_notifications":"Ingen nye varsler"},"presence":{"work_hours":"Arbeidstider","set_work_hours":"Legg inn arbeidstid","choose_weeks_for_work_hours":"Velg uker for arbeidstid","work_hours_in_the_week":"Timer i uken","cancel":"Angre","copy_to_multiple_weeks":"Sett inn i flere uker","back":"Tilbake","save":"Lagre","times_may_not_overlap":"Tidspunkt kan ikke overlappe","hours":"timer","minutes":"min","h":"t","m":"m","present":"Tilstede","not_present":"Ikke tilstede","total_working_hours":"Arbeidstid for året"},"createusers":{"create_users":"Opprett bruker(e)","login_options":"Login mulighet(er)","can_be_added_later":"kan legges til senere","must_be_added":"Fylles ut","name":"Navn","mail":"mail","placeholder_name":"Fornavn etternavn","placeholder_email":"navn@skolemail.no","email_error_text":"Ugyldig e-mail","add_more":"Legg til flere","create":"Opprett","user":"bruker","users":"brukere","user_created":"Bruker opprettet!","users_created":"Brukere opprettet!","feide_is_already_used_for":"Feide er allerede lagt til"},"createuser_button":{"create_user":"Opprett bruker"},"toast":{"something_went_wrong":"Noe gikk galt"},"subject":{"azure":"Azurblå","blue":"Blå","bronze":"Bronse","brown":"Brun","coral":"Korall","grey":"Grå","green":"Grønn","purple":"Lilla","lightblue":"Lyseblå","lightblue2":"Lyseblå2","lightbrown":"Lysebrun","lightgreen":"Lysegrønn","lightyellow":"Lysegul","lightyellow2":"Lysegul2","lightpurple":"Lyselilla","lightred":"Rosa","marinoblue":"Marineblå","darkblue":"Mørkeblå","darkgreen":"Mørkegrønn","darkyellow":"Mørkegul","darkpurple":"Mørk lilla","darkorange":"Mørkoransje","darkorange2":"Mørkoransje2","orange":"Oransje","red":"Rød","red2":"Rød2","turkis":"Turkis"},"createklass":{"create_klasses":"Opprett klasse(r)","schoolyear":"Skoleår","klass_name":"Klassens navn","klass_step":"Klassetrinn for import av fag (valgfritt)","import_subjects_question":"Ønsker du å importere basisfagene for klassen?","import_subjects_done":"Disse fagene vil bli opprettet i klassen","subjects_for":"Fag for","klass":"klasse","klasses":"klasser","hoursPrYear":"t/år","grade":"klasse","warning_text":"Klasser kan ikke ha samme navn","succes_text":"Klasse(r) ble opprettet","creating":"Oppretter","import_subject_to_the_klass":"Importer fag til klasser","subjects_created_successfully":"Fag ble opprettet"},"createrooms":{"create_rooms":"Opprett rom","room_name":"Navn på rom","placeholder":"Idrettshallen","room":"rom","rooms":"rom","warning_text":"Rom kan ikke ha samme navn","succes_text":"Rom(-mene) ble opprettet!","creating":"Oppretter"},"creating":"Oppretter","createroom_button":{"create_room":"Opprett rom"},"editCalendarEditName":{"edit_name":"Rediger navn","calendar_name":"Kalenderens navn","warning_text":"Navnet kan ikke stå blankt","update_name":"Oppdater navn","success_text":"Navnet er oppdatert!"},"editCalendarMenu":{"edit_name":"Rediger navn","delete_calendar":"Slett kalender","remove_calendar":"Fjern kalender","view":"Visning","5_days":"5 dager","7_days":"7 dager","7_days_and_24_hours":"7 dager, 24 timer","lock":"Lås kalenderen","unlock":"Lås opp","calendar_is_locked":"Kalenderen er låst","merge_with_merge_calendars":"Synkroniser med fellestimeplan","merge_with_calendar":"Synkroniser med klasser","is_merged":"Er synkronisert med","can_be_merged_into":"Kan synkroniseres med","see_public_view":"Se elevvisning","active_public_view":"Aktiver elevvisning"},"editCalendarDelete":{"delete_calendar":"Slett kalender","deleting_this_calendar":"Du er i ferd med å slette kalenderen","all_data_will_be_deleted":"Alle kalenderaktiviteter vil bli slettet permanent, og denne informasjonen kan ikke gjenopprettes.","validator_name":"slett kalenderen","write":"Skriv","if_you_want_to_delete":"hvis du vil slette denne kalenderen","you_have_to_write":"Du må skrive","success_text":"Kalenderen er slettet"},"setupWidget":{"do_steps_for_scheduling":"6 steg for å komme i gang med timeplanleggingen","get_going_easy":"Kom i gang","follow_these_steps":"Følg veiledningene i videoene","write_us":"Chat med oss","support_forum":"Supportforum"},"createmerge":{"create_merge":"Opprett fellestimeplan(er)","name":"Navn","placeholder":"Pauser","calendar":"kalender","calendars":"kalendere","warning_text":"Kalendere kan ikke ha samme navn","succes_text":"Kalender(e) ble opprettet!"},"sidenav":{"not_created_klass":"Du har ikke opprettet noen klasser","not_created_users":"Du har ikke opprettet noen brukere","not_created_rooms":"Du har ikke opprettet noen rom","not_created_merge":"Du har ikke opprettet noen fellestimeplaner","not_created_other":"Du har ikke opprettet noen andre kalendere"},"year_transfer":{"copy_klasses_from":"Kopier kalendere fra skoleåret","to":"til","copy_nothing":"Ikke kopier","klass_name":"Kalendernavn","klass_name_desc":"Kopierer en kalender med samme navn til det nye skoleåret, uten fag.","klass_name_and_subjects":"Navnet på kalenderen og fag inkl. timetall","klass_name_and_subjects_desc":"Kopierer en kalender med samme navn og fag inkl. timetall til det nye skoleåret.","klass_name_and_subjects_with_teachers":"Navnet på kalenderen og fag inkl. timetall og tilknyttede undervisere og rom","klass_name_and_subjects_with_teachers_desc":"Kopierer en kalender med samme navn til det nye skoleåret, i tillegg til fag inkl. timetall og tilknyttede undervisere og rom.","choose_all":"Velg alle","img_src_one":"http://support.docendo.dk/img/transferyear/1NO.png","img_src_two":"http://support.docendo.dk/img/transferyear/2NO.png","img_src_three":"http://support.docendo.dk/img/transferyear/3NO.png","year_transfer_link":"Vil du opprette klasser med navn og fag fra siste skoleår? Klikk her","from_week_33_in":"fra uke 33 i","to_week_33_in":"til uke 33 i","klass_name_and_subjects_with_teachers_and_schedules":"Klassens navn og fag inkl. timetall og tilknyttede undervisere, rom og timeplaner","calendar_already_exist":"kalenderen eksisterer allerede","everything_is_copied_except":"Alt kopieres undtagen evt. tilknyttede klasser","everything_is_copied_except_tooltip":"Hvis det er mer enn én klasse knyttet til brikkene, blir disse ikke kopiert, da de tilknyttede klassene tilhører det forrige skoleåret","and_schedules":"og skema","from_week":"Fra uke","to_week":"Til uke"},"assign_users_hours":{"assign_hours":"Tildel timer","search_a_name":"Søk etter navn","work_hours":"Arbeidstid","teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","name":"Navn","assigned":"Tildelt","scheduled":"Planlagt","diff":"Differanse","update":"Oppdater tall","applies_to_the_period":"Gjelder perioden","tasks":"Oppgaver","preparation":"Forberedelse"},"tagging":{"tagging_users":"Gruppering av brukere","users_selected_from":"brukere valgt av","add_tag_to":"Legg til","select_persons_first":"Velg personer først","select_all":"Velg alle","unselect_all":"Velg ingen","already_created":"Allerede opprettet","example_tags":"Eks. Lærer, Vikar, Team","create_tag":"Opprett tagg","search_tag":"Søk etter tagg","create_tags":"Opprett tagg","with":"med","you_have_created_zero_tags":"Du har opprettet 0 taggs"},"dselect":{"no_matching_results":"Ingen matchende resultater","create_user":"Opprett bruker","placeholder":"Søk etter person","in_same_klass":"I samme klasse","placeholder_calendars":"Søk og velg"},"substitution":{"substitution":"Fraværs- og vikarhåndtering","none_absent":"Ingen fraværende","number_absent_today":"Antall fraværende i dag","today":"I dag","create_absence":"Opprett fraværende","who":"Hvem","person_must_be_filled":"Person må utfylles","reason":"Årsak","choose_absence_reason":"Velg fraværsårsak","create":"Opprett","reason_must_be_filled":"Årsak må utfylles","date":"Dato","time":"Tid","absent_period":"Fraværsperiode","do_you_want_to_delete_the_absent_reason":"Vil du slette fraværsårsaken","yes":"Ja","cancel":"Annuller","substitutes_will_not_be_removed":"Vikarer i timeplaner vil IKKE bli fjernet. Fjern evt. disse først.","subject":"Fag","class":"Klasse","other_users":"Også tilknyttet","substitute":"Vikar","substitute_notes":"Vikarnotater","todays_lessons":"Dagens timer","see_all":"Se alle","see_less":"Se mindre","absence_is_created_in_a_calendar":"Fraværet er lagt inn en kalender, og må derfor slettes i denne.","go_to_calendar":"Gå til kalender","deleting_absence_from":"Slett fraværet for","to":"til","choose_absence_user":"Velg en eller flere lærere","absence_notes":"Notat for fravær","add_sub_to_several_lesson":"Sett en vikar på flere leksjoner","find_sub_for":"Finn vikar til","lessons":"leksjoner","finding_available_subs":"Finne tilgjengelig vikarer","select_lessons_to_substitute":"Velg leksjoner som skal dekkes av vikarer","overlap":"overlapping","available":"Tilgjengelig","do_you_want_to_save":"Vil du lagre endringene dine","no_close_without_saving":"Nei, lukk uten å lagre","yes_save_my_changes":"Ja, lagre endringene mine","lessons_updated":"Leksjoner oppdatert","lessons_without_sub":"Leksjoner uten vikarer","lessons_with_sub":"Leksjoner med vikarer","all_lessons":"Alle leksjoner","no_lessons_without_subs":"Ingen leksjoner uten vikarer","no_lessons_with_sub":"Ingen leksjoner med vikarer","no_lessons":"Ingen leksjoner","remove_sub_from_all_lessons":"Fjern som vikar for alle leksjoner","do_you_want_to_remove":"Vil du fjerne","as_sub_on":"som vikar på","or_on_all_lessons":"eller i alle leksjoner","remove_from_all_lessons":"Fjern fra alle leksjoner","just_this_lessons":"Bare i denne leksjonen","choose_period_lessons":"Velg en periode for å se leksjoner","from_selected_date_onwards":"Fra valgt dato og videre","entire_period":"Hele perioden","selected_date":"Valgt dato","lessons_that_overlap_in_class":"Samtidig i klassen","delete_lesson":"Slett leksjon"},"substitution_user":{"multiple_days":"Flere dager","lessons_on_day":"Undervisningstimer denne dag","lessons_affected_by_absence":"Timer påvirket av fravær","absent":"Fraværende"},"substitution_show":{"show_all_lessons":"Vis alle timer","show_the_absent":"Vis fraværende","lessons":"Timer","choosen_lessons":"Valgte timer"},"sub_scheduler":{"filter_substitutes":"Filtrer vikarer","sub_pools":"Vikarpuljer","todays_absent":"Dagens fraværende","potential_subs":"Mulige vikarer","choose_sub":"Velg vikar","status":"Status","sort_after":"Sorter etter forslag","set_priorities":"Velg prioriteringer","sorting_will_be_based_on":"Sorteringen baseres på","already_on_lesson":"Også tilknyttet timen","not_occupied_with_available_lesson":"Ledig m/rådighetstime","not_occupied_with_work_hours":"Ledig m/arbeidstid","not_occupied_without_work_hours":"Ledig u/arbeidstid","multiple_lessons_in_same_classes":"+2 lærere samtidig i en annen klasse","not_occupied_without_lessons_on_the_day":"Ledig u/timer på dagen","is_in_same_class_at_the_same_time":"Er i klassen samtidig","occupied":"Opptatt","it_will_also_be_sorted_based_on_tags_in_common":"Sorteringen skjer også ut fra antall taggs til felles med den fraværende","absent_people":"Fraværende","substitutes":"Vikarer","out_of":"av","potential_substitutes":"Potensielle vikarer","pool":"Pulje","choose_filters":"Velg filtre","list":"Liste","schedules_overview":"Timeplanoverblikk","is_substituted":"Er vikar-dekket"},"sub_scheduler_item":{"prolonged_absence":"Langtidsfravær","also_on_lesson":"Også tilknyttet"},"sub_scheduler_popover":{"substitute_for":"Sett inn vikar for","handled":"Håndtert","not_handled":"Ikke håndtert","handled_for_absence":"Håndtert for alle fraværende","pending":"Avventer"},"sub_scheduler_sub_pools":{"substitute_hours":"Vikartimer","difference":"Forskjell","assigned":"Tildelt","scheduled":"Planlagt"},"IEWarning":{"you_are_using_a_IE_or_Edge_to_get":"OBS! Du bruker Internet Explorer/Edge. For å få","a_faster_and_better_experience":"en raskere og bedre opplevelse","we_recommend_that_you_switch_to_these_browsers":"anbefaler vi at du bytter til en av disse gratis nettleserne","or":"eller"},"dashboard":{"welcome":"Velkommen","start_by_setting_up":"Kom i gang  med Docendo","steps_completed":"Steg gjennomført","step":"Steg","tutorial":"Video","follow_the_steps":"Følg oppsettingsguiden"},"delete_day_or_week":{"cant_delete":"Kunne ikke slette. Prøv igjen."},"user_event_list":{"teaching":"Undervisning","substitute_hours":"Vikartimer","absence":"Fravær","from":"fra","to":"til","no_matching_events":"List is empty","total":"Total","close":"Lukk"},"weekplan_2":{"no_events_this_week":"Ingen leksjoner denne uken"},"event_form":{"delete_events_onward":"Slett dette og alt for samme tid fremover","are_you_sure":"Er du sikker?","do_you_want_to_delete_this_and_all_in_same_timeslot":"Vil du slette denne leksjonen og alt som er på samme ukedag og i samme tidsrom fremover?","cancel":"Avbryt"},"calendar_export":{"export_calendar":"Eksporter kalender","export_calendar_to":"Eksporter kalenderen til...","copy_the_url_and_insert":"Kopier følgende URL og sett inn i den eksterne kalenderen","guide_to":"Veiledning til","guide_to_export_calendar":"Instruksjoner for eksport til en ekstern kalender","create_a_link_on_mobile":"Sette opp timeplaner på mobil"},"common":{"search":"Søk","show_print_hours":"Vis beregn timer","show_as_blocks":"Vis som blokker","show_as_list":"Vis som liste","add":"Legg til","save":"Lagre","saved":"Lagret","dont_save":"Ikke lagre","create":"Opprett","cancel":"Annuller","update":"Oppdater","edit":"Redigere","delete":"Slett","select":"Velg","yes":"Ja","no":"Nei","save_changes":"Ønsker du å lagre endringene?","ago":"siden","min":"min","class":"Klasse","classes":"Klasser","classes_sidenav":"Klasser","teacher":"Underviser","room":"Rom","substitute":"Vikarer","add_user":"Tilføy bruker","press":"Trykk","user":"Bruker","users":"Brukere","rooms":"Rom","merge_calendar":"Fellestimeplan","merge_calendars":"Fellestimeplan","merge_calendars_sidenav":"Felles-timeplaner","other_calendar":"kalender","other_calendars":"Andre kalendere","close":"Lukk","must_be_filled":"Må utfylles","something_went_wrong":"Noe gikk galt","show_weekends":"Vis helger","calendar":"Kalender","in":"i","search_for":"søk etter","remove":"Fjern","none_created":"None created","log":"Historikk","no_calendars_found":"Ingen kalendere funnet..","done":"Ferdig","is_deleted":"er slettet","choose_school":"Velg skole","show_more":"Vis flere","show_less":"Skjul flere","search_name_or_initials":"Søk på navn eller initialer","hide_calendars":"Skjul kalendere","hide_dates":"Skjul datoer"},"weeknote_log":{"saved_versions":"Lagrede versjoner av ukentlige notater","activity":"Historikk","no_saved_versions":"Ingen lagrede versjoner","choose_versions_to_compare":"Velg versjoner for sammenligning","current_version":"Gjeldende versjon"},"show_event":{"this_lesson_counts_as":"Denne leksjonen teller som"},"permissions":{"roles":"Roller","create_new_role":"Opprett ny rolle","users":"Brukere","users_assigned_role":"brukere tildelt rollen","add_user_to":"Tilføy bruker","role":"rolle","permissions":"Tillatelser","change_permissions_for_role":"Endre tillatelser for rollen","rename_role":"Endre navn på rollen","delete_role":"Slett rollen","give_role_a_title":"Gi rollen et navn","choose_new_name":"Velg nytt navn","you_cant_delete_a_role_that_has_users":"Du kan ikke slette en rolle som har brukere tilknyttet","give_the_following_user_a_new_role":"Gi følgende brukere en ny rolle","can_change_substitution":"Vikarhåndtering - Tilgang til vikarhåndteringen","can_do_most_stuff":"Kan gjøre det meste","can_edit_own_notes":"Timeplan - Kan redigere notater","can_export":"Kan eksportere til Docendo ZEN","can_manage_absence_reasons":"Vikarhåndtering - Kan opprette, slette og redigere fraværsårsaker","can_manage_assigned_hours":"Tildele timer - Kan redigere i Tildele timer","can_see_assigned_hours":"Tildele timer - Tilgang til Tildele timer","can_manage_school_years":"Kan redigere skoleår","can_manage_sms":"Kan sende SMS","can_manage_substitute_hours":"Kan redigere vikartimer","can_manage_tasks":"Kan redigere Oppgaver","can_manage_users":"Kan håndtere brukere","can_see_other_calendars":"Timeplan - Kan se alle kalendere","can_manage_calendars":"Kan opprette, slette og redigere kalendere","change_role":"Endre rolle","role_desc_administrator":"En administrator har tilgang til alle funksjoner i Docendo, og kan redigere brukerrettigheter for alle roller.","role_desc_read_only_user":"En bruker med lesetilgang har som utgangspunkt kun adgang til egen kalender, og brukeren kan ikke se eller redigere andre kalendere eller bruke vikarhåndteringen og andre administrative funksjoner. Denne rolle kan derimot tildeles tilgang til utvalgte funksjoner.","role_desc_regular_user":"En Vanlig bruker har tilgang til alle timeplaner/kalendere og de fleste funksjoner, men kan ikke tilføye, endre eller slette brukere og skoleår.","role_updated":"Rollen er oppdatert","role_deleted":"Rollen er slettet","role_created":"Rollen er opprettet","can_see_other_subject_requests":"Fagønsker - Kan se andres ønsker","can_edit_subject_requests":"Fagønsker - Kan ønske fag (når det er åpnet for Fagønsker)","can_see_subjects_distribution_page":"Fag- og lærerfordeling - Tilgang til fag- og lærerfordeling","can_see_others_task_overviews":"Oppgaveoversikt - Kan se andres oppgaveoversikt","can_see_own_task_overview":"Oppgaveoversikt - Kan se sin egen oppgaveoversikt","can_edit_own_presence":"Arbeidstid - Kan redigere sin egen arbeidstid","can_edit_others_presence":"Arbeidstid - Kan redigere andres arbeidstid","can_edit_user_year_notes":"Oppgaveoversikt - Kan skrive og redigere notater hos andre","can_send_substitute_email":"Vikarhåndtering - Kan sende emails","can_send_substitute_sms":"Vikarhåndtering - Kan sende SMS'er","select_role_to_base_new_on":"Velg en rolle den nye skal baseres på"},"calendars":{"calendars":"Kalendere","edit_calendars":"Slett / gi nytt navn til kalendere","copy_calendars":"Kopier kalendere","archive":"Fjern","show":"Se","hide":"Skjul","archived":"fjernet","unarchive":"Gjenopprett","write_name":"Skriv navn","selected_of":"valgt av","select_calendars_to_copy":"Velg kalendere som skal kopieres","copy":"Kopier","select_week_to_copy_from":"Velg uke å kopiere fra","select_weeks_that_week":"Velg uker som uke","must_be_copied_to":"må kopieres til","print_calendars":"Skrive ut kalendere","add_presence":"Legg til arbeidstid","do_you_want_to_delete":"Ønsker du å slette","delete_events_in_date_range":"Slett hendelser i datointervallet"},"sms":{"sms":"Melding","do_you_want_to_delete_the_template":"Vil du slette meldingen","template_sms_deleted":"Meldingen er slettet","an_error_occured":"Det oppsto en feil","add_number":"Legg til mobilnummer","number_must_be_8_digits":"Telefonnummer må være 8 sifre","number_deleted":"Telefonnummer slettet","number_added_awaiting":"Nummeret er lagt til. Venter på bekreftelse","edit":"Rediger","new":"Ny","standard_sms":"standard-meldingen","title":"Tittel","to_show_in_list":"til visning i listen","ex_you_are_sub":"Eks. Du er blitt vikar","insert_today_to":"Sett inn [today] for få dagen eks.","updated_sms_template":"Oppdaterte meldingen","created_sms_template":"Opprettet meldingen,","message":"Beskjed","subject":"Emne"},"subs_ongoing_absence":{"delete_absence":"Slett fravær","change_start_and_end_date":"Endre start- og sluttdato","ongoing_absence":"Løpende lengre fravær","ongoing_absence_explained":"Løpende fravær forlenges automatisk når den opprinnelige sluttdatoen for fraværet er nådd. Sluttdatoen er den forventede siste dato for fraværet. Fraværet forlenges med én dag om gangen frem til man avslutter fraværet.","date_label":"Dato (inkl. begge dager)","absence_will_be_deleted":"Fravær slettes","remove_subs_and_delete_absence":"Fjern vikarer og slett fravær","keep_subs_and_delete_absence":"Behold vikarer og slett fravær","remove_subs_and_update":"Fjern vikarer og oppdater","keep_subs_and_update":"Behold vikarer og oppdater","remove_subs_and_stop_ongoing_absence":"Fjern vikarer og stopp løpende fravær","keep_subs_and_stop_ongoing_absence":"Behold vikarer og stopp løpende fravær","confirm_date_and_stop_ongoing_absence":"Bekreft datoer og stopp løpende fravær","update_dates":"Oppdater datoer","checking_for_substitutes":"Ser etter vikarer vikarer","lessons_with_substitutes":"Timer med vikar","no_subs_on_lessons":"Ingen vikarer er planlagt i de dagene fraværet slettes","of":"av","lessons_that_will_have_subs_removed":"timer får slettet vikarer","select_all":"Velg alle","unselect_all":"Fjern alle","remove_sub":"Fjern vikar","teachers_with_ongoing_absence":"Undervisere med løpende fravær","no_teachers_with_ongoing_absence":"Ingen undervisere med løpende fravær","absence_will_be_prolonged_in":"Forlenges om","edit_stop":"Rediger/stopp","subs_removed":"Vikarer fjernet","absence_deleted":"Fravær slettet","auto_created_today":"Opprettet automatisk i dag","absence_updated":"Fravær oppdatert","stop_ongoing_absence":"Stopp løpende fravær","cant_be_ongoing_absence":"Løpende fravær kan ikke opprettes med en sluttdato tidligere enn dagens dato","auto_created":"Opprettet automatisk"},"zen_import":{"import_from_zen":"Importer timeplanversjonene fra ZEN til Docendo","choose_version":"Velg timeplanversjoner","you_have_no_created_any_versions":"Du har ikke opprettet timeplanversjoner i ZEN","last_updated":"Siste endring","choose_schoolyear":"Velg skoleår","insert_in_week":"Sett inn i uke","insert_schedules":"Sett inn timeplaner","week":"Uke","schedules_are_being_inserted":"Timeplaner settes inn i uke"},"create_calendars":{"other_calendar":"Opprett annen kalender","other_calendar_placeholder":"Eks. møtekalender"},"create_subject":{"create_subject":"Opprett fag","subject_is_not_created_in_this_school_year":"Brikken er opprettet. Vær imidlertid oppmerksom på at den er tilknyttet et skoleår som ikke matcher den nåværende datoen."},"task_overview":{"task_overview":"Oppgaveoversikt","no_tasks_assigned":"Ingen oppgaver tildelt","distribution":"Fordeling","work_hours":"Arbeidstid","teaching":"Undervisning","tasks":"Oppgaver","preparation":"Forberedelse","show_scheduled_hours":"Vis planlagte timer","coming_soon":"Kommer snart","belongs_to":"Tilhører","absence":"Fravær'","reset":"Tilbakestill datoer","club":"SFO","substitute_hours":"Vikartimer","showing_scheduled_hours_from":"Viser planlagte timer fra","rest":"Rest","pool":"Planleggingsdager","unknown":"Beredskapstimer","diff_from_total_workhours":"Forskjell i forhold til tildelt arbeidstid"},"standard_settings":{"standard_setting":"Standardinnstilling","set_default_start_and_endtime":"Angi standard start- og sluttid"},"print_all_calendars":{"loading":"Henter alle timeplaner. Det kan ta litt tid..","no_calendars":"Det er 0 kalendere med leksjoner","are_you_ready_to_print":"Er du klar til å skrive ut?","print":"Skrive ut","this_calendar":"Denne kalenderen","this_calendar_with_weekplan":"Kalender m. ukeplan","all_classes":"Alle klasser","all_teachers":"Alle lærere","all_rooms":"Alle rom","only_printing_calendars_with_lessons":"Printer kun timeplaner med timer","show_print_without_bg_colors":"Print uten bakgrunnsfarger","event_font_size":"Skriftstørrelse","custom":"Velg kalendere"},"edit_event":{"teachers":"Lærere","substitutes":"Vikarer","rooms":"Rom","klass":"Klasser","swap_headline":"Følgende leksjoner kan byttes med den valgte leksjon","swap_desc":"Bytt-funksjonen brukes til å bytte ut en eksisterende leksjon med en annen planlagt leksjon fra en annen tid i samme kalender. Dette betyr at man kan flytte en planlagt leksjon til en annen tid og erstatte den med en annen leksjon fra samme kalender. Følgende leksjoner er mulige å bytte med den valgte leksjonen, siden både læreren og klasserommet vil være tilgjengelige i de nye tidspunktene.","swap_no_lessons":"Dessverre ingen leksjoner å bytte med...","select":"Velg","replace_headline":"Erstat leksjonen med en ny","replace_desc":"Erstat-funksjonen brukes til å erstatte en eksisterende leksjon med en ny (ikke-planlagt) leksjon fra et valgt fag. Det er mulig å erstatte leksjonen med en ny fra de følgende fagene, siden både læreren og rommet er tilgjengelig.","replace_no_lessons":"Dessverre ingen leksjoner å erstatte med...","lesson_updated":"Leksjonen er oppdatert"},"students":{"all":"Alle","activated_schedules":"Aktiverte elevtimeplaner","student":"elev","students":"elever","created_student":"Elev opprettet","delete_student":"Fjern elev?","add_student":"Legg til fra andre klasse","create_student":"Opprett elev","students_with_same_name":"Følgende elever har et lignende navn","users_with_same_name":"Følgende brukere har et lignende navn","latest_updated":"Senest oppdatert","is_already_in_the_klass":"Er allerede i klassen","without_a_group":"uten klasse","has_no_groups":"Ingen klasser tilknyttet","name":"navn","feide":"feide","feide_is_already_used":"Dette Feide er allerede i bruk","import_students":"Importer elever","groups":"grupper","without_group":"Uten klasse","calendar":"kalender","remove":"fjern","of":"av","students_in":"elever i","the_group":"klassen","select_all":"Velg alle","unselect_all":"Fravelg alle","insert_multiple_students":"Sett inn liste over elevnavn. Bytt linje etter hver elev.","create_multiple_students":"Opprett flere elever samtidig","to_be_scheduled":"Kan planlegges"},"set_standard_duration":{"lessons_duration":"Timelengde","minutes":"minutter","set_standard_duration_for_the_school":"Standard timelengde på skolen","standard_duration_for_the_school":"Angi standard timelengde for skolens undervisningstimer","the_number_must_be_divisible_by_five":"Minuttallet må gå opp i 5","this_setting_will_be_selected_if_nothing_else_is":"Denne innstillingen vil gjelde, hvis man ikke velger annet.","standard_duration_can_be_selected_for_each_course":"Timelengden kan alltid endres for hvert enkelt fag","already_created_courses_want_be_updated":"Fag som allerede er opprettet vil ikke oppdateres","set_standard_length_for_zen":"Standardlengde på skoletimene brukes til å utregne antall leksjoner/timer i uken i en timeplan i Docendo ZEN."},"club":{"club":"SFO","club_calendar":"SFO-kalender","create_club_calendar":"Opprett SFO-kalender","not_created_club":"Med en timeplan for SFO kan du planlegge SFO-tid for ansatte uavhengig fra skoleundervisning"},"calendar_view_day":{"remove":"Fjern","add":"Legg til","replace":"Erstatt","actions_for":"Handlinger for","onwards":"fremover","remove_onwards":"Fjern fremover","do_you_want_to_remove":"Ønsker du å fjerne","on_all_lessons_from":"på alle leksjoner fra og med","and_onwards":"og på alle fremtidige leksjoner","add_onwards":"Legg til fremover","do_you_want_to_add":"Ønsker du å legge til","on_all":"på alle","lessons":"leksjoner","onwards_which_include":"fremover? Dette inkluderer leksjoner fra og med","and_all_onwards":"og på alle fremtidige leksjoner","with_on_all":"med på alle","select_the_person_to_replace":"Velg kalenderen du vil erstatte","select_person":"Velg kalender","replace_onwards":"Erstatt fremover"},"eventTypes":{"subject":"Fag","optional":"Valgfag/gruppe","supplemental":"UUV","frame":"Temavisning (Ramme)","break":"Pause","resource":"Ressurs","person_resource":"Ressurs (skjult)","other_tasks":"Annen tid","other_stuff":"Øvrig tid","available":"Rådighetstime","person_resource_visible":"Ressurs (Vises for elever)","club":"SFO tid","additional_tasks":"Øvrige oppgaver","preparation":"Forberedelse","with_kids":"Tid med børn","without_kids":"Tid uden børn","pool":"Planleggingsdager","absence":"Fravær"},"task_versions":{"task_overview":"Oppgaveoversikt","versions":"Versjoner","save_print_task_overviews":"Lag/skriv ut oppgaveoversikter","save_new_version_task_overviews":"Lag en ny versjon av oppgaveoversikter","print_latest_version_task_overviews":"Skriv ut nyeste versjon av oppgaveoversikter","saved_message":"Lagret","delete_message":"Slett","confirm_delete_message":"Ønsker du å slette","delete_warning_message":"Slettede versjoner kan ikke gjenopprettes","annual_norm":"Årsnorm","save_task_overview_version":"Lagre versjon av oppgaveoversikt","version_title":"Tittel for versjon av oppgaveoversikten","auto_name_description":"Navngis automatisk med dagens dato hvis du ikke angir en tittel","what_is_version":"Hva er en versjon?","saved_task_overview_description":"En lagret oppgaveoversikt viser et øyeblikksbilde av medarbeiderens oppgaveoversikt slik den så ut på tidspunktet da versjonen av oppgaveoversikten ble lagret. Det tilsvarer å lage en utskrift eller PDF med detaljer om hvordan oppgaveoversikten så ut på det gitte tidspunktet.","find_saved_versions":"Hvor kan jeg finne lagrede versjoner?","find_saved_versions_description":"Du kan finne lagrede versjoner ved å navigere til \"Oppgaveoversikt\" for hver enkelt person. Her vil det være en rullegardinmeny der alle lagrede versjoner i skoleåret er tilgjengelige for gjennomsyn.","select_personnel":"Velg personale","go_back":"Tilbake","select_min_user":"Minst én bruker må velges","save_for_selected_users":"Lagre for","save_for_selected_users_of":"av","print_latest_version":"Skriv ut nyeste versjon av oppgaveoversikt for alle","no_saved_versions":"Ingen versjoner er lagret"},"deleted_subjects_log":{"deleted_log":"Log over slettede","no_lessons_deleted":"Ingen leksjoner er slettet fra denne brikken","lesson":"Leksjonen","deleted":"Slettet"},"create_activity":{"create_activity":"Opprett aktivitet","create_activity_for":"Opprett aktivitet for","title":"tittel","search_or_create":"Søk eller opprett","created":"Opprettet","create_new_subject_for":"Opprett nytt fag for","choose_subject_type":"Velg type","the_selected_date_is_outside_schoolyears":"Den valgte datoen er utenfor alle aktive skoleår"},"datepicker":{"max_date_range_start":"Du kan maks hente","max_date_range_end":"dagers intervall"}}

/***/ }),
/* 1166 */,
/* 1167 */,
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 168,
		"./af.js": 168,
		"./ar": 175,
		"./ar-dz": 169,
		"./ar-dz.js": 169,
		"./ar-kw": 170,
		"./ar-kw.js": 170,
		"./ar-ly": 171,
		"./ar-ly.js": 171,
		"./ar-ma": 172,
		"./ar-ma.js": 172,
		"./ar-sa": 173,
		"./ar-sa.js": 173,
		"./ar-tn": 174,
		"./ar-tn.js": 174,
		"./ar.js": 175,
		"./az": 176,
		"./az.js": 176,
		"./be": 177,
		"./be.js": 177,
		"./bg": 178,
		"./bg.js": 178,
		"./bm": 179,
		"./bm.js": 179,
		"./bn": 180,
		"./bn.js": 180,
		"./bo": 181,
		"./bo.js": 181,
		"./br": 182,
		"./br.js": 182,
		"./bs": 183,
		"./bs.js": 183,
		"./ca": 184,
		"./ca.js": 184,
		"./cs": 185,
		"./cs.js": 185,
		"./cv": 186,
		"./cv.js": 186,
		"./cy": 187,
		"./cy.js": 187,
		"./da": 188,
		"./da.js": 188,
		"./de": 191,
		"./de-at": 189,
		"./de-at.js": 189,
		"./de-ch": 190,
		"./de-ch.js": 190,
		"./de.js": 191,
		"./dv": 192,
		"./dv.js": 192,
		"./el": 193,
		"./el.js": 193,
		"./en-au": 194,
		"./en-au.js": 194,
		"./en-ca": 195,
		"./en-ca.js": 195,
		"./en-gb": 196,
		"./en-gb.js": 196,
		"./en-ie": 197,
		"./en-ie.js": 197,
		"./en-il": 198,
		"./en-il.js": 198,
		"./en-nz": 199,
		"./en-nz.js": 199,
		"./eo": 200,
		"./eo.js": 200,
		"./es": 203,
		"./es-do": 201,
		"./es-do.js": 201,
		"./es-us": 202,
		"./es-us.js": 202,
		"./es.js": 203,
		"./et": 204,
		"./et.js": 204,
		"./eu": 205,
		"./eu.js": 205,
		"./fa": 206,
		"./fa.js": 206,
		"./fi": 207,
		"./fi.js": 207,
		"./fo": 208,
		"./fo.js": 208,
		"./fr": 211,
		"./fr-ca": 209,
		"./fr-ca.js": 209,
		"./fr-ch": 210,
		"./fr-ch.js": 210,
		"./fr.js": 211,
		"./fy": 212,
		"./fy.js": 212,
		"./gd": 213,
		"./gd.js": 213,
		"./gl": 214,
		"./gl.js": 214,
		"./gom-latn": 215,
		"./gom-latn.js": 215,
		"./gu": 216,
		"./gu.js": 216,
		"./he": 217,
		"./he.js": 217,
		"./hi": 218,
		"./hi.js": 218,
		"./hr": 219,
		"./hr.js": 219,
		"./hu": 220,
		"./hu.js": 220,
		"./hy-am": 221,
		"./hy-am.js": 221,
		"./id": 222,
		"./id.js": 222,
		"./is": 223,
		"./is.js": 223,
		"./it": 224,
		"./it.js": 224,
		"./ja": 225,
		"./ja.js": 225,
		"./jv": 226,
		"./jv.js": 226,
		"./ka": 227,
		"./ka.js": 227,
		"./kk": 228,
		"./kk.js": 228,
		"./km": 229,
		"./km.js": 229,
		"./kn": 230,
		"./kn.js": 230,
		"./ko": 231,
		"./ko.js": 231,
		"./ky": 232,
		"./ky.js": 232,
		"./lb": 233,
		"./lb.js": 233,
		"./lo": 234,
		"./lo.js": 234,
		"./lt": 235,
		"./lt.js": 235,
		"./lv": 236,
		"./lv.js": 236,
		"./me": 237,
		"./me.js": 237,
		"./mi": 238,
		"./mi.js": 238,
		"./mk": 239,
		"./mk.js": 239,
		"./ml": 240,
		"./ml.js": 240,
		"./mn": 241,
		"./mn.js": 241,
		"./mr": 242,
		"./mr.js": 242,
		"./ms": 244,
		"./ms-my": 243,
		"./ms-my.js": 243,
		"./ms.js": 244,
		"./mt": 245,
		"./mt.js": 245,
		"./my": 246,
		"./my.js": 246,
		"./nb": 247,
		"./nb.js": 247,
		"./ne": 248,
		"./ne.js": 248,
		"./nl": 250,
		"./nl-be": 249,
		"./nl-be.js": 249,
		"./nl.js": 250,
		"./nn": 251,
		"./nn.js": 251,
		"./pa-in": 252,
		"./pa-in.js": 252,
		"./pl": 253,
		"./pl.js": 253,
		"./pt": 255,
		"./pt-br": 254,
		"./pt-br.js": 254,
		"./pt.js": 255,
		"./ro": 256,
		"./ro.js": 256,
		"./ru": 257,
		"./ru.js": 257,
		"./sd": 258,
		"./sd.js": 258,
		"./se": 259,
		"./se.js": 259,
		"./si": 260,
		"./si.js": 260,
		"./sk": 261,
		"./sk.js": 261,
		"./sl": 262,
		"./sl.js": 262,
		"./sq": 263,
		"./sq.js": 263,
		"./sr": 265,
		"./sr-cyrl": 264,
		"./sr-cyrl.js": 264,
		"./sr.js": 265,
		"./ss": 266,
		"./ss.js": 266,
		"./sv": 267,
		"./sv.js": 267,
		"./sw": 268,
		"./sw.js": 268,
		"./ta": 269,
		"./ta.js": 269,
		"./te": 270,
		"./te.js": 270,
		"./tet": 271,
		"./tet.js": 271,
		"./tg": 272,
		"./tg.js": 272,
		"./th": 273,
		"./th.js": 273,
		"./tl-ph": 274,
		"./tl-ph.js": 274,
		"./tlh": 275,
		"./tlh.js": 275,
		"./tr": 276,
		"./tr.js": 276,
		"./tzl": 277,
		"./tzl.js": 277,
		"./tzm": 279,
		"./tzm-latn": 278,
		"./tzm-latn.js": 278,
		"./tzm.js": 279,
		"./ug-cn": 280,
		"./ug-cn.js": 280,
		"./uk": 281,
		"./uk.js": 281,
		"./ur": 282,
		"./ur.js": 282,
		"./uz": 284,
		"./uz-latn": 283,
		"./uz-latn.js": 283,
		"./uz.js": 284,
		"./vi": 285,
		"./vi.js": 285,
		"./x-pseudo": 286,
		"./x-pseudo.js": 286,
		"./yo": 287,
		"./yo.js": 287,
		"./zh-cn": 288,
		"./zh-cn.js": 288,
		"./zh-hk": 289,
		"./zh-hk.js": 289,
		"./zh-tw": 290,
		"./zh-tw.js": 290
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1168;


/***/ }),
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/frame.c31a116.png";

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/optional.0efc797.png";

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/subject.68609e0.png";

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABqWSURBVHgB7d1dkJ7ledjxW+hbQisk23ECEvGM4jbu0trJiLHFDE4Pagn6YeWASjoLsaEd2ukUpB45cUGZ+qStJHoQezrCOMm0M5aCPWGa1pJoemBqy7aYJCTamTix4jgSGDOgj0ViVx+rzXu94sUrsSvtx/O8+77P9fvNKMhgwDaB6//c9/3cz4LxlgIApHJbAQDSEQAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJCQAASEgAAEBCAgAAEhIAAJCQAACAhAQAACQkAAAgIQEAAAkJAABISAAAQEICAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJCQAASEgAAEBCAgAAEhIAAJCQAACAhAQAACQkAAAgIQEAAAkJAABISAAAQEICAAASEgAAkJAAAICEBAAAJLSoMGuvnR0vJ14fK6+dGy8/OXu1nB8tAJV7++JIOXvhfKGU9e9bXAZWLCx3r11S1r1/SRlct6wwOwJgBmLgf+uvrpSXf3S19WOsnL84XgDqdvbCxfLjN88U3itiYNOHV5YHPzZQNv29la1AWFKYngXjLYUpnR8dL4f//Er51vfHyst/O1YAui2e/n/85uuFW4sI2L5pTXngowPtOGBqAmAKMfi/duxK+fr3LnvSB+aVAJi5WAmIGNj1z3/GqsAUBMANDH6g1wiA2Yvhv23THa0Q+GDhegJggj9t7ev/lz+82D7UB9ArBMDcRQjs+7V15b7WqgDXCIB3/PYLl8rXj10uAL1GAFQntgSsBlyTPgDiZP9/bj31O+AH9CoBUK14dfDZx34+/dmA1BcBxfDf9T9HDH+ARIZOjZaH9v6wnHzzUsksbQB0hr/9foB8Yvhnj4CUAWD4A5A9AtIFgOEPQEfmCEgXAE9+bdTwB+BdMfwf/91TJZtUAfC7L14uP/jJ1QIAEx39ywvlyd//cckkTQDEJT+/92LuE58ATG3/H71Rvt0KgSzSBEDc8AcAN/NEaytg+O0cr4anCIBY+rfvD8CtxHmA/f/vjZJB4wMgTv0f+TNX/AIwPfv/6M0UqwCND4DY9/f0D8B0DY+MpVgFaHQAxKd9XfMLwExlWAVodAB86y/HPP0DMGOxCnDg6JnSZI0OgMN/dqUAwGwcenm4NFljAyAO/1n+B2C24nKgUw2+IrixAWD4AzBX3/jT5q4CNDYALP8DMFdNvhmwsQFwwp3/AMzRUQHQX37w2tVy/qLT/wDMTbwN0NRzAI0MgJ+c8/QPQDWOnxotTdTIAHht2NM/ANU4+YYVgL4RNwACQBVsAfQRt/8BUJVzI83cVk7xOWAA4HoCAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJCQAASEgAAEBCAgAAEhIAAJCQAACAhAQAACQkAAAgIQEAAAkJAABISAAAQEICAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJCQAASEgAAEBCAgAAEhIAAJCQAACAhAQAACQkAAAgIQEAAAkJAABISAAAQEICAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJCQAASEgAAEBCiwpUbMs/WlQ+evfCAlTj0hv/v5z/4X8vzI+7P/RPWv/335SmEQBULoZ/RABQjfFXf1LGxv9XYX4s+MCa0kS2AAAgIQEAAAkJAABISAAAQEICAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJCQAASEgAAEBCAgAAEhIAAJCQAACAhAQAACQkAAAgIQEAAAkJAABISAAAQEICAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJLSrAnA2PjpeTp8fK0CuXy8kzY+XUmavtfz08crWcGxmf9PdZvXxBGVh+W+vHgrJ+zcL2j8G7FrV/3eCd/tYE6uWfMjALMfBj2B86frEcPXGpDL16pczUqTNT/7aBZbe1Y2DThsXlvg1LWr9cUgCqJABgBmLYx9A/eGy0FQFXS13ijx1/rvixt1xorw5EBGy7d5kYACohAGAaDh4bKQdfGm0P5PkQ2wonX4r/DCPtGNi5eWW57xeWlHWtn3O9+Ov05B+8NatA27djoGzbuLxABgIAbiIG/uNfHW4t14+VXhEx8MSB4fbPY1jt2rJSCJRr2zJ7Dp8vz7z4dgFuTQDAJNpDtjX45+uJf7oOvrMqsHPz7eXR+1e0DxRmFGcwPvOVsz0VatDrvAYIN9hz5EL5xBfe6PnhP9HeI+fL5r1vtrcqstnfeuKP/+6GP8yMFQB4Rzz1f7b1FDmbE/29oLM1cPTE5bJ766rGrwb0yyoN9CorANBy+PjFsnnP6b4d/hPFlkDTn4g7f70Mf5g9AUB6seT/md85W+trfd0WT8efakVADMomiYN+Tz7/VuP+esF8EACkFsM/9s+baHhkvD0o9zfkVHysznxqz5tO+UNFnAEgrdg/juXypnuq9cQc4i2BfhUR0/nvAVRDAJBSPPlnGP4dMTzj2wP9dsmNg35QH1sApNPkZf+bib3zfjrkGEPfQT+ojwAglXhPPuPwD3EmIF5zHJ7i64S9onPQ76EvnXHQD2okAEgjlpOffD7n8O+I/w0eP3Cu9CoH/aB7BABpPPRFT5QhXg3sxdcD46Bf/DVyox90h0OApBD7/gbLT8UqwHc3fKAnbguMJf+4x99eP3SXAKDxYtm7m/v+A8tuK4N3LSyDdy5uf7p3/dqFkw7aoVeutP+zDb16ufXzsa6uTsQ5gP0vXii7Nt9e5lMvfm0RshAANF4sK3fDpg2L2wM1Bv90nqw3bVhy3b+OYRiHFON79t0Q++yP3r9yXlYBfLoX5p8AoNFiX7nup8stg0vLb21dVda1nvTnIoIgfsSnfWPFou4QmK9VgH7/6BI0hUOANFYMmme+Wd8TZiz1P/fYmvLsr98x5+E/UWwZ7Nuxunznc+8v69ZU98edTDyBd/O1wPanexvy0SXodwKAxjp4bLS2p//Y239h59r3LONX+udohcB3f+P9rSf0laUuMfwPdOFGxM5Bv7iR0JsY0BsEAI0UT/+xn16HGP7x5F/lU//NxJbA7k+vKnWp+5XAONsQ7/YfHmrWlwmh3zkDQCMd/cGlWp7+uz38Ox755Ir2Yb0nDgyXqsWAjpWAOg4Dxo1+DvpBb7ICQCPFe/91+PLDd3R9+Hdsu3d5bdsBh4aqPXAYKzCb97rRD3qZAKBx4mk2BmXVB+jijzl41/wumsV2QB3nDuJOgqo46Af9QQDQOLGUHU/LcYAuluu3bVxW5ire8d85z5fmdNSxClDFLXwO+kF/EQA0Wjwtd16pixCY7arA09tXl17RuS+gSifneF4ifn8H/aC/CABS6LxbH6sC+7YPtJ/op6u9nTBP+/5TqXoVILZN5nJocvWy+flHSRWrO5CVACCd2B547rG1764K3Eyc+t+2cXnpNdeuG672b9+zc7gQKLZdnt4xULql8zZGr2zLQD8SAKQ18ca9WBWYbHtg273Leu7pP8TAHbyz2gOJb43Mbd8+tiUevX9FqVtE25Gd76v1EibIQACQXoTAxEODW+5Z+u5v68Wn/46qA+BkBfcmxBN5XdcXx9XLu7euakdbL3zGGPqdi4Bggs4Bu5Onx9oH2nrx6b+jF4dgZyvgoS9V+wXGOLMRBzF7+a8H9BsrADCJWBV4pAvL2XNR9RmAqlS9FRB/rDizYfhDtQQA0La+wqX7KrYCOgf9ntpa33cQIDMBAH1qeKR3L9uZ61sBDvpB/QQA9KnhOby2N5lVFW8pzGYrwEE/6B4BAH2q6rv2767h9P5MtgLioN8LO9f2/NkLaAoBAH2qygCIp+06nrinuxXgoB90nwCAPhTDv8ozAFXfKTDRzbYCHPSD+SMAoA8dPDZSqhRXC9dpsq0AB/1gfgkA6EOHjlf71b0HJtx+WIeJWwEO+kFvcBMg9Jl4+j9VwbW9E9W9AhDiST8G/wODS+31Qw8QANBH4r7+PUculCrFtw+69STuhD/0DlsA0Eee/IO3Kn/6jydyIB8BAH0invzjA0VVilP48SVEIB8BAH0ghv/eI+dL1XZuXlmAnJwBgB42PDpePvOVs+XoiUulap7+ITcBAD3q8PGL5T8+X/2ef4enf8hNAECPiaf9WPKv46m/Iy7h8fQPuQkA6AGx1H/oz0fLwZdGax38IZb+d2+d/ad6gWYQADAPYln/5OmxMvTKlXJo6GL7l8Oj1d3tP5XO3ftu4AMEAMxB3MoXT+3TEQM/DI+Md2XYT+bLD9/hFj6gTQDAHMTNfHUv2Vdl346BMniXv+WBa9wDAAnE8N+20aE/4KcEADRYfHnP8AcmYz0QGioO/MWev2V/YDL+yQANtGnD4vLsw077A1MTANAgseS/a8tKn90FbkkAQEPs2hyDf6WnfmBaHAKEhoirfQ1/YLoEADTEx7/wRnniq8O1fTwIaBYBAA1y8KURIQBMiwCABooQeOiLZ9pXFQNMRgBAQ8U1xU8cGLYaAExKAEDDdVYDRAAwkQCABGI1IM4G7H/x7QIQBAAk8tTzb5U9Ry4UAAEAyew9cl4EAAIAMhIBgKuAYQ4evX9l2X7vzD61e/L02Lu/jL35oVevlKFXrnT9kF5EwPq1t/lUMCQlAGAO4urdgeULZ/T7rFtz7d+/acP1vz6C4OiJS+1T+0dPXC7d8OTzb5XBOxe3fvhHAWRjCwB6xPq1C9v3+T/32Nrync+9v/1xn04s1GV4ZLx89itn278EchEA0IMiBnZuvr28sPN97RCoU2xDPH7gXAFyEQDQw2KLIUIgVgQ2bVhS6nL4+MX2DyAPAQB9IFYEnntsTa2rAXEewFYA5CEAoI/EasCzD9/RWhmo/m/d2ArY/6JXAyELAQB9Zss9S9urAXVEwDMvvm0VAJIQANCH4rW9Zx9eXaoWw//ASz4hDBkIAOhTcShw96dXlao5DAg5CADoY498ckXlbwfEZUQ+HQzNJwCgz+3bPlCq9g2rANB4AgD6XPsGwY3LSpViFQBoNgEADbDt3mo/6CMAoPkEADRAnAOo8rXAeBvAOQBoNgEADVH1NsDQK935IiEwPwQANETVn/T92zNXC9BcAgAaIg4DVml4RABAkwkAaIh1a6oNAGcAoNkEAEwwPDruLnwgBQEA5dprb/E53I//pzfKoaHRAtB01Z4agj4ST/sHvzfSGvgXr3vvPX6+bWO179UD9BoBQDox4A8dv1gOHhttRcB7D7rFb9v96fEysHxB6Sf27IGZEACkEE/7R39wqex/8e1b3nIXZwCGXr1c+Ud26nbytAAApk8A0GgnW0/F8aT/zDffnvRpfyp7jlwozz3WXwFw9ES1F/dU/VYB0FsEAI0UT/kxxGd7p33nk7j9NAS/XfH9/VVeLQz0HgFAY8Qy//7Wk/5Mn/ansufwhbJvR/Wf2q1DJ1iqdPcaAQBNJgBohNi3/8jnXy9VOvjSSNm1ZWVfrALENkfV7lrrHw/QZBKfRogT+3Uc2nv8q8Ol17XPObRipWr33CkAoMkEAI2x5Z6lpWqxtH74+MXSy/a2tiqqtmnD4gI0mwCgMbbXdHnP4wfO9ew79vFaYx1P/4N3CgBoOgFAY9S1DRDnC3pxKyCW/ut4+g8P1LCaAvQWAUCj7Nq8stQhtgKe6KEIiOH/0BfPVPK2w43Wr1nYd5cgATMnAGiUGFx1vb8eS+1xt8B86wz/urYl7P9DDgKAxnnk/vo+5LP3yPl5XQmoe/iHbff6EBJkIABonEfvX1nrLXaxEvCJL7zR9YOBB18aLZv3nK71z2v5H/IQADROHAascxUgxJP4p/a+2T6FX7f2U/+XzrRWHs7Vsuc/0c6azlAAvUcA0EixClD3DX7xdsBTz7/VXg04eKz6V/HiauM4cxB//KMV3/M/mXj6t/wPeQgAGilWAZ7u0j3+8YT+xIHhd0NgLkv07c8Wt4Z9PPF/5Ddfb5856BZP/5CLuz5prNjLjh/deHoOnRAIg3cuav+572u/lbCgDN61uAwsW3Ddvz+G/fDI1TL0ypVy8vRYOTR0sf3zupf5JxMn/z39Qy4CgEbbt32gbN53uj1ou2no1SvtH8904YxAFZ7evroAudgCoNHWr11Ydn/69sLU4vKkdWt7/4uHQLUEAI0XS9uP3r+i8F6x9L9zs0CCjAQAKTy1dVV7X56filP/lv4hLwFAGl9++I7aXw3sFwPLbrv2v4elf0hLAJBGnAd47rE1IqBl96/eXgbvsiICmQkAUhEBpezbMVC2bfTKH2QnAEgncwQY/kCHACCliIAXdr6vbLlnackg9vyfbe35G/5AhwAgrbihL4biroZfgRun/V/YuTZN7ADTIwBIL96DjxsDm7glsGVwaTnSWulw2h+4kQCAcu2yoDgXsG3jstIEseS/e+uq8uyv39Fe6QC4kfeA4B1xLmDfjtXtj/jEZ3jn8lW/+RQRs3vrgMEP3JQAgBvEakD8iE/xHjg22jchENf67mptZ0TAANyKAIApxNmAf7lxefn9l0Z6OgQMfmA2BADcRGwLRAg8cv/Kcuj4aPvzvvGZ3/kWe/zb7l1WHrhnqcEPzIoAgGmI/fTO1kAEwMFjI+XoiUtdjYEY+pt+YXHZ3lqViKFvj/9aoL3yXz9YgJkTADBD8VXBOGEfTp4ea4fAoaGL5VTr51UGQQz8wbsWlvtaw37TOz8AqiIAYA7iCXT92msrA2F4ZLwVAZfL0CtXyskzY+0fwyNX27/+XOuXN1q9/Lb2k3z8cWLgx6U98fP4UI+PFgF1EgBQoRjmntaBfuAiIABISAAAQEICAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJCQAASEgAAEBCAgAAEhIAAJCQAACAhAQAACQkAAAgIQEAAAkJAABISAAAQEICAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAktKg00NtXXy5nr54qzI/vvL6yXP7h0gJU44M//H752HdvL8yPBZ/4mVL+QWmcRgbA2auHy6tj/6cwPw7+9Zryh2+uKEA1Hnz5TPmHz3+g0H0LfvEjZdG/+1xpIlsAADCJGP5Lfud/lAWrVpUmEgAAcIOmD/8gAABgggzDPwgAAHhHluEfBAAAlFzDPwgAANLLNvyDAAAgtYzDPwgAANLKOvyDAAAgpczDPwgAANLJPvyDAAAgFcP/GgEAQBqG/08JAABSMPyvJwAAaDzD/70EAACNZvhPTgAA0FiG/9QEAACNZPjfnAAAoHEM/1sTAAA0iuE/PQIAgMYw/KdPAADQCIb/zAgAAPqe4T9zAgCAvmb4z44AAKBvGf6zJwAA6EuG/9wIAAD6juE/dwIAgL5i+FdDAADQNwz/6ggAAPqC4V8tAQBAzzP8qycAAOhphn89BAAAPcvwr48AAKAnGf71EgAA9BzDv34CAICeYvh3hwAAoGcY/t0jAADoCYZ/dwkAAOad4d99AgCAeWX4zw8BAMC8MfznjwAAYF4Y/vNLAADQdYb//BMAAHSV4d8bBAAAXWP49w4BAEBXGP69RQAAUDvDv/cIAABqZfj3JgEAQG0M/94lAACoheHf2wQAAJUz/HufAACgUoZ/fxAAAFTG8O8fAgCAShj+/UUAADBnhn//EQAAzInh358EAACzZvj3LwEAwKwY/v1NAAAwY4Z//xMAAMyI4d8MAgCAaTP8m0MAADAthn+zCAAAbsnwbx4BAMBNGf7NJAAAmJLh31wCAIBJGf7N1sgAWL3M/7MCzIXh33yNDIB1d/xcAWB2DP8cGhkAdwsAgFkx/PNoZAAM/uyHCwAzY/jn0sgAWN9aARhwDgBg2gz/fBr7FsB9H/qlAsCtGf45NTYANv38LxcAbs7wz6uxAfDgL36yADA1wz+3xgZAnAOwDQAwOcOfRt8EuOXv/0oB4HqGP6HRAbDjY//M2wAAExj+dDQ6AAaW3V4e/fi2AoDhz/Ua/zGgf/WJHVYBgPQMf27U+ACwCgBkZ/gzmRSfA45VgPW+DwAkZPgzlRQBEKsAT2/9zQKQieHPzaQIgHDfh365tRWwvQBkYPhzK2kCIPzWA4+7HAhoPMOf6UgVAOHprZ93HgBoLMOf6UoXADH8v/Zrvy0CgMYx/JmJdAEQRADQNIY/M5UyAIIIAJrC8Gc20gZA6ETA4M9+uAD0I8Of2UodACEi4P/+698ru37lswWgnxj+zEX6AOj4D//4EVsCQN8w/JkrATBBXBb0vX//9fZqgBAAepXhTxUEwCQ6qwHbPvpPhQDQUwx/qrKoMKkY/P/tVz9fhkffKt/4i2+Wgy//7/Ltv/mTAjBfDH+qtGC8pTAtJ8/+uBUBf1wOtYLg2z/6k3Yc8F5rf25NWbF6RQGq8eDLZ8pvfP92w59KCYA5OP7aX5VTrSiIMDjXioH4OaU9/JeuWFqAavzSj86Xf/HgvzX8qZQAAICEHAIEgIQEAAAkJAAAICEBAAAJCQAASEgAAEBCAgAAEhIAAJCQAACAhAQAACQkAAAgIQEAAAkJAABISAAAQEICAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJCQAASEgAAEBCAgAAEhIAAJCQAACAhAQAACQkAAAgIQEAAAkJAABISAAAQEICAAASEgAAkJAAAICEBAAAJCQAACAhAQAACQkAAEhIAABAQgIAABISAACQkAAAgIQEAAAkJAAAICEBAAAJ/R0VlFJ6Z2QUFwAAAABJRU5ErkJggg=="

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/googlecalendar1.6721a2e.png";

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/googlecalendar2.b96f28d.png";

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/googlecalendar3.f6d1a39.png";

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ical-icon.83f4eb8.jpg";

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ical_1.4ae01c4.png";

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/outlook-icon.9fb38e9.png";

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/outlook1.7e31322.png";

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/outlook2.877ff05.png";

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1190 */,
/* 1191 */,
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1105)
	
	/* script */
	__vue_exports__ = __webpack_require__(384)
	
	/* template */
	var __vue_template__ = __webpack_require__(1730)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(827)
	
	/* script */
	__vue_exports__ = __webpack_require__(385)
	
	/* template */
	var __vue_template__ = __webpack_require__(1427)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0031812d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(898)
	
	/* script */
	__vue_exports__ = __webpack_require__(386)
	
	/* template */
	var __vue_template__ = __webpack_require__(1503)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2a15b7f0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1050)
	
	/* script */
	__vue_exports__ = __webpack_require__(388)
	
	/* template */
	var __vue_template__ = __webpack_require__(1670)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-790d2854"
	
	module.exports = __vue_exports__


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1110)
	
	/* script */
	__vue_exports__ = __webpack_require__(389)
	
	/* template */
	var __vue_template__ = __webpack_require__(1735)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-be090830"
	
	module.exports = __vue_exports__


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(840)
	
	/* script */
	__vue_exports__ = __webpack_require__(390)
	
	/* template */
	var __vue_template__ = __webpack_require__(1441)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-07078da5"
	
	module.exports = __vue_exports__


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(842)
	
	/* script */
	__vue_exports__ = __webpack_require__(391)
	
	/* template */
	var __vue_template__ = __webpack_require__(1443)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-07b4aa4a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1091)
	
	/* script */
	__vue_exports__ = __webpack_require__(394)
	
	/* template */
	var __vue_template__ = __webpack_require__(1713)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a45e855e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(926)
	
	/* script */
	__vue_exports__ = __webpack_require__(395)
	
	/* template */
	var __vue_template__ = __webpack_require__(1537)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3a5c1e24"
	
	module.exports = __vue_exports__


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(986)
	
	/* script */
	__vue_exports__ = __webpack_require__(396)
	
	/* template */
	var __vue_template__ = __webpack_require__(1600)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(911)
	
	/* script */
	__vue_exports__ = __webpack_require__(397)
	
	/* template */
	var __vue_template__ = __webpack_require__(1519)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-31c11c66"
	
	module.exports = __vue_exports__


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1150)
	
	/* script */
	__vue_exports__ = __webpack_require__(398)
	
	/* template */
	var __vue_template__ = __webpack_require__(1779)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f43488ea"
	
	module.exports = __vue_exports__


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1025)
	
	/* script */
	__vue_exports__ = __webpack_require__(399)
	
	/* template */
	var __vue_template__ = __webpack_require__(1643)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6f33ea8f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(981)
	
	/* script */
	__vue_exports__ = __webpack_require__(400)
	
	/* template */
	var __vue_template__ = __webpack_require__(1595)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5960870a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(861)
	
	/* script */
	__vue_exports__ = __webpack_require__(401)
	
	/* template */
	var __vue_template__ = __webpack_require__(1462)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-12ea7e91"
	
	module.exports = __vue_exports__


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(912)
	
	/* script */
	__vue_exports__ = __webpack_require__(403)
	
	/* template */
	var __vue_template__ = __webpack_require__(1520)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-31d3b1d4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(963)
	
	/* script */
	__vue_exports__ = __webpack_require__(406)
	
	/* template */
	var __vue_template__ = __webpack_require__(1576)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5061dab8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1153)
	
	/* script */
	__vue_exports__ = __webpack_require__(407)
	
	/* template */
	var __vue_template__ = __webpack_require__(1782)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f76bb71a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(899)
	
	/* script */
	__vue_exports__ = __webpack_require__(408)
	
	/* template */
	var __vue_template__ = __webpack_require__(1504)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2a55050e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(972)
	
	/* script */
	__vue_exports__ = __webpack_require__(409)
	
	/* template */
	var __vue_template__ = __webpack_require__(1586)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-55ed903a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1023)
	
	/* script */
	__vue_exports__ = __webpack_require__(410)
	
	/* template */
	var __vue_template__ = __webpack_require__(1641)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6dc8227f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1007)
	
	/* script */
	__vue_exports__ = __webpack_require__(411)
	
	/* template */
	var __vue_template__ = __webpack_require__(1622)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6730c6d4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(830)
	
	/* script */
	__vue_exports__ = __webpack_require__(413)
	
	/* template */
	var __vue_template__ = __webpack_require__(1430)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-02278584"
	
	module.exports = __vue_exports__


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(831)
	
	/* script */
	__vue_exports__ = __webpack_require__(414)
	
	/* template */
	var __vue_template__ = __webpack_require__(1432)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-02f6ec14"
	
	module.exports = __vue_exports__


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1128)
	
	/* script */
	__vue_exports__ = __webpack_require__(417)
	
	/* template */
	var __vue_template__ = __webpack_require__(1755)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d99ac434"
	
	module.exports = __vue_exports__


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1088)
	
	/* script */
	__vue_exports__ = __webpack_require__(418)
	
	/* template */
	var __vue_template__ = __webpack_require__(1710)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9f21d0ec"
	
	module.exports = __vue_exports__


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1089)
	
	/* script */
	__vue_exports__ = __webpack_require__(419)
	
	/* template */
	var __vue_template__ = __webpack_require__(1711)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a0b98898"
	
	module.exports = __vue_exports__


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(853)
	
	/* script */
	__vue_exports__ = __webpack_require__(421)
	
	/* template */
	var __vue_template__ = __webpack_require__(1454)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0f88a6a9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1002)
	
	/* script */
	__vue_exports__ = __webpack_require__(422)
	
	/* template */
	var __vue_template__ = __webpack_require__(1617)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(879)
	
	/* script */
	__vue_exports__ = __webpack_require__(424)
	
	/* template */
	var __vue_template__ = __webpack_require__(1481)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1e3bd68b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(834)
	
	/* script */
	__vue_exports__ = __webpack_require__(426)
	
	/* template */
	var __vue_template__ = __webpack_require__(1435)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(936)
	
	/* script */
	__vue_exports__ = __webpack_require__(428)
	
	/* template */
	var __vue_template__ = __webpack_require__(1548)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-42707fe6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1130)
	
	/* script */
	__vue_exports__ = __webpack_require__(429)
	
	/* template */
	var __vue_template__ = __webpack_require__(1757)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-db23bb08"
	
	module.exports = __vue_exports__


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1045)
	
	/* script */
	__vue_exports__ = __webpack_require__(430)
	
	/* template */
	var __vue_template__ = __webpack_require__(1665)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7814e750"
	
	module.exports = __vue_exports__


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1082)
	
	/* script */
	__vue_exports__ = __webpack_require__(431)
	
	/* template */
	var __vue_template__ = __webpack_require__(1704)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-98b610bc"
	
	module.exports = __vue_exports__


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(432)
	
	/* template */
	var __vue_template__ = __webpack_require__(1584)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1052)
	
	/* script */
	__vue_exports__ = __webpack_require__(433)
	
	/* template */
	var __vue_template__ = __webpack_require__(1672)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7a073072"
	
	module.exports = __vue_exports__


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1131)
	
	/* script */
	__vue_exports__ = __webpack_require__(434)
	
	/* template */
	var __vue_template__ = __webpack_require__(1758)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-dbf319dc"
	
	module.exports = __vue_exports__


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(435)
	
	/* template */
	var __vue_template__ = __webpack_require__(1760)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(436)
	
	/* template */
	var __vue_template__ = __webpack_require__(1543)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1047)
	
	/* script */
	__vue_exports__ = __webpack_require__(437)
	
	/* template */
	var __vue_template__ = __webpack_require__(1667)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-78da7ab5"
	
	module.exports = __vue_exports__


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(439)
	
	/* template */
	var __vue_template__ = __webpack_require__(1500)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(892)
	
	/* script */
	__vue_exports__ = __webpack_require__(440)
	
	/* template */
	var __vue_template__ = __webpack_require__(1495)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-275da70c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(935)
	
	/* script */
	__vue_exports__ = __webpack_require__(441)
	
	/* template */
	var __vue_template__ = __webpack_require__(1547)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-41df31b4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(948)
	
	/* template */
	var __vue_template__ = __webpack_require__(1560)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(913)
	
	/* script */
	__vue_exports__ = __webpack_require__(443)
	
	/* template */
	var __vue_template__ = __webpack_require__(1521)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3347a2de"
	
	module.exports = __vue_exports__


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1148)
	
	/* script */
	__vue_exports__ = __webpack_require__(444)
	
	/* template */
	var __vue_template__ = __webpack_require__(1777)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f2036002"
	
	module.exports = __vue_exports__


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(902)
	
	/* script */
	__vue_exports__ = __webpack_require__(445)
	
	/* template */
	var __vue_template__ = __webpack_require__(1507)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2c057be8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(901)
	
	/* script */
	__vue_exports__ = __webpack_require__(447)
	
	/* template */
	var __vue_template__ = __webpack_require__(1506)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2be6e1c6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(868)
	
	/* script */
	__vue_exports__ = __webpack_require__(448)
	
	/* template */
	var __vue_template__ = __webpack_require__(1469)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-15649ecc"
	
	module.exports = __vue_exports__


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1044)
	
	/* script */
	__vue_exports__ = __webpack_require__(449)
	
	/* template */
	var __vue_template__ = __webpack_require__(1664)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-77a9deef"
	
	module.exports = __vue_exports__


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(867)
	
	/* script */
	__vue_exports__ = __webpack_require__(450)
	
	/* template */
	var __vue_template__ = __webpack_require__(1468)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-153776aa"
	
	module.exports = __vue_exports__


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(941)
	
	/* script */
	__vue_exports__ = __webpack_require__(452)
	
	/* template */
	var __vue_template__ = __webpack_require__(1553)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(870)
	
	/* script */
	__vue_exports__ = __webpack_require__(453)
	
	/* template */
	var __vue_template__ = __webpack_require__(1471)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-197b3206"
	
	module.exports = __vue_exports__


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(858)
	
	/* script */
	__vue_exports__ = __webpack_require__(454)
	
	/* template */
	var __vue_template__ = __webpack_require__(1459)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1198c775"
	
	module.exports = __vue_exports__


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1029)
	
	/* script */
	__vue_exports__ = __webpack_require__(455)
	
	/* template */
	var __vue_template__ = __webpack_require__(1649)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-70fdd330"
	
	module.exports = __vue_exports__


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1016)
	
	/* script */
	__vue_exports__ = __webpack_require__(456)
	
	/* template */
	var __vue_template__ = __webpack_require__(1633)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6a2667ca"
	
	module.exports = __vue_exports__


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(845)
	
	/* script */
	__vue_exports__ = __webpack_require__(464)
	
	/* template */
	var __vue_template__ = __webpack_require__(1446)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-088a62da"
	
	module.exports = __vue_exports__


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1038)
	
	/* script */
	__vue_exports__ = __webpack_require__(469)
	
	/* template */
	var __vue_template__ = __webpack_require__(1658)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-74fb6dcf"
	
	module.exports = __vue_exports__


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1062)
	
	/* script */
	__vue_exports__ = __webpack_require__(470)
	
	/* template */
	var __vue_template__ = __webpack_require__(1682)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7f19439c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(472)
	
	/* template */
	var __vue_template__ = __webpack_require__(1742)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(851)
	
	/* script */
	__vue_exports__ = __webpack_require__(473)
	
	/* template */
	var __vue_template__ = __webpack_require__(1452)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0b87a766"
	
	module.exports = __vue_exports__


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1042)
	
	/* script */
	__vue_exports__ = __webpack_require__(474)
	
	/* template */
	var __vue_template__ = __webpack_require__(1662)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-777a068e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1147)
	
	/* script */
	__vue_exports__ = __webpack_require__(475)
	
	/* template */
	var __vue_template__ = __webpack_require__(1776)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f10bee34"
	
	module.exports = __vue_exports__


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(857)
	
	/* script */
	__vue_exports__ = __webpack_require__(477)
	
	/* template */
	var __vue_template__ = __webpack_require__(1458)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-117f370b"
	
	module.exports = __vue_exports__


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(993)
	
	/* script */
	__vue_exports__ = __webpack_require__(478)
	
	/* template */
	var __vue_template__ = __webpack_require__(1608)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-60a5ecdf"
	
	module.exports = __vue_exports__


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(862)
	
	/* script */
	__vue_exports__ = __webpack_require__(479)
	
	/* template */
	var __vue_template__ = __webpack_require__(1463)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-139df671"
	
	module.exports = __vue_exports__


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(481)
	
	/* template */
	var __vue_template__ = __webpack_require__(1431)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1134)
	
	/* script */
	__vue_exports__ = __webpack_require__(482)
	
	/* template */
	var __vue_template__ = __webpack_require__(1762)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e0a00a9c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(955)
	
	/* script */
	__vue_exports__ = __webpack_require__(483)
	
	/* template */
	var __vue_template__ = __webpack_require__(1568)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4b33942e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1069)
	
	/* script */
	__vue_exports__ = __webpack_require__(484)
	
	/* template */
	var __vue_template__ = __webpack_require__(1690)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8402db10"
	
	module.exports = __vue_exports__


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(486)
	
	/* template */
	var __vue_template__ = __webpack_require__(1646)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(487)
	
	/* template */
	var __vue_template__ = __webpack_require__(1626)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(489)
	
	/* template */
	var __vue_template__ = __webpack_require__(1566)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(966)
	
	/* script */
	__vue_exports__ = __webpack_require__(491)
	
	/* template */
	var __vue_template__ = __webpack_require__(1579)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5223cada"
	
	module.exports = __vue_exports__


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1036)
	
	/* script */
	__vue_exports__ = __webpack_require__(492)
	
	/* template */
	var __vue_template__ = __webpack_require__(1656)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7470078c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1015)
	
	/* script */
	__vue_exports__ = __webpack_require__(495)
	
	/* template */
	var __vue_template__ = __webpack_require__(1632)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-69ebd77e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1056)
	
	/* script */
	__vue_exports__ = __webpack_require__(496)
	
	/* template */
	var __vue_template__ = __webpack_require__(1676)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ad68305"
	
	module.exports = __vue_exports__


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(839)
	
	/* script */
	__vue_exports__ = __webpack_require__(497)
	
	/* template */
	var __vue_template__ = __webpack_require__(1440)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1138)
	
	/* script */
	__vue_exports__ = __webpack_require__(498)
	
	/* template */
	var __vue_template__ = __webpack_require__(1766)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e4ba18a2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(499)
	
	/* template */
	var __vue_template__ = __webpack_require__(1480)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(502)
	
	/* template */
	var __vue_template__ = __webpack_require__(1489)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1054)
	
	/* script */
	__vue_exports__ = __webpack_require__(505)
	
	/* template */
	var __vue_template__ = __webpack_require__(1674)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(944)
	
	/* script */
	__vue_exports__ = __webpack_require__(506)
	
	/* template */
	var __vue_template__ = __webpack_require__(1556)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-44e94f52"
	
	module.exports = __vue_exports__


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(881)
	
	/* script */
	__vue_exports__ = __webpack_require__(507)
	
	/* template */
	var __vue_template__ = __webpack_require__(1483)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2048d4bd"
	
	module.exports = __vue_exports__


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(914)
	
	/* script */
	__vue_exports__ = __webpack_require__(509)
	
	/* template */
	var __vue_template__ = __webpack_require__(1522)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-33d00cc7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(942)
	
	/* script */
	__vue_exports__ = __webpack_require__(511)
	
	/* template */
	var __vue_template__ = __webpack_require__(1554)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(947)
	
	/* script */
	__vue_exports__ = __webpack_require__(512)
	
	/* template */
	var __vue_template__ = __webpack_require__(1559)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4791d929"
	
	module.exports = __vue_exports__


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(917)
	
	/* script */
	__vue_exports__ = __webpack_require__(513)
	
	/* template */
	var __vue_template__ = __webpack_require__(1527)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-36534b01"
	
	module.exports = __vue_exports__


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1020)
	
	/* script */
	__vue_exports__ = __webpack_require__(515)
	
	/* template */
	var __vue_template__ = __webpack_require__(1637)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1022)
	
	/* script */
	__vue_exports__ = __webpack_require__(516)
	
	/* template */
	var __vue_template__ = __webpack_require__(1640)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6d69f84a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(915)
	
	/* script */
	__vue_exports__ = __webpack_require__(517)
	
	/* template */
	var __vue_template__ = __webpack_require__(1523)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(957)
	
	/* script */
	__vue_exports__ = __webpack_require__(518)
	
	/* template */
	var __vue_template__ = __webpack_require__(1570)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(843)
	
	/* script */
	__vue_exports__ = __webpack_require__(519)
	
	/* template */
	var __vue_template__ = __webpack_require__(1444)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(520)
	
	/* template */
	var __vue_template__ = __webpack_require__(1645)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(521)
	
	/* template */
	var __vue_template__ = __webpack_require__(1530)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1059)
	
	/* script */
	__vue_exports__ = __webpack_require__(522)
	
	/* template */
	var __vue_template__ = __webpack_require__(1679)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7d5532c8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1060)
	
	/* script */
	__vue_exports__ = __webpack_require__(523)
	
	/* template */
	var __vue_template__ = __webpack_require__(1680)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7e282bfb"
	
	module.exports = __vue_exports__


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(833)
	
	/* script */
	__vue_exports__ = __webpack_require__(524)
	
	/* template */
	var __vue_template__ = __webpack_require__(1434)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-03679bb0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(836)
	
	/* script */
	__vue_exports__ = __webpack_require__(525)
	
	/* template */
	var __vue_template__ = __webpack_require__(1437)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(967)
	
	/* script */
	__vue_exports__ = __webpack_require__(529)
	
	/* template */
	var __vue_template__ = __webpack_require__(1580)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5391cb55"
	
	module.exports = __vue_exports__


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(958)
	
	/* script */
	__vue_exports__ = __webpack_require__(530)
	
	/* template */
	var __vue_template__ = __webpack_require__(1571)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4e1ec158"
	
	module.exports = __vue_exports__


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(970)
	
	/* script */
	__vue_exports__ = __webpack_require__(531)
	
	/* template */
	var __vue_template__ = __webpack_require__(1583)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-548b08fd"
	
	module.exports = __vue_exports__


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1146)
	
	/* script */
	__vue_exports__ = __webpack_require__(532)
	
	/* template */
	var __vue_template__ = __webpack_require__(1775)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f10a4072"
	
	module.exports = __vue_exports__


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1083)
	
	/* script */
	__vue_exports__ = __webpack_require__(533)
	
	/* template */
	var __vue_template__ = __webpack_require__(1705)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-990cc956"
	
	module.exports = __vue_exports__


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(846)
	
	/* script */
	__vue_exports__ = __webpack_require__(535)
	
	/* template */
	var __vue_template__ = __webpack_require__(1447)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-098a0e7e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(874)
	
	/* script */
	__vue_exports__ = __webpack_require__(536)
	
	/* template */
	var __vue_template__ = __webpack_require__(1475)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ade1de9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1073)
	
	/* script */
	__vue_exports__ = __webpack_require__(537)
	
	/* template */
	var __vue_template__ = __webpack_require__(1694)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8911cb34"
	
	module.exports = __vue_exports__


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1048)
	
	/* script */
	__vue_exports__ = __webpack_require__(538)
	
	/* template */
	var __vue_template__ = __webpack_require__(1668)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-78ea03d4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(539)
	
	/* template */
	var __vue_template__ = __webpack_require__(1497)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(980)
	
	/* script */
	__vue_exports__ = __webpack_require__(540)
	
	/* template */
	var __vue_template__ = __webpack_require__(1594)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-58eff32a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(855)
	
	/* script */
	__vue_exports__ = __webpack_require__(541)
	
	/* template */
	var __vue_template__ = __webpack_require__(1456)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-100ca672"
	
	module.exports = __vue_exports__


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(933)
	
	/* script */
	__vue_exports__ = __webpack_require__(542)
	
	/* template */
	var __vue_template__ = __webpack_require__(1545)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f8b2a84"
	
	module.exports = __vue_exports__


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1122)
	
	/* script */
	__vue_exports__ = __webpack_require__(543)
	
	/* template */
	var __vue_template__ = __webpack_require__(1749)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d20fdc52"
	
	module.exports = __vue_exports__


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1013)
	
	/* script */
	__vue_exports__ = __webpack_require__(544)
	
	/* template */
	var __vue_template__ = __webpack_require__(1630)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6963107e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(946)
	
	/* script */
	__vue_exports__ = __webpack_require__(546)
	
	/* template */
	var __vue_template__ = __webpack_require__(1558)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-46ceca22"
	
	module.exports = __vue_exports__


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(921)
	
	/* script */
	__vue_exports__ = __webpack_require__(547)
	
	/* template */
	var __vue_template__ = __webpack_require__(1532)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-378d8e2c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1155)
	
	/* script */
	__vue_exports__ = __webpack_require__(550)
	
	/* template */
	var __vue_template__ = __webpack_require__(1784)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-fecede3e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1109)
	
	/* script */
	__vue_exports__ = __webpack_require__(553)
	
	/* template */
	var __vue_template__ = __webpack_require__(1734)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bc5396c8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1102)
	
	/* script */
	__vue_exports__ = __webpack_require__(554)
	
	/* template */
	var __vue_template__ = __webpack_require__(1727)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b64843ac"
	
	module.exports = __vue_exports__


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(876)
	
	/* script */
	__vue_exports__ = __webpack_require__(556)
	
	/* template */
	var __vue_template__ = __webpack_require__(1477)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ca9fa21"
	
	module.exports = __vue_exports__


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1000)
	
	/* script */
	__vue_exports__ = __webpack_require__(557)
	
	/* template */
	var __vue_template__ = __webpack_require__(1615)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-645d57ba"
	
	module.exports = __vue_exports__


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1003)
	
	/* script */
	__vue_exports__ = __webpack_require__(558)
	
	/* template */
	var __vue_template__ = __webpack_require__(1618)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-65d22297"
	
	module.exports = __vue_exports__


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(928)
	
	/* script */
	__vue_exports__ = __webpack_require__(559)
	
	/* template */
	var __vue_template__ = __webpack_require__(1539)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3bbe5ff6"
	
	module.exports = __vue_exports__


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(907)
	
	/* script */
	__vue_exports__ = __webpack_require__(561)
	
	/* template */
	var __vue_template__ = __webpack_require__(1514)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2e5c7d82"
	
	module.exports = __vue_exports__


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1114)
	
	/* script */
	__vue_exports__ = __webpack_require__(562)
	
	/* template */
	var __vue_template__ = __webpack_require__(1739)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c0615e10"
	
	module.exports = __vue_exports__


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1113)
	
	/* script */
	__vue_exports__ = __webpack_require__(563)
	
	/* template */
	var __vue_template__ = __webpack_require__(1738)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c0452f0e"
	
	module.exports = __vue_exports__


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1112)
	
	/* script */
	__vue_exports__ = __webpack_require__(564)
	
	/* template */
	var __vue_template__ = __webpack_require__(1737)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c029000c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1111)
	
	/* script */
	__vue_exports__ = __webpack_require__(565)
	
	/* template */
	var __vue_template__ = __webpack_require__(1736)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c00cd10a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(934)
	
	/* script */
	__vue_exports__ = __webpack_require__(568)
	
	/* template */
	var __vue_template__ = __webpack_require__(1546)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3fe44b62"
	
	module.exports = __vue_exports__


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1087)
	
	/* script */
	__vue_exports__ = __webpack_require__(570)
	
	/* template */
	var __vue_template__ = __webpack_require__(1709)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9df5b962"
	
	module.exports = __vue_exports__


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(880)
	
	/* script */
	__vue_exports__ = __webpack_require__(573)
	
	/* template */
	var __vue_template__ = __webpack_require__(1482)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1fa0e8f0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1072)
	
	/* script */
	__vue_exports__ = __webpack_require__(574)
	
	/* template */
	var __vue_template__ = __webpack_require__(1693)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-873e152a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1140)
	
	/* script */
	__vue_exports__ = __webpack_require__(576)
	
	/* template */
	var __vue_template__ = __webpack_require__(1768)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e7e207f0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1145)
	
	/* script */
	__vue_exports__ = __webpack_require__(577)
	
	/* template */
	var __vue_template__ = __webpack_require__(1774)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f0c4a276"
	
	module.exports = __vue_exports__


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1118)
	
	/* script */
	__vue_exports__ = __webpack_require__(578)
	
	/* template */
	var __vue_template__ = __webpack_require__(1744)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c6982942"
	
	module.exports = __vue_exports__


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(953)
	
	/* script */
	__vue_exports__ = __webpack_require__(579)
	
	/* template */
	var __vue_template__ = __webpack_require__(1565)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4a497fec"
	
	module.exports = __vue_exports__


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1035)
	
	/* script */
	__vue_exports__ = __webpack_require__(580)
	
	/* template */
	var __vue_template__ = __webpack_require__(1655)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7452aed4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(582)
	
	/* template */
	var __vue_template__ = __webpack_require__(1526)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1115)
	
	/* script */
	__vue_exports__ = __webpack_require__(584)
	
	/* template */
	var __vue_template__ = __webpack_require__(1740)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c3632bf0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(856)
	
	/* script */
	__vue_exports__ = __webpack_require__(585)
	
	/* template */
	var __vue_template__ = __webpack_require__(1457)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-10601e56"
	
	module.exports = __vue_exports__


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1005)
	
	/* script */
	__vue_exports__ = __webpack_require__(594)
	
	/* template */
	var __vue_template__ = __webpack_require__(1620)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-66c82bcd"
	
	module.exports = __vue_exports__


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(904)
	
	/* script */
	__vue_exports__ = __webpack_require__(595)
	
	/* template */
	var __vue_template__ = __webpack_require__(1510)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2cde8ebf"
	
	module.exports = __vue_exports__


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(908)
	
	/* script */
	__vue_exports__ = __webpack_require__(598)
	
	/* template */
	var __vue_template__ = __webpack_require__(1515)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2f998cac"
	
	module.exports = __vue_exports__


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(875)
	
	/* script */
	__vue_exports__ = __webpack_require__(599)
	
	/* template */
	var __vue_template__ = __webpack_require__(1476)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1c8bdc89"
	
	module.exports = __vue_exports__


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(877)
	
	/* script */
	__vue_exports__ = __webpack_require__(600)
	
	/* template */
	var __vue_template__ = __webpack_require__(1478)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ce3ee74"
	
	module.exports = __vue_exports__


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1080)
	
	/* script */
	__vue_exports__ = __webpack_require__(601)
	
	/* template */
	var __vue_template__ = __webpack_require__(1702)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9319a330"
	
	module.exports = __vue_exports__


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(918)
	
	/* script */
	__vue_exports__ = __webpack_require__(602)
	
	/* template */
	var __vue_template__ = __webpack_require__(1528)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-366dccd5"
	
	module.exports = __vue_exports__


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(847)
	
	/* script */
	__vue_exports__ = __webpack_require__(605)
	
	/* template */
	var __vue_template__ = __webpack_require__(1448)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-09fb3b83"
	
	module.exports = __vue_exports__


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1104)
	
	/* script */
	__vue_exports__ = __webpack_require__(609)
	
	/* template */
	var __vue_template__ = __webpack_require__(1729)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b77cc42a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(897)
	
	/* script */
	__vue_exports__ = __webpack_require__(610)
	
	/* template */
	var __vue_template__ = __webpack_require__(1502)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2a147321"
	
	module.exports = __vue_exports__


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1085)
	
	/* script */
	__vue_exports__ = __webpack_require__(611)
	
	/* template */
	var __vue_template__ = __webpack_require__(1707)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9d81f044"
	
	module.exports = __vue_exports__


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1090)
	
	/* script */
	__vue_exports__ = __webpack_require__(612)
	
	/* template */
	var __vue_template__ = __webpack_require__(1712)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a0d273a2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1117)
	
	/* script */
	__vue_exports__ = __webpack_require__(613)
	
	/* template */
	var __vue_template__ = __webpack_require__(1743)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c696ecc4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(615)
	
	/* template */
	var __vue_template__ = __webpack_require__(1772)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1017)
	
	/* script */
	__vue_exports__ = __webpack_require__(616)
	
	/* template */
	var __vue_template__ = __webpack_require__(1634)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b1035a2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1031)
	
	/* script */
	__vue_exports__ = __webpack_require__(617)
	
	/* template */
	var __vue_template__ = __webpack_require__(1651)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-71f48356"
	
	module.exports = __vue_exports__


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1139)
	
	/* script */
	__vue_exports__ = __webpack_require__(619)
	
	/* template */
	var __vue_template__ = __webpack_require__(1767)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e59bcd5c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1014)
	
	/* script */
	__vue_exports__ = __webpack_require__(620)
	
	/* template */
	var __vue_template__ = __webpack_require__(1631)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(896)
	
	/* script */
	__vue_exports__ = __webpack_require__(621)
	
	/* template */
	var __vue_template__ = __webpack_require__(1501)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-29c2dc02"
	
	module.exports = __vue_exports__


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(922)
	
	/* script */
	__vue_exports__ = __webpack_require__(622)
	
	/* template */
	var __vue_template__ = __webpack_require__(1533)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-38380940"
	
	module.exports = __vue_exports__


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1058)
	
	/* script */
	__vue_exports__ = __webpack_require__(623)
	
	/* template */
	var __vue_template__ = __webpack_require__(1678)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7cb284f7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(894)
	
	/* script */
	__vue_exports__ = __webpack_require__(624)
	
	/* template */
	var __vue_template__ = __webpack_require__(1498)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-28f80768"
	
	module.exports = __vue_exports__


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(910)
	
	/* script */
	__vue_exports__ = __webpack_require__(625)
	
	/* template */
	var __vue_template__ = __webpack_require__(1518)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-31bbfc94"
	
	module.exports = __vue_exports__


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1141)
	
	/* script */
	__vue_exports__ = __webpack_require__(626)
	
	/* template */
	var __vue_template__ = __webpack_require__(1769)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ea006af8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(627)
	
	/* template */
	var __vue_template__ = __webpack_require__(1716)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(932)
	
	/* script */
	__vue_exports__ = __webpack_require__(628)
	
	/* template */
	var __vue_template__ = __webpack_require__(1544)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f559256"
	
	module.exports = __vue_exports__


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1084)
	
	/* script */
	__vue_exports__ = __webpack_require__(629)
	
	/* template */
	var __vue_template__ = __webpack_require__(1706)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(991)
	
	/* script */
	__vue_exports__ = __webpack_require__(630)
	
	/* template */
	var __vue_template__ = __webpack_require__(1606)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5f3c020a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(987)
	
	/* script */
	__vue_exports__ = __webpack_require__(631)
	
	/* template */
	var __vue_template__ = __webpack_require__(1602)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5d630828"
	
	module.exports = __vue_exports__


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(943)
	
	/* script */
	__vue_exports__ = __webpack_require__(632)
	
	/* template */
	var __vue_template__ = __webpack_require__(1555)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1026)
	
	/* script */
	__vue_exports__ = __webpack_require__(633)
	
	/* template */
	var __vue_template__ = __webpack_require__(1644)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6f7191d3"
	
	module.exports = __vue_exports__


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(882)
	
	/* script */
	__vue_exports__ = __webpack_require__(635)
	
	/* template */
	var __vue_template__ = __webpack_require__(1484)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2176c8f8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1021)
	
	/* script */
	__vue_exports__ = __webpack_require__(636)
	
	/* template */
	var __vue_template__ = __webpack_require__(1638)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6ca3bcd3"
	
	module.exports = __vue_exports__


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1057)
	
	/* script */
	__vue_exports__ = __webpack_require__(637)
	
	/* template */
	var __vue_template__ = __webpack_require__(1677)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7c5facf7"
	
	module.exports = __vue_exports__


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(984)
	
	/* script */
	__vue_exports__ = __webpack_require__(638)
	
	/* template */
	var __vue_template__ = __webpack_require__(1598)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5b586c20"
	
	module.exports = __vue_exports__


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(997)
	
	/* script */
	__vue_exports__ = __webpack_require__(639)
	
	/* template */
	var __vue_template__ = __webpack_require__(1612)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-638e61a8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(930)
	
	/* script */
	__vue_exports__ = __webpack_require__(642)
	
	/* template */
	var __vue_template__ = __webpack_require__(1541)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f17a134"
	
	module.exports = __vue_exports__


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1123)
	
	/* script */
	__vue_exports__ = __webpack_require__(644)
	
	/* template */
	var __vue_template__ = __webpack_require__(1750)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(985)
	
	/* script */
	__vue_exports__ = __webpack_require__(645)
	
	/* template */
	var __vue_template__ = __webpack_require__(1599)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5b9f97b0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1079)
	
	/* script */
	__vue_exports__ = __webpack_require__(646)
	
	/* template */
	var __vue_template__ = __webpack_require__(1701)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-90a5b738"
	
	module.exports = __vue_exports__


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1068)
	
	/* script */
	__vue_exports__ = __webpack_require__(647)
	
	/* template */
	var __vue_template__ = __webpack_require__(1689)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-81db8b00"
	
	module.exports = __vue_exports__


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(951)
	
	/* script */
	__vue_exports__ = __webpack_require__(648)
	
	/* template */
	var __vue_template__ = __webpack_require__(1563)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4919a4ba"
	
	module.exports = __vue_exports__


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(920)
	
	/* script */
	__vue_exports__ = __webpack_require__(649)
	
	/* template */
	var __vue_template__ = __webpack_require__(1531)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-377012df"
	
	module.exports = __vue_exports__


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1098)
	
	/* script */
	__vue_exports__ = __webpack_require__(650)
	
	/* template */
	var __vue_template__ = __webpack_require__(1723)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-aff3b038"
	
	module.exports = __vue_exports__


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1081)
	
	/* script */
	__vue_exports__ = __webpack_require__(651)
	
	/* template */
	var __vue_template__ = __webpack_require__(1703)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-95ca2a2a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1125)
	
	/* script */
	__vue_exports__ = __webpack_require__(652)
	
	/* template */
	var __vue_template__ = __webpack_require__(1752)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d46d202a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(962)
	
	/* script */
	__vue_exports__ = __webpack_require__(654)
	
	/* template */
	var __vue_template__ = __webpack_require__(1575)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5047da95"
	
	module.exports = __vue_exports__


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(989)
	
	/* script */
	__vue_exports__ = __webpack_require__(655)
	
	/* template */
	var __vue_template__ = __webpack_require__(1604)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(657)
	
	/* template */
	var __vue_template__ = __webpack_require__(1699)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(965)
	
	/* script */
	__vue_exports__ = __webpack_require__(658)
	
	/* template */
	var __vue_template__ = __webpack_require__(1578)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-51914942"
	
	module.exports = __vue_exports__


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1095)
	
	/* script */
	__vue_exports__ = __webpack_require__(660)
	
	/* template */
	var __vue_template__ = __webpack_require__(1720)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ad750fde"
	
	module.exports = __vue_exports__


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(999)
	
	/* script */
	__vue_exports__ = __webpack_require__(661)
	
	/* template */
	var __vue_template__ = __webpack_require__(1614)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-64023200"
	
	module.exports = __vue_exports__


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1037)
	
	/* script */
	__vue_exports__ = __webpack_require__(664)
	
	/* template */
	var __vue_template__ = __webpack_require__(1657)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-74a3044f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(949)
	
	/* script */
	__vue_exports__ = __webpack_require__(665)
	
	/* template */
	var __vue_template__ = __webpack_require__(1561)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-480c8896"
	
	module.exports = __vue_exports__


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1100)
	
	/* script */
	__vue_exports__ = __webpack_require__(667)
	
	/* template */
	var __vue_template__ = __webpack_require__(1725)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b1d9e9c8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(990)
	
	/* script */
	__vue_exports__ = __webpack_require__(669)
	
	/* template */
	var __vue_template__ = __webpack_require__(1605)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5f022bbd"
	
	module.exports = __vue_exports__


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1070)
	
	/* script */
	__vue_exports__ = __webpack_require__(672)
	
	/* template */
	var __vue_template__ = __webpack_require__(1691)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1018)
	
	/* script */
	__vue_exports__ = __webpack_require__(676)
	
	/* template */
	var __vue_template__ = __webpack_require__(1635)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b10cf5a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(983)
	
	/* script */
	__vue_exports__ = __webpack_require__(678)
	
	/* template */
	var __vue_template__ = __webpack_require__(1597)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5aebe81c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1132)
	
	/* template */
	var __vue_template__ = __webpack_require__(1759)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1086)
	
	/* script */
	__vue_exports__ = __webpack_require__(687)
	
	/* template */
	var __vue_template__ = __webpack_require__(1708)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9de6840a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1064)
	
	/* script */
	__vue_exports__ = __webpack_require__(688)
	
	/* template */
	var __vue_template__ = __webpack_require__(1684)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7f660a7f"
	
	module.exports = __vue_exports__


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(860)
	
	/* template */
	var __vue_template__ = __webpack_require__(1461)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-12e33273"
	
	module.exports = __vue_exports__


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1004)
	
	/* script */
	__vue_exports__ = __webpack_require__(693)
	
	/* template */
	var __vue_template__ = __webpack_require__(1619)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-667a63b1"
	
	module.exports = __vue_exports__


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(886)
	
	/* script */
	__vue_exports__ = __webpack_require__(695)
	
	/* template */
	var __vue_template__ = __webpack_require__(1488)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-227e34f8"
	
	module.exports = __vue_exports__


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1127)
	
	/* script */
	__vue_exports__ = __webpack_require__(697)
	
	/* template */
	var __vue_template__ = __webpack_require__(1754)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d994f34a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1067)
	
	/* script */
	__vue_exports__ = __webpack_require__(699)
	
	/* template */
	var __vue_template__ = __webpack_require__(1688)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-808ab164"
	
	module.exports = __vue_exports__


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(975)
	
	/* script */
	__vue_exports__ = __webpack_require__(703)
	
	/* template */
	var __vue_template__ = __webpack_require__(1589)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-572d5dac"
	
	module.exports = __vue_exports__


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(994)
	
	/* script */
	__vue_exports__ = __webpack_require__(704)
	
	/* template */
	var __vue_template__ = __webpack_require__(1609)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-60f51688"
	
	module.exports = __vue_exports__


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(707)
	
	/* template */
	var __vue_template__ = __webpack_require__(1685)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(841)
	
	/* script */
	__vue_exports__ = __webpack_require__(709)
	
	/* template */
	var __vue_template__ = __webpack_require__(1442)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-07adafc2"
	
	module.exports = __vue_exports__


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(916)
	
	/* script */
	__vue_exports__ = __webpack_require__(710)
	
	/* template */
	var __vue_template__ = __webpack_require__(1525)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-354eb704"
	
	module.exports = __vue_exports__


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(1512)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(959)
	
	/* script */
	__vue_exports__ = __webpack_require__(711)
	
	/* template */
	var __vue_template__ = __webpack_require__(1572)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4e6d4768"
	
	module.exports = __vue_exports__


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(927)
	
	/* script */
	__vue_exports__ = __webpack_require__(712)
	
	/* template */
	var __vue_template__ = __webpack_require__(1538)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3b657902"
	
	module.exports = __vue_exports__


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(903)
	
	/* script */
	__vue_exports__ = __webpack_require__(713)
	
	/* template */
	var __vue_template__ = __webpack_require__(1509)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2c2af81c"
	
	module.exports = __vue_exports__


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(929)
	
	/* script */
	__vue_exports__ = __webpack_require__(714)
	
	/* template */
	var __vue_template__ = __webpack_require__(1540)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3f169b42"
	
	module.exports = __vue_exports__


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(885)
	
	/* script */
	__vue_exports__ = __webpack_require__(715)
	
	/* template */
	var __vue_template__ = __webpack_require__(1487)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2279ff9a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(937)
	
	/* script */
	__vue_exports__ = __webpack_require__(716)
	
	/* template */
	var __vue_template__ = __webpack_require__(1549)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-42c7094d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1032)
	
	/* script */
	__vue_exports__ = __webpack_require__(717)
	
	/* template */
	var __vue_template__ = __webpack_require__(1652)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1033)
	
	/* script */
	__vue_exports__ = __webpack_require__(718)
	
	/* template */
	var __vue_template__ = __webpack_require__(1653)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-737baac9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(866)
	
	/* script */
	__vue_exports__ = __webpack_require__(719)
	
	/* template */
	var __vue_template__ = __webpack_require__(1467)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-141e3622"
	
	module.exports = __vue_exports__


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1077)
	
	/* script */
	__vue_exports__ = __webpack_require__(720)
	
	/* template */
	var __vue_template__ = __webpack_require__(1698)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8d8163be"
	
	module.exports = __vue_exports__


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1107)
	
	/* script */
	__vue_exports__ = __webpack_require__(721)
	
	/* template */
	var __vue_template__ = __webpack_require__(1732)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bbeecbae"
	
	module.exports = __vue_exports__


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(952)
	
	/* script */
	__vue_exports__ = __webpack_require__(722)
	
	/* template */
	var __vue_template__ = __webpack_require__(1564)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-49ad9ab0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1051)
	
	/* script */
	__vue_exports__ = __webpack_require__(723)
	
	/* template */
	var __vue_template__ = __webpack_require__(1671)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7967a35a"
	
	module.exports = __vue_exports__


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(971)
	
	/* script */
	__vue_exports__ = __webpack_require__(724)
	
	/* template */
	var __vue_template__ = __webpack_require__(1585)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-553cbdab"
	
	module.exports = __vue_exports__


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(849)
	
	/* script */
	__vue_exports__ = __webpack_require__(725)
	
	/* template */
	var __vue_template__ = __webpack_require__(1450)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0a698985"
	
	module.exports = __vue_exports__


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(977)
	
	/* script */
	__vue_exports__ = __webpack_require__(726)
	
	/* template */
	var __vue_template__ = __webpack_require__(1591)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57b1d2c4"
	
	module.exports = __vue_exports__


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(832)
	
	/* script */
	__vue_exports__ = __webpack_require__(727)
	
	/* template */
	var __vue_template__ = __webpack_require__(1433)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-03156f74"
	
	module.exports = __vue_exports__


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1024)
	
	/* script */
	__vue_exports__ = __webpack_require__(728)
	
	/* template */
	var __vue_template__ = __webpack_require__(1642)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6e49ff2d"
	
	module.exports = __vue_exports__


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(976)
	
	/* script */
	__vue_exports__ = __webpack_require__(730)
	
	/* template */
	var __vue_template__ = __webpack_require__(1590)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5738d0d9"
	
	module.exports = __vue_exports__


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1027)
	
	/* script */
	__vue_exports__ = __webpack_require__(733)
	
	/* template */
	var __vue_template__ = __webpack_require__(1647)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-708361c0"
	
	module.exports = __vue_exports__


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(973)
	
	/* script */
	__vue_exports__ = __webpack_require__(736)
	
	/* template */
	var __vue_template__ = __webpack_require__(1587)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5633e290"
	
	module.exports = __vue_exports__


/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticStyle: {
	      "background-color": "lightgray",
	      "padding": "10px",
	      "width": "200px",
	      "position": "fixed",
	      "height": "100vh"
	    }
	  }, [_vm._l((_vm.components), function(component, index) {
	    return _c('div', [_c('button', {
	      on: {
	        "click": function($event) {
	          return _vm.select(index)
	        }
	      }
	    }, [_vm._v(_vm._s(component.name))])])
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "descripton"
	  }, [_vm._v(_vm._s(_vm.currentComponent.description))])], 2), _vm._v(" "), _c('div', {
	    staticClass: "component_container"
	  }, [_c(_vm.currentComponent, {
	    tag: "component"
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showModal) ? _c('modal', {
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('template', {
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "add-lesson__header",
	    style: ({
	      'backgroundColor': _vm.color ? _vm.color : '#fff'
	    })
	  }, [_c('h2', [_vm._v(_vm._s(_vm.name.length > 0 ? _vm.name : _vm.i18n[_vm.locale]['create_subject']))]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__calendars"
	  }, [_vm._v("\n        " + _vm._s(_vm.showMasterCalendarName) + "\n      ")]), _vm._v(" "), (_vm.editSubject && !_vm.showDbErrorText) ? _c('div', {
	    staticClass: "add-lesson__header__tabs"
	  }, [_c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.theActiveTab === 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 0
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].edit_subject) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.theActiveTab === 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 1
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].activity) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.theActiveTab === 2
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 2
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].deleted_lessons) + "\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.isLoadingSchoolCalenders || _vm.isLoadingTheEditSubject) ? _c('div', {
	    staticClass: "add-lesson__form add-lesson__loading-container"
	  }, [_c('Loader', {
	    attrs: {
	      "bgColor": "#f6f9fc"
	    }
	  })], 1) : _c('div', {
	    staticClass: "add-lesson__form"
	  }, [(_vm.showDbErrorText) ? _c('div', {
	    staticClass: "db-error-div"
	  }, [_c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].can_not_find_subject))])]) : [(_vm.theActiveTab === 2) ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('SubjectFormLogDeletedEvents', {
	    attrs: {
	      "subject": _vm.editSubject
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 1) ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].latest_activity))]), _vm._v(" "), _c('SubjectFormLog', {
	    attrs: {
	      "subject": _vm.editSubject
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 0) ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('div', {
	    class: {
	      'input-group__flex': _vm.isSchoolFromNorway
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_title']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    ref: "name",
	    class: {
	      'input--error': _vm.formErrors['name']
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['ex_subject']
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('name')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isArbeidstidsplanActivated) ? _c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "max-width": "100px"
	    }
	  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.preparation),
	      expression: "preparation",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "d-input__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return _vm._n(val)
	        });
	        _vm.preparation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.preparationOptionsForNorway), function(prep) {
	    return _c('option', {
	      key: prep
	    }, [_vm._v("\n                  " + _vm._s(prep) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isSchoolFromNorway) ? _c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "max-width": "100px"
	    }
	  }, [_c('label', [_vm._v("Fagkode")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.subjectCode),
	      expression: "subjectCode",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.subjectCode)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subjectCode = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), (_vm.calendarType !== 'user') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_teacher']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "user",
	      "showTags": true,
	      "preSelectedItems": _vm.userCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_room']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "room",
	      "preSelectedItems": _vm.roomCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedRooms
	    }
	  })], 1), _vm._v(" "), (!_vm.isPossibleToAddKlasses && _vm.isAllowedToAddKlasses) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setIsPossibleToAddKlasses
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_klass']) + "?")]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isPossibleToAddKlasses) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_klass']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "klass",
	      "calendarId": _vm.calendarId,
	      "showTags": true,
	      "preSelectedItems": _vm.klassCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedKlass
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (!_vm.isPossibleToAddClub && _vm.isAllowedToAddClub) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setIsPossibleToAddClub
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_club']) + "?\n          ")]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isPossibleToAddClub) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_club']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "club",
	      "calendarId": _vm.calendarId,
	      "showTags": true,
	      "preSelectedItems": _vm.clubCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedClub
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_in_school_year']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    class: {
	      'input--error': _vm.formErrors['hours']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['standard_duration']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.defaultDuration),
	      expression: "defaultDuration"
	    }],
	    class: {
	      'input--error': _vm.formErrors['defaultDuration']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.defaultDuration)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.defaultDuration = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['defaultDuration']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['defaultDuration'][_vm.locale]))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('ColorPicker', {
	    attrs: {
	      "initialColor": _vm.color
	    },
	    on: {
	      "changedColor": _vm.setSubjectColor
	    }
	  })], 1), _vm._v(" "), (_vm.calendarType === 'klass' && _vm.klassStudents.length > 0) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('StudentsOnSubject', {
	    attrs: {
	      "calendarId": _vm.calendarId,
	      "isNotEditSubject": _vm.isEditSubject,
	      "studentCalendarIds": _vm.studentCalendarIds
	    },
	    on: {
	      "changed": _vm.setStudentCalendarIds
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isShowSchool) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', [(!_vm.theSchoolForTheSubject) ? _c('h3', [_vm._v(_vm._s(_vm.activeSchool.name))]) : _c('h3', [_vm._v(_vm._s(_vm.theSchoolForTheSubject.name) + "\n                "), (_vm.theActiveSchoolYearForTheSubject) ? _c('span', {
	    staticClass: "small-text"
	  }, [_vm._v(", " + _vm._s(_vm.theActiveSchoolYearForTheSubject.name))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.isShowSchoolYearSelector) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_school_year']))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    staticStyle: {
	      "width": "50%"
	    },
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_subject_type']))]), _vm._v(" "), _c('SubjectTypePicker', {
	    attrs: {
	      "calendarType": _vm.calendarType,
	      "subjectType": _vm.subjectType
	    },
	    on: {
	      "change": _vm.selectSubjectType
	    }
	  })], 1), _vm._v(" "), (_vm.editSubject) ? _c('div', {
	    staticClass: "edit-subject"
	  }, [_c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }, [(_vm.editSubjectCanBeDeleted) ? _c('button', {
	    staticClass: "hint--right bttn--warning",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['delete_subject']
	    },
	    on: {
	      "click": _vm.deleteEditSubject
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['cannot_delete']
	    }
	  }, [_c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (_vm.editSubject) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.updateSubject
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_subject']) + "\n                ")]) : _vm._e()])])]) : _c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.createSubject
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_subject']))])])])], 1) : _vm._e()], _vm._v(" "), (_vm.subjectsWithSameName.length > 0) ? _c('SubjectFormDeleteSubjects', {
	    attrs: {
	      "subjectsWithSameName": _vm.subjectsWithSameName
	    },
	    on: {
	      "close": _vm.closeModalSubjectsWithSameName,
	      "keep": _vm.keepExistingSubjects,
	      "delete": _vm.deleteExistingSubjects
	    }
	  }) : _vm._e()], 2)])], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "small"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#ffffff"
	    }
	  }) : _c('line-chart', {
	    attrs: {
	      "chart-data": _vm.datacollection,
	      "options": _vm.options
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "is-bg-overlay": true
	    }
	  }, [_c('div', {
	    staticClass: "modal-merges",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [(_vm.isMergeCalendar) ? _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_calendar')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_merge_calendars')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [(_vm.isLoadingMerges) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc",
	      "isSmall": true
	    }
	  }) : [(_vm.isMergeCalendar) ? _c('div', [(_vm.calendarsMerged.length > 0) ? _c('label', {
	    staticClass: "d-label d-label__divider d-label__divider--top"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.is_merged')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.calendarsMerged), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "modal-merges__item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.unMergeCalendarFromMergeCalendar(calendar)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(calendar.name) + "\n                "), _c('span', {
	      staticClass: "do-pill marg-05-rem"
	    }, [_vm._v(_vm._s(calendar.year))])]), _vm._v(" "), (_vm.theLoaderId === calendar.id) ? _c('div', {
	      staticClass: "do-spinner do-spinner--custom-marg"
	    }) : _c('div', {
	      staticClass: "do-switch do-switch--active"
	    })])
	  }), 0), _vm._v(" "), _c('label', {
	    staticClass: "d-label d-label__divider"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.can_be_merged_into')))]), _vm._v(" "), _c('ul', _vm._l((_vm.possibleToMerge), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "modal-merges__item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.mergeCalendarFromMergeCalendar(calendar)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(calendar.name) + "\n                "), _c('span', {
	      staticClass: "do-pill marg-05-rem"
	    }, [_vm._v(_vm._s(calendar.year))])]), _vm._v(" "), (_vm.theLoaderId === calendar.id) ? _c('div', {
	      staticClass: "do-spinner do-spinner--custom-marg"
	    }) : _c('div', {
	      staticClass: "do-switch"
	    })])
	  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.isMergeCalendar) ? _c('ul', _vm._l((_vm.allMergeCalendars), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "modal-merges__item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleMergeCalendar(calendar)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(calendar.name)), (calendar.archived) ? _c('span', {
	      staticClass: "do-pill do-pill--yellow marg-05-rem"
	    }, [_vm._v("Archived")]) : _vm._e()]), _vm._v(" "), (_vm.theLoaderId === calendar.id) ? _c('div', {
	      staticClass: "do-spinner do-spinner--custom-marg"
	    }) : _c('div', {
	      staticClass: "do-switch",
	      class: {
	        'do-switch--active': calendar.vIsMerged
	      }
	    })])
	  }), 0) : _vm._e()]], 2), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.done')))])])])])
	},staticRenderFns: []}

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-kindergarten__color-picker"
	  }, [_vm._v("\n  " + _vm._s(_vm.hours) + "\n")])
	},staticRenderFns: []}

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user text-dark"
	  }, [(!_vm.user && !_vm.calendar) ? _c('Loader', {
	    staticStyle: {
	      "margin-top": "200px"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSubHeader) ? _c('div', {
	    staticClass: "sub-header"
	  }, [_c('p', {
	    staticClass: "sub-header__title"
	  }, [_vm._v("\n      " + _vm._s(_vm.theSelectedUser.name) + "\n      "), _c('span', {
	    staticClass: "sub-header__title-divider icon-arrow-right4"
	  })]), _vm._v(" "), _c('a', {
	    class: {
	      'active': _vm.theView === 'calendar'
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setTheView('calendar')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.calendar')))]), _vm._v(" "), _c('a', {
	    class: {
	      'active': _vm.theView === 'tasks'
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setTheView('tasks')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.task_overview')))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInUp"
	    }
	  }, [(_vm.user && _vm.calendar && _vm.theView === 'tasks') ? _c('UserTasks', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "isCanSeeOtherUsers": false,
	      "user_id": _vm.theSelectedUser.userId,
	      "user_calendar_id": _vm.theSelectedUser.calendarId,
	      "user_name": _vm.theSelectedUser.name
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInUp"
	    }
	  }, [(_vm.user && _vm.calendar && _vm.theView === 'calendar') ? _c('div', [_c('week-selector', {
	    attrs: {
	      "startDate": _vm.weekSelectorStartDate,
	      "endDate": _vm.weekSelectorEndDate,
	      "date": _vm.activeCalendarDate
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "printCalendar"
	    }
	  }, [_c('div', {
	    staticClass: "user-calendar"
	  }, [_c('div', {
	    staticClass: "user-calendar__header"
	  }, [_c('div', {
	    staticClass: "user-calendar__header__left"
	  }, [_c('SelectCalendar', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "isMultiple": _vm.userHasPermission('can_see_other_calendars')
	    }
	  }), _vm._v(" "), (_vm.isUsersCalendar) ? _c('UserPresence', {
	    attrs: {
	      "calid": _vm.user.user_calendar_id,
	      "activeCalendarDate": _vm.activeCalendarDate
	    },
	    on: {
	      "saved": _vm.presenceCall
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "user-calendar__header__right"
	  }, [_c('button', {
	    staticClass: "no-print",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "no-print",
	    class: {
	      'bttn--disabled': _vm.isNotThisWeek
	    },
	    on: {
	      "click": _vm.today
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('repitition.today')) + "\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "icon-arrow-left4 no-print",
	    on: {
	      "click": _vm.prevWeek
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "icon-arrow-right4 no-print",
	    on: {
	      "click": _vm.nextWeek
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-calendar__calendar__container",
	    class: {
	      'd-calendar__calendar__container--print-mode': _vm.isCalendarInPrintMode
	    }
	  }, [_c('DCalendar', {
	    attrs: {
	      "isEditable": _vm.isEditable,
	      "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
	      "isShowWeekends": _vm.isShowWeekends,
	      "startTime": _vm.startTime,
	      "endTime": _vm.endTime,
	      "date": _vm.activeCalendarDate,
	      "events": _vm.dCalendarEvents,
	      "calendarId": _vm.calendar.id,
	      "calendarName": _vm.calendar.name,
	      "isEventsClickable": true,
	      "isLoadingEvents": _vm.isEventsLoading
	    },
	    on: {
	      "onEventClick": _vm.setActiveEvent
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "user-calendar__footer no-print"
	  }, [(_vm.isUsersCalendar) ? _c('ExportCalendar', {
	    attrs: {
	      "calLink": _vm.iCalUrl
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.isShowWeekPlan) ? _c('DWeekplan', {
	    attrs: {
	      "isInPrintMode": _vm.isInPrintMode,
	      "isReadOnly": _vm.isInPrintMode || !_vm.userHasPermission('can_edit_own_notes')
	    }
	  }) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "canEditEvent": _vm.isEditable,
	      "canEditNotes": _vm.userHasPermission('can_edit_own_notes'),
	      "event": _vm.activeEvent,
	      "calendar": _vm.calendar,
	      "initCalendarId": _vm.calendar.id,
	      "isInDCalendar": true
	    },
	    on: {
	      "updated": _vm.readEvents,
	      "close": _vm.closeShowEvent
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    staticClass: "day-cal__overlay"
	  }, [_c('div', {
	    staticClass: "days-container",
	    style: ({
	      height: _vm.height + 'px'
	    })
	  }, [_c('full-calendar', {
	    attrs: {
	      "caldate": _vm.date,
	      "events": _vm.lessons,
	      "viewState": _vm.viewState,
	      "locale": _vm.locale,
	      "i18n": _vm.i18n
	    },
	    on: {
	      "eventclick": _vm.onTap
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pad-10 weekplan-header marg-20-top"
	  }, [_c('span', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.calRangeView))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))])]), _vm._v(" "), _c('weekplan', {
	    staticClass: "pad-10",
	    attrs: {
	      "weeknote": _vm.weeknote,
	      "calId": _vm.calId,
	      "date": _vm.date,
	      "events": _vm.lessons
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": 'etaeiteazYM?start=112',
	      "textForLink": "Guide: Se videoguide for ressourceforbrug"
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "text-link",
	    attrs: {
	      "target": "_blank",
	      "href": "https://test-data.stil.dk/grundskoleindberetning/Vejledninger/2022/1012/Praktisk%20vejledning_Ressourceforbrug_2022.pdf"
	    }
	  }, [_vm._v("Læs\n      officiel vejledning fra STIL")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', {
	    staticClass: "center"
	  }, [_c('tr', [_c('th', {
	    staticStyle: {
	      "min-width": "225px"
	    }
	  }, [_c('div', {
	    staticClass: "filter-and-select"
	  }, [_c('span', {
	    staticClass: "icon-filter"
	  }), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activeUserFilter),
	      expression: "activeUserFilter"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.activeUserFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.stilStillingerWithCount), function(stilStilling) {
	    return _c('option', {
	      domProps: {
	        "value": stilStilling.value
	      }
	    }, [_vm._v("\n              " + _vm._s(stilStilling.title) + " (" + _vm._s(stilStilling.count) + ")\n            ")])
	  }), 0)])]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Arbejdstimer")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Fagopdelt undervisning")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Understøttende undervisning")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('tr', {
	    staticClass: "thead-second-row"
	  }, [_c('th', [_c('div', {
	    staticClass: "select-all-and-button"
	  }, [_c('p', {
	    staticClass: "select-all",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUsers.length < 1) ? _c('span', [_vm._v("Vælg alle")]) : _c('span', [_vm._v("Fravælg alle")])]), _vm._v(" "), (_vm.selectedUsers.length < 1) ? _c('div', {
	    staticClass: "hint--bottom-left",
	    attrs: {
	      "aria-label": "Vælg brugere først"
	    }
	  }, [_c('button', {
	    staticClass: "no-print bttn bttn--disabled"
	  }, [_vm._v("\n              Indsæt på valgte\n            ")])]) : _c('button', {
	    staticClass: "up__button",
	    on: {
	      "click": function($event) {
	        _vm.isInsertOnMore = true
	      }
	    }
	  }, [_vm._v("Indsæt på valgte")])])]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsersWithVProps), function(user, userIdx) {
	    return _c('tr', {
	      key: user.id
	    }, [_c('td', {
	      staticClass: "td__select-user",
	      class: {
	        'td__select-user--selected': _vm.theActiveUserId === user.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectUser(user.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "name-and-title"
	    }, [_c('div', {
	      staticClass: "name-and-title__checkbox"
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': _vm.getIsUserSelected(user.id)
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', [(user.v_stil_stilling_title) ? _c('p', {
	      staticClass: "d-pill"
	    }, [_vm._v("\n              " + _vm._s(user.v_stil_stilling_title) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.theActiveUserId !== user.id ? 'Se opgaveoversigt' : 'Luk opgaveoversigt'
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheActiveUserId(user.id)
	        }
	      }
	    }, [(_vm.theActiveUserId !== user.id) ? _c('span', {
	      staticClass: "icon-clipboard2"
	    }) : _c('span', {
	      staticClass: "icon-cross2"
	    })])])])]), _vm._v(" "), (_vm.theActiveUserId === user.id) ? _c('StilRessourceTasks', {
	      attrs: {
	        "userId": user.id,
	        "schoolYear": _vm.activeSchoolYear,
	        "startDate": _vm.activeSchoolYear.employee_time_start,
	        "endDate": _vm.activeSchoolYear.employee_time_end
	      }
	    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_total_normal),
	        expression: "user.v_stil_hours_total_normal"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_total_normal
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_total_normal)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_40_B', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_total_normal", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_total_special),
	        expression: "user.v_stil_hours_total_special"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_total_special
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_total_special)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_50_B', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_total_special", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_fag_normal),
	        expression: "user.v_stil_hours_fag_normal"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_fag_normal
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_fag_normal)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_40_A1', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_fag_normal", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_fag_special),
	        expression: "user.v_stil_hours_fag_special"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_fag_special
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_fag_special)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_50_A1', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_fag_special", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_uuv_normal),
	        expression: "user.v_stil_hours_uuv_normal"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_uuv_normal
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_uuv_normal)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_40_A22', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_uuv_normal", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_uuv_special),
	        expression: "user.v_stil_hours_uuv_special"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_uuv_special
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_uuv_special)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_50_A22', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_uuv_special", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_other_normal),
	        expression: "user.v_stil_hours_other_normal"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_other_normal
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_other_normal)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_40_A33', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_other_normal", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_hours_other_special),
	        expression: "user.v_stil_hours_other_special"
	      }],
	      class: {
	        'number--empty': !user.v_stil_hours_other_special
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (user.v_stil_hours_other_special)
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'stil_hours_50_A33', $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(user, "v_stil_hours_other_special", $event.target.value)
	        }
	      }
	    })])])
	  }), 0)]), _vm._v(" "), (_vm.isInsertOnMore) ? _c('GrundskoleIndberetningRessourceInsertModal', {
	    attrs: {
	      "selectedUsers": _vm.selectedUserObjects,
	      "schoolId": _vm.schoolId
	    },
	    on: {
	      "updateRessource": _vm.updateRessourceFromModal,
	      "close": _vm.closeInsertOnMore
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("Bemærk: I skal indberette, hvor mange undervisningsressourcer (målt i arbejdstimer), som skolen\n      råder over, og hvordan skolen planlægger at bruge de undervisningsressourcer"), _c('br'), _vm._v("\n      Arbejdstiden for en fuldstidslærer er 1924 timer. Ud af dette findes et skøn for tid brugt på: Undervisning, UUV\n      og Øvrig tid med eleverne (f.eks. elevsamtaler, gårdvagt og pause med eleverne)")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Øvrig tid med eleverne"), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("(f.eks. elevsamtaler,\n        gårdvagt og pauser med eleverne)")])])
	}]}

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "left-panel",
	    class: {
	      'panelActive': this.selectedWeeks.length > 0 && this.deleteEvents
	    }
	  }, [(_vm.isLoading) ? _c('spinner') : [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.lessons.length === 0),
	      expression: "lessons.length === 0"
	    }]
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.noSubstitutesOrNotes')))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.lessons.length !== 0),
	      expression: "lessons.length !== 0"
	    }]
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.youAreAboutToDelete')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.lessons.length) + " " + _vm._s(_vm.lessons.length === 1 ? _vm.$t('vue2.copycalendar.lesson') : _vm.$t('vue2.copycalendar.lessons')) + " " + _vm._s(_vm.$t('vue2.copycalendar.withSubstitutesOrNotes')))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('ul', _vm._l((_vm.sortedLesson), function(lesson, index) {
	    return _c('li', {
	      key: lesson.id
	    }, [(!_vm.isSameDate(index)) ? _c('p', {
	      staticClass: "headline"
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.copycalendar.week')) + " " + _vm._s(_vm._f("showWeek")(lesson.event_time_start)) + "\n        ")]) : _vm._e(), _vm._v(" "), (lesson.has_notes) ? _c('span', {
	      staticClass: "icon-file-text2"
	    }) : _vm._e(), _vm._v(" "), (lesson.has_substitute) ? _c('span', {
	      staticClass: "icon-users"
	    }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm._f("showDateAndTime")(lesson.event_time_start)) + "\n        " + _vm._s(lesson.title) + "\n      ")])
	  }), 0)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-week-selector week-selector overflow no-print text-dark"
	  }, [(_vm.startDate) ? _c('ul', {
	    staticClass: "week-selector__weeks"
	  }, [_c('li', {
	    staticClass: "disabled"
	  }, [_vm._v(_vm._s(_vm.startDateInYear))]), _vm._v(" "), _vm._l((_vm.weeksInYear), function(week) {
	    return _c('li', [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n      arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n        }"
	      }],
	      staticClass: "pointer",
	      class: [{
	        'active': week.isChosenWeek,
	        'isThisWeek': week.isThisWeek
	      }],
	      attrs: {
	        "content": week.tooltipDate
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setDate(week.date)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(week.weekNum) + "\n      ")])])
	  }), _vm._v(" "), _c('li', {
	    staticClass: "disabled week-selector__weeks__right"
	  }, [_vm._v(_vm._s(_vm.endDateInYear))])], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "insert brutto text-dark brutto-container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h2', [_vm._v("Indsæt ressourceforbrug på flere")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [_c('div', {
	    staticClass: "brutto-container__body__left"
	  }, [_c('ul', {
	    staticClass: "brutto__items"
	  }, _vm._l((_vm.items), function(item, idx) {
	    return _c('li', {
	      key: item.id,
	      staticClass: "brutto__items__item__container"
	    }, [_c('div', {
	      staticClass: "brutto__items__item"
	    }, [_c('span', {
	      staticClass: "norm-title"
	    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', [_c('div', {
	      staticClass: "d-input-group__input"
	    }, [_c('span', {
	      staticClass: "label"
	    }, [_vm._v("Normalklasse")]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.nHours),
	        expression: "item.nHours"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (item.nHours)
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "nHours", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "d-input-group__input"
	    }, [_c('span', {
	      staticClass: "label"
	    }, [_vm._v("Special klasse")]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.sHours),
	        expression: "item.sHours"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (item.sHours)
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "sHours", $event.target.value)
	        }
	      }
	    })])])])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    class: [{
	      'bttn--loading': _vm.isSaving
	    }],
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n        Gem\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "delete-events text-dark"
	  }, [(!_vm.isInDCalendar) ? _c('div', {
	    staticClass: "delete-event__options"
	  }, [_c('DDropdown', [_c('ul', {
	    staticClass: "large-list",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": _vm.setDelete
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale].delete_events_onward))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isReadyForModal) ? _c('div', {
	    ref: "d_modal_delete_event"
	  }, [(_vm.isModal) ? _c('Modal', {
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('div', {
	    staticClass: "delete-events___modal text-dark",
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "delete-events___modal__header",
	    style: ({
	      backgroundColor: _vm.bgColor
	    })
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].are_you_sure))])]), _vm._v(" "), _c('div', {
	    staticClass: "delete-events___modal__form"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale].do_you_want_to_delete_this_and_all_in_same_timeslot))]), _vm._v(" "), _c('div', {
	    staticClass: "delete-events___modal__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].cancel))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn--warning bttn--red bttn marg-10-left",
	    on: {
	      "click": _vm.deleteEvents
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale].delete_events_onward) + "\n            ")])])])])]) : _vm._e()], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	}]}

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "shortcuts text-dark"
	  }, [_c('div', {
	    staticClass: "shortcuts__buttons"
	  }, [_c('label', {
	    staticClass: "marg-10-right"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.shortcuts')) + ":")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.getAbsentUsers
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.show_all_absent')))]), _vm._v(" "), (_vm.isShowExternalShortCuts) ? _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": true,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn dropdown-button",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Rapporter "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.schoolLinks), function(schoolLink) {
	    return _c('li', {
	      key: schoolLink.link,
	      staticClass: "li-links__link"
	    }, [_c('a', {
	      attrs: {
	        "href": schoolLink.link,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(schoolLink.title) + "\n            "), _c('svg', {
	      staticClass: "tw-icon w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
	      }
	    })])])])
	  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowAbsentUsers) ? _c('div', {
	    staticClass: "shortcuts__overlay__bg",
	    on: {
	      "click": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideUp"
	    }
	  }, [(_vm.isShowAbsentUsers) ? _c('div', {
	    staticClass: "shortcuts__overlay text-dark",
	    attrs: {
	      "id": "printList"
	    }
	  }, [_c('div', {
	    staticClass: "shortcuts__overlay__header"
	  }, [_c('h2', {
	    staticClass: "text-dark"
	  }, [(_vm.isLoading) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.getting_all')))]) : _c('span', [_vm._v(_vm._s(_vm.absentUsers.length))]), _vm._v("\n          " + _vm._s(_vm.$t('vue2.substitute_hours.absent_in_the_period')) + " " + _vm._s(_vm.startDateFormatted) + " - " + _vm._s(_vm.endDateFormatted) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "shortcuts__overlay__header__buttons"
	  }, [_c('button', {
	    staticClass: "no-print",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "shortcuts__overlay__close icon__bg-circle no-print",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _c('div', {
	    staticClass: "shortcuts__users"
	  }, [_c('div', {
	    staticClass: "filters__for__reasons no-print"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n['filter_reasons'],
	      "tags": _vm.absenceEventsTypes,
	      "selectedTags": _vm.selectedReasonsToFilter
	    },
	    on: {
	      "select": _vm.toggleFilter,
	      "clear": function($event) {
	        _vm.selectedReasonsToFilter = []
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.absenceEvents.length < 1) ? _c('h4', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.there_is_no_one_absent')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.absentUsers), function(absentUser) {
	    return _c('li', {
	      key: absentUser.userCalendarId,
	      staticClass: "shortcuts-user text-dark"
	    }, [_c('div', {
	      staticClass: "shortcuts-user__header"
	    }, [_c('div', {
	      staticClass: "shortcuts-user__header__name"
	    }, [_vm._v(_vm._s(_vm.getUserNameFromCalId(absentUser.userCalendarId)))]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.days_with_absence')) + ":")]), _vm._v("\n                " + _vm._s(_vm.getNumberOfDaysAbsent(absentUser.events)) + "\n              ")])]), _vm._v(" "), _c('ul', {
	      staticClass: "text-dark"
	    }, _vm._l((_vm.sortedEvents(absentUser.events)), function(day) {
	      return _c('li', [_c('ul', {
	        staticClass: "events__list"
	      }, _vm._l((day), function(event) {
	        return _c('li', {
	          staticClass: "events__list__event"
	        }, [_c('div', {
	          staticClass: "events__list__event__meta"
	        }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("ddd")(event.start))) + " " + _vm._s(_vm._f("LL")(event.start)) + "\n                      kl. " + _vm._s(_vm._f("LT")(event.start)) + " -\n                      " + _vm._s(_vm._f("LT")(event.end)) + ",\n                      "), _c('b', [_vm._v(_vm._s(event.title))])]), _vm._v(" "), (event.teacher_notes && _vm.hasNoteWithoutHTML(event.teacher_notes).length > 0) ? _c('div', {
	          staticClass: "events__list__event__note"
	        }, [_c('span', {
	          staticClass: "icon-pencil"
	        }), _vm._v(" "), _c('div', {
	          domProps: {
	            "innerHTML": _vm._s(event.teacher_notes)
	          }
	        })]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDuration(event)))])])
	      }), 0)])
	    }), 0)])
	  }), 0)])], 1) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "users-hours text-dark"
	  }, [_c('div', {
	    staticClass: "users-hours__header"
	  }, [_c('h2', [_vm._v("Årsnormsopgørelse for " + _vm._s(_vm.numberOfWorkDaysInPeriod) + " arbejdsdage")]), _vm._v(" "), _c('div', {
	    staticClass: "user-tasks__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('setIsShowEmploymentEnded', true)
	      }
	    }
	  }, [_vm._v("Brudt ansættelse")]), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-more2"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": _vm.updateUserHours
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.assign_users_hours.update')) + "\n          ")])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "user-table-container"
	  }, [(_vm.isLoadingUpdatedNumbers) ? _c('div', {
	    staticClass: "user-table-container__loader",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('Loader', {
	    attrs: {
	      "is-small": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "user-table"
	  }, [_c('thead', [_c('tr', [_c('thUser', {
	    attrs: {
	      "rowspan": "3",
	      "sort-prop": "name",
	      "title": _vm.$t('vue2.assign_users_hours.name'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.work_hours')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('tr', [_c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  })], 1)]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedUsers), function(user) {
	    return _c('tr', {
	      key: user.id,
	      staticClass: "tr-user"
	    }, [_c('th', {
	      staticClass: "tr-user__name"
	    }, [_c('div', {
	      staticClass: "tr-user__name__inner"
	    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "tr-user__name__bttn icon__bg-circle hint--right",
	      attrs: {
	        "aria-label": "Årsnormsoversigt"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveUserInAssignHours(user)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "icon-chart tw-icon tw-icon--small",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('path', {
	      staticClass: "primary",
	      attrs: {
	        "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
	      }
	    })])])])]), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number td-presence",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_assigned_total_hours)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence",
	      attrs: {
	        "aria-label": user.v_total_hours_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_total_hours_diff)),
	      attrs: {
	        "aria-label": user.v_total_hours_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number with-kids-color",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_total_with_kids)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_with_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number with-kids-color",
	      attrs: {
	        "aria-label": user.v_with_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number with-kids-color number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_with_kids_diff)),
	      attrs: {
	        "aria-label": user.v_with_kids_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number without-kids-color",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_total_without_kids)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_without_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number without-kids-color",
	      attrs: {
	        "aria-label": user.v_without_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number without-kids-color number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_without_kids_diff)),
	      attrs: {
	        "aria-label": user.v_without_kids_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number td-presence",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_assigned_total_hours)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence",
	      attrs: {
	        "aria-label": user.v_with_and_without_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_with_and_without_kids_diff)),
	      attrs: {
	        "aria-label": user.v_with_and_without_kids_diff
	      }
	    })])
	  }), 0)])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('div', {
	    staticClass: "user-task__container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "user-task__container__header"
	  }, [_c('h2'), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserTasks', {
	    attrs: {
	      "initialStartDate": _vm.startDate,
	      "initialEndDate": _vm.endDate,
	      "user_id": _vm.theUserToShowTasks.id,
	      "user_calendar_id": _vm.theUserToShowTasks.user_calendar_id,
	      "user_name": _vm.theUserToShowTasks.name,
	      "isShowPrintButton": false,
	      "isCanSeeOtherUsers": false
	    }
	  }) : _vm._e()], 1)]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Med børn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Uden børn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Med + uden børn")])])
	}]}

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "onboard-arrow",
	    style: ([{
	      right: _vm.right + 'px'
	    }, {
	      bottom: _vm.bottom + 'px'
	    }])
	  }, [_c('div', {
	    staticClass: "arrow_box no-print animated infinite onboarding_animate"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ul', {
	    staticClass: "doTable__items text-dark"
	  }, [(_vm.kindergartenCalendarsWithProps.length === 0) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen stuer oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.kindergartenCalendarsWithProps), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(calendar.name))]), _vm._v(" "), _c('div', [_c('button', {
	      on: {
	        "click": function($event) {
	          return _vm.setIsCreate(calendar)
	        }
	      }
	    }, [_vm._v("Opret brik på stuen")])])]), _vm._v(" "), _c('ul', {
	      staticClass: "subjects"
	    }, [(calendar.v_tasks_with_kids.length < 1) ? _c('h4', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen brikker oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((calendar.v_tasks_with_kids), function(subject) {
	      return _c('li', {
	        key: subject.id,
	        staticClass: "subjects_subject",
	        style: ({
	          'background': subject.color
	        }),
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(subject)
	          }
	        }
	      }, [_vm._v("\n          " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n        ")])
	    })], 2)])
	  }), _vm._v(" "), (_vm.isSubjectModal) ? _c('CreateSubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "initCalendarId": _vm.activeCalendarId,
	      "editSubject": _vm.theEditSubject,
	      "editSubjectId": _vm.theEditSubjectId
	    },
	    on: {
	      "close": _vm.closeSubjectModal,
	      "createSubject": _vm.createNewSubject,
	      "updateSubject": _vm.updateSubject,
	      "deleteSubject": _vm.deleteSubject
	    }
	  }) : _vm._e()], 2), _vm._v(" "), _c('AnnualNormWithoutKids', {
	    attrs: {
	      "isWithKids": true
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-profile__form"
	  }, [(_vm.canEdit) ? _c('div', {
	    staticClass: "d-profile__form__edit",
	    on: {
	      "click": function($event) {
	        _vm.isEditable = !_vm.isEditable
	      }
	    }
	  }, [(!_vm.isEditable) ? [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))] : [_vm._v("Afslut redigering")]], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-profile__form__body"
	  }, [_c('h3', [_vm._v("Undervisningskompetencer (Linjefag)")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.competencies.length < 1) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n      Ingen fag er tilføjet som kompetence\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "marg-1-top"
	  }, [(_vm.isEditable) ? [_vm._m(0), _vm._v(" "), _c('label', {
	    staticClass: "d-label marg-1-top marg-1-bottom"
	  }, [_vm._v("Tilføj op til seks kompetencer")]), _vm._v(" "), _c('DSelect', {
	    attrs: {
	      "items": _vm.standardSubjectsWithVProps,
	      "itemsSelected": _vm.userCompetencies,
	      "show": true,
	      "placeholder": "Tilføj kompetence"
	    },
	    on: {
	      "update": function($event) {
	        return _vm.updateSubjectOnUser($event)
	      }
	    }
	  })] : _vm._e(), _vm._v(" "), (!_vm.isEditable) ? _c('ul', {
	    staticClass: "linjefag linjefag--not-empty"
	  }, [(_vm.userCompetencies.length === 0) ? _c('li', {
	    staticClass: "linjefag__add"
	  }, [_vm._v("\n          Tilføj op til seks kompetencer\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userCompetencies), function(subject) {
	    return _c('li', {
	      staticClass: "d-pill"
	    }, [_vm._v("\n          " + _vm._s(subject.name) + "\n        ")])
	  })], 2) : _vm._e()], 2)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "div-explainer"
	  }, [_c('h3', [_vm._v("L eller K?")]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_c('b', [_vm._v("(L) Linjefag")]), _vm._v(": At have undervisningskompetence i et fag betyder, at\n            underviseren har haft det pågældende fag som linjefag på læreruddannelsen eller som ekstra linjefag på et\n            senere tidspunkt.")]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_c('b', [_vm._v("(K) Tilsvarende kompetence")]), _vm._v(": At have kompetence svarende til\n            undervisningskompetence betyder, at underviseren for eksempel har en efteruddannelse, videreuddannelse,\n            kompetencegivende uddannelse eller et længerevarende kursusforløb, der vurderes at give kompetence\n            svarende\n            til undervisningskompetence.")])])
	}]}

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isIEorEdge) ? _c('div', {
	    staticClass: "ie-warning"
	  }, [_c('h2', {
	    staticStyle: {
	      "font-weight": "lighter"
	    }
	  }, [_c('span', {
	    staticClass: "icon-warning"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.IEWarning.you_are_using_a_IE_or_Edge_to_get')) + "\n    "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold",
	      "font-style": "italic"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.IEWarning.a_faster_and_better_experience')))]), _vm._v("\n    " + _vm._s(_vm.$t('vue2.IEWarning.we_recommend_that_you_switch_to_these_browsers')) + ":\n    "), _c('a', {
	    staticClass: "text-blue",
	    attrs: {
	      "href": "https://www.google.com/chrome/",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n      Google Chrome")]), _vm._v("\n    " + _vm._s(_vm.$t('vue2.IEWarning.or')) + "\n    "), _c('a', {
	    attrs: {
	      "href": "https://www.mozilla.org/firefox/new/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Firefox")])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "d-select text-dark",
	    class: {
	      'openFromBottom': _vm.openFromBottom
	    }
	  }, [_c('div', {
	    staticClass: "width-100 no-print",
	    class: {
	      'box-shadow': _vm.boxShadow
	    }
	  }, [_c('div', {
	    staticClass: "d-select__input-look",
	    class: {
	      'active': _vm.showDropdown
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._l((_vm.usersThatAreSelected), function(selectedUser) {
	    return _c('div', {
	      staticClass: "d-select__selected__item",
	      class: {
	        'readyToDelete': _vm.isReadyToDelete(selectedUser)
	      }
	    }, [_vm._v("\n        " + _vm._s(selectedUser.name) + "\n        "), (_vm.userOccEvents(selectedUser) && _vm.userOccEvents(selectedUser).length > 0) ? [_c('div', {
	      staticClass: "icon-warning item__icon-warning marg-5-left",
	      class: {
	        'item_icon__hide': selectedUser.occupied.events.length === 1 && selectedUser.occupied.events[0].event_type === 'presence' || selectedUser.isOnLesson && selectedUser.occupied.events.length === 1
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "d-select__selected__item__secret-label"
	    }, _vm._l((_vm.userOccEvents(selectedUser)), function(event, index) {
	      return (index < 3) ? _c('div', {
	        staticClass: "d-select__selected__item__secret-label__event"
	      }, [_vm._v("\n              " + _vm._s(event.title) + "\n            ")]) : _vm._e()
	    }), 0)] : _vm._e(), _vm._v(" "), (!selectedUser.isErrorUser) ? _c('div', {
	      staticClass: "d-select__selected__item__remove",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.removeUser(selectedUser)
	        }
	      }
	    }, [_c('span', [_vm._v("×")])]) : _vm._e()], 2)
	  }), _vm._v(" "), (_vm.isLoading) ? [_c('spinner', {
	    staticStyle: {
	      "margin": "7px 0 0 0"
	    },
	    attrs: {
	      "color": "blue",
	      "size": "small"
	    }
	  })] : [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    ref: "inputfield",
	    staticClass: "d-select__header__search",
	    class: [{
	      'show': _vm.showDropdown
	    }, {
	      'input-active': _vm.searchText.length > 0 || _vm.selectedUsers.length < 1
	    }],
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.placeholderText
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "keypress": [function($event) {
	        return _vm.selectWithKeyboard('', $event)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('enter')
	      }],
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('down')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('up')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
	        return _vm.deleteUserWithKeyboard.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }
	    }
	  })]], 2), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    staticClass: "d-select__items"
	  }, [_c('ul', {
	    ref: "dropdown",
	    staticClass: "d-select__items__container"
	  }, [(_vm.isUpdatingUsers) ? [_c('li', {
	    staticClass: "item-template flex space-between"
	  }, [_c('spinner', {
	    staticStyle: {
	      "margin": "4px 0 0 0"
	    },
	    attrs: {
	      "color": "blue",
	      "size": "small"
	    }
	  })], 1)] : _vm._l((_vm.searchedUsers), function(item, index) {
	    return [_c('li', {
	      key: item.user_id,
	      class: [{
	          'isReadyForSelection': _vm.isSelectedWithKeyboard(item)
	        },
	        {
	          'item_is_selected': _vm.isSelected(item)
	        }
	      ],
	      on: {
	        "mouseenter": function($event) {
	          return _vm.setIsReadyForSelection(item, index)
	        },
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleUser(item)
	        }
	      }
	    }, [(item.occupied && item.occupied.events.length > 0) ? [_c('div', {
	      staticClass: "item-template isOccupied",
	      class: [{
	          'item-is-present': item.occupied.events.length === 1 && item.occupied.events[0].event_type === 'presence'
	        },
	        {
	          'item-is-already-attached': item.isOnLesson
	        }
	      ]
	    }, [(item.icon) ? _c('span', {
	      staticClass: "marg-10-right",
	      class: item.icon
	    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	      attrs: {
	        "src": item.default_thumb_url
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "warning-signs"
	    }, [_vm._l((item.occupied.events), function(event) {
	      return [(event.event_type !== 'presence') ? [(item.isOnLesson && item.currentEventId === event.event_id) ? _c('div', {
	        staticClass: "marg-10-left"
	      }, [_c('span', {
	        staticClass: "icon-user"
	      }), _vm._v(" " + _vm._s(_vm.i18n['also_assigned']) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (item.currentEventId !== event.event_id),
	          expression: "item.currentEventId !== event.event_id"
	        }],
	        staticClass: "marg-10-left warning-signs__sign"
	      }, [_c('span', {
	        staticClass: "icon-warning"
	      }), _vm._v(" " + _vm._s(event.title) + "\n                      ")])] : _vm._e(), _vm._v(" "), _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (item.occupied.events.length === 1 && event.event_type === 'presence'),
	          expression: "item.occupied.events.length === 1 && event.event_type === 'presence'"
	        }],
	        staticClass: "marg-10-left"
	      }, [_c('span', {
	        staticClass: "icon-clock"
	      }), _vm._v(" " + _vm._s(_vm.i18n['working_hours']) + ": " + _vm._s(_vm._f("localeTime")(event.event_time_start)) + " -\n                      " + _vm._s(_vm._f("localeTime")(event.event_time_end)) + "\n                    ")])]
	    })], 2)])] : _c('div', {
	      staticClass: "item-template"
	    }, [(item.icon) ? _c('span', {
	      staticClass: "marg-10-right",
	      class: item.icon
	    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	      attrs: {
	        "src": item.default_thumb_url
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])])], 2)]
	  })], 2), _vm._v(" "), (_vm.searchedUsers.length < 1) ? _c('div', {
	    staticClass: "no-match"
	  }, [_vm._t("noMatch", function() {
	    return [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))])]
	  })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.subFromIsOnLesson !== null) ? _c('div', {
	    staticClass: "subModal__bg"
	  }, [_c('div', {
	    staticClass: "subModal"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['would_you_like_to_set']) + " " + _vm._s(_vm.subFromIsOnLesson.name) + " " + _vm._s(_vm.i18n['as_a_substitute_instead_of_teacher']) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "subModal__buttons"
	  }, [_c('button', {
	    on: {
	      "click": _vm.setSubFromIsOnLesson
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['yes']))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn-simple bttn",
	    on: {
	      "click": function($event) {
	        _vm.subFromIsOnLesson = null
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['no']))])])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": '5Id4TeuHMvI?start=233',
	      "textForLink": "Guide: Se videoguide for kompetencedækning"
	    }
	  }), _vm._v(" "), (_vm.isShowSubjects) ? _c('p', {
	    staticClass: "italic"
	  }, [_c('b', [_vm._v("Bemærk:")]), _vm._v(" Opret, slet eller redigere fag påvirker kun indberetningsdata'en - ikke i resten af Docendo")]) : _vm._e()], 1), _vm._v(" "), (_vm.usersSorted.length < 1) ? _c('h3', {
	    staticClass: "text-explainer text-explainer__error"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v("\n    Der er ingen personer udfyldt med stilling og CPR. Gå tilbage til \"1. Undervisningskompetencer\"\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usersSorted), function(user) {
	    return _c('KompetenceIndberetningDaekningUser', {
	      attrs: {
	        "user": user,
	        "klokketimetyper": _vm.klokketimetyper,
	        "dbStilData": _vm.dbStilData
	      },
	      on: {
	        "updateStil": function($event) {
	          return _vm.$emit('updateStil', $event)
	        }
	      }
	    })
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "d_parent",
	    staticClass: "other-cal",
	    class: {
	      'other-cal--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    staticClass: "other-cal__selected d-input",
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.selectedCalendar))]), _vm._v(" "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), (_vm.isDropDown) ? _c('ul', {
	    ref: "d_child",
	    staticClass: "other-cal__options",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady, 'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('li', {
	    class: {
	      'item--active': _vm.selectedCalendarId === null
	    },
	    on: {
	      "click": function($event) {
	        return _vm.selectCalendar(null)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['own_calendars']) + "\n    ")]), _vm._v(" "), _vm._l((_vm.otherCalendars), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      class: {
	        'item--active': _vm.selectedCalendarId === calendar.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectCalendar(calendar.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name) + "\n    ")])
	  })], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "duty-schedule text-dark"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeOut"
	    }
	  }, [(_vm.isInitialLoading) ? _c('DoSplash') : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-wrapper"
	  }, [_c('WeekSelecter', {
	    attrs: {
	      "date": _vm.date,
	      "startDate": _vm.schoolYear.employee_time_start,
	      "endDate": _vm.schoolYear.employee_time_end
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setDate($event)
	      }
	    }
	  }), _vm._v(" "), _c('DutySchedulePlan', {
	    attrs: {
	      "theCreateEventObj": _vm.theCreateEventObj,
	      "usersCalIdsHash": _vm.allUsersInCalIdHash,
	      "calendars": _vm.kindergartenCalendars,
	      "isEventsLoading": _vm.isEventsLoading,
	      "date": _vm.date,
	      "events": _vm.events,
	      "eventsInHash": _vm.eventsInUserCalendarIdHash,
	      "userNorms": _vm.userNorms,
	      "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
	      "schoolSettings": _vm.schoolSettings,
	      "isCreateOpeningHours": _vm.isCreateOpeningHours,
	      "openingHours": _vm.openingHours
	    },
	    on: {
	      "createSubject": _vm.onCreateSubject,
	      "createEvent": _vm.onCreateEvent,
	      "editEvent": _vm.onEditEvent,
	      "setIsCreateOpeningHours": _vm.setIsCreateOpeningHours,
	      "today": _vm.setToday,
	      "next": _vm.setNext,
	      "prev": _vm.setPrev
	    }
	  }), _vm._v(" "), (_vm.theCreateEventObj) ? _c('CreateEvent', {
	    attrs: {
	      "openingHours": _vm.openingHours,
	      "user": _vm.theCreateEventObj.user,
	      "initDate": _vm.theCreateEventObj.date,
	      "initSubject": _vm.theCreateEventObj.subject,
	      "emitEvent": true
	    },
	    on: {
	      "addANewEvent": _vm.onAddedEvent,
	      "close": _vm.onCloseCreateEvent
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theEditEventObj) ? _c('CreateEvent', {
	    attrs: {
	      "user": _vm.theEditEventObj.user,
	      "editEvent": _vm.theEditEventObj.event,
	      "emitEvent": true,
	      "openingHours": _vm.openingHours
	    },
	    on: {
	      "updatedEvent": _vm.onUpdatedEvent,
	      "deletedEvent": _vm.onDeletedEvent,
	      "close": _vm.onCloseCreateEvent
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theCreateSubjectCalendar) ? _c('CreateSubject', {
	    attrs: {
	      "calendarAndUsers": _vm.theCreateSubjectCalendar,
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId
	    },
	    on: {
	      "created": _vm.onNewSubjectCreated,
	      "close": function($event) {
	        return _vm.onCreateSubject(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isCreateOpeningHours) ? _c('DutyScheduleOpeningHours', {
	    attrs: {
	      "propOpeningHours": _vm.openingHours
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsCreateOpeningHours(false)
	      }
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "public-app"
	  }, [_c('public-header', {
	    attrs: {
	      "locale": _vm.locale,
	      "showdatepicker": _vm.showdatepicker,
	      "date": _vm.datePickerDate
	    },
	    on: {
	      "monthClick": _vm.toggleDatePicker,
	      "menu": _vm.setMenu
	    }
	  }), _vm._v(" "), (_vm.showdatepicker) ? _c('pan-container', {
	    attrs: {
	      "active": _vm.isDatePickerReady,
	      "date": _vm.datePickerDate,
	      "theCalendarDate": _vm.date
	    },
	    on: {
	      "changed": _vm.setDatePickerDate,
	      "setDate": _vm.setDate
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showdatepicker) ? _c('v-touch', {
	    staticClass: "overlay",
	    on: {
	      "tap": _vm.closeDatepicker
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chosenView === 1) ? _c('day-selector', {
	    attrs: {
	      "date": _vm.date,
	      "locale": _vm.locale
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.load),
	      expression: "load"
	    }],
	    staticClass: "load-spinner mobile"
	  }, [_c('div', {
	    staticClass: "icon-docendo animated pulse infinite"
	  })]), _vm._v(" "), (_vm.chosenView === 1) ? _c('cal-container', {
	    attrs: {
	      "i18n": _vm.i18n,
	      "locale": _vm.locale,
	      "date": _vm.date,
	      "dateChange": _vm.dateChange,
	      "lessons": _vm.allEvents,
	      "viewState": _vm.viewState
	    },
	    on: {
	      "eventClicked": _vm.showEvent,
	      "update:date": function($event) {
	        _vm.date = $event
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chosenView === 2) ? _c('weekplan', {
	    attrs: {
	      "calId": _vm.calId,
	      "date": _vm.date,
	      "events": _vm.allEvents,
	      "locale": _vm.locale,
	      "weeknote": _vm.weeknote
	    },
	    on: {
	      "close": _vm.closeWeekPlan
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.chosenView === 3) ? _c('week-calendar', {
	    attrs: {
	      "calId": _vm.calId,
	      "i18n": _vm.i18n,
	      "date": _vm.date,
	      "dateChange": _vm.dateChange,
	      "lessons": _vm.allEvents,
	      "weeknote": _vm.weeknote,
	      "viewState": _vm.viewState,
	      "locale": _vm.locale
	    },
	    on: {
	      "eventClicked": _vm.showEvent,
	      "update:date": function($event) {
	        _vm.date = $event
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('footer-nav', {
	    attrs: {
	      "isNotToday": _vm.isNotToday
	    },
	    on: {
	      "today": function($event) {
	        return _vm.setDate(_vm.today)
	      },
	      "prev": _vm.prev,
	      "next": _vm.next
	    }
	  }), _vm._v(" "), _c('sidenav', {
	    attrs: {
	      "menu": _vm.menu,
	      "chosenView": _vm.chosenView,
	      "schoolName": _vm.schoolName,
	      "calName": _vm.calName
	    },
	    on: {
	      "update:chosenView": function($event) {
	        _vm.chosenView = $event
	      },
	      "update:chosen-view": function($event) {
	        _vm.chosenView = $event
	      },
	      "close": function($event) {
	        _vm.menu = false
	      },
	      "afterLeave": _vm.getView,
	      "locale": _vm.setLocale
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [(_vm.show) ? _c('div', [_c('div', {
	    class: {
	      'modal-mask': _vm.show_modal_mask
	    }
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.clickAway),
	      expression: "clickAway"
	    }],
	    staticClass: "modal-container",
	    class: {
	      'modal_from_bottom': _vm.modal_from_bottom
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "font-large close-cross",
	    on: {
	      "click": _vm.removeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer"
	  })]), _vm._v(" "), _vm._t("header", function() {
	    return [_vm._v("default header")]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body", function() {
	    return [_vm._v("default body")]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer", function() {
	    return [_c('button', {
	      staticClass: "bttn bttn_simple right marg-10"
	    }, [_vm._v("\n                Ok\n\n              ")]), _vm._v(" "), _c('button', {
	      staticClass: "bttn bttn_simple right marg-10"
	    }, [_vm._v("\n                Gem\n\n              ")])]
	  })], 2)])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.editEvent ? 'Rediger' : 'Opret') + " vagt til " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-group"
	  }, [_c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer",
	    class: {
	      'do-modal__footer--flex': _vm.editEvent
	    }
	  }, [(_vm.editEvent) ? _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.onDelete
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.editEvent) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.onSubmitEditEvent
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.update')) + "\n        ")]) : [(!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n          ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n          ")])]], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.showModal) ? _c('modal', {
	    on: {
	      "close": _vm.close
	    }
	  }, [(_vm.propIsLoading) ? _c('template', {
	    slot: "body"
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  })], 1) : _c('template', {
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "add-lesson__header",
	    style: ({
	      'backgroundColor': _vm.color ? _vm.color : '#fff'
	    })
	  }, [_c('h2', [_vm._v(_vm._s(_vm.name.length > 0 ? _vm.name : !_vm.isActivities ? _vm.i18n[_vm.locale]['create_subject'] : 'Opret aktivitet'))]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__calendars"
	  }, [_vm._v("\n          " + _vm._s(_vm.showMasterCalendarName) + "\n        ")]), _vm._v(" "), (_vm.editSubject && !_vm.isActivities) ? _c('div', {
	    staticClass: "add-lesson__header__tabs"
	  }, [_c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.activeTab === 'edit'
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeTab = 'edit'
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].edit_subject) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.activeTab === 'history'
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeTab = 'history'
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].activity) + "\n          ")]), _vm._v(" "), (_vm.isReductionsActive && _vm.isShowReductions) ? _c('div', {
	    staticClass: "add-lesson__header__tabs__tab",
	    class: {
	      'tab--is-active': _vm.activeTab === 'reductions'
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeTab = 'reductions'
	      }
	    }
	  }, [_vm._v("\n            Reduktioner\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__form"
	  }, [(_vm.activeTab === 'history') ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].latest_activity))]), _vm._v(" "), _c('SubjectFormLog', {
	    attrs: {
	      "subject": _vm.editSubject
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'reductions') ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [_c('h2', [_vm._v("Reduktioner")]), _vm._v(" "), _c('SubjectFormReductions', {
	    attrs: {
	      "subject": _vm.editSubject
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'edit') ? _c('div', {
	    staticClass: "add-lesson__form__content"
	  }, [(_vm.editSubject) ? [(_vm.isShowSubjectsRequest && _vm.subjectRequestedBy) ? _c('div', {
	    staticClass: "subjects-requested-by do-warning"
	  }, [_c('label', {
	    staticClass: "do-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['requested_by']))]), _vm._v(" " + _vm._s(_vm.subjectRequestedBy) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.editSubject) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_in_school_year']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "do-input",
	    class: {
	      'input--error': _vm.formErrors['hours']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.calendarType !== 'user') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_teacher']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "USER",
	      "showTags": true,
	      "preSelectedItems": _vm.userCalendarIds
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_room']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "ROOM",
	      "preSelectedItems": _vm.roomCalendarIds
	    },
	    on: {
	      "update": _vm.setSelectedRooms
	    }
	  })], 1), _vm._v(" "), (!_vm.isPossibleToAddKlasses && _vm.isAllowedToAddKlasses) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": function($event) {
	        _vm.isPossibleToAddKlasses = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_klass']) + "?")]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isPossibleToAddKlasses) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_klass']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "klass",
	      "calendarId": _vm.calendarId,
	      "showTags": true,
	      "preSelectedItems": _vm.klassCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedKlass
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('p', {
	    staticClass: "text-blue advanced-settings__link",
	    on: {
	      "click": function($event) {
	        _vm.isEditSubjectAdvanced = !_vm.isEditSubjectAdvanced
	      }
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['more_settings']) + "\n              ")])])] : _vm._e(), _vm._v(" "), (!_vm.editSubject || _vm.isEditSubjectAdvanced) ? [_c('div', {
	    class: {
	      'input-group__flex': _vm.isSubjectCodeActive
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_title']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    ref: "name",
	    staticClass: "do-input",
	    class: {
	      'input--error': _vm.formErrors['name']
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.isActivities ? 'Eks. Motionsdag' : _vm.i18n[_vm.locale]['ex_subject']
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('name')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isArbeidstidsplanActivated) ? _c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "max-width": "100px"
	    }
	  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.preparation),
	      expression: "preparation",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "d-input__select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return _vm._n(val)
	        });
	        _vm.preparation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.preparationOptionsForNorway), function(prep) {
	    return _c('option', {
	      key: prep
	    }, [_vm._v("\n                    " + _vm._s(prep) + "\n                  ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isSubjectCodeActive) ? _c('div', {
	    staticClass: "input-group",
	    staticStyle: {
	      "max-width": "100px"
	    }
	  }, [_c('label', [_vm._v("Fagkode")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.subjectCode),
	      expression: "subjectCode",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "do-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.subjectCode)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subjectCode = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), (!_vm.editSubject && !_vm.isEditSubjectAdvanced) ? _c('div', {
	    staticClass: "input-group input-group__flex"
	  }, [_c('div', {
	    staticClass: "flex-"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_in_school_year']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "do-input",
	    class: {
	      'input--error': _vm.formErrors['hours']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('hours')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "flex-1"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['standard_duration']))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group--flex"
	  }, [_c('div', {
	    staticClass: "flex-1"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.defaultDuration),
	      expression: "defaultDuration"
	    }],
	    ref: "input_default_duration",
	    staticClass: "do-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.defaultDuration)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.defaultDuration = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['defaultDuration']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['defaultDuration'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.userCanManageSchool) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n          arrow: true\n        }"
	    }],
	    staticClass: "input-group--flex__setting-icon",
	    attrs: {
	      "content": _vm.$t('vue2.set_standard_duration.set_standard_duration_for_the_school')
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isOpenDurationModal = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.calendarId) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_class']))]), _vm._v(" "), _c('DSelectKlass', {
	    on: {
	      "add": _vm.addKlass,
	      "remove": _vm.removeKlass
	    }
	  }), _vm._v(" "), (_vm.formErrors['calendarId']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['calendarId'][_vm.locale]))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('ColorPicker', {
	    attrs: {
	      "initialColor": _vm.color
	    },
	    on: {
	      "changedColor": _vm.setSubjectColor
	    }
	  })], 1), _vm._v(" "), (!_vm.isActivities) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_subject_type']))]), _vm._v(" "), _c('SubjectTypePicker', {
	    attrs: {
	      "calendarType": _vm.calendarType,
	      "subjectType": _vm.subjectType
	    },
	    on: {
	      "change": _vm.selectSubjectType
	    }
	  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.editSubject) ? _c('div', {
	    staticClass: "edit-subject"
	  }, [_c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }, [(_vm.editSubjectCanBeDeleted) ? _c('button', {
	    staticClass: "hint--right bttn--warning",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['delete_subject']
	    },
	    on: {
	      "click": _vm.deleteEditSubject
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['cannot_delete']
	    }
	  }, [_c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (_vm.editSubject) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.updateSubject
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_subject']) + "\n                ")]) : _vm._e()])])]) : _c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.createSubject
	    }
	  }, [_vm._v("\n                " + _vm._s(!_vm.isActivities ? _vm.i18n[_vm.locale]['create_subject'] : 'Opret aktivitet') + "\n              ")])])])], 2) : _vm._e()])])], 2) : _vm._e(), _vm._v(" "), _c('StandardDurationSetting', {
	    attrs: {
	      "isOpenModal": _vm.isOpenDurationModal
	    },
	    on: {
	      "close": function($event) {
	        _vm.isOpenDurationModal = false
	      },
	      "submit": _vm.saveUpdatedDuration
	    }
	  }), _vm._v(" "), (_vm.subjectsWithSameName.length > 0) ? _c('SubjectFormDeleteSubjects', {
	    attrs: {
	      "subjectsWithSameName": _vm.subjectsWithSameName
	    },
	    on: {
	      "close": _vm.closeModalSubjectsWithSameName,
	      "keep": _vm.keepExistingSubjects,
	      "delete": _vm.deleteExistingSubjects
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "external text-dark"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['external_view']))]), _vm._v(" "), _c('ul', {
	    staticClass: "d-tabs"
	  }, [_c('li', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 0
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(0)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['calendars']) + "\n    ")]), _vm._v(" "), _c('li', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 1
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(1)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['absent_today']) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [(_vm.theActiveTab === 1) ? [_c('h2', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_absent_today']))]), _vm._v(" "), _c('p', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_absent_today_desc']))]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": _vm.absence
	    }
	  }, [_vm._v(_vm._s(_vm.absence))])] : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 0) ? [_c('h2', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_selected_schedules']))]), _vm._v(" "), _c('p', [(_vm.studentCalendars.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_selected_schedules_desc']) + ":")]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_selected_schedules_desc_with_students']) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "href": _vm.publicLink,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.publicLink))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['use_update_in_url']))]), _vm._v(" "), (_vm.studentCalendars.length === 0) ? _c('h4', {
	    staticClass: "marg-1-bottom marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['selected_the_schedules']))]) : _c('h4', {
	    staticClass: "marg-1-bottom marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['selected_the_schedules_with_students']))]), _vm._v(" "), (_vm.isLoadingCalendars) ? _c('loader', {
	    staticStyle: {
	      "margin": "100px 200px"
	    },
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _c('table', {
	    staticClass: "d-table marg-2-top external__toggle-calendars"
	  }, [_c('thead', {
	    staticClass: "d-table__header"
	  }, [_c('th'), _vm._v(" "), _c('th', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n          arrow: true\n        }"
	    }],
	    staticClass: "inline-block",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['access_schedule_without_login']
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['visible_via_link']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })])]), _vm._v(" "), _c('th', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n          arrow: true\n        }"
	    }],
	    staticClass: "inline-block text-link pointer",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['visible_via_link_tooltip']
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowMobileGuide(true)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['schedules_on_desktop_mobile']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })])]), _vm._v(" "), _c('th', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n          arrow: true\n        }"
	    }],
	    staticClass: "inline-block",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['schedules_on_desktop_mobile_tooltip']
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_schedules_until']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })])]), _vm._v(" "), _c('th', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true
	      }),
	      expression: "{\n      arrow: true\n    }"
	    }],
	    staticClass: "pointer inline-block text-link",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['integrations_with_google']
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowICalGuide(true)
	      }
	    }
	  }, [_vm._v("Google, Apple, Outlook "), _c('span', {
	    staticClass: "icon-question3"
	  })])])]), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowKlass = !_vm.isShowKlass
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowKlass
	    }, {
	      'icon-arrow-down': !_vm.isShowKlass
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.calendarsWithProps.length) + "\n          " + _vm._s(_vm.calendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['grade'] : _vm.i18n[_vm.locale]['grades']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowKlass) ? [(_vm.isToggleLoading === 'klass') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllKlassCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyKlassCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowKlass) ? _c('tbody', [(_vm.calendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_grades_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.calendarsWithProps), function(calendar) {
	    return [_c('tr', {
	      key: calendar.id,
	      class: {
	        'tr-calendar--is-open': calendar.v_is_open
	      }
	    }, [_c('td', {
	      class: {
	        'name-and-toggle': calendar.students && calendar.students.length > 0
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveKlassCalendar(calendar)
	        }
	      }
	    }, [(calendar.students && calendar.students.length > 0) ? _c('div', {
	      staticClass: "d-toggle-arrow"
	    }) : _vm._e(), _vm._v("\n              " + _vm._s(calendar.name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "id": "inputfield",
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n              ")])])]), _vm._v(" "), (calendar.v_is_open) ? _c('tr', {
	      staticClass: "tr-student--tr-thead d-table__header"
	    }, [_c('th', [_vm._v(_vm._s(_vm.activeStudentCalenders.length) + " "), (_vm.activeStudentCalenders.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['student']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['students']))])]), _vm._v(" "), _c('th', {
	      staticClass: "toggle-all-calendars"
	    }, [(_vm.isToggleLoading === 'students') ? _c('loader', {
	      staticStyle: {
	        "margin": "0"
	      },
	      attrs: {
	        "isExtraSmall": true,
	        "bg-color": "#f6f9fc"
	      }
	    }) : _c('div', {
	      staticClass: "inline-block pointer",
	      on: {
	        "click": _vm.toggleAllStudentCalendars
	      }
	    }, [(_vm.isAnyActiveStudentCalendersWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n              ")])], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeStudentCalenders), function(student, key) {
	      return (calendar.v_is_open) ? _c('tr', {
	        key: student.id,
	        staticClass: "tr-student--tr",
	        class: {
	          'tr-student--tr-thead--first': _vm.activeStudentCalenders.length > 1 && key === 0
	        }
	      }, [_c('td', [_vm._v("\n              " + _vm._s(student.name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
	        staticClass: "inline-block",
	        on: {
	          "click": function($event) {
	            return _vm.toggleAnonymousAccess(student)
	          }
	        }
	      }, [_c('app-toggle', {
	        attrs: {
	          "prop-on": student.anonymous_access,
	          "allow-changes": false
	        }
	      })], 1)]), _vm._v(" "), _c('td', [(student.anonymous_access) ? _c('button', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            onShow: _vm.hideTippy,
	            trigger: 'manual',
	            arrow: true,
	            placement: 'top',
	            zIndex: 2147483010
	          }),
	          expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	        }],
	        staticClass: "bttn bttn--white bttn--small",
	        attrs: {
	          "content": _vm.i18n[_vm.locale]['copied'] + ' ' + student.v_public_link
	        },
	        on: {
	          "click": function($event) {
	            return _vm.copyToClipboard(student.v_public_link, $event)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	        staticStyle: {
	          "width": "400px"
	        }
	      }, [(!student.published_until && _vm.theActiveDatePickerId !== student.id) ? _c('div', {
	        staticClass: "calendar__no-end-date"
	      }, [_c('p', {
	        staticClass: "text-explainer"
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	        staticClass: "hint--right",
	        attrs: {
	          "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setActiveDatePicker(student)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "icon__bg-circle"
	      }, [_c('span', {
	        staticClass: "icon-calendar4"
	      })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === student.id) ? _c('div', {
	        staticClass: "calendar__datepicker-container"
	      }, [_c('DateSelector', {
	        staticStyle: {
	          "width": "210px"
	        },
	        attrs: {
	          "date": _vm.theActiveDatePickerDate,
	          "isOpen": true
	        },
	        on: {
	          "changed": function($event) {
	            return _vm.updatePublishUntilDate(student, $event)
	          },
	          "close": function($event) {
	            return _vm.closeDatepicker(student)
	          }
	        }
	      }), _vm._v(" "), (student.published_until) ? _c('button', {
	        staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	        on: {
	          "click": function($event) {
	            return _vm.deleteActiveDatePicker(student)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (student.published_until && _vm.theActiveDatePickerId !== student.id) ? _c('div', {
	        staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	      }, [_c('div', {
	        staticClass: "datepicker-input pointer pos-relative",
	        on: {
	          "click": function($event) {
	            return _vm.setActiveDatePicker(student)
	          }
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (student.v_formatted_date),
	          expression: "student.v_formatted_date"
	        }],
	        attrs: {
	          "type": "text",
	          "readonly": ""
	        },
	        domProps: {
	          "value": (student.v_formatted_date)
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(student, "v_formatted_date", $event.target.value)
	          }
	        }
	      }), _vm._v(" "), _c('div', {
	        staticClass: "icon-calendar4 input-icon"
	      })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            onShow: _vm.hideTippy,
	            trigger: 'manual',
	            arrow: true,
	            placement: 'top',
	            zIndex: 2147483010
	          }),
	          expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	        }],
	        staticClass: "bttn bttn--white bttn--small",
	        attrs: {
	          "content": _vm.i18n[_vm.locale]['copied'] + ' ' + student.v_ical_link
	        },
	        on: {
	          "click": function($event) {
	            return _vm.copyToClipboard(student.v_ical_link, $event)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n              ")])])]) : _vm._e()
	    })]
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowRooms = !_vm.isShowRooms
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowRooms
	    }, {
	      'icon-arrow-down': !_vm.isShowRooms
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.roomCalendarsWithProps.length) + "\n          " + _vm._s(_vm.roomCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['rooms'] : _vm.i18n[_vm.locale]['room']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowRooms) ? [(_vm.isToggleLoading === 'rooms') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllRoomCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyRoomCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowRooms) ? _c('tbody', [(_vm.roomCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_rooms_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.roomCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-location"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowUsers = !_vm.isShowUsers
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowUsers
	    }, {
	      'icon-arrow-down': !_vm.isShowUsers
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.userCalendarsWithProps.length) + "\n          " + _vm._s(_vm.userCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['users'] : _vm.i18n[_vm.locale]['user']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowUsers) ? [(_vm.isToggleLoading === 'users') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllUsersCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyUserCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowUsers) ? _c('tbody', [(_vm.userCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-location"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowMergeCalendars = !_vm.isShowMergeCalendars
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowMergeCalendars
	    }, {
	      'icon-arrow-down': !_vm.isShowMergeCalendars
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.mergeCalendarsWithProps.length) + "\n          " + _vm._s(_vm.mergeCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['merge_calendars'] : _vm.i18n[_vm.locale]['merge_calendar']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowMergeCalendars) ? [(_vm.isToggleLoading === 'merge') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllMergeCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyMergeCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowMergeCalendars) ? _c('tbody', [(_vm.mergeCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_merge_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mergeCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowOtherCalendars = !_vm.isShowOtherCalendars
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowOtherCalendars
	    }, {
	      'icon-arrow-down': !_vm.isShowOtherCalendars
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.otherCalendarsWithProps.length) + "\n          " + _vm._s(_vm.otherCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['other'] : _vm.i18n[_vm.locale]['other']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowOtherCalendars) ? [(_vm.isToggleLoading === 'other') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllOtherCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyOtherCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowOtherCalendars) ? _c('tbody', [(_vm.otherCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_other_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.otherCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('thead', {
	    staticClass: "d-table__header d-table__header__first"
	  }, [_c('th', {
	    staticClass: "th-hover",
	    on: {
	      "click": function($event) {
	        _vm.isShowClubCalendars = !_vm.isShowClubCalendars
	      }
	    }
	  }, [_c('span', {
	    staticClass: "marg-1-right",
	    class: [{
	      'icon-arrow-up': _vm.isShowClubCalendars
	    }, {
	      'icon-arrow-down': !_vm.isShowClubCalendars
	    }]
	  }), _vm._v("\n          " + _vm._s(_vm.clubCalendarsWithProps.length) + "\n          " + _vm._s(_vm.clubCalendarsWithProps.length !== 1 ? _vm.i18n[_vm.locale]['club'] : _vm.i18n[_vm.locale]['club']) + "\n        ")]), _vm._v(" "), _c('th', {
	    staticClass: "toggle-all-calendars"
	  }, [(_vm.isShowClubCalendars) ? [(_vm.isToggleLoading === 'club') ? _c('loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleAllClubCalendars.apply(null, arguments)
	      }
	    }
	  }, [(_vm.isAnyClubCalendarsWithAnonymousAccess) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unselect']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['all']) + "\n            ")])] : _vm._e()], 2), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), (_vm.isShowClubCalendars) ? _c('tbody', [(_vm.clubCalendarsWithProps.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "padding": "8px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_club_created']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.clubCalendarsWithProps), function(calendar) {
	    return _c('tr', {
	      key: calendar.id
	    }, [_c('td', [_c('span', {
	      staticClass: "icon-clipboard2"
	    }), _vm._v(" " + _vm._s(calendar.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "inline-block",
	      on: {
	        "click": function($event) {
	          return _vm.toggleAnonymousAccess(calendar)
	        }
	      }
	    }, [_c('app-toggle', {
	      attrs: {
	        "prop-on": calendar.anonymous_access,
	        "allow-changes": false
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(calendar.anonymous_access) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_public_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_public_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_calendar_link']) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(!calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__no-end-date"
	    }, [_c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_end_date']))]), _vm._v(" "), _c('div', {
	      staticClass: "hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['set_a_date']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "icon__bg-circle"
	    }, [_c('span', {
	      staticClass: "icon-calendar4"
	    })])])]) : _vm._e(), _vm._v(" "), (_vm.theActiveDatePickerId === calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container"
	    }, [_c('DateSelector', {
	      staticStyle: {
	        "width": "210px"
	      },
	      attrs: {
	        "date": _vm.theActiveDatePickerDate,
	        "isOpen": true
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.updatePublishUntilDate(calendar, $event)
	        },
	        "close": function($event) {
	          return _vm.closeDatepicker(calendar)
	        }
	      }
	    }), _vm._v(" "), (calendar.published_until) ? _c('button', {
	      staticClass: "bttn bttn-danger calendar__datepicker-container__button",
	      on: {
	        "click": function($event) {
	          return _vm.deleteActiveDatePicker(calendar)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['remove_end_date']) + "\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (calendar.published_until && _vm.theActiveDatePickerId !== calendar.id) ? _c('div', {
	      staticClass: "calendar__datepicker-container calendar__datepicker-container--has-date"
	    }, [_c('div', {
	      staticClass: "datepicker-input pointer pos-relative",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDatePicker(calendar)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (calendar.v_formatted_date),
	        expression: "calendar.v_formatted_date"
	      }],
	      attrs: {
	        "type": "text",
	        "readonly": ""
	      },
	      domProps: {
	        "value": (calendar.v_formatted_date)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(calendar, "v_formatted_date", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "icon-calendar4 input-icon"
	    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  onShow: hideTippy,\n                  trigger: 'manual',\n                  arrow: true,\n                  placement : 'top',\n                  zIndex: 2147483010\n                }"
	      }],
	      staticClass: "bttn bttn--white bttn--small",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['copied'] + ' ' + calendar.v_ical_link
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyToClipboard(calendar.v_ical_link, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['copy_ical_link']) + "\n            ")])])])
	  })], 2) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), _c('export-calendar', {
	    attrs: {
	      "isShowButton": false,
	      "isShowFromProp": _vm.isShowICalGuide
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowICalGuide(false)
	      }
	    }
	  }), _vm._v(" "), _c('CalendarOnMobileGuides', {
	    attrs: {
	      "isShowFromProp": _vm.isShowMobileGuide
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowMobileGuide(false)
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid grid-pad box-size subs-today-grid"
	  }, [_c('div', {
	    staticClass: "subs-today text-dark"
	  }, [_c('div', {
	    staticClass: "subs-today__header"
	  }, [(_vm.isSubsToday) ? _c('h1', [_vm._v(_vm._s(_vm.substitutesToday.length) + " " + _vm._s(_vm.i18n[_vm.locale]['subs']) + ", "), _c('span', {
	    staticClass: "headline-date"
	  }, [_vm._v(_vm._s(_vm.formattedDayDate))])]) : _c('h1', [_vm._v(_vm._s(_vm.absentToday.length) + " " + _vm._s(_vm.i18n[_vm.locale]['absent']) + ", "), _c('span', {
	    staticClass: "headline-date"
	  }, [_vm._v(_vm._s(_vm.formattedDayDate))])]), _vm._v(" "), _c('div', {
	    staticClass: "subs-today__header__right no-print"
	  }, [_c('button', {
	    staticClass: "date-buttons marg-5-right",
	    class: {
	      'bttn--disabled': _vm.getIsToday
	    },
	    on: {
	      "click": _vm.setToday
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['today']) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "date-buttons marg-5-right",
	    on: {
	      "click": _vm.prevDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  })]), _vm._v(" "), _c('DatePicker', {
	    attrs: {
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "marg-5-left date-buttons",
	    on: {
	      "click": _vm.nextDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  })]), _vm._v(" "), (_vm.isSubsToday) ? _c('button', {
	    staticClass: "marg-1-left",
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['download']) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "marg-1-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "marg-1-left marg-1-right",
	    on: {
	      "click": _vm.startSlider
	    }
	  }, [(_vm.isSlider) ? _c('span', {
	    staticClass: "icon-shrink7"
	  }) : _c('span', {
	    staticClass: "icon-enlarge2"
	  })])], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _vm._e(), _vm._v(" "), (_vm.isSubsToday && !_vm.isLoading && _vm.substitutesToday.length < 1) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_subs_today']) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isSubsToday && !_vm.isLoading && _vm.absentToday.length < 1) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_one_absent_today']) + "\n    ")]) : _c('div', {
	    staticClass: "users-today__container"
	  }, [_vm._l((_vm.usersInArraysSlider), function(userRow, key) {
	    return (!_vm.isSlider || key === _vm.theSliderIndex) ? _c('div', {
	      staticClass: "subs-grid"
	    }, _vm._l((userRow), function(user) {
	      return _c('div', {
	        key: user.id,
	        staticClass: "subs-today__sub",
	        attrs: {
	          "data-user-id": user.id
	        }
	      }, [_c('h3', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _vm._l((user.absence), function(absence) {
	        return _c('p', {
	          staticClass: "subs-today__sub__absence"
	        }, [_vm._v(_vm._s(absence.title) + " -\n            " + _vm._s(absence.timeFormatted) + "\n          ")])
	      }), _vm._v(" "), (user.events.length < 1) ? _c('p', {
	        staticClass: "text-explainer marg-1-top"
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_lessons_effected']))]) : _vm._e(), _vm._v(" "), (user.events.length > 0) ? _c('table', {
	        staticClass: "d-table"
	      }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['course']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['grade']))]), _vm._v(" "), (_vm.isShowRooms) ? _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['room']))]) : _vm._e(), _vm._v(" "), _c('th', {
	        class: {
	          'd-table__subs-for': !_vm.isShowRooms
	        }
	      }, [(!_vm.isSubsToday) ? [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sub']))] : [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sub_for']))]], 2)]), _vm._v(" "), _c('tbody', _vm._l((user.events), function(event) {
	        return _c('tr', {
	          key: event.id
	        }, [_c('td', [_c('div', {
	          staticClass: "subs-today__event-title"
	        }, [_vm._v(_vm._s(event.title))]), _vm._v("\n                " + _vm._s(event.timeFormatted) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.grades))]), _vm._v(" "), (_vm.isShowRooms) ? _c('td', [_vm._v(_vm._s(event.rooms))]) : _vm._e(), _vm._v(" "), _c('td', [(!_vm.isSubsToday) ? [_vm._v(_vm._s(event.substitute))] : [_vm._v(_vm._s(event.substitute_for))]], 2)])
	      }), 0)]) : _vm._e()], 2)
	    }), 0) : _vm._e()
	  }), _vm._v(" "), (_vm.isSlider) ? _c('div', {
	    staticClass: "users-today__slider-pager marg-2-top"
	  }, [_c('p', [_vm._v(_vm._s(_vm.theSliderIndex + 1) + " / " + _vm._s(_vm.userInRows.length))]), _vm._v(" "), (_vm.userInRows.length > 1) ? _c('div', {
	    staticClass: "d-progress"
	  }, [_c('div', {
	    staticClass: "d-progress__bar",
	    style: ({
	      'width': _vm.animatePercentage
	    })
	  })]) : _vm._e()]) : _vm._e()], 2)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": '5Id4TeuHMvI',
	      "textForLink": "Guide: Se videoguide for kompetenceindberetning i Docendo"
	    }
	  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-filters"
	  }, [_c('div', {
	    staticClass: "d-filters__filter",
	    class: {
	      'd-filters__filter--active': _vm.activeUserFilter === 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeUserFilter = 0
	      }
	    }
	  }, [_vm._v("Indberettes\n      "), _c('div', {
	    staticClass: "d-pill"
	  }, [_vm._v(_vm._s(_vm.filledUsers.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-filters__filter",
	    class: {
	      'd-filters__filter--active': _vm.activeUserFilter === 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeUserFilter = 1
	      }
	    }
	  }, [_vm._v("Indberettes ikke\n      "), _c('div', {
	    staticClass: "d-pill"
	  }, [_vm._v(_vm._s(_vm.unfilledUsers.length))])])]), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "d-table__sorter d-table__name",
	    class: {
	      'd-table__sorter--active': _vm.sortProperty === 'name'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortProperty('name')
	      }
	    }
	  }, [_vm._v("Navn "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "d-table__sorter",
	    class: {
	      'd-table__sorter--active': _vm.sortProperty === 'v_stil_stilling'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortProperty('v_stil_stilling')
	      }
	    }
	  }, [_vm._v("Stilling "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', [_vm._v("CPR")]), _vm._v(" "), _c('th', [_vm._v("Kompetencer: (L: Linjefag, K: Tilsvarende kompetencer)")])])]), _vm._v(" "), _c('tbody', [(_vm.filteredUsersWithVProps.length < 1) ? _c('tr', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedUsers), function(user, userIdx) {
	    return _c('tr', {
	      key: user.id
	    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_stilling),
	        expression: "user.v_stil_stilling"
	      }],
	      staticClass: "timetal-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(user, "v_stil_stilling", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updateUser(user, 'stil_stilling', $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "LA"
	      }
	    }, [_vm._v("Lærer")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "BH"
	      }
	    }, [_vm._v("Børnehaveklasseleder")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "PA"
	      }
	    }, [_vm._v("Pædagog")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "LE"
	      }
	    }, [_vm._v("Leder")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "AN"
	      }
	    }, [_vm._v("Andre med undervisningsopgaver")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "KO"
	      }
	    }, [_vm._v("Konsulenter")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "undtaget"
	      }
	    }, [_vm._v("Ingen undervisningsopgaver (ikke indberet)")])])]), _vm._v(" "), _c('td', [_c('input', {
	      staticStyle: {
	        "width": "110px"
	      },
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": user.v_ssn
	      },
	      on: {
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.updateUser(user, 'ssn', $event.target.value, true)
	        },
	        "blur": function($event) {
	          return _vm.updateUser(user, 'ssn', $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('div', {
	      staticStyle: {
	        "width": "400px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.theEditUserId = user.id
	        }
	      }
	    }, [(user.v_isTheEditUser) ? _c('DSelect', {
	      attrs: {
	        "show": true,
	        "items": _vm.standardSubjectsWithVProps,
	        "itemsSelected": user.v_competencies,
	        "placeholder": "Tilføj kompetence"
	      },
	      on: {
	        "close": function($event) {
	          _vm.theEditUserId = null
	        },
	        "update": function($event) {
	          return _vm.updateSubjectOnUser($event, user)
	        }
	      }
	    }) : _c('ul', {
	      staticClass: "linjefag linjefag--not-empty",
	      staticStyle: {
	        "width": "400px"
	      }
	    }, [(user.v_competencies.length === 0) ? _c('li', {
	      staticClass: "linjefag__add"
	    }, [_vm._v("\n              Tilføj op til seks kompetencer\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((user.v_competencies), function(subject) {
	      return _c('li', {
	        staticClass: "d-pill"
	      }, [_vm._v("\n              " + _vm._s(subject.name) + "\n            ")])
	    })], 2)], 1)])])
	  })], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-explainer"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://statistik.uni-c.dk/linjefag/Dokumentation/Generelvejledning2025.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n        Link til STIL's egen vejledning")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Linjefag (L):")]), _vm._v(" At have undervisningskompetence i et fag betyder, at underviseren har haft det\n        pågældende fag som linjefag på læreruddannelsen eller som ekstra linjefag på et senere tidspunkt.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Tilsvarende kompetence (K):")]), _vm._v(" At have kompetence svarende til undervisningskompetence betyder, at\n        underviseren for eksempel har en efteruddannelse, videreuddannelse, kompetencegivende uddannelse eller et\n        længerevarende kursusforløb, der vurderes at give kompetence svarende til undervisningskompetence.")]), _vm._v(" "), _c('p', [_vm._v("Skolens leder må foretage et skøn i denne forbindelse. En underviser kan samlet set maks. have\n        kompetencer (undervisningskompetence og tilsvarende\n        kompetence) i seks fag")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Ikke indberet person:")]), _vm._v(" Personale der ikke skal indberettes sættes til stillingen \"Ingen\n        undervisningsopgaver (ikke indberet)\"")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen skal ikke indberetes")])])
	}]}

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "students text-dark"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isShowModal = true
	      }
	    }
	  }, [_vm._v(" " + _vm._s(_vm.isEditSubject) + " " + _vm._s(_vm.studentCalendarIds.length) + " " + _vm._s(_vm.$t('vue2.students.of')) + " " + _vm._s(_vm.klassStudents.length) + " " + _vm._s(_vm.$t('vue2.students.students')) + "\n  ")]), _vm._v(" "), (_vm.isShowModal) ? _c('DModal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__students",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.studentsSelected.length) + " " + _vm._s(_vm.$t('vue2.students.of')) + " " + _vm._s(_vm.klassStudents.length) + "\n          " + _vm._s(_vm.$t('vue2.students.students_in')) + " 1.a")]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": _vm.closeStudentModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-modal__content__add-student"
	  }, [_c('transition-group'), _vm._v(" "), (!_vm.isAddStudentFromAnotherGroup) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": function($event) {
	        _vm.isAddStudentFromAnotherGroup = true
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.students.add_student')))]) : _c('DSelect', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "items": _vm.studentsFromOtherGroups,
	      "itemsSelected": [],
	      "placeholder": _vm.$t('vue2.students.add_student'),
	      "showSelectedUsers": false
	    },
	    on: {
	      "add": function($event) {
	        return _vm.addStudentToSubject($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "students__student__header border-1-bottom border-1-top"
	  }, [_c('p', {
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [(_vm.studentsSelected.length === _vm.klassStudents.length) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.unselect_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.select_all')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "border-1-bottom"
	  }, [_c('ul', {
	    staticClass: "students students__list"
	  }, _vm._l((_vm.studentsSorted), function(student) {
	    return _c('li', {
	      staticClass: "students__student",
	      on: {
	        "click": function($event) {
	          return _vm.toggleInStudentsSelected(student.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "students__student__name"
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': _vm.isInStudentsSelected(student.id)
	      }
	    }), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(student.name) + "\n                ")])]), _vm._v(" "), _c('div', {
	      staticClass: "student__grade"
	    }, _vm._l((_vm.getStudentKlasses(student)), function(klass, key) {
	      return _c('span', [(key > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" " + _vm._s(klass.name))])
	    }), 0)])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-1-right",
	    on: {
	      "click": _vm.closeStudentModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-button__multiple no-print"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-left4 no-print",
	    attrs: {
	      "content": _vm.tooltipArrowLeft
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('prev')
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "no-print do-button__multiple__bttn",
	    class: {
	      'bttn--disabled': _vm.isToday
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('today')
	      }
	    }
	  }, [_vm._v("\n    I dag\n  ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-right4 ",
	    attrs: {
	      "content": _vm.tooltipArrowRight
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('next')
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-cal__subjects no-print",
	    class: {
	      'd-cal__subjects--dragging': _vm.isDraggingSubject
	    },
	    on: {
	      "pointerenter": _vm.onMouseEnter,
	      "pointerleave": _vm.onMouseLeave
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.deleteSubject) ? _c('div', {
	    staticClass: "d-cal__subjects--trashcan",
	    class: {
	      'd-cal__subjects--trashcan--hovered': _vm.isDCalATrashcan
	    }
	  }, [_c('div', {
	    staticClass: "icon-bin"
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.common.delete')) + " " + _vm._s(_vm.deleteSubject.title))])]) : _vm._e()]), _vm._v(" "), _c('CreateSubject', {
	    attrs: {
	      "calendarId": _vm.calendarId,
	      "isInDCalendar": true
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__subjects__container"
	  }, [(_vm.isShowImportSubjectsOption) ? _c('ImportSubjectsToKlass', {
	    attrs: {
	      "calendarId": _vm.calendarId
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSubjectsLoading) ? _c('Loader', {
	    staticClass: "d-cal__subjects__container__loader",
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "d-acc"
	  }, _vm._l((_vm.subjectsInCategoriesSorted), function(subjectsCat) {
	    return _c('li', {
	      key: subjectsCat.type,
	      staticClass: "d-acc__container",
	      class: {
	        'd-acc__container--closed': _vm.theActiveAcc !== subjectsCat.type
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheActiveAcc(subjectsCat.type)
	        }
	      }
	    }, [_c('h4', [_vm._v(_vm._s(subjectsCat.v_title))]), _vm._v(" "), _c('transition', {
	      attrs: {
	        "name": "accordion"
	      },
	      on: {
	        "enter": _vm.startTrans,
	        "after-enter": _vm.endTrans,
	        "before-leave": _vm.startTrans,
	        "after-leave": _vm.endTrans
	      }
	    }, [(_vm.theActiveAcc === subjectsCat.type) ? _c('div', [_c('transition-group', {
	      staticClass: "d-acc__container__body",
	      attrs: {
	        "name": "list-complete",
	        "tag": "ul"
	      }
	    }, _vm._l((_vm.activeSubjects), function(subject) {
	      return _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: (_vm.tippySettings(subject)),
	          expression: "tippySettings(subject)"
	        }],
	        key: subject.id,
	        staticClass: "list-complete-item d-cal__subjects__subject",
	        class: {
	          'd-cal__subjects__subject--not-editable': !subject.v_is_editable
	        },
	        style: ([{
	            'borderColor': subject.color
	          },
	          {
	            'backgroundColor': subject.color
	          }
	        ]),
	        attrs: {
	          "subject": subject,
	          "content": _vm.tippyContent(subject),
	          "draggable": "false"
	        },
	        on: {
	          "dragstart": function($event) {
	            $event.preventDefault();
	          },
	          "click": function($event) {
	            $event.preventDefault();
	            $event.stopPropagation();
	          },
	          "pointerdown": function($event) {
	            $event.preventDefault();
	            return _vm.onMouseDown(subject, $event)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "d-cal__subjects__subject__left"
	      }, [_vm._v("\n                  " + _vm._s(subject.title) + "\n                ")]), _vm._v(" "), _c('div', {
	        staticClass: "d-cal__subjects__subject__right"
	      }, [(subject.v_must_have_teacher && subject.v_cal_types.users.length < 1) ? _c('div', {
	        staticClass: "subject-draggable__slider"
	      }, [_c('div', {
	        staticClass: "d-cal__subjects__subject__subject_info"
	      }, [_vm._v("\n                      " + _vm._s(subject.v_hours) + _vm._s(_vm.i18n[_vm.locale]['hours_per_year']) + "\n                    ")]), _vm._v(" "), _c('div', {
	        staticClass: "d-cal__subjects__subject__remember-teacher"
	      }, [_c('span', {
	        staticClass: "icon-user3"
	      }), _vm._v(_vm._s(_vm.i18n[_vm.locale]['add']) + "\n                    ")])]) : _c('div', {
	        staticClass: "d-cal__subjects__subject__subject_info"
	      }, [(subject.v_hours) ? [_vm._v(_vm._s(subject.v_hours) + _vm._s(_vm.i18n[_vm.locale]['hours_per_year']) + "\n                    ")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	        staticClass: "subject__details"
	      }, [(subject.v_cal_types.rooms.length > 0) ? _c('span', {
	        staticClass: "icon-location"
	      }) : _vm._e(), _vm._v(" "), (subject.v_cal_types.users.length > 0) ? _c('span', {
	        staticClass: "icon-user"
	      }) : _vm._e()])])
	    }), 0)], 1) : _vm._e()])], 1)
	  }), 0)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sub-salary"
	  }, [_c('div', {
	    staticClass: "sub-salary__header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "sub-salary__header__left"
	  }, [_vm._m(1), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--with-icon",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowSalarySettings(true)
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "mr-2 h-4 w-4",
	    attrs: {
	      "width": "15",
	      "height": "15",
	      "viewBox": "0 0 15 15",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
	      "fill": "currentColor",
	      "fill-rule": "evenodd",
	      "clip-rule": "evenodd"
	    }
	  })]), _vm._v("\n        Opsætning\n      ")]), _vm._v(" "), (_vm.isSchoolSelectorOn) ? _c('SchoolsSelector', {
	    attrs: {
	      "permission": _vm.permission,
	      "schools": _vm.userSchools,
	      "selectedSchoolIds": _vm.selectedSchoolIds
	    },
	    on: {
	      "toggleSchool": _vm.toggleSchool
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DoDatePickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "dateShortCutsProps": _vm.dateShortCuts,
	      "maximumDateRange": 89
	    },
	    on: {
	      "startChanged": _vm.startDateChanged,
	      "endChanged": _vm.endDateChanged
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "sub-salary__sub-header"
	  }, [_c('SalaryFilters', {
	    attrs: {
	      "activeFilter": _vm.activeFilter,
	      "userDaysSorted": _vm.userDaysSorted,
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setFilter($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "sub-salary__body"
	  }, [(_vm.isLoading) ? _c('Loader') : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.usersAndEventsFiltered.length < 1) ? _c('h2', {
	    staticClass: "text-explainer marg-1-top"
	  }, [(_vm.selectedSchoolIds.length > 0) ? [_vm._v("Ingen vikartimer i perioden")] : [_vm._v("Ingen skoler valgt")]], 2) : [_c('ul', {
	    staticClass: "user-list"
	  }, _vm._l((_vm.usersPackedInDaysWithProps), function(user) {
	    return _c('li', {
	      staticClass: "user-list__user"
	    }, [_c('div', {
	      staticClass: "user-list__user__header"
	    }, [_c('h4', [_vm._v(_vm._s(user.v_user_name) + "\n            ")]), _vm._v(" "), _c('div', {
	      staticClass: "user-list__user__header__right"
	    }, [_c('ul', _vm._l((user.v_user_sums), function(sum) {
	      return _c('li', {
	        key: sum.employment_id,
	        class: {
	          'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
	        }
	      }, [_vm._v("\n                  " + _vm._s(sum.employment_title) + ": "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))])])
	    }), 0), _vm._v(" "), _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	      }],
	      staticClass: "do-bttn do-bttn--small no-print",
	      attrs: {
	        "content": "Se alle dage på personen"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveUserId(user.user_id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-enlarge2"
	    })])])]), _vm._v(" "), _vm._l((user.days), function(userDay) {
	      return _c('table', {
	        key: userDay.day,
	        staticClass: "user-list__user__table",
	        class: {
	          'user-list__user__table--active': userDay.v_is_open
	        }
	      }, [_c('thead', {
	        on: {
	          "click": function($event) {
	            return _vm.setTheActiveUserDay(userDay)
	          }
	        }
	      }, [_c('tr', [_c('th', [_vm._v(_vm._s(userDay.v_date_formatted) + "\n                "), (userDay.error && Object.keys(userDay.error).length) ? _c('span', {
	        staticClass: "do-pill do-pill--yellow"
	      }, [_vm._v("\n                  Overførselsfejl\n                ")]) : _vm._e()]), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Kalender")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Type")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Vikar for")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Ansættelse")]) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive && userDay.v_is_open) ? _c('th', [_vm._v("Lønkode")]) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive && userDay.v_is_open) ? _c('th', [_vm._v("Løbenummer")]) : _vm._e(), _vm._v(" "), _c('th', {
	        staticClass: "user-list__user__table__arrow"
	      }, [(userDay.v_unfilled) ? _c('svg', {
	        staticClass: "tw-icon tw-icon--red",
	        attrs: {
	          "viewBox": "0 0 24 24",
	          "fill": "none",
	          "stroke": "currentColor",
	          "stroke-width": "2",
	          "stroke-linecap": "round",
	          "stroke-linejoin": "round"
	        }
	      }, [_c('path', {
	        attrs: {
	          "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	        }
	      }), _vm._v(" "), _c('line', {
	        attrs: {
	          "x1": "12",
	          "y1": "9",
	          "x2": "12",
	          "y2": "13"
	        }
	      }), _vm._v(" "), _c('line', {
	        attrs: {
	          "x1": "12",
	          "y1": "17",
	          "x2": "12.01",
	          "y2": "17"
	        }
	      })]) : _vm._e(), _vm._v(" "), (!userDay.v_is_open) ? _c('span', {
	        staticClass: "icon-arrow-up4"
	      }) : _c('span', {
	        staticClass: "icon-arrow-down4"
	      })])])]), _vm._v(" "), (userDay.v_is_open) ? [_c('SalarySubsPerfUserDay', {
	        attrs: {
	          "user": user,
	          "userDay": userDay,
	          "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	        },
	        on: {
	          "updatePropOnLesson": _vm.updatePropOnLesson
	        }
	      }), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	        attrs: {
	          "colspan": _vm.isSalaryIntegrationActive ? 8 : 6
	        }
	      }, [_c('div', {
	        staticClass: "user-list__user__footer"
	      }, [_vm._l((_vm.parseUserErrors(userDay.error)), function(error, index) {
	        return (userDay.error) ? _c('span', {
	          key: index,
	          staticClass: "do-pill do-pill--yellow do-pill--with-icon"
	        }, [_c('svg', {
	          staticClass: "tw-icon tw-icon--yellow",
	          attrs: {
	            "viewBox": "0 0 24 24",
	            "fill": "none",
	            "stroke": "currentColor",
	            "stroke-width": "2",
	            "stroke-linecap": "round",
	            "stroke-linejoin": "round"
	          }
	        }, [_c('path', {
	          attrs: {
	            "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	          }
	        }), _vm._v(" "), _c('line', {
	          attrs: {
	            "data-v-050a44fb": "",
	            "x1": "12",
	            "y1": "9",
	            "x2": "12",
	            "y2": "13"
	          }
	        }), _vm._v(" "), _c('line', {
	          attrs: {
	            "x1": "12",
	            "y1": "17",
	            "x2": "12.01",
	            "y2": "17"
	          }
	        })]), _vm._v("\n                      " + _vm._s(error) + "\n                    ")]) : _vm._e()
	      }), _vm._v(" "), _c('ul', {
	        staticClass: "user-list__user__footer__sums"
	      }, _vm._l((userDay.v_sums), function(sum) {
	        return _c('li', {
	          key: sum.employment_id,
	          class: {
	            'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
	          }
	        }, [_vm._v("\n                        " + _vm._s(sum.employment_title) + ": "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))]), _vm._v(" "), _c('button', {
	          directives: [{
	            name: "tippy",
	            rawName: "v-tippy",
	            value: ({
	              onShow: _vm.hideTippy,
	              trigger: 'manual',
	              arrow: true,
	              placement: 'top',
	              zIndex: 2147483010
	            }),
	            expression: "{\n                                  onShow: hideTippy,\n                                  trigger: 'manual',\n                                  arrow: true,\n                                  placement : 'top',\n                                  zIndex: 2147483010\n                                }"
	          }],
	          staticClass: "bttn bttn--white bttn--small do-copy-bttn",
	          attrs: {
	            "content": 'Kopieret ' + sum.minutes_to_copy
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              $event.preventDefault();
	              return _vm.copyToClipboard(sum.minutes_to_copy, $event)
	            }
	          }
	        }, [_c('svg', {
	          attrs: {
	            "xmlns": "http://www.w3.org/2000/svg",
	            "height": "48",
	            "viewBox": "0 0 48 48",
	            "width": "48"
	          }
	        }, [_c('path', {
	          attrs: {
	            "d": "M0 0h48v48h-48z",
	            "fill": "none"
	          }
	        }), _vm._v(" "), _c('path', {
	          attrs: {
	            "d": "M32 2h-24c-2.21 0-4 1.79-4 4v28h4v-28h24v-4zm6 8h-22c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4zm0 32h-22v-28h22v28z"
	          }
	        })])])])
	      }), 0), _vm._v(" "), (userDay.state === 'approved') ? _c('div', {
	        staticClass: "submit-buttons"
	      }, [_c('button', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            animateFill: false,
	            animation: 'shift-away',
	            zIndex: '999999992',
	            boundary: 'window'
	          }),
	          expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window'\n                        }"
	        }],
	        staticClass: "do-bttn do-bttn--danger",
	        attrs: {
	          "content": 'Dagen vil blive genberegnet'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.unApproveDay(userDay)
	          }
	        }
	      }, [_vm._v("\n                        Fortryd godkendelse\n                      ")]), _vm._v(" "), _c('button', {
	        staticClass: "do-bttn do-bttn--submit",
	        on: {
	          "click": function($event) {
	            return _vm.changeStateIsSent(userDay)
	          }
	        }
	      }, [_vm._v("\n                        " + _vm._s(_vm.isSalaryIntegrationActive ? 'Send til lønsystem' : 'Er indberettet') + "\n                      ")])]) : _vm._e(), _vm._v(" "), (userDay.state === 'draft') ? [(_vm.getIsDayValidated(userDay)) ? _c('button', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            animateFill: false,
	            animation: 'shift-away',
	            zIndex: '999999992',
	            boundary: 'window'
	          }),
	          expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window'\n                        }"
	        }],
	        staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled",
	        attrs: {
	          "content": 'Du skal vælge ansættelse på hver lektion'
	        }
	      }, [_vm._v("\n                        Godkend\n                      ")]) : _c('button', {
	        staticClass: "do-bttn do-bttn--submit",
	        class: {
	          'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
	        },
	        on: {
	          "click": function($event) {
	            return _vm.approveDay(userDay)
	          }
	        }
	      }, [_vm._v("Godkend\n                      ")])] : _vm._e()], 2)])])])] : _vm._e()], 2)
	    })], 2)
	  }), 0)]], 2), _vm._v(" "), (_vm.activeUserId) ? _c('SalarySubsPerfUser', {
	    attrs: {
	      "activeUserId": _vm.activeUserId,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "usersPackedInDaysWithProps": _vm.usersPackedInDaysWithProps,
	      "userDaysSorted": _vm.userDaysSorted,
	      "activeFilter": _vm.activeFilter,
	      "theUserDaySubmitting": _vm.theUserDaySubmitting,
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
	      "salaryCodes": _vm.salaryCodes,
	      "loebenummer": _vm.loebenummer,
	      "costCenters": _vm.costCenters,
	      "schoolId": _vm.schoolId
	    },
	    on: {
	      "updatePropOnLesson": _vm.updatePropOnLesson,
	      "setFilter": function($event) {
	        return _vm.setFilter($event)
	      },
	      "approveDay": function($event) {
	        return _vm.approveDay($event)
	      },
	      "unApproveDay": function($event) {
	        return _vm.unApproveDay($event)
	      },
	      "changeStateIsSent": function($event) {
	        return _vm.changeStateIsSent($event)
	      },
	      "close": function($event) {
	        return _vm.setActiveUserId(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowSalarySettings) ? _c('SalarySettings', {
	    attrs: {
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "update": _vm.onUpdate,
	      "close": function($event) {
	        return _vm.setIsShowSalarySettings(false)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sub-salary__header__left"
	  }, [_c('h1', [_vm._v("Vikarløn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "do-bttn do-bttn--with-icon",
	    attrs: {
	      "href": "https://docendohelp.crisp.help/da/article/vikarlon-1b1x6yz/",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "icon-question3"
	  }), _vm._v("\n        Guide\n      ")])
	}]}

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    staticClass: "icon-logo-docendo",
	    attrs: {
	      "enable-background": "new 16.5 363.8 484.1 110.9",
	      "viewBox": "16.5 363.8 484.1 110.9",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "m118 473.3c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.6-15.2 11.3-26.9 11.3zm2.9-10.1c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.5 13.6 7.5zm71.7 10.7c-12.4 0-21.2-2.6-26.4-7.8s-7.8-14.1-7.8-26.7c0-13.9 3.3-24.5 9.9-31.9 6.6-7.3 16.6-11 30.1-11 6.6 0 11.4.6 14.3 1.8 3 1.2 4.5 3.1 4.5 5.5 0 3-1.1 5.9-3.2 8.6-7.5-3.9-14-5.9-19.3-5.9-7 0-11.9 2.2-14.9 6.7-2.9 4.4-4.4 11.4-4.4 20.9 0 9.8 1.4 17.1 4.3 22.1s8.1 7.4 15.7 7.4c5.8 0 12.5-1.9 20.1-5.8 1.7 2.3 2.5 4.7 2.5 7.1 0 2.9-2.6 5.1-7.8 6.6-5.2 1.6-11.1 2.4-17.6 2.4zm61.2-77.7c9.3 0 16.3 2.2 20.8 6.6s6.8 11.7 6.8 21.9c0 4.5-.8 7.6-2.4 9.3-1.6 1.8-5.1 2.6-10.6 2.6h-33.3c.1 8.2 1.7 14.6 4.9 19.3s8.8 7 16.9 7c7.5 0 14.6-2 21-5.9 2.2 2.2 3.2 4.4 3.2 6.9 0 3.4-2.8 5.7-8.3 7.1-5.6 1.4-11.8 2-18.8 2-12.9 0-22.1-2.7-27.7-8.2s-8.4-14.6-8.4-27.6c0-12.7 3.2-22.8 9.5-30.1 6.4-7.2 15.1-10.9 26.4-10.9zm-2.9 10.1c-5 0-8.8 1.8-11.5 5.4-2.6 3.6-4 9.2-4.3 16.9h7.8c8.2 0 13.9-.2 16.9-.5s4.7-.9 5.2-1.6c.5-.8.7-2.2.7-4.2 0-5-1.3-8.9-3.8-11.7-2.5-2.9-6.1-4.3-11-4.3zm56.5.9c5-3.3 9.9-5.8 14.7-7.3 4.9-1.6 9.2-2.3 13-2.3 6.7 0 11.7 1.5 15.1 4.6s5.1 9 5.1 17.7c0 27 .4 41.4 1.2 43s2.6 2.4 5.4 2.3c.6 1.5.8 2.9.8 4.4 0 1.4-.4 2.3-1.3 2.7-.9.5-2.4.7-4.8.7-7 0-11.3-.1-12.8-.3-1.6-.2-2.6-.7-3.2-1.6s-.8-2.3-.8-4.4v-32.5c0-10.4-1.1-17.2-3.3-20.7-2.2-3.4-5.7-5.1-10.6-5.1-4.2 0-7.8 1.2-10.8 3.5s-4.6 6.6-4.6 12.7v15.9c0 8.9.2 17.1.5 24.6h8.4c.6 1.3.9 2.7.9 4.2 0 1.4-.3 2.3-.8 2.8-.6.5-1.6.8-3.2.8h-29.6c-.7-1.6-1-3.1-1-4.5 0-1.1.3-1.9.8-2.5.6-.5 1.5-.8 2.7-.8h5.2c.4-8 .6-17.8.6-29.4 0-14.8-.6-23.4-1.7-25.8-1.2-2.4-3.4-3.5-6.6-3.5-.7-1.4-1-2.9-1-4.4 0-1.4.5-2.2 1.6-2.6s7.7-.8 20-1.2c.4 2.4.4 5.3.1 9zm156.5 66.7c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.5-15.2 11.3-26.9 11.3zm2.9-10.2c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.6 13.6 7.5zm-422.3 10.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7zm352.3 18.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7z"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-table-container"
	  }, [_c('table', {
	    staticClass: "user-table"
	  }, [_c('thead', [_c('tr', [_c('thUser', {
	    attrs: {
	      "rowspan": "3",
	      "sort-prop": "name",
	      "title": _vm.$t('vue2.assign_users_hours.name'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.work_hours')))])]), _vm._v(" "), (_vm.isPoolsDeactivated) ? _c('th', {
	    staticClass: "rest-hours",
	    attrs: {
	      "colspan": "1"
	    }
	  }, [_vm._v("Rest")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "teaching-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.teaching')))])]), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? _c('th', {
	    staticClass: "task-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.tasks')))])]) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? _c('th', {
	    staticClass: "prep-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.assign_users_hours.preparation')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? _c('th', {
	    staticClass: "prep-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_vm._v("\n        Lokalpulje\n      ")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "absence-hours",
	    attrs: {
	      "colspan": "1"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.absence')))]), _vm._v(" "), _c('th', {
	    staticClass: "sub-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.substitute_hours')))]), _vm._v(" "), (_vm.isSFOActive) ? _c('th', {
	    staticClass: "club-hours",
	    attrs: {
	      "colspan": _vm.numberOfCols
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.club')))])]) : _vm._e()], 1), _vm._v(" "), _c('tr', [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "assigned_total_hours",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), _c('thUser', {
	    attrs: {
	      "sort-prop": "actual_total_hours",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "diff_total_hours",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isPoolsDeactivated) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "rest_hours",
	      "title": "Rest",
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "assigned_teaching_hours",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), _c('thUser', {
	    attrs: {
	      "sort-prop": "actual_teaching_hours",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "diff_teaching_hours",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "assigned_additional_task_hours",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), _c('thUser', {
	    attrs: {
	      "sort-prop": "actual_additional_task_hours",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "diff_additional_task_hours",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "assigned_preparation_hours",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), _c('thUser', {
	    attrs: {
	      "sort-prop": "actual_preparation_hours",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "diff_preparation_hours",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "assigned_pool_hours",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), _c('thUser', {
	    attrs: {
	      "sort-prop": "actual_pool_hours",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "diff_pool_hours",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('thUser', {
	    attrs: {
	      "sort-prop": "actual_absence_hours",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "substitute_pool_hours",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), _c('thUser', {
	    attrs: {
	      "sort-prop": "actual_substitute_hours",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "diff_substitute_hours",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSFOActive) ? [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "assigned_club_hours",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e(), _vm._v(" "), _c('thUser', {
	    attrs: {
	      "sort-prop": "actual_club_hours",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
	    attrs: {
	      "sort-prop": "diff_club_hours",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
	    staticClass: "user-table__body"
	  }, _vm._l((_vm.filteredData), function(user) {
	    return _c('trUser', {
	      key: user.id,
	      attrs: {
	        "theUserCanManageAssignedHours": _vm.theUserCanManageAssignedHours,
	        "schoolid": _vm.schoolid,
	        "user": user,
	        "isSFOActive": _vm.isSFOActive,
	        "isLocalPoolActivated": _vm.isLocalPoolActivated,
	        "isSchoolYearWithNewEmploymentDeal": _vm.isSchoolYearWithNewEmploymentDeal,
	        "activeSchoolYear": _vm.activeSchoolYear,
	        "isDatesPristine": _vm.isDatesPristine,
	        "numberOfWorkDays": _vm.numberOfWorkDays,
	        "numberOfWorkDaysInPeriod": _vm.numberOfWorkDaysInPeriod,
	        "locale": _vm.locale,
	        "viewSettings": _vm.viewSettings,
	        "isPoolsDeactivated": _vm.isPoolsDeactivated,
	        "prepFactor": _vm.prepFactor
	      },
	      on: {
	        "openEdit": _vm.setOpenEdit,
	        "setTheUserToShowTasks": _vm.setTheUserToShowTasks,
	        "setActiveUser": _vm.setActiveUser
	      }
	    })
	  }), 1)]), _vm._v(" "), (_vm.theEditNumberUserId) ? _c('div', {
	    ref: "popper_child",
	    staticClass: "popper_child"
	  }, [_c('transition', {
	    attrs: {
	      "name": "scale"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "number__input-opened"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.theEditNumberNumber),
	      expression: "theEditNumberNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeEditing),
	      expression: "closeEditing"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.theEditNumberNumber)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doneEditing.apply(null, arguments)
	      },
	      "change": function($event) {
	        _vm.theEditNumberNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--small--loading': _vm.isUpdatingNumber
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.doneEditing.apply(null, arguments)
	      }
	    }
	  }, [(!_vm.isUpdatingNumber) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-plan"
	  }, [_c('table', {
	    staticClass: "d-table d-table__stue"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', {
	    staticClass: "do-container"
	  }, [_c('div', {
	    staticClass: "do-container__left"
	  }, [_c('DDropdown', {
	    staticClass: "title--grey"
	  }, [_c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.createCalendars('kindergarten')
	      }
	    }
	  }, [_vm._v("\n                  Opret stuer\n                ")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateOpeningHours(true)
	      }
	    }
	  }, [_vm._v("\n                  Åbningstider\n                ")])])]), _vm._v("\n            Uge " + _vm._s(_vm.currentWeek) + "\n            "), _c('DutyScheduleNav', {
	    on: {
	      "today": function($event) {
	        return _vm.$emit('today')
	      },
	      "next": function($event) {
	        return _vm.$emit('next')
	      },
	      "prev": function($event) {
	        return _vm.$emit('prev')
	      }
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendarsCopy', {
	    attrs: {
	      "initCopyDate": _vm.date
	    },
	    on: {
	      "submit": function($event) {
	        return _vm.copyCals($event)
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "copy-button-title"
	    },
	    slot: "copy-button-title"
	  }, [_vm._v("Kopier")])])], 1), _vm._v(" "), (_vm.isEventsLoading) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.days), function(day) {
	    return _c('th', {
	      key: day.dateFormatted
	    }, [_vm._v(_vm._s(day.dateFormatted))])
	  })], 2)]), _vm._v(" "), _vm._l((_vm.calendars), function(calendar) {
	    return _c('DutyScheduleCalendar', {
	      attrs: {
	        "calendar": calendar,
	        "date": _vm.date,
	        "days": _vm.days,
	        "events": _vm.events,
	        "usersCalIdsHash": _vm.usersCalIdsHash,
	        "eventsInHash": _vm.eventsInHash,
	        "theCreateEventObj": _vm.theCreateEventObj,
	        "userNorms": _vm.userNorms,
	        "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
	        "openingHours": _vm.openingHours
	      },
	      on: {
	        "createSubject": function($event) {
	          return _vm.$emit('createSubject', $event)
	        },
	        "createEvent": function($event) {
	          return _vm.$emit('createEvent', $event)
	        },
	        "editEvent": function($event) {
	          return _vm.$emit('editEvent', $event)
	        }
	      }
	    })
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-dark do-calendar__wrapper",
	    class: {
	      'do-calendar__wrapper--dragging': _vm.isDragging
	    }
	  }, [(_vm.isDeviceMobile) ? _c('div', {
	    ref: "do_calendar_frontend_lock",
	    staticClass: "do-calendar-frontend-lock",
	    on: {
	      "click": _vm.setIsLockedFromFrontend
	    }
	  }, [_c('div', {
	    staticClass: "do-calendar-frontend-lock__inner"
	  }, [(_vm.isLockedFromFrontend) ? _c('span', {
	    staticClass: "icon-lock5"
	  }) : _c('span', {
	    staticClass: "icon-unlocked2"
	  })])]) : _vm._e(), _vm._v(" "), _c('week-selector', {
	    attrs: {
	      "startDate": _vm.weekSelectorStartDate,
	      "endDate": _vm.weekSelectorEndDate,
	      "date": _vm.activeCalendarDate
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "printCalendar"
	    }
	  }, [_c('div', {
	    staticClass: "d-calendar do-calendar"
	  }, [_c('div', {
	    staticClass: "d-calendar__header do-calendar__header",
	    staticStyle: {
	      "min-height": "54px"
	    }
	  }, [(_vm.calendar) ? _c('DCalendarHeader', {
	    attrs: {
	      "isLoadingEvents": _vm.isEventsLoading,
	      "activeCalendarDate": _vm.activeCalendarDate,
	      "calendarId": _vm.theActiveCalendarId,
	      "initCalendar": _vm.calendar,
	      "dates": _vm.calendarDates,
	      "hasHotKeys": true,
	      "isMultiple": _vm.userHasPermission('can_see_other_calendars')
	    },
	    on: {
	      "updateEvents": _vm.readEvents,
	      "updateCalendar": function($event) {
	        return _vm.readEvents(true)
	      },
	      "next": _vm.nextWeek,
	      "prev": _vm.prevWeek,
	      "today": _vm.today,
	      "copyCalendarModalOpen": function($event) {
	        return _vm.setIsCopyCalendarModalOpen($event)
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-calendar__calendar__container",
	    class: {
	      'd-calendar__calendar__container--print-mode': _vm.isCalendarInPrintMode
	    }
	  }, [_c('DCalendar', {
	    attrs: {
	      "calendar": _vm.calendar,
	      "isEditable": _vm.isEditable,
	      "isLocked": _vm.isLocked,
	      "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
	      "isShowWeekends": _vm.isShowWeekends,
	      "startTime": _vm.startTime,
	      "endTime": _vm.endTime,
	      "date": _vm.activeCalendarDate,
	      "events": _vm.dCalendarEvents,
	      "calendarId": _vm.theActiveCalendarId,
	      "calendarName": _vm.calendarName,
	      "firstDayOfWeek": _vm.firstDayOfWeek,
	      "isEventsClickable": true,
	      "isAbsenceEditable": _vm.getIsAbsenceEditable,
	      "isCopyCalendarModalOpen": _vm.isCopyCalendarModalOpen
	    },
	    on: {
	      "onEventClick": _vm.setActiveEvent,
	      "dates": _vm.setCalendarDates,
	      "onDragging": _vm.setIsDragging
	    }
	  })], 1)]), _vm._v(" "), (_vm.isShowWeekPlan) ? _c('DWeekplan', {
	    attrs: {
	      "isInPrintMode": _vm.isInPrintMode,
	      "isReadOnly": _vm.isInPrintMode || !_vm.userHasPermission('can_edit_own_notes')
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "isDCalendarInROR": true,
	      "canEditEvent": true,
	      "canEditNotes": _vm.userHasPermission('can_edit_own_notes'),
	      "event": _vm.activeEvent,
	      "calendar": _vm.calendar,
	      "initCalendarId": _vm.theActiveCalendarId,
	      "isInDCalendar": true
	    },
	    on: {
	      "updated": _vm.readEvents,
	      "close": _vm.closeShowEvent,
	      "submitDeleteEventOnward": function($event) {
	        return _vm.readEvents(true)
	      }
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.klassCalendars,
	      "isLoading": _vm.isLoading,
	      "itemsSelected": _vm.selectedKlasses,
	      "multiple": false,
	      "placeholder": _vm.i18n[_vm.locale]['search']
	    },
	    on: {
	      "add": _vm.add,
	      "remove": _vm.remove,
	      "update": _vm.setSelectedKasses
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "onboard-arrow",
	    class: {
	      'is-in-setup-widget': _vm.setupWidget
	    }
	  }, [_c('div', {
	    staticClass: "arrow_box no-print animated infinite onboarding_animate"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    staticClass: "day-cal__overlay"
	  }, [_c('div', {
	    staticClass: "days-container",
	    style: ({
	      height: _vm.height + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "day"
	  }, [_c('day-cal', {
	    attrs: {
	      "locale": _vm.locale,
	      "i18n": _vm.i18n,
	      "date": _vm.date,
	      "events": _vm.lessons,
	      "viewState": _vm.viewState
	    },
	    on: {
	      "eventClicked": _vm.onTap,
	      "lessonsUpdate": _vm.setScrollTop
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', {
	    staticClass: "only-print"
	  }, [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedCalendarId),
	      expression: "selectedCalendarId"
	    }],
	    staticClass: "no-desktop no-print",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedCalendarId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.nativeSelect]
	    }
	  }, _vm._l((_vm.sortedCalendars), function(calendar) {
	    return _c('option', {
	      domProps: {
	        "value": calendar.id
	      }
	    }, [_vm._v(_vm._s(calendar.name))])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "d-container no-mobile no-print",
	    class: {
	      'd-container--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "d_parent",
	    staticClass: "d-select__selected",
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_c('h1', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), (_vm.isSelectLoading) ? _c('div', {
	    staticClass: "d-spinner"
	  }) : _c('svg', {
	    staticClass: "tw-icon tw-icon-cheveron-selection",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	    }
	  })])]), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
	    ref: "d_child",
	    staticClass: "d-select__dropdown",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady, 'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('div', {
	    ref: "ref_d_select_input_container",
	    staticClass: "d-select-input",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "inputsearch",
	    attrs: {
	      "type": "search"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('ul', {
	    ref: "ref_d_select_calendar_dropdown",
	    staticClass: "d-select__dropdown__container"
	  }, [_vm._l((_vm.calendarQuery), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "d-list-item",
	      class: [{
	          'd-list-item--highlighted': _vm.getIsTheKeyboardSelected(calendar)
	        },
	        {
	          'd-list-item--selected': calendar.v_selected
	        }
	      ],
	      on: {
	        "click": function($event) {
	          return _vm.selectCalendar(calendar.id)
	        },
	        "mouseenter": function($event) {
	          return _vm.setTheKeyboardSelected(calendar)
	        },
	        "mousemove": _vm.onMouseMove
	      }
	    }, [_vm._v("\n          " + _vm._s(calendar.name) + " "), _c('span', {
	      staticClass: "icon-checkmark-circle"
	    })])
	  }), _vm._v(" "), (_vm.isSchoolCalendarsLoading) ? _c('li', {
	    staticClass: "d-select__dropdown__spinner-container"
	  }, [_c('div', {
	    staticClass: "d-spinner"
	  })]) : _vm._e(), _vm._v(" "), (_vm.calendarQuery.length === 0 && !_vm.isSchoolCalendarsLoading) ? _c('li', {
	    staticClass: "d-list-item text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.no_calendars_found')) + "\n        ")]) : _vm._e()], 2)]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-calendar-list"
	  }, [_c('div', {
	    staticClass: "d-calendar-list__header",
	    class: {
	      'd-calendar-list__header--flex': _vm.isCalendarInPrintMode
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dateRangeFormatted))])]), _vm._v(" "), _c('table', [_c('tbody', [(_vm.eventsSortedInDays.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer pad-1"
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n['no_lessons']) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsSortedInDays), function(event) {
	    return _c('tr', {
	      key: event.id,
	      class: {
	        'tr--is-day': event.type && event.type === 'dayDate'
	      }
	    }, [(event.type && event.type === 'dayDate') ? [_c('td', {
	      attrs: {
	        "colspan": "4"
	      }
	    }, [_c('div', [_c('p', [_vm._v(_vm._s(event.showDay))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(event.showDate))])])])] : [_c('td', [_c('div', {
	      staticClass: "lesson"
	    }, [_vm._v("\n            " + _vm._s(event.v_start) + " - " + _vm._s(event.v_end) + "\n            "), _c('div', {
	      staticClass: "lesson__dot",
	      style: ({
	        'backgroundColor': event.color
	      })
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(event.title)), (event.group.length > 0) ? [_vm._v(", " + _vm._s(event.group))] : _vm._e()], 2)])]), _vm._v(" "), _c('td', [(event.teacher.length > 0) ? _c('span', {
	      staticClass: "icon-user"
	    }) : _vm._e(), _vm._v(" " + _vm._s(event.teacher) + "\n        ")]), _vm._v(" "), _c('td', [(event.substitutes.length > 0) ? _c('span', {
	      staticClass: "icon-users3"
	    }) : _vm._e(), _vm._v(" " + _vm._s(event.substitutes) + "\n        ")]), _vm._v(" "), _c('td', [(event.room.length > 0) ? _c('span', {
	      staticClass: "icon-location"
	    }) : _vm._e(), _vm._v(" " + _vm._s(event.room) + "\n        ")])]], 2)
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickOutside),
	      expression: "onClickOutside"
	    }],
	    staticClass: "d-dropdown-container",
	    class: {
	      'd-dropdown-container--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "d_parent",
	    staticClass: "d-dropdown__title",
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_vm._t("title"), _vm._v(" "), (_vm.isShowDots) ? _c('div', {
	    staticClass: "d-dropdown__title__circle"
	  }, [_vm._t("d-dropdown__icon", function() {
	    return [_c('span', {
	      staticClass: "icon-more2"
	    })]
	  })], 2) : _vm._e()], 2), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
	    ref: "d_child",
	    staticClass: "d-dropdown text-dark",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady, 'd-dropdown--show': _vm.isPopperDone
	    },
	    attrs: {
	      "id": "d-dropdown__d-child"
	    }
	  }, [_vm._t("list", function() {
	    return [_vm._m(0)]
	  })], 2) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_vm._v("Rename")]), _vm._v(" "), _c('li', [_vm._v("Help")]), _vm._v(" "), _c('li', {
	    staticClass: "d-item-warning"
	  }, [_vm._v("Try")])])
	}]}

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert--small"
	  }, [_c('h4', [_vm._v("\n    " + _vm._s(_vm.i18n['following_persons_are_on_the_lesson_but_not_on_school']) + " " + _vm._s(_vm.activeSchoolName) + ".\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__group"
	  }, _vm._l((_vm.usersNotOnSchool), function(calendar) {
	    return _c('div', {
	      key: calendar.calendar_id,
	      staticClass: "d-cal-not-on-school",
	      attrs: {
	        "data-cal-id": calendar.calendar_id
	      }
	    }, [_vm._v("\n      " + _vm._s(calendar.name) + " "), (calendar.substitute) ? _c('span', {
	      staticClass: "do-pill do-pill--custom"
	    }, [_vm._v(_vm._s(_vm.i18n['sub']))]) : _vm._e(), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n                    arrow: true,\n                    placement : 'top'\n                  }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger icon__bg-circle--x-small",
	      attrs: {
	        "content": _vm.i18n['remove']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheRemoveCalendar(calendar)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })])])
	  }), 0), _vm._v(" "), (_vm.theRemoveCalendar) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar text-dark",
	    class: {
	      'd-modal__d-calendar--with-actions': true
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar__header text-dark"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.theRemoveCalendar.name))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setTheRemoveCalendar(null)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__d-calendar__content"
	  }, [_c('div', {
	    staticClass: "alert width-100"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n['remove']) + " " + _vm._s(_vm.theRemoveCalendar.name) + " " + _vm._s(_vm.i18n['from_this_lesson']) + "?")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-danger width-100",
	    on: {
	      "click": function($event) {
	        return _vm.removeCalendar(_vm.theRemoveCalendar)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['remove']) + "\n            " + _vm._s(_vm.theRemoveCalendar.name) + " " + _vm._s(_vm.i18n['from_this_lesson']) + "\n          ")])]), _vm._v(" "), (false) ? _c('div', {
	    staticClass: "alert"
	  }, [_c('h4', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n['remove_or_replace']) + " " + _vm._s(_vm.theRemoveCalendar.name) + " " + _vm._s(_vm.i18n['on']) + "\n            " + _vm._s(_vm.event.title) + " " + _vm._s(_vm.i18n['onwards']) + "?")]), _vm._v(" "), _c('CalendarViewDayRemoveOrReplace', {
	    staticClass: "width-100 d-event__actions--custom",
	    attrs: {
	      "isPossibleToAdd": false,
	      "event": _vm.event,
	      "calendar": _vm.theRemoveCalendar,
	      "calendars": _vm.userCalendars
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose
	    }
	  })], 1) : _vm._e()])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "pos-relative inline-block"
	  }, [_c('button', {
	    staticClass: "dropup-button",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropup"
	    }
	  }, [_c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "dropup-content bg-white large-box-shadow rounded"
	  }, [_vm._t("list", function() {
	    return [_c('li', [_vm._v("Three")]), _vm._v(" "), _c('li', [_vm._v("Two")]), _vm._v(" "), _c('li', [_vm._v("One")])]
	  })], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-filters text-dark"
	  }, [_c('div', {
	    staticClass: "do-filters__selected"
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickOutside),
	      expression: "onClickOutside"
	    }],
	    staticClass: "do-filters__dropdown__container"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    on: {
	      "click": function($event) {
	        _vm.isShowDropdown = !_vm.isShowDropdown
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-filter"
	  }), _vm._v("\n        " + _vm._s(_vm.i18n['substitutes']) + "\n        "), _c('div', {
	    staticClass: "do-filters__divider"
	  }), _vm._v(" "), (_vm.allSelectedFiltersLength === 0) ? _c('span', {
	    staticClass: "do-filters__selected-filters"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n['select_filters']) + "\n        ")]) : [_c('span', {
	    staticClass: "do-badge"
	  }, [_vm._v("\n            " + _vm._s(_vm.allSelectedFiltersLength) + " " + _vm._s(_vm.i18n['selected']) + "\n          ")])]], 2), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-dropdown"
	    }
	  }, [(_vm.isShowDropdown) ? _c('div', {
	    staticClass: "do-filters__dropdown"
	  }, [_c('button', {
	    staticClass: "do-filters__button-transparent",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('clearAll')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['clear_all']))]), _vm._v(" "), _c('div', {
	    staticClass: "do-filters__dropdown__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n['filter_by_criteria']))]), _vm._v(" "), _vm._l((_vm.quickFilters), function(quickFilter) {
	    return _c('button', {
	      key: quickFilter.value,
	      staticClass: "do-bttn__quick-filter",
	      class: {
	        'do-bttn__quick-filter--selected': _vm.getIsQuickFilterSelected(quickFilter)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('toggleQuickFilter', quickFilter)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-checkmark-circle"
	    }), _vm._v("\n              " + _vm._s(_vm.i18n[quickFilter.titleKey]) + "\n            ")])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "do-filters__dropdown__item"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n['filter_by_group']))]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n['groups'],
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags
	    },
	    on: {
	      "select": function($event) {
	        return _vm.$emit('select', $event)
	      },
	      "clear": function($event) {
	        return _vm.$emit('clear')
	      }
	    }
	  })], 1)]) : _vm._e()])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subjects text-dark",
	    class: {
	      'subjects--is-activities': _vm.isActivities
	    }
	  }, [(!_vm.isActivities) ? _c('div', {
	    staticClass: "subjects-header"
	  }, [_c('div', {
	    staticClass: "subjects-header__left"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['headline']))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['subjects'],
	      "tags": _vm.subjectTypeFilters,
	      "selectedTags": _vm.selectedSubjectTypeFilters
	    },
	    on: {
	      "select": _vm.toggleSelectedSubjectTypeFilters,
	      "clear": _vm.clearSelectedSubjectTypeFilters
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "subjects-header__right"
	  }, [(!_vm.isLoading && _vm.klassesWithoutSubjects.length > 0) ? _c('button', {
	    staticClass: "do-bttn do-bttn--large",
	    on: {
	      "click": _vm.setImportSubjects
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['import_subjects']) + "\n      ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "color": "blue"
	    }
	  }) : [(_vm.klassCalIdsHashSortedOnName.length < 1) ? _c('div', [_c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_classes_first']))])]) : _c('div', {
	    staticClass: "subjects-table",
	    style: ({
	      'width': _vm.tableWidth
	    })
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', {
	    ref: "tableHead"
	  }, [_c('tr', [_c('th', {
	    staticStyle: {
	      "min-width": "160px"
	    }
	  }), _vm._v(" "), _vm._l((_vm.klassCalIdsHashSortedOnName), function(calId) {
	    return _c('th', [_c('div', {
	      staticClass: "column-name"
	    }, [_vm._v(_vm._s(_vm.getCalendarName(calId)))])])
	  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.klassCalIdsHashSortedOnName), function(calId) {
	    return _c('td', {
	      key: calId,
	      staticClass: "td-create-bttn-container"
	    }, [_c('button', {
	      staticClass: "do-bttn td-bttn--small",
	      on: {
	        "click": function($event) {
	          return _vm.setCreateInCalendarId(calId)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create']) + "\n            ")])])
	  })], 2), _vm._v(" "), _vm._l((_vm.subjectsInKlassesWithProps), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('th', [_vm._v(_vm._s(subject.name))]), _vm._v(" "), _vm._l((_vm.klassCalIdsHashSortedOnName), function(calId) {
	      return (subject.klasses[calId] && subject.klasses[calId].hours > -1) ? _c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            onShow: function () { return subject.klasses[calId].v_subjectHasTeachers; }
	          }),
	          expression: "{\n                  arrow: true,\n                  onShow: () => subject.klasses[calId].v_subjectHasTeachers\n                }"
	        }],
	        key: calId,
	        staticClass: "td__subject",
	        class: [{
	            'td__subject--has-user': subject.klasses[calId].v_subjectHasTeachers
	          },
	          {
	            'td__subject--has-room': subject.klasses[calId].v_subjectHasRooms
	          },
	          {
	            'td__subject-has-other-klass': subject.klasses[calId].v_subjectOtherKlasses && subject.klasses[calId].v_subjectOtherKlasses.length > 0
	          }
	        ],
	        style: ({
	          '--subjectBgColor': subject.klasses[calId].color
	        }),
	        attrs: {
	          "aria-hours": subject.klasses[calId].hours,
	          "content": subject.klasses[calId].v_userNames
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(subject.klasses[calId])
	          }
	        }
	      }) : _c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            animateFill: false,
	            animation: 'shift-away',
	            zIndex: '999999992',
	            boundary: 'window',
	          }),
	          expression: "{\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n                }"
	        }],
	        staticClass: "td__create-subject",
	        attrs: {
	          "content": _vm.createTooltip(subject, calId)
	        },
	        on: {
	          "click": function($event) {
	            if ($event.target !== $event.currentTarget) { return null; }
	            return _vm.setIsCreateSubject(subject, subject.klasses[calId])
	          }
	        }
	      }, [(_vm.isCreateSubject(subject, subject.klasses[calId])) ? _c('AddSubject', {
	        attrs: {
	          "subject": subject,
	          "calendar": subject.klasses[calId]
	        },
	        on: {
	          "createSubject": _vm.createExistingSubjectInCal,
	          "close": _vm.closeIsCreateSubject
	        }
	      }) : _vm._e()], 1)
	    })], 2)
	  })], 2)])])], _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
	    attrs: {
	      "propCalendarId": _vm.createInCalendarId,
	      "showModal": _vm.isSubjectModal,
	      "editSubject": _vm.editSubject,
	      "isActivities": _vm.isActivities
	    },
	    on: {
	      "close": _vm.closeModal,
	      "createSubject": _vm.createNewSubject,
	      "updateSubject": _vm.updateSubject,
	      "deleteSubject": _vm.deleteSubject
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('th', {
	    attrs: {
	      "colspan": "8"
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.user.vName) + "\n  ")])]), _vm._v(" "), _c('tbody', [(_vm.user.vFag.length > 0) ? _c('tr', {
	    staticClass: "tr__header"
	  }, [_c('td', [_vm._v("Fag")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Lærerklokketimer")]), _vm._v(" "), _c('td', {
	    staticClass: "klokketime-td"
	  }, [_vm._v("Lærerklokketimer type")])]) : _vm._e(), _vm._v(" "), (_vm.user.vFag.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    attrs: {
	      "colspan": "8"
	    }
	  }, [_vm._v("\n      Brugeren har ingen fag\n    ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.vFag), function(fag) {
	    return _c('tr', [_c('td', [_c('div', {
	      staticClass: "subject"
	    }, [_vm._v("\n        " + _vm._s(fag.fag_navn) + " (" + _vm._s(fag.klasse_klokketimer) + ")\n      ")])]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "100%"
	      }
	    }, [_vm._v("\n      " + _vm._s(fag.klassebetegnelse) + "\n    ")]), _vm._v(" "), _c('td', [_c('input', {
	      staticClass: "d-input__small",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": fag.learer_klokketimer
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "keyup": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.updateStilKlasseFagLaerer(_vm.user, fag, 'klokketimer', $event.target.value, $event.target)
	        },
	        "blur": function($event) {
	          return _vm.updateStilKlasseFagLaerer(_vm.user, fag, 'klokketimer', $event.target.value, $event.target)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('select', {
	      staticClass: "d-select__small",
	      domProps: {
	        "value": fag.klokketimer_type
	      },
	      on: {
	        "change": function($event) {
	          return _vm.updateStilKlasseFagLaerer(_vm.user, fag, 'klokketimer_type', $event.target.value)
	        }
	      }
	    }, _vm._l((_vm.klokketimetyper), function(type, key) {
	      return _c('option', {
	        domProps: {
	          "value": key
	        }
	      }, [_vm._v(_vm._s(type))])
	    }), 0)])])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-subjects text-dark"
	  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading || _vm.isLoadingSubjectsRequests) ? _c('Loader') : _c('div', {
	    staticClass: "request-subjects-grid"
	  }, [_c('RequestSubjectsUser', {
	    attrs: {
	      "user": _vm.user,
	      "userSubjects": _vm.userRequestedSubjectsWithProps,
	      "allCalendarsInHash": _vm.allCalendarsInHash,
	      "loadingSubjects": _vm.loadingSubjects
	    },
	    on: {
	      "removeSubject": function($event) {
	        return _vm.onSetSubjectRequest($event)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "doTable"
	  }, [_c('div', {
	    staticClass: "subject-dist__header"
	  }, [_c('div', {
	    staticClass: "subject-dist__header__left"
	  }, [(_vm.selectedTab === 'Fag') ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Klasser',
	      "tags": _vm.klassTags,
	      "selectedTags": _vm.selectedKlassFilters
	    },
	    on: {
	      "select": _vm.toggleKlassTag,
	      "clear": function($event) {
	        _vm.selectedKlassFilters = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'Fag') ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Status på fag',
	      "tags": _vm.statusFilters,
	      "selectedTags": _vm.selectedStatusFilters
	    },
	    on: {
	      "select": _vm.toggleSelectedStatusFilters,
	      "clear": function($event) {
	        _vm.selectedStatusFilters = []
	      }
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedTab === 'Opgaver') ? _c('table', {
	    staticClass: "do-table do-table__tasks"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
	    staticClass: "td-number"
	  }, [_vm._v("Timer")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tasks), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('button', {
	      staticClass: "do-bttn do-bttn--request-subject marg-1-right",
	      on: {
	        "click": function($event) {
	          _vm.onSetSubjectRequest(task.id)
	        }
	      }
	    }, [_vm._v("\n              Ønsk\n            ")]), _vm._v("\n            " + _vm._s(task.name) + "\n          ")]), _vm._v(" "), _c('td', {
	      staticClass: "td-number"
	    }, [_vm._v(_vm._s(task.hours))])])
	  }), 0)]) : _c('ul', {
	    staticClass: "doTable__items"
	  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
	    return _c('li', {
	      key: klassCal.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(klassCal.name))])]), _vm._v(" "), _c('ul', {
	      staticClass: "subjects"
	    }, _vm._l((klassCal.vSubjects), function(subject) {
	      return _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            onShow: function () { return subject.vRequestedBy.length > 0 || subject.vHasTeachers; }
	          }),
	          expression: "{\n          arrow: true,\n          onShow: () => subject.vRequestedBy.length > 0 || subject.vHasTeachers\n        }"
	        }],
	        key: subject.id,
	        staticClass: "subjects_subject",
	        class: [{
	          'subject--has-user': subject.vRequestedBy.length > 0
	        }],
	        style: ({
	          'background': subject.color
	        }),
	        attrs: {
	          "content": !subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'
	        }
	      }, [_vm._v("\n\n              " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n              "), (!subject.vHasTeachers) ? _c('button', {
	        staticClass: "do-bttn do-bttn--request-subject",
	        class: {
	          'do-bttn--remove': subject.vIsRequestedByUser
	        },
	        on: {
	          "click": function($event) {
	            return _vm.onSetSubjectRequest(subject.id)
	          }
	        }
	      }, [(subject.vIsLoading) ? _c('div', {
	        staticClass: "do-spinner do-spinner__small"
	      }) : [_vm._v("\n                  " + _vm._s(subject.vIsRequestedByUser ? 'Fjern ønske' : 'Ønsk') + "\n                ")]], 2) : _vm._e()])
	    }), 0)])
	  }), 0)])], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-subjects__header"
	  }, [_c('h1', [_vm._v("Ønsker til fagfordelingen")])])
	}]}

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true,
	      "appendToBody": true,
	      "isCloseOnEsc": !_vm.theEditUser
	    },
	    on: {
	      "close": _vm.onClose
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__content text-dark"
	  }, [_c('div', {
	    staticClass: "d-modal__content__sidebar"
	  }, [_c('h2', [_vm._v("Opsætning af vikarløn")]), _vm._v(" "), _c('ul', {
	    staticClass: "d-modal__content__sidebar__nav"
	  }, _vm._l((_vm.tabs), function(tab) {
	    return _c('li', {
	      staticClass: "d-modal__content__sidebar__nav-item",
	      class: {
	        'd-modal__content__sidebar__nav-item--active': tab.id === _vm.theActiveTab
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveTab(tab.id)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content__body"
	  }, [_c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.onClose
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), (_vm.isInitLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [(_vm.theActiveTab === 1) ? _c('SalarySettingsUsers', {
	    attrs: {
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "setEditUser": _vm.setEditUser,
	      "changedMade": function($event) {
	        _vm.isChangesMade = true
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 2) ? _c('SalaryRule1', {
	    attrs: {
	      "schoolIds": [_vm.schoolId],
	      "config": _vm.config,
	      "propRules": _vm.rules,
	      "schoolSubstituteRules": _vm.schoolSubstituteRules
	    },
	    on: {
	      "changedMade": function($event) {
	        _vm.isChangesMade = true
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('SalaryRule2', {
	    attrs: {
	      "config": _vm.config,
	      "propRules": _vm.rules
	    },
	    on: {
	      "onSubmit": _vm.updateSchoolConfiguration
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 4) ? _c('SalaryRule3', {
	    attrs: {
	      "config": _vm.config,
	      "propRules": _vm.rules
	    },
	    on: {
	      "onSubmit": _vm.updateSchoolConfiguration
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 5) ? _c('SalaryRule4', {
	    attrs: {
	      "config": _vm.config,
	      "propRules": _vm.rules
	    },
	    on: {
	      "onSubmit": _vm.updateSchoolConfiguration
	    }
	  }) : _vm._e()]], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-subjects__user text-dark"
	  }, [_vm._m(0), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
	    staticClass: "number"
	  }, [_vm._v("\n      " + _vm._s(_vm.sumOfHours) + "\n    ")])]), _vm._v(" "), _c('tbody', [(_vm.userSubjects.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "italic",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Ingen fag ønsket")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userSubjects), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('td', {
	      staticClass: "td-delete"
	    }, [(!_vm.loadingSubjects[subject.id]) ? _c('div', {
	      staticClass: "icon__bg-circle icon-bin",
	      on: {
	        "click": function($event) {
	          return _vm.$emit('removeSubject', subject.id)
	        }
	      }
	    }) : _c('div', {
	      staticClass: "do-spinner do-spinner-small"
	    })]), _vm._v(" "), _c('td', {
	      staticClass: "td-subjects"
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          onShow: function () { return subject.vRequestedBy.length > 0; }
	        }),
	        expression: "{\n          arrow: true,\n          onShow: () => subject.vRequestedBy.length > 0\n        }"
	      }],
	      staticClass: "subjects_subject subjects_subject__simple",
	      class: {
	        'subjects_subject--has-user': subject.vRequestedBy.length > 0
	      },
	      style: ([{
	        'border-left-color': subject.color
	      }, {
	        'background-color': subject.color
	      }]),
	      attrs: {
	        "content": !subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'
	      }
	    }, [_vm._v("\n          " + _vm._s(subject.name) + "\n        ")])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_vm._v(_vm._s(subject.vKlass))]), _vm._v(" "), _c('td', {
	      staticClass: "number"
	    }, [_vm._v("\n        " + _vm._s(subject.hours) + "\n      ")])])
	  })], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-subjects__user__header"
	  }, [_c('h2', {
	    staticClass: "pad-1"
	  }, [_vm._v("Dine ønsker")])])
	}]}

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loader",
	    class: [{
	      'loader--small': _vm.isSmall
	    }, {
	      'loader--modal': _vm.isLoaderModal
	    }, {
	      'loader--extra-small': _vm.isExtraSmall
	    }],
	    style: (_vm.styleObj)
	  })
	},staticRenderFns: []}

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-search"
	  }, [_c('div', {
	    staticClass: "search-wrapper"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "search_input",
	    staticClass: "search-wrapper__search",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('repitition.search_for') + ' ' + _vm.$t('repitition.skole')
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "list-search__body"
	  }, [_c('ul', _vm._l((_vm.searchList), function(option) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": option.url,
	        "data-no-turbolink": "true"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.chooseItem(option)
	        }
	      }
	    }, [_vm._v(_vm._s(option.name))])])
	  }), 0)])])
	},staticRenderFns: []}

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals text-dark"
	  }, [_c('div', {
	    staticClass: "d-acc",
	    class: {
	      'd-acc--open': _vm.isAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header",
	    on: {
	      "click": _vm.toggleIsAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header__left"
	  }, [_c('div', {
	    staticClass: "d-toggle-arrow",
	    class: {
	      'd-toggle-arrow--open': _vm.isAccOpen
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title) + " (" + _vm._s(_vm.calendarsExclArchivedWithoutFilters.length) + ")")])])]), _vm._v(" "), (_vm.isAccOpen) ? _c('ul', {
	    staticClass: "d-copy-cals__list"
	  }, [(_vm.calType === 'user') ? _c('li', {
	    staticClass: "select-all-item d-copy-cals__list__header select-all-item d-copy-cals__list__header__filters"
	  }, [_c('TaggingFilter', {
	    attrs: {
	      "schoolid": _vm.schoolId,
	      "showHowMany": false,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "select-all-item d-copy-cals__list__header"
	  }, [_c('p', {
	    staticClass: "d-acc__header__select-all",
	    on: {
	      "click": _vm.toggleAllKlasses
	    }
	  }, [(_vm.selectedCalIds.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-copy-cals__list__header__right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.selectedCalIds.length) + " " + _vm._s(_vm.$t('vue2.calendars.selected_of')) + " " + _vm._s(_vm.calendarsExclArchived.length))]), _vm._v(" "), (_vm.selectedCalIds.length < 1) ? _c('button', {
	    staticClass: "bttn--disabled hint--bottom-left",
	    attrs: {
	      "aria-label": this.$t('vue2.calendars.select_calendars_to_copy')
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.copy')) + "\n          ")]) : _c('CopyButton', {
	    attrs: {
	      "calType": _vm.calType
	    },
	    on: {
	      "open": function($event) {
	        _vm.isCopyOpen = true
	      },
	      "close": function($event) {
	        _vm.isCopyOpen = false
	      },
	      "submit": function($event) {
	        return _vm.copyCals($event)
	      }
	    }
	  })], 1)]), _vm._v(" "), _vm._l((_vm.calendarsExclArchived), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "d-copy-cals__cal",
	      class: {
	        'd-copy-cals__cal--selected': _vm.getIsInSelectedCalIds(calendar.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toogleCal(calendar.id)
	        }
	      }
	    }, [_vm._m(0, true), _vm._v("\n        " + _vm._s(calendar.name) + "\n      ")])
	  })], 2) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals__cal__selector"
	  }, [_c('div', {
	    staticClass: "checkbox"
	  })])
	}]}

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid grid-pad box-size"
	  }, [_c('div', {
	    staticClass: "col-1-1 box-size"
	  }, [_c('isIEOrEdge'), _vm._v(" "), _c('div', {
	    staticClass: "dashboard text-dark"
	  }, [(_vm.isOnboarding) ? _c('div', {
	    staticClass: "box box-overview flex pad-0"
	  }, [_c('div', {
	    staticClass: "flex-1 box-overview__name"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.dashboard.welcome')) + " " + _vm._s(_vm.userName) + "!")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('vue2.dashboard.start_by_setting_up')) + " " + _vm._s(_vm.schoolName))])]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.openSetupWidget
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.dashboard.follow_the_steps')))]), _vm._v(" "), _c('div', {
	    staticClass: "flex bg-light-blue flex-1 steps-graph"
	  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.dashboard.steps_completed')))]), _vm._v(" "), _c('doughnut', {
	    attrs: {
	      "animate": true,
	      "steps": _vm.steps.length,
	      "stepNum": _vm.howManyDone
	    }
	  })], 1)])]) : _c('div', [_c('h1', [_vm._v(_vm._s(_vm.schoolName) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "dashboard-boxes"
	  }, _vm._l((_vm.steps), function(step, key) {
	    return (key < 4) ? _c('dashboardBox', {
	      key: step.dbName,
	      attrs: {
	        "step": step,
	        "isOnboarding": _vm.isOnboarding
	      }
	    }) : _vm._e()
	  }), 1), _vm._v(" "), _c('div', {
	    staticClass: "dashboard-boxes"
	  }, _vm._l((_vm.steps), function(step, key) {
	    return (key >= 4) ? _c('dashboardBox', {
	      key: step.dbName,
	      attrs: {
	        "step": step,
	        "isOnboarding": _vm.isOnboarding
	      }
	    }) : _vm._e()
	  }), 1), _vm._v(" "), _c('div', {
	    staticClass: "slide-up",
	    class: {
	      'active': _vm.showSlideUp
	    }
	  }, [_c('div', {
	    staticClass: "slide-up__close",
	    on: {
	      "click": function($event) {
	        return _vm.setShowSlideUp(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "slide-up__content box"
	  }, [_c('vacationDaySelector', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSlideUp),
	      expression: "showSlideUp"
	    }],
	    attrs: {
	      "school-id": _vm.schoolId,
	      "emit-event-on-load": false,
	      "initial-year": _vm.schoolYear
	    },
	    on: {
	      "schoolDays": _vm.setSchoolDays
	    }
	  })], 1)])])], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSlideUp),
	      expression: "showSlideUp"
	    }],
	    staticClass: "modal-mask"
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "permissions__col__body__users__list__user",
	    class: {
	      index: _vm.index
	    }
	  }, [_c('div', [_c('img', {
	    attrs: {
	      "src": _vm.source.default_thumb_url
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.source.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "role-change__selector role-change__selector__placeholder",
	    class: {
	      'role-change__selector--active': _vm.source.id === _vm.activeChangeId
	    },
	    attrs: {
	      "data-user-id": _vm.source.id
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setChangeRole.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.change_role')) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.user) ? _c('div', {
	    staticClass: "subs-panel"
	  }, [_c('div', {
	    staticClass: "slide-in__mask animated fadeIn",
	    on: {
	      "click": _vm.close
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideIn"
	    }
	  }, [(_vm.animate) ? _c('div', {
	    staticClass: "slide-in text-dark"
	  }, [_c('div', {
	    staticClass: "slide-in__header"
	  }, [_c('div', {
	    staticClass: "slide-in__header__close pointer icon__bg-circle",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.substitution.add_sub_to_several_lesson')))])]), _vm._v(" "), _c('div', {
	    staticClass: "slide-in__grid"
	  }, [_c('div', {
	    staticClass: "slide-in__content"
	  }, [_c('div', {
	    staticClass: "slide-in__content__header"
	  }, [_c('div', {
	    staticClass: "slide-in__content__header__left"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.user.default_thumb_url
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, _vm._l((_vm.absenceReasons), function(absence) {
	    return _c('AbsenceReason', {
	      key: absence.id,
	      attrs: {
	        "user_calendar_id": _vm.user.user_calendar_id,
	        "reason": absence
	      },
	      on: {
	        "close": _vm.close
	      }
	    })
	  }), 1)]), _vm._v(" "), _c('div', {
	    staticClass: "slide-in__content__body"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.choose_period_lessons')))]), _vm._v(" "), _c('DoDatePickerRange', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "dateShortCutsProps": _vm.dateShortCutsSorted,
	      "allowSameDate": true,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate
	    },
	    on: {
	      "datesChanged": _vm.setDates
	    }
	  }), _vm._v(" "), _c('SubsUserPanelLessons', {
	    attrs: {
	      "dates": _vm.absentDates,
	      "isSubStatusPendingActive": _vm.isSubStatusPendingActive,
	      "calendarId": _vm.user.user_calendar_id,
	      "subToAdd": _vm.subToAdd
	    },
	    on: {
	      "changed": _vm.updateSelectedEventIds,
	      "updatedArr": _vm.updateDbEventsWithSubs
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "slide-in__sidebar"
	  }, [_c('SubsUserPanelSubs', {
	    attrs: {
	      "selectedEvents": _vm.selectedEvents
	    },
	    on: {
	      "addSub": _vm.addSubToEvents
	    }
	  })], 1)]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeUp"
	    }
	  }, [(_vm.dbEventsWithSubs.length > 0) ? _c('div', {
	    staticClass: "slide-in__footer shadow"
	  }, [_c('button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "marg-10-left bttn bttn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.save')) + "\n          ")])]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), (_vm.isClosingWithoutSaving) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.substitution.do_you_want_to_save')) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.isClosingWithoutSaving = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.no_close_without_saving')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.yes_save_my_changes')))])])])])]) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-dark box vacations-days__wrapper"
	  }, [(_vm.isKindergarten) ? _c('h1', [_vm._v("Lukkedage")]) : _c('h1', [_vm._v(_vm._s(_vm.$t('vue.vacations_days_selector.vacation_for_pupils')))]), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('div', {
	    staticClass: "marg-20-right flex align-center"
	  }, [(_vm.isKindergarten) ? _c('span', {
	    staticClass: "font-large"
	  }, [_vm._v("Periode")]) : _c('span', {
	    staticClass: "font-large"
	  }, [_vm._v(_vm._s(_vm.$t('vue.vacations_days_selector.school_year')) + " ")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedSchoolYearIndex),
	      expression: "selectedSchoolYearIndex"
	    }],
	    staticClass: "marg-1-left like-date-picker",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedSchoolYearIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.onSchoolYearChanged]
	    }
	  }, _vm._l((_vm.activeSchoolYears), function(schoolYear, index) {
	    return _c('option', {
	      domProps: {
	        "value": index
	      }
	    }, [_vm._v("\n          " + _vm._s(schoolYear.name) + "\n        ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "marg-1-left marg-1-right"
	  }, [_c('date-picker-range', {
	    staticClass: "inline-block",
	    attrs: {
	      "startdate": _vm.currFromDate,
	      "enddate": _vm.currToDate
	    },
	    on: {
	      "startchanged": _vm.onStartDateChanged,
	      "endchanged": _vm.onEndDateChanged
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "marg-20-right flex align-center pointer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.includeWeekends),
	      expression: "includeWeekends"
	    }],
	    staticClass: "pointer",
	    attrs: {
	      "id": "weekendToggle",
	      "type": "checkbox",
	      "title": "Include weekends"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.includeWeekends) ? _vm._i(_vm.includeWeekends, null) > -1 : (_vm.includeWeekends)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.includeWeekends,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.includeWeekends = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.includeWeekends = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.includeWeekends = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "marg-05-left pointer",
	    staticStyle: {
	      "font-weight": "normal"
	    },
	    attrs: {
	      "for": "weekendToggle"
	    }
	  }, [_vm._v("Include weekends")])])]), _vm._v(" "), _c('div', {
	    staticClass: "vacations-days-selector__year-calendar"
	  }, [_c('h2', {
	    staticClass: "marg-10-bottom"
	  }, [(_vm.isKindergarten) ? [_vm._v("Institutionen har åbent " + _vm._s(_vm.schoolDaysCount) + " dage")] : [_vm._v(_vm._s(_vm.schoolDaysCount) + " " + _vm._s(_vm.$t('vue.vacations_days_selector.school_days')))]], 2), _vm._v(" "), _c('direct-day-selector', {
	    attrs: {
	      "from-date": _vm.currFromDate,
	      "to-date": _vm.currToDate,
	      "selected-days": _vm.initialSelectedDates,
	      "include-weekends": _vm.includeWeekends
	    },
	    on: {
	      "toggled": _vm.dayToggled
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tasks text-dark",
	    class: {
	      'tasks--with-kids': _vm.isWithKids
	    }
	  }, [_c('div', {
	    staticClass: "tasks-header"
	  }, [_c('h4', [_vm._v("Personalets kalender")]), _vm._v(" "), _c('button', {
	    class: {
	      'submit-button create-btn': !_vm.isWithKids
	    },
	    on: {
	      "click": _vm.setCreateNewTask
	    }
	  }, [_vm._v("\n      Opret opgave for personale\n    ")]), _vm._v(" "), (_vm.isTaskModal) ? _c('CreateTask', {
	    attrs: {
	      "editTask": _vm.theEditTask,
	      "activeFilter": _vm.theActiveFilter
	    },
	    on: {
	      "create": _vm.createTask,
	      "close": _vm.closeUpdateTask
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedTasksWithProps), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', {
	      staticClass: "task__task"
	    }, [_c('div', {
	      staticClass: "task__name"
	    }, [_c('div', {
	      class: [{
	        'td-subject--hidden': !task.can_schedule
	      }, {
	        'td-subject': task.can_schedule
	      }],
	      style: ({
	        'background-color': task.color
	      }),
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(task)
	        }
	      }
	    }, [_vm._v(_vm._s(task.name) + "\n          ")])])]), _vm._v(" "), _c('td', {
	      staticClass: "task__hours"
	    }, [_vm._v(_vm._s(task.hours))]), _vm._v(" "), _c('td', {
	      staticClass: "task__calendars",
	      class: {
	        'd-select-lookalike': !task.v_is_active_d_select && task.v_staff_names.length < 1
	      },
	      attrs: {
	        "aria-placeholder-label": "Søg og vælg"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDSelect(task)
	        }
	      }
	    }, [(task.v_is_active_d_select) ? _c('DSelectCalendarIds', {
	      directives: [{
	        name: "on-clickaway",
	        rawName: "v-on-clickaway",
	        value: (_vm.closeDSelect),
	        expression: "closeDSelect"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: function () { return _vm.usersWithEvents(task).length > 0; },
	          arrow: true,
	          placement: 'bottom'
	        }),
	        expression: "{\n                              onShow: () => usersWithEvents(task).length > 0,\n                              arrow: true,\n                              placement : 'bottom'\n                            }"
	      }],
	      attrs: {
	        "show": _vm.activeDSelectShow,
	        "itemType": "USER",
	        "preSelectedItems": task.user_calendar_ids,
	        "itemsThatCantBeDeleted": _vm.usersWithEvents(task),
	        "showTags": false,
	        "content": _vm.getUserNames(_vm.usersWithEvents(task)) + ' har skemalagte aktiviteter og kan ikke slettes'
	      },
	      on: {
	        "update": function($event) {
	          return _vm.setSelectedUsers($event, task)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (!task.v_is_active_d_select && task.v_staff_names.length > 0) ? _c('div', {
	      staticClass: "task__users"
	    }, _vm._l((task.v_staff_names), function(user) {
	      return _c('p', [_vm._v(_vm._s(user))])
	    }), 0) : _vm._e()], 1)])
	  }), 0)]), _vm._v(" "), (_vm.tasks.length < 1) ? _c('div', {
	    staticClass: "explainer-div"
	  }, [_vm._v("Ikke oprettet nogen opgaver uden børn")]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "task__task"
	  }, [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
	    staticClass: "task__hours"
	  }, [_vm._v("Timer")]), _vm._v(" "), _c('th', {
	    staticClass: "task__calendars"
	  }, [_vm._v("Personale")])])])
	}]}

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-smartscreen",
	    style: (_vm.computedStyle)
	  }, [_c('div', {
	    staticClass: "do-smartscreen__header"
	  }, [_c('div', {
	    staticClass: "do-smartscreen__header__left"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.dateFormatted))])]), _vm._v(" "), _c('div', {
	    staticClass: "do-smartscreen__header__right"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n        Senest opdateret: " + _vm._s(_vm.latestUpdate) + "\n      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "table-container"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.eventsWithProps.length === 0) ? _c('tr', [_c('th', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen lektioner")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsWithProps), function(event) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(event.vEventTime) + " " + _vm._s(event.title))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(event.vRooms) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(event.vTeachers) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.vStudents))])])
	  })], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Tidspunkt")]), _vm._v(" "), _c('th', [_vm._v("Lokale")]), _vm._v(" "), _c('th', [_vm._v("Lærer")]), _vm._v(" "), _c('th', [_vm._v("Elever")])])])
	}]}

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-container",
	    class: {
	      'd-container--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "d_parent",
	    staticClass: "d-select__selected",
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_c('h5', [_vm._v(_vm._s(_vm.selectedUser ? _vm.selectedUser.name : _vm.userName))]), _vm._v(" "), _c('svg', {
	    staticClass: "tw-icon tw-icon-cheveron-selection",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	    }
	  })])]), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
	    ref: "d_child",
	    staticClass: "d-select__dropdown",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady, 'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('div', {
	    staticClass: "d-select-input",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "inputsearch",
	    attrs: {
	      "type": "search"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('ul', _vm._l((_vm.usersQuery), function(user) {
	    return _c('li', {
	      class: {
	        'user--is-selected': user.id === _vm.selectedUser.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectUser(user.id)
	        }
	      }
	    }, [_c('p', [_vm._v(_vm._s(user.name))])])
	  }), 0)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login"
	  }, [_c('a', {
	    on: {
	      "click": _vm.login
	    }
	  }, [_vm._v("Login")])])
	},staticRenderFns: []}

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'do-calendar__header': _vm.activeCalendarDate
	    }
	  }, [_c('div', {
	    staticClass: "d-cal__header text-dark"
	  }, [_c('div', {
	    staticClass: "d-cal__header__left"
	  }, [(_vm.userHasPermission('can_see_other_calendars')) ? _c('DCalendarSelect', {
	    attrs: {
	      "calendar": _vm.calendar
	    }
	  }) : _c('h2', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), (_vm.activeCalendarDate) ? [_c('div', {
	    staticClass: "do-button__multiple no-print"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	        onShow: function () { return _vm.hasHotKeys; }
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n               onShow: () => hasHotKeys\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-left4 no-print",
	    attrs: {
	      "content": _vm.tooltipArrowLeft
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('prev')
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "no-print do-button__multiple__bttn",
	    class: {
	      'bttn--disabled': _vm.isToday
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('today')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('repitition.today')) + "\n          ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	        onShow: function () { return _vm.hasHotKeys; }
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n               onShow: () => hasHotKeys\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-right4 ",
	    attrs: {
	      "content": _vm.tooltipArrowRight
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('next')
	      }
	    }
	  })])] : _vm._e(), _vm._v(" "), (_vm.dates) ? _c('h3', {
	    staticClass: "do-calendar__date"
	  }, [_vm._v(_vm._s(_vm.calendarDateInterval))]) : _vm._e(), _vm._v(" "), (_vm.isLoadingEvents) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__header__right no-print"
	  }, [(_vm.isMergeCalendar) ? _c('button', {
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowMergeCalendars(true)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_calendar')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.canEditPresence) ? _c('UserPresence', {
	    staticClass: "d-cal__header__left__presence",
	    attrs: {
	      "calid": _vm.calendarId,
	      "firstDayOfTheWeek": _vm.firstDayOfTheWeek,
	      "activeCalendarDate": _vm.activeCalendarDate,
	      "isModalLeft": true
	    },
	    on: {
	      "saved": function($event) {
	        return _vm.$emit('updateEvents')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.activeCalendarDate) ? _c('div', {
	    staticClass: "do-calculate-hours"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isShowCalculateHours = !_vm.isShowCalculateHours
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['calculate_hours']) + "\n          "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.isShowCalculateHours) ? _c('div', {
	    staticClass: "do-calculate-hours__dropdown"
	  }, [_c('div', {
	    staticClass: "do-calculate-hours__dropdown__header",
	    on: {
	      "click": function($event) {
	        _vm.isShowCalculateHours = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle"
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('CalculateHours', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "calendarId": _vm.calendarId,
	      "date": _vm.activeCalendarDate
	    }
	  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('CopyCalendar', {
	    attrs: {
	      "calid": _vm.calendarId,
	      "calendarType": _vm.calendarType,
	      "activeCalendarDate": _vm.activeCalendarDate,
	      "initCalendar": _vm.initCalendar
	    },
	    on: {
	      "copyCalendarModalOpen": function($event) {
	        return _vm.$emit('copyCalendarModalOpen', $event)
	      }
	    }
	  }), _vm._v(" "), _c('Print', {
	    attrs: {
	      "calendarId": _vm.calendarId,
	      "activeCalendarDate": _vm.activeCalendarDate
	    }
	  }), _vm._v(" "), (_vm.activeCalendarDate) ? _c('DCalendarHeaderDelete', {
	    attrs: {
	      "calendarId": _vm.calendarId,
	      "firstDayOfTheWeek": _vm.firstDayOfTheWeek,
	      "date": _vm.activeCalendarDate
	    },
	    on: {
	      "update": function($event) {
	        return _vm.$emit('updateCalendar')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-more2"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [(_vm.canBeLocked) ? _c('li', {
	    on: {
	      "click": _vm.toggleCalendarLock
	    }
	  }, [(_vm.isLocked) ? [_c('span', {
	    staticClass: "icon-lock5"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.editCalendarMenu.unlock')) + "\n            ")] : [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.lock')) + "\n            ")]], 2) : _vm._e(), _vm._v(" "), (_vm.canSeePublicCalendar) ? _c('li', {
	    on: {
	      "click": _vm.openPublicCalendar
	    }
	  }, [(_vm.isAnonymousAccessActivated) ? [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.see_public_view')) + "\n            ")] : [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.active_public_view')) + "\n            ")]], 2) : _vm._e(), _vm._v(" "), (_vm.canSeeMergeWithMergeCalendars) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowMergeCalendars(true)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_merge_calendars')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeExportCalendar) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowExportCalendarModal(true)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.calendar_export.export_calendar')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canToggleViewState) ? _c('li', [_c('span', {
	    staticClass: "icon-arrow-left4"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.editCalendarMenu.view')) + "\n            "), _c('ul', [_c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleCalendarView(0)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.5_days')))]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleCalendarView(1)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.7_days')))]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleCalendarView(2)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.7_days_and_24_hours')))])])]) : _vm._e(), _vm._v(" "), (_vm.canEditName) ? _c('li', {
	    on: {
	      "click": _vm.openEditNameModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.editCalendarMenu.edit_name')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canBeDeleted) ? _c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": _vm.openDeleteModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.editCalendarMenu.delete_calendar')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canBeArchived) ? _c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": _vm.archiveCalendar
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.editCalendarMenu.remove_calendar')) + "\n          ")]) : _vm._e()])]), _vm._v(" "), (_vm.isLocked) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left'
	      }),
	      expression: "{arrow: true,placement : 'left'}"
	    }],
	    attrs: {
	      "content": _vm.$t('vue2.editCalendarMenu.calendar_is_locked')
	    }
	  }, [(true) ? _c('div', {
	    staticClass: "d-cal__header__right__lock icon__bg-circle",
	    on: {
	      "click": _vm.toggleCalendarLock
	    }
	  }, [_c('span', {
	    staticClass: "icon-lock5"
	  })]) : _c('div', {
	    staticClass: "d-cal__header__right__lock"
	  }, [_c('span', {
	    staticClass: "icon-lock5"
	  })])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.calendar) ? _c('EditCalendarEditName', {
	    attrs: {
	      "calendar": _vm.calendar
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.calendar) ? _c('EditCalendarDelete', {
	    attrs: {
	      "calendar": _vm.calendar
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ExportCalendar', {
	    attrs: {
	      "isShowButton": false,
	      "isShowFromProp": _vm.isShowExportCalendarModal,
	      "calLink": _vm.iCalUrl
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowExportCalendarModal(false)
	      }
	    }
	  }), _vm._v(" "), (_vm.isShowMergeCalendars) ? _c('CalendarMergeModal', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "calendarId": _vm.calendarId,
	      "calendar": _vm.calendar
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowMergeCalendars(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowCalculateHours) ? _c('div', {
	    staticClass: "bg-overlay do-datepicker__dropdown__overlay",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.isShowCalculateHours = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal"
	  }, [(!_vm.isReadOnly) ? _c('div', {
	    staticClass: "d-guides"
	  }, [_c('h4', [_vm._v("Vejledning")]), _vm._v(" "), _vm._m(0), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('GrundskoleIndberetningTimetalFag', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "undervisningskema": _vm.undervisningskema,
	      "fagFraStil": _vm.fagFraStil,
	      "isReadOnly": _vm.isReadOnly
	    },
	    on: {
	      "update": _vm.updateSubject,
	      "updateKonfirmation": _vm.updateKonfirmation,
	      "updatePraktik": _vm.updatePraktik,
	      "setTolaerer": _vm.setTolaerer,
	      "setForanstaltning": _vm.setForanstaltning,
	      "nulstilKlasse": _vm.nulstilKlasse
	    }
	  }), _vm._v(" "), _c('GrundskoleIndberetningTimetalFagSpecial', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "undervisningskema": _vm.undervisningskema,
	      "isReadOnly": _vm.isReadOnly
	    },
	    on: {
	      "update": _vm.updateSubject,
	      "updateKonfirmation": _vm.updateKonfirmation,
	      "updatePraktik": _vm.updatePraktik,
	      "setTolaerer": _vm.setTolaerer,
	      "setForanstaltning": _vm.setForanstaltning
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("\n      I dette skema skal der indtastes oplysninger om de årlige undervisningstimer, som skolen planlægger at give\n      eleverne i de enkelte fag på hver årgang. Bemærk, at timetallene skal opgøres som undervisningstimer á 60\n      minutter.\n      Der er automatisk importeret timetal fra UVM, som I har mulighed for at tilpasse. Hvis I ikke ønsker at bruge\n      disse tal – eller ikke ønsker at indberette for en årgang – kan I blot klikke på \"Nulstil\".\n      "), _c('br'), _vm._v(" "), _c('a', {
	    staticClass: "text-link",
	    attrs: {
	      "target": "_blank",
	      "href": "https://test-data.stil.dk/grundskoleindberetning/Vejledninger/2024/1012/Praktisk%20vejledning_Antal%20elever%20og%20undervisningstimer_folkeskoler_2024.pdf"
	    }
	  }, [_vm._v("\n        Læs den officielle vejledning fra STIL her\n      ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('b', [_vm._v("Vær særlig opmærksom på:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("1) Tysk og Fransk skal udfyldes, da de står med 0."), _c('br'), _vm._v("2) Vælg hvilken årgang konfirmationsforberedelse finder\n        sted.")])
	}]}

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "active-user"
	  }, [(_vm.showCloseCross) ? _c('div', {
	    staticClass: "active-user__close-cross",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]) : _vm._e(), _vm._v(" "), _c('h2', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.allUsersInHash[_vm.activeUserId].name))]), _vm._v(" "), _c('TasksTable', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['subjects'],
	      "hoursTitle": "UV",
	      "id": "teaching",
	      "tasks": _vm.getAllUserSubjectsAndTeachingTasks,
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": _vm.getUserAssignedTeachingHours(_vm.activeUserId),
	      "isTeaching": true,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "edit": _vm.setEditTask,
	      "setActiveSubject": _vm.setActiveSubject
	    }
	  }), _vm._v(" "), _c('TasksTable', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['additional_tasks'],
	      "id": "tasks",
	      "hoursTitle": "Øvrig",
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "tasks": _vm.getAllUserTasksTask,
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": _vm.getUserAssignedTaskHours(_vm.activeUserId),
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "edit": _vm.setEditTask
	    }
	  }), _vm._v(" "), _c('TasksTable', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['preparation'],
	      "id": "preperation",
	      "hoursTitle": "Forb.",
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "tasks": _vm.getAllUserTasksPrep,
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": _vm.getUserAssignedPreparationHours(_vm.activeUserId),
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "edit": _vm.setEditTask
	    }
	  }), _vm._v(" "), (_vm.getAllUserTasksClub.length > 0) ? _c('TasksTable', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['club'],
	      "id": "club",
	      "hoursTitle": "SFO.",
	      "user": _vm.allUsersInHash[_vm.activeUserId],
	      "tasks": _vm.getAllUserTasksClub,
	      "userCalendarId": _vm.userCalId,
	      "assignedHours": _vm.getUserAssignedClubHours(_vm.activeUserId),
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "edit": _vm.setEditTask
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "active-user__agreements"
	  }, [_c('SubjectsDistributionUserAgreements', {
	    attrs: {
	      "userId": _vm.activeUserId
	    }
	  })], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.theActiveSubject) ? _c('DModal', {
	    staticStyle: {
	      "border-radius": "4px"
	    },
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.theActiveSubject = null
	      }
	    }
	  }, [_c('SubjectsDistributionUserEditHours', {
	    attrs: {
	      "slot": "insertComponent",
	      "subject": _vm.getTheActiveSubject,
	      "teacher": _vm.getTheActiveUser
	    },
	    on: {
	      "close": function($event) {
	        _vm.theActiveSubject = null
	      }
	    },
	    slot: "insertComponent"
	  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.theActiveSubject) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        _vm.theActiveSubject = null
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "datepickerrange"
	  }, [_c('div', {
	    staticClass: "dateselector dateselector-start"
	  }, [_c('dateselector', {
	    attrs: {
	      "date": _vm.start
	    },
	    on: {
	      "changed": _vm.setStartDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "dateselector dateselector-line"
	  }, [_vm._v("\n    -\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "dateselector dateselector-end"
	  }, [_c('dateselector', {
	    attrs: {
	      "date": _vm.end
	    },
	    on: {
	      "changed": _vm.setEndDate
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Hvilken ansættelse skal det tælle som?")]), _c('br'), _vm._v(" "), _c('select', {
	    staticClass: "do-select",
	    domProps: {
	      "value": _vm.selectedEmploymentTitle
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onChange($event.target.value)
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }, [_vm._v("Vælg ansættelse")]), _vm._v(" "), _vm._l((_vm.employmentToSelectForRules), function(employmentsType) {
	    return _c('option', {
	      domProps: {
	        "value": employmentsType
	      }
	    }, [_vm._v("\n      " + _vm._s(employmentsType) + "\n    ")])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.create_activity.create_activity_for')) + " " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.title')))]), _vm._v(" "), _c('div', {
	    staticClass: "choose-subject"
	  }, [_c('dSelect', {
	    attrs: {
	      "items": _vm.sortedSubjects,
	      "receiveData": _vm.theNewSubject,
	      "multiple": false,
	      "placeholder": _vm.$t('vue2.create_activity.search_or_create'),
	      "itemSpaceBetween": true
	    },
	    on: {
	      "enter": _vm.onCreateNewSubject,
	      "update": _vm.setSubject,
	      "searchText": _vm.setTheSearchText,
	      "onSearchTextDebounced": _vm.onSearchTextDebounced,
	      "close": _vm.onCloseDSelect
	    },
	    scopedSlots: _vm._u([_vm._l((_vm.sortedSubjects), function(item, index) {
	      return {
	        key: "test",
	        fn: function(slotProps) {
	          return [_c('div', {
	            staticClass: "choose-subject__event_type"
	          }, [_vm._v("\n                " + _vm._s(slotProps.item.vSubjectType) + "\n              ")])]
	        }
	      }
	    })], null, true)
	  }, [_vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_c('h4', {
	    staticClass: "create-subject-link",
	    on: {
	      "click": _vm.onCreateNewSubject
	    }
	  }, [_vm._v("\n                + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.theSearchText) + "\"\n              ")])])]), _vm._v(" "), (_vm.isShowCreateSubjectButton) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "icon__bg-circle create-new-subject",
	    attrs: {
	      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.theSearchText + "\" "
	    },
	    on: {
	      "click": _vm.onCreateNewSubject
	    }
	  }, [_c('span', {
	    staticClass: "d-icon-plus"
	  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tbody', {
	    staticClass: "do-tbody"
	  }, [_c('tr', {
	    staticClass: "calendar-header"
	  }, [_c('td', [_c('div', {
	    staticClass: "calendar-header__title"
	  }, [_c('DDropdown', [_c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('createSubject', {
	          calendar: _vm.calendar,
	          users: _vm.users
	        })
	      }
	    }
	  }, [_vm._v("\n            Tilføj person til stue\n          ")])])]), _vm._v("\n      " + _vm._s(_vm.calendar.name) + "\n    ")], 1)]), _vm._v(" "), _c('td', {
	    staticClass: "norm"
	  }, [_vm._v("Norm")]), _vm._v(" "), _c('td', {
	    staticClass: "norm"
	  }, [_vm._v("I ugen")]), _vm._v(" "), _vm._l((_vm.eventsInDays), function(day) {
	    return _c('td', {
	      key: day.dateId
	    }, [_c('div', {
	      staticClass: "calendar__header__day"
	    }, [_c('div', [_c('DutySchedulePlanCalendarDayStats', {
	      attrs: {
	        "openingHours": _vm.openingHours,
	        "hours": day.v_formattedTime
	      }
	    })], 1)])])
	  })], 2), _vm._v(" "), _vm._l((_vm.usersWithCalc), function(user) {
	    return _c('tr', {
	      key: ("user-row-" + (user.id)),
	      staticClass: "user-row"
	    }, [_c('td', [_c('div', {
	      staticClass: "user-name"
	    }, [_c('DDropdown', {
	      staticClass: "title--grey",
	      on: {
	        "open": function($event) {
	          return _vm.readUserSubject(user)
	        }
	      }
	    }, [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [(_vm.isLoadingTheUserSubject) ? _c('li', [_c('div', {
	      staticClass: "do-spinner"
	    })]) : _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteUser(user)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    }), _vm._v(" " + _vm._s(_vm.theUserSubject && _vm.theUserSubject.can_delete ? 'Slet' : 'Fjern') + " fra\n            stue\n          ")])])]), _vm._v("\n      " + _vm._s(user.name) + "\n    ")], 1)]), _vm._v(" "), _c('td', {
	      staticClass: "norm"
	    }, [_vm._v(_vm._s(user.v_employment))]), _vm._v(" "), _c('td', {
	      staticClass: "norm"
	    }, [_vm._v(_vm._s(user.v_events.v_minutesFormatted))]), _vm._v(" "), _vm._l((_vm.days), function(day) {
	      return _c('td', {
	        key: ("day-cell-" + (user.id) + "-" + (day.dateFormatted))
	      }, [_c('DutyScheduleCalendarUserDay', {
	        attrs: {
	          "user": user,
	          "date": day.date,
	          "eventsInHash": _vm.eventsInHash,
	          "subjectsInUserCalIdHash": _vm.subjectsInUserCalIdHash,
	          "theCreateEventObj": _vm.theCreateEventObj
	        },
	        on: {
	          "createEvent": function($event) {
	            return _vm.$emit('createEvent', $event)
	          },
	          "editEvent": function($event) {
	            return _vm.$emit('editEvent', $event)
	          }
	        }
	      })], 1)
	    })], 2)
	  }), _vm._v(" "), (_vm.theDeleteUser) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isDeletingUserSubject
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setTheDeleteUser(null)
	      },
	      "confirm": _vm.deleteUserSubject
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DSelect', {
	    attrs: {
	      "items": _vm.itemsFiltered,
	      "itemsSelected": _vm.itemsSelectedFormatted,
	      "placeholder": "Tilføj underviser",
	      "isDeleteAllAnOption": false,
	      "show": true
	    },
	    on: {
	      "update": _vm.update,
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('h4', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_vm._v("Ingen personer matcher")])])
	},staticRenderFns: []}

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid grid-pad box-size",
	    staticStyle: {
	      "overflow": "initial"
	    }
	  }, [_c('div', {
	    staticClass: "col-1-1 text-dark"
	  }, [_c('div', {
	    staticClass: "substitution"
	  }, [_c('div', {
	    staticClass: "header width-100"
	  }, [_c('div', {
	    staticClass: "flex space-between align-center"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.substitution.substitution')))]), _vm._v(" "), _c('div', {
	    staticClass: "substitution__header__right"
	  }, [_c('SubsAbsentWithoutEnd'), _vm._v(" "), (_vm.userCanSeeInternalNote) ? _c('SubsNote', {
	    attrs: {
	      "date": _vm.getDate
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isTestingCreateAKU) ? _c('button', {
	    staticClass: "marg-10-right no-print aku-button",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModalOutOfSchool(true)
	      }
	    }
	  }, [_vm._v("\n              Opret klassefravær\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.localSchedulerView) ? _c('button', {
	    staticClass: "marg-10-right no-print",
	    staticStyle: {
	      "height": "38px",
	      "width": "38px"
	    },
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "date-buttons marg-5-right",
	    class: {
	      inactive: _vm.isToday
	    },
	    on: {
	      "click": _vm.setToday
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.substitution.today')) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "date-buttons marg-5-right",
	    on: {
	      "click": _vm.prevDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  })]), _vm._v(" "), _c('DatePicker', {
	    attrs: {
	      "date": _vm.getDate
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "marg-5-left date-buttons",
	    on: {
	      "click": _vm.nextDay
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  })]), _vm._v(" "), _c('SubstitutionCreate', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.allUsersSortedOnName,
	      "usersWithOngoingAbsenceInHash": _vm.usersWithOngoingAbsenceInHash,
	      "allUsersInCalIdHash": _vm.allUsersInCalIdHash
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-header__subHeader"
	  }, [_c('div', {
	    staticClass: "absentUsersFilters"
	  }, [_c('div', {
	    staticClass: "absentUsersFilters__filter",
	    class: {
	      'absentUsersFilters__filter--active': _vm.isAbsentUserFilter('')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setAbsentFilter('')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "absentUsersFilters__filter__number"
	  }, [_vm._v(_vm._s(_vm.absentUsersFromUserSet.length))]), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['absent_today']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "absentUsersFilters__filter",
	    class: {
	      'absentUsersFilters__filter--active': _vm.isAbsentUserFilter('handled')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setAbsentFilter('handled')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "absentUsersFilters__filter__number"
	  }, [_vm._v(_vm._s(_vm.absentUsersHandled.length))]), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['absent_handled']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "absentUsersFilters__filter",
	    class: {
	      'absentUsersFilters__filter--active': _vm.isAbsentUserFilter('unhandled')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setAbsentFilter('unhandled')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "absentUsersFilters__filter__number"
	  }, [_vm._v(_vm._s(_vm.absentUsersUnhandled.length))]), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['absent_unhandled']) + "\n          ")])]), _vm._v(" "), _c('app-flipper-button', {
	    attrs: {
	      "preselectedTab": _vm.activeTab
	    },
	    on: {
	      "update": _vm.setSchedulerView
	    }
	  })], 1), _vm._v(" "), ((_vm.isLoadingSchoolCalenders || _vm.dataIsLoading) && !_vm.localSchedulerView) ? _c('spinner', {
	    staticStyle: {
	      "margin-top": "150px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.localSchedulerView && !_vm.dataIsLoading && !_vm.isLoadingSchoolCalenders) ? _vm._l((_vm.absentUsers), function(user, idx) {
	    return _c('SubsUser', {
	      key: user.id,
	      attrs: {
	        "user": user,
	        "activeDSelect": _vm.activeDSelect,
	        "date": _vm.getDate,
	        "allEvents": _vm.allEvents,
	        "calsAndEventIds": _vm.calsAndEventIds,
	        "allEventsInAHash": _vm.allEventsInAHash,
	        "allUsersSortedOnName": _vm.allUsersSortedOnName,
	        "allUsersAndEvents": _vm.allUsersAndEvents,
	        "allCalendarsInAHash": _vm.allCalendarsInAHash,
	        "longAbsentListInHash": _vm.longAbsentListInHash,
	        "absentUsersHandledHash": _vm.absentUsersHandledHash,
	        "isSubStatusPendingActive": _vm.isSubStatusPendingActive
	      },
	      on: {
	        "splitLesson": _vm.setSplitLesson,
	        "setActiveDSelect": _vm.setActiveDSelect,
	        "selectedUser": function($event) {
	          _vm.selectedUser = user
	        },
	        "removeSubs": _vm.setRemoveSubsFromEvent,
	        "showLog": _vm.showEventLog
	      }
	    })
	  }) : _vm._e(), _vm._v(" "), (_vm.localSchedulerView) ? [_c('div', {
	    staticClass: "sub-scheduler"
	  }, [_c('div', {
	    staticClass: "sub-scheduler__header"
	  }, [_c('div', {
	    staticClass: "sub-scheduler__header__left"
	  }, [_c('div', {
	    staticClass: "sub-scheduler__filters sub-scheduler__filters__subzen"
	  }, [_c('SchedulerSort', {
	    attrs: {
	      "selected": _vm.selectedSort,
	      "locale": _vm.locale
	    },
	    on: {
	      "onSortBy": _vm.onSortBy
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInLeft"
	    }
	  }, [(_vm.selectedSort === 'subzen') ? _c('scheduler-prioritizer', {
	    attrs: {
	      "propsIsPrioritizerActive": _vm.isPrioritizerActive
	    },
	    on: {
	      "setIsPrioritizerActive": function($event) {
	        _vm.isPrioritizerActive = $event
	      }
	    }
	  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "sub-scheduler__header__right sub-scheduler__header__right__filters"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['absent'],
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFiltersAbsentUsers
	    },
	    on: {
	      "select": _vm.toggleAbsentFilter,
	      "clear": _vm.clearAllAbsentFilters
	    }
	  }), _vm._v(" "), _c('DoFilters', {
	    attrs: {
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters,
	      "selectedQuickFilters": _vm.selectedQuickFilters
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": _vm.clearAllTags,
	      "toggleQuickFilter": function($event) {
	        return _vm.toggleQuickFilter($event)
	      },
	      "clearAll": _vm.clearAllFiltersForSubs
	    }
	  })], 1)]), _vm._v(" "), _c('scheduler', {
	    attrs: {
	      "title": _vm.text,
	      "subsTitle": _vm.subsHeadline,
	      "items": _vm.absentAndSubs,
	      "isSortOnName": _vm.sortOnName,
	      "date": _vm.getDate,
	      "isSubStatusPendingActive": _vm.isSubStatusPendingActive,
	      "allCalendarsInHash": _vm.allCalendarsInAHash,
	      "longAbsentListInHash": _vm.longAbsentListInHash
	    },
	    on: {
	      "removeSubs": _vm.setRemoveSubsFromEvent,
	      "showLog": _vm.showEventLog,
	      "setCreateEventOnUser": _vm.setCreateEventOnUser,
	      "splitLesson": _vm.setSplitLesson,
	      "setTheOutOfSchoolLesson": function($event) {
	        return _vm.setTheOutOfSchoolLesson($event)
	      }
	    }
	  })], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.activeSplitLesson !== null) ? _c('splitLesson', {
	    attrs: {
	      "lesson": _vm.activeSplitLesson
	    },
	    on: {
	      "submitted": _vm.onSubmittedSplitEvent,
	      "closeSplitEvent": _vm.closeSplitLesson
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('AppModal', {
	    attrs: {
	      "submitTxt": _vm.i18n[_vm.locale]['button_text']
	    },
	    on: {
	      "close": function($event) {
	        _vm.isModal = false
	      },
	      "submit": _vm.removeSubs
	    }
	  }, [_c('h2', {
	    staticClass: "pad-10",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['remove_subs']) + "\n      ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['substitutes_for']))]), _vm._v(" "), _c('ul', {
	    staticClass: "marg-20-top marg-20-bottom bold text-blue"
	  }, _vm._l((_vm.userAndLessonAndSubsToBeDeleted.subsForTheSubToBeRemoved), function(sub) {
	    return _c('li', {
	      key: sub
	    }, [_vm._v("\n            " + _vm._s(_vm.allUsersInCalIdHash[sub].name) + "\n          ")])
	  }), 0), _vm._v(" "), _c('p', {
	    staticClass: "marg-5-bottom"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['has_to_remove_subs']) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['click_on_remove_all']) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.eventChangesEvent) ? _c('AppModal', {
	    attrs: {
	      "submitTxt": "OK",
	      "isShowFooter": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.eventChangesEvent = null
	      }
	    }
	  }, [_c('h2', {
	    staticClass: "pad-10",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.eventChangesEvent.title))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('EventChanges', {
	    attrs: {
	      "event-id": _vm.eventChangesEvent.id
	    }
	  })], 1)]) : _vm._e()], 1), _vm._v(" "), (_vm.activeAbsenceReason) ? _c('SubsEditAbsence') : _vm._e(), _vm._v(" "), (_vm.activeAbsentUser) ? _c('SubsUserPanel', {
	    attrs: {
	      "activeDate": _vm.getDate,
	      "isSubStatusPendingActive": _vm.isSubStatusPendingActive
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setActiveAbsentUser(null)
	      },
	      "readEvents": _vm.readEvents
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.createEventOnUser && _vm.createEventOnUser.user) ? _c('CreateTask', {
	    attrs: {
	      "user": _vm.createEventOnUser.user,
	      "initDate": _vm.createEventOnUser.date
	    },
	    on: {
	      "close": function($event) {
	        _vm.setCreateEventOnUser(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isModalOutOfSchool) ? _c('OutOfSchool', {
	    attrs: {
	      "initDate": _vm.getDate
	    },
	    on: {
	      "onCreatedEvents": _vm.readEvents,
	      "close": function($event) {
	        return _vm.setIsModalOutOfSchool(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theOutOfSchoolLesson) ? _c('DModalOutOfSchoolLesson', {
	    attrs: {
	      "event": _vm.theOutOfSchoolLesson,
	      "eventIdProp": 'id'
	    },
	    on: {
	      "updated": _vm.onOutOfSchoolLessonUpdated,
	      "close": function($event) {
	        return _vm.setTheOutOfSchoolLesson(null)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "copy-rotate text-dark"
	  }, [_c('button', {
	    ref: "copy_calendars_button",
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleDropdown.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("Rotating schedule\n  ")]), _vm._v(" "), (_vm.isDropdown) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "copy-calendars__panel"
	  }, [_c('div', {
	    staticClass: "copy-rotate__header"
	  }, [_c('h3', [_vm._v("Rotating schedule:\n            "), (!_vm.isSeeDates) ? [_vm._v("Select days to copy")] : [_vm._v("Select dates to insert")]], 2), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.closeDropdown
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "copy-rotate__body"
	  }, [(!_vm.isSeeDates) ? _c('div', [(_vm.isLoading || _vm.isLoadingSchoolSettings) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : [_c('div', {
	    staticClass: "d-copy-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n                Number of days\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-number-picker"
	  }, [_c('button', {
	    on: {
	      "click": _vm.subtractDay
	    }
	  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.numberOfDays),
	      expression: "numberOfDays"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.numberOfDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.numberOfDays = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.addDay
	    }
	  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', [_c('ul', {
	    staticClass: "copy-rotate__number-of-days"
	  }, _vm._l((_vm.daysToCopy), function(day, index) {
	    return _c('li', {
	      key: index
	    }, [_c('p', {
	      staticClass: "d-circle"
	    }, [_vm._v(_vm._s(day.label))]), _vm._v(" "), _c('DateSelector', {
	      attrs: {
	        "date": day.date
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.setDayToCopyDate($event, index)
	        }
	      }
	    })], 1)
	  }), 0)])]], 2) : _vm._e(), _vm._v(" "), (_vm.isSeeDates) ? _c('CopyCalendarRotateDates', {
	    attrs: {
	      "initStartDate": _vm.initStartPasteDate,
	      "schoolId": _vm.schoolId,
	      "daysToCopy": _vm.daysToCopy
	    },
	    on: {
	      "pasteDates": _vm.setPasteDates
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "copy-rotate__footer"
	  }, [(_vm.isSeeDates) ? _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isSeeDates = false
	      }
	    }
	  }, [_vm._v("Back to number of days")]) : _vm._e(), _vm._v(" "), (!_vm.isSeeDates) ? _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isSeeDates = true
	      }
	    }
	  }, [_vm._v("See dates")]) : _vm._e(), _vm._v(" "), (_vm.isSeeDates) ? _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Submit days")]) : _vm._e()])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('CreateTaskForm', {
	    attrs: {
	      "user": _vm.user,
	      "date": _vm.date,
	      "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject
	    },
	    on: {
	      "setDate": _vm.setDate,
	      "close": function($event) {
	        return _vm.$emit('close')
	      },
	      "createNewSubject": function($event) {
	        return _vm.setCreateNewSubject($event)
	      },
	      "onCreatedEvent": _vm.onCreatedEvent
	    }
	  }), _vm._v(" "), (_vm.theCreateNewSubjectName) ? _c('CreateTaskNewSubject', {
	    attrs: {
	      "user": _vm.user,
	      "date": _vm.date,
	      "title": _vm.theCreateNewSubjectName
	    },
	    on: {
	      "newSubject": _vm.onNewSubject,
	      "close": function($event) {
	        return _vm.setCreateNewSubject(null)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.styleObj.left !== -10),
	      expression: "styleObj.left !== -10"
	    }]
	  }, [_c('div', {
	    staticClass: "do-scheduler__line",
	    style: ([{
	        left: _vm.styleObj.left + 'px'
	      },
	      {
	        backgroundColor: this.styleObj.color
	      }
	    ])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "do-scheduler__line",
	    style: ([{
	        right: _vm.styleObj.right + 'px'
	      },
	      {
	        backgroundColor: this.styleObj.color
	      }
	    ])
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.teachersInKlassSameTime.length > 0),
	      expression: "teachersInKlassSameTime.length > 0"
	    }]
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.substitution.lessons_that_overlap_in_class')) + "\n  ")]), _vm._v(" "), _c('ul', [_vm._l((_vm.teachersInKlassSameTime), function(userAndLesson, key) {
	    return (_vm.isShowAllTeachers || key < _vm.numberOfTeachersToShow) ? _c('li', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'left',
	          boundary: 'window',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                  arrow: true,\n                  placement: 'left',\n                  boundary: 'window',\n                  zIndex: 2147483010\n                }"
	      }],
	      key: userAndLesson.user.user_calendar_id,
	      staticClass: "small-lesson",
	      class: {
	        'user--is-absent': userAndLesson.user.v_overlapping_absence.length > 0
	      },
	      style: ({
	        'border-left-color': userAndLesson.lesson.color
	      }),
	      attrs: {
	        "content": userAndLesson.user.v_overlapping_absence.length < 1 ? userAndLesson.lesson.v_title : userAndLesson.user.v_overlapping_absence
	      }
	    }, [(userAndLesson.user.v_is_substitute) ? _c('span', {
	      staticClass: "icon-users"
	    }) : _vm._e(), _vm._v("\n      " + _vm._s(userAndLesson.user.name) + "\n    ")]) : _vm._e()
	  }), _vm._v(" "), (_vm.teachersInKlassSameTime.length > _vm.numberOfTeachersToShow) ? _c('li', {
	    staticClass: "text-link",
	    on: {
	      "click": function($event) {
	        _vm.isShowAllTeachers = !_vm.isShowAllTeachers
	      }
	    }
	  }, [(!_vm.isShowAllTeachers) ? [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.show_more')) + " (" + _vm._s(_vm.numberOfTeachersHidden) + ")\n      ")] : [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.show_less')) + "\n      ")]], 2) : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "absence-reasons text-dark pad-1"
	  }, [_c('div', {
	    staticClass: "absence-reasons__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['absence_reasons']))]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom'\n                }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    attrs: {
	      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>N</span></p>'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateAbsenceReason(true)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n['create_absence']) + "\n    ")])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : [(_vm.absenceReasonsActive.length === 0) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n['no_absence_reasons_created']))]) : _c('AbsenceReasonsTable', {
	    attrs: {
	      "items": _vm.absenceReasonsActive
	    },
	    on: {
	      "editAbsencePrivate": _vm.editAbsencePrivate,
	      "toggleArchived": _vm.toggleArchived
	    }
	  }), _vm._v(" "), (_vm.absenceReasonsArchived.length > 0) ? _c('p', {
	    staticClass: "text-link marg-1-top",
	    on: {
	      "click": function($event) {
	        _vm.isShowArchived = !_vm.isShowArchived
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isShowArchived ? _vm.i18n['hide_archived'] : _vm.i18n['show_archived']) + "\n      " + _vm._s('(' + _vm.absenceReasonsArchived.length + ')'))]) : _vm._e(), _vm._v(" "), (_vm.isShowArchived && _vm.absenceReasonsArchived.length > 0) ? _c('AbsenceReasonsTable', {
	    attrs: {
	      "items": _vm.absenceReasonsArchived
	    },
	    on: {
	      "editAbsencePrivate": _vm.editAbsencePrivate,
	      "toggleArchived": _vm.toggleArchived
	    }
	  }) : _vm._e()], _vm._v(" "), (_vm.isCreateAbsenceReason) ? _c('AbsenceReasonsCreate', {
	    attrs: {
	      "reasons": _vm.absenceReasons
	    },
	    on: {
	      "create": _vm.handleCreateReason,
	      "cancel": function($event) {
	        return _vm.setIsCreateAbsenceReason(false)
	      }
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.institutionNumberConfirmed
	    }
	  }), _vm._v("\n    Institutionsnummer\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    Bekræft dit institutionsnummer\n    850999\n    "), _c('button', {
	    on: {
	      "click": _vm.institutionNumberConfirmedClick
	    }
	  }, [_vm._v("Ja det er korrekt")])]), _vm._v(" "), _c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.dataAgreementConfirmed
	    }
	  }), _vm._v("\n    Dataaftale godkendt\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    Din skole har godkendt dataaftalen.\n    Din skole har ikke godkendt dataaftalen.\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.locationsConfirmed
	    }
	  }), _vm._v("\n    Lokaler oprettet i Aula\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    Lokaler er oprettet i Aula\n    "), _c('button', {
	    on: {
	      "click": _vm.locationsConfirmedClick
	    }
	  }, [_vm._v("Ja det er korrekt")])]), _vm._v(" "), _c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.usersImported
	    }
	  }), _vm._v("\n    Brugere importeret\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    35 ud af 45 brugere er importeret.\n    "), _c('button', {
	    on: {
	      "click": _vm.usersImportedClick
	    }
	  }, [_vm._v("Vis brugere der kan importeres")])]), _vm._v(" "), _c('div', {
	    staticClass: "selector"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle",
	    class: {
	      active: _vm.groupsImported
	    }
	  }), _vm._v("\n    Grupper importeret\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    15 ud af 18 grupper er importeret.\n    "), _c('button', {
	    on: {
	      "click": _vm.groupsImportedClick
	    }
	  }, [_vm._v("Vis grupper der kan importeres")])])])
	},staticRenderFns: []}

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table d-table__tasks"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'name'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('name')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.getI18n(_vm.title)) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'calendar'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('calendar')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.task_overview.belongs_to')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), (!_vm.isOnlyShowScheduled) ? _c('th', {
	    staticClass: "is-number th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'hours'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('hours')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "th-sorter is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'actual'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('actual')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && !_vm.isOnlyShowScheduled) ? _c('th', {
	    staticClass: "th-sorter is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'diff'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('diff')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.tasks.length < 1) ? _c('tr', [_c('td', {
	    staticStyle: {
	      "width": "90%"
	    }
	  }, [_c('div', {
	    staticClass: "italic",
	    staticStyle: {
	      "padding": "4px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.no_tasks_assigned')))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.isShowScheduled) ? _c('td') : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td') : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedTasks), function(task) {
	    return _c('tr', {
	      key: task.id,
	      attrs: {
	        "data-task-id": task.id
	      }
	    }, [_c('td', [_c('div', {
	      staticClass: "task-with-edit"
	    }, [(task.can_schedule === 't') ? _c('div', {
	      staticClass: "subjects_subject",
	      style: ({
	        'background': task.color
	      })
	    }, [_vm._v("\n          " + _vm._s(task.name) + "\n        ")]) : _c('div', {
	      staticClass: "subjects_subject subjects_subject--not-subject"
	    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [_vm._v("\n      " + _vm._s(task.calendar) + "\n    ")]), _vm._v(" "), (!_vm.isOnlyShowScheduled) ? _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.getTasksHours(task)))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.getTaskActual(task)))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && !_vm.isOnlyShowScheduled) ? _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(task.diff))]) : _vm._e()])
	  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (!_vm.isOnlyShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'hours'
	    }
	  }, [_vm._v(_vm._s(_vm.sumOfHours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'actual'
	    }
	  }, [_vm._v(_vm._s(_vm.sumOfActual) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && !_vm.isOnlyShowScheduled) ? _c('td', {
	    staticClass: "total-hours is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'diff'
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.sumOfDiff) + "\n    ")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        trigger: 'click'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              trigger : 'click'\n            }"
	    }],
	    staticClass: "do-bttn",
	    attrs: {
	      "slot": "title",
	      "content": _vm.$t('vue.deleteday.delete_day_or_week')
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": function($event) {
	        return _vm.setIsConfirmDeletion('week')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue.deleteday.whole_week')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.weekDays), function(day) {
	    return _c('li', {
	      staticClass: "capitalize",
	      on: {
	        "click": function($event) {
	          return _vm.setIsConfirmDeletion(day)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(day.name) + "\n      ")])
	  })], 2)]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isDeleting
	    },
	    on: {
	      "close": _vm.closeIsConfirmDelete,
	      "confirm": _vm.onConfirmDelete
	    }
	  }, [_c('h3', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.theDeleteText))])]) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "d_cal_dragged",
	    staticClass: "d-cal__subjects__subject__dragged",
	    style: (_vm.styleObj)
	  }, [_vm._v("\n  " + _vm._s(_vm.subjectTitle) + "\n")])
	},staticRenderFns: []}

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    ref: "input",
	    class: _vm.customClass,
	    on: {
	      "input": function($event) {
	        return _vm.updateValue($event.target.value)
	      },
	      "focus": _vm.selectAll,
	      "blur": _vm.formatValue
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-public"
	  }, [_c('div', {
	    staticClass: "do-public__header"
	  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.calendarName))])]), _vm._v(" "), _c('div', {
	    staticClass: "do-public__body"
	  }, [(!_vm.calendar) ? _c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : _c('div', [_c('SmartScreen', {
	    attrs: {
	      "calendarId": _vm.calendarId
	    }
	  })], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "logo"
	    }
	  }, [_c('span', {
	    staticClass: "icon-docendo",
	    attrs: {
	      "id": "d-icon"
	    }
	  })])
	}]}

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-form__reductions"
	  }, [(_vm.isLoadingReductions) ? _c('Loader', {
	    attrs: {
	      "bg-color": '#f6f9fc'
	    }
	  }) : _c('table', {
	    staticClass: "do-table do-table--striped"
	  }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
	    staticClass: "td-number td-sum"
	  }, [_vm._v(_vm._s(_vm.totalReductionHours))])]), _vm._v(" "), _c('tbody', [(_vm.subjectReductionsSorted.length === 0) ? _c('tr', [_c('p', {
	    staticClass: "pad-1 italic"
	  }, [_vm._v("Ingen reduktioner")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.subjectReductionsSorted), function(subjectReduction) {
	    return _c('tr', {
	      key: subjectReduction.id
	    }, [_c('td', [_vm._v("\n        " + _vm._s(subjectReduction.vActivityTitle) + " (" + _vm._s(subjectReduction.vActivityReductionHours) + ")\n      ")]), _vm._v(" "), _c('td', {
	      staticClass: "td-number"
	    }, [_vm._v(_vm._s(subjectReduction.vFormattedHours))])])
	  })], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.emitClickAway),
	      expression: "emitClickAway"
	    }],
	    staticClass: "sub-popover__content"
	  }, [_c('div', {
	    staticClass: "sub-popover__content__header",
	    style: ({
	      'backgroundColor': _vm.lesson.color
	    })
	  }, [(_vm.lesson.event_type === 'absence') ? _c('h3', [_vm._v(_vm._s(_vm.getUser(_vm.lesson.calendar_id)))]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.lesson.title) + ",\n      "), _vm._l((_vm.klassesOnLesson), function(klass) {
	    return _c('a', {
	      staticClass: "link-white marg-5-right",
	      attrs: {
	        "href": klass.url,
	        "target": "blank"
	      }
	    }, [_vm._v("\n        " + _vm._s(klass.name) + "\n        "), _c('span', {
	      staticClass: "icon-calendar5",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "clock-and-delete"
	  }, [_c('p', [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm._f("time")(_vm.lesson.start)) + " - " + _vm._s(_vm._f("time")(_vm.lesson.end)))]), _vm._v(" "), (_vm.lesson.event_type !== 'absence') ? _c('DDropdown', {
	    attrs: {
	      "closeFromProp": _vm.propToCloseDropdown
	    }
	  }, [_c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [(!_vm.lesson.away) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setActiveSplitLesson(_vm.lesson)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['split_lesson']) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onDeletedLesson(_vm.lesson)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.substitution.delete_lesson')) + "\n          ")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('setTheOutOfSchoolLesson', _vm.lesson)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-home2 icon-home2-away"
	  }), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].out_of_school) + "\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__do-warning__container"
	  }, [(_vm.isCanceled) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].canceled))]) : _vm._e(), _vm._v(" "), (_vm.isAway) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning"
	  }, [_c('span', {
	    staticClass: "icon-home2 icon-home2-away",
	    staticStyle: {
	      "margin-right": "2px"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].out_of_school))]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "sub-popover__container"
	  }, [(_vm.lesson.event_type !== 'absence') ? [_c('ul', {
	    staticClass: "sub-popover__content__body"
	  }, [_c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.sub_scheduler.choose_sub')) + "\n          ")]), _vm._v(" "), _c('dSelectSub', {
	    staticStyle: {
	      "font-size": "11px"
	    },
	    attrs: {
	      "addClass": ['small-font'],
	      "user": _vm.user,
	      "eventId": _vm.lesson.id,
	      "startTime": _vm.lesson.start,
	      "endTime": _vm.lesson.end,
	      "subs": _vm.substitutesOnLesson,
	      "othersOnLesson": _vm.othersOnLesson
	    },
	    on: {
	      "addedSubFromTeachers": function($event) {
	        _vm.propStatus = 1
	      },
	      "add": _vm.addSubstitute,
	      "remove": _vm.removeSubstitute
	    }
	  })], 1), _vm._v(" "), _c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.substitute_for')) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), (_vm.othersOnLesson.length > 0) ? _c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.other_users')) + "\n          ")]), _vm._v(" "), _c('div', [_vm._l((_vm.othersOnLesson), function(other, idx) {
	    return (idx < _vm.showAllOnLesson) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          zIndex: 123123123123,
	          onShow: function () { return other.v_isUserAbsentFromLesson.length > 0; }
	        }),
	        expression: "{\n                  arrow: true,\n                  zIndex: 123123123123,\n                  onShow: () => other.v_isUserAbsentFromLesson.length > 0\n                }"
	      }],
	      key: other.id,
	      class: {
	        'user--is-absent': other.v_isUserAbsentFromLesson.length > 0
	      },
	      attrs: {
	        "content": other.v_isUserAbsentFromLesson
	      }
	    }, [_vm._v(" " + _vm._s(other.name)), (idx < _vm.othersOnLesson.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), _c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAllOnLesson < _vm.othersOnLesson.length),
	      expression: "showAllOnLesson < othersOnLesson.length"
	    }],
	    staticClass: "text-blue pointer",
	    on: {
	      "click": function($event) {
	        _vm.showAllOnLesson = _vm.othersOnLesson.length
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.substitution.see_all')) + "\n            ")]), _vm._v(" "), _c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAllOnLesson > 3),
	      expression: "showAllOnLesson > 3"
	    }],
	    staticClass: "text-blue pointer",
	    on: {
	      "click": function($event) {
	        _vm.showAllOnLesson = 3
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.substitution.see_less')))])], 2)]) : _vm._e(), _vm._v(" "), _c('LessonOverlapInKlass', {
	    attrs: {
	      "lesson": _vm.lesson
	    }
	  }), _vm._v(" "), _c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle"
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.sub_scheduler.status')) + "\n          ")]), _vm._v(" "), _c('lessonsSubstitutionStatus', {
	    attrs: {
	      "dropdown-placement": "bottom-start",
	      "user": _vm.user,
	      "statusProp": _vm.propStatus,
	      "lesson": _vm.lesson,
	      "othersOnLesson": _vm.othersOnLesson,
	      "userCalendarId": _vm.user.user_calendar_id,
	      "isSubStatusPendingActive": _vm.isSubStatusPendingActive
	    }
	  })], 1), _vm._v(" "), _c('li', [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v("\n            " + _vm._s(_vm.i18n[this.locale]['edit_teachers']) + "\n          ")]), _vm._v(" "), (!_vm.isEditTeacher) ? _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isEditTeacher = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInLeft"
	    }
	  }, [(_vm.isEditTeacher) ? _c('div', [_c('Loader', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isUpdatingSubstitutes),
	      expression: "isUpdatingSubstitutes"
	    }],
	    staticStyle: {
	      "margin": "2rem auto"
	    },
	    attrs: {
	      "bgColor": "#fff",
	      "isExtraSmall": true
	    }
	  }), _vm._v(" "), _c('DSelectCalendars', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isUpdatingSubstitutes),
	      expression: "!isUpdatingSubstitutes"
	    }],
	    attrs: {
	      "itemType": "user",
	      "isDeleteAllAnOption": false,
	      "showTags": true,
	      "event": _vm.lesson,
	      "eventId": _vm.lesson.id,
	      "preSelectedItems": _vm.usersOnLesson,
	      "itemsThatCantBeDeleted": _vm.userCalIdsSubstituted,
	      "itemsUnselectable": [],
	      "showCreateButton": false,
	      "isLoadingProp": _vm.isUpdatingTeachers
	    },
	    on: {
	      "update": function($event) {
	        return _vm.setUsers($event)
	      }
	    }
	  })], 1) : _vm._e()])], 1)], 1)] : [_c('div', {
	    staticClass: "pad-10",
	    staticStyle: {
	      "font-size": "12px"
	    }
	  }, [_c('AbsenceReason', {
	    attrs: {
	      "user_calendar_id": _vm.user.user_calendar_id,
	      "reason": _vm.lesson
	    },
	    on: {
	      "showLog": function($event) {
	        return _vm.showLog(_vm.lesson)
	      },
	      "close": _vm.emitClose
	    }
	  })], 1)], _vm._v(" "), _c('div', {
	    staticClass: "sub-popover__content__note"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  }), _vm._v(" "), (_vm.lesson.event_type === 'absence') ? [_vm._v(_vm._s(_vm.$t('vue2.substitution.absence_notes')))] : [_vm._v(_vm._s(_vm.$t('vue2.substitution.substitute_notes')))]], 2), _vm._v(" "), _c('weip', {
	    attrs: {
	      "noteType": "teacher_notes",
	      "textInput": _vm.lesson.teacher_notes,
	      "lesson": _vm.lesson
	    },
	    on: {
	      "close": _vm.updateTeacherNote
	    }
	  })], 1)], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeWithoutSubmit),
	      expression: "closeWithoutSubmit"
	    }],
	    staticClass: "user-phonenumber"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeInRight",
	      "mode": "out-in"
	    }
	  }, [(!_vm.isEdit) ? _c('div', {
	    key: "showNumber",
	    staticClass: "current-number",
	    on: {
	      "click": _vm.setEdit
	    }
	  }, [(!_vm.isPendingConfirmation && _vm.number.length < 8) ? _c('p', {
	    staticClass: "pointer link"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.sms.add_number')))]) : _vm._e(), _vm._v(" "), (_vm.number.length > 7) ? _c('div', {
	    staticClass: "current-number__number flex align-center"
	  }, [_vm._v("\n        " + _vm._s(_vm.number) + "\n      ")]) : _vm._e()]) : _c('div', {
	    key: "editNumber",
	    staticClass: "add-number"
	  }, [_c('div', {
	    staticClass: "input-group hint",
	    class: _vm.hintClass,
	    attrs: {
	      "aria-label": _vm.$t('vue2.sms.number_must_be_8_digits')
	    }
	  }, [_c('div', {
	    staticClass: "flex-group"
	  }, [_c('div', {
	    staticClass: "flag__input-lookalike active-country"
	  }, [_c('img', {
	    staticClass: "country-flag",
	    attrs: {
	      "src": _vm.activeCountry.flag
	    }
	  }), _vm._v("+" + _vm._s(_vm.activeCountry.countryCode) + "\n            "), _c('DDropdown', [_c('span', {
	    staticClass: "icon-arrow-down5",
	    attrs: {
	      "slot": "d-dropdown__icon"
	    },
	    slot: "d-dropdown__icon"
	  }), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.countries), function(country) {
	    return _c('li', {
	      key: country.countryCode,
	      staticClass: "country-select__item",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveCountry(country)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "country-select__item__name"
	    }, [_c('img', {
	      staticClass: "country-flag",
	      attrs: {
	        "src": country.flag
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(country.name))])]), _vm._v("\n                  +" + _vm._s(country.countryCode) + "\n                ")])
	  }), 0)])], 1), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.number),
	      expression: "number"
	    }],
	    ref: "inputfield",
	    staticClass: "input_phonenumber",
	    class: {
	      'input--error': _vm.showWarning
	    },
	    attrs: {
	      "type": "phonenumber",
	      "autocomplete": "off",
	      "placeholder": _vm.$t('vue2.sms.add_number')
	    },
	    domProps: {
	      "value": (_vm.number)
	    },
	    on: {
	      "keypress": function($event) {
	        return _vm.inputKeypress($event)
	      },
	      "keyup": [_vm.inputKeyup, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "submit", undefined, $event.key, undefined)) { return null; }
	        return _vm.keyPressEnter.apply(null, arguments)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        return _vm.closeWithoutSubmit.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.number = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.isNumberChanged) ? _c('button', {
	    staticClass: "submit-button",
	    class: [{
	        'submit-button--disabled': !_vm.isValidNumber && !_vm.isNumberBeingDeleted
	      },
	      {
	        'submit-button--delete': _vm.isNumberBeingDeleted
	      }
	    ],
	    attrs: {
	      "aria-label": _vm.$t('vue2.sms.number_must_be_8_digits')
	    },
	    on: {
	      "click": _vm.submitNumber,
	      "mouseenter": _vm.onMouseOver,
	      "mouseleave": _vm.onMouseLeave
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isNumberBeingDeleted),
	      expression: "isNumberBeingDeleted"
	    }]
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.delete')) + " ")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isNumberBeingDeleted),
	      expression: "!isNumberBeingDeleted"
	    }]
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _c('button', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        return _vm.closeWithoutSubmit('button')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.close')) + "\n          ")])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content",
	    class: {
	      'd-modal__content--no-employments': _vm.filteredEmployment.length === 0
	    }
	  }, [_c('table', {
	    staticClass: "do-table",
	    class: {
	      'do-table--max-width': !_vm.isSalaryIntegrationActive
	    }
	  }, [_c('thead', [_c('th', [_vm._v("\n          Ansættelse\n        ")]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Organisation")]) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Lønart")]) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("\n          Løbenummer\n        ")]) : _vm._e(), _vm._v(" "), (_vm.filteredEmployment.length !== 0) ? _c('th', {
	    staticClass: "center"
	  }, [_vm._v("\n          Indberettes som vikarløn\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isSalaryIntegrationActive) ? _c('th', {
	    staticClass: "td--delete"
	  }) : _vm._e()]), _vm._v(" "), _c('tbody', [(_vm.filteredEmployment.length === 0) ? _c('tr', [_c('td', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "font-weight": "normal"
	    }
	  }, [_vm._v("Ingen aktive ansættelser")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredEmployment), function(employment) {
	    return _c('tr', {
	      key: employment.id,
	      class: {
	        'employment--error': employment.v_has_error
	      }
	    }, [_c('td', [_vm._v(_vm._s(employment.title))]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? [_c('td', [_vm._v(_vm._s(employment.organisation))]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (employment.default_loenart),
	        expression: "employment.default_loenart"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (employment.default_loenart)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.onChanged(employment, 'default_loenart', employment.default_loenart)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(employment, "default_loenart", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (employment.default_loebenummer),
	        expression: "employment.default_loebenummer"
	      }],
	      staticClass: "input-loebenummer",
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (employment.default_loebenummer)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.onChanged(employment, 'default_loebenummer', employment.default_loebenummer)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(employment, "default_loebenummer", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !employment.default_loebenummer || !employment.default_loenart; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !employment.default_loebenummer || !employment.default_loenart\n            }"
	      }],
	      attrs: {
	        "content": "Løbenummer og lønart skal udfyldes "
	      }
	    }, [_c('div', {
	      staticClass: "d-input-group--toggler",
	      class: {
	        'd-input-group--toggler--disabled': !employment.v_has_error && (!employment.default_loebenummer || !employment.default_loenart)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setIsManualSalary(employment, !employment.manual_salary)
	        }
	      }
	    }, [_c('AppToggle', {
	      attrs: {
	        "allowChanges": false,
	        "propOn": employment.manual_salary
	      }
	    })], 1)])] : _vm._e(), _vm._v(" "), (!_vm.isSalaryIntegrationActive) ? [_c('td', [_c('div', {
	      staticClass: "d-input-group--toggler d-input-group--toggler--manual",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setIsManualSalary(employment, !employment.manual_salary)
	        }
	      }
	    }, [_c('AppToggle', {
	      attrs: {
	        "allowChanges": false,
	        "propOn": employment.manual_salary
	      }
	    })], 1)]), _vm._v(" "), _c('td', {
	      staticClass: "td--delete"
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'right',
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              arrow: false,\n              placement: 'right',\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'}"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      attrs: {
	        "content": employment['can_delete?'] ? 'Slet ansættelsen' : 'Arkiver ansættelsen'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setDeleteEmployment(employment)
	        }
	      }
	    }, [(employment['can_delete?']) ? _c('span', {
	      staticClass: "icon-bin"
	    }) : _c('svg', {
	      staticClass: "tw-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24",
	        "fill": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
	      }
	    })])])])] : _vm._e()], 2)
	  })], 2)]), _vm._v(" "), (_vm.user.v_oldEmployments && _vm.user.v_oldEmployments.length > 0) ? _c('p', {
	    staticClass: "text-link pointer marg-1-top",
	    on: {
	      "click": _vm.setIsShowOldEmployment
	    }
	  }, [(!_vm.isShowOldEmployment) ? [_vm._v("Se")] : [_vm._v("Skjul")], _vm._v("\n        arkiverede ansættelser\n      ")], 2) : _vm._e(), _vm._v(" "), (_vm.isShowOldEmployment) ? _c('ul', _vm._l((_vm.user.v_oldEmployments), function(employment) {
	    return _c('li', {
	      staticClass: "d-employment-item d-employment-item--deleted"
	    }, [_vm._v("\n          " + _vm._s(employment.title) + "\n        ")])
	  }), 0) : _vm._e()]), _vm._v(" "), (_vm.filteredEmployment.length !== 0) ? _c('div', {
	    staticClass: "d-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.saveChanges
	    }
	  }, [_vm._v("\n        Gem\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteEmployment) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__delete-employment",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Er du sikker?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.theDeleteEmployment = null
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('p', [_vm._v("Er du sikker på, at du vil du " + _vm._s(_vm.theDeleteEmployment['can_delete?'] ? 'slette' : 'arkivere') + "\n            ansættelsen som "), _c('b', [_vm._v(_vm._s(_vm.theDeleteEmployment.title))]), _vm._v(" for\n            "), _c('b', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" hos "), _c('b', [_vm._v(_vm._s(_vm.school.name ? _vm.school.name : 'docendo'))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.theDeleteEmployment['can_delete?']) ? _c('p', [_c('i', [_vm._v("Bemærk: Ansættelsen har ikke været brugt, og vil derfor\n            blive slettet permanent.")])]) : _c('p', [_c('i', [_vm._v("Bemærk: Ansættelsen har været brugt og vil derfor blive arkiveret, så den ikke kan anvendes\n            igen. Tidligere data vil dog ikke blive slettet.")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.theDeleteEmployment = null
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), (_vm.theDeleteEmployment['can_delete?']) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.deleteEmployment(_vm.theDeleteEmployment)
	      }
	    }
	  }, [_vm._v("Slet ansættelsen\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.theDeleteEmployment['can_delete?'] && _vm.theDeleteEmployment['can_archive?']) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.archiveEmployment(_vm.theDeleteEmployment)
	      }
	    }
	  }, [_vm._v("\n              Arkiver ansættelsen\n            ")]) : _vm._e()])])])]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "scaleUp"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.addSubject),
	      expression: "addSubject"
	    }],
	    staticClass: "subject",
	    style: ({
	      'background-color': _vm.subject.color
	    })
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hours),
	      expression: "hours"
	    }],
	    ref: "count",
	    staticClass: "subject__input-number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.addSubject.apply(null, arguments)
	      },
	      "focus": _vm.selectAll,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = $event.target.value
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cal",
	    class: {
	      'cal--is-dayview': _vm.isDayView
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.load),
	      expression: "load"
	    }],
	    staticClass: "full-spinner"
	  }, [_c('div', {
	    staticClass: "icon-docendo animated pulse infinite"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.itemsWithOccupation,
	      "event": _vm.event,
	      "isDeleteAllAnOption": _vm.isDeleteAllAnOption,
	      "itemsUnselectable": _vm.itemsUnselectable,
	      "isLoadingAvailability": _vm.isLoading,
	      "isLoading": _vm.isLoadingProp,
	      "itemsSelected": _vm.selectedItems,
	      "itemsThatCantBeDeleted": _vm.itemsThatCantBeDeleted,
	      "multiple": _vm.isMultiple,
	      "placeholder": _vm.i18n[_vm.locale]['search'],
	      "appendToBody": _vm.appendToBody,
	      "calculate-position": _vm.withPopper,
	      "show": _vm.show,
	      "showCreateButton": _vm.showCreateButton,
	      "newUserCalendarId": _vm.newUserCalendarId,
	      "disableAddMore": _vm.disableAddMore,
	      "isShowCollisions": true
	    },
	    on: {
	      "update": _vm.setSelectedItems,
	      "createNew": _vm.createNew,
	      "showCalendar": _vm.showCalendar
	    }
	  }, [(_vm.disableAddMore) ? _c('h4', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_vm._v(_vm._s(_vm.disableAddMoreMessage))]) : _vm._e()]), _vm._v(" "), (_vm.activeCalendar) ? _c('CalendarViewDay', {
	    attrs: {
	      "event": _vm.event,
	      "date": _vm.date,
	      "calendar": _vm.activeCalendar,
	      "calendars": _vm.items
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "close": function($event) {
	        _vm.activeCalendar = null
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "intern-notes-container text-dark"
	  }, [_c('button', {
	    staticClass: "open-button",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')) + "\n    "), (_vm.absenceAutogeneratedToday > 0) ? _c('div', {
	    staticClass: "dot--for-autogenered hint--bottom",
	    attrs: {
	      "aria-label": _vm.textAbsenceCreatedAuto
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.absenceAutogeneratedToday) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideInRight"
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "subs-note",
	    class: {
	      'subs-note--is-open': _vm.isOpen
	    }
	  }, [_c('div', {
	    staticClass: "subs-note__container"
	  }, [_c('div', {
	    staticClass: "subs-note__container__header"
	  }, [_c('div', {
	    staticClass: "subs-note__container__header__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.teachers_with_ongoing_absence')))])]), _vm._v(" "), _c('div', {
	    staticClass: "subs-note__container__body"
	  }, [(_vm.absentUsersSorted.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.no_teachers_with_ongoing_absence')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.absentUsersSorted), function(user) {
	    return _c('li', {
	      staticClass: "absent-user shadow"
	    }, [_c('div', {
	      staticClass: "absent-user__badges right marg-5-left"
	    }, [(_vm.getIsUserAbsenceAutogeneratedToday(user)) ? _c('div', {
	      staticClass: " badge badge--small badge--orange"
	    }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.auto_created')) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "absent-user__name"
	    }, [_c('img', {
	      attrs: {
	        "src": user.default_thumb_url
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user && user.name ? user.name : ''))])]), _vm._v(" "), _c('ul', _vm._l((user.reasons), function(reason) {
	      return _c('li', [_c('h4', [_vm._v(_vm._s(_vm.getReasonTitle(reason)))]), _vm._v(" "), _c('div', [_c('span', {
	        staticClass: "icon-calendar4"
	      }), _vm._v(" " + _vm._s(_vm._f("date")(reason.from_date)) + " -\n                    " + _vm._s(_vm._f("date")(reason.to_date)) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', {
	        staticClass: "icon-clock"
	      }), _vm._v(" " + _vm._s(_vm._f("showTime")(reason.from_time)) + " -\n                    " + _vm._s(_vm._f("showTime")(reason.to_time)) + "\n                  ")]), _vm._v(" "), _c('div', {
	        staticClass: "actions"
	      }, [_c('button', {
	        staticClass: "bttn bttn-primary shadow",
	        on: {
	          "click": function($event) {
	            return _vm.setTheEditAbsenceReason(reason)
	          }
	        }
	      }, [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.edit_stop')) + "\n                    ")])])])
	    }), 0)])
	  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = false
	      }
	    }
	  }) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "items-list"
	  }, [_c('ul', {
	    staticClass: "items"
	  }, [(!_vm.isEditPeriod) ? _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Periode")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_vm._v("\n          " + _vm._s(_vm.dateRangeFormatted) + "\n          "), _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": "Redigér periode"
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isEditPeriod = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isEditPeriod) ? [_c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Startdato")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.startDate
	    },
	    on: {
	      "changed": _vm.setStartDate
	    }
	  })], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Slutdato")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.endDate
	    },
	    on: {
	      "changed": _vm.setEndDate
	    }
	  })], 1)])])] : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Stillingsprosenten")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("%")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.employmentPercentage.hours),
	      expression: "employmentPercentage.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.employmentPercentage.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.employmentPercentageChanged($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.employmentPercentage, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('li', {
	    staticClass: "items__item",
	    class: {
	      'items__item--fixed': _vm.workingHours.isFixed
	    }
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.workingHours.title))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.workingHours.hours),
	      expression: "workingHours.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.workingHours.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditWorkingHours($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.workingHours, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('li', {
	    staticClass: "items__item",
	    class: {
	      'items__item--fixed': _vm.planleggingsdager.isFixed
	    }
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.planleggingsdager.title))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.planleggingsdager.hours),
	      expression: "planleggingsdager.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.planleggingsdager.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditPlanleggingsdager($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.planleggingsdager, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "item__total"
	  }, [_c('p', [_vm._v("Sum arbeidstid i 38 uker")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workingHoursWithoutPlanleggingsdager) + " timer")])]), _vm._v(" "), (true) ? _c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v("Reduksjon til undervisning")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.subtractedItems), function(subtractItem, idx) {
	    return _c('li', {
	      key: subtractItem.id,
	      staticClass: "subtract-item items__item"
	    }, [(subtractItem.id === 'reduction_employee_percentage') ? [_c('p', {
	      staticStyle: {
	        "margin-left": "19px"
	      }
	    }, [_vm._v("\n          Stillingsprosenten reduksjon")]), _c('p', [_vm._v(_vm._s(subtractItem.hours) + "%")])] : [_c('div', {
	      staticClass: "subtract-item__title"
	    }, [_c('div', {
	      staticClass: "d-input-group__input__close icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.deleteItem(subtractItem)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })]), _vm._v("\n            " + _vm._s(subtractItem.title) + "\n          ")]), _vm._v(" "), (subtractItem.isOwn) ? _c('div', {
	      staticClass: "input-group__input"
	    }, [_c('span', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s(subtractItem.unit ? subtractItem.unit : 'timer'))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (subtractItem.hours),
	        expression: "subtractItem.hours"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (subtractItem.hours)
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "change": function($event) {
	          return _vm.setSubtractedItemValue(subtractItem, $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(subtractItem, "hours", $event.target.value)
	        }
	      }
	    })]) : _c('p', [_vm._v(_vm._s(subtractItem.hours) + "%")])]], 2)
	  }), 0)], 2), _vm._v(" "), _c('ul', {
	    staticClass: "items",
	    attrs: {
	      "id": "items__list"
	    }
	  }, [(_vm.isAddNew) ? _c('li', {
	    staticClass: "items__item items__item__add__new"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newItemTitle),
	      expression: "newItemTitle"
	    }],
	    ref: "add_new_input",
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.newItemTitle)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.addOwn.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newItemTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "items__item__add__new__buttons"
	  }, [_c('button', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.reset
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": _vm.addOwn
	    }
	  }, [_vm._v("Gem")])])]) : _vm._e()]), _vm._v(" "), _c('DDropdown', {
	    staticClass: "add-more__dropdown",
	    attrs: {
	      "isShowDots": false
	    }
	  }, [(!_vm.isAddNew) ? _c('p', {
	    staticClass: "items__item__add",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("+ Legg til reduksjon")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('label', {
	    staticClass: "d-label d-label__headline"
	  }, [_vm._v("Livsfasetiltak")]), _vm._v(" "), _vm._l((_vm.possibleStandardItems), function(possibleItem, idx) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.addFromStandard(possibleItem)
	        }
	      }
	    }, [_vm._v(_vm._s(possibleItem.title) + "\n      ")])
	  }), _vm._v(" "), _c('li', {
	    staticClass: "items__item__add",
	    staticStyle: {
	      "border-top": "1px solid #ddd",
	      "margin-top": "0.5rem"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsAddNew(true)
	      }
	    }
	  }, [_vm._v("+\n        Lag din egen\n      ")])], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Deaktiver puljer")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('div', {
	    staticClass: "d-explainer-box text-explainer text-explainer__error"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-help",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
	    }
	  })]), _vm._v("\n        Deaktiver puljer for Undervisning, Øvrige opgaver m.m., så systemet i stedet beregner en samlet pulje baseret på det samlede antal timer allokeret på brikker.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsActive.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label color-dark"
	  }, [_vm._v("Deaktiver puljer")]), _vm._v(" "), _c('div', {
	    staticClass: "do-switch",
	    class: {
	      'do-switch--active': _vm.isActive
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "dayCalContainer",
	    staticClass: "day-cal__event-container",
	    class: {
	      'day-cal__event-container--no-bg-colors': _vm.isCalNoBgColors
	    }
	  }, [_c('div', {
	    staticClass: "day-cal__event-container__events"
	  }, _vm._l((_vm.correctEvents), function(event) {
	    return _c('div', {
	      key: event.obj.event_key,
	      staticClass: "day-cal__event",
	      class: [{
	        'day-cal__event--is-away': event.obj.away
	      }, {
	        'day-cal__event--is-canceled': event.obj.canceled
	      }, {
	        'fc-bgevent__presence': event.obj.event_type === 'presence'
	      }, {
	        'day-cal__event--clickable': _vm.isEventsClickable
	      }],
	      style: ({
	        'borderColor': event.obj.color,
	        'height': event.height + 'px',
	        'top': (event.top - 1) + 'px',
	        'left': event.left + '%',
	        'width': event.width + '%'
	      }),
	      attrs: {
	        "data-cols": event.cols ? event.cols : 1
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onEventClick(event, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "day-cal__event__content",
	      style: ({
	        fontSize: _vm.eventFontSize !== 10 ? _vm.eventFontSize + 'px' : ''
	      })
	    }, [_c('div', {
	      staticClass: "day-cal__event__content__header"
	    }, [_c('div', {
	      staticClass: "d-cal__event-title"
	    }, [(event.obj.away) ? _c('span', {
	      staticClass: "icon-home2 icon-home2-away icon-home2-away--schedules"
	    }) : _vm._e(), _vm._v(_vm._s(event.obj.title))]), _vm._v(" "), _c('div', {
	      staticClass: "d-cal__event-time"
	    }, [_c('span', {
	      staticClass: "d-cal__event-time__start"
	    }, [_vm._v(_vm._s(event.obj.event_starttime))]), _vm._v(" "), _c('span', {
	      staticClass: "d-cal__event-time__end"
	    }, [_vm._v(_vm._s(event.obj.event_endtime))]), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.has_notes && !_vm.isCalendarInPrintMode),
	        expression: "event.obj.has_notes && !isCalendarInPrintMode"
	      }],
	      staticClass: "d-cal__event-meta icon-file-text2"
	    }), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.has_substitute),
	        expression: "event.obj.has_substitute"
	      }],
	      staticClass: "d-cal__event-meta icon-users3"
	    }), _vm._v(" "), (event.obj.collision || event.obj.away || event.obj.canceled) ? _c('div', {
	      staticClass: "d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning",
	      class: {
	        'd-cal__event-meta__fixed--canceled': event.obj.canceled
	      }
	    }, [(event.obj.canceled) ? _c('span', {
	      staticClass: "icon-notification22"
	    }) : _c('svg', {
	      staticClass: "tw-icon tw-icon--warning",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })]), _vm._v("\n              " + _vm._s(_vm.getEventWarningLabel(event.obj)) + "\n            ")]) : _vm._e()])]), _vm._v(" "), (!_vm.isHideCalendars) ? [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.teacher),
	        expression: "event.obj.teacher"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n            " + _vm._s(event.obj.teacher) + "\n          ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.group),
	        expression: "event.obj.group"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-users"
	    }), _vm._v("\n            " + _vm._s(event.obj.group) + "\n          ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.room),
	        expression: "event.obj.room"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-location"
	    }), _vm._v("\n            " + _vm._s(event.obj.room) + "\n          ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.students),
	        expression: "event.obj.students"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-users5"
	    }), _vm._v("\n            " + _vm._s(event.obj.students) + "\n          ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__bg",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__sider",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    })])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "presence-for-users text-dark"
	  }, [_c('div', {
	    staticClass: "d-table-layout"
	  }, [_c('div', {
	    staticClass: "d-table-layout__col"
	  }, [_c('div', {
	    staticClass: "d-table-layout__header"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_presence_to_many_user']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-table-layout__header__right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.selectedIdsLength) + " " + _vm._s(_vm.i18n[_vm.locale]['of']) + " " + _vm._s(_vm.usersFiltered.length))]), _vm._v(" "), (_vm.selectedIdsLength < 1) ? _c('div', {
	    staticClass: "hint--bottom-left",
	    attrs: {
	      "aria-label": _vm.$t('vue2.tagging.select_persons_first')
	    }
	  }, [_c('button', {
	    staticClass: "up__button no-print bttn bttn--disabled"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.presence.work_hours')) + "\n              "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })])]) : _c('PresenceUser', {
	    attrs: {
	      "firstDayOfWeek": _vm.firstDayOfWeek
	    },
	    on: {
	      "save": _vm.savePresence
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-table-layout__header"
	  }, [_c('div', [(_vm.selectedIdsLength < 1) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.unSelectAll
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('TaggingFilter', {
	    attrs: {
	      "users": _vm.usersWithProps,
	      "showHowMany": false,
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags,
	      "schoolid": _vm.schoolId
	    },
	    on: {
	      "set": _vm.setTag,
	      "remove": _vm.removeTag
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-table-layout__body"
	  }, [(_vm.isLoadingSchoolCalenders) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [(_vm.usersWithProps.length < 1) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_created']))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "presence__user-list"
	  }, _vm._l((_vm.usersWithProps), function(user) {
	    return _c('li', {
	      key: user.id,
	      class: {
	        'user--selected': user.v_isSelected
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': user.v_isSelected
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])])
	  }), 0)]], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-profile text-dark"
	  }, [(_vm.schoolIsFromDenmark) ? [(!_vm.theUser || !_vm.schoolId) ? _c('Loader') : [_c('div', {
	    staticClass: "marg-1-top"
	  }), _vm._v(" "), _c('ProfileSubjects', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "canEdit": _vm.isUserCanEdit,
	      "schoolId": _vm.schoolId,
	      "user": _vm.user
	    }
	  })]] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.items,
	      "itemsSelected": _vm.selectedItems,
	      "itemsThatCantBeDeleted": _vm.itemsThatCantBeDeleted,
	      "multiple": _vm.isMultiple,
	      "placeholder": _vm.i18n[_vm.locale]['search'],
	      "appendToBody": _vm.appendToBody,
	      "calculate-position": _vm.withPopper,
	      "show": _vm.show,
	      "showCreateButton": _vm.showCreateButton,
	      "newUserCalendarId": _vm.newUserCalendarId
	    },
	    on: {
	      "update": _vm.setSelectedItems,
	      "add": _vm.add,
	      "remove": _vm.remove,
	      "createNew": _vm.createNew
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "setup-widget text-dark",
	    class: [{
	      setupWidgetOpen: _vm.showModal
	    }, {
	      animateSlide: _vm.animateSlide
	    }]
	  }, [_c('div', {
	    staticClass: "setup-widget__button",
	    on: {
	      "click": _vm.setShowModal
	    }
	  }, [_c('div', {
	    staticClass: "setup-widget__button__text"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.setupWidget.get_going_easy')))]), _vm._v(" "), _c('div', {
	    staticClass: "pointer setup-widget__button__close"
	  }, [(_vm.showModal) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]), _vm._v(" "), (_vm.showModal && _vm.activeOnboardingStep === 0 && _vm.showLocalOnboardingArrow) ? _c('arrow', {
	    style: ({
	      'top': _vm.onboardArrowTopPx + 'px'
	    }),
	    attrs: {
	      "setupWidget": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "setup-widget__header"
	  }, [_c('div', {
	    staticClass: "onboarding_section"
	  }, [_c('div', {
	    staticClass: "setup-widget__header pad-20 pad-0-top"
	  }, [_c('h1', {
	    staticClass: "center text-white"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.setupWidget.get_going_easy')))]), _vm._v(" "), _c('doughnut', {
	    attrs: {
	      "animate": true,
	      "steps": _vm.stepsLength,
	      "stepNum": _vm.howManyDone
	    }
	  })], 1)]), _vm._v(" "), _c('ul', {
	    staticClass: "setup-widget__steps"
	  }, _vm._l((_vm.stepNumbers), function(step, index) {
	    return _c('li', {
	      staticClass: "setup-widget__steps__step js-onboard-item-click js-setupWidgetEvent",
	      class: {
	        'isDone': step.done
	      },
	      on: {
	        "click": function($event) {
	          return _vm.stepFnc(step.stepNum, step.title)
	        }
	      }
	    }, [(step.guide.length > 1) ? [_c('div', {
	      staticClass: "youtube-popup js-setupWidgetEvent step__button__video-guide",
	      on: {
	        "click": function($event) {
	          return _vm.openYouTube(step.videoid)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "step__number js-setupWidgetEvent",
	      class: {
	        stepNumberDone: step.done
	      }
	    }, [(step.done) ? _c('span', {
	      staticClass: "icon-checkmark4 js-setupWidgetEvent"
	    }) : _c('span', {
	      staticClass: "step__number__play icon-play4 js-setupWidgetEvent"
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "step-text js-setupWidgetEvent"
	    }, [_vm._v(" " + _vm._s(step.title))])])] : [_c('div', {
	      staticClass: "js-setupWidgetEvent step__button__video-guide"
	    }, [_c('span', {
	      staticClass: "step__number js-setupWidgetEvent",
	      class: {
	        stepNumberDone: step.done
	      }
	    }, [(step.done) ? _c('span', {
	      staticClass: "icon-checkmark4 js-setupWidgetEvent"
	    }) : _c('span', {
	      staticClass: "js-setupWidgetEvent"
	    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('span', {
	      staticClass: "step-text js-setupWidgetEvent"
	    }, [_vm._v(" " + _vm._s(step.title))])])]], 2)
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "support-section"
	  }, [_c('div', {
	    staticClass: "support-section__list"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.showIntercom.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bubbles4"
	  }), _vm._v("\n        " + _vm._s(_vm.$t('vue2.setupWidget.write_us')))]), _vm._v(" "), (_vm.country === 'dk') ? [_c('a', {
	    attrs: {
	      "href": "http://support.docendo.dk/"
	    }
	  }, [_c('span', {
	    staticClass: "icon-question3"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.setupWidget.support_forum')) + "\n        ")])] : _vm._e()], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.html)
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('d-modal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "print-all-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "print-calendars__header border-1-bottom text-dark"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.print_latest_version')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "print-all-modal__body"
	  }, [(!_vm.isShowUserSelectModal) ? _c('div', {
	    attrs: {
	      "id": "printTaskOverviews"
	    }
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [(_vm.sortedUsers.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_versions.no_saved_versions')) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
	    return _c('TaskOverviewUser', {
	      key: user.user.id,
	      attrs: {
	        "user": user.user,
	        "version": user.version,
	        "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours,
	        "isHideTaskHoursUnderThreshold": _vm.isHideTaskHoursUnderThreshold
	      }
	    })
	  })]], 2) : _vm._e()]), _vm._v(" "), (_vm.isShowUserSelectModal) ? _c('d-modal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__content d-modal__content__hide-task-hours",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h3', [_vm._v("Vælg brugere til udskrift")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [(_vm.tags.length > 0) ? _c('div', {
	    staticClass: "brutto__users__header"
	  }, [_c('filterTags', {
	    attrs: {
	      "users": _vm.usersSortedOnNameWithTags,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users__list__header",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUserIds.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('ul', {
	    staticClass: "brutto__users__list"
	  }, _vm._l((_vm.filteredUsersOnTags), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "brutto__users__user",
	      class: {
	        'is-selected': _vm.getIsUserSelected(user)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(user.name) + "\n            ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [_c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsHideTaskHoursUnderThreshold.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label marg-1-right"
	  }, [_vm._v("Skjul timepuljer på opgaver under " + _vm._s(_vm.schoolThresholdToHideTaskHours) + "\n              timer")]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isHideTaskHoursUnderThreshold
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__print_buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isLoadingPrint
	    },
	    on: {
	      "click": _vm.startPrint
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.print')) + "\n            ")])])])])]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "print-popup"
	  }, [_vm._l((_vm.usersFilteredWithTags), function(user) {
	    return (!_vm.isUserFiltered(user)) ? _c('div', {
	      key: user.id,
	      staticClass: "user"
	    }, [_c('h4', [_vm._v("Opgaveoversigt " + _vm._s(_vm.activeSchoolYear.name))]), _vm._v(" "), _c('SubjectsDistributionUser', {
	      attrs: {
	        "activeUserId": user.id,
	        "showCloseCross": false
	      }
	    })], 1) : _vm._e()
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [(_vm.isPrintSettingsModal) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal__content",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "modal__content__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v("Print " + _vm._s(_vm.usersFilteredWithTags.length - _vm.filteredUsers.length) + " undervisere")]), _vm._v(" "), _c('label', {
	    staticClass: "print-form__label"
	  }, [_vm._v("Fravælg evt. undervisere")]), _vm._v(" "), _c('ul', {
	    staticClass: "user-list"
	  }, _vm._l((_vm.usersFilteredWithTags), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "user-list__item",
	      class: {
	        'user-list__item--disabled': _vm.isUserFiltered(user)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleFilteredUser(user)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(user.name) + "\n          ")])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "modal__content__buttons"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Luk")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": _vm.print
	    }
	  }, [_vm._v("Print")])])])]) : _vm._e()], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "d-event__actions text-dark"
	  }, [(_vm.isPossibleToAdd) ? _c('h3', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.actions_for')) + " \"" + _vm._s(_vm.event.title) + "\"\n    " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards ')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheShowAction('remove')
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheShowAction('remove')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendar_view_day.remove_onwards')) + "\n      "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheShowAction('remove')) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.do_you_want_to_remove')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.on_all')) + " \"" + _vm._s(_vm.event.title) + "\"-" + _vm._s(_vm.$t('vue2.calendar_view_day.lessons')) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards_which_include')) + " " + _vm._s(_vm.eventStartFormatted) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.and_all_onwards')) + ".")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-danger",
	    on: {
	      "click": _vm.removeOnward
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.remove')) + "\n          " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards')) + "\n        ")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.isPossibleToAdd) ? _c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheShowAction('add')
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheShowAction('add')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendar_view_day.add_onwards')) + "\n      "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheShowAction('add')) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.do_you_want_to_add')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.on_all')) + " \"" + _vm._s(_vm.event.title) + "\"-" + _vm._s(_vm.$t('vue2.calendar_view_day.lessons')) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards_which_include')) + " " + _vm._s(_vm.eventStartFormatted) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.and_all_onwards')) + ".")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.addOnward
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.add')) + " " + _vm._s(_vm.calendar.name) + "\n          " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards')) + "\n        ")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheShowAction('replace')
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheShowAction('replace')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.replace_onwards')) + "\n      "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheShowAction('replace')) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.select_the_person_to_replace')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.with_on_all')) + " \"" + _vm._s(_vm.event.title) + "\"-" + _vm._s(_vm.$t('vue2.calendar_view_day.lessons')) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards_which_include')) + " " + _vm._s(_vm.eventStartFormatted) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.and_all_onwards')))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theReplaceWithCalendarId),
	      expression: "theReplaceWithCalendarId"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theReplaceWithCalendarId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "selected": ""
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.select_person')) + "..")]), _vm._v(" "), _vm._l((_vm.selectableCalendars), function(cal) {
	    return _c('option', {
	      key: cal.id,
	      domProps: {
	        "value": cal.id
	      }
	    }, [_vm._v(_vm._s(cal.name))])
	  })], 2), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theReplaceWithCalendarId && _vm.theReplaceWithCalendarId !== _vm.calendar.id),
	      expression: "theReplaceWithCalendarId && theReplaceWithCalendarId !== calendar.id"
	    }],
	    on: {
	      "click": _vm.replaceOnward
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.replace')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards')) + "\n        ")])]) : _vm._e()])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', _vm._l((_vm.users), function(user) {
	    return _c('div', {
	      ref: "tooltip",
	      refInFor: true,
	      staticClass: "recent_user activity_avatar onlinepeeps"
	    }, [_c('a', {
	      staticClass: "hint--top-left",
	      attrs: {
	        "href": user.url,
	        "aria-label": _vm.tooltiptitle(user)
	      }
	    }, [_c('img', {
	      staticClass: "ag",
	      attrs: {
	        "src": user.thumb,
	        "alt": user.name,
	        "height": "50",
	        "width": "50"
	      }
	    })]), _vm._v(" "), (user.last_seen_one_hour_ago) ? _c('div', {
	      staticClass: "bg-green pos-absolute bottom-0 right-0 rounded-50",
	      attrs: {
	        "id": "indicatoronline"
	      }
	    }) : _vm._e()])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', {
	    staticClass: "d-table-tr",
	    class: {
	      'd-table-tr--odd': _vm.index % 2 === 1
	    }
	  }, [_c('td', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleSubject(_vm.subject)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-checkbox",
	    class: {
	      'd-checkbox--active': _vm.isSelected
	    }
	  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subject.subject.name))]), _vm._v(" "), _c('td', [(_vm.subject.calendar) ? [_vm._v("\n      " + _vm._s(_vm.subject.calendar.name) + "\n    ")] : _vm._e()], 2), _vm._v(" "), _c('td', [(_vm.subject.subject.calendar) ? [_vm._v("\n      " + _vm._s(_vm.subject.subject.calendar.name) + "\n    ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subject.v_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subject.v_DefaultCategory && _vm.subject.v_DefaultCategory.name))]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'left',
	        arrow: false,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function () { return _vm.selectedSubjects.length > 0; }
	      }),
	      expression: "{\n          placement: 'left',\n              arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => selectedSubjects.length > 0\n          }"
	    }],
	    attrs: {
	      "content": 'Tildel til flere i stedet'
	    }
	  }, [(_vm.taskCategories.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subject.selected_task_category_id),
	      expression: "subject.selected_task_category_id"
	    }],
	    staticClass: "do-select",
	    class: {
	      'do-select--disabled': _vm.selectedSubjects.length > 0
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.subject, "selected_task_category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.updateSubjectTaskCategory(_vm.subject, $event.target.value)
	      }]
	    }
	  }, _vm._l((_vm.taskCategories), function(taskCategory, key) {
	    return _c('option', {
	      key: taskCategory.id,
	      domProps: {
	        "value": taskCategory.id
	      }
	    }, [_vm._v("\n        " + _vm._s(taskCategory.name) + "\n      ")])
	  }), 0) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "reporting"
	  }, [_c('a', {
	    staticClass: "d-back-link",
	    attrs: {
	      "href": "/calendar"
	    }
	  }, [_vm._v("Tilbage til Docendo")]), _vm._v(" "), _c('div', {
	    staticClass: "reporting__header"
	  }, [_c('div', {
	    staticClass: "reporting__header__right"
	  }, [_c('h1', [_vm._v("Timetalsindberetning")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoadingStilData || !_vm.isUserLoaded) ? _c('div', {
	    staticStyle: {
	      "width": "500px"
	    }
	  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && _vm.userHasNoEmail) ? _c('div', {
	    staticClass: "d-form alert"
	  }, [_c('h3', [_vm._v("Der skal udfyldes en email for at benytte timetalsindberetning")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', [_vm._v("Din email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.userEmailInput),
	      expression: "userEmailInput",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    ref: "user_email_input",
	    class: {
	      'input--error': _vm.userEmailFormErrors['email']
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.userEmailInput)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('email')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.userEmailInput = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.userEmailFormErrors['email']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.createusers.email_error_text')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-form__submit"
	  }, [_c('button', {
	    staticClass: "bttn submit-button",
	    class: [{
	        'bttn--loading': _vm.isSavingUserEmail
	      },
	      {
	        'submit-button--disabled': _vm.isSaveButtonForUserEmailDisabled
	      }
	    ],
	    on: {
	      "click": _vm.submitUserEmail
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && !_vm.isLoadingStilData && !_vm.userHasNoEmail) ? [_c('div', {
	    staticClass: "reporting-content"
	  }, [_c('div', {
	    staticClass: "reporting__table"
	  }, [_c('GrundskoleIndberetningTimetal', {
	    attrs: {
	      "stilData": _vm.stilData
	    },
	    on: {
	      "update": _vm.update,
	      "updateSubject": _vm.updateSubject,
	      "updateKonfirmation": _vm.updateKonfirmation,
	      "updatePraktik": _vm.updatePraktik,
	      "setTolaerer": _vm.setTolaerer,
	      "setForanstaltning": _vm.setForanstaltning,
	      "nulstilKlasse": _vm.nulstilKlasse
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "submit-bttn__container"
	  }, [_c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--loading': _vm.isSendingToStil
	    },
	    staticStyle: {
	      "width": "165px"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Afslut og indberet\n        ")])])])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-scheduler-sort"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 8],
	      "isCloseOnDropdownClick": false
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-shuffle2"
	  }), _vm._v("\n      " + _vm._s(_vm.i18n['sort_by']) + "\n    ")]), _vm._v(" "), _c('ul', {
	    staticClass: "do-filters__filter__dropdown",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.options), function(option) {
	    return _c('li', {
	      key: option.value,
	      staticClass: "do-filters__filter__dropdown__item",
	      class: {
	        'do-filters__filter__dropdown__item--selected': option.selected
	      },
	      on: {
	        "click": function($event) {
	          return _vm.select(option.value)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(option.name) + "\n        "), _c('svg', {
	      staticClass: "tw-icon icon-check",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('circle', {
	      staticClass: "primary",
	      attrs: {
	        "cx": "12",
	        "cy": "12",
	        "r": "10"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z"
	      }
	    })])])
	  }), 0)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "absence-reasons__absence"
	  }, [_c('div', [_c('div', {
	    staticClass: "absence-reasons__absence__title"
	  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.reason.title))])]), _vm._v(" "), _c('p', [(_vm.isOngoing) ? _c('span', {
	    staticClass: "badge badge--orange badge--small badge--clickable",
	    on: {
	      "click": _vm.setTheEditAbsenceReason
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))]) : _vm._e(), _vm._v(" "), (!_vm.isOngoing && _vm.getIsAbsenceMultipleDays) ? _c('span', {
	    staticClass: "badge badge--small"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.substitution_user.multiple_days')))]) : _vm._e()])]), _vm._v(" "), _c('p', [(_vm.getSerialListItem) ? [_vm._v("\n        " + _vm._s(_vm._f("date")(_vm.getSerialListItem.from_date)) + "\n        - " + _vm._s(_vm._f("date")(_vm.getSerialListItem.to_date)) + ", " + _vm._s(_vm._f("showTime")(_vm.reason.start)) + " - " + _vm._s(_vm._f("showTime")(_vm.reason.end)) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm._f("showDate")(_vm.reason.start)) + " -\n        "), _c('span', [_vm._v(_vm._s(_vm._f("showTime")(_vm.reason.end)))])]], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "absence-reasons__absence__right"
	  }, [_c('div', {
	    staticClass: "absence-reasons__absence__right__edits"
	  }, [_c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	    }],
	    staticClass: "icon-bin icon__bg-circle icon__bg-circle--danger deleteAbsence",
	    attrs: {
	      "content": _vm.$t('vue2.common.delete')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setReadyToDelete(_vm.reason)
	      }
	    }
	  }), _vm._v(" "), (_vm.getSerialListItem) ? _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	    }],
	    staticClass: "icon-wrench icon__bg-circle",
	    attrs: {
	      "content": _vm.$t('vue2.common.edit')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheEditAbsenceReason(_vm.reason)
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	    }],
	    staticClass: "icon-clock icon__bg-circle",
	    attrs: {
	      "content": _vm.$t('vue2.common.log')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showLog(_vm.reason)
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "role_child",
	    staticClass: "role-change",
	    class: {
	      'role-change--active': _vm.isDropDown
	    }
	  }, [(_vm.isDropDown) ? _c('div', {
	    staticClass: "role-change__dropdown__container"
	  }, [_c('transition', {
	    attrs: {
	      "name": "d-dropdown"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "role-change__dropdown"
	  }, [_c('ul', _vm._l((_vm.roles), function(role) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setRole(role)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(role.v_title) + "\n          ")])
	  }), 0)]) : _vm._e()])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flex align-center",
	    class: _vm.addClass
	  }, [_c('div', {
	    class: {
	      'input-with-icon': _vm.showIcon
	    }
	  }, [_c('div', {
	    class: {
	      'icon': _vm.showIcon, 'icon-clock': _vm.showIcon
	    }
	  }), _vm._v(" "), _c('time-input', {
	    attrs: {
	      "date": _vm.startTime
	    },
	    on: {
	      "changed": _vm.setStartTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "timepicker timepicker-line"
	  }, [_vm._v("\n    -\n  ")]), _vm._v(" "), _c('div', {
	    class: {
	      'input-with-icon': _vm.showIcon
	    }
	  }, [_c('div', {
	    class: {
	      'icon': _vm.showIcon, 'icon-clock': _vm.showIcon
	    }
	  }), _vm._v(" "), _c('time-input', {
	    attrs: {
	      "date": _vm.endTime
	    },
	    on: {
	      "changed": _vm.setEndTime
	    }
	  })], 1), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.utcStart),
	      expression: "utcStart"
	    }],
	    staticClass: "none",
	    attrs: {
	      "name": "event_start",
	      "type": "hidden"
	    },
	    domProps: {
	      "value": (_vm.utcStart)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.utcStart = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.utcEnd),
	      expression: "utcEnd"
	    }],
	    staticClass: "none",
	    attrs: {
	      "name": "event_end",
	      "type": "hidden"
	    },
	    domProps: {
	      "value": (_vm.utcEnd)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.utcEnd = $event.target.value
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "annual-norm text-dark"
	  }, [_c('div', {
	    staticClass: "d-header"
	  }, [_c('div', {
	    staticClass: "d-header__left"
	  }, [_c('h1', [_vm._v("Arbeidstidsplan")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading && !_vm.isUpdatingTasks) ? _c('Loader') : [_c('div', {
	    staticClass: "d-tabs"
	  }, [_c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': !_vm.viewIsResult
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewIsResult = false
	      }
	    }
	  }, [_vm._v("\n        Arbeidsåret\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__container"
	  }, [(_vm.viewIsResult) ? [_c('AnnualNormResult', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.userWithProps
	    }
	  })] : _c('div', {
	    staticClass: "annual-norm__body"
	  }, [_c('div', {
	    staticClass: "annual-norm__body__left"
	  }, [_c('ArbeidsplanAssignHoursNorm', {
	    staticClass: "marg-1-bottom",
	    on: {
	      "updateUsersHours": _vm.readAssignedHours
	    }
	  }), _vm._v(" "), _c('ul', _vm._l((_vm.userWithProps), function(user) {
	    return _c('li', {
	      key: user.user_calendar_id,
	      staticClass: "user-item",
	      class: {
	        'user-item--active': user.v_is_active_user
	      }
	    }, [_c('div', {
	      staticClass: "user-item__body",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveUserId(user.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "user-item__name"
	    }, [(user.default_thumb_url) ? _c('img', {
	      staticClass: "user-item__name__img",
	      attrs: {
	        "src": user.default_thumb_url
	      }
	    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', {
	      staticClass: "user-item__right"
	    }, [_c('div', {
	      staticClass: "user-item__hours"
	    }, [_c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Årsverk")]), _c('span', [_vm._v(_vm._s(user.v_assigned_total_hours))])]), _vm._v(" "), _c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Undervisning")]), _c('span', [_vm._v(_vm._s(user.v_total_teaching_percentage_label))])]), _vm._v(" "), _c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Oppgaver")]), _c('span', [_vm._v(_vm._s(user.v_user_tasks_hours_label))])])]), _vm._v(" "), _c('div', {
	      staticClass: "user-item__arrow"
	    }, [(!user.v_is_active_user) ? _c('span', {
	      staticClass: "icon-arrow-right4"
	    }) : _c('span', {
	      staticClass: "icon-arrow-down4"
	    })])])]), _vm._v(" "), (user.v_is_active_user) ? _c('ArbeidsplanUser', {
	      attrs: {
	        "user": _vm.activeUser,
	        "activeNorm": _vm.activeNorm,
	        "activeNormFormatted": _vm.activeNormFormatted
	      }
	    }) : _vm._e()], 1)
	  }), 0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "annual-norm__body__right"
	  }, [_c('div', {
	    staticClass: "annual-norm__body__right__header"
	  }, [_c('div', {
	    staticClass: "flipper-buttons"
	  }, [_c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': !_vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-year-planning"
	  }), _vm._v("\n                Fag\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': _vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-file-text"
	  }), _vm._v("\n                Oppgaver\n              ")])])]), _vm._v(" "), (!_vm.isTasksView) ? _c('ArbeidsplanSubjects', {
	    on: {
	      "setIsCreate": _vm.setIsCreateSubject,
	      "setEditSubject": _vm.setEditSubject
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isTasksView) ? _c('SubjectsDistributionTasks') : _vm._e()], 1)])], 2)], _vm._v(" "), (_vm.isSubjectModal) ? _c('CreateSubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "initCalendarId": _vm.activeCalendarId,
	      "editSubject": _vm.theEditSubject,
	      "editSubjectId": _vm.theEditSubjectId
	    },
	    on: {
	      "close": _vm.closeSubjectModal,
	      "createSubject": _vm.createNewSubject,
	      "updateSubject": _vm.updateSubject,
	      "deleteSubject": _vm.deleteSubject
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$store.commit('setConfirmDeletion', false)
	      },
	      "confirm": _vm.confirmDelete
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "padding": "1rem 1rem 0 1rem"
	    },
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "desktop-wrapper"
	  }, [_c('desktop-header', {
	    attrs: {
	      "calname": _vm.calInfo.name,
	      "schoolname": _vm.schoolName
	    },
	    on: {
	      "locale": _vm.setLocale
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "wrapper"
	  }, [_c('week-selector', {
	    attrs: {
	      "startDate": _vm.calInfo.start_date,
	      "endDate": _vm.calInfo.end_date,
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box cal-container"
	  }, [_c('full-calendar-header', {
	    attrs: {
	      "locale": _vm.locale,
	      "date": _vm.date,
	      "calview": _vm.calView,
	      "isNotThisWeek": _vm.isNotThisWeek
	    },
	    on: {
	      "today": _vm.setToday,
	      "prevWeek": _vm.prevWeek,
	      "nextWeek": _vm.nextWeek
	    }
	  }), _vm._v(" "), _c('full-calendar', {
	    attrs: {
	      "calendarId": _vm.calId,
	      "locale": _vm.locale,
	      "caldate": _vm.date,
	      "events": _vm.allEvents,
	      "viewState": _vm.calInfo.view_state,
	      "i18n": _vm.i18n
	    },
	    on: {
	      "eventclick": _vm.showEvent,
	      "view": _vm.setView
	    }
	  })], 1), _vm._v(" "), _c('weekplan', {
	    attrs: {
	      "locale": _vm.locale,
	      "calId": _vm.calId,
	      "date": _vm.date,
	      "events": _vm.allEvents,
	      "calview": _vm.calView.type
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [_c('div', {
	    staticClass: "do-table__filters"
	  }, [_c('div', {
	    staticClass: "do-table__filters__left"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": "Grupper",
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": function($event) {
	        _vm.selectedTags = []
	      }
	    }
	  }), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Organisationer",
	      "tags": _vm.organisations,
	      "selectedTags": _vm.selectedOrganisations
	    },
	    on: {
	      "select": _vm.selectedOrganisation,
	      "clear": function($event) {
	        _vm.selectedOrganisations = []
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-table__filters__add"
	  }, [_c('span', [_vm._v("Viser " + _vm._s(_vm.filteredUsers.length) + " af " + _vm._s(_vm.users.length) + " brugere")])])]), _vm._v(" "), _c('SalarySettingsUsersTable', {
	    attrs: {
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
	      "filteredUsers": _vm.filteredUsers,
	      "isImportOfEmployments": true
	    },
	    on: {
	      "editEmployment": function($event) {
	        return _vm.$emit('editEmployment', $event)
	      },
	      "setTheEditUser": function($event) {
	        return _vm.$emit('setTheEditUser', $event)
	      }
	    }
	  })]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "flex"
	  }, [_c('div', {
	    staticClass: "header-container box-shadow"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "nav"
	  }, [_c('div', {
	    staticClass: "nav-left"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.calname))])]), _vm._v(" "), _c('div', {
	    staticClass: "nav-right no-print"
	  }, [_c('set-locale', {
	    on: {
	      "locale": _vm.emitLocale
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "print-button marg-5-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "print-button marg-5-left",
	    on: {
	      "click": _vm.printWithoutColors
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  }), _vm._v(" " + _vm._s(_vm.$t('calendars.public.print_in_black_white')) + "\n        ")])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "docendo-logo box-shadow no-print"
	  }, [_c('span', {
	    staticClass: "icon-docendo docendo-logo__icon",
	    attrs: {
	      "id": "d-icon"
	    }
	  })])
	}]}

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-grouping text-dark"
	  }, [_c('div', {
	    staticClass: "d-grouping__header"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.tagging.tagging_users')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-grid-table"
	  }, [_c('div', {
	    staticClass: "d-grid-table__column d-grid-table__column-1"
	  }, [_c('div', {
	    staticClass: "d-grid-table__column-header"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n['groups']) + "\n        ")]), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "tags-li__create"
	  }, [_c('button', {
	    staticClass: "btn btn-trans",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(true)
	      }
	    }
	  }, [_vm._v("\n              + " + _vm._s(_vm.i18n['create_a_new_group']) + "\n            ")])]), _vm._v(" "), _c('li', {
	    class: {
	      'filter--active': !_vm.activeTag
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setActiveTag(null)
	      }
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.i18n['all']))]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v("\n              " + _vm._s(_vm.usersSortedOnName.length) + "\n            ")])]), _vm._v(" "), _vm._l((_vm.tagsWithProps), function(tag) {
	    return _c('li', {
	      key: tag.v_name,
	      ref: "droppable_elements",
	      refInFor: true,
	      staticClass: "tag-filter",
	      class: [{
	        'filter--active': _vm.activeTag === tag.v_name
	      }],
	      on: {
	        "click": function($event) {
	          return _vm.setActiveTag(tag.v_name)
	        },
	        "dragover": function($event) {
	          $event.preventDefault();
	        },
	        "dragenter": function($event) {
	          $event.preventDefault();
	          return _vm.dragEnter(tag, $event)
	        },
	        "dragleave": function($event) {
	          $event.preventDefault();
	          return _vm.dragLeave.apply(null, arguments)
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(tag, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "tags-li__left"
	    }, [_c('DDropdown', [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditTag(tag)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.rename')) + "\n                  ")]), _vm._v(" "), _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteTag(tag)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    }), _vm._v("\n                    " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                  ")])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(tag.v_name))])], 1), _vm._v(" "), _c('div', [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n              " + _vm._s(tag.v_number_of_persons) + "\n            ")])])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-grid-table__column d-grid-table__column-3"
	  }, [_c('div', {
	    staticClass: "d-grid-table__column-header"
	  }, [_c('div', {
	    staticClass: "d-grid-table__column-header__left"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.users')) + "\n            "), (_vm.activeTag) ? [_vm._v(" " + _vm._s(_vm.i18n['in_the_group']) + ": "), _c('span', {
	    staticClass: "icon-price-tag2 marg-5-right marg-1-left"
	  }), _vm._v(_vm._s(_vm.activeTag) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-grid-table__column-header__right"
	  }, [_c('div', [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "isSmall": true,
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.activeTag) ? _c('DSelect', {
	    staticClass: "marg-1-left",
	    attrs: {
	      "items": _vm.usersForDSelect,
	      "itemsSelected": [],
	      "placeholder": _vm.$t('vue2.common.add_user'),
	      "showSelectedUsers": false
	    },
	    on: {
	      "add": function($event) {
	        return _vm.addUserToTag($event)
	      }
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "users-list-header"
	  }, [_c('span', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.usersSelectedForDrag.length < 1) ? [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))] : [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))]], 2)]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "user-in-list",
	      class: {
	        'isSelected': user.v_isSelectedForDrag
	      },
	      attrs: {
	        "draggable": "true"
	      },
	      on: {
	        "dragover": function($event) {
	          $event.stopPropagation();
	        },
	        "dragstart": function($event) {
	          $event.stopPropagation();
	          return _vm.dragStart(user, $event)
	        },
	        "dragend": function($event) {
	          $event.stopPropagation();
	          return _vm.dragEnd(user, $event)
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(user, $event)
	        }
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          boundary: 'window',
	          arrow: false,
	          placement: 'left-start'
	        }),
	        expression: "{boundary: 'window', arrow: false, placement : 'left-start'}"
	      }],
	      staticClass: "user-in-list__left",
	      attrs: {
	        "content": _vm.i18n['drag_and_drop_explained']
	      }
	    }, [_c('svg', {
	      staticStyle: {
	        "enable-background": "new 0 0 572.156 572.156"
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "xmlns:xlink": "http://www.w3.org/1999/xlink",
	        "version": "1.1",
	        "id": "Capa_1",
	        "x": "0px",
	        "y": "0px",
	        "width": "13px",
	        "height": "13px",
	        "viewBox": "0 0 572.156 572.156",
	        "xml:space": "preserve"
	      }
	    }, [_c('g', [_c('polygon', {
	      attrs: {
	        "points": "495.405,241.769 418.657,197.457 418.657,258.115 314.042,258.115 314.042,153.498 374.699,153.498    330.389,76.751 286.078,0 241.769,76.751 197.457,153.498 258.115,153.498 258.115,258.115 153.498,258.115 153.498,197.457    76.751,241.767 0,286.078 76.751,330.387 153.498,374.699 153.498,314.042 258.115,314.042 258.115,418.657 197.457,418.657    241.767,495.405 286.078,572.156 330.387,495.405 374.699,418.657 314.042,418.657 314.042,314.042 418.657,314.042    418.657,374.699 495.405,330.389 572.156,286.078  "
	      }
	    })]), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')]), _vm._v(" "), _c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          return _vm.setUsersSelectedForDrag(user)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': false
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "user-name"
	    }, [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', {
	      staticClass: "user-tags"
	    }, _vm._l((user.user_tags), function(tag) {
	      return _c('div', {
	        staticClass: "d-tag"
	      }, [_c('div', {
	        staticClass: "d-tag__text"
	      }, [_vm._v(_vm._s(tag))]), _vm._v(" "), _c('div', {
	        staticClass: "icon-cross2 d-tag__icon",
	        on: {
	          "click": function($event) {
	            return _vm.deleteTagFromUser(user, tag)
	          }
	        }
	      })])
	    }), 0)])
	  })], 2)])])]), _vm._v(" "), (_vm.isModal) ? _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "is-bg-overlay": true
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(!_vm.theEditTag && !_vm.theDeleteTag) ? _c('span', [_vm._v(_vm._s(_vm.i18n['create_group']))]) : _vm._e(), _vm._v(" "), (_vm.theEditTag && !_vm.theDeleteTag) ? _c('span', [_vm._v(_vm._s(_vm.i18n['edit_group']))]) : _vm._e(), _vm._v(" "), (_vm.theDeleteTag) ? _c('span', [_vm._v(_vm._s(_vm.i18n['delete_group']))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "role-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [(!_vm.theDeleteTag) ? _c('div', {
	    staticClass: "d-input-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label marg-5-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n['name_for_group']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.tagTitle),
	      expression: "tagTitle",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.tagTitle)
	    },
	    on: {
	      "change": function($event) {
	        _vm.tagTitle = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (!_vm.theDeleteTag && !_vm.theEditTag) ? _c('div', {
	    staticClass: "d-input-group marg-2-bottom"
	  }, [_c('label', {
	    staticClass: "d-label marg-5-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n['select_a_user']))]), _vm._v(" "), _c('DSelectUsers', {
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.theEditTag && !_vm.theDeleteTag) ? _c('button', {
	    staticClass: "submit-button",
	    class: [{
	        'submit-button--disabled': _vm.tagTitle.length < 1 || _vm.selectedUserIds.length === 0
	      },
	      {
	        'submit-button--loading': _vm.isButtonLoading
	      }
	    ],
	    on: {
	      "click": _vm.createTag
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.create')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theEditTag) ? _c('button', {
	    staticClass: "submit-button",
	    class: [{
	        'submit-button--disabled': _vm.tagTitle.length < 1
	      },
	      {
	        'submit-button--loading': _vm.isButtonLoading
	      }
	    ],
	    on: {
	      "click": _vm.editTag
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.save')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theDeleteTag) ? _c('button', {
	    staticClass: "submit-button submit-button--danger",
	    class: {
	      'submit-button--loading': _vm.isButtonLoading
	    },
	    on: {
	      "click": _vm.deleteTag
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    ref: "customdrag",
	    staticClass: "d-custom-drag",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n['add']) + " " + _vm._s(_vm.usersSelectedForDrag.length) + "\n    "), (_vm.usersSelectedForDrag.length === 1) ? [_vm._v(" " + _vm._s(_vm.$t('vue2.common.user')))] : [_vm._v(" " + _vm._s(_vm.$t('vue2.common.users')))]], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "d_question",
	    staticClass: "d-question",
	    on: {
	      "mouseenter": function($event) {
	        _vm.isHovered = true
	      },
	      "mouseleave": function($event) {
	        _vm.isHovered = false
	      }
	    }
	  }, [_c('div', {
	    ref: "d_popover",
	    staticClass: "d-question__answer",
	    class: {
	      'd-question__answer--show': _vm.isHovered
	    }
	  }, [_vm._t("answer", function() {
	    return [_c('p', [_vm._v("Her er svar på dine spørgsmål")])]
	  })], 2), _vm._v(" "), _c('svg', {
	    attrs: {
	      "width": "16px",
	      "height": "16px",
	      "viewBox": "0 0 16 16"
	    }
	  }, [_c('g', {
	    attrs: {
	      "id": "Artboard-2",
	      "stroke": "none",
	      "stroke-width": "1",
	      "fill": "none",
	      "fill-rule": "evenodd"
	    }
	  }, [_c('g', {
	    attrs: {
	      "id": "Group-2"
	    }
	  }, [_c('circle', {
	    attrs: {
	      "id": "Oval-10",
	      "fill": "#a2a3a6",
	      "cx": "8",
	      "cy": "8",
	      "r": "8"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M7.354,9.657 L7.354,9.294 C7.354,7.732 9.059,7.292 9.059,6.148 C9.059,5.51 8.652,5.191 8.014,5.191 C7.343,5.191 6.826,5.609 6.826,6.445 L5.473,6.445 C5.473,4.729 6.573,3.948 8.102,3.948 C9.389,3.948 10.533,4.608 10.533,6.005 C10.533,7.666 8.663,8.183 8.663,9.437 L8.663,9.657 L7.354,9.657 Z M7.156,11.373 C7.156,10.878 7.464,10.559 8.003,10.559 C8.509,10.559 8.85,10.878 8.85,11.34 C8.85,11.813 8.509,12.143 8.003,12.143 C7.464,12.143 7.156,11.813 7.156,11.373 Z",
	      "id": "?",
	      "fill": "#FFFFFF"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createuser_button.create_user')))])
	},staticRenderFns: []}

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weekdays-selector"
	  }, [_c('h3', [_vm._v("Kun specifikke dag/dage")]), _vm._v(" "), _c('app-toogler', {
	    attrs: {
	      "propOn": false
	    },
	    on: {
	      "changed": _vm.setSelectorActive
	    }
	  }), _vm._v(" "), (_vm.isSelectorActive) ? _c('div', {
	    staticClass: "weekdays"
	  }, _vm._l((_vm.weekDays), function(day, idx) {
	    return _c('div', {
	      staticClass: "weekday",
	      class: {
	        'isSelected': _vm.isInList(day)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleDay(day, idx)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(_vm._f("dddd")(day.date)) + "\n    ")])
	  }), 0) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container marg-1-top"
	  }, [_c('h4', {
	    staticClass: "uppercase marg-1-bottom"
	  }, [_vm._v("Fag")]), _vm._v(" "), (_vm.personaleUdenKorrekteOplysninger.length === 0 && _vm.fagUdenKorrekteOplysninger.length === 0) ? _c('h3', [_vm._v("Alt er udfyldt\n    korrekt")]) : _vm._e(), _vm._v(" "), (_vm.personaleUdenKorrekteOplysninger.length > 0 || _vm.fagUdenKorrekteOplysninger.length > 0) ? _c('div', {
	    staticClass: "d-attention"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v(" "), _c('h3', [_vm._v("Følgende fag mangler oplysninger")]), _vm._v(" "), _c('p', [_vm._v("Gå til step 3. \"Fag\" og tilføj oplysningerne eller slet faget, hvis faget ikke skal indberettes.")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__borders"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.fagUdenKorrekteOplysninger), function(fag, key) {
	    return _c('tr', {
	      key: fag.fag_id
	    }, [_c('td', [_vm._v(_vm._s(fag.klasse) + ", " + _vm._s(fag.fag_navn))]), _vm._v(" "), _c('td', _vm._l((fag.errors), function(error, errorIdx) {
	      return _c('span', {
	        staticClass: "fag-errors"
	      }, [_vm._v(_vm._s(error)), (errorIdx + 1 < fag.errors.length) ? [_vm._v(", ")] : _vm._e()], 2)
	    }), 0)])
	  }), 0)])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("Fag")]), _vm._v(" "), _c('th', [_vm._v("Fejl")])])
	}]}

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true,
	      "isCloseOnEsc": !_vm.activeOpusUser
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__full-width",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.userName) + " "), _c('span', {
	    staticClass: "d-tag marg-1-left"
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__header__right"
	  }, [(_vm.isSalaryIntegrationActive) ? _c('button', {
	    staticClass: "do-bttn no-print",
	    on: {
	      "click": function($event) {
	        return _vm.setActiveOpusUser(_vm.user)
	      }
	    }
	  }, [_vm._v("\n          Se i OPUS\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn no-print",
	    on: {
	      "click": function($event) {
	        _vm.isShowUserTable = !_vm.isShowUserTable
	      }
	    }
	  }, [_vm._v("\n          Vis tabel\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn no-print",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle no-print",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content",
	    attrs: {
	      "id": "printUserSalary"
	    }
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('h4', {
	    staticClass: "italic"
	  }, [_vm._v("\n        Ikke flere dage på brugeren i "), _c('span', {
	    staticClass: "d-tag"
	  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.isLoading) ? _c('div', {
	    staticClass: "user-list__user"
	  }, [_c('h2', {
	    staticClass: "only-print marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.user && _vm.user.v_user_name ? _vm.user.v_user_name : '') + " "), _c('span', {
	    staticClass: "d-tag marg-1-left"
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "user-list__user__header"
	  }, [_c('h4', [_vm._v("Samlet timer for perioden i "), _c('span', {
	    staticClass: "d-tag"
	  }, [_vm._v(_vm._s(_vm.title))]), _c('br'), _vm._v(_vm._s(_vm.titleOfPeriod))]), _vm._v(" "), _c('ul', _vm._l((_vm.user.v_user_sums), function(sum) {
	    return _c('li', {
	      key: sum.employment_id,
	      class: {
	        'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
	      }
	    }, [_vm._v("\n              " + _vm._s(sum.employment_title) + ": "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))])])
	  }), 0)]), _vm._v(" "), (_vm.isShowUserTable) ? _c('SalarySubsPerfUserTable', {
	    attrs: {
	      "user": _vm.user,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowUserTable = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "user-list__user__table user-list__user__table--active"
	  }, [_vm._l((_vm.user.days), function(userDay) {
	    return [_c('tr', {
	      staticClass: "user-list__user__table__header"
	    }, [_c('th', [_vm._v(_vm._s(userDay.v_date_formatted))]), _vm._v(" "), _c('th', [_vm._v("Kalender")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Vikar for")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Lønkode")]) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Løbenummer")]) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive && _vm.costCenters.length > 0) ? _c('th', [_vm._v("Cost center")]) : _vm._e(), _vm._v(" "), _c('th')]), _vm._v(" "), _c('SalarySubsPerfUserDay', {
	      attrs: {
	        "user": _vm.user,
	        "userDay": userDay,
	        "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
	        "salaryCodes": _vm.salaryCodes,
	        "loebenummer": _vm.loebenummer,
	        "costCenters": _vm.costCenters
	      },
	      on: {
	        "updatePropOnLesson": function($event) {
	          return _vm.$emit('updatePropOnLesson', $event)
	        }
	      }
	    }), _vm._v(" "), _c('tr', {
	      key: 'foot-' + userDay.day,
	      staticClass: "user-list__user__table__footer"
	    }, [_c('td', {
	      attrs: {
	        "colspan": !_vm.isSalaryIntegrationActive ? 6 : 9
	      }
	    }, [_c('div', {
	      staticClass: "user-list__user__footer"
	    }, [_c('ul', {
	      staticClass: "user-list__user__footer__sums"
	    }, _vm._l((userDay.v_sums), function(sum) {
	      return _c('li', {
	        key: sum.employment_id,
	        class: {
	          'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
	        }
	      }, [_vm._v("\n                      " + _vm._s(sum.employment_title) + ": "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))])])
	    }), 0), _vm._v(" "), (userDay.state === 'approved') ? _c('div', {
	      staticClass: "submit-buttons no-print"
	    }, [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                      arrow: true,\n                      animateFill: false,\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                    }"
	      }],
	      staticClass: "do-bttn do-bttn--danger no-print",
	      attrs: {
	        "content": 'Dagen vil blive genberegnet'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('unApproveDay', userDay)
	        }
	      }
	    }, [_vm._v("\n                      Fortryd godkendelse\n                    ")]), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn do-bttn--submit no-print",
	      on: {
	        "click": function($event) {
	          return _vm.$emit('changeStateIsSent', userDay)
	        }
	      }
	    }, [_vm._v("\n                      " + _vm._s(_vm.isSalaryIntegrationActive ? 'Send til lønsystem' : 'Er indberettet') + "\n                    ")])]) : _vm._e(), _vm._v(" "), (userDay.state === 'draft') ? [(_vm.getIsDayValidated(userDay)) ? _c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                      arrow: true,\n                      animateFill: false,\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                    }"
	      }],
	      staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled no-print",
	      attrs: {
	        "content": 'Du skal vælge ansættelse på hver lektion'
	      }
	    }, [_vm._v("\n                      Godkend\n                    ")]) : _c('button', {
	      staticClass: "do-bttn do-bttn--submit no-print",
	      class: {
	        'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('approveDay', userDay)
	        }
	      }
	    }, [_vm._v("\n                      Godkend\n                    ")])] : _vm._e()], 2)])])]
	  })], 2)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.activeOpusUser) ? _c('SalarySubsPerfUserOpusModal', {
	    attrs: {
	      "user": _vm.activeOpusUser,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "schoolId": _vm.schoolId
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setActiveOpusUser(null)
	      }
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.create_activity.create_new_subject_for')) + " " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.title')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subjectName),
	      expression: "subjectName"
	    }],
	    ref: "d_title_input",
	    staticClass: "d-input",
	    staticStyle: {
	      "height": "34px"
	    },
	    attrs: {
	      "id": "d-title-input-for-new-subject"
	    },
	    domProps: {
	      "value": (_vm.subjectName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subjectName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.choose_subject_type')))]), _vm._v(" "), _c('SubjectFormSubjectType', {
	    attrs: {
	      "calendarType": 'user'
	    },
	    on: {
	      "change": _vm.setSubjectType
	    }
	  })], 1), _vm._v(" "), (!_vm.isLoadingUserSchools && _vm.isUserHasMultipleSchools) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.choose_school')))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theActiveSchoolId),
	      expression: "theActiveSchoolId"
	    }],
	    staticClass: "d-select-with-options",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theActiveSchoolId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.userSchools), function(school) {
	    return _c('option', {
	      key: school.id,
	      domProps: {
	        "value": school.id
	      }
	    }, [_vm._v("\n            " + _vm._s(school.name) + "\n          ")])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dates text-dark"
	  }, [_c('div', {
	    staticClass: "dates__header"
	  }, [_c('ChangeSchoolYear', {
	    staticClass: "fit-content dates__change-schoolyear",
	    attrs: {
	      "whiteTheme": true
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "dates-input-group"
	  }, [_c('label', [_vm._v("Select the start and end dates for insertion")]), _vm._v(" "), _c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _c('div', {
	    staticClass: "dates-input-group marg-1-top"
	  }, [_c('p', {
	    staticClass: "text-explainer"
	  }, [_c('b', [_vm._v("Hint:")]), _vm._v(" Click on a day to exclude/include day in rotation")]), _vm._v(" "), _vm._l((_vm.groupedDatesByMonth), function(monthData, month) {
	    return _c('div', {
	      key: month,
	      staticClass: "cal-month"
	    }, [_c('h3', [_vm._v(_vm._s(month))]), _vm._v(" "), _c('ul', {
	      staticClass: "cal-month__header"
	    }, [_c('li', [_vm._v("Mon")]), _vm._v(" "), _c('li', [_vm._v("Tue")]), _vm._v(" "), _c('li', [_vm._v("Wed")]), _vm._v(" "), _c('li', [_vm._v("Thu")]), _vm._v(" "), _c('li', [_vm._v("Fri")]), _vm._v(" "), _c('li', [_vm._v("Sat")]), _vm._v(" "), _c('li', [_vm._v("Sun")])]), _vm._v(" "), _c('ul', {
	      staticClass: "cal-month__body"
	    }, [_vm._l((monthData.emptyDays), function(n) {
	      return _c('li', [_vm._v(" ")])
	    }), _vm._v(" "), _vm._l((monthData.dates), function(dateObj, i) {
	      return _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            zIndex: 123123123123
	          }),
	          expression: "{\n                  arrow: true,\n                  zIndex: 123123123123\n                }"
	        }],
	        key: i,
	        staticClass: "cal-month__body__day",
	        class: [{
	            'cal-month__body__day--can-be-toggled': !dateObj.isVacationDay && !dateObj.isWeekend
	          },
	          {
	            'cal-month__body__day--holiday': dateObj.isVacationDay
	          },
	          {
	            'cal-month__body__day--inactive': !dateObj.isIncluded
	          },
	          {
	            'cal-month__body__day--is-weekend': dateObj.isWeekend
	          }
	        ],
	        attrs: {
	          "content": dateObj.isWeekend ? 'Weekend' : dateObj.isVacationDay ? 'Vacation day' : dateObj.isIncluded ? 'Exclude day in rotation' : 'Include day in rotation'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.toggleDate(dateObj)
	          }
	        }
	      }, [_c('p', {
	        staticClass: "cal-month__body__date"
	      }, [_vm._v(_vm._s(dateObj.formattedDate))]), _vm._v(" "), (dateObj.dayToInsert) ? _c('p', {
	        staticClass: "cal-month__body__date__to-insert"
	      }, [_vm._v(_vm._s(dateObj.dayToInsert.label))]) : _vm._e()])
	    })], 2)])
	  })], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "marg-20-top weekplan"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('h2', {
	    staticClass: "marg-20-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))]), _vm._v(" "), (_vm.weekNote !== undefined && _vm.weekNote.length) ? _c('div', {
	    staticClass: "week_note"
	  }, [_c('div', {
	    staticClass: "week_note__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.weekNoteWithLineBreaks)
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('ul', [_vm._l((_vm.eventsWithNotes), function(day) {
	    return [(day.lessons.length !== 0) ? _c('li', {
	      staticClass: "day_change"
	    }, [_c('div', {
	      staticClass: "day_change_header"
	    }, [_c('h3', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.createLocaleDate(day.date))))])]), _vm._v(" "), _c('div', {
	      staticClass: "grid grid grid-responsive"
	    }, [_c('div', {
	      staticClass: "col-2-12 box-size"
	    }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.subject')))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-10-12"
	    }, [_c('div', {
	      staticClass: "col-1-3"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.learning_goal')))])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-1-3"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.content')) + " ")])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-1-3"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.pupil_preparation')))])])])])]), _vm._v(" "), _vm._l((day.lessons), function(event) {
	      return [_c('d-week-plan-lesson', {
	        attrs: {
	          "event": event,
	          "date": _vm.date
	        }
	      })]
	    })], 2) : _vm._e()]
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__user__settings__notifications text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['user_settings']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), (_vm.isSMSActive) ? _c('div', {
	    staticClass: "d-input-group__group"
	  }, [_c('div', {
	    staticClass: "d-input-group input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['mobile_number']))]), _vm._v(" "), _c('div', {
	    staticClass: "flex-group",
	    class: {
	      'animated shake': _vm.isAnimatePhone
	    }
	  }, [_c('div', {
	    staticClass: "flag__input-lookalike active-country"
	  }, [_c('img', {
	    staticClass: "country-flag",
	    attrs: {
	      "src": _vm.activeCountry.flag
	    }
	  }), _vm._v("+" + _vm._s(_vm.activeCountry.countryCode) + "\n              "), _c('DDropdown', [_c('span', {
	    staticClass: "icon-arrow-down5",
	    attrs: {
	      "slot": "d-dropdown__icon"
	    },
	    slot: "d-dropdown__icon"
	  }), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.countries), function(country) {
	    return _c('li', {
	      key: country.countryCode,
	      staticClass: "country-select__item",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveCountry(country)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "country-select__item__name"
	    }, [_c('img', {
	      staticClass: "country-flag",
	      attrs: {
	        "src": country.flag
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(country.name))])]), _vm._v("\n                    + " + _vm._s(country.countryCode) + "\n                  ")])
	  }), 0)])], 1), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.phone),
	      expression: "phone"
	    }],
	    ref: "input_phone",
	    staticClass: "d-input",
	    class: {
	      'input--error': !_vm.isPhoneValid
	    },
	    domProps: {
	      "value": (_vm.phone)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.onPhoneKeyup($event.target.value)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.phone = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (!_vm.isPhoneValid) ? _c('span', {
	    staticClass: "error-text marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['number_must_be_8_digits']))]) : _vm._e()]), _vm._v(" "), (_vm.user.unconfirmed_phone) ? _c('div', {
	    staticClass: "d-label d-pill",
	    class: {
	      'animated shake': _vm.isAnimatePhoneUnconfirmed
	    }
	  }, [_c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	    }
	  })]), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['awaiting_approval']) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.hideSMSToggle && (_vm.user.v_phone_setting === 'active' || _vm.user.v_phone_setting === 'deactivated')) ? _c('div', {
	    staticClass: "d-input-group marg-2-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['receive_sms']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group__toggle",
	    on: {
	      "click": function($event) {
	        return _vm.toggleSetting('phone')
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.receiveSMS
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('div', {
	    staticClass: "d-input-group__group"
	  }, [_c('div', {
	    staticClass: "d-input-group input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['email']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "d-input",
	    class: {
	      'input--error': !_vm.isEmailValid
	    },
	    staticStyle: {
	      "height": "40px"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.onEmailKeyup($event.target.value)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (!_vm.isEmailValid) ? _c('span', {
	    staticClass: "error-text marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['use_a_valid_email']))]) : _vm._e()]), _vm._v(" "), (!_vm.hideEmailToggle && (_vm.user.v_email_setting === 'active' || _vm.user.v_email_setting === 'deactivated')) ? _c('div', {
	    staticClass: "d-input-group marg-2-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['receive_email']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group__toggle",
	    on: {
	      "click": function($event) {
	        _vm.receiveEmails = !_vm.receiveEmails
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.receiveEmails
	    }
	  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group d-input-group__submit"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    class: [{
	      ' bttn--loading': _vm.isSubmitting
	    }, {
	      'bttn-primary--disabled': !this.isEmailValid || !this.isPhoneValid
	    }],
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "to-user text-dark"
	  }, [_c('h1', {
	    staticClass: "to-user__headline"
	  }, [_vm._v(_vm._s(_vm.user.name) + ", " + _vm._s(_vm.schoolYear)), (_vm.version.vTitle) ? _c('span', {
	    staticClass: "to-d-pill"
	  }, [_vm._v(_vm._s(_vm.version.vTitle))]) : _vm._e()]), _vm._v(" "), (_vm.userNorm.length > 0) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.annual_norm')))])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userNormFormatted), function(item, idx) {
	    return (idx < _vm.userNormFormatted.length - 1) ? _c('tr', {
	      key: item.title
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  }), 0), _vm._v(" "), _c('tfoot', _vm._l((_vm.userNormFormatted), function(item, idx) {
	    return (idx === _vm.userNormFormatted.length - 1) ? _c('tr', {
	      key: item.title
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  }), 0)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.userPoolsFormatted).length > 0) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.i18n['pools']))])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.userPoolsFormatted), function(pool, prop) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(prop))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(pool) + "\n      ")])])
	  }), _vm._v(" "), (_vm.rest) ? _c('tr', [_c('td', [_vm._v("Rest")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.rest) + "\n      ")])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.schoolSettingShownOwnPools && _vm.schoolSettingShownOwnPools.length > 0) ? _c('UserTasksOverviewOwnPools', {
	    attrs: {
	      "schoolSettingShownOwnPools": _vm.schoolSettingShownOwnPools,
	      "isShowScheduled": false,
	      "userTasks": _vm.tasksByMasterType
	    }
	  }) : _vm._e(), _vm._v(" "), _c('TaskOverviewUserTasks', {
	    attrs: {
	      "user": _vm.user,
	      "tasks": _vm.tasks,
	      "tasksByMasterType": _vm.tasksByMasterType,
	      "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours,
	      "isHideTaskHoursUnderThreshold": _vm.isHideTaskHoursUnderThreshold
	    }
	  }), _vm._v(" "), (_vm.userAgreements && _vm.userAgreements.length > 0) ? _c('div', {
	    staticClass: "to-agreements"
	  }, [_c('div', {
	    staticClass: "to-agreements__header"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n['notes']))])]), _vm._v(" "), _c('div', {
	    staticClass: "to-agreements__body",
	    domProps: {
	      "innerHTML": _vm._s(_vm.userAgreements)
	    }
	  })]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-tasks text-dark"
	  }, [(_vm.isShowHeader) ? _c('div', {
	    staticClass: "user-tasks__header no-print"
	  }, [_c('div', {
	    staticClass: "user-tasks__header__left"
	  }, [_c('h2', {
	    staticClass: "user-tasks__header__left__inner"
	  }, [(!_vm.isCanSeeOtherUsers) ? _c('h2', [_vm._v(_vm._s(_vm.user.name))]) : _c('SelectUser', {
	    attrs: {
	      "preSelectedUserId": _vm.user_id,
	      "userName": _vm.user_name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "no-mobile"
	  }, [_vm._v("-")]), _vm._v(" "), (_vm.isKindergarten) ? _c('p', [_vm._v("Årsnormsoversigt")]) : _c('p', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.task_overview')))])], 1), _vm._v(" "), (!_vm.initialStartDate) ? _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "user-tasks__header__right"
	  }, [(_vm.user && _vm.canUserSeeVersions) ? _c('TaskOverviewVersions', {
	    attrs: {
	      "user": _vm.user
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isStartOrEndDateChanged) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), (_vm.activeSchoolYear) ? _c('DatePickerRangeShortcuts', {
	    attrs: {
	      "startDate": _vm.activeSchoolYear.employee_time_start,
	      "endDate": _vm.activeSchoolYear.employee_time_end,
	      "selectedStartDate": _vm.startDate,
	      "selectedEndDate": _vm.endDate
	    },
	    on: {
	      "shortcutSelected": _vm.setDatesFromRange
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), (_vm.isShowPrintButton) ? _c('button', {
	    staticClass: "no-mobile marg-1-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && _vm.isShowHeader) ? _c('div', {
	    staticClass: "d-box marg-1-bottom no-mobile"
	  }, [_c('UserTasksChart', {
	    attrs: {
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "calendarId": _vm.user.user_calendar_id
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoadingTasksForUser) ? _c('Loader') : _c('div', {
	    staticClass: "marg-1-bottom"
	  }, [_c('UserTasksOverview', {
	    attrs: {
	      "user": _vm.user,
	      "dates": _vm.dates,
	      "activeUserId": this.user.id,
	      "isInUserCalendar": true,
	      "isKindergarten": _vm.isKindergarten,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate,
	      "isShowHeader": _vm.isShowHeader,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated,
	      "schoolPrepFactor": _vm.schoolPrepFactor
	    },
	    on: {
	      "changedIsShowScheduled": _vm.setIsShowScheduled
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark d-modal__select-teacher-for-sub",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['which_teacher_will']) + " " + _vm._s(_vm.substitute.name) + " " + _vm._s(_vm.i18n[_vm.locale]['be_substitute_for']) + "?")]), _vm._v(" "), _c('ul', _vm._l((_vm.teachers), function(teacher) {
	    return _c('li', {
	      key: teacher.id,
	      staticClass: "select-teacher-for-sub__teacher"
	    }, [_vm._v("\n          " + _vm._s(teacher.name) + "\n          "), _c('button', {
	      staticClass: "bttn bttn-primary",
	      staticStyle: {
	        "padding": "2px 1rem"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('select', teacher)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.common.select')))])])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.event && !_vm.event.deleted) ? _c('div', {
	    staticClass: "up__event"
	  }, [_c('div', {
	    staticClass: "up__event-edit"
	  }, [_c('timechanger', {
	    staticClass: "time-changer__create-presence",
	    class: {
	      'input-warning': _vm.event.tempIntersect
	    },
	    attrs: {
	      "lang": "da",
	      "start": _vm.event.start,
	      "end": _vm.event.end,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.updateStart,
	      "updateEnd": _vm.updateEnd
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "up__event-delete pointer",
	    on: {
	      "click": _vm.deleteEvent
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross3"
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "up__event-sum"
	  }, [_vm._v("\n    " + _vm._s(_vm.duration) + "\n  ")])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "intern-notes-container"
	  }, [_c('button', {
	    staticClass: "open-button",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_vm._v("Interne noter "), (_vm.noteText.length > 1) ? _c('div', {
	    staticClass: "dot"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "subs-note",
	    class: {
	      'subs-note--is-open': _vm.isOpen
	    }
	  }, [_c('div', {
	    staticClass: "subs-note__container"
	  }, [_c('div', {
	    staticClass: "subs-note__container__header"
	  }, [_c('div', {
	    staticClass: "subs-note__container__header__close",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v("Dagens interne noter")])]), _vm._v(" "), _c('div', {
	    staticClass: "subs-note__container__body"
	  }, [_c('h3', [_vm._v("Noter til " + _vm._s(_vm.showDate))]), _vm._v(" "), _c('div', {
	    staticClass: "subs-note__container__note"
	  }, [_c('AppEIPWYZIWYG', {
	    attrs: {
	      "textInput": _vm.noteText
	    },
	    on: {
	      "close": _vm.updateNoteText
	    }
	  })], 1)])])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = false
	      }
	    }
	  }) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "permissions"
	  }, [_c('div', {
	    staticClass: "permissions__col"
	  }, [_c('div', {
	    staticClass: "permissions__col__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.permissions.roles')))])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col__body"
	  }, [_c('ul', [(_vm.isLoadingRoles) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff",
	      "size": "small"
	    }
	  }) : _vm._l((_vm.rolesWithMeta), function(role) {
	    return _c('li', {
	      key: role.id,
	      staticClass: "permissions__roles__role",
	      class: {
	        'permissions__roles__role--is-active': _vm.isActiveRole(role)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveRole(role)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "role__left"
	    }, [_c('p', [_vm._v(_vm._s(role.v_title))])]), _vm._v(" "), _c('div', {
	      staticClass: "role__right"
	    }, [_c('span', {
	      staticClass: "role__number-of-user"
	    }, [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n            " + _vm._s(role.user_ids.length) + "\n            ")]), _vm._v(" "), (role.name !== 'Administrator' && role.name !== 'Regular user' && role.name !== 'Read only user') ? _c('DDropdown', {
	      staticClass: "role-dropdown"
	    }, [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditRole(role)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.rename')) + "\n                ")]), _vm._v(" "), (role.user_ids.length > 0) ? _c('li', {
	      staticClass: "d-item-warning d-item-warning--disabled hint--right",
	      attrs: {
	        "aria-label": _vm.$t('vue2.permissions.you_cant_delete_a_role_that_has_users')
	      }
	    }, [_c('div', {
	      staticClass: "d-item-warning--disabled__inner"
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    }), _vm._v("\n                    " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (role.user_ids.length === 0) ? _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteRole(role)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                ")]) : _vm._e()])]) : _vm._e()], 1)])
	  }), _vm._v(" "), (!_vm.isLoadingRoles) ? _c('li', {
	    staticClass: "permissions__roles__role__create"
	  }, [_c('button', {
	    staticClass: "btn btn-trans",
	    on: {
	      "click": function($event) {
	        return _vm.setIsRoleModal(true)
	      }
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.permissions.create_new_role')) + "\n          ")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col"
	  }, [_c('div', {
	    staticClass: "permissions__col__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.permissions.users')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeRole ? _vm.activeRole.v_title : ''))])])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col__body"
	  }, [_c('div', {
	    staticClass: "permissions__col__body__users"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('DSelect', {
	    attrs: {
	      "items": _vm.usersForDSelect,
	      "itemsSelected": [],
	      "placeholder": _vm.$t('vue2.common.add_user'),
	      "showSelectedUsers": false
	    },
	    on: {
	      "add": function($event) {
	        return _vm.addUserToRole($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('ul', {
	    staticClass: "permissions__col__body__users__list"
	  }, [_c('virtual-list', {
	    staticStyle: {
	      "height": "500px",
	      "overflow-y": "auto"
	    },
	    attrs: {
	      "estimate-size": 40,
	      "keeps": 20,
	      "data-key": 'id',
	      "data-sources": _vm.usersWithActiveRole,
	      "data-component": _vm.itemComponent,
	      "extra-props": {
	        selectableRoles: _vm.selectableRoles
	      }
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col"
	  }, [_c('div', {
	    staticClass: "permissions__col__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.permissions.permissions')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeRole && _vm.activeRole.v_title))])])]), _vm._v(" "), _c('div', {
	    staticClass: "permissions__col__body"
	  }, [(_vm.getRoleDesc.length > 0) ? _c('p', {
	    staticClass: "role__desc"
	  }, [_vm._v(_vm._s(_vm.getRoleDesc))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "permissions__permissions"
	  }, _vm._l((_vm.activePermissions), function(permission) {
	    return _c('li', {
	      key: permission.permission,
	      staticClass: "permissions__permissions__permission",
	      attrs: {
	        "data-permission": permission.permission
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          return _vm.togglePermissionToRole(permission.permission)
	        }
	      }
	    }, [(_vm.getIsPermissioni18n(permission.permission)) ? _c('p', [_vm._v(_vm._s(_vm.getIsPermissioni18n(permission.permission)))]) : _c('p', [_vm._v(_vm._s(permission.vTitle))]), _vm._v(" "), _c('app-toggle', {
	      attrs: {
	        "propOn": _vm.isPermissionInActiveRole(permission.permission)
	      }
	    })], 1)
	  }), 0)])]), _vm._v(" "), (_vm.isRoleModal) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "role-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "role-modal__header"
	  }, [_c('h2', [(!_vm.theEditRole && !_vm.theDeleteRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.create_new_role')))]) : _vm._e(), _vm._v(" "), (_vm.theEditRole && !_vm.theDeleteRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.rename_role')))]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.delete_role')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "role-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsRoleModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "role-modal__body"
	  }, [(!_vm.theDeleteRole) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [(!_vm.theEditRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.give_role_a_title')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.choose_new_name')))])]), _vm._v(" "), _c('input', {
	    ref: "roleCreateInputField",
	    staticClass: "box-shadow bg-white animated",
	    class: {
	      'shake': _vm.isSavingWithoutInput
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.createNewRoleName
	    },
	    on: {
	      "input": _vm.onInput
	    }
	  })]) : _vm._e(), _vm._v(" "), (!_vm.theDeleteRole) ? _c('div', {
	    staticClass: "d-group marg-1-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.select_role_to_base_new_on')))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.existingRoleToCopyId),
	      expression: "existingRoleToCopyId"
	    }],
	    staticClass: "do-select width-100",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.existingRoleToCopyId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.rolesToCopy), function(role) {
	    return _c('option', {
	      key: role.id,
	      domProps: {
	        "value": role.id
	      }
	    }, [_vm._v("\n              " + _vm._s(role.v_title) + "\n            ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length < 1) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.common.are_you_sure_you_want_to_delete')) + "\n            "), _c('span', {
	    staticClass: "text-danger"
	  }, [_vm._v("\"" + _vm._s(_vm.theDeleteRole.v_title) + "\"")]), _vm._v(" " + _vm._s(_vm.$t('vue2.permissions.role')) + " ?")])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length > 0) ? _c('div', {
	    staticClass: "unable-to-delete-warning"
	  }, [_c('h3', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.you_cant_delete_a_role_that_has_users')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.permissions.give_the_following_user_a_new_role')))]), _vm._v(" "), _c('ul', {
	    staticClass: "permissions__col__body__users__list"
	  }, _vm._l((_vm.usersWithActiveRole), function(user) {
	    return _c('li', {
	      staticClass: "permissions__col__body__users__list__user"
	    }, [_c('div', [_c('img', {
	      attrs: {
	        "src": user.default_thumb_url
	      }
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])])])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "submit-buttons marg-10-top"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": function($event) {
	        return _vm.setIsRoleModal(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.theDeleteRole && !_vm.isInputFieldLength) ? _c('button', {
	    staticClass: "submit-button bttn--disabled",
	    on: {
	      "click": _vm.onNoInput
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.create')) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.theEditRole && _vm.isInputFieldLength) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.createNewRole
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theEditRole && _vm.isInputFieldLength) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.updateRoleName
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.rename')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length < 1) ? _c('button', {
	    staticClass: "bttn bttn-danger",
	    on: {
	      "click": _vm.deleteRole
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length > 0) ? _c('button', {
	    staticClass: "bttn bttn--danger bttn--disabled"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.isRoleModal) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e(), _vm._v(" "), _c('PermissionsUserChange', {
	    attrs: {
	      "roles": _vm.selectableRoles
	    },
	    on: {
	      "set": function($event) {
	        return _vm.setRole($event)
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "d_modal",
	    staticClass: "modal-wrapper no-print",
	    class: [{
	      'js-no-close': _vm.appendToBody
	    }, {
	      'modal-wrapper--from-top': _vm.placeInTop
	    }],
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal",
	    style: ({
	      top: !_vm.placeInTop ? '0px' : _vm.pxFromTop + 'rem'
	    })
	  }, [(_vm.showClose) ? _c('div', {
	    staticClass: "close-cross",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]) : _vm._e(), _vm._v(" "), _vm._t("insertComponent", function() {
	    return [_c('h2', [_vm._v("Hello")])]
	  })], 2), _vm._v(" "), (_vm.isBgOverlay) ? _c('div', {
	    staticClass: "bg-overlay animateFast fadeIn",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.$emit('close')
	      }
	    }
	  }) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-tasks",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	      }
	    }
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "isSmall": true
	    }
	  }) : [_c('table', {
	    staticClass: "d-table__inner"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "75%"
	    }
	  }, [_vm._v("Tildelt arbejdstid")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm.tildeltArbejdstid))])]), _vm._v(" "), _c('tr', [_c('th', {
	    staticStyle: {
	      "width": "75%"
	    }
	  }, [_vm._v("Tildelt Undervisningstid")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm.tildeltUndervisning))])]), _vm._v(" "), _c('tr', [_c('th', {
	    staticStyle: {
	      "width": "75%"
	    }
	  }, [_vm._v("Tildelt Undervisningstid uden UUV")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm.tildeltUndervisningUdenUUV))])])])]), _vm._v(" "), _vm._l((_vm.tasksInTypes), function(type, idx) {
	    return _c('table', {
	      staticClass: "d-table__inner"
	    }, [_c('thead', {
	      staticClass: "d-table__inner__thead__small"
	    }, [_c('tr', [_c('th', {
	      staticStyle: {
	        "width": "75%"
	      }
	    }, [_vm._v("\n          " + _vm._s(type.title) + "\n        ")]), _vm._v(" "), _c('th', {
	      staticClass: "text-right"
	    }, [_vm._v("\n          " + _vm._s(type.sum) + "\n        ")])])]), _vm._v(" "), _c('tbody', [(type.events.length < 1) ? _c('tr', [_c('td', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen "), (idx === 0) ? _c('span', [_vm._v("lektioner")]) : _vm._e(), (idx === 1) ? _c('span', [_vm._v("UUV")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._l((type.events), function(task) {
	      return _c('tr', [_c('td', {
	        staticStyle: {
	          "width": "75%"
	        }
	      }, [_c('div', {
	        staticClass: "subject-and-calendar"
	      }, [_c('div', {
	        staticClass: "d-subject",
	        style: ({
	          'border-left-color': task.color
	        })
	      }, [_vm._v(_vm._s(task.name))]), _vm._v("\n            " + _vm._s(task.calendar) + "\n          ")])]), _vm._v(" "), _c('td', {
	        staticClass: "text-right"
	      }, [_vm._v(_vm._s(task.hours))])])
	    })], 2)])
	  })]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "relative"
	  }, [_c('div', {
	    staticClass: "week-picker__content flex"
	  }, [_c('div', {
	    staticClass: "content"
	  }, _vm._l((_vm.weeks), function(week, index) {
	    return _c('div', {
	      directives: [{
	        name: "tooltip",
	        rawName: "v-tooltip"
	      }],
	      key: week.serverDate,
	      staticClass: "number hint--top",
	      class: [{
	        'isSelected': week.isSelected
	      }, {
	        'isCopyWeek': week.isCopyWeek
	      }],
	      attrs: {
	        "aria-label": _vm._f("tooltipDate")(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleWeek(index)
	        }
	      }
	    }, [_c('span', {
	      class: {
	        'isNow': week.isNow
	      }
	    }, [_vm._v("\n            " + _vm._s(week.weekNum) + "\n          ")])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "sortcuts"
	  }, [(!_vm.calid) ? _c('select', {
	    staticClass: "copy-week-picker-school-year-selector",
	    domProps: {
	      "value": _vm.activeSchoolYear.id
	    },
	    on: {
	      "change": _vm.setActiveSchoolYear
	    }
	  }, _vm._l((_vm.activeSchoolYears), function(year) {
	    return _c('option', {
	      key: year.id,
	      domProps: {
	        "value": year.id
	      }
	    }, [_vm._v("\n          " + _vm._s(year.name) + "\n        ")])
	  }), 0) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "sortcuts__headline"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + "\n            "), _c('div', {
	    staticClass: "no-tag",
	    class: {
	      'tag': !_vm.showStartPasteWeek
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm._f("week")(_vm.startPasteWeek)) + "\n              "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showStartPasteWeek),
	      expression: "!showStartPasteWeek"
	    }],
	    staticClass: "icon-cross2 pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.eraseStartDate.apply(null, arguments)
	      }
	    }
	  })])])]), _c('li', [_c('span', {
	    staticClass: "sortcut__clickable",
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n                ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sortcut__clickable",
	    on: {
	      "click": _vm.selectOddWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sortcut__clickable",
	    on: {
	      "click": _vm.selectEvenWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sortcut__clickable",
	    on: {
	      "click": _vm.removeAllSelectedWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn btn-trans width-100 btn-remove"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n               ")])])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-app__cal__nav"
	  }, [_c('div', {
	    staticClass: "d-app__cal__nav__btn",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('prev')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M15.75 19.5L8.25 12l7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-app__cal__nav__btn d-app__cal__nav__btn__center",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('today')
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('repitition.today')) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-app__cal__nav__btn",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('next')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M8.25 4.5l7.5 7.5-7.5 7.5"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.work_hours')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.tooltipContent
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedTotalHoursForPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_total_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.diffTotalHoursForPeriod))
	  }, [_vm._v("\n      " + _vm._s(_vm.diffTotalHoursForPeriod) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Med børn")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.createTooltip(_vm.assignedHoursWithKids)
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedHoursWithKidsInPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.userActualWithKids))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.diffHoursWithKidsForPeriod))
	  }, [_vm._v(_vm._s(_vm.diffHoursWithKidsForPeriod))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Uden børn")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.createTooltip(_vm.assignedHoursWithoutKids)
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedHoursWithoutKidsInPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.userActualWithoutKids))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.diffHoursWithoutKidsForPeriod))
	  }, [_vm._v(_vm._s(_vm.diffHoursWithoutKidsForPeriod))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Med børn + Uden børn")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.tooltipContent
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedTotalHoursForPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.userWithKidsAndWithout))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.userDiffWithKidsAndWithout))
	  }, [_vm._v("\n      " + _vm._s(_vm.userDiffWithKidsAndWithout) + "\n    ")]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', [_c('h4', [_vm._v("Oversigt")])])
	}]}

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__header__right"
	  }, [_c('button', {
	    staticClass: "do-bttn no-print",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle no-print",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content",
	    attrs: {
	      "id": "printUserSalaryTable"
	    }
	  }, [_c('h4', {
	    staticClass: "only-print"
	  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
	    staticClass: "salarySubsPerfUserTable"
	  }, _vm._l((_vm.tables), function(table) {
	    return _c('div', {
	      key: table.employmentId
	    }, [_c('button', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: _vm.hideTippy,
	          trigger: 'manual',
	          arrow: true,
	          placement: 'top',
	          zIndex: 2147483010
	        }),
	        expression: "{\n                                  onShow: hideTippy,\n                                  trigger: 'manual',\n                                  arrow: true,\n                                  placement : 'top',\n                                  zIndex: 2147483010\n                                }"
	      }],
	      staticClass: "do-bttn do-copy-bttn no-print marg-1-bottom width-100",
	      attrs: {
	        "content": 'Kopieret tabel for ' + table.title
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyTableDayCounts(table, $event)
	        }
	      }
	    }, [_vm._v("\n            Kopier tabel for " + _vm._s(table.title) + "\n          ")]), _vm._v(" "), _c('table', {
	      staticClass: "d-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(table.title))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(table.minutes))])])]), _vm._v(" "), _c('tbody', _vm._l((table.dates), function(date, index) {
	      return _c('tr', {
	        key: index
	      }, [_c('td', [_vm._v(_vm._s(date.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.dayCount))])])
	    }), 0)])])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "task-overview-settings__tasks"
	  }, [(_vm.isInitLoad) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : [_c('div', {
	    staticClass: "do-table__filters"
	  }, [_c('div', {
	    staticClass: "do-table__filters__left"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": "Personer",
	      "tags": _vm.persons,
	      "selectedTags": _vm.selectedPersons,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.onSelectPerson,
	      "clear": function($event) {
	        _vm.selectedPersons = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Grupper",
	      "tags": _vm.tags,
	      "selectedTags": _vm.selectedTags,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.onSelectTags,
	      "clear": function($event) {
	        _vm.selectedTags = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Briktyper",
	      "tags": _vm.subjectTypes,
	      "selectedTags": _vm.selectedTypes,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.onSelectType,
	      "clear": function($event) {
	        _vm.selectedTypes = []
	      }
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": "Fag/Opgaver",
	      "tags": _vm.subjectNames,
	      "selectedTags": _vm.selectedSubjectsNames,
	      "numberOfSelectedTagsToShow": 1
	    },
	    on: {
	      "select": _vm.onSelectSubject,
	      "clear": function($event) {
	        _vm.selectedSubjectsNames = []
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-table__filters__add"
	  }, [_c('span', [_vm._v("Viser " + _vm._s(_vm.filteredSubjects.length) + " af " + _vm._s(_vm.subjects.length))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickAway),
	      expression: "onClickAway"
	    }],
	    staticClass: "do-dropdown",
	    class: {
	      'do-dropdown--open': _vm.isDropdown
	    }
	  }, [(_vm.selectedSubjects.length < 1) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'left',
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n                  placement: 'left',\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n              }"
	    }],
	    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit do-bttn--submit--disabled",
	    attrs: {
	      "content": "Vælg brikker først"
	    }
	  }, [_vm._v("\n            Tildel kategori til " + _vm._s(_vm.selectedSubjects.length) + " "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]) : _c('button', {
	    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.setIsDropdown
	    }
	  }, [_vm._v("\n            Tildel kategori til " + _vm._s(_vm.selectedSubjects.length) + " "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "do-dropdown"
	    }
	  }, [(_vm.isDropdown) ? _c('div', {
	    staticClass: "do-dropdown__dropdown"
	  }, [_c('ul', [(_vm.taskCategories.length === 0) ? _c('li', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen kategorier oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.taskCategories), function(taskCategory, key) {
	    return _c('li', {
	      staticClass: "do-dropdown__dropdown__item",
	      on: {
	        "click": function($event) {
	          return _vm.setTasksCategory(taskCategory)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "do-dropdown__dropdown__item__name"
	    }, [_vm._v("\n                    " + _vm._s(taskCategory.name) + "\n                  ")])])
	  })], 2)]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "do-table-wrapper"
	  }, [_c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "do-table__toggle-all",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedSubjects.length === 0) ? [_vm._v("\n              " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n            ")] : [_vm._v("\n              Fravælg\n            ")]], 2), _vm._v(" "), _c('th', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('subject.name')
	      }
	    }
	  }, [_vm._v("Titel "), (_vm.sortKey === 'subject.name') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), _c('th', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('calendar.name')
	      }
	    }
	  }, [_vm._v("Person "), (_vm.sortKey === 'calendar.name') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), _c('th', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('subject.calendar.name')
	      }
	    }
	  }, [_vm._v("Klasse / kalender "), (_vm.sortKey === 'subject.calendar.name') ? _c('span', {
	    staticClass: "pointer"
	  }, [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), _c('th', {
	    staticClass: "pointer",
	    on: {
	      "click": function($event) {
	        return _vm.sortBy('v_type')
	      }
	    }
	  }, [_vm._v("Type "), (_vm.sortKey === 'v_type') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), _c('th', [_vm._v("Standard kategori")]), _vm._v(" "), _c('th', [_vm._v("Egen kategori")])])]), _vm._v(" "), _c('tbody', [_c('virtual-list', {
	    style: ({
	      maxHeight: 80 + 'vh',
	      overflowY: 'auto'
	    }),
	    attrs: {
	      "estimate-size": 40,
	      "keeps": 40,
	      "data-key": 'id',
	      "data-sources": _vm.sortedSubjects,
	      "data-component": _vm.itemComponent,
	      "extra-props": {
	        selectedSubjectIds: _vm.selectedSubjectIds,
	        selectedSubjects: _vm.selectedSubjects,
	        taskCategories: _vm.taskCategories,
	        toggleSubject: _vm.toggleSubject,
	        updateSubjectTaskCategory: _vm.updateSubjectTaskCategory
	      }
	    }
	  })], 1)])])]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "now-marker",
	    style: ({
	      top: _vm.top + 'px'
	    })
	  })
	},staticRenderFns: []}

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data"
	  }, [_c('div', {
	    staticClass: "school-data__header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "school-data__header__right"
	  }, [_c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.readEvents
	    }
	  }, [_vm._v("Søg")])], 1)]), _vm._v(" "), (!_vm.isReadEventsClick) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Vælg datoer og klik \"Søg\"")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Henter lektioner fra en længere periode - det kan tage et par minutter")])], 1) : _vm._e(), _vm._v(" "), (_vm.isReadEventsClick && !_vm.isLoading) ? [(_vm.subEventsWithAbsenceType.length < 1) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Der er ingen vikartimer i perioden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedAbsenceTypesWithLessons), function(absenceType, prop) {
	    return _c('table', {
	      staticClass: "d-acc-body-table",
	      class: {
	        'd-acc-body-table--open': absenceType['isOpen']
	      }
	    }, [_c('thead', {
	      staticClass: "d-acc-body-table__first__header",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveAcc(prop, absenceType)
	        }
	      }
	    }, [_c('tr', [_c('th', {
	      attrs: {
	        "colspan": "3"
	      }
	    }, [_vm._v(_vm._s(prop) + ": " + _vm._s(absenceType['formattedDuration']))])])]), _vm._v(" "), (_vm.theActiveAcc === prop) ? _c('thead', {
	      staticClass: "d-acc-body-table__second__header"
	    }, [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), (_vm.theActiveAcc === prop) ? _c('tbody', _vm._l((absenceType['lessons']), function(lesson) {
	      return _c('tr', {
	        key: lesson.id
	      }, [_c('td', [_vm._v(_vm._s(lesson.vTimestamp) + ", " + _vm._s(lesson.title) + ", " + _vm._s(lesson.vKlasses))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lesson.substitute))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lesson.substituteFor))])])
	    }), 0) : _vm._e()])
	  })] : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data__header__left"
	  }, [_c('h1', [_vm._v("Vikartimer ift. Fraværstyper")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Vikar")]), _vm._v(" "), _c('th', [_vm._v("Vikar for")])])
	}]}

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-full-cal-event-panel"
	  }, [_c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.eventId) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "isInitEventLoading": !_vm.event || _vm.isEventsLoading,
	      "event": _vm.event,
	      "initCalendarId": _vm.calendarId
	    },
	    on: {
	      "submitDeleteEventOnward": _vm.onEventUpdated,
	      "close": _vm.onClose,
	      "updated": _vm.onEventUpdated
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-wrapper",
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "bg-overlay fadeIn animated",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal fadeInUp animated"
	  }, [_c('div', {
	    staticClass: "modal__close icon__bg-circle",
	    style: ({
	      'color': _vm.closeCrossColor
	    }),
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _vm._t("body", function() {
	    return [_c('h1', [_vm._v("Vil du slette?")])]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('AppModal', {
	    attrs: {
	      "show": _vm.openFromOtherComponent
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_vm._v(">\n  "), _c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.delete_calendar')))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "marg-10-bottom"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.deleting_this_calendar')) + ":")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.calName))])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-bottom"
	  }, [_c('h3', {
	    staticClass: "warning-text bold"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.editCalendarDelete.all_data_will_be_deleted')) + "\n        ")])]), _vm._v(" "), _c('p', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.write')) + " \"" + _vm._s(_vm.$t('vue2.editCalendarDelete.validator_name')) + "\" -\n        " + _vm._s(_vm.$t('vue2.editCalendarDelete.if_you_want_to_delete')) + ":")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.validatorText),
	      expression: "validatorText"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.validatorText)
	    },
	    on: {
	      "keyup": _vm.validateInput,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.validatorText = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end align-center pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(!_vm.validateInput()) ? _c('p', {
	    staticClass: "warning-text marg-10-right"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarDelete.you_have_to_write')) + " \"" + _vm._s(_vm.$t('vue2.editCalendarDelete.validator_name')) + "\"\n    ")]) : _vm._e(), _vm._v(" "), (_vm.validateInput()) ? _c('button', {
	    staticClass: "submit-btn bttn--warning",
	    on: {
	      "click": _vm.submitDelete
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarDelete.delete_calendar')) + "\n    ")]) : _c('button', {
	    staticClass: "submit-btn--disabled"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarDelete.delete_calendar')) + "\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flipper-buttons"
	  }, [_c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': _vm.isActiveTab(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTab(1)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-year-planning"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.sub_scheduler.schedules_overview')) + "\n  ")]), _vm._v(" "), _c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': _vm.isActiveTab(0)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTab(0)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-file-text"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.sub_scheduler.list')) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-profile__form"
	  }, [(!_vm.isEditable && _vm.canEdit) ? _c('div', {
	    staticClass: "d-profile__form__edit",
	    on: {
	      "click": function($event) {
	        _vm.isEditable = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))]) : _vm._e(), _vm._v(" "), (!_vm.isEditable) ? _c('div', {
	    staticClass: "d-input-group__un-edit"
	  }, [_c('h3', [_vm._v("CPR nummer")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ssnHidden))])]) : [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', [_vm._v("CPR nummer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.ssn),
	      expression: "ssn",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    class: {
	      'input--error': _vm.formErrors['ssn']
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.ssn)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('ssn')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ssn = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['ssn']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("\n        " + _vm._s(_vm.formErrors['ssn']) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-profile__form__submit"
	  }, [_c('button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    class: [{
	        'bttn--loading': _vm.isSaving
	      },
	      {
	        'submit-button--disabled': _vm.isSaveButtonDisabled
	      }
	    ],
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal",
	    class: {
	      'd-timetal--read-only': _vm.isReadOnly
	    }
	  }, [_c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('h4', {
	    staticClass: "uppercase"
	  }, [_vm._v("Undervisning i specialklasser")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.grades), function(grade) {
	    return _c('th', {
	      key: grade.value
	    }, [_vm._v(_vm._s(grade.title))])
	  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fagMedVProps), function(fag) {
	    return (!_vm.isReadOnly) ? _c('tr', {
	      key: fag.fagkode
	    }, [_c('td', [_vm._v(_vm._s(fag.title))]), _vm._v(" "), _vm._l((fag.klasser), function(klasse) {
	      return _c('td', {
	        class: [{
	          'td-is-obligatorisk': klasse.v_obligatorisk
	        }, {
	          'td-is-checkbox': klasse.hasOwnProperty('checkbox')
	        }]
	      }, [(klasse.hasOwnProperty('num')) ? _c('input', {
	        staticClass: "d-input",
	        attrs: {
	          "type": "number"
	        },
	        domProps: {
	          "value": klasse.num
	        },
	        on: {
	          "blur": function($event) {
	            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
	          }
	        }
	      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'konfirmation') ? _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': fag.v_fag.klassetrin * 1 === klasse.value * 1
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setKonfirmation(fag.v_fag, klasse.value)
	          }
	        }
	      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'praktik') ? _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': fag.praktikkode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setPraktik(fag)
	          }
	        }
	      }) : _vm._e()])
	    })], 2) : _vm._e()
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Obligatorisk fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.obligatoriskFagopdelt), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized d-explainer"
	  }, [_c('td', [_vm._v("Minimumstimetal")]), _vm._v(" "), _vm._l((_vm.minimumFagopdelt), function(num, key) {
	    return _c('td', [_vm._v("(" + _vm._s(num) + ")")])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Øvrig fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.ovrigFagopdelt), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _vm._l((_vm.uuv), function(uuvfag) {
	    return (!_vm.isReadOnly) ? _c('tr', [_c('td', [_vm._v(_vm._s(uuvfag.title))]), _vm._v(" "), _vm._l((uuvfag.klasser), function(klasse) {
	      return _c('td', [(klasse.hasOwnProperty('num')) ? _c('input', {
	        staticClass: "d-input",
	        attrs: {
	          "type": "number"
	        },
	        domProps: {
	          "value": klasse.num
	        },
	        on: {
	          "blur": function($event) {
	            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
	          }
	        }
	      }) : _vm._e()])
	    })], 2) : _vm._e()
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Skoleårets samlede længde\n          (= Obligatorisk fagopdelt undervisning\n          + øvrige fag + Understøttende undervisning)\n        ")]), _vm._v(" "), _vm._l((_vm.sammentaelling), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized d-explainer"
	  }, [_c('td', [_vm._v("Mindstekrav til skoleårets samlede længde")]), _vm._v(" "), _vm._l((_vm.totalMinimum), function(num, key) {
	    return _c('td', [(num > 0) ? _c('span', [_vm._v("(" + _vm._s(num) + ")")]) : _vm._e()])
	  })], 2), _vm._v(" "), _vm._l((_vm.tolaererArr), function(tolaerer) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(tolaerer.title))]), _vm._v(" "), _vm._l((tolaerer.klasser), function(klasse) {
	      return _c('td', {
	        staticClass: "td-is-checkbox"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setTolaerer(klasse)
	          }
	        }
	      })])
	    })], 2)
	  }), _vm._v(" "), _vm._l((_vm.foranstaltningerMedProps), function(foranstaltning) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(foranstaltning.title))]), _vm._v(" "), _vm._l((foranstaltning.klasser), function(klasse) {
	      return _c('td', {
	        staticClass: "td-is-checkbox"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setForanstaltning(klasse)
	          }
	        }
	      })])
	    })], 2)
	  })], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "position": "fixed",
	      "z-index": "100000",
	      "display": "none"
	    }
	  }, [_c('div', {
	    staticClass: "arrow_box no-print animated infinite onboarding_animate"
	  })])
	}]}

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog"
	  }, [_c('div', {
	    staticClass: "dialog-header",
	    style: ({
	      backgroundColor: _vm.event.color
	    })
	  }, [_c('div', {
	    staticClass: "header-top"
	  }, [_c('v-touch', {
	    staticClass: "no-desktop",
	    on: {
	      "tap": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "font-large close-tap"
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large no-mobile close-tap",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer"
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "header-body"
	  }, [_c('div', {
	    staticClass: "d-show-event__header__do-warning__container"
	  }, [(_vm.event && _vm.event.canceled) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning do-warning--canceled"
	  }, [_c('span', {
	    staticClass: "icon-notification22"
	  }), _vm._v("\n          " + _vm._s(_vm.i18n.canceled) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.event && _vm.event.away) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n.out_of_school))]) : _vm._e()]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.event.index))]), _vm._v(" "), _c('section', {
	    staticClass: "dialog-body"
	  }, [_c('div', {
	    staticClass: "dialog-icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.event.title))])])]), _vm._v(" "), _c('section', {
	    staticClass: "dialog-body"
	  }, [_c('div', {
	    staticClass: "dialog-icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('p', [_vm._v(_vm._s(_vm.dayAndDate))])])]), _vm._v(" "), _c('section', {
	    staticClass: "dialog-body"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('b', [_vm._v(_vm._s(_vm._f("LT")(_vm.event.start)) + " - " + _vm._s(_vm._f("LT")(_vm.event.end)))]), _vm._v(" "), _c('span', [_vm._v("(\n            "), (_vm.eventHours >= 1) ? _c('span', [_vm._v(_vm._s(_vm.eventHours) + " " + _vm._s(_vm.eventHours > 1 ? _vm.$t('calendars.subject_hours.timer') : _vm.$t('repitition.hour')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.eventMinutes >= 1) ? _c('span', [_vm._v(_vm._s(_vm.eventMinutes + ' min'))]) : _vm._e(), _vm._v("\n          )")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog__dialog-body"
	  }, [_c('ul', [(_vm.event.group) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('b', [_vm._v(_vm._s(_vm.event.group))])])]) : _vm._e(), _vm._v(" "), (_vm.event.teacher) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('b', [_vm._v(_vm._s(_vm.event.teacher))])])]) : _vm._e(), _vm._v(" "), (_vm.event.room) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text"
	  }, [_c('b', [_vm._v(_vm._s(_vm.event.room))])])]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.learning_goal)) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_c('div', {
	    staticClass: "dialog-text marg-10-bottom"
	  }, [_c('b', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan.learning_goal')))])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.learning_goal)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.description)) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_c('div', {
	    staticClass: "dialog-text marg-10-bottom"
	  }, [_c('b', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan.content')) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.description)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.notes_for_students)) ? _c('li', {
	    staticClass: "pad-15-0 border-bottom"
	  }, [_c('div', {
	    staticClass: "dialog-text marg-10-bottom"
	  }, [_c('b', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan.pupil_preparation')))])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.notes_for_students)
	    }
	  })]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon"
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon",
	    staticStyle: {
	      "margin-top": "-1px"
	    }
	  }, [_c('span', {
	    staticClass: "icon-calendar4"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon"
	  }, [_c('span', {
	    staticClass: "icon-user"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon"
	  }, [_c('span', {
	    staticClass: "icon-location"
	  })])
	}]}

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('d-select', {
	    attrs: {
	      "items": _vm.usersForList,
	      "itemsSelected": _vm.selectedUsers,
	      "eventId": _vm.eventId,
	      "allDataLoaded": _vm.allDataLoaded,
	      "show": _vm.show,
	      "addClass": _vm.addClass
	    },
	    on: {
	      "remove": _vm.removeUser,
	      "add": _vm.addUser,
	      "addIsOnLesson": _vm.addedIsOnLesson,
	      "update": _vm.setSelectedUsers,
	      "show": _vm.getUsers
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.subFromIsOnLesson !== null) ? _c('div', {
	    staticClass: "subModal__bg"
	  }, [_c('div', {
	    staticClass: "subModal"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['would_you_like_to_set']) + " " + _vm._s(_vm.subFromIsOnLesson.name) + " " + _vm._s(_vm.i18n['as_a_substitute_instead_of_teacher']) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "subModal__buttons"
	  }, [_c('button', {
	    on: {
	      "click": _vm.setSubFromIsOnLesson
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['yes']))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn-simple bttn",
	    on: {
	      "click": function($event) {
	        _vm.subFromIsOnLesson = null
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['no']))])])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-team-calendar__header"
	  }, [_c('div', {
	    staticClass: "d-team-calendar__header__header"
	  }, [_c('div', {
	    staticClass: "d-team-calendar__header__header__left team-d-tabs"
	  }, [_c('div', {
	    staticClass: "team-d-tabs__tab",
	    class: {
	      'team-d-tabs__tab--active': _vm.theTab === 1
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTab(1)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['custom']) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "team-d-tabs__tab",
	    class: {
	      'team-d-tabs__tab--active': _vm.theTab === 2
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTab(2)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['shortcuts']) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-team-calendar__header__header__right"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    class: [{
	      inactive: _vm.isToday
	    }, 'no-print'],
	    on: {
	      "click": _vm.today
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('repitition.today')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "icon-arrow-left4 no-print marg-5-right",
	    on: {
	      "click": _vm.prev
	    }
	  }), _vm._v(" "), _c('DatePicker', {
	    attrs: {
	      "popperPlacement": "bottom-end",
	      "date": _vm.date
	    },
	    on: {
	      "changed": _vm.setDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "icon-arrow-right4 no-print marg-5-left",
	    on: {
	      "click": _vm.next
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theTab === 1),
	      expression: "theTab === 1"
	    }],
	    staticClass: "team-d-tabs__tab__content"
	  }, [_c('dSelectAll', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "show-tags": true,
	      "showCreateButton": false,
	      "itemsSelected": _vm.itemsSelected
	    },
	    on: {
	      "add": function($event) {
	        return _vm.dSelectUsersUpdated('add')
	      },
	      "remove": function($event) {
	        return _vm.dSelectUsersUpdated('remove')
	      },
	      "update": function($event) {
	        return _vm.dSelectUsersUpdated('update', $event)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "cal-container__header"
	  }, [_c('div', {
	    staticClass: "cal-container__header--left"
	  }, [_c('div', {
	    staticClass: "d-cal-views"
	  }, [_c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('resourceTimeGridDay')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('resourceTimeGridDay')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_day']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('resourceTimeGridFiveDay')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('resourceTimeGridFiveDay')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_week']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('listView')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('listView')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_list']) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('schedulerView')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('schedulerView')
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['show_scheduler']) + "\n          ")])]), _vm._v(" "), (_vm.calview !== 'schedulerView') ? _c('DDropdown', {
	    attrs: {
	      "isShowDots": false
	    }
	  }, [_c('button', {
	    staticClass: "d-teamcalendar__saved-views__scroll bttn-simple",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n            " + _vm._s(_vm.theSelectedScrollOption) + "\n            "), _c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24",
	      "fill": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
	      "clip-rule": "evenodd"
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.scrollOptions), function(view) {
	    return _c('li', {
	      staticClass: "d-teamcalendar__saved-views__view",
	      on: {
	        "click": function($event) {
	          return _vm.setSelectedScrollOption(view)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(view.title) + "\n            ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.calview == 'resourceTimeGridDay' || _vm.calview == 'resourceTimeGridFiveDay') ? _c('button', {
	    staticClass: "marg-5-left",
	    on: {
	      "click": _vm.setIsShowSettings
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })]) : _vm._e(), _vm._v(" "), (_vm.calview !== 'schedulerView') ? _c('button', {
	    staticClass: "marg-5-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "bttn-with-svg",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('updateEvents')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
	    }
	  })])])], 1), _vm._v(" "), (_vm.isShowSettings) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.standard_setting')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-input marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.set_default_start_and_endtime')))]), _vm._v(" "), _c('TimeChanger', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "showIcon": true,
	      "start": _vm.standardStartTime,
	      "end": _vm.standardEndTime
	    },
	    on: {
	      "updateStart": _vm.setStandardStartTime,
	      "updateEnd": _vm.setStandardEndTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group d-input-group__is-toggle"
	  }, [_c('div', {
	    staticClass: "d-input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setCustomNumberOfDays(!_vm.isSetCustomNumberOfDays)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-input"
	  }, [_vm._v("Set custom number of days")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isSetCustomNumberOfDays
	    }
	  })], 1), _vm._v(" "), (_vm.isSetCustomNumberOfDays) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.numberOfDays),
	      expression: "numberOfDays"
	    }],
	    ref: "input_custom_number_of_days",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.numberOfDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.numberOfDays = $event.target.value
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), (!_vm.isSetCustomNumberOfDays) ? _c('div', {
	    staticClass: "d-input-group d-input-group__is-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsShowWeekends(!_vm.isShowWeekends)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-input-group__toggle"
	  }, [_c('label', {
	    staticClass: "d-input"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_weekends')))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.isShowWeekends,
	      "allowChanges": false
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-1-right",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.submitStandardSettings
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])])])]) : _vm._e(), _vm._v(" "), _c('TeamCalendarHeaderSaveView', {
	    attrs: {
	      "itemsSelected": _vm.itemsSelected
	    },
	    on: {
	      "setSavedView": _vm.setSavedView
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theTab === 2),
	      expression: "theTab === 2"
	    }],
	    staticClass: "team-d-tabs__tab__content team-d-tabs__tab__content__header"
	  }, [_c('div', {
	    staticClass: "d-cal-views"
	  }, [_c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('scheduler__all_cals')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('scheduler__all_cals')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['all_calendars']) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('scheduler__all_users')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('scheduler__all_users')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['all_users']) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('scheduler')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('scheduler')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['room_overview']) + "\n      ")]), _vm._v(" "), (_vm.userHasPermission('can_do_most_stuff')) ? [_c('div', {
	    staticClass: "d-cal-views__view",
	    class: {
	      'd-cal-views__view--active': _vm.getIsView('doubleBookings')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setView('doubleBookings')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['show_double_bookings']) + "\n        ")])] : _vm._e()], 2), _vm._v(" "), (_vm.calview !== 'doubleBookings') ? [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sort_by']))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theSortOptionForAllSchedules),
	      expression: "theSortOptionForAllSchedules"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theSortOptionForAllSchedules = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.setChangedSortOption(_vm.theSortOptionForAllSchedules)
	      }]
	    }
	  }, _vm._l((_vm.sortOptionsForAllSchedules), function(option) {
	    return _c('option', {
	      domProps: {
	        "value": option.value
	      }
	    }, [_vm._v(_vm._s(option.title))])
	  }), 0)] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "items-list"
	  }, [_c('ul', {
	    staticClass: "items"
	  }, [(!_vm.isEditPeriod) ? _c('li', {
	    staticClass: "items__item"
	  }, [(_vm.isKindergarten || _vm.isBruttoTid) ? _c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Periode")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_vm._v("\n          " + _vm._s(_vm.dateRangeFormatted) + "\n          "), _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": "Redigér periode"
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isEditPeriod = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-wrench"
	  })])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isEditPeriod) ? [_c('div', {
	    staticClass: "calc-method"
	  }, [_c('h3', [_vm._v("Vælg beregningsmetode")]), _vm._v(" "), _c('p', [_vm._v("Planlægges der for et helt skoleår/arbejdsår udgør arbejdstiden 1924 timer. Planlægges der for en del af et\n          skoleår/arbejdsår kan I selv vælge, hvilke af flg. metoder arbejdstiden skal beregnes ud fra.")]), _vm._v(" "), _c('ul', {
	    staticClass: "d-radio-group"
	  }, _vm._l((_vm.waysToCalculate), function(way) {
	    return _c('li', {
	      key: way.value,
	      staticClass: "d-radio-group__radio",
	      class: {
	        'd-radio-group__radio--selected': _vm.theSelectedWayToCalculate === way.value
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheSelectedWayToCalculate(way.value)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.theSelectedWayToCalculate),
	        expression: "theSelectedWayToCalculate"
	      }],
	      attrs: {
	        "type": "radio",
	        "id": 'subject_subject_type_' + way.value
	      },
	      domProps: {
	        "value": way.value,
	        "checked": _vm._q(_vm.theSelectedWayToCalculate, way.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.theSelectedWayToCalculate = way.value
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "calc-method__label",
	      attrs: {
	        "for": 'subject_subject_type_' + way.value
	      },
	      domProps: {
	        "innerHTML": _vm._s(way.title)
	      }
	    })])
	  }), 0), _vm._v(" "), _c('p', [_vm._v("I nedenstående udregnes automatisk søgnehelligdage i perioden. Men du skal selv indtaste om den ansatte har\n          ferie, der ikke er brugt – altså både gammel ferie og ny optjent ferie")])]), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content",
	    class: {
	      'items__item__content--error': _vm.isErrorInStartDate
	    }
	  }, [_c('p', [_vm._v("Startdato")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('DateSelector', {
	    attrs: {
	      "date": _vm.startDate,
	      "isOnlyShowFirstAndLastDateEachMonth": _vm.theSelectedWayToCalculate === 'month'
	    },
	    on: {
	      "changed": _vm.setStartDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isErrorInStartDate) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("Skal være den første eller sidste dag i måneden")]) : _vm._e()]), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content",
	    class: {
	      'items__item__content--error': _vm.isErrorInEndDate
	    }
	  }, [_c('p', [_vm._v("Slutdato")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('DateSelector', {
	    attrs: {
	      "isOnlyShowFirstAndLastDateEachMonth": _vm.theSelectedWayToCalculate === 'month',
	      "date": _vm.endDate
	    },
	    on: {
	      "changed": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isErrorInEndDate) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("Skal være den første eller sidste dag i måneden")]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Timeansættelse pr. uge")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hoursPerWeek.hours),
	      expression: "hoursPerWeek.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hoursPerWeek.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.hoursPerWeekChanged($event.target.value, true)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.hoursPerWeek, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), (_vm.isBruttoTid) ? _c('li', {
	    staticClass: "items__item"
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v("Beskæftigelsesgrad")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("%")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.employmentPercentage.hours),
	      expression: "employmentPercentage.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.employmentPercentage.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.employmentPercentageChanged($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.employmentPercentage, "hours", $event.target.value)
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "items__item",
	    class: {
	      'items__item--fixed': _vm.workingHours.isFixed
	    }
	  }, [_c('div', {
	    staticClass: "items__item__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.workingHours.title))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__input"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.workingHours.hours),
	      expression: "workingHours.hours"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.workingHours.hours)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditWorkingHours($event.target.value)
	      },
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.workingHours, "hours", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('ul', _vm._l((_vm.subtractedItems), function(subtractItem, idx) {
	    return _c('li', {
	      key: subtractItem.id,
	      staticClass: "subtract-item items__item",
	      class: {
	        'subtract-item--fixed': subtractItem.isFixed
	      }
	    }, [_c('div', {
	      staticClass: "subtract-item__title"
	    }, [_c('div', {
	      staticClass: "d-input-group__input__close icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.deleteItem(subtractItem)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })]), _vm._v("\n          " + _vm._s(subtractItem.title) + "\n        ")]), _vm._v(" "), _c('div', {
	      staticClass: "input-group__input"
	    }, [_c('span', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s(subtractItem.unit ? subtractItem.unit : 'timer'))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (subtractItem.hours),
	        expression: "subtractItem.hours"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (subtractItem.hours)
	      },
	      on: {
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "change": function($event) {
	          return _vm.setSubtractedItemValue(subtractItem, $event.target.value)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(subtractItem, "hours", $event.target.value)
	        }
	      }
	    })])])
	  }), 0)], 2), _vm._v(" "), _c('ul', {
	    staticClass: "items",
	    attrs: {
	      "id": "items__list"
	    }
	  }, [(_vm.isAddNew) ? _c('li', {
	    staticClass: "items__item items__item__add__new"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newItemTitle),
	      expression: "newItemTitle"
	    }],
	    ref: "add_new_input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Eks. Aldersreduktion"
	    },
	    domProps: {
	      "value": (_vm.newItemTitle)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.addOwn.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newItemTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "items__item__add__new__buttons"
	  }, [_c('button', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.reset
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": _vm.addOwn
	    }
	  }, [_vm._v("Gem")])])]) : _vm._e()]), _vm._v(" "), _c('DDropdown', {
	    staticClass: "add-more__dropdown",
	    attrs: {
	      "isShowDots": false
	    }
	  }, [(!_vm.isAddNew) ? _c('p', {
	    staticClass: "items__item__add",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("+ Tilføj reduktion")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('label', {
	    staticClass: "d-label d-label__headline"
	  }, [_vm._v("Vælg fra standard")]), _vm._v(" "), _vm._l((_vm.possibleStandardItems), function(possibleItem, idx) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.addFromStandard(possibleItem)
	        }
	      }
	    }, [_vm._v(_vm._s(possibleItem.title) + "\n      ")])
	  }), _vm._v(" "), _c('li', {
	    staticClass: "items__item__add",
	    staticStyle: {
	      "border-top": "1px solid #ddd",
	      "margin-top": "0.5rem"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsAddNew(true)
	      }
	    }
	  }, [_vm._v("+\n        Opret egen\n      ")])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "item__total"
	  }, [_c('p', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.nettoTime) + " timer")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-agreements"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale].notes_for) + " " + _vm._s(_vm.activeSchoolYear.name))]), _vm._v(" "), (_vm.userCanEditAgreementNote) ? _c('div', [_c('AppEIPWYZIWYG', {
	    attrs: {
	      "textInput": _vm.agreements
	    },
	    on: {
	      "close": _vm.updateAgreements
	    }
	  })], 1) : _c('div', {
	    staticClass: "user-agreements__notes"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.agreements)
	    }
	  }), _vm._v(" "), (_vm.agreements.length < 1) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen noter")]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.sortedVersions.length > 0) ? _c('div', {
	    staticClass: "task-overview"
	  }, [_c('div', {
	    staticClass: "to-versions"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false
	    }
	  }, [_c('div', {
	    staticClass: "d-drop-box",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.versions')) + " "), _c('span', {
	    staticClass: "icon-arrow-down52"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.sortedVersions), function(version) {
	    return _c('li', {
	      key: version.id,
	      on: {
	        "click": function($event) {
	          return _vm.selectVersion(version)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(version.vTitle) + "\n        ")])
	  }), 0)])], 1), _vm._v(" "), (_vm.activeVersion) ? _c('DModal', {
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeVersion = null
	      }
	    }
	  }, [_c('div', {
	    staticClass: "to-versions__modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "to-versions__modal__header"
	  }, [_c('div', {
	    staticClass: "to-versions__modal__header__left pad-1-left"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activeVersionId),
	      expression: "activeVersionId"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.activeVersionId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.selectVersionFromId(_vm.activeVersionId)
	      }]
	    }
	  }, _vm._l((_vm.sortedVersions), function(version) {
	    return _c('option', {
	      key: version.id,
	      domProps: {
	        "value": version.id
	      }
	    }, [_vm._v("\n            " + _vm._s(version.vTitle) + "\n          ")])
	  }), 0), _vm._v(" "), _c('span', {
	    staticClass: "pad-1-left"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_versions.saved_message')) + ": " + _vm._s(_vm.versionDateFormatted) + "\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "to-versions__modal__header__right"
	  }, [(_vm.isUserSchoolAdmin) ? _c('DDropdown', {
	    attrs: {
	      "isBottomStart": false
	    }
	  }, [_c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": _vm.setWarningToDelete
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.task_versions.delete_message')) + "\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.activeVersion = null
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "to-versions__modal__body"
	  }, [_c('TaskOverviewUser', {
	    attrs: {
	      "user": _vm.user,
	      "version": _vm.activeVersion
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isDeleteWarningActive) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "999999999"
	    },
	    attrs: {
	      "appendToBody": true,
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-warning text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-warning__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.are_you_sure_you_want_to_delete')) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": function($event) {
	        _vm.isDeleteWarningActive = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__body"
	  }, [_c('svg', {
	    staticClass: "tw-icon tw-icon--red",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "2",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "9",
	      "x2": "12",
	      "y2": "13"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "17",
	      "x2": "12.01",
	      "y2": "17"
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.confirm_delete_message')) + " " + _vm._s(_vm.activeVersion.vTitle) + "?")]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.task_versions.delete_warning_message')) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isDeleteWarningActive = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--warning bttn-danger bttn-primary--small",
	    class: [{
	      'bttn--loading': _vm.isSaving
	    }],
	    on: {
	      "click": _vm.deleteVersion
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.delete')) + "\n      ")])])])]) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-events text-dark"
	  }, [(_vm.type === 'swap') ? [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.swap_headline')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.swap_desc')))]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.events.length < 1) ? _c('p', {
	    staticClass: "text-explainer marg-2-top"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.edit_event.swap_no_lessons')))]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('ul', _vm._l((_vm.eventsVProps), function(event) {
	    return _c('li', {
	      key: event.id,
	      staticClass: "d-event",
	      style: ({
	        'backgroundColor': event.color
	      })
	    }, [_c('div', {
	      staticClass: "d-event__content"
	    }, [_c('b', [_vm._v(_vm._s(event.vTitle) + ",")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(event.vDateAndTime))])]), _vm._v(" "), _c('button', {
	      staticClass: "bttn",
	      class: {
	        'bttn--loading': _vm.isSubmittingEventId === event.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.eventSwap(event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.edit_event.select')))])])
	  }), 0) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.type === 'replace') ? [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.replace_headline')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.edit_event.replace_desc')))]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.subjects.length < 1) ? _c('p', {
	    staticClass: "text-explainer marg-2-top"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.edit_event.replace_no_lessons')))]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('ul', _vm._l((_vm.subjectsVProps), function(subject) {
	    return _c('li', {
	      key: subject.id,
	      staticClass: "d-subject",
	      style: ({
	        'backgroundColor': subject.color
	      })
	    }, [_c('div', [_vm._v(_vm._s(subject.vTitle))]), _vm._v(" "), _c('button', {
	      staticClass: "bttn",
	      class: {
	        'bttn--loading': _vm.isSubmittingSubjectId === subject.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.replaceEvent(subject)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.edit_event.select')))])])
	  }), 0) : _vm._e()] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal",
	    class: {
	      'd-timetal--read-only': _vm.isReadOnly
	    }
	  }, [_c('div', {
	    staticClass: "d-timetal__container"
	  }, [_vm._m(0), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.grades), function(grade) {
	    return _c('th', {
	      key: grade.value
	    }, [_vm._v(_vm._s(grade.title))])
	  })], 2)]), _vm._v(" "), _c('tbody', [(!_vm.isReadOnly) ? _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.grades), function(grade) {
	    return _c('td', {
	      staticClass: "td-is-checkbox"
	    }, [_c('button', {
	      staticClass: "bttn bttn--small hint--top",
	      attrs: {
	        "aria-label": "Sæt alle klassens fag til nul"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.nulstilKlasse(grade)
	        }
	      }
	    }, [_vm._v("Nulstil\n          ")])])
	  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.fagMedVProps), function(fag) {
	    return (!_vm.isReadOnly) ? _c('tr', {
	      key: fag.fagkode
	    }, [_c('td', [_vm._v(_vm._s(fag.title))]), _vm._v(" "), _vm._l((fag.klasser), function(klasse) {
	      return _c('td', {
	        class: [{
	          'td-is-obligatorisk': klasse.v_obligatorisk
	        }, {
	          'td-is-checkbox': klasse.hasOwnProperty('checkbox')
	        }]
	      }, [(klasse.hasOwnProperty('num')) ? _c('input', {
	        staticClass: "d-input",
	        attrs: {
	          "type": "number"
	        },
	        domProps: {
	          "value": klasse.num
	        },
	        on: {
	          "blur": function($event) {
	            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
	          }
	        }
	      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'konfirmation') ? _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': fag.v_fag.klassetrin * 1 === klasse.value * 1
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setKonfirmation(fag.v_fag, klasse.value)
	          }
	        }
	      }) : _vm._e(), _vm._v(" "), (klasse.hasOwnProperty('checkbox') && fag._type === 'praktik') ? _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': fag.praktikkode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setPraktik(fag)
	          }
	        }
	      }) : _vm._e()])
	    })], 2) : _vm._e()
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Obligatorisk fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.obligatoriskFagopdelt), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized d-explainer"
	  }, [_c('td', [_vm._v("Minimumstimetal")]), _vm._v(" "), _vm._l((_vm.minimumFagopdelt), function(num, key) {
	    return _c('td', [_vm._v("(" + _vm._s(num) + ")")])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Øvrig fagopdelt undervisning i alt")]), _vm._v(" "), _vm._l((_vm.ovrigFagopdelt), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _vm._l((_vm.uuv), function(uuvfag) {
	    return (!_vm.isReadOnly) ? _c('tr', [_c('td', [_vm._v(_vm._s(uuvfag.title))]), _vm._v(" "), _vm._l((uuvfag.klasser), function(klasse) {
	      return _c('td', [(klasse.hasOwnProperty('num')) ? _c('input', {
	        staticClass: "d-input",
	        attrs: {
	          "type": "number"
	        },
	        domProps: {
	          "value": klasse.num
	        },
	        on: {
	          "blur": function($event) {
	            return _vm.updateCell(klasse.v_originalObject, $event.target.value)
	          }
	        }
	      }) : _vm._e()])
	    })], 2) : _vm._e()
	  }), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized"
	  }, [_c('td', [_vm._v("Skoleårets samlede længde\n          (= Obligatorisk fagopdelt undervisning\n          + øvrige fag + Understøttende undervisning)\n        ")]), _vm._v(" "), _vm._l((_vm.sammentaelling), function(timer) {
	    return _c('td', [_vm._v(_vm._s(timer))])
	  })], 2), _vm._v(" "), _c('tr', {
	    staticClass: "d-summarized d-explainer"
	  }, [_c('td', [_vm._v("Mindstekrav til skoleårets samlede længde")]), _vm._v(" "), _vm._l((_vm.totalMinimum), function(num, key) {
	    return _c('td', [(num > 0) ? _c('span', [_vm._v("(" + _vm._s(num) + ")")]) : _vm._e()])
	  })], 2), _vm._v(" "), _vm._l((_vm.tolaererArr), function(tolaerer) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(tolaerer.title))]), _vm._v(" "), _vm._l((tolaerer.klasser), function(klasse) {
	      return _c('td', {
	        staticClass: "td-is-checkbox"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setTolaerer(klasse)
	          }
	        }
	      })])
	    })], 2)
	  }), _vm._v(" "), _vm._l((_vm.foranstaltningerMedProps), function(foranstaltning) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(foranstaltning.title))]), _vm._v(" "), _vm._l((foranstaltning.klasser), function(klasse) {
	      return _c('td', {
	        staticClass: "td-is-checkbox"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': klasse && klasse.godkendelseskode && klasse.godkendelseskode === 'J'
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setForanstaltning(klasse)
	          }
	        }
	      })])
	    })], 2)
	  })], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container__header"
	  }, [_c('h4', {
	    staticClass: "uppercase"
	  }, [_vm._v("UNDERVISNING I NORMALKLASSER")])])
	}]}

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "child_popper",
	    staticClass: "popper-container"
	  }, [(_vm.isTooltip) ? _c('div', {
	    staticClass: "desc__info text-dark"
	  }, [(_vm.isTooltipPopperDone) ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.activeSubjectTypeDesc)
	    }
	  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "subject-types text-dark",
	    class: {
	      'subject-types--focus': _vm.isFormElementActive
	    }
	  }, _vm._l((_vm.activeSubjectTypes), function(subjectType) {
	    return _c('div', {
	      key: subjectType.value,
	      staticClass: "subject-types__type",
	      class: {
	        'subject-types__type--selected': _vm.selectedtype === subjectType.value
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectedtype = subjectType.value
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedtype),
	        expression: "selectedtype"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "subject[subject_type]",
	        "id": 'subject_subject_type_' + subjectType.value
	      },
	      domProps: {
	        "value": subjectType.value,
	        "checked": _vm._q(_vm.selectedtype, subjectType.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selectedtype = subjectType.value
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": 'subject_subject_type_' + subjectType.value
	      },
	      domProps: {
	        "innerHTML": _vm._s(subjectType.name)
	      }
	    }), _vm._v(" "), _c('div', {
	      ref: "parent_popper",
	      refInFor: true,
	      staticClass: "desc",
	      on: {
	        "mouseenter": function($event) {
	          return _vm.showTooltip(subjectType.desc, $event)
	        },
	        "mouseleave": _vm.hideTooltip
	      }
	    }, [_c('svg', {
	      attrs: {
	        "width": "16px",
	        "height": "16px",
	        "viewBox": "0 0 16 16"
	      }
	    }, [_c('g', {
	      attrs: {
	        "id": "Artboard-2",
	        "stroke": "none",
	        "stroke-width": "1",
	        "fill": "none",
	        "fill-rule": "evenodd"
	      }
	    }, [_c('g', {
	      attrs: {
	        "id": "Group-2"
	      }
	    }, [_c('circle', {
	      attrs: {
	        "id": "Oval-10",
	        "fill": "#a2a3a6",
	        "cx": "8",
	        "cy": "8",
	        "r": "8"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M7.354,9.657 L7.354,9.294 C7.354,7.732 9.059,7.292 9.059,6.148 C9.059,5.51 8.652,5.191 8.014,5.191 C7.343,5.191 6.826,5.609 6.826,6.445 L5.473,6.445 C5.473,4.729 6.573,3.948 8.102,3.948 C9.389,3.948 10.533,4.608 10.533,6.005 C10.533,7.666 8.663,8.183 8.663,9.437 L8.663,9.657 L7.354,9.657 Z M7.156,11.373 C7.156,10.878 7.464,10.559 8.003,10.559 C8.509,10.559 8.85,10.878 8.85,11.34 C8.85,11.813 8.509,12.143 8.003,12.143 C7.464,12.143 7.156,11.813 7.156,11.373 Z",
	        "id": "?",
	        "fill": "#FFFFFF"
	      }
	    })])])])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isInPrintMode || _vm.eventsFiltered.length > 0) ? _c('ul', {
	    ref: "d_weekplan",
	    staticClass: "weekplan box text-dark",
	    class: {
	      'weekplan--editable': !_vm.isReadOnly
	    }
	  }, [(!_vm.isInViewport) ? _c('div', {
	    staticClass: "weekplan-placeholder box",
	    style: (_vm.placeholderHeight)
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].weekplan))]), _vm._v(" "), (_vm.isWeekplanHasLesson) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isInViewport) ? [_c('div', {
	    ref: "d_eip",
	    staticClass: "deip-holder",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [(_vm.activeEvent) ? _c('EIP', {
	    attrs: {
	      "activeEIP": _vm.activeEIP,
	      "lesson": _vm.activeEvent,
	      "noteType": _vm.activeNoteType,
	      "isUploadFile": false,
	      "isClosingWithoutSaving": _vm.isClosingWithoutSaving,
	      "isSaving": _vm.isSavingEIP
	    },
	    on: {
	      "changed": _vm.setIsEditorChangedWithoutSave,
	      "close": _vm.closeEip
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('h2', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].weekplan))]), _vm._v(" "), (_vm.weekNote !== undefined && _vm.calendar && _vm.calendar.type === 'klass') ? _c('div', {
	    staticClass: "week_note"
	  }, [(_vm.isReadOnly) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.weekNote)
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isReadOnly) ? _c('div', {
	    staticClass: "weekplan--grid__note",
	    class: [{
	      'weekplan--grid__note--open': _vm.activeEventId === _vm.calendar.id + '_' + 'weeknote'
	    }, {
	      'weekplan--grid__note--empty': _vm.weekNote.length < 1
	    }],
	    attrs: {
	      "id": _vm.calendar.id + '_' + 'weeknote'
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setActiveEip(null, 'weeknote', _vm.calendar.id + '_' + 'weeknote', $event)
	      }
	    }
	  }, [(_vm.activeEventId !== _vm.calendar.id + '_' + 'weeknote') ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.weekNote)
	    }
	  }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isWeekplanHasLesson) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].no_events_this_week))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsWithinDays), function(day, key) {
	    return (day.lessons.length !== 0) ? _c('li', {
	      key: day.date,
	      staticClass: "weekplan__day-change"
	    }, [_c('h3', [_vm._v(_vm._s(_vm.filterLocaleDate(day.date)))]), _vm._v(" "), _c('div', {
	      staticClass: "weekplan__grid day-change__headline"
	    }, [_c('p', {
	      staticClass: "weekplan__grid__title"
	    }, [(_vm.calendar.type !== 'other') ? void 0 : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].learning_goal))] : _vm._e(), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].meeting_purpose))] : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].content))] : _vm._e(), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].agenda))] : _vm._e()], 2), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].pupil_preparation))] : _vm._e(), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].decisions_and_resume))] : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].teacher_notes))] : _vm._e()], 2), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].internal_notes))] : _vm._e()], 2), _vm._v(" "), _c('ul', _vm._l((day.lessons), function(event) {
	      return _c('li', {
	        key: event.event_id,
	        staticClass: "box week-plan__lesson__note weekplan__grid",
	        class: {
	          'lesson__notes--readonly': _vm.isReadOnly
	        },
	        style: ({
	          borderColor: event.color
	        })
	      }, [_c('div', {
	        staticClass: "weekplan__grid__title"
	      }, [_c('span', {
	        staticClass: "bold"
	      }, [_vm._v(_vm._s(event.title))]), (event.group) ? _c('span', [_vm._v(", " + _vm._s(event.group))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timeStamp")(event.start)) + " - " + _vm._s(_vm._f("timeStamp")(event.end))), _c('br')])]), _vm._v(" "), _c('div', {
	        staticClass: "weekplan--grid__note",
	        class: [{
	          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'learning_goal'
	        }, {
	          'weekplan--grid__note--empty': event.learning_goal.length < 1
	        }],
	        attrs: {
	          "id": event.event_id + '_' + 'learning_goal'
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveEip(event, 'learning_goal', event.event_id + '_' + 'learning_goal', $event)
	          }
	        }
	      }, [(_vm.activeEventId !== event.event_id + '_' + 'learning_goal') ? _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(event.learning_goal)
	        }
	      }) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "weekplan--grid__note",
	        class: [{
	          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'description'
	        }, {
	          'weekplan--grid__note--empty': event.description.length < 1
	        }],
	        attrs: {
	          "id": event.event_id + '_' + 'description'
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveEip(event, 'description', event.event_id + '_' + 'description', $event)
	          }
	        }
	      }, [(_vm.activeEventId !== event.event_id + '_' + 'description') ? _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(event.description)
	        }
	      }) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "weekplan--grid__note",
	        class: [{
	          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'notes_for_students'
	        }, {
	          'weekplan--grid__note--empty': event.notes_for_students.length < 1
	        }],
	        attrs: {
	          "id": event.event_id + '_' + 'notes_for_students'
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveEip(event, 'notes_for_students', event.event_id + '_' + 'notes_for_students', $event)
	          }
	        }
	      }, [(_vm.activeEventId !== event.event_id + '_' + 'notes_for_students') ? _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(event.notes_for_students)
	        }
	      }) : _vm._e()]), _vm._v(" "), _c('div', {
	        staticClass: "weekplan--grid__note",
	        class: [{
	          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'teacher_notes'
	        }, {
	          'weekplan--grid__note--empty': event.teacher_notes.length < 1
	        }],
	        attrs: {
	          "id": event.event_id + '_' + 'teacher_notes'
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveEip(event, 'teacher_notes', event.event_id + '_' + 'teacher_notes', $event)
	          }
	        }
	      }, [(_vm.activeEventId !== event.event_id + '_' + 'teacher_notes') ? _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(event.teacher_notes)
	        }
	      }) : _vm._e()])])
	    }), 0)]) : _vm._e()
	  })] : _vm._e()], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": 'etaeiteazYM?start=67',
	      "textForLink": "Guide: Se videoguide for Personalets alder og køn"
	    }
	  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-filters"
	  }, [_c('div', {
	    staticClass: "d-filters__filter",
	    class: {
	      'd-filters__filter--active': _vm.activeFilter === 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeFilter = 0
	      }
	    }
	  }, [_vm._v("Alle\n      "), _c('div', {
	    staticClass: "d-pill"
	  }, [_vm._v(_vm._s(_vm.usersWithVProps.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-filters__filter",
	    class: {
	      'd-filters__filter--active': _vm.activeFilter === 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.activeFilter = 1
	      }
	    }
	  }, [_vm._v("Ikke udfyldte\n      "), _c('div', {
	    staticClass: "d-pill"
	  }, [_vm._v(_vm._s(_vm.unfilledUsers.length))])])]), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsersWithVProps), function(user, userIdx) {
	    return _c('tr', {
	      key: user.id
	    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.gender),
	        expression: "user.gender"
	      }],
	      staticClass: "timetal-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(user, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updateUser(user, 'gender', $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "female"
	      }
	    }, [_vm._v("Kvinde")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "male"
	      }
	    }, [_vm._v("Mand")])])]), _vm._v(" "), _c('td', [_c('input', {
	      attrs: {
	        "type": "date"
	      },
	      domProps: {
	        "value": user.v_birthday
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateUser(user, 'dob', $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (user.v_stil_stilling),
	        expression: "user.v_stil_stilling"
	      }],
	      staticClass: "timetal-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(user, "v_stil_stilling", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updateUser(user, 'stil_stilling', $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "LA"
	      }
	    }, [_vm._v("Lærer")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "BH"
	      }
	    }, [_vm._v("Børnehaveklasseleder")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "PA"
	      }
	    }, [_vm._v("Pædagog")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "LE"
	      }
	    }, [_vm._v("Leder")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "AN"
	      }
	    }, [_vm._v("Andre med undervisningsopgaver")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "undtaget"
	      }
	    }, [_vm._v("Ingen undervisningsopgaver (ikke indberet)")])])])])
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "italic"
	  }, [_vm._v("Bemærk: Det er de personaler, som er ansat på skolen pr. 5. september 2022, der skal\n      indberettes.\n      "), _c('br'), _vm._v("Personale der ikke skal indberettes sættes til \"Ingen undervisningsopgaver (ikke indberet)\"")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "d-table__name"
	  }, [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Mand / Kvinde")]), _vm._v(" "), _c('th', [_vm._v("Fødselsdato")]), _vm._v(" "), _c('th', [_vm._v("Stilling")])])])
	}]}

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createroom_button.create_room')))])
	},staticRenderFns: []}

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "flex"
	  }, [_c('div', {
	    staticClass: "header-container box-shadow"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "nav"
	  }, [_c('div', {
	    staticClass: "nav-left"
	  }, [_c('v-touch', {
	    staticClass: "touch-container mobile-nav",
	    on: {
	      "tap": _vm.sendClick
	    }
	  }, [_c('div', {
	    staticClass: "flex"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.isMonth))]), _vm._v(" "), _c('span', {
	    staticClass: "icon",
	    class: {
	      'icon-arrow-up5': !_vm.showdatepicker, 'icon-arrow-down5': _vm.showdatepicker
	    }
	  })])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "nav-right"
	  }, [_c('v-touch', {
	    staticClass: "pad-10-right",
	    on: {
	      "tap": function($event) {
	        return _vm.$emit('menu')
	      }
	    }
	  }, [_c('button', {
	    staticClass: "left-button nav-button"
	  }, [_c('span', {
	    staticClass: "icon-menu"
	  })])])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "docendo-logo box-shadow"
	  }, [_c('span', {
	    staticClass: "icon-docendo docendo-logo__icon",
	    attrs: {
	      "id": "d-icon"
	    }
	  })])
	}]}

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "basis-overview text-dark"
	  }, [_c('div', {
	    staticClass: "basis-overview__header"
	  }, [_c('h1', [_vm._v("Basis Hours")]), _vm._v(" "), _c('div', {
	    staticClass: "basis-overview__dates"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e(), _vm._v(" "), _c('Tabs', {
	    attrs: {
	      "tabs": [{
	        id: 'hours',
	        title: 'Hours'
	      }, {
	        id: 'minutes',
	        title: 'Minutes'
	      }],
	      "selected": _vm.theSelectedTab
	    },
	    on: {
	      "select": function($event) {
	        _vm.theSelectedTab = $event
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn",
	    class: {
	      'do-bttn--loading': _vm.isDownloading
	    },
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [_vm._v("Download\n        to excel\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "do-button__multiple"
	  }, [_c('button', {
	    staticClass: "do-button__multiple__bttn icon-arrow-left4",
	    on: {
	      "click": _vm.setPrevWeek
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "do-button__multiple__bttn",
	    class: {
	      'bttn--disabled': _vm.isThisWeek
	    },
	    on: {
	      "click": _vm.setThisWeek
	    }
	  }, [_vm._v("This\n          week\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-button__multiple__bttn icon-arrow-right4",
	    on: {
	      "click": _vm.setNextWeek
	    }
	  })]), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "basis-overview__body"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', _vm._l((_vm.col1), function(col) {
	    return _c('th', {
	      style: ({
	        backgroundColor: col.color ? col.color : null
	      }),
	      attrs: {
	        "rowspan": col.rowspan ? col.rowspan : 1,
	        "colspan": col.colspan ? col.colspan : 1
	      }
	    }, [_c('div', [_vm._v("\n            " + _vm._s(col.name) + "\n          ")])])
	  }), 0), _vm._v(" "), _c('tr', _vm._l((_vm.col2), function(col) {
	    return _c('th', {
	      style: ({
	        backgroundColor: col.color ? col.color : null
	      }),
	      attrs: {
	        "rowspan": col.rowspan ? col.rowspan : 1,
	        "colspan": col.colspan ? col.colspan : 1
	      }
	    }, [_vm._v("\n          " + _vm._s(col.name) + "\n        ")])
	  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.usersWithVEvents), function(user) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(user.employee_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.openEdit(user, user.v_presence, 'weeklyHours', $event)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(user.v_presence) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_subject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_break))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_tasks))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_preparation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_substitute_teaching))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_substitute_not_teaching))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_hours_left))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_absence))])])
	  }), 0)]), _vm._v(" "), (_vm.theEditNumberUser) ? _c('div', {
	    ref: "popper_child",
	    staticClass: "popper_child"
	  }, [_c('transition', {
	    attrs: {
	      "name": "scale"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "number__input-opened"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.theEditNumberNumber),
	      expression: "theEditNumberNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeEditing),
	      expression: "closeEditing"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.theEditNumberNumber)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doneEditing.apply(null, arguments)
	      },
	      "change": function($event) {
	        _vm.theEditNumberNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--small--loading': _vm.isUpdatingNumber
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.doneEditing.apply(null, arguments)
	      }
	    }
	  }, [(!_vm.isUpdatingNumber) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "toast",
	    class: [{
	      'toastSuccess': _vm.toast.success
	    }, {
	      'toast--left-bottom': _vm.leftBottom
	    }, {
	      'animated fadeInDown': !_vm.leftBottom
	    }, {
	      'animateFast fadeInUp': _vm.leftBottom
	    }],
	    style: (_vm.styleObj)
	  }, [_c('div', {
	    staticClass: "toast-content"
	  }, [(_vm.toast.success) ? _c('div', {
	    staticClass: "toast__icon toast_icon__success icon-checkmark-circle"
	  }) : _vm._e(), _vm._v(" "), (!_vm.toast.success) ? _c('div', {
	    staticClass: "toast__icon toast_icon__bell icon-bell"
	  }) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.toast.text))])]), _vm._v(" "), _c('div', {
	    staticClass: "cross pointer",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('removeNow', _vm.toast.id)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-shortcuts__container"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false
	    }
	  }, [_c('div', {
	    staticClass: "d-drop-box",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.title) + " "), _c('span', {
	    staticClass: "icon-arrow-down52"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.shortcuts), function(shortcut) {
	    return _c('li', {
	      key: shortcut.val,
	      on: {
	        "click": function($event) {
	          return _vm.$emit('shortcutSelected', shortcut.dateRange)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(shortcut.title) + "\n      ")])
	  }), 0)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "datepicker-container text-dark"
	  }, [_c('div', {
	    staticClass: "datepicker-panel no-select box-shadow",
	    class: {
	      'no_weekends': !_vm.weekends
	    },
	    attrs: {
	      "id": "datepicker-panel"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "calBoxContainer"
	    }
	  }, [_c('div', {
	    staticClass: "datepicker-cells",
	    attrs: {
	      "id": "calBox"
	    }
	  }, [_c('ul', {
	    staticClass: "week-row"
	  }, _vm._l((_vm.weekdays), function(day) {
	    return _c('li', {
	      key: day,
	      staticClass: "datepicker-cell"
	    }, [_vm._v(_vm._s(day) + "\n          ")])
	  }), 0), _vm._v(" "), _vm._l((_vm.datesInWeeks), function(weeks) {
	    return _c('div', {
	      staticClass: "week-row"
	    }, _vm._l((weeks.dates), function(date) {
	      return _c('div', {
	        class: 'datepicker-cell ' + date.dayClass
	      }, [_c('v-touch', {
	        on: {
	          "tap": function($event) {
	            return _vm.setDate(date)
	          }
	        }
	      }, [(date.show) ? _c('span', {
	        staticClass: "number",
	        class: [{
	          isToday: date.isToday,
	          active: date.isSelected
	        }]
	      }, [_vm._v("\n                    " + _vm._s(date.showDate) + "\n                ")]) : _c('span', {
	        staticClass: "number",
	        class: [{
	          isToday: date.isToday,
	          active: date.isSelected
	        }]
	      }, [_vm._v("\n                    " + _vm._s(date.showDate) + "\n              ")])])], 1)
	    }), 0)
	  })], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('div', {
	    staticClass: "box grid grid-responsive week_notes_lesson_note",
	    style: ({
	      borderColor: _vm.event.color
	    })
	  }, [_c('div', {
	    staticClass: "col-2-12 box-size"
	  }, [_c('h3', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), _c('span', {
	    staticClass: "bold"
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm._f("timeStamp")(_vm.event.start)) + " - " + _vm._s(_vm._f("timeStamp")(_vm.event.end))), _c('br')])]), _vm._v(" "), _c('div', {
	    staticClass: "col-10-12"
	  }, [(_vm.checkLengthWithoutHTML(_vm.event.learning_goal)) ? _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('p', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.learning_goal')))])]), _vm._v(" "), _c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.learning_goal)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.description)) ? _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('p', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.content')) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.description)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.notes_for_students)) ? _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('p', {
	    style: ({
	      color: _vm.event.color
	    })
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.pupil_preparation')))])]), _vm._v(" "), _c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.notes_for_students)
	    }
	  })]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "nav",
	    class: {
	      notTouchingSideNav: !_vm.touchingSideNav
	    },
	    style: ({
	      webkitTransform: 'translateX(' + _vm.translateX + ')'
	    }),
	    on: {
	      "transitionend": _vm.sendView
	    }
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.calName))])]), _vm._v(" "), _c('div', {
	    staticClass: "nav-menu"
	  }, [_c('ul', {
	    staticClass: "nav-menu__list"
	  }, [_c('li', {
	    staticClass: "nav-title"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue.public.app.sidenav.changeview')) + "\n          ")]), _vm._v(" "), _c('v-touch', {
	    staticClass: "list-item",
	    on: {
	      "tap": function($event) {
	        return _vm.setView(1)
	      }
	    }
	  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue.public.app.sidenav.showday')))])]), _vm._v(" "), _c('v-touch', {
	    staticClass: "list-item",
	    on: {
	      "tap": function($event) {
	        return _vm.setView(3)
	      }
	    }
	  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue.public.app.sidenav.showweek')))])]), _vm._v(" "), _c('v-touch', {
	    staticClass: "list-item",
	    on: {
	      "tap": function($event) {
	        return _vm.setView(2)
	      }
	    }
	  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue.public.app.sidenav.showweekplan')))])]), _vm._v(" "), _c('div', {
	    staticClass: "divider"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "nav-title"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('repitition.chooselanguage')) + "\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "list-item"
	  }, [_c('set-locale', {
	    on: {
	      "locale": _vm.emitLocale
	    }
	  })], 1)], 1)])]), _vm._v(" "), (_vm.menu) ? _c('v-touch', {
	    on: {
	      "panstart": _vm.onPanStart,
	      "panend": _vm.onPanEnd,
	      "pan": _vm.moveMenu,
	      "tap": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "drag-target"
	  })]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "opacity"
	    }
	  }, [(_vm.menu) ? _c('div', {
	    staticClass: "nav-overlay"
	  }) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tbody', {
	    staticClass: "user-list__user__table__tbody"
	  }, _vm._l((_vm.events), function(event) {
	    return _c('tr', {
	      key: event.event_id,
	      staticClass: "user-list__user__table__event",
	      class: {
	        'user-list__user__table__event--special': event.v_is_special
	      }
	    }, [_c('td', [_vm._v(_vm._s(event.v_start_and_endtime) + " | "), (event.v_is_special) ? _c('span', {
	      staticClass: "d-tag"
	    }, [_vm._v(_vm._s(event.title))]) : _c('b', [_vm._v(_vm._s(event.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.v_calendar_name))]), _vm._v(" "), _c('td', [_c('span', {
	      staticClass: "d-tag"
	    }, [_vm._v(_vm._s(event.v_event_type_name))])]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(event.v_substitute_for_name) + "\n    "), (event.v_substitute_for_employments.length > 0) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return event.v_substitute_for_employments.length > 1; }
	        }),
	        expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window',\n                          onShow: () => event.v_substitute_for_employments.length > 1\n                        }"
	      }],
	      staticClass: "d-tag",
	      attrs: {
	        "content": event.v_substitute_for_employments
	      }
	    }, [_vm._v("\n                    " + _vm._s(event.v_substitute_for_employments[0]) + "\n                    "), (event.v_substitute_for_employments.length > 1) ? [_vm._v("m.fl.")] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.userDay.state === 'draft') ? [(_vm.user.v_user_active_employments.length < 1) ? _c('p', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen ansættelser")]) : _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.number",
	        value: (event.employment_id),
	        expression: "event.employment_id",
	        modifiers: {
	          "number": true
	        }
	      }],
	      staticClass: "no-print",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return _vm._n(val)
	          });
	          _vm.$set(event, "employment_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updatePropOnLesson('employment_id', _vm.user, _vm.userDay, event, $event.target.value)
	        }]
	      }
	    }, _vm._l((_vm.user.v_user_active_employments), function(userEmployment) {
	      return _c('option', {
	        domProps: {
	          "value": Number(userEmployment.id)
	        }
	      }, [_vm._v("\n          " + _vm._s(userEmployment.title) + "\n        ")])
	    }), 0), _vm._v(" "), _c('span', {
	      staticClass: "only-print",
	      class: {
	        'italic': event.v_employment_id_title === 'Ingen valgt'
	      }
	    }, [_vm._v("\n        " + _vm._s(event.v_employment_id_title) + "\n      ")])] : _c('span', {
	      class: {
	        'd-tag': event.v_employment_id_title && event.v_employment_id_title !== 'Ingen valgt'
	      }
	    }, [_vm._v(_vm._s(event.v_employment_id_title) + "\n    ")])], 2), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('td', {
	      staticClass: "td-salary-input-number"
	    }, [(_vm.userDay.state === 'draft') ? [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (event.loenart),
	        expression: "event.loenart"
	      }],
	      staticClass: "no-print do-input",
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (event.loenart)
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(event, "loenart", $event.target.value)
	        }, function($event) {
	          return _vm.updatePropOnLesson('loenart', _vm.user, _vm.userDay, event, $event.target.value)
	        }]
	      }
	    })] : [_vm._v("\n      " + _vm._s(event.loenart) + "\n    ")]], 2) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('td', {
	      staticClass: "td-salary-input-number"
	    }, [(_vm.userDay.state === 'draft') ? [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (event.loebenummer),
	        expression: "event.loebenummer"
	      }],
	      staticClass: "no-print do-input input-loebenummer",
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": (event.loebenummer)
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(event, "loebenummer", $event.target.value)
	        }, function($event) {
	          return _vm.validateLoebenummer(_vm.user, _vm.userDay, event, $event.target.value)
	        }]
	      }
	    })] : [_vm._v("\n      " + _vm._s(event.loebenummer) + "\n    ")]], 2) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive && _vm.costCenters.length > 0) ? _c('td', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.number",
	        value: (event.afv_omkostningssted),
	        expression: "event.afv_omkostningssted",
	        modifiers: {
	          "number": true
	        }
	      }],
	      staticClass: "no-print",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return _vm._n(val)
	          });
	          _vm.$set(event, "afv_omkostningssted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.updatePropOnLesson('afv_omkostningssted', _vm.user, _vm.userDay, event, $event.target.value)
	        }]
	      }
	    }, _vm._l((_vm.costCenters), function(costCenter) {
	      return _c('option', {
	        domProps: {
	          "value": Number(costCenter.code)
	        }
	      }, [_vm._v("\n        " + _vm._s(costCenter.title) + "\n      ")])
	    }), 0)]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(event.minutes) + " min.\n  ")])])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "export-calendar text-dark"
	  }, [(_vm.isShowButton) ? _c('button', {
	    staticClass: "bttn bttn--is-loading",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(true)
	      }
	    }
	  }, [(_vm.calLink === 'loading') ? _c('spinner', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "size": "small",
	      "color": "blue"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.calLink.length > 0 && _vm.calLink !== 'loading') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.export_calendar')))]) : _vm._e(), _vm._v(" "), (_vm.calLink.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.guide_to_export_calendar')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('d-modal', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "modal__left"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.export_calendar_to')))]), _vm._v(" "), _c('ul', {
	    staticClass: "export-calendar__cals"
	  }, _vm._l((_vm.integrations), function(integration) {
	    return _c('li', {
	      key: integration.id,
	      class: {
	        'cal--is-active': _vm.theActiveIntegration === integration.id
	      },
	      on: {
	        "click": function($event) {
	          _vm.theActiveIntegration = integration.id
	        }
	      }
	    }, [_c('div', {
	      staticClass: "integration-img",
	      style: ({
	        'background-image': 'url(' + integration.icon + ')'
	      })
	    }), _vm._v("\n              " + _vm._s(integration.title) + "\n            ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "modal__right"
	  }, [(_vm.calLink.length > 0) ? [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.copy_the_url_and_insert')))]), _vm._v(" "), _c('input', {
	    staticClass: "marg-20-bottom",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.calLink
	    },
	    on: {
	      "click": function($event) {
	        return $event.target.select()
	      }
	    }
	  })] : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.guide_to')) + " " + _vm._s(_vm.integrations[_vm.theActiveIntegration].title))]), _vm._v(" "), _vm._l((_vm.integrations[_vm.theActiveIntegration].imgs), function(img) {
	    return _c('img', {
	      attrs: {
	        "src": img
	      }
	    })
	  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "add-lesson__header",
	    style: ({
	      'backgroundColor': _vm.color ? _vm.color : '#2c81ba'
	    })
	  }, [_c('h2', [_vm._v("Opret fag i " + _vm._s(_vm.theCreateSubject.klassebetegnelse))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__form"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Titel*")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "inputTitle",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Fagkode*")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fagkode),
	      expression: "fagkode"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.fagkode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.standardSubjects), function(fag) {
	    return _c('option', {
	      key: fag.fagkode,
	      domProps: {
	        "value": fag.fagkode
	      }
	    }, [_vm._v("\n            " + _vm._s(fag.fagkode) + ": " + _vm._s(fag.name) + "\n          ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Klassetimer på året*")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.klokketimer),
	      expression: "klokketimer"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.klokketimer)
	    },
	    on: {
	      "focus": function($event) {
	        return $event.target.select()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.klokketimer = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "marg-1-right bg-white",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isFormValid) ? _c('div', {
	    staticClass: "hint--top-left",
	    attrs: {
	      "aria-label": "Udfyld formularen"
	    }
	  }, [_c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v("Opret")])]) : _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Opret")])])])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "users-hours text-dark"
	  }, [_c('div', {
	    staticClass: "users-hours__header"
	  }, [_c('div', {
	    staticClass: "users-hours__header__left"
	  }, [_c('h1', {
	    staticClass: "marg-20-right"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assign_hours')))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  }), _vm._v(" "), (!_vm.isInitalLoad) ? _c('p', {
	    staticClass: "marg-10-left"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.showing_scheduled_hours_from')) + " " + _vm._s(_vm._f("yearFormat")(_vm.startDate)) + " - " + _vm._s(_vm._f("yearFormat")(_vm.endDate)))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "user-tasks__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), (_vm.activeSchoolYear) ? _c('DatePickerRangeShortcuts', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "startDate": _vm.activeSchoolYear.employee_time_start,
	      "endDate": _vm.activeSchoolYear.employee_time_end,
	      "selectedStartDate": _vm.startDate,
	      "selectedEndDate": _vm.endDate
	    },
	    on: {
	      "shortcutSelected": _vm.setDatesFromRange
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": function($event) {
	        return _vm.setEndDate($event, true)
	      }
	    }
	  }), _vm._v(" "), (_vm.isShowPrintButton) ? _c('button', {
	    staticClass: "marg-1-left",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "users border"
	  }, [(_vm.isLoadingUpdatedNumbers && !_vm.isInitalLoad && !this.numberOfWorkDaysInPeriod) ? _c('div', {
	    staticClass: "users--loading"
	  }, [_c('Spinner', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "users-header users-header-second"
	  }, [_c('div', {
	    staticClass: "flex-left"
	  }, [_c('div', {
	    staticClass: "users-user__meta"
	  }, [_c('div', [_c('input', {
	    staticClass: "users-header__searchfield",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.assign_users_hours.search_a_name')
	    },
	    on: {
	      "input": _vm.debounceSearch
	    }
	  })]), _vm._v(" "), _c('filterTags', {
	    staticClass: "marg-1-left",
	    attrs: {
	      "users": _vm.usersForList,
	      "schoolid": _vm.schoolId,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "flex-right users-header-second__buttons"
	  }, [(_vm.isShowPrintTaskOverviewModal) ? _c('PrintTaskOverviews', {
	    attrs: {
	      "tags": _vm.tags,
	      "theUserCanManageAssignedHours": _vm.theUserCanManageAssignedHours,
	      "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowPrintTaskOverviewModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowSaveVersionTaskOverviewModal) ? _c('SaveTaskOverview', {
	    on: {
	      "close": function($event) {
	        _vm.isShowSaveVersionTaskOverviewModal = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('AssignHoursNorm', {
	    attrs: {
	      "prepFactor": _vm.schoolPrepFactor,
	      "isLocalPoolActivated": _vm.isLocalPoolActivated,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated,
	      "isKindergarten": false,
	      "tags": _vm.tags
	    },
	    on: {
	      "updateUsersHours": _vm.getUsersHours
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "isBottomStart": false,
	      "propOffset": [5, 5]
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-more2"
	  })]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [(_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsDeactivatePoolsModalVisible(true)
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.isPoolsDeactivated ? 'Aktiver puljer' : 'Deaktiver puljer') + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsChangePrepFactorModal(true)
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(!_vm.schoolPrepFactor ? 'Aktiver forbereldesesfaktor' : 'Forberedelsesfaktor ' + _vm.schoolPrepFactor) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowTaskOverviewSettings = true
	      }
	    }
	  }, [_vm._v("\n              Design opgaveoversigter\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowSaveVersionTaskOverviewModal = true
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.task_versions.save_new_version_task_overviews')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.isShowPrintTaskOverviewModal = true
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.task_versions.print_latest_version_task_overviews')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.asyncLoadXLSXAndDownload
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n['download_to_excel']) + "\n            ")]), _vm._v(" "), (_vm.isSchoolFromCO) ? _c('li', {
	    on: {
	      "click": _vm.setIsChangeViewModal
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['change_view']))]) : _vm._e(), _vm._v(" "), _c('li', {
	    on: {
	      "click": _vm.updateUserHours
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.assign_users_hours.update')) + "\n            ")]), _vm._v(" "), (_vm.isSchoolDanish) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowEmploymentEnded(true)
	      }
	    }
	  }, [_vm._v("\n              Brudt ansættelse\n            ")]) : _vm._e()])])], 1)]), _vm._v(" "), (_vm.isInitalLoad || _vm.isLoadingSubjectsOrTasks) ? _c('div', {
	    staticStyle: {
	      "margin": "100px auto"
	    }
	  }, [_c('Spinner', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  })], 1) : _c('AllUsers', {
	    attrs: {
	      "theUserCanManageAssignedHours": _vm.theUserCanManageAssignedHours,
	      "prepFactor": _vm.schoolPrepFactor,
	      "viewSettings": _vm.viewSettings,
	      "schoolid": _vm.schoolId,
	      "users": _vm.filteredUsers,
	      "isDatesPristine": _vm.isDatesPristine,
	      "numberOfWorkDays": _vm.numberOfWorkDays,
	      "numberOfWorkDaysInPeriod": _vm.numberOfWorkDaysInPeriod,
	      "isLocalPoolActivated": _vm.isLocalPoolActivated,
	      "locale": _vm.locale,
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "setActiveUser": _vm.setActiveUser,
	      "setTheUserToShowTasks": _vm.setTheUserToShowTasks,
	      "updatedUser": _vm.updatedUser
	    }
	  })], 1), _vm._v(" "), (_vm.isChangeViewModal) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.setIsChangeViewModal
	    }
	  }, [_c('div', {
	    staticClass: "modal-assign-hours-view",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['change_view']))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.setIsChangeViewModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('ul', _vm._l((_vm.viewSettingsI18N), function(setting, key) {
	    return _c('li', {
	      key: key,
	      staticClass: "modal-assign-hours-view__item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setViewSetting(key, setting.active)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(setting.title))]), _vm._v(" "), _c('div', {
	      staticClass: "do-switch",
	      class: {
	        'do-switch--active': setting.active
	      }
	    })])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.setIsChangeViewModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.done')))])])])]) : _vm._e(), _vm._v(" "), (_vm.activeUserId) ? _c('ShowUserAbsence', {
	    attrs: {
	      "eventsFilter": _vm.activeUserEventFilter,
	      "userId": _vm.activeUserId
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeUserId = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('div', {
	    staticClass: "user-task__container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "user-task__container__header"
	  }, [_c('h2'), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserTasks', {
	    attrs: {
	      "initialStartDate": _vm.startDate,
	      "initialEndDate": _vm.endDate,
	      "user_id": _vm.theUserToShowTasks.id,
	      "user_calendar_id": _vm.theUserToShowTasks.user_calendar_id,
	      "user_name": _vm.theUserToShowTasks.name,
	      "isShowPrintButton": false,
	      "isCanSeeOtherUsers": false
	    }
	  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isChangePrepFactorModal) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsChangePrepFactorModal(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Forberedelsesfaktor")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsChangePrepFactorModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('div', {
	    staticClass: "d-explainer-box text-explainer text-explainer__error"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-help",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
	    }
	  })]), _vm._v("\n          Aktivering af forberedelsesfaktor gør, at timer til forberedelse automatisk opdateres, når undervisning\n          tildeles til en underviser.\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsThePrepFactorActive.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label color-dark"
	  }, [_vm._v("Aktiver forberedelsesfaktor")]), _vm._v(" "), _c('div', {
	    staticClass: "do-switch",
	    class: {
	      'do-switch--active': _vm.isThePrepFactorActive
	    }
	  })]), _vm._v(" "), (_vm.isThePrepFactorActive) ? _c('div', {
	    staticClass: "prep-factor-input marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Indtast jeres forberedelsesfaktor")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.thePrepFactor),
	      expression: "thePrepFactor"
	    }],
	    ref: "the_prep_factor_input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.thePrepFactor)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.savePrepFactor.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.thePrepFactor = $event.target.value
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn marg-1-right",
	    on: {
	      "click": function($event) {
	        return _vm.setIsChangePrepFactorModal(false)
	      }
	    }
	  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSavingPrepFactor
	    },
	    on: {
	      "click": _vm.savePrepFactor
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isShowEmploymentEnded) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowEmploymentEnded(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Brudt ansættelse")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowEmploymentEnded(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('AssignHoursEmploymentEnded', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.usersForList
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isShowTaskOverviewSettings) ? _c('TaskOverviewSettings', {
	    on: {
	      "close": function($event) {
	        _vm.isShowTaskOverviewSettings = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isDeactivatePoolsModalVisible) ? _c('AssignHoursDeactivatePoolsModal', {
	    attrs: {
	      "isPoolsDeactivated": _vm.isPoolsDeactivated
	    },
	    on: {
	      "reReadNumbers": _vm.reReadNumbers,
	      "close": function($event) {
	        return _vm.setIsDeactivatePoolsModalVisible(false)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.onCancel
	    }
	  }, [_c('div', {
	    staticClass: "do-modal do-modal__reasons-form",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n.create_absence))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('div', {
	    staticClass: "d-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n.title))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newReasonTitle),
	      expression: "newReasonTitle"
	    }],
	    staticClass: "d-input",
	    class: {
	      'd-input--error': _vm.errors.newReasonTitle
	    },
	    domProps: {
	      "value": (_vm.newReasonTitle)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onCreate.apply(null, arguments)
	      },
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newReasonTitle = $event.target.value
	      }, _vm.clearErrors]
	    }
	  }), _vm._v(" "), (_vm.errors.newReasonTitle) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.errors.newReasonTitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.defaultPrivate = !_vm.defaultPrivate
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n.hide_title))]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "propOn": _vm.defaultPrivate,
	      "allowChanges": false
	    }
	  })], 1), _vm._v(" "), _c('p', {
	    staticClass: "marg-1-top italic"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.i18n.default_private_explained)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isCreating
	    },
	    on: {
	      "click": _vm.onCreate
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.create')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cal-container__header flex flex-1"
	  }, [_c('div', {
	    staticClass: "cal-container__header--left flex"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.showDate))])]), _vm._v(" "), _c('div', {
	    staticClass: "cal-container__header--right"
	  }, [_c('button', {
	    class: [{
	      inactive: !_vm.isNotThisWeek
	    }, 'no-print'],
	    on: {
	      "click": function($event) {
	        return _vm.$emit('today')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('repitition.today')))]), _vm._v(" "), _c('button', {
	    staticClass: "icon-arrow-left4 no-print",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('prevWeek')
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "icon-arrow-right4 no-print",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('nextWeek')
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "doScheduler",
	    staticClass: "do-scheduler",
	    style: ({
	      maxHeight: _vm.schedulerMaxHeight + 'px'
	    })
	  }, [_c('ul', {
	    staticClass: "do-scheduler__list",
	    style: ({
	      'width': _vm.slotWidth * 48 + 'px'
	    })
	  }, [_c('ul', {
	    staticClass: "scheduler__header__times"
	  }, _vm._l((_vm.hoursInLocale), function(number) {
	    return _c('li', {
	      style: ({
	        minWidth: _vm.slotWidth * 2 + 'px'
	      })
	    }, [_vm._v(_vm._s(number))])
	  }), 0), _vm._v(" "), _vm._l((_vm.calendarsWithEvents), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "do-scheduler__list__item",
	      style: ({
	        height: (_vm.slotHeight * calendar.vColumns) + 'px'
	      })
	    }, [_c('div', {
	      staticClass: "do-scheduler__list__item__name"
	    }, [_c('h4', [_vm._v(_vm._s(calendar.name))])]), _vm._v(" "), _c('ul', {
	      staticClass: "do-scheduler__item__events",
	      style: ({
	        'width': _vm.slotWidth * 48 + 'px',
	        height: (_vm.slotHeight * calendar.vColumns) + 'px'
	      })
	    }, [_vm._l((calendar.vPresence), function(presence) {
	      return _c('li', {
	        staticClass: "do-scheduler__item__events__presence",
	        style: ({
	          left: presence.left + 'px',
	          right: presence.right + 'px'
	        })
	      })
	    }), _vm._v(" "), _vm._l((calendar.vEvents), function(event) {
	      return _c('li', {
	        key: event.id,
	        staticClass: "do-scheduler__item__events__event",
	        style: (_vm.getEventStyle(event))
	      }, [_c('div', {
	        staticClass: "do-scheduler__item__events__event__title"
	      }, [_vm._v(_vm._s(event.title))]), _vm._v(" "), _c('div', {
	        staticClass: "do-scheduler__item__events__event__klass"
	      }, [_vm._v(_vm._s(event.vKlasses))])])
	    })], 2)])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DModal', {
	    staticStyle: {
	      "z-index": "123123"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true,
	      "appendToBody": true,
	      "isCloseOnEsc": !_vm.isCreateCategory && !_vm.theEditTask && !_vm.isWatchGuide
	    },
	    on: {
	      "close": _vm.onClose
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__content text-dark"
	  }, [_c('div', {
	    staticClass: "d-modal__content__sidebar"
	  }, [_c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.onClose
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('h2', [_vm._v("Design opgaveoversigter")]), _vm._v(" "), _c('ul', {
	    staticClass: "d-modal__content__sidebar__nav"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    attrs: {
	      "id": "do-bttn--watch-guide"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isWatchGuide = true
	      }
	    }
	  }, [_vm._v("Se guide")]), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
	    return _c('li', {
	      staticClass: "d-modal__content__sidebar__nav-item",
	      class: {
	        'd-modal__content__sidebar__nav-item--active': tab.id === _vm.theActiveTab
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveTab(tab.id)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content__body"
	  }, [(_vm.isInitLoading) ? _c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  }) : [(_vm.theActiveTab === 1) ? _c('TaskOverviewSettingsCategories', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "schoolYear": _vm.schoolYear,
	      "locale": _vm.locale,
	      "taskCategories": _vm.taskCategories,
	      "dbSubjectTypes": _vm.dbSubjectTypes,
	      "subjects": _vm.subjects
	    },
	    on: {
	      "onDeleteTaskCategory": _vm.onDeleteTaskCategory,
	      "updateCategory": _vm.onUpdateCategory,
	      "setCreateCategory": _vm.setCreateCategory,
	      "onSetEditTask": _vm.onSetEditTask
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 2) ? _c('TaskOverviewSettingsCategoriesTasks', {
	    attrs: {
	      "taskCategories": _vm.taskCategoriesSorted,
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "subjects": _vm.subjects,
	      "allCalendarsInHash": _vm.allCalendarsInHash,
	      "allUsersInHash": _vm.allUsersInHash,
	      "tags": _vm.tags
	    },
	    on: {
	      "setCreateCategory": _vm.setCreateCategory,
	      "updateSubjects": _vm.updateSubjects
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('TaskOverviewSettingsSettings', {
	    attrs: {
	      "taskCategories": _vm.taskCategories
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 4) ? _c('TaskOverviewSettingsUserTasks', {
	    attrs: {
	      "theActiveUserId": _vm.theActiveUserIdForExample,
	      "users": _vm.users,
	      "schoolYear": _vm.schoolYear
	    },
	    on: {
	      "setTheActiveUserId": _vm.setTheActiveUserIdForExample
	    }
	  }) : _vm._e()]], 2), _vm._v(" "), (_vm.isCreateCategory) ? _c('TaskOverviewSettingsCategoryCreate', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "schoolYearId": _vm.schoolYearId,
	      "taskCategories": _vm.taskCategories
	    },
	    on: {
	      "close": function($event) {
	        _vm.isCreateCategory = false
	      },
	      "onNewCategory": _vm.onNewCategory
	    }
	  }) : _vm._e()], 1)])]), (_vm.isWatchGuide) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "12312323"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true,
	      "appendToBody": true,
	      "isCloseOnEsc": !_vm.isCreateCategory && !_vm.theEditTask
	    },
	    on: {
	      "close": function($event) {
	        _vm.isWatchGuide = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal--guide",
	    staticStyle: {
	      "width": "90vw"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.isWatchGuide = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content__guide text-dark"
	  }, [_c('TaskOverviewSettingsGuide')], 1)])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brutto brutto--kindergarten text-dark"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.setIsNormModal
	    }
	  }, [_vm._v("Tildel årsverk")]), _vm._v(" "), (_vm.isActive) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h2', [_vm._v("Tildel årsverk")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [_c('div', {
	    staticClass: "brutto-container__body__left"
	  }, [_c('h3', [_vm._v("Arbeidsåret")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__content"
	  }, [_c('ArbeidsplanAssignHoursNormList', {
	    attrs: {
	      "isNetto": _vm.activeTab === 1,
	      "schoolYear": _vm.activeSchoolYear,
	      "theEditUserNorm": _vm.theEditUserNorm
	    },
	    on: {
	      "updated": _vm.setItemsToSave,
	      "changedSum": _vm.setNettoTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "brutto__items__item__container brutto__items__item__container__notefield"
	  }, [_c('div', {
	    staticClass: "label-with-toggle",
	    on: {
	      "click": _vm.setIsShowAgreement
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Legg til et notat til valgte personer")]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isShowAgreement
	    }
	  })], 1), _vm._v(" "), (_vm.isShowAgreement) ? _c('AppEIPWYZIWYG', {
	    attrs: {
	      "isKeepOpen": true,
	      "is-open": true,
	      "isInTestOfSaveButton": false
	    },
	    on: {
	      "changed": _vm.updateAgreements
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowAgreement) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_c('svg', {
	    staticClass: "icon-archive tw-icon",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M5.23 3h13.54a2 2 0 0 1 1.98 2.22l-1.55 14A2 2 0 0 1 17.2 21H6.79a2 2 0 0 1-1.99-1.78l-1.55-14A2 2 0 0 1 5.23 3z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M10.59 14l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 12.58l2.3-2.3a1 1 0 0 1 1.4 1.42L13.42 14l2.3 2.3a1 1 0 0 1-1.42 1.4L12 15.42l-2.3 2.3a1 1 0 1 1-1.4-1.42L10.58 14zM4 3h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5c0-1.1.9-2 2-2z"
	    }
	  })]), _vm._v("\n              Merk at hvis det allerede står noe i personens notatfelt, vil dette bli slettet.\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users"
	  }, [(_vm.tags.length > 0) ? _c('div', {
	    staticClass: "brutto__users__header"
	  }, [_c('filterTags', {
	    attrs: {
	      "users": _vm.usersSortedOnNameWithTags,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users__list__header",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUsers.length < 1) ? _c('span', [_vm._v("Velg alle")]) : _c('span', [_vm._v("Fjern valg")])]), _vm._v(" "), _c('ul', {
	    staticClass: "brutto__users__list"
	  }, _vm._l((_vm.filteredUsers), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "brutto__users__user",
	      class: {
	        'is-selected': _vm.getIsUserSelected(user)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(user.name) + "\n              "), _c('div', {
	      staticClass: "icon__bg-circle d-edit-btn",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editUserNorm(user)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isActive = false
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        onShow: function () { return _vm.selectedUsers.length < 1; }
	      }),
	      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
	    }],
	    staticClass: "bttn bttn-primary",
	    class: [{
	      'bttn-primary--disabled': _vm.selectedUsers.length < 1
	    }, {
	      'bttn--loading': _vm.isSaving
	    }],
	    attrs: {
	      "content": "Der skal vælges minimum en bruger"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = true
	      }
	    }
	  }, [_vm._v("Lagre\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isWarningActive) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "999999999"
	    },
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-warning",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-warning__header"
	  }, [_c('h2', [_vm._v("Gem og erstat?")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__body"
	  }, [_c('svg', {
	    staticClass: "tw-icon tw-icon--red",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "2",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "9",
	      "x2": "12",
	      "y2": "13"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "17",
	      "x2": "12.01",
	      "y2": "17"
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          Du er i ferd med å tildele arbeidstid på " + _vm._s(_vm.nettoTime) + " til de valgte brukerne. Hvis det allerede er tildelt arbeidstid, vil denne bli erstattet.\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = false
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary bttn-primary--small",
	    class: [{
	      'bttn--loading': _vm.isSaving
	    }],
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n          Lagre og erstatt\n        ")])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    on: {
	      "click": _vm.emitClick
	    }
	  }, [_vm._v("TEST " + _vm._s(_vm.message))])
	},staticRenderFns: []}

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "split-event"
	  }, [(_vm.showModal) ? _c('AppModal', {
	    attrs: {
	      "submitTxt": _vm.i18n[_vm.locale].btn,
	      "isShowFooter": false
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].split) + " " + _vm._s(_vm.lesson.title) + ", " + _vm._s(_vm._f("showDate")(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
	    staticClass: "form",
	    attrs: {
	      "slot": "body"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "origin-lesson"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].original_lesson))]), _vm._v(" "), _c('div', {
	    staticClass: "flex border pad-10 relative"
	  }, [_c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times"
	  }, [_c('div', [_vm._v(", kl. " + _vm._s(_vm._f("LT")(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times__seperator"
	  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("LT")(_vm.lesson.end)))])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-left"
	  }, [_vm._v("\n            (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.oldDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n          ")])])]), _vm._v(" "), _c('h3', {
	    staticClass: "marg-24-top flex align-center"
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _c('span', {
	    staticClass: "marg-5-left"
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale].when_is_the_split) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex align-center split-input-wrapper"
	  }, [_c('timeInput', {
	    staticClass: "split-lesson-input",
	    attrs: {
	      "refs": "timeinput",
	      "id": "focus",
	      "date": _vm.newLessonStart
	    },
	    on: {
	      "changed": _vm.setStartTime
	    }
	  })], 1), _vm._v(" "), _c('p', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].split_lessons) + " ")]), _vm._v(" "), _c('div', {
	    staticClass: "flex border pad-10 marg-5-bottom relative"
	  }, [_c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times"
	  }, [_c('div', [_vm._v(", " + _vm._s(_vm._f("LT")(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times__seperator"
	  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("LT")(_vm.newLessonStart)))])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-left"
	  }, [_vm._v("\n          (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.lessonDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex border pad-10 relative"
	  }, [_c('div', {
	    staticClass: "lesson__border-left",
	    staticStyle: {
	      "{borderColor": "lesson.color}"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times"
	  }, [_c('div', [_vm._v(", " + _vm._s(_vm._f("LT")(_vm.newLessonStart)))]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_times__seperator"
	  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("LT")(_vm.lesson.end)))])]), _vm._v(" "), _c('div', {
	    staticClass: "marg-10-left"
	  }, [_vm._v("\n          (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.newLessonDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n        ")])]), _vm._v(" "), _c('p', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].everything_will_be_cloned))]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer modal-footer__flex"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.submit.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-container"
	  }, [_c('div', {
	    staticClass: "modal-header",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_vm._t("header", function() {
	    return [_vm._v("default header")]
	  }), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle close-cross",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer"
	  })])], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body", function() {
	    return [_vm._v("\n          default body\n        ")]
	  })], 2), _vm._v(" "), (_vm.isShowFooter) ? _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "bttn create-btn right marg-10",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('submit')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.submitTxt) + "\n        ")])]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-teamcalendar__saved-views text-dark"
	  }, [(_vm.itemsSelected.length > 0) ? _c('button', {
	    staticClass: "bttn bttn-blue",
	    on: {
	      "click": _vm.setIsSaveModal
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['save_view']) + "\n  ")]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.savedViews).length > 0) ? _c('DDropdown', {
	    attrs: {
	      "isShowDots": false
	    }
	  }, [_c('button', {
	    staticClass: "d-teamcalendar__saved-views__title bttn-simple",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n['saved_views']) + "\n      "), _c('svg', {
	    staticClass: "w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24",
	      "fill": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
	      "clip-rule": "evenodd"
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.savedViews), function(view, prop) {
	    return _c('li', {
	      staticClass: "d-teamcalendar__saved-views__view",
	      on: {
	        "click": function($event) {
	          return _vm.selectView(view, prop)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(prop) + "\n        "), _c('div', {
	      staticClass: "icon__bg-circle icon__bg-circle--danger icon__bg-circle--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setDeleteItemConfirm(prop)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isSaveModal) ? _c('DModal', {
	    attrs: {
	      "is-bg-overlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.closeIsSaveModal
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['create_new_view']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": _vm.closeIsSaveModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['give_the_view_a_title']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "is_save_modal_input",
	    staticClass: "d-input marg-1-top",
	    attrs: {
	      "disabled": _vm.isInputTitleDisabled,
	      "placeholder": _vm.i18n['ex_title']
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.saveView.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (Object.keys(_vm.savedViews).length > 0) ? _c('div', {
	    staticClass: "d-input-group marg-2-top"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['or_overwrite_existing']))]), _vm._v(" "), _c('select', {
	    staticClass: "d-teamcalendar__saved-views__select",
	    on: {
	      "change": function($event) {
	        return _vm.setReplaceExisting($event.target.value)
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": ""
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['choose_existing']))]), _vm._v(" "), _vm._l((_vm.savedViews), function(view, prop) {
	    return _c('option', [_vm._v("\n              " + _vm._s(prop) + "\n            ")])
	  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-10-right",
	    on: {
	      "click": _vm.closeIsSaveModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), (_vm.title.length < 1) ? _c('button', {
	    staticClass: "bttn submit-button submit-button--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n        ")]) : _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.saveView
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isConfirmModal) ? _c('ModalConfirmation', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.isConfirmModal = false
	      },
	      "confirm": _vm.deleteItem
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table d-table__tasks"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'name'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('name')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.getI18n(_vm.title)) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('th', {
	    staticClass: "th-sorter",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'calendar'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('calendar')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.task_overview.belongs_to')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "th-sorter is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'actual'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortKey('actual')
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n      "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tasksGrouped), function(taskGroup) {
	    return [_c('tr', {
	      staticClass: "d-table__second-header"
	    }, [_c('th', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.getI18n(taskGroup.masterType)) + "\n      ")]), _vm._v(" "), _c('th', {
	      staticClass: "is-number"
	    }, [(_vm.isShowScheduled) ? [_vm._v(_vm._s(_vm.toFixedIfNecessary(taskGroup.sum, 2)))] : _vm._e()], 2)]), _vm._v(" "), _vm._l((taskGroup.events), function(task) {
	      return _c('tr', {
	        key: task.id,
	        attrs: {
	          "data-task-id": task.id
	        }
	      }, [_c('td', [_c('div', {
	        staticClass: "task-with-edit"
	      }, [(task.can_schedule === 't') ? _c('div', {
	        staticClass: "subjects_subject",
	        style: ({
	          'background': task.color
	        })
	      }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
	        staticClass: "subjects_subject subjects_subject--not-subject"
	      }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	        staticClass: "td-calendars"
	      }, [_vm._v("\n        " + _vm._s(task.calendar) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	        staticClass: "is-number"
	      }, [_vm._v(_vm._s(_vm.getTaskActual(task)))]) : _vm._e()])
	    })]
	  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    class: {
	      'th-sorter--active': _vm.sortKey === 'actual'
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.sumOfActual) + "\n    ")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activeAbsenceReason) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.delete_absence')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.change_start_and_end_date')))])]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body d-modal__body--edit-absence"
	  }, [_c('div', {
	    staticClass: "d-modal__body--edit-absence__header"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.showUser.default_thumb_url
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "absent-user__name"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.showUser.name))]), _vm._v(" "), _c('div', {
	    staticClass: "reason"
	  }, [_c('p', [_vm._v(_vm._s(_vm.getReasonTitle(_vm.activeAbsenceReason)) + "\n            ")]), _c('p', [(_vm.isOngoing && _vm.isAbsenceOngoing) ? _c('span', {
	    staticClass: "badge badge--orange badge--small"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))]) : _vm._e(), _vm._v(" "), (!_vm.isOngoing && _vm.getIsAbsenceMultipleDays) ? _c('span', {
	    staticClass: "badge badge--small"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.substitution_user.multiple_days')))]) : _vm._e()])]), _vm._v(" "), _c('p', [(_vm.getSerialListItem) ? _c('span', [_vm._v("\n            " + _vm._s(_vm._f("date")(_vm.getSerialListItem.from_date)) + "\n            - " + _vm._s(_vm._f("date")(_vm.getSerialListItem.to_date)) + ", " + _vm._s(_vm._f("showTime")(_vm.getSerialListItem.from_time)) + " - " + _vm._s(_vm._f("showTime")(_vm.getSerialListItem.to_time)) + "\n          ")]) : _c('span', [_vm._v("\n            " + _vm._s(_vm._f("showDate")(_vm.activeAbsenceReason.start)) + " -\n            "), _c('span', [_vm._v(_vm._s(_vm._f("showTime")(_vm.activeAbsenceReason.end)))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body--edit-absence__body"
	  }, [(!_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('div', {
	    staticClass: "d-modal__page-1"
	  }, [(_vm.reason) ? _c('div', {
	    staticClass: "d-modal__body--edit-absence__body__input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason')))]), _vm._v(" "), _c('div', {
	    staticClass: "absence-reason"
	  }, [_c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.subsAbsenceReasonsSorted,
	      "multiple": false,
	      "items-selected": _vm.reason,
	      "placeholder": _vm.$t('vue2.substitution.choose_absence_reason')
	    },
	    on: {
	      "update": _vm.setReason
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_c('h4', [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.dselect.no_matching_results')) + "\n                    ")])])])], 1)]), _vm._v(" "), (_vm.showErrors) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason_must_be_filled')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body--edit-absence__body__input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.date_label')))]), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('DatepickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.originalStart,
	      "enddate": _vm.originalEnd
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "absence-no-end-date",
	    class: [{
	      'absence-no-end-date--active': _vm.isAbsenceOngoing
	    }, {
	      'absence-no-end-date--disabled': !_vm.isOngoingAbsenceAllowed
	    }]
	  }, [(!_vm.isOngoingAbsenceAllowed) ? _c('div', {
	    staticClass: "absence-no-end-date--not-allowed"
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "absence-no-end-date__inner",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.isAbsenceOngoing = !_vm.isAbsenceOngoing
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isAbsenceOngoing
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body--edit-absence__body__input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.time')))]), _vm._v(" "), _c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.deleteAbsenceFollowingDates.length > 0) ? _c('p', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.absence_will_be_deleted')))]), _vm._v(" "), _vm._l((_vm.deleteAbsenceFollowingDates), function(date, idx) {
	    return _c('span', [(idx > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("date")(date)))])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.originalDatesNotInNewRange.length > 0) ? _c('div', {
	    staticClass: "d-modal__page-2"
	  }, [_c('SubsDeleteAbsence', {
	    attrs: {
	      "calendarId": this.activeAbsenceReason.calendar_id,
	      "firstRange": _vm.originalDatesNotInNewRangeMinimum,
	      "lastRange": _vm.originalDatesNotInNewRangeMaximum,
	      "dates": _vm.originalDatesNotInNewRange,
	      "startTime": _vm.startTime,
	      "endTime": _vm.endTime
	    },
	    on: {
	      "lessonsWithSubs": _vm.setLessonsWithSubs,
	      "gotLessons": function($event) {
	        _vm.isLessonsLoaded = true
	      },
	      "changed": _vm.setDeleteSubs
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons d-modal__body--edit-absence__actions"
	  }, [_c('div', [(!_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('button', {
	    staticClass: "bttn bttn-danger marg-5-right",
	    on: {
	      "click": function($event) {
	        return _vm.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body--edit-absence__actions__right"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.isActiveAbsenceReasonIsReadyToDelete) ? [_c('button', {
	    staticClass: "submit-button submit-button--danger",
	    on: {
	      "click": _vm.removeSubsAndDeleteAbsence
	    }
	  }, [(_vm.eventsToRemovedSubs.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.remove_subs_and_delete_absence')))]) : _vm._e(), _vm._v(" "), (_vm.lessonsWithSubs.length > 0 && _vm.eventsToRemovedSubs.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.keep_subs_and_delete_absence')))]) : _vm._e(), _vm._v(" "), (_vm.lessonsWithSubs.length < 1 && _vm.eventsToRemovedSubs.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.delete_absence')))]) : _vm._e()])] : [(_vm.originalDatesNotInNewRange.length > 0) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.removeSubsAndUpdateAbsence
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.update')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.originalDatesNotInNewRange.length < 1 && this.eventsToRemovedSubs.length < 1) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.updateDates
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.update')) + "\n            ")]) : _vm._e()]], 2)])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tags-filter text-dark",
	    class: {
	      'flex_columns': _vm.columns
	    }
	  }, [_c('div', {
	    staticClass: "tags_filter__selected"
	  }, [_c('div', {
	    staticClass: "icon-filter"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "tags_filter__selected"
	  }, [_c('ul', _vm._l((_vm.selectedTags), function(tag) {
	    return _c('li', [_c('tag', {
	      attrs: {
	        "tag": tag
	      },
	      on: {
	        "remove": _vm.removeTag
	      }
	    })], 1)
	  }), 0)])]), _vm._v(" "), (!_vm.active) ? _c('button', {
	    staticClass: "btn-trans tags-filter__header__s-btn",
	    on: {
	      "click": function($event) {
	        _vm.active = true
	      }
	    }
	  }, [_vm._v("+\n    " + _vm._s(_vm.searchText.length > 1 ? _vm.searchText : _vm.$t('vue2.tagging.search_tag')) + "\n  ")]) : _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.hideActive),
	      expression: "hideActive"
	    }],
	    staticClass: "tags-filter-wrapper"
	  }, [_c('div', {
	    staticClass: "tags-filter__header"
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tagText),
	      expression: "tagText"
	    }],
	    staticClass: "tags-filter__header__search",
	    class: {
	      'show': _vm.showDropdown
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.tagText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tagText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tags_filter__tags",
	    class: {
	      'show': _vm.showDropdown
	    }
	  }, [(!_vm.isShowNoTagsText && (_vm.tags.length === 0)) ? _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))]) : _vm._e(), _vm._v(" "), _c('h4', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.tags.length < 1 && _vm.isShowNoTagsText),
	      expression: "tags.length < 1 && isShowNoTagsText"
	    }]
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.you_have_created_zero_tags')) + "\n        "), _c('a', {
	    attrs: {
	      "href": '/schools/' + _vm.schoolid + '/groups/#/'
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.create_tags')))])]), _vm._v(" "), _c('h4', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.filteredTags.length < 1 && _vm.tags.length > 0),
	      expression: "filteredTags.length < 1 && tags.length > 0"
	    }]
	  }, [_vm._v("0 " + _vm._s(_vm.$t('vue2.tagging.with')) + " \"" + _vm._s(_vm.tagText) + "\"")]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.filteredTags.length > 0),
	      expression: "filteredTags.length > 0"
	    }]
	  }, _vm._l((_vm.notSelectedTags), function(tag) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setTag(tag)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-price-tag2"
	    }), _vm._v(" " + _vm._s(tag) + " "), (_vm.showHowMany) ? _c('span', [_vm._v("(" + _vm._s(_vm.howManyWithTag(tag)) + ")")]) : _vm._e()])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Åbningstider")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dag")]), _vm._v(" "), _c('th', [_vm._v("Åbner")]), _vm._v(" "), _c('th', [_vm._v("Lukker")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.openingHours), function(time, day) {
	    return _c('tr', {
	      key: day
	    }, [_c('td', [_vm._v(_vm._s(_vm.getDayName(day)))]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (time.open),
	        expression: "time.open"
	      }],
	      attrs: {
	        "type": "time"
	      },
	      domProps: {
	        "value": (time.open)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.formatTime(day, 'open')
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(time, "open", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (time.close),
	        expression: "time.close"
	      }],
	      attrs: {
	        "type": "time"
	      },
	      domProps: {
	        "value": (time.close)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.formatTime(day, 'close')
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(time, "close", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'right'
	        }),
	        expression: "{\n                  arrow: false,\n                  placement : 'right'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      attrs: {
	        "content": 'Slet'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deleteDay(day)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.saveOpeningHours
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "day-select__container"
	  }, [_c('ul', {
	    staticClass: "flex-1 weekdays"
	  }, _vm._l((7), function(n) {
	    return _c('li', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.day(n))))])
	  }), 0), _vm._v(" "), _c('ul', {
	    staticClass: "flex flex-1",
	    attrs: {
	      "id": "select_day"
	    }
	  }, [_c('li', {
	    class: {
	      'isToday': _vm.isToday(_vm.date)
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setDay(1)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isMon ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm._f("D")(_vm._f("dayOfWeek")(_vm.date, 1))))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setDay(2)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isTue ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm._f("D")(_vm._f("dayOfWeek")(_vm.date, 2))))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setDay(3)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isWed ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm._f("D")(_vm._f("dayOfWeek")(_vm.date, 3))))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setDay(4)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isTur ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm._f("D")(_vm._f("dayOfWeek")(_vm.date, 4))))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setDay(5)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isFri ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm._f("D")(_vm._f("dayOfWeek")(_vm.date, 5))))])]), _vm._v(" "), (_vm.weekends) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setDay(6)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isSat ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm._f("D")(_vm._f("dayOfWeek")(_vm.date, 6))))])]) : _vm._e(), _vm._v(" "), (_vm.weekends) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setDay(7)
	      }
	    }
	  }, [_c('div', {
	    class: [_vm.isSun ? 'active' : '']
	  }, [_vm._v(_vm._s(_vm._f("D")(_vm._f("dayOfWeek")(_vm.date, 7))))])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.clickaway),
	      expression: "clickaway"
	    }],
	    staticClass: "no-print"
	  }, [_c('div', {
	    staticClass: "sidebar-nav"
	  }, [_c('div', {
	    staticClass: "nav"
	  }, [(_vm.userHasPermission('can_see_other_calendars') || (_vm.userHasMultipleSchools && !_vm.userHasPermission('can_see_other_calendars'))) ? _c('div', {
	    staticClass: "docendo-logo box-shadow"
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.open === false),
	      expression: "open === false"
	    }],
	    staticClass: "docendo-logo__icon icon-docendo",
	    on: {
	      "click": function($event) {
	        return _vm.openSideNav(0)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.open === true),
	      expression: "open === true"
	    }],
	    staticClass: "icon-cross2 font-large",
	    staticStyle: {
	      "padding": "18px"
	    },
	    on: {
	      "click": _vm.closeSideNav
	    }
	  })]) : _vm._e(), _vm._v(" "), (!_vm.userHasPermission('can_see_other_calendars') && !_vm.userHasMultipleSchools) ? _c('div', {
	    staticClass: "docendo-logo docendo-logo__not-active box-shadow"
	  }, [_c('span', {
	    staticClass: "docendo-logo__icon icon-docendo"
	  })]) : _vm._e(), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars') && _vm.activeSchool) ? _c('ul', {
	    on: {
	      "click": _vm.openSideNav
	    }
	  }, [(_vm.isKindergarten) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.goToDutySchedule.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-users5 gtm",
	    attrs: {
	      "data-gtm": "SideNav__club"
	    }
	  }), _vm._v("\n          Vagtplan\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isKindergarten) ? _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__kindergarten gtm",
	    class: {
	      active: _vm.isActive(7)
	    },
	    attrs: {
	      "data-gtm": "SideNav__club"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(7)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-users5 gtm",
	    attrs: {
	      "data-gtm": "SideNav__club"
	    }
	  }), _vm._v("\n          Stuer\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isKindergarten) ? _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__klass gtm test-2",
	    class: {
	      active: _vm.isActive(1)
	    },
	    attrs: {
	      "data-gtm": "SideNav__klass"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(1)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-calendar4 gtm",
	    attrs: {
	      "data-gtm": "SideNav__klass"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.classes_sidenav')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__users gtm",
	    class: {
	      active: _vm.isActive(2)
	    },
	    attrs: {
	      "data-gtm": "SideNav__users"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(2)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-users gtm",
	    attrs: {
	      "data-gtm": "SideNav__users"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.users')) + "\n        ")]), _vm._v(" "), _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__location gtm",
	    class: {
	      active: _vm.isActive(3)
	    },
	    attrs: {
	      "data-gtm": "SideNav__location"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(3)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-location gtm",
	    attrs: {
	      "data-gtm": "SideNav__location"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.rooms')) + "\n        ")]), _vm._v(" "), (!_vm.isKindergarten) ? _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__merge gtm",
	    class: {
	      active: _vm.isActive(4)
	    },
	    attrs: {
	      "data-gtm": "SideNav__merge"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(4)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-calendar-week gtm",
	    attrs: {
	      "data-gtm": "SideNav__merge"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.merge_calendars_sidenav')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__other gtm",
	    class: {
	      active: _vm.isActive(5)
	    },
	    attrs: {
	      "data-gtm": "SideNav__other"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(5)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-clipboard2 gtm",
	    attrs: {
	      "data-gtm": "SideNav__other"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.other_calendars')) + "\n        ")]), _vm._v(" "), (_vm.isSchoolSFOActive && !_vm.isKindergarten) ? _c('li', {
	    staticClass: "js-intro js-intro-sidebar-nav__club gtm",
	    class: {
	      active: _vm.isActive(6)
	    },
	    attrs: {
	      "data-gtm": "SideNav__club"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseCals(6)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icons icon-users5 gtm",
	    attrs: {
	      "data-gtm": "SideNav__club"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.club.club')) + "\n        ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "sidebar-nav__container",
	    class: [{
	      sidebar_nav_container_show: _vm.open
	    }]
	  }, [_c('div', {
	    staticClass: "sidebar-nav__container__header box-shadow flex"
	  }, [_c('div', {
	    staticClass: "flex flex-vertical-center",
	    staticStyle: {
	      "width": "85%"
	    }
	  }, [_c('h2', [(_vm.activeSchool) ? _c('a', {
	    staticClass: "link-white",
	    attrs: {
	      "href": '/schools/' + _vm.activeSchool.id
	    }
	  }, [_vm._v(_vm._s(_vm.activeSchool.name))]) : _vm._e()])]), _vm._v(" "), _c('span', {
	    staticClass: "icon-arrow-down5 arrow-dropdown",
	    class: {
	      active: _vm.changeSchoolDropdown
	    },
	    on: {
	      "click": _vm.toggleChangeSchoolDropdown
	    }
	  }), _vm._v(" "), (_vm.changeSchoolDropdown) ? _c('div', {
	    staticClass: "sidebar-nav__container--dropdown bg-light-blue box-shadow pos-absolute z-index-1000 text-white width-100 box-sizing"
	  }, [_c('list-with-search', {
	    attrs: {
	      "selected": _vm.activeSchool,
	      "options": _vm.allSchools
	    },
	    on: {
	      "choose": _vm.toggleChangeSchoolDropdown
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (!_vm.isLoading && _vm.yearCals.length < 1) ? [_c('div', {
	    staticClass: "no-cals"
	  }, [_c('div', {
	    staticClass: "no-cals__icon"
	  }, [_c('span', {
	    class: _vm.activeType.icon
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "no-cals__text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.notCreatedAnyTextString)
	    }
	  })])] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "create-link__container"
	  }, [(_vm.isActive(1) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
	    staticClass: "create-cal__button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createKlasses.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 1 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(2) && _vm.userHasPermission('can_manage_users')) ? _c('a', {
	    staticClass: "create-cal__button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createUsers.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 2 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(3) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
	    staticClass: "create-cal__button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      }
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 3 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(4) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
	    staticClass: "create-cal__button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      }
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 4 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.isActive(5) || _vm.isActive(6) || _vm.isActive(7)) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
	    staticClass: "create-cal__button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createCalendars(_vm.activeType.type)
	      }
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
	    staticClass: "lowercase"
	  }, [_vm._v(_vm._s(_vm.activeType.title))])]) : _vm._e()]), _vm._v(" "), (_vm.activeType.hasSchoolYear) ? _c('ChangeSchoolYear', {
	    staticStyle: {
	      "margin": "10px 15px 0"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.yearCals.length > 0) ? _c('div', {
	    staticClass: "sidebar-nav__search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "searchfield",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.common.search_for') + ' ' + _vm.searchName,
	      "id": "searchfield"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.search !== ''),
	      expression: "search !== ''"
	    }],
	    staticClass: "sidebar-nav__search__cross pointer icon-cross2",
	    on: {
	      "click": _vm.clearSearch
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars')) ? _c('div', {
	    staticClass: "sidebar-nav__container__body"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticStyle: {
	      "margin-top": "100px"
	    }
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#3e4450"
	    }
	  })], 1) : [_c('ul', {
	    staticClass: "nav__cal-list"
	  }, _vm._l((_vm.searchCals), function(cal) {
	    return _c('li', {
	      key: cal.id
	    }, [(cal.type !== 'klass') ? [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
	      attrs: {
	        "href": cal.url
	      }
	    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]) : _c('a', {
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.setActiveCalendarId(cal.id)
	        }
	      }
	    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))])] : _vm._e(), _vm._v(" "), (cal.type === 'klass') ? _c('div', {
	      staticClass: "nav__cal-list__item",
	      class: {
	        'nav__cal-list__item--open': _vm.isStudentsActiveForCal(cal.id)
	      }
	    }, [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
	      attrs: {
	        "href": cal.url
	      }
	    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]) : _c('a', {
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.setActiveCalendarId(cal.id)
	        }
	      }
	    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]), _vm._v(" "), (cal.students && cal.students.length > 0) ? _c('div', {
	      on: {
	        "click": function($event) {
	          return _vm.setTheStudentsActiveForCal(cal.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-arrow-down52"
	    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isStudentsActiveForCal(cal.id)) ? _c('ul', {
	      staticClass: "nav__cal-list__item__students"
	    }, _vm._l((_vm.getCalStudents(cal.students)), function(student) {
	      return _c('li', [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
	        attrs: {
	          "href": student.url
	        }
	      }, [_vm._v(_vm._s(student.name ? student.name : student.url))]) : _c('a', {
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.setActiveCalendarId(student.id)
	          }
	        }
	      }, [_vm._v(_vm._s(student.name ? student.name : student.url))])])
	    }), 0) : _vm._e()], 2)
	  }), 0)]], 2) : _vm._e()], 2), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars') && _vm.activeSchool) ? _c('TeamCalendar') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "create-subject"
	  }, [(!_vm.isHideCreateButton) ? _c('button', {
	    staticClass: "width-100",
	    class: [{
	      'do-bttn': _vm.isInDCalendar
	    }, {
	      'bttn': !_vm.isInDCalendar
	    }],
	    on: {
	      "click": function($event) {
	        _vm.isSubjectModal = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.create_subject.create_subject')) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isSubjectModal) ? _c('CreateSubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "initCalendarId": _vm.calendarId,
	      "editSubject": _vm.editSubject,
	      "editSubjectId": _vm.editSubjectId,
	      "isInDCalendar": _vm.isInDCalendar
	    },
	    on: {
	      "close": _vm.closeModal,
	      "setTheEditSubject": _vm.setTheEditSubject,
	      "createSubject": _vm.createNewSubject,
	      "updateSubject": _vm.updateSubject,
	      "deleteSubject": _vm.deleteSubject
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-subs"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeOut"
	    }
	  }, [(_vm.isInitialLoading) ? _c('DoSplash', {
	    key: "initial-splash"
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-subs__header"
	  }, [_c('div', {
	    staticClass: "do-subs__header__div"
	  }, [_c('h1', [_vm._v("Vikardækning")]), _vm._v(" "), _c('DoChangeDayNav', {
	    attrs: {
	      "date": _vm.date
	    },
	    on: {
	      "today": function($event) {
	        return _vm.setDate('today')
	      },
	      "prev": function($event) {
	        return _vm.setDate('prev')
	      },
	      "next": function($event) {
	        return _vm.setDate('next')
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormatted))]), _vm._v(" "), (_vm.isLoadingEvents) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-subs__header__div"
	  }, [_c('label', [_vm._v("Antal fraværende: " + _vm._s(_vm.absentUsers.length))])])]), _vm._v(" "), _c('div', {
	    staticClass: "do-subs__body"
	  }, [_c('Scheduler', {
	    attrs: {
	      "events": _vm.events,
	      "klassCalendars": _vm.klassCalendars,
	      "userCalendars": _vm.userCalendars,
	      "allCalendarsInHash": _vm.allCalendarsInHash
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeDropdown),
	      expression: "closeDropdown"
	    }],
	    staticClass: "copy-calendars text-dark"
	  }, [_c('button', {
	    ref: "copy_calendars_button",
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.openDropdown.apply(null, arguments)
	      }
	    }
	  }, [_vm._t("copy-button-title", function() {
	    return [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.copy')))]
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-arrow-down5 marg-5-left"
	  })], 2), _vm._v(" "), (_vm.isDropdown) ? _c('div', {
	    ref: "copy_calendars_panel",
	    staticClass: "copy-calendars__ref"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "copy-calendars__panel"
	  }, [_c('h3', {
	    style: ({
	      'backgroundColor': '#468ad7'
	    })
	  }, [(!_vm.copyDate) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.select_week_to_copy_from')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.select_weeks_that_week')) + " " + _vm._s(_vm.showWeek(_vm.copyDate)) + " " + _vm._s(_vm.$t('vue2.calendars.must_be_copied_to')))])]), _vm._v(" "), _c('div', {
	    staticClass: "copy-calendars__panel__container"
	  }, [_c('div', {
	    staticClass: "weeks-container"
	  }, [_c('ul', {
	    staticClass: "weeks"
	  }, [(_vm.weeks.length < 1) ? [_c('Spinner', {
	    staticStyle: {
	      "margin-bottom": "100px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  })] : _vm._l((_vm.weeks), function(week) {
	    return _c('li', {
	      key: week.serverDate,
	      staticClass: "weeks__week hint--top",
	      class: [{
	        'weeks__week--is-selected': _vm.isWeekSelected(week)
	      }, {
	        'weeks__week--is-copy-week': _vm.isCopyWeek(week)
	      }],
	      attrs: {
	        "aria-label": _vm.tooltipDate(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setSelectedWeek(week)
	        }
	      }
	    }, [_vm._v("\n                  " + _vm._s(_vm.showWeek(week.date)) + "\n                  "), (_vm.isNow(week)) ? _c('span', {
	      staticClass: "weeks__week__now-indicator"
	    }) : _vm._e()])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "copy-calendars__panel__sidebar"
	  }, [_c('transition', {
	    attrs: {
	      "name": "slide-fade",
	      "mode": "out-in"
	    }
	  }, [(!_vm.copyDate) ? _c('div', {
	    key: "1",
	    staticClass: "text-explainer"
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.calendars.select_week_to_copy_from')) + "\n              ")]) : _c('div', {
	    key: "2"
	  }, [_c('h4', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + " " + _vm._s(_vm.showWeek(_vm.copyDate)))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.addAllWeeksOnward
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.selectOddWeeks
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.selectEvenWeeks
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn btn-trans width-100 btn-remove",
	    on: {
	      "click": _vm.removeAllSelectedWeeks
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n                ")])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "copy-calendars__panel__footer"
	  }, [_c('div', {
	    staticClass: "delete-option"
	  }, [_c('label', {
	    attrs: {
	      "for": "checkbox"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.deleteLessonsInSelectedWeeks')))]), _vm._v(" "), (_vm.calType === 'user') ? _c('span', [_vm._v(" (" + _vm._s(_vm.$t('vue2.copycalendar.absenceWillNotBeDeleted')) + ")")]) : _vm._e()]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isDeleteEvents),
	      expression: "isDeleteEvents"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isDeleteEvents) ? _vm._i(_vm.isDeleteEvents, null) > -1 : (_vm.isDeleteEvents)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isDeleteEvents,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isDeleteEvents = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isDeleteEvents = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isDeleteEvents = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), (_vm.selectedWeeks.length < 1) ? _c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')) + "\n          ")]) : _c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')))])])]) : _vm._e()])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.userId) ? _c('modal', {
	    attrs: {
	      "closeCrossColor": "#ccc"
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "events__modal text-dark",
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "events__modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('h3', [(_vm.eventsFilter === 'absence') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.absence')))]) : _vm._e(), _vm._v(" "), (_vm.eventsFilter === 'subject') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.teaching')))]) : _vm._e(), (_vm.eventsFilter === 'substituteHours') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.substitute_hours')))]) : _vm._e(), _vm._v("  " + _vm._s(_vm.$t('vue2.user_event_list.from')) + " " + _vm._s(_vm._f("LL")(_vm.start)) + " " + _vm._s(_vm.$t('vue2.user_event_list.to')) + " " + _vm._s(_vm._f("LL")(_vm.end)))])]), _vm._v(" "), _c('div', {
	    staticClass: "events__modal__body"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : [(_vm.filteredEvents.length < 1) ? _c('h4', {
	    staticClass: "text--explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.no_matching_events')))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "events__list"
	  }, [_vm._l((_vm.sortedEvents), function(event) {
	    return _c('li', {
	      key: event.event_id
	    }, [_c('p', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("ddd")(event.start_time))) + " " + _vm._s(_vm._f("LL")(event.start_time)) + " kl. " + _vm._s(_vm._f("LT")(event.start_time)) + " -\n              " + _vm._s(_vm._f("LT")(event.end_time)) + ", " + _vm._s(event.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDuration(event)))])])
	  }), _vm._v(" "), _c('li', [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.total')))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.totalDuration))])])], 2)]], 2), _vm._v(" "), _c('div', {
	    staticClass: "events__modal__footer"
	  }, [_c('button', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.close')))])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "12312312312312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(_vm.isCreateNewEmploymentTitle) ? [_vm._v("Tilføj ny ansættelse")] : [_vm._v("Er det til vikarer?")]], 2), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isCreateNewEmploymentTitle) ? _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "title_input",
	    staticClass: "d-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('label', {
	    staticClass: "d-label",
	    staticStyle: {
	      "margin": "0 1rem"
	    }
	  }, [_vm._v("Skal personale med denne ansættelse inkluderes i\n        vikarlønindberetningen?")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group d-input-group--toggler",
	    class: {
	      'd-input-group--toggler--active': _vm.isManualSalary
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.$emit('setIsManualSalary', !_vm.isManualSalary)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Skal indberettes som vikarløn\n        ")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isManualSalary
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValid) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v("\n          Tilføj til " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.selectedUsers.length === 1 ? 'person' : 'personer') + "\n        ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v("\n          Tilføj til " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.selectedUsers.length === 1 ? 'person' : 'personer') + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar text-dark",
	    class: {
	      'd-modal__d-calendar--with-actions': _vm.isShowActions
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar__header text-dark"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.calendar.name))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__d-calendar__content"
	  }, [_c('div', {
	    staticClass: "d-modal__d-calendar__container"
	  }, [_c('DCalendar', {
	    attrs: {
	      "calendarId": _vm.calendar.id,
	      "isShowWeek": false,
	      "date": _vm.date,
	      "events": _vm.events,
	      "isLoadingEvents": _vm.isEventsLoading
	    }
	  })], 1), _vm._v(" "), (_vm.isShowActions) ? _c('CalendarViewDayRemoveOrReplace', {
	    attrs: {
	      "event": _vm.event,
	      "calendar": _vm.calendar,
	      "calendars": _vm.calendars
	    },
	    on: {
	      "updateAndClose": function($event) {
	        return _vm.$emit('updateAndClose')
	      }
	    }
	  }) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "collisions shadow text-dark"
	  }, [_c('div', {
	    staticClass: "collisions__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['double_bookings']) + ", " + _vm._s(_vm.formattedDate))]), _vm._v(" "), _c('div', {
	    staticClass: "collisions__date-changer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('prevDay')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  })]), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.$emit('nextDay')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  })])])]), _vm._v(" "), _c('ul', {
	    staticClass: "collisions__content"
	  }, [_c('li', {
	    staticClass: "collisions__lesson collisions__lesson__header"
	  }, [_c('div', [_vm._v(_vm._s(_vm.collisions.length) + " "), (_vm.collisions.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['double_booking']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['double_bookings']))])])]), _vm._v(" "), (_vm.isLoading) ? _c('li', {
	    staticClass: "collisions__loader"
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsWithOverlappingEvents.length < 1) ? _c('li', {
	    staticClass: "collisions__lesson text-explainer"
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['no_double_bookings']) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsWithOverlappingEvents), function(event) {
	    return _c('li', {
	      key: event.event_id,
	      staticClass: "collisions__lesson",
	      style: ({
	        'border-left-color': event.color
	      }),
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.activeEvent = event
	        }
	      }
	    }, [_c('div', [_vm._v("\n        " + _vm._s(event.v_start) + " - " + _vm._s(event.v_end) + " | "), _c('b', [_vm._v(_vm._s(event.title))]), _vm._v(", "), _c('i', [_vm._v(_vm._s(event.v_owner_calendar_name))])]), _vm._v(" "), _c('div', {
	      staticClass: "overlapping-calendars"
	    }, [_vm._l((event.v_overlapping_cals_with_events), function(overlappingCalendar) {
	      return (overlappingCalendar.idx < 3) ? _c('div', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            zIndex: '999999992',
	            boundary: 'window'
	          }),
	          expression: "{\n               arrow: true,\n               zIndex: '999999992',\n               boundary: 'window'}"
	        }],
	        key: overlappingCalendar.calendar.id,
	        staticClass: "overlapping-calendar shadow",
	        attrs: {
	          "content": overlappingCalendar.lessons.map(function (overlappingCalendarEvent) { return overlappingCalendarEvent.v_event_title; })
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            _vm.activeCalendar = overlappingCalendar.calendar
	          }
	        }
	      }, [_c('span', {
	        staticClass: "icon-warning"
	      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(overlappingCalendar.calendar.name ? overlappingCalendar.calendar.name : ''))])]) : _vm._e()
	    }), _vm._v(" "), (event.v_number_of_overlapping_events > 3) ? _c('div', [_vm._v("\n          + " + _vm._s(event.v_number_of_overlapping_events - 3) + " " + _vm._s(_vm.i18n[_vm.locale]['more']) + "\n        ")]) : _vm._e()], 2)])
	  })], 2), _vm._v(" "), (_vm.activeCalendar) ? _c('CalendarViewDay', {
	    attrs: {
	      "date": _vm.date,
	      "calendar": _vm.activeCalendar
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeCalendar = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "event": _vm.activeEvent,
	      "initCalendarId": _vm.activeEvent.calendar_id,
	      "showSettings": false
	    },
	    on: {
	      "updated": _vm.readCollisions,
	      "close": _vm.closeShowEvent
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-settings-users"
	  }, [(_vm.isSalaryIntegrationActive) ? _c('SalarySettingsUsersOpus', {
	    attrs: {
	      "users": _vm.usersWithEmployments,
	      "tags": _vm.tags,
	      "employments": _vm.employments,
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "setTheEditUser": _vm.setTheEditUser,
	      "editEmployment": _vm.setTheEditUserEmployment
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isSalaryIntegrationActive) ? [_c('div', {
	    staticClass: "do-table__filters"
	  }, [_c('div', {
	    staticClass: "do-table__filters__left"
	  }, [_c('TaggingFilter', {
	    attrs: {
	      "schoolid": _vm.schoolId,
	      "showHowMany": false,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-table__filters__add"
	  }, [_c('span', [_vm._v(_vm._s(_vm.selectedUsers.length) + " af " + _vm._s(_vm.filteredUsers.length))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickAway),
	      expression: "onClickAway"
	    }],
	    staticClass: "do-dropdown",
	    class: {
	      'do-dropdown--open': _vm.isDropdown
	    }
	  }, [(_vm.selectedUsers.length < 1) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'left',
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n                  placement: 'left',\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n              }"
	    }],
	    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit do-bttn--submit--disabled",
	    attrs: {
	      "content": "Vælg personale først"
	    }
	  }, [_vm._v("\n            Tilføj ansættelser "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]) : _c('button', {
	    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.setIsDropdown
	    }
	  }, [_vm._v("\n            Tilføj ansættelser "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "do-dropdown"
	    }
	  }, [(_vm.isDropdown) ? _c('div', {
	    staticClass: "do-dropdown__dropdown"
	  }, [_c('ul', [_vm._l((_vm.employmentsTypesForDropdown), function(employmentType) {
	    return _c('li', {
	      staticClass: "do-dropdown__dropdown__item",
	      class: {
	        'do-dropdown__dropdown__item--active': employmentType.v_isSelected
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectedEmploymentsType(employmentType.v_title)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "do-dropdown__dropdown__item__name"
	    }, [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n                    " + _vm._s(employmentType.v_title) + "\n                  ")]), _vm._v(" "), (employmentType.v_isSelected) ? _c('div', {
	      staticClass: "icon__checkmark"
	    }, [_c('span', {
	      staticClass: "icon-checkmark-circle"
	    })]) : _vm._e()])
	  }), _vm._v(" "), _c('li', {
	    staticClass: "do-dropdown__dropdown__item do-dropdown__dropdown__item--add",
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateNewEmploymentTitle(true)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "btn-trans"
	  }, [_vm._v("\n                    Opret ny ansættelsestitel\n                  ")])])], 2), _vm._v(" "), _c('div', {
	    staticClass: "do-dropdown__dropdown__buttons"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function () { return _vm.selectedEmployments.length < 1 || _vm.selectedUsers.length < 1; }
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => selectedEmployments.length < 1 || selectedUsers.length < 1\n            }"
	    }],
	    staticClass: "do-bttn do-bttn--submit",
	    class: [{
	      'do-bttn--submit--disabled': _vm.selectedEmployments.length < 1 || _vm.selectedUsers.length < 1
	    }, {
	      'do-bttn--submit--loading': _vm.isSubmittingUsers
	    }],
	    attrs: {
	      "content": "Vælg personer og ansættelser først"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsAddExistingEmploymentsToUsers(true)
	      }
	    }
	  }, [_vm._v("\n                  Gem\n                ")])])]) : _vm._e()])], 1)])]), _vm._v(" "), _c('table', {
	    staticClass: "do-table do-table__user-employments"
	  }, [_c('thead', [_c('th', {
	    staticClass: "do-table__toggle-all",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUsers.length === 0) ? [_vm._v("\n          " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n        ")] : [_vm._v("\n          " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n        ")]], 2), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v("Organisation")]), _vm._v(" "), _c('th', [_vm._v("Vikarløn")])]), _vm._v(" "), _c('tbody', {
	    ref: "d-b"
	  }, _vm._l((_vm.filteredUsers), function(user) {
	    return _c('tr', {
	      key: user.id,
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user)
	        }
	      }
	    }, [_c('td', [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': user.v_isSelected
	      }
	    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
	      staticClass: "d-tags"
	    }, [_vm._l((user.v_employments), function(employment) {
	      return _c('div', {
	        staticClass: "d-tag",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.setTheEditUserEmployment({
	              user: user,
	              employment: employment
	            })
	          }
	        }
	      }, [_vm._v("\n            " + _vm._s(employment.title) + "\n            "), (employment.manual_salary) ? _c('div', {
	        staticClass: "do-pill do-pill--small do-pill--yellow"
	      }, [_vm._v("Vikarløn")]) : _vm._e()])
	    }), _vm._v(" "), (user.v_employments.length === 0) ? _c('p', {
	      staticClass: "italic font-small"
	    }, [_vm._v("Ingen ansættelser")]) : _vm._e()], 2), _vm._v(" "), _c('td', [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	      }],
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "content": "Redigér ansættelser"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheEditUser(user)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })])])])
	  }), 0)])] : _vm._e(), _vm._v(" "), (_vm.theEditUser) ? _c('SalarySettingsUsersUser', {
	    attrs: {
	      "user": _vm.theEditUser,
	      "theEditEmployment": _vm.theEditUserEmployment,
	      "school": _vm.school,
	      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setTheEditUser(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isAddEmploymentModal) ? _c('SalarySettingsCreateEmploymentType', {
	    attrs: {
	      "selectedUsers": _vm.selectedUsers,
	      "isManualSalary": _vm.isManualSalary,
	      "isCreateNewEmploymentTitle": _vm.isCreateNewEmploymentTitle
	    },
	    on: {
	      "setIsManualSalary": _vm.setIsManualSalary,
	      "save": _vm.saveForUsers,
	      "close": function($event) {
	        return _vm.setIsAddExistingEmploymentsToUsers(false)
	      }
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.userSchoolsSorted.length > 1) ? _c('div', {
	    staticClass: "school-selector text-dark"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 8]
	    },
	    scopedSlots: _vm._u([{
	      key: "title",
	      fn: function() {
	        return [_c('button', {
	          staticClass: "do-bttn do-bttn--with-icon"
	        }, [_vm._v("\n        " + _vm._s(_vm.selectedTitle) + "\n        "), _c('svg', {
	          staticClass: "tw-icon tw-icon-cheveron-selection",
	          attrs: {
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 24 24"
	          }
	        }, [_c('path', {
	          staticClass: "secondary",
	          attrs: {
	            "fill-rule": "evenodd",
	            "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	          }
	        })])])]
	      },
	      proxy: true
	    }, {
	      key: "list",
	      fn: function() {
	        return [_c('ul', {
	          staticClass: "school-selector__list text-dark",
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	            }
	          }
	        }, _vm._l((_vm.userSchoolsSorted), function(school) {
	          return _c('li', {
	            key: school.id,
	            staticClass: "school-selector__list__item",
	            class: {
	              'school-selector__list__item--disabled': school.v_has_permission
	            },
	            on: {
	              "click": function($event) {
	                return _vm.toggleSchool(school)
	              }
	            }
	          }, [_vm._v("\n          " + _vm._s(school.name) + "\n          "), (school.v_is_selected) ? _c('svg', {
	            staticClass: "tw-icon icon-check",
	            attrs: {
	              "xmlns": "http://www.w3.org/2000/svg",
	              "viewBox": "0 0 24 24"
	            }
	          }, [_c('circle', {
	            staticClass: "primary",
	            attrs: {
	              "cx": "12",
	              "cy": "12",
	              "r": "10"
	            }
	          }), _vm._v(" "), _c('path', {
	            staticClass: "secondary",
	            attrs: {
	              "d": "M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z"
	            }
	          })]) : _vm._e()])
	        }), 0)]
	      },
	      proxy: true
	    }], null, false, 1138270715)
	  })], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "log-deleted-events text-dark"
	  }, [_c('h2', {
	    staticClass: "marg-5-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.deleted_log')) + " \"" + _vm._s(_vm.subject.name) + "\"")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _c('div', [(_vm.sortedLog.length < 1) ? _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.no_lessons_deleted')))]) : _vm._e(), _vm._v(" "), (_vm.sortedLog.length > 0) ? _c('ul', {
	    staticClass: "log-deleted-events__list"
	  }, [_c('li', {
	    staticClass: "log-deleted-events__event log-deleted-events__event__header"
	  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.lesson')))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.deleted')))])])]), _vm._v(" "), _vm._l((_vm.sortedLog), function(logEvent) {
	    return _c('li', {
	      key: logEvent.id,
	      staticClass: "log-deleted-events__event"
	    }, [_c('div', {
	      staticClass: "log-deleted-events__event__event-datetime subject-event",
	      style: ({
	        'backgroundColor': _vm.subject.color
	      })
	    }, [_vm._v("\n          " + _vm._s(logEvent.v_eventDate) + "\n        ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n          arrow: true,\n          placement : 'top'\n                }"
	      }],
	      staticClass: "text-greyed",
	      attrs: {
	        "content": logEvent.v_formattedDate
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin text-greyed"
	    }), _vm._v("\n          " + _vm._s(logEvent.name) + " -\n          " + _vm._s(logEvent.v_humanizedDate) + " " + _vm._s(_vm.$t('vue2.common.ago')) + "\n        ")])])
	  })], 2) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-print text-dark"
	  }, [_c('div', {
	    staticClass: "d-print__container no-print"
	  }, [_c('button', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    staticClass: "d-print__button",
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    attrs: {
	      "slot": "title"
	    },
	    on: {
	      "click": _vm.setIsDropdown
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isDropdown) ? _c('div', {
	    staticClass: "d-print__container__dropdown"
	  }, [_c('ul', [_c('li', {
	    on: {
	      "click": _vm.printThis
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.this_calendar')))]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.selectType({
	          type: 'multiple_calendars'
	        })
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.print_all_calendars.custom')) + "\n          ")]), _vm._v(" "), _vm._l((_vm.calendarTypes), function(type) {
	    return _c('li', {
	      key: type.type,
	      on: {
	        "click": function($event) {
	          return _vm.selectType(type)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(type.title) + "\n          ")])
	  })], 2)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
	    staticClass: "print-all text-dark"
	  }, [(_vm.isShowModal) ? _c('d-modal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "print-all-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "print-calendars__header border-1-bottom"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.only_printing_calendars_with_lessons')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": _vm.setIsShowModalFalse
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "print-all-modal__body"
	  }, [_c('div', [_c('PrintCalendars', {
	    attrs: {
	      "showDSelect": _vm.printCalendarType === 'multiple_calendars',
	      "calendarIds": _vm.calendarIds,
	      "start-date": _vm.startDate,
	      "end-date": _vm.endDate,
	      "date": _vm.date,
	      "firstDayOfWeek": _vm.firstDayOfWeek
	    },
	    on: {
	      "updateCalendars": function($event) {
	        return _vm.updateSelectedCalendar($event)
	      },
	      "clear": _vm.clearSelectedCalendars
	    }
	  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isShowModal) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": _vm.setIsShowModalFalse
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "pricing-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "pricing-container__right"
	  }, [_c('h2', [_vm._v("En stærk samlet pakke til jeres skole")]), _vm._v(" "), _c('ul', {
	    staticClass: "pricing-features"
	  }, [_vm._l((_vm.features), function(feature) {
	    return _c('li', [_c('span', {
	      staticClass: "icon-checkmark4 color-blue"
	    }), _vm._v(" " + _vm._s(feature))])
	  }), _vm._v(" "), _c('li', [_vm._v("... og meget mere")])], 2), _vm._v(" "), _c('h4', [_vm._v("Betaling hver måned eller årligt")]), _vm._v(" "), _c('p', [_vm._v("I bestemmer selv, om I vil faktureres hver måned eller hvert år")]), _vm._v(" "), _c('h4', [_vm._v("Prøv gratis i 30 dage")]), _vm._v(" "), _c('p', [_vm._v("Du kan prøve Docendo i 30 dage helt gratis. Du binder dig ikke til at købe systemet, og vi beder ikke\n        om dine kontooplysninger.\n        Efter 30 dage bestemmer du selv, om du vil fortsætte med Docendo.\n      ")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pricing-container__left"
	  }, [_c('div', {
	    staticClass: "pricing-box"
	  }, [_c('h2', [_vm._v("Skolens samlede elevtal")]), _vm._v(" "), _c('p', [_vm._v("Betal for skolens samlede elevtal - og få et ubegrænset antal brugere på")]), _vm._v(" "), _c('h3', [_vm._v("5"), _c('span', {
	    staticClass: "text-grey",
	    staticStyle: {
	      "font-size": "16px"
	    }
	  }, [_vm._v("kr")])]), _vm._v(" "), _c('p', [_vm._v("pr. elev / måned\n          ")]), _c('p', [_vm._v("+ 499 kr pr. måned i licens pr. institution"), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "font-small"
	  }, [_vm._v("Alle priser er eksklusiv moms")])]), _vm._v(" "), _c('p')])])
	}]}

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "do-table do-table__user-employments",
	    class: {
	      'do-table__user-employments--import': _vm.isSalaryIntegrationActive
	    }
	  }, [_c('thead', [(!_vm.isSalaryIntegrationActive) ? _c('th', {
	    staticClass: "do-table__toggle-all",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUsers.length === 0) ? [_vm._v("\n      " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n    ")] : [_vm._v("\n      " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n    ")]], 2) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v("Organisation")]), _vm._v(" "), _c('th', [_vm._v("Vikarløn")])]), _vm._v(" "), _c('tbody', {
	    ref: "d-b"
	  }, [_vm._l((_vm.filteredUsers), function(user) {
	    return (_vm.isSalaryIntegrationActive) ? [_c('tbody', {
	      key: 'user-' + user.id,
	      staticClass: "user-group"
	    }, [_vm._l((user.v_employments), function(employment, key) {
	      return _c('tr', {
	        key: 'employment-' + employment.id,
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.setTheEditUser(user)
	          }
	        }
	      }, [_c('td', [(key === 0) ? [_c('strong', [_vm._v(_vm._s(user.name))])] : _vm._e()], 2), _vm._v(" "), _c('td', [_c('span', {
	        staticClass: "d-tag d-tag--inline",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.$emit('editEmployment', {
	              user: user,
	              employment: employment
	            })
	          }
	        }
	      }, [_vm._v(_vm._s(employment.title))])]), _vm._v(" "), _c('td', {
	        staticClass: "td-organisation"
	      }, [_vm._v(_vm._s(employment.organisation))]), _vm._v(" "), (_vm.isSalaryIntegrationActive && (!employment.default_loebenummer || !employment.default_loenart)) ? _c('td', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            placement: 'left',
	            arrow: true,
	            animateFill: false,
	            animation: 'shift-away',
	            zIndex: '999999992',
	            boundary: 'window',
	            onShow: function () { return !employment.default_loebenummer || !employment.default_loenart; }
	          }),
	          expression: "{\n        placement: 'left',\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !employment.default_loebenummer || !employment.default_loenart\n            }"
	        }],
	        attrs: {
	          "content": "Løbenummer og lønart skal udfyldes "
	        }
	      }, [_c('div', {
	        staticClass: "toggle-flex toggle-flex--disabled",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.$emit('editEmployment', {
	              user: user,
	              employment: employment
	            })
	          }
	        }
	      }, [_c('AppToggle', {
	        attrs: {
	          "prop-on": employment.manual_salary,
	          "allow-changes": false
	        }
	      }), _vm._v(" "), (employment.manual_salary) ? _c('span', {
	        staticClass: "do-pill do-pill--small do-pill--yellow"
	      }, [_vm._v("Vikarløn")]) : _vm._e()], 1)]) : _c('td', [_c('div', {
	        staticClass: "toggle-flex",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.$emit('editEmployment', {
	              user: user,
	              employment: employment,
	              context: 'manual_salary'
	            })
	          }
	        }
	      }, [_c('AppToggle', {
	        attrs: {
	          "prop-on": employment.manual_salary,
	          "allow-changes": false
	        }
	      }), _vm._v(" "), (employment.manual_salary) ? _c('span', {
	        staticClass: "do-pill do-pill--small do-pill--yellow"
	      }, [_vm._v("Vikarløn")]) : _vm._e()], 1)])])
	    }), _vm._v(" "), (user.v_employments.length === 0) ? _c('tr', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setTheEditUser(user)
	        }
	      }
	    }, [_c('td', [_c('b', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e()], 2)] : _vm._l((_vm.filteredUsers), function(user) {
	      return _c('tr', {
	        key: user.id,
	        on: {
	          "click": function($event) {
	            return _vm.toggleUser(user)
	          }
	        }
	      }, [(!_vm.isSalaryIntegrationActive) ? _c('td', [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': user.v_isSelected
	        }
	      })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
	        staticClass: "d-tags"
	      }, [_vm._l((user.v_employments), function(employment) {
	        return _c('div', {
	          staticClass: "d-tag",
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.setTheEditUser(user)
	            }
	          }
	        }, [_vm._v("\n          " + _vm._s(employment.title) + "\n          "), (employment.organisation) ? _c('div', {
	          staticClass: "d-tag d-tag--inner"
	        }, [_vm._v(_vm._s(employment.organisation))]) : _vm._e(), _vm._v(" "), (employment.manual_salary) ? _c('div', {
	          staticClass: "do-pill do-pill--small do-pill--yellow"
	        }, [_vm._v("Vikarløn")]) : _vm._e()])
	      }), _vm._v(" "), (user.v_employments.length === 0 && _vm.isShowNoEmploymentsText) ? _c('p', {
	        staticClass: "italic font-small"
	      }, [_vm._v("Ingen\n          ansættelser")]) : _vm._e()], 2), _vm._v(" "), _c('td', [(user.v_employments.length > 0) ? _c('div', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            animateFill: false,
	            animation: 'shift-away',
	            zIndex: '999999992',
	            boundary: 'window'
	          }),
	          expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	        }],
	        staticClass: "icon__bg-circle",
	        attrs: {
	          "content": "Redigér ansættelser"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.setTheEditUser(user)
	          }
	        }
	      }, [_c('span', {
	        staticClass: "icon-wrench"
	      })]) : _vm._e()])])
	    })
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tabs-list",
	    class: {
	      'tabs-list--large': _vm.isLarge
	    }
	  }, _vm._l((_vm.tabs), function(tab) {
	    return _c('div', {
	      key: tab,
	      staticClass: "tabs-list__tab",
	      class: {
	        'tabs-list__tab--selected': _vm.selected === tab,
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onSelect(tab)
	        }
	      }
	    }, [_vm._v("\n    " + _vm._s(tab) + "\n  ")])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DSelect', {
	    attrs: {
	      "items": _vm.itemsFiltered,
	      "show": _vm.show,
	      "itemsSelected": _vm.itemsSelected,
	      "placeholder": _vm.placeholder,
	      "isDeleteAllAnOption": false
	    },
	    on: {
	      "update": _vm.update,
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('h4', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_vm._v("En person må have max seks kompetencer")])])
	},staticRenderFns: []}

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isCancellingLesson,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      },
	      "confirm": _vm.onConfirmCancelLesson
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [(!_vm.isCanceled) ? [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_cancel_title))]), _vm._v(" "), _c('p', {
	    staticClass: "pad-1 italic pad-0-top"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_cancel_text))])] : [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_uncancel_title))]), _vm._v(" "), _c('p', {
	    staticClass: "pad-1 italic"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_uncancel_text))])]], 2), _vm._v(" "), _c('p', {
	    attrs: {
	      "slot": "confirmText"
	    },
	    slot: "confirmText"
	  }, [_vm._v(_vm._s(!_vm.isCanceled ? _vm.i18n.cancel_event : _vm.i18n.uncancel_event))])])
	},staticRenderFns: []}

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.visibleCategories.length > 0) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
	    staticClass: "is-number",
	    staticStyle: {
	      "width": "70%"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.visibleCategories), function(taskCategory) {
	    return _c('UserTasksOverviewOwnPoolsPool', {
	      attrs: {
	        "taskCategory": taskCategory,
	        "isShowScheduled": _vm.isShowScheduled,
	        "is-date-interval-changed": _vm.isDateIntervalChanged
	      }
	    })
	  }), 1)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', [_c('h4', [_vm._v("Puljer")])])
	}]}

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "log"
	  }, [(_vm.isLoading) ? _c('Spinner', {
	    staticStyle: {
	      "padding-bottom": "50px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  }) : _c('div', {
	    staticClass: "log-list"
	  }, [(_vm.sortedActivities.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].there_is_no_logged_activity))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.packedActivities), function(activity) {
	    return _c('li', {
	      key: activity.at,
	      staticClass: "activity"
	    }, [_c('div', {
	      staticClass: "activity__headline"
	    }, [(_vm.usersHash[activity.by.id]) ? _c('div', {
	      staticClass: "user"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.getUserImg(activity)
	      }
	    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getUserName(activity)))])]) : _vm._e(), _vm._v(" "), _c('p', {
	      staticClass: "activity__headline__timestamp hint--top-left",
	      attrs: {
	        "aria-label": _vm.formatDate(activity.at)
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.getDuration(activity.at)) + " " + _vm._s(_vm.i18n[_vm.locale].ago) + "\n          ")])]), _vm._v(" "), _c('ul', {
	      staticClass: "activity-changes"
	    }, _vm._l((activity.changes), function(change) {
	      return _c('li', {
	        key: change.at,
	        staticClass: "activity-changes__change"
	      }, [_c('div', {
	        domProps: {
	          "innerHTML": _vm._s(_vm.humanizeChange(change))
	        }
	      })])
	    }), 0)])
	  }), 0)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "public-app"
	  }, [(_vm.isMobile) ? _c('app', {
	    attrs: {
	      "calId": _vm.calId,
	      "viewState": _vm.viewState,
	      "schoolName": _vm.schoolName,
	      "calName": _vm.calName,
	      "i18n": _vm.i18n
	    },
	    on: {
	      "setLocale": _vm.setLocale,
	      "eventClick": _vm.setActiveEvent
	    }
	  }) : [(_vm.view === 'desktop') ? _c('desktop', {
	    attrs: {
	      "calId": _vm.calId,
	      "schoolName": _vm.schoolName,
	      "viewState": _vm.viewState,
	      "i18n": _vm.i18n
	    },
	    on: {
	      "eventClick": _vm.setActiveEvent,
	      "setLocale": _vm.setLocale
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.view === 'smartscreen') ? _c('desktopVue', {
	    attrs: {
	      "calendarId": _vm.calId,
	      "calendar": _vm.calendar
	    }
	  }) : _vm._e()], _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "aniZoomIn"
	    }
	  }, [(_vm.activeEvent !== null) ? _c('show-event', {
	    attrs: {
	      "locale": _vm.locale,
	      "event": _vm.activeEvent,
	      "i18n": _vm.i18n
	    },
	    on: {
	      "close": function($event) {
	        _vm.activeEvent = null
	      }
	    }
	  }) : _vm._e()], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "resume"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.personale), function(persona) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(persona.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(persona.numberOfMales))])])
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Stillingstype")]), _vm._v(" "), _c('th', [_vm._v("Alder")])])])
	}]}

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "icon__bg-circle",
	    class: {
	      'icon__bg-circle--active': _vm.isPrioritizerActive
	    },
	    attrs: {
	      "content": _vm.$t('vue2.sub_scheduler.set_priorities')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsPrioritizerActive(true)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cog2"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInLeft"
	    }
	  }, [(_vm.isPrioritizerActive) ? _c('div', {
	    staticClass: "sub-scheduler__filters__subzen__priorities"
	  }, [_c('div', {
	    staticClass: "sub-scheduler__filters__subzen__priorities__header"
	  }, [_c('h3', [_vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler.set_priorities')) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle sub-scheduler__filters__subzen__priorities__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsPrioritizerActive(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.isEditable) ? _c('div', {
	    staticClass: "pad-10-bottom"
	  }, [_c('draggable', {
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.list),
	      callback: function($$v) {
	        _vm.list = $$v
	      },
	      expression: "list"
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": "flip-list"
	    }
	  }, _vm._l((_vm.list), function(element, key) {
	    return _c('div', {
	      key: element[0],
	      staticClass: "sub-scheduler__filters__subzen__priorities__priority"
	    }, [_c('div', {
	      staticClass: "sub-scheduler__filters__subzen__priorities__priority__number"
	    }, [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getItemTitle(element[0])))])])
	  }), 0)], 1)], 1) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "border-1-top sub-scheduler__unAvailableItems"
	  }, _vm._l((_vm.unAvailableItems), function(item, key) {
	    return _c('li', {
	      staticClass: "sub-scheduler__filters__subzen__priorities__priority sub-scheduler__filters__subzen__priorities__priority--not-moveable"
	    }, [_c('div', {
	      staticClass: "sub-scheduler__filters__subzen__priorities__priority__number"
	    }, [_vm._v(_vm._s(7 + key))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getItemTitle(item[0])))])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "sub-scheduler__filters__subzen__priorities__footer pad-10-bottom"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isPrioritizerActive = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary marg-10-left",
	    class: {
	      'bttn-primary--disabled': !_vm.isChangeHasBeenMade
	    },
	    on: {
	      "click": _vm.onSave
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.save')) + "\n        ")])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "omni-chat no-print"
	  }, [_c('div', {
	    staticClass: "omni-chat__button",
	    on: {
	      "click": _vm.setOpenChat
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "scaleIn",
	      "mode": "out-in"
	    }
	  }, [(!_vm.isShowChat) ? _c('svg', {
	    key: "chatClosed",
	    staticClass: "icon-chat-group-alt tw-icon--small",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('rect', {
	    staticClass: "secondary",
	    attrs: {
	      "width": "16",
	      "height": "13",
	      "x": "2",
	      "y": "2",
	      "rx": "2"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M6 16V8c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v13a1 1 0 0 1-1.7.7L16.58 18H8a2 2 0 0 1-2-2z"
	    }
	  })]) : _c('svg', {
	    key: "chatOpen",
	    staticClass: "tw-icon--small icon-close",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
	    }
	  })])])], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "chatFadeIn"
	    }
	  }, [(_vm.isShowChat) ? _c('div', {
	    staticClass: "omni-chat__container"
	  }, [_c('div', [_c('div', {
	    staticClass: "omni-chat__container__header"
	  }, [_c('div', {
	    staticClass: "omni-chat__logo"
	  }, [_c('span', {
	    staticClass: "icon-docendo"
	  })]), _vm._v(" "), _c('h1', [_vm._v("Hej 👋")]), _vm._v(" "), _c('p', [_vm._v("Vi er dit Docendo-team. Vi står klar til at svare på dine spørgsmål :)")])]), _vm._v(" "), _c('div', {
	    staticClass: "omni-chat__container__body"
	  }, [_c('div', {
	    staticClass: "omni-chat__container__body__box"
	  }, [_c('h4', [_vm._v("Skriv en email eller ring til os")]), _vm._v(" "), _c('div', {
	    staticClass: "customer-support__imgs"
	  }, [_c('img', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        zIndex: 2147483010
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 2147483010\n                }"
	    }],
	    attrs: {
	      "src": _vm.anne,
	      "content": "Anne"
	    }
	  }), _vm._v(" "), _c('img', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        zIndex: 2147483010
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 2147483010\n                }"
	    }],
	    attrs: {
	      "src": _vm.henrik,
	      "content": "Henrik"
	    }
	  }), _vm._v(" "), _c('img', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        zIndex: 2147483010
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 2147483010\n                }"
	    }],
	    attrs: {
	      "src": _vm.jeppe,
	      "content": "Jeppe"
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
	    staticClass: "support-options"
	  }, [_c('li', [_c('span', {
	    staticClass: "icon-question3"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://help.docendo.dk/da"
	    }
	  }, [_vm._v("Se supportforum")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "icon-envelop"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "mailto:kontakt@docendo.dk"
	    }
	  }, [_vm._v("kontakt@docendo.dk")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "icon-phone2"
	  }), _vm._v(" +45 43 31 06 12")])]), _vm._v(" "), _c('a', {
	    staticClass: "bttn bttn--primary bttn--primary--chat",
	    attrs: {
	      "target": "_blank",
	      "href": "mailto:kontakt@docendo.dk?subject=Supporthenvendelse"
	    }
	  }, [_vm._v("Send os en email")]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Chatsupport vender snart tilbage. Du kan altid sende os en email eller ringe, hvis du har spørgsmål.")])])])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "scheduler_user",
	    style: ({
	      'min-height': 40 * _vm.rows + 'px'
	    })
	  }, [_vm._l((_vm.correctEvents), function(event) {
	    return _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          zIndex: 123123123123,
	          onShow: function () { return event.obj.v_has_teachers; }
	        }),
	        expression: "{\n                  arrow: true,\n                  zIndex: 123123123123,\n                  onShow: () => event.obj.v_has_teachers\n                }"
	      }],
	      key: event.obj.id,
	      ref: _vm.calEvent,
	      refInFor: true,
	      staticClass: "day-cal__event day-cal__event__lesson",
	      style: ([{
	          'top': event.row * 26 + 'px'
	        },
	        {
	          'left': event.left + 'px'
	        },
	        {
	          'right': event.right + 'px'
	        },
	        {
	          'height': '25px'
	        }
	      ]),
	      attrs: {
	        "content": event.obj.v_user_names,
	        "aria-label": event.othersOnLesson
	      }
	    }, [_c('div', {
	      staticClass: "day-cal__event__content"
	    }, [_c('div', {
	      staticClass: "day-cal__event__content__title"
	    }, [_c('span', {
	      staticClass: "nowrap day-cal__event__content__title__title"
	    }, [_vm._v(_vm._s(event.obj.title))]), _vm._v(" "), (event.obj.v_groups.length > 0) ? _c('span', {
	      staticClass: "nowrap day-cal__event__content__title__grade"
	    }, [_vm._v(_vm._s(event.obj.v_group_names))]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__bg",
	      style: ({
	        backgroundColor: event.obj.color ? event.obj.color : '#ccc'
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__sider",
	      style: ({
	        backgroundColor: event.obj.color ? event.obj.color : '#ccc'
	      })
	    })])])
	  }), _vm._v(" "), _vm._l((_vm.userPresenceForPlacing), function(presence) {
	    return _c('div', {
	      key: presence.obj.id,
	      staticClass: "day-cal__event work_hours",
	      style: ([{
	          'left': presence.left + 'px'
	        },
	        {
	          'right': presence.right + 'px'
	        }
	      ])
	    })
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "scheduler"
	  }, [(_vm.activeUser !== null) ? _c('SchedulerSubsSubstituteHours', {
	    attrs: {
	      "item": _vm.activeUser,
	      "itemBCR": _vm.activeUserBCR
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "scheduler__header"
	  }, [_c('li', [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollTop),
	      expression: "handleScrollTop"
	    }],
	    ref: "topDiv",
	    staticClass: "do-scroller do-scroller--hide"
	  }, [_c('ul', {
	    staticClass: "scheduler__header__times"
	  }, _vm._l((_vm.hoursInLocale), function(number) {
	    return _c('li', [_vm._v(_vm._s(_vm._f("LT")(number)))])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "scheduler__container",
	    class: {
	      'scheduler__container--loading': _vm.dataIsLoading
	    }
	  }, [(_vm.dataIsLoading) ? _c('div', {
	    staticClass: "scheduler__container__loader"
	  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "do-scroller__container"
	  }, [_c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollLeft),
	      expression: "handleScrollLeft"
	    }],
	    ref: "leftDiv",
	    staticClass: "do-scroller do-scroller-max-height do-scroller--hide do-scroller__users",
	    style: ({
	      maxHeight: _vm.schedulerMaxHeight + 'px',
	      paddingBottom: _vm.isVerticalScrollbar ? '15px' : '0px'
	    })
	  }, [_c('ul', {
	    staticClass: "scheduler__users"
	  }, _vm._l((_vm.items), function(item, idx) {
	    return _c('li', {
	      key: item.id,
	      class: {
	        'item-is-headline': item.headline
	      },
	      style: ({
	        'height': 40 * _vm.rows[item.id] + 'px'
	      })
	    }, [(item.headline) ? _c('div', {
	      staticClass: "scheduler__users__headline"
	    }, [_c('div', {
	      staticClass: "scheduler__users__user__name"
	    }, [_vm._v(_vm._s(_vm.subsTitle))]), _vm._v(" "), _c('div', {
	      staticClass: "scheduler__users__user__subpools scheduler__users__user__subpools__title"
	    }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.sub_scheduler.pool')) + "\n              ")])]) : _c('div', {
	      staticClass: "scheduler__users__user",
	      class: [{
	          'scheduler__users__user--absence-autogenerated': _vm.isAbsenceAutoGenerated(item)
	        },
	        {
	          'scheduler__users__user--not-absent': item.dayAbsence.length < 1
	        }
	      ]
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          animateFill: false,
	          placement: 'right',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return item.dayAbsence.length < 1; }
	        }),
	        expression: "{\n              arrow: false,\n              animateFill: false,\n              placement: 'right',\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => item.dayAbsence.length < 1\n            }"
	      }],
	      staticClass: "scheduler__users__user__name",
	      attrs: {
	        "title": _vm.i18n.create_activity
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setCreateEventOnUserOnNotAbsentUser(item)
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(item.name) + "\n                "), (_vm.isAbsenceAutoGenerated(item)) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: "right",
	          animation: "fade"
	        }),
	        expression: "{ arrow: true, placement : \"right\", animation : \"fade\" }"
	      }],
	      staticClass: "absence-generated-sign",
	      attrs: {
	        "title": _vm.i18n.auto_created
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon tw-icon-important",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('path', {
	      staticClass: "primary",
	      attrs: {
	        "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	      }
	    })])]) : _vm._e(), _vm._v(" "), (item.dayAbsence.length > 0) ? _c('DDropdown', [_c('ul', {
	      staticStyle: {
	        "width": "180px"
	      },
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', [_c('a', {
	      staticClass: "marg-5-left text-link",
	      attrs: {
	        "href": '/calendars/' + item.user_calendar_id,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(_vm.i18n.go_to_calendar))])]), _vm._v(" "), _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setActiveAbsentUser(item)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n.add_sub_to_multiple_lessons))]), _vm._v(" "), _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setCreateEventOnUser(item)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n.create_activity))])])]) : _vm._e()], 1), _vm._v(" "), (item.dayAbsence.length === 0) ? _c('div', {
	      staticClass: "scheduler__users__user__subpools cursor-help",
	      on: {
	        "mouseenter": function($event) {
	          return _vm.setActiveUser(item, $event)
	        },
	        "mouseleave": function($event) {
	          _vm.activeUser = null
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm._f("round")(item.subPoolsDiff)) + "\n              ")]) : _c('div', {
	      ref: 'absence_status_dropdown__parent___' + item.id,
	      refInFor: true,
	      staticClass: "scheduler__users__user__handled",
	      class: {
	        'scheduler__users__user__handled--loading': _vm.getIsUserHandlerLoading(item.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheAbsentUserHandledDropdown(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "scheduler__users__user__handled__handler",
	      class: _vm.schedulerUserHandledCls(item)
	    })])])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "scheduler__cal"
	  }, [_c('div', {
	    staticClass: "do-scroller__container"
	  }, [_c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollRight),
	      expression: "handleScrollRight"
	    }],
	    ref: "rightDiv",
	    staticClass: "do-scroller do-scroller-max-height do-scroller--hide",
	    style: ({
	      maxHeight: _vm.schedulerMaxHeight + 'px'
	    })
	  }, [_c('ul', {
	    staticClass: "scheduler__cal__ress"
	  }, [_c('ul', {
	    staticClass: "scheduler__cal__ress__items"
	  }, _vm._l((_vm.items), function(user) {
	    return _c('SchedulerItem', {
	      key: user.id,
	      attrs: {
	        "user": user,
	        "locale": _vm.locale,
	        "allEvents": _vm.allEvents,
	        "isSubStatusPendingActive": _vm.isSubStatusPendingActive,
	        "allCalendarsInHash": _vm.allCalendarsInHash,
	        "longAbsentListInHash": _vm.longAbsentListInHash
	      },
	      on: {
	        "onChooseSubType": _vm.onChooseSubType,
	        "rows": function($event) {
	          return _vm.setRows($event, user.id)
	        }
	      }
	    })
	  }), 1), _vm._v(" "), _c('ul', {
	    staticClass: "scheduler__cal__timeslots"
	  }, _vm._l((_vm.hoursInLocale.length * 2), function(n) {
	    return _c('li')
	  }), 0), _vm._v(" "), _c('SchedulerRulers')], 1)]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.activeEvent && _vm.activeEvent.obj) ? _c('div', {
	    staticClass: "sub-popover"
	  }, [_c('div', {
	    staticClass: "icon__bg-circle close-cross",
	    on: {
	      "click": _vm.closePopover
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('SchedulerPopover', {
	    attrs: {
	      "activeEventId": _vm.activeEvent,
	      "user": _vm.schedulerUser,
	      "locale": _vm.locale
	    },
	    on: {
	      "chooseSubType": _vm.onChooseSubType,
	      "removeSubs": _vm.removeSubs,
	      "clickaway": _vm.closePopover,
	      "close": _vm.closePopover,
	      "showLog": _vm.showLog,
	      "deleteEvent": _vm.setDeleteEvent,
	      "splitLesson": function($event) {
	        return _vm.$emit('splitLesson', $event)
	      },
	      "setTheOutOfSchoolLesson": function($event) {
	        return _vm.$emit('setTheOutOfSchoolLesson', $event)
	      }
	    }
	  })], 1) : _vm._e()])], 1)])]), _vm._v(" "), (_vm.theAbsentUserHandledDropdown !== null) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeSubStatusDropdown),
	      expression: "closeSubStatusDropdown"
	    }],
	    ref: "absence_status_dropdown",
	    staticClass: "scheduler__users__user__handled__dropdown"
	  }, [_c('div', {
	    staticClass: "popper-arrow"
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "scheduler__users__user__handled__absense__reasons"
	  }, _vm._l((_vm.theAbsentUserHandledDropdown.dayAbsence), function(absence) {
	    return _c('li', {
	      staticClass: "scheduler__users__user__handled__absense__reasons__reason"
	    }, [_c('h4', [_vm._v(_vm._s(_vm.getAbsenceTitle(absence)))]), _vm._v(" "), _c('ul', [_c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setAbsenceStatus(_vm.theAbsentUserHandledDropdown, 0)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n          ")]), _vm._v(" "), _c('li', {
	      staticClass: "scheduler__users__user__handled__absense__reasons__reason--handled",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setAbsenceStatus(_vm.theAbsentUserHandledDropdown, 1)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n          ")])])])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.theTeacherOrSubObj) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal__choose-as-sub-or-teacher",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2'), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['should']) + " " + _vm._s(_vm.theSubName) + " " + _vm._s(_vm.i18n['be_appointed']) + "?")]), _vm._v(" "), (_vm.isLoadingEvent) ? _c('div', {
	    staticClass: "d-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : [_c('button', {
	    staticClass: "do-bttn do-bttn__option",
	    class: {
	      'do-bttn--loading': _vm.isLoadingEvent
	    },
	    on: {
	      "click": _vm.setAsSub
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n['as_a_substitute']) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn__option",
	    class: {
	      'do-bttn--loading': _vm.isLoadingEvent
	    },
	    on: {
	      "click": _vm.setAsTeacher
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n['as_a_teacher']) + "\n          ")])]], 2)])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteEvent) ? _c('ModalConfirmation', {
	    attrs: {
	      "appendToBody": true
	    },
	    on: {
	      "close": function($event) {
	        _vm.theDeleteEvent = null
	      },
	      "confirm": _vm.deleteTheDeleteEvent
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "zen-import text-dark"
	  }, [_c('div', {
	    staticClass: "zen-hero-bg"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "zen-import-container"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.zen_import.import_from_zen')))]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "box"
	  }, [_c('Loader', {
	    attrs: {
	      "bgColor": "#fff"
	    }
	  })], 1) : [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label d-label--white"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.choose_version')))]), _vm._v(" "), (_vm.schedules.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.zen_import.you_have_no_created_any_versions')) + "\n        ")]) : _c('div', {
	    staticClass: "zen-schedules"
	  }, [_c('div', {
	    staticClass: "zen-schedule zen-schedule__header"
	  }, [_c('div', {
	    staticClass: "zen-schedule__left"
	  }), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.last_updated')))])])]), _vm._v(" "), _vm._l((_vm.schedules), function(schedule) {
	    return _c('div', {
	      key: schedule.scheduleUuid,
	      staticClass: "zen-schedule",
	      class: {
	        'zen-schedule--selected': _vm.isSelected(schedule.scheduleUuid)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveSchedule(schedule.scheduleUuid)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "zen-schedule__left"
	    }, [_c('div', {
	      staticClass: "d-radio",
	      class: {
	        'd-radio--selected': _vm.isSelected(schedule.scheduleUuid)
	      }
	    }), _vm._v(" "), _c('p', {
	      staticClass: "zen-schedule__title"
	    }, [_vm._v(_vm._s(schedule.title))])]), _vm._v(" "), _c('p', {
	      staticClass: "zen-schedule__modified"
	    }, [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'right'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'right'\n                }"
	      }],
	      staticClass: "zen-schedule__modified__date hint--right",
	      attrs: {
	        "content": _vm.showDate(schedule.modifiedAt)
	      }
	    }, [_vm._v(_vm._s(_vm.showHumanizeDate(schedule.modifiedAt)))])])])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.choose_schoolyear')))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    staticStyle: {
	      "max-width": "210px"
	    },
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.insert_in_week')))]), _vm._v(" "), _c('DatePicker', {
	    attrs: {
	      "type": _vm.datepickerType,
	      "lang": _vm.datepickerLang,
	      "value-type": "YYYY-MM-DD",
	      "format": _vm.datepickerFormat
	    },
	    model: {
	      value: (_vm.theDate),
	      callback: function($$v) {
	        _vm.theDate = $$v
	      },
	      expression: "theDate"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [(_vm.schedules.length < 1) ? _c('button', {
	    staticClass: "bttn bttn--primary bttn--large bttn--primary--disabled"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.zen_import.insert_schedules')) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isSendingData && _vm.schedules.length > 0) ? _c('button', {
	    staticClass: "bttn bttn--primary bttn--large",
	    on: {
	      "click": _vm.submitSchudules
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.insert_schedules')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSendingData) ? _c('button', {
	    staticClass: "bttn bttn--primary bttn--large bttn--loading"
	  }) : _vm._e()])]], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-tag"
	  }, [_c('div', {
	    staticClass: "d-tag__text"
	  }, [_vm._v(_vm._s(_vm.tag))]), _vm._v(" "), _c('div', {
	    staticClass: "icon-cross2 d-tag__icon",
	    on: {
	      "click": function($event) {
	        return _vm.remove(_vm.tag)
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "print-calendars text-dark",
	    attrs: {
	      "id": "printCalendars"
	    }
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.loading')))])], 1) : [(_vm.calendars.length < 1) ? _c('h2', {
	    staticClass: "explainer-text italic pad-20"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.no_calendars')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.calendars), function(calendar) {
	    return _c('div', {
	      key: calendar.id,
	      staticClass: "d-calendar"
	    }, [(_vm.theViewSetting !== 'list') ? _c('h2', {
	      staticClass: "text-dark"
	    }, [_vm._v(_vm._s(calendar.name))]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "calculate-hours-wrapper"
	    }, [(_vm.isPrintHours) ? _c('CalculateHours', {
	      staticClass: "print-calculate-hours",
	      attrs: {
	        "isShowOptions": false,
	        "schoolId": _vm.schoolId,
	        "calendarId": calendar.id,
	        "date": _vm.date
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "d-calendar__calendar__container d-calendar__calendar__container--print-mode",
	      class: [{
	        'd-calendar__calendar__container--print-mode--is-list': _vm.theViewSetting === 'list'
	      }, {
	        'd-calendar__calendar__container--print-mode--is-print-hours': _vm.isPrintHours
	      }]
	    }, [(_vm.theViewSetting === 'blocks') ? _c('DCalendarPrint', {
	      attrs: {
	        "isCalendarInPrintMode": true,
	        "isShowWeekends": _vm.isShowWeekends,
	        "startTime": _vm.startTime,
	        "endTime": _vm.endTime,
	        "date": _vm.date,
	        "events": calendar.events,
	        "calendarId": calendar.id,
	        "calendarName": calendar.name,
	        "firstDayOfWeek": _vm.firstDayOfWeek
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.theViewSetting === 'calendar' || _vm.theViewSetting === 'list') ? _c('DCalendar', {
	      attrs: {
	        "isCalendarInPrintMode": true,
	        "isShowWeekends": _vm.isShowWeekends,
	        "isHideCalendars": _vm.isHideCalendars,
	        "isHideDates": _vm.isHideDates,
	        "isCalNoBgColors": _vm.isCalNoBgColors,
	        "eventFontSize": _vm.eventFontSize,
	        "startTime": _vm.startTime,
	        "endTime": _vm.endTime,
	        "date": _vm.date,
	        "events": calendar.events,
	        "calendarId": calendar.id,
	        "calendarName": calendar.name,
	        "isShowAsList": _vm.theViewSetting === 'list',
	        "firstDayOfWeek": _vm.firstDayOfWeek
	      }
	    }) : _vm._e()], 1)], 1)])
	  })], _vm._v(" "), (_vm.isShowPrintButton) ? _c('DModal', {
	    staticClass: "modal-print-button",
	    class: {
	      'modal-print-button--hide': !_vm.isShowPrintButton
	    },
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__content d-modal__print_button",
	    class: {
	      'd-modal__print_button--wide': _vm.showDSelect
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [(_vm.showDSelect) ? _c('div', {
	    staticClass: "custom-select-calendars"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.custom')))]), _vm._v(" "), _c('DSelectCals', {
	    attrs: {
	      "appendToBody": true
	    },
	    on: {
	      "updateItems": function($event) {
	        return _vm.dSelectCalsUpdated('update', $event)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "custom-select-calendars__submit"
	  }, [(!_vm.isCalendarsSelected) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.setIsCalendarsSelected
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showDSelect || _vm.isCalendarsSelected),
	      expression: "!showDSelect || isCalendarsSelected"
	    }],
	    staticClass: "d-modal__print_button__settings"
	  }, [_c('div', {
	    staticClass: "d-input-group marg-1-bottom",
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_c('label', {
	    staticClass: "d-input marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.set_default_start_and_endtime')))]), _vm._v(" "), _c('TimeChanger', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTimeDate,
	      "end": _vm.endTimeDate
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isHideDates', !_vm.isHideDates)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.hide_dates')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isHideDates
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isShowWeekends', !_vm.isShowWeekends)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_weekends')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isShowWeekends
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setViewSetting('list')
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_as_list')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.theViewSetting === 'list'
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setViewSetting('blocks')
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_as_blocks')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.theViewSetting === 'blocks'
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isPrintHours', !_vm.isPrintHours)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_print_hours')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isPrintHours
	    }
	  })], 1), _vm._v(" "), (_vm.theViewSetting === 'calendar') ? _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isCalNoBgColors', !_vm.isCalNoBgColors)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.show_print_without_bg_colors')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isCalNoBgColors
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.changeSetting('isHideCalendars', !_vm.isHideCalendars)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.hide_calendars')))]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isHideCalendars
	    }
	  })], 1), _vm._v(" "), (_vm.theViewSetting === 'calendar') ? _c('div', {
	    staticClass: "input-group input-group__toggle"
	  }, [_c('label', {
	    staticClass: "d-label marg-1-right"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.event_font_size')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.eventFontSize),
	      expression: "eventFontSize"
	    }],
	    attrs: {
	      "type": "range",
	      "name": "vol",
	      "min": "4",
	      "max": "16"
	    },
	    domProps: {
	      "value": (_vm.eventFontSize)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.changeSetting('eventFontSize', _vm.eventFontSize)
	      },
	      "__r": function($event) {
	        _vm.eventFontSize = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons d-modal__print_button__submit",
	    class: {
	      'd-modal__print_button__submit--space': _vm.hasUserPrintSettings
	    }
	  }, [_c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasUserPrintSettings),
	      expression: "hasUserPrintSettings"
	    }],
	    staticClass: "text-link",
	    on: {
	      "click": _vm.resetPrintSettings
	    }
	  }, [_vm._v("Nulstil")]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__print_button__submit--right"
	  }, [_c('button', {
	    staticClass: "marg-1-right do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.print
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.print')))])])])])])]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lessons text-dark"
	  }, [_c('div', {
	    staticClass: "lessons__filters"
	  }, [_c('div', {
	    staticClass: "lessons__filters__filter",
	    class: {
	      'lessons__filters__filter--active': _vm.activeFilter === 'lessonsWithoutSub'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFilter('lessonsWithoutSub')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.lessons_without_sub')) + "\n      (" + _vm._s(_vm.eventsWithoutSubstitute.length) + ")\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "lessons__filters__filter",
	    class: {
	      'lessons__filters__filter--active': _vm.activeFilter === 'lessonsWithSub'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFilter('lessonsWithSub')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.lessons_with_sub')) + "\n      (" + _vm._s(_vm.eventsWithSubstitute.length) + ")\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "lessons__filters__filter",
	    class: {
	      'lessons__filters__filter--active': _vm.activeFilter === ''
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFilter('')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.all_lessons')) + " (" + _vm._s(_vm.events.length) + ")\n    ")])]), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Loader', {
	    staticStyle: {
	      "margin-top": "10rem"
	    },
	    attrs: {
	      "isSmall": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length < 1) ? _c('div', {
	    staticClass: "no-lessons-text"
	  }, [_c('h4', {
	    staticClass: "text-explainer"
	  }, [(_vm.activeFilter === 'lessonsWithoutSub') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons_without_subs')))]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'lessonsWithSub') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons_with_sub')))]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === '') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length > 0) ? _c('div', {
	    staticClass: "marg-1-top"
	  }, [_c('div', {
	    staticClass: "subs-days-container__header"
	  }, [_c('p', {
	    staticClass: "select-all-item",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.eventIdsToAddSub.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.unselect_all')))])]), _vm._v(" "), _c('p', {
	    staticClass: "select-all-item",
	    on: {
	      "click": _vm.toggleAll
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "subs-days-container rounded shadow"
	  }, _vm._l((_vm.eventsSortedInDays), function(day) {
	    return _c('li', [_c('div', {
	      staticClass: "day__header"
	    }, [_c('label', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("ddd")(day.date))) + ", " + _vm._s(_vm._f("LL")(day.date)))])]), _vm._v(" "), _c('ul', {
	      staticClass: "sub-lessons"
	    }, _vm._l((day.events), function(event) {
	      return _c('li', {
	        key: event.event_id,
	        staticClass: "d-lesson",
	        class: {
	          'd-lesson--active': _vm.isInEventIdsToAddSub(event.event_id) || (_vm.activeLesson && event.event_id === _vm.activeLesson.event_id)
	        },
	        style: ({
	          'border-color': event.color
	        }),
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            $event.preventDefault();
	            return _vm.toggleEvent(event.event_id)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "d-lesson__left"
	      }, [_c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': _vm.isInEventIdsToAddSub(event.event_id)
	        }
	      }), _vm._v(" "), _c('div', {
	        staticClass: "d-lesson__title"
	      }, [_c('span', {
	        staticClass: "d-lesson__time"
	      }, [_vm._v(_vm._s(_vm._f("LT")(event.start)) + " - " + _vm._s(_vm._f("LT")(event.end)))]), _vm._v("\n                " + _vm._s(event.title) + "\n                "), _vm._l((_vm.getClasses(event)), function(klass) {
	        return _c('span', [_vm._v(", " + _vm._s(klass.name))])
	      })], 2)]), _vm._v(" "), _c('div', {
	        staticClass: "sub-selector",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	          }
	        }
	      }, [(_vm.getSubstitute(event).length > 0) ? _c('span', {
	        staticClass: "icon-users"
	      }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getSubstitute(event)), function(sub) {
	        return _c('p', {
	          staticClass: "sub-name"
	        }, [_c('b', [_vm._v(_vm._s(sub.name))]), _vm._v(" "), _c('span', {
	          staticClass: "icon-cross2",
	          on: {
	            "click": function($event) {
	              return _vm.setIsAskRemoveAll(true, event, sub)
	            }
	          }
	        })])
	      })], 2)])
	    }), 0)])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isAskRemoveAll) ? _c('DModal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.substitution.remove_sub_from_all_lessons')) + "?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsAskRemoveAll(false, null, null)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.substitution.do_you_want_to_remove')) + " " + _vm._s(_vm.activeSub.name) + "\n          " + _vm._s(_vm.$t('vue2.substitution.as_sub_on')) + " \""), _c('span', [_c('span', {
	    staticClass: "d-lesson__time"
	  }, [_vm._v(_vm._s(_vm._f("LT")(_vm.activeLesson.start)) + " - " + _vm._s(_vm._f("LT")(_vm.activeLesson.end)))]), _vm._v(_vm._s(_vm.activeLesson.title)), _vm._l((_vm.getClasses(_vm.activeLesson)), function(klass) {
	    return _c('span', [_vm._v(", " + _vm._s(klass.name))])
	  })], 2), _vm._v("\" -\n          " + _vm._s(_vm.$t('vue2.substitution.or_on_all_lessons')) + "?\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": _vm.removeSubFromAllLessons
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.remove_from_all_lessons')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.removeSubFromActiveLesson
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.just_this_lessons')) + "\n          ")])])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('dropup', {
	    attrs: {
	      "button-text": _vm.$t('vue.deleteday.delete_day_or_week'),
	      "show": _vm.showDropUp
	    },
	    on: {
	      "open": _vm.dropUp,
	      "close": function($event) {
	        _vm.showDropUp = false
	      }
	    }
	  }, [_c('template', {
	    slot: "list"
	  }, [_vm._l((_vm.weekDaysLocale), function(weekdayNum) {
	    return _c('li', {
	      key: weekdayNum,
	      on: {
	        "click": function($event) {
	          return _vm.setIsConfirmDeletion(weekdayNum)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.formattedDate(weekdayNum)) + "\n      ")])
	  }), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsConfirmDeletion('week')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue.deleteday.whole_week')))])], 2)], 2), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeIsConfirmDelete,
	      "confirm": _vm.confirmDelete
	    }
	  }, [_c('h3', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.theDeleteText))])]) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "week-to-print"
	  }, [_c('div', {
	    staticClass: "week-to-print__header"
	  }, [_c('change-school-year', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "weeks-container"
	  }, [_c('ul', {
	    staticClass: "weeks"
	  }, [(_vm.weeks.length < 1) ? [_c('Spinner', {
	    staticStyle: {
	      "margin-bottom": "100px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  })] : _vm._l((_vm.weeks), function(week) {
	    return _c('li', {
	      key: week.serverDate,
	      staticClass: "weeks__week hint--top",
	      attrs: {
	        "aria-label": _vm.tooltipDate(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setSelectedWeek(week)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.showWeek(week.date)) + "\n          "), (_vm.isNow(week)) ? _c('span', {
	      staticClass: "weeks__week__now-indicator"
	    }) : _vm._e()])
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box"
	  }, [(_vm.isCountryDK) ? _c('div', [_c('h1', {
	    staticClass: "primary-color"
	  }, [_vm._v("Kontakt os, hvis du ønsker at få fuld adgang til Docendo")]), _vm._v(" "), _c('ul', {
	    staticClass: "docendo-contact-options"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Eller skriv en chatbesked")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--primary",
	    on: {
	      "click": _vm.openCrispChat
	    }
	  }, [_vm._v("Skriv en chatbesked")])])]), _vm._v(" "), _c('Pricing')], 1) : _vm._e(), _vm._v(" "), (!_vm.isCountryDK) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('vue.buy.buy_access_for_school_users')))]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-2 marg-20-bottom"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue.buy.a_user_is')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.countryIsDkOrNo) ? _c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.choose_the_right_price')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.countryIsDkOrNo) ? _c('div', {
	    staticClass: "marg-20-bottom flex"
	  }, [_c('div', {
	    staticClass: "col-1-2"
	  }, [_c('div', {
	    staticClass: "pointer border rounded pad-20 center",
	    class: {
	      'active': _vm.isSelectedModel(1), 'notActive': _vm.isSelectedModel(2)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.selectModel(1)
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "font-large marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('vue.buy.per_user'))))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('vue.buy.price'))) + " " + _vm._s(_vm.$t('vue.buy.per_user')))]), _vm._v(" "), _c('p', {
	    staticClass: "text-blue bold blue-price"
	  }, [_vm._v(_vm._s(_vm.userPrice) + " " + _vm._s(_vm.currency))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.per_user')) + " / " + _vm._s(_vm.$t('vue.buy.month')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue.buy.only_pay_per')) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "cta-button"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('repitition.choose')) + "\n            ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-2"
	  }, [_c('div', {
	    staticClass: "pointer pos-relative border rounded pad-20 center",
	    class: {
	      'active': _vm.isSelectedModel(2), 'notActive': _vm.isSelectedModel(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.selectModel(2)
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "font-large marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.unlimited')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.total_student_number')))]), _vm._v(" "), _c('p', {
	    staticClass: "text-blue bold blue-price"
	  }, [_vm._v(_vm._s(_vm.pupilsPrice) + " " + _vm._s(_vm.currency))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.per_student')) + " / " + _vm._s(_vm.$t('vue.buy.month')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.pay_for_unlimited_users_and_get')))]), _vm._v(" "), _c('button', {
	    staticClass: "cta-button"
	  }, [_vm._v(_vm._s(_vm.$t('repitition.choose')))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedModel !== null) ? _c('div', [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.subscription_info')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isSelectedModel(1)) ? _c('div', [_c('div', {
	    staticClass: "form-group large-margin form-group__input"
	  }, [_c('label', [_vm._v("\n              " + _vm._s(_vm.$t('vue.buy.write_number_of_users')) + "\n            ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number.lazy",
	      value: (_vm.users),
	      expression: "users",
	      modifiers: {
	        "number": true,
	        "lazy": true
	      }
	    }],
	    staticClass: "type_number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.users)
	    },
	    on: {
	      "change": function($event) {
	        _vm.users = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.isSelectedModel(2)) ? _c('div', [_c('div', {
	    staticClass: "form-group large-margin form-group__input"
	  }, [_c('label', [_vm._v("\n              " + _vm._s(_vm.$t('vue.buy.write_number_of_students')) + "\n            ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number.lazy",
	      value: (_vm.pupils),
	      expression: "pupils",
	      modifiers: {
	        "number": true,
	        "lazy": true
	      }
	    }],
	    staticClass: "type_number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.pupils)
	    },
	    on: {
	      "change": function($event) {
	        _vm.pupils = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue.buy.billed_monthly_or_yearly')))]), _vm._v(" "), _c('div', {
	    staticClass: "form-group large-margin form-group__radiobuttons"
	  }, [_c('br'), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.interval),
	      expression: "interval",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "monthly",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.interval, _vm._n("1"))
	    },
	    on: {
	      "change": function($event) {
	        _vm.interval = _vm._n("1")
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "monthly"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.per_month')))])]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.interval),
	      expression: "interval",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "yearly",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.interval, _vm._n("2"))
	    },
	    on: {
	      "change": function($event) {
	        _vm.interval = _vm._n("2")
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "yearly"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.per_year')) + " "), _c('span', {
	    staticClass: "discount"
	  }, [_vm._v(_vm._s(_vm.$t('vue.buy.save_2')) + " ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "billing-bill large-margin"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.your_invoice')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('p', [_vm._v("1 " + _vm._s(_vm.$t('vue.buy.institution')))]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.monthlyInstitutionPrice * 12 : _vm.monthlyInstitutionPrice * 1) + " " + _vm._s(_vm.currency) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    class: {
	      'invalid-price': _vm.selectedModel !== 1
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.users === '' ? '0' : _vm.users) + " "), _c('span', [_vm._v(_vm._s(_vm.$t('repitition.users')))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.userAmount * 12 : _vm.userAmount) + " " + _vm._s(_vm.currency) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    class: {
	      'invalid-price': _vm.selectedModel !== 2
	    }
	  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('vue.buy.unlimited'))), _c('span', [_vm._v(" " + _vm._s(_vm.$t('repitition.users')))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("0 " + _vm._s(_vm.currency))])]), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    class: {
	      'invalid-price': _vm.selectedModel !== 2
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.pupils === "" || _vm.pupils < 0 ? '0' : _vm.pupils) + " "), _c('span', [_vm._v(_vm._s(_vm.$t('vue.buy.discount')))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.pupilAmount * 12 : _vm.pupilAmount) + " " + _vm._s(_vm.currency) + "\n            ")])]), _vm._v(" "), (_vm.yearlyPayment) ? _c('div', {
	    staticClass: "flex bg-discount"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.discount')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.per_year')))]), _vm._v(" "), _c('p', [_vm._v("-" + _vm._s(_vm.yearlySavings) + " " + _vm._s(_vm.currency))])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.total')))]), _vm._v(" "), _c('p', [(_vm.yearlyPayment) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue.buy.per_year')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue.buy.per_month')))])]), _vm._v(" "), _c('p', {
	    staticClass: "total-amount"
	  }, [_vm._v(_vm._s(_vm.totalAmount) + " " + _vm._s(_vm.currency))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.payment_info')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-group__input"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue.buy.school_name')) + " *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.schoolName),
	      expression: "schoolName"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.schoolName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.schoolName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-group__input"
	  }, [_c('label', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('vue.buy.your_name'))) + " *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-group__input"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue.buy.your_email')) + " *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-group__input"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue.buy.your_phonenumber')) + " *")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.phone),
	      expression: "phone"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.phone = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "cta-button",
	    attrs: {
	      "disabled": !_vm.buyButtonEnabled
	    },
	    on: {
	      "click": _vm.buyClick
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue.buy.buy')) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-2"
	  }, [_c('div', {
	    staticClass: "center"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.questions')) + " ?")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue.buy.call_us_at')) + " +45 43 31 06 12")])])]), _vm._v(" "), _c('modal', {
	    attrs: {
	      "show": _vm.showModal,
	      "close_on_click_away": true
	    },
	    on: {
	      "close": _vm.closedModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.modalHeader))]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-vertical-center",
	    staticStyle: {
	      "flex-direction": "row",
	      "justify-content": "center",
	      "align-items": "center",
	      "height": "100%"
	    },
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.modalBody)
	    }
	  })]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  })])], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('h4', [_vm._v("Ring til os på")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "tel:43310612"
	    }
	  }, [_vm._v("43 31 06 12")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('h4', [_vm._v("Skriv en en email")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "mailto:kontakt@docendo.dk"
	    }
	  }, [_vm._v("kontakt@docendo.dk")])])
	}]}

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    staticClass: "week-container"
	  }, [_c('div', {
	    staticClass: "header box-shadow"
	  }, [_c('span', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.calRangeView))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))]), _vm._v(" "), _c('v-touch', {
	    staticClass: "close",
	    on: {
	      "tap": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "font-large close-tap"
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer"
	  })])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "container",
	    style: ({
	      height: _vm.height + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "body"
	  }, [_c('weekplan', {
	    staticClass: "weekplan-container",
	    attrs: {
	      "calId": _vm.calId,
	      "date": _vm.date,
	      "events": _vm.events,
	      "weeknote": _vm.weeknote
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-item__tasks"
	  }, [(!_vm.activeNorm) ? _c('Loader', {
	    attrs: {
	      "isSmall": true,
	      "bg-color": "#fff"
	    }
	  }) : _c('table', {
	    staticClass: "d-table d-table__norm d-table__tasks marg-10-bottom"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "d-table__title",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('h4', [_vm._v("Årsverk")])])])]), _vm._v(" "), _c('tbody', [(_vm.activeNorm.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "italic"
	  }, [_vm._v("Ikke tildelt årsverk")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeNormFormatted), function(item) {
	    return (_vm.activeNorm.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  })], 2)]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__norm d-table__tasks marg-10-bottom"
	  }, [_c('tbody', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_c('b', [_vm._v(_vm._s(_vm.planfestet))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Undervisning")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.user.v_user_subjects_hours_label))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oppgaver")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.user.v_user_tasks_hours_label))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_c('b', [_vm._v(_vm._s(_vm.egenDisponibel))])])])])]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__tasks marg-10-bottom"
	  }, [_c('thead', [_c('tr', [_vm._m(2), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.user.v_total_teaching_percentage_label) + "\n      ")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.user.v_user_subjects_hours_label) + "\n      ")])])]), _vm._v(" "), _c('tbody', [(_vm.user.v_user_subjects.length < 1) ? _c('tr', [_c('td', {
	    staticClass: "italic"
	  }, [_vm._v("Ingen undervisning")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.v_user_subjects), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('div', {
	      staticClass: "task-with-edit"
	    }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	      staticClass: "subjects_subject subjects_subject__simple",
	      style: ([{
	        'border-left-color': task.color
	      }, {
	        'background-color': task.color
	      }])
	    }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
	      staticClass: "subjects_subject subjects_subject--not-subject"
	    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(task.v_calendar) + "\n      ")]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(task.v_percentage_label) + "\n      ")]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(task.v_hours_label) + "\n      ")])])
	  })], 2)]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__tasks marg-10-bottom"
	  }, [_c('thead', [_c('tr', [_vm._m(3), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.user.v_user_tasks_hours_label))])])]), _vm._v(" "), _c('tbody', [(_vm.user.v_user_tasks.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen oppgaver")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.v_user_tasks), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('div', {
	      staticClass: "task-with-edit"
	    }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	      staticClass: "subjects_subject subjects_subject__simple",
	      style: ([{
	        'border-left-color': task.color
	      }, {
	        'background-color': task.color
	      }])
	    }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
	      staticClass: "subjects_subject subjects_subject--not-subject"
	    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(task.v_hours_label) + "\n      ")])])
	  })], 2)]), _vm._v(" "), _c('SubjectsDistributionUserAgreements', {
	    attrs: {
	      "userId": _vm.user.id,
	      "userAgreements": _vm.activeUserAgreements,
	      "isReadAgreements": false
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('b', [_vm._v("Sum planfestet arbeidstid")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('b', [_vm._v("Sum egendisponibel resttid")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "d-table__title",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('div', {
	    staticClass: "d-table__title__header"
	  }, [_c('h4', [_vm._v("Undervisning")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "d-table__title"
	  }, [_c('h4', [_vm._v("Oppgaver")])])
	}]}

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sub border marg-20-bottom"
	  }, [_c('div', {
	    staticClass: "sub__user-header space-between flex align-center"
	  }, [_c('div', {
	    staticClass: "flex align-center"
	  }, [_c('img', {
	    staticClass: "marg-20-right rounded sub__user-img",
	    attrs: {
	      "src": _vm.user.default_thumb_url
	    }
	  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('DDropdown', [_c('ul', {
	    staticStyle: {
	      "width": "180px"
	    },
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', [_c('a', {
	    staticClass: "marg-5-left text-link",
	    attrs: {
	      "href": '/calendars/' + _vm.user.user_calendar_id,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['see_calendar']))])]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.setActiveAbsentUser(_vm.user)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_sub_to_multiple_lessons))])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "sub__user-header__right"
	  }, [_c('div', {
	    staticClass: "absence-status"
	  }, [_c('label', {
	    staticClass: "d-label marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['absent_handled']))]), _vm._v(" "), _c('div', {
	    staticClass: "absence__status",
	    on: {
	      "click": function($event) {
	        return _vm.setSubStatusDropdown(12)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot",
	    class: _vm.schedulerUserHandledCls(_vm.user)
	  }), _vm._v(" "), (_vm.isSubStatusDropdown(12)) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeSubStatusDropdown),
	      expression: "closeSubStatusDropdown"
	    }],
	    staticClass: "dropdown absence__status__dropdown sub-status__dropdown",
	    class: {
	      'sub-status__dropdown--loading': _vm.isSubmittingAbsenceStatus
	    }
	  }, [(_vm.isSubmittingAbsenceStatus) ? _c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setAbsenceStatus(0)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot dot-white"
	  }), _vm._v("\n                " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n              ")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setAbsenceStatus(1)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot"
	  }), _vm._v("\n                " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n              ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "absence-reasons"
	  }, _vm._l((_vm.absenceReasons), function(reason) {
	    return _c('div', {
	      staticClass: "absence-reasons__absence"
	    }, [_c('p', {
	      staticClass: "absence-reasons__absence__note"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['note']) + ":")]), _vm._v(" "), _c('weip', {
	      attrs: {
	        "lesson": reason,
	        "noteType": "teacher_notes"
	      },
	      on: {
	        "close": _vm.updateTeacherNote
	      }
	    })], 1), _vm._v(" "), _c('div', [_c('div', {
	      staticClass: "absence-reasons__absence__title"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(reason.title))])]), _vm._v(" "), (reason.event_serial_id) ? _c('p', [(_vm.getIsAbsenceOngoing(reason)) ? [(_vm.getIsAbsenceAutoGenerated(reason)) ? _c('span', {
	      staticClass: "badge badge--orange-warning badge--small badge--clickable",
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditAbsenceReason(reason)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['auto_created']))]) : _c('span', {
	      staticClass: "badge badge--orange badge--small badge--clickable",
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditAbsenceReason(reason)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['ongoing_absence']))])] : _vm._e(), _vm._v(" "), (!_vm.getIsAbsenceOngoing(reason) && _vm.getIsAbsenceMultipleDays(reason)) ? _c('span', {
	      staticClass: "badge badge--small"
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['multiple_days']))]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('p', [(_vm.getSerialListItem(reason)) ? [_vm._v("\n                " + _vm._s(_vm._f("date")(_vm.getSerialListItem(reason).from_date)) + "\n                - " + _vm._s(_vm._f("date")(_vm.getSerialListItem(reason).to_date)) + ", " + _vm._s(_vm._f("showTime")(reason.start)) + " -\n                " + _vm._s(_vm._f("showTime")(reason.end)) + "\n              ")] : [_vm._v("\n                " + _vm._s(_vm._f("absenceDate")(reason.start)) + " -\n                "), _c('span', [_vm._v(_vm._s(_vm._f("showTime")(reason.end)))])]], 2)]), _vm._v(" "), _c('div', {
	      staticClass: "absence-reasons__absence__right"
	    }, [_c('div', {
	      staticClass: "absence-reasons__absence__right__edits"
	    }, [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'top'\n                }"
	      }],
	      staticClass: "icon-bin icon__bg-circle deleteAbsence",
	      attrs: {
	        "content": _vm.$t('vue2.common.delete')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setReadyToDelete(reason)
	        }
	      }
	    }), _vm._v(" "), (_vm.getSerialListItem(reason)) ? _c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'top'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'top'\n                }"
	      }],
	      staticClass: "icon-wrench icon__bg-circle",
	      attrs: {
	        "content": _vm.$t('vue2.common.edit')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheEditAbsenceReason(reason)
	        }
	      }
	    }) : _vm._e()]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'left'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	      }],
	      staticClass: "activity-log icon__bg-circle",
	      attrs: {
	        "content": _vm.i18n[_vm.locale]['log']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showLog(reason)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-clock"
	    })])])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "sub-body"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['lessons_on_day']) + ": " + _vm._s(_vm.sortedEvents.length) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['lessons_affected_by_absence']) + ": " + _vm._s(_vm.overlappingArr.length) + "\n    ")]), _vm._v(" "), (_vm.sortedEvents.length > 0) ? _c('table', {
	    staticClass: "sub-table"
	  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("showDate")(_vm.sortedEvents[0].start))))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['class']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['same_time']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['substitute']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['substitute_notes']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['status']))])]), _vm._v(" "), _vm._l((_vm.sortedEvents), function(lesson, lessonIdx) {
	    return _c('tr', {
	      key: _vm.user.id + '_' + lesson.id,
	      staticClass: "sub-lesson",
	      class: [{
	        'lesson-overlaps': _vm.isLessonOverlappingWithAbsence(lesson)
	      }, {
	        'sub-lesson__absence-overlap--handled': lesson.v_status && lesson.v_status !== 2
	      }, {
	        'sub-lesson__absence-overlap--pending': lesson.v_status === 2
	      }],
	      attrs: {
	        "data-uuid": _vm.user.id + '_' + lesson.id
	      }
	    }, [_c('td', {
	      staticClass: "sub-lesson__time",
	      attrs: {
	        "aria-i18n": _vm.i18n[_vm.locale]['absent']
	      }
	    }, [_c('div', {
	      staticClass: "sub-lesson__time__content"
	    }, [_c('div', [_vm._v(_vm._s(_vm._f("LT")(lesson.start)) + " - " + _vm._s(_vm._f("LT")(lesson.end)))]), _vm._v(" "), _c('button', {
	      staticClass: "bttn bttn-sub-small hint--right",
	      attrs: {
	        "aria-label": _vm.i18n[_vm.locale]['split_lesson']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveSplitLesson(lesson)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })])])]), _vm._v(" "), _c('td', {
	      staticClass: "sub-lesson__title"
	    }, [_vm._v("\n          " + _vm._s(lesson.title) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "100px"
	      }
	    }, _vm._l((lesson.klassesAndOther), function(cal) {
	      return _c('a', {
	        key: cal.id,
	        attrs: {
	          "href": cal.url
	        }
	      }, [_vm._v("\n            " + _vm._s(cal.name) + "\n          ")])
	    }), 0), _vm._v(" "), _c('td', {
	      staticClass: "sub-lesson__others"
	    }, [(_vm.othersOnLesson(lesson).length > 0) ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.i18n[_vm.locale].on_the_lesson))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.othersOnLesson(lesson)), function(user, othersIdx) {
	      return (othersIdx < 3 || lesson.showAllOtherOnLesson) ? _c('div', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: false,
	            zIndex: 123123123123,
	            placement: 'top-start',
	            onShow: function () { return user.v_isUserAbsentFromLesson.length > 0; }
	          }),
	          expression: "{\n                  arrow: false,\n                  zIndex: 123123123123,\n                  placement : 'top-start',\n                  onShow: () => user.v_isUserAbsentFromLesson.length > 0\n                }"
	        }],
	        key: user.id,
	        staticClass: "sub-lesson__others__user",
	        class: {
	          'sub-lesson__others__user--absent': user.v_isUserAbsentFromLesson.length > 0
	        },
	        attrs: {
	          "content": user.v_isUserAbsentFromLesson
	        }
	      }, [(user.v_isUserAbsentFromLesson.length > 0) ? _c('span', {
	        staticClass: "icon-warning"
	      }) : _c('span', {
	        staticClass: "icon-user"
	      }), _vm._v("\n            " + _vm._s(user.name) + "\n          ")]) : _vm._e()
	    }), _vm._v(" "), (_vm.othersOnLesson(lesson).length > 3 && !lesson.showAllOtherOnLesson) ? _c('span', {
	      staticClass: "text-blue pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setShowOtherOnLesson(lesson.id)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_all))]) : _vm._e(), _vm._v(" "), (lesson.showAllOtherOnLesson) ? _c('span', {
	      staticClass: "text-blue pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setShowOtherOnLesson(null)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_less))]) : _vm._e(), _vm._v(" "), (lesson.otherLessonsInKlassThatOverlap.length > 0) ? _c('div', {
	      staticClass: "other_in_klass"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.i18n[_vm.locale].same_time_in_class))])]), _vm._v(" "), _vm._l((lesson.otherLessonsInKlassThatOverlap), function(otherLesson, otherKey) {
	      return (otherKey < 2 || lesson.showOtherLessonsInKlassThatOverlap) ? _c('div', {
	        key: otherLesson.id,
	        staticClass: "lesson",
	        style: ({
	          'borderLeft': '2px solid ' + otherLesson.color + ''
	        })
	      }, [_vm._v("\n              " + _vm._s(otherLesson.title) + ", " + _vm._s(_vm._f("LT")(otherLesson.start)) + " - " + _vm._s(_vm._f("LT")(otherLesson.end)) + "\n              "), _vm._l((otherLesson.users), function(user, key) {
	        return (key < 2 || otherLesson.showAllUsers) ? _c('div', {
	          key: user.id
	        }, [_c('span', {
	          staticClass: "icon-user"
	        }), _vm._v(" " + _vm._s(user.name) + "\n              ")]) : _vm._e()
	      }), _vm._v(" "), (otherLesson.users.length > 2 && !otherLesson.showAllUsers) ? _c('span', {
	        staticClass: "text-blue pointer",
	        on: {
	          "click": function($event) {
	            return _vm.setOtherLessonShowAllUsers(otherLesson.id)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_all))]) : _vm._e(), _vm._v(" "), (otherLesson.showAllUsers) ? _c('span', {
	        staticClass: "text-blue pointer",
	        on: {
	          "click": function($event) {
	            return _vm.setOtherLessonShowAllUsers(null)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].see_less))]) : _vm._e()], 2) : _vm._e()
	    })], 2) : _vm._e(), _vm._v(" "), (lesson.otherLessonsInKlassThatOverlap.length > 2 && !lesson.showOtherLessonsInKlassThatOverlap) ? _c('span', {
	      staticClass: "text-blue pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setShowOtherLessonsInKlassThatOverlap(lesson.id)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].view_all_lessons))]) : _vm._e(), _vm._v(" "), (lesson.showOtherLessonsInKlassThatOverlap) ? _c('span', {
	      staticClass: "text-blue pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setShowOtherLessonsInKlassThatOverlap(null)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].view_less_lessons))]) : _vm._e()], 2), _vm._v(" "), _c('td', {
	      class: {
	        'd-select-lookalike': !_vm.openDSelect(lesson) && _vm.getSubs(lesson).length === 0
	      },
	      staticStyle: {
	        "width": "40%"
	      },
	      attrs: {
	        "aria-placeholder-label": _vm.i18n[_vm.locale]['search']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setDSelect(lesson, lessonIdx)
	        }
	      }
	    }, [(_vm.openDSelect(lesson)) ? _c('dSelectSub', {
	      attrs: {
	        "show": _vm.openDSelect(lesson),
	        "items": _vm.usersForDSelect,
	        "startTime": lesson.start,
	        "endTime": lesson.end,
	        "user": _vm.user,
	        "eventId": lesson.id,
	        "itemsSelected": _vm.getSubs(lesson),
	        "othersOnLesson": _vm.othersOnLesson(lesson),
	        "isUpdatingUsers": _vm.isUpdatingPotentialSubs
	      },
	      on: {
	        "add": function($event) {
	          return _vm.addSubstitute($event, lesson)
	        },
	        "remove": function($event) {
	          return _vm.removeSubstitute($event, lesson)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (!_vm.openDSelect(lesson) && _vm.getSubs(lesson).length > 0) ? _c('div', {
	      staticClass: "d-select__input-look"
	    }, _vm._l((_vm.getSubs(lesson)), function(sub) {
	      return _c('div', {
	        key: sub.id,
	        staticClass: "d-select__selected__item",
	        class: {
	          'd-select__seleted__item--is-error-user': sub.isErrorUser
	        }
	      }, [_vm._v("\n              " + _vm._s(sub.name) + "\n              "), (_vm.subLessonsThatOverlap(lesson, sub.dayAllEvents).length > 0) ? _c('div', {
	        staticClass: "item__icon-warning marg-5-left hint--error hint--top",
	        attrs: {
	          "aria-label": _vm.textFromSubLessonsThatOverlap(lesson, sub.dayEvents)
	        }
	      }) : _vm._e(), _vm._v(" "), (!sub.isErrorUser) ? _c('div', {
	        staticClass: "d-select__selected__item__remove",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.removeSubstitute(sub, lesson)
	          }
	        }
	      }, [_vm._v("×\n              ")]) : _vm._e()])
	    }), 0) : _vm._e()], 1), _vm._v(" "), _c('td', {
	      staticClass: "sub_teacher_notes",
	      class: [{
	          'icon-pencil eip-lookalike eip-lookalike--empty': !_vm.isActiveEIP(lessonIdx) && lesson.teacher_notes.length < 1
	        },
	        {
	          'eip-lookalike eip-filled': !_vm.isActiveEIP(lessonIdx) && lesson.teacher_notes.length > 0
	        }
	      ],
	      staticStyle: {
	        "width": "250px"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveEIP(lessonIdx)
	        }
	      }
	    }, [(!_vm.isActiveEIP(lessonIdx)) ? _c('div', {
	      domProps: {
	        "innerHTML": _vm._s(lesson.teacher_notes)
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.isActiveEIP(lessonIdx)) ? _c('weip', {
	      attrs: {
	        "noteType": "teacher_notes",
	        "lesson": lesson,
	        "isOpen": true
	      },
	      on: {
	        "close": _vm.updateTeacherNote
	      }
	    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "width": "20px"
	      }
	    }, [(lesson.v_substituted && !_vm.isSubStatusPendingActive) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          placement: 'left',
	          arrow: false,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              placement: 'left',\n              arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n          }"
	      }],
	      staticClass: "flex set-status",
	      attrs: {
	        "content": _vm.$t('vue2.sub_scheduler.is_substituted')
	      }
	    }, [_c('div', {
	      staticClass: "dot"
	    })]) : _c('div', {
	      staticClass: "flex set-status pointer",
	      on: {
	        "click": function($event) {
	          return _vm.setSubStatusDropdown(lesson.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "dot",
	      class: [_vm.statusDotClass(lesson), {
	        'dot--loading': lesson.v_isLoading
	      }]
	    }), _vm._v(" "), _c('div', {
	      staticClass: "arrow icon-arrow-down"
	    }), _vm._v(" "), (_vm.isSubStatusDropdown(lesson.id)) ? _c('div', {
	      directives: [{
	        name: "on-clickaway",
	        rawName: "v-on-clickaway",
	        value: (_vm.closeSubStatusDropdown),
	        expression: "closeSubStatusDropdown"
	      }],
	      staticClass: "dropdown sub-status__dropdown"
	    }, [_c('ul', [(!lesson.v_substituted) ? _c('li', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setSubStatus(lesson, 0)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "dot dot-white"
	    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isSubStatusPendingActive) ? _c('li', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setSubStatus(lesson, 2)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "dot dot-yellow"
	    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.pending')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('li', {
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setSubStatus(lesson, 1)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "dot"
	    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n                ")])])]) : _vm._e()])])])
	  })], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "quillelement",
	    staticClass: "quill-on-lesson"
	  }, [_c('weip', {
	    attrs: {
	      "textInput": _vm.text,
	      "isInTestOfSaveButton": false,
	      "noteType": _vm.noteType
	    },
	    on: {
	      "changed": _vm.changed
	    }
	  }), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serverText),
	      expression: "serverText"
	    }],
	    staticClass: "none",
	    attrs: {
	      "name": 'event[' + _vm.noteType + ']',
	      "id": 'event_' + _vm.noteType,
	      "type": "hidden"
	    },
	    domProps: {
	      "value": (_vm.serverText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.serverText = $event.target.value
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    ref: "copy_event_button",
	    attrs: {
	      "id": "vue-popper__copy_event_button"
	    },
	    on: {
	      "click": _vm.openCopyEventDropdown
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + " "), _c('span', {
	    staticClass: "icon-arrow-down5 marg-5-left"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.seen) ? _c('div', {
	    staticClass: "banner",
	    class: {
	      active: _vm.isActive, 'isDone': _vm.isDone
	    }
	  }, [_c('div', {
	    staticClass: "banner-header"
	  }, [_c('div', {
	    staticClass: "banner-header__text pointer"
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.isActive = !_vm.isActive
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-play3"
	  }), _vm._v(" VIDEO: Føj til startskærm")])]), _vm._v(" "), _c('div', {
	    staticClass: "close",
	    on: {
	      "click": _vm.setSeen
	    }
	  }, [_c('span', {
	    staticClass: "black-close box-shadow icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "banner-body"
	  }, [_c('youtube', {
	    attrs: {
	      "video-id": _vm.videoid,
	      "player-width": _vm.w,
	      "player-height": _vm.h
	    }
	  })], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isOpenModal) ? _c('DModal', {
	    staticClass: "d-modal standard-duration",
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.set_standard_duration_for_the_school')))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.standard_duration_for_the_school')))]), _vm._v(" "), _c('div', {
	    staticClass: "input-minutes-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.inputDuration),
	      expression: "inputDuration"
	    }],
	    ref: "duration_input",
	    attrs: {
	      "type": "number",
	      "id": "standard-duration-input",
	      "maxlength": "4"
	    },
	    domProps: {
	      "value": (_vm.inputDuration)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.inputDuration = $event.target.value
	      }
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.set_standard_duration.minutes')) + "\n        ")]), _vm._v(" "), (!_vm.isAValidDuration) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.set_standard_duration.the_number_must_be_divisible_by_five')) + " ")]) : _vm._e()]), _vm._v(" "), (_vm.isForImportInZEN) ? _c('h4', {
	    staticClass: "marg-2-top standard-duration__explained text-explainer"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.set_standard_duration.set_standard_length_for_zen')) + "\n      ")]) : _c('div', {
	    staticClass: "marg-2-top"
	  }, [_c('ul', {
	    staticClass: "disc"
	  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.this_setting_will_be_selected_if_nothing_else_is')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.standard_duration_can_be_selected_for_each_course')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('vue2.set_standard_duration.already_created_courses_want_be_updated')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isAValidDuration) ? _c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")]) : _c('button', {
	    staticClass: "submit-button submit-button--danger bttn bttn--primary",
	    class: {
	      'bttn--loading': _vm.isButtonLoading
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])])], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "scheduler"
	  }, [_c('ul', {
	    staticClass: "scheduler__header"
	  }, [_c('li', [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollTop),
	      expression: "handleScrollTop"
	    }],
	    ref: "topDiv",
	    staticClass: "do-scroller do-scroller--hide"
	  }, [_c('ul', {
	    staticClass: "scheduler__header__times"
	  }, _vm._l((_vm.hoursInLocale), function(number) {
	    return _c('li', [_vm._v(_vm._s(_vm._f("LT")(number)))])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "scheduler__container"
	  }, [_c('div', {
	    staticClass: "do-scroller__container"
	  }, [_c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollLeft),
	      expression: "handleScrollLeft"
	    }],
	    ref: "leftDiv",
	    staticClass: "do-scroller do-scroller-max-height do-scroller--hide do-scroller__users"
	  }, [_c('ul', {
	    staticClass: "scheduler__users"
	  }, _vm._l((_vm.itemsSorted), function(item, idx) {
	    return _c('li', {
	      key: item.id,
	      class: {
	        'item-is-headline': item.headline
	      },
	      style: ({
	        'height': 40 * _vm.rows[item.id] + 'px'
	      })
	    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "scheduler__cal"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "scheduler__cal--loading"
	  }, [_c('Spinner', {
	    staticStyle: {
	      "margin-top": "-120px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "do-scroller__container"
	  }, [_c('div', {
	    directives: [{
	      name: "scroll",
	      rawName: "v-scroll",
	      value: (_vm.handleScrollRight),
	      expression: "handleScrollRight"
	    }],
	    ref: "rightDiv",
	    staticClass: "do-scroller do-scroller-max-height do-scroller--hide"
	  }, [_c('ul', {
	    staticClass: "scheduler__cal__ress"
	  }, [_c('ul', {
	    staticClass: "scheduler__cal__ress__items"
	  }, _vm._l((_vm.itemsSorted), function(item) {
	    return _c('SchedulerItem', {
	      key: item.id,
	      attrs: {
	        "user": item
	      },
	      on: {
	        "rows": function($event) {
	          return _vm.setRows($event, item.id)
	        }
	      }
	    })
	  }), 1), _vm._v(" "), _c('ul', {
	    staticClass: "scheduler__cal__timeslots"
	  }, _vm._l((_vm.hoursInLocale.length * 2), function(n) {
	    return _c('li')
	  }), 0)])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isDropdown) ? _c('div', {
	    ref: "copy_event_panel",
	    staticClass: "copy-event text-dark"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.isDropdownPopperDone) ? _c('div', {
	    staticClass: "copy-event__panel"
	  }, [_c('h3', {
	    style: ({
	      'backgroundColor': _vm.event.color
	    })
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + " " + _vm._s(_vm.event.title) + ", " + _vm._s(_vm.showDateAndTime) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle copy-event__panel__close-cross",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeDropdown.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "copy-event__panel__container"
	  }, [_c('div', {
	    staticClass: "weeks-container"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.componentActiveSchoolYearId),
	      expression: "componentActiveSchoolYearId"
	    }],
	    staticClass: "school-year-selector",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.componentActiveSchoolYearId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.activeSchoolYears), function(year) {
	    return _c('option', {
	      key: year.id,
	      domProps: {
	        "value": year.id
	      }
	    }, [_vm._v("\n              " + _vm._s(year.name) + "\n            ")])
	  }), 0), _vm._v(" "), _c('ul', {
	    staticClass: "weeks"
	  }, [(_vm.weeks.length < 1) ? [_c('Spinner', {
	    staticStyle: {
	      "margin-bottom": "100px"
	    },
	    attrs: {
	      "color": "blue"
	    }
	  })] : _vm._l((_vm.weeks), function(week) {
	    return _c('li', {
	      key: week.serverDate,
	      staticClass: "weeks__week hint--top",
	      class: [{
	          'weeks__week--is-selected': _vm.isWeekSelected(week)
	        },
	        {
	          'weeks__week--is-copy-week': _vm.isCopyWeek(week)
	        }
	      ],
	      attrs: {
	        "aria-label": _vm.tooltipDate(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setSelectedWeek(week)
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm._f("showWeek")(week.date)) + "\n                "), (_vm.isNow(week)) ? _c('span', {
	      staticClass: "weeks__week__now-indicator"
	    }) : _vm._e()])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "copy-event__panel__sidebar"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + "\n            " + _vm._s(_vm._f("showWeek")(_vm.copyDate)))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.addAllWeeksOnward
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.selectOddWeeks
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn width-100 btn-trans",
	    on: {
	      "click": _vm.selectEvenWeeks
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn btn-trans width-100 btn-remove",
	    on: {
	      "click": _vm.removeAllSelectedWeeks
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "copy-event__panel__footer"
	  }, [(_vm.selectedWeeks.length < 1) ? _c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')) + "\n        ")]) : _c('button', {
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')))])])]) : _vm._e()]), _vm._v(" "), (_vm.isDropdown) ? _c('div', {
	    ref: "d_copy_event_overlay",
	    staticClass: "copy-event__overlay",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeDropdown.apply(null, arguments)
	      }
	    }
	  }) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "scheduler_user",
	    class: [{
	        'isAbsence': _vm.user.dayAbsence.length > 0
	      },
	      {
	        'isPotentialSub': _vm.user.dayAbsence.length < 1
	      },
	      {
	        'item-is-headline': _vm.user.headline
	      }
	    ],
	    style: ({
	      'min-height': 40 * _vm.rows + 'px'
	    }),
	    on: {
	      "mouseenter": function($event) {
	        _vm.isShowSelectButton = true
	      },
	      "mouseleave": function($event) {
	        _vm.isShowSelectButton = false
	      }
	    }
	  }, [_vm._l((_vm.correctEvents), function(event) {
	    return _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return event.obj.hasOwnProperty('v_is_event_from_other_school'); }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => event.obj.hasOwnProperty('v_is_event_from_other_school')\n            }"
	      }],
	      key: _vm.user.id + '_' + event.obj.id,
	      ref: _vm.calEvent,
	      refInFor: true,
	      staticClass: "day-cal__event day-cal__event__lesson",
	      class: [{
	          'isActiveEvent animated bigPulseTwo infinite': _vm.activeEvent && event.obj.id === _vm.activeEvent.obj.id && _vm.activeUser && _vm.user.id === _vm.activeUser.id
	        },
	        {
	          'day-cal__event__handled': event.obj.v_status === 1
	        },
	        {
	          'day-cal__event__pending': event.obj.v_status === 2
	        },
	        {
	          'day-cal__event day-cal__event__lesson--from-other-school': event.obj.v_is_event_from_other_school
	        },
	        {
	          'day_cal__event__lesson__overlaps_absent': event.overlapsAbsent
	        },
	        event.subs.length > 0 ? 'hint--left hint--success' : 'hint--right'
	      ],
	      style: ([{
	          'top': event.row * 26 + _vm.hasAbsence + 'px'
	        },
	        {
	          'left': event.left + 'px'
	        },
	        {
	          'right': event.right + 'px'
	        },
	        {
	          'height': '25px'
	        }
	      ]),
	      attrs: {
	        "data-key": _vm.user.id + '_' + event.obj.id,
	        "content": _vm.i18n['from_another_school'],
	        "aria-label": _vm.allOnLessonHumanized(event)
	      }
	    }, [_c('div', {
	      staticClass: "day-cal__event__content",
	      on: {
	        "click": function($event) {
	          return _vm.setPopover(event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "day-cal__event__subs"
	    }, [(event.othersOnLesson.length > 0) ? _c('div', {
	      staticClass: "day-cal__event__other"
	    }, [_vm._v("\n          +"), _c('span', {
	      staticClass: "icon-user"
	    })]) : _vm._e(), _vm._v(" "), _vm._l((event.subs), function(sub) {
	      return _c('img', {
	        staticClass: "day-cal__event__subs__img",
	        attrs: {
	          "src": sub && sub.default_thumb_url ? sub.default_thumb_url : ''
	        }
	      })
	    })], 2), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__content__title"
	    }, [_c('span', {
	      staticClass: "nowrap day-cal__event__content__title__title"
	    }, [_vm._v(_vm._s(event.obj.title))]), _vm._v(" "), (event.klassesOnLesson.length > 0) ? _c('span', {
	      staticClass: "nowrap day-cal__event__content__title__grade"
	    }, [_vm._v(_vm._s(event.klassesAsString))]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__bg",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "day-cal__event__sider",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    })])])
	  }), _vm._v(" "), _vm._l((_vm.userPresenceForPlacing), function(presence) {
	    return (_vm.userAbsence.length < 1) ? _c('div', {
	      key: presence.obj.id,
	      staticClass: "day-cal__event work_hours",
	      style: ([{
	          'left': presence.left + 'px'
	        },
	        {
	          'right': presence.right + 'px'
	        }
	      ])
	    }) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.userAbsenceForPlacing), function(absence) {
	    return _c('div', {
	      key: absence.obj.id,
	      staticClass: "user_absence pointer",
	      style: ([{
	          'left': absence.left + 'px'
	        },
	        {
	          'right': absence.right + 'px'
	        }
	      ]),
	      on: {
	        "click": function($event) {
	          return _vm.setPopover(absence)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "user_absence__text",
	      domProps: {
	        "innerHTML": _vm._s(_vm.getAbsenceTitle(absence.obj))
	      }
	    })])
	  }), _vm._v(" "), (_vm.isShowSetAsSubButton) ? _c('div', {
	    staticClass: "select-user__button",
	    class: {
	      'select-user__button--loading': _vm.selectButtonLoading
	    },
	    style: ({
	      left: (_vm.styleObj.left + 2) + 'px',
	      right: (_vm.styleObj.right + 2) + 'px',
	      backgroundColor: _vm.styleObj.color
	    }),
	    on: {
	      "click": _vm.setAddSubstitute
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('div', {
	    staticClass: "box grid grid-responsive week_notes_lesson_note",
	    style: ({
	      borderColor: _vm.event.color
	    })
	  }, [_c('div', {
	    staticClass: "col-2-12 box-size"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.event.title) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("timeStamp")(_vm.event.start)) + " - " + _vm._s(_vm._f("timeStamp")(_vm.event.end))), _c('br')])]), _vm._v(" "), _c('div', {
	    staticClass: "col-10-12"
	  }, [_c('div', {
	    staticClass: "col-1-3"
	  }, [_c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.learningGoal)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.description)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-1-3"
	  }, [_c('div', {
	    staticClass: "word-break",
	    domProps: {
	      "innerHTML": _vm._s(_vm.notes_for_students)
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    staticClass: "day-cal__overlay",
	    attrs: {
	      "pan-options": {
	        direction: 'horizontal',
	        threshold: 4
	      }
	    },
	    on: {
	      "panleft": _vm.onPan,
	      "panright": _vm.onPan,
	      "panstart": _vm.setPanStart,
	      "panend": _vm.onPanEnd
	    }
	  }, [_c('div', {
	    staticClass: "days-container",
	    style: ({
	      transform: 'translate3d(' + _vm.translateX + '%, 0, 0)'
	    })
	  }, [_vm._l((_vm.calendars), function(cal) {
	    return [_c('div', {
	      staticClass: "day",
	      style: ({
	        webkitTransform: 'translate3d(' + cal.style + '%, 0,0)'
	      })
	    }, [_c('transition', {
	      attrs: {
	        "name": "fadeDown"
	      }
	    }, [_c('mobile-datepicker', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.isActive),
	        expression: "isActive"
	      }],
	      attrs: {
	        "date": cal.date,
	        "theCalendarDate": _vm.theCalendarDate
	      },
	      on: {
	        "changed": _vm.setCalDate
	      }
	    })], 1)], 1)]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-container",
	    class: {
	      'd-container--active': _vm.isDropDown
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.setDropdownFromClick),
	      expression: "setDropdownFromClick"
	    }],
	    ref: "d_parent",
	    staticClass: "d-select__selected",
	    class: {
	      'd-select__selected__dropdown': _vm.isMultiple && _vm.sortedCalendars.length > 1
	    },
	    on: {
	      "click": _vm.setDropdown
	    }
	  }, [_c('h5', [_vm._v(_vm._s(_vm.activeCalendarName))]), _vm._v(" "), _c('svg', {
	    staticClass: "tw-icon tw-icon-cheveron-selection",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	    }
	  })])]), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
	    ref: "d_child",
	    staticClass: "d-select__dropdown",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady, 'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('div', {
	    staticClass: "d-select-input",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    ref: "inputsearch",
	    attrs: {
	      "type": "search"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('ul', _vm._l((_vm.calendarQuery), function(calendar) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.selectCalendar(calendar.id)
	        }
	      }
	    }, [_c('p', [_vm._v(_vm._s(calendar.name))])])
	  }), 0)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    staticStyle: {
	      "height": "1600px"
	    },
	    attrs: {
	      "id": "djs-body-click"
	    }
	  }, [_c('div', {
	    staticClass: "header"
	  }), _vm._v(" "), _c('SideNav'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin": "1rem 1rem 1rem 75px"
	    },
	    attrs: {
	      "id": "djs-content-container"
	    }
	  }, [_c('SalarySubsPerf')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "calendar-guide text-dark"
	  }, [(_vm.isModal) ? _c('d-modal', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "modal__left"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.create_a_link_on_mobile')))]), _vm._v(" "), _c('ul', {
	    staticClass: "export-calendar__cals"
	  }, _vm._l((_vm.integrations), function(integration) {
	    return _c('li', {
	      key: integration.id,
	      class: {
	        'cal--is-active': _vm.theActiveIntegration === integration.id
	      },
	      on: {
	        "click": function($event) {
	          _vm.theActiveIntegration = integration.id
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(integration.title) + "\n            ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "modal__right"
	  }, [_c('h4', {
	    staticClass: "marg-2-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.guide_to')) + " " + _vm._s(_vm.integrations[_vm.theActiveIntegration].title))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theActiveIntegration === 0),
	      expression: "theActiveIntegration === 0"
	    }],
	    staticClass: "embed-container"
	  }, [_c('iframe', {
	    attrs: {
	      "src": "https://www.youtube.com/embed/Vkw-bVsvkq4",
	      "frameborder": "0",
	      "allowfullscreen": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.theActiveIntegration === 1),
	      expression: "theActiveIntegration === 1"
	    }],
	    staticClass: "embed-container"
	  }, [_c('iframe', {
	    attrs: {
	      "src": "https://www.youtube.com/embed/Idpmc8dcFV0",
	      "frameborder": "0",
	      "allowfullscreen": ""
	    }
	  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        return _vm.setIsModal(false)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-box"
	  }, [_c('div', {
	    staticClass: "user-tasks__header"
	  }, [_c('div', [(_vm.isShowScheduled) ? _c('label', {
	    staticClass: "d-label no-print"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.task_overview.showing_scheduled_hours_from')) + " " + _vm._s(_vm.dates) + " (" + _vm._s(_vm.numberOfWorkDaysInPeriod) + "\n        " + _vm._s(_vm.i18n['work_days']) + ")\n      ")]) : _vm._e(), _vm._v(" "), _c('h4', {
	    staticClass: "only-print"
	  }, [_vm._v(_vm._s(_vm.user.name) + ", " + _vm._s(_vm.dates))])]), _vm._v(" "), (_vm.isShowHeader) ? _c('div', {
	    staticClass: "d-input-group no-print no-mobile"
	  }, [_c('label', {
	    staticClass: "d-label",
	    staticStyle: {
	      "margin-bottom": "6px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.show_scheduled_hours')) + " ")]), _vm._v(" "), _c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.setIsShowScheduled(!_vm.isShowScheduled)
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "propOn": _vm.isShowScheduled
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.userNorm.length > 0) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.userNormFormatted), function(item, idx) {
	    return (idx < _vm.userNorm.length - 1) ? _c('tr', {
	      key: item.title
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  }), 0), _vm._v(" "), _c('tfoot', _vm._l((_vm.userNormFormatted), function(item, idx) {
	    return (idx === _vm.userNorm.length - 1) ? _c('tr', {
	      key: item.title
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isKindergarten) ? _c('UserTasksOverviewKindergarten', {
	    attrs: {
	      "isShowScheduled": _vm.isShowScheduled,
	      "isDateIntervalChanged": _vm.isDateIntervalChanged,
	      "assignedTotalHoursForYear": _vm.getUserHoursOverview.assigned_total_hours,
	      "assignedTotalHoursForPeriod": _vm.assignedTotalHoursForPeriod,
	      "diffTotalHoursForPeriod": _vm.diffTotalHoursForPeriod,
	      "userActualHours": _vm.userActualHours,
	      "getUserHoursOverview": _vm.getUserHoursOverview,
	      "tooltipContent": _vm.tooltipContent,
	      "numberOfWorkDays": _vm.numberOfWorkDays,
	      "numberOfWorkDaysInPeriod": _vm.numberOfWorkDaysInPeriod
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isKindergarten) ? _c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.distribution')))])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.getIsCategoryVisible('work_hours')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.work_hours')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v("100%")]) : _vm._e()]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.schoolTooltipContent
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.assignedTotalHoursForPeriod) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_total_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.diffTotalHoursForPeriod))
	  }, [_vm._v("\n        " + _vm._s(_vm.diffTotalHoursForPeriod) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getIsCategoryVisible('teaching')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.teaching')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfTeaching))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_teaching_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_teaching_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.getUserHoursOverview.diff_teaching_hours))
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_teaching_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getIsCategoryVisible('tasks')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.tasks')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfTasks))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_additional_task_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_additional_task_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_additional_task_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getIsCategoryVisible('preparation')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.preparation')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfPrep))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_preparation_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_preparation_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_preparation_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserHoursOverview.assigned_pool_hours > 0 && _vm.getIsCategoryVisible('pool')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.pool')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfPool))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_pool_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_pool_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_pool_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserHoursOverview.substitute_pool_hours > 0 && _vm.getIsCategoryVisible('substitute_hours')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.substitute_hours')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfSubPool))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.substitute_pool_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_substitute_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.getUserHoursOverview.diff_substitute_hours))
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_substitute_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getUserHoursOverview.assigned_club_hours > 0 && _vm.getIsCategoryVisible('club')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.club')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfClub))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.assigned_club_hours))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_club_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator(_vm.getUserHoursOverview.diff_club_hours))
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.diff_club_hours) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSchoolGlHjortespring && _vm.getIsCategoryVisible('teaching_and_club')) ? _c('tr', [_c('td', [_vm._v("Undervisning + SFO")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.assigned_teaching_hours + _vm.getUserHoursOverview.assigned_club_hours) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_club_hours) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator((_vm.getUserHoursOverview.assigned_teaching_hours + _vm.getUserHoursOverview.assigned_club_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_club_hours)))
	  }, [_vm._v("\n        " + _vm._s(_vm.toFixedIfNecessary((_vm.getUserHoursOverview.assigned_club_hours + _vm.getUserHoursOverview.assigned_teaching_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_club_hours))) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isShowSubsAndTeachingActive && _vm.getIsCategoryVisible('teaching_and_sub')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.titleForTeachingAndSubstituteHoursTotal))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.getUserHoursOverview.substitute_pool_hours + _vm.getUserHoursOverview.assigned_teaching_hours) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.toFixedIfNecessary(_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_substitute_hours)) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number",
	    style: (_vm.scaleIndicator((_vm.getUserHoursOverview.substitute_pool_hours + _vm.getUserHoursOverview.assigned_teaching_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_substitute_hours)))
	  }, [_vm._v("\n        " + _vm._s(_vm.toFixedIfNecessary((_vm.getUserHoursOverview.substitute_pool_hours + _vm.getUserHoursOverview.assigned_teaching_hours) - (_vm.getUserHoursOverview.actual_teaching_hours + _vm.getUserHoursOverview.actual_substitute_hours))) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isSchoolWantSum && _vm.getUserAssignedTotalHours > 0 && _vm.getTotalAssigned > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.rest')))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfRest))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.toFixedIfNecessary(_vm.getTotalAssigned)))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getTotalTooMany > 0 && !_vm.isSchoolWantSum && _vm.getUserAssignedTotalHours > 0) ? _c('tr', [_c('td', [_c('span', {
	    staticClass: "d-bagde d-badge--warning"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.diff_from_total_workhours')))])]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [(_vm.getUserAssignedTotalHours > 0) ? _c('div', [_vm._v(_vm._s(_vm.getPercentageOfTooMany))]) : _vm._e()]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.toFixedIfNecessary(_vm.getTotalTooMany)))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.isSchoolWantSum) ? _c('tfoot', [_c('tr', [_c('td', [_vm._v("Sum")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away'
	      }),
	      expression: "{\n          animateFill: false,\n          animation : 'shift-away'\n      }"
	    }],
	    staticClass: "is-number cursor-help",
	    attrs: {
	      "content": "Sum = (Skemalagt UV + Skemalagt SFO + Tildelte Øvrige Opgaver, Tildel Forberedelse osv.) - Total tildelt arbejdstid"
	    }
	  }, [(_vm.getSum > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm.toFixedIfNecessary(_vm.getSum)) + "\n      ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.schoolSettingShownOwnPools.length > 0) ? _c('UserTasksOverviewOwnPools', {
	    attrs: {
	      "schoolSettingShownOwnPools": _vm.schoolSettingShownOwnPools,
	      "isShowScheduled": _vm.isShowScheduled,
	      "isDateIntervalChanged": _vm.isDateIntervalChanged,
	      "userTasks": _vm.userTasksFiltered
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.userTasksFiltered), function(tasks) {
	    return _c('div', {
	      staticClass: "marg-1-bottom"
	    }, [(tasks.title === 'substitute_hours') ? _c('UserTasksTableSubstituteHours', {
	      attrs: {
	        "title": tasks.title,
	        "tasks": tasks.tasks,
	        "userCalendarId": _vm.user.user_calendar_id,
	        "userId": _vm.user.id,
	        "assignedHours": _vm.getUserAssignedTeachingHours,
	        "isShowScheduled": _vm.isShowScheduled
	      }
	    }) : _c('UserTasksTable', {
	      attrs: {
	        "title": tasks.title,
	        "tasks": tasks.tasks,
	        "userCalendarId": _vm.user.user_calendar_id,
	        "userId": _vm.user.id,
	        "assignedHours": _vm.getUserAssignedTeachingHours,
	        "isShowScheduled": _vm.isShowScheduled
	      }
	    })], 1)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "active-user__agreements"
	  }, [_c('SubjectsDistributionUserAgreements', {
	    attrs: {
	      "isReadAgreements": false,
	      "userAgreements": _vm.userAgreements,
	      "userId": _vm.activeUserId
	    }
	  })], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.theActiveSubject) ? _c('DModal', {
	    staticStyle: {
	      "border-radius": "4px"
	    },
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.theActiveSubject = null
	      }
	    }
	  }, [_c('SubjectsDistributionUserEditHours', {
	    attrs: {
	      "slot": "insertComponent",
	      "subject": _vm.getTheActiveSubject,
	      "teacher": _vm.getTheActiveUser
	    },
	    on: {
	      "close": function($event) {
	        _vm.theActiveSubject = null
	      }
	    },
	    slot: "insertComponent"
	  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.theActiveSubject) ? _c('div', {
	    staticClass: "bg-overlay",
	    on: {
	      "click": function($event) {
	        _vm.theActiveSubject = null
	      }
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Timer")])])])
	}]}

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-header"
	  }, [_c('div', {
	    staticClass: "do-nav do-nav__left"
	  }, [_c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": '/plan/' + _vm.schoolId,
	      "active-class": "nav-item--selected"
	    }
	  }, [_c('span', {
	    staticClass: "icon-calendar2"
	  }), _vm._v("\n      Vagtplan\n    ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav-item",
	    attrs: {
	      "to": '/show',
	      "active-class": "nav-item--selected"
	    }
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v("\n      Arbejdstider\n    ")])], 1), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "do-nav nav__right"
	  }, [_c('li')])
	}]}

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tags-filter text-dark",
	    class: {
	      'flex_columns': _vm.columns
	    }
	  }, [_c('div', {
	    staticClass: "tags_filter__selected"
	  }, [_c('span', {
	    staticClass: "icon-filter"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "tags_filter__selected"
	  }, [_c('ul', _vm._l((_vm.selectedTags), function(tag) {
	    return _c('li', [_c('tag', {
	      attrs: {
	        "tag": tag
	      },
	      on: {
	        "remove": _vm.removeTag
	      }
	    })], 1)
	  }), 0)])]), _vm._v(" "), (!_vm.active) ? _c('button', {
	    staticClass: "btn-trans tags-filter__header__s-btn",
	    on: {
	      "click": function($event) {
	        _vm.active = true
	      }
	    }
	  }, [_vm._v("+\n    " + _vm._s(_vm.searchText.length > 1 ? _vm.searchText : _vm.$t('vue2.tagging.search_tag')) + "\n  ")]) : _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.hideActive),
	      expression: "hideActive"
	    }],
	    staticClass: "tags-filter-wrapper"
	  }, [_c('div', {
	    staticClass: "tags-filter__header"
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tagText),
	      expression: "tagText"
	    }],
	    staticClass: "tags-filter__header__search",
	    class: {
	      'show': _vm.showDropdown
	    },
	    attrs: {
	      "type": "search",
	      "autocomplete": "new-password"
	    },
	    domProps: {
	      "value": (_vm.tagText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tagText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tags_filter__tags",
	    class: {
	      'show': _vm.showDropdown
	    }
	  }, [_c('h4', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.tags.length < 1),
	      expression: "tags.length < 1"
	    }]
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.you_have_created_zero_tags')) + " "), _c('a', {
	    attrs: {
	      "href": '/schools/' + _vm.schoolid + '/groups/#/'
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.tagging.create_tags')))])]), _vm._v(" "), _c('h4', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.filteredTags.length < 1 && _vm.tags.length > 0),
	      expression: "filteredTags.length < 1 && tags.length > 0"
	    }]
	  }, [_vm._v("0 " + _vm._s(_vm.$t('vue2.tagging.with')) + " \"" + _vm._s(_vm.tagText) + "\"")]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.filteredTags.length > 0),
	      expression: "filteredTags.length > 0"
	    }]
	  }, _vm._l((_vm.notSelectedTags), function(tag) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setTag(tag)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-price-tag2"
	    }), _vm._v(" " + _vm._s(tag) + " "), (_vm.showHowMany) ? _c('span', [_vm._v("(" + _vm._s(_vm.howManyWithTag(tag)) + ")")]) : _vm._e()])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "th-sorter",
	    class: [_vm.sortProp, {
	      'active': _vm.activeSortKey === _vm.sortProp
	    }],
	    on: {
	      "click": _vm.sortBy
	    }
	  }, [_c('div', {
	    staticClass: "column-width"
	  }, [_vm._v(_vm._s(_vm.title) + "\n  "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "switch",
	    on: {
	      "click": _vm.toggleIsOn
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isOn),
	      expression: "isOn"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "do-switch"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isOn) ? _vm._i(_vm.isOn, null) > -1 : (_vm.isOn)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isOn,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isOn = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isOn = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "slider round",
	    attrs: {
	      "for": "do-switch"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.create_activity.create_new_subject_for')) + " " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.title')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subjectName),
	      expression: "subjectName"
	    }],
	    ref: "d_title_input",
	    staticClass: "d-input",
	    staticStyle: {
	      "height": "34px"
	    },
	    attrs: {
	      "id": "d-title-input-for-new-subject"
	    },
	    domProps: {
	      "value": (_vm.subjectName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subjectName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.choose_subject_type')))]), _vm._v(" "), _c('SubjectFormSubjectType', {
	    attrs: {
	      "calendarType": 'user'
	    },
	    on: {
	      "change": _vm.setSubjectType
	    }
	  })], 1), _vm._v(" "), (!_vm.isLoadingUserSchools && _vm.isUserHasMultipleSchools) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.choose_school')))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theActiveSchoolId),
	      expression: "theActiveSchoolId"
	    }],
	    staticClass: "d-select-with-options",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theActiveSchoolId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.userSchools), function(school) {
	    return _c('option', {
	      key: school.id,
	      domProps: {
	        "value": school.id
	      }
	    }, [_vm._v("\n            " + _vm._s(school.name) + "\n          ")])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "calendar-navigation"
	  }, [_c('button', {
	    staticClass: "nav-button",
	    on: {
	      "click": function($event) {
	        return _vm.navigate('previous')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "icon",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M15.75 19.5L8.25 12l7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('button', {
	    staticClass: "nav-button center-button",
	    on: {
	      "click": _vm.goToToday
	    }
	  }, [_vm._v("I dag")]), _vm._v(" "), _c('button', {
	    staticClass: "nav-button",
	    on: {
	      "click": function($event) {
	        return _vm.navigate('next')
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "icon",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M8.25 4.5l7.5 7.5-7.5 7.5"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-cal-print text-dark"
	  }, [_c('ul', {
	    staticClass: "d-cal-print__cal"
	  }, _vm._l((_vm.weekDays), function(weekDay) {
	    return _c('li', {
	      key: weekDay.date,
	      staticClass: "d-cal-print__cal__day"
	    }, [_c('ul', [_c('li', {
	      staticClass: "d-cal-print__cal__day__header"
	    }, [_vm._v(_vm._s(weekDay.formatted))]), _vm._v(" "), (weekDay.events.length < 1) ? _c('p', {
	      staticClass: "text-explainer center"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons')))]) : _vm._e(), _vm._v(" "), _vm._l((weekDay.events), function(event) {
	      return _c('li', {
	        key: event.event_key,
	        staticClass: "d-cal-print__event",
	        class: {
	          'd-cal-print__event--presence': event.event_type === 'presence'
	        },
	        style: ({
	          backgroundColor: event.color
	        })
	      }, [_c('div', {
	        staticClass: "d-cal-print__event__header"
	      }, [_c('div', {
	        staticClass: "d-cal-print__event__title"
	      }, [_vm._v("\n              " + _vm._s(event.title) + "\n            ")]), _vm._v(" "), _c('div', {
	        staticClass: "d-cal-print__event__time"
	      }, [_vm._v("\n              " + _vm._s(event.event_starttime) + "-" + _vm._s(event.event_endtime) + "\n            ")])]), _vm._v(" "), (event.teacher) ? _c('div', {
	        staticClass: "day-cal__event__calendar"
	      }, [_c('span', {
	        staticClass: "icon-user"
	      }), _vm._v("\n            " + _vm._s(event.teacher) + "\n          ")]) : _vm._e(), _vm._v(" "), (event.room) ? _c('div', {
	        staticClass: "day-cal__event__calendar"
	      }, [_c('span', {
	        staticClass: "icon-location"
	      }), _vm._v("\n            " + _vm._s(event.room) + "\n          ")]) : _vm._e(), _vm._v(" "), (event.group) ? _c('div', {
	        staticClass: "day-cal__event__calendar"
	      }, [_c('span', {
	        staticClass: "icon-users"
	      }), _vm._v("\n            " + _vm._s(event.group) + "\n          ")]) : _vm._e(), _vm._v(" "), (event.students) ? _c('div', {
	        staticClass: "day-cal__event__calendar"
	      }, [_c('span', {
	        staticClass: "icon-users5"
	      }), _vm._v("\n            " + _vm._s(event.students) + "\n          ")]) : _vm._e()])
	    })], 2)])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pos-relative"
	  }, [_c('Modal', {
	    attrs: {
	      "show": _vm.showModal,
	      "show_modal_sidebar": _vm.showImportSubjects
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createklass.create_klasses')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createklass.import_subject_to_the_klass')))])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "tabs"
	  }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
	    staticClass: "title"
	  }, [_c('h3', {
	    staticClass: "flex align-center"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.schoolyear')) + "\n            "), _c('ChangeSchoolYear', {
	    staticStyle: {
	      "margin-left": "10px"
	    },
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.activeSchoolYears.length > 1 && _vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('a', {
	    attrs: {
	      "href": _vm.copySubjectsSchoolYearUrl
	    }
	  }, [_vm._v("\n        >> " + _vm._s(_vm.$t('vue2.year_transfer.year_transfer_link')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "content pos-relative"
	  }, [_c('div', {
	    staticClass: "flex modal-form__titles"
	  }, [_c('h3', {
	    staticClass: "flex-1"
	  }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createklass.klass_name')))]) : _c('span', [_vm._v("Klasser uden fag")])]), _vm._v(" "), (_vm.showImportSubjects) ? _c('h3', {
	    staticClass: "flex-2"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.klass_step')))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.klasses), function(klass, key) {
	    return _c('div', {
	      staticClass: "modal-form-group",
	      class: [{
	        'bgDelete': klass.deleteClass
	      }, {
	        'modal-form-group__already_created_klass': _vm.alreadyCreatedKlassesToImportSubjectTo.length > 0
	      }, {
	        'modal-form-group--first': key === 0
	      }]
	    }, [_c('div', {
	      staticClass: "flex create-form"
	    }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
	      staticClass: "flex-1"
	    }, [_c('input', {
	      ref: klass,
	      refInFor: true,
	      staticClass: "namefield",
	      class: [{
	        'missing-input': !klass.isValid
	      }, {
	        'missing-input': klass.isSameName
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "1.a"
	      },
	      on: {
	        "input": function($event) {
	          return _vm.checkAllForText(klass, key, $event.target.value)
	        }
	      }
	    })]) : _c('div', {
	      staticClass: "flex-1 create-form__name"
	    }, [_vm._v("\n              " + _vm._s(klass.name) + "\n            ")]), _vm._v(" "), (_vm.showImportSubjects) ? _c('div', {
	      staticClass: "import-klass flex-2"
	    }, _vm._l((_vm.stepNumbers), function(klassStep, key) {
	      return _c('div', {
	        staticClass: "import-klass__step",
	        class: [{
	            'lastStep': key === (_vm.stepNumbers.length - 1)
	          },
	          {
	            'firstStep': key === 0
	          },
	          {
	            'isActive': klass.template === klassStep
	          }
	        ],
	        on: {
	          "click": function($event) {
	            return _vm.setKlassImport(klass, klassStep, $event)
	          },
	          "mouseenter": function($event) {
	            return _vm.mouseOverStep(klassStep, $event, klass)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "import-klass__step__inner"
	      }, [_vm._v(_vm._s(klassStep))])])
	    }), 0) : _vm._e()]), _vm._v(" "), (_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
	      staticClass: "delete__user",
	      on: {
	        "click": function($event) {
	          return _vm.removeKlass(klass)
	        },
	        "mouseenter": function($event) {
	          return _vm.addDeleteClass(klass)
	        },
	        "mouseleave": function($event) {
	          return _vm.removeDeleteClass(klass)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })]) : _vm._e()])
	  }), _vm._v(" "), _c('div', [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
	    staticClass: "add-more-button",
	    on: {
	      "click": _vm.pushNewKlass
	    }
	  }, [_c('span', {
	    staticClass: "plus--icon"
	  }, [_vm._v("\n            +\n          ")]), _vm._v(" "), _c('span', {
	    staticClass: "add-more-button__text"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.createusers.add_more')))])]) : _vm._e()])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(_vm.someWithSameName) ? _c('p', {
	    staticClass: "error-message marg-20-right warning-text"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.warning_text')))]) : _vm._e(), _vm._v(" "), (_vm.showInactiveButton) ? _c('button', {
	    staticClass: "submit-btn--disabled"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.showInactiveButton && !_vm.isAwaitingServerResponse) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submitOrSetDuration
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.showInactiveButton && _vm.isAwaitingServerResponse) ? _c('button', {
	    staticClass: "submit-button submit-button--loading"
	  }) : _vm._e(), _vm._v(" "), _c('StandardDurationSetting', {
	    attrs: {
	      "isOpenModal": _vm.isOpenDurationModal
	    },
	    on: {
	      "close": function($event) {
	        _vm.isOpenDurationModal = false
	      },
	      "submit": _vm.saveDuration
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "width-100",
	    attrs: {
	      "slot": "sidebar"
	    },
	    slot: "sidebar"
	  }, [(!_vm.klassStepIsSelected) ? _c('div', {
	    staticClass: "explainer-text align-center pad-20"
	  }, [_c('div', {
	    staticClass: "marg-10-right"
	  }, [_c('span', {
	    staticClass: "icon-ask icon-question3"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.import_subjects_question')))])]) : _c('div', {
	    staticClass: "explainer-text align-center pad-20"
	  }, [_c('div', {
	    staticClass: "marg-10-right"
	  }, [_c('span', {
	    staticClass: "step-is-choosen icon-checkmark-circle"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.import_subjects_done')))])]), _vm._v(" "), _c('ShowSubjects', {
	    attrs: {
	      "arrowPosition": _vm.subjectsArrowPosition,
	      "activeKlassStep": _vm.activeKlassStep,
	      "klassStepIsSelected": _vm.klassStepIsSelected,
	      "country": _vm.country
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "small-arrow",
	    style: ({
	      top: _vm.subjectsArrowPosition + 5 + 'px'
	    })
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeClick),
	      expression: "closeClick"
	    }],
	    ref: "d_show_event",
	    staticClass: "d-show-event",
	    class: {
	      'd-show-event__changes-made': _vm.isChangesMade
	    },
	    attrs: {
	      "data-event-id": _vm.event ? _vm.event.event_id : ''
	    }
	  }, [(!_vm.isEveryThingReady) ? _c('div', {
	    staticClass: "d-show-event__init-loader"
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212\n             }"
	    }],
	    staticClass: "d-show-event__close d-show-event__close__loader icon__bg-circle",
	    attrs: {
	      "content": _vm.escTooltip
	    },
	    on: {
	      "click": _vm.closeClick
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  })], 1) : _c('div', {
	    staticClass: "d-show-event__content"
	  }, [_c('div', {
	    ref: "d_show_event_header",
	    staticClass: "d-show-event__header",
	    style: ({
	      backgroundColor: _vm.event.color
	    })
	  }, [_c('div', {
	    staticClass: "d-show-event__header__do-warning__container"
	  }, [(_vm.isCanceled) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning do-warning--canceled"
	  }, [_c('span', {
	    staticClass: "icon-notification22"
	  }), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].canceled) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isAway) ? _c('div', {
	    staticClass: "d-show-event__header__do-warning do-warning"
	  }, [_c('span', {
	    staticClass: "icon-home2 icon-home2-away",
	    staticStyle: {
	      "margin-right": "2px"
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].out_of_school))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    ref: "copy_event_button",
	    staticClass: "d-show-event__header__top",
	    attrs: {
	      "id": "vue-popper__copy_event_button"
	    }
	  }, [(_vm.isCanEditEvent) ? [(_vm.event.calendar_id !== _vm.calendarId) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n        placement: 'bottom',\n        zIndex: 1212121212\n      }"
	    }],
	    staticClass: "icon__bg-circle",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['go_to_calendar']
	    },
	    on: {
	      "click": _vm.goToCalendarForLesson
	    }
	  }, [_c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.event.calendar_id !== _vm.calendarId && _vm.eventMainCalendarType === 'merge') ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n        placement: 'bottom',\n        zIndex: 1212121212\n      }"
	    }],
	    staticClass: "icon__bg-circle dialog-header__bin",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['only_delete_this']
	    },
	    on: {
	      "click": _vm.setIsConfirmDeleteMerge
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin pointer"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isPossibleToDelete) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n        placement: 'bottom',\n        zIndex: 1212121212\n      }"
	    }],
	    staticClass: "icon__bg-circle dialog-header__bin",
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['delete_event']
	    },
	    on: {
	      "click": function($event) {
	        _vm.isConfirmDelete = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin pointer"
	  })]) : _vm._e(), _vm._v(" "), (_vm.event.calendar_id === _vm.calendarId && _vm.showSettings && _vm.event.event_type !== 'absence') ? _c('DDropdown', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 12121212
	      }),
	      expression: "{placement: 'bottom', zIndex: 12121212}"
	    }],
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['settings']
	    }
	  }, [_c('ul', {
	    staticClass: "large-list",
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('li', {
	    on: {
	      "click": _vm.openCopyEventDropdown
	    }
	  }, [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['copy_event_onward']) + "\n              ")]), _vm._v(" "), _c('li', {
	    staticClass: "d-item-warning",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.setIsDeleteOnWard.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].delete_events_onward) + "\n              ")]), _vm._v(" "), _c('li', {
	    staticClass: "d-cancel-lesson-item",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsCancelLesson(true)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-notification22"
	  }), _vm._v("\n                " + _vm._s(!_vm.isCanceled ? _vm.i18n[_vm.locale].cancel_event : _vm.i18n[_vm.locale].uncancel_event) + "\n              ")]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsOutOfSchoolLesson(true)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-home2 icon-home2-away"
	  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].out_of_school) + "\n              ")])])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212\n             }"
	    }],
	    staticClass: "d-show-event__close icon__bg-circle",
	    attrs: {
	      "content": _vm.escTooltip
	    },
	    on: {
	      "click": _vm.closeClick
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])], 2), _vm._v(" "), (_vm.isDeleteOnWard) ? _c('DeleteEventOnward', {
	    attrs: {
	      "isInDCalendar": true,
	      "event": _vm.event
	    },
	    on: {
	      "submit": _vm.submitDeleteEventOnward,
	      "close": function($event) {
	        _vm.isDeleteOnWard = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isInDCalendar) ? _c('CopyEvent') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__text"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), (_vm.isCanEditEvent && _vm.event.calendar_id !== _vm.calendarId) ? _c('h4', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom-start',
	        zIndex: 1212121212
	      }),
	      expression: "{\n              placement: 'bottom-start',\n              zIndex: 1212121212\n            }"
	    }],
	    class: {
	      'd-show-event__header__text__calendar-link': _vm.event.calendar_id !== _vm.calendarId
	    },
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['go_to_calendar']
	    },
	    on: {
	      "click": _vm.goToCalendarForLesson
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.getCalendarName) + "\n          "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
	    }
	  })])]) : _c('h4', [_vm._v(_vm._s(_vm.getCalendarName))])]), _vm._v(" "), (!_vm.isEventLoading) ? [_c('div', {
	    staticClass: "d-show-event__header__text--with-icon"
	  }, [_c('div', {
	    staticClass: "dialog-icon"
	  }, [(_vm.isCanEditEvent) ? _c('span', {
	    staticClass: "icon-calendar4"
	  }) : _vm._e()]), _vm._v(" "), (!_vm.isCanEditEvent) ? _c('div', {
	    staticClass: "dialog-text dialog-text__time"
	  }, [_vm._v("\n            " + _vm._s(_vm.dayAndDate) + "\n          ")]) : _c('div', {
	    staticClass: "dialog-text dialog-text__date"
	  }, [(!_vm.isEditDate) ? _c('p', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212\n             }"
	    }],
	    attrs: {
	      "content": _vm.i18n[_vm.locale]['edit_date']
	    },
	    on: {
	      "click": function($event) {
	        _vm.isEditDate = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.dayAndDate))]) : _c('DateSelector', {
	    attrs: {
	      "isOpen": true,
	      "date": _vm.startDate
	    },
	    on: {
	      "changed": _vm.setStartDate
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__text--with-icon"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "dialog-text dialog-text__time"
	  }, [(!_vm.isCanEditEvent) ? _c('div', {
	    staticClass: "dialog-text__time__time"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.formattedEventStart) + " - " + _vm._s(_vm.formattedEventEnd))]), _vm._v("\n              (" + _vm._s(_vm.formattedDuration) + ")\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isCanEditEvent) ? _c('TimeChanger', {
	    attrs: {
	      "start": _vm.event.start,
	      "end": _vm.event.end,
	      "addClass": "doc-times"
	    },
	    on: {
	      "updateStart": _vm.updateStartTime,
	      "updateEnd": _vm.updateEndTime
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.isChangesMade) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  placement : 'bottom',\n                  zIndex: 12312312312312\n                }"
	    }],
	    staticClass: "bttn-primary bttn box-shadow",
	    attrs: {
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.common.save')) + "\n              ")]) : _vm._e()])], 1)])] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__tabs"
	  }, [_c('div', {
	    staticClass: "d-show-event__header__tabs__tab",
	    class: {
	      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(0)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(0)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.edit')) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__header__tabs__tab",
	    class: {
	      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(1)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['activity']) + "\n        ")]), _vm._v(" "), (_vm.isShowReplaceAndSwap) ? _c('div', {
	    staticClass: "d-show-event__header__tabs__tab",
	    class: {
	      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(2)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(2)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-shuffle"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['swap_lesson']) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isShowReplaceAndSwap) ? _c('div', {
	    staticClass: "d-show-event__header__tabs__tab",
	    class: {
	      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(3)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveTab(3)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-shuffle"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['replace_lesson']) + "\n        ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-show-event__body",
	    style: ({
	      maxHeight: ("calc(100vh - " + _vm.dShowEventBodyMaxHeight + "px)")
	    })
	  }, [(_vm.isEventLoading) ? _c('Loader', {
	    staticStyle: {
	      "margin-top": "40px"
	    },
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : [(_vm.isTheActiveTab(0)) ? _c('div', {
	    staticClass: "d-show-event__form"
	  }, [(!_vm.isCanEditEvent) ? [(_vm.eventUsers.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.teachers')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventUsers), function(user) {
	    return _c('div', {
	      key: user.calendar_id,
	      staticClass: "event-cals__cal",
	      class: {
	        'event-cals__cal--sub': user.v_sub
	      }
	    }, [(user.v_sub) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          zIndex: 1231231231233,
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 1231231231233,\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "d-select__selected__item__warning icon__bg-circle icon__bg-circle--small",
	      attrs: {
	        "content": user.v_sub
	      }
	    }, [_c('span', {
	      staticClass: "icon-users3"
	    })]) : _vm._e(), _vm._v("\n                  " + _vm._s(user.name) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventSubstitutes.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-users3"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.substitutes')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventSubstitutes), function(cal) {
	    return _c('div', {
	      key: cal.calendar_id,
	      staticClass: "event-cals__cal"
	    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventRooms.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.rooms')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventRooms), function(cal) {
	    return _c('div', {
	      key: cal.calendar_id,
	      staticClass: "event-cals__cal"
	    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventKlasses.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.klass')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventKlasses), function(cal) {
	    return _c('div', {
	      key: cal.calendar_id,
	      staticClass: "event-cals__cal"
	    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventStudents.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group input-group--uneditable"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('div', {
	    staticClass: "event-cals"
	  }, _vm._l((_vm.eventStudents), function(cal) {
	    return _c('div', {
	      key: cal.calendar_id,
	      staticClass: "event-cals__cal"
	    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
	  }), 0)]) : _vm._e()] : [(_vm.usersNotOnSchool.length > 0) ? _c('DCalendarShowEventUsersNotOnSchool', {
	    attrs: {
	      "usersNotOnSchool": _vm.usersNotOnSchool,
	      "event": _vm.event,
	      "activeSchoolName": _vm.activeSchoolName
	    },
	    on: {
	      "removeCalendar": _vm.deleteCalendarFromCalendars,
	      "updateAndClose": _vm.updateAndClose
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.teachers')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "user",
	      "showTags": true,
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.userCalendarIds,
	      "itemsThatCantBeDeleted": _vm.usersWithSubstitute,
	      "itemsUnselectable": _vm.substituteCalendarIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears,
	      "isDeleteAllAnOption": _vm.substituteCalendarIds.length === 0
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedUsers
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'reservation' && _vm.event.event_type !== 'absence' && (_vm.userCalendarIds.length > 0 || this.ownerCalendarType === 'user')) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-users3"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.substitutes')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "user",
	      "showTags": true,
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.originalSubstituteCalendarIds,
	      "itemsUnselectable": _vm.userCalendarIds,
	      "showCreateButton": false,
	      "disableAddMore": _vm.possibleTeachersToSub.length < 1,
	      "disableAddMoreMessage": _vm.i18n[_vm.locale]['only_one_substitute_per_teacher'],
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedSubstitutes
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'absence') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.rooms')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "room",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.roomCalendarIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedRooms
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'kindergarten') ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v(" Stuer")]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "kindergarten",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.kindergartenCalendarsIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedKindergartenCalendar
	    }
	  })], 1)] : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'club') ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.club.club')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "club",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.clubCalendarsIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedClubCalendar
	    }
	  })], 1)] : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'other') ? [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-clipboard2"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.other_calendars')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "other",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.otherCalendarsIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedOtherCalendar
	    }
	  })], 1)] : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'klass') ? [(_vm.event.event_type !== 'reservation' && _vm.event.event_type !== 'absence' && !_vm.isShowKlass) ? _c('div', {
	    staticClass: "input-group input-group__label-link"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isShowKlass),
	      expression: "isShowKlass"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isShowKlass) ? _vm._i(_vm.isShowKlass, null) > -1 : (_vm.isShowKlass)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isShowKlass,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isShowKlass = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isShowKlass = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isShowKlass = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "d-link-text",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowKlass(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_grade))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInLeft"
	    },
	    on: {
	      "after-enter": _vm.onKlassDSelectTransitionDone
	    }
	  }, [(_vm.event.event_type !== 'absence' && _vm.isShowKlass) ? _c('div', {
	    staticClass: "input-group input-group__grades"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.klass')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "klass",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.klassCalendarIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedKlasses
	    }
	  })], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.isStudentsActivated && _vm.event.event_type !== 'absence' && _vm.event.event_type !== 'reservation') ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('DSelectCalendars', {
	    attrs: {
	      "itemType": "student",
	      "event": _vm.event,
	      "eventId": _vm.event.event_id,
	      "preSelectedItems": _vm.studentCalendarIds,
	      "showCreateButton": false,
	      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
	      "eventSchoolCalendars": _vm.eventSchoolCalendars,
	      "eventSchoolUsers": _vm.eventSchoolUsers,
	      "eventSchoolYears": _vm.eventSchoolYears
	    },
	    on: {
	      "updateAndClose": _vm.updateAndClose,
	      "update": _vm.setSelectedStudents
	    }
	  })], 1) : _vm._e()], _vm._v(" "), (_vm.isShowLearningGoal && (_vm.event.learning_goal.length > 0 || _vm.event.event_type !== 'absence') && (_vm.canEditNotes || (!_vm.canEditNotes && _vm.event.learning_goal.length > 0))) ? _c('div', {
	    staticClass: "d-notes"
	  }, [_c('label', {
	    style: ({
	      'color': _vm.event.color
	    })
	  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].learning_goal))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].meeting_purpose))]) : _vm._e()]), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.learning_goal)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
	    attrs: {
	      "isInDCalendar": true,
	      "isInTestOfSaveButton": false,
	      "lesson": _vm.event,
	      "noteType": "learning_goal"
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setNoteChanges($event, 'learning_goal')
	      }
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isShowOnlyNotes && (_vm.event.description.length > 0 || _vm.event.event_type !== 'absence') && (_vm.canEditNotes || (!_vm.canEditNotes && _vm.event.description.length > 0))) ? _c('div', {
	    staticClass: "d-notes"
	  }, [_c('label', {
	    style: ({
	      'color': _vm.event.color
	    })
	  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].content))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].agenda))]) : _vm._e()]), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
	    attrs: {
	      "isInDCalendar": true,
	      "isInTestOfSaveButton": false,
	      "lesson": _vm.event,
	      "noteType": "description"
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setNoteChanges($event, 'description')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.description)
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isShowNotesForStudent && (_vm.event.notes_for_students.length > 0 || _vm.event.event_type !== 'absence') && _vm.canEditNotes || (!_vm.canEditNotes && _vm.event.notes_for_students.length > 0)) ? _c('div', {
	    staticClass: "d-notes"
	  }, [_c('label', {
	    style: ({
	      'color': _vm.event.color
	    })
	  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].pupil_preparation))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].decisions_and_resume))]) : _vm._e()]), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
	    attrs: {
	      "isInDCalendar": true,
	      "isInTestOfSaveButton": false,
	      "lesson": _vm.event,
	      "noteType": "notes_for_students"
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setNoteChanges($event, 'notes_for_students')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.notes_for_students)
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isShowTeacherNotes && _vm.canEditNotes || (!_vm.canEditNotes && _vm.event.teacher_notes.length > 0)) ? _c('div', {
	    staticClass: "d-notes"
	  }, [_c('label', {
	    style: ({
	      'color': _vm.event.color
	    })
	  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].teacher_notes))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].internal_notes))]) : _vm._e()]), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
	    attrs: {
	      "isInDCalendar": true,
	      "isInTestOfSaveButton": false,
	      "lesson": _vm.event,
	      "noteType": "teacher_notes"
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setNoteChanges($event, 'teacher_notes')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
	    staticClass: "dialog-text__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.event.teacher_notes)
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['this_lesson_counts_as']))]), _vm._v(" "), _c('p', {
	    staticClass: "lesson-count-as"
	  }, [_vm._v(_vm._s(_vm.eventTypeTranslated) + ": " + _vm._s(_vm.eventDurationForCalendar))])])], 2) : _vm._e(), _vm._v(" "), (_vm.isTheActiveTab(1)) ? _c('div', {
	    staticClass: "d-show-event__form"
	  }, [_c('EventChanges', {
	    attrs: {
	      "event": _vm.event,
	      "event-id": _vm.event.event_id
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTheActiveTab(2)) ? _c('div', {
	    staticClass: "d-show-event__form"
	  }, [_c('EventSwapOrReplace', {
	    attrs: {
	      "propEvent": _vm.event,
	      "type": "swap"
	    },
	    on: {
	      "update": _vm.updateAndClose
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTheActiveTab(3)) ? _c('div', {
	    staticClass: "d-show-event__form"
	  }, [_c('EventSwapOrReplace', {
	    attrs: {
	      "propEvent": _vm.event,
	      "type": "replace"
	    },
	    on: {
	      "update": _vm.updateAndClose
	    }
	  })], 1) : _vm._e()]], 2), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeUp"
	    }
	  }, [(_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-show-event__footer"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'top',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  placement : 'top',\n                  zIndex: 12312312312312\n                }"
	    }],
	    staticClass: "bttn-primary bttn box-shadow",
	    attrs: {
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn box-shadow marg-1-left",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.dont_save')))])]) : _vm._e()]), _vm._v(" "), (_vm.isConfirmDelete) ? _c('ModalConfirmation', {
	    staticClass: "d-modal--from-top",
	    attrs: {
	      "show-close": false,
	      "appendToBody": true,
	      "isOnlyOwnCalendarText": _vm.isOnlyOwnCalendarTextWarning
	    },
	    on: {
	      "close": _vm.closeIsConfirmDelete,
	      "confirm": _vm.deleteEvent
	    }
	  }, [(_vm.originalSubstituteCalendarIds.length > 0) ? _c('div', {
	    staticClass: "d-custom-warning alert",
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [_c('span', {
	    staticClass: "icon-users3"
	  }), _vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['you_are_about_to_delete_substitutes']) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.subToSelectWhoToSubFor) ? _c('DCalendarsShowEventSubFor', {
	    attrs: {
	      "substitute": _vm.subToSelectWhoToSubFor,
	      "teachers": _vm.possibleTeachersToSub
	    },
	    on: {
	      "select": _vm.setTeacherToSub,
	      "cancel": _vm.cancelSubToSelectWhoToSubFor
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.isClosingWithoutSaving && !_vm.isEventLoading) ? _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__closing-without-saving text-dark",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.save_changes')))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unsaved_changes_will_be_lost']))])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__footer"
	  }, [_c('button', {
	    staticClass: "bttn bttn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.dont_save')))]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isClosingWithoutSaving = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isCancelLesson) ? _c('DModalCancelLesson', {
	    attrs: {
	      "event": _vm.event
	    },
	    on: {
	      "updated": _vm.onEventUpdated,
	      "close": function($event) {
	        return _vm.setIsCancelLesson(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isOutOfSchoolLesson) ? _c('DModalOutOfSchoolLesson', {
	    attrs: {
	      "event": _vm.event
	    },
	    on: {
	      "updated": _vm.onEventUpdated,
	      "close": function($event) {
	        return _vm.setIsOutOfSchoolLesson(false)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-show-event__overlay",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.closeClick.apply(null, arguments)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dialog-icon"
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  })])
	}]}

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "flex modal-form__titles"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.createusers.name')) + "*")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue2.createusers.login_options')) + " -\n      "), _c('span', {
	    staticClass: "text-grey italic font-small"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.can_be_added_later')))])])]), _vm._v(" "), _vm._l((_vm.users), function(user, key) {
	    return _c('div', {
	      staticClass: "modal-form-group",
	      class: {
	        'hoverDanger': user.userHoverDanger
	      }
	    }, [_c('div', {
	      staticClass: "create-form"
	    }, [_c('div', {
	      staticClass: "create-form__name"
	    }, [_c('input', {
	      staticClass: "namefield",
	      class: {
	        'inputError': !user.nameIsValid
	      },
	      attrs: {
	        "type": "text",
	        "placeholder": _vm.$t('vue2.createusers.placeholder_name')
	      },
	      on: {
	        "input": function($event) {
	          return _vm.checkAllForText($event.target.value, 'username', key)
	        },
	        "blur": function($event) {
	          return _vm.validate(user, key)
	        },
	        "focus": function($event) {
	          return _vm.unValidate(user, key)
	        }
	      }
	    }), _vm._v(" "), (!user.nameIsValid) ? _c('span', {
	      staticClass: "error-text"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.must_be_added')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "create-form__login"
	    }, [(_vm.country.toLowerCase() === 'dk') ? _c('div', [_c('input', {
	      staticClass: "UniLogin",
	      class: {
	        'inputPristine': user.unilogin.length < 1
	      },
	      attrs: {
	        "type": "text",
	        "placeholder": "uni-login"
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.validate(user, key)
	        },
	        "focus": function($event) {
	          return _vm.unValidate(user, key)
	        },
	        "input": function($event) {
	          return _vm.checkAllForText($event.target.value, 'unilogin', key)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (_vm.country.toLowerCase() === 'no') ? _c('div', [_c('input', {
	      staticClass: "feide",
	      class: [{
	        'inputPristine': user.feide.length < 1
	      }, {
	        'input--error': _vm.getIsUserWithSameFeide(user)
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "feide"
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.validate(user, key)
	        },
	        "focus": function($event) {
	          return _vm.unValidate(user, key)
	        },
	        "input": function($event) {
	          return _vm.checkAllForText($event.target.value, 'feide', key)
	        }
	      }
	    }), _vm._v(" "), (_vm.getIsUserWithSameFeide(user)) ? _c('p', {
	      staticClass: "error-text"
	    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.createusers.feide_is_already_used_for')) + " " + _vm._s(_vm.userWithSameFeide.name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
	      class: [{
	        'inputError': !user.validEmail
	      }, {
	        'inputPristine': user.email.length < 1
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": _vm.$t('vue2.createusers.mail')
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.validateEmail(user, $event.target.value, key)
	        },
	        "keyup": function($event) {
	          return _vm.checkEmailAndAllForText(user, $event.target.value, key)
	        },
	        "focus": function($event) {
	          return _vm.unValidate(user, key)
	        }
	      }
	    }), _vm._v(" "), (!user.validEmail) ? _c('span', {
	      staticClass: "error-text"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.email_error_text')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	      staticClass: "delete__user",
	      on: {
	        "click": function($event) {
	          return _vm.removeUser(user)
	        },
	        "mouseenter": function($event) {
	          return _vm.setHoverDanger(key)
	        },
	        "mouseleave": function($event) {
	          return _vm.removeHoverDanger(key)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })])])
	  }), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "add-more-button",
	    on: {
	      "click": _vm.pushNewUser
	    }
	  }, [_c('span', {
	    staticClass: "plus--icon"
	  }, [_vm._v("\n            +\n          ")]), _vm._v(" "), _c('span', {
	    staticClass: "add-more-button__text"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.createusers.add_more')))])])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container",
	    class: {
	      'd-timetal__container__width': !_vm.isShowSubjects
	    }
	  }, [_c('div', {
	    staticClass: "d-guides"
	  }, [_c('StilGuides', {
	    attrs: {
	      "video-id": _vm.videoGuideId,
	      "textForLink": _vm.videoGuideText
	    }
	  }), _vm._v(" "), (_vm.isShowSubjects) ? _c('p', {
	    staticClass: "italic"
	  }, [_c('b', [_vm._v("Bemærk:")]), _vm._v(" Opret, slet eller redigere fag påvirker kun\n      indberetningsdata'en - ikke i resten af Docendo")]) : _vm._e()], 1), _vm._v(" "), _c('table', {
	    staticClass: "d-table",
	    class: {
	      'd-table__subjects': _vm.isShowSubjects
	    }
	  }, [(!_vm.isShowSubjects) ? _c('thead', [_c('tr', {
	    staticClass: "tr--one"
	  }, [_c('th', [_vm._v("Klasse")]), _vm._v(" "), _c('th', [_vm._v("Klassetrin")]), _vm._v(" "), _c('th', [_vm._v("Spor")]), _vm._v(" "), _c('th', [_c('div', {
	    staticClass: "th__title-and-button"
	  }, [_vm._v("\n          Klassetype\n        "), _c('button', {
	    on: {
	      "click": _vm.setIsModalCreateGrade
	    }
	  }, [_vm._v("Opret klasse")])])])])]) : _vm._e(), _vm._v(" "), _c('tbody', [_vm._l((_vm.klasserMedProps), function(klasse) {
	    return [_c('tr', {
	      staticClass: "tr--one pos-relative"
	    }, [_c('td', {
	      staticClass: "grade-name"
	    }, [(!_vm.isShowSubjects) ? _c('div', {
	      staticClass: "hint--top-right d-hidden__dropdown",
	      attrs: {
	        "aria-label": "Slet klasse og fag fra indberetningen"
	      }
	    }, [_c('button', {
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteGrade(klasse)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])]) : _vm._e(), _vm._v("\n          " + _vm._s(klasse.klassebetegnelse) + "\n          "), (_vm.isShowSubjects) ? _c('button', {
	      staticClass: "klasse__create__btn",
	      on: {
	        "click": function($event) {
	          _vm.theCreateSubject = klasse
	        }
	      }
	    }, [_vm._v("\n            Opret fag\n          ")]) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isShowSubjects) ? _c('select', {
	      staticClass: "d-select__small",
	      domProps: {
	        "value": klasse.klassetrin
	      },
	      on: {
	        "change": function($event) {
	          return _vm.updateStilKlasse(klasse, 'klassetrin', $event.target.value)
	        }
	      }
	    }, _vm._l((_vm.klassetrin), function(standardKlasse) {
	      return _c('option', {
	        key: standardKlasse
	      }, [_vm._v("\n              " + _vm._s(standardKlasse) + "\n            ")])
	    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isShowSubjects) ? _c('input', {
	      staticClass: "d-input__small",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": klasse.spor
	      },
	      on: {
	        "blur": function($event) {
	          return _vm.updateStilKlasse(klasse, 'spor', $event.target.value, $event.target)
	        }
	      }
	    }) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isShowSubjects) ? _c('select', {
	      staticClass: "d-select__small",
	      domProps: {
	        "value": klasse.klasse_type
	      },
	      on: {
	        "change": function($event) {
	          return _vm.updateStilKlasse(klasse, 'klasse_type', $event.target.value)
	        }
	      }
	    }, _vm._l((_vm.klasseTyper), function(klasseType, key) {
	      return _c('option', {
	        key: key,
	        domProps: {
	          "value": key
	        }
	      }, [_vm._v("\n              " + _vm._s(klasseType) + "\n            ")])
	    }), 0) : _vm._e()])]), _vm._v(" "), (_vm.isShowSubjects) ? [_c('tr', {
	      staticClass: "tr__header"
	    }, [_c('td', [_vm._v("Fag")]), _vm._v(" "), _c('td', [_vm._v("Fagkode")]), _vm._v(" "), _c('td', [_vm._v("Klassetimer")]), _vm._v(" "), _c('td', [_vm._v("Underviser(e)")])]), _vm._v(" "), _vm._l((klasse.fag), function(fag) {
	      return _c('tr', {
	        key: fag.fag_id,
	        staticClass: "tr__two"
	      }, [_c('td', [_c('div', {
	        staticClass: "hint--top-right fag-delete-bin",
	        attrs: {
	          "aria-label": "Slet fra indberetningen"
	        }
	      }, [_c('button', {
	        staticClass: "icon__bg-circle icon__bg-circle--danger",
	        on: {
	          "click": function($event) {
	            return _vm.setTheDeleteSubject(klasse, fag)
	          }
	        }
	      }, [_c('span', {
	        staticClass: "icon-bin"
	      })])]), _vm._v("\n            " + _vm._s(fag.fag_navn) + "\n          ")]), _vm._v(" "), _c('td', [_c('select', {
	        staticClass: "d-select__small",
	        domProps: {
	          "value": fag.fagkode
	        },
	        on: {
	          "change": function($event) {
	            return _vm.updateStilKlasseFag(klasse, fag, 'fagkode', $event.target.value)
	          }
	        }
	      }, _vm._l((_vm.standardSubjects), function(fag) {
	        return _c('option', {
	          domProps: {
	            "value": fag.fagkode
	          }
	        }, [_vm._v("\n                " + _vm._s(fag.fagkode) + ": " + _vm._s(fag.name) + "\n              ")])
	      }), 0)]), _vm._v(" "), _c('td', [_c('input', {
	        staticClass: "d-input__small",
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": fag.klokketimer
	        },
	        on: {
	          "focus": function($event) {
	            return $event.target.select()
	          },
	          "keyup": function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	            _vm.updateStilKlasseFag(klasse, fag, 'klokketimer', $event.target.value, $event.target)
	          },
	          "blur": function($event) {
	            _vm.updateStilKlasseFag(klasse, fag, 'klokketimer', $event.target.value, $event.target)
	          }
	        }
	      })]), _vm._v(" "), _c('td', [_c('div', {
	        staticStyle: {
	          "width": "400px"
	        },
	        on: {
	          "click": function($event) {
	            _vm.theEditTeacher = fag.fag_id
	          }
	        }
	      }, [(fag.v_is_the_edit_teacher) ? _c('DSelect', {
	        attrs: {
	          "items": _vm.users,
	          "itemsSelected": fag.laerere,
	          "usersSSNHash": _vm.usersSSNHash
	        },
	        on: {
	          "update": function($event) {
	            _vm.updateStilKlasseFag(klasse, fag, 'laerere', $event)
	          },
	          "close": function($event) {
	            _vm.theEditTeacher = null
	          }
	        }
	      }) : _c('ul', {
	        staticClass: "d-select__container",
	        class: {
	          'd-select__container--empty': fag.laerere.length < 1
	        }
	      }, [(fag.laerere.length < 1) ? _c('li', {
	        staticClass: "d-select__container__add"
	      }, [_vm._v("\n                  Tilføj minimun en underviser\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((fag.laerere), function(user) {
	        return _c('li', {
	          staticClass: "d-pill",
	          class: {
	            'd-pill--error': user.v_no_cpr
	          }
	        }, [_vm._v("\n                  " + _vm._s(user.v_name) + "\n                ")])
	      })], 2)], 1)])])
	    })] : _vm._e()]
	  })], 2)]), _vm._v(" "), (_vm.theDeleteSubject || _vm.theDeleteGrade) ? _c('ModalConfirmation', {
	    attrs: {
	      "propLocale": "da",
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeModalConfirm,
	      "confirm": _vm.confirmDelete
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theCreateSubject) ? _c('KompetenceIndberetningKlasserFagForm', {
	    attrs: {
	      "theCreateSubject": _vm.theCreateSubject,
	      "standardSubjects": _vm.standardSubjects
	    },
	    on: {
	      "save": _vm.saveNewSubject,
	      "close": function($event) {
	        _vm.theCreateSubject = null
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isModalCreateGrade) ? _c('KompetenceIndberetningCreateKlasseModal', {
	    on: {
	      "save": _vm.saveNewGrade,
	      "close": _vm.setIsModalCreateGrade
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weekplan"
	  }, [(_vm.weeknote !== undefined && _vm.weeknote.length && !_vm.isLoading) ? _c('div', {
	    staticClass: "week_note"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.weekNoteWithLineBreaks)
	    }
	  })]) : _c('div', [(!_vm.anyNotes && !_vm.isLoading) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.$t('vue.public.no_notes')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('ul', [_vm._l((_vm.eventsWithNotes), function(day) {
	    return [(day.lessons.length !== 0) ? _c('li', {
	      staticClass: "day_change"
	    }, [_c('div', {
	      staticClass: "day_change_header"
	    }, [_c('h3', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("dateNoYear")(day.date))))])]), _vm._v(" "), _vm._l((day.lessons), function(event) {
	      return [_c('d-week-plan-lesson', {
	        attrs: {
	          "event": event,
	          "date": _vm.date
	        }
	      })]
	    })], 2) : _vm._e()]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: false,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	      }),
	      expression: "{\n              arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
	    }],
	    staticClass: "hide-title-th",
	    attrs: {
	      "content": _vm.tooltipForHideTitle
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['hide_title']) + " "), _c('span', {
	    staticClass: "icon-question3"
	  })]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(reason) {
	    return _c('tr', {
	      key: reason.id
	    }, [_c('td', [_vm._v(_vm._s(reason.name))]), _vm._v(" "), _c('td', {
	      staticClass: "hide-title-td"
	    }, [_c('div', {
	      staticClass: "do-table-flex"
	    }, [_c('AppToggle', {
	      attrs: {
	        "propOn": reason.default_private
	      },
	      on: {
	        "changed": function($event) {
	          return _vm.$emit('editAbsencePrivate', reason)
	        }
	      }
	    })], 1)]), _vm._v(" "), _c('td', [_c('button', {
	      staticClass: "do-bttn do-bttn--small",
	      class: {
	        'do-bttn--loading': _vm.theUpdatingReasonId === reason.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.$emit('toggleArchived', reason)
	        }
	      }
	    }, [_vm._v(_vm._s(reason.archived ? _vm.i18n['dearchive'] : _vm.i18n['archive']) + "\n      ")])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer-nav",
	    class: _vm.className
	  }, [_c('v-touch', {
	    on: {
	      "tap": _vm.prev,
	      "doubletap": _vm.preventZoom
	    }
	  }, [_c('div', {
	    staticClass: "icon-arrow-left4 no-print left-button"
	  })]), _vm._v(" "), _c('v-touch', {
	    staticClass: "today-button",
	    class: {
	      notActive: !_vm.isNotToday
	    },
	    on: {
	      "tap": function($event) {
	        return _vm.$emit('today')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "center-button"
	  }, [_vm._v(_vm._s(_vm.$t('repitition.today')))])]), _vm._v(" "), _c('v-touch', {
	    on: {
	      "tap": _vm.next
	    }
	  }, [_c('div', {
	    staticClass: "icon-arrow-right4 no-print right-button"
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "create-students"
	  }, [_c('button', {
	    staticClass: "bttn bttn--primary",
	    staticStyle: {
	      "width": "200px"
	    },
	    on: {
	      "click": _vm.setIsShowModal
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.students.create_student')) + "\n  ")]), _vm._v(" "), (_vm.isShowModal) ? _c('Modal', {
	    attrs: {
	      "is-bg-overlay": true,
	      "show-close": false,
	      "show": true
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_c('div', {
	    staticClass: "doc-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "doc-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + " "), (!_vm.isCreateMultipleStudents) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.student')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__close icon__bg-circle",
	    on: {
	      "click": _vm.setCloseModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.isCreateMultipleStudents) ? _c('div', {
	    staticClass: "doc-modal__body"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.insert_multiple_students')))]), _vm._v(" "), _c('div', {
	    staticClass: "textarea-placeholder-container"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theBulkStudentsStr),
	      expression: "theBulkStudentsStr"
	    }],
	    staticStyle: {
	      "height": "400px"
	    },
	    attrs: {
	      "spellcheck": "false",
	      "autocapitalize": "none",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.theBulkStudentsStr)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.theBulkStudentsStr = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isShowTextAreaPlaceholder),
	      expression: "isShowTextAreaPlaceholder"
	    }],
	    staticClass: "textarea-placeholder-container__placeholder"
	  }, [_vm._v("\n              Anne Anker\n              "), _c('br'), _vm._v(" Ella Madsen\n              "), _c('br'), _vm._v(" Michael Thomsen\n            ")])])])]) : _vm._l((_vm.students), function(student, key) {
	    return _c('div', {
	      staticClass: "doc-modal__body"
	    }, [(_vm.isFeideActive) ? _c('div', {
	      staticClass: "d-input-group"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide')))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (student.feide),
	        expression: "student.feide"
	      }],
	      ref: "feide",
	      refInFor: true,
	      staticClass: "d-input feide",
	      class: [{
	        'input--error': _vm.isFeideAlreadyCreated
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": ""
	      },
	      domProps: {
	        "value": (student.feide)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(student, "feide", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), (_vm.isFeideAlreadyCreated) ? _c('p', {
	      staticClass: "text--error"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide_is_already_used')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "d-input-group"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.students.name')))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (student.name),
	        expression: "student.name"
	      }],
	      ref: "studentname",
	      refInFor: true,
	      staticClass: "d-input namefield",
	      class: [{
	        'missing-input': false
	      }],
	      attrs: {
	        "type": "text",
	        "id": 'studentname_' + key,
	        "placeholder": ""
	      },
	      domProps: {
	        "value": (student.name)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(student, "name", $event.target.value)
	        }
	      }
	    })]), _vm._v(" "), _c('SearchForCalendar', {
	      attrs: {
	        "query": student.name
	      }
	    }), _vm._v(" "), (student.name.length < 1) ? _c('p', {
	      staticClass: "text-blue pointer text-link",
	      on: {
	        "click": function($event) {
	          _vm.isCreateMultipleStudents = !_vm.isCreateMultipleStudents
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.students.create_multiple_students')))]) : _vm._e()], 1)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__footer"
	  }, [_c('button', {
	    staticClass: "marg-1-right",
	    on: {
	      "click": _vm.setCloseModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button bttn--shadow",
	    class: {
	      'create-form__submit': _vm.showInactiveButton
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.create')) + " "), (!_vm.isCreateMultipleStudents) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.student')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))])])])], 2)]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.klassHasNoSubjects && _vm.theCalendar) ? _c('p', {
	    staticClass: "center italic text-dark marg-on-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_subjects_created']) + "\n  "), _c('span', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setImportSubjects
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['import_subjects']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['or_click_on_create_subject']))]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "header-nav__item header-nav__item__notifications pos-relative no-selection js-toggle-notifications",
	    class: {
	      active: _vm.show
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggle($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "inline-block",
	    class: {
	      'animated swing infinite': _vm.unReadCounter
	    }
	  }, [_c('span', {
	    staticClass: "icon-bell js-toggle-notifications",
	    staticStyle: {
	      "margin-right": "0",
	      "font-size": "13px"
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.unReadCounter),
	      expression: "unReadCounter"
	    }],
	    staticClass: "notify-number js-toggle-notifications"
	  }, [_vm._v(_vm._s(_vm.unReadCounter))]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show) ? _c('div', {
	    staticClass: "notifications_list pos-absolute bg-white rounded"
	  }, [_c('div', {
	    staticClass: "notifications__header popup_header"
	  }, [_c('h4', {
	    staticClass: "left marg-10-left"
	  }, [_vm._v(_vm._s(_vm.unReadCounter) + " " + _vm._s(_vm.$t('vue2.notifications.notifications')))]), _vm._v(" "), _c('div', {
	    staticClass: "notifications__header__tabs"
	  }, [_c('button', {
	    staticClass: "bttn right",
	    class: {
	      bttn_active: _vm.onlyUnreadMessagesActive
	    },
	    on: {
	      "click": _vm.getMessagesUnread
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.notifications.unread')) + "\n\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn right",
	    class: {
	      bttn_active: !_vm.onlyUnreadMessagesActive
	    },
	    on: {
	      "click": _vm.getMessages
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.notifications.all')) + "\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "notifications__body js-notifications-body-scroll"
	  }, [_c('div', [(_vm.isInitialLoad) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff",
	      "isSmall": true
	    }
	  }) : _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.messages.length === 0),
	      expression: "messages.length === 0"
	    }],
	    staticClass: "pad-20 center"
	  }, [_c('div', {
	    staticClass: "icon-checkmark-circle marg-10-bottom",
	    staticStyle: {
	      "font-size": "22px"
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.notifications.no_new_notifications')) + "\n          ")]), _vm._v(" "), _vm._l((_vm.messages), function(message, index) {
	    return _c('div', {
	      key: message.id,
	      staticClass: "notifations__body__message clearfix overflow pos-relative"
	    }, [_c('a', {
	      staticClass: "flex",
	      class: {
	        is_read: message.read
	      },
	      attrs: {
	        "href": message.link
	      }
	    }, [_c('div', {
	      staticClass: "notifications__message__image-wrapper",
	      on: {
	        "click": function($event) {
	          return _vm.readStatusRead($event, index, message.id, true)
	        }
	      }
	    }, [_c('img', {
	      staticClass: "notifications__body__message__image rounded",
	      attrs: {
	        "src": message.user.profile_image_thumb
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "notifications__body__message__header",
	      on: {
	        "click": function($event) {
	          return _vm.readStatusRead($event, index, message.id, true)
	        }
	      }
	    }, [_c('p', {
	      staticClass: "text-dark bold marg-10-bottom"
	    }, [_vm._v(_vm._s(message.header))]), _vm._v(" "), _c('p', {
	      staticClass: "text-dark"
	    }, [_vm._v(_vm._s(message.body))]), _vm._v(" "), _c('div', {
	      staticClass: "notifications_body__message__footer"
	    }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.notifications.sent_from')) + " " + _vm._s(message.user.name) + " - " + _vm._s(_vm._f("fromNow")(message.created_at)))])])]), _vm._v(" "), _c('div', {
	      staticClass: "notifications__body__message__isread css_show_tooltip",
	      on: {
	        "click": function($event) {
	          return _vm.changeReadStatus($event, index, message.id, !message.read)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "mark_as_read",
	      class: {
	        is_read: message.read
	      }
	    }, [_c('span', {
	      staticClass: "icon-checkmark4"
	    })])])])])
	  })], 2), _vm._v(" "), (_vm.messages.length > 4 && !_vm.isAllLoaded) ? _c('div', {
	    directives: [{
	      name: "observe-visibility",
	      rawName: "v-observe-visibility",
	      value: (_vm.handleScrolledToBottom),
	      expression: "handleScrolledToBottom"
	    }],
	    staticClass: "message-loader",
	    attrs: {
	      "div": ""
	    }
	  }, [_c('Loader', {
	    staticStyle: {
	      "margin": "0 auto"
	    },
	    attrs: {
	      "bg-color": "#fff",
	      "isSmall": true
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.unReadCounter),
	      expression: "unReadCounter"
	    }],
	    staticClass: "notifications__footer box-sizing"
	  }, [_c('span', {
	    staticClass: "pointer pad-10-0 notifications__footer__link ",
	    on: {
	      "click": _vm.markAllAsRead
	    }
	  }, [_c('span', {
	    staticClass: "icon-checkmark-circle marg-10-right"
	  }), _vm._v("\n        " + _vm._s(_vm.$t('vue2.notifications.mark_all_as_read')) + "\n      ")])])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-dist__edit-hours"
	  }, [_c('div', {
	    staticClass: "subject-dist__edit-hours__header",
	    style: ({
	      'background-color': _vm.subject.color
	    })
	  }, [_c('h4', [_vm._v(_vm._s(_vm.subject.name) + ", " + _vm._s(_vm.getAllKlasses))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle close-subject_edit",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "subject-dist__edit-hours__body"
	  }, [_c('h2', {
	    staticClass: "marg-20-bottom"
	  }, [_vm._v(_vm._s(_vm.getAllKlasses) + " " + _vm._s(_vm.i18n[_vm.locale].has) + " " + _vm._s(_vm.subject.hours) + " " + _vm._s(_vm.i18n[_vm.locale].hours_in_school_year))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', {
	    staticClass: "label--large"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_new_hours_for) + " " + _vm._s(_vm.teacher.name))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hours),
	      expression: "hours"
	    }],
	    ref: "input_hours",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": _vm.selectAll,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "submit-buttons marg-20-top"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].cancel))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button marg-10-left",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].update))])])])])
	},staticRenderFns: []}

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-1-1 text-dark"
	  }, [_c('div', {
	    staticClass: "flex column"
	  }, [_c('div', {
	    staticClass: "hours_show__header width-100"
	  }, [_c('div', {
	    staticClass: "flex space-between"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.title')))]), _vm._v(" "), _c('h1', {
	    staticClass: "only-print right"
	  }, [_vm._v(_vm._s(_vm._f("L")(_vm.startDate)) + " - " + _vm._s(_vm._f("L")(_vm.endDate)))]), _vm._v(" "), _c('div', {
	    staticClass: "flex align-center"
	  }, [_c('p', {
	    staticClass: "marg-10-right bold no-print"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.choose_period')))]), _vm._v(" "), _c('datePickerRange', {
	    staticClass: "inline-block align-center flex no-print",
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.startDateChanged,
	      "endchanged": _vm.endDateChanged
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "marg-10-left no-print",
	    on: {
	      "click": _vm.print
	    }
	  }, [_c('span', {
	    staticClass: "icon-printer3"
	  })])], 1)]), _vm._v(" "), _c('HoursShowShortcuts', {
	    attrs: {
	      "start": _vm.start,
	      "end": _vm.end
	    }
	  }), _vm._v(" "), _c('dSelectUsers', {
	    attrs: {
	      "showTags": true,
	      "showCreateButton": false
	    },
	    on: {
	      "usersUpdated": _vm.syncUsers
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "filters marg-20-top marg-10-bottom flex"
	  }, [_c('div', {
	    staticClass: "fl-icon icon-filter"
	  }), _vm._v(" "), _c('button', {
	    staticClass: "filter",
	    class: {
	      'active': _vm.filterIsActive(null)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setEventsFilter(null)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.all')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "filter",
	    class: {
	      'active': _vm.filterIsActive('subject')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setEventsFilter('subject')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.teaching')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "filter",
	    class: {
	      'active': _vm.filterIsActive('substituteHours')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setEventsFilter('substituteHours')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.substitute_hours')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "filter",
	    class: {
	      'active': _vm.filterIsActive('absence')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setEventsFilter('absence')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.absence')) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "hours_show__body width-100"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticStyle: {
	      "margin-top": "100px"
	    }
	  }, [_c('Spinner', {
	    attrs: {
	      "color": "blue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "user-list"
	  }, _vm._l((_vm.usersAndEventsWithProps), function(user) {
	    return _c('li', {
	      key: user.user_id,
	      staticClass: "user-list__user"
	    }, [_c('div', {
	      staticClass: "user-list__user__header"
	    }, [_c('h2', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "user-list__user__right"
	    }, [_c('p', [_vm._v(_vm._s(Object.keys(user.v_events_filtered).length) + " " + _vm._s(_vm.$t('vue2.substitute_hours.work_days')) + ": "), _c('b', [_vm._v(_vm._s(user.v_all_days_duration))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.v_filter_events.length) + "\n                "), (user.v_filter_events.length < 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_event')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_events')))]), _vm._v(":\n                "), _c('b', [_vm._v(_vm._s(_vm.getSumDuration(user.v_filter_events)))])])])]), _vm._v(" "), _c('ul', {
	      staticClass: "user-list__events"
	    }, _vm._l((user.v_events_filtered), function(dayEvents) {
	      return _c('li', {
	        key: dayEvents[0].start_time,
	        staticClass: "user-list__events_day"
	      }, [_c('div', {
	        staticClass: "user-list__events_day__header"
	      }, [_c('div', [_c('span', {
	        staticClass: "day-headline"
	      }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("ddd")(dayEvents[0].start_time))) + ", " + _vm._s(_vm._f("LL")(dayEvents[0].start_time)))]), _vm._v(",\n                  kl. " + _vm._s(_vm._f("LT")(dayEvents[0].start_time)) + " - " + _vm._s(_vm._f("LT")(dayEvents[dayEvents.length - 1].end_time)) + ", " + _vm._s(_vm.getDayDuration(dayEvents)) + "\n                ")]), _vm._v(" "), _c('div', {
	        staticClass: "user-list__events_day__header__day-events"
	      }, [_c('p', [_vm._v(_vm._s(dayEvents.length) + "\n                    "), (dayEvents.length < 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_event')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_events')))]), _vm._v(" -\n                    " + _vm._s(_vm.getSumDuration(dayEvents)) + "\n                  ")])])]), _vm._v(" "), _c('ul', {
	        staticClass: "user-list__event_day__lessons"
	      }, _vm._l((dayEvents), function(event) {
	        return _c('li', {
	          key: event.event_id,
	          staticClass: "lesson",
	          style: ({
	            'borderColor': event.color
	          })
	        }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm._f("LT")(event.start_time)) + " - " + _vm._s(_vm._f("LT")(event.end_time)) + " | " + _vm._s(event.title) + " "), (_vm.eventHasAnyKlass(event.klasses)) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("klassList")(event.klasses)) + "\n                  ")]), _vm._v(" "), (event.substitute_for) ? _c('div', [_c('span', {
	          staticClass: "icon-users3"
	        }), _vm._v(_vm._s(_vm.$t('vue2.substitute_hours.substitute_for')) + ":\n                    " + _vm._s(event.substitute_for) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.getEventDuration(event)) + "\n                  ")])])
	      }), 0)])
	    }), 0)])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "select-subs"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.find_sub_for')) + " ")]), _vm._v(" "), _c('div', {
	    staticClass: "select-subs__header"
	  }, [_c('FilterUsers')], 1), _vm._v(" "), _c('div', {
	    staticClass: "select-subs__header"
	  }, [_c('input', {
	    staticClass: "search-user",
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.$t('vue2.common.search_name_or_initials')
	    },
	    on: {
	      "input": _vm.debounceSearch
	    }
	  })]), _vm._v(" "), _c('ul', [(_vm.usersSorted.length === 0) ? _c('li', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usersSorted), function(user, index) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "select-subs__sub shadow"
	    }, [_c('div', {
	      staticClass: "select-subs__sub__header"
	    }, [_c('p', {
	      staticClass: "select-subs__sub__name"
	    }, [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('button', {
	      staticClass: "bttn",
	      on: {
	        "click": function($event) {
	          return _vm.addSub(user)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.select')) + "\n      ")])])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "scheduler__users__user__subpools__meta",
	    style: ([{
	        'left': _vm.itemBCR.right + 4 + 'px'
	      },
	      {
	        'top': _vm.posTop + 'px'
	      }
	    ])
	  }, [_c('table', [_c('thead', {
	    staticClass: "subPools__table__header"
	  }, [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.substitute_hours')) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.difference')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.assigned')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.sub_scheduler_sub_pools.scheduled')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.itemSubPoolDiff))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.itemSubPool))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.substituteHours))])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-subjects text-dark"
	  }, [_c('div', {
	    staticClass: "request-subjects__header"
	  }, [_c('div', {
	    staticClass: "request-subjects__header__left"
	  }, [_c('h1', [_vm._v("Reduktioner")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "request-subjects-grid"
	  }, [_c('div', {
	    staticClass: "doTable"
	  }, [_c('div', {
	    staticClass: "subject-dist__header"
	  }, [_c('div', {
	    staticClass: "subject-dist__header__left"
	  }, [_c('Tabslist', {
	    attrs: {
	      "tabs": ['Aktiviteter', 'Fag'],
	      "isLarge": true,
	      "selected": _vm.selectedTab
	    },
	    on: {
	      "select": _vm.onSelectTab
	    }
	  }), _vm._v(" "), (_vm.selectedTab === 'Fag') ? _c('div', {
	    staticClass: "do-search"
	  }, [_c('input', {
	    staticClass: "do-input",
	    attrs: {
	      "type": "search",
	      "placeholder": "Søg på fag"
	    },
	    on: {
	      "input": _vm.debounceSearch
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'Fag') ? _c('DoFiltersFilter', {
	    attrs: {
	      "title": 'Klasser',
	      "tags": _vm.klassTags,
	      "selectedTags": _vm.selectedKlassFilters
	    },
	    on: {
	      "select": _vm.toggleKlassTag,
	      "clear": function($event) {
	        _vm.selectedKlassFilters = []
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isRefreshingOrLoadingSubjects) ? _c('Loader', {
	    staticStyle: {
	      "margin": "0"
	    },
	    attrs: {
	      "is-extra-small": true
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedTab === 'Aktiviteter') ? _c('BulkCreateSubjects', {
	    attrs: {
	      "isActivities": true,
	      "prop-is-subject-modal": _vm.isCreateActivityModal
	    },
	    on: {
	      "closeSubjectModal": function($event) {
	        return _vm.setIsCreateActivityModal(false)
	      }
	    }
	  }) : _c('ul', {
	    staticClass: "doTable__items"
	  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
	    return _c('li', {
	      key: klassCal.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(klassCal.name))])]), _vm._v(" "), _c('ul', {
	      staticClass: "grade-subjects"
	    }, _vm._l((klassCal.vSubjects), function(subject) {
	      return _c('li', {
	        key: subject.id,
	        staticClass: "grade-subjects_subject",
	        style: ({
	          'background': subject.color
	        }),
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(subject)
	          }
	        }
	      }, [_vm._v("\n              " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n            ")])
	    }), 0)])
	  }), 0)], 1)]), _vm._v(" "), (_vm.editSubject) ? _c('SubjectForm', {
	    attrs: {
	      "showModal": _vm.editSubject,
	      "editSubject": _vm.editSubject,
	      "propTab": 'reductions',
	      "isActivities": true
	    },
	    on: {
	      "close": _vm.closeEditSubjectModal,
	      "deleteSubject": _vm.deleteSubject,
	      "updateSubject": _vm.updateSubject
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "reporting"
	  }, [_c('a', {
	    staticClass: "d-back-link",
	    attrs: {
	      "href": "/calendar"
	    }
	  }, [_vm._v("Tilbage til Docendo")]), _vm._v(" "), _c('div', {
	    staticClass: "reporting__header"
	  }, [_c('div', {
	    staticClass: "reporting__header__right"
	  }, [_c('h1', [_vm._v("Grundskoleindberetning")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('StilGuides', {
	    attrs: {
	      "is-button": true
	    }
	  })], 1), _vm._v(" "), (_vm.isLoadingStilData || !_vm.isUserLoaded) ? _c('div', {
	    staticStyle: {
	      "width": "500px"
	    }
	  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && _vm.userHasNoEmail) ? _c('div', {
	    staticClass: "d-form alert"
	  }, [_c('h3', [_vm._v("Der skal udfyldes en email for at benytte grundskoleindberetningen")]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', [_vm._v("Din email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.userEmailInput),
	      expression: "userEmailInput",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    ref: "user_email_input",
	    class: {
	      'input--error': _vm.userEmailFormErrors['email']
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.userEmailInput)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('email')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.userEmailInput = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.userEmailFormErrors['email']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.createusers.email_error_text')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-form__submit"
	  }, [_c('button', {
	    staticClass: "bttn submit-button",
	    class: [{
	        'bttn--loading': _vm.isSavingUserEmail
	      },
	      {
	        'submit-button--disabled': _vm.isSaveButtonForUserEmailDisabled
	      }
	    ],
	    on: {
	      "click": _vm.submitUserEmail
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isUserLoaded && !_vm.isLoadingStilData && !_vm.userHasNoEmail) ? [_c('div', {
	    staticClass: "d-tabs"
	  }, [_c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 0
	      }
	    }
	  }, [_vm._v("\n        1. Personalets alder og køn\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 1
	      }
	    }
	  }, [_vm._v("\n        2. Ressourceforbrug\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 2
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 2
	      }
	    }
	  }, [_vm._v("\n        3. Antal elever og undervisningstimer\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.theActiveTab === 3
	    },
	    on: {
	      "click": function($event) {
	        _vm.theActiveTab = 3
	      }
	    }
	  }, [_vm._v("\n        Resumé og indberetning\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "reporting-content"
	  }, [_c('div', {
	    staticClass: "reporting__table"
	  }, [(_vm.theActiveTab === 0) ? _c('GrundskoleIndberetningUsers') : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 1) ? _c('GrundskoleIndberetningRessource', {
	    attrs: {
	      "stilData": _vm.stilData
	    },
	    on: {
	      "updateStil": _vm.updateRessource
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 2) ? _c('GrundskoleIndberetningTimetal', {
	    attrs: {
	      "stilData": _vm.stilData
	    },
	    on: {
	      "update": _vm.update,
	      "updateSubject": _vm.updateSubject,
	      "updateKonfirmation": _vm.updateKonfirmation,
	      "updatePraktik": _vm.updatePraktik,
	      "setTolaerer": _vm.setTolaerer,
	      "setForanstaltning": _vm.setForanstaltning,
	      "nulstilKlasse": _vm.nulstilKlasse
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('GrundskoleIndberetningResume') : _vm._e()], 1)])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-splash"
	  }, [_c('div', {
	    staticClass: "do-splash__contanier"
	  }, [_c('DoLogo', {
	    attrs: {
	      "id": "do-logo"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "docendo-connection-indicator"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.is_connected),
	      expression: "!is_connected"
	    }],
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "connection_lost"
	    }
	  }, [_vm._v("Genopretter forbindelse...")])])
	},staticRenderFns: []}

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.searchedCalendars.length > 0 && _vm.query.length > 1) ? _c('div', {
	    staticClass: "search-for-calendar"
	  }, [_c('div', {
	    staticClass: "search-for-calendar__header"
	  }, [_vm._m(0), _vm._v(" "), (_vm.calendarType === 'users') ? _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.users_with_same_name')))]) : _vm._e(), _vm._v(" "), (_vm.calendarType === 'students') ? _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.students_with_same_name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "search-for-calendar__body"
	  }, [_c('ul', {
	    staticClass: "search-for-calendar__calendars"
	  }, _vm._l((_vm.searchedCalendars), function(calendar) {
	    return _c('li', {
	      staticClass: "search-for-calendar__calendar"
	    }, [_c('div', {
	      staticClass: "cal-name"
	    }, [_vm._v(_vm._s(calendar.name))]), _vm._v(" "), _c('div', {
	      staticClass: "cal-klasses"
	    }, _vm._l((_vm.getStudentKlasses(calendar)), function(klass, key) {
	      return _c('span', [(key !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n            " + _vm._s(klass.name))])
	    }), 0)])
	  }), 0)])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "search-for-calendar__left"
	  }, [_c('div', {
	    staticClass: "search-for-calendar__warning"
	  }, [_c('span', {
	    staticClass: "icon-warning"
	  })])])
	}]}

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-button__multiple no-print"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-left4 no-print",
	    attrs: {
	      "content": _vm.tooltipArrowLeft
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('prev')
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "no-print do-button__multiple__bttn",
	    class: {
	      'bttn--disabled': _vm.isToday
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('today')
	      }
	    }
	  }, [_vm._v("\n    I dag\n  ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'bottom',
	        zIndex: 1212121212,
	      }),
	      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
	    }],
	    staticClass: "do-button__multiple__bttn icon-arrow-right4 ",
	    attrs: {
	      "content": _vm.tooltipArrowRight
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('next')
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Slet onboarding steps")]), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('button', {
	    on: {
	      "click": _vm.deleteSetupWidgetOpen
	    }
	  }, [_vm._v("Slet Setup widget åben?")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteKlass
	    }
	  }, [_vm._v("Slet klasse")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteUser
	    }
	  }, [_vm._v("Slet Bruger")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteRoom
	    }
	  }, [_vm._v("Slet Lokale")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteMerge
	    }
	  }, [_vm._v("Slet Merge")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteVacation
	    }
	  }, [_vm._v("Slet ferie")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.deleteScheduling
	    }
	  }, [_vm._v("Slet skemalægning")])])])
	},staticRenderFns: []}

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner",
	    class: [_vm.color, _vm.size]
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickAway),
	      expression: "onClickAway"
	    }],
	    ref: "d_select",
	    staticClass: "d-select text-dark",
	    class: {
	      'openFromBottom': _vm.openFromBottom
	    }
	  }, [_c('div', {
	    staticClass: "width-100 no-print"
	  }, [_c('div', {
	    ref: "toggle",
	    staticClass: "d-select__input-look",
	    class: {
	      'active': _vm.showDropdown
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._l((_vm.selectedItems), function(selectedItem) {
	    return _c('div', {
	      key: selectedItem.id,
	      staticClass: "d-select__selected__item",
	      class: [{
	          'readyToDelete': _vm.isReadyToDelete(selectedItem)
	        },
	        {
	          'd-select__selected__item--is-in-event': _vm.isInEvent
	        },
	        {
	          'd-select__selected__item--cant-be-removed': _vm.isInItemsThatCantBeDeleted(selectedItem)
	        }
	      ]
	    }, [(_vm.isInEvent) ? [(_vm.isLoadingAvailability) ? _c('div', {
	      staticClass: "d-select__selected__item__spinner__container"
	    }, [_c('div', {
	      staticClass: "d-select__selected__item__spinner"
	    })]) : [(_vm.isShowCollisions && selectedItem.v_occupation && selectedItem.v_occupation.length > 0) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          zIndex: 1231231231233,
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 1231231231233,\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "d-select__selected__item__warning icon__bg-circle icon__bg-circle--small",
	      attrs: {
	        "content": _vm.getCollisionText(selectedItem)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showCalendar(selectedItem)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon tw-icon--warning",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })])]) : _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'bottom',
	          zIndex: 1231231231233,
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 1231231231233,\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--small",
	      attrs: {
	        "content": _vm.i18n['see_calendar']
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showCalendar(selectedItem)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon tw-icon--calendar",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
	      }
	    })])])]] : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "d-select__selected__item__name",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showCalendar(selectedItem)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(selectedItem.name) + "\n        ")]), _vm._v(" "), (!_vm.isInItemsThatCantBeDeleted(selectedItem)) ? _c('div', {
	      staticClass: "d-select__selected__item__remove icon__bg-circle icon__bg-circle--small icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.removeUser(selectedItem)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon--close",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "fill-rule": "evenodd",
	        "d": "M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
	      }
	    })])]) : _vm._e()], 2)
	  }), _vm._v(" "), (_vm.selectedItems.length > 0 && _vm.isDeleteAllAnOption) ? _c('div', {
	    staticClass: "d-select__delete-all",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.removeAllUsers.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'top',
	        zIndex: 1231231231233,
	        animation: 'hift-away'
	      }),
	      expression: "{\n               arrow: true,\n                  placement : 'top',\n                  zIndex: 1231231231233,\n                  animation: 'hift-away'\n                }"
	    }],
	    staticClass: "icon__bg-circle",
	    attrs: {
	      "content": _vm.i18n['delete_all']
	    }
	  }, [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.isLoadingAvailability) ? _c('Loader', {
	    staticClass: "input__spinner",
	    staticStyle: {
	      "margin": "6px 5px 0 5px"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#fff",
	      "color": "blue",
	      "size": "small"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    staticClass: "input__spinner",
	    staticStyle: {
	      "margin": "6px 5px 0 5px"
	    },
	    attrs: {
	      "isExtraSmall": true,
	      "bg-color": "#fff",
	      "color": "blue",
	      "size": "small"
	    }
	  }) : [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    ref: "inputfield",
	    staticClass: "d-select__header__search",
	    class: [{
	      'show': _vm.showDropdown
	    }, {
	      'input-active': _vm.searchText.length > 0 || _vm.selectedItems.length < 1
	    }],
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.placeholderText
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "focus": _vm.open,
	      "keypress": [function($event) {
	        return _vm.selectWithKeyboard('', $event)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('enter')
	      }],
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('down')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('up')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
	        return _vm.selectWithKeyboard('tab')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
	        return _vm.deleteUserWithKeyboard.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }
	    }
	  })]], 2), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    directives: [{
	      name: "append-to-body",
	      rawName: "v-append-to-body"
	    }],
	    ref: "d_select__items",
	    staticClass: "d-select__items"
	  }, [_c('ul', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'left-start',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'left-start',\n                  zIndex: 12312312312312\n                }"
	    }],
	    ref: "dropdown",
	    staticClass: "d-select__items__container text-dark",
	    attrs: {
	      "content": _vm.metaKeyTooltip
	    },
	    on: {
	      "scroll": _vm.handleScroll
	    }
	  }, [_vm._l((_vm.searchedUsers), function(item, index) {
	    return [(index < _vm.maxLimit) ? _c('li', {
	      key: item.id,
	      class: [{
	          'isReadyForSelection': _vm.isSelectedWithKeyboard(item)
	        },
	        {
	          'item_is_selected': _vm.isSelected(item)
	        }
	      ],
	      on: {
	        "mouseenter": function($event) {
	          return _vm.setIsReadyForSelection(item, index)
	        },
	        "mousemove": function($event) {
	          _vm.isMouseMoved = true
	        },
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleUser(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "item-template",
	      class: [{
	          'item-template--occupied': _vm.isShowCollisions && item.v_occupation && item.v_occupation.length > 0
	        },
	        {
	          'item-template--presence': _vm.isShowCollisions && item.v_presence && item.v_presence.length > 0 && item.v_occupation && item.v_occupation.length < 1
	        }
	      ]
	    }, [_c('div', {
	      staticClass: "item-template__left"
	    }, [(item.icon) ? _c('span', {
	      staticClass: "marg-10-right",
	      class: item.icon
	    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	      attrs: {
	        "src": item.default_thumb_url
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.showCalendarYear) ? _c('div', {
	      staticClass: "item-template__calendar-year"
	    }, [_vm._v(_vm._s(item.year))]) : _vm._e(), _vm._v(" "), (_vm.isShowCollisions && item.v_occupation && item.v_occupation.length > 0) ? _c('ul', {
	      staticClass: "item-template__occupations"
	    }, [_c('span', {
	      staticClass: "icon-warning"
	    }), _vm._v(" "), _vm._l((item.v_occupation), function(event) {
	      return _c('li', {
	        key: event.event_id
	      }, [_vm._v(_vm._s(event.title))])
	    })], 2) : _vm._e()])]) : _vm._e()]
	  }), _vm._v(" "), (_vm.searchedUsers.length > _vm.maxLimit) ? _c('li', {
	    ref: "infinite_scroll",
	    staticClass: "infinite-scroll__bottom"
	  }, [_c('Loader', {
	    staticStyle: {
	      "margin": "12px"
	    },
	    attrs: {
	      "is-extra-small": true,
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e()], 2), _vm._v(" "), (_vm.showCreateButton && _vm.searchedUsers.length < 1) ? [(_vm.searchedUsers.length < 1 || (_vm.searchText.length > 0 && _vm.searchedUsers.length < 1)) ? _c('div', {
	    staticClass: "no-match"
	  }, [(_vm.searchText.length < 1) ? _c('h4', {
	    staticClass: "create-new-item create-new-item--explained"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.dselect.type_to_create')) + "\n          ")]) : _c('h4', {
	    staticClass: "create-new-item",
	    on: {
	      "click": _vm.createNew
	    }
	  }, [_vm._v("\n            + " + _vm._s(_vm.$t('vue2.common.create')) + " " + _vm._s(_vm.searchText) + "\n          ")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.showCreateButton && _vm.searchedUsers.length < 1) ? _c('div', {
	    staticClass: "no-match",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_vm._t("noMatch", function() {
	    return [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))])]
	  })], 2) : _vm._e()], 2) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-select__delete-all__inner"
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])
	}]}

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "switch"
	  }, [_c('span', {
	    staticClass: "switch-label",
	    class: {
	      'active': _vm.checkValue(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setValue(1)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.val1))]), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    class: {
	      'active': _vm.checkValue(2)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setValue(2)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.val2))]), _vm._v(" "), _c('span', {
	    staticClass: "switch-selection",
	    class: {
	      'value-right': _vm.checkValue(2)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "1231231231223312"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": false,
	      "placeInTop": true,
	      "appendToBody": true,
	      "isCloseOnEsc": true
	    },
	    on: {
	      "close": _vm.onClose
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "tasks-create-category"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(!_vm.theEditCategory) ? [_vm._v("Opret ny kategori")] : [_vm._v("Rediger kategori")]], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "title_input",
	    staticClass: "d-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "keyup": [function($event) {
	        _vm.isTitleAlreadyCreated = false
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.createCategory.apply(null, arguments)
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.isTitleAlreadyCreated) ? _c('p', {
	    staticClass: "text--error"
	  }, [_vm._v("Titel er allerede brugt")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('div', [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: [{
	      'do-bttn--submit--loading': _vm.isSubmitting
	    }, {
	      'do-bttn--submit--disabled': _vm.title.length < 1
	    }],
	    on: {
	      "click": _vm.createCategory
	    }
	  }, [_vm._v("\n          Opret\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('AppModal', {
	    attrs: {
	      "show": _vm.openFromOtherComponent
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_vm._v(">\n  "), _c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarEditName.edit_name')))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarEditName.calendar_name')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.calName),
	      expression: "calName"
	    }],
	    class: {
	      'missing-input': !_vm.validateInput()
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.calName)
	    },
	    on: {
	      "keyup": _vm.validateInput,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.calName = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end align-center pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(!_vm.validateInput()) ? _c('p', {
	    staticClass: "warning-text marg-10-right"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarEditName.warning_text')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.validateInput()) ? _c('button', {
	    staticClass: "submit-btn",
	    on: {
	      "click": _vm.submitNewName
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarEditName.update_name')) + "\n    ")]) : _c('button', {
	    staticClass: "submit-btn--disabled"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarEditName.update_name')) + "\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "qeip qeip--active text-dark"
	  }, [_c('div', [_c('quill-editor', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "content": _vm.text,
	      "options": _vm.editorOption
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditorChange($event)
	      },
	      "ready": function($event) {
	        return _vm.onEditorReady($event)
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "toolbar",
	      "id": "toolbar"
	    },
	    slot: "toolbar"
	  }, [_c('button', {
	    staticClass: "ql-bold hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['bold']
	    }
	  }, [_vm._v("Bold")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-italic hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['italic']
	    }
	  }, [_vm._v("Italic")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-underline hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['underline']
	    }
	  }, [_vm._v("Underline")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-list hint--bottom",
	    attrs: {
	      "value": "ordered",
	      "aria-label": _vm.i18n[_vm.locale]['list_ordered']
	    }
	  }, [_vm._v("Ordered\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-list hint--bottom",
	    attrs: {
	      "value": "bullet",
	      "aria-label": _vm.i18n[_vm.locale]['list_bullets']
	    }
	  }, [_vm._v("bullet")]), _vm._v(" "), _c('button', {
	    staticClass: "hint--bottom",
	    attrs: {
	      "id": "custom-button",
	      "aria-label": _vm.i18n[_vm.locale]['insert_link']
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setIsLinkModal(true)
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 18 18"
	    }
	  }, [_c('line', {
	    staticClass: "ql-stroke",
	    attrs: {
	      "x1": "7",
	      "x2": "11",
	      "y1": "7",
	      "y2": "11"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "ql-even ql-stroke",
	    attrs: {
	      "d": "M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "ql-even ql-stroke",
	    attrs: {
	      "d": "M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"
	    }
	  })])])])]), _vm._v(" "), (_vm.isInTestOfSaveButton) ? _c('div', {
	    staticClass: "save-buttons"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.cancel.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isChanged) ? _c('button', {
	    staticClass: "submit-button submit-button--disabled",
	    class: {
	      'submit-button--loading': _vm.isSaving
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "submit-button",
	    class: {
	      'submit-button--loading': _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.save.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowModalTeleportClosingWithoutSaving) ? _c('div', {
	    ref: "d_modal_teleport_alert",
	    staticClass: "d-modal__teleport"
	  }, [(_vm.isClosingWithoutSaving) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e(), _vm._v(" "), (_vm.isClosingWithoutSaving) ? _c('DModal', {
	    staticClass: "ap",
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "quill-modal quill-modal__save-changes",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('h4', {
	    staticClass: "marg-20-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save_changes')))]), _vm._v(" "), _c('div', {
	    staticClass: "save-buttons"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.cancelModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    class: {
	      'submit-button--loading': _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.saveModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.save')) + "\n          ")])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isShowModalTeleport) ? _c('div', {
	    ref: "d_modal_teleport",
	    staticClass: "d-modal__teleport"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLinkModal),
	      expression: "isLinkModal"
	    }],
	    staticClass: "bg-overlay"
	  }), _vm._v(" "), _c('DModal', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLinkModal),
	      expression: "isLinkModal"
	    }],
	    on: {
	      "close": function($event) {
	        return _vm.setIsLinkModal(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "quill-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "quill-modal__content"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['link_text_label']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.linkText),
	      expression: "linkText"
	    }],
	    ref: "linkTextInput",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['link_text_placeholder']
	    },
	    domProps: {
	      "value": (_vm.linkText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.linkText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['link_link_label']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.link),
	      expression: "link"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['link_link_placeholder']
	    },
	    domProps: {
	      "value": (_vm.link)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.link = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "quill-modal__footer"
	  }, [_c('button', {
	    on: {
	      "!click": function($event) {
	        $event.preventDefault();
	        return _vm.setIsLinkModal(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "bttn bttn-primary submit-button submit-button--disabled"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['insert_link']) + "\n            ")]) : _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "!click": function($event) {
	        $event.preventDefault();
	        return _vm.insertLink.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['insert_link']) + "\n            ")])])])])])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [(_vm.editsms) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.sms.edit')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.sms.new')))]), _vm._v("\n        " + _vm._s(_vm.$t('vue2.sms.standard_sms')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.sms.subject')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    ref: "titleInput",
	    class: {
	      'input--error': _vm.errors.title
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.sms.ex_you_are_sub')
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.resetValidation('title')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.title) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.errors.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group marg-10-top"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.sms.message')))]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body),
	      expression: "body"
	    }],
	    ref: "smsbodyinput",
	    class: {
	      'input--error': _vm.errors.body
	    },
	    domProps: {
	      "value": (_vm.body)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.resetValidation('body')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.body = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.body) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.errors.body))]) : _vm._e()]), _vm._v(" "), _c('button', {
	    staticClass: "bttn--small marg-5-top",
	    on: {
	      "click": _vm.insertToday
	    }
	  }, [_vm._v(_vm._s(_vm.today))]), _vm._v(" "), _c('span', {
	    staticClass: "d-desc link",
	    on: {
	      "click": _vm.insertToday
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.sms.insert_today_to')) + " \"" + _vm._s(_vm.today) + "\"")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-10-right",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.editsms) ? _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.updateTemplate
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.update')) + "\n      ")]) : _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')))])])])])
	},staticRenderFns: []}

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cals box cals-classes",
	    class: _vm.step.uniClass
	  }, [(_vm.isOnboarding) ? _c('div', {
	    staticClass: "onboard-pill"
	  }, [_c('span', {
	    staticClass: "onboard-pill__status",
	    class: {
	      'onboard-pill__status__done': _vm.step.done
	    }
	  }, [(_vm.step.done) ? _c('span', {
	    staticClass: "icon-checkmark4 js-setupWidgetEvent"
	  }) : _vm._e()]), _vm._v(" " + _vm._s(_vm.$t('vue2.dashboard.step')) + " " + _vm._s(_vm.step.stepNum) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.step.icon) ? _c('span', {
	    staticClass: "cals_icon",
	    class: _vm.step.icon
	  }) : _vm._e(), _vm._v(" "), (_vm.step.stepNum < 6 && _vm.isLoading) ? _c('spinner', {
	    staticStyle: {
	      "margin-top": "30px"
	    },
	    attrs: {
	      "color": "blue",
	      "size": "small"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step.number >= 0 && !_vm.isLoading) ? _c('h6', [_vm._v(_vm._s(_vm.step.number))]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.step.title))]), _vm._v(" "), (_vm.step.desc && _vm.isOnboarding) ? _c('p', {
	    staticClass: "step-desc"
	  }, [_vm._v(_vm._s(_vm.step.desc))]) : _vm._e(), _vm._v(" "), (!_vm.isOnboarding) ? [(_vm.step.buttonText) ? _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.step.action
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.step.buttonText) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isSchoolFromNorway) ? _c('button', {
	    staticClass: "bttn bttn-simple youtube-popup",
	    on: {
	      "click": function($event) {
	        return _vm.seeTutorial(_vm.step)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-play3"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.dashboard.tutorial')) + " (" + _vm._s(_vm.step.guideDuration) + ")\n    ")]) : _vm._e()] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [(_vm.error) ? _c('h3', {
	    staticClass: "text-explainer text-explainer__error"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v("\n    Der er stadig oplysninger der skal udfyldes før der kan indberettes\n  ")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.klasserUdenFag.length > 0) ? _c('div', {
	    staticClass: "d-attention"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v(" "), _c('h3', [_vm._v("Følgende klasser har ingen fag, og skal derfor ikke indberettes.")]), _vm._v(" "), _c('p', [_vm._v("Slet dem i denne liste, hvis de ikke skal indberettes")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__borders"
	  }, [_c('tbody', _vm._l((_vm.klasserUdenFag), function(klasse, key) {
	    return _c('tr', {
	      key: klasse.klasse_id
	    }, [_c('td', [_c('div', {
	      staticClass: "grade-name"
	    }, [_c('div', {
	      staticClass: "hint--top-right d-hidden__dropdown",
	      attrs: {
	        "aria-label": 'Slet ' + klasse.klassebetegnelse + ' fra indberetningen'
	      }
	    }, [_c('button', {
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.confirmDeleteGrade(klasse)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])]), _vm._v("\n          " + _vm._s(klasse.klassebetegnelse) + "\n          ")])])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('IndberetetPersonale', {
	    attrs: {
	      "stilData": _vm.stilData
	    }
	  }), _vm._v(" "), _c('IndberetFag', {
	    attrs: {
	      "stilData": _vm.stilData
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "submit-bttn__container"
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "hint--left",
	    attrs: {
	      "aria-label": "Der er stadig oplysninger der skal udfyldes før der kan indberettes"
	    }
	  }, [_c('button', {
	    staticClass: "bttn bttn--primary bttn--primary--disabled",
	    staticStyle: {
	      "width": "165px"
	    }
	  }, [_vm._v("\n        Afslut og indberet\n      ")])]) : _c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--loading': _vm.isSendingToStil
	    },
	    staticStyle: {
	      "width": "165px"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Afslut og indberet\n    ")])]), _vm._v(" "), (_vm.messageFromStil.length > 0) ? _c('DModal', {
	    attrs: {
	      "is-bg-overlay": true,
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "doc-modal__header"
	  }, [_c('h2', [_vm._v("Svar fra STIL")]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.messageFromStil = ''
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__body"
	  }, [_c('p', {
	    staticClass: "message-from-stil"
	  }, [_vm._v("\"" + _vm._s(_vm.messageFromStil) + "\"")])])])]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container__header"
	  }, [_c('h2', {
	    staticClass: "uppercase"
	  }, [_vm._v("Resume")])])
	}]}

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [(_vm.show) ? _c('div', {
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        return _vm.$emit('removeModal')
	      }
	    }
	  }, [_c('div', {
	    class: [{
	      'modal-mask': _vm.show_modal_mask
	    }, {
	      'modal-add-sidebar': _vm.show_modal_sidebar
	    }]
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.clickAway),
	      expression: "clickAway"
	    }],
	    staticClass: "modal-container"
	  }, [_c('div', {
	    staticClass: "modal-left"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._t("header", function() {
	    return [_vm._v("default header")]
	  }), _vm._v(" "), _c('div', {
	    staticClass: "font-large close-cross icon__bg-circle js-modalCloseEvent",
	    on: {
	      "click": _vm.removeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 pointer js-modalCloseEvent"
	  })])], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body", function() {
	    return [_vm._v("default body")]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer", function() {
	    return [_c('button', {
	      staticClass: "bttn bttn_simple right marg-10"
	    }, [_vm._v("\n                  Ok\n                ")]), _vm._v(" "), _c('button', {
	      staticClass: "bttn bttn_simple right marg-10"
	    }, [_vm._v("\n                  Gem\n                ")])]
	  })], 2)]), _vm._v(" "), (_vm.show_modal_sidebar) ? _c('div', {
	    staticClass: "modal-right"
	  }, [_c('div', {
	    staticClass: "modal-sidebar"
	  }, [_vm._t("sidebar")], 2)]) : _vm._e()])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-datepicker"
	  }, [_c('div', {
	    staticClass: "do-datepicker__buttons"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 5]
	    }
	  }, [_c('button', {
	    staticClass: "bttn-with-icon",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("\n        " + _vm._s(_vm.activeShortCutTitle) + "\n        "), _c('svg', {
	    staticClass: "tw-icon tw-icon-cheveron-down",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "fill-rule": "evenodd",
	      "d": "M15.3 10.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, _vm._l((_vm.dateShortCuts), function(dateShortCut) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setDateFromShortCut(dateShortCut)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(dateShortCut.title) + "\n        ")])
	  }), 0)]), _vm._v(" "), (_vm.isDateDropdown) ? _c('div', {
	    ref: "child_popper",
	    staticClass: "do-datepicker__dropdown",
	    class: {
	      'd-dropdown--animate': _vm.isPopperReady, 'd-dropdown--show': _vm.isPopperDone
	    }
	  }, [_c('div', {
	    staticClass: "do-datepicker__dropdown__header"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.i18n['select_dates']))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isDateDropdown = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-datepicker__dropdown__body"
	  }, [_c('Datepickerrange', {
	    attrs: {
	      "allowSameDate": _vm.allowSameDate,
	      "maximumDateRange": _vm.maximumDateRange,
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-datepicker__dropdown__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.submitDateRange
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['submit']))])])]) : _vm._e(), _vm._v(" "), _c('button', {
	    ref: "date_input_button",
	    on: {
	      "click": _vm.openIsDateDropdown
	    }
	  }, [_c('span', {
	    staticClass: "icon-calendar4"
	  }), _vm._v("\n      " + _vm._s(_vm.dateRangeFormatted) + "\n    ")])], 1), _vm._v(" "), (_vm.isDateDropdown) ? _c('div', {
	    staticClass: "bg-overlay do-datepicker__dropdown__overlay",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.closeIsDateDropdown.apply(null, arguments)
	      }
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickAway),
	      expression: "onClickAway"
	    }],
	    ref: "d_select",
	    staticClass: "d-select text-dark",
	    class: {
	      'openFromBottom': _vm.openFromBottom
	    }
	  }, [_c('div', {
	    staticClass: "width-100 no-print",
	    class: {
	      'box-shadow': _vm.boxShadow
	    }
	  }, [_c('div', {
	    ref: "toggle",
	    staticClass: "d-select__input-look",
	    class: {
	      'active': _vm.showDropdown
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._l((_vm.selectedUsers), function(selectedUser) {
	    return _c('div', {
	      staticClass: "d-select__selected__item",
	      class: [{
	          'readyToDelete': _vm.isReadyToDelete(selectedUser)
	        },
	        {
	          'd-select__selected__item--item-is-error': selectedUser.isErrorUser
	        }
	      ]
	    }, [_vm._v("\n        " + _vm._s(selectedUser.name) + "\n        "), _vm._t("item_identifier", null, {
	      "userId": selectedUser.user_calendar_id
	    }), _vm._v(" "), (_vm.userOccEvents(selectedUser) && _vm.userOccEvents(selectedUser).length > 0) ? [_c('div', {
	      staticClass: "icon-warning item__icon-warning marg-5-left",
	      class: {
	        'item_icon__hide': selectedUser.occupied.events.length === 1 && selectedUser.occupied.events[0].event_type === 'presence' || selectedUser.isOnLesson && selectedUser.occupied.events.length === 1
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "d-select__selected__item__secret-label"
	    }, [_c('div', {
	      staticClass: "icon-warning"
	    }), _vm._v(" "), _vm._l((_vm.userOccEvents(selectedUser)), function(event, index) {
	      return (index < 3) ? _c('div', {
	        staticClass: "d-select__selected__item__secret-label__event"
	      }, [_vm._v("\n              " + _vm._s(event.title) + "\n            ")]) : _vm._e()
	    })], 2)] : _vm._e(), _vm._v(" "), (!selectedUser.isErrorUser) ? _c('div', {
	      staticClass: "d-select__selected__item__remove",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.removeUser(selectedUser)
	        }
	      }
	    }, [_c('span', [_vm._v("×")])]) : _vm._e()], 2)
	  }), _vm._v(" "), (_vm.isLoading) ? [_c('spinner', {
	    staticStyle: {
	      "margin": "7px 0 0 0"
	    },
	    attrs: {
	      "color": "blue",
	      "size": "small"
	    }
	  })] : [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    ref: "inputfield",
	    staticClass: "d-select__header__search",
	    class: [{
	      'show': _vm.showDropdown
	    }, {
	      'input-active': _vm.searchText.length > 0 || _vm.selectedUsers.length < 1
	    }],
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.placeholderText
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }, _vm.debounceSearch],
	      "keypress": [function($event) {
	        return _vm.selectWithKeyboard('', $event)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('enter')
	      }],
	      "keydown": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('down')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
	        $event.preventDefault();
	        return _vm.selectWithKeyboard('up')
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
	        return _vm.deleteUserWithKeyboard.apply(null, arguments)
	      }]
	    }
	  })]], 2), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    ref: "d_select__items",
	    staticClass: "d-select__items text-dark",
	    class: _vm.addClass
	  }, [_c('ul', {
	    ref: "dropdown",
	    staticClass: "d-select__items__container",
	    on: {
	      "scroll": _vm.handleScroll
	    }
	  }, [_vm._l((_vm.searchedUsers), function(item, index) {
	    return [(index < _vm.maxLimit) ? _c('li', {
	      key: item.user_id,
	      class: [{
	          'isReadyForSelection': _vm.isSelectedWithKeyboard(item)
	        },
	        {
	          'item_is_selected': _vm.isSelected(item)
	        }
	      ],
	      on: {
	        "mouseenter": function($event) {
	          return _vm.setIsReadyForSelection(item, index)
	        },
	        "click": function($event) {
	          return _vm.toggleUser(item)
	        }
	      }
	    }, [(item.occupied && item.occupied.events.length > 0) ? [_c('div', {
	      staticClass: "item-template isOccupied",
	      class: [{
	          'item-is-present': item.occupied.events.length === 1 && item.occupied.events[0].event_type === 'presence'
	        },
	        {
	          'item-is-already-attached': item.isOnLesson || item.isWithAvailability
	        }
	      ]
	    }, [(item.icon) ? _c('span', {
	      staticClass: "marg-10-right",
	      class: item.icon
	    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	      attrs: {
	        "src": item.default_thumb_url
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "warning-signs"
	    }, [_vm._l((item.occupied.events), function(event) {
	      return [(event.event_type !== 'presence') ? [(item.isOnLesson && item.currentEventId === event.event_id) ? _c('div', {
	        staticClass: "marg-10-left"
	      }, [_c('span', {
	        staticClass: "icon-user"
	      }), _vm._v(" " + _vm._s(_vm.i18n['also_assigned']) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (item.currentEventId !== event.event_id),
	          expression: "item.currentEventId !== event.event_id"
	        }],
	        staticClass: "marg-10-left warning-signs__sign"
	      }, [_c('span', {
	        staticClass: "icon-warning"
	      }), _vm._v(" " + _vm._s(event.title) + "\n                      ")])] : _vm._e(), _vm._v(" "), _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (item.occupied.events.length === 1 && event.event_type === 'presence'),
	          expression: "item.occupied.events.length === 1 && event.event_type === 'presence'"
	        }],
	        staticClass: "marg-10-left"
	      }, [_c('span', {
	        staticClass: "icon-clock"
	      }), _vm._v(" " + _vm._s(_vm.i18n['working_hours']) + ": " + _vm._s(_vm._f("localeTime")(event.event_time_start)) + " -\n                      " + _vm._s(_vm._f("localeTime")(event.event_time_end)) + "\n                    ")])]
	    })], 2)])] : _c('div', {
	      staticClass: "item-template",
	      class: {
	        'item-template--space-between': _vm.itemSpaceBetween
	      }
	    }, [(item.icon) ? _c('span', {
	      staticClass: "marg-10-right",
	      class: item.icon
	    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
	      attrs: {
	        "src": item.default_thumb_url
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._t("test", null, {
	      "item": item
	    })], 2)], 2) : _vm._e()]
	  }), _vm._v(" "), (_vm.searchedUsers.length > _vm.maxLimit) ? _c('li', {
	    ref: "infinite_scroll",
	    staticClass: "infinite-scroll__bottom"
	  }, [_c('Loader', {
	    staticStyle: {
	      "margin": "12px"
	    },
	    attrs: {
	      "is-extra-small": true,
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e()], 2), _vm._v(" "), (_vm.searchedUsers.length < 1) ? _c('div', {
	    staticClass: "no-match"
	  }, [_vm._t("noMatch", function() {
	    return [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))])]
	  })], 2) : _vm._e()]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "day-cal"
	  }, [_c('div', {
	    staticClass: "day-cal__container"
	  }, [_c('ul', {
	    staticClass: "day-cal__time-sidebar"
	  }, _vm._l((_vm.hoursInLocale), function(n) {
	    return _c('li', {
	      staticClass: "time-hours"
	    }, [_vm._v("\n          " + _vm._s(n) + "\n        ")])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('ul', {
	    staticClass: "day-cal__time-background"
	  }, [_vm._l((_vm.hours.length * 2), function(n) {
	    return _c('li', {
	      staticClass: "time-slot",
	      class: {
	        today: _vm.isToday
	      }
	    })
	  }), _vm._v(" "), (_vm.isToday) ? _c('now-indicator', {
	    attrs: {
	      "start": _vm.start,
	      "slotHeight": _vm.slotHeight
	    }
	  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event-container"
	  }, [_vm._l((_vm.correctEvents), function(event) {
	    return [_c('cal-event', {
	      attrs: {
	        "event": event,
	        "start": _vm.start,
	        "i18n": _vm.i18n
	      },
	      on: {
	        "eventClicked": _vm.onTap
	      }
	    })]
	  })], 2)])])])])
	},staticRenderFns: []}

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._v(_vm._s(_vm.count))])
	},staticRenderFns: []}

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "d_modal",
	    staticClass: "modal__confirm__delete-wrapper text-dark",
	    class: [{
	      'js-no-close': _vm.appendToBody
	    }, {
	      'modal__confirm__delete__wider': _vm.isShowDontAskAgain
	    }],
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal__confirm__delete"
	  }, [(_vm.showClose) ? _c('div', {
	    staticClass: "close-cross icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]) : _vm._e(), _vm._v(" "), _vm._t("insertComponent", function() {
	    return [_c('div', {
	      staticClass: "modal__confirm__delete__template",
	      attrs: {
	        "slot": "insertComponent"
	      },
	      slot: "insertComponent"
	    }, [_c('div', [_c('div', {
	      staticClass: "modal__confirm__delete__close icon__bg-circle",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.$emit('close')
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })]), _vm._v(" "), _vm._t("item"), _vm._v(" "), (_vm.isShowConfirmDeleteMessage) ? [(!_vm.isOnlyOwnCalendarText) ? _c('h4', [_vm._v(_vm._s(_vm.i18n.are_you_sure))]) : _vm._e(), _vm._v(" "), (_vm.isOnlyOwnCalendarText) ? _c('h4', [_vm._v(_vm._s(_vm.i18n.are_you_sure_own_calendar))]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', [_vm._t("custom_warning")], 2), _vm._v(" "), _c('div', {
	      staticClass: "modal__confirm__delete__buttons"
	    }, [(_vm.isShowDontAskAgain) ? _c('div', {
	      staticClass: "do-checkbox-group"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.isDontAskAgain),
	        expression: "isDontAskAgain"
	      }],
	      staticClass: "form-check-input",
	      attrs: {
	        "type": "checkbox",
	        "id": "dontAskAgain"
	      },
	      domProps: {
	        "checked": Array.isArray(_vm.isDontAskAgain) ? _vm._i(_vm.isDontAskAgain, null) > -1 : (_vm.isDontAskAgain)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.isDontAskAgain,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.isDontAskAgain = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.isDontAskAgain = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.isDontAskAgain = $$c
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "d-label form-check-label",
	      attrs: {
	        "for": "dontAskAgain"
	      }
	    }, [_vm._v(_vm._s(_vm.i18n.dont_ask_me_again))])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "modal__confirm__delete__buttons__buttons"
	    }, [_vm._t("confirm_buttons", function() {
	      return [_c('button', {
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.$emit('close')
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.i18n.cancel))]), _vm._v(" "), _c('button', {
	        ref: "submit_bttn",
	        staticClass: "bttn bttn--danger",
	        class: {
	          'bttn--loading': _vm.isSubmitButtonLoading
	        },
	        on: {
	          "keyup": [function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	            return _vm.onConfirm.apply(null, arguments)
	          }, function($event) {
	            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	            return _vm.$emit('close')
	          }],
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.onConfirm.apply(null, arguments)
	          }
	        }
	      }, [_vm._t("confirmText", function() {
	        return [_vm._v(_vm._s(_vm.i18n.delete))]
	      })], 2)]
	    })], 2)])], 2)])]
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "to-categories"
	  }, [_c('div', {
	    staticClass: "to-categories-container"
	  }, [_c('div', {
	    staticClass: "to-categories__header"
	  }, [_c('h3', [_vm._v("Opgaveoversigt kategorier " + _vm._s(_vm.schoolYear.name))]), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('setCreateCategory', true)
	      }
	    }
	  }, [_vm._v("\n        Opret ny kategori\n      ")])]), _vm._v(" "), (_vm.taskCategories.length < 1) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen kategorier")]) : _vm._e(), _vm._v(" "), _c('draggable', {
	    on: {
	      "change": _vm.onChangeOrder
	    },
	    model: {
	      value: (_vm.taskCategoriesOrder),
	      callback: function($$v) {
	        _vm.taskCategoriesOrder = $$v
	      },
	      expression: "taskCategoriesOrder"
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": "flip-list",
	      "tag": "ul"
	    }
	  }, _vm._l((_vm.taskCategoriesOrder), function(taskCategory, key) {
	    return _c('li', {
	      key: taskCategory.id,
	      staticClass: "to-categories-container__category__container"
	    }, [_c('div', {
	      staticClass: "to-categories-container__category"
	    }, [_c('div', [_c('div', {
	      staticClass: "to-categories-container__category__number"
	    }, [_c('span', [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'top',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                    arrow: false,\n                      placement : 'top',\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--move",
	      attrs: {
	        "content": 'Flyt op eller ned for at sortere'
	      }
	    }, [_c('svg', {
	      staticStyle: {
	        "enable-background": "new 0 0 572.156 572.156"
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "xmlns:xlink": "http://www.w3.org/1999/xlink",
	        "version": "1.1",
	        "id": "Capa_1",
	        "x": "0px",
	        "y": "0px",
	        "width": "13px",
	        "height": "13px",
	        "viewBox": "0 0 572.156 572.156",
	        "xml:space": "preserve"
	      }
	    }, [_c('g', [_c('polygon', {
	      attrs: {
	        "points": "495.405,241.769 418.657,197.457 418.657,258.115 314.042,258.115 314.042,153.498 374.699,153.498    330.389,76.751 286.078,0 241.769,76.751 197.457,153.498 258.115,153.498 258.115,258.115 153.498,258.115 153.498,197.457    76.751,241.767 0,286.078 76.751,330.387 153.498,374.699 153.498,314.042 258.115,314.042 258.115,418.657 197.457,418.657    241.767,495.405 286.078,572.156 330.387,495.405 374.699,418.657 314.042,418.657 314.042,314.042 418.657,314.042    418.657,374.699 495.405,330.389 572.156,286.078  "
	      }
	    })]), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')])])]), _vm._v(" "), _c('div', {
	      staticClass: "to-categories-container__category__text"
	    }, [(_vm.getIsTheEditTask(taskCategory)) ? _c('div', {
	      staticClass: "to-input-and-button"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.theEditTask.name),
	        expression: "theEditTask.name"
	      }, {
	        name: "focus",
	        rawName: "v-focus"
	      }],
	      staticClass: "d-input",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.theEditTask.name)
	      },
	      on: {
	        "keyup": [function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.saveEditTask.apply(null, arguments)
	        }, function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	          $event.stopPropagation();
	          return _vm.setEditTask(null)
	        }],
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.theEditTask, "name", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn do-bttn--submit",
	      class: {
	        'do-bttn--submit--loading': _vm.theUpdatingTaskId === taskCategory.id
	      },
	      on: {
	        "click": _vm.saveEditTask
	      }
	    }, [_vm._v("Gem\n                  ")]), _vm._v(" "), _c('button', {
	      staticClass: "do-bttn",
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(null)
	        }
	      }
	    }, [_vm._v("Annuller")]), _vm._v(" "), (taskCategory.v_is_used_on_subjects.length === 0) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'top',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                        arrow: false,\n                      placement : 'top',\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                    }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      attrs: {
	        "content": _vm.$t('vue2.common.delete')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheDeleteTaskCategory(taskCategory)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })]) : _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'top',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: false,\n                  placement : 'top',\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger cursor-not-allowed",
	      attrs: {
	        "content": 'Kan ikke slettes, da den bruges på ' + taskCategory.v_is_used_on_subjects.length + ' fag/opgaver'
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin",
	      staticStyle: {
	        "opacity": "0.5"
	      }
	    })])]) : [_vm._v("\n                  " + _vm._s(taskCategory.name) + "\n                  "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'top',
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                  arrow: false,\n                  placement : 'top',\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
	      }],
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "content": _vm.$t('vue2.common.edit')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(taskCategory)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })])]], 2)]), _vm._v(" "), _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedItem),
	        expression: "selectedItem"
	      }],
	      staticClass: "do-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.selectedItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	        }, function($event) {
	          return _vm.onAddSubjectType(taskCategory, $event.target.value)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": "",
	        "selected": "",
	        "value": "null"
	      }
	    }, [_vm._v("Tilføj briktype til kategorien")]), _vm._v(" "), _vm._l((_vm.getFilteredDbSubjectTypes(taskCategory)), function(option) {
	      return _c('option', {
	        domProps: {
	          "value": option.key
	        }
	      }, [_vm._v("\n                  " + _vm._s(option.v_title) + "\n                ")])
	    })], 2)])]), _vm._v(" "), _c('ul', {
	      ref: "droppable_elements",
	      refInFor: true,
	      staticClass: "to-categories-container__category__subject-types dropzone",
	      class: {
	        'dropzone--active': _vm.dragEvt && _vm.draggedFromCategoryId !== taskCategory.id
	      },
	      on: {
	        "dragover": function($event) {
	          $event.preventDefault();
	        },
	        "dragenter": function($event) {
	          $event.preventDefault();
	          return _vm.dragEnter(taskCategory, $event)
	        },
	        "dragleave": function($event) {
	          $event.preventDefault();
	          return _vm.dragLeave.apply(null, arguments)
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(taskCategory, $event)
	        }
	      }
	    }, [(taskCategory.v_subject_types.length === 0) ? _c('li', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen kategorier")]) : _vm._e(), _vm._v(" "), _vm._l((taskCategory.v_subject_types), function(subjectType) {
	      return _c('li', {
	        key: subjectType.key,
	        staticClass: "d-tag cursor-grab",
	        attrs: {
	          "draggable": "true"
	        },
	        on: {
	          "dragstart": function($event) {
	            $event.stopPropagation();
	            return _vm.dragStart(subjectType, taskCategory.id, $event)
	          },
	          "dragend": function($event) {
	            $event.stopPropagation();
	            return _vm.dragEnd(subjectType, $event)
	          },
	          "dragover": function($event) {
	            $event.stopPropagation();
	          },
	          "drop": function($event) {
	            $event.preventDefault();
	            return _vm.drop(taskCategory, $event)
	          }
	        }
	      }, [_vm._v("\n              " + _vm._s(subjectType.v_name) + "\n            ")])
	    })], 2)])
	  }), 0)], 1)], 1), _vm._v(" "), (_vm.theDeleteTaskCategory) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "123123"
	    },
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": false,
	      "placeInTop": true,
	      "appendToBody": true,
	      "isCloseOnEsc": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setTheDeleteTaskCategory(null)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "brutto-warning text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-warning__header"
	  }, [_c('h2', [_vm._v("Er du sikker")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": function($event) {
	        return _vm.setTheDeleteTaskCategory(null)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__body"
	  }, [_c('svg', {
	    staticClass: "tw-icon tw-icon--red",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "2",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "9",
	      "x2": "12",
	      "y2": "13"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "17",
	      "x2": "12.01",
	      "y2": "17"
	    }
	  })]), _vm._v(" "), (_vm.theDeleteTaskCategory.v_subject_types && _vm.theDeleteTaskCategory.v_subject_types.length > 0) ? [_c('h4', [_vm._v("Før du kan slette denne kategori, skal du vælge en ny kategori til dens standard briktyper.")]), _vm._v(" "), _c('ul', {
	    staticClass: "list-order-items"
	  }, _vm._l((_vm.theDeleteTaskCategory.v_subject_types), function(subjectType) {
	    return _c('li', {
	      key: subjectType.key
	    }, [_c('b', [_vm._v(_vm._s(subjectType.v_name))]), _vm._v(" "), _c('select', {
	      staticClass: "do-select",
	      domProps: {
	        "value": null
	      },
	      on: {
	        "change": function($event) {
	          return _vm.onChangeCategoryForSubjectType($event.target.value, subjectType.key)
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "disabled": ""
	      },
	      domProps: {
	        "value": null
	      }
	    }, [_vm._v("Vælg ny kategori..")]), _vm._v(" "), _vm._l((_vm.getTaskCategoriesOrder), function(option) {
	      return _c('option', {
	        domProps: {
	          "value": option.id
	        }
	      }, [_vm._v("\n                  " + _vm._s(option.name) + "\n                ")])
	    })], 2)])
	  }), 0)] : _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          Vil du slette kategorien permanent?\n        ")])], 2), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__footer"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.setTheDeleteTaskCategory(null)
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), (_vm.theDeleteTaskCategory.v_subject_types.length > 0) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v("Slet\n        ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--danger",
	    class: [{
	      'do-bttn--submit--loading': _vm.theDeletedCategoryId === _vm.theDeleteTaskCategory.id
	    }],
	    on: {
	      "click": function($event) {
	        return _vm.deleteTaskCategory(_vm.theDeleteTaskCategory)
	      }
	    }
	  }, [_vm._v("Slet\n        ")])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-dist text-dark"
	  }, [(_vm.isPrintUsers) ? _c('SubjectDistributionPrint', {
	    on: {
	      "close": _vm.closeIsPrintUsers
	    }
	  }) : [_c('div', {
	    staticClass: "subject-dist__header"
	  }, [_c('div', {
	    staticClass: "subject-dist__header__left"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale].subjects_for_teachers))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "subject-dist__header__right"
	  }, [(_vm.theZENToken.length > 0) ? _c('a', {
	    attrs: {
	      "href": _vm.zenUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].go_to_zen))]) : _vm._e(), _vm._v(" "), (_vm.userCanManageSchool) ? _c('button', {
	    staticClass: "do-bttn bttn-export",
	    on: {
	      "click": function($event) {
	        _vm.isOpenDurationModal = true
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].export_to_zen) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "flipper-buttons"
	  }, [_c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': !_vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-year-planning"
	  }), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].subjects) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': _vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-file-text"
	  }), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].tasks) + "\n          ")])])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "color": "blue"
	    }
	  }) : _c('div', {
	    staticClass: "subject-dist__body"
	  }, [_c('div', {
	    staticClass: "doTable__users"
	  }, [_c('div', {
	    staticClass: "doTable__users__header"
	  }, [_c('FilterUsers', {
	    staticClass: "pad-10",
	    attrs: {
	      "searchText": _vm.i18n[_vm.locale].filter_users
	    }
	  })], 1), _vm._v(" "), (!_vm.isPoolsDeactivated) ? _c('div', {
	    staticClass: "filter pointer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isShowOnlyTeacherWithTeachingTime),
	      expression: "isShowOnlyTeacherWithTeachingTime"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "only-teachers-with-teaching_time"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isShowOnlyTeacherWithTeachingTime) ? _vm._i(_vm.isShowOnlyTeacherWithTeachingTime, null) > -1 : (_vm.isShowOnlyTeacherWithTeachingTime)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isShowOnlyTeacherWithTeachingTime,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isShowOnlyTeacherWithTeachingTime = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isShowOnlyTeacherWithTeachingTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isShowOnlyTeacherWithTeachingTime = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "marg-5-left pointer no-select",
	    attrs: {
	      "for": "only-teachers-with-teaching_time"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].only_show_users_with_uv_time) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "d-box users-list"
	  }, [_c('li', {
	    staticClass: "user-item user-item__header"
	  }, [_c('div', {
	    staticClass: "user-sorter",
	    class: {
	      'user-sorter--active': _vm.sortBy === 'name'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortBy('name')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].name) + "\n              "), _c('span', {
	    staticClass: "icon-menu-open"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "user-sorter",
	    class: {
	      'user-sorter--active': _vm.sortBy === 'teachingTimeDiff'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setSortBy('teachingTimeDiff')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].teaching_hours) + " "), _c('span', {
	    staticClass: "icon-menu-open"
	  })])]), _vm._v(" "), (_vm.sortedUsersFilteredWithTags.length < 1) ? _c('h4', {
	    staticClass: "explainer-text"
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].no_users_matches) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedUsersFilteredWithTags), function(user) {
	    return _c('li', {
	      key: user.user_calendar_id,
	      staticClass: "user-item",
	      class: {
	        'user-item--is-open': user.id === _vm.activeUserId
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveUserId(user.id)
	        }
	      }
	    }, [(user.id !== _vm.activeUserId) ? _c('div', {
	      staticClass: "user-item__name"
	    }, [_c('span', {
	      staticClass: "icon-arrow-right4"
	    }), _vm._v(" "), (user.default_thumb_url) ? _c('img', {
	      staticClass: "user-item__name__img",
	      attrs: {
	        "src": user.default_thumb_url
	      }
	    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]) : _vm._e(), _vm._v(" "), (user.id !== _vm.activeUserId) ? _c('div', [(_vm.userHasAgreements(user.id)) ? _c('span', {
	      staticClass: "icon-file-text2"
	    }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.getUserTeachingHoursDiff(user.id)) + "\n              "), _c('span', {
	      staticClass: "icon-arrow-down4"
	    })]) : _vm._e(), _vm._v(" "), (user.id === _vm.activeUserId) ? _c('SubjectsDistributionUser', {
	      attrs: {
	        "activeUserId": _vm.activeUserId,
	        "isPoolsDeactivated": _vm.isPoolsDeactivated
	      },
	      on: {
	        "editSubject": _vm.setEditSubject,
	        "editTask": _vm.setEditTask,
	        "close": _vm.resetActiveUserId
	      }
	    }) : _vm._e()], 1)
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "subjects-and-tasks"
	  }, [(_vm.isTasksView) ? _c('SubjectsDistributionTasks') : _c('div', {
	    staticClass: "doTable"
	  }, [_c('div', {
	    staticClass: "subject-dist__header"
	  }, [_c('div', {
	    staticClass: "subject-dist__header__left"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['grades'],
	      "tags": _vm.klassTags,
	      "selectedTags": _vm.selectedKlassFilters
	    },
	    on: {
	      "select": _vm.toggleKlassTag,
	      "clear": _vm.clearSelectedKlassFilters
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['subjects_status'],
	      "tags": _vm.subjectStatusFilters,
	      "selectedTags": _vm.selectedSubjectStatusFilters
	    },
	    on: {
	      "select": _vm.toggleSelectedSubjectStatusFilters,
	      "clear": _vm.clearSelectedSubjectStatusFilters
	    }
	  }), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": _vm.i18n[_vm.locale]['subjects'],
	      "tags": _vm.uniqueSubjects,
	      "selectedTags": _vm.selectedSubjectFilters
	    },
	    on: {
	      "select": _vm.toggleSelectedSubjectFilters,
	      "clear": _vm.clearSelectedSubjectFilters
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "subject-dist__header__right"
	  }, [(_vm.isUpdatingSchoolYear) ? _c('div', {
	    staticClass: "do-spinner do-spinner--small"
	  }) : _vm._e(), _vm._v(" "), (_vm.userCanManageSchool && _vm.isSchoolDanish) ? _c('DoButtonAndDate', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: false,
	        placement: 'top'
	      }),
	      expression: "{\n                  arrow: false,\n                  placement : 'top'\n                }"
	    }],
	    attrs: {
	      "content": "Fag kan ønskes af brugere med rettigheden",
	      "selectedDate": _vm.subjectsRequestEndDate
	    },
	    on: {
	      "dateChanged": _vm.onSetSubjectsRequestEndDate
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('ul', {
	    staticClass: " doTable__items\n            "
	  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
	    return _c('li', {
	      key: klassCal.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(klassCal.name))]), _vm._v(" "), _c('div', {
	      staticClass: "doTable__klass__header__flex"
	    }, [(_vm.isSchoolDanish && idx === 0) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n                         arrow: true,\n                         animateFill: false,\n                         animation : 'shift-away',\n                         zIndex: '999999992',\n                         boundary: 'window'}"
	      }],
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "content": "Ændre fag der tæller i med i Timer i skoleåret"
	      },
	      on: {
	        "click": function($event) {
	          _vm.isModalKlassTotalHours = true
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].hours_in_school_year) + ":")]), _vm._v(" "), _c('span', {
	      staticClass: "doTable__klass__header__hours"
	    }, [_vm._v(_vm._s(klassCal.vTotalHours))])])]), _vm._v(" "), _c('ul', {
	      staticClass: "subjects"
	    }, _vm._l((klassCal.vSubjects), function(subject) {
	      return _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            onShow: function () { return subject.vHasTeachers; }
	          }),
	          expression: "{\n                  arrow: true,\n                  onShow: () => subject.vHasTeachers\n                }"
	        }],
	        key: subject.id,
	        staticClass: "subjects_subject",
	        class: [{
	          'subject--has-user': subject.vHasTeachers
	        }, {
	          'subject--has-room': subject.vHasRooms
	        }, {
	          'subject--has-request': subject.vRequestedBy.length > 0
	        }],
	        style: ({
	          'background': subject.color
	        }),
	        attrs: {
	          "content": subject.vUserNames
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(subject)
	          }
	        }
	      }, [_vm._v("\n                  " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n                ")])
	    }), 0)])
	  }), 0)])], 1)])], _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
	    attrs: {
	      "showModal": _vm.isSubjectModal,
	      "editSubject": _vm.editSubject,
	      "propIsLoading": _vm.isSubjectLoading,
	      "isShowSubjectsRequest": _vm.isShowSubjectsRequest,
	      "subjectsRequestsInHash": _vm.subjectsRequestsInHash
	    },
	    on: {
	      "deleteSubject": _vm.deleteSubject,
	      "close": _vm.closeModal,
	      "updateSubject": _vm.updateSubject
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$store.commit('setConfirmDeletion', false)
	      },
	      "confirm": _vm.confirmDelete
	    }
	  }, [_c('h3', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.theEditTask) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('SubjectsDistributionTasksCreate', {
	    attrs: {
	      "slot": "insertComponent",
	      "editTask": _vm.theEditTask
	    },
	    on: {
	      "close": function($event) {
	        _vm.theEditTask = null
	      }
	    },
	    slot: "insertComponent"
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('StandardDurationSetting', {
	    attrs: {
	      "isForImportInZEN": true,
	      "isOpenModal": _vm.isOpenDurationModal
	    },
	    on: {
	      "close": function($event) {
	        _vm.isOpenDurationModal = false
	      },
	      "submit": _vm.saveUpdatedDuration
	    }
	  }), _vm._v(" "), (_vm.isModalKlassTotalHours) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal text-dark",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h4', [_vm._v("Ændre \"Timer i skoleåret\"")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isModalKlassTotalHours = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "label-with-toggle",
	    on: {
	      "click": _vm.toggleDoesRessCount
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Skal ressourcetimer tælle med i tallet \"Timer i skoleåret\" på denne side?")]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.doesRessCountInKlassTotalHours
	    }
	  })], 1)])])]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "task-overview-settings__settings"
	  }, [_c('div', {
	    staticClass: "task-overview-settings__settings-container"
	  }, [_c('h2', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v("1. Skjul antal timer tildelt på visse opgaver")]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('div', {
	    staticClass: "d-explainer-box text-explainer text-explainer__error"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-help",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
	    }
	  })]), _vm._v("\n        Aktivér denne indstilling for at skjule timepuljen for alle opgaver med mindre end et bestemt antal timer\n        (f.eks. 60 timer) for alle andre end administratorer. Selve opgaverne vil stadig være synlige for lærerne, men\n        de vil ikke kunne se det specifikke antal timer, der er allokeret til dem.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-label-and-toggle",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setIsActive.apply(null, arguments)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label color-dark"
	  }, [_vm._v("Skjul timepuljer")]), _vm._v(" "), _c('div', {
	    staticClass: "do-switch",
	    class: {
	      'do-switch--active': _vm.isActive
	    }
	  })]), _vm._v(" "), (_vm.isActive) ? _c('div', [_c('div', {
	    staticClass: "prep-factor-input marg-1-bottom"
	  }, [_c('p', {
	    staticClass: "italic"
	  }, [_vm._v("Indtast det antal timer, hvor timepuljen på opgaver skal skjules")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.thresholdToHideTaskHours),
	      expression: "thresholdToHideTaskHours"
	    }],
	    ref: "the_input_field",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.thresholdToHideTaskHours)
	    },
	    on: {
	      "blur": _vm.onSave,
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSave.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.thresholdToHideTaskHours = $event.target.value
	      }
	    }
	  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "task-overview-settings__settings-container"
	  }, [_c('h2', [_vm._v("2. Visning af fordeling af puljer")]), _vm._v(" "), _c('h4', {
	    staticClass: "italic marg-1-bottom"
	  }, [_vm._v("Fordelingen er med til at give medarbejdere et overblik over deres arbejdstid og\n      puljer herunder som f.eks. undervisning.\n      Visse felter vises kun, hvis brugeren har fået tidelt timer timer i puljen f.eks. SFO.")]), _vm._v(" "), _c('div', {
	    staticClass: "d-table__container"
	  }, [_c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
	    staticClass: "td-toggler",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('work_hours')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('work_hours')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("100%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n            1642.8\n          ")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("1586")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgba(62, 207, 142, 0.57)"
	    }
	  }, [_vm._v("56.8")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "td-toggler",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('teaching')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('teaching')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Undervisning")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("49%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("800")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("693.88")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgb(62, 207, 142)"
	    }
	  }, [_vm._v("106.13")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    staticClass: "td-toggler",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('tasks')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('tasks')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Øvrige Opgaver")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("24%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("400")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("398")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('preparation')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('preparation')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Forberedelse")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("24%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("400")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("400")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('pool')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('pool')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Lokalpulje")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("5%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("80")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgba(62, 207, 142, 0.8)"
	    }
	  }, [_vm._v("80")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('substitute_hours')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('substitute_hours')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Vikartimer")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("1%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("20")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgba(62, 207, 142, 0.17)"
	    }
	  }, [_vm._v("17")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('teaching_and_sub')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('teaching_and_sub')
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_vm._v("Undervisning + Vikartimer (UV-timer)")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("820")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("696.88")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number",
	    staticStyle: {
	      "background-color": "rgb(62, 207, 142)"
	    }
	  }, [_vm._v("123.12")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSettings('club')
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.getIsOn('club')
	    }
	  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("3%")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("57.2")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.taskCategories), function(taskCategory) {
	    return _c('tr', {
	      key: taskCategory.id
	    }, [_c('td', [_c('div', {
	      staticClass: "td-toggler",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleOwnPool(taskCategory.name)
	        }
	      }
	    }, [_c('AppToggle', {
	      attrs: {
	        "allowChanges": false,
	        "propOn": _vm.getIsOwnPoolOn(taskCategory.name)
	      }
	    })], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(taskCategory.name))])])
	  })], 2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Vis")]), _vm._v(" "), _c('th', [_c('h4', [_vm._v("Standardpuljer")])]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Tildelt")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Skemalagt")]), _vm._v(" "), _c('th', {
	    staticClass: "is-number"
	  }, [_vm._v("Forskel")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('span', {
	    staticClass: "d-badge d-badge--warning"
	  }, [_vm._v("SFO")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_c('b', [_vm._v("Vis optælling fra egne kategorier")])])])
	}]}

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subject-list"
	  }, [_c('div', {
	    staticClass: "flex space-between"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.createklass.subjects_for')) + "\n      " + _vm._s(_vm.activeKlassStep)), (_vm.locale !== 'en') ? _c('span', [_vm._v(".")]) : _c('span', [_vm._v(_vm._s(_vm.classesNumberized))]), _vm._v("\n      " + _vm._s(_vm.$t('vue2.createklass.grade')) + "\n    ")])]), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Spinner', {
	    attrs: {
	      "color": "blue"
	    }
	  })], 1) : _c('ul', _vm._l((_vm.activeSubjects), function(subject) {
	    return _c('li', {
	      staticClass: "subject-list__subject",
	      style: ({
	        backgroundColor: subject.color
	      })
	    }, [_c('div', [_vm._v(_vm._s(subject.subject))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("removeDecimal")(subject.hours)) + _vm._s(_vm.$t('vue2.createklass.hoursPrYear')))])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "add-lesson__header"
	  }, [_c('h2', [_vm._v("Opret klasse")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "add-lesson__form"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Klassenavn")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.klassebetegnelse),
	      expression: "klassebetegnelse"
	    }],
	    ref: "inputTitle",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.klassebetegnelse)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submit.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.klassebetegnelse = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "marg-1-right bg-white",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isFormValid) ? _c('div', {
	    staticClass: "hint--top-left",
	    attrs: {
	      "aria-label": "Udfyld formularen"
	    }
	  }, [_c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v("Opret")])]) : _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Opret")])])])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "subs-delete",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	      }
	    }
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "subs-delete-subs text-dark"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "subs-delete-subs__loader marg-2-top"
	  }, [_c('h3', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.checking_for_substitutes')))]), _vm._v(" "), _c('Loader', {
	    staticStyle: {
	      "margin-top": "1rem"
	    },
	    attrs: {
	      "isSmall": true
	    }
	  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length < 1) ? _c('div', {
	    staticClass: "input-group-subs"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.lessons_with_substitutes')))]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.no_subs_on_lessons')))])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length > 0) ? _c('div', {
	    staticClass: "marg-1-top"
	  }, [_c('div', {
	    staticClass: "subs-days-container__header"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.eventsWithSubstitutes.length) + "\n        " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.lessons_with_substitutes')))]), _vm._v(" "), _c('p', {
	    staticClass: "select-all-item",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.eventsToRemovedSubs.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.unselect_all')))])])]), _vm._v(" "), _c('ul', {
	    staticClass: "subs-days-container rounded shadow"
	  }, _vm._l((_vm.eventsSortedInDays), function(day) {
	    return _c('li', [_c('div', {
	      staticClass: "day__header"
	    }, [_c('label', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("ddd")(day.date))) + ", " + _vm._s(_vm._f("LL")(day.date)))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.remove_sub')))])]), _vm._v(" "), _c('ul', {
	      staticClass: "sub-lessons"
	    }, _vm._l((day.events), function(event) {
	      return _c('li', {
	        key: event.event_id,
	        staticClass: "d-lesson",
	        class: {
	          'd-lesson--active': _vm.isInEventsToRemovedSubs(event)
	        },
	        style: ({
	          'border-color': event.color
	        }),
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            $event.preventDefault();
	            return _vm.toggleEvent(event)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "d-lesson__title"
	      }, [_c('span', {
	        staticClass: "d-lesson__time"
	      }, [_vm._v(_vm._s(_vm._f("LT")(event.start)) + " - " + _vm._s(_vm._f("LT")(event.end)))]), _vm._v("\n              " + _vm._s(event.title) + ", "), _vm._l((_vm.getClasses(event)), function(klass) {
	        return _c('span', [_vm._v(" " + _vm._s(klass.name))])
	      })], 2), _vm._v(" "), _c('div', {
	        staticClass: "sub-selector"
	      }, [_vm._l((_vm.getSubstitute(event)), function(sub) {
	        return _c('p', {
	          staticClass: "sub-name"
	        }, [_c('b', [_vm._v(_vm._s(sub.name))])])
	      }), _vm._v(" "), _c('div', {
	        staticClass: "d-checkbox",
	        class: {
	          'd-checkbox--active': _vm.isInEventsToRemovedSubs(event)
	        }
	      })], 2)])
	    }), 0)])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventsToRemovedSubs.length !== 0 || _vm.eventsWithSubstitutes.length !== 0) ? _c('div', {
	    staticClass: "subs-delete__footer"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.eventsToRemovedSubs.length) + " " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.of')) + " " + _vm._s(_vm.eventsWithSubstitutes.length) + "\n      " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.lessons_that_will_have_subs_removed')))])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Opret klassefravær")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isMultipleSchoolsActive && !_vm.activeSchoolId) ? [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vælg skole for klassefravær")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activeSchoolId),
	      expression: "activeSchoolId"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.activeSchoolId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.onChangeActiveSchoolId]
	    }
	  }, _vm._l((_vm.userSchoolsSorted), function(school) {
	    return _c('option', {
	      domProps: {
	        "value": school.id
	      }
	    }, [_vm._v("\n              " + _vm._s(school.name) + "\n            ")])
	  }), 0)])] : (_vm.activeSchoolId && (_vm.isLoadingSchoolCalendars || _vm.isLoadingSchoolYears)) ? [_c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })])] : [_c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vælg klasse")]), _vm._v(" "), _c('DSelectCals', {
	    attrs: {
	      "items": _vm.klassCalendars,
	      "itemsSelected": _vm.selectedKlasses,
	      "multiple": false,
	      "placeholder": _vm.$t('vue2.dselect.placeholder_calendars'),
	      "showCalendarYear": true
	    },
	    on: {
	      "update": _vm.setSelectedKlasses
	    }
	  })], 1), _vm._v(" "), (_vm.selectedKlasses.length > 0) ? [_c('OutOfSchoolSubject', {
	    attrs: {
	      "schoolId": _vm.activeSchoolId,
	      "calendarId": _vm.selectedKlasses[0]['id'],
	      "date": _vm.startDate,
	      "selectedSubject": _vm.selectedSubject
	    },
	    on: {
	      "setSubject": _vm.setSelectedSubject
	    }
	  })] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Deltagende personer")]), _vm._v(" "), _c('DSelectCals', {
	    attrs: {
	      "items": _vm.userCalendars,
	      "itemsSelected": _vm.selectedUsers,
	      "multiple": true,
	      "placeholder": _vm.$t('vue2.dselect.placeholder_calendars')
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1), _vm._v(" "), (_vm.selectedUsers.length > 0) ? [_c('OutOfSchoolAbsence', {
	    on: {
	      "setSubject": _vm.setSelectedAbsence
	    }
	  })] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Dato")]), _vm._v(" "), _c('DatepickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.date
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Tid")]), _vm._v(" "), _c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  })], 1)]], 2), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons d-modal__buttons__padding",
	    staticStyle: {
	      "padding": "1rem 3rem"
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.create')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-button-and-date"
	  }, [(_vm.isDatepickerOpen && _vm.selectedDate) ? _c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('dateChanged', null)
	      }
	    }
	  }, [_vm._v("\n    Luk for fagønsker\n  ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    on: {
	      "click": function($event) {
	        _vm.isDatepickerOpen = !_vm.isDatepickerOpen
	      }
	    }
	  }, [(!_vm.selectedDate) ? [_vm._v("\n      " + _vm._s(_vm.isDatepickerOpen ? 'Slutdato for fagønsker' : 'Åbn for fagønsker') + "\n    ")] : _vm._e(), _vm._v(" "), (_vm.selectedDate) ? [_vm._v("\n      Slutdato for fagønsker\n      "), _c('div', {
	    staticClass: "do-filters__divider"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "do-badge"
	  }, [_vm._v(_vm._s(_vm.selectedDateFormatted))])] : _vm._e()], 2), _vm._v(" "), (_vm.isDatepickerOpen) ? _c('div', {
	    staticClass: "do-button-and-date__datepicker"
	  }, [_c('DateSelector', {
	    staticStyle: {
	      "width": "210px"
	    },
	    attrs: {
	      "isOpen": true,
	      "isShowInput": false,
	      "date": _vm.selectedDate ? _vm.selectedDate : new Date()
	    },
	    on: {
	      "changed": function($event) {
	        return _vm.setDate($event)
	      },
	      "close": function($event) {
	        _vm.isDatepickerOpen = false
	      }
	    }
	  })], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    staticStyle: {
	      "z-index": "112313123"
	    },
	    attrs: {
	      "showClose": false,
	      "isBgOverlay": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal d-modal__opus",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Data fra KMD OPUS for " + _vm._s(_vm.user.v_user_name))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__header__right"
	  }, [_c('div', {
	    staticClass: "icon__bg-circle no-print",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : [_c('h3', [_vm._v("\n          For perioden " + _vm._s(_vm.titleOfPeriod) + "\n        ")]), _vm._v(" "), (_vm.oneTimePayments.length === 0) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen data for perioden")]) : _vm._e(), _vm._v(" "), (_vm.oneTimePayments.length > 0) ? _c('table', {
	    staticClass: "do-table"
	  }, [_c('thead', [_c('tr', _vm._l((_vm.oneTimePayments[0]), function(value, key) {
	    return _c('th', {
	      key: key
	    }, [_vm._v("\n              " + _vm._s(key.replace('_', ' ')) + "\n            ")])
	  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.oneTimePayments), function(payment) {
	    return _c('tr', {
	      key: payment.id
	    }, _vm._l((payment), function(value, key) {
	      return _c('td', {
	        key: key
	      }, [_vm._v("\n              " + _vm._s(value || '-') + "\n            ")])
	    }), 0)
	  }), 0)]) : _vm._e()]], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals text-dark"
	  }, [_c('div', {
	    staticClass: "d-acc",
	    class: {
	      'd-acc--open': _vm.isAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header",
	    on: {
	      "click": _vm.toggleIsAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header__left"
	  }, [_c('div', {
	    staticClass: "d-toggle-arrow",
	    class: {
	      'd-toggle-arrow--open': _vm.isAccOpen
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title) + " (" + _vm._s(_vm.calendarsExclArchived.length) + ")")])])]), _vm._v(" "), (_vm.isAccOpen) ? _c('ul', {
	    staticClass: "d-copy-cals__list"
	  }, [_vm._l((_vm.calendarsExclArchived), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "d-copy-cals__cal"
	    }, [_c('div', {
	      staticClass: "d-copy-cals__cal__left"
	    }, [_vm._v("\n          " + _vm._s(calendar.name) + "\n        ")]), _vm._v(" "), _c('div', {
	      staticClass: "d-copy-cals__cal__right"
	    }, [_c('button', {
	      staticClass: "bttn bttn-simple bttn--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setEditCal(calendar.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-pencil"
	    })]), _vm._v(" "), (_vm.calType === 'room' || _vm.calType === 'merge') ? _c('button', {
	      staticClass: "bttn bttn-simple bttn--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.archiveCal(calendar.id)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.archive')) + "\n          ")]) : _c('button', {
	      staticClass: "bttn bttn-simple bttn--small bttn--warning",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setDeleteCal(calendar.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])])
	  }), _vm._v(" "), (_vm.archivedCalendars.length > 0) ? _c('li', {
	    staticClass: "archived-cals-toggler",
	    on: {
	      "click": function($event) {
	        _vm.isArchivedAccOpen = !_vm.isArchivedAccOpen
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-toggle-arrow",
	    class: {
	      'd-toggle-arrow--open': _vm.isArchivedAccOpen
	    }
	  }), _vm._v(" "), _c('p', [(!_vm.isArchivedAccOpen) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.show')) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.hide')))]), _vm._v(" " + _vm._s(_vm.$t('vue2.calendars.archived')) + " (" + _vm._s(_vm.archivedCalendars.length) + ")")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.archivedCalendars), function(archivedCalendar) {
	    return (_vm.isArchivedAccOpen) ? _c('li', {
	      key: archivedCalendar.id,
	      staticClass: "archived-cal"
	    }, [_vm._v("\n        " + _vm._s(archivedCalendar.name) + "\n        "), (_vm.calType === 'room' || _vm.calType === 'merge') ? _c('button', {
	      staticClass: "bttn bttn-simple bttn--small",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.deArchiveCal(archivedCalendar.id)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.unarchive')) + "\n        ")]) : _vm._e()]) : _vm._e()
	  })], 2) : _vm._e()]), _vm._v(" "), (_vm.theActiveCalId) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.theActiveCalId = null
	      }
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarEditName.edit_name')))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeUpdateCalName
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.calendars.write_name')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.theUpdateCalName),
	      expression: "theUpdateCalName",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    ref: "edit_name_input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.theUpdateCalName)
	    },
	    on: {
	      "change": function($event) {
	        _vm.theUpdateCalName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": _vm.closeUpdateCalName
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.updateCalName
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.update')))])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.theDeleteCalId) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.theDeleteCalId = null
	      }
	    }
	  }, [_c('template', {
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.calendars.do_you_want_to_delete')) + " \"" + _vm._s(_vm.deleteCalName) + "\"?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeDeleteCalModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.write')) + " \"" + _vm._s(_vm.deleteCalName) + "\"\n            " + _vm._s(_vm.$t('vue2.editCalendarDelete.if_you_want_to_delete')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theDeleteCalName),
	      expression: "theDeleteCalName"
	    }],
	    ref: "delete_name_input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.theDeleteCalName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.theDeleteCalName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('h4', {
	    staticClass: "text-danger marg-20-top"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.all_data_will_be_deleted')))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-5-right",
	    on: {
	      "click": _vm.closeDeleteCalModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isDeleteCalValidated) ? _c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _c('button', {
	    staticClass: "submit-button submit-button--danger",
	    on: {
	      "click": _vm.deleteCal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.delete')) + "\n          ")])])])])], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals text-dark"
	  }, [_c('div', {
	    staticClass: "d-acc",
	    class: {
	      'd-acc--open': _vm.isAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header",
	    on: {
	      "click": _vm.toggleIsAccOpen
	    }
	  }, [_c('div', {
	    staticClass: "d-acc__header__left"
	  }, [_c('div', {
	    staticClass: "d-toggle-arrow",
	    class: {
	      'd-toggle-arrow--open': _vm.isAccOpen
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title) + " (" + _vm._s(_vm.calendarsExclArchived.length) + ")")])])]), _vm._v(" "), (_vm.isAccOpen) ? _c('ul', {
	    staticClass: "d-copy-cals__list"
	  }, [_c('li', {
	    staticClass: "d-copy-cals__list__header"
	  }, [_c('p', {
	    staticClass: "d-acc__header__select-all select-all-item ",
	    on: {
	      "click": _vm.toggleAllKlasses
	    }
	  }, [(_vm.selectedCalIds.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('div', {
	    staticClass: "d-copy-cals__list__header__right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.selectedCalIds.length) + " " + _vm._s(_vm.$t('vue2.calendars.selected_of')) + " " + _vm._s(_vm.calendarsExclArchived.length))]), _vm._v(" "), (_vm.selectedCalIds.length < 1) ? _c('button', {
	    staticClass: "bttn--disabled hint--bottom-left",
	    attrs: {
	      "aria-label": this.$t('vue2.calendars.select_calendars_to_copy')
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.delete')) + " " + _vm._s(_vm.fromDateAndToDate) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selectedCalIds.length > 0 && !_vm.isDeleting) ? _c('button', {
	    staticClass: "bttn bttn-danger hint--bottom-left",
	    attrs: {
	      "aria-label": "Both dates are included"
	    },
	    on: {
	      "click": _vm.deleteDays
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.delete')) + " " + _vm._s(_vm.fromDateAndToDate) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selectedCalIds.length > 0 && _vm.isDeleting) ? _c('button', {
	    staticClass: "bttn--disabled bttn-danger bttn--with-spinner"
	  }, [_c('Loader', {
	    staticStyle: {
	      "margin": "0 7px 0 0"
	    },
	    attrs: {
	      "is-extra-small": true
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.delete')) + " " + _vm._s(_vm.fromDateAndToDate) + "\n          ")], 1) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.calendarsExclArchived), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "d-copy-cals__cal",
	      class: {
	        'd-copy-cals__cal--selected': _vm.getIsInSelectedCalIds(calendar.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toogleCal(calendar.id)
	        }
	      }
	    }, [_vm._m(0, true), _vm._v("\n        " + _vm._s(calendar.name) + "\n      ")])
	  })], 2) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-copy-cals__cal__selector"
	  }, [_c('div', {
	    staticClass: "checkbox"
	  })])
	}]}

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-group text-dark"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Fraværsårsag på personer")]), _vm._v(" "), _c('div', {
	    staticClass: "choose-subject"
	  }, [(_vm.isLoadingSubjects) ? _c('div', {
	    staticClass: "choose-subject__spinner"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : _c('dSelect', {
	    attrs: {
	      "items": _vm.sortedSubjects,
	      "receiveData": _vm.theNewSubject,
	      "multiple": false,
	      "placeholder": _vm.$t('vue2.create_activity.search_or_create'),
	      "itemSpaceBetween": true
	    },
	    on: {
	      "enter": function($event) {
	        _vm.isCreateAbsenceReason = true
	      },
	      "update": _vm.setSubject,
	      "searchText": _vm.setTheSearchText,
	      "onSearchTextDebounced": _vm.onSearchTextDebounced,
	      "close": _vm.onCloseDSelect
	    },
	    scopedSlots: _vm._u([_vm._l((_vm.sortedSubjects), function(item, index) {
	      return {
	        key: "test",
	        fn: function(slotProps) {
	          return [_c('div', {
	            staticClass: "choose-subject__event_type"
	          }, [_vm._v("\n          " + _vm._s(slotProps.item.vSubjectType) + "\n        ")])]
	        }
	      }
	    })], null, true)
	  }, [_vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_c('h4', {
	    staticClass: "create-subject-link",
	    on: {
	      "click": function($event) {
	        _vm.isCreateAbsenceReason = true
	      }
	    }
	  }, [_vm._v("\n          + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.theSearchText) + "\"\n        ")])])]), _vm._v(" "), (_vm.isShowCreateSubjectButton) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "icon__bg-circle create-new-subject",
	    attrs: {
	      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.theSearchText + "\" "
	    },
	    on: {
	      "click": function($event) {
	        _vm.isCreateAbsenceReason = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "d-icon-plus"
	  })]) : _vm._e()], 1), _vm._v(" "), (_vm.isCreateAbsenceReason) ? _c('AbsenceReasonsCreate', {
	    attrs: {
	      "initTitle": _vm.theSearchText,
	      "reasons": _vm.sortedSubjects
	    },
	    on: {
	      "create": _vm.createAbsenceReason,
	      "cancel": function($event) {
	        _vm.isCreateAbsenceReason = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "users-hours text-dark"
	  }, [_c('div', {
	    staticClass: "users-hours__header"
	  }, [_c('h2', [_vm._v("Arbeidsplan for " + _vm._s(_vm.numberOfWorkDaysInPeriod) + " arbejdsdage")]), _vm._v(" "), _c('div', {
	    staticClass: "user-tasks__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), (_vm.activeSchoolYear) ? _c('DatePickerRangeShortcuts', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "startDate": _vm.activeSchoolYear.employee_time_start,
	      "endDate": _vm.activeSchoolYear.employee_time_end,
	      "selectedStartDate": _vm.startDate,
	      "selectedEndDate": _vm.endDate
	    },
	    on: {
	      "shortcutSelected": _vm.setDatesFromRange
	    }
	  }) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "marg-1-left bttn",
	    class: {
	      'bttn--loading': _vm.isLoadingUpdatedNumbers
	    },
	    on: {
	      "click": _vm.updateUserHours
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.assign_users_hours.update')) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "user-table-container"
	  }, [(_vm.isLoadingUpdatedNumbers) ? _c('div', {
	    staticClass: "user-table-container__loader",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('Loader', {
	    attrs: {
	      "is-small": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "user-table"
	  }, [_c('thead', [_c('tr', [_c('thUser', {
	    attrs: {
	      "rowspan": "3",
	      "sort-prop": "name",
	      "title": _vm.$t('vue2.assign_users_hours.name'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.work_hours')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('tr', [_c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_total_hours_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "sort-prop": "v_with_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "sort-prop": "v_without_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_assigned_in_period",
	      "title": _vm.$t('vue2.assign_users_hours.assigned'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_actual",
	      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  }), _vm._v(" "), _c('thUser', {
	    staticClass: "working-hours",
	    attrs: {
	      "sort-prop": "v_with_and_without_kids_diff",
	      "title": _vm.$t('vue2.assign_users_hours.diff'),
	      "activeSortKey": _vm.sortKey
	    },
	    on: {
	      "sortby": _vm.sortBy
	    }
	  })], 1)]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedUsers), function(user) {
	    return _c('tr', {
	      key: user.id,
	      staticClass: "tr-user"
	    }, [_c('th', {
	      staticClass: "tr-user__name"
	    }, [_c('div', {
	      staticClass: "tr-user__name__inner"
	    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "tr-user__name__bttn icon__bg-circle hint--right",
	      attrs: {
	        "aria-label": "Årsnormsoversigt"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveUserInAssignHours(user)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "icon-chart tw-icon tw-icon--small",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24"
	      }
	    }, [_c('path', {
	      staticClass: "primary",
	      attrs: {
	        "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
	      }
	    }), _vm._v(" "), _c('path', {
	      staticClass: "secondary",
	      attrs: {
	        "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
	      }
	    })])])])]), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number td-presence",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_assigned_total_hours)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence",
	      attrs: {
	        "aria-label": user.v_total_hours_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_total_hours_diff)),
	      attrs: {
	        "aria-label": user.v_total_hours_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number with-kids-color",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_total_with_kids)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_with_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number with-kids-color",
	      attrs: {
	        "aria-label": user.v_with_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number with-kids-color number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_with_kids_diff)),
	      attrs: {
	        "aria-label": user.v_with_kids_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number without-kids-color",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_total_without_kids)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_without_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number without-kids-color",
	      attrs: {
	        "aria-label": user.v_without_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number without-kids-color number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_without_kids_diff)),
	      attrs: {
	        "aria-label": user.v_without_kids_diff
	      }
	    }), _vm._v(" "), _c('td', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return !_vm.isDatesPristine; }
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	      }],
	      staticClass: "number td-presence",
	      class: {
	        'is-number--calculated': !_vm.isDatesPristine
	      },
	      attrs: {
	        "content": _vm.createTooltip(user.v_assigned_total_hours)
	      }
	    }, [(!_vm.isDatesPristine) ? _c('span', {
	      staticClass: "icon-clock"
	    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence",
	      attrs: {
	        "aria-label": user.v_with_and_without_kids_actual
	      }
	    }), _vm._v(" "), _c('td', {
	      staticClass: "number td-presence number__scale-indicator",
	      style: (_vm.scaleIndicator(user.v_with_and_without_kids_diff)),
	      attrs: {
	        "aria-label": user.v_with_and_without_kids_diff
	      }
	    })])
	  }), 0)])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('div', {
	    staticClass: "user-task__container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "user-task__container__header"
	  }, [_c('h2'), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.closeTheUserToShowTasks
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserTasks', {
	    attrs: {
	      "initialStartDate": _vm.startDate,
	      "initialEndDate": _vm.endDate,
	      "user_id": _vm.theUserToShowTasks.id,
	      "user_calendar_id": _vm.theUserToShowTasks.user_calendar_id,
	      "user_name": _vm.theUserToShowTasks.name,
	      "isShowPrintButton": false,
	      "isCanSeeOtherUsers": false
	    }
	  }) : _vm._e()], 1)]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "with-kids-color",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Med børn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "without-kids-color",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Uden børn")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('th', {
	    staticClass: "working-hours",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('div', [_vm._v("Med + uden børn")])])
	}]}

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tasks text-dark"
	  }, [_c('div', {
	    staticClass: "tasks-header"
	  }, [_c('DFilters', {
	    staticStyle: {
	      "margin": "0.5rem 0 -2px 0"
	    },
	    attrs: {
	      "filters": _vm.filters,
	      "initialFilter": _vm.theFilter
	    },
	    on: {
	      "set": _vm.setFilter
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "tasks-header__right"
	  }, [(_vm.isSubmittingTask) ? _c('div', {
	    staticClass: "do-spinner"
	  }) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    staticStyle: {
	      "width": "150px",
	      "height": "38px"
	    },
	    on: {
	      "click": _vm.setCreateNewTask
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['create_tasks']) + "\n    ")])])], 1), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "250px"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeSearchGroup),
	      expression: "closeSearchGroup"
	    }],
	    staticClass: "d-search__hidden__group",
	    class: {
	      'isShow': _vm.isSearchHiddenFadeIn
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setIsSearchHidden(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-search5"
	  }), _vm._v(" "), (_vm.isSearchHidden) ? _c('div', {
	    staticClass: "d-search__hidden__group--hide"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['search_task']) + "\n          ")]) : _c('div', {
	    staticClass: "d-search__hidden__group--show"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query),
	      expression: "query"
	    }],
	    ref: "query_input",
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.i18n[_vm.locale]['search_task']
	    },
	    domProps: {
	      "value": (_vm.query)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.query = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('th', {
	    staticClass: "d-table__number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['teaching']))]), _vm._v(" "), _c('th', {
	    staticClass: "d-table__number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['other_short']))]), _vm._v(" "), _c('th', {
	    staticClass: "d-table__number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['prep']))]), _vm._v(" "), (_vm.isSchoolFeatureLocalePool) ? _c('th', {
	    staticClass: "d-table__number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['pool']))]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "500px"
	    }
	  }, [_c('span', {
	    staticClass: "icon-user3"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['teacher']))]), _vm._v(" "), _c('th', {
	    staticClass: "d-table__number",
	    staticStyle: {
	      "width": "100px"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sum']) + " : " + _vm._s(_vm.calcAllHours))])])]), _vm._v(" "), _c('tbody', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom'\n                }"
	    }],
	    staticClass: "tr-create-shortcut",
	    class: {
	      'tr-create-shortcut--active': _vm.isShowCreateFast
	    },
	    attrs: {
	      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>' + _vm.keyboardShortcut + '</span></p>'
	    },
	    on: {
	      "click": _vm.setIsShowCreateFast
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "scaleIn"
	    }
	  }, [(_vm.isShowCreateFast) ? _c('tr', {
	    staticClass: "create-task-fast"
	  }, [_c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fastFormName),
	      expression: "fastFormName"
	    }],
	    ref: "shortcutInput",
	    class: {
	      'input--error': _vm.formErrors['fastFormName']
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['task_name']
	    },
	    domProps: {
	      "value": (_vm.fastFormName)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('fastFormName')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.fastFormName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fastFormHoursTeaching),
	      expression: "fastFormHoursTeaching"
	    }],
	    class: {
	      'input--error': _vm.formErrors['fastFormHours']
	    },
	    attrs: {
	      "type": "number",
	      "disabled": (_vm.fastFormHoursPrep !== '' || _vm.fastFormHoursTask !== '') || (_vm.theFilter === 'additional_tasks' || _vm.theFilter === 'preparation')
	    },
	    domProps: {
	      "value": (_vm.fastFormHoursTeaching)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('fastFormHours')
	      },
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.fastFormHoursTeaching = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fastFormHoursTask),
	      expression: "fastFormHoursTask"
	    }],
	    class: {
	      'input--error': _vm.formErrors['fastFormHours']
	    },
	    attrs: {
	      "type": "number",
	      "disabled": (_vm.fastFormHoursPrep !== '' || _vm.fastFormHoursTeaching !== '') || (_vm.theFilter === 'person_resource' || _vm.theFilter === 'preparation' || _vm.theFilter === 'subject')
	    },
	    domProps: {
	      "value": (_vm.fastFormHoursTask)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('fastFormHours')
	      },
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.fastFormHoursTask = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fastFormHoursPrep),
	      expression: "fastFormHoursPrep"
	    }],
	    class: {
	      'input--error': _vm.formErrors['fastFormHours']
	    },
	    attrs: {
	      "type": "number",
	      "disabled": (_vm.fastFormHoursTask !== '' || _vm.fastFormHoursTeaching !== '') || (_vm.theFilter === 'additional_tasks' || _vm.theFilter === 'person_resource')
	    },
	    domProps: {
	      "value": (_vm.fastFormHoursPrep)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('fastFormHours')
	      },
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.fastFormHoursPrep = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.isSchoolFeatureLocalePool) ? _c('td', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fastFormHoursPool),
	      expression: "fastFormHoursPool"
	    }],
	    class: {
	      'input--error': _vm.formErrors['fastFormHours']
	    },
	    attrs: {
	      "type": "number",
	      "disabled": (_vm.fastFormHoursTask !== '' || _vm.fastFormHoursTeaching !== '') || (_vm.theFilter === 'additional_tasks' || _vm.theFilter === 'person_resource')
	    },
	    domProps: {
	      "value": (_vm.fastFormHoursPool)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('fastFormHours')
	      },
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.fastFormHoursPool = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', [_c('DSelectCalendarIds', {
	    attrs: {
	      "show": _vm.activeDSelectShow,
	      "itemType": "USER",
	      "showTags": true,
	      "preSelectedItems": _vm.fastFormUsers
	    },
	    on: {
	      "update": function($event) {
	        return _vm.setSelectedUsers($event, null)
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('td', [_c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--primary--disabled': !_vm.isFastFormValid
	    },
	    staticStyle: {
	      "width": "100px"
	    },
	    on: {
	      "click": _vm.submitFastForm
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['create']) + "\n          ")])])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.searchedTasks), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('div', {
	      staticClass: "task__name"
	    }, [_c('div', {
	      class: [{
	        'td-subject--hidden': !task.can_schedule
	      }, {
	        'td-subject': task.can_schedule
	      }],
	      style: ({
	        'background-color': task.color
	      }),
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(task)
	        }
	      }
	    }, [_vm._v(_vm._s(task.name) + "\n          ")])])]), _vm._v(" "), _c('td', {
	      staticClass: "d-table__number"
	    }, [_vm._v(_vm._s(task.timeTeaching))]), _vm._v(" "), _c('td', {
	      staticClass: "d-table__number"
	    }, [_vm._v(_vm._s(task.timeTasks))]), _vm._v(" "), _c('td', {
	      staticClass: "d-table__number"
	    }, [_vm._v(_vm._s(task.timePrep))]), _vm._v(" "), (_vm.isSchoolFeatureLocalePool) ? _c('td', {
	      staticClass: "d-table__number"
	    }, [_vm._v(_vm._s(task.timePool))]) : _vm._e(), _vm._v(" "), _c('td', {
	      class: {
	        'd-select-lookalike': !_vm.isActiveDSelect(task.id) && task.user_calendar_ids.length < 1
	      },
	      attrs: {
	        "aria-placeholder-label": _vm.i18n[_vm.locale]['search_and_select']
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveDSelect(task)
	        }
	      }
	    }, [(_vm.isActiveDSelect(task.id)) ? _c('DSelectCalendarIds', {
	      directives: [{
	        name: "on-clickaway",
	        rawName: "v-on-clickaway",
	        value: (_vm.closeDSelect),
	        expression: "closeDSelect"
	      }, {
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          onShow: function () { return _vm.usersWithEvents(task).length > 0; },
	          arrow: true,
	          placement: 'bottom'
	        }),
	        expression: "{\n                              onShow: () => usersWithEvents(task).length > 0,\n                              arrow: true,\n                              placement : 'bottom'\n                            }"
	      }],
	      attrs: {
	        "show": _vm.activeDSelectShow,
	        "itemType": "USER",
	        "preSelectedItems": task.user_calendar_ids,
	        "itemsThatCantBeDeleted": _vm.usersWithEvents(task),
	        "showTags": true,
	        "content": _vm.getUserNames(_vm.usersWithEvents(task)) + ' ' + _vm.i18n[_vm.locale]['has_scheduled_and_cant_be_deleted']
	      },
	      on: {
	        "update": function($event) {
	          return _vm.setSelectedUsers($event, task)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (!_vm.isActiveDSelect(task.id) && task.user_calendar_ids.length > 0) ? _c('div', {
	      staticClass: "task__users"
	    }, _vm._l((_vm.getUsers(task.user_calendar_ids)), function(user) {
	      return _c('p', [_vm._v(_vm._s(user))])
	    }), 0) : _vm._e()], 1), _vm._v(" "), _c('td', {
	      staticClass: "d-table__number"
	    }, [_vm._v(_vm._s(_vm.getCalcTotal(task)))])])
	  })], 2)]), _vm._v(" "), (_vm.tasks.length < 1) ? _c('div', {
	    staticClass: "explainer-div"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks_created']))]) : _vm._e(), _vm._v(" "), (_vm.tasks.length > 0 && _vm.filteredTasks.length < 1) ? _c('div', {
	    staticClass: "explainer-div"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks_matching']) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isTaskModal) ? _c('CreateTask', {
	    attrs: {
	      "editTask": _vm.editTask,
	      "activeFilter": _vm.theFilter
	    },
	    on: {
	      "close": _vm.closeUpdateTask,
	      "create": _vm.createTask,
	      "updateTask": _vm.updateTask
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "toasts"
	  }, [(_vm.toasts.length > 0) ? [_c('transition-group', _vm._l((_vm.toasts), function(toast, index) {
	    return _c('div', {
	      key: toast.id
	    }, [_c('toast', {
	      attrs: {
	        "index": index,
	        "toast": toast,
	        "arrayLength": _vm.toasts.length
	      },
	      on: {
	        "remove": _vm.remove,
	        "removeNow": _vm.removeNow
	      }
	    })], 1)
	  }), 0)] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DSelect', {
	    attrs: {
	      "items": _vm.dSelectItems,
	      "multiple": true,
	      "placeholder": _vm.$t('vue2.substitution.choose_absence_user')
	    },
	    on: {
	      "update": _vm.sendUpdate
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('d-modal', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header",
	    style: ({
	      'background': _vm.firstInSubjectsWithSameName.color
	    })
	  }, [_c('h2', {
	    staticStyle: {
	      "color": "#ffffff"
	    }
	  }, [_vm._v("\""), _c('b', [_vm._v(_vm._s(_vm.firstInSubjectsWithSameName.name))]), _vm._v("\" " + _vm._s(_vm.i18n[_vm.locale]['exists']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    staticStyle: {
	      "color": "#ffffff"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['the_subject']) + ": \""), _c('b', [_vm._v(_vm._s(_vm.firstInSubjectsWithSameName.name))]), _vm._v("\" "), _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['already_exists']))])]), _vm._v(" "), (_vm.subjectsCanBeDeleted.length > 0) ? _c('h4', {
	    staticClass: "marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['do_you_want_to_delete']) + "?")]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "klassesWithSubjects"
	  }, _vm._l((_vm.subjectsCanBeDeletedWithVProps), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('td', [_vm._v(_vm._s(subject.v_calendar_name) + " ")]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "d-subject",
	      style: ({
	        'background': subject.color
	      })
	    }, [_vm._v(_vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")")])])])
	  }), 0), _vm._v(" "), (_vm.subjectsCannotDelete.length > 0) ? _c('p', {
	    staticClass: "bold italic marg-1-top text-danger"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_cannot_be_deleted']))]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "klassesWithSubjects"
	  }, _vm._l((_vm.subjectsCannotDeleteWithVProps), function(subject) {
	    return _c('tr', {
	      key: subject.id
	    }, [_c('td', [_vm._v(_vm._s(_vm.subjectsCannotDelete.v_calendar_name) + " ")]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "d-subject d-subject--cannot-delete",
	      style: ({
	        'background': subject.color
	      })
	    }, [_vm._v("\n              " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n            ")])])])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn marg-1-right",
	    on: {
	      "click": _vm.keepExistingSubjects
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_new_anyway']))]), _vm._v(" "), (_vm.subjectsCanBeDeleted.length > 0) ? _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.deleteExistingSubjects
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['delete']) + "\n      ")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isSubmitButtonLoading": _vm.isSubmitting,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      },
	      "confirm": _vm.onConfirmAwayStatus
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "custom_warning"
	    },
	    slot: "custom_warning"
	  }, [(!_vm.isAway) ? [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_away_title))]), _vm._v(" "), _c('p', {
	    staticClass: "pad-1 italic pad-0-top"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_away_text))])] : [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_unaway_title))]), _vm._v(" "), _c('p', {
	    staticClass: "pad-1 italic"
	  }, [_vm._v(_vm._s(_vm.i18n.confirm_unaway_text))])]], 2), _vm._v(" "), _c('p', {
	    attrs: {
	      "slot": "confirmText"
	    },
	    slot: "confirmText"
	  }, [_vm._v(_vm._s(!_vm.isAway ? _vm.i18n.mark_as_away : _vm.i18n.unmark_as_away))])])
	},staticRenderFns: []}

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "task-create text-dark"
	  }, [_c('DModal', {
	    attrs: {
	      "show-close": false
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "task-create__modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "task-create__header",
	    class: {
	      'task-create__header--create-subject': _vm.canSchedule
	    },
	    style: ({
	      'backgroundColor': _vm.color
	    })
	  }, [_c('h3', [(_vm.name.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_task']))]) : _c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "task-create__close icon__bg-circle",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('form', {
	    staticClass: "task-create__body",
	    attrs: {
	      "id": "task-create"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "task-create__form"
	  }, [_c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticClass: "input-group input-group__title"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['task_title']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    ref: "name",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['name']
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['ex_task']
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('name')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isArbeidstidsplanActivated) ? _c('div', {
	    staticClass: "input-group input-group__preparation"
	  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preparation),
	      expression: "preparation"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.preparation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.preparation = $event.target.value
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_user']))]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "USER",
	      "preSelectedItems": _vm.calendars,
	      "showTags": true,
	      "itemsThatCantBeDeleted": _vm.usersWithEvents
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1), _vm._v(" "), (!_vm.editTask) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_type']))]), _vm._v(" "), _c('SubjectFormSubjectType', {
	    attrs: {
	      "calendar-type": "user",
	      "subject-type": _vm.subjectType,
	      "isInTasks": true
	    },
	    on: {
	      "change": _vm.setSubjectType
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_as']) + " "), _c('span', {
	    staticClass: "pill pill--grey hint--top-right",
	    attrs: {
	      "aria-label": "Vælg briktype for at ændre"
	    }
	  }, [_vm._v(_vm._s(_vm.hoursType))])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group__flex"
	  }, [_c('div', {
	    staticStyle: {
	      "width": "50%"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.hours),
	      expression: "hours",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['hours']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('hours')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()])])]), _vm._v(" "), (!_vm.editTask) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "create-as-subject"
	  }, [_c('div', {
	    staticClass: "create-as-subject__inner",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.canSchedule = !_vm.canSchedule
	      }
	    }
	  }, [_c('AppToggle', {
	    attrs: {
	      "propOn": _vm.canSchedule,
	      "allowChanges": false
	    },
	    on: {
	      "changed": _vm.setIsCreateAsSubject
	    }
	  }), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['can_be_scheduled']))])], 1)])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.canSchedule) ? _c('div', [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['duration']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.duration),
	      expression: "duration",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "inputLessonCount",
	    staticClass: "d-input",
	    class: {
	      'input--error': _vm.formErrors['duration']
	    },
	    staticStyle: {
	      "width": "50%"
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.duration)
	    },
	    on: {
	      "focus": function($event) {
	        return _vm.selectAllOnFocus($event)
	      },
	      "blur": [function($event) {
	        return _vm.removeErrors('duration')
	      }, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.duration = _vm._n($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['duration']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['duration'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [(_vm.isCreateInOtherCalendarAnOption && !_vm.editTask) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_in_calendar']))]), _vm._v(" "), _c('SelectOtherCal', {
	    attrs: {
	      "selectedCalendarId": _vm.selectedOtherCalendarId
	    },
	    on: {
	      "changed": _vm.setSelectedOtherCalendarId
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.editTask && _vm.getOtherCalendarName(_vm.selectedOtherCalendarId)) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['created_in_calendar']))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.getOtherCalendarName(_vm.selectedOtherCalendarId)))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('color-picker', {
	    attrs: {
	      "initialColor": _vm.color
	    },
	    on: {
	      "changedColor": _vm.setColor
	    }
	  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group input-group__submit"
	  }, [_c('div', {
	    staticClass: "input-group__submit__left"
	  }, [(_vm.editTask) ? [(_vm.usersWithEvents.length < 1) ? _c('button', {
	    staticClass: "hint--right bttn--warning",
	    attrs: {
	      "aria-label": "Slet opgaven"
	    },
	    on: {
	      "click": _vm.deleteTask
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })]) : _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['cannot_be_deleted']
	    }
	  }, [_c('button', {
	    staticClass: "bttn bttn--disabled"
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "input-group__submit__right"
	  }, [_c('button', {
	    staticClass: "marg-1-right do-bttn",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (!_vm.editTask) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingTask
	    },
	    on: {
	      "click": _vm.createTask
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_task']) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editTask) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmittingTask
	    },
	    on: {
	      "click": _vm.updateTask
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_task']) + "\n              ")]) : _vm._e()])])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "bg-overlay animatedFast fadeIn"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "to-user-tasks text-dark"
	  }, [_c('table', {
	    staticClass: "d-table marg-1-bottom d-table__overview"
	  }, _vm._l((_vm.tasksByMasterType), function(tasksType, prop) {
	    return _c('tbody', [_c('tr', {
	      staticClass: "tr-thead"
	    }, [_c('td', [_c('h4', [_vm._v(_vm._s(tasksType.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.belongs_to')))]), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))])]), _vm._v(" "), _vm._l((tasksType.tasks), function(task) {
	      return _c('tr', {
	        key: task.id
	      }, [_c('td', [_vm._v(_vm._s(task.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(task.calendar))]), _vm._v(" "), _c('td', {
	        staticClass: "is-number"
	      }, [(!_vm.getIsHideHours(task)) ? [_vm._v(_vm._s(task.hours))] : _vm._e()], 2)])
	    }), _vm._v(" "), (!_vm.getIsHideTotalHours(tasksType)) ? _c('tr', {
	      staticClass: "to-user_tasks__footer"
	    }, [_c('td', [_vm._v("I alt")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v(_vm._s(tasksType.totalHours))])]) : _vm._e()], 2)
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.userHasPermissionToEdit) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "user-presence inline-block",
	    class: [{
	      'user-presence__modal-left': _vm.isModalLeft
	    }, {
	      'user-presence__multiple-users': !_vm.calid
	    }]
	  }, [_c('button', {
	    staticClass: "up__button no-print",
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.presence.work_hours')) + "\n    "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.modal) ? _c('div', {
	    staticClass: "up-modal text-dark"
	  }, [_c('div', {
	    staticClass: "up-modal__header"
	  }, [_c('h2', {
	    staticClass: "text-blue"
	  }, [(!_vm.showWeekSelector) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.set_work_hours')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.choose_weeks_for_work_hours')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "up-modal__content",
	    class: {
	      'showweeks': _vm.showWeekSelector
	    }
	  }, [(_vm.isLoading) ? _c('div', {
	    staticStyle: {
	      "margin-bottom": "100px"
	    }
	  }, [_c('Spinner', {
	    attrs: {
	      "color": "blue"
	    }
	  })], 1) : _c('div', {
	    staticClass: "up-modal__content-slider",
	    class: {
	      'showweeks': _vm.showWeekSelector
	    }
	  }, [_c('div', {
	    class: {
	      'up-modal__content-slider--weekend-with-hours': _vm.hasWeekendEvents && !_vm.showWeekSelector
	    }
	  }, [_c('div', {
	    staticClass: "flex-table user-presence__table"
	  }, [_c('div', {
	    staticClass: "flex-tr flex-tr__header"
	  }, [_c('div', {
	    staticClass: "flex-td"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex-td"
	  }, [_c('span', {
	    staticClass: "text-normal"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.work_hours_in_the_week')) + ":")]), _vm._v("\n                  " + _vm._s(_vm.durationAsHoursAndMin(_vm.totalDurationWeek)) + "\n                ")])]), _vm._v(" "), _vm._l((_vm.weekDays), function(weekDay) {
	    return _c('div', {
	      staticClass: "flex-tr tr-weekdays-hours"
	    }, [_c('div', {
	      staticClass: "flex-td flex-1 capitalize user-presence__table__first"
	    }, [_c('div', {
	      staticClass: "flex-td"
	    }, [_vm._v("\n                    " + _vm._s(_vm._f("dayOfWeek")(weekDay)) + "\n                  ")]), _vm._v(" "), _c('div', {
	      staticClass: "flex-td"
	    }, [_c('button', {
	      class: {
	        'inactive': _vm.lastEventOfDayIsCloseToMidnight(weekDay)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.addEvent(weekDay)
	        }
	      }
	    }, [_c('span', [_vm._v("+")])])])]), _vm._v(" "), _c('div', {
	      staticClass: "flex-td flex-3 time-changer"
	    }, [_vm._l((_vm.events), function(event) {
	      return [(_vm.compareDates(event.start, weekDay)) ? [_c('EditEvent', {
	        key: event.id,
	        attrs: {
	          "event": event
	        },
	        on: {
	          "updateStart": _vm.updateStart,
	          "updateEnd": _vm.updateEnd,
	          "delete": _vm.deleteEvent,
	          "duration": _vm.setEventDurations
	        }
	      })] : _vm._e()]
	    })], 2)])
	  })], 2)]), _vm._v(" "), _c('div', [_c('WeekPicker', {
	    attrs: {
	      "date": _vm.activeCalendarDate,
	      "calid": _vm.calid
	    },
	    on: {
	      "weeks": _vm.setPastedWeeks,
	      "isWithinCalRange": _vm.setCurrentDateIsNotWithinCalendarRange
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "up-modal__footer"
	  }, [_c('button', {
	    staticClass: "bg-white",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.presence.cancel')) + "\n        ")]), _vm._v(" "), _c('div', [(_vm.intersections.length < 1) ? _c('div', [(!_vm.currentDateIsNotWithinCalendarRange) ? [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.showWeekSelector = !_vm.showWeekSelector
	      }
	    }
	  }, [(!_vm.showWeekSelector) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.copy_to_multiple_weeks')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.back')))])])] : _vm._e(), _vm._v(" "), (_vm.calid || _vm.pasteInWeeks.length > 0) ? _c('button', {
	    staticClass: "bg-white",
	    class: {
	      'bttn-passive': true
	    },
	    on: {
	      "click": _vm.savePresence
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.presence.save')) + "\n            ")]) : _vm._e()], 2) : _c('div', [_c('p', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.times_may_not_overlap')))])])])])]) : _vm._e()])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.locale),
	      expression: "locale"
	    }],
	    attrs: {
	      "id": "locale-selector"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.locale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.saveInLocalStorage]
	    }
	  }, _vm._l((_vm.langSorted), function(lang) {
	    return _c('option', {
	      domProps: {
	        "value": lang.code
	      }
	    }, [_vm._v("\n      " + _vm._s(lang.name)), (lang.nativeName && lang.nativeName.length > 0) ? _c('span', [_vm._v(" - ")]) : _vm._e(), _vm._v(_vm._s(lang.nativeName) + "\n    ")])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vimeo-container"
	  }, [_c('iframe', {
	    attrs: {
	      "src": _vm.videoSrc,
	      "frameborder": "0",
	      "allow": "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media",
	      "allowfullscreen": "",
	      "title": "Guide til opgaveoversigt designeren"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "stil-guides"
	  }, [(_vm.isButton) ? _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isShowGuide = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-play"
	  }), _vm._v(" Se guide til indberetningen\n  ")]) : _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": function($event) {
	        _vm.isShowGuide = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.textForLink))]), _vm._v(" "), (_vm.isShowGuide) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true
	    },
	    on: {
	      "close": function($event) {
	        _vm.isShowGuide = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-embed",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-embed-container"
	  }, [_c('iframe', {
	    attrs: {
	      "src": _vm.videoLink,
	      "title": "YouTube video player",
	      "frameborder": "0",
	      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
	      "allowfullscreen": ""
	    }
	  })])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.taskCategory.title))]), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        animateFill: false,
	        animation: 'shift-away',
	        onShow: function () { return _vm.isDateIntervalChanged; }
	      }),
	      expression: "{\n        animateFill: false,\n        animation : 'shift-away',\n      onShow: () => isDateIntervalChanged\n    }"
	    }],
	    staticClass: "is-number",
	    class: {
	      'is-number--calculated': _vm.isDateIntervalChanged
	    },
	    attrs: {
	      "content": _vm.schoolTooltipContent
	    }
	  }, [(_vm.isDateIntervalChanged) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.sumOfHours) + "\n  ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.sumOfActual))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("\n    " + _vm._s(_vm.sumOfDiff) + "\n  ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters-container"
	  }, [_c('ul', {
	    ref: "dfilters",
	    staticClass: "filters"
	  }, [_c('div', {
	    staticClass: "filters__filter__activator",
	    style: ({
	      'left': _vm.left,
	      'width': _vm.width
	    })
	  }), _vm._v(" "), _vm._l((_vm.filters), function(filter, idx) {
	    return _c('li', {
	      staticClass: "filters__filter",
	      class: {
	        'filters__filter--active': _vm.isFilter(filter.value)
	      },
	      attrs: {
	        "id": 'filter_' + filter.value
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setFilter(filter)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(filter.label) + "\n      "), _c('span', {
	      staticClass: "filter__length"
	    }, [_vm._v("(" + _vm._s(filter.length) + ")")])])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-modal__employment text-dark"
	  }, [_c('button', {
	    on: {
	      "click": _vm.openIsModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  })]), _vm._v(" "), (_vm.isModal) ? _c('DModal', {
	    staticClass: "d-modal__employment-modal",
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Ansættelser for " + _vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": _vm.closeIsModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [(!_vm.isAllDoneLoading) ? _c('div', {
	    staticClass: "is-loading-container"
	  }, [_c('Loader', {
	    attrs: {
	      "isLoaderModal": true
	    }
	  })], 1) : [(_vm.userEmployments.length === 0) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen ansættelser oprettet")]) : _vm._e(), _vm._v(" "), (_vm.userEmployments.length > 0) ? _c('div', {
	    staticClass: "d-modal__employment__employments"
	  }, [_c('ul', [_c('li', {
	    staticClass: "d-modal__employment__employments__header"
	  }, [_c('div', [_vm._v("Ansættelse")]), _vm._v(" "), _c('div', [_vm._v("CPR NUMMER + EKSTRACIFFER")])]), _vm._v(" "), _vm._l((_vm.userEmploymentsWithTitle), function(userEmployment) {
	    return _c('li', {
	      key: userEmployment.id,
	      staticClass: "d-modal__employment__employments__employment"
	    }, [_c('div', {
	      staticClass: "d-modal__employment__employments__employment__container"
	    }, [_c('div', [_vm._v(_vm._s(userEmployment.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(userEmployment.employment_number))])]), _vm._v(" "), _c('span', {
	      staticClass: "icon__bg-circle icon__bg-circle--danger",
	      on: {
	        "click": function($event) {
	          return _vm.setDeleteEmployment(userEmployment)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])
	  }), _vm._v(" "), (_vm.userDeletedEmployments.length > 0) ? _c('li', {
	    staticClass: "text-blue text-link marg-1-bottom",
	    on: {
	      "click": function($event) {
	        _vm.isShowArchived = !_vm.isShowArchived
	      }
	    }
	  }, [(!_vm.isShowArchived) ? _c('span', [_vm._v("Se")]) : _vm._e(), (_vm.isShowArchived) ? _c('span', [_vm._v("Skjul")]) : _vm._e(), _vm._v(" tidligere ansættelser\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.deletedUserEmploymentsWithTitle), function(userEmployment) {
	    return (_vm.isShowArchived) ? _c('li', {
	      key: userEmployment.id,
	      staticClass: "d-modal__employment__employments__employment d-modal__employment__employments__employment--deleted"
	    }, [_c('div', {
	      staticClass: "d-modal__employment__employments__employment__container"
	    }, [_c('div', [_vm._v(_vm._s(userEmployment.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(userEmployment.employment_number))])])]) : _vm._e()
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [(!_vm.isCreateForm) ? _c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.setIsCreateForm(true)
	      }
	    }
	  }, [_vm._v("Tilføj ansættelse")]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "scaleIn",
	      "mode": "out-in"
	    }
	  }, [(_vm.isCreateForm) ? _c('div', {
	    staticClass: "d-modal__employment__form"
	  }, [_c('h4', [_vm._v("Tilføj ansættelse")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group-flex"
	  }, [_c('div', {
	    staticClass: "input-group flex-1 input-group__select"
	  }, [_c('label', [_vm._v("Ansættelsestype")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.createFormEmploymentTypeId),
	      expression: "createFormEmploymentTypeId"
	    }],
	    class: {
	      'input--error': _vm.formErrors['type']
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.createFormEmploymentTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.removeErrors('type')
	      }]
	    }
	  }, _vm._l((_vm.employmentTypesActive), function(employmentType) {
	    return _c('option', {
	      domProps: {
	        "value": employmentType.id
	      }
	    }, [_vm._v("\n                      " + _vm._s(employmentType.title) + "\n                    ")])
	  }), 0), _vm._v(" "), (_vm.formErrors['type']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['type']))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group flex-1"
	  }, [_c('label', [_vm._v("CPR nummer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.createFormCPR),
	      expression: "createFormCPR",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    class: {
	      'input--error': _vm.formErrors['cpr']
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.createFormCPR)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('cpr')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.createFormCPR = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['cpr']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['cpr']))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group flex-1 extra-ciffer-input"
	  }, [_c('label', [_vm._v("Ekstraciffer")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.createFormExtraCiffer),
	      expression: "createFormExtraCiffer",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    class: {
	      'input--error': _vm.formErrors['ciffer']
	    },
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.createFormExtraCiffer)
	    },
	    on: {
	      "keyup": function($event) {
	        return _vm.removeErrors('ciffer')
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.createFormExtraCiffer = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (_vm.formErrors['ciffer']) ? _c('p', {
	    staticClass: "input-error"
	  }, [_vm._v(_vm._s(_vm.formErrors['ciffer']))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": _vm.closeIsCreateForm
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.createEmployment
	    }
	  }, [_vm._v("Tilføj ansættelse")])])]) : _vm._e()])]], 2)])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteEmployment) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal__delete-employment",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Vil du slette ansættelsen?")]), _vm._v(" "), _c('div', {
	    staticClass: "font-large icon__bg-circle d-modal__header__close",
	    on: {
	      "click": function($event) {
	        _vm.theDeleteEmployment = null
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__body"
	  }, [_c('p', [_vm._v("Vil du slette "), _c('b', [_c('i', [_vm._v(_vm._s(_vm.theDeleteEmployment.title))])]), _vm._v(" for " + _vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "marg-10-right",
	    on: {
	      "click": function($event) {
	        _vm.theDeleteEmployment = null
	      }
	    }
	  }, [_vm._v("Nej")]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.deleteEmployment
	    }
	  }, [_vm._v("Ja, slet ansættelsen")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lessons__filters"
	  }, [_c('div', {
	    staticClass: "lessons__filters__filter",
	    class: {
	      'lessons__filters__filter--active': _vm.activeFilter === 'draft'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFilter('draft')
	      }
	    }
	  }, [_vm._v("Efterbehandling (" + _vm._s(_vm.userDaysDrafts.length) + ")\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "lessons__filters__filter",
	    class: {
	      'lessons__filters__filter--active': _vm.activeFilter === 'approved'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFilter('approved')
	      }
	    }
	  }, [_vm._v("Godkendt (" + _vm._s(_vm.userDaysApproved.length) + ")\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "lessons__filters__filter",
	    class: {
	      'lessons__filters__filter--active': _vm.activeFilter === 'sent'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFilter('sent')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isSalaryIntegrationActive ? 'Sendt til lønsystem' : 'Er indberettet') + " (" + _vm._s(_vm.userDaysSent.length) + ")\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "d-table d-table__tasks marg-10-bottom",
	    class: {
	      'd-table--open': _vm.isOpen
	    }
	  }, [_c('thead', {
	    staticClass: "pointer acc-header",
	    on: {
	      "click": _vm.setIsOpen
	    }
	  }, [_c('tr', [_c('th', {
	    staticClass: "d-table__title"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
	    staticClass: "is-number d-table__thead__last"
	  }, [_c('div', {
	    staticClass: "number_and_acc"
	  }, [_vm._v("\n        " + _vm._s(_vm.sumOfHours) + "\n        "), (!_vm.isOpen) ? _c('span', {
	    staticClass: "icon-arrow-down4"
	  }) : _vm._e(), _vm._v(" "), (_vm.isOpen) ? _c('span', {
	    staticClass: "icon-arrow-up4"
	  }) : _vm._e()])])])]), _vm._v(" "), (_vm.isOpen) ? [_c('tbody', [(_vm.tasks.length < 1) ? _c('tr', [_c('td', {
	    staticStyle: {
	      "width": "90%"
	    }
	  }, [_c('div', {
	    staticClass: "italic",
	    staticStyle: {
	      "padding": "4px"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['no_subjects_assigned']))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedTasks), function(task) {
	    return _c('tr', {
	      key: task.id
	    }, [_c('td', [_c('div', {
	      staticClass: "task-with-edit",
	      on: {
	        "click": function($event) {
	          return _vm.setEditTask(task)
	        }
	      }
	    }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	      staticClass: "subjects_subject subjects_subject__simple",
	      style: ([{
	        'border-left-color': task.color
	      }, {
	        'background-color': task.color
	      }])
	    }, [_vm._v("\n            " + _vm._s(task.name) + "\n          ")]) : _c('div', {
	      staticClass: "subjects_subject subjects_subject--not-subject"
	    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	      staticClass: "td-calendars"
	    }, [(_vm.getShowCalendarIfNotOwn(task)) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.getShowCalendarIfNotOwn(task)) + "\n      ")]) : _vm._e()]), _vm._v(" "), (!task.hasOwnProperty('can_schedule')) ? _c('td', {
	      staticClass: "is-number subject-hours-for-person",
	      class: {
	        'subject-hours-for-person--is-modified': _vm.getSubjectHours(task.id) !== task.hours
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActiveSubject(task.id)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.getSubjectHours(task.id)) + "\n      ")]) : _c('td', {
	      staticClass: "is-number"
	    }, [_vm._v("\n        " + _vm._s(task.hours) + "\n      ")])])
	  })], 2), _vm._v(" "), _c('tfoot', [(_vm.isOpen && _vm.tasksWithoutSubject.length > 0) ? [_c('tr', {
	    staticClass: "mini-table"
	  }, [_c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("Med brik")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "total-hours is-number"
	  }, [_vm._v("\n          " + _vm._s(_vm.sumOfHoursWithSubject) + "\n        ")])]), _vm._v(" "), _c('tr', {
	    staticClass: "mini-table"
	  }, [_c('td', {
	    staticClass: "is-number"
	  }, [_vm._v("Uden brik")]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "total-hours is-number"
	  }, [_vm._v("\n          " + _vm._s(_vm.sumOfHoursWithoutSubject) + "\n        ")])])] : _vm._e(), _vm._v(" "), _c('tr', {
	    staticClass: "tfoot-headline"
	  }, [_c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.i18n[_vm.locale]['assigned'] : ''))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.i18n[_vm.locale]['difference'] : ''))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['time']))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.assignedHours : ''))]), _vm._v(" "), _c('td', {
	    staticClass: "is-number"
	  }, [_vm._v(_vm._s(!_vm.isPoolsDeactivated ? _vm.getDiff : ''))]), _vm._v(" "), _c('td', {
	    staticClass: "total-hours is-number"
	  }, [_vm._v("\n        " + _vm._s(_vm.sumOfHours) + "\n      ")])])], 2)] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content_container",
	    attrs: {
	      "id": "djs-content-container"
	    }
	  }, [_c('docendo-connnection-indicator'), _vm._v(" "), _c('router-view', {
	    staticClass: "d-sidenav-active",
	    attrs: {
	      "name": "SideNav"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-width d-page-width",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view', {
	    attrs: {
	      "name": "Header"
	    }
	  }), _vm._v(" "), _c('router-view', {
	    attrs: {
	      "name": "Navigation"
	    }
	  }), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('Toast')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-filters"
	  }, [_c('div', {
	    staticClass: "do-filters__selected"
	  }, [_c('DDropdown', {
	    attrs: {
	      "isShowDots": false,
	      "propOffset": [0, 8],
	      "isCloseOnDropdownClick": false
	    },
	    on: {
	      "onClose": _vm.onCloseDropdown
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn__filter",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_c('span', {
	    staticClass: "icon-filter"
	  }), _vm._v("\n        " + _vm._s(_vm.title) + "\n        "), _c('div', {
	    staticClass: "do-filters__divider"
	  }), _vm._v(" "), (_vm.selectedTags.length === 0) ? _c('span', {
	    staticClass: "do-filters__selected-filters"
	  }, [_vm._v("\n          " + _vm._s(_vm.i18n['select_filters']) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTags.length > _vm.numberOfSelectedTagsToShow) ? _c('span', {
	    staticClass: "do-badge"
	  }, [_vm._v("\n          " + _vm._s(_vm.selectedTags.length) + " " + _vm._s(_vm.i18n['selected']) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedTags), function(selectedTag) {
	    return (_vm.selectedTags.length <= _vm.numberOfSelectedTagsToShow) ? _c('span', {
	      key: selectedTag,
	      staticClass: "do-badge"
	    }, [_vm._v("\n          " + _vm._s(selectedTag) + "\n        ")]) : _vm._e()
	  })], 2), _vm._v(" "), _c('ul', {
	    staticClass: "do-filters__filter__dropdown",
	    attrs: {
	      "slot": "list"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    },
	    slot: "list"
	  }, [_c('div', {
	    staticClass: "do-filters__filter__dropdown__header"
	  }, [_c('button', {
	    staticClass: "do-filters__button-transparent",
	    on: {
	      "click": _vm.clearAll
	    }
	  }, [_vm._v(_vm._s(_vm.i18n['clear_all']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query),
	      expression: "query"
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.i18n['search_placeholder']
	    },
	    domProps: {
	      "value": (_vm.query)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.query = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._l((_vm.filteredTags), function(item) {
	    return _c('li', {
	      key: item,
	      staticClass: "do-list-item",
	      on: {
	        "click": function($event) {
	          return _vm.select(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "do-checkbox",
	      class: {
	        'do-checkbox--selected': _vm.getIsItemSelected(item)
	      }
	    }), _vm._v("\n          " + _vm._s(item) + "\n        ")])
	  }), _vm._v(" "), (_vm.filteredTags.length === 0) ? _c('li', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.i18n['no_results']))]) : _vm._e()], 2)])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    on: {
	      "tap": function($event) {
	        return _vm.$emit('eventClicked', _vm.event.obj)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "day-cal__event",
	    class: {
	      'day-cal__event--is-canceled': _vm.event.obj.canceled
	    },
	    style: (_vm.styleObject)
	  }, [(_vm.event.obj.away || _vm.event.obj.canceled) ? _c('div', {
	    staticClass: "d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning",
	    class: {
	      'd-cal__event-meta__fixed--canceled': _vm.event.obj.canceled
	    }
	  }, [(_vm.event.obj.canceled) ? _c('span', {
	    staticClass: "icon-notification22"
	  }) : _c('svg', {
	    staticClass: "tw-icon tw-icon--warning",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	    }
	  })]), _vm._v("\n      " + _vm._s(_vm.getEventWarningLabel(_vm.event.obj)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__content"
	  }, [_c('span', [_vm._v(_vm._s(_vm.event.obj.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timeStamp")(_vm.event.obj.start)) + " - " + _vm._s(_vm._f("timeStamp")(_vm.event.obj.end)))]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.obj.has_notes),
	      expression: "event.obj.has_notes"
	    }],
	    staticClass: "notes-icon icon-file-text2"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.obj.group),
	      expression: "event.obj.group"
	    }]
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v(" " + _vm._s(_vm.event.obj.group))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.obj.teacher),
	      expression: "event.obj.teacher"
	    }]
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.event.obj.teacher))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.obj.room),
	      expression: "event.obj.room"
	    }]
	  }, [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v(" " + _vm._s(_vm.event.obj.room))])]), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__bg",
	    style: ({
	      backgroundColor: _vm.event.obj.color
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__sider",
	    style: ({
	      backgroundColor: _vm.event.obj.color
	    })
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.sms.do_you_want_to_delete_the_template')) + "?")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.editsms.title))]), _vm._v(" "), _c('p', {
	    staticClass: "marg-1-bottom"
	  }, [_c('i', [_vm._v(_vm._s(_vm.editsms.body))])])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn marg-10-right",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-danger",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.delete')))])])])])
	},staticRenderFns: []}

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sms text-dark no-print text-dark"
	  }, [(!_vm.isOpen) ? _c('div', {
	    staticClass: "sms-header__toggler",
	    on: {
	      "click": function($event) {
	        return _vm.setOpen(!_vm.isOpen)
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
	    staticClass: "close-icon sms-header__toggler__icon text-white"
	  }, [(_vm.isOpen) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideInUp"
	    },
	    on: {
	      "after-enter": _vm.onEnterComplete
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "sms-container"
	  }, [_c('div', {
	    staticClass: "sms-header__toggler",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
	    staticClass: "close-icon sms-header__toggler__icon text-white"
	  }, [(_vm.isOpen) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sms-body"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeOut"
	    }
	  }, [(_vm.noNumberForUser) ? _c('div', {
	    staticClass: "sms-body__signup"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    staticClass: "sms-body__signup__content box"
	  }, [_c('h2', {
	    staticClass: "text-blue"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['welcome_to_sms']))]), _vm._v(" "), _c('p', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number_to_send_sms']))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number']))]), _vm._v("\n                " + _vm._s(_vm.user.phone) + "\n                "), _c('SmsAddNumber', {
	    staticClass: "marg-10-right",
	    attrs: {
	      "userid": _vm.user.id,
	      "updateThisUser": true,
	      "isEditFromStart": true
	    }
	  })], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "select-users"
	  }, [_c('div', {
	    staticClass: "users-header-second users-header-second__button"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    on: {
	      "click": _vm.getSubsOfTheDay
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['todays_substitutes']) + "\n            ")]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": '',
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": _vm.clearAllTags
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    staticClass: "users-header__searchfield",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.common.search')
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "list"
	  }, [_c('ul', {
	    staticClass: "users-list"
	  }, [_c('li', {
	    staticClass: "users-user users-user__header"
	  }, [(_vm.selectedUsers.length < 1) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setAllUsersSelected
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n                ")]) : _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.removeAllSelectedUsers
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "users-user users-user__header__right"
	  }, [(_vm.isSMSActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sms']))]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['email']))]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? [(_vm.filteredUsers.length < 1) ? _c('p', {
	    staticClass: "pad-20"
	  }, [_c('i', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_matches']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user, idx) {
	    return _c('li', {
	      key: user.id,
	      ref: 'user_ ' + user.id,
	      refInFor: true,
	      staticClass: "users-user",
	      class: [{
	          'users-user--only': _vm.filteredUsers.length === 1
	        },
	        {
	          'isSelected': _vm.checkIfInList(user.id)
	        },
	        {
	          'user--has-no-active-contact': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
	        },
	        {
	          'selectedWithoutContactForm': _vm.checkIfInListWithoutContactForm(user.id)
	        }
	      ]
	    }, [_c('div', {
	      staticClass: "users-user__meta",
	      on: {
	        "click": function($event) {
	          return _vm.setUser(user, idx, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "users-choose",
	      class: {
	        'users-choose--disabled': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
	      }
	    }, [_c('div', {
	      staticClass: "checkbox",
	      class: {
	        'checkboxChecked': _vm.checkIfInList(user)
	      }
	    }, [_c('span', {
	      staticClass: "checked"
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "users-img"
	    }, [_c('img', {
	      attrs: {
	        "src": user.img
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "users-name"
	    }, [_c('p', [_vm._v(_vm._s(user.name))])])]), _vm._v(" "), _c('div', {
	      staticClass: "users-last"
	    }, [_c('div', {
	      staticClass: "contact-options"
	    }, [(_vm.isSMSActive) ? _c('div', {
	      staticClass: "contact-options__option",
	      class: {
	        'contact-options__option--disabled': user.v_phone_setting === 'deactivated'
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{\n                             arrow: true\n                           }"
	      }],
	      staticClass: "icon__bg-circle contact-options__option__phone",
	      attrs: {
	        "content": user.v_phone_tooltip
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setOption(user, 'phone')
	        }
	      }
	    }, [(user.v_phone_setting === 'no_number') ? _c('svg', {
	      staticClass: "d-hero-icon--add w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 4.5v15m7.5-7.5h-15"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'active' || user.v_phone_setting === 'deactivated') ? _c('svg', {
	      staticClass: "d-hero-icon w-6 h-6",
	      class: {
	        'd-tw-icon--deactivated': user.v_phone_setting === 'deactivated'
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'awaiting_approval') ? _c('svg', {
	      staticClass: "w-6 h-6 d-icon__awaiting-approval d-hero-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('div', {
	      staticClass: "contact-options__option",
	      class: {
	        'contact-options__option--disabled': user.v_email_setting === 'deactivated'
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{\n                             arrow: true\n                           }"
	      }],
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "content": user.v_email_tooltip
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setOption(user, 'email')
	        }
	      }
	    }, [(user.v_email_setting === 'no_email') ? _c('svg', {
	      staticClass: "d-hero-icon--add w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 4.5v15m7.5-7.5h-15"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_email_setting === 'active' || user.v_email_setting === 'deactivated') ? _c('svg', {
	      staticClass: "w-6 h-6",
	      class: {
	        'd-tw-icon--deactivated': user.v_email_setting === 'deactivated'
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
	      }
	    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "contact-options__option contact-options__option__settings"
	    }, [_c('div', {
	      staticClass: "icon__bg-circle icon-more2",
	      on: {
	        "click": function($event) {
	          _vm.theActiveEditUser = user
	        }
	      }
	    })])])])])
	  })] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms"
	  }, [_c('div', {
	    staticClass: "users-header-second"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message_to']) + " " + _vm._s(_vm.selectedUsers.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body"
	  }, [_c('div', {
	    staticClass: "send-sms__body__templates"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_a_standard_template']))]), _vm._v(" "), (_vm.isLoadingTemplates) ? _c('div', [_c('spinner', {
	    attrs: {
	      "isSmall": true
	    }
	  })], 1) : _vm._l((_vm.templates), function(template) {
	    return _c('div', {
	      key: template.id,
	      staticClass: "standard-sms flex"
	    }, [_c('div', {
	      staticClass: "standard-sms__sub sms-template"
	    }, [_c('div', {
	      staticClass: "sms-template__title",
	      on: {
	        "click": function($event) {
	          return _vm.selectTemplate(template)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-file-text"
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(template.title))])]), _vm._v(" "), _c('d-dropdown', [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.setTheEditTemplate(template)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))]), _vm._v(" "), _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.theDeleteTemplate = template
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                      ")])])])], 1)])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "standard-sms flex"
	  }, [_c('div', {
	    staticClass: "standard-sms__sub sms-template sms-template__create",
	    on: {
	      "click": function($event) {
	        _vm.isCreateTemplate = true
	      }
	    }
	  }, [_c('div', {
	    staticClass: "sms-template__title"
	  }, [_c('span', [_vm._v("+")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['create_a_standard_template']))])])])])], 2), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body__message"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.messageSubject),
	      expression: "messageSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['subject']
	    },
	    domProps: {
	      "value": (_vm.messageSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.messageSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.messageBody),
	      expression: "messageBody"
	    }],
	    ref: "sms",
	    staticClass: "marg-1-bottom marg-1-top",
	    class: {
	      'error-class': _vm.giveFeedback && _vm.noText
	    },
	    attrs: {
	      "placeholder": _vm.i18n[_vm.locale]['message']
	    },
	    domProps: {
	      "value": (_vm.messageBody)
	    },
	    on: {
	      "click": function($event) {
	        _vm.giveFeedback = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.messageBody = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.giveFeedback && _vm.noText) ? _c('span', {
	    staticClass: "error-text"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message_must_be_filled']))]) : _vm._e(), _vm._v(" "), (_vm.noText || _vm.noReceiver) ? _c('button', {
	    staticClass: "submit-button width-100 submit-button--disabled",
	    on: {
	      "click": function($event) {
	        _vm.giveFeedback = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")]) : _c('button', {
	    staticClass: "submit-button width-100",
	    on: {
	      "click": _vm.sendMessage
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body__receivers marg-1-left marg-1-right"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['recipients']))]), _vm._v(" "), (_vm.selectedUsers.length < 1) ? _c('p', {
	    staticClass: "explainer-text"
	  }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['select_recipients']))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "receivers-container"
	  }, _vm._l((_vm.userSetSelected), function(user) {
	    return _c('li', {
	      staticClass: "receivers-container__receiver"
	    }, [_c('div', {
	      staticClass: "receiver__name"
	    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "receiver__remove icon-cross2",
	      on: {
	        "click": function($event) {
	          return _vm.setUser(user, _vm.idx)
	        }
	      }
	    })])
	  }), 0)])])])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.isCreateTemplate) ? _c('TemplateModal', {
	    attrs: {
	      "editsms": _vm.theEditTemplate,
	      "messageType": "email"
	    },
	    on: {
	      "close": _vm.closeTemplate,
	      "updated": _vm.readMessageTemplates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteTemplate) ? _c('TemplateDelete', {
	    attrs: {
	      "editsms": _vm.theDeleteTemplate
	    },
	    on: {
	      "close": function($event) {
	        _vm.theDeleteTemplate = null
	      },
	      "updated": _vm.readMessageTemplates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('SendMessagesUserSetting', {
	    attrs: {
	      "user": _vm.theActiveEditUser,
	      "isEmailActive": _vm.isEmailActive,
	      "isSMSActive": _vm.isSMSActive
	    },
	    on: {
	      "close": _vm.closeUserSetting
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "annual-norm text-dark"
	  }, [_c('div', {
	    staticClass: "d-header"
	  }, [_c('div', {
	    staticClass: "d-header__left"
	  }, [_c('h1', [_vm._v("Årsnorm")]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading && !_vm.isUpdatingTasks) ? _c('Loader') : [_c('div', {
	    staticClass: "d-tabs"
	  }, [_c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': !_vm.viewIsResult
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewIsResult = false
	      }
	    }
	  }, [_vm._v("\n        Tildel opgaver\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.viewIsResult
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewIsResult = true
	      }
	    }
	  }, [_vm._v("\n        Se opgørelse\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__container"
	  }, [(_vm.viewIsResult) ? [_c('AnnualNormResult', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.userWithProps
	    },
	    on: {
	      "setIsShowEmploymentEnded": _vm.setIsShowEmploymentEnded
	    }
	  })] : _c('div', {
	    staticClass: "annual-norm__body"
	  }, [_c('div', {
	    staticClass: "annual-norm__body__left"
	  }, [_c('AssignHoursNorm', {
	    staticClass: "marg-1-bottom",
	    attrs: {
	      "isKindergarten": true
	    },
	    on: {
	      "updateUsersHours": _vm.readAssignedHours
	    }
	  }), _vm._v(" "), _c('ul', _vm._l((_vm.userWithProps), function(user) {
	    return _c('li', {
	      key: user.user_calendar_id,
	      staticClass: "user-item",
	      class: {
	        'user-item--active': user.v_is_active_user
	      }
	    }, [_c('div', {
	      staticClass: "user-item__body",
	      on: {
	        "click": function($event) {
	          return _vm.setActiveUserId(user.id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "user-item__name"
	    }, [(user.default_thumb_url) ? _c('img', {
	      staticClass: "user-item__name__img",
	      attrs: {
	        "src": user.default_thumb_url
	      }
	    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', {
	      staticClass: "user-item__right"
	    }, [_c('div', {
	      staticClass: "user-item__hours"
	    }, [_c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Arb. tid")]), _c('span', [_vm._v(_vm._s(user.v_assigned_total_hours))])]), _vm._v(" "), _c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Uden børn")]), _c('span', [_vm._v(_vm._s(user.v_total_without_kids))])]), _vm._v(" "), _c('p', [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Med børn")]), _c('span', [_vm._v(_vm._s(user.v_total_with_kids))])])]), _vm._v(" "), _c('div', {
	      staticClass: "user-item__arrow"
	    }, [(!user.v_is_active_user) ? _c('span', {
	      staticClass: "icon-arrow-right4"
	    }) : _c('span', {
	      staticClass: "icon-arrow-down4"
	    })])])]), _vm._v(" "), (user.v_is_active_user) ? _c('div', {
	      staticClass: "user-item__tasks"
	    }, [(!_vm.activeNorm) ? _c('Loader', {
	      attrs: {
	        "isSmall": true,
	        "bg-color": "#fff"
	      }
	    }) : _c('table', {
	      staticClass: "d-table d-table__norm d-table__tasks marg-10-bottom"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "d-table__title",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('h4', [_vm._v("Norm")])])])]), _vm._v(" "), _c('tbody', [(_vm.activeNorm.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen opgaver uden børn")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeNormFormatted), function(item) {
	      return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])])
	    })], 2)]), _vm._v(" "), _c('table', {
	      staticClass: "d-table d-table__tasks marg-10-bottom"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "d-table__title",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('h4', [_vm._v("Opgaver uden børn")])])])]), _vm._v(" "), _c('tbody', [(user.v_user_tasks_without_kids.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen opgaver uden børn")])]) : _vm._e(), _vm._v(" "), _vm._l((user.v_user_tasks_without_kids), function(task) {
	      return _c('tr', {
	        key: task.id
	      }, [_c('td', [_c('div', {
	        staticClass: "task-with-edit"
	      }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	        staticClass: "subjects_subject subjects_subject__simple",
	        style: ([{
	          'border-left-color': task.color
	        }, {
	          'background-color': task.color
	        }])
	      }, [_vm._v("\n                          " + _vm._s(task.name) + "\n                        ")]) : _c('div', {
	        staticClass: "subjects_subject subjects_subject--not-subject"
	      }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	        staticClass: "is-number"
	      }, [_vm._v("\n                      " + _vm._s(task.hours) + "\n                    ")])])
	    })], 2)]), _vm._v(" "), _c('table', {
	      staticClass: "d-table d-table__tasks marg-10-bottom"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "d-table__title",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_c('h4', [_vm._v("Opgaver med børn")])])])]), _vm._v(" "), _c('tbody', [(user.v_user_tasks_with_kids.length < 1) ? _c('tr', [_c('td', [_vm._v("Ingen opgaver med børn")])]) : _vm._e(), _vm._v(" "), _vm._l((user.v_user_tasks_with_kids), function(task) {
	      return _c('tr', {
	        key: task.id
	      }, [_c('td', [_c('div', {
	        staticClass: "task-with-edit"
	      }, [(task.can_schedule || !task.hasOwnProperty('can_schedule')) ? _c('div', {
	        staticClass: "subjects_subject subjects_subject__simple",
	        style: ([{
	          'border-left-color': task.color
	        }, {
	          'background-color': task.color
	        }])
	      }, [_vm._v("\n                          " + _vm._s(task.name) + "\n                        ")]) : _c('div', {
	        staticClass: "subjects_subject subjects_subject--not-subject"
	      }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
	        staticClass: "is-number"
	      }, [_vm._v("\n                      " + _vm._s(task.hours) + "\n                    ")])])
	    })], 2)])], 1) : _vm._e()])
	  }), 0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "annual-norm__body__right"
	  }, [_c('div', {
	    staticClass: "annual-norm__body__right__header"
	  }, [_c('div', {
	    staticClass: "flipper-buttons"
	  }, [_c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': _vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-file-text"
	  }), _vm._v("\n                Uden børn\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "flipper-buttons__button",
	    class: {
	      'active': !_vm.isTasksView
	    },
	    on: {
	      "click": function($event) {
	        _vm.isTasksView = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-year-planning"
	  }), _vm._v("\n                Med børn\n              ")])])]), _vm._v(" "), (!_vm.isTasksView) ? _c('AnnualNormWithKids') : _vm._e(), _vm._v(" "), (_vm.isTasksView) ? _c('AnnualNormWithoutKids') : _vm._e()], 1)])], 2)], _vm._v(" "), (_vm.isShowEmploymentEnded) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "show-close": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowEmploymentEnded(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "do-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "do-modal__header"
	  }, [_c('h2', [_vm._v("Brudt ansættelse")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowEmploymentEnded(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__body"
	  }, [_c('AssignHoursEmploymentEnded', {
	    attrs: {
	      "schoolId": _vm.schoolId,
	      "users": _vm.userWithProps
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "d-modal"
	    }
	  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$store.commit('setConfirmDeletion', false)
	      },
	      "confirm": _vm.confirmDelete
	    }
	  }, [_c('h3', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-rules__rule-container"
	  }, [_c('div', {
	    staticClass: "d-input-group--toggler",
	    class: {
	      'd-input-group--toggler--active': _vm.isOn
	    },
	    on: {
	      "click": _vm.setIsOn
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n      Skal vikaren have ekstra løn før første lektion?\n    ")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isOn
	    }
	  })], 1), _vm._v(" "), (_vm.isOn) ? _c('div', {
	    staticClass: "d-groups"
	  }, [_vm._l((_vm.atStartOfDay), function(timeItem, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "d-groups__group"
	    }, [_c('span', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: false,
	          placement: 'right'
	        }),
	        expression: "{\n                  arrow: false,\n                  placement : 'right'\n                }"
	      }],
	      staticClass: "icon__bg-circle icon__bg-circle--danger d-groups__group__delete-item",
	      attrs: {
	        "content": 'Slet dette starttidspunkt'
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deleteItem(index)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "d-group"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Angiv tidspunkt for første lektion")]), _vm._v(" "), _c('input', {
	      staticClass: "d-input",
	      attrs: {
	        "type": "time"
	      },
	      domProps: {
	        "value": timeItem.time
	      },
	      on: {
	        "input": function($event) {
	          return _vm.updateTime($event, index)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "d-group"
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Hvor mange minutter skal vikaren have ekstra?")]), _vm._v(" "), _c('input', {
	      staticClass: "d-input",
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": timeItem.minutes
	      },
	      on: {
	        "input": function($event) {
	          return _vm.updateMinutes($event, index)
	        }
	      }
	    })])])
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn-trans",
	    on: {
	      "click": _vm.addTime
	    }
	  }, [_vm._v("+ Tilføj starttidspunkt")])], 2) : _vm._e(), _vm._v(" "), (_vm.isOn) ? _c('SalaryRulesRule', {
	    attrs: {
	      "subjectType": _vm.subjectType,
	      "propSelectedEmploymentTypeId": _vm.selectedEmploymentTitle
	    },
	    on: {
	      "change": _vm.setRuleEmployment
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-rules__rule-container"
	  }, [_c('div', {
	    staticClass: "d-input-group--toggler",
	    class: {
	      'd-input-group--toggler--active': _vm.isOn
	    },
	    on: {
	      "click": _vm.setIsOn
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n      Skal vikaren have et minimum antal timer om dagen\n    ")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isOn
	    }
	  })], 1), _vm._v(" "), (_vm.isOn) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Hvor mange minutter skal vikaren minimum have?")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.minutes),
	      expression: "minutes"
	    }],
	    ref: "input_number",
	    staticClass: "d-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.minutes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.minutes = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.isOn) ? _c('SalaryRulesRule', {
	    attrs: {
	      "subjectType": _vm.subjectType,
	      "propSelectedEmploymentTypeId": _vm.selectedEmploymentTypeId
	    },
	    on: {
	      "change": _vm.setRuleEmployment
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-rules__rule-container"
	  }, [_c('div', {
	    staticClass: "d-input-group--toggler",
	    class: {
	      'd-input-group--toggler--active': _vm.isOn
	    },
	    on: {
	      "click": _vm.setIsOn
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("\n      Skal mellemtimer automatisk give tid\n    ")]), _vm._v(" "), _c('AppToggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isOn
	    }
	  })], 1), _vm._v(" "), (_vm.isOn) ? _c('div', {
	    staticClass: "d-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Hvor mange minutter skal mellemtimen max være?")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.minutes),
	      expression: "minutes"
	    }],
	    ref: "input_number",
	    staticClass: "d-input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.minutes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.minutes = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.isOn) ? _c('SalaryRulesRule', {
	    attrs: {
	      "subjectType": _vm.subjectType,
	      "propSelectedEmploymentTypeId": _vm.selectedEmploymentTypeId
	    },
	    on: {
	      "change": _vm.setRuleEmployment
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
	    staticClass: "d-modal__buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "salary-rules__rule-container"
	  }, [(_vm.rules.length === 0) ? _c('h4', {
	    staticClass: "text-explainer",
	    staticStyle: {
	      "margin-top": "0"
	    }
	  }, [_vm._v("Ingen regler oprettet")]) : _vm._e(), _vm._v(" "), _c('draggable', {
	    staticClass: "salary-rules__rule-container__draggable",
	    on: {
	      "change": _vm.onChangeOrder
	    },
	    model: {
	      value: (_vm.rules),
	      callback: function($$v) {
	        _vm.rules = $$v
	      },
	      expression: "rules"
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": "flip-list",
	      "tag": "ul"
	    }
	  }, _vm._l((_vm.rules), function(rule, key) {
	    return _c('li', {
	      key: rule.id,
	      staticClass: "salary-rules__rule"
	    }, [_c('div', [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('div', [_vm._v("\n          Hvis\n        ")]), _vm._v(" "), _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.type),
	        expression: "rule.type"
	      }],
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          return _vm.onChangeRuleType(rule, $event.target.value)
	        }]
	      }
	    }, _vm._l((_vm.ruleTypes), function(ruleType) {
	      return _c('option', {
	        domProps: {
	          "value": ruleType.value
	        }
	      }, [_vm._v("\n              " + _vm._s(ruleType.title) + "\n            ")])
	    }), 0)]), _vm._v(" "), (rule.type === 'employment_type') ? _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.substituted_employment_title),
	        expression: "rule.substituted_employment_title"
	      }],
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "substituted_employment_title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, _vm.onChange]
	      }
	    }, _vm._l((_vm.employmentsTypesForFullTime), function(employmentsType) {
	      return _c('option', {
	        domProps: {
	          "value": employmentsType
	        }
	      }, [_vm._v("\n              " + _vm._s(employmentsType) + "\n            ")])
	    }), 0)]) : _vm._e(), _vm._v(" "), (rule.type === 'subject_type') ? _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.subject_type),
	        expression: "rule.subject_type"
	      }],
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "subject_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, _vm.onChange]
	      }
	    }, _vm._l((_vm.subjectTypes), function(subjectType) {
	      return _c('option', {
	        domProps: {
	          "value": subjectType.value
	        }
	      }, [_vm._v("\n              " + _vm._s(subjectType.name) + "\n            ")])
	    }), 0)]) : _vm._e(), _vm._v(" "), (rule.type === 'subject_title') ? _c('div', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.trim",
	        value: (rule.subject_title),
	        expression: "rule.subject_title",
	        modifiers: {
	          "trim": true
	        }
	      }],
	      ref: 'subjectTitleInput' + rule.id,
	      refInFor: true,
	      staticClass: "rule-input-text",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (rule.subject_title)
	      },
	      on: {
	        "keyup": _vm.onChange,
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(rule, "subject_title", $event.target.value.trim())
	        },
	        "blur": function($event) {
	          return _vm.$forceUpdate()
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (rule.type === 'calendar_id') ? _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.calendar_id),
	        expression: "rule.calendar_id"
	      }],
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "calendar_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, _vm.onChange]
	      }
	    }, _vm._l((_vm.calendars), function(calendar) {
	      return _c('option', {
	        domProps: {
	          "value": calendar.id
	        }
	      }, [_vm._v("\n              " + _vm._s(calendar.name) + "\n            ")])
	    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("skal det tælle som")]), _vm._v(" "), _c('div', [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (rule.selected_employment_title),
	        expression: "rule.selected_employment_title"
	      }],
	      staticClass: "do-select",
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(rule, "selected_employment_title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, _vm.onChange]
	      }
	    }, _vm._l((_vm.employmentToSelectForRules), function(employmentsType) {
	      return _c('option', {
	        domProps: {
	          "value": employmentsType
	        }
	      }, [_vm._v("\n              " + _vm._s(employmentsType) + "\n            ")])
	    }), 0)]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          placement: 'left'
	        }),
	        expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
	      }],
	      staticClass: "icon__bg-circle d-item-delete icon__bg-circle--danger",
	      attrs: {
	        "content": _vm.$t('vue2.common.delete')
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setRoleToDelete(rule)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-bin"
	    })])])
	  }), 0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "do-buttons"
	  }, [_c('button', {
	    staticClass: "btn-trans",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.addNewRule.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("+ Tiløj regel")]), _vm._v(" "), (_vm.isChangeHasBeenMade) ? _c('div', {
	    staticClass: "do-submit-buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSaving
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid grid-pad box-size text-dark",
	    staticStyle: {
	      "padding-top": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "col-1-1 box-size"
	  }, [_c('div', {
	    staticClass: "students-container"
	  }, [_c('div', {
	    staticClass: "students-container__header"
	  }, [_c('div', {
	    staticClass: "students-container__header__left"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "students-container__header__right feide-import"
	  }, [(_vm.isFeideImportActive) ? _c('div', {
	    staticClass: "feide-import"
	  }, [_c('img', {
	    attrs: {
	      "id": "feide-logo",
	      "src": _vm.feideLogo
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "marg-1-right"
	  }, [_c('span', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.latest_updated')) + ":")]), _vm._v("\n              " + _vm._s(_vm.lastUpdateFromFeide))]), _vm._v(" "), _c('button', {
	    staticClass: "marg-1-right bttn--is-import",
	    staticStyle: {
	      "width": "120px",
	      "height": "34px"
	    },
	    on: {
	      "click": _vm.updateFromFeide
	    }
	  }, [(!_vm.isImporting) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.import_students')))]) : _c('Loader', {
	    staticStyle: {
	      "margin": "0",
	      "width": "20px",
	      "height": "20px"
	    },
	    attrs: {
	      "bg-color": "#f6f7f8"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('CreateStudents')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "students"
	  }, [_c('div', {
	    staticClass: "students__col students__col1"
	  }, [_c('div', {
	    staticClass: "students__col__header"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.groups')))])]), _vm._v(" "), _c('div', {
	    staticClass: "students__col__body",
	    style: (_vm.bodyStyleObj)
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _c('ul', [_c('li', {
	    staticClass: "students__filters__filter",
	    class: {
	      'students__filters__filter--active': _vm.isTheActiveFilter('')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveFilter('')
	      }
	    }
	  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.students.all')) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.students.length))])]), _vm._v(" "), _c('li', {
	    staticClass: "students__filters__filter",
	    class: {
	      'students__filters__filter--active': _vm.isTheActiveFilter('filter__activatedStudents')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveFilter('filter__activatedStudents')
	      }
	    }
	  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.students.activated_schedules')) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.studentsActivated.length))])]), _vm._v(" "), _c('li', {
	    staticClass: "students__filters__filter",
	    class: {
	      'students__filters__filter--active': _vm.isTheActiveFilter('filter__students_without_groups')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setTheActiveFilter('filter__students_without_groups')
	      }
	    }
	  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.students.without_group')) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.studentsWithoutKlasses.length))])]), _vm._v(" "), _c('li', {
	    staticClass: "students__filters__filter students__filters__filter__title"
	  }, [_vm._v(_vm._s(_vm.localActivatedSchoolYear.name) + "\n              ")]), _vm._v(" "), _vm._l((_vm.klassCalendars), function(klass) {
	    return _c('li', {
	      ref: "droppable_elements",
	      refInFor: true,
	      staticClass: "students__filters__filter",
	      class: {
	        'students__filters__filter--active': _vm.isTheActiveFilter(klass.id)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveFilter(klass.id)
	        },
	        "dragover": function($event) {
	          $event.preventDefault();
	        },
	        "dragenter": function($event) {
	          $event.preventDefault();
	          return _vm.dragEnter(klass, $event)
	        },
	        "dragleave": function($event) {
	          $event.preventDefault();
	          return _vm.dragLeave.apply(null, arguments)
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(klass, $event)
	        }
	      }
	    }, [_c('div', [_vm._v(_vm._s(klass.name))]), _vm._v(" "), _c('div', [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v(" " + _vm._s(klass.students ? klass.students.length : 0))])])
	  })], 2)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "students__col students__col2"
	  }, [_c('div', {
	    staticClass: "students__col__header students__col__header__students"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))])]), _vm._v(" "), _c('div', {
	    ref: "students_col1_body",
	    staticClass: "students__col__body",
	    style: (_vm.bodyStyleObj)
	  }, [_c('table', {
	    staticClass: "students__table"
	  }, [_c('thead', [_c('tr', {
	    staticClass: "students__student students__student__header"
	  }, [_c('th', [_c('span', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.dragStudents.length < 1) ? [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))] : [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))]], 2)]), _vm._v(" "), _c('th', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.groups')) + " (" + _vm._s(_vm.localActivatedSchoolYear.name) + ")")]), _vm._v(" "), (_vm.isFeideActive) ? _c('th', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide')))]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.to_be_scheduled')))])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _c('tbody', _vm._l((_vm.filteredStudents), function(student) {
	    return _c('tr', {
	      key: student.id,
	      staticClass: "students__student",
	      class: {
	        'isSelected': student.v_isSelectedForDrag
	      },
	      attrs: {
	        "draggable": "true"
	      },
	      on: {
	        "dragstart": function($event) {
	          $event.stopPropagation();
	          return _vm.dragStart(student, $event)
	        },
	        "dragend": function($event) {
	          $event.stopPropagation();
	          return _vm.dragEnd(student, $event)
	        },
	        "dragover": function($event) {
	          $event.stopPropagation();
	        },
	        "drop": function($event) {
	          $event.preventDefault();
	          return _vm.drop(_vm.slot, $event)
	        },
	        "click": function($event) {
	          return _vm.setTheActiveStudent(student)
	        }
	      }
	    }, [_c('td', [_c('div', {
	      staticClass: "name-and-checkbox"
	    }, [_c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setStudentsSelectedForDrag(student)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "d-checkbox",
	      class: {
	        'd-checkbox--active': false
	      }
	    })]), _vm._v("\n                    " + _vm._s(student.name) + "\n                  ")])]), _vm._v(" "), _c('td', _vm._l((student.v_klasses), function(klass, key) {
	      return _c('span', [(key !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                " + _vm._s(klass.name))])
	    }), 0), _vm._v(" "), (_vm.isFeideActive) ? _c('td', [_vm._v("\n                  " + _vm._s(student.custom_data && student.custom_data.feide ? student.custom_data['feide'] : '') + "\n                ")]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "d-toggle",
	      class: {
	        'd-toggle--active': !student.archived_at
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toggleStudentArchived(student)
	        }
	      }
	    })])])
	  }), 0)], 1)])])]), _vm._v(" "), (_vm.theActiveStudent) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('div', {
	    staticClass: "doc-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "doc-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.theActiveStudent.name))]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__close icon__bg-circle",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__body"
	  }, [_c('div', {
	    staticClass: "d-input-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.name')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editName),
	      expression: "editName"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.editName)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.isEditStudentChanges = true
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.isFeideActive) ? _c('div', {
	    staticClass: "d-input-group marg-1-bottom"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editFeide),
	      expression: "editFeide"
	    }],
	    staticClass: "d-input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.editFeide)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.isEditStudentChanges = true
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editFeide = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.students.groups')))]), _vm._v(" "), (_vm.getStudentRelations(_vm.theActiveStudent).length < 1) ? _c('div', {
	    staticClass: "doc-modal__student__klasses__no-klasses"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.students.has_no_groups')))])]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "doc-modal__student__klasses"
	  }, _vm._l((_vm.getStudentRelations(_vm.theActiveStudent)), function(klass, key) {
	    return _c('li', {
	      staticClass: "doc-modal__student__klasses__klass",
	      class: {
	        'klass--is-danger': _vm.isHoverOnKlass
	      }
	    }, [_c('div', [_vm._v(_vm._s(klass.name))]), _vm._v(" "), _c('div', {
	      staticClass: "text-link",
	      on: {
	        "click": function($event) {
	          return _vm.removeFromKlass(klass)
	        },
	        "mouseenter": function($event) {
	          _vm.isHoverOnKlass = true
	        },
	        "mouseout": function($event) {
	          _vm.isHoverOnKlass = false
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.students.remove')) + "\n                  ")])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-modal__footer"
	  }, [_c('div', [_c('button', {
	    staticClass: "hint--right bttn--warning",
	    attrs: {
	      "aria-label": _vm.$t('vue2.students.delete_student')
	    },
	    on: {
	      "click": function($event) {
	        _vm.isEditStudentConfirmation = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bin"
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInUp"
	    }
	  }, [(_vm.isEditStudentChanges) ? _c('div', [_c('button', {
	    staticClass: "bttn submit-button",
	    staticStyle: {
	      "width": "120px"
	    },
	    on: {
	      "click": _vm.submitModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n                ")])]) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isEditStudentConfirmation) ? _c('ModalConfirmation', {
	    on: {
	      "close": _vm.closeModal,
	      "confirm": _vm.deleteStudent
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    ref: "customdrag",
	    staticClass: "d-custom-drag",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.add')) + " " + _vm._s(_vm.dragStudents.length) + "\n    "), (_vm.dragStudents.length === 1) ? [_vm._v(" " + _vm._s(_vm.$t('vue2.students.student')))] : [_vm._v(" " + _vm._s(_vm.$t('vue2.students.students')))]], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brutto text-dark",
	    class: {
	      'brutto--kindergarten': _vm.isKindergarten
	    }
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": _vm.setIsNormModal
	    }
	  }, [_vm._v("Normberegning")]), _vm._v(" "), (_vm.isActive) ? _c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h2', [_vm._v("Normberegning")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [_c('div', {
	    staticClass: "brutto-container__body__left"
	  }, [_c('div', {
	    staticClass: "d-tabs"
	  }, [_c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.getIsActiveTab(0)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setActiveTab(0)
	      }
	    }
	  }, [_vm._v("\n              Bruttotid\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__tab",
	    class: {
	      'd-tabs__tab--active': _vm.getIsActiveTab(1)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setActiveTab(1)
	      }
	    }
	  }, [_vm._v("\n              Nettotid\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs__content"
	  }, [_c('AssignHoursNormList', {
	    attrs: {
	      "standardNettoHours": _vm.originalNettoTime,
	      "isNetto": _vm.activeTab === 1,
	      "isKindergarten": _vm.isKindergarten,
	      "schoolYear": _vm.activeSchoolYear,
	      "theEditUserNorm": _vm.theEditUserNorm
	    },
	    on: {
	      "onEditBrutto": function($event) {
	        return _vm.setActiveTab(0)
	      },
	      "onEditNetto": function($event) {
	        return _vm.setActiveTab(1)
	      },
	      "updated": _vm.setItemsToSave,
	      "changedSum": _vm.setNettoTime,
	      "onEditedStandardWorkingHours": function($event) {
	        return _vm.setIsShowNewNettoModal($event)
	      },
	      "changedEmploymentRate": _vm.onChangedEmploymentRate
	    }
	  })], 1), _vm._v(" "), (!_vm.isKindergarten && !_vm.isPoolsDeactivated) ? _c('div', {
	    staticClass: "more-norms"
	  }, [_c('div', {
	    staticClass: "rest-calculation"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Rest / Ikke fordelt på puljer")]), _vm._v("\n              " + _vm._s(_vm.restCalculation) + "\n            ")]), _vm._v(" "), _c('ul', {
	    staticClass: "brutto__items"
	  }, _vm._l((_vm.items), function(item, idx) {
	    return _c('li', {
	      key: item.id,
	      staticClass: "brutto__items__item__container"
	    }, [_c('div', {
	      staticClass: "label-with-toggle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleItem(idx)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "d-label"
	    }, [_vm._v("Indsæt " + _vm._s(item.name))]), _vm._v(" "), _c('app-toggle', {
	      attrs: {
	        "allowChanges": false,
	        "propOn": _vm.isItemToggled(idx)
	      }
	    })], 1), _vm._v(" "), (_vm.isItemToggled(idx)) ? _c('div', {
	      staticClass: "brutto__items__item"
	    }, [_c('span', {
	      staticClass: "norm-title"
	    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                    "), (_vm.prepFactor && item.id === 'assigned_preparation_hours') ? _c('span', {
	      staticClass: "norm-title__sub"
	    }, [_vm._v("\n                      " + _vm._s(_vm.prepFactor) + " Forberedelesfaktor * " + _vm._s(_vm.hoursForTeaching) + " UV\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window',
	          onShow: function () { return _vm.isShowPrepFactorTooltip(item); }
	        }),
	        expression: "{\n                    arrow: true,\n                    animateFill: false,\n                    animation : 'shift-away',\n                    zIndex: '999999992',\n                    boundary: 'window',\n                    onShow: () => isShowPrepFactorTooltip(item)\n                  }"
	      }],
	      staticClass: "d-input-group__input",
	      attrs: {
	        "content": "Forberedelse opdateres automatisk ift. hvad der er tildelt i \"Undervisning\""
	      }
	    }, [(_vm.isEmploymentRateChanged && (item.id !== 'assigned_preparation_hours' && _vm.prepFactor)) ? _c('div', {
	      staticClass: "employment-rate-calculator"
	    }, [_vm._v("\n                      (" + _vm._s(_vm.formatEmploymentRateText(item)) + ")\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s(item.unit ? item.unit : 'timer'))]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.hours),
	        expression: "item.hours"
	      }],
	      attrs: {
	        "disabled": _vm.prepFactor && item.id === 'assigned_preparation_hours',
	        "type": "number"
	      },
	      domProps: {
	        "value": (item.hours)
	      },
	      on: {
	        "change": function($event) {
	          return _vm.onUpdatingHours(item, $event.target.value)
	        },
	        "focus": function($event) {
	          return $event.target.select()
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "hours", $event.target.value)
	        }
	      }
	    })])]) : _vm._e()])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "brutto__items__item__container brutto__items__item__container__notefield",
	    class: {
	      'brutto__items__item__container__notefield--alone': _vm.isPoolsDeactivated
	    }
	  }, [_c('div', {
	    staticClass: "label-with-toggle",
	    on: {
	      "click": _vm.setIsShowAgreement
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Indsæt en note til de valgte personer")]), _vm._v(" "), _c('app-toggle', {
	    attrs: {
	      "allowChanges": false,
	      "propOn": _vm.isShowAgreement
	    }
	  })], 1), _vm._v(" "), (_vm.isShowAgreement) ? _c('AppEIPWYZIWYG', {
	    attrs: {
	      "isKeepOpen": true,
	      "is-open": true,
	      "isInTestOfSaveButton": false
	    },
	    on: {
	      "changed": _vm.updateAgreements
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowAgreement) ? _c('h4', {
	    staticClass: "text-explainer"
	  }, [_c('svg', {
	    staticClass: "icon-archive tw-icon",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M5.23 3h13.54a2 2 0 0 1 1.98 2.22l-1.55 14A2 2 0 0 1 17.2 21H6.79a2 2 0 0 1-1.99-1.78l-1.55-14A2 2 0 0 1 5.23 3z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M10.59 14l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 12.58l2.3-2.3a1 1 0 0 1 1.4 1.42L13.42 14l2.3 2.3a1 1 0 0 1-1.42 1.4L12 15.42l-2.3 2.3a1 1 0 1 1-1.4-1.42L10.58 14zM4 3h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5c0-1.1.9-2 2-2z"
	    }
	  })]), _vm._v("\n              Bemærk at hvis der står noget i personens notefelt i forvejen vil dette blive slettet\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users"
	  }, [_c('div', {
	    staticClass: "brutto__users__header"
	  }, [_c('DoFiltersFilter', {
	    attrs: {
	      "users": _vm.usersSortedOnNameWithTags,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "clear": function($event) {
	        _vm.appliedFilters = []
	      },
	      "select": _vm.toggleFilter
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "norm-select-users__header"
	  }, [_c('div', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.selectedUsers.length < 1 ? 'Vælg alle' : 'Fravælg alle') + "\n            ")]), _vm._v(" "), _c('span', [_vm._v(" Viser " + _vm._s(_vm.filteredUsers.length) + " af " + _vm._s(_vm.usersSortedOnName.length))])]), _vm._v(" "), _c('ul', {
	    staticClass: "brutto__users__list"
	  }, _vm._l((_vm.filteredUsers), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "brutto__users__user",
	      class: {
	        'is-selected': _vm.getIsUserSelected(user)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(user.name) + "\n              "), _c('div', {
	      staticClass: "icon__bg-circle d-edit-btn",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editUserNorm(user)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-wrench"
	    })])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isActive = false
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        onShow: function () { return _vm.selectedUsers.length < 1; }
	      }),
	      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
	    }],
	    staticClass: "bttn bttn-primary",
	    class: [{
	      'bttn-primary--disabled': _vm.selectedUsers.length < 1
	    }, {
	      'bttn--loading': _vm.isSaving
	    }],
	    attrs: {
	      "content": "Der skal vælges minimum en bruger"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = true
	      }
	    }
	  }, [_vm._v("Gem\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isWarningActive) ? _c('DModal', {
	    staticStyle: {
	      "z-index": "999999999"
	    },
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-warning",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-warning__header"
	  }, [_c('h2', [_vm._v("Gem og erstat?")]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__body"
	  }, [_c('svg', {
	    staticClass: "tw-icon tw-icon--red",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "2",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "9",
	      "x2": "12",
	      "y2": "13"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "17",
	      "x2": "12.01",
	      "y2": "17"
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v("\n          Du er ved at tildele arbejdstid på " + _vm._s(_vm.nettoTime) + " til de valgte brugere. Hvis der i forvejen er tildelt en\n          arbejdstid vil dette blive erstattet.\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-warning__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.isWarningActive = false
	      }
	    }
	  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-primary bttn-primary--small",
	    class: [{
	      'bttn--loading': _vm.isSaving
	    }],
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Gem\n          og erstat\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.theNewNettoValue) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setIsShowNewNettoModal(null)
	      }
	    }
	  }, [_c('h4', {
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v("Vil du gemme " + _vm._s(_vm.theNewNettoValue) + " som den nye standard netto tid på skolen, så du ikke skal\n      taste det næste gang?")]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.setIsShowNewNettoModal(null)
	      }
	    }
	  }, [_vm._v("\n        Ikke gem\n      ")]), _vm._v(" "), _c('button', {
	    ref: "submit_bttn",
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.saveNewNettoTime
	    }
	  }, [_vm._v("\n        Gem som ny standard\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.theNewStandardHoursForPool) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        return _vm.setTheNewStandardHoursForPool(null)
	      }
	    }
	  }, [_c('h4', {
	    staticStyle: {
	      "font-weight": "normal"
	    },
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_vm._v("\n      Vil du gemme "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.theNewStandardHoursForPool.hours) + " timer")]), _vm._v(" som den nye standard for\n      "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.theNewStandardHoursForPool.name) + "-puljen")]), _vm._v(", så du ikke behøver at indtaste det næste\n      gang?\n    ")]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        return _vm.setTheNewStandardHoursForPool(null)
	      }
	    }
	  }, [_vm._v("\n        Ikke gem\n      ")]), _vm._v(" "), _c('button', {
	    ref: "submit_bttn",
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.saveNewStandardHours
	    }
	  }, [_vm._v("\n        Gem som ny standard\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.isModalAutoCalculateOpen) ? _c('ModalConfirmation', {
	    attrs: {
	      "showClose": false,
	      "isShowConfirmDeleteMessage": false
	    },
	    on: {
	      "close": function($event) {
	        _vm.isModalAutoCalculateOpen = false
	      }
	    }
	  }, [_c('h4', {
	    staticStyle: {
	      "font-weight": "normal"
	    },
	    attrs: {
	      "slot": "item"
	    },
	    slot: "item"
	  }, [_c('h3', {
	    staticClass: "marg-1-bottom"
	  }, [_vm._v("Skal puljer automatisk opdateres?")]), _vm._v(" "), _c('ul', _vm._l((_vm.checkedItemsToUpdate), function(checkedItem) {
	    return _c('li', {
	      key: checkedItem.id
	    }, [_c('b', [_vm._v(_vm._s(checkedItem.name) + ":")]), _vm._v(" " + _vm._s(_vm.formatEmploymentRateText(checkedItem, true)) + "\n        ")])
	  }), 0)]), _vm._v(" "), _c('template', {
	    slot: "confirm_buttons"
	  }, [_c('button', {
	    staticClass: "do-bttn",
	    on: {
	      "click": function($event) {
	        _vm.isModalAutoCalculateOpen = false
	      }
	    }
	  }, [_vm._v("\n        Ikke opdatér\n      ")]), _vm._v(" "), _c('button', {
	    ref: "submit_bttn",
	    staticClass: "do-bttn do-bttn--submit",
	    on: {
	      "click": _vm.updateActivePoolsFromEmploymentRate
	    }
	  }, [_vm._v("\n        Opdatér puljer\n      ")])])], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('CreateTaskForm', {
	    attrs: {
	      "user": _vm.user,
	      "date": _vm.date,
	      "initSubject": _vm.initSubject,
	      "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
	      "editEvent": _vm.editEvent,
	      "openingHours": _vm.openingHours
	    },
	    on: {
	      "setDate": _vm.setDate,
	      "close": function($event) {
	        return _vm.$emit('close')
	      },
	      "createNewSubject": function($event) {
	        return _vm.setCreateNewSubject($event)
	      },
	      "onCreatedEvent": _vm.onCreatedEvent,
	      "deleteEvent": _vm.onDeleteEvent,
	      "updatedEvent": function($event) {
	        return _vm.$emit('updatedEvent', $event)
	      }
	    }
	  }), _vm._v(" "), (_vm.theCreateNewSubjectName) ? _c('CreateTaskNewSubject', {
	    attrs: {
	      "user": _vm.user,
	      "date": _vm.date,
	      "title": _vm.theCreateNewSubjectName
	    },
	    on: {
	      "newSubject": _vm.onNewSubject,
	      "close": function($event) {
	        return _vm.setCreateNewSubject(null)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteEvent) ? _c('ModalConfirmation', {
	    attrs: {
	      "isSubmitButtonLoading": _vm.isDeleting
	    },
	    on: {
	      "confirm": _vm.deleteEvent,
	      "close": _vm.onCloseConfirmation
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-group text-dark"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.title')))]), _vm._v(" "), _c('div', {
	    staticClass: "choose-subject"
	  }, [(_vm.isLoadingSubjects) ? _c('div', {
	    staticClass: "choose-subject__spinner"
	  }, [_c('div', {
	    staticClass: "do-spinner"
	  })]) : _c('dSelect', {
	    attrs: {
	      "items": _vm.sortedSubjects,
	      "receiveData": _vm.theNewSubject,
	      "multiple": false,
	      "placeholder": _vm.$t('vue2.create_activity.search_or_create'),
	      "itemSpaceBetween": true
	    },
	    on: {
	      "enter": _vm.onCreateNewSubject,
	      "update": _vm.setSubject,
	      "searchText": _vm.setTheSearchText,
	      "onSearchTextDebounced": _vm.onSearchTextDebounced,
	      "close": _vm.onCloseDSelect
	    },
	    scopedSlots: _vm._u([_vm._l((_vm.sortedSubjects), function(item, index) {
	      return {
	        key: "test",
	        fn: function(slotProps) {
	          return [_c('div', {
	            staticClass: "choose-subject__event_type"
	          }, [_vm._v("\n          " + _vm._s(slotProps.item.vSubjectType) + "\n        ")])]
	        }
	      }
	    })], null, true)
	  }, [_vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [_c('h4', {
	    staticClass: "create-subject-link",
	    on: {
	      "click": _vm.onCreateNewSubject
	    }
	  }, [_vm._v("\n          + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.theSearchText) + "\"\n        ")])])]), _vm._v(" "), (_vm.isShowCreateSubjectButton) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "icon__bg-circle create-new-subject",
	    attrs: {
	      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.theSearchText + "\" "
	    },
	    on: {
	      "click": _vm.onCreateNewSubject
	    }
	  }, [_c('span', {
	    staticClass: "d-icon-plus"
	  })]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data-grade"
	  }, [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "rowspan": "2"
	    }
	  }, [_c('div', {
	    staticClass: "grade-title"
	  }, [(_vm.events.length > 0) ? _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isShowMore = !_vm.isShowMore
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-down"
	  })]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.calendarName) + "\n        ")])]), _vm._v(" "), _c('th', [_vm._v("Antal skemabrikker")]), _vm._v(" "), _c('th', [_vm._v("Antal skemabrikker med vikar")]), _vm._v(" "), _c('th', [_vm._v("Antal klokketimer")]), _vm._v(" "), _c('th', [_vm._v("Antal klokketimer med vikar")]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.events.length))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.eventsWithSub.length))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.eventsInHours))]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.eventsWithSubInHours))]), _vm._v(" "), _c('th')])]), _vm._v(" "), (_vm.isShowMore) ? _c('tbody', _vm._l((_vm.eventsInPools), function(subject, prop) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(prop))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['events']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['eventsWithSubs']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['durationInHours']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['durationWithSubsInHours']))]), _vm._v(" "), _c('td')])
	  }), 0) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "donut-chart"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('svg', {
	    attrs: {
	      "width": "160",
	      "height": "160",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', [_c('circle', {
	    staticClass: "circle_animation-2",
	    attrs: {
	      "id": "circle-back",
	      "r": "60",
	      "cy": "81",
	      "cx": "81",
	      "stroke-width": "9",
	      "stroke": "#ffffff",
	      "fill": "none"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "item",
	    class: [{
	      animateProgess: _vm.animate
	    }, _vm.stepClass]
	  }, [_c('h2', [_vm._v(_vm._s(_vm.stepNum) + "/" + _vm._s(_vm.steps))]), _vm._v(" "), _c('svg', {
	    attrs: {
	      "width": "160",
	      "height": "160",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', [_c('circle', {
	    staticClass: "circle_animation",
	    attrs: {
	      "id": "circle",
	      "r": "60",
	      "cy": "81",
	      "cx": "81",
	      "stroke-width": "9",
	      "stroke": "#3ecf8e",
	      "fill": "none"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DSelect', {
	    attrs: {
	      "items": _vm.allCals,
	      "isLoading": _vm.isLoading,
	      "itemsSelected": _vm.itemsSelected,
	      "allDataLoaded": _vm.allDataLoaded,
	      "multiple": true,
	      "appendToBody": _vm.appendToBody,
	      "placeholder": this.$t('vue2.dselect.placeholder_calendars')
	    },
	    on: {
	      "add": function($event) {
	        return _vm.$emit('add', $event)
	      },
	      "remove": function($event) {
	        return _vm.$emit('remove', $event)
	      },
	      "update": function($event) {
	        return _vm.$emit('updateItems', $event)
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "event-log text-dark pad-10"
	  }, [_c('h2', {
	    staticClass: "marg-10-bottom event-log__header"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['latest_activity']))]), _vm._v(" "), _c('div', {
	    staticClass: "el-items"
	  }, [(_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#f6f9fc"
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.logsFormatted), function(activity) {
	    return _c('div', {
	      staticClass: "el-items__item marg-10-bottom"
	    }, [_c('div', {
	      staticClass: "el-info"
	    }, [_c('div', {
	      staticClass: "el-info-right"
	    }, [_c('div', {
	      staticClass: "el-info__headline"
	    }, [_c('p', [_c('b', [_vm._v(_vm._s(activity.by))])]), _vm._v(" "), _c('p', {
	      staticClass: "text-grey hint--top-left",
	      attrs: {
	        "aria-label": activity.vFormattedDate
	      }
	    }, [_vm._v("\n              " + _vm._s(activity.vDuration) + " " + _vm._s(_vm.i18n[_vm.locale].ago))])]), _vm._v(" "), (activity.changes) ? _c('div', {
	      staticClass: "el-items__item__changes"
	    }, _vm._l((activity.vHumanizedChanges), function(txt) {
	      return _c('p', {
	        domProps: {
	          "innerHTML": _vm._s(txt)
	        }
	      })
	    }), 0) : _c('div', {
	      staticClass: "el-items__item__changes"
	    }, [_c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['created']))])])])])])
	  }), _vm._v(" "), (!_vm.isLoading && _vm.sortedLogs.length < 1) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['no_changes']) + "\n    ")]) : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "copy-week text-dark no-print"
	  }, [(_vm.isShowCopyCalendarRotate) ? _c('CopyCalendarRotate', {
	    attrs: {
	      "calendarId": _vm.calid,
	      "activeCalendarDate": _vm.activeCalendarDate
	    }
	  }) : [(!_vm.isShowCopyCalendarRotate) ? _c('button', {
	    class: [{
	        'do-bttn': _vm.activeCalendarDate
	      },
	      {
	        'inactive': _vm.modal
	      },
	      {
	        'hint--left hint--always': _vm.isJustCopied
	      }
	    ],
	    attrs: {
	      "aria-label": _vm.tooptipCopyWeek
	    },
	    on: {
	      "click": _vm.getCopyDate
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + "\n      "), _c('span', {
	    staticClass: "icon-arrow-down5"
	  })]) : _vm._e(), _vm._v(" "), (_vm.currentDateIsNotWithinCalendarRange) ? _c('button', {
	    class: {
	      'do-bttn': _vm.activeCalendarDate
	    },
	    on: {
	      "click": _vm.submitThisWeek
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.copycalendar.pasteThisWeek')) + "\n    ")]) : _vm._e()], _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeInDown"
	    }
	  }, [(_vm.modal) ? _c('div', {
	    staticClass: "week-picker"
	  }, [_c('div', {
	    staticClass: "week-picker__inner"
	  }, [_c('div', {
	    staticClass: "week-picker__header"
	  }, [_c('div', {
	    staticClass: "week-picker__header__left"
	  }, [_c('h2', {
	    staticClass: "text-blue"
	  }, [_vm._v("\n              " + _vm._s(_vm.selectedWeeks.length) + "\n              "), (_vm.selectedWeeks.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.weekSelected')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.weeksSelected')))])]), _vm._v(" "), (_vm.schoolIsFromDenmark) ? _c('a', {
	    staticClass: "label-link",
	    attrs: {
	      "target": "_blank",
	      "href": "https://docendohelp.crisp.help/da/article/kopiering-af-uger-i-skemaerkalendere-1tka0r4/?bust=1737554247682"
	    }
	  }, [_c('label', {
	    staticClass: "do-pill animateFast fadeInLeftCustom"
	  }, [_c('span', {
	    staticClass: "label-text"
	  }, [_vm._v("Bemærk: Kopierer kun brikker lagt i denne kalender")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-question3 marg-1-left"
	  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle icon__bg-circle__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "week-picker__content flex"
	  }, [_c('div', {
	    staticClass: "content"
	  }, _vm._l((_vm.weeks), function(week, index) {
	    return _c('div', {
	      key: week.serverDate,
	      staticClass: "number hint--top",
	      class: [{
	        'isSelected': week.isSelected
	      }, {
	        'isCopyWeek': week.isCopyWeek
	      }],
	      attrs: {
	        "aria-label": _vm._f("tooltipDate")(week.date)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleWeek(index)
	        }
	      }
	    }, [_c('span', {
	      class: {
	        'isNow': week.isNow
	      }
	    }, [_vm._v("\n            " + _vm._s(week.weekNum) + "\n          ")])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "sidebar"
	  }, [_c('ul', [_c('li', {
	    staticClass: "sidebar__headline"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + "\n                  "), _c('div', {
	    staticClass: "no-tag",
	    class: {
	      'tag': !_vm.showStartPasteWeek
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("week")(_vm.startPasteWeek)) + "\n                    "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showStartPasteWeek),
	      expression: "!showStartPasteWeek"
	    }],
	    staticClass: "icon-cross2 pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.eraseStartDate.apply(null, arguments)
	      }
	    }
	  })])])]), _c('li', [_c('span', {
	    staticClass: "sidebar__clickable",
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n                ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sidebar__clickable",
	    on: {
	      "click": _vm.selectOddWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sidebar__clickable",
	    on: {
	      "click": _vm.selectEvenWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn width-100 btn-trans"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "sidebar__clickable",
	    on: {
	      "click": _vm.removeAllSelectedWeeks
	    }
	  }, [_c('span', {
	    staticClass: "bttn btn-trans width-100 btn-remove"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n               ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "week-picker__footer"
	  }, [_c('div', {
	    staticClass: "delete-option"
	  }, [_c('label', {
	    attrs: {
	      "for": "checkbox"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.deleteLessonsInSelectedWeeks')))]), _vm._v(" "), (_vm.calType === 'user') ? _c('span', [_vm._v(" (" + _vm._s(_vm.$t('vue2.copycalendar.absenceWillNotBeDeleted')) + ")")]) : _vm._e()]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.deleteEvents),
	      expression: "deleteEvents"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.deleteEvents) ? _vm._i(_vm.deleteEvents, null) > -1 : (_vm.deleteEvents)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.deleteEvents,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.deleteEvents = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.deleteEvents = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.deleteEvents = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "bttn--submit",
	    class: {
	      'inactive': _vm.noneSelected || _vm.notSubmit
	    },
	    on: {
	      "click": _vm.submitWeeks
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')))])])])]), _vm._v(" "), _c('left-panel', {
	    attrs: {
	      "deleteEvents": _vm.deleteEvents,
	      "selectedWeeks": _vm.selectedWeeks,
	      "calId": _vm.calid
	    },
	    on: {
	      "load": _vm.setSubmit
	    }
	  })], 1) : _vm._e()])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container"
	  }, [_c('h4', {
	    staticClass: "uppercase marg-1-bottom"
	  }, [_vm._v("Personale")]), _vm._v(" "), (_vm.personaleUdenKorrekteOplysninger.length > 0) ? _c('div', {
	    staticClass: "d-attention"
	  }, [_c('svg', {
	    staticClass: "tw-icon icon-important",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
	    }
	  }), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
	    }
	  })]), _vm._v(" "), _c('h3', [_vm._v("Følgende personer mangler enten CPR-nummer eller Stilling.")]), _vm._v(" "), _c('p', [_vm._v("Gå til step 1. Undervisningskompetencer for at tilføje. Sæt til \"Ikke indberet\", hvis personen ikke skal indberettes.")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table d-table__borders"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.personaleUdenKorrekteOplysninger), function(user, key) {
	    return _c('tr', {
	      key: user.user_id
	    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.cpr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.stilling))])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.groupedLaerereProps), function(group, key) {
	    return _c('tr', {
	      key: key
	    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((group), function(prop) {
	      return _c('td', [_vm._v("\n        " + _vm._s(prop.length) + "\n      ")])
	    })], 2)
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th'), _vm._v(" "), _c('th', [_vm._v("CPR")]), _vm._v(" "), _c('th', [_vm._v("STILLING")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("Stilling")]), _vm._v(" "), _c('th', [_vm._v("Antal ansatte indberretes")]), _vm._v(" "), _c('th', [_vm._v("Heraf ansatte, der ikke er\n      registeret undervisningskompetencer for\n    ")])])
	}]}

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brutto text-dark"
	  }, [_c('DModal', {
	    attrs: {
	      "isBgOverlay": true,
	      "showClose": false
	    }
	  }, [_c('div', {
	    staticClass: "brutto-container",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "brutto-container__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.save_task_overview_version')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle doc-modal__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__body"
	  }, [(_vm.theTab === 1) ? _c('div', {
	    staticClass: "brutto__users"
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('h4', {
	    staticClass: "marg-05-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.version_title')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newVersionTitle),
	      expression: "newVersionTitle"
	    }],
	    ref: "version_name_input",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newVersionTitle)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        _vm.theTab = 2
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newVersionTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "text-desc"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.auto_name_description')))])]), _vm._v(" "), _c('div', {
	    staticClass: "save-versions__explained"
	  }, [_c('ul', {
	    staticClass: "d-event__actions text-dark"
	  }, [_c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheFAQAcc(0)
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheFAQAcc(0)
	      }
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.task_versions.what_is_version')) + "\n                  "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheFAQAcc(0)) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.saved_task_overview_description')))])]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
	    staticClass: "d-event__actions__action",
	    class: {
	      'd-event__actions__action--open': _vm.getTheFAQAcc(1)
	    }
	  }, [_c('h4', {
	    on: {
	      "click": function($event) {
	        return _vm.setTheFAQAcc(1)
	      }
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.task_versions.find_saved_versions')) + "\n                  "), _c('svg', {
	    staticClass: "tw-icon w-6 h-6",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "fill": "none",
	      "viewBox": "0 0 24 24",
	      "stroke-width": "1.5",
	      "stroke": "currentColor"
	    }
	  }, [_c('path', {
	    attrs: {
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
	    }
	  })])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "accordion"
	    },
	    on: {
	      "enter": _vm.start,
	      "after-enter": _vm.end,
	      "before-leave": _vm.start,
	      "after-leave": _vm.end
	    }
	  }, [(_vm.getTheFAQAcc(1)) ? _c('div', [_c('p', [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.task_versions.find_saved_versions_description')) + "\n                    ")])]) : _vm._e()])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.theTab === 2) ? _c('div', {
	    staticClass: "brutto__users"
	  }, [(_vm.tags.length > 0) ? _c('div', {
	    staticClass: "brutto__users__header"
	  }, [_c('filterTags', {
	    attrs: {
	      "users": _vm.usersSortedOnNameWithTags,
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "set": _vm.setTagFromFilter,
	      "remove": _vm.removeTagFromFilter
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "brutto__users__list__header",
	    on: {
	      "click": _vm.toggleAll
	    }
	  }, [(_vm.selectedUsers.length < 1) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('ul', {
	    staticClass: "brutto__users__list"
	  }, _vm._l((_vm.filteredUsers), function(user) {
	    return _c('li', {
	      key: user.id,
	      staticClass: "brutto__users__user",
	      class: {
	        'is-selected': _vm.getIsUserSelected(user)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleUser(user)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(user.name) + "\n            ")])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "brutto-container__footer"
	  }, [(_vm.theTab === 2) ? _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.theTab = 1
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.go_back')))]) : _vm._e(), _vm._v(" "), (_vm.theTab === 1) ? _c('button', {
	    staticClass: "bttn bttn-primary",
	    on: {
	      "click": function($event) {
	        _vm.theTab = 2
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.task_versions.select_personnel')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.theTab === 2) ? _c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        onShow: function () { return _vm.selectedUsers.length < 1; }
	      }),
	      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
	    }],
	    staticClass: "bttn bttn-primary",
	    class: [{
	      'bttn-primary--disabled': _vm.selectedUsers.length < 1
	    }, {
	      'bttn--loading': _vm.isSaving
	    }],
	    attrs: {
	      "content": _vm.$t('vue2.task_versions.select_min_user')
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.save_for_selected_users')) + " " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.$t('vue2.task_versions.save_for_selected_users_of')) + " " + _vm._s(_vm.filteredUsers.length) + "\n        ")]) : _vm._e()])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "datepicker-container text-dark"
	  }, [(!_vm.isShowInput) ? _c('div', {
	    ref: "date_input_field",
	    staticStyle: {
	      "width": "0px",
	      "height": "0px"
	    }
	  }) : _c('div', {
	    staticClass: "datepicker-input pointer pos-relative"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formatDate),
	      expression: "formatDate"
	    }],
	    ref: "date_input_field",
	    class: {
	      'input-active': _vm.active
	    },
	    attrs: {
	      "id": "inputfield",
	      "type": "text",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.formatDate)
	    },
	    on: {
	      "click": _vm.openDatePicker,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formatDate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.active),
	      expression: "!active"
	    }],
	    staticClass: "icon-calendar4 input-icon",
	    on: {
	      "click": _vm.openDatePicker
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.active),
	      expression: "active"
	    }],
	    staticClass: "icon-cross2 input-icon",
	    on: {
	      "click": _vm.closeDatePicker
	    }
	  })]), _vm._v(" "), (_vm.active) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeDatePicker),
	      expression: "closeDatePicker"
	    }],
	    ref: "child_popper",
	    staticClass: "popper-child__container text-dark"
	  }, [_c('div', {
	    staticClass: "datepicker-panel no-select",
	    class: [{
	      'no_weekends': !_vm.weekends
	    }, {
	      'datepicker-panel--show': _vm.isDropdownPopperDone
	    }],
	    attrs: {
	      "id": "datepicker-panel"
	    }
	  }, [_c('div', {
	    staticClass: "month-header overflow font-large"
	  }, [_c('div', {
	    staticClass: "arrow left pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.prevMonth.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-left4"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "arrow right pointer",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.nextMonth.apply(null, arguments)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "center bold",
	    attrs: {
	      "id": "headline"
	    }
	  }, [_vm._v(_vm._s(_vm.datePickerDateFormatted))])]), _vm._v(" "), _c('div', {
	    staticClass: "datepicker-with-weeknums"
	  }, [_c('div', {
	    staticClass: "datepicker-with-weeknums__week-numbers"
	  }, [_c('ul', _vm._l((_vm.weekNumbers), function(week) {
	    return _c('li', [_vm._v(_vm._s(week))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "datepicker-with-weeknums__datepicker"
	  }, [_c('div', {
	    staticClass: "cal weekdays datepicker-cells"
	  }, _vm._l((_vm.weekDays), function(weekday) {
	    return _c('div', {
	      staticClass: "datepicker-cell weekday"
	    }, [_vm._v("\n              " + _vm._s(_vm._f("capitalize")(_vm._f("threeLetters")(weekday))) + "\n            ")])
	  }), 0), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "calBoxContainer"
	    }
	  }, [_c('div', {
	    staticClass: "datepicker-cells",
	    attrs: {
	      "id": "calBox"
	    }
	  }, _vm._l((_vm.dates[0].date), function(date) {
	    return _c('div', {
	      class: ['datepicker-cell ' + date.dayClass, {
	        'datepicker-cell--disabled': date.isDisabled
	      }],
	      attrs: {
	        "aria-label": date.date
	      }
	    }, [(date.show) ? _c('span', {
	      staticClass: "number",
	      class: [{
	        isToday: date.isToday,
	        active: date.isSelected
	      }],
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setDate(date)
	        }
	      }
	    }, [_vm._v(_vm._s(date.showDate))]) : _c('span', {
	      staticClass: "number",
	      class: [{
	        isToday: date.isToday,
	        active: date.isSelected
	      }]
	    }, [_vm._v(_vm._s(date.showDate))])])
	  }), 0)])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "to-user-task-container"
	  }, [_c('div', {
	    staticClass: "to-user-task-container__header"
	  }, [(_vm.theActiveUser) ? _c('h2', {
	    staticClass: "to-user-title"
	  }, [_vm._v(_vm._s(_vm.theActiveUser.name))]) : _vm._e(), _vm._v(" "), _c('select', {
	    staticClass: "do-select",
	    domProps: {
	      "value": null
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$emit('setTheActiveUserId', $event.target.value)
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Skift bruger..")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
	    return _c('option', {
	      key: user.id,
	      domProps: {
	        "value": user.id
	      }
	    }, [_vm._v("\n        " + _vm._s(user.name) + "\n      ")])
	  })], 2)]), _vm._v(" "), (_vm.schoolYear && _vm.theActiveUser) ? _c('UserTasks', {
	    attrs: {
	      "isShowHeader": false,
	      "initialStartDate": _vm.schoolYear.employee_time_start,
	      "initialEndDate": _vm.schoolYear.employee_time_end,
	      "user_id": _vm.theActiveUser.id,
	      "user_calendar_id": _vm.theActiveUser.user_calendar_id,
	      "user_name": _vm.theActiveUser.name,
	      "isShowPrintButton": false,
	      "initialIsShowScheduled": false,
	      "isCanSeeOtherUsers": false,
	      "isReactive": true
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-cal",
	    class: [{
	        'd-cal--multi': _vm.isMultiCalendar
	      },
	      {
	        'd-cal--am-pm': _vm.isLocaleEn
	      },
	      {
	        'd-cal--loading': _vm.isLoadingEvents
	      },
	      {
	        'd-cal--is-list-view': _vm.isShowAsList
	      },
	      {
	        'd-cal--highlight-events': _vm.isCopyCalendarModalOpen
	      }
	    ],
	    attrs: {
	      "id": 'calendar_dom_id_' + _vm.calendarDOMUuid
	    }
	  }, [(_vm.isLoadingEvents) ? _c('div', {
	    staticClass: "d-cal__events-loading"
	  }, [_c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isShowAsList) ? _c('DCalendarList', {
	    attrs: {
	      "calendarName": _vm.calendarName,
	      "events": _vm.eventsWithMetaData,
	      "date": _vm.date,
	      "isShowWeekends": _vm.isShowWeekends,
	      "firstDayOfWeek": _vm.firstDayOfWeek,
	      "isCalendarInPrintMode": _vm.isCalendarInPrintMode
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isEditable && _vm.calendarId && !_vm.isLocked) ? _c('DCalendarSubjects', {
	    attrs: {
	      "calendar-id": _vm.calendarId,
	      "dragActiveDate": _vm.dragActiveDate,
	      "school": _vm.school,
	      "locale": _vm.locale,
	      "deleteSubject": _vm.deleteSubject
	    },
	    on: {
	      "movedXY": _vm.setMovedXY,
	      "setDragLesson": _vm.setTheExternalEvent,
	      "setIsDraggingExternalEvent": _vm.setIsDraggingExternalEvent,
	      "doMouseUp": _vm.subjectsMouseUp,
	      "onMouseEnter": _vm.onMouseEnterSubjects,
	      "onMouseLeave": _vm.onMouseLeaveSubjects,
	      "setActiveSubjectBCR": _vm.setTheExternalEventBCR
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isShowAsList) ? _c('div', {
	    staticClass: "d-cal__week"
	  }, [(!_vm.isHideHeader) ? _c('div', {
	    staticClass: "d-cal__header"
	  }, [(_vm.isMultiCalendar) ? _c('div', {
	    staticClass: "d-cal__week__header__name",
	    class: {
	      'd-cal__week__header__name--no-sidebar': !_vm.showSidebar
	    }
	  }, [_vm._v(_vm._s(_vm.calendarName) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "d-cal__week__header"
	  }, [(_vm.showSidebar) ? _c('li', {
	    staticClass: "d-cal__week__header__day--weeknumber"
	  }, [(!_vm.isHideDates) ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].week) + " " + _vm._s(_vm.theWeekNumber))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.days), function(day) {
	    return _c('li', {
	      staticClass: "d-cal__week__header__day",
	      class: {
	        'd-cal__week__header__day--today': day.isToday
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.isHideDates ? day.dayName : day.date) + "\n          "), (day.isToday && !_vm.isCalendarInPrintMode) ? _c('span', [_vm._v(_vm._s(_vm.$t('repitition.today')))]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__week__timed"
	  }, [(_vm.showSidebar) ? _c('ul', {
	    staticClass: "d-cal__week__timed__sidebar"
	  }, _vm._l((_vm.hoursInLocale), function(n, key) {
	    return _c('li', {
	      staticClass: "time"
	    }, [(key !== 0) ? _c('span', [_vm._v(_vm._s(n))]) : _vm._e()])
	  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__week__timed__container"
	  }, [_c('ul', {
	    staticClass: "d-cal__week__timed__background"
	  }, [_c('ul', {
	    staticClass: "days-container"
	  }, _vm._l((_vm.days), function(day) {
	    return _c('li', {
	      staticClass: "days-container__day"
	    }, [(_vm.isEditable) ? _c('DCalendarDayDraggable', {
	      attrs: {
	        "calendar": _vm.calendar,
	        "isLocked": _vm.isLocked,
	        "events": _vm.eventsWithMetaData,
	        "calendarId": _vm.calendarId,
	        "calStartTime": _vm.calStartTime,
	        "calEndTime": _vm.calEndTime,
	        "slotHeight": _vm.slotHeight,
	        "isEventsClickable": _vm.isEventsClickable,
	        "date": day.day,
	        "dragLesson": _vm.theDragLesson,
	        "dragEventY": _vm.dragEventY,
	        "dragActiveDate": _vm.dragActiveDate,
	        "dragActiveDates": _vm.dragActiveDates,
	        "dragEventEnd": _vm.dragEventEnd,
	        "dragEventStart": _vm.dragEventStart,
	        "dragEventHeight": _vm.dragEventHeight,
	        "isResizingEvent": _vm.isResizingEvent,
	        "isSideResizingEvent": _vm.isSideResizingEvent,
	        "isDraggingEvent": _vm.isDraggingEvent,
	        "isDraggingExternalEvent": _vm.isDraggingExternalEvent,
	        "theExternalEvent": _vm.theExternalEvent,
	        "isCopyCalendarModalOpen": _vm.isCopyCalendarModalOpen
	      },
	      on: {
	        "setDragEventEnd": _vm.setDragEventEnd,
	        "setDragEventStart": _vm.setDragEventStart,
	        "setDragLesson": _vm.setTheDragLesson,
	        "setDragEventY": _vm.setDragEventY,
	        "setDragEventHeight": _vm.setDragEventHeight,
	        "setDragActiveDate": _vm.setDragActiveDate,
	        "setIsResizingEvent": _vm.setIsResizingEvent,
	        "setIsSideResizingEvent": _vm.setIsSideResizingEvent,
	        "setIsDraggingEvent": _vm.setIsDraggingEvent,
	        "onEventClick": _vm.onEventClick,
	        "onMouseUp": _vm.onMouseUpFromDragging,
	        "setIsDraggingExternalEvent": _vm.setIsDraggingExternalEvent,
	        "setTheDeleteSubjectCursorPlacement": _vm.setTheDeleteSubjectCursorPlacement
	      }
	    }) : _vm._e(), _vm._v(" "), (!_vm.isEditable) ? _c('DCalendarDay', {
	      attrs: {
	        "events": _vm.eventsWithMetaData,
	        "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
	        "isCalNoBgColors": _vm.isCalNoBgColors,
	        "calendarId": _vm.calendarId,
	        "isMobile": _vm.isMobile,
	        "calStartTime": _vm.calStartTime,
	        "calEndTime": _vm.calEndTime,
	        "slotHeight": _vm.slotHeight,
	        "isEventsClickable": _vm.isEventsClickable,
	        "eventFontSize": _vm.eventFontSize,
	        "date": day.day,
	        "isHideCalendars": _vm.isHideCalendars,
	        "isHideDates": _vm.isHideDates
	      },
	      on: {
	        "onPresenceClick": _vm.onPresenceClick,
	        "onEventClick": _vm.onEventClick
	      }
	    }) : _vm._e()], 1)
	  }), 0), _vm._v(" "), _vm._l((_vm.hoursInLocale.length * 2), function(n) {
	    return _c('li', {
	      key: n,
	      staticClass: "time-slot"
	    })
	  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.movedY && (_vm.theExternalEvent || _vm.deleteSubject) && !_vm.dragActiveDate) ? _c('DCalendarDraggedSubject', {
	    attrs: {
	      "movedY": _vm.movedY,
	      "movedX": _vm.movedX,
	      "deleteSubject": _vm.deleteSubject,
	      "activeSubject": _vm.theExternalEvent,
	      "activeSubjectBCR": _vm.theExternalEventBCR
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isConfirmDeleteModal) ? _c('ModalConfirmation', {
	    staticClass: "d-modal--from-top",
	    attrs: {
	      "show-close": false,
	      "appendToBody": false,
	      "isShowDontAskAgain": true
	    },
	    on: {
	      "close": _vm.closeIsConfirmDelete,
	      "confirm": _vm.onConfirmDeleteEvent
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tabs-list",
	    class: {
	      'tabs-list--large': _vm.isLarge
	    },
	    attrs: {
	      "role": "tablist"
	    }
	  }, _vm._l((_vm.tabs), function(tab) {
	    return _c('div', {
	      key: tab.id,
	      class: [
	        'tabs-list__tab',
	        {
	          'tabs-list__tab--selected': _vm.selected === tab.id
	        }
	      ],
	      attrs: {
	        "role": "tab",
	        "tabindex": "0",
	        "aria-selected": _vm.selected === tab.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onSelect(tab.id)
	        },
	        "keydown": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.onSelect(tab.id)
	        }
	      }
	    }, [_vm._v("\n    " + _vm._s(tab.title) + "\n  ")])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "calendars-bulk text-dark"
	  }, [_c('div', {
	    staticClass: "sub-header no-print"
	  }, [_c('p', {
	    staticClass: "sub-header__item sub-header__title"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.calendars')) + "\n      "), _c('span', {
	    staticClass: "sub-header__title-divider icon-arrow-right4"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "sub-header__item",
	    class: {
	      'sub-header__item--active': _vm.selectedView === 'crudCalendars'
	    },
	    on: {
	      "click": function($event) {
	        _vm.selectedView = 'crudCalendars'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.edit_calendars')))]), _vm._v(" "), _c('p', {
	    staticClass: "sub-header__item",
	    class: {
	      'sub-header__item--active': _vm.selectedView === 'copyCalendars'
	    },
	    on: {
	      "click": function($event) {
	        _vm.selectedView = 'copyCalendars'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.copy_calendars')) + "\n    ")]), _vm._v(" "), (_vm.userHasPermissionToEditOthersPresence) ? _c('p', {
	    staticClass: "sub-header__item",
	    class: {
	      'sub-header__item--active': _vm.selectedView === 'presence'
	    },
	    on: {
	      "click": function($event) {
	        _vm.selectedView = 'presence'
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendars.add_presence')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "sub-header__item",
	    class: {
	      'sub-header__item--active': _vm.selectedView === 'deleteDays'
	    },
	    on: {
	      "click": function($event) {
	        _vm.selectedView = 'deleteDays'
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendars.delete_events_in_date_range')) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "grid grid-pad min-height"
	  }, [_c('div', {
	    staticClass: "calendars-bulk__header"
	  }, [_c('div', {
	    staticClass: "calendars-bulk__header__left"
	  }, [_c('h1', {
	    staticClass: "marg-20-right text-dark"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.calendars')))]), _vm._v(" "), _c('ChangeSchoolYear', {
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "calendars-bulk__header__right"
	  }, [(_vm.selectedView === 'deleteDays') ? _c('Datepickerrange', {
	    attrs: {
	      "allow-same-date": true,
	      "startdate": _vm.fromDate,
	      "enddate": _vm.toDate
	    },
	    on: {
	      "startchanged": _vm.setFromDate,
	      "endchanged": _vm.setToDate
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedView === 'crudCalendars') ? [_c('CalendarsBulkArchiveCalendar', {
	    attrs: {
	      "calendars": _vm.klassCalendars,
	      "calType": "klass",
	      "isOpen": true
	    }
	  }), _vm._v(" "), _c('CalendarsBulkArchiveCalendar', {
	    attrs: {
	      "calendars": _vm.roomCalendarsInclArchived,
	      "calType": "room"
	    }
	  }), _vm._v(" "), _c('CalendarsBulkArchiveCalendar', {
	    attrs: {
	      "calendars": _vm.mergeCalendarsInclArchived,
	      "calType": "merge"
	    }
	  }), _vm._v(" "), _c('CalendarsBulkArchiveCalendar', {
	    attrs: {
	      "calendars": _vm.otherCalendars,
	      "calType": "other"
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.selectedView === 'copyCalendars') ? [_c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.klassCalendars,
	      "calType": "klass",
	      "isOpen": true
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.userCalendars,
	      "calType": "user"
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.roomCalendarsInclArchived,
	      "calType": "room"
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.mergeCalendarsInclArchived,
	      "calType": "merge"
	    }
	  }), _vm._v(" "), _c('CopyMultipleCalendars', {
	    attrs: {
	      "calendars": _vm.otherCalendars,
	      "calType": "other"
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.selectedView === 'presence') ? [_c('PresenceForUsers')] : _vm._e(), _vm._v(" "), (_vm.selectedView === 'deleteDays') ? [(_vm.klassCalendars.length > 0) ? _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.klassCalendars,
	      "calType": "klass",
	      "isOpen": false
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.kindergartenCalendars.length > 0) ? _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.kindergartenCalendars,
	      "calType": "Stuer",
	      "isOpen": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.userCalendars,
	      "calType": "user",
	      "isOpen": false
	    }
	  }), _vm._v(" "), _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.roomCalendarsInclArchived,
	      "calType": "room",
	      "isOpen": false
	    }
	  }), _vm._v(" "), _c('CalendarsDeleteEventsInDays', {
	    attrs: {
	      "fromDate": _vm.fromDate,
	      "toDate": _vm.toDate,
	      "calendars": _vm.otherCalendars,
	      "calType": "other",
	      "isOpen": false
	    }
	  })] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "stil-overview d-timetal__container"
	  }, [_c('h4', {
	    staticClass: "uppercase"
	  }, [_vm._v("Personale")]), _vm._v(" "), _c('table', {
	    staticClass: "d-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.stilDataRess), function(userType, idx) {
	    return _c('tr', {
	      key: userType.id
	    }, [_c('td', [_vm._v(_vm._s(userType.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.number_of_usertype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.years_of_work))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_B))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_B))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_A1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_A1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_A22))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_A22))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_A33))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_A33))])])
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticClass: "center"
	  }, [_c('tr', [_c('th', {
	    staticStyle: {
	      "min-width": "225px"
	    },
	    attrs: {
	      "rowspan": "2"
	    }
	  }), _vm._v(" "), _c('th', {
	    attrs: {
	      "rowspan": "2"
	    }
	  }, [_vm._v("Antal personer")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "rowspan": "2"
	    }
	  }, [_vm._v("Årsværk")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Arbejdstimer")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Fagopdelt undervisning")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Understøttende undervisning")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Øvrig tid med eleverne")])]), _vm._v(" "), _c('tr', {
	    staticClass: "thead-second-row"
	  }, [_c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")])])])
	}]}

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('Modal', {
	    attrs: {
	      "show": _vm.showModal
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [(_vm.theCreateCalendarsType === 'merge') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createmerge.create_merge')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'other') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.create_calendars.other_calendar')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'room') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createrooms.create_rooms')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'club') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.club.create_club_calendar')))]) : _vm._e(), _vm._v(" "), (_vm.theCreateCalendarsType === 'kindergarten') ? _c('span', [_vm._v("Opret stuer")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [(_vm.calendarTypeIsWithSchoolYear) ? _c('h3', {
	    staticClass: "flex align-center marg-1-bottom"
	  }, [(!_vm.isKindergarten) ? [_vm._v(_vm._s(_vm.$t('vue2.createklass.schoolyear')))] : [_vm._v("Periode")], _vm._v(" "), _c('ChangeSchoolYear', {
	    staticClass: "marg-1-left",
	    attrs: {
	      "whiteTheme": true
	    }
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "cr-content"
	  }, [_c('h3', {
	    staticClass: "modal-form__titles"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createmerge.name')))]), _vm._v(" "), _vm._l((_vm.calendars), function(cal) {
	    return _c('div', {
	      staticClass: "modal-form-group"
	    }, [_c('div', {
	      staticClass: "flex create-form"
	    }, [_c('div', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (cal.name),
	        expression: "cal.name"
	      }],
	      staticClass: "namefield",
	      class: {
	        'missing-input': cal.isSameName
	      },
	      attrs: {
	        "type": "text",
	        "placeholder": _vm.placeholderText
	      },
	      domProps: {
	        "value": (cal.name)
	      },
	      on: {
	        "keyup": _vm.checkAllForText,
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(cal, "name", $event.target.value)
	        }
	      }
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "delete__user",
	      on: {
	        "click": function($event) {
	          return _vm.removeCalendar(cal)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-cross2"
	    })])])
	  }), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "add-more-button",
	    on: {
	      "click": _vm.pushNewCalendar
	    }
	  }, [_c('span', {
	    staticClass: "plus--icon"
	  }, [_vm._v("\n            +\n          ")]), _vm._v(" "), _c('span', {
	    staticClass: "add-more-button__text"
	  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.createusers.add_more')))])])])], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(_vm.someWithSameName) ? _c('p', {
	    staticClass: "error-message marg-20-right warning-text"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createmerge.warning_text')))]) : _vm._e(), _vm._v(" "), (_vm.showInactiveButton) ? _c('button', {
	    staticClass: "submit-btn--disabled"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n    ")]) : _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('Modal', {
	    attrs: {
	      "show": _vm.showModal
	    },
	    on: {
	      "close": _vm.setCloseModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.create_users')))]), _vm._v(" "), _c('div', {
	    staticClass: "cu",
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "cu-tab-content"
	  }, [_c('createUserForm', {
	    attrs: {
	      "country": _vm.country,
	      "pushname": _vm.pushNameFromSelect2
	    },
	    on: {
	      "editedUsers": _vm.setUsers,
	      "onNameInput": _vm.checkForDoubleNames
	    }
	  }), _vm._v(" "), (_vm.isTestSchool) ? _c('SearchForCalendar', {
	    staticStyle: {
	      "border-top": "1rem solid #edf0f5"
	    },
	    attrs: {
	      "query": _vm.activeInputName,
	      "calendarType": "users"
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-end pad-10",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(_vm.showInactiveButton) ? _c('button', {
	    staticClass: "create-form__submit"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.usersToSubmit.length > 0) ? _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.submitUsers
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "button-spinner"
	  }, [_c('div', {
	    staticClass: "button-spinner__spinner"
	  })])
	}]}

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bttn",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.createuser_button.create_user')))])
	},staticRenderFns: []}

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.clickaway),
	      expression: "clickaway"
	    }],
	    staticClass: "school-year pos-relative",
	    class: {
	      'white-theme': _vm.whiteTheme
	    }
	  }, [(_vm.schoolYears.length > 1) ? _c('div', {
	    staticClass: "school-year__active pointer",
	    class: {
	      'isActive': _vm.showDropdown
	    },
	    on: {
	      "click": function($event) {
	        _vm.showDropdown = !_vm.showDropdown
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.activeSchoolYear.name))]), _vm._v(" "), _c('span', {
	    staticClass: "icon-arrow-down4"
	  })]) : _c('div', {
	    staticClass: "school-year__active"
	  }, [_c('p', [_vm._v(_vm._s(_vm.activeSchoolYear.name))])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "dropdown"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showDropdown),
	      expression: "showDropdown"
	    }],
	    staticClass: "school-year__active__dropdown"
	  }, [_c('ul', _vm._l((_vm.schoolYears), function(year) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.setActiveSchoolYear(year.id)
	        }
	      }
	    }, [_vm._v(_vm._s(year.name))])
	  }), 0)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "td-user-day",
	    class: {
	      'td-user-day--active': _vm.isTheActiveDay
	    },
	    on: {
	      "click": _vm.setCreateEventOnUser
	    }
	  }, [_c('div', {
	    staticClass: "do-events"
	  }, [_vm._l((_vm.filteredEvents), function(event) {
	    return _c('div', {
	      key: event.event_id,
	      staticClass: "do-events__event do-events__event--edit",
	      style: ({
	        backgroundColor: event.color
	      }),
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editEvent(event)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(event.v_time) + "\n    ")])
	  }), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn--small btn-trans do-events__event__add-event"
	  }, [_vm._v("\n      + Tilføj vagt\n    ")])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showTutorial) ? _c('div', [_c('div', {
	    staticClass: "do-yt fadeIn js-dontCloseSidenav"
	  }, [_c('div', {
	    staticClass: "do-yt__container"
	  }, [_c('div', {
	    staticClass: "do-yt__container-close js-dontCloseSidenav",
	    on: {
	      "click": _vm.closeYouTubePopup
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2 js-dontCloseSidenav"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "do-yt__embed",
	    class: {
	      'scaleUp': _vm.classListTimeout
	    }
	  }, [_c('youtube', {
	    ref: "youtube",
	    attrs: {
	      "video-id": _vm.videoId,
	      "player-vars": _vm.videoVars
	    },
	    on: {
	      "ready": _vm.videoReady,
	      "cued": _vm.videoCued,
	      "playing": _vm.videoPlaying,
	      "ended": _vm.videoEnded
	    }
	  })], 1)])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "directDaySelector"
	  }, _vm._l((_vm.datesInMonths), function(month) {
	    return _c('div', {
	      staticClass: "directDaySelector__month-and-dates"
	    }, [_c('div', {
	      staticClass: "month"
	    }, [_vm._v(_vm._s(month.month.format("MMMM")))]), _vm._v(" "), _c('div', {
	      staticClass: "directDaySelector__month-and-dates__dates"
	    }, _vm._l((month.dates), function(date) {
	      return _c('div', {
	        staticClass: "day",
	        class: {
	          'isSelectable': date.isSelectable,
	            'isWeekend': date.isWeekend,
	            'isInRange': date.isInRange,
	            'isSelected': date.isSelected
	        },
	        on: {
	          "click": function($event) {
	            return _vm.toggle(date)
	          }
	        }
	      }, [_vm._v("\n        " + _vm._s(date.format("D")) + "\n      ")])
	    }), 0)])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "650px"
	    }
	  }, [_c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label marg-05-bottom"
	  }, [_vm._v("Vælg medarbejder")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.theSelectedUserId),
	      expression: "theSelectedUserId"
	    }],
	    staticClass: "do-select",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.theSelectedUserId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.onUserIsSelected]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._v("Vælg person")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
	    return _c('option', {
	      key: user.id,
	      domProps: {
	        "value": user.id
	      }
	    }, [_vm._v("\n        " + _vm._s(user.name) + "\n      ")])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Indtast første og sidste arbejdsdag for personen (begge dage inklusiv)")]), _vm._v(" "), _c('div', {
	    staticClass: "d-group-flex"
	  }, [_c('DatePickerRange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": function($event) {
	        return _vm.setEndDate($event, true)
	      }
	    }
	  }), _vm._v(" "), (!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Antal feriedage afholdt i perioden")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.numberOfVacationDays),
	      expression: "numberOfVacationDays"
	    }],
	    staticClass: "d-input__number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.numberOfVacationDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.numberOfVacationDays = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "d-input-group"
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Timer pr. uge")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hoursPerWeek),
	      expression: "hoursPerWeek"
	    }],
	    staticClass: "d-input__number",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.hoursPerWeek)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hoursPerWeek = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('h4', [_vm._v("Udregning")]), _vm._v(" "), _c('table', {
	    staticClass: "do-table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Antal dage")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDays))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Antal dage uden weekender")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekends))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekendsInHours))])]), _vm._v(" "), _c('tr', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom',
	        onShow: function () { return _vm.hasAnyHolidays; }
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  onShow: () => hasAnyHolidays\n                }"
	    }],
	    attrs: {
	      "content": _vm.holidaysAsLabels
	    }
	  }, [_c('td', [_vm._v("Antal søgnehellidage på hverdage")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filteredHolidays.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filteredHolidaysInHours))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Antal arbejdsdage fratrukket søgnehellidage")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekendsAndHolidays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekendsAndHolidaysInHours))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ferie afholdt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfVacationDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfVacationDaysInHours))])]), _vm._v(" "), _c('tr', {
	    staticClass: "d-diff"
	  }, [_c('td', [_vm._v("Mulig arbejdstid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfWorkDaysPossible))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfWorkDaysPossibleInHours))])]), _vm._v(" "), (_vm.userData) ? [_c('tr', {
	    staticClass: "d-diff"
	  }, [_vm._m(1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userActualHours))])]), _vm._v(" "), (_vm.userData) ? _c('tr', {
	    staticClass: "d-diff"
	  }, [_c('td', [_vm._v("Difference i arbejdstid")]), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.userActualHoursDiff) ? _c('td', [_vm._v(_vm._s(_vm.userActualHoursDiff > 0 ? '+' : '') + _vm._s(_vm.userActualHoursDiff))]) : _vm._e()]) : _vm._e()] : _vm._e()], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("For perioden")]), _vm._v(" "), _c('th', [_vm._v("Dage")]), _vm._v(" "), _c('th', [_vm._v("Timer")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('b', [_vm._v("Præsteret arbejdstid")])])
	}]}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lesson"
	  }, [_c('div', {
	    staticClass: "lesson-time",
	    style: ({
	      borderColor: _vm.event.color
	    })
	  }, [_vm._v("\n    " + _vm._s(_vm._f("LT")(_vm.event.start_time)) + "\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm._f("LT")(_vm.event.end_time)) + "\n  ")]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.event.title)), (_vm.eventHasAnyKlass(_vm.event.klasses)) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._f("klassList")(_vm.event.klasses))), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "meta-info"
	  }, [_vm._v(_vm._s(_vm.showType))])]), _vm._v(" "), (_vm.event.substitute_for) ? _c('div', [_c('span', {
	    staticClass: "icon-users3"
	  }), _vm._v(_vm._s(_vm.$t('vue2.substitute_hours.substitute_for')) + ":\n    " + _vm._s(_vm.event.substitute_for) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "align-right"
	  }, [_vm._v(_vm._s(_vm.eventDuration))])])
	},staticRenderFns: []}

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.isSubStatusPendingActive && _vm.getIsUserSubstituted) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'left',
	        arrow: false,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n            placement: 'left',\n             arrow: false,\n           animateFill: false,\n              animation : 'shift-away',\n            zIndex: '999999992',\n             boundary: 'window'\n          }"
	    }],
	    staticClass: "flex set-status",
	    attrs: {
	      "content": _vm.$t('vue2.sub_scheduler.is_substituted')
	    }
	  }, [_c('div', {
	    staticClass: "dot"
	  })]) : _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeDropDown),
	      expression: "closeDropDown"
	    }],
	    staticClass: "flex set-status pointer",
	    class: 'do-' + _vm.dropdownPlacement,
	    on: {
	      "click": function($event) {
	        _vm.showDropdown = true
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot",
	    class: [_vm.statusDotClass, {
	      'mini-dot--loading': _vm.isSubmitting
	    }]
	  }), _vm._v(" "), _c('div', {
	    staticClass: "arrow icon-arrow-down"
	  }), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    staticClass: "dropdown sub-status__dropdown",
	    class: {
	      'sub-status__dropdown--loading': _vm.isSubmitting
	    }
	  }, [(_vm.isSubmitting) ? _c('div', {
	    staticClass: "do-spinner__container"
	  }, [_c('div', {
	    staticClass: "do-spinner do-spinner--large"
	  })]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "sub-status__dropdown__list"
	  }, [(!_vm.getIsUserSubstituted) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setStatus(0)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot dot-white"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSubStatusPendingActive) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setStatus(2)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot dot-yellow"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.pending')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setStatus(1)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n        ")]), _vm._v(" "), (_vm.othersOnLessonAbsence.length > 0) ? _c('li', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setStatusForAll(1)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dot"
	  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled_for_absence')) + "\n        ")]) : _vm._e()])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data"
	  }, [_c('div', {
	    staticClass: "school-data__header"
	  }, [_c('div', {
	    staticClass: "school-data__header__left"
	  }, [_c('h1', [_vm._v("Skemalagte timer")]), _vm._v(" "), _c('changeSchoolYear', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "white-theme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "school-data__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [(_vm.filteredCalendars.length < 1) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen klasser i skoleåret")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.filteredCalendars), function(calendar) {
	    return _c('li', {
	      key: calendar.id
	    }, [_c('SchoolDataGrade', {
	      attrs: {
	        "calendar": calendar,
	        "eventsInHash": _vm.eventsInHash
	      }
	    })], 1)
	  }), 0)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'bottom'
	      }),
	      expression: "{\n                  arrow: true,\n                  placement : 'bottom'\n                }"
	    }],
	    staticClass: "create-btn",
	    attrs: {
	      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>N</span></p>'
	    },
	    on: {
	      "click": _vm.setShowModal
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.substitution.create_absence')) + "\n  ")]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [(_vm.showModal) ? _c('AppModal', {
	    attrs: {
	      "isShowFooter": false
	    },
	    on: {
	      "close": _vm.closeModal
	    }
	  }, [_c('h1', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.create_absence')))]), _vm._v(" "), _c('div', {
	    staticClass: "create-absence__form",
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "create__form-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.who')))]), _vm._v(" "), _c('SubsCreateDSelect', {
	    attrs: {
	      "id": "create_absence_user",
	      "items": _vm.users
	    },
	    on: {
	      "update": _vm.setUsers
	    }
	  }), _vm._v(" "), (!_vm.isUserSelected && _vm.showErrorMessages) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.person_must_be_filled')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "create__form-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason')))]), _vm._v(" "), _c('div', {
	    staticClass: "absence-reason"
	  }, [_c('dSelect', {
	    attrs: {
	      "items": _vm.subsAbsenceReasonsSorted,
	      "receiveData": _vm.reasonCreated,
	      "multiple": false,
	      "placeholder": _vm.$t('vue2.substitution.choose_absence_reason')
	    },
	    on: {
	      "update": _vm.setReason,
	      "searchText": _vm.setReasonSearchText,
	      "onSearchTextDebounced": _vm.onSearchTextDebounced,
	      "enter": function($event) {
	        _vm.isCreateAbsenceReason = true
	      },
	      "close": _vm.onCloseDSelectAbsenceReasons
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "noMatch"
	    },
	    slot: "noMatch"
	  }, [(_vm.userHasPermission('can_manage_absence_reasons')) ? _c('h4', {
	    staticClass: "create-absence-link",
	    on: {
	      "click": function($event) {
	        _vm.isCreateAbsenceReason = true
	      }
	    }
	  }, [_vm._v("\n                  + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.reasonSearchText) + "\"\n                ")]) : _c('h4', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.dselect.no_matching_results')) + "\n                ")])])]), _vm._v(" "), (_vm.userHasPermission('can_manage_absence_reasons') && _vm.isShowCreateAbsenceReasonButton) ? _c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window'
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	    }],
	    staticClass: "icon__bg-circle absence-reasons__settings",
	    attrs: {
	      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.reasonSearchText + "\" " + _vm.i18n[_vm.locale]["as_a_new_reason"]
	    },
	    on: {
	      "click": function($event) {
	        _vm.isCreateAbsenceReason = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "d-icon-plus"
	  })]) : _vm._e()], 1), _vm._v(" "), (!_vm.isReasonSelected && _vm.showErrorMessages) ? _c('span', {
	    staticClass: "error-message"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason_must_be_filled')))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "create__form-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.date')))]), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('DatepickerRange', {
	    attrs: {
	      "allowSameDate": true,
	      "startdate": _vm.getDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  }), _vm._v(" "), (_vm.isOngoingAbsenceAllowed) ? _c('div', {
	    staticClass: "absence-no-end-date",
	    class: {
	      'absence-no-end-date--active': _vm.isAbsenceOngoing
	    }
	  }, [_c('div', {
	    staticClass: "absence-no-end-date__inner",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.isAbsenceOngoing = !_vm.isAbsenceOngoing
	      }
	    }
	  }, [_c('app-toggle', {
	    attrs: {
	      "prop-on": _vm.isAbsenceOngoing
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
	    staticClass: "text-dark",
	    attrs: {
	      "slot": "answer"
	    },
	    slot: "answer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : _c('div', {
	    staticClass: "absence-no-end-date"
	  }, [_c('p', {
	    staticClass: "text-explainer"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.cant_be_ongoing_absence')))])])], 1), _vm._v(" "), (_vm.absentUsersWithOngoingAbsenceAlready.length > 0) ? _c('div', {
	    staticClass: "do-warning marg-1-top"
	  }, [_vm._l((_vm.absentUsersWithOngoingAbsenceAlready), function(user) {
	    return _c('b', {
	      key: user,
	      staticClass: "marg-05-right"
	    }, [_vm._v(_vm._s(user) + " ")])
	  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['already_has_ongoing_absence']) + "\n          ")], 2) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "create__form-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.time')))]), _vm._v(" "), _c('div', {
	    staticClass: "time-changer__group"
	  }, [_c('TimeChanger', {
	    attrs: {
	      "showIcon": true,
	      "start": _vm.startTime,
	      "end": _vm.endTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStartTime,
	      "updateEnd": _vm.setEndTime
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "hint--right",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['set_default_start_and_endtime']
	    }
	  }, [_c('div', {
	    staticClass: "icon__bg-circle time-changer__settings",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cog2"
	  })])])], 1)]), _vm._v(" "), (_vm.isStartDateSameDayAsEndDate) ? _c('div', {
	    staticClass: "create__form-group create__form-group__note-to-absence"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['note_to_absence']))]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.noteForAbsentReason),
	      expression: "noteForAbsentReason"
	    }],
	    staticClass: "d-input",
	    domProps: {
	      "value": (_vm.noteForAbsentReason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.noteForAbsentReason = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'top',
	        zIndex: 12312312312312
	      }),
	      expression: "{\n                    placement : 'top',\n                    zIndex: 12312312312312\n                  }"
	    }],
	    staticClass: "bttn create-btn right marg-10",
	    attrs: {
	      "content": _vm.saveKeyTooltip
	    },
	    on: {
	      "click": _vm.submitUser
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.create_absence')) + "\n          ")])])])]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowSettings) ? _c('DModal', {
	    on: {
	      "close": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    staticStyle: {
	      "width": "400px"
	    },
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['standard_setting']))]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__close icon__bg-circle",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('label', {
	    staticClass: "d-input marg-1-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['set_default_start_and_endtime']))]), _vm._v(" "), _c('TimeChanger', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "showIcon": true,
	      "start": _vm.standardStartTime,
	      "end": _vm.standardEndTime,
	      "isFiveMinutesInterval": false
	    },
	    on: {
	      "updateStart": _vm.setStandardStartTime,
	      "updateEnd": _vm.setStandardEndTime
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__buttons pad-1"
	  }, [_c('button', {
	    staticClass: "bttn bttn-simple marg-1-right",
	    on: {
	      "click": function($event) {
	        _vm.isShowSettings = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": _vm.submitStandardSettings
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isCreateAbsenceReason) ? _c('AbsenceReasonsCreate', {
	    attrs: {
	      "initTitle": _vm.reasonSearchText,
	      "reasons": _vm.subsAbsenceReasonsSorted
	    },
	    on: {
	      "create": _vm.createAbsenceReason,
	      "cancel": function($event) {
	        _vm.isCreateAbsenceReason = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        placement: 'right'
	      }),
	      expression: "{arrow: true,placement : 'right'}"
	    }],
	    staticClass: "team-calendar-activator text-dark no-print",
	    class: {
	      'team-calendar-activator--is-active': _vm.showTeamCalendar
	    },
	    attrs: {
	      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>S</span></p>'
	    },
	    on: {
	      "click": _vm.toggleShowTeamCalendar
	    }
	  }, [_c('button', {
	    staticClass: " box-shadow submit-button button--rounded"
	  }, [(!_vm.showTeamCalendar) ? _c('span', {
	    staticClass: "icon-users"
	  }) : _c('span', {
	    staticClass: "icon-cross2"
	  })]), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.i18n[_vm.locale]['button_text'])
	    }
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadeIn"
	    }
	  }, [(_vm.showTeamCalendar) ? _c('div', {
	    staticClass: "background-overlay"
	  }) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideUp"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showTeamCalendar),
	      expression: "showTeamCalendar"
	    }],
	    staticClass: "overlay-calendars text-dark"
	  }, [_c('div', {
	    staticClass: "team-calendar",
	    class: {
	      'team-calendar--week-view': _vm.calView === 'resourceTimeGridFiveDay'
	    }
	  }, [_c('div', {
	    staticClass: "team-calendar__header flex space-between no-print"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['team_calendar']))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle team-calendar__close-cross pointer font-large no-print",
	    on: {
	      "click": _vm.closeTeamCalendar
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "team-calendar__body"
	  }, [_c('calHeader', {
	    attrs: {
	      "date": _vm.date,
	      "calview": _vm.calView,
	      "itemsSelected": _vm.selectedRess,
	      "selectedScrollOption": _vm.selectedScrollOption
	    },
	    on: {
	      "dateChange": _vm.setDate,
	      "setView": _vm.setCalView,
	      "updateEvents": _vm.updateEvents,
	      "usersUpdated": _vm.setSelectedRess,
	      "changedSortOption": _vm.setSortOption,
	      "setSelectedScrollOption": _vm.setSelectedScrollOption
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "team-calendar__calendars",
	    class: {
	      'team-calendar__calendars--loading-events': _vm.isLoadingEvents && _vm.isCalendarView
	    },
	    attrs: {
	      "id": "printTeamCalendar"
	    }
	  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isLoadingEvents && _vm.isCalendarView) ? _c('div', {
	    staticClass: "team-calendar__loader-container"
	  }, [_c('spinner', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['loading_events']))])], 1) : _vm._e(), _vm._v(" "), (_vm.calView === 'doubleBookings') ? _c('Collisions', {
	    attrs: {
	      "date": _vm.date,
	      "show": _vm.showTeamCalendar
	    },
	    on: {
	      "prevDay": _vm.setPrevDay,
	      "nextDay": _vm.setNextDay
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSchedulerView && !_vm.isLoading) ? _c('dScheduler', {
	    attrs: {
	      "calendars": _vm.selectedRess,
	      "events": _vm.events,
	      "title": _vm.schedulerDate,
	      "isLoading": _vm.isLoadingEvents
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isShowSchedulerShortcut) ? _c('dScheduler', {
	    attrs: {
	      "title": _vm.schedulerDate,
	      "calendars": _vm.theSchedulerCalendars,
	      "isLoading": _vm.isLoadingEvents,
	      "events": _vm.theSchedulerEvents,
	      "sortBy": _vm.theSortOptionForAllSchedules
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "zoomIn"
	    }
	  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
	    attrs: {
	      "event": _vm.activeEvent,
	      "calendar": _vm.activeCalendar,
	      "initCalendarId": _vm.activeEventCalendarId
	    },
	    on: {
	      "updated": _vm.updateEvents,
	      "close": function($event) {
	        return _vm.setActiveEvent(null)
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.selectedRess.length > 0 && _vm.isCalendarView && !_vm.isLoading) ? _c('div', {
	    ref: "calContainerRef",
	    staticClass: "calendar_container",
	    class: {
	      'calendar_container--side-scroll': _vm.selectedScrollOption === 'horizontal'
	    }
	  }, [_c('div', {
	    staticClass: "d-cals"
	  }, _vm._l((_vm.selectedRess), function(calendar, idx) {
	    return _c('div', {
	      key: calendar.id,
	      staticClass: "d-cals__calendar"
	    }, [_c('DCalendar', {
	      attrs: {
	        "initNumberOfDays": _vm.userCustomNumberOfDays,
	        "isMultiCalendar": true,
	        "isShowStudents": true,
	        "date": _vm.date,
	        "isEventsClickable": _vm.isUserCanEditCalendar,
	        "events": _vm.getCalendarEvents(calendar.id),
	        "startTime": _vm.startTime,
	        "endTime": _vm.endTime,
	        "isShowWeek": _vm.isShowWeek,
	        "isShowWeekends": _vm.isShowWeekends,
	        "calendarId": calendar.id,
	        "calendarName": calendar.name,
	        "showSidebar": idx % 5 === 0,
	        "isShowAsList": _vm.isListView
	      },
	      on: {
	        "onEventClick": function($event) {
	          return _vm.setActiveEvent($event, calendar)
	        }
	      }
	    })], 1)
	  }), 0)]) : _vm._e()], 1)], 1)])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal"
	  }, [_c('div', {
	    staticClass: "d-timetal__container"
	  }, [_vm._m(0), _vm._v(" "), (_vm.isLoadingStilData) ? _c('div', {
	    staticStyle: {
	      "width": "500px"
	    }
	  }, [_c('Loader')], 1) : [_c('GrundskoleIndberetningTimetal', {
	    staticClass: "marg-1-top",
	    attrs: {
	      "stilData": _vm.stilData,
	      "isReadOnly": true
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "submit-bttn__container"
	  }, [_c('button', {
	    staticClass: "bttn bttn--primary",
	    class: {
	      'bttn--loading': _vm.isSendingToStil
	    },
	    staticStyle: {
	      "width": "165px"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Afslut og indberet\n        ")])])]], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "d-timetal__container__header"
	  }, [_c('h2', {
	    staticClass: "uppercase"
	  }, [_vm._v("Resume")])])
	}]}

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('AbsentToday', {
	    attrs: {
	      "is-subs-today": false,
	      "is-public": true
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('DSelect', {
	    attrs: {
	      "items": _vm.usersAndTags,
	      "isLoading": _vm.isLoading,
	      "itemsSelected": _vm.selectedUsers,
	      "show": _vm.showDropDown,
	      "allDataLoaded": _vm.allDataLoaded,
	      "multiple": _vm.multiple
	    },
	    on: {
	      "add": _vm.addUser,
	      "remove": _vm.removeUser,
	      "show": _vm.setShow,
	      "update": _vm.setSelectedUsers,
	      "searchText": _vm.setCreateUserText
	    },
	    scopedSlots: _vm._u([{
	      key: "item_identifier",
	      fn: function(props) {
	        return [_vm._t("default", null, {
	          "slot": "item_identifier",
	          "userId": props.userId
	        })]
	      }
	    }], null, true)
	  }, [_vm._v(" "), (_vm.showCreateButton) ? _c('template', {
	    slot: "noMatch"
	  }, [_c('h4', [_c('span', {
	    staticClass: "marg-10-right pad-10"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')) + " ")]), _vm._v(" "), _c('button', {
	    staticClass: "bttn bttn-blue bttn-inline",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.createCalendarOnDSelect.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.dselect.create_user')) + "\n        ")])])]) : _vm._e()], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "school-data"
	  }, [_c('div', {
	    staticClass: "school-data__header"
	  }, [_c('div', {
	    staticClass: "school-data__header__left"
	  }, [_c('h1', [_vm._v("Fraværstyper fordelt over måneder")]), _vm._v(" "), _c('changeSchoolYear', {
	    staticClass: "marg-1-right",
	    attrs: {
	      "white-theme": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "school-data__header__right"
	  }, [(!_vm.isDatesPristine) ? _c('p', {
	    staticClass: "d-link",
	    on: {
	      "click": _vm.resetDates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
	    attrs: {
	      "startdate": _vm.startDate,
	      "enddate": _vm.endDate
	    },
	    on: {
	      "startchanged": _vm.setStartDate,
	      "endchanged": _vm.setEndDate
	    }
	  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [_c('table', {
	    staticClass: "d-table"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Årsag")]), _vm._v(" "), _vm._l((_vm.restructuredAbsenceData), function(monthData) {
	    return _c('th', {
	      key: monthData.month
	    }, [_vm._v(_vm._s(monthData.month))])
	  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.visibleAbsenceTypes), function(type) {
	    return _c('tr', [_c('td', [_c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleHiddenAbsence(type)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24",
	        "fill": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M12 15a3 3 0 100-6 3 3 0 000 6z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "fill-rule": "evenodd",
	        "d": "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z",
	        "clip-rule": "evenodd"
	      }
	    })])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(type))]), _vm._v(" "), _vm._l((_vm.restructuredAbsenceData), function(monthData) {
	      return _c('td', {
	        key: monthData.month
	      }, [_vm._v("\n        " + _vm._s(monthData[type]) + "\n      ")])
	    })], 2)
	  }), _vm._v(" "), (_vm.hiddenAbsenceTypes.length > 0) ? _c('tr', {
	    staticClass: "toggler",
	    on: {
	      "click": function($event) {
	        _vm.showHidden = !_vm.showHidden
	      }
	    }
	  }, [_c('td', {
	    attrs: {
	      "colspan": 2 + (_vm.restructuredAbsenceData.length * 1)
	    }
	  }, [(!_vm.showHidden) ? _c('p', {
	    staticClass: "hidden-toggler"
	  }, [_c('span', {
	    staticClass: "icon-arrow-right4"
	  }), _vm._v("Vis skjulte årsager (" + _vm._s(_vm.hiddenAbsenceTypes.length) + ")")]) : _c('p', {
	    staticClass: "hidden-toggler"
	  }, [_c('span', {
	    staticClass: "icon-arrow-down4"
	  }), _vm._v("Skjul skjulte årsager")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.hiddenAbsenceTypes), function(type) {
	    return (_vm.showHidden) ? _c('tr', [_c('td', [_c('div', {
	      staticClass: "icon__bg-circle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleHiddenAbsence(type)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "tw-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24",
	        "fill": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
	      }
	    })])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(type))]), _vm._v(" "), _vm._l((_vm.restructuredAbsenceData), function(monthData) {
	      return _c('td', {
	        key: monthData.month
	      }, [_vm._v("\n          " + _vm._s(monthData[type]) + "\n        ")])
	    })], 2) : _vm._e()
	  })], 2)])]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "reporting"
	  }, [_c('a', {
	    staticClass: "d-back-link",
	    attrs: {
	      "href": "/calendar"
	    }
	  }, [_vm._v("Tilbage til Docendo")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "d-tabs"
	  }, _vm._l((_vm.theTabs), function(tab, prop) {
	    return _c('div', {
	      staticClass: "d-tabs__tab",
	      class: [{
	          'd__tabs__tab--inactive': tab.inactive
	        },
	        {
	          'd-tabs__tab--active': _vm.getIsTheActiveTab(prop)
	        }
	      ],
	      on: {
	        "click": function($event) {
	          return _vm.setTheActiveTab(tab, prop)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(prop) + ". " + _vm._s(tab.title) + "\n    ")])
	  }), 0), _vm._v(" "), (_vm.isLoadingStilData) ? _c('div', {
	    staticStyle: {
	      "width": "500px"
	    }
	  }, [_c('Loader')], 1) : _c('div', {
	    staticClass: "reporting-content"
	  }, [_c('div', {
	    staticClass: "reporting__table"
	  }, [_c(_vm.theActiveComponent, {
	    tag: "component",
	    attrs: {
	      "standardSubjects": _vm.standardSubjects,
	      "stilData": _vm.stilData,
	      "dbStilData": _vm.dbStilData,
	      "isShowSubjects": _vm.isShowSubjects,
	      "usersSSNHash": _vm.usersSSNHash,
	      "klokketimetyper": _vm.klokketimetyper
	    },
	    on: {
	      "updateStil": _vm.updateStil,
	      "updateStilReportUser": _vm.updateStilReportUser
	    }
	  })], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "reporting__header"
	  }, [_c('div', {
	    staticClass: "reporting__header__right"
	  }, [_c('h1', [_vm._v("Kompetenceindberetning")])])])
	}]}

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('DModal', {
	    attrs: {
	      "show-close": false,
	      "isBgOverlay": true,
	      "placeInTop": true
	    },
	    on: {
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-modal",
	    attrs: {
	      "slot": "insertComponent",
	      "id": "d-create-task-for-user"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "d-modal__header"
	  }, [_c('h2', [_vm._v("Opret person på " + _vm._s(_vm.calendar.name))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "d-modal__content"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v(" Vælg personale ")]), _vm._v(" "), _c('DSelectCalendarIds', {
	    attrs: {
	      "itemType": "user",
	      "calendarIdsToHide": _vm.calendarIdsToHide,
	      "showTags": false,
	      "preSelectedItems": _vm.userCalendarIds,
	      "showCreateButton": false
	    },
	    on: {
	      "update": _vm.setSelectedUsers
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "do-modal__footer"
	  }, [(!_vm.isValidated) ? _c('button', {
	    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
	    staticClass: "do-bttn do-bttn--submit",
	    class: {
	      'do-bttn--submit--loading': _vm.isSubmitting
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "day-cal__event-container",
	    on: {
	      "pointerenter": _vm.onMouseEnterDay,
	      "pointerleave": _vm.onMouseLeaveDay
	    }
	  }, [(_vm.isDraggingEvent) ? _c('div', {
	    staticClass: "day-cal__event-container__events",
	    class: [{
	      'day-cal__event-container__events--active--resizing': _vm.isResizingEvent
	    }, {
	      'day-cal__event-container__events--active': _vm.dragLesson
	    }]
	  }, [(_vm.dragLesson && _vm.isActiveDay) ? _c('div', {
	    staticClass: "day-cal__event day-cal__event--dragged",
	    class: {
	      'day-cal__event--is-small': _vm.dragEventHeight < 20
	    },
	    style: ({
	      'borderColor': _vm.dragLesson.obj.color,
	      'height': _vm.dragEventHeight + 'px',
	      'top': (_vm.dragEventY - 1) + 'px',
	      'left': 0,
	      'width': '100%',
	      'zIndex': 100
	    }),
	    attrs: {
	      "data-cols": "1"
	    }
	  }, [_c('div', {
	    staticClass: "day-cal__event__content"
	  }, [_c('div', {
	    staticClass: "day-cal__event__content__header"
	  }, [_c('div', {
	    staticClass: "d-cal__event-title"
	  }, [_vm._v(_vm._s(_vm.dragLesson.obj.title))]), _vm._v(" "), _c('div', {
	    staticClass: "d-cal__event-time"
	  }, [_c('span', {
	    staticClass: "d-cal__event-time__start"
	  }, [_vm._v(_vm._s(_vm.dragEventStartTime) + " - " + _vm._s(_vm.dragEventEndTime))]), _vm._v(" "), (_vm.dragLesson.obj.has_notes) ? _c('span', {
	    staticClass: "d-cal__event-meta icon-file-text2"
	  }) : _vm._e(), _vm._v(" "), (_vm.dragLesson.obj.has_substitute) ? _c('span', {
	    staticClass: "d-cal__event-meta icon-users3"
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dragLesson.obj.teacher),
	      expression: "dragLesson.obj.teacher"
	    }],
	    staticClass: "day-cal__event__calendar"
	  }, [_c('span', {
	    staticClass: "icon-user"
	  }), _vm._v("\n          " + _vm._s(_vm.dragLesson.obj.teacher) + "\n        ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dragLesson.obj.group),
	      expression: "dragLesson.obj.group"
	    }],
	    staticClass: "day-cal__event__calendar"
	  }, [_c('span', {
	    staticClass: "icon-users"
	  }), _vm._v("\n          " + _vm._s(_vm.dragLesson.obj.group) + "\n        ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dragLesson.obj.room),
	      expression: "dragLesson.obj.room"
	    }],
	    staticClass: "day-cal__event__calendar"
	  }, [_c('span', {
	    staticClass: "icon-location"
	  }), _vm._v("\n          " + _vm._s(_vm.dragLesson.obj.room) + "\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__bg",
	    staticStyle: {
	      "opacity": "1"
	    },
	    style: ({
	      backgroundColor: _vm.dragLesson.obj.color
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event__sider",
	    style: ({
	      backgroundColor: _vm.dragLesson.obj.color
	    })
	  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "day-cal__event-container__events",
	    class: {
	      'day-cal__event-container__events--highlighted': _vm.isCopyCalendarModalOpen
	    }
	  }, _vm._l((_vm.correctEvents), function(event) {
	    return _c('div', {
	      key: event.obj.event_key,
	      staticClass: "day-cal__event",
	      class: [{
	        'day-cal__event--is-away': event.obj.away
	      }, {
	        'day-cal__event--is-canceled': event.obj.canceled
	      }, {
	        'day-cal__event--has-warning': event.obj.collision
	      }, {
	        'day-cal__event--is-other-calendar': event.obj.v_other_calendar
	      }, {
	        'day-cal__event--is-locked': _vm.isLocked
	      }, {
	        'day-cal__event--is-small': event.height < 20
	      }, {
	        'day-cal__event--other-school': event.obj.v_other_school
	      }, {
	        'day-cal__event--editable': event.obj.v_is_editable
	      }, {
	        'day-cal__event--hide': _vm.dragLesson && _vm.dragLesson.obj.event_id === event.obj.event_id && _vm.isDraggingEvent
	      }, {
	        'fc-bgevent__presence': event.obj.event_type === 'presence'
	      }, {
	        'day-cal__event--clickable': _vm.isEventsClickable
	      }, {
	        'day-cal__event--availability': event.obj.rendering
	      }],
	      style: ({
	        'borderColor': event.obj.color,
	        'height': event.height + 'px',
	        'top': (event.top - 1) + 'px',
	        'left': event.left + '%',
	        'width': event.width + '%'
	      }),
	      attrs: {
	        "data-cols": event.cols ? event.cols : 1,
	        "data-subject-type": event.obj.event_type
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onNativeEventClick(event, $event)
	        },
	        "pointerdown": function($event) {
	          $event.preventDefault();
	          return _vm.onMouseDown(event, $event)
	        }
	      }
	    }, [(!event.obj.v_other_school && event.obj.event_type !== 'presence') ? _c('div', {
	      staticClass: "day-cal__event__content",
	      class: {
	        'day-cal__event__content--loading': event.obj.v_is_loading
	      },
	      style: ({
	        'borderColor': event.obj.color
	      })
	    }, [_c('div', {
	      staticClass: "day-cal__event__content__header"
	    }, [_c('div', {
	      staticClass: "d-cal__event-title"
	    }, [(event.obj.v_other_calendar) ? _c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true,
	          animateFill: false,
	          animation: 'shift-away',
	          zIndex: '999999992',
	          boundary: 'window'
	        }),
	        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation: 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
	      }],
	      staticClass: "d-cal__event__other-calendar js-no-click",
	      attrs: {
	        "content": _vm.customTooltip(event.obj)
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          return _vm.goToCalendar(event.obj.calendar_id, $event)
	        }
	      }
	    }, [_c('svg', {
	      staticClass: "js-no-click tw-icon w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": event.obj.color
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
	      }
	    })])]) : _vm._e(), _vm._v(" "), (event.obj.away) ? _c('span', {
	      staticClass: "icon-home2 icon-home2-away icon-home2-away--schedules"
	    }) : _vm._e(), _vm._v("\n            " + _vm._s(event.obj.title) + "\n          ")]), _vm._v(" "), _c('div', {
	      staticClass: "d-cal__event-time"
	    }, [_c('span', {
	      staticClass: "d-cal__event-time__start"
	    }, [_vm._v(_vm._s(event.obj.event_starttime) + " - " + _vm._s(event.obj.event_endtime))]), _vm._v(" "), (event.obj.has_notes) ? _c('span', {
	      staticClass: "d-cal__event-meta icon-file-text2"
	    }) : _vm._e(), _vm._v(" "), (event.obj.has_substitute) ? _c('span', {
	      staticClass: "d-cal__event-meta icon-users3"
	    }) : _vm._e(), _vm._v(" "), (event.obj.collision || event.obj.away || event.obj.canceled) ? _c('div', {
	      staticClass: "d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning",
	      class: {
	        'd-cal__event-meta__fixed--canceled': event.obj.canceled
	      }
	    }, [(event.obj.canceled) ? _c('span', {
	      staticClass: "icon-notification22"
	    }) : _c('svg', {
	      staticClass: "tw-icon tw-icon--warning",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })]), _vm._v("\n              " + _vm._s(_vm.getEventWarningLabel(event.obj)) + "\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.isCalendarTypeRoom && event.obj.group) ? _c('div', {
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-users"
	    }), _vm._v("\n          " + _vm._s(event.obj.group) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.teacher),
	        expression: "event.obj.teacher"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-user"
	    }), _vm._v("\n          " + _vm._s(event.obj.teacher) + "\n        ")]), _vm._v(" "), (!_vm.isCalendarTypeRoom && event.obj.group) ? _c('div', {
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-users"
	    }), _vm._v("\n          " + _vm._s(event.obj.group) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.obj.room),
	        expression: "event.obj.room"
	      }],
	      staticClass: "day-cal__event__calendar"
	    }, [_c('span', {
	      staticClass: "icon-location"
	    }), _vm._v("\n          " + _vm._s(event.obj.room) + "\n        ")])]) : _vm._e(), _vm._v(" "), (event.obj.v_other_school) ? _c('div', {
	      staticClass: "day-cal__event__content"
	    }, [_c('div', {
	      staticClass: "day-cal__event__content__header"
	    }, [_c('div', {
	      staticClass: "d-cal__event-title"
	    }, [_vm._v(_vm._s(_vm.i18n['other_school']))]), _vm._v(" "), _c('div', {
	      staticClass: "d-cal__event-time"
	    }, [_c('span', {
	      staticClass: "d-cal__event-time__start"
	    }, [_vm._v(_vm._s(event.obj.event_starttime) + " - " + _vm._s(event.obj.event_endtime))])])])]) : _vm._e(), _vm._v(" "), (event.obj.v_is_editable && !_vm.isLocked && !event.obj.v_is_loading) ? _c('div', {
	      staticClass: "d-event__side__resizer"
	    }) : _vm._e(), _vm._v(" "), (event.obj.v_is_editable && !_vm.isLocked) ? _c('div', {
	      staticClass: "d-event__resizer"
	    }) : _vm._e(), _vm._v(" "), (event.obj.event_type !== 'presence') ? _c('div', {
	      staticClass: "day-cal__event__bg",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    }) : _vm._e(), _vm._v(" "), (!event.obj.v_other_calendar && event.obj.event_type !== 'presence') ? _c('div', {
	      staticClass: "day-cal__event__sider",
	      style: ({
	        backgroundColor: event.obj.color
	      })
	    }) : _vm._e()])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.weeknoteId) ? _c('div', {
	    staticClass: "weekplan-weeknote-log text-dark ww"
	  }, [_c('button', {
	    on: {
	      "click": _vm.setShowHistory
	    }
	  }, [_c('span', {
	    staticClass: "icon-clock"
	  }), _vm._v(" " + _vm._s(_vm.$t('vue2.weeknote_log.activity')))]), _vm._v(" "), (_vm.isShowHistory) ? _c('DModal', {
	    attrs: {
	      "showClose": false
	    },
	    on: {
	      "close": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "ww-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "ww-modal__header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.saved_versions')))]), _vm._v(" "), _c('div', {
	    staticClass: "icon__bg-circle ww-modal__header__close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross2"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "ww-modal__body"
	  }, [_c('div', {
	    staticClass: "ww-modal__body__sidebar"
	  }, [(_vm.logSorted.length === 0) ? _c('h3', {
	    staticClass: "marg-20-bottom text-explainer italic"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.no_saved_versions')))]) : _c('p', {
	    staticClass: "sidebar__headline"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.choose_versions_to_compare')))]), _vm._v(" "), _c('ul', _vm._l((_vm.logSorted), function(activity, key) {
	    return _c('li', {
	      staticClass: "log-list__item",
	      class: {
	        'log-list__item--active': _vm.isInActiveIdx(key)
	      },
	      attrs: {
	        "aria-number": _vm.revertedKey(activity)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setVersion(activity)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "log-list__item__header"
	    }, [_c('div', [_vm._v(_vm._s(_vm.showHumanizedTime(activity.at)) + " " + _vm._s(_vm.$t('vue2.common.ago')))]), _vm._v(" "), (_vm.isNewestVersion(activity)) ? _c('div', {
	      staticClass: "pill"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.current_version')))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(_vm.showUser(activity.by)))])])])])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "log-cards"
	  }, _vm._l((_vm.latestActivity), function(activity, key) {
	    return _c('div', {
	      staticClass: "log-cards__card"
	    }, [_c('div', {
	      staticClass: "log-cards__card__header"
	    }, [_c('h6', [_vm._v("\n                " + _vm._s(_vm.showHumanizedTime(activity.at)) + " " + _vm._s(_vm.$t('vue2.common.ago')) + "\n                "), (_vm.isNewestVersion(activity)) ? _c('span', {
	      staticClass: "pill"
	    }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.current_version')))]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.showUser(activity.by)))]), _vm._v(", " + _vm._s(_vm.showDate(activity.at)))])]), _vm._v(" "), _c('div', {
	      staticClass: "log-cards__card__content",
	      domProps: {
	        "innerHTML": _vm._s(activity.note)
	      }
	    })])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.isShowHistory) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "d-show-only-checkbox",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.isShowOnlySubjectsWithoutTeacher = !_vm.isShowOnlySubjectsWithoutTeacher
	      }
	    }
	  }, [_c('label', {
	    staticClass: "d-label"
	  }, [_vm._v("Vis kun fag uten underviser")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isShowOnlySubjectsWithoutTeacher),
	      expression: "isShowOnlySubjectsWithoutTeacher"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isShowOnlySubjectsWithoutTeacher) ? _vm._i(_vm.isShowOnlySubjectsWithoutTeacher, null) > -1 : (_vm.isShowOnlySubjectsWithoutTeacher)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isShowOnlySubjectsWithoutTeacher,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isShowOnlySubjectsWithoutTeacher = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isShowOnlySubjectsWithoutTeacher = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isShowOnlySubjectsWithoutTeacher = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "doTable__items text-dark"
	  }, [(_vm.calendarsWithProps.length === 0) ? _c('h2', {
	    staticClass: "text-explainer"
	  }, [_vm._v("Ingen klasser opprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.calendarsWithProps), function(calendar) {
	    return _c('li', {
	      key: calendar.id,
	      staticClass: "doTable__klass"
	    }, [_c('div', {
	      staticClass: "doTable__klass__header"
	    }, [_c('div', [_vm._v(_vm._s(calendar.name))]), _vm._v(" "), _c('div', [_c('button', {
	      staticClass: "do-bttn",
	      on: {
	        "click": function($event) {
	          return _vm.setIsCreate(calendar)
	        }
	      }
	    }, [_vm._v("Opprett fag i klassen")])])]), _vm._v(" "), _c('ul', {
	      staticClass: "subjects"
	    }, [(calendar.v_subjects.length < 1) ? _c('h4', {
	      staticClass: "text-explainer"
	    }, [_vm._v("Ingen fag opprettet")]) : _vm._e(), _vm._v(" "), _vm._l((calendar.v_subjects), function(subject) {
	      return (_vm.isShowOnlySubjectsWithoutTeacher ? !subject.v_has_teacher : true) ? _c('li', {
	        directives: [{
	          name: "tippy",
	          rawName: "v-tippy",
	          value: ({
	            arrow: true,
	            onShow: function () { return subject.v_has_teacher; }
	          }),
	          expression: "{\n                  arrow: true,\n                  onShow: () => subject.v_has_teacher\n                }"
	        }],
	        key: subject.id,
	        staticClass: "subjects_subject",
	        class: [{
	          'subject--has-user': subject.v_has_teacher
	        }, {
	          'subject--has-room': subject.v_has_room
	        }],
	        style: ({
	          'background': subject.color
	        }),
	        attrs: {
	          "content": subject.v_teacher_names
	        },
	        on: {
	          "click": function($event) {
	            return _vm.setEditSubject(subject)
	          }
	        }
	      }, [_vm._v("\n          " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n        ")]) : _vm._e()
	    })], 2)])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._l((_vm.colors), function(color, idx) {
	    return _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedColor),
	        expression: "selectedColor"
	      }],
	      key: idx,
	      ref: "inputradio",
	      refInFor: true,
	      staticClass: "hidden_field",
	      attrs: {
	        "type": "radio",
	        "name": "color"
	      },
	      domProps: {
	        "value": color.value,
	        "checked": _vm._q(_vm.selectedColor, color.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selectedColor = color.value
	        }
	      }
	    })
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "color-picker"
	  }, _vm._l((_vm.colors), function(color, idx) {
	    return _c('li', {
	      key: color.value,
	      staticClass: "color-picker__color hint--top",
	      class: {
	        'isActive': _vm.isSelectedColor(color.value)
	      },
	      style: ({
	        'backgroundColor': color.value
	      }),
	      attrs: {
	        "aria-label": color.title
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setColor(idx)
	        }
	      }
	    })
	  }), 0)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "do-hours"
	  }, [(_vm.isShowOptions) ? _c('label', {
	    staticClass: "d-label marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n['period_hours']))]) : _vm._e(), _vm._v(" "), (_vm.isShowOptions) ? _c('DoDatePickerRange', {
	    attrs: {
	      "date": _vm.date,
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate
	    },
	    on: {
	      "datesChanged": _vm.setDates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "is-small": true,
	      "bg-color": "#ffffff"
	    }
	  }) : [_c('div', {
	    ref: "dropdown",
	    staticClass: "do-card--overflow",
	    style: ({
	      'maxHeight': _vm.maxHeight
	    })
	  }, [(_vm.hoursGrouped.length < 1) ? _c('h3', {
	    staticClass: "text-explainer marg-1-top"
	  }, [_vm._v(_vm._s(_vm.i18n['no_schedule']))]) : _vm._l((_vm.hoursGroupedSorted), function(parentCat) {
	    return _c('ul', {
	      staticClass: "do-card"
	    }, [_c('li', [_c('div', {
	      staticClass: "do-hours__item do-hours__item__headline",
	      class: {
	        'do-hours__item__headline--no-border': parentCat.subCategories.length > 1
	      }
	    }, [_c('p', [_vm._v(_vm._s(parentCat.vTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(parentCat.vHours))])]), _vm._v(" "), _c('ul', _vm._l((parentCat.subCategories), function(subCat) {
	      return _c('li', [(parentCat.subCategories.length > 1) ? _c('div', {
	        staticClass: "do-hours__item do-hours__item__sub__headline do-hours__item__child"
	      }, [_c('p', [_vm._v(_vm._s(subCat.vTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(subCat.vHours))])]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((subCat.subjects), function(subject) {
	        return _c('li', {
	          staticClass: "do-hours__item do-hours__item__child"
	        }, [_c('p', [_vm._v(_vm._s(subject.vTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(subject.vHours))])])
	      }), 0)])
	    }), 0)])])
	  })], 2)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', {
	    staticClass: "tr-user",
	    class: {
	      'tr-user--cant-edit': !_vm.theUserCanManageAssignedHours || _vm.isPoolsDeactivated
	    }
	  }, [_c('th', {
	    staticClass: "tr-user__name"
	  }, [_c('div', {
	    staticClass: "tr-user__name__inner"
	  }, [_c('p', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
	    staticClass: "tr-user__name__bttn icon__bg-circle hint--right",
	    attrs: {
	      "aria-label": _vm.$t('vue2.task_overview.task_overview')
	    },
	    on: {
	      "click": _vm.setTheActiveUserInAssignHours
	    }
	  }, [_c('svg', {
	    staticClass: "icon-chart tw-icon tw-icon--small",
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('path', {
	    staticClass: "primary",
	    attrs: {
	      "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "secondary",
	    attrs: {
	      "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
	    }
	  })])])])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function () { return !_vm.isDatesPristine; }
	      }),
	      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
	    }],
	    staticClass: "number number_edit td-presence",
	    class: {
	      'is-number--calculated': !_vm.isDatesPristine
	    },
	    attrs: {
	      "content": _vm.createTooltip(_vm.user.assigned_total_hours)
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.openEdit(_vm.user.assigned_total_hours, 'assigned_total_hours', $event)
	      }
	    }
	  }, [(!_vm.isDatesPristine) ? _c('span', {
	    staticClass: "icon-clock"
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.user.v_total_hours_assigned_in_period) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        placement: 'right',
	        arrow: true,
	        animateFill: false,
	        animation: 'shift-away',
	        zIndex: '999999992',
	        boundary: 'window',
	        onShow: function () { return _vm.user.vIsPedagogog === true; }
	      }),
	      expression: "{\n              placement: 'right',\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => user.vIsPedagogog === true\n            }"
	    }],
	    staticClass: "number td-presence",
	    class: {
	      'td-presence--pedagog': _vm.user.vIsPedagogog
	    },
	    attrs: {
	      "aria-label": _vm.user.actual_total_hours,
	      "content": "For pædagoger tælles skemalagte timer, ikke timer fra arbejdstidsfunktionen"
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number td-presence number__scale-indicator",
	    style: (_vm.scaleIndicator(_vm.user.diff_total_hours)),
	    attrs: {
	      "aria-label": _vm.user.diff_total_hours
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isPoolsDeactivated) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        content: ("<div>\n                <div class='do-flex-labels'>Arbejdstid: <span>" + (_vm.user.assigned_total_hours) + "</span></div>\n                <div class='do-flex-labels'>Tildelte timer: <span>" + (_vm.user.sum_hours) + "</span></div>\n              </div>"),
	        allowHTML: true,
	        arrow: true,
	        placement: 'left'
	      }),
	      expression: "{\n    content: `<div>\n                <div class='do-flex-labels'>Arbejdstid: <span>${user.assigned_total_hours}</span></div>\n                <div class='do-flex-labels'>Tildelte timer: <span>${user.sum_hours}</span></div>\n              </div>`,\n    allowHTML: true,\n    arrow: true,\n    placement: 'left'\n  }"
	    }],
	    staticClass: "number pointer td-rest number__scale-indicator",
	    style: (_vm.scaleIndicator(_vm.user.rest_hours)),
	    attrs: {
	      "aria-label": _vm.user.rest_hours
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number_edit td-teaching",
	    attrs: {
	      "aria-label": _vm.user.assigned_teaching_hours
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.openEdit(_vm.user.assigned_teaching_hours, 'assigned_teaching_hours', $event)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "number td-teaching",
	    attrs: {
	      "aria-label": _vm.user.actual_teaching_hours
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number__scale-indicator td-teaching",
	    style: (_vm.scaleIndicator(_vm.user.diff_teaching_hours)),
	    attrs: {
	      "aria-label": _vm.user.diff_teaching_hours
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number_edit td-tasks",
	    attrs: {
	      "aria-label": _vm.user.assigned_additional_task_hours
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.openEdit(_vm.user.assigned_additional_task_hours, 'assigned_additional_task_hours', $event)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "number td-tasks",
	    attrs: {
	      "aria-label": _vm.user.actual_additional_task_hours
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number__scale-indicator td-tasks",
	    style: (_vm.scaleIndicator(_vm.user.diff_additional_task_hours)),
	    attrs: {
	      "aria-label": _vm.user.diff_additional_task_hours
	    }
	  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
	    directives: [{
	      name: "tippy",
	      rawName: "v-tippy",
	      value: ({
	        content: ((_vm.user.assigned_teaching_hours) + " UV-timer * " + _vm.prepFactor + " forberedelsesfaktor"),
	        arrow: true,
	        placement: 'top',
	        onShow: function () { return _vm.isShowPrepFactorCalculation; }
	      }),
	      expression: "{\n    content: `${user.assigned_teaching_hours} UV-timer * ${prepFactor} forberedelsesfaktor`,\n    arrow: true,\n    placement: 'top',\n    onShow: () => isShowPrepFactorCalculation\n  }"
	    }],
	    staticClass: "number number_edit td-preparation",
	    attrs: {
	      "aria-label": _vm.user.assigned_preparation_hours
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.openEdit(_vm.user.assigned_preparation_hours, 'assigned_preparation_hours', $event)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "number td-preparation",
	    attrs: {
	      "aria-label": _vm.user.actual_preparation_hours
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number__scale-indicator td-preparation",
	    style: (_vm.scaleIndicator(_vm.user.diff_preparation_hours)),
	    attrs: {
	      "aria-label": _vm.user.diff_preparation_hours
	    }
	  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number_edit td-preparation",
	    attrs: {
	      "aria-label": _vm.user.assigned_pool_hours
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.openEdit(_vm.user.assigned_pool_hours, 'assigned_pool_hours', $event)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "number td-preparation",
	    attrs: {
	      "aria-label": _vm.user.actual_pool_hours
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number__scale-indicator td-preparation",
	    style: (_vm.scaleIndicator(_vm.user.diff_pool_hours)),
	    attrs: {
	      "aria-label": _vm.user.diff_pool_hours
	    }
	  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "number pointer td-absence",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setActiveUser('absence')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "tr-user__text"
	  }, [_vm._v("\n      " + _vm._s(_vm.user.actual_absence_hours) + "\n    ")])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number_edit td-sub-hours",
	    attrs: {
	      "aria-label": _vm.user.substitute_pool_hours
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.openEdit(_vm.user.substitute_pool_hours, 'substitute_pool_hours', $event)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "number pointer td-sub-hours",
	    attrs: {
	      "aria-label": _vm.user.actual_substitute_hours
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.setActiveUser('substituteHours')
	      }
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number__scale-indicator td-sub-hours",
	    style: (_vm.scaleIndicator(_vm.user.diff_substitute_hours)),
	    attrs: {
	      "aria-label": _vm.user.diff_substitute_hours
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isSFOActive) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number_edit td-club",
	    attrs: {
	      "aria-label": _vm.user.assigned_club_hours
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.openEdit(_vm.user.assigned_club_hours, 'assigned_club_hours', $event)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('td', {
	    staticClass: "number td-club",
	    attrs: {
	      "aria-label": _vm.user.actual_club_hours
	    }
	  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
	    staticClass: "number number__scale-indicator td-club",
	    style: (_vm.scaleIndicator(_vm.user.diff_club_hours)),
	    attrs: {
	      "aria-label": _vm.user.diff_club_hours
	    }
	  }) : _vm._e()] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeEdit),
	      expression: "closeEdit"
	    }],
	    staticClass: "qeip text-dark",
	    class: {
	      'qeip--active': _vm.edit
	    },
	    on: {
	      "mousedown": function($event) {
	        _vm.isMouseDown = true
	      },
	      "mouseup": function($event) {
	        _vm.isMouseDown = false
	      }
	    }
	  }, [(!_vm.edit && _vm.textWithoutHTML.length < 1) ? _c('div', {
	    staticClass: "qeip--empty",
	    on: {
	      "click": _vm.setEdit
	    }
	  }, [_c('span', {
	    staticClass: "icon-pencil"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.edit && _vm.textWithoutHTML.length > 0) ? _c('div', {
	    staticClass: "qeip--filled",
	    on: {
	      "click": _vm.setEdit
	    }
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('div', [_c('quill-editor', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "content": _vm.text,
	      "options": _vm.editorOption
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onEditorChange($event)
	      },
	      "ready": function($event) {
	        return _vm.onEditorReady($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "d-quill__toolbar",
	    attrs: {
	      "slot": "toolbar",
	      "id": 'toolbar_' + _vm.uniqueNum,
	      "data-num": _vm.uniqueNum
	    },
	    slot: "toolbar"
	  }, [_c('button', {
	    staticClass: "ql-bold hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['bold']
	    }
	  }, [_vm._v("Bold")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-italic hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['italic']
	    }
	  }, [_vm._v("Italic")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-underline hint--bottom",
	    attrs: {
	      "aria-label": _vm.i18n[_vm.locale]['underline']
	    }
	  }, [_vm._v("Underline")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-list hint--bottom",
	    attrs: {
	      "value": "ordered",
	      "aria-label": _vm.i18n[_vm.locale]['list_ordered']
	    }
	  }, [_vm._v("Ordered\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "ql-list hint--bottom",
	    attrs: {
	      "value": "bullet",
	      "aria-label": _vm.i18n[_vm.locale]['list_bullets']
	    }
	  }, [_vm._v("bullet")]), _vm._v(" "), _c('button', {
	    staticClass: "hint--bottom",
	    attrs: {
	      "id": "custom-button",
	      "aria-label": _vm.i18n[_vm.locale]['insert_link']
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setIsLinkModal(true)
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 18 18"
	    }
	  }, [_c('line', {
	    staticClass: "ql-stroke",
	    attrs: {
	      "x1": "7",
	      "x2": "11",
	      "y1": "7",
	      "y2": "11"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "ql-even ql-stroke",
	    attrs: {
	      "d": "M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "ql-even ql-stroke",
	    attrs: {
	      "d": "M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"
	    }
	  })])])])]), _vm._v(" "), (_vm.isInTestOfSaveButton) ? _c('div', {
	    staticClass: "save-buttons"
	  }, [_c('button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isChanged) ? _c('button', {
	    staticClass: "submit-button submit-button--disabled"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isClosingWithoutSaving) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e(), _vm._v(" "), (_vm.isClosingWithoutSaving) ? _c('DModal', {
	    staticClass: "ap",
	    attrs: {
	      "show-close": false
	    }
	  }, [_c('div', {
	    staticClass: "quill-modal quill-modal__save-changes",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('h4', {
	    staticClass: "marg-20-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save_changes')))]), _vm._v(" "), _c('div', {
	    staticClass: "save-buttons"
	  }, [_c('button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
	    staticClass: "submit-button",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isLinkModal) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e(), _vm._v(" "), (_vm.isLinkModal) ? _c('DModal', {
	    on: {
	      "close": function($event) {
	        return _vm.setIsLinkModal(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "quill-modal",
	    attrs: {
	      "slot": "insertComponent"
	    },
	    slot: "insertComponent"
	  }, [_c('div', {
	    staticClass: "quill-modal__content"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['link_text_label']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.linkText),
	      expression: "linkText"
	    }],
	    ref: "linkTextInput",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['link_text_placeholder']
	    },
	    domProps: {
	      "value": (_vm.linkText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.linkText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['link_link_label']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.link),
	      expression: "link"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['link_link_placeholder']
	    },
	    domProps: {
	      "value": (_vm.link)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.link = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "quill-modal__footer"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setIsLinkModal(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
	    staticClass: "bttn bttn-primary submit-button submit-button--disabled"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['insert_link']) + "\n          ")]) : _c('button', {
	    staticClass: "bttn submit-button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.insertLink.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['insert_link']) + "\n          ")])])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sms text-dark no-print text-dark"
	  }, [(!_vm.isOpen) ? _c('div', {
	    staticClass: "sms-header__toggler",
	    on: {
	      "click": function($event) {
	        return _vm.setOpen(!_vm.isOpen)
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
	    staticClass: "close-icon sms-header__toggler__icon text-white"
	  }, [(_vm.isOpen) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideInUp"
	    },
	    on: {
	      "after-enter": _vm.onEnterComplete
	    }
	  }, [(_vm.isOpen) ? _c('div', {
	    staticClass: "sms-container"
	  }, [_c('div', {
	    staticClass: "sms-header__toggler",
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
	    staticClass: "close-icon sms-header__toggler__icon text-white"
	  }, [(_vm.isOpen) ? _c('span', {
	    staticClass: "icon-cross2"
	  }) : _c('span', {
	    staticClass: "icon-arrow-up4"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sms-body"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeOut"
	    }
	  }, [(_vm.noNumberForUser) ? _c('div', {
	    staticClass: "sms-body__signup"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    staticClass: "sms-body__signup__content box"
	  }, [_c('h2', {
	    staticClass: "text-blue"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['welcome_to_sms']))]), _vm._v(" "), _c('p', {
	    staticClass: "marg-10-bottom"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number_to_send_sms']))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number']))]), _vm._v("\n                " + _vm._s(_vm.user.phone) + "\n                "), _c('SmsAddNumber', {
	    staticClass: "marg-10-right",
	    attrs: {
	      "userid": _vm.user.id,
	      "updateThisUser": true,
	      "isEditFromStart": true
	    }
	  })], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "select-users"
	  }, [_c('div', {
	    staticClass: "users-header-second users-header-second__button"
	  }, [_c('button', {
	    staticClass: "do-bttn do-bttn--small",
	    on: {
	      "click": _vm.getSubsOfTheDay
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['todays_substitutes']) + "\n            ")]), _vm._v(" "), _c('DoFiltersFilter', {
	    attrs: {
	      "title": '',
	      "tags": _vm.tags,
	      "selectedTags": _vm.appliedFilters
	    },
	    on: {
	      "select": _vm.toggleTag,
	      "clear": _vm.clearAllTags
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchText),
	      expression: "searchText"
	    }],
	    staticClass: "users-header__searchfield",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('vue2.common.search')
	    },
	    domProps: {
	      "value": (_vm.searchText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchText = $event.target.value
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "list"
	  }, [_c('ul', {
	    staticClass: "users-list"
	  }, [_c('li', {
	    staticClass: "users-user users-user__header"
	  }, [(_vm.selectedUsers.length < 1) ? _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.setAllUsersSelected
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n                ")]) : _c('p', {
	    staticClass: "text-link",
	    on: {
	      "click": _vm.removeAllSelectedUsers
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "users-user users-user__header__right"
	  }, [(_vm.isSMSActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sms']))]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['email']))]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
	    attrs: {
	      "bg-color": "#fff"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? [(_vm.filteredUsers.length < 1) ? _c('p', {
	    staticClass: "pad-20"
	  }, [_c('i', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_matches']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user, idx) {
	    return _c('li', {
	      key: user.id,
	      ref: 'user_ ' + user.id,
	      refInFor: true,
	      staticClass: "users-user",
	      class: [{
	          'users-user--only': _vm.filteredUsers.length === 1
	        },
	        {
	          'isSelected': _vm.checkIfInList(user.id)
	        },
	        {
	          'user--has-no-active-contact': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
	        },
	        {
	          'selectedWithoutContactForm': _vm.checkIfInListWithoutContactForm(user.id)
	        }
	      ]
	    }, [_c('div', {
	      staticClass: "users-user__meta",
	      on: {
	        "click": function($event) {
	          return _vm.setUser(user, idx, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "users-choose",
	      class: {
	        'users-choose--disabled': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
	      }
	    }, [_c('div', {
	      staticClass: "checkbox",
	      class: {
	        'checkboxChecked': _vm.checkIfInList(user)
	      }
	    }, [_c('span', {
	      staticClass: "checked"
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "users-img"
	    }, [_c('img', {
	      attrs: {
	        "src": user.img
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "users-name"
	    }, [_c('p', [_vm._v(_vm._s(user.name))])])]), _vm._v(" "), _c('div', {
	      staticClass: "users-last"
	    }, [_c('div', {
	      staticClass: "contact-options"
	    }, [(_vm.isSMSActive) ? _c('div', {
	      staticClass: "contact-options__option",
	      class: {
	        'contact-options__option--disabled': user.v_phone_setting === 'deactivated'
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{\n                             arrow: true\n                           }"
	      }],
	      staticClass: "icon__bg-circle contact-options__option__phone",
	      attrs: {
	        "content": user.v_phone_tooltip
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setOption(user, 'phone')
	        }
	      }
	    }, [(user.v_phone_setting === 'no_number') ? _c('svg', {
	      staticClass: "d-hero-icon--add w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 4.5v15m7.5-7.5h-15"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'active' || user.v_phone_setting === 'deactivated') ? _c('svg', {
	      staticClass: "d-hero-icon w-6 h-6",
	      class: {
	        'd-tw-icon--deactivated': user.v_phone_setting === 'deactivated'
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'awaiting_approval') ? _c('svg', {
	      staticClass: "w-6 h-6 d-icon__awaiting-approval d-hero-icon",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
	      }
	    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('div', {
	      staticClass: "contact-options__option",
	      class: {
	        'contact-options__option--disabled': user.v_email_setting === 'deactivated'
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "tippy",
	        rawName: "v-tippy",
	        value: ({
	          arrow: true
	        }),
	        expression: "{\n                             arrow: true\n                           }"
	      }],
	      staticClass: "icon__bg-circle",
	      attrs: {
	        "content": user.v_email_tooltip
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setOption(user, 'email')
	        }
	      }
	    }, [(user.v_email_setting === 'no_email') ? _c('svg', {
	      staticClass: "d-hero-icon--add w-6 h-6",
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M12 4.5v15m7.5-7.5h-15"
	      }
	    })]) : _vm._e(), _vm._v(" "), (user.v_email_setting === 'active' || user.v_email_setting === 'deactivated') ? _c('svg', {
	      staticClass: "w-6 h-6",
	      class: {
	        'd-tw-icon--deactivated': user.v_email_setting === 'deactivated'
	      },
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "fill": "none",
	        "viewBox": "0 0 24 24",
	        "stroke-width": "1.5",
	        "stroke": "currentColor"
	      }
	    }, [_c('path', {
	      attrs: {
	        "stroke-linecap": "round",
	        "stroke-linejoin": "round",
	        "d": "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
	      }
	    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "contact-options__option contact-options__option__settings"
	    }, [_c('div', {
	      staticClass: "icon__bg-circle icon-more2",
	      on: {
	        "click": function($event) {
	          _vm.theActiveEditUser = user
	        }
	      }
	    })])])])])
	  })] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms"
	  }, [_c('div', {
	    staticClass: "users-header-second"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message_to']) + " " + _vm._s(_vm.selectedUsers.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body"
	  }, [_c('div', {
	    staticClass: "send-sms__body__templates"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_a_standard_template']))]), _vm._v(" "), (_vm.isLoadingTemplates) ? _c('div', [_c('spinner', {
	    attrs: {
	      "isSmall": true
	    }
	  })], 1) : _vm._l((_vm.templates), function(template) {
	    return _c('div', {
	      key: template.id,
	      staticClass: "standard-sms flex"
	    }, [_c('div', {
	      staticClass: "standard-sms__sub sms-template"
	    }, [_c('div', {
	      staticClass: "sms-template__title",
	      on: {
	        "click": function($event) {
	          return _vm.selectTemplate(template)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "icon-file-text"
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(template.title))])]), _vm._v(" "), _c('d-dropdown', [_c('ul', {
	      attrs: {
	        "slot": "list"
	      },
	      slot: "list"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          return _vm.setTheEditTemplate(template)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))]), _vm._v(" "), _c('li', {
	      staticClass: "d-item-warning",
	      on: {
	        "click": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.theDeleteTemplate = template
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                      ")])])])], 1)])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "standard-sms flex"
	  }, [_c('div', {
	    staticClass: "standard-sms__sub sms-template sms-template__create",
	    on: {
	      "click": function($event) {
	        _vm.isCreateTemplate = true
	      }
	    }
	  }, [_c('div', {
	    staticClass: "sms-template__title"
	  }, [_c('span', [_vm._v("+")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['create_a_standard_template']))])])])])], 2), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body__message"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message']))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.messageSubject),
	      expression: "messageSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.i18n[_vm.locale]['subject']
	    },
	    domProps: {
	      "value": (_vm.messageSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.messageSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.messageBody),
	      expression: "messageBody"
	    }],
	    ref: "sms",
	    staticClass: "marg-1-bottom marg-1-top",
	    class: {
	      'error-class': _vm.giveFeedback && _vm.noText
	    },
	    attrs: {
	      "placeholder": _vm.i18n[_vm.locale]['message']
	    },
	    domProps: {
	      "value": (_vm.messageBody)
	    },
	    on: {
	      "click": function($event) {
	        _vm.giveFeedback = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.messageBody = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.giveFeedback && _vm.noText) ? _c('span', {
	    staticClass: "error-text"
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message_must_be_filled']))]) : _vm._e(), _vm._v(" "), (_vm.noText || _vm.noReceiver) ? _c('button', {
	    staticClass: "submit-button width-100 submit-button--disabled",
	    on: {
	      "click": function($event) {
	        _vm.giveFeedback = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")]) : _c('button', {
	    staticClass: "submit-button width-100",
	    on: {
	      "click": _vm.sendMessage
	    }
	  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "send-sms__body__receivers marg-1-left marg-1-right"
	  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['recipients']))]), _vm._v(" "), (_vm.selectedUsers.length < 1) ? _c('p', {
	    staticClass: "explainer-text"
	  }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['select_recipients']))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "receivers-container"
	  }, _vm._l((_vm.userSetSelected), function(user) {
	    return _c('li', {
	      staticClass: "receivers-container__receiver"
	    }, [_c('div', {
	      staticClass: "receiver__name"
	    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
	      staticClass: "receiver__remove icon-cross2",
	      on: {
	        "click": function($event) {
	          return _vm.setUser(user, _vm.idx)
	        }
	      }
	    })])
	  }), 0)])])])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.isCreateTemplate) ? _c('TemplateModal', {
	    attrs: {
	      "editsms": _vm.theEditTemplate,
	      "messageType": "email"
	    },
	    on: {
	      "close": _vm.closeTemplate,
	      "updated": _vm.readMessageTemplates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteTemplate) ? _c('TemplateDelete', {
	    attrs: {
	      "editsms": _vm.theDeleteTemplate
	    },
	    on: {
	      "close": function($event) {
	        _vm.theDeleteTemplate = null
	      },
	      "updated": _vm.readMessageTemplates
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('SendMessagesUserSetting', {
	    attrs: {
	      "user": _vm.theActiveEditUser,
	      "isEmailActive": _vm.isEmailActive,
	      "isSMSActive": _vm.isSMSActive
	    },
	    on: {
	      "close": _vm.closeUserSetting
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('div', {
	    staticClass: "bg-overlay"
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	var link = document.createElement('link');
	link.setAttribute('rel', 'manifest');
	link.setAttribute('href', __webpack_require__.p + "static/appmanifest.79c8be3a682f8272a7116a8e3c8cfc5b.json");
	document.head.appendChild(link);
	var manifest = {"name":"Docendo","short_name":"Docendo","theme_color":"#468ad7","background_color":"#468ad7","display":"standalone","icons":[{"src":"/app/static/icons/icon-72x72.f584413a724fc454007b3560d1c15b9d.png","sizes":"72x72","type":"image/png"},{"src":"/app/static/icons/icon-96x96.0e05086c44641ea344a819b88585ab47.png","sizes":"96x96","type":"image/png"},{"src":"/app/static/icons/icon-128x128.a855fd0e0c747c8095602abe2ef87059.png","sizes":"128x128","type":"image/png"},{"src":"/app/static/icons/icon-144x144.c7242051565445c99d4cd9f37db9da1f.png","sizes":"144x144","type":"image/png"},{"src":"/app/static/icons/icon-152x152.5b92e6ea3021ee7fe29ce0dbdf6162e9.png","sizes":"152x152","type":"image/png"},{"src":"/app/static/icons/icon-192x192.ebb3986f7be6530b978af6b82f44d8f3.png","sizes":"192x192","type":"image/png"},{"src":"/app/static/icons/icon-384x384.41378a54e0b40578c27271d92cc6b77d.png","sizes":"384x384","type":"image/png"},{"src":"/app/static/icons/icon-512x512.09293af4c248bb63ac6ebc0c27ef193e.png","sizes":"512x512","type":"image/png"}],"splash_pages":null};
	if(manifest.icons && manifest.icons.length){
	  for(var i in manifest.icons){
	    var link = document.createElement('link');
	    link.setAttribute('rel', 'apple-touch-icon');
	    link.setAttribute('sizes', manifest.icons[i].sizes);
	    link.setAttribute('href', manifest.icons[i].src);
	    document.head.appendChild(link);
	  }
	}
	if(manifest.display && (manifest.display == 'fullscreen' || manifest.display == 'standalone')){
	  var meta = document.createElement('meta');
	  meta.setAttribute('name', 'apple-mobile-web-app-capable');
	  meta.setAttribute('content', 'yes');
	  document.head.appendChild(meta);
	}
	if(manifest.theme_color){
	  var meta = document.createElement('meta');
	  meta.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
	  meta.setAttribute('content', manifest.theme_color);
	  document.head.appendChild(meta);
	}


/***/ }),
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.f4ca6563b2c7a9748b22.js